var __defProp = Object.defineProperty;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// ../../node_modules/tsup/assets/esm_shims.js
var init_esm_shims = __esm({
  "../../node_modules/tsup/assets/esm_shims.js"() {
  }
});

// src/uds/index.ts
init_esm_shims();

// src/uds/glyphs.ts
var glyphs_exports = {};
__export(glyphs_exports, {
  Ai: () => Ai,
  AirplaneReturn: () => AirplaneReturn,
  AirplaneTakingOff: () => AirplaneTakingOff,
  AirplaneToRight: () => AirplaneToRight,
  AirplaneToRightTop: () => AirplaneToRightTop,
  AirplaneToTop: () => AirplaneToTop,
  AirplaneWithArrowsCirclePath: () => AirplaneWithArrowsCirclePath,
  AppartmentBuilding: () => AppartmentBuilding,
  ArrowDownInCircleMulticolor: () => ArrowDownInCircleMulticolor,
  ArrowUpFromLine: () => ArrowUpFromLine,
  ArrowUpInCircle: () => ArrowUpInCircle,
  ArrowsCirclePath: () => ArrowsCirclePath,
  ArrowsSquarePath: () => ArrowsSquarePath,
  Baby: () => Baby,
  BabyAndWaterWaves: () => BabyAndWaterWaves,
  BackpackWithCheckMark: () => BackpackWithCheckMark,
  BeachUmbrella: () => BeachUmbrella,
  Bed: () => Bed,
  BedFor2Persons: () => BedFor2Persons,
  BedSheets: () => BedSheets,
  Bike: () => Bike,
  BowlWithFood: () => BowlWithFood,
  BusFront: () => BusFront,
  BusRight: () => BusRight,
  Cake: () => Cake,
  Calendar: () => Calendar,
  CarDoor: () => CarDoor,
  CarFront: () => CarFront,
  CarRight: () => CarRight,
  CheckMark: () => CheckMark,
  CheckMarkExtraSmall: () => CheckMarkExtraSmall,
  CheckMarkInCircle: () => CheckMarkInCircle,
  CheckMarkSmall: () => CheckMarkSmall,
  Checklist: () => Checklist,
  ChevronDoubleSmall: () => ChevronDoubleSmall,
  ChevronDown: () => ChevronDown,
  ChevronDownExtraSmall: () => ChevronDownExtraSmall,
  ChevronLeft: () => ChevronLeft,
  ChevronLeftExtraSmall: () => ChevronLeftExtraSmall,
  ChevronRight: () => ChevronRight,
  ChevronRightExtraSmall: () => ChevronRightExtraSmall,
  ChevronUp: () => ChevronUp,
  ChevronUpExtraSmall: () => ChevronUpExtraSmall,
  Child: () => Child,
  ChildSeatHighChair: () => ChildSeatHighChair,
  Clock: () => Clock,
  ClockMulticolor: () => ClockMulticolor,
  Clown: () => Clown,
  Cocktail: () => Cocktail,
  CrossMedium: () => CrossMedium,
  Deposit: () => Deposit,
  Diamond: () => Diamond,
  Dismiss: () => Dismiss,
  DismissExtraSmall: () => DismissExtraSmall,
  DismissSmall: () => DismissSmall,
  DocumentPdf: () => DocumentPdf,
  DocumentWithEuro: () => DocumentWithEuro,
  DocumentWithText: () => DocumentWithText,
  Dumbbell: () => Dumbbell,
  Duration: () => Duration,
  ElevatorFilledWithPeople: () => ElevatorFilledWithPeople,
  EllipsisHorizontal: () => EllipsisHorizontal,
  Esim: () => Esim,
  ExclamationInCircle: () => ExclamationInCircle,
  ExclamationInTriangle: () => ExclamationInTriangle,
  Eye: () => Eye,
  EyeSlashed: () => EyeSlashed,
  FaceHappy: () => FaceHappy,
  FaceSad: () => FaceSad,
  Family: () => Family,
  ForkAndKnive: () => ForkAndKnive,
  GolfClub: () => GolfClub,
  Grid: () => Grid,
  Group: () => Group,
  Hamam: () => Hamam,
  Heart: () => Heart,
  HeartFilled: () => HeartFilled,
  HeartWithSmallerHeart: () => HeartWithSmallerHeart,
  House: () => House,
  HouseBadgePlus: () => HouseBadgePlus,
  HouseHeating: () => HouseHeating,
  HouseWithHeart: () => HouseWithHeart,
  Houses: () => Houses,
  ImageSlashed: () => ImageSlashed,
  InformationInCircle: () => InformationInCircle,
  LanguageTranslate: () => LanguageTranslate,
  Leaf: () => Leaf,
  List: () => List,
  LockClosed: () => LockClosed,
  LogoElizaWasHere: () => LogoElizaWasHere,
  LogoFacebook: () => LogoFacebook,
  LogoInstagram: () => LogoInstagram,
  LogoPinterest: () => LogoPinterest,
  LogoPrimavera: () => LogoPrimavera,
  LogoSunweb: () => LogoSunweb,
  LogoTiktok: () => LogoTiktok,
  LogoTotally: () => LogoTotally,
  LogoYoutube: () => LogoYoutube,
  Lotus: () => Lotus,
  LuggageCheck: () => LuggageCheck,
  Magnifier: () => Magnifier,
  ManualTransmission: () => ManualTransmission,
  Map: () => Map,
  MapPin: () => MapPin,
  MapPinOnMap: () => MapPinOnMap,
  Minus: () => Minus,
  MinusExtraSmall: () => MinusExtraSmall,
  MountainsSlope: () => MountainsSlope,
  NoImage: () => NoImage,
  OptionalFacilities: () => OptionalFacilities,
  ParkingSign: () => ParkingSign,
  PaymentCard: () => PaymentCard,
  PaymentCardWithCoins: () => PaymentCardWithCoins,
  Pencil: () => Pencil,
  PercentageInCircleMulticolor: () => PercentageInCircleMulticolor,
  Person: () => Person,
  PersonAtReception: () => PersonAtReception,
  PersonInCircle: () => PersonInCircle,
  PersonInWheelchair: () => PersonInWheelchair,
  PersonRunning: () => PersonRunning,
  PersonSkiing: () => PersonSkiing,
  PersonStretching: () => PersonStretching,
  PersonWithSuitcase: () => PersonWithSuitcase,
  PigBank: () => PigBank,
  Placeholder: () => Placeholder,
  PlayFilled: () => PlayFilled,
  Plus: () => Plus,
  PlusExtraSmall: () => PlusExtraSmall,
  PlusInSquare: () => PlusInSquare,
  QuestionMarkInCircle: () => QuestionMarkInCircle,
  ServingFoodWithCloche: () => ServingFoodWithCloche,
  ServingFoodWithClocheSlashed: () => ServingFoodWithClocheSlashed,
  ServingFoodWithFullCloche: () => ServingFoodWithFullCloche,
  ServingFoodWithHalfCloche: () => ServingFoodWithHalfCloche,
  ServingFoodWithPlusCloche: () => ServingFoodWithPlusCloche,
  ServingFoodWithStarCloche: () => ServingFoodWithStarCloche,
  ShieldWithDismiss: () => ShieldWithDismiss,
  ShieldWithLock: () => ShieldWithLock,
  ShieldWithPlus: () => ShieldWithPlus,
  SkiPass: () => SkiPass,
  Skis: () => Skis,
  Sliders: () => Sliders,
  SmallHouse: () => SmallHouse,
  Snowflake: () => Snowflake,
  SpadeSymbol: () => SpadeSymbol,
  Spinner: () => Spinner,
  Spray: () => Spray,
  SquareArrowUp: () => SquareArrowUp,
  SquareOnSquare: () => SquareOnSquare,
  StarFilled: () => StarFilled,
  StarHalfFilled: () => StarHalfFilled,
  SteeringWheel: () => SteeringWheel,
  Suitcase: () => Suitcase,
  SuitcaseOnWheels: () => SuitcaseOnWheels,
  SuitcaseOnWheelsWithCheckMark: () => SuitcaseOnWheelsWithCheckMark,
  Sweater: () => Sweater,
  SwimmingPool: () => SwimmingPool,
  TShirt: () => TShirt,
  Tag: () => Tag,
  TennisBall: () => TennisBall,
  ThreePeople: () => ThreePeople,
  ThumbsUp: () => ThumbsUp,
  Ticket: () => Ticket,
  TicketFlight: () => TicketFlight,
  TicketWithPercentage: () => TicketWithPercentage,
  TipiTent: () => TipiTent,
  Towel: () => Towel,
  ToyHorseWithRoof: () => ToyHorseWithRoof,
  TrashCan: () => TrashCan,
  TvScreen: () => TvScreen,
  TwoChildren: () => TwoChildren,
  TwoPeople: () => TwoPeople,
  Villa: () => Villa,
  Wallet: () => Wallet,
  WashingMachine: () => WashingMachine,
  WaterSlide: () => WaterSlide,
  WiFi: () => WiFi,
  World: () => World
});
init_esm_shims();
import { Ai } from "@sunwebgroup/uds-icons";
import { AirplaneTakingOff } from "@sunwebgroup/uds-icons";
import { AirplaneToRight } from "@sunwebgroup/uds-icons";
import { AirplaneToRightTop } from "@sunwebgroup/uds-icons";
import { AirplaneToTop } from "@sunwebgroup/uds-icons";
import { AirplaneWithArrowsCirclePath } from "@sunwebgroup/uds-icons";
import { AppartmentBuilding } from "@sunwebgroup/uds-icons";
import { ArrowDownInCircleMulticolor } from "@sunwebgroup/uds-icons";
import { ArrowUpFromLine } from "@sunwebgroup/uds-icons";
import { ArrowsCirclePath } from "@sunwebgroup/uds-icons";
import { ArrowsSquarePath } from "@sunwebgroup/uds-icons";
import { Baby } from "@sunwebgroup/uds-icons";
import { Bed } from "@sunwebgroup/uds-icons";
import { Bike } from "@sunwebgroup/uds-icons";
import { BowlWithFood } from "@sunwebgroup/uds-icons";
import { BusFront } from "@sunwebgroup/uds-icons";
import { BusRight } from "@sunwebgroup/uds-icons";
import { Cake } from "@sunwebgroup/uds-icons";
import { Calendar } from "@sunwebgroup/uds-icons";
import { CarDoor } from "@sunwebgroup/uds-icons";
import { CarRight } from "@sunwebgroup/uds-icons";
import { CheckMark } from "@sunwebgroup/uds-icons";
import { CheckMarkExtraSmall } from "@sunwebgroup/uds-icons";
import { CheckMarkInCircle } from "@sunwebgroup/uds-icons";
import { CheckMarkSmall } from "@sunwebgroup/uds-icons";
import { ChevronDoubleSmall } from "@sunwebgroup/uds-icons";
import { ChevronDown } from "@sunwebgroup/uds-icons";
import { ChevronDownExtraSmall } from "@sunwebgroup/uds-icons";
import { ChevronLeft } from "@sunwebgroup/uds-icons";
import { ChevronLeftExtraSmall } from "@sunwebgroup/uds-icons";
import { ChevronRight } from "@sunwebgroup/uds-icons";
import { ChevronRightExtraSmall } from "@sunwebgroup/uds-icons";
import { ChevronUp } from "@sunwebgroup/uds-icons";
import { ChevronUpExtraSmall } from "@sunwebgroup/uds-icons";
import { Clock } from "@sunwebgroup/uds-icons";
import { ClockMulticolor } from "@sunwebgroup/uds-icons";
import { Dismiss } from "@sunwebgroup/uds-icons";
import { DismissExtraSmall } from "@sunwebgroup/uds-icons";
import { DismissSmall } from "@sunwebgroup/uds-icons";
import { DocumentPdf } from "@sunwebgroup/uds-icons";
import { DocumentWithText } from "@sunwebgroup/uds-icons";
import { Duration } from "@sunwebgroup/uds-icons";
import { EllipsisHorizontal } from "@sunwebgroup/uds-icons";
import { Esim } from "@sunwebgroup/uds-icons";
import { ExclamationInCircle } from "@sunwebgroup/uds-icons";
import { ExclamationInTriangle } from "@sunwebgroup/uds-icons";
import { Eye } from "@sunwebgroup/uds-icons";
import { EyeSlashed } from "@sunwebgroup/uds-icons";
import { FaceHappy } from "@sunwebgroup/uds-icons";
import { FaceSad } from "@sunwebgroup/uds-icons";
import { Family } from "@sunwebgroup/uds-icons";
import { ForkAndKnive } from "@sunwebgroup/uds-icons";
import { GolfClub } from "@sunwebgroup/uds-icons";
import { Heart } from "@sunwebgroup/uds-icons";
import { HeartFilled } from "@sunwebgroup/uds-icons";
import { HeartWithSmallerHeart } from "@sunwebgroup/uds-icons";
import { House } from "@sunwebgroup/uds-icons";
import { Houses } from "@sunwebgroup/uds-icons";
import { ImageSlashed } from "@sunwebgroup/uds-icons";
import { InformationInCircle } from "@sunwebgroup/uds-icons";
import { LanguageTranslate } from "@sunwebgroup/uds-icons";
import { Leaf } from "@sunwebgroup/uds-icons";
import { List } from "@sunwebgroup/uds-icons";
import { LogoElizaWasHere } from "@sunwebgroup/uds-icons";
import { LogoSunweb } from "@sunwebgroup/uds-icons";
import { LogoPrimavera } from "@sunwebgroup/uds-icons";
import { LogoTiktok } from "@sunwebgroup/uds-icons";
import { LogoTotally } from "@sunwebgroup/uds-icons";
import { LogoFacebook } from "@sunwebgroup/uds-icons";
import { LogoInstagram } from "@sunwebgroup/uds-icons";
import { LogoYoutube } from "@sunwebgroup/uds-icons";
import { Lotus } from "@sunwebgroup/uds-icons";
import { Magnifier } from "@sunwebgroup/uds-icons";
import { ManualTransmission } from "@sunwebgroup/uds-icons";
import { Map } from "@sunwebgroup/uds-icons";
import { MapPin } from "@sunwebgroup/uds-icons";
import { MapPinOnMap } from "@sunwebgroup/uds-icons";
import { Minus } from "@sunwebgroup/uds-icons";
import { MinusExtraSmall } from "@sunwebgroup/uds-icons";
import { ParkingSign } from "@sunwebgroup/uds-icons";
import { PaymentCardWithCoins } from "@sunwebgroup/uds-icons";
import { Pencil } from "@sunwebgroup/uds-icons";
import { PercentageInCircleMulticolor } from "@sunwebgroup/uds-icons";
import { Person } from "@sunwebgroup/uds-icons";
import { PersonInCircle } from "@sunwebgroup/uds-icons";
import { PersonRunning } from "@sunwebgroup/uds-icons";
import { PersonSkiing } from "@sunwebgroup/uds-icons";
import { PersonWithSuitcase } from "@sunwebgroup/uds-icons";
import { PigBank } from "@sunwebgroup/uds-icons";
import { Placeholder } from "@sunwebgroup/uds-icons";
import { Plus } from "@sunwebgroup/uds-icons";
import { PlusExtraSmall } from "@sunwebgroup/uds-icons";
import { QuestionMarkInCircle } from "@sunwebgroup/uds-icons";
import { ShieldWithDismiss } from "@sunwebgroup/uds-icons";
import { ShieldWithLock } from "@sunwebgroup/uds-icons";
import { ShieldWithPlus } from "@sunwebgroup/uds-icons";
import { SkiPass } from "@sunwebgroup/uds-icons";
import { Skis } from "@sunwebgroup/uds-icons";
import { Sliders } from "@sunwebgroup/uds-icons";
import { SmallHouse } from "@sunwebgroup/uds-icons";
import { Snowflake } from "@sunwebgroup/uds-icons";
import { SpadeSymbol } from "@sunwebgroup/uds-icons";
import { Spinner } from "@sunwebgroup/uds-icons";
import { StarFilled } from "@sunwebgroup/uds-icons";
import { StarHalfFilled } from "@sunwebgroup/uds-icons";
import { Suitcase } from "@sunwebgroup/uds-icons";
import { SuitcaseOnWheels } from "@sunwebgroup/uds-icons";
import { SuitcaseOnWheelsWithCheckMark } from "@sunwebgroup/uds-icons";
import { Sweater } from "@sunwebgroup/uds-icons";
import { Tag } from "@sunwebgroup/uds-icons";
import { ThreePeople } from "@sunwebgroup/uds-icons";
import { Ticket } from "@sunwebgroup/uds-icons";
import { TicketFlight } from "@sunwebgroup/uds-icons";
import { TicketWithPercentage } from "@sunwebgroup/uds-icons";
import { TipiTent } from "@sunwebgroup/uds-icons";
import { TrashCan } from "@sunwebgroup/uds-icons";
import { TShirt } from "@sunwebgroup/uds-icons";
import { TwoChildren } from "@sunwebgroup/uds-icons";
import { TwoPeople } from "@sunwebgroup/uds-icons";
import { Villa } from "@sunwebgroup/uds-icons";
import { World } from "@sunwebgroup/uds-icons";
import { Cocktail } from "@sunwebgroup/uds-icons";
import { Dumbbell } from "@sunwebgroup/uds-icons";
import { Hamam } from "@sunwebgroup/uds-icons";
import { WiFi } from "@sunwebgroup/uds-icons";
import { SwimmingPool } from "@sunwebgroup/uds-icons";
import { LockClosed } from "@sunwebgroup/uds-icons";
import { ElevatorFilledWithPeople } from "@sunwebgroup/uds-icons";
import { Towel } from "@sunwebgroup/uds-icons";
import { PersonInWheelchair } from "@sunwebgroup/uds-icons";
import { PersonAtReception } from "@sunwebgroup/uds-icons";
import { ServingFoodWithCloche } from "@sunwebgroup/uds-icons";
import { ServingFoodWithClocheSlashed } from "@sunwebgroup/uds-icons";
import { ServingFoodWithStarCloche } from "@sunwebgroup/uds-icons";
import { ServingFoodWithPlusCloche } from "@sunwebgroup/uds-icons";
import { ServingFoodWithHalfCloche } from "@sunwebgroup/uds-icons";
import { ServingFoodWithFullCloche } from "@sunwebgroup/uds-icons";
import { HouseHeating } from "@sunwebgroup/uds-icons";
import { TvScreen } from "@sunwebgroup/uds-icons";
import { WashingMachine } from "@sunwebgroup/uds-icons";
import { WaterSlide } from "@sunwebgroup/uds-icons";
import { TennisBall } from "@sunwebgroup/uds-icons";
import { Clown } from "@sunwebgroup/uds-icons";
import { BabyAndWaterWaves } from "@sunwebgroup/uds-icons";
import { ToyHorseWithRoof } from "@sunwebgroup/uds-icons";
import { ChildSeatHighChair } from "@sunwebgroup/uds-icons";
import { BedSheets } from "@sunwebgroup/uds-icons";
import { LogoPinterest } from "@sunwebgroup/uds-icons";
import { NoImage } from "@sunwebgroup/uds-icons";
import { CrossMedium } from "@sunwebgroup/uds-icons";
import { Diamond } from "@sunwebgroup/uds-icons";
import { MountainsSlope } from "@sunwebgroup/uds-icons";
import { PlayFilled } from "@sunwebgroup/uds-icons";
import { Grid } from "@sunwebgroup/uds-icons";
import { CarFront } from "@sunwebgroup/uds-icons";
import { ThumbsUp } from "@sunwebgroup/uds-icons";
import { OptionalFacilities } from "@sunwebgroup/uds-icons";
import { Deposit } from "@sunwebgroup/uds-icons";
import { LuggageCheck } from "@sunwebgroup/uds-icons";
import { AirplaneReturn } from "@sunwebgroup/uds-icons";
import { Checklist } from "@sunwebgroup/uds-icons";
import { Group } from "@sunwebgroup/uds-icons";
import { Wallet } from "@sunwebgroup/uds-icons";
import { BeachUmbrella } from "@sunwebgroup/uds-icons";
import { BackpackWithCheckMark } from "@sunwebgroup/uds-icons";
import { SteeringWheel } from "@sunwebgroup/uds-icons";
import { PlusInSquare } from "@sunwebgroup/uds-icons";
import { PaymentCard } from "@sunwebgroup/uds-icons";
import { Spray } from "@sunwebgroup/uds-icons";
import { HouseWithHeart } from "@sunwebgroup/uds-icons";
import { BedFor2Persons } from "@sunwebgroup/uds-icons";
import { Child } from "@sunwebgroup/uds-icons";
import { HouseBadgePlus } from "@sunwebgroup/uds-icons";
import { ArrowUpInCircle } from "@sunwebgroup/uds-icons";
import { SquareArrowUp } from "@sunwebgroup/uds-icons";
import { SquareOnSquare } from "@sunwebgroup/uds-icons";
import { PersonStretching } from "@sunwebgroup/uds-icons";
import { DocumentWithEuro } from "@sunwebgroup/uds-icons";

// src/uds/components/Accordion/index.ts
init_esm_shims();

// src/uds/components/Accordion/Accordion.tsx
var Accordion_exports = {};
__export(Accordion_exports, {
  Item: () => Item,
  Root: () => Root2
});
init_esm_shims();
import { styled as styled6 } from "styled-components";

// src/utils/index.ts
init_esm_shims();

// src/utils/components/index.tsx
init_esm_shims();

// src/utils/components/Grid/index.ts
init_esm_shims();

// src/utils/components/Grid/Grid.tsx
init_esm_shims();
import { css, styled } from "styled-components";
import { jsx } from "react/jsx-runtime";
function Grid2({
  as,
  children,
  gap,
  cols,
  alignItems,
  autoColumns,
  justifyItems,
  ...attributes
}) {
  return /* @__PURE__ */ jsx(GridStyled, {
    as,
    $gap: gap,
    $cols: cols,
    $alignItems: alignItems,
    $autoColumns: autoColumns,
    $justifyItems: justifyItems,
    ...attributes,
    children
  });
}
Grid2.displayName = "Grid";
var GridStyled = styled.div`
  display: grid;
  gap: ${(props) => props.$gap};
  align-items: ${(props) => props.$alignItems};
  justify-items: ${(props) => props.$justifyItems};

  // create equal sized columns
  ${(props) => props.$cols && !props.$autoColumns && css`
      grid-template-columns: repeat(${props.$cols}, 1fr);
    `}

  // create auto sized columns
  grid-auto-columns: ${(props) => props.$autoColumns};
  ${(props) => props.$autoColumns && props.$cols && css`
      grid-template-areas: '${Array(props.$cols).fill("section").join(" ")}'; // create "section section" (based on the amount of columns)
    `}
`;

// src/utils/components/SpaceBetween/index.ts
init_esm_shims();

// src/utils/components/SpaceBetween/SpaceBetween.tsx
init_esm_shims();
import { css as css2, styled as styled2 } from "styled-components";

// src/utils/typescript/index.ts
init_esm_shims();

// src/utils/typescript/exhaustive-string-tuple.ts
init_esm_shims();

// src/utils/typescript/partial-prefix.ts
init_esm_shims();

// src/utils/typescript/with-style-modifiers.ts
init_esm_shims();
function withStyleModifiers(Component, modifiers) {
  return Object.assign(Component, modifiers);
}

// src/utils/components/SpaceBetween/SpaceBetween.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
function SpaceBetweenComponent({
  alignItems,
  direction,
  spacing,
  justifyContent,
  padding,
  children,
  ...attributes
}) {
  return /* @__PURE__ */ jsx2(StyledSpaceBetween, {
    $spacing: spacing,
    $direction: direction,
    $alignItems: alignItems,
    $justifyContent: justifyContent,
    $padding: padding,
    ...attributes,
    children
  });
}
SpaceBetweenComponent.displayName = "SpaceBetween";
var StyledSpaceBetween = styled2.div`
  ${(props) => {
  var _a, _b;
  switch (props.$direction) {
    case "x":
      return css2`
          flex-direction: row;
          > * ~ * {
            margin-left: ${(_a = props.$spacing) != null ? _a : "initial"} !important;
          }
        `;
    case "y":
      return css2`
          flex-direction: column;
          > * ~ * {
            margin-top: ${(_b = props.$spacing) != null ? _b : "initial"} !important;
          }
        `;
  }
}}
  display: flex;
  align-items: ${(props) => props.$alignItems};
  justify-content: ${(props) => props.$justifyContent};
  padding: ${(props) => props.$padding};
`;
var modAlignment = (spacing, direction = "x") => css2`
  ${() => {
  return css2`
      > * ~ * {
        ${direction === "x" ? "margin-left" : "margin-top"}: ${spacing} !important;
      }
    `;
}}
`;
var SpaceBetween = withStyleModifiers(styled2(SpaceBetweenComponent)``, {
  modAlignment
});

// src/utils/components/Collapsible/index.ts
init_esm_shims();

// src/utils/components/Collapsible/Collapsible.tsx
init_esm_shims();
import * as RadixCollapsible from "@radix-ui/react-collapsible";
import { keyframes, styled as styled3 } from "styled-components";
var slideDown = keyframes`
  from {
    height: 0;
  }
  to {
    height: var(--radix-collapsible-content-height);
  }
`;
var slideUp = keyframes`
  from {
    height: var(--radix-collapsible-content-height);
  }
  to {
    height: 0;
  }
`;
var CollapsibleRoot = styled3(RadixCollapsible.Root)``;
var Collapsible = styled3(RadixCollapsible.Content).attrs((props) => ({
  $duration: props.$duration || "200ms"
}))`
  overflow: hidden;
  will-change: height;

  &[data-state='open'] {
    animation: ${slideDown} ease-out;
    animation-duration: ${(props) => props.$duration};

    @media (prefers-reduced-motion) {
      animation: none;
    }
  }

  &[data-state='closed'] {
    animation: ${slideUp} ease-out;
    animation-duration: ${(props) => props.$duration};

    @media (prefers-reduced-motion) {
      animation: none;
    }
  }
`;
var CollapsibleTrigger = styled3(RadixCollapsible.Trigger)``;

// src/utils/dates/index.ts
init_esm_shims();

// src/utils/dates/dates.ts
init_esm_shims();
import {
  add,
  differenceInCalendarDays,
  differenceInDays,
  differenceInMonths,
  differenceInWeeks,
  format,
  isAfter,
  isBefore,
  isEqual,
  lastDayOfMonth,
  startOfMonth,
  sub
} from "date-fns";
function getMonthList(locale) {
  const date = new Date();
  const currentMonth = date.getMonth();
  const currentYear = date.getFullYear();
  const monthList = [];
  for (let i = currentMonth; i < currentMonth + 12; i++) {
    const newDate = new Date(currentYear, i);
    monthList.push({
      date: getLocaleDateString(newDate),
      firstDay: getFirstDayOfMonth(newDate),
      lastDay: getLastDayOfMonth(newDate),
      month: newDate.toLocaleString(locale, { month: "long" }),
      year: newDate.toLocaleString(locale, { year: "numeric" })
    });
  }
  return monthList;
}
function getFirstDayOfMonth(date) {
  const d = new Date(date);
  return startOfMonth(d);
}
function getLastDayOfMonth(date) {
  const d = new Date(date);
  return lastDayOfMonth(d);
}
function getLocaleDateString(date) {
  return format(date, "yyyy-MM-dd");
}
function getMonthFromDateString(dateString, locale) {
  const date = new Date(Array.isArray(dateString) ? dateString[0] : dateString);
  const month = date.toLocaleString(locale, { month: "long" });
  if (month !== "Invalid Date") {
    return month;
  }
}

// src/utils/styling/index.ts
init_esm_shims();

// src/utils/styling/gap.ts
init_esm_shims();
import { css as css3 } from "styled-components";

// src/utils/styling/get-token.ts
init_esm_shims();
var tk = (tokenName) => (props) => props.theme.tokens[tokenName];
var tok = (tokenName) => (props) => props.theme.udsTokens[tokenName];
function tokPx(tokenName) {
  return ({ theme }) => theme.udsTokens[tokenName] ? `${theme.udsTokens[tokenName]}px` : "0";
}
var space = (tokenName) => tokPx(tokenName);
function mqMin(tokenName) {
  return ({ theme }) => theme.udsTokens[tokenName] ? `(min-width: ${theme.udsTokens[tokenName]}px)` : "0";
}
function mqMax(tokenName) {
  return ({ theme }) => theme.udsTokens[tokenName] ? `(max-width: ${theme.udsTokens[tokenName]}px)` : "0";
}
function textColor(tokenName) {
  return tok(tokenName);
}

// src/utils/styling/use-token.ts
init_esm_shims();
import { useTheme } from "styled-components";
function useUdsToken(tokenName) {
  const theme = useTheme();
  return theme.udsTokens[tokenName];
}

// src/utils/styling/z-index.ts
init_esm_shims();
var zIndex = {
  modalOrMobilePopover: 1500,
  sheet: 1500,
  backdrop: 1499,
  header: 99,
  heroContent: 98,
  popover: 97,
  menuOrDrawer: 96,
  anchorMenu: 50,
  sub: -1,
  min: 0,
  level1: 1,
  level2: 10,
  level3: 50,
  level4: 100,
  level5: 1e3,
  level6: 1500,
  level7: 2e3,
  max: 99999
};

// src/uds/utils/index.ts
init_esm_shims();

// src/uds/utils/breakpoints.tsx
init_esm_shims();
import { createContext, useContext, useMemo } from "react";

// ../../node_modules/react-use/esm/index.js
init_esm_shims();

// ../../node_modules/react-use/esm/misc/util.js
init_esm_shims();
var isBrowser = typeof window !== "undefined";

// ../../node_modules/react-use/esm/useMedia.js
init_esm_shims();
import { useEffect, useState } from "react";
var getInitialState = function(query, defaultState) {
  if (defaultState !== void 0) {
    return defaultState;
  }
  if (isBrowser) {
    return window.matchMedia(query).matches;
  }
  if (process.env.NODE_ENV !== "production") {
    console.warn("`useMedia` When server side rendering, defaultState should be defined to prevent a hydration mismatches.");
  }
  return false;
};
var useMedia = function(query, defaultState) {
  var _a = useState(getInitialState(query, defaultState)), state = _a[0], setState = _a[1];
  useEffect(function() {
    var mounted = true;
    var mql = window.matchMedia(query);
    var onChange = function() {
      if (!mounted) {
        return;
      }
      setState(!!mql.matches);
    };
    mql.addListener(onChange);
    setState(mql.matches);
    return function() {
      mounted = false;
      mql.removeListener(onChange);
    };
  }, [query]);
  return state;
};
var useMedia_default = useMedia;

// src/uds/utils/breakpoints.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var BreakpointContext = createContext({
  isDesktop: false,
  isTablet: false,
  isMobile: false
});
function BreakpointProvider({ children }) {
  const mqDesktop = useUdsToken("primitives_breakpoint_l_min");
  const mqTablet = useUdsToken("primitives_breakpoint_m_min");
  const mqMobile = useUdsToken("primitives_breakpoint_s_min");
  const isMobile = useMedia_default(`(min-width: ${mqMobile}px)`, false);
  const isTablet = useMedia_default(`(min-width: ${mqTablet}px)`, false);
  const isDesktop = useMedia_default(`(min-width: ${mqDesktop}px)`, false);
  const value = useMemo(
    () => ({
      isMobile,
      isTablet,
      isDesktop
    }),
    [isMobile, isTablet, isDesktop]
  );
  return /* @__PURE__ */ jsx3(BreakpointContext.Provider, {
    value,
    children
  });
}
var useBreakpoints = () => useContext(BreakpointContext);

// src/uds/utils/focusOutline.tsx
init_esm_shims();
import { css as css4 } from "styled-components";
function outlineStyles(offset = 2) {
  return css4`
    outline: ${tokPx("semantics_focus_outer_ring_width")} solid ${tok("semantics_focus_outer_ring_color")};
    outline-offset: ${offset}px;
  `;
}
function focusOutline(offset) {
  return css4`
  &:focus-visible {
    ${outlineStyles(offset != null ? offset : 2)};
  }
`;
}
function focusWithinOutline(offset) {
  return css4`
  &:focus-within {
    ${outlineStyles(offset != null ? offset : 2)};
  }
`;
}
function resetFocusOutline() {
  return css4`
  &:focus-visible {
    outline: initial;
    outline-offset: initial;
  }
`;
}

// src/uds/utils/modDisabled.tsx
init_esm_shims();
import { css as css5 } from "styled-components";
function modDisabled($disabled) {
  return css5`
    transition: opacity 0.2s 0s;
    ${$disabled && css5`
      opacity: ${tok("primitives_opacity_disabled")}%;
      pointer-events: none;
    `}
  `;
}

// src/uds/utils/typescript/index.ts
init_esm_shims();

// src/uds/utils/typescript/with-style-modifiers.ts
init_esm_shims();
function withStyleModifiers2(Component, modifiers) {
  return Object.assign(Component, modifiers);
}

// src/uds/components/Icon/index.ts
init_esm_shims();

// src/uds/components/Icon/Icon.tsx
init_esm_shims();
import { css as css6, styled as styled4 } from "styled-components";
import { jsx as jsx4 } from "react/jsx-runtime";
var IconWrapper = styled4.span`
  display: inline-flex;
  flex-shrink: 0;

  ${({ $size }) => $size && modSize($size)}
  ${({ $fullWidth }) => $fullWidth && modFullWidth()}
`;
function Icon({ className, glyph, size = 24, fullWidth = false, ...rest }) {
  const GlyphComponent = glyphs_exports[glyph];
  return /* @__PURE__ */ jsx4(IconWrapper, {
    className,
    $size: size,
    $fullWidth: fullWidth,
    children: /* @__PURE__ */ jsx4(GlyphComponent, {
      ...rest
    })
  });
}
Icon.displayName = "Icon";
function modSize(size) {
  return css6`
  & > svg {
    height: ${size}px;
    width: ${size}px;
  }
`;
}
function modFullWidth() {
  return css6`
  & > svg {
    height: initial;
    width: 100%;
  }
`;
}
var Icon_default = withStyleModifiers(styled4(Icon)``, {
  modSize
});

// src/uds/components/Typography/index.ts
init_esm_shims();

// src/uds/components/Typography/Typography.tsx
init_esm_shims();
import { css as css7, styled as styled5 } from "styled-components";
var Typography = styled5.span`
  margin: 0;

  ${({ $variant }) => modVariant($variant)}
  ${({ $color }) => $color && modColor($color)}
`;
Typography.displayName = "Typography";
function modVariant(variantName = "body-m-regular-snug") {
  return {
    "body-l-regular-loose": css7`
      font-family: ${tok("typography_primitives_body_l_regular_loose_font_family")};
      font-size: ${tokPx("typography_primitives_body_l_regular_loose_font_size")};
      line-height: ${tok("typography_primitives_body_l_regular_loose_line_height")};
      font-weight: ${tok("typography_primitives_body_l_regular_loose_font_weight")};
      letter-spacing: ${tok("typography_primitives_body_l_regular_loose_letter_spacing")};
    `,
    "body-l-regular-snug": css7`
      font-family: ${tok("typography_primitives_body_l_regular_snug_font_family")};
      font-size: ${tokPx("typography_primitives_body_l_regular_snug_font_size")};
      line-height: ${tok("typography_primitives_body_l_regular_snug_line_height")};
      font-weight: ${tok("typography_primitives_body_l_regular_snug_font_weight")};
      letter-spacing: ${tok("typography_primitives_body_l_regular_snug_letter_spacing")};
    `,
    "body-l-regular-tight": css7`
      font-family: ${tok("typography_primitives_body_l_regular_tight_font_family")};
      font-size: ${tokPx("typography_primitives_body_l_regular_tight_font_size")};
      line-height: ${tok("typography_primitives_body_l_regular_tight_line_height")};
      font-weight: ${tok("typography_primitives_body_l_regular_tight_font_weight")};
      letter-spacing: ${tok("typography_primitives_body_l_regular_tight_letter_spacing")};
    `,
    "body-l-regular-flat": css7`
      font-family: ${tok("typography_primitives_body_l_regular_flat_font_family")};
      font-size: ${tokPx("typography_primitives_body_l_regular_flat_font_size")};
      line-height: ${tok("typography_primitives_body_l_regular_flat_line_height")};
      font-weight: ${tok("typography_primitives_body_l_regular_flat_font_weight")};
      letter-spacing: ${tok("typography_primitives_body_l_regular_flat_letter_spacing")};
    `,
    "body-l-bold-loose": css7`
      font-family: ${tok("typography_primitives_body_l_bold_loose_font_family")};
      font-size: ${tokPx("typography_primitives_body_l_bold_loose_font_size")};
      line-height: ${tok("typography_primitives_body_l_bold_loose_line_height")};
      font-weight: ${tok("typography_primitives_body_l_bold_loose_font_weight")};
      letter-spacing: ${tok("typography_primitives_body_l_bold_loose_letter_spacing")};
    `,
    "body-l-bold-snug": css7`
      font-family: ${tok("typography_primitives_body_l_bold_snug_font_family")};
      font-size: ${tokPx("typography_primitives_body_l_bold_snug_font_size")};
      line-height: ${tok("typography_primitives_body_l_bold_snug_line_height")};
      font-weight: ${tok("typography_primitives_body_l_bold_snug_font_weight")};
      letter-spacing: ${tok("typography_primitives_body_l_bold_snug_letter_spacing")};
    `,
    "body-l-bold-tight": css7`
      font-family: ${tok("typography_primitives_body_l_bold_tight_font_family")};
      font-size: ${tokPx("typography_primitives_body_l_bold_tight_font_size")};
      line-height: ${tok("typography_primitives_body_l_bold_tight_line_height")};
      font-weight: ${tok("typography_primitives_body_l_bold_tight_font_weight")};
      letter-spacing: ${tok("typography_primitives_body_l_bold_tight_letter_spacing")};
    `,
    "body-l-bold-flat": css7`
      font-family: ${tok("typography_primitives_body_l_bold_flat_font_family")};
      font-size: ${tokPx("typography_primitives_body_l_bold_flat_font_size")};
      line-height: ${tok("typography_primitives_body_l_bold_flat_line_height")};
      font-weight: ${tok("typography_primitives_body_l_bold_flat_font_weight")};
      letter-spacing: ${tok("typography_primitives_body_l_bold_flat_letter_spacing")};
    `,
    "body-m-regular-loose": css7`
      font-family: ${tok("typography_primitives_body_m_regular_loose_font_family")};
      font-size: ${tokPx("typography_primitives_body_m_regular_loose_font_size")};
      line-height: ${tok("typography_primitives_body_m_regular_loose_line_height")};
      font-weight: ${tok("typography_primitives_body_m_regular_loose_font_weight")};
      letter-spacing: ${tok("typography_primitives_body_m_regular_loose_letter_spacing")};
    `,
    "body-m-regular-snug": css7`
      font-family: ${tok("typography_primitives_body_m_regular_snug_font_family")};
      font-size: ${tokPx("typography_primitives_body_m_regular_snug_font_size")};
      line-height: ${tok("typography_primitives_body_m_regular_snug_line_height")};
      font-weight: ${tok("typography_primitives_body_m_regular_snug_font_weight")};
      letter-spacing: ${tok("typography_primitives_body_m_regular_snug_letter_spacing")};
    `,
    "body-m-regular-tight": css7`
      font-family: ${tok("typography_primitives_body_m_regular_tight_font_family")};
      font-size: ${tokPx("typography_primitives_body_m_regular_tight_font_size")};
      line-height: ${tok("typography_primitives_body_m_regular_tight_line_height")};
      font-weight: ${tok("typography_primitives_body_m_regular_tight_font_weight")};
      letter-spacing: ${tok("typography_primitives_body_m_regular_tight_letter_spacing")};
    `,
    "body-m-regular-flat": css7`
      font-family: ${tok("typography_primitives_body_m_regular_flat_font_family")};
      font-size: ${tokPx("typography_primitives_body_m_regular_flat_font_size")};
      line-height: ${tok("typography_primitives_body_m_regular_flat_line_height")};
      font-weight: ${tok("typography_primitives_body_m_regular_flat_font_weight")};
      letter-spacing: ${tok("typography_primitives_body_m_regular_flat_letter_spacing")};
    `,
    "body-m-bold-loose": css7`
      font-family: ${tok("typography_primitives_body_m_bold_loose_font_family")};
      font-size: ${tokPx("typography_primitives_body_m_bold_loose_font_size")};
      line-height: ${tok("typography_primitives_body_m_bold_loose_line_height")};
      font-weight: ${tok("typography_primitives_body_m_bold_loose_font_weight")};
      letter-spacing: ${tok("typography_primitives_body_m_bold_loose_letter_spacing")};
    `,
    "body-m-bold-snug": css7`
      font-family: ${tok("typography_primitives_body_m_bold_snug_font_family")};
      font-size: ${tokPx("typography_primitives_body_m_bold_snug_font_size")};
      line-height: ${tok("typography_primitives_body_m_bold_snug_line_height")};
      font-weight: ${tok("typography_primitives_body_m_bold_snug_font_weight")};
      letter-spacing: ${tok("typography_primitives_body_m_bold_snug_letter_spacing")};
    `,
    "body-m-bold-tight": css7`
      font-family: ${tok("typography_primitives_body_m_bold_tight_font_family")};
      font-size: ${tokPx("typography_primitives_body_m_bold_tight_font_size")};
      line-height: ${tok("typography_primitives_body_m_bold_tight_line_height")};
      font-weight: ${tok("typography_primitives_body_m_bold_tight_font_weight")};
      letter-spacing: ${tok("typography_primitives_body_m_bold_tight_letter_spacing")};
    `,
    "body-m-bold-flat": css7`
      font-family: ${tok("typography_primitives_body_m_bold_flat_font_family")};
      font-size: ${tokPx("typography_primitives_body_m_bold_flat_font_size")};
      line-height: ${tok("typography_primitives_body_m_bold_flat_line_height")};
      font-weight: ${tok("typography_primitives_body_m_bold_flat_font_weight")};
      letter-spacing: ${tok("typography_primitives_body_m_bold_flat_letter_spacing")};
    `,
    "body-s-regular-loose": css7`
      font-family: ${tok("typography_primitives_body_s_regular_loose_font_family")};
      font-size: ${tokPx("typography_primitives_body_s_regular_loose_font_size")};
      line-height: ${tok("typography_primitives_body_s_regular_loose_line_height")};
      font-weight: ${tok("typography_primitives_body_s_regular_loose_font_weight")};
      letter-spacing: ${tok("typography_primitives_body_s_regular_loose_letter_spacing")};
    `,
    "body-s-regular-snug": css7`
      font-family: ${tok("typography_primitives_body_s_regular_snug_font_family")};
      font-size: ${tokPx("typography_primitives_body_s_regular_snug_font_size")};
      line-height: ${tok("typography_primitives_body_s_regular_snug_line_height")};
      font-weight: ${tok("typography_primitives_body_s_regular_snug_font_weight")};
      letter-spacing: ${tok("typography_primitives_body_s_regular_snug_letter_spacing")};
    `,
    "body-s-regular-tight": css7`
      font-family: ${tok("typography_primitives_body_s_regular_tight_font_family")};
      font-size: ${tokPx("typography_primitives_body_s_regular_tight_font_size")};
      line-height: ${tok("typography_primitives_body_s_regular_tight_line_height")};
      font-weight: ${tok("typography_primitives_body_s_regular_tight_font_weight")};
      letter-spacing: ${tok("typography_primitives_body_s_regular_tight_letter_spacing")};
    `,
    "body-s-regular-flat": css7`
      font-family: ${tok("typography_primitives_body_s_regular_flat_font_family")};
      font-size: ${tokPx("typography_primitives_body_s_regular_flat_font_size")};
      line-height: ${tok("typography_primitives_body_s_regular_flat_line_height")};
      font-weight: ${tok("typography_primitives_body_s_regular_flat_font_weight")};
      letter-spacing: ${tok("typography_primitives_body_s_regular_flat_letter_spacing")};
    `,
    "body-s-bold-loose": css7`
      font-family: ${tok("typography_primitives_body_s_bold_loose_font_family")};
      font-size: ${tokPx("typography_primitives_body_s_bold_loose_font_size")};
      line-height: ${tok("typography_primitives_body_s_bold_loose_line_height")};
      font-weight: ${tok("typography_primitives_body_s_bold_loose_font_weight")};
      letter-spacing: ${tok("typography_primitives_body_s_bold_loose_letter_spacing")};
    `,
    "body-s-bold-snug": css7`
      font-family: ${tok("typography_primitives_body_s_bold_snug_font_family")};
      font-size: ${tokPx("typography_primitives_body_s_bold_snug_font_size")};
      line-height: ${tok("typography_primitives_body_s_bold_snug_line_height")};
      font-weight: ${tok("typography_primitives_body_s_bold_snug_font_weight")};
      letter-spacing: ${tok("typography_primitives_body_s_bold_snug_letter_spacing")};
    `,
    "body-s-bold-tight": css7`
      font-family: ${tok("typography_primitives_body_s_bold_tight_font_family")};
      font-size: ${tokPx("typography_primitives_body_s_bold_tight_font_size")};
      line-height: ${tok("typography_primitives_body_s_bold_tight_line_height")};
      font-weight: ${tok("typography_primitives_body_s_bold_tight_font_weight")};
      letter-spacing: ${tok("typography_primitives_body_s_bold_tight_letter_spacing")};
    `,
    "body-s-bold-flat": css7`
      font-family: ${tok("typography_primitives_body_s_bold_flat_font_family")};
      font-size: ${tokPx("typography_primitives_body_s_bold_flat_font_size")};
      line-height: ${tok("typography_primitives_body_s_bold_flat_line_height")};
      font-weight: ${tok("typography_primitives_body_s_bold_flat_font_weight")};
      letter-spacing: ${tok("typography_primitives_body_s_bold_flat_letter_spacing")};
    `,
    "body-xs-regular-loose": css7`
      font-family: ${tok("typography_primitives_body_xs_regular_loose_font_family")};
      font-size: ${tokPx("typography_primitives_body_xs_regular_loose_font_size")};
      line-height: ${tok("typography_primitives_body_xs_regular_loose_line_height")};
      font-weight: ${tok("typography_primitives_body_xs_regular_loose_font_weight")};
      letter-spacing: ${tok("typography_primitives_body_xs_regular_loose_letter_spacing")};
    `,
    "body-xs-regular-snug": css7`
      font-family: ${tok("typography_primitives_body_xs_regular_snug_font_family")};
      font-size: ${tokPx("typography_primitives_body_xs_regular_snug_font_size")};
      line-height: ${tok("typography_primitives_body_xs_regular_snug_line_height")};
      font-weight: ${tok("typography_primitives_body_xs_regular_snug_font_weight")};
      letter-spacing: ${tok("typography_primitives_body_xs_regular_snug_letter_spacing")};
    `,
    "body-xs-regular-tight": css7`
      font-family: ${tok("typography_primitives_body_xs_regular_tight_font_family")};
      font-size: ${tokPx("typography_primitives_body_xs_regular_tight_font_size")};
      line-height: ${tok("typography_primitives_body_xs_regular_tight_line_height")};
      font-weight: ${tok("typography_primitives_body_xs_regular_tight_font_weight")};
      letter-spacing: ${tok("typography_primitives_body_xs_regular_tight_letter_spacing")};
    `,
    "body-xs-regular-flat": css7`
      font-family: ${tok("typography_primitives_body_xs_regular_flat_font_family")};
      font-size: ${tokPx("typography_primitives_body_xs_regular_flat_font_size")};
      line-height: ${tok("typography_primitives_body_xs_regular_flat_line_height")};
      font-weight: ${tok("typography_primitives_body_xs_regular_flat_font_weight")};
      letter-spacing: ${tok("typography_primitives_body_xs_regular_flat_letter_spacing")};
    `,
    "body-xs-bold-loose": css7`
      font-family: ${tok("typography_primitives_body_xs_bold_loose_font_family")};
      font-size: ${tokPx("typography_primitives_body_xs_bold_loose_font_size")};
      line-height: ${tok("typography_primitives_body_xs_bold_loose_line_height")};
      font-weight: ${tok("typography_primitives_body_xs_bold_loose_font_weight")};
      letter-spacing: ${tok("typography_primitives_body_xs_bold_loose_letter_spacing")};
    `,
    "body-xs-bold-snug": css7`
      font-family: ${tok("typography_primitives_body_xs_bold_snug_font_family")};
      font-size: ${tokPx("typography_primitives_body_xs_bold_snug_font_size")};
      line-height: ${tok("typography_primitives_body_xs_bold_snug_line_height")};
      font-weight: ${tok("typography_primitives_body_xs_bold_snug_font_weight")};
      letter-spacing: ${tok("typography_primitives_body_xs_bold_snug_letter_spacing")};
    `,
    "body-xs-bold-tight": css7`
      font-family: ${tok("typography_primitives_body_xs_bold_tight_font_family")};
      font-size: ${tokPx("typography_primitives_body_xs_bold_tight_font_size")};
      line-height: ${tok("typography_primitives_body_xs_bold_tight_line_height")};
      font-weight: ${tok("typography_primitives_body_xs_bold_tight_font_weight")};
      letter-spacing: ${tok("typography_primitives_body_xs_bold_tight_letter_spacing")};
    `,
    "body-xs-bold-flat": css7`
      font-family: ${tok("typography_primitives_body_xs_bold_flat_font_family")};
      font-size: ${tokPx("typography_primitives_body_xs_bold_flat_font_size")};
      line-height: ${tok("typography_primitives_body_xs_bold_flat_line_height")};
      font-weight: ${tok("typography_primitives_body_xs_bold_flat_font_weight")};
      letter-spacing: ${tok("typography_primitives_body_xs_bold_flat_letter_spacing")};
    `,
    "display-a-regular": css7`
      font-family: ${tok("typography_primitives_display_a_regular_font_family")};
      font-size: ${tokPx("typography_primitives_display_a_regular_font_size")};
      line-height: ${tok("typography_primitives_display_a_regular_line_height")};
      font-weight: ${tok("typography_primitives_display_a_regular_font_weight")};
      letter-spacing: ${tok("typography_primitives_display_a_regular_letter_spacing")};
    `,
    "display-b-regular": css7`
      font-family: ${tok("typography_primitives_display_b_regular_font_family")};
      font-size: ${tokPx("typography_primitives_display_b_regular_font_size")};
      line-height: ${tok("typography_primitives_display_b_regular_line_height")};
      font-weight: ${tok("typography_primitives_display_b_regular_font_weight")};
      letter-spacing: ${tok("typography_primitives_display_b_regular_letter_spacing")};
    `,
    "display-c-regular": css7`
      font-family: ${tok("typography_primitives_display_c_regular_font_family")};
      font-size: ${tokPx("typography_primitives_display_c_regular_font_size")};
      line-height: ${tok("typography_primitives_display_c_regular_line_height")};
      font-weight: ${tok("typography_primitives_display_c_regular_font_weight")};
      letter-spacing: ${tok("typography_primitives_display_c_regular_letter_spacing")};
    `,
    "display-d-regular": css7`
      font-family: ${tok("typography_primitives_display_d_regular_font_family")};
      font-size: ${tokPx("typography_primitives_display_d_regular_font_size")};
      line-height: ${tok("typography_primitives_display_d_regular_line_height")};
      font-weight: ${tok("typography_primitives_display_d_regular_font_weight")};
      letter-spacing: ${tok("typography_primitives_display_d_regular_letter_spacing")};
    `,
    "display-e-regular": css7`
      font-family: ${tok("typography_primitives_display_e_regular_font_family")};
      font-size: ${tokPx("typography_primitives_display_e_regular_font_size")};
      line-height: ${tok("typography_primitives_display_e_regular_line_height")};
      font-weight: ${tok("typography_primitives_display_e_regular_font_weight")};
      letter-spacing: ${tok("typography_primitives_display_e_regular_letter_spacing")};
    `,
    "display-f-regular": css7`
      font-family: ${tok("typography_primitives_display_f_regular_font_family")};
      font-size: ${tokPx("typography_primitives_display_f_regular_font_size")};
      line-height: ${tok("typography_primitives_display_f_regular_line_height")};
      font-weight: ${tok("typography_primitives_display_f_regular_font_weight")};
      letter-spacing: ${tok("typography_primitives_display_f_regular_letter_spacing")};
    `,
    "display-g-regular": css7`
      font-family: ${tok("typography_primitives_display_g_regular_font_family")};
      font-size: ${tokPx("typography_primitives_display_g_regular_font_size")};
      line-height: ${tok("typography_primitives_display_g_regular_line_height")};
      font-weight: ${tok("typography_primitives_display_g_regular_font_weight")};
      letter-spacing: ${tok("typography_primitives_display_g_regular_letter_spacing")};
    `,
    "display-h-regular": css7`
      font-family: ${tok("typography_primitives_display_h_regular_font_family")};
      font-size: ${tokPx("typography_primitives_display_h_regular_font_size")};
      line-height: ${tok("typography_primitives_display_h_regular_line_height")};
      font-weight: ${tok("typography_primitives_display_h_regular_font_weight")};
      letter-spacing: ${tok("typography_primitives_display_h_regular_letter_spacing")};
    `,
    "display-i-regular": css7`
      font-family: ${tok("typography_primitives_display_i_regular_font_family")};
      font-size: ${tokPx("typography_primitives_display_i_regular_font_size")};
      line-height: ${tok("typography_primitives_display_i_regular_line_height")};
      font-weight: ${tok("typography_primitives_display_i_regular_font_weight")};
      letter-spacing: ${tok("typography_primitives_display_i_regular_letter_spacing")};
    `,
    "display-j-regular": css7`
      font-family: ${tok("typography_primitives_display_j_regular_font_family")};
      font-size: ${tokPx("typography_primitives_display_j_regular_font_size")};
      line-height: ${tok("typography_primitives_display_j_regular_line_height")};
      font-weight: ${tok("typography_primitives_display_j_regular_font_weight")};
      letter-spacing: ${tok("typography_primitives_display_j_regular_letter_spacing")};
    `
  }[variantName];
}
function modColor(colorName) {
  return css7`
    color: ${textColor(colorName)};
  `;
}
var TypographyWithModifiers = withStyleModifiers(Typography, {
  modVariant,
  modColor
});
var Typography_default = TypographyWithModifiers;

// src/uds/components/Accordion/Accordion.tsx
import { jsx as jsx5, jsxs } from "react/jsx-runtime";
var Wrapper = styled6.div`
  border-bottom: ${tokPx("semantics_dividers_tickness")} solid ${tok("semantics_dividers_color")};
  padding: ${tokPx("primitives_space_8")} 0;

  ${Collapsible} {
    // This is needed to avoid the outline being cut off
    padding: 4px;
    margin: -4px -4px 0 -4px;

    padding-bottom: ${space("primitives_space_16")};
  }
`;
var Header = styled6(CollapsibleTrigger)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  width: 100%;
  text-align: left;
  min-height: ${tokPx("primitives_space_48")};
  padding-top: ${space("primitives_space_8")};
  padding-bottom: ${space("primitives_space_8")};

  ${Icon_default}:last-of-type {
    transition: transform 200ms ease-out;
    margin-left: auto !important;
  }

  &[data-state='open'] {
    ${Icon_default}:last-of-type {
      transform: rotate(180deg);
    }
  }

  ${focusOutline()}
`;
function Item({
  children,
  title,
  defaultOpen,
  onOpenChange,
  disabled,
  ...rest
}) {
  return /* @__PURE__ */ jsx5(Wrapper, {
    ...rest,
    children: /* @__PURE__ */ jsxs(CollapsibleRoot, {
      defaultOpen,
      onOpenChange,
      disabled,
      children: [
        /* @__PURE__ */ jsxs(Header, {
          children: [
            /* @__PURE__ */ jsx5(Typography_default, {
              $variant: "body-m-bold-tight",
              children: title
            }),
            /* @__PURE__ */ jsx5(Icon_default, {
              glyph: "ChevronDown",
              size: 24,
              "aria-hidden": true
            })
          ]
        }),
        /* @__PURE__ */ jsx5(Collapsible, {
          children: /* @__PURE__ */ jsx5(Typography_default, {
            children
          })
        })
      ]
    })
  });
}
Item.displayName = "Accordion.Item";
var Root2 = styled6.article``;
Root2.displayName = "Accordion.Root";

// src/uds/components/AirlineIcon/index.ts
init_esm_shims();

// src/uds/components/AirlineIcon/AirlineIcon.tsx
init_esm_shims();
import { css as css8, styled as styled7 } from "styled-components";

// src/uds/airline-logos/generated/index.ts
var generated_exports = {};
__export(generated_exports, {
  IconAegeanAirlines: () => AegeanAirlines_default,
  IconAirBaltic: () => AirBaltic_default,
  IconAirCairo: () => AirCairo_default,
  IconAirEuropa: () => AirEuropa_default,
  IconAirSeven: () => AirSeven_default,
  IconArkefly: () => Arkefly_default,
  IconAtlanticAirways: () => AtlanticAirways_default,
  IconAustrianAirlines: () => AustrianAirlines_default,
  IconBrusselsAirlines: () => BrusselsAirlines_default,
  IconBulAir: () => BulAir_default,
  IconBulgariaAir: () => BulgariaAir_default,
  IconCityjet: () => Cityjet_default,
  IconCondor: () => Condor_default,
  IconCorendonAirlines: () => CorendonAirlines_default,
  IconDanishAirTransport: () => DanishAirTransport_default,
  IconEasyjet: () => Easyjet_default,
  IconEdelweiss: () => Edelweiss_default,
  IconEgyptair: () => Egyptair_default,
  IconEurowings: () => Eurowings_default,
  IconFlyegypt: () => Flyegypt_default,
  IconFreebirdAirlines: () => FreebirdAirlines_default,
  IconJet2: () => Jet2_default,
  IconJetTime: () => JetTime_default,
  IconLufthansa: () => Lufthansa_default,
  IconLuxair: () => Luxair_default,
  IconNesmaAirlines: () => NesmaAirlines_default,
  IconNorwegian: () => Norwegian_default,
  IconPegasus: () => Pegasus_default,
  IconRoyalAirMaroc: () => RoyalAirMaroc_default,
  IconRyanair: () => Ryanair_default,
  IconSas: () => Sas_default,
  IconSkyExpress: () => SkyExpress_default,
  IconSmartwings: () => Smartwings_default,
  IconSunExpress: () => SunExpress_default,
  IconSunclass: () => Sunclass_default,
  IconSundair: () => Sundair_default,
  IconSwiss: () => Swiss_default,
  IconTailwindAirlines: () => TailwindAirlines_default,
  IconTailwindAirlinesCopy: () => TailwindAirlinesCopy_default,
  IconTransavia: () => Transavia_default,
  IconTunisair: () => Tunisair_default,
  IconVolotea: () => Volotea_default,
  IconVueling: () => Vueling_default,
  IconWizzAir: () => WizzAir_default
});
init_esm_shims();

// src/uds/airline-logos/generated/AegeanAirlines.tsx
init_esm_shims();
import { jsx as jsx6, jsxs as jsxs2 } from "react/jsx-runtime";
var SvgAegeanAirlines = (props) => /* @__PURE__ */ jsxs2("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx6("path", {
      fill: "#88A8D8",
      d: "M32.822 25H42a25.872 25.872 0 0 1-11.24-11.354C26.84 5.625 19.105.937 9 0l.206.73c6.91 2.812 11.756 7.29 14.54 13.645 2.063 4.27 5.157 8.02 9.076 10.625Z"
    }),
    /* @__PURE__ */ jsx6("path", {
      fill: "#1C4093",
      d: "M32.822 25H42a25.872 25.872 0 0 0-11.24 11.354C26.84 44.48 19.105 49.063 9 50l.206-.73c6.91-2.812 11.756-7.29 14.54-13.645 2.063-4.27 5.157-8.02 9.076-10.625Z"
    }),
    /* @__PURE__ */ jsx6("path", {
      fill: "#88A8D8",
      d: "M9 8.125c1.65 6.25 3.919 11.354 5.878 13.854 1.031 1.354 2.372 2.396 3.816 3.021h7.219a15.36 15.36 0 0 1-7.632-7.708C16.528 13.125 13.125 9.896 9 8.125Z"
    }),
    /* @__PURE__ */ jsx6("path", {
      fill: "#1C4093",
      d: "M9 41.875c1.65-6.25 3.919-11.354 5.878-13.854 1.031-1.354 2.372-2.396 3.816-3.021h7.219a15.36 15.36 0 0 0-7.632 7.708c-1.753 4.167-5.156 7.5-9.281 9.167Z"
    })
  ]
});
var AegeanAirlines_default = SvgAegeanAirlines;

// src/uds/airline-logos/generated/AirBaltic.tsx
init_esm_shims();
import { jsx as jsx7, jsxs as jsxs3 } from "react/jsx-runtime";
var SvgAirBaltic = (props) => /* @__PURE__ */ jsxs3("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx7("path", {
      fill: "#bfd730",
      d: "M0 5h50v40H0z"
    }),
    /* @__PURE__ */ jsx7("g", {
      fill: "#11175e",
      children: /* @__PURE__ */ jsx7("path", {
        d: "M12.834 28.934h1.42v-5.957h-1.42zm0-6.514h1.42V21h-1.42zM16.314 28.934h-1.42v-5.957h1.392v1.113c.446-.64 1.086-1.225 1.949-1.225.167 0 .25 0 .334.028v1.336c-.111-.027-.334-.027-.418-.027-.64 0-1.81.612-1.81 1.81v2.922zM18.93 28.934V21h2.562c.668 0 2.951 0 2.951 1.949 0 1.336-1.03 1.698-1.587 1.865.613.167 1.754.473 1.754 1.949 0 1.197-.918 2.171-2.95 2.171zm1.504-4.705h1.058c1.364 0 1.476-.807 1.476-1.085 0-1.003-1.03-1.003-1.337-1.003h-1.169v2.088zm0 3.536h.947c1.002 0 1.726-.334 1.726-1.17 0-.556-.306-1.196-1.615-1.196h-1.03v2.366zM28.647 28.934l-.167-.64c-.362.306-.919.752-1.81.752-1.058 0-1.837-.696-1.837-1.643 0-.612.223-1.336 1.531-1.782l1.726-.584c.25-.084.25-.084.25-.25v-.251c0-.501-.445-.64-1.001-.64-.947 0-1.81.584-2.144.807v-1.225c.39-.223 1.113-.613 2.366-.613 1.865 0 2.227.919 2.227 2.06v4.037h-1.141zm-1.559-2.533c-.613.223-.807.501-.807.919 0 .584.529.723.78.723.222 0 .723-.083 1.308-.668V25.9c-.084.056-.112.083-.362.167zM11.024 28.934l-.167-.612c-.361.306-.918.752-1.81.752-1.057 0-1.837-.697-1.837-1.643 0-.613.223-1.336 1.532-1.782l1.726-.584c.25-.084.278-.084.278-.251v-.25c0-.502-.445-.64-1.03-.64-.947 0-1.81.584-2.144.807v-1.225c.39-.223 1.114-.613 2.367-.613 1.865 0 2.227.919 2.227 2.06v4.037h-1.141zm-1.559-2.533c-.612.223-.807.501-.807.919 0 .584.53.723.78.723.222 0 .724-.083 1.308-.668V25.9c-.083.056-.111.083-.362.167zM30.345 21h1.42v7.934h-1.42zM33.018 24.062h-.891v-1.085h.89V21h1.42v1.977h1.086v1.085h-1.085v3.09c0 .446.055.836.724.836.167 0 .306-.028.417-.056v1.086c-.195.028-.39.055-.668.055-1.587 0-1.893-.807-1.893-1.837zM36.08 21h1.42v1.42h-1.42zm0 1.977h1.42v5.985h-1.42zM42.65 24.591c-.278-.25-.751-.612-1.559-.612-1.225 0-1.726 1.03-1.726 2.004 0 .418.111 2.005 1.67 2.005.808 0 1.337-.362 1.727-.64V28.6c-.279.14-.92.473-1.95.473-2.031 0-2.894-1.53-2.894-3.118 0-1.67.918-3.118 2.95-3.118.975 0 1.504.307 1.754.446v1.308z"
      })
    })
  ]
});
var AirBaltic_default = SvgAirBaltic;

// src/uds/airline-logos/generated/AirCairo.tsx
init_esm_shims();
import { jsx as jsx8, jsxs as jsxs4 } from "react/jsx-runtime";
var SvgAirCairo = (props) => /* @__PURE__ */ jsxs4("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx8("path", {
      fill: "#3d1063",
      d: "M4.293 21c-.545.015-1.09.012-1.635.02C1.77 23.58.888 26.141 0 28.701v.01h2.357c.552-1.54 1.068-3.092 1.613-4.634.048.095.087.194.118.296.347.998.682 2 1.037 2.996.181.445.35.896.53 1.341H8.12C7.226 26.143 6.342 23.571 5.45 21zm1.789 0c.895 2.569 1.776 5.143 2.67 7.711h2.556c-.843-2.421-1.677-4.847-2.517-7.27-.054-.148-.09-.305-.174-.441zm4.95 0c-.585.021-1.17.01-1.753.019.885 2.565 1.77 5.13 2.66 7.692h2.15c-.133-.364-.258-.732-.387-1.098.469-.005.937.007 1.406-.006.131 0 .268-.04.397-.012.426.364.834.749 1.258 1.116h3.334c-.865-.778-1.725-1.563-2.587-2.345a2.404 2.404 0 0 0 .356-1.586c-.115-1.03-.71-1.958-1.498-2.61A4.897 4.897 0 0 0 13.52 21zm14.745 0c-.59 1.683-1.173 3.367-1.767 5.048-.23.652-.498 1.296-.868 1.882a3.14 3.14 0 0 1-.677.781h2.085c.55-.242 1.054-.657 1.281-1.226l.602-1.517c.206-.543.373-1.1.583-1.641.52 1.458 1.018 2.924 1.536 4.384h2.5c-.895-2.569-1.776-5.142-2.67-7.711zm3.237 0c.895 2.569 1.775 5.143 2.67 7.711h2.556c-.893-2.569-1.772-5.142-2.665-7.711zm3.186 0c.895 2.569 1.776 5.143 2.67 7.711h2.15c-.125-.36-.245-.722-.367-1.083.648-.011 1.297.027 1.944-.033.422.372.843.747 1.268 1.116h3.382c-.871-.777-1.738-1.559-2.606-2.338a2.39 2.39 0 0 0 .353-.93c.086-.613-.06-1.238-.318-1.793-.37-.791-1.008-1.43-1.734-1.903A4.867 4.867 0 0 0 36.909 21zm4.683 2.35a1.4 1.4 0 0 1 1.207.722c.122.23.154.526.018.758-.135.238-.414.36-.68.362-.543.002-1.085.001-1.627 0l-.635-1.842c.572-.003 1.145-.002 1.717 0zm-24.645.014c.522 0 1.044-.002 1.566.001a1.38 1.38 0 0 1 1.19.714c.125.236.154.542.006.775-.145.239-.436.347-.706.342-.476 0-.952.003-1.428-.002-.208-.61-.418-1.22-.628-1.83z"
    }),
    /* @__PURE__ */ jsx8("path", {
      fill: "#f58220",
      d: "M22.224 21c-1.699.23-3.15 1.69-3.365 3.39-.127.926.034 1.905.537 2.7a4.352 4.352 0 0 0 1.833 1.621h1.236a3.14 3.14 0 0 0 .677-.781c.37-.586.638-1.23.868-1.882-.09.196-.26.342-.447.444-.663.38-1.552.17-2.047-.39-.356-.372-.42-.93-.347-1.419.067-.437.344-.814.694-1.072.66-.48 1.661-.376 2.207.232l.804-2.321A2.873 2.873 0 0 0 23.531 21zm21.673 0c-.69.097-1.365.38-1.864.875-.486.466-.822 1.1-.872 1.777-.065.82.185 1.642.603 2.34.502.823 1.246 1.48 2.077 1.957a5.443 5.443 0 0 0 2.72.746c.774.006 1.573-.168 2.209-.627.696-.491 1.18-1.288 1.23-2.146v-.369a4.358 4.358 0 0 0-.767-2.118c-.459-.664-1.086-1.195-1.766-1.621a5.607 5.607 0 0 0-2.23-.814zm1.272 2.215c.51.004 1.01.199 1.414.508.49.338.842.896.85 1.5.011.69-.652 1.22-1.31 1.223-.83.054-1.663-.383-2.117-1.076-.245-.394-.383-.902-.212-1.351.183-.466.663-.768 1.155-.794.073-.008.147-.011.22-.01z"
    })
  ]
});
var AirCairo_default = SvgAirCairo;

// src/uds/airline-logos/generated/AirEuropa.tsx
init_esm_shims();
import { jsx as jsx9 } from "react/jsx-runtime";
var SvgAirEuropa = (props) => /* @__PURE__ */ jsx9("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsx9("path", {
    fill: "#006fde",
    d: "M9.515 43a9.07 9.07 0 0 1-2.923-.464c-1.777-.573-4.128-3.124-5.025-5.455a22.349 22.349 0 0 1-1.063-7.228c.004-2.578.409-5.14 1.2-7.596A27.538 27.538 0 0 1 6.64 13.54a21.978 21.978 0 0 1 3.289-3.203 14.136 14.136 0 0 1 3.496-2.044 15.74 15.74 0 0 1 5.653-1.038 13.94 13.94 0 0 1 5.07.914 12.035 12.035 0 0 1 4.576 3.136 15.253 15.253 0 0 1 5.709-3.34 17.512 17.512 0 0 1 5.331-.941h.157C40.267 7.008 40.6 7 40.934 7c3.11 0 5.508.684 7.133 2.033a7.184 7.184 0 0 1 1.885 2.627 7.118 7.118 0 0 1 .534 3.178 7.374 7.374 0 0 1-.918 3.207 9.092 9.092 0 0 1-2.192 2.826c-1.038.852-4.776 3.315-8.016 5.38a72.352 72.352 0 0 1-6.968 4.149l-.032-3.72 3.658-2.617c4.718-3.373 6.315-5.123 6.838-7.487.198-.82.235-1.67.11-2.503a3.894 3.894 0 0 0-.777-1.81 3.702 3.702 0 0 0-1.338-1.008 3.739 3.739 0 0 0-1.65-.319c-1.125.084-2.22.4-3.215.928A8.073 8.073 0 0 0 33.426 14a17.06 17.06 0 0 0-2.888 4.768 25.845 25.845 0 0 0-1.634 5.821 23.012 23.012 0 0 0-.215 5.813c.12 1.658.586 3.273 1.37 4.743.372.741.951 1.36 1.668 1.785a4.402 4.402 0 0 0 2.377.612c2.28 0 5.331-1.222 9.885-3.96l2.752-1.789 1.941 2.743a71.155 71.155 0 0 1-8.507 6.349 15.484 15.484 0 0 1-7.983 2.093 15.983 15.983 0 0 1-6.723-1.28 7.647 7.647 0 0 1-3.828-4.09 5.911 5.911 0 0 0-.953.66c-.532.397-1.26.941-2.066 1.488A16.888 16.888 0 0 1 9.515 43zM20.44 10.6c-1.02.043-2.02.3-2.934.752a11.672 11.672 0 0 0-3.094 2.523 17.765 17.765 0 0 0-2.696 3.724 22.25 22.25 0 0 0-2.276 9.319 15.015 15.015 0 0 0 1.535 7.79c.266.558.677 1.035 1.19 1.385s1.111.557 1.733.604c1.545-.06 3.475-1.28 5.518-2.571a94.012 94.012 0 0 1 1.548-.962 23.048 23.048 0 0 1 .144-7.065 40.91 40.91 0 0 1 1.51-6.063 14.997 14.997 0 0 0 1.08-4.669 5.804 5.804 0 0 0-.752-3.518 2.83 2.83 0 0 0-1.086-.953c-.44-.22-.929-.32-1.42-.296z"
  })
});
var AirEuropa_default = SvgAirEuropa;

// src/uds/airline-logos/generated/AirSeven.tsx
init_esm_shims();
import { jsx as jsx10, jsxs as jsxs5 } from "react/jsx-runtime";
var SvgAirSeven = (props) => /* @__PURE__ */ jsxs5("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx10("path", {
      d: "M38.602 5.578c-.098-.137-.282-.21-.54-.21H7.875c-.602 0-.797.343-.797.788v1.227c0 .441.207.785.797.785h26.637c.43 0 .664.285.55.75l-9.667 40.098c-.122.492 0 .886.601.886h1.305c.453 0 .808-.172.933-.613L38.652 6.168c.059-.285.035-.469-.05-.59Zm0 0",
      style: {
        stroke: "none",
        fillRule: "nonzero",
        fill: "#769d91",
        fillOpacity: 1
      }
    }),
    /* @__PURE__ */ jsx10("path", {
      d: "M45.95.207C45.851.074 45.663 0 45.405 0H4.965c-.602 0-.797.344-.797.785v1.23c0 .442.195.786.797.786h36.89c.43 0 .665.281.555.75L31.477 49.004c-.125.492 0 .887.601.887h1.3c.458 0 .813-.172.934-.618L45.996.785c.074-.27.05-.453-.047-.578Zm0 0",
      style: {
        stroke: "none",
        fillRule: "nonzero",
        fill: "#769d91",
        fillOpacity: 1
      }
    }),
    /* @__PURE__ */ jsx10("path", {
      d: "m19.902 33.488 4.008-16.597c.059-.27.035-.442-.05-.575-.098-.136-.258-.21-.516-.21h-9.645c-.601 0-.785.343-.785.785v1.23c0 .442.184.785.785.785h6.621c.075 0 .114.012.137.051.023.035.035.086.023.16L17.066 33.22c-.125.492 0 .883.602.883h1.316c.453 0 .809-.157.918-.614Zm0 0",
      style: {
        stroke: "none",
        fillRule: "nonzero",
        fill: "#769d91",
        fillOpacity: 1
      }
    }),
    /* @__PURE__ */ jsx10("path", {
      d: "M31.242 10.945c-.097-.133-.281-.207-.539-.207H10.79c-.601 0-.785.344-.785.785v1.227c0 .445.184.79.785.79h16.363c.43 0 .664.28.551.75l-8.375 34.702c-.125.492 0 .887.602.887h1.3c.454 0 .813-.172.934-.617l9.129-37.739c.059-.27.035-.453-.05-.578Zm0 0",
      style: {
        stroke: "none",
        fillRule: "nonzero",
        fill: "#769d91",
        fillOpacity: 1
      }
    })
  ]
});
var AirSeven_default = SvgAirSeven;

// src/uds/airline-logos/generated/Arkefly.tsx
init_esm_shims();
import { jsx as jsx11 } from "react/jsx-runtime";
var SvgArkefly = (props) => /* @__PURE__ */ jsx11("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsx11("g", {
    fill: "#e41917",
    children: /* @__PURE__ */ jsx11("path", {
      d: "M2.375 16.143h11.886c1.165 0 2.043.368 2.389 2.023.384 1.84.226 3.12-1.845 3.267l-3.732.267c2.747 17.353 18.805 23.009 27.547 4.32 1.447-3.094 1.92-3.658 3.506-3.264 2.149.533 2.442 1.638 1.418 4.757-7.559 23.04-32.964 25.35-37.949-5.42l-3.032.22C.097 22.49 0 20.408 0 19.251c0-2.288.85-3.108 2.375-3.108zM45.589 5a4.411 4.411 0 1 1 0 8.823 4.411 4.411 0 0 1 0-8.823z"
    })
  })
});
var Arkefly_default = SvgArkefly;

// src/uds/airline-logos/generated/AtlanticAirways.tsx
init_esm_shims();
import { jsx as jsx12, jsxs as jsxs6 } from "react/jsx-runtime";
var SvgAtlanticAirways = (props) => /* @__PURE__ */ jsxs6("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx12("clipPath", {
      id: "atlantic-airways_svg__a",
      children: /* @__PURE__ */ jsx12("path", {
        d: "M0 0h50v50H0z"
      })
    }),
    /* @__PURE__ */ jsxs6("g", {
      fillRule: "evenodd",
      clipPath: "url(#atlantic-airways_svg__a)",
      clipRule: "evenodd",
      children: [
        /* @__PURE__ */ jsx12("path", {
          fill: "#00529b",
          d: "M17.544 27.553s-4.503-2.057-4.417-3.183a.45.45 0 0 1 .176-.308s2.346-2.585 6.893-4.405c3.67-1.472 4.537-1.37 4.537-1.37-.063 1.684 1.027 3.011 2.778 3.624 0 0 6.878-2.192 10.76-2.505 4.684-.38 6.385 1.365 6.385 1.365s3.894.224 5.185 1.022c0 0 .166.131.159.2-.003.023-.024.035-.078.035-.215.004-.932-.153-1.975-.04-2.494.267-6.992.82-8.32 1.557 0 0-7.216 11.44-39.627 11.275 0 0 10.03-2.186 17.544-7.267z"
        }),
        /* @__PURE__ */ jsx12("path", {
          fill: "#df3127",
          d: "M25.368 16.352c.285-.016.96.099 1.102.485 0 0-1.053-.633-14.373 3.597C7.922 21.757 1.627 17.371.015 16c0 0 5.037 1.326 25.353.35"
        })
      ]
    })
  ]
});
var AtlanticAirways_default = SvgAtlanticAirways;

// src/uds/airline-logos/generated/AustrianAirlines.tsx
init_esm_shims();
import { jsx as jsx13, jsxs as jsxs7 } from "react/jsx-runtime";
var SvgAustrianAirlines = (props) => /* @__PURE__ */ jsxs7("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx13("clipPath", {
      id: "austrian-airlines_svg__a",
      children: /* @__PURE__ */ jsx13("path", {
        d: "M0 0h50v50H0z"
      })
    }),
    /* @__PURE__ */ jsxs7("g", {
      fill: "#d81e05",
      fillRule: "evenodd",
      clipPath: "url(#austrian-airlines_svg__a)",
      clipRule: "evenodd",
      children: [
        /* @__PURE__ */ jsx13("path", {
          d: "M5.465 33.294c6.619-5.363 11.345-9.959 12.753-12.45.599-.961.79-1.88.458-2.629-.617-1.393-2.797-1.816-5.486-1.293A209.116 209.116 0 0 1 49.771 12a.222.222 0 0 1 .076.433C34.261 17.498 20.074 25.706 8.02 36.323a.11.11 0 0 1-.052.026L.123 37.725c-.11.02-.168-.123-.08-.192a208.677 208.677 0 0 0 5.422-4.239z"
        }),
        /* @__PURE__ */ jsx13("path", {
          d: "M4.414 19.011c-.174.048-.348.095-.524.146-.103.027-.094.18.014.195l2.972.425 5.191.742c.02.002.041-.002.06-.01 3.654-1.744 6.09-2.416 6.626-1.656.166.236.137.597-.057 1.066a5.266 5.266 0 0 1-.253.508c.57-.908.753-1.777.438-2.485-.59-1.318-2.672-1.718-5.248-1.221-3.09.69-6.164 1.454-9.218 2.29"
        })
      ]
    })
  ]
});
var AustrianAirlines_default = SvgAustrianAirlines;

// src/uds/airline-logos/generated/BrusselsAirlines.tsx
init_esm_shims();
import { jsx as jsx14 } from "react/jsx-runtime";
var SvgBrusselsAirlines = (props) => /* @__PURE__ */ jsx14("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsx14("g", {
    fill: "#e5002b",
    fillRule: "evenodd",
    clipRule: "evenodd",
    children: /* @__PURE__ */ jsx14("path", {
      d: "M12.007 40.225c0-1.6-1.306-2.897-2.92-2.897-1.612 0-2.92 1.297-2.92 2.897 0 1.6 1.308 2.896 2.92 2.896 1.614 0 2.92-1.296 2.92-2.896zM43.074 40.225c0-1.566-1.28-2.835-2.857-2.835s-2.857 1.27-2.857 2.835 1.28 2.834 2.857 2.834 2.857-1.27 2.857-2.834zM29.466 40.225c0-2.638-2.155-4.775-4.814-4.775-2.658 0-4.813 2.137-4.813 4.775S21.994 45 24.652 45c2.659 0 4.814-2.138 4.814-4.775zM13.175 24.784c0-2.24-1.83-4.056-4.088-4.056C6.83 20.728 5 22.544 5 24.784s1.83 4.055 4.087 4.055c2.258 0 4.088-1.816 4.088-4.055zM45 24.784c0-2.62-2.142-4.745-4.783-4.745-2.641 0-4.782 2.124-4.782 4.745 0 2.62 2.14 4.744 4.782 4.744 2.641 0 4.783-2.124 4.783-4.744zM30.162 24.784c0-3.019-2.467-5.466-5.51-5.466-3.042 0-5.509 2.447-5.509 5.466 0 3.018 2.467 5.465 5.51 5.465 3.042 0 5.509-2.447 5.509-5.465zM44.595 9.342c0-2.398-1.96-4.342-4.378-4.342C37.8 5 35.84 6.944 35.84 9.342c0 2.399 1.96 4.343 4.377 4.343 2.418 0 4.378-1.944 4.378-4.343zM27.837 9.342c0-1.744-1.426-3.158-3.185-3.158s-3.184 1.414-3.184 3.158c0 1.745 1.426 3.16 3.184 3.16s3.184-1.415 3.184-3.16zM9.088 12.177c-1.578 0-2.858-1.269-2.858-2.835 0-1.565 1.28-2.834 2.858-2.834s2.857 1.27 2.857 2.834c0 1.566-1.28 2.835-2.857 2.835z"
    })
  })
});
var BrusselsAirlines_default = SvgBrusselsAirlines;

// src/uds/airline-logos/generated/BulAir.tsx
init_esm_shims();
import { jsx as jsx15, jsxs as jsxs8 } from "react/jsx-runtime";
var SvgBulAir = (props) => /* @__PURE__ */ jsxs8("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsxs8("linearGradient", {
      id: "bul-air_svg__b",
      x1: 38.514,
      x2: 3.712,
      y1: 30.427,
      y2: 15.855,
      gradientUnits: "userSpaceOnUse",
      children: [
        /* @__PURE__ */ jsx15("stop", {
          offset: 0,
          stopColor: "#e5e5e5"
        }),
        /* @__PURE__ */ jsx15("stop", {
          offset: 0.119,
          stopColor: "#eee"
        }),
        /* @__PURE__ */ jsx15("stop", {
          offset: 0.264,
          stopColor: "#fff"
        }),
        /* @__PURE__ */ jsx15("stop", {
          offset: 0.455,
          stopColor: "#fbfbfb"
        }),
        /* @__PURE__ */ jsx15("stop", {
          offset: 0.635,
          stopColor: "#f0f0f0"
        }),
        /* @__PURE__ */ jsx15("stop", {
          offset: 0.81,
          stopColor: "#ddd"
        }),
        /* @__PURE__ */ jsx15("stop", {
          offset: 0.981,
          stopColor: "#c2c2c2"
        }),
        /* @__PURE__ */ jsx15("stop", {
          offset: 1,
          stopColor: "#bfbfbf"
        })
      ]
    }),
    /* @__PURE__ */ jsxs8("linearGradient", {
      id: "bul-air_svg__c",
      x1: 18.988,
      x2: 25.154,
      y1: 11.509,
      y2: 41.029,
      gradientUnits: "userSpaceOnUse",
      children: [
        /* @__PURE__ */ jsx15("stop", {
          offset: 0.093,
          stopColor: "#7fbb85"
        }),
        /* @__PURE__ */ jsx15("stop", {
          offset: 0.167,
          stopColor: "#73b874"
        }),
        /* @__PURE__ */ jsx15("stop", {
          offset: 0.338,
          stopColor: "#5aaf53"
        }),
        /* @__PURE__ */ jsx15("stop", {
          offset: 0.486,
          stopColor: "#45a73d"
        }),
        /* @__PURE__ */ jsx15("stop", {
          offset: 0.604,
          stopColor: "#38a231"
        }),
        /* @__PURE__ */ jsx15("stop", {
          offset: 0.676,
          stopColor: "#33a02c"
        }),
        /* @__PURE__ */ jsx15("stop", {
          offset: 0.885,
          stopColor: "#00742f"
        })
      ]
    }),
    /* @__PURE__ */ jsxs8("linearGradient", {
      id: "bul-air_svg__a",
      children: [
        /* @__PURE__ */ jsx15("stop", {
          offset: 0.066,
          stopColor: "#e36853"
        }),
        /* @__PURE__ */ jsx15("stop", {
          offset: 0.352,
          stopColor: "red"
        }),
        /* @__PURE__ */ jsx15("stop", {
          offset: 0.533,
          stopColor: "#fd0002"
        }),
        /* @__PURE__ */ jsx15("stop", {
          offset: 0.628,
          stopColor: "#f40006"
        }),
        /* @__PURE__ */ jsx15("stop", {
          offset: 0.702,
          stopColor: "#e70009"
        }),
        /* @__PURE__ */ jsx15("stop", {
          offset: 0.766,
          stopColor: "#d3000c"
        }),
        /* @__PURE__ */ jsx15("stop", {
          offset: 0.823,
          stopColor: "#ba0010"
        }),
        /* @__PURE__ */ jsx15("stop", {
          offset: 0.85,
          stopColor: "#ab0012"
        })
      ]
    }),
    /* @__PURE__ */ jsx15("linearGradient", {
      xlinkHref: "#bul-air_svg__a",
      id: "bul-air_svg__d",
      x1: 24.81,
      x2: 24.862,
      y1: 20.59,
      y2: 38.545,
      gradientUnits: "userSpaceOnUse"
    }),
    /* @__PURE__ */ jsx15("linearGradient", {
      xlinkHref: "#bul-air_svg__a",
      id: "bul-air_svg__e",
      x1: 38.803,
      x2: 46.507,
      y1: 45.872,
      y2: 32.703,
      gradientUnits: "userSpaceOnUse"
    }),
    /* @__PURE__ */ jsx15("path", {
      fill: "url(#bul-air_svg__b)",
      d: "M48.507 31.893c-1.611-4.263-5.612-7.419-11.557-10.132C22.836 15.284 2.945 10.191 1 1c1 16.498 23.726 18.879 36.95 25.08 3.223 1.55 6 3.986 7.612 5.647 2.612 2.657 1.334 9.024-1.445 11.681 5.668-4.097 5.223-9.3 4.39-11.515z"
    }),
    /* @__PURE__ */ jsx15("path", {
      fill: "url(#bul-air_svg__c)",
      d: "M43.284 28.792c-9.946-6.92-35.45-11.681-38.061-16 5.167 13.177 29.504 12.513 38.394 20.65 6.724 6.146-.722 10.908-2.5 12.015 6.39-3.488 10.446-10.907 2.167-16.665z"
    }),
    /* @__PURE__ */ jsx15("path", {
      fill: "url(#bul-air_svg__d)",
      d: "M46.729 37.872c-.333-10.408-30.616-12.568-37.394-18.104C17.39 32.945 44.006 32.17 45.84 39.09c.389 1.495-.5 2.934-1.611 3.986 1.5-1.495 2.555-2.768 2.5-5.204z"
    }),
    /* @__PURE__ */ jsx15("path", {
      fill: "url(#bul-air_svg__e)",
      d: "M32.894 49c9.168-3.045 13.446-10.464 8.223-12.9 9.78 2.99 2.778 9.634-8.223 12.9z"
    })
  ]
});
var BulAir_default = SvgBulAir;

// src/uds/airline-logos/generated/BulgariaAir.tsx
init_esm_shims();
import { jsx as jsx16, jsxs as jsxs9 } from "react/jsx-runtime";
var SvgBulgariaAir = (props) => /* @__PURE__ */ jsxs9("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsxs9("linearGradient", {
      id: "bulgaria-air_svg__b",
      x1: 38.514,
      x2: 3.712,
      y1: 30.427,
      y2: 15.855,
      gradientUnits: "userSpaceOnUse",
      children: [
        /* @__PURE__ */ jsx16("stop", {
          offset: 0,
          stopColor: "#e5e5e5"
        }),
        /* @__PURE__ */ jsx16("stop", {
          offset: 0.119,
          stopColor: "#eee"
        }),
        /* @__PURE__ */ jsx16("stop", {
          offset: 0.264,
          stopColor: "#fff"
        }),
        /* @__PURE__ */ jsx16("stop", {
          offset: 0.455,
          stopColor: "#fbfbfb"
        }),
        /* @__PURE__ */ jsx16("stop", {
          offset: 0.635,
          stopColor: "#f0f0f0"
        }),
        /* @__PURE__ */ jsx16("stop", {
          offset: 0.81,
          stopColor: "#ddd"
        }),
        /* @__PURE__ */ jsx16("stop", {
          offset: 0.981,
          stopColor: "#c2c2c2"
        }),
        /* @__PURE__ */ jsx16("stop", {
          offset: 1,
          stopColor: "#bfbfbf"
        })
      ]
    }),
    /* @__PURE__ */ jsxs9("linearGradient", {
      id: "bulgaria-air_svg__c",
      x1: 18.988,
      x2: 25.154,
      y1: 11.509,
      y2: 41.029,
      gradientUnits: "userSpaceOnUse",
      children: [
        /* @__PURE__ */ jsx16("stop", {
          offset: 0.093,
          stopColor: "#7fbb85"
        }),
        /* @__PURE__ */ jsx16("stop", {
          offset: 0.167,
          stopColor: "#73b874"
        }),
        /* @__PURE__ */ jsx16("stop", {
          offset: 0.338,
          stopColor: "#5aaf53"
        }),
        /* @__PURE__ */ jsx16("stop", {
          offset: 0.486,
          stopColor: "#45a73d"
        }),
        /* @__PURE__ */ jsx16("stop", {
          offset: 0.604,
          stopColor: "#38a231"
        }),
        /* @__PURE__ */ jsx16("stop", {
          offset: 0.676,
          stopColor: "#33a02c"
        }),
        /* @__PURE__ */ jsx16("stop", {
          offset: 0.885,
          stopColor: "#00742f"
        })
      ]
    }),
    /* @__PURE__ */ jsxs9("linearGradient", {
      id: "bulgaria-air_svg__a",
      children: [
        /* @__PURE__ */ jsx16("stop", {
          offset: 0.066,
          stopColor: "#e36853"
        }),
        /* @__PURE__ */ jsx16("stop", {
          offset: 0.352,
          stopColor: "red"
        }),
        /* @__PURE__ */ jsx16("stop", {
          offset: 0.533,
          stopColor: "#fd0002"
        }),
        /* @__PURE__ */ jsx16("stop", {
          offset: 0.628,
          stopColor: "#f40006"
        }),
        /* @__PURE__ */ jsx16("stop", {
          offset: 0.702,
          stopColor: "#e70009"
        }),
        /* @__PURE__ */ jsx16("stop", {
          offset: 0.766,
          stopColor: "#d3000c"
        }),
        /* @__PURE__ */ jsx16("stop", {
          offset: 0.823,
          stopColor: "#ba0010"
        }),
        /* @__PURE__ */ jsx16("stop", {
          offset: 0.85,
          stopColor: "#ab0012"
        })
      ]
    }),
    /* @__PURE__ */ jsx16("linearGradient", {
      xlinkHref: "#bulgaria-air_svg__a",
      id: "bulgaria-air_svg__d",
      x1: 24.81,
      x2: 24.862,
      y1: 20.59,
      y2: 38.545,
      gradientUnits: "userSpaceOnUse"
    }),
    /* @__PURE__ */ jsx16("linearGradient", {
      xlinkHref: "#bulgaria-air_svg__a",
      id: "bulgaria-air_svg__e",
      x1: 38.803,
      x2: 46.507,
      y1: 45.872,
      y2: 32.703,
      gradientUnits: "userSpaceOnUse"
    }),
    /* @__PURE__ */ jsx16("path", {
      fill: "url(#bulgaria-air_svg__b)",
      d: "M48.507 31.893c-1.611-4.263-5.612-7.419-11.557-10.132C22.836 15.284 2.945 10.191 1 1c1 16.498 23.726 18.879 36.95 25.08 3.223 1.55 6 3.986 7.612 5.647 2.612 2.657 1.334 9.024-1.445 11.681 5.668-4.097 5.223-9.3 4.39-11.515z"
    }),
    /* @__PURE__ */ jsx16("path", {
      fill: "url(#bulgaria-air_svg__c)",
      d: "M43.284 28.792c-9.946-6.92-35.45-11.681-38.061-16 5.167 13.177 29.504 12.513 38.394 20.65 6.724 6.146-.722 10.908-2.5 12.015 6.39-3.488 10.446-10.907 2.167-16.665z"
    }),
    /* @__PURE__ */ jsx16("path", {
      fill: "url(#bulgaria-air_svg__d)",
      d: "M46.729 37.872c-.333-10.408-30.616-12.568-37.394-18.104C17.39 32.945 44.006 32.17 45.84 39.09c.389 1.495-.5 2.934-1.611 3.986 1.5-1.495 2.555-2.768 2.5-5.204z"
    }),
    /* @__PURE__ */ jsx16("path", {
      fill: "url(#bulgaria-air_svg__e)",
      d: "M32.894 49c9.168-3.045 13.446-10.464 8.223-12.9 9.78 2.99 2.778 9.634-8.223 12.9z"
    })
  ]
});
var BulgariaAir_default = SvgBulgariaAir;

// src/uds/airline-logos/generated/Cityjet.tsx
init_esm_shims();
import { jsx as jsx17 } from "react/jsx-runtime";
var SvgCityjet = (props) => /* @__PURE__ */ jsx17("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsx17("path", {
    fill: "#781520",
    d: "M47.955 6H19.02L2 17.902h28.091l.01-.005L18.892 44l17.548-11.082L48 6h-.045Z"
  })
});
var Cityjet_default = SvgCityjet;

// src/uds/airline-logos/generated/Condor.tsx
init_esm_shims();
import { jsx as jsx18 } from "react/jsx-runtime";
var SvgCondor = (props) => /* @__PURE__ */ jsx18("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsx18("path", {
    fill: "currentColor",
    d: "M3.004 24.5C2.778 12.238 12.726 2.113 25.049 2h.452C37.824 1.889 47.886 11.789 48 24.05v.45c.113 12.262-9.723 22.274-21.932 22.499H25.5c-12.322.112-22.384-9.675-22.497-21.937V24.5zm2.148.113c-.113 11.137 8.705 20.249 19.897 20.474h.452c11.193.112 20.35-8.775 20.463-19.912v-.45c.226-11.137-8.818-20.362-20.01-20.474H25.5C14.31 4.138 5.151 13.138 5.04 24.388c.113-.113.113 0 .113.225zm2.6-6.75h10.853v1.912l-2.148.563 7.01 4.5s-3.731-3.263-2.488-5.738c.565-.9 1.583-1.35 2.714-1.237h19.784L31.607 27.2l-1.357-1.35 5.765-5.512H25.05c-.113 0-.678 0-.791.337-.792 1.688 5.653 8.1 11.984 12.375l2.713 1.8V38z"
  })
});
var Condor_default = SvgCondor;

// src/uds/airline-logos/generated/CorendonAirlines.tsx
init_esm_shims();
import { jsx as jsx19 } from "react/jsx-runtime";
var SvgCorendonAirlines = (props) => /* @__PURE__ */ jsx19("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsx19("path", {
    fill: "#cf2a2b",
    fillRule: "evenodd",
    d: "M41.46 12.275c-2.161.062-4.301-.982-4.768-3.239-.281-1.358-.161-2.819.521-4.045.745-1.344 2.49-2.25 3.97-2.447 2.572-.344 4.98 1.358 5.378 4.021.435 2.94-2.299 5.41-5.05 5.71zM9.203 24.825c.308-2.74-1.691-4.004-3.55-4.48-1.623-.396-2.971-.586-2.587-1.857l.058-.131c.594-1.258 2.058-1.92 4.017-2.447l.84-.206c1.853-.428 4.024-.59 6.127-.965a17.71 17.71 0 0 0 2.686-.669c1.948-.861 3.203-2.75 3.996-4.669.336-.785.59-1.578.775-2.308.285-1.155.511-2.164.868-2.916.36-.668.85-1.12 1.65-1.233 1.56-.172 2.181 1.533 2.689 4 .576 2.84.494 6.833 1.87 9.28.737.996 2.133 1.354 3.82 1.347 1.993-.007 4.35-.524 6.466-1.15 2.649-.786 4.954-1.5 6.415-1.369.761.07 1.303.369 1.567 1.01.063.172.094.354.09.538-.309 1.54-2.967 3.335-6.377 5.402-4.291 2.595-9.725 4.928-11.934 7.578a3.684 3.684 0 0 0-.696 1.664c-.617 2.605 1.5 6.01 3.914 8.78 2.326 2.64 4.48 4.9 4.39 6.381-.114.33-.343.606-.644.78a2.174 2.174 0 0 1-1.287.31c-1.927-.063-4.792-1.903-7.95-4.232-3.963-2.922-7.695-6.902-10.682-8.129a2.843 2.843 0 0 0-.817-.148c-2.202-.069-4.137 2.584-5.361 5.182-1.118 2.392-1.938 4.463-2.895 4.28a1.128 1.128 0 0 1-.587-.403c-.525-.606-.7-1.654-.651-3.005.068-1.32.35-2.908.727-4.648.72-3.267 2.058-6.823 2.703-9.714a16.11 16.11 0 0 0 .35-1.854z",
    clipRule: "evenodd"
  })
});
var CorendonAirlines_default = SvgCorendonAirlines;

// src/uds/airline-logos/generated/DanishAirTransport.tsx
init_esm_shims();
import { jsx as jsx20, jsxs as jsxs10 } from "react/jsx-runtime";
var SvgDanishAirTransport = (props) => /* @__PURE__ */ jsxs10("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx20("path", {
      fill: "#fff",
      d: "M48 25c0 12.426-10.074 22.5-22.5 22.5C13.073 47.5 3 37.426 3 25S13.073 2.5 25.5 2.5C37.926 2.5 48 12.574 48 25z"
    }),
    /* @__PURE__ */ jsx20("path", {
      stroke: "#fff",
      strokeWidth: 0.63,
      d: "M48 25c0 12.426-10.074 22.5-22.5 22.5C13.073 47.5 3 37.426 3 25S13.073 2.5 25.5 2.5C37.926 2.5 48 12.574 48 25z"
    }),
    /* @__PURE__ */ jsx20("path", {
      fill: "#f9a91f",
      d: "M32.019 24.334c3.023 2.381 5.57 4.694 7.414 6.703 1.708-.718 5.146-2.04 8.124-2.516.688-4.33.076-8.775-1.73-12.75z"
    }),
    /* @__PURE__ */ jsx20("path", {
      fill: "#fcd213",
      d: "M40.022 41.98a22.106 22.106 0 0 0 3.77-4.163 22.409 22.409 0 0 0 2.624-4.965l-4.474 3.673z"
    }),
    /* @__PURE__ */ jsx20("path", {
      fill: "#1f4fa2",
      d: "M35.926 36.04c-2.517-1.042-5.563-2.644-8.836-4.67l-3.31 15.886c4.346.34 8.73-.605 12.561-2.728-.566-2.948-.498-6.636-.415-8.487z"
    }),
    /* @__PURE__ */ jsx20("path", {
      fill: "#d22027",
      d: "M19.117 45.911c-.62-.763.008-15.969.174-19.907-7.61-5.774-12.516-11.948-12.176-13.597-6.907 10.075-4.428 23.869 5.608 30.881a22.246 22.246 0 0 0 7.18 3.326c-.355-.272-.635-.514-.786-.703z"
    }),
    /* @__PURE__ */ jsx20("path", {
      fill: "#009a68",
      d: "M24.316 18.832c3.628-1.504 17.717-7.3 18.646-6.976.227.076.56.264.93.498a22.234 22.234 0 0 0-5.578-5.615C28.277-.282 14.477 2.1 7.373 12.038c1.427-.877 8.917 1.61 16.943 6.794z"
    })
  ]
});
var DanishAirTransport_default = SvgDanishAirTransport;

// src/uds/airline-logos/generated/Easyjet.tsx
init_esm_shims();
import { jsx as jsx21, jsxs as jsxs11 } from "react/jsx-runtime";
var SvgEasyjet = (props) => /* @__PURE__ */ jsxs11("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx21("path", {
      fill: "#ff6801",
      d: "M3 3h44v44H3z"
    }),
    /* @__PURE__ */ jsx21("path", {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M37.998 26.104H23.911c-.638 0-.928.29-.928.828 0 1.278.697 2.498 2.09 3.66 1.394 1.17 2.908 1.756 4.544 1.756.93 0 2.034-.176 3.196-.524 1.163-.363 2.15-.826 2.904-1.35.697-.465 1.233-.696 1.64-.696.524 0 1.045.29 1.51.928.525.64.756 1.294.756 1.99 0 1.452-.873 2.787-2.673 4.125-3.15 2.395-6.81 3.557-10.949 3.557-4.18 0-7.681-1.22-10.527-3.674a14.47 14.47 0 0 1-3.384-4.297c-1.162-2.281-1.742-4.605-1.742-7.117 0-3.311.987-6.344 3.021-9.017 1.757-2.339 3.964-4.022 6.692-5.184 2.05-.887 4.257-1.294 6.581-1.294 3.789 0 6.982 1.062 9.655 3.211 1.353 1.045 2.398 2.322 3.209 3.847.93 1.684 1.396 3.316 1.396 4.895 0 1.276-.293 2.324-.814 3.193-.582.756-1.28 1.163-2.09 1.163zm-13.273-5.592h3.021c1.286 0 1.93-.58 1.93-1.742 0-1.045-.29-1.976-.943-2.614-.639-.711-1.394-1.001-2.442-1.001-1.104 0-1.973.465-2.611 1.35-.583.813-.873 1.627-.873 2.497 0 .582.117.99.407 1.279.29.117.756.231 1.51.231z",
      clipRule: "evenodd"
    })
  ]
});
var Easyjet_default = SvgEasyjet;

// src/uds/airline-logos/generated/Edelweiss.tsx
init_esm_shims();
import { jsx as jsx22, jsxs as jsxs12 } from "react/jsx-runtime";
var SvgEdelweiss = (props) => /* @__PURE__ */ jsx22("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsxs12("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx22("path", {
        fill: "#e40421",
        d: "M3 47h23.338c8.35 0 12.948-3.7 14.472-11.666L47 3H23.664c-8.352 0-12.95 3.7-14.472 11.666z"
      }),
      /* @__PURE__ */ jsx22("path", {
        fill: "#0e4194",
        d: "M39.135 20.868c-.316-.036-.663.002-1.02 0-.66-.01-1.298-.059-1.69-.095-1.578-.149-3.19-.418-4.756-.048.563-.702 1.938-2.995.566-3.661-.92-.447-2.88.634-4.138 1.803.088-1.587.072-4.744-.967-6.787-.432-.844-1.261-1.854-1.992-1.854-1.62 0-1.412 2.01-1.417 2.963-.008.915.005 1.852-.087 2.731a15.039 15.039 0 0 1-.554 2.706c-.964-.986-3.648-3.512-5.057-2.915-.662.28-.794.881-.476 1.511.226.453.616 1.04.956 1.545.41.607.707 1.154.885 1.476-1.037-.369-1.868-.197-2.805-.023-.624.12-1.191.24-1.773.356-.609.125-1.505.311-2.322.529-.577.148-1.15.278-1.47.594-.552.545-.588 1.355.03 1.829.393.301 1.154.54 1.652.623 1.998.337 3.556 1.156 5.392 1.505-.99.386-3.173 1.431-2.635 2.793.23.577.845.767 1.531.861a8.937 8.937 0 0 0 2.187-.007 9.65 9.65 0 0 0-.786 1.417c-.455 1.04-.686 2.105-1.252 3.146-.128.24-.323.635-.586 1.03-.203.298-.464.62-.632.924-.253.46-.004 1.116.453 1.3.607.249 1.271.009 1.959-.35.569-.294 1.17-.653 1.552-.907 1.496-1.003 2.713-2.277 3.838-3.665.169.951.537 2.434 1.815 2.033.188-.057.387-.236.514-.38.27-.297.523-.951.64-1.48.895 1.468 3.879 4.504 6.769 4.781.32.034 1.03-.093 1.284-.33.648-.607.459-1.407.163-1.883-.299-.483-.742-.906-1.046-1.269-1.051-1.248-2.01-2.466-2.743-3.991 1.113.471 2.698.54 3.346-.308.195-.254.3-.668.16-1.153-.23-.793-1.243-1.678-2.015-2.084 1.101-.124 3.077-.451 5.461-1.74 1.274-.692 2.227-1.618 2.14-2.55-.042-.527-.576-.922-1.074-.976z"
      }),
      /* @__PURE__ */ jsx22("path", {
        fill: "#fff",
        d: "M17.23 24.657c-.747-.203-1.481-.478-2.227-.726-.31-.105-1.146-.319-1.949-.505-.847-.204-1.665-.387-1.665-.8 0-.413.524-.552 1.293-.744a77.14 77.14 0 0 1 3.305-.73c.807-.164 1.687-.397 2.49-.3a2.35 2.35 0 0 1 1.47.707c.18.185.464.429.694.25a.42.42 0 0 0 .155-.216c.038-.13-.02-.266-.112-.483a8.864 8.864 0 0 0-.298-.656l-.285-.548c-.42-.81-.932-1.573-1.431-2.338-.283-.435-.544-.822-.498-1.002.037-.152.332-.186.607-.122.206.048.396.13.678.274.475.24.913.571 1.345.902.558.427 1.09.891 1.545 1.39.48.529.631.544.957.479.372-.072.441-.452.545-.762.075-.254.178-.58.25-.922.126-.59.224-.938.308-1.6.04-.349.086-1.035.1-1.422.017-.641.017-1.323.017-1.929.001-.935-.057-1.503.344-1.783.163-.115.415.004.487.049.995.657 1.497 2.227 1.666 3.05.284 1.392.372 2.81.316 4.228-.02.562-.09 1.068-.098 1.412-1.049-.045-1.622.445-1.908.988-.343-1.07-1.563-1.196-2.542-.678-.95.501-1.7 1.674-1.237 2.642-1.252-.1-1.872 1.252-1.768 2.344-.881-.096-1.72-.224-2.554-.45zM39.017 22.724c-.22.29-.632.55-1.02.791-.608.372-1.205.611-1.406.705a13.51 13.51 0 0 1-3.17.996c-.366.066-.944.125-1.431.191-.3.042-.607.127-.805.181-.17.049-.244.197-.272.295-.047.164.049.365.213.441.257.117.74.226 1.725.908.652.452 1.102 1.077 1.035 1.496-.03.21-.16.339-.543.44-.558.156-1.107.053-1.647-.105a7.672 7.672 0 0 1-.755-.32c-.209-.1-.393-.26-.583-.278-.294-.032-.568.22-.387.616.7 1.638 1.61 3.088 2.748 4.446.199.23.584.7.964 1.155.193.231.308.351.492.588.319.42.283.893-.12 1.019-1.25.387-3.337-.97-4.121-1.607-.73-.601-1.425-1.225-2.016-1.97a15.43 15.43 0 0 1-.7-.998c-.163-.247-.342-.885-.66-.935-.26-.045-.443.186-.484.532-.055.315-.128.939-.33 1.478-.163.428-.379.786-.65.734-.214-.044-.371-.467-.454-.837-.021-.094-.128-.565-.183-.936-.039-.299-.066-.579-.133-.763-.054-.145-.27-.257-.45-.19-.198.068-.427.437-.595.668-.77 1.056-1.795 2.245-3.192 3.273-.87.645-1.831 1.209-2.536 1.536-.42.192-.744.231-.893.098-.127-.12.023-.275.18-.513.218-.335.557-.769.702-1.03a14.55 14.55 0 0 0 1.014-2.252c.14-.39.258-.8.408-1.178.16-.41.362-.805.579-1.199.075-.128.458-.72.956-1.243.265-.283.036-.82-.439-.663-.699.235-1.958.378-2.993.25-.42-.052-.762-.083-.884-.447-.122-.363.53-.883 1.1-1.201.89-.49 1.869-.797 2.689-.992.502 1.028 1.138 1.194 1.401 1.238-.505.866-.022 1.902.752 2.483.963.723 2.515.765 3.26-.347.538.734 1.339.856 2.059.638 1.135-.344 2.08-1.577 1.556-2.885 1-.388 1.564-1.606 1.434-2.725-.09-.776-.498-1.571-1.323-1.808.294-.73.05-1.494-.457-2.018a2.31 2.31 0 0 0-.616-.445c.192-.196.774-.82 1.64-1.399.363-.244.816-.514 1.254-.684.492-.19.92-.267 1.052-.104.11.134.04.544-.101.93-.135.369-.335.704-.412.832-.32.543-.688.973-1.12 1.37a4.16 4.16 0 0 1-.346.293c-.213.158-.312.304-.195.566.041.099.231.283.473.195.582-.208 1.07-.44 1.607-.557.788-.167 1.647-.16 2.558-.099.354.022 1.526.178 2.669.233.553.027 1.03.047 1.406.034.556-.015.784.013.888.239.081.163-.118.477-.392.84z"
      }),
      /* @__PURE__ */ jsx22("path", {
        fill: "#ffde43",
        d: "M26.795 22.606c.722.31 1.357.05 1.564-.39.27-.574-.115-1.242-.754-1.502-.643-.26-1.351-.09-1.57.493-.195.526.126 1.128.76 1.399zm1.977.648c-.48-.04-1.08.586-1.155 1.44-.075.851.174 1.523.832 1.618.478.068 1.083-.54 1.191-1.39.117-.952-.293-1.625-.868-1.668zm-2.238 3.894c-.62.394-.837 1.238-.463 1.7.371.455 1.063.486 1.66.055.583-.424.797-1.131.508-1.612-.312-.52-1.041-.57-1.705-.143zm.412-2.36c0-1.07-.837-1.942-1.872-1.942-1.038 0-1.876.872-1.876 1.941 0 1.07.74 1.97 1.876 1.936.96-.024 1.872-.866 1.872-1.936zm-3.055 2.471c-.687-.316-1.565-.279-1.843.335-.278.62.194 1.274.83 1.57.766.361 1.529.17 1.793-.244.4-.635-.095-1.344-.78-1.66zm.019-4.902c.605-.443.84-1.172.613-1.48-.309-.423-1.162-.314-1.712.167-.632.555-.727 1.162-.52 1.426.327.417 1.06.299 1.619-.113zm-1.546 2.53c-.07-.797-.563-1.359-.987-1.341-.51.023-.844.717-.805 1.49.04.781.613 1.347.985 1.32.585-.05.867-.777.807-1.469z"
      })
    ]
  })
});
var Edelweiss_default = SvgEdelweiss;

// src/uds/airline-logos/generated/Egyptair.tsx
init_esm_shims();
import { jsx as jsx23 } from "react/jsx-runtime";
var SvgEgyptair = (props) => /* @__PURE__ */ jsx23("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsx23("path", {
    fill: "#00265d",
    fillRule: "evenodd",
    d: "M32.967 12.706c1.193 1.413 2.936 1.916 4.05 1.104.698-.513.956-1.443.804-2.46.662.1 1.306.301 2.074.61.38.128.832-1.458.243-1.513-6.327-.91-9.84 4.19-9.754 4.109.977-.734 1.785-1.356 2.583-1.85zm3.61.582c-.835.676-2.229.255-3.21-.824 1.321-.816 2.442-1.201 3.647-1.186.246.776.033 1.637-.437 2.01zm-31.522 2.25a24.736 24.736 0 0 1 5.453-9.48C21.41 1.463 35.466 1.497 46 9.964 39.39 6.6 19.846 3.02 5.055 15.538zM4.424 27.21a24.402 24.402 0 0 1-.198-7.835c7.715-7.831 19.26-12.985 31.38-10.454-6.634.015-22.536 4.554-31.182 18.289zm4.126 9.644a24.383 24.383 0 0 1-3.1-5.876c4.59-9.705 13.44-18.158 25.334-19.998-5.92 2.228-18.257 11.297-22.234 25.874zm7.486 6.91a24.6 24.6 0 0 1-4.96-3.887c1.584-10.26 7.86-20.984 17.896-26.55-.738 1.085-1.078 2.356-1.017 3.708-5.85 5.924-11.661 15.123-11.919 26.729zM25.32 47a25.618 25.618 0 0 1-5.705-1.461c.067-9.287 3.082-20.314 8.555-27.075.304 1.185.88 2.401 1.813 3.62 4.332-5.09 9.329-8.69 15.534-10.281C37.057 15.01 23.887 25.243 25.32 47z",
    clipRule: "evenodd"
  })
});
var Egyptair_default = SvgEgyptair;

// src/uds/airline-logos/generated/Eurowings.tsx
init_esm_shims();
import { jsx as jsx24, jsxs as jsxs13 } from "react/jsx-runtime";
var SvgEurowings = (props) => /* @__PURE__ */ jsxs13("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx24("path", {
      fill: "#7bcbe2",
      d: "M18.444 11.084c-4.007-.548-6.042 1.682-8.848 3.733L.003 22.35 0 22.35l1.847.977c.003.003.008.004.012.007 2.403 1.181 5.744.778 8.02-.908l4.05-3.218 1.549-1.233 7.72-6.133z"
    }),
    /* @__PURE__ */ jsx24("path", {
      fill: "#089bc9",
      d: "m.003 22.35 1.844.98c.004 0 .008.004.012.005 2.403 1.183 5.746.78 8.02-.908l4.05-3.217 1.55-1.232z"
    }),
    /* @__PURE__ */ jsx24("path", {
      fill: "#8f174f",
      d: "m34.825 15.737-5.15-.927s-3.585-.852-6.58 1.469c0 0-2.212 1.645-3.843 2.917l-3.627 2.873-8.39 6.674-.07.055 2.533 1.34c2.404 1.187 5.753.785 8.032-.903l7.502-5.943 6.05-4.765z"
    }),
    /* @__PURE__ */ jsx24("g", {
      fill: "#c8c4c3",
      children: /* @__PURE__ */ jsx24("path", {
        d: "M19.254 19.196c1.628-1.272 3.84-2.917 3.84-2.917a7.45 7.45 0 0 1 1.734-1.003l-9.347 2.702-1.55 1.23-4.048 3.22c-2.275 1.687-5.618 2.09-8.02.907 2.048 1.228 5.23 1.51 10.022.081l3.273-.974.47-.373zM32.44 22.058c1.544-1.209 2.709-2.084 3.868-2.604l-10.463 3.355-.615.484-7.502 5.942c-2.278 1.688-5.627 2.092-8.031.903 3.693 2.028 9.381.537 14.165-1.164l.285-.231s8.007-6.478 8.292-6.685zM44.743 28.798c-4.2-1.22-5.46-.448-10.407 1.04h-.002l-.413.343v-.001l-.004.004.004-.003-.012.008-7.974 6.323c-2.272 1.684-5.823 2.008-8.225.831 2.964 1.546 6.029 1.168 11.273-.468L50 30.423z"
      })
    }),
    /* @__PURE__ */ jsx24("path", {
      fill: "#8f174f",
      d: "m46.137 20.08-5.56-1.012c-3.33-.618-4.905.459-8.14 2.99-.285.208-8.292 6.684-8.292 6.684l-8.989 7.253 2.532 1.34c2.405 1.188 5.972.865 8.248-.823l7.974-6.323.011-.008-.004.003z"
    }),
    /* @__PURE__ */ jsx24("path", {
      fill: "#b4175e",
      d: "m15.156 22.442 17.778-5.218-7.09 5.585-18.68 5.99zM23.86 28.972l19.36-6.48-8.884 7.346-19.178 6.157z"
    })
  ]
});
var Eurowings_default = SvgEurowings;

// src/uds/airline-logos/generated/Flyegypt.tsx
init_esm_shims();
import { jsx as jsx25, jsxs as jsxs14 } from "react/jsx-runtime";
var SvgFlyegypt = (props) => /* @__PURE__ */ jsxs14("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx25("path", {
      fill: "#216092",
      d: "M16.521 13.042c-.07.004-.139.013-.208.013-1.616 0-3.232-.011-4.848.004-1.339.013-2.343.609-2.995 1.764-.23.41-.32.858-.322 1.324-.002.497.006.994-.005 1.49-.004.158.04.203.2.198 1.1-.034 2.177.1 3.223.447 1.506.502 2.792 1.338 3.886 2.47.088.09.078.143-.004.226-1.685 1.72-3.712 2.736-6.154 2.895-.312.02-.626.027-.938.019-.167-.005-.214.037-.213.206.007 1.484.004 2.968.004 4.452 0 1.722-.002 3.445.003 5.168 0 .162-.02.207-.192.137-3.19-1.294-5.112-3.607-5.772-6.939-.07-.358-.112-.72-.147-1.083-.004-.04.014-.09-.039-.116V15.302c.056-.023.038-.074.042-.114.04-.343.091-.685.17-1.022.839-3.61 3.812-6.384 7.518-7.023.298-.051.604-.054.895-.143h8.97c-.287.335-.628.62-.919.953A9.807 9.807 0 0 0 17.37 9.84a7.378 7.378 0 0 0-.848 3.202z"
    }),
    /* @__PURE__ */ jsx25("path", {
      fill: "#eb7204",
      d: "M35.385 25.228c.136.473.313.926.62 1.323 1.515 1.96 4.152 1.49 5.203.174.427-.535.624-1.148.632-1.821.01-.94.113-1.867.398-2.77.487-1.542 1.4-2.808 2.59-3.897.087-.08.133-.051.203.015 1.232 1.157 2.101 2.533 2.586 4.142.17.562.276 1.136.34 1.718.005.046-.018.104.043.133v10.906c-.083.032-.048.107-.054.162a8.937 8.937 0 0 1-1.136 3.494c-1.084 1.887-2.647 3.25-4.682 4.083-.054.022-.143.016-.146.11h-.192c.075-.042.042-.113.042-.17.002-3.08.002-6.16.002-9.24 0-.217-.011-.225-.231-.153-1.934.628-3.875.655-5.819.06a9.024 9.024 0 0 1-3.472-1.966h.002c.009-.083.078-.125.13-.179.27-.282.562-.547.81-.848a9.561 9.561 0 0 0 1.314-2.051c.366-.787.595-1.6.713-2.453.036-.257-.023-.528.104-.772z"
    }),
    /* @__PURE__ */ jsx25("path", {
      fill: "#0d2060",
      d: "M16.521 13.042c.04-1.13.322-2.199.849-3.202a9.812 9.812 0 0 1 1.306-1.887c.29-.334.632-.618.919-.953h.038c.966.884 1.783 1.879 2.352 3.058a6.93 6.93 0 0 1 .712 2.79c.002.068-.005.137-.007.205-.032-.003-.064-.009-.096-.009l-5.896.001c-.05 0-.1.012-.15.018a.04.04 0 0 1-.026-.021z"
    }),
    /* @__PURE__ */ jsx25("path", {
      fill: "#c20e2f",
      d: "M16.548 13.063c.05-.006.1-.018.15-.018h5.897c.031 0 .063.005.095.008.002.195.007.39.007.585 0 3.666.024 7.332-.011 10.997-.016 1.627 1.12 2.827 2.505 3.145 1.464.336 2.962-.38 3.658-1.743.162-.318.257-.655.33-1 .056.05.037.117.036.177-.007.572.086 1.132.22 1.685a8.364 8.364 0 0 0 1.346 2.94c.403.561.845 1.093 1.374 1.547.043.037.088.075.092.138-1.256 1.126-2.72 1.85-4.378 2.205-4.509.963-9.205-1.583-10.779-5.847a8.37 8.37 0 0 1-.542-2.897c-.007-3.942-.004-7.885-.004-11.827 0-.032.002-.063.004-.095z"
    }),
    /* @__PURE__ */ jsx25("path", {
      fill: "#d5441d",
      d: "M32.247 31.524c-.004-.063-.049-.101-.092-.138-.53-.454-.97-.986-1.374-1.548a8.366 8.366 0 0 1-1.346-2.94c-.134-.552-.227-1.112-.22-1.684 0-.06.02-.127-.037-.177.002-1.676.34-3.266 1.241-4.713.48-.772 1.07-1.453 1.736-2.073.071-.066.121-.103.218-.015 1.339 1.23 2.296 2.682 2.717 4.454.166.7.246 1.409.265 2.126.003.137.02.275.03.412-.127.244-.068.515-.104.772a8.545 8.545 0 0 1-.713 2.453 9.565 9.565 0 0 1-1.314 2.051c-.248.3-.54.566-.81.848-.052.054-.121.096-.13.18v.002l-.067-.01z"
    }),
    /* @__PURE__ */ jsx25("path", {
      fill: "#c20e2f",
      d: "m32.315 31.534-.001-.002h-.002l.003.002z"
    })
  ]
});
var Flyegypt_default = SvgFlyegypt;

// src/uds/airline-logos/generated/FreebirdAirlines.tsx
init_esm_shims();
import { jsx as jsx26, jsxs as jsxs15 } from "react/jsx-runtime";
var SvgFreebirdAirlines = (props) => /* @__PURE__ */ jsx26("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsxs15("g", {
    fill: "#0055a4",
    children: [
      /* @__PURE__ */ jsx26("path", {
        d: "M2 33.175c2.367 2.781 4.894 9.844 13.191 11.378 3.676.682 7.456-.537 10.458-1.692 3.47-1.338 6.158-3.686 8.326-5.744 7.896-7.48 9.355-13.89 14.025-10.938-1.014-1.578-2.146-3.796-3.44-5.091-2.394-2.025-5.178-1.305-8.617 2.196-6.063 6.106-12.325 12.672-17.74 15.624C12.919 41.775 6.676 37.966 2 33.176z"
      }),
      /* @__PURE__ */ jsx26("path", {
        d: "M11.91 5.25c-1.318 1.951-5.972 4.877-4.58 10.1.611 2.255 1.818 3.812 3.293 5.097 1.802 1.595 3.968 2.717 5.674 3.656 6.193 3.417 9.78 4.399 8.839 7.765.79-.9 1.8-2.198 2.588-3.1 1.566-1.554 1.157-4.897-1.693-6.342-4.975-2.557-10.283-5.157-13.171-7.9-2.824-2.694-2.987-5.645-.95-9.276z"
      })
    ]
  })
});
var FreebirdAirlines_default = SvgFreebirdAirlines;

// src/uds/airline-logos/generated/JetTime.tsx
init_esm_shims();
import { jsx as jsx27, jsxs as jsxs16 } from "react/jsx-runtime";
var SvgJetTime = (props) => /* @__PURE__ */ jsxs16("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx27("path", {
      fill: "#034ea1",
      d: "m46.5 9.181-1.286 5.556h-5.905l-3.098 15.03a9.012 9.012 0 0 0-.175.847 4.125 4.125 0 0 0-.059.555c0 .547.088.966.263 1.258.176.292.4.517.673.673.272.156.575.243.906.262.321.02.643.03.965.03a25 25 0 0 0 2.981-.176l-1.403 6.375c-.858.077-1.715.146-2.573.204-.857.059-1.734.088-2.63.088-.975 0-1.94-.088-2.894-.263a7.786 7.786 0 0 1-2.573-.936 4.964 4.964 0 0 1-1.811-1.842c-.45-.78-.653-1.793-.615-3.04 0-.39.04-.829.117-1.317a30.39 30.39 0 0 1 .293-1.55l3.39-16.198H25.63l1.286-5.556h5.32L34.106 0h8.302l-1.87 9.181z"
    }),
    /* @__PURE__ */ jsx27("path", {
      fill: "#ffa000",
      d: "M18.875 0 11.04 37.778c-.117.39-.233.887-.35 1.491a9.84 9.84 0 0 1-.527 1.784 5.3 5.3 0 0 1-.876 1.49c-.352.41-.82.615-1.404.615a37.665 37.665 0 0 1-2.981-.117L3.5 49.708c.674.04 1.346.098 2.017.175.682.078 1.355.117 2.016.117 1.872 0 3.43-.195 4.678-.585 1.246-.39 2.299-.975 3.156-1.754.858-.78 1.54-1.775 2.047-2.983.506-1.209.935-2.612 1.286-4.21L27.177 0z"
    })
  ]
});
var JetTime_default = SvgJetTime;

// src/uds/airline-logos/generated/Jet2.tsx
init_esm_shims();
import { jsx as jsx28 } from "react/jsx-runtime";
var SvgJet2 = (props) => /* @__PURE__ */ jsx28("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsx28("path", {
    fill: "#ee3123",
    d: "m36.917 14.4 3.122 7.423-1.434-.042-5.358-7.38s-1.434-.042-1.982-.042c-.254 0-.549 0-.929-.084a275.312 275.312 0 0 1-1.982 11.07c-1.646 8.26-1.519 14.13-8.69 14.13-2.279 0-4.43-1.048-4.43-2.725 0-3.02.464-8.26.464-8.26l-12.15-.042S3 33.479 3 38.846C3 43.71 8.358 50.042 18.904 50c8.058-.042 13.415-1.887 18.056-8.47 2.32-3.27 3.459-11.07 5.273-19.582.506-2.474 1.055-4.99 1.56-7.337l-.463-.546zM40.587.02c-2.362.042-5.188.503-6.749 2.39-1.603 1.887-2.447 5.535-2.869 7.799-.084.587-.21 1.3-.337 2.138.253-.042.464-.042.633-.042.548 0 1.982-.042 1.982-.042l5.358-7.38 1.434-.041-3.122 7.38 6.455.377 1.181-1.384L47 .02s-4.05-.042-6.412 0z"
  })
});
var Jet2_default = SvgJet2;

// src/uds/airline-logos/generated/Lufthansa.tsx
init_esm_shims();
import { jsx as jsx29 } from "react/jsx-runtime";
var SvgLufthansa = (props) => /* @__PURE__ */ jsx29("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsx29("path", {
    fill: "#0a1d3d",
    d: "M33.918 20.427c-.175 0-.322.004-.405.013-.096.175-.239.41-.45.736 3.293 0 6.282.272 9.59.865l-.934.901c-2.985-.529-5.464-.74-8.624-.74-.46 0-.557 0-.667.004-.11.166-.359.488-.607.787.28-.018.823-.028 1.573-.028 2.599 0 5.027.193 7.663.617l-.934.906c-2.006-.313-4.457-.492-6.656-.492-.781 0-1.67.027-2.465.073-.18.207-.648.713-.79.87 1.052-.11 2.211-.162 3.591-.162 1.964 0 3.84.13 5.616.391l-.934.897a35.83 35.83 0 0 0-4.157-.248c-3.5 0-6.26.759-9.112 2.502 2.718 2.916 7.17 4.76 11.485 4.76h.405l-1.509 1.459c-6.223-1.169-12.773-3.906-18.305-7.654-5.322-3.592-7.185-4.655-11.338-6.49l-.028-1.067 2.81 1.205.957-.759 9.176 4.204-.598.478-4.71-2.046-.464.363 2.447 1.366c2.065 1.15 3.638 1.665 5.091 1.665 3.178 0 6.03-2.254 7.87-6.214 1.384-.179 2.86-.262 4.636-.262 3.643 0 7.18.35 11.186 1.1l-.975.942c-2.493-.52-6.73-.943-9.434-.943zM25 46.62C13.063 46.62 3.38 36.937 3.38 25S13.063 3.38 25 3.38 46.62 13.063 46.62 25 36.937 46.62 25 46.62zM25 2C12.281 2 2 12.281 2 25s10.281 23 23 23 23-10.281 23-23S37.719 2 25 2z"
  })
});
var Lufthansa_default = SvgLufthansa;

// src/uds/airline-logos/generated/Luxair.tsx
init_esm_shims();
import { jsx as jsx30, jsxs as jsxs17 } from "react/jsx-runtime";
var SvgLuxair = (props) => /* @__PURE__ */ jsx30("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsxs17("g", {
    fill: "#00abbf",
    children: [
      /* @__PURE__ */ jsx30("path", {
        d: "M29.267 7.035 8.11 32.482c-.218.24-.3.528-.202.751.098.24.316.387.62.387l32.695.005c.294 0 .5-.25.5-.528 0-.289-.135-.457-.424-.523-1.176-.277-7.595-1.666-12.206-3.06-2.859-.865-3.975-3.32-3.23-6.598.823-3.631 4.308-15.304 4.318-15.337.082-.24.028-.544-.223-.664-.277-.153-.517-.082-.691.12z"
      }),
      /* @__PURE__ */ jsx30("path", {
        d: "M25.04 2C37.7 2 48 12.306 48 25.063c0 12.642-10.3 22.959-22.96 22.959C12.3 48.022 2 37.705 2 25.062 2 12.313 12.3 2 25.04 2zm0 2.815c-11.171 0-20.23 9.06-20.23 20.253 0 11.161 9.059 20.22 20.23 20.22 11.173 0 20.238-9.059 20.238-20.22A20.187 20.187 0 0 0 25.04 4.815z"
      })
    ]
  })
});
var Luxair_default = SvgLuxair;

// src/uds/airline-logos/generated/NesmaAirlines.tsx
init_esm_shims();
import { jsx as jsx31 } from "react/jsx-runtime";
var SvgNesmaAirlines = (props) => /* @__PURE__ */ jsx31("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsx31("g", {
    fill: "#646263",
    children: /* @__PURE__ */ jsx31("path", {
      d: "M23.11 31.494c0 1.256-.594 1.888-1.791 1.888-.545 0-1.166-.268-1.86-.797L4.267 20.605v11.604c0 .54-.233.869-.705 1.006-.247.054-.717.085-1.414.085C1.38 33.3 1 32.942 1 32.222v-13.83c0-1.2.56-1.798 1.672-1.798.705 0 1.427.287 2.165.865L19.84 29.303V17.789c0-.527.232-.857.707-.986.24-.059.71-.088 1.405-.088.77 0 1.158.353 1.158 1.063zM41.192 26.534l-4.881-7.202-4.915 7.202zM49 32.637c0 .44-.152.811-.452 1.11-.294.3-.665.448-1.114.448-.617 0-1.116-.285-1.507-.867l-2.854-4.133H29.52l-2.862 4.133c-.309.45-.637.684-.995.684-.356 0-.7-.121-1.027-.35-.372-.248-.552-.548-.552-.885 0-.106.028-.202.082-.288l10.167-15.537c.42-.637 1.138-.952 2.15-.952.753 0 1.254.21 1.507.637.021.027.04.065.067.12.016.057.057.121.113.195l10.777 15.246c.033.075.054.212.054.439z"
    })
  })
});
var NesmaAirlines_default = SvgNesmaAirlines;

// src/uds/airline-logos/generated/Norwegian.tsx
init_esm_shims();
import { jsx as jsx32 } from "react/jsx-runtime";
var SvgNorwegian = (props) => /* @__PURE__ */ jsx32("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsx32("path", {
    fill: "currentColor",
    d: "m41.965 19.172-6.138 5.397-.065.058 7.646 13.65a1.322 1.322 0 0 1-.193 1.54L42.096 41l-12.553-8.43 2.265-3.634-.534-.358-5.544 4.874c-6.07 5.32-12.883 8.389-17.783 8.018-1.979-.153-3.511-.849-4.549-2.08-2.893-3.388-1.203-10.112 4.2-16.745l.635.424c-2.86 4.013-3.614 7.857-1.91 9.814.67.791 1.624 1.24 2.835 1.335 3.001.231 7.236-1.759 11.33-5.327l1.528-1.372L3.178 14.866l1.18-1.038a3.123 3.123 0 0 1 3.052-.614l26.425 8.936.726-.634-.118-.078c-1.972-1.323-3.808-3.741-3.21-5.937l4.505-3.96a12.044 12.044 0 0 1 4.648-2.546 11.952 11.952 0 0 1 4.321-.457c1.384.115 2.54.515 2.948 1.013.238.293.7 1.17-.13 3.024-.842 1.88-2.712 4.1-5.555 6.6z"
  })
});
var Norwegian_default = SvgNorwegian;

// src/uds/airline-logos/generated/Pegasus.tsx
init_esm_shims();
import { jsx as jsx33 } from "react/jsx-runtime";
var SvgPegasus = (props) => /* @__PURE__ */ jsx33("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsx33("path", {
    fill: "#e31f26",
    fillRule: "evenodd",
    d: "m3 42.5 13.708-31.635a.75.75 0 0 0 .047-.209c.009-.453-.342-.687-.563-.783-.515-.199-.845-.621-.845-1.125 0-.689.678-1.248 1.514-1.248h14.914l8.538.026c2.599 0 4.896 1.519 5.853 3.748.548 1.356.834 2.822.834 4.376 0 2.443-.758 4.712-2.042 6.591-2.751 4.048-7.26 6.473-12.13 6.473H22.522l-4.56 10.634c-.022.06-.06.137-.06.21 0 .253.182.473.399.57.519.195.845.62.845 1.12 0 .693-.676 1.252-1.512 1.252zm21.373-17.92 5.782-13.334s.922-.024 1.232.024c.634.1 1.118.247 1.619.537 2.315 1.351 2.492 5.187.395 8.57-1.59 2.569-3.9 4.17-6.772 4.19z",
    clipRule: "evenodd"
  })
});
var Pegasus_default = SvgPegasus;

// src/uds/airline-logos/generated/RoyalAirMaroc.tsx
init_esm_shims();
import { jsx as jsx34, jsxs as jsxs18 } from "react/jsx-runtime";
var SvgRoyalAirMaroc = (props) => /* @__PURE__ */ jsxs18("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx34("clipPath", {
      id: "royal-air-maroc_svg__a",
      children: /* @__PURE__ */ jsx34("path", {
        d: "M0 0h50v50H0z"
      })
    }),
    /* @__PURE__ */ jsx34("g", {
      clipPath: "url(#royal-air-maroc_svg__a)",
      children: /* @__PURE__ */ jsx34("path", {
        fill: "#c20831",
        d: "M19.847 37.247v.005l7.184-5.221-.293-.904-5.175 3.76.873-2.684-.769-.557-1.525 4.69a7.851 7.851 0 0 1-2.826-7.854l-.792-.574c-.931 3.5.39 7.213 3.323 9.34zm4.77-5.136-5.18-3.76h2.822l.293-.904h-4.935a7.884 7.884 0 0 1 6.598-5.116l.305-.929a8.782 8.782 0 0 0-7.858 6.045l7.184 5.221zm-4.797-11.63h.051c-.034-.395-.172-.63-.42-.722-.894-.337-1.374-1.074-1.374-1.898 0-.938.6-1.522 1.355-1.522 1.07 0 1.457 1.248 2.679 1.248.438 0 .8-.26.8-.48v-.13h-.23c-1.535 0-1.77-1.545-3.249-1.545-1.26 0-2.261.999-2.261 2.429 0 1.442 1.115 2.618 2.65 2.618M5.661 30.55h5.505v-.046a3.642 3.642 0 0 1-1.452-.858H5.662c-2.063 0-2.67-.19-3.691-1.294h13.986c.06-.306.138-.609.227-.902H0l.625.742c1.641 1.943 2.255 2.358 5.04 2.358M22.59 16.47c.783 0 1.267-.652 1.267-1.254 0-.615-.28-.862-.574-.862a.464.464 0 0 0-.463.46c0 .274.247.458.431.458-.237.361-.596.485-1.059.451a.459.459 0 0 0-.376-.725c-.225 0-.455.218-.455.49.002.514.485.982 1.229.982zm-4.514 19.774h-6.631c-1.823 0-2.512-.153-3.355-.955H6.843c1.338 1.515 2.082 1.859 4.605 1.859h7.546a9.494 9.494 0 0 1-.917-.904zm-3.051-1.297v-.046a3.62 3.62 0 0 1-1.455-.858h-4.05c-1.825 0-2.511-.15-3.355-.95H4.918c1.338 1.51 2.08 1.854 4.605 1.854zm-1.927-2.199v-.05a3.67 3.67 0 0 1-1.452-.851H7.592c-1.823 0-2.512-.153-3.355-.955H2.989c1.338 1.515 2.082 1.856 4.605 1.856zm13.748-14.977c-.45 0-.907.55-1.074 1.353.276.02.555.05.827.092.18-.7.492-1.025.751-1.069-.092-.213-.269-.376-.504-.376zm-1.85 3.617-2.743 8.45.768.557 1.973-6.082.875 2.681h.95l-1.522-4.693a7.872 7.872 0 0 1 6.903 4.693h.975a8.782 8.782 0 0 0-8.174-5.606m4.894.455v-.923A10.212 10.212 0 0 0 25 19.582a10.228 10.228 0 0 0-4.901 1.335v.926c1.44-.848 3.112-1.36 4.901-1.36s3.459.512 4.896 1.36zM20.54 20.08c.233-.107.468-.209.708-.3-.117-.35-.337-.75-.75-.75-.208 0-.37.167-.438.359.192.073.347.238.48.69zm.494 16.868-.79.574a8.728 8.728 0 0 0 9.904-.269h.005l-2.744-8.45h-.952l1.975 6.082-2.28-1.656-.769.56 3.99 2.9a7.822 7.822 0 0 1-8.339.259zM23.4 19.213c.274-.043.55-.07.83-.09-.17-.8-.626-1.352-1.075-1.352-.237 0-.412.163-.506.376.262.046.574.368.751 1.066zm-1.636-.838a.537.537 0 0 0-.485.356c.194.027.458.187.65.815.252-.076.509-.143.768-.2-.184-.622-.518-.974-.933-.974m21.39 16.917h-1.247c-.841.8-1.53.955-3.353.955h-6.631a9.16 9.16 0 0 1-.914.901h7.545c2.521 0 3.26-.341 4.6-1.856zm-18.697-7.842-.296.905h6.397l-2.28 1.657.292.902 3.997-2.901a7.84 7.84 0 0 1-2.336 8.01l.303.93a8.753 8.753 0 0 0 2.804-9.507zm23.57.905c-1.023 1.1-1.629 1.294-3.692 1.294h-4.052c-.46.42-.9.688-1.455.858v.05h5.507c2.783 0 3.399-.419 5.037-2.36L50 27.45H33.816c.09.296.164.599.225.904h13.986zM24.108 14.749l.892-.65.894.65-.339-1.05.892-.65h-1.105L25 12l-.34 1.05h-1.107l.897.65zM45.079 33.09h-1.248c-.84.8-1.527.953-3.352.953h-4.055c-.458.42-.9.688-1.452.858v.05h5.507c2.523-.002 3.265-.35 4.6-1.86zm1.93-2.198H45.76c-.844.8-1.53.955-3.355.955h-4.053c-.458.414-.9.686-1.454.853v.05h5.507c2.523 0 3.265-.343 4.603-1.858zM29.939 19.39c-.067-.191-.23-.356-.435-.356-.413 0-.636.398-.75.75.24.091.476.19.706.3.128-.458.288-.626.48-.694zm-5.509-1.699c.25.289.398.507.555.866l.013.017.012-.017a3.17 3.17 0 0 1 .557-.866 3.22 3.22 0 0 0-.567-.887c-.19.182-.475.638-.57.887zm2.662-.712v.13c0 .221.359.476.8.476 1.221 0 1.61-1.244 2.678-1.244.754 0 1.357.584 1.357 1.525 0 .824-.484 1.558-1.374 1.895-.25.092-.388.325-.424.723h.056c1.534 0 2.649-1.176 2.649-2.618 0-1.43-.999-2.429-2.261-2.429-1.48 0-1.714 1.544-3.248 1.544zm-.95-1.767c0 .598.484 1.253 1.267 1.253.745 0 1.227-.468 1.227-.984 0-.274-.228-.49-.458-.49a.458.458 0 0 0-.374.725c-.462.034-.819-.09-1.056-.451a.466.466 0 0 0 .431-.458c0-.25-.208-.46-.465-.46-.291.004-.572.254-.572.865zm-1.144-.35a.725.725 0 1 0 0 1.451.725.725 0 0 0 0-1.45zm3.723 3.872a.533.533 0 0 0-.485-.357c-.415 0-.75.35-.933.975.26.055.516.123.768.198.192-.63.453-.79.65-.816z"
      })
    })
  ]
});
var RoyalAirMaroc_default = SvgRoyalAirMaroc;

// src/uds/airline-logos/generated/Ryanair.tsx
init_esm_shims();
import { jsx as jsx35, jsxs as jsxs19 } from "react/jsx-runtime";
var SvgRyanair = (props) => /* @__PURE__ */ jsx35("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsxs19("g", {
    fill: "#073590",
    children: [
      /* @__PURE__ */ jsx35("path", {
        d: "M32.907 4.254c3 .816 6 1.721 9.001 2.174h2.182c1.273 0 2.182-.453 3.455-.815H48c0 .453 0 .453-.455.815-1.727 1.268-3.455 2.174-5.182 2.536-.455 0-1.273.453-1.728.453-2.182.815-4.728.815-6.91.815-4.273-.453-8.183-1.72-12.456-1.72-3.819-.363-7.637 1.358-9.82 4.347-.454 1.72-1.272 3.441-1.272 5.162s2.545 2.174 3.455 3.442l1.273 2.536c.454 1.72 1.272 3.442 2.545 5.162.819.815 1.728 2.174 3 2.536 1.728 1.268 3.001 2.536 3.91 4.257.819 1.72 1.728 2.989 2.183 4.71.454.815.818 1.72.818 2.989v.452c.454.816.454 1.721.818 2.174v.453c0 .453.455 1.268 0 1.268-.818-.815-1.273-1.72-1.727-2.536-.455-1.72-1.728-3.442-3-5.163-.819-.815-1.728-2.173-2.547-2.988-3.455-3.895-8.637-6.43-12.456-9.873 0 0 0-.452-.454-.815-.455-.815-.819-1.268-1.273-2.173-.819-1.721-2.182-3.442-3-5.525 0-.815-.455-1.721-.455-2.536v-.453c0-.815-2.182-1.268-.819-2.989.819-.815 3.455-1.72 4.274-3.442v-.905s0-.453-.455-.453c-.454 0-1.727.815-1.727-.453V6.428c.454-.815.454-1.72.454-2.536 0-.453.455-.453.819-.453s1.272-.453 1.727-.453c1.273 0 3 0 3.91.816.454.815 0 1.72 0 2.536 0 .815-.91 1.358-.455 1.81h.818c1.728-1.267 3.455-2.988 5.183-4.709 1.273-1.268 3.455-1.72 5.182-1.268 3.91 0 6.91 1.268 10.73 2.083z"
      }),
      /* @__PURE__ */ jsx35("path", {
        d: "M23.088 11.138c.454.815 0 1.268-.455 2.173-2.182 2.99-3 6.884-4.273 10.326h-.455c-.455 0-.455-.453-.455-.816 0-3.894 1.273-7.245 3-10.687.455-.453.82-1.268 1.728-.815.455-.634.455-.181.91-.181zm6 .906c.455 1.267-.454 2.173-.818 3.441-2.182 4.257-4.728 8.604-6 13.314 0 0 0 .453-.455.453h-.455c-.455-1.721 0-3.895.455-5.525 1.273-3.895 2.546-7.698 4.728-11.593.454 0 .454-.453.454-.453.818-.09 1.637-.09 2.091.363zm6.001.362c.455.453.455 1.268 0 1.72-2.546 5.525-6.455 10.326-8.183 16.303l-1.273 3.895c0 .453-.454.453-.454 0-.455-.453 0-1.268 0-1.721.454-4.71 1.727-9.42 3.91-13.314.818-2.174 2.182-3.894 3-5.978.454-.452.818-1.267 1.727-1.267.455 0 .819 0 1.273.362zm6.91.453c.455.815 0 1.268 0 2.173-1.727 4.257-4.728 8.152-6.91 12.409-2.182 3.441-3.455 7.245-4.728 10.687-.454 1.268-.818 2.174-1.273 3.442h-.454c-.455-.453-.455-.816-.455-1.269.455-4.71 2.182-8.604 3.91-12.86 2.182-4.71 4.728-8.967 6.91-13.677.454-.453.818-1.268 1.727-1.72.364 0 .819 0 1.273.815z"
      })
    ]
  })
});
var Ryanair_default = SvgRyanair;

// src/uds/airline-logos/generated/Sas.tsx
init_esm_shims();
import { jsx as jsx36, jsxs as jsxs20 } from "react/jsx-runtime";
var SvgSas = (props) => /* @__PURE__ */ jsx36("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsxs20("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx36("path", {
        fill: "#0858a5",
        d: "M2.063 46.603c0 .762.572 1.397 1.333 1.397h43.208c.761 0 1.396-.634 1.396-1.397V3.335C48 2.572 47.365 2 46.604 2H3.396A1.41 1.41 0 0 0 2 3.398z"
      }),
      /* @__PURE__ */ jsx36("path", {
        fill: "#fefefe",
        d: "M24.334 32.497h-3.047v-.063l3.997-5.146h.127l-1.015 5.21zm6.535-9.085h-3.87c-.191 0-.253.063-.253.063L16.022 36.818c-.064.064-.064.127.063.127h1.587c.126 0 .126 0 .19-.063l2.284-2.923s0-.064.063-.064h3.807s.063 0 .063.064c0 .063-.57 2.86-.57 2.86 0 .063 0 .126.19.126h4.568c.127 0 .127 0 .127-.063l2.601-13.344s.064-.126-.126-.126zM5.68 35.294c-.063.126 0 .253.317.508.508.444 2.157 1.398 4.695 1.398 4.568 0 6.282-2.987 5.711-5.465-.19-.698-1.08-4.192-1.143-4.638-.38-1.461.318-2.478 1.65-2.478 1.206 0 1.904.444 2.539.826.126.063.19.126.253 0 0-.064.19-1.207.19-1.207s.063-.19-.19-.317c-.443-.255-1.46-.827-3.68-.827-4.123 0-5.9 2.67-5.139 5.528.19.89 1.142 4.32 1.142 5.019 0 .255.127 1.97-1.968 1.97-1.966 0-3.362-1.334-3.806-1.779-.064-.063-.19 0-.19.127-.063.126-.38 1.335-.38 1.335zm24.364.063c-.063.127 0 .253.317.508.571.444 2.03 1.335 4.569 1.335 4.631 0 6.281-2.987 5.71-5.465-.19-.7-1.016-4.193-1.142-4.638-.38-1.461.316-2.478 1.649-2.478 1.206 0 1.903.445 2.538.826.127.063.19.127.253 0 0-.127.191-1.207.191-1.207s.063-.19-.19-.317c-.445-.255-1.46-.827-3.68-.827-4.124 0-5.9 2.668-5.14 5.528.19.89 1.143 4.32 1.143 5.019 0 .255.126 1.97-1.967 1.97-1.967 0-3.3-1.271-3.744-1.716-.126-.126-.253-.063-.253.064s-.254 1.398-.254 1.398z"
      })
    ]
  })
});
var Sas_default = SvgSas;

// src/uds/airline-logos/generated/SkyExpress.tsx
init_esm_shims();
import { jsx as jsx37 } from "react/jsx-runtime";
var SvgSkyExpress = (props) => /* @__PURE__ */ jsx37("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsx37("g", {
    fill: "#2b4077",
    children: /* @__PURE__ */ jsx37("path", {
      d: "M14.674 23.172v-.051c0-3.194-2.118-4.535-5.881-5.502-3.208-.813-4-1.201-4-2.41v-.051c0-.894.822-1.598 2.385-1.598s3.178.682 4.822 1.81l2.119-3.04C12.237 10.835 9.933 10 7.229 10 3.445 10 .742 12.198.742 15.524v.051c0 3.641 2.407 4.66 6.14 5.604 3.097.784 3.734 1.312 3.734 2.33v.051c0 1.077-1.008 1.73-2.674 1.73-2.119 0-3.867-.865-5.534-2.228L0 25.92c2.222 1.964 5.06 2.93 7.867 2.93 4 .008 6.807-2.036 6.807-5.677zM20.97 22.989l2.149-2.198 5.748 7.802h4.896l-7.889-10.556 6.496-6.689 6.423 10.015v7.23h4.081V21.29L50 10.256h-4.637l-4.504 7.363-4.422-7.363h-7.941l-7.526 8.015v-8.015h-4.074v18.337h4.074zM4.178 30.696c-1.904 0-3.341 1.612-3.341 3.626v.03c0 2.168 1.6 3.626 3.444 3.626 1.349 0 2.193-.542 2.911-1.311l-.466-.41c-.578.615-1.326 1.091-2.415 1.091-1.378 0-2.637-1.011-2.756-2.74h5.83c.015-.11.015-.147.015-.242v-.029c.007-2.059-1.252-3.641-3.222-3.641zm-2.623 3.311c.126-1.538 1.2-2.703 2.593-2.703 1.615 0 2.43 1.297 2.526 2.703zM14.63 30.857h-.808l-2.377 2.945-2.37-2.945h-.838l2.77 3.407-2.881 3.545h.815l2.481-3.091 2.482 3.091h.837l-2.882-3.553zM20.037 30.696c-1.393 0-2.289.806-2.896 1.722v-1.553h-.674V40h.674v-3.685c.577.872 1.489 1.663 2.896 1.663 1.696 0 3.422-1.377 3.422-3.641v-.03c0-2.263-1.726-3.611-3.422-3.611zm2.689 3.67c0 1.868-1.23 2.975-2.756 2.975-1.459 0-2.866-1.202-2.866-2.99v-.029c0-1.772 1.407-2.989 2.866-2.989 1.474 0 2.756 1.173 2.756 3.004zM26.067 32.835v-1.978h-.674v6.952h.674v-2.85c0-2.263 1.422-3.48 3.044-3.48h.067v-.74c-1.385-.043-2.556.858-3.111 2.096zM33.245 30.696c-1.904 0-3.341 1.612-3.341 3.626v.03c0 2.168 1.6 3.626 3.444 3.626 1.348 0 2.193-.542 2.911-1.311l-.466-.41c-.578.615-1.326 1.091-2.415 1.091-1.378 0-2.637-1.011-2.756-2.74h5.83c.015-.11.015-.147.015-.242v-.029c0-2.059-1.252-3.641-3.222-3.641zm-2.623 3.311c.126-1.538 1.2-2.703 2.593-2.703 1.615 0 2.43 1.297 2.526 2.703zM40.652 33.941c-1.008-.285-1.956-.571-1.956-1.348v-.029c0-.696.637-1.216 1.6-1.216.748 0 1.519.271 2.163.696l.356-.557c-.704-.461-1.652-.762-2.496-.762-1.363 0-2.319.806-2.319 1.927v.03c0 1.237 1.267 1.582 2.415 1.911.978.271 1.86.572 1.86 1.392v.03c0 .806-.75 1.326-1.697 1.326-.897 0-1.748-.33-2.526-.916l-.4.535c.748.6 1.86 1.01 2.881 1.01 1.348 0 2.43-.79 2.43-2.029v-.029c0-1.253-1.185-1.656-2.311-1.97zM47.185 33.941c-1.007-.285-1.955-.571-1.955-1.348v-.029c0-.696.637-1.216 1.6-1.216.748 0 1.518.271 2.163.696l.355-.557c-.703-.461-1.652-.762-2.496-.762-1.363 0-2.318.806-2.318 1.927v.03c0 1.237 1.266 1.582 2.414 1.911.978.271 1.86.572 1.86 1.392v.03c0 .806-.749 1.326-1.697 1.326-.896 0-1.748-.33-2.526-.916l-.4.535c.748.6 1.86 1.01 2.882 1.01 1.348 0 2.43-.79 2.43-2.029v-.029c.007-1.253-1.178-1.656-2.312-1.97z"
    })
  })
});
var SkyExpress_default = SvgSkyExpress;

// src/uds/airline-logos/generated/Smartwings.tsx
init_esm_shims();
import { jsx as jsx38, jsxs as jsxs21 } from "react/jsx-runtime";
var SvgSmartwings = (props) => /* @__PURE__ */ jsxs21("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx38("clipPath", {
      id: "smartwings_svg__a",
      children: /* @__PURE__ */ jsx38("path", {
        d: "M0 0h50v50H0z"
      })
    }),
    /* @__PURE__ */ jsx38("g", {
      clipPath: "url(#smartwings_svg__a)",
      children: /* @__PURE__ */ jsx38("path", {
        fill: "#ff8c00",
        d: "M13.528 9.942c2.378-.308 8.284-1.156 10.432-1.619 2.07-.463 13.883-2.236 19.867-2.314 6.06-.077 5.753.309 5.83 1.466.153 1.156.69 1.542 0 2.622-.768 1.08-1.995 1.542-3.836 2.236-3.375 1.311-18.18 5.321-20.174 6.324 3.069-.154 7.518-.926 11.966-1.157 2.992-.077 3.375.54 3.606 1.928.306 1.31.383 2.005-1.611 2.776-1.995.771-4.296 1.62-8.975 3.008-6.52 1.928-10.432 2.776-15.264 4.935 2.685.309 7.057-.154 10.585 0 5.293.155 5.523.771 5.753 2.39.077 1.543.307 2.006-1.918 3.086-2.224.925-6.136 2.005-8.284 2.467a882.813 882.813 0 0 0-12.12 2.7c-1.457.385-2.684 2.004-4.908 2.776-2.455.848-3.529.462-4.373-1.234-.537-1.311 1.074-2.468 3.069-3.085 1.994-.54 8.13-1.928 10.738-2.622 2.608-.694 7.748-2.082 9.435-2.776-2.301 0-7.9.077-12.273.154-2.608.077-3.528-.077-3.912-2.005-.383-1.928.384-2.622 2.685-3.239 2.301-.771 5.753-2.313 7.9-3.085 2.148-.77 8.438-3.007 10.126-3.393-4.219-.077-13.654 2.005-16.032 2.468-1.917.386-2.07-.308-2.838-1.542-.767-1.311.154-2.237 1.304-2.468 1.458-.386 4.219-1.697 8.131-3.239 3.145-1.234 7.517-2.622 10.816-3.624 3.068-1.08 8.284-2.854 10.048-3.548-1.304 0-7.517.848-11.66 1.465-3.988.54-10.968 2.005-12.042 2.39s-2.301.31-2.992-1.31c-.69-1.62-.076-2.468.92-2.622"
      })
    })
  ]
});
var Smartwings_default = SvgSmartwings;

// src/uds/airline-logos/generated/SunExpress.tsx
init_esm_shims();
import { jsx as jsx39, jsxs as jsxs22 } from "react/jsx-runtime";
var SvgSunExpress = (props) => /* @__PURE__ */ jsxs22("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx39("g", {
      fill: "#1a428a",
      children: /* @__PURE__ */ jsx39("path", {
        d: "M30.936 33.193c-7.899.584-18.836 2.313-26.665 1.893.818 1.682 1.87 3.248 3.085 4.697a25.568 25.568 0 0 0 2.22 2.29 23.047 23.047 0 0 0 15.447 5.936c5.726 0 11.218-2.08 15.424-5.842 1.753-1.566 3.155-3.225 4.277-5.048.77-1.239 1.378-2.547 1.893-3.973-3.366-.678-9.161-.42-15.681.047zM12.32 5.929a.542.542 0 0 0-.42.093c-.421.28-.842.608-1.24.912a.54.54 0 0 0-.14.677l3.903 6.777.21.28v.024l-.28-.21-6.777-3.926c-.21-.14-.514-.07-.678.14a15.31 15.31 0 0 0-.911 1.239.453.453 0 0 0-.07.42c.023.14.117.257.257.35L17.74 19.39l.258.07c.14 0 .28-.07.397-.187a7.14 7.14 0 0 1 .841-.842.537.537 0 0 0 .117-.654L12.67 6.209c-.093-.163-.21-.257-.35-.28zM44.053 12.33c.023-.14 0-.28-.07-.421-.28-.42-.608-.841-.912-1.238a.54.54 0 0 0-.677-.14l-6.777 3.902-.28.21.21-.28 3.926-6.777a.514.514 0 0 0-.14-.678 15.31 15.31 0 0 0-1.24-.911c-.116-.094-.256-.117-.42-.07-.14.023-.257.116-.35.257L30.639 17.75l-.07.257c0 .14.07.28.187.398.304.257.584.537.841.841a.537.537 0 0 0 .654.117L43.82 12.68a.59.59 0 0 0 .234-.35zM35.16 4.49a.553.553 0 0 0-.28-.326c-.467-.21-.934-.42-1.425-.608a.537.537 0 0 0-.654.234l-3.927 6.777-.14.304h-.023l.047-.327v-7.83c0-.256-.187-.49-.444-.513-.514-.07-1.029-.14-1.543-.164-.14 0-.28.047-.397.14a.465.465 0 0 0-.164.374V15.92l.07.257c.07.116.21.21.351.257.397.07.771.187 1.145.303.234.07.49-.023.631-.233l6.684-11.568a.454.454 0 0 0 .07-.444zM47.86 23.571a.634.634 0 0 0 .14-.397 17.326 17.326 0 0 0-.187-1.542.525.525 0 0 0-.514-.444H39.47l-.327.046v-.023l.304-.14 6.777-3.926a.528.528 0 0 0 .234-.655 25.33 25.33 0 0 0-.608-1.402.536.536 0 0 0-.748-.234l-11.59 6.708-.188.186a.57.57 0 0 0-.047.444c.14.374.234.748.304 1.145.047.258.257.421.514.421h13.368c.14-.023.28-.07.397-.187zM4.454 14.821a.552.552 0 0 0-.327.28c-.21.468-.421.935-.608 1.426a.538.538 0 0 0 .234.654l6.777 3.903.304.14v.024l-.328-.047H2.678c-.257 0-.491.187-.514.444-.07.514-.14 1.028-.164 1.542 0 .14.047.28.14.397a.551.551 0 0 0 .374.164h13.367l.257-.07c.117-.07.21-.21.257-.35.07-.398.164-.772.304-1.146.094-.233-.023-.49-.233-.63L4.874 14.867a.525.525 0 0 0-.42-.047zM23.535 2.14a.634.634 0 0 0-.397-.14 17.35 17.35 0 0 0-1.543.187.525.525 0 0 0-.444.514v7.829l.047.327h-.024l-.14-.304-3.926-6.777a.495.495 0 0 0-.654-.21c-.467.187-.958.397-1.402.607a.535.535 0 0 0-.234.748l6.684 11.568.187.187c.14.07.28.093.42.047.374-.117.748-.234 1.145-.304a.505.505 0 0 0 .42-.514V2.537c.048-.14-.022-.28-.14-.397z"
      })
    }),
    /* @__PURE__ */ jsx39("path", {
      fill: "#ee5f2a",
      d: "M46.535 26.63c-4.814 0-8.53 1.169-18.111 3.202-13.555 2.874-23.183.49-25.38.21-.327-.047-.537.117-.443.49.233 1.1 1.051 3.46 1.659 4.534 7.852.421 18.789-1.308 26.664-1.892 6.52-.468 12.292-.725 15.68-.047a26.484 26.484 0 0 0 1.216-4.954c.187-1.005.047-1.543-1.285-1.543z"
    }),
    /* @__PURE__ */ jsx39("path", {
      fill: "#ee5f2a",
      d: "M2.463 28.27c.444.187 6.73 2.314 16.452 2.454 2.757.047 6.286-.374 8.39-.818-1.1.164-3.46.537-6.357.514-5.609-.023-14.115-1.986-18.135-3.786a.519.519 0 0 0-.514.07c-.14.117-.234.28-.21.468l.07.77c0 .118.047.235.304.328z"
    })
  ]
});
var SunExpress_default = SvgSunExpress;

// src/uds/airline-logos/generated/Sunclass.tsx
init_esm_shims();
import { jsx as jsx40 } from "react/jsx-runtime";
var SvgSunclass = (props) => /* @__PURE__ */ jsx40("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsx40("path", {
    d: "M25 50c13.809 0 25-11.191 25-25S38.809 0 25 0 0 11.191 0 25s11.191 25 25 25Zm1.863-17.906c.578.379 1.262.55 1.946.613 1.43.133 2.882-.14 4.27-.46 1.644-.376 3.226-.985 4.796-1.59.145-.06.29-.114.43-.169.28-.105.558-.21.84-.32.457-.172.91-.348 1.367-.523.246-.098.46-.188.476-.2.012-.011.356-.883.762-1.93.406-1.046.742-1.921.746-1.94.008-.032.004-.036-.027-.028-.02.004-.426.164-.91.36-1.5.6-3.016 1.175-4.532 1.75l-.043.015c-1.554.59-3.12 1.16-4.75 1.5-.582.125-1.172.234-1.761.3-.504.06-1.008.079-1.516.067a7.388 7.388 0 0 1-.695-.031c-.809-.098-1.68-.344-2.211-1a2.254 2.254 0 0 1-.438-.992 3.615 3.615 0 0 1-.039-.618c-.004-.214-.004-.43-.043-.64a3.01 3.01 0 0 0-.766-1.492 2.955 2.955 0 0 0-1.1-.704 5.249 5.249 0 0 0-1.532-.3c-1.113-.075-2.238.101-3.324.32-2.262.457-4.47 1.184-6.637 1.973a113.212 113.212 0 0 0-5.961 2.367c-.375.16-.457.2-.469.23-.008.02-.012.715-.012 1.63 0 .874.004 1.609.008 1.628.008.027.016.031.047.027.02-.003.332-.132.695-.289a127.05 127.05 0 0 1 2.614-1.09c2.875-1.163 5.8-2.253 8.812-3.007.88-.219 1.77-.41 2.668-.524.742-.093 1.504-.136 2.25-.058.258.027.516.066.766.129.41.105.816.261 1.16.52.293.218.523.527.66.87.07.18.117.371.14.563.009.078.016.262.016.41a3.312 3.312 0 0 0 .137 1.02c.063.214.149.425.258.62.105.196.234.38.383.551.148.172.328.32.52.442Zm.305-5.864c.191.098.387.18.59.243.844.257 1.754.273 2.625.187a20.154 20.154 0 0 0 3.722-.719c2.676-.777 5.27-1.84 7.848-2.898.387-.16.77-.316 1.156-.473.348-.144.641-.265.653-.273.011-.012.39-.895.808-1.965.418-1.074.735-1.969.739-1.992.007-.043.007-.043-.036-.035-.023.004-.28.11-.574.238-2.566 1.133-5.187 2.133-7.808 3.125-2.09.793-4.246 1.523-6.477 1.773-.785.086-1.617.118-2.402-.007-.25-.04-.5-.098-.739-.176-.207-.07-.41-.16-.601-.266a2.195 2.195 0 0 1-.41-.297 2.113 2.113 0 0 1-.668-1.437 9.698 9.698 0 0 1-.02-.535 3.374 3.374 0 0 0-.09-.711 2.991 2.991 0 0 0-.27-.668 2.863 2.863 0 0 0-.843-.953c-.398-.286-.887-.457-1.363-.555-.91-.188-1.899-.14-2.813-.023-1.367.175-2.71.507-4.03.89-3.427.985-6.755 2.309-10.028 3.711-.29.125-.375.168-.39.195-.013.028-.017.395-.017 1.645 0 1.351 0 1.61.02 1.633.02.027.04.02.492-.172 2.73-1.176 5.496-2.29 8.32-3.219a44.684 44.684 0 0 1 3.192-.945c1.156-.293 2.336-.551 3.531-.63.695-.046 1.406-.05 2.09.09.457.094.906.255 1.297.512.2.13.394.325.527.524.106.16.196.34.254.523.078.23.098.461.106.703.003.301.02.602.078.899a3.165 3.165 0 0 0 .558 1.258c.125.172.282.336.45.468.16.133.34.239.523.332Zm0 0",
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "#fc8b00",
      fillOpacity: 1
    }
  })
});
var Sunclass_default = SvgSunclass;

// src/uds/airline-logos/generated/Sundair.tsx
init_esm_shims();
import { jsx as jsx41, jsxs as jsxs23 } from "react/jsx-runtime";
var SvgSundair = (props) => /* @__PURE__ */ jsxs23("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx41("clipPath", {
      id: "sundair_svg__a",
      children: /* @__PURE__ */ jsx41("path", {
        d: "M0 0h50v50H0z"
      })
    }),
    /* @__PURE__ */ jsxs23("g", {
      clipPath: "url(#sundair_svg__a)",
      children: [
        /* @__PURE__ */ jsx41("path", {
          fill: "#fff",
          d: "M25 48c12.703 0 23-10.298 23-23C48 12.296 37.703 2 25 2S2 12.297 2 25c0 12.702 10.297 23 23 23z"
        }),
        /* @__PURE__ */ jsx41("path", {
          stroke: "#0b1213",
          strokeWidth: 2.446,
          d: "M25 48c12.703 0 23-10.298 23-23C48 12.296 37.703 2 25 2S2 12.297 2 25c0 12.702 10.297 23 23 23z"
        }),
        /* @__PURE__ */ jsx41("g", {
          fill: "#0b1213",
          children: /* @__PURE__ */ jsx41("path", {
            d: "M34.729 30.684v-1.291a4.39 4.39 0 0 0-.775-.068c-.39 0-.784.062-1.18.189-.395.126-.754.31-1.076.55a2.777 2.777 0 0 0-.783.922c-.201.372-.302.812-.302 1.317v6.112h1.378v-6.112c0-.276.054-.517.164-.723.109-.207.255-.382.439-.526.183-.143.396-.25.636-.318.242-.069.5-.104.776-.104.126 0 .246.004.361.01s.235.02.362.042zM22.487 38.46c.62-.098 1.24-.256 1.86-.474v-5.786c0-.482-.095-.903-.285-1.265a2.611 2.611 0 0 0-.758-.895 3.415 3.415 0 0 0-1.084-.534 4.393 4.393 0 0 0-1.248-.18 4.41 4.41 0 0 0-1.696.352 4.041 4.041 0 0 0-1.472 1.042l.86.843a2.312 2.312 0 0 1 1-.731 3.31 3.31 0 0 1 1.205-.233c.263 0 .522.034.774.104.252.068.476.172.672.31.195.137.353.306.473.508.121.2.181.427.181.68v1.188a5.42 5.42 0 0 0-2.135-.431c-.436 0-.855.057-1.257.172a3.298 3.298 0 0 0-1.068.517c-.31.23-.559.522-.748.878-.19.356-.284.78-.284 1.274 0 .482.083.895.25 1.24.165.344.39.631.67.86.282.23.617.403 1.008.517.39.115.809.172 1.257.172.597.012 1.205-.032 1.825-.128zm.482-1.215c-.368.08-.743.133-1.128.155-.385.023-.766.03-1.145.018-.528-.011-.97-.14-1.326-.388-.356-.246-.533-.657-.533-1.231 0-.32.06-.594.18-.818.121-.224.279-.404.474-.542a1.99 1.99 0 0 1 .68-.301c.259-.063.525-.095.8-.095.368 0 .724.034 1.068.103.345.069.654.15.93.241zm3.788-6.871v8.042h1.377v-8.044a3.349 3.349 0 0 1-.703.074c-.235 0-.459-.025-.674-.072zM7.078 25.768c.474.629 1.017 1.068 1.626 1.318.61.25 1.26.376 1.954.376.462 0 .91-.067 1.347-.202s.82-.34 1.154-.616c.333-.275.6-.62.799-1.03.199-.41.298-.885.298-1.423 0-.475-.09-.88-.27-1.213a2.678 2.678 0 0 0-.692-.837 3.97 3.97 0 0 0-.924-.549 6.358 6.358 0 0 0-.982-.327 2.323 2.323 0 0 1-.846-.356 1.562 1.562 0 0 1-.356-.327.568.568 0 0 1-.125-.414c.026-.295.128-.503.308-.625a1.04 1.04 0 0 1 .596-.183c.296 0 .597.061.905.183.308.122.545.266.712.433l1.328-1.828a4.225 4.225 0 0 0-1.636-.828c-.577-.14-1.09-.212-1.54-.212-.551 0-1.039.087-1.462.26a3.22 3.22 0 0 0-1.068.693 2.905 2.905 0 0 0-.654.99c-.148.374-.222.752-.222 1.137 0 .359.067.711.202 1.058.135.346.337.667.607.962.269.295.606.552 1.01.77.404.218.888.372 1.453.462.449.064.753.218.914.461.16.244.176.514.048.809-.141.295-.41.442-.808.442-.347 0-.741-.096-1.184-.288a4.108 4.108 0 0 1-1.222-.828zM38.681 13.664h-2.695v3.79a3.853 3.853 0 0 0-1.635-.346c-.462 0-.914.08-1.357.241-.442.16-.837.385-1.183.674a3.315 3.315 0 0 0-.837 1.058 3.082 3.082 0 0 0-.318 1.414v3.522c.052.642.196 1.184.433 1.626s.546.799.924 1.068c.378.27.805.462 1.28.577.474.116.975.174 1.5.174.63 0 1.28-.068 1.954-.202a12.47 12.47 0 0 0 1.934-.55zm-2.695 11.604c-.23.115-.497.182-.798.202-.302.02-.586-.01-.856-.087a1.61 1.61 0 0 1-.693-.394 1.02 1.02 0 0 1-.308-.722v-3.906a1.06 1.06 0 0 1 .356-.683c.199-.174.433-.295.702-.366.27-.07.55-.086.838-.048.289.038.542.115.76.23zM28.888 24.66v-7.013c0-.655-.122-1.213-.366-1.674a3.194 3.194 0 0 0-.971-1.126 4.167 4.167 0 0 0-1.386-.635 6.45 6.45 0 0 0-1.626-.202c-.616 0-1.231.077-1.847.23-.616.155-1.2.366-1.752.636v2.275h-.005v7.775a2.717 2.717 0 0 1-.962.173 1.9 1.9 0 0 1-1.174-.375c-.334-.25-.5-.67-.5-1.26V17.15h-2.675v6.467c0 .706.116 1.295.346 1.77.231.475.539.853.924 1.136.385.282.83.484 1.337.605a6.738 6.738 0 0 0 1.588.183c.693 0 1.36-.073 2.001-.22a15.67 15.67 0 0 0 1.77-.511v-2.41h.002v-7.486c.32-.18.71-.27 1.12-.27.385 0 .734.107 1.049.318.314.212.471.548.471 1.01v6.814a3.074 3.074 0 0 1 1.2-.233c.54 0 1.026.113 1.456.337z"
          })
        }),
        /* @__PURE__ */ jsx41("path", {
          fill: "#c0046b",
          d: "M29.168 26.977a1.785 1.785 0 0 0-3.524.408 1.785 1.785 0 0 0 3.516.435c-.15.065-.307.117-.476.138-.52.063-1.044-.06-1.402-.388-.045.007-.163.026-.241.032.046-.078.078-.137.13-.231a2.294 2.294 0 0 0 1.996-.393z"
        })
      ]
    })
  ]
});
var Sundair_default = SvgSundair;

// src/uds/airline-logos/generated/Swiss.tsx
init_esm_shims();
import { jsx as jsx42, jsxs as jsxs24 } from "react/jsx-runtime";
var SvgSwiss = (props) => /* @__PURE__ */ jsxs24("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx42("path", {
      fill: "#cf0a2c",
      d: "M40.182 43H1L29.706 7H49z"
    }),
    /* @__PURE__ */ jsx42("path", {
      fill: "#fff",
      d: "M34.178 21.683v-7.766H27.58v7.766h-7.724v6.634h7.692v7.734h6.63v-7.734h7.692v-6.634z"
    })
  ]
});
var Swiss_default = SvgSwiss;

// src/uds/airline-logos/generated/TailwindAirlinesCopy.tsx
init_esm_shims();
import { jsx as jsx43, jsxs as jsxs25 } from "react/jsx-runtime";
var SvgTailwindAirlinesCopy = (props) => /* @__PURE__ */ jsxs25("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx43("path", {
      fill: "#00acc8",
      d: "M4.5 38.439c3.384-4.25 7.552-10.73 13.144-14.271 8.264-5.241 14 2.797 17.74 9.667C38.34 39.29 41.51 45.31 45.5 48c-10.045-3.01-14.035-19.477-28.105-16.679-5.2 1.062-9.226 4.816-12.895 7.118z"
    }),
    /* @__PURE__ */ jsx43("path", {
      fill: "#575656",
      d: "M42.401 47.61c-5.308-2.939-14.39-6.48-18.915-11.615-1.21-1.38-1.959-2.726-2.422-4.037 10.33.921 14.07 11.722 21.337 15.653zM24.27 21.76c2.03-2.337 4.702-4.497 7.267-6.41 5.45-4.143 9.902-8.144 11.719-13.35.712 8.995-9.368 15.546-12.147 23.761-1.995-2.16-4.239-3.683-6.84-4.001z"
    })
  ]
});
var TailwindAirlinesCopy_default = SvgTailwindAirlinesCopy;

// src/uds/airline-logos/generated/TailwindAirlines.tsx
init_esm_shims();
import { jsx as jsx44, jsxs as jsxs26 } from "react/jsx-runtime";
var SvgTailwindAirlines = (props) => /* @__PURE__ */ jsxs26("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx44("path", {
      fill: "#00acc8",
      d: "M4.5 38.439c3.384-4.25 7.552-10.73 13.144-14.271 8.264-5.241 14 2.797 17.74 9.667C38.34 39.29 41.51 45.31 45.5 48c-10.045-3.01-14.035-19.477-28.105-16.679-5.2 1.062-9.226 4.816-12.895 7.118z"
    }),
    /* @__PURE__ */ jsx44("path", {
      fill: "#575656",
      d: "M42.401 47.61c-5.308-2.939-14.39-6.48-18.915-11.615-1.21-1.38-1.959-2.726-2.422-4.037 10.33.921 14.07 11.722 21.337 15.653zM24.27 21.76c2.03-2.337 4.702-4.497 7.267-6.41 5.45-4.143 9.902-8.144 11.719-13.35.712 8.995-9.368 15.546-12.147 23.761-1.995-2.16-4.239-3.683-6.84-4.001z"
    })
  ]
});
var TailwindAirlines_default = SvgTailwindAirlines;

// src/uds/airline-logos/generated/Transavia.tsx
init_esm_shims();
import { jsx as jsx45, jsxs as jsxs27 } from "react/jsx-runtime";
var SvgTransavia = (props) => /* @__PURE__ */ jsx45("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsxs27("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx45("path", {
        fill: "#00d66c",
        d: "M47.996 25.004C47.996 12.191 37.84 2 25 2 12.158 2 2 12.193 2 25.006 2 37.817 12.163 48 25 48c12.839.002 22.996-10.182 22.996-22.994l.004-.002h-.002z"
      }),
      /* @__PURE__ */ jsx45("path", {
        fill: "#fff",
        d: "M35.1 28.073h-1.294c-1.293 0-1.845.69-2.033 2.024-.327 2.446-2.263 4.1-4.805 4.1-2.953 0-4.844-2.163-4.844-5.3v-7.371c0-.295-.043-.556-.116-.787.278.125.61.19.991.19h6.788c1.297 0 2.033-.74 2.033-2.026v-.598c0-1.293-.736-2.03-2.033-2.03h-3.83v-4.153c0-1.288-.74-2.027-2.03-2.027h-.928c-1.29 0-2.03.74-2.03 2.027V18.9c0 .292.038.552.116.787a2.442 2.442 0 0 0-.994-.189h-6.787c-1.292 0-2.033.738-2.033 2.027v.602c0 1.29.74 2.028 2.033 2.028h3.833v4.74c0 5.946 3.834 10.095 9.837 10.095 5.59 0 9.283-3.551 9.976-8.895.182-1.337-.695-2.023-1.852-2.023z"
      })
    ]
  })
});
var Transavia_default = SvgTransavia;

// src/uds/airline-logos/generated/Tunisair.tsx
init_esm_shims();
import { jsx as jsx46 } from "react/jsx-runtime";
var SvgTunisair = (props) => /* @__PURE__ */ jsx46("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsx46("g", {
    fill: "#e52725",
    children: /* @__PURE__ */ jsx46("path", {
      d: "m12.714 11.5-.764.775h11.289l-.764-.775zM8.13 12.663l-.552.56h16.595l-.595-.56zM7.536 13.61l.764.775h7.851l.722-.775zM26.21 15.332l-.552-.56H10.676c.128.087.552.56.552.56zM1.764 28.294 1 29.07h29.963l.764-.775zM1.17 29.457l.552.56h38.96l-.552-.56zM45.265 35.356l-.764-.775H31.048a6.196 6.196 0 0 0 1.867.775zM2.103 30.404l.764.732h2.165l-.764-.732zM4.14 32.471l.765.775H7.11l-.763-.775zM3.207 31.524l.594.56h2.165l-.552-.56zM5.287 33.634l.551.56h2.207l-.551-.56zM6.22 34.581l.764.775H9.15l-.722-.775zM7.366 35.744l.552.56h2.207l-.595-.56zM8.3 36.691l.764.775h1.018v-.775zM9.446 37.811l.551.603.085.086v-.689zM24.555 26.184l-.764.775h5.432l-.764-.775zM10.889 17.4c.17-.216.34-.388.467-.56h16.382l.551.56zM9.403 18.95c-.17.172-.34.387-.467.56H30.37l-.552-.56zM7.663 21.62c.085-.216.17-.388.255-.56h23.936l.552.56zM7.196 23.127c-.042.172-.042.387-.085.56h27.375l-.552-.56zM7.07 25.237c0 .172.042.387.042.56h29.453l-.552-.56zM7.62 27.907c-.042-.173-.127-.388-.17-.56h30.643l.552.56zM14.75 15.677c-.211.215-.424.474-.678.775H11.44c.043-.172 0-.646-.042-.775zM12.968 17.787l-.51.775H9.744l.764-.775zM11.61 20.672c.043-.258.127-.517.212-.775H8.64c-.17.259-.34.474-.509.775zM11.525 22.007l.128.775H7.28c.085-.258.128-.516.212-.775zM12.926 24.85c-.255-.26-.424-.518-.637-.776H7.07v.775zM14.496 26.184c.382.259.806.517 1.273.775H7.324c-.043-.258-.128-.516-.17-.775zM9.7 31.136a6.229 6.229 0 0 1-.679-.775h23.597l.764.775zM10.804 32.084a8.151 8.151 0 0 1-.722-.56H42.21l.551.56zM13.138 33.246c-.51-.172-1.103-.43-1.74-.775h8.7s-1.358.775-1.655.775zM29.223 33.246c-.297-.301-.51-.56-.637-.775h6.07l.763.775zM30.453 34.194a11.964 11.964 0 0 1-.763-.56h14.6l.55.56zM42.337 36.304c-.722-.258-1.4-.43-2.037-.56h6.026l.552.56zM43.356 36.691c.636.259 1.23.517 1.825.775h2.164l-.764-.775zM45.944 37.811c.382.215.722.388 1.019.56H49l-.552-.56z"
    })
  })
});
var Tunisair_default = SvgTunisair;

// src/uds/airline-logos/generated/Volotea.tsx
init_esm_shims();
import { jsx as jsx47, jsxs as jsxs28 } from "react/jsx-runtime";
var SvgVolotea = (props) => /* @__PURE__ */ jsx47("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: /* @__PURE__ */ jsxs28("g", {
    fill: "#ed164a",
    children: [
      /* @__PURE__ */ jsx47("path", {
        d: "m17.333 40.337 7.67-7.673 7.664 7.673L25.002 48zM17.333 9.668 25.003 2l7.664 7.668-7.665 7.668zM32.666 25l7.67-7.665L48 25l-7.665 7.666zM2 25l7.67-7.665L17.333 25l-7.665 7.666z"
      }),
      /* @__PURE__ */ jsx47("path", {
        d: "M11.37 34.37v-3.407l-1.7 1.702zm1.706 1.704 1.706 1.703v-10.22l-1.706 1.705zm3.409-10.218v13.63l.85.851.848-.852v-13.63L17.334 25zm6.808 5.107v3.407l1.71-1.705zm-3.404 6.814 1.706-1.703v-6.812l-1.706-1.705zM26.703 19.034v-3.402l-1.705 1.705zm1.703 1.705 1.706 1.704V12.22l-1.706 1.708zm3.407-10.218V24.15l.854.851.85-.851V10.52l-.85-.854zm6.813 5.11v3.403l1.705-1.697zm-3.406 6.812 1.707-1.704v-6.811L35.22 12.22z"
      }),
      /* @__PURE__ */ jsx47("path", {
        d: "M26.703 34.37v-3.407l-1.705 1.702zm1.703 1.704 1.706 1.703v-10.22l-1.706 1.705zm3.407-10.218v13.63l.854.851.85-.852v-13.63l-.85-.856zm6.813 5.107v3.407l1.705-1.705zm-3.406 6.814 1.707-1.703v-6.812l-1.708-1.705zM11.37 19.034v-3.402l-1.7 1.705zm1.706 1.705 1.706 1.704V12.22l-1.706 1.708zm3.409-10.218V24.15l.85.851.848-.851V10.52l-.849-.854zm6.808 5.11v3.403l1.71-1.697zm-3.404 6.812 1.706-1.704v-6.811l-1.706-1.708z"
      })
    ]
  })
});
var Volotea_default = SvgVolotea;

// src/uds/airline-logos/generated/Vueling.tsx
init_esm_shims();
import { jsx as jsx48, jsxs as jsxs29 } from "react/jsx-runtime";
var SvgVueling = (props) => /* @__PURE__ */ jsxs29("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsx48("clipPath", {
      id: "vueling_svg__a",
      children: /* @__PURE__ */ jsx48("path", {
        d: "M0 0h50v50H0z"
      })
    }),
    /* @__PURE__ */ jsxs29("g", {
      clipPath: "url(#vueling_svg__a)",
      children: [
        /* @__PURE__ */ jsx48("path", {
          fill: "#ffd300",
          d: "M0 0h50v50H0z"
        }),
        /* @__PURE__ */ jsx48("path", {
          fill: "#504f4f",
          d: "m24.885 29.796-4.699-15.248a3.317 3.317 0 0 0-3.27-2.487A3.547 3.547 0 0 0 13 15.47c.017.7.174 1.388.46 2.026l6.081 16.768c1.198 3.27 2.257 4.377 5.344 4.377h.507c3.132 0 3.823-1.106 5.02-4.33l6.127-16.814c.283-.64.44-1.328.461-2.027a3.548 3.548 0 0 0-3.87-3.455 3.316 3.316 0 0 0-3.316 2.533l-4.607 15.478z"
        })
      ]
    })
  ]
});
var Vueling_default = SvgVueling;

// src/uds/airline-logos/generated/WizzAir.tsx
init_esm_shims();
import { jsx as jsx49, jsxs as jsxs30 } from "react/jsx-runtime";
var SvgWizzAir = (props) => /* @__PURE__ */ jsxs30("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 51 50",
  ...props,
  children: [
    /* @__PURE__ */ jsxs30("linearGradient", {
      id: "wizz-air_svg__a",
      x1: 25,
      x2: 25,
      y1: 36.5,
      y2: 13.5,
      gradientUnits: "userSpaceOnUse",
      children: [
        /* @__PURE__ */ jsx49("stop", {
          offset: 0,
          stopColor: "#161998"
        }),
        /* @__PURE__ */ jsx49("stop", {
          offset: 0.129,
          stopColor: "#441e93"
        }),
        /* @__PURE__ */ jsx49("stop", {
          offset: 0.266,
          stopColor: "#6e228f"
        }),
        /* @__PURE__ */ jsx49("stop", {
          offset: 0.407,
          stopColor: "#90258c"
        }),
        /* @__PURE__ */ jsx49("stop", {
          offset: 0.549,
          stopColor: "#ab2889"
        }),
        /* @__PURE__ */ jsx49("stop", {
          offset: 0.694,
          stopColor: "#be2a87"
        }),
        /* @__PURE__ */ jsx49("stop", {
          offset: 0.842,
          stopColor: "#c92b86"
        }),
        /* @__PURE__ */ jsx49("stop", {
          offset: 1,
          stopColor: "#cd2b86"
        })
      ]
    }),
    /* @__PURE__ */ jsx49("path", {
      fill: "url(#wizz-air_svg__a)",
      d: "M36.743 21.664h4.83l-5.72 7.456H31.02zm-.363-.728-6.08 7.928a.59.59 0 0 0-.064.639.62.62 0 0 0 .551.344h5.428l6.13-7.988a.583.583 0 0 0 .058-.608.577.577 0 0 0-.523-.315zM19.014 17.06a.18.18 0 0 1 .155-.087h3.167l.455-2.605a.171.171 0 0 1 .171-.138l2.965-.003c.054 0 .099.017.13.052.032.04.048.094.04.141l-.295 1.686 13.938.01c.075 0 .13.046.156.09.016.031.038.097-.008.159l-1.258 1.638L48.96 18c.06 0 .102.037.12.071a.11.11 0 0 1-.002.121l-8.585 11.2c-.098.121-.093.431-.025.564.07.133.315.323.469.323l6.039.006a.168.168 0 0 1 .169.194l-.46 2.617a.171.171 0 0 1-.171.137H23.54l-.377-.002a2.135 2.135 0 0 1-2.101 2.533 2.136 2.136 0 0 1-2.141-2.132c0-1.177.958-2.13 2.14-2.13.808 0 1.512.445 1.878 1.103l9.363-12.23c.15-.316.075-.43-.006-.615-.06-.14-.286-.285-.532-.283H25.21l-1.675 9.529a.17.17 0 0 1-.168.127H20.4a.175.175 0 0 1-.131-.059.162.162 0 0 1-.038-.136l1.819-10.343-7.4 14.452a.378.378 0 0 1-.328.191l-2.52.012c-.09 0-.163-.063-.172-.14l-.695-10.499L5.47 33.05a.379.379 0 0 1-.327.19l-2.556-.002a.167.167 0 0 1-.17-.147L.75 17.153a.182.182 0 0 1 .043-.132.179.179 0 0 1 .13-.048h3.436c.094 0 .172.076.172.176l.516 10.397 5.053-10.483a.172.172 0 0 1 .153-.09l3.132-.013c.087 0 .164.065.17.141l.508 10.478zm3.803-3.56a.729.729 0 0 0-.718.601l-.378 2.143h-2.664a.738.738 0 0 0-.653.4l-3.75 7.97-.373-7.706a.73.73 0 0 0-.728-.664h-3.41a.736.736 0 0 0-.653.4l-3.857 8.002-.38-7.676c0-.4-.328-.725-.73-.725H.73c-.207 0-.4.08-.539.226a.763.763 0 0 0-.19.567l1.701 16.277c.041.368.353.646.726.646l2.82.001a.93.93 0 0 0 .824-.494l4.306-8.22.531 8.067a.73.73 0 0 0 .725.646l2.799.001c.344 0 .662-.19.825-.498l5.233-10.223-1.013 5.765a.733.733 0 0 0 .158.596.73.73 0 0 0 .559.259h3.317c.344 0 .637-.24.714-.583l1.596-9.074h5.698l-8.61 11.23a2.876 2.876 0 0 0-1.843-.664 2.876 2.876 0 0 0-2.876 2.865 2.876 2.876 0 0 0 2.876 2.865 2.894 2.894 0 0 0 2.861-2.538l22.733-.002a.722.722 0 0 0 .718-.602l.52-2.949a.726.726 0 0 0-.72-.849l-5.895-.005 8.596-11.207a.672.672 0 0 0 .038-.705.69.69 0 0 0-.613-.371h-9.198l.583-.759a.714.714 0 0 0 .04-.747.734.734 0 0 0-.644-.389H26.67l.184-1.028a.747.747 0 0 0-.17-.598.71.71 0 0 0-.552-.251z"
    })
  ]
});
var WizzAir_default = SvgWizzAir;

// src/uds/components/AirlineIcon/AirlineIcon.tsx
import { jsx as jsx50 } from "react/jsx-runtime";
var iconSizes = {
  "xs": "12px",
  "sm": "16px",
  "md": "24px",
  "lg": "32px",
  "xl": "40px",
  "2xl": "48px"
};
var IconWrapper2 = styled7.span`
  display: inline-flex;
  flex-shrink: 0;

  ${({ $size }) => modSize2($size)}
`;
function AirlineIcon({ className, glyph, size, ...attrs }) {
  const GlyphComponent = generated_exports[glyph];
  if (GlyphComponent === void 0) {
    console.error(`Icon: No icon found for glyph "${glyph}"`);
    return null;
  }
  return /* @__PURE__ */ jsx50(IconWrapper2, {
    className,
    $size: size,
    children: /* @__PURE__ */ jsx50(GlyphComponent, {
      ...attrs
    })
  });
}
AirlineIcon.displayName = "AirlineIcon";
function modSize2(sizeName = "sm") {
  return css8`
  & > svg {
    height: ${iconSizes[sizeName]};
    width: ${iconSizes[sizeName]};
  }
`;
}
var AirlineIcon_default = withStyleModifiers2(styled7(AirlineIcon)``, {
  modSize: modSize2
});

// src/uds/components/AlertWindow/index.ts
init_esm_shims();

// src/uds/components/AlertWindow/AlertWindow.tsx
init_esm_shims();
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { styled as styled9 } from "styled-components";

// src/uds/components/Button/index.ts
init_esm_shims();

// src/uds/components/Button/Button.tsx
init_esm_shims();
import { css as css9, styled as styled8 } from "styled-components";

// src/uds/components/Typography/wrap-text-children-with-typography.tsx
init_esm_shims();
import { Children } from "react";
import { jsx as jsx51 } from "react/jsx-runtime";
function wrapTextChildrenWithTypography(children) {
  return Children.map(children, (child) => {
    if (typeof child === "string") {
      return /* @__PURE__ */ jsx51(Typography_default, {
        as: "span",
        children: child
      });
    }
    return child;
  });
}

// src/uds/components/Button/Button.tsx
var Button = styled8.button.attrs(({ children }) => ({
  children: wrapTextChildrenWithTypography(children)
}))`
  border: none;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: fit-content;

  ${({ disabled }) => disabled && modDisabled2()}

  > * + * {
    margin-left: ${space("primitives_space_4")};
  }

  ${focusOutline()}

  ${({ $fullWidth }) => $fullWidth && modFullWidth2()};
  ${({ $size }) => modSize3($size)};
  ${({ $type }) => modType($type)};
`;
function modFullWidth2() {
  return css9`
    width: 100%;
  `;
}
function modSize3(sizeName = "M") {
  const configs = {
    M: {
      paddingTop: "components_button_m_padding_top",
      paddingBottom: "components_button_m_padding_bottom",
      paddingRight: "components_button_m_padding_right",
      paddingLeft: "components_button_m_padding_left",
      minHeight: "semantics_controls_m_min_height",
      borderRadius: "semantics_buttons_m_corner_radius",
      typography: "body-m-bold-tight",
      typographyPadding: true,
      iconSize: 24
    },
    S: {
      paddingTop: "components_button_s_padding_top",
      paddingBottom: "components_button_s_padding_bottom",
      paddingRight: "components_button_s_padding_right",
      paddingLeft: "components_button_s_padding_left",
      minHeight: "semantics_controls_s_min_height",
      borderRadius: "semantics_buttons_s_corner_radius",
      typography: "body-s-bold-tight",
      typographyPadding: true,
      iconSize: 20
    },
    XS: {
      paddingTop: "components_button_xs_padding_top",
      paddingBottom: "components_button_xs_padding_bottom",
      paddingRight: "components_button_xs_padding_right",
      paddingLeft: "components_button_xs_padding_left",
      minHeight: "semantics_controls_xs_min_height",
      borderRadius: "semantics_buttons_xs_corner_radius",
      typography: "body-s-bold-flat",
      typographyPadding: false,
      iconSize: 16
    }
  };
  const config = configs[sizeName];
  return css9`
    padding-top: ${tokPx(config.paddingTop)};
    padding-bottom: ${tokPx(config.paddingBottom)};
    padding-right: ${tokPx(config.paddingRight)};
    padding-left: ${tokPx(config.paddingLeft)};
    min-height: ${tokPx(config.minHeight)};
    border-radius: ${tokPx(config.borderRadius)};

    ${Typography_default} {
      ${Typography_default.modVariant(config.typography)};
      ${config.typographyPadding ? css9`
            padding-left: ${space("primitives_space_4")};
            padding-right: ${space("primitives_space_4")};
          ` : ""}
    }

    ${Icon_default} {
      ${Icon_default.modSize(config.iconSize)}
    }
  `;
}
var transparentSpacing = css9`
  padding-right: 0;
  padding-left: 0;
`;
function modType(type = "primary") {
  return {
    primary: css9`
      background-color: ${tok("semantics_buttons_primary_background_color")};
      color: ${tok("semantics_buttons_primary_content_color")};

      &:hover {
        background-color: ${tok("semantics_buttons_primary_hover_background_color")};
        color: ${tok("semantics_buttons_primary_hover_content_color")};
      }
    `,
    secondary: css9`
      background-color: ${tok("semantics_buttons_secondary_background_color")};
      color: ${tok("semantics_buttons_secondary_content_color")};

      &:hover {
        background-color: ${tok("semantics_buttons_secondary_hover_background_color")};
        color: ${tok("semantics_buttons_secondary_hover_content_color")};
      }
    `,
    transparentPrimary: css9`
      color: ${tok("semantics_buttons_transparent_primary_content_color")};
      ${transparentSpacing}
      ${Typography_default} {
        ${transparentSpacing}
      }

      &:hover {
        color: ${tok("semantics_buttons_transparent_primary_hover_content_color")};
      }
    `,
    transparentNeutral: css9`
      color: ${tok("semantics_buttons_transparent_neutral_content_color")};
      ${transparentSpacing}
      ${Typography_default} {
        ${transparentSpacing}
      }

      &:hover {
        color: ${tok("semantics_buttons_transparent_neutral_hover_content_color")};
      }
    `,
    outlinedPrimary: css9`
      border: ${tokPx("semantics_buttons_outlined_primary_border_width")} solid
        ${tok("semantics_buttons_outlined_primary_border_color")};
      color: ${tok("semantics_buttons_outlined_primary_content_color")};

      &:hover {
        border-color: ${tok("semantics_buttons_outlined_primary_hover_border_color")};
        color: ${tok("semantics_buttons_outlined_primary_hover_content_color")};
      }
    `,
    outlinedNeutral: css9`
      border: ${tokPx("semantics_buttons_outlined_neutral_border_width")} solid
        ${tok("semantics_buttons_outlined_neutral_border_color")};
      color: ${tok("semantics_buttons_outlined_neutral_content_color")};

      &:hover {
        border-color: ${tok("semantics_buttons_outlined_neutral_hover_border_color")};
        color: ${tok("semantics_buttons_outlined_neutral_hover_content_color")};
      }
    `,
    overlayPrimary: css9`
      background-color: ${tok("semantics_buttons_overlay_primary_background_color")};
      color: ${tok("semantics_buttons_overlay_primary_content_color")};

      &:hover {
        color: ${tok("semantics_buttons_overlay_primary_hover_content_color")};
      }
    `,
    overlayNeutral: css9`
      background-color: ${tok("semantics_buttons_overlay_neutral_background_color")};
      color: ${tok("semantics_buttons_overlay_neutral_content_color")};

      &:hover {
        color: ${tok("semantics_buttons_overlay_neutral_hover_content_color")};
      }
    `
  }[type];
}
function modDisabled2() {
  return css9`
    pointer-events: none;
    opacity: ${tok("primitives_opacity_disabled")}%;
  `;
}
var Button_default = withStyleModifiers(Button, {
  modSize: modSize3
});

// src/uds/components/Overlays/Overlays.tsx
init_esm_shims();
import { css as css10 } from "styled-components";
function backdropStyles() {
  return css10`
    cursor: default;
    position: fixed;
    background: ${tok("components_backdrop_color")};
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: ${zIndex.level5};
  `;
}

// src/uds/components/AlertWindow/AlertWindow.tsx
import { jsx as jsx52, jsxs as jsxs31 } from "react/jsx-runtime";
var Backdrop = styled9(DialogPrimitive.Overlay)`
  ${backdropStyles()}
`;
var AlertWindowWrapper = styled9(DialogPrimitive.Content)`
  background-color: ${tok("semantics_views_background_color")};
  box-shadow: ${tok("primitives_box_shadows_level_5")};
  z-index: ${zIndex.level6};
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: ${tokPx("semantics_overlays_corner_radius")};
  min-width: ${tokPx("primitives_area_size_240")};
  max-width: ${tokPx("primitives_area_size_480")};
  width: calc(100vw - calc(2 * ${space("primitives_space_56")}));
  padding: ${space("primitives_space_24")};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;
var ActionsWrapper = styled9.div`
  display: flex;
  flex-direction: column;
  gap: ${space("primitives_space_8")};
  width: 100%;
  margin-top: ${space("primitives_space_16")};
  max-width: ${tokPx("primitives_area_size_320")};
`;
var IconStyled = styled9(Icon_default)`
  color: ${tok("primitives_color_warning_400")};
  margin-bottom: ${space("primitives_space_6")};
`;
var AlertWindowTextContainer = styled9.div`
  display: flex;
  flex-direction: column;
  gap: ${space("primitives_space_2")};
`;
var Root4 = DialogPrimitive.Root;
function Trigger3({ children }) {
  return /* @__PURE__ */ jsx52(DialogPrimitive.Trigger, {
    asChild: true,
    children
  });
}
function Content3({
  hasIcon = false,
  text,
  supportingText,
  primaryButtonText,
  secondaryButtonText,
  onPrimaryAction,
  onSecondaryAction
}) {
  return /* @__PURE__ */ jsxs31(DialogPrimitive.Portal, {
    children: [
      /* @__PURE__ */ jsx52(Backdrop, {}),
      /* @__PURE__ */ jsxs31(AlertWindowWrapper, {
        children: [
          hasIcon && /* @__PURE__ */ jsx52(IconStyled, {
            glyph: "ExclamationInTriangle",
            size: 48
          }),
          /* @__PURE__ */ jsxs31(AlertWindowTextContainer, {
            children: [
              /* @__PURE__ */ jsx52(DialogPrimitive.Title, {
                asChild: true,
                children: /* @__PURE__ */ jsx52(Typography_default, {
                  $variant: "body-m-bold-snug",
                  children: text
                })
              }),
              supportingText && /* @__PURE__ */ jsx52(DialogPrimitive.Description, {
                asChild: true,
                children: /* @__PURE__ */ jsx52(Typography_default, {
                  $variant: "body-s-regular-snug",
                  children: supportingText
                })
              })
            ]
          }),
          (primaryButtonText || secondaryButtonText) && /* @__PURE__ */ jsxs31(ActionsWrapper, {
            children: [
              primaryButtonText && /* @__PURE__ */ jsx52(Button_default, {
                $type: "primary",
                onClick: onPrimaryAction,
                children: primaryButtonText
              }),
              secondaryButtonText && /* @__PURE__ */ jsx52(Button_default, {
                $type: "transparentNeutral",
                onClick: onSecondaryAction,
                children: secondaryButtonText
              })
            ]
          })
        ]
      })
    ]
  });
}
var AlertWindow = {
  Root: Root4,
  Trigger: Trigger3,
  Content: Content3
};

// src/uds/components/Badge/index.ts
init_esm_shims();

// src/uds/components/Badge/Badge.tsx
init_esm_shims();
import { styled as styled10 } from "styled-components";
var Badge = styled10(Typography_default).attrs({
  $variant: "body-m-bold-flat",
  as: "span"
})`
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  min-width: ${space("primitives_space_28")};
  height: ${space("primitives_space_28")};
  background: ${tok("primitives_color_neutral_150")};
  border-radius: ${tokPx("primitives_corner_radius_xxl")};
  color: ${tok("primitives_color_neutral_800")};
  display: inline-flex;
  padding: ${space("primitives_space_8")};
`;
Badge.displayName = "Badge";
var Badge_default = Badge;

// src/uds/components/Banner/index.ts
init_esm_shims();

// src/uds/components/Banner/Banner.tsx
init_esm_shims();
import { css as css13, styled as styled14 } from "styled-components";

// src/uds/components/Banner/ActionsWrapper.tsx
init_esm_shims();
import { css as css11, styled as styled11 } from "styled-components";
var ActionsWrapper2 = styled11.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${tokPx("primitives_space_8")};
  margin-left: auto;

  ${({ actionsPosition }) => actionsPosition === "bottom" && css11`
      margin-left: 0;
      flex-direction: row;
      justify-content: flex-start;
    `}
`;

// src/uds/components/Banner/ContentWrapper.tsx
init_esm_shims();
import { css as css12, styled as styled12 } from "styled-components";
var ContentWrapper = styled12.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: ${tokPx("primitives_space_8")};

  ${({ actionsPosition }) => actionsPosition === "right" && css12`
      width: 100%;
    `}
  ${({ actionsPosition }) => actionsPosition === "bottom" && css12`
      flex-direction: column;
    `}
`;
var Content4 = styled12.div`
  display: flex;
  align-items: flex-start;
  gap: ${tokPx("primitives_space_8")};
  ${({ $isCentered = false }) => modCenteredAligned($isCentered)}
`;
function modCenteredAligned($isCentered = false) {
  return $isCentered ? css12`
        align-items: center;
      ` : css12`
      align-items: flex-start;
    `;
}

// src/uds/components/Banner/TextsWrapper.tsx
init_esm_shims();
import { styled as styled13 } from "styled-components";
var TextsWrapper = styled13.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;
var Text = styled13(Typography_default).attrs({ as: "strong" })`
    ${Typography_default.modVariant("body-m-bold-tight")}
`;
var SupportingText = styled13(Typography_default).attrs({ as: "div" })`
    ${Typography_default.modVariant("body-s-regular-tight")}
`;

// src/uds/components/Banner/types.ts
init_esm_shims();
var iconMapping = {
  neutral: "InformationInCircle",
  secondary: "InformationInCircle",
  danger: "ExclamationInCircle",
  warning: "ExclamationInTriangle",
  success: "CheckMarkInCircle"
};

// src/uds/components/Banner/Banner.tsx
import { jsx as jsx53, jsxs as jsxs32 } from "react/jsx-runtime";
var StyledBanner = styled14.div`
  border: 2px solid;
  border-radius: ${tokPx("primitives_corner_radius_l")};
  padding: ${space("primitives_space_12")};

  ${({ $color }) => modType2($color)}

  ${({ display }) => display === "overlay" && css13`
      box-shadow: ${tok("primitives_box_shadows_level_4")};
    `}

  ${({ $size }) => $size === "S" && css13`
      & ${Text} {
        ${Typography_default.modVariant("body-s-bold-tight")}
      }
      & ${SupportingText} {
        ${Typography_default.modVariant("body-xs-regular-tight")}
      }
    `}
`;
var Banner = ({
  color,
  hasIcon,
  display = "inline",
  text,
  supportingText,
  supportingTextHtml,
  size,
  className,
  icon,
  contentIsCentered = false,
  actionsPosition,
  children
}) => {
  const getIconGlyph = () => {
    if ((color === "neutral" || color === "secondary") && icon) {
      return icon;
    }
    return iconMapping[color];
  };
  const iconGlyph = getIconGlyph();
  const isAlert = color === "danger" || color === "warning";
  return /* @__PURE__ */ jsx53(StyledBanner, {
    $color: color,
    $size: size,
    display,
    role: isAlert ? "alert" : "status",
    "aria-live": isAlert ? void 0 : "polite",
    className,
    children: /* @__PURE__ */ jsxs32(Content4, {
      $isCentered: contentIsCentered,
      children: [
        hasIcon && /* @__PURE__ */ jsx53(Icon_default, {
          size: size === "S" ? 24 : 32,
          glyph: iconGlyph,
          "aria-hidden": "true"
        }),
        !children && /* @__PURE__ */ jsx53(ContentWrapper, {
          actionsPosition,
          children: /* @__PURE__ */ jsxs32(TextsWrapper, {
            children: [
              /* @__PURE__ */ jsx53(Text, {
                children: text
              }),
              supportingText && /* @__PURE__ */ jsx53(SupportingText, {
                as: "div",
                dangerouslySetInnerHTML: { __html: supportingText }
              }),
              supportingTextHtml
            ]
          })
        }),
        children
      ]
    })
  });
};
function modType2(color) {
  return {
    neutral: css13`
      background-color: ${tok("primitives_color_neutral_50")};
      border-color: ${tok("primitives_color_neutral_150")};

      & ${Icon_default} {
        color: ${tok("primitives_color_neutral_600")};
      }
    `,
    secondary: css13`
      background-color: ${tok("primitives_color_secondary_50")};
      border-color: ${tok("primitives_color_secondary_150")};

      & ${Icon_default} {
        color: ${tok("primitives_color_secondary_500")};
      }
    `,
    danger: css13`
      background-color: ${tok("primitives_color_danger_50")};
      border-color: ${tok("primitives_color_danger_150")};

      & ${Icon_default} {
        color: ${tok("primitives_color_danger_500")};
      }
    `,
    warning: css13`
      background-color: ${tok("primitives_color_warning_50")};
      border-color: ${tok("primitives_color_warning_150")};

      & ${Icon_default} {
        color: ${tok("primitives_color_warning_500")};
      }
    `,
    success: css13`
      background-color: ${tok("primitives_color_success_50")};
      border-color: ${tok("primitives_color_success_150")};

      & ${Icon_default} {
        color: ${tok("primitives_color_success_500")};
      }
    `
  }[color];
}
Banner.ActionsWrapper = ActionsWrapper2;
Banner.TextsWrapper = TextsWrapper;
Banner.ContentWrapper = ContentWrapper;
Banner.Text = Text;
Banner.SupportingText = SupportingText;
var Banner_default = Banner;

// src/uds/components/Benefits/index.ts
init_esm_shims();

// src/uds/components/Benefits/Benefits.tsx
var Benefits_exports = {};
__export(Benefits_exports, {
  Item: () => Item2,
  Root: () => Root5
});
init_esm_shims();
import { css as css14, styled as styled15 } from "styled-components";
import { jsx as jsx54, jsxs as jsxs33 } from "react/jsx-runtime";
var SuportingText = styled15(Typography_default)`
  color: ${tok("semantics_content_secondary_color")};
`;
var TextWrapper = styled15.div`
  display: flex;
  padding-top: ${tokPx("primitives_space_2")};
  justify-content: center;
  align-items: flex-start;
  flex: 1 0 0;
  flex-direction: column;
  text-wrap: auto;
`;
var ItemWrapper = styled15.div`
  display: flex;
  align-items: flex-start;
  gap: ${tokPx("primitives_space_4")};
  align-self: stretch;
`;
var IconWrapper3 = styled15(Icon_default)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
var Root5 = styled15.ul.attrs(() => ({}))`
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  margin: 0;

  ${({ $type }) => modType3($type)}
  ${({ $align }) => modAlign($align)}
`;
Root5.displayName = "Benefits.Root";
var Item2 = styled15.li.attrs(({ $icon, title, supportingtext }) => ({
  children: /* @__PURE__ */ jsxs33(ItemWrapper, {
    children: [
      /* @__PURE__ */ jsx54(IconWrapper3, {
        glyph: $icon != null ? $icon : "CheckMarkSmall",
        "aria-hidden": true
      }),
      /* @__PURE__ */ jsxs33(TextWrapper, {
        children: [
          /* @__PURE__ */ jsx54(Typography_default, {
            $variant: supportingtext ? "body-m-bold-tight" : "body-m-regular-tight",
            children: title
          }),
          supportingtext && /* @__PURE__ */ jsx54(SuportingText, {
            $variant: "body-s-regular-tight",
            children: supportingtext
          })
        ]
      })
    ]
  })
}))`
  list-style-type: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: list-item;
  list-style-position: inside;

  ${Icon_default} {
    margin-right: ${tokPx("primitives_space_2")};
    vertical-align: text-top;
  }
`;
Item2.displayName = "Benefits.Item";
function modType3(typeName = "vertical") {
  return {
    vertical: css14`
      flex-direction: column;
      ${Item2} {
        &:not(:last-child) {
          margin-bottom: ${tokPx("primitives_space_8")};
          margin-left: ${tokPx("primitives_space_0")};
        }
      }
    `,
    inline: css14`
      gap: ${tokPx("primitives_space_6")} ${tokPx("primitives_space_12")};
      ${Item2} {
        display: flex;
        align-items: flex-start;
        align-content: flex-start;
        flex-wrap: wrap;
      }
    `
  }[typeName];
}
function modAlign(alignName = "left") {
  return {
    left: css14`
      align-items: flex-start;
      align-content: flex-start;
    `,
    center: css14`
      justify-content: center;
      align-items: center;
      align-content: center;
    `,
    right: css14`
      align-items: flex-end;
      align-content: flex-end;
    `
  }[alignName];
}

// src/uds/components/Breadcrumbs/index.ts
init_esm_shims();

// src/uds/components/Breadcrumbs/Breadcrumbs.tsx
init_esm_shims();
import { styled as styled17 } from "styled-components";

// src/uds/components/IconCell/index.ts
init_esm_shims();

// src/uds/components/IconCell/IconCell.tsx
init_esm_shims();
import { styled as styled16 } from "styled-components";
import { jsx as jsx55 } from "react/jsx-runtime";
var iconCellSize = {
  sm: "20px",
  md: "24px",
  lg: "32px"
};
var Wrapper2 = styled16.div`
  display: flex;
  flex-direction: column;
  align-items: ${({ $verticalAlignment }) => $verticalAlignment === "top" ? "flex-start" : "center"};
  width: ${({ $size }) => iconCellSize[$size]};
`;
function IconCell({
  glyph,
  size = "md",
  hidden = false,
  verticalAlignment = "center",
  className
}) {
  return /* @__PURE__ */ jsx55(Wrapper2, {
    className,
    $size: size,
    $verticalAlignment: verticalAlignment,
    children: !hidden && /* @__PURE__ */ jsx55(Icon_default, {
      glyph,
      fullWidth: true
    })
  });
}
var IconCell_default = styled16(IconCell)``;

// src/uds/components/Breadcrumbs/Breadcrumbs.tsx
import { jsx as jsx56, jsxs as jsxs34 } from "react/jsx-runtime";
var Root6 = styled17.nav`
  width: 100%;
  display: flex;
  align-items: center;
`;
var List2 = styled17.ol`
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
`;
var ListItem = styled17.li`
  display: ${({ $isPenultimate }) => $isPenultimate ? "flex" : "none"};
  align-items: center;

  @media ${mqMin("primitives_breakpoint_m_min")} {
    display: flex;
  }
`;
var StyledLink = styled17.a`
  display: flex;
  align-items: center;
  text-decoration: none;
  color: inherit;
  &:hover {
    text-decoration: none;
    color: inherit;
  }
`;
var Separator = styled17(IconCell_default)`
  display: ${({ showOn }) => showOn === "mobile" ? "flex" : "none"};

  @media ${mqMin("primitives_breakpoint_m_min")} {
    display: ${({ showOn }) => showOn === "desktop" ? "flex" : "none"};
  }
`;
var BreadcrumbSeparator = ({ isLast, showOn }) => {
  if (isLast)
    return null;
  return /* @__PURE__ */ jsx56(Separator, {
    glyph: showOn === "mobile" ? "ChevronLeft" : "ChevronRightExtraSmall",
    size: "sm",
    showOn
  });
};
function renderItems(items) {
  const penultimateIdx = items.length - 2;
  const lastIdx = items.length - 1;
  return items.map((item, idx) => {
    const isPenultimate = idx === penultimateIdx;
    const isLast = idx === lastIdx;
    return /* @__PURE__ */ jsxs34(ListItem, {
      $isPenultimate: isPenultimate,
      "aria-current": isLast ? "page" : void 0,
      children: [
        item.href ? /* @__PURE__ */ jsxs34(StyledLink, {
          href: item.href,
          children: [
            isPenultimate && /* @__PURE__ */ jsx56(BreadcrumbSeparator, {
              isLast: false,
              showOn: "mobile"
            }),
            /* @__PURE__ */ jsx56(Typography_default, {
              $variant: "body-m-regular-tight",
              children: item.label
            })
          ]
        }) : /* @__PURE__ */ jsx56(Typography_default, {
          $variant: "body-m-regular-tight",
          as: "span",
          children: item.label
        }),
        /* @__PURE__ */ jsx56(BreadcrumbSeparator, {
          isLast,
          showOn: "desktop"
        })
      ]
    }, item.id);
  });
}
var Breadcrumbs = ({ items }) => {
  return /* @__PURE__ */ jsx56(Root6, {
    "aria-label": "Breadcrumb",
    children: /* @__PURE__ */ jsx56(List2, {
      children: renderItems(items)
    })
  });
};
var Breadcrumbs_default = Breadcrumbs;

// src/uds/components/Card/index.ts
init_esm_shims();

// src/uds/components/Card/Card.tsx
init_esm_shims();
import { styled as styled18 } from "styled-components";
import { jsx as jsx57, jsxs as jsxs35 } from "react/jsx-runtime";
var CardContainer = styled18.a`
  display: flex;
  gap: ${space("primitives_space_12")};
  background-color: ${tok("semantics_views_background_color")};
  box-shadow: ${tok("primitives_box_shadows_level_2")};
  padding: ${space("primitives_space_8")};
  border-radius: ${tokPx("primitives_corner_radius_l")};
  max-width: ${tokPx("primitives_area_size_640")};
  text-decoration: none;

  &:hover {
    color: inherit;
  }
`;
var ImageContainer = styled18.div`
  width: ${space("primitives_space_80")};
  height: ${space("primitives_space_80")};
  flex-shrink: 0;
  background-color: ${tok("semantics_views_tinted_background_color")};
  border-radius: ${tokPx("primitives_corner_radius_s")};
  overflow: hidden;
`;
var Image = styled18.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
var Content5 = styled18.div`
  flex: 1;
`;
var Title2 = styled18(Typography_default)`
  font-weight: bold;
`;
var Subtitle = styled18(Typography_default)`
  color: ${tok("semantics_content_secondary_color")};
  margin-top: ${space("primitives_space_2")};
`;
var Date2 = styled18(Typography_default)`
  margin-top: ${space("primitives_space_4")};
`;
function Card({ title, subtitle, date, mediaSrc, href }) {
  return /* @__PURE__ */ jsxs35(CardContainer, {
    href,
    children: [
      mediaSrc && /* @__PURE__ */ jsx57(ImageContainer, {
        children: /* @__PURE__ */ jsx57(Image, {
          src: mediaSrc,
          alt: title || ""
        })
      }),
      /* @__PURE__ */ jsxs35(Content5, {
        children: [
          /* @__PURE__ */ jsx57(Title2, {
            as: "div",
            $variant: "display-i-regular",
            children: title
          }),
          subtitle && /* @__PURE__ */ jsx57(Subtitle, {
            as: "div",
            $variant: "body-s-regular-tight",
            children: subtitle
          }),
          date && /* @__PURE__ */ jsx57(Date2, {
            as: "div",
            $variant: "body-s-bold-tight",
            children: date
          })
        ]
      })
    ]
  });
}

// src/uds/components/Carousel/index.ts
init_esm_shims();

// src/uds/components/Carousel/Carousel.tsx
init_esm_shims();
import useEmblaCarousel from "embla-carousel-react";
import { useCallback, useEffect as useEffect2, useState as useState2 } from "react";
import { styled as styled20 } from "styled-components";

// src/uds/components/IconButton/index.ts
init_esm_shims();

// src/uds/components/IconButton/IconButton.tsx
init_esm_shims();
import { css as css15, styled as styled19 } from "styled-components";
import { jsx as jsx58, jsxs as jsxs36 } from "react/jsx-runtime";
var baseIconSizes = {
  M: 24,
  S: 20,
  XS: 16
};
var transparentIconSizes = {
  M: 32,
  S: 24,
  XS: 20
};
var sizeStyles = {
  M: css15`
    min-height: ${tokPx("semantics_controls_m_min_height")};
    min-width: ${tokPx("semantics_controls_m_min_height")};
    border-radius: ${tokPx("semantics_buttons_m_corner_radius")};
  `,
  S: css15`
    min-height: ${tokPx("semantics_controls_s_min_height")};
    min-width: ${tokPx("semantics_controls_s_min_height")};
    border-radius: ${tokPx("semantics_buttons_s_corner_radius")};
  `,
  XS: css15`
    min-height: ${tokPx("semantics_controls_xs_min_height")};
    min-width: ${tokPx("semantics_controls_xs_min_height")};
    border-radius: ${tokPx("semantics_buttons_xs_corner_radius")};
  `
};
var Button2 = styled19.button`
  border: none;
  text-decoration: none;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  gap: ${tokPx("primitives_space_2")};

  ${({ type, size }) => modType4(type, size)};
  ${({ disabled }) => disabled && modDisabled3()};
  ${focusOutline()}
`;
var IconWrapper4 = styled19.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  ${({ size = "M" }) => sizeStyles[size]};
`;
var TitleText = styled19(Typography_default)`
  text-align: center;
  max-width: ${tokPx("primitives_area_size_120")};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
function IconButton({ glyph, type, size, onClick, className, title, disabled, ariaLabel }) {
  return /* @__PURE__ */ jsxs36(Button2, {
    className,
    onClick,
    type,
    size,
    disabled,
    "aria-label": ariaLabel,
    children: [
      /* @__PURE__ */ jsx58(IconWrapper4, {
        size,
        children: /* @__PURE__ */ jsx58(Icon_default, {
          glyph
        })
      }),
      title && /* @__PURE__ */ jsx58(TitleText, {
        $variant: "body-xs-regular-tight",
        children: title
      })
    ]
  });
}
function modSize4(sizeName = "M") {
  return css15`
    ${IconWrapper4} {
      ${sizeStyles[sizeName]}
    }
  `;
}
function modType4(type = "overlay-neutral", size = "M") {
  const iconSizes2 = type === "transparent-neutral" ? transparentIconSizes : baseIconSizes;
  return {
    "overlay-neutral": css15`
      ${IconWrapper4} {
        background-color: ${tok("semantics_buttons_overlay_neutral_background_color")};
        color: ${tok("semantics_buttons_overlay_neutral_content_color")};

        ${Icon_default} {
          ${Icon_default.modSize(iconSizes2[size])}
        }
      }

      &:hover ${IconWrapper4} {
        color: ${tok("semantics_buttons_overlay_neutral_hover_content_color")};
      }
    `,
    "transparent-neutral": css15`
      ${IconWrapper4} {
        background-color: transparent;
        color: ${tok("semantics_buttons_transparent_neutral_content_color")};

        ${Icon_default} {
          ${Icon_default.modSize(iconSizes2[size])}
        }
      }

      &:hover ${IconWrapper4} {
        color: ${tok("semantics_buttons_transparent_neutral_hover_content_color")};
      }
    `,
    "secondary": css15`
      ${IconWrapper4} {
        background-color: ${tok("semantics_buttons_secondary_background_color")};
        color: ${tok("semantics_buttons_secondary_content_color")};

        ${Icon_default} {
          ${Icon_default.modSize(iconSizes2[size])}
        }
      }

      &:hover ${IconWrapper4} {
        background-color: ${tok("semantics_buttons_secondary_hover_background_color")};
      }
    `
  }[type];
}
function modDisabled3() {
  return css15`
    opacity: ${tok("primitives_opacity_disabled")}%;
    pointer-events: none;
  `;
}
var StyledIconButton = withStyleModifiers(styled19(IconButton)``, {
  modSize: modSize4
});
StyledIconButton.displayName = "IconButton";
var IconButton_default = StyledIconButton;

// src/uds/components/Carousel/useCarouselItemsInView.ts
init_esm_shims();
import { createContext as createContext2, useContext as useContext2 } from "react";
var EmblaCarouselContext = createContext2([]);
function useCarouselItemsInView(ref) {
  const context = useContext2(EmblaCarouselContext);
  return {
    isVisibleItem: Boolean(context.find((item) => item === ref.current))
  };
}

// src/uds/components/Carousel/Carousel.tsx
import { jsx as jsx59, jsxs as jsxs37 } from "react/jsx-runtime";
var Container = styled20.div`
  width: 100%;
  overflow: hidden;
`;
var ItemsWrapper = styled20.div`
  display: flex;
  gap: ${space("primitives_space_24")};

  > :last-child {
    margin-right: ${space("primitives_space_24")};
  }
`;
var ButtonsWrapper = styled20.div`
  display: flex;
  width: fit-content;
  margin-left: auto;
  align-items: center;
  gap: ${space("primitives_space_12")};
  padding: ${space("primitives_space_8")};
  border-radius: ${tokPx("components_carousel_controls_area_corner_radius")};
  border: ${tokPx("semantics_dividers_tickness")} solid ${tok("semantics_dividers_color")};
  background-color: ${tok("semantics_views_background_color")};
  margin-top: ${space("primitives_space_16")};
`;
var OPTIONS = { dragFree: true, loop: false, startIndex: 0, align: "start" };
function Carousel({ hasControls, children, prevButtonAriaLabel, nextButtonAriaLabel }) {
  const [emblaRef, emblaApi] = useEmblaCarousel(OPTIONS);
  const [lazyLoadedSlides, setLazyLoadedSlides] = useState2([]);
  const [prevBtnDisabled, setPrevBtnDisabled] = useState2(true);
  const [nextBtnDisabled, setNextBtnDisabled] = useState2(true);
  const inViewHandler = useCallback(() => {
    if (!emblaApi) {
      return;
    }
    const slides = emblaApi.slideNodes();
    const slidesInView = emblaApi.slidesInView();
    const items = slidesInView.map((slide) => slides[slide]);
    const newLazyLoadedSlides = Array.from(/* @__PURE__ */ new Set([...lazyLoadedSlides, ...items]));
    if (slides.length === newLazyLoadedSlides.length) {
      emblaApi.off("slidesInView", inViewHandler);
    }
    setLazyLoadedSlides(newLazyLoadedSlides);
  }, [emblaApi, lazyLoadedSlides]);
  const onSelect = useCallback((emblaApi2) => {
    setPrevBtnDisabled(!emblaApi2.canScrollPrev());
    setNextBtnDisabled(!emblaApi2.canScrollNext());
  }, []);
  useEffect2(() => {
    if (!emblaApi || emblaApi.slideNodes().length === lazyLoadedSlides.length) {
      return;
    }
    emblaApi.on("slidesInView", inViewHandler);
    onSelect(emblaApi);
    emblaApi.on("reInit", onSelect).on("select", onSelect);
    return () => {
      emblaApi.off("slidesInView", inViewHandler);
    };
  }, [emblaApi, inViewHandler, lazyLoadedSlides.length, onSelect]);
  return /* @__PURE__ */ jsx59(EmblaCarouselContext.Provider, {
    value: lazyLoadedSlides,
    children: /* @__PURE__ */ jsxs37(Container, {
      children: [
        /* @__PURE__ */ jsx59("div", {
          ref: emblaRef,
          children: /* @__PURE__ */ jsx59(ItemsWrapper, {
            children
          })
        }),
        hasControls && /* @__PURE__ */ jsxs37(ButtonsWrapper, {
          children: [
            /* @__PURE__ */ jsx59(IconButton_default, {
              onClick: () => emblaApi == null ? void 0 : emblaApi.scrollPrev(),
              glyph: "ChevronLeft",
              type: "secondary",
              size: "S",
              disabled: prevBtnDisabled,
              ariaLabel: prevButtonAriaLabel
            }),
            /* @__PURE__ */ jsx59(IconButton_default, {
              onClick: () => emblaApi == null ? void 0 : emblaApi.scrollNext(),
              glyph: "ChevronRight",
              type: "secondary",
              size: "S",
              disabled: nextBtnDisabled,
              ariaLabel: nextButtonAriaLabel
            })
          ]
        })
      ]
    })
  });
}

// src/uds/components/Checkbox/index.ts
init_esm_shims();

// src/uds/components/Checkbox/Checkbox.tsx
init_esm_shims();
import * as RadixCheckbox from "@radix-ui/react-checkbox";
import { styled as styled21 } from "styled-components";
import { jsx as jsx60, jsxs as jsxs38 } from "react/jsx-runtime";
var IconCheck = styled21(Icon_default)``;
var IconIndeterminate = styled21(Icon_default)``;
var IndicatorIcon = styled21.div`
  position: relative;

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  ${IconCheck}, ${IconIndeterminate} {
    display: none;
  }

  &[data-state='checked'] {
    ${IconCheck} {
      display: block;
    }
  }

  &[data-state='indeterminate'] {
    ${IconIndeterminate} {
      display: block;
    }
  }
`;
var CheckboxElement = styled21(RadixCheckbox.Root)`
  width: 20px;
  height: 20px;
  background-color: ${tok("semantics_views_background_color")};
  border: 2px solid ${tok("semantics_selectors_shape_color")};
  border-radius: ${tokPx("primitives_corner_radius_s")};
  box-sizing: border-box;

  &[data-state='checked'],
  &[data-state='indeterminate'] {
    background-color: ${tok("semantics_selectors_selected_background_color")};
    color: ${tok("semantics_selectors_selected_content_color")};
    border: none;
  }

  //Hover State
  &:hover {
    &:not([data-state='checked']):not(:disabled),
    &:not([data-state='indeterminate']):not(:disabled) {
      border-color: ${tok("semantics_selectors_hover_shape_color")};
    }

    &[data-state='checked']:not(:disabled),
    &[data-state='indeterminate']:not(:disabled) {
      background-color: ${tok("semantics_selectors_selected_hover_background_color")};
    }
  }

  //Disabled State
  &:disabled {
    opacity: ${tok("primitives_opacity_disabled")}%;
  }

  //Focus State
  ${focusOutline()}
`;
function CheckboxComponent({ checked, defaultChecked, onCheckedChange, ...rest }) {
  return /* @__PURE__ */ jsx60(CheckboxElement, {
    checked,
    defaultChecked,
    onCheckedChange,
    ...rest,
    children: /* @__PURE__ */ jsx60(RadixCheckbox.Indicator, {
      asChild: true,
      children: /* @__PURE__ */ jsxs38(IndicatorIcon, {
        children: [
          /* @__PURE__ */ jsx60(IconIndeterminate, {
            glyph: "MinusExtraSmall",
            size: 24
          }),
          /* @__PURE__ */ jsx60(IconCheck, {
            glyph: "CheckMarkExtraSmall",
            size: 24
          })
        ]
      })
    })
  });
}
var Checkbox = styled21(CheckboxComponent)``;

// src/uds/components/ContentPosition.ts
init_esm_shims();

// src/uds/components/ContentUnavailable/index.ts
init_esm_shims();

// src/uds/components/ContentUnavailable/ContentUnavailable.tsx
init_esm_shims();
import { css as css16, styled as styled22 } from "styled-components";
import { jsx as jsx61, jsxs as jsxs39 } from "react/jsx-runtime";
var Container2 = styled22.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  max-width: ${tokPx("primitives_area_size_480")};
`;
var Title3 = styled22(Typography_default)`
  ${Typography_default.modVariant("body-m-bold-snug")};

  @media ${mqMin("primitives_breakpoint_m_min")} {
    ${Typography_default.modVariant("body-l-bold-snug")};
  }
`;
var Subtitle2 = styled22(Typography_default)`
  ${Typography_default.modVariant("body-s-regular-snug")};

  @media ${mqMin("primitives_breakpoint_m_min")} {
    ${Typography_default.modVariant("body-m-regular-snug")};
  }
`;
var IconStyled2 = styled22(Icon_default)`
  margin-bottom: ${tokPx("primitives_space_4")};

  @media ${mqMin("primitives_breakpoint_m_min")} {
    margin-bottom: ${tokPx("primitives_space_6")};
  }

    & > svg {
    height: ${tokPx("primitives_space_32")};
    width: ${tokPx("primitives_space_32")};

    @media ${mqMin("primitives_breakpoint_m_min")} {
      height: ${tokPx("primitives_space_48")};
      width: ${tokPx("primitives_space_48")};
    }

    ${({ $isAlert }) => $isAlert && css16`
    color: ${tok("primitives_color_warning_400")};
  `}
  }
`;
function ContentUnavailable({ icon, text, supportingText, type }) {
  const isAlert = type === "alert";
  const glyph = isAlert ? "ExclamationInTriangle" : icon;
  return /* @__PURE__ */ jsxs39(Container2, {
    role: isAlert ? "alert" : void 0,
    "aria-live": isAlert ? "assertive" : void 0,
    children: [
      glyph && /* @__PURE__ */ jsx61(IconStyled2, {
        glyph,
        $isAlert: isAlert,
        "aria-hidden": "true"
      }),
      /* @__PURE__ */ jsx61(Title3, {
        children: text
      }),
      supportingText && /* @__PURE__ */ jsx61(Subtitle2, {
        children: supportingText
      })
    ]
  });
}
var ContentUnavailable_default = ContentUnavailable;

// src/uds/components/DatePicker/index.ts
init_esm_shims();

// src/uds/components/DatePicker/DatePicker.tsx
init_esm_shims();
import { da, de, enGB, fr, nl, sv } from "date-fns/locale";
import * as RDP from "react-datepicker";
import { css as css17, styled as styled23 } from "styled-components";
import { jsx as jsx62, jsxs as jsxs40 } from "react/jsx-runtime";
var ReactDatePicker = RDP.default.default || RDP.default || RDP;
var map = {
  "nl-NL": nl,
  "da-DK": da,
  "sv-SE": sv,
  "fr-FR": fr,
  "de-DE": de,
  "en-GB": enGB,
  "nl-BE": nl,
  "fr-BE": fr
};
var BREAKPOINT_DATEPICKER_SMALL = "max-width: 375px";
var StyledDatePickerHeader = styled23.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: ${space("primitives_space_24")};
  text-transform: capitalize;

  ${IconButton_default} {
    display: inline-flex;
    position: absolute;
    left: 0;
  }

  ${Typography_default} + ${IconButton_default} {
    left: auto;
    right: 0;
  }
`;
var StyledDatePicker = styled23.div`
  .react-datepicker {
    display: flex;
    flex-wrap: wrap;
    gap: ${space("primitives_space_48")};
    justify-content: center;
  }

  .react-datepicker__triangle {
    display: none;
  }

  .react-datepicker__aria-live {
    position: absolute;
    clip-path: circle(0);
    border: 0;
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    width: 1px;
    white-space: nowrap;
  }

  .react-datepicker__day-names {
    display: flex;
    gap: ${space("primitives_space_8")};
    margin-bottom: ${space("primitives_space_16")};
    text-transform: capitalize;
    white-space: nowrap;

    @media (${BREAKPOINT_DATEPICKER_SMALL}) {
      gap: ${space("primitives_space_4")};
    }
  }

  .react-datepicker__day-name {
    flex: 1;
    min-width: 40px;
    height: 21px;
    margin: 0;
    ${Typography_default.modVariant("body-s-bold-snug")}
    color: ${tok("semantics_content_secondary_color")};
    text-align: center;

    ${({ $showWeekNumbers }) => $showWeekNumbers && css17`
        &:first-child {
          position: relative;

          &::after {
            content: '';
            border-right: 1px solid ${tok("semantics_boxes_border_color")};
            height: 100%;
            position: absolute;
            right: 0;
          }
        }
      `}
  }

  .react-datepicker__month {
    display: flex;
    flex-direction: column;
    gap: ${space("primitives_space_8")};

    @media (${BREAKPOINT_DATEPICKER_SMALL}) {
      gap: ${space("primitives_space_4")};
    }
  }

  .react-datepicker__week {
    gap: ${space("primitives_space_8")};

    @media (${BREAKPOINT_DATEPICKER_SMALL}) {
      gap: ${space("primitives_space_4")};
    }
  }

  .react-datepicker__week-number {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    min-width: 40px;
    height: 40px;
    line-height: 40px;
    margin: 0;
    pointer-events: none;
    ${Typography_default.modVariant("body-s-regular-snug")};
    color: ${tok("semantics_content_secondary_color")};
    position: relative;

    &::after {
      content: '';
      border-right: 1px solid ${tok("semantics_boxes_border_color")};
      height: calc(100% + ${space("primitives_space_16")});
      position: absolute;
      right: 0;
      bottom: 0;
    }

    &:last-child::after {
      height: 100%;
    }
  }

  .react-datepicker__day {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    min-width: 48px;
    height: 40px;
    line-height: 40px;
    margin: 0;
    border-radius: ${tokPx("primitives_corner_radius_full")};
    cursor: pointer;
    ${focusOutline()};
    span {
      z-index: 1;
    }
    @media (${BREAKPOINT_DATEPICKER_SMALL}) {
      min-width: 44px;
    }

    &.react-datepicker__day--keyboard-selected {
      background-color: transparent;
    }

    &:hover {
      background-color: unset;
      position: relative;
      &::after {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: ${tok("primitives_color_neutral_100")};
        border-radius: ${tokPx("primitives_corner_radius_full")};
        max-width: 40px;
      }
    }
    &:hover.react-datepicker__day--keyboard-selected {
      background-color: ${tok("primitives_color_neutral_100")};
    }

    &.react-datepicker__day--outside-month {
      pointer-events: none;
      opacity: 0;
    }

    &.react-datepicker__day--disabled {
      cursor: default;
      color: ${tok("semantics_content_color")};
      opacity: ${tok("primitives_opacity_disabled")}%;
      ${Typography_default} {
        text-decoration: line-through;
      }

      &:hover,
      &:focus,
      &:focus-visible,
      &.react-datepicker__day--keyboard-selected {
        box-shadow: none;
      }
    }

    &.react-datepicker__day--in-range {
      color: ${tok("primitives_color_neutral_800")};
      background-color: ${tok("primitives_color_selected_50")};
      border-radius: 0;
      border: solid ${tok("primitives_color_selected_450")};
      border-width: 2px 0;
      &.react-datepicker__day--disabled {
        opacity: unset;
        span {
          opacity: 38%;
        }
        &.react-datepicker__day--outside-month {
          opacity: 0;
        }
      }
    }
    &.react-datepicker__day--selected {
      color: ${tok("semantics_selectors_selected_content_color")};
      position: relative;
      &::after {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: ${tok("primitives_color_selected_500")};
        border: 1px solid ${tok("primitives_color_selected_600")};
        border-radius: ${tokPx("primitives_corner_radius_full")};
        max-width: 40px;
      }
    }
    &.react-datepicker__day--range-start {
      border-radius: ${tokPx("primitives_corner_radius_full")} 0 0 ${tokPx("primitives_corner_radius_full")};
      min-width: 48px;
      border-left: 2px solid ${tok("primitives_color_selected_600")};
      @media (${BREAKPOINT_DATEPICKER_SMALL}) {
        min-width: 44px;
      }
      span {
        position: relative;
        right: 0;
      }
      &::after {
        right: ${space("primitives_space_4")};
      }
    }

    &.react-datepicker__day--range-end {
      border-radius: 0 ${tokPx("primitives_corner_radius_full")} ${tokPx("primitives_corner_radius_full")} 0;   //0 24px 24px 0;
      min-width: 48px;
      @media (${BREAKPOINT_DATEPICKER_SMALL}) {
        min-width: 44px;
      }
      border-right: 2px solid ${tok("primitives_color_selected_600")};
      span {
        position: relative;
        left: 0;
      }
      &::after {
        left: ${space("primitives_space_4")};
      }
    }
  }
`;
function DatePickerHeader(props) {
  const isFirstShownMonth = props.customHeaderCount === 0;
  return /* @__PURE__ */ jsxs40(StyledDatePickerHeader, {
    children: [
      isFirstShownMonth && /* @__PURE__ */ jsx62(IconButton_default, {
        glyph: "ChevronLeft",
        size: "S",
        type: "secondary",
        onClick: () => props.decreaseMonth(),
        disabled: props.prevMonthButtonDisabled,
        "aria-label": props.previousMonthAriaLabel
      }),
      /* @__PURE__ */ jsx62(Typography_default, {
        $variant: "body-m-bold-tight",
        as: "p",
        children: props.monthDate.toLocaleDateString(props.localeString, { month: "long", year: "numeric" })
      }),
      (!isFirstShownMonth || props.monthsShown === 1) && /* @__PURE__ */ jsx62(IconButton_default, {
        glyph: "ChevronRight",
        size: "S",
        type: "secondary",
        onClick: () => props.increaseMonth(),
        disabled: props.nextMonthButtonDisabled,
        "aria-label": props.nextMonthAriaLabel
      })
    ]
  });
}
function DatePickerDay({ dayOfMonth }) {
  return /* @__PURE__ */ jsx62(Typography_default, {
    $variant: "body-s-bold-snug",
    children: dayOfMonth
  });
}
function DatePicker({
  availableDates,
  selectedDate,
  locale,
  setSelectedDate,
  nextMonthAriaLabel,
  previousMonthAriaLabel,
  startDate,
  endDate,
  numberOfMonths = 2,
  showWeekNumbers,
  weekLabel = "Wk",
  ...attributes
}) {
  RDP.registerLocale(locale, map[locale]);
  const onChange = (date) => {
    setSelectedDate(getLocaleDateString(date));
  };
  return /* @__PURE__ */ jsx62(StyledDatePicker, {
    ...attributes,
    $showWeekNumbers: showWeekNumbers,
    children: /* @__PURE__ */ jsx62(ReactDatePicker, {
      selected: selectedDate ? new Date(selectedDate) : void 0,
      startDate: startDate ? new Date(startDate) : void 0,
      endDate: endDate ? new Date(endDate) : void 0,
      includeDates: availableDates.map((date) => new Date(date)),
      onChange,
      monthsShown: numberOfMonths,
      inline: true,
      showWeekNumbers: Boolean(showWeekNumbers),
      renderCustomHeader: (props) => /* @__PURE__ */ jsx62(DatePickerHeader, {
        ...props,
        monthsShown: numberOfMonths,
        localeString: locale,
        nextMonthAriaLabel,
        previousMonthAriaLabel
      }),
      renderDayContents: (dayOfMonth) => /* @__PURE__ */ jsx62(DatePickerDay, {
        dayOfMonth
      }),
      locale,
      weekLabel
    })
  });
}
DatePicker.modSize = (minWidth) => {
  switch (minWidth) {
    case "desktop":
      return css17`
        .react-datepicker__month {
          width: auto;
        }
      `;
    case "tablet":
      return css17`
        .react-datepicker__month {
          width: 424px;
        }
      `;
    default:
      return css17``;
  }
};

// src/uds/components/DatePicker/MonthPicker.tsx
init_esm_shims();
import { isAfter as isAfter2, isBefore as isBefore2, isFirstDayOfMonth, isLastDayOfMonth } from "date-fns";
import { styled as styled24 } from "styled-components";
import { jsx as jsx63, jsxs as jsxs41 } from "react/jsx-runtime";
var StyledWrapper = styled24.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${space("primitives_space_8")};

  @media ${mqMin("primitives_breakpoint_m_min")} {
    grid-template-columns: repeat(auto-fit, minmax(7rem, 1fr));
  }
`;
var ContentWrapper2 = styled24.div`
  position: relative;
`;
var StyledLabel = styled24.label`
  color: ${tok("semantics_content_color")};
  align-items: center;
  background-color: ${tok("semantics_selectors_background_color")};
  border: 2px solid ${tok("semantics_selectors_border_color")};
  border-radius: ${tokPx("primitives_corner_radius_l")};
  display: flex;
  flex: 1 0 0;
  height: 8rem;
  justify-content: center;
  padding: ${space("primitives_space_24")} ${space("primitives_space_8")};
  text-align: center;

  & > div {
    display: flex;
    flex-direction: column;
  }

  &:hover {
    border-color: ${tok("semantics_selectors_hover_border_color")};
    background-color: ${tok("semantics_selectors_hover_background_color")};
  }
`;
var StyledYear = styled24(Typography_default)`
  color: ${tok("semantics_content_color")};
`;
var HiddenRadio = styled24.input`
  left: 0;
  visibility: hidden;
  position: absolute;
  top: 0;

  &:checked + ${StyledLabel} {
    color: ${tok("semantics_selectors_selected_content_color")};
    background-color: ${tok("semantics_selectors_selected_background_color")};

    ${StyledYear} {
      color: ${tok("semantics_selectors_selected_content_color")};
    }

    &:hover {
      color: ${tok("semantics_selectors_selected_hover_content_color")};
      background: ${tok("semantics_selectors_selected_hover_background_color")};

      ${StyledYear} {
        color: ${tok("semantics_selectors_selected_hover_content_color")};
      }
    }
  }

  &:disabled + ${StyledLabel} {
    opacity: ${tok("primitives_opacity_disabled")};
  }

  &:not(:disabled) + ${StyledLabel} {
    cursor: pointer;
  }
`;
function MonthPicker({
  name,
  className,
  availableDates,
  locale,
  maxDateString,
  minDateString,
  selectedMonth,
  setSelectedDates
}) {
  const monthList = getMonthList(locale);
  const onChange = (e) => {
    const { value } = e.target;
    const lastDayOfMonth2 = getLastDayOfMonth(value);
    const lastDayOfMonthString = getLocaleDateString(getLastDayOfMonth(value));
    const isStartDateBeforeMinDate = minDateString && isBefore2(new Date(value), new Date(minDateString));
    const isEndDateAfterMaxDate = maxDateString && isAfter2(lastDayOfMonth2, new Date(maxDateString));
    const startDate = isStartDateBeforeMinDate ? minDateString : value;
    const endDate = isEndDateAfterMaxDate ? maxDateString : lastDayOfMonthString;
    const isStartDateAfterMinDate = minDateString && isAfter2(new Date(startDate), new Date(minDateString));
    const isEndDateBeforeMaxDate = maxDateString && isBefore2(new Date(endDate), new Date(maxDateString));
    const startDateToSet = isStartDateAfterMinDate ? getLocaleDateString(getFirstDayOfMonth(endDate)) : startDate;
    const endDateToSet = isEndDateBeforeMaxDate ? getLocaleDateString(getLastDayOfMonth(startDate)) : endDate;
    const areStartDateAndEndDateEqual = startDateToSet === endDateToSet;
    setSelectedDates(areStartDateAndEndDateEqual ? startDateToSet : [startDateToSet, endDateToSet]);
  };
  function areFirstAndLastDaySelected(dates, month) {
    if (!dates || !Array.isArray(dates))
      return false;
    const [firstDay, lastDay] = dates;
    return (isFirstDayOfMonth(new Date(firstDay)) || minDateString === firstDay) && (isLastDayOfMonth(new Date(lastDay)) || maxDateString === lastDay) && getMonthFromDateString(firstDay, locale) === month;
  }
  function isMonthDisabled(firstDay, lastDay) {
    return !availableDates.some((date) => {
      const parsedDate = new Date(date);
      return parsedDate >= firstDay && parsedDate <= lastDay;
    });
  }
  return /* @__PURE__ */ jsx63(StyledWrapper, {
    className,
    children: monthList.map(({ date, firstDay, lastDay, month, year }, index) => {
      return /* @__PURE__ */ jsxs41(ContentWrapper2, {
        children: [
          /* @__PURE__ */ jsx63(HiddenRadio, {
            type: "radio",
            name,
            id: `${name}-${index}`,
            value: date,
            onChange,
            defaultChecked: areFirstAndLastDaySelected(selectedMonth, month),
            disabled: isMonthDisabled(firstDay, lastDay)
          }),
          /* @__PURE__ */ jsx63(StyledLabel, {
            htmlFor: `${name}-${index}`,
            children: /* @__PURE__ */ jsxs41("div", {
              children: [
                /* @__PURE__ */ jsx63(Typography_default, {
                  $variant: "body-m-bold-loose",
                  children: month.charAt(0).toUpperCase() + month.slice(1)
                }),
                /* @__PURE__ */ jsx63(StyledYear, {
                  children: year
                })
              ]
            })
          })
        ]
      }, `${name}-${index}`);
    })
  });
}

// src/uds/components/Dropdown/index.ts
init_esm_shims();

// src/uds/components/Dropdown/Dropdown.tsx
var Dropdown_exports = {};
__export(Dropdown_exports, {
  Content: () => Content7,
  EmptyValueItem: () => EmptyValueItem,
  Item: () => Item4,
  Root: () => Root11,
  Trigger: () => Trigger5
});
init_esm_shims();
import * as Select from "@radix-ui/react-select";
import React from "react";
import { styled as styled28 } from "styled-components";

// src/uds/components/Fields/BaseField.tsx
init_esm_shims();
import { css as css19, styled as styled26 } from "styled-components";

// src/uds/components/Fields/FormField.tsx
init_esm_shims();
import { css as css18, styled as styled25 } from "styled-components";
import { jsx as jsx64, jsxs as jsxs42 } from "react/jsx-runtime";
var FeedbackText = styled25(Typography_default)`
  display: block;
  color: ${tok("semantics_content_danger_color")};
  :not(:last-child) {
    padding-bottom: ${space("primitives_space_2")};
  }
`;
var Label = styled25(Typography_default)`
  padding-bottom: ${space("primitives_space_4")};
  display: block;
  color: ${tok("semantics_content_color")};
`;
var HelpText = styled25(Typography_default)`
  display: block;
  vertical-align: middle;
  color: ${tok("semantics_content_color")};
`;
var FormFieldWrapper = styled25.label`
  ${Label}, ${FeedbackText}, ${HelpText} {
    ${({ $disabled }) => $disabled && css18`opacity: ${tok("primitives_opacity_disabled")}%;`}
  }
`;
function FormField({ children, disabled, status, label, helpText, feedbackText }) {
  return /* @__PURE__ */ jsxs42(FormFieldWrapper, {
    $disabled: disabled,
    children: [
      label && /* @__PURE__ */ jsx64(Label, {
        $variant: "body-m-regular-tight",
        children: label
      }),
      children,
      feedbackText && status === "error" ? /* @__PURE__ */ jsx64(FeedbackText, {
        $variant: "body-s-regular-tight",
        children: feedbackText
      }) : null,
      helpText ? /* @__PURE__ */ jsx64(HelpText, {
        $variant: "body-s-regular-tight",
        children: helpText
      }) : null
    ]
  });
}

// src/uds/components/Fields/BaseField.tsx
import { jsx as jsx65 } from "react/jsx-runtime";
function ValidationIcon({ status, className }) {
  if (status === "default") {
    return null;
  }
  return /* @__PURE__ */ jsx65(Icon_default, {
    size: 20,
    className,
    glyph: status === "error" ? "ExclamationInCircle" : "CheckMarkInCircle"
  });
}
var StyledValidationIcon = styled26(ValidationIcon)`
  & > svg {
    width: ${space("primitives_space_20")};
    height: ${space("primitives_space_20")};
  }
`;
var BaseFieldWrapper = styled26.div`
  display: flex;
  align-items: center;
  background: ${tok("semantics_input_fields_background_color")};
  border: solid 2px ${tok("semantics_input_fields_border_color")};
  border-radius: ${tokPx("semantics_controls_m_corner_radius")};
  height: ${tokPx("semantics_controls_m_min_height")};
  position: relative;
  cursor: pointer;
  margin-bottom: ${space("primitives_space_2")};
  overflow: hidden;

  &:hover {
    border-color: ${tok("semantics_input_fields_hover_border_color")};
  }

  ${StyledValidationIcon} {
    ${({ status }) => status === "error" && css19`
        color: ${tok("semantics_input_fields_invalid_icon_color")};
      `}
    ${({ status }) => status === "success" && css19`
        color: ${tok("semantics_input_fields_valid_icon_color")};
      `}
  }

  ${focusWithinOutline()}
  ${({ disabled }) => disabled && modDisabled4()}
  ${({ status }) => status === "error" && modError()}
  ${({ status }) => status === "success" && modSuccess()}
`;
function BaseField({
  disabled,
  status,
  className,
  label,
  helpText,
  feedbackText,
  attributes,
  children
}) {
  const wrapper = /* @__PURE__ */ jsx65(BaseFieldWrapper, {
    className,
    disabled,
    status,
    ...attributes,
    children
  });
  if (label || helpText || feedbackText) {
    return /* @__PURE__ */ jsx65(FormField, {
      disabled,
      label,
      helpText,
      feedbackText,
      status,
      children: wrapper
    });
  }
  return wrapper;
}
function modDisabled4() {
  return css19`
  border-color: ${tok("semantics_input_fields_border_color")};
  box-shadow: none;
  pointer-events: none;
  cursor: default;
  opacity: ${tok("primitives_opacity_disabled")}%;
`;
}
function modError() {
  return css19`
  border-color: ${tok("semantics_input_fields_invalid_border_color")};
  &:hover {
    border-color: ${tok("semantics_input_fields_invalid_hover_border_color")};
  }
`;
}
function modSuccess() {
  return css19`
  border-color: ${tok("semantics_input_fields_valid_border_color")};
  &:hover {
    border-color: ${tok("semantics_input_fields_valid_hover_border_color")};
  }
`;
}
function inputStyles() {
  return css19`
    width: 100%;
  cursor: pointer;
  background: transparent;
  ${Typography_default.modVariant("body-m-regular-tight")}
  color: ${tok("semantics_content_color")};
  margin: 0;
  border: none;
  text-overflow: ellipsis;
  padding-left: ${space("primitives_space_16")};
  padding-top: ${space("primitives_space_12")};
  padding-bottom: ${space("primitives_space_12")};

  &:focus {
    border-color: transparent;
    outline: none;
  }

  &::placeholder {
    color: ${tok("semantics_input_fields_placeholder_color")};
  }

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    transition: background-color 9999s ease-in-out 0s;
    -webkit-text-fill-color: ${tok("semantics_content_color")} !important;
    background-color: transparent !important;
    box-shadow: 0 0 0 1000px transparent inset !important;
  }
  `;
}
var Input = styled26.input`
  ${inputStyles()}
`;

// src/uds/components/Overlays/Animations.tsx
init_esm_shims();
import { keyframes as keyframes2 } from "styled-components";
var slideInFromRight = keyframes2`
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
`;
var slideOutToRight = keyframes2`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
`;
var slideInFromBottom = keyframes2`
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
`;
var slideOutToBottom = keyframes2`
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(100%);
  }
`;
var slideInFromLeft = keyframes2`
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
`;
var slideOutToLeft = keyframes2`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-100%);
  }
`;

// src/uds/components/ScrollArea/index.ts
init_esm_shims();

// src/uds/components/ScrollArea/ScrollArea.tsx
var ScrollArea_exports = {};
__export(ScrollArea_exports, {
  Root: () => Root9,
  Scrollbar: () => Scrollbar2,
  Thumb: () => Thumb2,
  Viewport: () => Viewport2
});
init_esm_shims();
import * as ScrollArea from "@radix-ui/react-scroll-area";
import { styled as styled27 } from "styled-components";
var Root9 = styled27(ScrollArea.Root)`
  overflow: hidden;
`;
var Viewport2 = styled27(ScrollArea.Viewport)`
  width: 100%;
  height: 100%;
  border-radius: inherit;

`;
var Scrollbar2 = styled27(ScrollArea.Scrollbar)`
  display: flex;
  /* ensures no selection */
  user-select: none;
  /* disable browser handling of all panning and zooming gestures on touch devices */
  touch-action: none;
  padding: ${tokPx("semantics_overlays_corner_radius")} 2px;


  &[data-orientation="vertical"] {
    width: 12px;
  }

  &[data-orientation="horizontal"] {
    flex-direction: column;
    height: 10px;
  }
`;
var Thumb2 = styled27(ScrollArea.Thumb)`
  flex: 1;
  background: ${tok("primitives_color_neutral_550")};
  border-radius: ${tokPx("semantics_overlays_corner_radius")};
  position: relative;

  /* increase target size for touch devices https://www.w3.org/WAI/WCAG21/Understanding/target-size.html */

  &::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    min-width: 44px;
    min-height: 44px;
  }
`;

// src/uds/components/Dropdown/Dropdown.tsx
import { jsx as jsx66, jsxs as jsxs43 } from "react/jsx-runtime";
var StyledTrigger = styled28(Select.Trigger)`
  width: 100%;
  display: inline-flex;
  align-items: center;
  padding-left: ${space("primitives_space_16")};
  padding-top: ${space("primitives_space_12")};
  padding-bottom: ${space("primitives_space_12")};
  ${Typography_default.modVariant("body-m-regular-tight")};
  ${focusOutline()}
  background-color: ${tok("semantics_input_fields_background_color")};

  span:first-of-type {
    flex: 1;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    text-align: start;
  }
`;
var StyledIcon = styled28(Select.Icon)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;

  & > span {
    justify-content: center;
  }
`;
var StyledItem = styled28(Select.Item)`
  padding-top: ${space("primitives_space_8")};
  padding-right: ${space("primitives_space_8")};
  padding-bottom: ${space("primitives_space_8")};
  padding-left: calc(${space("primitives_space_8")} + 28px);
  border-radius: ${tokPx("primitives_corner_radius_l")};
  display: flex;
  align-items: center;
  position: relative;
  user-select: none;
  min-height: ${tokPx("semantics_controls_m_min_height")};
  cursor: pointer;

  &[data-disabled] {
    opacity: ${tok("primitives_opacity_disabled")};
  }

  ${focusOutline()}

  &:hover {
    background-color: ${tok("components_menu_hover_background_color")};
  }

  &:focus-visible:hover,
  &:focus:hover{
    outline: none;
  }
`;
var StyledItemIndicator = styled28(Select.ItemIndicator)`
  position: absolute;
  left: 0;
  width: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;
var StyledContent = styled28(Select.Content)`
  background: ${tok("semantics_views_background_color")};
  box-shadow: ${tok("primitives_box_shadows_level_4")};
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  animation-duration: 0.6s;
  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
  animation-name: ${slideInFromBottom};
  border-top-left-radius: ${tokPx("semantics_overlays_corner_radius")};
  border-top-right-radius: ${tokPx("semantics_overlays_corner_radius")};
  z-index: ${zIndex.level6};
  height: var(--radix-select-content-available-height);
  max-height: 50vh;

  @media ${mqMin("primitives_breakpoint_m_min")} {
    max-height: min-content;
    border-radius: ${tokPx("semantics_overlays_corner_radius")};
    animation-name: initial;
    position: initial;
    width: calc(var(--radix-select-trigger-width) + ${tokPx("primitives_space_8")});
  }
`;
var SelectGroup = styled28(Select.Group)`
  padding: ${space("primitives_space_12")};
`;
var StyledDropdownWrapper = styled28.div`
  // non-mobile first strategy is needed due to overriding radix inline styles
  @media ${mqMax("primitives_breakpoint_s_max")} {
    [data-radix-popper-content-wrapper] {
      bottom: 0;
      right: 0;
      transform: translate(0, 0) !important; // Enforced to override radix inline styles
      z-index: ${zIndex.level6} !important; // Enforced to override radix inline styles
    }
  }
`;
var BaseFieldItem = styled28(BaseField)`
  background-color: ${tok("semantics_input_fields_background_color")};

  &:hover {
    background-color: ${tok("semantics_selectors_hover_background_color")};
  }
`;
var Backdrop2 = styled28.div`
${backdropStyles()}

${({ $show }) => $show ? "" : "display: none;"}

@media ${mqMin("primitives_breakpoint_m_min")} {
  display: none;
}
`;
var TriggerComponent = React.forwardRef(
  ({ placeholder, label, className }, forwardedRef) => {
    return /* @__PURE__ */ jsx66(BaseFieldItem, {
      label,
      className,
      children: /* @__PURE__ */ jsxs43(StyledTrigger, {
        ref: forwardedRef,
        "aria-label": "patata",
        children: [
          /* @__PURE__ */ jsx66(Select.Value, {
            placeholder
          }),
          /* @__PURE__ */ jsx66(StyledIcon, {
            className: "SelectIcon",
            children: /* @__PURE__ */ jsx66(Icon_default, {
              size: 20,
              glyph: "ChevronDown"
            })
          })
        ]
      })
    });
  }
);
var Trigger5 = styled28(TriggerComponent)``;
var Item4 = React.forwardRef(
  ({ children, ...props }, forwardedRef) => {
    return /* @__PURE__ */ jsxs43(StyledItem, {
      ...props,
      ref: forwardedRef,
      children: [
        /* @__PURE__ */ jsx66(StyledItemIndicator, {
          children: /* @__PURE__ */ jsx66(IconCell_default, {
            glyph: "CheckMarkSmall",
            size: "sm"
          })
        }),
        /* @__PURE__ */ jsx66(Select.ItemText, {
          children: /* @__PURE__ */ jsx66(Typography_default, {
            $variant: "body-m-regular-tight",
            children
          })
        })
      ]
    });
  }
);
function Content7({ children }) {
  const contentSideOffsetSpacing = Number(useUdsToken("primitives_space_12"));
  const contentSideOffset = -Number(useUdsToken("semantics_controls_m_min_height")) - contentSideOffsetSpacing;
  return /* @__PURE__ */ jsx66(Select.Portal, {
    children: /* @__PURE__ */ jsx66(StyledDropdownWrapper, {
      children: /* @__PURE__ */ jsx66(StyledContent, {
        align: "center",
        sideOffset: contentSideOffset,
        position: "popper",
        avoidCollisions: true,
        children: /* @__PURE__ */ jsxs43(ScrollArea_exports.Root, {
          children: [
            /* @__PURE__ */ jsx66(Select.Viewport, {
              asChild: true,
              children: /* @__PURE__ */ jsx66(ScrollArea_exports.Viewport, {
                children: /* @__PURE__ */ jsx66(SelectGroup, {
                  children
                })
              })
            }),
            /* @__PURE__ */ jsx66(ScrollArea_exports.Scrollbar, {
              orientation: "vertical",
              children: /* @__PURE__ */ jsx66(ScrollArea_exports.Thumb, {})
            })
          ]
        })
      })
    })
  });
}
function Root11({
  children,
  open,
  value,
  defaultValue,
  disabled,
  onValueChange,
  ...props
}) {
  const [showBackdrop, setShowBackdrop] = React.useState(false);
  const handleOpen = (open2) => {
    setShowBackdrop(open2);
  };
  return /* @__PURE__ */ jsxs43(Select.Root, {
    onOpenChange: handleOpen,
    open,
    value,
    defaultValue,
    disabled,
    onValueChange,
    ...props,
    children: [
      /* @__PURE__ */ jsx66(Select.Portal, {
        children: /* @__PURE__ */ jsx66(Backdrop2, {
          $show: showBackdrop
        })
      }),
      children
    ]
  });
}
function EmptyValueItem({
  className,
  children,
  value = null,
  ...props
}) {
  return /* @__PURE__ */ jsx66(Item4, {
    value,
    ...props,
    children
  }, "reset");
}

// src/uds/components/Fields/index.ts
init_esm_shims();

// src/uds/components/Fields/CheckboxField.tsx
init_esm_shims();

// src/uds/components/Fields/SelectionField.tsx
init_esm_shims();
import { css as css21, styled as styled30 } from "styled-components";

// src/uds/components/RadioButton/index.ts
init_esm_shims();

// src/uds/components/RadioButton/RadioButton.tsx
init_esm_shims();
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";
import { forwardRef } from "react";
import { css as css20, styled as styled29 } from "styled-components";
import { jsx as jsx67 } from "react/jsx-runtime";
function RadioButtonGroup({ value, defaultValue, ...props }) {
  return /* @__PURE__ */ jsx67(RadioGroupPrimitive.Root, {
    value,
    defaultValue,
    ...props
  });
}
var ItemIndicator2 = styled29(RadioGroupPrimitive.Indicator)`
  width: 12px;
  height: 12px;
  border-radius: ${tokPx("primitives_corner_radius_full")};
  background: ${tok("semantics_selectors_selected_background_color")};
`;
var ItemRadio = styled29(RadioGroupPrimitive.Item)`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${tokPx("primitives_corner_radius_full")};
  background: ${tok("semantics_views_background_color")};
  border: 2px solid ${tok("semantics_selectors_shape_color")};

  &:hover {
    border-color: ${tok("semantics_selectors_hover_shape_color")};
  }

  &[data-state='checked'] {
    border-color: ${tok("semantics_selectors_selected_background_color")};
  }

  &[data-state='checked']:hover {
    border-color: ${tok("semantics_selectors_selected_hover_background_color")};

    ${ItemIndicator2} {
      background: ${tok("semantics_selectors_selected_hover_background_color")};
    }
  }


  ${({ disabled }) => disabled && modDisabled5()}

  ${focusOutline()}
`;
var RadioButton = forwardRef(({ className, ...rest }, ref) => /* @__PURE__ */ jsx67(ItemRadio, {
  className,
  ref,
  ...rest,
  children: /* @__PURE__ */ jsx67(ItemIndicator2, {})
}));
function modDisabled5() {
  return css20`
  pointer-events: none;
  opacity: ${tok("primitives_opacity_disabled")}%;
`;
}
var StyledRadioButton = withStyleModifiers(styled29(RadioButton)``, {
  modDisabled: modDisabled5
});
StyledRadioButton.displayName = "RadioButton";
var RadioButton_default = StyledRadioButton;

// src/uds/components/Fields/SelectionField.tsx
import { jsx as jsx68, jsxs as jsxs44 } from "react/jsx-runtime";
var Wrapper3 = styled30.label`
  padding: ${space("primitives_space_12")} 0;
  display: flex;
  align-items: center;
  gap: ${space("primitives_space_8")};
  user-select: none;
  width: 100%;
  border-radius: ${tokPx("semantics_controls_m_corner_radius")};
  cursor: pointer;

  ${RadioButton_default},
  ${Checkbox} {
    ${resetFocusOutline()}
    flex-shrink: 0;
  }

  ${({ $variant }) => $variant === "outlined" && css21`
      padding: ${space("primitives_space_12")};
      background-color: ${tok("semantics_views_background_color")};
      border: ${tokPx("semantics_input_fields_border_width")} solid ${tok("semantics_selectors_border_color")};
    `}

  ${({ $disabled }) => modDisabled6($disabled)};

  ${focusWithinOutline()}
`;
function SelectionField({
  label,
  id,
  disabled,
  className,
  select,
  variant = "transparent",
  ...rest
}) {
  return /* @__PURE__ */ jsxs44(Wrapper3, {
    $disabled: disabled,
    htmlFor: id,
    className,
    $variant: variant,
    children: [
      select === "checkbox" ? /* @__PURE__ */ jsx68(Checkbox, {
        className,
        disabled,
        id,
        ...rest
      }) : /* @__PURE__ */ jsx68(RadioButton_default, {
        className,
        disabled,
        id,
        ...rest
      }),
      label && /* @__PURE__ */ jsx68(Typography_default, {
        $variant: "body-m-regular-tight",
        children: label
      })
    ]
  });
}
function modDisabled6(disabled) {
  if (!disabled) {
    return "";
  }
  return css21`
    cursor: initial;
    opacity: ${tok("primitives_opacity_disabled")}%;

    ${RadioButton_default} {
      opacity: initial;
    }

    ${Checkbox} {
      opacity: initial;
    }
  `;
}

// src/uds/components/Fields/CheckboxField.tsx
import { jsx as jsx69 } from "react/jsx-runtime";
function CheckboxField({
  label,
  id,
  disabled,
  className,
  variant = "transparent",
  ...rest
}) {
  return /* @__PURE__ */ jsx69(SelectionField, {
    label,
    disabled,
    className,
    variant,
    select: "checkbox",
    ...rest
  });
}

// src/uds/components/Fields/DateField.tsx
init_esm_shims();
import { forwardRef as forwardRef2, useImperativeHandle, useRef } from "react";
import { styled as styled31 } from "styled-components";
import { jsx as jsx70, jsxs as jsxs45 } from "react/jsx-runtime";
var DateFieldIcons = styled31.div`
  position: absolute;
  right: ${space("primitives_space_0")};
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  z-index: 3;
  background: ${tok("semantics_input_fields_background_color")};
  height: 100%;
  padding-right: ${space("primitives_space_16")};
`;
var IconCalendar = styled31.button`
  display: flex;
  align-items: center;
  ${Icon_default} {
    color: ${tok("semantics_content_color")};
  }
`;
var BaseFieldStyled = styled31(BaseField)`
  width: ${tokPx("primitives_area_size_200")};
  &[data-empty='true'] > ${Input} {
    color: ${tok("semantics_input_fields_placeholder_color")};
  }
`;
var DateInput = styled31(Input)`
  cursor: default;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: textfield;
  &::-webkit-inner-spin-button,
  &::-webkit-calendar-picker-indicator {
    display: none;
    pointer-events: none;
  }
  ${IconCalendar} {
    cursor: default;
  }
`;
var StyledValidationDateFieldIcon = styled31(StyledValidationIcon)`
  padding-right: ${space("primitives_space_6")};
}`;
var DateField = forwardRef2(
  (props, ref) => {
    var _a;
    const inputRef = useRef(null);
    useImperativeHandle(ref, () => {
      if (!inputRef.current) {
        throw new Error("DateField inputRef is unexpectedly null");
      }
      return inputRef.current;
    });
    const handleIconClick = () => {
      var _a2, _b, _c;
      (_b = (_a2 = inputRef.current) == null ? void 0 : _a2.showPicker) == null ? void 0 : _b.call(_a2);
      (_c = inputRef.current) == null ? void 0 : _c.focus();
    };
    return /* @__PURE__ */ jsxs45(BaseFieldStyled, {
      ...props,
      children: [
        /* @__PURE__ */ jsx70(DateInput, {
          ref: inputRef,
          name: props.name,
          disabled: props.disabled,
          value: props.value,
          onChange: props.onChange,
          onBlur: props.onBlur,
          type: "date",
          min: props.minDate,
          max: props.maxDate,
          "aria-label": props.label
        }),
        /* @__PURE__ */ jsxs45(DateFieldIcons, {
          children: [
            /* @__PURE__ */ jsx70(StyledValidationDateFieldIcon, {
              status: (_a = props.status) != null ? _a : "default"
            }),
            /* @__PURE__ */ jsx70(IconCalendar, {
              onClick: handleIconClick,
              type: "button",
              "aria-label": `Select ${props.label}`,
              children: /* @__PURE__ */ jsx70(Icon_default, {
                size: 20,
                glyph: "Calendar"
              })
            })
          ]
        })
      ]
    });
  }
);
DateField.displayName = "DateField";
var DateField_default = styled31(DateField)`
  position: relative;
`;

// src/uds/components/Fields/PasswordField.tsx
init_esm_shims();
import { styled as styled32 } from "styled-components";
import { jsx as jsx71, jsxs as jsxs46 } from "react/jsx-runtime";
var IconPswdBtn = styled32.button`
  padding: ${space("primitives_space_12")};
  display: flex;
  align-items: center;
`;
function PasswordField(props) {
  var _a;
  return /* @__PURE__ */ jsxs46(BaseField, {
    ...props,
    children: [
      /* @__PURE__ */ jsx71(Input, {
        disabled: props.disabled,
        type: "password",
        value: "1234"
      }),
      /* @__PURE__ */ jsx71(StyledValidationIcon, {
        status: (_a = props.status) != null ? _a : "default"
      }),
      /* @__PURE__ */ jsx71(IconPswdBtn, {
        children: /* @__PURE__ */ jsx71(Icon_default, {
          size: 16,
          glyph: "Eye"
        })
      })
    ]
  });
}
var PasswordField_default = styled32(PasswordField)``;

// src/uds/components/Fields/PhoneField/index.ts
init_esm_shims();

// src/uds/components/Fields/PhoneField/country-data.ts
init_esm_shims();
var countryData = [
  { name: "Oostenrijk", code: "43", icon: "IconFlagAt", pattern: "^[0-9]{10,11}$", isoCode: "AT" },
  { name: "Belgi\xEB", code: "32", icon: "IconFlagBe", pattern: "^[0-9]{8,9}$", isoCode: "BE" },
  { name: "Bulgarije", code: "359", icon: "IconFlagBg", pattern: "^[0-9]{8,9}$", isoCode: "BG" },
  { name: "Kroati\xEB", code: "385", icon: "IconFlagHr", pattern: "^[0-9]{9,10}$", isoCode: "HR" },
  { name: "Cyprus", code: "357", icon: "IconFlagCy", pattern: "^[0-9]{8}$", isoCode: "CY" },
  { name: "Tsjechi\xEB", code: "420", icon: "IconFlagCz", pattern: "^[0-9]{9}$", isoCode: "CZ" },
  { name: "Denemarken", code: "45", icon: "IconFlagDk", pattern: "^[0-9]{8}$", isoCode: "DK" },
  { name: "Estland", code: "372", icon: "IconFlagEe", pattern: "^[0-9]{7,8}$", isoCode: "EE" },
  { name: "Finland", code: "358", icon: "IconFlagFi", pattern: "^[0-9]{7,12}$", isoCode: "FI" },
  { name: "Frankrijk", code: "33", icon: "IconFlagFr", pattern: "^[0-9]{9}$", isoCode: "FR" },
  { name: "Duitsland", code: "49", icon: "IconFlagDe", pattern: "^[0-9]{10,14}$", isoCode: "DE" },
  { name: "Griekenland", code: "30", icon: "IconFlagGr", pattern: "^[0-9]{10}$", isoCode: "GR" },
  { name: "Hongarije", code: "36", icon: "IconFlagHu", pattern: "^[0-9]{8,9}$", isoCode: "HU" },
  { name: "Ierland", code: "353", icon: "IconFlagIe", pattern: "^[0-9]{9,10}$", isoCode: "IE" },
  { name: "Itali\xEB", code: "39", icon: "IconFlagIt", pattern: "^[0-9]{9,10}$", isoCode: "IT" },
  { name: "Letland", code: "371", icon: "IconFlagLv", pattern: "^[0-9]{8}$", isoCode: "LV" },
  { name: "Litouwen", code: "370", icon: "IconFlagLt", pattern: "^[0-9]{8}$", isoCode: "LT" },
  { name: "Luxemburg", code: "352", icon: "IconFlagLu", pattern: "^[0-9]{9}$", isoCode: "LU" },
  { name: "Malta", code: "356", icon: "IconFlagMt", pattern: "^[0-9]{8}$", isoCode: "MT" },
  { name: "Nederland", code: "31", icon: "IconFlagNl", pattern: "^[0-9]{9}$", isoCode: "NL" },
  { name: "Polen", code: "48", icon: "IconFlagPl", pattern: "^[0-9]{9}$", isoCode: "PL" },
  { name: "Portugal", code: "351", icon: "IconFlagPt", pattern: "^[0-9]{9}$", isoCode: "PT" },
  { name: "Roemeni\xEB", code: "40", icon: "IconFlagRo", pattern: "^[0-9]{9,10}$", isoCode: "RO" },
  { name: "Slowakije", code: "421", icon: "IconFlagSk", pattern: "^[0-9]{9}$", isoCode: "SK" },
  { name: "Sloveni\xEB", code: "386", icon: "IconFlagSi", pattern: "^[0-9]{9}$", isoCode: "SI" },
  { name: "Spanje", code: "34", icon: "IconFlagEs", pattern: "^[0-9]{9}$", isoCode: "ES" },
  { name: "Zweden", code: "46", icon: "IconFlagSe", pattern: "^[0-9]{7,10}$", isoCode: "SE" }
];

// src/uds/components/Fields/PhoneField/PhoneField.tsx
init_esm_shims();
import React5, { forwardRef as forwardRef3 } from "react";
import { styled as styled36 } from "styled-components";

// src/uds/components/IconCountryFlag/index.ts
init_esm_shims();

// src/uds/components/IconCountryFlag/IconCountryFlag.tsx
init_esm_shims();
import { css as css22, styled as styled33 } from "styled-components";

// src/country-flag-icons/generated/index.ts
var generated_exports2 = {};
__export(generated_exports2, {
  IconFlagAd: () => Ad_default,
  IconFlagAe: () => Ae_default,
  IconFlagAf: () => Af_default,
  IconFlagAg: () => Ag_default,
  IconFlagAi: () => Ai_default,
  IconFlagAl: () => Al_default,
  IconFlagAm: () => Am_default,
  IconFlagAo: () => Ao_default,
  IconFlagAq: () => Aq_default,
  IconFlagAr: () => Ar_default,
  IconFlagAs: () => As_default,
  IconFlagAt: () => At_default,
  IconFlagAu: () => Au_default,
  IconFlagAw: () => Aw_default,
  IconFlagAx: () => Ax_default,
  IconFlagAz: () => Az_default,
  IconFlagBa: () => Ba_default,
  IconFlagBb: () => Bb_default,
  IconFlagBd: () => Bd_default,
  IconFlagBe: () => Be_default,
  IconFlagBf: () => Bf_default,
  IconFlagBg: () => Bg_default,
  IconFlagBh: () => Bh_default,
  IconFlagBi: () => Bi_default,
  IconFlagBj: () => Bj_default,
  IconFlagBl: () => Bl_default,
  IconFlagBm: () => Bm_default,
  IconFlagBn: () => Bn_default,
  IconFlagBo: () => Bo_default,
  IconFlagBq: () => Bq_default,
  IconFlagBr: () => Br_default,
  IconFlagBs: () => Bs_default,
  IconFlagBt: () => Bt_default,
  IconFlagBv: () => Bv_default,
  IconFlagBw: () => Bw_default,
  IconFlagBy: () => By_default,
  IconFlagBz: () => Bz_default,
  IconFlagCa: () => Ca_default,
  IconFlagCc: () => Cc_default,
  IconFlagCd: () => Cd_default,
  IconFlagCf: () => Cf_default,
  IconFlagCg: () => Cg_default,
  IconFlagCh: () => Ch_default,
  IconFlagCi: () => Ci_default,
  IconFlagCk: () => Ck_default,
  IconFlagCl: () => Cl_default,
  IconFlagCm: () => Cm_default,
  IconFlagCn: () => Cn_default,
  IconFlagCo: () => Co_default,
  IconFlagCp: () => Cp_default,
  IconFlagCr: () => Cr_default,
  IconFlagCu: () => Cu_default,
  IconFlagCv: () => Cv_default,
  IconFlagCw: () => Cw_default,
  IconFlagCx: () => Cx_default,
  IconFlagCy: () => Cy_default,
  IconFlagCz: () => Cz_default,
  IconFlagDe: () => De_default,
  IconFlagDj: () => Dj_default,
  IconFlagDk: () => Dk_default,
  IconFlagDm: () => Dm_default,
  IconFlagDo: () => Do_default,
  IconFlagDz: () => Dz_default,
  IconFlagEc: () => Ec_default,
  IconFlagEe: () => Ee_default,
  IconFlagEg: () => Eg_default,
  IconFlagEh: () => Eh_default,
  IconFlagEr: () => Er_default,
  IconFlagEs: () => Es_default,
  IconFlagEt: () => Et_default,
  IconFlagFi: () => Fi_default,
  IconFlagFj: () => Fj_default,
  IconFlagFk: () => Fk_default,
  IconFlagFm: () => Fm_default,
  IconFlagFo: () => Fo_default,
  IconFlagFr: () => Fr_default,
  IconFlagGa: () => Ga_default,
  IconFlagGb: () => Gb_default,
  IconFlagGd: () => Gd_default,
  IconFlagGe: () => Ge_default,
  IconFlagGf: () => Gf_default,
  IconFlagGg: () => Gg_default,
  IconFlagGh: () => Gh_default,
  IconFlagGi: () => Gi_default,
  IconFlagGl: () => Gl_default,
  IconFlagGm: () => Gm_default,
  IconFlagGn: () => Gn_default,
  IconFlagGp: () => Gp_default,
  IconFlagGq: () => Gq_default,
  IconFlagGr: () => Gr_default,
  IconFlagGs: () => Gs_default,
  IconFlagGt: () => Gt_default,
  IconFlagGu: () => Gu_default,
  IconFlagGw: () => Gw_default,
  IconFlagGy: () => Gy_default,
  IconFlagHk: () => Hk_default,
  IconFlagHm: () => Hm_default,
  IconFlagHn: () => Hn_default,
  IconFlagHr: () => Hr_default,
  IconFlagHt: () => Ht_default,
  IconFlagHu: () => Hu_default,
  IconFlagId: () => Id_default,
  IconFlagIe: () => Ie_default,
  IconFlagIl: () => Il_default,
  IconFlagIm: () => Im_default,
  IconFlagIn: () => In_default,
  IconFlagIo: () => Io_default,
  IconFlagIq: () => Iq_default,
  IconFlagIr: () => Ir_default,
  IconFlagIs: () => Is_default,
  IconFlagIt: () => It_default,
  IconFlagJe: () => Je_default,
  IconFlagJm: () => Jm_default,
  IconFlagJo: () => Jo_default,
  IconFlagJp: () => Jp_default,
  IconFlagKe: () => Ke_default,
  IconFlagKg: () => Kg_default,
  IconFlagKh: () => Kh_default,
  IconFlagKi: () => Ki_default,
  IconFlagKm: () => Km_default,
  IconFlagKn: () => Kn_default,
  IconFlagKp: () => Kp_default,
  IconFlagKr: () => Kr_default,
  IconFlagKw: () => Kw_default,
  IconFlagKy: () => Ky_default,
  IconFlagKz: () => Kz_default,
  IconFlagLa: () => La_default,
  IconFlagLb: () => Lb_default,
  IconFlagLc: () => Lc_default,
  IconFlagLi: () => Li_default,
  IconFlagLk: () => Lk_default,
  IconFlagLr: () => Lr_default,
  IconFlagLs: () => Ls_default,
  IconFlagLt: () => Lt_default,
  IconFlagLu: () => Lu_default,
  IconFlagLv: () => Lv_default,
  IconFlagLy: () => Ly_default,
  IconFlagMa: () => Ma_default,
  IconFlagMc: () => Mc_default,
  IconFlagMd: () => Md_default,
  IconFlagMe: () => Me_default,
  IconFlagMf: () => Mf_default,
  IconFlagMg: () => Mg_default,
  IconFlagMh: () => Mh_default,
  IconFlagMk: () => Mk_default,
  IconFlagMl: () => Ml_default,
  IconFlagMm: () => Mm_default,
  IconFlagMn: () => Mn_default,
  IconFlagMo: () => Mo_default,
  IconFlagMp: () => Mp_default,
  IconFlagMq: () => Mq_default,
  IconFlagMr: () => Mr_default,
  IconFlagMs: () => Ms_default,
  IconFlagMt: () => Mt_default,
  IconFlagMu: () => Mu_default,
  IconFlagMv: () => Mv_default,
  IconFlagMw: () => Mw_default,
  IconFlagMx: () => Mx_default,
  IconFlagMy: () => My_default,
  IconFlagMz: () => Mz_default,
  IconFlagNa: () => Na_default,
  IconFlagNc: () => Nc_default,
  IconFlagNe: () => Ne_default,
  IconFlagNf: () => Nf_default,
  IconFlagNg: () => Ng_default,
  IconFlagNi: () => Ni_default,
  IconFlagNl: () => Nl_default,
  IconFlagNo: () => No_default,
  IconFlagNp: () => Np_default,
  IconFlagNr: () => Nr_default,
  IconFlagNu: () => Nu_default,
  IconFlagNz: () => Nz_default,
  IconFlagOm: () => Om_default,
  IconFlagPa: () => Pa_default,
  IconFlagPe: () => Pe_default,
  IconFlagPf: () => Pf_default,
  IconFlagPg: () => Pg_default,
  IconFlagPh: () => Ph_default,
  IconFlagPk: () => Pk_default,
  IconFlagPl: () => Pl_default,
  IconFlagPm: () => Pm_default,
  IconFlagPn: () => Pn_default,
  IconFlagPr: () => Pr_default,
  IconFlagPs: () => Ps_default,
  IconFlagPt: () => Pt_default,
  IconFlagPw: () => Pw_default,
  IconFlagPy: () => Py_default,
  IconFlagQa: () => Qa_default,
  IconFlagRe: () => Re_default,
  IconFlagRo: () => Ro_default,
  IconFlagRs: () => Rs_default,
  IconFlagRu: () => Ru_default,
  IconFlagRw: () => Rw_default,
  IconFlagSa: () => Sa_default,
  IconFlagSb: () => Sb_default,
  IconFlagSc: () => Sc_default,
  IconFlagSd: () => Sd_default,
  IconFlagSe: () => Se_default,
  IconFlagSg: () => Sg_default,
  IconFlagSh: () => Sh_default,
  IconFlagSi: () => Si_default,
  IconFlagSj: () => Sj_default,
  IconFlagSk: () => Sk_default,
  IconFlagSl: () => Sl_default,
  IconFlagSm: () => Sm_default,
  IconFlagSn: () => Sn_default,
  IconFlagSo: () => So_default,
  IconFlagSr: () => Sr_default,
  IconFlagSs: () => Ss_default,
  IconFlagSt: () => St_default,
  IconFlagSv: () => Sv_default,
  IconFlagSx: () => Sx_default,
  IconFlagSy: () => Sy_default,
  IconFlagSz: () => Sz_default,
  IconFlagTc: () => Tc_default,
  IconFlagTd: () => Td_default,
  IconFlagTf: () => Tf_default,
  IconFlagTg: () => Tg_default,
  IconFlagTh: () => Th_default,
  IconFlagTj: () => Tj_default,
  IconFlagTk: () => Tk_default,
  IconFlagTl: () => Tl_default,
  IconFlagTm: () => Tm_default,
  IconFlagTn: () => Tn_default,
  IconFlagTo: () => To_default,
  IconFlagTr: () => Tr_default,
  IconFlagTt: () => Tt_default,
  IconFlagTv: () => Tv_default,
  IconFlagTw: () => Tw_default,
  IconFlagTz: () => Tz_default,
  IconFlagUa: () => Ua_default,
  IconFlagUg: () => Ug_default,
  IconFlagUm: () => Um_default,
  IconFlagUs: () => Us_default,
  IconFlagUy: () => Uy_default,
  IconFlagUz: () => Uz_default,
  IconFlagVa: () => Va_default,
  IconFlagVc: () => Vc_default,
  IconFlagVe: () => Ve_default,
  IconFlagVg: () => Vg_default,
  IconFlagVi: () => Vi_default,
  IconFlagVn: () => Vn_default,
  IconFlagVu: () => Vu_default,
  IconFlagWf: () => Wf_default,
  IconFlagWs: () => Ws_default,
  IconFlagYe: () => Ye_default,
  IconFlagYt: () => Yt_default,
  IconFlagZa: () => Za_default,
  IconFlagZm: () => Zm_default,
  IconFlagZw: () => Zw_default
});
init_esm_shims();

// src/country-flag-icons/generated/Ad.tsx
init_esm_shims();
import { jsx as jsx72, jsxs as jsxs47 } from "react/jsx-runtime";
var SvgAd = (props) => /* @__PURE__ */ jsxs47("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx72("path", {
      fill: "#d0103a",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx72("path", {
      fill: "#fedf00",
      d: "M0 0h435.2v480H0z"
    }),
    /* @__PURE__ */ jsx72("path", {
      fill: "#0018a8",
      d: "M0 0h204.8v480H0z"
    }),
    /* @__PURE__ */ jsx72("path", {
      fill: "#c7b37f",
      d: "M300.4 136.6c7.7 0 10.9 6.6 18.6 6.6 4.7 0 7.5-1.5 11.7-3.9 2.9-1.6 4.7-2.5 8-2.5 3.4 0 5.5 1 7.3 4 1 1.6 1.8 4.9 1.3 6.7a40 40 0 0 1-2.7 8.3c-.7 1.6-1.3 2.5-1.3 4.2 0 4.1 5.6 5.5 9.4 5.6.8 0 7.7 0 12-4.2-2.3-.1-4.9-2-4.9-4.3 0-2.6 1.8-4.3 4.3-5.1.5-.1 1.3.3 1.7 0 .7-.3.4-1 1-1.4 1.2-1 2-1.6 3.6-1.6 1 0 1.6.1 2.5.7.4.4.6.8 1 .8 1.2 0 1.8-.8 3-.8a5 5 0 0 1 2.3.6c.6.3.6 1.5 1.4 1.5.4 0 2.4-.9 3.5-.9 2.2 0 3.4.8 4.8 2.5.4.5.6 1.4 1 1.4a6.2 6.2 0 0 1 4.8 3c.3.4.7 1.4 1.1 1.5.6.3 1 .2 1.7.7a6 6 0 0 1 2.8 4.8c0 .7-.3 1.6-.5 2.2-1.8 6.5-6.3 8.6-10.8 14.3-2 2.4-3.5 4.3-3.5 7.4 0 .7 1 2.1 1.3 2.7-.2-1.4.5-3.2 2-3.3a4 4 0 0 1 4 3.6 4.5 4.5 0 0 1-.3 1.8 9.6 9.6 0 0 1 4-1.4h1.9c3.3 0 7 1.9 9.3 3.8a21 21 0 0 1 7.3 16.8c-.8 5.2-.3 14.8-13.8 18.6 2.5 1 4.2 3 4.2 5.2a4.5 4.5 0 0 1-4.4 4.7 4.4 4.4 0 0 1-3.5-1.4c-2.8 2.8-3.3 5.7-3.3 9.7 0 2.4.4 3.8 1.4 6 1 2.2 1.8 3.5 3.7 5.1 1-1.5 2.1-2.6 4-2.6 1.7 0 3.2.6 3.9 2.2.2.5 0 .9.3 1.4.3.6.8.7 1.1 1.3.5 1 0 1.8.5 2.7.3.7.9.8 1.2 1.4.4 1 .5 1.6.5 2.7 0 3-2.7 5.2-5.7 5.2-1 0-1.4-.4-2.3-.3 1.7 1.7 3 2.5 4.3 4.5a17.7 17.7 0 0 1 3 10.3 22 22 0 0 1-2.8 11.2 20 20 0 0 1-7 8.5 35 35 0 0 1-16 6.4 74.4 74.4 0 0 1-11 1.4l-14.1.8c-7.2.4-12.2 1.5-17.3 6.6 2.4 1.7 4 3.5 4 6.4 0 3-1.8 5.3-4.7 6.2-.7.2-1.2 0-1.9.4s-.7 1.3-1.4 1.7a6.2 6.2 0 0 1-3.8 1 8 8 0 0 1-6.4-2.5c-2.2 1.8-3 3.4-5.5 4.9-.8.4-1.2 1-2.1 1-1.5 0-2.2-1-3.4-1.8a23 23 0 0 1-4.4-4c-2.3 1.3-3.6 2.4-6.3 2.4a7 7 0 0 1-4-1c-.6-.5-.8-1.2-1.5-1.6-.7-.5-1.3-.3-2.1-.7-3-1.3-5-3.5-5-6.8 0-2.9 1.8-4.7 4.4-6-5-5-10-5.8-17-6.2l-14-.8c-4.4-.3-6.8-.7-11-1.4-3.3-.5-5.2-.7-8.2-2.1-10.2-4.8-16.8-11.3-18-22.5-.2-1-.2-1.5-.2-2.5 0-5.8 2.3-9.4 6.4-13.5-1-.3-1.7 0-2.8-.3-2.5-1-4.4-2.7-4.4-5.5 0-1 0-1.7.5-2.6.4-.6 1-.7 1.2-1.4.2-1 0-1.6.4-2.5.3-.5.8-.6 1-1.2 1-1.9 2-3.4 4.1-3.4 1.8 0 3 1 3.8 2.5 1.8-.8 2.2-2.1 3.2-3.7a15.5 15.5 0 0 0 1.4-13.3c-.4-1.5-.6-2.5-1.8-3.7-1 1-2 1.4-3.4 1.4-2.9 0-5-2.5-5-5.3a4.8 4.8 0 0 1 3-4.6c-1.6-1.4-3-1.5-4.7-2.6-2.6-1.6-3.5-3.4-5.2-6-1.2-1.6-1.5-2.8-2-4.7a19 19 0 0 1-1-7.8c.6-5 1.5-8 4.6-11.9 1.8-2.3 3-3.7 5.8-4.9 2.3-1 3.7-1.7 6.2-1.7l2 .1a6.9 6.9 0 0 1 2.8.8c.4.2 1.1.9 1.1.4s-.3-.8-.3-1.3c0-2 1.5-4 3.6-4 1.5 0 2.1 1.4 2.9 2.7.4-.8.7-1.4.7-2.3 0-3.4-1.9-5.2-4-7.9-4.7-5.8-10.5-8.5-10.5-16 0-2.2 1-3.7 3-4.9.5-.3 1.3 0 1.8-.3s.4-1 .7-1.4c.5-.7 1-1 1.6-1.6 1-1 2-.6 3.1-1.5.6-.4.8-1 1.2-1.4 1.3-1.6 2.5-2.4 4.6-2.4 1 0 1.6 0 2.5.4l1 .5c.3-.2.8-.8 1.5-1.1a4 4 0 0 1 2.2-.6c1.1 0 1.8.6 3 .6.3 0 .4-.4.8-.6 1-.7 1.5-1 2.7-1 1.2 0 1.8.3 2.8 1 1 .5 1 1.3 2 1.8.5.3 1 .2 1.5.4 2.6.9 4.5 2.6 4.5 5.3 0 1.5-.3 2.5-1.4 3.5-.9.7-1.7.6-2.8 1a16 16 0 0 0 11.3 3.5c4.2 0 9.3-1.7 9.3-5.9 0-2-1-3-1.8-4.8a18.8 18.8 0 0 1-2.1-8.5c0-2.8.3-4.5 1.9-6.7 1.6-2.3 3.6-2.9 6.5-2.9"
    }),
    /* @__PURE__ */ jsxs47("g", {
      fill: "none",
      stroke: "#703d29",
      children: [
        /* @__PURE__ */ jsx72("path", {
          strokeLinejoin: "round",
          strokeWidth: 0.7,
          d: "M272.4 159a3.6 3.6 0 0 0 2.4 2.4c.8.3 2.7.2 3.8-1.4 1-1.2 1-2.8.6-4a4.7 4.7 0 0 0-1.7-2.2z"
        }),
        /* @__PURE__ */ jsx72("path", {
          strokeLinecap: "round",
          strokeWidth: 0.7,
          d: "M401 236.1c-1.2-2.9-4.3-1.6-4.4 0-.5 3.7 2.7 4.8 5 4.2a4 4 0 0 0 2.5-2c.6-1 .8-2.4.4-3.7a4.9 4.9 0 0 0-.8-1.6 5 5 0 0 0-1.3-1.2c-.9-.6-1.9-.6-3.4-.6-5.5 0-10.4 6.5-12 13.4-.6 2.2-1.3 7.3-.3 12a22.4 22.4 0 0 0 5.9 11.3 25.7 25.7 0 0 0 9.9 5.8 7.9 7.9 0 0 0 4 .1c3.2-.7 4.7-3.8 3-7-1.3-2.5-5.3-4-7.2-.6-.1.3-.4.9-.4 1.5 0 .9.4 2 1 2.4 1.5.9 3.8.6 3.7-2"
        }),
        /* @__PURE__ */ jsx72("path", {
          strokeWidth: 0.8,
          d: "M383.8 274a11.3 11.3 0 0 1 6.6-3.7c3-.4 5.6.5 8.2 2a18.5 18.5 0 0 1 10.8 17c0 3.6-1 7.5-2 9.4-.8 1.7-3 9-15.3 14-7.1 3-18 3.6-25.7 4-10.4.3-20 .7-25.5 7.6"
        }),
        /* @__PURE__ */ jsxs47("g", {
          strokeWidth: 0.7,
          children: [
            /* @__PURE__ */ jsx72("path", {
              d: "M386.4 285.7c-.3-1 0-2.1.8-3.3 1.2-1.6 3.7-2.1 6-1a7.4 7.4 0 0 1 2.5 2.2l1.1 1.6c.7 1.1 1 2 1 2.5 2.5 7-1.4 14.5-6.5 17.6-4 2.4-8.7 3.4-14.4 4-2.5.4-4 .3-6.5.5h-9.6a70.1 70.1 0 0 0-7.2 0c-2.9.3-5 .4-7.6.8-1.6.2-3.4.5-5.4 1-.6 0-1.2.2-1.8.4l-1.2.3c-3.6 1.1-7 2.4-9.8 4.2-.8.5-1.8 1-2.5 1.7l-1.3 1.2c-2 2-3.9 4-4.4 6.7v1.6c0 1.8 1.4 4.3 5.4 5m5.5-170c.8 1.4 1.3 2.3.8 3.9-.6 1.7-1.8 2.8-3.6 2.8-4 0-6.3-4.8-4.5-7.8 3.2-5.3 9.3-2.3 15 .3-.3-1.3-.8-1.8-.7-3.5.1-4.2 3.2-6 4.5-10 .7-2.3 1-4.3-.7-6-1.5-1.3-3.2-1.3-5.1-.6-3.8 1.5-8.5 5.9-16.6 6-8.2-.1-12.8-4.5-16.7-6-2-.7-3.6-.7-5.1.7-1.7 1.6-1.4 3.6-.7 6 1.3 3.8 4.4 5.7 4.5 10 0 1.6-.4 2-.7 3.4 5.7-2.6 12-5.9 15-.3 1.7 3.2-.5 7.7-4.5 7.7-1.8 0-3-1-3.6-2.7-.4-1.5 0-2.8.8-4"
            }),
            /* @__PURE__ */ jsx72("path", {
              strokeLinecap: "round",
              d: "M314.6 159.9a5.3 5.3 0 0 1 2.4 5c-.2 2.5-.8 3.1-2.8 4.5m2.4-3.8c-.1 1.5-.7 2.5-2.3 3.1"
            })
          ]
        }),
        /* @__PURE__ */ jsx72("path", {
          fill: "#c7b37f",
          stroke: "none",
          d: "m276.7 153.3.7.5.8.8.5 1 .2.8v1.9l-.2.8-.5.6-.6.6-.9.5-1 .2-1 .2-1-.5-.9-.6-.5-.8-.4-1v-.4z"
        }),
        /* @__PURE__ */ jsx72("path", {
          strokeLinecap: "round",
          strokeWidth: 0.7,
          d: "M275.2 157.2c-.3-1.7-2.2-2-3-1-1.1 1.5-.3 4 2 4.7a4 4 0 0 0 3.9-1.4c1-1.3.9-2.8.5-4a4.5 4.5 0 0 0-1.7-2.2c-2.7-2-7.1-1.6-8.6 2-1.8 4.4 2.2 7.8 6 10.3 4.6 3.2 10 3.8 14 3.8 9.2-.1 16.2-4.5 20.7-7 1-.6 2.1-.5 2.7.2a2 2 0 0 1-.3 2.7"
        }),
        /* @__PURE__ */ jsx72("path", {
          strokeWidth: 0.7,
          d: "m248 281.2-2 .7-2 1.6-1 1.3-1.1 2-.5 1.5-.4 1.8-.2 1.4m19-10.1-.1 1.8-.3 1.2-1 2.2-1.3 1.8-1.5 1.2-1.1.5-1.6.4"
        }),
        /* @__PURE__ */ jsx72("path", {
          strokeWidth: 0.8,
          d: "M319.7 329.1c-.3 1.7-1.9 3.6-5.3 4.2l-.6.2"
        }),
        /* @__PURE__ */ jsx72("path", {
          strokeWidth: 0.9,
          d: "M404.2 276.2a18.3 18.3 0 0 1 5.6 13.5c0 3.6-1 7.5-2 9.4-.8 1.7-3 9-15.3 14a85 85 0 0 1-25.6 4c-10.3.3-19.8.7-25.4 7.3"
        }),
        /* @__PURE__ */ jsx72("path", {
          strokeWidth: 0.6,
          d: "M387.5 282.9c.8-1 3.5-2.4 5.8-1.1a6.2 6.2 0 0 1 2.3 2"
        }),
        /* @__PURE__ */ jsx72("path", {
          strokeWidth: 0.9,
          d: "m401.6 273.8 1.4.5a7 7 0 0 0 4 0c2.8-.8 4.6-3.4 3.2-6.9a6 6 0 0 0-1.8-2.1"
        }),
        /* @__PURE__ */ jsx72("path", {
          strokeLinecap: "round",
          strokeWidth: 0.7,
          d: "M240.3 199.8c-2 1.1-3.3 1.4-4.8 3.1a28.1 28.1 0 0 0-2.6 6.8m46-51.7c0 1.8-1.2 2.8-3 3.2"
        }),
        /* @__PURE__ */ jsx72("path", {
          strokeWidth: 0.6,
          d: "M397.1 192a19 19 0 0 1 18.6 19.8c0 16-9.9 18.5-13.8 19.6"
        }),
        /* @__PURE__ */ jsx72("path", {
          strokeWidth: 0.7,
          d: "M398.4 192c8.1-.3 16.5 5.7 16.9 20.7.3 11.7-8 17-12 18"
        }),
        /* @__PURE__ */ jsx72("path", {
          strokeWidth: 0.6,
          d: "m393.8 248.4.1-1.6.6-2.5.7-2 .9-1.6 1-1.3m7.8-3.4v1.5l-.5 1-.7 1.1-.8.6-1.2.5h-1.1l-.8-.1m-14.3-52.8.3-1.7.8-1.6 1-1.5 1.6-2.2 1.4-1.4 2-2.2 2-1.9 1.1-1.3 1.5-1.9 1.4-2 .8-1.7.5-2.2.1-2.7-.2-.8m-12.3 128.2 1.6-.4 1.2-.6.7-.7.5-.8.3-1.2v-.9m-158.2-12.1h2.7l1.6-.6m5-36.5-.2 1.4-.4.6-.4.6-.7.5-.7.3-1 .1h-.6m9.9-15.5-.3 2.1-.5 1-.8 1.2-1.2.9-1.2.6-2.3.5m15.3-39.7-.5 1.3-.5 1-.8 1-1 1-1.2.5-1.1.3-.6-.1m.3-6.2v1"
        }),
        /* @__PURE__ */ jsxs47("g", {
          strokeWidth: 0.6,
          children: [
            /* @__PURE__ */ jsx72("path", {
              strokeLinecap: "round",
              d: "M254.3 224a6.9 6.9 0 0 1-2.1 1.4m150.5 44.8.5.2c1.4.8 4.2-.2 3.4-2.4"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M397.8 239.6c1 1.3 2.9 1.7 4.4 1.3a4 4 0 0 0 2.5-2c.6-1 .8-2.4.4-3.7a4.9 4.9 0 0 0-.9-1.6 6.8 6.8 0 0 0-1.3-1.5l-.4-.2m6.4 34a4 4 0 0 0 .1-.7 4 4 0 0 0-1.3-3l-.8-.8m.4.5c0-1.8-1.5-3.2-3.4-3.5m-4.2 2.8-1.3-1a15.7 15.7 0 0 1-4.3-10.7c0-4.2 1.6-8.4 3.6-10M341.2 324l1.8-1.6 1.2-1 2.3-1.4 2.2-1 1.6-.5 3-.6 3.6-.6m-29.5 19.4a17 17 0 0 1-7.6 6.1 17.7 17.7 0 0 1-7.6-6.1"
            }),
            /* @__PURE__ */ jsx72("path", {
              strokeLinecap: "round",
              d: "M314.4 332.6a10 10 0 0 1-2.2 4.2"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "m314.7 330.5-.4 2.2M312 337l-1 1-1.7.9-2 .6m-5.6-177.8c.3-.8.5-1.4.5-2.6-.1-4.2-3.2-6.1-4.5-10-.7-2.3-1-4.3.7-6 1.4-1.4 3.2-1.4 5-.6 4 1.5 8.6 5.8 16.7 6-8.1-.2-12.8-4.5-16.6-6-2-.8-3.8-1-5.3.5-1.7 1.6-1.2 3.8-.5 6.1 1.3 3.9 4.2 5.8 4.3 10 0 1.2-.3 1.8-.5 2.6M320 148c8-.4 14.9-5.8 17.1-6.3 2-.4 3-.2 4.5 1.1-1.4-1.3-3-1.2-5-.5-3.8 1.5-8.4 5.8-16.6 6m79.6 112.9a15.5 15.5 0 0 1-6.2-12.4c0-4.1 1.7-8.4 3.6-10m-70 97.6c-1.3 2-4.3 5-7.6 6.2a17.7 17.7 0 0 1-7.6-6.2"
            }),
            /* @__PURE__ */ jsx72("path", {
              strokeLinecap: "round",
              d: "m306.7 163.7 2.3-1.3c1-.6 2.3-.5 2.9.2.6.7.7 2-.2 2.8"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M294.7 169.3c5.5-1.2 10-3.6 13.4-5.5M340.3 328c.5.3.8 1 .8 1 .1.2.3.5.3.8.3 1.5-.7 2.4-2 2.6-1.7.2-3-.8-3.5-2M294.4 169c5.5-1.1 10-3.6 13.4-5.5m97.6 106.9c-1 .4-1.6.3-3-.2l-1.8-1a20.7 20.7 0 0 1-8.4-9 18.8 18.8 0 0 1-1.7-4.6 12 12 0 0 1-.5-3.3 25.6 25.6 0 0 1 4.7-15.3c1.1-1.6 2.1-2.5 4.2-2.6m-143.7-39.3a7.1 7.1 0 0 1 2.7 5.7c0 3.1-2.6 8.2-9 10a8.3 8.3 0 0 1-6.3-.8"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M256.3 205.6c1.1.8 1.6 1.7 1.6 3.3 0 1-.7 2.4-1.9 3.7a12.4 12.4 0 0 1-8.8 4c-2 0-4-.4-6-1.7a9 9 0 0 1-3.8-5.4"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M256.2 212.3c1.3 1.2 1.7 2.7 1.7 4.6 0 2.7-1.1 4.8-3.7 7-.6.6-1.2 1-2 1.5m129.5-22.1v3.5m-.3-4.4v5m.3-15.8v6.6m-.3-8v8.9m-1.9 82a18.7 18.7 0 0 1-4.2 5.6 19.6 19.6 0 0 1-5.8 4.1 24.6 24.6 0 0 1-6.6 2.2 33 33 0 0 1-6.8.9c-2.5 0-3.9 0-6.4-.2-2.6-.2-4-.6-6.7-.8-2.2-.2-3.4-.4-5.6-.3a28.3 28.3 0 0 0-11 1.8c-2.6 1-5.7 3-6.3 3.8a22 22 0 0 0-6.4-3.8 22 22 0 0 0-5.1-1.4c-2.3-.4-3.5-.4-5.8-.4-2.2 0-3.4.1-5.6.3-2.6.3-4 .6-6.7.8-2.5.2-3.9.3-6.4.2a33 33 0 0 1-13.4-3 19.5 19.5 0 0 1-6.4-4.8m42.1 53.4 1.8-.2m30.3-2.4 1.8-.1 1.7-.7 1.2-.8 1.7-2 .3-.6.3-1.7v-.8m47-136.7c.7-2.6-.2-5.4-2.8-5.3m-132 46.5a8.2 8.2 0 0 1-3.5 4.7m3.6-46.7a6.5 6.5 0 0 1-3.6 4c-1.9.8-4 0-5.2-.8"
            }),
            /* @__PURE__ */ jsx72("path", {
              strokeLinecap: "round",
              d: "M243.8 202.4c1.5.8 3.1-.4 2.8-2.4a2.9 2.9 0 0 0-2.5-2.2"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M250.2 286.6c.3.3.4.7.8.8.7.2 1.2.4 1.9-.5.8-1.1.3-2.8-.5-3.9a5 5 0 0 0-5.8-1c-.8.5-1.7 1-2.6 2.2l-1.1 1.6c-.7 1.1-1 2-1.1 2.4-2 5.9.4 12 4.1 15.7"
            }),
            /* @__PURE__ */ jsx72("path", {
              strokeLinecap: "round",
              d: "m340.2 327.8.7.8.2.9c.3 1.5-.7 2.4-2 2.6-1.6.2-2.8-.8-3.3-2"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M389.4 154.8a7.4 7.4 0 0 1 6.3 7c0 4.4-1.5 6-3.8 9.2-2.5 3.4-10.7 9.6-10.7 16.7 0 4.3 1.2 7 4.3 8.4 2 1 4.3 0 5.4-1 2.6-2.4 1.5-6.5-1.2-7-3.2-.6-3.9 4.6-.7 4.3m17.9 69a3.7 3.7 0 0 0-3.6-3 3.7 3.7 0 0 0-3.7 3.7c0 1 .4 2 1 2.6"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M383.9 195.1a7.1 7.1 0 0 0-2.7 5.7c0 3.1 2.6 8.2 9 10 2.4.7 4.8.6 6.2-.3m-156-10.3a9.4 9.4 0 0 0-4.8 3.5 16.9 16.9 0 0 0-2.2 12.7 15.8 15.8 0 0 0 2.3 5.6 8 8 0 0 0 1 1.2l1.2 1m64 92c4.9 2.1 8.4 3.7 11.4 8.5a10 10 0 0 1 1.2 4.9c0 2.7-1 5.7-3.3 7.6a8.3 8.3 0 0 1-6.7 2c-1.9-.2-3.7-1.6-4-2.6M254 224.1c2.7 2.2 3.9 4.2 3.9 7.5a8.4 8.4 0 0 1-4 7.5"
            }),
            /* @__PURE__ */ jsx72("path", {
              strokeLinecap: "round",
              d: "M251.5 236.4c4 5.1 6.3 8.1 6.4 14.1.1 5.7-1.7 9.6-5 13.7"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M329.8 169.3a4.1 4.1 0 0 0 1.5-2.2c.5-1.5.5-2.8-.2-4 1 1.4 1 2.5.7 4-.1 1-.8 1.5-1.6 2.3m51.5 86.1v16.2l-.1 2.5a34.4 34.4 0 0 1-.3 1.7"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M381.4 254v19.9l-.5 2.6m.5-43v14.6m.3-13.4v11.8m0-26.8v8.8m-.3-9.9v11m.3-19v3.5m-.3-4.2v5m-1.8 65.2-.4.7a18.7 18.7 0 0 1-4.1 5.7 19.6 19.6 0 0 1-5.9 4 24.6 24.6 0 0 1-6.5 2.2c-2.7.6-4.2.8-6.9.9-2.5 0-3.9 0-6.3-.2-2.7-.2-4.1-.5-6.8-.8-2.2-.2-3.4-.3-5.6-.3-2.2 0-3.5 0-5.7.4a22 22 0 0 0-5.2 1.4c-2.7 1.1-5.7 3-6.4 3.8-.6-.8-3.7-2.7-6.3-3.8a22 22 0 0 0-5.2-1.4c-2.2-.4-3.5-.4-5.8-.4-2.2 0-3.4.1-5.6.3-2.6.3-4 .6-6.7.8-2.5.2-3.9.3-6.3.2a33 33 0 0 1-13.5-3 19.5 19.5 0 0 1-5.8-4.1 22 22 0 0 1-2.5-2.8m-2-3.2a10.1 10.1 0 0 1-2.3 7.7c-.8.9-2.6 2.6-5 2.6-3.7 0-4.8-2.5-5-3.2"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M255.6 278.9c.7.7 1.3 1.5 1.9 2.5 1 1.8.6 4.8-.1 6.2a4.4 4.4 0 0 1-.3.4m-20.3 18c2.3 2.4 5.7 5 10.9 7.1 7.1 3 18.1 3.6 25.7 4 10 .3 19.3.7 25 7m17.3-4a12 12 0 0 1 4 5.5m-7.3 11.5a8.2 8.2 0 0 1-.7.7 8.3 8.3 0 0 1-6.6 2c-2-.2-3.8-1.6-4.3-2.6m-5.4-2.9.3.4a7.6 7.6 0 0 0 5.1 2.4m27 0a18 18 0 0 1-7.7 6.1 17.7 17.7 0 0 1-7.6-6.1l-.3-.5m15.6.4.7.7a8.3 8.3 0 0 0 6.7 2 5.5 5.5 0 0 0 4-2.5l.5-.7"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "m339 336.6-.7 1.2-1.1 1-1.7.7h-1.6"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M343 325.3a7.7 7.7 0 0 1 2.4 2.9c.3.7.4 1.5.5 2.3a5.8 5.8 0 0 1-1.5 4.2 7.5 7.5 0 0 1-5.4 2.4 5.5 5.5 0 0 1-.4 0m.2-.2a6.8 6.8 0 0 1-5.2-2.2m63.7-67.9a23.8 23.8 0 0 1-4.8-6.4 18.8 18.8 0 0 1-1.7-4.5 12 12 0 0 1-.5-3.3 26 26 0 0 1 4.6-15.3c.7-.8 1.4-1.8 2.1-2.2m-1.3-75.9c2.5.2 4.8 3 4.8 5.7 0 3.8-1.3 5.5-4.4 9.3-2.6 3.2-10.6 9-10.3 14.5 0 1 .5 2 1.1 2.8m-3.2 3.5a7 7 0 0 0 2 1.4 5 5 0 0 0 4.3-.3M369 153a6 6 0 0 1 2.2 2.6c1.8 4.5-2.2 7.9-6 10.4a21.3 21.3 0 0 1-8.3 3.3"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M364.6 161.6a4.2 4.2 0 0 1-3.1-1.5 3.4 3.4 0 0 1-.7-1m-15 4.9a4.6 4.6 0 0 1-1.2-1c-1-1-1.5-2.3-.8-4.4.6-1.9 3.7-7.2 3.8-10.9.2-5.6-2-9-5.3-10.2"
            }),
            /* @__PURE__ */ jsx72("path", {
              strokeLinecap: "round",
              d: "m347.3 146.5-.1 2-.6 2.2-1 3-1 1.9-.8 1.9-.4 1.3-.2 1 .1.9m38 126.3.6.8c.7 1 3.2 3 5.5 3 3.7 0 4.6-2.6 4.7-3.2.5-2.9-.5-3.6-2-4.5 0 0-.8-.4-1.9-.2"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M237 274.4a6.9 6.9 0 0 1-3.7 0c-2.9-.9-5.2-3.6-4-7m13.4-31.8c.3.3.4.7.4 1 .4 3.8-2.8 4.8-5 4.2a5.6 5.6 0 0 1-3-2.3 4.7 4.7 0 0 1-.7-2.3m22-23.6c.6.5 1 1 1.3 1.7m-1.1-8.5c.5.4.9.9 1.1 1.3"
            }),
            /* @__PURE__ */ jsx72("path", {
              strokeLinecap: "round",
              d: "M257.9 210.5a8.5 8.5 0 0 1-1.6 2.4 12.4 12.4 0 0 1-8.8 4c-2 0-4-.4-6-1.7a9.5 9.5 0 0 1-4-5.6"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M255.4 195.3a7.8 7.8 0 0 1 2.4 3.4"
            }),
            /* @__PURE__ */ jsx72("path", {
              strokeLinecap: "round",
              d: "M257.8 203.2c-.9 3-3.5 6.6-8.6 7.9-2.4.6-5.6-.2-6.6-1"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M240 202.6c.3 2.6 2 4.6 5.4 4.6 4.7.1 7.6-6.7 3.4-11.5"
            }),
            /* @__PURE__ */ jsx72("path", {
              strokeLinecap: "round",
              d: "M229.4 225.5c.7.9 1.5 1.7 2.4 2.4a16.8 16.8 0 0 0 6 3.3m5.2.5c4.2-.5 6.6-3.7 6-7.3-.3-2.8-2.8-5-4.6-5.1"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M249.8 188.1c1.9 0 3 1.6 2.9 3"
            }),
            /* @__PURE__ */ jsx72("path", {
              strokeLinecap: "round",
              d: "M249.4 163a11.5 11.5 0 0 0 5 5.9m144.2 31c1.7 2.3.6 7-4 7a5.2 5.2 0 0 1-4.5-2.5"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M381.7 169.1V185"
            }),
            /* @__PURE__ */ jsx72("path", {
              strokeLinecap: "round",
              d: "M243.8 202.3c1.4 1 3.3-.7 2.5-2.6-.5-1.2-2.2-2.6-4.7-.9-2.8 1.9-2 7.8 3.2 7.9 4.7 0 7.6-6.8 3.4-11.6-4-4.6-11.3-3.6-16 .2A21.4 21.4 0 0 0 225 207a22.5 22.5 0 0 0 0 9.2 20.9 20.9 0 0 0 3 7.5l1.3 1.7c.8.8 1 1.2 2 2a15 15 0 0 0 10.4 3.7c4.6-.2 7.3-3.4 6.8-7.3-.4-3.8-4.2-5.7-6.7-3.9-1.7 1.2-2.3 4.9.7 5.8 1.6.5 3.1-1.7 2-3M374 150.9c2.7-1.4 4.8-1.2 6.3 1a9.9 9.9 0 0 1 1.6 7.2 9.2 9.2 0 0 1-3.5 5.8"
            }),
            /* @__PURE__ */ jsx72("path", {
              strokeLinecap: "round",
              d: "M380.5 152c3.1-2 6.5-1.1 8.3 1.6 1.3 2 1.7 3.6 1.6 6.1a11.2 11.2 0 0 1-5.7 9.2"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M395 159.2c2.6.2 4.6 2.5 4.6 5.1 0 3.8-1 5.5-4 9.3-2.7 3.3-10.6 9-10.4 14.6 0 2.1 1.8 4 3.3 4.2"
            }),
            /* @__PURE__ */ jsx72("path", {
              strokeLinecap: "round",
              d: "M395.4 202.3c-1.5 1-3.3-.6-2.5-2.4.5-1.2 2.2-2.8 4.7-1.1 2.7 1.9 2 7.8-3.3 7.9-4.7 0-8-6.6-3.4-11.6 4-4.6 11.7-3.7 16.5.1 2 1.6 6.1 6 7 12 1 7 .9 15.6-6.4 21-3 2.1-7 3.1-10.6 3-4.6-.2-7.3-3.5-6.8-7.4.5-3.8 4-5.4 6.7-3.9 2.8 1.5 2.3 5.4-.7 5.8-1.7.2-3.1-1.7-2-3"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M392.9 199.9c.8-3.5 3.7-3.8 6.2-3.8 6.5.1 11.1 8 11.2 15.5 0 9.5-4 15.2-11 15.5-1.9 0-5-.8-5-3"
            }),
            /* @__PURE__ */ jsx72("path", {
              strokeLinecap: "square",
              d: "M397 198.3c6.9 1.6 9.3 7.8 9.3 13.8 0 4.9-.5 11.6-10 13.9"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M408.4 265.3a3.9 3.9 0 1 0-6.3 2.4"
            }),
            /* @__PURE__ */ jsx72("path", {
              strokeLinecap: "round",
              d: "M394.4 259.4c1.4 2 3 4.1 6.3 6m-1.3 10.5c-3.2-2.2-9.5-5-15-2.2a7.6 7.6 0 0 0-4.4 4.4 10 10 0 0 0 1.8 9.5c.9 1 2.7 2.6 5 2.7 3.8 0 4.7-2.6 4.8-3.2.4-2.8-1.2-3.9-2-4.1-.7-.3-2.8-.2-3.2 1.3-.2.5-.2 1.3.2 2"
            }),
            /* @__PURE__ */ jsx72("path", {
              strokeLinecap: "round",
              d: "M340.5 328.4c1 2.2-.2 3.2-1.6 3.4-2.2.3-3.3-1.4-3.4-3a4.4 4.4 0 0 1 4.3-4.7c2.3 0 4.1 1.5 5 3.5.3.7.5 1.5.5 2.4a5.8 5.8 0 0 1-1.4 4.1 7.5 7.5 0 0 1-5.4 2.5c-4.2.1-7.5-3.8-7.5-7.8 0-7.7 11.4-12 16-13a84 84 0 0 1 17.9-2.4c3.5-.1 6.2 0 10.1-.5 3.5-.3 5.4-.5 9-1.3a27.2 27.2 0 0 0 12.6-6.4c2.9-2.7 4.5-4.5 5.9-8.2a17 17 0 0 0-1.3-13.9 14.3 14.3 0 0 0-10.3-6.8c-3.7-.5-7 1.1-9 4.8-1 1.8-.6 4.8.1 6.2a6 6 0 0 0 4.8 3c3.8 0 4.7-2.6 4.8-3.2.4-2.8-1.2-3.9-2-4.2-.7-.2-2.8-.1-3.2 1.4-.2.5-.2 1.3.2 2"
            }),
            /* @__PURE__ */ jsx72("path", {
              strokeLinecap: "round",
              d: "M337.2 316.2c-4.8 2.1-8.4 3.7-11.4 8.5a9.9 9.9 0 0 0-1.2 4.9c0 2.7 1.1 5.7 3.3 7.6a8.3 8.3 0 0 0 6.7 2c2-.2 3.7-1.6 4-2.6"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M385.1 224.1c-2.3.8-3.9 4.2-3.9 7.5a8.4 8.4 0 0 0 4 7.5"
            }),
            /* @__PURE__ */ jsx72("path", {
              strokeLinecap: "round",
              d: "M387.6 236.4c-4 5.1-6.3 8.1-6.4 14.1 0 5.7 1.7 9.6 5.1 13.7"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "m365.9 152 .3-.5c1.7-2.4 4.7-3.1 6.9-1.5 2.6 2 3.3 5.4 2.6 9-.5 2.2-2 4.1-4 5.5"
            }),
            /* @__PURE__ */ jsx72("path", {
              strokeLinecap: "round",
              d: "M265.1 150.8c-2.6-1.2-4.7-1-6.3 1a8.7 8.7 0 0 0-1.6 7.2c.6 2.7 1.4 3.8 3.5 5.8"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M258.6 152a5.8 5.8 0 0 0-8.3 1.6 9.1 9.1 0 0 0-1.6 6.1c.2 4.2 2.8 7.6 5.8 9.2"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M249.7 154.8a6.8 6.8 0 0 0-6 6.6c0 4.5 1 6.3 3.5 9.6 2.5 3.4 10.7 9.6 10.7 16.7 0 4.3-1.2 7-4.3 8.4-2 1-4.3 0-5.4-1-2.6-2.4-1.5-6.5 1.2-7 3.3-.6 3.9 4.6.7 4.3"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M244 159.2c-2.5.2-5 2.3-5 5 0 3.8 1.5 5.6 4.6 9.4 2.6 3.3 10.1 9 9.9 14.5 0 2-1.5 4.6-2.9 4.3"
            }),
            /* @__PURE__ */ jsx72("path", {
              strokeLinecap: "round",
              d: "M238 236.1c1.3-2.9 4.4-1.6 4.6 0 .4 3.7-2.8 4.8-5.1 4.2a4 4 0 0 1-2.5-2 4.8 4.8 0 0 1-.4-3.7 4.9 4.9 0 0 1 .9-1.6 5 5 0 0 1 1.2-1.2c1-.6 1.9-.6 3.4-.6 5.5 0 10.4 6.5 12 13.4.6 2.2 1.3 7.3.3 12a22.4 22.4 0 0 1-5.8 11.3 25.8 25.8 0 0 1-10 5.8 7 7 0 0 1-3.9.1c-2.8-.9-4.6-3.5-3.2-7 1.2-2.6 5.4-4 7.3-.6.2.3.4.9.4 1.5 0 .9-.4 2-1 2.4-1.4.9-3.7.6-3.6-2"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M233.8 270.4c1 .4 1.6.3 2.9-.2l1.8-1c2.6-1.5 5.6-3.8 8.4-9.1a18.8 18.8 0 0 0 1.7-4.5c.3-1 .5-2.2.6-3.3a25.6 25.6 0 0 0-4.8-15.3c-1.1-1.6-2-2.5-4.2-2.6m-9.5 31a3.9 3.9 0 1 1 6.3 2.3"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M232.2 261.4a3.7 3.7 0 0 1 3.7-3 3.7 3.7 0 0 1 3.6 3.7 3.8 3.8 0 0 1-1 2.6"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M239.4 261.3a15.5 15.5 0 0 0 6.2-12.4c0-4.1-1.6-8.4-3.6-10"
            }),
            /* @__PURE__ */ jsx72("path", {
              strokeLinecap: "round",
              d: "M244.7 259.4a16.5 16.5 0 0 1-6.3 6"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M254.6 273.7c-1-2.2-2.8-3.2-5.8-3.5-3-.3-5.5.5-8.2 1.9a18.6 18.6 0 0 0-10.8 17 25 25 0 0 0 2 9.5c.9 1.6 3 9 15.3 14a86.1 86.1 0 0 0 25.7 3.9c10.4.4 20 .8 25.6 7.6"
            }),
            /* @__PURE__ */ jsx72("path", {
              strokeLinecap: "round",
              d: "M239.7 275.9c3.3-2.2 9.5-5 15.1-2.2a8 8 0 0 1 4.3 4.4 10 10 0 0 1-1.8 9.5c-.9 1-2.7 2.6-5 2.7-3.8 0-4.7-2.6-4.8-3.2-.4-2.8 1.2-3.9 2-4.2.7-.2 2.8-.1 3.2 1.4.2.5.2 1.3-.2 2"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M252.7 285.7c.3-1 .2-2.2-.8-3.3a5.1 5.1 0 0 0-6-1c-.7.5-1.6 1-2.4 2.2-.4.4-1 1.1-1.2 1.6-.7 1.1-1 2-1 2.5-2.5 7 1.5 14.4 6.5 17.6 4.4 2.8 8.8 3.6 14.4 4 2.5.3 4 .3 6.5.5h9.6a70.1 70.1 0 0 1 7.2 0c3 .3 5.1.4 7.6.8 1.6.2 3.5.5 5.4 1 .6 0 1.2.2 1.8.4l1.2.3c3.6 1.1 7 2.4 9.8 4.2.8.5 1.8 1 2.5 1.7l1.3 1.2c2 2 4 4 4.4 6.7v1.6c0 1.8-1.4 4.3-5.3 5"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M298.6 328.4c-1 2.2.2 3.2 1.6 3.4 2.2.3 3.3-1.4 3.5-3a4.4 4.4 0 0 0-4.4-4.7 5.5 5.5 0 0 0-5 3.5 6.9 6.9 0 0 0-.5 2.4 5.8 5.8 0 0 0 1.4 4.1 7.5 7.5 0 0 0 5.4 2.5c4.2.1 7.5-3.8 7.5-7.8 0-7.7-11.4-12-16-13a84 84 0 0 0-17.9-2.4c-3.5-.1-6.2 0-10.1-.5-3.5-.3-5.4-.5-9-1.3a27.2 27.2 0 0 1-12.5-6.4 17 17 0 0 1-4.7-22 14.3 14.3 0 0 1 10.3-6.9c3.8-.5 7 1.1 9 4.8 1 1.8.6 4.8-.1 6.2a6 6 0 0 1-4.8 3c-3.8 0-4.7-2.6-4.8-3.2-.4-2.8 1.2-3.9 2-4.2.7-.2 2.8-.1 3.2 1.4.2.5.2 1.3-.2 2"
            }),
            /* @__PURE__ */ jsx72("path", {
              strokeLinecap: "round",
              d: "m273.3 152-.4-.5c-1.7-2.4-4.7-3.1-6.9-1.5-2.6 2-3.3 5.4-2.5 9a9 9 0 0 0 4 5.5"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M366.8 159.6c-4 4.4-8.1 5.8-14.1 6-2 0-5.5-.6-7.6-2.1-1.3-1-2.8-2.6-1.9-5.5.6-1.9 3.7-7.2 3.8-10.9.3-5.6-1.9-8.7-5.3-9.9-6.2-2.2-13 4-17 5.4-2.1.7-3.2.8-5.1.8-2 0-3-.1-5.2-.8-4-1.4-10.7-7.6-17-5.4-3.4 1.2-5.5 4.3-5.3 10 .1 3.6 3.2 9 3.8 10.8 1 2.9-.5 4.5-1.9 5.5-2 1.5-5.7 2.1-7.5 2-6-.1-10.1-1.5-14.1-5.9"
            }),
            /* @__PURE__ */ jsx72("path", {
              strokeLinecap: "round",
              d: "M297.3 314.4c.8.3.2-.2 5.3 2a22 22 0 0 1 11.3 8.9 10.5 10.5 0 0 1 .9 7.3"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M297.7 336a8 8 0 0 0 3.2.9c4.2.1 7.5-3.8 7.5-7.8 0-2.8-1.5-5.2-3.6-7"
            }),
            /* @__PURE__ */ jsx72("path", {
              strokeLinecap: "round",
              d: "M298.6 328.4c-1 2.3.4 3.5 1.8 3.7 2.2.2 3.4-1.4 3.6-3a4.5 4.5 0 0 0-2.2-4.2"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M390.1 154.8c3.2 0 6 3.6 6 7.2 0 4.3-2.2 6.9-3.9 8.8-1.3 1.6-2.7 3-4.4 4.7"
            }),
            /* @__PURE__ */ jsx72("path", {
              strokeLinecap: "round",
              d: "M386.3 151.4a9 9 0 0 1 2.8 2.4c1.3 2 1.7 3.7 1.6 6.2-.2 4.2-3.2 7.1-6 9m-4.7-17.6.6.7c1.9 2.2 2 5.4 1.6 7.2a8.2 8.2 0 0 1-3.8 5.4m-5-14.4c2.6 2 3.4 5.4 2.5 9-.6 2.5-2.2 4-4.2 5.2m11.1 41.1c.3 1 .9 1.3 1.5 2a13.5 13.5 0 0 0 6.2 3.5c2.4.7 4.6.2 6.3-.9m-163 54c1.2 0 2.5.9 3.3 2.3.1.2.4.8.4 1.5 0 .9-.4 1.8-1 2.2-1.5 1-4 .5-4-2"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M241.5 231.3c5 1 9.7 6.9 11.2 13.3.6 2.3 1.3 7.3.3 12a22.4 22.4 0 0 1-6 11.4 16.5 16.5 0 0 1-2.1 1.9l-1 .7m-8-12.1c2 0 3.8 1.9 3.8 4a3.8 3.8 0 0 1-1 2.6"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M234.6 260.7c2.1 0 4.1 2 4.1 4.2a3.9 3.9 0 0 1-1.4 3"
            }),
            /* @__PURE__ */ jsx72("path", {
              strokeLinecap: "round",
              d: "M254 239.5a18 18 0 0 1 3.8 7.7m0 8.5a17.3 17.3 0 0 1-1.5 4 17.8 17.8 0 0 1-3.6 4.7"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M254.3 224.3c1.8 1.5 3 3 3.5 4.8"
            }),
            /* @__PURE__ */ jsx72("path", {
              strokeLinecap: "round",
              d: "M257.9 219.5a10 10 0 0 1-3.4 4.6m-9.2-17.2 2.2-.6 1.3-1 .8-1.1.7-1.8.3-1.5"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M241 199.3c-.7.2-1.6.4-2.5.8a9 9 0 0 0-3.5 3 17 17 0 0 0-2.2 12.7 15.8 15.8 0 0 0 2.3 5.6l1 1.4c1.4 1.3 2.6 2 4.6 1.7"
            }),
            /* @__PURE__ */ jsx72("path", {
              strokeLinecap: "round",
              d: "M253 189.8c-.3 1.3-1 2.9-3 2.7"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M245.7 198.5c-2-1.9-6-2.4-10.1.2L234 200a8.8 8.8 0 0 0-1.4 1.6 17.5 17.5 0 0 0-2.4 5c-.7 3-.7 5.6-.6 6.3 0 1 .2 1.9.3 2.7.6 2.8 1.4 4.8 2.3 6.2.9 1.5 3 5 7.7 5.4 1.8.1 4.8-.7 5-3"
            }),
            /* @__PURE__ */ jsx72("path", {
              strokeLinecap: "round",
              d: "M363.8 157c.3-1.6 2.3-1.9 3-1 1.2 1.6.4 4.2-2 4.9a4 4 0 0 1-3.8-1.4c-1-1.3-.9-2.8-.5-4 .2-.8.9-1.5 1.7-2.2 2.7-2 7.1-1.6 8.6 2 1.8 4.4-2.2 7.8-6 10.3-4.6 3.2-10 3.8-14 3.7-9.2 0-16.1-4.4-20.7-7-1-.5-2.1-.4-2.7.3a2 2 0 0 0 .3 2.7"
            }),
            /* @__PURE__ */ jsx72("path", {
              strokeLinecap: "round",
              d: "M365.6 155.5c1 0 1.2.4 1.5.8 1.2 1.5.3 4.1-2 4.9m17.8 51.5c-3.5 3.8-.2 10.3 2.4 11.8.9.7 1.3.3 2 .7"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M383.1 205.4c-1.1.8-1.5 1.7-1.6 3.3a5.3 5.3 0 0 0 1.4 4 14 14 0 0 0 9.3 3.7c2 0 4-.4 6-1.7a9 9 0 0 0 3.8-5.4m-20.8 61.8-.2 2.5a18.9 18.9 0 0 1-2 7 18.7 18.7 0 0 1-4.2 5.6 19.6 19.6 0 0 1-5.9 4 24.6 24.6 0 0 1-6.5 2.3 43.8 43.8 0 0 1-13.2.6c-2.7-.2-4.1-.5-6.8-.8-2.2-.1-3.4-.3-5.6-.3a28.3 28.3 0 0 0-10.9 1.9c-2.7 1-5.7 3-6.4 3.8-.6-.9-3.7-2.8-6.3-3.8a22 22 0 0 0-5.2-1.5c-2.2-.4-3.5-.4-5.8-.4-2.2 0-3.4.2-5.6.4-2.6.2-4 .6-6.7.7-2.5.2-3.9.3-6.3.2a33 33 0 0 1-7-.8 24.6 24.6 0 0 1-6.5-2.2 19.6 19.6 0 0 1-5.8-4.1 18.7 18.7 0 0 1-4.2-5.7 19 19 0 0 1-2-6.9c-.2-1-.2-2.5-.2-2.5V169.3h123.2z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs47("g", {
          fill: "#c7b37f",
          stroke: "#c7b37f",
          children: [
            /* @__PURE__ */ jsx72("path", {
              strokeWidth: 0.3,
              d: "M248 285.6a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0zM232.5 268c0-1.3.8-2.3 1.8-2.3s1.7 1 1.7 2.3c0 1.2-.8 2.2-1.7 2.2-1 0-1.8-1-1.8-2.2z"
            }),
            /* @__PURE__ */ jsx72("path", {
              stroke: "none",
              d: "M241.3 223.6c0-1 .8-1.8 1.7-1.8 1 0 1.7.8 1.7 1.8s-.7 1.8-1.7 1.8-1.7-.8-1.7-1.8M272 158c0-1 .5-2 1.4-2 .9-.1 1.7.6 1.8 1.6 0 1-.5 2-1.4 2-.9.1-1.6-.6-1.8-1.6"
            })
          ]
        }),
        /* @__PURE__ */ jsxs47("g", {
          stroke: "#c7b37f",
          strokeLinecap: "round",
          strokeWidth: 0.6,
          children: [
            /* @__PURE__ */ jsx72("path", {
              d: "M239.3 234c-.4.1-.6.2-.8.5-.3.3-.4.4-.6.9l-.2 1.2m4.7 26.7 1-1 .6-1 .5-1 .7-1.3m-1.3 14-1.5.7-1.1.6a17.4 17.4 0 0 0-1.3.8l-1.2 1m15-37.9-.8-.8-1-.8-.9-.8"
            }),
            /* @__PURE__ */ jsx72("path", {
              strokeLinecap: "butt",
              d: "m254.2 225-1.2.5a5.1 5.1 0 0 1-1.5.3"
            }),
            /* @__PURE__ */ jsx72("path", {
              d: "M237.4 208.4c.2.6.2 1 .5 1.5.2.7.5 1.1.9 1.7a8.3 8.3 0 0 0 2.6 2.7l1.5.8m-1-5.8 1.3.6a7.4 7.4 0 0 0 3 .6l1.8-.1m7.2-40.7-2-1.2c-.9-.5-1.3-.9-2-1.5a9.3 9.3 0 0 1-1.1-1.3l-.8-1.3m7.5-4.6.6 1.7a7.8 7.8 0 0 0 1.4 2c1 1 1.7 1.3 2.8 2.2m1.4-6c.3.7.3 1 .7 1.6.2.5.4.8.8 1.2l1.3 1.3c.7.6 1.2.7 2 1.1"
            })
          ]
        }),
        /* @__PURE__ */ jsx72("path", {
          fill: "#703d29",
          strokeWidth: 0.2,
          d: "M333.3 151.6c0-1.7-1.7-1.8-2.4-1.8-1.8 0-2.3 1.1-4.6 2.3a11.9 11.9 0 0 1-6.7 2 12 12 0 0 1-6.7-2c-2.3-1.2-2.7-2.3-4.6-2.3a2.3 2.3 0 0 0-2.2 2.4v.9l.3.2c0-.8.1-1.2.5-1.7a2.2 2.2 0 0 1 1.6-.8c1.8 0 2.5 1.2 4.8 2.4 3 1.6 4.2 1.9 6.7 2a12 12 0 0 0 6.8-2c2.3-1.2 3-2.5 4.8-2.5.6 0 1 .4 1.3 1v.9l.2.1c0-.3.2-.4.2-1z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs47("g", {
      fill: "#703d29",
      children: [
        /* @__PURE__ */ jsx72("path", {
          d: "M264.4 294c.5-.5.9-.3 1-.6 0-.2 0-.2-.3-.3l-.9-.2-.8-.4c-.1 0-.4-.2-.5 0-.1.4 1 .4.6 1.4a3.7 3.7 0 0 1-.8 1.2l-2.6 3-.2.1v-4.3l.1-1.8c.2-.4.8 0 .9-.4 0-.1 0-.2-.3-.3-.2 0-.5 0-1.1-.3l-1-.5c-.2 0-.5-.2-.6 0l.1.3c.4.2.5.4.5 1v7.4c0 .5.1.6.2.7.1 0 .2 0 .4-.3z"
        }),
        /* @__PURE__ */ jsx72("path", {
          d: "M267.5 295.2c.3-1.1 1-.4 1-.8.1-.2 0-.2-.2-.3l-1.3-.4c-.4 0-.8-.3-1.2-.4 0 0-.3-.1-.4 0-.1.5 1.1.5.8 1.5l-1.7 5.5c-.3 1-1 .6-1.1 1v.1l1.2.4 1.6.5h.3c.2-.4-1.2-.3-.7-1.7zm3.7 1c.2-.6.5-.5.9-.4 1 .3 1.4 1.3 1 2.5-.2.6-.4 1.2-2 .8-.3-.1-.7-.2-.6-.5l.7-2.3zm-2.8 5c-.5 1.4-1.2.8-1.3 1.2 0 .2.2.2.3.3l1.6.4.8.3h.4c.1-.5-1-.3-.7-1.5l.6-2c.1-.4.1-.5.6-.3.6.1.7.3.8.8l.3 2c.2.9.3 1.7 1 2 .5 0 1.2 0 1.4-.4l-.2-.2h-.3s-.3 0-.3-.3l-.7-3.6c0-.2.4-.2.8-.3a2 2 0 0 0 1-1.3c.1-.5.4-2.2-1.8-2.9l-2.1-.5-1.2-.4h-.3c-.1.5 1.1.4.7 1.7zm8.4 2.5c-.4 1.4-1.4.5-1.5 1 0 .2.1.3.3.3l1.5.3 1.4.4c.3 0 .5.2.6-.1 0-.3-1.3-.3-1-1.8l1.3-5.2c0-.6.2-.6.6-.5l1 .2c1.1.3.5 1.5 1 1.6.2 0 .2-.4.2-.6l.1-1v-.4l-3.3-.7-3.2-.8c-.1 0-.2 0-.2.2l-.5 1.5c-.1.1-.2.4 0 .4.5.1.5-1.5 1.7-1.2l.9.2c.4.1.5.2.4.8zm12.7-3.3c.4-.6.8-.5.9-.7 0-.2-.2-.2-.4-.3h-.9l-.9-.3c-.1 0-.4-.1-.4.1-.1.4 1 .2.8 1.3 0 .2-.1.6-.6 1.3l-2 3.3-.3.2v-.2l-.7-4a5.4 5.4 0 0 1-.1-1.8c0-.5.7-.2.7-.5 0-.2 0-.2-.4-.3l-1.1-.1c-.4 0-.7-.2-1-.3-.2 0-.5-.1-.6.1l.1.2c.5.2.6.4.7.9l1.3 7.3c.1.5.2.7.3.7.1 0 .2 0 .4-.3zm.6 6.8c0 .3 0 .3.2.5.6.2 1 .6 1.7.7 1.4.2 2.6-.7 2.8-2.2.3-1.5-.3-2.1-1.4-2.9-1.3-.9-1.8-1.1-1.7-2 .1-.7.7-1 1.4-1 1.8.3 1.6 2.6 1.8 2.6.3 0 .3-.1.3-.4l.2-1.6v-.4h-.6c-.4 0-.7-.5-1.6-.7-1.2-.2-2.3.7-2.5 2-.2 1.2.4 1.8 1.2 2.4 1.6 1.1 2.2 1.4 2 2.4-.1 1-.9 1.4-1.7 1.3-1.2-.2-1.6-1.4-1.8-2.6 0-.2 0-.3-.2-.3s-.2.3-.2.5v1.7zm15.8-4.5c.3-.7.8-.6.8-.9 0-.2-.1-.1-.4-.2h-.9l-.9-.1c-.1 0-.4 0-.4.2 0 .4 1 0 1 1.1 0 .2-.1.6-.5 1.4l-1.8 3.5-.1.3-.1-.3-1.1-4a5.4 5.4 0 0 1-.3-1.6c0-.5.7-.3.7-.6 0-.2 0-.2-.4-.2h-1.2l-1-.2c-.2 0-.5-.1-.6.1l.2.2c.4.2.6.3.7.8l2.1 7.1.4.7c.1 0 .2 0 .3-.4z"
        }),
        /* @__PURE__ */ jsx72("path", {
          d: "M307.6 308.5c0 1.2-1 1-1 1.5 0 .2.1.1.3.1h2.2l.4-.1c0-.6-1.4.2-1.4-2v-4.2l.1-.1.2.1 5.1 6.3.3.1.2-.3v-6.7c0-1.3 1-1 1-1.3 0 0 0-.2-.3-.2h-2.3c-.2 0-.2.1-.2.2 0 .4 1.3.2 1.3 1.3v4l-.1.4-.4-.3-4.2-5.3c-.2-.3-.1-.3-.4-.3h-1.8l-.2.1c0 .6 1.2-.2 1.2 2.1zM318 303c0-1.1.8-.7.8-1.1 0-.1 0-.2-.4-.2h-2.6s-.3 0-.3.2c0 .4 1.1 0 1.1 1.2v5.7c0 1.1-.8.8-.8 1.2 0 0 0 .2.2.2h2.8c.2 0 .3 0 .3-.2 0-.4-1.2.2-1.2-1.3zm4.5 5.5c0 1.5-1.2 1-1.2 1.4 0 .2.2.2.4.2h3c.3 0 .5 0 .5-.3s-1.4 0-1.4-1.4V303c0-.6 0-.6.5-.6h1c1.2-.1.8 1.2 1.3 1.2.2 0 .1-.4.1-.6l-.1-1c0-.2 0-.4-.2-.4l-3.3.1h-3.3l-.2.3-.1 1.6.1.4c.5 0 .2-1.6 1.4-1.6h.9c.4 0 .5 0 .6.6v5.6zm6.3-2.2h-.4l.1-.5.7-2.2v-.2l.2.1 1 2.1.2.4c0 .2-.2.2-.4.2zm1.8.5c.3 0 .3 0 .8 1l.2.8c0 .7-.7.6-.7 1 0 .1.2.1.4 0h1.2l1.3-.1c.3 0 .4 0 .4-.2 0-.4-.6 0-1-.7l-3.4-7-.3-.4c-.2 0-.2.2-.3.4L327 309c-.2.7-.8.7-.7 1h2.3c.2-.1.5 0 .5-.3s-1.2 0-1.3-.9l.2-1c.2-.8.4-.8.6-.8l2.1-.2zm8.3-5c-.1-.8 0-.8 1.2-1 2-.2 1.4 1.3 2 1.2.2 0 0-.4 0-.6l-.1-1.1c0-.1-.1-.2-.3-.2-1 0-1.7.2-2.4.3l-2.8.4c-.2 0-.3 0-.3.2.1.5 1.3 0 1.4 1l.7 5.5c.2 1.5-.7 1-.6 1.5 0 0 0 .1.2 0l1.4-.1 1.2-.1c.3 0 .5 0 .5-.3s-1.2.1-1.4-1.2l-.2-1.7c-.1-.7-.1-.9.3-1h.8c1.1-.2 1 1.1 1.3 1 .3 0 .2-.4.1-.5l-.3-2.1c0-.3-.2-.3-.2-.3-.3 0-.1 1.1-1 1.2l-.7.1c-.5.1-.5 0-.6-.5zm4 2.8c.4 2.3 2.1 3.7 4.2 3.3 3.4-.7 3.5-3.6 3.2-5.3-.5-2.5-2.3-3.7-4.4-3.3-2.5.5-3.5 2.7-3 5.3m1.1-1c-.3-1.6 0-3.4 1.7-3.7 1.4-.3 3 .8 3.4 3.4.3 2 0 3.6-1.8 4-1.9.4-3-2-3.3-3.6zm8.3-4.1c-.1-.7.2-.8.6-.9 1-.2 1.8.5 2.1 1.6.2.7.3 1.4-1.3 1.8-.3 0-.7.1-.8-.2l-.5-2.3zm0 5.7c.4 1.4-.5 1.3-.5 1.6.1.3.3.2.4.1.6 0 1-.3 1.6-.4l1-.2c.2 0 .2-.1.2-.2 0-.4-1 .3-1.3-1l-.5-2c0-.4-.2-.4.4-.5.5-.2.7-.1 1.1.3l1.3 1.6c.5.6 1 1.3 1.8 1.1.5-.1 1-.5 1-.9l-.2-.1-.3.1s-.3.1-.4 0l-2.4-2.9.5-.6c.2-.4.4-.9.2-1.6-.1-.5-.7-2.1-3-1.6l-2.1.6-1.2.2c-.2 0-.3.1-.2.2 0 .5 1.1-.2 1.4 1zm8.7-2c.3 1.4-1 1.2-.9 1.6 0 .3.3.2.5.2l1.4-.5 1.5-.3c.3 0 .5 0 .4-.4 0-.3-1.3.4-1.7-1l-1.3-5.3c-.2-.5 0-.6.3-.7l1-.2c1.1-.4 1.1 1 1.5.9.3 0 0-.5 0-.7l-.4-1s0-.3-.2-.2l-3.2.9-3.2.7v.3l.1 1.6c0 .2 0 .4.3.4.5-.1-.3-1.6 1-1.9l.8-.2c.4-.1.6 0 .7.5zm5.5-7.3c-.3-1 .6-.9.4-1.3h-.3l-1.4.4-1.2.3s-.3 0-.3.2c.1.4 1.2-.2 1.5.8l1.6 5.6c.2 1-.6 1-.5 1.3 0 .1 0 .2.2.1l1.1-.3 1.6-.4c.3 0 .3-.1.3-.3-.1-.3-1.1.5-1.5-.9zm2.3 2.7c.7 2.3 2.6 3.4 4.7 2.7 3.2-1.1 3-4.1 2.4-5.7-.8-2.4-2.8-3.3-4.8-2.7-2.4.9-3.2 3.2-2.3 5.7m1-1c-.6-1.7-.6-3.5 1.1-4 1.3-.5 3 .4 3.9 2.9.6 1.8.5 3.6-1.2 4.2-1.8.6-3.2-1.5-3.8-3.2zm7.6-5.5c-.2-.7 0-.8.4-1 1-.3 2 .3 2.4 1.4.2.6.4 1.3-1.1 1.9-.3 0-.7.2-.8 0zm.8 5.6c.6 1.4-.4 1.4-.2 1.7 0 .3.2.1.4.1l1.5-.7.9-.2c.2-.1.2-.2.2-.3-.2-.4-1 .4-1.4-.8l-.8-1.9c-.2-.4-.2-.5.3-.7.5-.2.7-.1 1.1.3l1.6 1.4c.5.5 1.1 1.1 2 .8.3-.2.9-.7.7-1l-.2-.1-.2.2h-.5l-2.8-2.5.4-.7a2 2 0 0 0 0-1.6c-.1-.6-1-2-3.1-1.2l-2 .9-1.2.4-.2.2c.2.4 1.1-.4 1.6.8l2 5z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs47("g", {
      fill: "#fedf00",
      transform: "matrix(.64 0 0 .64 0 16)",
      children: [
        /* @__PURE__ */ jsx72("path", {
          fill: "#d52b1e",
          d: "M412.7 249.3h82.1v82h-82.1z"
        }),
        /* @__PURE__ */ jsx72("path", {
          id: "ad_svg__a",
          fill: "#fff",
          d: "M451.2 313.8s0 3-.8 5.3c-1 2.7-1 2.7-1.9 4a13.2 13.2 0 0 1-3.8 4c-2 1.2-4 1.8-6 1.6-5.4-.4-8-6.4-9.2-11.2-1.3-5.1-5-8-7.5-6-1.4 1-1.4 2.8-.3 4.6a9 9 0 0 0 4.1 2.8l-2.9 3.7s-6.3-.8-7.5-7.4c-.5-2.5.7-7.1 4.9-8.5 5.3-1.8 8.6 2 10.3 5.2 2.2 4.4 3.2 12.4 9.4 11.2 3.4-.7 5-5.6 5-7.9l2.4-2.6 3.7 1.2z"
        }),
        /* @__PURE__ */ jsx72("use", {
          xlinkHref: "#ad_svg__a",
          width: "100%",
          height: "100%",
          transform: "matrix(-1 0 0 1 907.5 0)"
        }),
        /* @__PURE__ */ jsx72("path", {
          d: "m461.1 279 10.8-11.7s1.6-1.3 1.6-3.4l-2.2.4-.5-1.2-.1-1.1 3-.7V260l.3-1.3-3.2.2.3-1.4.5-1 1.9-.4h1.9c1.8-3.4 9.2-6.4 14.4-1 3.8 4 3 11.2-2 13.2a6.3 6.3 0 0 1-6.8-1.1l2-4c2.7 1.7 5-.3 4.8-2.4-.2-2.7-2-4.3-4.3-4.5-2.3-.2-4 1-5 3-.6 1.3-.3 2.2-.5 3.6-.2 1.5 0 2.3-.5 3.8a8.8 8.8 0 0 1-2.4 3.6l-11 12-43 46.4-3.2-3z"
        }),
        /* @__PURE__ */ jsx72("path", {
          fill: "#fff",
          d: "M429.5 283s2.7 13.4 11.9 33.5c4.7-1.7 7.4-2.8 12.4-2.8 4.9 0 7.6 1 12.3 2.8A171 171 0 0 0 478 283l-24.2-31z"
        }),
        /* @__PURE__ */ jsx72("path", {
          d: "m456.1 262.4 16.8 21.7s-2.2 10.5-9 26.3c-2.7-.6-5-1.1-7.8-1.3zm-4.7 0-16.8 21.7s2.2 10.5 9 26.3c2.7-.6 5-1.1 7.8-1.3z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs47("g", {
      fill: "#d52b1e",
      children: [
        /* @__PURE__ */ jsx72("path", {
          fill: "#fedf00",
          d: "M322.3 175.5h52.6V228h-52.6z"
        }),
        /* @__PURE__ */ jsx72("path", {
          d: "M329.7 175.5h7.8V228h-7.8zm15 0h7.8V228h-7.8zm15 0h7.9V228h-7.9z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs47("g", {
      fill: "#d52b1e",
      stroke: "#d52b1e",
      strokeWidth: 0.5,
      children: [
        /* @__PURE__ */ jsx72("path", {
          fill: "#fedf00",
          stroke: "none",
          d: "M264.3 273.5c.1 1 .5 2.6 1.4 4.3 1 1.5.6 1.4 2.7 3.8a15.3 15.3 0 0 0 4 2.9 32.7 32.7 0 0 0 15 2.6c2.7-.1 4.8-.4 6.6-.7a71 71 0 0 1 11-.6c1.5 0 3 .3 4.7.6 3.5.7 7 2 7 2v-54.7h-52.6V271l.2 2.4z"
        }),
        /* @__PURE__ */ jsx72("path", {
          strokeWidth: 0.3,
          d: "m270.4 283.1 2.5 1.5 3.4 1.2v-52.2h-5.9zm29.2 2.4v-51.9h-5.8v52.8l5.8-.7zm11.7-51.9h-5.8v52.1c1.9.2 3.8.6 5.8 1zm-23.4 0V287s-3.8.2-5.8 0v-53.4z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs47("g", {
      transform: "matrix(.64 0 0 .64 0 16)",
      children: [
        /* @__PURE__ */ jsx72("path", {
          fill: "#fedf00",
          d: "M585.5 402.4a20.8 20.8 0 0 1-2.2 6.6c-1.5 2.3-1 2.3-4.3 6a26.3 26.3 0 0 1-13 7 51.8 51.8 0 0 1-16.6 1.6c-4.3-.2-7.5-.7-10.3-1-3.8-.6-6.7-.9-11-1a62.9 62.9 0 0 0-6.2 0 83.3 83.3 0 0 0-18.3 4.2V340h82.2v58.5z"
        }),
        /* @__PURE__ */ jsxs47("g", {
          id: "ad_svg__b",
          children: [
            /* @__PURE__ */ jsx72("path", {
              fill: "#d52b1e",
              d: "m524.6 347-.6.2-.8.8c-.4.4-.7.5-1.2.8l-.6.5c-.3.3 0 .6-.3 1-.1.4-.3.6-.6 1-.4.4-.7.5-1 1l-1.2 1-.3.1h-.6c-.4.2-.5.6-.8.8l.3.6.8 1.4c.2.3.2.7.5.8.5.2.9.2 1.3.1.8.2 1.3.2 2 .5l1.5.8c.5.3.8.4 1.3.5h1.8v.3l2 1a1.7 1.7 0 0 0-.1.4c-.1.3-.2.7-.1.8.6 1.9 1.2 3 1.5 3.2.6.2.8.9 1.1 1.5l-.3.3c-.6.6-1.2 1-1.7 1.8-.7 1.2-1.2 1.2-.3 2.8l1.5 2.4c.4.7.6 1.2.8 2 .2.7.3 1.2.3 2l1 .3.7-.6.6-1.2v-1c-.2-.1-.3-.4-.2-.7 0-.4.5-.3.7-.6.3-.5-.4-.8-.7-1.1-.6-.7-1.4-.9-1.6-1.9 0-.2 0-.4.4-.7l2-1.8c.2.1.6.2 1 .1l1.3.4c.6.2.9 0 1.2 0h.4l.1.6c.1 1-.1 3 .2 3.5l.3.6.2.6v2l-.2 1.7c0 .4-.2.7-.5 1-.2.4-.6.4-1 .7v1l1.1.5 1.3.3.7-.3.1-.6.5-.5c.4-.2.8 0 .9-.1.2-.3 0-.4 0-.8 0-.6-.2-1-.3-1.6a11.8 11.8 0 0 1-.1-2.8c0-.6 0-1 .2-1.5.1-1 .4-1.4.6-2.2.3-1 .3-1.6.4-2.5a24.4 24.4 0 0 0 10.1-.6c.8.7 1.7 1.2 2.7 1.6v1c0 .3 0 .4.2.7l.3.3c.3 0 .5 0 .7-.2.2-.2.2-.4.2-.7v-.7h1.8v1.1c.1.3.3.4.5.4a.7.7 0 0 0 .6 0c.3-.2.2-.6.3-1v-.7l1-.4a5.1 5.1 0 0 1 0 .9l-.3.9c-.2.6-.5.8-.8 1.4-.4.6-.5 1-1 1.5l-.6.7-.6.9-.9 1c-.7.6-1.2.2-2 .9l-.3 1 1.4.6 1.3.2.4-.2c0-.3 0-.6.3-.8.2-.3.4-.3.7-.4.4 0 .8 0 1-.2.4-.3.4-1 .7-1.5a12.7 12.7 0 0 1 3-3.9l1.7-1.4c.2-.4.5-.5.5-1l-.2-.6-.2-1c1.5.7 1 .7 1.2 1.4.3.6 0 1 .1 1.7.1.8.5 1.1.5 1.9.1.9-.1 1.4-.3 2.3-.1.8-.1 1.3-.5 2a3.8 3.8 0 0 1-1.1 1.5l-.6.5-.1 1 1.1.4 1.6.4.4-.3c.2-.7 0-1.7.4-1.7.4-.1.7 0 .8-.3v-.7l.7-4.5.4-1.9.4-1.7c.7-2-.2-2.3-1-3.6-.5-.7-.7-1-.7-1.5V362a42.7 42.7 0 0 1 0-2.8l.4-.2c1.2-.7 1.7-.9 2.4-2.5a3.4 3.4 0 0 0 .3-1.5v-1l-.4-1a3.2 3.2 0 0 0-.6-.8c-.7-1-1.7-1.1-2.7-1.5-1.5-.5-2.5-.4-4-.5-1.8-.2-2.7-.2-4.4 0-2 0-3.1.4-5.1.7l-4.9.4c-2.3 0-4.4-.5-5.8-.4-2.4.2-2.5.8-6.2 1.1a67 67 0 0 1-3.8.2l-2.2-.7c.9-.3 1.1-.5 1.5-1 .3-.4.2-.7.6-1.1l.7-1a2.2 2.2 0 0 0-.9-.4h-1a3 3 0 0 0-1.2.3l-.8.6-2.2-1.2a8.8 8.8 0 0 0-3-.9zm2 11.8"
            }),
            /* @__PURE__ */ jsxs47("g", {
              fill: "none",
              stroke: "#fedf00",
              strokeLinecap: "round",
              children: [
                /* @__PURE__ */ jsx72("path", {
                  d: "m568.8 359.5-.8.3c-.9.4-1.6.4-2.6.5-2.6.2-4.3-1.1-7-.9-1.4.1-2 1.2-3.5 1.6a9.3 9.3 0 0 1-1.7.2l.5-1s-1.2.3-2 .3a7.5 7.5 0 0 1-1.6-.2l1-1-1.3-.2a4 4 0 0 1-1-.7 20.5 20.5 0 0 0 1.7-.3c1.5-.4 2-1.2 3.9-1.4 1.1 0 3 0 7.6.8 3 .5 4.4.2 5.5-.3.8-.3 1-1 1.1-1.8.1-.8-.4-1.4-.8-1.8-.1 0-.5-.3-1.1-.4"
                }),
                /* @__PURE__ */ jsx72("path", {
                  fill: "#fcd900",
                  strokeLinecap: "butt",
                  strokeWidth: 0.5,
                  d: "M524.8 350.6c-.5 0-.9 0-1.3.3-.5.3-.6.7-1 1.1.5.1.8.4 1.2.3.4 0 .5-.2.8-.5.3-.4.4-.7.4-1.2z"
                }),
                /* @__PURE__ */ jsx72("path", {
                  d: "M536 363.8a13.6 13.6 0 0 0 1 2.3c.2.8 0 1.2.2 2v1.6m6.8-7-.3 1.3-1 3.5v.7m-11-4c.9.2.6 3.3 1.9 4"
                }),
                /* @__PURE__ */ jsx72("path", {
                  strokeLinecap: "butt",
                  d: "m560.1 369.8.4-.3a8.2 8.2 0 0 0 2.7-1.8"
                }),
                /* @__PURE__ */ jsx72("path", {
                  d: "M552.4 368c3.5-.9 5.9-2.6 7.6-2.9m-4-1.5h.8c1.5-.3 1.7.6 2.7 1.2 1.9 1 2.1 2.3 4.3 3.4l.4.1.8.4"
                }),
                /* @__PURE__ */ jsx72("path", {
                  fill: "#fcd900",
                  strokeLinecap: "butt",
                  strokeWidth: 0.5,
                  d: "M517.7 354.5h.7l.8-.2c.3 0 .5 0 .7.2.2 0 .2.1.3.3 0 .2.2.3.1.5 0 .2-.3.4-.6.4-.2 0-.4 0-.5-.3a.5.5 0 0 1 0-.4 1 1 0 0 1-.9 0 1 1 0 0 1-.6-.5z"
                })
              ]
            }),
            /* @__PURE__ */ jsx72("path", {
              fill: "#0065bd",
              d: "m525.1 364.2-2-.9c.4-.2.7-.2 1-.5.3-.4.3-.8.5-1.3s.2-1 .7-1.4c.3-.2.8-.2 1.1-.1.4 0 .8.4.9.7 0 .6-.2 1-.3 1.5 0 .6-.3.9-.2 1.4 0 .4.2.6.4 1l-2-.4zm-1 1a.6.6 0 1 1 .7.5.6.6 0 0 1-.7-.6zm-1.7-16.6h-.2c-.4-.4-.4-.8-.6-1.2a4 4 0 0 1-.3-1.2v-2c0-.3 0-.6-.2-.9 0-.2-.4-.3-.3-.4 0-.1.3 0 .4 0 .4 0 .6.1 1 .4.3.3.5.6.6 1l.4 1.5.3.8.5.6-.7.8zm3.6 10.6 2.2 1a9.2 9.2 0 0 0 3.5-3.8c.9-1.8 1-2.7 1.4-4.4l-1.8-.5h-.4c-.5 1.8-.7 2.7-1.6 4.2-.8 1.3-1.7 2.3-2.6 3zm5 18.2.8-1.3 1.4-1.1h.4a8.7 8.7 0 0 1-.5 2.8l-.4 1-.5.5c-.5-.8-1.3-1.3-1.3-2zm33 1.8 1.4.6 1.5.9v.5l-1.5.2a8.4 8.4 0 0 1-1.3 0h-1l-.6-.4c.5-.7.8-1.6 1.4-1.8zm-9.8-2 1.4.5 1.5 1c0 .1.1.3 0 .4a9 9 0 0 1-2.7.3l-1-.1-.7-.3c.6-.7.9-1.7 1.5-1.8m-17.4 2.1 1.5.5 1.5 1v.5a9 9 0 0 1-2.8.2h-1l-.6-.4c.5-.7.8-1.6 1.4-1.8m-9-29.8c-.6-.3-1-1-.6-1.6.1-.2.4-.2.6-.4.2-.3.1-.5 0-.8l-.1-1-.2-1c0-.6 0-1 .4-1.6.2-.3.7-.6.8-.6.2.1 0 .5 0 .8 0 .5.1.7.3 1.2l.7 1.3c.2.6.4.8.4 1.4 0 .5 0 .7-.2 1.2a2 2 0 0 1-.6.8 2 2 0 0 1-.8.4 1.1 1.1 0 0 1-.6 0z"
            })
          ]
        }),
        /* @__PURE__ */ jsx72("use", {
          xlinkHref: "#ad_svg__b",
          width: "100%",
          height: "100%",
          y: 36.6
        })
      ]
    }),
    /* @__PURE__ */ jsx72("path", {
      fill: "none",
      stroke: "#703d29",
      strokeWidth: 0.5,
      d: "M264.1 175.5h52.6V228h-52.6zm58.2 0h52.6V228h-52.6zm-58 98c.1 1 .5 2.6 1.4 4.3 1 1.5.6 1.4 2.7 3.8a15.3 15.3 0 0 0 4 2.9 32.7 32.7 0 0 0 15 2.6c2.7-.1 4.8-.4 6.6-.7a71 71 0 0 1 11-.6c1.5 0 3 .3 4.7.6 3.5.7 7 2 7 2v-54.7h-52.6V271l.2 2.4zm110.4 0a13 13 0 0 1-1.4 4.3c-1 1.5-.6 1.4-2.7 3.8a15.4 15.4 0 0 1-4 2.9c-1.3.7-2.3 1-4.4 1.6a32.6 32.6 0 0 1-10.6 1c-2.7-.1-4.8-.5-6.5-.7a71 71 0 0 0-7.2-.6 40.5 40.5 0 0 0-3.9 0c-1.5 0-3 .3-4.7.6-3.5.7-7 2-7 2v-54.8H375v37.5l-.2 2.4z"
    })
  ]
});
var Ad_default = SvgAd;

// src/country-flag-icons/generated/Ae.tsx
init_esm_shims();
import { jsx as jsx73, jsxs as jsxs48 } from "react/jsx-runtime";
var SvgAe = (props) => /* @__PURE__ */ jsxs48("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx73("path", {
      fill: "#00732f",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsx73("path", {
      fill: "#fff",
      d: "M0 160h640v160H0z"
    }),
    /* @__PURE__ */ jsx73("path", {
      fill: "#000001",
      d: "M0 320h640v160H0z"
    }),
    /* @__PURE__ */ jsx73("path", {
      fill: "red",
      d: "M0 0h220v480H0z"
    })
  ]
});
var Ae_default = SvgAe;

// src/country-flag-icons/generated/Af.tsx
init_esm_shims();
import { jsx as jsx74, jsxs as jsxs49 } from "react/jsx-runtime";
var SvgAf = (props) => /* @__PURE__ */ jsxs49("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsxs49("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      children: [
        /* @__PURE__ */ jsx74("path", {
          fill: "#000001",
          d: "M0 0h640v480H0z"
        }),
        /* @__PURE__ */ jsx74("path", {
          fill: "#090",
          d: "M426.7 0H640v480H426.7z"
        }),
        /* @__PURE__ */ jsx74("path", {
          fill: "#bf0000",
          d: "M213.3 0h213.4v480H213.3z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs49("g", {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#bd6b00",
      strokeWidth: 0.5,
      transform: "translate(1 27.3) scale(1.06346)",
      children: [
        /* @__PURE__ */ jsx74("path", {
          d: "M319.5 225.8h8.3c0 3.2 2 6.6 4.5 8.5h-16c2.5-2.2 3.2-5 3.2-8.5z"
        }),
        /* @__PURE__ */ jsx74("path", {
          stroke: "none",
          d: "m266.7 178.5 4.6 5 57 .2 4.6-5-14.6-.3-7-5h-23l-6.6 5.1z"
        }),
        /* @__PURE__ */ jsx74("path", {
          d: "M290 172.7h19.7c2.6-1.4 3.5-5.9 3.5-8.4 0-7.4-5.3-11-10.5-11.2-.8 0-1.7-.6-1.9-1.3-.5-1.6-.4-2.7-1-2.6-.4 0-.3 1-.7 2.4-.3.8-1.1 1.5-2 1.6-6.4.3-10.6 5-10.5 11.1.1 4 .6 6.4 3.4 8.4z"
        }),
        /* @__PURE__ */ jsx74("path", {
          stroke: "none",
          d: "M257.7 242.8H342l-7.5-6.1h-69.4z"
        }),
        /* @__PURE__ */ jsx74("path", {
          d: "m296.4 219.7 1.5 4.6h3.5l-2.8-4.6zm-2 4.6 1 4.6h4l-1.5-4.6zm7 0 2.8 4.6h5.9l-4.6-4.6zm-34.5 10.4c3.1-2.9 5.1-5.3 5.1-8.8h7.6c0 2 .7 3.1 1.8 3h7.7v-4.5h-5.6v-24.7c-.2-8.8 10.6-13.8 15-13.8h-26.3v-.8h55.3v.8H301c7.9 0 15.5 7.5 15.6 13.8v7h-1l-.1-6.9c0-6.9-8.7-13.3-15.7-13.1-6 .1-15.4 5.9-15.3 13v2.2l14.3.1-.1 2.5 2.2 1.4 4.5 1.4v3.8l3.2.9v3.7l3.8 1.7v3.8l2.5 1.5-.1 3.9 3.3 2.3h-7.8l4.9 5.5h-7.3l-3.6-5.5h-4.7l2.1 5.4h-5l-1.3-5.4h-6.2v5.8H267zm22.2-15v4.6h5.3l-1-4.6H289z"
        }),
        /* @__PURE__ */ jsx74("path", {
          fill: "none",
          d: "M289.4 211.7h3.3v7.6h-3.3z"
        }),
        /* @__PURE__ */ jsx74("path", {
          fill: "none",
          d: "M284.7 219.8h3.2v-5.6c0-2.4 2.2-4.9 3.2-5 1.2 0 2.9 2.3 3 4.8v5.8h3.4v-14.4h-12.8zm25.6 3.3h4v3.2h-4zm-2.4-5.3h4v3.1h-4zm-3.9-5.4h4v3.1h-4zm-3.3-4.5h4v3.1h-4z"
        }),
        /* @__PURE__ */ jsx74("path", {
          fill: "none",
          d: "m298 219.8 4.2.2 7.3 6.4v-3.8l-2.5-1.8v-3l-3.6-2v-3.3l-3.5-1.2V207l-1.7-1.5z"
        }),
        /* @__PURE__ */ jsx74("path", {
          d: "M315.4 210.3h1v7.1h-1z"
        }),
        /* @__PURE__ */ jsxs49("g", {
          id: "af_svg__a",
          children: [
            /* @__PURE__ */ jsx74("path", {
              d: "M257.3 186.5c-1.2-2-2.7 2.8-7.8 6.3-2.3 1.6-4 5.9-4 8.7 0 2 .2 3.9 0 5.8-.1 1.1-1.4 3.8-.5 4.5 2.2 1.6 5.1 5.4 6.4 6.7 1.2 1 2.2-5.3 3-8 1-3 .6-6.7 3.2-9.4 1.8-2 6.4-3.8 6-4.6z"
            }),
            /* @__PURE__ */ jsx74("path", {
              fill: "#bf0000",
              d: "M257 201.9a10 10 0 0 0-1.6-2.6 6.1 6.1 0 0 0-2.4-1.8 5.3 5.3 0 0 1-2.4-1.5 3.6 3.6 0 0 1-.8-1.5 5.9 5.9 0 0 1 0-2l-.3.3c-2.3 1.6-4 5.9-4 8.7a28.5 28.5 0 0 0 0 2.3c.2.5.3 1 .6 1.3l1.1.8 2.7.7a7.1 7.1 0 0 1 2.6 2 10.5 10.5 0 0 1 1.8 2.6l.2-.8c.8-2.7.7-5.9 2.6-8.5z"
            }),
            /* @__PURE__ */ jsx74("path", {
              fill: "none",
              d: "M249.8 192.4c-.5 3.3 1.4 4.5 3.2 5.1 1.8.7 3.3 2.6 4 4.4m-11.7 1.5c.8 3 2.8 2.6 4.6 3.2 1.8.7 3.7 3 4.5 4.8"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "m255.6 184.5 1-.6 17.7 29.9-1 .6z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M257.5 183.3a2 2 0 1 1-4 0 2 2 0 1 1 4 0zm15.2-24h7.2v1.6h-7.2zm0 3.1h7.2v13.8h-7.2zm-.4-5h8c.2-2.7-2.5-5.6-4-5.6-1.6.1-4.1 3-4 5.6z"
            }),
            /* @__PURE__ */ jsx74("path", {
              fill: "#bd6b00",
              stroke: "none",
              d: "M292.6 155.8c-1.5.6-2.7 2.3-3.4 4.3-.7 2-1 4.3-.6 6.1 0 .7.3 1.1.5 1.5.2.3.4.5.6.5.3 0 .6 0 .7-.3l.2-.8c-.1-2-.1-3.8.3-5.4a7.7 7.7 0 0 1 3-4.4c.3-.2.4-.5.5-.7a1 1 0 0 0-.3-.7c-.4-.3-1-.4-1.5-.1m.2.4c.4-.2.8 0 1 .1l.1.2c0 .1 0 .2-.3.4a8.2 8.2 0 0 0-3.1 4.6 16.7 16.7 0 0 0-.3 5.6 1 1 0 0 1-.2.6s0 .1-.2 0c0 0-.2 0-.4-.3a3.9 3.9 0 0 1-.4-1.2c-.3-1.8 0-4 .7-6 .7-1.8 1.8-3.4 3-4z"
            }),
            /* @__PURE__ */ jsx74("path", {
              fill: "#bd6b00",
              stroke: "none",
              d: "M295.2 157.7c-1.5.7-2.5 2.3-3 4.2a13.6 13.6 0 0 0-.3 5.9c.2 1.3 1 2 1.6 2 .3.1.6 0 .8-.3.2-.3.3-.6.2-1-.4-1.6-.5-3.4-.3-5.1.3-1.7 1-3.2 2.2-4.1.3-.3.5-.5.5-.8a.8.8 0 0 0-.2-.6c-.4-.3-1-.4-1.5-.2m.2.5c.4-.2.8-.1 1 0l.1.3-.3.4a6.5 6.5 0 0 0-2.4 4.4c-.3 1.8-.1 3.7.2 5.2.1.4 0 .6 0 .8l-.5.1c-.3 0-1-.5-1.2-1.7-.3-1.7-.2-3.9.3-5.7.5-1.8 1.5-3.3 2.8-3.8"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M272.3 187.4h8v11h-8zm.5 17.4h7.7v2.4h-7.7zm-.2 4.1h8v8.7h-8zm-.6 10.5h8.7v4.9H272zm1.1-16.6h7l1.4-2.4h-9.6zm9.4-8.6.1-6h4.8a17.4 17.4 0 0 0-4.9 6z"
            }),
            /* @__PURE__ */ jsx74("path", {
              fill: "none",
              d: "M273.6 196.7c0 1.3 1.5.8 1.5.1v-5.6c0-1 2.4-.8 2.4-.1v6c0 1 1.7.9 1.6 0v-7c0-2.2-5.5-2.1-5.5-.1zm0 13.3h5.7v7h-5.7z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M277.2 213h2v1h-2zm-3.5 0h2v1h-2zm2-3h1.5v3h-1.5zm0 4h1.5v3.1h-1.5zM244 139c.4 5.5-1.4 8.6-4.3 8.1-.8-3 1-5.1 4.3-8.1zm-6.5 12.3c-2.6-1.3-.7-11.5.3-15.8.7 5.5 2 13.3-.3 15.8z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M238.4 151.8c4.4 1.5 8-3.2 9.1-8.7-3.6 5-9.5 5-9 8.7zm-3.3 5.1c-3.4-.9-1.4-11.7-.7-16 .7 4.5 3.1 14.5.7 16zm1.2-.3c.2-3.7 3.9-2.7 6.5-4.7-.5 2-2 5.2-6.5 4.7zm-4.2 5c-3.4-1-1.4-12.6-1.6-17.4 1 4.2 4.2 16.3 1.6 17.4zm1.6-.5c2.8.9 6.5-1 6.8-4.3-2.5 1.7-6.3.4-6.8 4.3z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M229.5 166.7c-3.2.3-1.8-9.6-1.8-18.8 1.2 8.6 4.5 16.5 1.8 18.8z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M230.7 166.3c2.2 1 6.1-.7 7.2-4.4-4 1.7-6.6 0-7.2 4.4zm25.6-22.2c-.6 4.9-2.6 7.7-5.5 7.2-.8-3 1.6-5 5.5-7.2zm-7.8 12.4c4.9.7 6.6-3 10-7.9-4.7 3.4-10.2 4-10 8z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M247 156c-2.6-3.2 0-7.3 2-10.7-.4 5.1 1.3 8-2 10.7zm-1 5.3c-.4-3.2 5-3.9 7.4-5.6-.9 1.8-2 6.7-7.5 5.6z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M244.8 161.3c-3.7-.4-2.2-6.7.5-10.1-1.1 4.8 2 8.1-.5 10.1z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M242 166.6c-4.2-2-1.5-7.2 0-10.3-.6 4.1 2.8 7.2 0 10.2z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M242.8 166c2.2 3 6.5-.8 7.4-5.2-3.7 3.1-6.5 2.6-7.4 5.3zm-9.6 20.3c-.4-4.3 2.8-12 .5-16.2-.3-.6.7-2.1 1.4-1.2 1 1.5 2 5.7 2.5 4.1.4-1.7.5-4.6 2-5.2 1-.3 2.3-.6 1.9 1-.4 1.4-1.2 3.4-.3 3.5.5 0 2-2 3.3-3 1-.8 2.6.6 1 1.8-4.8 4-9.5 5.9-12.3 15.2zm-8.7 64.5c-.6 0-1.3-.3-.6.6 5.7 7 7.3 9 15.6 8 8.3-1.1 10.3-3.4 16.2-6.7a14.6 14.6 0 0 1 11.2-1c1.6.5 2.6.5 1.4-.7-1.2-1.1-2.5-2.7-4-3.8a17.5 17.5 0 0 0-12.7-2.7c-6 1-11.1 4.9-17.2 6.4a25 25 0 0 1-9.9 0zm47.8 12.5c1 .2 1.7 2.2 2.3.9.8-2.3.2-4-.8-3.9-1.2.3-3.1 3-1.5 3z"
            }),
            /* @__PURE__ */ jsx74("path", {
              stroke: "none",
              d: "M220.6 183c-1.2-1.4-.9-1.8 1-1.9 1.4 0 4.2 1 5.3.1 1-.7.5-3.7 1-5 .2-.9.7-2 2-.2 3.6 5.8 8 12.8 10 19.6 1 3.8 0 9.8-3.4 13.8 0-3.4-1.2-5.7-2.7-8.6-2-3.7-9.1-14-13.2-17.9z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M235.5 213.4c4 0 4.7-5.3 4.7-6.8-2 .4-5.4 3.7-4.7 6.8zm34.5 51.9c2.8.6 2.7-6.2-.2-9.1 1.3 4.4-2 8.4.1 9zm-1.2-.1c.2 3.2-8-.4-10-3 4.8 2.1 9.8.4 10 3zm-3.5-4.6c.3 3.1-7 .3-9.3-2.1 4.9 1.6 9-.5 9.3 2zm1.3.4c2.9.7 2.4-6.4-.4-8.8 1.4 4.7-1.8 8.1.4 8.8zm-3-4.3c2.9.7 1.2-5.4-.9-7.8.4 4.4-1 7.5 1 7.8zm-1.5 0c.3 3.2-5.4.8-7.6-2.3 4.8 1.5 7.3-.3 7.6 2.3zm-1.5-2.5c1.8-1.3-.1-4.8-3.7-4.6.4 2.1 1.6 5.9 3.7 4.6zm14 14.7c.1 3.2-8 1.6-10.6-1.8 5.2 1 10.3-.8 10.5 1.8zm-32.4-5.8c.3 3.2-8.6-.4-10.8-3.4 4.7 1.6 10.5.8 10.8 3.4zm5.4 1.3c1.9-1.3-1.9-4.7-5-5.5.4 2.1 3 6.8 5 5.6zm.6 2.3c.2 2.9-9.5 1.3-12-1.4 8.3 1.5 11.7-1.1 12 1.4z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M252.8 268.6c1 2.7-8.3 2-11.6.5 5.3 0 10.8-2.4 11.6-.5z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M257.1 270.6c1 2.4-7.6 2.4-11.8 1 5.6 0 10.8-3.4 11.8-1zm6.3 1.3c1.6 2.9-7.6 3.1-10.5 1.7 5.2-.7 9.2-4 10.5-1.7zm-10.7-4.9c-2.9 1.8-2.7-3.6-5-7.3 3.6 3.3 7 5.6 5 7.3z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M257.9 269c-2.4 2.1-4.4-5.3-6.6-9.5 3.6 4 8.8 7.7 6.6 9.4zm6.8 2c-2 2.4-8-7-10.2-12 3.3 3.9 11.8 10 10.2 12zm-5.8 7.2c-1 3.6-16.2-3.4-18-7.1 8.8 4.6 18.2 3.6 18 7zm-48.7-73.8c-.4-.5-1.4 0-1.2 1.1.3 1.5 2.5 9.2 6.3 11.8 2.7 2 17 5.1 23.4 6.5 3.6.7 6.5 2.5 8.9 5.3a94.4 94.4 0 0 0-3-9.8c-1.2-3-4.4-6.2-7.8-6.3-6.1-.3-14.1-.8-20-3.3a16 16 0 0 1-6.7-5.3z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M245.5 234.9c2 1.4 4.1-3.7 1.7-8.6-.1 4.7-3.8 6.3-1.7 8.6z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M247.4 239.6c2.7.8 3.5-4 1.8-7.8.3 4.1-4.3 6.6-1.8 7.8z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M249.5 243.4c2.6 1.3 3.5-3.6 1.7-7.1.2 4.5-3.7 5.9-1.7 7z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M248.4 243.7c-1 3-7-2.7-8-5.8 3.7 3.7 8.7 3.2 8 5.7z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M245.7 239c-1.2 3-8.7-5-10.4-8.7 3.7 3.7 11.2 6.5 10.4 8.6z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M244.2 234.3c-1.2 3.5-9.3-5.8-11.7-9.1 4 3.6 12.6 6.6 11.7 9.1zm-.3-3.4c3-.6-.1-3-3.7-6.9-.1 4.1.5 7 3.7 6.9z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M239 228.5c1.3-1.3-1.1-1.9-4.1-5.3-.5 2.3 2.8 6.5 4.2 5.3zm14 15.2c1.6 1 2.6-2.3.7-5.2-.5 3.2-2.1 4-.7 5.2zm-34.2-20.3c-3.3 2-8.6-6-10-9.3 2.9 3.8 10.6 7.2 10 9.3z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M221.7 228c-1.9 2-7.7-3.5-9.7-6.3 3 2.7 10.5 3 9.7 6.3z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M224.8 232.2c-.6 2.8-9-3.5-11-6.5 3.6 3.5 11.6 3.2 11 6.5z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M223.5 235.3c-1.3 2.5-8.2-3.8-9.9-7 4.3 3.6 11 4.5 10 7zM220 223c2.1-2.3 1.2-3.4-.4-7-.8 3.7-2.1 5.2.4 7zm2.9 4.3c4 .2 0-4.6-1-8.7.4 4.6-1 8.3 1 8.7z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M225.4 231.1c2.7-.6 2-4.5-.2-9.2.5 5.1-2.3 8 .2 9.2zm-1 7.7c-1 3-8.8-4-10-6.8 4 3.4 10.7 4.5 10 6.8z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M229.1 243.6c-1.1 3-9.3-3.2-11.8-6.6 4.9 4 12.4 3.6 11.8 6.6z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M233.9 248.5c-1.3 4.3-9.9-2.6-12.4-6 5.4 4.2 13 3 12.4 6zm-8-11c2.3 1.1 3.2-5.4 1.9-10.1 0 5-4.7 8.8-2 10z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M229.8 242.7c2.8.8 2-6.3-.5-11-.3 4.7-2.3 9 .5 11zm5 4.9c3 .1 1-6.1-1.6-9.6.4 4.5-1 9 1.6 9.6zm-5.5 2.6c-1 1.6-3.2-1.3-7-3.5 3.4 1 7.4 2 7 3.5zm-1.8-52.7c3-2.2.7-6.2 0-10-1 3.6-3.4 8.4 0 10zm0 5.3c-4.5-.5-3.8-6.1-4-9.7 1.4 4.9 5 5.7 4 9.8zm.6-.7c3.7-.2 3.5-4.4 3.7-8.6-1.9 3.9-4 4.5-3.7 8.6z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M228 207.3c-3 .3-4.4-2.6-5-7 2.7 4.1 5.1 2.8 5 7zm1-.3c3.7.5 3-3.8 3-7-1.2 3-4.2 4-3 7z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M223.2 205.2c.3 2.8 2.1 7.6 5 6.5 1.1-3.4-2.6-4.1-5-6.5z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M229 212c-1.2-2.4 3-3.7 3.8-6.9.5 4.6.1 7.6-3.8 7zm-11.9-29.2c2.3-2.4.3-6.4-.4-10.2-1 3.6-2.5 8.4.4 10.2zm0 4.6c-4 .5-5-7.7-5.5-11.3 1.4 4.9 6 7 5.5 11.4zm.8 0c2.8-1.5 2.2-4.7 3-7-1.8 2.9-3.6 3.3-3 7z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M217 192.8c-4.1.3-6.6-8.8-6.8-12.4 1.3 4.9 7.4 7.5 6.9 12.4zm.9-.2c4-.9 3.5-3.5 2.9-7.6-1.3 4.2-3.5 3.3-2.9 7.6z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M217 198c-4.6.8-4.3-6.6-8-11.9 3.2 4 9 9 8 11.9zm1-.3c3.6.2 4-5.1 3.8-7.3-.9 2.2-5 4.2-3.7 7.4z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M209.8 192.3c1.7 5.7 4.2 11.4 7.2 11 1.5-3.3-2.9-3.7-7.2-11z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M218.1 202.4c-1.2-2.5 3-3.7 3.8-6.9.5 4.6.1 7.6-3.8 6.9zm-7.1-3.6c2.5 5.1 3.6 11 7 10.1 1.3-4-3.8-4.8-7-10.1z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M218.7 208c-1.5-2.8 2.7-3.7 3.8-7.4.5 4.8 0 8.3-3.8 7.3zm7.2-34.5c2.4.6 5-2.1 4.1-6.2-2.8.6-4 3.2-4.1 6.2zm-7.9-2.1c.2 1.2 1.7 1.3 1.2-.4a5.3 5.3 0 0 1 0-3.4 7.5 7.5 0 0 0 0-4.6c-.4-1-1.8-.4-1.2.4.6.9.7 2.8.2 3.7-.6 1.3-.4 3-.2 4.3zm22.9 16c-1 1.3-2.9.4-1.4-1.5 1.2-1.5 3-2.8 3-4.4.2-2 1.3-5 2.4-6.1 1.1-1.1 2.4.4 1.2 1.2-1.3.8-2.2 4.4-2.1 5.8-.1 2-2 3.5-3.1 5zm-3-2.3c-1 1.4-2.4.5-1.6-1.7.7-1.5.8-3.5 1.6-4.6 1.2-1.7 3-3.1 4.1-4.2 1.2-1 2 0 1 1a27 27 0 0 0-3.3 4c-1.4 2.2-.8 4-1.8 5.5zm-15.7-7.2c-.1 2 1.5 2.4 1.4-.4 0-3-2.2-5.8-1-10.3.8-2.2.8-6.3.4-8.4-.4-2.2-2-.8-1.3.9.6 2-.1 5.6-.6 7.5-1.5 5.4 1.2 8 1 10.7zm4.3-11c-.2 1.9-1.8 2-1.3-.5.4-2 .4-3.6 0-5.3-.6-2.1-.4-5.7 0-7.2.5-1.6 2-.7 1.4.5a9.9 9.9 0 0 0-.3 5.9c.6 2 .5 4.8.2 6.7zM210.9 204c.8.9 2 .3 1-1-1-1-.7-1.2-1.3-2.4-.6-1.4-.5-2.1-1.2-3-.7-1-1.6 0-1 .7.8 1 .6 1.6 1 2.5 1 1.5.7 2.3 1.5 3.2zm20.4 24.6a8.6 8.6 0 0 1 4.4 6.7 16 16 0 0 0 2 7.1c-2-.5-3-3.7-3.3-6.8-.3-3.2-2-4.5-3-7zm5.1 5.9c1.7 3.1 4 4.3 4.2 6.6.2 2.7.4 2.8 1.1 5.4-2-.5-2.5-.7-3-4.7-.3-2.8-2.6-4.7-2.3-7.3z"
            }),
            /* @__PURE__ */ jsx74("path", {
              stroke: "none",
              d: "M289 263.3c1 1.8 2 4.5 4 4 0-1.3-2.1-2.3-4-4m3 .6c3.7 1.6 7 1.2 7.5 3.6-3.6.4-5-1-7.6-3.6zm-16.1-12.7a14 14 0 0 1 5 7.7 29 29 0 0 0 3.6 7.8 13 13 0 0 1-5.3-7.4c-.7-3-1.6-5.3-3.3-8zm3.1 0c2.8 2.2 5.4 4.8 6.2 7.9.8 2.9 1.3 5.1 3.2 8-3-1.9-4.1-4.7-5-7.8-.7-3-2.5-5.2-4.4-8zm9.2 7.3a1.1 1.1 0 0 1 .7-1.2 33.4 33.4 0 0 1 2.6-.8c1-.3 1.6.4 1.6.9v2c0 .7-.2.8-.7.9-.7.1-1.7.2-2.4.7-.6.4-1.2.1-1.5-.5zm10.6 0c0-.6-.2-1.1-.6-1.2a5.4 5.4 0 0 0-2.4-.4c-1 0-1.1.2-1.1.6v2.1c0 .8 0 .8.4 1 .7 0 1.8 0 2.5.6.5.3 1 0 1.1-.6z"
            })
          ]
        }),
        /* @__PURE__ */ jsx74("use", {
          xlinkHref: "#af_svg__a",
          width: "100%",
          height: "100%",
          x: -600,
          transform: "scale(-1 1)"
        }),
        /* @__PURE__ */ jsxs49("g", {
          stroke: "none",
          children: [
            /* @__PURE__ */ jsx74("path", {
              d: "M328.5 286.6c0 1.2.2 2.2 1 3.1a19 19 0 0 0-13.8 1.1c-1.8.8-4-1-1.9-2.7 3-2.3 9.7-1 14.7-1.5m-57.5 0a7 7 0 0 1-.4 3c4.4-1.7 9.1-.2 13.6 1.6 3 1.3 3.3-1 2.8-1.7a6.5 6.5 0 0 0-5-2.9zm3.8-21.7c-1.3-.5-2.7 0-4 1.4-4.3 4.2-9.4 8.3-13.5 11.6-1.5 1.3-3 3.7 3.4 6 .3.2 5 2 8 2 1.3 0 1.3 1.8 1 2.3-.5 1-.1 1.4-1.1 2.3-1.1 1 0 2.1 1 1.3 3.6-3.2 9.6-1.1 15.3.7 1.4.4 3.8.3 3.8-1.6 0-2 1.5-3.4 2.4-3.5 2.4.4 14 .5 17.5.1 2-.3 2.2 2.9 3.3 4 .8.9 3.7 1.1 5.8.2 4-1.8 10-1.8 12.5 0 1 .7 1.9 0 1.3-.7-.8-1-.7-1.6-1.1-2.4-1-2-.2-2.4.8-2.5 11-1.5 14.6-5.2 11.2-8.3-4.4-3.8-9.2-7.7-13.4-12.2-1.2-1.2-2-1.7-4.3-.7a66.5 66.5 0 0 1-25.3 5.9 76 76 0 0 1-24.6-5.8z"
            }),
            /* @__PURE__ */ jsx74("path", {
              fill: "#bd6b00",
              d: "m326.6 265.5-1.6.4c-9 3.2-17.2 5.4-25.7 5.4-8.3 0-17-2.4-24.9-5.6a2.3 2.3 0 0 0-1.5 0c-.5.1-1 .4-1.3.7a115.5 115.5 0 0 1-11.8 10.3c-.7.5-.6 1.8.5 2.2 8.3 3 16.4 8.5 39.6 8.3 23.5-.2 31.8-5.6 39.2-8.1.5-.2 1-.5 1.3-1a1 1 0 0 0 .1-.8 2 2 0 0 0-.6-.8c-4.3-3.5-8.8-6.3-11.8-10.4-.3-.5-.9-.6-1.5-.5zm0 .5c.5 0 1 0 1.1.3 3 4.3 7.7 7 11.9 10.5l.4.7a.5.5 0 0 1 0 .4c-.1.3-.6.6-1 .7-7.6 2.6-15.7 8-39 8.2-23.2.2-31.2-5.3-39.5-8.3-.8-.4-.7-1.2-.4-1.4 4.2-3.2 8.2-6.8 11.8-10.4a2.5 2.5 0 0 1 1.1-.6h1.2a68 68 0 0 0 25 5.6c8.7 0 17-2.2 26-5.3a6.7 6.7 0 0 1 1.5-.4z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M269.7 114.6c0-1.4 2-1.5 1.8.4-.3 2.3 4.5 8.3 4.9 12 .3 2.5-1.5 4.6-3.2 6a6.6 6.6 0 0 1-6.8.5c-.9-.8-1.7-3.3-1-4.3.2-.3 1.3 3.7 3.7 3.7 3.3 0 6-2.5 6-4.7.2-3.8-5.3-9.8-5.4-13.6m9.5 9.4c.6-.4 1.4 1.3.8 1.7-.5.3-1.5-1.3-.8-1.8zm1.5-3.5c-.3.2-.8 0-.7-.2a12 12 0 0 1 3.6-3.3c.4-.2 1 .4.8.7a11 11 0 0 1-3.7 2.8m12.6-10c.3-.6 2.1-1.3 2.6-1.7.4-.5.6.4.4.7-.3.7-1.9 1.7-2.6 1.8-.3 0-.6-.4-.4-.7zm4.3.3a8.3 8.3 0 0 1 2.5-3.4c.5-.3 1.3 0 1.1.4a9 9 0 0 1-2.9 3.3c-.3.3-.8 0-.7-.3m-3.7 2.7c-.3.2-.1.7.1.8.6.2 1.5.2 2 0 .6-.4.3-2.9-.5-1.6-.6.8-1 .6-1.6.8m-7.3 5.6c-1.3-1 .4-2.4 1.7-1.4 2.7 2-4 9.8-7.6 13.4-.7.7-1.3-1-.4-1.9a33.7 33.7 0 0 0 6.7-7.6c.4-.5.7-1.6-.4-2.5m15.3-6.6c.1-1-1.6 0-1.6-1.3 0-.7 1.9-1.2 2.7-.4 1.3 1.4.3 3.7-2 3.9-1.8 0-5 2.7-4.5 3.2.5.7 5.4 1.1 8.3.7 1.8-.3 1.4 1.3-.4 1.5-1.8.2-3.2 0-4.8.6-2 .5-2.8 3-3.9 4-.2.2-.8-.8-.6-1.2.8-1.2 2-3 3.4-3.6.8-.3-2.4-.4-3.4-.7-.8-.2-.6-1.3-.3-1.9.4-.8 3.4-3.9 4.7-3.8 1.1 0 2.3-.3 2.4-1m5 .2c.6-.5 1-1.3 1.5-1.8.3-.3.9 0 .8.8-.1.7-1 1.2-1.5 1.7-.5.3-1-.4-.7-.7zm6.5-2.3c.9 0 1 1.6.2 1.8-.6.2-1-1.7-.2-1.8m-2.1 5c0 1.5.7 1.4 2 1.3 1.3 0 2.4 0 2.4-1.2 0-1.3-.7-2.5-1-1.6-.1.8-.3 2.2-.8 1.6-.4-.5-.2-.6-1 .2-.5.5-.5-.2-.8-.6-.2-.3-.8.2-.8.4zm-9.2 7.2c-.3 1.9 0 4.5.9 4.5 1.2 0 3.6-4 4.8-6.2.7-1.2 1.8-1.4 1.3-.1-.7 1.9-.6 6 0 7.2.4.6 3-.6 3.4-1.5.8-1.7.1-4.8.4-6.7.1-1.2 1.3-1.5 1.2-.3a75.6 75.6 0 0 0-.1 7.5c0 1 2.9 2.4 3.3-.6.2-1.8 1.2-3.7 0-5.7-.8-1.3 1.1-1.2 2.1.6.7 1.2-.6 3.2-.5 4.7 0 2.4-1.8 3.8-3.1 3.8-1.2 0-2-1.5-3-1.5s-2.2 1.7-3 1.6c-3.6-.2-1.7-5.3-2.8-5.4-1.2 0-2.5 5-4 4.9-1.4-.2-3-4.2-2.3-5.8.5-1.6 1.5-2 1.4-1m16.9-8c-1.7-1 0-3.7.9-2.8 1.6 2 3.2 6.5 4.4 6.9.7.2.6-3.4 1.1-5 .4-1.3 1.8-.9 1.6.7-.1.5-2 6.4-1.8 6.6a47.1 47.1 0 0 1 3.3 7.8c.3 1.2-1.1.4-1.3.2-.9-1.4-2.4-6.5-2.4-6.2l-1.7 7.7c-.2 1-1.7.8-1.3-1 .3-1.4 2.3-8.3 2.2-8.6a17.2 17.2 0 0 0-5-6.3"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M322 131.2c-.4 0-1.2 1 1.2 1.5 3.1.6 6.6-.5 7.6-3.6 1.3-3.7 2-7.2 2.7-8.5.8-1.5 1.8-1.4 1-3.6-.5-1.7-1.5-1.2-1.7-.3-.5 2.3-2.6 10-3.3 11.3-1.2 2.6-3.7 3.6-7.5 3.2"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M328.4 119c-.4-.7-1.2 0-1 .7a1.2 1.2 0 0 0 1.2 1c.7 0 2.2.1 2.2-1 0-.8-.7-1.5-1.1-.6-.5.8-1 .7-1.3 0zm.7-3c-.2.2 0 1.1.3 1a7 7 0 0 0 3.3-.8c.2-.2.1-.7-.2-.7-1 0-2.6 0-3.4.5m8.8 2.3c.8-1.2 2.8-1.3 2 .4a614.3 614.3 0 0 1-6.3 12.3c-.8 1.4-1.4.7-.8-.4.7-1.4 4.9-12 5.1-12.3"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M330.2 133c-.2-.8-1.5-2-1.3.2.2 3.8 5.5 2.6 7 1.3s.3 4.3 2.2 4.9c1 .3 3-1.1 4-2.4 2.7-3.5 4.5-8.6 7-12 1-1.4-.5-2.4-1-1.3-2.4 3.8-5.2 11.6-8.3 13.6-2.5 1.6-1.7-2-1.8-3.2-.1-.8-1.1-2-2.4-.9a5.5 5.5 0 0 1-3.7 1.2c-.7 0-1.4 0-1.7-1.4"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M339.6 126c0-.3-1.1-.4-1 .7 0 .8 1 1 1.1 1 1.5-1.2-.3-.6-.1-1.8zm-2.3 4.4c-.3 0-.6 1 .2 1.1l3.9-.2c.4 0 .6-.9-.4-.8-1.2 0-2.7-.3-3.7 0zm-62-16.6c.5 0 1.6 1.4 1.5 1.9 0 .2-1.2 0-1.5-.3-.3-.3-.2-1.6 0-1.6m-5.3 10.4c-1 .6.2 1.7 1 1.2 2.8-1.9 7-3.8 8-7.5.3-1.2 1.4-3.1 2.5-3.5 1-.5 2.6 1.9 3.6 0 .6-1 2.7.7 3.2-.4.6-1.3.3-2 .3-3.4 0-.8-.7-1-1.2.3-.2.6 0 1.2-.1 1.6-.2.2-.6.4-1 .2-.2-.2 0-.7-.6-1-.2 0-.6-.1-.8.2-.7 1.3-1 2.5-2.1 1-.9-1-1.4-3.1-2-.3-.2 1-1.7 2.4-2.6 2.4-1.1 0-.8-3-3.2-2.5-1.3.3-1.2 2.7-1 3.5.3 1.3 4 .4 3.7 1.2-.6 2.7-4.4 5.4-7.7 7m-22.7 13.2c-.1.5.5 1.7 1.1 1.8.6 0 1-1.3.8-1.8-.2-.3-1.8-.3-1.9 0m3.3 4.9c-.4-.4-1.6.7-.6 1.5.5.5 2.5 1.1 3 .2.8-1.2-.7-5.5 0-6 .5-.5 2.8 2.8 4 3 2.7.4 2-4.6 5-4.2 1.9.2 2.1-2.2 1.8-3.8-.2-1.5-2.6-3.6-3.7-4.6-1.4-1.2-2.1 1-1.2 1.6 1.2 1 3.3 2.9 3.6 4.1.1.6-1.4 1.8-2 1.5-1.4-.8-2.6-4-3.8-4.7-.4-.2-1.4.3-1 1.3.6 1.1 3 2.7 3.1 3.9.1 1-1 3.2-1.8 3.2-.9 0-3-2.7-3.7-4-.4-.5-1.5-.5-1.7.4a22 22 0 0 0 .5 5.5c.2 1.6-.9 1.7-1.5 1.1m-4-8.6c-.4.4.8 1.2 1 1 .4-.4 2.1-2.3 1.8-3-.3-.6-2.6-2-3-1.3-.7 1.1 2.2 1.7 1.7 2a7 7 0 0 0-1.5 1.3m4.1-8.4s.8 2.5 1.4 1.4c.4-.7-1.4-1.4-1.4-1.4m1.2 4c-.2 0-1 .7-.5 1 .8.4 2.9.8 2.4-.7-.3-.9 3.2 0 2.3-2.4a3.7 3.7 0 0 0-1.7-1.7c-.4 0-1.5.5-.8.9.5.2 2 1.1 1.5 1.7-.7.6-1.1-.3-1.9-.1-.4 0-.1 1.2-.4 1.5 0 .2-.7-.4-.9-.3zm5.5-9.5a3.5 3.5 0 0 0-1.2 2c0 .2.3.6.5.5a3.2 3.2 0 0 0 1.2-1.9c0-.3-.2-.8-.5-.6m2.8-.3c-.8-1 1-2.6 1.7-.5.5 1.3 5.5 7.9 6.5 10.1.8 1.5 0 2.1-.9 1-2.5-3.2-4.6-7.2-7.3-10.6m5.2.1c.9-1 2.7-3 2.2-4-.4-1-1.5-1-1.7-.7-1 1.3.8 1 .5 1.4-.5 1-1 1.6-1.3 2.6-.1.3.1.9.3.7m77.8 3.2c-.7-.5.6-3 1.5-2 2.3 2.7 3.4 11.6 4.1 18.3 0 0-1 .9-1 .7 0-3.5-1.5-14.4-4.6-17m-53.1-8.6c-.8-1.8 1.1-2.4 1.4-1.2 1.3 5.8 4.5 10.2 7 14.1.7 1.2 0 2-1.7.8-1.2-.8-2.5-3.9-3-4-1.2-.2-3.8 5-9.1 3.5-1.4-.4-1.3-4.5-1.4-6.3 0-.9 1-1 1 0 0 1.7 0 5.2 2.1 5.4 1.8 0 5.6-2.4 6.4-4.4.8-2-1.9-5.9-2.7-8z"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M344.6 138.4c.4-1.2 6.1-10.8 6.9-12.9.4-1 2 1.8.4 3.3-1.4 1.2-5.5 8-6.3 10.4-.4 1-1.4.5-1-.8"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M354.3 129.3c1-4 3.6.6 1.3 2.8-3.4 3.4-4.5 9.9-10 10.9-1.4.3-4-.7-4.8-1.3-.3-.2.2-1.6 1.1-.9 1.3 1 4.1 1.3 5.6.1a25.4 25.4 0 0 0 6.8-11.6m-57 12.7c-.3.3-1 .3-1.1.7-.3 1.4 0 2.2-.3 3.6s-1.3 1.4-1.2.3c0-1.4 1.3-3.5.4-3.6-.6-.1-1-.9-.4-1.3 1.1-.7 1.7-.6 2.4-.4.3.1.4.5.2.7"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "M296.5 140c-1.4 1.4-2.8 1.9-4.1 3.5-.6.6-.5 1.5-.9 2.4-.3.9-1.4 1-1.7.9-.5-.4-.4-2-1-1.2-.6.9-.9 2-1.7 2-.7 0-2-1.5-1.3-1.5 2.3-.3 2.2-2 3-2.2 1-.1 1 1.5 1.7 1.2.4-.2.7-2.1 1.2-2.6 1.5-1.6 2.7-2.4 4.3-3.6.7-.6 1.3.5.5 1.2zm5.3 5c-1.2.2-1 1.7-.6 1.8.5.3 1.4.4 1.7-1.3.2-.7.3 3.5 1.8 1.9 1-1 3.1.2 4-1 .7-.9 1-1.5.4-2.7-.2-.3-1-.2-1 .7 0 .8-.5 1.7-1.3 1.6-.4-.1.2-1.9-.2-2.4a.5.5 0 0 0-.7 0c-.3.4.3 2.2-.6 2.4-1.2.2-.6-1.2-1-1.4-1.7-.8-1.8.2-2.5.3zm9-3c.9-.2.6-.2 2-1.3.5-.4.6.8.5 1.3 0 .7-1 .2-1.3.9-.4.9-.2 3-.4 3.8 0 .4-.8.4-.8 0-.2-1 .1-2 0-3.3 0-.4-.5-1.1 0-1.3zm-5-2.5c-.2.9-.2 1.6-.2 2.3 0 .5 1 .2 1 .1 0-.8.2-2 0-2.3-.2-.1-.7-.3-.8-.1"
            }),
            /* @__PURE__ */ jsx74("path", {
              d: "m299.5 130.2-1.4 5.6-2-3.8v3.9l-4.4-5.2 1.5 5.6-4-3.4 2.2 3.8-7-4.5 4.4 5.2-5.6-2.8 4 3.4-9-3.4 8.7 4.3a29 29 0 0 1 12.6-2.6c4.9 0 9.3 1 12.5 2.6l8.8-4.3-9 3.4 4-3.4-5.5 2.8 4.3-5.2-7 4.5 2.2-3.8-4 3.3 1.5-5.5-4.3 5.2V132l-2 3.8z"
            })
          ]
        })
      ]
    }),
    /* @__PURE__ */ jsx74("path", {
      fill: "#fff",
      d: "m311.3 295-.3 2.6h-.4l-.1-1.8a9.3 9.3 0 0 0-.5-1.6 7.3 7.3 0 0 0-.5-1.3l-1-1.4.8-2.2a6.6 6.6 0 0 1 1.5 2.4 9.4 9.4 0 0 1 .5 3.2m7-4.2c0 .7-.2 1.2-.5 1.5-.2.3-.6.6-1.3.7l.4 1.5a6.7 6.7 0 0 1 0 2 22.5 22.5 0 0 1-.1 1.3h-.4a8.2 8.2 0 0 0-.1-1.3 5.5 5.5 0 0 0-.2-1l-.4-1a10.5 10.5 0 0 0-.7-1.4l-1-1.7.6-2 1 1c.3.2.6.3 1 .3.8 0 1.2-.4 1.2-1.3h.4v1.4m6.4 4.8-.5 2.1c-.4 0-.6-.3-.8-.7l-.4-1.3a12.4 12.4 0 0 1-.1-1.7 4 4 0 0 1-1 .2 2 2 0 0 1-1.3-.4 1.3 1.3 0 0 1-.5-1c0-.9.3-1.7.7-2.3.5-.7 1-1 1.5-1.1.5 0 .8.1 1 .4a2 2 0 0 1 .3.9v2c0 .9.1 1.5.3 1.9 0 .3.3.6.8 1m-2-3.5c0-.6-.3-.8-.8-.8a1 1 0 0 0-.6.1c-.2.1-.2.2-.2.3 0 .3.3.5 1 .5zm8.7 3-.3 2.6c-.5-.4-1-1-1.4-2a25.4 25.4 0 0 1-1.3-4.1 52.8 52.8 0 0 1-1.8 5.5 2.9 2.9 0 0 1-.8.7v-2.5c.6-.7.9-1.1 1-1.5a7.6 7.6 0 0 0 .8-1.7l.5-2.7h.4l.9 2.7c.2.6.5 1.2.9 1.6l1 1.4"
    }),
    /* @__PURE__ */ jsx74("path", {
      fill: "#bf0000",
      d: "M350.8 319.4c.4.4.6.8.7 1.2l.4 1.6-.8.1a7.8 7.8 0 0 0-1-1.5 18.8 18.8 0 0 0-1.1-1.2 46 46 0 0 0-1.7-1.5 34.4 34.4 0 0 0-2-1.7c-.4-.2-.6-.4-.6-.5a1.9 1.9 0 0 1-.3-.8 11.2 11.2 0 0 1-.2-1.6l2.7 2.2a44.3 44.3 0 0 1 2.5 2.2zm-9.5-5.8-.2 2H338l.3-2zm8.4 8.9-7.6 2.3-1.3-2 6.5-2-.7-.8a2.8 2.8 0 0 0-.9-.6 1.4 1.4 0 0 1-.4 1 2 2 0 0 1-1 .6 3.4 3.4 0 0 1-1.8 0 2 2 0 0 1-1.3-.7 4 4 0 0 1-.7-2.2c0-1 .3-1.6.9-1.8.7-.2 1.8 0 3 .7a8.1 8.1 0 0 1 3 2.4zm-5.8-4a3.8 3.8 0 0 0-.8-.3 1.1 1.1 0 0 0-.6 0 .7.7 0 0 0-.5.3.5.5 0 0 0 0 .6l.5.2h.6l.4-.3zm-8-1.6-.5 2-3.2-.3.5-2zm7.5 7.7-1.7.4a5.3 5.3 0 0 1-1.7 0 3.6 3.6 0 0 1-1.5-.4c-.3.5-.8 1-1.5 1.2a7.4 7.4 0 0 1-1.6.6l-1.2.3-1-2 1.1-.3a9.1 9.1 0 0 0 1.3-.4l.9-.5-1-.5h-.7a.4.4 0 0 0-.2 0 .6.6 0 0 0-.2.3h-.5c-.5-.8-.6-1.5-.3-2s.9-.8 2-1a6.8 6.8 0 0 1 2.6-.2c.8.1 1.3.4 1.5.9.2.2.2.5.2.7l-.4 1.2h.5a2 2 0 0 0 .6 0l1.7-.3zm-8 1.8-1.6.3a3 3 0 0 1-2.2-.4 5.5 5.5 0 0 1-1.7-2.6l-.8-2.2a2 2 0 0 0-.8-1 4.6 4.6 0 0 0-.9-.5l.6-2.1c.6.3 1 .6 1.4 1l1 1.7.5 1.5 1.1 2.2c.3.3.7.4 1 .3l1.7-.2zm-7-7.5-1 1.9-3-.7 1-1.9zm1.8 8.4-7.5.7-.4-2 6.2-.7a2.3 2.3 0 0 0-.6-.8 8.3 8.3 0 0 0-1-.6l.5-2c.7.4 1.2.9 1.6 1.3.3.5.6 1.2.8 2.1zm-6 1a17 17 0 0 1-2.2-.2 10.5 10.5 0 0 1-1.7-.5 5.6 5.6 0 0 1-1.3.4 9.9 9.9 0 0 1-1.7 0h-2a2.5 2.5 0 0 1-1.2-.3c-.3-.2-.5-.5-.8-1a4.1 4.1 0 0 1-1.5 1l-1.7.1h-1.7l.2-2.1h1.7c.8 0 1.5 0 2.1-.4a2 2 0 0 0 1.3-1.8l.7.1a30.2 30.2 0 0 0-.1 1.3c0 .3 0 .5.3.7.3.2.6.3 1 .3h1.5c1 0 1.6 0 2-.2.6-.2.9-.5 1-1.1l.1-.4s.3 0 .5-.2l.5-.2v.4a8.9 8.9 0 0 1 0 .3l-.3 1.1a12.4 12.4 0 0 0 2 .5c.1-.2 0-.4-.1-.7l-.3-.6a.5.5 0 0 1 .1-.3l.3-.2 1-.9.5 1v1zm-11.3-8.7-2 1.3-1.3-.9-1.4 1-1.9-1 1.8-1.3 1.5.8 1.5-1 1.8 1m-3 8.2-7.3-1.2.8-2 6.2 1c0-.4 0-.7-.2-1a5.2 5.2 0 0 0-.5-.8l1.6-1.7c.4.6.6 1 .7 1.6 0 .5-.2 1.2-.5 2.1zm-6.1-1-1.6-.3c-.9-.2-1.4-.6-1.5-1.2-.2-.6.1-1.5.8-2.8l1.2-2c.3-.5.4-.9.3-1.2a2.2 2.2 0 0 0-.3-.7l2.2-1.6c.3.5.3 1 .3 1.4 0 .5-.3 1.1-.7 1.8l-.8 1.4a5.8 5.8 0 0 0-.9 2.2c0 .4.2.6.5.7l1.6.4zm-3.8-8-2.5 1.1-1.8-1.7 2.6-1zm-1 6.6a6.8 6.8 0 0 1-1.6 1.4 4.2 4.2 0 0 1-1.7.6l-2.4-.1a14.8 14.8 0 0 1-2.8-.7 7.7 7.7 0 0 1-3.4-2c-.6-.8-.6-1.5 0-2.2a7 7 0 0 1 2-1.6c.8-.5 2-1 3.8-1.6l.4.5-2.8 1.2c-.5.3-1 .6-1.3 1-.4.4-.3 1 .2 1.6a10.5 10.5 0 0 0 6.3 2.2c1.2 0 2-.3 2.3-.7.3-.3.4-.6.5-1l.2-1.6 2.5-1.5a8 8 0 0 1-.1 1.5 4.4 4.4 0 0 1-1 1.6z"
    })
  ]
});
var Af_default = SvgAf;

// src/country-flag-icons/generated/Ag.tsx
init_esm_shims();
import { jsx as jsx75, jsxs as jsxs50 } from "react/jsx-runtime";
var SvgAg = (props) => /* @__PURE__ */ jsxs50("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx75("defs", {
      children: /* @__PURE__ */ jsx75("clipPath", {
        id: "ag_svg__a",
        children: /* @__PURE__ */ jsx75("path", {
          fillOpacity: 0.7,
          d: "M-79.7 0H603v512H-79.7z"
        })
      })
    }),
    /* @__PURE__ */ jsxs50("g", {
      fillRule: "evenodd",
      clipPath: "url(#ag_svg__a)",
      transform: "translate(74.7) scale(.9375)",
      children: [
        /* @__PURE__ */ jsx75("path", {
          fill: "#fff",
          d: "M-79.7 0H603v512H-79.7z"
        }),
        /* @__PURE__ */ jsx75("path", {
          fill: "#000001",
          d: "M-79.6 0H603v204.8H-79.7z"
        }),
        /* @__PURE__ */ jsx75("path", {
          fill: "#0072c6",
          d: "M21.3 203.2h480v112h-480z"
        }),
        /* @__PURE__ */ jsx75("path", {
          fill: "#ce1126",
          d: "M603 .1V512H261.6L603 0zM-79.7.1V512h341.3L-79.7 0z"
        }),
        /* @__PURE__ */ jsx75("path", {
          fill: "#fcd116",
          d: "M440.4 203.3 364 184l64.9-49-79.7 11.4 41-69.5-70.7 41L332.3 37l-47.9 63.8-19.3-74-21.7 76.3-47.8-65 13.7 83.2L138.5 78l41 69.5-77.4-12.5 63.8 47.8L86 203.3z"
        })
      ]
    })
  ]
});
var Ag_default = SvgAg;

// src/country-flag-icons/generated/Ai.tsx
init_esm_shims();
import { jsx as jsx76, jsxs as jsxs51 } from "react/jsx-runtime";
var SvgAi = (props) => /* @__PURE__ */ jsxs51("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx76("defs", {
      children: /* @__PURE__ */ jsx76("path", {
        id: "ai_svg__b",
        fill: "#f90",
        d: "M271 87c1.5 3.6 6.5 7.6 7.8 9.6-1.7 2-2 1.8-1.8 5.4 3-3.1 3-3.5 5-3 4.2 4.2.8 13.3-2.8 15.3-3.4 2.1-2.8 0-8 2.6 2.3 2 5.1-.3 7.4.3 1.2 1.5-.6 4.1.4 6.7 2-.2 1.8-4.3 2.2-5.8 1.5-5.4 10.4-9.1 10.8-14.1 1.9-.9 3.7-.3 6 1-1.1-4.6-4.9-4.6-5.9-6-2.4-3.7-4.5-7.8-9.6-9-3.8-.7-3.5.3-6-1.4-1.6-1.2-6.3-3.4-5.5-1.6"
      })
    }),
    /* @__PURE__ */ jsx76("clipPath", {
      id: "ai_svg__a",
      children: /* @__PURE__ */ jsx76("path", {
        d: "M0 0v120h373.3v120H320zm320 0H160v280H0v-40z"
      })
    }),
    /* @__PURE__ */ jsx76("path", {
      fill: "#012169",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx76("path", {
      stroke: "#fff",
      strokeWidth: 50,
      d: "m0 0 320 240m0-240L0 240"
    }),
    /* @__PURE__ */ jsx76("path", {
      stroke: "#c8102e",
      strokeWidth: 30,
      d: "m0 0 320 240m0-240L0 240",
      clipPath: "url(#ai_svg__a)"
    }),
    /* @__PURE__ */ jsx76("path", {
      stroke: "#fff",
      strokeWidth: 75,
      d: "M160 0v280M0 120h373.3"
    }),
    /* @__PURE__ */ jsx76("path", {
      stroke: "#c8102e",
      strokeWidth: 50,
      d: "M160 0v280M0 120h373.3"
    }),
    /* @__PURE__ */ jsx76("path", {
      fill: "#012169",
      d: "M0 240h320V0h106.7v320H0z"
    }),
    /* @__PURE__ */ jsx76("path", {
      fill: "#fff",
      d: "M424 191.8c0 90.4 9.7 121.5 29.3 142.5a179.4 179.4 0 0 0 35 30 179.7 179.7 0 0 0 35-30c19.5-21 29.3-52.1 29.3-142.5-14.2 6.5-22.3 9.7-34 9.5a78.4 78.4 0 0 1-30.3-9.5 78.4 78.4 0 0 1-30.3 9.5c-11.7.2-19.8-3-34-9.5"
    }),
    /* @__PURE__ */ jsxs51("g", {
      transform: "matrix(1.96 0 0 2.002 -40.8 62.9)",
      children: [
        /* @__PURE__ */ jsx76("use", {
          xlinkHref: "#ai_svg__b"
        }),
        /* @__PURE__ */ jsx76("circle", {
          cx: 281.3,
          cy: 91.1,
          r: 0.8,
          fill: "#fff",
          fillRule: "evenodd"
        })
      ]
    }),
    /* @__PURE__ */ jsxs51("g", {
      transform: "matrix(-.916 -1.77 1.733 -.935 563.4 829)",
      children: [
        /* @__PURE__ */ jsx76("use", {
          xlinkHref: "#ai_svg__b"
        }),
        /* @__PURE__ */ jsx76("circle", {
          cx: 281.3,
          cy: 91.1,
          r: 0.8,
          fill: "#fff",
          fillRule: "evenodd"
        })
      ]
    }),
    /* @__PURE__ */ jsxs51("g", {
      transform: "matrix(-1.01 1.716 -1.68 -1.031 925.4 -103.2)",
      children: [
        /* @__PURE__ */ jsx76("use", {
          xlinkHref: "#ai_svg__b"
        }),
        /* @__PURE__ */ jsx76("circle", {
          cx: 281.3,
          cy: 91.1,
          r: 0.8,
          fill: "#fff",
          fillRule: "evenodd"
        })
      ]
    }),
    /* @__PURE__ */ jsx76("path", {
      fill: "#9cf",
      d: "M440 315.1a78 78 0 0 0 13.3 19.2 179.4 179.4 0 0 0 35 30 180 180 0 0 0 35-30 78 78 0 0 0 13.2-19.2z"
    }),
    /* @__PURE__ */ jsx76("path", {
      fill: "#fdc301",
      d: "M421.2 188.2c0 94.2 10.2 126.6 30.6 148.5a187 187 0 0 0 36.5 31.1 186.3 186.3 0 0 0 36.4-31.1c20.4-21.9 30.6-54.3 30.6-148.5-14.8 6.8-23.3 10.1-35.5 10-11-.3-22.6-5.7-31.5-10-9 4.3-20.6 9.7-31.5 10-12.3.1-20.7-3.2-35.6-10m4 5c14 6.5 22 9.6 33.5 9.4a76.4 76.4 0 0 0 29.6-9.4c8.4 4 19.3 9.2 29.6 9.4 11.5.2 19.4-3 33.4-9.4 0 89-9.6 119.6-28.8 140.2a176 176 0 0 1-34.2 29.4 175.6 175.6 0 0 1-34.3-29.4c-19.2-20.6-28.7-51.3-28.7-140.2z"
    })
  ]
});
var Ai_default = SvgAi;

// src/country-flag-icons/generated/Al.tsx
init_esm_shims();
import { jsx as jsx77, jsxs as jsxs52 } from "react/jsx-runtime";
var SvgAl = (props) => /* @__PURE__ */ jsxs52("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx77("path", {
      fill: "red",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx77("path", {
      id: "al_svg__a",
      fill: "#000001",
      d: "M272 93.3c-4.6 0-12.3 1.5-12.2 5-13-2.1-14.3 3.2-13.5 8 1.2-1.9 2.7-3 3.9-3.1 1.7-.3 3.5.3 5.4 1.4a21.6 21.6 0 0 1 4.8 4.1c-4.6 1.1-8.2.4-11.8-.2a16.5 16.5 0 0 1-5.7-2.4c-1.5-1-2-2-4.3-4.3-2.7-2.8-5.6-2-4.7 2.3 2.1 4 5.6 5.8 10 6.6 2.1.3 5.3 1 8.9 1 3.6 0 7.6-.5 9.8 0-1.3.8-2.8 2.3-5.8 2.8-3 .6-7.5-1.8-10.3-2.4.3 2.3 3.3 4.5 9.1 5.7 9.6 2 17.5 3.6 22.8 6.5a37.3 37.3 0 0 1 10.9 9.2c4.7 5.5 5 9.8 5.2 10.8 1 8.8-2.1 13.8-7.9 15.4-2.8.7-8-.7-9.8-2.9-2-2.2-3.7-6-3.2-12 .5-2.2 3.1-8.3.9-9.5a273.7 273.7 0 0 0-32.3-15.1c-2.5-1-4.5 2.4-5.3 3.8a50.2 50.2 0 0 1-36-23.7c-4.2-7.6-11.3 0-10.1 7.3 1.9 8 8 13.8 15.4 18 7.5 4.1 17 8.2 26.5 8 5.2 1 5.1 7.6-1 8.9-12.1 0-21.8-.2-30.9-9-6.9-6.3-10.7 1.2-8.8 5.4 3.4 13.1 22.1 16.8 41 12.6 7.4-1.2 3 6.6 1 6.7-8 5.7-22.1 11.2-34.6 0-5.7-4.4-9.6-.8-7.4 5.5 5.5 16.5 26.7 13 41.2 5 3.7-2.1 7.1 2.7 2.6 6.4-18.1 12.6-27.1 12.8-35.3 8-10.2-4.1-11 7.2-5 11 6.7 4 23.8 1 36.4-7 5.4-4 5.6 2.3 2.2 4.8-14.9 12.9-20.8 16.3-36.3 14.2-7.7-.6-7.6 8.9-1.6 12.6 8.3 5.1 24.5-3.3 37-13.8 5.3-2.8 6.2 1.8 3.6 7.3a53.9 53.9 0 0 1-21.8 18c-7 2.7-13.6 2.3-18.3.7-5.8-2-6.5 4-3.3 9.4 1.9 3.3 9.8 4.3 18.4 1.3 8.6-3 17.8-10.2 24.1-18.5 5.5-4.9 4.9 1.6 2.3 6.2-12.6 20-24.2 27.4-39.5 26.2-6.7-1.2-8.3 4-4 9 7.6 6.2 17 6 25.4-.2 7.3-7 21.4-22.4 28.8-30.6 5.2-4.1 6.9 0 5.3 8.4-1.4 4.8-4.8 10-14.3 13.6-6.5 3.7-1.6 8.8 3.2 9 2.7 0 8.1-3.2 12.3-7.8 5.4-6.2 5.8-10.3 8.8-19.9 2.8-4.6 7.9-2.4 7.9 2.4-2.5 9.6-4.5 11.3-9.5 15.2-4.7 4.5 3.3 6 6 4.1 7.8-5.2 10.6-12 13.2-18.2 2-4.4 7.4-2.3 4.8 5-6 17.4-16 24.2-33.3 27.8-1.7.3-2.8 1.3-2.2 3.3l7 7c-10.7 3.2-19.4 5-30.2 8l-14.8-9.8c-1.3-3.2-2-8.2-9.8-4.7-5.2-2.4-7.7-1.5-10.6 1 4.2 0 6 1.2 7.7 3.1 2.2 5.7 7.2 6.3 12.3 4.7 3.3 2.7 5 4.9 8.4 7.7l-16.7-.5c-6-6.3-10.6-6-14.8-1-3.3.5-4.6.5-6.8 4.4 3.4-1.4 5.6-1.8 7.1-.3 6.3 3.7 10.4 2.9 13.5 0l17.5 1.1c-2.2 2-5.2 3-7.5 4.8-9-2.6-13.8 1-15.4 8.3a17 17 0 0 0-1.2 9.3c.8-3 2.3-5.5 4.9-7 8 2 11-1.3 11.5-6.1 4-3.2 9.8-3.9 13.7-7.1 4.6 1.4 6.8 2.3 11.4 3.8 1.6 5 5.3 6.9 11.3 5.6 7 .2 5.8 3.2 6.4 5.5 2-3.3 1.9-6.6-2.5-9.6-1.6-4.3-5.2-6.3-9.8-3.8-4.4-1.2-5.5-3-9.9-4.3 11-3.5 18.8-4.3 29.8-7.8l7.7 6.8c1.5.9 2.9 1.1 3.8 0 6.9-10 10-18.7 16.3-25.3 2.5-2.8 5.6-6.4 9-7.3 1.7-.5 3.8-.2 5.2 1.3 1.3 1.4 2.4 4.1 2 8.2-.7 5.7-2.1 7.6-3.7 11-1.7 3.5-3.6 5.6-5.7 8.3-4 5.3-9.4 8.4-12.6 10.5-6.4 4.1-9 2.3-14 2-6.4.7-8 3.8-2.8 8.1 4.8 2.6 9.2 2.9 12.8 2.2 3-.6 6.6-4.5 9.2-6.6 2.8-3.3 7.6.6 4.3 4.5-5.9 7-11.7 11.6-19 11.5-7.7 1-6.2 5.3-1.2 7.4 9.2 3.7 17.4-3.3 21.6-8 3.2-3.5 5.5-3.6 5 1.9-3.3 9.9-7.6 13.7-14.8 14.2-5.8-.6-5.9 4-1.6 7 9.6 6.6 16.6-4.8 19.9-11.6 2.3-6.2 5.9-3.3 6.3 1.8 0 6.9-3 12.4-11.3 19.4 6.3 10.1 13.7 20.4 20 30.5l19.2-214L320 139c-2-1.8-8.8-9.8-10.5-11-.7-.6-1-1-.1-1.4.9-.4 3-.8 4.5-1-4-4.1-7.6-5.4-15.3-7.6 1.9-.8 3.7-.4 9.3-.6a30.2 30.2 0 0 0-13.5-10.2c4.2-3 5-3.2 9.2-6.7a86.3 86.3 0 0 1-19.5-3.8 37.4 37.4 0 0 0-12-3.4zm.8 8.4c3.8 0 6.1 1.3 6.1 2.9 0 1.6-2.3 2.9-6.1 2.9s-6.2-1.5-6.2-3c0-1.6 2.4-2.8 6.2-2.8"
    }),
    /* @__PURE__ */ jsx77("use", {
      xlinkHref: "#al_svg__a",
      width: "100%",
      height: "100%",
      transform: "matrix(-1 0 0 1 640 0)"
    })
  ]
});
var Al_default = SvgAl;

// src/country-flag-icons/generated/Am.tsx
init_esm_shims();
import { jsx as jsx78, jsxs as jsxs53 } from "react/jsx-runtime";
var SvgAm = (props) => /* @__PURE__ */ jsxs53("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx78("path", {
      fill: "#d90012",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsx78("path", {
      fill: "#0033a0",
      d: "M0 160h640v160H0z"
    }),
    /* @__PURE__ */ jsx78("path", {
      fill: "#f2a800",
      d: "M0 320h640v160H0z"
    })
  ]
});
var Am_default = SvgAm;

// src/country-flag-icons/generated/Ao.tsx
init_esm_shims();
import { jsx as jsx79, jsxs as jsxs54 } from "react/jsx-runtime";
var SvgAo = (props) => /* @__PURE__ */ jsxs54("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsxs54("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      children: [
        /* @__PURE__ */ jsx79("path", {
          fill: "red",
          d: "M0 0h640v243.6H0z"
        }),
        /* @__PURE__ */ jsx79("path", {
          fill: "#000001",
          d: "M0 236.4h640V480H0z"
        })
      ]
    }),
    /* @__PURE__ */ jsx79("path", {
      fill: "#ffec00",
      fillRule: "evenodd",
      d: "M228.7 148.2c165.2 43.3 59 255.6-71.3 167.2l-8.8 13.6c76.7 54.6 152.6 10.6 174-46.4 22.2-58.8-7.6-141.5-92.6-150z"
    }),
    /* @__PURE__ */ jsx79("path", {
      fill: "#ffec00",
      fillRule: "evenodd",
      d: "m170 330.8 21.7 10.1-10.2 21.8-21.7-10.2zm149-99.5h24v24h-24zm-11.7-38.9 22.3-8.6 8.7 22.3-22.3 8.7zm-26-29.1 17.1-16.9 16.9 17-17 16.9zm-26.2-39.8 22.4 8.4-8.5 22.4-22.4-8.4zM316 270l22.3 8.9-9 22.2-22.2-8.9zm-69.9 70 22-9.3 9.5 22-22 9.4zm-39.5 2.8h24v24h-24zm41.3-116-20.3-15-20.3 14.6 8-23-20.3-15h24.5l8.5-22.6 7.8 22.7 24.7-.3-19.6 15.3z"
    }),
    /* @__PURE__ */ jsx79("path", {
      fill: "#fe0",
      fillRule: "evenodd",
      d: "M336 346.4c-1.2.4-6.2 12.4-9.7 18.2l3.7 1c13.6 4.8 20.4 9.2 26.2 17.5a7.9 7.9 0 0 0 10.2.7s2.8-1 6.4-5c3-4.5 2.2-8-1.4-11.1-11-8-22.9-14-35.4-21.3"
    }),
    /* @__PURE__ */ jsx79("path", {
      fill: "#000001",
      fillRule: "evenodd",
      d: "M365.3 372.8a4.3 4.3 0 1 1-8.7 0 4.3 4.3 0 0 1 8.6 0zm-21.4-13.6a4.3 4.3 0 1 1-8.7 0 4.3 4.3 0 0 1 8.7 0m10.9 7a4.3 4.3 0 1 1-8.7 0 4.3 4.3 0 0 1 8.7 0"
    }),
    /* @__PURE__ */ jsx79("path", {
      fill: "#fe0",
      fillRule: "evenodd",
      d: "M324.5 363.7c-42.6-24.3-87.3-50.5-130-74.8-18.7-11.7-19.6-33.4-7-49.9 1.2-2.3 2.8-1.8 3.4-.5 1.5 8 6 16.3 11.4 21.5A5288 5288 0 0 1 334 345.6c-3.4 5.8-6 12.3-9.5 18z"
    }),
    /* @__PURE__ */ jsx79("path", {
      fill: "#ffec00",
      fillRule: "evenodd",
      d: "m297.2 305.5 17.8 16-16 17.8-17.8-16z"
    }),
    /* @__PURE__ */ jsx79("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 3,
      d: "m331.5 348.8-125-75.5m109.6 58.1L274 304.1m18.2 42.7L249.3 322"
    })
  ]
});
var Ao_default = SvgAo;

// src/country-flag-icons/generated/Aq.tsx
init_esm_shims();
import { jsx as jsx80, jsxs as jsxs55 } from "react/jsx-runtime";
var SvgAq = (props) => /* @__PURE__ */ jsxs55("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx80("path", {
      fill: "#3a7dce",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx80("path", {
      fill: "#fff",
      d: "M157.7 230.8c-3.5-7.8-3.5-7.8-3.5-15.6-1.8 0-2 .3-3 0-1.1-.3-1.5 7.2-4.8 5.8-.5-.8 2.4-6.2-.7-8.5-1-.7.2-5.2-.2-7.2 0 0-4 2.4-7-5.8-1.5-2.2-3.5 2-3.5 2s.9 2.4-.7 3c-2.2-1.8-3.9-.8-6.7-3.4-2.8-2.5.6-5.4-4.8-7.5 3.5-9.8 3.5-7.9 12.2-11.8-5.2-4-5.2-4-8.7-9.8-5.2-2-7-4-12.2-7.8-7-9.9-10.5-29.5-10.5-43.2 4.4-4.6 10.5 15.7 19.2 21.6l12.2 5.9c7 3.9 8.7 7.8 14 11.7l15.6 6c7 5.8 10.5 13.6 15.7 15.6 5.7 0 6.8-3.7 8.6-3.9 10.3-.6 15.5-2 17.5-5.5 2.1-2.8 7 1.6 21-4.3l-1.7-7.9s3.7-3.4 8.7-2c-.1-3.5-.5-13 4.5-17.4-3-3.5 1.8-9 2-10.7-1.4-8.6 1.4-8.7 2-11.3.6-2.5-2.4-1.7-1.6-5.2.9-3.5 6-4.3 6.6-7.2.7-2.9-1.1-14.3-1.3-16.8 9.4-2.8 12.4-11.4 15.7-7.8C264 70 265.8 66 276.3 66c1.4-3.6-3.9-6.7-1.8-7.9 3.5-.5 6.1-.2 10.2 5.7 1.3 2 1.6-2.7 2.9-3.2 1.3-.5 4.4-.5 4.9-2.8.5-2.4 1.2-5.6 3-9.5 1.4-3.2 2.5 1.3 3.8 7.5 7.4.3 24 2.1 31 4.3 5.2 1.5 8.7-1.5 13.7-2.2 3.7 4.2 7.2 1 9.2 10 2.7 4.8 7.3.4 8.3 1.8 5.8 18.1 25.8 5.9 27.4 6.2 2.5 0 5.6 8 7.7 7.9 3.2-.6 2.3-3.1 5.2-2.1-.8 6.8 5.6 14.6 5.6 19.7 0 0 1.5.9 3-.6 1.4-1.6 2.7-5.4 4-5.3 3 .5 22 6 25.8 7.9 1.7 3.5 3.3 5.3 6.8 4.7 2.8 2.1.8 5 2.4 5.1 3.5-2 4.7-4 8.2-2.1 3.5 2 7 5.9 8.7 9.8 0 2-1.8 9.8 0 21.6.9 3.9 9.7 32.3 9.7 35.2 0 4-2.7 6-4.5 9.9 7 5.9 0 15.7-3.5 21.6 26.2 5.9 14 17.6 34.9 11.7-5.2 13.8-3.4 12.7 1.8 26.4-10.4 7.8-.2 10.2-7.1 20-.5.7 4.1 8.6 10.5 8.6-1.7 15.6-7 9.8-5.2 33.3-13.7-.3-8.2 17.6-17.4 15.7.5 11.2 5.2 12.2 3.4 23.5-7 2-7 2-10.4 7.9l-5.2-2c-1.8 9.8-5.3 11.8 0 21.6 0 0-6.8.2-8.8 0-.1 3.4 3 4.3 3.5 7.8-.2 1.4-9.9 7.6-17.4 7.9-2 4.8 5.2 10 4.8 12.4-8.2 1.8-11.8 13-11.8 13s4.2 2 3.5 4c-2.2-1.8-3.5-2-7-2-1.7.5-6 0-10 7.7-4.5 1.6-6.6 1-10 6-1.5-4.7-3.7.1-6.3 2-2.7 1.8-6.2 6.5-6.7 6.3.1-1.4 1.6-6.3 1.6-6.3L399 437c-.7.1-.5-5.7-2.2-5.5-1.7.2-6.4 7.3-8 7.5-1.6.2-2.1-2.2-3.5-2-1.4.2-4 7.5-5 7.7-1 .1-5-4.5-8.3-3.8-17.1 6.8-19.9-13.4-22.5-2-3.6-2.2-3-1-6.7.1-2.3.7-2.5-3.4-4.6-3.4-4.1.2-4 4.6-6.2 3.3-1.8-9.2-13-7.6-14-11.5-1-4 4.8-4 6.6-6.8 1.4-4-1.5-5.6 4.3-9.4 7.5-5.7 6.8-19.8 4.9-25.3 0 0-5.9-17.7-7-17.7-3.5-1-3.5 6.5-8.6 8.6-10.5 4-29-9.9-32.2-9.9-2.9 0-16.5 3.6-16-4-2 7.4-9.5 1.7-10 1.7-7 0-4.3 6.1-9 5.9-2.1-.8-23.6-2.3-23.6-2.3v4l-26.1-11.8c-10.5-4-5.3-13.7-22.7-7.8v-11.8h-8.7c3.5-23.6 0-11.8-1.8-33.4l-7 2c-7-10.6 9.8-8.6-5.2-15.7 0 0 .3-11.7-3.5-7.8-.7.5 1.8 5.8 1.8 5.8-14-2-17.4-5.8-17.4-21.5 0 0 11.4 1.8 10.4 0-1.6-3-3.7-22-3.4-23.4-.1-2.6 10.7-9 8.6-15.2 1.4-.6 5.3-.7 5.3-.7"
    }),
    /* @__PURE__ */ jsx80("path", {
      fill: "none",
      stroke: "#fff",
      strokeLinejoin: "round",
      strokeWidth: 2.5,
      d: "M595.5 297.6c-.6 1.3-.5 2.6.1 3.6 1.1-1.7.2-2.4 0-3.6zm-476-149.4s-3-.4-2.4 2.3c1-2 2.3-2.2 2.4-2.3zm-.3-6.4c-1.7 0-3.8-.2-3 2.5 1-2.1 3-2.4 3-2.5zm12.7 36.3s2.6-.2 2 2.5c-1-2-2-2.4-2-2.5z",
      transform: "scale(.86021 .96774)"
    })
  ]
});
var Aq_default = SvgAq;

// src/country-flag-icons/generated/Ar.tsx
init_esm_shims();
import { jsx as jsx81, jsxs as jsxs56 } from "react/jsx-runtime";
var SvgAr = (props) => /* @__PURE__ */ jsxs56("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx81("path", {
      fill: "#74acdf",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx81("path", {
      fill: "#fff",
      d: "M0 160h640v160H0z"
    }),
    /* @__PURE__ */ jsxs56("g", {
      id: "ar_svg__c",
      transform: "translate(-64) scale(.96)",
      children: [
        /* @__PURE__ */ jsx81("path", {
          id: "ar_svg__a",
          fill: "#f6b40e",
          stroke: "#85340a",
          strokeWidth: 1.1,
          d: "m396.8 251.3 28.5 62s.5 1.2 1.3.9c.8-.4.3-1.6.3-1.6l-23.7-64m-.7 24.2c-.4 9.4 5.4 14.6 4.7 23-.8 8.5 3.8 13.2 5 16.5 1 3.3-1.2 5.2-.3 5.7 1 .5 3-2.1 2.4-6.8-.7-4.6-4.2-6-3.4-16.3.8-10.3-4.2-12.7-3-22"
        }),
        /* @__PURE__ */ jsx81("use", {
          xlinkHref: "#ar_svg__a",
          width: "100%",
          height: "100%",
          transform: "rotate(22.5 400 250)"
        }),
        /* @__PURE__ */ jsx81("use", {
          xlinkHref: "#ar_svg__a",
          width: "100%",
          height: "100%",
          transform: "rotate(45 400 250)"
        }),
        /* @__PURE__ */ jsx81("use", {
          xlinkHref: "#ar_svg__a",
          width: "100%",
          height: "100%",
          transform: "rotate(67.5 400 250)"
        }),
        /* @__PURE__ */ jsx81("path", {
          id: "ar_svg__b",
          fill: "#85340a",
          d: "M404.3 274.4c.5 9 5.6 13 4.6 21.3 2.2-6.5-3.1-11.6-2.8-21.2m-7.7-23.8 19.5 42.6-16.3-43.9"
        }),
        /* @__PURE__ */ jsx81("use", {
          xlinkHref: "#ar_svg__b",
          width: "100%",
          height: "100%",
          transform: "rotate(22.5 400 250)"
        }),
        /* @__PURE__ */ jsx81("use", {
          xlinkHref: "#ar_svg__b",
          width: "100%",
          height: "100%",
          transform: "rotate(45 400 250)"
        }),
        /* @__PURE__ */ jsx81("use", {
          xlinkHref: "#ar_svg__b",
          width: "100%",
          height: "100%",
          transform: "rotate(67.5 400 250)"
        })
      ]
    }),
    /* @__PURE__ */ jsx81("use", {
      xlinkHref: "#ar_svg__c",
      width: "100%",
      height: "100%",
      transform: "rotate(90 320 240)"
    }),
    /* @__PURE__ */ jsx81("use", {
      xlinkHref: "#ar_svg__c",
      width: "100%",
      height: "100%",
      transform: "rotate(180 320 240)"
    }),
    /* @__PURE__ */ jsx81("use", {
      xlinkHref: "#ar_svg__c",
      width: "100%",
      height: "100%",
      transform: "rotate(-90 320 240)"
    }),
    /* @__PURE__ */ jsx81("circle", {
      cx: 320,
      cy: 240,
      r: 26.7,
      fill: "#f6b40e",
      stroke: "#85340a",
      strokeWidth: 1.4
    }),
    /* @__PURE__ */ jsx81("path", {
      id: "ar_svg__h",
      fill: "#843511",
      strokeWidth: 1,
      d: "M329 234.3c-1.7 0-3.5.8-4.5 2.4 2 1.9 6.6 2 9.7-.2a7 7 0 0 0-5.1-2.2zm0 .4c1.8 0 3.5.8 3.7 1.6-2 2.3-5.3 2-7.4.4 1-1.4 2.4-2 3.8-2z"
    }),
    /* @__PURE__ */ jsx81("use", {
      xlinkHref: "#ar_svg__d",
      width: "100%",
      height: "100%",
      transform: "matrix(-1 0 0 1 640.2 0)"
    }),
    /* @__PURE__ */ jsx81("use", {
      xlinkHref: "#ar_svg__e",
      width: "100%",
      height: "100%",
      transform: "matrix(-1 0 0 1 640.2 0)"
    }),
    /* @__PURE__ */ jsx81("use", {
      xlinkHref: "#ar_svg__f",
      width: "100%",
      height: "100%",
      transform: "translate(18.1)"
    }),
    /* @__PURE__ */ jsx81("use", {
      xlinkHref: "#ar_svg__g",
      width: "100%",
      height: "100%",
      transform: "matrix(-1 0 0 1 640.2 0)"
    }),
    /* @__PURE__ */ jsx81("path", {
      fill: "#85340a",
      d: "M316 243.7a1.8 1.8 0 1 0 1.8 2.9 4 4 0 0 0 2.2.6h.2c.6 0 1.6-.1 2.3-.6.3.5.9.7 1.5.7a1.8 1.8 0 0 0 .3-3.6c.5.2.8.6.8 1.2a1.2 1.2 0 0 1-2.4 0 3 3 0 0 1-2.6 1.7 3 3 0 0 1-2.5-1.7c0 .7-.6 1.2-1.3 1.2-.6 0-1.2-.6-1.2-1.2s.3-1 .8-1.2zm2 5.4c-2.1 0-3 2-4.8 3.1 1-.4 1.8-1.2 3.3-2 1.4-.8 2.6.2 3.5.2.8 0 2-1 3.5-.2 1.4.8 2.3 1.6 3.3 2-1.9-1.2-2.7-3-4.8-3-.4 0-1.2.2-2 .6z"
    }),
    /* @__PURE__ */ jsx81("path", {
      fill: "#85340a",
      d: "M317.2 251.6c-.8 0-1.8.2-3.4.6 3.7-.8 4.5.5 6.2.5 1.6 0 2.5-1.3 6.1-.5-4-1.2-4.9-.4-6.1-.4-.8 0-1.4-.3-2.8-.2"
    }),
    /* @__PURE__ */ jsx81("path", {
      fill: "#85340a",
      d: "M314 252.2h-.8c4.3.5 2.3 3 6.8 3s2.5-2.5 6.8-3c-4.5-.4-3.1 2.3-6.8 2.3-3.5 0-2.4-2.3-6-2.3"
    }),
    /* @__PURE__ */ jsx81("path", {
      fill: "#85340a",
      d: "M323.7 258.9a3.7 3.7 0 0 0-7.4 0 3.8 3.8 0 0 1 7.4 0"
    }),
    /* @__PURE__ */ jsx81("path", {
      id: "ar_svg__e",
      fill: "#85340a",
      strokeWidth: 1,
      d: "M303.4 234.3c4.7-4.1 10.7-4.8 14-1.7a8 8 0 0 1 1.5 3.4c.4 2.4-.3 4.9-2.1 7.5l.8.4c1.6-3.1 2.2-6.3 1.6-9.4l-.6-2.3c-4.5-3.7-10.7-4-15.2 2z"
    }),
    /* @__PURE__ */ jsx81("path", {
      id: "ar_svg__d",
      fill: "#85340a",
      strokeWidth: 1,
      d: "M310.8 233c2.7 0 3.3.6 4.5 1.7 1.2 1 1.9.8 2 1 .3.2 0 .8-.3.6-.5-.2-1.3-.6-2.5-1.6s-2.5-1-3.7-1c-3.7 0-5.7 3-6.1 2.8-.5-.2 2-3.5 6.1-3.5"
    }),
    /* @__PURE__ */ jsx81("use", {
      xlinkHref: "#ar_svg__h",
      width: "100%",
      height: "100%",
      transform: "translate(-18.4)"
    }),
    /* @__PURE__ */ jsx81("circle", {
      id: "ar_svg__f",
      cx: 310.9,
      cy: 236.3,
      r: 1.8,
      fill: "#85340a",
      strokeWidth: 1
    }),
    /* @__PURE__ */ jsx81("path", {
      id: "ar_svg__g",
      fill: "#85340a",
      strokeWidth: 1,
      d: "M305.9 237.5c3.5 2.7 7 2.5 9 1.3 2-1.3 2-1.7 1.6-1.7-.4 0-.8.4-2.4 1.3-1.7.8-4.1.8-8.2-.9"
    })
  ]
});
var Ar_default = SvgAr;

// src/country-flag-icons/generated/As.tsx
init_esm_shims();
import { jsx as jsx82, jsxs as jsxs57 } from "react/jsx-runtime";
var SvgAs = (props) => /* @__PURE__ */ jsxs57("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx82("path", {
      fill: "#006",
      d: "M0 0h640v480H0Z"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#bd1021",
      d: "m-.6 240 640-240v480Z"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#fff",
      d: "m59.7 240 580-214.3v428.6"
    }),
    /* @__PURE__ */ jsx82("path", {
      d: "M474 270.4c5.1.3 5 5.4 5 5.4l18 .4c2.3-6.3 4.8-5.6 9.2-2.4a32.9 32.9 0 0 0 8.7 4.2c1.7-9 14.5-7.2 14.5-7.2 5.6-13 6-12.9 2.7-14.5a10.7 10.7 0 0 1-4.6-4.5c-3-3.7-4.6-9.1-5-12.4-.4-3.3-4.2 1.6-5 .6-.6-1-6.3-.4-6.3-.4 1.4 1.5-3.4.6-3.4.6.5.4 0 1.7 0 1.7-.4-.6-4.1-1.2-4.1-1.2a6.1 6.1 0 0 1-1.1 1.6c-2-.8-6-.7-6-.7a20 20 0 0 0-10.9 2.8c-1.6.9-7.4 3.8-12.3 8.5-4.7 4.6-7.4 4-7.4 4-1.4 5.2-12.8 11.5-12.8 11.5-1.8 1.6-7.6 2.4-10.5 0-2.9-2.4 0-6.9 0-6.9 1.2-2 2.2-1.9 2.3-9 .1-4.7 5-8.5 10-14 6.3-6.8 15-18 15-18 0 3.4 1.8 4 1.8 4 1.7-3.5 4.2-6.3 4.2-6.3.1.3.5.4.5.4 2-2.6 3-3.6 3-3.6-.5-.3-6 0-11 4.4s-8.4 3-8.4 3c-3.5-1.2-3.8-4-3.8-4-2.5-10.9 7.4-18.7 7.4-18.7-13.4-3.2-3.7-20.3 13-27.5 16.6-7.2 16.4-10.5 16.4-10.5a13 13 0 0 1 1.8 3c.1 0 1.4-1.9 11-6.1 9.6-4.3 14.2-8 14.2-8 1.2 2.4 1 4 1 4 26.3-9.1 52-30.2 52-30.2.8 1.7.5 4.4.5 4.4 4.2-4 19.7-13.2 19.7-13.2a8.6 8.6 0 0 1-4.6 8.2 7.7 7.7 0 0 1 .8 2.3 360 360 0 0 0 14.4-9.5c4.3 3.7.4 9.8.4 9.8 1.6-.3 2.6-1.6 2.6-1.6 1.2 6.4-5.9 12-5.9 12 1.3 0 3.3-1.3 3.3-1.3-1.3 7-14.4 14.6-14.4 14.6 1.9 1.8 0 4-1.6 5-1.5 1-4.3 3.3-3.4 4.2.8 1 6.7-3.2 6.7-3.2 1 2.9-6.5 8.6-6.5 8.6 5.2.7 19.6-5.9 19.6-5.9-1.1 5.6-6.6 10-13.3 12.5-6.7 2.5-6.4 3-6.4 3 1.2.8 10.5-1.8 10.5-1.8-2.8 6.2-12.5 10.5-12.5 10.5 2.7 2.3 6.3-.4 10-2.9a58.2 58.2 0 0 1 14-6.4c5.3-1.9 9.2-.5 9.2-.5a12 12 0 0 1 8.4.6c8.7.7 9.6 3.9 9.6 3.9 1 .2 1.7.6 4 2.3 2.1 1.6 2 6.6 2 9.2-.2 2.4-.9 2.4-1.3 3-.4.8-.5 1.6-.5 2.5 0 1-2.2 6.9-15.7 6.9h-20.3c-1.2 0-2.5.7-2.5.7-5.7 2.8-2.7-2-9.4 3.6-6.8 5.5-10.2 4.6-10.2 4.6A90.1 90.1 0 0 1 568 221c-4 2.6-3.3 2.3.3 3.8s8.8 0 8.8 0c-3.4 2.3-1 3.4-1 3.4 4.4-2.7 7.2-1.7 7.2-1.7 1.4 3.9-3.8 10-3.8 10 2 .3 5.8 0 5.8 0-1 2.7-4.6 5.6-7.4 6.4-2.7 1-2.3 1.3-1.4 3 .7 1.6.1 3.3.1 3.3-4.8-3.3-5-.4-5-.4-.5 4-.4 9.6-.4 9.6-3.4-1.7-3.5.5-3.5.5-1 3.6-5.1 7.7-5.1 7.7-.2-2.2-2.2-2.8-2.2-2.8-2.2 4.2-6.1 6.7-6.1 6.7-.5 3.5.5 8.6.5 8.6-2.6-.6-3.5-.6-4 0-.3.7.6 1 .6 1l33.4.8c.5 0 2.5.3 2.5 3.8 0 3.7-3 3.9-3 3.9l-36.4-.9s.1 1-1.8 2-1.2-1.1-1.7 3.4c-.6 4.4-7.8-.4-7.8-.4-1.2 1.8-4 4-4 4-1.7-5-3.4-6.4-6-2.2-2.6 4.3 4.8 3.6 4.8 3.6s42.8-6.3 45.1-6.5c2.3-.3 4.9-.1 6 3.1 1 3.3-5.3 3.8-5.3 3.8l-44 4.8c-.9 2.6-4.5 2.4-4.5 2.4.3 2.5-2.3 4-3.6 5-1.4.8-5.6.5-5.6.5-5 3.4-7.6.7-7.6.7-3.3 1.4-5.4.8-8.1-.4-2.8-1.2-2.5-4.5-2.5-4.5l-27.8 3a6.7 6.7 0 0 0-2.2 1.2c1 1.3-2 4.3-2 4.3.9.5 2.5 2.1 2.7 5.5.2 3.7-4.5 4.3-2.2 7 2.3 2.5 6.7.3 11.5-2s9.5-2 11.5-2 7.8 1.6 11.4 2.8c3.6 1.2 4.8.4 5-1.4.2-1.7 1.9-2.3 1.9-2.3-.5 1.8.5 2.6.5 2.6a11 11 0 0 0 3.7-1.3c-.2 1.4-2 2.2-2 2.2-3.4 2.3 1.4 1.5 1.4 1.5a44 44 0 0 1 15.4-1.5 122.5 122.5 0 0 1 14.3 5.2c.4-1.2.1-4 .1-4 3 .8 4.2 2.5 4.2 2.5 1.2-1.2.4-3.4.4-3.4 9.7 5.5-2 8-5.1 9-3 1-3 2.3-3 2.3a28 28 0 0 1 6.4-1.3c2.2-.2 1.4 0 6.5-1 5.2-1 7.8 1.2 7.8 1.2-4.3.2-5.5 1.5-5.5 1.5 2.6 1.7 0 3.4 0 3.4-3.8-5-7.2.1-7.2.1a15.3 15.3 0 0 1 6.4 1.4l5.4 2.7c3.6 1.6 2.9.6 5.6 1.6 2.8 1 1.7 3.7 1.7 3.7a6.8 6.8 0 0 0-3.7-3c-.2 3-3.1 3.5-3.1 3.5 3.6-4-4.1-5.8-7.8-5.7-3.6 0-6.3 2.4-6.3 2.4 7.3 6.9 12.3 4.6 12.3 4.6-.9 2.5-6.9 1.5-6.9 1.5 2.8 2.2 2.5 3.6 2.5 3.6-1.5-1.4-4-.7-9.2-4-5.2-3.5-9.9-2.3-9.9-2.3 5.2 5.3-1.8 8.6-1.8 8.6-2.6 1.6 1 3.5 1 3.5-3.2.6-3.6-2.6-3.6-2.6-1.7-.4-4.2 1.6-4.2 1.6.2-3.2 4.6-1.6 4.6-5 .2-3.5-4-6.2-16.3-4.5-12.4 1.7-16-2.2-16-2.2-1 0-1.2 1-1.2 1 2 2 2.9 2.8 2.6 4.2-.4 1.3.6 1.8.6 1.8-2.3-.2-2.4-2.8-2.4-2.8 0 1.1-.5 1.2-1.3 2.3s0 2.7 0 2.7c-1-.8-2.7-1.8-1-4.3 1.2-1.8-2.7-4.2-2.7-4.2-1.5-1.5-5.6 0-5.6 0a14.9 14.9 0 0 1-13.3-3.7c-1 0-2.9-.6-2.9-.6-8.9 4-16.7-4.6-16.7-4.6-6.7 1.3-9.8-2-11.8-5.2a11.5 11.5 0 0 0-5.2-5c-2.6-1.6-5.2-6.2-2.6-8.7 2-2.1 1.5-2.6 1.5-2.6-3.5-5.9 6.1-7.7 6.3-9.2.3-2 2.3-3.3 4.5-3.4 2.2-.2 2.2 0 3.7-1.4 1.3-1.5 4 .3 4 .3.7-.4 5.5-4.1 9.7-2.2 4.3 1.9 7.9.6 7.9.6 3-.7 28-4 28-4 1.5-2.5 2.7-5.4 9.6-7s12-6 12-6c-1.2-1.2-3.2-1.2-4.2-1.3-1.1 0-3.2-2-3.2-2-1.3.6-2 .3-11 5.8-8.1 5-8.3-4.8-8.3-4.8H479c-.3 3.7-3 5.2-3 5.2l-6.5.3c-3.6-1.8-3.6-8.2-3.6-8.2-19.4.3-30.1 7.2-30.1 7.2-22-11.2-39.2-13.8-39.2-13.8a122.4 122.4 0 0 0 40.8-10.2 63.3 63.3 0 0 0 28.5 9c.5-5.4 4.1-6.7 4.1-6.7z"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#ffc221",
      d: "M442.3 314.6c-5.5 3.2-4.5 5-4 6s.5 2-1 3.6c-1.5 1.5-1.4 2-1.4 2 .3 5.4 4 6.6 5.7 8 1.4 1 3.6 4.5 3.6 4.5 2.9 4.1 5.9 4.2 8.1 4.2 2.3 0 2-.3 1-1.3l-3.4-2.7a17.6 17.6 0 0 1 5.9 4.1c5.6 6.2 10.8 5.4 13.1 5.2 2.3-.3 2-1.7 2-1.7a9 9 0 0 0-2.4-.4c-8.5-.8-11-6.4-11-6.4a24.1 24.1 0 0 0 15.6 6c2.4-.1 2.3.6 1.7.8l-2.4-.2c-1.1 0-1.1.3-.9.8.3.4 1.4.4 2.7.4 1.4 0 .3.1 3.8 2.8 3.6 2.8 12.3.5 12.3.5-5.7-1.3-6.4-4-6.4-4-7.7 1-10.8-3.6-10.8-3.6a32.5 32.5 0 0 0-5.6-3.5 8.9 8.9 0 0 1-5-5.8c1.3 1.8 3.7 3.8 6.7 4.6 3 .8 3.8 1.2 3.8 1.2a3.8 3.8 0 0 1-2.3-.2c-3-1-1.3.3-1.3.3 3.4 2.7 4.3 2.5 4.3 2.5 8.6.9 4.3-2.6 4.3-2.6 6.2 1.5 7.2-.8 7.2-.8 1.3 2.7 6 1.7 6 1.7-6.2 3-1.5 2.1-1.5 2.1 6.3-1.1 7.6.5 7.6.5 1.6 1.5 3.4 1.4 3.4 1.4s1.2 0 3.5.4c2.4.5 6.2 2.5 9.6 2.2 3.5-.5 4 .6 4 .6-.6-.3-2.2-.5-4.8.7-2.7 1.3-7.4 1.6-14.2 0s-7.4-1.3-7.4-1.3a8.7 8.7 0 0 1 3.4 4c.3 1.2 1.5 1.2 1.5 1.2.5-1.5 2.5-2.1 2.5-2.1a27 27 0 0 0 5 2.8c.4-.7 0-1.3 0-1.3 2.6 2.5 5.6 1.7 5.6 1.7.8-.5.6-2 .6-2 1 0 1.2.6 2 1.2.7.4 3 .1 3 .1-.8-.4-1.5-1.7-1.5-1.7 3.5-2.3 11-1.3 11-1.3 5.3 1 4.7 4.5 4.7 4.5a10 10 0 0 1 2.5 2.1c.5-1.2 0-2.5 0-2.5 2.6 1.2 3 4 3 4 3-3.2-2.7-6.8-2.7-6.8 2.7-.4 5.7-.2 7.5 0a13.8 13.8 0 0 1 6.6 3.1c2.1 1.7 5.9 2.5 5.9 2.5-.1-.7-2.2-2-2.7-2.2-.4-.2-.6-.9-.6-.9 1.9.4 3.1.2 3.1.2-6.4-4-8.1-5.9-8.1-5.9 2.4.3 3.8-1.2 3.8-1.2-5.1 0-5.4-1.2-5.4-1.2.7.1 3.1.7 6.2.1s7.2 0 7.2 0c-2.2-3.6-10.7-3-13.5-2.8-2.8.2-3.8-.2-3.8-.2.4-.2.9-.6 3-.7 2.2 0 4.3.2 6.8-1.6 2.3-1.6 5.7-1 5.7-1-.8-1.6-4.7-2.2-8 0-3.5 2.1-6.5 1.5-6.5 1.5 5.3-.8 6.9-2.7 6.9-2.7-1.6-.4-2.5.1-5.8.8-3.2.6-4-.5-4-.5 3.5-2.1 6-3 6-3-3-.6-5.8-2-5.8-2-3.2 3-5.6 4.6-11.7 1.6-6-3.2-9.2-2.8-9.2-2.8a14.2 14.2 0 0 1 14.8.6c4 2.3 5 .4 5 .4-1.2-.7-1-1.5-1-1.5 9.6 4.9 13.8 2 15.9.5 2.1-1.5-1-3.4-1-3.4-.2 3-4 4.6-7.2 3.5-3-1-6-2.4-10.4-4.3-4.4-1.8-10-.8-15.1.2-5.2 1.1-5.9.6-6.4.2-.5-.4-.7-1.7-3.4-.6-2.6 1.1-8.8-1.8-12.6-2.7-3.8-1-10.1-.5-15.5 2.5-5.4 3.1-8.2 2.3-9.8 1.6-1.6-.8-2.7-2.8-.9-4.6s2-2.3 1.8-5c-.2-2.6-2.8-4.2-2.8-4.2 2.4-2.5 3-3 2.2-4-.8-1.2.4-1.2 1.8-1.8 1.4-.6.8-.7.5-1.5-.4-.8-1.2-.6-1.2-.6-3.1.1-4.9-.8-4.9-.8-5.2-2.4-10.1 2.3-10.1 2.3-3-2.3-3.7-.7-4.2-.2-.5.5-1.6 1-3 1-1.2.2-3.1.7-3.8 1.9 0 0-.6 1 .1 2 0 0 .8 1.2-.6 2.7-1.5 1.5-2 1.8-1.5 3.3.4 1.3.3 2.4-.3 3.3 0 0-.7-.7-.5-1.7.2-1 .2-1.6 0-2 0 0-1.5 1.4-1.8 2.4 0 0-.6-1.6 1.6-3.7 2-2 3-3.2 2.4-4-.4-.6-2 .4-2.3.6z"
    }),
    /* @__PURE__ */ jsx82("path", {
      d: "M448.4 338s-2.7-2-2.4-4.9c.3-2.7.3-3 0-3.7 0 0-.5.3-.4 1.4 0 1-.2 2.1-.3 2.3 0 0-1.3-2.3-2-2.8 0 0 .6-2.4-.2-3.4-.7-1.1-1.5-1.2-2.4-.8-1.2.4-2.1 1.5 2 4.8 0 0 1.5 1.3 2.5 3.9 1 2.6 2.8 3 3.1 3.2zm13-7.8s-.1-1.5 1.3-4.3a6.1 6.1 0 0 0 .3-5.6c-.3-.8-.6-.5.9-1.7 1.7-1.5-.7-3.4 2.3-6 0 0 1.8-1.6 2.3-2.3 0 0-3 1.6-5.2 2.5-2 .8-9.6 4.6-8 7.1 1.8 2.5 1.6 2.7 1.3 3.8 0 0-4.6-2.5-3-6.4 0 0 .8-1.5 2.7-3.4 1.8-1.6.8.4 4.3-1.7 0 0 2.7-1.6 4.3-3.9 0 0-2 1.2-2.6 1.4 0 0-4 .8-5.8 2.5-1.6 1.7-5.1 4.7-4 8 0 0-4-.4-5-4.7 0 0-7.6 9.4 8.4 13.8 0 0 3 .8 5.6 1z"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#ffc221",
      d: "M531.6 299c6-1 40.4-6.2 43.6-6.5 3.4-.3 4.7-.8 5.9 2 1.3 3-4.8 3.1-4.8 3.1l-41.1 4.7c-2 .2-2.5-.6-2.5-.6l-1.5-2s-.5-.6.4-.8z"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#5a3719",
      d: "M447.3 317.7s-4.4 9.3 13 11.6c0 0 .1-1 .8-2.5.8-1.5 2.3-4.5.8-6.4-1.4-1.9 1.2-.9 1.5-3.4.5-2.5-.2-2.2 1-3.8 0 0-5.4 2-7.6 4.5-2 2.4 2.9 4.2 0 6.9 0 0-2.5-1-4-3.6 0 0-3.3 0-5.5-3.3"
    }),
    /* @__PURE__ */ jsx82("path", {
      d: "M464.5 329.2s4.3 3.7 9.4 3.6c5.1-.3 7.4-1.6 8.7-3.6 0 0 1 1.5 1 2.6 0 0 4.4-3.7 12-.5s5.4 2.3 7.1 2.5c0 0-3.3-.5-10.7 2.9-7.7 3.5-27.7 2.3-27.6-7.5z"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#5a3719",
      d: "M457.3 312.6s1.9.3 3.8-1.9c0 0-2.6.5-3.8 2zM442.6 330s-3.6-2.8-1.3-3.4c0 0 1.7-.3 1.3 3.4"
    }),
    /* @__PURE__ */ jsx82("path", {
      d: "M521.2 347.8s2-3.5 7.5-3.5 6.1 2.6 13.1 3c0 0-8.4 2.4-14.2.3-3-1.1-5.8-.2-6.4.2"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#5a3719",
      d: "M466.3 331.7s8.4 5 15.7-.5c0 0 .6.6 1.2 2 0 0 5.6-5.4 15.5.4 0 0-1.2-.1-5.9 1.8-6.1 2.7-21.4 4.5-26.5-3.8z"
    }),
    /* @__PURE__ */ jsx82("path", {
      d: "M498.3 336.7s8 1 14.7.6c4.1-.2 8.6-1 6.4.4-2.3 1.3-1.1 1.5 8.4.7 9.4-1-.1 1.7 6.4 2.6 0 0-15.9 8-35.9-4.3"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#5a3719",
      d: "M519.2 331.7s4.6-1.7 9 .3c4.3 2 3.6 2.2 6.5 2.5 0 0-2 2.9-6.7.6-4.8-2.3-6-2.8-8.8-3.4m5.2 14.3s4.6-2.3 9.6 0c.6.4 2 1 3.3 1.2 0 0-3.8 1.3-7.8 0-1.7-.5-3-.9-5.1-1.2m-22.7-8.2s10.3 1 15.8-.1c0 0-6.4 3 9.7 1.7 0 0 3.5-.4 3 .1-.3.5-.6 1 1.2 1.5 0 0-12 5.4-29.7-3.2"
    }),
    /* @__PURE__ */ jsx82("path", {
      d: "M450.7 329.2s.2.7 2.4 1.7a8.7 8.7 0 0 1 4 3.9 5.6 5.6 0 0 0 3.5 2.9s-8 1.7-11.6-2.6c0 0-2.7-3 1.6-6"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#5a3719",
      d: "M513.7 347.6s-3.1-.2-7.5-1.7c-4.3-1.5-5.4-.2-7.9-2-2.4-1.9-7.3-.7-8.2-.6-1 .1-3.6 0-.3-2.1 0 0-2.6 0-3.6-1.4 0 0-1.2 1.2-5.6.8 0 0 2 3-6 2.1a10.3 10.3 0 0 0 11.1 3c0 .2-.5 2.5 3 3.5 3.8.9 4.5 1.6 6.4 2.3 0 0 .3-1.5-4.6-5 0 0 2.6-.2 6.4.7s12.2 3.1 16.8.4m2 3.7s.8 1.8 3.2 1.4a17 17 0 0 1 10.2.8s.7-3.2-7-3.4c0 0-4.8.2-6.4 1.2m-65.2-21s-3 2.5-.3 5c2.4 2.3 6.2 2.1 8 2 0 0-1-.6-2-2-1-1.5-1-2.5-3-3.4-2.1-.9-2.3-1.1-2.7-1.6m-3-12.6s-4.6 9.3 13 11.6c0 0 0-1 .7-2.5.6-1.5 2.1-4.5.8-6.4-1.6-1.9 1.1-.9 1.5-3.4.4-2.5-.3-2.2 1-3.8 0 0-5.5 2-7.7 4.5-2 2.4 2.9 4.2 0 6.9 0 0-2.5-1-4-3.6 0 0-3.3 0-5.5-3.3z"
    }),
    /* @__PURE__ */ jsx82("path", {
      d: "M493.3 339.3s3.7-.6 13 2.9c9.4 3.4 13.3 2.6 14.6 2.5 0 0-5.2 2.8-13.4-.8-7.2-3.2-7.6-2-14.2-4.6"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#ffc221",
      d: "M551.8 337.2s2 0 3.4.5c0 0 .7-.7 2.7-1 0 0-1.3-1.2-6.1.5m-6.4-5.2s2.1 0 2.8-1.2c0 0-1.1-1.3-2.8-2 0 0 .4 1.6 0 3.2m-71.7-23.8s-.5-1 1.8-1.4l31.3-4.5s1.5 0 1.7 1c.3 1.1-.1 1.9-7.2 2.7l-25.6 3.2s-1.9.3-2-1"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#ffc221",
      d: "M502 306.9s0 4.1 4.2 4.7c4 .6 5.5-.2 6.5-2.3.3-.7 1.6-5-.2-5.3-.8-.1-2 0-2.9.3-1.4.7-2.7 1.4-2.3 2 1 1.6 1.2 2 1 2-1.2.3-1.8-.6-2-1.2-.3-.8.5-1.2-2.2-.8-1.2.1-2 .1-2 .6zm17.5-3.2c2 .3 1.9 4.8-.6 6.9-2.8 2.2-5.4 1.3-5.4 1.3-1.4-.5-1.2-.4-.1-2 1-1.5 1.5-3.6.9-5-.2-.5.3-.9 1-1 0 0 2-.4 4.2-.2"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#ffc221",
      d: "M521.3 304.1s1.6 2-.4 5.5c0 0-.8 1 1.1.9 1.8-.2 6.1-2.2 5.7-4.8 0 0-.2-.6-1.3-.6s-.2-.5.3-.8c.4 0 1.9-.6-1.9-3 0 0-.6-.6-1.3-.3-.6.2-2.6 1-2.6 2.2 0 .5.4 1 .4 1z"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#ffc221",
      d: "M525.4 300.9s3 2.1 3 2.8c0 .6-.3 1.5.5 1.3.8 0 4-.7 3-2.8-.8-2.1-1.7-3-3.2-3.4-1.5-.6-1.9.1-3.2 1.1 0 0-.9.6-.1 1m-16.1 3s.5-1.5-2.2-2.2c0 0 1.1-1 3.4-.4 2.2.4 2 2 2 2.1 0 0-1.8 0-3.2.5m5.8-.4s3-.5 4.5-.4c0 0-1.6-3.3-5.7-2.3 0 0 1.5 1.8 1.2 2.7m5.3-.8s0-1.1 2.6-2.1c0 0-1.2-1.2-3-1-2 0-2.5.7-2.5.7s2.3.8 2.9 2.4m1-3.6s1.7.4 2.7 1.3c0 0 1.5-1.7 2.8-2 0 0-2.5-1.4-5.5.7"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#5a3719",
      d: "M435.8 290.9s7.2-6.2 11.2-5.4c4 .8 2 .2 6.4-.5 4.4-.6 9-1.1 10.8-.9 0 0-5.4-3.8-14.9-3.7 0 0-6.6 2.3-11.3 5.3 0 0-8.9-4.9-18-2 0 0 9.9 3.7 15.8 7.2"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#ffc221",
      d: "m512.2 301.4 1.2-.2s2 2.5.6 2.5c-1.2 0-.8-.3-1-1a2.3 2.3 0 0 0-.8-1.3m-9 .2s-.8 1 .6.8c1.7-.3 1.4 0 3.1-1.3 0 0 1.2-1.1 3.2-.4 0 0 1.8.6 3.2-.1 1.4-.8 1.7-.7 2.5-.6.8 0 .8.2 1.7-.6 1-.7 2.8-.1 3.9-1 1.1-1 2.5-.2 0-2 0 0-.5-.5-.5-1 0 0 1 .4 1.8 1 .8.8 2 .5 2.2.4 0 0 .2-2.3 2.3-4.3 2.3-2 2.3-2.2 1-2.2s-3.5-.6-4.3 0-7.2 4.8-11 5.5c-3.8.7-7.3 1.8-9.7 5.8m-101.3-23.4s11.7 3 14.3 4.2c0 0 .6-1.9-4.7-3.4 0 0 12.9-.4 26.4 5.8 0 0 6.6-5.6 27.7-3.9 0 0 0-1.8.2-3.3 0 0-14.8-.4-28.4-8.7 0 0-12.3 6-35.5 9.3m64.7 5.6c-.7-11.8 3.8-13 3.8-13s2.1 0 4.4.5c0 0-3.6 4.3-2.6 12.8 0 0 .4 1.3-2.7 1.3s-2.9-1.5-2.9-1.5z"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#5a3719",
      d: "M469.8 291.7s-2.3-2.3-2.5-4.9c0 0 0-.6 2.2-.6 2.3 0 2.5-.2 3 1.1.6 1.3 2 4 2.3 4.3z"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#ffc221",
      d: "M474.5 285.7a28.3 28.3 0 0 1-.2-4.5c.1-6.6 1.2-6 1.7-5.2h2.3s-1.7-7.4-3.7-3a19 19 0 0 0-1.5 10.4c.1 2 .3 3.3.6 4z"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#5a3719",
      d: "M500.2 285.7s4.3.8-2.3 2.3c0 0 .3 8.2 8.2 2.5 0 0 4.7-3 8-4.2 0 0 1.6-.6 1.4-1.8 0 0 .2-1.5-1.5-1.1 0 0-1.4 0-2.3-.3 0 0-1-1.2-1.6-.8-.6.5-2.1.2-.9 1.7 1.2 1.4 1.5 1 2 .6.6-.4 3.1-1.4.9.7s-4.2-1.2-5-1.8zm-22 1h-2s-1 1.6-1.7-1l-.7 1.6s2.3 8.8 4.4-.6"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#ffc221",
      d: "M475.4 276.6s-1 5.8.3 9.2l21.1.5s-.2-4 0-9.7H494s-.5 4.6 0 7.5h-.5s-.4-4 0-7.5H491s-.4 4.3 0 7.5h-.5s-.4-3.7 0-7.5H488s-.5 3.9 0 7.5h-.6s-.5-3.9 0-7.5h-2.7s-.6 3.6 0 7.5h-.5s-.6-3.6 0-7.5h-2.7s-.6 4.2 0 7.5h-.6s-.4-4 .1-7.5h-2.5s-.7 3.5 0 7.5h-.7s-.4-3 .2-7.5zm22.3 10.4s-.5-10.2 1.4-13c2-2.6 2.5-2 5.8 0 3.4 2.2 7.7 4.5 8.5 4.8.6.3 1.6.5 1.6 2.4s.3 2.4-2.6 0a9 9 0 0 0-2.7-1.8c-2.6-.9.6.5 1.5 1.9.8 1 1.5 1-.6 1.5a219 219 0 0 0-12.9 4.2"
    }),
    /* @__PURE__ */ jsx82("path", {
      d: "M505 279.6s-1.5-1.8.5-2.3c2-.4 2.1 3 2.5 5.1.3 2.2-2.5-2.1-2.8-2.7zm-2.7 9s-2.3.9-.7 1.6c1.4.7 5.5-2.7 4.2-2.5-1.6.3-3.5 1-3.5 1zm3-3s2-.3 1.6.5c-.3 1-1 .4-1.4.2-.3-.2-1.6-.7-.1-.8z"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#ffc221",
      d: "M516 282.8s.6 4 4 5c0 0 2 .4 1.5-1.3 0 0-.3-1.5-.6-2-.3-.7-1.6-1-1.8-1.1-.2 0-.3-.5.6-.2 1 .3 1 .4 1-.3s-.6-.4-1.4-.8c-.4-.2 0-.4.3-.3.4 0 1.3.3 1.3-1 0 0 .1-.8-.9-.8-1.1 0-1-.6-.7-.7.3 0 1.5.8 1.9-.6.3-1.3-1.6-.5-1.4-1.2.3-.8 1.7.3 1.7-.5.2-.8 1.3-1.1-.6-1.4-.9-.1 0-.6 1-.4 1 .1 1.6-1.2 2.3-1.6.6-.5 4.2-2.6-.6-1.9-4.7.7-6.1 3-6.3 3.5a13 13 0 0 0-1.3 7.6"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#ffc221",
      d: "M527 285.8c.7 0 1.2 0 1.4.5.8 1.6-1 1-2 2.2s-1 1-2.4.5c-1.4-.4-2-2.5-2-2.5 0-.7.5-.8 1.2-.6 0 0 2.3.2 3.9 0zm-5-.8s0 .4.9.5c.7 0 3 .3 4.5-.1 0 0 .4-.1.2-1 0 0 0-.7-1.2-.4-1.3.2-3 0-3.7-.1-.6-.2-1 0-.8 1zm-.2-2.9s-.1 1.3 1.1 1.4c1.3.2 2.9.2 3.5 0 .5 0 1.4-.2 1.5-1 0-.7.2-1.2-1.3-.8s-3.4 0-3.6 0c-.1 0-1.2-.3-1.2.4m.5-2.5s-.3.6-.2 1.2c0 .5.9.7 2.5.7s3-.2 3.2-.7c.1-.7.5-1.3-.7-1-1.3.1-3 .2-3.6 0-.6-.3-1.1-.4-1.2-.2"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#5a3719",
      d: "M582.1 286s0 1 .9 2.2l-45.2-1.3s.6-.4.8-2.2z"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#ffc221",
      d: "M522.7 277.8s-.4 1.1.4 1.4c.7.2 2.2.4 4 .1 0 0 1 0 1.3-1 .3-1 .3-.4-2.3-.8 0 0-.8-.3 1.5-.3 0 0 1.4 0 1.5-.2.3-.2 2-1.7-.3-1.5-2.3 0-1.1-.5 0-.5 1.2 0 1.6.3 2 0s0-.2-.7-.8-.1-.5.3-.1c.5.3.8.5 1.3 0s-.4-1.2 0-1c.3 0 .6.8 2 0 1.6-.7 3.5-.3 4 0 .6.5 2.2 1 3.1 0 1-.8-1.1-1.7-.3-1.8 1-.1 1.6.2 1.9-.5.4-.8-1.4-1.4.3-1.8 1.6-.5.2-5-.3-5.5 0 0-1.9 1.1-3.8 4.3-2.1 3.3-3.3 5.2-6 4.2-3.9-1.5-6 .6-6.5 1-1 .6 2 .8.2.9-1.7 0-1.7.2-1.8.4-.2.3 0 .5.3.6.3 0 .9.6-.1.6s-1.8-.3-1.5.9c0 0 0 .2.6.3.6 0 .8.8-.3.8-.8 0-.8.2-.8.3m4.1 11.3s-.7.5.3.6c1.2 0 1.7.3 2.1-.3s1.8-.4.8-1.2c-1-.8-1.6-.3-3.2 1z"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#ffc221",
      d: "M531.5 275.5s3.8-3.5 6.9-1.2c3.2 2.5 3.4 2.8 3.5 2.9 0 0 .4.3-.4 1-.9.8 0 .8.9.3s1 0 1.4.5c.5.5 1.1.8-.3.8h-4.6s-2.1.2-1-.7c1-.9.8-1.9.3-2-.6 0 0 .6-.3 1-.4.4-1.1.7-1.9.7s-1.4.6-.2 1c1.1.4-.2.7-.8.7s-3.5.2-.5.6c3 .3-.3.3 2 1.5 2.4 1.4.6 4.3-.3 4.6 0 0-1 .5.2.4 1.3-.2 2-.3 1 .4-.8.6-2.6 2.9-5 1.2 0 0-1.2-.6.8-.7 2 0-1.6-.5-2.3-1-.5-.3-3-2.7-1.5-2.5 1.6.4 1-.5.1-.8-.8-.3-1-1.6 0-1.4 1 .3 2 .9 3 .8.7 0 .5-.3-1.2-.8-1.7-.6-2.4-.7-2-2 .4-1.5 2.3.5 1.8-.6-.4-1-2-.5-1.2-1.9s1-.8 1.5-.6c.3.1 1 0-.1-.8-.8-.5 0-1.3.2-1.4"
    }),
    /* @__PURE__ */ jsx82("path", {
      d: "M534.2 276.5s0-.5.8-.4c.6 0 .4-.2.6-.4.2 0 1.9.5.3 1-.6.3-1.6.2-1.6-.2z"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#ffc221",
      d: "M537.9 280.5s-1.3.6-.2 2c1 1 1 1.5 1 2.2-.1.8 43.4 1.3 43.4 1.3s0-2.9 1.8-4.5z"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#5a3719",
      d: "M582.8 285.2s.2-2.4 1.6-3.1c.7-.5 1.6-.3 2 1.6.6 2.7-1.7 5.1-2.7 4-1-1-.8-2.5-.8-2.5z"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#7b3c20",
      d: "M532.9 295.4s2.9-2.5 3.4-3.6c0 0 7.8 5.6 7.3.4l.2-2.6s2.9.3 3.3-2l-7.3-.3s-.8-.1-2 1.1c-1 1.2-3.4 2.5-5.5 1.4 0 0-1-.8-1.9 0-1 .5-1 .7-.2 1.5s2.4 2.9 2.7 4zm16.8-15.4-4.3-.2s-1.5-2.2-4.6-4.6c0 0-.9-.4.8-1.8 1.8-1.4 2.3-2.8 2.3-3.5 0-.6 0-1.7.6-1 .6.8 5 4.9 5.8 3.7.6-1.2.7-1.7.7-2.1.2-.4.3-1.5 1-.3.6 1.1 1 .8 1.1 3.8 0 0 0 3 .5 4 0 0-5.6-1.7-3.8 2zm-18.6-9.2s3.3 2 5-.6c1.5-2.5 2.6-2.8 1.4-5.3-1.2-2.3 0-3.4.9-4.4 1-1 1.8-.8 1.8-4.6.2-3.9 2.8-5 4-6.3 1.2-1.2 4.2-3-.4-3.7-4.4-.8-13.4-3-15.7-6.5-2.3-3.5-3.3-1.5-3.3-1.3 0 .2-.8 2.7 1.5 7.3s4.2 7.6 6.5 9c2.2 1.5 4.2 2.3 3 5.4s-3 8.6-4.7 11"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#5a3719",
      d: "M543.2 261s.6 8 6.3 10.8c0 0 1.3-3 .8-6.1 0 0 1.9.1 2.4 1 0 0 0-2.3-2.6-3.2-2.7-.7-1.4-6-.4-6.5.9-.6.6-1.7 0-2.6-.7-1-.8-2.3 1.4-1.7 2.3.6 2-.6.5-1.7-1.3-1.1-1.3-2.5.7-2.5s5-1.9 3.2-2.4c-2-.6-2.5-1.3 0-2 2.7-.8 4-1.7 2-2-2-.2-3.3-.9-1.4-1.2 1.9-.3-.3-2.3-2.5-2.3-2.3-.2-7 .7-3.3-2.3 3.8-3-5.4-.8-1.6-2.8 3.8-2-1.3-1.1-2-1.1s-.7 0-.4-1c.2-1-.5-1.6-1.7-.9-1 .6-1 .6-1-.7 0-1.5-1.3-.4-2.1 0-.9.3-3 1.9-3.9 1-.7-.9-1.2-1.7-3.8-.2-2.6 1.5-2 .2-2-.5s1-3.4-2.4-.5-.7-3-3.5-1c-2.7 2-3 2.4-3.5 1.5-.5-1-1-1.7-4 .3-3.1 1.9-.8-1.3-.5-2 .5-.6 1.8-5-.9-1.6 0 0-1.3 2.4-4.2-1.9 0 0-3 4.3-3.9 2.4-.8-2-1.5-2-2.6-.8-1 1.2-.2-.1-.7-1.2-.4-1-.7-2.9-5.8.8-5.1 3.8 1.8 1-2.1 2.7s-13.5 7-4.8 5.9c8.7-1.3-4.2 3.3-1.2 4.2 3 .8 2 3.5 13.4.3 11.2-3 9.4-.4 15.2-3 5.8-2.4-1.4.9 6.4.8 7.7-.2 1.3 0 2.8 1.6 1.5 1.6 8 5.3 14.1 6 6.1.6 7.7-1.7 5.9 1-1.8 2.6-2.4 3.6-3.4 4.6-1 .8-4 3-4 6.6 0 3.7-4.8 4.3-3 8.3l4.1-4z"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#5a3719",
      d: "M553.3 269.9s-1.4-1-1.4-2.8c0 0 1 .2 1.4.8 0 0 3.5-4-.8-5.4-4.1-1.4-2-5.3-.6-5.3s1.7-.3.4-2c-1.2-1.5-1-1.6 1.3-2 2.3-.4 2.1-1 1-1.5a7.7 7.7 0 0 1-1.9-1.6s6.8-2.9 4.6-4.3c-2.2-1.3 0-1 2-2.3 2-1.4 2.2-1.7 2.5-2.3 0 0-2 .3-3.4 0 0 0 1.7-.9 0-2.3s-2.3-2.6-5-2c-2.7.7-1.8-.2-.8-1.3s.6-1.7-1.3-2c0 0 .2-1.2 1.7-2.5 0 0-3.7.2-5-.4 0 0 1.6-1 1.6-2.3 0 0-2 .7-4.5.5 0 0 1.5-1.3 1.5-2.4 0 0-4.4 1-6.4 2.5 0 0-.5 0-.8-.6-.4-.4-.6-1-5.5.6 0 0 .5-2.2 1.7-3 1.2-.8 1-2.6-6.5 2.1 0 0-1-.6-1.9-2.9 0 0-1.7 2.3-2.9 3.1 0 0-1 .5-1-1 .2-1.5-.7-.5-1.4 0-.8.4-1.3 1.5-1-1.5s-1-3.6-1-3.6-2.3 3.3-3.7 3.7c0 0-2.5-2.4-3.4-4-.8-1.6-.8-2.2-1.7.6-.9 2.7-2 3-2 3s-1.5-1.3-1.6-2c0 0-.3.7-.8 1 0 0-1.3-1.5-1.2-3.7 0 0-8.2 4.5-9.2 7.2 0 0-7.7-.5-10.8.1 0 0 .7-2.4 2.7-3.7 0 0-2-.2-2-2.3 0 0 1.6.2 2.6 0s-1.4-3.1 1.1-3.2c2.5-.1 4.2 1.2 3-2.2-1-3.3-.6-3.3-.6-3.3s4.4 2.6 5.1 1.9c.8-.6-.5-2 3.4-1.4 3.9.7 2.8-1.5 4.4-1.7 1.5 0 2.3 1 1.3-6.1s4.8 3.5.9-7.2c0 0-1-3.3-3.3-4.7 0 0-.6 2.3-3.2.3-2.6-2-7.8-2.8-5.6-4.4 2.2-1.7 3.2-3.9 2.6-5.2 0 0-2.6 2.6-7 .7-3.6-1.5-4.4 1.3-8 .5 0 0 0-1 3.1-3.4 3-2.3-1.8.8-3.6 1.3-1.9.4-2.4 0 1.5-3.1 4-3 12-8.5 11-13 0 0 1.8 2.3 6.7.6 5-1.7 8.6-2.3 10-5a23 23 0 0 1 6.4-5.6c1.1-.5 2.4-1 .9 1.5-1.6 2.4-4 6.6-10.8 9.4-6.8 2.8-9.5 4.8-10.7 6.3-1.2 1.5-7.4 4.8-3.3 4.3 4-.7 10.9 0 7.6-1-3.2-.9-6.9.6-3.9-2.1 3-2.7 3.5-3.6 7.9-5.4 4.4-1.9 9.2-6.1 8.7-1.6-.5 4.4-8.6 9.1-10.6 10.6-2 1.4-1.2 1.2-1.2 1.8 0 .6-.4 1.8-1.2 2.3-.8.6-.5 1.2-.3 2.4.2 1.3-.2 1.8.4 2 .6.1 1.2.2 1.4 1.1.2 1 .6 1 1.8 1 1.1-.2 2 0 2 .6 0 .7 1.2 1.7 1.3-.4.1-2.2 1-2.5-1.2-1.5-2.2.9-2.6.6-2.6-.4s-.2-.8-1-.9c-1 0-1.3-1.3.3-2.2 1.6-.8 1.6 0 3.6-1.6 2-1.7 2-2 2.3-3 .3-.7-2.9 2.4-4.4 3-1.5.8-1-.5-.8-2.1.3-1.7 4-4 5.7-4 1.8 0 5.6 1 4 3.3-1.7 2.3-6.4 5.2-4.5 5.4 2.1.2 2.4-.6 3.6.4 1.2 1 0 3.2-.4 4.4a8.4 8.4 0 0 1-2.2 2.7s-2.2-3.8-2.1-.8c0 3.1-.5 4.2 0 4.3.5.1 2.8 1.7 3.6 1.7s-4.1 2.3-2 2.5c2 .1 5.3-1 6.4-3 0 0-4.2-1-5.9-2.6 0 0 4.9-1.2 3.5-5.8 0 0 4.9 1.3 2.7 3.5-2 2.1-3.3 1.8-1.5 2.4 1.9.6 2.7 1.2 2.7 1.2s1.3.6.5 1.6c-.7 1-.7 2.6 0 2.5.5 0 2.6-1 .9-2-1.8-1 1.9-.8.4-1.7-1.6-1-2-1.1-2.4-1.6-.5-.3 19.7-12.2 9.5-7.8 0 0 2.1-4.6 5.1-4.6 3 0 3.2 2.3 1.5 4.2-1.7 1.7-2.8 4.6-6.7 5.2 0 0 5.6 2.7-1 7.2 0 0-1.5.7-1 1.2s4.5-1.7 5-3a5.5 5.5 0 0 1 3-3 38 38 0 0 0 11.2-9.6c2.3-3.9 2.8-4 7.2-7.5s3.6-2.8 4.2-3.6c.5-.9.7-2.3 2.7-3.4 2-1.2 9.8-5.4 12.3-7.2 2.4-1.8 7.4-5 9.6-7.8 2.1-2.7 8-6.2 9.4-5.6 1.4.7-.2 2.8-3.5 5.4-3.5 2.5-12 9.3-13.3 10.4a44.7 44.7 0 0 1-11.2 6.6c-2.7.3-2.4 1.3-4 3s-5.3 5.4-6.5 6.4c-1.3 1-4.3 3-4.4 4.5-.2 1.5.5 1.6-1.9 3.8a50 50 0 0 1-11.9 8.1s4.5 1.6 1.8 4.6c-2.6 3-2.5 2.6-2.6 2.8 0 0 6.7-1 2 4.3 0 0-1 1.5 1.1 0 2.3-1.9 1.4-4.1 1-4.5 0 0 3.7-2.3 7.9-2.3 4.1 0 4-.3.2-1.4 0 0 2.7-3.2 5-1.6 2.2 1.5 1.4 2.5-.9 3.8-2.4 1.2-5.8 1.7-8.5 3.2 0 0 5 1 7.6-1.1 2.6-2 2.8-1 3-.6.5.4.8 1-.4 2.6-1.2 1.7-1.3 1.8-1.2 2.2 0 .4-.1 1.5-2.5 2-2.3.3-3.5 1.3-2.6 2.4.7 1.2.7 4-1.2 3.7-2-.3-1.6-1.9-2.3-2.5-.8-.6-1.9-1.5-5.4.2-3.6 1.9-3.8-.3-3.7-1.5 0 0-2.3 2-4.2.2-2-1.9-.2-2.6 1-3.5 1-1 5.5-3 2.8-2.5-2.7.3-6.7.4-7.6-1.6-1-2.1 2-1.9 2.4-1.7.5.2 2.3 1.7 2.5-.3 0-2 3-2.3 2-2.6-1-.4-2.5.9-2.9 1.3 0 0-2-2.9-5.4-2-3.4 1 1 .7 2 .8.8.2.3 1.8-2.7 4.6-3 2.7-1.7 1.8.5 1.8 2.3 0 7.9 0 4.6 2.6-3.2 2.7-4.5 4-6 3.6-1.8-.5 0-1.6.8-2.1s1.2-1.2-.4-.6c-1.6.5-2.1.7-3.4-1.5-1.2-2.3-.8-1.6-.2-3.1.6-1.5 1.8-3 .4-2.5-1.6.6-1.4.7-1.3-1 .1-1.7-1.7-2.1-1.7-2.1s.8 1.7.1 2.8c-.6 1-.7 1.4.4 1.6 1 .4 2 1.3.6 2.3-1.4.9-1.2.7-.4 1.3 1 .7 2.3 1.3.9 2.7-1.4 1.4-.3 1 .4 1 .8 0 2.3.6 2.3 2 0 1.2 0 1.5 2.3.3 2.3-1.3 6.7-1.1 6.7.6 0 1.8-.6 2.3 1.8.8 2.4-1.5 3.5 1.4 5.2 0 1.6-1.5 2.6-2.8 4.6-.4 1.9 2.4 1.3 3-1 4.8-2.3 1.7 1.1.4 2.9-.5s6.7-1.5 9.5-.2c2.9 1.2 3.7 1 5.8 0 2.1-.8 3.2-1 6.3 1.1 3.3 2.2 5.7 2.6 7.4 2.5 0 0-3.5 1.4-7.5 1.6-4 .3-6 1-6.7 1.6 0 0 2.3 1.5 2.8 3.2 0 0 2.6-.3 3.8.2 0 0-.6 1.9 1 2.9s2.7 1.4 1.5 2.7c-1.2 1.4 1.9.8.1 2.7-1.7 2-2.1 3-2.2 4.5 0 1.6.4 1.8-1.1 2-1.6.1.2 1.9-.5 4-.7 2-5 1.7-4.8 7.2 0 0 1.2-2.7 3.8-5 2.5-2.4 2.6-2.6 2.5-4 0-1.4-.1-1.1 1.2-2.2 1.4-1-.6-2 .8-3.6 1.3-1.5.2-1.2 1.8-2.7 1.5-1.6-1.5-1.7.2-3.3 1.5-1.6-4-3.5-2.3-4.5 1.5-1 4.3-2.4-5-2.3 0 0 2.3-3.6 10-2.9 0 0-2 1.6-2.2 3l1.6.5s-.4 1.1-1.9 2.3c0 0 4.2 2.3 4.9 3.8 0 0-2.6.8-3.3 1.8 0 0 1.2 1.3 1.6 3 0 0-2.9-.4-3.2 1.7-.4 2.1-1.3.7-1.3 2s.1 1.7-.9 2c-1 0-.1 1.1 0 1.8.2.7.6 2.3.4 2.8 0 0-1.5 0-2.1.2 0 0 .4 3-1.3 3.5-1.7.4 1 1-.9 1.3-1.8.3-1.5.5-3.7 4.5 0 0 1.9-1 3.8-2.4 2-1.3-.2-1 3-4 3.3-3.3 2.7-3.5 2.4-5.1-.2-1.6-.3-3 .9-4.5s1.5-3.2 5.7-3c0 0-1.2-2.8-2.7-3.5 0 0 2-1.3 4-1.5 0 0-1.8-2.3-5.6-4.4 0 0 3-2.6 3.9-3.9 0 0-1.5.3-2.7 0 0 0 .6-1.3 3.4-3.1 0 0 1.5 1.4 1.4 2.9 0 0 4.8-2.7 7.5-2.4 0 0 1.4 3.4-5.3 10 0 0 4.2.3 6 0 0 0-1 3.2-6 5-5 2 1 4.2-4.1 3.8-5-.4-3.5 1.3-3.4 3.9.2 2.6.3 5.3.2 6 0 0-4-1.3-4 2.6.1 4-2 4.8-2.5 5.1 0 0-1.2-1-3-1.7 0 0-2.5 4.9-6.5 7.7"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#7b3c20",
      d: "M547.4 220.5s1.4-.2 3.8 1.2c2.3 1.5 4.6-1.5 2-2.3-2.6-.8 0-1.8 2.4.2 2.4 1.9 3.3.9 4.2.3.8-.7 1.9-1.1.3-2.2-1.6-1.1 1-.6 2.3.3 1.2.7.7 1.5.6 1.7-.2.2-.3 2.9 2 .5 2.4-2.5 3.7-4.8 3.6-6 0 0 1.3.8 1.5 2.3.2 1.5 2-.8 2.6-1.6.6-.8 1.6-3 1.5-4.4 0 0 1.6 2.5 4 0s1.4-1 4.2-1.7a17.6 17.6 0 0 0 8.5-5.2c2-2.5 2.1-.8 4.6-1.4s7.7-4.2 8.2-6.1c.4-1.9.3-3.1-.4-2.4-.7.6-.4 0-1.5-.6-1.1-.7-2.7.9-2.7.9s1.6 1.2.3 1.7c-1.2.6-2.3 2.3-4.6 1.6-2.3-.6-4.8 2.2-4.8 2.2s2 1.6-.7 2.7c-2.7 1-2.3 1.4-3.9.2 0 0-2.9 3.7-4.6 4.5 0 0-.7 0-1.2-.8 0 0-2 2.1-2.8 2.5 0 0-1.3-1-2.3-1.5 0 0-2.3 2.9-4.2 3.7 0 0-.6-1-1.8-1.7 0 0-.6 3.6-4.6 5.8 0 0 .2-1-1.8-2.3 0 0-5 4.3-6.9 4.7-2 .4-.2-.9 0-1.5.4-.5 1.6-2.3-.8-3s-2 .5-2.5.7c-.6.2-.6-.4-2.2-.2s-1.3.9-2 1.2c-.8.2-3.6-.5-3.4 1.4.1 1.8 1.5 3.1-1 4.2-2.5 1 1 .8 4.1.4"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#5a3719",
      d: "M557.5 215.3s.6-2.5-1.5-3.5c0 0 13.2-2.1 3.2-7.2 0 0 11.9-2.3 9-6.1-2.7-3.8-5.4-3-5.8-3-.4 0 2.5-2.1 3.3-1.8.7.3 10.2 3.9 7.8.7-2.4-3-2.2-2.9-2.6-3.8 0 0 3.1 0 7.9 4.6 0 0 1-1 .9-2.9 0 0 3.3 1 4.4 2 0 0 .6-1.2.3-1.8 0 0 3 1.5 4 3.2 0 0 1.3-1.2 1.5-2.6 0 0 3 1.3 3.7 2.2 0 0 1-1.3.6-3 0 0 4.9 1.3 5.5-1.6 0 0 4.9 1 1.7 2.9-4 2.5-.4-.6-4.6 2.3-3.2 2.3-5 4.9-6.6 4.4-1.1-.5-2.5 2.9-4 1.3-1.5-1.7-1.5-1-2.7.7a24.5 24.5 0 0 1-2.8 3.5s-.8-.5-1.6-1.2c0 0-.8 1.6-2 2.8 0 0-1-1.3-2.6-2 0 0-2.3 2.7-3.8 3.7 0 0-1.4-1.4-2.9-1.9 0 0-.2 3.8-3.1 5.7 0 0-.6-1.2-2.6-2 0 0-1.4 2.3-4.6 4.3z"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#5a3719",
      d: "M550.6 209.5s-1.6 1.2-.6 2.5c1 1.4 1.1-.2 2.4-.3 1.3-.2 17.5-3 2.8-7.3 0 0 .7-.6 3.1-.8 2.6-.3 11.8-2.7 7.5-6-4.3-3.2-7.9 1.1-4.3-2.8 3-3.1.6-4.6.6-4.6s-8.5 5.6-10.4 6.7c-1.8 1-4.6 3-1.4 4 3.3 1 5.4-3.4 5.7-2.4.3 1-6.4 4.8-5.4 6.4.9 1.8.7 3.3 2.4 2.9 1.6-.3 6 .8 2.5.7-3.7-.1-5 1-5 1z"
    }),
    /* @__PURE__ */ jsx82("path", {
      d: "M556.4 201.3s-1.5 1.1.5.6 5.9-1.4 5.2-2.4c-.8-1-3.4.2-5.7 1.8"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#7b3c20",
      d: "M582.4 184.5s7.5-.2 10.5 1.9c3 2 4.6 3.4 5.5 3.8 0 0-.1 2.8-5 .7 0 0 .4 1.4-.2 2.8 0 0-1.7-1.2-3.8-1.7 0 0-.4 1-1 1.7 0 0-2.1-2.2-4.6-2.9 0 0-.4 1.1-.8 1.6 0 0-2.6-1.6-4.6-1.6 0 0 .4 1.7 0 2.3 0 0-5.4-4.3-10.3-3.8 0 0 2.3 3.5 3.8 5.1 0 0-9.8-.7-8-6 1.5-5.3-.2-4 6.2-4z"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#5a3719",
      d: "M536.3 199.1s-1.1 1 0 1.7c1.1.8 5-2 5.5-2.4.6-.4 2-.4 0 1.1s-3.8 3-5 4.6c0 0 6.4-1.8 10.6-5.4 4.3-3.7-.1-1.3 7-4.8 7.3-3.5 11.1-9.1 7.2-8.5-3.8.6-7.3 5-10.4 6.7-3 1.7-4.7 2-4.2 1 .4-1 2.7-.6 6.9-4 4.1-3.3 3.2-3 3.2-4.2 0-1.2-1.5-4 4.7-7.4 6.2-3.3 25.6-14.5 27.3-18.5 0 0-5.7.6-13.2 6.1a69.7 69.7 0 0 1-13.4 8.8c-2 .8-1.8.2-3.1 1.9a171.8 171.8 0 0 1-10.1 9.8c-1.3 1-1.8 1.6-1.9 3.8 0 1-8.4 7.3-11 9.7z"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#5a3719",
      d: "M562 184.3s-1.5.6-3 0c-1.3-.7-.8-3.6 2.5-5.5a50 50 0 0 1 12.6-4.8s-.5 3.8-10.1 7.1c0 0 .6 2-2 3.2"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#aa5323",
      d: "M565.4 181.8s.3 1 0 1.8c0 0 17.9 1.7 27.1-9.2 0 0-12.7 1.2-17.7 4.3 0 0 3.2-4 12.7-7.3s13.4-7.4 14.2-9.7c0 0-12 4.3-17.7 4.3 0 0-1.2 0-2.3.5-1.1.7-8.8 6.2-10.8 7.2 0 0 4.3-.4 5.9-1.8 0 0-3 8-11.4 10z"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#5a3719",
      d: "M531 192s-2.3 1.7-1.3 2.4c1 .9 2.6 1 6-1.9 3.6-3 12.1-10.2 6.8-10.5 0 0-7-.4-6.7 3.8.2 4.2-4.4 6-4.8 6.2m-15.9-2.5s4.6 2.7 2.8 4.9c0 0 14-11.8 10-14.4-3.8-2.6-6.9 2.3-6 2.7 1 .6 3-.4 2.3.6a77.4 77.4 0 0 1-9 6.2zm-3.6-3.8s3 1 3.2 2.3c.1 1.2 9.2-6.4 6.8-9.7-1.1-1.5-6-2-6.4.8-.2 3 4.6-.3 3 1.8-2.2 2.7-5.9 4.4-6.6 4.8m32.6-6.4s-1.9 1.4-.1 2.3c1.8.7 2.8-.6 3.7-1.3.9-.8 5.3-4 6.2-6 1-2 2.5-2.7 4.1-3.7 1.5-1 12.6-6.6 19.5-12.7 6.8-6.1 4-4.5 11-8.4s11.7-7.5 13.2-11.8c0 0-3.3 1-6.2 3a243 243 0 0 1-10.7 6.5c-1.3.5-3 .6-4 1.6s-1 2.3-4.3 5c-3.5 2.9-21 15.3-23.2 17a334.7 334.7 0 0 0-9.2 8.5"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#aa5323",
      d: "M530 183.4s2-1 5.6-.8c3.6.2 17.8-13.6 22-16.3a341.6 341.6 0 0 0 18.7-13.8c1.8-1.8 2-3.6 3.6-4.6 1.5-1 3-.9 6.4-2.9 3.5-2 20.3-12 19.3-17.8 0 0-25 15-30.7 19.8a375 375 0 0 1-24.7 17.7c-2.8 1.9-5 5-9.9 8.8-4.7 3.9-9.5 7.2-10.3 10z"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#aa5323",
      d: "M524.8 178s4.6-.4 5.2 1.9c0 0 10-6.8 12.2-9.6 2.2-2.8-.8-1.2 4.9-4.9a594.3 594.3 0 0 0 27-19.1c2.7-2.3 7.8-5.5 11.9-8.2 4-2.8 19.9-10.6 18.1-17l-14.2 9.5c-2.7 1.8-3.9.8-6.5 2.9-2.6 2.1-8.5 6.3-9.5 7.6a161.3 161.3 0 0 1-14.4 11c-4.4 3-14.1 8.6-18.9 12.8a602.8 602.8 0 0 1-15.8 13.2z"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#aa5323",
      d: "M510.4 176.8s2.3 0 3.1.9c0 0 4.3-3.9 8.9 0 0 0 16.8-11.5 18.5-14.4 1.7-2.8 4.5-2.9 11-7.6 6.6-4.8 10.7-6.9 15-10.2 4.4-3.4 8.1-7.3 11.2-9.3 3.1-2 11-7.2 9.8-11.7 0 0-6.5 3.6-10.6 8.2-4.2 4.6-3.8.7-8.1 4.5a82.7 82.7 0 0 1-16.3 11.7c-5.5 2.7-2.2 2.4-6.2 5-3.9 2.5-3.6 2-5 2.5a10 10 0 0 0-5.1 3c-1.6 1.7-5.4 4-9.6 6.5a106.5 106.5 0 0 0-16.6 10.9"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#aa5323",
      d: "M515.5 168s-1-1.9.7-3.3c1.6-1.3 4.6-4.8 5-7 .5-2.3.1-1.9 4.8-3.8a188.2 188.2 0 0 0 38.2-21.6c1.8-1.5 6.4-4.6 8.3-6.2 0 0 .8 2.5-1.2 4.2a222.1 222.1 0 0 1-21.5 14.9 76.6 76.6 0 0 0-9.6 5.5c-1.9 1.6-1.6 2-10.2 6.3-8.5 4.1-9 4.6-8.7 4.9.3.4 4.2-1.3 6-2.4 1.8-1 8.8-4.3 11-6a69 69 0 0 1 7-5 296 296 0 0 0 18-11.2c3.5-2.7 4.5-3.5 5.3-3 .7.4 2 .4.4 2s-6.7 6-8.7 7.3c-2 1.3-8.1 5-9.8 5.8-1.7 1-2.4 2.5-3.4 3.2-.9.8-3.7 2.7-7 3.5s-4 3.3-6.3 4.8c-2.3 1.4-18 10-18.5 10.3 0 0 .9-1 .2-3.2"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#aa5323",
      d: "M570.3 132.4s-.9.8-.4 1.2c.6.6 2.8 2.2 5.6-.6a106.5 106.5 0 0 1 12.5-10c2.3-1.5 3.6-2.8 3.5-4.7 0 0-11.4 6-21.2 14.1m15.6-1s1.7-2.9 6-5.7c4.3-2.7 10.8-6.7 11.5-7.6 0 0 1.6 1.7-1.7 3.8a311.7 311.7 0 0 0-10.8 7c-.7.7-2 1.6-5 2.5"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#7b3c20",
      d: "M499 163s-4.8 2.6-3.1 4.2c1.7 1.5 4.2 1 5.4.6l3.2-1c.4 0 4.5-1.3 5.6-3.2 1-2 3.8-4.2 6-5.8 2.2-1.5 3-3.2 2.7-4.3zm-28.4 22s3.4-2 8-.7c0 0-.2-1.1-1-1.7 0 0 5.7-1.5 6.9-4 1.2-2.5 1.5-2 2.5-2.6 1.2-.8 8.7-6.8 7.8-8.1-.9-1.3-1-3.1-1.7-3.7 0 0-1.5 2.1-9 5.7-7.2 3.6-15.4 6.2-21.4 14.2-5.9 8-5.3 12.6 2 14.7 0 0 5-3.2 17.6-2.1 12.4 1.1 16.6 5.8 17.4 6.6.8.9 3.3 4 .9 9.1 0 0 2.5 1.1 2.6-1.3.3-2.3.4-1.8 1-1.5.6.4 1.3.5 1-1.4a18 18 0 0 0-2.3-7.2c-1.1-1.5.2-.8.9-.6.7.3 3.3 2.5 1.8-1.5-1.5-3.8-2-2-2-1.8 0 .3-.4 1.2-3.8-1.4a26.8 26.8 0 0 0-8.8-4.4c-2.3-.6-.7-.6.7-1 1.4-.6 3.1-.8 3.8-2.4 0 0-1.4.3-3.8-.6a13.2 13.2 0 0 0-11.5 2s1.2-4.5-2.5-4.3c-3.6.3-6.2.2-10 3.2 0 0-.3-4.6 3.4-7 3.7-2.5 3.2-1 5.2-1.6 2-.6 2.3-2.7 1.4-3.4 0 0 4.8.9 12.8-5.8 0 0-4.3 5.7-9.5 6.8 0 0-.9 3-5.7 3.7-4.8.7-4.6 3.4-4.6 4.1z"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#5a3719",
      d: "M457 212.7s2.2-14.1 15.5-15.1c11.4-1 15.1.5 17.4 1.3s8 2.4 5.8 4.2c-2.2 1.8-3.5 1.5-3.5 1.5s2.5-2.9.2-3.3c-2.3-.5-2.4.9-2.7 2-.4 1.3-.5 2.6-1.6 3.6 0 0-1.2-1.4-2.9-.2s-.2 1.2.5 1c.6-.2 1.5-.5 1.3.5-.1 1-1 2.8-3.8 4.2-2.7 1.4-2.6 1.3-5.8 1.9-3.3.5-6.3 1.8-10.5 5.3-4.2 3.6-8.7 2.4-9.6-1.5-.8-3.4-.4-5.4-.4-5.4z"
    }),
    /* @__PURE__ */ jsx82("path", {
      d: "M472 212.2s1.2-2.7-1-4c0 0-6.9 1.2-9-.9 0 0 7.5-.4 12.2-2.3 4.6-1.7 3.3-3 1.7-3.4-1.6-.3-4.6.5-4.9 2 0 0-1-1.6.2-2.6a5 5 0 0 1 4.7-.8c1.7.4 3.1 1.2 8.6-1.6 0 0 3.1.7 3.3 2.8 0 2.2-.3 3-.6 3.3-.2.4-.6 1-1.3 1-.6-.2-1.5-.3-2.3 1.2a8.9 8.9 0 0 1-2.6 3.7s1.5-4.6-2.5-5.7c0 0-3.3 2-5.8 2.1 0 0 3.2 3-.8 5.2z"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#5a3719",
      d: "M479.3 203.8s-1.6-1.6.4-1.9c2-.1 4.6 1.4 4.2 2.7-.6 1.2-3 1.1-4.6-.8"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#fff",
      d: "M592.6 181.6s-3.7 1-.2 3.3c3.4 2.3 5 4.2 7.5 4.8 2.5.7 5 1.5 5 4s-.5 3.5-1.9 5.2c-1.3 1.7.8 2.4 2.6 1.5 1.8-1 3.3-1.5 4.5-2.2 1.1-.7 3-.6 1.4.3-1.9 1-3.7 1.5-1.4 1.5 2.3.1 16.2.4 19.1-.6 3-.9 6.8-1.2 7-5 0 0 .2-1.6 1.3-2.4 1-.7 1.8-2.3.2-1.2-1.5 1.1-2.7 1.7-3 1.3-.3-.3-.5-.6.7-1.1 1.2-.5 1.8 0 2.9-1.5 1-1.6 1-1.4.4-2-.6-.6-1.8-1-1.2-1.8.6-.8 1.2-3-1.4-1.7-2.5 1.3-7.6 4.8-10 5.3-2.2.5-4 1.2-7.1 1.8-3 .7-5 1.4-8.5 3.3-3.3 1.8-3-1.1-2.5-1.5 0 0 1.3 2.3 4.7-.7 3.4-2.9 2.3-.1 10.6-2.9 8.3-2.7 6.3-3.1 9.5-4.8 3.3-1.7 6.4-1.8 4-4-2.2-2.4-2.4-2.5-5.3 0a34.5 34.5 0 0 1-16 6.4s18.8-8 16.9-9.2a20.8 20.8 0 0 0-5.3-2.5c-1.3-.3-1.7-.6-4.7.8-3 1.3-3.5 1.6-4.3 1.7-1 0-3.5.6-7 2.4-3.6 1.9-5.5 2.6-8 4 0 0 1.7-3.3 9.1-5.5 7.4-2.2 11.1-4.2 10.4-4.6s-2.7-.8-4-.5c-1.5.3-1-.1-5.6 1.7-4.5 1.8-2.6 1.4-6.2 2.2-3.7.7-5.1 1.5-6.9 2.3 0 0 .8-1 3.1-1.9 1.3-.4-1.3-.9 2.2-1h1a32.2 32.2 0 0 0 8.6-3.3c-.7-.1-5.1-.6-9.5 1.6-4.5 2-2.5 1.3-4 1.5-1.6.4-5 2.4-6 3.4-1.1.9-2.7 1.5-2.7 1.5z"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#5a3719",
      d: "M482.7 201.8s1.8.5 2.2 1.8c.5 1.2 1.6-.6 1.6-1.1-.1-.6-1.2-3-3-1.9-2 1.1-1 1.1-.8 1.2"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#7b3c20",
      d: "M477.9 226s3.7-1.8 6.9-1.5c0 0-1.3-4.4.9-3.7 2.1.8 1.5.4 2 .4 0 0 .1-2.9-.5-4 0 0 2.3.5 4.6.5 0 0-2.2-4.1.2-7a6.9 6.9 0 0 0 4.2 3.4v-2.3s1.7-.3 3 .4c1.4.8 2.5-7.6-1.5-9.3 0 0-1 1.5-4.7 2.3s-3.7 1.5-5.2 4.3-3 2.9-6.2 5c-3 2-5 6-5 6.4 0 0 1.5 2 1.3 5.1"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#999",
      d: "M603.1 177.8c1.3-.2-1.4-.9 2-1h1a32.2 32.2 0 0 0 8.7-3.3c-.7-.1-5.1-.6-9.5 1.5s-2.5 1.4-4 1.7c-1.6.3-5 2.3-6 3.3-1.1.9-2.7 1.5-2.7 1.5s-3.7 1-.2 3.4c3.4 2.3 5 4.2 7.5 4.8 2.5.7 5 1.5 5 4a7 7 0 0 1-1.9 5.2c-1.3 1.7.8 2.4 2.6 1.5 1.8-1 3.3-1.5 4.5-2.2 1.1-.7 3-.6 1.3.3-1.8 1-3.6 1.5-1.3 1.5 2.3.1 16.2.4 19.1-.6 3-.9 6.8-1.2 7-5 0 0 .2-1.6 1.3-2.4 1-.7 1.8-2.3.2-1.2-1.5 1.1-2.8 1.7-3 1.3-.3-.3-.5-.6.7-1.1 1.2-.5 1.8 0 2.9-1.5 1-1.6 1-1.4.4-2l-1-.9s-.9-.7-1.9-.1a27.6 27.6 0 0 1-7 2.7c-1.6.1-3.5.9-6.5 2.4s-8.2 4.6-9 1.7l-2.8 1c-3.4 1.8-3-.7-2.5-1.4 0 0-1.8 2-1.7.2 0-1.8 1.2-1.5 3.3-2.1 2-.6 5-2 3.8-3-1.3-1-2.7 1-4.2 1.8-1.4.7-4.3 1.2-4.8-.9-.4-2.1-.4-3.6-4.3-3.8-4-.2-3.9-2.7-2.8-3.8 1.1-1 2-2.8 5.7-3.5z"
    }),
    /* @__PURE__ */ jsx82("path", {
      d: "M615.6 196.9s6.1-2.8 11.7-4.1c5.7-1.3 1.2.2.3.4-1 .3-9.7 3.2-11.8 4.2-2 1-1.7.2-.2-.4zm1.4 1.3s6.9-2.3 8.2-1.4c1.3 1 .2.6-1.3.8-1.6.1-5.7.8-6.8.8-1.1 0-.1-.2-.1-.2m11-2.5s1.4-.2 1.5.4c.1.4-.6.5-1.3.4-.7-.1-1.3-.5-.1-.8z"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#fff",
      d: "M446 255.9s-.3-6.2 2.8-9.2 17.8-18.5 20.1-22.8c0 0 2 1.3 2 3.8 0 0 2.5-4.3 4.5-6 0 0 1.7 1.8 1.5 5.4 0 0 3.5-1.9 9-1.9 0 0-2 2.4-2.1 3.9 0 0 7.6-1 11.7-.3 0 0-10.6 6-7.7 6.5 3.1.5 6.2 0 6.2 0s-3.4 3.3-8.8 4c0 0 6.9 0 8.2 1.5 0 0-6.6 1-12 5 0 0-.4-.2-.4-1.7 0 0-.3 1.4-1.8 2.7-1.5 1.2-5.1 4-6.5 5.3-1.4 1.3-3.8 4-6.6 4 0 0 .6-2.1-1.4-2.8a5.7 5.7 0 0 0-6 1.5s-7 .1-9.4.5c0 0 1.6-2.6 3-2.6 1.6 0 7.6 1 8.1-3.2.6-4-3.8-3-2.2-5.4 1.7-2.4 1.3-2.2 1.4-2.6 0 0-1.4.8-2.2 3a10.7 10.7 0 0 1-4.2 6 15 15 0 0 0-4.8 5s-1.3 0-2.4.4"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#fff",
      d: "M452.8 252.2s.3-.8 2.3-1.2c2.2-.3 2.3-1.3 2-1.8-.3-.4-1.5-.4.5-2.8 0 0 .8.3 1.2.8.6.6 2.9 5.5-6 5"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#999",
      d: "M447.9 247.9c0 4 5.3 2.5 5.3 2.5a21.4 21.4 0 0 0-3.8 3.6c.4-2-3-2.5-3-2.5a12.3 12.3 0 0 1 1.5-3.6m19.3-21.5 1.7-2.5s2 1.3 2 3.8c0 0 2.5-4.3 4.5-6 0 0 1.7 1.8 1.5 5.4 0 0 3.5-1.9 9-1.9 0 0-2 2.4-2.1 3.9 0 0 7.6-1 11.7-.3 0 0-10.6 6-7.7 6.5 3.1.5 6.2 0 6.2 0s-3.4 3.3-8.8 4c0 0 6.9 0 8.2 1.5 0 0-2 .3-4.6 1.2 0 0-1.9-1.8-7.6-1.5 0 0 4.4-2.6 8-3.4 0 0-1.6-2-4-.1 0 0-4.9-3.3-.8-6.2 0 0-2.8-.5-4.7.8 0 0 0-2.3 2.1-3.3 0 0-5.4-1-6.7 3 0 0-1-1.5-.5-3.4 0 0-3.3 1.9-4.8 4 0 0-.5-4-2.6-5.5M456.8 252c-.9.2-2.3.3-4 .2 0 0 .2-.5 1.3-1 0 0 .4.8 2.7.8"
    }),
    /* @__PURE__ */ jsx82("path", {
      d: "M466.6 236.7s2.5 2 3.3 3c0 0 2.3-1.4 3-2.7 0 0 1.9 1.1 2.4 2.8 0 0 1.3-.8 1.5-2 0 0 3 .6 4.2 1.6 0 0 .4-3 0-4.8 0 0 2.1.2 3.4.7 0 0-1.2-2 5-4.5 0 0-4.7 1.1-6.5 3 0 0-2 .2-2.9-.4v4.5s-1.2-.6-3.5-1.1c0 0-.6 1-1 1.2 0 0-1.5-1.2-2.1-2.7 0 0-2.3 2.1-3 3 0 0-2.3-1.6-3.8-1.6"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#ffc221",
      d: "M452.5 267.3s1 .4 3.3-1.4 8.7-5.9 9.2-9.2c.7-3.3-2-3.4-4-2.5-2.2 1-1.3 2.7-1.2 3.4 0 .6.2 2.9-3.3 6z"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#ffc221",
      d: "M451.9 268.3s-5.2-2.2-.6-4.5 6.7-2.9 7.2-4.9c.6-1.9.2-1.5-1.5-.7-1.7.7-8.2 3.8-9.2 1 0 0 2.7 1 6-.6 3.4-1.7 6.2-2.1 4-2.8a37 37 0 0 0-11 .5c-1.4.4-1 .3-1.3 1.6-.2 1.3-1.6 4-2.2 4.7-.5.8-1.8 4 .6 5.5a8.6 8.6 0 0 0 8 .2"
    }),
    /* @__PURE__ */ jsx82("path", {
      d: "M449.9 257s-1.3.2-1 .7c.2.5.5.4 1 .4.3 0 1-.2 1.1-.5 0-.3-.8-.7-1.1-.5z"
    }),
    /* @__PURE__ */ jsx82("path", {
      fill: "#fff",
      d: "M451.5 267.1s-2.4-1.1.4-2.6c2.7-1.5 5.6-3 6-3.6 0 0-1.3 1.9-6.4 6.2"
    })
  ]
});
var As_default = SvgAs;

// src/country-flag-icons/generated/At.tsx
init_esm_shims();
import { jsx as jsx83, jsxs as jsxs58 } from "react/jsx-runtime";
var SvgAt = (props) => /* @__PURE__ */ jsxs58("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx83("path", {
      fill: "#fff",
      d: "M0 160h640v160H0z"
    }),
    /* @__PURE__ */ jsx83("path", {
      fill: "#c8102e",
      d: "M0 0h640v160H0zm0 320h640v160H0z"
    })
  ]
});
var At_default = SvgAt;

// src/country-flag-icons/generated/Au.tsx
init_esm_shims();
import { jsx as jsx84, jsxs as jsxs59 } from "react/jsx-runtime";
var SvgAu = (props) => /* @__PURE__ */ jsxs59("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx84("path", {
      fill: "#00008B",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx84("path", {
      fill: "#fff",
      d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0z"
    }),
    /* @__PURE__ */ jsx84("path", {
      fill: "red",
      d: "M212 140.5 320 220v20l-135.5-99.5zm-92 10 3 17.5-96 72H0zM320 0v1.5l-124.5 94 1-22L295 0zM0 0l119.5 88h-30L0 21z"
    }),
    /* @__PURE__ */ jsx84("path", {
      fill: "#fff",
      d: "M120.5 0v240h80V0zM0 80v80h320V80z"
    }),
    /* @__PURE__ */ jsx84("path", {
      fill: "red",
      d: "M0 96.5v48h320v-48zM136.5 0v240h48V0z"
    }),
    /* @__PURE__ */ jsx84("path", {
      fill: "#fff",
      d: "m527 396.7-20.5 2.6 2.2 20.5-14.8-14.4-14.7 14.5 2-20.5-20.5-2.4 17.3-11.2-10.9-17.5 19.6 6.5 6.9-19.5 7.1 19.4 19.5-6.7-10.7 17.6zm-3.7-117.2 2.7-13-9.8-9 13.2-1.5 5.5-12.1 5.5 12.1 13.2 1.5-9.8 9 2.7 13-11.6-6.6zm-104.1-60-20.3 2.2 1.8 20.3-14.4-14.5-14.8 14.1 2.4-20.3-20.2-2.7 17.3-10.8-10.5-17.5 19.3 6.8L387 178l6.7 19.3 19.4-6.3-10.9 17.3 17.1 11.2ZM623 186.7l-20.9 2.7 2.3 20.9-15.1-14.7-15 14.8 2.1-21-20.9-2.4 17.7-11.5-11.1-17.9 20 6.7 7-19.8 7.2 19.8 19.9-6.9-11 18zm-96.1-83.5-20.7 2.3 1.9 20.8-14.7-14.8-15.1 14.4 2.4-20.7-20.7-2.8 17.7-11L467 73.5l19.7 6.9 7.3-19.5 6.8 19.7 19.8-6.5-11.1 17.6zM234 385.7l-45.8 5.4 4.6 45.9-32.8-32.4-33 32.2 4.9-45.9-45.8-5.8 38.9-24.8-24-39.4 43.6 15 15.8-43.4 15.5 43.5 43.7-14.7-24.3 39.2 38.8 25.1Z"
    })
  ]
});
var Au_default = SvgAu;

// src/country-flag-icons/generated/Aw.tsx
init_esm_shims();
import { jsx as jsx85, jsxs as jsxs60 } from "react/jsx-runtime";
var SvgAw = (props) => /* @__PURE__ */ jsxs60("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx85("defs", {
      children: /* @__PURE__ */ jsx85("clipPath", {
        id: "aw_svg__a",
        children: /* @__PURE__ */ jsx85("path", {
          fillOpacity: 0.7,
          d: "M0 0h288v216H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs60("g", {
      clipPath: "url(#aw_svg__a)",
      transform: "scale(2.2222)",
      children: [
        /* @__PURE__ */ jsx85("path", {
          fill: "#39c",
          d: "M0 0v216h324V0z"
        }),
        /* @__PURE__ */ jsx85("path", {
          fill: "#ff0",
          d: "M0 144v12h324v-12zm0 24v12h324v-12z"
        })
      ]
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cc",
      d: "m142.7 28 2.9 3zm-3 6 3 3zm5.9 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#ccf",
      d: "m139.7 37 3 2.9-3-3m5.9 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#6cc",
      d: "m136.7 42.8 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#c66",
      d: "m142.7 42.8 2.9 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#6cc",
      d: "m148.6 42.8 2.9 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#ccf",
      d: "m136.7 45.8 3 3zm11.9 0 2.9 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m139.7 48.7 3 3zm5.9 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#6cc",
      d: "m133.8 51.7 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#c00",
      stroke: "#fff",
      strokeWidth: 3.7,
      d: "m142.2 34-20.7 78.5L42.8 134l78.4 20.5 21 78.4 20.9-78.4 78.4-21-78.4-20.9-21-78.4z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#6cc",
      d: "m151.5 51.7 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cf",
      d: "m133.8 54.6 3 3zm17.7 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m136.7 57.6 3 3zm11.9 0 2.9 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#69c",
      d: "m130.8 60.5 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#c33",
      d: "m137.7 62.5 1 2zm11.8 0 1 2z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#69c",
      d: "m154.5 60.5 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cf",
      d: "m130.8 63.5 3 3zm23.7 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m133.8 66.4 3 3zm17.7 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#69c",
      d: "m127.9 69.4 3 3zm29.5 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cc",
      d: "m127.9 72.3 3 3zm29.5 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#cff",
      d: "m127.9 75.3 3 3zm29.5 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#69c",
      d: "m125 78.3 2.9 2.9z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m130.8 78.3 3 2.9zm23.7 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#69c",
      d: "m160.4 78.3 3 2.9z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cc",
      d: "m125 81.2 2.9 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#c33",
      d: "m131.8 83.2 1 2zm23.6 0 1 2z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cc",
      d: "m160.4 81.2 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#cff",
      d: "m125 84.2 2.9 3zm35.5 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m127.9 87.1 3 3zm29.5 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cc",
      d: "m122 90 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#c33",
      d: "m128.9 92 1 2zm29.5 0 1 2z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cc",
      d: "m163.3 90 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#ccf",
      d: "m122 93 3 3zm41.3 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m125 96 2.9 3zm35.5 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cc",
      d: "m119 99 3 2.9z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#c33",
      d: "m126 100.9.9 2zm35.4 0 1 2z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cc",
      d: "m166.3 99 3 2.9z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#ccf",
      d: "m119 101.9 3 3zm47.3 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m122 104.8 3 3zm41.3 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cc",
      d: "m116 107.8 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#c33",
      d: "m122 107.8 3 3zm41.3 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cc",
      d: "m169.2 107.8 3 3zm-62 3 3 2.9z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#ccf",
      d: "m110.2 110.7 3 3zm65 0 2.9 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cc",
      d: "m178 110.7 3 3zm-79.6 3 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#ccf",
      d: "m101.3 113.7 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m113.1 113.7 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#c33",
      d: "m116 113.7 3 3zm53.2 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m172.2 113.7 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#ccf",
      d: "m184 113.7 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cc",
      d: "m187 113.7 2.9 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#69c",
      d: "m86.6 116.6 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cc",
      d: "m89.5 116.6 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#cff",
      d: "m92.5 116.6 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m104.3 116.6 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#c33",
      d: "m109.2 117.6 2 1zm67.9 0 2 1z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m181 116.6 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#cff",
      d: "m192.8 116.6 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cc",
      d: "m195.8 116.6 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#69c",
      d: "m198.7 116.6 3 3zm-121 3 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cc",
      d: "m80.7 119.6 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#cff",
      d: "m83.6 119.6 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m95.4 119.6 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#c33",
      d: "m100.3 120.6 2 1zm85.6 0 2 1z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m189.9 119.6 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#cff",
      d: "m201.7 119.6 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cc",
      d: "m204.6 119.6 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#69c",
      d: "m207.6 119.6 3 3zm-138.8 3 3 2.9z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cf",
      d: "m71.8 122.5 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m86.6 122.5 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#c33",
      d: "m91.5 123.5 2 1zm103.3 0 2 1z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m198.7 122.5 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cf",
      d: "m213.5 122.5 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#69c",
      d: "m216.4 122.5 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#6cc",
      d: "m60 125.5 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cf",
      d: "m63 125.5 2.9 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m74.8 125.5 2.9 3zm135.8 0 2.9 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cf",
      d: "m222.3 125.5 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#6cc",
      d: "m225.3 125.5 3 3zm-174.2 3 3 2.9z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#ccf",
      d: "m54 128.4 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m65.9 128.4 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#c33",
      d: "m70.8 129.4 2 1zm144.7 0 2 1z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m219.4 128.4 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#ccf",
      d: "m231.2 128.4 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#6cc",
      d: "m234.2 128.4 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cc",
      d: "m42.3 131.4 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#ccf",
      d: "m45.2 131.4 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m57 131.4 3 3zm171.3 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#ccf",
      d: "m240 131.4 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cc",
      d: "m243 131.4 3 3zm-206.6 3 3 2.9z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#c66",
      d: "m51.1 134.3 3 3zm183 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cc",
      d: "m249 134.3 2.9 3zm-206.6 3 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#ccf",
      d: "m45.2 137.3 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m57 137.3 3 3zm171.3 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#ccf",
      d: "m240 137.3 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cc",
      d: "m243 137.3 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#6cc",
      d: "m51.1 140.3 3 2.9z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#ccf",
      d: "m54 140.3 3 2.9z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m65.9 140.3 3 2.9z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#c33",
      d: "m70.8 141.2 2 1zm144.7 0 2 1z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m219.4 140.3 3 2.9z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#ccf",
      d: "m231.2 140.3 3 2.9z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#6cc",
      d: "m234.2 140.3 3 2.9zm-174.2 3 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cf",
      d: "m63 143.2 2.9 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m74.8 143.2 2.9 3zm135.8 0 2.9 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cf",
      d: "m222.3 143.2 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#6cc",
      d: "m225.3 143.2 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#69c",
      d: "m68.8 146.2 3 2.9z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cf",
      d: "m71.8 146.2 3 2.9z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m86.6 146.2 3 2.9z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#c33",
      d: "m91.5 147.1 2 1zm103.3 0 2 1z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m198.7 146.2 3 2.9z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cf",
      d: "m213.5 146.2 3 2.9z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#69c",
      d: "m216.4 146.2 3 2.9zm-138.7 3 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cc",
      d: "m80.7 149.1 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#cff",
      d: "m83.6 149.1 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m95.4 149.1 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#c33",
      d: "m100.3 150 2 1zm85.6 0 2 1z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m189.9 149.1 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#cff",
      d: "m201.7 149.1 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cc",
      d: "m204.6 149.1 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#69c",
      d: "m207.6 149.1 3 3zm-121 3 2.9 2.9z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cc",
      d: "m89.5 152 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#cff",
      d: "m92.5 152 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m104.3 152 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#c33",
      d: "m109.2 153 2 1zm67.9 0 2 1z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m181 152 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#cff",
      d: "m192.8 152 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cc",
      d: "m195.8 152 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#69c",
      d: "m198.7 152 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cc",
      d: "m98.4 155 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#ccf",
      d: "m101.3 155 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m113.1 155 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#c33",
      d: "m116 155 3 3zm53.2 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m172.2 155 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#ccf",
      d: "m184 155 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cc",
      d: "m187 155 2.9 3zm-79.7 3 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#ccf",
      d: "m110.2 158 3 3zm65 0 2.9 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cc",
      d: "m178 158 3 3zm-62 3 3 2.9z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#c33",
      d: "m122 161 3 2.9zm41.3 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cc",
      d: "m169.2 161 3 2.9z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m122 163.9 3 3zm41.3 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#ccf",
      d: "m119 166.8 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#c33",
      d: "m126 168.8.9 2zm35.4 0 1 2z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#ccf",
      d: "m166.3 166.8 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cc",
      d: "m119 169.8 3 3zm47.3 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m125 172.7 2.9 3zm35.5 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#ccf",
      d: "m122 175.7 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#c33",
      d: "m128.9 177.6 1 2zm29.5 0 1 2z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#ccf",
      d: "m163.3 175.7 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cc",
      d: "m122 178.6 3 3zm41.3 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m127.9 181.6 3 3zm29.5 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#cff",
      d: "m125 184.5 2.9 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#c33",
      d: "m131.8 186.5 1 2zm23.6 0 1 2z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#cff",
      d: "m160.4 184.5 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cc",
      d: "m125 187.5 2.9 3zm35.5 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#69c",
      d: "m125 190.4 2.9 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m130.8 190.4 3 3zm23.7 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#69c",
      d: "m160.4 190.4 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#cff",
      d: "m127.9 193.4 3 3zm29.5 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cc",
      d: "m127.9 196.3 3 3zm29.5 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#69c",
      d: "m127.9 199.3 3 3zm29.5 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m133.8 202.2 3 3zm17.7 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cf",
      d: "m130.8 205.2 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#c33",
      d: "m137.7 207.2 1 2zm11.8 0 1 2z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cf",
      d: "m154.5 205.2 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#69c",
      d: "m130.8 208.2 3 2.9zm23.7 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m136.7 211.1 3 3zm11.9 0 2.9 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cf",
      d: "m133.8 214 3 3zm17.7 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#6cc",
      d: "m133.8 217 3 3zm17.7 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#fcc",
      d: "m139.7 220 3 3zm5.9 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#ccf",
      d: "m136.7 222.9 3 3zm11.9 0 2.9 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#6cc",
      d: "m136.7 225.9 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#c66",
      d: "m142.7 225.9 2.9 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#6cc",
      d: "m148.6 225.9 2.9 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#ccf",
      d: "m139.7 231.8 3 3zm5.9 0 3 3z"
    }),
    /* @__PURE__ */ jsx85("path", {
      fill: "#9cc",
      d: "m139.7 234.7 3 3zm5.9 0 3 3zm-3 6 3 2.9z"
    })
  ]
});
var Aw_default = SvgAw;

// src/country-flag-icons/generated/Ax.tsx
init_esm_shims();
import { jsx as jsx86, jsxs as jsxs61 } from "react/jsx-runtime";
var SvgAx = (props) => /* @__PURE__ */ jsxs61("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx86("defs", {
      children: /* @__PURE__ */ jsx86("clipPath", {
        id: "ax_svg__a",
        children: /* @__PURE__ */ jsx86("path", {
          fillOpacity: 0.7,
          d: "M106.3 0h1133.3v850H106.3z"
        })
      })
    }),
    /* @__PURE__ */ jsxs61("g", {
      clipPath: "url(#ax_svg__a)",
      transform: "matrix(.56472 0 0 .56482 -60 -.1)",
      children: [
        /* @__PURE__ */ jsx86("path", {
          fill: "#0053a5",
          d: "M0 0h1300v850H0z"
        }),
        /* @__PURE__ */ jsxs61("g", {
          fill: "#ffce00",
          children: [
            /* @__PURE__ */ jsx86("path", {
              d: "M400 0h250v850H400z"
            }),
            /* @__PURE__ */ jsx86("path", {
              d: "M0 300h1300v250H0z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs61("g", {
          fill: "#d21034",
          children: [
            /* @__PURE__ */ jsx86("path", {
              d: "M475 0h100v850H475z"
            }),
            /* @__PURE__ */ jsx86("path", {
              d: "M0 375h1300v100H0z"
            })
          ]
        })
      ]
    })
  ]
});
var Ax_default = SvgAx;

// src/country-flag-icons/generated/Az.tsx
init_esm_shims();
import { jsx as jsx87, jsxs as jsxs62 } from "react/jsx-runtime";
var SvgAz = (props) => /* @__PURE__ */ jsxs62("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx87("path", {
      fill: "#3f9c35",
      d: "M.1 0h640v480H.1z"
    }),
    /* @__PURE__ */ jsx87("path", {
      fill: "#ed2939",
      d: "M.1 0h640v320H.1z"
    }),
    /* @__PURE__ */ jsx87("path", {
      fill: "#00b9e4",
      d: "M.1 0h640v160H.1z"
    }),
    /* @__PURE__ */ jsx87("circle", {
      cx: 304,
      cy: 240,
      r: 72,
      fill: "#fff"
    }),
    /* @__PURE__ */ jsx87("circle", {
      cx: 320,
      cy: 240,
      r: 60,
      fill: "#ed2939"
    }),
    /* @__PURE__ */ jsx87("path", {
      fill: "#fff",
      d: "m384 200 7.7 21.5 20.6-9.8-9.8 20.7L424 240l-21.5 7.7 9.8 20.6-20.6-9.8L384 280l-7.7-21.5-20.6 9.8 9.8-20.6L344 240l21.5-7.7-9.8-20.6 20.6 9.8z"
    })
  ]
});
var Az_default = SvgAz;

// src/country-flag-icons/generated/Ba.tsx
init_esm_shims();
import { jsx as jsx88, jsxs as jsxs63 } from "react/jsx-runtime";
var SvgBa = (props) => /* @__PURE__ */ jsxs63("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx88("defs", {
      children: /* @__PURE__ */ jsx88("clipPath", {
        id: "ba_svg__a",
        children: /* @__PURE__ */ jsx88("path", {
          fillOpacity: 0.7,
          d: "M-85.3 0h682.6v512H-85.3z"
        })
      })
    }),
    /* @__PURE__ */ jsxs63("g", {
      fillRule: "evenodd",
      clipPath: "url(#ba_svg__a)",
      transform: "translate(80) scale(.9375)",
      children: [
        /* @__PURE__ */ jsx88("path", {
          fill: "#009",
          d: "M-85.3 0h682.6v512H-85.3z"
        }),
        /* @__PURE__ */ jsx88("path", {
          fill: "#FC0",
          d: "m56.5 0 511 512.3V.3z"
        }),
        /* @__PURE__ */ jsx88("path", {
          fill: "#FFF",
          d: "M439.9 481.5 412 461.2l-28.6 20.2 10.8-33.2-28.2-20.5h35l10.8-33.2 10.7 33.3h35l-28 20.7zm81.3 10.4-35-.1-10.7-33.3-10.8 33.2h-35l28.2 20.5-10.8 33.2 28.6-20.2 28 20.3-10.5-33zM365.6 384.7l28-20.7-35-.1-10.7-33.2-10.8 33.2-35-.1 28.2 20.5-10.8 33.3 28.6-20.3 28 20.4zm-64.3-64.5 28-20.6-35-.1-10.7-33.3-10.9 33.2h-34.9l28.2 20.5-10.8 33.2 28.6-20.2 27.9 20.3zm-63.7-63.6 28-20.7h-35L220 202.5l-10.8 33.2h-35l28.2 20.4-10.8 33.3 28.6-20.3 28 20.4-10.5-33zm-64.4-64.3 28-20.6-35-.1-10.7-33.3-10.9 33.2h-34.9L138 192l-10.8 33.2 28.6-20.2 27.9 20.3-10.4-33zm-63.6-63.9 27.9-20.7h-35L91.9 74.3 81 107.6H46L74.4 128l-10.9 33.2L92.1 141l27.8 20.4zm-64-64 27.9-20.7h-35L27.9 10.3 17 43.6h-35L10.4 64l-11 33.3L28.1 77l27.8 20.4zm-64-64L9.4-20.3h-35l-10.7-33.3L-47-20.4h-35L-53.7 0l-10.8 33.2L-35.9 13l27.8 20.4z"
        })
      ]
    })
  ]
});
var Ba_default = SvgBa;

// src/country-flag-icons/generated/Bb.tsx
init_esm_shims();
import { jsx as jsx89, jsxs as jsxs64 } from "react/jsx-runtime";
var SvgBb = (props) => /* @__PURE__ */ jsxs64("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx89("path", {
      fill: "#00267f",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx89("path", {
      fill: "#ffc726",
      d: "M213.3 0h213.4v480H213.3z"
    }),
    /* @__PURE__ */ jsx89("path", {
      id: "bb_svg__a",
      fill: "#000001",
      d: "M319.8 135.5c-7 19-14 38.6-29.2 53.7 4.7-1.6 13-3 18.2-2.8v79.5l-22.4 3.3c-.8 0-1-1.3-1-3-2.2-24.7-8-45.5-14.8-67-.5-2.9-9-14-2.4-12 .8 0 9.5 3.6 8.2 1.9a85 85 0 0 0-46.4-24c-1.5-.3-2.4.5-1 2.2 22.4 34.6 41.3 75.5 41.1 124 8.8 0 30-5.2 38.7-5.2v56.1H320l2.5-156.7z"
    }),
    /* @__PURE__ */ jsx89("use", {
      xlinkHref: "#bb_svg__a",
      width: "100%",
      height: "100%",
      transform: "matrix(-1 0 0 1 639.5 0)"
    })
  ]
});
var Bb_default = SvgBb;

// src/country-flag-icons/generated/Bd.tsx
init_esm_shims();
import { jsx as jsx90, jsxs as jsxs65 } from "react/jsx-runtime";
var SvgBd = (props) => /* @__PURE__ */ jsxs65("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx90("path", {
      fill: "#006a4e",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx90("circle", {
      cx: 280,
      cy: 240,
      r: 160,
      fill: "#f42a41"
    })
  ]
});
var Bd_default = SvgBd;

// src/country-flag-icons/generated/Be.tsx
init_esm_shims();
import { jsx as jsx91, jsxs as jsxs66 } from "react/jsx-runtime";
var SvgBe = (props) => /* @__PURE__ */ jsx91("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs66("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    children: [
      /* @__PURE__ */ jsx91("path", {
        fill: "#000001",
        d: "M0 0h213.3v480H0z"
      }),
      /* @__PURE__ */ jsx91("path", {
        fill: "#ffd90c",
        d: "M213.3 0h213.4v480H213.3z"
      }),
      /* @__PURE__ */ jsx91("path", {
        fill: "#f31830",
        d: "M426.7 0H640v480H426.7z"
      })
    ]
  })
});
var Be_default = SvgBe;

// src/country-flag-icons/generated/Bf.tsx
init_esm_shims();
import { jsx as jsx92, jsxs as jsxs67 } from "react/jsx-runtime";
var SvgBf = (props) => /* @__PURE__ */ jsx92("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs67("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx92("path", {
        fill: "#de0000",
        d: "M640 479.6H.4V0H640z"
      }),
      /* @__PURE__ */ jsx92("path", {
        fill: "#35a100",
        d: "M639.6 480H0V240.2h639.6z"
      }),
      /* @__PURE__ */ jsx92("path", {
        fill: "#fff300",
        d: "m254.6 276.2-106-72.4h131L320 86.6 360.4 204l131-.1-106 72.4 40.5 117.3-106-72.6L214 393.4"
      })
    ]
  })
});
var Bf_default = SvgBf;

// src/country-flag-icons/generated/Bg.tsx
init_esm_shims();
import { jsx as jsx93, jsxs as jsxs68 } from "react/jsx-runtime";
var SvgBg = (props) => /* @__PURE__ */ jsxs68("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx93("path", {
      fill: "#fff",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsx93("path", {
      fill: "#00966e",
      d: "M0 160h640v160H0z"
    }),
    /* @__PURE__ */ jsx93("path", {
      fill: "#d62612",
      d: "M0 320h640v160H0z"
    })
  ]
});
var Bg_default = SvgBg;

// src/country-flag-icons/generated/Bh.tsx
init_esm_shims();
import { jsx as jsx94, jsxs as jsxs69 } from "react/jsx-runtime";
var SvgBh = (props) => /* @__PURE__ */ jsxs69("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx94("path", {
      fill: "#fff",
      d: "M0 0h640v480H0"
    }),
    /* @__PURE__ */ jsx94("path", {
      fill: "#ce1126",
      d: "M640 0H96l110.7 48L96 96l110.7 48L96 192l110.7 48L96 288l110.7 48L96 384l110.7 48L96 480h544"
    })
  ]
});
var Bh_default = SvgBh;

// src/country-flag-icons/generated/Bi.tsx
init_esm_shims();
import { jsx as jsx95, jsxs as jsxs70 } from "react/jsx-runtime";
var SvgBi = (props) => /* @__PURE__ */ jsxs70("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx95("defs", {
      children: /* @__PURE__ */ jsx95("clipPath", {
        id: "bi_svg__a",
        children: /* @__PURE__ */ jsx95("path", {
          fillOpacity: 0.7,
          d: "M-90.5 0H592v512H-90.5z"
        })
      })
    }),
    /* @__PURE__ */ jsxs70("g", {
      fillRule: "evenodd",
      clipPath: "url(#bi_svg__a)",
      transform: "translate(84.9) scale(.9375)",
      children: [
        /* @__PURE__ */ jsx95("path", {
          fill: "#18b637",
          d: "m-178 0 428.8 256L-178 512zm857.6 0L250.8 256l428.8 256z"
        }),
        /* @__PURE__ */ jsx95("path", {
          fill: "#cf0921",
          d: "m-178 0 428.8 256L679.6 0zm0 512 428.8-256 428.8 256z"
        }),
        /* @__PURE__ */ jsx95("path", {
          fill: "#fff",
          d: "M679.6 0h-79.9L-178 464.3V512h79.9L679.6 47.7z"
        }),
        /* @__PURE__ */ jsx95("path", {
          fill: "#fff",
          d: "M398.9 256a148 148 0 1 1-296.1 0 148 148 0 0 1 296 0z"
        }),
        /* @__PURE__ */ jsx95("path", {
          fill: "#fff",
          d: "M-178 0v47.7L599.7 512h79.9v-47.7L-98.1 0z"
        }),
        /* @__PURE__ */ jsx95("path", {
          fill: "#cf0921",
          stroke: "#18b637",
          strokeWidth: 3.9,
          d: "m280 200.2-19.3.3-10 16.4-9.9-16.4-19.2-.4 9.3-16.9-9.2-16.8 19.2-.4 10-16.4 9.9 16.5 19.2.4-9.3 16.8zm-64.6 111.6-19.2.3-10 16.4-9.9-16.4-19.2-.4 9.3-16.9-9.2-16.8 19.2-.4 10-16.4 9.9 16.5 19.2.4-9.3 16.8zm130.6 0-19.2.3-10 16.4-10-16.4-19.1-.4 9.3-16.9-9.3-16.8 19.2-.4 10-16.4 10 16.5 19.2.4-9.4 16.8z"
        })
      ]
    })
  ]
});
var Bi_default = SvgBi;

// src/country-flag-icons/generated/Bj.tsx
init_esm_shims();
import { jsx as jsx96, jsxs as jsxs71 } from "react/jsx-runtime";
var SvgBj = (props) => /* @__PURE__ */ jsxs71("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx96("defs", {
      children: /* @__PURE__ */ jsx96("clipPath", {
        id: "bj_svg__a",
        children: /* @__PURE__ */ jsx96("path", {
          fill: "gray",
          d: "M67.6-154h666v666h-666z"
        })
      })
    }),
    /* @__PURE__ */ jsx96("g", {
      clipPath: "url(#bj_svg__a)",
      transform: "matrix(.961 0 0 .7207 -65 111)",
      children: /* @__PURE__ */ jsxs71("g", {
        fillRule: "evenodd",
        strokeWidth: "1pt",
        children: [
          /* @__PURE__ */ jsx96("path", {
            fill: "#319400",
            d: "M0-154h333v666H0z"
          }),
          /* @__PURE__ */ jsx96("path", {
            fill: "#ffd600",
            d: "M333-154h666v333H333z"
          }),
          /* @__PURE__ */ jsx96("path", {
            fill: "#de2110",
            d: "M333 179h666v333H333z"
          })
        ]
      })
    })
  ]
});
var Bj_default = SvgBj;

// src/country-flag-icons/generated/Bl.tsx
init_esm_shims();
import { jsx as jsx97, jsxs as jsxs72 } from "react/jsx-runtime";
var SvgBl = (props) => /* @__PURE__ */ jsxs72("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx97("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx97("path", {
      fill: "#000091",
      d: "M0 0h213.3v480H0z"
    }),
    /* @__PURE__ */ jsx97("path", {
      fill: "#e1000f",
      d: "M426.7 0H640v480H426.7z"
    })
  ]
});
var Bl_default = SvgBl;

// src/country-flag-icons/generated/Bm.tsx
init_esm_shims();
import { jsx as jsx98, jsxs as jsxs73 } from "react/jsx-runtime";
var SvgBm = (props) => /* @__PURE__ */ jsxs73("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx98("path", {
      fill: "#cf142b",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#fff",
      d: "M559.7 130.6v161.6c0 43.1-86.2 57.2-86.2 57.2s-86.4-14-86.4-57.4V130.6h172.5z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#2f8f22",
      d: "M559.7 292.2c0 43.1-86.2 57.2-86.2 57.2s-86.4-14-86.4-57.4c0 0 0-3.5 1.8-5.4 0 0-1 7.1 4.5 12.6 0 0-4.3-7.8 0-15.3 0 0-1.7 9.8 4.4 15.3 0 0-3.3-7.9.4-16.7 0 0-1.8 14.3 4.7 17.3 0 0 1.8-8.4-.8-13.6 0 0 4.5 1.8 4.3 13.8 0 0 1.4-1.8 1.8-10.5 0 0 .2 10 3.5 12.3 0 0 1.2-1-.3-5.5-1.6-4.4.6-6 1-6 0 0-.8 5 3.4 8.8 0 0-1.8-7.9.7-9 0 0-.6 6.7 4.8 8.1 0 0 .3-1.9-.8-4 0 0-1-2.5-.3-4.5 0 0 1.7 6 4 7 0 0-1.4-3.6 0-7 0 0 .2 5 4.7 7.1 0 0-3-4-1.9-8.2l28.7 1.4 15 .7 44.7-3 7.6-6.7s3.1 4.1-1.8 10.8c0 0 4.8-.8 6.3-8.3 0 0 2 4.1-.7 8.8 0 0 5.3-5.4 6-11.3 0 0 2.1 5.8-2.9 12 0 0 4.4-1.6 6.3-8.1 0 0 1.6 4-2.7 9.5 0 0 8.1-4.1 7.9-13 0 0 3.3 4.8-.5 11.6 0 0 4-3.7 4.5-9.3 0 0 2.3 2.5-.2 9.4 0 0 5-4.8 5.8-9.9 0 0 1 4.8-3.2 10.8 0 0 2.9-.8 5.7-6.6 0 0 .7 2.4-1.8 6.6 0 0 2.8-.5 4.6-5.9 0 0 .3 3.2-.5 6 0 0 2.1-1.3 2.6-7.3a9 9 0 0 0 1.2 4.4v.8z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#d40000",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 1.2,
      d: "M515.4 198.7s-3 .6-7-.6c-3.8-1.2-5.3-.7-6.5 0 0 0 1.5-3.1-2.3-5.6 0 0 1.2 3.2-.5 4.6 0 0-.7.7-1.6-.3 0 0-1.3-1.5-2.8-2.4 0 0 3.3-1.2 2.7-4.5-.6-3.3-2.4-3.6-3.3-4.1a6 6 0 0 0 0 2.4s-3.5-2 1.2-4.7c4.8-2.7 4-4.4 3.1-5.8a13.1 13.1 0 0 0-3.5-3.6s1 1.6.7 2.9c-.1 1.2-2.4 2-2-.1.5-2.4 0-2 0-4.3 0 0 4.2 1.4 6-2.8 0 0 1.6-4.3-3.8-6.4 0 0 1.3 1.8.7 3 0 0-1.2 2.2-2.5.6-1.3-1.7-2.2-2.2-2.1-4.2 0 0 4.9.7 3.6-4.7 0 0-.9 3.6-7.2-1.2 0 0 4.2-4.2 2.5-7.6 0 0-.5-1.5-4.9-.7 0 0 3.8-2.4 2.3-4.5 0 0-.9-1.3-4.6.4 0 0 1.5-2.3-2.1-5 0 0-2.4 1.2-3.6 2.4 0 0-2.4-3-4-4.3 0 0-2.8 1.1-3.5 4.3 0 0-1.3-1.5-4.3-2.4 0 0-1.4 2.8.5 5 0 0-1.4 0-4-1.1 0 0-2.8-1.2-2.3 1.1.3 2.4.6 3 1.2 4.2 0 0-6.5-1.5-6.2 2a8.8 8.8 0 0 0 3 6.2s-3.5 4.8-6.6 1.2c0 0-1.2 1.2 1.2 4.2 0 0 2.4 2.5.3 4.2 0 0-2.5 2-3.7-2 0 0-4.1 4.1.8 7.2 0 0 3 1.8 6.3-1 0 0-1 8-4 6.4 0 0-1.9-1.2 1.4-2.9 0 0-4.8-.6-5.5 4 0 0-.6 3.5 3.5 5 0 0 3.1 1.2 0 3.6 0 0-2.5 1.7-.9 4.4 0 0 1.8 2.8-2.9 3.2 0 0-2.4 0-3.3-.4 0 0-1 2-.4 4 0 0-2.3-1.7-7.5.2-5.2 2-4.9.6-5.2 1.2l-1.6 2.4s2.8 3.6 2.9 3.3l-.6 4 1.4.6 10.8-4.8 11-5.7 8.9.4 5.6 1.3 7.2.6 5.4-2.8h7.6l8.4 4.2 9.5 5.7 5 1 3.9-.3v-7.8z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#d40000",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 1.2,
      d: "M428.2 207.7s4.2 2.2 6-.3c0 0 2.2-4.4-2.8-6 0 0 2.8-3.2-.2-6.2 0 0-1.6-1.6-4.2-.5 0 0-1.2-2.3-3.7-2.2 0 0-2.4 0-3 2.5 0 0-3.2-1.2-4.9.6 0 0-3 3.2 1.1 5.8l2.9.3 2.8-1.4 3.3.9s-.9 3.2 2.7 6.5z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#64b4d1",
      stroke: "#000",
      strokeWidth: 1.2,
      d: "M521.6 200.1a6.7 6.7 0 0 1 6.9 3.8c2.6 6.2-3 9.6-3 9.6.4 1.3.5 3.2.5 3.2 7.8 1 6.4 9.8 6.4 9.8l-2.6-2.2c-4.5-1.8-9.3 2.2-12.6 8.6-3.4 6.6-1.8 9.5-1.2 17.3.6 7.7 13 12.4 13 12.4l-9.7 25c-3.8 10-12 5.9-14.3 3.7-2.3-2-2.9-.8-4 0-1.1 1 5.3 6-6.5 10.8-11.7 4.7-13.7 8.3-15.7 9.5-2 1.2-10 .5-10.8-.6-1-1-.4-1-3.5-2.9-3-1.7-8.2-3.5-13.8-6.2-5.6-2.7-5.4-6.2-5.3-6.9 0-.7 1.9-6.5-4.7-1.9-6.5 4.7-12.1-2.2-12.1-2.2-1.2-1.7-6.8-16.4-6.8-16.4a92.4 92.4 0 0 0-4.3-12s-.4.8 4.5-2c4.8-2.7 7-7.3 8.7-11.9 1.7-4.6 0-12.5-.6-14-.6-1.6-4.2-8.9-8.7-10.4-4.4-1.6-7.5 2.4-7.5 2.4s-1.3-9 6.6-10c0 0 0-1.8.4-3.1 0 0-5.6-3.4-3-9.6 0 0 1.8-4.3 6.8-3.8l-1.1 2.4s-1.2 12.6 17.2 4.2c18.5-8.6 18-10.2 28.7-4.8l7.6-.1s11-5.3 14.7-3c3.5 2.3 16.3 9.4 16.3 9.4s12.4 4.7 14.9-4z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#fff",
      stroke: "#00247d",
      strokeMiterlimit: 10,
      strokeWidth: 1.2,
      d: "M465.8 255s-.6-3.9-1.2-6.4c0 0-1.5-3.9 1-6.8l2.8-3.3s1.8-2.4 4-2.7c0 0 2.3 0 2.4-.5.3-.5 2.8-4.5 8.6 0 0 0 1.8-3 4.8-3.6 0 0 3-.8 4.5 1.4 0 0 3.5-2.6 6.4 1.7 0 0 4.1-2.4 7.2 2.3 0 0 4-2 6.4 2.1 2.5 4.3 2 6 2 6l2 6.8 6.5 8-15.2 5.8h-7l-13.7 3.6-24.3 1.9-6.7-8 9.6-8.3z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#d40000",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 1.2,
      d: "M445.3 295.5s-3.6.1-5.5 1.2c-1.8.8-3.3 1.8-5.4 3.2 0 0-1 1.3-5.2.5 0 0-7.2-1.7-7.2 4 0 0-8.8.6-5.2 8.3 0 0 2.3 6 7.3 1.8 0 0-3.2 4.5 3 6.3 0 0 4.4 1.2 5.8-3.5 0 0 .7-1.8-1-4 0 0 2.1-.4 3.6-2.7 0 0-4.6 5.8.5 8 0 0 6.3 1.5 6.6-5 0 0-.6-3.2 2-4.3 0 0 5-1.2 7-6.6 0 0-7-3.9-6.3-7.2zM430.6 238s-5.6-2.5-8.4 0c0 0-3.5-2.2-7.5 0 0 0-3.7 2.4-6.3 5.2 0 0-1.8 1.5-1.2 6.4 0 0 1 3.5.5 5.1 0 0-1.2-.2-3.7 2.8 0 0-3.1 3.5-6 .3 0 0 1 4.6 6.1 3.8 0 0-2.5 2-.3 7 0 0 1.6 3.6-1 8.2 0 0 4.5-1.8 4.4-7.2 0 0-.5-3.6 1-6 0 0-1.5 2.2 1.6 7.1 0 0 2.4 3.6.5 7.2 0 0 4.4-1.6 4-7-.4-5.4-3-3.2-1.4-8.2 0 0 .5 2.6 1.8 4a7.2 7.2 0 0 1 2.4 7s2.6-3.4 2-6.8a13.1 13.1 0 0 0-1.3-4.4l8.4-4.8 4.3-7.5z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 1.2,
      d: "M417.8 259.5s-3.5-.2-4-3m-6.1-1.8s1.2 0 2.4 1.2c0 0 .7 1.2 1.9 1"
    }),
    /* @__PURE__ */ jsx98("path", {
      d: "M423 249.2s-1.8 0-3-.8c0 0-.9-.7-1.5.4 0 0-1 1.6.8 2.3 0 0 2.2 1.2-1.2 3.4 0 0 4-1.6 2.4-3.6 0 0-1.8-1.2-1.2-1.7 0 0 .2-.4 1 0 .6.6 2 .4 2.7 0"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#784421",
      stroke: "#000",
      strokeWidth: 1.2,
      d: "m477.6 259 2.1-.6-14-48h-.4z"
    }),
    /* @__PURE__ */ jsx98("path", {
      d: "M431.2 312.3s-3.2-1.9-6 .3c0 0 .4-1.2 2.4-1.7 0 0 1.2-3.2 4.3-2.9 0 0-1.3 1.6-3 2.8 0 0 1.8.2 2.4 1.5z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#64b4d1",
      stroke: "#00247d",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M419.7 319.8s-5.2-3.2-2.3-8.7c0 0 .8-1.5 2.3-1.2 0 0 3.3 1 .8 5.5 0 0-1.4 2.9-.8 4.5zm10.5 5.3s-7.4-3.4-5.1-9.2c0 0 .7-2 2.4-1.8 0 0 2.8.2 2.3 4 0 0-.9 3.6.4 7z"
    }),
    /* @__PURE__ */ jsx98("path", {
      d: "M428.7 303.6s-2.3 1.7-3.1 2.8c0 0-1-1.2-2.2-1.8 0 0 1.5-.3 2.2.3 0 0 1.2-1 3-1.3z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#64b4d1",
      stroke: "#00247d",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M435.2 323.6s6-1.4 4.8-7.5c0 0-.6-2.6-3-2.2 0 0-3 .8-1 4.6 0 0 1.1 2.6-.8 5.1z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#f5ce00",
      stroke: "#000",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "m461.6 196.7 5.7 1.9s5.4 2.3 12.3 0l5.2-2-3.5 5.4v2.9l2.1 3.2s-1.3.6-5.4-2c0 0-4.4-3.4-9.6 0 0 0-3 2-5.4 2l3.5-3.8-1.3-3.5-3.6-4.3z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#fff",
      d: "M437.5 316.5s.2-.4 0-.5l-.5.2s-.6 1 0 2.4c0 0 .5.9.3 1.8v.4s.3-.1.3-.4c0 0 .4-.8-.2-1.8 0 0-.6-1.4.1-2.1"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#d40000",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 1.2,
      d: "M518 207.7s-4.2 2.2-6-.3c0 0-2.1-4.4 2.9-6 0 0-2.8-3.2.1-6.2 0 0 1.6-1.6 4.2-.5 0 0 1.2-2.3 3.7-2.2 0 0 2.4 0 3 2.5 0 0 3.3-1.2 5 .6 0 0 2.8 3.2-1.2 5.8l-2.9.3-2.9-1.4-3 .9s.8 3.2-3 6.5z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#f5ce00",
      stroke: "#000",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M484.8 204.4s0 .8-.8 1c0 0-1 .3-1.5-.9v-.3c0-.5-.3-2 1.4-3.3 0 0 2.6-2.1 7.6.5a192 192 0 0 0 14.8 7.5s3.1 1.6 7.9 1.8c0 0 6.5.5 9.3-4.1 0 0 2.1-3.5 0-5.8 0 0-.9-1-2.3-.8a3 3 0 0 0-1.8 1.2s-1 1.4.1 2.5c0 0 1.6 1 2.2-1 0 .2.5 1.7-.4 2.9 0 0-4 6-14.9-.1l-14.3-8.1s-7.1-3.7-11.6 2.1c0 0-3.4 4.8 1.1 7.9 0 0 3.4 2 5.4-1.2 0 0 1.8-3.1-1-4.4 0 0-2.4-1.2-3.3 1.2-1 2.4 1.8 3 2 1.3 0 0 0-.4.3 0z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#e4cb5e",
      stroke: "#000",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M428 229.2v-9c0-.8 0-1.2 1.2-2.2 1-.8 2.1-2.3 3.7 1.7 0 0 3.2-3.5 4.2-4 0 0 2-1.5 3.3.7 0 0 1.6-2.6 3-3.2 0 0 3.2-2 3.3 4.2l2.5-2.4s2-1.5 4.2.7c0 0 3.5 3.6 4 4.6 0 0 .8 1 1 2.7 0 0 0 2 1 3 0 0 1.1 1 2.2 1.2 0 0 2.5.1 3.6 2.6 0 0 .3-.5 1.6 11.2v21.5l-14.4 17.1-23.1-6.6-9.2-3.9-2.2-6.6 9-5.9 4.8-13-1.5-9.3-2.2-5.2z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#784421",
      stroke: "#000",
      strokeWidth: 1.2,
      d: "m491.6 240.4 1.2-1.5 2.5-2s4 10.4 4.2 12.7v3.2s6 1.6 7.2 10.7l-5 9.2-7.8-4.4-2.3-1.5z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#fff",
      d: "M418.3 312.4s.2-.3 0-.6l-.5.4s-1.5 1.7-.2 4.4c0 0 0 .4.3.2 0 0 .3 0 0-.3 0 0-1.1-2.4.4-4z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 1.2,
      d: "M441.7 310.6s.1-.8-.4-1.6c0 0-.3-.6-.2-1.5m5.6-90.1s0 2.3.7 4c.6 1.6 2.9 4.5 3 5.9"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#d40000",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 1.2,
      d: "M501 295.5s3.6.1 5.5 1.2c2 .8 3.4 1.8 5.5 3.2 0 0 1 1.3 5.2.5 0 0 7.2-1.7 7.2 4 0 0 8.7.6 5.2 8.3 0 0-2.4 6-7.4 1.8 0 0 3.2 4.5-3 6.3 0 0-4.4 1.2-5.7-3.5 0 0-.8-1.8 1-4 0 0-2.1-.4-3.5-2.7 0 0 4.5 5.8-.5 8 0 0-6.3 1.5-6.7-5 0 0 .5-3.2-2-4.3 0 0-5-1.2-7.2-6.6 0 0 7.2-3.9 6.5-7.2z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 1.2,
      d: "m443.8 227.4 6 47.8m-4.5-47.9 6.6 44.6m-5.5-44.8 7.8 44.2"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#784421",
      stroke: "#000",
      strokeWidth: 1.2,
      d: "m458.6 267.5 2.2-.7-14-48h-.5z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 1.2,
      d: "m450.7 225.3 14.1 35.5m-15-35 13.6 37"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#fff",
      d: "M427.6 321.6s-1.7-1.5-1.4-4.3c0 0 0-.6-.3-.7 0 0-.3-.1-.3.6 0 0-.5 2.9 1.5 4.5 0 0 .1.3.4.2 0 0 .2 0 0-.3z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 1.2,
      d: "m451.5 224.8 14.3 32.4m-18.3-30.4 9 43.7"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#f5ce00",
      stroke: "#000",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M520 259c-6.3-3.6-7.7-11.4-7.7-11.4a24.6 24.6 0 0 1 1.6-14.3c4-8.6 11.1-10.3 11.1-10.3s-6.9 4.8-8.8 11.2c0 0-1.4 5.5-.6 10.7.8 5.5.5 4.1 1.8 8.3l2.6 6z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#784421",
      stroke: "#000",
      strokeWidth: 1.2,
      d: "m492.7 238.7-26.6 8.5-1.4 12c-6.3 9.1-19.2 10.7-19.2 10.7l10 10.7 19 4 10.2-7.8 9.2-8.4c-1-4.5-.5-11.2-.5-11.2 0-1.2.5-3.8.5-3.8s-1.5-10.7-1.2-14.5z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 1.2,
      d: "M465 256.2s17.6-5.5 28-10m-36.4 20s22-4 37.3-12.8l5.6-3.8"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 1.2,
      d: "m499.5 252.8-6 4.4s-24.5 11.2-43.2 11.6m43.1-3.6S474.6 275 464 275"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#d40000",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 1.2,
      d: "M515.8 238s5.6-2.5 8.4 0c0 0 3.6-2.2 7.6 0 0 0 3.6 2.4 6.2 5.2 0 0 1.8 1.5 1.2 6.4 0 0-1 3.5-.3 5.1 0 0 1.1-.2 3.5 2.8 0 0 3.3 3.5 6 .3 0 0-.8 4.6-6 3.8 0 0 2.4 2 .3 7 0 0-1.6 3.6 1 8.2 0 0-4.6-1.8-4.4-7.2 0 0 .4-3.6-1-6 0 0 1.4 2.2-1.7 7.1 0 0-2.4 3.6-.4 7.2 0 0-4.5-1.6-4-7 .3-5.4 3-3.2 1.3-8.2 0 0-.4 2.6-1.7 4a7.2 7.2 0 0 0-2.4 7s-2.6-3.4-2-6.8c.6-3.5 1.2-4.4 1.2-4.4l-8.3-4.8-4.2-7.5z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#fff",
      stroke: "#00247d",
      strokeMiterlimit: 10,
      strokeWidth: 1.2,
      d: "M420.6 268.4s.8-3.7 4.3-2.4c0 0 1.2-6 7.7-6.2 6.5-.2 6.8 6.4 6.8 6.8 0 0 2-2.8 5.1-2.5 0 0 5.5-.3 3.6 8.5l1 1.2s4.1-9.9 12.7-7.4c0 0 8.4 2.6 3 10.7 0 0 4.2 5.5 7.6 5 3.6-.5 6.7-1.6 10.2-7.8 3.6-6.2 11.7-7.2 13.7-6.8 2 .3 3.7 1.8 4 3.2 0 0 4.3-14.3 19.8-12.2l6.2 3.3 2.4 1-3.6 10-8.4 19.2-6.6 2-6.8-3.9-2.4 1.2v5.9l-9 6.4-6.2 2.5-6.8 4.8-1.7 4.2s-3.7-1.7-8 0l-1.4-3.6-4-3.7-15.6-7.4-2.7-9-2.9-1.3-3.2 3.6-4.5.6-7-4.8-7.4-21z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M488.2 198s-6-.2-5.7 6"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#f5ce00",
      stroke: "#000",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M527 263.3c-10.2-3.2-13-14.3-13-14.3a25.5 25.5 0 0 1 1.2-15.5c4.8-11 12.7-11 12.7-11a4 4 0 0 1 4.5 3.2c.4 2.4-1.3 3.3-1.3 3.3-2.7 1.5-4.5-.5-4.5-.5-1.2-1.6-.3-2.9-.3-2.9.7-1 2-.4 2-.4 1.3.2 1 1.6 1 1.6s.4-1.6-1.2-1.8c0 0-3.2-.7-6.8 3.8 0 0-4.7 6.1-4.7 14.1 0 0-.6 14.8 14.7 18.6 0 0-1.6 2.4-4.6 11.1 0 0-3.3 11.2-6.4 17.3 0 0-4.3 8.6-13.9 5.1 0 0-5.6-2.5-5.6-6.5 0 0-.3-3.8 3-4 0 0 3.3-.3 3.3 2.5 0 0 0 3-3.5 2.4 0 0-1.2-.3-1.1-1.5 0 0 .2-1.2 1.8-.6 1.5.6 0 0 0-.1 0 0-.6-.3-1.2 0 0 0-.6 0-.6 1 0 0 0 .6.7 1.1l1.7.2s1 2 3 2.7a8 8 0 0 0 7.1-1.2 10.7 10.7 0 0 0 3-4.3 113.3 113.3 0 0 0 5.2-13.5s1.8-5.7 3.4-8.7z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#f5ce00",
      stroke: "#000",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M498 291.4s2-.2 2 1.5c0 0-.1 2.4-3.2 1.9 0 0-3-.6-2-4 0 0 .8-2.3 3.6-2 0 0 2.8 0 4 3.8 0 0 1 3.3-.7 6-1.8 3-6.2 5-8.4 6 0 0-8.7 3.3-11.3 5.3 0 0-4 2.9-2.2 5.6 0 0 .7 1.1 1.7 1.1 0 0 1.2 0 1.3-1.2 0 0 0 .7-.7 1 0 0-.8.4-1.7-.3 0 0-1-1-.2-2.4 0 0 1-1.6 3.6-.6 0 0 2 1.1 1.2 3.3 0 0-.9 2.1-3.4 2 0 0-1.9 0-3.2-1.2-2-2.1-2-6-.2-8 0 0 1.5-2.1 4.7-3.6l9-3.5c2.6-1.1 4.9-2.3 6.4-4.1 0 0 1.3-1.4 1.8-4 0 0 .4-2-.8-2.4l-1.2-.3z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M498.2 291.4s2.1-.4 3.5 2.2c0 0 .7 1.5.8 2.5m.7-9s-2.1.3-1 3.4c1.1 2.9 3 3.7 3.5 4.2"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#f5ce00",
      stroke: "#000",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M461.6 204.4s0 .8 1 1c0 0 .8.2 1.3-.9v-.3c0-.5.3-2-1.2-3.3 0 0-2.8-2.1-7.8.5 0 0-4 2-6.7 3.6 0 0-7.1 3.8-8 4 0 0-3.2 1.6-8 1.8 0 0-6.5.5-9.2-4.1 0 0-2.2-3.5 0-5.8 0 0 .8-1 2.2-.8.6.1 1.2.4 1.8 1.2 0 0 1 1.4-.1 2.5 0 0-1.6 1-2.2-1 0 .2-.3 1.6.5 3 0 0 4 5.9 14.8-.3l14.3-8s7.2-3.7 11.6 2c0 0 3.4 4.8-1 8 0 0-3.3 2-5.5-1.2 0 0-1.6-3 1-4.4 0 0 2.4-1.2 3.5 1.2 1 2.4-2 3-2.2 1.3 0 0 0-.4-.1 0zm-35.2 54.7c6.3-3.5 7.8-11.5 7.8-11.5 1.4-8-1.7-14.3-1.7-14.3-4-8.6-11-10.3-11-10.3s6.8 4.8 8.7 11.2c0 0 1.6 5.5.6 10.7-.8 5.5-.5 4.1-1.8 8.3z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M458.4 198s6-.2 5.6 6"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#f5ce00",
      stroke: "#000",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M419.3 263.3c10.3-3.2 13-14.3 13-14.3a25.5 25.5 0 0 0-1.1-15.5c-4.8-11-12.7-11-12.7-11a4 4 0 0 0-4.5 3.2c-.3 2.4 1.3 3.3 1.3 3.3 2.8 1.5 4.6-.5 4.6-.5 1.1-1.6.2-2.9.2-2.9-.7-1-2-.4-2-.4-1.2.2-1 1.6-1 1.6s-.3-1.6 1.2-1.8c0 0 3.2-.7 6.8 3.8 0 0 4.8 6.1 4.8 14.1 0 0 .6 14.8-14.8 18.6 0 0 1.7 2.4 4.6 11.1 0 0 3.4 11.2 6.6 17.3 0 0 4.2 8.6 13.7 5.1 0 0 5.6-2.5 5.6-6.5 0 0 .4-3.8-3-4 0 0-3.3-.3-3.3 2.5 0 0 0 3 3.6 2.4 0 0 1.2-.3 1-1.5 0 0-.2-1.2-1.7-.6-1.6.6 0 0 0-.1 0 0 .5-.3 1.1 0 0 0 .6 0 .6 1 0 0 0 .6-.7 1.1l-1.5.2s-1 2-3.2 2.7a7.5 7.5 0 0 1-7-1.2 10.7 10.7 0 0 1-3-4.3 113.5 113.5 0 0 1-5.3-13.5s-1.8-5.7-3.2-8.7l-.6-1.2z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#f5ce00",
      stroke: "#000",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M448.5 291.4s-2-.2-2 1.5c0 0 0 2.4 3.2 1.9 0 0 3-.6 1.9-4 0 0-.7-2.3-3.6-2 0 0-2.7 0-4 3.8 0 0-.9 3.3.8 6 1.8 3 6.2 5 8.3 6 0 0 8.7 3.3 11.4 5.3 0 0 3.9 2.9 2.1 5.6 0 0-.6 1.1-1.7 1.1 0 0-1.2 0-1.3-1.2 0 0 0 .7.7 1 0 0 .9.4 1.7-.3 0 0 1-1 .2-2.4 0 0-1-1.6-3.4-.6 0 0-2.2 1.1-1.2 3.3 0 0 .7 2.1 3.2 2 0 0 2 0 3.2-1.2 2-2.1 2-6 .4-8 0 0-1.7-2.1-4.8-3.6-1.9-.6-5.5-2.1-9-3.5-2.7-1.1-5-2.3-6.5-4.1 0 0-1.3-1.4-1.8-4 0 0-.3-2 .9-2.4l1.2-.3z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M448.2 291.4s-2.1-.4-3.4 2.2c0 0-.7 1.5-.9 2.5m-.7-9s2.2.3 1.1 3.4c-1.2 2.9-3 3.7-3.6 4.2m27.4-91.1s5.2-3.3 10.4.3m-39.7 31.3s.7-3-2.6-8c0 0-2.2-4.7-3.2-7.5m7.4-3.3 2.3 6.6 3 6.8"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 1.2,
      d: "M441.2 238.3s2 2.1 1.8 5.6m-8.1-7.9s2.1 1 1.9 6.8c0 0-.1 4 3 6.2m-5.3 1.4s6.7-.7 7.2 3.5c0 0 0 4 2.4 4.3 0 0 3.3.3 4 3.6m-11.4-6.8s1.2 1.7 2.4 2.6m6.2-7s1.6 2.7 2 4.1m5.3-35s1.6 2.1 3.1 3m3.1 9.6s3.4 1.6 3 10c0 0-.6 5 .9 7.7"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#784421",
      stroke: "#000",
      strokeWidth: 1.2,
      d: "m443.1 226.6.4.8s6 .3 9.1-3.8l-.3-.8s-5.3-.3-9 3.8z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 1.2,
      d: "M464.7 258.5s20.6-6 28.6-9.6"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#784421",
      stroke: "#000",
      strokeWidth: 1.2,
      d: "m462.5 220.5-.2-.6 10.1-4 .3.8z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 1.2,
      d: "m463.4 220.1 6.8 33.3m-5.6-33.6 7.7 33m-6.4-33.6 8.4 32.9m-5-34.1 11.5 24.6m-10-25 12.3 24.2M471.8 217l13.4 24.3m-15.5 12.4 5.2-1.6m-9.1-1.6s15.2-4.5 27-9.2M465.4 252s19.5-5 27.2-8.8m-21.2 24.6 1 3.3 2.8-1-1-3.1m5-1.3 1 3 2.8-.9-1-3m-16-17.6-.2-4.2 25.5-7.7 1.3 3.6m-16 .8 1.3 3.8m7.6-6.4 1.6 3.6m.5-4.3 1.6 3.3m.4-4 1.6 3.6m0-4 2.8-1.6 1.2 3.1m-2.6-2.3 1.4 3.3"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "none",
      stroke: "#00247d",
      strokeMiterlimit: 10,
      strokeWidth: 1.2,
      d: "M429.5 283.1s-5-5.1 0-10c0 0-5.5-2.6-4.6-7m13.6 21s-5.3.7-3.7-9.4c0 0-2.2 4-2.9 6a4.7 4.7 0 0 0 2 5.4c.9.6 5.5 1.8 7-1.2m-8.3-16.2s-2.1 1.9-.6 5.4m2.8-5s.2 3.5 2 5.4m-.5-6.7s0 4 2.9 6.6m-1.5-8s0 4.5 3.4 7.4m13.5-.7s1.6-3.9 5.2-3.6c0 0-1.7.8-1.7 2.5 0 0-.2 3 2.9 3.2 0 0 2.5.4 3.8-1"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "none",
      stroke: "#00247d",
      strokeMiterlimit: 10,
      strokeWidth: 1.2,
      d: "M463.1 293.1s-8.9-4.2-8-10.1c0 0 .4-3.6 4-5.4m-2 3.8s-.8 2.5 1 4.3m1.1-6s-1.2 2.8.7 4.8m1.5-6.3s-1.4 2.4.2 4.5m-8.4 11s4.8 4.3 8.6 4.3m-10.1-2.9s4.5 3.6 7.4 4.2m-9-3.2s5.5 4.9 9 5.2m13.7 4.6s-5.5 3-1.2 6.2m-2.4-9.4 9-4.6m-6.7 6.2s9-5.5 11.7-6.7m-7 7.2s7.7-5.2 11.9-7.5m-6.8 7.1s5.3-4 10.5-7.1m1.7-5.1s-2.6-3.9-11.2 0c0 0 3.3-2.9 9.5-5.2m8.5-16.3s.8 3.1 0 5"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "none",
      stroke: "#00247d",
      strokeMiterlimit: 10,
      strokeWidth: 1.2,
      d: "M486.5 285.7s1.8-2.6 6.3-4c0 0 1.2 3 4.8 2.5 0 0 5.2-1.1 3.6-7 0 0-1.1-4.2-7.2-4.7m18.1-7.3s6.1 1.2 6 6.1c0 0 .6 7.6-7.4 9m6.6-12s1.6-3.7 5.5-5.2m-4.6-2.2s1.7 2.8 2.8 3.1m-3.6-1s1.5 2.1 2 2.5m-2.6-.5a8 8 0 0 0 1.5 1.6M485 235.8s1.2-2 4.3-1.2m12.1 15.8s2-7.8 8.5-5m-2.6-.6s.6-3.6-1-5.5m-3.6 5.2s.9 1.5.1 2.7"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#64b4d1",
      stroke: "#00247d",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M516.2 325s7.4-3.3 5.1-9.1c0 0-.7-2-2.4-1.8 0 0-2.8.1-2.3 4 0 0 1 3.8-.5 7z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#fff",
      d: "M518.8 321.6s1.7-1.5 1.5-4.3c0 0-.2-.6 0-.7 0 0 .4-.1.4.6 0 0 .5 2.9-1.4 4.5 0 0-.1.3-.4.2 0 0-.2 0 0-.3z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#64b4d1",
      stroke: "#00247d",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M526.7 319.8s5.2-3.2 2.4-8.7c0 0-.9-1.5-2.4-1.2 0 0-3.2 1-.7 5.5 0 0 1.2 2.9.7 4.5z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#fff",
      d: "M528 312.4s-.2-.3 0-.6l.4.4s1.5 1.7.3 4.4c0 0-.1.4-.5.2v-.3s1.2-2.4-.2-4z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#64b4d1",
      stroke: "#00247d",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M511 323.6s-5.8-1.4-4.7-7.5c0 0 .6-2.6 3.1-2.2 0 0 3 .8 1 4.6 0 0-1.1 2.6.7 5.1z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#fff",
      d: "M508.8 316.5v-.5s.4 0 .5.2c0 0 .6 1 .1 2.4 0 0-.5.9-.2 1.8 0 0 0 .3-.3.4l-.2-.4s-.3-.8.2-1.8c0 0 .6-1.4 0-2.1z"
    }),
    /* @__PURE__ */ jsx98("path", {
      d: "M515.2 312.3s3.4-1.9 6 .3c0 0-.2-1.2-2.4-1.7 0 0-1-3.2-4.2-2.9 0 0 1.2 1.6 3 2.8 0 0-1.8.2-2.4 1.5m2.4-8.7s2.4 1.7 3.2 2.8c0 0 .9-1.2 2-1.8 0 0-1.2-.3-2 .3 0 0-1.1-1-3-1.3z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 1.2,
      d: "M504.8 310.6s-.3-.8.3-1.6c0 0 .4-.6.2-1.5m23.4-48s3.5-.2 4-3m6-1.8s-1.2 0-2.2 1.2c0 0-.9 1.2-2 1"
    }),
    /* @__PURE__ */ jsx98("path", {
      d: "M523.6 249.2s1.8 0 2.7-.8c0 0 1.1-.7 1.7.4 0 0 1 1.6-.8 2.3 0 0-2.2 1.2 1.3 3.4 0 0-4.2-1.6-2.4-3.6 0 0 1.8-1.2 1-1.7 0 0-.2-.4-.9 0-.7.6-2.1.4-2.6 0"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#64b4d1",
      stroke: "#00247d",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M526 205.6s.8-1.2.5-4.4c-.4-3.2 2.6-3.7 3.6-2.8 0 0 1.2 1 0 3.1a8.3 8.3 0 0 1-4.1 4.1z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#fff",
      d: "M527 203s1.2-1.1.6-3.6l.2-.2h.3s.6 2.8-.6 4.2c0 0-.2.3-.5 0z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#64b4d1",
      stroke: "#00247d",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M525.1 204.4s0-1.4-2.3-3.6c-2.4-2.4-.5-4.4 1-4.4 0 0 1.3 0 2 2.3a8.3 8.3 0 0 1-.7 5.7z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#fff",
      d: "M524.8 201.4s0-1.6-2.2-3.3v-.4h.4s2.3 1.8 2.3 3.8c0 0 0 .3-.3.3 0 0-.2 0-.2-.4"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#64b4d1",
      stroke: "#00247d",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M522 203.3s-.7-1-3.5-2.1c-2.9-1-2.2-3.5-1-4 0 0 1.3-.5 2.6 1.1a7.6 7.6 0 0 1 1.8 5z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#fff",
      d: "M520.6 201.3s-.6-1.4-3.2-2.1c0 0-.2 0-.2-.3 0 0 0-.2.3-.1 0 0 2.9.6 3.7 2.4l-.1.3s-.3 0-.4-.2z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#64b4d1",
      stroke: "#00247d",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M523.7 204.4s-1.3.5-4.4-1c-3.1-1.5-4.4 1.1-3.8 2.3 0 0 .5 1.6 2.8 1.2a8.3 8.3 0 0 0 5.4-2.4z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#fff",
      d: "M516.6 205.4s1.4 1 3.9 0h.3s0 .2-.2.3c0 0-2.6 1.2-4.4.1 0 0-.2 0 0-.3z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M519.3 194.7s1.4.8 1.2 2.5"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 1.2,
      d: "M526 195s.6 1.9 0 3"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#64b4d1",
      stroke: "#00247d",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M420.2 205.6s-.8-1.2-.5-4.4c.4-3.4-2.5-3.7-3.5-2.8 0 0-1.2 1-.2 3.1a8.3 8.3 0 0 0 4.2 4.1z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#fff",
      d: "M419.1 203s-1-1.1-.6-3.6v-.2h-.4s-.5 2.8.7 4.2c0 0 .2.3.3 0z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#64b4d1",
      stroke: "#00247d",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M421.2 204.4s0-1.4 2.4-3.6c2.3-2.4.4-4.4-1-4.4 0 0-1.6 0-2 2.3a8.3 8.3 0 0 0 .6 5.7z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#fff",
      d: "M421.5 201.4s0-1.6 2-3.3c0 0 .3-.3 0-.4h-.2s-2.4 1.8-2.4 3.8c0 0 0 .3.4.3 0 0 .2 0 .2-.4"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#64b4d1",
      stroke: "#00247d",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M424.3 203.3s.6-1 3.5-2.1c2.8-1 2-3.5.9-4 0 0-1.2-.5-2.6 1.1a7.6 7.6 0 0 0-1.8 5z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#fff",
      d: "M425.6 201.3s.6-1.4 3.2-2.1c0 0 .2 0 .2-.3 0 0 0-.2-.2-.1 0 0-2.9.6-3.7 2.4v.3s.4 0 .5-.2"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#64b4d1",
      stroke: "#00247d",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M422.5 204.4s1.4.5 4.4-1c3-1.5 4.4 1.1 4 2.3 0 0-.7 1.6-3 1.2a8.3 8.3 0 0 1-5.4-2.4z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#fff",
      d: "M429.6 205.4s-1.3 1-3.9 0h-.2v.3s2.8 1.2 4.5.1c0 0 .2 0 0-.3z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 2.6,
      strokeWidth: 1.2,
      d: "M427 194.7s-1.5.8-1.2 2.5"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 1.2,
      d: "M420.2 195s-.6 1.9 0 3"
    }),
    /* @__PURE__ */ jsx98("path", {
      d: "M486.7 177.6s1 2.7.6 5.2c-.3 2.4.2 2.9 1 3.4.7.3 2.4-.4 2.5-2.2 0 0 2 3.8-1.8 6.3 0 0-2.7 1.7-5-.4-.8-.9-1.2-3-.7-5 0 0 .6-2.7-.5-5.5 0 0 1.6 1.6 1.2 4.9 0 0-.8 6 3.6 5.6 0 0 3 0 3-3.6 0 0-1.1 1.2-2.4.8a2.4 2.4 0 0 1-1.8-2.8c.1-1.6.6-4.3.3-6.7M482 187s-.4 4.8-4.6 5.9c0 0 .6-.9-.3-3.3 0 0-1-1.2-1-3.3 0 0-1.2 1 .3 3.8 1 1.7 0 3.6-.1 3.7-.4.1 6.9-1 5.6-6.7zm-5.6-4.5s-1.1-1.2-1.2-3.8c0-2.7-.5-3.4-.9-3.6 0 0 .5 2.3.4 3.6a7 7 0 0 0 .4 3s-2.4.3-3.9-3c-1.3-3.3-2.7-3-3.4-3 0 0 .8.1 2.4 3 1.6 3 2.1 3.7 6.2 3.7zm-10.8-7s1.2 3.2 1.4 4.8c0 0-3.1-1-4-3.5 0 0-3.2 1-2 4.7 0 0-2.9-1-4.2-3.2 0 0 1.6 1.2 3.1 1.7 0 0-.2-3.1 3.6-4.2 0 0 .6 2.7 2.6 3.3zm5-5.4s1.2 1.5 3.4 1.5a3.6 3.6 0 0 0 3.2-1.5s-.1 2.6-3.2 2.7c0 0-3.3 0-3.3-2.7zm-13.4 18.5 2 1.9s1.2 1.2 2-.3c0 0 1.3-2.4 2.9-2.2 0 0-1.2.7-2.4 3 0 0-.2.7-1.2.8-.5 0-1 .2-1.8-.7 0 0-.7-.9-1.5-2.4zm16.7-29.4c-3.2 0-.5 2.4-.5 2.4 0 4-3.1 5.4-5.3 4.2-2.2-1.2-.4-4-.4-4s-2.4 1.5-1 3.9c1.6 2.4 5.7 1.2 7.2-.9 1.5 2.2 5.7 3.3 7.1.9 1.7-2.4-.8-4-.8-4s1.8 2.9-.5 4c-2.1 1.3-5.4 0-5.2-4 0 0 2.7-2.5-.5-2.5zm2-4.4s1.2 2 1 5c0 0 .9-3-1-4.9zm-10 4.7s-.3-2.2-2.4-2.4c0 0 1.9 1.3 2.4 2.4m16 0s.3-2.2 2.5-2.4c0 0-1.8 1.3-2.4 2.4zm-19.2 3.2s1.6.5 2.6-.7zm-5.4-13.1s1.9-.1 3.8 2.7c0 0-1.9 1-2.4 1.6 0 0 0-1 1-1.7 0 0-.4-1.4-2.4-2.5zm32 0s-2-.1-3.9 2.7c0 0 2 1 2.4 1.6 0 0 0-1-1-1.7 0 0 .4-1.4 2.5-2.5zm-14.7 2.2s1.7.5 3.8-.7c0 0 2.6-1.4 4.3 0 0 0-1.4-.7-4.3.7 0 0-2.7 1.6-3.8 0"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#fff",
      d: "M476.4 153.6s1.4-2.5 6-2c0 0-1.3 3.6-6 2"
    }),
    /* @__PURE__ */ jsx98("ellipse", {
      cx: 479.4,
      cy: 152.8,
      fill: "#784421",
      rx: 0.8,
      ry: 1.1
    }),
    /* @__PURE__ */ jsx98("ellipse", {
      cx: 479.4,
      cy: 152.8,
      rx: 0.5,
      ry: 0.7
    }),
    /* @__PURE__ */ jsx98("path", {
      d: "M466.8 148.1s2.8.3 4.6 1.2c0 0 1.8 1.2 3.8-.3 0 0 2.2-1.4 3.7-3.1 0 0-3.5 2.3-4.8 2.7 0 0-1.2-1-1.5-2.3 0 0 0-1 2-2.7 0 0-2.5.8-3 2.9a7.2 7.2 0 0 0 1.4 2.3s-.4.3-1.6-.6c0 0-2.8-.8-4.6 0zm7.2 17c-2.4 2.1 0 1.9 0 1.9s2.4.2 0-2zm-1.4-13.2s-1.8.5-4-.7c0 0-2.6-1.4-4.3 0 0 0 1.5-.7 4.3.7 0 0 2.9 1.6 4 0"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#fff",
      d: "M470.8 153.6s-1.5-2.5-6-2c0 0 1.2 3.6 6 2"
    }),
    /* @__PURE__ */ jsx98("ellipse", {
      cx: 467.7,
      cy: 152.8,
      fill: "#784421",
      rx: 0.8,
      ry: 1.1
    }),
    /* @__PURE__ */ jsx98("ellipse", {
      cx: 467.7,
      cy: 152.8,
      rx: 0.5,
      ry: 0.7
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.2,
      d: "M560 130.6v161.6c0 43.1-86.2 57.2-86.2 57.2s-86.4-14-86.4-57.2V130.6z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#006",
      d: "M0 0h320v240H0z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#fff",
      d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#c8102e",
      d: "M212 140.5 320 220v20l-135.5-99.5zm-92 10 3 17.5-96 72H0zM320 0v1.5l-124.5 94 1-22L295 0zM0 0l119.5 88h-30L0 21z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#fff",
      d: "M120.5 0v240h80V0zM0 80v80h320V80z"
    }),
    /* @__PURE__ */ jsx98("path", {
      fill: "#c8102e",
      d: "M0 96.5v48h320v-48zM136.5 0v240h48V0z"
    })
  ]
});
var Bm_default = SvgBm;

// src/country-flag-icons/generated/Bn.tsx
init_esm_shims();
import { jsx as jsx99, jsxs as jsxs74 } from "react/jsx-runtime";
var SvgBn = (props) => /* @__PURE__ */ jsxs74("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx99("path", {
      fill: "#f7e017",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx99("path", {
      fill: "#fff",
      d: "M0 33.3v213.4l640 100V233.3z"
    }),
    /* @__PURE__ */ jsx99("path", {
      fill: "#000001",
      d: "M0 146.7v100l640 200v-100z"
    }),
    /* @__PURE__ */ jsxs74("g", {
      fill: "#cf1126",
      transform: "translate(-160) scale(.66667)",
      children: [
        /* @__PURE__ */ jsx99("path", {
          d: "M695.7 569.7a117.2 117.2 0 0 1-49.4-17.2c-2.4-1.6-4.6-3-5-3-.4 0-.6 1.9-.6 4.1 0 6.4-2.6 9.6-9 11.3-6.2 1.6-15.6-1.6-23.2-8a68.3 68.3 0 0 0-24.7-13.5 39.9 39.9 0 0 0-28 3.6 8.7 8.7 0 0 1-2.8 1.3c-1.1 0-1-6.9.2-9 1.5-3 5.1-5.8 9.4-7.3 2.2-.8 4-1.8 4-2.3 0-.4-.8-2-1.7-3.6-2.9-5.1-1.7-10 3.4-13.9 5.2-4 14-4.6 21.7-1.7a32 32 0 0 0 4 1.4c1 0 .4-1.5-2.4-5.6-3.2-4.7-3.9-7-3.5-12.7a14.7 14.7 0 0 1 13.5-13.5c5.8-.4 9.4 1.6 18 9.7a144 144 0 0 0 86 41.6c8.3 1 24.8.5 34.5-1a156 156 0 0 0 81.8-40.8c6.4-6 9.4-7.6 14.7-7.6 4.5 0 7.7 1.4 11 5 3 3.3 4 6.4 3.6 11.5-.2 3.2-.7 4.7-2.6 7.9-2.8 4.5-2.3 5 3.2 2.8 7.6-3 16.9-1.6 21.9 3.2 4.4 4.2 4.8 8.4 1.4 14-1.3 2.1-2.3 4-2.3 4.4 0 .6 1 .8 5.5 1.6 6 1 9.5 5.4 9.5 12.2 0 2-.3 3.7-.6 3.7s-2.6-.9-5-1.9c-7-2.9-11-3.6-19.2-3.5-6.2 0-8.3.3-12.6 1.7a57.5 57.5 0 0 0-19.5 11.5c-6.4 5.7-10.4 7.5-16.6 7.4-5.8 0-9.7-1.7-11.8-5-1.1-1.8-1.3-2.8-1-6.8.2-2.6.1-4.7 0-4.7-.3 0-2.5 1.4-5 3.1A80.5 80.5 0 0 1 778 560a181.6 181.6 0 0 1-82.3 9.7"
        }),
        /* @__PURE__ */ jsx99("path", {
          d: "M706.3 525.2a136.4 136.4 0 0 1-97.9-55.7c-24.4-33.2-32-77.1-24.6-117.2 4-18.3 12-36.6 25.5-49.6a114.6 114.6 0 0 0-8.7 74.3c9 49.8 51 91.9 101.3 99.2 20 5.7 40.5-.4 59.5-6.5 42-14.8 74-54.6 77.8-99.1 3.3-24-.3-49.1-11.2-71 6.2 3.3 14 16.2 18.6 24.8 16 31 16.7 68.1 7.3 101.2-12.8 42.1-45 79-87.5 92.4a165.7 165.7 0 0 1-60 7.2z"
        }),
        /* @__PURE__ */ jsxs74("g", {
          id: "bn_svg__a",
          children: [
            /* @__PURE__ */ jsx99("path", {
              d: "M512 469.9c-2.5-.4-5.3 2.1-4.3 4.7 1.8 2.6 5 4 7.8 5.2a54.2 54.2 0 0 0 23.2 3.6 49.6 49.6 0 0 0 17-3c3-1 6.8-2 8-5.4 1.3-2.1-1-4.3-3.1-3.9-3 .7-6 2-9 2.9a57.7 57.7 0 0 1-20.3 2 54 54 0 0 1-14.4-4.2c-1.6-.7-3.1-1.7-4.9-1.9"
            }),
            /* @__PURE__ */ jsx99("path", {
              d: "M514.8 459.5c-2.5-.4-4.7 2.6-3.7 5 2 2.8 5.3 4.3 8.4 5.6a42.4 42.4 0 0 0 17 2.9h1.5a37.6 37.6 0 0 0 14.4-2.8c2.7-1.1 6.1-2.2 7.3-5.2.9-1.7.2-4.1-2-4.3-1.8 0-3.5 1.2-5.3 1.7a44.3 44.3 0 0 1-20.6 3.2c-4.4-.5-8.5-2.1-12.5-4-1.5-.7-2.8-1.8-4.5-2z"
            }),
            /* @__PURE__ */ jsx99("path", {
              d: "M518.3 449.6c-2.2-.3-3.7 2.2-3.3 4.1.3 1.8 1.8 3 3.1 4a30 30 0 0 0 18.6 5.3h1.6a28 28 0 0 0 12-2.8c2.5-1 5.4-2.3 6.3-5.2.4-1.3.6-3.2-.9-4-1.6-.8-3.1.5-4.5 1a34 34 0 0 1-15.5 3.9 27 27 0 0 1-13.1-4c-1.5-.7-2.7-2-4.3-2.3"
            }),
            /* @__PURE__ */ jsx99("path", {
              d: "M481.5 302.7c-3.2 3.3-.7 9.3-1 13.5 1.8 13.2 3.9 26.5 8.8 39 6 12 18.8 18.5 26.5 29.2 2.8 5.1 1.8 11.3 2.4 17 .4 15.3.3 30.7 0 46 7 3.6 14.5 7 22.5 5.7 4.7-1.1 13.5-1.8 14.5-6.5l-1-79.5c-2.7-8.1-11-12.3-17.1-17.5a155.5 155.5 0 0 1-14.2-16.1c-2.6-4.5-12.9-6-9.2 1.6 2.2 6.7 7.7 11.6 9.1 18.6.3 3.9 5 11 1 13.2a24.5 24.5 0 0 0-10.7-10c-4.4-3.3-11.7-4.7-13.3-10.5a42.9 42.9 0 0 0-11-22c1.5-7.4 0-16.7-6.4-21.5z"
            }),
            /* @__PURE__ */ jsx99("path", {
              d: "M491.4 304.2c-3 .5-2.8 4.2-1.5 6.2a27.2 27.2 0 0 1 1.1 13.4 44.1 44.1 0 0 1 10.6 21.7c0 3 3.2 4 5.3 5.5 4.9 3.1 10.3 5.4 14.7 9.3.9 1 1.6 2 1 0-.7-2.6-1-5.4-3-7.3-2.8-3-6.2-5.6-10.2-6.4-.3-4.2-2.3-8-4.1-11.6-2-3.5-4.1-7.2-7.5-9.4 0-6.1 0-12.5-2.6-18.2-.8-1.4-2-3.1-3.8-3.2"
            }),
            /* @__PURE__ */ jsx99("path", {
              d: "M499.7 306.6c-2 .6-1.6 3.2-1 4.7a54 54 0 0 1 1 13.2c3.9 3 6.2 7.4 8.4 11.6 1.4 2.8 2.6 5.8 3.1 8.9 3.1 1 5.8 3 8.2 5-1-2.8-3-5-4.5-7.7s-3-5.6-3.7-8.7c-3-3.1-4.6-7.6-4-12 .2-4.7-1.3-9.6-4.5-13.2-.8-.8-1.8-1.7-3-1.8"
            }),
            /* @__PURE__ */ jsx99("path", {
              d: "M509.2 308c-1.2.2-1.8 1.2-2.4 2.1-.3.9.8 1.8 1 2.8a21.8 21.8 0 0 1 1.4 10.4c-.1 2.5.8 5 2 7a3.9 3.9 0 0 1 3.5-2.8c.5 0 1.4.2 1-.7-.4-4.8-1.1-9.6-2.8-14a9.6 9.6 0 0 0-2.8-4.5c-.2-.2-.6-.4-1-.3z"
            })
          ]
        }),
        /* @__PURE__ */ jsx99("use", {
          xlinkHref: "#bn_svg__a",
          width: "100%",
          height: "100%",
          transform: "matrix(-1 0 0 1 1440 0)"
        }),
        /* @__PURE__ */ jsx99("path", {
          d: "M715.7 476a35.6 35.6 0 0 1-29.9-24c.3-2.2 3 1.2 4.3 1.5a19 19 0 0 0 8 2.6c3.5 1.5 5.7 5 9.1 6.9 1.6 1.2 7.2 3.6 6.1-.3-1.3-2-2.2-4.6-1-7 1.8-4.1 4.7-7.7 7.7-11.2 2.1-.7 3.6 3.6 5.1 5 2.1 3.3 4.7 7.3 3.4 11.3-1.2 1.5-2 6 1.3 4.6 4-1.8 7.3-4.8 10.6-7.6 3-2 6.7-2.1 9.7-4 1.5-.3 4.4-3.1 5-1.6a44.9 44.9 0 0 1-7.4 12.3 32.1 32.1 0 0 1-18.8 10.9c-4.4.8-8.8 1-13.2.6"
        }),
        /* @__PURE__ */ jsx99("path", {
          d: "M731.5 460.2c.3-2.7-.3-5.4-1.7-8-2.1-4.2-5-8-8-11.9-2.8-1.6-4.3 3.7-6.1 5.2-2.9 4.3-6.5 8.7-6.7 14-1.6 2.5-4.6-2-5.9-3.5a19 19 0 0 1-4-12 50.8 50.8 0 0 1 3.6-20.6c2-5.6 5.1-11 4.8-17 .2-4.7-.7-9.7-4.4-12.8-3.6-2.8 2.3-3.4 4.1-2 3.2.3 4.9 5.5 7.8 4.2 1.1-2.7 1.4-6 3.8-8.1 2.3-3.2 4.7 1.3 5.5 3.5 1.7 1.8 0 6.5 2.6 6.6 3.2-2.3 5.5-6 9.6-6.9 1.7-1 4.5 0 2.3 1.8-3 2.9-5.6 6.4-6.2 10.7-.9 5.3.4 10.7 2.7 15.4 4.5 9.4 8 20 5.7 30.5-1 4.6-4.2 8.6-8 11.3-.5.3-1.3.3-1.5-.4"
        }),
        /* @__PURE__ */ jsx99("path", {
          d: "M726.7 389.6a21.2 21.2 0 0 0-5.6-7c-2.4 0-3.9 3-5.5 4.6-1.1 2.1-2.5 5.6-5.3 2.9-4.5-2.6-5.2-8.3-5.2-13-.3-7.6 2.8-14.7 5.5-21.6 1.7-4.3 1.3-9.2.2-13.6-1.3-5-5.4-8.6-8.5-12.6.2-1.5 4.2-.7 5.7-.4 3.4.9 5.4 3.8 7.9 6 1.8-.6 1-4.2 1.9-5.9 0-2.4 3.2-5.5 4.5-2.1 2 2.2 0 6.5 2.5 7.8 2.4-.9 3.6-3.5 5.8-4.7a8 8 0 0 1 7.8-.5c.9 2.2-2.6 4-3.6 6a20.4 20.4 0 0 0-3.8 18c1.4 5 3.8 9.5 4.7 14.5a40.1 40.1 0 0 1-.5 17.2c-.9 3.4-3.8 5.6-6.8 7-.8-.7-1.2-1.7-1.7-2.6"
        }),
        /* @__PURE__ */ jsx99("path", {
          d: "M711.6 326.9c-3.4-2.5-4.5-4.8-4.5-9.5 0-2.3.5-3.6 2-5.8 2.4-3.2 2-4.2-1.3-3.3-5.3 1.5-7.8.2-8-4.3 0-2.2.4-3.1 3.3-6.7 2.4-2.8 3.3-4.3 2.8-4.8-.5-.4-3.3 2-9 7.8a124 124 0 0 1-11.4 10.6c-9.8 6.6-19.2 7.6-23.5 2.5-2.2-2.6-2.1-4 .4-5.6a27.4 27.4 0 0 0 4.4-3.7 86 86 0 0 1 16.1-11.6c3.6-1.8 4.4-3 2.1-3-3 0-12.5 6.2-19.8 12.8-2.1 2-5.2 4.2-6.8 5a25.4 25.4 0 0 1-13.9 1c-2.2-.7-6.3-4.5-6.3-5.9 0-.3 1-1.1 2-1.8a30 30 0 0 0 4.6-3.2c5.8-5 16.8-10.3 25.5-12.2 2.8-.5 1.7-2-1.4-1.8a56 56 0 0 0-25 11.7c-8.3 6.9-20.8 6.2-24.8-1.3-.7-1.3-1.2-2.5-1-2.7a92.8 92.8 0 0 0 20.4-7.8 51.5 51.5 0 0 1 18.1-6.5c2.8-.5 3-1.9.3-2.2-3.6-.4-9 1.4-18.5 6-12.3 6.1-15.8 7.2-22.2 6.8-6-.4-9.3-1.9-14-6.4-3.2-3-7.6-10.5-6.8-11.4a63.5 63.5 0 0 0 15.8 1.3c8.3 0 10.6-.2 15-1.5a84.3 84.3 0 0 0 24-12.1 57.5 57.5 0 0 1 36.8-13.6c12.4 0 20.2 2.8 27.2 9.9 2.4 2.4 4.4 3.9 4.7 3.6.3-.3.6-4.5.7-9.3 0 0 3.7-.4 4.5.7 0 7.7 0 8.4 1.2 8.4.7 0 1.5-.8 2-2 1-2.5 5-6 9.2-8.2 9-4.5 24.7-4.7 37.3-.3a62.4 62.4 0 0 1 16.7 9.5 90.2 90.2 0 0 0 24 12c6.8 2 19 2.5 25.1 1a61.9 61.9 0 0 1 5.4-1c2.3 0-1.6 7.6-6.2 12.1-8.4 8.2-19.3 8.1-34.6-.1-9.6-5.2-21-8-21-5.2 0 .6.6 1 1.5 1 3.3 0 9.7 2.2 18.7 6.5a53.7 53.7 0 0 0 18.3 6.5c2.3 0 2.4 1.5.2 4.7-2.3 3.4-6.2 5-11.7 5-5.3 0-8.3-1.1-13-5-8-6.6-27.6-14-26.9-10 .2.7 1.1 1.2 3.2 1.5a56 56 0 0 1 23.1 11l5.9 4.3c1.1.6 1.1.8.2 2.5-1.4 2.8-5.2 4.9-9.2 5.3-5.2.6-9.8-1-14.5-5-10-8.3-19.3-14.3-22.3-14.3-2.5 0-1.4 1.4 3 3.7a79.7 79.7 0 0 1 15.8 11c2 1.9 4.3 3.7 5 4.1 1.9 1 1.8 2.4-.2 5s-5.4 3.8-9.7 3.3c-8.6-.9-15.4-5-26-16a70.7 70.7 0 0 0-8.2-7.8c-1.4 0-.5 1.9 2.2 5 3.4 3.7 4 5.8 2.7 9-1.1 2.6-3 3.3-6.8 2.2-4-1-4.6 0-2 3.1 3.8 4.9 3.3 10.7-1.5 14.8a12 12 0 0 1-3.4 2.3c-.4 0-1.4-1-2.3-2.4-3-4.6-5.7-4.6-8.7 0a53.6 53.6 0 0 1-2 3 113.1 113.1 0 0 1-3-2.2"
        }),
        /* @__PURE__ */ jsx99("path", {
          d: "m726.7 233-5.2 4-4.6-3.4v27.8h9.8z"
        }),
        /* @__PURE__ */ jsx99("path", {
          d: "M694.9 204.3a88.3 88.3 0 0 1-9 32.3l11.1-10.3 7.7 9.2 8.4-9.4 8.5 8 8.2-8.3 8.5 10 7.4-8.2 12.6 9c-4.6-10-10.7-18.6-10-32.8-12.1 9-41 10.6-53.4.4z"
        }),
        /* @__PURE__ */ jsx99("path", {
          d: "M717 197.6c-4.5 0-9.2.1-13.4 1a20.1 20.1 0 0 0-7.8 3c.3 8.6 41 12.1 51.9.2a20 20 0 0 0-8.2-3.3c-4-.8-8.6-.8-12.9-1v7.1H717z"
        }),
        /* @__PURE__ */ jsx99("path", {
          d: "M724.9 154h-6.3v49.4h6.4z"
        }),
        /* @__PURE__ */ jsx99("path", {
          d: "m724.9 155.2-2.4 23.7 24.3 11.9-12.3-16.5 16.8-5.5zm-2.7-6.1c-3.7 0-6.4 1.4-6.4 3s2.7 3 6.4 3 6.4-1.4 6.4-3-2.7-3-6.4-3"
        })
      ]
    }),
    /* @__PURE__ */ jsxs74("g", {
      fill: "#f7e017",
      children: [
        /* @__PURE__ */ jsx99("path", {
          d: "M314 375.9c2.7-.9 4.2-2.5 5.3-5.6.5-1.6.9-3.2.8-3.6-.2-1-1.4-1-2.6.1-.9.7-1 1.1-.8 2.6.7 3.7-.7 4.7-7.7 5.4-.7 0-2.8 0-4.5-.3-3.4-.4-4.6 0-3.4 1a7 7 0 0 0 2.1.9c1.9.5 8.8.2 10.8-.5m14.7-.6c.4-.4 1.7-1 3-1.5 1.7-.5 2.6-1 3.3-2.2 2.1-3 1.7-5.7-1.3-9.3-1.7-2-2.4-1.9-3.7.3-1.2 1.8-1.1 2 .5 2.4.9.2 1.7.8 2.1 1.6 1.8 3.1 1.3 5-1.4 5-2.4 0-3 .4-3.7 2l-.6 1.9c0 .6 1 .5 1.8-.2m-4.8-3.5c.4-1.3.6-3.5.5-8a33 33 0 0 0-.3-6.4c-.4-.4-2.3.8-2.6 1.7a3 3 0 0 0 .5 2.1c.6 1.2.7 2.4.5 7-.3 6 .1 7 1.4 3.6"
        }),
        /* @__PURE__ */ jsx99("path", {
          d: "m312.6 369 .7-5c.1-1.7.5-3.8.7-4.7.7-2.3 0-2.9-1.8-1.6l-1.3 1 .2 3.3c.3 3-.2 8.5-.9 10.7-.2.6.1.4.9-.5.6-.7 1.3-2.2 1.5-3.3zm-10 1.6c2.4-2 2.1-5.6 2.7-8.4 0-1.9 1.2-4.1.4-5.8-2.3.4-3.7 2.6-2.5 4.7 0 2.5 0 5.2-1.3 7.4-1 1.5-4.4 1.1-4.2-1 .8-3-2.9-1.5-4.3-.7-1.1.8-3.5.9-2.6-1-.6-2.7-3.9-1-5.7-1-1.7 0-.1-3.5-2.6-3-4.5-.3-9.5.1-13.5-2.6-2.3-1.1-2-3.9-.7-5.7 1.4-2.4 1.8-5.5 4-7.4 2.3-2.1-2-1.2-3-.5-2.2 1.2-.2 4.3-2 6-1 1.8-2.4 4.2-4.8 3.9-3.5-.7-5.5-4-8-6-2.2-.5-1 3.4.2 4.2a21.9 21.9 0 0 0 7.4 3.6c2.6-.5 2.7 3 5 3.5 4 2 8.6 2.5 13.1 2.8 1.8.1.8 3.3 3.1 2.6 1.3.4 4.3-.5 4.4 1-2 2.4 1.9 2.3 3.3 2 1.9-.4 4.2-1 4.7 1.4 1.5 1.7 4.3 1.4 6.2.5z"
        }),
        /* @__PURE__ */ jsx99("path", {
          d: "M262.8 350.4a23.9 23.9 0 0 0 2.4-4.2 16 16 0 0 1 2-3.6c1.2-1.2.5-2-1.4-1.6-1 .2-1.4.6-1.5 1.5a23 23 0 0 1-2.5 7c-1.7 2.5-1.7 2.6-1 2.6.3 0 1.2-.8 2-1.7m-25-15.7c-1.9 0-2 1.2-.2 1.8 1 .3 1.7 1 2.3 2.3 1.7 3.5 2.8 4.2 7.5 4.6l3 .2.2 1.9c0 1 .3 1.8.5 1.8l2.6-1c2.2-1.2 4.3-3.8 4.3-5.5 0-1-1.8-2.2-3.4-2.2-.7 0-2 .6-3.1 1.4-3.4 2.4-7 2-9-1.2-1.5-2.6-3.2-4-4.7-4zm16.3 6.5c.9 0 1 .7.6 2a.9.9 0 0 1-1.7 0c-.4-1 .1-2 1-2zm126.5-4c-1.3 0-1.6.2-2.4 1.4-1.3 1.9-1.4 6-.2 7.4.7.9.8.9 2.3.2 2.2-.9 2.6-.8 2.5.3 0 3-4.2 8.7-8.6 11.7a9.7 9.7 0 0 0-2.4 2c-.3.8 1.3.7 3.3-.4a21 21 0 0 0 7.9-8c1.1-2.3 1.3-3 1.5-7 0-3.8 0-5-.6-6.2-.8-1.4-1-1.5-2.8-1.5h-.5zm.1 2.5c1 0 1 .2 1.2 1.6 0 1-.1 1.7-.7 2.3-.8.7-1 .7-1.6-.4-1-1.6-.4-3.5 1.1-3.5m-20.2 28.5c3.9-2 6.2-4.1 7.6-7.2a20 20 0 0 0 1.3-3.1c0-.6-1.9-1.5-3-1.5s-1.4-.8-1-3c.5-2.1 0-4.8-1-4.8-.3 0-1 .5-1.3 1.1-.6 1-.7 1.4-.2 2.7.7 2 .1 3.6-1.7 4.9-.9.6-1.3 1.3-1.3 2l.1 1 2.1-1 2-1.2 1.1 1c.7.4 1.2 1.2 1.2 1.7 0 2.4-6.8 6.4-11.4 6.8-2.5.2-3 0-3.8-.8-.7-.7-.9-1.3-.7-2l.5-2.6c.4-2.1-.4-1.8-2 .6-1.2 2-1.6 4.1-.9 5.2.6 1 4.4 1.8 7.2 1.6 1.7 0 3.4-.5 5.2-1.4m26-14.5c2.4-2.5 3.5-5.5 3.5-10v-3.5l2-1c2.7-1.2 5.2-3.7 5.2-5.1 0-1.4-.7-1.4-1.8.2-.9 1.1-2 1.8-6 3.7-1 .4-1.1.7-1.4 5-.2 5-1 6.8-3.7 10.2-1.7 2-1.8 2.4-.6 2.4.5 0 1.8-.9 2.8-2zm-26.7-2.8c.2-.7-1.2-1.2-1.7-.6-.3.2-.4.6-.2.9.4.6 1.6.4 1.9-.3m36.8-9.5c.3-.8-1.1-1.3-1.7-.7-.2.3-.3.7-.1 1 .4.6 1.6.4 1.8-.3m-44.3-25.9c-1 .5-1.5 1.5-2.1 2.3-.5.3-.1.6.1 1 1.7 1.7 2.4 4.2 3.2 6.5.8 2.7 1.8 5.6 1 8.4-.3 1-1.2 2.1-2.4 1.8-2-.1-4-.7-6-.7-1.9.1-3.3 1.8-5.1 1.6-1.2 0-1.2-2.4-2.2-1.7-.6 1.3-.3 2.7-.4 4 .2.3.8.1 1.1.2h3.7c.2 1.2.2 2.7 1 3.7 1.3.4 2.8 0 4-.5 1.2-.6 1.4-2.1 1.8-3.3.4-1.3 2-1 3-1.5a5.7 5.7 0 0 0 4-5.7c-.2-3.9-1.6-7.4-2.8-11-.5-1.6-.9-3.3-1.5-4.9zm-6 21.8c1.3 0 1.9 1.6 1.6 2.7-.5 1.5-2.4.6-2.7-.5-.7-1-.3-2.3 1-2.2z"
        }),
        /* @__PURE__ */ jsx99("path", {
          d: "M296 324.8c-.6 0-1.3.2-2 .7-3.5 2.5-4.5 5.4-2 6.6 1.7.8 1.3 1.8-1.5 3.2-4 2-7.5 1.7-14.2-1-1.6-.7-2-.4-1.7 1 .4 1.5 1.8 2.3 5.1 3 3.6 1 8 .7 10.8-.5a14 14 0 0 0 4.3-3.4l2.2-2.3 2.5.3c3.1.4 3.2.4 3.2 1.9 0 1.2 0 1.2 2.9 1.5l4.7.2c1.3 0 2 .3 2.4.9.6.7.9.8 5.6.4 4.4-.4 5.2-.4 7.2.3 1.4.4 3 .6 4.1.5 3.4-.4 8-3.1 8.7-5.1 0-.3 1.3-.7 2.7-1 3.4-.7 3.5-1.4.4-1.8a22.9 22.9 0 0 1-4.6-1.1 12.2 12.2 0 0 0-3.5-.9c-1.7 0-3.3 1-3.3 2.2 0 .7.2.8 2.3.6 1.8-.2 2.4-.1 3.4.7.7.5 1.1 1.1 1 1.3-.5.8-4.5 2.6-6.2 2.9a4.7 4.7 0 0 1-3-.5c-1.6-.8-3.8-.9-4.3-.2-.2.3-.6.1-1.3-.5l-1-1-2.4 1c-2.4 1-3.3 1-3.3-.2 0-.5-.7-.6-4.2-.3-3.9.2-4.3.1-5-.7-.7-.7-.7-1-.2-1.7.4-.8.4-1 0-1.5-.4-.4-1-.4-2.5 0-3.9 1-5 .5-5-2.5 0-1.9-1-3-2.3-3m-1 2.8c.2 0 .4.1.7.4.3.3.5 1 .3 1.3-.3.9-2 .9-2.3 0-.2-.5 0-1 .5-1.3z"
        }),
        /* @__PURE__ */ jsx99("path", {
          d: "M288 330.4c2.4-1.5 2.4-1.4 2.7-5.5.2-3 .2-3.2-.6-3.2-1.2 0-1.8 1.3-1.8 3.7 0 1.6-.2 2.3-1 3-2 2-6.8 1.1-7.5-1.3-.2-.8.1-1.6 1.1-3 2.1-3 1.7-3.8-1-1.5-1.7 1.6-2 1.6-1.7.3.3-1.3-.3-1.8-1.8-1.4-.7.2-1.2.6-1.3 1.6-.2.8-.6 1.3-1.3 1.5-1.2.3-3.2-.8-3.2-1.8 0-.7 3-4.4 6.9-8.4 1.4-1.5 2.6-3 2.6-3.1 0-.2-.8-.4-1.7-.4-1.4 0-1.8.2-1.8.8 0 .4-1.9 3-4.3 5.7-5 5.6-5.4 6.7-3 8.2a6 6 0 0 0 6.6-.2l1.6-1.1v2c0 2.5.5 3.5 2.5 4.5a8 8 0 0 0 8-.4m104.4-34.6c-1.8 1.1-.4 3.4 0 5-.8 2-3.5 2.6-5.5 3-2.8.5-4.8 2.8-5.8 5.3-.6 1.6-2 4-3.5 1.6-1.3-1.3-3.7-2.4-5.2-.8-1.2 1.1-1.5 2.7-2 4.2-.7-1.1-1-2.8-2.4-3.2-2.4.3-1.5 3.3-.4 4.5 1 1.5 2 3.3 1 5-1 2-4 3.4-5.7 1.7-1.6-.9-.5-4-2.2-4.2-.8.6-.8 3.9-2.1 2.1-1-1.5-.4-3.6-1.6-4.9-1.3.2-2.4 2.5-2 3.7 1.8 2.4 2.6 5.4 3.3 8.3.4 1.2-.1 3.5 1 4 .7-1.9 0-4 .6-5.9 1.8-.2 3.7.6 5.5.2 2.7-.3 4.7-2.6 5.6-4.9.3-1.8 0-3.6-.1-5.4 2 .4 4.2.4 6.2 1 1 1.5-.3 3.7-.6 5.3-1 3.4-3.7 5.8-6.2 8-1.1.7-1.2 2.4.3 1.5a15 15 0 0 0 7.5-8c1.1-2.6.2-5.5 1-8.1 1-2 3.5-1.6 5.4-1.6 1.9 0 3.5-2.3 2.9-4.2-.6-2.2 1.7-3.2 3.2-4 2.1-1 3.7-3.1 3.5-5.5 0-1.3 0-3.6-1.7-3.7m-7.3 12.5c2.2.6-.4 4.8-1.6 2.1-.4-1 .5-2.1 1.6-2.1m-10.3 3c2.9-.1 1.8 4-.6 2.2-1.3-.7-.9-2.2.6-2.2M270 327.6c0-.4-.2-.7-.6-.7-.7 0-1.2.7-.9 1.3.4.7 1.3.3 1.5-.6m34-3.6c0-.7-.3-.9-.8-.8-1.1.2-1.3 1.7-.1 1.7.6 0 .9-.3.9-1zm-42-20.4c-1.3-.3-2.2.9-2.7 2-1 1.7-2.2 3.4-4 4.3-1.3.4-2.7-.1-3.9-.8-1.3-.7-1-2.3-1.6-3.4-1-.8-2.7.3-2.6 1.5-.1 1.6 1.3 2.5 2.6 3.1 1 .7 2.6 1 3 2.3 0 1.1.4 2.4 1.7 2 1.5 0 2 1.8 1.3 2.9a6.3 6.3 0 0 0-.7 4c.7.7 1.4-1 2-1.4l1-1.4c2.7.1 5.3.5 8 .4 2 0 3.5-1.2 4.7-2.6 1.8-1.8 3.2-3.9 5.1-5.4 1.4-.4.7-3-.8-2.2-1.3.5-1.7 2-2.6 2.9a31 31 0 0 1-5 5.2c-1.5.6-3.1.3-4.6 0-.6-.5 1.2-1 1.5-1.6.8-.8 1.8-1.6 2.3-2.7-.5-1-1.9-1-2.9-1-2.4.2-4.3 2.3-6.8 2.5-1.9 0-.9-2 0-2.7 1.6-2 3.4-3.8 5.1-5.7.5-.6 2.3-1.2 1.2-2-.4-.2-.9-.2-1.3-.2m1.2 10c1.3.7-.8 1.8-1.6 1.7-1.1.3-1.2-.8-.2-1 .6-.4 1.2-.7 1.8-.7m-3.8 2.6c.7 0 2.2.7.8 1.1-1 .8-2-.8-.8-1.1"
        }),
        /* @__PURE__ */ jsx99("path", {
          d: "M289.4 317.8c0-1-1.6-.8-1.8.2-.2.6 0 .7.8.6.6 0 1-.4 1-.8m74.7-6.6c.2-.9-1-1.5-1.7-.8-.7.6 0 1.9.8 1.7.4 0 .8-.5 1-.9zM248 302.1c1.1-1 1.2-1.1.7-3.3-.8-3.1-.7-3.5.5-3.8 1.5-.3 5.3 1.7 6 3.3.8 1.3.7 1.4-.4 2.4-1.2 1.1-1.2 2.4 0 2.4 1 0 3.7-2.6 3.7-3.5 0-1.3-3-4.4-5.4-5.5a10.7 10.7 0 0 0-4.6-1c-3.1 0-3.5.7-2.7 4.2 1 4.2-.3 4.8-3.7 1.6a10.4 10.4 0 0 1-3.5-8.6c0-4 1.6-6.1 5.1-6.6 2.4-.3 2.3-.9 0-1.2-3.6-.6-6.6 1.8-7.7 6-1.3 4.7 1.6 10.4 6.7 13.3 2.7 1.5 3.7 1.6 5.3.3m139.2-5.2c.3-.2.5-.9.5-1.4s.5-1.6 1.1-2.4c.6-.8 1-1.6 1-1.8 0-.8-1.3-.8-2.3 0-1.1.9-2 1-2 0l1.2-.9c1.6-.7 1.7-1.5.4-2.1-1.7-.8-3.5.6-3.6 3-.1 1.6 0 1.8 1.2 2.5 1.1.7 1.3 1 1.1 2-.3 1.6.4 2.2 1.4 1.1m13-1.4c1-1 1.8-1.9 1.8-2.2 0-.3.9-1.2 1.9-2 2.8-2 3.5-4 2.2-7.3-.5-1.3-2-3-5.5-6a26 26 0 0 0-5.4-4.4c-.9 0-.7 3.4.2 3.7 1.7.6 2.8 1.3 5.4 3.7 3.2 2.8 4.6 5.5 3.8 7-.7 1.4-1.7 1-4.5-2a13.8 13.8 0 0 0-3.2-2.9c-.3 0-.5.6-.5 1.4 0 1 .5 2 2 3.5 2.3 2.6 2.5 4.1.7 5.5a5 5 0 0 1-1.4 1 33.2 33.2 0 0 0-9-10c-.3 0-.5.4-.5 1.4 0 1.3.2 1.7 1.2 2.2a38 38 0 0 1 7 7l1.8 2a9 9 0 0 0 2-1.7zm6-16.8c-.5-1.2-8.4-9.4-9.3-9.4-.4 0-.5.5-.4 1.8 0 1.6.3 1.8 1.4 2.1a20 20 0 0 1 4.6 3.7 17 17 0 0 0 3.7 3zm-47.8 92.6a1.2 1 0 1 1-2.3 0 1.2 1 0 1 1 2.3 0m4.2-1.4a1.2 1 0 1 1-2.4 0 1.2 1 0 1 1 2.4 0"
        })
      ]
    })
  ]
});
var Bn_default = SvgBn;

// src/country-flag-icons/generated/Bo.tsx
init_esm_shims();
import { jsx as jsx100, jsxs as jsxs75 } from "react/jsx-runtime";
var SvgBo = (props) => /* @__PURE__ */ jsxs75("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#ffe000",
      d: "M0 0h640v320H0z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d52b1e",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#a05a2c",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m368.6 210.7-98 97.9a91.8 91.8 0 0 0-1.3-1l98-97.8a6.3 6.3 0 0 1 1.3 1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e7e7e7",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M374.7 204.5c-.4.7-1.4 2.5-1 3.8l-2-1.5c.5 1 .4 1.4-.1 1.8-.3.4-1.4.3-2.1.2.7.4 1.5.8 2.4 1h2c-.7.3-2.2.8-3.3 1-.5.1-1.6.2-2 0-.6.5-1.9-.4-1.3-1-.3-.3-.3-.8-.4-1.4 0-.7.1-1.9.7-3l.5 1.7c.2.5.7 1 1.1 1.4-.2-.5-.4-1.2.1-1.8.5-.5 1.3-.5 2-.2l-1.9-1.3c.8 0 3.3-1 4.1-1.5a62.3 62.3 0 0 0 4.9-3.8 57 57 0 0 0-3.7 4.6z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#a05a2c",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m387 222.8-125.7 70.9a85 85 0 0 0-.9-1.2l125.7-71a5.6 5.6 0 0 1 1 1.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e7e7e7",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M394.9 218.3c-.6.6-2.2 2-2.2 3.4l-1.4-2c.2 1-.1 1.5-.7 1.7-.4.4-1.4 0-2-.3a5.1 5.1 0 0 0 2 1.5l1.7.6c-.6.1-2.3.3-3.4.2-.5 0-1.5-.2-1.9-.6-.7.4-1.6-.8-1-1.2 0-.4 0-.8.2-1.4.2-.7.7-1.8 1.6-2.8a7.8 7.8 0 0 0 0 1.8c0 .5.3 1 .5 1.6 0-.5 0-1.3.7-1.7.7-.4 1.4-.2 2 .3l-1.4-1.7c.8.1 3.5-.2 4.4-.5 1-.2 4.1-1.6 6-2.5-1.7 1-4.6 3-5.1 3.6z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#a05a2c",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m376.3 217.5-113 85.2-1-1.1 112.9-85.2a6 6 0 0 1 1.1 1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e7e7e7",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M383.4 212.1c-.5.6-1.8 2.3-1.6 3.6L380 214c.3 1 .1 1.5-.4 1.7-.4.4-1.5.2-2.1 0 .6.5 1.3 1 2.2 1.2l1.9.3c-.7.3-2.3.6-3.4.6-.5 0-1.6 0-2-.3-.6.5-1.7-.6-1.1-1.1-.2-.3-.1-.8-.1-1.4a6 6 0 0 1 1.1-3 7.8 7.8 0 0 0 .2 1.8c.2.6.5 1 .9 1.6-.2-.5-.2-1.3.4-1.8.6-.4 1.3-.3 2 0l-1.6-1.5c.7 0 3.3-.6 4.2-1 1-.4 3.8-2 5.5-3.1-1.4 1.2-4 3.5-4.4 4z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#a05a2c",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m271.4 210.7 98 97.9 1.3-1-98-97.8a6.3 6.3 0 0 0-1.3 1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e7e7e7",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M265.3 204.5c.4.7 1.4 2.5 1 3.8l2-1.5c-.5 1-.4 1.4.1 1.8.3.4 1.4.3 2.1.2-.7.4-1.5.8-2.4 1h-2c.7.3 2.2.8 3.3 1 .5.1 1.6.2 2 0 .6.5 1.9-.4 1.3-1 .3-.3.3-.8.4-1.4 0-.7-.1-1.9-.7-3a8 8 0 0 1-.5 1.7c-.2.5-.7 1-1.1 1.4.2-.5.4-1.2-.1-1.8-.5-.5-1.3-.5-2-.2l1.9-1.3c-.8 0-3.3-1-4.1-1.5a62.3 62.3 0 0 1-4.9-3.8 57 57 0 0 1 3.7 4.6z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#a05a2c",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m253 222.8 125.7 70.9c.2-.3.6-1 .9-1.2l-125.7-71a5.6 5.6 0 0 0-1 1.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e7e7e7",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M245.1 218.3c.6.6 2.2 2 2.2 3.4l1.4-2c-.2 1 .1 1.5.7 1.7.4.4 1.4 0 2-.3a5.1 5.1 0 0 1-2 1.5l-1.8.6c.7.1 2.3.3 3.4.2.6 0 1.6-.2 2-.6.7.4 1.6-.8 1-1.2 0-.4 0-.8-.2-1.4a6.3 6.3 0 0 0-1.6-2.8v1.8c0 .5-.3 1-.5 1.6 0-.5 0-1.3-.7-1.7-.7-.4-1.4-.2-2 .3l1.4-1.7a17 17 0 0 1-4.4-.5 70.5 70.5 0 0 1-6-2.5c1.7 1 4.6 3 5.1 3.6z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#a05a2c",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m263.7 217.5 113 85.2 1-1.1-112.9-85.2a6 6 0 0 0-1.1 1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e7e7e7",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M256.6 212.1c.5.6 1.8 2.3 1.6 3.6l1.7-1.7c-.3 1-.1 1.5.4 1.7.4.4 1.5.2 2.1 0a5.4 5.4 0 0 1-2.2 1.2l-1.9.3c.7.3 2.3.6 3.4.6.5 0 1.6 0 2-.3.6.5 1.7-.6 1.1-1.1.2-.3.1-.8.1-1.4a6 6 0 0 0-1.1-3 7.8 7.8 0 0 1-.2 1.8c-.2.6-.5 1-.9 1.6.2-.5.2-1.3-.4-1.8-.6-.4-1.3-.3-2 0l1.6-1.5a15 15 0 0 1-4.2-1c-1-.4-3.8-2-5.5-3.1 1.4 1.2 4 3.5 4.4 4z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#00e519",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M300.1 283.4c4-2.6 15.1-4 16.7-3.6-8 6-16 6.3-16.7 3.7z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#ffe533",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M300.2 283.5c.7 2.6 8.7 2.4 16.6-3.6a69 69 0 0 1-16.6 3.6z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: 0.1,
      d: "M300.2 283.5c.7 2.6 8.7 2.4 16.6-3.6a69 69 0 0 1-16.6 3.6z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M300.1 283.4a40.6 40.6 0 0 1 16.7-3.6c-8 6-16 6.3-16.7 3.6z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#a05a2c",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M347.6 220.2 322 272.5c-1.3 1-2.3-.3-2.7-.2-1.5 1.7-3.6 2-4 2.5-1.8 2.4-.8 4.3-.7 4.5 1.3 1.8-1.6 3.5-1.5 4-.6 1-2.7.9-3.1 2l-4.8 9.3c-.6.5-3.7 6.1-3.7 6.1-2 0-10.2-5.2-10.4-5.1 4.6-7.3 15.6-18.5 15.3-19.2 3.1-5.2 8-10.9 10.1-10.8 3-1.6 4.5-5.7 4-6.6 2.2 0 3.5-1.4 3.6-1.5l18.8-37.6c1.6-.5 1.4.1 1.9 1 0 0 1-1.2.9-1.3.9-.4 1.8.2 1.8.6z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#cce5e5",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M348.6 208.8c-.6 1 .2 1 .5 1.1l1 .3c1.3 0 2 .7 2 1l-30 61.3c-1.3 1-2.5-.3-2.9-.1l20.6-41.8 10-18.8-2.8-1.2c-.8-.2-1-.8-.7-1.6l12.6-21.6-10.2 21-.1.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e7e7e7",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M348.6 208.8c-.6 1 .2 1 .5 1.1l1 .3c1.3 0 2 .7 2 1l-30 61.3c-1.3 1-2.5-.3-2.9-.1l20.6-41.8 10-18.8-2.8-1.2c-.8-.2-1-.8-.7-1.6l12.6-21.6-10.2 21-.1.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M308.8 272.4c-3 0-4.6 2-2.7 4.7m1.4-2.4c-1 .6-1.7-.3-1.7-.3m15.2-13c-1.5 5.6-4.3 9.3-5 10.4-2 2.2-3.9 7.2-3.5 8.1l-8.1 13.3"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#cce5e5",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M322 272.7c-1.4-.5-5.7-4.5-10-3.8-3.3 3.8-5.3 7.7-5.9 8.2 4 3.3 6.7 5 7.6 5.4.7-.4 1-1.5 1-1.5.9-1-.2-1.7-.2-1.7.2-2.5 2-4.2 3.8-4.3 2.2-.2 1.6-.4 1.9-.4 1-.6 1.8-1.9 1.8-1.9z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M322 272.7c-1.4-.5-5.7-4.5-10-3.8-3.3 3.8-5.3 7.7-5.9 8.2 4 3.3 6.7 5 7.6 5.4.7-.4 1-1.5 1-1.5.9-1-.2-1.7-.2-1.7.2-2.5 2-4.2 3.8-4.3 2.2-.2 1.6-.4 1.9-.4 1-.6 1.8-1.9 1.8-1.9z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#cce5e5",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M317.6 272.8c-2 0-4 .9-4.8 2.6l4.8-2.6"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M317.6 272.8c-2 0-4 .9-4.8 2.6m-3.5.7c.1.4.7.6 1.1.5.6-.2.8-.7.6-1-.2-.5-.7-.7-1.2-.5-.5.1-.7.6-.5 1zm2.5-3.4c.1.4.7.6 1.2.4.5-.1.7-.6.5-1-.2-.4-.7-.6-1.2-.5-.5.2-.7.7-.5 1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#cce5e5",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M345.3 226.1c.8-.2 1.2-1.1.8-2l-4.7-1.7s-.6 0-1 .7c-.5.7.1 1.2.1 1.2l4.8 1.8"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M345.3 226.1c.8-.2 1.2-1.1.8-2l-4.7-1.7s-.6 0-1 .7c-.5.7.1 1.2.1 1.2l4.8 1.8"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#00e519",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M294.5 286c3.9-2.7 15-4.2 16.6-3.8-7.8 6.2-15.8 6.5-16.6 3.9z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#ffe533",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M294.6 286c.7 2.7 8.7 2.3 16.5-3.8a62.4 62.4 0 0 1-16.5 3.9z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: 0.1,
      d: "M294.6 286c.7 2.7 8.7 2.3 16.5-3.8a62.4 62.4 0 0 1-16.5 3.9z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M294.6 286a40 40 0 0 1 16.6-3.9c-7.9 6.2-16 6.6-16.6 4z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#a05a2c",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m340.7 222-24.4 52.8c-1.3 1-2.4-.3-2.7-.2-1.5 1.7-3.6 2.1-4 2.5-1.8 2.5-.7 4.4-.6 4.6 1.3 1.8-1.5 3.5-1.4 4-.6 1-2.7.9-3.1 2.1-.1-.1-4.2 8.4-4.6 9.3-.6.5-3.5 6.2-3.5 6.2-2.1 0-10.3-5-10.5-5 4.4-7.3 15.1-18.7 14.9-19.4 3-5.3 7.7-11 9.9-11 3-1.6 4.3-5.7 3.7-6.6 2.3-.1 3.5-1.5 3.7-1.6l18-37.8c1.6-.6 1.3 0 1.9 1 0 0 1-1.2.9-1.4.9-.4 1.7.2 1.8.6z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m340.7 222-24.4 52.8c-1.3 1-2.4-.3-2.7-.2-1.5 1.7-3.6 2.1-4 2.5-1.8 2.5-.7 4.4-.6 4.6 1.3 1.8-1.5 3.5-1.4 4-.6 1-2.7.9-3.1 2.1-.1-.1-4.2 8.4-4.6 9.3-.6.5-3.5 6.2-3.5 6.2-2.1 0-10.3-5-10.5-5 4.4-7.3 15.1-18.7 14.9-19.4 3-5.3 7.7-11 9.9-11 3-1.6 4.3-5.7 3.7-6.6 2.3-.1 3.5-1.5 3.7-1.6l18-37.8c1.6-.6 1.3 0 1.9 1 0 0 1-1.2.9-1.4.9-.4 1.7.2 1.8.6z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#cce5e5",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M341.4 210.6c-.5 1 .3 1 .6 1.2l1 .3c1.3 0 2 .6 2 1l-28.7 61.7c-1.3 1-2.5-.3-2.9 0l19.7-42.2 9.6-19-2.8-1c-.8-.3-1-.8-.7-1.7l12-21.8-9.6 21.1-.2.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e7e7e7",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M341.4 210.6c-.5 1 .3 1 .6 1.2l1 .3c1.3 0 2 .6 2 1l-28.7 61.7c-1.3 1-2.5-.3-2.9 0l19.7-42.2 9.6-19-2.8-1c-.8-.3-1-.8-.7-1.7l12-21.8-9.6 21.1-.2.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M303 275c-3-.2-4.6 2-2.6 4.6m1.3-2.4c-1 .6-1.7-.3-1.7-.3m15-13.3c-1.5 5.7-4.2 9.4-4.7 10.6-2.2 2.2-3.9 7.3-3.5 8.1l-7.8 13.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#cce5e5",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M316.1 275c-1.3-.5-5.8-4.5-10-3.7-3.3 3.9-5.1 7.8-5.7 8.3a50 50 0 0 0 7.7 5.3c.7-.4 1-1.5 1-1.5.8-1-.2-1.8-.2-1.8 0-2.4 1.8-4.2 3.6-4.3 2.2-.2 1.6-.4 1.9-.4 1-.6 1.7-2 1.7-2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M316.1 275c-1.3-.5-5.8-4.5-10-3.7-3.3 3.9-5.1 7.8-5.7 8.3a50 50 0 0 0 7.7 5.3c.7-.4 1-1.5 1-1.5.8-1-.2-1.8-.2-1.8 0-2.4 1.8-4.2 3.6-4.3 2.2-.2 1.6-.4 1.9-.4 1-.6 1.7-2 1.7-2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#cce5e5",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M311.8 275.1c-2 0-4 1-4.7 2.7l4.7-2.7"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M311.8 275.1c-2 0-4 1-4.7 2.7m-3.6.8c.2.4.7.6 1.2.4.5-.2.7-.6.5-1-.2-.5-.7-.6-1.2-.5-.5.2-.7.6-.5 1zm2.4-3.5c.2.4.8.6 1.3.5.5-.2.7-.7.5-1-.2-.5-.7-.7-1.2-.5-.5.1-.8.6-.6 1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#cce5e5",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M338.5 228c.8-.2 1.1-1.1.7-2l-4.7-1.6s-.5 0-1 .7c-.4.7.2 1.2.2 1.2l4.8 1.8"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M338.5 228c.8-.2 1.1-1.1.7-2l-4.7-1.6s-.5 0-1 .7c-.4.7.2 1.2.2 1.2l4.8 1.8"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#00e519",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M340.6 283.3a39 39 0 0 0-16.8-3.7c8 6.1 16.1 6.3 16.8 3.7z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#ffe533",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M340.6 283.3c-.7 2.7-8.8 2.4-16.8-3.6a63.4 63.4 0 0 0 16.8 3.6z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: 0.1,
      d: "M340.6 283.3c-.7 2.7-8.8 2.4-16.8-3.6a63.4 63.4 0 0 0 16.8 3.6z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M340.6 283.3c-4.2-3-15.8-4-16.9-3.7 8 6 16.2 6.3 16.9 3.6z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#a05a2c",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m292.7 219.3 25.7 52.9c1.3 1 2.4-.3 2.7-.2 1.6 1.7 3.7 2.1 4.2 2.5 1.8 2.4.8 4.4.7 4.6-1.4 1.8 1.5 3.5 1.4 4.1.6 1 2.7.8 3.2 2l4.8 9.3c.7.5 3.7 6.2 3.7 6.2 2.1 0 10.3-5.3 10.5-5.2-4.6-7.3-15.7-18.7-15.4-19.4-3.1-5.2-8.1-11-10.2-10.9-3-1.6-4.5-5.7-4-6.6-2.3 0-3.6-1.5-3.7-1.6l-19-37.9c-1.6-.5-1.3.1-1.9 1 0 0-1-1.2-.9-1.3-.9-.5-1.8.2-1.8.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#cce5e5",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M291.7 207.8c.5 1-.2 1-.5 1.2l-1.1.3c-1.2 0-1.9.7-1.9 1l30.2 61.9c1.3 1 2.5-.3 3-.1l-20.8-42.3-10-19 2.7-1.1c.8-.2 1-.8.7-1.6l-12.7-21.9 10.2 21.2.2.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e7e7e7",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M291.7 207.8c.5 1-.2 1-.5 1.2l-1.1.3c-1.2 0-1.9.7-1.9 1l30.2 61.9c1.3 1 2.5-.3 3-.1l-20.8-42.3-10-19 2.7-1.1c.8-.2 1-.8.7-1.6l-12.7-21.9 10.2 21.2.2.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M331.9 272.1c3 0 4.6 2.1 2.7 4.7m-1.4-2.3c1 .6 1.7-.4 1.7-.4M319.5 261c1.6 5.7 4.4 9.5 5 10.6 2.2 2.2 4 7.3 3.7 8.2l8.1 13.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#cce5e5",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M318.6 272.4c1.3-.4 5.7-4.6 10-3.8 3.4 3.8 5.4 7.7 6 8.2-4 3.4-6.7 5-7.7 5.5-.7-.4-1-1.5-1-1.5-.9-1 .2-1.8.2-1.8-.1-2.4-2-4.2-3.8-4.3-2.3-.2-1.6-.4-2-.4-1-.6-1.7-1.9-1.7-1.9z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M318.6 272.4c1.3-.4 5.7-4.6 10-3.8 3.4 3.8 5.4 7.7 6 8.2-4 3.4-6.7 5-7.7 5.5-.7-.4-1-1.5-1-1.5-.9-1 .2-1.8.2-1.8-.1-2.4-2-4.2-3.8-4.3-2.3-.2-1.6-.4-2-.4-1-.6-1.7-1.9-1.7-1.9z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#cce5e5",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M323 272.5c2 0 4 1 4.8 2.7l-4.8-2.7"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M323 272.5c2 0 4 1 4.8 2.7m3.6.6a1 1 0 0 1-1.2.5.7.7 0 0 1-.5-1c.1-.5.7-.6 1.2-.5.5.2.7.6.5 1zm-2.5-3.4c-.2.4-.8.6-1.3.5-.4-.2-.7-.7-.5-1 .2-.5.7-.7 1.2-.5.5.1.8.6.6 1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#cce5e5",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M295 225.4a1.4 1.4 0 0 1-.8-2l4.8-1.8s.5.1 1 .7c.5.7-.2 1.2-.2 1.2l-4.8 1.9"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M295 225.4a1.4 1.4 0 0 1-.8-2l4.8-1.8s.5.1 1 .7c.5.7-.2 1.2-.2 1.2l-4.8 1.9"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#00e519",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M345.6 286a38 38 0 0 0-16.6-3.8c7.9 6.2 15.9 6.5 16.6 3.9z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#ffe533",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M345.6 286c-.8 2.7-8.7 2.3-16.5-3.8a62.4 62.4 0 0 0 16.5 3.9z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: 0.1,
      d: "M345.6 286c-.8 2.7-8.7 2.3-16.5-3.8a62.4 62.4 0 0 0 16.5 3.9z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M345.6 286a40.1 40.1 0 0 0-16.6-3.9c7.8 6.2 15.9 6.6 16.6 4z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#a05a2c",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m299.5 222 24.4 52.8c1.3 1 2.3-.3 2.7-.2 1.5 1.7 3.6 2.1 4 2.5 1.7 2.5.7 4.4.6 4.6-1.4 1.7 1.5 3.5 1.4 4 .5 1 2.6.9 3 2.1.2-.1 4.2 8.4 4.7 9.3.6.5 3.5 6.2 3.5 6.2 2 0 10.3-5 10.5-5-4.4-7.4-15.2-18.7-15-19.4-2.9-5.3-7.7-11-9.8-11-3-1.6-4.3-5.7-3.7-6.6-2.3-.1-3.6-1.5-3.7-1.6L304 222c-1.6-.6-1.4 0-2 1 0 0-.9-1.2-.8-1.4-.9-.4-1.8.2-1.8.6z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m299.5 222 24.4 52.8c1.3 1 2.3-.3 2.7-.2 1.5 1.7 3.6 2.1 4 2.5 1.7 2.5.7 4.4.6 4.6-1.4 1.7 1.5 3.5 1.4 4 .5 1 2.6.9 3 2.1.2-.1 4.2 8.4 4.7 9.3.6.5 3.5 6.2 3.5 6.2 2 0 10.3-5 10.5-5-4.4-7.4-15.2-18.7-15-19.4-2.9-5.3-7.7-11-9.8-11-3-1.6-4.3-5.7-3.7-6.6-2.3-.1-3.6-1.5-3.7-1.6L304 222c-1.6-.6-1.4 0-2 1 0 0-.9-1.2-.8-1.4-.9-.4-1.8.2-1.8.6z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#cce5e5",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M298.8 210.6c.4 1-.3 1-.6 1.2l-1 .3c-1.3 0-2 .6-2 1l28.7 61.7c1.3 1 2.5-.3 2.9 0L307 232.5l-9.6-19 2.7-1c.9-.3 1.2-.8.8-1.7L288.8 189l9.7 21.1.2.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e7e7e7",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M298.8 210.6c.4 1-.3 1-.6 1.2l-1 .3c-1.3 0-2 .6-2 1l28.7 61.7c1.3 1 2.5-.3 2.9 0L307 232.5l-9.6-19 2.7-1c.9-.3 1.2-.8.8-1.7L288.8 189l9.7 21.1.2.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M337.2 275c3-.2 4.5 2 2.6 4.6m-1.4-2.4c1 .6 1.8-.3 1.8-.3m-15-13.3c1.4 5.7 4.2 9.4 4.7 10.6 2.1 2.2 3.8 7.3 3.5 8.1l7.8 13.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#cce5e5",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M324 275c1.4-.5 5.8-4.5 10.1-3.7 3.2 3.9 5.1 7.8 5.7 8.3a54.1 54.1 0 0 1-7.8 5.3c-.6-.4-1-1.5-1-1.5-.7-1 .3-1.8.3-1.8 0-2.4-1.8-4.2-3.6-4.3-2.3-.2-1.6-.4-2-.4-1-.6-1.7-2-1.7-2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M324 275c1.4-.5 5.8-4.5 10.1-3.7 3.2 3.9 5.1 7.8 5.7 8.3a54.1 54.1 0 0 1-7.8 5.3c-.6-.4-1-1.5-1-1.5-.7-1 .3-1.8.3-1.8 0-2.4-1.8-4.2-3.6-4.3-2.3-.2-1.6-.4-2-.4-1-.6-1.7-2-1.7-2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#cce5e5",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M328.4 275.1c2 0 4 1 4.7 2.7l-4.7-2.7"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M328.4 275.1c2 0 4 1 4.7 2.7m3.6.8a1 1 0 0 1-1.2.4c-.5-.2-.8-.6-.6-1 .2-.5.8-.6 1.3-.5.4.2.7.6.5 1zm-2.5-3.5c-.2.4-.7.6-1.2.5-.5-.2-.7-.7-.5-1 .2-.5.7-.7 1.2-.5.5.1.7.6.5 1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#cce5e5",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M301.6 228c-.8-.2-1-1.1-.7-2l4.7-1.6s.6 0 1 .7c.5.7-.2 1.2-.2 1.2l-4.8 1.8"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M301.6 228c-.8-.2-1-1.1-.7-2l4.7-1.6s.6 0 1 .7c.5.7-.2 1.2-.2 1.2l-4.8 1.8"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#a05a2c",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m315.3 250.7 35.5-38a97.4 97.4 0 0 1-1.4-.9l-35.6 38a7.5 7.5 0 0 0 1.5.9z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e7e7e7",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M349.8 212.2c-1.2-1-3.4-2.2-5-1.8-.5-2.2 2.5-4.4 3.8-4-.3 2.3 3.2 3.8 3.1 3.8z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e7e7e7",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M352.1 210.4c1 .8 1.4.8 2.8 1.6 1.4.7 3.2-1.1 4.1-1.7 0 0 1 3.4-1.1 5.6-2 2.3-4.6 2.8-6.5 2.1 0 0 2.6-2.5 1.5-3.6-1-1.1-1.4-1.2-2.5-1.9"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e7e7e7",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M-27.7-406.5h4.1v2.2h-4.1z",
      transform: "matrix(-.67726 .73575 -.82314 -.56784 0 0)"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m308.2 290.3-1 9 1.8-2.2c.3-.6 1.5-2.1 1.8-7.4 0 0-1-2.9-1.4-2.9-.7-.4-1.2 3.5-1.2 3.5zm2.2-20.1-2.7 15.8c0 .5 1.3 1.6 2.1-1.2l1.5-10.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d52b1e",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M315.9 284.6a8.7 8.7 0 0 1-1.4-2l-.4 3.1s2 1.5 1.7 4.3l.4-.6.2-1s.5-2 .5-3.1c0 0-.5-.2-1-.7z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#ffe000",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M307.3 299.4s3.3-3 3.5-9.7l.4-1.9s0 1.5.8.4c.6-1.5.6-2.8.6-2.8s1.2-1.6 1.6.3l-1.2 9.6a51.4 51.4 0 0 1-.3 2s-.7-1-1.4.1c-.7 1.2-1.8 2.7-4 2zm4-25.1-1.5 10.5s1.2.6 1.4 3c.1 1.2.6.6.8.4.2-.8 0-2.3 0-2.3l.6-7.3s-1.2-3.4-1.3-4.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#ffe000",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m310.1 298.8-.2 2.6s1 0 1.7-1.2c.8-1.1 1-2.8 1-2.8s-.7-1.1-1.3 0c-.5 1-1.2 1.4-1.2 1.4zm1.8-10.6c.6-1 .8-2.6.7-2.8l-.7.5c.2 1.2 0 2.3 0 2.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d52b1e",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M315.3 287.1a4.4 4.4 0 0 0-1.3-1.5l-1.5 12s-.4 3-2.3 3.7c0 0 1.1 10.3 4.5 7.5.4-.4 1-3.6.9-5.5l-.9-6a26.8 26.8 0 0 1 .5-4.7l.6-2.6c.2-.2 0-1.8-.5-2.9z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d52b1e",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m316.9 285.3 1 1c.3 0-2.3 19.3-2.3 19.3s0-2-.7-6c-.6-3.2.2-7.5.9-9.6 0 0 .8-.5 1-4.7z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#f7e214",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m312.6 278.8-.7 7.1s1.8-2.4 2.2-.2l.4-3.2s-1.5-2.4-2-3.7z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M311.3 287.8s-.6-6.1-3.6-1.8a10 10 0 0 0 0 3c0 .8.9 1.8 1.2 2.3.7 1 1.3-.2 1.3-.2s.7-1 1-3.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M287.8 237c-.1-3.5-1.2-9.3-1.3-13.3l-12-12.2s-1.4 9.9-5.8 15.5l19 10"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#ffe000",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M288.7 237.3c.5-2.4 1-5 1.5-10.2l-7.7-7.6c0 3.2-3.6 8.1-3.9 14"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M295.3 244.7c1-4.3-1.3-4.8 2-10.8l-7.2-6.8c-1.3 4-2.2 6.6-2 10l6 4.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M267.6 270c-1.5-4.2.5-12.7.2-18-.1-3.5 2.5-16.7 2.4-20.6l-14.1-8.8s-.6 14.3-2.3 29.9c-1.4 8-1.4 15.3-.4 21.5 1.5 8.7 3 12.2 6.5 15.9 6.3 6.5 19.7 2.7 19.7 2.7 11.3-2.3 17.8-9.4 17.8-9.4s-3.7.8-9.6 1.4c-13-.9-18.2 2.4-18.6-11"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#f7e214",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m305.4 278.8.2-.1-5.9 1.9-8 .6c-17.2.4-15-10.3-14.3-27.5.1-6.6 1.4-14.8 1-17.7l-11.5-6.6c-3.8 10.6-2.6 18-3.3 23.5-.4 6-1.7 17.4.2 22.4 2.7 11.6 11.8 11.2 24.2 10.1 6.1-.5 9.4-2 9.4-2l8-4.6"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007a3d",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M305.6 278.5a34.4 34.4 0 0 1-6 2.2l-8 .8c-12.5 1-19.8-7.7-18.2-27.6 0-7 .2-10.2 2.6-19.5l7 4v.7c-.5 2-1.5 7-1.5 9.2 0 16 10.1 28.2 23.9 30.3h.2"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M260 230.6c1 2 8 12.5 12 14.5m-11-7.6c1.3 2 9.8 14 13.6 14.6m-15.5 3.6c2 2.4 4 7 9.7 10m-7 3.3c4 3.7 13.6 11.6 23 12m-23-6c2 2.3 6.2 13.3 24 8.3m-26.7-6.3c1.2 2.6 10.1 17.3 26 11.6"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M277.8 264.8c-1.5-4.3.5-12.7.2-18.1-.1-3.5 1.5-15.5 1.5-19.5l-13.2-9.9s-.6 14.3-2.3 30a84 84 0 0 0-1.5 23.9c1.8 10 6.6 12.8 7.5 13.6 6.7 6 22 5.4 23.5 4.9 10.8-4 15.6-10.8 15.6-10.8s-5.2-.1-11.1.5c-13-1-19.7-.4-20.1-13.8"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#ffe000",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M315.6 273.5h.2l-5.9 1.8-8 .6c-17.2.5-15-10.2-14.3-27.5.1-6.5.3-12.4 0-15.3l-10.3-7.6c-3.8 10.7-2.8 16.7-3.5 22.2-.4 5.8-1.7 17.3.2 22.3 2.7 11.7 11.8 11.2 24.2 10.2 6.1-.5 9.4-2.1 9.4-2.1l8-4.6"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M315.9 273.4c-2.4 1.2-6 2.1-6 2.1l-8 .8c-12.5 1-19.8-7.7-18.2-27.6 0-7-.3-7.5 2.2-16.9 3.8 2.5 11.1 8.8 11.1 8.8s-2 2.8-1.5 6.7c0 16 6.4 24 20.2 26.1l1.5-13"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M270.1 225.3c1.2 2 8.1 12.6 12 14.6m-10.8-7.7c1.2 2 9.7 14 13.5 14.7m-15.5 3.6c2 2.3 4 7 9.7 10m-7 3.3c4 3.6 13.6 11.6 23 12m-23-6c2 2.3 6.2 13.2 24 8.3m-26.7-6.4c1.2 2.7 10.1 17.3 26 11.7"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m256.2 224-.7 6c-.2 4.4-.1 7.7.1 9.8 0 .2.9 5.5.6 5.8-1 1.1-1.1 1.2-2.2.4-.1-.2.5-5.6.5-6.3l.4-9.9c0-1 1-6.4 1-6.4s0-1.2.3.5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m256.2 224-.7 6c-.2 4.4-.1 7.7.1 9.8l.7 5.8c-1 1.1-1.2 1.6-2.3.7-.1-.2.5-5.9.5-6.6l.4-9.9c0-1 1-6.4 1-6.4s0-1.2.3.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#f7e214",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M256 222.2s-1 6-1.2 9.6l-.3 7.9-.5 4.5c-.1.7.1.2 0 .2-.9.5-1.5.1-2-.3-.2-.1 1.4-3.8 1.4-4.5.9-10.8 2.4-17 2.4-17s-.6 3.7.3-.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M256 222.2s-1 6-1.2 9.6l-.3 7.9-.5 4.5c-.1.7.1.2 0 .2-.9.5-1.5.1-2-.3-.1-.1 1.4-3.8 1.5-4.5.8-10.8 2.3-17.1 2.3-17.1s-.6 3.8.3-.3zm-.4 17.3s-1 .4-1 .2m0-1.3s.7 0 .8-.2m0-1s-.6.3-.8 0m.8-1.6h-.6m.6-1.5h-.6m.5-2.1s-.3.1-.4-.1m.5-1.7h-.5m-.5 9.5s-.9.2-1-.1m1.1-2s-.9.1-1-.1m1-1.3h-.7m.9-1.5h-.7m.7-1.7h-.5m.7-1.5h-.6m.6-1.7s-.4.3-.4 0m0 9s-.9 0-.9-.3m12.8-19.8-.7 6a63.4 63.4 0 0 0 0 9.8c0 .3 1 5.5.7 5.8-1 1.2-1.1 1.3-2.2.4-.1-.1.5-5.5.5-6.3l.4-9.8c0-1.1 1-6.5 1-6.5s0-1.1.3.6"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m266.4 218.7-.7 6a73 73 0 0 0 .1 9.8l.7 5.8c-1 1.2-1.2 1.6-2.3.7-.1-.1.5-5.8.5-6.6l.4-9.8c0-1.1 1-6.5 1-6.5s0-1.1.3.6z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M266.3 217s-1.2 6-1.3 9.5l-.3 8-.5 4.4v.3c-.9.5-1.5 0-2-.4-.2 0 1.4-3.7 1.4-4.5a127 127 0 0 1 2.4-17l.3-.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M266.3 217s-1.2 6-1.3 9.5l-.3 8-.5 4.4v.3c-.9.5-1.5 0-2-.4-.2 0 1.4-3.7 1.4-4.5.9-10.8 2.4-17 2.4-17zm-.5 17.2s-1 .5-1 .2m0-1.2s.7 0 .8-.3m0-1s-.6.4-.8.1m.7-1.7h-.5m.6-1.5h-.6m.5-2s-.4 0-.4-.2m.5-1.7h-.5m-.5 9.6s-.9.1-1-.2m1.1-1.9s-.9 0-1-.2m1-1.3h-.7m.9-1.4h-.7m.7-1.7-.5-.1m.7-1.4-.6-.1m.6-1.6s-.4.2-.4 0m0 9s-.9 0-.9-.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M274.3 211.3s.5 5.1.2 8c-.3 3.5-.3 4.5-.6 6.6v3.9c.8.5 1.5.2 2 0 .3-.1-1-3.3-1-4 .5-8.9-.4-14.3-.4-14.3l-.2-.2"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M274.3 211.3s.5 5.1.2 8c-.3 3.5-.3 4.5-.6 6.6v3.8c0 .5-.1 0 0 .1.8.5 1.4.2 2 0 .2-.1-1-3.3-1-4 .5-9-.4-14.3-.4-14.3zm-.3 14.6s.9.2 1 0m-.8-1.7s.9.2 1 0m-1-1.2h.9m-.8-1.2h.7m-.5-1.4h.5m-.5-1.3h.5m-.4-1.4s.4.2.4 0m-1 7.4s1 .1 1-.1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#005000",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M306 221.7h.8z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M316.7 256.4s-.3-.2-.4 0l.1.2zm-1 1.1 2.1-.1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M292.2 284.2c-.2 3-7.4 6.6-12.7.1-5.7-4.5-4.5-11.4 0-12.3l54.7-53.3c2.2-1.2 2.4-2.3 3.5-3.5 2.3 2.5 7 6.8 9.6 9-1.6 1.2-2.9 2.5-3.2 3.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e7e7e7",
      fillRule: "evenodd",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.1,
      d: "M337.8 215c2.6-3.5 12.8 5.8 10 8.7-2.6 2.8-12.4-5-10-8.6z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#cccccf",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M347 223c-2 1.4-9.3-4.8-8.1-7.2 2-2.2 10.1 5.7 8 7.2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M344 227.9a15.8 15.8 0 0 1-9.9-9m-23 44.8a16.3 16.3 0 0 1-11.4-11.6m9.1 14.3a16.3 16.3 0 0 1-11.4-11.6m-2.1 25.8c-5.8-1.8-10.4-6-12.2-12.1m9.8 14.8a18 18 0 0 1-12.3-12.2"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: 0.1,
      d: "M279.4 285c-.3 1.4-1 1.8-2.1 1.4m13.7-2c-2.1 3.5-4.5 2.4-6.5 2.5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M276.4 285.2c0 1 .8 1.6 1.7 1.6a1.7 1.7 0 0 0 1.7-1.6c0-1-.7-1.6-1.7-1.6s-1.7 1-1.7 1.9"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: 0.1,
      d: "M279.5 284.9c-.3 1.3-1 1.7-2 1.3m13.5-1.7c-2.1 3.4-4.5 2.3-6.5 2.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m331.8 290.3 1 9-1.8-2.2c-.3-.6-1.5-2.1-1.8-7.4 0 0 1-2.9 1.4-2.9.7-.4 1.2 3.5 1.2 3.5zm-2.2-20.1 2.7 15.8c0 .5-1.3 1.6-2.1-1.2l-1.5-10.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d52b1e",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m324.1 284.6 1.4-2 .4 3.1s-2 1.5-1.7 4.3l-.4-.6-.2-1s-.5-2-.5-3.1c0 0 .5-.2 1-.7z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#ffe000",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M332.8 299.4s-3.4-3-3.6-9.7l-.4-1.9s0 1.5-.8.4c-.6-1.5-.6-2.8-.6-2.8s-1.2-1.6-1.6.3l1.2 9.6.3 2s.7-1 1.4.1c.7 1.2 1.8 2.7 4 2zm-4.1-25.1 1.5 10.5s-1.2.6-1.4 3c-.1 1.2-.6.6-.8.4-.2-.8 0-2.3 0-2.3l-.6-7.3s1.2-3.4 1.3-4.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#ffe000",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m329.9 298.8.2 2.6s-1 0-1.7-1.2c-.8-1.1-1-2.8-1-2.8s.7-1.1 1.3 0c.5 1 1.2 1.4 1.2 1.4zm-1.8-10.6a6 6 0 0 1-.7-2.8l.7.5c-.2 1.2 0 2.3 0 2.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d52b1e",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M324.8 287.1a4.4 4.4 0 0 1 1.2-1.5l1.5 12s.4 3 2.3 3.7c0 0-1.1 10.3-4.5 7.5-.4-.4-1-3.6-.9-5.5l.9-6a26.8 26.8 0 0 0-.5-4.7 31 31 0 0 0-.6-2.6c-.2-.2 0-1.8.5-2.9z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d52b1e",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m323.1 285.3-1 1c-.3 0 2.3 19.3 2.3 19.3s0-2 .7-6c.6-3.2-.2-7.5-.9-9.6 0 0-.8-.5-1-4.7z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#f7e214",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m327.4 278.8.7 7.1s-1.8-2.4-2.2-.2l-.4-3.2s1.5-2.4 2-3.7z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M328.7 287.8s.6-6.1 3.6-1.8c0 0 .2 2.4 0 3 0 .8-.9 1.8-1.2 2.3-.7 1-1.3-.2-1.3-.2s-.7-1-1-3.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M352.2 237c.1-3.5 1.2-9.3 1.3-13.3l12-12.2s1.4 9.9 5.8 15.5l-19 10"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#ffe000",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M351.3 237.3c-.5-2.4-1-5-1.5-10.2l7.7-7.6c0 3.2 3.6 8.1 3.9 14"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M344.7 244.7c-1-4.3 1.3-4.8-2-10.8l7.2-6.8c1.3 4 2.2 6.6 2 10l-6 4.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M372.4 270c1.5-4.2-.5-12.7-.2-18 .1-3.5-2.5-16.7-2.4-20.6l14.1-8.8s.6 14.3 2.3 29.9c1.4 8 1.4 15.3.4 21.5-1.5 8.7-3 12.2-6.5 15.9-6.3 6.5-19.7 2.7-19.7 2.7-11.3-2.3-17.8-9.4-17.8-9.4s3.7.8 9.6 1.4c13-.9 18.2 2.4 18.6-11"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#f7e214",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m334.6 278.8-.2-.1 5.9 1.9 8 .6c17.2.4 15-10.3 14.3-27.5-.1-6.6-1.4-14.8-1-17.7l11.5-6.6c3.8 10.6 2.6 18 3.3 23.5.4 6 1.7 17.4-.2 22.4-2.7 11.6-11.8 11.2-24.2 10.1-6.1-.5-9.4-2-9.4-2l-8-4.6"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007a3d",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M334.4 278.5a34.4 34.4 0 0 0 6 2.2l8 .8c12.5 1 19.8-7.7 18.2-27.6 0-7-.2-10.2-2.6-19.5l-7 4v.7c.5 2 1.5 7 1.5 9.2 0 16-10.1 28.2-23.9 30.3h-.2"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M380 230.6c-1 2-8 12.5-12 14.5m11-7.6c-1.3 2-9.8 14-13.6 14.6m15.5 3.6c-2 2.4-4 7-9.7 10m7 3.3c-4 3.7-13.6 11.6-23 12m23-6c-2 2.3-6.2 13.3-24 8.3m26.7-6.3c-1.2 2.6-10.1 17.3-26 11.6"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M362.3 264.8c1.4-4.3-.6-12.7-.4-18.1.2-3.5-1.4-15.5-1.4-19.5l13.2-9.9s.6 14.3 2.3 30a84 84 0 0 1 1.5 23.9c-1.8 10-6.6 12.8-7.5 13.6-6.7 6-22 5.4-23.5 4.9-10.8-4-15.6-10.8-15.6-10.8s5.2-.1 11.1.5c13-1 19.7-.4 20.1-13.8"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#ffe000",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M324.4 273.5h-.2l5.9 1.8 8 .6c17.2.5 15-10.2 14.3-27.5-.1-6.5-.3-12.4 0-15.3l10.3-7.6c3.8 10.7 2.8 16.7 3.5 22.2.4 5.8 1.7 17.3-.2 22.3-2.7 11.7-11.8 11.2-24.2 10.2-6.1-.5-9.4-2.1-9.4-2.1l-8-4.6"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M324.1 273.4a34.4 34.4 0 0 0 6 2.1l8 .8c12.5 1 19.8-7.7 18.2-27.6 0-7 .3-7.5-2.2-16.9-3.8 2.5-11.1 8.8-11.1 8.8s2 2.8 1.5 6.7c0 16-6.4 24-20.2 26.1l-1.5-13"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M369.9 225.3c-1.2 2-8.1 12.6-12 14.6m10.8-7.7c-1.2 2-9.7 14-13.5 14.7m15.5 3.6c-2 2.3-4 7-9.7 10m7 3.3c-4 3.6-13.6 11.6-23 12m23-6c-2 2.3-6.2 13.2-24 8.3m26.7-6.4c-1.2 2.7-10.1 17.3-26 11.7"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#f7e214",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m383.8 224 .7 6c.2 4.4.1 7.7-.1 9.8 0 .2-.8 5.5-.6 5.8 1 1.1 1.1 1.2 2.2.4.1-.2-.5-5.6-.5-6.3l-.4-9.9c0-1-1-6.4-1-6.4s0-1.2-.3.5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m383.8 224 .7 6c.2 4.4.1 7.7-.1 9.8l-.7 5.8c1 1.1 1.2 1.6 2.3.7.1-.2-.5-5.9-.5-6.6l-.4-9.9c0-1-1-6.4-1-6.4s0-1.2-.3.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#f7e214",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M384 222.2s1 6 1.2 9.6l.3 7.9.5 4.5c.1.7 0 .2 0 .2.9.5 1.5.1 2-.3.2-.1-1.4-3.8-1.4-4.5-.9-10.8-2.4-17-2.4-17s.6 3.7-.3-.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M384 222.2s1 6 1.2 9.6l.3 7.9.5 4.5c.1.7-.1.2 0 .2.9.5 1.5.1 2-.3.2-.1-1.4-3.8-1.4-4.5-.9-10.8-2.4-17.1-2.4-17.1s.6 3.8-.3-.3zm.4 17.3s1 .4 1 .2m0-1.3s-.7 0-.8-.2m0-1s.6.3.8 0m-.7-1.6h.5m-.6-1.5h.6m-.5-2.1s.4.1.4-.1m-.5-1.7h.5m.5 9.5s.9.2 1-.1m-1.1-2s.9.1 1-.1m-1-1.3h.7m-.9-1.5h.7m-.7-1.7h.5m-.7-1.5h.6m-.6-1.7s.4.3.4 0m0 9s.9 0 .9-.3"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#f7e214",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m373.6 218.7.7 6a73 73 0 0 1-.1 9.8c0 .3-.8 5.5-.6 5.8 1 1.2 1.1 1.3 2.2.4.1-.1-.5-5.5-.5-6.3l-.4-9.8c0-1.1-1-6.5-1-6.5s0-1.1-.3.6"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m373.6 218.7.7 6a73 73 0 0 1-.1 9.8l-.7 5.8c1 1.2 1.2 1.6 2.3.7.1-.1-.5-5.8-.5-6.6l-.4-9.8c0-1.1-1-6.5-1-6.5s0-1.1-.3.6z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#f7e214",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M373.7 217s1.2 6 1.3 9.5l.3 8 .5 4.4v.3c.9.5 1.5 0 2-.4.2 0-1.4-3.7-1.4-4.5a127 127 0 0 0-2.4-17l-.3-.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M373.7 217s1.2 6 1.3 9.5l.3 8 .5 4.4v.3c.9.5 1.5 0 2-.4.2 0-1.4-3.7-1.4-4.5-.9-10.8-2.4-17-2.4-17zm.5 17.2s1 .5 1 .2m0-1.2s-.7 0-.8-.3m0-1s.6.4.8.1m-.7-1.7h.5m-.6-1.5h.6m-.5-2s.4 0 .4-.2m-.5-1.7h.5m.5 9.6s.9.1 1-.2m-1.1-1.9s.9 0 1-.2m-1-1.3h.7m-.9-1.4h.7m-.7-1.7.5-.1m-.7-1.4.6-.1m-.6-1.6s.4.2.4 0m0 9s.9 0 .9-.4m-10.5-22s-.5 5.2-.2 8.1c.3 3.5.3 4.5.6 6.6v3.9c-.8.5-1.4.2-2 0-.2-.1 1-3.3 1-4-.5-8.9.4-14.3.4-14.3l.2-.2"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M365.7 211.3s-.5 5.1-.2 8c.3 3.5.3 4.5.6 6.6v3.8c0 .5.1 0 0 .1-.8.5-1.4.2-2 0-.2-.1 1-3.3 1-4-.5-9 .4-14.3.4-14.3zm.3 14.6s-.9.2-1 0m.8-1.7s-.9.2-1 0m1-1.2h-.9m.8-1.2h-.7m.5-1.4h-.5m.5-1.3h-.5m.4-1.4s-.4.2-.4 0m1 7.4s-1 .1-1-.1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#005000",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M334 221.7h-.8z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M323.3 256.4s.3-.2.4 0l-.1.2zm1 1.1-2.1-.1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M291.7 215.5c0-2.1 2-3.3 2.2-3.6 1-.6 1.7-1.2 3.7-1.5l.2.9c0 .3-.5 1.6-2 2.7a11.5 11.5 0 0 1-4.1 1.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#a05a2c",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m291.6 214.7 29.7 38.4 1.4-1.3-30.2-39.1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M291.2 207.2s3.2-.4 2.8-2.2c-.5-1.8-2.6-1.8-3.5-1.9-1 0-4 .7-4.8 1.5-.9 1-2.7 2.5-2.1 5s1.3 4.4 2.3 6c.9 1.6.7 3.2.4 3.9 0 .3-.4 1.3.4 1.6 1.2.5 1.5.5 2.5-.6s2.5-3 2.5-5c0-2.1 2-3.3 2.2-3.6 1-.6 1.7-1.2 3.7-1.5 0 0-.7-1.2-1.8-1-1.1 0-3.4-1-4.6-2.2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M291.2 207.2s3.2-.4 2.8-2.2c-.5-1.8-2.6-1.8-3.5-1.9-1 0-4 .7-4.8 1.5-.9 1-2.7 2.5-2.1 5s1.3 4.4 2.3 6c.9 1.6.7 3.2.4 3.9 0 .3-.4 1.3.4 1.6 1.2.5 1.5.5 2.5-.6s2.5-3 2.5-5c0-2.1 2-3.3 2.2-3.6 1-.6 1.7-1.2 3.7-1.5 0 0-.7-1.2-1.8-1-1.1 0-3.4-1-4.6-2.2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M291.2 207.2c-.4 0-1.7-.6-2.6-.3-.9.4-2.7 1.4-2.4 3m10.4-.3s-1.8.8-3.1 1.7c-.6.3-2.4 2-3.5 3.2-1 1-1.3 2.4-3.5 3.9m9-9-1.4 1c-.7.3-.9.9-1.2 1.3"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M347.8 284.2c.2 3 7.4 6.6 12.7.1 5.7-4.5 4.5-11.4 0-12.3l-54.7-53.3c-2.2-1.2-2.4-2.3-3.5-3.5a133 133 0 0 1-9.6 9 9.9 9.9 0 0 1 3.2 3.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e7e7e7",
      fillRule: "evenodd",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.1,
      d: "M302.2 215c-2.6-3.5-12.8 5.8-10 8.7 2.6 2.8 12.4-5 10-8.6z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#cccccf",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M293 223c2 1.4 9.3-4.8 8.1-7.2-2-2.2-10.1 5.7-8 7.2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M296 227.9a16 16 0 0 0 9.9-9m23 44.8c5.7-1.7 9.6-5.5 11.4-11.6m-9.1 14.3c5.7-1.8 9.7-5.5 11.4-11.6m2.1 25.8c5.8-1.8 10.4-6 12.2-12.1m-9.8 14.8a18 18 0 0 0 12.3-12.2"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: 0.1,
      d: "M360.6 285c.3 1.4 1 1.8 2.1 1.4m-13.7-2c2.1 3.5 4.5 2.4 6.5 2.5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M363.6 285.2c0 1-.8 1.6-1.7 1.6a1.7 1.7 0 0 1-1.7-1.6c0-1 .7-1.6 1.7-1.6s1.7 1 1.7 1.9"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: 0.1,
      d: "M360.5 284.9c.3 1.3 1 1.7 2 1.3m-13.5-1.7c2.1 3.4 4.5 2.3 6.5 2.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M339.6 175.5c1.8 2.9 4.4 8 5.2 12a22.5 22.5 0 0 1-7 20.8c-5.2 4.7-13.3 6-16.7 6.8-3.3.7-5.7 1.8-6.3 2.5 0-.5 0-1 .5-1.6 1.6-.7 4.1-1 7.8-1.8 7.2-1.5 14.8-4.2 19-12.2 5.4-10.3 2.2-18.4-2.5-26.4z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M341.6 206.2a.4.6 49.9 0 1-.6-.6.4.6 49.9 1 1 .6.6z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M346.6 205c-1.1.6-2.2.7-3 1a65.7 65.7 0 0 0-3.7 1.4c-.8.3-1.6 1.3-1.6 1.3s1.2 1.3 2.6 1.1c1.2-.1 1.7-.4 2.3-.7.6-.3.6-.6 1.4-1.2 1-.7 1.6-2 2-3zm-5.7 1.1c-.3.6-1.1.5-1.6.5l-.2.2c.6 0 1.5 0 2-.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M346.6 205c-1 1-2.8 2-4.7 2.8a14 14 0 0 1-5 1l-.2.3c1.4-.1 3.4-.4 5-1.1a14.9 14.9 0 0 0 4.9-3zm-2.4 4.6c-2-.1-3 .5-4.8.9-1.7.4-3.7-.5-4.8 1.1 4.4 2.9 7.6 1 9.6-2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M340.2 213.6c-.8-.8-8-3.2-9.2-.5 1.7 2 6.8 2.4 9.2.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m338.5 215.5-2.5-.4c-1-.1-1.3-.3-1.9-.4-1-.1-2.3-1.6-6-.5 1.4 3.4 6.4 4 10.4 1.3zm1.6-1.9c-3.8.8-8.3 0-10.1-1l-.3.2a16.3 16.3 0 0 0 10.4.8zm4-4c-2.2 1.5-5.2 2.6-11.4 1.8v.2c8.5.7 9.3-.8 11.4-2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M338.5 215.5c-3 .1-4.7 1.4-10.3-1.3l-1.4-.6-.5.2 1.4.4c7 3 6.8 1.6 10.8 1.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M327.3 211.6a.4.6 66.2 1 0 .4.7.4.6 66.2 0 0-.4-.7z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M327.1 212.3c-.6.1-.8.9-.8 1.3l-.4.2c.2-.6.4-1.4 1.2-1.7z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M346 186.8a.4.6 15.8 1 1-1-.2.4.6 15.8 0 1 1 .2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M341.6 203.2c-.1-2.1-1.1.8-3.2-3.9-.6-1.4-.6-2.2-1-4.3 1.2 1.8 3 2.3 3.8 3.6.7 1.4.5 3.5.4 4.6z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M337.5 195.2s1 2.4 2.4 4a7.9 7.9 0 0 1 1.8 3.7"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M338.5 197.2c1.3 1.7 3 3.8 3 6h.3c-.3-2.8-2-4.1-3-5.6zm10.8 2.7c-1 .7-2 1-2.7 1.4l-1.4.9c-.4.2-1 .2-1.4.5-.7.5-2 2-2 2s1.3 1.1 2 1c2.4-.5 3.1-1.4 4.3-2.3 1-.8 1-2.5 1.2-3.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m340.7 204.8-.2.4c1.3-.2 3.5-1.5 5-2.2 1.8-1 3-1.7 3.7-3a8.9 8.9 0 0 1-3.9 3c-1.5.7-3.7 2-4.6 1.8zm9.4-9.5c-.8.9-1.7 1.3-2.4 1.8l-1.3 1.1-1.2.8c-.6.6-1.5 2.2-1.5 2.2s.7.7 1.4.4c2.4-.3 3.1-1.4 4-3.5.5-1 1-1.8 1-2.8z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M341.5 199.4a.6.4 62 1 0 .8-.3.6.4 62 0 0-.8.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m342.5 201.6-.2.3c2.9-1.3 6.6-3.9 7.8-6.5a17.2 17.2 0 0 1-7.6 6.2zm8.3-10.7c-.7 1-1.6 1.4-2.2 2l-1 1.1-1.2.9c-.5.6-1.2 2.2-1.2 2.2s.8.9 1.5.5a12 12 0 0 0 2.1-1.6c.5-.4.6-1.4 1.2-2.2.7-1 .8-1.9.8-2.9z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M348.7 193.8c-1.4 1.6-3 3.1-4.6 3.8l-.2.4c2.6-1.5 3.7-2.8 4.9-4.1zm1-5.6c-.4 1-1 1.5-1.6 2l-.8 1.2-1 .9-.7 2.1s.6.6 1.2.2a12 12 0 0 0 1.8-1.6c.4-.5.6-1.4 1-2.2a4 4 0 0 0 .2-2.6zm-4.3-1.1-.5 1.6v-.4c0-.4.2-.9.4-1.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M348.4 191a13 13 0 0 1-3.8 4v.3c2.2-1.6 3-3 3.8-4.2zm-5.6 10c-.2-.6-.3-1-.6-1.4.2.5.4 1 .4 1.6l.1-.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M341.9 181.3a.4.3 39.5 0 1-.5.5.4.3 39.5 0 1 .5-.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m343.1 182.5-1.2-.8 1.3 1v-.2zm5.6.4c-1.2 2.4-3.9 4-2.8 7.5 2.8 2.6 3-4.5 2.8-7.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M346.1 177.7c-.5 2.4-2.6 4.4-1.2 7.6 4 1 2-4.3 1.2-7.6z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M343.7 174c2 3.7 2.5 5.9.2 8.3 0 0-1.3-1.1-1.6-3.3-.2-1.8 1.2-4 1.4-5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M340.4 171.8c.5 2.4-1.5 3.5 1.4 6.5 2.1-2.4 1.1-3-1.4-6.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M339.6 176c-3.3.3-2-2.6-3-5.3 2 1.5 4.7 2.1 3 5.3zm2.2 4.4c-1-4.4-4-2.6-5.6-4.6.9 2.9 2.1 4.8 5.6 4.6zm1.4 4.1c-2.6-.1-4.8-1.4-6.2-4.4 2.7 1.2 5.7 1.4 6.2 4.4z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M343.6 188.3c-1-1.2-1-2-1.5-2.7a9 9 0 0 0-3-3.7c0 3 .4 6.5 4.5 6.4z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M344.2 191.6a20 20 0 0 0-5.6-5.7c1 2.2.6 6.3 5.6 5.7z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M343.7 196c-5-.1-4.5-4.8-4.5-7 .9 1.4 2 2.5 2.8 3.5.9 1 1.8 2.2 1.7 3.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M343.1 198.8c-.4-1 0-1.4-1-2.3-1-1-2.8-2.7-3.7-4.6-.1 1.7-.2 4.4 1.2 5.3 1 .7 2 .9 3.5 1.6zm-4.3 7.3c-3.9-3-1.6-5.6-1.2-7.9 1 2.6 3.7 4.8 1.2 7.9zm1.6-29.2c-1.3-2.3-2-3.6-3.7-6 2 2.7 2.8 4.5 3.9 6.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M338.9 206.8c.1-3-.7-5.7-1.3-8.5.5 3 1.3 6 1 8.8zm4.6-7.4c-.4-1.8-4.1-3-5-7.5.7 4.4 4.5 5.5 4.8 8zm.8-2.5-.1.5c-.6-3-4-4.4-5-8.4 1.5 4.3 4.3 4.9 5.1 7.9zm.7-4.4c-1.7-2.6-4.1-3.6-6.4-6.7 2.1 3 4.8 4.4 6.4 7zm0-3.5c-2-.8-3.9-3-6-7.1 1.4 3 3 5.8 6 7.6zm-1-4c-2.1-1.7-5-2.8-7-4.9 1.7 2 5 3.3 7.1 5.2v-.3zm-1.6-4.3c-2.2-1.5-4.4-2-6.2-4.8 1.5 2.8 3.8 3.5 6.3 5zm6.3 2.2c-.8 3.1-1.5 6.3-3.6 8.4v-.4c1-.5 2.5-3.7 3.6-8zm-2.6-5.1c-.1 3.2 0 6.5-1.7 8.3l-.1-.3c1.6-1.4 1.5-5 1.8-8zm-2.2-3.6c.5 2.8.6 5.3-.2 9.5l-.1-.3c.4-2.4 1-5 .3-9.2zm-3.4-2.3c1.1 2.4 2 4.8 1.2 7.4l-.2-.3c.9-2.4-.1-4.7-1-7zm-4.4 31.2c1.4 3.2-.4 5.6-2.5 7-1.6-4.7 1.8-4.2 2.5-7z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M336.2 203.1c.2 2-2 4.2-2.6 7.6l-.3.2c1-4 3-5.6 2.9-7.8z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M343.7 181.2a.3.4 1.9 1 1-.6-.1.3.4 1.9 0 1 .6.1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M343.5 183v-1.6h-.2v1.7z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M342.8 180.9a.3.4 2 0 1-.5.2.3.4 2 0 1 .5-.2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m343.2 182.3-.5-1.1.4 1.4v-.2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M344.7 186.9a.4.3 80.5 1 1-.7 0 .4.3 80.5 0 1 .7 0z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M344.9 188.6a9.3 9.3 0 0 0-.4-1.4h-.1l.4 1.6v-.2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M343.6 187.2a.4.3 57 1 1-.5.5.4.3 57 0 1 .5-.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M344.8 188.6a8.8 8.8 0 0 0-1.2-1v.1l1.3 1.1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M343.4 199.1a.3.4 12.7 1 1-.7-.2.3.4 12.7 0 1 .7.2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M342.8 200.8c.2-.5.2-1 .2-1.5a9 9 0 0 1-.4 1.7z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M344 199.9a.3.4 50.5 1 0 .5.4.3.4 50.5 1 0-.5-.4z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m342.7 201 1.3-.8v.1a8.7 8.7 0 0 0-1.3 1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M340.7 205a.3.4 40.4 1 1-.4-.6.3.4 40.4 0 1 .4.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m339.5 206.2.9-1.3h-.1l-1 1.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M338.8 204.5a.5.6 10 0 0 1 .1.5.6 10 1 0-1 0z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M339.4 205c-.3.7 0 1 0 1.2l-.1.3c-.2-.4-.3-.8-.1-1.5zm-12.1 9.5c-.7 0-1-.4-1.3-.8h-.3c.4.5.8 1 1.5 1v-.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M327.3 215.2a.6.4 9.5 0 1 .2-.9.6.4 9.5 1 1-.2.8z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M332.7 206a5.5 5.5 0 0 1-4 6.4c-.9-4 2.8-4 4-6.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M332.7 206.1a21 21 0 0 1-4.8 7.2h-.5c2.7-2.1 4.2-4.9 5.3-7.2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M327.8 213.3a.5.4 9.8 1 1-.4-.7.5.4 9.8 0 1 .4.7z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M326 213.8a8 8 0 0 0 1.4-.7h-.1l-1.7.6h.3zm2.5-5c0 1.2-1 2.4-2 3.2-.9.9-1 1.2-2.2 1.6-1.2-2.8 2.8-3.3 4.2-4.8z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M328.5 208.8c-1.3 2.5-3.5 3.8-4.7 5.4h-.1c1.6-2.2 3-2.7 4.8-5.4z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M300.4 175.5c-1.7 2.9-4.4 8-5.1 12a22.5 22.5 0 0 0 7 20.8c5.2 4.7 13.3 6 16.6 6.8 3.4.7 5.8 1.8 6.4 2.5 0-.5 0-1-.5-1.6-1.6-.7-4.2-1-7.8-1.8-7.2-1.5-14.9-4.2-19-12.2-5.4-10.3-2.2-18.4 2.5-26.4z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M314.1 213.6c-.2.4-4 3.7-7.5 3.5-2.5-.2-2.9-.8-2.9-.8s-.2-.7 2-1.1c2.3-.5 6.2-2 8.4-1.6z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M303.8 216.3c2.7.3 5.5-.8 7.7-1.6"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M311.2 208.7a11 11 0 0 1 4.6 3.7c.9 1.5.7 1.9.7 1.9s-.2.3-1.3-1c-1-1.2-3.4-3.3-4-4.6z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M316.5 214.2c-.9-1.7-2.5-3-3.7-4.2"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M300.3 175.8c-.1-.3.3-3.4 2-4.4 1.3-.7 1.8-.5 1.8-.5s.3.3-.5 1.3c-1 1-2.1 3.2-3.3 3.7z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M304 171c-1.4.7-2.3 2.2-3 3.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M299.4 177.4c-.2-.2-1-3-.2-4.7.5-1.3.9-1.4.9-1.4s.3 0 .1 1.3c-.2 1.3-.2 3.8-.8 4.8z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M300 171.4c-.6 1.3-.6 3-.6 4.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M299.4 177.5c.2 0 2.7-.8 3.9-2.1.8-1 .8-1.3.8-1.3s-.2-.2-1.1.5c-1 .8-3 2-3.6 2.9z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M304 174.1c-.9 1.1-2.2 2-3.3 2.6"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M298.2 179.6a10 10 0 0 1-.9-5.2c.3-1.6.6-1.7.6-1.7s.4 0 .4 1.4c0 1.5.3 4.2-.1 5.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M298 172.7c-.5 1.7-.2 3.6 0 5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M297.3 181.6c-.3-.2-2.3-3-2-5.2 0-1.7.5-2 .5-2s.3-.1.6 1.4c.3 1.6 1.2 4.3.9 5.8z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M295.7 174.5c-.2 1.8.5 3.7 1 5.2"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M296.2 184.1a9.9 9.9 0 0 1-2.4-4.7c-.2-1.5 0-1.8 0-1.8s.4-.1.8 1.3c.4 1.4 1.6 3.9 1.6 5.2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M293.9 177.7c.1 1.7 1 3.4 1.5 4.8"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M298.2 179.6c.3 0 3.2-.2 4.6-1.7 1-1 1-1.5 1-1.5s-.2-.3-1.4.4c-1.1.8-3.4 1.8-4.2 2.8z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M303.7 176.5c-1 1.2-2.7 1.9-4 2.5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M297.3 181.6c.2 0 3.2 0 4.6-1.4 1.1-1 1-1.4 1-1.4s0-.3-1.2.3c-1.2.7-3.6 1.5-4.4 2.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M303 178.9c-1.2 1-2.8 1.7-4.1 2.2"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M296.4 184.2c.2 0 3.4-.2 4.9-1.7 1-1.1 1-1.5 1-1.5s-.1-.4-1.4.3c-1.2.8-3.7 1.8-4.5 2.9z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M302.3 181c-1.2 1.3-2.9 2-4.3 2.5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M296.8 183s-.3-.5-.3-1c0-.6.2-.8.2-.8l-.2-.2-.1.9v.3l-.5-.5a10.8 10.8 0 0 1-.1-.4h-.2l.3.7c.5.4.8 1.1.8 1.1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M295.6 180.3a.5.4 83.5 1 1 .1 1 .5.4 83.5 1 1-.1-1z",
      overflow: "visible",
      style: {
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx100("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M296.8 180.3a.4.5 19.3 1 1-.3 1 .4.5 19.3 1 1 .3-1z",
      overflow: "visible",
      style: {
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m296.7 183 1-.7c.3-.4.3-.7.3-.7h.2l-.4.8-.2.2.6-.1.4-.2.1.1-.6.4c-.6 0-1.3.3-1.3.3"
    }),
    /* @__PURE__ */ jsx100("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M299.4 181.6a.4.5 45.6 1 0-.8.8.4.5 45.6 1 0 .8-.8z",
      overflow: "visible",
      style: {
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx100("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M298.4 180.8a.4.5 19.8 1 0-.3 1 .4.5 19.8 1 0 .3-1z",
      overflow: "visible",
      style: {
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M295.4 186.9c-.2-.2-2.4-2.6-2.8-4.8-.3-1.6 0-1.9 0-1.9s.3-.1.8 1.3c.6 1.5 2 4 2 5.4z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M292.6 180.3c.2 1.8 1.2 3.5 2 4.9"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M295.6 186.9c.3 0 3.5-.4 5-2 1-1.3 1-1.7 1-1.7s-.2-.4-1.4.5-3.8 2-4.6 3.2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M301.5 183.2c-1 1.4-2.8 2.2-4.2 3"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M295.2 189.6c.3 0 3.5-.9 5-2.6 1.1-1.3 1-1.7 1-1.7s-.1-.2-1.4.7c-1.2 1-3.8 2.5-4.6 3.6z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M301.2 185.4c-1.1 1.4-3 2.4-4.3 3.2"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M295 189.6c-.3 0-3.3-2.2-3.8-4.5-.3-1.7 0-2 0-2s.5-.3 1.2 1.2c.7 1.4 2.5 3.8 2.7 5.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M291.3 183.2c.3 1.8 1.5 3.5 2.5 4.8"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M295.2 193a11 11 0 0 0 4.6-3.6c.9-1.5.7-1.8.7-1.8s-.2-.3-1.3 1c-1 1.2-3.4 3.1-4 4.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M300.5 187.7c-1 1.6-2.5 3-3.8 4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M295 193.2c-.3 0-3.6-1.7-4.4-4-.7-1.6-.4-2-.4-2s.4-.4 1.3 1c1 1.3 3.1 3.5 3.5 5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M290.3 187.2c.5 1.8 2 3.4 3.2 4.6"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M295 191.6s-.4-.5-.5-1c-.2-.6 0-.9 0-.9h-.3v.8l.2.4-.6-.4-.3-.5-.2.2.5.6c.6.2 1.1 1 1.1 1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M293 189a.6.4 69.4 1 1 .4 1.2.6.4 69.4 1 1-.4-1.1z",
      overflow: "visible",
      style: {
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx100("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M294.3 188.7a.4.6 5.2 1 1 0 1.2.4.6 5.2 1 1 0-1.2z",
      overflow: "visible",
      style: {
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M295 191.6s.6-.5.8-1c.3-.5.2-.8.2-.8h.3l-.3.8-.1.4.6-.3.4-.4.1.2-.6.5c-.6.1-1.2.7-1.2.7"
    }),
    /* @__PURE__ */ jsx100("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M297.5 189.4a.4.6 31.5 1 0-.6 1 .4.6 31.5 1 0 .6-1z",
      overflow: "visible",
      style: {
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx100("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M296.3 188.9a.4.6 5.7 1 0-.1 1.1.4.6 5.7 1 0 0-1.1z",
      overflow: "visible",
      style: {
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M295.4 196.2a12 12 0 0 1-5.1-4c-1-1.7-.8-2.1-.8-2.1s.2-.3 1.4 1c1.3 1.4 3.8 3.6 4.5 5.1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M289.5 190.2c1 1.8 2.8 3.3 4.2 4.6"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M295.6 196.2c.4 0 4-1.9 5-4.4.6-1.8.3-2.3.3-2.3s-.4-.3-1.4 1.2c-1 1.4-3.4 3.8-3.9 5.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M300.9 189.6c-.7 2-2.3 3.7-3.6 5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M296.6 199.3c.3-.1 3.7-2.3 4.5-4.8.7-1.9.4-2.3.4-2.3s-.4-.3-1.3 1.3c-1 1.5-3.2 4-3.6 5.7z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M301.5 192.3c-.7 2-2.2 3.8-3.4 5.2"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M296.3 199.3c-.4 0-4.7-1.3-6.2-3.8-1-2-.9-2.5-.9-2.5s.4-.4 1.8 1c1.5 1.4 4.5 3.5 5.3 5.2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M289.3 193.1c1.1 2 3.3 3.6 5 4.8"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M300.1 205.7c.3-.2 2.6-3 2.8-5.6.2-1.8-.2-2-.2-2s-.3-.2-.8 1.4c-.5 1.7-1.8 4.6-1.8 6.2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M302.8 198.1c-.1 2-1 4-1.8 5.6"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M300 205.6c-.5.2-5.4 0-7.7-2.1-1.6-1.6-1.5-2.2-1.5-2.2s.2-.5 2.1.5c2 1 5.7 2.3 7 3.8z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M290.9 201.4c1.7 1.7 4.4 2.6 6.5 3.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M298.2 203c-.4.1-4.8-1-6.8-3.1-1.6-1.6-1.5-2.1-1.5-2.1s.2-.4 2 .8c1.6 1.2 5 3 6.3 4.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M290 197.9c1.6 1.7 4 3 5.8 4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M298.4 203c.4-.2 3.6-2.9 4-5.6.2-2-.2-2.5-.2-2.5s-.5-.2-1.2 1.5c-.7 1.8-2.6 4.7-2.6 6.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M302.2 195c-.2 2.2-1.5 4.3-2.5 6"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m297.4 201.5-1-.8c-.4-.5-.5-.9-.5-.9h-.3a8 8 0 0 0 .8 1.2l-.8-.1-.5-.3v.2l.7.4c.7 0 1.6.5 1.6.5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M294.2 199.8a.7.5 45.9 1 1 1 1 .7.5 45.9 1 1-1-1z",
      overflow: "visible",
      style: {
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx100("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M295.4 198.8a.7.5 71.6 1 1 .4 1.3.7.5 71.6 1 1-.4-1.3z",
      overflow: "visible",
      style: {
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M297.5 201.4s.4-.6.4-1.3l-.1-1h.2a7.8 7.8 0 0 0 .1 1.3l.6-.5.2-.6.2.1-.4.8c-.6.5-1 1.4-1 1.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M299.1 198.2a.5.7 8 1 0-.2 1.3.5.7 8 1 0 .2-1.3z",
      overflow: "visible",
      style: {
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx100("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M297.6 198.1a.7.5 72.2 1 0 .4 1.3.7.5 72.2 1 0-.4-1.3z",
      overflow: "visible",
      style: {
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M301.8 207.6c-.3.2-4.3 1-6.8-.3-1.8-.9-2-1.4-2-1.4s0-.5 2 0c1.8.4 5.2.7 6.8 1.7z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M293.1 206c2 1 4.4 1.2 6.3 1.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M302 207.5c.2-.1 2-2.5 1.9-4.8 0-1.7-.4-2-.4-2s-.3-.2-.6 1.3c-.2 1.5-1 4-.9 5.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M303.5 200.8c.2 1.8-.4 3.6-.9 5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M305.5 210.3c-.3.3-5 1.5-8 .3-2-1-2.1-1.5-2.1-1.5s0-.5 2.2-.1c2.1.3 6.2.4 8 1.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M295.5 209.2c2.2 1 5 1 7.3 1.1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M305.8 210.3c.2-.3 1.2-3.8 0-5.6-1-1.4-1.5-1.3-1.5-1.3s-.4 0 0 1.5c.3 1.5.5 4.3 1.5 5.4z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M304.4 203.4c1 1.4 1.1 3.4 1.3 5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M303.3 208.7s-.5.4-1.2 0c-.6-.3-.8-.7-.8-.7l-.3.2 1 .7.3.2-.9.2-.6-.1v.3h1a13.6 13.6 0 0 0 1.5-.5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M299.5 208.7a.8.5 24.1 1 1 1.4.7.8.5 24.1 1 1-1.4-.7z",
      overflow: "visible",
      style: {
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx100("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M300.3 207.2a.8.5 49.9 1 1 1 1.2.8.5 49.9 1 1-1-1.2z",
      overflow: "visible",
      style: {
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M303.4 209s.6-.5.2-1.2l-.6-.9.1-.2.7 1 .2.3.2-.9v-.6h.2v1l-.5 1.5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M303.7 205.1a.8.5 69.5 1 0 .6 1.5.8.5 69.5 1 0-.6-1.5zm-1.5.8a.8.5 43.7 1 0 1 1 .8.5 43.7 1 0-1-1z",
      overflow: "visible",
      style: {
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M308.3 211.8c-.3.4-4.2 3-7.4 2.3-2.3-.4-2.6-1-2.6-1s-.1-.6 2-.8c2.2-.1 6-1 8-.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M298.4 213.1c2.5.6 5.2 0 7.3-.5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M310.8 212.6s-.5.7-1.3.5a3 3 0 0 1-1.2-.5l-.3.3 1.3.4.5.1-.9.6-.7.1v.3l1.2-.3c.2 0 1.4-1 1.4-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M306.6 214a.9.6 5.4 1 1 1.7.2.9.6 5.4 1 1-1.7-.1zm.4-2a.9.6 31.2 1 1 1.5 1 .9.6 31.2 1 1-1.5-1z",
      overflow: "visible",
      style: {
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M309.5 212.2c.2-.3.7-4-1-5.6-1.1-1.2-1.7-1-1.7-1s-.5.1.1 1.5c.7 1.4 1.4 4.2 2.6 5.1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M306.8 205.6c1.4 1.2 1.9 3.2 2.3 4.7"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M311.4 213s.2-.7-.5-1.2c-.6-.5-1.1-.6-1.1-.6v-.4l1.2.7.4.3c.4.3 0-.8-.2-1l-.4-.7.3-.2.5 1 .2 2"
    }),
    /* @__PURE__ */ jsx100("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M309.7 209a.9.6 42.7 1 0 1.3 1.1.9.6 42.7 1 0-1.3-1.2zm-1.2 1.5a.9.6 17 1 0 1.7.6.9.6 17 1 0-1.7-.6z",
      overflow: "visible",
      style: {
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M319.1 209s-2.3 5.4-1.5 6c0 0 2.4-4.3 4.4-5.8 1.1-1 1.8 0 2-1 0-.8-3-2.1-3-2.1l-1.8 2.7"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.2,
      d: "M319.1 209s-2.3 5.4-1.5 6c0 0 2.4-4.3 4.4-5.8 1.1-1 1.8 0 2-1 0-.8-3-2.1-3-2.1l-1.8 2.7"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M310.6 213.1s-3.4 6-2.5 6c.8 0 4.5-7.5 4.5-7.5l-1.3.2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M310.6 213.1s-3.4 6-2.5 6c.8 0 4.5-7.5 4.5-7.5l-1.3.2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M311.6 211.5s-3.6 5.8-2.7 5.9c1 .1 4.8-7.4 4.8-7.4l-1.3.1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M311.6 211.5s-3.6 5.8-2.7 5.9c1 .1 4.8-7.4 4.8-7.4l-1.3.1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M312.3 210.5s-4 5.4-3.2 5.6c1 .2 5.4-7 5.4-7l-1.3.1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M312.3 210.5s-4 5.4-3.2 5.6c1 .2 5.4-7 5.4-7l-1.3.1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M313.4 209.5s-4.8 4.9-3.9 5.2c.8.3 6.2-6.2 6.2-6.2l-1.2-.1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M313.4 209.5s-4.8 4.9-3.9 5.2c.8.3 6.2-6.2 6.2-6.2l-1.2-.1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M313.6 207.7s-4.2 5.4-3.3 5.6c.9.2 5.5-6.9 5.5-6.9l-1.3.1-1 1.2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M313.6 207.7s-4.2 5.4-3.3 5.6c.9.2 5.5-6.9 5.5-6.9l-1.3.1-1 1.2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M312.5 212.4s-4 5.5-3.2 5.6c1 .2 5.4-7 5.4-7l-1.3.1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M312.5 212.4s-4 5.5-3.2 5.6c1 .2 5.4-7 5.4-7l-1.3.1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M314.8 211.3s-2.4 4.5-2.1 4.6c.3.2 3.1-2.5 4.6-5.2 1.4-2.6-2.6.5-2.6.5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M314.8 211.3s-2.4 4.5-2.1 4.6c.3.2 3.1-2.5 4.6-5.2 1.4-2.6-2.6.5-2.6.5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M315 210.8s-2.3 5.5-1.5 6c0 0 3-3.3 3.7-5.9.8-2.6 0-.1 0-.1l-.2-2.9-2 2.7"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.2,
      d: "M315 210.8s-2.3 5.5-1.5 6c0 0 3-3.3 3.7-5.9.8-2.6 0-.1 0-.1l-.2-2.9-2 2.7"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M313.8 210.4s-4.7 4.8-3.9 5.1c.9.3 6.3-6.1 6.3-6.1l-1.3-.1-1 1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M313.8 210.4s-4.7 4.8-3.9 5.1c.9.3 6.3-6.1 6.3-6.1l-1.3-.1-1 1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M314.2 211s-4.7 5-3.9 5.2c.8.3 6.2-6.2 6.2-6.2h-1.2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M314.2 211s-4.7 5-3.9 5.2c.8.3 6.2-6.2 6.2-6.2h-1.2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M314.6 211.8s-4.8 4.9-4 5.2c1 .3 6.3-6.2 6.3-6.2h-1.2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M314.6 211.8s-4.8 4.9-4 5.2c1 .3 6.3-6.2 6.3-6.2h-1.2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M315 205.1s-3.6 4.5-3 5.3c.4.8 3.6-2 4.7-4 1-2-1.7-1.4-1.7-1.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M315 205.1s-3.6 4.5-3 5.3c.4.8 3.6-2 4.7-4 1-2-1.7-1.4-1.7-1.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M314.8 209.9s-3 5.8-2.2 5.5c.8-.4 3.8-4.7 4.2-5.7.3-1 .2-2 .2-2l-2.3 1.5.2 1.1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M314.8 209.9s-3 5.8-2.2 5.5c.8-.4 3.8-4.7 4.2-5.7.3-1 .2-2 .2-2l-2.3 1.5.2 1.1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M314.8 208s2.5-4.6 0 .9-3.4 4.5-3.4 4.5c-.2-.3 2.2-4 2.2-4s1.7-2.8 2.1-3.1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M314.8 208s2.5-4.6 0 .9-3.4 4.5-3.4 4.5c-.2-.3 2.2-4 2.2-4s1.7-2.8 2.1-3.1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M317.5 207.4s2.8-4.6 0 .9c-2.8 5.4-3.9 4.5-3.9 4.5-.2-.3 2.5-4 2.5-4s2-2.8 2.4-3.1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M317.5 207.4s2.8-4.6 0 .9c-2.8 5.4-3.9 4.5-3.9 4.5-.2-.3 2.5-4 2.5-4s2-2.8 2.4-3.1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M316.5 205.5s-3.5 4.5-3 5.2c.5.8 3.7-2 4.7-4s-1.7-1.4-1.7-1.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M352.8 251a32.8 37 0 1 1-65.6 0 32.8 37 0 1 1 65.6 0"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#390",
      strokeWidth: 0.8,
      d: "M293.7 251c0-17 12-30.2 26.3-30.2s26.3 13.1 26.3 30.3",
      color: "#000",
      fontFamily: "Sans",
      fontWeight: 400,
      overflow: "visible",
      style: {
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textTransform: "none",
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#eee",
      strokeWidth: 0.1,
      d: "M287.2 253c1 19.5 15.3 35 32.8 35s31.9-15.5 32.8-35z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M352.8 251a32.8 37 0 1 1-65.6 0 32.8 37 0 1 1 65.6 0z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d52b1e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M314.5 225.4c-.3 1.4 0 2.5.7 3.6.6.9 1 1.8.9 2.7a7.9 7.9 0 0 0-.7.5l-5.5-3.7 3.7 5.5a8 8 0 0 0-.2.2 4.9 4.9 0 0 0-3-.3 5 5 0 0 1-3.7-.8 4.5 4.5 0 0 0 3.1 2.1 5 5 0 0 1 2.6 1.3 8 8 0 0 0-.2.8l-6.6 1.3 6.6 1.3v.3a4.9 4.9 0 0 0-2.4 1.9 5 5 0 0 1-3 2c1.3.4 2.5 0 3.6-.7a5 5 0 0 1 2.7-.9l.4.7-3.6 5.6 5.4-3.7.3.2a4.9 4.9 0 0 0-.4 3 5 5 0 0 1-.7 3.6 4.5 4.5 0 0 0 2-3.1 4.9 4.9 0 0 1 1.4-2.5l.8.2 1.3 6.5 1.3-6.5h.3a4.9 4.9 0 0 0 1.8 2.3 5 5 0 0 1 2.1 3.1 4.4 4.4 0 0 0-.7-3.6 4.9 4.9 0 0 1-.9-2.8l.7-.4 5.5 3.7-3.7-5.5.2-.3c1 .5 2 .6 3 .4a5 5 0 0 1 3.7.7 4.5 4.5 0 0 0-3.1-2 4.9 4.9 0 0 1-2.6-1.4l.2-.8 6.6-1.3-6.6-1.2a7.9 7.9 0 0 0 0-.4 4.9 4.9 0 0 0 2.4-1.8 5 5 0 0 1 3-2 4.5 4.5 0 0 0-3.6.7 4.9 4.9 0 0 1-2.7.8 7.9 7.9 0 0 0-.4-.7l3.7-5.5-5.5 3.7a8 8 0 0 0-.3-.2c.5-1 .6-2 .4-3a5 5 0 0 1 .7-3.6 4.5 4.5 0 0 0-2 3 5 5 0 0 1-1.4 2.6 8 8 0 0 0-.8-.2l-1.3-6.5-1.2 6.5h-.4a4.9 4.9 0 0 0-1.8-2.3 5 5 0 0 1-2-3.1z",
      overflow: "visible",
      style: {
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx100("path", {
      d: "M325.9 236.7c-1.7-1.4-3.8-1.6-4.9-.6-.8 1.1-.8 2.4.2 3.8a.5.5 0 0 0-.3.2 4.9 4.9 0 0 1-.3-4.1c1.5-1.3 3.7-1.4 5.2.7"
    }),
    /* @__PURE__ */ jsx100("path", {
      d: "M323.3 236.3c-1 0-1.2.2-1.6.5-.4.4-.6.3-.7.4 0 0 0 .3.1.2.2 0 .5-.2.9-.6.4-.3.8-.3 1.3-.3 1.3 0 2 1 2.1 1 .2 0-.7-1.2-2.1-1.2"
    }),
    /* @__PURE__ */ jsx100("path", {
      d: "M325 237.5c-1-1-2.7-1-3.4 0h.2c.8-1 2.5-.6 2.6 0"
    }),
    /* @__PURE__ */ jsx100("circle", {
      cx: 323.1,
      cy: 237.4,
      r: 0.6
    }),
    /* @__PURE__ */ jsx100("path", {
      d: "M321.6 237.6c.7.6 2.2.7 3.3-.1h-.5c-.7.7-1.8.6-2.5 0"
    }),
    /* @__PURE__ */ jsx100("path", {
      d: "M325 237.8c-1.2 1-2.4.9-3.1.5-.7-.5-.7-.6-.6-.6l.8.4c.6.3 1.5.3 2.9-.2m-3.5 2a.4.4 0 1 1-.6.5c0 .1-.3.6-.9.6h-.1l.1.2c.1 0 .6 0 .9-.2a.6.6 0 1 0 .6-1m.9 3c-.7-.5-1-1-1.7-1a2 2 0 0 0-.7.1h-.1l.1.2c.3 0 .7-.3 1.2 0zm-.3 0c-1.4-.5-1.7-.2-2.1-.2h-.1l.1.3c.6 0 .9-.4 2.1-.1"
    }),
    /* @__PURE__ */ jsx100("path", {
      d: "M322.4 243c-1.6-.2-1.1.8-2.4.8h-.1l.1.2c1.6 0 .9-.9 2.4-1m-8.2-6.3c1.6-1.4 3.7-1.6 4.8-.6.8 1.1.8 2.4-.2 3.8a.5.5 0 0 1 .3.2 5 5 0 0 0 .3-4.1c-1.5-1.3-3.7-1.4-5.2.7"
    }),
    /* @__PURE__ */ jsx100("path", {
      d: "M316.7 236.3c1 0 1.2.2 1.6.5.4.4.6.3.7.4 0 0 0 .3-.1.2a4.1 4.1 0 0 1-.9-.6c-.4-.3-.8-.3-1.3-.3-1.3 0-2 1-2.1 1-.2 0 .7-1.2 2.1-1.2"
    }),
    /* @__PURE__ */ jsx100("path", {
      d: "M315 237.5c1-1 2.7-1 3.4 0h-.2c-.8-1-2.5-.6-2.6 0"
    }),
    /* @__PURE__ */ jsx100("circle", {
      cx: -316.9,
      cy: 237.4,
      r: 0.6,
      transform: "scale(-1 1)"
    }),
    /* @__PURE__ */ jsx100("path", {
      d: "M318.4 237.6c-.7.6-2.2.7-3.3-.1h.5c.7.7 1.8.6 2.5 0"
    }),
    /* @__PURE__ */ jsx100("path", {
      d: "M315 237.8c1.2 1 2.4.9 3.1.5.8-.5.8-.6.6-.6l-.8.4c-.5.2-1.5.3-2.9-.2m3.5 2a.4.4 0 1 0 .6.5c0 .1.3.6.9.6h.1l-.1.2c-.1 0-.6 0-.9-.2a.6.6 0 1 1-.6-1m-.9 3c.7-.5 1-1 1.7-1l.7.1h.1l-.1.2c-.3 0-.7-.3-1.2 0zm.3 0c1.4-.5 1.7-.2 2.1-.2h.1l-.1.3c-.6 0-.9-.4-2.1-.1"
    }),
    /* @__PURE__ */ jsx100("path", {
      d: "M317.6 243c1.6-.2 1.1.8 2.4.8h.1l-.1.2c-1.6 0-.9-.9-2.4-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: 0.1,
      d: "M323.2 258.4c1.6.2 3.3.2 4.7-.3a9.9 9.9 0 0 1 4.2-.6c0-.2.5-.3.2-.5-.5-.3-1.2-.3-1.8-.6-1-.5-1.7-1.3-2.7-2-.1 0-.6-.3-.6-.5 2.2 3.2 7.5 1.5 12 1.2.4.1 1.5-.2 2.4-.5 1-.4 3.6 0 4.3-.5l-1.3-1c-.6-.8-2.3-.7-3-1.5-1.3-1.5-3.3-1.9-4.9-3-.3-.3-1-.2-1.6-.3-.6-.6 0-.5-5-4.7-4.5-1.8-4.2-3.2-7-4.3-1-.5-1.9-1.4-2.7-1.1a30 30 0 0 0-6.3 3c-1.2.6-2.7 2-3.8 2.8-.2.2-3.4 2.9-7 4.8a115 115 0 0 1-9.2 4.8c8-.4-7.3 2.3 29.1 4.8z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M303.3 249c2-1 10-5.3 12.4-8.4-.4 0 .6 1 .5 1.4.8 0 .4-1 1-1 .5 0 .9-.1 1.3-.3.5 0 .2.2.2.4-.7 1.2-2 2-3.2 2.9l.2.4c.4 0 .9 0 1.1-.2l.1-.3c.4.1.3.5.1.7-.3.6-1.4.5-1.8 1a6.2 6.2 0 0 1-1.5 1.7c.5-.4 1-1 1.7-1 1 0 1.3-.7 2.2-.9.9-.1 1.5-.9 2.2-1.4-.3.4-.9.7-.7 1.2a.6.6 0 0 0 .6.2c-.7.8-2 1.4-2.4 2.4-.4-.2-.7.2-1 .2-.4.1-.3.8-.6 1-1.2.7-1.8 1.8-2.3 2.7l-1.3.7c-.7.3-4.6 3.4-4.7 3-.3-2.1-4.3 1.6-13.3-1.6m30.6-.1-.2-.2c.1-.3-.5-.4-.5-.7 1 0 1.8 1.2 2.5.5.1-.1-.3-.4.4-.6 0 0-.2-.1-.1-.2h-.8l-.8-.3c-.3-.1-.5-.5 0-.6 1-.1 1.9.5 2.6.2.6-.3 1.1-.3 1.7-.5.3-.1 1.2 0 .9.2-.2.2-.7.1-1 .2-.5.1-1 .4-1.4.6.3 0 .2.3.7.2a6 6 0 0 1 2-.4v-.5h.3c-.3-.5.6-.2 1-.6l.1.1c-.5.2-.3.5-.4.8 0 0-.3 0-.2.2.2.2.2-.2.5 0h.6c.3 0 .7-.1.5-.4-.3-.2-.6-.5-.6-.8l-.1-.1c.5 0 1 .2 1.1.4.3.3.3.6.8.7.8.2.7-.2.7-.6.7 0 1.6.3 1.4.6 0 .3-.6.5-1 .5s-.2.3-.4.3c-.4 0-.9 0-1 .2-.2.2 0 .7.3.9.4.2 1.2 0 1.8 0 .1-.3.5-.4.9-.6.4-.3-.2-.5-.5-.7-.3 0 0-.1 0-.3.3-.3.9 0 1-.2.1-.3-.1-.6.1-.8.2-.1.5.1.4.3l.7-.2c.3 0 .5.3.4.4-.5.2-.8.4-.7.8 0 .2-.5.3-.3.5.4.3.4.5.5.9.2.3 1 .4 1.6.3-.2-.7 1.4-.4 2-.5.1 0 .1-.1 0-.2-.3-.2-.3-.3-.3-.6l-.1-.1c1 .3 2.8.8 3.6 1.4-1 .2-2.8-.2-3.8 0a15 15 0 0 1-3.7.6c-.5 0-1-.3-1.6-.3m-11.3-.7-.4-.1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M321.2 259.1c2 0 2.2 1.4 3.5.1 1.1.2 2.2-.2 2.2-.3 2.7.6 11.1-.2 10.6-.8-.9-1-2.3-1.4-3.4-2.2l-1.1-.4c-.7-.2-1.5 0-2-.3l-2.6-1.5c-.5-.4-.7-1-1.2-1.4-.6-.4-1.4-.5-2-.7-.9-.4-1.4-1.2-2.2-1.9l-1.1-.4c-.7-.3-1.2-1.1-1.9-1-1 .2-1.7 1-2.8 1.6-1 .4-1.4 1.1-2.2 1.6-.2.2-2.6 1.8-5.3 2.9a72.6 72.6 0 0 1-6.6 2.5s2.4 1.7 8 1.5l3.4 1 1.9-.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M309.8 254.8c1.2-.6 6-2.9 7.4-4.5-.1 0 .5.5.4.7.5 0 .2-.4.6-.5l.8-.1c.3 0 .1 0 .1.2-.4.6-1.3 1-2 1.5l.2.2h.7v-.3c.3.1.2.3.1.4-.2.4-.9.3-1.1.6a3 3 0 0 1-1 .9c.4-.2.7-.5 1.1-.5.6 0 .8-.4 1.3-.5.6-.1 1-.5 1.4-.8-.2.2-.5.4-.4.7l.4.1c-.4.4-1.2.7-1.5 1.2l-.6.1c-.3.1-.2.5-.4.6-.7.3-1 1-1.4 1.4l-.8.4c-.4.2-2.8 1.8-2.8 1.6-.2-1.1-2.6.5-8-1.2"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#00a6de",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M320 214.2c-18.1 0-32.8 16.5-32.8 36.9S301.9 288 320 288s32.8-16.5 32.8-37c0-20.3-14.7-36.9-32.8-36.9zm0 8.2c13.2 0 24.7 12.3 24.7 28.7s-11.5 28.6-24.7 28.6-24.7-12.2-24.7-28.6c0-16.4 11.5-28.7 24.7-28.7z",
      color: "#000",
      fontFamily: "Sans",
      fontWeight: 400,
      overflow: "visible",
      style: {
        lineHeight: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textTransform: "none",
        marker: "none"
      }
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M324.7 266.8c0 .2 0 .2-.4.3-.4 0-.5 0-.5-.2s.1-.2.5-.2c.3-.1.4-.1.4 0z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "m324.8 266.8-.5.2h-.5c0-.2.2-.2.5-.3h.5zm-2.8 9c.8-2.2 1-3.8-.2-6 2-1.9 3.3-1.2 4.6 0-1.2 2.3-1 4-.2 6a4 4 0 0 1-4.2 0"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M324 268.6v7.7h.1v-7.7z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M324.4 268.6a44.6 44.6 0 0 0-.3 7.7c0-2.9.2-5.3.4-7.6zm.7-2.4c-.4.4-.6.4-.4 1 .4-.3.4-.5.4-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M324.3 266.4c.2.3.6.4.3 1-.4-.3-.3-.4-.3-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M324.3 267c.2.3.5.3.3.9-.3-.3-.4-.3-.4-.8z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M324.2 267.4c.2.2.5.4.3 1-.4-.4-.3-.4-.3-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M324 267.9c.3.2.7.3.4 1-.4-.4-.2-.5-.4-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M324 268.4c.2.2.6.3.4 1-.3-.4-.4-.4-.4-1m1.3-1.7c-.2.1-.6.1-.6.8.5-.3.5-.3.6-.8"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M325.3 267.1c-.2.2-.7.2-.7.7.6-.2.5-.2.7-.7"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M325.2 267.6c-.2.1-.6 0-.7.7.6-.3.6-.2.7-.8z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M325.2 268.1c-.2 0-.7 0-.7.7.4-.1.4-.3.7-.7"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M325 268.6c-.4.1-.5 0-.6.7.5-.3.4-.2.5-.7zm.2.3c-.7 2.1-.8 4-.7 7.4h.1c0-3.4.1-5.2.8-7.3a2.8 2.8 0 0 0-.1 0zm1.2-2.2c-.4.3-.6.2-.5.8.4-.1.4-.3.5-.8"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M325.6 266.8c.2.2.5.4.1 1-.3-.4-.2-.5 0-1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M325.4 267.4c.3.3.5.3.2.8-.2-.3-.3-.3-.2-.8"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M325.3 267.7c.1.3.4.4.1 1-.3-.4-.3-.4-.1-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M325 268.1c.3.3.6.5.3 1-.4-.4-.2-.5-.3-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M324.9 268.6c.2.3.5.5.2 1-.3-.4-.3-.4-.2-1m1.6-1.4c-.2.2-.6 0-.7.7.5-.2.5-.2.7-.6z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M326.4 267.7c-.2 0-.6 0-.8.5.6-.1.6 0 .8-.5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M326.3 268c-.3.2-.7 0-.9.7.7-.2.6-.2.9-.6z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M326.1 268.6c-.2 0-.6-.2-.8.5.4 0 .4-.2.8-.5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M325.8 269c-.3 0-.5 0-.7.6.5-.2.5-.1.7-.6m.1.4c-1 1.9-1.1 3.6-.7 6.8l.2-.1c-.4-3-.2-4.7.6-6.6zm1.6-2.2c-.5.2-.7.2-.7.8.4-.2.5-.4.7-.8"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M326.7 267.2c.1.3.4.5 0 1-.3-.5-.2-.5 0-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M326.4 267.8c.2.2.4.4 0 .8 0-.4-.2-.4 0-.9z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M326.2 268c.1.3.4.5 0 1-.3-.4-.2-.4 0-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M326 268.5c0 .3.4.5 0 1-.3-.5 0-.5 0-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M325.7 268.9c.2.3.5.5 0 1-.1-.4-.2-.5 0-1m1.8-1.1c-.2 0-.6-.1-.8.5.6-.1.5 0 .8-.5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M327.3 268.2c-.2 0-.6-.1-.8.4.6 0 .6 0 .8-.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M327.1 268.5c-.2 0-.6 0-.8.5.6 0 .5 0 .8-.5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M327 269c-.3 0-.7-.3-1 .4.5 0 .5-.1 1-.4m-.5.4c-.3 0-.4 0-.7.5.5-.1.5 0 .7-.5m-3-.7c.2 2.4.4 4.8.4 7.6h.1c.1-2.9 0-5.3-.4-7.6zm-.6-2.6c.4.4.5.4.4 1-.4-.3-.4-.5-.4-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M323.7 266.4c-.3.2-.6.4-.4 1 .4-.3.4-.4.4-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M323.7 267c-.3.3-.5.3-.3.8.2-.3.3-.2.3-.7z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M323.8 267.4c-.2.2-.5.3-.3 1 .4-.4.3-.4.3-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M324 267.9c-.3.2-.7.3-.5 1 .5-.4.2-.5.4-1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M324 268.4c-.3.2-.6.3-.4.9.3-.3.4-.4.4-.9m-1.3-1.8c.2.2.6.2.6.8-.5-.3-.5-.2-.6-.8"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M322.7 267.1c.2.1.6.1.6.7-.5-.3-.5-.2-.6-.7"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M322.8 267.5c.2.1.6.1.6.8-.5-.3-.5-.3-.6-.8"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M322.8 268c.2.1.7 0 .7.8-.4-.1-.4-.4-.7-.7z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M323 268.5c.3.2.5.1.5.8-.4-.3-.4-.3-.5-.8m-.2.5a3.8 3.8 0 0 0-.2.1c.7 2 1 3.9.9 7.2h.1a19 19 0 0 0-.8-7.3m-1.2-2.4c.4.3.5.3.5.8-.4-.1-.4-.3-.5-.8"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M322.4 266.7c-.2.3-.5.4-.2 1 .3-.4.3-.4.2-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M322.6 267.3c-.3.3-.6.4-.2.9.2-.4.3-.4.2-.9"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M322.7 267.6c-.2.3-.5.5-.1 1 .3-.4.2-.4.1-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M323 268.1c-.3.3-.6.4-.3 1 .4-.5.1-.5.2-1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M323 268.6c-.1.2-.5.4-.1 1 .2-.4.3-.5.2-1zm-1.5-1.5c.2.1.6 0 .7.7-.6-.2-.5-.2-.7-.7"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M321.6 267.6c.2 0 .6 0 .7.5-.5-.1-.5 0-.7-.5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M321.7 268c.2 0 .7 0 .8.6-.6-.2-.6-.2-.8-.7z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M321.9 268.5c.2 0 .6-.2.8.6-.4 0-.5-.3-.8-.6"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M322.2 269c.3 0 .4 0 .6.5-.5-.2-.4-.1-.6-.6zm0 .5a4.1 4.1 0 0 0-.2 0c.9 2 1 3.6.7 6.6h.2c.3-3 .2-4.6-.8-6.6zm-1.7-2.5c.4.3.6.2.6.8-.4-.1-.5-.3-.6-.8"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M321.3 267c-.1.3-.4.6 0 1 .3-.4.2-.4 0-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M321.6 267.6c-.2.3-.5.4-.1.9.1-.4.3-.4 0-.9z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M321.8 268c-.2.2-.4.4 0 1 .2-.5.2-.5 0-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M322 268.4c-.1.3-.4.5 0 1 .3-.5 0-.5 0-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M322.3 268.8c-.2.3-.5.5-.1 1 .2-.4.2-.5 0-1zm-1.8-1.2c.2 0 .6 0 .8.5-.6 0-.6 0-.8-.5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M320.6 268c.3 0 .7 0 .9.5-.6-.1-.6 0-.9-.5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M320.8 268.4c.3 0 .7 0 1 .5-.7-.1-.7 0-1-.5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M321 268.9c.3 0 .7-.3 1 .5-.5 0-.5-.3-1-.5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M321.4 269.3c.3 0 .5 0 .7.5-.5-.1-.4 0-.7-.5m2.2-3.2c.3.4.5.4.3 1-.4-.3-.3-.5-.3-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M324.3 266.4c-.2.2-.5.3-.4 1 .5-.3.4-.4.4-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M324.4 267c-.3.2-.6.3-.4.8.2-.3.3-.2.4-.7z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M324.4 267.4c-.2.2-.5.3-.4 1 .4-.4.4-.4.4-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M324.5 268c-.3.1-.6.2-.5.8.5-.3.3-.4.5-.9z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M324.5 268.4c-.2.2-.6.3-.4.9.3-.3.4-.3.4-.9m-1.2-1.8c.2.2.6.2.6.8-.5-.3-.5-.3-.6-.8"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M323.3 267c.2.2.6.2.6.8-.5-.3-.5-.3-.6-.8"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M323.4 267.4c.2.2.6.2.6.9-.5-.4-.5-.3-.6-.9"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M323.4 268c.2.1.7 0 .6.8-.4-.2-.3-.4-.6-.8"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M323.6 268.5c.2.1.4.1.4.8-.4-.4-.4-.3-.4-.8m-.4.3a2.7 2.7 0 0 0-.1 0c.5 2.5.7 4.7.6 7.5h.2c0-2.5 0-5-.7-7.5m-1-2.4c.4.4.6.3.5 1-.4-.3-.4-.5-.5-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M323 266.6c-.2.2-.5.4-.2 1 .3-.4.3-.4.2-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M323.1 267.2c-.2.2-.5.3-.2.8.2-.3.3-.3.2-.8"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M323.3 267.5c-.2.3-.5.4-.2 1 .3-.3.3-.4.2-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M323.5 268c-.3.3-.6.4-.3 1 .4-.4.2-.5.3-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M323.6 268.5c-.2.3-.6.4-.3 1 .3-.4.3-.5.3-1M322 267c.3 0 .7 0 .8.6-.6-.2-.6-.1-.8-.6"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M322.1 267.4c.2.1.7 0 .8.6-.6-.2-.6-.1-.8-.6"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M322.3 267.8c.2.1.6 0 .7.7-.6-.2-.6-.2-.7-.7"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M322.4 268.3c.2 0 .6-.1.8.7-.5-.1-.5-.3-.8-.7"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M322.7 268.8c.3 0 .4 0 .6.6-.5-.2-.5-.1-.6-.6m-.8.9c.6 1.4.8 2.6.7 3.7l-.3 2.5h.1c.6-2.5.5-4.4-.5-6.2"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "m322.5 269.2-.1.1c.8 2.1.9 4 .7 7h.1c.2-3 .1-5-.7-7zm-1.4-2.4c.4.3.5.2.5.8-.4-.1-.4-.3-.5-.8"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M321.8 266.9c-.1.2-.4.4 0 1 .3-.4.2-.5 0-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M322 267.4c-.1.3-.4.4 0 1 .1-.4.2-.4 0-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M322.3 267.8c-.2.2-.5.4 0 1 .2-.5.1-.5 0-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M322.5 268.2c-.2.3-.5.5 0 1 .2-.5 0-.5 0-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M322.7 268.7c-.1.2-.5.5-.1 1 .2-.4.3-.5.1-1m-1.7-1.3c.2 0 .6 0 .8.5-.6-.1-.6 0-.8-.5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M321.1 267.8c.3 0 .7 0 .8.5-.5-.1-.5 0-.8-.5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M321.3 268.1c.2.1.7 0 .9.6-.6-.1-.6 0-.9-.6"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M321.5 268.7c.2 0 .6-.3.9.5-.5 0-.5-.2-.9-.5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M321.9 269c.3.1.4 0 .6.6-.4-.1-.4 0-.6-.5zm-2-1.6c.5.2.7.2.8.7-.4 0-.5-.2-.7-.7z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M320.7 267.4c0 .3-.3.5.2 1 .2-.5.1-.5-.2-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M321 267.9c0 .3-.3.5.1.9.1-.4.2-.4 0-.9z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M321.3 268.2c0 .3-.3.5.1 1 .2-.5.2-.5 0-1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M321.6 268.6c0 .3-.4.5.1 1 .2-.6 0-.5 0-1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M322 269c-.2.3-.5.6 0 1 .1-.4.2-.5 0-1m-2-1c.2 0 .6-.1.9.4-.6 0-.6 0-1-.4z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M320.2 268.4c.2 0 .6-.2.9.4-.6 0-.6 0-.9-.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M320.4 268.7c.3 0 .7-.1 1 .4-.6 0-.6 0-1-.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M320.7 269.2c.2 0 .6-.3 1 .4-.5 0-.5-.2-1-.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M321.1 269.5c.3 0 .5 0 .8.5-.5 0-.5 0-.8-.5m3.8-.7a25.9 25.9 0 0 0-.7 7.5 2.5 2.5 0 0 0 .2 0c0-2.8 0-5 .7-7.4a2.8 2.8 0 0 0-.2-.1m1-2.3c-.4.3-.5.3-.5.9.4-.2.5-.4.5-.9"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M325.1 266.6c.2.3.5.5.2 1-.3-.4-.3-.4-.2-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M325 267.3c.3.2.5.3.2.8-.2-.3-.3-.3-.2-.9z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M324.9 267.6c.2.2.5.4.2 1-.4-.4-.3-.5-.2-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M324.7 268c.2.3.5.5.2 1-.4-.4-.1-.5-.2-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M324.5 268.5c.2.3.6.5.3 1-.3-.4-.3-.4-.3-1m1.6-1.5c-.2.2-.6 0-.7.7.5-.2.5-.2.7-.7"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M326 267.5c-.2 0-.6 0-.7.6.5-.2.5-.1.7-.6"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M325.9 267.9c-.2 0-.7 0-.8.6.6-.2.6-.1.8-.6"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M325.7 268.4c-.2 0-.6-.2-.7.6.4 0 .4-.3.7-.6"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M325.4 268.8c-.2.1-.4 0-.5.7.4-.2.4-.2.5-.7m.2.4c-.9 2.1-1 4.1-.8 7h.2c-.2-3-.1-4.9.7-7zm1.5-2.3c-.5.3-.6.2-.6.8.4-.1.4-.3.6-.8"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M326.3 267c.1.2.4.5 0 1-.3-.5-.2-.5 0-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M326 267.5c.3.3.5.5.1 1-.1-.5-.2-.5 0-1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M325.9 267.8c.1.3.4.5 0 1-.3-.4-.2-.4 0-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M325.6 268.3c.2.3.5.5.1 1-.3-.5 0-.5-.1-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M325.4 268.7c.2.3.5.5.1 1-.2-.4-.3-.4-.1-1m1.7-1.2c-.2.1-.6 0-.8.5.6 0 .6 0 .8-.5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M327 268c-.2 0-.6-.1-.8.4.6-.1.5 0 .8-.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M326.8 268.3c-.2 0-.7 0-.8.5.6-.1.5 0 .8-.5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M326.6 268.8c-.2 0-.6-.3-.8.5.4 0 .4-.3.8-.5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M326.3 269.2c-.4 0-.5 0-.7.5.4-.1.4 0 .6-.5zm0 .5c-1.1 2-1 4-.6 6.3h.2l-.3-2.9a6 6 0 0 1 .8-3.3h-.1zm1.9-2c-.5.1-.7 0-.8.6.5 0 .5-.2.8-.7z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M327.4 267.5c0 .3.3.6-.2 1-.2-.5-.1-.5.2-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M327 268c.2.3.4.5 0 .9-.1-.4-.2-.4 0-.9"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M326.8 268.3c.1.3.3.5-.1 1-.2-.5-.2-.5.1-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M326.5 268.7c0 .3.4.6-.1 1-.2-.6 0-.5 0-1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M326.2 269c.1.4.4.7 0 1-.2-.4-.2-.4 0-1m2-.8c-.3 0-.6-.2-1 .4.6 0 .6 0 1-.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M327.9 268.6c-.2 0-.6-.2-.9.3.6 0 .6 0 .9-.3"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M327.7 268.9c-.3 0-.7-.2-1 .4.7 0 .6 0 1-.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M327.4 269.4c-.2 0-.6-.4-1 .3.5 0 .6-.2 1-.3"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "M327 269.7c-.3 0-.5-.1-.8.4.5 0 .5 0 .8-.4m-3.5 2.7h1.1c.7 0 1.2.2 1.2.4s-.5.3-1.2.3h-1.1c-.7 0-1.3-.2-1.3-.4s.6-.3 1.3-.3"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      d: "m322.7 272.4-.4.6a.3.3 0 0 0 .2 0h.2l.4-.6zm.9 0-.4.6h.4l.4-.6zm.9 0-.4.7h.4l.4-.7zm.8 0-.3.7h.4l.3-.6a.3.3 0 0 0-.2 0z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e7e7e7",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m316.5 268.8.5 2.7.2.2v1.1c.3.5.3 1.1.5 1.6l.3.6h.4l.1.2-.2.2h-.6l-.3-.1v-.3h-.2l-.1-.6-.8-1c0-.1 0-.4-.2-.5l-.3-.3c-.5-1-1-3-1-3m-6.4-1 1.8.4-.5 2.6c-.3.8-.3.9-.2 1 .2.5.4 1.2 1.1 2.3l.6.4.5.3h.5l.1-.2c0-.1-.3 0-.5-.2 0-.3-.5-.8-.5-1.2-.3-.7-.2-.7-.2-1.5l.5-1.6c.2-.5.5-1.4.5-2l-.8-1.7-.5-.7m-1.6-1.1c-2.9 1-1.7 3.5-.9 3.6m9.2-8.1.4-1v-.4l-.7.9"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e7e7e7",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M319.2 262.4c.2 0 .4.1.4 0v-.6c-.6-.4-1-.4-1-.7v-.2c0-.2-.8-.3-1-.4l-.4-.2h-.2c-.8 0-1.1.7-1.2 1.2 0 0-.2 2.1-.5 3a.7.7 0 0 1-.2.3l-.2.2c-2-.2-3.4-.2-4.2-.2-.8 0-1.8.7-1.8.7s-1 .6-1.1 1.6c-.1.3 0 .7.1 1 1 2.7 1.8 0 2.1.1h.4c.5 0 1.4 1.5 2.7 1.8 4 .9 5-1.2 5-5.8v-.2l.2-.4v-.8l1-.2.2-.1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e7e7e7",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m317.3 261 .4-1v-.4l-.9 1m-8.9 7.6c.3.8.7 1.5.7 1.8 0 .4-.3.6-.3.7h-.2l-.2.6a1.3 1.3 0 0 0 0 .6c0 .7.4 2.2.4 2.3 0 0 .3 0 .3.2v1.2c0 .2.3.3.3.3h.6l-.4-.4a.4.4 0 0 1 0-.2c0-.2.2-.4.3-.5v-.3l-.1-.2a8.3 8.3 0 0 1-.1-.9v-1.1l.2-.2.1-.2 1-.6.8-1 .2-.5a.5.5 0 0 0 0-.2 3.8 3.8 0 0 0-.3-.9 3.2 3.2 0 0 0-.6-.8m5.9 1.8c-.5.4-1.8.7-1.8 1 0 0 0 1.6-.2 2.2l-.3.6-.2.7-.3 1v.3l.4.3h-.4l-.6-.2V274l-.2-1.4.1-1-.1-3.6m4.7-5.4c.2.2.6.4 1.3.1.2.1.3.2.6-.2m-.3-.5h.2s.1 0 0 0c0 0 0-.1 0 0z"
    }),
    /* @__PURE__ */ jsx100("path", {
      d: "M317.8 261.4c.2.3.4.3.6.1-.2-.3-.4-.1-.5-.1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e7e7e7",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M329.1 272.9a2 2 0 0 0 0 .7v.8a2 2 0 0 0 0 .7 2 2 0 0 0 0 .7c.2.2 1 .2 1.2 0a2.2 2.2 0 0 0 0-.7v-.7a2 2 0 0 0 0-.7v-.8a2.3 2.3 0 0 0 0-.8v-.7a2.2 2.2 0 0 0 0-.8v-.8a2.4 2.4 0 0 0 0-.8v-.7a2.2 2.2 0 0 0 0-.8 1.9 1.9 0 0 0 0-.8 2.5 2.5 0 0 0 0-.8 2.3 2.3 0 0 0 0-.8 3.3 3.3 0 0 0 0-.8 2.9 2.9 0 0 0 0-.7v-.8a2.6 2.6 0 0 0 0-.8 2.7 2.7 0 0 0 0-.8v-.8a2.3 2.3 0 0 0 0-.8v-.7a2 2 0 0 0 0-.3h-.9v1a2.3 2.3 0 0 0 0 .8v.8a2.7 2.7 0 0 0 0 .8 2.6 2.6 0 0 0 0 .8 3 3 0 0 0 0 .7l-.1.8v.8a2.4 2.4 0 0 0 0 .8 2.5 2.5 0 0 0 0 .8 1.9 1.9 0 0 0 0 .8c-.1.3-.1.5 0 .8v.7a2.4 2.4 0 0 0-.1.8 2.6 2.6 0 0 0 0 .8 2.2 2.2 0 0 0 0 .8 2 2 0 0 0 0 .7 2.3 2.3 0 0 0 0 .8z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e7e7e7",
      fillRule: "evenodd",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.1,
      d: "M329.1 273.6c.3.2 1 .1 1.2 0m-1.2-.7h1.2m-1.2-.8h1.2m-1.1-.7h1.1m-1.1-.8h1.1m-1.1-.8h1.1m-1-.8h1m-1-.7h1m-1-.8h1m-1-.8h1m-1-.8h1m-1-.8h1m-1-.8h1m-1-.7h1m-1-.8h1m-1-.8h1m-.9-.8h.8m-.8-.8h.8m-.8-.8h.8m-.8-.7h.8m-1 15.5h1.1m-1.2.7h1.2"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#007934",
      fillRule: "evenodd",
      stroke: "#e7e7e7",
      strokeWidth: 0.1,
      d: "M331.5 257a13 13 0 0 1 2.1 0 13.7 13.7 0 0 0-.8-.3h2.2a5 5 0 0 0-1-.5 8 8 0 0 1 2.2.1l-1-.5c.9 0 1.2 0 2 .2a2.6 2.6 0 0 0-.9-.5 8 8 0 0 1 2.5-.2 8.6 8.6 0 0 0-8 .8 6 6 0 0 1 1-1.1 2.5 2.5 0 0 0-.7 0c.3-.3.8-.8 1.2-1l-.7.1 1.4-1a3.1 3.1 0 0 0-.9.1 5.2 5.2 0 0 1 1.6-1.1 4 4 0 0 0-1 0 8.7 8.7 0 0 1 2-1.3c-3.3.4-5.1 2.8-5.3 4.8a7 7 0 0 0-6.6-3.6c1 .3 1.8.7 2.4 1a4.4 4.4 0 0 0-1 .1c.7.2 1.5.6 2 1a3.4 3.4 0 0 0-1 0l1.8.8-.8.1a5 5 0 0 1 1.5.8h-.8c1 .4 1.1.6 1.3.7a8 8 0 0 0-7.3 3 10 10 0 0 1 2.2-1l-.5.8c.5-.4 1.3-.8 2-1a4.8 4.8 0 0 0-.4.7l1.8-1-.4.8 1.7-.7-.5.7 1-.4a6.2 6.2 0 0 0-2.9 5.8l.9-2v1a8.5 8.5 0 0 1 1-2v1l1-2v1l1.1-1.9v.8l.3-.6.7-.9.2.3c.3.4.4 1.1.5 1.8a3.2 3.2 0 0 0 .2-.9c.3.7.7 1.8.7 2.4a3.6 3.6 0 0 0 .2-1c.3.5.6 1.8.7 2.3l.3-.9c.3.8.4 1.7.5 2.3.8-3-.4-4.9-1.8-6.3.4.1.8.5 1.3 1a4.9 4.9 0 0 0-.3-.9l1.5 1.4-.2-.8c.6.4 1.1 1.2 1.5 1.6a5.4 5.4 0 0 0-.2-1 6 6 0 0 1 1.3 1.8l-.1-1c.7.6 1 1.3 1.3 1.7 0-2.7-3.1-5-6-5.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#e7e7e7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.1,
      d: "M330.3 257.1c3.1-.5 7.2 2.3 7.2 5.3-.3-.4-.6-1.1-1.3-1.8l.1 1a6 6 0 0 0-1.3-1.7l.2 1c-.4-.4-.9-1.2-1.5-1.6l.2.8-1.5-1.4.3 1c-.5-.6-1-1-1.3-1.1m-1.8-1.5c-1.9-1.2-5.8-1-8.7 2.3a10 10 0 0 1 2.2-.9l-.5.8c.5-.4 1.3-.8 2-1a4.8 4.8 0 0 0-.4.7l1.8-1-.4.8 1.7-.7-.5.7 1-.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#e7e7e7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.1,
      d: "M329.7 256.6c-.4-2.2-3-4.8-6.9-4.6 1 .3 1.8.7 2.4 1a4.3 4.3 0 0 0-1 .1c.7.2 1.5.6 2 1a3.4 3.4 0 0 0-1 0l1.8.8a3.2 3.2 0 0 0-.8.1 5 5 0 0 1 1.5.7l-.7.1c1 .4 1 .6 1.2.7m1.5 1c-2.6.8-5.1 3.3-4.7 6.7 0-.4.5-1.5.8-2v1l1-2v1l1-2v1a13.3 13.3 0 0 1 1.1-1.9v.8a5 5 0 0 1 1-1.5m-1.6.2a8.7 8.7 0 0 0-.5 1.4m-.5-.8a9.7 9.7 0 0 0-.5 1.9m-.5-1a9 9 0 0 0-.5 2"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#e7e7e7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.1,
      d: "M329.9 258.6v-.6",
      className: "bo_svg__bo-fil1 bo_svg__bo-str2"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#e7e7e7",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.1,
      d: "M332.6 261.3v1.3m-1-3 .1 1.6m-1-2.7.1 1.3m4.8-.4.6 1.2m-2-2.1.8 1.4m-2-1.8c.3.3.5.7.7 1.2m-10.6-.8a4.7 4.7 0 0 1 1.7-1.2m-.2 1c.4-.6.6-.9 1.6-1.3m-.2 1c.4-.4.9-.8 1.7-1.1m-.4 1.2c.5-.5 1-.7 1.6-1m-3.7-4c.7 0 1.6.2 2.2.6m-1.2.4c.6 0 1.4.2 1.8.4m-1 .4c.6 0 1.3.3 2 .6m-1.3.2a4 4 0 0 1 1.7.6m.9.2a8.6 8.6 0 0 1 8.5-1.2 8 8 0 0 0-2.4.2c.4 0 .7.3.8.4h-2c.4 0 .7.2 1 .4a7.3 7.3 0 0 0-2.2 0l1 .3h-2.2l.8.3c-1 0-1.6 0-2 .2m4.8-1.6a6 6 0 0 0-2.2-.4m1 .7a5.8 5.8 0 0 0-2.5-.2m1.3.6a6.8 6.8 0 0 0-2.5-.2m1.3.7a5 5 0 0 0-2-.1m.8 1c.4.3.6.7.8 1.1m-3-3.1c.2-2 2-4.4 5.3-4.8a9 9 0 0 0-2 1.3h1c-.5.2-1.2.7-1.6 1.1a3.1 3.1 0 0 1 .9 0 6.7 6.7 0 0 0-1.4 1l.7-.1a4.1 4.1 0 0 0-1.2.9h.7l-1 1.1m2-4c-.5.1-1.1.4-1.6.7m1 .4a4.5 4.5 0 0 0-1.5.5m.9.4c-.5.1-1 .4-1.5.7m1 .2a3.2 3.2 0 0 0-1.4.8m-.5 2.4a6 6 0 0 0-.3 1.1m1.2-2c1.8 1.6 4.1 3.7 3 7.6a6 6 0 0 0-.4-2.2l-.3.9a6.8 6.8 0 0 0-.7-2.4 3.5 3.5 0 0 1-.2 1 8.3 8.3 0 0 0-.7-2.4c0 .2 0 .6-.2.9 0-.9-.3-1.7-.7-2"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m293.3 233.5 1.3.7.3-.6c.1-.3.2-.5.1-.6 0-.2-.2-.4-.5-.5-.3-.2-.6-.3-.7-.2-.2 0-.4.2-.5.4l-.2.5c0 .1 0 .2.2.3m1.6 1 1.7.8h.3l.3-.5.3-.6a.6.6 0 0 0 0-.4.7.7 0 0 0-.2-.2 1.9 1.9 0 0 0-.3-.2c-.8-.4-1.3-.3-1.7.3l-.4.7m-2.6-.8a33 33 0 0 0 .6-1.2 3.3 3.3 0 0 1 .6-.7l.6-.4h.9c.2.1.3.3.4.6.1.2.2.5.1.7a2 2 0 0 1 1-.6l1 .1c.3.2.5.6.6 1 .1.5 0 1-.4 1.7a32.4 32.4 0 0 1-.7 1.3l-.3.7-1.4-.9-1.8-1-1.5-.7.3-.6m9-10.8c-.8.6-.7 1.5.3 2.6.5.6 1 1 1.5 1 .4.2.9 0 1.3-.3.3-.3.5-.6.4-1a3.1 3.1 0 0 0-.8-1.5c-.5-.7-1-1-1.4-1.2-.5 0-1 0-1.4.4m3.8-.2c.5.6.7 1.3.7 2a2.8 2.8 0 0 1-1.2 2 2.9 2.9 0 0 1-2 .7 2.4 2.4 0 0 1-1.8-1 2.8 2.8 0 0 1-.7-2c0-.7.4-1.4 1-2a2.9 2.9 0 0 1 2-.7c.8 0 1.4.4 2 1m8-2.6.3 1a14.4 14.4 0 0 0 1.9-.7h.3a4.5 4.5 0 0 0 .3.7l-.5.1-2.4.7-.7.2-.4-1.6-.5-2a12 12 0 0 0-.5-1.5l.6-.2.7-.2.3 1.6.6 2m9.2-3a12.2 12.2 0 0 0 0-1.6h.8l.7.1c-.2.5-.2 1-.3 1.7l-.2 2a11.9 11.9 0 0 0-.1 1.6h-.7l-.7-.1.3-1.7.2-2m9.9 5.3c1.6-1.3 2.7-2.2 3.1-2.7l.4.2.4.2a230 230 0 0 0-4.7 3.6l-.5-.3a316.2 316.2 0 0 1 .2-2 362.5 362.5 0 0 0 .4-3.8 7.7 7.7 0 0 0 1.2.7 34.8 34.8 0 0 0-.5 4m8.4 4 1.2-1.3.4.6.5.4a11.1 11.1 0 0 0-1.3 1.1l-1.5 1.4a12 12 0 0 0-1.1 1.1l-.5-.5-.5-.5 1.3-1 1.5-1.4m5 10 1.3-1.4h-2a18 18 0 0 0 .7 1.4m-1.1-1.3-2 .1a1.9 1.9 0 0 0-.1-.3 2.6 2.6 0 0 0-.2-.4h5.9l.3.6a82.5 82.5 0 0 0-4 4.3l-.2-.7a5.4 5.4 0 0 0-.3-.6 23.9 23.9 0 0 0 1.4-1.3 35 35 0 0 0-.4-.8 39.5 39.5 0 0 0-.4-1",
      fontFamily: "Linux Biolinum",
      fontSize: 100,
      fontWeight: 700,
      letterSpacing: 60,
      style: {
        lineHeight: "125%",
        textAlign: "center"
      },
      textAnchor: "middle",
      wordSpacing: 0
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e8a30e",
      stroke: "#000",
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeWidth: 0.1,
      d: "m325 280.6-.8 2.2h-2.4l1.9 1.5-.7 2.2 2-1.3 1.8 1.3-.6-2.2 1.8-1.4h-2.3zm9-3.9-.7 2.2H331l1.8 1.5-.7 2.2 2-1.3 1.9 1.3-.7-2.2 1.9-1.4h-2.4zm14.2-25-.8 2.3h-2.3l1.8 1.4-.6 2.3 1.9-1.4 1.9 1.4-.7-2.3 1.9-1.4h-2.4zm-6.7 17.9.7 2.2h2.4l-1.9 1.4.7 2.3-2-1.4-1.9 1.4.7-2.3-1.8-1.4h2.3zm4.7-8.2.8 2.2h2.3l-1.9 1.5.7 2.2-1.9-1.3-2 1.3.8-2.2-1.9-1.4h2.3zm-31.1 19.2.8 2.2h2.3l-1.9 1.5.7 2.2-2-1.3-1.8 1.3.6-2.2-1.8-1.4h2.3zm-9.2-3.9.8 2.2h2.4l-2 1.5.8 2.2-2-1.3-1.9 1.3.7-2.2-1.9-1.4h2.4zm-14-25 .7 2.3h2.3l-1.8 1.4.6 2.3-1.9-1.4-1.9 1.4.7-2.3-1.9-1.4h2.4zm6.6 17.9-.7 2.2h-2.4l1.9 1.4-.7 2.3 2-1.4 1.9 1.4-.7-2.3 1.8-1.4h-2.3zm-4.7-8.2-.8 2.2h-2.3l1.9 1.5-.7 2.2 1.9-1.3 2 1.3-.8-2.2 1.9-1.4h-2.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e7e7e7",
      d: "M321 248.1v-.5h.1l-.8-.5h-.7l-.8.5v.5h2.3"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e7e7e7",
      d: "M321 248.1v-.5h.1l-.8-.5v-.7h-.6v.7l-.9.5v.5h2.3zm.3.6v.2h-2.6v-.2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e7e7e7",
      d: "M321.3 248.7v.2h-2.6v-.2zm-2.5 0v-.5h.1v.5-.5h-.1v-.1h2.4v.1h-.2v.5-.5h.1v.5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e7e7e7",
      d: "M318.9 248.7v-.5zv-.5h-.1v-.1h2.4v.1h-.2v.5-.5h.1v.5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e7e7e7",
      d: "M319.4 248.6v-.4h-.4v.4z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e7e7e7",
      d: "M319.1 248.3v.2h.2v-.2zm1.8.3v-.4h-.3v.4z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e7e7e7",
      d: "M320.7 248.3v.2h.1v-.2zm.2-.3v-.3h-.3v.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e7e7e7",
      d: "M320.7 247.7v.2h.1v-.2zm-1.3.3v-.3h-.4v.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e7e7e7",
      d: "M319.1 247.7v.2h.2v-.2zm.8.3v-.3h-.3v.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e7e7e7",
      d: "M319.7 247.7v.2h.1v-.2zm.7.3v-.3h-.3v.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e7e7e7",
      d: "M320.1 247.7v.2h.2v-.2zm.4.2v.8h-1v-.8z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e7e7e7",
      d: "M320.5 247.9v.8h-1v-.8zm-1 .2h1m-.9.6v-.6m.7.6v-.6m.5-.5-.5-.4h-.6l-.5.4zm-1-.5h.4m-.3-.1h.2zm.1 1h.1zm.3 0h.1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e7e7e7",
      fillRule: "evenodd",
      d: "M319.8 246h.4v.4h-.4z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M320 245.6v.4m-.2-.2h.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M317.1 210.3s-2.3 5.4-1.5 6c0 0 3-3.3 3.7-5.9.8-2.6 0-.2 0-.2l-.2-2.8-2 2.7"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.2,
      d: "M317.1 210.3s-2.3 5.4-1.5 6c0 0 3-3.3 3.7-5.9.8-2.6 0-.2 0-.2l-.2-2.8-2 2.7"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M317.6 207.7s-2.8 6-2.1 6.4c0 0 2.3-2.7 3-4.8.5-2.1 0-.1 0-.1l.7-3.9"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M317.6 207.7s-2.8 6-2.1 6.4c0 0 2.3-2.7 3-4.8.5-2.1 0-.1 0-.1l.7-3.9"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M320.5 206.4s-2.8 6-2.1 6.4c0 0 2.3-2.7 3-4.8.5-2.2 0-.2 0-.2l.7-3.8"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M320.5 206.4s-2.8 6-2.1 6.4c0 0 2.3-2.7 3-4.8.5-2.2 0-.2 0-.2l.7-3.8"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "m356.8 195.6 3.4 1.9s.8.7-1 .3a42 42 0 0 1-12.8-6.4c-3.3-2-4.3-2-4.3-2l4.5.1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m356.8 195.6 3.4 1.9s.8.7-1 .3a42 42 0 0 1-12.8-6.4c-3.3-2-4.3-2-4.3-2l4.5.1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "m358 194.8 3.3 1.9s.8.7-1 .3a45 45 0 0 1-12.8-6.4c-3.3-2.1-.6 1.7-.6 1.7l.5-2.5 10.5 5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m358 194.8 3.3 1.9s.8.7-1 .3a45 45 0 0 1-12.8-6.4c-3.3-2.1-.6 1.7-.6 1.7l.5-2.5 10.5 5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M363.5 196.6s-4-.7-5.4-1.8c0 0 .2.5-1.7-.4 0 0 .7 1.7-4.8-2-5.5-3.8-3.6-2-3.6-2l1.6-.3 9.3 3.7a53 53 0 0 1 4.6 2.8"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M363.5 196.6s-4-.7-5.4-1.8c0 0 .2.5-1.7-.4 0 0 .7 1.7-4.8-2-5.5-3.8-3.6-2-3.6-2l1.6-.3 9.3 3.7a53 53 0 0 1 4.6 2.8z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "m342.6 198.1 1.4 1.9s-.5 1.8-5.1-1.7-4.4-3.2-4.4-3.2l2.6-.3 5.6 3.2"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m342.6 198.1 1.4 1.9s-.5 1.8-5.1-1.7-4.4-3.2-4.4-3.2l2.6-.3 5.6 3.2"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M336.6 199s2.2 2.9 1.7 3.2c-.5.4-3 .2-4.8-2.5-1.9-2.8 0-.2 0-.2v-4.4z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M336.6 199s2.2 2.9 1.7 3.2c-.5.4-3 .2-4.8-2.5-1.9-2.8 0-.2 0-.2v-4.4l3.2 3.8"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M338.8 197.8s2.1 2.6 1.9 3c-.2.4-3.2.2-5.5-2.5-2.3-2.6-.3-3.4-.3-3.4l3.9 2.7"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M338.8 197.7s2.1 2.7 1.9 3.1c-.2.4-3.2.2-5.5-2.5-2.3-2.6-.3-3.4-.3-3.4z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M350.6 196.2s6 2.5 1.6 2.4c0 0-8.6-2.3-13-6.2l1.2-1.6 10.2 5.2"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M350.6 196.2s6 2.5 1.6 2.4c0 0-8.6-2.3-13-6.2l1.2-1.6 10.2 5.2"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M353.8 195.4s3.1 2 3.4 2.7c.2.8-10-1.9-15.3-6.3l2.4-1.2 9.4 4.8z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M353.8 195.4s3.1 2 3.4 2.7c.2.8-10-1.9-15.3-6.3l2.4-1.2 9.4 4.8z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M344.5 197.2s2.3 1.9 2 2.1c-.3.2-5-.5-8.6-3.3l.4-1.7z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M344.5 197.2s2.3 1.9 2 2.1c-.3.2-5-.5-8.6-3.3l.4-1.7 6.2 2.8"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M348.4 197s2.3 1.6 1.8 1.8c-.4.1-2.2 1.6-10.7-3.4l-1-.6 1.3-2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M348.4 197s2.3 1.6 1.8 1.8c-.4.1-2.2 1.6-10.7-3.4l-1-.6 1.3-2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M339.7 192.4s2.8 2.4 2.4 2.8c-.4.4-3.6-.4-5-1.5-1.5-1-2.6-2.4-2.6-2.4l3-.7z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M339.7 192.4s2.8 2.4 2.4 2.8c-.4.4-3.6-.4-5-1.5-1.5-1-2.6-2.4-2.6-2.4l3-.7z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "m336.4 188.3 5 3s4.1 2.8 3.7 3.1c-.4.3-3.7-.8-6-2-2.2-1.3-5-4-5-4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m336.4 188.3 5 3s4.1 2.8 3.7 3.1c-.4.3-3.7-.8-6-2-2.2-1.3-5-4-5-4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M333.2 202.4s1 2.4.4 2.6c-.6.3-2-.2-3-2.3-1.2-2.2 1-1.3 1-1.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M333.2 202.4s1 2.4.4 2.6c-.6.3-2-.2-3-2.3-1.2-2.2.7-1.3.7-1.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M334.9 200.9s1.4 2.3 1.1 2.6c-.3.2-2.2 1-4.2-2s2.1-2.3 2.1-2.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M334.9 200.9s1.4 2.3 1.1 2.6c-.3.2-2.2 1-4.2-2s2.1-2.3 2.1-2.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M330.7 190.4s4.8 9.3 4.4 9.8c-.4.5-2.3 0-3.4-2.5s-1.9-5.6-1.9-5.6z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M330.7 190.4s4.8 9.3 4.4 9.8c-.4.5-2.3 0-3.4-2.5s-1.9-5.6-1.9-5.6z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M336.3 192.8s4 3.3 3.2 3.8c-.8.4-2.4-.2-4.8-2.5-2.3-2.3 1.6-1.5 1.6-1.5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M336.3 192.7s4 3.5 3.2 3.9c-.9.4-2.5-.2-4.8-2.5s1.6-1.4 1.6-1.4z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M334.4 192.8s2.8 5.3 2.5 5.8c-.4.5-2.5-1.3-3.6-2.7-1-1.3-1.9-3.3-1.9-3.3"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M334.4 192.8s2.8 5.3 2.5 5.8c-.4.5-2.5-1.3-3.6-2.7-1-1.3-1.9-3.3-1.9-3.3"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M312.9 203.6s-.2 3.1 0 3.3c.2.3 1.7.3 1.8-2 .1-2.4-.3-2.5-.3-2.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M312.9 203.6s-.2 3.1 0 3.3c.2.3 1.7.3 1.8-2 .1-2.4-.3-2.5-.3-2.5l-1.5 1.1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M313.8 199.9s-1 3.4 0 4.1c1 .7 1.9-3.4 2-4.3 0-1-2 .2-2 .2"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M313.8 199.9s-1 3.4 0 4.1c1 .7 1.9-3.4 2-4.3 0-1-2 .2-2 .2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M314.6 204.3s.2 3.2.8 3.4c.6.1 1.6-1 1.6-1.8s-1-2.8-1-2.8l-1.4 1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M314.6 204.3s.2 3.2.8 3.4c.6.1 1.6-1 1.6-1.8s-1-2.8-1-2.8l-1.4 1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M314.6 200.4s-1 3.5 0 4.2c1 .7 1.9-3.4 2-4.4 0-.9-2 .2-2 .2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M314.7 194.8s-1.6 1.7-1.6 2.6c0 1 2.4-1.2 2.6-1.6.2-.4-1-1-1-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M314.7 194.8s-1.6 1.7-1.6 2.6c0 1 2.4-1.2 2.6-1.6.2-.4-1-1-1-1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M313.6 194s-1.3 2.3-1 3c.4.8 1.6-.5 2.2-1.4.6-.8-1.2-1.7-1.2-1.7"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M313.6 194s-1.3 2.3-1 3c.4.8 1.6-.5 2.2-1.4.6-.8-1.2-1.7-1.2-1.7z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M331.5 190.8s2 3.8 1.5 4c-.6.2-1.4-.7-2.3-1.9-.8-1.1.8-2.1.8-2.1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M331.5 190.8s2 3.8 1.5 4c-.6.2-1.4-.7-2.3-1.9-.8-1.1.8-2.1.8-2.1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M331.6 198.6s.7 3.3 0 3.6c-1.2.5-2-2.3-2-3.4 0-1.2 2-.2 2-.2zm-2.6 5.1s.2 2.5-.2 2.7c-.3.2-1.2.2-2.1-1.8-1-2-.5-1.2-.5-1.2l2.3-1.2.5 1.3"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M331.4 203.2s.2 2.5-.3 2.6c-.5 0-1.9-.8-2.5-2.3-.6-1.8 2.4-1.3 2.4-1.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M329 195.3s2.6 6 2.1 6.7c-.8 1.7-3.2-3.5-3.9-5.6-.8-2.2 1.7-1 1.7-1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M327.7 196.3s3.6 6.5 2.1 6.6c-1.5.2-4.3-4.6-4.7-5.8-.5-1 2.6-.8 2.6-.8z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M327.5 197.7s1.8 6.2.6 5.6c-1-.5-2.5-5.2-2.6-6.2-.2-1 2 .6 2 .6zm6.2-8.8s2.7 4.1 1.8 4.2c-.8.2-4-2.7-4-3.2-.1-.5 2.2-1 2.2-1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M332 189s3.5 4.8 2.4 5c-1 .2-1.1-.5-1.1-.5s-2.8-2.5-3-3.1c-.1-.6 1.6-1.4 1.6-1.4m3.5.1s2.4 2.5 1.8 3.3c-.6.8-4-3.1-4.4-3.6-.4-.5 2.9.2 2.9.2m-6 3.5s3.8 7.5 3 8.2c-.6.8-4.9-5.6-5-6.5-.2-.9 2-1.8 2-1.8"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M327.5 193.2s1.5 2.3 1.4 3.6c0 1.2-2.3-1.8-2.5-2.4-.2-.6 1-1.2 1-1.2zm3.1-1.2s1.2 2.4.8 3.1c-.3.8-2-1.4-2.5-2.3-.6-.8 1.7-.8 1.7-.8z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.2,
      d: "M325 194.4s2 2 1.9 3.1c-.1 1.1-2.8-1.6-3-2-.3-.6 1.2-1.1 1.2-1.1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M337.2 188.4s2.8 2.5 2.4 3c-.5.3-4.3-2.4-4.9-3-.6-.5 2.5 0 2.5 0z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m334.8 188.2 2.2 1.9s2 1.3 1.7 1.7c-.3.3-3.6-1.1-4.1-1.8-.6-.7-.6-1.4-.6-1.4zm7.3.6s8.4 3.4 8 4.2c-.3.8-8.8-2.7-10-3.7-1.4-.9 1.8-.6 1.8-.6"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M342.4 189.8s6.3 3.6 5.5 4c-.7.3-5.2-1-7.5-2.5a36.6 36.6 0 0 1-3.3-2.5l2.8-.6zm-15.5 4.4s1.2 2.4.8 3c-.4.8-1.5-.5-2.1-1.4-.6-.8 1.3-1.6 1.3-1.6zm.3 5.4s1 3.5-.1 4.2c-1.1.6-1.8-3.6-1.8-4.5 0-.9 1.9.3 1.9.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M322.3 193.8s3.5-1.5 4.1-1.4c0 0 .8-.2 1.1-.5l1.3-1s-.6-4.3 3.9-3.8l11.5 1.1a45 45 0 0 1 6.5 2l9 3.9a30 30 0 0 1 4 2.3c.8.5-.1.1-.1.1s-10.7-5.7-14.5-6.4c-1-.2 0 1 0 1l-3.4-1.3a6 6 0 0 0-2.9-.6 5.8 5.8 0 0 1-2.2-.3c-.6-.2-3.8-.3-4.4-.4a7.3 7.3 0 0 1-1-.2l.3.4-1.6-.2-.5.6s-1.5.3-1.6-.2c-.1-.4-1 2.3-1.3 3-.4.9-1.9.9-2.3 1.4l-1 .9c-.2.1-1.3.8-1.7.8l-2.9.2-.6-1zm4.6 10-.1 3.3c-.2.2-1.8.1-1.8-2.2s.5-2.4.5-2.4l1.5 1.2"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M327.3 201.4s-.3-1.4-.5-1.6c-.3-.2 0-.3 0-.3s-.5-1.4-.9-1.6c-.3-.2.1-.4.1-.4s-.6-1-1-1.2c-.4-.3 0-.4 0-.4s-.5-1.2-1.5-1.8c0 0-.7-.7-1.4-.9-.7-.2-2.4-.4-4.5-.3-2.2 0-3.2 1.5-3.2 1.5l-.1 1.8.3-.2-.5 2.2c0 .5.5 1.4.5 2.5v1c.1 1 .4 2 .8 2.9v.2c.2-.2.5.6.7 1 0 0 0 1 .2.6l.6 1.1c0 .2.5 1.4.5.9 0-.6.4 1.3.4 1.5l.5-.7.2.8h.5l-.2.8s1.2-1 1.3-1.4v-.6l.4-.4.6-1s1.5 1.2 1.7 1.7l.3.7.4-.3.3.8.3-.4.2.6.1.3c.1.1.4.2.8-.6.6-1 .6-1.9.6-2 0-.3.3.2.3.2s.6-1 .5-1.6c0-.7.3-.4.3-.4v-2.2c0-.4.3-.3.3-.3l-.2-2.3c-.2-.2.3-.2.3-.2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      d: "M324.3 196.7c.3 0 .4.4.6.6-.1-.4-.3-.7-.6-.8zm.3 1.2c.5.5.6 1.1.5 1.8v.1c0-.7 0-1.5-.5-2zm1.1.7a3 3 0 0 1 .4 1.6c0-.6 0-1.2-.4-1.7m.4 2.5c0 .4 0 .7-.2 1a.4.4 0 0 0 0 .2 11 11 0 0 0 .2-1.2m-.4 1.9v.7a3.8 3.8 0 0 0 0-.8m.7 0c.2.1.3.3.3.6a.4.4 0 0 0 0-.1 1.2 1.2 0 0 0-.3-.7zm0-2.6.4.5v-.2a3.1 3.1 0 0 0-.5-.5zm-1.4 2a5.9 5.9 0 0 1 0 1 6.6 6.6 0 0 0 0-1m-.7.7a5.2 5.2 0 0 1 0 1 6.2 6.2 0 0 0 0-1.1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M310.7 194.3s-.8 3.2-.2 3.5c1.3.7 2-2.2 2.2-3.2.1-1.2-2-.3-2-.3"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M310.7 194.3s-.8 3.2-.2 3.5c1.3.7 2-2.2 2.2-3.2.1-1.2-2-.3-2-.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M312.6 194.3s-1.6 1.7-1.6 2.6c0 1 2.4-1.3 2.6-1.7.2-.4-1-.9-1-.9"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M312.6 194.3s-1.6 1.7-1.6 2.6c0 1 2.4-1.3 2.6-1.7.2-.4-1-.9-1-.9z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M285 194.5s-3.3 1.7-3.6 2.4c-.3.7 10-1 15.8-5l-2.3-1.4z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M285 194.5s-3.3 1.7-3.6 2.4c-.3.7 10-1 15.8-5l-2.3-1.4z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M289 195.2s-6 2.2-1.7 2.3c0 0 8.7-1.8 13.3-5.4l-1.1-1.7z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M289 195.1s-6 2.3-1.7 2.4c0 0 8.7-1.8 13.3-5.4l-1.1-1.7z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M298 189s-6.5 3.4-5.8 3.7c.7.4 5.3-.6 7.7-2l3.4-2.4-2.9-.8-2.5 1.6z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M298 189s-6.5 3.4-5.8 3.7c.7.4 5.3-.6 7.7-2l3.4-2.4-2.9-.8-2.5 1.6z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M295.5 196.3s-2.3 1.9-2 2.1c.2.2 5-.5 8.6-3.4l-.5-1.7z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M295.5 196.3s-2.3 1.9-2 2.1c.2.2 5-.5 8.6-3.4l-.5-1.7-6.2 2.9"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M291.5 196s-2.2 1.7-1.7 1.8c.5.1 2.3 1.5 10.6-3.9l1-.6-1.5-2-8.4 4.5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M291.5 196s-2.2 1.7-1.7 1.8c.5.1 2.3 1.5 10.6-3.9l1-.6-1.5-2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M289.8 189.6a66 66 0 0 0-13.9 7.2l17.9-7m11.2 10.6s-1.5 2.3-1.2 2.5c.3.3 2.1 1.2 4.3-1.7 2-3-2-2.5-2-2.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M305 200.4s-1.5 2.3-1.2 2.5c.3.3 2.1 1.2 4.3-1.7 2-3-2-2.5-2-2.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M306.6 202s-1 2.4-.5 2.6c.6.3 2-.1 3.2-2.2 1.2-2.2-.6-1.1-.6-1.1zm-3.3-3.5s-2.2 2.7-1.7 3.1c.4.4 3 .3 4.9-2.4 1.9-2.6 0 0 0 0l-.5-2.5-2.7 1.7"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M306.6 202s-1 2.4-.5 2.6c.6.3 2-.1 3.2-2.2 1.2-2.2-.6-1.1-.6-1.1zm-3.3-3.5s-2.2 2.7-1.7 3.1c.4.4 3 .3 4.9-2.4 1.9-2.6 0 0 0 0l-.5-2.5-2.7 1.7"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M301.2 197.1s-2.2 2.6-2 3c.2.5 3.2.3 5.6-2.2s.5-3.5.5-3.5l-4 2.6"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M301.2 197.1s-2.2 2.6-2 3c.2.5 3.2.3 5.6-2.2s.5-3.5.5-3.5l-4 2.6"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "m297.4 197.3-1.4 1.9s.3 1.8 5.1-1.5l4.5-3-2.5-.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m297.3 197.2-1.3 2s.3 1.8 5.1-1.5l4.5-3-2.6-.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "m282.2 194.5-3 1.3s-.7.6 1 .7c1.8 0 5.5-.5 11.9-4 2.8-1.7 4.7-3.3 4.7-3.3l-2.4-.8-12.2 6z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m282.2 194.5-3 1.3s-.7.6 1 .7c1.8 0 5.5-.5 11.9-4 2.8-1.7 4.7-3.3 4.7-3.3l-2.4-.8-12.2 6z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M277 196.4s4.4-.5 6-1.6c0 0-.3.5 2-.4 0 0-1.2 2 5.3-2 6.5-3.8 0 0 0 0l7.2-4.1-.4-.8-14.7 6.2c-1 .3-5.4 2.7-5.4 2.7"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m290.3 192.4 7.2-4.1-.4-.8-14.7 6.2c-1 .3-5.4 2.7-5.4 2.7s4.4-.5 6-1.6c0 0-.3.5 2-.4 0 0-1.1 2 5.3-2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M308.5 202s-.4 3.4.1 3.5c.5.1 2-1 2.6-3 .6-2.2-2.4-2-2.4-2l-.4 1.3"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.2,
      d: "M308.5 202s-.4 3.4.1 3.5c.5.1 2-1 2.6-3 .6-2.2-2.4-2-2.4-2l-.4 1.3"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M310.8 203.5s-.3 2.4 0 2.6c.4.3 1.3.4 2.3-1.6 1-2 .5-1.3.5-1.3l-2.3-1.2-.5 1.3"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M310.8 203.4s-.3 2.5 0 2.7c.4.3 1.3.4 2.3-1.6 1-2 .5-1.3.5-1.3l-2.3-1.2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M311.4 199s-1.9 4-.8 4c1 0 2.5-3 2.7-3.7.2-.7-1.9-.3-1.9-.3"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M311.4 199s-1.9 4-.8 4c1 0 2.5-3 2.7-3.7.2-.7-1.9-.3-1.9-.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M311.3 199s-.8 4.5.2 4c1-.3 1.6-3.7 1.7-4.4 0-.7-2 .4-2 .4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M311.3 199s-.8 4.5.2 4c1-.3 1.6-3.7 1.7-4.4 0-.7-2 .4-2 .4z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M312.8 199.4s-1.1 3.5 0 4.2c1 .7 1.8-3.4 1.9-4.3 0-1-2 .1-2 .1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M312.8 199.4s-1.1 3.5 0 4.2c1 .7 1.8-3.4 1.9-4.3 0-1-2 .1-2 .1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M308.4 198.3s-1 3.2-.4 3.5c1.2.6 2.3-2.2 2.4-3.3.1-1.2-2-.2-2-.2zm-7.9-6.6s-2.8 2.4-2.5 2.7c.3.4 3.6-.2 5.1-1.3l2.1-1.5-2.5-1.6z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M303 189.3s-1.8 1.5-1.5 1.9c.4.3 3.6-1 4.2-1.7.6-.6.6-1.3.6-1.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M304.9 189s-2.5 2.1-1.9 2.9c.6.7 4-2.6 4.5-3 .5-.4-2.9 0-2.9 0"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m303.8 188.2-5 2.3s-4.2 2.7-3.8 3c.4.3 3.7-.6 6-1.7a37.9 37.9 0 0 0 5-3.1m-.9 2.1s-5.3 4.7-4.5 5.1c.8.5 4.4-1.4 6.8-3.7"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M305.8 192.4s-3 5-2.7 5.6c.4.5 2.6-1.2 3.7-2.5s2-3.2 2-3.2"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M307.6 192.8s-3.3 6.1-3 6.6c.4.5 2.4.1 3.5-2.3 1.2-2.4 1-4 1-4z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M309.5 193.1s-3.7 7.6-3 8.3c.8.8 4.8-5.7 5-6.6.3-1.6-2-1.8-2-1.8m-7.7-4.9s-3.3 1.6-2.7 2c.7.2 3.8-1.2 4.2-1.3.5-.1-1.5-.7-1.5-.7z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M302.3 188.6s-2 1.6-1.6 2c.4.5 3.5-1.2 4-1.7.7-.5-2.4-.3-2.4-.3zm4.3.2s-2.8 3.7-2 3.8c.9.2 4.1-2.4 4.2-2.8 0-.5-2.2-1-2.2-1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M307.8 189.6s-3 3.7-2.1 4c.8.2 1-.4 1-.4s2.3-2 2.4-2.5c.2-.5-1.2-1.2-1.2-1.2"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M308.7 190.5s-2.1 3.7-1.6 4c.6.2 1.5-.8 2.4-1.9.9-1-.8-2.1-.8-2.1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M309.3 192.2s-1.3 2.3-1 3c.4.8 1.6-.5 2.2-1.3.6-.8-1.2-1.7-1.2-1.7zm.5 6.5s-.8 3.2-.2 3.5c1.3.7 2-2.2 2.2-3.2.1-1.2-2-.3-2-.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M315.7 194.4s-.9-.3-1.5-.3c0 0-1.9-1.4-3-1.6-1-.1 0-.2 0-.2s-.2-2.4-.5-2.6c0 0-.1-2.5-1.7-2.6-1.6-.2-5.1.1-5.7-.1-.7-.3-2.6-1-6.3 0-3.8 1-11.2 4.3-11.6 4.4-.4 0 8.5-2 11-3l3.3-.5s-2.8 1.4-.2.8c2.6-.6 2 0 2 0s-.2.6 1.3.3c1.4-.4 1.4 0 1.4 0s1.7.6 3-.2c0 0 .7 2.3 1.6 2.6 0 0 1 2.2 3.1 2.6l1.2.9 1.2.4 1.3-1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M298.3 188s-8.6 3-8.3 3.9c.4.8 9-2.4 10.3-3.2 1.4-1-2-.7-2-.7"
    }),
    /* @__PURE__ */ jsx100("path", {
      d: "m321.8 194.6.5.2a1.5 1.5 0 0 0-.3-.3l-.7-.3.1.2zM315 201c.2.2.2.5.3.8v-.2c-.1-.2-.1-.5-.3-.7zm1.2-6.5.9-.2v-.1l-.9.1zm1.7-.2.8-.1a.3.3 0 0 0 0-.1 2 2 0 0 0-.8.1zm-3 1.5a.3.3 0 0 0 0 .2zm-.1 4.6a4.8 4.8 0 0 0 0 .7.4.4 0 0 0 0-.1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#bd8759",
      d: "M316.6 213.9s-1 .7-1 1a3.8 3.8 0 0 0-.2.8s.8-.1.7.3c0 0 .3.2.8-.8.4-1 .8-1.5 1.1-1.5.4 0 .8.4 1 .6.2.2.4.4.8.3 0 0-.4-.6-.2-.7l.6-.1s-.3-.7-.9-.8c-.6-.1-1-.3-1-.6.2-.2 1-2.4 1-2.4l-1-1.5-.5 1.3.2 1-1 2.1c0 .1-2.4 1-2.7 1l-.8.9v.5s.3-.4.4-.2c0 0 .3-.3.6-.2.2.1.1.2.1.2l.5-.4.1-.1.6-.1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M316.6 213.9s-1 .7-1 1a3.8 3.8 0 0 0-.2.8s.8-.1.7.3c0 0 .3.2.8-.8.4-1 .8-1.5 1.1-1.5.4 0 .8.4 1 .6.2.2.4.4.8.3 0 0-.4-.6-.2-.7l.6-.1s-.3-.7-.9-.8c-.6-.1-1-.3-1-.6.2-.2 1-2.4 1-2.4l-1-1.5-.5 1.3.2 1-1 2.1c0 .1-2.4 1-2.7 1l-.8.9v.5s.3-.4.4-.2c0 0 .3-.3.6-.2.2.1.1.2.1.2l.5-.4.1-.1.6-.1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#bd8759",
      d: "M323.1 209.2v2.1c0 .3 0 .8-.2 1.1-.2.3-.4.5-.7.5-.3 0-1 0-1.2.3l-.3.4s.5-.3.6 0l-.2.6.9-.2.8-.3.4.2v1c0 .4 0 1.2.3 1.2l.4-.5.5.5-.1-1.2a6.7 6.7 0 0 1-.3-1l1.5.6c0 .2.4.5.5.5.1 0 0-.5.2-.5.3-.1.4 0 .4 0s-.4-.8-1-1c-.5-.4-1-.4-1.2-.6l-.3-.9v-2.8l-1-.2"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M323.1 209v2.3c0 .3 0 .8-.2 1.1-.2.3-.4.5-.7.5-.3 0-1 0-1.2.3l-.3.4s.5-.3.6 0l-.2.6.9-.2.8-.3.4.2v1c0 .4 0 1.2.3 1.2l.4-.5.5.5-.1-1.2-.3-1s1.4.5 1.5.7l.5.4c.1 0 0-.5.2-.5.3-.1.4 0 .4 0s-.4-.8-1-1c-.5-.4-1-.4-1.2-.6l-.3-.9v-2.8z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#dcddde",
      d: "M315 197.3s0-1.3.3-1.4c0 0 .1-1.2 1.7-1 0 0 .5-.9 1.4-.4 0 0 .8-.4 1.3-.2l1 .7s.7-.1 1 .1c.3.3.2 1.1.2 1.1s.8.6.8 1.1v.9s.3.3.2.7c0 .4-.4 1-.4 1-.1 0 0 1-.3 1.3l-.8.5c-.2 0-.6.6-1 .6-.3 0-.8-.5-.8-.7 0-.2-.6-.4-.6-.4s-1 1.2-1.8 1c-.8-.2-1.1-.8-1.2-1l-.3-1s-.8-.4-.7-.9c0-.4.4-1 .4-1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m317.8 212-.2-.1m.6-.9a.8.8 0 0 1-.3-.1m0 .6h.2m5.5.5.5.2m-.2-.6h-.3m.4-.5a.9.9 0 0 1-.5 0m0 1.8.4.1m-.4.5a.2.2 0 0 1 .2 0m-.1 1.6a.4.4 0 0 1 .3 0m-5.1-2a.3.3 0 0 0-.3.1m1-.1c-.1.1-.3.2-.3.4m-4.5.5.4.3m10-1a.3.3 0 0 0-.3.3m.7-.1a.2.2 0 0 0 0 .2"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d9c0b9",
      d: "M313.4 215h.6s-.3.7-.2.8c0 .2-.5-.3-.3-.7"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M313.4 215h.6s-.3.7-.2.8c0 .2-.5-.3-.3-.7z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d9c0b9",
      d: "M315.6 215.5s-.7 1 .1 1.5c0 0 0-1 .6-1.1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M315.6 215.5s-.7 1 .1 1.5c0 0 0-1 .6-1.1z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d9c0b9",
      d: "m319.6 214.5-.2-.5.2-.3h.6s.4.9 0 1.3c0 0 0-.5-.2-.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m319.6 214.5-.2-.5.2-.3h.6s.4.9 0 1.3c0 0 0-.5-.2-.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d9c0b9",
      d: "M321 213.4h.3l.1.3v.3l-.3.2s-.5-.2-.4.5c0 0-.3-1.2.2-1.3"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M321 213.4h.3l.1.3v.3l-.3.2s-.5-.2-.4.5c0 0-.3-1.2.2-1.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d9c0b9",
      d: "m323.5 215.9.4-.4.4.2-.3 1.2-.2-.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m323.5 215.9.4-.4.4.2-.3 1.2-.2-.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d9c0b9",
      d: "m326 214.8.5 1s.6-.6-.2-1.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m326 214.8.5 1s.6-.6-.2-1.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      d: "m323.3 195.9.2.2v-.1zm.1 2.2.4.7v-.2a1.7 1.7 0 0 0-.4-.7zm-.4-1.6.5.6v-.2zm.5 3.5c0 .3 0 .6-.2.8v.2c.2-.4.2-.7.2-1.1a.5.5 0 0 0 0 .1m.5 1v.5a.4.4 0 0 0 0 .1 2.2 2.2 0 0 0 0-.6m1.8 3.9a4.8 4.8 0 0 1 .1 1.3l-.1-1.5zm-.3.8-.4 1 .4-.8zm-10.3-2.9.7 1.2v-.1zm1.8 0c-.2 0-.3-.3-.5-.4v.2c.2 0 .3.4.5.4zm-1 1.8.5 1v-.2l-.5-1zm1.2.4.5.8v-.1c0-.3-.3-.6-.5-.8m0 1.3.2.7v-.1zm1.1.3a2.8 2.8 0 0 1 .1.7 3.3 3.3 0 0 0 0-.9v.2m-.5 1c0 .3.1.7.3 1v-.2a3.2 3.2 0 0 1-.3-.9.4.4 0 0 0 0 .1m.2-4.4.8.3v-.1a8 8 0 0 1-.8-.3zm.2 1.2 1 .4c-.3-.3-.7-.4-1-.6zm.3 1.2.6.6v-.1a4.5 4.5 0 0 1-.6-.6zm.4 1.6.2.7a1.8 1.8 0 0 0-.2-.8zm1-4v.5a10 10 0 0 1 0-.5m2.3-.9a3.6 3.6 0 0 1-.2.5v.1l.2-.4zm1 0v.8a.4.4 0 0 0 0 .1 4.2 4.2 0 0 0 0-1m.2 1.6v.7a3.7 3.7 0 0 0 0-.8m.7 1.5c0 .3-.2.6-.5.8v.1c.3-.2.5-.4.5-.8m-2.4-1.5-.2.4v.1zm.3 1.8a1.9 1.9 0 0 1-.4.4v.1c.2 0 .3-.2.4-.3zm-.9 1c-.3-.4-.4-.8-.3-1.3v-.1c-.2.5 0 1 .3 1.5v-.2m-1-1-.1.5v-.6m2.6 1.3c0 .3-.2.5-.3.7v.1l.3-.6zm1.7.7a9.2 9.2 0 0 1-.5.7v.2zm.8.8a17 17 0 0 0-.2 1.3v.1za.6.6 0 0 0 0-.1m1-1.6v.5zM315 202l.1 1.3v-.2a2.2 2.2 0 0 1-.1-1 .6.6 0 0 0 0-.1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#fff",
      d: "M318.8 196.3c.7-.6 1.7-1.3 2.7-1v-.2c-1-.2-2 .5-2.7 1.1zm3.5.8c-.8-.5-2-.6-2.7 0 .7-.5 2-.3 2.7.2zm-2.8 1.1c.3 1 .7 2 .5 3 .2-1-.2-2-.5-3m-1.1.6v3c0-1 .2-2 0-3.1a.4.4 0 0 0 0 .1m1.5-.7c1 .2 1.9.9 2.4 1.7v-.1a3.9 3.9 0 0 0-2.4-1.7zm-.8 1.3c0 .6 0 1.2-.2 1.8.2-.5.2-1.2.2-1.8m1.4-.1a3.1 3.1 0 0 1 1.2 2v-.1a3.2 3.2 0 0 0-1.2-2m-4.3 1.7c.2-.3.4-.6.8-.7v-.1c-.4 0-.6.4-.8.7zm1.4-5c-.1-.6-.5-1-1-1.2v.1c.5.3.9.6 1 1.2zm-.8 0c-.5-.2-1-.2-1.5-.2a.3.3 0 0 0 0 .1c.5 0 1 0 1.5.3zm1.5 0c0-.6 0-1-.4-1.3.3.3.5.7.4 1.2m1.8.7c.5-.3 1-.2 1.5-.2v-.2c-.5 0-1 0-1.5.2zm.9 1.2a2.6 2.6 0 0 1 1.7 1v-.3a2.6 2.6 0 0 0-1.7-1zm-3.1 2c-.2.6 0 1.5-.9 1.8v.2c.8-.3.7-1.1.9-1.8z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#fff",
      d: "M319.5 199c.3.7.7 1.4.5 2.2a.9.9 0 0 0 0 .3c.2-1-.1-1.8-.5-2.7zm1-.1c.7 0 1.3.7 1.4 1.4a1 1 0 0 0 0-.2 1.7 1.7 0 0 0-1.4-1.5zm0 1c.1.6.3 1.2.1 1.8v.2c.3-.7 0-1.5 0-2.2a1 1 0 0 0 0 .2m-.4-2.6c.7-.1 1.5-.2 2.2.3v-.3c-.7-.5-1.5-.4-2.2-.2zm-1.4-1.5c0-.6.6-1 1.2-1.3v-.2c-.6.2-1.2.6-1.3 1.3a1 1 0 0 0 0 .2m-.6.4c0-.7-.4-1.3-.7-1.9v.2c.3.6.6 1.1.6 1.8zm-.6.4a2 2 0 0 0-1-1.4v.3c.5.3.9.7 1 1.3a.8.8 0 0 0 0-.2m-1-.3a2.9 2.9 0 0 0-1.2-.5v.2c.5 0 .8.3 1.2.5zm2.2 3c0 .6.2 1.3-.2 1.9v.2c.4-.7.3-1.6.2-2.3z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#fff",
      d: "M319.4 198.9c.2.6.5 1.3.4 2a5.8 5.8 0 0 0-.4-2.3zm.5-1c.6.3 1.3.5 1.7 1v-.3a3.6 3.6 0 0 0-1.7-.9zm-1.7-1.4a14.8 14.8 0 0 0 0-1.7 11.8 11.8 0 0 1 0 1.7m-1.2-.4a5.6 5.6 0 0 1-1.2-.8v.2l1.2.9zm-.2 3.3c-.3.2-.5.5-.6.8v.2a1.6 1.6 0 0 1 .6-.7zm.9.5c0 .5-.3.9-.6 1.2v.2c.4-.4.6-.8.6-1.3 0 0 0-.3 0 0m2.1-3.6c.4-.6 1.3-.7 1.9-.9v-.2c-.6.2-1.5.2-2 .8v.3m-4 0a2 2 0 0 1-.5-.3v.2l.4.2v-.2m.1 3-.4.3v.1a.7.7 0 0 0 0 .1.8.8 0 0 1 .4-.2.7.7 0 0 0 0-.2m.5.1-.6.6v.2l.6-.6zm1 .3c-.1.6-.8 1.2-.3 1.8v-.2c-.3-.5.2-1 .4-1.4zm.7 0c0 .6 0 1.1-.2 1.7a.9.9 0 0 0 0 .2 9.8 9.8 0 0 0 .2-2m1.9-.6c.4.5.8 1.1 1 1.8v-.2a5 5 0 0 0-1-1.9zm.2-.5c.7.6 1.5 1 2 1.8v-.2c-.5-.8-1.3-1.3-2-1.8z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#fff",
      d: "M320.5 197.8h.8l.6.5.6.4c.2.2.2.6.3.9a.7.7 0 0 0 0-.2l-.2-.7c0-.2-.3-.4-.5-.5l-.7-.4a1.4 1.4 0 0 0-.9-.2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#fff",
      d: "m322.3 199.3.2.6v-.1l-.2-.7zm-2-3.6 1.5-.4v-.3l-1.5.4zm-2 .2c0-.2.1-.5.3-.7l.4-.8v-.3l-.4.7c0 .3-.3.5-.4.9zm-1.7 4.6.1 1.3v-.2a1.4 1.4 0 0 1 0-.8.7.7 0 0 0 0-.2s0-.1 0 0m1 .7c-.2.3-.2.6-.1 1a.3.3 0 0 0 0-.2zm.8-.5-.2.7v.2zs0-.2 0 0m0-1.5v.4zm-.3.2a.7.7 0 0 0 0 .3v-.7zm-.5-.2-.1.5a.8.8 0 0 0 0 .2 3.3 3.3 0 0 1 .1-.4zm-.4 0-.8.6v.3l.8-.7zm-.6 0a1.6 1.6 0 0 1-.5.3v.3c.2 0 .3-.2.5-.3v-.2m-1-.3-.4.2v.2c.2 0 .3 0 .4-.2zm2.9 0v.4a.8.8 0 0 0 0-.2v-.4zm.4-.2.1.6v-.3a1 1 0 0 1 0-.3v-.1.1m.3 0v.3h.1a.8.8 0 0 0-.1-.6zm.4-.2.4.2v-.2a.8.8 0 0 0-.4-.2zm.2-.3.6.3v-.3a1.2 1.2 0 0 1-.6-.3zm.5-1h.4v-.2a2.3 2.3 0 0 0-.4-.1zm-.3-.6.4-.3v-.3l-.4.4zm-.4-.5a1 1 0 0 1 .2-.5v-.2a1 1 0 0 0-.2.7m-.3-.2.4-.8v-.2l-.4.7z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#fff",
      d: "M318.6 195.3v.9a.7.7 0 0 0 0-.3 3.7 3.7 0 0 1 0-.7zm-1.3.2.2.3v.6l.1-.5-.3-.6zm-.2.5a4.5 4.5 0 0 0-.6-.4v.2l.6.5zm.8.2c0-.6 0-1.2-.2-1.7v.3c.2.4.3.7.2 1.2a.8.8 0 0 0 0 .1m1.2-.7v-.2z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#fff",
      d: "m317.7 196.3.2-1v-.2l-.2 1zm3.5 2c.3 0 .6.3.7.6v-.4c-.1-.3-.4-.5-.7-.6zm-1 2a1 1 0 0 1 0 .4 1.2 1.2 0 0 0 0 .3h.1v-1 .3m-.8-.5v1.2s0 .2 0 0v-1.4zm-.4.4-.3 1.2a1 1 0 0 0 0 .3s0 .1 0 0l.3-1.2zm.5.2v1.1a1.3 1.3 0 0 0 0 .3v-1.6zm-2.6.2a.6.6 0 0 1 0 .1v.4c.1-.2.1-.6 0-.8 0-.1 0 0 0 0zm1.2-.8v.4c0-.3.1-.6 0-.8zm.3 0a.4.4 0 0 1 .1 0v.1a.8.8 0 0 0 0 .1v-.2l-.1-.5a1.3 1.3 0 0 0 0 .2zm.4-.3.1.3v-.3l-.1-.4a.9.9 0 0 0 0 .1v.2m.8-.2.5.6v-.4a9.3 9.3 0 0 1-.5-.6zm.5-.8.3.6v-.4a4.1 4.1 0 0 1-.3-.5zm-4.3-2a1.7 1.7 0 0 0-.4-.2 1.1 1.1 0 0 0 0 .2v.2l.4.3zm1.3-.5a.5.5 0 0 1 0 .1.8.8 0 0 0 0 .2za1 1 0 0 0 0-.4.8.8 0 0 0 0 .2zm1-1v.8c-.1 0-.1.1 0 .2v.1l.1-1.2a.6.6 0 0 0 0-.1v.2m.2 1.5.5-.7v-.3l-.5.6zm.7 0 .2-.3v-.4l-.2.2a1.3 1.3 0 0 0 0 .2v.2m1 .2a7.6 7.6 0 0 1-.8 0v.4h.8zm-.3.9 1 .6v-.4l-1-.6z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#fff",
      d: "m320 198 .8.5v-.4l-.8-.5a2 2 0 0 0 0 .2zm-2-1.4.1-.5v-.2.6m-2.3-1c.2.3.5.6.9.8l.6.7s.1-.4 0-.4l-.6-.6-1-.9c.1 0 0 .3 0 .4m.6 1a7.7 7.7 0 0 1-.4-.4 1.6 1.6 0 0 0 0 .2v.1l.4.5zm-.3 2.5-.3.6v.4l.3-.6zm.3.4-.1.6a1.3 1.3 0 0 0 0 .3zv-.2a.6.6 0 0 0 0 .1m1 1.8c.2-.6.2-1.3.2-2v.2c0 .5 0 1-.2 1.4zm.6-1.5v.6a1.3 1.3 0 0 0 0 .3v-1.3a.6.6 0 0 0 0 .2zm.6-.2c.2.2.3.6.2 1v.1c.1-.5.1-1-.2-1.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#fff",
      d: "M318.6 199.3a12.6 12.6 0 0 1 .3 1.7v-.3l-.2-1.7v.3m.5-.1.6 1v-.3l-.6-1zm1.1-1c0-.1-.3-.2-.5-.1v.3c.2 0 .4 0 .5.2v-.3"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#fff",
      d: "M319.7 198.1a7.5 7.5 0 0 1 1.1 0v-.4a7.5 7.5 0 0 0-1 0c-.1 0 0 .4 0 .4m.6-3c-.3.4-.4.9-.5 1.3v.3s0 .1 0 0c0-.4.2-.8.5-1.1zm-1.5.4.2 1a.7.7 0 0 0 0-.2v-.2l-.2-1zm-.3.5a1.6 1.6 0 0 1-.3-.5.8.8 0 0 0 0 .2v.2l.2.5v-.3m-.5.2a4 4 0 0 1-1.2-.6v.4l1.2.6s.1-.4 0-.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#dba05f",
      d: "m318.5 196.2-2.2.4-1.8.2-1.3-.4c-.3 0-1.6-.2-2 .3l-.9.8c-.1.1-.7.6-.7.9 0 .2.1.5.4.5.3 0 .9.6.9.7 0 .3.8.5 1.5.5 1.3 0 2-.7 4-.5 1 .2 3-.7 3.4-1.2.4-.5.6-1 .2-1.7-.3-.6-1.4-.5-1.5-.5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m318.5 196.2-2.2.4-1.8.2-1.3-.4c-.3 0-1.6-.2-2 .3l-.9.8c-.1.1-.7.6-.7.9 0 .2.1.5.4.5.3 0 .9.6.9.7 0 .3.8.5 1.5.5 1.3 0 2-.7 4-.5 1 .2 3-.7 3.4-1.2.4-.5.6-1 .2-1.7-.3-.6-1.4-.5-1.5-.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      d: "m311.4 198.1.1-.1.1-.2a.8.8 0 0 1 .4-.3h.5-.2.2-.2l-.3.1c-.3 0-.3.4-.6.6"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      d: "m311.3 198 .4-.4.6-.3h.3"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      d: "m312 197.4-.4.3c0 .2-.3.3-.3.3m.7-.5h.5m-.6 0h.5"
    }),
    /* @__PURE__ */ jsx100("path", {
      d: "m312.4 197.9-.2.1-.1.1-.3.2-.3.1.4-.2-.4.2.4-.1-.3.1h.1s.3 0 .7-.4"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      d: "m312.3 197.8-.3.2-.3.2-.2.1m.4-.1.2-.2.2-.2m-.4.4-.3.1m.4-.1-.3.1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#c6262c",
      d: "M312.9 196.5s0-.6-.6-.8c-.5-.2-1-.2-1.3-.2l-.5.2a2.5 2.5 0 0 0-.6.2l-.1.2c-.1.2-.4.4-.3.6.2.3 0 .3.2.3s-1 .3-.8.8c.3.6.5.4.6.3l.5-.2.7-.7 1-.4h.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M312.9 196.5s0-.6-.6-.8c-.5-.2-1-.2-1.3-.2l-.5.2a2.5 2.5 0 0 0-.6.2l-.1.2c-.1.2-.4.4-.3.6.2.3 0 .3.2.3s-1 .3-.8.8c.3.6.5.4.6.3l.5-.2.7-.7 1-.4h.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      d: "M312.2 197.8c0 .1-.1.3-.3.3h-.3s.1-.4.3-.4z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d9c0b9",
      d: "M308.6 200.2s-.7-1.2 1.2-1.8c0 0 .6.3.8.6 0 0-.4.5-1.5.7 0 0-.5.1-.5.5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M308.6 200.2s-.7-1.2 1.2-1.8c0 0 .6.3.8.6 0 0-.4.5-1.5.7 0 0-.5.1-.5.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#d9c0b9",
      d: "M308.8 200s.8.2 1.3-.2c.5-.3.6-.2.7-.1 0 0 0-.4-.2-.7l-1 .5c-.4.2-.7.1-.8.5"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M308.8 200s.8.2 1.3-.2c.5-.3.6-.2.7-.1 0 0 0-.4-.2-.7l-1 .5c-.4.2-.7.1-.8.5z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#7a2e26",
      d: "M311 199.6h.5v-.1za.3.3 0 0 0 0 .1m-.3-2-.1.2v.1zm.5.2.3-.2v-.1c-.2 0-.3 0-.3.2zm.5.8a.3.3 0 0 0 .2-.2.3.3 0 0 1-.2 0zm.4-.2a.8.8 0 0 0 .4-.3v-.1a.7.7 0 0 1-.4.3zm-.7-.7c0 .2-.2.2-.3.4v.1c0-.1.3-.2.3-.4m.3 2c.4 0 .7 0 1-.2a3.1 3.1 0 0 1-1 0zm1.6 0c.4-.4.8-.7 1-1.3a2 2 0 0 1-1 1v.2m.3-.8c.3-.2.5-.4.6-.8v-.1a1.6 1.6 0 0 1-.6.8zm-.2-2 .7.4v-.1l-.7-.4zm6.3 1c.2-.5 0-1-.2-1.4.2.4.4.8.2 1.2zm-4.8-.7c.3.2 1 .7.8 1.2.3-.5-.4-1-.8-1.3zm2.1 2a1.4 1.4 0 0 0 .1-.3 1.3 1.3 0 0 1 0 .3"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#5e3f17",
      d: "m317.9 199.2.5-.2m-8.5-.3c-.3.2-.8.2-1 .7.2-.5.7-.5 1-.6"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#842116",
      d: "M309.7 197.3c.1 0 .3 0 .3.2a.4.4 0 0 0 0 .1.7.7 0 0 0 0-.3l-.3-.1m.7.4a.7.7 0 0 0-.1-.6v.5m.6-.5c0-.3-.1-.5-.3-.6v.1c.2.1.3.4.3.6a.4.4 0 0 0 0-.1m.5-.1c0-.3 0-.5-.2-.6v.1l.2.3a.4.4 0 0 0 0 .1m-.8-.7c.4-.2 1.4-.3 1.8.2v-.2c-.4-.4-1.4-.3-1.8 0"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#7a2e26",
      d: "M309.5 198.1v-.5s-.1 0 0 .1zm4.7 1.4a.6.6 0 0 0 .3-.5.6.6 0 0 1-.3.3zm.7 0a.4.4 0 0 0 .1-.3v-.1.3m4.3-2.4a1 1 0 0 1 0 .7.4.4 0 0 0 0 .1v-.9zm-.5.5v.7c.1-.3.2-.6 0-.9zm-.4.3"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M324.3 210.5v.2l.1.1-.1-.4z"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#dcddde",
      d: "M314.4 195c-1.7 0-3.3-1-3.3-1a2.7 2.7 0 0 1-2.3-2.4c-.8-.4-1.6-2.5-1.6-2.5-1.3.7-3 0-3 0s0-.4-1.4 0c-1.5.3-1.3-.3-1.3-.3s.6-.6-2 0 .2-.8.2-.8c-.8.2-3.3.4-3.3.4-.9 0-1.8.5-2.8.8l-2.3.6-6.8 3-5.5 2.1c.2 0 3.4-2.1 7.5-4a87.8 87.8 0 0 1 10.3-3.9 9.9 9.9 0 0 1 6.5 0c.6.2 4.2 0 5.7 0 1.6.3 1.8 2.9 1.8 2.9.3.1.4 2.6.4 2.6s-1 0 .1.1c1 .2 2.9 1.7 2.9 1.7h.7s.4-.5.9-.7l1.5-.5a11.6 11.6 0 0 1 2 0l2 .3 1.2.3h.5c1-.5 3-1.2 3.4-1.1 0 0 .7-.2 1.1-.5a105 105 0 0 0 1.3-1s-.6-4.5 3.9-4l11.5 1.2a43.9 43.9 0 0 1 6.5 1.8l5.2 2.4 4 1.7c2.3 1 4 2.4 4 2.4-1.5-.6-2.6-1.3-3.7-1.8-.9-.4-1.8-.5-2.6-.9l-3.6-1.7c-3.5-1.6-3.5-1.7-4.9-1.8-1 0 .7 1.2.7 1.2l-4.1-1.7a6 6 0 0 0-2.9-.5 5.8 5.8 0 0 1-2.2-.3c-.6-.2-3.8-.3-4.4-.4a7.3 7.3 0 0 1-1-.2l.2.4-1.5-.3-.5.7s-1.5.3-1.6-.2c-.1-.5-1 2.2-1.3 3-.4.8-2.2.6-2.7 1-.4.5-1.4.9-1.6 1h-1.3c-.6 0-.1 0-1 .3 0 0-.9 0-1.2-.2l-1.4-.4a27.5 27.5 0 0 0-3.5-.2 5.4 5.4 0 0 0-2.7 1.1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#e7e7e7",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M314.4 195c-1.7 0-3.3-1-3.3-1a2.7 2.7 0 0 1-2.3-2.4c-.8-.4-1.6-2.5-1.6-2.5-1.3.7-3 0-3 0s0-.4-1.4 0c-1.5.3-1.3-.3-1.3-.3s.6-.6-2 0 .2-.8.2-.8c-.8.2-3.3.4-3.3.4-.9 0-1.8.5-2.8.8l-2.3.6-6.8 3-5.5 2.1c.2 0 3.4-2.1 7.5-4a87.8 87.8 0 0 1 10.3-3.9 9.9 9.9 0 0 1 6.5 0c.6.2 4.2 0 5.7 0 1.6.3 1.8 2.9 1.8 2.9.3.1.4 2.6.4 2.6s-1 0 .1.1c1 .2 2.9 1.7 2.9 1.7h.7s.4-.5.9-.7l1.5-.5a11.6 11.6 0 0 1 2 0l2 .3 1.2.3h.5c1-.5 3-1.2 3.4-1.1 0 0 .7-.2 1.1-.5l1.3-1s-.6-4.5 3.9-4l11.5 1.2a43.9 43.9 0 0 1 6.5 1.8l5.2 2.4 4 1.7c2.3 1 4 2.4 4 2.4-1.5-.6-2.6-1.3-3.7-1.8-.9-.4-1.8-.5-2.6-.9l-3.6-1.7c-3.5-1.6-3.5-1.7-4.9-1.8-1 0 .7 1.2.7 1.2l-4.1-1.7a6 6 0 0 0-2.9-.5 5.8 5.8 0 0 1-2.2-.3c-.6-.2-3.8-.3-4.4-.4a7.3 7.3 0 0 1-1-.2l.2.4-1.5-.3-.5.7s-1.5.3-1.6-.2c-.1-.5-1 2.2-1.3 3-.4.8-2.2.6-2.7 1-.4.5-1.4.9-1.6 1h-1.3c-.6 0-.1 0-1 .3 0 0-.9 0-1.2-.2a17.9 17.9 0 0 0-1.4-.4c-.5-.2-3.1-.2-3.5-.2a5.4 5.4 0 0 0-2.7 1.1"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#452c25",
      d: "M314.6 194.4s-.2.2-.2.5v.2"
    }),
    /* @__PURE__ */ jsx100("path", {
      fill: "#574f4c",
      d: "m323.3 194 .7.5a.5.5 0 0 0-.1-.1 6.5 6.5 0 0 0-.7-.6.6.6 0 0 0 0 .1"
    })
  ]
});
var Bo_default = SvgBo;

// src/country-flag-icons/generated/Bq.tsx
init_esm_shims();
import { jsx as jsx101, jsxs as jsxs76 } from "react/jsx-runtime";
var SvgBq = (props) => /* @__PURE__ */ jsxs76("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx101("path", {
      fill: "#21468b",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx101("path", {
      fill: "#fff",
      d: "M0 0h640v320H0z"
    }),
    /* @__PURE__ */ jsx101("path", {
      fill: "#ae1c28",
      d: "M0 0h640v160H0z"
    })
  ]
});
var Bq_default = SvgBq;

// src/country-flag-icons/generated/Br.tsx
init_esm_shims();
import { jsx as jsx102, jsxs as jsxs77 } from "react/jsx-runtime";
var SvgBr = (props) => /* @__PURE__ */ jsx102("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs77("g", {
    strokeWidth: "1pt",
    children: [
      /* @__PURE__ */ jsx102("path", {
        fill: "#229e45",
        fillRule: "evenodd",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsx102("path", {
        fill: "#f8e509",
        fillRule: "evenodd",
        d: "m321.4 436 301.5-195.7L319.6 44 17.1 240.7z"
      }),
      /* @__PURE__ */ jsx102("path", {
        fill: "#2b49a3",
        fillRule: "evenodd",
        d: "M452.8 240c0 70.3-57.1 127.3-127.6 127.3A127.4 127.4 0 1 1 452.8 240"
      }),
      /* @__PURE__ */ jsx102("path", {
        fill: "#ffffef",
        fillRule: "evenodd",
        d: "m283.3 316.3-4-2.3-4 2 .9-4.5-3.2-3.4 4.5-.5 2.2-4 1.9 4.2 4.4.8-3.3 3m86 26.3-3.9-2.3-4 2 .8-4.5-3.1-3.3 4.5-.5 2.1-4.1 2 4.2 4.4.8-3.4 3.1m-36.2-30-3.4-2-3.5 1.8.8-3.9-2.8-2.9 4-.4 1.8-3.6 1.6 3.7 3.9.7-3 2.7m87-8.5-3.4-2-3.5 1.8.8-3.9-2.7-2.8 3.9-.4 1.8-3.5 1.6 3.6 3.8.7-2.9 2.6m-87.3-22-4-2.2-4 2 .8-4.6-3.1-3.3 4.5-.5 2.1-4.1 2 4.2 4.4.8-3.4 3.2m-104.6-35-4-2.2-4 2 1-4.6-3.3-3.3 4.6-.5 2-4.1 2 4.2 4.4.8-3.3 3.1m13.3 57.2-4-2.3-4 2 .9-4.5-3.2-3.3 4.5-.6 2.1-4 2 4.2 4.4.8-3.3 3.1m132-67.3-3.6-2-3.6 1.8.8-4-2.8-3 4-.5 1.9-3.6 1.7 3.8 4 .7-3 2.7m-6.7 38.3-2.7-1.6-2.9 1.4.6-3.2-2.2-2.3 3.2-.4 1.5-2.8 1.3 3 3 .5-2.2 2.2m-142.2 50.4-2.7-1.5-2.7 1.3.6-3-2.1-2.2 3-.4 1.4-2.7 1.3 2.8 3 .6-2.3 2M419 299.8l-2.2-1.1-2.2 1 .5-2.3-1.7-1.6 2.4-.3 1.2-2 1 2 2.5.5-1.9 1.5"
      }),
      /* @__PURE__ */ jsx102("path", {
        fill: "#ffffef",
        fillRule: "evenodd",
        d: "m219.3 287.6-2.7-1.5-2.7 1.3.6-3-2.1-2.2 3-.4 1.4-2.7 1.3 2.8 3 .6-2.3 2"
      }),
      /* @__PURE__ */ jsx102("path", {
        fill: "#ffffef",
        fillRule: "evenodd",
        d: "m219.3 287.6-2.7-1.5-2.7 1.3.6-3-2.1-2.2 3-.4 1.4-2.7 1.3 2.8 3 .6-2.3 2m42.3 3-2.6-1.4-2.7 1.3.6-3-2.1-2.2 3-.4 1.4-2.7 1.3 2.8 3 .5-2.3 2.1m-4.8 17-2.6-1.5-2.7 1.4.6-3-2.1-2.3 3-.4 1.4-2.7 1.3 2.8 3 .6-2.3 2m87.4-22.2-2.6-1.6-2.8 1.4.6-3-2-2.3 3-.3 1.4-2.7 1.2 2.8 3 .5-2.2 2.1m-25.1 3-2.7-1.5-2.7 1.4.6-3-2-2.3 3-.3 1.4-2.8 1.2 2.9 3 .5-2.2 2.1m-68.8-5.8-1.7-1-1.7.8.4-1.9-1.3-1.4 1.9-.2.8-1.7.8 1.8 1.9.3-1.4 1.3m167.8 45.4-2.6-1.5-2.7 1.4.6-3-2.1-2.3 3-.4 1.4-2.7 1.3 2.8 3 .6-2.3 2m-20.8 6-2.2-1.4-2.3 1.2.5-2.6-1.7-1.8 2.5-.3 1.2-2.3 1 2.4 2.5.4-1.9 1.8m10.4 2.3-2-1.2-2.1 1 .4-2.3-1.6-1.7 2.3-.3 1.1-2 1 2 2.3.5-1.7 1.6m29.1-22.8-2-1-2 1 .5-2.3-1.6-1.7 2.3-.3 1-2 1 2.1 2.1.4-1.6 1.6m-38.8 41.8-2.5-1.4-2.7 1.2.6-2.8-2-2 3-.3 1.3-2.5 1.2 2.6 3 .5-2.3 1.9m.6 14.2-2.4-1.4-2.4 1.3.6-2.8-1.9-2 2.7-.4 1.2-2.5 1.1 2.6 2.7.5-2 2m-19-23.1-1.9-1.2-2 1 .4-2.2-1.5-1.7 2.2-.2 1-2 1 2 2.2.4-1.6 1.6m-17.8 2.3-2-1.2-2 1 .5-2.2-1.6-1.7 2.3-.2 1-2 1 2 2.1.4-1.6 1.6m-30.4-24.6-2-1.1-2 1 .5-2.3-1.6-1.6 2.2-.3 1-2 1 2 2.2.5-1.6 1.5m3.7 57-1.6-.9-1.8.9.4-2-1.3-1.4 1.9-.2.9-1.7.8 1.8 1.9.3-1.4 1.3m-46.2-86.6-4-2.3-4 2 .9-4.5-3.2-3.3 4.5-.6 2.2-4 1.9 4.2 4.4.8-3.3 3.1"
      }),
      /* @__PURE__ */ jsx102("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M444.4 285.8a124.6 124.6 0 0 0 5.8-19.8c-67.8-59.5-143.3-90-238.7-83.7a124.5 124.5 0 0 0-8.5 20.9c113-10.8 196 39.2 241.4 82.6"
      }),
      /* @__PURE__ */ jsx102("path", {
        fill: "#309e3a",
        d: "m414 252.4 2.3 1.3a3.4 3.4 0 0 0-.3 2.2 3 3 0 0 0 1.4 1.7c.7.5 1.4.8 2 .7.6 0 1-.3 1.3-.7a1.3 1.3 0 0 0 .2-.9 2.3 2.3 0 0 0-.5-1c-.2-.3-.7-1-1.5-1.8a7.7 7.7 0 0 1-1.8-3 3.7 3.7 0 0 1 2-4.4 3.8 3.8 0 0 1 2.3-.2 7 7 0 0 1 2.6 1.2c1.4 1 2.3 2 2.6 3.2a4.1 4.1 0 0 1-.6 3.3l-2.4-1.5c.3-.6.4-1.2.2-1.7-.1-.5-.5-1-1.2-1.4a3.2 3.2 0 0 0-1.8-.7 1 1 0 0 0-.9.5c-.2.3-.2.6-.1 1s.6 1.2 1.6 2.2c1 1 1.6 1.9 2 2.5a3.9 3.9 0 0 1-.3 4.2 4.1 4.1 0 0 1-1.9 1.5 4 4 0 0 1-2.4.3c-.9-.2-1.8-.6-2.8-1.3-1.5-1-2.4-2.1-2.7-3.3a5.4 5.4 0 0 1 .6-4zm-11.6-7.6 2.5 1.3a3.4 3.4 0 0 0-.2 2.2 3 3 0 0 0 1.4 1.6c.8.5 1.4.7 2 .6.6 0 1-.3 1.3-.8a1.3 1.3 0 0 0 .2-.8c0-.3-.2-.7-.5-1a34.6 34.6 0 0 0-1.6-1.8c-1.1-1.1-1.8-2-2-2.8a3.7 3.7 0 0 1 .4-3.1 3.6 3.6 0 0 1 1.6-1.4 3.8 3.8 0 0 1 2.2-.3 7 7 0 0 1 2.6 1c1.5 1 2.4 2 2.7 3.1a4.1 4.1 0 0 1-.4 3.4l-2.5-1.4c.3-.7.4-1.2.2-1.7s-.6-1-1.3-1.4a3.2 3.2 0 0 0-1.9-.6 1 1 0 0 0-.8.5c-.2.3-.2.6-.1 1s.7 1.2 1.7 2.2c1 1 1.7 1.8 2 2.4a3.9 3.9 0 0 1 0 4.2 4.2 4.2 0 0 1-1.8 1.6 4 4 0 0 1-2.4.3 8 8 0 0 1-2.9-1.1 6 6 0 0 1-2.8-3.2 5.4 5.4 0 0 1 .4-4m-14.2-3.8 7.3-12 8.8 5.5-1.2 2-6.4-4-1.6 2.7 6 3.7-1.3 2-6-3.7-2 3.3 6.7 4-1.2 2zm-20.7-17 1.1-2 5.4 2.7-2.5 5c-.8.2-1.8.3-3 .2a9.4 9.4 0 0 1-3.3-1 7.7 7.7 0 0 1-3-2.6 6 6 0 0 1-1-3.5 8.6 8.6 0 0 1 1-3.7 8 8 0 0 1 2.6-3 6.2 6.2 0 0 1 3.6-1.1c1 0 2 .3 3.2 1 1.6.7 2.6 1.7 3.1 2.8a5 5 0 0 1 .3 3.5l-2.7-.8a3 3 0 0 0-.2-2c-.3-.6-.8-1-1.6-1.4a3.8 3.8 0 0 0-3.1-.3c-1 .3-1.9 1.2-2.6 2.6-.7 1.4-1 2.7-.7 3.8a3.7 3.7 0 0 0 2 2.4c.5.3 1.1.5 1.7.5a6 6 0 0 0 1.8 0l.8-1.6zm-90.2-22.3 2-14 4.2.7 1.1 9.8 3.9-9 4.2.6-2 13.8-2.7-.4 1.7-10.9-4.4 10.5-2.7-.4-1.1-11.3-1.6 11zm-14.1-1.7 1.3-14 10.3 1-.2 2.4-7.5-.7-.3 3 7 .7-.3 2.4-7-.7-.3 3.8 7.8.7-.2 2.4z"
      }),
      /* @__PURE__ */ jsxs77("g", {
        strokeOpacity: 0.5,
        children: [
          /* @__PURE__ */ jsx102("path", {
            fill: "#309e3a",
            d: "M216.5 191.3c0-1.5.3-2.6.7-3.6a6.7 6.7 0 0 1 1.4-1.9 5.4 5.4 0 0 1 1.8-1.2c1-.3 2-.5 3-.5 2.1 0 3.7.8 5 2a7.4 7.4 0 0 1 1.6 5.5c0 2.2-.7 4-2 5.3a6.5 6.5 0 0 1-5 1.7 6.6 6.6 0 0 1-4.8-2 7.3 7.3 0 0 1-1.7-5.3"
          }),
          /* @__PURE__ */ jsx102("path", {
            fill: "#f7ffff",
            d: "M219.4 191.3c0 1.5.3 2.7 1 3.6.7.8 1.6 1.3 2.8 1.3a3.5 3.5 0 0 0 2.8-1.1c.7-.8 1-2 1.1-3.7 0-1.6-.2-2.8-1-3.6a3.5 3.5 0 0 0-2.7-1.3 3.6 3.6 0 0 0-2.8 1.2c-.8.8-1.1 2-1.2 3.6"
          })
        ]
      }),
      /* @__PURE__ */ jsxs77("g", {
        strokeOpacity: 0.5,
        children: [
          /* @__PURE__ */ jsx102("path", {
            fill: "#309e3a",
            d: "m233 198.5.2-14h6c1.5 0 2.5.2 3.2.5.7.2 1.2.7 1.6 1.3s.6 1.4.6 2.3a3.8 3.8 0 0 1-1 2.6 4.5 4.5 0 0 1-2.7 1.2l1.5 1.2c.4.4.9 1.2 1.5 2.3l1.7 2.8h-3.4l-2-3.2-1.4-2a2.1 2.1 0 0 0-.9-.6 5 5 0 0 0-1.4-.2h-.6v5.8z"
          }),
          /* @__PURE__ */ jsx102("path", {
            fill: "#fff",
            d: "M236 190.5h2c1.4 0 2.3 0 2.6-.2.3 0 .6-.3.8-.5s.3-.7.3-1c0-.6-.1-1-.4-1.2-.2-.3-.6-.5-1-.6h-2l-2.3-.1z"
          })
        ]
      }),
      /* @__PURE__ */ jsxs77("g", {
        strokeOpacity: 0.5,
        children: [
          /* @__PURE__ */ jsx102("path", {
            fill: "#309e3a",
            d: "m249 185.2 5.2.3c1.1 0 2 .1 2.6.3a4.7 4.7 0 0 1 2 1.4 6 6 0 0 1 1.2 2.4c.3.9.4 2 .3 3.3a9.3 9.3 0 0 1-.5 3c-.4 1-1 1.8-1.7 2.4a5 5 0 0 1-2 1c-.6.2-1.5.2-2.5.2l-5.3-.3z"
          }),
          /* @__PURE__ */ jsx102("path", {
            fill: "#fff",
            d: "m251.7 187.7-.5 9.3h3.8c.5 0 .9-.2 1.2-.5.3-.3.6-.7.8-1.3.2-.6.4-1.5.4-2.6l-.1-2.5a3.2 3.2 0 0 0-.8-1.4 2.7 2.7 0 0 0-1.2-.7 13 13 0 0 0-2.3-.3z"
          })
        ]
      }),
      /* @__PURE__ */ jsxs77("g", {
        strokeOpacity: 0.5,
        children: [
          /* @__PURE__ */ jsx102("path", {
            fill: "#309e3a",
            d: "m317.6 210.2 3.3-13.6 4.4 1 3.2 1c.7.4 1.3 1 1.6 1.9.4.8.4 1.7.2 2.8-.2.8-.5 1.5-1 2a3.9 3.9 0 0 1-3 1.4c-.7 0-1.7-.2-3-.5l-1.7-.5-1.2 5.2z"
          }),
          /* @__PURE__ */ jsx102("path", {
            fill: "#fff",
            d: "m323 199.6-.8 3.8 1.5.4c1 .2 1.8.4 2.2.3a1.9 1.9 0 0 0 1.6-1.5c0-.5 0-.9-.2-1.3a2 2 0 0 0-1-.9l-1.9-.5-1.3-.3z"
          })
        ]
      }),
      /* @__PURE__ */ jsxs77("g", {
        strokeOpacity: 0.5,
        children: [
          /* @__PURE__ */ jsx102("path", {
            fill: "#309e3a",
            d: "m330.6 214.1 4.7-13.2 5.5 2c1.5.5 2.4 1 3 1.4.5.5.9 1 1 1.8s.2 1.5 0 2.3c-.4 1-1 1.7-1.8 2.2-.8.4-1.8.5-3 .3.4.5.8 1 1 1.6l.8 2.7.6 3.1-3.1-1.1-1-3.6a19.5 19.5 0 0 0-.7-2.4 2.1 2.1 0 0 0-.6-.8c-.2-.3-.6-.5-1.3-.7l-.5-.2-2 5.6z"
          }),
          /* @__PURE__ */ jsx102("path", {
            fill: "#fff",
            d: "m336 207.4 1.9.7c1.3.5 2.1.7 2.5.7.3 0 .6 0 .9-.3.3-.2.5-.5.6-.9.2-.4.2-.8 0-1.2a1.7 1.7 0 0 0-.8-.9l-2-.7-2-.7-1.2 3.3z"
          })
        ]
      }),
      /* @__PURE__ */ jsxs77("g", {
        strokeOpacity: 0.5,
        children: [
          /* @__PURE__ */ jsx102("path", {
            fill: "#309e3a",
            d: "M347 213.6a9 9 0 0 1 1.7-3.2 6.6 6.6 0 0 1 1.8-1.5 6 6 0 0 1 2-.7c1 0 2 0 3.1.4a6.5 6.5 0 0 1 4.2 3.3c.8 1.6.8 3.5.2 5.7a7.4 7.4 0 0 1-3.4 4.5c-1.5.9-3.3 1-5.2.4a6.6 6.6 0 0 1-4.2-3.3 7.3 7.3 0 0 1-.2-5.6"
          }),
          /* @__PURE__ */ jsx102("path", {
            fill: "#fff",
            d: "M349.8 214.4c-.4 1.5-.5 2.8 0 3.8s1.2 1.6 2.3 2c1 .3 2 .2 3-.4 1-.5 1.6-1.6 2.1-3.2.5-1.5.5-2.7 0-3.7a3.5 3.5 0 0 0-2.2-2 3.6 3.6 0 0 0-3 .3c-1 .6-1.7 1.6-2.2 3.2"
          })
        ]
      }),
      /* @__PURE__ */ jsxs77("g", {
        strokeOpacity: 0.5,
        children: [
          /* @__PURE__ */ jsx102("path", {
            fill: "#309e3a",
            d: "m374.3 233.1 6.4-12.4 5.3 2.7a10 10 0 0 1 2.7 1.9c.5.5.8 1.1.8 1.9s0 1.5-.4 2.2a3.8 3.8 0 0 1-2 2c-1 .2-2 .2-3.1-.2.4.6.6 1.2.8 1.7.2.6.3 1.5.4 2.8l.2 3.2-3-1.5-.4-3.7a20 20 0 0 0-.3-2.5 2 2 0 0 0-.5-1l-1.2-.7-.5-.3-2.7 5.2z"
          }),
          /* @__PURE__ */ jsx102("path", {
            fill: "#fff",
            d: "m380.5 227.2 1.9 1c1.2.6 2 1 2.3 1 .3 0 .7 0 1-.2.3-.1.5-.4.7-.8.2-.4.3-.8.2-1.2a2 2 0 0 0-.7-1 23.7 23.7 0 0 0-1.8-1l-2-1z"
          })
        ]
      }),
      /* @__PURE__ */ jsxs77("g", {
        strokeOpacity: 0.5,
        children: [
          /* @__PURE__ */ jsx102("path", {
            fill: "#309e3a",
            d: "M426.1 258.7a8.9 8.9 0 0 1 2.5-2.6 6.6 6.6 0 0 1 2.2-.9 5.5 5.5 0 0 1 2.2 0c1 .2 1.9.6 2.8 1.2a6.6 6.6 0 0 1 3 4.4c.3 1.7-.2 3.6-1.4 5.5a7.3 7.3 0 0 1-4.5 3.3 6.5 6.5 0 0 1-5.2-1.1 6.6 6.6 0 0 1-3-4.4c-.3-1.8.2-3.6 1.4-5.4"
          }),
          /* @__PURE__ */ jsx102("path", {
            fill: "#fff",
            d: "M428.6 260.3c-1 1.3-1.3 2.5-1.1 3.6a3.6 3.6 0 0 0 1.6 2.5c1 .7 2 .9 3 .6 1-.3 2-1 2.9-2.4.9-1.4 1.3-2.6 1.1-3.6-.1-1-.7-1.9-1.6-2.6s-2-.8-3-.5c-1 .2-2 1-3 2.4z"
          })
        ]
      }),
      /* @__PURE__ */ jsx102("path", {
        fill: "#309e3a",
        d: "m301.8 204.5 2.3-9.8 7.2 1.7-.3 1.6-5.3-1.2-.5 2.2 4.9 1.1-.4 1.7-4.9-1.2-.6 2.7 5.5 1.3-.4 1.6z"
      })
    ]
  })
});
var Br_default = SvgBr;

// src/country-flag-icons/generated/Bs.tsx
init_esm_shims();
import { jsx as jsx103, jsxs as jsxs78 } from "react/jsx-runtime";
var SvgBs = (props) => /* @__PURE__ */ jsxs78("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx103("defs", {
      children: /* @__PURE__ */ jsx103("clipPath", {
        id: "bs_svg__a",
        children: /* @__PURE__ */ jsx103("path", {
          fillOpacity: 0.7,
          d: "M-12 0h640v480H-12z"
        })
      })
    }),
    /* @__PURE__ */ jsxs78("g", {
      fillRule: "evenodd",
      clipPath: "url(#bs_svg__a)",
      transform: "translate(12)",
      children: [
        /* @__PURE__ */ jsx103("path", {
          fill: "#fff",
          d: "M968.5 480h-979V1.8h979z"
        }),
        /* @__PURE__ */ jsx103("path", {
          fill: "#ffe900",
          d: "M968.5 344.5h-979V143.3h979z"
        }),
        /* @__PURE__ */ jsx103("path", {
          fill: "#08ced6",
          d: "M968.5 480h-979V320.6h979zm0-318.7h-979V2h979z"
        }),
        /* @__PURE__ */ jsx103("path", {
          fill: "#000001",
          d: "M-11 0c2.3 0 391.8 236.8 391.8 236.8L-12 479.2z"
        })
      ]
    })
  ]
});
var Bs_default = SvgBs;

// src/country-flag-icons/generated/Bt.tsx
init_esm_shims();
import { jsx as jsx104, jsxs as jsxs79 } from "react/jsx-runtime";
var SvgBt = (props) => /* @__PURE__ */ jsxs79("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx104("path", {
      fill: "#ffd520",
      d: "M.1 0h640.1v480H.1z"
    }),
    /* @__PURE__ */ jsx104("path", {
      fill: "#ff4e12",
      d: "M.1 480h640.1V0z"
    }),
    /* @__PURE__ */ jsxs79("g", {
      stroke: "#000",
      strokeWidth: 0.5,
      children: [
        /* @__PURE__ */ jsxs79("g", {
          fill: "#fff",
          strokeWidth: 0.4,
          children: [
            /* @__PURE__ */ jsx104("path", {
              d: "M345.4 150c-4-1.3-6.6.7-6.4 5.9 0 5.1 2.8 8 6.8 6.1z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M348.9 140.4c-3.3-2.6-6.4-1.5-8 3.4-1.5 5 .1 8.6 4.5 8z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M354.4 131c-2.8-3-6-2.4-8.4 2.2-2.3 4.6-1.3 8.5 3.2 8.7zm-3.6 45.5c-4.9 1.8-5.4 8.5-2.3 12.6 3 4.1 8.7 4.9 11.8 0z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M345.1 162.3c-4.6-1.5-8.8 4.7-9.5 10.3-.9 7-11 9.4-5.4 20.1 1.2-6.8 5.7-10.6 9.3-10.8 3.6-.3 9-1 11.3-5.4zm14.7 27.6c-5.4 1.3-6.2 8.5-2.3 13.6 3.3 4.4 13.7 3.4 13.4-1zm15.3 43.4c.3-4.7-7.2-6.5-10.8-5.6-3.6 1-10.5-.1-12-4-1.4 3.1.5 6.5 5.7 8.2 4 1.2 3.9 4 2.7 5.4 3 .5 11.7.5 14.4-4z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M370.9 203.7c-5.3-2.4-8.4 1.2-10.4 4.6-3 5-12.1-1.4-15.2 5.3 4.2-1.8 8.4 2 10.4 3.3 5.7 3.7 16.6 2.6 18.2-6.2z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M374 209.8c-5.3 4-7.4 8.8-7.2 12 .1 3.2 4.6 10.3 9.5 10.7 2.8-5.8 4.3-18-2.3-22.7zm-22 24.9c0-2 2.8-2.7 4.8-2 1.9.6 4.9 2.5 3.8 4.6zM323 224c-.5-2.3 3.2-6.3 8.2-4.1 5 2.2 5.7 6.4 3.6 8.1z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M335.2 228.4c-.4-1.3 3.3-3.9 9.4-2.4 6.2 1.6 7.7 5.6 7.5 8.7zm-12.9-4.3c3.3-2.4 2-7-.9-8.5-5.2-2.6-3.3-9.2-6.7-10.5-3.3-1.3-6.5-3.6-6.7-6-1.6 3.3-.6 6.2 1.7 8.3 2.3 2-1.8 10.4 1.2 12.6zm-69-1.8c-2.7-4.2-9.1-3.5-11.8-.5-2.7 3-2.3 7.3.2 9.3zm15.5-6.3c-1-5.7-7.9-6.3-11.6-4.9-3.8 1.4-6.3 7.1-3.9 11.2z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M279 215.2c2.5-4.7-2.3-11.8-7.7-12.8-4.5-1-9.8-.9-11.6-5.3-1 3.8 1.8 6.3 5.2 8.5 3.3 2.2-.6 7.8 4.8 11z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M278.6 215.4c-1.2-3.4 1.1-8 5.7-7.6 4.7.3 7.3 3.6 5.3 7.9z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M288.9 215.7c-.7-3.6 2.2-7.8 6.8-6.8 4.5 1 6.6 4.7 4 8.5l-10.8-1.8z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M299 217.3c-.4-3.6 2.7-7.6 7.2-6.4 4.5 1.2 6.4 5 3.6 8.7l-10.7-2.3zm-77.6 59c-8.7 0-10.8 2-12 11-1.6 11 13.5 12.3 12-11z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M225.2 264.7c-13.2-5-20.4 16-33.6 12.2 4.7 7.5 16.1 0 20.4.8 7.2 1.3 22.8-1.4 13.2-13zm-8.6 28.7c-6.6-3-13.6 7-12.4 11.5 1.7 5.5 16.7 1 12.4-11.5zM186 336.7c3.6 1 8 3 7.2 10-.8 7-14 21.1-25.8 22-11.8.7-16 15-26.3 11 9.6-1.8 9.6-12.6 17-16-5.4-2-8.2 10.3-15.2 10.3s-10.3 11.1-18.8 10.3c-8.5-.7-9.3 13.5-26.4 13.7-13 .1-29 15.3-34.9 8.7 12.7-1.8 17.8-8.8 25.3-16.5 12-12.3 25.7-6.8 30.4-17.7a31.6 31.6 0 0 1-18.3 5.4c-8-.2-16.6 12.6-25.5 7 5.1-.7 8.5-2.9 13.9-8.6 5.5-5.8 13.7-2 20.1-8 10-9.2 18.7-1.5 28.3-13-2.7-1.4-8.5-.5-13.9 2.4-5.4 2.8-12.3-2-18.5 1.4.7-7.6 15.2-3.3 24.2-8.5 10.2-6 18.6-4.2 26.6-3.5-11.2 0-15.5-10.7-31-7.6-6.7 1.4-12.1-9.3-18.8-3.9.2-4 7.2-7.2 14.4-3.3 7.2 3.9 10.1-3.4 24.5 5.7 6 3.7 16.1-2.4 22.5 1.6-.8-2.4-4.5-4-8.8-3.6 2.7-5.6 20.2-4.9 27.8.7z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M197.4 328.3c-5.6-4.4-13.5.9-19-1.2 0 3.6 1.9 9 7.8 11.1 1.8-1.3 10-8.4 11.2-9.9z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M206.3 315.8c-8.9-4.5-10.4 6.7-17.4 4.4.3 3.2 2.9 7.2 8.5 8.1z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M211.6 305.6c-13.1-5.1-14.8 7.5-22.5 5 1.8 4.4 12.8 6.8 18.5 5.2zm18-55.2c-3.5-5-10.8-1-12 4.9-1.1 5.8 1.7 13.9 6.6 12z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M238.5 235c-6-1.5-13-.8-12.2 5-2.4 1.1-3 8.7 3.3 10.4z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M242.5 231c-6-7-12.5-6.9-16.2-4-6.9 5.5-13.5 2.4-13.7 7.8 4.1-3.2 7.8.6 11-.5 3.4-1.2 5.9 5.3 15.2 2.6zm-14.3 103.9c.9 1.7 6.4 2.4 9.1-.4 3.6-3.8-.3-14.2-6-15-5.7-.7-6.2 11.8-3.1 15.4z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M221.8 335.1c8 3 11.5-3.7 7.2-8a80 80 0 0 1-7.2 8z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M191.4 346.2c-1.6 4.7-9.6 5.4-18.6 19.8-9 14.5-17.6 8.4-19.8 18.3 10.8-8.7 19.3-3 25.8-11.6 9.7-13.1 17.8-11.2 21.6-20 5.4-12.7 29-12.4 30.4-32.3-8-1.5-33.3 19.9-39.4 25.8zm203.2-194.7c10.3 3.4 10.5 16.7 22.4 21.1 11.8 4.4 13 15 22.7 12.4-9-2.5-8.4-12.9-17.8-15.5-11-3-15.2-19.8-24-22.4m44 74.3c1.8 4.2 1.5 11.5-5 13.4 3.5 2.2 8.7.2 11.5-4.6-4.2 9.4-1.4 17.9 5.3 19.6-3.2-6.6 4-9.7 1.7-14 4.2 1.9 8 7.7 7.8 11.3 5.6-6.2-4-14.5-2.3-20.3zM375 287.6c-6.3-5.5-9 1.5-12-1-3-2.2-6.8-2.5-8.3-.3 5.4.2 2.8 4.4 13.3 5.4-10.5.7-8.6 12.5-15.6 11.9 7.4 7 11.3-6.3 17.4-4.1-1.8.5 2.8 4.7-.4 10.4 5.2-.1 7.3-7.3 8-11zm-139 60.2c-2.2-2-9-2.9-11.5-1.3-2.6 1.5-1.7 2 1.4 2.2 3.1.2 7 5.2.4 5.5-3.1.1-2 7.6-8.5 8.1 2.6 3.2 10.2 1.1 12.9-2.4-.5 2.9 3.3 5.5 1.8 9 4.7.5 2-9.7 9.5-9.2-3 .4-1.8 7.4 3.6 5.6-3.2 1.5-1.5 5.3 2 4.4-2.2.7-3 3.7.2 5.4 3.1-4.3-.4-19.5-11.7-27.3zm280.6-142.1a17.9 17.9 0 1 0 0-35.7 17.9 17.9 0 0 0 0 35.7z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M423.4 227.2c5.5-5.1 13.7-7.7 19.4-3.8 5.6 3.8 24.4 8.4 33.7 2 9.3-6.4 13.7-9.8 17.8-9 3 4.6 6.8 6.8 11.4 7.2 1.4 1.6 6.5 2.8 9.3 2.5 4.1 1 9.1-.3 13.1-4.7 6.2 1 12-3.7 14.2-10.7 6.6-.7 7-8 2.8-13-3.8-.7-.9-13.8-14.9-11.2 6 3.6 1.4 10.8 6.3 14.2-3.3 0-7.7 1.4-8.7 6.4 1.3-3.4-.2-5.8-1-6.5 0-3-6.5-10.3-12.7-7.6 4.4 1 2 8 5.2 10.8a8.1 8.1 0 0 0-6.2 3.3c-1.7-3-7.6-6-11.2-6.3 0-1-.2-3-.7-4.1-1.6-3.1-3-6.8-2.3-11.5a48 48 0 0 0-7.2 11.4c-4.9-3.4-17 1.5-22.7 2.8-5.6 1.3-24.7-1.8-29-6.4a49.2 49.2 0 0 0-21-9.8c-11-3.2-11-15.2-23.1-23.5-.3 15 22.4 62.4 27.5 67.5zM297.2 341.1a17.3 17.3 0 1 0 0-34.6 17.3 17.3 0 0 0 0 34.6z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M256 327.8c3.5 4.5 9.4 4.2 11.9 3.9 2 5.4 8.6 5.2 11.4 8.2 2.9 3 12.5 2.7 15.3 1-2.5-.2-5.9-1.8-9-4.5-4-3.2-2.2-9.8-5.2-12a11 11 0 0 0 2.2-8.6c2.4-1.4 4.2-3.7 4.4-4.9a15 15 0 0 0 9.6-4.1c2.2 2 7.7-.6 10.7 2.8.6-8.5-7.5-13-13-10.1-2.1-1.2-7.9-.4-9 1.1-1.7-.8-6.8 1.8-9 3.5 2.5-1.4 2.9-5.7 1.9-7.2 2.2-1 4.6-3.9 4.9-6 3 .5 7.7-1.6 9.7-1.1-3.3-4.4-8.8-6-14.5-5.5-5.9.3-8.4 4.4-9.2 8.8-3.4 2.1-4.6 9-3.3 11.5-2 0-3.9 1.9-4.6 3a26.7 26.7 0 0 0-9.4-2m1.3-7c-1.2-3.4.3-6.4 1.1-9 2-6.8.8-8.6-5.3-7.7a47 47 0 0 0 4.2 16.7z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M248.6 282.3c1.6 1.6 7 2.3 7.6-2.6.7-5.6-1.6-7.8-6.5-5.6-.4 1.3-.8 6.5-1 8.2z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M249.8 273.9c2 .8 6.5 2.5 9-2.3 2-4-.7-7-5-6.8-1 1.2-3 5.3-4 9.1z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M253.6 264.4c.5 1.6 5.8 6.7 9.6 3 3.9-3.7 3.9-9.3-1.9-11.3-1.5.2-6.2 5.6-7.7 8.3z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M261.3 256c1.1 3.3 4.8 8.8 11.5 6.3 6.7-2.6 3.8-11 .7-12.7a33 33 0 0 0-12.2 6.5z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M273.5 249.6c-.5 2.9 0 10.6 9.2 10.5 9.1-.2 6.6-10.9 4.2-12.4-3.7 0-10 .1-13.4 2z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M287.3 248c-1 2.3-3.3 16.7 14.6 12.7 2.3-.5 8.3-13.8-14.6-12.6z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M297.1 249.4c-1.8 1.8 2.8 16.3 15 13.9 12-2.5 1.9-16.3-15-14z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M307.4 251.6c-2 4 1 15.8 15.9 15.8 13.5 0-.7-15.6-15.9-15.8z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M319.1 255c-1 2.3-2.1 14.8 15.5 15.9 12.7.8 9.6-17.3-15.5-15.9z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M338 260.3c-2.1 3.9-4.4 13.5 14.9 14.3 12.3.5 4.7-14-14.8-14.3z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M354.1 263.3c-2.8 3.8-.7 11.4 6.5 12.8 9 1.8 10.3-6.7 4.1-10.8-6.2-4-10.6-2-10.6-2z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M363 265c-2.1 3.7-.9 12.4 12.8 12.4 2.8 0 13.6-11-12.9-12.3zM257.1 433a20 20 0 1 0 0-40 20 20 0 0 0 0 40z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M404.1 141.7a35.2 35.2 0 0 0-5.4 8c-6.7 20 11.2 35 21.6 56.7a63 63 0 0 1-5.6 60.7c-4.4 5.8-3.1 7.5-8.8 13.4-2.2 2.3-4.6 5.2-3.8 13.4 3.6-1.3 8.7 2 9.7 5 2.6-1.4 6.2-.9 7.5.7 4.4-2 8-1 11.9 3 3.3-.4 7 0 10.3 3.7 1.8-3.6 5.4-5 8-4.1-.3-4.7 4.3-8 8.4-6.2a7.6 7.6 0 0 1 9.8-9c4.7-3.6 14-3.9 18.6 1.5-8.3-2.3-8 6.5-15 5.7 1.8 5.1-2.8 8.1-7.4 9.8 3-1.4 6.2-3.1 7.2-1.3 2.6-2.3 7.7-1.4 9-.3 3.4-1 6.7-.2 8.2 3.9 4.7 2.8 7.8 10 4.4 15.4-1-5.6-4.9-5.4-6.4-7.7-3.6 1.3-7.2 1.3-8.3-1-2 2-9 3.9-12 .8-1.2 4.6-5.2 8.5-9.9 8.5 1.3 3.6-2.3 9.7-5.1 12.8 4.4 2.3 3 7.5 2 10.6 6.8 1 1 7 12.7 10.8-5.7 1.8-16.8 0-18.3-7-5.7-.2-9.5-5.9-9.3-11.8-4.4-4.1-5-10 1-14.2-5.1 1.6-8-6.7-15.4-3.3-3.7 1.7-13.5-1.2-13.4-4.6-1.5 2.5-11 1.5-12.2-2.9-3.1 1.7-10.3-1.1-10.2-5.4-4 1.8-9.4-1.4-9.1-5.5-3.8-.5-4.2-3.9-4-6.7-3.3-1.6-2.4-4.8-1-8.6-2.4-2.6-1.4-6.2.4-9.6-2.5-2.6-2-5.6-1.3-9.3-12.3-1-27.8-4-63.3-14.9-53.6-16.5-68 22.2-56.2 46.4 13.7 28-1.5 34 3.1 54.8 5 1 7.5 5.2 7.2 9.6 3 .1 5 2.8 4 8a9 9 0 0 1 7.6 2.3c1.8-3.4 7.8-4.2 10.8-.3 6.7-.5 10.1 5 9.8 11.6a18 18 0 0 1-1.5 19.3c.4-2.7 0-6.5-.1-8.9-.3-4.2-6.2-5.1-5.6-8.6-3 .3-6-1.4-7-3.7a6.8 6.8 0 0 1-6.6 1.3c3.4 1.5 6.2 7.7 5.1 11.8 1.8 3.1 1.4 8.8-.7 11.2-1 5-5 6.8-10 4.6 2.9-1.8 3.9-5 3.8-7.7a10 10 0 0 1-2.9-6.3c-5 .8-12-3.5-13.2-5.2a20 20 0 0 0-20 20.1c-.6-4.1-5.8-8.2-5.1-11.7-3.1-9.5 1.3-18.4 13.9-20.2-1.6-3.6 3.8-7.3 1.8-11.4a97 97 0 0 0-14.7-20.1c4.4-7.5 3-17.5.5-23.7-3.7-8.9-7.2-6.7-20.3 7.7-21.4 23.5-50 17-75.2 32.5-6.7 4-13.4 5.6-6.2-1.6s26.2-14.4 38.6-20.6c23.2-11.6 42.8-30.9 50.5-68.5 18.1-88.4 85-59.2 127.2-42.8 39.7 15.5 32.5-19.5 12.4-40.7-24.2-25.3-19.3-45.3-8-61.3 20.3-2.8 59.4 4.3 51.5 11.1z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M475.9 358.8a22 22 0 1 0 0-44.1 22 22 0 0 0 0 44z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs79("g", {
          fill: "none",
          strokeWidth: 0.4,
          children: [
            /* @__PURE__ */ jsx104("path", {
              d: "M391.8 142.7c-5 21.7-.8 31.5 6.4 41 14.9 19.7 26.8 64.6 9.8 94"
            }),
            /* @__PURE__ */ jsxs79("g", {
              strokeLinecap: "round",
              children: [
                /* @__PURE__ */ jsx104("path", {
                  d: "M417.5 252.3c2-.7 6-3.2 6.8-7.4m-5.2-2c.6-3.7 6.4-5.3 6.5-9.3m-6.4-5.2c-.4-3.9 5.8-7.4 4.9-11.2m-8.3-2.7c-.5-2.2 5.2-6.3 3.6-9.8m-7.8-3.8c-1.2-2.4 2.7-5.2 1-7.8m-7.2-3c-.4-1.6 2-5.3.7-7.5m-6.9-5.2c.5-.7 2.6-2.2 1.8-4.1m-6-5.3c.8-.4 3.3-1.2 3-3"
                }),
                /* @__PURE__ */ jsx104("path", {
                  strokeLinejoin: "round",
                  d: "M266 410.9c-5-1.8-11.5.7-12.8 5.1m3.9 4c.6-4.4 7.3-6.3 9.3-4.3-4.2-2.3-6.3 6-2.5 6.2m34.6-103.8c-3 1.6-4 7.2 0 11.5m4.6-10.2c-2.1 1.8-2 7.2 1.2 8.5-2.7-2 0-5.3 2-5.4 1.9-.1 3.2 2.2.8 4.5m177 5.2c-7.2-2-13 6.4-6.4 13.9-.2-7.2 5-12 11.3-10.7m-3 5a2.7 2.7 0 0 0-2.7 2.7c0 1.4 1.2 2.8 3.2 2.8 1.3 0 2.4-1.5 2.4-2.7m22.6-161c1.2 4.4 7.2 6.3 12 5.2m0-2.8c-3.7.1-6.8-3.4-6.6-6.3 0 2.2 5 3.2 6.6 1.8"
                }),
                /* @__PURE__ */ jsx104("path", {
                  d: "M267.9 331.7c-1-2.6 3-5.2 3.2-7.6.1-2.5 4.6-4.4 9.3.2m-2.2-27.4-2.5 1.2m11.4 12.8c-1.1 0-3.4 0-4.6-.9m0 5.8c-.8.5-2.8 1.2-4 1.5m-40.1 76.3c-.2 2.3 2.2 5.7 3.4 6.7m6.6-12.2a10 10 0 0 0-1.3 7.6m20.5 0c-2.3-1.5-.8-5.4-1-8-.3-2.6 2.7-6.7 8.5-3.2M246 381c2.3-.4 4.7-.3 6.3.4m23-7.7a8.3 8.3 0 0 0-1.4 4m12.3-4.3c-1.8 0-3.4 1.3-4.2 2.6m-20.8-68.5c2 .7 7.4 4 7.6 7.4m14.3-24.2c-6.3-.1-8.8-6.5-4-6.5m15.3 15.2c-2.4 1-1.3 5.2 2.2 7.3m-17.3 33.1c-1.2-1.6.4-6 4.4-4.7m5 51.7c.3-4 5.2-6.2 7.2-1.8m-25.5 13c-.3-4.3 2-5.7 3.8-6 2-.2 4.7 1.4 6 4.2m-48.1 5c.2-2.6 2.4-5.3 4.7-4.9m231-109.4c-1.7 1.2-2.8 6.7 3.5 7.2M458 296c0 .6.8 1.5 1.3 2m29 8.3c-1.6-1.3-6 4-2 7.7m-39 35.6c-.9-3.7 2.5-4.7 5.8-3.9m-14-22.2c2-1.2 4-2.7 6.4-3.3m-7.4 17.5c0-3 1.6-5.7 3-6.4m8.4-29.1a16 16 0 0 0 2.4 9.2m28.2-9c-1.9.6-3.5 1.3-4.2 2.9m2.1 7.7c1-.8 2-1.7 2.4-2.3m46.3-110.2c0 3.6-4.5 5.6-7.5 3.3m17.3-3.1c2 1.5 8.9 0 7.3-4M528 221.4a11 11 0 0 1-4.9-3m19.1-7.7c-2.3.5-3.9 0-5-.5m-31.6 13.4a17 17 0 0 0 6.5-1.6M502 200.8c-1.7-.2-3 .1-3.9.8m29.8 5.5a11 11 0 0 1-3 5.2"
                }),
                /* @__PURE__ */ jsx104("path", {
                  strokeLinejoin: "round",
                  d: "M497.5 212.8c3.2-1.4 7.2 9.5 15 5.7m.6-11.4a11.3 11.3 0 0 0-1.8 5.6"
                })
              ]
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M359 190.4c1-.2 2.9-.5 3.3-1.8M226.5 310.3c3.9 2.2 6.6 5.9 5 11.4m172.1-143.2c1.2.8 5.5.8 8 0m3 2.6c0 1.8.5 8.6-3 10m1.3-.8c3.2 1 9.6.6 11.7-5.3m-4.5 5c1.7 2.6 2.2 7.6-2.8 10.3m4-6c3.8 1.2 12.4 1.4 11.5-6m-3 6c2.7 3.5 14 7.8 12.2.3m-22.5 10c4.3 1.1 10.5-1.9 8-9.6m12.3 3.9c.6 3 15 6 13.1-.7m-2.7 3.9c2.7 6.2 17 5.7 12.5-2.6m-2.3 6.5c2.8 3.4 15.5 1.4 10.4-7m-.1 6.8c7.9 6 17-2.5 7-8.7m4.6 6.8c7 5.5 15.5-4.5 9.4-7.3m-64.4 5c2.2.6 6.8.4 7.9-3.6m-1.8 2.7c-.2 5.8 9.6 8 12.1 1.3m-3.3 3.7c1.8 3.9 10.5 5.4 11.9-.1m-1.4 2.6c1.4 3.8 8.9 3.4 11-.6m-2.8 2.6c2.3 5 11.9 5 14-2.3m-1.6 3.2c3.7 2.3 11.7 1.4 11-5.8m-1.5 5.2c5.6 4.5 13.4.1 9.5-7.5m-.3 13.4c3-.5 4.5-6.4 1.4-8m-70 9c6-3.3 7.3-9 3-14.5m2.2 8.9c3.9 2.3 11.2-.2 12.5-5.8m-7.2 6.4c2.2 2.8 2.6 6.3-.3 9.5m2-5.9c6.9-4.2 15.4 3.6 9 8.4m-1-8.8c1.5-.4 4.2-3.2 4.4-6.4m-1.4 9.4c2.9-3 22.2 3 10 9.3m-1-17.4c3.8 1.4 5.7 6.7 0 8.5m5 4.4c4-4.3 17-1.6 12.3 3.8m-3.1-5.5c2.3-7.9 16.1-3 11.6.2m-14.4-8c.4 1.5.5 5.3-2 7.4m13.6-9a6.1 6.1 0 0 1-.8 5.3m9.5-5.2c.8 1.4 2 4.1-.8 6.3m-109.4-65.5c.1 7.3 2.7 12.2 12.6 7.6m-9.5 1.1c-5 6.6.6 13.7 10.3 6.6M365 165c6.7 7.2 18.7 2 11-9m8 15.2c-1.2 7.1 4.6 8.5 9.3 5.3m-34.2-10.3c1.2 7.1 8.5 12.7 15.6 8.4m-6.9 1.4c0 10.2 14 11.3 17.3.8m-5 6.4c4.5 9.3 14.3 5.5 17.5-.1m-27.4-14.7c1.8 4.5 5.4 9.5 13.7 5.8m-39.5-8c1.2 3.7 7.9 8.2 15.6 3m-10.8 1.8c-4.2 6 4 11.7 14 2.7m-9.1 4.7c1.6 8.5 5 15.4 17 4.4m-6 4.4c4.4 5.4 11.1 8.7 17.4-.4"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M387.3 188.8c-.4 6.5.8 9.7 5.9 9.4 4-.2 7.7-3.3 9.9-6.7m-10.8 6.7c-.2 7.4 5.6 13.2 16.5 5.7m-12 3c-2 5.5 4.1 14.5 16.2 9.9m-41.9-24.6c-.7 7 5.8 11.8 16.4 2.7m-11.2 5.1c.4 5.8 7 12.8 16.6 2.7m-12 4.7c-.7 9.9 8.4 12.7 16.1 5.1M367.2 200c2 .2 3.7-1.6 4.7-3m-.4 10.2c1.8.4 5-1.2 6-3.3m-1.4 15c2 2.3 9 .7 9.9-2.3m-2.2 2.2c3.8 9 14.1 8.7 18.4-1.5m-2 3.6c2 5.3 6.9 8.6 14.9 6.8m-11-1.4c-4.5 7.3 1.4 16 11.5 7.5m-9 3.5c-.5 4.6 3.7 9.9 9.5 10.5m-28.6-24c-1.5 10.4 6 15.4 15.3 9.8m-26.2-4.8c2.4 1.9 6.8 2.1 11 .6m5 6c-2.4 8.8 6.6 15.1 14.3 5.3M380 230.2c.2 4.5 4.5 9.4 12.1 8m21.3 9c-5.2 3.4-6.2 9.6 1 13.6m-13.6-15.4c.2 5.2 2.7 8.2 8.5 8.7m-16.1-11.4c-7.8 7-.2 15.3 9 8.3m-3.6 2.2c-2.6 8.1 7 13 12.2 4.8m-28.2-22c-2.8 8 .8 13.2 7.4 12.7m-17.6-14.3c.4 4.8 4.5 6.5 9.2 5.4m-6.2-.4c-3.5 6.7 1.8 10.3 8.8 7.8m21 15c-1 4.2-.4 7.2 5.9 8.7m-5.4-2.7c-7.6 3.4-8.3 10.8-2.4 15.5m-3.8-23.7a7.6 7.6 0 0 0 1.2 12.3m-35-35.8c-4.3 4.3-.2 16.2 9.5 9.7m15.7 5.3c-6 5-3.3 13.8 6.5 11.4m-16.3-15c-3.1 8.7-.2 11.8 6.8 11.9"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M359.3 236.1a8.2 8.2 0 0 0-1.5 12.2c2.3 2.6 6.7 1.4 8-1.9m-17.6-13.8c-5.9 7.6 0 16.6 8.4 14m23.3 8.6c-6 2.1-10.7 7.6-7 12.5 2.3 2.8 11.8 3.2 14.5-7.8M369 248.1c-3.5 5-2.4 9.8 4 12.2m-4.4-2.8c-3.8 2-6.2 4.5-5.3 9m-3.1-16.9c-1.4 6 .3 9.8 4 11.6m-4.1-4.4c-5.8-.4-8.8 2-6.8 7.8m.5-6.4c-5.7-2-6.6-7-4.1-12m-.8 7.6c-6.2.2-9 3.3-9 7.5"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M340.5 229.7c-4.5 1.9-6 8-4.3 11.3 1.7 3.3 7 3.6 10.2 1.4M328 224.9c-4.1 4.6.6 13.7 8 11.5m-18.6-15.1c-3.8 5.4.4 14.4 10.3 11.8m.5 25.1c-1-6.4 5.7-10.6 14-2.3m-4-13a10.1 10.1 0 0 0-3.3 8.5m-28-33.2c-4.3 7.2.9 13.8 10 11.2m13.8 6.7c-6 6-4 12.1.5 15.6m-4.4-8.5c-9.1.1-9.6 10.7-2.2 14m-4.7-24.6c-3.8 2.6-5 9.7 1.5 12.5m-1.8 3.4c-3.9-1.8-8.5.4-8.1 4.9m2.3-4.8c-3.5-8.2-13.6-6.8-12.7 1.7m15.5-11.9c-2.1.4-6.5 1.7-8.2 5m.6-14.3a7 7 0 0 0 2.5 11.4M296.7 216c-.8 5.6 1.4 8.3 8.4 7.8m-6-.7c-2.6 6.7 1 9.7 8 9.3m-6.4-1c-4.1 4.9-1.3 10.1 2.7 12.3m-4.6-6.1c-7.4-1-8.5 7.6-6 11.5"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M292.9 215.5c-4.5 2-7.1 7.6-4.7 11 2.5 3.5 7.4 2.4 10 .6m-8.4 1c-3.8 5.7-.4 10 3.6 11.6"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M275.3 214.8c-3 3.1-1.1 9.4 6 9.6 5.9 0 8.8-5.4 7-9.3m-8 9.3c-2.3 5.1-.8 10.7 8 9.8m3.6 8c-5.3-2.4-12.6 0-9.5 6.5m-.7-15.6c-2.2 3.1-1.5 7.5 1 10.2m-1.4-2c-3.6.7-7.1 2.6-5 8.3m-.5-4.6c-4.6-1.4-10.5 2-7 6.7m-.7-4.5c-4-.7-8.7 3.6-4.9 7.8m-1.5-3.5c-3.6 1-7.9 5-4.1 8.3m22.3-28.5c-5.2 2.3-5.7 8.1-3.3 12.4m-2.2-23c-7.7 3-7.6 13.2 1 16.4m-3.7-2.3c-4.6 2.7-5.5 7.9-2.4 11.2m-5.7-29.2c-3 1-2.8 10.5 5.4 10.3m-13.9-7.1c-6.2 4.1 1.3 14.5 11.3 7m-5.5 2.7c-.9 4.2.3 8.8 7.1 9.4m-6.7-3.8c-4.9 1.8-5.8 11.9 3 12.7m-18.6-21.8c-6.3 5.8 5.2 10.8 9.4 2.4m-18.1 7.2c-3.1 3.8 7.7 13.6 12.5-2.8m1.1-.3c.3 4 2.6 6.2 7.3 6.5m0 3.7c-7.7 1.2-10.1 10.7-1.6 12.8m-12.5-14c-.3 3.5 3.5 6.5 7.7 5.9m3.9 7.8c-7 1.6-7.9 10.6-1.7 10m-3.2 8.4c-5.8-1.7-6-8.6-.8-11.2"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M245.7 267.8c-4.9 3-3 10-.4 11s4.7-.2 5-2.4m-.5 10c.6 3.3-11.9 2-5.5-8.4m0 8.9c-4.2 6.6 2.6 12 6.9 6.3m-6.4 1.6c-1.7 5.3 4.7 9.1 8.8 5M231 245.4c-2.3 4.7 9.3 6.5 10-3.3m-13.2 10.3c-2.3 9.3 15.2 7.4 10.7-4.6m.4 6.2a8.2 8.2 0 0 0 11.6-6.3m-5.3 6.6a10 10 0 0 0 4.7 6.3m-13.1-3.9c-.8 5 4.3 9.2 10 8.8m-9.1-3.9c-2.8 3.9-3.7 11.3 5.2 11.8M224 263c-1.4 4 7 8.1 11.8 1.5m-14.4 8.7c-.7 3 6.8 7 11-5.8m-3.3 6.5c1.8 3.2 7.9 5.8 11.6-.5m-6 3.9c-1.6 4.5 2.7 8.7 7.8 7.5m-17.5-8.5c-1 6.4 6.5 10.1 11 6.8m-15.9-4c-2.2 8.2 8.4 11.3 12.4 5.1m-2.7 2.5c.4 4.6 7.6 8.6 13.2 4.8m-26.1-1c-.5 2.1 8.1 4.2 9.4-3m-4.4 4.9c2 5.2 9 6.5 13 0m-2.3 2.6c1 5 7.2 7.7 12.8 4.3m2.3 2c-1.4 6.5 5.4 11.8 9.6 8.2m-20.6-9.4c-2 7.2 7 11.3 12 7.3m-22.8-11c-.5 6.8 4.8 10.8 10.8 7.8m-22.3-7c-1.8 4.3 7.8 7.9 12.3 4.2m-18.2 7.7c2.5 2.8 11 0 11.7-6.3m-2.3 4.6c3.1 3.6 10.5 5.6 13.4-2.2m-2.6 4c0 5.6 9.8 9.6 13-.6m11.7 2c-1 2.7 1.2 7 5.7 7.5m-13.9-9.2c-.6 3 3.9 7.4 8.7 5.7m.9 1.3c-1.3 3.3-.2 8.1 4.3 8m-3.9-1.8c-3.4 2.8-2 7.9 2.9 8m-4.6-3.2c-4.8 3.2-3.1 10.3 3.2 9.9M239 313c0 7 8.7 8 10.3 1.6m-3.3 4c-1.3 4.2 2 8.2 7.3 7m-6.3 42.8c1.2 1.7 6-1.2 4.7-4-1.3-2.8-6.4-1.3-5.8 1.7m4.6-2.9c.6-5.6-6-6.5-7.7-1.6m2.4-2.9c1.7-2.8-4-6.7-6.3-2.5m2-1.7c1.6-4.1-4.8-6-5.3-2.2m-1.5-5.4c.8-2 8-.8 5 3.5m5.5 5.1c2.8-2.6-2-7.8-5-6m24 13.9c-2.2.2-4.5 1.7-2.9 6.5 1.2 3.3 6.1 3.4 6.9 1.5"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M260.5 365.9c-2.2-1.5-7 1-4.8 5.6 1.6 3.5 5.8 2 6.4.2m-14 .8c1.2 2 6.6 1 7.6-1m-3.8-5.4c1.2-.8 3.3.2 3.7 1.2m-4-33c-3.8 2.5-1.5 10 4.3 8m-5.6-1.9c-3 2.3-.2 9.6 5.3 6.8m-4.3 0c-2.1 2.1-.1 7.8 5.2 6.7m-6-3.8c-1.2-.5-4.2-.2-5.5 1.8m2.1-28c-2.8 2.8-1.4 8.3 3.8 8.8m-4.8-3c-4 2-4 10 4 10.3m-4.3-1.3c-2.3 1.8-1.2 8.8 4.6 7.9m-2.8-.3c-.8.9-1 3-.2 3.9m-2.3-6.5c-2 0-4.8 1.5-5.5 3.7m-3.7-7.5c.7-2 7.1-2 7.6 4.1m.6-7.2c-.9.2-2.6 1-3 2.8m.2-21.7c-2.7 2.6-4 10.5 4.3 12m-9.9 4.4c0-2.1 5.8-4 7.8-.8M232 322.8c.8 1.6 4.8 3.8 7.2 2m-28-14.6a6.3 6.3 0 0 0 7.2 6.5c4.3-.5 5.2-4.2 3.9-6.7m-3.2 6.9c-2.9 3.4.6 8.3 3.8 6.9m-.6-9.4c1.7-.6 7.2-1.4 8.9 1.2m-26.8-.2c-1.3 2 6.7 3.9 9.4.2m-2.7 1.9c-.3 2.6 1 7 7.6 5.1"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M219.8 326.6c1-2.2-3.8-5.8-7.6-1.8-3.7 4 .6 8.5 2.9 7M202.7 318c-2 3.4 5.5 9.5 9.8 3.8"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M197.7 323.8c-2.7 2.8.7 7.9 4.7 6.3 4.1-1.5 3.7-5.8 2.7-6.9"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M192.5 329c-2.2 2 0 6.6 3 6.6s4.9-2.3 4.3-5.4m5-1.6c-.4 3 4 5 6.9 2.2m0-5.4c.5-.6.2-1.7-.5-2.3m-23.4 9.8c-2.5 2 3 7.6 6.3 2.5m13.1-3.5c-1.6 1.5 1 5.5 3.6 4.3m-12.4-1.5c.4 2.7 5.8 4.8 9.2.6m-6.3 2.1c-.8 1.8.9 4.5 3 4.2m48.3 11.8c-2 3.9 4.4 8.5 9 3.7m-4.4 2.1c-1 2.1.2 5.1 2 6.2m-8-1.7c.4-2 3.2-3.8 5.7-2.9m-9-2.2c.3-1.8 2.6-3.5 4.4-3m147.2-77.4c-9.2.1-5.3 14.8 2.6 11.9m-5.6-1c-1.8 2.9 1.7 7.6 5.6 4.8m-1 .6c-2.8 4.5 6.9 11.4 10.8 4.3m-3.1 2.7c0 4.3 12.5 7 10.7-1.5m-1.2 4.6c3 5 14 5.5 12.9-2m-2.5 5.2c2.3 3.4 13.2 5.4 12.8-1.5m-56.7-40.8c1.5 4 6.8 5.4 12.6 3m-16-.2c3.7 2.3-1.6 12.9-7.1 8.6m7.2-2c4 1.9 8.9.5 10.3-5.2m-2.5 4.4c.4 3 4.7 5.3 10.2 4.1m-20.1-1c5.2 4.4-2.3 13.4-5.7 9.3m7.6-6c2.5 1.8 8.8.8 9.4-4m-2.8 4c.5 3.1 3 4.3 6.4 4.4m-14.4-.1c2.6 3.6 9 4.6 11.9-.1m-2.9 2.7c-.2 3.4 3.6 6.3 7.6 5.5M375 295c3.3 1.7 7-4.7 4.1-9m-.2 15.7c4 .2 4.5-5.8.7-9.2m8.4 14.7c3.4-.8 2.3-8.1-5.8-8.7m16 14.1c3.2-.9.6-9-8.3-8.5m20.5 11.4c2.2-3.4-5-9-11-6m17 10.6c4 1.2 6.8-9.4-5.9-7.7m13.3 7.7c3.5-1 6-7.2-4.2-5.2m12 5.7c3 1.6 4.4-7.5-5-5m-47-23c3.9 2.1 10-.4 9.4-5.3m-1.5 4.2c1.3 2.3.8 6.8-1.7 8m2-2.6c2.6 1 6.1.1 8.2-4m-3.6 4c.7 1.8 1 5.4-.7 7.2m1.3-4.1c2.9 1.6 6.2-.5 7.6-3.5m-1.8 2.6c2 1.3 3.9 7.3.4 9.8m2-2.8c2.4 0 6 0 8.3-3m-1.7 1.7c2.2.6 4.8 4.2 3.9 7.4m.1-1.1c2.5-.3 6.7-2 7.9-5m-1.2 2a6.6 6.6 0 0 1 3.2 6.5m0-2.1c2.5-.1 4.7-1.4 5.3-4.1m-.6 1.8c1.8.6 4 2.7 4.1 5.1m-.3-1.5c1.8-.3 3.1-1.4 4.3-3.2m4.9-.3c2.3 2.3-.8 10-5.6 8.6m-43.9-164.7c-4.7 2.9-18.3 2-11.6-9.2m13 1.6c-9.5 3.8-21-3.5-9-11.3m-3.2-2.6c-7.8 0-13.1 12.6-2.6 17M348.6 138c-2 4 5.3 8.4 10.3 4.4 3.9-3.1 3.6-11.5 1.3-14.7m-15.6 19.8c-2.6 8.5 16.4 9 13.4-4.5m-14.4 17.2c.6 6.4 18.1 4.3 12.5-8.7m2-3.6c1.4 2 5.3 5.3 11.9 4.6m-9-13.5c.6 2.3 4.5 4 9.5 2.3M185.4 334.8c-4.5 3.1 2.4 8.1 4.9 2.6m-8.4-.2c-4.4 3.2 2.4 8.2 4.9 2.7m-8.6-.3c-4.4 3.2 2.4 8.1 5 2.7m-8.8-.5c-4.3 2.3.7 7.8 5 3m-9.2-.9c-4.3 2.3.7 7.8 5 3m16.6-9.6c-.1 3.3 6.1 4.6 8.4-.3m-4.5 3.3c-2 2.5 1.6 5.5 3.5 4.4m-11.8-4.8c-.2 2.8 5.2 4.4 7.8 1.3m-4.9 1.6c-1.7 2.2 1.7 5.3 4 4.4m-10.5-4.8c.2 2.2 3.3 4.7 6.6 3.3m-4.6-.3c-1.3 1.1-.7 3.8 1.1 4.7m-7.8-5c-.5 2 2.9 5.6 6.4 3.3m-5.7-1c-2 1.7-1.8 4.1.8 4.5m-5.8-4.7c-.2 1.4 1.5 3.6 3.7 3.3m-14.7-3.4c-2 1.1 3.2 6.7 6.5 1.5m-11.6.8c-2.6 1.2 3.8 7.4 6.7 1.1m10-1.3c-2 .4-3.3 3.3-1.6 4.5m-5-3.5c-.2 1.2 2.3 3 4.3 2.4m-5.9-1.9c-2 1.2-.9 4.6 1.4 4.1m-8.3-1.8c-1.8 1.3-.5 4 2 3.4m1.3-3.6c0 .7 1.7 1.8 3 1.3m-12.5-2.5c-2.3 1-2.1 6.6 5.5 3.6m-10.6-1.3c-3.2 1.5-2.1 5.8 4.8 1.7m.5.3c-.8.7-1.7 3.5 1.5 2.4m-7.2-1c-1.3 1.1-.5 3.5 2.3 2.6m-9-2.2c-2.3 1.3 2.8 3.1 6.2-.5m-4.6 2.1c-1 1-1 4.1 1.6 3m-8.2-1.7c-1.5 1.1 1 2.7 6 .5m-4 1.1c-1.9 1.5-1.7 3.4 1 2.8m-6.4-2c-2 1.9.9 3.1 4.4 1.6m-4.4.5c-3.4 1.5-1.9 4.4.2 3.3m113.8 6.5c-.8 1.7 1.8 3.1 4.3 2.7 2.3-.3 4.6-2.3 2.8-5m.1 3.4c2.4 1.8 6.5-.3 6.5-3"
            })
          ]
        }),
        /* @__PURE__ */ jsxs79("g", {
          fill: "#fff",
          strokeWidth: 0.4,
          children: [
            /* @__PURE__ */ jsx104("path", {
              d: "M396.8 103c-10.3-5-31.7-14.6-37.8-6.9 5.6-2.3 21.8.1 35.2 12.5z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M403 102.5c-11.9-13.9-19-10.8-27.5-15.5-8-4.5-20.8-5.4-23.3 1.7 11.7-5.7 22.5 3 29.2 4.2 9 1.4 14.2 8.5 16.9 11.7l4.7-2zm44.9-1.8c-6.2-14.1-19.4-10.4-25.2-16.4-8.5-8.8-30-17-39-10.9 19.6-1 28 13.5 38.4 18.6 7.5 3.6 15.5 11.3 25.8 8.7z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M424.7 99.2c-10.5-13.1-26.8-24.7-34.2-20.4 9.8.6 12.9 7.4 19.8 11.8 7 4.3 3.9 10.7 14.4 8.6zm-50.2 23.2c-11-4.1-32.7-6.2-42.8 6.4 16.8 2.9 42 1.3 42.8-6.4z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M372.4 127.3c-11-5.2-19.7 2-30.1 1-19.8-2-34-.8-35.8 8.8 11.3-10.2 30.4-1.8 38.1-3.9 7.7-2 36.3-.3 45.3 3.6-4.6-5.7-11.8-7.2-17.5-9.5zm34.8-29.5c-2.6-8.5-2.4-17.5 10.3-16.9-3.2-4-15-6-17 8.9-14-10.3-29.4-12.1-32.2-3.2 7.2-6.2 18.4-1.7 31.8 13.5a23.8 23.8 0 0 1 7.1-2.3z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M387.9 109.5c-8-5.2-18.8-13.5.1-16.9-8-4.3-20-2.4-18.7 12.5-21.6-8.7-37.1-5.8-40.4 2.9-3.6 9.5 9.8 14.8 12.1 8.7-2.4 1-10.8-1.8-6.4-7.2s26.8-1.3 48.1 9.8c6 3 26.3 2.6 5.2-9.8z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M382.2 123.7c-6.1-12.6-26.1-1.2-30.1-13.4-5.6 17.9 28.4 8 30.1 13.4zm127.1 13.6c4.2 2.1 7.8-1.2 1.4-3.7 4.2 2 7.9-1.1 1.5-3.7 4.2 2 7.8-1.1 1.4-3.7-1.7 1.7-4.1 8-4.3 11.1zm2.2-24.2c9.3-9.8-.7-13.1 10.6-23.2 9.3-8.2 1.8-13.7 10.5-20 2.9-2.1 9-6.2 9.6-10.4 3.7 9.3-11.6 10.6-10.6 25.5.7 9.5-5.8 8.7-8.2 24.8-.5 3.3-2.9 10.8-11.9 3.3z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M515.6 117.5c5.2-11 11.1-10.9 14-15.2 5.4-8.3 16.8 1.4 26.5-6-1.7 10.5-14.7 6.8-20.4 13.5-5.6 6.7-10.3 9.7-20 7.7z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M517 121.1c9-7.2 15.6-2.4 21.8-6.2 15.7-9.5 22 2 36-2.6-3.6 9-24.4 1.3-33.4 8s-40.7 13.2-24.5.8zm-26.3 51.4c-.2-4.1-4-9.4-9.4-10-5.4-.7-7.8-6.4-11.9-6.6-4.1-.3-6.8-8.5-12.5-8.4-5.6.1-8 7.5 5.3 14.2 13.3 6.7 28 14.4 28.5 10.8zm-16.8 3.5c-5.6.2-6.4 8.5-11.8 8.7 7.4 4 12.9-1.8 16.7-7L474 176z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M478.6 177c-5 4.1-6.4 12.7.7 15.2-4.2-5.9 7.5-8.5 3.9-14z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M483.4 177.3c-3.8 7.4 6.1 8.3 3.5 14 5.7-1.3 6.6-12 1.4-14.8l-4.9.7z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M445.6 161.3c9.3-.5 17.7 4.5 23.4 12.6 3.6 5.1 15.7 7.2 19.9 3 4-4 1.8-12.8-8.5-10-2.6-4.3-10-2.8-13.7-6.4-3.6-3.6-17.5-13.9-21.1.8z"
            }),
            /* @__PURE__ */ jsx104("path", {
              strokeLinecap: "round",
              d: "M480.4 167c-2.5.5-3.3 4.7-1.7 6.9m7-4.4c.7 1.3.2 3.1-.2 4m-25.2-11.8c4.7.2 5.6 3.7 10.8 5"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M457.1 150a161 161 0 0 1 37.6 12.3c8.1 4.6 20.7 6 31.6 2.8 11-3 32.2-5.9 31.1 7.8 5.8-6.9-1.5-14.2-16.2-15.5.3-6.7-6.9-12.7-12-8.7 4.7-.7 8.8 8.2-.6 11.8a8.4 8.4 0 0 0-11.7-9.8c4.4 1.3 9 8.8-1 11.6-6.3 1.8-15.4-.5-22.2-4.6-6.8-4.1-45-19-36.6-7.8z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M498.6 143.3c-5.1 2.3-1.8 7.7-9.7 10.8-8 3-13.6 10.1-11.8 16.2 5.4-11.9 15-11.3 18.3-16 3.4-4.6 8.3-11.4 3.2-11z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M500 144c-.2 9.4-7.6 6-4.7 19.2.9 4.1 2.6 10.8-.3 17.5 8.3-6 3-18.7 6.7-23.5 1.8-2.4 4.2-6 5-9-1.9 5.3-1.7 15.4 3.5 18-4.2-10 11.5-18.3.7-30-1.6 3-6.5 8-10.8 7.8zm-26.2-9.4c1.3 2 2.6 6.8 1.4 9.6 2.6-1.6 6.3-5.6 7.5-8.3 5.3.8 7.3 7.3 2.3 10.2 3 0 8.4 0 11.3-3.5-3.6-4-14.8-10.2-22.5-8z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M393.7 116.1a10 10 0 0 0-4.8-2c-7.8-1.6-3.7-8.6 2.9-8.5 14.2-15.5 22.1-3.6 39.4-8.4 6-1.8 10.2-1.3 13.4.2 7.8-5.2 16.8-3.8 23.4 2.3a5.3 5.3 0 0 1 3-2.4c6.1-1.7 11 3.4 12.7 10.1 4.7-.8 10.1 1.5 13.7 4.7 4.9-2.5 8.2-2.6 9.5 0 4.4-2 10-3.4 12.9 3.6s-6.7 4.9-8.3 19.6c-1 9-11 12.6-19 7.2-12.8-8.7-25.3-10-31.5 3-6.1 13.2-11 20.8-26 16.5a16 16 0 0 0-16.7 6.5c-4.4 6-11 .4-19 1 10-1.5 6.1-4 14.9-4.6 8-.5 5.9-8 11-9-20 5.1-19.3-2.4-35.8 2.8 7.2-9.3 18.6-4.1 24.2-9.5-14.9-.3-21.6-10-28.3-6-10.5 6.5-6 24.8-33.5 23.2-13.4-.7-21.9 1-29.8 9 13.9-28.8 32.8-13 42-22.1a68 68 0 0 0 12.3-14.7 6.1 6.1 0 0 1 4-3.2c-22.9-7.2-9-18.5 13.4-19.3z"
            }),
            /* @__PURE__ */ jsx104("path", {
              strokeLinecap: "round",
              d: "M506.9 112c.3.8.5 1.8.5 3 0 5.6-8.5 5.8-9 14.2-.3 4.4-.8 6.8-3.7 6.3-3-.5-5.6-5.1-2.8-10.5"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M398 107.7a10.9 10.9 0 0 0-6.2-2.1m52.8-8.3c6.8 3 10.1 10 20 10.4 9.6.3 15.5 14.2 31.5 5.1a38 38 0 0 1 1.2-.6M468 99.7a12.7 12.7 0 0 0-1.4 8.2m-29.8 21c-12 0-15.2 6.1-15.2 12 0 6 5.7 13.7 15.7 13.7s15.5-6.2 15.5-12.9-6.2-12.9-16-12.9z"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M439 154.3c-.2-3.3-6.3-2.8-6-5.4.2-2.6 3.3-3.6 3.3-7.2s5.4-3.9 7.2-1c1.8 2.8 7.2 8.3 8.4 5.5m-8.4-5.5a9.9 9.9 0 0 0-.4 13.1m4.3-8.8c-1 2-1.2 5-.1 6.8"
            }),
            /* @__PURE__ */ jsx104("path", {
              fill: "none",
              d: "M495.5 135.6c9.5.8 11-9.7 4-10.3m-15.7-17.8c-3.2-4.2-10.8-5.6-11 3.2"
            }),
            /* @__PURE__ */ jsx104("path", {
              d: "M472 120.8c-3.2-8-11.5-9.1-15.8-5.1-3.7 3.3-3.8 12 4 13.8 2.8-3.3 8-7.5 11.8-8.7zm-3.5-5c-4.7-4.1-11.5 3.7-5.3 10.8m-83 8.7c3.2-.7 7.7.8 14.7 4 4.3 2.1 17.5 6.5 25.7 2.1-8.5 3.1-15-9.7-21.4-8.2-6.4 1.6-18.2 4-23.1-.8 12 .8 18.5-8.8 32.4-.5a24 24 0 0 0 13.1 3.6c-11.3-13.6-26.2-4.9-27.8-16 6.8 7.4 23.5-1.6 32 12.1m-29.5-10c-1.6-2-1-4-2.6-5.5"
            })
          ]
        }),
        /* @__PURE__ */ jsx104("path", {
          stroke: "none",
          d: "M483.8 107.5c-2.8-3-9-.7-7.2 5.4a9.6 9.6 0 0 1 7.2-5.5zM466.3 124a21.1 21.1 0 0 1 5.7-3.2 12.4 12.4 0 0 0-3.8-5.2c-1.5-1-5.7 4.7-1.9 8.3z"
        }),
        /* @__PURE__ */ jsx104("path", {
          fill: "none",
          strokeLinecap: "round",
          strokeWidth: 0.4,
          d: "M458.7 113.5c-4.6-3.1-8.9-2.8-10.3-.3-3.3 0-6.1 2.4-6.2 7.2m7.1 2.1c-5.5-3.8-13.1-2.4-12.6 6.1m-3.4 4.9c2.7-2.2 6.6-3.8 9.6 0m31.8-8.4c-1 1.4-1.8 3.6-.1 7-2-2.8-7.2-2.8-12.8 4.4m25.1-11.8c-6.7.8-6.5 5.2-1.1 7m-46.5-23.4c-5.7-1.1-9.8 2.2-2 5m12.8-8.8c-8-2-11.2.1-7.6 2m-15.5 30c-.2 2.9 1.3 6.6 6 2.4m-4.4 6.1c0 .8-.1 1.7-.7 2.4m-17.9-40c-4.9-1.5-5.8-6 0-5.6m-1.6 16c-5.4-1.9-5.4-7.1-1-6.6m11 3.8c-6.3-1.5-6.5-5.9-1.8-5.2m2.6-8.2c-3.4-.2-8.5 3.5.1 5.7m9.3 1.8c-7.9-1.1-7.7 2-3.1 4.1m9-11.6c-6-1.1-8.1 2.5-4 4m-15 18.3c-1.5-1.2-2.7-7 4.3-5.3m10.3 3.5c-4.7-1.3-9.2 3.4-4.9 6m11.2-11.5c-5-1-9.2.5-6.5 2.3"
        }),
        /* @__PURE__ */ jsx104("path", {
          fill: "#fff",
          strokeWidth: 0.4,
          d: "M483.6 107.5a9.6 9.6 0 0 0-7 5.4"
        })
      ]
    })
  ]
});
var Bt_default = SvgBt;

// src/country-flag-icons/generated/Bv.tsx
init_esm_shims();
import { jsx as jsx105, jsxs as jsxs80 } from "react/jsx-runtime";
var SvgBv = (props) => /* @__PURE__ */ jsxs80("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx105("defs", {
      children: /* @__PURE__ */ jsx105("clipPath", {
        id: "bv_svg__a",
        children: /* @__PURE__ */ jsx105("path", {
          fillOpacity: 0.7,
          d: "M0 0h640v480H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs80("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      clipPath: "url(#bv_svg__a)",
      children: [
        /* @__PURE__ */ jsx105("path", {
          fill: "#fff",
          d: "M-28 0h699.7v512H-28z"
        }),
        /* @__PURE__ */ jsx105("path", {
          fill: "#d72828",
          d: "M-53-77.8h218.7v276.2H-53zM289.4-.6h381v199h-381zM-27.6 320h190.4v190.3H-27.6zm319.6 2.1h378.3v188.2H292z"
        }),
        /* @__PURE__ */ jsx105("path", {
          fill: "#003897",
          d: "M196.7-25.4H261v535.7h-64.5z"
        }),
        /* @__PURE__ */ jsx105("path", {
          fill: "#003897",
          d: "M-27.6 224.8h698v63.5h-698z"
        })
      ]
    })
  ]
});
var Bv_default = SvgBv;

// src/country-flag-icons/generated/Bw.tsx
init_esm_shims();
import { jsx as jsx106, jsxs as jsxs81 } from "react/jsx-runtime";
var SvgBw = (props) => /* @__PURE__ */ jsx106("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs81("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx106("path", {
        fill: "#00cbff",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsx106("path", {
        fill: "#fff",
        d: "M0 160h640v160H0z"
      }),
      /* @__PURE__ */ jsx106("path", {
        fill: "#000001",
        d: "M0 186h640v108H0z"
      })
    ]
  })
});
var Bw_default = SvgBw;

// src/country-flag-icons/generated/By.tsx
init_esm_shims();
import { jsx as jsx107, jsxs as jsxs82 } from "react/jsx-runtime";
var SvgBy = (props) => /* @__PURE__ */ jsxs82("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  xmlSpace: "preserve",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx107("defs", {
      children: /* @__PURE__ */ jsx107("clipPath", {
        id: "by_svg__a",
        children: /* @__PURE__ */ jsx107("path", {
          d: "M0 0h200v608h8v284l-8 8H0z"
        })
      })
    }),
    /* @__PURE__ */ jsx107("path", {
      fill: "#ce1720",
      d: "M0 0h640v480H0Z"
    }),
    /* @__PURE__ */ jsxs82("g", {
      fill: "#fff",
      clipPath: "url(#by_svg__a)",
      transform: "matrix(.52885 0 0 .53333 5 0)",
      children: [
        /* @__PURE__ */ jsxs82("g", {
          id: "by_svg__c",
          children: [
            /* @__PURE__ */ jsx107("path", {
              id: "by_svg__b",
              d: "M36 0v14h-9v14H16v16H8v13H-8V24H8V6H-8V0Zm26 77v15h-8v12h-8V92h-8V77h-8V57h8V42h8V30h8v12h8v15h8v20Zm-17-1h10V58H45ZM19 183h8v-18h-8zm54 0h8v-18h-8ZM-8 305H6v13h6v16h9v15h12v-15h9v-16h8v-13H38v-15h21v10h13v17h11v19h-8v14h-7v13h-6v14h-9v12h-7v11h-9v14H24v-15h-9v-14H8v-9H-8v-23H8v-20H-8Z"
            }),
            /* @__PURE__ */ jsx107("use", {
              xlinkHref: "#by_svg__b",
              transform: "matrix(-1 0 0 1 200 0)"
            }),
            /* @__PURE__ */ jsx107("path", {
              d: "M96 0v32h8V0h32v14h-8v14h-12v16h-8v13H92V44h-8V28H72V14h-8V0Zm-2 274v-11h-6v-13h-7v-14h-8v-14h-8v-10h-9v-14H44v14h-9v10h-7v14h-8v14h-6v13H8v17H-8v-44H8v-20H-8v-33H8v14h10v14h10v-14h10v-14h8v-18h-8v-14H28v-14H18v14H8v14H-8v-41H8v-19H-8V77H8v13h8v16h11v13h9v15h7v12h14v-12h7v-15h9v-13h11V90h8V77h16v13h8v16h11v13h9v15h7v12h14v-12h7v-15h9v-13h11V90h8V77h16v28h-16v19h16v41h-16v-14h-10v-14h-10v14h-10v14h-8v18h8v14h10v14h10v-14h10v-14h16v33h-16v20h16v44h-16v-17h-6v-13h-6v-14h-8v-14h-7v-10h-9v-14h-12v14h-9v10h-8v14h-8v14h-7v13h-6v11zm2-167v27h8v-27zm-4 58v-14H82v-14H72v14H62v14h-8v18h8v14h10v14h10v-14h10v-14h16v14h10v14h10v-14h10v-14h8v-18h-8v-14h-10v-14h-10v14h-10v14zm4 46v27h8v-27z"
            })
          ]
        }),
        /* @__PURE__ */ jsx107("use", {
          xlinkHref: "#by_svg__c",
          transform: "matrix(1 0 0 -1 0 900)"
        }),
        /* @__PURE__ */ jsx107("path", {
          d: "M-8 408H8v14h7v8h8v14h7v12h-7v14h-8v8H8v14H-8Zm216 0v84h-16v-14h-7v-8h-8v-14h-7v-12h7v-14h8v-8h7v-14ZM62 459h8v-18h-8zm76 0v-18h-8v18zm-42-59h8v-18h-8zm0 100v18h8v-18Zm-50-75h14v-11h10v-10h5v-10h6v-14h8v-14h4v-13h14v13h4v14h8v14h6v10h5v10h10v11h14v50h-14v11h-10v10h-5v10h-6v14h-8v14h-4v13H93v-13h-4v-14h-8v-14h-6v-10h-5v-10H60v-11H46Zm50 9v-15h-8v-10h-8v25h8v9h5v14h-5v9h-8v25h8v-10h8v-15h8v15h8v10h8v-25h-8v-9h-5v-14h5v-9h8v-25h-8v10h-8v15z"
        })
      ]
    }),
    /* @__PURE__ */ jsx107("path", {
      fill: "#007c30",
      d: "M110 320h530v160H110Z"
    })
  ]
});
var By_default = SvgBy;

// src/country-flag-icons/generated/Bz.tsx
init_esm_shims();
import { jsx as jsx108, jsxs as jsxs83 } from "react/jsx-runtime";
var SvgBz = (props) => /* @__PURE__ */ jsxs83("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsxs83("defs", {
      children: [
        /* @__PURE__ */ jsxs83("radialGradient", {
          id: "bz_svg__a",
          children: [
            /* @__PURE__ */ jsx108("stop", {
              offset: 0,
              stopColor: "#ffef5d"
            }),
            /* @__PURE__ */ jsx108("stop", {
              offset: 1,
              stopColor: "#ea5700"
            })
          ]
        }),
        /* @__PURE__ */ jsxs83("radialGradient", {
          id: "bz_svg__b",
          children: [
            /* @__PURE__ */ jsx108("stop", {
              offset: 0,
              stopColor: "#952d1a"
            }),
            /* @__PURE__ */ jsx108("stop", {
              offset: 1,
              stopColor: "#570a00"
            })
          ]
        }),
        /* @__PURE__ */ jsx108("radialGradient", {
          xlinkHref: "#bz_svg__a",
          id: "bz_svg__c",
          cx: 247.1,
          cy: 238.3,
          r: 36,
          fx: 247.1,
          fy: 238.3,
          gradientTransform: "scale(1.22624 .8155)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx108("radialGradient", {
          xlinkHref: "#bz_svg__a",
          id: "bz_svg__d",
          cx: 322,
          cy: 152.9,
          r: 10.6,
          fx: 322,
          fy: 152.9,
          gradientTransform: "scale(.93615 1.06821)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx108("radialGradient", {
          xlinkHref: "#bz_svg__b",
          id: "bz_svg__e",
          cx: 364.2,
          cy: 237.8,
          r: 36,
          fx: 364.2,
          fy: 237.8,
          gradientTransform: "scale(1.2242 .81686)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx108("radialGradient", {
          xlinkHref: "#bz_svg__b",
          id: "bz_svg__f",
          cx: 468.1,
          cy: 156.1,
          r: 10.7,
          fx: 468.1,
          fy: 156.1,
          gradientTransform: "scale(.95596 1.04607)",
          gradientUnits: "userSpaceOnUse"
        })
      ]
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#ce1126",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#003f87",
      d: "M0 34.3h640v411.4H0z"
    }),
    /* @__PURE__ */ jsx108("circle", {
      cx: 320,
      cy: 240,
      r: 188.6,
      fill: "#fff"
    }),
    /* @__PURE__ */ jsx108("circle", {
      cx: 320,
      cy: 239,
      r: 156.3,
      fill: "none",
      stroke: "#552300",
      strokeWidth: 3.9
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#007f00",
      d: "M302 73.2c14-15.2 26.9 2.3 26.5 10.6C328.2 92 314 110 301 95.5c13.4 3.4 17.4-11.5 24.1-11.7-6.7.2-9.5-14.6-23.2-10.6zm-147.2 119c-7.4-19.4 14-23 21.3-19 7.3 3.9 17.3 24.6-1.6 29.6 9-10.4-2.7-20.5.2-26.6-2.9 6-17.5 2-19.9 16M471.9 173c19.4 7.6 7.6 25.8-.2 28.4-7.9 2.7-30-4-21-21.2 1.6 13.6 17 12 19.7 18.1-2.6-6.2 10.3-14 1.5-25.3M218.8 377.4c-20.7-2-14.3-22.7-7.5-27.4 6.8-4.7 30-4.3 26 14.7-5.3-12.6-19.7-6.8-24-12 4.3 5.2-6 16.3 5.5 24.7m209.3-15c.3 20.7-21.1 16.8-26.6 10.6-5.4-6.2-7.7-29 11.8-27.3-12 6.6-4.6 20.2-9.4 25 4.8-4.8 17.1 4 24.2-8.2zM170 153c-1.9-20.6 19.8-18.3 25.7-12.6 6 5.8 10 28.4-9.6 28.2 11.5-7.6 3-20.5 7.4-25.6-4.4 5-17.3-2.8-23.5 10m22.2 193c-20.5-3.5-12.7-23.7-5.6-27.9 7-4.2 30.1-2.3 25 16.4-4.5-13-19.3-8-23.1-13.6 3.8 5.5-7.2 16 3.7 25zM354.3 74c18.6-9.2 24.3 11.7 21 19.3-3.2 7.5-23 19.4-29.8 1.3 11.2 7.9 20.3-4.7 26.7-2.4-6.4-2.3-3.7-17-17.9-18.2M394 388.3c-9.3 18.5-26.5 5.3-28.5-2.7s6.5-29.3 23-19c-13.8.5-13.4 16-19.8 18 6.4-2 13.3 11.4 25.3 3.7m90.5-178.7c15.6 13.7-1.7 26.8-10 26.7-8.2-.1-26.8-13.8-12.5-27-3 13.4 12 17 12.4 23.6-.3-6.7 14.5-9.8 10-23.3zm-263-108.8c4.7-20 24.5-11.2 28.4-3.9 3.8 7.3.5 30-18 23.8 13.3-3.7 9.3-18.6 15-22-5.7 3.4-15.5-8-25.4 2.1m-61.6 172.5c-18.2-10-4.2-26.5 4-28.1 8-1.7 29.2 7.7 18 23.7.2-13.7-15.4-14-17.2-20.5 1.8 6.5-12 12.7-4.8 25zm263.6-159.6c20.6-3 19.4 18.7 14 24.8-5.5 6.2-28 11.4-28.9-8 8.2 11 20.8 1.9 26.2 6-5.4-4.1 1.9-17.3-11.3-22.8M306.3 408.1c-19 8.4-23.8-12.7-20.3-20 3.6-7.5 23.9-18.6 30-.1-11-8.4-20.5 3.8-26.8 1.3 6.3 2.5 3 17.2 17.1 18.8M476.8 293c8.6 18.8-12.6 23.7-20.1 20.2-7.5-3.5-18.8-23.6-.2-29.7-8.4 10.9 4 20.3 1.4 26.6 2.5-6.3 17.3-3 19-17.1zm-325.1-60.6c-12-17 8-25.7 16-23.6 8 2 22.8 19.8 5.7 29.2 6.2-12.3-7.6-19.3-6.3-25.9-1.3 6.6-16.5 6.1-15.4 20.2zM264 395.6c-19.6 7.1-23-14.2-18.9-21.4 4-7.2 25-16.9 29.9 2-10.3-9.1-20.7 2.4-26.8-.5 6 2.9 1.8 17.3 15.8 19.9m-5.7-314c11.6-17.2 27-2 28 6.3.9 8.1-10.3 28.2-25.4 15.8 13.8 1.3 15.4-14 22-15.2-6.6 1.2-11.7-13-24.6-7zm200.2 252.1c1.3 20.6-20.3 17.7-26 11.7-5.8-5.9-9.1-28.6 10.4-27.8-11.7 7.2-3.6 20.4-8.2 25.4 4.6-5 17.3 3.3 23.8-9.3m-5.3-194.4c20.4 4 12 24 4.7 28-7.2 4-30.2 1.3-24.4-17.2 4 13.1 19 8.7 22.6 14.4-3.6-5.7 7.7-15.7-3-25.2zm-258.4-14.6c.2-20.6 21.5-16.2 26.8-9.9 5.3 6.3 7 29.3-12.4 27 12.2-6.3 5-20 10-24.7-5 4.7-17-4.5-24.4 7.6M169 311c-18.6-9.4-5.1-26.4 2.9-28.3 8-2 29.5 6.7 19 23-.4-13.7-16-13.4-18-19.8 2 6.4-11.6 13.1-4 25zM392 91c19.5-7.3 23 14 19 21.2-4 7.2-24.9 17.1-29.9-1.7 10.4 9 20.7-2.6 26.9.3-6.2-2.9-2-17.3-16-19.8m-41.3 314.8c-15.2 14.2-26.7-4.1-25.8-12.3.9-8.2 16.3-25.3 28.2-9.9-13-4.3-18 10.4-24.9 10 6.8.4 8.5 15.3 22.5 12.2m132.7-158c14.2 15.1-4.4 26.5-12.6 25.5-8.2-.9-25.4-16.3-9.8-28-4.4 13 10.3 18 10 24.7.3-6.7 15.4-8.4 12.4-22.2"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#005800",
      d: "M301 95.5c13.4 3.4 16.7-11.3 23.5-11.5-4 4.7-14.2 16.7-23.5 11.5m1-22.3c14-15.2 26.9 2.3 26.5 10.6-11.5-20-15-17-26.6-10.6zM174.4 202.8c9-10.4-2.8-19.9 0-26 2.6 5.6 8.9 20.1 0 26m-19.7-10.7c-7.4-19.3 14-22.9 21.3-19-23.1 1.4-22 6-21.3 19m295.9-11.8c1.6 13.5 16.7 11.3 19.3 17.5-5.9-2-21-7.1-19.3-17.6zm21.2-7.3c19.4 7.6 7.6 25.8-.3 28.4 14.7-17.8 10.5-20 .3-28.4M237.3 364.7c-5.3-12.6-19.2-6.4-23.4-11.7 6.2.3 22 1.2 23.4 11.7m-18.5 12.7c-20.7-2-14.3-22.7-7.5-27.4-9.2 21.1-4.6 22.1 7.5 27.4m194.5-31.7c-12 6.6-4.2 19.6-9 24.3-.4-6-1.3-21.8 9-24.3m14.8 16.7c.3 20.7-21.1 16.8-26.6 10.6 22.3 6.6 22.7 2 26.6-10.6M186 168.4c11.5-7.5 2.7-19.8 7-25 1 6.1 3 21.8-7 25M169.9 153c-1.9-20.6 19.8-18.3 25.7-12.6-22.7-4.9-22.8-.2-25.7 12.6m41.5 181.5c-4.4-13-18.7-7.6-22.5-13.2 6.1.7 21.9 2.7 22.5 13.2M192.1 346c-20.5-3.5-12.7-23.7-5.6-27.9-10.6 20.5-6 21.8 5.6 27.9M345.4 94.6c11.3 7.9 19.7-4.7 26.1-2.5-5.4 3-19.3 10.6-26 2.5zm8.9-20.6c18.6-9.2 24.3 11.7 21 19.3-3.5-22.8-8-21.1-21-19.3m34.2 292.6c-13.8.5-12.8 15.6-19.3 17.6 2.5-5.6 9-20 19.3-17.5zm5.5 21.7c-9.3 18.5-26.5 5.3-28.5-2.7 16.7 16 19.2 12 28.5 2.7m68-179c-3.1 13.4 11.9 16.3 12.2 23-4.9-3.8-17.2-13.7-12.2-23m22.5.3c15.6 13.7-1.7 26.8-10 26.7 19.9-12 16.7-15.4 10-26.7m-252.6-89c13.3-3.6 8.8-18 14.6-21.5-1 6-4 21.5-14.6 21.6zm-10.4-19.8c4.7-20 24.5-11.2 28.4-3.9-20-11.7-21.6-7.2-28.4 4zm-39.5 168c.1-13.6-15.2-13.3-17-19.8 5.6 2.7 19.9 9.7 17 19.9zm-22 4.5c-18.3-10-4.3-26.5 3.9-28.1-16.8 15.9-13 18.6-4 28.1zm248.6-142.8c8.2 11 20.2 1.6 25.6 5.7-6.1 1.2-21.7 4.1-25.6-5.7m14.9-16.8c20.6-3 19.4 18.7 14 24.8 3.7-22.7-1-22.5-14-24.8M316 388c-11-8.4-19.9 3.9-26.1 1.4 5.5-2.8 19.7-9.8 26-1.4zm-9.7 20.1c-19 8.4-23.8-12.7-20.3-20 2.7 22.8 7.2 21.4 20.3 20m150.2-124.7c-8.4 10.9 4 19.7 1.5 25.9-2.8-5.4-10-19.5-1.5-26zm20.3 9.5c8.6 18.8-12.6 23.7-20.1 20.2 23-2.8 21.6-7.2 20.1-20.2m-303.3-55c6.2-12.3-7.7-18.6-6.4-25.2 3.8 4.8 13.5 17.3 6.4 25.2m-21.8-5.7c-12-16.9 8-25.5 16-23.5-22.1 7-19.8 11-16 23.6zm123.3 144c-10.3-9.1-20 2.5-26.2-.4 5.7-2.4 20.4-8.5 26.2.3zm-11 19.4c-19.6 7.1-23-14.2-18.9-21.4 1.1 23 5.7 21.9 18.9 21.4m-3-291.9c13.7 1.3 14.7-13.8 21.3-15-3.1 5.3-11.4 18.8-21.4 15zm-2.7-22.2c11.6-17.1 27-1.8 28 6.3-14.5-18-17.6-14.3-28-6.3M443 317.6c-11.7 7.2-3.3 19.8-7.9 24.8-.7-6.1-2.3-21.8 8-24.8zm15.6 16.1c1.3 20.6-20.3 17.7-26 11.7 22.4 5.7 22.7 1 26-11.7m-25-183.6c4 13.1 18.5 8.3 22.1 14-6-1-21.8-3.5-22-14zm19.7-10.8c20.4 4 12 24 4.7 28 11.3-20.1 6.8-21.6-4.7-28m-244 2.6c12.2-6.4 4.7-19.6 9.6-24.2.3 6.1.8 21.9-9.6 24.2m-14.4-17.2c.2-20.6 21.5-16.2 26.8-9.9-22-7.1-22.6-2.4-26.8 10zm-4 181c-.3-13.7-15.6-12.8-17.6-19.2 5.7 2.4 20.2 9 17.6 19.2M169 311c-18.5-9.4-5-26.4 3-28.3-16.2 16.4-12.3 19-3 28.3m212.2-200.4c10.4 9 20-2.8 26.2 0-5.7 2.6-20.3 8.7-26.2 0M392 91c19.5-7.3 23 14 19 21.3-1.2-23-5.8-21.9-19-21.3m-38.9 292.6c-13-4.3-17.4 10.2-24.2 10 4.3-4.5 15.4-15.8 24.2-10m-2.4 22.2c-15.2 14.2-26.7-4.1-25.8-12.3 10 20.7 13.8 17.9 25.8 12.3M461 245.3c-4.4 13 10.2 17.3 9.9 24-4.5-4.2-15.8-15.3-9.9-24m22.4 2.5c14.2 15.1-4.4 26.5-12.6 25.5 21-9.9 18.1-13.6 12.6-25.5"
    }),
    /* @__PURE__ */ jsxs83("g", {
      fill: "#730000",
      stroke: "#000",
      strokeWidth: 0.5,
      children: [
        /* @__PURE__ */ jsx108("path", {
          d: "M349 120.3s.6-1.3 1.7-.6c1 .8 1.3 4.2 1.3 4.2l-1.6.8s.9-1.3-1.3-4.4zm-8.8 30.7s.8-1-.3-3.4l1.5-.5s.6 1.8-.2 3.9h-1m27-5.4-3.7 2.3 1.9.8 4.5-2.6-2.7-.5m-49.7 14.6c-1 .8-1 2.1-1.7 3-.4.7-2 1.8-2 3-.2 1.1-.3 1.9.2 3.5.6 1.5 3 8.5 2 13.7-1 5.3-.6 7.5-.3 8.3.4.8 1.6 3 2.3 3 1.6-.2.9-.7 1.5-1.7 1.4-2.5 0-22.2-.7-27.6-.5-4.2-2.5-8-2.7-8.4l-.8-2.6c-1.5-3.5-3.3-6.5-3.3-13.9 0 0-4.7 1.1-8.8-8.2-2.2-4.7-5.3-4.2-9-5.7l1.6-1.1s3.2 1.6 4.7 1.6c1.6 0 1-3.2 1-3.2l1.7-1.5v6.8c0 3.1 4.3 7.4 6.8 8.7 1.6.8 3.6-2.4 3.1-5.6-.5-3 0-7.3 0-7.3l2.2 1.3s-.8 1.3-.6 2.1c.3.8 1.3-.7 2.1-1.5 0 0 .2.2 1 .2l-2.3 4c-.8 1.2-.8 6.2-.8 8 0 2 .7 6.2.7 7.6 0 1 1.8 5 3.3 7.4l1.6 3.5c1.2 1.9 1.3 3.2 2 4.7.4.8 1 3 1.6 7l.7 7c.2 2.4 2.2.6 4.5-1 2.4-1.8 2.4-6 2.4-6s1.8-1.6 1.5-.7c-.2 1 1 2 1 2-1.4 3.3-.6 2.9.9 2.8 1.5-.2 6.5-4 6.5-4 .7-.2 3.8-.2 3.3 0-.6.3-1.4 1.7-1.4 1.7l3.3-.4c-1.1.9-5.5 3.4-6.5 4a90.6 90.6 0 0 1-8.6 4.1c-2.3 1-6.7 3.2-6.9 5.4 0 2.3.3 8.3 0 10.3l-1 10.6h-10.4s2-7.6 0-9.7c-2.1-2.1-7-8.4-10-10.5-3.2-2 2-.5 2-.5v-2.1l4.8 5.7s8.3-7.3 0-17.3c-2.6-3.1-5.3-7.9-7.3-8.4-2.2-.6-3.3-1-6.9 0-3.7 1.1-12.6 1.1-16.3-4.8l3.1-.5 2.7-1s-1.1 3.7 6.3 3.7 8.4 0 7.8-6.8l2.2-1.1 1.6 1.5s-1.1 3.8-.5 5.3c.5 1.6 3 2.7 5.1 4.2 1 .7 1.6.8 2.2.8.9-.1 1-.1 2.2-1.3 1.8-2 1.4-1.8 3.2-3.4l1-1.6z"
        }),
        /* @__PURE__ */ jsx108("path", {
          d: "M319 155c.5-.4 1.2-1.9 2-3.1 1.1-2 2.5-3.2 4-5.6 1.5-2.2 2-5.6 1.5-7.9l1.4.8v3.7l2.7-2 .8.4s-5.9 6-11.3 15.9zm-51.3-20.3c.8 1.4 1.6 4 3.9 6l1.6-.4s-3.6-4.2-3.6-6l-1.9.4m9.2-2.4s.5 5-.8 6.9l1.6-.8s1-3.4.7-5.3zm51.4-15.7s-.3 7 1.1 11.3l1.9-.5s-.3-1.3 1.2-1.9c1.6-.5 5.3-2 7.2-3.6l-.6-1.6s-2.8 2.3-4.2 2.9c-1.3.5-2 1-3.1.7-1.1-.3-2.4-2-1.6-6l-1.9-1.3m20.7 32.8s-.4 5-.2 7.2l1.7.4s-.4-6 .7-6.5l-2.2-1m7.5 3.7s-1.9 3.2-4 3.5l3.4-.7s1-.5 2.4-2l-1.8-.8"
        })
      ]
    }),
    /* @__PURE__ */ jsxs83("g", {
      fill: "#289400",
      stroke: "#030",
      strokeWidth: 0.5,
      children: [
        /* @__PURE__ */ jsx108("path", {
          d: "m326.6 138.4 1.3.8 1.3.2 3.2 2.6c1.2 1 1.2-.2 1.2-.2l.8 3.1h1l-.2 3.2 1.8-1.6 2.2 1.9s1.5-1.4 2.3-1.4c.8 0 1.1-.8 1.1-.8h.1c-5.2-2.4-7.4-5-5.9-7.6 2.6-4.4 6.8-1.6 8.1-1l19 10.2s1.3-.8.4-1.6c-1-.8-1.4-2.7-1-3.5.2-.8 2.4 2.4 3.4 2.7l3.5.7v-1s3 2.2 3 3.3c0 0 2.3-1.2 1.5-1.9-.7-.7 3.5 1.7 3.7 3l1-1c-.2 0 .2-3.2 1.3-4.6a4.8 4.8 0 0 1 2-1.9s1-1.7 2-1.7c0 0-1-.6-1.4-1.4-.5-.8-1.6-1.2-1.6-1.2s1.4-1 1.8-1.5c.4-.6.8-.7.8-.7s-2.2-1.9-3.8-2.2c0 0-.1-2.5-2-2.7h.8s-1.4-2.8-2.8-2.8c0 0 .9-1 1.6-1.1 0 0-1.6-2.2-3.9-1.4l1.5-.6s-1-1.1-4.4-.6c0 0 .3-1.3-1.2-2.4 0 0-1.2 0-1.2 1 0 0-1.2-1-2.7-1-1.4 0 .5 1.6.5 1.6s-2-1.3-3.1-1c0 0 .5-2.2-.8-3.3 0 0-1.4.7-1.8 1.7l-.4-1s-2 2.4-2.4 1.7c-.3-.4-.6-2-.6-2l-1.1 1.7.2-2.4s-1.4.8-2.5 3.3c0 0-1.3 1.3-1.3 2.4 0 0-1.1-1.2-2 0-1 1.4 0 1.1 0 1.1s-.5.5-1.5.7l.2.8s-1.2-.7-2.2-.4l.5 1.2s-2.6.2-2.7-2c0 0-2.1-1-2.4.2l-1.6 1s-.5-1-1.3-1.2c-1-.3-.2 1.3-.2 1.3s-.3-1.2-1.5-1.8c-1.2-.5-.2 1-.2 1s-1.5-1.2-.8-2.2c0 0-1.4 1.4-.7 2.7l-1 .7s-.5-.5-.4-1c0-.3-1.7 1.3-1.7 1.3s-1-2.6 0-2.6c.1 0-1.8 0-2.1 2.2 0 0-1.3 0-2.5.4s1 1.3 1 1.3-2-.4-3 .2l.7.9s-.7-.7-2.4-.1c-1.7.5.4.8.4.8s-1.7-.4-2.6 0c-.9.4.3 1 .3 1s-3.2-1-3.7-.6c-.5.3 1 1.8 1 1.8s-2 .5-2.3 2l1.8.7s-.8.4-1.2 1.1c-.4.8 1.2.4 1.2.4s-2.2 1.6-2.2 2.8c0 0 1.6.5 2.7-.7 1.2-1.2.4-.8.4-.8l.1.8s2.3-1 2.3-1.6c0-.5-.4.8-.4.8l2.2-1.2z"
        }),
        /* @__PURE__ */ jsx108("path", {
          d: "m324.7 108-.5-2.2 5 .6.9-2s2.4 1 3.1 1.8c0 0 4.6-1.2 6-.7l-.6 2.1s4.2.3 5.6.8c1.2.5-.6 1.6-.6 1.6s4.8.6 6.8 1.8c2.2 1.3 2.2 2.4 1.1 2.7l2.6 4.2s-4.2.5-5 1.5c-.7 1.1-1.5-1-1.5-1l-.8 2.9s-2.6-1.4-3.7-2.4c0 0-1.3 1.6-.5 2.4l-4.8-3.1s-2-.3-2 1.5l-3-3.4-2.6.8s-.8-1-1.7-1.4c-1.1-.2-.3 1.4-.3 1.4l-1.6-1.9-1.6-1.8s-1.3 1.8-2.4 1.8c-1 0-1-1.2-.8-2.1.3-.8-3.1-1-3.4 0 0 0-1-4 2.6-5l3.7-1zm-19 13.3-1.6 1.6-1-.5-1.9 2.1-.4-1.1-1 1.7-1.7-.6-.8 1.3-1.5-.3s-1.2 1.2-2 1.5c-.8.2 0-1.8 0-1.8s-1.2 2-2 2c-.9 0-.6-1-.6-1s-.5 1.4-1.4 1.6c-.9 0-.5-1-.5-1l-1.6 1.2v-1l-.7-.3s.4-1.8 1.1-2.2c.7-.4-.7-1.5-.7-1.5l.7-.8s-2-.5-2-.1c0 0 1-2.6 2.4-3.1l.1-3s1.4-1.1 2.6-1.2c1.4-.2-.4-2.3-.4-2.3l3.2-1.8.4-2.3 4.7.4 1-2 3.8 1 3.3-1.7 2.3 2.7 3.5.3v3.1s4.1 1.3 4.6 1.7c0 0-.8 2.5-.8 3 0 0 3-.8 3.8-.6l.4 3.4s5 1.6 5.3 2.5c0 0-1 .7-1.7 1.6 0 0 .6 3 .6 4l-.4.5s-1.4-1.3-2.6-1.5l-1 2.1-1.7-1.1h-1.1s-.9-1-1.6-1v-1l-1.4.9s-2.2-1.1-2.2-1.8l.1-1.5-2.2 1.5s-.5-1.1-.4-1.6c0-.5-.9 1.1-.9 1.1s-1.2-2-1-2.4l-.4 1.7s-2.3-.8-2.6-2.4z"
        }),
        /* @__PURE__ */ jsx108("path", {
          d: "M274.5 130.9s4.1 2 4.1 3c0 0 1.1-2.1.5-3l1.6 1.1s.5-1.9-.1-2.5c-.5-.5 3.5-2.1 4.4.5 0 0 2.4-2.5-2.3-4.7 0 0-.4-1.6 2.5-1.2 0 0-.2-1-.9-1.3h2.7s-1.6-1.4-4-1.8c-2.4-.4-1-.7-1-1.2-.2-.5 0-2.2 0-2.2s-1.4-.5-2.5 0l.4-.4s-2.5-.7-3.5-.1c0 0-1.5-.6-1.3-2.1 0 0-1.5-.1-2.1 1.4 0 0-1.4 1.6-3.3 1.6-.3 0-1.7-.8-1.7-.8l-1.2 2.7H265l.5 1s-2.8-.8-3.7 0c0 0 1.1 1.7.8 2.8 0 0-2.2.4-2.7.8-.6.4.8.7.8.7s-2.6.8-3.2 1.6l1 .7-1.2 1.6 1 .2-2.5.8c-.9.3 1.5.5 1.5.5l-1.1 1 1.8.3s-1.4 4-1.5 5.8c0 0 2.2-2.7 2.8-3l-1.8 3s3.4-1 3.7-1.6l.5-1 .1 1.6s1.3-1.7 1.5-2.4c.1-.7 2 .7 2 .7v-1l2.4.7c.7 0 .8-.3.8-.3l1.6-.2-.3 1.4s1.2-.8 1.5-1.6c.2-.8.8 0 .8 0l.8-3.1zm-13.4 13.8 1.6 3.3c-1.3 0-3.1 1.5-3.1 1.5.3 5.4-1 5.1-1 5.1.3 1-.3 2.8-.3 2.8l7.7-4.6.1-.5 9.2-4.3.3.5 2.6-1.5 1.9 4.9-1.9 1c.1 1.7 2.1 4.6 2.1 4.6l2.4-.6 2.7-1v1c0-.3 2.9-1.3 2.9-1.3l1.3 1.3c1-.1 2.7-2.5 2.7-2.5l2 .8s.7-1.2.7-2 2.6-.8 2.6-.8l1.7 1.2 2.3-1.8s.7 1.3 1.6 1.5c1 .1 3.4 2 3.4 1.6 0-.4 1-2.5 1-2.5l4.1 1.6c-.5-1.8-2-4-2-4s2-1.6 1.7-2c-.4-.4-1.6 0-1.6 0l1.2-2.4h-1.6l.5-.6-2.5-1 1.3-2.8c-.6-.7-7.3-2-7.3-2l1.6-1.5s-.8-1.2-1.6-1.2-4.9.1-5-.3l-1.8-1.8-2.6 1.9-1.3-.4-2.2.8s0 1.3-.3.4c-.3-.8-2.3-2.8-2.3-2.8-.4.7-3 3.8-3 3.8s-.5 1.7-1.3.5c-1-1.2-3-2.4-3.4-1.5-.2 1.1-2.1 2-2.5 1.8-.4-.3-2.5-.1-2.7.5-.1.7-2.5 2.4-2.5 2.4-1.4-.7-3.8-.3-3.8-.3s-.7 1.1-.8 2zm44.2 39.6v-2l2.3 1.5 1.4-1.5 1.8 1.7 1-1.7v2.8l2.7-2.3 1.5.6v-2.2s1.9-3.1 1.1-3.7l1.6-.5s-2.7-2.6-3.4-3.1c-.8-.6-1.9-.6-1.9-.6s-2-2-3.4-2.7c-1.3-.5-2 .6-2 .6s-.8-1.5-2.2-1.8c-1.3-.3-1.3 1-1.3 1s-1-1-2.2-1.4c-1.3-.6-.4 1.2-.4 1.2l-4.5-1.4.6 1.4-4.2-1.1.5 1.5-3-.5-.2 1.3-4.2.8.8 1.4-2.6-1.1v1.9l-3 1 1.1 1-4.7 2.4c-.7.5 1.6 1.6 1.6 1.6l-4.2-.6 1.6 1.4-3.7 3.4 2.6 1.9-1.6 2.3 4 .8 1.5 2.6 3.2-.6v3l4.7-3.7s3.4 3 3.7 2.1c.2-.8.2-3.4.2-3.4h1.7V187l1.2 1 2.2-3.1 2.8 3.9 2.2-5zm19.1-11.8-.4-4.5-1.4 1.4.6-4.2-2.2-.4.8-4.1-1.6-.8.4-2 1.6-1.1 2.8-2.8 6.6.1.7-2.1 4.7.8c.8.8 3.3-1.8 3.3-1.8h1l1 2s3.4-.4 5 .6l-1.9 2.6 3.5.3 2.3.5 2.4-.8 3.2-.2.7 1.3h3l-1 1.1 3.8 1.8-.8.8s2.2.8 3.7.8h.8s.8 1.8-.3 2.6c0 0 1.1 2.6 3.4 3.1 2.4.5 2.4.5 2.7 1 .3.6 0 3.2-2.7 3.2v2.7s-2 1.8-2.3 2.6l-1.6-1s-1.3 1.5-1.3 2.5c0 0-3.5-4.5-4.7-4.7-1.4-.2-1 2.6-1 2.6l-3.8-3.1-.5 2.1-3.1-2.6-1.9 1.3-3.3-3.5-3.2.4 1.2-1.6h-3.9l-.7-3.4-.6 2.8-2.4-1.6-3 3.3s-.4-.4-.9-2c-.5-1.5-1.8 2-1.8 2l-1.1-2.5-1.3 2.4s-1-1.8-2.1-2.4c-1-.5-2 3-2.4 4.5zm.6 10.3.2-1.6 5.6-2.2 4.7-1.7 2.3-1.1 1.1 1.9 1.4-2.7 2.1 2.8 1.2-1.5 1.8 1.4h1.6l.3 2s3.9.3 4.2-.5c.3-.8.8 2.7.8 2.7l3.7.5.8 4.2s1.8 3.9 1.2 5.4c-.5 1.7-2-2-2-2s-.3 2.9-.6 3.7c-.2.8-5-.8-5-.8l-2 3.9s-2.2-3.1-3.2-3.1-1 3.1-1 3.1l-4.5-5.3c-1.3-1.5-1.6 1.6-1.6 1.6s-2-3.4-2-4.4c0-1-1.9-2.2-1.9-2.2s-3.2 3.7-5.6 4.7c0 0 .3-2.3-.5-3-.7-.9-3 1.5-3 1.5s-1.7-3.6 0-7.4z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs83("g", {
      fill: "none",
      stroke: "#004b00",
      strokeWidth: 0.5,
      children: [
        /* @__PURE__ */ jsx108("path", {
          d: "m350.8 124.5.5 2s1.8-.4 3-.3l-.7 2.2s2.3-.4 3.4.3l-.5 1.2 2.7 1.2-2.5 2s4 1.5 4.9 2.7c0 0-2.7 1.8-3 1.7-.5-.2-.2.8.5 1.7l-2.2-.1s.9 2 .8 2.8c-.2.8-3.8.6-3.8.6m14.1-5.3s.7-3.9-.4-4.9c0 0 2.5 2.2 4.2 2.3 1.8 0 0-3.2 0-3.2s2.3 1.2 3.5 1.5c1.2.2-.9-2.4-.9-2.4s.7-1.3 2.7-.1m-45.4-15.5s0-1-.3-1.4c-2.4-3.2 2.4 2.4 3.4 2.6m4.5 0s1.6 1.2 2.3 1.2c.8 0-.5-3.1-.9-3.5-.3-.4 2.9 1.3 4 1.4 1.2.3 1.4-2 1.4-2s3.6.7 4.4 1.2m-25-.7-.5-3m-24.2 12.7c-.2-.3 1-2 .5-2.9 0 0 .7.6 1.4.7.6.1.4-2.2.4-2.2l.7.3s2-1 1.7-1.8c-.4-.8 1.4 1.2 1.4 1.2s1.1-1.2 1.1-1.7 1.4 1.2 1.4 1.2 1.5-.3 1.5-1.2c0-.9 1.8.3 1.8.3s.8-1 .7-1.8m-19.7 9.8s.9-2-.1-3.4m-23.6 9.8c0-1 .5-3.6 0-4-.4-.4 1 .4 2.2.7m9.3-.4c-1.2-1.1-1.9-1.7-3.7-1.7m-16.2 8.3c.3-.7.8-2.4.5-3.3m25 51.7 1.3-2.6 1.6 3.7 1-2.3.4.7 2.4-2.5 2.5 3.8m40.7-16.5 1.7-3.3 2.3 1.2 1-3.3 2.4 1.5 1.3-3 2.7.7.2-2.2s1.8 1 2.3 1.9c.6.7 0-2.7 0-2.7l2.2 1s1.5-1.6-.6-2.4"
        }),
        /* @__PURE__ */ jsx108("path", {
          d: "m343.6 163.1 2.3 3.4 2-2.2 1.7 3.8 2.3-1.4 3.2 1.9 1.5-1.2 3.5 2.5 1.4-3 3.2 1 2-3.5m-84.4-9.2s1.4-2.3 1-3.4c-.7-1 2.8 1.8 2.8 1.8s.7-2.3.3-3.4c-.6-1 3.9 3.2 3.9 3.2s.7-3.7 0-4.4c-.8-.8 4.3 1 4.3 1s2-.6 1.2-1.6c-.8-1.1 3.4 1.5 3.4 1.5s1-2.6 0-3.6 3.2 1.3 3.2 1.3l-1.6-2.8 3.4.2-.3-3.2m30.3 45.1 2.2-1 2 2 2.2-3.5 2.6 2.5.4-2.5 2.8 1.2.6-1.6 3.1 1.7.3-2.4 1.6.5.3-1.5"
        })
      ]
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#9dd7ff",
      d: "M283.1 298.1a69.8 69.8 0 0 1-6-13l42.4-37.2 42.3 37.1a64.7 64.7 0 0 1-6.2 13.3l-.3.5-3.2-1.2s-1.4 1.3-2.5 1.4c-1.4.2-2.7-1.3-2.7-1.3s-1.8 1.6-3.7 1.3c-1.9-.2-2.6-1.4-2.6-1.4s-2 1.6-3.4 1.3c-1.2-.3-2.1-1.2-2.1-1.2s-1.2 1.5-2.8 1.2c-1.6-.3-3-1.2-3-1.2s-2.5 1-4 1.3c-1.6.3-3-1.4-3-1.4s-2 1.4-2.8 1.4c-.8 0-3.7-1.4-3.7-1.4s-3 1-4.1 1c-1 0-4-1.3-4-1.3s-2.9.8-4.1.8c-1.4 0-3.4-.8-3.4-.8s-2.3 1.1-3.6.8c-1.4-.3-2.4-.8-2.4-.8s-2.6 1.1-4.2.8c-1.6-.3-3.4-1.4-3.4-1.4s-.3.8-3.4 1.4"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 0.7,
      d: "M319.5 205.1V248l-42.3 37.4a84.2 84.2 0 0 1-4.4-27.1V205h46.7"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#ffd83c",
      stroke: "#000",
      strokeWidth: 0.7,
      d: "M319.5 205.1V248l42.2 37.4a84.2 84.2 0 0 0 4.3-27.1V205h-46.5"
    }),
    /* @__PURE__ */ jsxs83("g", {
      stroke: "#000",
      strokeWidth: 0.5,
      children: [
        /* @__PURE__ */ jsx108("path", {
          fill: "#730000",
          d: "M292.2 289.2c3.2 1.7 2 1.2 8.7 3.5a61.8 61.8 0 0 0 20.7 2.8c8 0 12.4-.7 15-1.4 2.5-.7 3.1-1.8 3.1-1.8l-6.5 6.7s-26.3 1.4-31-1.7c-2-1-6-4.2-10-8z"
        }),
        /* @__PURE__ */ jsx108("path", {
          fill: "none",
          d: "M330.8 276.8s8.4 4.8 0 14m-37.8-1 12-11.6-1.3 15.4m6.3 1.4v-25.8m20.8 25.8v-27.4m-10.5 27.9V266"
        }),
        /* @__PURE__ */ jsx108("path", {
          fill: "#ff0018",
          d: "m310 270.6-5.4 1.7 5.4.6v-2.3m10.3-4-5.8 2.1 5.8.2v-2.4m10.5 1.6-5.8 2.2 5.8.3V268zm3.4 12.4c-.3-1.1 3.4-1 3.4-1s1 3.9 0 6.3l-3.1-.6s.3-2.6-.3-4.7z"
        }),
        /* @__PURE__ */ jsxs83("g", {
          fill: "#fff",
          children: [
            /* @__PURE__ */ jsx108("path", {
              d: "m294.8 288.1 10.3-10-.5 6s-5.3 3.5-5.3 5.9l-4.5-1.9m5.5 2.1s1-3.1 4-4.7l-.3 6.3zm14.7-17.3s4.2-.6 7.4 0c0 0-.5 4.2 0 5 0 0-5.8-1.4-8.1.8 0 0-.8-4 .7-5.8zm-8.9 1s4.2-.5 7.4 0c0 0-.8 4.8-.3 5.5 0 0-4.7-2.6-7-.4 0 0-1.6-3.3 0-5z"
            }),
            /* @__PURE__ */ jsx108("path", {
              d: "M305.9 279.4s4.2-.4 7.3 0c0 0-.5 4.3 0 5 0 0-5.5-1.2-7.8.8 0 0-1.1-3.9.5-5.8zm8.4-.7s6-.8 9.1-.3c0 0-1.2 3.4.3 5.7 0 0-6.5-1.7-9 .3 0 0-2-3.9-.4-5.7zm-9 6.5 8.2.6s-.8 6-.3 6.7c0 0-6.6-1.5-7.8.6 0 0-2.2-5.4 0-7.9zm9.2 0s7-.5 10.3 0c0 0-1.9 4.5.2 8.4 0 0-9.2-2.6-10.5-.5 0 0-2.1-5.4 0-7.9zm10.8-12.3s4.2-.6 7.3 0c0 0-.5 4.2 0 5 0 0-5.8-1.4-8 .8 0 0-.9-4 .7-5.8zm0 5.8s4.2-.5 7.3 0c0 0-.5 4.2 0 5 0 0-5.8-1.3-8 .7 0 0-.9-3.9.7-5.7zm.5 6s4.2-.6 7.4 0c0 0-1 6.6-.6 7.4 0 0-4.8-2.3-7-.3 0 0-1.4-5.2.2-7z"
            }),
            /* @__PURE__ */ jsx108("path", {
              d: "M334.5 285.2s1.3 5 3 5.6l-2.2 2.8s-2.9-2-3.2-4.4c0 0 1.9-2.1 2.4-4z"
            })
          ]
        })
      ]
    }),
    /* @__PURE__ */ jsxs83("g", {
      stroke: "#000",
      strokeWidth: 0.6,
      children: [
        /* @__PURE__ */ jsx108("path", {
          fill: "#006ac8",
          stroke: "none",
          d: "M355.4 298.7a66.2 66.2 0 0 1-36 28.3 67.3 67.3 0 0 1-36.3-28.8h.1c3-.7 3.4-1.5 3.4-1.5s1.8 1.1 3.4 1.4c1.6.3 4.2-.8 4.2-.8s1 .5 2.4.8c1.3.3 3.6-.8 3.6-.8s2 .8 3.3.8c1.3 0 4.1-.8 4.1-.8s3 1.3 4 1.3c1.1 0 4.2-1 4.2-1s2.9 1.4 3.7 1.4c.7 0 2.8-1.4 2.8-1.4s1.4 1.7 3 1.4c1.5-.2 4-1.3 4-1.3s1.4.9 3 1.2c1.6.3 2.8-1.2 2.8-1.2s.9.9 2.1 1.2c1.4.3 3.3-1.3 3.3-1.3s.8 1.2 2.7 1.4c1.8.3 3.7-1.3 3.7-1.3s1.3 1.5 2.7 1.3c1.1-.1 2.5-1.4 2.5-1.4l3.3 1"
        }),
        /* @__PURE__ */ jsx108("path", {
          fill: "none",
          strokeWidth: 0.5,
          d: "M353.7 301.2c-1.4.1-1.6-.8-1.6-.8s-2 1.6-3.8 1.3c-2-.3-2.9-1.5-2.9-1.5s-2 1.6-3.4 1.3a5 5 0 0 1-2.3-1.1s-1.3 1.4-3 1.1c-1.6-.2-3-1.1-3-1.1s-2.7 1-4.4 1.3c-1.6.3-3-1.5-3-1.5s-3.8 1.2-4.6 1.2c-.9 0-3.6-1.2-3.6-1.2s-1.9 1.1-3 1.1-4.2-1.3-4.2-1.3-3 .8-4.3.8c-1.4 0-3.5-.8-3.5-.8s-2.5 1-3.9.8l-2.4-.8s-2.7 1-4.4.8c-1.6-.4-3.6-1.4-3.6-1.4s-.3.7-3.5 1.4h-.1"
        }),
        /* @__PURE__ */ jsx108("path", {
          fill: "#5ac800",
          d: "M293.1 305.2s-.3.7-2.8 1.2l-.7.2.6-.2-.7.3a44 44 0 0 0 11.7 11c4.5 3 9.6 6.6 18.4 9.2a71 71 0 0 0 17.8-9c6-4.5 9.2-7.2 12.6-11.7-2.7 1.5-2.3 1.5-3.7 1.3-1.3-.3-2.3-1.3-2.3-1.3s-1.3 1.5-3 1.3c-1.6-.3-3-1.3-3-1.3s-2.2 1.5-4.4 1.4c-1.6-.1-3-1.6-3-1.6s-3.8 1.3-4.6 1.3c-.9 0-3.6-1.3-3.6-1.3s-1.9 1.2-3 1.2-4.2-1.4-4.2-1.4-3 .8-4.3.8-3.4-.8-3.4-.8-2.5 1-4 .8c-1.3-.3-2.4-.8-2.4-.8s-2.7 1-4.4.8c-1.6-.3-3.6-1.4-3.6-1.4z"
        }),
        /* @__PURE__ */ jsx108("path", {
          fill: "#ffd800",
          d: "M319.6 326.9a89 89 0 0 0 17.1-8.6c-1 0-4-1-2.9-1.2 0 0-1.2 1-2.3 1-1.1 0-4.2-1.3-4.2-1.3s-3 .7-4.3.7c-1.4 0-3.4-.7-3.4-.7s-2.6 1-4 .7l-2.4-.7s-2.8 1-4.4.7c-1.6-.3-3.6-1.3-3.6-1.3s-2.4 1.3-4 1.4a55 55 0 0 0 18.4 9.3z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs83("g", {
      stroke: "#000",
      strokeWidth: 0.5,
      children: [
        /* @__PURE__ */ jsx108("path", {
          fill: "#b34b00",
          d: "M313.2 249c1.9-1.6 3-3 2.3-4.2-.7-1-1.8.6-3 .2 0 0-2-1.1-2.5-2-1-1.2-2.5-2.3-3.3-3.4-.9-1-4.2-5.3-9.1-10.3-1.5-.9-1.1-4.4-2.2-5.5 0-.8-10-10.6-13.4-14-1.5-1.1-2.2-1.8-4.7.5-2 1.7-2.7 3.6-.1 5.8l12.8 11.7c1.9 1.8 4.5 2.1 5.6 3l13 13.4c1.7 1.4 2.5 2.4 1.5 3.6-1 2 .1 2.3.3 2.3.2.1 1.1.1 1.7-.4z"
        }),
        /* @__PURE__ */ jsx108("path", {
          fill: "none",
          d: "m280.7 214 13.4 13.2"
        }),
        /* @__PURE__ */ jsx108("path", {
          fill: "#fff",
          strokeWidth: 0.6,
          d: "m298.8 220 1.1-2.5c.2-.4 3.8-6.2 5.6-6.3l11.3 8.2c0 .5-5 7.8-5.3 7.2 0 0-13.2-5.5-12.7-6.6z"
        }),
        /* @__PURE__ */ jsx108("path", {
          fill: "#ccb8c8",
          stroke: "none",
          d: "M306 222c-1.6-1.2-4.1-2.4-6.2-3.8l-.9 2c.7.8 10 5.1 11.6 6 0 0-1.8-2-4.6-4.2z"
        }),
        /* @__PURE__ */ jsx108("path", {
          fill: "none",
          strokeWidth: 0.4,
          d: "M299.8 218a73 73 0 0 0 5 3.1c2.7 2 4.4 4 6.4 5.2"
        }),
        /* @__PURE__ */ jsx108("path", {
          fill: "#782121",
          d: "m277.1 253 25.5-31.7c.5-.4 2.9-.4 3.2 2l-24.2 33s-2.7-.3-4.5-3.4z"
        }),
        /* @__PURE__ */ jsx108("path", {
          fill: "#730000",
          d: "M362.7 253.3c-1 .7-2.4.8-2.4.8-1.7-1.9-3-4-5.4-6.5l-25.5-31.3 2.7-2.6 23 26.9c.6.7 4.6 4.9 8.4 9.8 0 0 .3 2-.8 2.9z"
        }),
        /* @__PURE__ */ jsx108("path", {
          fill: "#fff",
          d: "m338.1 220.3-4-5s-3.2.5-3.8 2.1c0 0-2.2 3.7-8.2 4.1 0 0 1.7 7 8.6 10.7 0 0 2.5-7.2 5-8.4 0 0 2.5-1.9 2.4-3.6z"
        }),
        /* @__PURE__ */ jsx108("path", {
          fill: "#730000",
          d: "M327.9 242c-.6-.3-1.2 0-2 .4-.9.5-1.8.3-1.7-.7 0-.8 0-.7 1-1.4a6.3 6.3 0 0 1 5-.5l-2.3 2.1m27.8-27.7c-.2-.7-.4-1.4.3-2.2.7-.8.7-2.2-1-1.5-1.7.7-2.2 2.5-.9 5.4z"
        }),
        /* @__PURE__ */ jsx108("path", {
          fill: "#fff",
          d: "m327.3 242.5 28.9-28.7 7.1 7.6s-1.5-.6-2-.2c-.5.4.5 1.9.5 1.9s-1.3-.5-1.9-.1c-.7.4 0 2 0 2s-1.2-.8-1.8-.5c-.5.4 0 2.3 0 2.3s-1.5-.5-2-.1c-.3.4 0 2 0 2s-1.5-.7-2.3 0 .4 1.9.4 1.9-2-.8-2.7.4c-.8 1.2.1 2.2.1 2.2s-1.6-.7-2-.4c-.4.4 0 2.3 0 2.3s-1.3-.8-2.2.2c-.9 1 .1 2 .1 2s-1.3-.8-2-.4c-.6.4.2 2.2.2 2.2s-1.2-.9-2.1 0c-.9 1 0 2 0 2s-1-1-2.2 0c-1 1 0 2.1 0 2.1s-1.5-.8-2.1 0c-.7.8.2 1.9.2 1.9s-1.2-.7-2-.3c-.7.4 0 2.1 0 2.1s-1.1-1.3-1.6-.6c-.6.7 0 2.4 0 2.4s-1-1.3-1.6-.6c-.7.6.4 2 .4 2s-2-.8-1.5-.8z"
        }),
        /* @__PURE__ */ jsx108("path", {
          fill: "#7e4b7e",
          stroke: "none",
          d: "m354.5 216.2-2.2 2.2.5 7.7s.5-2.2 1.1-.7c0 0 .2-1.8.7-1.5-.4-.2 0-7.8 0-7.8m-4.3 4.3-1.6 1.5.6 7.7s.4-2.9 1.1-.6v-8.6m-17.6 17.2-1.5 1.7.4 4.7s.5-3 1.1-.7l-.2-2.6z"
        }),
        /* @__PURE__ */ jsxs83("g", {
          fill: "none",
          stroke: "#7e4b7e",
          strokeWidth: 0.9,
          children: [
            /* @__PURE__ */ jsx108("path", {
              d: "M330.9 218.3c1 1 4 5 4 5m-2.6-2.9c-.2.6-.6 2.3-1.5 3.2m2-2.8c-.2.4-.2 1.7-1.5 3m2-2.4c-.3.7-.4 1.2-.8 1.7m1-1c0 .4-.3.5-.4.8m-3.2-2.7a29 29 0 0 1-4.8 2.8m4-1.8a14 14 0 0 1-3.1 2.2m2.8-1c-.5.4-1.5 1.4-2.3 1.7m1.8-.5c-.4.5-1 .8-1.5 1.1"
            }),
            /* @__PURE__ */ jsx108("path", {
              strokeLinecap: "square",
              d: "M311.3 224.7c.3-.6.9-1.8 1.6-2.8 1-1.4 1.3-1.6 1.8-2"
            })
          ]
        })
      ]
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#289400",
      stroke: "#060",
      strokeWidth: 0.5,
      d: "M217 303.4c1.5.7 0-4.8.5-6.8.6-2.2 4.8 5.2 6.8 6.2 2.2 1 15.3-5.2 15.3-5.2l3.1-5.8 1.7 4.8s3.6-4.2 4.6-5.8c1.1-1.6 0 3.1-1 4.7-1.1 1.5 3.1 2.1 2.6 5.3-.5 3 4.2-2.2 4.2-2.2l12.1 1s2-7.3 5.3-11.5l1 4.8 5-5.1a65.9 65.9 0 0 0 41.3 39.2 66.6 66.6 0 0 0 40.2-36.6l6.7 7s5.3-1.6 6.3-2.2a70.3 70.3 0 0 1 15.5 5.6c1 .7.3-3.5.3-3.5s5.8 1.1 5.3 4.2c0 0 1.2-2.9 2.3-3.4 1.1-.5 3.6 2.7 4.2 3.7.5 1 13 2.6 14.7 3.6 0 0 1.3 1.6 1.3 2.7 0 0 2.7-.3 4.7-.3 0 0-1.5.8-1.5 2.4 0 1.6-.8 2.9-2.4 3.6-1.5.8 0 1.4 2 1.6 2.2.3 0 3-4.1 4.5 0 0-1 2.3.8 3.1 0 0-3.7.3-4.2-.8 0 0-1.3 2.5-1.3 3.8 0 0-4-1.3-5-1.9 0 0-1.6 1.6-.5 2.3 0 0-7.1-.7-8.5-3.4 0 0-2.5.8-2 1.7 0 0-5-3.4-6.6-3.4l-1 1.7s-3.5-2-4.5-2-.2 1.5-.2 1.5l-4.8-2.9-1.9 3-5-2.7c-1-.8-1.2 1.6-2 1.9 0 0-1.6-2.2-3.7-1.9 0 0-.8 2.6-.5 3.4l-7.1-1.5c-1.1-.3-.5 1.2 0 2.3 0 0-4.5-1.3-5.5-2l-.3 2s-3.7-.3-4.5-1l-2.3 3.1h-3.5l-.7 2.9s-6.6-1.9-7.2-.8c-.5 1 .3 2.6.3 2.6l-5.7-.7-.5 2.3s-6.7-2-8.2-1c0 0-2 2-3.4 2.6-1.3.5 0-.8 0-.8l-2-2.9s-2.4 1.3-3.8.8c-1.3-.6-5.5 2-6.8 1.3 0 0 0-1.9-1.1-2.4-1-.4-2.8-.4-3.6.8l-2.2-3c-1.2-2.2-3.1.1-3.1.1l-.3-2.5-3.6-.3c-2.2-.3-2.6-2.2-2.6-2.2s-5.6.6-6.4.3l1.4-1.3s-7.6 1.6-9.2 1c-1.7-.5 1.8-2.6 1.8-2.6l-8.4-2c-1.3-.4-9 1.2-10 1.2s-1.6-1.8-1.6-1.8-1.8 1.6-3.4 2.1c0 0-1.3-3.1-.5-3.4 0 0-5 1.3-5.3 2.6 0 0-1.2-2-1-3 0 0-2.4 3.8-3.5 4.6-1 .8-.2-1.9-.2-1.9s-2.9 3.7-4 4v-2.6s-8.4 4.5-10.7 3.9c0 0 0-1.9.8-2.4l-5.3-.2c-1.3-.2-2.8-.8-4.2-1.1-1.3-.2 1.9-1.6 4-1 0 0-5.8-2.1-7.6-1 0 0-.8-2.2 2.3-3 0 0-4-3.9-6.3-3.6 0 0 2.6-1.6 4.8-.8 0 0-2.5-6.6-4-7.4 0 0 5.5-1 7.1-.2z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#730000",
      stroke: "#000",
      strokeWidth: 0.5,
      d: "M208.9 188.8 280 152c.3-2-.7-3.4-1.9-5-20.3 10-38.8 22.2-61.4 29.5-1.3.5-12.5 5.2-18.3 12.1a7.7 7.7 0 0 0-2 4.5s.2 3.1.9 4c0 0 .1.8 1.2 1.5 0 0 .7.3 1.1.2.5 0 1.4 0 2.6-2a52.4 52.4 0 0 1 6.7-8z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 0.5,
      d: "m266.1 152.4 9.2-4.4s3.1 2.3 2.8 5c0 0 .7 6 8.2 10.2 0 0-6.3 8-17.4 8.6 0 0 1.2-10.4-1.1-13.5 0 0-.4.4-.2-.1.3-1-.2-4.5-1.7-5.3z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#7e4b7e",
      strokeWidth: 0.8,
      d: "M276.9 153.6c-2 .8-8.3 4.1-8.3 4.1m5.2-2.1c0 1-.6 3.3 0 5m-.8-4.7c0 .5-.8 2.2 0 4.6m-1-4.1c-.2 1-.4 1.5 0 2.6m-.8-2c-.2.5 0 .8 0 1.2m5.8-1.5c.3.7 2.9 4.8 4.5 6.5m-4.1-4.7c.3.8 1.7 3.6 2.8 4.7m-3-3c.4 1 1.1 2.7 2 3.7m-2-1.8a8 8 0 0 0 1.1 2.5"
    }),
    /* @__PURE__ */ jsxs83("g", {
      stroke: "#000",
      strokeWidth: 0.5,
      children: [
        /* @__PURE__ */ jsx108("path", {
          fill: "#b34b00",
          d: "m342.3 148.3 26.1 12.8c5.2 2.5 7.1.2 10 1.5l51.6 26.2c4.5 2 7 2.5 6.3 4.8-.1 3.7 1.7 3.7 2.2 3.8.4 0 2.1-.2 2.8-1.2l.6-.6c.6-.6.5-.7.7-1 2.1-3 3.3-5.8 1-7.5-2.5-1.3-2.8 1.5-5.6 1.2 0 0-4.8-1.8-6.6-3.1-3.2-1.8-7.8-3.9-8.8-5-3.3-.6-28-14.6-42.1-21.6-1.5-1.2-2.3-5.9-5.3-7.4-.8-1.3-19.8-10-29.8-15-3.6-1.3-5.7-2.2-8.3 2.3-2.3 4.4-1.8 6.8 5.2 9.8z"
        }),
        /* @__PURE__ */ jsx108("path", {
          fill: "none",
          d: "m344.5 142.8 29.2 14.6"
        })
      ]
    }),
    /* @__PURE__ */ jsxs83("g", {
      fill: "#ffa54b",
      stroke: "#000",
      strokeWidth: 0.5,
      transform: "translate(-40) scale(.96)",
      children: [
        /* @__PURE__ */ jsx108("path", {
          fill: "url(#bz_svg__c)",
          d: "M309.7 165.1c-.2.6-.7.2-.7.4-.4 2.2-.3 3.3-.8 4.5a7.1 7.1 0 0 1-3.1 2.6c-2 .7-4.5 3.1-8.5.9l-.6-.5s1.1 4.1-3 6.2l-15.7 8.2s-1.5 2.8-.5 6.5c0 .6.3 1.1-.3 1.5-1 .7-2.7 2.8-3.7 6 0 0-3-1.3-3-3.2 0-2 1.2-3 1.5-4.4.3-1.3 1-4.7.7-5.7-.4-1.1-2.3-1.5-3-2-.6-.3-1.4.5-1.3 1.4.1 1 .8.8 1.6 1 0 0-.9 2-.8 3.4l-9.2 4.8 1.6 2.3c.4.7 1.3 10.2 4 14.7s3.7 3.2 4.3 3.8l2 2c.8.5 4 .8 4.5-1a9 9 0 0 1 3.2-4.1c2-1.6 6-5.4 6-7.2 0 0 2.3 6.8 2 12.4 0 0 8.5 1.7 16.1 1.9 7.6 0 11.5-1.5 11.5-1.5s1-6.4.6-7.7c0 0 1.2 4.2 2.2 5.6 1 1.8 2.1 5.3 4.3 5.5 2.2.1 4-2.1 4.2-3v-6.8h8.7s3.8 1.5 5 1.3c1.3-.1 2-1.3.8-1.7l-.4-.3c1.2 0 2.6.7 2.6.7h4.3l-.1-.5c-.3-1.2-2.6-2.2-4.2-3-1.6-.5-3.5-1.2-4.7-1.3a20 20 0 0 0-6.2.4c-.8 0-3.9.4-5.8 1.3-.5.3-1 .4-.8-1 .3-1.3.2-7.8-1.3-10.5-1.2-2-1-3.6-.9-5.2a87 87 0 0 0 0-8.8c-.3-1.7-2.5-4-6.6-4.4-3.8-.5-7-3.7-7.3-6.2-.3-2.6.4-7.2.8-9.3"
        }),
        /* @__PURE__ */ jsxs83("g", {
          fill: "none",
          children: [
            /* @__PURE__ */ jsx108("path", {
              fill: "url(#bz_svg__d)",
              d: "M292.4 153.6c-.7 3.3-.7 6.1-.6 9.3.1 2.1 1.1 4.6 2 6.7a10 10 0 0 0 2.8 3.9c3.6 2.3 7-.2 8.9-1a6.4 6.4 0 0 0 2.7-2.5c.5-1.2.3-2.1.8-4.5l.7-.4c1-1.5.7-2 1.2-3 .6-1-.5-2.2-1.8-2 .6-1.9 1-4 .4-5.9-.2-.6.5-2.2-.6-1.8-4.6 1.8-10 1.4-14.8 1.4-.4 0-.8-.8-1.4-.7l-.3.5"
            }),
            /* @__PURE__ */ jsx108("path", {
              fill: "#000001",
              d: "M292 155.3c-.5-.4-.6-1.3 0-3.2.7-2 0-2 1.1-3.2s.9-1.6 1.6-1.9c.7-.2 2.8-.2 3.5-.5a11 11 0 0 1 9-.3c1.5.8 2.5 2.8 3.4 3.6 1 .7 1.7 3.6 1.5 7.9-.3 4.3-1.2 3.5-1.2 3.5s-1.2-2-2.2-.3c0 0 0-1.7.2-3 .1-1.1-.6-3.4.1-4.9 0 0-5.8 1.8-8.7 1.7-3-.2-7.4-.9-7.6-1.6l-.7 2.2"
            }),
            /* @__PURE__ */ jsx108("path", {
              fill: "#fff",
              stroke: "#fff",
              d: "M295 151.8c-.3-.6-1.8-2.9-.6-3.6 1-.6.4 2.8 2 3.5 0 0-.6 1.5-1.4.1z"
            }),
            /* @__PURE__ */ jsx108("path", {
              d: "m298.3 160.1-.9 3.2m10.6 1.6c.2.6.4.3 1 .4m.3-4c.5-.5 1.2-.2.8 1.3m-17.7-4.9 2.8 1c1.5.6.6 2.9.2 4.3-.2.7-1 2-.6 2.5.5.8 1.1.3 2 .4 0-.3.6-.5.8-.5.7 0 1.1.5 1.7.3.6-.3.5-1.2.3-1.7m-.1-4.5c0-.4 1-.8 1.5-.9 2.1-.4 3.6-.7 5.4.5m-5.7 11.1c-1.8.4-3.6.7-5.2-.2m0-.8c.8-.4 1.1-.8 2.1-.3a5 5 0 0 1 1.1-.4c.8 0 1.4.3 2.2.8m-5.5.3c1-.3 3.3-.3 5.4.1"
            }),
            /* @__PURE__ */ jsx108("path", {
              fill: "#fff",
              strokeWidth: 0.3,
              d: "M292.3 160.1c.7 0 1.6-.9 3.2.3 1.1.8-1.8 1.5-1.3 1.4-1.4.2-1.8-.5-1.9-1.2 0-.1-.2-.5 0-.5zm8.4.8c.7-1.4 1.8-1 2.8-.8 1 .3.7.1 1.7.7-1.2.1-.9.2-1.7.6-.9.5-1.7.7-2.3.3-.2-.2-.7-.5-.7-1 0 .2 0 .3.2.3z"
            }),
            /* @__PURE__ */ jsx108("path", {
              fill: "#000001",
              strokeWidth: 0.3,
              d: "M293.8 161.4c.4 0 .7-.4.7-.8 0-.6-.3-1-.7-1-.5 0-.9.4-.9 1 0 .4.4.8.9.8zm8.6.2c.4 0 .7-.4.7-1a.8.8 0 0 0-.8-.8c-.4 0-.7.3-.7.8 0 .6.4 1 .8 1z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs83("g", {
          id: "bz_svg__g",
          children: [
            /* @__PURE__ */ jsxs83("g", {
              fill: "none",
              children: [
                /* @__PURE__ */ jsx108("path", {
                  d: "M345.9 213.7a3.9 3.9 0 0 0-1.9-1.4l-2-1c-.7-.4-1.7-.5-2.4-.9m.5 2.6-.9-.5c-.3 0-.7 0-1-.2 0 0 0-.2-.2-.2a3.5 3.5 0 0 1-2.4-1.3m-62.8-9.3c1 .7 3.2 2.2 3.4 5.1a10.5 10.5 0 0 0 1 3M264 202c.5 1.7.6 7.4 6 13.4m-5-21.4c-.4 1.1-1 2.2.2 3m14.4 10.7c1.1-2.6 4.6-2.4 4.6-4.8"
                }),
                /* @__PURE__ */ jsx108("path", {
                  d: "M284.8 207.3c-.3-2.9-1-4.5-.4-8.7.2-1.2.4-5.9 0-8.1 0 0 1.6 7.8-3.7 9.3m34.4 12.5c0-4 1-6.2 1-6.2 1.2-5.6-1.2-7.7-.3-9.1.9-1.2 2-3.8.5-8.9 0 0 2.8 10.5-4.5 10.5-7.5 0-7.2-2.7-7.2-2.7"
                }),
                /* @__PURE__ */ jsx108("path", {
                  d: "M284.4 190.5c0 2 0 8.4 9 8.4 2.8 0 5.8-2 7.4-3.3m2.2-2.7c-.3-2-.3-4.4-.3-7m-13.6-3.4c2.4-.3 4.4-.6 9-.6m.2-6.3c.5 2.2-.3 5.8 4 6.3m4.3-7.1c-.6 1.6-.6 3.3-.8 4.4m.2 2.7c1.7 0 5-1.1 9-.3m1.4 22.8c.9 1.6 1 3.8 3.6 6.2m-31.7-11.4c.2 1.3-1.8 5.7-.3 9.3a12.3 12.3 0 0 1-1.2 11m6.7-19c-.9 1.7-2.3 3.3-2.6 4.7m6.6-1.6c0 1-2.7 8.7-4.7 10.9 0 0 3.6 1.4 3 6.6m7.4-21c0 1.2-.2 1.6 1 2.4m2.4 0c1.3 1.6 5.5 6.5 4.6 9.2m-7.4-6.5c.3 1 .3 6.3-.6 9m-2.1-.2c-1.1 0-2.8.8-3 2.7m8.7-3c1.1-.3 3.3 1.6 3.3 7m15.7-10.2c-2.1.6-3 1.7-2.4 1.1-1.1 1-2.2 1.6-2.2 1.6"
                })
              ]
            }),
            /* @__PURE__ */ jsx108("path", {
              fill: "#000001",
              strokeWidth: 0.3,
              d: "M289.8 198c.6 0 1.1-.4 1.1-1 0-.3-.5-.7-1.1-.7-.5 0-1 .4-1 .8 0 .5.5.9 1 .9zm23 .3c.6 0 1.1-.4 1.1-1 0-.4-.5-.7-1-.7-.6 0-1.1.3-1.1.8s.5.9 1 .9z"
            }),
            /* @__PURE__ */ jsx108("path", {
              fill: "#fff",
              d: "M280.5 239.8c1.3-8 5-14.5 5.1-15.2 0 0 3.9.9 10.6 1.5 6.6.7 8.4.4 11.5.2l6.8-.8s1.2 2.4 1.3 4.8c.3 5.2 2.3 27.7 2.5 33.7 0 0 .8 3.6.8 12.3 0 9.6 2.6 29 2.6 39.4l-2.6.5s-14.5 1.1-14.5-.8c0-2.1-.8-27 1.4-42.1 0 0-.5-3-1.4-5.5-.8-2.5-4.3-10-4.3-11.7 0 0-5.7 16-6 18.8-.3 2.6-1.2 38.4-1.7 41.3 0 0-8.2 6.3-9.3 7-1.1.4-9-3.4-9.3-4.4a211 211 0 0 1 4.6-33.2c1.4-7.1.6-8.4.6-10.4s.1-27.5 1.3-35.4z"
            }),
            /* @__PURE__ */ jsx108("path", {
              fill: "none",
              d: "M294.3 275c-.6 2.2-1.7 4.3-3.6 5.7m-2.7-53.6c-.3 1.3-2.3 7.3-7.2 10.9m14.3-9.8c-1.1 3.6-5.5 22.7-6.3 45.4m-.3 7.1-1.7 20.8m-.8 3a71.3 71.3 0 0 0-2.7 18.7m32.2-36c-.2 2-1 15.7 3.6 28m-18.5-86c-.3 2.3-.8 16.7-.8 17.8 0 1.2 1.6 2.8 2.4 3 0 0-1.6.6-2 6m-4-12.8c-.3 1.7-2 8.5-3 11.3m13-25.5s5 1 5.3 0c0 0 1.6 29.5 3.8 46m-11.2-42.2-.6 16.5m2.5 2.1s1.9 2.8 1.4 4m-17.8-28 3 .8m5.2 1.6c-.3.9-.6 4.6-.6 4.6m8.8 38.9c.6.8 1.4 2 .8 4.4"
            }),
            /* @__PURE__ */ jsx108("path", {
              fill: "#9b5f00",
              d: "M285 224.4s0-3.2 1.1-4.8c0 0 3.5.7 8.4 1.2 5 .5 9 .9 12.6.5 3.7-.4 7.4-1.3 7.4-1.3s1 4.8.5 5.5c0 0-4 .8-8.3 1a86 86 0 0 1-14.5-.8 57 57 0 0 1-7.3-1.3z"
            }),
            /* @__PURE__ */ jsx108("path", {
              fill: "#fff",
              d: "m288 224.8.7-4.8h1l-.2 5.1-1.4-.2m22-4.1.1 5.5 1.3-.2-.1-5.6-1.3.3m-15.6 0-.4 5.3h.7l.7-5.3h-1"
            }),
            /* @__PURE__ */ jsx108("path", {
              d: "M276.8 320.8c-.3 1.3-.8 3.2-1 5.5 0 .5-.6 3.3 1 3.4 1 0 1.4-2.9 1.4-2.9s-1 3.3.3 3.7c1.8.4 2-3.6 2-3.6-.2 1.1-1.4 4 .3 4.3 1.9.3 2.4-3.9 2.4-3.9s-1.6 4.2.3 4.3c1.7 0 1.7-4 1.7-4s-.9 5 1.5 4.5c1.4-.2 1.7-2 2-3 .4-1.5 1.3-3.4.2-6.6-.8-2.3-.5-3-.5-3s-2.9 2.2-5.1 3.6c-1 .6-6.5-2.3-6.5-2.3zm29.7-4.4c-.5-.3-.4 1.9-.6 2.9-.1 1 .2 3.2 3.6 3 3.4-.3 6.7-1 8.9-.5 2.1.6 5.3.7 7 .7 1.7 0 2.8-.2 3.7-.5.7-.3 2.2.4 3 .4s1.7-1 1.6-1.8c0-1.3-1.3-1.3-3-1.4a22 22 0 0 1-5-1c-1.1-.3-3.1-1.5-5.7-2l-5.9.2c-1 0-7 .3-7.6 0z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs83("g", {
          fill: "none",
          children: [
            /* @__PURE__ */ jsx108("path", {
              fill: "#ffb366",
              d: "M255.7 189.8c-.5.3-1.1-2 .4-2.9 0 0 .4-2 2-2.1 0 0 1.4-1.9 3.3-1.7 0 0 2.2-1.5 3-1.3.9.1 3 2.1 3 2.9.2.7 0 1.9-.5 2.4-.6.6-1-.1-1.1-1 0 0 .4 1.6-.8 2.2-1.2.7-1.1.2-1.2-.6 0 0-.4 1.6-1.2 1.9-.8.3-1.3-.5-2-.5 0 0 1.1.9.4 1.5-.7.5-1.5.3-2-.1-.5-.5-1.2-1.9-3.3-.6z"
            }),
            /* @__PURE__ */ jsx108("path", {
              d: "M265.7 186c-.5-1.5-2.2-3-4-2.8m2.2 4.4c-.3-.4-.4-.8-.8-1.2-.9-1.5-2.8-1.4-4.4-1.8m2.4 4.5c-.6-.4-.8-1.2-1.4-1.5-1-.4-2-.9-3.3-.7"
            })
          ]
        })
      ]
    }),
    /* @__PURE__ */ jsxs83("g", {
      stroke: "#000",
      strokeWidth: 0.5,
      transform: "translate(-40) scale(.96)",
      children: [
        /* @__PURE__ */ jsx108("path", {
          fill: "url(#bz_svg__e)",
          d: "M439.1 165.1c.7-.3.5.6.6 1 .4 1.3.4 2.7.9 3.9.6 1.1.8 1.5 1.8 2 1.6 1 6.4 3.6 9.8 1.5a3.1 3.1 0 0 0 .7-.5s-1.3 4.1 3 6.2l15.6 8.2s1.5 2.7.6 6.5c-.2.6-.4 1.1.2 1.5 1 .7 2.6 2.8 3.8 6 0 0 3-1.3 3-3.2 0-2-1.3-3-1.6-4.4-.2-1.3-1-4.7-.6-5.7.4-1.1 2.1-1.5 2.8-2 .7-.3 1.6.5 1.3 1.4 0 1-.8.8-1.6 1 0 0 1 2 .8 3.4l9.4 4.8-1.6 2.3c-.5.7-1.5 10.2-4.2 14.6-2.8 4.5-3.7 3.3-4.2 4l-2.1 1.8c-.6.5-3.8.9-4.5-.9a9 9 0 0 0-3.1-4.1c-2-1.6-6-5.4-6-7.2 0 0-2.3 6.8-2 12.4 0 0-8.4 1.7-16.2 1.9-7.6 0-11.5-1.5-11.5-1.5s-1-6.4-.6-7.7c0 0-1.2 4.2-2 5.6-1.1 1.8-2.2 5.3-4.4 5.5-2.2.1-4-2.1-4.2-3v-6.8h-8.7s-3.8 1.5-5 1.3c-1.3-.1-1.9-1.3-.9-1.7l.4-.3a7 7 0 0 0-2.5.7H402l.1-.5c.3-1.2 2.6-2.2 4.3-3 1.6-.5 3.3-1.2 4.6-1.3 1.9-.2 3.2-.1 6.2.4.8 0 4 .4 5.8 1.3.5.3 1 .4.8-1-.3-1.3-1.2-5.5.3-8.3 1-1.9.9-3.5.8-5.2-.2-1.7-1.1-5.6-1.1-7.3 0-5.7 4.4-8 8.2-9.2 4.3-1.4 7.1-2.8 7-5.3-.2-2.7.5-7 .1-9"
        }),
        /* @__PURE__ */ jsxs83("g", {
          fill: "none",
          children: [
            /* @__PURE__ */ jsx108("path", {
              fill: "url(#bz_svg__f)",
              d: "M456.3 153.6a20 20 0 0 1 1.2 5.3c0 1.2-.5 1.4-.1 2.8.7 2.4-.8 5-2.5 8-.8 1.2-1.4 3-2.7 3.8-3.4 2.1-7.5-.4-9.6-1.3a3.7 3.7 0 0 1-2-2.2c-.4-1.2-.5-2.3-.8-4 0-.3 0-1.2-.6-.9-1.3-1.4-1-2-1.6-3-.5-1 1-2.2 2-2a10 10 0 0 1-.2-5.9c.2-.6-.6-2.2.5-1.8 4.5 1.8 10 1.4 14.8 1.4.4 0 .7-.8 1.3-.7l.3.5"
            }),
            /* @__PURE__ */ jsx108("path", {
              fill: "#000001",
              d: "M456.8 155.3c.4-.4.1-2.3-.4-4.3-.1-1-1-1.5-2-2.6s-1.6-1-2.3-1.4c-.6-.2-2-.2-2.8-.5-.6-.3-2.2-.1-3.7.1-2 .3-3.2.2-4.7 1s-2.8 1.8-3.3 3.3c-.4 1-1 2.5-.8 6.8.2 4.3 1 3.5 1 3.5s1.1-1.7 1.9-.6l-.3-3.6c-.1-1.2 0-2.8.5-4.6 0 0 4.6 1.7 9 1.7 3 0 7-.3 7.1-1l.7 2.2z"
            }),
            /* @__PURE__ */ jsx108("path", {
              d: "M450.4 160.1c.7 1.8.1 1.3.4 2.4m-10.2 2c0 .8-.6.6-1 .6"
            }),
            /* @__PURE__ */ jsx108("path", {
              d: "M456.9 158.8c-1-.7-2.7-.2-3.5.1-1.5.7-.7 2.3-.2 3.7.2.7 1 1.7.5 2.4-.4.8-.7.4-1.6.5 0-.3-.8 0-1.1 0-.6 0-1 .4-1.5.2-.6-.3-.5-1.2-.3-1.7m.1-4.5c0-.4-1.3-.8-2.7-.9-2.3 0-2.5.1-4.2 1.3m11.5 9c-.4-.6-1-1-2.1-.4 0-.2-1.6-.4-1.6-.4-.8 0-1.3.3-2.1.7m5.6.6c-1-.6-3.3-.2-5.6-.2m.2.8c1.7.5 3.5.8 5.2 0"
            }),
            /* @__PURE__ */ jsx108("path", {
              fill: "#fff",
              strokeWidth: 0.3,
              d: "M456.4 160.1c-.7 0-1-.9-3.1.3-1.1.7 1.8 1.5 1.4 1.4 1.2.2 1.6-.5 1.7-1.2 0-.1.2-.5 0-.5zm-8.3.8c0-.8-1.8-1-2.9-.8-1 .3-.5.1-1.5.7 1 .1.7.2 1.6.6.9.5 1 .9 2.3.3.3-.1.7-.5.8-1 0 .2-.2.3-.3.3z"
            }),
            /* @__PURE__ */ jsx108("path", {
              fill: "#000001",
              strokeWidth: 0.3,
              d: "M455.1 161.4a.8.8 0 0 1-.8-.8c0-.6.3-1 .8-1 .4 0 .7.4.7 1 0 .4-.3.8-.7.8zm-8.7.2c-.4 0-.7-.4-.7-1 0-.5.4-.8.8-.8s.7.3.7.8c0 .6-.3 1-.8 1z"
            })
          ]
        }),
        /* @__PURE__ */ jsx108("use", {
          xlinkHref: "#bz_svg__g",
          width: "100%",
          height: "100%",
          fill: "#730000",
          transform: "matrix(-1 0 0 1 748.8 0)"
        }),
        /* @__PURE__ */ jsxs83("g", {
          fill: "none",
          children: [
            /* @__PURE__ */ jsx108("path", {
              fill: "#730000",
              d: "M491.6 193.5c.5.2 2-2 .5-3 0 0-.5-2-2-2 0 0-1.4-2-3.4-1.7 0 0-2-1.5-2.9-1.4-1 .2-3 2.2-3 3-.2.5 0 1.8.5 2.4.6.5 1-.1 1-1 0 0-.3 1.5.9 2.2 1.2.7 1.1 0 1.2-.7 0 0 .3 1.6 1.1 2 .9.2 1.4-.5 2-.5 0 0-1 .8-.3 1.3.7.6 1.5.3 2 0 .6-.5.3-1.8 2.4-.6z"
            }),
            /* @__PURE__ */ jsx108("path", {
              d: "M482.5 189.8c.5-1.8 2.2-3.2 4-2.9m-2 4.4c.1-.4.2-.8.5-1.2 1-1.6 3-1.6 4.6-1.9m-2.5 4.5c.6-.4.8-1.1 1.4-1.4a5.3 5.3 0 0 1 3.2-.7"
            }),
            /* @__PURE__ */ jsx108("path", {
              fill: "#730000",
              stroke: "none",
              d: "M482.3 186.8c-.9.7-1.8 1.8-1.9 2.2 0 .7 0 1.9.5 2.5.6.5 1 0 1.1-.8 0 .5 0 1.5.8 2 1.3.7 1.2.1 1.3-.7 0 0 .3 1.6 1 2 .9.2 1.4-.5 2-.5 0 0-1 .8-.3 1.3.7.6 1.5.3 2 0 .6-.5.3-1.8 2.5-.6.2.2.8-.4 1-1.1l-7.7-5.5z"
            }),
            /* @__PURE__ */ jsx108("path", {
              d: "M480.7 188.2c-1.5 2.6.5 4.1 1.1 2.6-.1 2.4 1.7 2.3 2.3 1.5.7 2.5 1.9 1.4 3 1.2-1.3 2.3 1.4 1.6 2 1 1-1.3 1.4-.2 2-.3l1.3-1.3m-8-5.7c-1.7 1-2.5 2.2-2.6 3.7m5-2.2c-1.8 1-2.6 2.2-2.6 3.7m5.4-1.7c-1.7.9-1.8 1.7-2.5 2.8"
            })
          ]
        })
      ]
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#5ac800",
      d: "m238.5 310.7-.2-4.5 1.9 1.6.4-3.4c.8-.2 2.1 1.3 2.1 1.3l-.2-3.4 2.8 3.1s-.2-2.6.8-4.2c0 0 2.2 1.9 2.2 4 0 1.9 1.8-2.6 1.8-2.6a3116.2 3116.2 0 0 0 1.6 5l1.3-1.9 1 4 2.4-3.5 1.8 4 4.2-.3.5 2.4 1.9-2 2.4 1.5s2-.6 3.1-.6 2.4 1.4 2.4 1.4.8-1.4 1.5-1.9 1.9.8 2.2 1.6l1.6-2.9s2 2 2.3 2.9c0 0 .3-2.4.8-3.2.5-.7 1.2.3 1.8 1.3l1.3-4.2s1.4.3 2.3 1.9c1.1 1.5 1.1-2.4 1.1-2.4s2.4 3.2 3 5.3c0 0-16.2 5.6-27.6 4a306 306 0 0 1-24.5-4.3m110.9-.5s.7-2.1 1.8-3.2c0 0 2 2.4 2 3.2l1.7-1 1.6 1.5 1.8-1.3 1.8 1.6 3.2-1.4 1.3 1.4 5-.6 1.8.8 1.8-2.3 1.6 1.8 2.7-2.6s1.3 1 1.5 1.8c0 0 2.2-1 2.7-1.8 0 0 2-.8 2.3.5 0 0 1.3-1 1.2-2-.1-1.2 1.5-.4 2 1 0 0 .5-2.2 2-2.4 0 0 1.2 1.3.9 3.7 0 0 2.3-1.9 3.4-2.1 0 0 .5 2.6-.3 5 0 0 2.4-4 3-2.7.1.8.7 3.5.1 5.3l2.2-1.3.8 2.6 2.3-.5s-13.9 2.1-27 .9c-13-1.3-25.3-5.9-25.3-5.9m-9.6 9.7c.6-.4-4.4 10.3-16.5 10.9-16.9.8-31.3-7.7-31.3-7.7s1.8-2.9 2.9-3.7c0 0 2.3 1.9 3 4.2 0 0 .4-1.5 1.2-2.9 0 0 2.9 1.4 3.4 3.2 0 0 1-1.8 1.8-2.3.8-.6 1.6 2 1.6 3.6 0 0 1.9-2 3-2 0 0 2 1 2.6 4.3 0 0 2-1.8 2.6-1.5 0 0 2.3 1.5 1.8 3.7-.3 1.2 2.3-1.4 5.5-2.2l2.9 2.2 3.4-4.7s2.1.8 2.1 2c0 0 1-3.7 1.8-4 .8-.5 1.8 1.1 1.8 2.2 0 0 .3-2.8 1.9-3.4 0 0 1.6 1 1.6 2.1 0 0 1.6-3.2 2.9-4"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#060",
      strokeWidth: 0.5,
      d: "m238.5 310.7-.2-4.5 1.9 1.6.4-3.4c.8-.2 2.1 1.3 2.1 1.3l-.2-3.4 2.8 3.1s-.2-2.6.8-4.2c0 0 2.2 1.9 2.2 4 0 1.9 1.8-2.6 1.8-2.6l1.6 5 1.3-1.9 1 4 2.4-3.5 1.8 4 4.2-.3.5 2.4 1.9-2 2.4 1.5s2-.6 3.1-.6 2.4 1.4 2.4 1.4.8-1.4 1.5-1.9c.8-.5 1.9.8 2.2 1.6l1.6-2.9s2 2.1 2.3 2.9c0 0 .3-2.4.8-3.2.5-.7 1.2.3 1.8 1.3l1.3-4.2s1.4.3 2.3 1.9c1.1 1.5 1.1-2.4 1.1-2.4s2.4 3.2 3 5.3m58.7-.8s.8-2.1 1.9-3.2c0 0 2 2.4 2 3.2l1.7-1 1.6 1.5 1.8-1.3 1.8 1.6 3.2-1.4 1.3 1.4 5-.6 1.8.8 1.8-2.2 1.6 1.7 2.7-2.6s1.2 1 1.5 1.8c0 0 2.2-1 2.7-1.8 0 0 2-.8 2.3.5 0 0 1.3-1 1.2-2-.1-1.2 1.5-.4 2 1 0 0 .5-2.2 2-2.4 0 0 1.2 1.3.9 3.7 0 0 2.3-1.9 3.4-2 0 0 .5 2.5-.3 4.9 0 0 2.4-4 3-2.7.1.8.7 3.5.1 5.3l2.2-1.3.8 2.6 2.3-.5m-109.8 8s1.8-3 2.9-3.7c0 0 2.3 1.8 3.1 4.2 0 0 .3-1.6 1-3 0 0 3 1.4 3.5 3.2 0 0 1-1.8 1.9-2.3.7-.6 1.5 2 1.5 3.6 0 0 1.9-2 3-2 0 0 2 1 2.6 4.4 0 0 2-1.9 2.6-1.6 0 0 2.4 1.6 1.8 3.7-.3 1.2 2.3-1.4 5.5-2.1l2.9 2.1 3.4-4.7s2.1.8 2.1 2c0 0 1-3.6 1.8-4 .8-.5 1.9 1.1 1.9 2.2 0 0 .3-2.8 1.8-3.4 0 0 1.6 1 1.6 2.1 0 0 1.6-3.2 3-4"
    }),
    /* @__PURE__ */ jsxs83("g", {
      fill: "#fff",
      children: [
        /* @__PURE__ */ jsx108("path", {
          d: "M319.5 361.9c22 .2 35-7.8 42-12.6 16.8-11.2 20.3-11.6 23-11.4 3.1.3 7.7 1.3 8 4 .2 4.3-6.6 6.1-10.5 6.1-4 0-14.5-2.6-14.5-2.6l-2.7 1.9c1.8.8 23.2 8 27.3 1.2 4.2-6.8 8.4-17.9 8.4-17.9s-4.7-8.4-15.1-8.4c-10.6 0-20.8 6.7-27.6 11.7-6.9 5-15.5 11.8-38.3 11.8-22.9 0-31.6-6.8-38.4-11.8-6.9-5-17.1-11.7-27.6-11.7a18 18 0 0 0-15.2 8.4s4.2 11 8.4 18c4.1 6.7 25.5-.5 27.3-1.4l-2.6-1.8S261 348 257 348s-10.9-1.8-10.6-6c.2-2.8 4.8-3.8 8-4.1 2.7-.2 6.2.2 22.9 11.4a72 72 0 0 0 42.2 12.6"
        }),
        /* @__PURE__ */ jsx108("path", {
          d: "M284.1 336s0-1.9-.3-4.6c-.4-3.5-2.4-4.4-4-3.9-1.2.4-3.3 3-3.3 3v.1a31 31 0 0 0-3-1.8 18 18 0 0 1 6.3-3.6c1 0 14.5 5.4 18.8 9.1 1 1 1.8 7 1.2 9a46.5 46.5 0 0 1-15.7-7.2m-6.5 13.6s-2.9 3-3 8.3c0 6.3 4.5 6.6 7.5 6.5 3.7 0 6.6-2.1 6.5-8.9 0 0-6-2.5-11-6m77.1-13.6.4-4.6c.4-3.5 2.4-4.4 4-3.9 1 .4 3.2 3 3.2 3v.1l3-1.8c-.7-1-5.2-3.6-6.2-3.6s-14.5 5.4-18.8 9.1c-1 1-1.8 7-1.3 9a45.5 45.5 0 0 0 15.7-7.2zm6.5 13.7s2.9 3 3 8.3c.2 6.3-4.5 6.6-7.5 6.5-3.6 0-6.5-2.1-6.5-8.9 0 0 6-2.5 11-6"
        })
      ]
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "#69f",
      d: "M271.3 345.4S260.9 348 257 348c-4 0-10.9-1.8-10.6-6 .2-2.8 4.8-3.8 8-4.1 2.3-.2 5.3 0 17 7.5m96.1 0S378 348 382 348c3.9 0 10.7-1.8 10.4-6-.2-2.8-4.8-3.8-7.9-4.1-2.3-.2-5.4 0-17 7.5m-83.4-9.3a93.7 93.7 0 0 1-3.1-2.3c-1.5-1.1-3-2-4.5-3.2 0 0 2.1-2.7 3.2-3 1.7-.6 3.7.3 4.1 3.8.3 2.7.3 4.7.3 4.7m-7.1 27.6c1.8 1 3.9 1 5.1.8 3.7 0 6.6-2.1 6.5-8.9 0 0 4.5 2.3 11.8 4 0 0 1.2 1.5 1.4 4.4.3 2.5-1.4 5.1-3.3 5 0 0-10.3-2-16.5-3-3.7-.7-5-2.3-5-2.3m77.7-27.6 3.2-2.3 4.4-3.2s-2.1-2.7-3.2-3c-1.6-.6-3.6.3-4 3.8zm7.1 27.6c-1.8 1-3.9 1-5.1.8-3.6 0-6.5-2.1-6.5-8.9 0 0-4.5 2.3-11.7 4 0 0-1.3 1.5-1.5 4.4-.2 2.5 1.5 5.1 3.4 5 0 0 10.3-2 16.5-3 3.6-.7 5-2.3 5-2.3"
    }),
    /* @__PURE__ */ jsxs83("g", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.7,
      children: [
        /* @__PURE__ */ jsx108("path", {
          d: "M319.5 361.9c22 .2 35-7.8 42-12.6 16.8-11.2 20.3-11.6 23-11.4 3.1.3 7.7 1.3 8 4 .2 4.3-6.6 6.1-10.5 6.1-4 0-14.5-2.6-14.5-2.6l-2.7 1.9c1.8.8 23.2 8 27.3 1.2 4.2-6.8 8.4-17.9 8.4-17.9s-4.7-8.4-15.1-8.4c-10.6 0-20.8 6.7-27.7 11.7-6.8 5-15.4 11.8-38.2 11.8s-31.6-6.8-38.4-11.8c-6.9-5-17.1-11.7-27.6-11.7s-15.2 8.4-15.2 8.4 4.2 11 8.4 18c4.1 6.7 25.5-.5 27.4-1.4l-2.7-1.8S261 348 257 348s-10.9-1.8-10.6-6c.2-2.8 4.8-3.8 8-4.1 2.7-.2 6.2.2 22.9 11.4a72 72 0 0 0 42.2 12.6z"
        }),
        /* @__PURE__ */ jsx108("path", {
          d: "M271.3 345.4S260.9 348 257 348c-4 0-10.9-1.8-10.6-6 .2-2.8 4.8-3.8 8-4.1 2.3-.2 5.3 0 17 7.5zm96.2 0S378 348 382 348c3.9 0 10.7-1.8 10.4-6-.2-2.8-4.8-3.8-7.9-4.1-2.3-.2-5.4 0-17 7.5zm-83.4-9.3a92.6 92.6 0 0 1-3.1-2.3c-1.5-1.1-3-2-4.5-3.2 0 0 2.1-2.7 3.2-3 1.7-.6 3.7.3 4.1 3.8.3 2.8.3 4.7.3 4.7z"
        }),
        /* @__PURE__ */ jsx108("path", {
          d: "M284.1 336s0-1.9-.3-4.6c-.4-3.5-2.4-4.4-4-3.9-1.2.4-3.3 3-3.3 3v.1a31.9 31.9 0 0 0-3-1.8 18 18 0 0 1 6.3-3.6c1 0 14.5 5.4 18.8 9.1 1 1 1.8 7 1.2 9a46.6 46.6 0 0 1-15.7-7.2m-6.5 13.6s-2.9 3-3 8.3c0 6.3 4.5 6.6 7.5 6.5 3.7 0 6.6-2.1 6.5-8.9 0 0-6-2.5-11-6z"
        }),
        /* @__PURE__ */ jsx108("path", {
          d: "M280.1 351.1s-2.3 2.5-2.7 6.5c-.2 3.1 1.8 4.9 4.5 4.7 3.7-.2 5.1-5.3 3.4-8.1l-5.2-3"
        }),
        /* @__PURE__ */ jsx108("path", {
          d: "M277 363.7c1.8 1 3.9 1 5.2.8 3.6 0 6.5-2.1 6.4-8.9 0 0 4.5 2.3 11.8 4 0 0 1.2 1.5 1.4 4.5.3 2.4-1.4 5-3.3 4.8L282 366c-3.7-.7-5-2.3-5-2.3zm77.7-27.6 3.3-2.3c1.3-1.1 2.8-2 4.4-3.2 0 0-2.2-2.7-3.3-3-1.6-.6-3.6.3-4 3.8z"
        }),
        /* @__PURE__ */ jsx108("path", {
          d: "m354.7 336 .4-4.6c.4-3.5 2.4-4.4 4-3.9 1 .4 3.2 3 3.2 3v.1a31.9 31.9 0 0 1 3-1.8c-.7-.9-5.2-3.6-6.2-3.6s-14.5 5.4-18.8 9.1c-1 1-1.8 7-1.3 9a45.7 45.7 0 0 0 15.7-7.2m6.5 13.6s2.9 3 3 8.3c.2 6.3-4.5 6.6-7.5 6.5-3.6 0-6.5-2.1-6.5-8.9 0 0 6-2.5 11-6z"
        }),
        /* @__PURE__ */ jsx108("path", {
          d: "M358.7 351.1s2.4 2.5 2.8 6.5c.3 3.1-1.9 4.9-4.5 4.7-3.7-.2-5.1-5.3-3.4-8.1l5.1-3"
        }),
        /* @__PURE__ */ jsx108("path", {
          d: "M361.9 363.7c-2 1-4 1-5.2.8-3.6 0-6.5-2.1-6.5-8.9 0 0-4.5 2.3-11.7 4 0 0-1.3 1.5-1.5 4.5-.2 2.4 1.5 5 3.4 4.8l16.5-2.9c3.6-.7 5-2.3 5-2.3z"
        })
      ]
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 0.7,
      d: "M299.6 361.4s3.3 2.4-.7 5.3m-9-6.8 10 4.3m-8.3-2.1 7.2 3.1m-4.6-5 5.4 2.5m39.7-1.3s-3.3 2.4.6 5.3m9-6.8-10 4.3m8.4-2.1-7.2 3.1m4.6-5-5.4 2.5"
    }),
    /* @__PURE__ */ jsx108("path", {
      stroke: "#000",
      strokeWidth: 0.7,
      d: "M261 331.4c.2.2.2.4.3.7a2.5 2.5 0 0 1 0 .8 2.4 2.4 0 0 1-1.2 1.6 3 3 0 0 1-2.2.4 3.7 3.7 0 0 1-1-.4 4.3 4.3 0 0 1-1-.6l-.3.4-.4-.1.4-2.9.5.1c0 .4 0 .7.2 1l.3 1 .7.6c.2.2.5.3.9.4h.7a1.2 1.2 0 0 0 .9-.6 1.8 1.8 0 0 0 .2-.6 1.7 1.7 0 0 0-.1-1 1.8 1.8 0 0 0-.7-.7 48.3 48.3 0 0 0-.8-.5l-.8-.6c-.5-.3-.8-.6-1-1-.2-.4-.2-.8-.1-1.4 0-.3.2-.6.4-.8a2.5 2.5 0 0 1 1.5-1 2.9 2.9 0 0 1 1 0l1 .4.8.6.3-.4.5.1-.5 2.8-.5-.1a11.2 11.2 0 0 0 0-1 3.6 3.6 0 0 0-.4-.8 2 2 0 0 0-.5-.7 2 2 0 0 0-.8-.4 1.4 1.4 0 0 0-1 .2c-.4.2-.6.5-.6.8v1l.7.7.8.5a14.1 14.1 0 0 1 1.3 1c.2 0 .4.3.5.5m12 1.6-.5-.1a1.4 1.4 0 0 0-.5-.1c-.2 0-.4.1-.5.3a5.7 5.7 0 0 0-.6 1l-1.8 3.1a2.4 2.4 0 0 1-1.9 1.3h-1.1a4.2 4.2 0 0 1-1-.5 4.3 4.3 0 0 1-1-.8 3 3 0 0 1-.7-1 2.2 2.2 0 0 1-.1-1 2 2 0 0 1 .2-.8l2.4-4.3a.9.9 0 0 0 .1-.4v-.3a1.5 1.5 0 0 0-.3-.3l-.4-.3.2-.3 3.1 1.7-.2.3-.3-.1a2 2 0 0 0-.4-.1h-.4a.9.9 0 0 0-.2.3l-2.2 4a3.3 3.3 0 0 0-.3.7 1.8 1.8 0 0 0 0 .8c0 .2 0 .5.2.7l.9.8 1 .3a1.9 1.9 0 0 0 1.5-.5l.5-.6 1.6-3 .5-1v-.6c0-.2-.2-.3-.4-.5a3.6 3.6 0 0 0-.4-.3l.2-.4 3 1.7a19.2 19.2 0 0 1-.2.3m4.3 7.5a1.9 1.9 0 0 1 0 1.8 2 2 0 0 1-.8.8 2.2 2.2 0 0 1-1 .3l-1-.1a4 4 0 0 1-.9-.4l-3.5-2 .2-.4a5 5 0 0 0 .8.3.5.5 0 0 0 .3 0 .7.7 0 0 0 .3-.3l3-5.3a1 1 0 0 0 .1-.3.6.6 0 0 0-.1-.4 1.7 1.7 0 0 0-.3-.3l-.3-.2.2-.4 3.4 2 .7.5.6.7a1.6 1.6 0 0 1 0 1.6 1.8 1.8 0 0 1-.6.6l-.7.3a2.5 2.5 0 0 1-.7 0 3.3 3.3 0 0 1-.8-.2v.1a5 5 0 0 1 .6.6zm-.6-1.8c.2 0 .4-.2.5-.3a2.7 2.7 0 0 0 .5-.6c.2-.4.3-.8.2-1.2-.1-.3-.4-.6-.9-.9l-.4-.2-.4-.3-1.6 2.8.6.4.8.3zm-.6 2.7c.2-.4.3-.8.1-1.3 0-.4-.4-.8-1-1.1a29 29 0 0 0-.5-.4l-.4-.1-1.5 2.5a.6.6 0 0 0 0 .7c.1.2.4.4.7.5.5.3 1 .4 1.4.3.5-.2.8-.5 1.2-1zm18.9 4.3a3.5 3.5 0 0 0-.5 0 1.4 1.4 0 0 0-.6-.1c-.1 0-.3.1-.4.4a5.9 5.9 0 0 0-.5 1l-1.5 3.3c-.1.4-.4.7-.7 1a2.6 2.6 0 0 1-1 .4 3.2 3.2 0 0 1-1.1 0 4.3 4.3 0 0 1-2.2-1 3.1 3.1 0 0 1-.7-.8 2.2 2.2 0 0 1-.3-1 2 2 0 0 1 .2-.9l2-4.5a.9.9 0 0 0 0-.4.7.7 0 0 0-.1-.3 1.6 1.6 0 0 0-.3-.3l-.4-.2.2-.4 3.3 1.4-.2.4a3.5 3.5 0 0 0-.4-.1 2.3 2.3 0 0 0-.4 0h-.3a1 1 0 0 0-.2.3l-1.9 4.3-.2.7a1.7 1.7 0 0 0 .4 1.4c.2.3.5.5 1 .7l1 .2a1.9 1.9 0 0 0 1.5-.7 2.5 2.5 0 0 0 .4-.6l1.3-3.1.3-1v-.7l-.4-.4a3.7 3.7 0 0 0-.5-.3l.2-.4 3.1 1.4-.1.3m9.2 10.8-3.6-1v-.4a9 9 0 0 0 .6 0l.4.1a.8.8 0 0 0 .4-.2.7.7 0 0 0 .2-.3l1.7-5.8a1.4 1.4 0 0 0-.1 0l-4.8 6h-.3l-.6-7.9-1.5 4.8-.2 1.1.1.6.5.4a3.2 3.2 0 0 0 .5.3l-.2.4-3.2-1v-.4h.6a1 1 0 0 0 .5 0c.2 0 .3-.2.5-.4l.3-1 1.2-4.2a1.7 1.7 0 0 0 .1-.6 1 1 0 0 0-.1-.4 1.2 1.2 0 0 0-.4-.4 2 2 0 0 0-.5-.2l.1-.4 2.8.8.6 6.7 3.5-4.5.3-.5a2.8 2.8 0 0 0 .2-.4l2.7.8-.1.4a3.9 3.9 0 0 0-.5 0 2.4 2.4 0 0 0-.4-.1.4.4 0 0 0-.3.1 1 1 0 0 0-.1.4l-1.7 5.8a.8.8 0 0 0 0 .3l.1.3a3.4 3.4 0 0 0 .8.4l-.1.4m8.7-2.6a1.9 1.9 0 0 1 .7 1.7l-.4 1c-.2.3-.5.4-.8.6-.3.2-.6.2-1 .3h-1l-4-.5v-.4h.5a1.7 1.7 0 0 0 .4 0 .5.5 0 0 0 .3-.2.7.7 0 0 0 .1-.4l.8-6a1 1 0 0 0 0-.3.6.6 0 0 0-.3-.3 1.7 1.7 0 0 0-.4-.2h-.3v-.5l3.9.5c.3 0 .6 0 .9.2l.7.4a1.6 1.6 0 0 1 .6 1.5l-.2.8a1.7 1.7 0 0 1-.6.5 2.6 2.6 0 0 1-.6.3 3.4 3.4 0 0 1-.8.2l.8.3zm-1.3-1.5.4-.5.2-.7a1.5 1.5 0 0 0-.3-1.1c-.2-.3-.6-.5-1.1-.5a27.3 27.3 0 0 0-1-.1l-.4 3.2h.8c.3.1.6 0 .8 0a1.3 1.3 0 0 0 .6-.3zm.5 2.8c0-.5 0-1-.3-1.3-.3-.3-.8-.5-1.4-.6l-.7-.1h-.4l-.3 2.9a.6.6 0 0 0 .2.6l.8.3c.6 0 1 0 1.5-.4.3-.3.5-.7.6-1.4zm11.4 2.6h-2.2a44 44 0 0 0-1.4-2l-1.3-1.8h-1v2.7l.1.4.3.2h.4l.5.1v.4h-3.6v-.4h.4l.4-.1a.5.5 0 0 0 .2-.2.7.7 0 0 0 .1-.4v-6.4l-.3-.3a2.2 2.2 0 0 0-.4 0l-.4-.1v-.4h4.9a2.8 2.8 0 0 1 .9.4l.6.6a2.3 2.3 0 0 1 0 1.8 2 2 0 0 1-.4.7 2.5 2.5 0 0 1-.7.4 5.3 5.3 0 0 1-.8.3l1 1.4c.3.4.7.8 1 1.4a2.5 2.5 0 0 0 1 .8 3 3 0 0 0 .8.1zm-3.1-6.2c0-.5-.2-1-.4-1.2-.3-.3-.8-.5-1.3-.5h-1v3.6h.8c.5 0 1-.1 1.3-.5.4-.3.6-.8.6-1.4zm13 5.6-3.6.3v-.4l.7-.2c.2 0 .3-.2.3-.2v-.2a.5.5 0 0 0 0-.1l-.9-1.8-3 .2a9.6 9.6 0 0 0-.2.7l-.1.6a3.4 3.4 0 0 0-.1.4v.3c0 .2.1.3.4.3l.9.1v.4l-3.2.3v-.4a2 2 0 0 0 .4-.1 1.3 1.3 0 0 0 .7-.6l.2-.5 1.1-3.6 1.1-3.6h.5l3.4 7 .2.3a1.2 1.2 0 0 0 .7.4h.4v.4zm-3.7-3.1-1.6-3.2-1 3.4zm15.7-6.7a27.9 27.9 0 0 0-.4.2 3.1 3.1 0 0 0-.8-.9c-.4-.2-.7-.4-1-.3a6.3 6.3 0 0 0-.3 0l-.6.2-1.4.4.9 3.2 1-.2.6-.3.3-.4.1-.4v-.6l.4-.2.9 3.2-.4.1a2.9 2.9 0 0 0-.3-.5l-.4-.4a.9.9 0 0 0-.5-.2 2.3 2.3 0 0 0-.6.1l-1 .3.8 2.8s0 .2.2.3a.6.6 0 0 0 .3.2h.4l.4-.1.1.4-3.5 1-.1-.4a9.5 9.5 0 0 0 .4-.2l.4-.2a.5.5 0 0 0 .2-.3.8.8 0 0 0 0-.3l-1.6-5.9a1.1 1.1 0 0 0-.2-.3l-.3-.2a2.4 2.4 0 0 0-.4 0 2.4 2.4 0 0 0-.5 0l-.1-.3 6.4-1.8.6 2m9.4-.7 1 2.4-6 2.8-.2-.3.4-.3a1.4 1.4 0 0 0 .3-.2.5.5 0 0 0 .1-.3.8.8 0 0 0 0-.4l-2.7-5.4a1 1 0 0 0-.2-.3.5.5 0 0 0-.4 0h-.4a2 2 0 0 0-.4 0l-.2-.3 3.3-1.6.2.4a2.8 2.8 0 0 0-.4.2 2.2 2.2 0 0 0-.3.3.4.4 0 0 0-.2.3.8.8 0 0 0 .1.4l2.5 5c0 .3.2.5.3.6l.3.2h.4l.7-.3.4-.2.4-.3.3-.2a.6.6 0 0 0 .2-.3 6.3 6.3 0 0 0 .2-2l.3-.2m4.5-8.3a4.2 4.2 0 0 1 1.5.8l1.2 1.4a5 5 0 0 1 .6 1.7 4.1 4.1 0 0 1 0 1.6 4 4 0 0 1-.7 1.5 4 4 0 0 1-1.2 1 4 4 0 0 1-3.2.4 4 4 0 0 1-1.4-.7 5 5 0 0 1-1.2-1.4 5 5 0 0 1-.6-1.7 4.3 4.3 0 0 1 0-1.7 4 4 0 0 1 2-2.4 4 4 0 0 1 1.5-.6 3.9 3.9 0 0 1 1.5.1zm2.3 5.6a4 4 0 0 0-.2-1.3 7 7 0 0 0-.7-1.4 7.2 7.2 0 0 0-1-1.3 4 4 0 0 0-1-.8 2.4 2.4 0 0 0-1-.2c-.5 0-.8.1-1.2.3-.4.3-.7.6-.9 1a2.6 2.6 0 0 0-.3 1c0 .5.1.9.3 1.3a7.2 7.2 0 0 0 1.5 2.6c.3.4.7.6 1 .8a2.4 2.4 0 0 0 1.2.3c.3 0 .7 0 1.1-.3a2.3 2.3 0 0 0 1.2-2zm10.5-5.7-1.9 1.3-2.3-.9-2-.6-.8.5 1.6 2.1.2.3h.4a1.8 1.8 0 0 0 .3-.1l.4-.3.3.4-3 2-.2-.3a8.6 8.6 0 0 0 .6-.5.5.5 0 0 0 0-.4.7.7 0 0 0 0-.3l-3.6-5a1 1 0 0 0-.2-.2.3.3 0 0 0-.4 0 3 3 0 0 0-.7.3l-.3-.4 3.2-2.2a4.6 4.6 0 0 1 .9-.5 2.7 2.7 0 0 1 .9-.2l.8.1a2.2 2.2 0 0 1 1.1 1.4v.8a2.5 2.5 0 0 1-.2.7 4.9 4.9 0 0 1-.5.8l1.6.5 1.6.5a2.5 2.5 0 0 0 1.2.1h.4a2.6 2.6 0 0 0 .4-.3zm-6.2-3.3c-.3-.4-.6-.6-1-.7-.4-.1-.9 0-1.3.3l-.8.6 2 3 .7-.5c.4-.3.7-.7.8-1.2 0-.5 0-1-.4-1.5zm13.2-2 .7 2.4-6.6 2.4-.2-.4a4.3 4.3 0 0 0 .8-.4.6.6 0 0 0 .2-.3.7.7 0 0 0 0-.4l-2.2-5.6a1 1 0 0 0-.1-.3l-.4-.1h-.4a2.2 2.2 0 0 0-.5 0l-.1-.3 6.1-2.3.7 1.9-.4.1a2.7 2.7 0 0 0-.8-.7l-.9-.3a4.3 4.3 0 0 0-.4.2l-.6.2-1.2.4 1.1 3.1 1-.3c.2 0 .4-.2.5-.3a.9.9 0 0 0 .3-.4v-1.1l.4-.1 1.1 3-.4.2a3.2 3.2 0 0 0-.3-.5 1.5 1.5 0 0 0-.4-.3.9.9 0 0 0-.5-.2c-.2 0-.4 0-.6.2l-.9.3.9 2.4.2.5a.5.5 0 0 0 .3.3h.5l.7-.3.5-.2a3.9 3.9 0 0 0 1-.4l.2-.3.2-1v-1l.5-.1m7.1-5.8c.4.3.8.7 1 1.3.3.5.5 1 .6 1.7a4.9 4.9 0 0 1 0 1.8 4.1 4.1 0 0 1-.8 1.5 3.9 3.9 0 0 1-2.7 1.6 3.9 3.9 0 0 1-3-.9 4.1 4.1 0 0 1-1-1.2 4.9 4.9 0 0 1-.6-1.7 5 5 0 0 1 0-1.9l.8-1.5a4 4 0 0 1 2.7-1.5 4 4 0 0 1 1.6 0zm-.1 6c.2-.4.3-.8.3-1.3v-1.5a7 7 0 0 0-.4-1.5 3.9 3.9 0 0 0-.7-1.2 2.4 2.4 0 0 0-.9-.7 2.3 2.3 0 0 0-1.1-.1c-.5 0-1 .2-1.2.5-.3.2-.6.6-.7 1a4 4 0 0 0-.3 1.2 7 7 0 0 0 .4 3l.7 1.1c.2.4.5.6.9.7.3.2.7.2 1.2.2a2.3 2.3 0 0 0 1-.5 2.4 2.4 0 0 0 .8-1z"
    }),
    /* @__PURE__ */ jsx108("path", {
      fill: "none",
      stroke: "#000",
      d: "M366 205.1v53c0 10.6-1.4 52.6-46.5 69-45.3-16.4-46.7-58.4-46.7-69v-53H366"
    })
  ]
});
var Bz_default = SvgBz;

// src/country-flag-icons/generated/Ca.tsx
init_esm_shims();
import { jsx as jsx109, jsxs as jsxs84 } from "react/jsx-runtime";
var SvgCa = (props) => /* @__PURE__ */ jsxs84("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx109("path", {
      fill: "#fff",
      d: "M150.1 0h339.7v480H150z"
    }),
    /* @__PURE__ */ jsx109("path", {
      fill: "#d52b1e",
      d: "M-19.7 0h169.8v480H-19.7zm509.5 0h169.8v480H489.9zM201 232l-13.3 4.4 61.4 54c4.7 13.7-1.6 17.8-5.6 25l66.6-8.4-1.6 67 13.9-.3-3.1-66.6 66.7 8c-4.1-8.7-7.8-13.3-4-27.2l61.3-51-10.7-4c-8.8-6.8 3.8-32.6 5.6-48.9 0 0-35.7 12.3-38 5.8l-9.2-17.5-32.6 35.8c-3.5.9-5-.5-5.9-3.5l15-74.8-23.8 13.4c-2 .9-4 .1-5.2-2.2l-23-46-23.6 47.8c-1.8 1.7-3.6 1.9-5 .7L264 130.8l13.7 74.1c-1.1 3-3.7 3.8-6.7 2.2l-31.2-35.3c-4 6.5-6.8 17.1-12.2 19.5-5.4 2.3-23.5-4.5-35.6-7 4.2 14.8 17 39.6 9 47.7"
    })
  ]
});
var Ca_default = SvgCa;

// src/country-flag-icons/generated/Cc.tsx
init_esm_shims();
import { jsx as jsx110, jsxs as jsxs85 } from "react/jsx-runtime";
var SvgCc = (props) => /* @__PURE__ */ jsxs85("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsxs85("defs", {
      children: [
        /* @__PURE__ */ jsx110("path", {
          id: "cc_svg__a",
          d: "m0-360 69.4 215.8 212-80.3L156-35.6 351 80.1 125 99.8l31.1 224.6L0 160l-156.2 164.3 31.1-224.5L-351 80l195-115.7-125.5-188.9 212 80.3z"
        }),
        /* @__PURE__ */ jsx110("path", {
          id: "cc_svg__b",
          d: "M0-210 54.9-75.5l144.8 10.6-111 93.8 34.7 141L0 93.3-123.4 170l34.6-141-111-93.8 145-10.6z"
        })
      ]
    }),
    /* @__PURE__ */ jsx110("path", {
      fill: "green",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx110("circle", {
      cx: 320,
      cy: 240,
      r: 66.7,
      fill: "#ffe000"
    }),
    /* @__PURE__ */ jsx110("circle", {
      cx: 340.8,
      cy: 240,
      r: 54.9,
      fill: "green"
    }),
    /* @__PURE__ */ jsx110("circle", {
      cx: 109.8,
      cy: 173.3,
      r: 69.8,
      fill: "#ffe000"
    }),
    /* @__PURE__ */ jsx110("path", {
      fill: "#802000",
      stroke: "#7b3100",
      strokeWidth: 1.5,
      d: "M105 226h17.5s.7-1.6-.2-2.4c-1-.8-4.7-1-3.7-3.8 2-5.8 2.4-4 3.7-17.8a739 739 0 0 0 2-35.5h-2.6s.5 6.7-1 15.5c-1.4 8.8-1.9 9.5-3.5 16.3a63.5 63.5 0 0 1-3.3 11.2c-1.4 4-1.6 4.1-3.8 7.8-2.3 3.6-1.5 2.2-2.7 4.4-.7 1.1-1.4.8-1.9 1.6-.4.8-.5 2.7-.5 2.7z"
    }),
    /* @__PURE__ */ jsx110("path", {
      fill: "green",
      d: "M118.3 122.5a23 23 0 0 1-1.2 9.2 26.5 26.5 0 0 0-2.3 9.8c-1.8.6-3.7-3.9-5.5-1.2 1.3 3.7 4.4 6.6 6.4 9.9.4 1 3.4 3.7 1.6 4.3-4.3-1.5-5.4-7-8-10.3a19 19 0 0 0-15.5-10c-2.5.1-10.4-.5-8.4 3.7 3 2 6.8 3.4 9.8 5.7 2.3.2 6.3 4 6.1 5.4-4-1.6-5.8-3.5-10-5.2-5.8-2.2-13.7-.9-17 4.8-.5 1.5-1.4 5.8.5 6.3 2.2-3.4 5.3-7.3 9.9-6.2 3.6.3-4 6.7-1.1 5.4 1-.4 3-1.8 4.6-2 1.5 0 2.3 1 3.4 1.2 2.3.3 3 1.2 2.7 1.8-.2.6-1 0-3.3.8-1.1.4-1.7 1.4-3 1.9-1.4.4-4.2.5-5.2 0-3.7-1.5-9.7-1.3-10.8 3.3 0 2-1.8-.2-2.6.7-.7 2.2-.8 4.4-4 4.2-2 2-4 4.2-6.6 5.7 1.5 3.4 7.3-3.4 7-.5-2.5 3.5 1.4 4.2 3 1.5 2.9-3 6.5-6.7 10.7-3.6 2 1.9 3.2-1 4.7-1 1 2.5 2.1.2 3.2-.5 1.7-.2 1.2 2.2 3.2.7 4.1-2.7 9.1-.4 13.1-3 4.3-2 .6 1.5-.5 2.9-1.9 3.6-.3 8.4-4.3 10.6-1.7 4.3 1.9 10-1.7 13.2-.5 2 4.6 1.8 6 2.6 2.6 0 0-5.8 2.5-6.6 3.4 2 3.2-3.8 2.5-5.6.4-4 .6-8.6 2.6-12.3 2.2-4.5 4.2 1.9 1.8 3.7-1.4 4.1-3.4 9.4-.3 13.3 1 .2 1.7 2.4 2.8 3 1.2.7 2.8-.1 3-2.1 1.6-6 .8-12.4 3-18.3 1.5-1.8 3.6-.3 4.5 1.4 3 3.5 5.1 7.8 8.7 10.7a15 15 0 0 1 7.8 7.3c0 2.6 7.4 3 5.2 0-2.1-2.7-.7-5.6 1.4-7.5 1.2.3.9-1.8 0-1-1.5-.3-1.6-3 .4-1.7 3.5 1.1-.2-2.5-1.5-2.6-2.9-1.8-6.2-3.8-7.6-7 3.8 0 7.7 2.1 11.5.9 3.1-1.6 6.2 0 7.3 2.8 2.4-.4 1.4-2.8 0-3.6 1.7-.7 3-2.2.8-3.5-1-1.4 1.5-4-1.7-3.8.1-2.5-.8-4.7-3.5-5.6-2.7-2.2-10.6 3.4-10.3-1.7-.8-2.8 3.2-.4 4.3-1.8 1.1-3-5.5-2.6-3.3-5 1.4-.8 8.1-2.1 2.9-3.1a8.3 8.3 0 0 1-7-1.1c-1.9 3.1-7.2-1.8-6.3 3.8-.7 2.1-5.5 7.6-6.8 3.4 1-3.3 6.8-4.3 5-8.8-.3-2.7-2.6.5-3.6.3-.6-1.7 1.6-3.8 3.2-4.2 3 2.4 3-3 6-2.5 2.1-.5-.7-1.4-1.3-1.8.6-1.5 3.9-2.3.7-3.7-2.9-2-5 2.1-7.3 2.3-2.2-2.5 2-3.7 3.2-5 .1-1-2.4-.3-1.7-1.2.7-1.1 5.2-1.2 3-3a14.7 14.7 0 0 0-10.2.6c-2 .6-2.5 5-4.2 4.8-.7-2 .3-5.8-2.4-6.3m15 42.3c2.4-.4 0 3.7-1 3.6 0-1.4-3.6-1.3-1.3-2.6a7.3 7.3 0 0 1 2.3-1"
    }),
    /* @__PURE__ */ jsxs85("g", {
      fill: "#ffe000",
      transform: "translate(0 80) scale(.0635)",
      children: [
        /* @__PURE__ */ jsx110("use", {
          xlinkHref: "#cc_svg__a",
          width: "100%",
          height: "100%",
          x: 7560,
          y: 4200
        }),
        /* @__PURE__ */ jsx110("use", {
          xlinkHref: "#cc_svg__a",
          width: "100%",
          height: "100%",
          x: 6300,
          y: 2205
        }),
        /* @__PURE__ */ jsx110("use", {
          xlinkHref: "#cc_svg__a",
          width: "100%",
          height: "100%",
          x: 7560,
          y: 840
        }),
        /* @__PURE__ */ jsx110("use", {
          xlinkHref: "#cc_svg__a",
          width: "100%",
          height: "100%",
          x: 8680,
          y: 1869
        }),
        /* @__PURE__ */ jsx110("use", {
          xlinkHref: "#cc_svg__b",
          width: "100%",
          height: "100%",
          x: 8064,
          y: 2730
        })
      ]
    })
  ]
});
var Cc_default = SvgCc;

// src/country-flag-icons/generated/Cd.tsx
init_esm_shims();
import { jsx as jsx111, jsxs as jsxs86 } from "react/jsx-runtime";
var SvgCd = (props) => /* @__PURE__ */ jsxs86("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx111("path", {
      fill: "#007fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx111("path", {
      fill: "#f7d618",
      d: "M28.8 96H96l20.8-67.2L137.6 96h67.2l-54.4 41.6 20.8 67.2-54.4-41.6-54.4 41.6 20.8-67.2zM600 0 0 360v120h40l600-360V0z"
    }),
    /* @__PURE__ */ jsx111("path", {
      fill: "#ce1021",
      d: "M640 0 0 384v96L640 96z"
    })
  ]
});
var Cd_default = SvgCd;

// src/country-flag-icons/generated/Cf.tsx
init_esm_shims();
import { jsx as jsx112, jsxs as jsxs87 } from "react/jsx-runtime";
var SvgCf = (props) => /* @__PURE__ */ jsxs87("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx112("defs", {
      children: /* @__PURE__ */ jsx112("clipPath", {
        id: "cf_svg__a",
        children: /* @__PURE__ */ jsx112("path", {
          fillOpacity: 0.7,
          d: "M-12.4 32h640v480h-640z"
        })
      })
    }),
    /* @__PURE__ */ jsxs87("g", {
      fillRule: "evenodd",
      clipPath: "url(#cf_svg__a)",
      transform: "translate(12.4 -32)",
      children: [
        /* @__PURE__ */ jsx112("path", {
          fill: "#00f",
          d: "M-52 32h719.3v119H-52z"
        }),
        /* @__PURE__ */ jsx112("path", {
          fill: "#ff0",
          d: "M-52 391.6h719.3V512H-52z"
        }),
        /* @__PURE__ */ jsx112("path", {
          fill: "#009a00",
          d: "M-52 271.3h719.3v120.3H-52z"
        }),
        /* @__PURE__ */ jsx112("path", {
          fill: "#fff",
          d: "M-52 151h719.3v120.3H-52z"
        }),
        /* @__PURE__ */ jsx112("path", {
          fill: "red",
          d: "M247.7 32.5h119.9V512H247.7z"
        }),
        /* @__PURE__ */ jsx112("path", {
          fill: "#ff0",
          d: "m99.3 137.7-31.5-21.8-31.3 22L47.4 101 16.9 78l38.2-1 12.5-36.3L80.3 77l38.1.7L88.2 101"
        })
      ]
    })
  ]
});
var Cf_default = SvgCf;

// src/country-flag-icons/generated/Cg.tsx
init_esm_shims();
import { jsx as jsx113, jsxs as jsxs88 } from "react/jsx-runtime";
var SvgCg = (props) => /* @__PURE__ */ jsxs88("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx113("defs", {
      children: /* @__PURE__ */ jsx113("clipPath", {
        id: "cg_svg__a",
        children: /* @__PURE__ */ jsx113("path", {
          fillOpacity: 0.7,
          d: "M-79.5 32h640v480h-640z"
        })
      })
    }),
    /* @__PURE__ */ jsxs88("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      clipPath: "url(#cg_svg__a)",
      transform: "translate(79.5 -32)",
      children: [
        /* @__PURE__ */ jsx113("path", {
          fill: "#ff0",
          d: "M-119.5 32h720v480h-720z"
        }),
        /* @__PURE__ */ jsx113("path", {
          fill: "#00ca00",
          d: "M-119.5 32v480l480-480z"
        }),
        /* @__PURE__ */ jsx113("path", {
          fill: "red",
          d: "M120.5 512h480V32z"
        })
      ]
    })
  ]
});
var Cg_default = SvgCg;

// src/country-flag-icons/generated/Ch.tsx
init_esm_shims();
import { jsx as jsx114, jsxs as jsxs89 } from "react/jsx-runtime";
var SvgCh = (props) => /* @__PURE__ */ jsx114("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs89("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    children: [
      /* @__PURE__ */ jsx114("path", {
        fill: "red",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsxs89("g", {
        fill: "#fff",
        children: [
          /* @__PURE__ */ jsx114("path", {
            d: "M170 195h300v90H170z"
          }),
          /* @__PURE__ */ jsx114("path", {
            d: "M275 90h90v300h-90z"
          })
        ]
      })
    ]
  })
});
var Ch_default = SvgCh;

// src/country-flag-icons/generated/Ci.tsx
init_esm_shims();
import { jsx as jsx115, jsxs as jsxs90 } from "react/jsx-runtime";
var SvgCi = (props) => /* @__PURE__ */ jsx115("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs90("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx115("path", {
        fill: "#00cd00",
        d: "M426.8 0H640v480H426.8z"
      }),
      /* @__PURE__ */ jsx115("path", {
        fill: "#ff9a00",
        d: "M0 0h212.9v480H0z"
      }),
      /* @__PURE__ */ jsx115("path", {
        fill: "#fff",
        d: "M212.9 0h214v480h-214z"
      })
    ]
  })
});
var Ci_default = SvgCi;

// src/country-flag-icons/generated/Ck.tsx
init_esm_shims();
import { jsx as jsx116, jsxs as jsxs91 } from "react/jsx-runtime";
var SvgCk = (props) => /* @__PURE__ */ jsxs91("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx116("path", {
      fill: "#006",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx116("path", {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m471.6 213 5.2-16.7-14-10.6 17.6-.2 6-16.5 5.6 16.5 17.7.5-14.1 10.5 5 16.7-14.5-10m27.1 13 10.4-13.9-9.7-14.8 16.7 5.8 11-13.5v17.6l16.4 6.4-16.8 5-.8 17.5-10.2-14.4m-98.4 15-.7-17.5-16.8-5.2L431 198v-17.4l10.9 13.5 16.8-5.6-9.8 14.7 10.3 14-17-4.5m-39.6 40.9-7.4-15.8-17.4 1.8 12.8-12.3L384 211l15.2 8.2 13.3-11.8-3.4 17.4 14.9 8.9-17.3 2.5M389 291.8l-13.3-11.1-15 9.2 6.4-16.7-12.9-11.6 17.3.7 7-16.4 4.3 17.2 17.2 1.5-14.6 9.8m3.2 60.4-16.5-4.8-10.1 14.5-.7-17.9-16.4-5.5 16.1-6.2v-18l10.7 14.1 16.4-5.6-9.6 15m29.5 50.8-17 2.4-3.5 17.4-7.8-16-17.1 1.6 12.2-12.3-7.1-16.4 15.3 8.5 12.8-11.8L393 362m45 38-15.1 8.2 2.6 17.6-12.7-12.4-15.6 7.6 7.3-15.9-12.3-12.9 17.3 2.6 8-15.5 3.4 17.4m53.8 9-8.3 15.3 11.7 13.2-17.4-3.3-8.9 15-2.4-17.3-17.2-4 15.8-7.4-1.7-17.5 12.2 12.8m57.4-13.1-.5 17.4 16.3 6.4-17 5-1.2 17.5-10-14.3-17 4.4 10.8-13.9-9.4-14.7 16.6 5.7M559 209.8l12 12.6 15.9-7.4-8.3 15.8 11.5 13.1-17-2.8-9 15.5L562 239l-17-3.5 15.7-8m34.2 21 5.5 16.6 17.5.3-14.2 10.7 4.7 16.8-14.1-10-14.6 10.1 5.4-16.8-13.8-10.6 17.6-.4m19.5 33.2-2 17.4 15.7 7.7-17.3 3.6-2.7 17.3-8.7-15.1-17.4 2.9 12-13-8.1-15.5 16 7.2m3 39.8-7.8 15.6L603 379l-17.4-2.7-8.4 15.3-3-17.3-17.4-3.3 15.6-8-2.3-17.4 12.6 12.3m-9.8 39.1-14.7 9.2 3.8 17.3-13.5-11.5-15 8.6 6.3-16.3-13.1-12.1 17.4 1.5 7-16 4.4 17.2"
    }),
    /* @__PURE__ */ jsx116("path", {
      fill: "#006",
      d: "M0 0h320v240H0z"
    }),
    /* @__PURE__ */ jsx116("path", {
      fill: "#fff",
      d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0z"
    }),
    /* @__PURE__ */ jsx116("path", {
      fill: "#c8102e",
      d: "M212 140.5 320 220v20l-135.5-99.5zm-92 10 3 17.5-96 72H0zM320 0v1.5l-124.5 94 1-22L295 0zM0 0l119.5 88h-30L0 21z"
    }),
    /* @__PURE__ */ jsx116("path", {
      fill: "#fff",
      d: "M120.5 0v240h80V0zM0 80v80h320V80z"
    }),
    /* @__PURE__ */ jsx116("path", {
      fill: "#c8102e",
      d: "M0 96.5v48h320v-48zM136.5 0v240h48V0z"
    })
  ]
});
var Ck_default = SvgCk;

// src/country-flag-icons/generated/Cl.tsx
init_esm_shims();
import { jsx as jsx117, jsxs as jsxs92 } from "react/jsx-runtime";
var SvgCl = (props) => /* @__PURE__ */ jsxs92("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx117("defs", {
      children: /* @__PURE__ */ jsx117("clipPath", {
        id: "cl_svg__a",
        children: /* @__PURE__ */ jsx117("path", {
          fillOpacity: 0.7,
          d: "M0 0h682.7v512H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs92("g", {
      fillRule: "evenodd",
      clipPath: "url(#cl_svg__a)",
      transform: "scale(.9375)",
      children: [
        /* @__PURE__ */ jsx117("path", {
          fill: "#fff",
          d: "M256 0h512v256H256z"
        }),
        /* @__PURE__ */ jsx117("path", {
          fill: "#0039a6",
          d: "M0 0h256v256H0z"
        }),
        /* @__PURE__ */ jsx117("path", {
          fill: "#fff",
          d: "M167.8 191.7 128.2 162l-39.5 30 14.7-48.8L64 113.1l48.7-.5L127.8 64l15.5 48.5 48.7.1-39.2 30.4z"
        }),
        /* @__PURE__ */ jsx117("path", {
          fill: "#d52b1e",
          d: "M0 256h768v256H0z"
        })
      ]
    })
  ]
});
var Cl_default = SvgCl;

// src/country-flag-icons/generated/Cm.tsx
init_esm_shims();
import { jsx as jsx118, jsxs as jsxs93 } from "react/jsx-runtime";
var SvgCm = (props) => /* @__PURE__ */ jsxs93("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx118("path", {
      fill: "#007a5e",
      d: "M0 0h213.3v480H0z"
    }),
    /* @__PURE__ */ jsx118("path", {
      fill: "#ce1126",
      d: "M213.3 0h213.4v480H213.3z"
    }),
    /* @__PURE__ */ jsx118("path", {
      fill: "#fcd116",
      d: "M426.7 0H640v480H426.7z"
    }),
    /* @__PURE__ */ jsxs93("g", {
      fill: "#fcd116",
      transform: "translate(320 240) scale(7.1111)",
      children: [
        /* @__PURE__ */ jsxs93("g", {
          id: "cm_svg__b",
          children: [
            /* @__PURE__ */ jsx118("path", {
              id: "cm_svg__a",
              d: "M0-8-2.5-.4 1.3.9z"
            }),
            /* @__PURE__ */ jsx118("use", {
              xlinkHref: "#cm_svg__a",
              width: "100%",
              height: "100%",
              transform: "scale(-1 1)"
            })
          ]
        }),
        /* @__PURE__ */ jsx118("use", {
          xlinkHref: "#cm_svg__b",
          width: "100%",
          height: "100%",
          transform: "rotate(72)"
        }),
        /* @__PURE__ */ jsx118("use", {
          xlinkHref: "#cm_svg__b",
          width: "100%",
          height: "100%",
          transform: "rotate(144)"
        }),
        /* @__PURE__ */ jsx118("use", {
          xlinkHref: "#cm_svg__b",
          width: "100%",
          height: "100%",
          transform: "rotate(-144)"
        }),
        /* @__PURE__ */ jsx118("use", {
          xlinkHref: "#cm_svg__b",
          width: "100%",
          height: "100%",
          transform: "rotate(-72)"
        })
      ]
    })
  ]
});
var Cm_default = SvgCm;

// src/country-flag-icons/generated/Cn.tsx
init_esm_shims();
import { jsx as jsx119, jsxs as jsxs94 } from "react/jsx-runtime";
var SvgCn = (props) => /* @__PURE__ */ jsxs94("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx119("defs", {
      children: /* @__PURE__ */ jsx119("path", {
        id: "cn_svg__a",
        fill: "#ff0",
        d: "M-.6.8 0-1 .6.8-1-.3h2z"
      })
    }),
    /* @__PURE__ */ jsx119("path", {
      fill: "#ee1c25",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx119("use", {
      xlinkHref: "#cn_svg__a",
      width: 30,
      height: 20,
      transform: "matrix(71.9991 0 0 72 120 120)"
    }),
    /* @__PURE__ */ jsx119("use", {
      xlinkHref: "#cn_svg__a",
      width: 30,
      height: 20,
      transform: "matrix(-12.33562 -20.5871 20.58684 -12.33577 240.3 48)"
    }),
    /* @__PURE__ */ jsx119("use", {
      xlinkHref: "#cn_svg__a",
      width: 30,
      height: 20,
      transform: "matrix(-3.38573 -23.75998 23.75968 -3.38578 288 95.8)"
    }),
    /* @__PURE__ */ jsx119("use", {
      xlinkHref: "#cn_svg__a",
      width: 30,
      height: 20,
      transform: "matrix(6.5991 -23.0749 23.0746 6.59919 288 168)"
    }),
    /* @__PURE__ */ jsx119("use", {
      xlinkHref: "#cn_svg__a",
      width: 30,
      height: 20,
      transform: "matrix(14.9991 -18.73557 18.73533 14.99929 240 216)"
    })
  ]
});
var Cn_default = SvgCn;

// src/country-flag-icons/generated/Co.tsx
init_esm_shims();
import { jsx as jsx120, jsxs as jsxs95 } from "react/jsx-runtime";
var SvgCo = (props) => /* @__PURE__ */ jsx120("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs95("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    children: [
      /* @__PURE__ */ jsx120("path", {
        fill: "#ffe800",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsx120("path", {
        fill: "#00148e",
        d: "M0 240h640v240H0z"
      }),
      /* @__PURE__ */ jsx120("path", {
        fill: "#da0010",
        d: "M0 360h640v120H0z"
      })
    ]
  })
});
var Co_default = SvgCo;

// src/country-flag-icons/generated/Cp.tsx
init_esm_shims();
import { jsx as jsx121, jsxs as jsxs96 } from "react/jsx-runtime";
var SvgCp = (props) => /* @__PURE__ */ jsx121("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs96("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    children: [
      /* @__PURE__ */ jsx121("path", {
        fill: "#fff",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsx121("path", {
        fill: "#000091",
        d: "M0 0h213.3v480H0z"
      }),
      /* @__PURE__ */ jsx121("path", {
        fill: "#e1000f",
        d: "M426.7 0H640v480H426.7z"
      })
    ]
  })
});
var Cp_default = SvgCp;

// src/country-flag-icons/generated/Cr.tsx
init_esm_shims();
import { jsx as jsx122, jsxs as jsxs97 } from "react/jsx-runtime";
var SvgCr = (props) => /* @__PURE__ */ jsx122("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs97("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    children: [
      /* @__PURE__ */ jsx122("path", {
        fill: "#0000b4",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsx122("path", {
        fill: "#fff",
        d: "M0 75.4h640v322.3H0z"
      }),
      /* @__PURE__ */ jsx122("path", {
        fill: "#d90000",
        d: "M0 157.7h640v157.7H0z"
      })
    ]
  })
});
var Cr_default = SvgCr;

// src/country-flag-icons/generated/Cu.tsx
init_esm_shims();
import { jsx as jsx123, jsxs as jsxs98 } from "react/jsx-runtime";
var SvgCu = (props) => /* @__PURE__ */ jsxs98("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx123("defs", {
      children: /* @__PURE__ */ jsx123("clipPath", {
        id: "cu_svg__a",
        children: /* @__PURE__ */ jsx123("path", {
          fillOpacity: 0.7,
          d: "M-32 0h682.7v512H-32z"
        })
      })
    }),
    /* @__PURE__ */ jsxs98("g", {
      fillRule: "evenodd",
      clipPath: "url(#cu_svg__a)",
      transform: "translate(30) scale(.94)",
      children: [
        /* @__PURE__ */ jsx123("path", {
          fill: "#002a8f",
          d: "M-32 0h768v512H-32z"
        }),
        /* @__PURE__ */ jsx123("path", {
          fill: "#fff",
          d: "M-32 102.4h768v102.4H-32zm0 204.8h768v102.4H-32z"
        }),
        /* @__PURE__ */ jsx123("path", {
          fill: "#cb1515",
          d: "m-32 0 440.7 255.7L-32 511z"
        }),
        /* @__PURE__ */ jsx123("path", {
          fill: "#fff",
          d: "M161.8 325.5 114.3 290l-47.2 35.8 17.6-58.1-47.2-36 58.3-.4 18.1-58 18.5 57.8 58.3.1-46.9 36.3z"
        })
      ]
    })
  ]
});
var Cu_default = SvgCu;

// src/country-flag-icons/generated/Cv.tsx
init_esm_shims();
import { jsx as jsx124, jsxs as jsxs99 } from "react/jsx-runtime";
var SvgCv = (props) => /* @__PURE__ */ jsxs99("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx124("defs", {
      children: /* @__PURE__ */ jsx124("clipPath", {
        id: "cv_svg__a",
        children: /* @__PURE__ */ jsx124("path", {
          fillOpacity: 0.7,
          d: "M-123.4 0h682.6v512h-682.6z"
        })
      })
    }),
    /* @__PURE__ */ jsxs99("g", {
      fillRule: "evenodd",
      clipPath: "url(#cv_svg__a)",
      transform: "translate(115.7) scale(.94)",
      children: [
        /* @__PURE__ */ jsx124("path", {
          fill: "#fff",
          d: "M-123.4 233H723v206h-846.5z"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#081873",
          d: "M-122.8 0h846v256.6h-846zm.3 385.9h852.1V512h-852.1z"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#de3929",
          d: "M-122.5 302.6h846v39.6h-846z"
        }),
        /* @__PURE__ */ jsx124("path", {
          fill: "#ffce08",
          d: "m131 399.2 6.6 20.4H159l-17.4 12.7 6.6 20.5L131 440l-17.4 12.7 6.7-20.5-17.4-12.7h21.5M317 250.4l6.7 20.5H345l-17.4 12.6 6.6 20.5-17.4-12.7-17.4 12.7 6.6-20.5-17.4-12.6h21.6m-222 64.4 6.6 20.5h21.5L99 368.6l6.7 20.4-17.4-12.6L70.9 389l6.6-20.4-17.4-12.7h21.5M317 329.5l6.7 20.4H345l-17.4 12.7 6.6 20.4-17.4-12.6-17.4 12.7 6.6-20.5-17.4-12.7h21.6m-40.5-161.7 6.7 20.4H298l-17.4 12.7 6.6 20.5-17.4-12.7-17.4 12.7 6.7-20.5-17.5-12.7h21.6m-64.5-45.2 6.7 20.5h21.5l-17.4 12.6 6.6 20.5-17.4-12.6-17.4 12.6 6.7-20.5-17.4-12.6H192m-64.5 2.9 6.7 20.5h21.5l-17.4 12.6 6.7 20.5-17.5-12.7-17.4 12.7 6.7-20.5-17.4-12.6H121m-34.8 43.2 6.6 20.5h21.6l-17.5 12.6 6.7 20.5-17.4-12.7-17.4 12.7 6.6-20.5L58 271h21.5m119.2 149.4 6.7 20.5h21.5l-17.4 12.6 6.7 20.5-17.5-12.7-17.4 12.7 6.7-20.5-17.4-12.6H192m82.2-41.7 6.6 20.4h21.5L285 432.3l6.7 20.5-17.4-12.7-17.5 12.7 6.7-20.5-17.4-12.7h21.5"
        })
      ]
    })
  ]
});
var Cv_default = SvgCv;

// src/country-flag-icons/generated/Cw.tsx
init_esm_shims();
import { jsx as jsx125, jsxs as jsxs100 } from "react/jsx-runtime";
var SvgCw = (props) => /* @__PURE__ */ jsxs100("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsxs100("defs", {
      children: [
        /* @__PURE__ */ jsx125("clipPath", {
          id: "cw_svg__a",
          children: /* @__PURE__ */ jsx125("path", {
            fillOpacity: 0.7,
            d: "M0 0h682.7v512H0z"
          })
        }),
        /* @__PURE__ */ jsx125("path", {
          id: "cw_svg__b",
          d: "m0-1 .2.7H1L.3 0l.2.7L0 .4l-.6.4.2-.7-.5-.4h.7z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs100("g", {
      clipPath: "url(#cw_svg__a)",
      transform: "scale(.94)",
      children: [
        /* @__PURE__ */ jsx125("path", {
          fill: "#002b7f",
          d: "M0 0h768v512H0z"
        }),
        /* @__PURE__ */ jsx125("path", {
          fill: "#f9e814",
          d: "M0 320h768v64H0z"
        }),
        /* @__PURE__ */ jsx125("use", {
          xlinkHref: "#cw_svg__b",
          width: 13500,
          height: 9e3,
          x: 2,
          y: 2,
          fill: "#fff",
          transform: "scale(42.67)"
        }),
        /* @__PURE__ */ jsx125("use", {
          xlinkHref: "#cw_svg__b",
          width: 13500,
          height: 9e3,
          x: 3,
          y: 3,
          fill: "#fff",
          transform: "scale(56.9)"
        })
      ]
    })
  ]
});
var Cw_default = SvgCw;

// src/country-flag-icons/generated/Cx.tsx
init_esm_shims();
import { jsx as jsx126, jsxs as jsxs101 } from "react/jsx-runtime";
var SvgCx = (props) => /* @__PURE__ */ jsxs101("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx126("path", {
      fill: "#0021ad",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx126("path", {
      fill: "#1c8a42",
      d: "M0 0h640v480z"
    }),
    /* @__PURE__ */ jsx126("circle", {
      cx: 320,
      cy: 240,
      r: 57.8,
      fill: "#ffc639"
    }),
    /* @__PURE__ */ jsx126("path", {
      fill: "#1c8a42",
      d: "M284.7 214c4 5.5 10 14.6 14.8 12.2 3.7 0 5.7.3 6.2 2.8a37 37 0 0 0 33-14.3s.8 0 .5-4.5c0-2 2.8-1.6 2.8-1 .4 1 .4 1.7.9 1.8 1-.4 2.7-3 4-4.6.3-.7.1-1.5.2-2.4.7-1.7 2.4-1.3 2.8-.4l.6 1.6c1.8 1.2 5 0 5.2 0 .3-1.4 1.2-1.2 1.2-1.2 1.2-.3.7-.2 1.5.2-.7 7.7 1.5 8 1.3 12 .1 4.4-1.3 5.6-1.3 7.3.4 2 7 2.1 4.6 3.9-2 1 0 3-3 3.8-8.8 4.5-10.4 8.3-10.4 8.3s-2.2 4.2-2.5 4.2c-1.5 2.8-3.3 1.2-4.4 2.6-.5 1.7-1 5.5 0 7.4.5 2.7 0 4.2-.7 6.9-.6 5.6-2.8 6.5-3.1 8.4-1 2.2.2 12-.8 12-6.5.2-11.5-1.2-14.1-1.7 2.5-10.9 1.5-20.4 1.5-21.4-.6-7.8-11.6-5.9-13.3-7-1.4-.2-2.3-1.3-2.7-1.8-1.6-.2-2.2-.6-3.7-.7-.8.4-.3.8-2 1.3-4.5.5-6.4-3.8-6.4-3.8.2-1.5-9.9.3-15.3-1-2.3 1.3-3.3 5-5.1 5.4 0 1.1-3-1-3.6-2-.2-3.4 2.8-4.8 2.8-4.8 2.4-1.7 3.8-2 5-3.1.5-2.9.2-5 1.5-7.1 1-1.7 2.5-1 3.5-1.6 1.1-.8 1.6-5.6.6-7l-4.7-4.2c-1.4-4.1 1.7-6.8 2.6-6.5"
    }),
    /* @__PURE__ */ jsx126("path", {
      fill: "#ffc639",
      d: "M561.9 142.4c-2.6-10.3-26-32.7-43.7-46.9-4.2-2.8-7-1.1-6.4 3 2.2 3.6 3.8 7.6 6 11.3.6 2.5 1.8 4.2 2.4 6.6 0 0 .2 4.2.6 4.6 5.4 6 6.2 11.1 6.2 11.1a49 49 0 0 0 11.5 15.6c6.2 3.9 1.6 16 1.8 22.5 0 4-2.9 3.6-5.5 3-20.1-18.5-40.1-18.5-57.8-23.9-6.8-.7-7 2.6-4.7 4.4a129 129 0 0 0 39.1 29.6l7.7 4.8 8.8 7.3c6.8 4.4 7.3 8.4 7.3 8.8.2 8.2-4.2 14.6-5.5 17.2-2.3 8.7-7 10.2-7 10.2-37.6 25.4-57.4 32-118.4 24.1-1-.4-6.8.5 0 3 15.5 5.2 53.7 13.5 90.6-4 9-6.2 14.8-4.2 21.3-8a287.3 287.3 0 0 1 28.3-15.4c8.3-4.5 31.3-9.4 36.6-13.8 6.1-.5 12.4-1.3 12.8-6.5 2-1.3 5-.3 7.2-4.6 4.8-.9 4-2.6 4-2.6-1.2-3.4-5.8-4.8-9-7.3-4.8-1.6-8-2-11.5-.4l-3.3 1.5s-5.1-.7-5.1-1.1c-11.4-.6-10.3-38.3-14.3-54z"
    }),
    /* @__PURE__ */ jsx126("path", {
      fill: "#1c8a42",
      d: "M588.6 204.2a2.8 1.8 16 1 1-5.4-1.7 2.8 1.8 16 0 1 5.4 1.7"
    }),
    /* @__PURE__ */ jsxs101("g", {
      fill: "#fff",
      transform: "matrix(.64 0 0 .64 0 80)",
      children: [
        /* @__PURE__ */ jsx126("path", {
          id: "cx_svg__a",
          d: "m188.2 191-12.8-12-12.9 11.8 1.4-17.4-17.3-2.8 14.5-9.8-8.6-15.2 16.7 5.3 6.5-16.2L182 151l16.7-5-8.8 15 14.4 10-17.3 2.5z"
        }),
        /* @__PURE__ */ jsx126("path", {
          d: "m233.4 335.5-13.8-9.1-13.4 9.6 4.8-15.5-13.6-9.5 16.6-.4 5-15.5 5.6 15.3 16.7-.1L228 320l5.3 15.4z"
        }),
        /* @__PURE__ */ jsx126("use", {
          xlinkHref: "#cx_svg__a",
          width: "100%",
          height: "100%",
          x: 2.5,
          y: 269.1
        }),
        /* @__PURE__ */ jsx126("use", {
          xlinkHref: "#cx_svg__a",
          width: "100%",
          height: "100%",
          x: -112.1,
          y: 123.2
        }),
        /* @__PURE__ */ jsx126("use", {
          xlinkHref: "#cx_svg__a",
          width: "100%",
          height: "100%",
          x: 108.4,
          y: 85
        })
      ]
    })
  ]
});
var Cx_default = SvgCx;

// src/country-flag-icons/generated/Cy.tsx
init_esm_shims();
import { jsx as jsx127, jsxs as jsxs102 } from "react/jsx-runtime";
var SvgCy = (props) => /* @__PURE__ */ jsxs102("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx127("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx127("path", {
      id: "cy_svg__a",
      fill: "#435125",
      d: "M307.8 398.6a.8.8 0 0 1-.2-.2h-.1l-1.3-1.4-3.8-4.5-4.9-6.3-.6-.9-6.2-1.9-4.6-2.1 2.4-2.7 8.4 3.5 6.2 1.3 11.5 8.5-3.3 2.9a37.2 37.2 0 0 0-3.3 3.5l.7-.5.8.6zm-42.6-12.8a31.7 31.7 0 0 1-16-4.5s.7-1.3 2.3-2.4c1.6-1.2 4.4-2.5 9-2.6 5.4 0 12 1.9 19.5 5.4a28.8 28.8 0 0 1-14.8 4zm-23.5-5.2c-1 0-2-.4-2.6-1a5.2 5.2 0 0 1-1.1-2.4 11.7 11.7 0 0 1-.3-3.4 3.5 3.5 0 0 1 1.3-.2c2 0 3.6 1.7 4.3 3.4.4 1 .5 1.8.2 2.5-.2.6-1 1-1.8 1zm41.3-4.8c-13.9-2-19.8-7-22.3-10.9-2.6-4.1-2-8-2-8s.8-.2 2-.2c3.8 0 13.2 1.9 22.3 19zm-28.5-2.8c-5.9 0-10.4-1-13.4-3a8.3 8.3 0 0 1-3-3.3 5.4 5.4 0 0 1-.4-1.6 18.2 18.2 0 0 1 7.2-1.4 27 27 0 0 1 18.9 8.7c-3.4.4-6.5.6-9.3.6m-28.7-1c-6.2 0-14.8-2-20.2-7.3 0 0 5.9-1.5 12.4-1.7h1.2c5.9 0 10.4 1.1 13.4 3.4 1 .8 1.6 1.5 1.7 2.2.1.6-.2 1.2-.8 1.7-1.4 1-3.8 1.6-7.2 1.6h-.5zm-20.3-10.5a2.6 2.6 0 0 1-2-1 4.7 4.7 0 0 1-.8-2c-.3-1.4-.2-2.8-.2-2.9a2.4 2.4 0 0 1 1-.2c.9 0 1.6.5 2 1a5.6 5.6 0 0 1 1.4 2c.2.9.3 1.6 0 2.2 0 .4-.6 1-1.3 1zm46.9-1c-1 0-2-.4-2.6-1a5.2 5.2 0 0 1-1.1-2.4 11.7 11.7 0 0 1-.3-3.4 3.5 3.5 0 0 1 1.3-.2c2 0 3.7 1.7 4.3 3.4.4 1 .5 1.8.3 2.5-.3.6-1 1-2 1zm-22.8-1c-12.6-.4-19.2-4-22.4-7a14.6 14.6 0 0 1-3.4-4.3c-.5-1-.7-1.8-.7-2s1.2-.4 3-.4h.4c4.2 0 12.9 1.8 23 13.7zm13.6-1.2a30.8 30.8 0 0 1-18.9-9.3 19.4 19.4 0 0 1-4.1-7s1.2-.3 3-.4a14.2 14.2 0 0 1 1 0c5 .1 14.3 2.4 19 16.7m-52-5a42 42 0 0 1-9.5-1c-5.3-1.4-7.6-3.4-8.6-4.9a5 5 0 0 1-.8-2 3.4 3.4 0 0 1 0-.8s3.5-1 8.4-1.1a35 35 0 0 1 7.4.6 21.7 21.7 0 0 1 12.8 8.1s-4 1.2-9.7 1.2zm23.5-8.4a3.4 3.4 0 0 1-2.5-1 5.2 5.2 0 0 1-1.1-2.4c-.4-1.6-.3-3.2-.3-3.4a3.5 3.5 0 0 1 1.2-.3h.1c2 0 3.6 1.8 4.3 3.5.4 1 .4 1.8.2 2.4-.3.7-1 1.1-1.9 1.1zm-17.6-2.5a38.6 38.6 0 0 1-9.6-4.2c-4.4-2.7-9.9-7.5-10.5-15l1-.1h.3c1.3 0 4 .3 7.3 2.8 4.2 3.2 8 8.8 11.5 16.5m11.5-.4a31.2 31.2 0 0 1-7.6-4.9 48.5 48.5 0 0 1-13.3-18.6s.9-.5 2.3-.6a3.3 3.3 0 0 1 .2 0h.4c2 0 4.9.9 8.1 4.4 3.8 4 7.1 10.6 10 19.7zm-29.9-.9c-3.9 0-5.2-2-5.6-3a6 6 0 0 1-.4-3 8.5 8.5 0 0 1 2-.2 8 8 0 0 1 6.5 3c.2.4.8 1.4.3 2.3-.4.6-1.3 1-2.8 1zm-8.5-10.8a51.1 51.1 0 0 1-9-.7c-3.4-.6-5.3-3.5-6.4-5.9-1-2.5-1.4-5-1.4-5 10.6.3 15.7 3.4 18 6a9.4 9.4 0 0 1 2.6 5.5s-1.6.2-3.8.2zm11-11a42.7 42.7 0 0 1-2.4-3.4c-1.3-2-2.4-4-2.4-5.6 0-1.7-.4-5-.6-7l-.6-4.5c.3 0 6.6 2.4 6.6 8.4s-.6 12-.6 12zm-8.2-.6h-.2a43.7 43.7 0 0 1-18.2-10.8c-1.7-2-2.8-5.2-3.1-9.4-.2-3 0-5.5 0-5.8a3.3 3.3 0 0 1 1.1-.1c1.4 0 3 .6 5 2a39.6 39.6 0 0 1 5.2 4.4c3.2 3.2 5.7 6.4 5.7 6.4.3.4 2 3.7 3.5 6.9a22 22 0 0 1 1.6 4.6c.1.6.2 1 0 1.4a.7.7 0 0 1-.3.4.9.9 0 0 1-.4 0z"
    }),
    /* @__PURE__ */ jsx127("use", {
      xlinkHref: "#cy_svg__a",
      width: "100%",
      height: "100%",
      transform: "matrix(-1 0 0 1 593.7 0)"
    }),
    /* @__PURE__ */ jsx127("path", {
      fill: "#d47600",
      d: "m519 76.4-1.8.7-.8.3-2.2-.1-2.2 1-3.8 2.6-.1.1-1.5.4-1.3-.6-.7.4-.3 1.5-.7 1.1-.9.6-3 .3-2.5 1.4-3.4-1-1.5.7-3.3 3-1.7.7h-.5l-2.3-.1-.9.3-1.4 1.3-2.6.2-.9.6-1.3 2.6L476 96l-.8.1-.8-.3-.7.1-.3 1.7-.6.7-1.8.6-1.4 1.2-1.3.6h-2l-1.7 1-3.1.2-1.3 1.2-.3.3-.6.3-1 .6-.2.2-1.2-.2-1.4.5-.6-.8-1 .5-1.2.1-1.6-.7-1.3-.6-.9.2-.3 1.5v.2l-1 1.2-1.7 1.1-.2.3-2 2.6-3.8 4-3.2 1.6-3.3 1-2.3 1.9-6 3-9.7 4.8-2 .6-2.8.4-5 1.9-4.4 1.3-.3.1-.8.3-6.3 1.9-2.9-.4-1.7.7-4.5-.5h-3.1l-2 .4-3.7 1.8-6.3 3-2 2-3.2 1.6-3.8 1.2v-1.6l-1.3.4-1 .3-3 .4h-1.7l-1.1-.3h-.2l-6.2 2.1-7 .7-3.5 1.1H333l-1.6.5-3.2.4-1.2-.3-.2-.1-9.4.4-4.3-.5-2 .5-3.5-1.2-5-.6-1.2-.3-2.6-.8-1.2.7-1 .1-2-.8h-.8l-1.8.6-1-.2-1-.8-2.1-.3-1.4-1.1-7.5 1-2-.6-6.9-2h-1l-1.4 1-2 .8-1.9.4-2.4.1-2.8-.7-2.8-1.4-1.1-.3-2.4.3h-.7l-4.4-2.3-5.6-3.5-3.8-1.9-1.5-.2-.2.7.7 2.2.3 2.3v2l-.1 1.3.3 1.1 1.4 1.6.6 1.5.4 4.2v4.3l-.7 6.8-.2 1-.8 3.6-.7 3.3-2.9 8.7-.7 1-2 1.3-4.3 3-3.2 1.8-1 .4-2.6.2H219l-2-1.1-2-.5-2.6-1.9-2.8-.6-3.2-1.8-.8-1-1.7-.2-2.4-.7-.9-.3-.6-.1-3-.1-2.9-1.3-1.5-.4h-2l-2.1 1-1.1.4-1.4-.5h-1l-1 1.7-.2.3-.8.4h-1.7l-.8.3-1.1.5-1 .4-.5.2h-.3l-.5.2h-.6l-1.2-.6-.6-.3-1-.2-.5.3-.1 1.9-.5 1.1-1.6 1.4-1.6 1.4-1 1.6-3 6.7-1.9 2.7-.5.7-2 2.1-1.7 1.3-3.9 3-3.7 1.5-3.2.6h-1.6l-3-.4-2.6-.8-3-1.8-3.1-2.6-4.7-4.5-.6-.4-.2-.1-1.4-1h-1.1l-.4.8-.3 1-.2.9-.5 5v.3l.3 2.1 3.6 5 1 2.6.2.3.7 1.2.6 1 1.3 3.6-.9 2 .4 1.4-1 .8-.2 1.2 3.1 4 .7 1.7-.7 2.4-1.3 1.4-.3.3.2 1 1.4 1.4 2.5 2.2 1.3 3.2 1 1 1.2-.3.6.5h1l1 1 .6.2 1 .5.8 1 .1 3.2 1.5 3.8v2.5l1 1.5.2 1.2-.5 3.3 1.2 1 1.2-.2.8.1 1.3 1.1 1.6 2.4 1.6-.2 1 .4 4.7 4.3 1 .6.9.4 1 1 1.4-1h.2l1.6-.2.7.5 1.4.9h1.7l4 1.2 1.6.4 3.4 2.1 1.5.9.8.7 1.2 1 2.2 1 2 .4 1 .2.9.3 4.2 1.7 2.3.5 2 .8 1.6.5h1.2l1.6-1.3h1.5l1.3.2 1.3-.2 2-1.2.3-.6 1.4-.6 4.8-.6 1.4.4 3.6-1.5 2.4.6 2-.7 4.7 1 1.2.9 1.4 1.5h1.7l-.7 1.1 2 2.2 1.9 2.7.1.4 1.3 3.9 1 1.4.7 1.9v1.2l-1 .9-.2.4v.2l.2.5.4-.2.7-.4 1-.2 1.6.2 1.1.1 1.7-.8 1.2-.6 1.8.8h2l.9.3 2.4 1.1 1.2.1.4-.3.3-.6-.1-.8-1-1.1-2-2.4-.8-1.2-.6-1.7-.2-2.2-.2-1.5.3-2 .5-.7.4-1.6.1-.4 1.2-1.5 3-2 3.2-2.8 2.5-1.7 2.6-1.1v-.3l.4.1 6.6-2.3 3-.5 20 1.4.7-.2.7-1.9.3-.3.3-.2 2.2-1 1-.2 2.8.7 1.2.3 1.9-1h1.3l2.7-1.5h1.7l.7-.2 3.3-2.4 3.1-.9.8-.4.3-.2 3.3-1.7 2-1.6 1.8-1 2-.4 5-.4 1.1-1.7 2.2-.3 1.3-1.5 1.5-.6 1.1-1.6 1-1.3 1.2-.7 4.1-.3 4.8.6.7-.4 1-3.9 1.2-.7 3-4.5v-1.6l.1-1.4.5-2-.3-3.4.4-3.6 1.9-4.5 1.7-1.8 2.7-1.9 1.4-.6 2-.3h.2l.5-.2h9.2l2.3-.1 5.7 1h.4l1.9.7 2.2 1.7 2.4 2.3.4.4 1.5.7.5.2 1.2-.2 1.8-1 1.4-1 1.8-1v-.2l1.1-1.5.4-.7 3.6-1.4 4.2-.2.5-.3h.2l1.1-1.4h1l2.6 1 1.7-.4 1.4.5 1.1-.1 2-.3 2.3 1.6 1.3.2 4.5 2.6h.4l.2.1.5-.2.8-.2h.1l.1.1.6.7.7.1.8-1-.3-.6-.1-.2-1.7-.3-1.4-2.5 1.4-1.5-2.2-2.6-.4-.5v-.1l-.8-1.2-3.8-5.8-5-4-1.7-1.3-.6-.5-2.7-2.7-1.9-2.5-.2-.5-.4-.9-1.1-2.4-2-1.5-1.6-1.8-3.4-4.6-.5-.7-.8-.5h-1.7l-.1-.2h-.1v-.1l.8-.8 1-.2.3-.9-1.7-4.9v-.2l-.1-1.5 1.3-7.1.2-.9 2.4-4.7 1.4-1.2 1.6-3.1 1.4-2 1.3-1.3.2-.1 2.3-1.4 2-.3 1.9-.3 3.3 1h3l.7-.1 1.4-.2 2.3-.7 1.1-.7.6-.8 1.2-4 .4-1.3.7-1.4 4.3-4.9 3.2-3 7.2-5.2 3.5-2.1 1.8-1.1 16.1-7.2 4.2-4.2 2.2-2.2 3.8-2.6 4.5-1.9 4-3 .8-1.1 1-3.5 1-.2.7-1.7.3-.5 3.1-2.2.4-.2 12.3-6.2 1.8.3 1-1.5 3.5-.6h.7l.9-.5.7-1.3v-.3l.1-3.4.8-.9.4-2.2.4-.6.4-.5 1-.7z"
    })
  ]
});
var Cy_default = SvgCy;

// src/country-flag-icons/generated/Cz.tsx
init_esm_shims();
import { jsx as jsx128, jsxs as jsxs103 } from "react/jsx-runtime";
var SvgCz = (props) => /* @__PURE__ */ jsxs103("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx128("path", {
      fill: "#fff",
      d: "M0 0h640v240H0z"
    }),
    /* @__PURE__ */ jsx128("path", {
      fill: "#d7141a",
      d: "M0 240h640v240H0z"
    }),
    /* @__PURE__ */ jsx128("path", {
      fill: "#11457e",
      d: "M360 240 0 0v480z"
    })
  ]
});
var Cz_default = SvgCz;

// src/country-flag-icons/generated/De.tsx
init_esm_shims();
import { jsx as jsx129, jsxs as jsxs104 } from "react/jsx-runtime";
var SvgDe = (props) => /* @__PURE__ */ jsxs104("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx129("path", {
      fill: "#fc0",
      d: "M0 320h640v160H0z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "#000001",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsx129("path", {
      fill: "red",
      d: "M0 160h640v160H0z"
    })
  ]
});
var De_default = SvgDe;

// src/country-flag-icons/generated/Dj.tsx
init_esm_shims();
import { jsx as jsx130, jsxs as jsxs105 } from "react/jsx-runtime";
var SvgDj = (props) => /* @__PURE__ */ jsxs105("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx130("defs", {
      children: /* @__PURE__ */ jsx130("clipPath", {
        id: "dj_svg__a",
        children: /* @__PURE__ */ jsx130("path", {
          fillOpacity: 0.7,
          d: "M-40 0h682.7v512H-40z"
        })
      })
    }),
    /* @__PURE__ */ jsxs105("g", {
      fillRule: "evenodd",
      clipPath: "url(#dj_svg__a)",
      transform: "translate(37.5) scale(.94)",
      children: [
        /* @__PURE__ */ jsx130("path", {
          fill: "#0c0",
          d: "M-40 0h768v512H-40z"
        }),
        /* @__PURE__ */ jsx130("path", {
          fill: "#69f",
          d: "M-40 0h768v256H-40z"
        }),
        /* @__PURE__ */ jsx130("path", {
          fill: "#fffefe",
          d: "m-40 0 382.7 255.7L-40 511z"
        }),
        /* @__PURE__ */ jsx130("path", {
          fill: "red",
          d: "M119.8 292 89 270l-30.7 22.4L69.7 256l-30.6-22.5 37.9-.3 11.7-36.3 12 36.2h37.9l-30.5 22.7 11.7 36.4z"
        })
      ]
    })
  ]
});
var Dj_default = SvgDj;

// src/country-flag-icons/generated/Dk.tsx
init_esm_shims();
import { jsx as jsx131, jsxs as jsxs106 } from "react/jsx-runtime";
var SvgDk = (props) => /* @__PURE__ */ jsxs106("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx131("path", {
      fill: "#c8102e",
      d: "M0 0h640.1v480H0z"
    }),
    /* @__PURE__ */ jsx131("path", {
      fill: "#fff",
      d: "M205.7 0h68.6v480h-68.6z"
    }),
    /* @__PURE__ */ jsx131("path", {
      fill: "#fff",
      d: "M0 205.7h640.1v68.6H0z"
    })
  ]
});
var Dk_default = SvgDk;

// src/country-flag-icons/generated/Dm.tsx
init_esm_shims();
import { jsx as jsx132, jsxs as jsxs107 } from "react/jsx-runtime";
var SvgDm = (props) => /* @__PURE__ */ jsxs107("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx132("defs", {
      children: /* @__PURE__ */ jsx132("clipPath", {
        id: "dm_svg__a",
        children: /* @__PURE__ */ jsx132("path", {
          fillOpacity: 0.7,
          d: "M-85 0h682.7v512H-85z"
        })
      })
    }),
    /* @__PURE__ */ jsxs107("g", {
      fillRule: "evenodd",
      clipPath: "url(#dm_svg__a)",
      transform: "translate(79.7) scale(.94)",
      children: [
        /* @__PURE__ */ jsx132("path", {
          fill: "#108c00",
          d: "M-258.3 0H769.2v512H-258.3z"
        }),
        /* @__PURE__ */ jsx132("path", {
          fill: "#ffd600",
          d: "M-260 178.2H772.6v50.1H-260z"
        }),
        /* @__PURE__ */ jsx132("path", {
          fill: "#ffd600",
          d: "M181 0h48.5v512h-48.4z"
        }),
        /* @__PURE__ */ jsx132("path", {
          fill: "#000001",
          d: "M227.8 0h48.4v512h-48.4z"
        }),
        /* @__PURE__ */ jsx132("path", {
          fill: "#000001",
          d: "M-260 226.6H772.6v50.2H-260z"
        }),
        /* @__PURE__ */ jsx132("path", {
          fill: "#fff",
          d: "M-260 276.8H772.6v50.1H-260z"
        }),
        /* @__PURE__ */ jsx132("path", {
          fill: "#fff",
          d: "M276.2 0h48.5v512h-48.5z"
        }),
        /* @__PURE__ */ jsx132("rect", {
          width: 273.8,
          height: 275,
          x: -394.6,
          y: -393.9,
          fill: "#e72910",
          ry: 137.5,
          transform: "scale(-1)"
        }),
        /* @__PURE__ */ jsxs107("g", {
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx132("path", {
              d: "m250.5 137 5.6-16 5.1 15.7s17.1.5 17.1.2-13.5 10.3-13.5 10.3l6.1 17.6c-.2-.5-14.8-10.9-14.8-10.9s-14.8 10.4-14.5 10.4 5.6-17 5.6-17l-13.3-10.1 16.6-.3z"
            }),
            /* @__PURE__ */ jsx132("path", {
              fill: "#ffe700",
              d: "M251.3 137.7 256 124l4.4 13.6s14.9.4 14.9.2-11.7 9-11.7 9l5.2 15.2c-.2-.5-12.8-9.4-12.8-9.4s-12.8 9-12.6 9 5-14.8 5-14.8l-11.6-8.8 14.4-.2z"
            }),
            /* @__PURE__ */ jsx132("path", {
              fill: "#108c00",
              d: "m253.3 140 2.8-8 2.6 7.9s8.5.2 8.5 0-6.7 5.2-6.7 5.2l3 8.8c-.1-.3-7.4-5.4-7.4-5.4l-7.2 5.2c.2 0 2.8-8.5 2.8-8.5l-6.6-5z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs107("g", {
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx132("path", {
              d: "m356.9 211.8 5.6-16 5 15.7s17.2.6 17.2.3-13.5 10.3-13.5 10.3l6 17.6c-.2-.5-14.7-10.9-14.7-10.9s-14.8 10.4-14.5 10.4 5.6-17 5.6-17L340.3 212l16.6-.3z"
            }),
            /* @__PURE__ */ jsx132("path", {
              fill: "#ffe700",
              d: "m357.6 212.6 4.9-13.9 4.4 13.7s14.8.4 14.8.2-11.7 9-11.7 9l5.3 15.1c-.2-.4-12.8-9.4-12.8-9.4s-12.8 9-12.6 9 4.9-14.8 4.9-14.8l-11.5-8.7z"
            }),
            /* @__PURE__ */ jsx132("path", {
              fill: "#108c00",
              d: "m359.7 214.9 2.8-8 2.5 7.8 8.6.2-6.8 5.1s3.2 9 3 8.8c0-.3-7.3-5.4-7.3-5.4l-7.3 5.1 2.8-8.5-6.6-5z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs107("g", {
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx132("path", {
              d: "m325.9 330.6 5.6-16 5 15.8s17.2.5 17.2.3-13.5 10.3-13.5 10.3l6 17.5c-.2-.5-14.7-10.8-14.7-10.8S316.7 358 316.9 358s5.7-17 5.7-17l-13.3-10z"
            }),
            /* @__PURE__ */ jsx132("path", {
              fill: "#ffe700",
              d: "m326.6 331.4 4.9-13.8 4.4 13.6s14.8.5 14.8.2-11.7 9-11.7 9l5.3 15.2c-.2-.5-12.8-9.4-12.8-9.4s-12.8 9-12.6 9 4.9-14.8 4.9-14.8l-11.5-8.7z"
            }),
            /* @__PURE__ */ jsx132("path", {
              fill: "#108c00",
              d: "m328.7 333.7 2.8-8 2.5 7.9s8.6.3 8.6.1-6.8 5.2-6.8 5.2l3 8.7c0-.2-7.3-5.4-7.3-5.4l-7.3 5.2 2.8-8.5-6.6-5z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs107("g", {
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx132("path", {
              d: "m177.2 330.6 5.6-16 5 15.8s17.1.5 17.1.3-13.5 10.3-13.5 10.3l6.2 17.5c-.3-.5-14.8-10.8-14.8-10.8S168 358 168.2 358s5.7-17 5.7-17l-13.3-10z"
            }),
            /* @__PURE__ */ jsx132("path", {
              fill: "#ffe700",
              d: "m178 331.4 4.8-13.8 4.4 13.6s14.8.5 14.8.2-11.7 9-11.7 9l5.3 15.2c-.2-.5-12.8-9.4-12.8-9.4s-12.8 9-12.6 9 4.9-14.8 4.9-14.8l-11.5-8.7z"
            }),
            /* @__PURE__ */ jsx132("path", {
              fill: "#108c00",
              d: "m180 333.7 2.8-8 2.5 7.9s8.6.3 8.6.1-6.8 5.2-6.8 5.2l3 8.7c0-.2-7.3-5.4-7.3-5.4l-7.3 5.2 2.8-8.5-6.6-5z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs107("g", {
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx132("path", {
              d: "m150 208.7 5.6-16 5.1 15.8s17.1.5 17.1.2-13.5 10.4-13.5 10.4l6.1 17.5c-.3-.5-14.8-10.8-14.8-10.8S140.8 236 141.1 236s5.6-17 5.6-17l-13.3-10z"
            }),
            /* @__PURE__ */ jsx132("path", {
              fill: "#ffe700",
              d: "m150.8 209.5 4.8-13.8 4.5 13.6s14.7.5 14.7.2-11.7 9-11.7 9l5.3 15.2c-.2-.5-12.8-9.4-12.8-9.4s-12.8 9-12.5 9 4.8-14.8 4.8-14.8l-11.5-8.7z"
            }),
            /* @__PURE__ */ jsx132("path", {
              fill: "#108c00",
              d: "m152.8 211.8 2.8-8 2.6 7.9 8.5.1-6.7 5.2 3 8.7c-.1-.2-7.4-5.4-7.4-5.4l-7.2 5.2c.2 0 2.8-8.5 2.8-8.5l-6.6-5z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs107("g", {
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx132("path", {
              d: "m324.6 174.1-5.6 16-5-15.7s-17.2-.5-17.2-.3 13.5-10.3 13.5-10.3l-6-17.5c.2.5 14.7 10.8 14.7 10.8s14.8-10.3 14.5-10.3-5.6 17-5.6 17l13.3 10z"
            }),
            /* @__PURE__ */ jsx132("path", {
              fill: "#ffe700",
              d: "M323.9 173.3c0 .3-5 13.9-5 13.9l-4.3-13.6s-14.8-.5-14.8-.3 11.7-8.9 11.7-8.9l-5.3-15.2c.2.5 12.8 9.4 12.8 9.4s12.8-9 12.6-9-4.9 14.8-4.9 14.8l11.5 8.7z"
            }),
            /* @__PURE__ */ jsx132("path", {
              fill: "#108c00",
              d: "m321.8 171-2.8 8-2.5-7.8s-8.6-.3-8.6-.1 6.8-5.2 6.8-5.2l-3-8.7c0 .2 7.3 5.4 7.3 5.4l7.3-5.2c-.2 0-2.9 8.5-2.9 8.5l6.7 5-8.3.2z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs107("g", {
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx132("path", {
              d: "m367.3 290.3-5.6 16-5-15.8s-17.2-.5-17.2-.2S353 280 353 280l-6-17.6c.2.5 14.7 10.8 14.7 10.8s14.8-10.3 14.5-10.3-5.6 17-5.6 17L384 290z"
            }),
            /* @__PURE__ */ jsx132("path", {
              fill: "#ffe700",
              d: "m366.6 289.5-4.9 13.8-4.4-13.6s-14.8-.4-14.8-.2 11.7-9 11.7-9l-5.3-15.2c.2.5 12.8 9.4 12.8 9.4s12.8-9 12.6-9-4.9 14.8-4.9 14.8l11.5 8.8z"
            }),
            /* @__PURE__ */ jsx132("path", {
              fill: "#108c00",
              d: "m364.5 287.2-2.8 8-2.5-7.9s-8.6-.2-8.6 0 6.8-5.2 6.8-5.2l-3-8.8c0 .3 7.3 5.4 7.3 5.4l7.3-5.2c-.2 0-2.9 8.6-2.9 8.6l6.7 5z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs107("g", {
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx132("path", {
              d: "m261.4 375.3-5.6 16-5-15.8s-17.2-.5-17.2-.3 13.5-10.3 13.5-10.3l-6-17.5c.2.5 14.7 10.8 14.7 10.8s14.8-10.3 14.5-10.3-5.6 17-5.6 17L278 375z"
            }),
            /* @__PURE__ */ jsx132("path", {
              fill: "#ffe700",
              d: "m260.7 374.4-4.9 14-4.4-13.7s-14.8-.5-14.8-.2 11.7-9 11.7-9l-5.3-15.2c.2.5 12.8 9.4 12.8 9.4s12.8-9 12.6-9-4.9 14.8-4.9 14.8l11.5 8.7-14.3.3z"
            }),
            /* @__PURE__ */ jsx132("path", {
              fill: "#108c00",
              d: "m258.6 372.2-2.8 8-2.5-7.9s-8.6-.3-8.6-.1 6.8-5.2 6.8-5.2l-3-8.7c0 .2 7.3 5.4 7.3 5.4l7.3-5.2-2.8 8.5 6.6 5z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs107("g", {
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx132("path", {
              d: "m162 290.3-5.7 16-5-15.8s-17.2-.5-17.2-.2 13.5-10.3 13.5-10.3l-6-17.6c.2.5 14.7 10.8 14.7 10.8L171 263l-5.7 17 13.3 10.1-16.6.3z"
            }),
            /* @__PURE__ */ jsx132("path", {
              fill: "#ffe700",
              d: "m161.2 289.5-4.9 13.8-4.4-13.6s-14.8-.4-14.8-.2 11.7-9 11.7-9l-5.3-15.2c.2.5 12.8 9.4 12.8 9.4s12.8-9 12.6-9-4.9 14.8-4.9 14.8l11.5 8.8z"
            }),
            /* @__PURE__ */ jsx132("path", {
              fill: "#108c00",
              d: "m159.1 287.2-2.8 8-2.5-7.9s-8.6-.2-8.6 0 6.8-5.2 6.8-5.2l-3-8.8c0 .3 7.3 5.4 7.3 5.4l7.3-5.2-2.8 8.6 6.6 5z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs107("g", {
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx132("path", {
              d: "m198.7 175.8-5.6 16-5.2-15.7s-17-.5-17-.3 13.5-10.3 13.5-10.3l-6.1-17.5c.2.5 14.7 10.8 14.7 10.8s14.8-10.3 14.6-10.3-5.6 17-5.6 17l13.2 10z"
            }),
            /* @__PURE__ */ jsx132("path", {
              fill: "#ffe700",
              d: "m197.9 175-4.9 14-4.4-13.7s-14.8-.5-14.8-.2 11.7-9 11.7-9l-5.3-15.2c.2.5 12.8 9.4 12.8 9.4s12.8-9 12.6-9-4.8 14.8-4.8 14.8l11.4 8.7-14.3.3z"
            }),
            /* @__PURE__ */ jsx132("path", {
              fill: "#108c00",
              d: "m195.8 172.8-2.8 8-2.5-7.9s-8.5-.3-8.5-.1 6.7-5.2 6.7-5.2l-3-8.7c0 .2 7.3 5.4 7.3 5.4l7.3-5.2-2.8 8.5 6.6 5z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs107("g", {
          transform: "matrix(1.04 0 0 1.04 -250.6 359.4)",
          children: [
            /* @__PURE__ */ jsxs107("g", {
              fill: "#009200",
              stroke: "#000",
              strokeWidth: 2.5,
              transform: "matrix(.16 -.02 0 .18 429.8 -215.6)",
              children: [
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 680.2,
                  cy: 586.1,
                  rx: 30.8,
                  ry: 189.8,
                  transform: "matrix(1.4 0 0 1 -534.3 263.7)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 680.2,
                  cy: 586.1,
                  rx: 30.8,
                  ry: 189.8,
                  transform: "matrix(1.5 0 0 1 -547.2 267)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 680.2,
                  cy: 586.1,
                  rx: 30.8,
                  ry: 189.8,
                  transform: "matrix(1.2 0 0 1.1 -365 214.1)"
                })
              ]
            }),
            /* @__PURE__ */ jsxs107("g", {
              stroke: "#000",
              transform: "translate(72.9 -9.8)",
              children: [
                /* @__PURE__ */ jsx132("path", {
                  fill: "#a95600",
                  strokeWidth: 0.5,
                  d: "M388.5-53c6-.3 3.4-3.3 6.4-5 3-1.6 7.3-.6 8.6 1.4 1.3 2 .3 4 2 4s47-2.5 48.6-.9c1.6 1.7 2 5 .3 6.3-1.6 1.4-58.9 3-60.9 1.6s-5-7-5-7.4z"
                }),
                /* @__PURE__ */ jsx132("path", {
                  fill: "#ff0",
                  strokeWidth: 3.9,
                  d: "M529.6 405.5c0 40 45.6 27.8 46.8 61.2-.7 35.4-76.7 3.5-78.6-61.2 1.9-64.8 75-98 76.7-61 1.2 30.6-45 21-45 61z",
                  transform: "matrix(.15 0 0 .1 340.4 -81.7)"
                }),
                /* @__PURE__ */ jsx132("path", {
                  fill: "#ff0",
                  strokeWidth: 3.9,
                  d: "M529.6 405.5c0 40 45.6 27.8 46.8 61.2-.7 35.4-76.7 3.5-78.6-61.2 1.9-64.8 75-98 76.7-61 1.2 30.6-45 21-45 61z",
                  transform: "matrix(.15 0 0 .1 344.4 -81.6)"
                }),
                /* @__PURE__ */ jsx132("path", {
                  fill: "#ff0",
                  strokeWidth: 3.9,
                  d: "M529.6 405.5c0 40 45.6 27.8 46.8 61.2-.7 35.4-76.7 3.5-78.6-61.2 1.9-64.8 75-98 76.7-61 1.2 30.6-45 21-45 61z",
                  transform: "matrix(.15 0 0 .1 348.7 -81.8)"
                }),
                /* @__PURE__ */ jsx132("path", {
                  fill: "#ff0",
                  strokeWidth: 3.9,
                  d: "M529.6 405.5c0 40 45.6 27.8 46.8 61.2-.7 35.4-76.7 3.5-78.6-61.2 1.9-64.8 75-98 76.7-61 1.2 30.6-45 21-45 61z",
                  transform: "matrix(.15 0 0 .1 352.7 -81.8)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 478.4,
                  cy: -41.1,
                  fill: "#a95600",
                  strokeWidth: 0.4,
                  rx: 3.5,
                  ry: 3.4,
                  transform: "matrix(1.1 .02 -.02 1.15 -75.6 4.7)"
                })
              ]
            }),
            /* @__PURE__ */ jsxs107("g", {
              fill: "#009200",
              stroke: "#000",
              strokeWidth: 2.5,
              transform: "rotate(-5.8 688.4 -625.2)",
              children: [
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 427.1,
                  cy: 905,
                  rx: 20.8,
                  ry: 24.1,
                  transform: "matrix(.17 0 0 .32 369.8 -361.6)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 427.1,
                  cy: 905,
                  rx: 20.8,
                  ry: 24.1,
                  transform: "matrix(.17 0 0 .32 364 -362.7)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 427.1,
                  cy: 905,
                  rx: 20.8,
                  ry: 24.1,
                  transform: "matrix(.17 0 0 .32 360.6 -370.6)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 427.1,
                  cy: 905,
                  rx: 20.8,
                  ry: 24.1,
                  transform: "matrix(.16 0 0 .35 369.3 -399.4)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 427.1,
                  cy: 905,
                  rx: 20.8,
                  ry: 24.1,
                  transform: "matrix(.16 0 0 .33 377.4 -379)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 427.1,
                  cy: 905,
                  rx: 20.8,
                  ry: 24.1,
                  transform: "matrix(.16 0 0 .33 373.2 -382.2)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 427.1,
                  cy: 905,
                  rx: 20.8,
                  ry: 24.1,
                  transform: "matrix(.16 0 0 .33 368 -386.7)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 427.1,
                  cy: 905,
                  rx: 20.8,
                  ry: 24.1,
                  transform: "matrix(.16 0 0 .33 363 -389.5)"
                })
              ]
            }),
            /* @__PURE__ */ jsx132("path", {
              fill: "#804bff",
              stroke: "#000",
              strokeWidth: 0.5,
              d: "M482.6-141s-11.7 10-10.1 36.9c1.8 27 26.5 39.5 26.5 39.5s6.2-7.7 5.2-29.5c-2-31.8-13.8-45.7-13.8-45.7l-7.8-1.3z"
            }),
            /* @__PURE__ */ jsxs107("g", {
              fill: "#009200",
              stroke: "#000",
              strokeWidth: 2.5,
              transform: "rotate(4.5 181 769.9)",
              children: [
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 427.1,
                  cy: 905,
                  rx: 20.8,
                  ry: 24.1,
                  transform: "matrix(.17 0 0 .32 369.8 -361.6)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 427.1,
                  cy: 905,
                  rx: 20.8,
                  ry: 24.1,
                  transform: "matrix(.17 0 0 .32 364 -362.7)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 427.1,
                  cy: 905,
                  rx: 20.8,
                  ry: 24.1,
                  transform: "matrix(.17 0 0 .32 360.6 -370.6)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 427.1,
                  cy: 905,
                  rx: 20.8,
                  ry: 24.1,
                  transform: "matrix(.16 0 0 .35 369.3 -399.4)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 427.1,
                  cy: 905,
                  rx: 20.8,
                  ry: 24.1,
                  transform: "matrix(.16 0 0 .33 377.4 -379)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 427.1,
                  cy: 905,
                  rx: 20.8,
                  ry: 24.1,
                  transform: "matrix(.16 0 0 .33 373.2 -382.2)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 427.1,
                  cy: 905,
                  rx: 20.8,
                  ry: 24.1,
                  transform: "matrix(.16 0 0 .33 368 -386.7)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 427.1,
                  cy: 905,
                  rx: 20.8,
                  ry: 24.1,
                  transform: "matrix(.16 0 0 .33 363 -389.5)"
                })
              ]
            }),
            /* @__PURE__ */ jsx132("ellipse", {
              cx: 624.4,
              cy: 606.1,
              fill: "#c90000",
              stroke: "#000",
              strokeWidth: "1pt",
              rx: 58.3,
              ry: 186.5,
              transform: "matrix(.16 -.06 .06 .15 369.6 -145)"
            }),
            /* @__PURE__ */ jsxs107("g", {
              fill: "#009200",
              stroke: "#000",
              transform: "rotate(1 242.4 -1957.8)",
              children: [
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 218.1,
                  cy: 356.8,
                  strokeWidth: 1.5,
                  rx: 10.8,
                  ry: 12.9,
                  transform: "matrix(.4 0 0 .3 445 -230.5)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 218.1,
                  cy: 356.8,
                  strokeWidth: 1.6,
                  rx: 10.8,
                  ry: 12.9,
                  transform: "matrix(.35 0 0 .3 457.2 -236)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 218.1,
                  cy: 356.8,
                  strokeWidth: 1.6,
                  rx: 10.8,
                  ry: 12.9,
                  transform: "matrix(.35 0 0 .3 452 -236)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 218.1,
                  cy: 356.8,
                  strokeWidth: 1.6,
                  rx: 10.8,
                  ry: 12.9,
                  transform: "matrix(.37 0 0 .27 449.5 -233.5)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 218.1,
                  cy: 356.8,
                  strokeWidth: 1.6,
                  rx: 10.8,
                  ry: 12.9,
                  transform: "matrix(.37 0 0 .27 449 -238)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 218.1,
                  cy: 356.8,
                  strokeWidth: 1.6,
                  rx: 10.8,
                  ry: 12.9,
                  transform: "matrix(.35 0 0 .3 447 -238.8)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 218.1,
                  cy: 356.8,
                  strokeWidth: 1.6,
                  rx: 10.8,
                  ry: 12.9,
                  transform: "matrix(.35 0 0 .3 448 -241.6)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 218.1,
                  cy: 356.8,
                  strokeWidth: 1.5,
                  rx: 10.8,
                  ry: 12.9,
                  transform: "matrix(.4 0 0 .3 432.8 -243.5)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 218.1,
                  cy: 356.8,
                  strokeWidth: 1.6,
                  rx: 10.8,
                  ry: 12.9,
                  transform: "matrix(.37 0 0 .27 446 -243.5)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 218.1,
                  cy: 356.8,
                  strokeWidth: 1.6,
                  rx: 10.8,
                  ry: 12.9,
                  transform: "matrix(.35 0 0 .3 444.2 -247)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 218.1,
                  cy: 356.8,
                  strokeWidth: 1.6,
                  rx: 10.8,
                  ry: 12.9,
                  transform: "matrix(.35 0 0 .3 436.1 -243.2)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 218.1,
                  cy: 356.8,
                  strokeWidth: 1.6,
                  rx: 10.8,
                  ry: 12.9,
                  transform: "matrix(.35 0 0 .3 437.4 -243.9)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 218.1,
                  cy: 356.8,
                  strokeWidth: 1.6,
                  rx: 10.8,
                  ry: 12.9,
                  transform: "matrix(.35 0 0 .3 439 -247)"
                })
              ]
            }),
            /* @__PURE__ */ jsxs107("g", {
              fill: "#009200",
              stroke: "#000",
              transform: "matrix(.18 0 0 .2 421 -216.8)",
              children: [
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 528.7,
                  cy: 564.5,
                  strokeWidth: 2.5,
                  rx: 67.4,
                  ry: 205.6,
                  transform: "matrix(.98 -.3 .36 .87 -245.8 324.4)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 528.7,
                  cy: 646.1,
                  strokeWidth: 2.5,
                  rx: 13.3,
                  ry: 40.8,
                  transform: "rotate(-23.4 630.5 660.9)"
                }),
                /* @__PURE__ */ jsx132("path", {
                  strokeWidth: 1.5,
                  d: "M139.9 644c0 57.7-18.8 86.2-34.6 110.3 7.5-32.5 13-52.6 13-110.3 0-57.7 29.5-85.3 40.3-102-4.2 16.7-18.7 44.3-18.7 102z",
                  transform: "matrix(1.88 -.46 .95 1.18 -352.3 -10)"
                }),
                /* @__PURE__ */ jsx132("path", {
                  strokeWidth: 1.5,
                  d: "M139.9 644c0 57.7-18.8 86.2-34.6 110.3 7.5-32.5 13-52.6 13-110.3 0-57.7 29.5-85.3 40.3-102-4.2 16.7-18.7 44.3-18.7 102z",
                  transform: "matrix(1.88 -.46 .95 1.18 -348.4 44)"
                }),
                /* @__PURE__ */ jsx132("path", {
                  strokeWidth: 1.5,
                  d: "M139.9 644c0 57.7-18.8 86.2-34.6 110.3 7.5-32.5 13-52.6 13-110.3 0-57.7 29.5-85.3 40.3-102-4.2 16.7-18.7 44.3-18.7 102z",
                  transform: "matrix(1.87 -.5 .98 1.16 -362 105.8)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 528.7,
                  cy: 646.1,
                  strokeWidth: 1.4,
                  rx: 13.3,
                  ry: 40.8,
                  transform: "matrix(1.8 -.4 .7 1.64 -915.6 -221)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 528.7,
                  cy: 646.1,
                  strokeWidth: 1.6,
                  rx: 13.3,
                  ry: 40.8,
                  transform: "matrix(1.63 -.23 .54 1.35 -739.5 -91.8)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 528.7,
                  cy: 646.1,
                  strokeWidth: 1.6,
                  rx: 13.3,
                  ry: 40.8,
                  transform: "matrix(1.63 -.2 .5 1.36 -750.6 -91.8)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 528.7,
                  cy: 646.1,
                  strokeWidth: 2.1,
                  rx: 13.3,
                  ry: 40.8,
                  transform: "matrix(1.3 -.2 .47 1 -531 47.6)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 528.7,
                  cy: 646.1,
                  strokeWidth: 2.1,
                  rx: 13.3,
                  ry: 40.8,
                  transform: "matrix(1.33 -.13 .4 1.03 -517.9 12.2)"
                }),
                /* @__PURE__ */ jsx132("path", {
                  strokeWidth: 2.1,
                  d: "M145.7 569.5c0 34-6.7 61.6-15 61.6s-15-27.6-15-61.6",
                  transform: "matrix(1.03 -.5 .46 1.18 12.8 -14.5)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 528.7,
                  cy: 646.1,
                  strokeWidth: 2.1,
                  rx: 13.3,
                  ry: 40.8,
                  transform: "matrix(1.33 -.13 .4 1.03 -519.5 -34.4)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 528.7,
                  cy: 646.1,
                  strokeWidth: 2.1,
                  rx: 13.3,
                  ry: 40.8,
                  transform: "matrix(1.33 -.1 .38 1.04 -534 -40.1)"
                }),
                /* @__PURE__ */ jsx132("path", {
                  strokeWidth: 2.9,
                  d: "M145.7 569.5c0 34-6.7 61.6-15 61.6s-15-27.6-15-61.6",
                  transform: "matrix(.67 -.47 .46 .8 39.5 143.3)"
                }),
                /* @__PURE__ */ jsx132("path", {
                  strokeWidth: 2.9,
                  d: "M145.7 569.5c0 34-6.7 61.6-15 61.6s-15-27.6-15-61.6",
                  transform: "matrix(.67 -.47 .46 .8 51.1 125.8)"
                }),
                /* @__PURE__ */ jsx132("path", {
                  strokeWidth: 2.1,
                  d: "M145.7 569.5c0 34-6.7 61.6-15 61.6s-15-27.6-15-61.6",
                  transform: "matrix(.94 -.64 .64 1.1 -40.2 -10.7)"
                }),
                /* @__PURE__ */ jsx132("path", {
                  strokeWidth: 2.7,
                  d: "M145.7 569.5c0 34-6.7 61.6-15 61.6s-15-27.6-15-61.6",
                  transform: "matrix(.67 -.52 .46 .88 68.6 71.2)"
                })
              ]
            }),
            /* @__PURE__ */ jsxs107("g", {
              fill: "#804bff",
              stroke: "#000",
              strokeWidth: 2.5,
              children: [
                /* @__PURE__ */ jsx132("path", {
                  d: "M276.3 345.4c-12.3 9.2.4 25.2 12 30.7 13 7.7 86.6 58.2 136.3 12-40.8.8-118.7-63.2-148.3-42.7z",
                  transform: "matrix(.16 0 0 .22 458 -214.3)"
                }),
                /* @__PURE__ */ jsx132("path", {
                  d: "M276.3 345.4c-12.3 9.2.4 25.2 12 30.7 13 7.7 86.6 58.2 136.3 12-40.8.8-118.7-63.2-148.3-42.7z",
                  transform: "matrix(.16 0 0 .22 456.6 -220.2)"
                }),
                /* @__PURE__ */ jsx132("path", {
                  d: "M276.3 345.4c-12.3 9.2.4 25.2 12 30.7 13 7.7 86.6 58.2 136.3 12-40.8.8-118.7-63.2-148.3-42.7z",
                  transform: "matrix(.16 0 0 .22 454.8 -225.8)"
                }),
                /* @__PURE__ */ jsx132("path", {
                  d: "M276.3 345.4c-12.3 9.2.4 25.2 12 30.7 13 7.7 86.6 58.2 136.3 12-40.8.8-118.7-63.2-148.3-42.7z",
                  transform: "matrix(.16 0 0 .22 450.9 -232.2)"
                })
              ]
            }),
            /* @__PURE__ */ jsxs107("g", {
              transform: "rotate(1 -589.6 681.6)",
              children: [
                /* @__PURE__ */ jsx132("path", {
                  fill: "#804bff",
                  stroke: "#000",
                  strokeWidth: 2.5,
                  d: "M211.2 247.3c21.7-12 56.6-9.8 79.7 11.2 19.4 17 45.3 75.2 70.3 92.8a57.7 57.7 0 0 1-42.2-15.2c-28.8 15.5-38.1 16.7-64 15.7-35.8-1.4-62.4-17.7-68-40.6-6.3-21.8 4.8-52.5 24.2-63.9z",
                  transform: "matrix(.2 -.04 .05 .18 407.8 -213.6)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 287.2,
                  cy: 323,
                  fill: "red",
                  stroke: "#000",
                  strokeWidth: 2.5,
                  rx: 14.2,
                  ry: 15,
                  transform: "matrix(.25 0 0 .13 401.8 -215.2)"
                }),
                /* @__PURE__ */ jsx132("ellipse", {
                  cx: 204.6,
                  cy: 348.3,
                  fill: "#ff0",
                  stroke: "#000",
                  strokeWidth: 2.5,
                  rx: 23.3,
                  ry: 15.9,
                  transform: "matrix(.2 -.08 .07 .17 398.7 -208)"
                }),
                /* @__PURE__ */ jsx132("circle", {
                  cx: 283.9,
                  cy: 333.9,
                  r: 5.8,
                  transform: "matrix(.2 0 0 .2 411.3 -233.7)"
                }),
                /* @__PURE__ */ jsx132("path", {
                  fill: "#ff0",
                  stroke: "#000",
                  strokeWidth: 6.6,
                  d: "M516.8 260.3c4.4 18-6.7 43-33.1 52.6-26.8 13.2-46.1 41.8-55.7 88-47.2-103.2-23-148.3 20.6-160.3 37.4-14.4 60.4-13.4 68.2 19.7z",
                  transform: "matrix(.1 0 0 .08 417.9 -191.5)"
                }),
                /* @__PURE__ */ jsx132("circle", {
                  cx: 199,
                  cy: 362.4,
                  r: 4.7,
                  transform: "matrix(.2 0 0 .2 418.7 -235)"
                })
              ]
            })
          ]
        })
      ]
    })
  ]
});
var Dm_default = SvgDm;

// src/country-flag-icons/generated/Do.tsx
init_esm_shims();
import { jsx as jsx133, jsxs as jsxs108 } from "react/jsx-runtime";
var SvgDo = (props) => /* @__PURE__ */ jsxs108("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx133("path", {
      fill: "#fff",
      d: "M0 0h640v480H0Z"
    }),
    /* @__PURE__ */ jsx133("path", {
      fill: "#002d62",
      d: "M0 0h272v192H0Zm368 288h272v192H368Z"
    }),
    /* @__PURE__ */ jsx133("path", {
      fill: "#ce1126",
      d: "M0 288h272v192H0ZM368 0h272v192H368Z"
    }),
    /* @__PURE__ */ jsx133("path", {
      fill: "#201b18",
      d: "M307.4 196.6a34.9 34.9 0 0 0-19 4.9c-2.6 1.6-3.2 2.1-1.8 4.7l-3.3 1.1a38 38 0 0 0-6 2.7c-1.2.7-1.6 1.2-2.5 2.1l5.3-.4-.7 1.2c-1 1.3-1.5 2.3-2.3 3.7 1.5-1 2.9-2 4.6-2.8 3.8-2 10.7-2 13.5-5.4.7-.9.3-1.4-.3-2.8 2-.6 2.9-1.1 5.4-1.7 6.1-1.4 10.3.3 13.3-.5 1-.2 1.8-.7 1.9-1.7l-.5-3h10c0 1.7-1.7 4 1.4 4.7 2.8.8 8.4-.8 13.3.5l5.4 1.8-.5 1.3c-.3.6-.2 1 .2 1.4.5.6 1.2 1.2 2 1.6a22.3 22.3 0 0 0 5.6 2c5.7 1.3 6.2 1.7 10.5 4.6-.3-.9-2.3-3.9-3-5l5.3.5c-1-1.4-3.7-2.9-5.3-3.5l-6.5-2.4c.6-1 1-2 .5-3a24 24 0 0 0-7.7-4.3 68.4 68.4 0 0 0-7-1.6l-6.8-.7c-.3-.3.6-2-.8-3.3-.8-.6-2-.9-3.3-1-5-.5-11.6-.3-16.6 0-1.5.1-2.5.3-3.3 1-1 1-1.1 1.5-1 3.3"
    }),
    /* @__PURE__ */ jsxs108("g", {
      fill: "#002d62",
      children: [
        /* @__PURE__ */ jsx133("path", {
          d: "M308.7 200.1c.8-.6.9-.8 2-1.2 2.6-.9 6.6-.8 9.3-.8 2.2 0 4.3 0 6.5.2s3.4.5 4.9 1.7c.3-1.5.6-2.8.6-4.5.1-1.8-1-2.3-2.5-2.6-2.6-.6-7-.5-10-.5a63 63 0 0 0-9.7.6c-1.2.4-2.2 1.4-2 3 0 .9.6 3.6 1 4.1z"
        }),
        /* @__PURE__ */ jsx133("path", {
          d: "M289.4 208.7c.4-.4.1-.8 2.2-2a34.8 34.8 0 0 1 9.3-3.4c2.6-.5 5.3-.5 8-.3 1.2.1 2.8.3 4 .1 0 0 1.3-.3 1.7-.6.4-.4.4-1.4.4-1.4-.9-.7-3.4 1.8-5.6 1-.7-.2-1-1.4-1.2-2.3l-.8-2.7a35.1 35.1 0 0 0-15 2.8c-1.8.8-4.6 2.2-5.7 3.3-1 1 0 2.4.6 3.1.6.9 1.6 2 2 2.4zm35.6-7.6c-.2 1.4.8 1.8 2.1 2 2.7.4 6.7-.8 12 .2a35.2 35.2 0 0 1 6.4 2c.8.4 3.6 1.6 4.1 2.2l1 1.2c.3-.1 1.8-2 2.1-2.4.7-.7 1.5-2 .6-3.1a25 25 0 0 0-5.7-3.3 38.8 38.8 0 0 0-7.8-2.1c-2.5-.4-7.6-.8-7.6-.8s-.3 4.7-1.6 5.1c-2.5.8-3.8-1.4-5.6-1"
        }),
        /* @__PURE__ */ jsx133("path", {
          d: "M345 207c-.2.6-.5.7.9 1.8 3 2.6 8.4 2.7 11.6 4.1 1.7.8 2.6 1.4 4.1 2.3-.1-.5-2-3.2-2.5-4l4.9.2-.2-.2c-2.2-1.9-7.9-3.7-10.7-4.6l-2.5 2.8c-.3.3-.6.6-1.3.4-.8-.3-1.5-1-2-1.5-.6-.5-1.6-1.3-2.3-1.4zm-20-6.4c1.7.1 1.9.4 3 1l1.8.2c.9 0 1-.2 1.2-.9.3-1-1.3-1.6-2-1.7l-3.5-.6zm-10 0-.4-2c-1 0-6 .8-5.6 2.3.2.7.3.8 1 1 2.2.1 2.6-1.2 5-1.3m-25.2 8.4c.7 1.3 2.6-1 3.7-1.8.6-.5.7-.4 1.4-.7l-.4-.7-2.7 1.3c-.8.5-1.8 1-2 2z"
        }),
        /* @__PURE__ */ jsx133("path", {
          d: "M345.1 206.5c.3 0 .5.1.8.3 1.6.9 3.5 3.3 4.3 2.4.4-.5-1.3-1.7-1.8-2l-2.8-1.3a1.6 1.6 0 0 0-.5.6m-50.2.5c.2.7.5.8-.8 1.9-3.2 2.5-8.4 2.7-11.7 4.1-1.7.7-2.6 1.3-4 2.2 0-.4 2-3.2 2.5-4l-5 .3.3-.2c2.2-2 7.8-3.7 10.6-4.7l.9 1a37 37 0 0 0 1.6 1.9c.4.3.6.5 1.3.3.9-.2 1.6-1 2-1.4.6-.5 1.6-1.4 2.3-1.4"
        })
      ]
    }),
    /* @__PURE__ */ jsx133("path", {
      fill: "#eac102",
      d: "M295.7 199.8c-.5 0-.9.2-1.3.3-.1 0-.5.2-.2.3.2.1.2.4.3.6l.3.9.5 1.4c0 .1 0 .4.2.3l.8-.3c.3-.1.6-.3.8-.7l.2-.5a.8.8 0 0 0 0-.4c0-.2 0-.4-.2-.6a1.8 1.8 0 0 0-.4-.8c-.2-.2-.4-.4-.7-.4a.8.8 0 0 0-.3-.1m-.2.3c.2 0 .5.2.6.5l.4.7.2 1.3c0 .2-.3.3-.5.5-.2 0-.4-.1-.4-.3l-.2-.6-.4-1a4.7 4.7 0 0 1-.2-.8c0-.2.2-.3.4-.3zm1.7-.9.3.3.2.6.1.5.2.7.2.6v.6s0 .2.1 0h.5c.1 0 .3 0 .3-.2l-.2-.3-.2-.8-.2-.5-.1-.4-.3-.9v-.3c0-.2-.2 0-.3 0zm3-.8c-.3 0-.6.1-.8.3l-.3.9v.8l.6 1.2.7.4h.6c.3-.1.6-.4.7-.7l.1-.8v-.7a2.6 2.6 0 0 0-.4-.7l-.5-.5a1.1 1.1 0 0 0-.7-.2m0 .2c.2 0 .4.3.5.6l.4 1.2.1.5v.7c-.2.2-.5.3-.7.1l-.4-.5-.2-.8-.1-.6c0-.3-.2-.6 0-1zm2.3-.5-.3.5.1.7a.8.8 0 0 0 .4.4l.9.5c.2 0 .4.2.4.4v.5c0 .1-.2.3-.4.2a.7.7 0 0 1-.4-.2 1.2 1.2 0 0 1-.4-.6l-.2.1v.6l.4.2.5.2c.2 0 .4 0 .6-.2.2 0 .3-.2.4-.4a1 1 0 0 0 0-.7 1.1 1.1 0 0 0-.6-.8 4 4 0 0 0-.6-.3l-.6-.5c0-.2 0-.5.2-.5h.6l.3.5c0 .2.2.1.1 0 0-.2.2-.5 0-.6a1.4 1.4 0 0 0-.6-.2 1 1 0 0 0-.6.1zm11.2-4.4-.9.2-.4.1a.7.7 0 0 1 .2.4v1.5l.1.8v.6c-.2.1 0 .2.2.1h.6c.2 0 0-.2 0-.3l-.1-.6v-.6l.6-.1c.4-.1.8-.4.9-.8a1.1 1.1 0 0 0-.4-1 1.4 1.4 0 0 0-.8-.3m0 .3c.2 0 .4.2.4.5v.5c0 .3-.2.5-.5.6-.1 0-.3 0-.3-.2v-.6c0-.3-.2-.5 0-.7h.3zm2.6-.4c-.2 0-.4.1-.3.3l-.2.7a9.9 9.9 0 0 1-.2 1l-.3 1.2c0 .1-.2.3 0 .3h.5c.2 0 0-.2 0-.3v-.5s0-.2.1-.1h.8v.6c0 .1 0 .3.2.3h.7c.2-.1 0-.3-.1-.4l-.2-.7-.3-.9-.1-.5a9.3 9.3 0 0 1-.3-1zm-.2.8.4 1.3c.1.1 0 .2-.2.2-.1 0-.5.1-.5-.1l.1-.5a6.9 6.9 0 0 0 .2-.7zm3-1h-1.3a.8.8 0 0 1 0 .5l-.1.4.3-.3c.1 0 .2-.3.4-.2h.3v2.9l-.1.2h.9c.1 0 .1-.1 0-.1v-3c0-.1.1-.2.3 0h.2l.2.4h.2l-.1-.5c0-.1 0-.3-.2-.3zm2.8 0h-.8s-.2 0-.1.1c.2.1.1.3.1.5v2.5c0 .1 0 .3-.2.4h1c0-.1-.2-.2-.1-.3v-1.2c.2 0 .3.1.3.3l.2.5c0 .2.2.3.3.5.2 0 .3.2.5.3l.3.1-.2-.3-.3-.8a2 2 0 0 1-.2-.5c0-.2.1-.1.2-.2a1 1 0 0 0 .5-.4v-.6l-.2-.5c-.1-.2-.3-.2-.4-.3a3.3 3.3 0 0 0-.6-.1zm.3.2c.2 0 .3.1.4.3a.8.8 0 0 1 .2.4v.4c-.1.2-.3.4-.5.4h-.5v-1.3c0-.2.2-.2.4-.2m2.2.4v1.2l-.1 1.4a.8.8 0 0 1-.2.4s0 .1 0 0l.4.1h.5c.2 0 0 0 0-.2v-2.7c.1-.1 0-.3.2-.4v-.2h-1zm2.5-.2-.3.9-.1.5-.3.8c-.1.4-.2.8-.4 1-.2 0-.1.3 0 .2h.5c.1.1.2 0 0 0v-.6c0-.2.1-.3.3-.2h.6l.1.6c0 .2-.2.4 0 .4h.7s.2 0 0 0l-.1-1-.2-1-.1-.9a1.9 1.9 0 0 0-.1-.5s0-.2-.2-.1h-.4zm0 .8c.2.2.1.4.2.6v.8c.2.3-.2.1-.3.1-.2 0-.4 0-.3-.2l.1-.4.2-.5zm6.5 3.5c0 .2.2.3.1.4v2.9a.3.3 0 0 1 0 .3h1.9v-.8c0-.1 0 0 0 0-.2.3-.4.5-.7.5h-.5v-.5a31.7 31.7 0 0 1 0-2.4l.1-.4zm2.3 3.6h1l-.2-.4v-2.9l.2-.3h-1c0 .2.2 0 .2.3v2.9zm1.5-3.7c0 .2.2.3.1.4v1.2a26.1 26.1 0 0 1-.1 1.4l-.1.5s-.2.1 0 .1l1.1.2c.3 0 .6 0 .8-.2.4-.2.5-.7.4-1 0-.2-.2-.3-.3-.5a13 13 0 0 0-.4-.3.8.8 0 0 0 .7-.5c0-.3 0-.6-.2-.8l-.2-.2-.5-.1zm.8.4.6.1c.2.3.2.6 0 1l-.2.1h-.5v-.8zm-.2 1.5c.3 0 .6 0 .8.3.2.2 0 .5.1.7 0 .4-.3.6-.6.6-.2 0-.3-.1-.3-.3a9 9 0 0 1 0-1.3m1.8 2 .3.2.9.2.8.1.2-.5c0-.2-.1-.3-.2-.1a1 1 0 0 1-.9.1c-.2 0-.3-.2-.3-.4l.2-1.2.4.1c.2 0 .3.2.4.4l.1-.3v-.7c-.1 0-.2.4-.4.2-.2 0-.5 0-.4-.2l.1-.8c.3-.1.7 0 .9.3l.3.3v-.7l-.5-.2-1.3-.3c-.3 0 0 .2 0 .3l-.2 1.7-.2 1.2a.5.5 0 0 1-.2.3m3-2.8v.6l-.3 1.6-.2 1c0 .1-.4.2-.1.3l.7.2c.2 0 0-.2 0-.3l.2-.7.1-.4c.2 0 .1.3.2.4 0 .4.2.8.3 1.1l.6.5-.2-.5v-1.4c.1 0 .3 0 .5-.2.2-.3.3-.7.2-1a1.3 1.3 0 0 0-.6-.8l-1.2-.4a1.2 1.2 0 0 0-.2 0m.8.4a.7.7 0 0 1 .6.4c.1.4 0 .8-.1 1.1-.2.2-.4.2-.6.1-.2 0-.4 0-.3-.2l.2-1a.7.7 0 0 1 .2-.4m1.5 1.2.5-.2s.3-.1.4 0c.1.1 0 .3 0 .4l-.1.7-.4 1.6-.3.4c0 .2.2.2.3.2l.6.2c0-.1-.1-.2 0-.4l.2-1.2a31.3 31.3 0 0 1 .4-1.6c.2 0 .4.2.5.3l.2.5c.1 0 0-.2 0-.4l.1-.4-.8-.3-.6-.3-.7-.2za.3.3 0 0 0 0 .1m3.4.7c-.2 0-.2.2-.3.4 0 .2-.2.3-.3.5l-.9 1.4a1.1 1.1 0 0 1-.4.4c-.2.2.1.2.2.3.1 0 .3.2.4.1 0-.2-.2-.3 0-.5 0-.1 0-.4.3-.3l.6.4v.5c0 .1-.3.2-.2.4l.5.3s.3.2.2 0v-.8l.1-.5v-.8l.2-1.2c0-.2.1-.4 0-.4zm-.3.7s.1.1 0 .2v1.3c0 .2-.3 0-.4 0-.1-.1-.4-.2-.2-.4l.4-.6zm2.2.5-.1.6-.4.6-.4.7-.5 1h-.2l.5.5.6.6c.3.2.8.3 1.1.1l.5-.5a3.4 3.4 0 0 0 .3-.6v-1c0-.4-.2-.9-.5-1.2l-.6-.6zm.6.9c.3.2.5.5.4.8 0 .5-.2 1-.5 1.4-.2.3-.4.6-.7.6-.2.1-.5 0-.6-.3l.2-.6.8-1.4c0-.2.2-.4.3-.5z"
    }),
    /* @__PURE__ */ jsx133("path", {
      fill: "#006300",
      d: "m308.8 279.2 2.5 1 1.8 3.4c.7.5.6.4 1.3.6l-4.3 1.8c-1.2.4-.7 1.5-.1 1.7.6.2 2-.3 2.4-.5 2.1-1 4-2 6-3.3.3-.2 1.7-1.1 2-1l7.6 4.2c.6.3 1.7 1 2.3.6.3-.2.6-.6.5-1-.1-.5-.4-.6-.8-.7l-4.1-1.8.9-.3c.3-.2-.2-.7.2-.6l1.9-3.1 2.3-.9c0-2.1-17.8-3.5-22.4-.1"
    }),
    /* @__PURE__ */ jsx133("path", {
      fill: "#ff0",
      d: "M310 286.5c-.6.2-.5 1.4.8 1 .9-.3.2-1.3-.8-1m19 0c-.3.5-.3.7.2 1 .5.1.7.1 1-.2.5-.4.1-.6-.2-.8-.4-.2-.1-.2-.4 0z"
    }),
    /* @__PURE__ */ jsx133("path", {
      fill: "#006300",
      stroke: "olive",
      strokeWidth: 0.2,
      d: "M345.8 216v.3c1.7 3.2 1 1.7 2.4 5.9l-.8-1.1a30.2 30.2 0 0 1-2-3 1.3 1.3 0 0 0-.4-.6c-.2.3.4 2 .6 2.5.5 2 2.1 4.4 3.3 6.3l-.9-.7c-1-.8-.7-.6-1.3-1.7a20.3 20.3 0 0 1-1.4-3 51.6 51.6 0 0 0-.8-2.2l-.2.2v.9l.6 3.6c-.8-.3-.6-.4-1.3-1-.2 0-.4-.6-.6-.6l-.7-.8c-.1.4 1 2.4 1.2 2.6.4.6 1.8 1.6 2 2a14 14 0 0 0 2.1 3.7l.9 1.1-1.9-1.8a33 33 0 0 0-3.4-3c0 .4.6.8.9 1l2.3 2.6c.7 1 1.6 1.8 2.2 2.8l1.5 2.5a13.8 13.8 0 0 0-.8-1.1l-2.3-2.8c-.8-1-1.6-1.6-2.6-2.4a25.6 25.6 0 0 0-2-1.4c0 .3 1.9 2.7 3.2 3.4l1.2 1.3 1.2 1.3a36.3 36.3 0 0 1 1.9 3l.9 1.5c-.7-.2-4-4-4.7-4.7-.7-.7-1-1-1.8-1.5 0 .4 2.3 3 2.8 3.5l.5.6 1 1.1c.6.8 1.8 2.2 2.2 3l.7 1.4a20 20 0 0 0-1.5-2 7.8 7.8 0 0 0-.9-1c-.7-.8-1.9-2.2-2.8-2.8l-2.2-1.3c-.1.2.4.6.6.8l.9.8a21.7 21.7 0 0 1 3.1 3.4c.6.6 1 1.2 1.4 2a3.1 3.1 0 0 1-.7-.7l-.7-.7-1.6-1.2-3.6-1.8c0 .3 1.3 1 1.6 1.2.7.5 2 1.2 2.5 1.9l.7.7c.5.5 1 1 1.3 1.6l1.2 1.7 1 2 1.3 4.5c-.4-1.5-1.2-3-1.7-4.6-.4-1-1.4-3.8-2.8-3.3-.5.2-.8.8-1 1.2-.3.7-.8-.2-2 2a18.1 18.1 0 0 0-1.2 4.3v.7c.3-.1.5-.9.6-1.2.5-1.4 1-2.3 1.9-3.6l-1.1 4.9c.4-.1.5-.7.6-1l1.4-3.7c1.6 1.1 2 7.2 2.3 9.3a21.4 21.4 0 0 0-1.1-3l-1.7-2.8c-1 .1-1 1.4-1.2 2.1-.3-.4-.6-1-1.3-1-.5 0-.8.8-.9 1.4a7.7 7.7 0 0 0 0 2.2l.4 1.6.2.2.3-4.1c.6.3 1.8 3 1.6 4-.6 4-1 5.3-3.1 8.6l-1.2 1.7a10 10 0 0 1-.6.8l-.7.8c1.1-2 1.6-2.7 2.4-4.9a24 24 0 0 0 1.2-5v-.9c-.3 0-.3.4-.4.7-1.8 5.7-2.1 6-5.1 11l.5-3.3c-.2 0-.2.2-.3.6l-.2.6a17.8 17.8 0 0 1-1.6 3.6c0-.3.3-.8.4-1.1a26 26 0 0 0 .7-3.4v-.7c-.3 0-.4.6-.5 1-.4 1.2-1 2.2-1.4 3.3v-.3c0-.7.3-1.8.1-2.5v-.3c-.3.1-.4.7-.5 1l-.3 1c-.7 1.9-1.5 3.1-2.5 5-.6-.1-.2 0 0 0a209.5 209.5 0 0 0 5.7 1.1c2.8-.1 4.6-.3 7.4 0 .4 0 2.1.3 2.4 0-.8-.4-1.6-.6-2.5-.9l-2.7-.6 7.5-.2-.6-.4c-1.3-.5-4.6-.7-6-.8 2.5-.2 4.4-.4 6.8-.4.7-.2 2.9.5 2-.5-1-.6-3.8-.7-4.7-.6l4.4-.2c.7-.2 5.3.8 3.7-.2-1.3-.7-4-1.2-5.4-1.4.8-.5 1.5-1 2.3-1.3a40.7 40.7 0 0 1 5.3-1.7c2-.3 3.5-1.3.9-.9-1.6.2-3.5.7-5 .8l1.3-.7c1.3-.6 2.7-.9 4-1.3.3-.1.2 0 .3-.2l-.2-.1h-.8a65.1 65.1 0 0 0 7-2c.3 0 .7 0 .9-.2l-.2-.1a86 86 0 0 0-6.4.8l-2 .3 5-2c.4 0 1.6-.2 1.8-.5-.3-.2-.6-.1-1.1 0a36 36 0 0 0-4.7 1.2l-1.8.5c5.6-2.1 3.4-1.5 8.6-2.5.6-.1 1 0 1.1-.4l-3-.2c-1 0-2 .2-2.7.3l2.2-1.9c.6-.5.3-.7 1.4-.7h2c-.8-.9-1-.5-1.8-.9l1-1 .5-1c.1-.1.1-.1 0-.2h-.3l-2.3 2c-.4.2-.3.2-.9.2l-3 .6a24.7 24.7 0 0 1 3-2.1l1.7-1c.5-.2 1.6-.6 1.7-.8l-3.6.9a19.2 19.2 0 0 0-3 1.5 45.8 45.8 0 0 1 5.8-5.2c.2-.1.8-.4.9-.7h-.3c-1 .2-3.2 1.7-4 2.1a36.3 36.3 0 0 0-3.8 2.8 27.9 27.9 0 0 1 2.7-2.6l.5-.5 1.1-1c.8-.6 1.5-1.2 2.2-2l1.1-.9c.3-.2 1-.7 1-1a55.3 55.3 0 0 0-4.4 2.7l-2.1 1.5-2.1 1.6c.9-1.4 1.8-2.9 2.9-4.1a45.6 45.6 0 0 1 4.7-4.4c.4-.3.8-.8 1.2-1v-.2c-.4 0-1.6.9-1.9 1.1a38.5 38.5 0 0 0-4.7 4l-.7.8a15 15 0 0 0-2 2.4 62 62 0 0 0-2.4 3.6c.5-2.2 2-4 3.2-5.2l2.7-3 .4-.5a10 10 0 0 0 3-5.8l-1.3 1.8-.7.7-5.4 6.3c.2-.9 1.3-2.8 1.8-3.5a63.3 63.3 0 0 1 5.6-7.5l.3-.3c0-.3.4-.5.8-.9l1-.8c-.5-.5-2.4.6-2.7.9-2.4 1.6-4.1 3.9-5.9 6.1a26.1 26.1 0 0 1 2.4-5.7c.5-.8 1-1.8 1.6-2.5l1.6-2.4c-.4 0-.8.5-1 .8l-.5.4c-2 2.3-3.3 4.8-4.8 7.5.1-1.3 1.3-3.7 2-4.8l2.8-4.2c-.5-.1-2 1.6-2.3 2-.6.8-1.3 1.6-1.8 2.6a31 31 0 0 0-2.7 5.5l-.2.4c.1-1.8 2-6.1 2.7-7.6l1.6-2.2.5-.7 1.1-1.4 1.1-1.5c-.7-.2-3.2 2.6-3.7 3.2l-1.7 2.5c.3-1.4 1.3-3.3 2.1-4.5l2.1-2.7.7-1c-.8 0-4 3.7-4.7 4.5l-.7 1.1-1.1 1.7-.2.3-.2.3a37 37 0 0 1 1.4-5.3l2-4.5c-.5 0-1.6 1.4-1.9 1.8l-1.2 2.5c.1-1.2 1.8-5 2.4-6.5-.3 0-.5.6-.8 1l-2.3 3.8c.1-1.3 1-2.6 1.5-3.7-1 .4-2.8 4.2-3.2 5.3l-.5 1.6-.2.6c0-2.8.5-5.7 1-8.5-.3 0-.4.3-.5.6l-.3.7-.6 1.6-.8 3.4c-1.2-1.7-1.5-4.8-3.9-8.4-.7-1.1-1-1.2-2-2zm1.3 33.8c1 2.8 1.3 3.7 2 6.6a.7.7 0 0 0-.2.3l-.4 1.2-.8-2.5c-.2-1 .2-2.8-.2-3.1-.2.5-.2.5-.2 1.4l-.5-1c-.5-1.6-.6-1.1-.2-2 0-.3.2-.7.5-.9z"
    }),
    /* @__PURE__ */ jsxs108("g", {
      fill: "#008f4c",
      children: [
        /* @__PURE__ */ jsx133("path", {
          d: "M354.4 245.1c.4-3.8 5-12.8 6.5-13 .2 0-1.6 2.5-2.8 5a56.7 56.7 0 0 0-3 7.3 17 17 0 0 1-.7 2.6zm10.2-2.3s-.8.9-1.9 1.8a44.3 44.3 0 0 0-9.6 13.8c-2 5-1.5 3.7-.9 1.3a35.3 35.3 0 0 1 9.7-15.1c1.4-1.2 2.8-2.1 2.7-1.8m-11.8-8.6c0-3.4.4-4.6 2.4-8.8 1.2-2.7 1.7-3.5 1.9-3.3 0 .1 0 .6-.3 1a50 50 0 0 0-3.4 11.7 5.5 5.5 0 0 1-.4 1.7 7 7 0 0 1-.2-2.3m-5.6 19.4a20.2 20.2 0 0 1-1.4 8.8c-.7 1.8-3.5 6-4.2 6.4-.3 0-.2 0 .5-1a22.1 22.1 0 0 0 5-13.4c-.2-2.6 0-3 .1-.9z"
        }),
        /* @__PURE__ */ jsx133("path", {
          d: "M355.8 250.3c.4 1.2.5 4 0 5.5a11 11 0 0 1-7.2 7.5 5.7 5.7 0 0 1-1.3.3 5.4 5.4 0 0 1 1.2-.7 12.4 12.4 0 0 0 7.3-11c0-1-.1-1.4-.2-1.6 0-.4-.1-.7 0-.8z"
        }),
        /* @__PURE__ */ jsx133("path", {
          d: "m365.7 257.9-4.4.8a194.8 194.8 0 0 0-9.3 1.6.9.9 0 0 1-.1-.3 168.7 168.7 0 0 1 13.8-2.1m-18.5-39.7c1.5 1.8 1.8 2.6 2.6 5.7.5 2 .6 2.6.5 2.6l-.4-.7a34.4 34.4 0 0 0-3.2-7.7 3.8 3.8 0 0 1-.6-1 5 5 0 0 1 1 1zm-1.6 2.2c.6 2.2 1.1 3 3.3 5.3 1.4 1.4 1.9 1.9 1.9 1.7 0 0-.1-.4-.4-.6a34 34 0 0 1-4.6-6.9 3.8 3.8 0 0 0-.6-1s0 .7.4 1.5m13.4 7c-2.4 2.2-6.3 9.2-5.7 10.3.1.1 1.1-1.5 2.2-3.6a48.4 48.4 0 0 1 3.4-5.8l1.4-2zm1 1.8c-2.6 2.4-6.9 10.2-6.3 11.4.1.2 1.2-1.6 2.4-4a54.3 54.3 0 0 1 3.9-6.4 15.7 15.7 0 0 0 1.5-2.1zm-15.2-7.1c.4 2.3.8 3 2.6 5.6 1.2 1.7 1.7 2.2 1.7 2 0 0 0-.4-.3-.6a34.3 34.3 0 0 1-3.7-7.5 3.8 3.8 0 0 0-.5-1.1z"
        }),
        /* @__PURE__ */ jsx133("path", {
          d: "m348.4 226.7 2.6.7c0-.2-.4-.3-.7-.4-1.7-.5-6.4-2.6-6.5-3.4l-1-1.5s4 4 5.6 4.6m16.2 8.3c-3.6 2.5-10 11.2-9.5 12.8 0 .3 1.7-1.7 3.6-4.4a65.8 65.8 0 0 1 5.7-7.3 19 19 0 0 0 2.1-2.3s-1 .5-1.9 1.2m-.5 5.3c-1.6 3.2-7.7 9.3-9 9a15 15 0 0 1 3.1-3.3 51.8 51.8 0 0 0 5-5.4 15.6 15.6 0 0 1 1.6-2c0 .2-.3 1-.7 1.7m-21.4 22c-.6 3.1-4.5 9.8-5.7 9.9-.1 0 .7-1.7 2-3.7a47.3 47.3 0 0 0 3-5.8l1-2zm10-18.9c-.7-2-2.5-4.4-5-6.6-2.4-2.2-3.2-2.5-1-.5a29 29 0 0 1 6.3 8.8s0-.8-.3-1.7m1.8 25.5c-2.8-.8-10-.7-10.5.1 0 .2 1.6.2 3.8.1a47.3 47.3 0 0 1 8 .3zm-3 1.2c-2.9-.7-10-.3-10.5.6h3.7a47 47 0 0 1 8.2-.1zm-3.2 1.6c-2.8-.7-10 0-10.5.8l3.8-.2a47.8 47.8 0 0 1 8.1-.2z"
        }),
        /* @__PURE__ */ jsx133("path", {
          d: "M346.4 273.5c-2.3-1-8.6-1-9-.3-.2.2 1.3.3 3.2.2a36.1 36.1 0 0 1 5.2.3l1.8.3a9 9 0 0 0-1.2-.5m11.2-8.9c-6 1.7-13 2.7-13.4 4.1 0 .2 2.6-.2 5.2-1.2a56.4 56.4 0 0 1 7.5-2.4c1.5-.3 2.7-.6 2.7-.8 0 0-1 .4-2 .3m7.6-3.7-5.2 1a213 213 0 0 0-8 1.5c-2.4.5-2.9.6-3 .3a1 1 0 0 1-.2-.3 197.6 197.6 0 0 1 16.4-2.5m-1.8-1.5-4.3 1.2a174.5 174.5 0 0 0-9 2.5.9.9 0 0 1-.2-.2 168.8 168.8 0 0 1 13.5-3.5"
        }),
        /* @__PURE__ */ jsx133("path", {
          d: "M362 252.4c-4.1 1.7-12.2 8.8-12 10.5 0 .3 2-1.3 4.4-3.6a64.4 64.4 0 0 1 7-5.8 18.7 18.7 0 0 0 2.6-1.8z"
        }),
        /* @__PURE__ */ jsx133("path", {
          d: "M365 254.4c-4 .3-13.3 4.4-13.5 6 0 .3 2.1-.5 4.9-2a56 56 0 0 1 7.8-3.2l2.8-.8z"
        }),
        /* @__PURE__ */ jsx133("path", {
          d: "M364.8 254.8c-10.3 8.7-16.1 13-18.2 12-.3 0 3.8-2.4 7.3-4.7a78 78 0 0 0 9.4-7l3-2.7a18 18 0 0 1-1.5 2.4m-11 2.8c2-3.4 3-4.4 7.5-7.2 2.9-1.8 3.9-2.4 4-2l-1 .8a56.1 56.1 0 0 0-11.8 10.7zm1.1-9.8c.4-3.8 6.8-16.5 8.2-16.7.2 0-1.5 2.5-2.7 5a57 57 0 0 0-3 7.3 74 74 0 0 1-2.8 7zm-2.7-14.6c-1.1-2.6-1.2-3.6-.4-7.2.5-2.3.8-3.1 1-3v.9a28.7 28.7 0 0 0 .2 11s-.5-.8-.8-1.7m2 13.9a15 15 0 0 0-4.5-6c-2.2-2-2.9-2.3-.9-.4a26 26 0 0 1 4.9 6.6l.7 1.3zm-10 2.9c2-7.4 3.7-6.1 3.7-6.1 4.4 4.2 2.2 18.7 2.2 18.7 0-29.6-5.9-12.6-5.9-12.6"
        }),
        /* @__PURE__ */ jsx133("path", {
          d: "M345.9 249.5c2-7.4 2.5-7 2.5-7 3.7.7 3.5 17 3.5 17-1.6-28-6-10-6-10m-2 5.7c0-5.3 1-4.5 1-4.5 3 2.7 4 13 4 13-4.6-20.8-5-8.5-5-8.5m9-15.5c-.8-2.9-3.6-5.8-6.4-9.5-3.5-3.2-4.6-3.7-1.5-.7 2 1.2 6 7 7.2 10.5.6 1.2 1.1 2.1 1.2 2 .2 0 0-1.1-.4-2.3z"
        }),
        /* @__PURE__ */ jsx133("path", {
          d: "M352.7 237.2a18 18 0 0 0-5.2-7.4l-1.6-1.5A60 60 0 0 1 353 239c.1 0 0-.9-.3-1.8m-15 29.3c-.1 1.5-1.8 5.1-2.4 5.2l.8-2a24 24 0 0 0 1.7-4v.8zm-1.4.9c-.2 1.6-1.9 5.1-2.5 5.2l.8-1.9a24.1 24.1 0 0 0 1.8-4.1v.8zm2.2.1c-.2 1.6-1.9 5.2-2.5 5.2l.9-1.9a24 24 0 0 0 1.7-4.1z"
        })
      ]
    }),
    /* @__PURE__ */ jsx133("path", {
      fill: "#00873f",
      d: "M284 227c0 .8.2 1 .6 1.5V227c-.2-.2-.3 0-.6 0"
    }),
    /* @__PURE__ */ jsxs108("g", {
      fill: "none",
      stroke: "#006300",
      strokeWidth: 0.6,
      transform: "translate(-106.1 -20.4) scale(.85227)",
      children: [
        /* @__PURE__ */ jsx133("path", {
          d: "m455.2 304-.9-.8m1.8-4.6-.8-1m-1.7 13.5c-.3-2.1-1.5-2.8-1.5-2.8m11.3 30c-5.4-6-7.1-16.7-7.1-16.7 1.7-4.6 4-5.6 4-5.6m-4 5.5c-1.8-7-1.3-14.2-1.3-14.2a70.8 70.8 0 0 1 3.4-16.8m-3.5 19.3c1.4-6.6 6.9-5.8 6.9-5.8"
        }),
        /* @__PURE__ */ jsx133("path", {
          d: "M454.8 311c5-2 4.3-6.3 5.2-8 1.3-2.7 2.3-3.5 2.3-3.5m-2.6 32.9c-1.7-4.2.3-5 .3-5m-1 3.6c-2.1-2.7-4.8-2.5-4.8-2.5m3.9-10.3c1.3-2.4 0-4.8 0-4.8m.6 16.3-3.8-4.9m2.3-30.4c.5-2-1-2.9-1-2.9"
        }),
        /* @__PURE__ */ jsx133("g", {
          transform: "translate(442 224.2) scale(.1567)",
          children: /* @__PURE__ */ jsx133("path", {
            id: "do_svg__a",
            fill: "red",
            strokeWidth: 2,
            d: "M91.4 426a6 6 0 1 1-12 0 6 6 0 0 1 12 0z"
          })
        }),
        /* @__PURE__ */ jsx133("use", {
          xlinkHref: "#do_svg__a",
          width: "100%",
          height: "100%",
          transform: "matrix(.1567 0 0 .18128 444.6 235.3)"
        }),
        /* @__PURE__ */ jsx133("use", {
          xlinkHref: "#do_svg__a",
          width: "100%",
          height: "100%",
          transform: "translate(443.7 248.3) scale(.1567)"
        }),
        /* @__PURE__ */ jsx133("use", {
          xlinkHref: "#do_svg__a",
          width: "100%",
          height: "100%",
          transform: "translate(440 252) scale(.16899)"
        }),
        /* @__PURE__ */ jsx133("use", {
          xlinkHref: "#do_svg__a",
          width: "100%",
          height: "100%",
          transform: "translate(438.7 256.2) scale(.16899)"
        }),
        /* @__PURE__ */ jsx133("use", {
          xlinkHref: "#do_svg__a",
          width: "100%",
          height: "100%",
          transform: "translate(440.3 257.8) scale(.16899)"
        }),
        /* @__PURE__ */ jsx133("use", {
          xlinkHref: "#do_svg__a",
          width: "100%",
          height: "100%",
          transform: "translate(463.2 286) scale(.12289)"
        }),
        /* @__PURE__ */ jsx133("use", {
          xlinkHref: "#do_svg__a",
          width: "100%",
          height: "100%",
          transform: "translate(464.3 287.3) scale(.12289)"
        }),
        /* @__PURE__ */ jsx133("path", {
          d: "M458.8 316.6a1.8 1.8 0 0 0-1.1-1.2m14.7 24.1c1.6 1.2 2 .5 2 .5"
        })
      ]
    }),
    /* @__PURE__ */ jsxs108("g", {
      fill: "#006300",
      children: [
        /* @__PURE__ */ jsx133("path", {
          d: "M298.2 271.8c-.9-3-.7-3.6-.7-3.6m-6.5-1.7s-.5-1.2.4-1.9c.4-.4 2.5.8 3.6-3.9 0 0-.7 0-2.1.7v-.4s-.4-1-.2-2.3c0 0 .7-1.1.7-1.6 0 0-1.3-.5-4 2.9 0 0-.2-.7-2.1-2 0 0-1 3-.5 4.6.4 1.3.4 1.8 1.8 2.7 0 0 1 .5 1.2 2l1.2-.1zm-2 3.4c-.3.2-.5.5-1.3.6-3.3.4-5.2-4-5.2-4-.1-1 .3-.5 1-.2.9.3 1.2 0 2.2 0 1.4-.2 2.9 1.1 2.9 1.1.8.8 1 2.3 1 2.3-.2.2-.5.2-.5.2zm-4-8c-3.4-1.5-5.5.2-5.5.2-.2.2.2.3.2.3 2.2.3 1.5.1 2.4 1.4 1.6 2.2 4.4 1.7 4.4 1.7.5.2 1.1.8 1.1.8-.2-1.9-2.5-4.4-2.5-4.4zm-6-14c-.7-.5-.6.4-.6.4-1.4-2.5-5.3-2.7-5.3-2.7a.7.7 0 0 1-.5-.3c-.6 0 .2 1.3.2 1.3 1.1 3.1 2.2 3.5 2.2 3.5-1.3.7-3.4-.9-3 .3 2.1 2.1 3.5 2.4 3.5 2.4 2.6.7 3.7 0 3.7 0 .6 1.1 1 1.3 1 1.3 2.4.7 2.9 2 2.9 2 0-2.6-1-5.7-1-5.7a12 12 0 0 0-3.1-2.5"
        }),
        /* @__PURE__ */ jsx133("path", {
          d: "M297.2 272.7c-1.3.4-1.4 1.3-1.4 1.3-1.2 1.7-5.6 0-5.6 0-1.4-.3-1-.7-1-.7a5.6 5.6 0 0 0 1.6-1 8.6 8.6 0 0 1-2.7-5c3.6-.7 4.7 0 4.7 0-.2-1.4-1.4-1.4-1.4-1.4-.3-.5.3-.5.3-.5a7.8 7.8 0 0 1 5 2.3c1.2 1.7.8 3.4.8 3.4.3 1.7-.3 1.6-.3 1.6M282.3 258c-1.8-.5-2.8 0-2.8 0-1 .4-2.6-.6-2.6-.6-2.2-1.9-2.6-3-2.6-3 0-.3 1.9-.3 1.9-.3 2.6 0 3.2.5 3.2.5 1.3.7 1.2 1.4 1.6 1.7a5 5 0 0 1 1.4 1c.3.5.4.9-.1.7m3.4 1c1.3-1.5 3-.5 3-.5 2.5.3 3.3-2.6 3.3-2.6l1-1.7c.1-.7-1.1-.1-1.1-.1-2.2.5-2.3.7-2.3.7l.4-3.4c0-.6-.6-.2-.6-.2-3.1 1.8-3.5 3.1-3.5 3.1l-1.3-2.4c-.4-1-.7.1-.7.1-.6 3-.3 3.2-.3 3.2.4 1.6.8 2 .8 2 .7 1 .7 1.4.7 1.4z"
        }),
        /* @__PURE__ */ jsx133("path", {
          d: "M304.2 267c-.5.1-1.8 2.2-1.8 2.2-1.6-3-3.7-3.4-3.7-3.4-.4.1 0 .8 0 .8.7 1.6 0 2.8 0 2.8-.2 1.2 0 1.4 0 1.4-2.5-1.3-2.6-1.1-2.6-1.1 0 1.6 1.8 4.5 1.8 4.5l4.5-1 1.5-.2c1.2-3.6.3-6 .3-6M284 250.8c1.6.7 1.7 1.8 1.7 1.8.4 1.3 4.1 1.7 4.1 1.7 3-.3 2.7-1 2.7-1-1.7-1.4-1.2-1.3-2-2-1.3-1.3-3-1.4-3-1.4-2.3.4-2.8 0-2.8 0-.9.4-.7.9-.7.9m-3.6-5.4c-.7-2.7 1.7-6 1.7-6 2 3.8 1.7 4.8 1.7 4.8a24.6 24.6 0 0 1-1.7 4.5c-.4-2-1.4-2.3-1.7-3.3"
        }),
        /* @__PURE__ */ jsx133("path", {
          d: "M279 246.5c-2.5 0-5-2.9-5-2.9 3.9-1 4.7-.4 4.7-.4a22.7 22.7 0 0 1 3.6 2.5c-1.8 0-2.3.8-3.2.8z"
        }),
        /* @__PURE__ */ jsx133("path", {
          d: "M277 242.8c-1.6.3-3-1.3-3-1.3-2.2-3-1.5-4-1.5-4 .2 0 .4.3.4.3.7.6 2 .8 2 .8-3.6-2.2-1.2-7.1-1.2-7.1.4-.5.6.7.6.7a4.6 4.6 0 0 0 1.8 2c.8 1 .8 1.4.8 1.4.3-1.6.8-1.2.8-1.2.4 1.3 1.9 2.3 2 3.2.6 2.5.2 2.8.2 2.8-.3 1.4-.3 2.5-.3 2.5-1.4-.5-2.5 0-2.5 0zm8.4 6c.8-1.2 0-3.3 0-3.3-.3-2.3 3.1-4.5 3.1-4.5 1 1.9.9 3 .9 3l3.2-.8c.1 1.4-1.3 3.6-1.3 3.6 2.1.6 2.9-.4 2.9-.4-1 4.7-5.6 3.8-5.6 3.8a8.8 8.8 0 0 0-3.2-1.4"
        }),
        /* @__PURE__ */ jsx133("path", {
          d: "M278.3 234.9c.3-2.9.8-3 .8-3 .3.1.4 1.4.8 1.6 1.8.8 1.8 2.8 1.8 2.8 0 2.3-.4 2-.4 2-2.5 0-3-3.4-3-3.4m8.3.6c.9-3.3.3-3.6.3-3.6-.3 0-1 1.3-1.6 1.4-2.3.1-3 2.3-3 2.3-1 2.5-.5 2.4-.5 2.4 2.8 1 4.5-1.4 4.8-2.5"
        }),
        /* @__PURE__ */ jsx133("path", {
          d: "M278.4 229.5c.3-3.3 1-3.5 1-3.5.3.2.5 1.7 1 1.9 2 1 2 3.2 2 3.2 0 2.7-.4 2.5-.4 2.5-3 0-3.7-2.9-3.6-4zm9.4.8c1-3.2.4-3.5.4-3.5-.4 0-1.1 1.3-1.6 1.3a3.7 3.7 0 0 0-3.2 2.2c-.9 2.5-.4 2.5-.4 2.5 2.7 1 4.4-1.3 4.8-2.5m3.8 9c2.7-2 2.5-2.6 2.5-2.6-.3-.2-1.7.4-2.1.2-2-1.3-3.9 0-3.9 0-2.2 1.4-1.8 1.6-1.8 1.6 1.6 2.5 4.4 1.6 5.3.9z"
        }),
        /* @__PURE__ */ jsx133("path", {
          d: "M291.5 241.1c2.6-1.1 2.5-1.6 2.5-1.6-.2-.3-1.5 0-1.8-.3-1.4-1.2-3.1-.6-3.1-.6-2.1.8-1.8 1-1.8 1 .9 2.2 3.3 2 4.2 1.5m-8.7-15.4c-1-3 2-7 2-7a40.5 40.5 0 0 1 1 3.4c2.4-2.5 4.6-2.9 4.6-2.9l-.1 2a6.8 6.8 0 0 0 2.3-.6c-.4 2.4-3.4 4.9-3.4 4.9-1.2.7-2.6.4-2.6.4-2.2.7-2.7 2.1-2.7 2.1-.2-1.3-.4 0-1.1-2.3m4.4 10c1.4-1.7 3.5-1 3.5-1 2 .2 3.7-1.8 3.7-1.8a5.6 5.6 0 0 1 1.4-1.8c0-.5-.6-.4-.6-.4l-1.1.3c.9-3.3.4-3.4.4-3.4-.3 0-.5.2-.5.2-.5 1.5-2.6 1.4-2.6 1.4-.1-2.2-.6-1.9-.6-1.9-.3.6-1 1-1 1-2.1 2-2.1 2.9-2.1 2.9.1 2.4-.5 4.6-.5 4.6z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs108("g", {
      fill: "#00863d",
      children: [
        /* @__PURE__ */ jsx133("path", {
          d: "m286.8 247.7 1.4-1c.5-.3.3-.2.5-.7l.5-.7-.3.9 1.4-.8c0 .3-.5.5-.9.8a22.6 22.6 0 0 1-1 .6l-1.9 1.6c1.8-.4 1.4-.1 2.3-.2 1.9-.3 2.8-3 3.4-4.5a9.9 9.9 0 0 0-3.5 1.1c-1.2.8-1.2 1.6-1.9 3zm-4.8 6.7c0-.3-.4-.8-.6-1-.5-1-.5-1.2-1.2-2.3l-.5-1c.2 0 .6.8.9 1v-1c.3 0 .2.3.2.6 0 1 0 .9.6 2l1.3 2.2c0-.4-.2-.7-.3-1-.4-1.4.5-3.1-3-5.2l-.9-.5c0 1.7.3 4.5 1.8 5.4l1 .4zm-.8-21.5c0-.4-.3-.8-.4-1.3-.2-.4 0-.3-.4-.5l-.4-.5.5.2a3.3 3.3 0 0 0-.4-.8c-.3-.4-.2-.1-.5-.7.6-.1 1.2 1.7 1.3 2.1.5 1.4.4 1.2 1.3 2.3 0-.2-.4-.5-.4-.8-.2-.7.6-1.7-.2-3.4-.5-1-1.5-1-2-1.9l-.4-.8a7.6 7.6 0 0 0-.4 1.8c0 1.2.2 2.7 1 3.5.3.3 1 .7 1.4.8m4.5-8.5c.2 0 .5-.5.8-.8l.8-.7-.1-.8c.2 0 0 0 .3.5l1-1.4c0 .3-.4 1-.6 1.2-.2.4-.4.7-.8 1l-1.6 2 1-.3c1-.2 1.4-.3 2.1-1.5a10 10 0 0 0 1.2-3.8c-1.5.6-3.1 1.3-3.9 2.7-.3.5-.2 1-.2 2zm-9.5 14.3c-.5-1-1.7-2.4-1.8-3l-.2-1.3c.3 0 .2 0 .2.2l.2 1 .5 1c0-.7 0-.4.2-1 .3.4-.1 1 .2 1.6l.8 1.2c0-1 .6-2.4-.4-3.7-.4-.5-.8-.7-1.3-1l-.9-1.4c-.7 1.5-.5 4.5.9 5.5l.8.5.4.2zm6.8-6c.6-.4.4-.6 1.8-1.7l.9-.9.9-.9c.1.3-.8 1.2-1.1 1.6h.6c-.1.4-.5.1-1 .3-.3 0-1.4 1.3-1.7 1.6l.8-.2c.9-.2 1.5 0 2.4-1.2.8-1 1-2.3 1.5-3.5-1.2.3-2.7 1-3.4 1.6-1 1-.9 1.7-1.2 2.6zm-4.8 9.3a4.9 4.9 0 0 0-.8-.8c-.5-.3-.6-.3-1.2-.4l-2-1.1c.2-.2.3.1.8.4l1 .4-.2-.5c.2 0 .2 0 .3.2v.3c1 .1.8.1 1.7.7 0-.4-.1-.4-.4-.6l-.5-.5-.4-.6c-.8-1.2-1.7-.7-2.2-.8l-1.5-.6a5.6 5.6 0 0 0 1.7 3.1c.4.4.9.8 1.6.9zm-.8 7.5a8.1 8.1 0 0 0-1-.7c-.2-.2-.3-.2-.6-.2l-.7-.2h.7l-.3-.3-1-1c.2-.1.3 0 .5.2l2.3 1.8 1.1.6c0-.6-1-2.4-1.8-2.8l-3.7-1a15 15 0 0 0 1.5 2.8c1 1.5 1.2 1 2 .9zm1.8-8.1-1.4-4.6c.2.1.2.4.3 1l.4.9.3-.7c.2.2 0 .6 0 .9-.2.4-.2.3 0 .8l.6 1.6v-1c.3-1 .5-1.6 0-2.8-.5-1-1.3-1.7-2-2.5l-.3 1.8c-.2 1.2-.1 2.8.8 3.5.8.6.3.1 1.3 1zm2.7 5.8v-4.7c.2.1.2.3.2.4v1.5l.4-.7c.3.1 0 .4-.1.6l-.4.8.1 2.1.4-.8c.5-.7 1-1.8.8-2.8l-1.2-3.4-.8 1.6a7.3 7.3 0 0 0-.5 1.9c-.3 1.6.2 1.9.7 2.7zm1.9-20.3c0-.4.2-2.5.1-2.7l-.2-.4-.2-.9c.3 0 .2.3.4.6v.1l.1-.6c0-.4 0-.2.2-.6.2.1 0 0 .1.2a3 3 0 0 1 0 .3c-.2 1.4-.2 3-.3 4.3l.4-.8c.3-.7 1-2 .9-2.8l-.8-4.1-.8 1.6c-.5 1.1-1 2.8-.7 4l.7 1.6zm-11 23.6 1.1 1c.7.5 2.3 1.2 3.1 1.2l1.8-.4-.2-.8-1 .1a6.7 6.7 0 0 1-1.2 0 14.8 14.8 0 0 1-1-.2c-.6-.2-.4 0-.9-.4l2 .3c-.6-.4-.4-.2-.8-.7.3 0 .9.5 1.2.7l1.6-.1-.1-1c-.8-.3-2-.3-2.9 0-1.7.6-1 .4-2.7.3m2.2 4.3c0 .3 1.8 2.3 2.2 2.5l3.9.1a16.1 16.1 0 0 0-1.7-.7c-.8-.3-.8-.2-2 0 0-.3.3-.3 1-.4l-1.5-.5-.2-.2h.5l4 1.5a4.5 4.5 0 0 1-1.1-1c-1.6-2-3.2-1.4-5.1-1.3m13.3-21.3.5-1c.3-.7-.1-.7 0-1.5.3 0 .2 0 .3.7l.7-1.6c.2.6-.9 2.6-1.1 3.2l-.4 1c1-1 2-1.5 2.2-2.4l.1-4c-.6.5-1.5 1.4-2 2.1-.6 1-.6 2-.4 3.5zm-1.8 24.2 1-.5c1.5-.4.9.3 1.8-1l-.2.7c.7-.3.8-.7 1.3-1.2.2.3-.2.7-.4.9-.9.8-1.7.5-2.2.7l-1 .5c1.1-.2 1 0 2 .2 1.8.3 2.4-1.6 3-2.8l.5-.8a9.6 9.6 0 0 0-4.5 2.2l-.6.6c-.3.2-.5.2-.7.5"
        }),
        /* @__PURE__ */ jsx133("path", {
          d: "M286.4 247.5c.6-.6.5-2.1 1-3 0-.2.2-.3.3-.4.1-.2 0-.2.3-.2.1.2-.3.4-.4.7l-.3 1 .1-.1a.9.9 0 0 0 .1-.2c.5-.6.9-.8 1.6-1.2l-.7-2.4-1.2 1a5.6 5.6 0 0 0-1 1.2c-.8 1.5.1 2.2.2 3.6m-.4 10 1.6-2.6v-1.2c.2 0 .1-.1.3.7.5-.8.2-.7.8-1a6 6 0 0 1-.8 1.4l-1.5 2.5c.4 0 .9-.6 1.1-.9l.6-.5.7-.4.7-3.6a10 10 0 0 0-2.7 2c-1 1.2-1 1.6-.8 3.6m3.5-9 2-.3c0 .3-.3.3-.9.4l-3.6.1.9.5.8.4c.7.4 1.4.3 2.1 0l2.7-2.4c-1.4.3-.6.4-2.5 0l-1 1zm-14.5-5c.6 1.2 2.3 2.6 3.8 2.4.7 0 .8-.3 1.2-.7h-.1a.7.7 0 0 0-.2-.1c-1.2-.3-1.3-.2-2.5 0l.5-.3-.9-.2-.8-.4c.2-.1.1-.1.4 0 1.5.5 1.9.4 3.6.7-.2-.5-1.5-1.2-2.2-1.3-1.2-.1-1.6.5-2.8-.1m10 13.6-.5-3.3c.3 0 .2.2.3.9l.6 3c0-1.2.4-2 .1-3.2l-1.2-2.2a9 9 0 0 0-.3 2.7c0 1 .3 1.3.8 1.9zm4.5-33.7.4-.5.5-.4c0 .3-.4.6-.6 1-.4.5-.7.6-.9.8-.7 1-.6.8-1.8 1.3 2.4.2 3.8-2.4 4.8-4.2-2.3.3-1.9.5-2.1 1.2zm.8 10.4.7-1.1c.4-.6.6-.2 1.3-.8-.2-.2-.2-.1-.9.1l1.2-1.5c-.7.1-2 2.3-2.3 2.8l-.8.9c.5-1.4.3-2.7 1-3.3l3.7-2.3c-.1.9-.5 2.1-.9 3-.6 1.1-1.5 1.6-3 2.2m-9.2 4.4-1.1-1.6-.5-2.2c.3 0 .3.6.3.9l.3 1c.2-.8-.1-.3.3-1 .2.5-.3 1.1 0 1.5l.7 1c.3-1 .3-2.3-.3-3l-1.7-1.8c-.4.6-.4 2.4 0 3.3.3 1 .7 1.2 1.3 1.5zm1.4-.3c.5-.5 1.5-1 1.7-1.3l1.4-2c-.3-.1-.5.5-.7.7l-.6.9c0-.8.2-.2 0-1-.4.4-.2 1.2-.6 1.5l-1.1.8c0-1.1.5-2.5 1.4-3l2.5-1.4c.2.9-.5 2.8-1.1 3.6-.8 1-1.2 1-2 1zm4.6.3c.6 0 2.5 0 3-.4l.8-.3c0 .2 0 0-.3.4h1.1c0 .1.2.1-.6.2l-2 .2-2.7.3c1.8.6 2 1.6 4 .8 1.6-.6 2-1.2 3-2.4-2.6.6-2.8-1.5-5.2 0z"
        }),
        /* @__PURE__ */ jsx133("path", {
          d: "M290.4 239.7c.6 0 .3 0 .9.2-.3.2-1.4 0-1.8 0h-1.8c.6.8 1.6 1.2 2.9 1 1.3-.1 1.7-.4 2.7-1l-2-.7zm-.8 11.5a3.2 3.2 0 0 0-.9-.5c-1-.5-2 0-2.5 0l-1.3-.2a6 6 0 0 0 2.4 1c1.7.3.5.7 2.3-.3m.2 1.2.5.5c-.1 0-.3 0-.5-.2l-.1 1.2 2.3-.3a17 17 0 0 0-2-2.2zm-3 .7 1.4-1c-.3-.4-1-.3-1.5-.5l-1.3-.5.7 1zm6.7-20.6c-.6.4-1 .9-1.7 1.2-.9.4-1.8 0-2.4.6 1.5-.1 2.5.5 3.7-.6.8-.7 1.4-1.7 2-2.6a2.7 2.7 0 0 0-1.2.4l-.3.5c-.3.4 0 0 0 .5zm-5 35 1 2.2 1.6 2 1-.7 1.3-.4c-.7-.3-.7-.6-1.1-.7h-1.7c.1-.3 0-.2.8-.2h.8c-.5-.5-1.1-.8-1.6-1.2l1.6.9v-1.1c.4 0 .1.7.3 1.3.1.2.6.6 1 .7.5.3.7.2 1.2.4l1.3.4c-.5-.8-.2.1-1.1-1.8a3.4 3.4 0 0 0-1.4-1.6c-1.5-.9-3.3-.3-5-.2m1.9-2.3v-2.7l-.3-2.1c.2 0 .2.1.3.4l.1.6c.2-1 .3-1 .8-1.6 0 .2-.5 1-.6 2l-.1 2.7.2-.3.3-.3.5-.6c1.3-2 .5-3.2.5-3.8l.4-2a9.5 9.5 0 0 0-1.8 1.3c-1 1-2 2.8-1.3 4.3l.5 1 .4 1.1z"
        }),
        /* @__PURE__ */ jsx133("path", {
          d: "m289.7 273 1.8.6c1.1.4 3 .5 3.8-.6.5-.6.8-.7 1.3-1.2-.8 0-1.5.4-2.2.5-.6.2-.6.6-1.1 1l-.4.3c0-.3.5-.8.8-1.1h-1.8c0-.3.6-.2 1.3-.2 1.5-.2 1.8-.6 3.4-.8a.7.7 0 0 0 .3 0c-2.4 0-3-1.7-5.9.4zm11-1.5v-1.2c-.5-.4-.5-.6-.8-1.2.3 0 .4.5.9.8 0-.6-.3-1.6-.5-2.2.3 0 .4.8.5 1.1.4 1.4 0 2.5.3 3l.7 1c.2-1 1.3-1.7 0-4.1-.7-1.5-1.3-1.8-2.5-2.7.1.7.3 1 .2 1.8l-.4 1.6c-.2 1.3.3 1.2.5 1.3zm-12-2.3-.3-.8c-1 0-1.3.4-2.8-.6-.3-.2-.3-.2-.5-.6l1.6 1-.6-1c0-.1 0-.2.1 0h.2l.7 1h1l-.2-.7c-.1-.4 0-.4-.3-.6a2.8 2.8 0 0 0-1.4-.6l-1.6.2-1.6-.3c0 .3.7 1.3.8 1.6.7 1 2.5 2.3 4 1.7zm-8.4-7.5h.1l.2.1a3 3 0 0 1 1.1.8c.5.4.5.7 1.1 1.2 1 .9 2.1.8 3.5 1a7.2 7.2 0 0 0-.6-.7c-1.1-1.2-1-1.1-1.6-1H283c0-.2.7-.2 1.2-.3a3.1 3.1 0 0 0-.7-.3c-.6 0-.2 0-.9-.2.3-.4 1.8.2 2.5.8l1.6 1.8-.8-1.7c-.8-1.5-3-2-4.5-1.7a4 4 0 0 0-1 .2zm9.5 3.9c-.5-1.8-1.5-2.6-1.7-3.7-.2-.7-.1-.7 0-1.4.4.5-.3.8.8 2.6 0-.6-.2-.8-.1-1.5l.4-1.4c-.1-.3-1.4-1.5-1.7-1.9-.2 1.6-.6 3-.1 4.6.5 1.6 1.4 1.3 2.4 2.7m8.6 8 1.1-.2a6.3 6.3 0 0 1-.7-1c-.5-.7-.4-.7-.2-1l.1.6.4.4c.2.4.4.6.8.9 0-.6-.2-.8 0-1.2.2.1 0 0 .1.2l.1 1 1.3-.4c-.9-1.5-2.5-2-4-2.6l.4 1.8zm-2-3.2-.5-1c-.4-1-.4-1.3-1.2-2.2l-.4-.4-.3-.3v-.1c.2 0 .8.6 1 .8.5.4 1.6 2.8 2 3.5-.1-.3-.3-.7-.2-1 .4-1-.5-2.4-1-2.7l-3.5-1.5c.4.4.7.6 1 1.2.2.6.3.1 1.2 1 1 1.1 1 2.4 2 2.7z"
        }),
        /* @__PURE__ */ jsx133("path", {
          d: "m302.9 270.4.1-.5c.2-.3 0-.2.3-.4.2.2 0 .3-.1.7l-.7 2.5c.8-.1.7-.1 1-.7.3-.4.4-.9.5-1.3l-.1-3.3-1 1.3c-.5.7-.2.3 0 1.7m-10.6-7.5c.3-.1.8-.8 1.1-1 .1.2-.5.9-.7 1-.6.6-.2 0-1 1 1.6.2 2.2-1.8 2.7-2.8l-1.5.4c-.2.1-.1 0-.2.3l-.1.4c0 .3-.2.5-.3.8z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs108("g", {
      fill: "#ce1126",
      stroke: "#000",
      strokeWidth: 0.2,
      children: [
        /* @__PURE__ */ jsx133("path", {
          d: "m307.6 281.8 1.9 1-1.1 2.1c.8-.1 3.6-1.1 4.6-1.4-.3-.7-.4-.7-.3-1.6l-.3-1.5-2.3.8a19.2 19.2 0 0 1-2.5.6zm24.8-.3-1.9 1 1.1 2c-.8 0-3.6-1-4.6-1.3.3-.7.4-.8.3-1.6l.3-1.5 2.3.8z"
        }),
        /* @__PURE__ */ jsx133("path", {
          d: "M314.4 284.8a12.4 12.4 0 0 0 4-1.4c.4.3 2.1 0 2.1 0a8.8 8.8 0 0 0 1.1-.2 10.1 10.1 0 0 0 3.8 1.6c1.9-.1 2-1.6 2-1.6l-.3-1.3c1-1.6 0-2.8 0-2.8-.6-.6-3.5.3-3.5.3-2 1-2 .5-2 .5-.6-.8-2.6-.7-3.5 0l-2.5-.6c-2.2-.9-2.5-.4-2.5-.4-.8 1-.5 2-.5 2l.1 1c-.4 2.8 1.8 3 1.8 3z"
        }),
        /* @__PURE__ */ jsx133("path", {
          d: "M321.6 282.4c4.7 1.1 4.4 1.8 4.4 1.8-.3.5-1.7-.2-1.7-.2-3.6-1.2-2.7-1.6-2.7-1.6zm-2.9 0c-4.7 1.1-4.3 1.8-4.3 1.8.3.5 1.6-.2 1.6-.2 3.7-1.2 2.7-1.5 2.7-1.5z"
        }),
        /* @__PURE__ */ jsx133("path", {
          fill: "#aa241e",
          d: "M319 279.3c-2 .3-.5 1.8-.4 2.8 0 .5-.5 1.3 0 1.5.5.3 1.5 0 2.1 0 .8 0 1.3 0 1.2-1 0-.7-.3-1-.3-2 0-.6.1-1.4-.6-1.4a12.5 12.5 0 0 0-2 0z"
        }),
        /* @__PURE__ */ jsx133("path", {
          fill: "none",
          d: "M321.7 280.4c5.3 0 5-.9 5-.9m-5 2.5c5.4.7 4.7 1.5 4.7 1.5m-7.9-1.6c-5 1-4.5 1.9-4.5 1.9m4-3.5c-5.1.3-4.6-.5-4.6-.5"
        })
      ]
    }),
    /* @__PURE__ */ jsx133("path", {
      d: "M298.1 274c-2.7 1-4.5 1.6-7 3.1l-3.3-5a7 7 0 0 0-2.2-1.8c-1.5-.7-2-.5-3 .3l-.6-1.3c-1.3-2.3-2.7-3.3-4.1-5.2l-1.4-1.5-.4-.5c.5 1.9 1 3.6 1.3 5.7-.8-.5-1.6-1-2.4-1.3a9 9 0 0 0-3-.5l1 .9a11.8 11.8 0 0 1 3.3 5.5 16.7 16.7 0 0 0 4.2 6.5 7.9 7.9 0 0 0 2 1.5c2 .8 1.9 0 2.6-.3a31.2 31.2 0 0 0 4.2 5.8 8 8 0 0 0 7.5 1.9c1.2-.3 2-.7 3-1.2 3.4-2 1.7-3.6 1.3-5.2a109 109 0 0 1 7.2-2c5.6-1 16-1.2 22.7-.2.6.1 7.3 1.9 8 2.3a5.4 5.4 0 0 0-.6 2.9c0 1.1 1 1.7 2 2.2a10 10 0 0 0 6.4 1.3 7.7 7.7 0 0 0 4.9-3.2c1.8-2 2.3-3.2 3.2-4.7 0 0 .5.5.9.6.3.1 1.5 0 1.8-.2.8-.3 1.4-1 2-1.5a15.5 15.5 0 0 0 4.1-6.6 12 12 0 0 1 4.3-6.3c-2.8.1-3.8.9-5.4 1.8l.6-3 .7-2.7-3.5 4c-.5.8-1.1 1.4-1.7 2.1-1.1 1.8-.9 1.8-1.3 2.4-4-2.2-5.8 3.1-8.4 6.4-5-2.8-9.3-3.6-15.2-4.7l-3.5-.4a88.7 88.7 0 0 0-22.7.2c-3.8.5-6.1 1.2-9.5 2z"
    }),
    /* @__PURE__ */ jsxs108("g", {
      fill: "#ce1126",
      children: [
        /* @__PURE__ */ jsx133("path", {
          d: "M293 285.5c.5-1.3 1-1.6 2.2-2.1 3.6-1.7 5.4-2.4 9.5-3.5a53.1 53.1 0 0 1 7.2-1.3 67.4 67.4 0 0 1 12.3-.4 54.5 54.5 0 0 1 20.6 5.1c1.5.7 1.3.8 2.2 2.2 1-.8 1.9-2.4 2.5-3.4l1-2c.4-1.1-.3-1.5-.8-1.9-1.8-1.6-5.3-3-8.3-3.8a86.5 86.5 0 0 0-42.7 0 24.8 24.8 0 0 0-9 4.4c-.8.9.4 2.5.8 3.2l1 2z"
        }),
        /* @__PURE__ */ jsx133("path", {
          d: "M280.5 274.2c1.4.3 2 .7 2.9 2 2 2.8 2.1 4.8 5.6 8.6a6 6 0 0 0 2.6 2.1 7.5 7.5 0 0 0 4.2.6 9 9 0 0 0 3.5-1.2s1.3-.7 1.7-1.2c.3-.4.4-1.5.4-1.5-1-.3-3 1.7-4.2 2.5-2.2 1.5-3 1-4.7-.5-1.3-1.1-1.8-2.4-2.7-4-.4-.6-1-1.5-.8-2.5l1.7-1.7-2.1-3.2c-.8-1.3-1.3-2.2-2.4-3-.6-.5-1.9-1.2-2.8-.7l-2 2c-.3.5-.7 1-.9 1.7"
        }),
        /* @__PURE__ */ jsx133("path", {
          d: "m278.1 268.8-2.1-1.3-2.7-1 1.5 1.7c1.6 2 1.6 3.8 3 6.4a16.3 16.3 0 0 0 4.2 5c1 .8 1.9 1 2.4.3.1-.5-1.1-1.3-1.7-1.6a11 11 0 0 1-2.1-1.4c-1.6-1.6-.4-3.5.8-4.9l.8-1c.2-.6-1.1-2.4-1.8-3.3-.7-.9-2.5-3-3.4-3.8l.5 2.5zm23.2 14.3-.6-1.5c-.9.1-5.1 2-6.1 2.6-.3.2-1.5 1.1-1 1.7 1.7 1.8 4.2-.8 5.6-2a3.1 3.1 0 0 1 2-.8z"
        }),
        /* @__PURE__ */ jsx133("path", {
          d: "M285 279.7c-.3-.1-.3-.6-1.2-1.3-.4-.3-2.6-1.5-3-1.9 0 0-.6-.5-.6-1.2.1-.6.6-.7.6-.7 2 0 4.2 4.8 4.1 5zm74.6-5.4c-1.5.3-2 .7-2.9 2-2 2.8-2.1 4.8-5.6 8.6-.8.9-1.4 1.6-2.7 2.1a7.5 7.5 0 0 1-4.1.6 9 9 0 0 1-3.6-1.2s-1.3-.7-1.6-1.2a3.8 3.8 0 0 1-.4-1.5c1-.4 3 1.7 4.1 2.5 2.3 1.5 3.1 1 4.7-.5 1.4-1.1 1.9-2.4 2.8-4 .4-.6 1-1.5.8-2.5l-1.7-1.7 2-3.2c1-1.3 1.4-2.2 2.5-3 .6-.5 1.9-1.2 2.8-.7l1.9 2c.3.5.8 1 1 1.7"
        }),
        /* @__PURE__ */ jsx133("path", {
          d: "m362 268.9 2.1-1.3 2.6-1-1.4 1.7c-1.7 2-1.7 3.8-3 6.4a16.5 16.5 0 0 1-4.2 5c-1 .8-2.1.8-2.4.3-.1-.5 1-1.3 1.7-1.6.8-.4 1.5-1 2.1-1.4 1.6-1.6.4-3.5-.8-4.9l-.8-1a9 9 0 0 1 1.8-3.3l3.3-3.8c0 .7-.3 1.7-.5 2.5zm-23.2 14.3.6-1.5c.9.1 5.1 2 6.1 2.6.3.2 1.5 1.1 1 1.7-1.7 1.8-4.2-.8-5.7-2-.5-.3-1.1-.8-2-.8"
        }),
        /* @__PURE__ */ jsx133("path", {
          d: "M355.2 279.8c.2-.1.2-.7 1.1-1.4.4-.3 2.6-1.4 3-1.8 0 0 .6-.5.5-1.2 0-.6-.5-.7-.5-.7-2 0-4.2 4.8-4.1 5z"
        })
      ]
    }),
    /* @__PURE__ */ jsx133("path", {
      fill: "#eac102",
      d: "M297.4 277h-.6l-.9.4v.3c.2 0 .1.3.2.5l.2.6.2.8.2.8c0 .1-.2.4 0 .3l.7-.2c.1 0 .3-.2 0-.2-.1-.1 0-.4-.2-.6l-.1-.6c0-.2.3 0 .3.1l.5.5.6.3a.8.8 0 0 0 .6 0c-.3-.2-.6-.4-.7-.7l-.5-.6c.2-.2.5-.5.5-.8a1 1 0 0 0-.4-.9 1.3 1.3 0 0 0-.6 0m-.2.2c.2 0 .3.2.4.3.1.2.2.4.1.7a.6.6 0 0 1-.3.4c-.1.1-.4.3-.5 0l-.2-1c0-.2.1-.3.3-.3a1 1 0 0 1 .2 0zm1.4-.7c0 .1.3.2.2.4l.2.7.2.7v.5l.2.6c0 .1-.2.3 0 .3l1.8-.5c.2 0 .2 0 .2-.2v-.6c-.2 0-.2.3-.3.4l-.9.4c-.1 0-.2-.1-.2-.3l-.1-.4-.2-.7h.7c.1 0 .2.2.3 0v-.5c-.1 0-.1-.4-.3-.3 0 .1 0 .3-.2.4a1.5 1.5 0 0 1-.5.1l-.1-.5c0-.2-.1-.5.1-.5a.8.8 0 0 1 .8 0c.1 0 .3.3.3 0 0-.1 0-.4-.2-.5h-.5zm4.1-1.1h-.7l-.8.3c-.2.1.2.2.2.4v.5l.2.5.1.8.1.7v.4c.2 0 .5 0 .7-.2.2 0 .2-.1 0-.2v-.5l-.2-.6a2 2 0 0 0 1-.5.9.9 0 0 0 .4-.7 1.1 1.1 0 0 0-.2-.7 1 1 0 0 0-.4-.2zm-.3.2a.5.5 0 0 1 .5.4l.1.7c0 .1-.1.3-.3.3l-.4.2-.1-.4-.2-.8c0-.2 0-.3.2-.3a.8.8 0 0 1 .2 0zm3.3-.9.3.3v.5l.2.6v.5l.1.7a.6.6 0 0 1-.7.5.4.4 0 0 1-.3-.2 1 1 0 0 1-.2-.5l-.1-.7a7.9 7.9 0 0 0-.1-.7l-.1-.5c0-.1.2-.3 0-.3l-.8.1c-.2.2.1.2.1.4l.1.5.2 1v.5c0 .2.2.3.3.5.1.1.3.3.5.3.4 0 .8 0 1.1-.3l.3-.5-.1-.8-.1-.8-.1-.6a.5.5 0 0 1 0-.3c0-.1.2-.3 0-.3h-.4a.2.2 0 0 0-.2.1m2.6-.5-1 .2-.5.1.2.4c0 .4 0 .8.2 1.1v.7l.1.8c0 .1-.2.3 0 .3l.5-.1a4.2 4.2 0 0 1 .6 0 3.8 3.8 0 0 0 .7-.3l.3-.3a.6.6 0 0 0 .2-.4c0-.2 0-.5-.3-.7l-.4-.2c-.1 0-.3-.1 0-.2a.8.8 0 0 0 .3-.5.6.6 0 0 0-.1-.5c0-.2-.3-.3-.5-.3a2 2 0 0 0-.3 0zm-.5.3c.3 0 .5 0 .7.2v.6c0 .2-.2.3-.4.4-.1 0-.4.1-.4-.1v-.5a4 4 0 0 1 0-.5zm.3 1.5.5.1c.2.1.2.4.2.6l-.1.5-.6.2c-.2-.1-.2-.4-.2-.5v-.9a.5.5 0 0 1 .2 0m1.7-2s.2 0 .1.2l.1.6v.5l.1.7v1.2c-.1.1.1 0 .2 0h1.2l.6-.1v-.9c0 .2-.2.3-.3.4a.7.7 0 0 1-.3.2h-.3l-.4-.1v-.7l-.1-1.2v-.7c0-.1.2-.3 0-.3h-.4l-.4.1a.8.8 0 0 0-.1 0zm2.5-.3.1.2.1.4v.4l.2 1.6v.4s-.2.2-.1.3a4 4 0 0 0 1-.1l-.1-.2-.1-.4-.1-.7v-.6l-.1-.8v-.5s.2-.2 0-.2a5.5 5.5 0 0 0-.9.1zm4 2c-.2 0-.3.2-.4.3 0 .2-.3.2-.4.3-.3 0-.4-.1-.6-.3a1.6 1.6 0 0 1-.3-.5v-.5a3.4 3.4 0 0 1 0-.9c0-.2 0-.4.2-.5.2-.1.5 0 .7.1l.2.5c.2.2.2-.1.2-.2l.1-.4a1 1 0 0 0-.5-.2 1.2 1.2 0 0 0-1.1.2 1 1 0 0 0-.3.3 1 1 0 0 0-.1.4l-.2.6.3 1.2c0 .2.2.3.4.5l.5.2a1 1 0 0 0 .7-.2c.2 0 .3-.3.4-.4a1 1 0 0 0 .2-.4zm1.3-2.5h-.4l-.1.8-.2.5-.2 1.3-.3.7v.1h.7l-.2-.3v-.5c0-.2.3 0 .4 0l.5-.1.2.6s-.2.3 0 .3h.7c.2-.1 0-.3 0-.4l-.3-.8-.3-1-.3-1zm-.3.8.4 1.3-.2.1h-.4c-.1-.1 0-.3 0-.4l.1-.6zm4.3-1-1 .1.2.3v2.9c0 .1-.4.3-.1.3h1.4a1 1 0 0 0 .4-.3l.4-.5.1-.7a2.7 2.7 0 0 0 0-.7l-.2-.6-.3-.4a1.7 1.7 0 0 0-.4-.2l-.5-.1zm0 .3c.3 0 .5.1.6.3a1 1 0 0 1 .1.5v1.4a1.4 1.4 0 0 1-.2.6l-.3.2-.5-.1v-2.6c0-.2.2-.3.4-.3zm3-.1a.8.8 0 0 0-.5.1l-.5.6-.2.8v.8l.2.5a1.1 1.1 0 0 0 1 .8c.3 0 .6-.2.8-.4l.4-.7v-1.2a2 2 0 0 0-.2-.6l-.4-.6a.9.9 0 0 0-.5-.1zm0 .2c.3 0 .5.3.5.5l.1.6v.9l-.1.6a1 1 0 0 1-.3.5c-.1.1-.3.2-.4 0-.2 0-.2-.3-.3-.4v-1.9c0-.2 0-.4.2-.6a.4.4 0 0 1 .4-.2zm1.4 3.5h.6c.1-.1-.2-.2-.1-.4a2 2 0 0 1 0-.6l.1-.6.1-.6.1-.5.1.5v.7l.2.6v.6c.1.2 0 .5.3.4.2 0 .1-.2.2-.3l.2-1 .2-.5.3-.9v2.5c0 .1-.3.3 0 .3h.6c.2.1.1 0 0-.1v-3.1s.2-.2 0-.2h-.7l-.2.5a9 9 0 0 1-.2.7l-.1.7s-.1.2-.1 0v-.6c0-.1-.2-.3-.1-.4l-.2-1c0-.2-.2 0-.4-.2h-.4v1.2l-.2 1.3-.1.5c0 .2-.1.3-.3.4zm3.3.3.6.1h.3l-.2-.4v-.6l.2-.5a22 22 0 0 1 0-1.1 1.3 1.3 0 0 1 0-.5l.2-.2c.1-.2-.1-.1-.2-.1l-.7-.1s.2.2.1.3v1.7l-.1.5a2.5 2.5 0 0 1 0 .5zm1.1.3h.5c.1 0 .3.1.2 0a.8.8 0 0 1-.1-.5v-.9a2 2 0 0 1 .1-.6v-.6c.2.1.2.3.3.5l.8 2c0 .2 0 .4.2.4s.2-.1.2-.3v-.5l.1-.5v-.6l.2-.6v-.6s.4-.2.2-.3h-.6l.2.4-.1 1.1-.1.6-.2-.5-.3-.6-.2-.6-.3-.7a3.5 3.5 0 0 1-.6-.1c-.2 0 0 .2 0 .4.1.3 0 .6 0 .8a4.2 4.2 0 0 1 0 .6l-.1.6-.1.6c0 .2-.2.3-.3.4zm3-3c.1.2.3.3.2.4v.5a3.1 3.1 0 0 1-.1.5l-.1.7v.5l-.1.3v.3l-.2.2c-.1.1.2 0 .3.1l.5.1s.1 0 0-.1v-1l.1-.5v-.4c.1-.2 0-.4.2-.6v-.4c0-.1 0-.3.2-.4a1.2 1.2 0 0 0-.4 0l-.4-.2a.2.2 0 0 0-.1 0zm1.1 2.4a2 2 0 0 0 .4 1.3c0 .2.3.2.4.3h.6c.1 0 .3 0 .4-.2l.3-.5c0-.2-.2.1-.3.2-.2.1-.5.2-.7 0a.8.8 0 0 1-.3-.4v-.5a7 7 0 0 1 0-.7v-.5l.3-.5a.5.5 0 0 1 .3-.2c.2 0 .3.2.4.3a.8.8 0 0 1 .1.5c0 .1.1.3.2.1l.2-.5c0-.2-.2-.3-.3-.4l-.3-.2h-.8a1.2 1.2 0 0 0-.3.4c-.2.1-.3.4-.4.6a2.6 2.6 0 0 0-.1.7zm3.5-1.3-.6 1.4c0 .1 0 .3-.2.5l-.3.7-.3.4c-.1 0-.1.2 0 .2l.5.1c.2 0 0-.2 0-.3v-.4c.2-.2.4 0 .5 0h.4v.8c-.1 0 0 .2 0 .2l.5.2c.1 0 .3 0 .2-.1-.1-.3 0-.5 0-.8l-.1-.6v-2.1zm0 .8v1.5l-.6-.1c-.1-.2.1-.3.1-.5l.4-.7zm1.5 3.3v-1.4l.2-.5v-.6c.2-.2.2 0 .2.1l.3 1 .2.6.2.9c0 .1.1.4.3.3l.2-.6.1-.6.2-1 .2-.8s.4-.2.1-.3c-.1 0-.3-.2-.5-.1l.1.4v.6a4.6 4.6 0 0 0-.2.5l-.1.6c-.2-.1-.1-.3-.2-.5l-.2-.7a6 6 0 0 1-.2-.7 2.1 2.1 0 0 1-.1-.5c-.1-.2-.4-.2-.5-.3-.2 0-.3 0-.2.2v1l-.3 1-.1.6-.3.4c-.2.2.2.2.3.3a.7.7 0 0 0 .3 0zm3.4-2.3-.3.7-.4.7-.8 1.3s-.2.2 0 .2l.5.2v-.8l.5.1c.1.1.4 0 .4.3l-.1.6c-.1 0-.2.1 0 .2l.3.1c.2 0 .3.2.4.1v-3.6zm0 .7v1.6l-.5-.2s-.3 0-.2-.2l.3-.7z"
    }),
    /* @__PURE__ */ jsxs108("g", {
      transform: "matrix(.89273 0 0 .89274 -125.5 -33.3)",
      children: [
        /* @__PURE__ */ jsx133("path", {
          fill: "#fff",
          d: "M474.5 281v40.6c0 3.6 0 5.9 1.8 8.1a11 11 0 0 0 6 4.2c1.7.3 7.7.2 9.8.2 4.6-.3 5.2.8 7 3 2-3.1 4.1-3.2 8.2-3 2 0 6.6.1 8.4-.3a9.4 9.4 0 0 0 5.4-3.3c2.4-2.7 2.2-6 2.2-9.6v-38.3c0-1.8-.2-1.3.7-2.2l5.8-6H468l6.4 6.7z"
        }),
        /* @__PURE__ */ jsx133("path", {
          fill: "#002d62",
          d: "M493.8 299v-24.7h-25.5l6.3 6.7v18z"
        }),
        /* @__PURE__ */ jsx133("path", {
          fill: "#ce1126",
          d: "M504 299v-24.7h26l-6.7 7.1v17.7zm-10.2 10.3h-19.3l-.1 15.6c.9 6.8 6 9.2 10.4 9.1h9z"
        }),
        /* @__PURE__ */ jsx133("path", {
          fill: "#002d62",
          d: "M504 309.3h19.4V325c-.5 6.8-6 9.2-10.5 9.1h-9z"
        }),
        /* @__PURE__ */ jsx133("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 0.5,
          d: "M474.6 281v40.6c0 3.6 0 5.8 1.8 8.3a9.2 9.2 0 0 0 6 4c1.7.3 7.7.2 9.8.2 2.7 0 3.9-.2 5.7 1.6.6.6.7.8 1.1 1.5a8.1 8.1 0 0 1 3-2.8c1.4-.5 3.8-.3 5.4-.3 2.1 0 6.6.1 8.4-.3a10.6 10.6 0 0 0 5.4-3.3c2.4-2.7 2.2-6 2.2-9.6v-38.3c0-1.8-.2-1.3.7-2.2l5.8-6h-61.7z"
        }),
        /* @__PURE__ */ jsx133("path", {
          fill: "#eac102",
          stroke: "#000",
          strokeWidth: 0.3,
          d: "M498 280.4v2.8h-3v2.3h2.8v10h2.3v-10h2.9v-2.3h-2.9v-2.8z"
        }),
        /* @__PURE__ */ jsxs108("g", {
          id: "do_svg__b",
          children: [
            /* @__PURE__ */ jsx133("path", {
              fill: "#fff",
              d: "M481.9 284v4.6l-1.9-2 .3 32c0 4.7 3.4 8.6 7.6 8.6 4.2 0 7.6-3.8 7.7-8.5l-.3-16.4-2-2.2-.1-1.7z"
            }),
            /* @__PURE__ */ jsx133("path", {
              fill: "#002d62",
              d: "M481.9 284.2v4.6l-1.9-2 .2 18.2 8.2 7.9v-17.4l-.2-.4v-3z"
            }),
            /* @__PURE__ */ jsx133("path", {
              fill: "#ce1126",
              d: "m490.8 295.5 2.4 3v1.1l-2.4-2.5zm4.5 7 .2 11.4c-1.2 2.2-3.6 1-3.6 1l.1-15.8z"
            }),
            /* @__PURE__ */ jsx133("path", {
              fill: "#002d62",
              d: "M495.6 319.6c-3.2 2.4-4-1-4-1a4.4 4.4 0 0 0 4-3z"
            }),
            /* @__PURE__ */ jsx133("path", {
              fill: "#ce1126",
              d: "M480.2 309.7a54 54 0 0 0 8 7.5c1 7.7 5.5 5.1 7.1 4-1 3.6-3.9 6.2-7.4 6.2-4.2 0-7.6-3.9-7.6-8.6z"
            }),
            /* @__PURE__ */ jsx133("path", {
              fill: "none",
              stroke: "#000",
              strokeWidth: 0.3,
              d: "M493.2 299.6v-1.1L481.9 284v4zM480 286.7l.3 31.9c0 4.7 3.4 8.6 7.7 8.6 4.1 0 7.5-3.8 7.6-8.5l-.3-16.4z"
            }),
            /* @__PURE__ */ jsxs108("g", {
              fill: "#eac102",
              stroke: "#000",
              strokeWidth: 0.1,
              children: [
                /* @__PURE__ */ jsx133("path", {
                  d: "M486.2 281.2c-.8-1.4-.6-2-.1-2.6l-3-3 .9 4.2c.8-.2 1.4 0 2.2 1.4zm-3-5.6 3 5.6"
                }),
                /* @__PURE__ */ jsx133("path", {
                  d: "m498 300.7-.7.3-12-20.4.8-.4z"
                }),
                /* @__PURE__ */ jsx133("path", {
                  d: "M485 280.6c-.1-.2 0-.5.5-.7.3-.2.7-.2.8 0 0 .2-.1.5-.5.7-.3.2-.7.2-.8 0zm-4 1.6c-1-1.3-.9-2-.4-2.6l-3.3-2.6 1.4 4c.8-.3 1.4-.1 2.3 1.2zm-3.7-5.2 3.7 5.2"
                }),
                /* @__PURE__ */ jsx133("path", {
                  d: "m495.3 300-.7.4-14.4-18.7.6-.5z"
                }),
                /* @__PURE__ */ jsx133("path", {
                  d: "M479.8 281.8c-.2-.2 0-.6.3-.8.4-.3.7-.3.9-.1 0 .1 0 .5-.4.7s-.7.3-.8.1zm.4 4.6c-1.1-1.3-1.1-2-.7-2.6l-3.6-2.2 1.8 3.9c.8-.4 1.4-.4 2.5.9zm-4.3-4.8 4.3 4.7"
                }),
                /* @__PURE__ */ jsx133("path", {
                  d: "m495.7 302.9-16.4-17 .6-.5 16.4 17z"
                }),
                /* @__PURE__ */ jsx133("path", {
                  d: "M478.9 286c-.2-.1 0-.5.3-.8.3-.3.6-.4.8-.2.1.2 0 .5-.3.8-.3.3-.7.4-.8.2z"
                })
              ]
            })
          ]
        }),
        /* @__PURE__ */ jsx133("use", {
          xlinkHref: "#do_svg__b",
          width: "100%",
          height: "100%",
          transform: "matrix(-1 0 0 1 998.3 0)"
        }),
        /* @__PURE__ */ jsxs108("g", {
          stroke: "#000",
          strokeWidth: 0.2,
          children: [
            /* @__PURE__ */ jsx133("path", {
              fill: "#ce1126",
              d: "m496.7 314.5-.6 10.1c-.6 0-1.9-.1-2-1 0-.4 1.3-8.7 1.3-9.5z"
            }),
            /* @__PURE__ */ jsx133("path", {
              fill: "#002d62",
              d: "m495.8 314.1-.3 3.1c.2 1 1.4.8 2 .9l.2-5.2a16.5 16.5 0 0 1-2 1.2z"
            }),
            /* @__PURE__ */ jsx133("path", {
              fill: "#002d62",
              d: "M495.9 327c1.6-2 4.8-.5 4.8-.5 3.4.8 2.5-3.1 2.5-3.1-.7-7.8-1.5-13.2-1.5-13.2l-5 3.4z"
            }),
            /* @__PURE__ */ jsx133("path", {
              fill: "#002d62",
              d: "M495.9 327.2c-.4 2.3 2 2 2 2 2.7 0 1.9-3 1.9-3-3-.9-4 1-4 1z"
            }),
            /* @__PURE__ */ jsx133("path", {
              fill: "#ce1126",
              d: "m497.8 312.7-.2 9c.1 2.1 2.5 1 2.5 1 .6-.3 1.2-.1 1.2-.1v-2.8c4-.3 3-2.6 3-2.6-1.6-7.6-1.8-7.3-1.8-7.3z"
            }),
            /* @__PURE__ */ jsx133("path", {
              fill: "none",
              d: "M501.3 319.8c-2.5 0-3.6 1-3.6 1v.2"
            }),
            /* @__PURE__ */ jsx133("path", {
              fill: "#fff",
              d: "m501 326.4-.9-15.1 1.8-1.2 1.5 14.2v.1c0 2.7-2.4 2-2.4 2z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs108("g", {
          fill: "#fff",
          stroke: "#000",
          children: [
            /* @__PURE__ */ jsx133("path", {
              fill: "#000001",
              stroke: "none",
              d: "m488.2 302.2 6.8 12.4 14.7-9.7-7.7-11.2z"
            }),
            /* @__PURE__ */ jsx133("path", {
              strokeWidth: 0.3,
              d: "m488.5 302.1 13.7-8 7.6 10.8-14.6 9.4z"
            }),
            /* @__PURE__ */ jsx133("path", {
              fill: "#000001",
              stroke: "none",
              d: "m495.4 313.5 13.7-8.8-1-1.7-6.9-9.3-5 4-6.3 3.5-1.1-.7.2 1.5z"
            }),
            /* @__PURE__ */ jsx133("path", {
              strokeWidth: 0.1,
              d: "M496.2 297.8c-2-1-4.4 2-5 2.6-.8.6-2.1.3-2.1.3l6.2 11c1.8.8 3-1.5 3.8-2.3 1.6-1.3 3.4-1.2 3.4-1.2z"
            }),
            /* @__PURE__ */ jsx133("path", {
              strokeWidth: 0.1,
              d: "M496.4 297.9c0-2.4 3-3.1 3.7-3.6.8-.4 1-1.9 1-1.9l7 10.6c-.2 2-2.6 2.3-3.6 2.8-1.8 1-2 2.5-2 2.5zm-1.4 13.9a595.6 595.6 0 0 0-6.1-11v1.2c4.6 7.5 6.5 11.5 6.5 11.5z"
            }),
            /* @__PURE__ */ jsx133("path", {
              fill: "#000001",
              stroke: "none",
              d: "M490.9 302.2v.2l.1-.1.2.1h-.2l.1.2.2-.2-.3.3-.2-.4h-.1l.4-.3v.2zm.4-.3.2.4v.2c-.1 0 0 0 0-.1l-.1-.1-.2-.3zm.5-.3h-.2v.1h.4v.3a.2.2 0 0 1-.2 0v.1l-.1-.1h.2c.1 0 .1-.1 0-.1h-.1l-.2-.1v-.2a.2.2 0 0 1 .1 0v-.1zm.5.2h-.2v-.1l.1-.1v-.1h-.1v.1c-.1 0 0 0 0 0a.2.2 0 0 1 0-.2l.2.1zm0 0v-.1l-.1.1zm.1-.4.1-.1h.1l.2.2-.1.2v-.1l-.1-.1v-.1zv.2h.1l-.1.2v-.2zh-.1zm.3-.4.1.1h.1v.3h.1-.1l-.2-.2a.5.5 0 0 0 0-.2m.3 0a.2.2 0 0 1 .2 0 .2.2 0 0 1 .1.1.2.2 0 0 1 0 .2.1.1 0 0 1-.2 0 .2.2 0 0 1-.1-.3m0 0v.1l.2.2v-.3zm-1.6 2 .1.2v-.1l.2.2h-.2l.1.1h.1l.1-.1v-.1.2l-.3.2v-.1l-.2-.3.3-.3v.1h-.1zm.7.2-.3-.2.1-.1v.1h.2c0-.1 0-.2-.1-.1v-.1.2zm.3-.3v.2h-.2v-.2zc0-.1-.1 0-.1 0a.2.2 0 0 1 .1-.2l.1.1.1.2zm.2-.4c.1-.1.2 0 .2 0l.1.1v.2c-.1 0 0 0 0 0l-.2-.2zv.4l-.1-.2-.1-.1v-.1zm.4-.3v.3h.2v.2a.4.4 0 0 1-.2 0l-.1-.1v-.1a.1.1 0 0 1-.1 0v-.2a.2.2 0 0 1 .1 0zm0 0v.2c.1 0 .1 0 0 0a.3.3 0 0 0 0-.1zm.2.4s-.1 0 0 .1zm.3-.5h-.2l.1.2za.2.2 0 0 1 0 .1h-.2a.3.3 0 0 1 0-.1c-.1 0 0-.2 0-.2a.1.1 0 0 1 .1 0 .3.3 0 0 1 .1 0zm-.1 0h-.1zm0-.4.3.4h.1l-.2.1v-.1zm.4 0 .1.3v.1c-.1 0 0 0 0 0l-.1-.1-.1-.2zm.2-.1a.2.2 0 0 1 .1 0l.1.2a.2.2 0 0 1 0 .1.1.1 0 0 1-.2 0 .2.2 0 0 1 0-.3m0 0v.3h.2v-.2zc0-.1 0-.1 0 0m-2 2.2.1.2c0-.1-.2-.1-.2 0h.2l.2.1v.2a.2.2 0 0 1-.2.1l-.2-.1h.3v-.1h-.4a.2.2 0 0 1 0-.3.2.2 0 0 1 .2 0zm.6 0-.2.2h.2a.2.2 0 0 1 0 .1h-.2a.2.2 0 0 1-.1 0v-.3a.1.1 0 0 1 .2 0zm-.1.1h-.1zm.2-.3a.2.2 0 0 1 0 .1v.1h.2v.1a.4.4 0 0 1-.2.1l-.1-.1a.2.2 0 0 1 0-.1.1.1 0 0 1-.1 0v-.3a.2.2 0 0 1 .1 0m0 0v.2s.1 0 0 0a.3.3 0 0 0 0-.2m.2.4s-.1 0 0 0c0 0 .1 0 0 0m.2-.7.2.3-.2.2-.2-.3.2.2h.1v-.1zm.3-.1v-.1h.2l.1.2-.1.2v-.2zs-.1 0 0 0v.4c-.1 0 0 0 0 0l-.2-.2v-.2zm.6-.6h-.2v.1h.4v.3a.2.2 0 0 1-.2 0v.1l-.1-.1h.2v-.1h-.3a.2.2 0 0 1 0-.3.2.2 0 0 1 .1 0v-.1zm.5.2-.1.1h-.1a.2.2 0 0 1 0-.2v-.1.1c-.1 0 0 0 0 0a.2.2 0 0 1 0-.2.1.1 0 0 1 .2 0zm0 0-.1-.1v.1zm.1-.4.1-.1h.1l.2.2-.1.2-.1-.2v-.1zv.2h.1l-.1.2v-.2l-.2-.1zm.4-.5.3-.1.1.3v.2a.2.2 0 0 1-.1.1h-.1v-.1h.1v-.2zm.7-.2.1.3h.1-.1l-.1.2a.1.1 0 0 1-.1 0l-.2-.3h.1l.1.2h.1zh-.1zm.4.1h-.2v-.3.1c-.1 0 0 0 0-.1h.2v.1h.1zm0 0-.1.1zm.1-.4zl.2.2-.1.1-.1-.1v-.1zv.2h.1l-.1.2zh-.2zm-2.7 4.7a.2.2 0 0 0-.2 0 .2.2 0 0 0-.1.2l.1.2h.3v-.2.1a.2.2 0 0 1 0 .2.2.2 0 0 1-.3 0 .3.3 0 0 1-.1-.4.3.3 0 0 1 .2-.1zm.6 0-.2.2v.1c.1 0 0 0 0 0v.1-.2l-.1-.4.4.3a.1.1 0 0 0 .1 0l-.2.1v-.1zm0 0h-.3v.2l.2-.1zm.2-.2.1.2h.1l-.2.1v-.1zh-.1l.2-.2h.1c.1 0 .1.1 0 .2a.3.3 0 0 1 0 .1zm0 0 .1-.1a.1.1 0 0 0 0-.2l-.2.1zm.6 0h-.2l-.1-.4h-.1l.1-.1v.1l.2.3zm.1-.8h-.2l.2.4h.1l-.2.2c.1 0 0-.1 0-.2l-.1-.3h-.1v.2l-.1-.1zm.4-.2h.2v.3l.1.1a.3.3 0 0 1-.2.2.2.2 0 0 1-.2-.1v-.2h-.2l.2-.2v.1l.1.2.1.1a.2.2 0 0 0 .2 0 .1.1 0 0 0 0-.2l-.2-.2c0-.1 0 0 0 0zm.7 0 .1.1-.4.2c.1 0 0 0 0 0l-.1-.4h-.1l.2-.1v.1l.1.3h.1l.1-.1zm.1-.5h.3a.3.3 0 0 1 .1.3.3.3 0 0 1-.3.2.3.3 0 0 1-.2-.1.3.3 0 0 1 0-.3.3.3 0 0 1 .1-.1m0 0a.1.1 0 0 0 0 .2.4.4 0 0 0 0 .2h.2a.2.2 0 0 0 .2-.1.4.4 0 0 0-.1-.2.2.2 0 0 0-.2-.1zm1-.6v.7l-.4-.3h.1l.3.2v-.3s0-.1-.1 0zm.4.3-.2.2v-.2l-.2-.3.1-.1v.1zm.2-.1-.1.1zl-.2-.3h-.1l.2-.2v.2zm.3-.2-.2.2v-.1l-.2-.4h-.1l.2-.1v.1zm-4 4.2v-.2h.2v.1a.1.1 0 0 1 .2.1.2.2 0 0 1 0 .2.3.3 0 0 1-.1.1c.1-.1.1-.2 0-.2h-.1a.1.1 0 0 0 0-.2zm.4-.3v-.2l.3.4h.1l-.1.2v-.2zm.7-.5.2-.1v.4c0 .1 0 .1.1 0v.1l-.2.1v-.2l-.3-.1zl.2.1zm.8 0h-.2a.2.2 0 0 1 0-.3v-.2l.3.3zm0 0v-.2h-.2v.1zm.1-.3.2.1v-.1h.1v.2a.1.1 0 0 1-.2 0 .3.3 0 0 1-.1-.2.2.2 0 0 1 0-.1.1.1 0 0 1 .2 0zm0 0h.2l-.1-.1s-.1 0 0 .1zm.6-.2a.2.2 0 0 1 0 .2.1.1 0 0 1-.2 0l-.1-.1v-.2a.1.1 0 0 1 .2 0h-.1v.1a.2.2 0 0 0 0 .1.1.1 0 0 0 .2 0zm.1-.2.2.3c-.1 0 0 0 0 0h-.1l-.1-.2zm.4.1v.1h-.2v-.1a1 1 0 0 1 .1-.1.1.1 0 0 0 0-.1h-.1v.1-.1h.1zm0 0v-.1za.2.2 0 0 0 .1 0m.1-.6.2-.1.1.3v.2s-.1 0 0 0v-.1zm.4 0 .2.2.1-.1v.1a.1.1 0 0 1-.2 0 .2.2 0 0 1 0-.1.2.2 0 0 1 0-.2h.2zm0 0h.2s0-.1-.1 0zm.4-.3c-.1.1 0 .2 0 .1za.1.1 0 0 1 .1.1v.1h-.2.1zh-.2v-.1a.2.2 0 0 1 0-.1zm.4-.2.1.2v.1c-.1.1-.2.1-.2 0l-.2-.1v-.1l.2.2h.1zm.2-.2c0 .1 0 0 0 0-.1.1 0 .2 0 .2h.1a.1.1 0 0 1 .1 0v.2h-.2c0-.1 0 0 0 0h.2v-.2h-.3zm.6 0v.1h-.2v-.1l.1-.1a.1.1 0 0 0 0-.1h-.1v.1-.1h.1c.1 0 0 0 0 0zm0 0v-.1h-.2za.2.2 0 0 0 0-.1zm-4.5 3.5.2.4h.1-.1zs-.1 0 0 0v-.2zm.3 0a.2.2 0 0 1 .2 0 .2.2 0 0 1 0 .1.2.2 0 0 1 0 .2.1.1 0 0 1-.1 0 .2.2 0 0 1-.2-.2.2.2 0 0 1 .1-.1m0 0a.3.3 0 0 0 .1.3h.1v-.2zm.4-.3v.1h-.1s0 .1 0 0h.2a.1.1 0 0 1 0 .2v.1h-.2.2v-.2h-.2zm.2-.3s.1 0 0 0m.1.1.2.3v.2c-.1 0 0 0 0 0v-.3zm.4-.2.2.2v.1l-.2.1-.2-.1v-.2l.2.2s.1 0 0 0v-.2zm.5 0-.1.2h-.2a.2.2 0 0 1 0-.3h.1v-.2h-.1zv.1zm0 0h-.2v-.1c-.1 0-.1 0 0 .1v.1h.1zm-.1-.5c0 .1 0 0 0 0m.1.2.2.2v.1c-.1 0 0 0 0 0h-.1l-.1-.2zm.2-.2a.2.2 0 0 1 .2 0 .2.2 0 0 1 .1.2.2.2 0 0 1 0 .1.1.1 0 0 1-.2 0 .2.2 0 0 1-.1-.2.2.2 0 0 1 0-.1m0 0v.1a.3.3 0 0 0 .1.2h.2v-.2h-.2zm.4-.2v.1h.2v.2h-.1s0 .1 0 0h-.1.2v-.1h-.3a.1.1 0 0 1 0-.2zm.5-.4.3.4v.2c-.1 0 0 0 0 0v-.2h-.4a.2.2 0 0 1 0-.2v-.1h.1zm.1.3h-.2l.1.2a.1.1 0 0 0 .1 0zm.3-.5.1.3v.1h-.2l-.1-.2h-.1.1l.1.2h.1v-.3h-.1zm.2 0 .1.2.1-.1v.1a.1.1 0 0 1-.2 0 .2.2 0 0 1 0-.1.2.2 0 0 1 0-.2.1.1 0 0 1 .1 0l-.1.2zm.3-.5.3.4v.1c-.1 0 0 0 0 0l-.1-.1-.2-.3zm.3.2h.2v-.1h.1v.2a.1.1 0 0 1-.2 0 .2.2 0 0 1-.1-.1.2.2 0 0 1 0-.2.1.1 0 0 1 .2 0zm0 0 .2-.2h-.1s-.1 0 0 .1zm-3.7 3.1.1.3.1-.2a.1.1 0 0 1 .1 0l.1.2h.1l-.1.2v-.2l-.1-.1h-.1v.3h.1-.1v-.1l-.2-.3zm.7.2c-.1.1-.2.1-.2 0a1 1 0 0 1 0-.2c0 .1-.1.1-.1 0 .1 0 .1-.1.2 0zc.1 0 0 0 0 0 0 .1 0 .1 0 0m0 0-.1-.2zm0-.4h.2a.2.2 0 0 1 0 .3c-.1 0-.1.1-.2 0l-.2-.3zm0 0 .2.2h.1v-.2zm.4-.3.2.3-.1.1v-.1l-.1-.1zm.4.2h-.2v-.1a1 1 0 0 1 .1-.1h-.1l.1-.1zs0 .1 0 0m0 0v-.2l-.1.1v.1zm.1-.4h.2l.1.2v.1zv.2h.1l-.1.1-.1-.2h-.1a.2.2 0 0 1 0-.1zm.8-.3a.2.2 0 0 1 0 .2.1.1 0 0 1-.2 0h-.1v-.3a.1.1 0 0 1 .2 0h-.1l-.1.1a.2.2 0 0 0 .1.2.1.1 0 0 0 .2 0zm0-.3v.1zv.4h.1l-.1.1-.1-.2s-.1 0 0 0v-.2zm.2 0 .2.1v-.1h.1v.2a.1.1 0 0 1-.2 0 .2.2 0 0 1-.1-.2.2.2 0 0 1 0-.1.1.1 0 0 1 .2 0zm0 0h.2zs-.1 0 0 0a.1.1 0 0 0 0 .1zm.2-.5v.1zm.1.2.2.2v.2c-.1 0 0 0 0 0l-.1-.2zm.5 0-.1.2h-.2a.2.2 0 0 1 0-.3h.1v-.2h-.1zs.1 0 0 0v.1zm0 0h-.1l-.1-.1v.2zm0-.4a.2.2 0 0 1 .3 0 .2.2 0 0 1 0 .2.2.2 0 0 1 0 .2.2.2 0 0 1-.2 0 .2.2 0 0 1 0-.3zm0 0v.2a.3.3 0 0 0 .2.1h.1v-.1l-.1-.1zm-1-9.2.2.1a.1.1 0 0 0-.3 0v.1h.3a.1.1 0 0 1 .1.2h-.1l-.1.1v-.1h.1v-.1h-.2c-.1-.1-.1-.2 0-.2zm.2-.1.2.3h.1l-.1.1-.1-.2v-.1zm.3 0 .2.2v-.3.4zm.4-.3a.1.1 0 0 1 .2 0v.3a.2.2 0 0 1-.2-.1.1.1 0 0 1 0-.2m0 0v.2h.2v-.1s-.1-.1-.1 0zm.4-.2h-.1v.1h.2v.2h-.1c.1 0 0-.1 0-.1h-.1v-.2zm.2-.1a.1.1 0 0 1 .1 0l.1.2s-.1.1-.2 0a.2.2 0 0 1-.1 0 .1.1 0 0 1 0-.2zm0 0v.2h.2v-.1zm.1-.3h.2v.2c.1 0 0 0 0 0 0 .1 0 0 0 0zc-.1 0 0 0 0 0zm.3 0s.1 0 0 0v.2h.2l-.2.1zh-.1zm.2-.1a.1.1 0 0 1 .1 0l.1.2h-.1a.2.2 0 0 1-.2 0 .1.1 0 0 1 0-.2.1.1 0 0 1 .1 0m0 0 .1.1h.1v-.1zm.3-.2h.1s.1 0 0 .1v.1a45 45 0 0 1-.1 0h.2l-.1-.1h-.1zm-2 2.4c0-.1.1-.1.1 0l.1.1a.1.1 0 0 1-.1.1v.1h.1l-.1.1zm0 0h.2c0 .1 0 .1 0 0v-.1zm.3-.2h.2v.1a.1.1 0 0 1-.1 0 .2.2 0 0 1-.1-.1.1.1 0 0 1 0-.2.1.1 0 0 1 .2 0zm0 0 .2-.1zm.3-.3s.1 0 0 0v.2h.2l-.2.1zm.2 0v-.2h.2c0-.1.1 0 .1 0l.1.1v.1-.1l-.1-.1h-.1v.2h.1l-.1.1v-.2zl.1.2a54.8 54.8 0 0 1 0 .1v-.1zm.6-.2c-.1.1-.2 0-.1 0v-.1c0-.1 0-.1 0 0h-.1v-.1h.1zm0 0a.3.3 0 0 0-.1 0za.2.2 0 0 0 .1 0m.1-.3h.2v.2h.1-.1v-.1zl.1.2zm.3-.1h.2a.1.1 0 0 1-.2 0 .1.1 0 0 1 0-.2.1.1 0 0 1 .1 0zm0 0 .1-.1h-.1zm.5-.2a.1.1 0 0 1-.2 0h-.1a.1.1 0 0 1 0-.2h.2-.2a.2.2 0 0 0 0 .2zm0-.2.1.1h.1v-.1.2a.1.1 0 0 1-.2 0 .2.2 0 0 1 0-.2.1.1 0 0 1 0-.1.1.1 0 0 1 .1 0zm0 0c0-.1 0-.1-.1 0m.2-.2v.4h.1c-.1 0 0 0 0 0l-.2-.2zm.3 0h.2a.1.1 0 0 1-.2 0 .2.2 0 0 1-.1 0 .1.1 0 0 1 0-.2.1.1 0 0 1 .2 0zm0-.5c.1 0 .2 0 .1.1zm.2.2.1.2h.1-.1zm.2-.2c0 .1 0 0 0 0h.1s.1.1 0 .2h-.1.2s0-.1-.1 0h-.1zm-2.7 3h.2v-.1.1a.1.1 0 0 1-.1 0 .2.2 0 0 1-.1 0 .1.1 0 0 1 0-.2.1.1 0 0 1 .1 0zm0-.1c0-.1 0-.1-.1 0m.3-.2.1.1v.1zv.2h.1v.1zm.4-.3v-.1h.2v-.1h.1l.1.2-.1-.2h-.1v.4h.1a51.1 51.1 0 0 1-.1 0v-.1zl.1.2h-.1zm.3-.5s.1 0 0 0c0 .1 0 0 0 0m.1.1.2.3c-.1 0 0 0 0 0h-.1v-.2zm.2 0v-.1h.2s.1.2 0 .2a.1.1 0 0 1 0 .1v.2zm.2 0c0 .1.1.1.1 0zm.4-.1c-.1.1-.1 0-.1 0v-.2.1h-.1v-.1h.2zs0 .1 0 0m0 0v-.1h-.1c0 .1 0 .2.1.1m0-.5.2.3v.1zm.5.2zv-.2s-.1 0 0 0v-.1zm0 0-.1-.1za.2.2 0 0 0 0-.1zm0-.3v-.1h.2a.2.2 0 0 1 0 .2.1.1 0 0 1 0 .1h-.1l-.2-.3zm0 0 .1.2h.1v-.2zm.3-.2c.1 0 .1 0 0 0l.1.2v.1zm.4 0h-.2l.1-.2h-.1c0 .1 0 0 0 0h.1zm0 0s0 .1 0 0m-2.6 2.4c-.1.1 0 .1 0 .1h.1v.2a45 45 0 0 1-.1 0h.1v-.1h-.2zm.2 0h.2v.1a.1.1 0 0 1-.2 0 .2.2 0 0 1 0-.1.1.1 0 0 1 0-.1.1.1 0 0 1 .1 0zm0 0v-.1zm.2-.3v.2h.1a67.3 67.3 0 0 0-.1.1l-.1-.2zm.2 0 .1.1h.1v-.1.1a.1.1 0 0 1-.1 0 .2.2 0 0 1-.1 0 .1.1 0 0 1 0-.2.1.1 0 0 1 .2 0zm0 0c0-.1 0-.1 0 0m.4-.4.2.3zs-.1 0 0 0zm.3-.1c-.1.1 0 .1 0 .1h.1v.2h-.1.1v-.1h-.2zm.2-.1.1-.1.2.2v-.2h-.1v-.1l.1.3zm.4-.2zh.1v-.1.2a.1.1 0 0 1-.2 0 .2.2 0 0 1 0-.2.1.1 0 0 1 0-.1.1.1 0 0 1 .1 0zm0 0c0-.1 0-.1-.1 0m.2-.3zv.4h.1c-.1 0 0 0 0 0l-.2-.2zm.5 0a.1.1 0 0 1-.1.2.2.2 0 0 1-.2 0 .2.2 0 0 1 0-.3h.1v-.2zm0 0h-.1c0-.1-.1-.1-.1 0v.1zm.2 0h-.1v-.2h-.1.2c0 .1.1 0 .1 0zm0 0v-.2l-.1.1s0 .1.1 0zm.3-.3a.1.1 0 0 1 0 .1.2.2 0 0 1-.2 0 .2.2 0 0 1 0-.2v-.2zm0 0v-.1h-.2l.1.2zm0-.2.2.1h.1v-.1.1a.1.1 0 0 1-.2 0 .1.1 0 0 1 0-.2.1.1 0 0 1 .1 0zm0 0h.2c0-.1 0-.1-.1 0zm.3-.3v.2h.1l-.1.2v-.1zm.4 0v.2l-.1-.1v-.2.1h-.1v-.1h.2zm0 0h-.1c0 .1 0 .2.1.1zm.1-.2v-.1h.2v-.1h.1l.1.2c.1 0 0 0 0 0l-.1-.2h-.1v.4h.1c-.1 0 0 0 0 0h-.1v-.1zl.1.2zm.5-.2h.2v.1a.1.1 0 0 1-.2 0 .2.2 0 0 1-.1-.1.1.1 0 0 1 0-.2.1.1 0 0 1 .2 0zm0 0v-.1zm.2-.2v-.2h.2v.2h.1v.1l-.1-.2zv.4l-.1-.2zm.2-.4zv.2h.2-.2v-.1h-.1a.2.2 0 0 0 0-.2m.3.1zh.2v-.1.2a.1.1 0 0 1-.2 0 .2.2 0 0 1 0-.2.1.1 0 0 1 0-.1zm0 0c0-.1 0-.1 0 0m-4.5 3.8h.2v-.1h.1l.1.2-.1-.1h-.1v.2h.1a51.1 51.1 0 0 1-.1 0v-.1zl.1.2zh-.1zm.3-.5s.1 0 0 .1zm.1.2.2.2c-.1 0 0 0 0 0h-.1zm.3-.2c0 .1 0 0 0 0l-.1.1h.2v.2h-.1c.1 0 0-.1 0 0h-.1v-.3zm.5 0a.1.1 0 0 1 0 .1.2.2 0 0 1-.2 0 .2.2 0 0 1 0-.2v-.2zs.1 0 0 0m0 0c-.1 0-.2-.1-.2 0l.1.2zm0-.5c0 .1 0 0 0 0m0 .1.2.3-.1-.2h-.1zm.3-.1h-.1v.1h.2v.2h-.1.1v-.1h-.2v-.2zm.4 0v.1a.1.1 0 0 1-.2 0 .1.1 0 0 1 0-.2zh-.2a.2.2 0 0 0 .1.2h.1zm0-.3.2.3h.1-.1zm.2 0h.2v.2a.1.1 0 0 1 0 .1h-.1v.1h.1-.1zm0 0 .2.2c.1 0 0-.1 0-.2zm.2-.4s.1 0 0 0c0 .1 0 0 0 0m.1.1.2.3-.2-.2zm.1-.2.2.4h.1-.1zm.3 0a.1.1 0 0 1 .1 0l.1.2-.1.1a.2.2 0 0 1-.2-.1.1.1 0 0 1 0-.2.1.1 0 0 1 .1 0m0 0v.2h.2v-.1zm.3-.2c0 .1 0 0 0 0v.1h.1s.1.1 0 .2a45 45 0 0 1-.1 0h.2s0-.1-.1 0h-.1zm-1.7 4.3v-.2a.1.1 0 0 1 .1 0za.1.1 0 0 1 .2.1.2.2 0 0 1 0 .2h-.1c.1 0 0-.1 0-.2zm.6-.1-.2.2v-.4h-.1v.1-.1a.1.1 0 0 1 .1 0h.1v.3h.1zm.4-.7.2-.1v.6-.1l-.1-.1-.3-.1zv.1l.2.1zm.7 0a.1.1 0 0 1-.1.1l-.1-.1a.1.1 0 0 1 0-.2h.2s0 .1-.1 0c0 0-.1 0 0 .1a.2.2 0 0 0 0 .1zm.1-.3a.1.1 0 0 1 .1 0l.1.1-.1.2a.2.2 0 0 1-.2-.2.1.1 0 0 1 0-.1.1.1 0 0 1 .1 0m0 0v.1l.1.1h.1v-.2zm.3-.1v-.2h.1l.1.2v.1zv.2h.1v.1l-.2-.2zm.3-.3a.1.1 0 0 1 .1 0l.1.2s0 .1-.1 0a.2.2 0 0 1-.2 0 .1.1 0 0 1 0-.2zm0 0v.3l.2-.1v-.1c-.1 0-.2-.1-.2 0zm.5 0a.1.1 0 0 1-.2.1v-.1a.1.1 0 0 1 0-.2h.1l-.2.1a.2.2 0 0 0 .1.1zm0-.2h.2v.1a.1.1 0 0 1-.1 0 .2.2 0 0 1-.1-.1.1.1 0 0 1 0-.1.1.1 0 0 1 .1 0zm.2-.3v.2h.1v.1c-.1 0 0 0 0 0l-.2-.2zm.3 0v.1h.2v-.1.1a.1.1 0 0 1-.2 0 .1.1 0 0 1 0-.2zm0 0c0-.1 0-.1 0 0m.1-.2.1.2h.1l-.1.1-.1-.2zm.2-.1v.1h.1s.1.1 0 .1v.1h-.1.2l-.1-.1h-.1zm.2-.4.3.4h-.1zm.5.3c-.1.1-.2 0-.2 0zh-.1v-.1h.2zm0 0v.1zm-4 3.3.2.2v-.3.4zm.3-.2.1.1h.1v-.1.2a.1.1 0 0 1-.1 0 .2.2 0 0 1-.1-.2.1.1 0 0 1 0-.1.1.1 0 0 1 .2 0zm0 0c0-.1 0-.1 0 0m.3-.3v.1zv.4h.2-.2v-.2h-.1zm.4.1a.1.1 0 0 1 0 .1.2.2 0 0 1-.2 0 .2.2 0 0 1 0-.2v-.2zs.1 0 0 0m0 0c-.1 0-.2-.1-.2 0l.1.2zm.3-.2-.1.1h-.1v-.2s-.1 0 0 0zc0 .1 0 0 0 0v.2zm0 0s0 .1 0 0m.3-.1a.1.1 0 0 1-.1 0 .2.2 0 0 1-.2 0 .2.2 0 0 1 0-.2h.1v-.2h-.1zm0 0-.1-.2h-.2v.1zm.2 0c.1 0 .1 0 0 0v.1zm0-.5.2.2v-.2zl.1.3v.2s-.1 0 0 0v-.2zm.4-.5.3.4h-.1l-.2-.3zm.5.2-.1.1s-.1 0 0 0zh-.1v-.1h.1zm0 0-.1.1s0 .1 0 0zm0-.3.2-.1.2.2v-.2h-.1v-.1l.1.3-.2-.1zm.5-.2h.2v.1a.1.1 0 0 1-.2 0 .1.1 0 0 1 0-.2.1.1 0 0 1 .1 0zm0 0a.1.1 0 0 0 0 .1m.2-.3v.2h.1l-.1.2v-.1l-.1-.2zm.5 0a.1.1 0 0 1-.1.2.2.2 0 0 1-.2 0 .2.2 0 0 1 0-.3h.1v-.2zv.1zm0 0c0-.1-.1-.1-.1 0v.1h.2zm.2 0v-.2s-.1 0 0 0h-.1v-.1h.2zm0-.1v.2a.2.2 0 0 0 .1-.1m.3-.2a.1.1 0 0 1 0 .1.2.2 0 0 1-.2 0 .2.2 0 0 1 0-.2v-.2zm0 0h-.2l.1.2h.1zm.3-.5c.2 0 .2.1.2.2 0 0-.1.2-.2.1a.2.2 0 0 1-.1-.1.1.1 0 0 1 0-.1zm0 0v.4h.2l-.1-.2h-.1zm.3-.2v.1h-.1.2v.2l-.1.1c0-.1 0 0 0 0l.1-.1h-.2v-.2zm-4.6 3.8v.2l.2-.1.2.2h-.1l-.1-.2zv.1l.1.2h-.1zm.6.1-.1.1h-.1v-.2c0 .1 0 0 0 0zm0 0s0 .1 0 0m0-.3v.2h.1l-.1.1-.1-.2zm.4 0v.2l-.2-.1zs-.1 0 0 0c-.1.1-.1 0-.1 0zs0 .1 0 0m0 0a.3.3 0 0 0-.1 0v.1a.2.2 0 0 0 .1 0zm.1-.5.2.3h.1l-.1.1-.2-.3zm.2-.1.2.3v.1-.1l-.1-.1s-.1 0 0 0zm.3 0h.2a.2.2 0 0 1 0 .2.1.1 0 0 1-.1 0l-.3-.2v-.1zm0 0v.2h.2v-.2zm.2-.2v.2h.1a67.3 67.3 0 0 0-.1.1l-.1-.2zm.2 0 .1.1h.2v-.1.1a.1.1 0 0 1-.2 0 .2.2 0 0 1-.1 0 .1.1 0 0 1 0-.2.1.1 0 0 1 .2 0zm0 0c0-.1 0-.1 0 0m.4-.3v.1h.2v.2h-.1v-.1h-.1zm.2.1"
            })
          ]
        })
      ]
    })
  ]
});
var Do_default = SvgDo;

// src/country-flag-icons/generated/Dz.tsx
init_esm_shims();
import { jsx as jsx134, jsxs as jsxs109 } from "react/jsx-runtime";
var SvgDz = (props) => /* @__PURE__ */ jsxs109("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx134("path", {
      fill: "#fff",
      d: "M320 0h320v480H320z"
    }),
    /* @__PURE__ */ jsx134("path", {
      fill: "#006233",
      d: "M0 0h320v480H0z"
    }),
    /* @__PURE__ */ jsx134("path", {
      fill: "#d21034",
      d: "M424 180a120 120 0 1 0 0 120 96 96 0 1 1 0-120m4 60-108-35.2 67.2 92V183.2l-67.2 92z"
    })
  ]
});
var Dz_default = SvgDz;

// src/country-flag-icons/generated/Ec.tsx
init_esm_shims();
import { jsx as jsx135, jsxs as jsxs110 } from "react/jsx-runtime";
var SvgEc = (props) => /* @__PURE__ */ jsxs110("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsxs110("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      children: [
        /* @__PURE__ */ jsx135("path", {
          fill: "#ffe800",
          d: "M0 0h640v480H0z"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#00148e",
          d: "M0 240h640v240H0z"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#da0010",
          d: "M0 360h640v120H0z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs110("g", {
      fillRule: "evenodd",
      children: [
        /* @__PURE__ */ jsx135("path", {
          d: "M269.6 290.8 197 367.3l-1.2-1.6 72.4-76.5 1.2 1.6zm50.4 12.5-94.8 100-1.6-1.6 94.7-100z"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "gray",
          stroke: "#000",
          strokeWidth: 4.1,
          d: "M478.4 60.2v88.6l17.7 88.6 17.7-88.6V60.2z",
          transform: "matrix(-.07 -.07 -.1 .1 265 429.6)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "gray",
          stroke: "#000",
          strokeWidth: 4.1,
          d: "M478.4 60.2v88.6l17.7 88.6 17.7-88.6V60.2z",
          transform: "matrix(-.07 -.07 -.1 .1 240.6 390.5)"
        })
      ]
    }),
    /* @__PURE__ */ jsx135("path", {
      fill: "#ffdf00",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "M301.2 272.8s-17.7 336.6 53.1 336.6S460.6 574 460.6 574l-.8-185z",
      transform: "matrix(.45 0 0 .64 72.4 -59.8)"
    }),
    /* @__PURE__ */ jsx135("path", {
      fill: "#0000c4",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "M344.5 304.2c0 17.7-7.9 269.8 27.5 269.8s88.6-17.7 88.6-17.7l-.8-167.3z",
      transform: "matrix(.45 0 0 .64 72.4 -59.8)"
    }),
    /* @__PURE__ */ jsx135("path", {
      fill: "#e10000",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "M367.5 321.2c0 17.7 4.5 217.4 40 217.4h53.1l-.8-149.6z",
      transform: "matrix(.45 0 0 .64 72.4 -59.8)"
    }),
    /* @__PURE__ */ jsx135("path", {
      fillRule: "evenodd",
      d: "m206.2 116 72.4 76.5 1.3-1.6-72.4-76.5z"
    }),
    /* @__PURE__ */ jsx135("path", {
      fill: "#ffdf00",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "M301.2 272.8S265.8 609.4 372 609.4c88.5 0 88.5-53.1 106.2-53.1l-17.7-124z",
      transform: "matrix(.58 0 0 .62 9.6 -10.2)"
    }),
    /* @__PURE__ */ jsxs110("g", {
      stroke: "#000",
      children: [
        /* @__PURE__ */ jsx135("path", {
          fill: "none",
          strokeWidth: 2.3,
          d: "M269.6 155.2c1.1 0 28.3-94 119-147.2",
          transform: "matrix(.4 -.03 -.05 .35 135.1 147.4)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#005b00",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
          transform: "matrix(.14 -.22 .3 .14 175.9 257.4)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "red",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M454.2-169.3c0 4-3.8 7.4-8.5 7.4s-8.5-3.3-8.5-7.4 3.8-7.3 8.5-7.3 8.5 3.3 8.5 7.3z",
          transform: "matrix(.18 -.1 .1 .17 177.6 256.7)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#005b00",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
          transform: "matrix(.18 .12 -.13 .33 181 96.4)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#005b00",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
          transform: "matrix(.17 -.03 -.03 .33 179.3 159.3)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#005b00",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
          transform: "matrix(.06 .25 -.17 .2 228 45.5)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#005b00",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
          transform: "matrix(.2 -.2 .2 .24 150.3 241)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#005b00",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
          transform: "matrix(.22 -.22 .25 .2 135.6 282.1)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#005b00",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
          transform: "matrix(.26 .1 -.2 .32 130.8 147.7)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#005b00",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
          transform: "matrix(.15 .2 -.32 .22 178.5 103.3)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#005b00",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
          transform: "matrix(.08 .1 -.14 .16 250.7 102.6)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#005b00",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
          transform: "matrix(.1 0 -.08 .17 238 136.4)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#005b00",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
          transform: "matrix(0 .14 -.14 .08 287.4 81.1)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#005b00",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
          transform: "matrix(.07 .1 -.25 .15 220.7 115.6)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#005b00",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M421.4-20.3c0 18.1-4.6 31.7-11.4 45.3-5.6-18.1-9-27.2-9-45.3s6.8-35.1 12.4-48.7c2.3 12.4 8 30.5 8 48.7z",
          transform: "matrix(.13 .22 -.33 .2 207 70.1)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "none",
          strokeWidth: 2.4,
          d: "M269.6 155.2c1.1 0 28.3-94 119-147.2",
          transform: "matrix(.35 -.2 .14 .28 111.8 227.8)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "red",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M454.2-169.3c0 4-3.8 7.4-8.5 7.4s-8.5-3.3-8.5-7.4 3.8-7.3 8.5-7.3 8.5 3.3 8.5 7.3z",
          transform: "matrix(.18 -.1 .1 .17 200.3 224.6)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "red",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M454.2-169.3c0 4-3.8 7.4-8.5 7.4s-8.5-3.3-8.5-7.4 3.8-7.3 8.5-7.3 8.5 3.3 8.5 7.3z",
          transform: "matrix(.18 -.1 .1 .17 211.1 218.3)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "red",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M454.2-169.3c0 4-3.8 7.4-8.5 7.4s-8.5-3.3-8.5-7.4 3.8-7.3 8.5-7.3 8.5 3.3 8.5 7.3z",
          transform: "matrix(.2 -.1 .07 .13 166.8 232.7)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "red",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M454.2-169.3c0 4-3.8 7.4-8.5 7.4s-8.5-3.3-8.5-7.4 3.8-7.3 8.5-7.3 8.5 3.3 8.5 7.3z",
          transform: "matrix(.2 -.1 .07 .13 170 231.3)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "red",
          fillRule: "evenodd",
          strokeWidth: "1pt",
          d: "M454.2-169.3c0 4-3.8 7.4-8.5 7.4s-8.5-3.3-8.5-7.4 3.8-7.3 8.5-7.3 8.5 3.3 8.5 7.3z",
          transform: "matrix(.2 -.1 .07 .13 168.1 234.3)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "red",
          fillRule: "evenodd",
          strokeWidth: 0.3,
          d: "M252.7 167.3c.4.8 0 1.8-1 2.3s-2 .2-2.4-.7 0-1.8 1-2.3 2-.2 2.3.7z"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "red",
          fillRule: "evenodd",
          strokeWidth: 0.3,
          d: "M255 164.9c.3.8 0 1.8-1 2.3s-2 .2-2.5-.6 0-1.9 1-2.4 2-.1 2.4.7z"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "red",
          fillRule: "evenodd",
          strokeWidth: 0.3,
          d: "M255.5 166c.4.8 0 1.9-1 2.3s-2 .2-2.4-.6 0-1.8 1-2.3 2-.2 2.4.6z"
        })
      ]
    }),
    /* @__PURE__ */ jsx135("path", {
      fill: "#0000c4",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "M336.6 308.3c0 17.7-35.4 212.6 53.2 265.7 35.4 17.7 88.5-17.7 88.5 0l-17.7-141.7z",
      transform: "matrix(.58 0 0 .62 9.6 -10.2)"
    }),
    /* @__PURE__ */ jsx135("path", {
      fill: "#e10000",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "M372 343.7c0 17.7-17.7 159.4 35.5 194.9 35.4 35.4 124 25.8 124 25.8l-70.9-132.1z",
      transform: "matrix(.58 0 0 .62 9.6 -10.2)"
    }),
    /* @__PURE__ */ jsx135("path", {
      fillRule: "evenodd",
      d: "m183.8 158 94.8 100 1.7-1.6-94.8-99.9z"
    }),
    /* @__PURE__ */ jsx135("path", {
      fill: "#cececc",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "m460.6 184.3 17.7 35.4v17.7c-.8-1.3 0 17.7-17.7 17.7S443 219.7 443 219.7s-17.7 35.4-17.7 70.9 17.7 53.1 17.7 53.1-2.6-36.7 17.7-35.4c20.4 1.2 17.7 17.7 17.7 17.7v35.4h17.8V219.7l17.7-35.4-27.2-53.2-26 53.1z",
      transform: "matrix(.14 -.14 .1 .1 86.3 192.2)"
    }),
    /* @__PURE__ */ jsx135("path", {
      fill: "#cececc",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "m557.8 95.7-26.3 70.8 17.7 53.2-35.4-17.7 35.4 53.1v35.5H567V255l35.5-53.1-35.5 17.7 17.8-53.2-26.9-70.8z",
      transform: "matrix(.1 -.16 .14 .1 114 183.8)"
    }),
    /* @__PURE__ */ jsx135("path", {
      fill: "#e10000",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "M422.5 137c0 2-2 3.7-4.3 3.7s-4.4-1.7-4.4-3.7 2-3.8 4.4-3.8 4.3 1.7 4.3 3.8zm-6.2 7.9c0 35.8 20.9 187.8 22.6 191.5.1 4.5-4.8 6.4-7.1.9-6.6-17.4-20.8-160-21.3-193.3-.3-13.7 3.7-14.8 8.3-14.5 3.7.2 8.3 3.7 8.3 7.9 0 5-5.8 8.7-10.8 7.5z",
      transform: "matrix(.4 0 0 .3 43.8 69.8)"
    }),
    /* @__PURE__ */ jsx135("path", {
      fill: "#0000c4",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "M422.5 137c0 2-2 3.7-4.3 3.7s-4.4-1.7-4.4-3.7 2-3.8 4.4-3.8 4.3 1.7 4.3 3.8zm-6.2 7.9c31.5 61.4 48.7 166.7 50.4 170.5.1 4.4-4.8 6.4-7.1.8-2.5-3.3-12.7-100.2-49.1-172.2-.3-13.7 3.7-14.8 8.3-14.5 3.7.2 8.3 3.7 8.3 7.9 0 5-5.8 8.7-10.8 7.5z",
      transform: "matrix(.38 .1 -.15 .3 76 38.2)"
    }),
    /* @__PURE__ */ jsx135("path", {
      fill: "#e10000",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.7,
      d: "M186.7 151.5c0 1-1 2-2.2 2-1.2 0-2.2-1-2.2-2s1-1.8 2.2-1.8c1.2 0 2.1.8 2.1 1.8zm-3.2 4c0 17.9 10.5 93.9 11.3 95.8 0 2.2-2.3 3.2-3.5.4-3.3-8.7-10.4-80-10.7-96.6-.1-6.9 1.9-7.4 4.2-7.3 1.9.1 4.1 1.9 4.1 4 0 2.4-2.9 4.3-5.4 3.7z"
    }),
    /* @__PURE__ */ jsx135("path", {
      fill: "#0000c4",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "M422.5 137c0 2-2 3.7-4.3 3.7s-4.4-1.7-4.4-3.7 2-3.8 4.4-3.8 4.3 1.7 4.3 3.8zm-6.2 7.9c31.5 61.4 48.7 166.7 50.4 170.5.1 4.4-4.8 6.4-7.1.8-2.5-3.3-12.7-100.2-49.1-172.2-.3-13.7 3.7-14.8 8.3-14.5 3.7.2 8.3 3.7 8.3 7.9 0 5-5.8 8.7-10.8 7.5z",
      transform: "matrix(.48 .15 -.2 .48 16.7 31.6)"
    }),
    /* @__PURE__ */ jsxs110("g", {
      fillRule: "evenodd",
      children: [
        /* @__PURE__ */ jsx135("path", {
          d: "m370.4 290.8 72.5 76.5 1.3-1.6-72.5-76.5zM320 303.3l94.8 100 1.6-1.6-94.7-100z"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "gray",
          stroke: "#000",
          strokeWidth: 4.1,
          d: "M478.4 60.2v88.6l17.7 88.6 17.7-88.6V60.2z",
          transform: "matrix(.07 -.07 .1 .1 375 429.6)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "gray",
          stroke: "#000",
          strokeWidth: 4.1,
          d: "M478.4 60.2v88.6l17.7 88.6 17.7-88.6V60.2z",
          transform: "matrix(.07 -.07 .1 .1 399.4 390.5)"
        })
      ]
    }),
    /* @__PURE__ */ jsxs110("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      children: [
        /* @__PURE__ */ jsx135("path", {
          fill: "#ffdf00",
          stroke: "#000",
          d: "M301.2 272.8s-17.7 336.6 53.1 336.6S460.6 574 460.6 574l-.8-185z",
          transform: "matrix(-.45 0 0 .64 567.6 -59.8)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#0000c4",
          stroke: "#000",
          d: "M344.5 304.2c0 17.7-7.9 269.8 27.5 269.8s88.6-17.7 88.6-17.7l-.8-167.3z",
          transform: "matrix(-.45 0 0 .64 567.6 -59.8)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#e10000",
          stroke: "#000",
          d: "M367.5 321.2c0 17.7 4.5 217.4 40 217.4h53.1l-.8-149.6z",
          transform: "matrix(-.45 0 0 .64 567.6 -59.8)"
        }),
        /* @__PURE__ */ jsx135("path", {
          d: "m433.8 116-72.4 76.5-1.3-1.6 72.4-76.5z"
        }),
        /* @__PURE__ */ jsxs110("g", {
          fill: "#005b00",
          stroke: "#000",
          children: [
            /* @__PURE__ */ jsx135("path", {
              d: "M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z",
              transform: "matrix(.16 -.07 .08 .35 309.5 211)"
            }),
            /* @__PURE__ */ jsx135("path", {
              d: "M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z",
              transform: "matrix(.2 -.05 .07 .4 291.5 182.6)"
            }),
            /* @__PURE__ */ jsx135("path", {
              d: "M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z",
              transform: "matrix(.23 .14 -.03 .4 296.5 69.4)"
            }),
            /* @__PURE__ */ jsx135("path", {
              d: "M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z",
              transform: "matrix(.25 .03 .02 .44 274.4 115)"
            }),
            /* @__PURE__ */ jsx135("path", {
              d: "M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z",
              transform: "matrix(.18 .17 -.04 .35 330 67)"
            }),
            /* @__PURE__ */ jsx135("path", {
              d: "M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z",
              transform: "matrix(.23 0 .03 .4 280.6 141.9)"
            }),
            /* @__PURE__ */ jsx135("path", {
              d: "M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z",
              transform: "matrix(.2 -.07 .07 .38 290.1 196.8)"
            }),
            /* @__PURE__ */ jsx135("path", {
              d: "M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z",
              transform: "matrix(.2 -.03 .05 .4 292.7 166.8)"
            }),
            /* @__PURE__ */ jsx135("path", {
              d: "M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z",
              transform: "matrix(.22 .15 -.05 .38 305 65.5)"
            }),
            /* @__PURE__ */ jsx135("path", {
              d: "M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z",
              transform: "matrix(.24 .05 0 .44 278.9 97.7)"
            }),
            /* @__PURE__ */ jsx135("path", {
              d: "M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z",
              transform: "matrix(.17 .17 -.06 .33 339 70)"
            }),
            /* @__PURE__ */ jsx135("path", {
              d: "M428.2-17s81.5 90.7 111 154.1c29.4 63.5 54.4 156.3 54.4 156.3s2.2-86-36.3-163C505.2 32.8 425.9-12.5 428.2-17z",
              transform: "matrix(.24 .02 0 .4 276.4 128)"
            })
          ]
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#ffdf00",
          stroke: "#000",
          d: "M301.2 272.8S265.8 609.4 372 609.4c88.5 0 88.5-53.1 106.2-53.1l-17.7-124z",
          transform: "matrix(-.58 0 0 .62 630.4 -10.2)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#0000c4",
          stroke: "#000",
          d: "M336.6 308.3c0 17.7-35.4 212.6 53.2 265.7 35.4 17.7 88.5-17.7 88.5 0l-17.7-141.7z",
          transform: "matrix(-.58 0 0 .62 630.4 -10.2)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#e10000",
          stroke: "#000",
          d: "M372 343.7c0 17.7-17.7 159.4 35.5 194.9 35.4 35.4 124 25.8 124 25.8l-70.9-132.1z",
          transform: "matrix(-.58 0 0 .62 630.4 -10.2)"
        }),
        /* @__PURE__ */ jsx135("path", {
          d: "m456.2 158-94.8 100-1.7-1.6 94.8-99.9z"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#cececc",
          stroke: "#000",
          d: "m460.6 184.3 17.7 35.4v17.7c-.8-1.3 0 17.7-17.7 17.7S443 219.7 443 219.7s-17.7 35.4-17.7 70.9 17.7 53.1 17.7 53.1-2.6-36.7 17.7-35.4c20.4 1.2 17.7 17.7 17.7 17.7v35.4h17.8V219.7l17.7-35.4-27.2-53.2-26 53.1z",
          transform: "matrix(-.14 -.14 -.1 .1 553.7 192.2)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#cececc",
          stroke: "#000",
          d: "m557.8 95.7-26.3 70.8 17.7 53.2-35.4-17.7 35.4 53.1v35.5H567V255l35.5-53.1-35.5 17.7 17.8-53.2-26.9-70.8z",
          transform: "matrix(-.1 -.16 -.14 .1 526 183.8)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#e10000",
          stroke: "#000",
          d: "M422.5 137c0 2-2 3.7-4.3 3.7s-4.4-1.7-4.4-3.7 2-3.8 4.4-3.8 4.3 1.7 4.3 3.8zm-6.2 7.9c0 35.8 20.9 187.8 22.6 191.5.1 4.5-4.8 6.4-7.1.9-6.6-17.4-20.8-160-21.3-193.3-.3-13.7 3.7-14.8 8.3-14.5 3.7.2 8.3 3.7 8.3 7.9 0 5-5.8 8.7-10.8 7.5z",
          transform: "matrix(-.4 0 0 .3 596.3 69.8)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#0000c4",
          stroke: "#000",
          d: "M422.5 137c0 2-2 3.7-4.3 3.7s-4.4-1.7-4.4-3.7 2-3.8 4.4-3.8 4.3 1.7 4.3 3.8zm-6.2 7.9c31.5 61.4 48.7 166.7 50.4 170.5.1 4.4-4.8 6.4-7.1.8-2.5-3.3-12.7-100.2-49.1-172.2-.3-13.7 3.7-14.8 8.3-14.5 3.7.2 8.3 3.7 8.3 7.9 0 5-5.8 8.7-10.8 7.5z",
          transform: "matrix(-.38 .1 .15 .3 564 38.2)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#e10000",
          stroke: "#000",
          strokeWidth: 0.7,
          d: "M453.4 151.5c0 1 1 2 2.1 2 1.2 0 2.2-1 2.2-2s-1-1.8-2.2-1.8c-1.2 0-2.1.8-2.1 1.8zm3 4a1152 1152 0 0 1-11.2 95.8c0 2.2 2.3 3.2 3.5.4 3.3-8.7 10.4-80 10.7-96.6.1-6.9-1.9-7.4-4.2-7.3-1.9.1-4.1 1.9-4.1 4 0 2.4 2.9 4.3 5.4 3.7z"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#0000c4",
          stroke: "#000",
          d: "M422.5 137c0 2-2 3.7-4.3 3.7s-4.4-1.7-4.4-3.7 2-3.8 4.4-3.8 4.3 1.7 4.3 3.8zm-6.2 7.9c31.5 61.4 48.7 166.7 50.4 170.5.1 4.4-4.8 6.4-7.1.8-2.5-3.3-12.7-100.2-49.1-172.2-.3-13.7 3.7-14.8 8.3-14.5 3.7.2 8.3 3.7 8.3 7.9 0 5-5.8 8.7-10.8 7.5z",
          transform: "matrix(-.48 .15 .2 .48 623.3 31.6)"
        })
      ]
    }),
    /* @__PURE__ */ jsxs110("g", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      children: [
        /* @__PURE__ */ jsx135("path", {
          fill: "#e10000",
          d: "M478.4 698a53.3 53.3 0 0 0 53.1 0V556.3h-35.4c17.7 53.1 17.7 106.3-17.8 141.7z",
          transform: "matrix(.58 0 0 .62 9.6 -10.2)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#0000c4",
          d: "M513.8 609.5c0 88.5-42.5 108.2-42.5 126 17.7 0 29.5-8.3 42.5-19.7 17.7-17.8 19.4-107.7 17.7-106.3z",
          transform: "matrix(.35 0 0 .7 123.5 -90)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#0000c4",
          d: "M478.4 609.5c-.9 51.7-44.8 99.6-36.5 110.2 9.4 9.5 36.5-21.7 71.9-4 17.7-17.7 19.4-107.6 17.7-106.3z",
          transform: "matrix(.35 0 0 .7 123.5 -90)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#ffdf00",
          d: "M513.8 609.5c0 88.5-40.7 94.4-40.7 118 17.7 0 40.6-12.9 40.7-11.7 17.7-17.8 19.4-107.7 17.7-106.3z",
          transform: "matrix(.35 0 0 .46 112.5 51)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#ffdf00",
          d: "M478.4 609.5c-.9 51.7-43.8 95.7-35.5 106.3 9.5 9.4 35.5-17.8 70.9 0 17.7-17.8 19.4-107.7 17.7-106.3z",
          transform: "matrix(.35 0 0 .46 112.5 51)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#e10000",
          d: "M478.4 698a53.3 53.3 0 0 0 53.1 0V556.3h-35.4c17.7 53.1 17.7 106.3-17.8 141.7z",
          transform: "matrix(-.58 0 0 .62 630.4 -10.2)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#0000c4",
          d: "M513.8 609.5c0 88.5-42.5 108.2-42.5 126 17.7 0 29.5-8.3 42.5-19.7 17.7-17.8 19.4-107.7 17.7-106.3z",
          transform: "matrix(-.35 0 0 .7 516.5 -90)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#0000c4",
          d: "M478.4 609.5c-.9 51.7-44.8 99.6-36.5 110.2 9.4 9.5 36.5-21.7 71.9-4 17.7-17.7 19.4-107.6 17.7-106.3z",
          transform: "matrix(-.35 0 0 .7 516.5 -90)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#ffdf00",
          d: "M513.8 609.5c0 88.5-40.7 94.4-40.7 118 17.7 0 40.6-12.9 40.7-11.7 17.7-17.8 19.4-107.7 17.7-106.3z",
          transform: "matrix(-.35 0 0 .46 527.5 51)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#ffdf00",
          d: "M478.4 609.5c-.9 51.7-43.8 95.7-35.5 106.3 9.5 9.4 35.5-17.8 70.9 0 17.7-17.8 19.4-107.7 17.7-106.3z",
          transform: "matrix(-.35 0 0 .46 527.5 51)"
        })
      ]
    }),
    /* @__PURE__ */ jsxs110("g", {
      fillRule: "evenodd",
      stroke: "#000",
      children: [
        /* @__PURE__ */ jsx135("path", {
          fill: "#908f8a",
          strokeWidth: 4.5,
          d: "m198.6 78-89.7 35.4 89.7 35.4 44.8-17.7 22.4 17.7 22.4 35.4 22.5-35.4 22.4-17.7H1535V95.7H333l-22.4-17.8c0-17.7 4.7-35.4 22.5-35.4h89.6c0-17.7-44.8-53.1-134.5-53.1-89.6 0-134.5 35.4-134.5 53.1h89.7c17.7 0 22.4 17.7 22.4 35.5l-22.4 17.7z",
          transform: "matrix(.12 0 0 .22 217.8 324.4)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#b74d00",
          strokeWidth: 1.8,
          d: "M204.3 95.7H541v17.7H204.4zm0-17.8H541v17.8H204.4zm0-17.7H541V78H204.4zm0-17.7H541v17.7H204.4zm0-17.7H541v17.7H204.4zm0-17.8H541v17.8H204.4zm0-17.6H541V7H204.4z",
          transform: "matrix(.28 0 0 .27 216 334.6)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#908f8a",
          strokeWidth: 3.3,
          d: "m423.2 60.2 137.8 124h19.7L443 60.3h-19.7z",
          transform: "matrix(.25 0 0 .27 171.9 315.2)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#908f8a",
          strokeWidth: 3.3,
          d: "m423.2 60.2 137.8 124h19.7L443 60.3h-19.7z",
          transform: "matrix(.25 0 0 -.27 171.9 382.2)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#908f8a",
          strokeWidth: 3.1,
          d: "M425.2 60.2v124h17.7v-124z",
          transform: "matrix(.28 0 0 .27 159.6 315.2)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#908f8a",
          strokeWidth: 3.3,
          d: "m423.2 60.2 137.8 124h19.7L443 60.3h-19.7z",
          transform: "matrix(.25 0 0 .27 216.2 315.2)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#908f8a",
          strokeWidth: 3.3,
          d: "m423.2 60.2 137.8 124h19.7L443 60.3h-19.7z",
          transform: "matrix(.25 0 0 -.27 216.2 382.2)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#908f8a",
          strokeWidth: 3.1,
          d: "M425.2 60.2v124h17.7v-124z",
          transform: "matrix(.28 0 0 .27 238.4 315.2)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#908f8a",
          strokeWidth: 3.1,
          d: "M425.2 60.2v124h17.7v-124z",
          transform: "matrix(.28 0 0 .27 204 315.2)"
        }),
        /* @__PURE__ */ jsx135("path", {
          fill: "#908f8a",
          strokeWidth: 3.1,
          d: "M425.2 60.2v124h17.7v-124z",
          transform: "matrix(.28 0 0 .27 194 315.2)"
        })
      ]
    }),
    /* @__PURE__ */ jsxs110("g", {
      fill: "#ffdf00",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      children: [
        /* @__PURE__ */ jsx135("path", {
          d: "M655.5 396.9c0 88-55.6 159.4-124 159.4s-124-71.4-124-159.4 55.5-159.5 124-159.5 124 71.4 124 159.4zm-17.7 0c0 78.2-47.6 141.7-106.3 141.7-58.7 0-106.3-63.5-106.3-141.7 0-78.3 47.6-141.8 106.3-141.8 58.7 0 106.3 63.5 106.3 141.8z",
          transform: "matrix(.58 0 0 .62 9.6 -10.2)"
        }),
        /* @__PURE__ */ jsx135("path", {
          d: "M579.8 250c-14.9-8.1-31.2-12.6-48.3-12.6s-33.4 4.5-48.3 12.5l7 16.4a82.8 82.8 0 0 1 82.7 0z",
          transform: "matrix(.58 0 0 .62 9.6 -10.2)"
        }),
        /* @__PURE__ */ jsx135("path", {
          d: "M579.8 250c-14.9-8.1-31.2-12.6-48.3-12.6s-33.4 4.5-48.3 12.5l7 16.4a82.8 82.8 0 0 1 82.7 0z",
          transform: "matrix(.58 0 0 -.62 9.8 479.3)"
        })
      ]
    }),
    /* @__PURE__ */ jsx135("path", {
      fill: "#a7cfff",
      fillRule: "evenodd",
      d: "M379.6 235.9c0 48.5-27.7 87.8-61.7 87.8s-61.6-39.3-61.6-87.8 27.6-88 61.6-88 61.7 39.4 61.7 88"
    }),
    /* @__PURE__ */ jsx135("path", {
      fill: "#afff7b",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "M637.8 396.9c1.1 26.6-4.6 39.6-11.9 67.3-1.9 3-11-6.5-16.4-11.2s-7.8 4.2-14.6-3c-6.7-7.4-11 2-16-4.2s-51.3-7-51.3-7.6c4.6-2.2 28.2.2 24.4-11.1-4.3-11.8-31-.4-34.6-15.4-2.5-15-53.6-15.6-57.3-19.2 1.5 5.6 39.8 8 38.9 22.5-.9 6-37.7 7.7-41.3 12.7-3 6.3 29-1.7 30.1 6 0 3.2-4.7 0-21.3 5-8.4 2.5 15.4 10.3 6.4 14.6-9 4.3-28.3 6.2-27.5 8 3 9 44.7 19.6 40.6 21.1-14.8 6.6-22.6 10.9-29.7 14.7a167.9 167.9 0 0 1-31.1-100.2c31.7-11.4 25-13.8 83.6-13.8s78 2.3 129 13.8z",
      transform: "matrix(.58 0 0 .62 9.6 -10.2)"
    }),
    /* @__PURE__ */ jsx135("path", {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "M637.8 396.9c-8 0-16.4 3.4-25 3.4-8.7 0-17.5-3.5-26.5-3.5s-19.3 4.6-28.5 4.6c-9.3 0-17.4-4.5-26.7-4.5s-18.6 3.4-27.8 3.4-18.3-3.5-27.2-3.5-17.7 3.5-26.2 3.5-16.8-3.5-24.7-3.5c0-19.5 3-38.1 8.4-55.1 27 2 11-15.7 27-15.7a33 33 0 0 1 25.3 9.8c2.4 0 14.4-11.4 27.9-9.8 13.4 1.6 8.5 27.3 26.4 28.6 9 6.8 14.3 11.1 26.7 13.9 17.7 1.6 68.4-2.5 68.7-.2a188.2 188.2 0 0 1 2.2 28.6z",
      transform: "matrix(.58 0 0 .62 9.6 -10.2)"
    }),
    /* @__PURE__ */ jsx135("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "M549.9 474c0-5.7 13.5-9.5 13.5-18.6s-12-9.3-12.4-17.8c-.2-3.5 10.3-7 14.9-7.4s8.5 7.4 8.5 9.1-4.7-4.2-8.6-4.3-12.3.6-12.3 2.3c0 3.4 14.8 7.6 13.7 19-1.1 11.2-12.7 14.6-12.7 18s5 12.8 5 12.8-9.7-7.5-9.7-13.2z",
      transform: "matrix(.2 0 0 .48 217.2 59.5)"
    }),
    /* @__PURE__ */ jsx135("path", {
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "M549.9 474c0-5.7 13.5-9.5 13.5-18.6s-12-9.3-12.4-17.8c-1-4 11.8-6.6 16.4-6.9s10 8 10 9.6-5.4-5.2-9.3-5.3-14.6.6-14.6 2.3c0 3.4 14.8 7.6 13.7 19-1.1 11.2-12.7 14.6-12.7 18s5 12.8 5 12.8-9.7-7.5-9.7-13.2z",
      transform: "matrix(-.2 0 0 .48 445.8 59.1)"
    }),
    /* @__PURE__ */ jsx135("path", {
      fillRule: "evenodd",
      d: "M333 264.9c0 1.3-.7 2.4-1.5 2.4s-1.4-1.1-1.4-2.5.6-2.4 1.4-2.4c.8 0 1.5 1.1 1.5 2.5m17 9h.4v19.5h-.5zm4.1-1.6h.5V292h-.5z"
    }),
    /* @__PURE__ */ jsx135("path", {
      fillRule: "evenodd",
      d: "M352.6 281.2v-.5l4 .7v.5z"
    }),
    /* @__PURE__ */ jsx135("path", {
      fill: "#b74d00",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "M497.3 478s26 11.4 31.7 18.2c5.6 6.8 3.4 6.8 3.4 6.8l57.7 2.3c0-3.4 10.2-3.4 12.5-11.4 2.3-7.9 2.3-10.2 2.3-10.2l-18.1 5.7 1-10.2H572l-2.3 10.2-34-1.1L538 461l-6.8 1.1-1 26c-1.2 0-31.8-7.9-33-10.1z",
      transform: "matrix(.58 0 0 .62 7 -9.5)"
    }),
    /* @__PURE__ */ jsx135("path", {
      fill: "#fede00",
      fillRule: "evenodd",
      stroke: "#fede00",
      strokeWidth: "1pt",
      d: "M440.5 316.3s37.7-11.2 92.1-10.4 92.1 12.8 91.3 12.8-10.4-18.4-10.4-18.4-38.4-10.5-81.7-11.3c-43.2-.8-80.9 8-80 8.8z",
      transform: "matrix(.58 0 0 .62 9.6 -10.2)"
    }),
    /* @__PURE__ */ jsx135("path", {
      fill: "#38a9f9",
      fillRule: "evenodd",
      d: "m306 169.8 13.6-.2.2 7.9-13.6.3zm-31.2 4.3L270 182l16.2-2-1.3-7.7-10.1 2zm13.7-3 13.6-1.1.6 7.8-13.5 1.2zm48.9-.7-13.5-1-.5 8 13.5.8zm29.2 5 4.9 9.6-14.6-3.6 1.6-7.7 8 1.6zm-11.8-3-13.4-1.7-1 7.8 13.5 1.8z"
    }),
    /* @__PURE__ */ jsx135("path", {
      fill: "#ffdf00",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "m532.6 323.5-2.5-13.5-7.6 11.5 2.8-13.5-11.3 7.7 7.6-11.3-13.4 2.8 11.5-7.6-13.5-2.5 13.5-2.6-11.5-7.6 13.4 2.8-7.7-11.3 11.4 7.7-2.8-13.5 7.6 11.5 2.5-13.5 2.6 13.5 7.5-11.5-2.7 13.5 11.3-7.7-7.7 11.3 13.5-2.8-11.5 7.6 13.5 2.6-13.5 2.5 11.5 7.6-13.5-2.8 7.7 11.3L540 308l2.8 13.5-7.6-11.5z",
      transform: "matrix(.58 0 0 .62 9.6 -10.2)"
    }),
    /* @__PURE__ */ jsx135("path", {
      fill: "#ffdf00",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "M547 293.9c0 9.3-6.6 16.8-14.8 16.8s-14.8-7.5-14.8-16.8S524 277 532.2 277s14.8 7.6 14.8 17z",
      transform: "matrix(.57 0 0 .5 18.3 21.8)"
    }),
    /* @__PURE__ */ jsx135("path", {
      fillRule: "evenodd",
      d: "M320.7 170.6c0 .5-1.3 1-2.8 1s-2.8-.5-2.8-1 1.2-1 2.8-1 2.8.4 2.8 1m6 0c0 .5-.9 1-2 1s-2.2-.5-2.2-1c0-.6 1-1 2.1-1s2.1.4 2.1 1"
    }),
    /* @__PURE__ */ jsx135("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "m529.4 297.9.8.8c-1.9-2-1-1.2 1.6 3.2 2.4-.5 3.1-1.4 4.8-2.4",
      transform: "matrix(.56 -.18 .17 .6 -26.7 90.6)"
    }),
    /* @__PURE__ */ jsx135("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: "1pt",
      d: "m527.8 304.3.8.8c-1.9-2-1-1 3.2 1.6 4 .5 8.1-1.2 10.5-4",
      transform: "matrix(.58 0 0 .62 8.7 -10.2)"
    }),
    /* @__PURE__ */ jsx135("path", {
      fill: "#b7e1ff",
      fillRule: "evenodd",
      d: "M281.4 194.8s1 8-5.1 18c-6 9.9-5.1 6.4-5.1 6.4s2.8 5.5 2.3 5.5-4.7-5-4.7-5l-5 5.5s4.6-8.5 4.1-8.5-1.4-3-1.4-3l3.7-1.5s5.6-10.4 5.6-9.9-16.7 11.4-16.7 11.4zm3.7 3c-.5 0 2.3 8 4.7 12 2.3 4 2.3 8.9 2.3 8.9l7.9 4-10.2-15.4 6.5 2.4zm0 20.9s5.6 6 6 8 .5 6.4.5 6.4l-2.3-5-3.3 4.5s2.4-7 1.9-7.5-3.7 2.5-3.7 2.5 1.4-4 1.4-4.4 0-3-.5-4.5m-27.9 13.9c1.9-1.5 5.6-2.5 5.6-2.5s-2.3 4-2.8 4-1.8 0-2.8-1.5m64.1-21.8s12.1 7.4 12.1 7.9-7.9-3.5-7.9-3.5zm-21.8-15.5c1 .5 17.7 14.4 17.2 14.4s-7.4-4-7.4-3.4v3.4l-3.8-7.9-.9 3zm4.2 22.4 4.6 9.4 4.7-1s-8.8-8.4-9.3-8.4m14.4-6 .5 9s2.7 2.5 2.7 2-2.7-10.5-3.2-11"
    }),
    /* @__PURE__ */ jsx135("path", {
      fill: "#984000",
      fillRule: "evenodd",
      d: "M182.6 89.5s21-11.6 44.9-20.2a303.8 303.8 0 0 1 54.2-14.4c7 0 19.2 17.8 21.2 17.8s10.1-5 20.3-5 16.1 8 18.2 8h18.2c2 0-6.1-19.8 0-18.8 3 .5 28.8 4.5 52.8 12.2 24 7.8 58 21.6 58 21.6S414.9 98 400 95.9c-2 1 0 13-3 7.7-4.6-1-21.7-3.7-24.7-3.7s-8.7 3.4-16.8 5.4c-8 2-18.2 5-18.2 5l13.2 20.7-16.2 8s-10.1-23.8-14.2-23.8-6 16.8-11.1 15.8c-5-1-7-15.8-11.1-19.8-4-3.9-25.4-5.4-33.5-7.3-8-2-21.1-3.5-28.2-5.5-7-2-14.2 5-17.2 5s4-6 1-7-5 3-7 3-23.3-4-25.3-5 5-4.9 3-4.9z"
    }),
    /* @__PURE__ */ jsx135("path", {
      fill: "gray",
      fillRule: "evenodd",
      stroke: "#772600",
      strokeWidth: 3.7,
      d: "M463-65c0 21.2-20.6 38.4-45.9 38.4S371.3-43.8 371.3-65s20.5-38.3 45.8-38.3S463-86.1 463-65z",
      transform: "matrix(.22 0 0 .26 231.6 96.5)"
    }),
    /* @__PURE__ */ jsx135("path", {
      fill: "#984000",
      fillRule: "evenodd",
      stroke: "#772600",
      strokeWidth: 5.3,
      d: "M284.7-60c6.7-6.6 15-16.6 36.7-16.6 5-1.7 5-11.7 16.6-11.7 11.7 0 8.3 10 16.7 13.4 8.3 3.3 76.6-3.4 76.6-3.4s6.6 5 6.6 11.7-5 11.6-6.6 11.6-68.3-5-73.3-3.3c-5 1.7-8.3 3.3-20 3.3-11.6 0-15-11.6-23.3-11.6s-16.6-1.7-30 6.7z",
      transform: "matrix(.27 0 0 .32 205.4 100.7)"
    }),
    /* @__PURE__ */ jsx135("path", {
      fill: "none",
      stroke: "#772600",
      strokeWidth: 3.5,
      d: "M487.9-76.6h26.6c9.6.1 12.9 3 21.7 3.3h23.3c8.5-.3 13-2.3 21.6-3.3 14.5-.2 9.6-1.3 6.7-10-2.6-6.5-3-9.6-6.7-13.3-1.4-8-4.6-10.8-5-20-1.5-7-4.3-11.7-1.6-20 3.8 5.7 5.3 8 15 8.4 10 0 13.9-.3 20 3.3 4.6 4.9 10.8 3.3 20 3.3 7.6 1.4 8.9 5.3 14.9 8.3 7.1 4 11.7 5 21.6 5 8 1.5 15 2.6 20 5 4.3 5.1 11 6.4 20 6.7 5 0 9-.5 13.3-1.7 7.7.4 15.5 0 25 0 6.2 7.2 7.6 9.9 18.3 10 7.4 5.2 13.6 6 20 8.3h25c9 .7 11.8 4.4 20 6.7a200.9 200.9 0 0 0 21.6 8.3 108 108 0 0 0 21.7 1.7c6.1 3.2 13.6 3.4 18.3 6.6 6.9 1.5 16.3 3.3 21.6 5 8.8 1.2 12.2 4 20 5 6.7 2-2.2 3.6-6.7 5-9.8-.3-10.5-4-20-5-5-2.9-12.6-2.5-20-5h-1.6c6.6 4 13 6.5 10 13.4-8.5 0-15.4-1.1-23.3-1.7-8.4-1.6-12.2-3.3-21.6-3.3 9.4-2.3 11.8.2 18.3 3.3 2.4 8-2.8 5-11.7 5-7.6-2.7-12.2-6-21.6-6.7h-20c9.9.4 12 4.1 18.3 8.4.5 2.6-.1 2.4-5 3.3-5.2-4.5-11.9-6-20-8.3-7.9-.3-16.2-1-23.3-3.4-4.9-.3-4.1-6.1 6.7 3.4 6.5 3.8 8.8 7 8.3 10-8.6-2.2-12.8-5.6-18.3-8.4a61.3 61.3 0 0 0-23.3-3.3c-8.6-2.3.9-3.6 6.6 5 12.4 8.8-1.6 5-6.6 3.3-7.5-2.1-15.3-5.2-21.7-6.6-5-1.5-9.4-2.9-15-3.4 8.7.8 11.6 3.9 15 10 8.8 6-.4 3.1-8.3 1.7-5-4.4-11.5-6.7-15-11.7-8.3-4.1-8.6-9-3.3 1.7 1.3 3.4 1 10.8 1.6 11.7-6.1-6.7-4.8-8.4-11.6-8.4-4.7-3.2-11.5-5.7-15-10-6.4-.6-6.8-2.9-13.3-5 5.3 6.3 12.4 12.5 16.6 18.4 7.6 4.2 9.7 8 15 11.6 2.1 3.7 8 6.7 1.7 1.7-7.2-7-12.5-8.7-23.3-13.3-6.2-5-8.4-7-15-11.7-9-2.9-5.5-4.5 0 5 6.3 5.8 11.1 12.2 16.6 16.7a67.8 67.8 0 0 0 15 13.3c1.5 2.2 6 2.6 0 3.3-5-4.6-12.4-7.5-18.3-11.7-8.3-2.3-12.2-6.6-18.3-11.6-4-5.9-10.4-10.4-15-15-9.6-3.8 1.9 3.6 5 8.3 2.1 6.1 4.8 11 6.6 16.7 2.8 5.5-8.4-1.3-11.6-3.3a57 57 0 0 0-21.7-8.4 298 298 0 0 0-20-3.3c-7.5-2 4.1 4.8 8.4 11.7 8.4 7.9-8.3 1.4-13.3 0a125 125 0 0 0-25-1.7c-10.7.6-3 2 0 6.6 3.3 2.6 5.6 8 5 10-7-1-13-3-21.7-3.3-7 2.3-15.3 1.7-23.3 1.7-.3 4.2 1.5.6 5 5 5.8 2.3 9.6 5.1 8.4 8.3h-48.3c-5.3 1.4 1.1.7 5 6.7-2.2 5.4-5 3.3-11.7 3.3-4.5-1.8-13.6-2.6-18.3-5-4.7 0-4.3-1.2-8.3-1.7 14 10 7 7.5 15 15 1.3.5 4.5 1.7 1.6 1.7M371.3 73.3c-1 0-3.2-5.4-6.6-10-2.4-6-5.4-2.6-8.4-11.7.4-9.4.7-11 0-20-6.8-4.8-9.7-6.2-15-15-8.4-7 1.3-19 2.9-27.8-7.4-1.6-11 11.5-22.3 16.2-8.2 5.5-1-11.4-5-21.2-2.7-13.9-10.8 7-13.8 12.9-5.5 3.7-7.2 8.5-15 1.6 0-5.1 4.9-19.5 2.8-22.3-7.8 3.9-18 15.5-26.1 17.3-8.2-1.7 1.7-14.8 1.7-24.5-3-1-14.7 25.8-19.5 26s-2.7-26-5-25.4c-3.5 5-10.6 15.4-15.5 19-9.5-1.3 1.4-17.5 2.8-23.5 1.6-7.2-8.9 13.8-14.5 15.1-4.1 3.6-12.2 6-15 6.7 3.2-6.2 19-18.7 18-22.3-9.3.3-23.4 12.5-31.3 14-5.2 0-12.4 1.7-13.3 1.6.4-8 19.4-14.6 22.4-19.5-9.3 1.5-27.2 9.7-32.4 16.2-6.2 1.3-14 3-20 0 .9-7.5 14.9-22 18-26.8-8.5 3.7-12.7 6.6-21.7 8.3-1.7 1.7-6.5 5.3-5 1.7 2.7-7 6.7-10 10-15-7.5 1.4-10.3 5.7-18.3 10-5.1.2-19.7 14.9-24.6 15.1a69.1 69.1 0 0 1-28.3 13.3c-7.6 1.4-11.3 3-15 6.7 3.8-6.7 9.6-13 15-16.6a29.8 29.8 0 0 1 15-13.4c1.9-2.3 7.1-2.9 1.6-3.3-4.7 4.2-12.7 9-16.6 11.7-5.1 3.2-11 6.4-13.4 5 2.7-7.2 7.5-9 11.7-15 8.8-5.6 0-2-6.7 0-4.3 3.8-12 6.7-18.3 10-7 1.8-11.7 6-20 8.3 0 2.4 2.4-4.3 3.4-6.7 6.8-7.4 8.6-9.5 16.6-11.6 2-2.9 4.4-1.7-1.6-1.7-4.6 4-10.8 6.2-16.7 10-5.9 1.3-13.6 1.7-21.6 1.7-10.4 1.2-9.5 2 0-3.4 5.3-5 9.7-3.7 10-10-6.3 4.6-14 8-21.7 11.7-6.4.2-8.1 1.7-15 1.7 3.3-3.4 5.3-7.7 10-10 7-7.7-4.4-1.5-6.7 0h-25c-4.4 5.6-.2 0 3.4-3.4 4.3-2.2 8.8-5.1 8.3-6.6-5 4.3-10.7 6.3-15 10-4.6 1.4-10 2-10 3.3 3.7-5.3 9.6-8.6 13.4-13.3 5.6-1.2 10.4-3 11.6-5h-23.3 16.6c8.5 0 15.7-.8 23.4-1.7 13.2-2.2-1.2-3.3-8.4-3.3-1.3-2.6 4.2-4 10-5C-6.7-69-.4-71.1 5-73.3a45.2 45.2 0 0 0 13.3-6.6c-5 .2-5 1.4-10 1.6 7.5-.5 12.8-1.6 21.7-1.6a239 239 0 0 0 21.6-8.3c3-3.6 4.2-3.4-3.3-3.4 6.7-2.1 16.2-3.2 21.6-5a94 94 0 0 0 20-6.6c4.9-3.3 7.7-7.2 13.3-10 6.5 4.4 6.6 5 18.3 5 9.4-.1 15.2-2.4 20-6.7 7.2-2 8.5-5.4 16.7-6.6a134 134 0 0 0 23.3 1.6c8-2.1 15.7-6 21.6-10 5.1-2.5 11.2-6.1 16.7-8.3 6 3.1 10.8 5.6 18.3 6.7 7.7-1.2 11.8-5 18.3-6.7a28 28 0 0 1 15-8.3c9.7-4.8 9 1.5 13.3 6.6 5 5.2 11.4 2.7 18.3 5 3.9 6 6.7 10 11.7 13.3 3.9 4.8 8.5 6 16.7 6.7 3 4 .6 6.8 6.6 8.3 2.4 2.6 6.5 3.6 10 5",
      transform: "matrix(.27 0 0 .32 205.4 104.9)"
    }),
    /* @__PURE__ */ jsx135("path", {
      fill: "none",
      stroke: "#782600",
      strokeWidth: 3.1,
      d: "M468.7 30.8v.8c0-2.3 0-1 1.7 3.4.6 3.6-.8 3.2-2.5 5.8-.3 3.7-.8 6.4-.8 10.8-.6 3.6-2.6 7-4.2 10-1.6 3.1-8.5 4.9-8.3 9.2-4 1.1-4.1-1.5-4.2-5.9-2.4-2.7-3.2-6.4-5-10-1-3.4-3.4-6-5-10-2.4-3.7-4.5-4.8-6.6-9.1-.9-2-.7-4.6-2.5-5.8-2.7-3.5-4.5-4-9.2-4.2-3.6.8-5 2.4-8.3 3.3-2.6.9-7.6.6-10.8 1.7-.8 1.3 1.6 2 2.5 5-2.2 1.8-3 4.9-4.2 7.5-2 2.5-3.3 3.7-4.2 7.5 1.4 2.3.2 5.4-1.6 7.5-.6 3.8-2.5 5.9-3.4 9.1-2.6 1.9-3.6 3.6-5.8 6.7-1.9 2.7-3.6 2.5-8.3 2.5-3.7-1-4.2-3-7.5-4.2-.3-1-.6-1.3-1.7-1.6",
      transform: "matrix(.27 0 0 .32 205.4 104.9)"
    }),
    /* @__PURE__ */ jsx135("path", {
      fill: "#812e00",
      fillRule: "evenodd",
      d: "M307.6 125.5s-.4 5-3.6 8.3-9.8 7.1-9.8 7.1 8.9-4.2 9.8-3.3c1 1-5.7 8.3-5.7 8.3s8.7-7.7 9.8-7.7 3.6 7.5 4.6 7.3c.9-.2-2-9.5-1.6-11 .4-1.4 0-9.3 0-9.3l-3.4.3zm20.5-.6s-.4 5.3-3.6 8.8-9.8 7.6-9.8 7.6 8.9-4.5 9.8-3.5c1 1-5.7 8.8-5.7 8.8s8.7-8.2 9.8-8.2 3.6 8 4.6 7.8c.9-.2-2-10.2-1.6-11.7.4-1.6 0-10 0-10zm-28.7-48c0 .9-1 1.7-2.1 1.7s-2.2-.8-2.2-1.8 1-1.8 2.2-1.8 2.1.8 2.1 1.8z"
    })
  ]
});
var Ec_default = SvgEc;

// src/country-flag-icons/generated/Ee.tsx
init_esm_shims();
import { jsx as jsx136, jsxs as jsxs111 } from "react/jsx-runtime";
var SvgEe = (props) => /* @__PURE__ */ jsxs111("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx136("path", {
      fill: "#1791ff",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsx136("path", {
      fill: "#000001",
      d: "M0 160h640v160H0z"
    }),
    /* @__PURE__ */ jsx136("path", {
      fill: "#fff",
      d: "M0 320h640v160H0z"
    })
  ]
});
var Ee_default = SvgEe;

// src/country-flag-icons/generated/Eg.tsx
init_esm_shims();
import { jsx as jsx137, jsxs as jsxs112 } from "react/jsx-runtime";
var SvgEg = (props) => /* @__PURE__ */ jsxs112("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx137("path", {
      fill: "#000001",
      d: "M0 320h640v160H0z"
    }),
    /* @__PURE__ */ jsx137("path", {
      fill: "#fff",
      d: "M0 160h640v160H0z"
    }),
    /* @__PURE__ */ jsx137("path", {
      fill: "#ce1126",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsxs112("g", {
      fill: "#fff",
      stroke: "#c09300",
      transform: "matrix(.8 0 0 .8 -40 0)",
      children: [
        /* @__PURE__ */ jsx137("path", {
          strokeLinejoin: "round",
          strokeWidth: 1.3,
          d: "m450.8 302.4 68.5 63.6-4.9-115.5c-.7-17.5-15.9-13.5-27-7.2-11.1 7.2-24 7.2-37.4 2.5-13.5 4.7-26.3 4.7-37.4-2.5-11-6.3-26.3-10.3-27 7.2L380.7 366z"
        }),
        /* @__PURE__ */ jsx137("path", {
          id: "eg_svg__a",
          fill: "#c09300",
          stroke: "none",
          d: "m393.5 246.5-4.8 112.3-8 7.2 4.9-115.5a24 24 0 0 1 7.9-4m9.6 8-4 94-8 8.2 4.8-108.5c1.6 1.6 6.3 5.5 7.2 6.3m8.7 7.2-3.1 78.4-6.5 6.3 4-89.4c1.6 1.5 4.8 3.8 5.6 4.7m9.5 4-3.1 66.8-6.3 5.1 3.1-74.3c1.6.7 4.7 2.4 6.3 2.4m8.8 0-2.3 55.7-6.5 6.3 2.5-61.3c1.5 0 5.6 0 6.3-.7"
        }),
        /* @__PURE__ */ jsx137("use", {
          xlinkHref: "#eg_svg__a",
          width: "100%",
          height: "100%",
          transform: "matrix(-1 0 0 1 900 0)"
        }),
        /* @__PURE__ */ jsx137("path", {
          fill: "#c09300",
          strokeWidth: 1.1,
          d: "m453.2 315 9.6 43.8-3.2 3.2-3.3-2.5-5.4-39 2.3 39-3.2 4-3.1-4 2.3-39-5.5 39-3.3 2.5-3.2-3.2 9.6-43.7h6.4z"
        }),
        /* @__PURE__ */ jsxs112("g", {
          id: "eg_svg__b",
          fill: "none",
          strokeLinejoin: "round",
          strokeWidth: 1.3,
          children: [
            /* @__PURE__ */ jsx137("path", {
              fill: "#fff",
              strokeWidth: 1.2,
              d: "m428.5 295.8-19.1 67.7 26.3 4 11.1-50.9z"
            }),
            /* @__PURE__ */ jsx137("path", {
              d: "m422.2 319 2.3 5.5 12.4-11.8"
            }),
            /* @__PURE__ */ jsx137("path", {
              d: "m430.8 305 2.6 24.3 7.9-10.4m-3.2 4 4.3 15m1.7-5.5-8.7 13.2m2.7 13.2-2.8-13.2-2.4-13.4-5.9 7.9-2.5-9.1-8.2 8.4 4.1 15.2 5.8-9.4 3.1 9.6 6-9.2"
            }),
            /* @__PURE__ */ jsx137("path", {
              d: "m415 362 5.3-7.5 3.4 11.5 4.8-8 3.1 9.6"
            })
          ]
        }),
        /* @__PURE__ */ jsx137("use", {
          xlinkHref: "#eg_svg__b",
          width: "100%",
          height: "100%",
          transform: "matrix(-1 0 0 1 900 0)"
        }),
        /* @__PURE__ */ jsxs112("g", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.3,
          children: [
            /* @__PURE__ */ jsx137("path", {
              strokeWidth: 2.4,
              d: "M450 393.8c20 0 39-1.6 50.2-4.7 4.7-.9 4.7-3.3 4.7-6.5 4.8-1.6 2.4-7.2 5.7-7.2-3.4 1-4-5.5-8-4.7 0-5.6-5.7-6.3-10.4-4.7-9.5 3.1-26.3 3.9-42.2 3.9-16-.8-32.6-.8-42.2-4-4.7-1.5-10.3-.8-10.3 4.8-4-.8-4.7 5.6-8 4.7 3.3 0 .8 5.7 5.6 7.2 0 3.2 0 5.6 4.8 6.5 11 3.1 30.2 4.7 50.1 4.7"
            }),
            /* @__PURE__ */ jsx137("path", {
              d: "M422.9 363.5c6.4.9 13.6 1.6 19.2.9 3.2 0 5.5 5.5-.9 6.3-5.5.7-14.3 0-19-.8a231 231 0 0 1-18.4-4c-5.6-2.4-1.6-7 1.6-6.4a105.3 105.3 0 0 0 17.5 4m54.2 0c-6.4.9-13.6 1.6-19 .9-3.4 0-5.7 5.5.7 6.3 5.6.7 14.3 0 19-.8 4-.8 12.8-2.3 18.4-4 5.6-2.4 1.6-7-1.6-6.4a105.2 105.2 0 0 1-17.5 4"
            }),
            /* @__PURE__ */ jsx137("path", {
              d: "M403 360.4c-4.8-.9-7 4.7-5.5 7.9.7-1.6 4-1.6 4.7-3.2.9-2.4-.7-2.4.9-4.7zm19.2 14.7c0-3.2 3.1-2.8 3.1-6 0-1.5-.8-4-2.4-4a3.4 3.4 0 0 0-3.2 3.2c-.7 3.1 2.5 3.6 2.5 6.8m22.7-9.1c4.7 0 4.2 6.3 2 9.5 0-2.3-4-3.2-4-4.8 0-2.4 3.6-2.4 2-4.7m52-5.6c4.9-.9 7.2 4.7 5.6 7.9-.7-1.6-4-1.6-4.7-3.2-.9-2.4.7-2.4-.9-4.7M478 375c0-3.2-3.2-2.8-3.2-6 0-1.5.8-4 2.4-4a3.4 3.4 0 0 1 3.2 3.2c.7 3.1-2.5 3.6-2.5 6.8zm-23-9c-4.7 0-4.2 6.3-2 9.5 0-2.3 4-3.2 4-4.8 0-2.4-3.6-2.4-2-4.7"
            }),
            /* @__PURE__ */ jsx137("path", {
              strokeWidth: 0.9,
              d: "M404.7 362c1.6 0 4 .7 4.7 1.6zm7.9 2.4c.8 0 4 .7 5.5 1.6zm28.6 3.2c-1.5 0-4.7 0-5.5.7l5.5-.8zm-8.7 0c-.9-.9-4-.9-5.6 0zm62.8-5.6a8 8 0 0 0-4.7 1.6zm-7.8 2.4c-1 0-4 .7-5.6 1.6zm-28.7 3.2c1.5 0 4.7 0 5.6.7l-5.6-.8zm8.7 0c.9-.9 4-.9 5.6 0z"
            }),
            /* @__PURE__ */ jsxs112("g", {
              fill: "#c09300",
              stroke: "none",
              children: [
                /* @__PURE__ */ jsx137("path", {
                  d: "M403.3 374.6c-.5-.1-.8-.6-.6-1 .1-.7.6-1 1-.8.4 0 .9.6.9.8l-.4.7-.2.1c0 .2-.4.2-.7.2m55 3.9c-.2 0-.6-.5-.6-.7 0-.4.6-1 1-1l.8.4c.3.3.3.9-.1 1.2-.2.2-.8.2-1.1 0zm.3 2.5c-.4-.2-.5-.4-.6-.8 0-.5 0-.6.5-.9l.4-.2.4.2c.4.2.7.4.7.8 0 .3-.3.6-.7.8-.3.2-.4.2-.7 0z"
                }),
                /* @__PURE__ */ jsx137("path", {
                  d: "M407.8 370c-.4 0-.9.4-1.2.6-.6.1-1.4.5-2 0-.6-.1-1.4 0-1.5.8.1.7 1 1 1.6.6.4-.5 1.5-.9 1.7 0-.5.8-.4 1.7-.8 2.4 0 .5-.3.9-.5 1.3-.5 0-1 0-1.4.3a2 2 0 0 0-1.6.8c-.4.6-.8 1.2-.9 2 .1.6 1 .8 1.6.9l2 .6 3.2.9c1.6.5 3.2.7 4.8 1.1l.5.1c.7.2 1-.5 1-1l1-3.6c.2-.5.5-1.5-.4-1.3-.5.3-1 .8-1.6.8-.9 0-.4 1 0 1.3 0 .6-.2 1.3-.5 1.8-.6.3-1.2 0-1.8-.2-.5 0-1.7-.3-1.2-1l.5-1.8c.3-.6.3-1.3.5-2-.4-.7-1 .3-1.5.4-.4.2-1.6.3-1 1 .6.4.2 1.1 0 1.7 0 .7-.8 1-1.4.7-.6 0-1.5-.5-1-1.1l.5-1.8.7-2c0-.7.3-1.2.6-1.8 0-.7.5-1.3.5-2 0-.3-.2-.4-.4-.4zm-3.7 7.3a.3.3 0 0 1 .3 0c.2.2.2.4 0 .6l-.3.2c-.5 0-.6-.1-.6-.3 0-.1 0-.2.3-.3a1.4 1.4 0 0 1 .4-.2zm-1 5c-.5-.4-.4-.7.3-1.3.4-.2.5-.2.9.1.6.5.6.8 0 1.3-.2.2-.3.2-.5.2-.3 0-.4 0-.7-.2zm3 1a.9.9 0 0 1-.6-1.1c.2-.4.3-.5.9-.5.7 0 .8.1.9.7 0 .4 0 .5-.3.7a1 1 0 0 1-.8.2zm89.2 0c-.2-.1-.3-.2-.3-.5 0-.4.2-.7.8-.9.6-.3 1-.3 1.2.2.3.6.3.8-.1 1.2-.2.3-.3.3-.8.3s-.6 0-.8-.2zm-85 1.2c-.4 0-.6-.4-.6-.8 0-.3 0-.4.2-.6l.6-.2.6.1c.5.4.6.8.3 1.2-.3.4-.6.4-1.2.3zm21.8 1-.2-.3c0-.6 0-1.1.2-1.7.1-.5 0-1 .2-1.5l.4-2.8c0-.5 0-1 .2-1.4.1-.8 0-1.5.2-2.2 0-.3.3-1 .6-.6.4.6.9 1 1.4 1.5.4.3 0 .7-.3.8-.4.1-.5.6-.5 1l-.2 1.2c0 .7 0 1.3-.2 2l-.1 1.8-.2 1.2c0 .4 0 .9-.4 1.1-.3.2-.8.2-1-.1zm29.7-9.8-1.3 1.2c-.6.5.5.7.6 1.1.2.6.2 1.2.2 1.8.2.6.3 1.1.2 1.7 0 .7-.8.5-1.2.9-.5.2-.7.7-1 1a4.2 4.2 0 0 0-.4 1.6c0 .5-.3 1 0 1.4l.1.2h.5l1.5-.1c1.2-.2 2.5-.2 3.7-.3l2.2-.2c.6.1.9-.5.9-1-.4-.7-.1-1.4-.4-2-.2-.8-.1-1.5-.2-2.2 0-.6-.7-.8-1-.4-.4.4-1 .5-1.2.9-.3.6.6.6.8 1l.1 1.5c.1.6-.5.6-1 .7-.5.2-1.2.3-1.5-.3-.2-.5-.2-1-.2-1.5 0-1-.3-1.8-.3-2.7 0-1-.3-2.1-.3-3.2 0-.5-.1-1.2-.8-1.1m-.6 8.2h.3v.8l-.3.1a3.3 3.3 0 0 1-.4.1 2.5 2.5 0 0 1-.2 0c-.2-.2-.2-.5.1-.8zm-30-9.2c-.3 0-.8.7-1.2.6-.9.1-.8 1-.1 1.3v.8c.1.8-.4 1.5-.3 2.3 0 .8-.3 1.7-.3 2.6-.3.9-.3 1.8-.4 2.7-.1.8-.7.5-1.2.3v-1c.1-.9-.5-1.1-1.2-1.2-.7 0-1-.5-.8-1.1.3-.4 1-.3 1.5-.3 1 .2.9-1.1.4-1.6-.4-.6-1.2-1-1.4-1.6 0-.8-.5-1.7-1.2-2.1-1.1-.1-2 .8-2.3 1.8-.5 0-1 .2-1.4.4-.7.2-1.7 1.4-.7 1.9.5.1 2.2.5 1.4 1.2-.4.8-1.2.8-1.9.6-.7 0-1.5-.4-1.5-1.2-.1-.8-.1-1.6-.4-2.3-.2-.8-1.1-.6-1.2.2-.7.5-.6 1.4-.1 2 .3.7 0 1.6-.3 2.2-.2 1-1.2 1-1.9 1.2-.3.2-1.6 0-1.1.7a4 4 0 0 0 2.4.3c.8 0 1.5-.7 2-1.4.5-.5 1.4-.2 2.2-.2.7 0 1.5.5 2.3.1.2-.5 1.2-1.5 1.5-.5 0 .9.7 1.3 1.5 1.2.9 0 .5.6.5 1.2 0 .9.7 1.4 1.5 1.8h.8c.7-.3 1.5-.6 1.8-1.4.3-.7.3-1.5.5-2.2.2-1.1.4-2.3.4-3.4.3-1 .2-2.1.4-3.2l.3-2.3c0-.5-.2-.5-.5-.4m-6.7 4.1c.1 0 .2.2.2.5 0 .4.2.7.5.8v.3l-.8.2c-.5 0-.9-.2-1.2-.5l-.2-.2.3-.2.5-.5c.3-.3.5-.4.7-.4m66-7.9a8.4 8.4 0 0 0-1.7.3c-1 0-1.5 1-.5 1.6.6 1.5 1.5-.4 2.5-.2 1.4.2 1.5 1.8 1.8 3 0 1.1.4 2.2.7 3.3 1 1.1-.7 1.8-1.4 1-.6-.7-2-1.5-2.7-.6-.9.4-1 1.6-1.7 2-1.2.3-1.3-1.2-2-1.8-.6-.9-1.7-1-2.6-1.2-.4-.9-.2-2.4-1-3-.8.3-2.2 1.7-1 2.4 1 1-.5 1.4-1 2-.8.9-1 2-1 3-1.3.7-1.5-.8-1.7-1.7 0-1.1-1-.8-1.7-.4-1 .4-1.4 1.3-2 2v2c.2.9 1.2.5 1.8.4 1-.4 1.4.7.6 1.3-.6.6-2.2.3-2 1.4h1.6c1-.3 2.2-1.1 2.3-2.3.2-1 1.7-.9 2.5-1.1 1-.3 2.3-.4 2.6 1 .7.7 2.2 1.5 3 .5a2.4 2.4 0 0 0 1.1-2.3c-.1-.8 1.3-.8 1.7-.3.5.8 2.1.6 2.9 0 .8-.5 1-1.6 2.2-1.6l5.4-1.5c1.4-.3-.2-1.2-.6-1.8-1-.5-2 1.7-3.2.6-1-.7-.9-2-1.2-3.1-.3-1.4-.2-3-1.2-4-.6-.7-1.6-.9-2.5-.9m-6.8 9.5c.1 0 .3 0 .5.2.4.2.7.6.7 1 0 .2 0 .2-.3.3l-.5.2c-.2 0-.7-.3-.7-.5v-.4c-.2-.4-.2-.4 0-.6zm6.5.4c.4 0 .6 0 .8.3.1.4 0 .6-.4.8l-.5.2-.4-.3c-.2-.1-.3-.2-.3-.4 0-.3.4-.6.8-.7zm-9 0c.2 0 .3 0 .4.2.2.2.3.3.3.6v.6c0 .3 0 .2-.6.2s-.7 0-.7-.6c0-.4 0-.5.3-.7.1-.2.3-.2.4-.2zm-5.4 1.5a.6.6 0 0 1 .4.4c0 .3 0 .5-.2.6-.3.1-.8.2-1 0a.6.6 0 0 1 0-.1c-.2-.1-.2-.2 0-.3v-.1l.2-.3a.5.5 0 0 1 .6-.2m9.2 1.2.5.1v.6h-1.2l-.1-.2c0-.2 0-.3.2-.4zm-17.1 4.8c-.1 0-.3-.1-.1-.2.1-.3.5-.4.8-.6a3.4 3.4 0 0 0 1.4-1c0-.4.4-.6.4-1l-.1-1.4a1.8 1.8 0 0 0-.8-1c-.3-.1-.7-.2-.8-.6 0-.3.3-.6.4-.9l.6-1.2c.3-.3.7 0 .8.2l.5 1c.3.3.5.6.6 1 .2.4.4.7.4 1l.2 1.3c0 .5 0 1.1-.2 1.6l-.6.8c-.3.3-.6.6-1 .7-.3.1-.5.4-.9.4H468zm-6.9.4c-.2-.2-.3-.3-.3-.6s0-.3.3-.6c.4-.4.6-.4 1.4 0 .7.4 1 .4 1 .1.1-.2.5-.5 1-.5a.8.8 0 0 1 .5.2c.2.2.3.3.3.7 0 .5 0 .5-.3.8-.3.2-.3.2-.7.2a.9.9 0 0 1-.8-.6c0-.2 0-.3-.2-.1l-.2.1c-.2 0-.6.3-.8.5l-.5.1c-.4 0-.4 0-.7-.3m-19.8-8.9c-.7 0-1.4.6-1.5 1.3.2.7.8 1.5.4 2.2.3 1-.8 1.4-1.5.9-.4-1-.6-2-1.3-3-.8-.2-1.1 1.1-1.7 1.6.3.7 1.1 1.4 1.2 2.3.2 1-.4 2-1.1 2.4-.7.7-1.7.5-2.5.6-1 .6.7.8 1.2.8 1 .1 2.1 0 3-.8.7-.3.6-1.7 1.5-1.8l4.8.3c.8.2 2.1-.1 2.7.5 0 1 1 1.8 1.9 2.2.5.2 1-.5 1.5-.6 1-.3.7-1.5 1.3-2h5c.2 0 .3-.5.6-.7l-.2-1.9c-.3-.8 0-1.8-.5-2.5-.9-.2-1.6.5-2.4.6-1 .4-1.7 1.3-1.8 2.3-.5.9-1.4-.2-1-1l-.1-1c-.5-.5-1.4-.3-2.1-.4l-3-.2c-1 0-1.9.1-2.7-.1-1 0-1-1-1-1.8a1 1 0 0 0-.7-.2m2 3.7 1 .1h1.3c1 .2 2 .2 3 .2.2 0 .4.2.6.4v2c0 .3 0 .7-.2.8a.7.7 0 0 1-.2.2 1 1 0 0 1-.7-.5v-1.4a1.3 1.3 0 0 0-.7-.3l-2.6-.1-2-.1c-.3-.1-.7 0-.9-.4-.2-.2.1-.6.4-.7a2.3 2.3 0 0 1 1-.2m11.3.3c.1 0 .2 0 .2.3l.2.5c0 .1 0 .2-.2.2-.5.2-1 .2-1.2 0 0-.1 0-.5.2-.6z"
                })
              ]
            })
          ]
        }),
        /* @__PURE__ */ jsx137("path", {
          strokeWidth: 1.1,
          d: "M450 327.2c32.6-25 29.8-61.8 29.8-61.8l-2.5.2c-6.9 0-23.2-4-27-8.9-4 4.5-20.8 9-27.6 9l-2.5-.3s-2.9 36.7 29.8 61.8z"
        }),
        /* @__PURE__ */ jsx137("path", {
          strokeWidth: 0.9,
          d: "M477.2 268h-.8c-6.2 0-20.6-3.1-26.2-7.9-5.8 4.4-20.5 8-26.6 8a4.7 4.7 0 0 1-.8-.1 73.1 73.1 0 0 0 2.6 18.7 71 71 0 0 0 24.6 37.1 71.2 71.2 0 0 0 24.6-37.2 73.1 73.1 0 0 0 2.6-18.6z"
        }),
        /* @__PURE__ */ jsx137("path", {
          fill: "#c09300",
          stroke: "none",
          d: "M439.4 265a62.2 62.2 0 0 1-16.6 3l.1 4.1a72.8 72.8 0 0 0 2.5 14.5 71 71 0 0 0 14 26.8zm20.6 0v49.2a71.1 71.1 0 0 0 14.6-27.6 73 73 0 0 0 2.5-14.5l.1-4h-.8c-3.8 0-10.4-1.2-16.4-3.2z"
        }),
        /* @__PURE__ */ jsxs112("g", {
          strokeWidth: 1.3,
          children: [
            /* @__PURE__ */ jsx137("path", {
              strokeWidth: 1.2,
              d: "M462.3 253c.7.1-.9-3.5-.9-3.5 1.8 1.8 8.4 2.3 8.4 2.3-4-1.8-8-15.1-7.5-25.8.4-10.6-1.5-14.8-3-16.4-2-2-8.5-3.8-12.7-4-2.5-.1-2 1.8-2 1.8-4.5-1.1-9-1.6-11-.2-1.8 1.2-2.2 7.5-.8 6.4 3.3-2.7 6.2-.2 8.2 2.7 1.8 2.5 1.7 9.7-.9 18.2a60 60 0 0 1-10 17.7c4 0 9.6-3.5 9.6-3.5l-1.3 5.5c4.2-2 7.5-5.1 7.5-5.1l4 4.2c1.3-1.8 4-4.2 4-4.2s3.3 3.5 8.4 4z"
            }),
            /* @__PURE__ */ jsx137("path", {
              fill: "none",
              d: "M446.1 227.6s-2.2 16.4-6.4 21m10-21.5s-1 16.7-3.8 22m6.9-21.3s0 18.2 1 21.3m3-20.4s.8 15.3 4.6 20.8"
            }),
            /* @__PURE__ */ jsx137("path", {
              fill: "#c09300",
              strokeWidth: 0.3,
              d: "M442 219.6a8 8 0 0 0-1-3.3c-2-3-4.9-5.4-8.2-2.7 0 0 1.1-3.5 3.6-3.6 1.8-.1 6.1 1.4 9.9 7.8 0 0-2.8-.6-3.5 0-1.2 1-.7 1.8-.7 1.8z"
            }),
            /* @__PURE__ */ jsx137("path", {
              fill: "#c09300",
              strokeWidth: 0.3,
              d: "M432.4 209.3c.3-1 .7-1.8 1.3-2.1 2-1.4 6.4-1 10.9.2 0 0-.4-1.9 2-1.8 4.2.2 10.6 2 12.6 4a7.9 7.9 0 0 1 1.5 2.4c-1-1.4-3.8-1.3-4.5-1.2-1 .1-1.7 0-3.1.4-.7.2-1.7.4-2.3.8-.4.4-.8 1.6-1.4 1.6-1 0-1-.2-1.3-.5-.3-.5-.5-1.1-.9-1-1 .1-2.8-.7-5-2.5-2.3-1.8-3.2-2.2-6-2-3 .2-3.8 1.9-3.8 1.9z"
            }),
            /* @__PURE__ */ jsx137("circle", {
              cx: 448.8,
              cy: 210.7,
              r: 1.2,
              stroke: "none"
            })
          ]
        })
      ]
    })
  ]
});
var Eg_default = SvgEg;

// src/country-flag-icons/generated/Eh.tsx
init_esm_shims();
import { jsx as jsx138, jsxs as jsxs113 } from "react/jsx-runtime";
var SvgEh = (props) => /* @__PURE__ */ jsxs113("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx138("defs", {
      children: /* @__PURE__ */ jsx138("clipPath", {
        id: "eh_svg__a",
        children: /* @__PURE__ */ jsx138("path", {
          fillOpacity: 0.7,
          d: "M-158.7 0H524v512h-682.7z"
        })
      })
    }),
    /* @__PURE__ */ jsxs113("g", {
      fillRule: "evenodd",
      clipPath: "url(#eh_svg__a)",
      transform: "translate(148.8) scale(.94)",
      children: [
        /* @__PURE__ */ jsx138("path", {
          fill: "#000001",
          d: "M-158.3 0h680.9v255.3h-680.9z"
        }),
        /* @__PURE__ */ jsx138("path", {
          fill: "#007a3d",
          d: "M-158.3 255.3h680.9v255.3h-680.9z"
        }),
        /* @__PURE__ */ jsx138("path", {
          fill: "#fff",
          d: "M-158.3 148.9h680.9v212.8h-680.9z"
        }),
        /* @__PURE__ */ jsx138("path", {
          fill: "#c4111b",
          d: "m-158.3 0 340.4 255.3-340.4 255.3Z"
        }),
        /* @__PURE__ */ jsx138("circle", {
          cx: 352.3,
          cy: 255.3,
          r: 68.1,
          fill: "#c4111b"
        }),
        /* @__PURE__ */ jsx138("circle", {
          cx: 377.9,
          cy: 255.3,
          r: 68.1,
          fill: "#fff"
        }),
        /* @__PURE__ */ jsx138("path", {
          fill: "#c4111b",
          d: "m334 296.5 29.1-20.7 28.8 21-10.8-34 29-20.9-35.7-.2-11-34-11.2 33.9-35.7-.2 28.7 21.2-11.1 34z"
        })
      ]
    })
  ]
});
var Eh_default = SvgEh;

// src/country-flag-icons/generated/Er.tsx
init_esm_shims();
import { jsx as jsx139, jsxs as jsxs114 } from "react/jsx-runtime";
var SvgEr = (props) => /* @__PURE__ */ jsx139("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs114("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx139("path", {
        fill: "#be0027",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsx139("path", {
        fill: "#b4d7f4",
        d: "m0 480 640-.3V240z"
      }),
      /* @__PURE__ */ jsx139("path", {
        fill: "#239e46",
        d: "m0 0 640 .3V240z"
      }),
      /* @__PURE__ */ jsx139("path", {
        fill: "#f3e295",
        d: "M186.2 360.4c-10.7 3-16.8 11.3-16.7 19.1l52.8-.2c.4-8.4-6.5-16.2-17-19.3 51.6-1 96.4-20.4 104.6-32.8-8-3.5-17.4 2.1-24 .8 15.7-7.3 63-37.9 55.3-70.7-6 18.2-24 33.3-31.8 37.4 17.7-26.8 41.8-54.8 20.9-76.4 1 12.5-8 26.3-12 27.4 10.3-28.4 20-64-2.1-87.4 2.9 8.5 1.7 32.4-2.3 33.5-1.2-19.3-4.5-59.8-24.8-59.3 6.4 5.8 9.2 21.4 9.4 37.2a57.5 57.5 0 0 0-21.1-27 118.3 118.3 0 0 0-41.5-42.2c1.8 12.7 3.3 22.7 21 35.9-9.2-.6-18.4-18.1-28.3-18.6-7.9-.4-14 7.1-26.9 2.8 1.4 4.2 7.4 6.1 8.7 9.2-2.8 2-9.3-.3-14.7-3 7.5 10 19 16 28.8 14 11.7-2.2 24.2-1 36.2 5.8a63 63 0 0 1-22.5.6c6.9 7 11.5 11.7 23.6 11.6 10.7 0 16.4-5.8 19.1-2.2 6.8 8 11.3 16 17 25.4-12.5 1.3-8.7-14.1-22.6-22-7.9 16 9 35.2 20.3 43.2a65 65 0 0 0 7.1 31.5c3.5 6.5 8 13.2 6.3 27.9-6.9-5-13.5-21.8-11-35.1-8.6 2.3-12 17.4-8 25 3 5.7 5 16.8 1.6 21.7-3.4 4.6-3.7 4-3.7 14 .1 5.8-3.2 12.8-8.5 17.7a35.5 35.5 0 0 0 1.1-15.8c-4.2 7.2-14.9 14.6-18.2 22.4-3.3 7.7-4.1 21.2-20 24.3-20.6 4-27.7 7.6-40.8 13-1.5-10 2.9-31 11.3-29.7 8.1 1.4 33-8.6 24-29.5-1.7 6.6-7.5 13-13.9 13.3 6.9-8.8 19-18 13.1-32.8a42.6 42.6 0 0 1-16.3 18c8.4-16 1-21-9-7.6-3.8 5.1-6.1 15.4-8.5 28.5-4-10.6-3.7-24.6-8.4-36-4.8-12.3 6.5-15.5 11.8-14.5 13 3.5 34.9 3.5 33.3-18.1-5.7 7.3-15.5 9.5-26.2 7 12-8.8 21.4-25.3 8-34a31 31 0 0 1-16.9 24.1 50.8 50.8 0 0 1-.3-24.8c-5.2 5.6-9 17-12.1 30.2-.3-13 2.2-22.3 4-29.3 2.8-10.1 9.6-3.5 20-2.8 10.2.6 24-5 21.4-18.7-3.4 5.5-10.5 7.6-17.7 7 8.7-5.3 23.8-14.6 15.5-29-3.5 5.4-4.6 10-14.7 11.7 2.6-6 3-14.7 11-18-14-2.9-22 6.3-26.2 20.7-1.6-10-3.6-13.6-4-21 7.6-8.3 8.4-24.8-8-28.4a35 35 0 0 0 1.2 17.4c-7.7-4.6-18.5-7.1-25.8-.7 5 5.3 12.5 10 24.2 4.2-2.8 9-10 7.5-19.8 4 6 11.3 13.6 13.3 22 12 4.4 11.6 4.6 20.4-8.3 37.2.6-10.4-.1-18.2-8.4-26.7-7.2-7-13 .3-1.8 15.8-6.8-5-14.4-15-16.7-25.1-2.2 12.4-.2 27.1 6.7 35.4-3.3 3.5-7-.4-12.5-9 2 27.4 13.7 32.7 29.4 26.6.4 15 .4 28.9 1.3 47-9.1-13.2-20.7-23-27.1-25.4-2 7.3 5.5 17 9.8 22.3-6.5-1.4-20.5-12-20.5-12-1.4 12.1 14.3 23.4 24.5 28.4-12-.5-17.3-5-25-12.4.2 33.8 36.6 27.9 43.5 22.7l3 52.5c-10.3-1.8-9.5-5-18.3-5.7-24.5-1-43.9-29.4-50.3-50.3-1.9 3.4-.4 7-2.1 11.3-4-10.3-9-23.6-15.9-29.8 1.8 6 2 12.1 1.4 23.3-2.4-7.2-4.5-9.5-4.7-18 .1-6.5 6.3-11.3 6-20.5-.3-6.7-6.4-21.3-7.3-32.5-3 11.6-4.8 23.8-9.4 31 2.3-12.4 1.6-21 5.4-29.3 4.4-8.7 8.1-16.6 5.2-25.4-2.8 3.4-1.9 6.5-9 14.8-1.5-9 9.2-23.5 19.6-29.3 7.3-3.8 16.5-17.6 10.5-27-6.9 5-10 11.6-19.7 23 7-27 25-34.2 46.5-34.3 4.7 0 14.3-1.7 17-8-6 2.3-13.2 2.6-19.6 1.4 4.7-6.9 14.4-6 23.6-6 7.1 0 18.3-1 22.8-11.2a50.8 50.8 0 0 1-31 1.9c13.7-7 35-7.8 46-17.1-12.5-9.3-43.7 2.2-63.4 15.7 5.5-5 14.2-14 19-21.2-10.8-5.2-38 25-47.4 43-9 5-12.5 13-16 18.5 4.7-16.1 5.2-27.8 9.2-41C80 138 92.6 194.6 86 208.2c.8-15 .1-34.1-6-44-9.4 7.2-10.2 49.5-1.4 84.7-3.2-9.4-9.2-18.2-11.1-29.7-14 25.4 8.2 55.5 26.7 79.2-14-7.3-27.7-22.9-36.8-36 2.5 45.6 50 55 57.4 66.2-10-4.7-29.1-13.9-37.3-4.2a99 99 0 0 1 32.3 12.1c12.4 15.4 35.7 22.2 76.4 23.9"
      })
    ]
  })
});
var Er_default = SvgEr;

// src/country-flag-icons/generated/Es.tsx
init_esm_shims();
import { jsx as jsx140, jsxs as jsxs115 } from "react/jsx-runtime";
var SvgEs = (props) => /* @__PURE__ */ jsxs115("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx140("path", {
      fill: "#AA151B",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#F1BF00",
      d: "M0 120h640v240H0z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ad1519",
      d: "m127.3 213.3-.8-.1-1-1-.7-.4-.6-.8s-.7-1.1-.4-2c.3-.9.9-1.2 1.4-1.5a12 12 0 0 1 1.5-.5l1-.4 1.3-.3.5-.3c.2 0 .7 0 1-.2l1-.2 1.6.1h4.8c.4 0 1.2.3 1.4.4a35 35 0 0 0 2 .7c.5.1 1.6.3 2.2.6.5.3.9.7 1.1 1l.5 1v1.1l-.5.8-.6 1-.8.6s-.5.5-1 .4c-.4 0-4.8-.8-7.6-.8s-7.3.9-7.3.9"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.3,
      d: "m127.3 213.3-.8-.1-1-1-.7-.4-.6-.8s-.7-1.1-.4-2c.3-.9.9-1.2 1.4-1.5a12 12 0 0 1 1.5-.5l1-.4 1.3-.3.5-.3c.2 0 .7 0 1-.2l1-.2 1.6.1h4.8c.4 0 1.2.3 1.4.4a35 35 0 0 0 2 .7c.5.1 1.6.3 2.2.6.5.3.9.7 1.1 1l.5 1v1.1l-.5.8-.6 1-.8.6s-.5.5-1 .4c-.4 0-4.8-.8-7.6-.8s-7.3.9-7.3.9z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M133.3 207c0-1.3.6-2.3 1.3-2.3.8 0 1.4 1 1.4 2.4 0 1.3-.6 2.4-1.4 2.4s-1.3-1.1-1.3-2.5"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M133.3 207c0-1.3.6-2.3 1.3-2.3.8 0 1.4 1 1.4 2.4 0 1.3-.6 2.4-1.4 2.4s-1.3-1.1-1.3-2.5z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M134 207c0-1.2.3-2.1.7-2.1.3 0 .6 1 .6 2.1 0 1.3-.3 2.2-.6 2.2-.4 0-.6-1-.6-2.2"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M134 207c0-1.2.3-2.1.7-2.1.3 0 .6 1 .6 2.1 0 1.3-.3 2.2-.6 2.2-.4 0-.6-1-.6-2.2z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M133.8 204.5c0-.4.4-.8.8-.8s1 .4 1 .8c0 .5-.5.9-1 .9s-.8-.4-.8-.9"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M135.3 204.2v.6h-1.4v-.6h.5V203h-.7v-.6h.7v-.5h.5v.5h.6v.6h-.6v1.2z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M135.3 204.2v.6h-1.4v-.6h.5V203h-.7v-.6h.7v-.5h.5v.5h.6v.6h-.6v1.2h.4"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M135.9 204.2v.6h-2.5v-.6h1V203h-.7v-.6h.7v-.5h.5v.5h.6v.6h-.6v1.2z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M135.9 204.2v.6h-2.5v-.6h1V203h-.7v-.6h.7v-.5h.5v.5h.6v.6h-.6v1.2h1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M134.9 203.7c.4.1.6.4.6.8 0 .5-.4.9-.8.9s-1-.4-1-.9c0-.4.3-.7.7-.8"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M134.7 213.2H130v-1.1l-.3-1.2-.2-1.5c-1.3-1.7-2.5-2.8-2.9-2.5.1-.3.2-.6.5-.7 1.1-.7 3.5 1 5.2 3.6l.5.7h3.8l.4-.7c1.8-2.7 4.1-4.3 5.2-3.6.3.1.4.4.5.7-.4-.3-1.6.8-2.9 2.5l-.2 1.5-.2 1.2-.1 1.1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M134.7 213.2H130v-1.1l-.3-1.2-.2-1.5c-1.3-1.7-2.5-2.8-2.9-2.5.1-.3.2-.6.5-.7 1.1-.7 3.5 1 5.2 3.6l.5.7h3.8l.4-.7c1.8-2.7 4.1-4.3 5.2-3.6.3.1.4.4.5.7-.4-.3-1.6.8-2.9 2.5l-.2 1.5-.2 1.2-.1 1.1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M126.8 206.8c1-.5 3 1.1 4.6 3.6m11-3.6c-.8-.5-2.8 1.1-4.5 3.6"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m127.8 215.3-.5-1a27.3 27.3 0 0 1 14.7 0l-.5.8a5.7 5.7 0 0 0-.3.8 22.9 22.9 0 0 0-6.6-.8c-2.6 0-5.2.3-6.5.8z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m127.8 215.3-.5-1a27.3 27.3 0 0 1 14.7 0l-.5.8a5.7 5.7 0 0 0-.3.8 22.9 22.9 0 0 0-6.6-.8c-2.6 0-5.2.3-6.5.8l-.3-.6"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M134.6 217.7c2.4 0 5-.4 5.9-.6.6-.2 1-.5 1-.8 0-.2-.2-.3-.4-.4-1.4-.5-4-.8-6.5-.8s-5 .3-6.4.8c-.2 0-.3.2-.4.3 0 .4.3.7 1 .9 1 .2 3.5.6 5.8.6"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M134.6 217.7c2.4 0 5-.4 5.9-.6.6-.2 1-.5 1-.8 0-.2-.2-.3-.4-.4-1.4-.5-4-.8-6.5-.8s-5 .3-6.4.8c-.2 0-.3.2-.4.3 0 .4.3.7 1 .9 1 .2 3.5.6 5.8.6z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m142.1 213.2-.5-.5s-.6.3-1.3.2c-.6 0-.9-1-.9-1s-.7.7-1.3.7c-.7 0-1-.6-1-.6s-.7.5-1.3.4c-.6 0-1.2-.8-1.2-.8s-.6.8-1.2.8c-.6.1-1-.5-1-.5s-.4.6-1.1.7-1.4-.6-1.4-.6-.5.7-1 1c-.5 0-1.2-.4-1.2-.4l-.2.5-.3.1.2.5a27 27 0 0 1 7.2-.9c3 0 5.5.4 7.4 1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m142.1 213.2-.5-.5s-.6.3-1.3.2c-.6 0-.9-1-.9-1s-.7.7-1.3.7c-.7 0-1-.6-1-.6s-.7.5-1.3.4c-.6 0-1.2-.8-1.2-.8s-.6.8-1.2.8c-.6.1-1-.5-1-.5s-.4.6-1.1.7-1.4-.6-1.4-.6-.5.7-1 1c-.5 0-1.2-.4-1.2-.4l-.2.5-.3.1.2.5a27 27 0 0 1 7.2-.9c3 0 5.5.4 7.4 1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M134.7 210.7h.2a1 1 0 0 0 0 .4c0 .6.4 1 1 1a1 1 0 0 0 1-.7l.2-.3v.4c.1.5.6.8 1.1.8.6 0 1-.4 1-1v-.1l.4-.4.2.5a.9.9 0 0 0-.1.4 1 1 0 0 0 1 1c.4 0 .7-.2.9-.5l.2-.2v.3c0 .3.1.6.4.7 0 0 .4 0 1-.4l.7-.7v.4s-.5.8-1 1c-.2.2-.5.4-.8.3-.3 0-.6-.3-.7-.6-.2.2-.4.2-.7.2-.6 0-1.2-.3-1.4-.8-.3.3-.7.5-1.1.5a1.6 1.6 0 0 1-1.2-.6 1.6 1.6 0 0 1-1 .4 1.6 1.6 0 0 1-1.3-.6 1.6 1.6 0 0 1-2.4.2 1.6 1.6 0 0 1-1.2.6 1.5 1.5 0 0 1-1.1-.5c-.2.5-.8.8-1.4.8-.2 0-.5 0-.7-.2-.1.3-.4.6-.7.6-.3 0-.6 0-.9-.2l-1-1 .1-.5.8.7c.5.4.9.4.9.4.3 0 .4-.4.4-.7v-.3l.2.2c.2.3.5.5.9.5a1 1 0 0 0 1-1 .9.9 0 0 0 0-.4v-.5l.4.4a.7.7 0 0 0 0 .1c0 .6.5 1 1 1 .6 0 1-.3 1.1-.9v-.3l.2.3c.2.4.6.7 1 .7.7 0 1.1-.4 1.1-1a1 1 0 0 0 0-.3h.3"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M134.7 210.7h.2a1 1 0 0 0 0 .4c0 .6.4 1 1 1a1 1 0 0 0 1-.7l.2-.3v.4c.1.5.6.8 1.1.8.6 0 1-.4 1-1v-.1l.4-.4.2.5a.9.9 0 0 0-.1.4 1 1 0 0 0 1 1c.4 0 .7-.2.9-.5l.2-.2v.3c0 .3.1.6.4.7 0 0 .4 0 1-.4l.7-.7v.4s-.5.8-1 1c-.2.2-.5.4-.8.3-.3 0-.6-.3-.7-.6-.2.2-.4.2-.7.2-.6 0-1.2-.3-1.4-.8-.3.3-.7.5-1.1.5a1.6 1.6 0 0 1-1.2-.6 1.6 1.6 0 0 1-1 .4 1.6 1.6 0 0 1-1.3-.6 1.6 1.6 0 0 1-2.4.2 1.6 1.6 0 0 1-1.2.6 1.5 1.5 0 0 1-1.1-.5c-.2.5-.8.8-1.4.8-.2 0-.5 0-.7-.2-.1.3-.4.6-.7.6-.3 0-.6 0-.9-.2l-1-1 .1-.5.8.7c.5.4.9.4.9.4.3 0 .4-.4.4-.7v-.3l.2.2c.2.3.5.5.9.5a1 1 0 0 0 1-1 .9.9 0 0 0 0-.4v-.5l.4.4a.7.7 0 0 0 0 .1c0 .6.5 1 1 1 .6 0 1-.3 1.1-.9v-.3l.2.3c.2.4.6.7 1 .7.7 0 1.1-.4 1.1-1a1 1 0 0 0 0-.3h.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M134.6 213.3c-2.9 0-5.5.4-7.3 1l-.3-.2.1-.3a27 27 0 0 1 7.5-1c3 0 5.7.4 7.6 1 0 0 .2.2.1.3l-.3.2a27.3 27.3 0 0 0-7.4-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.3,
      d: "M134.6 213.3c-2.9 0-5.5.4-7.3 1l-.3-.2.1-.3a27 27 0 0 1 7.5-1c3 0 5.7.4 7.6 1 0 0 .2.2.1.3l-.3.2a27.3 27.3 0 0 0-7.4-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M131.8 214.4c0-.3.2-.4.5-.4a.4.4 0 0 1 .4.4c0 .2-.2.4-.4.4a.4.4 0 0 1-.5-.4"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M131.8 214.4c0-.3.2-.4.5-.4a.4.4 0 0 1 .4.4c0 .2-.2.4-.4.4a.4.4 0 0 1-.5-.4z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ad1519",
      d: "M134.7 214.5h-1c-.1 0-.3 0-.3-.3l.3-.3h2a.3.3 0 0 1 .2.3.3.3 0 0 1-.3.3h-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M134.7 214.5h-1c-.1 0-.3 0-.3-.3l.3-.3h2a.3.3 0 0 1 .2.3.3.3 0 0 1-.3.3h-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#058e6e",
      d: "M130 214.9h-.7c-.1 0-.3 0-.3-.2a.3.3 0 0 1 .2-.3l.7-.1.7-.1c.2 0 .3 0 .4.2a.3.3 0 0 1-.3.4z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M130 214.9h-.7c-.1 0-.3 0-.3-.2a.3.3 0 0 1 .2-.3l.7-.1.7-.1c.2 0 .3 0 .4.2a.3.3 0 0 1-.3.4h-.7"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ad1519",
      d: "m127.3 215.3.3-.4h.7l-.4.6z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m127.3 215.3.3-.4h.7l-.4.6-.6-.2"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M136.6 214.4c0-.3.2-.4.4-.4a.4.4 0 0 1 .5.4.4.4 0 0 1-.5.4.4.4 0 0 1-.4-.4"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M136.6 214.4c0-.3.2-.4.4-.4a.4.4 0 0 1 .5.4.4.4 0 0 1-.5.4.4.4 0 0 1-.4-.4z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#058e6e",
      d: "M139.3 214.9h.6a.3.3 0 0 0 .4-.2.3.3 0 0 0-.3-.3l-.6-.1-.7-.1c-.2 0-.3 0-.4.2 0 .2.1.3.3.4z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M139.3 214.9h.6a.3.3 0 0 0 .4-.2.3.3 0 0 0-.3-.3l-.6-.1-.7-.1c-.2 0-.3 0-.4.2 0 .2.1.3.3.4h.7"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ad1519",
      d: "m142 215.4-.3-.5h-.7l.3.6z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m142 215.4-.3-.5h-.7l.3.6.6-.1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ad1519",
      d: "M134.6 217.1a25 25 0 0 1-6-.6 25.5 25.5 0 0 1 12.1 0c-1.6.4-3.7.6-6 .6"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.3,
      d: "M134.6 217.1a25 25 0 0 1-6-.6 25.5 25.5 0 0 1 12.1 0c-1.6.4-3.7.6-6 .6z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m142 212-.1-.3c-.2 0-.3 0-.4.2 0 .2 0 .4.2.4 0 0 .2 0 .3-.3"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m142 212-.1-.3c-.2 0-.3 0-.4.2 0 .2 0 .4.2.4 0 0 .2 0 .3-.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M137.3 211.2c0-.2 0-.4-.2-.4 0 0-.2.1-.2.3 0 .2 0 .4.2.4l.3-.3"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M137.3 211.2c0-.2 0-.4-.2-.4 0 0-.2.1-.2.3 0 .2 0 .4.2.4l.3-.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m132 211.2.1-.4c.2 0 .3.1.3.3 0 .2 0 .4-.2.4z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m132 211.2.1-.4c.2 0 .3.1.3.3 0 .2 0 .4-.2.4z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m127.3 212 .1-.3c.2 0 .3 0 .4.2 0 .2 0 .4-.2.4 0 0-.2 0-.3-.3"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m127.3 212 .1-.3c.2 0 .3 0 .4.2 0 .2 0 .4-.2.4 0 0-.2 0-.3-.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m134.6 208.5-.8.5.6 1.3.2.1.2-.1.7-1.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m134.6 208.5-.8.5.6 1.3.2.1.2-.1.7-1.3-.9-.5"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m132.8 210.5.4.5 1.3-.4.1-.2-.1-.2-1.3-.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m132.8 210.5.4.5 1.3-.4.1-.2-.1-.2-1.3-.3-.4.6"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m136.4 210.5-.3.5-1.3-.4-.2-.2.2-.2 1.3-.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m136.4 210.5-.3.5-1.3-.4-.2-.2.2-.2 1.3-.3.3.6"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m129.3 209-.7.7.9 1 .2.1.1-.1.3-1.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m129.3 209-.7.7.9 1 .2.1.1-.1.3-1.3-.8-.3"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m128 211.2.4.5 1.2-.6v-.2l-.1-.2-1.3-.1-.3.6"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m128 211.2.4.5 1.2-.6v-.2l-.1-.2-1.3-.1-.3.6"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m131.5 210.5-.3.6H130l-.2-.2.1-.3 1.2-.6z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m131.5 210.5-.3.6H130l-.2-.2.1-.3 1.2-.6.5.5"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M126.6 211.4v.6l-1.4.2-.2-.1v-.2l1-.9z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M126.6 211.4v.6l-1.4.2-.2-.1v-.2l1-.9.6.4"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M129.2 210.9c0-.3.2-.5.5-.5s.5.2.5.5a.5.5 0 0 1-.5.4.5.5 0 0 1-.5-.4"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M129.2 210.9c0-.3.2-.5.5-.5s.5.2.5.5a.5.5 0 0 1-.5.4.5.5 0 0 1-.5-.4z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m140 209 .7.7-.9 1-.2.1-.1-.1-.3-1.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m140 209 .7.7-.9 1-.2.1-.1-.1-.3-1.3.8-.3"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m141.4 211.2-.5.5-1.2-.6v-.2l.1-.2 1.3-.1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m141.4 211.2-.5.5-1.2-.6v-.2l.1-.2 1.3-.1.3.6"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m137.8 210.5.3.6h1.3l.2-.2-.1-.3-1.2-.6z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m137.8 210.5.3.6h1.3l.2-.2-.1-.3-1.2-.6-.5.5"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m142.5 211.4.1.6 1.3.2.2-.1v-.2l-1-.9z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m142.5 211.4.1.6 1.3.2.2-.1v-.2l-1-.9-.6.4"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M134.2 210.4a.5.5 0 0 1 .4-.4c.3 0 .5.2.5.4a.5.5 0 0 1-.5.5.5.5 0 0 1-.4-.5"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M134.2 210.4a.5.5 0 0 1 .4-.4c.3 0 .5.2.5.4a.5.5 0 0 1-.5.5.5.5 0 0 1-.4-.5z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M139.1 210.9c0-.3.3-.5.5-.5a.5.5 0 0 1 .5.5.5.5 0 0 1-.5.4.5.5 0 0 1-.5-.4"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M139.1 210.9c0-.3.3-.5.5-.5a.5.5 0 0 1 .5.5.5.5 0 0 1-.5.4.5.5 0 0 1-.5-.4z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m124.8 212.2-.6-.7c-.2-.2-.7-.3-.7-.3 0-.1.3-.3.6-.3a.5.5 0 0 1 .4.2v-.2s.3 0 .4.3v1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m124.8 212.2-.6-.7c-.2-.2-.7-.3-.7-.3 0-.1.3-.3.6-.3a.5.5 0 0 1 .4.2v-.2s.3 0 .4.3v1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M124.8 212c.1-.2.4-.2.5 0 .2.1.3.3.2.5l-.5-.1c-.2-.1-.3-.4-.2-.5"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M124.8 212c.1-.2.4-.2.5 0 .2.1.3.3.2.5l-.5-.1c-.2-.1-.3-.4-.2-.5z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m144.3 212.2.6-.7c.2-.2.7-.3.7-.3 0-.1-.3-.3-.6-.3a.6.6 0 0 0-.4.2v-.2s-.3 0-.4.3v.7z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m144.3 212.2.6-.7c.2-.2.7-.3.7-.3 0-.1-.3-.3-.6-.3a.6.6 0 0 0-.4.2v-.2s-.3 0-.4.3v.7z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M144.3 212c0-.2-.3-.2-.5 0-.2.1-.2.3-.1.5l.5-.1c.2-.1.2-.4.1-.5"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M144.3 212c0-.2-.3-.2-.5 0-.2.1-.2.3-.1.5l.5-.1c.2-.1.2-.4.1-.5z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M124 223h21.4v-5.5H124z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M124 223h21.4v-5.5H124z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M126.2 226.8a1 1 0 0 1 .4 0h16.5a1.4 1.4 0 0 1-1-1.2c0-.6.5-1.1 1-1.3a1.7 1.7 0 0 1-.4 0h-16a1.4 1.4 0 0 1-.5 0c.6.2 1 .7 1 1.3a1.3 1.3 0 0 1-1 1.2"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.4,
      d: "M126.2 226.8a1 1 0 0 1 .4 0h16.5a1.4 1.4 0 0 1-1-1.2c0-.6.5-1.1 1-1.3a1.7 1.7 0 0 1-.4 0h-16a1.4 1.4 0 0 1-.5 0c.6.2 1 .7 1 1.3a1.3 1.3 0 0 1-1 1.2z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M126.6 226.8h16c.6 0 1 .3 1 .7 0 .4-.4.8-1 .8h-16c-.5 0-1-.4-1-.8s.5-.8 1-.8"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M126.6 226.8h16c.6 0 1 .3 1 .7 0 .4-.4.8-1 .8h-16c-.5 0-1-.4-1-.8s.5-.8 1-.8z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M126.6 223h16c.6 0 1 .4 1 .7 0 .4-.4.6-1 .6h-16c-.5 0-1-.2-1-.6 0-.3.5-.6 1-.6"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M126.6 223h16c.6 0 1 .4 1 .7 0 .4-.4.6-1 .6h-16c-.5 0-1-.2-1-.6 0-.3.5-.6 1-.6z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#005bbf",
      d: "M149.6 317.4c-1.4 0-2.8-.3-3.7-.8a8.4 8.4 0 0 0-3.8-.8c-1.4 0-2.7.3-3.7.8a8.3 8.3 0 0 1-3.8.8c-1.5 0-2.8-.3-3.7-.8a8.4 8.4 0 0 0-3.7-.8 8 8 0 0 0-3.7.8 8.3 8.3 0 0 1-3.8.8v2.4c1.5 0 2.8-.4 3.8-.9a8.2 8.2 0 0 1 3.7-.8c1.4 0 2.7.3 3.7.8s2.2.9 3.7.9a8.4 8.4 0 0 0 3.8-.9c1-.5 2.3-.8 3.7-.8 1.5 0 2.8.3 3.8.8s2.2.9 3.7.9z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M149.6 317.4c-1.4 0-2.8-.3-3.7-.8a8.4 8.4 0 0 0-3.8-.8c-1.4 0-2.7.3-3.7.8a8.3 8.3 0 0 1-3.8.8c-1.5 0-2.8-.3-3.7-.8a8.4 8.4 0 0 0-3.7-.8 8 8 0 0 0-3.7.8 8.3 8.3 0 0 1-3.8.8v2.4c1.5 0 2.8-.4 3.8-.9a8.2 8.2 0 0 1 3.7-.8c1.4 0 2.7.3 3.7.8s2.2.9 3.7.9a8.4 8.4 0 0 0 3.8-.9c1-.5 2.3-.8 3.7-.8 1.5 0 2.8.3 3.8.8s2.2.9 3.7.9z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ccc",
      d: "M149.6 319.8a8 8 0 0 1-3.7-.9 8.3 8.3 0 0 0-3.8-.8c-1.4 0-2.7.3-3.7.8s-2.3.9-3.8.9-2.8-.4-3.7-.9a8.4 8.4 0 0 0-3.7-.8 8.2 8.2 0 0 0-3.7.8c-1 .5-2.3.9-3.8.9v2.3c1.5 0 2.8-.4 3.8-.9a8.1 8.1 0 0 1 3.7-.7c1.4 0 2.7.2 3.7.7a8.3 8.3 0 0 0 7.5 0 8.5 8.5 0 0 1 7.5.1 8.1 8.1 0 0 0 3.7.8z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M149.6 319.8a8 8 0 0 1-3.7-.9 8.3 8.3 0 0 0-3.8-.8c-1.4 0-2.7.3-3.7.8s-2.3.9-3.8.9-2.8-.4-3.7-.9a8.4 8.4 0 0 0-3.7-.8 8.2 8.2 0 0 0-3.7.8c-1 .5-2.3.9-3.8.9v2.3c1.5 0 2.8-.4 3.8-.9a8.1 8.1 0 0 1 3.7-.7c1.4 0 2.7.2 3.7.7a8.3 8.3 0 0 0 7.5 0 8.5 8.5 0 0 1 7.5.1 8.1 8.1 0 0 0 3.7.8v-2.3"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#005bbf",
      d: "M149.6 322a7 7 0 0 1-3.7-.8 8.3 8.3 0 0 0-3.8-.7c-1.4 0-2.7.2-3.7.7-1 .6-2.3.9-3.8.9s-2.8-.4-3.7-.9a8.4 8.4 0 0 0-3.7-.8 8 8 0 0 0-3.7.8c-1 .5-2.3.9-3.8.9v2.3c1.5 0 2.8-.3 3.8-.9a10.2 10.2 0 0 1 7.4 0 7 7 0 0 0 3.7.9 8.4 8.4 0 0 0 3.8-.8c1-.5 2.3-.8 3.7-.8 1.5 0 2.8.3 3.8.8s2.2.8 3.7.8z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M149.6 322a7 7 0 0 1-3.7-.8 8.3 8.3 0 0 0-3.8-.7c-1.4 0-2.7.2-3.7.7-1 .6-2.3.9-3.8.9s-2.8-.4-3.7-.9a8.4 8.4 0 0 0-3.7-.8 8 8 0 0 0-3.7.8c-1 .5-2.3.9-3.8.9v2.3c1.5 0 2.8-.3 3.8-.9a10.2 10.2 0 0 1 7.4 0 7 7 0 0 0 3.7.9 8.4 8.4 0 0 0 3.8-.8c1-.5 2.3-.8 3.7-.8 1.5 0 2.8.3 3.8.8s2.2.8 3.7.8V322"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ccc",
      d: "M149.6 326.7a8 8 0 0 1-3.7-.8c-1-.5-2.3-.8-3.7-.8a8.4 8.4 0 0 0-3.8.8c-1 .5-2.3.8-3.8.8a7 7 0 0 1-3.7-.9 8.4 8.4 0 0 0-3.7-.7c-1.4 0-2.7.3-3.7.8s-2.3.8-3.8.8v-2.3a8.3 8.3 0 0 0 3.8-.9 10.2 10.2 0 0 1 7.4 0 8 8 0 0 0 3.7.9 8.4 8.4 0 0 0 3.8-.8c1-.5 2.3-.8 3.8-.8 1.4 0 2.7.3 3.7.8s2.3.8 3.7.8z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M149.6 326.7a8 8 0 0 1-3.7-.8c-1-.5-2.3-.8-3.7-.8a8.4 8.4 0 0 0-3.8.8c-1 .5-2.3.8-3.8.8a7 7 0 0 1-3.7-.9 8.4 8.4 0 0 0-3.7-.7c-1.4 0-2.7.3-3.7.8s-2.3.8-3.8.8v-2.3a8.3 8.3 0 0 0 3.8-.9 10.2 10.2 0 0 1 7.4 0 8 8 0 0 0 3.7.9 8.4 8.4 0 0 0 3.8-.8c1-.5 2.3-.8 3.8-.8 1.4 0 2.7.3 3.7.8s2.3.8 3.7.8v2.3"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#005bbf",
      d: "M149.6 329a8.1 8.1 0 0 1-3.7-.8c-1-.5-2.3-.8-3.7-.8a8.4 8.4 0 0 0-3.8.8c-1 .5-2.3.8-3.8.8a7 7 0 0 1-3.7-.9 8.4 8.4 0 0 0-3.7-.7c-1.4 0-2.7.3-3.7.8s-2.3.8-3.8.8v-2.3a8.3 8.3 0 0 0 3.8-.8c1-.5 2.3-.8 3.7-.8 1.4 0 2.7.3 3.7.7a8.4 8.4 0 0 0 7.5 0c1-.4 2.3-.7 3.8-.7 1.4 0 2.7.3 3.7.8s2.2.8 3.7.8z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M149.6 329a8.1 8.1 0 0 1-3.7-.8c-1-.5-2.3-.8-3.7-.8a8.4 8.4 0 0 0-3.8.8c-1 .5-2.3.8-3.8.8a7 7 0 0 1-3.7-.9 8.4 8.4 0 0 0-3.7-.7c-1.4 0-2.7.3-3.7.8s-2.3.8-3.8.8v-2.3a8.3 8.3 0 0 0 3.8-.8c1-.5 2.3-.8 3.7-.8 1.4 0 2.7.3 3.7.7a8.4 8.4 0 0 0 7.5 0c1-.4 2.3-.7 3.8-.7 1.4 0 2.7.3 3.7.8s2.2.8 3.7.8z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m126.2 308 .2.5c0 1.5-1.3 2.6-2.7 2.6h22a2.7 2.7 0 0 1-2.7-2.6v-.5a1.3 1.3 0 0 1-.3 0h-16a1.4 1.4 0 0 1-.5 0"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.4,
      d: "m126.2 308 .2.5c0 1.5-1.3 2.6-2.7 2.6h22a2.7 2.7 0 0 1-2.7-2.6v-.5a1.3 1.3 0 0 1-.3 0h-16a1.4 1.4 0 0 1-.5 0z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M126.6 306.5h16c.6 0 1 .3 1 .8 0 .4-.4.7-1 .7h-16c-.5 0-1-.3-1-.8 0-.4.5-.7 1-.7"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M126.6 306.5h16c.6 0 1 .3 1 .8 0 .4-.4.7-1 .7h-16c-.5 0-1-.3-1-.8 0-.4.5-.7 1-.7z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M123.7 316.7h22V311h-22z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M123.7 316.7h22V311h-22z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ad1519",
      d: "M122 286.7c-2.2 1.2-3.7 2.5-3.4 3.2 0 .6.8 1 1.8 1.6 1.5 1.1 2.5 3 1.7 4a5.5 5.5 0 0 0-.1-8.8"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M122 286.7c-2.2 1.2-3.7 2.5-3.4 3.2 0 .6.8 1 1.8 1.6 1.5 1.1 2.5 3 1.7 4a5.5 5.5 0 0 0-.1-8.8z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ccc",
      d: "M126.8 305.6h15.6V229h-15.6v76.5z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M138 229.2v76.3m1.7-76.3v76.3m-12.9 0h15.6v-76.4h-15.6v76.5z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ad1519",
      d: "M158.4 257.7a49.6 49.6 0 0 0-23.3-2c-9.4 1.6-16.5 5.3-15.9 8.4v.2l-3.5-8.2c-.6-3.3 7.2-7.5 17.6-9.2a43 43 0 0 1 9.2-.7c6.6 0 12.4.8 15.8 2.1v9.4"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.4,
      d: "M158.4 257.7a49.6 49.6 0 0 0-23.3-2c-9.4 1.6-16.5 5.3-15.9 8.4v.2l-3.5-8.2c-.6-3.3 7.2-7.5 17.6-9.2a43 43 0 0 1 9.2-.7c6.6 0 12.4.8 15.8 2.1v9.4"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ad1519",
      d: "M126.8 267.3c-4.3-.3-7.3-1.4-7.6-3.2-.3-1.5 1.2-3 3.8-4.5 1.2.1 2.5.3 3.8.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M126.8 267.3c-4.3-.3-7.3-1.4-7.6-3.2-.3-1.5 1.2-3 3.8-4.5 1.2.1 2.5.3 3.8.3v7.4"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ad1519",
      d: "M142.5 261.5c2.7.4 4.7 1 5.7 1.9l.1.2c.5 1-1.9 3-5.9 5.4v-7.5"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M142.5 261.5c2.7.4 4.7 1 5.7 1.9l.1.2c.5 1-1.9 3-5.9 5.4v-7.5"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ad1519",
      d: "M117.1 282c-.4-1.2 3.8-3.6 9.8-5.8l7.8-3.2c8.3-3.7 14.4-7.9 13.6-9.4v-.2c.4.4 1 8 1 8 .8 1.3-4.8 5.5-12.4 9.1-2.5 1.2-7.6 3-10 4-4.4 1.4-8.7 4.3-8.3 5.3l-1.5-7.7"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.4,
      d: "M117.1 282c-.4-1.2 3.8-3.6 9.8-5.8l7.8-3.2c8.3-3.7 14.4-7.9 13.6-9.4v-.2c.4.4 1 8 1 8 .8 1.3-4.8 5.5-12.4 9.1-2.5 1.2-7.6 3-10 4-4.4 1.4-8.7 4.3-8.3 5.3l-1.5-7.7z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M125.8 254c1.9-.6 3.1-1.5 2.5-3-.4-1-1.4-1-2.8-.6l-2.6 1 2.3 5.8.8-.3.8-.3zm-1.2-2.7.7-.3c.5-.2 1.2.1 1.4.8.2.5.2 1-.5 1.5a4.4 4.4 0 0 1-.6.3zm7.3-2.5-.9.3h-.8l1.3 6.1 4.3-.8-.2-.4v-.4l-2.5.6zm8.4 5.2c.8-2.2 1.7-4.3 2.7-6.4a5.3 5.3 0 0 1-1 0 54.8 54.8 0 0 1-1.8 4.6l-2.4-4.3-1 .1h-1a131.4 131.4 0 0 1 3.5 6zm8.8-4.7.4-.9a3.4 3.4 0 0 0-1.7-.6c-1.7-.1-2.7.6-2.8 1.7-.2 2.1 3.2 2 3 3.4 0 .6-.7.9-1.4.8-.8 0-1.4-.5-1.4-1.2h-.3a7.3 7.3 0 0 1-.4 1.1 4 4 0 0 0 1.8.6c1.7.2 3-.5 3.2-1.7.2-2-3.3-2.1-3.1-3.4 0-.5.4-.8 1.3-.7.7 0 1 .4 1.2.9z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ad1519",
      d: "M277.9 211.6s-.7.8-1.3.9c-.5 0-1.1-.5-1.1-.5s-.5.5-1 .6c-.6.1-1.4-.6-1.4-.6l-1 1c-.6 0-1.1-.3-1.1-.3s-.3.4-.7.6h-.4l-.6-.4-.7-.7-.5-.3-.4-1v-.5c-.1-.6.8-1.4 2.2-1.7a3.9 3.9 0 0 1 2 0c.5-.5 1.7-.8 3-.8s2.4.3 3 .7a5.5 5.5 0 0 1 2.9-.7c1.3 0 2.5.3 3 .8.5-.2 1.2-.2 2 0 1.4.3 2.3 1 2.2 1.7v.5l-.4 1-.6.3-.6.7-.6.3s-.3.2-.4 0c-.4-.1-.7-.5-.7-.5s-.6.4-1 .2c-.5-.2-1-1-1-1s-.9.8-1.4.7c-.6-.1-1-.6-1-.6s-.7.6-1.2.5c-.5-.1-1.2-.9-1.2-.9"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M277.9 211.6s-.7.8-1.3.9c-.5 0-1.1-.5-1.1-.5s-.5.5-1 .6c-.6.1-1.4-.6-1.4-.6l-1 1c-.6 0-1.1-.3-1.1-.3s-.3.4-.7.6h-.4l-.6-.4-.7-.7-.5-.3-.4-1v-.5c-.1-.6.8-1.4 2.2-1.7a3.9 3.9 0 0 1 2 0c.5-.5 1.7-.8 3-.8s2.4.3 3 .7a5.5 5.5 0 0 1 2.9-.7c1.3 0 2.5.3 3 .8.5-.2 1.2-.2 2 0 1.4.3 2.3 1 2.2 1.7v.5l-.4 1-.6.3-.6.7-.6.3s-.3.2-.4 0c-.4-.1-.7-.5-.7-.5s-.6.4-1 .2c-.5-.2-1-1-1-1s-.9.8-1.4.7c-.6-.1-1-.6-1-.6s-.7.6-1.2.5c-.5-.1-1.2-.9-1.2-.9z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M276.5 207.6c0-1 .6-2 1.3-2 .8 0 1.3 1 1.3 2s-.5 1.8-1.3 1.8c-.7 0-1.3-.8-1.3-1.9"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M276.5 207.6c0-1 .6-2 1.3-2 .8 0 1.3 1 1.3 2s-.5 1.8-1.3 1.8c-.7 0-1.3-.8-1.3-1.9z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M277.3 207.6c0-1 .2-1.8.5-1.8.4 0 .7.8.7 1.8s-.3 1.7-.6 1.7c-.4 0-.6-.8-.6-1.8"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M277.3 207.6c0-1 .2-1.8.5-1.8.4 0 .7.8.7 1.8s-.3 1.7-.6 1.7c-.4 0-.6-.8-.6-1.8z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M271 215.3a4.5 4.5 0 0 0-.5-1 27.4 27.4 0 0 1 14.8 0l-.6.8a5.2 5.2 0 0 0-.3.8 22.9 22.9 0 0 0-6.6-.8c-2.6 0-5.2.3-6.6.8z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M271 215.3a4.5 4.5 0 0 0-.5-1 27.4 27.4 0 0 1 14.8 0l-.6.8a5.2 5.2 0 0 0-.3.8 22.9 22.9 0 0 0-6.6-.8c-2.6 0-5.2.3-6.6.8l-.2-.6"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M277.8 217.7c2.4 0 5-.4 5.9-.6.6-.2 1-.5 1-.8 0-.2-.2-.3-.4-.4a24.1 24.1 0 0 0-6.5-.8c-2.5 0-5 .3-6.4.8-.2 0-.3.2-.4.3 0 .4.3.7 1 .9 1 .2 3.5.6 5.8.6"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M277.8 217.7c2.4 0 5-.4 5.9-.6.6-.2 1-.5 1-.8 0-.2-.2-.3-.4-.4a24.1 24.1 0 0 0-6.5-.8c-2.5 0-5 .3-6.4.8-.2 0-.3.2-.4.3 0 .4.3.7 1 .9 1 .2 3.5.6 5.8.6z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M283.5 208.4c0-.2.2-.4.4-.4s.5.2.5.4-.2.4-.5.4a.4.4 0 0 1-.4-.4"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.2,
      d: "M283.5 208.4c0-.2.2-.4.4-.4s.5.2.5.4-.2.4-.5.4a.4.4 0 0 1-.4-.4zm-.2-1.4a.4.4 0 0 1 .4-.4c.2 0 .4.1.4.4s-.2.4-.4.4a.4.4 0 0 1-.4-.4zm-1.1-1c0-.2.2-.3.4-.3s.4.1.4.4c0 .2-.2.4-.4.4a.4.4 0 0 1-.4-.5zm-1.4-.4c0-.2.2-.4.4-.4.3 0 .5.2.5.4s-.2.4-.4.4-.5-.2-.5-.4zm-1.4 0c0-.2.2-.3.5-.3s.4.1.4.4c0 .2-.2.4-.4.4a.4.4 0 0 1-.5-.4z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: 0.3,
      d: "m287.8 211.2.2-1a2.7 2.7 0 0 0-2.7-2.8c-.5 0-1 .1-1.3.3"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m283 209.2.2-.8c0-1.1-1.1-2-2.5-2-.6 0-1.2.2-1.6.4"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.2,
      d: "M288.2 210c0-.3.2-.5.4-.5s.4.2.4.4c0 .3-.2.4-.4.4s-.4-.1-.4-.4zm-.2-1.6c0-.2.2-.4.4-.4a.4.4 0 0 1 .5.4c0 .2-.2.4-.4.4-.3 0-.5-.2-.5-.4zm-1-1.1a.4.4 0 0 1 .5-.4c.2 0 .4.1.4.4a.4.4 0 0 1-.4.4.4.4 0 0 1-.5-.4zm-1.3-.7c0-.2.2-.4.5-.4s.4.2.4.4c0 .3-.2.5-.4.5a.4.4 0 0 1-.5-.5zm-1.4.1c0-.2.2-.4.5-.4s.4.2.4.4-.2.4-.4.4-.5-.2-.5-.4z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m285.3 213.2-.5-.5s-.6.3-1.3.2c-.6 0-.9-1-.9-1s-.7.7-1.3.7c-.7 0-1-.6-1-.6s-.7.5-1.3.4c-.6 0-1.2-.8-1.2-.8s-.6.8-1.2.8c-.6.1-1-.5-1-.5s-.3.6-1.1.7-1.4-.6-1.4-.6-.4.7-1 1c-.5 0-1.2-.4-1.2-.4l-.1.5-.3.1.1.5a27 27 0 0 1 7.3-.9c2.8 0 5.4.4 7.3 1l.2-.6"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m285.3 213.2-.5-.5s-.6.3-1.3.2c-.6 0-.9-1-.9-1s-.7.7-1.3.7c-.7 0-1-.6-1-.6s-.7.5-1.3.4c-.6 0-1.2-.8-1.2-.8s-.6.8-1.2.8c-.6.1-1-.5-1-.5s-.3.6-1.1.7-1.4-.6-1.4-.6-.4.7-1 1c-.5 0-1.2-.4-1.2-.4l-.1.5-.3.1.1.5a27 27 0 0 1 7.3-.9c2.8 0 5.4.4 7.3 1l.2-.6z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M271.3 208.4c0-.2.2-.4.4-.4s.4.2.4.4a.4.4 0 0 1-.4.4.4.4 0 0 1-.4-.4"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.2,
      d: "M271.3 208.4c0-.2.2-.4.4-.4s.4.2.4.4a.4.4 0 0 1-.4.4.4.4 0 0 1-.4-.4zm.2-1.4c0-.3.2-.4.4-.4s.5.1.5.4-.2.4-.5.4a.4.4 0 0 1-.4-.4zm1-1c0-.2.3-.3.5-.3s.5.1.5.4c0 .2-.2.4-.5.4a.4.4 0 0 1-.4-.5zm1.4-.4c0-.2.2-.4.5-.4s.4.2.4.4-.2.4-.4.4-.5-.2-.5-.4zm1.4 0c0-.2.2-.3.5-.3.2 0 .4.1.4.4 0 .2-.2.4-.4.4a.4.4 0 0 1-.5-.4z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeWidth: 0.3,
      d: "M267.8 211.2a2.8 2.8 0 0 1-.2-1 2.7 2.7 0 0 1 2.7-2.8c.5 0 1 .1 1.4.3"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M272.7 209.2a1.7 1.7 0 0 1-.3-.8c0-1 1.2-2 2.6-2a3 3 0 0 1 1.5.4"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.2,
      d: "M266.6 210c0-.3.2-.5.4-.5.3 0 .4.2.4.4a.4.4 0 0 1-.4.4c-.2 0-.4-.1-.4-.4zm.1-1.6c0-.2.3-.4.5-.4s.4.2.4.4-.2.4-.4.4-.4-.2-.4-.4zm1-1.1c0-.3.2-.4.5-.4a.4.4 0 0 1 .4.4.4.4 0 0 1-.4.4.4.4 0 0 1-.5-.4zm1.3-.7c0-.2.2-.4.5-.4.2 0 .4.2.4.4 0 .3-.2.5-.4.5a.4.4 0 0 1-.5-.5zm1.4.1c0-.2.2-.4.5-.4a.4.4 0 0 1 .4.4.4.4 0 0 1-.4.4c-.3 0-.5-.2-.5-.4z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M277.9 210.7h.2a1 1 0 0 0 0 .4c0 .6.5 1 1 1a1 1 0 0 0 1-.7l.2-.3v.4c.1.5.6.8 1.1.8.6 0 1-.4 1-1a.7.7 0 0 0 0-.1l.4-.4.2.5a1 1 0 0 0-.1.4 1 1 0 0 0 1 1c.4 0 .7-.2.9-.5l.2-.2v.3c0 .3.1.6.4.7 0 0 .4 0 1-.4s.7-.7.7-.7v.4s-.5.8-1 1c-.2.2-.5.4-.8.3-.3 0-.6-.3-.7-.6a1.5 1.5 0 0 1-.7.2c-.6 0-1.2-.3-1.4-.8a1.5 1.5 0 0 1-1.1.5c-.5 0-1-.2-1.2-.6a1.5 1.5 0 0 1-1 .4c-.6 0-1-.2-1.4-.6-.2.4-.7.6-1.2.6-.4 0-.8-.1-1-.4a1.6 1.6 0 0 1-1.3.6c-.4 0-.8-.2-1.1-.5-.2.5-.8.8-1.4.8-.2 0-.5 0-.7-.2-.1.3-.4.6-.7.6-.3 0-.6 0-.9-.2a4.2 4.2 0 0 1-1-1l.1-.5.8.7c.5.4.9.4.9.4.3 0 .4-.4.4-.7v-.3l.2.2c.2.3.5.5.9.5a1 1 0 0 0 1-1 1 1 0 0 0 0-.4v-.5l.4.4v.1c0 .6.5 1 1 1 .6 0 1-.3 1.1-.9v-.3l.2.3c.2.4.6.7 1 .7.6 0 1.1-.4 1.1-1a1 1 0 0 0 0-.3h.2"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M277.9 210.7h.2a1 1 0 0 0 0 .4c0 .6.5 1 1 1a1 1 0 0 0 1-.7l.2-.3v.4c.1.5.6.8 1.1.8.6 0 1-.4 1-1a.7.7 0 0 0 0-.1l.4-.4.2.5a1 1 0 0 0-.1.4 1 1 0 0 0 1 1c.4 0 .7-.2.9-.5l.2-.2v.3c0 .3.1.6.4.7 0 0 .4 0 1-.4s.7-.7.7-.7v.4s-.5.8-1 1c-.2.2-.5.4-.8.3-.3 0-.6-.3-.7-.6a1.5 1.5 0 0 1-.7.2c-.6 0-1.2-.3-1.4-.8a1.5 1.5 0 0 1-1.1.5c-.5 0-1-.2-1.2-.6a1.5 1.5 0 0 1-1 .4c-.6 0-1-.2-1.4-.6-.2.4-.7.6-1.2.6-.4 0-.8-.1-1-.4a1.6 1.6 0 0 1-1.3.6c-.4 0-.8-.2-1.1-.5-.2.5-.8.8-1.4.8-.2 0-.5 0-.7-.2-.1.3-.4.6-.7.6-.3 0-.6 0-.9-.2a4.2 4.2 0 0 1-1-1l.1-.5.8.7c.5.4.9.4.9.4.3 0 .4-.4.4-.7v-.3l.2.2c.2.3.5.5.9.5a1 1 0 0 0 1-1 1 1 0 0 0 0-.4v-.5l.4.4v.1c0 .6.5 1 1 1 .6 0 1-.3 1.1-.9v-.3l.2.3c.2.4.6.7 1 .7.6 0 1.1-.4 1.1-1a1 1 0 0 0 0-.3h.2z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M277.8 213.3c-2.9 0-5.5.4-7.3 1l-.3-.2.1-.3c2-.6 4.6-1 7.5-1 3 0 5.7.4 7.6 1 0 0 .2.2.1.3l-.3.2a27 27 0 0 0-7.4-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M277.8 213.3c-2.9 0-5.5.4-7.3 1l-.3-.2.1-.3c2-.6 4.6-1 7.5-1 3 0 5.7.4 7.6 1 0 0 .2.2.1.3l-.3.2a27 27 0 0 0-7.4-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M275 214.4c0-.3.2-.4.5-.4a.4.4 0 0 1 .4.4.4.4 0 0 1-.4.4c-.3 0-.5-.2-.5-.4"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M275 214.4c0-.3.2-.4.5-.4a.4.4 0 0 1 .4.4.4.4 0 0 1-.4.4c-.3 0-.5-.2-.5-.4z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ad1519",
      d: "M277.9 214.5h-1c-.1 0-.3 0-.3-.3l.3-.3h2a.3.3 0 0 1 .2.3.3.3 0 0 1-.3.3h-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M277.9 214.5h-1c-.1 0-.3 0-.3-.3l.3-.3h2a.3.3 0 0 1 .2.3.3.3 0 0 1-.3.3h-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#058e6e",
      d: "M273.2 214.9h-.6a.3.3 0 0 1-.4-.2.3.3 0 0 1 .3-.3l.6-.1.7-.1c.2 0 .3 0 .4.2a.3.3 0 0 1-.3.4z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M273.2 214.9h-.6a.3.3 0 0 1-.4-.2.3.3 0 0 1 .3-.3l.6-.1.7-.1c.2 0 .3 0 .4.2a.3.3 0 0 1-.3.4h-.7"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ad1519",
      d: "m270.5 215.3.3-.4h.7l-.4.6z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m270.5 215.3.3-.4h.7l-.4.6-.6-.2"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M279.8 214.4c0-.3.2-.4.4-.4.3 0 .5.1.5.4 0 .2-.2.4-.5.4a.4.4 0 0 1-.4-.4"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M279.8 214.4c0-.3.2-.4.4-.4.3 0 .5.1.5.4 0 .2-.2.4-.5.4a.4.4 0 0 1-.4-.4z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#058e6e",
      d: "M282.5 214.9h.7a.3.3 0 0 0 .3-.2.3.3 0 0 0-.2-.3l-.7-.1-.7-.1c-.2 0-.3 0-.4.2 0 .2.1.3.3.4z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M282.5 214.9h.7a.3.3 0 0 0 .3-.2.3.3 0 0 0-.2-.3l-.7-.1-.7-.1c-.2 0-.3 0-.4.2 0 .2.1.3.3.4h.7"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ad1519",
      d: "m285.1 215.4-.2-.5h-.7l.3.6z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m285.1 215.4-.2-.5h-.7l.3.6.6-.1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ad1519",
      d: "M277.8 217.1a25 25 0 0 1-6-.6 25.4 25.4 0 0 1 6-.7c2.4 0 4.5.3 6.1.7-1.6.4-3.7.6-6 .6"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.3,
      d: "M277.8 217.1a25 25 0 0 1-6-.6 25.4 25.4 0 0 1 6-.7c2.4 0 4.5.3 6.1.7-1.6.4-3.7.6-6 .6z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m285.2 212-.1-.3c-.2 0-.3 0-.4.2l.1.4c.2 0 .3 0 .4-.3"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m285.2 212-.1-.3c-.2 0-.3 0-.4.2l.1.4c.2 0 .3 0 .4-.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M280.6 211.2c0-.2-.1-.4-.3-.4 0 0-.2.1-.2.3 0 .2 0 .4.2.4z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M280.6 211.2c0-.2-.1-.4-.3-.4 0 0-.2.1-.2.3 0 .2 0 .4.2.4z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M275.2 211.2c0-.2 0-.4.2-.4l.3.3-.2.4c-.2 0-.3-.2-.3-.3"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M275.2 211.2c0-.2 0-.4.2-.4l.3.3-.2.4c-.2 0-.3-.2-.3-.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m270.5 212 .1-.3c.2 0 .3 0 .4.2l-.1.4c-.2 0-.3 0-.4-.3"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m270.5 212 .1-.3c.2 0 .3 0 .4.2l-.1.4c-.2 0-.3 0-.4-.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m277.8 208.5-.8.5.6 1.3.2.1.3-.1.6-1.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m277.8 208.5-.8.5.6 1.3.2.1.3-.1.6-1.3-.9-.5"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m276 210.5.4.5 1.3-.4.1-.2-.1-.2-1.3-.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m276 210.5.4.5 1.3-.4.1-.2-.1-.2-1.3-.3-.4.6"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m279.6 210.5-.3.5-1.3-.4-.1-.2v-.2l1.4-.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m279.6 210.5-.3.5-1.3-.4-.1-.2v-.2l1.4-.3.4.6"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m272.5 209-.7.7.9 1 .2.1.2-.1.2-1.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m272.5 209-.7.7.9 1 .2.1.2-.1.2-1.3-.8-.3"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m271.1 211.2.5.5 1.2-.6v-.2l-.1-.2-1.3-.1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m271.1 211.2.5.5 1.2-.6v-.2l-.1-.2-1.3-.1-.3.6"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m274.7 210.5-.3.6h-1.3l-.2-.2.1-.3 1.2-.6z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m274.7 210.5-.3.6h-1.3l-.2-.2.1-.3 1.2-.6.5.5"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M269.8 211.4v.6l-1.4.2-.2-.1v-.2l1-.9z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M269.8 211.4v.6l-1.4.2-.2-.1v-.2l1-.9.6.4"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M272.4 210.9c0-.3.2-.5.5-.5a.5.5 0 0 1 .5.5.5.5 0 0 1-.5.4.5.5 0 0 1-.5-.4"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M272.4 210.9c0-.3.2-.5.5-.5a.5.5 0 0 1 .5.5.5.5 0 0 1-.5.4.5.5 0 0 1-.5-.4z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m283.2 209 .7.7-.9 1-.2.1-.1-.1-.3-1.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m283.2 209 .7.7-.9 1-.2.1-.1-.1-.3-1.3.8-.3"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m284.6 211.2-.5.5-1.2-.6v-.2l.1-.2 1.3-.1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m284.6 211.2-.5.5-1.2-.6v-.2l.1-.2 1.3-.1.3.6"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m281 210.5.3.6h1.3l.2-.2-.1-.3-1.2-.6z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m281 210.5.3.6h1.3l.2-.2-.1-.3-1.2-.6-.5.5"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M285.7 211.4v.6l1.4.2.2-.1v-.2l-1-.9z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M285.7 211.4v.6l1.4.2.2-.1v-.2l-1-.9-.6.4"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M277.4 210.4c0-.2.2-.4.5-.4.2 0 .4.2.4.4 0 .3-.2.5-.4.5a.5.5 0 0 1-.5-.5"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M277.4 210.4c0-.2.2-.4.5-.4.2 0 .4.2.4.4 0 .3-.2.5-.4.5a.5.5 0 0 1-.5-.5z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M282.3 210.9c0-.3.3-.5.5-.5.3 0 .5.2.5.5s-.2.4-.5.4a.5.5 0 0 1-.5-.4"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M282.3 210.9c0-.3.3-.5.5-.5.3 0 .5.2.5.5s-.2.4-.5.4a.5.5 0 0 1-.5-.4z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M277 205.4c0-.5.4-.8.8-.8s1 .3 1 .8-.5.8-1 .8a.9.9 0 0 1-.8-.8"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M278.5 205.1v.6H277v-.6h.4v-1.3h-.5v-.5h.5v-.6h.6v.6h.6v.6h-.6v1.2h.4"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M278.5 205.1v.6H277v-.6h.4v-1.3h-.5v-.5h.5v-.6h.6v.6h.6v.6h-.6v1.2h.4z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M279 205.1v.6h-2.4v-.6h1v-1.3h-.7v-.5h.6v-.6h.6v.6h.6v.6h-.6v1.2h1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M278.1 204.6c.4 0 .6.4.6.8 0 .5-.4.8-.9.8a.9.9 0 0 1-.8-.8c0-.4.2-.7.6-.8"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m268 212.2-.6-.7a2.3 2.3 0 0 0-.7-.3c0-.1.3-.3.6-.3.2 0 .3 0 .4.2v-.2s.3 0 .4.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m268 212.2-.6-.7a2.3 2.3 0 0 0-.7-.3c0-.1.3-.3.6-.3.2 0 .3 0 .4.2v-.2s.3 0 .4.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M268 212c.1-.2.4-.2.5 0 .2.1.3.3.1.5l-.5-.1c-.1-.1-.2-.4 0-.5"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M268 212c.1-.2.4-.2.5 0 .2.1.3.3.1.5l-.5-.1c-.1-.1-.2-.4 0-.5z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m287.5 212.2.6-.7c.2-.2.7-.3.7-.3 0-.1-.3-.3-.6-.3a.6.6 0 0 0-.4.2v-.2s-.3 0-.4.3v.7z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m287.5 212.2.6-.7c.2-.2.7-.3.7-.3 0-.1-.3-.3-.6-.3a.6.6 0 0 0-.4.2v-.2s-.3 0-.4.3v.7z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M287.5 212c-.1-.2-.3-.2-.5 0-.2.1-.2.3-.1.5l.5-.1c.2-.1.2-.4.1-.5"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M287.5 212c-.1-.2-.3-.2-.5 0-.2.1-.2.3-.1.5l.5-.1c.2-.1.2-.4.1-.5z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M267.2 223h21.4v-5.5h-21.4z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M267.2 223h21.4v-5.5h-21.4z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M286.3 226.8a1 1 0 0 0-.4 0h-16.5c.6-.2 1-.7 1-1.2 0-.6-.4-1.1-1-1.3h17-.1c-.6.2-1 .7-1 1.3 0 .5.4 1 1 1.2"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.4,
      d: "M286.3 226.8a1 1 0 0 0-.4 0h-16.5c.6-.2 1-.7 1-1.2 0-.6-.4-1.1-1-1.3h17-.1c-.6.2-1 .7-1 1.3 0 .5.4 1 1 1.2z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M269.9 226.8h16c.6 0 1 .3 1 .7 0 .4-.4.8-1 .8h-16c-.6 0-1-.4-1-.8s.5-.8 1-.8"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M269.9 226.8h16c.6 0 1 .3 1 .7 0 .4-.4.8-1 .8h-16c-.6 0-1-.4-1-.8s.5-.8 1-.8z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M269.9 223h16c.6 0 1 .4 1 .7 0 .4-.4.6-1 .6h-16c-.6 0-1-.2-1-.6 0-.3.4-.6 1-.6"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M269.9 223h16c.6 0 1 .4 1 .7 0 .4-.4.6-1 .6h-16c-.6 0-1-.2-1-.6 0-.3.4-.6 1-.6z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#005bbf",
      d: "M263 317.4c1.4 0 2.7-.3 3.7-.8a8.4 8.4 0 0 1 3.7-.8c1.4 0 2.8.3 3.8.8s2.3.8 3.7.8c1.5 0 2.8-.3 3.8-.8a8.4 8.4 0 0 1 3.6-.8 8 8 0 0 1 3.7.8c1 .5 2.4.8 3.8.8v2.4a8.3 8.3 0 0 1-3.8-.9 8.2 8.2 0 0 0-3.7-.8c-1.4 0-2.7.3-3.6.8-1 .5-2.3.9-3.8.9a8 8 0 0 1-3.7-.9 8.4 8.4 0 0 0-3.8-.8 8.3 8.3 0 0 0-3.7.8c-1 .5-2.3.9-3.8.9v-2.4"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M263 317.4c1.4 0 2.7-.3 3.7-.8a8.4 8.4 0 0 1 3.7-.8c1.4 0 2.8.3 3.8.8s2.3.8 3.7.8c1.5 0 2.8-.3 3.8-.8a8.4 8.4 0 0 1 3.6-.8 8 8 0 0 1 3.7.8c1 .5 2.4.8 3.8.8v2.4a8.3 8.3 0 0 1-3.8-.9 8.2 8.2 0 0 0-3.7-.8c-1.4 0-2.7.3-3.6.8-1 .5-2.3.9-3.8.9a8 8 0 0 1-3.7-.9 8.4 8.4 0 0 0-3.8-.8 8.3 8.3 0 0 0-3.7.8c-1 .5-2.3.9-3.8.9v-2.4z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ccc",
      d: "M263 319.8c1.4 0 2.7-.4 3.7-.9s2.3-.8 3.7-.8c1.4 0 2.8.3 3.8.8s2.3.9 3.7.9a8.2 8.2 0 0 0 3.8-.9 8.4 8.4 0 0 1 3.6-.8c1.5 0 2.8.3 3.7.8 1 .5 2.4.9 3.8.9v2.3a8.3 8.3 0 0 1-3.8-.9 8.1 8.1 0 0 0-3.7-.7c-1.4 0-2.7.2-3.6.7-1 .5-2.3.9-3.8.9a7 7 0 0 1-3.7-.9c-1-.4-2.3-.7-3.8-.7a8.3 8.3 0 0 0-3.7.7 8.1 8.1 0 0 1-3.8.9v-2.3"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M263 319.8c1.4 0 2.7-.4 3.7-.9s2.3-.8 3.7-.8c1.4 0 2.8.3 3.8.8s2.3.9 3.7.9a8.2 8.2 0 0 0 3.8-.9 8.4 8.4 0 0 1 3.6-.8c1.5 0 2.8.3 3.7.8 1 .5 2.4.9 3.8.9v2.3a8.3 8.3 0 0 1-3.8-.9 8.1 8.1 0 0 0-3.7-.7c-1.4 0-2.7.2-3.6.7-1 .5-2.3.9-3.8.9a7 7 0 0 1-3.7-.9c-1-.4-2.3-.7-3.8-.7a8.3 8.3 0 0 0-3.7.7 8.1 8.1 0 0 1-3.8.9v-2.3"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#005bbf",
      d: "M263 322c1.4 0 2.7-.2 3.7-.8 1-.4 2.3-.7 3.7-.7 1.4 0 2.8.2 3.8.7s2.3.9 3.7.9a8.2 8.2 0 0 0 3.8-.9 8.4 8.4 0 0 1 3.6-.8 8 8 0 0 1 3.7.8c1 .5 2.4.9 3.8.9v2.3a8.3 8.3 0 0 1-3.8-.9 8.2 8.2 0 0 0-3.7-.7c-1.4 0-2.7.3-3.6.7-1 .6-2.3.9-3.8.9-1.4 0-2.8-.3-3.7-.8a8.4 8.4 0 0 0-3.8-.8 8.3 8.3 0 0 0-3.7.8c-1 .5-2.3.8-3.8.8V322"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M263 322c1.4 0 2.7-.2 3.7-.8 1-.4 2.3-.7 3.7-.7 1.4 0 2.8.2 3.8.7s2.3.9 3.7.9a8.2 8.2 0 0 0 3.8-.9 8.4 8.4 0 0 1 3.6-.8 8 8 0 0 1 3.7.8c1 .5 2.4.9 3.8.9v2.3a8.3 8.3 0 0 1-3.8-.9 8.2 8.2 0 0 0-3.7-.7c-1.4 0-2.7.3-3.6.7-1 .6-2.3.9-3.8.9-1.4 0-2.8-.3-3.7-.8a8.4 8.4 0 0 0-3.8-.8 8.3 8.3 0 0 0-3.7.8c-1 .5-2.3.8-3.8.8V322"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ccc",
      d: "M263 326.7a8 8 0 0 0 3.7-.8c1-.5 2.3-.8 3.7-.8 1.4 0 2.8.3 3.8.8s2.3.8 3.7.8c1.5 0 2.8-.3 3.8-.9a8.4 8.4 0 0 1 3.6-.7c1.5 0 2.8.3 3.7.8a8.3 8.3 0 0 0 3.8.8v-2.3a8.3 8.3 0 0 1-3.8-.9 8.2 8.2 0 0 0-3.7-.7c-1.4 0-2.7.3-3.6.7-1 .5-2.3.9-3.8.9-1.4 0-2.8-.3-3.7-.8a8.4 8.4 0 0 0-3.8-.8 8.3 8.3 0 0 0-3.7.8c-1 .5-2.3.8-3.8.8v2.3"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M263 326.7a8 8 0 0 0 3.7-.8c1-.5 2.3-.8 3.7-.8 1.4 0 2.8.3 3.8.8s2.3.8 3.7.8c1.5 0 2.8-.3 3.8-.9a8.4 8.4 0 0 1 3.6-.7c1.5 0 2.8.3 3.7.8a8.3 8.3 0 0 0 3.8.8v-2.3a8.3 8.3 0 0 1-3.8-.9 8.2 8.2 0 0 0-3.7-.7c-1.4 0-2.7.3-3.6.7-1 .5-2.3.9-3.8.9-1.4 0-2.8-.3-3.7-.8a8.4 8.4 0 0 0-3.8-.8 8.3 8.3 0 0 0-3.7.8c-1 .5-2.3.8-3.8.8v2.3"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#005bbf",
      d: "M263 329a8.1 8.1 0 0 0 3.7-.8c1-.5 2.3-.8 3.7-.8 1.4 0 2.8.3 3.8.8s2.3.8 3.7.8a8.2 8.2 0 0 0 3.8-.9 8.4 8.4 0 0 1 3.6-.7c1.5 0 2.8.3 3.7.8 1 .5 2.4.8 3.8.8v-2.3a8.3 8.3 0 0 1-3.8-.8 8.2 8.2 0 0 0-3.7-.8 8.4 8.4 0 0 0-3.6.7 8.2 8.2 0 0 1-3.8.9c-1.4 0-2.8-.3-3.7-.8-1-.5-2.3-.8-3.8-.8-1.4 0-2.7.3-3.7.8s-2.3.8-3.8.8v2.3"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M263 329a8.1 8.1 0 0 0 3.7-.8c1-.5 2.3-.8 3.7-.8 1.4 0 2.8.3 3.8.8s2.3.8 3.7.8a8.2 8.2 0 0 0 3.8-.9 8.4 8.4 0 0 1 3.6-.7c1.5 0 2.8.3 3.7.8 1 .5 2.4.8 3.8.8v-2.3a8.3 8.3 0 0 1-3.8-.8 8.2 8.2 0 0 0-3.7-.8 8.4 8.4 0 0 0-3.6.7 8.2 8.2 0 0 1-3.8.9c-1.4 0-2.8-.3-3.7-.8-1-.5-2.3-.8-3.8-.8-1.4 0-2.7.3-3.7.8s-2.3.8-3.8.8v2.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m286.3 308-.1.5c0 1.5 1.2 2.6 2.7 2.6h-22c1.5 0 2.7-1.2 2.7-2.6l-.1-.5z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.4,
      d: "m286.3 308-.1.5c0 1.5 1.2 2.6 2.7 2.6h-22c1.5 0 2.7-1.2 2.7-2.6l-.1-.5z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M269.9 306.5h16c.6 0 1 .3 1 .8 0 .4-.4.7-1 .7h-16c-.6 0-1-.3-1-.8 0-.4.5-.7 1-.7"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M269.9 306.5h16c.6 0 1 .3 1 .8 0 .4-.4.7-1 .7h-16c-.6 0-1-.3-1-.8 0-.4.5-.7 1-.7z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M266.9 316.7h22V311h-22z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M266.9 316.7h22V311h-22z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ad1519",
      d: "M290.6 286.7c2.1 1.2 3.6 2.5 3.4 3.2-.1.6-.8 1-1.8 1.6-1.6 1.1-2.5 3-1.8 4a5.5 5.5 0 0 1 .2-8.8"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M290.6 286.7c2.1 1.2 3.6 2.5 3.4 3.2-.1.6-.8 1-1.8 1.6-1.6 1.1-2.5 3-1.8 4a5.5 5.5 0 0 1 .2-8.8z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ccc",
      d: "M270.1 305.6h15.6V229h-15.6v76.5z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M281.4 229.1v76.3m1.8-76.3v76.3m-13 .2h15.5V229h-15.6v76.5z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ad1519",
      d: "M254.2 257.7a49.6 49.6 0 0 1 23.3-2c9.3 1.6 16.4 5.3 15.9 8.4v.2l3.5-8.2c.6-3.3-7.3-7.5-17.6-9.2a53.5 53.5 0 0 0-9.2-.7c-6.7 0-12.4.8-15.9 2.1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.4,
      d: "M254.2 257.7a49.6 49.6 0 0 1 23.3-2c9.3 1.6 16.4 5.3 15.9 8.4v.2l3.5-8.2c.6-3.3-7.3-7.5-17.6-9.2a53.5 53.5 0 0 0-9.2-.7c-6.7 0-12.4.8-15.9 2.1v9.4"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ad1519",
      d: "M285.7 267.3c4.4-.3 7.3-1.4 7.7-3.2.2-1.5-1.2-3-3.8-4.5-1.2.1-2.5.3-3.9.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M285.7 267.3c4.4-.3 7.3-1.4 7.7-3.2.2-1.5-1.2-3-3.8-4.5-1.2.1-2.5.3-3.9.3v7.4"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ad1519",
      d: "M270 261.5a13 13 0 0 0-5.7 1.9v.2c-.5 1 1.8 3 5.8 5.4v-7.5"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M270 261.5a13 13 0 0 0-5.7 1.9v.2c-.5 1 1.8 3 5.8 5.4v-7.5"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ad1519",
      d: "M295.4 282c.4-1.2-3.8-3.6-9.7-5.8-2.8-1-5-2-7.8-3.2-8.3-3.7-14.4-7.9-13.6-9.4v-.2c-.4.4-1 8-1 8-.8 1.3 4.8 5.5 12.4 9.1 2.4 1.2 7.6 3 10 4 4.3 1.4 8.7 4.3 8.3 5.3l1.4-7.7"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.4,
      d: "M295.4 282c.4-1.2-3.8-3.6-9.7-5.8-2.8-1-5-2-7.8-3.2-8.3-3.7-14.4-7.9-13.6-9.4v-.2c-.4.4-1 8-1 8-.8 1.3 4.8 5.5 12.4 9.1 2.4 1.2 7.6 3 10 4 4.3 1.4 8.7 4.3 8.3 5.3l1.4-7.7z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M263.9 254.4c.6-2.3 1.4-4.4 2.1-6.6h-.5a5.2 5.2 0 0 1-.5.1 52.8 52.8 0 0 1-1.4 4.8c-1-1.4-2-2.7-2.7-4.1l-1 .2h-1a131.3 131.3 0 0 1 4 5.7h.5zm6-6.6h-1a8 8 0 0 1-.8 0v6.2h4.2v-.7h-2.6zm6.8 1 2 .3v-.7l-5.8-.5v.8a19.3 19.3 0 0 1 2 0l-.4 5.6h1.6l.5-5.4m2.4 6c.3 0 .5 0 .8.2l.8.2.7-2.9.6 1.2.8 2.1 1 .2c.4 0 .7.2 1 .3l-.3-.7c-.4-1-1-1.9-1.3-2.9 1 0 1.9-.3 2.1-1.2.1-.6 0-1-.7-1.5-.4-.3-1.2-.4-1.7-.5l-2.4-.5zm3-5.2c.7.2 1.5.3 1.5 1v.5c-.3.9-1 1.2-2 .9zm8 7-.2 2 .8.5.9.5.5-7a3.4 3.4 0 0 1-.7-.3l-6.1 3.8.5.3.4.2 1.7-1.2 2.3 1.3zm-1.7-1.5 2-1.4-.2 2.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M182.2 192.4c0-1 1-2 2-2s2.2 1 2.2 2c0 1.1-1 2-2.1 2a2 2 0 0 1-2.1-2z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ad1519",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M205.7 175.4c6.3 0 12 1 15.7 2.4a31.7 31.7 0 0 0 14.6 2.3c2.7 0 6.5.8 10.3 2.4a27.3 27.3 0 0 1 7.4 4.7l-1.5 1.4-.4 3.8-4.1 4.7-2 1.8-5 3.9-2.5.2-.7 2.1-31.6-3.7-31.7 3.7-.8-2.1-2.5-.2-4.9-4-2-1.7-4.1-4.7-.5-3.8-1.5-1.4a27.6 27.6 0 0 1 7.5-4.7 26 26 0 0 1 10.2-2.4c2 .2 4.2.1 6.6-.2a30 30 0 0 0 8-2c3.7-1.5 9-2.5 15.5-2.5z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M206.2 217.1c-11.8 0-22.4-1.4-29.9-3.6a1.1 1.1 0 0 1-.8-1.2c0-.5.3-1 .8-1.2a109 109 0 0 1 29.9-3.6c11.7 0 22.3 1.4 29.8 3.6a1.3 1.3 0 0 1 0 2.4c-7.5 2.2-18 3.6-29.8 3.6"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ad1519",
      d: "M206.1 215.6c-10.6 0-20.2-1.2-27.5-3.1 7.3-2 16.9-3 27.5-3.1a115 115 0 0 1 27.6 3c-7.3 2-17 3.2-27.6 3.2"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M206.9 215.7v-6.3m-1.7 6.3v-6.3"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.2,
      d: "M203.6 215.7v-6.3m-1.6 6.3v-6.3"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M200.6 215.7v-6.3m-2.8 5.9v-5.7m1.3 5.8v-6m-3.8 5.6v-5.2m1.3 5.4v-5.6"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M192 214.8V210m1 4.7V210m1.2 5v-5m-3.4 4.7v-4.5"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.5,
      d: "M189.7 214.5v-4.2m-1.2 4.1v-4"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.6,
      d: "M186 214v-3m1.3 3.2v-3.5m-2.5 3.1V211"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.7,
      d: "M183.7 213.6v-2.3m-1.3 2v-1.8m-1.2 1.6v-1.3"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.9,
      d: "M179.8 212.8v-.7"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M213.7 215.3v-5.8m-2.9 6v-6.1m-2.1 6.2v-6.3"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M206 207.4a108 108 0 0 0-30 3.9c.6-.3.5-1-.3-3-1-2.5-2.4-2.4-2.4-2.4 8.3-2.5 20-4 32.8-4a123 123 0 0 1 33 4s-1.5-.1-2.5 2.3c-.8 2-.8 2.8-.2 3-7.5-2.2-18.4-3.7-30.3-3.7"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M206.1 201.9c-12.9 0-24.5 1.5-32.8 4a1 1 0 0 1-1.3-.6 1 1 0 0 1 .7-1.3 121 121 0 0 1 33.4-4.2c13.2 0 25.2 1.7 33.5 4.2.6.2.9.8.7 1.3-.2.5-.8.8-1.3.6-8.4-2.5-20-4-32.9-4"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.4,
      d: "M206.1 215.6c-10.6 0-20.2-1.2-27.5-3.1 7.3-2 16.9-3 27.5-3.1a115 115 0 0 1 27.6 3c-7.3 2-17 3.2-27.6 3.2z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M197 204.8c0-.5.4-1 1-1 .5 0 1 .5 1 1s-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ad1519",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M206.1 205.6H203a1 1 0 0 1 0-2h6.4c.5 0 1 .5 1 1s-.5 1-1 1h-3.2"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#058e6e",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "m190.3 206.5-2.3.2c-.6.1-1-.3-1.2-.8a1 1 0 0 1 1-1.1l2.2-.3 2.4-.3c.5 0 1 .3 1.1.9.1.5-.3 1-.9 1l-2.3.4"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M181 206.7c0-.6.5-1 1.1-1 .6 0 1 .4 1 1 0 .5-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ad1519",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "m174 208.5 1.2-1.6 3.3.4-2.6 2-1.8-.8"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#058e6e",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "m222 206.5 2.3.2c.5.1 1-.3 1.1-.8a1 1 0 0 0-.9-1.1l-2.2-.3-2.4-.3a1 1 0 0 0-1.1.9c-.1.5.3 1 .9 1l2.3.4"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M213.3 204.8c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1-1-1m15.8 1.9c0-.6.5-1 1-1 .6 0 1.1.4 1.1 1 0 .5-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ad1519",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "m238.2 208.5-1.1-1.6-3.3.4 2.6 2 1.8-.8"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M177.3 212.8c7.4-2.1 17.6-3.4 28.8-3.4 11.3 0 21.4 1.3 28.9 3.4"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m182.3 183.8 1.4 1 2-3.2a7.4 7.4 0 0 1-3.6-7.2c.2-4.1 5.2-7.6 11.7-7.6 3.3 0 6.3 1 8.5 2.4 0-.6 0-1.2.2-1.8a17.4 17.4 0 0 0-8.7-2.1c-7.4 0-13.2 4.1-13.5 9.1a8.9 8.9 0 0 0 3 7.6z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "m182.3 183.8 1.4 1 2-3.2a7.4 7.4 0 0 1-3.6-7.2c.2-4.1 5.2-7.6 11.7-7.6 3.3 0 6.3 1 8.5 2.4 0-.6 0-1.2.2-1.8a17.4 17.4 0 0 0-8.7-2.1c-7.4 0-13.2 4.1-13.5 9.1a8.9 8.9 0 0 0 3 7.6l-1 1.8"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M182.4 183.8a9.3 9.3 0 0 1-4-7.3c0-3.2 2-6.1 5.3-8a8.5 8.5 0 0 0-3.4 6.8 8.9 8.9 0 0 0 3 6.7z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M182.4 183.8a9.3 9.3 0 0 1-4-7.3c0-3.2 2-6.1 5.3-8a8.5 8.5 0 0 0-3.4 6.8 8.9 8.9 0 0 0 3 6.7l-.9 1.8"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M160.1 187.1a8.8 8.8 0 0 1-2.3-5.9c0-1.3.3-2.6 1-3.8 2-4.2 8.4-7.2 16-7.2 2 0 4 .2 5.9.6l-1 1.4a25.5 25.5 0 0 0-4.9-.4c-7 0-12.8 2.7-14.5 6.3a7 7 0 0 0-.7 3.1 7.3 7.3 0 0 0 2.7 5.6l-2.6 4.1-1.3-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M160.1 187.1a8.8 8.8 0 0 1-2.3-5.9c0-1.3.3-2.6 1-3.8 2-4.2 8.4-7.2 16-7.2 2 0 4 .2 5.9.6l-1 1.4a25.5 25.5 0 0 0-4.9-.4c-7 0-12.8 2.7-14.5 6.3a7 7 0 0 0-.7 3.1 7.3 7.3 0 0 0 2.7 5.6l-2.6 4.1-1.3-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M162.7 173.3a10.5 10.5 0 0 0-4 4.1 8.6 8.6 0 0 0-.9 3.8c0 2.3.9 4.3 2.3 5.9l-1.5 2.5a10.4 10.4 0 0 1-2.3-6.5c0-4 2.5-7.5 6.4-9.8"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M162.7 173.3a10.5 10.5 0 0 0-4 4.1 8.6 8.6 0 0 0-.9 3.8c0 2.3.9 4.3 2.3 5.9l-1.5 2.5a10.4 10.4 0 0 1-2.3-6.5c0-4 2.5-7.5 6.4-9.8z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M206 164.4c1.7 0 3.2 1.1 3.5 2.6.3 1.4.4 2.9.4 4.5v1.1c.1 3.3.6 6.3 1.3 8.1l-5.2 5-5.2-5c.7-1.8 1.2-4.8 1.3-8.1v-1.1c0-1.6.2-3.1.4-4.5.3-1.5 1.8-2.6 3.5-2.6"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M206 164.4c1.7 0 3.2 1.1 3.5 2.6.3 1.4.4 2.9.4 4.5v1.1c.1 3.3.6 6.3 1.3 8.1l-5.2 5-5.2-5c.7-1.8 1.2-4.8 1.3-8.1v-1.1c0-1.6.2-3.1.4-4.5.3-1.5 1.8-2.6 3.5-2.6z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M206 166c1 0 1.7.6 1.8 1.4.2 1.2.4 2.6.4 4.2v1c.1 3.2.6 6 1.2 7.7l-3.4 3.2-3.4-3.2c.7-1.7 1.1-4.5 1.2-7.7v-1a28.1 28.1 0 0 1 .4-4.2 2 2 0 0 1 1.8-1.4"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M206 166c1 0 1.7.6 1.8 1.4.2 1.2.4 2.6.4 4.2v1c.1 3.2.6 6 1.2 7.7l-3.4 3.2-3.4-3.2c.7-1.7 1.1-4.5 1.2-7.7v-1a28.1 28.1 0 0 1 .4-4.2 2 2 0 0 1 1.8-1.4z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m229.7 183.8-1.3 1-2-3.2a7.4 7.4 0 0 0 3.6-6.3 7 7 0 0 0 0-.9c-.2-4.1-5.3-7.6-11.7-7.6a15 15 0 0 0-8.5 2.4 23 23 0 0 0-.2-1.8 17.4 17.4 0 0 1 8.7-2.1c7.4 0 13.2 4.1 13.4 9.1a8.9 8.9 0 0 1-3 7.6z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "m229.7 183.8-1.3 1-2-3.2a7.4 7.4 0 0 0 3.6-6.3 7 7 0 0 0 0-.9c-.2-4.1-5.3-7.6-11.7-7.6a15 15 0 0 0-8.5 2.4 23 23 0 0 0-.2-1.8 17.4 17.4 0 0 1 8.7-2.1c7.4 0 13.2 4.1 13.4 9.1a8.9 8.9 0 0 1-3 7.6l1 1.8"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M229.6 183.8a9.1 9.1 0 0 0 4.1-7.3c0-3.2-2.1-6.1-5.3-8a8.5 8.5 0 0 1 3.4 6.8 8.9 8.9 0 0 1-3.2 6.7z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M229.6 183.8a9.1 9.1 0 0 0 4.1-7.3c0-3.2-2.1-6.1-5.3-8a8.5 8.5 0 0 1 3.4 6.8 8.9 8.9 0 0 1-3.2 6.7l1 1.8"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M252 187.1a8.8 8.8 0 0 0 2.2-5.9 8.7 8.7 0 0 0-.9-3.8c-2-4.2-8.4-7.2-16-7.2a29 29 0 0 0-6 .6l1 1.4a25.4 25.4 0 0 1 5-.4c7 0 12.8 2.7 14.4 6.3.5 1 .7 2 .7 3.1a7.3 7.3 0 0 1-2.6 5.6l2.5 4.1 1.3-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M252 187.1a8.8 8.8 0 0 0 2.2-5.9 8.7 8.7 0 0 0-.9-3.8c-2-4.2-8.4-7.2-16-7.2a29 29 0 0 0-6 .6l1 1.4a25.4 25.4 0 0 1 5-.4c7 0 12.8 2.7 14.4 6.3.5 1 .7 2 .7 3.1a7.3 7.3 0 0 1-2.6 5.6l2.5 4.1 1.3-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M249.3 173.3a10.6 10.6 0 0 1 4 4.1 8.7 8.7 0 0 1 .9 3.8 8.8 8.8 0 0 1-2.3 5.9l1.6 2.5a10.4 10.4 0 0 0 2.3-6.5c0-4-2.6-7.5-6.5-9.8"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M249.3 173.3a10.6 10.6 0 0 1 4 4.1 8.7 8.7 0 0 1 .9 3.8 8.8 8.8 0 0 1-2.3 5.9l1.6 2.5a10.4 10.4 0 0 0 2.3-6.5c0-4-2.6-7.5-6.5-9.8z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M204.2 181.4c0-1 .8-1.8 1.8-1.8s1.9.8 1.9 1.8-.9 1.7-1.9 1.7a1.8 1.8 0 0 1-1.8-1.7"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M204.2 181.4c0-1 .8-1.8 1.8-1.8s1.9.8 1.9 1.8-.9 1.7-1.9 1.7a1.8 1.8 0 0 1-1.8-1.7z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M204.2 178c0-1 .8-1.8 1.8-1.8s1.9.8 1.9 1.8-.9 1.7-1.9 1.7a1.8 1.8 0 0 1-1.8-1.7m.4-3.7c0-.7.6-1.3 1.4-1.3.8 0 1.5.6 1.5 1.3 0 .8-.7 1.4-1.5 1.4s-1.4-.6-1.4-1.4m.4-3.3c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1-1-1m.2-2.8c0-.5.4-.8.8-.8.5 0 .9.3.9.8 0 .4-.4.8-.9.8a.8.8 0 0 1-.8-.8"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "m206.2 191.8 1.2.2a4.6 4.6 0 0 0 4.5 6 4.7 4.7 0 0 0 4.4-3c.1 0 .5-1.7.7-1.7.2 0 .1 1.8.2 1.7.3 2.3 2.4 3.8 4.7 3.8a4.6 4.6 0 0 0 4.7-5l1.5-1.5.7 2a4 4 0 0 0-.4 1.9 4.4 4.4 0 0 0 4.5 4.2c1.6 0 3-.7 3.8-1.9l.9-1.2v1.5c0 1.5.6 2.8 2 3 0 0 1.7.1 4-1.6 2.1-1.7 3.3-3.1 3.3-3.1l.2 1.7s-1.8 2.8-3.8 4c-1 .6-2.7 1.3-4 1-1.4-.2-2.4-1.3-3-2.6a6.7 6.7 0 0 1-3.3 1 6.5 6.5 0 0 1-6.1-3.7 7 7 0 0 1-10.4-.3 7 7 0 0 1-4.6 1.8 6.9 6.9 0 0 1-5.7-3 6.9 6.9 0 0 1-5.7 3 7 7 0 0 1-4.7-1.8 7 7 0 0 1-10.4.3 6.5 6.5 0 0 1-6 3.7 6.7 6.7 0 0 1-3.4-1c-.6 1.3-1.5 2.4-3 2.7-1.2.2-2.9-.5-4-1.1-2-1.2-3.8-4-3.8-4l.2-1.7s1.2 1.4 3.4 3.1c2.2 1.8 3.9 1.6 3.9 1.6 1.4-.2 2-1.5 2-3v-1.5l1 1.2a4.6 4.6 0 0 0 3.7 2c2.5 0 4.5-2 4.5-4.3a4 4 0 0 0-.4-2l.8-1.9 1.5 1.5a4.4 4.4 0 0 0 0 .6c0 2.4 2 4.4 4.6 4.4 2.4 0 4.4-1.5 4.7-3.8 0 0 0-1.6.2-1.7.2 0 .6 1.7.7 1.6a4.7 4.7 0 0 0 4.5 3.1 4.6 4.6 0 0 0 4.5-6l1.2-.2"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M238.6 197.7c.3-.8 0-1.6-.6-1.8-.5-.2-1.2.3-1.5 1.1-.3.8 0 1.6.6 1.8.5.2 1.2-.3 1.5-1.1m-20.5-4c0-.8-.3-1.6-1-1.6-.5-.1-1 .5-1.2 1.4-.1.8.3 1.5.9 1.6.6 0 1.2-.6 1.3-1.4m-23.9 0c0-.8.4-1.6 1-1.6.6-.1 1.1.5 1.2 1.4.1.8-.3 1.5-.9 1.6-.6 0-1.1-.6-1.2-1.4m-20.6 4c-.2-.8 0-1.6.6-1.8.6-.2 1.2.3 1.5 1.1.3.8 0 1.6-.5 1.8-.6.2-1.3-.3-1.6-1.1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M182.7 184a5.1 5.1 0 0 1 2.2 2.9s0-.3.6-.6 1-.3 1-.3l-.1 1.3-.3 2.2a7.4 7.4 0 0 1-.7 1.6 1.9 1.9 0 0 0-1.5-.4 1.8 1.8 0 0 0-1.2.9s-.7-.6-1.2-1.3l-1.1-2-.7-1.1s.5-.2 1.1 0c.6 0 .8.2.8.2a4.9 4.9 0 0 1 1-3.4m.4 9.8a1.8 1.8 0 0 1-.6-1c0-.5 0-.9.3-1.2 0 0-.9-.5-1.8-.7-.7-.2-2-.2-2.3-.2h-1l.2.5c.2.5.5.7.5.7a5 5 0 0 0-3 2 5.3 5.3 0 0 0 3.5 1l-.2.8v.6l1-.4c.3-.1 1.5-.5 2-1 .8-.4 1.5-1.1 1.5-1.1m2.7-.5a1.6 1.6 0 0 0 .2-1.1 1.7 1.7 0 0 0-.6-1l1.4-1.3a10 10 0 0 1 2-.9l1.1-.4v.6a5.7 5.7 0 0 1-.2.8 5 5 0 0 1 3.4 1 5 5 0 0 1-2.9 2 6.4 6.4 0 0 0 .7 1.2h-1c-.4 0-1.6 0-2.3-.2a11 11 0 0 1-1.8-.7"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ad1519",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M182.2 192.4c0-1 1-2 2-2s2.2 1 2.2 2c0 1.1-1 2-2.1 2a2 2 0 0 1-2.1-2"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M206.1 180.8a5.7 5.7 0 0 1 1.9 3.7s.2-.3.9-.5c.7-.3 1.2-.2 1.2-.2l-.5 1.4-.8 2.4a8.2 8.2 0 0 1-1 1.7 2.1 2.1 0 0 0-1.7-.7c-.6 0-1.2.3-1.6.7 0 0-.6-.7-1-1.7l-.8-2.4-.5-1.4 1.2.2c.7.2.9.5.9.5 0-1.4.8-2.8 1.8-3.7"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M204.6 191.8a2 2 0 0 1-.5-1.2c0-.5.1-1 .4-1.3 0 0-.8-.7-1.8-1-.7-.4-2-.7-2.5-.7l-1.2-.2.2.6.4.9a5.9 5.9 0 0 0-3.7 1.7c1 .9 2.3 1.6 3.7 1.6l-.4 1-.2.6 1.2-.2c.4-.1 1.8-.4 2.5-.7 1-.4 1.9-1 1.9-1m3 0a1.9 1.9 0 0 0 .1-2.6s.9-.7 1.8-1a8 8 0 0 1 2.5-.7l1.2-.3-.1.7-.4.9c1.4 0 2.7.8 3.6 1.7a5.9 5.9 0 0 1-3.6 1.6 6.9 6.9 0 0 0 .5 1.6l-1.2-.2-2.5-.7c-1-.4-1.8-1-1.8-1m22-8a5.2 5.2 0 0 0-2.2 3l-.7-.6c-.6-.3-1-.3-1-.3l.2 1.3c0 .3 0 1.3.3 2.2.2 1 .6 1.6.6 1.6a2 2 0 0 1 1.5-.4c.6.1 1 .5 1.3.9l1.1-1.3c.6-.8 1-1.7 1.1-2l.7-1.1s-.4-.2-1 0c-.7 0-1 .2-1 .2a4.9 4.9 0 0 0-1-3.4m-.3 9.8c.3-.3.5-.6.6-1a1.6 1.6 0 0 0-.2-1.2s.8-.5 1.7-.7c.7-.2 2-.2 2.3-.2h1.1l-.3.5a6.2 6.2 0 0 1-.4.7 5 5 0 0 1 2.9 2 5.3 5.3 0 0 1-3.5 1l.2.8v.6l-1-.4c-.3-.1-1.4-.5-2-1-.8-.4-1.4-1.1-1.4-1.1m-2.8-.5a1.7 1.7 0 0 1-.2-1.1c0-.5.3-.8.6-1 0 0-.6-.8-1.4-1.3-.6-.4-1.7-.8-2-.9a171.4 171.4 0 0 1-1-.4v.6c0 .5.2.8.2.8a5.2 5.2 0 0 0-3.5 1c.7.9 1.7 1.7 3 2 0 0-.3.2-.5.7l-.3.5h1c.4 0 1.7 0 2.3-.2a11.1 11.1 0 0 0 1.8-.7"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ad1519",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M226 192.4c0-1 1-2 2-2s2.1 1 2.1 2a2 2 0 0 1-2 2 2 2 0 0 1-2.1-2m23.2 4.4c-.4-.5-1.4-.4-2.2.2-.8.7-1 1.6-.5 2.2.5.5 1.5.4 2.3-.3.7-.6 1-1.6.5-2"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "m246.3 198 .7-1c.7-.6 1.8-.7 2.3-.2l.1.2s1-2 2.3-2.6c1.3-.7 3.4-.5 3.4-.5a2.8 2.8 0 0 0-2.9-2.8 3 3 0 0 0-2.4 1l-.2-1s-1.3.3-1.9 1.8c-.6 1.5 0 3.6 0 3.6s-.3-.9-.7-1.5a8 8 0 0 0-2.4-1.6l-1.3-.7-.1.5a5 5 0 0 0 0 .8 7.9 7.9 0 0 0-3.7.5 4.7 4.7 0 0 0 2.5 2.2l-.8.7a4 4 0 0 0-.4.5l1.3.2 2.5.2a14.5 14.5 0 0 0 1.7-.2m-80.3 0c0-.4-.3-.7-.7-1-.7-.7-1.7-.8-2.2-.3l-.2.3s-1-2-2.3-2.7c-1.2-.7-3.3-.5-3.3-.5a2.8 2.8 0 0 1 2.8-2.8c1 0 1.9.4 2.4 1l.2-1s1.3.3 2 1.8c.5 1.5-.1 3.6-.1 3.6s.3-.9.8-1.5a8 8 0 0 1 2.4-1.6l1.3-.7v1.3a7.9 7.9 0 0 1 3.7.5 4.7 4.7 0 0 1-2.5 2.2l.8.7.4.5-1.2.2-2.6.2a14.7 14.7 0 0 1-1.7-.2"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ad1519",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M163 196.8c.6-.5 1.6-.4 2.4.3.7.6 1 1.5.4 2-.5.6-1.5.5-2.2-.2-.8-.6-1-1.6-.5-2m41-6.3c0-1.1.9-2 2-2s2.1.9 2.1 2c0 1-1 2-2 2a2 2 0 0 1-2.1-2"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#005bbf",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M201.8 160.6c0-2.2 1.9-4 4.3-4s4.2 1.8 4.2 4-1.9 4-4.3 4a4.1 4.1 0 0 1-4.2-4"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M205 149.3v2.2h-2.4v2.2h2.3v6.3H202l-.2.6c0 .6.1 1.1.3 1.6h7.9c.2-.5.3-1 .3-1.6l-.2-.6h-2.8v-6.3h2.3v-2.2h-2.3v-2.2z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ccc",
      d: "M206.5 330.6a82 82 0 0 1-35.5-8.2 22.7 22.7 0 0 1-12.8-20.4v-32h96.4v32a22.7 22.7 0 0 1-12.8 20.4 81 81 0 0 1-35.3 8.2"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.5,
      d: "M206.5 330.6a82 82 0 0 1-35.5-8.2 22.7 22.7 0 0 1-12.8-20.4v-32h96.4v32a22.7 22.7 0 0 1-12.8 20.4 81 81 0 0 1-35.3 8.2z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ccc",
      d: "M206.3 270h48.3v-53.5h-48.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.5,
      d: "M206.3 270h48.3v-53.5h-48.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ad1519",
      d: "M206.3 302c0 12.6-10.7 22.9-24 22.9s-24.2-10.3-24.2-23v-32h48.2v32"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: 0.5,
      d: "M168.6 320.9c1.5.8 3.6 2 5.8 2.6l-.1-54.7h-5.7z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.5,
      d: "M158 301.6a24.4 24.4 0 0 0 5.5 15v-47.5h-5.4z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c7b500",
      stroke: "#000",
      strokeWidth: 0.5,
      d: "M179.4 324.7a26.6 26.6 0 0 0 5.6 0v-55.9h-5.6v56z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: 0.5,
      d: "M190 323.5a19 19 0 0 0 5.8-2.5v-52.2H190z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ad1519",
      d: "M158.1 270h48.2v-53.5H158z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.5,
      d: "M158.1 270h48.2v-53.5H158z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: 0.5,
      d: "M201 316c2.4-2 4.6-6.8 5.4-12.2l.1-35H201l.1 47.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.5,
      d: "M206.3 302c0 12.6-10.7 22.9-24 22.9s-24.2-10.3-24.2-23v-32h48.2v32"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ad1519",
      d: "M254.6 270v32c0 12.6-10.8 22.9-24.1 22.9s-24.2-10.3-24.2-23v-32h48.3"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.5,
      d: "M254.6 270v32c0 12.6-10.8 22.9-24.1 22.9s-24.2-10.3-24.2-23v-32h48.3"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m215.1 294.1.1.5c0 .6-.5 1-1.1 1a1 1 0 0 1-1.1-1v-.5h-1.5a2.5 2.5 0 0 0 1.8 2.9v3.9h1.6V297a2.6 2.6 0 0 0 1.7-1.6h4.4v-1.2zm21.8 0v1.2h-4a2.5 2.5 0 0 1-.3.6l4.6 5.2-1.2 1-4.6-5.3-.2.1v8.7h-1.6V297h-.2l-4.8 5.2-1.2-1 4.7-5.3a2.1 2.1 0 0 1-.2-.4h-4V294h13zm2.6 0v1.2h4.4c.3.8.9 1.4 1.7 1.6v3.9h1.6V297a2.5 2.5 0 0 0 1.8-2.4 2 2 0 0 0 0-.5h-1.6l.1.5c0 .6-.5 1-1 1-.7 0-1.2-.4-1.2-1a1 1 0 0 1 .1-.5zm-6.7 22.1a15.6 15.6 0 0 0 3.7-1l.8 1.4a17.6 17.6 0 0 1-4.3 1.2 2.6 2.6 0 0 1-2.6 2 2.6 2.6 0 0 1-2.5-2 17.5 17.5 0 0 1-4.6-1.2l.8-1.4c1.3.5 2.6.9 4 1a2.5 2.5 0 0 1 1.5-1.3v-6.7h1.6v6.7c.7.2 1.3.7 1.6 1.4zm-11-2.2-.8 1.4a16.6 16.6 0 0 1-3.6-3.1c-.9.2-1.8 0-2.5-.5a2.4 2.4 0 0 1-.3-3.5l.1-.1a15.3 15.3 0 0 1-1.3-4.8h1.7a13.1 13.1 0 0 0 1 4c.5 0 1 0 1.4.2l4.1-4.5 1.3 1-4.1 4.5c.5.9.5 2-.1 2.8a15.2 15.2 0 0 0 3.1 2.6m-6-4.8c.3-.4 1-.5 1.5 0s.5 1 .1 1.4a1.2 1.2 0 0 1-1.6.1 1 1 0 0 1 0-1.5m-2.2-4.5-1.6-.3-.3-4.3 1.7-.6v2.5c0 1 0 1.8.2 2.7m1.4-5.3 1.7.4v2.2c0-.8.3 2.1.3 2.1l-1.7.6a14 14 0 0 1-.3-2.7zm5.6 13.7a15.7 15.7 0 0 0 4.8 2.6l.4-1.6a13.7 13.7 0 0 1-4-2zm-.8 1.4a17.4 17.4 0 0 0 4.8 2.6l-1.2 1.1a18.7 18.7 0 0 1-4-2zm2.2-9.4 1.6.7 3-3.3-1-1.4zm-1.3-1-1-1.4 3-3.3 1.6.7zm18.1 9.9.8 1.4a16.7 16.7 0 0 0 3.6-3.1c.9.2 1.8 0 2.5-.5a2.4 2.4 0 0 0 .3-3.5l-.1-.1a15 15 0 0 0 1.3-4.8h-1.7a13.3 13.3 0 0 1-1 4 3 3 0 0 0-1.4.2l-4.1-4.5-1.3 1 4.1 4.5a2.4 2.4 0 0 0 .1 2.8 15 15 0 0 1-3.1 2.6m6-4.8a1.2 1.2 0 0 0-1.5 0 1 1 0 0 0-.1 1.4 1.2 1.2 0 0 0 1.6.1 1 1 0 0 0 0-1.5m2.2-4.5 1.6-.3.3-4.3-1.7-.6v2.5c0 1 0 1.9-.2 2.8zm-1.4-5.3-1.7.4v2.2c0-.8-.3 2.1-.3 2.1l1.7.6.3-2.7zm-5.6 13.7a15.7 15.7 0 0 1-4.8 2.6l-.4-1.6a13.7 13.7 0 0 0 4-2zm.8 1.4a17.4 17.4 0 0 1-4.8 2.6l1.2 1.1a18.6 18.6 0 0 0 4-2zm-2.2-9.4-1.6.7-2.9-3.3 1-1.4zm1.3-1 1-1.4-3-3.3-1.6.7zm-20.1-8.7.5 1.6h4.5l.5-1.6zm21.1 0-.5 1.6h-4.5l-.5-1.6zm-11.6 21.9c0-.6.5-1 1.1-1a1 1 0 0 1 1.1 1c0 .6-.5 1-1 1a1.1 1.1 0 0 1-1.2-1m1.9-7.8 1.7-.4v-4.3l-1.7-.5zm-1.6 0-1.7-.4v-4.3l1.7-.5z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M211.5 294.2c.2-1 1-1.6 1.8-2V287h1.6v5.3c.8.3 1.5.9 1.7 1.6h4.4v.3h-6a1.2 1.2 0 0 0-1-.6c-.4 0-.7.3-1 .6zm12.2 0v-.3h4.1a2.4 2.4 0 0 1 .2-.3l-5-5.7 1.2-1 5 5.6.2-.1V285h1.6v7.3h.3l4.9-5.5 1.2 1-4.9 5.5.3.6h4v.3zm21.6 0a1.1 1.1 0 0 1 1-.6c.5 0 .8.3 1 .6h1.6c-.2-1-.9-1.6-1.8-2V287h-1.6v5.3c-.8.3-1.4.8-1.7 1.6h-4.4v.3zm-30.2-15 6 6.8 1.3-1-6.1-6.7.3-.6h4.4V276h-4.4a2.6 2.6 0 0 0-2.5-1.7 2.6 2.6 0 0 0-2.7 2.5 2.5 2.5 0 0 0 1.8 2.4v5.2h1.6v-5.2zm32 0v5.3h-1.7v-5.2a2.5 2.5 0 0 1-.4-.2l-6 6.8-1.3-1 6.2-6.9-.1-.3h-4.5V276h4.5a2.6 2.6 0 0 1 2.4-1.7 2.6 2.6 0 0 1 2.7 2.5 2.5 2.5 0 0 1-1.9 2.4zm-16.1 0v3.3h-1.7v-3.2a2.6 2.6 0 0 1-1.7-1.6h-4V276h4a2.6 2.6 0 0 1 2.5-1.7c1.2 0 2.2.7 2.5 1.7h4v1.6h-4a2.5 2.5 0 0 1-1.6 1.6m-17.8 4-1.7.4v4.3l1.7.5zm1.6 0 1.7.4v4.3l-1.7.5zm30.6 0-1.7.4v4.3l1.7.5zm1.6 0 1.7.4v4.3l-1.7.5zm-25.5.8 1.6-.7 2.9 3.3-1 1.4zm-1.3 1-1 1.4 3 3.3 1.6-.7zm18.5-1.1-1.6-.7-3 3.3 1 1.4zm1.2 1 1 1.4-3 3.3-1.5-.7zm-20.3 9 .5-1.6h4.5l.5 1.6zm-6.7-17c0-.6.5-1 1.2-1a1 1 0 0 1 1 1c0 .6-.4 1-1 1a1.1 1.1 0 0 1-1.2-1m12.1.8-.5 1.6H220l-.5-1.6zm0-1.6-.5-1.6H220l-.5 1.6zm15.7 17.8-.5-1.6h-4.5l-.5 1.6zm4.4-17c0-.6.5-1 1.1-1a1 1 0 0 1 1.1 1c0 .6-.5 1-1 1a1.1 1.1 0 0 1-1.2-1m-16.1 0c0-.6.5-1 1.1-1a1 1 0 0 1 1.1 1c0 .6-.5 1-1.1 1a1.1 1.1 0 0 1-1.1-1m6.2.8.5 1.6h4.6l.5-1.6zm0-1.6.5-1.6h4.6l.5 1.6zm-5.9 5-1.7.5v4.3l1.7.5V281m1.7 0 1.6.5v4.3l-1.6.5z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#c8b100",
      strokeWidth: 0.3,
      d: "M232.7 316.3a15.6 15.6 0 0 0 3.7-1.1l.8 1.4a17.6 17.6 0 0 1-4.3 1.2 2.6 2.6 0 0 1-2.6 2 2.6 2.6 0 0 1-2.5-2 17.5 17.5 0 0 1-4.6-1.2l.8-1.4c1.3.5 2.6.9 4 1a2.5 2.5 0 0 1 1.5-1.3v-6.7h1.6v6.7c.7.2 1.3.7 1.6 1.4zm-4.7-20.4a2.3 2.3 0 0 1-.2-.5h-4V294h4a2.6 2.6 0 0 1 .2-.4l-5-5.6 1.2-1 5 5.5a2.2 2.2 0 0 1 .2 0V285h1.7v7.3h.2l4.9-5.5 1.2 1-4.9 5.5.3.6h4v1.5h-4c0 .2-.2.4-.3.5l4.7 5.3-1.3 1-4.6-5.3-.2.1v8.7h-1.6V297l-.2-.1-4.8 5.3-1.2-1 4.7-5.3m-12.8-16.7 6 6.8 1.3-1-6.1-6.7.3-.6h4.4V276h-4.4a2.6 2.6 0 0 0-2.5-1.7 2.6 2.6 0 0 0-2.6 2.5 2.5 2.5 0 0 0 1.7 2.4v5.2h1.6v-5.2zm6.5 34.8-.8 1.4a16.6 16.6 0 0 1-3.6-3.1c-.9.2-1.8 0-2.5-.5a2.4 2.4 0 0 1-.3-3.5l.1-.1a15.3 15.3 0 0 1-1.2-4.8h1.6a13.1 13.1 0 0 0 1 4c.5 0 1 0 1.4.2l4.1-4.5 1.3 1-4.1 4.5c.6.9.5 2-.1 2.8a15.2 15.2 0 0 0 3.1 2.6zm-8.4-13.1V297a2.5 2.5 0 0 1-1.8-2.4c0-1 .8-2 1.8-2.4V287h1.6v5.3c.8.2 1.5.8 1.7 1.6h4.4v1.5h-4.4a2.6 2.6 0 0 1-1.6 1.6v3.9h-1.7m2.3 8.3c.4-.4 1.1-.5 1.6 0s.5 1 .1 1.4a1.2 1.2 0 0 1-1.6.1 1 1 0 0 1 0-1.5zm-2-4.5-1.7-.3-.3-4.3 1.7-.6v2.5c0 1 0 1.8.3 2.7zm1.4-5.3 1.6.4v2.2c0-.8.3 2.1.3 2.1l-1.7.6-.3-2.7v-2.6zm5.5 13.7a15.7 15.7 0 0 0 4.8 2.6l.4-1.6a13.7 13.7 0 0 1-4-2l-1.2 1m-.8 1.4a17.4 17.4 0 0 0 4.8 2.6l-1.2 1.1a18.7 18.7 0 0 1-4-2l.4-1.7"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#c8b100",
      strokeWidth: 0.3,
      d: "m221.9 305.1 1.6.7 3-3.3-1-1.4-3.6 4m-1.3-1-1-1.4 3-3.3 1.6.7-3.6 4m-7.6-9.5c0-.6.5-1 1-1 .7 0 1.2.5 1.2 1 0 .6-.5 1.1-1.1 1.1a1 1 0 0 1-1.1-1zm25.7 19.4.8 1.4a16.7 16.7 0 0 0 3.6-3.1c.9.2 1.8 0 2.6-.5a2.4 2.4 0 0 0 .2-3.5l-.1-.1a15 15 0 0 0 1.3-4.8h-1.7a13.3 13.3 0 0 1-1 4 3 3 0 0 0-1.4.2l-4.1-4.5-1.3 1 4.1 4.5a2.4 2.4 0 0 0 .1 2.8 15 15 0 0 1-3 2.6zm8.4-13.1V297a2.5 2.5 0 0 0 1.8-2.4c0-1-.7-2-1.8-2.4V287h-1.6v5.3c-.8.2-1.4.8-1.7 1.6h-4.4v1.5h4.4c.3.8.9 1.3 1.7 1.6v3.9zm-2.3 8.3a1.2 1.2 0 0 0-1.6 0 1 1 0 0 0-.1 1.4 1.2 1.2 0 0 0 1.6.1 1 1 0 0 0 0-1.5zm2-4.5 1.7-.3.3-4.3-1.7-.6v2.5c0 1 0 1.8-.2 2.7zm-1.3-5.3-1.7.4v2.2c0-.8-.3 2.1-.3 2.1l1.7.6.3-2.7v-2.6m1.6-20.1v5.2h-1.6v-5.2a2.3 2.3 0 0 1-.4-.2l-6 6.8-1.2-1 6-7v-.2h-4.5V276h4.4a2.6 2.6 0 0 1 2.5-1.7 2.6 2.6 0 0 1 2.6 2.5 2.5 2.5 0 0 1-1.8 2.4zm-16 0v3.2h-1.7v-3.2a2.6 2.6 0 0 1-1.7-1.6h-4V276h4c.4-1 1.3-1.7 2.5-1.7s2.2.7 2.5 1.7h4v1.6h-4a2.5 2.5 0 0 1-1.6 1.6zm8.8 33.8a15.7 15.7 0 0 1-4.8 2.6l-.4-1.6a13.7 13.7 0 0 0 4-2l1.2 1m.8 1.4a17.4 17.4 0 0 1-4.8 2.6l1.2 1.1a18.7 18.7 0 0 0 4-2l-.4-1.7m-27.4-31.4-1.7.5v4.3l1.7.5v-5.2m1.7 0 1.6.4v4.3l-1.6.5V283m30.5 0-1.7.5v4.3l1.7.5V283"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#c8b100",
      strokeWidth: 0.3,
      d: "m247.1 283.1 1.7.5v4.3l-1.7.5V283m-8.6 22-1.6.7-2.9-3.3 1-1.4 3.5 4m1.3-1 1-1.4-3-3.3-1.6.7 3.6 4m-18.2-20 1.6-.7 3 3.3-1 1.4-3.6-4m-1.3 1-1 1.4 3 3.3 1.6-.7-3.6-4m18.5-1.1-1.6-.7-3 3.3 1 1.4 3.6-4m1.2 1 1 1.4-3 3.2-1.5-.6 3.5-4m-20.3 9 .5-1.6h4.5l.5 1.6h-5.5m0 1.5.5 1.6h4.5l.5-1.6h-5.5M213 277c0-.6.5-1 1.2-1 .6 0 1 .4 1 1s-.4 1-1 1a1 1 0 0 1-1.2-1zm12.1.8-.5 1.6h-4.5l-.5-1.6h5.5m0-1.6-.5-1.6h-4.5l-.5 1.6h5.5m20.1 18.5c0-.5.5-1 1.1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1.1-1 1.1a1 1 0 0 1-1.2-1zm-4.4-.7-.5-1.6h-4.5l-.5 1.6h5.5m0 1.5-.5 1.6h-4.5l-.5-1.6h5.5m-11.6 21.9c0-.6.5-1 1.1-1 .6 0 1.1.4 1.1 1s-.5 1-1 1a1.1 1.1 0 0 1-1.2-1zm1.9-7.8 1.7-.4v-4.3l-1.7-.5v5.2m-1.6 0-1.7-.4v-4.3l1.7-.5v5.2m15.7-32.6c0-.6.5-1 1.1-1a1 1 0 0 1 1.1 1c0 .6-.5 1-1 1a1.1 1.1 0 0 1-1.2-1zm-16.1 0c0-.6.5-1 1.1-1a1 1 0 0 1 1.1 1c0 .6-.5 1-1 1a1.1 1.1 0 0 1-1.2-1zm6.2.8.5 1.6h4.6l.5-1.6h-5.5m0-1.6.4-1.6h4.6l.5 1.6h-5.5m-6 5-1.6.5v4.3l1.6.5V281m1.7 0 1.6.5v4.3l-1.6.5V281"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#058e6e",
      d: "M227.7 294.7a2.6 2.6 0 0 1 2.6-2.5 2.6 2.6 0 0 1 2.6 2.5 2.6 2.6 0 0 1-2.6 2.4c-1.4 0-2.6-1-2.6-2.4"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#db4446",
      d: "M230.9 229.7v-.6l.1-.3-2.3-.1a5.9 5.9 0 0 1-2.3-1.2c-.8-.7-1.1-1-1.6-1.2-1.3-.2-2.3.4-2.3.4s1 .4 1.7 1.3 1.5 1.3 1.8 1.4c.6.2 2.6 0 3.1.1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M230.9 229.7v-.6l.1-.3-2.3-.1a5.9 5.9 0 0 1-2.3-1.2c-.8-.7-1.1-1-1.6-1.2-1.3-.2-2.3.4-2.3.4s1 .4 1.7 1.3 1.5 1.3 1.8 1.4c.6.2 2.6 0 3.1.1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ed72aa",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M238.1 227.5v1.4c.2.6-.1 1.2 0 1.5 0 .4.1.6.3.9l.2.9-.7-.5-.6-.4v1c.1.2.3.8.6 1.1l1 1.3c.2.5.1 1.4.1 1.4s-.4-.7-.8-.8l-1.2-.7s.7.8.7 1.5c0 .8-.3 1.6-.3 1.6s-.3-.7-.8-1.1l-1-.9s.4 1.2.4 2v2.3l-.9-1-1-.7c0-.2.5.6.6 1.1 0 .5.3 2.3 1.8 4.5 1 1.3 2.3 3.6 5.3 2.9 3-.8 1.9-4.8 1.3-6.7a16.8 16.8 0 0 1-1-4.6c0-.8.6-2.9.5-3.3a8 8 0 0 1 .2-3.1c.4-1.3.7-1.8.9-2.3.2-.6.4-.9.4-1.3l.1-1.3.7 1.3.1 1.5s.1-1 1-1.6c.8-.6 1.8-1.1 2-1.4.3-.3.3-.5.3-.5s0 1.8-.6 2.6l-1.7 2s.7-.3 1.2-.3h.9s-.6.4-1.4 1.6c-.8 1-.5 1.2-1 2.1-.6 1-1 1-1.7 1.5-1 .8-.5 4.2-.4 4.7.2.5 2 4.5 2 5.5s.2 3.2-1.5 4.6c-1.1 1-3 1-3.4 1.2-.4.3-1.2 1.1-1.2 2.8 0 1.7.6 2 1 2.4.6.5 1.2.2 1.3.6.2.3.2.5.5.7.2.2.3.4.2.8 0 .3-.8 1.1-1.1 1.7l-.8 2.4c0 .2-.1 1 .1 1.3 0 0 .9 1 .3 1.2-.4.2-.8-.2-1-.2l-.9.5c-.3-.1-.3-.3-.4-.8l-.1-.7c-.2 0-.3.2-.4.5 0 .2 0 .8-.3.8-.2 0-.5-.4-.8-.5-.2 0-.8-.2-.8-.4 0-.3.4-.9.7-1 .4 0 .8-.3.5-.5s-.5-.2-.7 0-.8 0-.7-.2v-.8c0-.2-.4-.5.1-.8.6-.3.8.2 1.4.1.6 0 .8-.3 1-.6.2-.3.2-1-.2-1.4-.4-.5-.7-.5-.9-.8l-.3-.9v2.2l-.7-.8c-.3-.3-.6-1.3-.6-1.3v1.3c0 .4.3.7.2.8-.1.1-.8-.7-1-.8a3.7 3.7 0 0 1-1-1l-.4-1.4a4.2 4.2 0 0 1 0-1.5l.4-1h-1.4c-.7 0-1.2-.3-1.5.2-.3.5-.2 1.5.2 2.8.3 1.2.5 1.9.4 2.1a3 3 0 0 1-.7.8h-.9a2.5 2.5 0 0 0-1.2-.3h-1.3l-1.1-.3c-.3.1-.8.3-.6.7.2.6-.2.7-.5.7l-.9-.2c-.4-.1-.9 0-.8-.4 0-.4.2-.4.4-.7.2-.3.2-.5 0-.5h-.6c-.2.2-.5.5-.8.4-.2-.1-.4-.4-.4-1s-.7-1.2 0-1.1c.5 0 1.3.4 1.4 0 .2-.3 0-.4-.2-.7s-.8-.4-.3-.7l.7-.5c.1-.2.4-.8.7-.6.6.2 0 .7.6 1.3.6.7 1 1 2 .8 1 0 1.3-.2 1.3-.5l-.1-1v-1s-.4.3-.5.6l-.4.8v-2a8 8 0 0 0-.2-.8l-.3.9-.1 1s-.7-.5-.5-1.5c.1-.7-.1-1.6.1-2 .2-.3.7-1.5 2-1.6h2.6l2-.3s-2.8-1.4-3.5-1.9a9.5 9.5 0 0 1-2-2l-.6-1.6s-.5 0-1 .3a5 5 0 0 0-1.2 1l-.7 1 .1-1.2v-.8s-.4 1.2-1 1.7l-1.4 1v-.8l.2-1s-.4.8-1.1 1c-.7 0-1.8 0-1.9.4 0 .5.2 1 0 1.4 0 .3-.4.5-.4.5l-.8-.4c-.4 0-.7.2-.7.2s-.3-.4-.2-.7c.1-.2.7-.6.5-.8l-.8.2c-.3.1-.8.3-.8-.2 0-.4.2-.7 0-1 0-.3 0-.5.2-.6l1.2-.1c0-.2-.2-.5-.8-.6-.6-.1-.8-.5-.5-.8.3-.2.3-.3.5-.6.1-.2.2-.7.7-.5.5.3.4.8 1 1a4 4 0 0 0 2-.2l1.5-1 1.5-1-1-.8c-.3-.3-.7-.9-1-1a8.3 8.3 0 0 0-1.8-.6 9 9 0 0 1-1.7-.5l.8-.3c.2-.2.6-.6.8-.6h.3-1.4c-.3-.1-1-.6-1.3-.6l-.8.1s.8-.4 1.4-.5l1-.1s-.9-.3-1.1-.6l-.6-1c-.2-.1-.3-.5-.6-.5l-1 .3c-.4 0-.6-.2-.6-.6l-.1-.5c-.2-.3-.6-.8-.2-1h1.4c0-.2-.5-.6-.8-.8-.4-.2-1-.5-.7-.8l.8-.5c.2-.3.3-1 .7-.7.4.2.8 1.2 1.1 1.1.3 0 .3-.8.3-1 0-.4 0-1 .2-.9.3 0 .5.4 1 .5.4 0 1-.1 1 .2 0 .3-.3.7-.6 1-.3.3-.4 1-.3 1.4.2.5.7 1.2 1.2 1.4.4.3 1.2.5 1.7.9.5.3 1.7 1.2 2.1 1.3l.8.4s.5-.2 1.1-.2c.7 0 2.1 0 2.6-.2.6-.2 1.3-.6 1-1-.1-.6-1.3-1-1.2-1.4 0-.4.5-.4 1.2-.4.8 0 1.8.1 2-1 .2-1 .2-1.5-.8-1.8-1-.2-1.8-.2-2-1-.2-.7-.4-.9-.2-1.1.3-.2.6-.3 1.4-.4.8 0 1.6 0 1.9-.2.2-.2.3-.7.6-.9.3-.2 1.4-.4 1.4-.4s1.4.7 2.7 1.7a15 15 0 0 1 2.2 2.1"
    }),
    /* @__PURE__ */ jsx140("path", {
      d: "m228.1 226.8-.2-.6v-.3s.8 0 .7.3c0 .2-.2.2-.3.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m228.1 226.8-.2-.6v-.3s.8 0 .7.3c0 .2-.2.2-.3.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      d: "M232 225.4v-.4s.7 0 1 .3c.5.4.9 1 .9 1l-.8-.4h-.5l-.3-.1v-.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M232 225.4v-.4s.7 0 1 .3c.5.4.9 1 .9 1l-.8-.4h-.5l-.3-.1v-.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m237.3 231.3-.4-.7a8 8 0 0 1-.3-.4"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#db4446",
      d: "M217.4 226.6s.5.4.8.4h.8s.2-.5.1-.8c-.2-1.2-1.2-1.4-1.2-1.4s.3.7.1 1a2 2 0 0 1-.6.8"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M217.4 226.6s.5.4.8.4h.8s.2-.5.1-.8c-.2-1.2-1.2-1.4-1.2-1.4s.3.7.1 1a2 2 0 0 1-.6.8z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#db4446",
      d: "M215.2 227.6s-.4-.7-1.3-.6c-.8 0-1.4.8-1.4.8h1.2c.3.3.4 1 .4 1l.7-.6a7.2 7.2 0 0 0 .4-.6"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M215.2 227.6s-.4-.7-1.3-.6c-.8 0-1.4.8-1.4.8h1.2c.3.3.4 1 .4 1l.7-.6a7.2 7.2 0 0 0 .4-.6z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#db4446",
      d: "M214.2 230.6s-.8.1-1.2.6c-.4.5-.3 1.3-.3 1.3s.4-.5.9-.5l1 .2-.1-.8z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M214.2 230.6s-.8.1-1.2.6c-.4.5-.3 1.3-.3 1.3s.4-.5.9-.5l1 .2-.1-.8z"
    }),
    /* @__PURE__ */ jsx140("path", {
      d: "m228.2 230.5.3-.5.3.5z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m228.2 230.5.3-.5.3.5h-.7"
    }),
    /* @__PURE__ */ jsx140("path", {
      d: "m229 230.5.3-.5.4.5z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m229 230.5.3-.5.4.5h-.8"
    }),
    /* @__PURE__ */ jsx140("path", {
      d: "m228.6 227.3.8.3-.7.4-.1-.6"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m228.6 227.3.8.3-.7.4-.1-.6"
    }),
    /* @__PURE__ */ jsx140("path", {
      d: "m229.5 227.6.7.2-.5.4z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m229.5 227.6.7.2-.5.4-.2-.6"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M224.2 233.7s-.7.2-1 .6c-.4.5-.3 1-.3 1s.6-.5 1.5-.3l1.2.3 1.3-.3s-.7.8-.7 1.3l.2 1.1c0 .7-.6 1.6-.6 1.6l1-.3a4.6 4.6 0 0 0 1.7-.8l.9-1s-.2 1 0 1.4l.2 1.6.8-.6c.2-.1.7-.4.9-.7l.3-1s0 .8.4 1.3l.6 1.6s.3-.8.6-1.1c.3-.4.7-.8.7-1a4.3 4.3 0 0 0-.1-.9l.4.8m-11 .6s.5-.8 1-1l1.1-.8.9-.4m1 5 1.3-.8a4 4 0 0 0 1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#db4446",
      d: "M216.6 240.4s-.4-.5-1.1-.3c-.7 0-1.2.9-1.2.9s.6-.2 1-.1.6.4.6.4l.4-.4z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M216.6 240.4s-.4-.5-1.1-.3c-.7 0-1.2.9-1.2.9s.6-.2 1-.1.6.4.6.4l.4-.4z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#db4446",
      d: "M215.8 243.2s-.6 0-1.1.3c-.5.4-.5 1.2-.5 1.2s.4-.4.8-.3l.9.2v-.6c.2-.4-.1-.8-.1-.8"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M215.8 243.2s-.6 0-1.1.3c-.5.4-.5 1.2-.5 1.2s.4-.4.8-.3l.9.2v-.6c.2-.4-.1-.8-.1-.8z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#db4446",
      d: "M217.2 245.8s0 .8.3 1.3c.4.5 1.1.5 1.1.5l-.3-.7c0-.4.3-.8.3-.8s-.3-.3-.7-.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M217.2 245.8s0 .8.3 1.3c.4.5 1.1.5 1.1.5l-.3-.7c0-.4.3-.8.3-.8s-.3-.3-.7-.3zm16 1.3s2 1.2 1.9 2.2c0 1-1 2.3-1 2.3"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#db4446",
      d: "M224.2 252.6s-.4-.6-1.1-.6c-.7 0-1.4.7-1.4.7s.8-.1 1 .2l.5.6.5-.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M224.2 252.6s-.4-.6-1.1-.6c-.7 0-1.4.7-1.4.7s.8-.1 1 .2l.5.6.5-.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#db4446",
      d: "M222.2 255.3s-1-.1-1.4.3c-.4.5-.4 1.3-.4 1.3s.6-.6 1-.5c.5 0 1 .3 1 .3v-.7l-.3-.7"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M222.2 255.3s-1-.1-1.4.3c-.4.5-.4 1.3-.4 1.3s.6-.6 1-.5c.5 0 1 .3 1 .3v-.7l-.3-.7z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#db4446",
      d: "M224 258.1s-.3.7 0 1.1c.3.5 1 .8 1 .8s-.3-.4-.2-.8c.1-.3.7-.8.7-.8l-1.4-.2"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M224 258.1s-.3.7 0 1.1c.3.5 1 .8 1 .8s-.3-.4-.2-.8c.1-.3.7-.8.7-.8l-1.4-.2z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#db4446",
      d: "M236 259.3s-.8-.2-1.2 0c-.5.3-.8 1.4-.8 1.4s.7-.6 1.2-.5c.5 0 1 .3 1 .3v-.8z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M236 259.3s-.8-.2-1.2 0c-.5.3-.8 1.4-.8 1.4s.7-.6 1.2-.5c.5 0 1 .3 1 .3v-.8z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#db4446",
      d: "M236.4 262.2s-.6.6-.4 1.1l.6 1s0-.7.2-1l1-.3-.7-.5a15.8 15.8 0 0 1-.7-.3"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M236.4 262.2s-.6.6-.4 1.1l.6 1s0-.7.2-1l1-.3-.7-.5a15.8 15.8 0 0 1-.7-.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#db4446",
      d: "M239.4 263s-.3.8.2 1.3c.6.5 1 .5 1 .5s-.3-.7-.2-1.1c.1-.5.5-.7.5-.7l-.8-.2-.7.3"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M239.4 263s-.3.8.2 1.3c.6.5 1 .5 1 .5s-.3-.7-.2-1.1c.1-.5.5-.7.5-.7l-.8-.2-.7.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ffd691",
      stroke: "#000",
      strokeWidth: 0.5,
      d: "M208.8 316.4c2 .6 3 2 3 3.8 0 2.3-2.2 4-5 4-3 0-5.3-1.7-5.3-4 0-1.7 1-3.6 3-3.8l-.2-.4-.7-.7h1.2l.8.5.5-.7c.3-.4.6-.5.6-.5l.6.6.3.5.7-.4.8-.3s0 .4-.2.7l-.1.7"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#058e6e",
      stroke: "#000",
      strokeWidth: 0.5,
      d: "M206.3 326.7s-3.8-2.6-5.5-3c-2-.4-4.5 0-5.5 0 0 0 1.2.8 1.8 1.4.5.5 2.3 1.5 3.3 1.8 3 .8 6-.2 6-.2m1 .2s2.4-2.5 5-2.9c3-.4 5 .3 6.2.6l-1.5.8c-.5.3-2 1.5-4 1.6-2 0-4.4-.3-4.8-.2l-.9.1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ad1519",
      stroke: "#000",
      strokeWidth: 0.5,
      d: "M206.7 323.8a4.8 4.8 0 0 1 0-7.1 4.8 4.8 0 0 1 1.5 3.5 4.9 4.9 0 0 1-1.5 3.6"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#058e6e",
      stroke: "#000",
      strokeWidth: 0.5,
      d: "M205.7 329s.6-1.5.6-2.7l-.1-2.1h.8s.3 1.1.3 2l-.1 2.4-.7.1-.8.3"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M254 190.7c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M254 190.7c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M255.4 188.2c0-.6.5-1 1.1-1 .6 0 1 .4 1 1s-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M255.4 188.2c0-.6.5-1 1.1-1 .6 0 1 .4 1 1s-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M256.4 185.2c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 0 1-1.1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M256.4 185.2c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 0 1-1.1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M256.5 182c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M256.5 182c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M255.7 179c0-.6.5-1 1-1 .7 0 1.2.4 1.2 1s-.5 1-1.1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M255.7 179c0-.6.5-1 1-1 .7 0 1.2.4 1.2 1s-.5 1-1.1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M254.1 176.1c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M254.1 176.1c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M252 173.8c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M252 173.8c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M249.4 171.8c0-.5.5-1 1.1-1a1 1 0 0 1 0 2c-.6 0-1-.4-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M249.4 171.8c0-.5.5-1 1.1-1a1 1 0 0 1 0 2c-.6 0-1-.4-1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M246.5 170.3c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M246.5 170.3c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M243.3 169.1c0-.5.5-1 1.1-1a1 1 0 0 1 0 2 1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M243.3 169.1c0-.5.5-1 1.1-1a1 1 0 0 1 0 2 1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M239.9 168.5c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M239.9 168.5c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M236.6 168.3c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M236.6 168.3c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M233.3 168.5c0-.6.5-1 1-1 .7 0 1.1.4 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M233.3 168.5c0-.6.5-1 1-1 .7 0 1.1.4 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M230.1 168.5c0-.6.5-1 1-1 .6 0 1.1.4 1.1 1s-.5 1-1 1a1 1 0 0 1-1.1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M230.1 168.5c0-.6.5-1 1-1 .6 0 1.1.4 1.1 1s-.5 1-1 1a1 1 0 0 1-1.1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M231.7 171.2c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1m.6 3.1c0-.6.4-1 1-1s1 .4 1 1c0 .5-.4 1-1 1a1 1 0 0 1-1-1m0 3c0-.5.6-1 1.1-1a1 1 0 0 1 0 2 1 1 0 0 1-1-1m-1 2.8c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1 0 .6-.4 1-1 1a1 1 0 0 1-1-1m-1.9 2.6c0-.5.5-1 1-1 .7 0 1.2.5 1.2 1s-.5 1-1.1 1c-.6 0-1-.4-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M227.6 166.5c0-.5.5-1 1.1-1a1 1 0 0 1 0 2 1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M227.6 166.5c0-.5.5-1 1.1-1a1 1 0 0 1 0 2 1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M224.8 165c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M224.8 165c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M221.6 164c0-.6.5-1 1-1 .6 0 1.1.4 1.1 1 0 .5-.5 1-1 1-.6 0-1.1-.5-1.1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M221.6 164c0-.6.5-1 1-1 .6 0 1.1.4 1.1 1 0 .5-.5 1-1 1-.6 0-1.1-.5-1.1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M218.3 163.4c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 0 1-1.1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M218.3 163.4c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 0 1-1.1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M215 163.5c0-.6.5-1 1.1-1 .6 0 1 .4 1 1 0 .5-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M215 163.5c0-.6.5-1 1.1-1 .6 0 1 .4 1 1 0 .5-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M211.7 164c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M211.7 164c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M208.6 165.1c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 0 1-1.1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M208.6 165.1c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 0 1-1.1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M156 190.7c0-.5.4-1 1-1s1 .5 1 1c0 .6-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M156 190.7c0-.5.4-1 1-1s1 .5 1 1c0 .6-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M154.5 188.2c0-.6.5-1 1-1 .6 0 1 .4 1 1s-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M154.5 188.2c0-.6.5-1 1-1 .6 0 1 .4 1 1s-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M153.5 185.2c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M153.5 185.2c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M153.4 182c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M153.4 182c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M154.2 179c0-.6.5-1 1-1 .6 0 1 .4 1 1s-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M154.2 179c0-.6.5-1 1-1 .6 0 1 .4 1 1s-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M155.8 176.1c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M155.8 176.1c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1s-.5 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M158 173.8c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M158 173.8c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M160.5 171.8c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M160.5 171.8c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M163.5 170.3c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M163.5 170.3c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M166.6 169.1c0-.5.5-1 1-1a1 1 0 0 1 0 2 1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M166.6 169.1c0-.5.5-1 1-1a1 1 0 0 1 0 2 1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M170 168.5c0-.5.5-1 1.1-1a1 1 0 0 1 0 2c-.6 0-1-.4-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M170 168.5c0-.5.5-1 1.1-1a1 1 0 0 1 0 2c-.6 0-1-.4-1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M173.4 168.3c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M173.4 168.3c0-.5.4-1 1-1s1 .5 1 1-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M176.6 168.5c0-.6.5-1 1-1 .6 0 1.1.4 1.1 1s-.5 1-1 1a1 1 0 0 1-1.1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M176.6 168.5c0-.6.5-1 1-1 .6 0 1.1.4 1.1 1s-.5 1-1 1a1 1 0 0 1-1.1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M179.8 168.5c0-.6.5-1 1-1 .7 0 1.2.4 1.2 1s-.5 1-1.1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M179.8 168.5c0-.6.5-1 1-1 .7 0 1.2.4 1.2 1s-.5 1-1.1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M178.2 171.2c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1m-.7 3.1c0-.6.4-1 1-1s1 .4 1 1c0 .5-.4 1-1 1a1 1 0 0 1-1-1m-.2 3c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1m.9 2.8c0-.5.5-1 1-1 .6 0 1.1.5 1.1 1 0 .6-.5 1-1 1a1 1 0 0 1-1.1-1m1.8 2.6c0-.5.5-1 1-1a1 1 0 0 1 0 2 1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M182.3 166.5c0-.5.5-1 1-1a1 1 0 0 1 0 2 1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M182.3 166.5c0-.5.5-1 1-1a1 1 0 0 1 0 2 1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M185.2 165c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M185.2 165c0-.6.4-1 1-1s1 .4 1 1-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M188.3 164c0-.6.5-1 1-1 .7 0 1.1.4 1.1 1 0 .5-.4 1-1 1s-1-.5-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M188.3 164c0-.6.5-1 1-1 .7 0 1.1.4 1.1 1 0 .5-.4 1-1 1s-1-.5-1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M191.6 163.4c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M191.6 163.4c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M194.9 163.5c0-.6.4-1 1-1s1 .4 1 1c0 .5-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M194.9 163.5c0-.6.4-1 1-1s1 .4 1 1c0 .5-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M198.2 164c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M198.2 164c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#fff",
      d: "M201.3 165.1c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M201.3 165.1c0-.5.5-1 1-1 .7 0 1.1.5 1.1 1s-.4 1-1 1a1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M174.7 228.9h-1v-1h-1.5v3.6h1.6v2.5h-3.4v7h1.8v14.3h-3.5v7.3h27.2v-7.3h-3.5V241h1.8v-7h-3.4v-2.5h1.6V228h-1.6v.9h-.8v-1h-1.6v1h-1.1v-1h-1.6v3.6h1.6v2.5H184v-7.8h1.7v-3.5H184v.9h-1v-1h-1.5v1h-.9v-1H179v3.6h1.7v7.8h-3.3v-2.5h1.6V228h-1.6v.9h-.9v-1h-1.8zm-6 33.7H196m-27.3-1.8H196m-27.3-1.8H196m-27.3-1.7H196m-27.3-2H196m-23.8-1.6h20.2m-20.2-1.8h20.2m-20.2-2h20.2m-20.2-1.7h20.2m-20.2-1.8h20.2m-20.2-1.8h20.2m-20.2-1.7h20.2m-22-1.8h23.8m-23.8-1.8h23.8m-23.8-1.8h23.8m-23.8-1.8h23.8m-20.4-1.7h17m-10.2-1.8h3.4m-3.4-1.8h3.4m-3.4-1.8h3.4m-3.4-1.7h3.4m-5.1-2.2h6.8m-12 7.5h3.6m-5-2.2h6.6m-6.7 32.6v-1.8m0-1.8v-1.7m-1.8 1.7v1.8m3.4 0V259m1.7 3.6v-1.8m0-1.8v-1.7m0-2v-1.6m0-1.8v-2m-1.7 7.4v-2m-3.4 2v-2m7 0v2m1.5-2v-1.6m-5.1-1.8v1.8m3.5-1.8v1.8m3.3-1.8v1.8M179 252v-2m1.7-1.7v1.7m0-5.3v1.8m-1.7-3.6v1.8m1.7-3.5v1.7m-3.3-1.7v1.7m-3.5-1.7v1.7m-1.6-3.5v1.8m3.3-1.8v1.8m3.4-1.8v1.8m1.7-3.6v1.8m-3.3-1.8v1.8m-3.5-1.8v1.8m-1.6-3.6v1.8m6.7-1.8v1.8m-3.4-5.3v1.8m15.3-1.8h-3.5m5-2.2h-6.6m6.7 32.6v-1.8m0-1.8v-1.7m1.8 1.7v1.8m-3.4 0V259m-1.7 3.6v-1.8m0-1.8v-1.7m0-2v-1.6m0-1.8v-2m1.7 7.4v-2m3.4 2v-2m-7 0v2m-1.5-2v-1.6m5.1-1.8v1.8m-3.5-1.8v1.8m-3.3-1.8v1.8m1.7-1.8v-2m-1.7-1.7v1.7m0-5.3v1.8m1.7-3.6v1.8m-1.7-3.5v1.7m3.3-1.7v1.7m3.5-1.7v1.7m1.6-3.5v1.8m-3.3-1.8v1.8m-3.4-1.8v1.8m-1.7-3.6v1.8m3.3-1.8v1.8m3.5-1.8v1.8m1.6-3.6v1.8m-6.7-1.8v1.8m3.4-5.3v1.8m-7 18v-2m0-5.4v-1.8m0 5.4v-1.8m0-5.3v-1.8m0-1.8v-1.7m0-3.6v-1.8m0-1.7v-1.8m-8.3 4.6h3.5m3.3-5.3h3.4m3.3 5.3h3.5"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M186.8 262.6v-4.7c0-.8-.4-3.5-4.6-3.5-4 0-4.4 2.7-4.4 3.5v4.7z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "m179.3 258.2-2.2-.3c0-.9.2-2.2.9-2.6l2 1.5c-.3.2-.7 1-.7 1.4zm6 0 2.2-.3c0-.9-.2-2.2-.9-2.6l-2 1.5c.3.2.7 1 .7 1.4zm-2.2-2.3 1-2a5.3 5.3 0 0 0-2-.4l-1.7.4 1.1 2zm-4.2-5.5v-4.9c0-1.3-1-2.4-2.5-2.4s-2.4 1-2.4 2.4v4.9zm6.8 0v-4.9c0-1.3 1-2.4 2.5-2.4s2.4 1 2.4 2.4v4.9zm-1.7-12 .4-4.4h-4.2l.2 4.4zm3.3 0-.4-4.4h4.4l-.5 4.4zm-10 0 .2-4.4h-4.2l.5 4.4z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#0039f0",
      d: "M185.3 262.6v-4c0-.7-.5-2.7-3.1-2.7-2.4 0-2.9 2-2.9 2.7v4zm-6.9-12.7v-4.2c0-1-.6-2.2-2-2.2s-2 1.1-2 2.2v4.3h4zm7.8 0v-4.2c0-1 .7-2.2 2-2.2s2 1.1 2 2.2v4.3h-4z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#ad1519",
      d: "M190.8 269.8c0-9.7 7-17.6 15.6-17.6s15.6 7.9 15.6 17.6-7 17.5-15.6 17.5-15.6-7.8-15.6-17.5"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.6,
      d: "M190.8 269.8c0-9.7 7-17.6 15.6-17.6s15.6 7.9 15.6 17.6-7 17.5-15.6 17.5-15.6-7.8-15.6-17.5z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#005bbf",
      d: "M195.4 269.7c0-7 5-12.8 11-12.8s11 5.7 11 12.8c0 7.2-5 13-11 13s-11-5.8-11-13"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.6,
      d: "M195.4 269.7c0-7 5-12.8 11-12.8s11 5.7 11 12.8c0 7.2-5 13-11 13s-11-5.8-11-13z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M201.2 260.9s-1.3 1.4-1.3 2.7a6 6 0 0 0 .6 2.4c-.2-.5-.8-.8-1.4-.8-.8 0-1.4.6-1.4 1.3l.2.8.5.9c.1-.3.5-.5 1-.5s1 .4 1 1a.9.9 0 0 1 0 .2h-1.2v1h1l-.8 1.5 1-.4.8.9.8-.9 1 .4-.7-1.5h1v-1h-1.1a.9.9 0 0 1 0-.3 1 1 0 0 1 1-1c.4 0 .7.3 1 .6l.4-1 .2-.7a1.4 1.4 0 0 0-1.4-1.3c-.7 0-1.2.3-1.4.9 0 0 .6-1.2.6-2.5s-1.4-2.7-1.4-2.7"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.3,
      d: "M201.2 260.9s-1.3 1.4-1.3 2.7a6 6 0 0 0 .6 2.4c-.2-.5-.8-.8-1.4-.8-.8 0-1.4.6-1.4 1.3l.2.8.5.9c.1-.3.5-.5 1-.5s1 .4 1 1a.9.9 0 0 1 0 .2h-1.2v1h1l-.8 1.5 1-.4.8.9.8-.9 1 .4-.7-1.5h1v-1h-1.1a.9.9 0 0 1 0-.3 1 1 0 0 1 1-1c.4 0 .7.3 1 .6l.4-1 .2-.7a1.4 1.4 0 0 0-1.4-1.3c-.7 0-1.2.3-1.4.9 0 0 .6-1.2.6-2.5s-1.4-2.7-1.4-2.7z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M199.2 269.9h4.1v-1h-4.1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M199.2 269.9h4.1v-1h-4.1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M211.4 260.9s-1.3 1.4-1.3 2.7c0 1.3.6 2.4.6 2.4-.2-.5-.7-.8-1.4-.8-.8 0-1.4.6-1.4 1.3l.2.8.5.9c.2-.3.5-.5 1-.5a1 1 0 0 1 1 1 .9.9 0 0 1 0 .2h-1.2v1h1l-.8 1.5 1-.4.8.9.8-.9 1 .4-.7-1.5h1v-1h-1.1a.8.8 0 0 1 0-.3 1 1 0 0 1 1-1c.4 0 .8.3 1 .6l.4-1 .2-.7a1.4 1.4 0 0 0-1.4-1.3c-.6 0-1.2.3-1.4.9 0 0 .6-1.2.6-2.5s-1.4-2.7-1.4-2.7"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.3,
      d: "M211.4 260.9s-1.3 1.4-1.3 2.7c0 1.3.6 2.4.6 2.4-.2-.5-.7-.8-1.4-.8-.8 0-1.4.6-1.4 1.3l.2.8.5.9c.2-.3.5-.5 1-.5a1 1 0 0 1 1 1 .9.9 0 0 1 0 .2h-1.2v1h1l-.8 1.5 1-.4.8.9.8-.9 1 .4-.7-1.5h1v-1h-1.1a.8.8 0 0 1 0-.3 1 1 0 0 1 1-1c.4 0 .8.3 1 .6l.4-1 .2-.7a1.4 1.4 0 0 0-1.4-1.3c-.6 0-1.2.3-1.4.9 0 0 .6-1.2.6-2.5s-1.4-2.7-1.4-2.7z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M209.4 269.9h4.1v-1h-4.1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M209.4 269.9h4.1v-1h-4.1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M206.3 269.6s-1.3 1.5-1.3 2.8.6 2.4.6 2.4c-.2-.5-.7-.9-1.4-.9-.8 0-1.4.6-1.4 1.4l.2.7.5 1c.1-.4.5-.6 1-.6a1 1 0 0 1 1 1 .9.9 0 0 1 0 .3h-1.2v1h1l-.8 1.5 1-.4.8.9.8-1 1 .5-.7-1.5h1v-1h-1.1a.9.9 0 0 1 0-.3 1 1 0 0 1 1-1c.4 0 .7.2.9.6l.5-1 .2-.7a1.4 1.4 0 0 0-1.4-1.4c-.7 0-1.2.4-1.4 1 0 0 .6-1.2.6-2.5s-1.4-2.7-1.4-2.7"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.3,
      d: "M206.3 269.6s-1.3 1.5-1.3 2.8.6 2.4.6 2.4c-.2-.5-.7-.9-1.4-.9-.8 0-1.4.6-1.4 1.4l.2.7.5 1c.1-.4.5-.6 1-.6a1 1 0 0 1 1 1 .9.9 0 0 1 0 .3h-1.2v1h1l-.8 1.5 1-.4.8.9.8-1 1 .5-.7-1.5h1v-1h-1.1a.9.9 0 0 1 0-.3 1 1 0 0 1 1-1c.4 0 .7.2.9.6l.5-1 .2-.7a1.4 1.4 0 0 0-1.4-1.4c-.7 0-1.2.4-1.4 1 0 0 .6-1.2.6-2.5s-1.4-2.7-1.4-2.7z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M204.3 278.6h4.1v-1h-4.1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M204.3 278.6h4.1v-1h-4.1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M237.6 223.4h-.3a1.5 1.5 0 0 1-.3.4c-.2.2-.6.2-.8 0a.5.5 0 0 1-.1-.4.5.5 0 0 1-.5 0c-.3-.1-.3-.5-.1-.7v-.5h-.3l-.1.2c-.2.3-.5.3-.7.2a.6.6 0 0 1 0-.2h-.3c-.5.2-.7-1-.7-1.2l-.2.2s.2.7.1 1.2c0 .6-.3 1.2-.3 1.2a9 9 0 0 1 2.9 1.6 9 9 0 0 1 2.2 2.3l1.2-.5c.6-.2 1.3-.2 1.3-.2l.2-.2c-.3 0-1.5.1-1.5-.4v-.2a.7.7 0 0 1-.2 0c-.2-.2-.2-.4 0-.7l.2-.1v-.3h-.3l-.2.1c-.2.3-.6.3-.8 0a.4.4 0 0 1-.1-.4.6.6 0 0 1-.5 0c-.2-.2-.3-.5 0-.8l.2-.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M237.6 223.4h-.3a1.5 1.5 0 0 1-.3.4c-.2.2-.6.2-.8 0a.5.5 0 0 1-.1-.4.5.5 0 0 1-.5 0c-.3-.1-.3-.5-.1-.7v-.5h-.3l-.1.2c-.2.3-.5.3-.7.2a.6.6 0 0 1 0-.2h-.3c-.5.2-.7-1-.7-1.2l-.2.2s.2.7.1 1.2c0 .6-.3 1.2-.3 1.2a9 9 0 0 1 2.9 1.6 9 9 0 0 1 2.2 2.3l1.2-.5c.6-.2 1.3-.2 1.3-.2l.2-.2c-.3 0-1.5.1-1.5-.4v-.2a.7.7 0 0 1-.2 0c-.2-.2-.2-.4 0-.7l.2-.1v-.3h-.3l-.2.1c-.2.3-.6.3-.8 0a.4.4 0 0 1-.1-.4.6.6 0 0 1-.5 0c-.2-.2-.3-.5 0-.8l.2-.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      d: "M235.4 224h.2v.3h-.1c-.1 0-.1-.2 0-.2"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M235.4 224h.2v.3h-.1c-.1 0-.1-.2 0-.2z"
    }),
    /* @__PURE__ */ jsx140("path", {
      d: "m236.3 224.8-.3-.2v-.2h.1l.4.3.3.2v.2h-.2z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m236.3 224.8-.3-.2v-.2h.1l.4.3.3.2v.2h-.2l-.3-.3"
    }),
    /* @__PURE__ */ jsx140("path", {
      d: "m234.6 223.7-.2-.2s-.1 0 0-.1l.3.1.3.1v.2h-.1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m234.6 223.7-.2-.2s-.1 0 0-.1l.3.1.3.1v.2h-.1l-.3-.1"
    }),
    /* @__PURE__ */ jsx140("path", {
      d: "M233.7 223h.2v.2h-.2s-.1-.1 0-.2"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M233.7 223h.2v.2h-.2s-.1-.1 0-.2z"
    }),
    /* @__PURE__ */ jsx140("path", {
      d: "M237.3 225.5v-.2h-.3l.1.2z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M237.3 225.5v-.2h-.3l.1.2z"
    }),
    /* @__PURE__ */ jsx140("path", {
      d: "m237.9 226.2.2.2h.1c.1 0 0-.1 0-.2l-.2-.2-.2-.2h-.1v.2z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "m237.9 226.2.2.2h.1c.1 0 0-.1 0-.2l-.2-.2-.2-.2h-.1v.2l.2.2"
    }),
    /* @__PURE__ */ jsx140("path", {
      d: "M238.8 227v-.3h-.3v.2h.3"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M238.8 227v-.3h-.3v.2h.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M236.2 221.1h-.6l-.1.9v.1h.2l.7-.5-.3-.5"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M236.2 221.1h-.6l-.1.9v.1h.2l.7-.5-.3-.5"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M234.6 221.6v.5l.9.1h.1v-.2l-.5-.7z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M234.6 221.6v.5l.9.1h.1v-.2l-.5-.7-.5.3"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m236.4 222.6-.4.3-.6-.7v-.1h1.1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m236.4 222.6-.4.3-.6-.7v-.1h1.1v.5"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M235.3 222a.3.3 0 0 1 .4 0 .3.3 0 0 1 0 .3.3.3 0 0 1-.3 0 .3.3 0 0 1-.1-.3"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M235.3 222a.3.3 0 0 1 .4 0 .3.3 0 0 1 0 .3.3.3 0 0 1-.3 0 .3.3 0 0 1-.1-.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m233.2 221.1-.2-.7-.4-.4s.4-.2.8.1c.4.3 0 .9 0 .9z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m233.2 221.1-.2-.7-.4-.4s.4-.2.8.1c.4.3 0 .9 0 .9z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m234.2 221.4-.4.4-.6-.6v-.2h1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m234.2 221.4-.4.4-.6-.6v-.2h1v.4"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m233.1 221 .3-.1v.3c0 .2-.1.2-.2.2z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m233.1 221 .3-.1v.3c0 .2-.1.2-.2.2z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M238.3 222.5h-.5l-.3.7v.2h.2l.8-.4z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M238.3 222.5h-.5l-.3.7v.2h.2l.8-.4-.2-.5"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M236.7 222.8v.5l.8.2h.1v-.2l-.4-.7z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M236.7 222.8v.5l.8.2h.1v-.2l-.4-.7-.5.2"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m238.4 224-.5.2-.4-.7v-.2h.1l.9.2z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m238.4 224-.5.2-.4-.7v-.2h.1l.9.2-.1.5"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M237.3 223.2h.4a.3.3 0 0 1 0 .4.3.3 0 0 1-.3 0 .3.3 0 0 1 0-.4"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M237.3 223.2h.4a.3.3 0 0 1 0 .4.3.3 0 0 1-.3 0 .3.3 0 0 1 0-.4z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m240.2 224.3.1.5-.8.3h-.2v-.2l.4-.8z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m240.2 224.3.1.5-.8.3h-.2v-.2l.4-.8.5.2"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m240 225.8-.5.1-.3-.8v-.1h.2l.8.3z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m240 225.8-.5.1-.3-.8v-.1h.2l.8.3-.1.5"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m238.6 224.3-.2.5.9.3h.1v-.1l-.3-.8z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m238.6 224.3-.2.5.9.3h.1v-.1l-.3-.8-.5.1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M239.5 225.2a.3.3 0 0 0 0-.3.3.3 0 0 0-.4 0 .3.3 0 0 0 0 .3.3.3 0 0 0 .4 0"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M239.5 225.2a.3.3 0 0 0 0-.3.3.3 0 0 0-.4 0 .3.3 0 0 0 0 .3.3.3 0 0 0 .4 0z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M240.8 227h.8l.5.3s.1-.4-.3-.7c-.3-.3-.8.2-.8.2z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M240.8 227h.8l.5.3s.1-.4-.3-.7c-.3-.3-.8.2-.8.2z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "m240.3 226.1-.3.5.8.5v-.1h.2l-.1-1z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m240.3 226.1-.3.5.8.5v-.1h.2l-.1-1-.6.1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "#c8b100",
      d: "M241 227s.1-.1 0-.2h-.3c-.2 0-.2.1-.1.2z"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M241 227s.1-.1 0-.2h-.3c-.2 0-.2.1-.1.2zm38-21.9v.6h-2.4v-.6h1v-1.3h-.7v-.5h.6v-.6h.6v.6h.6v.6h-.6v1.2h1"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      d: "M134.4 217.1v-1.2m-.4 1.2v-1.2m-.2 1.2v-1.2m-.3 1.2v-1.2"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M133.2 217.1v-1.2m-.5 1.1v-1m.2 1v-1m-.7 1v-1m.2 1v-1m-.9 1v-1m.2 1v-1m.3 1v-1m-.7 1v-1m-.3.9v-.8m-.1.8v-.8m-.5.7v-.6m.2.6v-.6m-.4.5v-.5m-.2.5v-.4m-.3.3v-.3m-.3.3v-.2"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.2,
      d: "M129.2 216.6v-.2"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      d: "M135.7 217v-1m-.5 1v-1m-.4 1.2V216m143 1.1V216m-.4 1.1V216m-.3 1.1V216m-.3 1.2V216"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.1,
      d: "M276.6 217.1V216m-.6 1v-1m.3 1v-1m-.8 1v-1m.3 1v-1m-.9 1v-1m.2 1v-1m.2 1v-1m-.6 1v-1m-.3.9v-.8m-.2.8v-.8m-.4.7v-.6m.2.6v-.6m-.5.6v-.6m-.2.5v-.4m-.3.4v-.4m-.2.3v-.2"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.2,
      d: "M272.6 216.6v-.2"
    }),
    /* @__PURE__ */ jsx140("path", {
      fill: "none",
      d: "M279.1 217v-1m-.6 1v-1m-.4 1.1V216"
    })
  ]
});
var Es_default = SvgEs;

// src/country-flag-icons/generated/Et.tsx
init_esm_shims();
import { jsx as jsx141, jsxs as jsxs116 } from "react/jsx-runtime";
var SvgEt = (props) => /* @__PURE__ */ jsxs116("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx141("defs", {
      children: /* @__PURE__ */ jsx141("clipPath", {
        id: "et_svg__a",
        children: /* @__PURE__ */ jsx141("path", {
          fillOpacity: 0.7,
          d: "M-61.3 0h682.7v512H-61.3z"
        })
      })
    }),
    /* @__PURE__ */ jsxs116("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      clipPath: "url(#et_svg__a)",
      transform: "translate(57.5) scale(.94)",
      children: [
        /* @__PURE__ */ jsx141("path", {
          fill: "#ffc621",
          d: "M-238 3.5H800v498H-238z"
        }),
        /* @__PURE__ */ jsx141("path", {
          fill: "#ef2118",
          d: "M-240 342.5H799.3V512H-240z"
        }),
        /* @__PURE__ */ jsx141("path", {
          fill: "#298c08",
          d: "M-238 0H800v180H-238z"
        }),
        /* @__PURE__ */ jsx141("circle", {
          cx: 534.2,
          cy: 353,
          r: 199.7,
          fill: "#006bc6",
          transform: "matrix(.54 0 0 .54 -25.8 74)"
        }),
        /* @__PURE__ */ jsx141("path", {
          fill: "#ffc621",
          d: "m214.3 188.2-6.5 4.5 23.5 33 6.3-4zm29.4 78-9.7-6.8 4-12.7-48.1.7-14-10.7 65.7-.7 12.2-36.9 6.6 15zm76.5-70.7-6.3-4.8-24.3 32.4 5.6 4.7zM254.8 247l3.5-11.2h13.3L256.4 190l6-16.5 20.5 62.4 38.8.5-12.2 10.7zm90.6 51.2 2.7-7.4-38.3-13.3-2.8 7zm-69.1-46.4 11.7-.1 4.1 12.6 38.8-28.5 17.6.6-53.1 38.7 11.5 37.2-14-8.4zm-19.8 102 7.9.2.3-40.5-7.4-.5zm22-80.3 3.8 11.1-10.7 8 39.4 27.7 5 16.8-53.6-38-31.5 22.7 3.5-16 44-32.3zm-103.3 13 2.3 7.5 38.7-12.2-2-7.2zm83.2-4-9.4 7.1-10.8-7.7-14.2 46-14.4 10 19.5-62.7-31.4-23 16.3-1.6z"
        })
      ]
    })
  ]
});
var Et_default = SvgEt;

// src/country-flag-icons/generated/Fi.tsx
init_esm_shims();
import { jsx as jsx142, jsxs as jsxs117 } from "react/jsx-runtime";
var SvgFi = (props) => /* @__PURE__ */ jsxs117("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx142("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx142("path", {
      fill: "#002f6c",
      d: "M0 174.5h640v131H0z"
    }),
    /* @__PURE__ */ jsx142("path", {
      fill: "#002f6c",
      d: "M175.5 0h130.9v480h-131z"
    })
  ]
});
var Fi_default = SvgFi;

// src/country-flag-icons/generated/Fj.tsx
init_esm_shims();
import { jsx as jsx143, jsxs as jsxs118 } from "react/jsx-runtime";
var SvgFj = (props) => /* @__PURE__ */ jsxs118("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx143("path", {
      fill: "#68bfe5",
      d: "M0 0v480h640V0z"
    }),
    /* @__PURE__ */ jsxs118("g", {
      strokeMiterlimit: 4.8,
      children: [
        /* @__PURE__ */ jsx143("path", {
          fill: "#fff",
          d: "M420.9 193.2v136.4c0 44.6 80.6 71 80.6 71s80.5-26.4 80.5-71V193.2z"
        }),
        /* @__PURE__ */ jsx143("path", {
          fill: "#d21034",
          d: "M490.3 241.2v61.4h-69.4v22.3h69.4v71.5l11.2 4.3 11.1-4.3V325H582v-22.4h-69.4v-61.4z"
        }),
        /* @__PURE__ */ jsx143("path", {
          fill: "#d21034",
          d: "M420.9 193.2H582V246H420.8z"
        }),
        /* @__PURE__ */ jsxs118("g", {
          strokeMiterlimit: 3,
          children: [
            /* @__PURE__ */ jsxs118("g", {
              fill: "#fff",
              stroke: "#000",
              strokeWidth: 0.8,
              transform: "translate(-96.9 97.5) scale(.66486)",
              children: [
                /* @__PURE__ */ jsx143("ellipse", {
                  cx: 798.2,
                  cy: 192.2,
                  rx: 13.6,
                  ry: 11
                }),
                /* @__PURE__ */ jsx143("ellipse", {
                  cx: 798.2,
                  cy: 186.5,
                  rx: 12.1,
                  ry: 6.1
                }),
                /* @__PURE__ */ jsx143("ellipse", {
                  cx: 798.2,
                  cy: 198.8,
                  rx: 12.1,
                  ry: 6.1
                }),
                /* @__PURE__ */ jsx143("ellipse", {
                  cx: 798.2,
                  cy: 192.2,
                  rx: 12.1,
                  ry: 6.1
                })
              ]
            }),
            /* @__PURE__ */ jsx143("path", {
              fill: "#ffd100",
              stroke: "#000",
              strokeWidth: 0.8,
              d: "m578 235.4-1.3-3.6s-3.6-1.5-3.9-3.4c-.6-5.1-2.4-7-5.2-7.8a6 6 0 0 0-4.5.5c-.8 1.2-5 1.2-7.2 1.3-2.3 0-2.4-1-2.4-1-1.7 0-2.5-1.3-2.5-1.3-1.1-2.3-2-3.2-2.6-3.5 3 0 5.2-1.3 8.6-4.8 3.6-3.8 6.2-2.4 6.2-2.4-1.8 3.6.6 3.3.6 3.3 4.8-2.5.6-8.7-.8-8.4-1.5.3-1.9-.7-1.9-.7 0 1.1-1.6 1.6-1.6 1.6 1.2-7.1-3-9-3-9-.6.6-1 1.9-1 1.9-1.2 4.3-5.1 3.6-9.5 1.5-4.4-2-16 2.2-19.7 3.7-3.7 1.5-10.4 3.7-16.4.4-6-3.4-7.5-2.8-9.9-2.1-2.3.6-6.5 1.6-8 .8a8.5 8.5 0 0 0-3.4-.9c.4-.2-.2-1.2-.2-1.2-1.9-2.5.2-4 .2-4s-3.4 1-2 6.8l.6.8s.4 1.9 1.4 2.4v.4s.9-.4 1.1.8c.3 1.2 1.6 0 2.1-1 0 0-.9 5.4 5.7 6.7 0 0-.7-.9-.5-1.4.3-.6-.8-1-.7-1.8.1-.9-1.6-1.2-.3-1.9 1.4-.6 2-1.9 5-.1 2.9 1.7 5.2 1.3 5.2 1.3s-1.8-3.6-.8-3.6 5.4 5.4 7.5 5.2c2.2-.3 6.4-2.8 8.5-1.9 0 0 .2-1 8.2-2.4 8-1.4 18-5.4 21.7-1.9 0 0 .4 2.8 2 3.5 0 0-.3 5.8-10.2 2.6l-3.6-1s-.6-1.7-19.5 3.2c0 0-1.1.4-1.9.9-.7.5-1.7-.3-5.5 1-3.7 1.5-17.7 6-26.3 4.4-1.9-.6-3.6-.3-3.7-.6 0-.3 1 .1 1 .1-.6-.7-.9-.8-.9-.8-7.2-.8-6-4-6-4l.4 1c1.2-1.6-.4-5.2-.4-5.2h-.1a3.8 3.8 0 0 0 0-.3l.5-.4c3.5-3 7.5-3.5 7.5-3.5-2.4-3-7.4-1.4-7.4-1.4.1-3.5-1.4-7.7-1.4-7.7a12 12 0 0 0-7.7 4.7c-.2-3.7-4.9-5.8-4.9-5.8 1.8 2.1.7 7.2.7 7.2h.2-.5l-.1 1.1h-.2s-1.7.6-3.7 5.2c0 0-.2 1-1 2v-.4s-2.3 3-7.4 0c0 0-7-4.1-9.6-4-2.4.2-4 1.3-3.9 2 0 0-5.7-.4-7.6 2.8 0 0-4.3 1.6-.6 5 0 0 .5 1.6 1.5 2.4 0 0-.1-3.2.7-2.3l.5.6c.1.4.5 1.6 1.2 2.3l.6-.2c0-.8.2-1.8.4-2.2h.2l1 1.6 1-.6c.6 0 1.3.5 1.3.5l1.3-1.1c1.3.2 1.7-2.4 1.7-2.4a4 4 0 0 0 3.1-.5c.6 2 5.2 4.3 5.2 4.3h.2l-.6.4c2.1 1.5 6 1.1 6 1.1-1.6.6-1.4 3.7-1.4 3.7-1 .4-1 1.3-1 1.3 3.2 1.3 5.3.2 5.3.2.2 1 0 1.2 0 1.2-1.3 2.7-1.9 5.4-1.9 5.4h.1v.2s-5.7 2-8.1 4.7c0 0-.3-.8-1-.8s-2.8-1.8-3.8-2.1c-1-.3-2.5.3-3-.2-.3-.4-.1-3.6-.8-4l-.7-2c-.4 1-2.4.8-2.4.8l-.8.6-.8-.1c-.2 0-.4.5-.5 1l-.3.3v-.6c-.3.3-1.1-.1-1.4-.1-.2 0-.4.4-.5.9l-1.9.1c-.3.2 0 2.6 0 2.6-2.3 1.2-1.2 3.1-1.2 3.1 1.2 6 11.5 3.3 12.3 4.1.8.8 2.6 1 3.5 1 1 0 2.1 2.2 3.4 2.4 1.3.2 0-1.8 6.1-3.2 6.1-1.5 8.2-4 8.2-4 1.9-.4 2.4-2.7 2.5-3.6l.2 1.4c.3 2.1-1.2 3-1.2 3l5.3-1.7c2.1-.5 1.8-2.4 1.8-2.4 2 5.8 5.7 6.2 5.7 6.2.7-2.2.6-2.9.6-2.9h1.7c0-1.3-1-2.2-1.7-2.6l2.6 1.5 1-.1c0 .9 1.3 1.7 1.3 1.7l.2-1.2c1.2 1.6 3.4 1 3.4 1a7.3 7.3 0 0 0-.2-.8c4.7 2.9 12.2-.8 12.2-.8 2 .4 2.3-.8 2.3-.8 2.2.3 2.8-1.3 2.8-1.3 5.3-.4 9.1-4.2 9.1-4.2 2.7-.2 2.8-2.1 2.8-2.1s2.6.5 5.2-2.7c6-8.5 14.8-4 14.8-4l-5.1.3c-13.5-.1-7.9 9-7.9 9h.8c1.3.2 5.7 3.7 4 6.2v.2c-2.8 3.7-7.8.2-9.3-3-1.4-3.2-4.4-2.5-4.4-2.5s-7.5 1.3-4.4 7.3c.1 1.5 1 3.2 3.8 4.8 1.5 2.2 6.5 2.4 10.1 1.6C524 244 533 240 533 240c.7-2 3-1.5 5-4.4 2-2.8-2.9-3.8-4-5.4-1-1.5.3-1.2.3-1.2 4.4 2.3 4.8-5.2 4.8-5.2a6.6 6.6 0 0 0 4.3 5.5c2.3-2.3.6-7.2.6-7.2 5.7 10.2 9.1 8.5 9.1 8.5-3-1.8-1.5-4.4-1.5-4.4 2.7 10.8 14 1.4 14 1.4-.6 1.6 0 2.5 1 3.5s2.2 1.4 1.6 3.3c-.5 1.8-5.8 1.4-5.8 1.4s-5-.2-4.6 4c.3 1 3.6 1.4 5 1.1 0 0-.6.2 1.3.4h2.2c2.1 0 4.5-.4 4.5-.4 2.9-.6 2.4-1.6 2.4-1.6 4.5-.8 5-3.8 5-3.8z"
            }),
            /* @__PURE__ */ jsx143("path", {
              d: "M429.6 216.7s.3-.5.7-.6c.4 0 .8.2 1.2.8l.3-.2s-1.2-1.8-.8-3c.3-.6.8-1 1.6-1.1v-.3c-1 .2-1.6.6-1.8 1.3a2 2 0 0 0-.2.7c0 .6.2 1.2.5 1.7a1.1 1.1 0 0 0-.8-.2 1 1 0 0 0-.8.6zm141 24c-3 .5-7.5.7-7.9-.2 0-.2 0-.8 2.4-2.4l-.2-.5c-2.1 1.4-3 2.3-2.7 3 .7 1.8 7.2.8 8.5.6zm-58.4 1.7c-.7-1-.3-2.5 1-4.3l-.5-.3c-1.4 2-1.7 3.6-1 5z"
            }),
            /* @__PURE__ */ jsx143("path", {
              d: "M508.1 237.8c0 1.9 1.4 3.6 3.9 5.1l.3-.5c-2.4-1.4-3.6-3-3.6-4.6-.2-2.5 2.5-4.5 2.6-4.5l-.3-.4c-.2 0-3 2.1-2.9 5zm52 .7c-.8 1.3-.5 2.8-.5 2.8h.5c0-.1-.2-1.4.5-2.5a3 3 0 0 1 2-1.2v-.5c-1.1.2-2 .7-2.4 1.4zM441 215.1h-.2v.2s-.2 1.6-1 2a.8.8 0 0 1-.6 0l-1.3-.7c-.2-.2-.4-.3-.8-.2a1.8 1.8 0 0 1-.4-1.4c.1-.7.6-1.4 1.6-2l-.2-.3c-1 .7-1.6 1.5-1.7 2.3 0 1 .5 1.6.5 1.6v.1h.2c.3-.1.3 0 .6.2l1.4.8h1c.7-.5 1-1.9 1-2.2 3.2.7 5.8-3.3 6-3.4l-.3-.2s-2.7 4-5.8 3.2"
            }),
            /* @__PURE__ */ jsx143("path", {
              d: "M433.1 214.5a3 3 0 0 0 .4 2c.3.5.7.8 1 .9.5 0 .8-.3 1.2-.6.2-.2.4-.4.6-.4l.3.2.2-.2-.5-.3c-.3 0-.6.2-.8.5s-.6.5-1 .5c-.2 0-.5-.3-.8-.8a2.2 2.2 0 0 1-.3-1.7c.4-1.4 2.1-2.5 2.1-2.5l-.1-.3c-.1 0-1.9 1.2-2.3 2.7m-4.4 20.7c.1-.6.6-1 1.3-1.4-.2 0 .6.6 1.3.6l.5-.3c.2.2 1.4 1.3 1.4 2.7 0 .3 0 .6-.2.9l.3.1c.9-2.1-1.4-4-1.4-4h-.2l-.4.3c-.6 0-1.3-.6-1.3-.6-1 .4-1.4 1-1.6 1.6zm10.3-5.4c-.7.1-2.5.4-3.1 1.4-.2.4-.3.8-.1 1.2l.2.6c.6 1.6 1.2 3.2 1.9 3.6l.1-.3c-.6-.3-1.2-2-1.7-3.4l-.2-.6a1 1 0 0 1 0-1c.5-.7 2.2-1 3-1.1.4 0 .5 1.5.6 2.4h.3c-.1-1.4-.3-2.8-1-2.8"
            }),
            /* @__PURE__ */ jsx143("path", {
              d: "M433.9 231.4c-.4.3-.3.8-.3.9 0 .1.2 4 2 4.8l.1-.3c-1.6-.7-1.8-4.5-1.8-4.6 0 0 0-.4.2-.6.3-.2.8-.3 1.6 0l.1-.3c-.9-.3-1.5-.2-1.9 0z"
            }),
            /* @__PURE__ */ jsx143("path", {
              d: "M432.4 231.7c-.8.6-.7 2.2-.7 2.3h.3s0-1.6.6-2c.3-.2.6-.2 1 0l.1-.4c-.5-.2-1-.2-1.3 0z"
            }),
            /* @__PURE__ */ jsxs118("g", {
              transform: "translate(-96.9 97.5) scale(.66486)",
              children: [
                /* @__PURE__ */ jsx143("path", {
                  d: "M862.3 169.5s1.3 3 1.3 5.3c0 .4-.2.7-.3 1l-.5-1.3-.3 1s-.6 1.4.3 2.9c1.2 2 4.2 3.2 9 3.7v.1a.8.8 0 0 0-.4.1l-.2.2v.4c.2.5.7.5 1.8.5l.7.1.6.2-.1-.1c1 0 2.3.3 3.6.8l-1 .2 1.1.5c.1 0 8.7 3.5 12.2 6.3-1 .9-5.3 4-12.7 2.2l-1.2-.3.8 1s4.9 5.6 5.9 9c-1.7 0-8.2 0-10.5-2l-.5.5s3 4.6 3.8 8.1c-1 .2-3 .3-4.3-1.4l-.6-.7-.3 2c-.6-.5-1.4-1.1-1.4-1.9v-.4l-1.8.3-3.8-2.3a8 8 0 0 0-.6-.4l-.4.7.6.3c.8.6 2.2 1.7 2.3 3.3H863v.5c0 .3 0 1.4-.9 3.7-1.1-.2-5.3-1.7-7.8-8.8l-.8.2v.2c0 .7-.2 2.3-2.4 2.9l-6.5 2a4.5 4.5 0 0 0 .8-2.8v-.8a20.3 20.3 0 0 1-.2-2.6c0-1.5.3-2.4 1.4-3l-.4-.8c-.1 0-9.6 3.9-14.3 2.3.2-1 1-4.2 2.6-7.6l-.2.2c.3-.2.6-.6.3-2.2v-.5l-.5.2s-3 1.4-7.4-.2c0-.4.3-1 1.2-1.4l.3-.1v-.8c0-1.2.1-4 1.8-4.6l-.2-.8s-5.1.4-8.2-1.3a11 11 0 0 1 4.5-1.9h.3v-.4a6 6 0 0 0-.5-2.3c1.2.4 2.6.7 3.1.3l.2-.1-.2-3.1h-.8l.1 2.6-3-.7-1.2-.4.8 1a4 4 0 0 1 .7 2.4 12.7 12.7 0 0 0-5 2.3l-.5.4.5.3c2.4 1.6 6.1 1.8 8 1.7a8.4 8.4 0 0 0-1.3 4.5v.4a3.1 3.1 0 0 0-1.5 2.2v.3l.2.1a11 11 0 0 0 7.9.5v.9c-2 4.2-3 8.3-3 8.3v.4h.3c3.9 1.6 10.7-.5 13.8-1.6-.4.7-.7 1.5-.7 2.5a22.1 22.1 0 0 0 .3 3.4c0 2.3-1.5 3.2-1.6 3.2l.3.8 8-2.4c1.8-.5 2.5-1.6 2.8-2.5 3.1 7.4 8 8 8.3 8.1h.3l.1-.3a14 14 0 0 0 1-4 439.6 439.6 0 0 0 2.4-.1v-.5c0-.7-.1-1.3-.4-1.8l1.4.8 1.3-.2c.3 1.3 1.9 2.4 2.1 2.5l.5.3.3-1.7c2 1.7 4.7 1.2 4.9 1.2l.3-.1v-.4c-.4-2.7-2.2-5.9-3.3-7.6 3.5 1.6 9.9 1.5 10.2 1.5h.4v-.5a30 30 0 0 0-5.6-9c8.2 1.5 12.6-2.8 12.8-3l.3-.3-.4-.2a53.8 53.8 0 0 0-11.6-6.3l.9-.2-1-.5a12.8 12.8 0 0 0-5.8-1.4c-1-1.2-1.5-1.3-1.6-1.4-5.6-.6-7.6-2.1-8.4-3.3v-.3l.2-.3c.5-.7.7-1.6.7-2.6 0-2.6-1.3-5.5-1.3-5.6z"
                }),
                /* @__PURE__ */ jsx143("path", {
                  d: "M836.8 167.9s-.6 3-3.2 4.5c-2 1-4.5 1-7.6-.3l-.4-.1v.4a5 5 0 0 0 2 3.2c1.3 1 3.3 1.4 5.9 1.2-.9 1-3.6 4.4-3.6 7.8v.5c.4.2 4.6 1.4 6.6-1.1 0 1 .4 4.5 1.7 5.8.8.8 1 1.8 1 2.7 0 .8-.2 1.4-.2 1.4l-.2.6.5-.4c.2-.1 4.1-3 5.3-6.7 0 0 .7-1 1.9-1.3v.5c0 1.5.6 4.1 4.8 5.7l.3.1v-.3a7.1 7.1 0 0 1 0-.7c0-1.1 0-3 1.1-4a2.8 2.8 0 0 0 .6-3.3c.9.2 2.9.9 3.7 2.4 1.2 2.2 5.3.4 5.5.4l-.1-.5s-1.8.4-2.9-.3a2.1 2.1 0 0 1-.8-1.5l-.2-2.4c0-1-.2-1.7-.7-2.2.5 0 1.6 0 2 1 .8 1.6 3.3 1.7 3.4 1.7l.9.1-.7-.5s-2.2-1.4-1.8-3.3l.3-1.4c.6-2.5 1.6-6.6.7-9.2l-.4.2c.2.6.3 1.4.3 2.2 0 2.2-.7 5-1 6.7l-.4 1.4a2.6 2.6 0 0 0 0 .5c0 1.3.7 2.2 1.3 2.7-.7-.1-1.7-.5-2-1.3-.7-1.4-2.3-1.4-3-1.3l-.6.1.4.4c.7.4.8 1 .8 2.3l.2 2.3c.1.8.5 1.4 1 1.8.6.4 1.2.4 1.7.5-1.2.3-2.9.5-3.5-.6-1.1-2.2-4.3-2.7-4.4-2.8h-.5l.2.4s.4.6.4 1.4c0 .5-.2 1.2-.7 1.7-1.1 1.1-1.3 3.2-1.3 4.3v.4c-3.6-1.5-4.2-3.7-4.2-5v-1l.2-.3h-.4a3.5 3.5 0 0 0-2.5 1.8 15 15 0 0 1-4.7 6.2 6.9 6.9 0 0 0 .1-1c0-.9-.2-2-1-2.9-1.5-1.4-1.7-6-1.7-6v-.8l-.4.7c-1.6 2.8-6.2 1.4-6.3 1.4-.2-3.5 4-8.1 4-8.2l.4-.4h-.6c-2.7.4-4.8 0-6.2-1a4.6 4.6 0 0 1-1.6-2.5c3 1.1 5.6 1.2 7.6.1a7.4 7.4 0 0 0 3.4-4.8c3-6.6 5.5-7.7 5.5-7.7l-.1-.4c-.2 0-2.8 1-5.8 8"
                }),
                /* @__PURE__ */ jsx143("path", {
                  d: "M843.5 158h-.2l-2.4 3.3h.7a31 31 0 0 1 19.7 9.2l.3.3 2.3-2.5-.2-.3c-6.5-10.2-20.1-10-20.3-10zm.2.9c1.6 0 13.2.3 19.2 9.3l-1.3 1.4a33 33 0 0 0-19.3-8.9 631.2 631.2 0 0 1 1.4-1.8"
                }),
                /* @__PURE__ */ jsx143("path", {
                  d: "M841.6 164.8a11 11 0 0 0-2.1 4.8l.1.4a7.3 7.3 0 0 0-2 5.5c0 1.3.2 2.6.6 3.8l.3.7c1.2 3.4 2.3 6.4 7.8 4.6 5.2-1.6 5.4-2 6.7-4.2l.4-.5c.7-1.2 1.5-1.4 2.3-1.7 1-.3 2-.6 3-2.4l.8-1.3c1-1.3 2.2-3 2.3-5h-.4a9.8 9.8 0 0 1-2.2 4.7l-1 1.4a3.6 3.6 0 0 1-2.6 2.2 3.9 3.9 0 0 0-2.6 1.8l-.4.6c-1.2 2.1-1.4 2.4-6.5 4-5 1.6-6-.9-7.2-4.4l-.3-.7c-1.4-3.8-.3-7.6 1.6-9l.6-.5-.9.1v-.1c0-.7.7-2.6 2-4.5 1.2-1.6 4-3.1 4-3.2l-.2-.4c-.2.1-2.9 1.7-4.1 3.3"
                }),
                /* @__PURE__ */ jsx143("path", {
                  d: "M839.2 178.7c.9.6 2.1.5 3.7 0 0 .5 0 1.7 1 2.5 1.2 1 3 1.2 5.5.6v-.5c-2.4.6-4.2.4-5.2-.5a3 3 0 0 1-.9-2.4v-.4l-.3.2c-1.5.6-2.7.7-3.6 0-1.5-1-1.4-3.7-1.4-3.7h-.4s-.2 3 1.6 4.2"
                }),
                /* @__PURE__ */ jsx143("path", {
                  d: "M842 175c-.6.2-.8.7-.8 1.1v.3c.2 1.2 1.5 2 2.6 2.3 1.2.3 2.6.4 3.1-.3.2-.3.4-.8 0-1.7a3.7 3.7 0 0 0-4.8-1.7zm2 3.3c-1-.3-2.2-1-2.3-2 0 0-.1-.7.5-.9a3.3 3.3 0 0 1 4.2 1.6c.3.4.3.8.1 1-.3.5-1.4.6-2.5.3m-.4 2.7c-.3 2.5 0 2.6.1 2.6h.2l.2-.1 1.4-2-1.8-.8v.3zm.5.4.7.3-.8 1.1zm-4.2-2.4-.1 2.3 2-2.4-2-.2zm.4.2h.6l-.6.8z"
                }),
                /* @__PURE__ */ jsx143("path", {
                  d: "M838.5 178.2s1.5 2.9 1.8 4c.1.6 1 1.4 2 1.7 1 .4 2 .4 2.7-.1l1.3-1.1c.4-.5.6-.6 1-.5v-.5c-.6 0-.9.2-1.3.6l-1.3 1c-.8.6-1.7.4-2.2.2-1-.3-1.7-1-1.8-1.5-.3-1-1.7-3.9-1.8-4zm2-8.6a5 5 0 0 0-2.4 2.8l.4.1s.7-1.8 2.1-2.5a2.9 2.9 0 0 1 2.4 0l.1-.4c-1-.4-1.8-.4-2.7 0zm10.8 5.2c.2 0 3.2 2.4 1.5 5.2l.3.3c2-3.3-1.5-5.9-1.5-6zm-9.2.4s-.5 1.7 2 2.3c0 0-2.3 0-2.5-.6-.1-.6 0-1.9.5-1.7m7.5 2c0 .2-.2.3-.3.3a.3.3 0 0 1-.3-.2c0-.2.1-.3.3-.3.1 0 .3.1.3.3zm.2 1.2c0 .1 0 .2-.2.2a.3.3 0 0 1-.3-.2.3.3 0 0 1 .3-.3c.1 0 .2.1.2.3"
                }),
                /* @__PURE__ */ jsx143("circle", {
                  cx: 848,
                  cy: 177.8,
                  r: 0.3
                }),
                /* @__PURE__ */ jsx143("path", {
                  d: "M848.8 179.4a.3.3 0 1 1-.6 0c0-.1.1-.2.3-.2zm-7.1-7.3a.3.3 0 0 1-.6 0 .3.3 0 0 1 .5 0z"
                }),
                /* @__PURE__ */ jsx143("circle", {
                  cx: 841.6,
                  cy: 173.2,
                  r: 0.3
                }),
                /* @__PURE__ */ jsx143("circle", {
                  cx: 840.1,
                  cy: 172.7,
                  r: 0.3
                }),
                /* @__PURE__ */ jsx143("path", {
                  d: "M840.8 174.3a.3.3 0 0 1-.2.3.3.3 0 0 1 0-.6.3.3 0 0 1 .2.3m4.8-9.6s3.5 2.2.1 6.3c0 0 1.7-1.3 1.8-3.4.2-2.1-1.2-3.8-2-2.9zm13.5 5.9c-1.2.6-2.8-.5-3.6-1.5-.8-1-2.5-1.3-3.6.6-1 1.8-2.5 2.5-2.5 2.5s1.5-.8 3-2.5c1.5-1.6 2.4-.3 3.9.5 1.4.8 1.7 1 2.7.5v-.1z"
                }),
                /* @__PURE__ */ jsx143("path", {
                  d: "M858.8 170.9a1.7 1.7 0 0 1-2.2-.1c-1-.8-1.7-1.8-2.8-1.2-1.2.6-3.3 2.2-3.3 2.2s3.5-2.4 4.2-1.8c.6.5 2.2 1.8 3.1 1.4z"
                }),
                /* @__PURE__ */ jsx143("path", {
                  d: "M856.1 172.3c-1.1-.8-2.2 1-3.1.8-1-.2-1.7-1.8-1.7-1.8s.8 1.6 2 1.3c1.3-.4 2.1-1.2 2.9-.6.7.6-.1.3-.1.3"
                }),
                /* @__PURE__ */ jsx143("path", {
                  d: "M854.4 172.6a2 2 0 0 1-2.4-1.9s.7 1.8 2.6 1.5z"
                }),
                /* @__PURE__ */ jsx143("path", {
                  d: "M854.3 171.2c.1.5.1.8-.5.8s-1-.2-1-.8c0-.5 1.4-.4 1.5 0m-7.8-3a.7.7 0 0 1-.7.6c-.4 0-.5-.2-.5-.6s0-.7.5-.7.7.3.7.7"
                }),
                /* @__PURE__ */ jsx143("path", {
                  d: "M844 165.7s3.8 0 2 4.7c0 0 1.4-2.3.5-4-1-1.6-2.3-1.2-2.3-1.2s-.4.3-.2.5"
                }),
                /* @__PURE__ */ jsx143("path", {
                  d: "M844 167.6c0 1 .6 1.9 1.8 2.9l.3-.4c-1.1-.9-1.7-1.7-1.7-2.5s.6-1.3.6-1.3l-.3-.3s-.7.6-.8 1.6z"
                }),
                /* @__PURE__ */ jsx143("path", {
                  d: "M844.8 168.4c.1.5.6 1 1.2 1.2l.2-.4c-.5-.2-.9-.6-1-1-.2-.8.4-1.7.4-1.7l-.4-.3s-.7 1.2-.4 2.2m5.1 2.6s.7 1.5-.3 3.1l-1 1.6s1.2-2.3.7-3.2c-.4-1 .6-1.5.6-1.5m14.6 15.8c3.8.7 12.5 7.5 12.5 7.5l.5-.6c-.3-.3-8.9-7-12.9-7.7zm3.4 9.5c.2 3.5 4 5.6 4 5.7l.5-.7s-3.5-2-3.7-5zm-9.3.8c0 3.8 3.6 8.4 3.8 8.6l.6-.5s-3.6-4.6-3.6-8.1zm-12.1.4c.6 1.3.6 1.9.4 2.2-.2.4-.6.4-.6.4l.1.8c.3 0 .9-.2 1.2-.8.4-.7.3-1.7-.4-3z"
                })
              ]
            }),
            /* @__PURE__ */ jsxs118("g", {
              fill: "#fff",
              stroke: "#000",
              strokeWidth: 0.2,
              children: [
                /* @__PURE__ */ jsx143("path", {
                  d: "M429.6 216.3s.1 1.7 1.4 2.7c0 0-.1-1.8.3-2.6 0 0-.7-.8-1.7-.1zm2.6 1s.3 1.6 1.2 2.3l.6-.1s.2-2 .5-2.2c.3-.2-1.3.7-2.3 0z"
                }),
                /* @__PURE__ */ jsx143("path", {
                  d: "m434.5 217.3 1 1.6 1.2-.7-.2-1.8s-.7-.2-2 .9zm4.7.3-1.3 1.1s-.7-.5-1.2-.5l.2-1.7s1-.7 2.3 1.1zm-9.3 16s-.2-2.4 0-2.5c0 0 1 .3 1.4 0 0 0 .5 1.8.4 2.6-.2.8-1.1.5-1.8 0zm6-2.4s-.1-2 .2-2.3c0 0 2 .3 2.4-.8l.7 2s-2.1-.3-3.4 1z"
                }),
                /* @__PURE__ */ jsx143("path", {
                  d: "M433.8 231.6s.3-2.1.7-2.2c0 0 1 .3 1.3-.1v2.6s0-1.1-2-.3zm-2.3.3s.5-1.9.8-1.9 1 .5 1.4.2v1.4s-1.6-.4-1.9 1.9z"
                })
              ]
            })
          ]
        }),
        /* @__PURE__ */ jsxs118("g", {
          fill: "#00a651",
          stroke: "#000",
          strokeWidth: 0.8,
          children: [
            /* @__PURE__ */ jsx143("path", {
              strokeWidth: 0.5,
              d: "M461.7 270.4s5.2 4.9 3.9 9.2c0 0 3.3-7.3-.3-9.5-3.6-2-3.7-.5-3.6.3z"
            }),
            /* @__PURE__ */ jsx143("path", {
              fill: "#964b36",
              strokeWidth: 0.5,
              d: "M455 275.1s-1.3 2 .2 3.3c0 0-1.7 2.4-.4 4.4 0 0-1 2.1-.8 4.4 0 0-.8 3.5 1 5.1 0 0 2 1 3 .1 0 0 1.7-2.6.6-5.3 0 0 1.2-2.3-.2-5.2 0 0 .4-1.6-.7-3.5 0 0 .7-1.2.1-2.2 0 0-2.5-2.7-2.8-1z"
            }),
            /* @__PURE__ */ jsx143("path", {
              strokeWidth: 0.5,
              d: "M456.5 269s-6.2-12-10.6-12.5c-4.4-.5-4.6-4.8-4.6-4.8s.5 2 4 2 10.2 5 11 8.7c.7 3.7 1.5 3.2 1.5 3.2z"
            }),
            /* @__PURE__ */ jsx143("path", {
              strokeWidth: 0.5,
              d: "M456.5 268.1s2.3-15.1 12.2-15.4c9.9-.2 6.6.8 9-.8 0 0-6.6 3.4-10.7 4-4.2.4-7.6 8.5-7.4 10 0 1.5-2.3 4.4-3.4 3.4-1.2-1 .3-1.2.3-1.2z"
            }),
            /* @__PURE__ */ jsx143("path", {
              strokeWidth: 0.5,
              d: "M458.8 273.8s2.3-6 6.1-4c0 0-3-5.8-8.4-.8 0 0 2.4 3.3 2.3 4.8zm-7.5-6s3.2 13.4-1.8 17.5c0 0 .2-6.9-2.9-11-3-4.2 3-8.7 4.7-6.5z"
            }),
            /* @__PURE__ */ jsx143("path", {
              strokeWidth: 0.5,
              d: "M451.7 270.1s5.9 5.7 6.2 7.6c.4 1.8 1.8-5.7-1-7.8s-5.7-2.5-5.7-2.5l.5 2.8z"
            }),
            /* @__PURE__ */ jsx143("path", {
              fill: "#964b36",
              strokeWidth: 0.5,
              d: "M440.8 285s.5 2.3 2 2.8c0 0 0 1.7 1.4 2.2 0 0-.7 1.5.4 2.4 0 0-.2 3 .8 3.5 0 0 2.7-.1 3.6-.9 0 0 .5-1.9-1-3.8 0 0 .3-1.8-1.2-2.8 0 0 .5-2.5-1.4-3.4 0 0-.3-2-1.4-3 0 0-2.2 3.1-3.2 3z"
            }),
            /* @__PURE__ */ jsx143("path", {
              strokeWidth: 0.5,
              d: "M443.7 282s-7.7-2.8-12 1.2c0 0 6.6 1 7.4 2.3.8 1.3 4.9-2.2 4.6-3.5z"
            }),
            /* @__PURE__ */ jsx143("path", {
              strokeWidth: 0.5,
              d: "m441.3 286.8-1.4-1c-.7-.6-7.2-2.3-8.1 4 0 0-2.4-6.3 1-7 3.5-1 6.2 1 8.5 4m-5-12.8s2.3 5.2 3.2 5.4c.9.3 1.5-.6 1.5-.6s-3.1-4.6-4.8-4.8zm-1.8-7.9s-2-6.6-4.4-4.8c-2.4 1.7-1.8 6.5-1.8 6.5s-4.7-5-2-8.8c2.8-3.9 8.2.4 8.2 7.1z"
            }),
            /* @__PURE__ */ jsx143("path", {
              fill: "#964b36",
              strokeWidth: 0.5,
              d: "M439.9 279.8s0 1.3.9 1.6c.8.4 2.5 1 2.5.3s-1.3-3.7-1.8-3.3c-.5.4-1.4.4-1.6 1.4z"
            }),
            /* @__PURE__ */ jsx143("path", {
              strokeWidth: 0.5,
              d: "M438.4 272s-.3-5.7 3.5-7.9c0 0 .7.2 1.1-1 0 0-3 7.3-2.1 11l-.1.4"
            }),
            /* @__PURE__ */ jsx143("path", {
              strokeWidth: 0.5,
              d: "M439.1 265s6.8-14 15-9.1c0 0-8.6 1.7-11.7 7.9l-3.1 4.6z"
            }),
            /* @__PURE__ */ jsx143("path", {
              strokeWidth: 0.5,
              d: "M435.5 270.1s-2-9.4-3.3-10.6c-1.2-1.3-3.3-2.6-5.9-.5 0 0 4.4-3.9 9-.6 4.7 3.2 3.7 8.4 3.7 8.4l-.5 6.5-3.1-2.9"
            }),
            /* @__PURE__ */ jsx143("path", {
              strokeWidth: 0.5,
              d: "M442.8 281.3s-8.3-15.7-13.7-4.5c0 0-1 2.9.1 4 0 0-3-2.3-1.6-7.8s10.5-3 13.2 1.5c2.6 4.5 3.3 6.8 3 7-.4.3-1-.2-1-.2zm23.3 4.5s6-12.4 9.5-6.8c0 0 1 2.8-.5 4 0 0-2.4-3-4.5.6-2.2 3.5-1.3 3.2-1.3 3.2s-2.2.6-3.2-1z"
            }),
            /* @__PURE__ */ jsx143("path", {
              strokeWidth: 0.5,
              d: "M475 283s3.3 1.7 2.2 5.2c0 0 4.4-8.4-1.6-9.2 0 0 1.1 2.7-.5 4zm.5-8.6s7.9 2.3 8.1 5.7c0 0 1.4-6.6-3.1-8.6 0 0-5.4 1-5 3z"
            }),
            /* @__PURE__ */ jsx143("path", {
              strokeWidth: 0.5,
              d: "M479 264c3.4-6.6 7.6 2.1 7.6 2.1s1.5-6.9-2.7-8.1c-4.3-1.3-7 14.7-7 14.7l-5 1s1.3-13.8 8.8-15h1"
            }),
            /* @__PURE__ */ jsx143("path", {
              strokeWidth: 0.5,
              d: "M473 268s-4.8-9.8-8-10.8 1.7-2.5 3.7-.6 5.8 4.3 5.4 9.3zm-5 13.4s1.4-6.6 5.2-8.6c3.8-2 7.3-1.3 7.3-1.3s-4.5 1-5.3 3.3c-.7 2.2-2 2.4-2 2.4z"
            }),
            /* @__PURE__ */ jsx143("path", {
              fill: "#964b36",
              strokeWidth: 0.5,
              d: "M466 285.8s-2 4-1.6 4.6c0 0-2.2 3.3-1.3 5 0 0 2.2 1.7 3.2 1 0 0 2.6-3.7 1.9-5.7 0 0 1.8-2.4 1.1-3.9 0 0-2.6.1-3.2-1z"
            }),
            /* @__PURE__ */ jsx143("path", {
              fill: "#000001",
              stroke: "none",
              d: "M455 278.6c.2.1 1.5.7 2.3.4l.6-.5-.5-.2c-.3.6-1.7.1-2.1-.1l-.2.4zm-.1 4-.2.5c.1 0 2.7.5 3.9-.6l-.4-.4c-1 .9-3.3.4-3.4.4zm-.7 4.4-.3.4s3 2.1 4.9-.2l-.5-.3c-1.5 1.9-4 .2-4.1 0zm-11.5.6.1.3c.1 0 2.6-1 2.8-2.9h-.3c-.1 1.6-2.5 2.6-2.6 2.6m1.4 2.3v.3c.2 0 2.5-.2 2.9-1.8h-.3c-.4 1.3-2.5 1.5-2.6 1.5m.5 2.4v.3c.1 0 2.7.1 3.6-1.3l-.3-.2c-.8 1.3-3.3 1.2-3.3 1.2m19.7-1.7s1.1 1.2 2.4 1.1a2.3 2.3 0 0 0 1.7-.8l-.4-.4c-.4.5-.8.7-1.3.7-1 0-2-1-2-1z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs118("g", {
          fill: "#964b36",
          stroke: "#000",
          strokeWidth: 0.3,
          children: [
            /* @__PURE__ */ jsx143("path", {
              d: "M542 299.8a1.1 1.1 0 0 0-.3.3l.4-.3zm9.3-2.3c-.1-.2-.2-.1-.3-.2l-.4-.8h-.3l-.7-1.4a.4.4 0 0 0 0-.3 7.6 7.6 0 0 0 0-.4s-.2 0-.3-.2v-1.6l-.1-.5a2 2 0 0 1-.3-1.1v-1c.1-.4-.1-.6-.1-1l.1-.9v-5.4l-.1-1-.1-.4v-1.6 2.6l-.2-4.3-3.4-1.6s-.3 6.2-.2 7c0 .9.4 6.7.2 7.4l-.5 4.3s-1.6 1.2-2.2 2.4c-.7 1.3-.5 1.7-.7 1.7l1.5-.2-1.1.8a.7.7 0 0 1 .7.1l.2.2.2-.2c.3 0 .5.4.7.3l.4-.2.2-.4c.1-.1.3 0 .4 0h.7c.3 0 .6-.5.9-.7.2-.2.4-.3.7-.3.3 0 .6.3 1 .3.2 0 .3 0 .5-.2l.4-.6.8-.1.4.1h.6l.3.2.2-.4z"
            }),
            /* @__PURE__ */ jsx143("path", {
              d: "M544.5 299.7h.6v.2a.2.2 0 0 0 .2 0l.3.2h.3l.4.1c.2.1.4 0 .6-.1.2-.2.3 0 .6.2.1.1.1.1.2 0l.1-.1.3-.1.3-.1.4-.2.4.2a.8.8 0 0 1 .2 0l.7-.5c.3-.2.5 0 .7 0h.3c.1-.1.2 0 .4 0 0-.1 0-.2.2-.3l.7.4c.1.1.7.2.6-.2 0-.4-.4-.1-.5-.4v-.6a.7.7 0 0 0-.3-.4c-.2 0-.2.1-.4 0l-.2-.6-.3.2c-.2 0-.2-.1-.3-.3-.3-.3-.4.2-.7.1-.2 0-.4-.5-.5-.7-.1-.1-.3-.5-.5-.4-.2.1 0 .5 0 .7h-.5c-.2 0-.2 0-.3.2-.2.4-.3.7-.7.6-.1 0-.3-.1-.4 0l-.5.2a1 1 0 0 1-.4 0l-.4-.4a.1.1 0 0 0-.2 0 8.7 8.7 0 0 0-.1-.2c-.2 0-.2 0-.3.3l-.1.5-.3.4-.4.1c-.2 0-.4.3-.4 0-.2-.4.3-1.1-.2-1-.1 0-.2 0-.3.2v.7c-.1.3-.7.8-.6 1 0 .3.4 0 .4 0l.2.4c.2.3.7-.4.7 0m-2.1-2.7v-.2l-.4-.1c-.2 0-.4.3-.5.4-.2.4-.2 1-.6 1h-.5v1s-.2 0-.2.2c-.1.4.2.2.4.2h1l.5-.1c.2 0 .4 0 .5-.2a2.2 2.2 0 0 0 .2-.4v-.4c0-.2.3-.1.3-.4.1-.7-.6-.2-.5-.9"
            })
          ]
        }),
        /* @__PURE__ */ jsxs118("g", {
          stroke: "#000",
          strokeWidth: 0.5,
          children: [
            /* @__PURE__ */ jsx143("path", {
              d: "M550.8 277.9c0 .9-.6 1.6-1.4 1.6-.7 0-1.4-.7-1.4-1.6 0-.9.7-1.6 1.4-1.6.8 0 1.4.7 1.4 1.6zm-4.5-2c0 .9-.6 1.6-1.4 1.6s-1.4-.7-1.4-1.6c0-1 .7-1.6 1.4-1.6s1.4.7 1.4 1.6z"
            }),
            /* @__PURE__ */ jsx143("path", {
              d: "M548.7 276.5c0 1-.6 1.6-1.4 1.6-.8 0-1.4-.7-1.4-1.6 0-.9.6-1.6 1.4-1.6.8 0 1.4.7 1.4 1.6z"
            }),
            /* @__PURE__ */ jsx143("path", {
              d: "M546.4 278c0 .9-.6 1.6-1.4 1.6-.8 0-1.4-.7-1.4-1.6 0-.9.6-1.6 1.4-1.6.8 0 1.4.7 1.4 1.6z"
            }),
            /* @__PURE__ */ jsx143("path", {
              d: "M548.5 279.3c0 .8-.6 1.6-1.4 1.6-.7 0-1.4-.7-1.4-1.6 0-1 .7-1.7 1.4-1.7.8 0 1.4.7 1.4 1.6z"
            })
          ]
        }),
        /* @__PURE__ */ jsx143("path", {
          fill: "#00a651",
          stroke: "#000",
          strokeWidth: 0.5,
          d: "M549.2 261.5s13.9-19.4 28.8.7c0 0 .1 2-1.3 4.2l-.3-1.7-1 .3-.2-1-1.6-.1.5-2.2-1.7 1.4.2-1.5-2 2 .3-4.3-2.2 3.7.3-2.5-.8 1.1-.4-1.5-.7 1.5-1-.7v1l-1.8-1.5-.6 2-.9-2.2-.2 1.5-.9-1.7-.1 1.9-2.9-1.3.6 1.8-1.3-1 .2 1-1.9-.4.2 1.1-2-.4.3 1-2.7-.3 1 1-.3.6s15-5 16 13.8l-2.7 1.3.8-1.5-.8-.5-2.3-1.7.7-2.4-.8.3-.1-1.4-.4.2-.9-1.3-.2.5-.6-1.7-.7 1.2-.3-2.8-1 1.8-.2-1-.3.6-1.3-1.5-.4 1-.5-.8-.3 1-1.4-1.4v1l-1-.7-.3.5-2.1-1.1-.1 1-1.2-1-.3 1s13.6 7.8 9.4 20.4l-.8 1.6-.2-4.2-1.3 2.2.9-4.9-.9 1-.1-2-1.1 2-.4-2.2-.5.6-.8-3.2-.6 1.3-1-3.6-.8 1.5-.5-3.1-.5 1.9-1.5-2.8-.2 1.1-.9-2.2-.5.7s-2.5-.1-3.3-.7c-.7-.7-2.8 3.7-2.8 3.7l.2-2.6-.9 1.8v-1.8l-1.6 5.3-.4-3.8-.8 3.3-.4-1-.3 1.3-.5-.5-.4 1.5-.8-.6v2l-.8-1-.6 3-.4-1.2v1.3l-.6-.7-.6 3-1-1.3v2.2l.3 1.6-1-.5.4 2.6s-3.9-7.2.8-14.2c4.6-7 10.9-9 10.9-9l-.7-.6v-.6l-3.8 1.9v-1.1l-1 .8-.2-1.2-.6 1.1-.1-.5-1 1.4-.4-2-.6 2.4-.6-1.7-1.3 3.5V270l-1 2.8-.4-3-.7 3.4v-3l-1.2 3-.7-3-.5 3-.8-2.3-.7 3.4-1.2-3-.6 4.5-.7-1.8-.2 3.3-.8-2 .8 4.2-1-1.6.3 2.6-1.6-2.9v3.4l-.8-1.1-.4 1.3s-.3-13 8.6-15.6c8.9-2.5 14.6.8 14.6.8l-3.4-2.8.4-.9h-1.2l.5-1-2.7.1.8-1-2 .3v-.6l-1.3 1 .5-1.2-1.7 1.2-.1-1.7-1 1.4-.4-1.5-4 4 1-4.1-.7.9-.1-1-1.1 1.8-.3-1.2-.5 1.5-.4-1.8-.8 1.8-1-1.6-.3 2.1-.6-1.1-.8 1.6-1-1v1l-2-.9.4 1.5-1.5-1.2-.4 2-.8-1-.7 2.5-.6-2.4-.6 1.9s7.8-20.2 27.6-7c0 0 2.2 2.1 2.7 3.6s.1.2.1.2l-.4-13.9.8 6 .5-2-.1 3 2-4.3s-2.4 7.2-1.5 9.9c0 0 .9-8.4 3.9-9.4l-2.8 6 .9-.1-.6 1.2h.7l-.9 2-.5 1 .5 1z"
        }),
        /* @__PURE__ */ jsx143("path", {
          d: "m547.1 269.6.4.4s1.3-1.4 3.4.4l.3-.4c-2.5-2.1-4-.4-4-.4zm-.6-6.8v.5l.9-.4-.7 1.2 1.5-.5-1.8 2.3.4.3 2.9-3.7-1.8.6.8-1.3-1.6.6.3-1.9h-.5z"
        }),
        /* @__PURE__ */ jsx143("path", {
          d: "m543.9 263 .6 1.3-1-.4 2.9 5.2.4-.5-.6 1.5.5.2 1.2-3.2-.4-.3-1 1.3-1.8-3.1.8.3-.8-1.7 1.1.6v-1.9h-.5v1l-1.8-1.1zm-1.9 6.4.2.5c.8-.3 1.5-.4 2-.2.5.3.7.9.7 1l.5-.2s-.2-.9-1-1.2c-.6-.3-1.4-.3-2.4.1m2.3 5.4-.5-2.8h.6l.4 2.7zm3.8-.4-.7-2.2.5-.1.7 2zm1.4 1.5-.5-2.1.5-.1.6 2.1z"
        }),
        /* @__PURE__ */ jsx143("path", {
          fill: "#00a651",
          stroke: "#000",
          strokeWidth: 0.5,
          d: "M442.6 340.2s-2.4-1-3.5-.2c-1 .7-.9 1.9-1.8 1.8 0 0 3.6.8 4.3-.1l1-1.2m.4.7s-1.6 2-1 3.3c.5 1.2 1.7 1.3 1.4 2.2 0 0 1.5-3.3.8-4.3s-1-1.1-1-1.1m-2.8-5.8s-2.5.8-2.8 2c-.2 1.4.6 2.1-.1 2.7 0 0 3.2-1.8 3.1-3v-1.5m1.2.7s1.2-2.3.5-3.4c-.8-1.2-2-1-1.8-2 0 0-1 3.5 0 4.4l1.1 1m-2.2-.9s0-2.6-1-3.2c-1.2-.7-2.2-.1-2.5-1 0 0 .7 3.6 1.8 4l1.5.3m4.4 4.2s2.7-1 3 2c.2 3-.2 2-.2 2s-1.4-3.2-3-3.7z"
        }),
        /* @__PURE__ */ jsx143("path", {
          d: "m443 341.3.2 2.2h.4l-.3-2.2 1-4.9h-.4l-1 4.9z"
        }),
        /* @__PURE__ */ jsx143("path", {
          d: "m440.5 340.6-.1.3c1.3.5 3-1 3.1-1l-.2-.3s-1.7 1.3-2.8 1m3.4-2.9-6-3 .2-.5 6 3z"
        }),
        /* @__PURE__ */ jsx143("path", {
          d: "m439.5 337-.4-.4 1.2-1.2.4.4zm2.1-.6-1.3-2.8.5-.2 1.3 2.8zm1.8 3.4v.6c1.7-.1 2 1 2 1l.6-.2c0-.3-.7-1.5-2.6-1.4"
        }),
        /* @__PURE__ */ jsx143("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: 0.7,
          d: "M471.2 341c2-1 2.4-5 2.4-5-.5 1.4-4.2 2.9-4.2 2.9 2.7-1.7 6-9.4 6-9.4-.8 2.7-8 5-12.6 7.6-4.6 2.6-2.2 10-2.2 10-1.3-.9-3.8-4.8-4.3-8.3-.5-3.5-1.8-4.9-5-5.3-3.1-.4-5 3.2-5 3.2l-4.7 2.4 4.8.2s3.4 1.1 3.4 3.8c0 2.6-3 13.3 2 19.3 3.3 4.1 16 6.5 16 6.5"
        }),
        /* @__PURE__ */ jsx143("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: 0.7,
          d: "M461.9 349.3s1-4.8 4.1-4.6c3.1.2 4-3.6 5.9-4.1 1.9-.6 11.5-3.2 12.5-7.8 0 0-.9 7.6-9.7 11.4 0 0 7.1-2.3 8-3.9 0 0-3.2 6.8-10.9 7.9 0 0 7.2-.6 8.2-2.5 0 0-3.2 4.2-8.5 4.8 0 0 5 2 6.2.3 0 0-2.7 3.2-6 3.4l1 .2s-3.2 3.8-6.7 1.3-3.6.6-3.6.6"
        }),
        /* @__PURE__ */ jsx143("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: 0.7,
          d: "M469 356.5s4.1 6.8 4.5 10.4c0 0 7.8 8.5 10.7 9 0 0-1.4.6-4-1.5 0 0 2.2 2.2 2.6 2.3.4 0-1.7-.2-2-.8a6 6 0 0 0 1.4 1.5l-.5-.2s-1-.1-1.6-.5c-.5-.4-.1 1-.1 1s-1.2-.3-1.6-.7c-.4-.4.1.9.1.9l-1-.3-.8.5s0 .5-.5 0c-.5-.3-1.4 0-1.4 0s-.6.6-1 .2c-.3-.4-1.5 1.6-1.5 1.6l-5-12.3"
        }),
        /* @__PURE__ */ jsx143("path", {
          d: "m473.9 378.7-6.4-12.2.6-.4 6.4 12.3zm5.6-.8-11-12.3.6-.5 11 12.3zm2.5-1L469.5 365l.5-.5 12.5 11.7z"
        }),
        /* @__PURE__ */ jsxs118("g", {
          transform: "translate(-96.9 97.5) scale(.66486)",
          children: [
            /* @__PURE__ */ jsx143("path", {
              d: "M823.4 360.8s-1.2-2.2-2.3-1.3c-1 .8-1.6 1-1.8.9 0 0 1 0 1.7-.5.6-.6 1.6-.3 2.4 1zm-6.6-1 .7 1.4-.8 2.3.6.2.7-2.5-.7-1.6z"
            }),
            /* @__PURE__ */ jsx143("path", {
              d: "M823.2 360.5s-1 1-2.2.8l-1.3-.3h1.8c.7 0 1.6-.3 1.7-.5"
            }),
            /* @__PURE__ */ jsx143("path", {
              d: "M822.9 360.7s-1.2-1.2-2-.8c0 0 1.4-.5 2.2.7z"
            }),
            /* @__PURE__ */ jsx143("path", {
              d: "M822.7 360.5s-1.3.9-2.7 0l-.1-.2h.2s1.7.7 2.6.2"
            }),
            /* @__PURE__ */ jsx143("circle", {
              cx: 821.6,
              cy: 360.3,
              r: 0.4
            })
          ]
        }),
        /* @__PURE__ */ jsx143("path", {
          d: "M450 359.6s-.7 1.2-.3 2c.3.7 2 1 2.1 2 .2 1 .8 1 1.5 1l.9-.3s-3.1-1.6-4-4.3z"
        }),
        /* @__PURE__ */ jsxs118("g", {
          fill: "#964b36",
          stroke: "#000",
          strokeWidth: 0.5,
          children: [
            /* @__PURE__ */ jsx143("path", {
              strokeWidth: 0.3,
              d: "M549.4 334.8s5.6-7.4 10.6-5.5c5 2 8.1 3 8.1 3s.1 4.9-2.5 4.9-5.2-5-7.6-3.5a13 13 0 0 0-4.5 4.2c-.1.7-6.3.8-4.1-3.1z"
            }),
            /* @__PURE__ */ jsx143("path", {
              d: "M528.2 370.4s-1.6 1.6-.9 2c.7.4 2.1 0 2.1-.6s-1-1.6-1.2-1.4z"
            }),
            /* @__PURE__ */ jsx143("path", {
              d: "M527 372s-3-1.7-5.2 2.2c-2.3 3.8-4.1 10.1-5.4 11-1.3.8 12.8-6.2 13-9.2 0 0 .9-3.8-.6-3.7-1.5 0-1.6.2-1.9-.4z"
            }),
            /* @__PURE__ */ jsx143("path", {
              strokeWidth: 0.3,
              d: "M527.3 372.4s-3 .7-3.6 4.9c-.6 4.2-4.7 6.3-5 6.5m49.4-51.6s-4.4 1.6-3.7 4.7"
            })
          ]
        }),
        /* @__PURE__ */ jsx143("path", {
          fill: "#fff200",
          stroke: "#000",
          strokeWidth: 0.3,
          d: "M533.7 341.3s.2-10.6 8.9-10.2c1.6.2.8 2.1.8 2.1s2-1.3 2.8.8c0 0 2.7-1.2 3 1.5 0 0 3-.4 2.6 2 0 0 2-.5 2 1.2 0 0 2.3-.9 2 1.5 0 0 2.6-1.7 2.3 1.4 0 0 2.6-1.9 3.5 1.2 1 3.2-2.6 9.8-6.1 11.5"
        }),
        /* @__PURE__ */ jsx143("path", {
          d: "M557.9 342s1.1 8.2-3.5 11.3l.1.2c4.9-3 3.7-11.5 3.7-11.6h-.3zm-5.7 9 .2.2c3-2.9 3.7-10.6 3.7-11h-.3s-.7 8-3.6 10.8m-2.7-1.9h.3a26 26 0 0 1 4.1-10.3l-.2-.1s-3.8 5.5-4.2 10.4m-2.2-1.4h.3c.5-5.7 4.4-10 4.4-10.1l-.2-.2s-4 4.5-4.5 10.3m-3-2h.3c.3-6.7 4.8-10 4.8-10l-.2-.3s-4.6 3.4-5 10.4zm-2.8-1.6h.3c-.2-6.2 4.5-10 4.6-10l-.2-.2s-5 3.8-4.7 10.2m-5-2.3h.3a10.2 10.2 0 0 1 6.8-8.4v-.3a10.5 10.5 0 0 0-7.1 8.7"
        }),
        /* @__PURE__ */ jsx143("path", {
          fill: "#00a651",
          stroke: "#000",
          strokeWidth: 0.3,
          d: "M528.6 354.2s-1.5-9.9 4.4-13c0 0 1.1-.2 1.7 1.2 0 0 3.1-1.3 3.2 1.3 0 0 1.6-1.2 2 .5 0 0 3.3-.7 2.7 1.8 0 0 2.8-.8 2.5 1.6 0 0 2.8-1 2.4 1 0 0 3-.6 2.2 1.8 0 0 3.7-.4 2.6 2.1 0 0 2.7-.7 2 1.4 0 0 3.6.7 2 3a24.1 24.1 0 0 1-9.8 7"
        }),
        /* @__PURE__ */ jsx143("path", {
          fill: "#00a651",
          stroke: "#000",
          strokeWidth: 0.3,
          d: "M525.4 364.1s-2.4-8.2 2.2-10.3c0 0 .9-.2 1 .6 0 0 1-1.3 1.8-.1 0 0 2.3-1.1 2.9.6 0 0 1.5-1.3 2.3.6 0 0 1.5-.6 1.5 1 0 0 2-1 2 1 0 0 2-.8 1.5 1.2 0 0 3 .5 2.1 1.9 0 0 2.7.7 1.7 1.8 0 0 2.8-.3 1.3 1.6 0 0 2.2-.7 1 1.7-1.3 2.4-5.2 5-8 5.4"
        }),
        /* @__PURE__ */ jsx143("path", {
          fill: "#00a651",
          stroke: "#000",
          strokeWidth: 0.3,
          d: "M528.3 370.6s-5.1-5-2.7-6.4c0 0 1 .3 1.5 1.4 0 0 1.2-1.8 2 0 0 0 1.8-.6 1.8.7l1.4 1s1.7-.1 1.4 1c0 0 1.9-.3 1.8.7 0 0 1.6.1 1.5 1.2 0 0 2.8.5 1.5 1.9 0 0-4.8 1-8.3-.4 0 0-1.7-.6-1.9-1.1z"
        }),
        /* @__PURE__ */ jsx143("path", {
          d: "M545.9 362.4v.3a36 36 0 0 0 8.6-8.7l-.3-.2c0 .1-5.4 7.5-8.3 8.6m-1.8-1.3.2.3c2.6-1.5 7.9-8.5 8-8.8l-.1-.2c-.1.1-5.5 7.2-8 8.7zm-1.5-.6.2.2a48 48 0 0 0 7-10.3l-.2-.1s-4.2 7.9-7 10.2m-1.3-1.8h.3c.5-3.8 6-9.9 6-10l-.3-.1c-.2.2-5.5 6.2-6 10.1m-10.9-4.7h.3c-.4-5.5 4.1-11.5 4.2-11.5l-.3-.2s-4.7 6.2-4.2 11.7m2.9.5h.3c-.8-4.4 4.4-10.6 4.4-10.7l-.2-.2c-.2.3-5.3 6.4-4.5 10.9m4.4 1.6h.3c-.2-5 4.6-10 4.7-10l-.2-.3c0 .1-5 5.2-4.8 10.3m-10.5 9h.3c-1.8-4.7 1.2-10.6 1.3-10.6l-.3-.2s-3.1 6.1-1.3 10.9zm2 .4.3-.1c-1.6-4.7 1-11 1-11l-.2-.2s-2.7 6.5-1.1 11.3m8.3 4.7v.2c5-1.7 8.3-6.3 8.3-6.3l-.3-.2s-3.2 4.5-8 6.3m-1-1.1v.3c4-1.8 7.7-6.8 7.7-6.8l-.2-.2s-3.7 5-7.5 6.7m-1-.4.2.3c3-2.3 7-8 7-8l-.2-.2s-4 5.7-7 7.9m-5-2.9h.4a21 21 0 0 1 2.5-10.9l-.3-.1s-3.2 6-2.5 11zm2.2 1.4.2.2c3.2-2.9 4.3-10.6 4.3-11h-.3s-1 8-4.2 10.8m2.2.8.2.3a17 17 0 0 0 5.7-9.5h-.3s-1.2 6-5.6 9.3zm.5-13.4v.9l-3.4 11 .3.1 3.4-11c-.5-5.4 4.2-11.3 4.3-11.3l-.3-.2s-4.3 5.3-4.3 10.5"
        }),
        /* @__PURE__ */ jsx143("path", {
          d: "M539 357.3c0 .2-1.1 7.7-5.2 10.5l.2.3c4.2-2.9 5.2-10.3 5.2-10.7 1.8-2.1 6-9.7 6-9.7l-.2-.2s-4.2 7.6-6 9.8m-12 8.3c0 .1.6 4 1.4 5.2l.3-.1c-.8-1.3-1.5-5.1-1.5-5.2l-.3.1zm1.9 0-.1 5.3h.3v-5.3z"
        }),
        /* @__PURE__ */ jsx143("path", {
          d: "m529 371 .3.1c1.3-2.8 1.7-4.8 1.7-4.8h-.3s-.4 1.9-1.7 4.7m.3.1.2.3a6.6 6.6 0 0 0 3-4h-.3s-.6 2.4-2.9 3.7m.5.2v.3c2.4-.2 4-3.1 4-3.3h-.2s-1.6 2.8-3.8 3"
        }),
        /* @__PURE__ */ jsx143("path", {
          d: "M530 371.5v.3c3.9-.3 5.6-2.6 5.6-2.7l-.2-.1s-1.7 2.2-5.4 2.5"
        }),
        /* @__PURE__ */ jsx143("path", {
          d: "M530.3 371.5v.3c.1 0 5 1.1 6.7-1.4l-.3-.2c-1.5 2.4-6.4 1.4-6.4 1.3"
        }),
        /* @__PURE__ */ jsx143("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 2.8,
          d: "M420.9 193.2v136.4c0 44.6 80.6 71 80.6 71s80.5-26.4 80.5-71V193.2z"
        })
      ]
    }),
    /* @__PURE__ */ jsx143("path", {
      fill: "#012169",
      d: "M0 0h320v240H0z"
    }),
    /* @__PURE__ */ jsx143("path", {
      fill: "#FFF",
      d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0z"
    }),
    /* @__PURE__ */ jsx143("path", {
      fill: "#C8102E",
      d: "M212 140.5 320 220v20l-135.5-99.5zm-92 10 3 17.5-96 72H0zM320 0v1.5l-124.5 94 1-22L295 0zM0 0l119.5 88h-30L0 21z"
    }),
    /* @__PURE__ */ jsx143("path", {
      fill: "#FFF",
      d: "M120.5 0v240h80V0zM0 80v80h320V80z"
    }),
    /* @__PURE__ */ jsx143("path", {
      fill: "#C8102E",
      d: "M0 96.5v48h320v-48zM136.5 0v240h48V0z"
    })
  ]
});
var Fj_default = SvgFj;

// src/country-flag-icons/generated/Fk.tsx
init_esm_shims();
import { jsx as jsx144, jsxs as jsxs119 } from "react/jsx-runtime";
var SvgFk = (props) => /* @__PURE__ */ jsxs119("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsxs119("defs", {
      children: [
        /* @__PURE__ */ jsx144("linearGradient", {
          xlinkHref: "#fk_svg__a",
          id: "fk_svg__c",
          x1: 444.4,
          x2: 470.9,
          y1: 592.2,
          y2: 577.1,
          gradientTransform: "matrix(-1.08448 0 0 1.26674 909.5 -414.7)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx144("linearGradient", {
          xlinkHref: "#fk_svg__a",
          id: "fk_svg__g",
          x1: 851.8,
          x2: 646.2,
          y1: 369.9,
          y2: 369.9,
          gradientTransform: "matrix(.85733 0 0 .9624 -161.5 .3)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx144("linearGradient", {
          xlinkHref: "#fk_svg__a",
          id: "fk_svg__d",
          x1: 458.2,
          x2: 520.5,
          y1: 562.5,
          y2: 552.8,
          gradientTransform: "matrix(-1.01941 0 0 1.3554 909.5 -414.7)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx144("linearGradient", {
          xlinkHref: "#fk_svg__a",
          id: "fk_svg__e",
          x1: 472.4,
          x2: 445.3,
          y1: 578.7,
          y2: 580.2,
          gradientTransform: "matrix(1.08448 0 0 1.26674 49.7 -414.7)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx144("linearGradient", {
          xlinkHref: "#fk_svg__a",
          id: "fk_svg__f",
          x1: 518,
          x2: 456.4,
          y1: 553.7,
          y2: 558.1,
          gradientTransform: "matrix(1.01941 0 0 1.3554 49.7 -414.7)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsxs119("linearGradient", {
          id: "fk_svg__a",
          children: [
            /* @__PURE__ */ jsx144("stop", {
              offset: 0,
              stopColor: "#a43907"
            }),
            /* @__PURE__ */ jsx144("stop", {
              offset: 1,
              stopColor: "#fff"
            })
          ]
        }),
        /* @__PURE__ */ jsx144("linearGradient", {
          xlinkHref: "#fk_svg__a",
          id: "fk_svg__h",
          x1: 388.5,
          x2: 677.4,
          y1: 507.2,
          y2: 508.8,
          gradientTransform: "matrix(.88927 0 0 1.54542 50.4 -413.6)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx144("linearGradient", {
          xlinkHref: "#fk_svg__a",
          id: "fk_svg__i",
          x1: 579.8,
          x2: 556.8,
          y1: 504.9,
          y2: 505.9,
          gradientTransform: "matrix(.91096 0 0 1.52008 49.7 -414.7)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx144("linearGradient", {
          xlinkHref: "#fk_svg__a",
          id: "fk_svg__j",
          x1: 581.4,
          x2: 558.9,
          y1: 512,
          y2: 514.3,
          gradientTransform: "matrix(-.88927 0 0 1.54542 908.8 -413.6)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx144("linearGradient", {
          xlinkHref: "#fk_svg__a",
          id: "fk_svg__k",
          x1: 552,
          x2: 589.8,
          y1: 517.9,
          y2: 503.9,
          gradientTransform: "matrix(-.91096 0 0 1.52008 909.5 -414.7)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx144("linearGradient", {
          xlinkHref: "#fk_svg__a",
          id: "fk_svg__b",
          x1: 444.4,
          x2: 470.9,
          y1: 592.2,
          y2: 577.1,
          gradientTransform: "matrix(.85733 0 0 .9624 -162.4 -.6)",
          gradientUnits: "userSpaceOnUse"
        })
      ]
    }),
    /* @__PURE__ */ jsx144("path", {
      fill: "#012169",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx144("path", {
      fill: "#012169",
      fillRule: "evenodd",
      d: "M0 0h400v200H0z"
    }),
    /* @__PURE__ */ jsx144("path", {
      fill: "url(#fk_svg__b)",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 10,
      d: "M412.9 308.9a11.3 12.7 0 0 0-1.7 0c-3 .6-7.6 11.3-10 17.6-4.1 5.4-6.2 9.6-7.8 12.7-.7 1.2-1.7 2.6-1.4 4.2-6 1.6-6.3 7.4-6.3 9.6 0 2.5.7 3.7.7 3.7l3.6 7.5v.1c3.8 9 9.4 20.9 12.7 21.8 4.4 1.5 16-3.3 24.8-11.7a140.6 157.8 0 0 0 53.2 12.1c20.4 0 38.7-5.5 53-12.1 8.8 8.4 20.4 13.2 25 11.7 3-1 8.7-13 12.6-21.8l3.5-7.6s.7-1.2.7-3.6c0-2.2-.3-8-6.3-9.6.3-1.6-.6-3-1.3-4.3-1.7-3.2-3.8-7.4-7.7-13-2.6-6.2-7.2-16.7-10-17.2-4.2-.8-13 1.5-13 2.4v.4l-17.7 18.6c0 .5.9 14 4.3 26a126 141.5 0 0 1-43.3 8.2c-17 0-31.5-3.4-43.2-8.3a116.6 130.9 0 0 0 4.3-26L424 311.8v-.4c0-.7-6.8-2.5-11.1-2.5zm4.4 23c2.3 0 4.6 2.2 6.5 4.4l-.1 1.3a67.5 75.7 0 0 1-2.8 10.2 73.6 82.6 0 0 1-12.2-9.9c1.9-2.3 5-5.4 8.2-5.8h.4zm126.6 0h.4c3.3.6 6.3 3.7 8.3 6a73.4 82.4 0 0 1-12.3 10 67.1 75.4 0 0 1-2.8-10.3 14.6 16.4 0 0 1-.2-1.3c2-2.3 4.3-4.3 6.6-4.3zm-142.4 26.4c2.4 2 5.4 4.4 9.1 6.8a10.5 11.8 0 0 1-3.2 1.6c-1.6.4-3.1.3-4.7 0a15 16.8 0 0 1-1-5.6 60.3 67.7 0 0 1-.2-2.8zm158.2 0-.1 2.8a15 17 0 0 1-1 5.5 10.3 11.5 0 0 1-8-1.5c3.7-2.4 6.8-4.8 9.1-6.8z"
    }),
    /* @__PURE__ */ jsx144("path", {
      fill: "url(#fk_svg__c)",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.2,
      d: "M426.2 339.6s-6.1-11.1-11.1-10.2c-5.1.7-10 7.8-10.2 8.2a44.5 52 0 0 1-7.5-9.5c.3-.4 7.8-20.9 12-21.8 4-.9 12.7 1.5 12.7 2.3z"
    }),
    /* @__PURE__ */ jsx144("path", {
      fill: "url(#fk_svg__d)",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.2,
      d: "M439.8 327.7c0 .8-2.2 30.2-10.9 40.4-8.6 10.3-23 16.6-28.2 15.1-5-1.6-16.5-31.3-16.5-31.3s12.2 14.2 21.3 11.8c9.1-2.3 14.6-20.1 16.3-28.9 1.7-8.6.3-25.7.3-25.7l17.8 18.6z"
    }),
    /* @__PURE__ */ jsx144("path", {
      fill: "url(#fk_svg__e)",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.2,
      d: "M532.9 339.6s6.2-11.1 11.2-10.2c5 .7 9.8 7.8 10.2 8.2a44.5 52 0 0 0 7.5-9.5c-.4-.4-7.9-20.9-12-21.8-4.1-.9-12.8 1.5-12.8 2.3z"
    }),
    /* @__PURE__ */ jsx144("path", {
      fill: "url(#fk_svg__f)",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.2,
      d: "M519.3 327.7c0 .8 2.2 30.2 10.9 40.4 8.7 10.3 23 16.6 28.2 15.1 5-1.6 16.6-31.3 16.6-31.3s-12.3 14.2-21.4 11.8c-9-2.3-14.5-20.1-16.2-28.9-1.8-8.6-.4-25.7-.4-25.7z"
    }),
    /* @__PURE__ */ jsx144("path", {
      fill: "url(#fk_svg__g)",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.5,
      d: "M401.2 326.2c-4 5.5-6.1 9.8-7.9 13-1.7 3.2-.6 7.7 3.2 14 4.3 6.7 39 33.4 84.1 33.4 45.2 0 79.8-26.6 84-33.4 4-6.4 5-10.8 3.3-14-1.7-3.2-3.9-7.5-7.9-13 0 8.3-28.7 38.5-79.4 38.5s-79.4-30.2-79.4-38.5z"
    }),
    /* @__PURE__ */ jsx144("path", {
      fill: "url(#fk_svg__h)",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.2,
      d: "m557.7 378.8 7.8-15.1-3.9-3.2c-1 3.8-5.5 5.1-6.3 10-.7 4.7 3 9.4 2.4 8.3z"
    }),
    /* @__PURE__ */ jsx144("path", {
      fill: "url(#fk_svg__i)",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.2,
      d: "M564.8 374.5s1.4-6.8-3-7.6c-4.4-.8-6.8 3.8-6.1 2 .6-2 3.2-4 3.7-10.7.3-6.7-.4-10.3-.4-10.3s1.8-8.7 8.8-7.5c7.2 1.3 7.5 7.6 7.5 9.9a9 9 0 0 1-.6 3.5z"
    }),
    /* @__PURE__ */ jsx144("path", {
      d: "m539.2 351.7 1.5 2.8 1-.6-.7-2 .1-.3 1.7-1.2 4.4 8.7v.5l-1 .7.5.8 4.2-3-.4-.8-1 .6h-.3l-4.4-8.8 1.6-1.2h.4l1 1.6 1-.7-1.5-2.8-8 5.7zm-10.5 6.7.4.8.9-.4.3.1 3.9 8.9-.1.4-.8.6.3.8 4.1-2.5-.3-.8-.9.4h-.4l-1.8-4.3 4.3-2.4 1.8 4v.5l-1 .6.4.9 4.2-2.5-.4-.8-.9.4-.3-.2-3.8-8.8v-.4l.8-.6-.3-.8-4.1 2.5.3.8 1-.5.3.2 1.5 3.6-4.2 2.5-1.6-3.7.2-.4.8-.5-.4-.9zm-2.4 7.6.2.8 1.2-.3.4.1.9 3.7-.8.4c-2.5.8-4.4-.5-5.3-3.7-.8-3.2.2-5.6 2.5-6.4a3.5 4 0 0 1 1.4-.1l.3.2.8 1.7 1.2-.4-.7-3c-1.3 0-2.5.2-3.5.6-3.6 1.3-5.2 4.5-4.3 8.2 1 3.7 3.9 5.4 7.2 4.3a11.3 12.7 0 0 0 3.4-2L530 366l.2-.4.9-.4-.3-.9zm-9.7 10.3 4.7-1.7-.3-.9-1 .2-.3-.1-2.6-9.6.1-.3 1-.5-.2-.8-4.7 1.6.3.9 1-.3.4.2 2.5 9.5-.2.4-1 .4.3.9zm-25.5 4.6 8.3-.8-.3-3.4-1 .1-.2 2-.2.3-3.5.4-.4-4.9 2-.2.3.3.2 1.3h1l-.4-4.4h-1v1.4l-.2.4-2 .1-.4-4.4 3.1-.3.2.2.4 1.7 1.1-.1-.2-3-7.8.8v.9h1l.3.3.7 9.9-.1.3-1 .2v1zm-12.4-12.3v1h1l.2.3.1 9.9-.2.3-.9.2v.8h4.4v-.9h-1l-.2-.4V375h4.4v4.6l-.2.3-.9.1v1h4.4v-1h-1l-.1-.4-.2-10 .2-.3h1v-1h-4.5v1l1 .1.2.3v4l-4.3.1-.2-4 .3-.3h.9v-1zm-9.4-.3v3.3h1l.3-2 .2-.3h1.9v10.2l-.3.4h-1v1h4.6v-.9l-1-.1-.3-.4.1-10h1.8l.3.2.3 2h1v-3.3zM455 378.9l8 .4.2-3.3h-1l-.3 1.9-.2.2-3.5-.1.2-5 1.9.2.2.3.2 1.4h.8l.2-4.3h-.9l-.2 1.2-.2.3h-2l.2-4.6 3 .2.2.2.1 1.7h1.1v-2.9l-7.5-.4v.9l1 .2.1.3-.4 9.9-.2.3h-1v.9zm-18.6-5.4 4.4 1.6.2-.8-1-.5v-.4l2.5-9.5.3-.2 1 .3.2-.8-4.3-1.7-.2.9.9.4.2.4-2.7 9.4-.2.3-1-.3zm-7.6-3.3a8.4 9.4 0 0 0 2.6 1.6c2.4.8 4.3-.2 4.8-2.2a3 3.5 0 0 0-.5-3.2l-1.8-2c-.6-.9-.8-1.6-.6-2.5.3-.9 1.1-1.4 2.2-1 .4.2.8.4 1 .7v.3l-.2 2 1 .3.8-2.8a8 9 0 0 0-2.5-1.7c-2-.8-3.8.3-4.4 2.2a3.2 3.5 0 0 0 .4 2.8c.4 1 1 1.5 1.5 2 .9 1 1.2 2 1 2.9-.3 1-1.2 1.5-2.4 1a4 4.5 0 0 1-1.2-.8l-.1-.3.4-2.2-1.1-.4zm-9.8-4.6 7.4 4 1.2-3-1-.5-.9 1.7-.3.1-3.1-1.8 1.8-4.3 1.8 1v.3l-.3 1.3.8.5 1.6-4-.8-.4-.7 1.1-.3.2-1.7-1 1.6-4 2.7 1.5.1.3-.4 1.6 1 .5 1-2.6-6.8-3.9-.4.8.8.6.1.4-3.6 9h-.3l-.9-.3zm-1.1-15-3.7-2.9-.5.8.7.7.1.4-4.6 8.2-.4.1-.7-.5-.5.8 3.6 2.8c1.4 1 2.5 1.5 3.6 1.4 1.6-.2 3-1.2 4-3 1.8-3.4 1.3-6.6-1.6-8.8m-1.6 0 .8.6c2 1.5 2.2 3.7.5 6.6-1.7 3-3.5 3.6-5.4 2l-.8-.4 5-8.7zm29.3 13-.1.8.9.3.1.4-1.7 9.7-.3.2h-1v.8l4.1 1 .2-.8-1-.4-.1-.3.7-4.1h.3c1.5.4 1.8 1.3 1.8 3.2.1.9.1 1.7.8 2.7.3.4.7.8 1.4.9a10.1 11.4 0 0 0 1.5.2l.1-.8h-.1c-1-.3-1.5-.7-1.5-1.8-.2-1 0-2-.4-3a2.6 2.9 0 0 0-1.3-1.4c1.7 0 2.7-.9 3-2.5.4-2-.5-3.5-2.9-4zm3 1.7.6.2c1.4.4 2 1.4 1.7 2.9-.3 1.7-1.2 2.3-2.8 1.8l-.5-.1.9-4.8zm54.2 1 .1 1h1l.3.2 1.4 9.8-.2.3-1 .3.2.8 4.5-.8v-1l-1.1.2-.3-.3-.6-4h.3c1.6-.5 2.2.2 3 1.9.3.8.5 1.6 1.5 2.2.4.3 1 .4 1.8.3a12 13.6 0 0 0 1.6-.5l-.1-.9h-.2c-1.1.3-1.7 0-2.2-.9-.4-.8-.7-1.8-1.3-2.5-.4-.5-1-.8-1.8-.8 1.7-.8 2.5-2 2.3-3.7-.3-2-1.7-3-4.2-2.5zm3.5.5h.7c1.6-.4 2.5.2 2.8 1.8.2 1.6-.5 2.6-2.2 3h-.6l-.8-4.8z"
    }),
    /* @__PURE__ */ jsx144("path", {
      fill: "url(#fk_svg__j)",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.2,
      d: "m401.5 378.8-7.8-15.1 3.9-3.2c1 3.8 5.5 5.1 6.3 10 .7 4.7-3 9.4-2.4 8.3z"
    }),
    /* @__PURE__ */ jsx144("path", {
      fill: "url(#fk_svg__k)",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.2,
      d: "M394.3 374.5s-1.4-6.8 3-7.6c4.4-.8 6.8 3.8 6.2 2-.7-2-3.3-4-3.7-10.7-.4-6.7.3-10.3.3-10.3s-1.7-8.7-8.8-7.5c-7.1 1.3-7.5 7.6-7.5 9.9 0 2.2.7 3.5.7 3.5z"
    }),
    /* @__PURE__ */ jsx144("path", {
      fill: "#0072c4",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 3.9,
      d: "M480.5 356.1s-82-27-81.4-129.4l.6-135.6H561l.6 134.8c.5 102.4-81.4 130.1-81.4 130.1z"
    }),
    /* @__PURE__ */ jsxs119("g", {
      fillRule: "evenodd",
      children: [
        /* @__PURE__ */ jsx144("path", {
          fill: "#bcbcbc",
          d: "m410.3 123.6 2-2c1.3-.8 2.4-1.7 3.7-2.4 1-.6 3-1.1 3.7-1.6a9.2 10.3 0 0 0 3-2.8c.2-1.7.5-3 .5-5a12 12 0 0 1 3.6-2c1.7-.6 2-1.4 3.8-1.7 1-.4 2.8-.4 4.4-.4 1.6 0 2.7 1.4 4.2 1.6 1.8.8 2.6 1.4 4.1 2.8a7.5 7.5 0 0 0 2.6 3c1.1.6 2.2 1.6 3.4 2 1.5.9 2.7 1.4 3.8 2.8 1 .8 1.4 2 2.3 2.7a26.5 29.7 0 0 0 3.4 2.8c1.5 1.1 3 2 5.2 1.7 1.3 0 2.6-.3 4 0 1.8 0 3.4 0 4.8.5 1.8 0 3.2.2 4.8.4 1.5.2 3 .3 4.7.3 1.5.5 3 .4 4.8.4h9.5c1.7 0 3.4.1 4.7.4a37.4 42 0 0 0 4.7-.4c1.9 0 3.3-.3 5-.4h5.8c1.5.5 3.4.8 4.4 1.7 1.4.4 2 1.1 3.4 1.5a11 11 0 0 1 3.4 2.8 18.1 20.3 0 0 1 2.7 4.4c1 1.5 1.3 3.3 2 5.2.4 1.8.7 3.5.7 5.5.4 1.7.3 3.6.3 5.6-.3 1.8-.4 3.8-1 5.5 0 2-.4 3.7-.7 5.2-.2 1.6-.6 2.7-.7 4.7v5.6c0 1.8-.4 3.2-.6 5.1a52 58.4 0 0 0-2.4 6 10.8 12 0 0 0-2.7 3.2c-.7.5-1.1 1.3-1 1.6 1.4.5 1 1.6 1 3.5l.7 5.2c.1 2 .5 3 1 4.4.6.8.7.4-.7.4-1 .8-2 .4-2.3-1.2a8.8 9.9 0 0 1-1.4-4.4c-.2-1.8-.5-3.6-1-4.8-.2-2.2-.7-2.2-2.7-2.4-1-.9-2.2-1.1-4-1.1-2 0-2-.2-2 2v5.6c-.4 1.6-1 2.8-1.5 4.3-1 .8-1.4 2.2-2.7 3.2-.5 1.8-1.4 2-3 2.4l-2-2.8c1-1.8 1.7-2 2.3-4 .8-1.6 1.2-2.6 1.7-4-.7-1.2-1.3-1.8-2-3.5a19.3 21.6 0 0 1-1.7-4.4c-1.1-.4-2.9-.5-3.7-1.2-1.7-.4-2.1 1.7-4 1.7h-4.8c-2.1 0-2.6 1.2-4.4 1.1-.5.2-1.8 0-3.7 0-1.5.6-3.2.4-4.8.4-1.7 0-3-.5-4.4-.8-1.5-.5-3-1-4.7-1.2-2 0-2.7.2-4 1.2-1 .7-2.6 2.3-3.7 3.2-.5 1.3-.8 3.5-1.5 5.1-.3 1.7-.9 2.6-1.2 4a13.5 15.1 0 0 0-1 4.8c-.2 2.6-.7 2.3-2.1 1.6-.6-1.2-1.5-2.3-2-3.6.2-2 .7-3 .7-5.1-.4-1.7-1.1-1.5-2-.5 0 2.1 0 3.7-.8 4.8a4.4 5 0 0 1-2 3.1 4.7 4.7 0 0 1-2.7 2.8c-.2 0 0-.5 0-1.6-.8-1.7 0-3.3 0-5.5 0-2-.2-3.3.4-5.1 0-2-.8-3.8-1-5.2-.7-1.5-1.1-2.2-2.8-2.8-1.2-.6-3-1.2-3.7-2.5a7 7.9 0 0 0-3.1-2.7c-1.5-.6-2.3-1.2-3.4-2-1-1.3-1.9-1.8-2.3-3.5-.7-1.2-.8-3.5-1.3-5.2a15.9 17.8 0 0 0-1-4.7 17.8 20 0 0 0-1-4.8l-1.1-5.2c0-1.9 0-3.8-.4-5.5v-5.6c-.2-1.7-.3-4-.6-5.2 0-2.1-.3-3.3-.8-4.8-.7-1.4-.7-2-2-2.3-.8 1.2-2.2 1.8-4 2-1.2-.3-3-.6-4.4-1.2-1.4-.4-2.2-1-3.3-1.7a31.7 35.5 0 0 0-2.1-3c-.2-2.1-.6-3.2-.7-5.3 0-1.5 0-.6 1.4-2.7"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "#fefefe",
          d: "m430.3 138 .3-.4c-.6.7-.4.3 1-.3.6-.4 2-1.4 2.5-2 .6-.3 1.7-.7 2.2-1.3.6-.8 1.3-1.5 2.2-2.2.9-1 1.7-1.3 2.8-2 1.3-.2 1.9-.8 3.1-.3 1.2.3 1.7.3 2.6-.9 1-.6 2.1-1.4 2.5-2.4v-1.8c0 1.8-.4 2.5-1.5 3-.7 1.1-1.8 2.2-2.2 3.2-.7 1.2-.9 1.9-1.6 2.5-.7.9-1.7 1.4-2 2.8.4.7 0 1 .8 1.1.7.7 1.4.4 2.4 0a10.4 11.7 0 0 0 1.9-3.3l1.7-2.9c.8-.6 1.3-1.1 1.6-2.2 1-.6 1.8-1.3 2.5-2 .7-.4 1-.9 2-1.1a4.4 5 0 0 1-.7 3.1c-.2 1.6-.1 2.3.3 3.3.7.6.6 1 1 2 .4-1 .6-2.7.7-3.9v-.2c0 1.1 0 2.8-.3 3.6 0 1.6.4 2.4.8 3.6.3.7.7 1 1.1 1.4 0-1.6.5-2.6.6-4.1l.4 3.9c0 1.3.5 2.3 1 3.3.5.4.7 1.5.9.6.6-2 .6-4 1-6.2 0-1 0-2.6.5-3.3l-.6 3.3c.1-1 .2-2.5.6-3.3v-.4a28.6 32 0 0 1 .5 4.6c0 1.2-.1 2.4.2 3.6.7-.4 1.2-1.4 1.7-2.5a13.3 15 0 0 1 1.9-3.1l-2 3a13.3 15 0 0 1 2-3v-.2a29.5 33.1 0 0 0-.2 3.8c0 1.3 0 2.8.2 3.7.3 1.5.6 1.7.7 3.3 0 .8-.1 1.7.2 2 1 .3 1-.3 1.2-2 0-1.7.4-3 .5-4.7 0-2.1.2.3.5 1a9.5 10.7 0 0 1 .7 3.8c0 .8 0 1.6.2 2 1-.5 1.3-1.7 2-2.3.4-1.4 1-2 1.4-2.8 1.2-.3 1.2-.9 1.2-2.5 0-1.4-.1-2.8.3-4a30 33.7 0 0 0 .9-3.7c.4-.2.9.5 1.2 1.2.5.9.4 2.2.4 3.6a14 14 0 0 0 1.3 3.4 11 12.3 0 0 0 1.6 2.8c.3.9.3 2.5.3 3.7 1-1.2 1-3 1.1-4.8-.1-1.2-.1-2.8-.4-4 0-1.2-.3-2.4-.5-3.3-.7-.4-1-.8-.2-2 .7-.7 1.6-.4 2.8-.2.7.7.9 1.1 1 2.8 0 1.5 0 2.6.5 3.6.4.8.9 1.4 1.2 2.8.3.4.6 1 1.1.3.3-.8.5-2.4.8-3.4.2-1 .6-1.6 1.1-2 0 1.6 0 2.5.6 3.7l1.1 3.1c.5.4.6 1.3 1.3 1.7l.2-4.5v-4c0-1.2.4-2 .7-3 .8 1.1.8 1.5.8 3 .7-.3.8-1 1.1-1.9.5-.6.8-.8 1 .6.1 1.5.4 2.8.7 4.2.5.6 1 2.2 1.6 2.8a12 13.5 0 0 0 1.5 2.3c.4.8.4 1.4 1.5 1.6 0-1.9 0-3.8-.3-5.6 0-1.6-.3-2.2-.5-3.7-.4-.9-.6-2.4-.5-2.8a8 9 0 0 1 2.2 3.4l1.5 3.7a14.7 16.5 0 0 1 1.8 2.8c.9.8 1.3 1.7 2.2 2.5.4.5 1.5.8 1.7.5 0-1.6-.3-3-.7-4.4a6.6 7.4 0 0 0-.8-3.4c-1-.9-1.7-1.5-2.2-2.8-.3-.4-.3-.6-.4-1.4a19.3 21.6 0 0 1 3.4 3.9 5.1 5.8 0 0 0 1.9 2c.4.6 1.8 1.4 2.8 1.6a4.1 4.6 0 0 0 2.4 1.7l-2.4-1.6a4.1 4.6 0 0 0 2.4 1.6v.4a9.5 10.7 0 0 0-1.4-4.6 6.4 7.2 0 0 0-2.2-3 6.8 7.6 0 0 0-2.4-2.5c-.6-.9-1.6-2.4-2.2-2.8 1.1-.9 2.3.4 3.4 1 1 1.2 1.8 2.7 2.4 3.4a13.2 14.8 0 0 0 2.2 3.7c1 .7 1.7 1.3 2.6 2.2 1.4.4.9-.1.5-1.4-.5-1.6 0-1.6 1-.6.6.6 1.4 1.4 2.4 2 .3.6 1 1 1.6.6.3-.4.3-.4.3-.8-.5-1.8-1-3.2-2.2-3.7-.5-.9-1.5-1.7-2.2-2.5-.5-.8-1-1.3-1.4-2.3l1.4 2.2c-.5-.8-1-1.2-1.4-2.2h-.2c1.4 0 2 .5 3 1.2a5 5.6 0 0 1 2.2 2c.5.6 1.2 1.3 1.7 2.1l2.4 2c.8 1.2 1 2 1 3.6.4.9.5 2.5.7 3.4-.2 1.6-.7.3-.8-.6-.1-1.2-.6-1.1-1.4-.8 0 1.7.2 2.2.7 3.4a5.9 6.6 0 0 1-.9 2.8c-.6.4-.7-.8-1.2-1.4 0-1.7-.5-2-1.5-2.8v1.1c.6 1.2 1.2 2.3 1.2 3.9a8.8 9.9 0 0 1 .6 3.7c0 1.4 0 2.7-.3 4 0 1.4-.3 2-.3 3.6v7.9a17 19.2 0 0 0-.2 3.6l.2-3.6c-.2 1-.2 2.2-.2 3.6v.2c-.4-1.4-1-2.6-1.2-4a7.5 8.5 0 0 1-1.6-3c-.3-1.2-.3-2.6-.5-3.6-.4-1-.8-2-1.5-1.4-.3 2 0 3.3.7 5.3.4 1.3.4 2.5.8 3.7.5 1.5 1 1.6 0 3.3-.6 1-.8 1.2-1 2.3-.9.5-1.1.8-1.2 2-.3-1.1-1-2.4-1.4-3.7-.5-1.4-1-2.8-1.2-4-.6-.9-1.3-2.4-2-3l-1.8-3.3c-1-1.3-1.2-2-2-2.6-.1-.5-.4-1.3-1-.8 0 1.3 0 2.7.3 3.9.3 1.6.7 2.5.8 4.2v3c-.6-1.6-1.3-2.9-1.7-4.4-.6-.9-1.1-2.5-1.7-3-.4-1.2-.7-2.1-1.2-2.9-.1-.8-.5-.8-.8-1.4 0 1.6.5 2.2.8 3.3.5 1.2.6 2.9.5 3.5-.6-2-1.2-4.1-2-6a26 26 0 0 1-1.8-3.7c-.8-.9-1.5-1-2.2-1.6a4.3 4.9 0 0 1-1.7-1.4c.2 1.5.7 2.5 1 3.6.2 1.4.7 2.6.9 3.7-.2 2-.6-.5-1-1.4-.2-1.6-.7-2.4-1.1-3.3-.7-.6-1.3-1.5-2-2-.7-.3-.4 0-.4 1 0 1.8 0 3 .5 4 .5.8.5 1.9.5 3.4-.1 1.4-.3 2.4-.3 4v2.1c-.5-1.1-1-1.9-1.5-3.3-.7-1.3-1-2.3-1.6-3.7-.5-.2-1.5-.4-2 0 .2 1.4.7 2 .8 3.7-1 1-.8 1.4-1.4-.3-.6-1.3-1.2-1.2-2-2-1.2-.1-.8-1-1.1-2.3 0-1 0-2-.3-3-1.3 0-2 0-2.9.8-.3.8-.2 2.5 0 3.7v3.9c-.3 1-.7 1-1 2.3-.4 1.1-.5 2.5-.9 3.3-.9.9-.5 1-1-.5v-9c0-1.5.3-2.3.3-3.7-.5-1.1-.6-1.4-2.2-1.4a6 6 0 0 0 0 2.8c0 1.4.1 2.7.3 3.7l.2 3.6c0 1.5-.3 2.7-1 3.3-.8.4 0 1-.9 1.3a11 12.3 0 0 1-2.6-2c-1-.3-1.8-.6-3.1-.6-1.6 0-1.6-.2-2.2-1.6a23 25.8 0 0 1-1-4.6c-.5-1.3-.6-2.2-1-3.7a4.5 5.1 0 0 0-1.4-2c-.3 1.6-.6 2.7-.6 4.3-.3.7-.4 2.4-.6 3-.4-.7-.6-2.4-1-3.5-.3-1.7-.7-2.8-2.3-2.2-1.6 0-1.6 0-1.6 2l1.9 3.2v4c0 1.6 0 2.1-1 2.4-.4-1.6-1.2-3.3-2.2-4.7 0-1.1-.4-.8-1.4-.8-.6 0-1.3-.1-1.7.3v2.4c-.5.2-.7 0-1.1-.5-.5.9-.2 2 0 3a10 10 0 0 1-1.2 3.2c-.2-.4-.4-.2 0-.2-1.7-.8-3-1.2-4.4-1.7-.7 0-1.4 1-1.8 1.7-1.3.4-1.8.8-3.2.8l-3 .2c-1 .3-2 .4-3.2.4-.6-.3-1.8-.3-2.1-.6.5-.8 1-1.2 1.4-2.5a14.7 16.5 0 0 0 2-2l1.8-2.3c.4-1.4 1-1.6 1.7-2.2 1.5 0 1.7.6 3.1.8 1.4.6 2.2.9 3-.3 1-.5 2-1.4 3.2-1.6l2.4-1.7c1-.7 1.5-1.5 2.4-2.3.3-1.1 1-2 .7-3.3-1.3-.4-2.1-.3-3 .5-.9 1-1 1.4-2.3 2.2-1 .4-1.4.9-2.6 1.2-1 .4-2.2.2-3.3.2s-2.5 0-3.1.4c1-.8 2.3-1.7 3.3-2 1-.7 1.4-1 2.7-1.2.6-.8 1.1-.8 1.4-2.2.4-1.6-1-1.1-2-.5-.9.2-2 1-2.8 1.3a10.5 11.8 0 0 1-3 .6c-.4-.5.1-.9.4-1.6 1-.5 1.3-.7 1.4-2-1.3.2-1.7.7-2.9.8a18 18 0 0 1-3.8.6h-3.3c-1.2 0-1.8-.3-3.2-.3-1-.6-1-.8-1-2.5.8-1 1.5-.8 3-.8l2.6-1.5c.9-.2 1.4-.6 1.2-1h-3.3c-1.4-.7 0-1 .7-1.5 1 0 2.3 0 3 .5 1.5 0 2-.5 3.1-1.6 1-.8 1.5-1.4 2.5-2 .7-.9 1.4-1.4 1.9-2.2 1-1 1.7-1.7 2.2-2.6.6-.4 1-.8.7-1.4-1.5.2-2.2.9-3.2 1.7a7.3 8.2 0 0 1-1.9 1.6 6 6.7 0 0 1-3.1 1.3c-1.2 0-2.2-.3-3.3-.4-1.3-.1-.2-.5.2-1.1.5-.3.9-1.2.5-2-1-.3-2.2-.2-3.3-.2h-3.4c-1.3 0-1.8-.4-2.7-.9-.2-.8 0-.5 1-.5a13.2 14.8 0 0 0 3.1-.6c1.1-.3 1.3-.8 1.5-2.2-1.2 0-2.4 0-3.1-.3zm-20.7-6.5c-.2-2-.7-3.1-.7-5.2 0-1.5 0-.6 1.4-2.7l2-2c1.3-.8 2.4-1.7 3.7-2.4 1-.6 3-1.1 3.7-1.6a9.2 10.3 0 0 0 3-2.8c.2-1.7.4-3 .4-5 1.4-1 2.5-1.6 3.7-2 1.7-.6 2-1.4 3.8-1.7 1-.4 2.8-.4 4.4-.4 1.6 0 2.7 1.4 4.2 1.6 1.8.8 2.6 1.4 4 2.8.8 1.2 1.4 2.2 2.7 3 1.1.6 2.2 1.6 3.4 2 0 1.4.3 1.2-.6 1.2-.1 1.5-.4 1.3-1.7 1.4a5.9 6.6 0 0 1-2.2-2.3c.6-1.4.3 1.2 0 1.7-.5.6-.9 1.2-1.6.6-.4-1.4-.7-2.3-.7-4-.2-1.7-.7-.5-1 .3-.3 1.5-.2 2 .3 3.1-1.3 0-2.2-.2-3.1-.3-.9-.3-2 0-3 .6-1.2.9-.7.9-.2 2 1.1.3 2 1 3 1.6l3.3-.8c1.1-.5 2.2-.2 3.3 0 .6.4 1.4.4 1.7.8 0 .9 0 1.8-.3 2.3-.4.4-1 1.4-1.7 1.6a11.8 13.2 0 0 1-3.2 1.5c-1.5 0-2.1.4-3.2 1-.1 1.6-.5 1.9-1.7 2.4a7.5 8.5 0 0 1-3.3.8c-.7 0-1.4 0-1.7-.3a9.4 10.5 0 0 0 2-3.3c.2-.7.6-1 .2-1.5-1.4 0-1.8 0-2 1.6-.1 1.6-.6 1.9-1.6 2.4.3-1.4.3-2.5.7-3.7a18.3 20.6 0 0 1-3 .3c-.8.5-1.1.7-.8 1.6-1 .4-2.2.2-3.4 0-1 0-.4-.5-1.2-1-.5-1.1-1-1.4-2.2-1.4-.5.8-1.4 1-2 1.6-1.1.4-1.8 0-2.7-.5-1.2 0-1 .4-.7 1.4.5.3 0 .7.7.8.7.7 1.3.9 2.6.9 1-.4 2.2-.3 3.4-.3 1.2 0 1 .3 1 1.6-.8.7-2 .6-3.2.6a12.2 13.7 0 0 1-2.9-.8c-1 0-2-.3-2.8 0-.4.5-1.5.7-.2.8.5.6 3.3.3 3.4 1.3.7.8.5 1.9-.6 1.9a1.6 1.8 0 0 0-1.7 0l-3.1.1c1.8.2-1.3-2.2-2-3.2"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "#bcbcbc",
          d: "m417.1 122.2-1.4 1-2.9 2.3c-.5.5-.5.8-1.1.8 1-.1 1.6-.5 2.6-1 1.2-.2 2.4-.5 3-1.2.7-.2 0-1.3-.2-2zm11-13.2c.2 0 .5.8 1 1.4.4 1 .7 1.8.7 3 .3-1.3.8-2.4 1-3.9-.4-.8-.4-1-1.5-1.1 0 .8.2.2-1.2.6"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "#c4c4c2",
          stroke: "#000",
          strokeWidth: 0.9,
          d: "M349.4 417.7c-.5 0 .8-.5 1.3-.6.4-.8.6-1.3 1.3-1.8 1.1 0 1.7.4 2.2 1.1 1 .3 1.3.7 2.4.9.5.4 1 .4 0 .7-.6.3-1.5.4-2.6.4a7.2 7.2 0 0 0-2.6.7c-1.5 0-1.3 0-2-1.4z",
          transform: "matrix(1.08448 0 0 1.26674 42.6 -410.2)"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "#bcbcbc",
          d: "M432.5 109.2v.3c0-.8 0-.4.2 1.2a6.6 7.4 0 0 1 .5 3.3 5 5.5 0 0 0 1.5-2.5c0-2.2-.4-2.1-2.2-2.3m8.8 32.3h.3c-.8 0-.3 0 .9-.8.8-.6 1.5-1.6 2.6-2a9.5 10.7 0 0 1 3.1-2c.6-.3 1.1-.8 1.7-.2-.1 1.3-.4 2-1.5 2.5-.5.8-1.3 1.3-2 1.6-.8.5-1.7.5-2 1.5-1.3.7-1.5.5-3-.6zm4.6 8.2c.3-.4 1.9-2.2 2.6-2.8a11 12.3 0 0 1 2.4-2.8c.7-1.2 1.6-2 2.2-3.1l1.9-2.8c0 1.2-.2 2.8.2 3.6a5.1 5.8 0 0 1-.8 3.4c-.5 1-1 1.6-2.2 2.3-1 .6-1.6.8-2.5 1.6a19 21.4 0 0 1-2.2 1.4c-.7.3-.4.3-1.6-.8m-7.5 6.4h.3c-.7 0-.4 0 1-.8 1-1.2 1.8-1.7 3-2.2a7.5 8.5 0 0 0 3-.9c.5-.1 1-.5 1.3 0 .8 1.2 1 1.5-.2 2.3a6.9 7.7 0 0 1-2.4 1.4c-.6.5-1.8.5-3 .8-.8 0-1.4.1-1.8-.6l2 .6c-1 0-1.5.1-3.2-.6m10.3 0v-.2c0 .8 0 .4.5-1.2 1-1.6 1.2-2.5 2.4-2.8.5-.8 1.5-1 2.6-1.4.5.8.1 1.8 0 2.8-.3 1-1.1 1.8-1.7 2.6-.7.5-1 1.1-2.2 1.4-.8 0-.3 0-1.6-1.2"
        }),
        /* @__PURE__ */ jsx144("path", {
          d: "M425.3 119.7c0 .7-.5 1.4-1.2 1.4s-1.2-.7-1.2-1.4c0-.8.6-1.4 1.2-1.4.7 0 1.2.5 1.2 1.4"
        })
      ]
    }),
    /* @__PURE__ */ jsxs119("g", {
      fill: "#005120",
      fillRule: "evenodd",
      stroke: "#002b0d",
      strokeWidth: "1pt",
      children: [
        /* @__PURE__ */ jsx144("path", {
          d: "M351.8 479.6h.9c-2.8 0-1.1-.2 3.5 3.5 2-1.6 2-1.8 3.5 1 1 1.5 1.2-.2 2.7-1.8.7 3.2 1.1 6.5 3.5 3.5 2.8 0 5.6-.2 7.1.9 1.8 3.3 1.2-.6 2.6.9 4 .4 3.9-3.4 8.1-4.4 2.6 3.3 3.8.8 7-.8 2.5.6 4.8 4.3 5.3.7 2-3.2 2.1-3 3.5 0 2 1.8 2.8-.8 4.4-1.7 3 1.7 6.3 2 10.6.9.8 2.9 2.6 1.6 4.5.8 3.9 1.7 5.2 2.2 9.7 0 2.2-2.6 1 .1 2.6 1.8 3.3-1 2.4-1.2 6.2-.9 3.9 0 4.2 0 5.3-2.6 2 1.9 2.6 3.3 5.3.9 4.2 0 2.9.5 5.3-1 1.9 4 2.3 1.2 4.5 2.7a14.5 14.5 0 0 1-6.2 7c-1.7 3-2.8 6-6.2 7.2-2.5 2.5-5.2 4-8 6.2-3.8 1-8 .8-12.3.8H388c-2.6 1.4-7 2-10.6 2.7-4 0-8.7 0-11.5-.9-1.9-1.9-5.2-4-7-6.2-2-1.5-2-4.4-3.6-6.2-1.4-2.5-2-6.5-3.5-8.8z",
          transform: "matrix(1.08448 0 0 1.26674 47.3 -411.4)"
        }),
        /* @__PURE__ */ jsx144("path", {
          d: "M437.5 487.6v.8c0-2.4.1-1.1-1.8 3.6-.3 1.1-1.2 1.4-2.6 1.8m-3.5-2.7h.9c-3.3 3-5.5 4.5-6.2 8l6.2-8c-3.3 3-5.5 4.5-6.2 8m-7.1-12.4s-.1 3.1-.9 4.4m-2.6 1.8v.8zm-7.1-5.3h.9-1c.4 0 .7 0 0 0zm-49.5 0c.4 0 2.2 2.8 4.4 4.4-.5 2.6-1.4 5.6 0 8m2.7-7.1c.4 0 2.1 2.8 4.4 4.4l-4.4-4.4c.4 0 2.1 2.8 4.4 4.4v.9c0-2.8-.2-5.6.9-7.1 1 1.7 2.2 4.3 2.6 1.8 5-.2 7.4-1.6 10.6-2.7 0 1.3-.2.7 1 1.8m60-3.6h.9c-1.7 1.4-3 4.3-4.4 6.2m-32.7-8.8h7",
          transform: "matrix(1.08448 0 0 1.26674 47.3 -411.4)"
        })
      ]
    }),
    /* @__PURE__ */ jsx144("path", {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M425.9 214.3c-11.5 0-15.4 13.5-26.9 13.5h-.6v.8c0 9.4.6 18.1 1.8 26.2 10.6-.8 14.5-13.4 25.7-13.4 11.5 0 15.3 13.4 26.8 13.4 11.6 0 15.4-13.4 26.9-13.4 11.5 0 15.4 13.4 26.9 13.4 11.5 0 15.3-13.4 26.8-13.4 11 0 15 12.5 25.6 13.4a139 156.1 0 0 0 1.9-27h-.7c-11.5 0-15.3-13.4-26.8-13.4s-15.4 13.5-26.8 13.5c-11.5 0-15.4-13.5-27-13.5-11.4 0-15.3 13.5-26.8 13.5-11.4 0-15.3-13.5-26.8-13.5zm0 52.7c-9 0-13.2 8.2-20.2 11.8a111 124.5 0 0 0 8.6 20.5c3.3-2.8 6.7-5.2 11.6-5.2 11.5 0 15.3 13.5 26.8 13.5 11.6 0 15.4-13.5 26.9-13.5 11.5 0 15.4 13.5 26.8 13.5s15.4-13.5 26.9-13.5a18.3 20.6 0 0 1 11.3 5 112 125.7 0 0 0 8.6-20.4c-6.7-3.7-11-11.7-20-11.7-11.4 0-15.3 13.5-26.8 13.5S491 267 479.6 267s-15.4 13.5-26.9 13.5c-11.4 0-15.3-13.5-26.8-13.5m53.7 52.7c-11.5 0-15.4 13.5-26.9 13.5-10.9 0-14.9-12-25-13.4a132 132 0 0 0 39.3 33c3.6-3.2 7.3 3.6 12.5 3.6 5.3 0 9-6.9 12.5-3.8a129.1 145 0 0 0 39-32.7c-9.8 1.7-14 13.3-24.6 13.3-11.5 0-15.3-13.5-26.8-13.5"
    }),
    /* @__PURE__ */ jsxs119("g", {
      transform: "matrix(.86465 0 0 .97062 -175.4 2.5)",
      children: [
        /* @__PURE__ */ jsx144("path", {
          fill: "none",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M332.5 541.4a110 110 0 0 1 10.5-3l16.3 15.7-13.4 2.7z",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "none",
          stroke: "#512007",
          strokeWidth: 0.6,
          d: "M413.6 471c.3-4.6 8.8-31 8.8-31m-5.9 31.3 6.7-31.1m-4.4 31.2 5.6-31.2m-10.5 27c1.5-.8 5.8-2 5.8-2m-3.7-2.6c1.4 0 4.3-1.2 4.3-1.2m-3.5-2.3a24 24 0 0 1 4.4-1.2m-3.8-3.2 4.7-.8m-2.6-3c0 .3 3.2.3 3.2.3m-2.4-3.7 3.2.5",
          transform: "matrix(1.06 0 0 1.03 276.8 -178)"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "none",
          stroke: "#512007",
          strokeWidth: 0.4,
          d: "M413.6 471c.3-4.6 8.8-31 8.8-31m-5.9 30.1 6.7-30m-3.7 27.7c.2-1.7 4.9-27.6 4.9-27.6m-10.5 27c1.5-.8 5.8-2 5.8-2m-3.7-2.6c1.4 0 4.3-1.2 4.3-1.2m-3.5-2.3a24 24 0 0 1 4.4-1.2m-3.8-3.2 4.7-.8m-2.6-3c0 .3 3.2.3 3.2.3m-2.4-3.7 3.2.5",
          transform: "matrix(-1.25 0 0 1.76 1290.4 -502)"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "none",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M413.6 471c.3-4.6 8.8-31 8.8-31m-5.9 30.1 6.7-30m-3.7 27.7c.2-1.7 4.9-27.6 4.9-27.6m-10.5 27c1.5-.8 5.8-2 5.8-2m-3.7-2.6c1.4 0 4.3-1.2 4.3-1.2m-3.5-2.3a24 24 0 0 1 4.4-1.2m-3.8-3.2 4.7-.8m-2.6-3c0 .3 3.2.3 3.2.3m-2.4-3.7 3.2.5",
          transform: "matrix(-1.25 0 0 1.3 1321.3 -302)"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "#dd8b59",
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "m395.3 572.2.9-73s2.6-.3 2.6 0-.3 72.7-.6 73c-.3.3-3.2.5-2.9 0zm28.5-69.8-.6 61.3-2 2.4.6-63.7z",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "#dd8b59",
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M363 560.2s3 30 36.4 29.1c33.4-.9 42.7-30.2 42.7-30.2l-14.5-.6c-.3 0-11.6 14-26.2 13.7-14.6-.3-19.2-3.8-22.4-6.7-3.2-3-6-7.3-6-7.3l-17-6.7 1 6.4zm90.3-3-1-4v-3.4l1.6-3.6s-25.3 3.7-25.3 4l-.1 6.8 24.8.1z",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "none",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "m448.5 549.8-.6 6h4.1l-.3-6zm-4.3.3-.3 6.4 2.6-.3.3-6.1zm-4.4 6.4v-5l2.6-.9.3 5zm-5-.3.6-4.4 3 .3.2 4.7zm-5.5 0 .3-3.8 3-.3v4.4zm-67.4 3.7c.9 0 7.6 1.5 7.6 1.5l7 9.3",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "none",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M366.8 561.1c.3.3 6.1 19.8 34 19.8s34.6-22.1 34.6-22.1",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "none",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M439.8 559.4s-13.4 29-39 27c-25.5-2-29.6-11.6-31.6-16.6-2-5-3.2-9-3.2-9",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "#dd8b59",
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M373.2 558.2c.3-1.7.3-54.4.3-54.4l-1.7-.2-.3 53.7 1.7 1zm-41.5-17.1 22 10.7-.5 1.5S332 543.3 332 543c0-.3.2-1.5-.3-2z",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "#dd8b59",
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M341.8 537.9c0 .8 3.2 18.6 3.2 18.6s2 .3 2 0l-3.4-18.3zm20.4.5c1.1 0 21-3.2 21-3.2l-.4 3.2-19.5 2z",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "#fecf3e",
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M365 514.3c.7 0 7 3.2 9.7 2.4 2.7-.8.9-3 1.4-3 .6 0 2.6 1.5 3.8.3 1.2-1.1 2-4.6 1.5-4.3-.6.3-16 5.8-16.3 4.6z",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "#dd8b59",
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M362.5 521.6c1.1.3 23.8-6.1 23.8-6.1s0 2-.3 2l-23.5 6.1z",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "#fecf3e",
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M415 512.6s1.5 3.5 3 2.9c1.5-.6 2.9-1.8 2.9-1.8s1.2 3 3.2 2.4c2-.6 3.2-3.8 3.2-3.8s2 .6 2.9.3c.9-.3 2-5 2-5zm-1.7 28.2c-.3.6 1.5 2 3 2s2-2 2.3-1.4c.3.5.3 3.2 4 2.3 3.7-.9 3.8-3.5 3.8-3.5s-1.1.9 1.5 1.2c2.6.3 5.2-3.8 5-3.8-.4 0-19 3.5-19.6 3.2z",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "#dd8b59",
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M363.4 513.1a5 5 0 0 0 .2 2.7l19-6.4s.8-1.5 0-1.5-19.5 5.8-19.3 5.3zm25-4c.5 0 19.4-6.1 19.4-6.1s.3 2.6 0 2.6l-17.7 5.2-1.8-1.7z",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "#fecf3e",
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M413.3 521.9s-2.9 3.2-2 7.5c.9 4.4 2 8.2 2.3 8.2.3 0 3.5-5.8 7-6.1 3.5-.3 9.9 3.2 9.9 3.2s-.9-7-.6-10.2c.3-3.2 5.2-8.7 5.2-8.7l-21.8 6z",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "#dd8b59",
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M386.9 516.6s-.6 2.7-.3 2.7l24.7-6.4V511l-24.4 5.5z",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "#b6b6b4",
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M355.5 551.8s-5.8-.8-5.5.6c.3 1.5 2.9 2.9 3.2 3.8.3.9-.9 4 .9 3.8 1.7-.3 3.4-1.5 3.4-2.4l-.3-5z",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "#dd8b59",
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M387.8 537.3v2l20.9-2.9-.6-1.5z",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "#fecf3e",
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M363 540.8c.4 0 0 2.6 2.4 2 2.3-.6 2.9-2 2.9-2s.6 3.2 3.8 2.9c3.2-.3 5-3.8 5-3.8s.2 2.6 2.2 1.7c2-.9 2.6-2.9 2.6-2.9l-18.3 2.6zm0-17.2s-2.6.9-1.7 6.1c.9 5.2 3 8.2 3.2 8.2.3 0 2.6-5 6.1-5.8 3.5-1 9.6 2.6 9.6 2.6s-.6-4.7.3-9a18 18 0 0 1 3.8-7.6s-20.4 5.5-21.2 5.5z",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "#dd8b59",
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "m411.9 538.7.3 1.8s21-2.6 21-3c0-.2 0-2-.4-2-.3 0-20.6 3.5-21 3.2zm-.3-18.6.3 2 24.7-6.6s.6-1.8.3-1.8-24.7 7.3-25.3 6.4z",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "none",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M414.2 510.8s-.3 1.8 0 1.8 18.3-4.4 18.3-4.7c0-.3 1.8-2 .3-1.7-1.4.3-18 5.5-18.6 4.6zm38.7 33.7-18-28.4m-2.4 19.7c.3-.8 1.2-18.3 1.2-18.3",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "#fecf3e",
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M389 510c1 .2 3.1 3.2 4.3 2.6 1.2-.6 2.9-2.4 2.9-2.4s-.3 3.5 2 3c2.4-.6 2.7-3 2.7-3s1.7 1 3.2 0c1.4-.8 2.8-5.2 2.3-5.2s-16.9 5.2-17.5 5zm-.6 8.4c0 .6-3 5.2-2 9.6 1 4.4 2.5 8.4 2.8 8.4.3 0 4.7-4.6 8.5-5.5 3.7-.9 9.3 2.9 9 2.9-.3 0-1.5-4.4-1.5-7.6 0-3.2 4.4-13 4.4-13zm0 21c0 .2.8 2.2 2.9 2.2 2 0 2.3-2 2.3-2s-.3 3.5 2.9 3.2c3.2-.3 4.3-3.5 4.3-3.5s.3 1.8 3 .9c2.6-.9 6-3.8 5.8-3.8-.3 0-21 3.8-21.3 3z",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx144("use", {
          xlinkHref: "#fk_svg__l",
          width: 992.1,
          height: 496.1,
          transform: "translate(-6.6 7.3)"
        }),
        /* @__PURE__ */ jsx144("use", {
          xlinkHref: "#fk_svg__l",
          width: 992.1,
          height: 496.1,
          transform: "translate(6.6 3.8)"
        }),
        /* @__PURE__ */ jsx144("use", {
          xlinkHref: "#fk_svg__l",
          width: 992.1,
          height: 496.1,
          transform: "translate(0 11)"
        }),
        /* @__PURE__ */ jsx144("path", {
          id: "fk_svg__l",
          fill: "#be0f17",
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.6,
          d: "M409 477a1.9 1.9 0 1 1-3.8 0 1.9 1.9 0 0 1 3.8 0z",
          transform: "matrix(.04 -1.07 1.02 .04 251.6 668)"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "none",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M398.2 500c0-.2 9 3.8 9 4.1 0 .3 32 42.8 32.3 42.8m-16-42.8 8.2 3.5 2.6 6.4m-61.4-10.4c-.3 0 9 7 9 7l1.2 5.7M341.3 546c4-1.7 32.2-26.4 32.2-26.4m-39.8 21.7 31.7-26.7m21.2 4 30 49.8m-3.6-29.2s3.5 11.7 7 13.5a86 86 0 0 1 7.6 4.6",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "none",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M412.6 539.5s2.5 13.8 6 16.4c3.5 2.6 7 5.5 7 5.5",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "none",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M391 439s3.4 19.2 10.4 23.6a950 950 0 0 1 12.8 8.1",
          transform: "matrix(1.25 0 0 1.3 256.3 -299.5)"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "none",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M390.7 438.7s7.5 15.2 14 19.8c6.3 4.7 15 9 15 9M366.3 440c2 3.5 1.7 10.2 4 12.5a66 66 0 0 1 5.8 7.6m-9.3-19.9c1.2 1.7 4.4 10.4 6.4 13 1.5 2.4 16.3 17.2 16.3 17.2",
          transform: "matrix(1.25 0 0 1.3 256.3 -299.5)"
        }),
        /* @__PURE__ */ jsx144("path", {
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M384.6 471.1a2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 0 1 4.4 0zm10.7 4.7a1.9 1.9 0 1 1-3.8 0 1.9 1.9 0 0 1 3.8 0zM409 477a1.9 1.9 0 1 1-3.8 0 1.9 1.9 0 0 1 3.8 0zm11.9-4.5c0 1-.7 1.7-1.6 1.7-.9 0-1.6-.8-1.6-1.7 0-.9.7-1.8 1.6-1.8.9 0 1.6.8 1.6 1.8zm9.6-5.7c0 .9-.9 1.6-1.9 1.6-1 0-1.9-.7-1.9-1.6 0-.9.9-1.6 1.9-1.6 1 0 1.9.7 1.9 1.6z",
          transform: "matrix(1.25 0 0 1.3 256.3 -299.5)"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "red",
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M374.1 404.4c-.9.6-15.4 4.1-13.4 3.8 2-.3 13.7 3 13.4 2-.3-1 0-5.2 0-5.8zm24.7-4.3c-.6 0-9 3.2-8.7 3.2.3 0 9.6 2.6 9.3 2-.3-.6-.3-4.4-.6-5.2zm25.3 2.9c-.6.3-10.5 2.6-8.7 2.9 1.8.3 8.4 2.6 8.4 2 0-.5 0-4.6.3-5z",
          transform: "matrix(1.25 0 0 1.3 256.3 -299.5)"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "none",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M413.6 471c.3-4.6 8.8-31 8.8-31m-5.9 30.1 6.7-30m-3.7 27.7c.2-1.7 4.9-27.6 4.9-27.6m-10.5 27c1.5-.8 5.8-2 5.8-2m-3.7-2.6c1.4 0 4.3-1.2 4.3-1.2m-3.5-2.3a24 24 0 0 1 4.4-1.2m-3.8-3.2 4.7-.8m-2.6-3c0 .3 3.2.3 3.2.3m-2.4-3.7 3.2.5",
          transform: "matrix(1.25 0 0 1.3 256.3 -299.5)"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "none",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M413.6 471c.3-4.6 8.8-31 8.8-31m-5.9 31.3 6.7-31.1m-4.4 31.2 5.6-31.2m-10.5 27c1.5-.8 5.8-2 5.8-2m-3.7-2.6c1.4 0 4.3-1.2 4.3-1.2m-3.5-2.3a24 24 0 0 1 4.4-1.2m-3.8-3.2 4.7-.8m-2.6-3c0 .3 3.2.3 3.2.3m-2.4-3.7 3.2.5",
          transform: "matrix(1.25 0 0 1.36 225.3 -323.4)"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "none",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "M413.6 471c.3-4.6 8.8-31 8.8-31m-5.9 30.1 6.7-30m-3.7 27.7c.2-1.7 4.9-27.6 4.9-27.6m-10.5 27c1.5-.8 5.8-2 5.8-2m-3.7-2.6c1.4 0 4.3-1.2 4.3-1.2m-3.5-2.3a24 24 0 0 1 4.4-1.2m-3.8-3.2 4.7-.8m-2.6-3c0 .3 3.2.3 3.2.3m-2.4-3.7 3.2.5",
          transform: "matrix(-1.25 0 0 1.32 1259.2 -307.3)"
        }),
        /* @__PURE__ */ jsx144("path", {
          fill: "#dd8b59",
          fillRule: "evenodd",
          stroke: "#512007",
          strokeWidth: 0.5,
          d: "m426.4 558.5 27.6.6.3-2-28.5-.3zm1.2-7.3c3.2 0 27.3-4.6 27.3-4.6s.9-3 0-3-27.3 5.6-27.3 5.6z",
          transform: "matrix(1.25 0 0 1.3 259.4 -430)"
        }),
        /* @__PURE__ */ jsx144("use", {
          xlinkHref: "#fk_svg__l",
          width: 992.1,
          height: 496.1,
          transform: "translate(0 5.5)"
        })
      ]
    }),
    /* @__PURE__ */ jsx144("path", {
      fill: "#012169",
      d: "M0 0h320v240H0z"
    }),
    /* @__PURE__ */ jsx144("path", {
      fill: "#FFF",
      d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0z"
    }),
    /* @__PURE__ */ jsx144("path", {
      fill: "#C8102E",
      d: "M212 140.5 320 220v20l-135.5-99.5zm-92 10 3 17.5-96 72H0zM320 0v1.5l-124.5 94 1-22L295 0zM0 0l119.5 88h-30L0 21z"
    }),
    /* @__PURE__ */ jsx144("path", {
      fill: "#FFF",
      d: "M120.5 0v240h80V0zM0 80v80h320V80z"
    }),
    /* @__PURE__ */ jsx144("path", {
      fill: "#C8102E",
      d: "M0 96.5v48h320v-48zM136.5 0v240h48V0z"
    })
  ]
});
var Fk_default = SvgFk;

// src/country-flag-icons/generated/Fm.tsx
init_esm_shims();
import { jsx as jsx145, jsxs as jsxs120 } from "react/jsx-runtime";
var SvgFm = (props) => /* @__PURE__ */ jsxs120("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx145("defs", {
      children: /* @__PURE__ */ jsx145("clipPath", {
        id: "fm_svg__a",
        children: /* @__PURE__ */ jsx145("path", {
          fillOpacity: 0.7,
          d: "M-81.3 0h682.6v512H-81.3z"
        })
      })
    }),
    /* @__PURE__ */ jsxs120("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      clipPath: "url(#fm_svg__a)",
      transform: "translate(76.3) scale(.94)",
      children: [
        /* @__PURE__ */ jsx145("path", {
          fill: "#6797d6",
          d: "M-252 0H772v512H-252z"
        }),
        /* @__PURE__ */ jsx145("path", {
          fill: "#fff",
          d: "m259.8 123-32.4 22.2 12.4-35.9-32.5-22.2h40.1l12.4-35.9 12.4 36h40l-32.4 22.1 12.4 35.9M259.8 390l-32.4-22.2 12.4 36-32.5 22.1h40.1l12.4 35.9 12.4-36 40 .1-32.4-22.2 12.4-35.9m-188.4-92.4L79.3 306l1.4-38-37.5-11.7 38.4-11.7 1.3-38 22.3 30.8 38.4-11.8-24.6 30.7 22.4 30.7m274.2-11.7 24.6 30.7-1.4-38 37.5-11.7-38.4-11.7-1.3-38-22.3 30.8-38.4-11.8 24.6 30.7-22.4 30.7"
        })
      ]
    })
  ]
});
var Fm_default = SvgFm;

// src/country-flag-icons/generated/Fo.tsx
init_esm_shims();
import { jsx as jsx146, jsxs as jsxs121 } from "react/jsx-runtime";
var SvgFo = (props) => /* @__PURE__ */ jsxs121("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx146("defs", {
      children: /* @__PURE__ */ jsx146("clipPath", {
        id: "fo_svg__a",
        children: /* @__PURE__ */ jsx146("path", {
          fillOpacity: 0.7,
          d: "M-78 32h640v480H-78z"
        })
      })
    }),
    /* @__PURE__ */ jsxs121("g", {
      fillRule: "evenodd",
      strokeWidth: 0,
      clipPath: "url(#fo_svg__a)",
      transform: "translate(78 -32)",
      children: [
        /* @__PURE__ */ jsx146("path", {
          fill: "#fff",
          d: "M-78 32h663.9v480H-78z"
        }),
        /* @__PURE__ */ jsx146("path", {
          fill: "#003897",
          d: "M-76 218.7h185.9V32H216v186.7h371.8v106.6H216V512H109.9V325.3h-186z"
        }),
        /* @__PURE__ */ jsx146("path", {
          fill: "#d72828",
          d: "M-76 245.3h212.4V32h53.1v213.3H588v53.4H189.5V512h-53V298.7H-76z"
        })
      ]
    })
  ]
});
var Fo_default = SvgFo;

// src/country-flag-icons/generated/Fr.tsx
init_esm_shims();
import { jsx as jsx147, jsxs as jsxs122 } from "react/jsx-runtime";
var SvgFr = (props) => /* @__PURE__ */ jsxs122("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx147("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx147("path", {
      fill: "#000091",
      d: "M0 0h213.3v480H0z"
    }),
    /* @__PURE__ */ jsx147("path", {
      fill: "#e1000f",
      d: "M426.7 0H640v480H426.7z"
    })
  ]
});
var Fr_default = SvgFr;

// src/country-flag-icons/generated/Ga.tsx
init_esm_shims();
import { jsx as jsx148, jsxs as jsxs123 } from "react/jsx-runtime";
var SvgGa = (props) => /* @__PURE__ */ jsx148("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs123("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx148("path", {
        fill: "#ffe700",
        d: "M640 480H0V0h640z"
      }),
      /* @__PURE__ */ jsx148("path", {
        fill: "#36a100",
        d: "M640 160H0V0h640z"
      }),
      /* @__PURE__ */ jsx148("path", {
        fill: "#006dbc",
        d: "M640 480H0V320h640z"
      })
    ]
  })
});
var Ga_default = SvgGa;

// src/country-flag-icons/generated/Gb.tsx
init_esm_shims();
import { jsx as jsx149, jsxs as jsxs124 } from "react/jsx-runtime";
var SvgGb = (props) => /* @__PURE__ */ jsxs124("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx149("path", {
      fill: "#012169",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx149("path", {
      fill: "#FFF",
      d: "m75 0 244 181L562 0h78v62L400 241l240 178v61h-80L320 301 81 480H0v-60l239-178L0 64V0z"
    }),
    /* @__PURE__ */ jsx149("path", {
      fill: "#C8102E",
      d: "m424 281 216 159v40L369 281zm-184 20 6 35L54 480H0zM640 0v3L391 191l2-44L590 0zM0 0l239 176h-60L0 42z"
    }),
    /* @__PURE__ */ jsx149("path", {
      fill: "#FFF",
      d: "M241 0v480h160V0zM0 160v160h640V160z"
    }),
    /* @__PURE__ */ jsx149("path", {
      fill: "#C8102E",
      d: "M0 193v96h640v-96zM273 0v480h96V0z"
    })
  ]
});
var Gb_default = SvgGb;

// src/country-flag-icons/generated/Gd.tsx
init_esm_shims();
import { jsx as jsx150, jsxs as jsxs125 } from "react/jsx-runtime";
var SvgGd = (props) => /* @__PURE__ */ jsxs125("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx150("defs", {
      children: /* @__PURE__ */ jsxs125("g", {
        id: "gd_svg__c",
        children: [
          /* @__PURE__ */ jsxs125("g", {
            id: "gd_svg__b",
            children: [
              /* @__PURE__ */ jsx150("path", {
                id: "gd_svg__a",
                fill: "#fcd116",
                d: "M0-1v1h.5",
                transform: "rotate(18 0 -1)"
              }),
              /* @__PURE__ */ jsx150("use", {
                xlinkHref: "#gd_svg__a",
                transform: "scale(-1 1)"
              })
            ]
          }),
          /* @__PURE__ */ jsx150("use", {
            xlinkHref: "#gd_svg__b",
            transform: "rotate(72)"
          }),
          /* @__PURE__ */ jsx150("use", {
            xlinkHref: "#gd_svg__b",
            transform: "rotate(144)"
          }),
          /* @__PURE__ */ jsx150("use", {
            xlinkHref: "#gd_svg__b",
            transform: "rotate(216)"
          }),
          /* @__PURE__ */ jsx150("use", {
            xlinkHref: "#gd_svg__b",
            transform: "rotate(288)"
          })
        ]
      })
    }),
    /* @__PURE__ */ jsx150("path", {
      fill: "#ce1126",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx150("path", {
      fill: "#007a5e",
      d: "M67.2 67.2h505.6v345.6H67.2z"
    }),
    /* @__PURE__ */ jsx150("path", {
      fill: "#fcd116",
      d: "M67.2 67.3h505.6L67.2 412.9h505.6z"
    }),
    /* @__PURE__ */ jsx150("circle", {
      cx: 319.9,
      cy: 240.1,
      r: 57.6,
      fill: "#ce1126"
    }),
    /* @__PURE__ */ jsx150("use", {
      xlinkHref: "#gd_svg__c",
      width: "100%",
      height: "100%",
      transform: "matrix(52.8 0 0 52.8 320 240)"
    }),
    /* @__PURE__ */ jsx150("use", {
      xlinkHref: "#gd_svg__d",
      width: "100%",
      height: "100%",
      x: -100,
      transform: "translate(-30.3)"
    }),
    /* @__PURE__ */ jsx150("use", {
      xlinkHref: "#gd_svg__c",
      id: "gd_svg__d",
      width: "100%",
      height: "100%",
      transform: "matrix(31.2 0 0 31.2 320 33.6)"
    }),
    /* @__PURE__ */ jsx150("use", {
      xlinkHref: "#gd_svg__d",
      width: "100%",
      height: "100%",
      x: 100,
      transform: "translate(30.3)"
    }),
    /* @__PURE__ */ jsx150("path", {
      fill: "#ce1126",
      d: "M102.3 240.7a80.4 80.4 0 0 0 33.5 33.2 111 111 0 0 0-11.3-45z"
    }),
    /* @__PURE__ */ jsx150("path", {
      fill: "#fcd116",
      d: "M90.1 194.7c10.4 21.7-27.1 73.7 35.5 85.9a63.2 63.2 0 0 1-10.9-41.9 70 70 0 0 1 32.5 30.8c16.4-59.5-42-55.8-57.1-74.8"
    }),
    /* @__PURE__ */ jsx150("use", {
      xlinkHref: "#gd_svg__d",
      width: "100%",
      height: "100%",
      x: -100,
      transform: "translate(-30.3 414.6)"
    }),
    /* @__PURE__ */ jsx150("use", {
      xlinkHref: "#gd_svg__c",
      width: "100%",
      height: "100%",
      transform: "matrix(31.2 0 0 31.2 320 448.2)"
    }),
    /* @__PURE__ */ jsx150("use", {
      xlinkHref: "#gd_svg__d",
      width: "100%",
      height: "100%",
      x: 100,
      transform: "translate(30.3 414.6)"
    })
  ]
});
var Gd_default = SvgGd;

// src/country-flag-icons/generated/Ge.tsx
init_esm_shims();
import { jsx as jsx151, jsxs as jsxs126 } from "react/jsx-runtime";
var SvgGe = (props) => /* @__PURE__ */ jsxs126("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx151("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx151("path", {
      fill: "red",
      d: "M272 0h96v480h-96z"
    }),
    /* @__PURE__ */ jsx151("path", {
      fill: "red",
      d: "M0 192h640v96H0z"
    }),
    /* @__PURE__ */ jsx151("path", {
      fill: "red",
      fillRule: "evenodd",
      d: "M146.8 373.1c1-16.8 4-31.1 4-31.1s-9.8 1-14.8 1c-4.9 0-14.8-1-14.8-1s3 14.3 4 31.2c-16.9-1-31.2-4-31.2-4s1 7.4 1 14.8-1 14.8-1 14.8 14.3-3 31.2-4c-1 16.9-4 31.2-4 31.2s7.4-1 14.8-1 14.8 1 14.8 1-3-14.3-4-31.2c16.9 1 31.2 4 31.2 4s-1-9.8-1-14.8c0-4.9 1-14.8 1-14.8s-14.3 3-31.1 4zm368-288c1-16.8 4-31.1 4-31.1s-9.8 1-14.8 1c-4.9 0-14.8-1-14.8-1s3 14.3 4 31.1c-16.9-1-31.2-3.9-31.2-3.9s1 7.4 1 14.8-1 14.8-1 14.8 14.3-3 31.2-4c-1 16.9-4 31.2-4 31.2s7.4-1 14.8-1 14.8 1 14.8 1-3-14.3-4-31.1c16.9 1 31.2 4 31.2 4s-1-10-1-14.9 1-14.8 1-14.8-14.3 3-31.2 4zm-368 0c1-16.8 4-31.1 4-31.1s-9.8 1-14.8 1c-4.9 0-14.8-1-14.8-1s3 14.3 4 31.2c-16.9-1-31.2-4-31.2-4s1 7.4 1 14.8-1 14.8-1 14.8 14.3-3 31.2-4c-1 16.9-4 31.2-4 31.2s7.4-1 14.8-1 14.8 1 14.8 1-3-14.3-4-31.2c16.9 1 31.2 4 31.2 4s-1-9.8-1-14.8c0-4.9 1-14.8 1-14.8s-14.3 3-31.1 4zm368 288c1-16.8 4-31.1 4-31.1s-9.8 1-14.8 1c-4.9 0-14.8-1-14.8-1s3 14.3 4 31.2c-16.9-1-31.2-4-31.2-4s1 7.4 1 14.8-1 14.8-1 14.8 14.3-3 31.2-4c-1 16.9-4 31.2-4 31.2s7.4-1 14.8-1 14.8 1 14.8 1-3-14.3-4-31.2c16.9 1 31.2 4 31.2 4s-1-9.8-1-14.8c0-4.9 1-14.8 1-14.8s-14.3 3-31.2 4z"
    })
  ]
});
var Ge_default = SvgGe;

// src/country-flag-icons/generated/Gf.tsx
init_esm_shims();
import { jsx as jsx152, jsxs as jsxs127 } from "react/jsx-runtime";
var SvgGf = (props) => /* @__PURE__ */ jsxs127("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx152("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx152("path", {
      fill: "#000091",
      d: "M0 0h213.3v480H0z"
    }),
    /* @__PURE__ */ jsx152("path", {
      fill: "#e1000f",
      d: "M426.7 0H640v480H426.7z"
    })
  ]
});
var Gf_default = SvgGf;

// src/country-flag-icons/generated/Gg.tsx
init_esm_shims();
import { jsx as jsx153, jsxs as jsxs128 } from "react/jsx-runtime";
var SvgGg = (props) => /* @__PURE__ */ jsxs128("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx153("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx153("path", {
      fill: "#e8112d",
      d: "M256 0h128v480H256z"
    }),
    /* @__PURE__ */ jsx153("path", {
      fill: "#e8112d",
      d: "M0 176h640v128H0z"
    }),
    /* @__PURE__ */ jsx153("path", {
      id: "gg_svg__a",
      fill: "#f9dd16",
      d: "m110 286.7 23.3-23.4h210v-46.6h-210L110 193.3z"
    }),
    /* @__PURE__ */ jsx153("use", {
      xlinkHref: "#gg_svg__a",
      width: 36,
      height: 24,
      transform: "rotate(90 320 240)"
    }),
    /* @__PURE__ */ jsx153("use", {
      xlinkHref: "#gg_svg__a",
      width: 36,
      height: 24,
      transform: "rotate(-90 320 240)"
    }),
    /* @__PURE__ */ jsx153("use", {
      xlinkHref: "#gg_svg__a",
      width: 36,
      height: 24,
      transform: "rotate(180 320 240)"
    })
  ]
});
var Gg_default = SvgGg;

// src/country-flag-icons/generated/Gh.tsx
init_esm_shims();
import { jsx as jsx154, jsxs as jsxs129 } from "react/jsx-runtime";
var SvgGh = (props) => /* @__PURE__ */ jsxs129("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx154("path", {
      fill: "#006b3f",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx154("path", {
      fill: "#fcd116",
      d: "M0 0h640v320H0z"
    }),
    /* @__PURE__ */ jsx154("path", {
      fill: "#ce1126",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsx154("path", {
      fill: "#000001",
      d: "m320 160 52 160-136.1-98.9H404L268 320z"
    })
  ]
});
var Gh_default = SvgGh;

// src/country-flag-icons/generated/Gi.tsx
init_esm_shims();
import { jsx as jsx155, jsxs as jsxs130 } from "react/jsx-runtime";
var SvgGi = (props) => /* @__PURE__ */ jsxs130("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx155("path", {
      fill: "#da000c",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx155("path", {
      fill: "#fff",
      d: "M0 0h640v321.6H0z"
    }),
    /* @__PURE__ */ jsxs130("g", {
      stroke: "#000",
      transform: "translate(-160) scale(1.875)",
      children: [
        /* @__PURE__ */ jsxs130("g", {
          id: "gi_svg__a",
          fill: "#da000c",
          strokeLinecap: "square",
          children: [
            /* @__PURE__ */ jsx155("path", {
              fill: "#000001",
              stroke: "none",
              d: "M196.6 116.3h64v44h-64z"
            }),
            /* @__PURE__ */ jsx155("path", {
              d: "M229.8 153.9h-39l-8.7 5.7v6h47.7m-16.3-37c5.6 0 10.2 4.7 10.2 10.5v14.7h7.3v-56h-40.3v56h12.6v-14.7c0-5.6 4.5-10.5 10.2-10.5z"
            }),
            /* @__PURE__ */ jsx155("path", {
              fill: "#000001",
              stroke: "none",
              d: "M204.5 60h18.6v34h-18.6z"
            }),
            /* @__PURE__ */ jsx155("path", {
              d: "M223 88.7h-16.2v-5.8h-11.9v5.8h-8v-5.8H182v10.4h41m-36.2 0h35v4.5h-35zm14-45.7V83h6v-9.7c0-3.6 2.5-6.6 6.1-6.8h.4a6.8 6.8 0 0 1 6.8 6.8V83h5.7V47.6zm-2.3-4.8v4.8h29.3v-4.8zm-3.7-9.1v9.1h35v-9.1h-5.3v4.7h-6.6v-4.7h-10v4.7h-6.5v-4.7zM182 159.6h48m31-2.8h-32.4l-9.8 4.7v7H261"
            }),
            /* @__PURE__ */ jsx155("path", {
              strokeLinecap: "butt",
              d: "M218.8 161.5H262"
            })
          ]
        }),
        /* @__PURE__ */ jsx155("use", {
          xlinkHref: "#gi_svg__a",
          width: "100%",
          height: "100%",
          transform: "matrix(-1 0 0 1 512 0)"
        }),
        /* @__PURE__ */ jsxs130("g", {
          fill: "#f8d80e",
          children: [
            /* @__PURE__ */ jsxs130("g", {
              strokeLinecap: "round",
              children: [
                /* @__PURE__ */ jsx155("path", {
                  strokeWidth: 0.8,
                  d: "M273.3 150c-2.7 1-5 2.4-7.5 3.8a72.4 72.4 0 0 0-8.9 6c-1 .7-2 1.4-2.7 2.4-1 .8-2 2-1.8 3.5 0 .6.8-.8 1.4-.9a4.4 4.4 0 0 1 3.1-.4c1.3-1.4 3-2.3 4.4-3.4a77.4 77.4 0 0 1 13-7.6z"
                }),
                /* @__PURE__ */ jsx155("path", {
                  d: "M260.4 157.4v3.9m2.4-5.6v3.9m2.4-5.4v3.8m2.5-5.3v4"
                }),
                /* @__PURE__ */ jsx155("path", {
                  strokeWidth: 0.8,
                  d: "m238.9 150.2-1.2 3.3a86.6 86.6 0 0 1 15.8 8c1.7 1.2 3.5 2.3 4.8 3.9.3.8-.5 1.5-1.3 1.2-.7-.2-1.5-.5-2.2 0-1.1.5-2.1 2.2-.5 2.7 2.4 1.6 6.1.9 7.2-1.8.6-1.4.7-3.2-.5-4.4-2-2.3-4.8-4-7.4-5.7a89.2 89.2 0 0 0-14.7-7.2z"
                }),
                /* @__PURE__ */ jsx155("path", {
                  d: "m254 158-.3 3.4m3.1-1.7-.8 3.3m3.8-1-1.8 2.6m2.7 3.6-2.6-1.4m3.4-1.4-3 .3m-.8 4-.2-2.6m-1-.3-2.4 1.8m-9.4-15.7v3.1m6.3.3v3.5m-3.2-5.2v3.3"
                })
              ]
            }),
            /* @__PURE__ */ jsx155("path", {
              d: "M235.8 227.6v8h5v-4h6.9v4h5.4v-8zm0 11v8H253v-8h-5.4v4h-6.9v-4z"
            }),
            /* @__PURE__ */ jsx155("path", {
              d: "M253 193.7h5v58h-5z"
            }),
            /* @__PURE__ */ jsx155("path", {
              d: "M253 198.7h5v50h-5zm2.6-19.3 10.6 6.2-10.6 6.2-10.7-6.2zm-14.3 4h-2.7v4.4h2.7l14.3 8.3 14.2-8.3h2.8v-4.4h-2.8l-14.2-8.3z"
            }),
            /* @__PURE__ */ jsx155("path", {
              d: "M255.3 164.3a5 5 0 0 0-4 5.1v11.2a5 5 0 0 0 4.6 4.6 4.9 4.9 0 0 0 4.8-2.8l-1.7-1a2.9 2.9 0 0 1-3 1.8c-1.6 0-2.9-1.6-2.7-3.1v-11.2a2.9 2.9 0 0 1 3-2.6c.6-.2 1.5.7 1.9 0 .6-.9-.4-1.5-1-2zm5.8 3.9a5 5 0 0 1-1.9 1.6v7.5l2 1.1v-10.2z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs130("g", {
          fill: "#da000c",
          children: [
            /* @__PURE__ */ jsx155("path", {
              fill: "#000001",
              stroke: "none",
              d: "M240.8 38.4h29.3v53.2h-29.3z"
            }),
            /* @__PURE__ */ jsx155("path", {
              d: "M238.8 38.4v44.5h9.3V69.7c0-3 2-7.3 7.9-7.3s8 4.3 8 7.3V83h9.2V38.4zm15.8 5h2.8v15.2h-2.8zm-8.3 3h3v11.1h-3zm16.5 0h2.9v11.1h-3zM235.6 32v6.3h40.8V32zm-3.8-7.4V32h48.5v-7.4h-6.1v4h-7v-4h-7.8v4h-6.8v-4h-7.9v4H238v-4zm-9 73.2v4.6h66.5v-4.6z"
            }),
            /* @__PURE__ */ jsx155("path", {
              d: "M220 82.9v15h72v-15h-6.8v5.8H276v-5.8h-12.2v5.8H248v-5.8h-12.2v5.8h-9v-5.8z"
            }),
            /* @__PURE__ */ jsx155("path", {
              strokeLinejoin: "round",
              d: "M228.7 102.4v54.4h12.8v-20.4c0-9.5 6.4-14 14.5-14 7.8 0 14.5 4.5 14.5 14v20.4h12.8v-54.4z"
            })
          ]
        })
      ]
    })
  ]
});
var Gi_default = SvgGi;

// src/country-flag-icons/generated/Gl.tsx
init_esm_shims();
import { jsx as jsx156, jsxs as jsxs131 } from "react/jsx-runtime";
var SvgGl = (props) => /* @__PURE__ */ jsxs131("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx156("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx156("path", {
      fill: "#d00c33",
      d: "M0 240h640v240H0zm80 0a160 160 0 1 0 320 0 160 160 0 0 0-320 0"
    })
  ]
});
var Gl_default = SvgGl;

// src/country-flag-icons/generated/Gm.tsx
init_esm_shims();
import { jsx as jsx157, jsxs as jsxs132 } from "react/jsx-runtime";
var SvgGm = (props) => /* @__PURE__ */ jsxs132("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx157("defs", {
      children: /* @__PURE__ */ jsx157("clipPath", {
        id: "gm_svg__a",
        children: /* @__PURE__ */ jsx157("path", {
          fillOpacity: 0.7,
          d: "M0-48h640v480H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs132("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      clipPath: "url(#gm_svg__a)",
      transform: "translate(0 48)",
      children: [
        /* @__PURE__ */ jsx157("path", {
          fill: "red",
          d: "M0-128h640V85.3H0z"
        }),
        /* @__PURE__ */ jsx157("path", {
          fill: "#fff",
          d: "M0 85.3h640V121H0z"
        }),
        /* @__PURE__ */ jsx157("path", {
          fill: "#009",
          d: "M0 120.9h640V263H0z"
        }),
        /* @__PURE__ */ jsx157("path", {
          fill: "#fff",
          d: "M0 263.1h640v35.6H0z"
        }),
        /* @__PURE__ */ jsx157("path", {
          fill: "#090",
          d: "M0 298.7h640V512H0z"
        })
      ]
    })
  ]
});
var Gm_default = SvgGm;

// src/country-flag-icons/generated/Gn.tsx
init_esm_shims();
import { jsx as jsx158, jsxs as jsxs133 } from "react/jsx-runtime";
var SvgGn = (props) => /* @__PURE__ */ jsx158("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs133("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    children: [
      /* @__PURE__ */ jsx158("path", {
        fill: "red",
        d: "M0 0h213.3v480H0z"
      }),
      /* @__PURE__ */ jsx158("path", {
        fill: "#ff0",
        d: "M213.3 0h213.4v480H213.3z"
      }),
      /* @__PURE__ */ jsx158("path", {
        fill: "#090",
        d: "M426.7 0H640v480H426.7z"
      })
    ]
  })
});
var Gn_default = SvgGn;

// src/country-flag-icons/generated/Gp.tsx
init_esm_shims();
import { jsx as jsx159, jsxs as jsxs134 } from "react/jsx-runtime";
var SvgGp = (props) => /* @__PURE__ */ jsxs134("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx159("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx159("path", {
      fill: "#000091",
      d: "M0 0h213.3v480H0z"
    }),
    /* @__PURE__ */ jsx159("path", {
      fill: "#e1000f",
      d: "M426.7 0H640v480H426.7z"
    })
  ]
});
var Gp_default = SvgGp;

// src/country-flag-icons/generated/Gq.tsx
init_esm_shims();
import { jsx as jsx160, jsxs as jsxs135 } from "react/jsx-runtime";
var SvgGq = (props) => /* @__PURE__ */ jsxs135("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx160("path", {
      fill: "#e32118",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx160("path", {
      fill: "#fff",
      d: "M0 0h640v320H0z"
    }),
    /* @__PURE__ */ jsx160("path", {
      fill: "#3e9a00",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsx160("path", {
      fill: "#0073ce",
      d: "M0 0v480l180-240z"
    }),
    /* @__PURE__ */ jsxs135("g", {
      stroke: "#000",
      children: [
        /* @__PURE__ */ jsx160("path", {
          fill: "#fff",
          d: "M281.6 191.8h76.6V272c0 27-35.2 6.2-38.2 20.6-5.2-14.8-38.2 6.6-38.2-22.2z"
        }),
        /* @__PURE__ */ jsx160("path", {
          fill: "#73452b",
          strokeWidth: 0.2,
          d: "M325.4 279.8s-1 1-2.8.2c-1.8-.8-2-51.4-2-51.4 4-4.4 7.2-5.8 7.2-5.8l2.4 2c-9 4.6-8.2 11.2-7.4 22.6.2 4.2.2 9.6 1.2 14.8 1.4 6.6 4.2 12.2 4.4 16.4.2 2.6-3 1.2-3 1.2z"
        }),
        /* @__PURE__ */ jsx160("path", {
          fill: "#73452b",
          strokeWidth: 0.2,
          d: "M319.2 221.6h3.6c-3 29-.4 46.2-.4 54.6 0 2.8 1.6 3.8 1.4 3.8-3.6 4-5.4-.2-5.4-.2z"
        }),
        /* @__PURE__ */ jsx160("path", {
          fill: "#a36629",
          strokeWidth: 0.2,
          d: "M313.6 279.8c-3.4 1.6-3.8-1.6-3.6-2 7.4-15 10.6-48 3.8-51.6l.4-3.2c2.6.8 5 4.2 5 4.2 1 37 0 52.2-.6 52.8-3.6 3.8-5-.6-5.2-1"
        }),
        /* @__PURE__ */ jsx160("path", {
          fill: "none",
          strokeWidth: 0.2,
          d: "M313.4 279.2c-.6-3.2 5.2-11.4 4.8-20m5 7c1.8 5 2.6 9.4 2.2 13.6"
        }),
        /* @__PURE__ */ jsx160("path", {
          fill: "#009a3b",
          strokeWidth: 0.2,
          d: "M331 208c1.2-1.4 1.2-1.4 3.4-1.4.4-3 5.4-3 5.8.8 4-.8 4.8 1.6 3.2 4 3.8-1 7.2 0 6.2 4.4 6.8 1.8 4.2 6.6 1.2 7.6-.4 3-3.2 4-7 2.8-4.8 3.4-7.6 2.2-9.8-1.2-5.4.8-5.8-.4-8.2-3.4-4.2 1.8-5 1.8-8.6-.4-.2 2.8-1.2 2-3 1.8.2 3.6-1.2 5.2-4.4 4 2.4 5-3.8 7.2-6.8 3-2.8.2-3-.6-4.4-1.6-1.2 4-5.6 3.4-6.4 1.2-5.6-.8-5-3.8-.4-4 .4-3.2 3.2-2.6 5-2.2.2-2 1.4-1.6 2.4-1.2-.6-1.4-.2-2.2 1.6-2.6-2.6-3.4-1-4.6 1.6-5.8-1.4-3.2 1-3 2.8-3.2-.2-3.4.8-4 4.4-4.4-.4-1.2.2-2.2 2.2-2.2-1.2-3.4.4-4.2 4-3.6.6-5 11.2-2.6 10.4 4.2 3 .4 4 1 4.8 3.4z"
        }),
        /* @__PURE__ */ jsx160("path", {
          fill: "none",
          strokeWidth: 0.2,
          d: "M309.6 206.2c.8.4 1.8 0 2 2.2 1.6-2.8 3.6-1.2 3.6 2m11-5.8c-.8 1.2-3.8 1.2-3.4 4.4-1-1.4-3-1.8-3.8-.4m12-.6c0 .8-.2 3.2-1 4.4m13.4-1c.2.2-2.8 0-4.2 1m11.6 11c-.8-.4-2.4-1.4-3.6.2 0-.8 0-3-2.2-3m-1.2 5.6c0-2-.4-2.6-.8-3.2m-5.8.4c-1.6-1.2-3.2.6-3.2 1.6m-8.4-3.4c0-.8-.6-2.4.8-3M302.8 230c.4-2 1.8-2 1.6-3-.2-1.6-2-3-4.2-.8m4.2.8c1.2-.4 2.4-.2 2.8.4m-6.2-7.8c.8-.8 2.8-.6 4 0m0-4.8c1 0 2.8-.4 3.4 1.4 2.2-3.4 3.8-3 4.2-2.2m4-.4c1.6-.6 4.4 1 6 3.8.8-2.2 2-1.8 3.2-2m7.6 2c2.6-1.2 4.2 1.2 5 2.2 1.2-1.6 2.2-1.6 3.4-1.6m-32.6 4.2c.6-1 2-1.2 3-.6-.2-1.8 1-2.6 1.8-2.2"
        }),
        /* @__PURE__ */ jsx160("path", {
          fill: "gold",
          strokeWidth: 0.7,
          d: "m317.4 180.5-4.4.2-2.2 4-2.4-3.8-4.4.2 2-4-2.4-3.7 4.6-.2 2-4 2.4 3.8 4.4-.2-2 4zm-18.8 1.5-4.4 1-1.2 4.3-3.2-3.2-4.2 1 1.2-4.2-3-3.2 4.2-1.1 1.2-4.3 3.2 3.2 4.4-1-1.4 4.3zm-18.2 3.7-4 2-.2 4.4-3.8-2.4-4 2 .4-4.5-3.8-2.4 4-2 .4-4.5 3.6 2.5 4-2-.2 4.4zm42.8-5.2 4.4.2 2 4 2.4-3.8 4.4.2-2-4 2.4-3.7-4.4-.2-2.2-4-2.4 3.8-4.4-.2 2 4zM342 182l4.2 1 1.2 4.3 3.2-3.2 4.2 1-1.2-4.2 3.2-3.2-4.4-1.1-1.2-4.3-3.2 3.2-4.2-1 1.2 4.3zm18 3.7 4 2 .2 4.4 3.8-2.4 4 2-.2-4.5 3.6-2.4-4-2-.2-4.5-3.8 2.5-4-2 .4 4.4z"
        }),
        /* @__PURE__ */ jsxs135("g", {
          fill: "#fff",
          strokeWidth: 0.7,
          children: [
            /* @__PURE__ */ jsx160("path", {
              d: "m365.4 270.4 5 7.2 4.6-6.8-3.2-5.8zm-31.8 21 .4 7.2s2 0 3.8-.6c1.6-.6 3-1.8 3-1.8l-.2-3.8zm-26.8 0-.4 7s-1.8 0-3.6-.4c-1.6-.4-3-1.4-3-1.4l-2-4.8zm-32.2-21-5.2 7.2-5.6-9.2 4.2-4.4z"
            }),
            /* @__PURE__ */ jsx160("path", {
              d: "M299.6 305.8c0 6.8 41.2 6.8 41.2 0v-9.6c0 5-41.2 4-41.2 0z"
            }),
            /* @__PURE__ */ jsx160("path", {
              d: "M262.8 283.6c3.6 18.4 36.8 18.8 36.8 18.8v-6.2c-.8-2.4.6-3.2 6-4 2.2-.2 1.2-3.4 1.2-3.4s-14.4 2.6-24.6-1.4c-13.8-5.6-15.8-16.4-15.8-16.4s-1 8.4-3.6 12.6zm114.6 0c-3.4 18.4-36.6 18.8-36.6 18.8v-6.2c.6-2.4-.8-3.2-6.2-4-2.2-.2-1-3.4-1-3.4s14.4 2.6 24.6-1.4c13.6-5.6 15.2-16.4 15.2-16.4s1.4 8.4 4 12.6z"
            }),
            /* @__PURE__ */ jsx160("path", {
              d: "M265.4 276.6c-9.2-5-2-10.2-1.2-25 1.4 9 11.6 12.8 10.4 18.6-4.2.2-6.2-6.2-8.2.8zm109.4 0c9.2-5.2 1.6-10.2.8-25-1.4 9-11.4 12.8-10.2 18.6 4 .2 6-6.2 8 .8l1.4 5.4z"
            })
          ]
        }),
        /* @__PURE__ */ jsx160("path", {
          stroke: "none",
          d: "m271 283.4 1 .8-2.2 2.4c-1 1-1.1 1.6-.5 2.2.7.7 1.3.4 2-.4l2.5-2.6.8.8-2.4 2.8c-1.3 1.5-2.5 1.2-3.6.2-.8-.8-1.4-2 0-3.5zm4 3.4 1 .6-.2 4.8 2.2-3.4 1 .6-3.2 5.2-1.2-.6.2-4.8-2.2 3.4-1-.6zm1.8 8.4 2.8-5.6 1 .6-2.6 5.4zm4.4-4.8-2.2 5.8 2.2.8c2 .7 3-.2 3.6-1.9.7-1.8.4-3-1.6-3.9zm.8 1.4c2 .7 2.2 1.5 1.6 3-.6 1.3-1 1.8-3 .8zm5.8.8-3.6 5.4 1.4.4.8-1.4 2.4.6.2 1.4 1.4.2-1.4-6.4zm.4 1.4.4 2.4-1.6-.2zm3-.9-.2 6.2h2.3c2.2.1 2.8-1 2.9-3 0-1.8-.7-3-2.9-3zm1.2 1c2.2.1 2.5.8 2.5 2.3-.1 1.5-.4 2.1-2.6 1.8v-4zm19.8 7.7v6.4h1.4v-2.4s1.2 0 2.2-.2c.7-.2 1.3-.7 1.3-2 0-1.2-.7-1.8-1.9-1.8zm1.4 1h1.4c1.1 0 1 1.8 0 1.8h-1.4zm5.8-1-2.6 6.4h1.4l.6-1.6h2.6l.6 1.6h1.4l-2.6-6.4zm.6 1.4 1 2.4h-1.8zm3.4 3.8 3.4-4.2h-3v-1h4.8v1L325 307h3.6v1.2h-5.2zm20.2-12.4 1.2-.2.6 3.6c.2 1.3-.4 2.1-1.3 2.5-1 .4-2.4 0-2.5-1.7l1-.2c.2 1 .6 1.1 1 1 .5-.2.7-.8.6-1.4zm2-.4 1.1-.2.6 3c.2 1.3.6 1.8 1.5 1.7 1-.2 1.1-.8.9-2l-.7-3.1 1.2-.2.8 3.3c.4 2-.6 2.7-2 3-1.1.2-2.4 0-2.8-2zm6.2 2.8 1-.4c.5.9 1.2.8 1.8.6.8-.4 1-1.1.5-1.4-.6-.3-2 .2-2.7 0-.9-.4-1.3-1-1.2-1.7 0-1 .8-1.4 1.7-1.7 1-.3 2-.2 2.7 1l-1.2.4c-.4-.7-1-.6-1.4-.4-.4.2-1 .5-.6 1 .2.5 1.7.2 2.5.2s1.4.6 1.5 1.3c.2 1.1-.2 1.7-1.5 2.2-1.5.6-2.9 0-3.1-1.1m5.4-5-1.6.8-.4-1 4.4-1.8.4.8-1.6.8 1.8 4.4-1 .6zm2.6-2.2 1-.6 2.8 5.2-1 .6zm6.8.4 1.2-.4a2.4 2.4 0 0 1-2.4 3.3c-3 0-3.4-3.4-2.9-4.5.8-1.9 3-1.8 4-.8l-1 .8c-.6-.8-2-.3-2 .4a2.7 2.7 0 0 0 1.4 3c1 .4 2.4-.8 1.7-1.8m-.6-4.2 1-.8 3.6 4.8-1 .8zm3.8-3-1 .8 2.2 6 1-1-.6-1.2 1.8-1.6 1.2.6 1-.8zm.4 1.4 2 1-1.2 1.2z"
        })
      ]
    })
  ]
});
var Gq_default = SvgGq;

// src/country-flag-icons/generated/Gr.tsx
init_esm_shims();
import { jsx as jsx161, jsxs as jsxs136 } from "react/jsx-runtime";
var SvgGr = (props) => /* @__PURE__ */ jsxs136("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx161("path", {
      fill: "#0d5eaf",
      fillRule: "evenodd",
      d: "M0 0h640v53.3H0z"
    }),
    /* @__PURE__ */ jsx161("path", {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M0 53.3h640v53.4H0z"
    }),
    /* @__PURE__ */ jsx161("path", {
      fill: "#0d5eaf",
      fillRule: "evenodd",
      d: "M0 106.7h640V160H0z"
    }),
    /* @__PURE__ */ jsx161("path", {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M0 160h640v53.3H0z"
    }),
    /* @__PURE__ */ jsx161("path", {
      fill: "#0d5eaf",
      d: "M0 0h266.7v266.7H0z"
    }),
    /* @__PURE__ */ jsx161("path", {
      fill: "#0d5eaf",
      fillRule: "evenodd",
      d: "M0 213.3h640v53.4H0z"
    }),
    /* @__PURE__ */ jsx161("path", {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M0 266.7h640V320H0z"
    }),
    /* @__PURE__ */ jsx161("path", {
      fill: "#0d5eaf",
      fillRule: "evenodd",
      d: "M0 320h640v53.3H0z"
    }),
    /* @__PURE__ */ jsx161("path", {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M0 373.3h640v53.4H0z"
    }),
    /* @__PURE__ */ jsxs136("g", {
      fill: "#fff",
      fillRule: "evenodd",
      strokeWidth: 1.3,
      children: [
        /* @__PURE__ */ jsx161("path", {
          d: "M106.7 0H160v266.7h-53.3z"
        }),
        /* @__PURE__ */ jsx161("path", {
          d: "M0 106.7h266.7V160H0z"
        })
      ]
    }),
    /* @__PURE__ */ jsx161("path", {
      fill: "#0d5eaf",
      d: "M0 426.7h640V480H0z"
    })
  ]
});
var Gr_default = SvgGr;

// src/country-flag-icons/generated/Gs.tsx
init_esm_shims();
import { jsx as jsx162, jsxs as jsxs137 } from "react/jsx-runtime";
var SvgGs = (props) => /* @__PURE__ */ jsxs137("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsxs137("defs", {
      children: [
        /* @__PURE__ */ jsxs137("linearGradient", {
          id: "gs_svg__b",
          children: [
            /* @__PURE__ */ jsx162("stop", {
              offset: 0,
              stopColor: "#d5dfff"
            }),
            /* @__PURE__ */ jsx162("stop", {
              offset: 1,
              stopColor: "#fff"
            })
          ]
        }),
        /* @__PURE__ */ jsxs137("linearGradient", {
          id: "gs_svg__a",
          children: [
            /* @__PURE__ */ jsx162("stop", {
              offset: 0,
              stopColor: "#474747"
            }),
            /* @__PURE__ */ jsx162("stop", {
              offset: 1,
              stopColor: "#f50"
            })
          ]
        }),
        /* @__PURE__ */ jsx162("linearGradient", {
          xlinkHref: "#gs_svg__a",
          id: "gs_svg__c",
          x1: 109.3,
          x2: 110.9,
          y1: 218.5,
          y2: 173.4,
          gradientTransform: "matrix(1.178 0 0 .50849 388 38.3)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsxs137("linearGradient", {
          id: "gs_svg__d",
          x1: 125.9,
          x2: 126,
          y1: 316.4,
          y2: 337.2,
          gradientTransform: "matrix(.96067 0 0 .6235 388 38.3)",
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx162("stop", {
              offset: 0,
              stopColor: "#b50000"
            }),
            /* @__PURE__ */ jsx162("stop", {
              offset: 1,
              stopColor: "#ffc500"
            })
          ]
        }),
        /* @__PURE__ */ jsx162("linearGradient", {
          xlinkHref: "#gs_svg__b",
          id: "gs_svg__e",
          x1: 407.9,
          x2: 456.4,
          y1: 149.4,
          y2: 147.4,
          gradientTransform: "matrix(.4361 0 0 1.37349 388 38.3)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx162("linearGradient", {
          xlinkHref: "#gs_svg__a",
          id: "gs_svg__f",
          x1: 215.8,
          x2: 229,
          y1: 103,
          y2: 103,
          gradientTransform: "matrix(.57794 0 0 1.03641 388 38.3)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx162("linearGradient", {
          xlinkHref: "#gs_svg__b",
          id: "gs_svg__g",
          x1: 117.6,
          x2: 78.2,
          y1: 1040.4,
          y2: 1003.7,
          gradientTransform: "matrix(1.9991 0 0 .29962 388 38.3)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx162("linearGradient", {
          xlinkHref: "#gs_svg__b",
          id: "gs_svg__h",
          x1: 264.7,
          x2: 255,
          y1: 246,
          y2: 226.4,
          gradientTransform: "matrix(.69142 0 0 .86628 388 38.3)",
          gradientUnits: "userSpaceOnUse"
        })
      ]
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#006",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#6a4c2d",
      stroke: "#000",
      d: "M471 345s-2.6 6.8-4 6.8c-1.6 0-7-3-7-3s-3.9 6.4-6 6.7c-2 .4-7.4-.9-7.4-.9s-5.2 0-5.4-.7c-.2-.8.2-2.3.2-2.3s-7.5 6-9.1 5.6c-1.7-.3-7.3-7.4-7.3-7.4l-1 3.7-10.6-.4-9.3-6s-5.2 8.6-5.4 8.4c-.2-.1-9.1 2.1-9.1 2.1l-.6-1.7-6-3.5s4.7-6.5 4.7-6.7c0-.2-2.2-1-2.2-1l-3.4 2.8-6.9 4.5-6.9-3.2 3-5.6.4-4 5.4-8.3 66.2-64.3 32.6 60.2z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#fff",
      stroke: "#000",
      d: "m518 348.8 17.3-.6-7.4-3.6 65.7-2.5-9.3-3.5-8.2-11.2-34-2.5s-2.6-2-6.7-1c-.2-2.6-3.4-6-3.4-6l-21-1.7-13 9 8.8 22.6z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "url(#gs_svg__c)",
      stroke: "#000",
      d: "m451 156 1.8-6s3-5 3-7.4c0-2.2 2.3-4.9 2.3-4.9s6.9-2 8.4 2.3c7.4-11.3 16.2-.6 16.2-.6l2.4-2.8 5-6s7 6.5 7 7.6c.2 1.2 1.3.4 1.3.4l7.6-.6a9 9 0 0 0 2.9 8.2c2.7 1.6 5.1 11 5.1 11z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#656263",
      stroke: "#000",
      d: "M518 226.1c1.4-.8 5.5-2.1 5-8.2-.5-6-5.7-6.8-8.7-6.6-3 .2-5.5 2.8-5.5 2.8l-9.8-6.2s4.9-30.7 10-32.6c5-3.5 5.8-5 5.8-5.8 0-.9-1.8-2.9-1.8-2.9l-31.7-3.7-30 3.5s-2.2 3.6-2 5c.4 1.4.5 2.9 5.8 7 6 4.6 10 30.8 10 30.8s-8.3 4.2-8.9 3.6c-.5-.5-3-1-4.3-.8-1.3.2-5.7 2.5-5.7 8.2 0 5.8 4.4 9.1 4.4 9.1s28.6-3.3 32.9 4.6c4.1-9.5 31.3-6.2 34.6-7.8z"
    }),
    /* @__PURE__ */ jsx162("path", {
      stroke: "#000",
      strokeLinejoin: "round",
      d: "M548.9 194.2s.3-3.3 2.7-4.9c2.4-1.6 18.2-2.4 22 0 3.8 2.4 5.2 14.1 5.2 14.1s2.4 4.1 2.6 7.2c.1 3 .5 5 .5 5s12.6 16.5 12.8 31.4c1.4 10.1 1.1 37.2-2.9 47.5a43.4 43.4 0 0 1-5.5 21.3s1.3 2.2 1.1 4.6c-.2 2.3-1.4 4.6-1.4 4.6l18.5 9.1-6.8-2.5 6.8 5.7-7.7-3.6 4.5 4.6c-.1-.2-11.2-5.1-11.2-5.1l5 4.7-8.5-4s5 5.5 5 5.2a91 91 0 0 0-7.4-3.2l.4 2.7s-5.8-.3-5.8-4.6a19 19 0 0 1-4.7-3.8l-13.2-2.2-14.9-44.6 3.5-75.2 1-3.8z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#fb0",
      stroke: "#000",
      d: "M539 434.8s-7.7-16-11.5-16.3c-3.4-6.6 12-60 41.7-63.1 16.3 1.3 1.3 18.8-9.4 13.4a44.7 44.7 0 0 0 6.7 11.5s-21.3 9.2-27.6 54.5zm-102.3 2.3s6.3-18.3 10.1-18.5c3.9-.2-10.1-60.9-40.6-61.3-16.4 1.3-1.3 18.9 9.5 13.5a44.8 44.8 0 0 1-6.8 11.5s21.5 9.2 27.8 54.8z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#00713d",
      stroke: "#000",
      d: "M464.6 323c0-.2-7.6 2.3-2.7 10.5.3-3.2 3.7-5 3.7-5s-5.1 6 .3 11.1c.7-4.8 3.8-6.3 3.8-6.3s-3.9 11.2 0 13.5c.5-4.5 3.3-6.5 3.3-6.5s-3.4 10-.3 12.3c.3-3.8 2.9-5.5 2.9-5.5s-1.5 10.5 2.5 11.2c0-3.7 3-7.3 3-7.3s-1.3 8.5 5 8.9c0-3.2 1.2-6.9 1.2-6.9s2.9 9 7 7.6v-7.7s2.7 8.6 7.7 7c-.7-2.4.3-5.3.3-5.3s2.6 5.4 7.4 3.6c.8-1.6-.2-4.8-.2-4.8s7 7.2 9 2.9c2.2-4.3-5.5-5.8-5.5-5.8h5.2s-1.7-4.4-8.7-5.4c2.4-1 4.9-.2 4.9-.2s-1.5-5.5-8.7-6.1c2.8-1 6-.3 6-.3s-1-5.2-9-6.7c1.3-1.4 4.7-1 4.7-1s-3.2-4.9-6.8-4.6c-3.6.3-36-3.3-36-3.2z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "none",
      stroke: "#3ec26d",
      strokeLinecap: "round",
      d: "M496.6 349.5s3 1.4 2.8 2.6m-1.1-4.9s3.7 2.6 3.6 4.5m-.3-5.8s2.9 1.8 3 4.7m1.9-3.6s1.4 3.2 1 3.8m1.9-2.1c.2 2.5-.2 2.8-.2 2.8m-36-18.5s3.5 2.2 3.2 5.3m-3.4-2.7s1.6 1.6 1.3 2.6m3-5.2s2.3 3.2 1.5 5.4m2.4-3.3s1 2 0 3m1.8-2.1s1.2 2 .1 2.7m-1.5 3.9s3.2.7 3.7 3.1m-1.8-5.3s3.4.2 3.8 3.8m.7-5.1s2.3 4 1.9 5.2m2.4-4.8s.9 3.7.2 5m2.6-3.5v4.3m-4.2-10.2s2 .8 2 2.9m-.1-4.8s2.7 1.5 2.5 4.5m.7-5.7s2.3 2.7 1.5 5.8m2.5-5.2s-.8 3.5-.4 4.9m3-2.5s-1.5 1.1-.7 2.6m-12.7 10.8s.5 2.6 0 3m-3.3-4.6s1.6 3 1 4.4m-4.6-4.5s1.9 2.2 1.8 4m-4.8-3.6s1.8 1.7 1.6 2.7m-3.1-.1s1.7 1.8 1.6 2.1"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#fff",
      stroke: "#000",
      d: "m441.3 229.3 24.3-.5s16 0 17.7 5.2c3-6.9 17-6.5 17-6.5l25-.8.5 60.6c-5 23.6-22 40.2-40.7 47.3a62.3 62.3 0 0 1-41.2-47.7z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#006b00",
      stroke: "#000",
      d: "m450 229 35.3 94.2 32-96.2c-10 .6-31.2-1.6-33.9 7.5-4-8.1-26.4-4.9-33.5-5.5z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#ffc900",
      stroke: "#006b00",
      strokeLinecap: "round",
      strokeWidth: 0.5,
      d: "M474 280c1.4.7 1.3-25.5 3.1-26.3l1.4-5.5c-1.5-2.7-8.4-2.6-11-.2l1.7 4.8c3.5 5.6 2.8 27.8 4.8 27.2z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#cdad56",
      stroke: "#000",
      strokeLinejoin: "round",
      d: "M464.5 77s2.5-2.9 2.6-3.5c.2-.7 11.4-1.2 18-13.7 3.8-6.5 0-2.7 0-2.7L485 54s4.6-4.4 3-6.8c-1.8-2.4-1.2 3-4 3-2.7-.1-1.2-6-1.2-6s-.2-.6-1-1c-1.1.2-.8 2.2-1.8 2.4-1 .3-2-4.7-2-4.7s-1.7-2.3-3.1 4.8c.8 7.7 5.6 6.2 5.6 11.2 0 5-4.3 8.8-5.5 9-1.3 0-.8-4.3-.8-4.3s-.7-2-1.1-2c-.5 0 2.5-.5 2-6.1-1-6.8-1.8 1.6-3.6 1.2-1.9-.3-.5-6.2.2-7 .7-.6-.8-3.4-4.8 3.8-.3 3.6-.8-.9-1.6-.6-1.3 2.8-1.1 4.8.8 7.4 2.9 2.7 4.7 5.3 4.6 6.6-.1 1.4-1.6 4.5-3.7 4.5-2 0 .1-3.8 0-5 0-1.3-3.5-5.8-3.5-5.8s-2.4-3.9-2.1-4c.2-.1-.3-.7-1.4 3.3-1.1 4-2.5-2.6-2.5-2.6s-1.6 4.9 1.8 7.8c-2.6-.3-2.8.7-2.8.7 0 1.4 3.5 2 4 4.3.4 2.4-3.7 3.8-3.7 3.8s1.7 2.3 6.5-2.3c.1 3-1.8 5-1.8 5 1.6.7 2.8.6 3 2.5z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#cdad56",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 0.9,
      d: "M449 77s-2.2-3.2-2.3-3.8c0-.6-10.4.8-15.3-11.8-3.2-6 0-2.5 0-2.5l.2-2.9s-3.4-4.1-2-6.3c1.5-2.2 1 2.8 2.8 2.8 2.3-.1 1-5.4 1-5.4s.2-.6 1-.9c.9.1 1.3 3.2 2.1 3.4.9.2 2.7-3.6 3.3-4.4.8-.1.7-3.2 2 3.3-.7 6.9-6.4 5.5-6.4 10 0 4.6 3.6 8.1 4.7 8.2 1 .2.7-3.8.7-3.8s.6-1.8 1-1.8c.3 0-3.4.7-3-4.5.8-4.8 2.7.3 4.3 0 1.5-.3-.2-5 .2-5.8.1-.8 2.4-3.9 3.3 3 .3 3.3 2-2.7 2.7-2.5 1.2 2.6-.5 6-2.1 8.4-2.4 2.4-3.5 5-3.4 6.2 0 1.3.6 2.8 2.4 2.8 1.7 0 .5-2.2.6-3.3.1-1.1 3-4.8 3-4.8.6-1 .1-2.6.7-3.4 1 0 1.4-1.3 2.3 2.3 1 3.6 2.1-2.4 2.1-2.4s1.4 4.5-1.5 7.2c2.2-.3 2.4.6 2.4.6 0 1.2-1 1.7-1.4 4a3.7 3.7 0 0 0 1.1 3.3s-1.4 2.2-5.5-2a7 7 0 0 0 1.6 4.5c-1.4.7-2.4.6-2.6 2.3z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#ffc900",
      d: "M511.3 243c-2-1.8-2.3-.2-3.4-.6-.5-.2-.9-.7-1.3-1.1-.4-.4-.9-.6-1.4-.8l-.6 1.7c-.2.6.6 1.5.6 2.4-.2 1.3-.7 2.3-2.3 2.7.5-.9.7-.9.6-2 0-.5-1.6-1.5-1.4-2 .2-.9.7-1.8.4-2.7-.7.5-1.5.2-2.2.5-.5.3-.6 1.3-1.3 1.7-.8.4-2.5.2-4-.6.9-.7 1.6-.2 2.5-1 .4-.2.4-1.7.9-2l1.9-1c-.4-.5-.4-1.2-.8-1.6-.4-.5-2.1-.4-2.5-.8-.8-1-.7-2.1-1.4-3 2 .7 1.7 1.7 2.2 1.6 1-.5 2-.5 2.5-.3s1.4 1.5 2 1.7l.6-1.9c.2-.6-.8-1.5-.7-2.1.4-1.1 1.4-2.1 1.8-3.3l.4 3.1c.1.6 1.2.9 1.2 1.4.1.6-.5 1.8-.5 2.4.6-.1 1.5 0 2-.2.7-.1 1-1.5 1.6-1.6 1.2-.2 2-.1 3.3 0-1 .9-1.6.8-2.1 1.6-.5.3.1 1.4-1.1 2.2-.5.3-1.8 0-2.2.3l1.2 1.3c.4.5 2.1.7 2.5 1.2.8.8 1.2 2 1 2.9zm-54.3 1c2-1.9 2.3-.2 3.4-.7.5-.2.9-.6 1.3-1 .4-.5.9-.6 1.4-.9l.6 1.8c.2.5-.6 1.5-.6 2.3.2 1.3.7 2.3 2.3 2.8-.5-1-.7-1-.6-2 0-.6 1.6-1.6 1.4-2.1-.2-.8-.7-1.8-.4-2.6.7.4 1.5.2 2.2.4.5.3.6 1.3 1.3 1.7.8.4 2.5.2 4-.6-.9-.7-1.6-.2-2.5-.9-.4-.3-.4-1.8-.9-2-.4-.4-1.5-.8-1.9-1.1.4-.5.4-1.2.8-1.6.4-.5 2.1-.4 2.5-.8.8-1 .7-2.1 1.4-3-2 .7-1.7 1.7-2.2 1.6-1-.4-2-.5-2.5-.3s-1.4 1.5-2 1.7l-.6-1.9c-.2-.5.9-1.5.7-2-.4-1.2-1.4-2.2-1.8-3.4l-.4 3.2c-.1.5-1.2.8-1.2 1.3-.1.6.5 1.9.5 2.4-.6-.1-1.5 0-2-.2-.7 0-1-1.4-1.6-1.6-1.2-.2-2-.1-3.3.1 1 .8 1.6.8 2.2 1.5.4.4-.2 1.5 1 2.2.5.3 1.8 0 2.2.3l-1.2 1.4c-.4.4-2.1.6-2.5 1-.8 1-1.2 2-1 3"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#ffc900",
      stroke: "#006b00",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.5,
      d: "M509.4 249.2c-1.9 1.5-14.3 4.6-14.4 15.3-.1 10.8 2.2 13.2-.1 13.5-4.5 0-5.1-12-5-17.3.1-5.3.3-4.5.3-4.5s3 .8 2.8 3.4c-.3 2.6 3-6.4 1.9-8.8 2 2 4.7 1.2 4.7 1 0 0-1.5-1.7-2.2-3-.6-1.1 2.3.8 2.3.8s.2-2-2.4-2c-3.3 0 .5-1 .5-1s2 1.7 3.2-.2a11 11 0 0 0-3.4-2.3s-1.8-3.4-4.2-4c-2.8-.7-2.5 1.2-5.7.9-.6 1.2-.6 1.4.7 1.8-2.2 1.5-1 4.4-1 4.4s3.4-1.4 3.3 1c-.1 2.5-2 2-3.3.5-1.2-.6-1.6.7-1.6.7l1.8 2s-3.4-.2-4.3 2.1c1.9-.1 3 .4 3 .4s-4 1.8-4.4 2.7c-.4 1-.5-1-.7-1l-3.8-1.4-1.3 5.9s2.6 2.5 4 1.7 4-3.3 5.5-2.6c-4.5 3.4-9 8.3-11.4 9-.6-.6-2.8-2.7-3.7-1.6-.9 1-.2 2.4 1 2.3 1-.2-3.8 1-2.8 3.1 1 2 1 1.9 1.8 1.4 1-.6-.7-.7 2.6-1.7s3.2-1.9 3.2-1.9-.7 1.5-2.5 2c-1.7.3-3.1.3-2.8.9.4.5 1.2 1.5 1 2-.3.6 3.6-2.8 4.7-.1 2.6-.2 4.4-3.4 3.1-5.3.2 2 1.4 2.7.7 3.7-.8.9 6-3.2 2.7-5.6.8 2 1 3.6 1 3.6s1.5 0 1.9-.6c.4-.6-.8 1.5-.3 1.9.5.4 3 2.7 2 4.3-.7-1-.8-2.4-1.6-2.3-.8.1-4 2.5-5.9 2.6-1.9.1 2.3 7 2.3 7s-2.9-.3-3.3 0c-.4.2-2.3-2.5-2.6-.9-.7 2 .6 1.2.6 1.2s-1.7-.8-2.6.2c-.9 1-1.7 1.9-1.1 2.3.6.4 3.4.4 3.8.3.4-.2-3.2.2-3.4.6-.3.4-.8 2 0 2.5.7.5 2.7-.3 2.8-.7.1-.4.2 1.5.2 1.5s3.3.3 3.3-3.1.3 2.4.3 2.4 3.3.6 3.4-2.8c.2-3.4.4 2.3.4 2.3s2.2-.7 2.2-1.2c0-.6-.1 6.7-1.7 8.8-2.4-1.6-4 1-4 1s.2 4 0 5c-.3 1 1.6-.6 1.7-1 .2-.4 2.5-1.5 2.6-1.7l.8-1.7s-.6 2-1.4 2.2c-1 .3-1.8 1.2-1.4 2 .3.9 1.7 1.4 2.2 2.2.6.8 2.3-4.7 2.3-4.7l.2 1.2s2.3-.6 2.5-1.7c.3-1-2.4-2-.2-3.8 2.1-1.7 0 1.7 0 1.7s.7 2.6 1.2 2.6c.6 0 1.8-5 .6-6.2-1.3-1.2 1.9 1.5 1.9 1.5s1.8-5-.2-5.7l-2.8-1s1-1.3.5-1.4c-.5-.2 2.7 3 3.2 2.1.5-.8 1.3-3.2-2.4-4.6-3.7-1.3-.1-5.1-.1-5.1s2.3 2.7 4 1.2c1.6-1.5-.2-1.5-.2-1.5s4.7-3 4.9-4.5c-1-.1-2.5.1-2.5.1s2.7-1.7 2-4.6c-1 1.5-2.4 1.5-2.4 1.5s2.3-2.3 2-4.5c-1.4 1.1-1.3 2-2.2 1.7-.9-.3-2.4-8.9 1.1-9.4 3.6-.6 1.7 4.2 1.8 4.2.2 0 5.4-2.2 0-5.7 1.3-.4 4 2 4 2s-1.2-6-7-2.3c1.5-1.5 2.4-2.4 3.5-2.2 1.2.3 5.3-.1 5.3-1.3-1-.8-3.2.4-4.4 0-1.1-.4 8.2-1.1 7.4-5.7"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "none",
      stroke: "#006b00",
      strokeLinecap: "round",
      strokeWidth: 0.5,
      d: "M469 252.7s5.1-2.9 7.6.7m2.1 5.4c-.1 0-1.8 1.8-2.2 1.8m5.6 3.9s4.8.4 7.8-4.6"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "none",
      stroke: "#006b00",
      strokeLinecap: "round",
      strokeWidth: 0.5,
      d: "M487.2 263s.4 2.7 1.2 2.7c.7 0-1.3.7-2 .2.8 1.2 1.3 3.4 0 4.2"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#e80000",
      stroke: "#006b00",
      strokeLinecap: "round",
      strokeWidth: 0.5,
      d: "M484.8 297.3s-1.6 1.9-3.7 2"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "none",
      stroke: "#006b00",
      strokeLinecap: "round",
      strokeWidth: 0.5,
      d: "M486.7 288.6s-1-5.5-.4-6.8c.4-1.8 2-2.5 3.4-4.8"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "none",
      stroke: "#006b00",
      strokeLinecap: "round",
      strokeWidth: 0.5,
      d: "M486.2 284.6s-1.3 3.3-6.9 2.2m8.4-10.3s.4 4.3-4.7 2.7m-1.5-22.2s-2 1.8-1.3 4.4"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#006b00",
      d: "M489.1 252.1s2.7-1 3.2-1.6a8 8 0 0 0 1.7-2.4c.2-.8-1.8-2-.8-3.8.7-.9 1.6-1 3 0 1.6 1-1.3-3-2.8-3.2-1.6-.1-2.6 1.1-3 .8-.4-.2.1 1.1-.5 1.1s1.3 1.1 1.2 1.8c-.2.7 2 3 1.9 3.5-.2.6-3.2 3.7-3.9 3.8"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#ffc900",
      stroke: "#ffc900",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.5,
      d: "M491 243.2c1.2-.3 1.4 0 1.2 1a3 3 0 0 1-1.1-1z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#e80000",
      stroke: "#006b00",
      strokeLinejoin: "round",
      strokeWidth: 0.5,
      d: "M483 303.7s-.5 2.9.5 3.1c0-1 .3-1.8.5-2.1zm-2.5-3.5c-1-.1-2.5.8-2 1.8.7-.7 1.4 0 2-.7v-1zm0-2s-1.5-.2-1.7.9c1-.2 1.4-.3 1.7 0z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#e80000",
      stroke: "#006b00",
      strokeLinejoin: "round",
      strokeWidth: 0.6,
      d: "M474.1 282.2s1 .3 1.2 1.3c.7-.4 1-2.6-1.2-1.3zm-2.3 2.4s2-1.2 2.1 0c-.4.3-.5.6-.8.7-.3 0-.8-.8-1.3-.7zm-.1 3.9s1.2-1 1.6-.4c.5.8-.4.7-.4.7zm-1.7-21.9s-1.5-.6-2.1.5c1 .2 1.3.5 1.8.9-.2-.5-.4-1.2.3-1.4zm-2.9 8.3s0-1.9 1-2.6c.4.3.5.7.8 1.2-.6.2-1.4.2-1.8 1.4zm3.9-1.3s-1.6.8-1 1.7c.5-.7 1.1-.5 1.1-.5v-1.2z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#ffc900",
      stroke: "#006b00",
      strokeLinejoin: "round",
      strokeWidth: 0.6,
      d: "M468.7 255.8c-.6.7.7 2.2 2.1 2 .4-1.6-1.7-2.5-2-2z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "none",
      d: "M468.7 252.6c-.3.8.9 1.9 1.5 1.6.3-.8-1.2-2.2-1.5-1.6"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#e80000",
      stroke: "#006b00",
      strokeLinejoin: "round",
      strokeWidth: 0.6,
      d: "M470.2 254.6s.3 1.3 1.5 1a4 4 0 0 0-1-1.9c0 .3.1.8-.5.9zm.8 3.7s.7.8 2-.7c-.6.1-1.6-.4-1.6-.4s0 1-.4 1.1z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#ffc900",
      stroke: "#006b00",
      strokeLinejoin: "round",
      strokeWidth: 0.6,
      d: "M468.6 252.8c-.5.7.3 1.7 1.7 1.5.3-1.7-1.3-2-1.7-1.5z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "url(#gs_svg__d)",
      d: "M469.2 246.3s5.5-1.6 8.4.8c3 2.3 3 .2 3 .2s4.2 1.6 5.4 1.2c1.2-.3-.9.2.8-.9 1.7-1-3.4.3-3.8-1.9-.8-1.3 0-3-1.7-2.4-1.2-1.6.8-2.7.3-4.4-1.2 1-1.9-.3-2.9 2-2.3-.5-.3-3.8-2.9-4.1 0 2.3-1.9 2.4-2 3.8-1.1.8-6 3.7-4.6 5.7"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#c01500",
      stroke: "#000",
      d: "M406 425c3.6-1 22.9 4.2 30.3 12.2-1.6-14.3-5.5-25.1-5.5-25.1s-11.5-3.3-13-1.7a80.8 80.8 0 0 0-11.8 14.5zm-5.9-65.7c-1.3.2-2.7 1.1-4 3.4-1.6 3.8-2.7 13.5-5 15.8-2.2 2.2-4.3 2.4-4.3 4.5 0 2 .3 6.7 6.3 8.5 6.1.3 15.8-9.7 15.8-9.7s5-5.4 7-11.2c-11.7 4-20-6.8-15.8-11.3zm169.6 63.4a53 53 0 0 0-30.4 12.1c1.6-14.1 5.5-25 5.5-25 1.3-.3 11.3-3.2 12.8-1.6 2.3 2.4 9.7 9.7 12.1 14.5zm5.5-65.3c1.3.2 1.8 2 3 4.2 1.5 3.9 3 9.4 5.3 11.6 2.3 2.3 4.3 5.6 4.3 7.6s-.5 4.8-6.5 6.6c-6 .2-14.8-7.6-14.8-7.6s-5-5.3-7-11.2c11.7 4 19.2-6.3 15.7-11.2z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#fb0",
      stroke: "#000",
      d: "M393.4 412.5s12.1 8.4 12.4 12.2c32.7-48.5 116.1-63.6 163.7-3.4 6.3-8.3 12.8-11 12.8-11-50-65.4-149.7-57.3-189 2.2z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#1e5aa6",
      stroke: "#000",
      d: "m517.4 227 4.8-.1-8.5 10.8 10.2 11.9-20.1 25.3 19 22.8a57.9 57.9 0 0 1-7.8 14l-10.9-12L524 275l-16.2-18.4zm-68.1 2.2h-5l9.5 10.4-10.1 12.6 21 22.8-17.4 23.3c2 5 5 10.8 8.3 15l10.3-13.1-21.2-23.6 15.5-19.7z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#1e5aa6",
      stroke: "#000",
      d: "m473 290.4-7.6 10 26.8 31c4.8-2.4 8.5-5.1 12.5-8.4l-14-16.1 5.7-16.7 8.2 9.4-25.5 32.6c-4.3-1.8-9-4.6-13.3-8.2l13.5-17.1zm-8.3-15.5 4.8 6.1-3.1-8.3zm34.9 5.4 4-5.2-1.5-2z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "none",
      stroke: "#fff700",
      strokeLinecap: "round",
      d: "M556 195s4.8-4 8.1-4"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "none",
      stroke: "#fff700",
      strokeLinecap: "round",
      d: "M556.7 194.5c.1-.1 28.1-4 29-5m-28.9 5.2 31.4-2.7m-31.5 2.8s33.3-1.5 35.3.2"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "none",
      stroke: "#fff700",
      strokeLinecap: "round",
      d: "M556.6 194.7s32.6.3 33.2 1m-33.1-1 31.4 2.6m-31.7-2.3s32 2.8 35 6.8"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "none",
      stroke: "#fff700",
      strokeLinecap: "round",
      d: "M593.1 207.5c0-.1-10.8-12.9-36.8-12.7"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "none",
      stroke: "#fff700",
      strokeLinecap: "round",
      d: "M556.4 195s18 1.3 23.7 7.6"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "none",
      stroke: "#fff700",
      strokeLinecap: "round",
      d: "M556.7 194.8s11.7-2.2 23.9 12.5"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "url(#gs_svg__e)",
      stroke: "#000",
      d: "M549.4 208.2s16.1.6 16.1 2.2-12 4.6-12.2 11.2c-.1 6.7 9.2 7.2 9.9 15.6.6 8.4-7.3 9.6-9 11.9-1.5 1-5.3 13-4.8 20 .5 6.9 2.5 30.5 6.2 35.3 2.8 2.2 7 9.3 11.7 7 4.6-2.1 1.4-10.2 1-12.4-.5-2.2 1.8-5.9 1.8-9.2 0-3.4-1.7-6-1.5-6.8.1-.8 12.8 3 12 15.5-.8 12.5-5.9 8.7-5.9 8.7s1.6 15.4-2.3 17.4c-7.2 3.8-12.4-.8-12.4-.8l.7 3.2-5.5-2.8s-7-10-8.5-14.5a126 126 0 0 1-2.9-28.5c.7-4.3 1.1-29.3.8-30.6-.3-1.2-1.6-22.1-.8-25.3.8-3.2 5.7-17.1 5.6-17.1z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#ff7000",
      stroke: "#000",
      d: "M532 204s11.2-10.9 17.7-9.6c3.3 0 .2 2.4.2 2.4s5.7.4 6.5 3c.1 1-2.7 1.4-2.7 1.4s2.3.5 2.5 2.5c.2 2.1-24 .5-24.3.4z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "none",
      stroke: "#000",
      d: "M532.6 203.6s12-1.6 17.1-6.7"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "none",
      stroke: "#000",
      d: "M544.8 200.3s8.9-.4 8.9 1"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#fff",
      stroke: "#000",
      strokeLinejoin: "round",
      d: "M576.3 329.9s7.6-1.8 9.7-4.5c1.2-1 7.9 10-9.7 4.5z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      d: "M574.3 267s1 5.8-1.8 9.8c-1.4 1.6-5.7 4.3-5.7 6.2 0 1.9 1.6 4.4 1.3 6.6-.3 2.2-2.7 4.5-2.6 6.4 0 1.9 2.7 12 2.4 12.2m-7.6-60.2s-6 2-7.3 8"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#c75b00",
      stroke: "#000",
      d: "M557.8 200.3s2 5.7 8.7.3c-4.3-5.9-8.7-.2-8.7-.3z"
    }),
    /* @__PURE__ */ jsx162("path", {
      d: "M562.7 200c0 .3-.3.6-.7.6-.4 0-.7-.3-.7-.6s.3-.5.7-.5c.4 0 .7.2.7.5"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#fff",
      stroke: "#000",
      d: "M503.4 187s12.6 13.7 20.7 13.5c1.5 4-3.7 7.8-5.7 9.5-4.2-1.3-8 .3-17.6-11.6.6-7.6 2.7-11 2.6-11.4zm17-31.8c1.7-5 5-9 7.8-9.5-.8-3.8 5.9-20.9 25.3-27.4 1.2 8.7-8.3 17.4-8.3 17.4s28.7-5 34.5-12.2c-.6 3.2-6.4 23.6-37 23.4 11.6 11-3.7 19.8-10.2 17.1 12-9.2-3.5-14.7-12-8.8z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#cccccd",
      stroke: "#ccc",
      d: "M530.2 148.1c5.8-3.7 7.9-3.7 12.7-3l-3.5.6s-.3.5 1.8 2.4c-2.4-.6-4.4-2-11 0z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "none",
      stroke: "#000",
      d: "M528 145.7s11.4-6 17.8-10.2"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#00f",
      stroke: "#000",
      d: "M518.2 210s15.7 4.3 17.5-18.2c-3.4-9.8-8.1-31-.9-37-6.6-4.6-14 .2-14 .2-.4 1-6.3 9.5 1.7 24.3-19-5-11.3 13-11.3 13 .8-3 10.9-5.6 13.4 8.8 1 3.6-6.8 9-6.4 9z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#00f",
      stroke: "#000",
      d: "M535.9 192s16.6-9 16.2-30c-14.2.4-19.2 18.6-19.2 18.6z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#fff",
      stroke: "#000",
      d: "M461.3 190.9s-12.3 10.7-19.3 7.3c-5.1 3-11.2-2.4-11.2-2.4s7 26.3 32.6 7.3a60.5 60.5 0 0 0-2-12.2z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#00f",
      stroke: "#000",
      d: "M441.9 197.7c1-5.5 5.3-8.2 8.8-3 4.6 1 9.2-18-7.2-14.8 4.6-24.7-9.2-33.9-9.2-33.9s-4.9 27.4-2.6 32.4c2.2 5-3.3-9.3-21-13.4-.3 20.7 19.8 30.3 19.8 30.3s5.6 5.2 11.4 2.4z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "none",
      stroke: "#000",
      d: "M443.5 179.7s-7.7 6.6-6 15.5m-5.7-16.3s-1.8 6.3 2 15.4"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "none",
      stroke: "#000",
      d: "M430.6 196.4s3.6-5.8 11.3 1.6"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#fff",
      stroke: "#000",
      d: "M432.1 156.3c0-.2-11.7 0-4.8 11.9-5.1 1.6-16.7-6-8.7-16-26.3-.7-37-13.3-37-24.9 7.7 8 26.2 4.8 32.7 9.7-8-7.4-6.4-17.7-6.4-17.7s22.4 6.7 26.4 26.6c-1.3 3.9-1.9 10.7-2.2 10.4z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "none",
      stroke: "#000",
      d: "M414 136.5c4.4 4.4 15.5 5.7 21.1 10.6"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#cccccd",
      stroke: "#ccc",
      strokeWidth: 0.7,
      d: "M419.2 149.5s9.2-1.2 11.9 2c-3.6 0-4.8-.9-10 1 1.4-.7 1-2 1.8-2s-3.3-1-3.7-1z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#923f00",
      stroke: "#000",
      d: "M465 77.5s5.1-4.5 10.6-.5c-2.5 7.4-11.4 4.6-11.4 4.6s.3 3.7-.6 5.5c1.8 1.4 3.2 5.8 3.2 5.8s9.2-2.2 11.2 1.8c3.5-.5 6 0 6 0s7.2-1.8 9.7-1.8c2.5 0 10.5 2 11.3 3.6.7 1.4 3.4 11.4 5.2 11.2 1.8-.1-4.3 2.4-6-.1-1.6-2.5-1.1 3.3-1.1 3.3s5 5.3 5.6 6.5c.6 1.2-3.1 10.8-.3 17.5-2.5.2-2.7 2.8-2.7 2.8-.1 3-3.8 3.7-3.8 3.7l-1-4-2.4 1.5 1-3.1s3.4-8.3 3.7-11c.3-2.7-3.1-7.4-5.8-7.4-2.7 0-4.6 8.5-4.6 8.5s-1.3 6.3-.9 7l-1.8-2.1s-1.1 3.8-2 5c-1 1.2-2.9 1.6-2.9 1.6s-1.3-3.8-.8-5.3c.4-1.5 7.2-7.3 6.6-11.4-.6-4.2 0-3.2-.1-3.3-.2-.2-3.6-3.1-3.7-4.8-.2-1.6-4.5 2.1-10.1 1-1.7 3-2 10.5-2 10.5s-.5 9 .6 10c1.2 1.1-3 3.3-3 3.3l-2.9 4-1-2.3-2.1 1.5 1.2-3c-.1-2.3 2.9-8.4 2.9-13.6 0-5.2.3-10.8.3-10.8s-5.4-.3-5.3 5.4c.1 5.6-1.3 6-1 7.5.3 1.7 1.7 6.3 1.3 7.6-.4 1.4-2.2 1.8-2.2 1.8l-.5.7s-5.5 2.6-5.3 3.6l-.2-3-.3-4.3s3.3-2 3.3-7.2-.7-6-.6-7.2c.1-1.2.9-5.5.7-6-.1-.4-3 1.3-4 1.3-.9 0 1.7-3.1 2-5.4.3-2.2-3 2.1-5.7-.4 1.3-2.7 3.1-3.6 3.4-5.6.3-2.1-2 1.7-4.1.2.2-2 2.2-3.7 2.2-3.7s-1.7-.2-2.4 0c-1.3-.4 1.5-2.5 1.7-5.5.1-3-1.7-4.1-1.7-4.3 0-.1-3-2.6-3.4-3.7-.4-1-.4-2.2-.4-2.2s-5 3.6-10.7-4c5.3-4.5 11-1.2 11-1.2s1.5-4.2 8.3-3.9c6.8.3 8.2 4.2 7.9 3.8z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#00f",
      stroke: "#000",
      d: "M502.4 154.2c.1 0 12.6.4 12.7 7.1.2 6.7-3.8 5-4 5l-9-1.2z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#fffeff",
      stroke: "#000",
      d: "M490.3 152.4s15.6-.1 14.7 6.7c-.9 6.8-4.8 5.4-4.8 5.4l-7.6-.6z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#00f",
      stroke: "#000",
      d: "m481.5 151.7 9 .7s5.5.7 5.2 6c-.2 5.1-5.5 5.2-5.5 5.2l-8.8-.5z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#fff",
      stroke: "#000",
      d: "M460.4 154.2c-.2 0-12.6.4-12.8 7.1 0 6.7 3.9 5 4 5l9.1-1.2z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#00f",
      stroke: "#000",
      d: "M472.5 152.4s-15.6-.1-14.7 6.7c.8 6.8 4.8 5.4 4.8 5.4l7.5-.6z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#fff",
      stroke: "#000",
      d: "m481.3 151.7-9 .7s-5.5.7-5.3 6c.3 5.1 5.6 5.2 5.6 5.2l8.8-.5z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#5e0043",
      stroke: "#000",
      d: "M505.4 226.7s6.5-9.5 9.3-8.5c2.4.8.5 8.2-.6 8.9zm-44.4 1.7c-2.1-2.8-5-10.7-7.8-8.5-2.4.8-.6 8.2.6 8.9z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "none",
      stroke: "#000",
      d: "M465.2 209.5s12.7 7.8 16.8 8c4.2.2 17.3-10.1 17.3-10.1"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#5e0043",
      stroke: "#000",
      d: "m466.5 179 2.4-3 12.1 6 12.4-5.5 2.4 2.6-13.8 9.7z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#474747",
      stroke: "#474747",
      strokeLinejoin: "round",
      d: "M456.8 178.8a51 51 0 0 1 10.3 18.7c1.4 7.9-.8-10.9-.8-10.9s9.7 4.8 10 7.8c.3 3 4.6-.2 4.8-.7l-28-18.2zm48-.5s-10.2 13.4-9 28c-2.1-7-.4-18.5-.4-18.5l-2.2 1.4s-2.4 9.9-5.3 11.4c-.5-1.2-.4-1.6-.4-1.6s-3.1 4-3.7 4.4c-.6.4.2 13.7.2 13.7s1 9.6 2.2 9.5a41 41 0 0 0-3 1.7l-1.3-25.6 2.9-2.9s3.8-4.7 4.1-9.2c-1.6 1.4-3.5 1.8-3.5 1.8s-.5 6.5-2 7.4c-1.6 1-1.6 2.6-1.6 2.6l-.4-8.5z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      d: "m481.4 193.8 2 40.5"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "none",
      stroke: "#000",
      d: "M456.5 213.2s4.7 2.7 6.4 11c15.2-1.1 20 4.2 20 4.2s12.4-6 18.2-4.8c2-4.3 7.8-9.7 7.8-9.7"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#b4b6b9",
      stroke: "#000",
      d: "m450.2 173.5 31.2 20.4 28.2-18.9s5.8-3.2 5.3-5.5c-.5-2.4-2.5-1.5-3.5-1-1 .3-29.5 20.5-29.5 20.5l-30.2-19.2s-2.2-.7-2.6.8c-.4 1.4.8 2.2 1.1 2.9z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#474747",
      stroke: "#474747",
      strokeLinejoin: "round",
      d: "M506 168.2s-8-3.4-8-.5c0 3 .3 3.3 1.6 5.2 1.3 1.8-1 3-1 3l-.8-2c-.4-1.3-4.7-2.2-5-3.8-.5-1.5.8-3.9-1.7-4.2-2.6-.3-5.1 1-5.6 4a61 61 0 0 1-3.9 9.8l.5-15.6c5.6.4 16 1.6 24.1 2.6-2.4-.4 1 .1.8 1-.2.6-1 .7-1 .5zm-28.2-3.9a37 37 0 0 0-10.4 1.9c-1.8 1 3 2.7 2.3 4-.6 1.5-.7 4.4-3 3.8-2.2-.6-9.8-4.4-10-5.7-.3-1.2-1.8-1.3-1.8-1.3s21.8-3 22.9-2.7z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "none",
      stroke: "#000",
      d: "M481.2 162.5v19.1m-14.7-41.7-9 14.6"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "url(#gs_svg__f)",
      stroke: "#000",
      d: "M482.6 139.5s3.8 5.2 3.4 6.7c1.5 1.2 3.3 6 3.3 6"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "none",
      stroke: "#000",
      d: "M497.3 138.7s-8.2 11.6-8 12.5"
    }),
    /* @__PURE__ */ jsx162("path", {
      d: "M455.1 83.4c-.2.6-1.2.9-2.3.6-1.1-.4-1.9-1.2-1.7-1.8.2-.7 1.3-1 2.4-.6 1 .3 1.8 1.1 1.6 1.8m3.4-.2c.2.6 1.2.9 2.3.5 1.1-.3 1.9-1.1 1.7-1.8-.2-.6-1.3-.9-2.4-.5-1 .3-1.8 1.1-1.6 1.8"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#ff7000",
      stroke: "#000",
      strokeLinejoin: "round",
      d: "M555 324s-3.2.5-3 .8c0 .3-9 .6-9.1.3-.2-.3-1.4 1.5-1.4 1.5l1.5-.9s2.2 2.3 2.8 2.1c.7-.1-.3 1 0 1.1.1.2.8-.4.8-.4l14.8-.2zm5.4 4.5-12 .4s-3.1 2.8-3.3 3.4c-.2.7 2 .9 2 .9l.6 2.3 1.6-.6s10.3 1.5 19.7-.6c4.8-1.6 5.7-3.6 2.3-4.9-3.3-1.2-10.8-.8-10.9-.9z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "url(#gs_svg__g)",
      stroke: "#000",
      d: "m519 353.4 21.7-1-4-3.4 59-2.4-2-4.7-66.1 2.7 8 3.7-18 .5.6 1.9-4.7-.2s5.3 2 5.4 3z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "url(#gs_svg__h)",
      stroke: "#000",
      d: "M543.4 232.9c-1.7-.9-9.4-2-17.9 3.6l.4 19.6s12.5-6.7 18.5-5.2c-.3-6-.3-13.8-1-18z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "none",
      stroke: "#000",
      d: "m422.7 292.4-51.4 51m74.4-50.7-41.8 55m39.9-69.3-55.7 67.5m-1.7-.9 5.4-6.4m62.6-26.3-21.6 29.8m-.9 3.9.5 11.4m31.9-34.7-23 28.8m18.9-2.3 9.3-15.3m-5.7-2.9-11.2 12.6m7.8-24.6-7.6 9.3m-2.3-22.9s-23.3 34.1-22.9 37m20.5-41.4c-.6.3-20.1 26.2-20.1 26.2m-1.1 8.2-3.6 4.3m-4.5 6.5-5.4 7.1"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#8a9396",
      stroke: "#2b2b2b",
      d: "M420.2 213.8s-1.6 5 0 7.5 11.5 22.5 11.5 22.5 6.8-8.3 9.3-8.5c2.4-.3 1.3 21.6 1.3 21.6s-4 3.8-6.5 3.6c-2.5-.2 6 8.6 5.8 16-.2 7.5-11.2 44.5-15.3 45.1-4 .7 1.8-6.7 1.6-8.8-.3-2-1.4-.6-2.3-2.9-.9-2.2 1.4-5.6 1-7.9-.5-2.2-2.6-1.8-2.8-3.4-.2-1.6 1.4-2 1.1-3.8-.2-1.8-2.7-1.4-2.4-3 .2-1.5.4-.8.2-3.8-.2-2.9-.7 2-3.2 2.3-2.5.2-4.5 5.9-4.5 5.9s-5 7-9.9 3.8c3 6.3.7 9-.5 9.2-1 .3 1 5-1.8 5.2-2.7.2 2 10.6-1 11.5 3.3 1.6.6 3.6.6 3.6s-7.8.7-6.1 10.9c-23-8.2-34.3-22.1-34-36.4.2-14.2 4.7-27 15.7-31.7 3.2-11.8 8.6-24.4 8.6-24.4s-.9-5.2-.2-8.6a17 17 0 0 1 3.8-6.7s-.4-8.2-.2-12.2 1.8-5.9 2-8.1c.2-2.3-.7-13.8 1.6-15.8 2.2-2 6.5-1.8 8.8-3.2 2.2-1.3 5.2-3.8 8.1-3.6 3 .2 5.4 2.3 5.4 2.3s11 0 11.7 4.2c.7 4.3-2.2 6-2.2 6s1.6 6-5.2 11.6z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#cecfcf",
      stroke: "#2b2b2b",
      d: "M410.4 198.2c.3.7-.5 1.8-1.8 2.5-1.4.7-2.7.8-3 .2-.4-.7.4-1.8 1.7-2.5 1.4-.8 2.7-.8 3-.2z"
    }),
    /* @__PURE__ */ jsx162("path", {
      d: "M408.5 199.4c0 .4-.4.7-.8.7-.5 0-.9-.3-.9-.7 0-.5.4-.8.9-.8.4 0 .8.3.8.8"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "none",
      stroke: "#2b2b2b",
      strokeWidth: 0.5,
      d: "M425 206.8s2.7 12.2-.5 20.7m1.4-26s5.3 7 4.6 15.8m-4.1-17.3c.1 0 4.5 3.7 4.3 6.3m-3.3-7.9s3 2 3.6 4.1"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "none",
      stroke: "#000",
      d: "M426 197.2s-10.5 17-9.1 27.7"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "none",
      stroke: "#2b2b2b",
      strokeWidth: 0.5,
      d: "M426.7 196.6s-14 8.3-16.5 35.4"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "none",
      stroke: "#000",
      d: "m425.2 201.6-5.6 4.2"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "none",
      stroke: "#2b2b2b",
      strokeWidth: 0.5,
      d: "M405 233.5s7.8-32.2 21.5-36.9"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#2b2b2b",
      stroke: "#2b2b2b",
      d: "M431.9 244.4s7.4-9.3 9.1-9c1.7.4 1.2 21.6 1.2 21.6s-5.5 4.1-6.7 4c-1.2-.2 6.2 10 6 13.7-.1 3.8-.3 3.8-.3 3.8s0-2.2-1.7-5.8c-1.8-3.7-.7-7.8-12-17-2.7-5.6 5.6 3.5 7.3 2.1 1.7-1.3-3-13.2-3-13.4z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "none",
      stroke: "#2b2b2b",
      d: "M418.7 192s-3.1.8-3.5 2c-.5 1.4-2.3 2.6-3.3 2.2-1-.4-2.8-2-2.8-2"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#2b2b2b",
      stroke: "#2b2b2b",
      strokeLinejoin: "round",
      d: "M401 202.9s-4.7 4.6-2.4 5.2c2.3.6 4.7-3.7 4.7-3.7s0 7.3 2 6.1c2-1.1 7.7-5.2 7.7-5.2s2-.2 2.5 0c.4.1 5.3 4.4 8.6 2.8-1.9 4.8-4 5.4-4 5.4s-3.4 4.4-7.8 3.4c-4.4-1-5.5-2.8-5.5-2.8s-3.7.2-4.8-1.5l-1.6-2.6s-2 2-2.7 1c-.5-1 0-6.7 3.3-8.1z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "none",
      stroke: "#2b2b2b",
      d: "M427.5 196.4s-8.6-2.6-11.6 1.7c-3 4.2-2.3 6.6-.7 7"
    }),
    /* @__PURE__ */ jsx162("path", {
      d: "M428.8 196.1c0 1-.7 1.9-1.6 1.9-1 0-1.6-.9-1.6-1.9 0-1 .7-1.8 1.6-1.8.9 0 1.6.8 1.6 1.8"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#2b2b2b",
      stroke: "#2b2b2b",
      d: "M403.7 218.2s3.5 5.4 7.7 6.9-3 2.7-7.1 0c-3-4.2-2.2-7.2-2.2-7.2s.8-.8 1.6.3zm30.1 31.9s-9.9-13.7-12.7-14.5c-2.9-.7 2.2-1.3 5.2 1.6 3 3-.8-4.7-.8-4.7z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#2b2b2b",
      stroke: "#2b2b2b",
      strokeLinejoin: "round",
      d: "M402.7 329.6c3.8-1 20.4 9.5 24 12.1 3.8 2.7 11.6 1 11.6 1s-3.6 2.2-5.8 2.7c-2.3.5 6.6.5 6.6.5s-21.1 5.9-42.6-5.4c-2-8.8 4.6-10.8 6.2-10.9z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#2b2b2b",
      stroke: "#2b2b2b",
      d: "M427 253.5s-2.9-.5-4.3-2.1c-1.4-1.7-3.4-5.7-5.5-7.4-2.1-1.6-12.6-7.4-16.4-7-3.8.4-5-.4-5.5-.9-.4-.5-2 .2-1.7 2.2.3 2-3 6.3-1.8 8.3a62 62 0 0 0 7.7 10.6c1 .3.4 4.8.4 4.8s4.8 4.9 6 5.1c1.2.3 2.5 1.2 2.3 2.4-.1 1.1-5.3 7.4-5.3 7.4s-5.5 3-5.6 4.5c0 1.7 1.4 5 5.8 6.1a41 41 0 0 0 16.8-.8c.6-1 1.6-7 1.2-7.7-.4-.6-3.3-2.4-4.8-2.2-1.5.3-2.9 1.5-2.7 1.8.1.3-2.1 1.4-2.1.3 0-1 4.4-6 4.8-5.5.4.4 6.6 1 7.8 4.1 1.1 3.1 1.1 5.4 4.4 5 3.2-.3 7.8-3.3 8.2-9.5a13 13 0 0 0-4.7-11c-1-.7-4.4-2.7-4.7-3.7-.2-1-1-4-.4-4.8z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#2b2b2b",
      stroke: "#2b2b2b",
      d: "M368.3 281s10.5-2.7 13.2-2.6c2.7 0 13 4.8 16 7.7 3 3 9 9.8 13 9.2 4-.6 5.2-1.4 5.2-1.4l-1.6 3s-3.2.9-4.9.5c-1.6-.4-4.8-1.5-8-4.6-3.1-3-13-11.5-21.3-10.9-8.3.6-13.1 8.8-13.1 8.8s0-4 .4-4.9c.3-.8-1.8 2-1.8 2z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#2b2b2b",
      stroke: "#2b2b2b",
      d: "M407 289.2s2.6.7 7 .7c4.3 0 6.6-1.9 6.6-1.9l-.3-1.7.7-2.3s3.3 3.3 3.3 4c0 .7-1.4 1-1.4 1l-.5-1.7-1.1 1.5s-6.3 5-9.8 4.2c-3.4-.7-6.6-3-5.7-3.5.9-.5 1.3-.3 1.2-.3zm-15.3 8.8s-3.8 0-5.5.8c-1.7.8-2.3 1.8-3.5 1.7-1.1-.2-2-1.6-1.7-2.2.5-1 2.8-2.2 7-1.9 4.3.4 3.7 1.6 3.7 1.6zm13.3 10.3c0-.2-.3-5.5-2.4-7.7a6.4 6.4 0 0 0-5.8-1.9c-1.2.3 4.2 2.7 4.8 4.2.5 1.6 2.3 6 1.8 7-.5 1-1.3-3-4.7-4.2-3.3-1.2-7.9-.5-7 1 1 1.4 4.7 0 6.6 3.3a60 60 0 0 1 3.3 6.5l.7-2.3 1.6-.4.3-4.4z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#2b2b2b",
      stroke: "#2b2b2b",
      strokeLinejoin: "round",
      d: "m402.3 325.7-3.5-7s-1-4.3-4-5.5c-3-1.3-6.8-1-6.8.4-.1 1.5 6.2 3.4 6.6 4.2.4.8.2 2.2-.3 2.3-.6 0-3.4-1-4.8-.7-1.4.3-2.2 2.2-4.3 1.6-2.1-.5-3.9-7.2-3-8 .7-.6-1.6 1.3-2.1-.5-.5-1.7.7-7.2-.1-7.9-.8-.7-4.8-3-4.8-3.5-.1-.5.2-27 22.3-5-9.5-11.3-13.2-10-15-10.1-1.2 0-9.9.7-12 11.7-2.2 11-4.8 4.1-4.8 4.1s-.4 4.8 1.9 6.1c2.3 1.4-1.1 5.3-1.1 5.3s-4.2-10-3.5-14.5c-.9 3.5-.8 12.3 4.4 21.8a71.2 71.2 0 0 0 27.2 19.1c8-12.3 7.7-13.8 7.7-14z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#8a9396",
      stroke: "#2b2b2b",
      strokeLinejoin: "round",
      d: "M387.8 325.8s4.4.5 5.6 2.8c1.3 2.3 1.8 5.8 1.8 5.8.8-1.5 1-2.7 2.6-3.8 1.5-1.1 2.6-1.3 2.5-2 0-.9-4.8-5.8-7.1-6.1-2.4-.3-6.5 2.6-6.5 2.6s-.8 1 1 .7z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "none",
      stroke: "#8a9396",
      strokeLinecap: "round",
      d: "M398 337.4s11.6 5.3 30.6 5.6"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "none",
      stroke: "#2b2b2b",
      strokeLinecap: "round",
      d: "M436.7 283.6s-1 9.7-8.5 29"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "none",
      stroke: "#2b2b2b",
      d: "M435.2 289.6s-2.3 7-8.5 12.2"
    }),
    /* @__PURE__ */ jsx162("path", {
      d: "m401.3 410.3 2-2.2.6.5-.1.2-.2.3v.2l.2.2 2.6 2.3.2.2h.2l.1-.2q.4-.4.5-.8.2-.4.1-.8 0-.5-.4-1l.8-.4 1.2 2-3.2 3.6-.6-.5.2-.3.1-.2v-.2l-.2-.2-2.6-2.3-.3-.2h-.1l-.3.2-.2.2zm4.4-4.9 3.7-3.6 1.8.9-.3.7-1-.2-.6.2q-.3.1-.6.5l-.7.6 1 1.1.3-.2q.3-.2.3-.4v-.2l-.2-.3-.2-.2.6-.6 1.8 1.9-.6.5-.2-.1-.3-.3h-.2l-.4.3-.2.2 1 1 .2.2h.1l.2-.2.4-.3.6-.8q.2-.4.1-1 0-.4-.3-.9l.8-.4 1 2.3-3.8 3.7-.6-.6h.2l.2-.4v-.2l-.2-.3-2.4-2.4-.3-.2h-.2l-.2.1-.2.2zm7.7-7.4q1.2-1 2.4-.9 1.3.1 2.2 1.2.6.7.8 1.5.2.9-.1 1.6-.3.8-1.1 1.5-1 .9-2.2.9-1.4 0-2.4-1.2-1-1-.8-2.3.1-1.3 1.2-2.3m.7.7q-.5.5-.5 1.2 0 .8.7 1.6t1.5 1q.6 0 1.1-.4.6-.4.6-1 0-.9-.8-1.7-.4-.5-1-.8-.4-.2-.9-.2-.4 0-.7.3m6.1-6.2.5-.3.1.1 2.9-2v-.2l.4-.3 1.9 1.3-.5.7-.7-.3q-.4-.2-.8-.1l-.4.1-.1.1v.2l2.1 3 .2.3h.3l.5-.3.4.7-2.4 1.8-.5-.7.1-.1.3-.3v-.2l-.1-.3-2.1-3-.2-.2-.1.1q-.2.1-.3.4-.2.3-.2.7l.1.8-.8.2zm5.6-3.5 4.4-2.8 1.7 1.3-.6.7-.8-.4h-.7q-.3 0-.7.3l-.8.5.8 1.3.2-.2.4-.2v-.3l-.1-.4-.1-.2.7-.4 1.3 2.3-.7.4-.1-.3-.3-.3h-.2l-.4.2-.3.1.8 1.3.1.2h.1l.3-.1.4-.3.8-.6.3-.9v-1l.8-.2.5 2.4-4.6 2.8-.4-.7.1-.1.3-.3q.1 0 0-.2v-.3l-1.8-2.9-.3-.3h-.1l-.3.1-.2.1zm6.2-3.8 3.5-1.8.7-.3q.4-.2.9-.1.4 0 .7.2l.5.6q.4.7.1 1.3-.2.6-.8 1l1.8.8h.1l.3.1h.3l.2-.1.3-.1.3.7-1.7 1-3-1.5-.5.2.6 1.1.2.4h.5l.2-.2.4.8-2.7 1.4-.4-.8.3-.1.2-.2.1-.2-.1-.3-1.6-3.1-.2-.2q0-.1-.2 0h-.3l-.2.1-.4-.7zm2.6-.2.7 1.4.8-.4q.5-.2.7-.5l.2-.4v-.5l-.4-.3h-.4l-.7.2zm4.4-3.4 3.6-1.6.7-.2h.9q.4 0 .7.2l.5.7q.3.6 0 1.2t-.9 1l1.8.9.4.1h.5l.2-.2.4.8-1.8.8-3-1.6-.4.2.5 1.1.2.4h.4l.3-.1.3.7-2.7 1.3-.4-.8.3-.1.2-.2.1-.2-.1-.3-1.4-3.2q0-.2-.2-.3h-.5l-.2.2-.3-.8zm2.6 0 .6 1.5.9-.4.7-.4q.2-.2.2-.5v-.4l-.3-.4h-.5l-.7.2-1 .4zm6.8-3.9 1.3-.5 3.4 3.9.4.3h.5l.2.8-2.7 1-.3-.8.2-.1q.2 0 .3-.2v-.2l-.2-.2-.4-.5-1.7.6v1l.3.1.4-.1.3.8-2.3.8-.3-.8q.2 0 .3-.2l.1-.1v-.4zm1 3.2 1.1-.4-1.1-1.4zm3.8-4.9 2.7-.8 2.1 3.3v-4l2.8-.7.2.8-.3.1q-.2 0-.3.2v.4l1 3.4.1.2.2.1h.6l.2.7-2.9.9-.2-.9h.2q.3 0 .3-.2l.1-.1v-.3l-1-3.7-.1 5.4-.8.2-2.8-4.4 1 3.7.1.1.2.1h.3l.3-.1.2.8-2.4.7-.3-.8h.3l.3-.2v-.5l-1-3.3v-.3l-.2-.1h-.6zm12.4-3.3 3.2-.6h1q.5 0 .8.2.4.2.6.5l.3.7q.1.8-.4 1.4-.5.7-1.5.9l-1 .2.2 1.1v.3h.8l.1.8-3 .6v-.8h.1l.4-.2v-.5l-.6-3.3v-.4l-.2-.1h-.6zm2.4.6.4 1.7h.5l.7-.3.3-.4v-.5q0-.4-.4-.6-.3-.1-.8 0zm4.2-1.8 3.8-.5h.8l.8.2q.4.2.6.5.3.3.3.7.1.7-.3 1.2-.5.5-1.1.8l1.4 1.3.3.2.2.1h.6v.8l-1.9.3-2.3-2.4h-.5l.2 1.2v.4l.2.2h.6v.8l-3 .4v-.9h.2l.3-.1.2-.2v-.3l-.5-3.5v-.3h-.8zm2.4.7.2 1.6h1l.7-.3.4-.3v-.5l-.1-.4-.4-.2h-.8zm8.8-1.9q1.4-.1 2.4.7 1 .9 1 2.3 0 1-.3 1.7-.4.7-1 1.2-.8.4-1.8.5-1.4 0-2.3-.6-1.1-.9-1.2-2.4 0-1.4.8-2.4.9-1 2.4-1m0 1q-.7 0-1 .6-.6.6-.5 1.7 0 1 .6 1.6.4.5 1.1.5.7 0 1.1-.6.5-.6.4-1.7 0-.7-.3-1.2-.2-.5-.6-.7-.4-.3-.8-.2m4.6-1.1h3.4l1 .1.7.4.4.6.2.8q0 .8-.6 1.3t-1.7.5h-1v1.5l.4.1h.3v.9h-3v-.9h.5l.1-.1v-.4l.1-3.4v-.4l-.1-.1h-.6zm2.3 1v1.8h.6l.7-.1.3-.3q.2-.2.2-.5 0-.5-.3-.7-.3-.2-.8-.2zm4.5-1 3.8.3.8.1.8.4q.3.2.5.6l.1.8q0 .7-.6 1-.5.5-1.2.6l1.2 1.5v.1l.2.3h.2l.3.1h.3v.9l-2-.1-1.9-2.8h-.5v1.6h.6v1l-3-.3v-.8h.6l.2-.2v-.3l.2-3.5v-.3l-.3-.2h-.4zm2.2 1.2-.1 1.6h.9q.5.1.8 0 .3 0 .4-.2.2-.2.2-.5v-.4l-.4-.3-.8-.1h-1zm5.4-.6 3 .4v.9h-.3q-.3-.1-.4 0l-.2.4-.4 3.4v.4h.1l.3.2h.3l-.1.9-3-.4.1-.9h.2q.3.1.4 0h.1l.1-.3.4-3.5v-.5h-.4l-.3-.1zm6.5.9 1.4.3 1 5q0 .4.2.5l.4.2-.2.8-2.9-.5.2-.8h.5l.1-.1v-1l-2-.3-.3.6v.2q-.1.1 0 .2h.1l.4.2-.1.8-2.4-.4.1-.8h.4l.2-.1.2-.3zm-.8 3.3 1.3.2-.3-1.8zm5.9-2.4 2.7.7.2 4 2-3.4 2.7.7-.2.8h-.3q-.2-.2-.3 0-.2 0-.2.3l-.9 3.4v.4l.3.1.3.1-.2.9-2.9-.8.2-.8h.3l.3.1h.2v-.4l1-3.7-2.7 4.7-.8-.3-.3-5.1-.9 3.6v.2l.1.2h.3l.3.1-.2.9-2.5-.6.2-.9h.3l.3.1h.1l.2-.4.8-3.4v-.4l-.3-.1-.3-.1zm12.5 3.5 3 1.1 1 .5.5.6.2.7-.1.8q-.3.7-1 1-.8.3-1.8 0l-1-.4-.4 1v.5l.3.2h.3l-.3.9-2.9-1 .3-.9h.2l.4.2h.1l.2-.4 1.2-3.2v-.5l-.3-.2h-.2zm1.7 1.7-.6 1.7.5.2.7.1.5-.1.3-.5q.1-.4-.1-.7-.2-.3-.6-.4zm4.6.6 3.5 1.6.7.4q.4.2.6.6l.3.7-.2.8q-.3.7-.9.9h-1.3l.5 1.9.2.3.1.2.3.2h.2l-.3.9-1.8-.8-.8-3.3-.5-.2-.5 1.1v.6l.2.1.3.2-.4.7-2.7-1.2.3-.8.3.1.3.1h.2l.1-.3 1.4-3.2.1-.3v-.2l-.2-.1h-.2l-.2-.1zm1.7 1.9-.7 1.5.9.3q.4.3.7.3l.5-.1q.2-.1.3-.4.1-.2 0-.4l-.1-.4-.7-.4-1-.4zm8.5 2.9q1.3.7 1.7 1.9.4 1.2-.3 2.5-.4.8-1.1 1.2-.7.5-1.6.5-.8 0-1.7-.5-1.2-.6-1.7-1.7-.5-1.3.3-2.6.6-1.3 1.9-1.7 1.2-.3 2.5.4m-.4.9q-.6-.4-1.3-.1-.7.3-1.2 1.3-.5.9-.4 1.7.1.6.8 1 .6.3 1.2 0 .7-.3 1.2-1.2.4-.7.4-1.2 0-.6-.2-1zm5 1.5.5.3v.2l3 1.9.1-.1.5.3-.5 2.2-.8-.2v-.8q0-.4-.2-.7l-.3-.4h-.2l-.1.2-1.9 3-.2.4v.1l.1.1.4.3-.4.7-2.6-1.6.5-.7.1.1.4.2h.1l.3-.4 2-3v-.3h-.1q-.2-.2-.6-.2l-.6.1-.7.4-.6-.6zm5.6 3.8 4.2 3-.6 2-.8-.2v-1l-.2-.6q-.2-.3-.6-.5l-.7-.6-1 1.3.3.2.4.2h.3l.2-.4.2-.2.6.5-1.5 2.1-.6-.4.1-.2.2-.4v-.2l-.4-.4-.3-.1-.8 1.1-.1.3.2.3.4.3 1 .4q.4.1.8 0 .5-.1 1-.5l.4.7-2 1.4-4.3-3 .5-.8.1.1.4.2h.2l.2-.3 2-2.8.2-.3v-.1l-.3-.3-.2-.1zm6.9 8.8 2.3 2-.5.6-.2-.1-.2-.2h-.2l-.3.3-1.2 1.5-.7-.6.1-.5-1-.2-.7-.5q-.7-.6-1-1.3-.2-.8 0-1.6 0-.8.6-1.6.6-.7 1.4-1 .8-.3 1.6-.1.8.1 1.5.6l.5.6.4.7.3-.1.5.4-.9 2-.8-.4v-1.1l-.1-.7-.4-.5-.8-.3-.9.2q-.4.2-.9.8l-.6 1v1.1q.1.4.5.7l.5.3h.5l.4-.2.1-.2.2-.3v-.1l-.3-.3-.2-.2zm6.7 2 1 1-1.9 4.8q-.2.3-.1.5l.2.3-.6.7-2-2 .5-.7.1.2.3.1h.2l.2-.3.2-.5-1.4-1.3-.6.3-.2.1v.3l.3.3-.6.6-1.7-1.6.6-.6.2.2h.2l.4-.1zm-2.4 2.3.9.9.7-1.7zm6.5 1.4.4.4-.1.2 2.4 2.5h.2l.4.3-1 2-.8-.3.2-.8v-.7q0-.3-.2-.5h-.2l-.2.1-2.5 2.5-.3.3v.2l.3.4-.6.6-2-2.2.6-.6v.2l.4.2h.2l.3-.2 2.6-2.5.1-.2v-.1l-.5-.3h-.7l-.8.2-.3-.8 2-1z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#012169",
      d: "M0 0h320v240H0Z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#fff",
      d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0Z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#c8102e",
      d: "M212 140.5 320 220v20l-135.5-99.5Zm-92 10 3 17.5-96 72H0ZM320 0v1.5l-124.5 94 1-22L295 0ZM0 0l119.5 88h-30L0 21Z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#fff",
      d: "M120.5 0v240h80V0ZM0 80v80h320V80Z"
    }),
    /* @__PURE__ */ jsx162("path", {
      fill: "#c8102e",
      d: "M0 96.5v48h320v-48ZM136.5 0v240h48V0Z"
    })
  ]
});
var Gs_default = SvgGs;

// src/country-flag-icons/generated/Gt.tsx
init_esm_shims();
import { jsx as jsx163, jsxs as jsxs138 } from "react/jsx-runtime";
var SvgGt = (props) => /* @__PURE__ */ jsxs138("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsxs138("defs", {
      children: [
        /* @__PURE__ */ jsx163("radialGradient", {
          xlinkHref: "#gt_svg__a",
          id: "gt_svg__d",
          cx: 447.4,
          cy: 308.3,
          r: 16.5,
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsxs138("radialGradient", {
          id: "gt_svg__a",
          children: [
            /* @__PURE__ */ jsx163("stop", {
              offset: 0.2,
              stopColor: "#f9f0aa"
            }),
            /* @__PURE__ */ jsx163("stop", {
              offset: 1,
              stopColor: "#b07e09"
            })
          ]
        }),
        /* @__PURE__ */ jsx163("radialGradient", {
          xlinkHref: "#gt_svg__a",
          id: "gt_svg__e",
          cx: 451.6,
          cy: 313,
          r: 10.9,
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx163("radialGradient", {
          xlinkHref: "#gt_svg__a",
          id: "gt_svg__f",
          cx: 454.1,
          cy: 308.6,
          r: 9.8,
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx163("radialGradient", {
          xlinkHref: "#gt_svg__a",
          id: "gt_svg__g",
          cx: 458.4,
          cy: 307.1,
          r: 17.4,
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx163("radialGradient", {
          xlinkHref: "#gt_svg__a",
          id: "gt_svg__j",
          cx: 446,
          cy: 252.4,
          r: 13,
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsxs138("radialGradient", {
          id: "gt_svg__m",
          cx: 477.9,
          cy: 215.3,
          r: 0.3,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx163("stop", {
              offset: 0.3,
              stopColor: "#a50a0a"
            }),
            /* @__PURE__ */ jsx163("stop", {
              offset: 1,
              stopColor: "#4c0505"
            })
          ]
        }),
        /* @__PURE__ */ jsxs138("radialGradient", {
          id: "gt_svg__n",
          cx: 489.1,
          cy: 210.3,
          r: 0.3,
          fx: 489.1,
          fy: 210.3,
          gradientTransform: "scale(.97707 1.02346)",
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx163("stop", {
              offset: 0,
              stopColor: "#fff"
            }),
            /* @__PURE__ */ jsx163("stop", {
              offset: 1,
              stopColor: "#fff",
              stopOpacity: 0
            })
          ]
        }),
        /* @__PURE__ */ jsxs138("linearGradient", {
          id: "gt_svg__h",
          x1: 473.9,
          x2: 472.4,
          y1: 259.2,
          y2: 232,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx163("stop", {
              offset: 0.2,
              stopColor: "#b07e09",
              stopOpacity: 0
            }),
            /* @__PURE__ */ jsx163("stop", {
              offset: 1,
              stopColor: "#b07e09"
            })
          ]
        }),
        /* @__PURE__ */ jsxs138("linearGradient", {
          id: "gt_svg__i",
          x1: 483.1,
          x2: 485.5,
          y1: 296.7,
          y2: 326.6,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx163("stop", {
              offset: 0.2,
              stopColor: "#b07e09",
              stopOpacity: 0
            }),
            /* @__PURE__ */ jsx163("stop", {
              offset: 1,
              stopColor: "#b07e09"
            })
          ]
        }),
        /* @__PURE__ */ jsxs138("linearGradient", {
          id: "gt_svg__k",
          x1: 451.5,
          x2: 455.4,
          y1: 249.5,
          y2: 240.6,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx163("stop", {
              offset: 0.2,
              stopColor: "#f9f0aa"
            }),
            /* @__PURE__ */ jsx163("stop", {
              offset: 1,
              stopColor: "#b07e09"
            })
          ]
        }),
        /* @__PURE__ */ jsxs138("linearGradient", {
          id: "gt_svg__l",
          x1: 473.3,
          x2: 475.9,
          y1: 237.2,
          y2: 270.4,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx163("stop", {
              offset: 0.2,
              stopColor: "#f9f0aa"
            }),
            /* @__PURE__ */ jsx163("stop", {
              offset: 1,
              stopColor: "#b07e09"
            })
          ]
        })
      ]
    }),
    /* @__PURE__ */ jsx163("path", {
      fill: "#4997d0",
      d: "M0 0h640v480H0Z"
    }),
    /* @__PURE__ */ jsx163("path", {
      fill: "#fff",
      d: "M213.3 0h213.4v480H213.3Z"
    }),
    /* @__PURE__ */ jsxs138("g", {
      transform: "matrix(.81133 0 0 .8264 -69.4 -8)",
      children: [
        /* @__PURE__ */ jsxs138("g", {
          stroke: "#24420e",
          children: [
            /* @__PURE__ */ jsx163("path", {
              fill: "none",
              strokeWidth: 0.4,
              d: "M452.1 377.5c2.7-.4 4.2-1.2 6-1.8m2.3-4.1a13 13 0 0 1 3 4.7m-8.1-5.1a13 13 0 0 1 3 4.2m-49.5-136.6c-1 1.6-3 2.7-4.8 3.4m-.3-.2c0-1.4-.2-3 0-4.4m-1.9 5c0 .4.4 1.4.6 2m2.1 1-2 .3m-4-.9c0 2.6.3 5.6.5 7.9m-1.8-1c.5.8 1 1.5 1.6 1.9m-4.6 6.5c.5.9 1 2 1.3 4m3.7-4.7-2 1.5m1.7 4.4c-1 .9-2.2 1.5-3.5 2.1m-3.8 40.4a16 16 0 0 0 4 4.7m.6 1.7a8 8 0 0 1-3-1m4.4 8.5 1.7 1m-.4 3.4c1.2.8 2.5 2.3 3.7 3.9m-1.4 2.8c1.4.3 2.5.7 3.2 1m-1 2.5h2m1.3-5.3-.5 4.2m1 1.6.4-1.6m4.7 6-.1 3.2m39.2 27.9-1.2 1.6m-2.4-3.9-.7-1.8"
            }),
            /* @__PURE__ */ jsxs138("g", {
              strokeWidth: 0.2,
              children: [
                /* @__PURE__ */ jsx163("path", {
                  fill: "#406325",
                  d: "M486.1 385a7.8 7.8 0 0 0-3.3-2.7c-7.7-4-15.4-5.9-24-7.3-2.1-.3-4.1-2.2-6.2-3.2-5-2.3-10.5-3.2-15.3-5.7-.3-.1-1.5-.8-2-1.5-2-2.2-5.5-2.9-7.6-5-8.4-7.8-17.2-15-21.8-25.5-5.6-12.7-12.5-25.8-11.6-40.2.6-9.2-.7-18.4 1.5-27 3.4-13 7.6-25.7 15.4-36.4l-1.3.8a103.8 103.8 0 0 0-15.4 36.3c-2.3 8.7-1 18-1.5 27-1 14.5 6 27.6 11.5 40.3 4.6 10.4 13.5 17.7 21.8 25.6 2.2 2 5.6 2.7 7.6 5a10 10 0 0 0 2 1.5c4.9 2.4 10.4 3.3 15.4 5.7 2 1 4 2.8 6 3.2a76.5 76.5 0 0 1 24.2 7.2 8 8 0 0 1 3.3 2.7l1.3-.9"
                }),
                /* @__PURE__ */ jsxs138("g", {
                  fill: "#67923d",
                  children: [
                    /* @__PURE__ */ jsx163("path", {
                      d: "M406.3 331.6a46.9 46.9 0 0 1-.2-23.5c6.7 13 4.5 23.7.2 23.5zm45.9 45.4a49 49 0 0 0-21.9 11.4c15.1.1 24-7.3 21.9-11.4zm7.5-4.3a60.1 60.1 0 0 1-14-26.5c15 10.9 18.9 24.3 14 26.5z"
                    }),
                    /* @__PURE__ */ jsx163("path", {
                      d: "M454.6 372.8a55.1 55.1 0 0 1-16-22.8c15.3 8.2 20.3 20.2 16 22.8zM439 366c1-7.8-5.6-24.2-7.5-26-3 16.5 3 27.6 7.5 26zm-27.3-24.3a42 42 0 0 1 .5-21c5.5 11.7 3.3 21.2-.5 21zM398 264.9a51 51 0 0 1 21-16c-6.8 14.6-18 19.9-21 16z"
                    }),
                    /* @__PURE__ */ jsx163("path", {
                      d: "M398.7 259.3a51.8 51.8 0 0 1 17.4-20c-3.7 15.7-13.7 23.2-17.4 20zm27.9 99.2a55 55 0 0 1-7.3-26.4c11.2 12.5 12 25.3 7.2 26.4zM397.9 322c-7 1.1-21.4-4.6-23-6.3 14.6-3.2 24.4 2 23 6.3zm-2.2-9.7c.8-5.5 8.6-15.8 10.3-16.6-1 12-7.4 18.6-10.3 16.6zm51.3 58.6a57 57 0 0 0-26.1 13.6c18 .1 28.7-8.7 26.1-13.6z"
                    })
                  ]
                }),
                /* @__PURE__ */ jsxs138("g", {
                  fill: "#406325",
                  children: [
                    /* @__PURE__ */ jsx163("path", {
                      d: "M406.4 331.5c4.2.2 6.4-10.4-.3-23.4a78.9 78.9 0 0 1 .3 23.4zm11.2 20a48.8 48.8 0 0 0-21.7-11.2c8.9 12.1 19.9 15.1 21.7 11.2zm-24.4-53a56.8 56.8 0 0 0-14.8-24c1.5 17.2 10.6 26.7 14.8 24zm8.4 34.3c-5-3.7-19-5.4-21-4.8 10.2 8.4 20.2 8.5 21 4.8zm-9.4-24.8a42 42 0 0 0-16.9-13.8c5.5 12.4 14.6 17 16.9 13.7zm2.8-47.6c.8-7.6-5.6-23.4-7.4-25.2-2.9 16 2.9 26.7 7.3 25.2zm4.4-14.9c2.7-6.5.8-22.4-.5-24.4-6.4 13.5-3.8 24.6.5 24.4z"
                    }),
                    /* @__PURE__ */ jsx163("path", {
                      d: "M404.4 237.8a40.3 40.3 0 0 0 3.5-19.4c-7.2 9.7-7 18.9-3.5 19.4zm6-6.1a38.8 38.8 0 0 0 9-17.4c-9.7 7-12.2 15.8-9 17.4zm-16.1 43.2c.1.9-1-8.2-10-18.3.4 14.8 6.2 20.4 10 18.3zm32.6 85.8a53 53 0 0 0-25.8-6c12.6 10.4 24.9 10.6 25.8 6zM439 366c-4.6 1.5-10.5-9.5-7.6-26a99 99 0 0 0 7.5 26zm13.3 11c2 4.1-6.8 11.5-21.8 11.4 12-5 21.2-9.9 21.8-11.3zm7.3-4.4c4.9-2.3 1.1-15.5-14-26.4 8.6 13.2 14.5 24.6 14 26.4z"
                    }),
                    /* @__PURE__ */ jsx163("path", {
                      d: "M454.6 372.7c4.2-2.7-.7-14.5-16-22.7 9.5 11.2 16.2 21 16 22.7zm-42.8-31c3.7.2 6-9.3.5-21 .7 11 .4 20-.5 21zM398 265c3 3.8 14-1.4 20.9-16a90.6 90.6 0 0 1-20.9 16z"
                    }),
                    /* @__PURE__ */ jsx163("path", {
                      d: "M398.9 259.3c3.6 3.2 13.5-4.3 17.2-20-8 11.3-15.6 19.8-17.2 20zm27.7 99.1c4.7-1.1 4-13.8-7.3-26.3 5 13.5 8 24.8 7.3 26.3zM397.7 322c1.4-4.3-8.3-9.4-22.8-6.3 12.3 2.2 22 5 22.8 6.3zm-1.9-9.6c2.9 1.8 9.1-4.7 10.3-16.7a68.6 68.6 0 0 1-10.3 16.7zM447 371c2.5 5-8 13.7-26 13.6 14.2-5.9 25.3-11.8 26-13.6z"
                    }),
                    /* @__PURE__ */ jsx163("path", {
                      d: "M399.4 326.3a45 45 0 0 0-17-15.8c5 13.6 14.2 19.1 17 15.8z"
                    })
                  ]
                }),
                /* @__PURE__ */ jsxs138("g", {
                  fill: "#67923d",
                  children: [
                    /* @__PURE__ */ jsx163("path", {
                      d: "M392.4 274c4-4.7 17.5-9.2 19.6-9-8 10.5-18 12.6-19.6 9zm25.1 77.5c-1.8 4-12.7 1-21.7-11.1a84.4 84.4 0 0 0 21.7 11.1zm-24.4-53c-4.2 2.7-13.1-6.8-14.7-24 6.6 13.3 13 23.5 14.7 24zm8.4 34.3c-.7 3.7-10.7 3.6-20.8-4.7a74 74 0 0 0 20.8 4.7zm-9.5-24.9c-2.3 3.2-11.2-1.3-16.7-13.7 8.2 8 15.5 13.7 16.8 13.7zm2.8-47.6c-4.4 1.6-10.1-9-7.3-25 2.7 13.5 6 24.2 7.3 25zm4.5-14.9c-4.3.3-6.9-10.8-.5-24.3-.8 12.8-.5 23.3.5 24.3zm5-7.6c-3.4-.6-3.7-9.7 3.6-19.4a66.2 66.2 0 0 0-3.6 19.4zm6-6.1c-3.1-1.7-.7-10.4 9-17.3a66.2 66.2 0 0 0-9 17.3z"
                    }),
                    /* @__PURE__ */ jsx163("path", {
                      d: "M394.3 274.9c-3.9 2.1-9.6-3.5-10-18.3 5 11.7 8.6 17.8 10 18.3zm32.5 85.8c-.9 4.6-13.1 4.4-25.7-5.9 13.2 4.3 24.3 6.7 25.7 5.9zm-8.2-9.5A41 41 0 0 1 412 332c9 8.7 10.2 18.1 6.8 19.2zm-16.8-25c-3.6-5.8-4-20.9-3-23 8.3 11.9 7.3 22.7 3 23zm-2.7.1c-2.7 3.3-11.9-2.1-16.8-15.8a77.3 77.3 0 0 0 16.8 15.8z"
                    })
                  ]
                }),
                /* @__PURE__ */ jsxs138("g", {
                  fill: "#406325",
                  children: [
                    /* @__PURE__ */ jsx163("path", {
                      d: "M392.4 274c1.6 3.6 11.4 1.5 19.5-8.9-12 6.8-16.7 9.8-19.5 8.9zm9.3 52c4.3-.3 5.3-11-3-22.8a72.7 72.7 0 0 1 3 22.9zm17 25.2c3.4-1 2.2-10.5-6.7-19.2 4.4 9.7 7.2 18 6.7 19.2z"
                    }),
                    /* @__PURE__ */ jsx163("path", {
                      d: "M394.2 291.8c2-8.4-1.7-22.6-4.3-25.6-4.7 15.4-.2 26.6 4.3 25.6z"
                    })
                  ]
                }),
                /* @__PURE__ */ jsx163("path", {
                  fill: "#67923d",
                  d: "M394 293.8c-6 1.3-8.7-12-4.1-27.1 1 13.5 2.8 26.1 4 27z"
                }),
                /* @__PURE__ */ jsx163("path", {
                  fill: "#67923d",
                  d: "M392.7 293.7a53 53 0 0 1 9-24.7c2 15.8-4.5 26.3-9 24.7z"
                }),
                /* @__PURE__ */ jsx163("path", {
                  fill: "#406325",
                  d: "M392.8 293.6c4.5 1.6 10.9-8.8 8.9-24.6-3.5 13.3-7.5 23.8-8.9 24.6z"
                }),
                /* @__PURE__ */ jsx163("path", {
                  fill: "#67923d",
                  d: "M394.1 303.3a50 50 0 0 1 10.6-23.7c.8 16.2-6.3 25.9-10.6 23.7z"
                }),
                /* @__PURE__ */ jsx163("path", {
                  fill: "#406325",
                  d: "M394.2 303.4c4.2 2.2 11.3-7.4 10.5-23.5-4.4 12.8-9 22.9-10.5 23.5z"
                })
              ]
            }),
            /* @__PURE__ */ jsxs138("g", {
              fill: "#ba1f3e",
              stroke: "#511124",
              strokeWidth: 0.2,
              children: [
                /* @__PURE__ */ jsx163("circle", {
                  cx: 396.8,
                  cy: 251.3,
                  r: 1.1
                }),
                /* @__PURE__ */ jsx163("circle", {
                  cx: 405.2,
                  cy: 245.1,
                  r: 1.1
                }),
                /* @__PURE__ */ jsx163("circle", {
                  cx: 401.6,
                  cy: 241.7,
                  r: 1.1
                }),
                /* @__PURE__ */ jsx163("circle", {
                  cx: 392.5,
                  cy: 313.1,
                  r: 1.3
                }),
                /* @__PURE__ */ jsx163("circle", {
                  cx: 395,
                  cy: 297.1,
                  r: 1.3
                }),
                /* @__PURE__ */ jsx163("circle", {
                  cx: 408.2,
                  cy: 334.5,
                  r: 1.3
                }),
                /* @__PURE__ */ jsx163("circle", {
                  cx: 402.4,
                  cy: 336.4,
                  r: 1.3
                }),
                /* @__PURE__ */ jsx163("circle", {
                  cx: 446.7,
                  cy: 367.6,
                  r: 1.3
                }),
                /* @__PURE__ */ jsx163("circle", {
                  cx: 449.6,
                  cy: 374.7,
                  r: 1.3
                })
              ]
            })
          ]
        }),
        /* @__PURE__ */ jsxs138("g", {
          stroke: "#24420e",
          children: [
            /* @__PURE__ */ jsx163("path", {
              fill: "none",
              strokeWidth: 0.4,
              d: "M561.1 259c.7.6 1.2.8 2.3 1.9m-6.6-18.9c0-1.4-.6-3.7-.9-5m3.5 3c0 1.9-.3 3.7-1.1 5.4m-4.2-.5c1.8 1.6 3.5 3 5.3 3.9m3.8 1.2c.1 2-.1 4-.7 6m.4 1.5 1.3-2.3m-1.9 12.2c1.4.3 2.8 2 3.5 3.5m.5-1.3 1.6-2.2m1.7 30.8a24 24 0 0 1-2.4 3.4m-4 0c.8 1.4 1.6 3 2.6 4m2.5 5.9a13.2 13.2 0 0 1-4.5 4m.2 4.5c-1.1.8-2.5 3-3.7 4.7m8.4-20.2-2.1.9m-1.4-7.4 1.2 1m-9.3 37.4h-2m-2.1-1.8.6 1.6m-7.6 5.1c-.3 1.9-.1 3.7.1 5.6m4.3-9 1 2.2m3.9-.1-2.5.3M522 365.6l-1 1.8m11.9-4c-1.5.2-2.8 0-4.1-.2m-5.5 6c-1-.5-2-.7-3-1m-14.7 2.7c-.9.7-2 2.4-3 4m-.6-4.5c-2.4 1.3-3.2 3.7-4.4 5.8m2.8 2.8c-1.6-.4-3.4-1.2-5.3-2m16.7-.7c-2.3-1.2-4.7-1-7.1-1.4m10.8-.4c-3.7-.7-7-.6-10.3-.1m7.8-2.6-1.4-.6m-5.6 5.5-2.3-1.3m57.9-49.2c-1.2.8-2.5 2.3-3.7 3.9m1.8-79.6-2.2-.8"
            }),
            /* @__PURE__ */ jsxs138("g", {
              strokeWidth: 0.2,
              children: [
                /* @__PURE__ */ jsx163("path", {
                  fill: "#406325",
                  d: "M474.4 384.9c.8-1.3 2.1-2 3.3-2.7 7.7-4 15.4-5.8 24-7.2 2.1-.4 4.1-2.3 6.2-3.2 5-2.4 10.5-3.3 15.3-5.7.3-.2 1.5-.9 2-1.6 2-2.2 5.5-2.9 7.6-5 8.4-7.8 17.2-15 21.8-25.5 5.6-12.7 12.5-25.8 11.6-40.2-.6-9.2.7-18.4-1.5-27a104.6 104.6 0 0 0-15.4-36.4l1.3.8a103.8 103.8 0 0 1 15.4 36.4c2.3 8.6 1 17.9 1.5 27 1 14.4-6 27.5-11.5 40.3-4.6 10.4-13.5 17.6-21.8 25.5-2.2 2-5.6 2.7-7.6 5a10 10 0 0 1-2 1.5c-4.9 2.4-10.4 3.4-15.4 5.7-2 1-4 2.8-6 3.2A76.5 76.5 0 0 0 479 383a8 8 0 0 0-3.3 2.7l-1.3-.8"
                }),
                /* @__PURE__ */ jsxs138("g", {
                  fill: "#406325",
                  children: [
                    /* @__PURE__ */ jsx163("path", {
                      d: "M553.6 334.6c2.8-7.4 0-24.8-1.4-27-6.7 15.4-3.4 27.6 1.4 27z"
                    }),
                    /* @__PURE__ */ jsx163("path", {
                      d: "M546.5 341.6c2.3-5.6.7-19.3-.4-21-5.5 11.7-3.3 21.3.4 21zm16.9-74.1a46.9 46.9 0 0 0-19.3-14.6c6.2 13.3 16.5 18.2 19.3 14.6z"
                    }),
                    /* @__PURE__ */ jsx163("path", {
                      d: "M561.8 259.5a43.3 43.3 0 0 0-14.5-16.7c3.1 13 11.4 19.3 14.5 16.7zm4.7 14.9c-3.5-4-15.2-7.9-17-7.7 7 9 15.6 10.9 17 7.7zm-2.8 46.4a40 40 0 0 0 20.3-5.7c-12.9-2.8-21.5 1.9-20.3 5.7zm-.2-5.7c0-5.6-6.3-16.8-8-18-.5 12 4.9 19.5 8 18z"
                    }),
                    /* @__PURE__ */ jsx163("path", {
                      d: "M564 301.4a50 50 0 0 0-10.6-23.6c-.8 16.2 6.3 25.8 10.6 23.6zm-53 75.3a47.7 47.7 0 0 0 22.2 11c-8.8-12.3-20.1-15.1-22.1-11z"
                    })
                  ]
                }),
                /* @__PURE__ */ jsxs138("g", {
                  fill: "#67923d",
                  children: [
                    /* @__PURE__ */ jsx163("path", {
                      d: "M553.6 334.4c-4.9.6-8.1-11.4-1.4-26.8-.5 14.2.2 25.7 1.4 26.8zM500.2 378a50 50 0 0 1 21.9 11.5c-15.1.1-24-7.3-22-11.4zm0-7.9c2-8 15-21.2 17.5-22.1-3.6 17.1-13.7 25.5-17.5 22.1zm21.3-4.1a54 54 0 0 1 7.5-26c3 16.4-3 27.5-7.5 26zm21.5-14.6a48.8 48.8 0 0 1 21.6-11.2c-8.9 12.1-19.8 15.1-21.7 11.2zm25.7-53.3c1-6.3 9.7-17.9 11.6-18.9-1.2 13.6-8.3 21-11.6 19z"
                    }),
                    /* @__PURE__ */ jsx163("path", {
                      d: "M557 336.2a50.5 50.5 0 0 1 24.4-5.5c-11.8 9.7-23.5 9.8-24.4 5.5zm10.3-24.5a44 44 0 0 1 17.7-14.4c-5.8 13-15.3 17.8-17.7 14.4zm-1.5-45.6c0-7.6 8-22.7 10-24.2 1.1 16.1-5.7 26.2-10 24.2zm-6.9-25.9a40.4 40.4 0 0 1-.1-20c5.5 10.9 3.7 20 0 20z"
                    }),
                    /* @__PURE__ */ jsx163("path", {
                      d: "M554.6 238a49.7 49.7 0 0 1-10.4-22.1c11.8 9.3 14.4 20.4 10.4 22.1zm11.7 34.5c-.3.9 3-7.7 14.2-15.3-4 14.3-11 18.3-14.2 15.3zm-34.1 89.9a61 61 0 0 1 29.2-6.7c-14.2 11.8-28.2 12-29.2 6.7zm14.3-20.8c-3.7.2-6-9.3-.5-21-.7 11-.4 20 .5 21zm16.9-74.1c-2.7 3.6-13-1.2-19.2-14.6a78.8 78.8 0 0 0 19.2 14.6zm-1.7-8c-3.1 2.6-11.3-3.6-14.4-16.7 6.7 9.4 13 16.5 14.4 16.7zm4.8 15c-1.4 3.1-9.9 1.3-16.9-7.7 10.4 5.9 14.5 8.4 17 7.7zm-2.6 46.2c-1.3-3.8 7.3-8.3 20.2-5.5a69 69 0 0 0-20.2 5.5zm-.4-5.6c-3.2 1.5-8.5-5.9-8-17.9a68.7 68.7 0 0 0 8 18z"
                    }),
                    /* @__PURE__ */ jsx163("path", {
                      d: "M563.9 301.6c-4.3 2.2-11.3-7.4-10.5-23.5 4.4 12.8 9 22.9 10.5 23.5zm-52.7 75.1c2-4.2 13.1-1.4 22 10.8-11-6.7-20.5-11.3-22-10.8z"
                    })
                  ]
                }),
                /* @__PURE__ */ jsxs138("g", {
                  fill: "#406325",
                  children: [
                    /* @__PURE__ */ jsx163("path", {
                      d: "M521.5 365.8c4.6 1.6 10.5-9.4 7.6-25.9-2.8 14-6.2 25.1-7.6 26z"
                    }),
                    /* @__PURE__ */ jsx163("path", {
                      d: "M531.8 360.6a55 55 0 0 0 4.6-27c-10 13.6-9.4 26.3-4.6 27zm-31.7 17.5c-2 4.1 6.7 11.5 21.8 11.3-12-4.8-21.2-9.8-21.8-11.3zm.2-8.1c3.8 3.4 13.8-4.9 17.4-22-8.1 12.4-15.7 21.8-17.4 22zm42.7-18.6c1.8 4 12.7 1 21.7-11.1a84.4 84.4 0 0 1-21.7 11.1zm25.8-53.3c3.3 2.1 10.3-5.3 11.5-18.8a74.8 74.8 0 0 1-11.5 18.8zM557 336.2c1 4.4 12.5 4.2 24.4-5.5-12.5 4-23 6.2-24.3 5.5zm10.4-24.6c2.5 3.4 11.9-1.4 17.7-14.4a75 75 0 0 1-17.7 14.4zM566 266c4.2 2 11-8 9.8-24-4 13-8.4 23.3-9.9 24zm-7-25.9c3.5.1 5.4-9-.2-20 1 10.5 1 19.1.2 20zm-4.3-2.2c4-1.7 1.4-12.7-10.4-22a81.7 81.7 0 0 1 10.4 22zm11.6 34.7c3.2 3 10.2-1 14.2-15.4-7.8 10.1-12.7 15.2-14.2 15.4zm-34 89.9c1 5.2 14.9 5 29-6.7-14.9 4.8-27.4 7.6-29 6.7z"
                    }),
                    /* @__PURE__ */ jsx163("path", {
                      d: "M539.1 354.8a41 41 0 0 0 3.6-20.1c-7.5 10-7.2 19.5-3.6 20zm19.6-28.7c3.6-5.7 4-20.9 3-23-8.3 11.9-7.3 22.7-3 23z"
                    })
                  ]
                }),
                /* @__PURE__ */ jsx163("path", {
                  fill: "#67923d",
                  d: "M531.8 360.5c-4.8-.6-5.3-13.3 4.5-26.8-3.6 13.8-5.4 25.4-4.5 26.8zm35.2-68.3c-1-7.8 4-20.1 6.6-22.5 2.6 14.4-2.7 24-6.6 22.5zm-27.9 62.5c-3.6-.5-3.9-10 3.6-20a67.4 67.4 0 0 0-3.6 20zm23.4-104.2c-2.2-6 0-20 1.2-21.8 5.3 12.2 2.6 22.1-1.2 21.8zm-58.1 120.1c2.5-8 16.2-21 18.8-22-4.3 17.5-15 25.6-18.8 22zM559 329a45 45 0 0 1 16.9-15.8c-5 13.6-14.2 19.1-17 15.8zm-.2-3c-4.3-.4-5.3-11 3-22.9a72.7 72.7 0 0 0-3 22.9z"
                }),
                /* @__PURE__ */ jsx163("path", {
                  fill: "#406325",
                  d: "M567 294c5.2 1.9 9-9.8 6.6-23.9a98 98 0 0 1-6.6 24z"
                }),
                /* @__PURE__ */ jsx163("path", {
                  fill: "#406325",
                  d: "M567.8 293.6c.5-7.5-7-23-9-24.7-2 15.8 4.5 26.3 9 24.7zm-5.3-43.2c3.9.4 6.5-9.4 1.2-21.7.4 11.5-.2 20.8-1.2 21.7zm-58 120.1c3.8 3.7 14.4-4.4 18.7-21.8-8.8 12.3-17 21.6-18.7 21.8zm54.6-41.5c2.8 3.3 12-2.1 17-15.8a77.3 77.3 0 0 1-17 15.8z"
                }),
                /* @__PURE__ */ jsx163("path", {
                  fill: "#67923d",
                  d: "M567.7 293.5c-4.5 1.7-10.9-8.7-8.9-24.5 3.5 13.2 7.5 23.7 8.9 24.5z"
                })
              ]
            }),
            /* @__PURE__ */ jsxs138("g", {
              fill: "#ba1f3e",
              stroke: "#511124",
              strokeWidth: 0.2,
              children: [
                /* @__PURE__ */ jsx163("circle", {
                  cx: 564.6,
                  cy: 254.9,
                  r: 1.1
                }),
                /* @__PURE__ */ jsx163("circle", {
                  cx: 568.4,
                  cy: 266.8,
                  r: 1.1
                }),
                /* @__PURE__ */ jsx163("circle", {
                  cx: 569.8,
                  cy: 304.3,
                  r: 1.3
                }),
                /* @__PURE__ */ jsx163("circle", {
                  cx: 564.6,
                  cy: 297.3,
                  r: 1.3
                }),
                /* @__PURE__ */ jsx163("circle", {
                  cx: 549.9,
                  cy: 337.2,
                  r: 1.3
                }),
                /* @__PURE__ */ jsx163("circle", {
                  cx: 556.2,
                  cy: 339.9,
                  r: 1.3
                }),
                /* @__PURE__ */ jsx163("circle", {
                  cx: 513.8,
                  cy: 372.3,
                  r: 1.3
                }),
                /* @__PURE__ */ jsx163("circle", {
                  cx: 506.8,
                  cy: 377.3,
                  r: 1.3
                }),
                /* @__PURE__ */ jsx163("circle", {
                  cx: 557.1,
                  cy: 249.3,
                  r: 1.1
                })
              ]
            })
          ]
        }),
        /* @__PURE__ */ jsxs138("g", {
          id: "gt_svg__b",
          fill: "#8c959d",
          stroke: "#485654",
          strokeWidth: 0.1,
          children: [
            /* @__PURE__ */ jsx163("path", {
              d: "M434.3 336.3c-.2 1 .8 2.3 2 2 .5 0 .7-.5.2-.5-.4.2-.9 0-1.2-.3a2 2 0 0 1-.4-2z"
            }),
            /* @__PURE__ */ jsx163("path", {
              stroke: "none",
              d: "M437.2 338.3c-1 1.2-2.5 1.7-3.4.9-.6-.6-.8-1.2-.5-2l-1 1.3s.6 1.3 1.6 1.8c1.3.5 3-.3 4-1.6.8-1 1.6-2.4 1-3.6a4 4 0 0 0-2-1.7l-1 1c.5-.2 1.2 0 1.7.4 1.3 1 .6 2.5-.4 3.5"
            }),
            /* @__PURE__ */ jsx163("path", {
              fill: "#485654",
              stroke: "none",
              d: "M437.2 338.3a4 4 0 0 1-1.1 1c-.5.2-1 .4-1.5.3a1 1 0 0 1-.7-.3 1 1 0 0 1-.5-.6c-.2-.2-.2-.4-.3-.7 0-.3 0-.5.2-.8l.1.1-1.1 1.3v-.1l1 1.3.7.4.8.1a3 3 0 0 0 1.6-.5c.5-.2 1-.6 1.3-1l1-1.4c.2-.5.4-1 .3-1.6 0-.3 0-.5-.2-.8a4.2 4.2 0 0 0-1.9-1.6h.1l-1 1.1h-.1c.2-.2.5-.2.7-.2l.8.2c.4.3.8.7.9 1.2.1.5 0 1-.2 1.4-.2.5-.5.9-.9 1.2m0 0c.4-.3.6-.7.8-1.2.2-.4.3-1 .2-1.4-.1-.5-.5-.8-.9-1-.4-.3-1-.4-1.3-.2h-.1l1-1.2a4.2 4.2 0 0 1 2 1.7c.2.2.3.5.3.8 0 .6-.1 1.2-.4 1.7-.2.5-.5 1-1 1.4-.3.5-.8.8-1.3 1.1-.5.3-1 .5-1.7.5a2.2 2.2 0 0 1-1.6-.6 5 5 0 0 1-1-1.4l1-1.3h.2l-.1.8c0 .2 0 .5.2.7l.5.5c.1.2.4.3.6.3.5.1 1 0 1.5-.2z"
            }),
            /* @__PURE__ */ jsx163("path", {
              fill: "#6c301e",
              stroke: "#351710",
              strokeLinejoin: "round",
              strokeWidth: 0.2,
              d: "m515.2 249.3-40.1 39.5L434 328l-4.6 5.4c-2 2.3-4.4 5.3-7.2 8-.5.7-1.1.4-1.7.8-1.8 1-3.7 2.8-5 4.3L403.2 360c-.7.9-1 1.4-.4 2l6.6 8.8c1.2 1.2 2.6 1.8 3.2.8 3.1-5.5 11-13.8 14-20.3 1.7-4 3.9-11.1 5.5-12.8 2-2.2 7.1-7.8 11.8-12.7l1-1c.2-.4.5-.7.9-1 23.5-24 50.7-53.1 70.5-73.6z"
            }),
            /* @__PURE__ */ jsx163("path", {
              d: "M431.9 328.1c-1.2 0-2-.7-2.9-1.4 1.2.4 2.4.8 3.5.3z"
            }),
            /* @__PURE__ */ jsx163("path", {
              fill: "#b2b6ba",
              strokeWidth: 0.2,
              d: "m557 220.1-31.8 26.2c-.3.4-.6.3-.9 0l-2.9-2.4v-.6l1.4-1.4c.2-.2 0-.3-.1-.6l-.6-.6c-.3-.1-.5 0-.7.2l-1.4 1.5c-.7 0-1.3.6-1.4 1.4-19.2 18.7-35.8 35.4-54.9 53.8l-22.6 21.6c-.8 1-4.3 2.9-6.6 4.4-.8.5-1.5 1-1.8 1.5l-1.8 5.5c-.6 1.2-2.5 4-2.5 4.2l3.8 3.7 11.1-11.9.9-1a13.3 13.3 0 0 0-2.6-2.7l-.7-.5c-.1-.2.3-.5.5-.7 26.4-25.6 55-53.7 78.2-76.6a1.4 1.4 0 0 0 1 0l2.9 3.1c.6.7 1.2.7 1.7.4l31.9-28.5z"
            }),
            /* @__PURE__ */ jsx163("path", {
              fill: "#485654",
              stroke: "none",
              d: "M431 330.4h.6l.5-.1.7-2.4.8-2.4c-.2-.2-.4-.4-.7-.4.3 0 .5.2.7.4l-.7 2.4-.7 2.4-.6.2z"
            }),
            /* @__PURE__ */ jsx163("circle", {
              cx: 438.2,
              cy: 328.1,
              r: 0.6,
              fill: "none",
              strokeWidth: 0.2
            }),
            /* @__PURE__ */ jsx163("circle", {
              cx: 434.4,
              cy: 331.9,
              r: 0.6,
              fill: "none",
              strokeWidth: 0.2
            }),
            /* @__PURE__ */ jsx163("path", {
              fill: "#485654",
              stroke: "none",
              d: "M441 322.4a11.7 11.7 0 0 1-1.8-1.6 11.6 11.6 0 0 1 1.8 1.6"
            }),
            /* @__PURE__ */ jsx163("path", {
              d: "m502.2 259 3.5 3.5.6-.6-3.5-3.4-.6.6z"
            })
          ]
        }),
        /* @__PURE__ */ jsx163("use", {
          xlinkHref: "#gt_svg__b",
          width: "100%",
          height: "100%",
          transform: "scale(-1 1) rotate(-2.8 -9.3 19640.2)"
        }),
        /* @__PURE__ */ jsxs138("g", {
          stroke: "#24420e",
          strokeWidth: 0.2,
          children: [
            /* @__PURE__ */ jsx163("path", {
              fill: "#67923d",
              d: "M434 365.4a55.8 55.8 0 0 0-29.3.9c16.3 8 29.5 4.6 29.2-1zm89 3.3c7.8-3.3 26.8-.7 29.1 1-16.2 7.9-29.5 4.5-29.2-1z"
            }),
            /* @__PURE__ */ jsx163("path", {
              fill: "#406325",
              d: "M433.8 365.5c.3 5.5-12.8 8.9-29.1.9 15.3 1 27.8.4 29-1zm89.2 3.3c-.2 5.5 12.9 8.9 29.2.9-15.3 1-27.8.4-29.1-1z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs138("g", {
          id: "gt_svg__c",
          children: [
            /* @__PURE__ */ jsx163("path", {
              fill: "#b2b6ba",
              stroke: "#485654",
              strokeWidth: 0.2,
              d: "M508.5 360a237.5 237.5 0 0 0-76.1-68c3.5-.2 11.4 3.9 14.7 6 23.9 15.4 44.3 35.8 65.6 59.8-1.2 1.2-2 2-3.4 3z"
            }),
            /* @__PURE__ */ jsx163("path", {
              fill: "#8c959d",
              d: "M510.6 359.8 509 361c-23-29.6-55-57.9-76.7-69 30.1 13.8 55.4 41.7 78 67.6h.1z"
            }),
            /* @__PURE__ */ jsx163("path", {
              fill: "#485654",
              d: "M510.6 359.8 509 361a303 303 0 0 0-35.2-38 285 285 0 0 0-30.4-24.3c-3.6-2.4-7.3-4.7-11.1-6.7v-.2c8 3.7 15.4 8.2 22.5 13.3 7 5 13.6 10.7 20 16.6a360 360 0 0 1 18.3 18.5c6 6.4 11.6 13 17.4 19.5zm0 0c-5.8-6.6-11.5-13-17.5-19.4a355 355 0 0 0-18.3-18.5c-6.4-5.9-13-11.5-20-16.6-7-5-14.5-9.6-22.4-13.2v-.2a196.2 196.2 0 0 1 21.7 14.3 284.9 284.9 0 0 1 38.2 35.1 314 314 0 0 1 16.8 19.8z"
            }),
            /* @__PURE__ */ jsxs138("g", {
              fill: "#fab81c",
              stroke: "#6c301e",
              strokeWidth: 0.1,
              children: [
                /* @__PURE__ */ jsx163("path", {
                  strokeWidth: 0.2,
                  d: "M517.5 355c-2 .6-3.7 1.3-5.3 2.3-.2 1.4-2 3-3.5 3.3l-.6-.8h-.2l-.6.3c-.6 0-1.3.2-1.6 1-.4 1 .3 2.3 1.2 3.1 1 .7 1.4 1 2.4 1 1.1-.3 1.7-1.3 2-1.6 3.7 4.5 6.5 7 11.2 10.6 2.1 0 3.2-1.3 2.5-2.8-.2-.5-.8-.8-1.3-.6v-.5c2.4-2.2 3.5-5 .9-9.8-2.2-4-4.7-5.4-7-5.4h-.1zm6.2 4.6c.5.7.7 1.4 1 2 1.6 3 .3 6.7-2.3 7.8h-.2c.4-.7-.8-2.2-1.4-1.7.3-.7-.7-2-1.5-1.7.4-.7-.5-1.9-1.4-1.5.4-.7-.3-1.8-1.3-1.6.3-.8-.4-1.8-1.3-1.6 0-.8-.2-1.2-.5-1.5 1-.8 2.3-2.1 3.4-2.7 2.7-1.2 4.4 1 5.5 2.5z"
                }),
                /* @__PURE__ */ jsx163("path", {
                  d: "M524.9 362.8c-.5-.3-.8-.8-.6-1.1.2-.4.7-.5 1.2-.2.5.2.8.7.7 1-.2.4-.8.5-1.3.3z"
                }),
                /* @__PURE__ */ jsx163("path", {
                  d: "M524.6 361.8c-.5-.3-.8-.8-.6-1.2.2-.3.7-.4 1.2-.1.5.2.8.7.7 1-.2.4-.8.5-1.3.3z"
                }),
                /* @__PURE__ */ jsx163("path", {
                  d: "M524 360.6c-.5-.2-.8-.7-.6-1 .2-.4.7-.5 1.2-.3.5.3.8.8.6 1.1-.1.4-.7.5-1.2.2z"
                }),
                /* @__PURE__ */ jsx163("path", {
                  d: "M523.2 359.6c-.5-.3-.8-.8-.6-1.1.2-.3.7-.4 1.2-.2.5.3.8.8.7 1.1-.2.3-.8.5-1.3.2z"
                }),
                /* @__PURE__ */ jsx163("path", {
                  d: "M522.2 358.6c-.6-.2-.8-.8-.6-1v-.2c.2.1.7.2.6-.1 0-.2-.1-.3 0-.2l.6.2c.5.3.8.8.6 1.1-.1.4-.7.5-1.2.2z"
                })
              ]
            }),
            /* @__PURE__ */ jsx163("path", {
              fill: "#fab81c",
              d: "M511.3 363.6c.7-1.8 2-3.4 3.5-3.8m-3.3 4.1c1.3.2 3.3-1.3 3.8-2.6m-2.6 4c1.6.4 3.3-1.2 4-2.4m-2.5 4c2 0 3.1-1.3 3.7-2.4m-2.2 3.9c1.7 0 3.2-1.3 3.6-2.4m-2.2 3.8c1.9 0 3.1-.9 3.7-2m-2 3.4c1.7.1 3-.9 3.4-1.8m-1.6 3.3c1.6 0 2.7-1 3.1-2"
            }),
            /* @__PURE__ */ jsx163("path", {
              fill: "#6c301e",
              d: "M511.3 363.6a7 7 0 0 1 2.3-3.2c.3-.3.7-.5 1.2-.6a4 4 0 0 0-1.2.6 6 6 0 0 0-1 1 8 8 0 0 0-1.3 2.2m.2.3c.4 0 .8 0 1.2-.2l1-.6 1-.8.6-1a2 2 0 0 1-.6 1 5.3 5.3 0 0 1-2 1.4c-.4.2-.8.3-1.2.2m1.2 1.4h1.2l1-.6a5.6 5.6 0 0 0 1.7-1.8l-.7 1-.9.9-1 .5zm1.5 1.6c.4 0 .8 0 1.1-.2l1-.5 1-.8.6-1a4 4 0 0 1-1.5 1.9l-1 .5zm1.5 1.5c.8 0 1.5-.3 2.1-.8a5.2 5.2 0 0 0 1.5-1.6c-.1.3-.3.7-.6 1l-.8.7-1 .6a3 3 0 0 1-1.2.1m1.4 1.4c.4 0 .8 0 1.1-.2a4.6 4.6 0 0 0 2-1l.6-.9-.6 1c-.3.2-.6.5-1 .6-.6.4-1.3.5-2 .5zm1.7 1.4a4.5 4.5 0 0 0 2-.5l.8-.5c.2-.3.5-.5.6-.8 0 .3-.3.6-.5.8a3.6 3.6 0 0 1-3 1zm1.8 1.5 1-.1.8-.4.7-.6.6-.8a3 3 0 0 1-3.1 1.9"
            })
          ]
        }),
        /* @__PURE__ */ jsx163("use", {
          xlinkHref: "#gt_svg__c",
          width: "100%",
          height: "100%",
          transform: "scale(-1 1) rotate(-3.4 -13.8 16470.8)"
        }),
        /* @__PURE__ */ jsxs138("g", {
          stroke: "#24420e",
          strokeWidth: 0.2,
          children: [
            /* @__PURE__ */ jsx163("path", {
              fill: "#406325",
              d: "M409.2 240a52.4 52.4 0 0 0 19.5-17.9c-15.6 4.2-22.7 14.3-19.5 18zm145.8 4.7a50 50 0 0 0-15.6-19.9c2.8 15.2 12 22.8 15.6 20z"
            }),
            /* @__PURE__ */ jsx163("path", {
              fill: "#67923d",
              d: "M409.2 240c-3.3-3.6 3.8-13.6 19.4-17.8-11 8.4-19.2 16.2-19.4 17.8zm145.8 4.7c-3.7 3-12.7-4.6-15.5-19.7 7.2 11 14 19.5 15.5 19.7z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs138("g", {
          stroke: "#999270",
          strokeWidth: 0.2,
          children: [
            /* @__PURE__ */ jsx163("path", {
              fill: "url(#gt_svg__d)",
              d: "M452.2 318.1s-6.1.7-7.9-7.8c-1.8-9.1 5.3-10 5.3-10s8.1-.9 13.2-1l2.2 18z"
            }),
            /* @__PURE__ */ jsx163("path", {
              fill: "url(#gt_svg__e)",
              d: "M453 315.4s-4 .7-4.8-5.6c-.6-4.5 2.2-5.1 2.2-5.1l9.2 1.6v8.2z"
            }),
            /* @__PURE__ */ jsx163("path", {
              fill: "url(#gt_svg__f)",
              d: "M450.4 304.7s6-.4 9-.8l1.3 5.7-7.1.4s-.5-5.1-3.2-5.3z"
            }),
            /* @__PURE__ */ jsx163("path", {
              fill: "url(#gt_svg__g)",
              d: "M449.2 300.4s7.5-1.9 8.5 6.4c.2 2.2-1 7.2-4.7 8.6l13.9-1.5-1.3-15-4.6.4s-10 .3-11.8 1z"
            }),
            /* @__PURE__ */ jsx163("path", {
              fill: "#f9f0aa",
              d: "M452.2 318.1s51.9-3.5 57.2-3.3c15.8-8.6 0-42.5-13.3-61.5 1.5-4.3-29.9-13.9-44-13-1.9 0-3.6.2-5.2.3-7.7.8-7.8 10.7-4.7 17 3 6 30.4 55 11.2 60.3z"
            }),
            /* @__PURE__ */ jsx163("path", {
              fill: "url(#gt_svg__h)",
              d: "M507.8 273.3c-3.5-7.3-7.7-14.3-11.7-20 1.5-4.3-29.9-13.9-44-13-1.9 0-3.6.2-5.2.3-7.7.8-7.8 10.7-4.7 17 1 1.8 4.3 8 7.9 15.7"
            }),
            /* @__PURE__ */ jsx163("path", {
              fill: "url(#gt_svg__i)",
              d: "M455 285c5.6 14.6 8.7 30-1.6 32.9l-1.2.2s52-3.5 57.2-3.3c8.6-4.7 7.8-16.8 3.2-30"
            }),
            /* @__PURE__ */ jsx163("path", {
              fill: "url(#gt_svg__j)",
              d: "M447.4 243.5c-3.7 0-4.7 3.6-4.6 5.8.1 6 4.6 6.2 4.6 6.2l6-.3 2.8-12.2z"
            }),
            /* @__PURE__ */ jsx163("path", {
              fill: "url(#gt_svg__k)",
              d: "m447.4 243.5 8.8-.5 1 9.1-7.8.4s2.5-7.3-2-9z"
            }),
            /* @__PURE__ */ jsx163("path", {
              fill: "url(#gt_svg__l)",
              d: "M496.1 253.3c6.7-1 6.6-10 2-13.7-15.5-.6-35.8-.1-50.6 1 1.7 0 6.4.4 6.9 6.5a8.2 8.2 0 0 1-3 7 7 7 0 0 1-4 1.4h3.6l3-.4c21-2.7 42-1.8 42-1.8z"
            }),
            /* @__PURE__ */ jsx163("path", {
              fill: "#b07e09",
              stroke: "none",
              d: "M458.5 267.4c-.2-.3-.4-.7-.8-.8-.2 0-.6 0-.5-.4h.8l1.6-.2c.4.1.3.5 0 .5-.5 0-.2.5-.1.8l1.3 3c.1.4.4.7.7.7l1.1-.1c.3-.2.2-.6.2-1-.1-.3.5-.2.5 0l.4 1.4c0 .2-.2.1-.4.1l-3 .2c-.3 0-.8.3-1 0 0-.4.6-.2.6-.5l-.3-1zm4.8-.4c-.1-.2-.3-.6-.7-.7-.2 0-.6 0-.6-.4.2-.2.5 0 .7 0l1.7-.2c.3 0 .4.5 0 .4-.3 0-.3.4-.2.7l1.5 3.4c0 .2.2.5.5.6.2 0 .6 0 .7.3 0 .3-.4.1-.6.1-.5 0-1 0-1.6.2-.2 0-.5 0-.5-.3s.5 0 .6-.4c0-.3-.2-.6-.4-1l-1.1-2.6zm4.5.8c0 .2.4 0 .5 0 .3 0 .6-.1.6-.4 0-.5-.3-1-.7-1.2-.3-.3-.7-.2-1.1-.2l.1.5zm.6 1.6c.2.3.3.7.6 1 .2.2.6.1.8 0 .3 0 .5-.3.4-.5-.1-.7-.5-1.3-1.2-1.5h-1l.2.5zm-2-2.4c-.2-.3-.3-.8-.7-1-.2 0-.6.1-.7-.2 0-.3.6-.1.8-.2.9 0 1.8-.3 2.6 0 .7.2 1.4.8 1.5 1.6 0 .4-.3.7-.6.8l.5.1c.6.2 1.1.6 1.4 1.2.2.4.3.9 0 1.3-.4.4-1 .4-1.4.4-.8 0-1.5 0-2.3.2-.3 0-.4-.5 0-.5.3 0 .3-.4.2-.6l-1.3-3zm7.4-1.9c.3 0 .4.3.5.5l.3.9c-.3.2-.5-.2-.6-.4-.2-.2-.4-.5-.7-.4h-1.2c-.2.2 0 .4.1.6l.6 1.4c.2 0 .6 0 .8-.3 0-.2-.3-.7.2-.6.3.2.2.6.4.9l.5 1.1c-.3.3-.5-.1-.6-.4-.2-.3-.7-.3-1-.3-.2 0 0 .2 0 .3l.6 1.5c.2.3.7.3 1 .3.3 0 .8 0 1-.4.2-.2-.3-.7 0-.8.4 0 .4.4.5.6 0 .3.2.6.3.8 0 .2-.3.2-.4.2l-3 .2c-.4 0-.9.2-1-.2 0-.3.7-.1.6-.5l-.4-1-1.1-2.7c-.2-.3-.4-.7-.8-.7-.2 0-.6 0-.4-.4h1zm2.3 1.3c-.1-.3-.3-.7-.7-.9-.2 0-.7 0-.7-.4.3-.2.7 0 1 0 .8 0 1.6-.3 2.4 0 .8.1 1.5.9 1.6 1.8 0 .4-.3.7-.7.8-.3 0 .2.1.3.2.7.3 1 .9 1.4 1.5.1.2.5.7.6.2 0-.5.6 0 .5.3 0 .4-.4.6-.7.6-.4 0-.9-.2-1.1-.6-.4-.6-.7-1.3-1.3-1.7a.8.8 0 0 0-.8-.2v.5l.6 1.2c.2.3.6.3 1 .3.3.1.2.6-.2.5h-1.7c-.3.2-.9 0-.7-.3.3 0 .7-.2.5-.5l-1-2.6zm1.4 1c.2.2.6 0 .9 0 .3 0 .3-.5.2-.7-.1-.5-.4-1-.9-1.2-.2 0-.8-.2-.9.1l.7 1.6zm7.2 1.6c.1.3.3.6.6.7.2 0 .6 0 .7.3 0 .3-.4.1-.6.2h-1.6c-.3.1-.6 0-.6-.3.2-.2.7 0 .7-.4l-.5-1.1-1.1-2.9c-.1-.3-.5-.3-.7-.3-.3 0-.7 0-.7.4 0 .3.2.6 0 .8-.3 0-.4-.3-.5-.5 0-.3-.2-.6-.4-1 0-.2.4-.1.5-.1l4.2-.2c.3 0 .5.2.5.5l.4 1c-.1.3-.5 0-.6-.3-.1-.3-.5-.7-.9-.7-.2 0-.6 0-.8.2l.2.7zm3.8-.9c-.2 0-.1.3-.1.4v.8c.1.4.5.3.8.4.2 0 .1.5-.2.4h-1.2c-.3.1-.8-.1-.5-.4.2 0 .4-.1.5-.3v-5c.2-.3.5 0 .6.2l3.6 4.5c.2.2.5.4.8.4.3 0 .4.5 0 .4h-1.5c-.2 0-.5.2-.7 0-.2-.1 0-.4.2-.4.3 0 0-.4-.1-.6l-.6-.8zm1.1-.5c.2 0 0-.1 0-.2l-1.3-1.7v2h1.3zm3.1-1.8c-.1-.4-.3-1-.8-1-.3 0-.7-.2-.5-.4h1.7c.7-.1 1.4-.1 2 .1 1.5.5 2.7 1.8 3 3.4 0 .6-.1 1.3-.6 1.6-.8.5-1.7.4-2.5.3l-1.4.1c-.3 0-.4-.5 0-.4.4 0 .4-.5.2-.7zm2 2.5c.1.3.2.7.5 1h1c.5 0 .7-.5.7-.9a5 5 0 0 0-.6-2.1c-.4-.7-1-1.2-1.8-1.4a3 3 0 0 0-1 0c-.1 0 0 .2 0 .4zm-21.1 12.4c0 .3.4.6.8.6.2 0 .7 0 .7.4-.2.2-.6 0-.8 0l-1.5.2h-.9c-.2 0-.2-.4.1-.4.3 0 .6-.1.6-.4l-.2-.8-1.2-2.8c0-.3-.4-.3-.7-.3-.2 0-.6.1-.7-.2 0-.3.5-.2.7-.4l1-.3c.2 0 .3.1.3.3zm.7-4.5h2c.4 0 .2-.5.4-.5.4 0 .4.5.4.7 0 .4-.3.7-.6.6H475l.5 1.2.6-.2c1 0 2.2.6 2.6 1.6.2.5.3 1 0 1.5-.4.5-1 .6-1.6.6-.5 0-1-.1-1.4-.6-.1-.2-.1-.7.2-.6.4 0 .7.2.7.6.1.2.5.1.7.1.3 0 .6-.2.6-.5 0-.5-.2-1-.5-1.4-.2-.4-.7-.7-1.3-.7l-.8.1c-.3 0-.3-.3-.4-.5l-.7-1.9.2-.1zm6.9 1c-.2-.4-.4-.9-.9-1-.2 0-.7-.1-.4-.4h1.6c.7-.2 1.5-.1 2.1.1 1.5.5 2.7 1.8 3 3.4 0 .6-.1 1.2-.7 1.6-.7.4-1.6.3-2.4.3l-1.3.2c-.3 0-.4-.5 0-.5.3 0 .3-.4.2-.7zm2 2.5c.1.3.3.7.6 1h1c.4-.1.6-.6.6-1 0-.7-.3-1.4-.7-2.1-.4-.7-1-1.2-1.8-1.3a3 3 0 0 0-1 0v.4zm6.4-4.3c.3 0 .4.3.5.5 0 .3.2.5.3.8-.2.3-.5 0-.6-.3-.1-.2-.3-.5-.6-.5h-1.3c-.2.2 0 .5 0 .6l.6 1.4c.3 0 .6 0 .8-.2.2-.2-.3-.7.2-.6.3 0 .3.5.4.8l.5 1.1c-.1.4-.5 0-.6-.3-.1-.3-.5-.3-.8-.3-.2 0-.4 0-.2.2l.6 1.5c.2.4.7.3 1 .3.4 0 .8 0 1-.3.2-.2-.2-.6 0-.8.4 0 .5.3.5.5l.3 1c0 .1-.3 0-.4 0l-3.1.2c-.3 0-.7.2-.9-.1-.2-.4.5-.2.6-.5l-.3-.9-1.1-2.9c-.2-.3-.4-.6-.8-.7-.2 0-.6 0-.4-.4h1zm-27.2 14.3c.1.5.6.7 1 .8.8.2 1.7.5 2.2 1.1.3.4.5.9.5 1.4 0 .5-.5.9-1 1-.5.2-1.1.1-1.7-.1-.2-.1-.1.4-.5.3-.2-.2-.1-.6-.2-.9a9 9 0 0 0-.4-1c0-.3.4 0 .5.2.3.6.9 1 1.6 1.1.4 0 .8-.2.8-.6 0-.5-.4-1-.8-1.2-.7-.3-1.4-.4-2-.8a2 2 0 0 1-1-1.6c0-.4.4-.8.8-.9.5-.2 1-.2 1.6 0 .2 0 .3-.3.6-.1 0 .2 0 .4.2.6l.3.9c-.2.2-.5 0-.5-.2-.3-.4-.5-.8-1-.8-.4 0-.8 0-1 .3zm6.6-1.7c.4 0 .4.3.5.5l.2.8c0 .3-.4 0-.5-.2-.1-.2-.3-.5-.7-.5h-1.2c-.2.2 0 .5 0 .6l.5 1.4c.3 0 .6 0 .8-.2.2-.2-.2-.6.1-.7.4 0 .4.5.5.7 0 .4.3.8.4 1.3-.1.3-.5 0-.5-.3-.1-.3-.5-.4-.8-.3-.2 0-.4 0-.3.2l.6 1.5c.1.3.4.3.7.3.4 0 .9 0 1.2-.3.2-.2 0-.6 0-.8.3-.2.6 0 .6.3l.2 1c0 .2-.3.2-.4.2l-3 .2c-.4 0-.8.3-1 0 0-.4.5-.3.6-.6 0-.2 0-.5-.2-.8l-1-3c0-.3-.3-.6-.7-.6-.2 0-.6-.1-.4-.4h1zm4.2 4.2c.1.3.3.6.6.7.3 0 .7-.1.8.2 0 .4-.5.2-.7.2-.6 0-1 0-1.6.2-.2 0-.5 0-.6-.2 0-.4.5-.2.6-.4l-.1-.8-1-3c-.2-.3-.3-.7-.7-.7-.2 0-.6 0-.5-.4.1-.2.4 0 .7 0 .7 0 1.4-.3 2.2-.2a2 2 0 0 1 1.7 1.2c.2.4.2 1 0 1.3-.5.4-1.1.5-1.7.6-.2 0 0 .2 0 .3zm-.6-1.8h.7c.3-.1.5-.4.4-.7 0-.5-.2-.9-.5-1.2-.3-.3-.8-.3-1.1-.2-.2.1 0 .3 0 .5zm6.2 1.5c0 .2.2.6.5.6.2 0 .7 0 .7.3s-.5.2-.7.2l-1.6.1c-.2 0-.5 0-.5-.3.2-.2.7 0 .7-.4l-.3-1.2-1-2.9c0-.3-.4-.2-.7-.2-.2 0-.6 0-.7.3v.8c-.2.2-.5 0-.4-.3l-.4-1c0-.3.3-.2.5-.3l4.1-.2c.3 0 .5.2.5.5l.4 1c-.1.2-.5 0-.5-.2-.2-.3-.5-.7-1-.7-.2 0-.5-.1-.8 0l.2.7zm2.1-3.3c-.1-.3-.2-.7-.6-.8-.2 0-.6 0-.6-.4.1-.2.4 0 .6 0l1.8-.2c.3-.1.5.4.2.4s-.6.2-.5.5l.5 1.6.7 2.2c0 .2.3.4.5.4.3 0 .7 0 .6.4h-.7l-1.6.2c-.2 0-.6-.2-.4-.4.2-.1.6 0 .6-.4l-.3-1.2zm5.8-1.6c.3 0 .3.3.4.5l.2.8c-.1.3-.5 0-.5-.2-.1-.3-.3-.6-.7-.6H485c-.2.2 0 .5 0 .7l.5 1.3c.2 0 .5 0 .8-.2.2-.1-.2-.6.1-.6.4 0 .4.4.5.6 0 .5.3.9.4 1.3-.1.3-.5 0-.5-.2-.1-.3-.5-.4-.8-.4-.1 0-.5 0-.3.2l.5 1.5c.1.3.5.4.7.4.4 0 .9 0 1.2-.3.2-.2 0-.6.1-.9.3-.1.5.1.5.4l.2 1c0 .2-.2.2-.4.2l-3 .1c-.4 0-.7.2-1 0-.1-.4.5-.3.6-.5a1 1 0 0 0-.1-.8l-1-3c0-.3-.3-.7-.7-.7-.2 0-.6-.2-.4-.4h1l2.9-.2zm2 1c-.1-.4-.4-.7-.8-.7-.3.1-.5-.6 0-.4h1.5l.7.9 2.2 2.9c-.2 0 0-.2-.1-.3l.4-3.6c.2-.2.7 0 1-.2.3 0 1 0 .8.4-.4 0-.8.2-.6.6l1.2 3.6c0 .4.4.6.8.5.3 0 .3.6 0 .5H494c-.3.1-.8.1-.7-.3.3 0 .8-.2.6-.6l-1-3.2c.1.1 0 .3 0 .4l-.2 3-.1.8c-.3.1-.4-.1-.5-.3l-2.9-3.7.2.3c.3 1 .5 2 .9 2.9 0 .4.5.5.8.5.4.2.1.5-.2.4h-1.5c-.3 0-.3-.4 0-.4.5 0 .4-.5.2-.8zm8.7.8c0 .2.4 0 .5 0 .3 0 .6 0 .7-.4 0-.4-.2-1-.5-1.2-.4-.3-.8-.2-1.2-.2v.5zm.5 1.6.4 1c.3.2.6.1.9.1.2 0 .5-.2.4-.5 0-.6-.3-1.3-.9-1.5h-1v.3zM496 288c-.1-.4-.2-.8-.6-1-.2 0-.6 0-.6-.3s.5 0 .7-.1c1 0 1.8-.2 2.7 0 .7.2 1.3.9 1.3 1.6 0 .4-.4.7-.7.9 0-.2.4 0 .5 0 .5.2 1 .6 1.2 1.2.2.4.3.9 0 1.3-.4.4-1 .4-1.5.4l-2.3.1c-.3 0-.4-.5 0-.4.3 0 .4-.4.2-.7zm5.1-.2c0-.3-.2-.8-.6-1-.2 0-.6 0-.6-.3.2-.3.6 0 1-.1h2c.8 0 1.5.6 1.7 1.4.1.4 0 1-.4 1.2l-.4.2c.6.2 1.1.7 1.4 1.2l.5.8c.2.2.3-.1.3-.3.4-.2.6.3.4.6-.1.4-.7.5-1 .4a.9.9 0 0 1-.8-.6l-1-1.7c-.3-.1-.6-.3-.9-.1v.4l.5 1.2c.1.3.5.4.8.4.4 0 .4.5 0 .4h-1.8c-.2 0-.6.2-.7 0-.2-.5.4-.3.6-.5l-.2-.9zm1.3 1c.1.3.6 0 .8 0 .3 0 .5-.3.4-.5 0-.5-.2-1-.5-1.3-.3-.2-.7-.2-1-.1-.2 0-.1.3 0 .5l.3 1.3zm6.9-2.6c.3 0 .3.3.4.5 0 .3.2.6.3.8-.2.3-.5 0-.6-.2 0-.2-.2-.6-.6-.6h-1.3c-.2.1 0 .4 0 .6l.4 1.4c.3 0 .6 0 .8-.2.3-.1-.1-.5.2-.7.4 0 .4.4.4.7 0 .5.3.9.4 1.3-.1.3-.5 0-.5-.2 0-.3-.4-.5-.7-.4-.1 0-.5-.2-.4 0l.5 1.7c.1.3.4.3.7.3.4 0 .9 0 1.2-.2.2-.2 0-.6.1-.8.3-.2.6 0 .5.3l.2 1c0 .2-.3.2-.4.2h-3.1c-.3 0-.6.2-.8 0-.3-.4.2-.3.4-.5s0-.5 0-.7l-.9-3.1c0-.3-.3-.7-.6-.7s-.6-.1-.5-.4h1zm-32.8 13.1c0-.3-.2-.8-.6-1-.3 0-.7 0-.5-.3l1-.1c.8 0 1.6-.2 2.4 0 1.2.2 2.3 1.2 2.6 2.3.2.8.3 1.6-.2 2.3-.5.6-1.4.8-2.2.8-.7 0-1.3 0-1.9.2-.2.1-.6-.1-.4-.4.3 0 .7-.1.6-.5l-.4-1.5zm1.6 2.5c.1.3.2.7.4.9.3.2.7.1 1 0 .4 0 .8-.4.9-.9a4 4 0 0 0-.4-2.2 2 2 0 0 0-1.5-1.2 3 3 0 0 0-1.1 0c-.1 0 0 .2 0 .4zm7.1-4.5c.3 0 .3.3.4.5l.2.9c-.2.2-.5 0-.5-.2-.1-.3-.3-.6-.6-.6h-1.3c-.2.1 0 .4 0 .6 0 .5.2 1 .3 1.4.3 0 .6 0 .8-.2.2-.2-.1-.6.2-.7.4 0 .3.5.4.7l.3 1.3c0 .3-.5 0-.5-.2 0-.3-.4-.5-.7-.4-.1 0-.5-.1-.3.1 0 .5.2 1 .4 1.6 0 .3.4.3.7.3.4 0 .9 0 1.2-.3.2-.2 0-.6.2-.8.2-.2.4.1.4.4 0 .3 0 .6.2 1-.1.2-.3.1-.5.1l-3 .2c-.3 0-.6.2-.9 0-.2-.2.1-.4.4-.4.3-.1.2-.5.1-.7l-.7-3.2c-.1-.3-.3-.7-.6-.7s-.6-.1-.5-.4h1zm6.5 4.1c0 .3.3.6.6.7.2 0 .6 0 .7.2.1.3-.4.2-.6.2l-1.7.1c-.3 0-.6.1-.8 0-.3 0-.2-.4.1-.4.3 0 .6-.1.7-.4l-.1-.8-.7-2.8c0-.3-.3-.3-.6-.3-.2 0-.6.2-.7-.1 0-.4.5-.3.7-.4l1.1-.4c.2 0 .3.1.3.3zm3.7-3.3c0-.4-.3-.8-.7-.8-.3 0-.7 0-.8.3-.1.4 0 .8.4 1l.9.5.2-.6zm.8 2.9c0-.5-.6-.8-1-1-.2 0-.4-.2-.5-.1a1 1 0 0 0-.4 1c.2.6.5 1 1 1 .4.1.8 0 1-.4v-.5zm1-.2c0 .5-.2 1-.6 1.3-.5.4-1.3.4-2 .2-.6-.1-1-.6-1.2-1.2 0-.5.1-1 .5-1.4.1 0 .5-.1.2-.2-.5-.2-1-.6-1-1.2-.2-.5 0-1 .5-1.3a2 2 0 0 1 2.6.7c.2.4.2.9 0 1.2l-.6.5c.5 0 1 .4 1.2.8.2.1.3.4.3.6zm3.2.6c.2 0 .5-.2.5-.4.1-.2 0-.7.3-.6.3 0 .2.3.3.6 0 .4 0 .8-.4 1.1-.2.2-.5.1-.8.1h-1.7c-.2 0-.5.2-.7 0-.2-.2 0-.5 0-.7.2-.7.6-1.2 1-1.6.4-.3.8-.6.8-1.1 0-.4 0-.8-.2-1.2a1 1 0 0 0-1.4-.3c-.3.1-.5.5-.3.7.2.2.6 0 .7.4.2.2 0 .6-.3.6-.4 0-.8-.3-1-.7-.1-.5.1-1.1.6-1.4.5-.3 1.1-.3 1.7-.2.5.2 1 .6 1.2 1.2.1.4.1.9-.1 1.3-.4.7-1.2 1-1.7 1.7-.1.1-.2.3-.1.6 0-.3.4-.2.5-.2zm3.9-.4c0 .2.3.5.6.6.2 0 .6 0 .7.2.2.3-.3.3-.5.3h-2.7c-.2-.1 0-.5.2-.4.3 0 .6-.1.7-.4v-.8l-.7-2.8c0-.3-.3-.3-.5-.3-.3 0-.6.2-.7 0-.2-.4.3-.4.5-.5l1.2-.4c.3 0 .3.1.4.3z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs138("g", {
          fill: "#448127",
          stroke: "#34541f",
          strokeWidth: 0.2,
          children: [
            /* @__PURE__ */ jsx163("path", {
              fill: "url(#gt_svg__m)",
              stroke: "#4c0505",
              d: "M475.8 219.4 472 224c-1.2 5.2 1.8 9.2 7.7 12.6 4.7 3 13.5 3.7 16.3 1.3l-13.7-13z"
            }),
            /* @__PURE__ */ jsx163("path", {
              d: "m503.6 354.3-2-2.5a100.8 100.8 0 0 1-32.7 28.6c15.1-4.2 25-15.2 34.7-26.1zM488.1 390a455.8 455.8 0 0 1 18.2-32.3l-2.1-2.7c-7.4 12.2-16 26.7-16 35zm41.8-114.5a62 62 0 0 0-4.3-13 126.6 126.6 0 0 0-43.8-44v-.3h.4l-.1-.1h.4l-.2-.3h.4l-.3-.4h.4l-.3-.3h.5l-.3-.4h.4l-.4-.3.6-.1-.5-.3.5-.1-.4-.3.6-.2-.5-.3.6-.3-.6-.4.7-.2-.8-.3.7-.4h-.8l.5-.7h-.7l.3-.5h-.6l.3-.5-.7.1.3-.6-.6.4.2-.7-.7.4.1-.7-.6.5.1-.7-.5.5v-.7l-.5.6v-.7l-.4.5-.2-.6-.4.6-.1-.7-.3.7-.2-.7-.3.7-.2-.6-.2.6-.2-.6-.2.8-.2-.7-.3.8-.3-.7v.8l-.4-.7v.8l-.5-.6v.8l-.4-.6v.7l-.4-.3.2.7-.5-.3.2.6-.4-.2.1.6h-.4l.2.4h-.3l.2.4a9 9 0 0 0-.4 3.5c0 .2.6.4.7.6.3.4.2.6.2.6-1.6 2.6-3 4.6-3.1 7.6 1.2-1.6 2.6-3.6 4.4-3.6-.9 1.5-1.3 6.1-.3 6.8l.8-1.3c0 1 .1 1.8.4 2.3.3-.6.6-1.3 1-1.7 0 1.5.2 2.7.6 3.3.5-.8 1-1.2 1.6-1.6-.2.9-.5 1.7-.3 2.7.6-1 1.2-1.7 1.9-2.5-.4 1.6 0 2.8.4 4.5.4-2 .6-2.3 1.5-3.1.1 1.9-.2 3.6.2 4.7.8-1.7 1.4-1.5 2-2.6-.2 1.6-.5 3.3 0 4.7a4.5 4.5 0 0 1 1.9-2.6c0 2.2.5 1.8-.8 3.7.6.2 2.5-.4 3.6-.9-.5 1.2-.4 2.1-.9 3 1-.6 2-1.5 2.9-2.4-.4 1.4-1.5 2.8-1 4.1.3-1.3 1.3-2.3 2.3-2.5-.2.7-.3 2.2-1.3 2.9 2.4.2 3.4-1.4 4.6-2.7-.1 1.3 0 2.4 1.6 4.3-.3-2.4.2-1.9 1.3-3.3.6 2.1 1.2 4.4 3.4 6-1-2.3-1-3.5-.6-4.9.3 1.5 1.7 3.3 2 4.6.3-1.5.5-3 1-4a20 20 0 0 1 1.4 5.6c.5-1 .9-2 1.1-3 19.8 20.5 24.2 46.7 2.5 74.4 7.8-5.2 9.8-13.5 14.1-20.6-4.2 9.3-6 19.7-13.5 27.4 7.2-6.2 8.7-11.9 13-17.9-4.5 12.5-11 26.2-19.8 38.8l4.8 5.2 4-6.9c9.4-15.4 24.7-37.5 17-71.1z"
            })
          ]
        }),
        /* @__PURE__ */ jsx163("path", {
          fill: "#eac102",
          stroke: "#a08307",
          strokeWidth: 0.2,
          d: "M473.2 215.3c-1 .2-1.4.6-2.2 1.4 1 .2 1.7.3 2.6.3.2 0 .3-.4.3-.6l-.2-1c0-.2-.6-.1-.8 0z"
        }),
        /* @__PURE__ */ jsx163("path", {
          fill: "#a08307",
          d: "M471 216.7a9.9 9.9 0 0 1 2.2-.5 9.8 9.8 0 0 1-2.2.5"
        }),
        /* @__PURE__ */ jsx163("circle", {
          cx: 477.7,
          cy: 215.4,
          r: 0.8,
          stroke: "#000",
          strokeWidth: 0.1
        }),
        /* @__PURE__ */ jsx163("ellipse", {
          cx: 477.9,
          cy: 215.3,
          fill: "url(#gt_svg__n)",
          rx: 0.3,
          ry: 0.4
        }),
        /* @__PURE__ */ jsxs138("g", {
          fill: "#34541f",
          children: [
            /* @__PURE__ */ jsx163("path", {
              d: "M488.2 389.7a83.4 83.4 0 0 1 7.4-17.2 199.6 199.6 0 0 1 7.1-12.2l2.6-4-2.5 4a407 407 0 0 0-7 12.3 133.7 133.7 0 0 0-7.6 17zm-18.9-9.5a75.8 75.8 0 0 0 29.7-23.1 153.5 153.5 0 0 0-11.2 11.8 70 70 0 0 1-18.5 11.3m37.3-29.3c.8-1 1.5-2.2 2.2-3.3a136.2 136.2 0 0 0 6-10.2c1.4-2.3 2.6-4.7 3.8-7l3.7-7-1.7 3.5-1.8 3.6a256 256 0 0 1-7.7 13.8 93.8 93.8 0 0 1-4.5 6.6m5.9-25.1a58.4 58.4 0 0 0 8.5-13.4 72.6 72.6 0 0 0 6-23 54.2 54.2 0 0 0-.1 4 58.8 58.8 0 0 1-5.8 19 59.9 59.9 0 0 1-8.6 13.4"
            }),
            /* @__PURE__ */ jsx163("path", {
              d: "M510.9 320a52 52 0 0 0 8.7-12.5A96 96 0 0 0 524 297l.3-.9.3-.9.6-1.8a41.6 41.6 0 0 0 .2-15.4 58 58 0 0 0 .7 7.7c0 2.6-.2 5.2-.7 7.7-.3.6-.4 1.3-.6 1.9l-.3.9-.4.9a229 229 0 0 1-4.4 10.6 51.6 51.6 0 0 1-3.8 6.6 36 36 0 0 1-5 5.8z"
            }),
            /* @__PURE__ */ jsx163("path", {
              d: "M505 349.2c1.3-1.6 2.4-3.3 3.6-5l1.8-2.5 1.7-2.5 3-5.4 2.6-5.5c1.8-3.7 3.5-7.4 5-11.3a78.8 78.8 0 0 0 5.3-23.8 58.4 58.4 0 0 0-2.6-24.2 52.4 52.4 0 0 1 2.8 24.2 80 80 0 0 1-5.3 23.9c-1.5 3.8-3.2 7.5-5 11.2l-2.8 5.5c-.9 1.9-1.8 3.7-2.9 5.4-.5 1-1.1 1.7-1.7 2.6l-1.8 2.5-3.6 5z"
            }),
            /* @__PURE__ */ jsx163("path", {
              d: "M507.8 352.3a443.4 443.4 0 0 0 13.4-23.5 81.9 81.9 0 0 0 8.7-39.2c0-4.5-.4-9-1.2-13.4a57.6 57.6 0 0 0 .1 0c.9 4.4 1.2 9 1.2 13.4a102.9 102.9 0 0 1-3.6 26.7 82 82 0 0 1-5 12.6 442.6 442.6 0 0 1-13.5 23.4zM480 220.8h1.4a14.3 14.3 0 0 1 4.1 1.3 35.8 35.8 0 0 1 9 6.8 37.8 37.8 0 0 0-9-6.6 19 19 0 0 0-5.5-1.5"
            })
          ]
        }),
        /* @__PURE__ */ jsxs138("g", {
          fill: "#448127",
          children: [
            /* @__PURE__ */ jsx163("path", {
              d: "M496.4 231.6s3 1.8 4.7 4.4c0 0-4.7-.9-8-4.6"
            }),
            /* @__PURE__ */ jsx163("path", {
              fill: "#34541f",
              d: "M496.4 231.6a14.4 14.4 0 0 1 4.8 4.4l.1.2h-.2a14.5 14.5 0 0 1-4.4-1.8c-1.4-.8-2.6-1.8-3.7-3a15.2 15.2 0 0 0 5.9 3.8l2.2.7v.2a11.1 11.1 0 0 0-2.2-2.5 17.7 17.7 0 0 0-2.5-2"
            }),
            /* @__PURE__ */ jsx163("path", {
              d: "M489.6 230.7s7.2 4.6 8.3 5c0 0-1.7-3.5-5.1-5"
            }),
            /* @__PURE__ */ jsx163("path", {
              fill: "#34541f",
              d: "m489.6 230.7 4.1 2.5a156.9 156.9 0 0 0 3.1 1.8l1 .6v.1a10.7 10.7 0 0 0-2.1-2.9 10.7 10.7 0 0 0-2.9-2.1 8.4 8.4 0 0 1 3 2 11 11 0 0 1 2.1 3l.2.2-.3-.1-2.1-1.2a153.5 153.5 0 0 1-6.1-4z"
            }),
            /* @__PURE__ */ jsx163("path", {
              d: "M492.5 228.4s3.7 1.6 4.6 4.3c0 0-6.8-2.8-8-4.3"
            }),
            /* @__PURE__ */ jsx163("path", {
              fill: "#34541f",
              d: "M492.5 228.4a10.7 10.7 0 0 1 2.8 1.6l1.1 1.2.8 1.5v.2h-.2a77.2 77.2 0 0 1-7-3.7l-.9-.8.9.7 1 .6a36 36 0 0 0 6.1 3h-.1c-.2-.4-.4-1-.8-1.3a4 4 0 0 0-1-1.2 10.8 10.8 0 0 0-2.7-1.8"
            }),
            /* @__PURE__ */ jsx163("path", {
              d: "M486.8 231.3s6.6 4.7 8.6 4.7c0 0-2-3.3-5.4-4.7"
            }),
            /* @__PURE__ */ jsx163("path", {
              fill: "#34541f",
              d: "M486.8 231.3a124 124 0 0 0 7.4 4.3l1.2.3-.1.2a12.4 12.4 0 0 0-2.3-2.8 13 13 0 0 0-3-2 10.7 10.7 0 0 1 4.4 3.2l1 1.5.2.1h-.2c-.5 0-.9-.1-1.3-.3l-1-.5a33.3 33.3 0 0 1-6.3-4"
            }),
            /* @__PURE__ */ jsx163("path", {
              d: "M486.8 232.7s3.4 3 5.4 3c0 0-2-3.3-5.4-4.8"
            }),
            /* @__PURE__ */ jsx163("path", {
              fill: "#34541f",
              d: "M486.8 232.7a32 32 0 0 0 4 2.5l.6.2.8.2-.1.1a12.4 12.4 0 0 0-2.3-2.7 13 13 0 0 0-3-2 10.7 10.7 0 0 1 4.4 3.1l1 1.5.2.2h-.2a4 4 0 0 1-1.6-.4 11.5 11.5 0 0 1-2.6-1.7 4 4 0 0 1-1.2-1"
            }),
            /* @__PURE__ */ jsx163("path", {
              d: "M485 226.2s7.2 5.1 8 7.9c0 0-6.4-3-7.6-4.5"
            }),
            /* @__PURE__ */ jsx163("path", {
              fill: "#34541f",
              d: "M485 226.2a51.6 51.6 0 0 1 7.5 6.6l.7 1.2v.3l-.2-.1a79.6 79.6 0 0 1-6.8-3.9l-.8-.7.8.7 1 .6a37.3 37.3 0 0 0 6 3l-.2.2-.7-1.2a29.3 29.3 0 0 0-5-5z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs138("g", {
          stroke: "#24420e",
          strokeWidth: 0.2,
          children: [
            /* @__PURE__ */ jsx163("path", {
              fill: "#406325",
              d: "M445 370.3a42.2 42.2 0 0 1-20.4 4.8c10-8.2 19.7-8.4 20.4-4.8zm69.8 4.5c5.2 4.7 21 8 23.5 7.4-10.6-10.7-22.1-11.8-23.5-7.4z"
            }),
            /* @__PURE__ */ jsx163("path", {
              fill: "#67923d",
              d: "M445 370.3c-.7-3.7-10.5-3.4-20.4 4.8a69.6 69.6 0 0 1 20.4-4.8zm69.9 4.4c1.4-4.4 12.8-3.3 23.4 7.5a84 84 0 0 0-23.4-7.5z"
            })
          ]
        })
      ]
    })
  ]
});
var Gt_default = SvgGt;

// src/country-flag-icons/generated/Gu.tsx
init_esm_shims();
import { jsx as jsx164, jsxs as jsxs139 } from "react/jsx-runtime";
var SvgGu = (props) => /* @__PURE__ */ jsxs139("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx164("path", {
      fill: "#be0027",
      fillRule: "evenodd",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx164("path", {
      fill: "#3b5aa3",
      fillRule: "evenodd",
      d: "M25.6 27.3h589.5v428.4H25.6z"
    }),
    /* @__PURE__ */ jsx164("path", {
      fill: "#cbe0e5",
      fillRule: "evenodd",
      d: "M314.4 413.2a10 10 0 0 0 8.4.1c137.8-73.3 137.8-274.3.1-346.6a10 10 0 0 0-8.7.2c-134.3 73.4-134.7 272.1.1 346.3z"
    }),
    /* @__PURE__ */ jsx164("path", {
      fill: "#add2d9",
      fillRule: "evenodd",
      d: "M314.4 416.9c2 1.7 6.4 1.5 8.4 0 101.5-76 102-123.3 97.6-123.3h-201c-3 0 1.8 48.2 95 123.3"
    }),
    /* @__PURE__ */ jsx164("path", {
      fill: "#fdf9a1",
      fillRule: "evenodd",
      d: "M235.3 331.2a39.2 39.2 0 0 1 27.9 1.7c7.6 4 12 4 20.2 4 8.6.2 15.3 6.5 24.6 6.8 17.1.4 24.3 8.9 11 9-6.2 0-19.7-4.3-26.2-3.4-13.6 1.4-22.2 4.4-35 18.7l14.8 10c12.8-5.1 14.9-11 22-11.2 8-.3 10.7-5.2 20-5.2a92.6 92.6 0 0 0 33-3.2c14.8-3.4 7.8-13.8-1.2-17.5-7.3-3.1-20.8-.1-29.2-3.2-6.4-2.5-1.2-6.5 2.3-7.3 3.4-.7 7.1.5 11.4 1.2 7.7.6 17.4-.1 24.1-1.2 14-2.1 13.4-6.2 20-6.3 5-.3 8.7-1.7 12-4.1 4-2.7 8.1-8 12.9-7.8l12.7.5-18 40.4-50.7 51.7-26.3 10-57.8-37.7-29.1-44.7z"
    }),
    /* @__PURE__ */ jsx164("path", {
      fill: "#179a3b",
      fillRule: "evenodd",
      d: "m301.8 292 116-.6 2-10.3s-4.1-.6-7.5-.8c-4.1-.3-11.3 4.4-16 4.3-3.5 0-7.3-6-10.7-6-6 0-6.4 5.3-12 5.5-4.5-.2-6.4-3.6-12.3-3.2-6 .3-5.6 3.7-13.3 3.5-10.2-.3-14.3-9.1-22.5-9.2-13.6-.2-14 13-23.8 16.7z"
    }),
    /* @__PURE__ */ jsx164("path", {
      fill: "#fdf9a1",
      fillRule: "evenodd",
      d: "m301.8 294.4 119.4-.6v-3.2l-122.2.6z"
    }),
    /* @__PURE__ */ jsx164("path", {
      fill: "#a79270",
      fillRule: "evenodd",
      d: "M350.8 330.3c1.9 7 3.8 9.4 11.2 11.3 7.3 1.7 18.5-5.4 11.6-12.3-6.6-6.4-13.6-8-19.5-13.8-12.5-12.3-31.3-42.5-31.3-63.8 0-18.3-1.8-55.8-1.8-91.3 0-2.3-7 6.4-7 8.8.4 31.3.4 55 1.6 86.6 2 23.1 13 38.7 22.7 52.7 4.3 6.8 10.6 14 12.5 21.8"
    }),
    /* @__PURE__ */ jsx164("text", {
      x: 465.1,
      y: 269.5,
      fill: "#bd0728",
      stroke: "#fff",
      strokeWidth: 1.6,
      fontFamily: "helvetica",
      fontSize: 25.6,
      transform: "matrix(1.33 0 0 1.33 -363 -108)",
      children: /* @__PURE__ */ jsx164("tspan", {
        children: "G"
      })
    }),
    /* @__PURE__ */ jsx164("text", {
      x: 488.1,
      y: 269.6,
      fill: "#bd0728",
      stroke: "#fff",
      strokeWidth: 1.6,
      fontFamily: "helvetica",
      fontSize: 25.6,
      transform: "matrix(1.33 0 0 1.33 -363 -108)",
      children: /* @__PURE__ */ jsx164("tspan", {
        children: "U"
      })
    }),
    /* @__PURE__ */ jsx164("text", {
      x: 516,
      y: 269.6,
      fill: "#bd0728",
      stroke: "#fff",
      strokeWidth: 1.6,
      fontFamily: "helvetica",
      fontSize: 25.6,
      transform: "matrix(1.33 0 0 1.33 -363 -108)",
      children: /* @__PURE__ */ jsx164("tspan", {
        children: "A"
      })
    }),
    /* @__PURE__ */ jsx164("text", {
      x: 539.5,
      y: 269.5,
      fill: "#bd0728",
      stroke: "#fff",
      strokeWidth: 1.6,
      fontFamily: "helvetica",
      fontSize: 25.6,
      transform: "matrix(1.33 0 0 1.33 -363 -108)",
      children: /* @__PURE__ */ jsx164("tspan", {
        children: "M"
      })
    }),
    /* @__PURE__ */ jsx164("path", {
      fill: "#239e46",
      fillRule: "evenodd",
      d: "M259.6 160.9c-1.5 3 3.6-.9 4.8-1.3 6.7-2.4 9.3-10.8 20.8-5.7 9 3.9 21.1 1.6 14.8 5.6-7.8 4.7-23.5 9.9-23.8 33.2 1.3 2.2 1.4 1.9 2.5-.6 2.4-5.4 13.7-20.1 19.3-18.9 2.3.6 8.9-6.7 9-4.6.7 5.8-9 17.6-8.8 33.3 0 3.7 4.5 4.9 6.6 2.3 2.2-2.3 3.4-4.6 7.2-7.6 6.6-5.4 4.8-28.6 5.6-27.5 4.7 6 5.4 23.3 12.4 30.3 5.9 5.9 10.6 3 9.3-5-2.5-16.4-10.2-11.7-13.9-28.6-.8-3.3-1-6.2 3.4-4.9 5.3 1.6 8.5 4 12.4 10 4 5.8 11.4 11.3 15.7 14.6 7.5 5.8 10.2.8 6.6-6.6a39.6 39.6 0 0 0-21-18.2c-6.2-2.2-8.4-2.4-13.8-3.4-1.5-.3-3-3.4-.4-5.1a42.5 42.5 0 0 1 19.6-7.7c6.7-.2 12 5.2 16.7 6.6 9.4 2.4 9.4-3.5 5.2-8-3.4-3.7-10.6-10-17.3-9.1-13.5 1.7-12.6 1.3-21 6.8-3 1.8-6.4 3.8-5.1 1.6 3-5.5.2-4.5 4.9-10.1 3.6-4 6.3-7 10-8 3.4-.9 8-4.5 9.3-6.4 3.4-4.6.5-7.3-4.7-5.7-4.6 1.2-7 4.2-10 5-7.4 2.4-13.3 19-14.2 21.4-1.1 2.8-2.4 1.4-2.2-1 1-11.7 2-31.5-2-39.6-6.4-12-5.8-6.4-8.2-.7-3.6 9-2.3 17.5 0 26.3 1 4.4 4.6 9.4 5.3 12.9.5 2.7-1.6-.8-2.8-2.5-3.9-6-6.8-10-13.2-13.3a35.3 35.3 0 0 0-20.2-2c-1.8.6 2 3.2 3.5 4.4 4.3 3.4 12.4 4.5 18 7.9 4.6 2.9 8.2 4.7 9.8 8.7.6 3 1.6 7.4-.4 7.3-5.1-.3-13-4.8-29.4-3-8.4 1.2-15.6 8.3-20.3 16.9"
    }),
    /* @__PURE__ */ jsx164("path", {
      fillRule: "evenodd",
      d: "M295.3 310.6h4.7v7.9h-4.7z"
    }),
    /* @__PURE__ */ jsx164("path", {
      fill: "#fdf9ff",
      fillRule: "evenodd",
      d: "M271.7 257.9c18.8 26 49 41.2 49.6 53h-58.8c13.5-16.2 21.8-27.2 9.2-53"
    }),
    /* @__PURE__ */ jsx164("path", {
      fill: "#a68861",
      fillRule: "evenodd",
      d: "M254.6 311.5c25.6 5.7 56.1 8.9 75.6-.8.2 5.7-6.3 14-11.7 14h-49c5.7-.9 9-2.6 18.2-3l-26 .2c-3 .1-8-7.6-7.1-10.4"
    }),
    /* @__PURE__ */ jsx164("path", {
      fill: "#be0027",
      fillRule: "evenodd",
      d: "M312.6 425c2.6 1.5 6.7 1.4 9 .2 147.8-78.7 147.9-294.4.2-372a10.7 10.7 0 0 0-9.4.2c-144 78.8-144.4 292 .2 371.7zm.7-17.7a9.3 9.3 0 0 0 8 .1c123.6-72.8 125.1-265.1.1-334-2.4-1.8-5.9-1.2-8.3 0-118.4 70.1-125 254.5.2 333.9"
    }),
    /* @__PURE__ */ jsx164("path", {
      fill: "#bd0728",
      d: "M268.8 225.4q3.4 0 6 1.4 3.5 1.8 4.3 6.6H276q-.6-2.6-2.6-4-1.8-1.2-4.7-1.2-3.3 0-5.7 2.7-2.3 2.5-2.3 7.6 0 4.2 1.9 7 2 2.7 6.3 2.7 3.3 0 5.4-1.9 2.3-1.9 2.3-6.2H269v-2.7h10.6v13h-2.1l-.8-3.2q-1.6 1.9-3 2.7-2.2 1.2-5.5 1.2-4.3 0-7.5-2.8-3.4-3.6-3.4-9.7t3.3-9.7q3.2-3.5 8.2-3.5m-.6 0",
      "aria-label": "G",
      fontFamily: "helvetica",
      fontSize: 25.6
    }),
    /* @__PURE__ */ jsx164("path", {
      fill: "#bd0728",
      d: "M292.4 226.1v15.2q0 2.6 1 4.3 1.4 2.7 5 2.7 4.1 0 5.7-2.8.8-1.6.8-4.2V226h3.4v13.8q0 4.4-1.4 7-2.1 4.3-8.2 4.3-6.3 0-8.5-4.4-1.2-2.5-1.2-6.9V226zm6.3 0",
      "aria-label": "U",
      fontFamily: "helvetica",
      fontSize: 25.6
    }),
    /* @__PURE__ */ jsx164("path", {
      fill: "#bd0728",
      d: "m338.4 240.5-3.7-10.7-4 10.7zM333 226h3.7l9 24.5h-3.8l-2.4-7.3h-9.7l-2.7 7.3h-3.3z",
      "aria-label": "A",
      fontFamily: "helvetica",
      fontSize: 25.6
    }),
    /* @__PURE__ */ jsx164("path", {
      fill: "#bd0728",
      d: "M357 226h4.9l6.9 20.7 7-20.7h4.7v24.4h-3.2v-20.6l-7 20.6h-3.1l-7-20.6v20.6H357z",
      "aria-label": "M",
      fontFamily: "helvetica",
      fontSize: 25.6
    })
  ]
});
var Gu_default = SvgGu;

// src/country-flag-icons/generated/Gw.tsx
init_esm_shims();
import { jsx as jsx165, jsxs as jsxs140 } from "react/jsx-runtime";
var SvgGw = (props) => /* @__PURE__ */ jsxs140("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx165("path", {
      fill: "#ce1126",
      d: "M0 0h220v480H0z"
    }),
    /* @__PURE__ */ jsx165("path", {
      fill: "#fcd116",
      d: "M220 0h420v240H220z"
    }),
    /* @__PURE__ */ jsx165("path", {
      fill: "#009e49",
      d: "M220 240h420v240H220z"
    }),
    /* @__PURE__ */ jsxs140("g", {
      id: "gw_svg__b",
      transform: "matrix(80 0 0 80 110 240)",
      children: [
        /* @__PURE__ */ jsx165("path", {
          id: "gw_svg__a",
          fill: "#000001",
          d: "M0-1v1h.5",
          transform: "rotate(18 0 -1)"
        }),
        /* @__PURE__ */ jsx165("use", {
          xlinkHref: "#gw_svg__a",
          width: "100%",
          height: "100%",
          transform: "scale(-1 1)"
        })
      ]
    }),
    /* @__PURE__ */ jsx165("use", {
      xlinkHref: "#gw_svg__b",
      width: "100%",
      height: "100%",
      transform: "rotate(72 110 240)"
    }),
    /* @__PURE__ */ jsx165("use", {
      xlinkHref: "#gw_svg__b",
      width: "100%",
      height: "100%",
      transform: "rotate(144 110 240)"
    }),
    /* @__PURE__ */ jsx165("use", {
      xlinkHref: "#gw_svg__b",
      width: "100%",
      height: "100%",
      transform: "rotate(-144 110 240)"
    }),
    /* @__PURE__ */ jsx165("use", {
      xlinkHref: "#gw_svg__b",
      width: "100%",
      height: "100%",
      transform: "rotate(-72 110 240)"
    })
  ]
});
var Gw_default = SvgGw;

// src/country-flag-icons/generated/Gy.tsx
init_esm_shims();
import { jsx as jsx166, jsxs as jsxs141 } from "react/jsx-runtime";
var SvgGy = (props) => /* @__PURE__ */ jsx166("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs141("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx166("path", {
        fill: "#399408",
        d: "M2.4 0H640v480H2.4z"
      }),
      /* @__PURE__ */ jsx166("path", {
        fill: "#fff",
        d: "M.2 0c-.9 0 619.6 241.5 619.6 241.5L0 479.8z"
      }),
      /* @__PURE__ */ jsx166("path", {
        fill: "#ffde08",
        d: "M.3 20.2c3.4 0 559 217.9 555.9 220L1.9 463.2.3 20.3z"
      }),
      /* @__PURE__ */ jsx166("path", {
        fill: "#000001",
        d: "M1.9.8c1.8 0 290.9 240.9 290.9 240.9L1.8 477z"
      }),
      /* @__PURE__ */ jsx166("path", {
        fill: "#de2110",
        d: "M.3 33.9c1.6-15 260.9 208.4 260.9 208.4L.2 451.7V33.9z"
      })
    ]
  })
});
var Gy_default = SvgGy;

// src/country-flag-icons/generated/Hk.tsx
init_esm_shims();
import { jsx as jsx167, jsxs as jsxs142 } from "react/jsx-runtime";
var SvgHk = (props) => /* @__PURE__ */ jsxs142("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx167("path", {
      fill: "#EC1B2E",
      d: "M0 0h640v480H0"
    }),
    /* @__PURE__ */ jsx167("path", {
      id: "hk_svg__a",
      fill: "#fff",
      d: "M346.3 103.1C267 98 230.6 201.9 305.6 240.3c-26-22.4-20.6-55.3-10.1-72.4l1.9 1.1c-13.8 23.5-11.2 52.7 11.1 71-12.7-12.3-9.5-39 12.1-48.9s23.6-39.3 16.4-49.1q-14.7-25.6 9.3-38.9M307.9 164l-4.7 7.4-1.8-8.6-8.6-2.3 7.8-4.3-.6-8.9 6.5 6.1 8.3-3.3-3.7 8.1 5.6 6.8z"
    }),
    /* @__PURE__ */ jsx167("use", {
      xlinkHref: "#hk_svg__a",
      transform: "rotate(72 312.5 243.5)"
    }),
    /* @__PURE__ */ jsx167("use", {
      xlinkHref: "#hk_svg__a",
      transform: "rotate(144 312.5 243.5)"
    }),
    /* @__PURE__ */ jsx167("use", {
      xlinkHref: "#hk_svg__a",
      transform: "rotate(216 312.5 243.5)"
    }),
    /* @__PURE__ */ jsx167("use", {
      xlinkHref: "#hk_svg__a",
      transform: "rotate(288 312.5 243.5)"
    })
  ]
});
var Hk_default = SvgHk;

// src/country-flag-icons/generated/Hm.tsx
init_esm_shims();
import { jsx as jsx168, jsxs as jsxs143 } from "react/jsx-runtime";
var SvgHm = (props) => /* @__PURE__ */ jsxs143("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx168("path", {
      fill: "#00008B",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx168("path", {
      fill: "#fff",
      d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0z"
    }),
    /* @__PURE__ */ jsx168("path", {
      fill: "red",
      d: "M212 140.5 320 220v20l-135.5-99.5zm-92 10 3 17.5-96 72H0zM320 0v1.5l-124.5 94 1-22L295 0zM0 0l119.5 88h-30L0 21z"
    }),
    /* @__PURE__ */ jsx168("path", {
      fill: "#fff",
      d: "M120.5 0v240h80V0zM0 80v80h320V80z"
    }),
    /* @__PURE__ */ jsx168("path", {
      fill: "red",
      d: "M0 96.5v48h320v-48zM136.5 0v240h48V0z"
    }),
    /* @__PURE__ */ jsx168("path", {
      fill: "#fff",
      d: "m527 396.7-20.5 2.6 2.2 20.5-14.8-14.4-14.7 14.5 2-20.5-20.5-2.4 17.3-11.2-10.9-17.5 19.6 6.5 6.9-19.5 7.1 19.4 19.5-6.7-10.7 17.6zm-3.7-117.2 2.7-13-9.8-9 13.2-1.5 5.5-12.1 5.5 12.1 13.2 1.5-9.8 9 2.7 13-11.6-6.6zm-104.1-60-20.3 2.2 1.8 20.3-14.4-14.5-14.8 14.1 2.4-20.3-20.2-2.7 17.3-10.8-10.5-17.5 19.3 6.8L387 178l6.7 19.3 19.4-6.3-10.9 17.3 17.1 11.2ZM623 186.7l-20.9 2.7 2.3 20.9-15.1-14.7-15 14.8 2.1-21-20.9-2.4 17.7-11.5-11.1-17.9 20 6.7 7-19.8 7.2 19.8 19.9-6.9-11 18zm-96.1-83.5-20.7 2.3 1.9 20.8-14.7-14.8-15.1 14.4 2.4-20.7-20.7-2.8 17.7-11L467 73.5l19.7 6.9 7.3-19.5 6.8 19.7 19.8-6.5-11.1 17.6zM234 385.7l-45.8 5.4 4.6 45.9-32.8-32.4-33 32.2 4.9-45.9-45.8-5.8 38.9-24.8-24-39.4 43.6 15 15.8-43.4 15.5 43.5 43.7-14.7-24.3 39.2 38.8 25.1Z"
    })
  ]
});
var Hm_default = SvgHm;

// src/country-flag-icons/generated/Hn.tsx
init_esm_shims();
import { jsx as jsx169, jsxs as jsxs144 } from "react/jsx-runtime";
var SvgHn = (props) => /* @__PURE__ */ jsxs144("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx169("path", {
      fill: "#18c3df",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx169("path", {
      fill: "#fff",
      d: "M0 160h640v160H0z"
    }),
    /* @__PURE__ */ jsxs144("g", {
      id: "hn_svg__c",
      fill: "#18c3df",
      transform: "translate(320 240) scale(26.66665)",
      children: [
        /* @__PURE__ */ jsxs144("g", {
          id: "hn_svg__b",
          children: [
            /* @__PURE__ */ jsx169("path", {
              id: "hn_svg__a",
              d: "m-.3 0 .5.1L0-1z"
            }),
            /* @__PURE__ */ jsx169("use", {
              xlinkHref: "#hn_svg__a",
              width: "100%",
              height: "100%",
              transform: "scale(-1 1)"
            })
          ]
        }),
        /* @__PURE__ */ jsx169("use", {
          xlinkHref: "#hn_svg__b",
          width: "100%",
          height: "100%",
          transform: "rotate(72)"
        }),
        /* @__PURE__ */ jsx169("use", {
          xlinkHref: "#hn_svg__b",
          width: "100%",
          height: "100%",
          transform: "rotate(-72)"
        }),
        /* @__PURE__ */ jsx169("use", {
          xlinkHref: "#hn_svg__b",
          width: "100%",
          height: "100%",
          transform: "rotate(144)"
        }),
        /* @__PURE__ */ jsx169("use", {
          xlinkHref: "#hn_svg__b",
          width: "100%",
          height: "100%",
          transform: "rotate(-144)"
        })
      ]
    }),
    /* @__PURE__ */ jsx169("use", {
      xlinkHref: "#hn_svg__c",
      width: "100%",
      height: "100%",
      transform: "translate(133.3 -42.7)"
    }),
    /* @__PURE__ */ jsx169("use", {
      xlinkHref: "#hn_svg__c",
      width: "100%",
      height: "100%",
      transform: "translate(133.3 37.3)"
    }),
    /* @__PURE__ */ jsx169("use", {
      xlinkHref: "#hn_svg__c",
      width: "100%",
      height: "100%",
      transform: "translate(-133.3 -42.7)"
    }),
    /* @__PURE__ */ jsx169("use", {
      xlinkHref: "#hn_svg__c",
      width: "100%",
      height: "100%",
      transform: "translate(-133.3 37.3)"
    })
  ]
});
var Hn_default = SvgHn;

// src/country-flag-icons/generated/Hr.tsx
init_esm_shims();
import { jsx as jsx170, jsxs as jsxs145 } from "react/jsx-runtime";
var SvgHr = (props) => /* @__PURE__ */ jsxs145("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx170("path", {
      fill: "#171796",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx170("path", {
      fill: "#fff",
      d: "M0 0h640v320H0z"
    }),
    /* @__PURE__ */ jsx170("path", {
      fill: "red",
      d: "M0 0h640v160H0zm320 364.1c51.3 0 93.3-42 93.3-93.3V160H226.7v110.8c0 51.4 42 93.4 93.3 93.4z"
    }),
    /* @__PURE__ */ jsx170("path", {
      fill: "#fff",
      d: "M320 362.6a91.8 91.8 0 0 0 91.6-91.5V161.8H228.5V271a91.8 91.8 0 0 0 91.5 91.5z"
    }),
    /* @__PURE__ */ jsxs145("g", {
      fill: "red",
      children: [
        /* @__PURE__ */ jsx170("path", {
          d: "M267.1 165.2H232v38.7h35.2zm0 77.4h35.3v-38.7H267zM232 270.9c0 3.5.2 7 .6 10.4h34.6v-38.7H232zm105.7-28.3h-35.2v38.7h35.2zm0 77.4h35.2v-38.7h-35.2zm35.2 21.2A89.2 89.2 0 0 0 393 320h-20v21.2zM267.1 320h35.3v-38.7H267zm-20.1 0a89.2 89.2 0 0 0 20.1 21.2V320zm79.1 38.7c4-.3 7.7-.8 11.5-1.6V320h-35.2v37.1a87 87 0 0 0 11.4 1.6c4.1.3 8.2.2 12.3 0"
        }),
        /* @__PURE__ */ jsx170("path", {
          d: "M407.4 281.3c.4-3.4.6-6.9.6-10.4v-28.3h-35.2v38.7zm-69.8-38.7h35.2v-38.7h-35.2zm0-77.4h-35.2v38.7h35.2zm70.4 38.7v-38.7h-35.2v38.7z"
        })
      ]
    }),
    /* @__PURE__ */ jsx170("path", {
      fill: "#fff",
      d: "m410 158.8 21.8-49.5-16.6-26.8-27.6 10.2-19.4-22.2-25.4 14.7L320 66.5l-22.7 18.6-25.5-14.6-19.4 22.2-27.6-10.3-16.6 27 21.8 49.4a217.8 217.8 0 0 1 90-19.3c32 0 62.5 6.9 90 19.3"
    }),
    /* @__PURE__ */ jsx170("path", {
      fill: "#0093dd",
      d: "m253 94.8-27.4-10-15.3 24.7 5.9 13.3 14.8 33.7a219.7 219.7 0 0 1 34.6-12z"
    }),
    /* @__PURE__ */ jsx170("path", {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M251.4 119.3a13.3 13.3 0 0 1 1.6 6.2c0 7.3-6 13.3-13.4 13.3a13.4 13.4 0 0 1-13.1-10.8 13.4 13.4 0 0 0 11.7 6.9 13.4 13.4 0 0 0 13.2-15.6z"
    }),
    /* @__PURE__ */ jsx170("path", {
      d: "m227.6 114 1-4.9-3.8-3.2-.1-.1.2-.1 4.6-1.6 1-4.8v-.2l.2.1 3.7 3.2 4.6-1.6h.2v.2l-1 4.8 3.7 3.2.2.2h-.3l-4.6 1.6-1 4.8v.2l-.1-.1-3.7-3.2-4.6 1.6h-.3z"
    }),
    /* @__PURE__ */ jsx170("path", {
      fill: "#f7db17",
      d: "m233.6 107.6 3.5 3 4.3-1.5zm0-.2 7.8 1.6-3.4-3zm-8.3-1.6 7.8 1.5-3.5-3zm7.8 1.7-7.8-1.5 3.4 3zm.4-.3 5.2-6-4.3 1.5zm-5.6 6.4 5.2-6-4.3 1.5zm5.3-5.9-5.2 6 4.3-1.5zm5.6-6.4-5.2 6 4.3-1.5zm-5.6 6-2.6-7.6-.9 4.5zm2.7 8-2.5-7.5-.9 4.5zm-2.4-7.6 2.6 7.5.9-4.5zm-2.7-8 2.5 7.5 1-4.5z"
    }),
    /* @__PURE__ */ jsx170("path", {
      fill: "#171796",
      d: "M297.5 87.4 272.1 73 253 94.9l12.6 49.6a219.8 219.8 0 0 1 36.1-6z"
    }),
    /* @__PURE__ */ jsx170("path", {
      fill: "red",
      d: "M262.5 132.2a232.3 232.3 0 0 1 38.2-6.4l-1-12.9a245.6 245.6 0 0 0-40.4 6.7zm-6.3-25a258 258 0 0 1 42.4-7l-1.1-12.7a270.7 270.7 0 0 0-44.5 7.4z"
    }),
    /* @__PURE__ */ jsxs145("g", {
      transform: "translate(-160) scale(.00237)",
      children: [
        /* @__PURE__ */ jsx170("path", {
          fill: "#0093dd",
          d: "m212105 36890-23 13-9517-7794-9497 7778 1788 21560c2543-210 5113-322 7709-322 2608 0 5190 113 7744 325l1795-21560z"
        }),
        /* @__PURE__ */ jsxs145("g", {
          id: "hr_svg__a",
          children: [
            /* @__PURE__ */ jsx170("path", {
              d: "M202545 46585c-18-2-44 10-69 45-186 250-359 469-545 720-195 61-242 180-167 348-261-26-291 193-302 432-250-379-522-482-814-307-11-230-187-338-439-392-180-10-319-65-436-145-60-42-110-64-170-106-126-88-226-5-172 74 267 434 535 868 802 1302-14 80 6 151 88 204 47 133 93 265 140 397-11 38-21 75-32 113-221-105-443-118-664-133-170-8-287-50-361-137-54-63-91-26-92 82-3 534 162 1014 599 1492-231 4-462 11-694 21-79 6-95 39-73 104 126 304 339 579 822 766-208 112-327 285-357 520-9 224-75 382-212 455-60 32-81 65-24 106 253 185 565 193 895 112-157 270-226 553-198 850 208 56 412 15 614-52-29 61-44 175-52 309-7 115-41 229-104 343-32 33-65 84 4 102 336 91 648 52 915-47 0 243 2 487 76 727 18 58 70 102 125 26 155-214 322-396 527-517 31 90 75 168 156 215 96 55 147 170 153 343 0 30-2 60 35 90 149 7 514-380 589-597 206 121 284 246 439 461 55 76 99 29 128-25 62-243 67-481 66-724 267 99 579 138 915 47 69-19 36-70 4-102-62-114-105-250-113-365-9-133-14-226-43-287 202 68 405 108 614 52 29-297-53-579-211-850 330 80 655 73 908-112 57-41 35-74-24-106-136-73-203-231-212-455-30-235-149-409-357-520 483-187 696-463 822-766 22-66 6-99-73-104-231-10-480-24-711-27 437-478 606-961 604-1495-1-108-38-146-92-82-74 87-179 137-348 146-222 15-435 24-656 128-11-38-21-75-32-113 46-132 106-260 153-393 82-53 102-123 88-204 267-434 513-868 781-1302 54-79-46-162-171-74-60 42-110 64-170 106-117 80-257 134-437 145-251 54-417 167-428 397-293-175-564-73-814 307-11-239-41-457-302-432 75-168 17-291-178-352-186-250-458-470-644-720-31-35-51-47-69-45z"
            }),
            /* @__PURE__ */ jsxs145("g", {
              fill: "#f7db17",
              children: [
                /* @__PURE__ */ jsx170("path", {
                  d: "M205075 47978c-51-26-124 17-162 95s-33 170 19 196c40 20 84-6 119-56l22-36c2-3 4-6 5-9 38-78 49-163-2-188zm-5008 0c52-26 124 17 162 95s39 165-13 191-103-24-141-102-60-158-9-184zm4539 905c-32 0-59 27-59 59s26 59 59 59 59-26 59-59c0-32-26-59-59-59m-4032 0a59.1 59.1 0 1 0 .2 118.2 59.1 59.1 0 0 0-.2-118.2m4294-304c-754-91-1506-133-2260-133s-1509 41-2269 115c-26 8-21 90 14 86 756-73 1507-113 2256-113 743 0 1485 40 2228 129 39 4 54-80 32-84z"
                }),
                /* @__PURE__ */ jsx170("path", {
                  d: "M200319 48495c768-75 1530-117 2289-116 754 0 1507 42 2261 133l111-184c-32 10-62 9-90-5-76-38-92-161-36-274 56-114 164-175 240-138 39 19 62 62 68 114l446-739c-204 130-328 214-581 252-281 41-409 139-368 307 38 156-57 133-201 54-314-171-541 71-652 353-73 186-159 181-168-13-4-70 0-131-7-200-21-223-89-286-216-224-161 78-175 25-137-58 28-60 86-128 66-221-9-67-66-92-151-98-182-244-467-483-649-727-182 244-374 483-556 727-86 5-142 30-152 98-20 93 52 157 80 217 38 82 23 135-137 57-127-61-186-3-207 220-7 69-10 139-13 209-9 194-95 199-168 13-111-282-352-524-667-353-145 79-203 102-182-54 23-172-107-266-388-307-253-37-377-122-581-252l419 682c12-25 29-45 53-57 76-38 184 24 240 138 56 113 40 237-36 274-10 5-21 8-32 10l100 163zm4389 911c-7 3-7 4-24 11-46 19-80 66-134 124-57 60-128 125-211 188-12 10-25 19-44-6s-7-35 6-44c80-62 149-124 204-182 30-32 56-63 77-92-95-11-190-21-284-30-79 24-157 55-222 95-59 35-107 77-137 125-8 14-16 27-44 11-27-16-19-30-11-44 35-58 91-107 158-147 33-20 69-38 106-54-107-9-214-18-321-25-22 13-42 29-61 47-20 19-39 42-56 67-9 13-18 26-44 8s-18-31-8-44c19-29 41-54 64-77l9-9c-80-5-161-10-241-14-2 2-5 5-8 7a340.4 340.4 0 0 0-93 126c-6 15-12 29-41 18-29-12-23-26-17-41 12-29 27-55 45-81 8-11 18-22 27-33-115-5-230-9-344-12-4 5-9 8-14 11-25 15-47 32-66 51s-35 40-48 63c-8 14-16 28-43 12-28-16-20-29-12-43 16-28 35-54 59-77 7-7 14-13 21-19-122-2-244-4-365-4-120 0-240 1-360 3 8 7 15 13 22 20 23 23 42 49 59 77 8 14 16 27-12 43s-35 2-44-12c-13-23-29-44-48-63s-41-36-66-51c-6-3-12-7-15-12-115 2-230 6-345 11 11 11 20 23 29 35 19 25 33 52 45 81 6 15 12 29-17 41s-35-3-41-18c-9-24-22-46-38-67-15-21-34-41-55-59-4-3-7-6-10-10-81 4-162 8-243 13 4 4 9 8 13 12 24 23 45 48 64 77 9 13 18 26-8 44s-35 5-44-8c-18-26-36-48-56-67s-41-35-64-49c-1-1-3-2-5-3-110 7-220 14-330 23 43 18 85 38 122 61 67 40 124 89 158 147 8 14 16 27-11 44-27 16-35 3-44-11-29-48-78-90-137-125-72-44-159-77-246-102h-2c-90 7-179 15-268 24 22 33 51 68 86 106 55 58 124 120 204 182 13 9 25 19 6 44s-32 15-44 6c-83-64-155-128-211-188-37-38-99-111-135-140-196-90-354-127-575-147-153-14-318-9-458-79 36 85 75 164 126 229 53 68 120 121 209 147 8 2 21 16 22 25 28 157 84 286 169 386 52 60 114 110 188 149-75-81-132-166-172-251-67-142-90-286-77-420 1-16 3-32 34-29 32 3 30 19 29 35-11 123 9 256 72 387 56 118 159 237 291 346 24 19 0 63-29 55-154-44-290-123-383-231-89-104-149-237-180-397-94-32-165-90-222-164-47-60-85-131-118-205 28 428 182 801 456 1137 61 75 165 182 255 216 92 35 95 100-20 101-34 1-69 1-105 1 84 31 164 66 233 105 127 73 217 162 224 273 1 16 2 32-29 34-32 2-33-14-34-29-6-86-82-160-192-223-113-65-259-117-402-160-154 0-312-1-459 3 39 28 80 57 131 84 82 44 188 86 343 122 89 21 166 52 233 91 71 42 130 93 177 150 10 12 20 25-5 45s-34 8-45-5c-42-52-95-98-159-135-61-36-133-64-216-84-161-38-272-81-358-128-75-40-131-82-184-123 180 393 450 573 835 689 23 7 43 13 61 19 3 1 6 1 9 2 86 21 175 40 266 55 92 15 166 28 261 37 16 1 32 3 29 34-3 32-19 30-34 29-99-9-174-22-266-38-58-10-115-21-171-33-26 6-64 9-107 12-232 14-420 225-435 494 0 5 0 11-1 16 88-80 179-157 273-212 117-68 239-103 364-69 15 4 31 8 22 39-8 31-23 27-39 22-106-28-212 3-316 63-108 63-213 158-315 253-24 147-82 285-205 377 61 34 104 65 163 45 86-39 172-78 261-108 91-31 184-52 282-57 16-1 32-1 33 31s-14 32-31 33c-91 4-179 24-264 53-75 26-149 58-222 91 221 47 460-1 667-79 60-22 105-42 133-41 51-30 112-53 172-79 66-28 132-51 182-57 16-2 32-4 35 28 4 32-12 33-28 35-112 13-127 21-222 79 0 21-66 57-126 96-36 24-70 52-87 67-95 86-144 181-188 287-29 70-52 145-68 224 55-108 121-211 201-303 94-108 208-201 345-265 14-7 29-13 42 15 13 29-1 35-15 42-129 60-236 147-324 250-90 103-161 222-219 345-31 64-8 1-42 86 110-122 212-224 323-307 132-100 283-157 418-133 15 3 31 6 26 37s-21 28-37 26c-116-21-250 32-369 121-121 92-244 223-366 361 184 26 366-26 542-85 91-30 183-135 239-152 19-24 38-46 57-67 33-37 67-71 102-100 12-10 24-20 45 4s8 34-4 45c-33 28-65 60-96 94-32 35-62 73-92 113-6 8-13 17-24 16-60 70-151 162-172 240-57 210-25 370-122 576 71-38 128-81 175-134 53-60 94-135 128-230 37-104 95-195 167-270 75-77 165-136 261-172 15-5 30-11 41 19s-4 35-19 41c-87 32-169 86-238 157-66 68-119 151-153 247-37 102-81 183-141 250-44 50-95 91-156 127 52-3 78-10 121-7 79-6 211-66 279-119 66-51 116-120 154-206 6-15 13-29 42-16s23 27 16 42c-42 96-99 174-173 231-56 43-121 75-196 93 161-5 311-42 467-100 65-24 87-168 127-208 32-58 66-112 105-158 47-56 101-101 164-127 15-6 29-12 41 18 12 29-3 35-17 41-52 21-98 60-139 108-36 42-68 93-98 147 10 73-51 228-53 305-7 205-2 409 53 612 53-71 107-134 162-192 0-5 0-10 1-15 18-106 33-219 40-332 7-112 7-223-6-329-2-16-4-32 27-35 32-4 34 12 35 28 14 111 14 226 7 340-6 90-16 180-30 269 54-51 53-51 77-103 37-80 59-159 67-237 9-80 5-157-13-230-4-15-7-31 24-38s35 8 38 24c19 80 25 165 14 252-8 65-24 132-49 199 56-42 114-82 178-122-4-75-5-153-3-227 2-68 7-134 18-190 4-20 7-40 47-33s37 27 33 48c-9 50-14 111-16 177-2 78 0 162 4 243 5 82 49 185 125 230 103 62 158 163 186 274 16-145 17-280 3-400-17-143-55-267-114-368-8-14-16-27 12-44 27-16 35-2 43 12 63 110 104 241 122 393 17 146 13 310-13 488 102-82 381-258 352-594-7-27-16-52-28-75-7-14-14-28 14-42s35 0 42 14c17 33 30 69 39 110 5 24 8 49 11 76 13-7 45-43 51-39 24 16 58 38 80 54-21-60-35-120-42-178-10-87-5-172 14-252 4-15 7-31 38-24s27 23 24 38c-18 73-22 151-13 230 9 77 31 157 67 237 4 8 8 16 5 25 24 21 47 42 70 65-13-84-22-170-28-255-8-115-7-230 7-341 2-16 4-32 35-28s29 20 27 35c-13 106-13 217-6 329 7 113 22 225 40 332 1 2 1 5 1 7 54 59 95 120 152 196 55-203 73-407 66-612-2-76-69-227-65-302-30-55-63-107-100-151-41-49-87-87-139-108-15-6-29-12-18-41 12-29 27-24 41-18 62 26 117 71 164 127 38 45 72 98 103 154 57 7 78 179 143 212 154 57 298 94 453 100-75-19-140-50-195-93-74-57-131-135-173-231-6-15-13-29 16-42s35 2 42 16c38 86 88 156 154 206 85 66 289 124 400 127-61-37-113-78-157-128-59-67-104-148-141-250-34-95-87-179-153-247a642 642 0 0 0-238-157c-15-6-29-11-19-41 11-29 26-24 41-19 96 36 186 94 261 172 72 74 130 166 167 270 34 95 75 169 128 230 47 54 105 98 177 135-98-207-66-367-122-577-35-129-232-277-193-320 45-51 133 88 248 127 175 59 357 111 540 85-122-138-244-269-366-361-119-90-237-140-352-120-16 3-31 6-37-26-5-31 10-34 26-37 135-24 269 32 401 132 111 84 201 175 311 298-18-47 0-14-30-77-59-123-130-241-220-345-89-102-196-189-324-250-14-7-28-13-15-42 13-28 28-22 42-15 137 65 251 157 345 265 81 93 147 198 203 307-15-81-39-157-68-227-44-106-93-201-188-287-62-56-209-140-208-179-29-15-33-11-63-24-61-26-121-46-164-52-16-2-32-4-28-35 4-32 19-30 35-28 50 6 115 28 182 56 33 14 66 43 98 60 53 4 139 47 208 74 206 78 446 126 666 79-73-33-147-65-223-91-85-29-172-49-264-53-16-1-32-1-31-33s17-31 33-31c98 4 191 26 282 57 89 30 175 69 261 108 59 27 101-7 163-45-123-92-181-230-205-376l-2-2c-102-95-207-190-315-253-104-60-210-91-316-63-15 4-31 8-39-22-8-31 7-35 22-39 125-33 247 1 364 69 94 55 186 132 274 213 0-6-1-11-1-17-15-270-203-480-435-494-78-5-189 21-186-32 4-59 97-44 234-86 385-116 655-296 836-690-54 41-110 83-186 124-86 47-198 91-358 128-82 19-154 48-216 84-64 38-117 84-159 135-10 12-20 25-45 5s-14-32-5-45c47-57 106-108 177-150 67-39 145-70 233-91 155-36 261-78 343-122 51-27 92-55 131-84-148-4-305-3-459-3-143 44-289 96-402 160-110 63-186 136-192 223-1 16-2 32-34 29-32-2-31-18-29-34 8-111 97-200 224-273 69-39 149-74 233-105-35 0-70 0-104-1-116-2-112-66-20-101 90-34 190-141 251-216 271-334 412-714 456-1130-33 72-69 140-115 198-57 73-128 131-222 164-31 160-91 293-180 397-92 108-216 185-369 230-29 8-52-35-29-55 132-109 221-226 278-344 62-131 83-264 72-387-1-16-3-32 29-35 31-3 33 13 34 29 12 134-10 278-78 420-40 85-97 170-172 251 73-39 136-89 187-149 85-100 141-229 170-386 1-8 14-22 22-25 89-27 155-79 209-147 51-65 90-143 126-228-140 69-304 64-457 78-213 19-369 68-554 152z"
                }),
                /* @__PURE__ */ jsx170("path", {
                  d: "M204649 49231c-680-88-1359-113-2041-114-684 0-1369 40-2058 112-20 6-15 33-14 46 2 28 37 35 121 27 643-60 1285-93 1932-93 674 0 1351 21 2038 102 33 9 77-85 22-81z"
                }),
                /* @__PURE__ */ jsx170("path", {
                  fillRule: "evenodd",
                  d: "M200570 49160c683-71 1362-110 2038-110 675 0 1349 40 2025 127l31-127c-17 9-37 15-58 15a123 123 0 1 1 113-171l60-170c-724-84-1446-122-2171-122-729 0-1459 38-2193 107l58 164c22-32 59-54 101-54a123 123 0 1 1 0 246c-12 0-25-2-36-6l33 94-2 7zm3067-416a123 123 0 1 0 0 246 123 123 0 1 0 0-246m0 64a59.1 59.1 0 0 0 0 118c32 0 59-27 59-59s-26-59-59-59m-1082-91a123 123 0 1 0 123 123c0-68-55-123-123-123m0 64a59.1 59.1 0 1 0 .2 118.2 59.1 59.1 0 0 0-.2-118.2m-1064-40a123 123 0 1 0-.2 245.8 123 123 0 0 0 .2-245.8m0 64c-33 0-59 26-59 59s26 59 59 59a59.1 59.1 0 0 0 0-118"
                })
              ]
            }),
            /* @__PURE__ */ jsx170("path", {
              d: "M202601 47974c-14-68-49-129-100-175-51-47-116-78-187-88-33-4-39-58-7-68 60-20 114-67 157-133 45-69 79-157 95-256 5-34 64-35 69-1 15 84 51 153 97 208 55 66 125 112 193 138 31 12 25 63-8 68-59 9-105 42-141 87-50 62-81 145-100 221-8 33-62 31-69-2zm33-118c20-52 47-103 81-146 28-34 60-64 99-84-51-30-100-70-143-120-28-34-53-73-73-116-19 59-45 112-75 158-31 47-67 86-108 116 50 19 95 47 134 82 34 31 63 68 85 110m799 5115-515 206c-17 7-35 14-48-21-14-34 4-41 21-48l515-206c17-7 35-14 48 21 14 34-4 41-21 48m59-326-604 328c-16 9-33 18-51-15s-1-42 15-51l604-328c16-9 33-18 51 15s1 42-15 51m-1826-65 604 328c16 9 33 18 15 51s-34 24-51 15l-604-328c-16-9-33-18-15-51s34-24 51-15m51 322 515 206c18 7 35 14 21 48-14 35-31 28-49 21l-515-206c-17-7-34-14-21-48 14-35 31-28 48-21zm224 434c137 33 261 48 358 31 88-16 155-60 191-146v-493c-107-1-212-15-303-41-109-31-170-98-201-178-41-107-27-235-4-329 5-18 9-36 45-27s32 27 27 45c-20 82-33 194 1 284 23 60 69 110 152 133 91 25 198 38 307 38 107 0 214-13 304-40 82-24 148-69 192-123s65-117 57-176c-5-36-24-62-49-80-34-24-82-35-128-37-47-2-94 7-142 16-25 5-50 9-77 13-19 2-37 5-42-32s14-40 32-42c23-3 48-8 73-12 52-10 105-20 159-18 60 2 121 18 168 51 42 29 72 72 80 131 11 80-16 163-73 233-53 65-131 119-229 147-83 24-178 38-274 42v483c3 5 3 11 2 16 37 82 102 125 188 141 97 18 221 2 358-31 18-5 36-9 45 27 8 37-9 41-28 45-146 35-279 51-388 32-92-17-165-58-215-132-49 74-124 115-215 132-109 20-242 4-388-32-18-4-37-8-28-45 8-36 27-32 45-27zm356 210 402-9c19 0 38-1 38 37 1 38-18 38-37 38l-402 9c-19 0-37 1-38-37s18-38 37-38m593-3082c151-125 293-227 423-297 133-72 254-111 359-106 19 1 37 1 36 39-1 37-20 37-39 36-92-4-200 32-322 97-125 67-263 166-410 289-14 12-29 24-53-5s-9-41 5-53zm-605 56c-141-130-298-240-445-314-139-71-268-108-363-100-19 2-37 4-40-34-4-37 15-39 34-40 110-10 252 31 404 107 152 77 315 191 461 325 14 13 28 25 2 53-25 27-39 15-53 2zm-213 1004c37-83 83-155 136-219 53-63 112-119 174-170 14-12 29-24 52 5 24 29 9 41-5 53-59 48-114 101-164 160-49 59-91 125-125 201-8 17-15 34-49 19s-27-32-19-49m371-1734c49 66 88 139 114 223 26 82 40 175 39 279 5 80 6 165-7 249-13 86-42 170-97 246-43 60-101 97-165 113-53 13-109 10-164-7 29 100 51 208 6 308-8 18-33 27-51 18-43-22-86-43-128-62s-84-36-127-51l-1-1c-95-37-173-73-236-112-65-39-115-80-150-124l1 2c-44-49-72-106-88-170-14-55-20-114-22-174-72-39-138-78-194-116-64-43-118-87-161-131-13-14-26-27 1-53s40-12 53 1c39 40 89 80 150 121 60 40 128 81 204 121 124 13 247 51 370 109 106 50 211 115 317 192 13 7 19 16 27 20 8 6 16 13 25 19 51 22 104 28 152 16 47-11 90-39 122-84 48-66 72-139 84-214 12-77 11-157 6-234v-2c1-97-12-183-35-258-24-76-58-142-102-201-11-15-22-30 7-52s41-7 52 7zm-375 1047c-104-77-207-141-311-190-105-49-210-83-314-98 2 48 8 93 18 135 13 52 35 99 71 138l1 1c30 37 73 72 130 107 60 36 134 71 225 106l-1-1c45 16 89 34 133 54 31 14 61 28 93 44 19-83-10-179-37-267-2-8-5-15-9-29zm776-1003c-44 59-79 125-102 201-24 76-36 161-35 258v2c-5 77-6 158 6 234 12 75 37 148 84 214 32 45 75 72 122 84 48 12 101 6 152-16l25-19c6-4 13-12 27-20 105-77 211-143 317-192 123-58 246-95 370-109 75-40 144-80 204-121s111-81 149-121c13-13 26-27 53-1s14 39 0 53c-43 44-97 88-161 131-57 38-122 77-194 116-2 61-8 119-22 174-16 63-44 121-88 170l1-2c-35 44-85 85-150 124-63 38-141 75-237 112l-1 1c-43 15-85 32-127 51-43 19-85 40-128 62-18 9-43 0-51-18-45-100-23-208 6-308-55 18-111 20-164 7-64-15-122-53-165-113-55-76-84-160-97-246-13-85-12-169-7-249-1-104 13-196 39-279 26-84 65-158 114-223 11-15 22-30 52-7 30 22 19 37 7 52zm940 715c-105 15-209 49-314 98-104 49-207 113-311 190-4 13-6 21-8 29-27 88-56 184-37 267 31-15 62-30 93-44 44-20 87-38 133-54l-1 1c91-35 165-70 225-106 58-34 100-70 131-107l1-1c35-39 57-86 71-138 11-42 16-87 19-135z"
            }),
            /* @__PURE__ */ jsx170("path", {
              fillRule: "evenodd",
              d: "M203459 50602a216.4 216.4 0 0 0 0 433 216.6 216.6 0 0 0 0-433m0 69c-81 0-147 66-147 147s66 147 147 147 147-66 147-147-66-147-147-147m0 60a87 87 0 1 0 .1 174.1 87 87 0 0 0-.1-174.1m-1697-124c119 0 217 97 217 216s-97 217-217 217a216.6 216.6 0 0 1 0-433m0 69c81 0 147 66 147 147s-66 147-147 147-147-66-147-147 66-147 147-147m0 60a87 87 0 1 1-.1 174.1 87 87 0 0 1 .1-174.1"
            })
          ]
        }),
        /* @__PURE__ */ jsx170("use", {
          xlinkHref: "#hr_svg__a",
          width: "100%",
          height: "100%",
          transform: "rotate(-2.2 -55532.8 156275.8)"
        }),
        /* @__PURE__ */ jsx170("use", {
          xlinkHref: "#hr_svg__a",
          width: "100%",
          height: "100%",
          transform: "rotate(2.2 459865.8 156275.8)"
        })
      ]
    }),
    /* @__PURE__ */ jsx170("path", {
      fill: "#171796",
      d: "m387.2 94.9-19.3-22-25.2 14.5-4.3 51.1a219.7 219.7 0 0 1 36.2 6z"
    }),
    /* @__PURE__ */ jsx170("path", {
      d: "M347.7 98c.8-.2 1.7-.2 2.6.3.3.1.6.3.8.6.4-.3.7-.6 1.2-.8a4 4 0 0 1 1.8-1c.9-.5 1.8-.8 2.7-.9h2.8c.8 0 1.6.2 2.3.6l2 1c.8.4 1.5.8 2.2 1a9.1 9.1 0 0 0 4.5.5c.4-.2.7.1.2.4-3.3 2-5.9.2-8.1-.6a16.2 16.2 0 0 1 2.1 1.7c.8.8 1.8 1.6 3.5 2.4a8.4 8.4 0 0 0 5 .7l.4.1-.1.5a4.8 4.8 0 0 1-2.6.7 10 10 0 0 1-5.2-1.3c-1.4-.7-2.3-1.6-3.3-2.4a7.5 7.5 0 0 0-3-1.4 6 6 0 0 0-2.9 0c.3.1.5.2.6.4.5.3 1 .4 2 .5.4 0 .2.3-.5.7a2 2 0 0 1-1.6.8c-1 .6-1.3.2-1.7-.2 0 .3 0 .5-.2.8a.6.6 0 0 1 0 .4l.2.7c0 .2 0 .3.2.4.2.2.3.4.3.7 0 .2.1.3.3.4l.6.6c.6.2.8.7 1 1.2.4.2.6.5.7.9.2 0 .4.2.6.4l2.6.1c.8.1 1.4.6 2 1.2h1.2a4 4 0 0 1 1.3-.3h2.3c.5.2.9.4 1.2.8.5.5 1.2.4 1.8.2a2.7 2.7 0 0 1 2.4 0 2.3 2.3 0 0 1 1-.2c.4-.3.7-.4 1-.4.6 0 1 0 .9.8 0 .2-.2.4-.3.4-.3.6-.7.7-1.3.7-.1.4-.3.7-.5.8.3.9 0 1.3-.7 1.2 0 .3-.3.4-.6.4a1.4 1.4 0 0 1-1 .5l.4.6c.4.7-.2 1-.8 1v1.2c.7.4.8.8.2 1.2.4.7.3 1.3-.5 1.6 0 .4 0 .8-.3 1-.2.2-.5.3-.3.6.3.5.2 1.1-.2 1.2l-.2.1-.2.2a9.6 9.6 0 0 0-1.5 1c-.1 0-.2.1-.2 0a9.6 9.6 0 0 1-1.8 2.4c0 .5-.4 1-1 1.1a.4.4 0 0 1-.3.4c.3.3.5.6.2 1a3 3 0 0 1-1.3.8c-1 .3-1.7.2-2-.2-.4-.3-.3-.6 0-.7-.7 0-.8-.2-.8-.7 0-.2.1-.2.3-.1.4 0 .7-.2 1-.3l.5-.6c0-.7.5-1 1.1-1.3.5-.2 1-.6 1.4-1.2l.9-1.5a1.2 1.2 0 0 1-.3-.7 1.5 1.5 0 0 1-.5-.6c-.5 0-.7-.2-.7-.5a1.1 1.1 0 0 1-.3 0c-.3.1-.5.3-.7.2a6.9 6.9 0 0 1-1.1 1c-.2.3-.4.5-.7.5-1 .1-1.5 1.2-2 1.7-.2.1-.3.4-.4.7 0 .6-.1 1-.4 1h-.4a1.2 1.2 0 0 0-.4 0c.3.3.3.6 0 .9-.1.3-.4.4-.8.4a3.6 3.6 0 0 1-1.6-.2c-.4-.2-.5-.5-.5-.7-.3-.2-.4-.3-.3-.5 0-.2.2-.3.4-.2l.6-.2a5.2 5.2 0 0 1 1.8-1.4 3 3 0 0 1 .7-.7c0-.5.5-1 1-1.4l.1-.6v-.3c-.2-.3-.3-.7-.1-1a1.3 1.3 0 0 1 0-.6c-1.1.6-1.5.4-1.6-.1-.4.3-.8.5-1 0-.4.1-.8.3-1.2.1l-.8.2-.4.7c0 .5-.2 1-.5 1.5a9.3 9.3 0 0 1-.7 1.5 1 1 0 0 1-.1.5c0 .6-.2.9-.5 1a2.4 2.4 0 0 1-.4.8v.2c.1.3.1.7-.2 1l-1 .6h-1c-.4-.3-.4-.4-.3-.6a.6.6 0 0 1-.5 0l-.4-.3c-.1-.2-.1-.4.1-.5l.9-.6c0-.2.2-.3.4-.4.2-.4.4-.6.6-.7l.7-1.5c.1-.1.2-.3.1-.4l.1-.3s.2-.1 0-.2a1.4 1.4 0 0 1 .2-1.2c.3-.4.6-1.4.3-2v-.8h-.3c-.2-.2-.4 0-.6.2l-.4.6c-.1.8-.5 1.5-1 1.6v1.2c0 .4 0 .7-.2.7s-.4.2-.5.5a1 1 0 0 0-.1.3c.3.3.2.7-.1 1-.6.6-1.4.5-2.2.3-.6-.3-.8-.5-.7-.8-.8 0-.7-.7 0-.9.8-.2 1.4-.7 1.9-1.4 0-.8.2-1.3.7-1.4 0-.5.2-1 .4-1.4.2-.4.3-.8.2-1.3-.4-.3-.4-.6 0-1 .1 0 .1 0 0-.2-.3 0-.3-.3-.3-.5s0-.2-.2-.2c-.6-.1-.5-.4-.2-.7.1 0 .2-.3 0-.4l-.1-.4c-.4-.3-.2-.6 0-.9l-.4-.8c-.7 0-1-.4-.6-.9a3.4 3.4 0 0 1 .7-.6c.1-.3.3-.6.2-.8-.2-.6.5-1 1-1.4a.9.9 0 0 1-.1-.4c-.3-.3-.2-.6.1-.8a1 1 0 0 1-.1-.5c-.8.2-.8-.3-.4-1-.5-.3-.4-.8.5-1.5a1 1 0 0 1 0-.4 2 2 0 0 0-1 .3c-.3.3-.6.2-.9.1a1.5 1.5 0 0 0-.4-.4.6.6 0 0 1-.2-.6c-1 0-1.1-.7-.6-1 .3-.3.6-.6.7-.9.2-.6.7-1 1.3-1.5v-.5a1.6 1.6 0 0 0-.7-.3 1.2 1.2 0 0 0-.6-.7c-.1 0-.2-.2 0-.4-.6-.4-.5-.7-.3-1"
    }),
    /* @__PURE__ */ jsxs145("g", {
      fill: "#f7db17",
      children: [
        /* @__PURE__ */ jsx170("path", {
          d: "M364.5 122a1.4 1.4 0 0 1-.2 0 8.4 8.4 0 0 1-.8.7c-.2-.3-.5 0-.2.1l-.2.2c0 .3-.2.4-.5.4h-.1a3 3 0 0 1 0-.3 3.5 3.5 0 0 1 0-.4 3.9 3.9 0 0 0-.1.4 2.8 2.8 0 0 0 0 .4c-.8.3-1.3 1.1-1.9 1.7l-.4.8c0 .2 0 .9-.3.9h-.2c0-.1-.2-.1-.4 0h-1c-.2.2.4.2.7.3.1.1.2.3.1.5-.2.7-1.8.5-2.3.2-.2-.1-.2-.3-.2-.5h.3c.2 0 .4 0 .5-.2 0 0 .1 0 0-.1 0-.1 0-.1 0 0a1.3 1.3 0 0 1-.5 0 2.6 2.6 0 0 1-.5 0h-.2c0-.1.2 0 .2 0l.7-.3a5.3 5.3 0 0 1 1.9-1.4l.8-.7c0-.7.4-1 .8-1.5l.3-.7v-.3c-.2-.4-.3-.7-.1-1a1.5 1.5 0 0 1 0-.8.3.3 0 0 0 0-.1 6.2 6.2 0 0 1 .8-.6v.8a1.3 1.3 0 0 0-.2.3.5.5 0 0 0 0 .2v.1a.4.4 0 0 1 0-.3l.3-.2.7-.4.7-.6v1l-.6.7v.1h.1a2.3 2.3 0 0 1 .5-.7 3.2 3.2 0 0 1 1-.6v1a1.5 1.5 0 0 0 .5.9"
        }),
        /* @__PURE__ */ jsx170("path", {
          d: "m349 113 .2-.2.4-.6a4 4 0 0 1 .5-.6 4 4 0 0 0-.4.7 5.8 5.8 0 0 0-.4.5v.2c.1.3.1.5.3.7l.3-.4a1.6 1.6 0 0 1 .4-.4 1.8 1.8 0 0 0 .5-.6h.1l-.2.4a2 2 0 0 1-.3.3l-.4.3a1.3 1.3 0 0 0-.2.4v.3c-.2.3-.5.5 0 .7a.6.6 0 0 0 .1.5l-.1.7c-.3.2 0 .2.1.2l.4-.4a4.3 4.3 0 0 1 .3-.4l.4-.5.1-.5h.1a1.4 1.4 0 0 1-.1.6 2 2 0 0 1-.5.5 3.8 3.8 0 0 0-.2.4 2.6 2.6 0 0 0-.3.4c.2.1.2.4.2.7h.1l.2-.2.2-.4h.1l-.2.4-.2.3c.2.1.2.3 0 .5-.4.3-.3.4 0 .7v1.2l.1.3h-.1v-.3c-.4.7-.6 1.1-.7 1.8-.6.1-.5.8-.6 1.3a3.9 3.9 0 0 1-1.9 1.5c-.1 0-.5.1-.5.3 0 .1.2.3.4.2.4-.5.7-.2.2.2v.3c.5.4 1.6.5 2.2.2.3-.3.5-.5.2-.9 0-.5.2-1 .8-1.2v-.4l.1-1.3.2-.1c.2 0 .6-.7.7-1.3v-.4c.1-.2.2-.2.3 0 0-.2 0-.3.2-.4.2-.3.5-.6.8-.4a3 3 0 0 1-.1-.8 2.7 2.7 0 0 1 0-1l.2-.2.3-.7.3-.7h.1l-.3.7-.3.8v.1a2.5 2.5 0 0 0-.1 1l.2.9.2.4v.6c.4.6 0 1.7-.3 2.2a1 1 0 0 0-.1.8c.2.2 0 .4-.1.6v.1c0 .2 0 .4-.2.5l-.7 1.6c-.4.1-.5.3-.6.7-.3.1-.3.2-.4.4a2.7 2.7 0 0 1-.9.6c-.3.1 0 .2.2.4.2.1.4-.2.6-.4.2-.3.3-.2.2 0a2 2 0 0 0-.2.7l.7.3c.4 0 .9-.4 1.2-.6.3-.2.2-.5.1-.8a2 2 0 0 1-.5 0 3.4 3.4 0 0 1-.5-.3 2.8 2.8 0 0 0 1 .2v-.3a2.7 2.7 0 0 0 .5-.8c.4-.2.4-.4.4-.9l.1-.5a10 10 0 0 0 .7-1.6c.4-.4.5-.9.5-1.4 0-.2.1-.3.3-.3a3.8 3.8 0 0 0 .3-.5l.1-.4a.8.8 0 0 1 .2-.2 1 1 0 0 0 0-.5 1.1 1.1 0 0 0-.1-.4.5.5 0 0 1-.1-.2v-.2h.1c.1 0 0 0 0 0v.1a.5.5 0 0 0 0 .2c.2.2.2.3.2.5a1 1 0 0 1 0 .5.7.7 0 0 0-.2.2 1.7 1.7 0 0 0 0 .3l.6-.1.4-.5.2-.6c.1 0 0 0 0 0a2 2 0 0 1-.1.7l-.3.3c.4.2.7 0 1 0V119l.4-.7c.1 0 .1 0 0 0l-.2.8v1c.1.4.2.5.5.3l.4-.2v-.1a18.2 18.2 0 0 1 1.8-1.6c.1.1 0 .1 0 .1a6.5 6.5 0 0 0-.8.7l-.8.7v.3c0 .3.1.5.6.3l.6-.2a1.3 1.3 0 0 1 .3-.2 8 8 0 0 1 .5-.3l.5-.3a3 3 0 0 1 .1-.6l.7-1.3a2.3 2.3 0 0 0 1.1-1.1h.1l-.4.7a2.5 2.5 0 0 1-.7.5l-.7 1.2a2.7 2.7 0 0 0-.1.5v.1a2.8 2.8 0 0 0 0 .8c.2 0 .4 0 .7-.3l.7-.7a1.7 1.7 0 0 1 .2-.5 1 1 0 0 1 .4-.4h.1v.1a.9.9 0 0 0-.4.3 1.7 1.7 0 0 0-.2.5v1.1l1-.5v1c0 .3.2.6.4.8a2.8 2.8 0 0 1 .5-.6l.3-.3.2-.2.3-.2-.2.3-.2.2-.3.2v.5h.6c0 .5 0 .6.5.6a3.2 3.2 0 0 1 0-.5l.1-.5h.1a1.9 1.9 0 0 0-.1.5 3.1 3.1 0 0 0 0 .5c.2.3.3.4.7.6l.2-.5a1.4 1.4 0 0 0 0-.4h.1v.5l-.3.5v.5a3 3 0 0 1 .2-.3l.3-.4c.1 0 .1 0 0 0 0 .2 0 .3-.2.4a4 4 0 0 0-.2.4l.2.2c-.6 1-1.3 2.5-2.5 3-.6.2-.9.5-1 1.2a1 1 0 0 0-.5.6l-1.2.3c0 .3 0 .4.3.4l.7-.3c.1 0 0 .5-.5.8v.1c.4.6 1.4.4 1.9.2.4 0 1-.5 1.2-.9.1-.2 0-.4-.2-.6-.8.1-.6-.6 0-.3.2 0 .3 0 .3-.3.6-.2.9-.5 1-1 .6-.7 1.2-1.4 1.6-2.1.1-.2.2-.4.1-.5a1 1 0 0 0 .2-.5l.1-.4h.1v.5a4.5 4.5 0 0 1-.2.3c0 .1 0 .2.2.2l1.5-1c0-.3.2-.4.4-.4l.2-.1c.1-.4 0-.6-.2-.8-.1-.4.1-.5.4-.7.2-.2.2-.7.2-1v-.2a2.6 2.6 0 0 0 0-.3l.1.3v.1c.3-.1.6-.3.7-.6 0-.3-.1-.6-.3-.8a9.6 9.6 0 0 1-.6.2 10.2 10.2 0 0 0 .7-.4 1.3 1.3 0 0 0 .3-.2c.2-.3-.3-.5-.5-.6l-.7-.7v-.1l.7.6v-1.1l-.2-.4a1.1 1.1 0 0 1-.5-.4 1 1 0 0 1-.1-.5l.2.4.4.4h1c.3-.3-.2-.7-.3-.9l-.1-.5h.1a1 1 0 0 0-.2-.2.6.6 0 0 0-.1 0v-.2a.7.7 0 0 1 .2.1l.2.2a.9.9 0 0 0 .1 0c.3 0 .5-.2.7-.5a3.6 3.6 0 0 0-.3-.4 10 10 0 0 0-.5-.3v-.1h.1a4 4 0 0 1 .8.8c.4 0 .4 0 .6-.3a1.5 1.5 0 0 0-.2-.4 2.5 2.5 0 0 0-.3-.4c0-.1 0 0 0 0 .2 0 .3.2.4.3l.2.5.4-.1c.3-.2 0-.8 0-1a2.8 2.8 0 0 0-.1 0l-.2-.2c0-.1 0 0 0 0h.2l.2.1.4-.6c0-.4 0-.2.5-.3.4 0 .6 0 .9-.6.1 0 .2 0 .2-.3s0-.4-.3-.4c-.5 0-.8 0-1 .3v.3c0 .1 0 0 0 0l-.2-.2c-.4 0-.7 0-1.1.2h-.2l.2.3.1.4a1 1 0 0 0-.2-.4 1.8 1.8 0 0 0-.3-.4 2.6 2.6 0 0 0-1-.2l.2.1.2.2v.1a7.7 7.7 0 0 1-.2-.2 6.5 6.5 0 0 1-.2-.2 2.7 2.7 0 0 0-.9.2l-.6.2.4.5.2.6a2.1 2.1 0 0 0-.3-.6 1.9 1.9 0 0 0-.4-.4 1.8 1.8 0 0 1-.5 0l.2.3-.3-.4a1.4 1.4 0 0 1-.5-.2 8.3 8.3 0 0 1 .2 1.5 7.8 7.8 0 0 0-.2-.9 4.7 4.7 0 0 0-.1-.7 1.7 1.7 0 0 1-.2-.2 2.1 2.1 0 0 0-.6-.4 1 1 0 0 1-.2.7c-.1 0 0 0 0 0a.8.8 0 0 0 .1-.8 3.1 3.1 0 0 0-1-.2 5.3 5.3 0 0 1 .5.8l.3.5v.5a2 2 0 0 0-.1-.5.7.7 0 0 0-.3-.4 5.6 5.6 0 0 0-.3-.5 4.6 4.6 0 0 0-.3-.4h-.4.1a.6.6 0 0 1 0 .3.5.5 0 0 0 0-.2.7.7 0 0 0-.2-.1h-.8a5 5 0 0 1 1 2.3 4.8 4.8 0 0 0-.4-1.2 5.1 5.1 0 0 0-.7-1h-.6a1.7 1.7 0 0 1 .4.4c0 .1 0 .1 0 0a1.6 1.6 0 0 0-.3-.1 2.4 2.4 0 0 0-.3-.2 5 5 0 0 0-.3 0l-.1.1a4.7 4.7 0 0 1 1 1.1c0 .1 0 0 0 0a3.8 3.8 0 0 0-.6-.6 4.7 4.7 0 0 0-.6-.4h-.6a5 5 0 0 1 .5 1.7h-.1a3.5 3.5 0 0 0-.2-.8 6.2 6.2 0 0 0-.3-.9 8 8 0 0 1-.4 0 9.1 9.1 0 0 1 .3 1.6v.1a9.3 9.3 0 0 0-.2-1 9.3 9.3 0 0 0-.3-.8 3.9 3.9 0 0 0-1.3-1 1.7 1.7 0 0 1 .4 1.1v.1a1.6 1.6 0 0 0-.2-.7 1.7 1.7 0 0 0-.4-.6 2 2 0 0 0-.3 0 15.6 15.6 0 0 0-1 0c.2.1.4.4.4.6 0-.2-.3-.5-.6-.7h-.6l.3.3.2.5.2.6.4.4s.1 0 0 0c0 .1 0 .1 0 0a1.1 1.1 0 0 1-.5-.3 1.5 1.5 0 0 1-.2-.7 1.3 1.3 0 0 0-.2-.4 2.7 2.7 0 0 0-.3-.4h-.7l.2.8.1 1h-.1a7.1 7.1 0 0 0 0-1 4.5 4.5 0 0 0-.3-.8 1 1 0 0 0-.6-.5.6.6 0 0 1 0 .3h-.1a.5.5 0 0 0 0-.3c-.2-.5-.3-.7-.6-.8v.4l-.2.4h-.1l.1-.5v-.4c0-.6-.2-1-.8-1.2v.2l-.1.5h-.1v-.5a1.9 1.9 0 0 0 0-.3l-.5-.5a2.3 2.3 0 0 1 0 .7 3 3 0 0 1-.4.8h-.1a3 3 0 0 0 .3-.8 2.2 2.2 0 0 0 .1-.8 1 1 0 0 1-.2-.3v.2h-.1v-.2l.1-.1v-.1a.7.7 0 0 0-.3-.5 1.5 1.5 0 0 1-.2.5h-.1c-.1 0 0 0 0 0l.1-.3.1-.3a1 1 0 0 1-.1-.2.8.8 0 0 1-.1.2 1.2 1.2 0 0 1-.2.2c-.1-.1 0-.1 0-.1l.1-.2a.7.7 0 0 0 .1-.2v-.2c0-.3 0-.4-.2-.7a.9.9 0 0 0-.3 0 2.8 2.8 0 0 0-.5.4v-.1a3.2 3.2 0 0 1 .4-.3.9.9 0 0 1 .4-.1.4.4 0 0 0 0-.2l-1 .3a1.6 1.6 0 0 1-.9-.2h.8c.3 0 .7 0 1.1-.2l.2-.6a1.7 1.7 0 0 1-.5 0l.6-.1v-.2c0-.2.3-.2.4 0 .2 0 .3.2.4.3.3.2.6 0 .9-.2h-.2v-.1h.3c.6 0 1 0 1.4-.5a7 7 0 0 1-1 0c-.2 0-.4 0-.6-.2l.7.1h1l.5-.3a5.4 5.4 0 0 1-2-.6 1.4 1.4 0 0 0-.6-.3c-.5 0-1 0-1.4.3l-.3-.3-.4-.2h-.6s-.1 0 0 0h1.2a4.5 4.5 0 0 1 1.7-.3 5.7 5.7 0 0 1 1.7-.2v-.2c.3-.3.4-.6.3-.9-.1-.2-.4-.5-.8-.7h-1.3a4 4 0 0 0-.8.1l.6.4.4 1v.1h-.2a2 2 0 0 0-.4-1c-.1-.2-.6-.3-.7-.4l-1.3.2-.7.4c.3-.1.6 0 .8 0 .3.2.5.4.6.8v.1h-.2a1 1 0 0 0-.5-.7c-.4-.2-1.2 0-1.6.3a4.2 4.2 0 0 0-.6.6h-.2v-.2l.7-.6.7-.4a2 2 0 0 1 1-.5l1.3-.2a1 1 0 0 0-.5-.5 1.4 1.4 0 0 0-.8 0c-.5.1-1 .4-1.5.7h.5l.1.2h-.5a1.4 1.4 0 0 0-.4 0l-1.5 1.2c-.5 0-.8 0-1 .2l-.1.6-.2.7c-.5.5-1 .9-1.3 1.5a1.4 1.4 0 0 1-.3.5.5.5 0 0 1 .3.1v-.2l.2-.4h.1a1.2 1.2 0 0 0-.1.4v.5h-.2a.3.3 0 0 0-.1-.2.5.5 0 0 0-.3 0l-.3.2-.2.3c0 .3.2.3.5.3.6 0 .1.4.4.7l.5.4h.5c0-.4 0-.6.2-.6a.8.8 0 0 1 .2-.4.8.8 0 0 0 0 .2.8.8 0 0 0-.1.2v.4a2.4 2.4 0 0 1 1-.2c.7-.8 1-.6.4 0l-.1.2a1.4 1.4 0 0 0-.2.6c-.2.1-1 .8-.7 1 .2 0 .4 0 .3.2-.1.2-.4.6-.3.9h.3a6.2 6.2 0 0 0 .7-.6 3.8 3.8 0 0 0 .5-.8h.1a9 9 0 0 1 .3-.8c0-.2.1-.5.3-.7l.3.3a.4.4 0 0 0 .2 0 .4.4 0 0 0 .3 0l.2-.3h.1a1.2 1.2 0 0 1-.3.4.5.5 0 0 1-.3 0 .5.5 0 0 1-.2 0 1.1 1.1 0 0 1-.3-.3 12 12 0 0 0-.5 1.4v.1a5.6 5.6 0 0 1-1.2 1.4l.2.5 1-1 .8-1a6 6 0 0 1-.3.6v1.1h-.1v-.9l-.3.3a11.6 11.6 0 0 1-1 1c-.3.3-.6.3-.2.7l.3-.3.4-.3h.1v.1l-.4.3-.4.3a.6.6 0 0 0 .1.3.5.5 0 0 1 .1 0l.8-.6c.1 0 0 .1 0 .1l-.7.6a.7.7 0 0 1-.1 0c-.3.3-1.2.8-1 1.2l.6-.2.6-.5c.1 0 0 0 0 .1a2.5 2.5 0 0 1-.6.5v.2-.1a3.6 3.6 0 0 1-.7.1c.1.4 0 .7-.3 1 0 .1-1 .9-.6 1a1 1 0 0 0 .3.2"
        }),
        /* @__PURE__ */ jsx170("path", {
          d: "M349.4 100.1a2.2 2.2 0 0 0-.6-.3 1.4 1.4 0 0 0-.5-.5c-.2-.2-.2-.1-.1-.3l.2-.1a.9.9 0 0 1 .3 0 .4.4 0 0 1 .2.2h.1c.1 0 0 0 0 0a.5.5 0 0 0-.2-.2 1 1 0 0 0-.4-.1.7.7 0 0 0-.4 0l-.2-.5.4.1.2.1a.7.7 0 0 0-.2-.2 2 2 0 0 0-.2 0 2.9 2.9 0 0 1 2.1.2c.4.1.6.3.8.6l-.2.2c-.5 0-.8 0-1 .2-.2.1-.2.4-.2.6z"
        })
      ]
    }),
    /* @__PURE__ */ jsx170("path", {
      d: "m365 121.8-.4.2c0-.3.2-.4.3-.6v.2zm2 4.2a2.3 2.3 0 0 1-.4.4 4 4 0 0 1-.5.4v-.1l.4-.4.4-.4zm1.3-1.6-.2.3h-.1l.2-.3zm-.7 0a1.1 1.1 0 0 1-.2.3 1 1 0 0 1-.5.4v-.1a1 1 0 0 0 .4-.3 1 1 0 0 0 .1-.4zm1.2-1.6a1 1 0 0 0-.1.2 1.1 1.1 0 0 0-.1.2h-.1a1.1 1.1 0 0 1 .3-.5zm1 0v.5l-.3.5c-.1 0 0 0 0 0l.1-.5zm-.4-6c.3.5.4 1 .4 1.5a7.3 7.3 0 0 1 .1-.6 1.4 1.4 0 0 0 .3-1.1c0-.1.1 0 .1 0v.6a1.7 1.7 0 0 1-.3.6l-.2 1h-.1v-.1c0-.6 0-1.2-.4-1.8zm-.8 1v.3h-.1v-.4zm-.2 1.4a6.2 6.2 0 0 1 .2 1.4 1 1 0 0 1 .1-.1l.3-.3h.1a1 1 0 0 0-.3.3.7.7 0 0 0-.2.4 5 5 0 0 0-.1-.9 5.9 5.9 0 0 0-.2-.8zm1 .5a3.6 3.6 0 0 1 .1 1.2v-.6a3.6 3.6 0 0 0-.1-.6m1-.2v.6a1.5 1.5 0 0 1 0 .5 1.2 1.2 0 0 0 0 .6l.1.6a2.5 2.5 0 0 1-.3-.6 1.3 1.3 0 0 1 0-.6 1.4 1.4 0 0 0 .2-.5 2.3 2.3 0 0 0 0-.6m.5-1.5-.1.3v.2h-.1v-.6zm-.5-2.6v.2c.1 0 .1 0 0 0 0 .1 0 0 0 0zs-.1 0 0 0c0-.1 0 0 0 0m.2-2v.8a.8.8 0 0 0-.2.3 1.4 1.4 0 0 0 0 .6h-.1a1.4 1.4 0 0 1 0-.6.9.9 0 0 1 .3-.4zm-2-.7c.4.2.6.4.8.7.2.2.3.5.3.9l-.6-.2v1.8c-.2.5-.5.8-1 1a3.8 3.8 0 0 0 0-1.8h.1a3.6 3.6 0 0 1 0 1.6 1.5 1.5 0 0 0 .7-.8 3.7 3.7 0 0 0 .1-1.9l.6.2c0-.3-.1-.5-.3-.8a2.5 2.5 0 0 0-.7-.6zm5.2-1v.2h-.1v-.2s0-.1 0 0zm-1.2 0 .3.1a.8.8 0 0 1 .1.2v.1a.8.8 0 0 0-.2-.2.6.6 0 0 0-.2-.2m-1.8.5.3.5v.6c-.1 0-.1 0 0 0l-.1-.6a1 1 0 0 0-.3-.5zm-6 .5v.4l-.1.1zm1-.6.2.4v.1h-.1v-.1l-.1-.3zm2.4 1.6v.1a1.1 1.1 0 0 1 0 .2.8.8 0 0 0 0-.2.6.6 0 0 0-.1 0zm.8-1.8v.2a.2.2 0 0 1 0 .2.1.1 0 0 0 0-.2c-.1-.1-.1-.1 0-.1zm-5.5.3a1 1 0 0 0 .2.7c.2.1.2.3.3.4v.4h-.1v-.4a.9.9 0 0 0-.2-.3 1 1 0 0 1-.2-.4 1.1 1.1 0 0 1-.1-.4zm2.2 1.5.2.7v.7c0 .3 0 .6.2.8l.6.7a2.9 2.9 0 0 1-.1-1l.3-1c.2 0 .2-.2.3-.3v-.4h.1v.4a1.5 1.5 0 0 1-.3.5 1.6 1.6 0 0 0-.3.9c0 .3 0 .6.2 1h-.1c-.4-.2-.6-.5-.8-.8a1.3 1.3 0 0 1-.2-.8v-.7a1.8 1.8 0 0 0-.2-.6c0-.1.1 0 .1 0zm-.9 1.4c0 .2 0 .5-.2.7a3.4 3.4 0 0 1-.4.6h.3a2.2 2.2 0 0 0 .7-.6l.3-.3c.1 0 0 0 0 0a3.6 3.6 0 0 1-.2.4 2.5 2.5 0 0 1-.3.2 24.5 24.5 0 0 1 0 .4v-.2a1.5 1.5 0 0 0-.1-.1 2.2 2.2 0 0 1-.4.2l-.4.2v-.1l.4-.7zm-1 0v.1h-.1c-.1 0 0 0 0 0z"
    }),
    /* @__PURE__ */ jsx170("path", {
      d: "M363 113.7c.2.3.2.6.2 1a1.9 1.9 0 0 1-.4.8 1.9 1.9 0 0 0-.5.6 2.6 2.6 0 0 0-.2.6l.2-.3.5-.3a4.6 4.6 0 0 0 1.1-.9h.1c.1 0 0 0 0 0a4 4 0 0 1-1.2 1 1 1 0 0 0-.4.3 2.3 2.3 0 0 0-.4.5c0-.4 0-.7.2-1l.5-.6.4-.8c0-.3 0-.6-.2-.9zm2.3 3.5.1.4.1.1c.2.3.3.5.3.8l-.1 1h-.1a1.8 1.8 0 0 0-.4-1 3.4 3.4 0 0 0-.8-.6v-.1c.4.2.7.4.9.7l.3.6a3.4 3.4 0 0 0 0-.6 1.3 1.3 0 0 0-.1-.7l-.1-.2c-.2-.2-.3-.3-.2-.4zm1 0 .1.2c0 .1 0 0 0 0h-.1l-.2-.2zm1 .3-.2.7-.2.7.2-.7zm.7 4a.3.3 0 0 1 0-.2zm-.7-1.2v.3l-.2.4v-.4l.1-.4h.1zm-1 0h.1v.1zm-1.1-.6a7.3 7.3 0 0 1-.1.2v.2h-.1a5 5 0 0 1 0-.2 5 5 0 0 1 0-.2h.1c.1 0 0 0 0 0zm-1.7 1.8a.7.7 0 0 0-.1.2 1.3 1.3 0 0 0 0 .2s-.1.1-.2 0v-.2a.8.8 0 0 1 .2-.3zm-4.8 4.6a.7.7 0 0 1 0 .2 1.1 1.1 0 0 1-.2.1c-.1 0-.1 0 0 0a.8.8 0 0 0 .1-.3zm.8-.4a.3.3 0 0 1-.1.2.6.6 0 0 1-.2 0 .4.4 0 0 0 .1-.1.3.3 0 0 0 0-.1zm1-.6a.5.5 0 0 1 0 .1.5.5 0 0 1-.2.1.4.4 0 0 0 0-.2zm1.5-3.8-.1.4a1.4 1.4 0 0 0 0 .4h-.1a1.4 1.4 0 0 1 0-.4v-.5h.1zm1-10.3a.9.9 0 0 1-.1.3 1.4 1.4 0 0 1-.2.3h-.1l.2-.3a.8.8 0 0 0 0-.3l.1-.1zm-1-1a1.9 1.9 0 0 1 .1 1 1.8 1.8 0 0 0 0-.5 1.5 1.5 0 0 0-.2-.4c0-.1 0 0 0 0zm-1.4 1.7a1.5 1.5 0 0 1-.4-.4.7.7 0 0 1-.1-.4l.2.4zm1.5 2.6v.2h-.1v-.2zm-2-2 .6 1 .1.8c.2 0 .3-.1.4-.3v-.9a1.9 1.9 0 0 0 .3-.6 3.5 3.5 0 0 0 .1-.5h.1l.4.8.3.9h-.1a2.9 2.9 0 0 0-.3-.9 3.9 3.9 0 0 0-.3-.6 2.9 2.9 0 0 1 0 .4 2 2 0 0 1-.3.5l-.1 1-.4.3v.4h-.1c0-.4 0-.8-.2-1.2a2 2 0 0 0-.5-1zm1.2 5v.3l-.1.4h-.1v-.8h.1c.1 0 .1 0 0 0zm-2.2.9v.3l-.1-.3c0-.1.1 0 .1 0m1.9-2.5a2.3 2.3 0 0 1-.2.6l-.3.5a1.1 1.1 0 0 0-.3.6 1.8 1.8 0 0 0 0 .7c0 .1 0 0 0 0a1.9 1.9 0 0 1-.1-.7c0-.2.1-.5.3-.7a2.1 2.1 0 0 0 .3-.5 2.1 2.1 0 0 0 .2-.6c.1 0 0 0 0 0zm-.5-.8v.6a2.2 2.2 0 0 1-.5.6 1.8 1.8 0 0 0-.4.5l-.2.5h-.1l.2-.6.5-.5a2 2 0 0 0 .3-.5 1 1 0 0 0 .1-.6zm-2.4 1.2c0 .4 0 .7-.2 1-.1.3-.3.6-.6.8h-.1v-.1c.3-.2.5-.5.6-.8.2-.2.2-.6.2-1zm-3 1.7v.2l.1.1v.1h-.1l-.1-.2v-.2s-.1 0 0 0zm-1.3 0a2.7 2.7 0 0 0 0 .7l.4.6.1.5v.4l.4-.5a1.4 1.4 0 0 0 .2-.6 1.6 1.6 0 0 1 0 .6l-.5.6h-.1a3.3 3.3 0 0 0 0-.5 1.8 1.8 0 0 0-.2-.4 2 2 0 0 1-.3-.7 2.7 2.7 0 0 1-.1-.7zm.2 4.2a2.6 2.6 0 0 1 .1-.8h.1a2.5 2.5 0 0 0-.1.8zm-.2 1.1v-.4s0-.1.1 0v.4zm-.8 2 .2-.3.2-.3h.1a4 4 0 0 1-.2.4l-.2.2c-.1 0-.1 0 0 0zm-1.1-6.6v.2h-.1v-.2zm-2 4.5a2.9 2.9 0 0 0 0-.1v-.2h.1v.3zm5-8-.3 1c0 .3.1.6.3.7.3.2.4.4.5.7v-.4c.1-.1.1-.3 0-.4h.1a2.7 2.7 0 0 1 0 1h-.1a6 6 0 0 1 0-.2l-.5-.6c-.3-.2-.4-.4-.4-.8l.2-1zm-.4-1.3a2.5 2.5 0 0 1 0 .8 4 4 0 0 1-.3.7 2.4 2.4 0 0 0-.2 1c0 .4.1.7.3 1v.1a2.5 2.5 0 0 1-.2-2.1 3.8 3.8 0 0 0 .2-.7c0-.3.1-.5 0-.8zc.1 0 0 0 0 0m-2.3 3.3a.8.8 0 0 0 0 .4l.1.5c0 .1 0 0 0 0a1.5 1.5 0 0 1-.3-.5.9.9 0 0 1 .1-.5zm-1-.4v.3a.9.9 0 0 1 0 .3.4.4 0 0 0-.1.3l.1.2v.1a.8.8 0 0 1-.2-.3.5.5 0 0 1 0-.4.8.8 0 0 0 .1-.2zm5.8-8.6a2.3 2.3 0 0 0 .3 1.5 2.6 2.6 0 0 1-.4-.7 2.3 2.3 0 0 1 0-.8zm-.7.7a4 4 0 0 1 .5 1.7h-.1a3.8 3.8 0 0 0-.5-1.6v-.1zm-3.6.1c-.4.5-.5 1-.6 1.3l.2.9.2.8a2.6 2.6 0 0 1-.2.8c-.1 0 0 0 0 0v-.8a2.3 2.3 0 0 0 0-.8 1.7 1.7 0 0 1-.3-1c0-.3.2-.7.6-1.2.1 0 0 0 0 0zm3.3-1.4v.5l-.4.4a.8.8 0 0 0-.3.4v.7c0 .1 0 0 0 0a1.9 1.9 0 0 1 0-.7 1 1 0 0 1 .3-.5 1 1 0 0 0 .3-.4.6.6 0 0 0 0-.4zm-3.5.3v.7c0 .2-.2.4-.4.6a1.2 1.2 0 0 0-.4.6 2.9 2.9 0 0 0-.1.7h-.1a3 3 0 0 1 .1-.8c0-.2.2-.4.4-.6l.4-.6a1 1 0 0 0 0-.6zm2 .1a.8.8 0 0 0 0 .2.5.5 0 0 0 .1.3.6.6 0 0 1-.2-.2.8.8 0 0 1 0-.3zm0-.5a.8.8 0 0 0-.5.4l-.2.7.2.5v.7a2.4 2.4 0 0 0 0-.7l-.3-.4a2 2 0 0 0-.5 1.2c0 .5.1 1 .5 1.5h-.1a2.7 2.7 0 0 1-.5-1.5c0-.5.2-.9.6-1.3 0-.3 0-.6.2-.8a1 1 0 0 1 .5-.4zm-.7-.8c0 .3 0 .6-.2.7a.8.8 0 0 0-.2.3 1.6 1.6 0 0 0-.1.4h-.1a1.7 1.7 0 0 1 0-.4 1 1 0 0 1 .3-.4c.2-.1.2-.4.2-.6a2.7 2.7 0 0 0 0-.1zm5.7 6 .1.5v.4a1.4 1.4 0 0 0 0-.4 1.9 1.9 0 0 0-.2-.4zm0 2v.6l-.2.6-.3.6.2-.6a2.1 2.1 0 0 0 .2-.6 1.6 1.6 0 0 0 0-.7h.1zm-1.2-1.8a2.5 2.5 0 0 1 .7 2.5h-.1a2.4 2.4 0 0 0-.6-2.4zc0-.1 0 0 0 0m0 2a5.3 5.3 0 0 1-1 1.4 2.5 2.5 0 0 0-.5 1 1.4 1.4 0 0 0-.1-.6 1.9 1.9 0 0 0-.2-.4 1.4 1.4 0 0 1-.3-.9l.3-.8.3-.6a2.4 2.4 0 0 0 0-.6h.1c.1 0 0 0 0 0a2.6 2.6 0 0 1-.3 1.3 1 1 0 0 0-.3.7c0 .3 0 .6.2.8a2 2 0 0 1 .3.8 2.6 2.6 0 0 1 .5-.8 5 5 0 0 0 .5-.6l.3-.7zm-3.2-1a2.8 2.8 0 0 0 .4 1.4v.1h-.1a2.3 2.3 0 0 1-.3-.7 3 3 0 0 1 0-.7zm-1.7 1v.3h-.1zm.6-1.6-.1.5a1.4 1.4 0 0 1-.3.5c-.1 0 0 0 0 0l.2-.5a1.4 1.4 0 0 0 0-.5zm-1.6 3.1a3.3 3.3 0 0 1-.3-1.7c0-.5.3-.8.6-1l.4-.7c.1-.2.2-.5.1-1s.1 0 .1 0v1l-.6.7a1.9 1.9 0 0 0-.5 1c0 .5 0 1 .3 1.7zm-1-1.1a.7.7 0 0 0 0 .3l.1.4a1 1 0 0 1-.2-.4.8.8 0 0 1 0-.4zm4.6-3.2c.1.2.3.5.3.8 0 .3 0 .6-.2.9h-.1c-.1 0 0 0 0 0l.2-.9a1.5 1.5 0 0 0-.3-.8zm1.4-1.1a2.4 2.4 0 0 1 0 1.7 1.8 1.8 0 0 0-.2-.8 1.5 1.5 0 0 0-.5-.5c0-.1 0-.1.1 0a1.6 1.6 0 0 1 .6 1v-.6a2.3 2.3 0 0 0-.1-.8zm.8-1.2.4.8v1a2 2 0 0 0 0 .5 1 1 0 0 0 .2.4 1 1 0 0 1-.2-.4 2.3 2.3 0 0 1 0-.5 3.5 3.5 0 0 0-.1-1 1.5 1.5 0 0 0-.4-.7c0-.1 0 0 .1 0zm-2.2-.2a1 1 0 0 0-.3.5v.7a2 2 0 0 1 0-.7c0-.2 0-.4.2-.5.1 0 .1 0 0 0zm-4.4 3a2 2 0 0 1-.3 1 2.5 2.5 0 0 1-.8.7c-.1 0 0 0 0 0l.7-.7c.2-.3.3-.6.3-1zm0-1.6v.5a2.2 2.2 0 0 1-.3.5l.1-.5v-.5zm2.9-.2v1h-.1zm.7-1.3c-.2.3-.3.5-.3.8l.2.7.3 1.2c0 .4-.2.7-.4 1.1l.3-1.1a1.9 1.9 0 0 0-.3-1.2l-.2-.7c0-.3 0-.6.3-.8.1 0 0 0 0 0zm-4.6-8.1a2 2 0 0 1 1-.5c.4 0 .8 0 1.2.3h.8-.8c-.4.5-.8.7-1.1.7a1 1 0 0 1-.9-.2c0-.1 0-.1 0 0a1 1 0 0 0 .9 0c.2 0 .6-.1 1-.5a1.9 1.9 0 0 0-1-.1 2 2 0 0 0-1 .4c-.1 0 0 0 0-.1z"
    }),
    /* @__PURE__ */ jsx170("path", {
      d: "M351.6 101a.3.3 0 0 1 .3.3.3.3 0 0 1-.3.2.3.3 0 0 1-.2-.2.3.3 0 0 1 .2-.3m1.8 1.6a2.2 2.2 0 0 0 .8-.7c.1 0 0 0 0 .1a2.3 2.3 0 0 1-.2.3l-.5.4c-.1-.1 0-.1 0-.1zm3.7-1.6a.5.5 0 0 1 .3 0 .8.8 0 0 1 .3.2.7.7 0 0 0-.3 0 .5.5 0 0 0-.2 0l-.1-.1zm-2 .1a.8.8 0 0 1 .3-.4l.7-.1v.1a1 1 0 0 0-.7 0 .7.7 0 0 0-.3.5c-.1 0-.1 0 0 0zm.2.4a.4.4 0 0 1 0-.3.6.6 0 0 1 .3-.1h.1a.5.5 0 0 0-.3.2.3.3 0 0 0 0 .2zm-3.6 1.1-.1.3a.8.8 0 0 0 0 .3l-.1.1a1 1 0 0 1 0-.4c0-.1 0-.2.2-.3m1 .5v.2zm-.6-1.1a1 1 0 0 0 .3 0h.3a1.4 1.4 0 0 1-.3.1 1 1 0 0 1-.3 0s-.1 0 0-.1m.6-2a.3.3 0 0 0-.2.1.4.4 0 0 0-.1.2h-.1a.5.5 0 0 1 .2-.3.4.4 0 0 1 .2 0m-1 .2a.8.8 0 0 0-.2 0 .3.3 0 0 0 0 .2h-.1c-.1 0 0 0 0 0a.4.4 0 0 1 0-.2.9.9 0 0 1 .3-.1zm-.7 0a.8.8 0 0 0-.1.1.7.7 0 0 0-.1.2h-.1a.7.7 0 0 1 .1-.2.9.9 0 0 1 .2-.2zm-.8.7a1.7 1.7 0 0 0-.4.4v-.1a2 2 0 0 1 .4-.4zm0 .9-.2.2c-.1 0-.1 0 0 0v-.2zc.1 0 .1 0 0 0m-.7.2v.3l-.1.1c-.1 0 0 0 0 0v-.4zm1 1.4v.6h-.1v-.6zm-.6-.4v.3h-.1v-.3zm-.6-4.5a.7.7 0 0 1 .5.4v.1h-.1a.7.7 0 0 0-.2-.3.7.7 0 0 0-.2-.1zm5.2 6.7a1.6 1.6 0 0 1 0 1.4h-.1a1.6 1.6 0 0 0 0-1.3v-.1zm-1.7 2c0-.3.2-.5.3-.7l.4-.6c.2-.2.3-.4.3-.7a1.8 1.8 0 0 0 0-.7h.1a2 2 0 0 1-.3 1.5 6.3 6.3 0 0 0-.4.5zm-2.2-.6a.7.7 0 0 1 .2-.3.9.9 0 0 1 .3-.1.8.8 0 0 0-.2.2.6.6 0 0 0-.2.2zm-.4-.2.3-.3.3-.2v.1a1 1 0 0 0-.3.2 2 2 0 0 0-.2.3c-.1 0-.1 0 0 0zm2.3-2.2h.2a.8.8 0 0 0 .3 0v.1a.8.8 0 0 1-.6 0c0-.1 0-.1 0 0zm-1.2-.1c.1 0 .1 0 0 0m24.2 7a1.1 1.1 0 0 1 .2.3h-.1a.8.8 0 0 0 0-.1.8.8 0 0 0-.2-.2c0-.1 0 0 0 0zm-26.8 12.5.3.3a1 1 0 0 0 .5 0v.1a1 1 0 0 1-.5 0 1.7 1.7 0 0 1-.4-.3c0-.1 0-.1 0 0z"
    }),
    /* @__PURE__ */ jsxs145("g", {
      fill: "red",
      children: [
        /* @__PURE__ */ jsx170("path", {
          d: "M368.9 99.6a8.2 8.2 0 0 0 1.7 0c-.6.3-1.2.6-2 .7a.8.8 0 0 0 .3-.4.4.4 0 0 0 0-.3m-1.4-.1h1.2v.4s0 .2-.2.3c0 0-.1 0 0 .1a5.6 5.6 0 0 1-1.3 0 1 1 0 0 0 .3-.5.6.6 0 0 0 0-.4zm-10.5-3c.7-.2 1.3-.2 2-.2a1 1 0 0 1 .5.4c.1.2.2.5.1.8l.1.1h.1l-.1-1a1 1 0 0 0-.3-.2h.2a5 5 0 0 1 2.1.6c.2.2.3.3.2.5l-.3.5v.2h.2l.3-.7a.7.7 0 0 0 0-.3l1.7.8a.5.5 0 0 1 0 .5 1 1 0 0 1-.5.3v.1l.1.1c.3 0 .5-.2.6-.4a.6.6 0 0 0 0-.4l1.2.6v.3c0 .2-.1.3-.3.4 0 0-.1 0 0 .1 0 .1 0 0 0 0 .3 0 .5-.2.6-.4a.5.5 0 0 0 0-.3l.4.1a8.1 8.1 0 0 0 1.3.4.5.5 0 0 1 .1.4.7.7 0 0 1-.2.3v.2c-1.4-.1-2.7-.9-4.1-1.4l-.5-.2-1.6-.6-.1-.1a8.5 8.5 0 0 0-1.5-.4 6.1 6.1 0 0 0-1.6 0h-.1l-.1-.8a1.3 1.3 0 0 0-.5-.4z"
        }),
        /* @__PURE__ */ jsx170("path", {
          d: "M354.6 97a8.7 8.7 0 0 1 2-.5c.4.1.6.3.7.5v.6a4.2 4.2 0 0 0-1.7.2 1.2 1.2 0 0 0-.7-.6 1.2 1.2 0 0 0-.3-.1zm7.4 3.9a9.4 9.4 0 0 0-.5-.4 7 7 0 0 0-3-.8c.3-.4.4-.8.3-1.1a1.7 1.7 0 0 0-.7-.8h1a8 8 0 0 1 2 .6c0 .3.1.6 0 .8 0 .3-.2.5-.5.7 0 0-.1 0 0 .1 0 .1 0 .1 0 0 .4-.1.6-.4.7-.7v-.8l1 .6 1 .8c0 .4 0 .6-.3.8h-.9v.2z"
        }),
        /* @__PURE__ */ jsx170("path", {
          d: "m364 102.4-1.8-1.4c.4 0 .7 0 1-.2.1-.1.3-.4.3-.8l1.1 1 .6.5v.4a.5.5 0 0 1 0 .2.6.6 0 0 1-.4.2h-.7z"
        }),
        /* @__PURE__ */ jsx170("path", {
          d: "M366.2 103.8a11.8 11.8 0 0 1-2-1.3h.7a.8.8 0 0 0 .4-.2l.1-.4a1 1 0 0 0 0-.2 10.5 10.5 0 0 0 2.1 1.4c0 .3 0 .4-.3.5a3 3 0 0 1-1 .1z"
        }),
        /* @__PURE__ */ jsx170("path", {
          d: "M368.4 104.7a11.9 11.9 0 0 1-2-.8c.4 0 .7 0 1-.2.2 0 .3-.2.3-.5a10.8 10.8 0 0 0 1.3.6v.4l-.5.4s-.1 0 0 0z"
        }),
        /* @__PURE__ */ jsx170("path", {
          d: "M373.2 104.2s.4-.1.2 0c-1.4 1-3.1 1-4.8.5.3-.1.5-.2.6-.4a.6.6 0 0 0 0-.5l1.7.4a.4.4 0 0 1-.1.3l-.5.3s-.1 0 0 .1c0 .1 0 0 0 0 .3 0 .5-.2.6-.3a.6.6 0 0 0 .2-.4 9 9 0 0 0 2 0zm-9.7 24-.2.4-1.2.3c0 .3 0 .4.3.4l.7-.3c.1 0 0 .5-.5.8v.1c.4.6 1.4.4 1.9.3a3 3 0 0 0 1.3-1l-.3-.6c-.4.1-.6 0-.5-.2a3.9 3.9 0 0 0-1.5-.2m-15.1-4.8c-.3.3-.7.5-1 .6-.2 0-.6.1-.6.3 0 .1.2.3.4.2.4-.5.7-.2.2.2v.3c.5.4 1.6.5 2.2.2.3-.2.6-.5.2-.9a1.7 1.7 0 0 1 0-.2h-.6l-.4-.3zm10 3.5h-.1c-.2.2.3.2.6.3.2.1.2.3.2.5-.3.7-1.9.5-2.4.2-.2-.1-.2-.3-.2-.5h.3c.2 0 .4 0 .6-.2v-.2h-.2a1.3 1.3 0 0 1-.4.2 2.6 2.6 0 0 1-.5 0l-.2-.2h.2l.7-.2.1-.1c.5 0 1 0 1.3.2m-7.2-.4-.2.3a2.7 2.7 0 0 1-.9.6c-.2.1 0 .2.2.4.2.1.5-.2.6-.4.2-.3.3-.2.2 0l-.2.7.7.3c.4 0 1-.4 1.2-.6.3-.2.2-.5.1-.8a2 2 0 0 1-.5 0 3.4 3.4 0 0 1-.5-.3zm2.8-26.4h.3l.6.1a4.5 4.5 0 0 1 1.7-.3 5.7 5.7 0 0 1 1.7-.2v-.2c.3-.3.4-.6.3-.9-.1-.2-.4-.5-.8-.7h-1.3a4 4 0 0 0-.8.1l.6.4.4 1c-.2.1-.2 0-.2 0 0-.4-.2-.6-.3-.9l-.8-.4a9 9 0 0 0-1.3.2c-.3 0-.5.2-.7.3l.8.1c.3.1.5.4.6.8-.1.1-.1 0-.1 0a1 1 0 0 0-.5-.6c-.4-.2-1.3 0-1.7.2a4.2 4.2 0 0 0-.6.6zm-2.3-.4.7-.6.7-.4a2 2 0 0 1 1-.5l1.3-.2a1 1 0 0 0-.5-.5l-.8-.1-1.5.8h.5l.1.2h-.4a1.4 1.4 0 0 0-.4 0h-.1l-1.3 1c.3.1.6.2.7.4"
        })
      ]
    }),
    /* @__PURE__ */ jsx170("path", {
      fill: "#0093dd",
      d: "m409 156.5 20.8-47-15.3-24.7-27.3 10-12.7 49.8a219.4 219.4 0 0 1 34.5 11.9"
    }),
    /* @__PURE__ */ jsx170("path", {
      fill: "#fff",
      d: "M382.6 113a251.7 251.7 0 0 1 39.6 13.7l-8 18.2a232 232 0 0 0-36.5-12.7z"
    }),
    /* @__PURE__ */ jsx170("path", {
      fill: "red",
      d: "m415.4 142 5.4-12.2a248.6 248.6 0 0 0-39-13.5l-3.2 12.4a235.9 235.9 0 0 1 37 12.8z"
    }),
    /* @__PURE__ */ jsx170("path", {
      d: "M385.6 125.8c.3-.3.7-.2 1.1-.1.3-.2.7-.2 1-.2l.6-.2c.2 0 .2-.2 0-.3a.6.6 0 0 1 0-.3c-.7-.4-1-1-1.2-1.5-.3 0-.5-.2-.5-.3h-.5c-.8 0-1-.3-1.3-.5a1 1 0 0 1-.6-.4l-.3-.3c-.2-.3-.1-.7.2-.7h.7a2 2 0 0 1 .9-.1c.3 0 .5-.3.9-.6v-.4s0-.2.2-.1a1 1 0 0 1 .8.5c.5 0 1 .3 1.2.7.7 0 1.1.3 1.2.5 0 .2-.2.4-.5.6v.2l.4.4 1 .7c1-.1 2.6.6 4.8 2a18.6 18.6 0 0 1 4.1 1.2h.9c2.4-.4 4.7 0 6.8 1.5.8.1 1.5.4 2.2.7.5.2 1 .3 1.6.3a8 8 0 0 1 2.6.7c1 .2 1.9.6 2.4 1.2.4.5.3 1-.2 1.2-.3.6-.9.6-1.8.3-.6.1-1.3-.4-2-.9-.8-.2-1.6-.8-2.4-1.3l-1.3-.6h-.8v.2c.2.2.4.4.4.8v1c0 .4.3.6.7.9l1 .4c.2 0 .3.1.3.3l.4 1.7.4.3c.6.5.2 1-.3 1a3.1 3.1 0 0 1-1.3.8c-.4.2-.6 0-.7-.2a.5.5 0 0 1-.4-.2c-.5-.4-.1-1 1-.7l.2-.2a1.5 1.5 0 0 1 0-.9l-.3-.2a2.8 2.8 0 0 1-1-.6c-.6-.5-1.5-1-2.4-1.4-.7 0-1.2-.4-1.8-.7h-.8c-.2 0-.4 0-.5.2-.2.3-.5.2-.8.2h-1.6c-.4 0-.7 0-1 .3-.2.2-.4.2-.7 0a1 1 0 0 1-.3-.2c-.3 0-.5 0-.5-.2-.5-.1-.6-.2-.6-.4-.6-.1-.3-.6 0-.6l1.4.1c.4.1 1 0 1.2-.2l.5-.5a4 4 0 0 1-1.8-.5c-1.1-.7-2-.9-2.8-.3-.2.2-.3.2-.6.1a1 1 0 0 0-.5 0c-.5.1-.9 0-1.3-.1a4 4 0 0 1-1.8 0c-.6.3-1 .4-1.2.2a8.6 8.6 0 0 1-.6-.4c-.4-.1-.5-.2-.5-.3-.4 0-.5-.2-.5-.4-.2-.2 0-.3 0-.4.4-.2.7-.2 1 0 .3 0 .5.2.6.3h.6c.1-.2.5-.2 1-.2l.7-.2v-.2c-.4 0-.6-.4-.9-.7a3 3 0 0 1-1.5-.5c-.4 0-.7-.1-1-.3h-.7a2.5 2.5 0 0 1-1.4 0h-.8a1 1 0 0 1-1 .2 1.5 1.5 0 0 0-.8-.5c-.3-.1-.4-.2-.4-.4-.4-.2-.3-.4 0-.5.3-.1.5-.2 1 0z"
    }),
    /* @__PURE__ */ jsx170("path", {
      fill: "#fff",
      d: "M401.2 130.5s0-.2-.3 0c-.8 0-1.6 0-2.2-.4-.7-.4-1.3-.8-2-.8l.7-.4h1.5c.7 0 1.4.2 2 .4.4.2.8.5 1 .8a3.4 3.4 0 0 1 .8.7 2.5 2.5 0 0 1-.7 0 2.9 2.9 0 0 1-.8-.3"
    }),
    /* @__PURE__ */ jsx170("path", {
      d: "M403 94.7v.2l.9 4.9-3.7 3.2-.2.1.2.1 4.7 1.6 1 4.9v.2l.2-.1 3.7-3.3 4.6 1.6h.3v-.1l-1-4.9 3.7-3.2.2-.2h-.3l-4.6-1.6-1-4.9V93l-.2.1-3.7 3.3z"
    }),
    /* @__PURE__ */ jsx170("path", {
      fill: "#f7db17",
      d: "m400.6 103 3.5-3 4.4 1.4zm8.5-1.7 3.4-3 4.4 1.5zm7.8-1.3-3.4 3-4.4-1.5zm-8.4 1.6-3.5 3-4.3-1.5zm-5-6.4 4.3 1.4.8 4.6zm5.5 6.4 4.4 1.5.9 4.5zm5.1 6.1-4.3-1.5-.9-4.5zm-5.6-6.4-4.3-1.5-.9-4.5zm3-7.7 1 4.6-3.5 3zm-2.7 8.1.8 4.6-3.4 3zm-2.8 7.5-.9-4.5 3.5-3zm2.8-8-.9-4.6 3.5-3z"
    })
  ]
});
var Hr_default = SvgHr;

// src/country-flag-icons/generated/Ht.tsx
init_esm_shims();
import { jsx as jsx171, jsxs as jsxs146 } from "react/jsx-runtime";
var SvgHt = (props) => /* @__PURE__ */ jsxs146("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx171("path", {
      fill: "#d21034",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx171("path", {
      fill: "#00209f",
      d: "M0 0h640v240H0z"
    }),
    /* @__PURE__ */ jsxs146("g", {
      fill: "#f1b517",
      stroke: "#000",
      strokeWidth: 0.2,
      children: [
        /* @__PURE__ */ jsx171("path", {
          fill: "#fff",
          stroke: "none",
          d: "M244.3 179.7h151.4v120.5H244.3z"
        }),
        /* @__PURE__ */ jsx171("path", {
          fill: "#016a16",
          stroke: "#016a16",
          strokeWidth: 0.3,
          d: "m350.5 266.8-31 1-30.7.3s-15.8 5.8-22.3 7.1c-6.4 1.3-5.6 3.4-10.5 4.6-4 .9-4.5 1.1-6.8 1.3-1.5 0-3.2 1.2-5 2.4v16.7h151.5v-15.9c-1.6-.9-3.2-1.5-4.8-2-2.2-.8-3.7-1.6-7.7-2.5-5-1.1-4.2-3.3-10.6-4.6-6.5-1.3-22.1-8.4-22.1-8.4z"
        }),
        /* @__PURE__ */ jsxs146("g", {
          transform: "translate(-80) scale(1.6)",
          children: [
            /* @__PURE__ */ jsxs146("g", {
              id: "ht_svg__a",
              children: [
                /* @__PURE__ */ jsx171("path", {
                  d: "M244.5 143.5h1.4l2.6 10.7-.6 3.4z"
                }),
                /* @__PURE__ */ jsx171("path", {
                  fill: "#fff",
                  d: "m243 136.3 1 8.3h1l-2-8.2z"
                }),
                /* @__PURE__ */ jsx171("path", {
                  d: "m245.7 154.6-4.3-11.5 1.6-.1 5 14z"
                }),
                /* @__PURE__ */ jsx171("path", {
                  fill: "#fff",
                  d: "m239.4 136.5 1.8 8h1.4z"
                }),
                /* @__PURE__ */ jsx171("path", {
                  d: "m241.9 150.6-2.5-5.5 1-.2 4.7 9z"
                }),
                /* @__PURE__ */ jsx171("path", {
                  fill: "#fff",
                  d: "m236 138.8 2.9 7.6h1.4l-4.2-7.6z"
                }),
                /* @__PURE__ */ jsx171("path", {
                  fill: "#0a328c",
                  d: "m242.3 151.4-11.5-12.5c-3.6 2.8-2.9 8-2.9 8l13 10.2z"
                }),
                /* @__PURE__ */ jsx171("path", {
                  fill: "#d20014",
                  d: "m248.9 158.2-8.5-8.6c-3.6.2-.8 5.5-.6 6.2l9 7.7z"
                }),
                /* @__PURE__ */ jsx171("path", {
                  d: "M248.1 156.8 230.6 138l-.7.5 18.6 20.6zm-18.5-20-.4-.5v-.9l-3.6-2.3 1.6 3.7 1.3.2.3.4z"
                }),
                /* @__PURE__ */ jsx171("path", {
                  d: "M227.7 138.1a8.4 8.4 0 0 1 2.7-2.2l1 1.5-2.2 1.8-1.5-1z"
                }),
                /* @__PURE__ */ jsx171("path", {
                  fill: "#0a328c",
                  stroke: "#0a328c",
                  d: "m225.8 141.3.6 1c.4-.1 4-3.5 4-3.5h2.7l.7-.9c-2-2-3.7.3-3.7.3z"
                }),
                /* @__PURE__ */ jsx171("path", {
                  fill: "#d20014",
                  stroke: "#d20014",
                  d: "M228 143c0-1 1.8-3.2 2-3.3 1.3.4 2.5 1.2 3.9-1.8-1.2 1.4-3.5 0-3.5 0l-1 .8v.4l-3 2.8z"
                }),
                /* @__PURE__ */ jsx171("path", {
                  fill: "#0a328c",
                  d: "m237.3 154.7-14.4-11.4c-2.5 2.5-.4 10.2-.4 10.2l14 7.6.7-6.4z"
                }),
                /* @__PURE__ */ jsx171("path", {
                  fill: "#d20014",
                  d: "m249.2 164-11.9-9.6c-4 .6-.8 6.5-.6 7.2l12.5 6.8z"
                }),
                /* @__PURE__ */ jsx171("path", {
                  d: "m248.7 162-25.6-19.2-.5.6 26.8 21zm-26.8-20.2-.4-.4-.2-.8-4-1.7 2.3 3.3h1.3l.4.4z"
                }),
                /* @__PURE__ */ jsx171("path", {
                  d: "M220.3 143.4a8.2 8.2 0 0 1 2.3-2.6l1.2 1.3-1.8 2.1z"
                }),
                /* @__PURE__ */ jsx171("path", {
                  fill: "#0a328c",
                  stroke: "#0a328c",
                  d: "M219 146.6v1.1c.4-.2 3.7-3.7 3.7-3.7l2.5-.5.6-.8c-1.8-2.1-3.7.7-3.7.7z"
                }),
                /* @__PURE__ */ jsx171("path", {
                  fill: "#d20014",
                  stroke: "#d20014",
                  d: "M221 148.5c-.2-1 1.2-3.8 1.4-4 1.6.5 3 1.2 3.5-2-1 1.6-3.5.4-3.5.4l-.8 1v.5l-2.5 3.3z"
                }),
                /* @__PURE__ */ jsx171("path", {
                  fill: "#0a328c",
                  d: "M236.2 161.7a2783.3 2783.3 0 0 1-18.5-10.5c-1.3 2.3-.1 5.5.5 6 0 1.5-.6 2.3.7 5.5.4 2 1.3 3.9 2.7 5 1.6 6.4 8.2 6.9 10.7 1.6z"
                }),
                /* @__PURE__ */ jsx171("path", {
                  fill: "#d20014",
                  d: "m248.3 168.5-12.5-7.3c-4 .5 0 8 .3 8.7l12.2 4.3z"
                }),
                /* @__PURE__ */ jsx171("path", {
                  d: "m246.2 165.8-28.3-15-.5.6 30 16.7zM216.5 150l-.5-.3-.3-.8-4.1-1 2.7 2.9 1.2-.2.6.3z"
                }),
                /* @__PURE__ */ jsx171("path", {
                  d: "M215.2 151.8c.4-1 .8-1.9 1.8-3l1.4 1.1-1.4 2.4z"
                }),
                /* @__PURE__ */ jsx171("path", {
                  fill: "#0a328c",
                  stroke: "#0a328c",
                  d: "m214.1 155.2.6 1.2 3-4.6 2.5-.9.5-1c-2-1.8-3.5 1.4-3.5 1.4z"
                }),
                /* @__PURE__ */ jsx171("path", {
                  fill: "#d20014",
                  stroke: "#d20014",
                  d: "M216.8 156.8c-.2-1 .5-4.2.7-4.3 1.5.5 2.8.6 3.2-2.6-1 1.5-3.3 1-3.3 1l-.7 1 .1.4-2 4z"
                })
              ]
            }),
            /* @__PURE__ */ jsx171("use", {
              xlinkHref: "#ht_svg__a",
              width: "100%",
              height: "100%",
              transform: "matrix(-1 0 0 1 499.9 0)"
            })
          ]
        }),
        /* @__PURE__ */ jsxs146("g", {
          transform: "translate(-80) scale(1.6)",
          children: [
            /* @__PURE__ */ jsx171("path", {
              fill: "#016a16",
              stroke: "#016a16",
              d: "m248.8 125.6-.5 9h2.9l-.4-9 3-.3-.3-3.6-7.5.3v3.2z"
            }),
            /* @__PURE__ */ jsxs146("g", {
              id: "ht_svg__b",
              fill: "#016a16",
              children: [
                /* @__PURE__ */ jsx171("path", {
                  d: "M249.8 121.9c-7.8-7.8-13.9-4-15.3-2.9 1 .2 1.8-.4 2.3-.5l-1 1.2s2.5-1 2.8-1c-.4.3-.8 1-.8 1 .2 0 1.6-1.1 1.8-1.1-.4.4-.5 1.5-.5 1.5l1.2-.5c.3.2-.1.6.1.6 2-.2 4.7 1.7 5 2.3"
                }),
                /* @__PURE__ */ jsx171("path", {
                  d: "M247.9 123.3c-.8-1.8-15.6-5-18.6.3 1.2.3 2.3-1 2.3-1v1.2l1.9-1.6-.7 1.6 1.5-1.3v1.3l2-2-.3 1.1 1.7-.7-.2 1"
                }),
                /* @__PURE__ */ jsx171("path", {
                  d: "M247.2 123.6c-3.8-2.5-9.6-.8-9.6-.8-3.8 2-5.8 1.7-6.2 5.6.3-.1 1.3-1.4 1.3-1.4l.8 1.5.2-2.1.6 1.7 1-2.8.2 1.9 1.4-1.9.6.6.6-1.5.6 1s1-.6 1.5-.3l1-1.2.3.9 1-1 .3.7.9-.8v.6h3"
                }),
                /* @__PURE__ */ jsx171("path", {
                  d: "M246.4 124c-2.7 0-10.3 2.9-12.2 5.8a13.3 13.3 0 0 1 1.3-.6l.3 1.2.5-1.2.1 1c.3-.8.6-.8 1.2-.1l.2-1.1.3 1 .5-1.1s.3 1.2.5 1.2c0 0 .8-2.2 1.2-2.3l.1 1.4.5-1.4.5 1v-1.4l.6 1s.2-1 .6-1.2l.8.7 3.4-2.5"
                }),
                /* @__PURE__ */ jsx171("path", {
                  d: "M246.9 124.7c-3.5 1.3-6.7 6.2-6.4 8.2 1.5-2 1.2-1.7 1.9.6 0 0 .2-2 .5-2.2l.5 1.4.1-1.9h.5l-.1-1.1.7.5c-.2-.7-.3-.9.4-1.5 0 0-1 .1-.2-1.5l.7.6s-.2-.7 0-1l2.6-.8"
                }),
                /* @__PURE__ */ jsx171("path", {
                  d: "m247.2 125-1.3 2.6.7.2-1.6 1.1 1.3-.1s-2 .7-2.2 2.7l2-1s-1.7 1.8-2 2.9l1.3-1s-1.2 1.2-1 3l.9-1c-.2 2.3-.2 2.5.8 4.2 0 0-.2-2.6 0-3l2.3 2.4-1.2-3.3s1.4 2 2.2 1.9l-1.8-2.7 1.8 1.4-2-3 1.8.6s-1.3-1.7-1.2-2.8l1.3 1.4s-.5-1.5-.4-2l.7.1-1.3-1.4.9-.2-.1-1 .6-.1v-1.1m-1.1 0c-2.2 3-1.1 7.5-2.4 9.9"
                })
              ]
            }),
            /* @__PURE__ */ jsx171("use", {
              xlinkHref: "#ht_svg__b",
              width: "100%",
              height: "100%",
              transform: "matrix(-1 0 0 1 499.9 0)"
            }),
            /* @__PURE__ */ jsx171("path", {
              d: "M251 166.5s1.1-10 1.1-14.2c0-3.4-.8-10.8-.8-10.8H248s-.5 7.4-.4 10.8c0 4.2 1.1 14.2 1.1 14.2z"
            }),
            /* @__PURE__ */ jsx171("path", {
              d: "M247.7 142h4l-.5-2.7h-2.9z"
            }),
            /* @__PURE__ */ jsx171("path", {
              d: "M248 139.8h3.5l-.7-2.7h-2.2z"
            }),
            /* @__PURE__ */ jsx171("path", {
              d: "M248.2 137.7h3l-.6-2.7h-1.9z"
            }),
            /* @__PURE__ */ jsx171("path", {
              d: "M250.7 134.7h-2l-.3 1h2.5zm.4 29.7h-2.6m2.8-2h-3m3.4-2h-3.8m4-2.1h-4m4-2.2h-4.1m4.2-2h-4.4m4.4-1.7h-4.6m4.6-2.2h-4.6m4.5-2.1h-4.5m4.3-2.2h-4.1m3.9-2h-3.7"
            }),
            /* @__PURE__ */ jsx171("path", {
              fill: "#0a328c",
              stroke: "#0a328c",
              d: "M250 119c-.8-.3-2.3-1.3-1.9-1.9l.7-1.2c1-2.2 0-1.4 0-2-.2-.8 3.8-.2 3.8 1.3 0 .5-.3.2-.2 2.6l-.8 1.5a3.5 3.5 0 0 1-1.7-.2z"
            }),
            /* @__PURE__ */ jsx171("path", {
              d: "m250.4 125-1-.9.3-7.1 1 .3-.3 7.6z"
            }),
            /* @__PURE__ */ jsx171("path", {
              fill: "#d20014",
              stroke: "#d20014",
              d: "M251.7 119.3c.6-.4 1-1.5.6-2.1-1-1.3-1.7-.8-3.4-1.4-.3.4-1 1-.9 1.6 2.3 1 1.4.2 2.2.3.4 0 .6.5 1.5 1.5z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs146("g", {
          transform: "translate(-80) scale(1.6)",
          children: [
            /* @__PURE__ */ jsx171("use", {
              xlinkHref: "#ht_svg__c",
              width: "100%",
              height: "100%",
              transform: "matrix(1 0 0 -1 0 320.4)"
            }),
            /* @__PURE__ */ jsx171("path", {
              fill: "#016a16",
              stroke: "#fff",
              strokeLinecap: "round",
              d: "M238.4 161.8c0 1.2-.9 2.3-1.9 2.3s-1.8-1-1.8-2.4v-1.2h3.7z"
            }),
            /* @__PURE__ */ jsx171("ellipse", {
              cx: 236.5,
              cy: 160.1,
              fill: "#fff",
              stroke: "none",
              rx: 1.8,
              ry: 0.9
            }),
            /* @__PURE__ */ jsx171("path", {
              fill: "#016a16",
              stroke: "#f1b517",
              d: "m236.1 161-.3-3.2h1.4l-.2 3.3h-.9z"
            }),
            /* @__PURE__ */ jsx171("path", {
              id: "ht_svg__c",
              fill: "#016a16",
              stroke: "#fff",
              strokeLinecap: "round",
              d: "M238.5 160.1c-.2.5-1 .9-2 .9s-1.7-.4-2-.9a.8.8 0 0 0 0 .4c0 .7.9 1.2 2 1.2 1.2 0 2.1-.5 2.1-1.2a.8.8 0 0 0 0-.4z"
            }),
            /* @__PURE__ */ jsxs146("g", {
              id: "ht_svg__d",
              children: [
                /* @__PURE__ */ jsx171("path", {
                  d: "m246 172.8-7-2.2-3.1-5.3-10.9-.5.4 4 9.3 1.7.8 1.6 10.7 3z"
                }),
                /* @__PURE__ */ jsx171("path", {
                  fill: "#503200",
                  d: "m238.7 174.3-11.2-16.5-.5.5 11 16.4z"
                }),
                /* @__PURE__ */ jsx171("path", {
                  fill: "#fff",
                  d: "m228.6 158.5-1.2-2c-.3-.4-.6-.5-1.1-.2-.5.2-.4.7-.2 1.1l1 1.9z"
                }),
                /* @__PURE__ */ jsx171("path", {
                  d: "m240 164.1-22.5-2.3-.6 3.3 22.4 2.3z"
                }),
                /* @__PURE__ */ jsx171("path", {
                  d: "m217 161-.5 4.5h1l.6-4.1zm3.8.7-.2 4.1h.6l.5-3.5zm15.3 1.8-.6 3.8h1.1l.5-3.8zm3.3.1-.7 4.4 1.2.2.4-2.3c0 .5.5.8 1 .8.6 0 1-.5 1-1 0-.6-.4-1-1-1a1 1 0 0 0-1 .6l.3-1.6zm-8 .7-3.2 3.5.4.4 4-2.7zM224 173l3.1-3.5-.3-.4-4 2.7zm8.1-.9-3.7-2.9-.4.3 3 3.8zm-9.3-6.7 3.9 2.8.4-.3-3-3.8zm4.2-2.3.4 4.6h.5l1.2-4.5zm1.2 11-.3-4.5h-.6l-.7 4.6zm5.1-6-4.8.4v.5l4.8.6zm-11.4 1.5 4.7-.7v-.4l-4.8-.5v1.6z"
                }),
                /* @__PURE__ */ jsx171("ellipse", {
                  cx: 227.7,
                  cy: 168.6,
                  rx: 1.3,
                  ry: 1.2
                }),
                /* @__PURE__ */ jsx171("path", {
                  fillRule: "evenodd",
                  strokeLinecap: "round",
                  d: "M234.4 168.6c0 3.5-3 6.5-6.7 6.5a6.6 6.6 0 0 1-6.7-6.5c0-3.6 3-6.5 6.7-6.5a6.6 6.6 0 0 1 6.7 6.5zm-1.3 0a5.3 5.3 0 0 1-5.4 5.2 5.3 5.3 0 0 1-5.4-5.3 5.3 5.3 0 0 1 5.4-5.1 5.3 5.3 0 0 1 5.4 5.2z"
                }),
                /* @__PURE__ */ jsx171("path", {
                  d: "m223.5 165.3-1-.8m8.5 0 1-1m1 9.2-1.1-.9m-8.4 1.9 1-1m21.7-10.6 1.1 6-.9.4-1-6.3z"
                }),
                /* @__PURE__ */ jsx171("path", {
                  fill: "#fff",
                  d: "M245.6 161.4c-.5-.3-1.2.1-2.4-1.3-1.9 1.7 0 2 .2 3.7.5.2.9-1.4 2.3-1.5l2.3-.2-.5-.7z"
                }),
                /* @__PURE__ */ jsx171("path", {
                  fill: "#fff",
                  d: "m246.4 162.5-.2-1.7c-.3-.7-1-.1-1 .2l.2 1.7z"
                }),
                /* @__PURE__ */ jsx171("path", {
                  fillRule: "evenodd",
                  d: "M240.8 167.4v1.6c-.6.2-.5.6-.5 1.2v4.7c-.1.4-.7.4-1 .6-.3.3-.2.8 1 1l1 .1c1.5-.3 1.8-.8 1-1-.3-.2-.9-.4-1-.6v-1.2h1c.2 0 .7-.6.7-1.1v-2.5c0-1.4-1-1.6-1.4-1.5v-1.3zm1.6 2.7c0-.4-.6-.8-.8-.8-.2 0-.7.5-.7.9v1c0 .4.3 1.6.9 1.7.2 0 .6-.4.6-.8z"
                }),
                /* @__PURE__ */ jsx171("path", {
                  fill: "#fff",
                  d: "M234.3 172.3c-.7-.2-.7 1.2-.7 1.2h1c.5.2.8.8.6 1.2-.3.2-2.2-.5-2.3 0 .3 1.9 2.9 2.6 3.8 1.8.9-.9 1.1-3-1.8-3.7zm.6.6-.3.6"
                }),
                /* @__PURE__ */ jsx171("path", {
                  d: "m215 173-1-4m2.1 3.8-1.5-3.1m4 2.3-3.3-1.8m4.8 1.4-6.2-2.7"
                }),
                /* @__PURE__ */ jsx171("path", {
                  fill: "#d20014",
                  stroke: "#d20014",
                  d: "m210.2 166-2.6.1c-.2.1.5.9.4 1.1-.6 1.1-4.4 1-4.7.8-.5-.5 3.5-.8 3.6-1 0-.4-.6-1.2-.5-1.7 0-.7 1.7-1 1.7-1z"
                }),
                /* @__PURE__ */ jsx171("path", {
                  fill: "#503200",
                  d: "m213.2 168-5-4.2s-.3-.2-.5 0 0 .4 0 .4l5.4 4.4.1-.5z"
                }),
                /* @__PURE__ */ jsx171("path", {
                  d: "m218.2 172.2-4.2-3.6-.3-1-.8.6c-.3.2-.6.8-.6.8h1.1l3.6 3.4 1.1-.2z"
                }),
                /* @__PURE__ */ jsx171("circle", {
                  cx: 232.5,
                  cy: 177.1,
                  r: 0.7
                }),
                /* @__PURE__ */ jsx171("circle", {
                  cx: 230.6,
                  cy: 175.7,
                  r: 0.7
                }),
                /* @__PURE__ */ jsx171("circle", {
                  cx: 228.1,
                  cy: 176.6,
                  r: 0.7
                }),
                /* @__PURE__ */ jsx171("circle", {
                  cx: 224.2,
                  cy: 177.4,
                  r: 0.7
                }),
                /* @__PURE__ */ jsx171("circle", {
                  cx: 222.5,
                  cy: 177.6,
                  r: 0.7
                }),
                /* @__PURE__ */ jsx171("circle", {
                  cx: 220.8,
                  cy: 177.6,
                  r: 0.7
                }),
                /* @__PURE__ */ jsx171("circle", {
                  cx: 219.2,
                  cy: 177.6,
                  r: 0.7
                }),
                /* @__PURE__ */ jsx171("circle", {
                  cx: 220,
                  cy: 176.3,
                  r: 0.7
                }),
                /* @__PURE__ */ jsx171("circle", {
                  cx: 221.6,
                  cy: 176.4,
                  r: 0.7
                }),
                /* @__PURE__ */ jsx171("circle", {
                  cx: 223.1,
                  cy: 176.2,
                  r: 0.7
                }),
                /* @__PURE__ */ jsx171("circle", {
                  cx: 222.4,
                  cy: 175,
                  r: 0.7
                }),
                /* @__PURE__ */ jsx171("circle", {
                  cx: 220.8,
                  cy: 174.9,
                  r: 0.7
                }),
                /* @__PURE__ */ jsx171("path", {
                  fillRule: "evenodd",
                  d: "M236.5 178c0-.3-.8-.2-.8-.6 0-.4 1.2 0 1.3.3.7-.6 1-.2 1.4 0 .6-.8 1.3-.8 2-.2.4-.4 1.4-.3 1.7.2.7-.6 1.3-.5 1.7 0 .2-.3.5-.3.7 0 .3-.7 1.2-.5 1.6 0 .3-.4.7-.1 1.1.1.3-.2.8-.2.8 0 0 .4-.6.3-.6.6 0 .2.4 0 .4.4 0 .3-.6.4-.7 0-.3.4-1.1.2-1.2-.2a.8.8 0 0 1-1.2 0c-.3.2-.7.2-.8 0-.5.5-1.4.4-1.7-.2h-.3a1 1 0 0 1-1.5 0c-.9.6-1.4.4-1.9 0-.5.7-1.4.7-1.5 0-.4.3-1.2.4-1.2 0 0-.2.7-.1.7-.4zm1.6.1c0 .2-.2.3-.4.3s-.4-.1-.4-.3.1-.2.4-.2.4.1.4.2zm1.9-.2c0 .2-.3.3-.6.3s-.5-.1-.5-.3c0-.1.2-.3.5-.3s.5.2.5.3zm3.5.2c0 .2-.2.3-.5.3s-.4-.1-.4-.3c0-.1.2-.3.4-.3s.5.1.5.3zm-1.9 0c0 .2-.2.3-.5.3s-.4-.1-.4-.4c0-.2.2-.4.4-.4s.5.2.5.4zm4 0c0 .1-.1.3-.3.3-.3 0-.5-.2-.5-.4s.2-.3.5-.3c.2 0 .4.1.4.3zm-1.2 0c0 .2 0 .3-.2.3s-.3-.1-.3-.3.1-.2.3-.2zm2.4.1c0 .2 0 .4-.3.4-.1 0-.3-.2-.3-.4s.2-.3.3-.3c.2 0 .3.1.3.3z"
                })
              ]
            }),
            /* @__PURE__ */ jsx171("use", {
              xlinkHref: "#ht_svg__d",
              width: "100%",
              height: "100%",
              transform: "matrix(-1 0 0 1 499.9 0)"
            }),
            /* @__PURE__ */ jsx171("path", {
              fill: "#0a328c",
              stroke: "#0a328c",
              d: "M249.8 165.7c-2.5 0-4.5 1-4.5 2.1 0 .2 0 .4.2.6.5.6 2.3 1 4.4 1 2 0 3.6-.3 4.2-.9.2-.2.3-.4.3-.7 0-1.1-2-2-4.6-2z"
            }),
            /* @__PURE__ */ jsx171("path", {
              d: "M254.4 168v7c0 .9-2 1.5-4.5 1.5s-4.6-.6-4.6-1.5v-7c0 .8 2 1.5 4.5 1.5 2.6 0 4.6-.7 4.6-1.5z"
            }),
            /* @__PURE__ */ jsx171("path", {
              fill: "#d20014",
              stroke: "#d20014",
              d: "M245.3 168v1l2.2 7 1.8-5.4 2 5.5 1.3-5.2 1.8 3.5v-1.9l-1.6-3.4a8.3 8.3 0 0 1-.6.2l-1 3.8-1.5-3.6a14.5 14.5 0 0 1-.7 0l-1.5 3.6-1.6-4.4c-.4-.2-.6-.5-.6-.7z"
            }),
            /* @__PURE__ */ jsx171("path", {
              fill: "#0a328c",
              stroke: "#0a328c",
              d: "M254.4 173.7v1.3c0 .9-2 1.5-4.5 1.5s-4.6-.6-4.6-1.5v-1.3c0 .9 2 1.5 4.5 1.5 2.6 0 4.6-.6 4.6-1.5z"
            }),
            /* @__PURE__ */ jsx171("path", {
              d: "m251.7 175-1.1.2v1.3l1.2-.1zm-4.8-.1v1.3l1.1.2v-1.3a8.9 8.9 0 0 1-1.1-.2zm-1.6-1.2v1.3c0 .3.2.5.5.7v-1.3c-.3-.2-.5-.4-.5-.7zm9.1.2c0 .2-.4.5-.8.7v1.3c.5-.2.8-.5.8-.9z"
            }),
            /* @__PURE__ */ jsx171("path", {
              fill: "none",
              d: "M254.4 168v7c0 .9-2 1.5-4.5 1.5s-4.6-.6-4.6-1.5v-7"
            }),
            /* @__PURE__ */ jsx171("path", {
              fill: "#fff",
              stroke: "#fff",
              d: "M253.4 167.5c0 .5-1.6 1-3.5 1-2 0-3.6-.5-3.6-1s1.6-.9 3.5-.9c2 0 3.6.4 3.6 1z"
            }),
            /* @__PURE__ */ jsx171("path", {
              d: "m248.7 168.2.2 1.2h1l.1-1.2zm4.1-.3-1 .2.1 1.2 1-.2zm-5.4-2-.7.3.1 1 .6-.2zm2.4-.3h-.3l.2 1.2h.6l.2-1.2a9.7 9.7 0 0 0-.7 0zm2.7.4-.1 1 .7.3v-1a5.3 5.3 0 0 0-.6-.3zm-6.5 2.8.2-1.3-1-.5v1.5zm8.4-.3v-1.3l-.8.3zm9.3-8.5c.8 0 2 1 2.1 2.5 0 1-1.7 1-1.7 1 0 .5-1 .9-1.8 1-.8 0 .2-1.5.2-1.5-.5-1.3.2-2.7.2-2.7z"
            }),
            /* @__PURE__ */ jsx171("path", {
              d: "M262.5 163h.8s0 .3.2.3.3-.4.3-.4h1.2"
            }),
            /* @__PURE__ */ jsx171("path", {
              fill: "#d20014",
              stroke: "#f1b517",
              d: "M264.1 160.9c.7-.5.1-1.5-.4-1.5h-1c-.6 0-1.4.6-1.3 1 0 .5.4.7.8.6.2 0 .6-.6.8-.6.3 0 1 .6 1.1.5z"
            }),
            /* @__PURE__ */ jsx171("path", {
              fillRule: "evenodd",
              d: "M214.2 174.8c-.6.1-.7.8-.5 1.5-2.6.7-5 1.7-7.4 2.4-.1-.5 1.2-1.8 1.2-1.8.3.1.6.9.6.9 0-1.6 1.6-2.6 1.6-2.6-1-.2-3.7 1-4 1.4 0 0 1-.2 1.2 0 0 0-2.2 2.3-2.3 3 .4.7 4 1.3 4 1.3 0 .2-1 1-1 1 1.5.2 3.7-.8 4.3-1.4 0 0-1.7-.2-3-1.3 0 0 .2.7 0 1 0 0-2-.6-2.3-1 0 0 5-1.2 7.4-2 .1.5.6 1.3 1.2 1.1.3-.1.2-.8 0-1.4a.8.8 0 0 0 .6.2c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7a.8.8 0 0 0-.7.5c-.1-.5-.4-1.4-.8-1.3zm2 1.6c0 .2-.2.3-.4.3a.3.3 0 0 1-.4-.3c0-.2.2-.4.4-.4s.3.2.3.4z"
            }),
            /* @__PURE__ */ jsx171("path", {
              d: "M293 177.9c.2-.4 0-2.2 0-2.2-.5 0-1 .7-1 .7.5-1.6-.8-4-.8-4 .9.1 3.9 3 4 3.6 0 0-1.3-.5-1.5-.4.3 1.5 1.3 2.2 1.7 3 0 0-1.7.3-1.6 1.8h-1.1c-.4-.5.1-1.3.1-1.3l-7.7-3.2c-.5-.2-1.6-.8-1.4-1.4.1-.5 2 .3 2.4.5z"
            }),
            /* @__PURE__ */ jsx171("path", {
              d: "m285.6 176.5 1-1.6c.3-.5-.4-1-.9-.4l-1 1.5c-.4.9.5 1.1 1 .5z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs146("g", {
          fill: "#fff",
          strokeWidth: 0.3,
          children: [
            /* @__PURE__ */ jsx171("path", {
              d: "m290.2 288.6-.1-3-3.5.3-.2 3.1z"
            }),
            /* @__PURE__ */ jsx171("path", {
              d: "m264.4 292.7-4.7-2.7c19.4 1.8 23.4-5 28.1-5.3 3-.3 3.3 3.2-2.3 1.5l1.5 3.6s-13.8 7.8-27.4 4.6zm84.8-4.1.1-3 4.3.2.2 3.1z"
            }),
            /* @__PURE__ */ jsx171("path", {
              d: "m375.9 292 4.5-2.5c-22.4.7-17.3-3.6-28.4-4.8-3-.4-5 3.4 2.2 1.5l-1.4 3.6h3.5c7.6 5 17.8 5.5 24.6 3.9z"
            }),
            /* @__PURE__ */ jsx171("path", {
              d: "M285.5 286.3v5s12.3 4.6 34.4 4.6c22.2 0 34.4-4.6 34.4-4.6v-5s-9.3 4.3-34.4 4.3c-25 0-34.4-4.3-34.4-4.3z"
            })
          ]
        }),
        /* @__PURE__ */ jsx171("path", {
          fill: "#000001",
          stroke: "none",
          d: "m287.3 291.3 1.1-3.7.5.2-1 3.2 2 .5-.2.5zm3.6-1.6v-.7l.2-.7.6.2-.2.6-.3.7zm5.3-.3.5.2-.4 2.1-.4 1a1.2 1.2 0 0 1-.5.4h-1a2 2 0 0 1-.9-.4 1 1 0 0 1-.4-.6l.1-1 .5-2.2.5.1-.5 2.2a2.1 2.1 0 0 0 0 .8.7.7 0 0 0 .2.4l.5.2h1l.4-1zm.6 4 .6-3.7h.6l1.5 3.4.5-3h.5l-.6 3.9-.5-.1-1.6-3.3-.5 3zm4 .7.6-3.8h.5l-.5 3.8h-.5zm1.6-1.7c0-.6.3-1.1.7-1.4a2 2 0 0 1 1.4-.4c.4 0 .7.1 1 .3l.5.8c.2.3.2.7.1 1a2.2 2.2 0 0 1-.3 1 1.7 1.7 0 0 1-.8.7 2 2 0 0 1-1 .1 2 2 0 0 1-1-.3 1.7 1.7 0 0 1-.5-.8 2.1 2.1 0 0 1-.1-1m.5 0c0 .5 0 1 .3 1.2.2.3.5.5.9.5s.7 0 1-.3c.3-.2.4-.6.5-1a1.9 1.9 0 0 0 0-1 1.2 1.2 0 0 0-.5-.5 1.3 1.3 0 0 0-.7-.3c-.3 0-.7 0-1 .3-.2.2-.4.6-.5 1.2zm3.7 2.3.3-3.8h.6l1.8 3.2.2-3h.5l-.3 3.9h-.5l-1.9-3.2-.2 3zm5.6.4.1-3.8 2.7.1v.5l-2.1-.1-.1 1.1 1.9.1v.5l-2-.1v1.8zm3 .1 1.5-3.8h.6l1.5 4h-.6l-.4-1.3h-1.7l-.4 1.2zm1-1.5h1.4l-.4-1a9.8 9.8 0 0 1-.2-.9l-.2.8-.5 1.1zm3.1 1.6v-3.8h.6v3.8zm2.5 0V292h-1.3v-.4h3.1v.4h-1.3v3.4zm4 0-.3-4h.6l.1 3.4h2v.4zm2.6-.2 1.2-4h.6l2 3.7h-.7l-.5-1h-1.7l-.3 1.3zm1-1.7h1.4l-.5-1-.4-.9a4.8 4.8 0 0 1-.1.8zm4.7 1.2-.4-3.8 2.6-.3.1.5-2.1.2v1.2l2-.2v.5l-1.9.2.2 1.7zm3-2.1a2 2 0 0 1 .2-1.6 2 2 0 0 1 1.3-.7l1 .1c.4.1.6.3.8.6l.4 1-.1 1a1.6 1.6 0 0 1-.6.8 2 2 0 0 1-.9.4 2 2 0 0 1-1-.1 1.7 1.7 0 0 1-.8-.6 2.1 2.1 0 0 1-.4-1zm.5-.1c0 .4.2.8.5 1 .3.3.6.3 1 .3s.7-.2 1-.5c.2-.3.2-.7.2-1.2a2 2 0 0 0-.3-.8 1.3 1.3 0 0 0-.6-.5 1.4 1.4 0 0 0-.7 0c-.4 0-.7.1-1 .4-.1.3-.2.7-.1 1.3m4.1 1.3-.6-3.8 1.7-.3h.8c.2 0 .4 0 .5.2l.3.6c0 .3 0 .5-.2.7-.1.2-.4.4-.7.5a1.4 1.4 0 0 1 .3.1l.5.5 1 .9h-.7l-.7-.6a7.4 7.4 0 0 0-.5-.5 1.2 1.2 0 0 0-.3-.2.8.8 0 0 0-.3 0h-.3l-.6.1.4 1.7zm.2-2.2 1-.2a1.7 1.7 0 0 0 .6-.2.6.6 0 0 0 .3-.6.6.6 0 0 0-.2-.4h-.7l-1.3.1zm6.3-.4h.5c0 .4-.1.8-.3 1a2 2 0 0 1-1 .6 2 2 0 0 1-1 0 1.6 1.6 0 0 1-.8-.6 2.6 2.6 0 0 1-.5-1 2.2 2.2 0 0 1 0-1c0-.4.3-.7.5-.9l.9-.4h1c.4.2.6.4.8.8l-.5.2a1.2 1.2 0 0 0-.5-.5 1.1 1.1 0 0 0-.7 0 1 1 0 0 0-.7.3 1.1 1.1 0 0 0-.3.7v.7a2.3 2.3 0 0 0 .4.8c.1.2.3.4.6.4h.7a1.1 1.1 0 0 0 .6-.3c.2-.2.3-.5.3-.8m1.4 1-1-3.7 2.7-.7.2.4-2.3.6.3 1.1 2.1-.5.2.4-2.2.6.4 1.2 2.4-.6v.4z"
        })
      ]
    })
  ]
});
var Ht_default = SvgHt;

// src/country-flag-icons/generated/Hu.tsx
init_esm_shims();
import { jsx as jsx172, jsxs as jsxs147 } from "react/jsx-runtime";
var SvgHu = (props) => /* @__PURE__ */ jsx172("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs147("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx172("path", {
        fill: "#fff",
        d: "M640 480H0V0h640z"
      }),
      /* @__PURE__ */ jsx172("path", {
        fill: "#388d00",
        d: "M640 480H0V320h640z"
      }),
      /* @__PURE__ */ jsx172("path", {
        fill: "#d43516",
        d: "M640 160.1H0V.1h640z"
      })
    ]
  })
});
var Hu_default = SvgHu;

// src/country-flag-icons/generated/Id.tsx
init_esm_shims();
import { jsx as jsx173, jsxs as jsxs148 } from "react/jsx-runtime";
var SvgId = (props) => /* @__PURE__ */ jsxs148("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx173("path", {
      fill: "#e70011",
      d: "M0 0h640v240H0Z"
    }),
    /* @__PURE__ */ jsx173("path", {
      fill: "#fff",
      d: "M0 240h640v240H0Z"
    })
  ]
});
var Id_default = SvgId;

// src/country-flag-icons/generated/Ie.tsx
init_esm_shims();
import { jsx as jsx174, jsxs as jsxs149 } from "react/jsx-runtime";
var SvgIe = (props) => /* @__PURE__ */ jsx174("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs149("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    children: [
      /* @__PURE__ */ jsx174("path", {
        fill: "#fff",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsx174("path", {
        fill: "#009A49",
        d: "M0 0h213.3v480H0z"
      }),
      /* @__PURE__ */ jsx174("path", {
        fill: "#FF7900",
        d: "M426.7 0H640v480H426.7z"
      })
    ]
  })
});
var Ie_default = SvgIe;

// src/country-flag-icons/generated/Il.tsx
init_esm_shims();
import { jsx as jsx175, jsxs as jsxs150 } from "react/jsx-runtime";
var SvgIl = (props) => /* @__PURE__ */ jsxs150("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx175("defs", {
      children: /* @__PURE__ */ jsx175("clipPath", {
        id: "il_svg__a",
        children: /* @__PURE__ */ jsx175("path", {
          fillOpacity: 0.7,
          d: "M-87.6 0H595v512H-87.6z"
        })
      })
    }),
    /* @__PURE__ */ jsxs150("g", {
      fillRule: "evenodd",
      clipPath: "url(#il_svg__a)",
      transform: "translate(82.1) scale(.94)",
      children: [
        /* @__PURE__ */ jsx175("path", {
          fill: "#fff",
          d: "M619.4 512H-112V0h731.4z"
        }),
        /* @__PURE__ */ jsx175("path", {
          fill: "#0038b8",
          d: "M619.4 115.2H-112V48h731.4zm0 350.5H-112v-67.2h731.4zm-483-275 110.1 191.6L359 191.6z"
        }),
        /* @__PURE__ */ jsx175("path", {
          fill: "#fff",
          d: "m225.8 317.8 20.9 35.5 21.4-35.3z"
        }),
        /* @__PURE__ */ jsx175("path", {
          fill: "#0038b8",
          d: "M136 320.6 246.2 129l112.4 190.8z"
        }),
        /* @__PURE__ */ jsx175("path", {
          fill: "#fff",
          d: "m225.8 191.6 20.9-35.5 21.4 35.4zM182 271.1l-21.7 36 41-.1-19.3-36zm-21.3-66.5 41.2.3-19.8 36.3zm151.2 67 20.9 35.5-41.7-.5zm20.5-67-41.2.3 19.8 36.3zm-114.3 0L189.7 256l28.8 50.3 52.8 1.2 32-51.5-29.6-52z"
        })
      ]
    })
  ]
});
var Il_default = SvgIl;

// src/country-flag-icons/generated/Im.tsx
init_esm_shims();
import { jsx as jsx176, jsxs as jsxs151 } from "react/jsx-runtime";
var SvgIm = (props) => /* @__PURE__ */ jsxs151("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx176("defs", {
      children: /* @__PURE__ */ jsx176("clipPath", {
        id: "im_svg__a",
        children: /* @__PURE__ */ jsx176("path", {
          fillOpacity: 0.7,
          d: "M-77.6 0H605v512H-77.6z"
        })
      })
    }),
    /* @__PURE__ */ jsxs151("g", {
      clipPath: "url(#im_svg__a)",
      transform: "translate(72.8) scale(.94)",
      children: [
        /* @__PURE__ */ jsx176("path", {
          fill: "#ba0000",
          fillRule: "evenodd",
          d: "M629.4 512H-102V0h731.4z"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "#ffef00",
          fillRule: "evenodd",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "M281 376c.2-.6.6-6.8.4-6.8s-9.4-10.9-9.2-10.9c.2 0 11.8 2.6 11.8 2.2 0-.4 4.7-11.5 4.7-11.7l5.6 13.5 11.5 5-8 6.7 1.7 13c0 .3-8-7.6-8-7.6l-8.9 1s-1.2-4-1.6-4.4z"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "#fff",
          fillRule: "evenodd",
          stroke: "#000",
          strokeWidth: 2.6,
          d: "M218.7 206.9c-7.7 4-37 37.5-41 42.7a77.3 77.3 0 0 1-16.8 23.4c-7.3 5.5-11.3 13-10.3 20 0 9 4.9 15 8.8 21.1 2.3 2.9 5.5 4.7 8.8 5 6.9.8 7.5 3 11 4.2 13.4 18.4 33.6 32 48 42.7a68.4 68.4 0 0 1 18 12.4c4.2 8.2 3.4 16 2.8 20L237.3 439c-1.9 11 7.8 8.6 8.3 6.4 4.3-5.7 10.8-1.7 20-34.3l12.8-17.1s4.9-2 4.9-2.5c7.5-9 1.8-14-2.5-15.7l-9.2-3.4s-10.8-10.8-11.3-10.8c-5.1-14.9-30.3-46.6-36.1-51-4-4.3-6-6-9.8-8.4-5.9-2.8-7.8-3.8-11.4-5.2-3-1.2-.9-4.5 1-6 20-10.9 35.7-22.9 54.8-35.1l3-2-6.9-39.2-31.8-11.2c-1.7 1.1-3 2.3-4.4 3.4z"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "#ffec00",
          fillRule: "evenodd",
          d: "M245.3 413.1c0-.4 20-4 20-4l-2.5 7.4-19.7 6z"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "M193.6 338.5a37.9 37.9 0 0 1 21.6-20.4"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 2.4,
          d: "M244.6 413.3c1.3-.3 7-2 8.6-2.3 1.8-.4 3.5-.8 5.2-1.4 2-.4 3.2-.8 5.2-1.1a39 39 0 0 1 5-1.4M241 425.6a14.6 14.6 0 0 1 2.5-2c1.1-.4 5-2 6.5-2.3a54 54 0 0 0 4.7-1.4l4.6-1.2c1.5-.6 2.9-1 4.4-1.4"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "M249 341.4h-.2c.8 0 .3 0-.9 1.4-.4 1.1-4 3.7-6.8 3.7a53 53 0 0 1-4.7.3l-1.3-.3m13.7 53.5h1.4c1.5 0 3 .3 4.2.3 1.5 0 2.9.4 4.3.4 1.5.2 3.2.1 4.7.4 1.6 0 3 .3 4.7.3 1.4.1 2.2.3 3.7.3l-3.7-.3c1.4.1 2.2.3 3.7.3m-32.7 33a13.6 13.6 0 0 1 2.3-2c1-.3 4.6-2 6-2.2a46.7 46.7 0 0 0 4.2-1.5l4.3-1c1.3-.7 2.6-1.1 4-1.5m5.8-41.2c-.8 2.3.3 2.9.7 3.9a12 12 0 0 0 5.7 3.4c1.2.3 2 .6 3.4 1.2.9 0 1.3.3 2 .5m-124.4-94.8h.3c-.9 0-.3.1 1.1-1 1-1.1 1.7-1.6 2.6-2.7m14.4 24c.2 0 16.6-8.2 18.3-10l3.7-2.9c1-.5 1.7-1.1 2.6-1.7.7-1 1.7-1.7 2.3-2.7 1-.9.5-1.8 1.4-2.9l1.3-3.8m20.8 12.2c.1.6-.2 2.4-.2 3.8 0 1.6-2.1 6.5-4.6 8"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "m192.6 307.8 6.7 2.1c5 1.8 15.4 8.4 16.5 9.3 1 .8 3 1.6 3.6 2.5 1.2 1 2 2.1 2.9 3.2 1 1.2 2 2.3 2.5 3.4a113.2 113.2 0 0 1 13.4 24.5c.7.7 1 1.7 1.7 2.8.6 1.4 1.3 2 2 3.1 1 .7 2.2 2 3.4 2.6 1.3 1.1 2.5 1.5 3.5 2.3 1.3.6 16.3 10 17 10.5 1.4 1.1 5.5 5.4 2.6 8.6-1.2 1-2.4 2.5-3.4 3-1.1 1.2-2.6 1.7-3.9 2.2-6.7 2-10.2 1.3-11.5 1.3h-1.4m-88.8-114.9c2 .8 1.2.2 2.9 1 1.2.5 2 .5 3 1 1.3.3 4.7 1 6.3 2.6 1.2 1 2 2 3.4 2.7a21.8 21.8 0 0 0 4.6 2.4c1.6.6 3.4 1.3 5 1.3h7.8-4 4"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "#ffe606",
          fillRule: "evenodd",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "M159 293.3c4.2-.3 11.3 1 11.5 1l9.4-.2c5-.4 6-2.3 6.8-3.7 1.9-2.8 3.1-3.8 4.6-6 2.2-1.6 5.4 2.3 5.5 2.3 8 7.6 1.6 16.8 1.2 17.1-4 3.7-4.9 3.9-7.3 1.6-2.4-2.9-3.1-4.2-5.1-5.2-3.9-1.8-11.8-.4-12-.4l-4.1 1.6c-2 .7-3.2 2.4-6.5 3-3.5.2-4.6-.1-6.3-2.9-2.3-3.5-1.2-7.8 2.3-8.2z"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "#ffef00",
          fillRule: "evenodd",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "M381.8 120.7c-.6 0-6.3 2.8-6.2 3 .1.1-4.8 13.5-4.9 13.4-.1-.2-3.5-11.7-3.9-11.5-.3.2-12.3 1.6-12.4 1.7l9-11.5-1.3-12.5 9.8 3.8 10.5-8c.2-.1-2.7 10.8-2.7 10.8l5.2 7.2s-3 3-3.1 3.6z"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "#fff",
          fillRule: "evenodd",
          stroke: "#000",
          strokeWidth: 2.6,
          d: "M265 257.9c7.1 4.7 50.7 13.9 57.3 14.8a77 77 0 0 1 28.6 3.2c8.3 3.6 16.8 3.4 22.5-1 7.8-4.2 10.6-11.4 14-18a12 12 0 0 0 0-10c-2.6-6.4-1-8-1.6-11.6 9.4-20.8 11.4-45 13.6-62.9-.2-10.5.9-18.5 2-21.7a32 32 0 0 1 16-12.2l40.7-10.6c10.6-3.8 3.7-11 1.5-10.4-7-1-6.8-8.6-39.7-.7l-21.2-2.7s-4-3.3-4.5-3c-11.5-2.1-13.1 5.3-12.5 9.8l1.6 9.8s-4.1 14.6-3.9 15c-10.5 11.8-26 49.6-27 56.9-.5 6.8-3 5.5-2.4 12.2 0 5.2-.6 2 1.1 12.6.5 3.2-3.5 3-5.7 2-19.2-12-37.4-19.9-57.5-30.5l-3.1-1.6-30.8 25.2 5.8 33.2c1.8 1 3.4 1.5 5.1 2.2z"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "#ffec00",
          fillRule: "evenodd",
          d: "M431.7 133.6a375 375 0 0 1-13.3-15.4l7.6-1.5 14.8 14.3z"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "M392 215.2a37.9 37.9 0 0 1-28.4-8.8"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 2.4,
          d: "M432.2 134.1c-1-.9-5.2-5-6.2-6.4a66.5 66.5 0 0 0-3.8-3.8c-1.3-1.5-2.3-2.4-3.6-4a37.1 37.1 0 0 1-3.6-3.6m29.6 15c-.3 0-2-.7-3-1.2-.8-.9-4.2-3.4-5.1-4.6a54.2 54.2 0 0 0-3.5-3.4c-1.2-1.3-2.1-2-3.3-3.5a30.3 30.3 0 0 1-3.4-3"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "m367.3 165.5.1.3c-.4-.8-.2-.3 1.7 0 1.2-.2 5.2 1.7 6.5 4.1.8 1.1 2 2.8 2.6 4 .2.3.2 1 .4 1.3m40-38.2-.2-.2-.6-1-1.8-3.9c-.7-1.2-1-2.7-1.7-3.9-.6-1.4-1.5-2.8-2-4.2-.8-1.5-1.2-2.8-2-4.4-.7-1.2-.8-2-1.6-3.3l1.6 3.3c-.7-1.2-.8-2-1.6-3.3m44.8 12.3a12 12 0 0 1-2.8-1c-.8-.7-4-3-5-4a47 47 0 0 0-3.3-3c-1-1.3-1.9-2-3-3.3a26.2 26.2 0 0 1-3.2-2.7m-38.9 15c2.5-.4 2.5-1.6 3.1-2.5.5-1 .9-3.5.2-6.6l-.6-3.5c-.4-.9-.4-1.4-.5-2m-21.7 154.8-.1-.2c.4.8.2.3-1.6-.5l-3.5-1m13.9-24.3c-.1-.2-15.3-10.4-17.7-11-1.4-.7-2.7-1-4.3-1.8l-2.8-1.4c-1.3-.2-2.4-.7-3.5-.7-1.2-.4-1.9.4-3.2.2l-4 .7m.5-24.1c.4-.4 2.2-1 3.4-1.7 1.4-.7 6.7-1.3 9.2.1"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "m365.7 231.2-1.5-7a100 100 0 0 1 0-18.8c.2-1.3 0-3.4.5-4.5.3-1.4.8-2.7 1.3-4 .6-1.5 1.1-2.8 1.7-3.9.7-4 12-20.1 12.8-20.9a43 43 0 0 1 2-2.7c.3-1 1-1.8 1.6-3 1-1.1 1.2-2 1.8-3.2.1-1.1.6-2.9.6-4.2.3-1.7 0-3 .3-4.1-.2-1.5.7-19.2.8-20 .3-1.8 2-7.5 6.2-6.5 1.5.5 3.3.8 4.4 1.5 1.4.4 2.6 1.5 3.7 2.3 5 4.9 6.1 8.2 6.8 9.4l.7 1.2M352.6 276l-.1-.2c.4.7.2.3-.3-1.1-.1-1.3-.5-3-.7-4.2-.3-1.3-.9-2.7-.7-3.5-.5-1.3-.2-2.3 0-3.6.3-1.6.5-2.7.5-4.2.2-2 0-3.2.1-5-.5-1.5-.6-2.7-1.3-4.2l-2-4-2-3.5 2 3.4-2-3.4"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "#ffe606",
          fillRule: "evenodd",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "M369.5 267.6c-2.3-3.6-4.7-10.4-4.8-10.5l-4.7-8.2c-2.8-4-5-4-6.6-4-3.4-.3-4.9-1-7.4-1.1-2.6-1.2-.7-5.9-.8-6 2.7-10.6 14-9.6 14.4-9.4 5.1 1.7 5.7 2.4 4.9 5.6-1.3 3.5-2 4.8-2 7 .3 4.2 5.5 10.5 5.5 10.6l3.4 2.8c1.6 1.4 3.7 1.6 5.8 4.3 1.9 2.9 2.2 4 .6 6.8-2 3.8-6.2 4.9-8.3 2.1z"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "#ffef00",
          fillRule: "evenodd",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "M105.2 168.7c.5.4 5.8 3.7 6 3.5s14-3.4 13.8-3.2-7.8 9.3-7.4 9.5c.4.2 8 9.4 8.2 9.5l-14.5-1.2-9.8 7.8-2.2-10.2L87 180c-.2-.1 10.5-3.6 10.5-3.6l3.2-8.3s4.1.7 4.7.6z"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "#fff",
          fillRule: "evenodd",
          stroke: "#000",
          strokeWidth: 2.6,
          d: "M284 191.3c0-8.7-16.2-50.2-19-56.1a77.2 77.2 0 0 1-13-25.7c-1.5-9-6.3-16-13-18.4-7.9-4.1-15.5-2.5-22.8-1.8-3.6.7-6.7 2.7-8.4 5.5-4 5.7-6.1 5.2-8.9 7.7-22.5 3.5-43.8 15.1-60 23a68 68 0 0 1-19.3 10.2 32 32 0 0 1-19-6.6l-31.1-28.3c-9-6.7-11.2 3-9.5 4.5 3 6.4-3.5 10.3 21.2 33.6l9.3 19.2s-.5 5.2 0 5.4c4.4 10.8 11.6 8.1 15 5.1l7.3-6.7s14.5-4.6 14.7-5c15.6 2.3 55.8-5.3 62.4-8.5 6-3.3 6.3-.5 11.5-4.7 4.3-2.9 2-.6 10-7.9 2.4-2 4.3 1.3 4.8 3.7.4 22.7 3.8 42.2 5.9 64.8l.4 3.5 38 12 24.6-23-1-5.6z"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "#ffec00",
          fillRule: "evenodd",
          d: "M88.7 119.8c.3.3-5.6 19.6-5.6 19.6l-5.4-5.5 3.8-20.3z"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "M178.8 108.4c7.2 8 9.5 21.2 8.2 28.6"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 2.4,
          d: "M89 119.1c-.3 1.3-1.5 7.2-2 8.7a66.8 66.8 0 0 0-1.2 5.3l-1.4 5.2c-.2 1.7-.5 3.3-1 5m-3.7-33c.1.3.5 2 .6 3.1-.2 1.2-.5 5.4-1 6.9a54.4 54.4 0 0 0-.9 4.8l-1 4.6a30.6 30.6 0 0 1-.8 4.6"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "m150.7 156.3.1-.3c-.4.8 0 .3-.8-1.4-.9-1-1.4-5.3-.2-7.8a55 55 0 0 1 2-4.3c.1-.3.6-.7.8-1M98.8 129l-.1.2-.6 1c-.6 1.4-1.6 2.6-2.2 3.7-.6 1.3-1.7 2.3-2.3 3.6l-2.4 4c-.9 1.4-1.8 2.5-2.6 4l-2 3.2 2-3.2-2 3.2m-14.2-44.3c.2.2.7 1.9.8 3-.2 1-.4 5-.8 6.3l-.7 4.4c-.4 1.6-.5 2.7-1 4.3a26.2 26.2 0 0 1-.5 4.2M104 151c-1.7-1.9-2.7-1.2-3.8-1.3a12 12 0 0 0-5.7 3.5c-.8.9-1.5 1.6-2.6 2.5-.5.8-.9 1-1.4 1.5M232 90.4l-.1.3c.4-.8.1-.4.5 1.5.5 1.3.5 2.2 1 3.4m-27.9 1.8c0 .2-.3 18.5.5 20.9.2 1.5.6 2.7.8 4.6 0 1 .3 2 .4 3 .6 1.2.7 2.4 1.4 3.3.3 1.3 1.3 1.4 1.9 2.5.7.9 2 2.4 2.8 3m-20.5 12.9c-.6-.2-2-1.4-3.2-2-1.4-.8-4.9-4.9-5-7.8"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "m206.5 121.6-5 5a94.3 94.3 0 0 1-15.8 10.3c-1.2.6-2.7 2-4 2.1-1.3.6-2.7.8-4 1.1a113.4 113.4 0 0 1-28.7 1.5 43.2 43.2 0 0 1-3.4-.2c-1 .2-2 .1-3.3.2-1.6-.1-2.4.2-3.7.3-1 .6-2.7 1.1-3.9 1.9-1.5.6-2.5 1.5-3.6 2-1 .9-16.4 9.8-17.2 10.2-1.6.7-7.3 2.5-8.8-1.6-.4-1.6-1-3.3-1.1-4.5-.5-1.4-.2-3-.2-4.4 1.4-6.9 3.6-9.6 4.2-10.8l.7-1.2M251 108l-.1.3c.3-.7.2-.4-.8.8-1 .8-2.2 2-3.1 3-1 .8-1.8 2-2.6 2.4-.8 1-1.8 1.4-3 2a20 20 0 0 0-3.8 1.9c-1.7.8-2.7 1.7-4.2 2.6-1 1.2-2 2-2.8 3.4-.8 1.3-1.6 2.4-2.3 3.9l-1.8 3.5 1.8-3.5-1.8 3.5m11.7 73.1.3-.5c-.5 1-.4.7.1-.9 0-1.8.5-4.1.5-5.8.3-1.8.6-3.7.6-5.5-.1-2-.1-4-.4-6 0-1.8-.3-3.7-.3-5.6 0-1.8-.2-3.3-.6-5a29.5 29.5 0 0 0-.4-4.8c.1-1.2-.2-2.4-.5-3.4l-1.2-5.1-1-4.1c-.2-1.6-1-3.6-1.4-4.9a13.6 13.6 0 0 1-1.1-3.4c-.5-1.1-1.2-2.4-1.3-3.6l-1.6-3.7-1.4-3.6c-.5-1.4-1.1-2.6-1.5-4-.5-.5-.6-1-.8-1.4"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "#ffe606",
          fillRule: "evenodd",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "M234.9 98.5a59 59 0 0 1-6.2 9.7l-4.2 8.4c-1.8 4.6-.7 6.5.1 7.8 1.7 3 2 4.6 3.2 6.8.5 2.8-4.5 3.8-4.5 3.9-10.4 3.6-15.7-6.4-15.7-6.9-1.4-5.2-1.2-6 2-7.1 3.6-.9 5-1 6.8-2.2 3.5-2.6 5.9-10.3 6-10.4l.4-4.4c.3-2-.6-4 .4-7.2 1.4-3.2 2.2-4 5.4-4.3 4.2-.3 7.5 2.6 6.3 5.9z"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "#ffef00",
          fillRule: "evenodd",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "M221.3 199.7c-1.6-1.5 29.4 11.2 33.7 11.3 5.8-2.1 29.9-22.4 29.9-22.4.2 2 1.1 7.1 3.4 8.2-9.3 7.5-17.7 14.8-27 22.3.6 12-1.5 24.7 4.5 38 0 0-7.2.2-7.2 0-6.4-6.4-8.7-37.2-8.7-37.2l-30.6-13.6c1.5-1 2.6-3.9 2-6.7z"
        }),
        /* @__PURE__ */ jsx176("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "M250.8 231.3c.5-.4-5.6 2.8-7.2 3.6-28.1 15-42.6 37-43.5 37.8l-2.2 3.4-2.3 3a60.6 60.6 0 0 1-3.6 4.7c-.2.6.4-.3.2.2m77.9-70.6a79 79 0 0 0 6.5 4.7c26.2 18.2 52.3 21.1 53.5 21.5 1 0 2.5.3 4 .5 1.2 0 2.6.4 3.8.5 1.4.2 4.4.8 5.8 1.2.6-.2-.5-.3 0-.4"
        })
      ]
    })
  ]
});
var Im_default = SvgIm;

// src/country-flag-icons/generated/In.tsx
init_esm_shims();
import { jsx as jsx177, jsxs as jsxs152 } from "react/jsx-runtime";
var SvgIn = (props) => /* @__PURE__ */ jsxs152("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx177("path", {
      fill: "#f93",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsx177("path", {
      fill: "#fff",
      d: "M0 160h640v160H0z"
    }),
    /* @__PURE__ */ jsx177("path", {
      fill: "#128807",
      d: "M0 320h640v160H0z"
    }),
    /* @__PURE__ */ jsxs152("g", {
      transform: "matrix(3.2 0 0 3.2 320 240)",
      children: [
        /* @__PURE__ */ jsx177("circle", {
          r: 20,
          fill: "#008"
        }),
        /* @__PURE__ */ jsx177("circle", {
          r: 17.5,
          fill: "#fff"
        }),
        /* @__PURE__ */ jsx177("circle", {
          r: 3.5,
          fill: "#008"
        }),
        /* @__PURE__ */ jsxs152("g", {
          id: "in_svg__d",
          children: [
            /* @__PURE__ */ jsxs152("g", {
              id: "in_svg__c",
              children: [
                /* @__PURE__ */ jsxs152("g", {
                  id: "in_svg__b",
                  children: [
                    /* @__PURE__ */ jsxs152("g", {
                      id: "in_svg__a",
                      fill: "#008",
                      children: [
                        /* @__PURE__ */ jsx177("circle", {
                          r: 0.9,
                          transform: "rotate(7.5 -8.8 133.5)"
                        }),
                        /* @__PURE__ */ jsx177("path", {
                          d: "M0 17.5.6 7 0 2l-.6 5z"
                        })
                      ]
                    }),
                    /* @__PURE__ */ jsx177("use", {
                      xlinkHref: "#in_svg__a",
                      width: "100%",
                      height: "100%",
                      transform: "rotate(15)"
                    })
                  ]
                }),
                /* @__PURE__ */ jsx177("use", {
                  xlinkHref: "#in_svg__b",
                  width: "100%",
                  height: "100%",
                  transform: "rotate(30)"
                })
              ]
            }),
            /* @__PURE__ */ jsx177("use", {
              xlinkHref: "#in_svg__c",
              width: "100%",
              height: "100%",
              transform: "rotate(60)"
            })
          ]
        }),
        /* @__PURE__ */ jsx177("use", {
          xlinkHref: "#in_svg__d",
          width: "100%",
          height: "100%",
          transform: "rotate(120)"
        }),
        /* @__PURE__ */ jsx177("use", {
          xlinkHref: "#in_svg__d",
          width: "100%",
          height: "100%",
          transform: "rotate(-120)"
        })
      ]
    })
  ]
});
var In_default = SvgIn;

// src/country-flag-icons/generated/Io.tsx
init_esm_shims();
import { jsx as jsx178, jsxs as jsxs153 } from "react/jsx-runtime";
var SvgIo = (props) => /* @__PURE__ */ jsxs153("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx178("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "#000063",
      fillRule: "evenodd",
      d: "M640 416.2c-7.2 6.7-13.3 22-32.4 22-38.1 0-47.6-32.5-76.2-32.5-19 0-28.5 32.5-47.6 32.5-38.1 0-47.6-32.5-76.2-32.5-19 0-28.5 32.5-47.5 32.5-38.2 0-47.7-32.5-76.3-32.5-19 0-28.6 32.5-47.6 32.5-38.1 0-47.6-32.5-76.2-32.5-19 0-28.6 32.5-47.6 32.5-38.2 0-47.7-32.5-76.2-32.5-19 0-24.8 23.2-36.2 23.2v41.7c11.4 0 17.1-23 36.3-23 28.5 0 38 32.4 76 32.4 19.1 0 28.6-32.5 47.7-32.5 28.6 0 38.1 32.5 76.3 32.5 19 0 28.4-32.5 47.5-32.5 28.6 0 38.1 32.5 76.2 32.5 19 0 28.6-32.5 47.6-32.5 28.6 0 38.1 32.5 76.2 32.5 19 0 28.6-32.5 47.6-32.5 28.6 0 38.2 32.5 76.2 32.5 19 0 25.2-9.2 32.4-15.8zm0-81.2c-7.2 6.7-13.3 22-32.4 22-38.1 0-47.6-32.5-76.2-32.5-19 0-28.5 32.5-47.6 32.5-38.1 0-47.6-32.5-76.2-32.5-19 0-28.5 32.5-47.5 32.5-38.2 0-47.7-32.5-76.3-32.5-19 0-28.6 32.5-47.6 32.5-38.1 0-47.6-32.5-76.2-32.5-19 0-28.6 32.5-47.6 32.5-38.2 0-47.7-32.5-76.2-32.5-19 0-24.8 23.2-36.2 23.2v41.8c11.4 0 17.1-23.1 36.3-23.1 28.5 0 38 32.5 76 32.5 19.1 0 28.6-32.5 47.7-32.5 28.6 0 38.1 32.5 76.3 32.5 19 0 28.4-32.5 47.5-32.5 28.6 0 38.1 32.5 76.3 32.5 19 0 28.5-32.5 47.5-32.5 28.6 0 38.1 32.5 76.2 32.5 19 0 28.6-32.5 47.6-32.5 28.6 0 38.2 32.5 76.2 32.5 19 0 25.2-9.2 32.4-15.8zm0-81.1c-7.2 6.7-13.3 22-32.4 22-38.1 0-47.6-32.5-76.2-32.5-19 0-28.5 32.5-47.6 32.5-38.1 0-47.6-32.5-76.2-32.5-19 0-28.5 32.5-47.5 32.5-38.2 0-47.7-32.5-76.3-32.5-19 0-28.6 32.5-47.6 32.5-38.1 0-47.6-32.5-76.2-32.5-19 0-28.6 32.5-47.6 32.5-38.2 0-47.7-32.5-76.2-32.5-19 0-24.8 23.2-36.2 23.2v41.8c11.4 0 17.1-23.2 36.3-23.2 28.5 0 38 32.5 76 32.5 19.1 0 28.6-32.5 47.7-32.5 28.6 0 38.1 32.5 76.3 32.5 19 0 28.4-32.5 47.5-32.5 28.6 0 38.1 32.5 76.3 32.5 19 0 28.5-32.5 47.5-32.5 28.6 0 38.1 32.5 76.2 32.5 19 0 28.6-32.5 47.6-32.5 28.6 0 38.2 32.5 76.2 32.5 19 0 25.2-9.2 32.4-15.8zm0-81.1c-7.2 6.6-13.3 22-32.4 22-38.1 0-47.6-32.5-76.2-32.5-19 0-28.5 32.5-47.6 32.5-38.1 0-47.6-32.5-76.2-32.5-19 0-28.5 32.5-47.5 32.5-38.2 0-47.7-32.5-76.3-32.5-19 0-28.6 32.5-47.6 32.5-38.1 0-47.6-32.5-76.2-32.5-19 0-28.6 32.5-47.6 32.5-38.2 0-47.7-32.5-76.2-32.5-19 0-24.8 23.2-36.2 23.2v41.7c11.4 0 17.1-23 36.3-23 28.5 0 38 32.4 76 32.4 19.1 0 28.6-32.5 47.7-32.5 28.6 0 38.1 32.5 76.3 32.5 19 0 28.4-32.5 47.5-32.5 28.6 0 38.1 32.5 76.3 32.5 19 0 28.5-32.5 47.5-32.5 28.6 0 38.1 32.5 76.2 32.5 19 0 28.6-32.5 47.6-32.5 28.6 0 38.2 32.5 76.2 32.5 19 0 25.2-9.3 32.4-15.9zm0-81.3c-7.2 6.7-13.3 22.1-32.4 22.1-38.1 0-47.6-32.5-76.2-32.5-19 0-28.5 32.5-47.6 32.5-38.1 0-47.6-32.5-76.2-32.5-19 0-28.5 32.5-47.5 32.5-38.2 0-47.7-32.5-76.3-32.5-19 0-28.6 32.5-47.6 32.5-38.1 0-47.6-32.5-76.2-32.5-19 0-28.6 32.5-47.6 32.5-38.2 0-47.7-32.5-76.2-32.5-19 .1-24.8 23.3-36.2 23.3v41.8c11.4 0 17.1-23.1 36.2-23.1 28.5 0 38.1 32.5 76.2 32.5 19 0 28.5-32.5 47.6-32.5 28.6 0 38.1 32.5 76.3 32.5 19 0 28.4-32.5 47.4-32.5 28.7 0 38.2 32.5 76.3 32.5 19 0 28.6-32.5 47.6-32.5 28.6 0 38.1 32.5 76.2 32.5 19 0 28.6-32.5 47.6-32.5 28.6 0 38.2 32.5 76.2 32.5 19 0 25.2-9.3 32.4-15.9v-48Zm0-81c-7.2 6.6-13.3 22-32.4 22C569.5 32.5 560 0 531.4 0c-19 0-28.5 32.5-47.6 32.5-38.1 0-47.6-32.5-76.2-32.5-19 0-28.5 32.5-47.5 32.5-38.2 0-47.7-32.5-76.3-32.5-19 0-28.6 32.5-47.6 32.5C198 32.5 188.6 0 160 0c-19 0-28.6 32.5-47.6 32.5C74.2 32.5 64.7 0 36.2 0 17.2 0 11.4 23.2 0 23.2v41.9C11.4 65 17.1 42 36.2 42c28.5 0 38.1 32.4 76.2 32.4 19 0 28.5-32.4 47.6-32.4 28.6 0 38.1 32.4 76.3 32.4 19 0 28.4-32.4 47.4-32.4 28.7 0 38.2 32.4 76.3 32.4 19 0 28.6-32.4 47.6-32.4 28.6 0 38.1 32.4 76.2 32.4 19 0 28.6-32.4 47.6-32.4 28.6 0 38.2 32.4 76.2 32.4 19 0 25.2-9.2 32.4-15.8z"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "#a24300",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 2.1,
      d: "m474.8 131.7-3.5 329c0 17.3 15.7 17.3 17.4 0l-3.5-329Z"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "#006d00",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 1.8,
      d: "m510.7 254-11-11.9-2.6 12.1-4.7-17.5-4.5 8.8-.8-18.6-4.4 8.8-.8-18.6-4.4 8.8L475 204l-4.4 8.8L468 191l-4.5 8.8-2.5-21.9-1.3-11 2.2-4.3 5.8 2.1 9.1 8.7 18.3 17.4-11.3-4.3 18.3 17.4-11.4-4.3 18.3 17.3-11.4-4.2 16.6 14-11.3-4.2 16.5 14-11.3-4.2 12.6 15.2-13.1-7.6 3 14.3z"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M510.7 254 462 162.6m33.1 28.2L469 175.6l-5.4 24.1"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m502.2 203.8-26.3-15.1-5.3 24.1"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m509.1 216.8-26.2-15-5.4 24"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m514.3 226.7-24.5-11.9-7 21"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M519.5 236.5 495 224.6l-7 21"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m520.8 247.4-22.3-16.2-1.4 23"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "#006d00",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 2,
      d: "m383 97.9 17.8 6.8-5.2-13.5 15.6 15.3-1.5-11 12.6 18.4-1.5-11 12.6 18.4-1.5-11 16.3 20.8-1.5-11 16.3 20.8-1.4-11 16.2 20.8 8.2 10.4.7 5.5-6.7.6-14-4.3-28.2-8.7 13.3-1.1-28.1-8.7 13.3-1.1-28.1-8.7 13.3-1.2-24.4-6.2 13.3-1.1-24.4-6.2 13.3-1.2-21.5-9.3 17.1 1.3L383.1 98z"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m383 97.9 103.7 68.7m-48.9-12.4 34.1 2.6-10.3-26.9"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m423 144.4 34 2.6-10.3-27"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m408.2 134.6 34 2.6-10.3-27"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m397 127.2 30.5.1-6.7-24.4"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m386 119.8 30.4.2-6.7-24.5"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m377.8 109.4 31.1 5.7-13.2-23.9"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "#006d00",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 2,
      d: "M589.8 120.8 575 131.7l16.4 1.8-22.9 5.4 12.2 3.6-24.7 1.8 12.2 3.6-24.7 1.8 12.1 3.7-28.9 3.6 12.2 3.6-28.9 3.6 12.2 3.6-28.9 3.6-14.5 1.8-6-1.8 2.2-5.4 10.7-9 21.3-18.1-4.6 10.8 21.3-18-4.6 10.8 21.3-18-4.6 10.8L553 119l-4.5 10.9 17-16.3-4.5 10.8 19-12.6-8.7 12.7 18.6-3.6z"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m589.8 120.8-117 50.6m34.1-32.5-17.4 25.3 32.7 3.6"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M523.7 131.7 506.2 157l32.7 3.6"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m540.4 124.4-17.5 25.3 32.7 3.7"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m553 119-13.3 23.5 28.5 5.4"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m565.5 113.6-13.3 23.5 28.5 5.4"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m580 111.8-19.4 21.7h30.7"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "#006d00",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 2,
      d: "M587.4 230.3 569 225l6.6 13-17.1-14 2.6 10.7-14.5-17.2 2.7 10.8-14.5-17.3 2.6 10.8-18.5-19.4 2.7 10.8-18.5-19.4 2.7 10.8-18.5-19.4-9.2-9.7-1.3-5.4 6.6-1.2 14.5 3.2 29 6.4-13.2 2.2 29 6.4-13.2 2.2 29 6.4-13.2 2.3 25 4.2-13.2 2.2 25 4.2L569 211l22.3 7.5h-17l13 12z"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m587.4 230.3-110.6-60.2m50 8.4-34.2.2 13.2 26"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m542.6 187.1-34.2.2 13.2 26"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m558.4 195.7-34.2.2 13.2 26"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m570.3 202.2-30.3 2.3 9.3 23.8"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m582.2 208.7-30.3 2.2 9.2 23.8"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m591.3 218.4-31.5-3.2 15.8 22.8"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "#006d00",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 1.8,
      d: "m395.2 236.6 9.3-13-14.1 2.1 17.4-9.9-11.1-.5 20-7-11.1-.6 20-7-11.1-.6 23-9.6-11.2-.5 23-9.7-11.1-.5 23-9.6 11.5-4.9 5.6.3-.4 5.3-6.3 10.4-12.6 20.8.8-10.6-12.6 20.8.7-10.7-12.6 20.8.7-10.6-9.6 18.2.7-10.6-9.6 18.2.7-10.6-12.2 15.4 3.7-13.2z"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m395.2 236.6 83-71m-19.1 36.5 7.3-26.4-28.2 4.1"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m447.2 212.3 7.3-26.4-28.2 4"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m435.3 222.4 7.4-26.4-28.2 4.1"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m426.4 230 4.4-23.8-25.2 1.5"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m417.5 237.6 4.4-23.8-25.2 1.5"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m406 242.4 10-23.5-25.6 6.8"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "#006d00",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 2,
      d: "m563 66.2-17.9 12-2.9-12.9-10.5 17.8-2-8.5-8.6 18.2-1.2-8.4-6.7 18.7-3.8-9-6.7 22.7-3.8-9-6.7 22.7-3.9-9-6.7 22.7-3.3 11.4 1.9 4.5 7.2-2.4 12.4-9.2 25-18.4-14.4 4.7 24.9-18.5-14.4 4.8 24.9-18.5-14.4 4.8 25-14.4-17 4L566 83.3l-16.3 4.2 19.7-15.6-17 8.1z"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m556 72.7-25.8 22.2-50 65.2"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m519.3 132.8-28.6 13.5-2.4-20.8"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m530.2 119.2-29 13.4-2.3-20.8"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m540.5 105.5-28.7 13.4-2.2-20.7"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m549.1 95.3-26.8 9.9-3-17"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M559 85.5 530.2 95l-1-16.4"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m562.8 76.2-26.6 13.6 5.2-20.6"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "#006d00",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 2,
      d: "m466.1 43.8 8 18.2 10.3-9.6-1.7 19.8 6.8-6.4-3.7 19.4 6-6.6-5.5 19 8.7-6-8 22.3 8.6-6-8 22.5 8.7-6-8 22.4-4 11.2-4.4 3-4.8-5.3-5-13.4-10-26.9 9.4 10.5-10.1-27 9.4 10.6-10-27L468 93l-12.5-23.4 12 11.1-14.4-23.9 11.3 11-7.3-22.2 9.6 14.6z"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m468.2 52.4 8.5 30.5 3.2 78"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m463 120.2 16.2 24.3 14.7-16.7"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m462 103.7 16.5 24.4 14.7-16.7"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m461.5 87.3 16.4 24.4L492.3 95"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m460.4 74.9 16.8 20.4 13-13"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m458 62 18.7 21 11-13.6"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m460.3 52.4 14.4 23.5 8.1-19.9"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "#006d00",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeWidth: 1.9,
      d: "m359 178 23.3-16.2-11.7-6 20.5 3.4-7-9.3 19.8 7.5-7-9.3 19.9 7.4-7-9.2 24 8.1-7-9.3 23.3 12.1-7-9.3 24 8.2 11.7 6 3.5 4.6-4.7 3.3-12.9 1.8-20.7 8.6 3.8-7.4-25.7 3.6 9.3-6.4-26.3 7.6 9.4-6.5-22.2 8.3 9.9-10.4-22.8 12.2 10-10.4-18.8 13 10.5-14.4z"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m366.3 173.6 24.2-10.5 12.9-1.8 10.7-.2 18.5 1.2 16.7.7 33 3.7"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m447.2 176.9 18.5-11.4-18.8-14.7"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m426.5 175.2 22.7-12.2-18.7-14.8"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m411.7 174.8 20.9-12.5-19-13.7m-29.5 29.6 19.3-16.9-15.6-8.5"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "m375.5 179.3 15-16.1-12-4.5m18.4 17.7 19-15.2-15.2-10.4"
    }),
    /* @__PURE__ */ jsxs153("g", {
      fillRule: "evenodd",
      children: [
        /* @__PURE__ */ jsx178("path", {
          fill: "#c00",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "m541.5 1173.3-1.7-229.1-61.1-107c-15.3-52.6-7.8-78 17-79.8 24.7-1.6 49.2 13.6 84.8 15.3 35.6 1.7 28.9-59.4 81.5-57.7 52.6 1.7 144.3 32.3 222.3 37.4 78.1 5 118.8-27.2 208.8-30.6 90-3.4 113.7 42.4 118.8 42.4 5.1 0 30.6-18.6 56-22 25.5-3.4 34 10.2 34 10.2s-1.7 57.7-13.6 91.6c-11.9 34-54.3 90-56 90-1.7 0-15.3 249.5-15.3 251.2 0 1.7-675.5-6.8-675.5-11.9z",
          transform: "matrix(.12934 0 0 .11906 367.5 215.5)"
        }),
        /* @__PURE__ */ jsxs153("g", {
          stroke: "#000",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx178("path", {
              fill: "#fff100",
              d: "M531.5 584.6s-68-52-69.8-177.1c-1-72 34.4-124 123-124 124 0 301.1 53.1 301.1 53.1v17.7s-141.7-53.1-301.2-53.1c-70.8 0-106.3 52-106.3 105.2 0 88.6 71 178.3 71 178.3v141.7h-17.8z",
              transform: "matrix(-.12934 0 0 .11906 596.6 257.6)"
            }),
            /* @__PURE__ */ jsx178("path", {
              fill: "#fff",
              d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
              transform: "matrix(-.12934 0 0 .11906 594.5 257.4)"
            }),
            /* @__PURE__ */ jsx178("path", {
              fill: "#fff",
              d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
              transform: "matrix(-.12934 0 0 .11906 596.8 252.6)"
            }),
            /* @__PURE__ */ jsx178("path", {
              fill: "#fff",
              d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
              transform: "matrix(-.12934 0 0 .11906 598 247.6)"
            }),
            /* @__PURE__ */ jsx178("path", {
              fill: "#fff",
              d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
              transform: "matrix(-.12934 0 0 .11906 598.9 242.4)"
            }),
            /* @__PURE__ */ jsx178("path", {
              fill: "#fff",
              d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
              transform: "matrix(-.12934 0 0 .11906 598.7 236.8)"
            }),
            /* @__PURE__ */ jsx178("path", {
              fill: "#fff",
              d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
              transform: "matrix(-.12934 0 0 .11906 591.2 261.7)"
            }),
            /* @__PURE__ */ jsx178("path", {
              fill: "#fff",
              d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
              transform: "matrix(-.12934 0 0 .11906 596.7 231.4)"
            }),
            /* @__PURE__ */ jsx178("path", {
              fill: "#fff",
              d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
              transform: "matrix(-.12934 0 0 .11906 592.5 227.1)"
            }),
            /* @__PURE__ */ jsx178("path", {
              fill: "#fff",
              d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
              transform: "matrix(-.12934 0 0 .11906 586.8 224.3)"
            }),
            /* @__PURE__ */ jsx178("path", {
              fill: "#fff",
              d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
              transform: "matrix(-.12934 0 0 .11906 581 223.9)"
            }),
            /* @__PURE__ */ jsx178("path", {
              fill: "#fff",
              d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
              transform: "matrix(-.12934 0 0 .11906 575 224)"
            }),
            /* @__PURE__ */ jsx178("path", {
              fill: "#fff",
              d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
              transform: "matrix(-.12934 0 0 .11906 568.8 225)"
            }),
            /* @__PURE__ */ jsx178("path", {
              fill: "#fff",
              d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
              transform: "matrix(-.12934 0 0 .11906 562.7 225.7)"
            }),
            /* @__PURE__ */ jsx178("path", {
              fill: "#fff",
              d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
              transform: "matrix(-.12934 0 0 .11906 556 226.6)"
            }),
            /* @__PURE__ */ jsx178("path", {
              fill: "#fff",
              d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
              transform: "matrix(-.12934 0 0 .11906 550.4 228.1)"
            })
          ]
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 369.5 257.4)"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 367.2 252.6)"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 366 247.6)"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 365.2 242.4)"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 365.4 236.8)"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 367.3 231.4)"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 371.4 227.1)"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 377.2 224.3)"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 382.9 223.9)"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 389 224)"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 395.2 225)"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 401.4 225.7)"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 407.9 226.6)"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 413.6 228.1)"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 372.8 261.7)"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff100",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M531.5 584.6s-68-52-69.8-177.1c-1-72 34.4-124 123-124 124 0 301.1 53.1 301.1 53.1v17.7s-141.7-53.1-301.2-53.1c-70.8 0-106.3 52-106.3 105.2 0 88.6 71 178.3 71 178.3v141.7h-17.8z",
          transform: "matrix(.12934 0 0 .11906 367.5 257.6)"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff100",
          stroke: "#000",
          strokeWidth: 3,
          d: "M1240.2 531.5s15.3-35.4 70.9-35.4c37.8 0 70.8 35.4 70.8 70.8v70.9h35.5v-70.9c0-35.4 35.4-70.8 70.8-70.8 53.2 0 70.9 35.4 70.9 35.4s0-106.3-70.9-106.3c-53.1 0-70.8 35.4-70.8 35.4s17.7-53.1 17.7-106.3c0-53.2-35.4-88.6-35.4-88.6 0 6.8-35.5 35.5-35.5 88.6 0 53.1 17.7 106.3 17.7 106.3s-17.7-35.4-70.8-35.4c-70.9 0-70.9 106.3-70.9 106.3z",
          transform: "matrix(.04311 0 0 .04536 398.7 310.9)"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff100",
          stroke: "#000",
          strokeWidth: 3,
          d: "M1240.2 531.5s15.3-35.4 70.9-35.4c37.8 0 70.8 35.4 70.8 70.8v70.9h35.5v-70.9c0-35.4 35.4-70.8 70.8-70.8 53.2 0 70.9 35.4 70.9 35.4s0-106.3-70.9-106.3c-53.1 0-70.8 35.4-70.8 35.4s17.7-53.1 17.7-106.3c0-53.2-35.4-88.6-35.4-88.6 0 6.8-35.5 35.5-35.5 88.6 0 53.1 17.7 106.3 17.7 106.3s-17.7-35.4-70.8-35.4c-70.9 0-70.9 106.3-70.9 106.3z",
          transform: "matrix(.04311 0 0 .04536 444.5 310.9)"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff100",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M531.5 832.7V673.2s35.4 53.2 88.6 53.2c43.5 0 88.6-70.9 88.6-70.9s41.5 53.2 88.6 53.2c42 0 88.5-68.6 88.5-68.6s43.2 68.6 88.6 68.6c45.5 0 88.6-53.2 88.6-53.2s46.3 70.9 106.3 70.9c53.1 0 70.9-53.2 70.9-53.2v159.5z",
          transform: "matrix(.12934 0 0 .11906 367.5 257.6)"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff100",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M708.7 832.7v-124S815 744 815 832.7z",
          transform: "matrix(.12934 0 0 .11906 344.5 257.6)"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff100",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M708.7 832.7v-124S815 744 815 832.7z",
          transform: "matrix(-.12934 0 0 .11906 619.4 257.6)"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff100",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M602.4 832.7C602.4 744 708.7 688 708.7 688S815 744 815 832.7z",
          transform: "matrix(.12934 0 0 .11906 367.5 257.6)"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff100",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M602.4 832.7C602.4 744 708.7 688 708.7 688S815 744 815 832.7z",
          transform: "matrix(.12934 0 0 .11906 413.3 257.6)"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff100",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M584.6 847.5c0-88.6 124.1-159.4 124.1-159.4s124 70.8 124 159.4h-248z",
          transform: "matrix(.12934 0 0 .11906 390.4 255.9)"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M1275.6 655.5c-35.4-17.7-166-35.4-376.3-35.4s-350 17.7-385.5 35.4c-35.4 17.7-35.4 53.2 0 70.9 35.4 17.7 175.3 35.4 385.5 35.4s340.9-17.7 376.3-35.4c35.4-17.7 35.4-53.2 0-70.9z",
          transform: "matrix(.12788 0 0 .11906 367 278.7)"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "gray",
          d: "M527.9 365.2c0 4.2-38.2 4.2-45.9 4.2-8.3 0-45.8 1.2-45.8-4.2 0-4.2 37.8-4.2 45.8-4.2s45.9.8 45.9 4.2"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#c00",
          d: "M440.8 350c0 1.4-1 2.6-2.3 2.6s-2.3-1.2-2.3-2.6c0-1.4 1-2.5 2.3-2.5 1.2 0 2.3 1.2 2.3 2.5m87 0c0 1.4-1 2.6-2.3 2.6-1.2 0-2.3-1.2-2.3-2.6 0-1.4 1-2.5 2.3-2.5 1.3 0 2.3 1.2 2.3 2.5"
        }),
        /* @__PURE__ */ jsx178("path", {
          d: "M486.6 348.8c0 1.3-2.1 2.4-4.6 2.4-2.4 0-4.6-1.1-4.6-2.5s2-2.5 4.6-2.5 4.6 1.2 4.6 2.5z"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#006300",
          d: "M508.6 348.8c0 1.3-1.6 2.4-3.5 2.4s-3.4-1.1-3.4-2.5 1.6-2.5 3.4-2.5 3.5 1.2 3.5 2.5zm-47.2 0c0 1.3-1.5 2.4-3.4 2.4s-3.5-1.1-3.5-2.5 1.5-2.5 3.5-2.5c1.9 0 3.4 1.2 3.4 2.5z"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff100",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "M1257.9 496s35.4-53 70.9-53h35.4v35.3c0 53.2-53.1 71-53.1 71h141.7s-53.2-17.8-53.2-71V443h35.5c35.4 0 70.8 53.2 70.8 53.2V354.3s-35.4 53.2-70.8 53.2h-35.5V372c0-53.1 53.2-70.8 53.2-70.8H1311s53.1 17.7 53.1 70.8v35.5h-35.4c-35.5 0-70.9-53.2-70.9-53.2v141.8z",
          transform: "matrix(.0739 0 0 .06804 379.9 300.5)"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff100",
          stroke: "#000",
          strokeWidth: 3.3,
          d: "M1381.9 549.2h70.9s-53.2-17.7-53.2-70.9V443h35.4c35.5 0 71 53.2 71 53.2V354.3s-35.5 53.2-71 53.2h-35.4V372c0-53.1 53.2-70.8 53.2-70.8h-70.9z",
          transform: "matrix(.03696 0 0 .05953 385 309.3)"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff100",
          stroke: "#000",
          strokeWidth: 3.3,
          d: "M1381.9 549.2h70.9s-53.2-17.7-53.2-70.9V443h35.4c35.5 0 71 53.2 71 53.2V354.3s-35.5 53.2-71 53.2h-35.4V372c0-53.1 53.2-70.8 53.2-70.8h-70.9z",
          transform: "matrix(-.03696 0 0 .05953 579 309.3)"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M903.5 602.4a17.7 17.7 0 1 1-35.4 0 17.7 17.7 0 0 1 35.4 0z",
          transform: "matrix(.12934 0 0 .11906 367.5 257.6)"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff100",
          stroke: "#000",
          strokeWidth: 2.2,
          d: "M1257.9 496s35.4-53 70.9-53h35.4v35.3c0 53.2-53.1 71-53.1 71h141.7s-53.2-17.8-53.2-71V443h35.5c35.4 0 70.8 53.2 70.8 53.2V354.3s-35.4 53.2-70.8 53.2h-35.5V372c0-53.1 53.2-70.8 53.2-70.8H1311s53.1 17.7 53.1 70.8v35.5h-35.4c-35.5 0-70.9-53.2-70.9-53.2v141.8z",
          transform: "matrix(.0739 0 0 .06804 379.9 256.2)"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M903.5 602.4a17.7 17.7 0 1 1-35.4 0 17.7 17.7 0 0 1 35.4 0z",
          transform: "matrix(.12934 0 0 .11906 367.7 213.7)"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff100",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M850.4 655.5h70.9v53.2h-71z",
          transform: "matrix(.12934 0 0 .11906 367.5 215.5)"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff100",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M850.4 683.3h70.9v202.5h-71z",
          transform: "matrix(.12934 0 0 .11906 367.5 215.5)"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 422.4 251.2)"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 422.4 245.8)"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 422.4 240.8)"
        }),
        /* @__PURE__ */ jsx178("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: "1pt",
          d: "M478.4 549.2a17.8 17.8 0 1 1-35.5 0 17.8 17.8 0 0 1 35.5 0z",
          transform: "matrix(.12934 0 0 .11906 422.4 235.5)"
        }),
        /* @__PURE__ */ jsx178("path", {
          d: "M486.9 356.8c0 1-2.1 1.7-4.8 1.7s-4.5-.7-4.5-1.7 2-1.7 4.6-1.7 4.7.8 4.7 1.7M529 361c-.3.7-2.6.8-5.1 0-2.6-.5-4.4-1.4-4.2-2 .3-.8 2.6-.8 5.1-.2 2.6.6 4.4 1.5 4.2 2.2m-17.7-2.8c0 .8-2.3 1.3-5 1.2-2.5-.2-4.6-1-4.5-2 .1-.8 2.4-1.2 5-1 2.6.1 4.7.9 4.5 1.8m-77.5 2.8c.2.7 2.5.8 5 0 2.6-.5 4.5-1.4 4.2-2-.3-.8-2.5-.8-5-.2-2.6.6-4.4 1.5-4.2 2.2m18.5-3.2c.1.8 2.4 1.3 5 1.1 2.6-.2 4.7-1 4.5-1.9 0-.7-2.3-1.3-5-1.1-2.5.2-4.6 1-4.5 1.9"
        })
      ]
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "#012169",
      d: "M0 0h320v240H0Z"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "#fff",
      d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0Z"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "#c8102e",
      d: "M212 140.5 320 220v20l-135.5-99.5Zm-92 10 3 17.5-96 72H0ZM320 0v1.5l-124.5 94 1-22L295 0ZM0 0l119.5 88h-30L0 21Z"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "#fff",
      d: "M120.5 0v240h80V0ZM0 80v80h320V80Z"
    }),
    /* @__PURE__ */ jsx178("path", {
      fill: "#c8102e",
      d: "M0 96.5v48h320v-48zM136.5 0v240h48V0Z"
    })
  ]
});
var Io_default = SvgIo;

// src/country-flag-icons/generated/Iq.tsx
init_esm_shims();
import { jsx as jsx179, jsxs as jsxs154 } from "react/jsx-runtime";
var SvgIq = (props) => /* @__PURE__ */ jsxs154("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx179("path", {
      fill: "#fff",
      d: "M0 160h640v160H0z"
    }),
    /* @__PURE__ */ jsx179("path", {
      fill: "#ce1126",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsx179("path", {
      fill: "#000001",
      d: "M0 320h640v160H0z"
    }),
    /* @__PURE__ */ jsxs154("g", {
      fill: "#007a3d",
      transform: "translate(-179.3 -92.8) scale(1.75182)",
      children: [
        /* @__PURE__ */ jsx179("path", {
          d: "M325.5 173.2a5 5 0 0 1-1.4-1c-.3-.5-.1-.5 1.2-.2 2.3.7 3.8.4 5.3-.8l1.3-1.1 1.5.7c.9.5 1.8.8 2 .7.7-.2 2.1-2 2-2.6 0-.7.6-.5 1 .3.6 1.6-.3 3.5-2 3.9-.7.2-1.4.1-2.6-.3-1.4-.5-1.7-.5-2.4 0a5.4 5.4 0 0 1-5.9.4m5.8-5.3a8 8 0 0 1-1-4c.1-.6.3-.8.8-.6 1 .3 1.2 1 1 3 0 1.8-.3 2.3-.8 1.6m-67.6-1.9c-.1 1.3 2.4 4.6 3.5 5.2-.8.3-1.7.2-2.4.5-4 4-18.4 18-21 21.4 7.8.2 16.4-.1 23.7-.4 0-5.3 5-5.6 8.4-7.5 1.7 2.7 6 2.5 6.6 6.6v17.6H216a9.7 9.7 0 0 1-12.3 7.5c2-2 5.4-2.8 6.6-5.7 1-6.4-2-10.3-4-14a24 24 0 0 0 7-3.6c-2.3 7 6.2 6.3 12.4 6.1.2-2.4.1-5.2-1.7-5.6 2.3-.9 2.7-1.2 6.6-4.4v9.6l46.1-.1c0-3 .8-7.9-1.6-7.9-2.2 0 0 6.2-1.8 6.2h-35.7v-6c1.5-1.6 1.3-1.5 11.6-11.8 1-1 8.3-7.6 14.6-13.7zm89.1-.3c2.5 1.4 4.5 3.2 7.5 4-.3 1.3-1.5 1.8-1.8 3.1v27c3.4.7 4.2-1.3 5.8-2.3.4 4.3 3.2 8.5 3 12h-14.5zm-19.4 14.5s5.3-4.5 5.3-4.7V199h3.8l-.1-26.3c1.5-1.6 4.6-3.8 5.3-5.4v42h-33.4c-.5-8.7-.6-17.7 9.6-15.8V190c-.3-.6-.9.1-1-.7 1.6-1.6 2.1-2 6.5-5.8l.1 15.5h3.9zm-12.6 18.6c.7 1 3.2 1 3-.8-.3-1.5-3.5-1-3 .8"
        }),
        /* @__PURE__ */ jsx179("circle", {
          cx: 224,
          cy: 214.4,
          r: 2
        }),
        /* @__PURE__ */ jsx179("path", {
          d: "M287 165.8c2.5 1.3 4.5 3.2 7.6 4-.4 1.2-1.5 1.7-1.8 3v27c3.4.7 4.1-1.2 5.7-2.3.5 4.3 3.2 8.6 3.1 12H287z"
        })
      ]
    })
  ]
});
var Iq_default = SvgIq;

// src/country-flag-icons/generated/Ir.tsx
init_esm_shims();
import { jsx as jsx180, jsxs as jsxs155 } from "react/jsx-runtime";
var SvgIr = (props) => /* @__PURE__ */ jsxs155("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx180("defs", {
      children: /* @__PURE__ */ jsx180("clipPath", {
        id: "ir_svg__a",
        children: /* @__PURE__ */ jsx180("path", {
          fillOpacity: 0.7,
          d: "M-85.3 0h682.7v512H-85.3z"
        })
      })
    }),
    /* @__PURE__ */ jsxs155("g", {
      fillRule: "evenodd",
      clipPath: "url(#ir_svg__a)",
      transform: "translate(80) scale(.9375)",
      children: [
        /* @__PURE__ */ jsx180("path", {
          fill: "#fff",
          d: "M-192 0h896v512h-896z"
        }),
        /* @__PURE__ */ jsx180("path", {
          fill: "#da0000",
          d: "M-192 343.8h896V512h-896z"
        }),
        /* @__PURE__ */ jsxs155("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx180("path", {
              d: "M-21.6 351h49v3.3h-49zm7.3 16.8h3.4v3.3h-3.4zm41.9 0v3.3h-9.8v-3.4zm5.2-16.8h3.4v20h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M52.4 367.7v3.4H33.8v-3.4zm-34.6-7.9H21v11.3h-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M49.6 351H53v20h-3.4zm-8.4 0h3.3v20h-3.3zm-44.8 8v3.4h-18V359zm39.3 0v3.4h-18V359z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M17.8 359.9H21V371h-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M17.8 359.9H21V371h-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M17.8 359.9H21V371h-3.3zm-39.3 0h3.3V371h-3.3zm28.8 0h3.4V371H7.3zm-14.3 0h3.4V371H-7z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M9.6 367.7v3.4H-5.5v-3.4zm1-8.7v3.4H1V359z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs155("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx180("path", {
              d: "M-102.2 351h49v3.3h-49zm7.3 16.8h3.4v3.3H-95zm41.9 0v3.3h-9.8v-3.4zm5.2-16.8h3.4v20h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M-28.2 367.7v3.4h-18.6v-3.4zm-34.6-7.9h3.3v11.3h-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M-31 351h3.4v20H-31zm-8.4 0h3.3v20h-3.3zm-44.8 8v3.4h-18V359zm39.3 0v3.4h-18V359z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M-62.8 359.9h3.3V371h-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M-62.8 359.9h3.3V371h-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M-62.8 359.9h3.3V371h-3.3zm-39.3 0h3.3V371h-3.3zm28.8 0h3.3V371h-3.3zm-14.3 0h3.4V371h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M-71 367.7v3.4h-15v-3.4zm1-8.7v3.4h-9.6V359z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs155("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx180("path", {
              d: "M58.3 351h49v3.3h-49zm7.3 16.8H69v3.3h-3.4zm41.9 0v3.3h-9.8v-3.4zm5.3-16.8h3.4v20h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M132.3 367.7v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M129.5 351h3.4v20h-3.4zm-8.4 0h3.4v20H121zm-44.8 8v3.4h-18V359zm39.3 0v3.4h-18V359z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M97.7 359.9h3.4V371h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M97.7 359.9h3.4V371h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M97.7 359.9h3.4V371h-3.4zm-39.3 0h3.4V371h-3.4zm28.8 0h3.4V371h-3.4zm-14.3 0h3.4V371h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M89.6 367.7v3.4H74.4v-3.4zm1-8.7v3.4H81V359z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs155("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx180("path", {
              d: "M622.7 351h49v3.3h-49zm7.3 16.8h3.4v3.3H630zm41.9 0v3.3H662v-3.4zm5.3-16.8h3.3v20h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M696.7 367.7v3.4H678v-3.4zm-34.6-7.9h3.4v11.3H662z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M694 351h3.3v20h-3.4zm-8.5 0h3.4v20h-3.4zm-44.8 8v3.4h-18V359zm39.3 0v3.4h-18V359z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M662 359.9h3.5V371H662z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M662 359.9h3.5V371H662z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M662 359.9h3.5V371H662zm-39.2 0h3.4V371h-3.4zm28.8 0h3.4V371h-3.4zm-14.3 0h3.4V371h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M654 367.7v3.4h-15.2v-3.4zm1-8.7v3.4h-9.6V359z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs155("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx180("path", {
              d: "M138.7 351h49.1v3.3h-49zm7.4 16.8h3.3v3.3h-3.3zm41.8 0v3.3h-9.8v-3.4zm5.3-16.8h3.4v20h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M212.8 367.7v3.4h-18.6v-3.4zm-34.7-7.9h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M210 351h3.4v20H210zm-8.5 0h3.4v20h-3.4zm-44.8 8v3.4h-17.9V359zm39.3 0v3.4h-17.9V359z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M178.1 359.9h3.4V371h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M178.1 359.9h3.4V371h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M178.1 359.9h3.4V371h-3.4zm-39.3 0h3.4V371h-3.4zm28.8 0h3.4V371h-3.4zm-14.2 0h3.3V371h-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M170 367.7v3.4h-15.1v-3.4zm1-8.7v3.4h-9.6V359z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs155("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx180("path", {
              d: "M219.5 351h49v3.3h-49zm7.3 16.8h3.4v3.3h-3.4zm41.9 0v3.3h-9.8v-3.4zM274 351h3.3v20H274z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M293.5 367.7v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M290.7 351h3.4v20h-3.4zm-8.4 0h3.4v20h-3.4zm-44.8 8v3.4h-18V359zm39.3 0v3.4h-18V359z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M258.9 359.9h3.4V371h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M258.9 359.9h3.4V371h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M258.9 359.9h3.4V371h-3.4zm-39.3 0h3.3V371h-3.3zm28.8 0h3.4V371h-3.4zm-14.3 0h3.4V371H234z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M250.8 367.7v3.4h-15.2v-3.4zm1-8.7v3.4H242V359z"
            })
          ]
        }),
        /* @__PURE__ */ jsx180("path", {
          fill: "#239f40",
          d: "M-192 0h896v168.2h-896z"
        }),
        /* @__PURE__ */ jsxs155("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx180("path", {
              d: "M300.7 351h49v3.3h-49zm7.3 16.8h3.4v3.3H308zm41.9 0v3.3H340v-3.4zm5.3-16.8h3.3v20h-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M374.7 367.7v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3H340z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M372 351h3.3v20H372zm-8.5 0h3.4v20h-3.4zm-44.8 8v3.4h-18V359zm39.3 0v3.4h-18V359z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M340 359.9h3.5V371H340z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M340 359.9h3.5V371H340z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M340 359.9h3.5V371H340zm-39.2 0h3.4V371h-3.4zm28.8 0h3.4V371h-3.4zm-14.3 0h3.4V371h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M332 367.7v3.4h-15.2v-3.4zm1-8.7v3.4h-9.6V359z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs155("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx180("path", {
              d: "M381.4 351h49v3.3h-49zm7.3 16.8h3.4v3.3h-3.4zm42 0v3.3h-9.9v-3.4zm5.2-16.8h3.4v20h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M455.4 367.7v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M452.7 351h3.3v20h-3.3zm-8.5 0h3.4v20h-3.4zm-44.8 8v3.4h-17.9V359zm39.3 0v3.4h-17.9V359z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M420.8 359.9h3.4V371h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M420.8 359.9h3.4V371h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M420.8 359.9h3.4V371h-3.4zm-39.3 0h3.4V371h-3.4zm28.8 0h3.4V371h-3.4zm-14.3 0h3.4V371h-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M412.7 367.7v3.4h-15.1v-3.4zm1-8.7v3.4H404V359z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs155("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx180("path", {
              d: "M462.2 351h49v3.3h-49zm7.3 16.8h3.4v3.3h-3.4zm41.9 0v3.3h-9.8v-3.4zm5.2-16.8h3.4v20h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M536.2 367.7v3.4h-18.6v-3.4zm-34.7-7.9h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M533.4 351h3.4v20h-3.4zm-8.4 0h3.3v20H525zm-44.8 8v3.4h-18V359zm39.3 0v3.4h-18V359z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M501.6 359.9h3.3V371h-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M501.6 359.9h3.3V371h-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M501.6 359.9h3.3V371h-3.3zm-39.4 0h3.4V371h-3.4zm28.9 0h3.3V371h-3.3zm-14.3 0h3.4V371h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M493.4 367.7v3.4h-15.1v-3.4zm1-8.7v3.4h-9.6V359z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs155("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx180("path", {
              d: "M543.4 351h49v3.3h-49zm7.3 16.8h3.4v3.3h-3.4zm41.9 0v3.3h-9.8v-3.4zm5.2-16.8h3.4v20h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M617.4 367.7v3.4h-18.6v-3.4zm-34.6-7.9h3.3v11.3h-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M614.6 351h3.4v20h-3.4zm-8.4 0h3.3v20h-3.3zm-44.8 8v3.4h-18V359zm39.3 0v3.4h-18V359z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M582.8 359.9h3.3V371h-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M582.8 359.9h3.3V371h-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M582.8 359.9h3.3V371h-3.3zm-39.3 0h3.3V371h-3.3zm28.8 0h3.4V371h-3.4zm-14.3 0h3.4V371H558z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M574.6 367.7v3.4h-15.1v-3.4zm1-8.7v3.4H566V359z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs155("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx180("path", {
              d: "M-183.8 351h49v3.3h-49zm7.3 16.8h3.4v3.3h-3.4zm42 0v3.3h-9.9v-3.4zm5.2-16.8h3.4v20h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M-109.8 367.7v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M-112.5 351h3.3v20h-3.3zm-8.5 0h3.4v20h-3.4zm-44.8 8v3.4h-17.9V359zm39.3 0v3.4h-17.9V359z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M-144.4 359.9h3.4V371h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M-144.4 359.9h3.4V371h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M-144.4 359.9h3.4V371h-3.4zm-39.3 0h3.4V371h-3.4zm28.8 0h3.4V371h-3.4zm-14.3 0h3.4V371h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M-152.5 367.7v3.4h-15.2v-3.4zm1-8.7v3.4h-9.6V359z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs155("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx180("path", {
              d: "M-21.6 143.4h49v3.4h-49zm7.3 17h3.4v3.2h-3.4zm41.9-.2v3.4h-9.8v-3.4zm5.2-16.8h3.4v20.2h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M52.4 160.2v3.4H33.8v-3.4zm-34.6-7.9H21v11.3h-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M49.6 143.4H53v20.2h-3.4zm-8.4 0h3.3v20.2h-3.3zm-44.8 8v3.4h-18v-3.3zm39.3 0v3.4h-18v-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M17.8 152.3H21v11.3h-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M17.8 152.3H21v11.3h-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M17.8 152.3H21v11.3h-3.3zm-39.3 0h3.3v11.3h-3.3zm28.8 0h3.4v11.3H7.3zm-14.3 0h3.4v11.3H-7z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M9.6 160.2v3.4H-5.5v-3.4zm1-8.7v3.3H1v-3.3z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs155("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx180("path", {
              d: "M-102.2 143.4h49v3.4h-49zm7.3 17h3.4v3.2H-95zm41.9-.2v3.4h-9.8v-3.4zm5.2-16.8h3.4v20.2h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M-28.2 160.2v3.4h-18.6v-3.4zm-34.6-7.9h3.3v11.3h-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M-31 143.4h3.4v20.2H-31zm-8.4 0h3.3v20.2h-3.3zm-44.8 8v3.4h-18v-3.3zm39.3 0v3.4h-18v-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M-62.8 152.3h3.3v11.3h-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M-62.8 152.3h3.3v11.3h-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M-62.8 152.3h3.3v11.3h-3.3zm-39.3 0h3.3v11.3h-3.3zm28.8 0h3.3v11.3h-3.3zm-14.3 0h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M-71 160.2v3.4h-15v-3.4zm1-8.7v3.3h-9.6v-3.3z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs155("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx180("path", {
              d: "M58.3 143.4h49v3.4h-49zm7.3 17H69v3.2h-3.4zm41.9-.2v3.4h-9.8v-3.4zm5.3-16.8h3.4v20.2h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M132.3 160.2v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M129.5 143.4h3.4v20.2h-3.4zm-8.4 0h3.4v20.2H121zm-44.8 8v3.4h-18v-3.3zm39.3 0v3.4h-18v-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M97.7 152.3h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M97.7 152.3h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M97.7 152.3h3.4v11.3h-3.4zm-39.3 0h3.4v11.3h-3.4zm28.8 0h3.4v11.3h-3.4zm-14.3 0h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M89.6 160.2v3.4H74.4v-3.4zm1-8.7v3.3H81v-3.3z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs155("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx180("path", {
              d: "M622.7 143.4h49v3.4h-49zm7.3 17h3.4v3.2H630zm41.9-.2v3.4H662v-3.4zm5.3-16.8h3.3v20.2h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M696.7 160.2v3.4H678v-3.4zm-34.6-7.9h3.4v11.3H662z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M694 143.4h3.3v20.2h-3.4zm-8.5 0h3.4v20.2h-3.4zm-44.8 8v3.4h-18v-3.3zm39.3 0v3.4h-18v-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M662 152.3h3.5v11.3H662z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M662 152.3h3.5v11.3H662z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M662 152.3h3.5v11.3H662zm-39.2 0h3.4v11.3h-3.4zm28.8 0h3.4v11.3h-3.4zm-14.3 0h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M654 160.2v3.4h-15.2v-3.4zm1-8.7v3.3h-9.6v-3.3z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs155("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx180("path", {
              d: "M138.7 143.4h49.1v3.4h-49zm7.4 17h3.3v3.2h-3.3zm41.8-.2v3.4h-9.8v-3.4zm5.3-16.8h3.4v20.2h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M212.8 160.2v3.4h-18.6v-3.4zm-34.7-7.9h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M210 143.4h3.4v20.2H210zm-8.5 0h3.4v20.2h-3.4zm-44.8 8v3.4h-17.9v-3.3zm39.3 0v3.4h-17.9v-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M178.1 152.3h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M178.1 152.3h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M178.1 152.3h3.4v11.3h-3.4zm-39.3 0h3.4v11.3h-3.4zm28.8 0h3.4v11.3h-3.4zm-14.2 0h3.3v11.3h-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M170 160.2v3.4h-15.1v-3.4zm1-8.7v3.3h-9.6v-3.3z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs155("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx180("path", {
              d: "M219.5 143.4h49v3.4h-49zm7.3 17h3.4v3.2h-3.4zm41.9-.2v3.4h-9.8v-3.4zm5.3-16.8h3.3v20.2H274z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M293.5 160.2v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M290.7 143.4h3.4v20.2h-3.4zm-8.4 0h3.4v20.2h-3.4zm-44.8 8v3.4h-18v-3.3zm39.3 0v3.4h-18v-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M258.9 152.3h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M258.9 152.3h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M258.9 152.3h3.4v11.3h-3.4zm-39.3 0h3.3v11.3h-3.3zm28.8 0h3.4v11.3h-3.4zm-14.3 0h3.4v11.3H234z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M250.8 160.2v3.4h-15.2v-3.4zm1-8.7v3.3H242v-3.3z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs155("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx180("path", {
              d: "M300.7 143.4h49v3.4h-49zm7.3 17h3.4v3.2H308zm41.9-.2v3.4H340v-3.4zm5.3-16.8h3.3v20.2h-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M374.7 160.2v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3H340z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M372 143.4h3.3v20.2H372zm-8.5 0h3.4v20.2h-3.4zm-44.8 8v3.4h-18v-3.3zm39.3 0v3.4h-18v-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M340 152.3h3.5v11.3H340z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M340 152.3h3.5v11.3H340z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M340 152.3h3.5v11.3H340zm-39.2 0h3.4v11.3h-3.4zm28.8 0h3.4v11.3h-3.4zm-14.3 0h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M332 160.2v3.4h-15.2v-3.4zm1-8.7v3.3h-9.6v-3.3z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs155("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx180("path", {
              d: "M381.4 143.4h49v3.4h-49zm7.3 17h3.4v3.2h-3.4zm42-.2v3.4h-9.9v-3.4zm5.2-16.8h3.4v20.2h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M455.4 160.2v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M452.7 143.4h3.3v20.2h-3.3zm-8.5 0h3.4v20.2h-3.4zm-44.8 8v3.4h-17.9v-3.3zm39.3 0v3.4h-17.9v-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M420.8 152.3h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M420.8 152.3h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M420.8 152.3h3.4v11.3h-3.4zm-39.3 0h3.4v11.3h-3.4zm28.8 0h3.4v11.3h-3.4zm-14.3 0h3.4v11.3h-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M412.7 160.2v3.4h-15.1v-3.4zm1-8.7v3.3H404v-3.3z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs155("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx180("path", {
              d: "M462.2 143.4h49v3.4h-49zm7.3 17h3.4v3.2h-3.4zm41.9-.2v3.4h-9.8v-3.4zm5.2-16.8h3.4v20.2h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M536.2 160.2v3.4h-18.6v-3.4zm-34.7-7.9h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M533.4 143.4h3.4v20.2h-3.4zm-8.4 0h3.3v20.2H525zm-44.8 8v3.4h-18v-3.3zm39.3 0v3.4h-18v-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M501.6 152.3h3.3v11.3h-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M501.6 152.3h3.3v11.3h-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M501.6 152.3h3.3v11.3h-3.3zm-39.4 0h3.4v11.3h-3.4zm28.9 0h3.3v11.3h-3.3zm-14.3 0h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M493.4 160.2v3.4h-15.1v-3.4zm1-8.7v3.3h-9.6v-3.3z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs155("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx180("path", {
              d: "M543.4 143.4h49v3.4h-49zm7.3 17h3.4v3.2h-3.4zm41.9-.2v3.4h-9.8v-3.4zm5.2-16.8h3.4v20.2h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M617.4 160.2v3.4h-18.6v-3.4zm-34.6-7.9h3.3v11.3h-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M614.6 143.4h3.4v20.2h-3.4zm-8.4 0h3.3v20.2h-3.3zm-44.8 8v3.4h-18v-3.3zm39.3 0v3.4h-18v-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M582.8 152.3h3.3v11.3h-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M582.8 152.3h3.3v11.3h-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M582.8 152.3h3.3v11.3h-3.3zm-39.3 0h3.3v11.3h-3.3zm28.8 0h3.4v11.3h-3.4zm-14.3 0h3.4v11.3H558z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M574.6 160.2v3.4h-15.1v-3.4zm1-8.7v3.3H566v-3.3z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs155("g", {
          fill: "#fff",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx180("path", {
              d: "M-183.8 143.4h49v3.4h-49zm7.3 17h3.4v3.2h-3.4zm42-.2v3.4h-9.9v-3.4zm5.2-16.8h3.4v20.2h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M-109.8 160.2v3.4h-18.6v-3.4zm-34.6-7.9h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M-112.5 143.4h3.3v20.2h-3.3zm-8.5 0h3.4v20.2h-3.4zm-44.8 8v3.4h-17.9v-3.3zm39.3 0v3.4h-17.9v-3.3z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M-144.4 152.3h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M-144.4 152.3h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M-144.4 152.3h3.4v11.3h-3.4zm-39.3 0h3.4v11.3h-3.4zm28.8 0h3.4v11.3h-3.4zm-14.3 0h3.4v11.3h-3.4z"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M-152.5 160.2v3.4h-15.2v-3.4zm1-8.7v3.3h-9.6v-3.3z"
            })
          ]
        }),
        /* @__PURE__ */ jsx180("path", {
          fill: "#d90000",
          d: "M-68.8 339.5h6V350h-6zm160.5 0h6V350h-6zm-283.7 0h6V350h-6zm81.5 0h6V350h-6zm80.9 0h6V350h-6zm40 0h6V350h-6zm40.9 0h6V350h-6zm80.4 0h6V350h-6zm203 0h6.1V350h-6zm-162.1 0h6V350h-6zm40 0h6V350h-6zm40.5 0h6V350h-6zm40.4 0h6V350h-6zm323.2 0h6V350h-6zm-242.7 0h6V350h-6zm40.8 0h6V350h-6zm41.3 0h6V350h-6zm38.8 0h6V350h-6zm41.3 0h6V350h-6zm40.4 0h6V350h-6zm119.7 0h6V350h-6zm-38.8 0h6V350h-6zm-808.9 0h6V350h-6z"
        }),
        /* @__PURE__ */ jsx180("path", {
          fill: "#239e3f",
          d: "M-68.8 162.6h6v10.5h-6zm160.5 0h6v10.5h-6zm-283.7 0h6v10.5h-6zm81.5 0h6v10.5h-6zm80.9 0h6v10.5h-6zm40 0h6v10.5h-6zm40.9 0h6v10.5h-6zm80.4 0h6v10.5h-6zm203 0h6.1v10.5h-6zm-162.1 0h6v10.5h-6zm40 0h6v10.5h-6zm40.5 0h6v10.5h-6zm40.4 0h6v10.5h-6zm323.2 0h6v10.5h-6zm-242.7 0h6v10.5h-6zm40.8 0h6v10.5h-6zm41.3 0h6v10.5h-6zm38.8 0h6v10.5h-6zm41.3 0h6v10.5h-6zm40.4 0h6v10.5h-6zm119.7 0h6v10.5h-6zm-38.8 0h6v10.5h-6zm-808.9 0h6v10.5h-6z"
        }),
        /* @__PURE__ */ jsxs155("g", {
          fill: "#da0000",
          children: [
            /* @__PURE__ */ jsx180("path", {
              d: "M279.8 197.5c8.4 10.4 34.5 67.6-15.7 105.2-23.7 17.8-9 18.6-8.3 21.6 38-20.1 50.3-47.5 50-72-.2-24.4-13.2-46-26-54.8"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M284.8 194.8a73.3 73.3 0 0 1 15.7 112.4c27.2-6 62-86.4-15.7-112.4m-57.6 0a73.3 73.3 0 0 0-15.6 112.4c-27.3-6-62-86.4 15.6-112.4"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M232.2 197.5c-8.4 10.4-34.5 67.6 15.7 105.2 23.6 17.8 9 18.6 8.3 21.6-38-20.1-50.3-47.5-50-72 .2-24.4 13.2-46 26-54.8"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "M304.2 319.1c-14.9.2-33.6-2-47.5-9.3 2.3 4.5 4.2 7.3 6.5 11.7 13.2 1.3 31.5 2.8 41-2.4m-95 0c14.9.2 33.6-2 47.5-9.3-2.3 4.5-4.2 7.3-6.5 11.7-13.2 1.3-31.5 2.8-41-2.4m27.3-138.7c3 8 10.9 9.2 19.3 4.5 6.2 3.6 15.7 3.9 19-4.1 2.5 19.8-18.3 15-19 11.2-7.8 7.5-22.2 3.2-19.3-11.6"
            }),
            /* @__PURE__ */ jsx180("path", {
              d: "m256.4 331.6 7.8-9 1.1-120.1-9.3-8.2-9.3 7.8 1.9 121z"
            })
          ]
        })
      ]
    })
  ]
});
var Ir_default = SvgIr;

// src/country-flag-icons/generated/Is.tsx
init_esm_shims();
import { jsx as jsx181, jsxs as jsxs156 } from "react/jsx-runtime";
var SvgIs = (props) => /* @__PURE__ */ jsxs156("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx181("defs", {
      children: /* @__PURE__ */ jsx181("clipPath", {
        id: "is_svg__a",
        children: /* @__PURE__ */ jsx181("path", {
          fillOpacity: 0.7,
          d: "M0 0h640v480H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs156("g", {
      fillRule: "evenodd",
      strokeWidth: 0,
      clipPath: "url(#is_svg__a)",
      children: [
        /* @__PURE__ */ jsx181("path", {
          fill: "#003897",
          d: "M0 0h666.7v480H0z"
        }),
        /* @__PURE__ */ jsx181("path", {
          fill: "#fff",
          d: "M0 186.7h186.7V0h106.6v186.7h373.4v106.6H293.3V480H186.7V293.3H0z"
        }),
        /* @__PURE__ */ jsx181("path", {
          fill: "#d72828",
          d: "M0 213.3h213.3V0h53.4v213.3h400v53.4h-400V480h-53.4V266.7H0z"
        })
      ]
    })
  ]
});
var Is_default = SvgIs;

// src/country-flag-icons/generated/It.tsx
init_esm_shims();
import { jsx as jsx182, jsxs as jsxs157 } from "react/jsx-runtime";
var SvgIt = (props) => /* @__PURE__ */ jsx182("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs157("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    children: [
      /* @__PURE__ */ jsx182("path", {
        fill: "#fff",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsx182("path", {
        fill: "#009246",
        d: "M0 0h213.3v480H0z"
      }),
      /* @__PURE__ */ jsx182("path", {
        fill: "#ce2b37",
        d: "M426.7 0H640v480H426.7z"
      })
    ]
  })
});
var It_default = SvgIt;

// src/country-flag-icons/generated/Je.tsx
init_esm_shims();
import { jsx as jsx183, jsxs as jsxs158 } from "react/jsx-runtime";
var SvgJe = (props) => /* @__PURE__ */ jsxs158("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx183("path", {
      fill: "#fff",
      d: "M0 0h640v480H0Z"
    }),
    /* @__PURE__ */ jsx183("path", {
      d: "m1.3-.077 637.387 480.088m-637.387 0L638.687-.077",
      color: "#000"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "#cf142b",
      d: "M0-.077V28.84l280.494 211.127L0 451.194v28.718h44l275.994-210.236L595.788 480.01h44.2v-29.114l-280.495-210.93L639.987 28.74V.022h-43.999L319.994 210.061 43.999-.077Z",
      color: "#000"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "#cf142b",
      stroke: "maroon",
      strokeMiterlimit: 140.8,
      strokeWidth: 0.5,
      d: "M364.2 65c10.8 44 4.8 98.2-44.2 128.4-49-30.2-55-84.4-44.2-128.4 11.6-10.5 64.2-17 88.4 0z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "gold",
      stroke: "#806600",
      strokeMiterlimit: 135.2,
      strokeWidth: 0.2,
      d: "M295.1 91a6.6 6.6 0 0 1-2.4-.4 6 6 0 0 1-1.4-2 10.4 10.4 0 0 1-2.7.2 7.2 7.2 0 0 1-2.1-1.2 4 4 0 0 0 2.2-.9 10.7 10.7 0 0 1-2.5-.5c-.8-.4-1.5-.8-2.1-1.3.8-.2 1.6-.2 2.1-.8l-2.4-.3a8.4 8.4 0 0 1-1.7-1.3c.8 0 1.6-.3 2.2-1a8.2 8.2 0 0 1-2.3-.1 11.8 11.8 0 0 1-2.4-1.6 4.6 4.6 0 0 0 2.6-.8l-.6-1c-.6-1.2-1.8-.7-2.7-1.1a2.4 2.4 0 0 1-1.4-1.8c0-.9.4-2.3 2.4-2-1-1.6.1-2.7 1.2-3.2 1-.4 2-.2 2.7 1.5a5.6 5.6 0 0 1 1.4-.8 1.5 1.5 0 0 1 1.8.6v1.2c-.3.6-1 1-1 1.8-.3.8.5 2.4.5 2.4s4 3.2 5.7 4.8l2.8 3h4.1l.3 6.6H295z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "#377bc8",
      stroke: "#2c5aa0",
      strokeMiterlimit: 135.2,
      strokeWidth: 0.2,
      d: "M284.2 69.2a2.4 2.4 0 0 1 .7 2.4c.2.3.5.5 1 .4a1 1 0 0 0 .7-1.3c-.4-.3-.5-1.1-2.4-1.6zm-4.5.5a4.6 4.6 0 0 0-1.1.1 2.4 2.4 0 0 1 1.6 2c.3.1.8.1 1-.1a1 1 0 0 0 .2-1.5c-.4 0-.8-.5-1.6-.5zm-1.3 4.2c-.5.1-1.2-.4-2.7.8a2.4 2.4 0 0 1 2.3 1c.3 0 .7-.1.9-.4a1 1 0 0 0-.5-1.4z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "gold",
      stroke: "#806600",
      strokeMiterlimit: 135.2,
      strokeWidth: 0.2,
      d: "M317.6 94c-.6-.2-1.5-1-2.2-1a2 2 0 0 0-1.7 1 1.8 1.8 0 0 0 .4 1.5l1.3.8a4.4 4.4 0 0 0-1 1.6 1.6 1.6 0 0 0 .6 1.1c.4.5.6.8 1.2.8a6.6 6.6 0 0 0 1.5-.1 2.4 2.4 0 0 0 .1 1.1 2.3 2.3 0 0 0 2.1 1.1 1.4 1.4 0 0 0 1.2-.6c.3-.4.3-1.4.7-1.9l1.9-1.6c.8.4.8 1.2.6 2a6.9 6.9 0 0 0 1.6-1.4 7 7 0 0 0 .5-1.8 2 2 0 0 1 .8 2 7.8 7.8 0 0 0 1.6-1.2 6 6 0 0 0 .8-2c.6.7.8 1.6.5 2.3a6.4 6.4 0 0 0 1.7-1.6 7.2 7.2 0 0 0 .4-1.6c1.6.1 2.8-.6 2.8-1.4 0-.5-.6-1.3-1.9-1.6a7 7 0 0 1-.6-1.2 1.8 1.8 0 0 1 0-1.1 4.8 4.8 0 0 1 1.5-2 18.4 18.4 0 0 1 2.8-1.5l-.6-2.9-6.5-1-7.4 1.8c1.4.6 4.3 2.7 4.1 3.5 0 .3-.7.6-1 1-.2.2 0 .8.2 1 .2.4 1 .5 1.3.9.2.3.2.8 0 1-.5.7-2.2 1-3 1.3l-4 2.1a5.5 5.5 0 0 1-2.2-.4z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "gold",
      stroke: "#806600",
      strokeMiterlimit: 135.2,
      strokeWidth: 0.2,
      d: "M333.1 85.1s-.1 2.4-1.1 3a1.8 1.8 0 0 1-1.4.1 1.8 1.8 0 0 1-1-1l-.3-1.1a9.4 9.4 0 0 0-2.3-.7c-1.2 0-2.4.3-3.6.6a8 8 0 0 1 2.7-3.2l3.9-.3z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "gold",
      d: "M343.6 69.4c1.1-.1 3.4-.6 4.2-1.3l1.4-1.4c-.2 2.3-1.4 3.7-3.8 4.7a13.8 13.8 0 0 1-6.2.8 28.2 28.2 0 0 1-3.8-.8c1.4 1.4.7 2.4-1 3 0 0 .2-1.3-.2-1.5-1-.4-2.4.1-3.5.8a6.9 6.9 0 0 1-3 .6 8 8 0 0 1-3.6-.5c-.8-.2-2.3-1.3-2.8-1.2-1.4.2-3 .4-3.7 1.4-.2.3-.2.8 0 1.2a4 4 0 0 0 2.6 1.5c2.8.6 5.6.7 8.4.3l9.6-1.9c3-.5 6.8-1.4 9-1.9a34.2 34.2 0 0 1 8.9-1c5.3.1 7 2.8 6.9 5.6-.2 2.8-3.3 4.1-6 5-4.8 1.4-11.4.6-15.6.4l2 1.6c.8.6 1.2 1.8 2 2 1.3.4 3.2-.4 4.5-.4 1.9-.2 5 0 5 0a3 3 0 0 1 1.3-.8 2.4 2.4 0 0 1 1.2 0c.6.2 1 .8.8 2 .2.2.5.5 1 .6h1.7l1.6.8-1.5.5a3.1 3.1 0 0 0-.7.7c.7 0 1.3 0 2 .3a3.8 3.8 0 0 1 1.2 1 2.9 2.9 0 0 0-1.3.2 6 6 0 0 0-.8.6s1.6-.1 2.2.3l1.1 1.2a6.6 6.6 0 0 0-1.3 0l-.8.4a5.6 5.6 0 0 1 1.6 1.2c.4.4.5 1 .6 1.6a8 8 0 0 0-1.1-.6 2.9 2.9 0 0 0-.8 0l.2 2.2c0 .6 1 1.2 1 1.6a1 1 0 0 1-.1 1.2 2.2 2.2 0 0 1-2.2.7 3 3 0 0 1-1-.6 5 5 0 0 1-.9 1c-.5.4-.6.4-1.3.4a2 2 0 0 1-1.3-.5 4.3 4.3 0 0 1-.7-1.6l-1.6.3a2.2 2.2 0 0 1-1.5-.7 1.6 1.6 0 0 1 .3-1.8c.4-.4 1.6-.5 2.2-.8a5 5 0 0 0 1.6-1.3 38 38 0 0 1-3.8-3 25.6 25.6 0 0 1-1.6-2.1s-3.4 1-4.7 1a26 26 0 0 1-6.4 0c-4.8 0-8-6.6-12.3-8.2a5 5 0 0 0-3.3 0c-5 1-10.4 6.8-15.3 8-2.1.4-4.3.6-6.4.7a5.6 5.6 0 0 1-1.3 1.7 7.2 7.2 0 0 1-2.6.5 8.3 8.3 0 0 1-1 2.3 7.1 7.1 0 0 1-2 1.3 3.3 3.3 0 0 0 0-2.3 9 9 0 0 1-1.5 2 12 12 0 0 1-2.2 1.1c.2-.6.5-1.3 0-2.1a7.7 7.7 0 0 1-1.2 1.8c-.6.5-1.3.8-2 1a2.4 2.4 0 0 0 0-2.3 6.9 6.9 0 0 1-1.2 1.9 12.2 12.2 0 0 1-2.6 1.3 3.7 3.7 0 0 0 .4-2.4h-1.2c-1.5 0-1.6 1.3-2.3 1.9a2.7 2.7 0 0 1-2.4.4c-.8-.4-1.7-1.4-.5-3-2 .2-3-1-3-2.2 0-1 .3-1.9 2.4-1.8a4 4 0 0 1-.2-1.4 1.4 1.4 0 0 1 1.5-1.2c.4 0 .8.3 1.2.6.4.4.5 1.1 1.2 1.6.8.6 2.7.5 2.7.5a50.2 50.2 0 0 1 6.2-2.8c1.3-.4 5-1 5-1V81a86.9 86.9 0 0 1 13 1.1l5.2-.3s8.4-1.3 12.4-1.7c2-.2 4-.3 6.1-.2 3 .2 5.6.9 8.6 1 2.1.3 4.3.4 6.4.3 3.5-.2 9.7 0 11.7-3a2 2 0 0 0-.6-2.6 3.1 3.1 0 0 0-3-.8c-.8.1-1.6.6-1.7 1.2a1.4 1.4 0 0 0 .3 1.1c.2.4.6.7 1.1.9a3.8 3.8 0 0 1-2.2-.3 6.4 6.4 0 0 1-1.4-2.2 2 2 0 0 0-.5 1.5c0 .6.2 1.2.7 1.6a4.2 4.2 0 0 1-2.4-.8 6.8 6.8 0 0 1-.9-2.2 2.4 2.4 0 0 0-.8 1.6c0 .6.3 1 .5 1.7a5 5 0 0 1-2.2-1.2 6.4 6.4 0 0 1-.7-2.2l-9 1.8-9.5 1.6a24 24 0 0 1-11.3-.8c-1.6-.8-2.4-1.3-2.8-2.7a3.2 3.2 0 0 1 1-2.7 9.8 9.8 0 0 1 5-2.6 76.3 76.3 0 0 1 8.8-1.6 33.6 33.6 0 0 1 9.5.4c1.4.2 3-.1 3.3-.6.4-.4 1-.8.2-1.8.8 0 1.4.5 1.8 1.2.3.4 0 1.6 0 1.6z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "none",
      stroke: "#806600",
      strokeMiterlimit: 135.2,
      strokeWidth: 0.2,
      d: "M343.6 69.4c1.1-.1 3.4-.6 4.2-1.3l1.4-1.4c-.2 2.3-1.4 3.7-3.8 4.7a13.8 13.8 0 0 1-6.2.8 28.2 28.2 0 0 1-3.8-.8c1.4 1.4.7 2.4-1 3 0 0 .2-1.3-.2-1.5-1-.4-2.4.1-3.5.8a6.9 6.9 0 0 1-3 .6 8 8 0 0 1-3.6-.5c-.8-.2-2.3-1.3-2.8-1.2-1.4.2-3 .4-3.7 1.4-.2.3-.2.8 0 1.2a4 4 0 0 0 2.6 1.5c2.8.6 5.6.7 8.4.3l9.6-1.9c3-.5 6.8-1.4 9-1.9a34.2 34.2 0 0 1 8.9-1c5.3.1 7 2.8 6.9 5.6-.2 2.8-3.3 4.1-6 5-4.8 1.4-11.4.6-15.6.4l2 1.6c.8.6 1.2 1.8 2 2 1.3.4 3.2-.4 4.5-.4 1.9-.2 5 0 5 0a3 3 0 0 1 1.3-.8 2.4 2.4 0 0 1 1.2 0c.6.2 1 .8.8 2 .2.2.5.5 1 .6h1.7l1.6.8-1.5.5a3.1 3.1 0 0 0-.7.7c.7 0 1.3 0 2 .3a3.8 3.8 0 0 1 1.2 1 2.9 2.9 0 0 0-1.3.2 6 6 0 0 0-.8.6s1.6-.1 2.2.3l1.1 1.2a6.6 6.6 0 0 0-1.3 0l-.8.4a5.6 5.6 0 0 1 1.6 1.2c.4.4.5 1 .6 1.6a8 8 0 0 0-1.1-.6 2.9 2.9 0 0 0-.8 0l.2 2.2c0 .6 1 1.2 1 1.6a1 1 0 0 1-.1 1.2 2.2 2.2 0 0 1-2.2.7 3 3 0 0 1-1-.6c-.2.4-.5.7-.9 1a1.8 1.8 0 0 1-1.3.5 2 2 0 0 1-1.3-.6 4.3 4.3 0 0 1-.7-1.6l-1.6.3a2.2 2.2 0 0 1-1.5-.7 1.6 1.6 0 0 1 .3-1.8c.4-.4 1.6-.5 2.2-.8a5 5 0 0 0 1.6-1.3 38 38 0 0 1-3.8-3 25.6 25.6 0 0 1-1.6-2.1s-3.4 1-4.7 1a26 26 0 0 1-6.4 0c-4.8 0-8-6.6-12.3-8.2a5 5 0 0 0-3.3 0c-5 1-10.4 6.8-15.3 8-2.1.4-4.3.6-6.4.7a5.6 5.6 0 0 1-1.3 1.7 7.2 7.2 0 0 1-2.6.5 8.3 8.3 0 0 1-1 2.3 7.1 7.1 0 0 1-2 1.3 3.3 3.3 0 0 0 0-2.4 9 9 0 0 1-1.5 2 12 12 0 0 1-2.2 1.2c.2-.6.5-1.3 0-2.1a7.7 7.7 0 0 1-1.2 1.8c-.6.5-1.3.8-2 1a2.4 2.4 0 0 0 0-2.3 6.9 6.9 0 0 1-1.2 1.9 12.2 12.2 0 0 1-2.6 1.3 3.7 3.7 0 0 0 .4-2.4h-1.2c-1.5 0-1.6 1.3-2.3 1.9a2.7 2.7 0 0 1-2.4.4c-.8-.4-1.7-1.4-.5-3-2 .2-3-1-3-2.2 0-1 .3-1.9 2.4-1.8a4 4 0 0 1-.2-1.4 1.4 1.4 0 0 1 1.5-1.2c.4 0 .8.3 1.2.6.4.4.5 1.1 1.2 1.6.8.6 2.7.5 2.7.5a50.2 50.2 0 0 1 6.2-2.8c1.3-.4 5-1 5-1V81a86.9 86.9 0 0 1 13 1.1l5.2-.3s8.4-1.3 12.4-1.7c2-.2 4-.3 6.1-.2 3 .2 5.6.9 8.6 1 2.1.3 4.3.4 6.4.3 3.5-.2 9.7 0 11.7-3a2 2 0 0 0-.6-2.6 3.1 3.1 0 0 0-3-.8c-.8.1-1.6.6-1.7 1.2 0 .4 0 .8.3 1 .3.4.6.7 1.1 1 0 0-1.7 0-2.4-.4a4.6 4.6 0 0 1-1.2-2.1 2 2 0 0 0-.5 1.5c0 .6.2 1.2.7 1.6a4.2 4.2 0 0 1-2.4-.8 6.8 6.8 0 0 1-.9-2.2 2.4 2.4 0 0 0-.8 1.6c0 .6.3 1 .5 1.7a5 5 0 0 1-2.2-1.2 6.4 6.4 0 0 1-.7-2.2l-9 1.8-9.5 1.6a22 22 0 0 1-11.3-1c-1.6-.6-2.4-1.1-2.8-2.5a3.2 3.2 0 0 1 1-2.8 9.8 9.8 0 0 1 5-2.5 76.3 76.3 0 0 1 8.8-1.6 33.6 33.6 0 0 1 9.4.4c1.4.2 3-.1 3.4-.6.4-.4 1-.8.1-1.8a2 2 0 0 1 1.8 1.2c.3.4 0 1.6 0 1.6z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "gold",
      d: "M307.6 82.3c1 .7 2-.1 2.2-.2a2.6 2.6 0 0 1-.8-1.1 7.1 7.1 0 0 1-.2-2c0-1.6.6-1.9.6-1.8a7.4 7.4 0 0 0 1.6-.7 2.4 2.4 0 0 0 .7-1.5 5.1 5.1 0 0 0-.2-1.9c-1.6 0-2 .1-2.4.6a7.2 7.2 0 0 0-.2-1.6 4.8 4.8 0 0 0-.6-1.2 2.2 2.2 0 0 0-.5-.6c0 .5-.4.8-.6 1.1a6.6 6.6 0 0 0-.6-2.1 6.2 6.2 0 0 0-1.2-1 6.2 6.2 0 0 0-1.5.2 6.6 6.6 0 0 0-1.6 1.6 2.4 2.4 0 0 1 .1-1.3c-.2 0-.5 0-.8.2a4.8 4.8 0 0 0-1.1.7 7.2 7.2 0 0 0-1 1.2c0-.7-.4-1-1.7-1.9a5.1 5.1 0 0 0-1.2 1.6 2.4 2.4 0 0 0-.2 1.6c.2.6.6 1 1 1.5 0-.1.4.5-.5 1.8a7.2 7.2 0 0 1-1.3 1.5 2.6 2.6 0 0 1-1.3.5c.3.9.4 1.3 1.8 1.5-3 2.2-3.4 5.7-1 8.7a6.9 6.9 0 0 1 .9-1.5 4.3 4.3 0 0 0 1 2.6c.2.3.4 2 .8 2.4l1 1s.3-1.3.9-1.5l2-.6c.9-.3 2.1-1.9 2.1-1.9l-.2 2c4-1.4 5-4.2 4-7.9"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "#504416",
      d: "M299.8 77.4a8.2 8.2 0 0 1-.8 4l2.5 1 2.7.4c-.3-1.1.8-3.2 1.3-3.8h-1.9l-.8-.8-1.6.3z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "#fff",
      d: "M300.2 78a3.2 3.2 0 0 0 0 2l.8-1.6zm3.8 1.2-.2 1.8a3.2 3.2 0 0 0 1-1.7zm-3.8 1.3a3.2 3.2 0 0 0-1 1.7h.9zm3.3.9-.7 1.6.6.4a3.2 3.2 0 0 0 .1-2m-3-8.6c-.5 0-.8.2-1 .6 0 .4.3 1 1 1.2a1.4 1.4 0 0 0 1.7-.7c.2-.5-.4-.8-1.2-1a2.6 2.6 0 0 0-.5-.1m5.4 1.6c-.4 0-.6 0-.8.4a1.4 1.4 0 0 0 1.1 1.4c.8.3 1.4 0 1.6-.5.1-.6-.4-1-1-1.2z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "#d1b948",
      d: "M300.5 72.6a1.5 1.5 0 0 0-.5.1.8.8 0 0 0-.6.6c0 .3 0 .6.2.9.2.3.6.5.9.6.8.2 1.6 0 1.8-.8a.7.7 0 0 0-.2-.8 2.8 2.8 0 0 0-1-.4 2.6 2.6 0 0 0-.6-.2m0 .4a2.5 2.5 0 0 1 .5 0l.8.4c.3 0 .4.4.3.5a1.2 1.2 0 0 1-1.5.7 1.4 1.4 0 0 1-.8-.6.8.8 0 0 1 0-.6.6.6 0 0 1 .3-.4zm5.4 1.2h-.2a.7.7 0 0 0-.7.5 1.4 1.4 0 0 0 1.2 1.6c.3.2.8.2 1 0 .3 0 .6-.3.6-.6a.8.8 0 0 0-.1-.8 2 2 0 0 0-1-.5zm0 .3.8.1c.3 0 .6.3.8.4.1.2.2.4.1.7a.8.8 0 0 1-.5.5h-.9a1.2 1.2 0 0 1-1-1.4c0-.2.2-.2.5-.3z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "gold",
      d: "M300.6 71.7a1.3 1.3 0 0 0-1 .2c-.2.2-.2.7-.2.7h.4l.7.1 1.3.6h1.5l-1.2-.7c-.5-.2-1-.8-1.6-1zm7 2c-.6-.2-1.1 0-1.6 0l-1.4-.1 1.2.8 1.5.2.6.2.4.3.3-.6a1.3 1.3 0 0 0-1-.8m-8.6 7.7c-1.3 3.5 4 5.2 4.8 1.4a11 11 0 0 1-4.8-1.4"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "#806600",
      d: "m299 81.1-.2.3a2.7 2.7 0 0 0 0 2.4 2.8 2.8 0 0 0 5.4-.8v-.4h-.3a10.7 10.7 0 0 1-4.8-1.3zm.1.4A14 14 0 0 0 304 83a3.2 3.2 0 0 1-1.1 1.7 3.5 3.5 0 0 1-2.2.2 3.5 3.5 0 0 1-1.6-1.4 2.6 2.6 0 0 1 0-1.9z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "#377bc8",
      stroke: "#2c5aa0",
      strokeMiterlimit: 135.2,
      strokeWidth: 0.2,
      d: "M301.3 78.4a15.2 15.2 0 0 0-.8 7.2c1.6-1.8 2.4-4.2 3-6.4 0-.2-.4-.3-.5-.4l-.4-.6a3.4 3.4 0 0 1-.7.4 2 2 0 0 1-.6-.1z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "gold",
      d: "M305.4 68.2a6.2 6.2 0 0 0-1.5.3 6.6 6.6 0 0 0-1.6 1.6 2.4 2.4 0 0 1 0-1.3c-.2 0-.5 0-.7.2a4.8 4.8 0 0 0-1.2.7 7.2 7.2 0 0 0-1 1.1c.4 0 1.6-1 2-.9.4 0 .2 1 .5 1.1.5 0 1-.8 1.6-1.2a3 3 0 0 1 1.6-.8 2.4 2.4 0 0 1 1 1.6c.3.8.5 1.6.9 1.9.3.1.6-.8 1-.8.5.2.7 1.7 1.1 2a7.2 7.2 0 0 0-.2-1.6 4.8 4.8 0 0 0-.7-1.2 2.2 2.2 0 0 0-.5-.6c0 .4-.4.8-.6 1.1a6.6 6.6 0 0 0-.5-2.1 6.2 6.2 0 0 0-1.2-1zm-6.5 5.7c-.6 1 0 2 1.2 2.1l-.4 1.1.6 1.3 1.2.4 1-.4.9 1 1 .2 1.3-.8.5-.9h.8l.8-.4.2-.9a2.3 2.3 0 0 1-2.6.4 2 2 0 0 1-.5 1.4 1 1 0 0 1-1 .2 2.3 2.3 0 0 1-1.2-1c-.5.3-.8.6-1.2.5a1.4 1.4 0 0 1-1-1 1.6 1.6 0 0 1 .5-1.4c-2.4-.7-1.6-1.4-2.2-1.8zm-1.3.3a19.8 19.8 0 0 1-2 2.8 2.6 2.6 0 0 1-1.3.5c.3.9.4 1.3 1.8 1.5-3 2.2-3.4 5.7-1 8.7a6.9 6.9 0 0 1 .9-1.5 4.3 4.3 0 0 0 1 2.6c.2.3.4 2 .8 2.4l1 1s.3-1.3.9-1.5l2-.6c.9-.3 2.1-1.9 2.1-1.9l-.1 2c4-1.4 5-4.2 3.9-7.9 1 .7 2-.1 2.2-.2a2.6 2.6 0 0 1-.8-1.2 7.8 7.8 0 0 1-.2-2l-.2-1.1-.5 1.7v1.8a5.4 5.4 0 0 1-1.9-1 31.2 31.2 0 0 1 .8 4c0 .9-.1 1.8-.4 2.7a7 7 0 0 1-1.7 1.7 20.2 20.2 0 0 0 .3-2.4c0-.8-.4-3-.4-3a16.5 16.5 0 0 1-.8 3l-1.3 2c.3-2.1.2-2.2-.1-3 0 0-.5 2.6-1.5 3.7a8 8 0 0 1-1.6.8 1.8 1.8 0 0 0-.8.6l-.6-1.8a20.9 20.9 0 0 1-1.2-2.4c-.3-1.2 1.3-3.6 1.3-3.6-.6 0-1.2.7-1.9 1.4a18.2 18.2 0 0 0-1.3 1.8 16 16 0 0 1-.5-2.4 4.5 4.5 0 0 1 .7-2.2 21.6 21.6 0 0 1 3.4-3.3 4.5 4.5 0 0 1-3 0s1.3-1.3 1.4-1.6a4.3 4.3 0 0 0 .6-2zm5.2 1.2h-1.3v.6l.6.2.8 1 1.7-.5.3-.4a6.5 6.5 0 0 0-1.6-.9 2.5 2.5 0 0 0-.5 0"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "none",
      stroke: "#806600",
      strokeMiterlimit: 135.2,
      strokeWidth: 0.2,
      d: "M307.6 82.3c1 .7 2-.1 2.2-.2a2.6 2.6 0 0 1-.8-1.1 7.1 7.1 0 0 1-.2-2c0-1.6.6-1.9.6-1.8a7.4 7.4 0 0 0 1.6-.7 2.4 2.4 0 0 0 .7-1.5 5.1 5.1 0 0 0-.2-1.9c-1.6 0-2 .1-2.4.6a7.2 7.2 0 0 0-.2-1.6 4.8 4.8 0 0 0-.6-1.2 2.2 2.2 0 0 0-.5-.6c0 .5-.4.8-.6 1.1a4 4 0 0 0-1.8-3.2c-1.4 0-2.2.8-3.2 1.8a2.4 2.4 0 0 1 .2-1.2 2.2 2.2 0 0 0-.8.2 4.8 4.8 0 0 0-1.1.7 7.2 7.2 0 0 0-1 1.2c0-.7-.4-1-1.7-1.9a5.1 5.1 0 0 0-1.2 1.6 2.4 2.4 0 0 0-.2 1.6c.2.6.6 1 1 1.5 0-.1.4.5-.5 1.8a7.2 7.2 0 0 1-1.3 1.5 2.6 2.6 0 0 1-1.3.5c.3.9.4 1.3 1.8 1.5-3 2.2-3.4 5.7-1 8.7a6.9 6.9 0 0 1 .9-1.5 4.3 4.3 0 0 0 1 2.6c.2.3.4 2 .8 2.4l1 1s.3-1.3.9-1.5l2-.6c.9-.3 2.1-1.9 2.1-1.9l-.2 2c4-1.4 5-4.2 4-7.9z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "#806600",
      d: "M297.8 70.2a3.2 3.2 0 0 0-.6 1.6 6.4 6.4 0 0 0 1 1.7l.4-2.4c0-.4-.8-1-.8-1Zm2.1 2.1a.8.8 0 0 0-.3.1c-.2.2-.4.2-.6.6l.8-.4a.4.4 0 0 1 .3 0c.4.4.8.5 1.2.7a4.9 4.9 0 0 0 1.9 0 2.7 2.7 0 0 1-.2.8s-.7.2-1 .5a8.6 8.6 0 0 0-.3.4 1 1 0 0 0-.3.3v.8h.2c.4.1.8.5.8 1l.2.2a.5.5 0 0 0 .3 0h.4c.3-.3.8-.4 1.3-.3h.1l.1-.1c.2-.2.2-.3.2-.6V76a7.5 7.5 0 0 0-.1-.6l-.4-1 .1-.9a5 5 0 0 0 1.6 1.2l1.4.1.3.2.5.6c0-.3 0-.6-.2-.8-.1-.2-.3-.2-.5-.2-.4-.2-1 0-1.3-.2a4 4 0 0 1-1.5-1l-.3-.2-.1.2-.3 1.2.4 1.2a6.2 6.2 0 0 1 .1.7v.1a2.2 2.2 0 0 0-1.7.5h-.1a2.6 2.6 0 0 0-1.2-1.3v-.3l.1-.2.4-.3c.2-.3.8-.5 1-.8.2-.3.3-.7.3-1v-.4h-.3a3.6 3.6 0 0 1-1.8.2l-1.2-.6a.8.8 0 0 0-.3 0zm-1 1.4a1.6 1.6 0 0 0-.3 1.7c.3.4.7.7 1.2.8l-.1.2-.2.8c.1.6.4 1 .8 1.4a1.8 1.8 0 0 0 1.3.4 1.8 1.8 0 0 0 .8-.4l.6.8a1.8 1.8 0 0 0 1.3.3 1.8 1.8 0 0 0 1.8-1.5v-.1a1.6 1.6 0 0 0 1.4-.2c.4-.4.7-1 .7-1.6-.4.3 0 .8-1 1.4a1.1 1.1 0 0 1-1.1 0l-.4-.3v1a2.2 2.2 0 0 1-.3.5c-.3.3-.8.5-1.2.5a1.4 1.4 0 0 1-.8-.2 2 2 0 0 1-.6-.8v-.5l-.3.3-.5.3a1.4 1.4 0 0 1-.5.1 1.4 1.4 0 0 1-.9-.3 2 2 0 0 1-.8-1.2l.2-.5a1.4 1.4 0 0 1 .2-.4l.2-.4h-.4a1.4 1.4 0 0 1-1-.6c-.6-.6 0-1-.1-1.5m12 .2s-1 0-1.3.4a8.8 8.8 0 0 0-.8 2.3 6.4 6.4 0 0 0 1.6-1 3.2 3.2 0 0 0 .5-1.7"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "#2b2200",
      d: "M301 73.1a.6.6 0 0 0-.2 1.1.6.6 0 1 0 .2-1zm5.4 1.6a.6.6 0 0 0-.2 1 .6.6 0 1 0 .2-1"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "#377bc8",
      stroke: "#2c5aa0",
      strokeMiterlimit: 135.2,
      strokeWidth: 0.2,
      d: "M280.2 91.5c-.5.3-1.2-.2-2.7 1a2.4 2.4 0 0 1 2.4 1c.3 0 .7-.2.8-.6a1 1 0 0 0-.5-1.4zm33.9 1.6c-.5.3-1.2-.2-2.7 1a2.4 2.4 0 0 1 2.4 1 1 1 0 0 0 .8-.5 1 1 0 0 0-.5-1.5zm-36.4 2c-.4.3-1.2.2-2.1 1.9a2.4 2.4 0 0 1 2.6 0c.3-.2.5-.6.5-1a1 1 0 0 0-1-1zm37 2.6c-.4.4-1.2.3-1.9 2a2.4 2.4 0 0 1 2.5-.2c.4-.1.5-.5.5-.8a1 1 0 0 0-1.2-1zM280.1 99a1.3 1.3 0 0 0-.6.2c-.2.5-.9.8-.8 2.7a2.4 2.4 0 0 1 2.2-1.3c.2-.3.3-.7 0-1a1 1 0 0 0-.8-.6zm73.8.3h-.5c-.1.5-1 .8-1.1 2.7a2.4 2.4 0 0 1 2.4-1c.2-.4.2-.8.2-1.1a1 1 0 0 0-1-.6zm-35.2 1.2a1.3 1.3 0 0 0-.6.3c0 .5-.8.8-.5 2.7a2.4 2.4 0 0 1 2-1.4c.2-.4.2-.8 0-1a1 1 0 0 0-.8-.6zm43.8.2a1 1 0 0 0-1 .6c.2.5-.3 1.2.8 2.7a2.4 2.4 0 0 1 1.1-2.3 1 1 0 0 0-.5-1 1.3 1.3 0 0 0-.4 0zm-4.8.6c-.2 0-.4.1-.7.4 0 .4-.6 1 .1 2.8a2.4 2.4 0 0 1 1.7-2 1 1 0 0 0-.3-1 1 1 0 0 0-.8-.2z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "gold",
      stroke: "#806600",
      strokeMiterlimit: 128.6,
      strokeWidth: 0.2,
      d: "M295.2 127a6.2 6.2 0 0 1-2.2-.3 5.8 5.8 0 0 1-1.5-1.8 9 9 0 0 1-2.5 0 6.8 6.8 0 0 1-2-1 3.8 3.8 0 0 0 2.1-1 10.2 10.2 0 0 1-2.4-.3 11.2 11.2 0 0 1-2-1.3c.7-.2 1.5-.2 2-.8a8.8 8.8 0 0 1-2.1-.3 8 8 0 0 1-1.8-1.2 2.9 2.9 0 0 0 2.2-1 7.8 7.8 0 0 1-2.3-.2 11.2 11.2 0 0 1-2.2-1.5 4.4 4.4 0 0 0 2.4-.6l-.5-1c-.6-1.2-1.8-.8-2.6-1.1a2.2 2.2 0 0 1-1.3-1.6c-.1-.9.3-2.2 2.3-2-1-1.4 0-2.5 1-3 1-.4 2-.2 2.6 1.4a5.3 5.3 0 0 1 1.4-.8 1.4 1.4 0 0 1 1.6.6c.2.4.2.8 0 1.2-.2.5-.8.8-1 1.6-.2.8.6 2.4.6 2.4s3.8 3 5.5 4.6l2.6 2.7h3.8l.3 6.3z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "#377bc8",
      stroke: "#2c5aa0",
      strokeMiterlimit: 128.6,
      strokeWidth: 0.2,
      d: "M284.8 106.3a2.4 2.4 0 0 1 .6 2.3c.3.4.6.4 1 .4a1 1 0 0 0 .6-1.2c-.4-.4-.4-1-2.2-1.5zm-4.2.5a4.4 4.4 0 0 0-1.2 0 2.4 2.4 0 0 1 1.6 2 1 1 0 0 0 1 0 1 1 0 0 0 0-1.5c-.2 0-.6-.5-1.4-.5zm-1.3 4c-.5 0-1.1-.3-2.6.8a2.4 2.4 0 0 1 2.2 1c.4 0 .8-.2.9-.5a1 1 0 0 0-.5-1.3z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "gold",
      stroke: "#806600",
      strokeMiterlimit: 128.6,
      strokeWidth: 0.2,
      d: "M316.6 130c-.6-.2-1.4-1.1-2.1-1.1a2 2 0 0 0-1.6 1 1.7 1.7 0 0 0 .4 1.4l1.2.9a4.2 4.2 0 0 0-.8 1.4 1.4 1.4 0 0 0 .5 1.1c.4.5.4.7 1.2.8a6.2 6.2 0 0 0 1.2-.1c0 .3 0 .8.3 1a2.2 2.2 0 0 0 1.9 1c.5 0 1-.1 1.2-.5.2-.4.2-1.4.6-1.8l1.8-1.6c.8.5.7 1.1.6 1.9a6.6 6.6 0 0 0 1.5-1.2 5.5 5.5 0 0 0 .5-1.9 2 2 0 0 1 .8 2 7.4 7.4 0 0 0 1.6-1.2l.7-1.7a2.2 2.2 0 0 1 .4 2 6 6 0 0 0 1.6-1.6 6.9 6.9 0 0 0 .5-1.4c1.6 0 2.5-.6 2.6-1.3 0-.5-.6-1.3-1.8-1.5a6.6 6.6 0 0 1-.7-1.2 1.6 1.6 0 0 1 0-1.1 4.6 4.6 0 0 1 1.5-1.8 17.4 17.4 0 0 1 2.7-1.6l-.6-2.6-6.2-1-7 1.7c1.3.6 4.1 2.6 4 3.4-.2.2-.9.5-1.1.8-.2.4 0 .8.2 1 .3.5 1 .6 1.2.9a.8.8 0 0 1 0 1c-.4.7-2 .9-2.8 1.2l-3.8 2a5.2 5.2 0 0 1-2.2-.4z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "gold",
      stroke: "#806600",
      strokeMiterlimit: 128.6,
      strokeWidth: 0.2,
      d: "M331.4 121.4s-.1 2.3-1 2.8a1.7 1.7 0 0 1-1.5.3 1.8 1.8 0 0 1-.8-1.1l-.3-1a9 9 0 0 0-2.3-.7 13.3 13.3 0 0 0-3.3.6 7.7 7.7 0 0 1 2.4-3l3.8-.3z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "gold",
      d: "M341.4 106.5c1-.1 3.2-.6 4-1.2l1.2-1.3c-.1 2-1.2 3.4-3.6 4.4a13.1 13.1 0 0 1-5.9.7 26.8 26.8 0 0 1-3.5-.8c1.3 1.5.6 2.4-1 3 0 0 .3-1.3-.2-1.5-1-.4-2.2.2-3.4.8a6.5 6.5 0 0 1-2.8.6 9.1 9.1 0 0 1-3.4-.5c-.8-.2-2.2-1.3-2.7-1.2-1.3.3-2.8.4-3.5 1.4a1.1 1.1 0 0 0 0 1.2 4 4 0 0 0 2.5 1.3c2.6.6 5.3.7 8 .3 2.8-.4 6.2-1.2 9-1.7l8.8-2a32.6 32.6 0 0 1 8.4-.7c5 0 6.6 2.5 6.5 5.1-.2 2.8-3.2 4-5.8 4.8-4.6 1.4-10.8.6-14.7.5l1.9 1.4c.7.6 1 1.7 2 2 1.1.3 3-.4 4.2-.5l4.8.1c.2-.3.7-.6 1.2-.8a2.4 2.4 0 0 1 1 0c.6.2 1 .8.8 1.9a1.8 1.8 0 0 0 .9.5c.6.2 1.3 0 1.7.2l1.5.6-1.5.6a3 3 0 0 0-.6.6 7.6 7.6 0 0 1 2 .3c.3.2.7.5 1 1a2.7 2.7 0 0 0-1.2 0 5.7 5.7 0 0 0-.8.7s1.6-.1 2.2.3l1 1a6.3 6.3 0 0 0-1.2.2 4 4 0 0 0-.8.3 5.4 5.4 0 0 1 1.6 1.1 3.7 3.7 0 0 1 .5 1.6 7.6 7.6 0 0 0-1-.6 2.8 2.8 0 0 0-.8 0l.2 2.1c0 .5.8 1.1 1 1.5.2.4.1 1-.2 1.2a2.2 2.2 0 0 1-2 .6 3 3 0 0 1-1-.6 4.7 4.7 0 0 1-.8 1c-.4.4-.7.3-1.3.3a1.8 1.8 0 0 1-1.3-.4 4 4 0 0 1-.6-1.5l-1.5.3a2 2 0 0 1-1.4-.7 1.6 1.6 0 0 1 .2-1.7c.4-.5 1.6-.5 2.2-.8a4.8 4.8 0 0 0 1.4-1.2 36 36 0 0 1-3.5-2.9 24.4 24.4 0 0 1-1.6-2l-4.5 1a24.7 24.7 0 0 1-6 0c-4.6 0-7.6-6.3-11.7-7.8a4.8 4.8 0 0 0-3.2 0c-4.8 1-9.9 6.4-14.6 7.6a43.6 43.6 0 0 1-6 .7 5.3 5.3 0 0 1-1.3 1.6c-.8.3-1.6.5-2.4.5a8 8 0 0 1-1 2.1 6.8 6.8 0 0 1-2 1.3c.3-.8.4-1.5 0-2.2a8.6 8.6 0 0 1-1.3 1.9 11.4 11.4 0 0 1-2 1.1c0-.6.3-1.3 0-2a7.3 7.3 0 0 1-1.3 1.7c-.5.4-1.2.8-1.9 1a2.4 2.4 0 0 0 0-2.2 6.5 6.5 0 0 1-1.1 1.7 11.5 11.5 0 0 1-2.4 1.3c.3-.8.5-1.5.3-2.2H286c-1.3 0-1.4 1.1-2.1 1.7a2.6 2.6 0 0 1-2.2.4c-.9-.4-1.7-1.4-.6-3-1.9.3-2.8-.9-2.8-2 0-.9.3-1.8 2.2-1.7a3.8 3.8 0 0 1-.2-1.3 1.4 1.4 0 0 1 1.5-1c.4 0 .8 0 1.1.4.4.4.5 1 1.2 1.6a5.8 5.8 0 0 0 2.6.4 47.7 47.7 0 0 1 5.8-2.6c1.3-.4 4.8-1 4.8-1v-8.7h3.1c2.6 0 9.3 1 9.3 1l4.8-.3s8-1.2 12-1.6a38.6 38.6 0 0 1 5.7-.2c3 .1 5.4.8 8.1 1 2.1.2 4.2.3 6.2.2 3.3-.1 9.2 0 11-3a2 2 0 0 0-.4-2.3 3 3 0 0 0-3-.8c-.6.1-1.5.6-1.5 1.2-.1.4 0 .8.2 1.1l1 .8a3.7 3.7 0 0 1-2-.3 6 6 0 0 1-1.3-2.1 2 2 0 0 0-.5 1.4 2.2 2.2 0 0 0 .7 1.6 4 4 0 0 1-2.3-.8 6.5 6.5 0 0 1-.9-2.1 2.3 2.3 0 0 0-.8 1.5c0 .6.4 1 .6 1.6a4.8 4.8 0 0 1-2-1.1 6.2 6.2 0 0 1-.9-2.1l-8.5 1.6a101 101 0 0 1-9 1.6c-4.6.6-8 .3-10.8-.8-1.5-.6-2.2-1.2-2.6-2.4a3 3 0 0 1 .8-2.7 9.4 9.4 0 0 1 4.8-2.4 72.6 72.6 0 0 1 8.4-1.6 32 32 0 0 1 9 .5c1.4.1 2.8-.2 3.2-.6.4-.4 1-.8.2-1.8.7 0 1.3.5 1.6 1.2.3.4 0 1.6 0 1.6z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "gold",
      stroke: "#806600",
      strokeMiterlimit: 128.6,
      strokeWidth: 0.2,
      d: "M341.4 106.5c1-.1 3.2-.6 4-1.2l1.2-1.3c-.1 2-1.2 3.4-3.6 4.4a13.1 13.1 0 0 1-5.9.7 26.8 26.8 0 0 1-3.5-.8c1.3 1.5.6 2.4-1 3 0 0 .3-1.3-.2-1.5-1-.4-2.2.2-3.4.8a6.5 6.5 0 0 1-2.8.6 9.1 9.1 0 0 1-3.4-.5c-.8-.2-2.2-1.3-2.7-1.2-1.3.3-2.8.4-3.5 1.4a1.1 1.1 0 0 0 0 1.2 4 4 0 0 0 2.5 1.3c2.6.6 5.3.7 8 .3 2.8-.4 6.2-1.2 9-1.7l8.8-2a32.6 32.6 0 0 1 8.4-.7c5 0 6.6 2.5 6.5 5.1-.2 2.8-3.2 4-5.8 4.8-4.6 1.4-10.8.6-14.7.5l1.9 1.4c.7.6 1 1.7 2 2 1.1.3 3-.4 4.2-.5l4.8.1c.2-.3.7-.6 1.2-.8a2.4 2.4 0 0 1 1 0c.6.2 1 .8.8 1.9a1.8 1.8 0 0 0 .9.5c.6.2 1.3 0 1.7.2l1.5.6-1.5.6a3 3 0 0 0-.6.6 7.6 7.6 0 0 1 2 .3c.3.2.7.5 1 1a2.7 2.7 0 0 0-1.2 0 5.7 5.7 0 0 0-.8.7s1.6-.1 2.2.3l1 1a6.3 6.3 0 0 0-1.2.2 4 4 0 0 0-.8.3 5.4 5.4 0 0 1 1.6 1.1 3.7 3.7 0 0 1 .5 1.6 7.6 7.6 0 0 0-1-.6 2.8 2.8 0 0 0-.8 0l.2 2.1c0 .5.8 1.1 1 1.5.2.4.1 1-.2 1.2a2.2 2.2 0 0 1-2 .6 3 3 0 0 1-1-.6 4.7 4.7 0 0 1-.8 1 1.7 1.7 0 0 1-1.3.5 1.8 1.8 0 0 1-1.3-.6 4 4 0 0 1-.6-1.5l-1.5.3a2 2 0 0 1-1.4-.7 1.6 1.6 0 0 1 .2-1.7c.4-.5 1.6-.5 2.2-.8a4.8 4.8 0 0 0 1.4-1.2 36 36 0 0 1-3.5-2.9 24.4 24.4 0 0 1-1.6-2l-4.5 1a24.7 24.7 0 0 1-6 0c-4.6 0-7.6-6.3-11.7-7.8a4.8 4.8 0 0 0-3.2 0c-4.8 1-9.9 6.4-14.6 7.6a43.6 43.6 0 0 1-6 .7 5.3 5.3 0 0 1-1.3 1.6 6.8 6.8 0 0 1-2.4.5 8 8 0 0 1-1 2.1 6.8 6.8 0 0 1-2 1.3c.3-.8.4-1.5 0-2.2a8.6 8.6 0 0 1-1.3 1.9 11.4 11.4 0 0 1-2 1.1c0-.6.3-1.3 0-2a7.3 7.3 0 0 1-1.3 1.7c-.5.4-1.2.8-1.9 1a2.4 2.4 0 0 0 0-2.2 6.5 6.5 0 0 1-1.1 1.7 11.5 11.5 0 0 1-2.4 1.3c.3-.8.5-1.5.3-2.2H286c-1.3 0-1.4 1.1-2.1 1.7a2.6 2.6 0 0 1-2.2.4c-1-.4-1.7-1.4-.6-3-1.9.3-2.8-.9-2.8-2 0-.9.3-1.8 2.2-1.7a3.8 3.8 0 0 1-.2-1.3 1.4 1.4 0 0 1 1.5-1c.4 0 .8 0 1.1.4.4.4.5 1 1.2 1.6a5.8 5.8 0 0 0 2.6.4 47.7 47.7 0 0 1 5.8-2.6c1.3-.4 4.8-1 4.8-1v-8.7h3.1c2.6 0 9.3 1 9.3 1l4.8-.3s8-1.2 12-1.6a38.6 38.6 0 0 1 5.7-.2c3 .1 5.4.8 8.1 1 2.1.2 4.2.3 6.2.2 3.3-.1 9.2 0 11-3a2 2 0 0 0-.4-2.3 3 3 0 0 0-3-.8c-.6.1-1.5.6-1.5 1.2a1.2 1.2 0 0 0 .2 1l1 .9a4.9 4.9 0 0 1-2.2-.4 4.4 4.4 0 0 1-1.1-2 2 2 0 0 0-.5 1.4 2.2 2.2 0 0 0 .7 1.6 4 4 0 0 1-2.3-.8 6.5 6.5 0 0 1-.9-2.1 2.3 2.3 0 0 0-.8 1.5c0 .6.4 1 .6 1.6a4.8 4.8 0 0 1-2-1.1 6.2 6.2 0 0 1-.9-2.1l-8.5 1.6a101 101 0 0 1-9 1.6c-4.6.6-8 .3-10.8-.8-1.5-.6-2.2-1.2-2.6-2.4a3 3 0 0 1 .8-2.7 9.4 9.4 0 0 1 4.8-2.4 72.6 72.6 0 0 1 8.4-1.6 32 32 0 0 1 9 .5c1.4.1 2.8-.1 3.2-.6.4-.4 1-.8.2-1.8.7 0 1.3.5 1.6 1.2.3.4 0 1.6 0 1.6z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "gold",
      d: "M307 118.8c1 .6 2-.2 2.3-.2a2.5 2.5 0 0 1-.8-1.2 6.8 6.8 0 0 1-.3-1.8c0-1.6.5-1.8.6-1.6a7 7 0 0 0 1.4-.8c.4-.3.7-.8.8-1.3a4.8 4.8 0 0 0-.2-1.9c-1.5 0-1.8.2-2.2.6a6.9 6.9 0 0 0-.3-1.5 4.6 4.6 0 0 0-.5-1.2 2 2 0 0 0-.6-.5c0 .4-.3.8-.6 1a6.4 6.4 0 0 0-.4-2 1.6 1.6 0 0 0-2.6-.8 6.4 6.4 0 0 0-1.6 1.5 2.2 2.2 0 0 1 .2-1.2 2 2 0 0 0-.8.2 4.6 4.6 0 0 0-1 .7 6.9 6.9 0 0 0-1.1 1.1c0-.6-.3-1-1.6-1.7a4.8 4.8 0 0 0-1.1 1.6 2.4 2.4 0 0 0-.1 1.4 7 7 0 0 0 .8 1.4c.1 0 .5.4-.4 1.7a6.8 6.8 0 0 1-1.2 1.4c-.4.3-.8.5-1.3.5.4.8.5 1.2 1.8 1.4-3 2-3.2 5.4-1 8.3.2-.5.5-1 .9-1.4a4 4 0 0 0 .8 2.5c.3.3.5 1.8.8 2.3l1 1s.3-1.3.9-1.5l2-.6a7.4 7.4 0 0 0 2-1.7l-.3 1.8c3.8-1.3 4.8-4 3.7-7.5"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "#504416",
      d: "M299.6 114a7.8 7.8 0 0 1-.8 4l2.6 1 2.4.2c-.2-1 .8-3 1.2-3.6h-1.7l-.8-.8-1.5.3-1.4-1z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "#fff",
      d: "M300 114.7a3 3 0 0 0 0 1.9l.7-1.6zm3.6 1.1-.2 1.7a3 3 0 0 0 1-1.6h-.8zM300 117a3 3 0 0 0-.9 1.6l.7.1zm3.2 1-.8 1.5.7.3a3 3 0 0 0 0-1.9zm-2.9-8.2c-.5 0-.8.1-.9.4-.1.5.3 1 1 1.3a1.3 1.3 0 0 0 1.6-.6c0-.6-.4-.8-1.1-1zm5.2 1.4c-.4 0-.6.2-.8.4a1.3 1.3 0 0 0 1 1.4c.9.3 1.3 0 1.5-.5.2-.5-.2-.9-1-1.1a3.2 3.2 0 0 0-.8-.2z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "#d1b948",
      d: "M300.3 109.6a1.4 1.4 0 0 0-.4 0 .8.8 0 0 0-.5.6c-.1.3 0 .6.1.8.2.4.5.5.8.6a1.4 1.4 0 0 0 1.8-.8.6.6 0 0 0-.3-.6 2.7 2.7 0 0 0-1-.5 2.4 2.4 0 0 0-.5 0zm0 .2.5.1.8.4a.4.4 0 0 1 .2.5 1.2 1.2 0 0 1-1.4.6 1.4 1.4 0 0 1-.7-.4.7.7 0 0 1-.2-.7.6.6 0 0 1 .4-.4zm5.2 1.3a1.6 1.6 0 0 0-.2 0 .6.6 0 0 0-.7.5 1.4 1.4 0 0 0 1.2 1.6 1.6 1.6 0 0 0 1 0c.2-.2.5-.4.6-.7a.8.8 0 0 0-.3-.8 2 2 0 0 0-.8-.4 3.3 3.3 0 0 0-.8-.2m0 .3.7.1c.3 0 .5.2.8.4l.1.6a.7.7 0 0 1-.5.4 1.4 1.4 0 0 1-.8 0 1.2 1.2 0 0 1-1-1.2c0-.3.2-.3.5-.3z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "gold",
      d: "M300.4 108.6a1.2 1.2 0 0 0-1 .3c-.2.1-.2.6-.2.6h.6l.5.2 1.3.5h1.4l-1.2-.6c-.4-.2-.8-.9-1.4-1m6.6 2c-.4-.2-1 .1-1.5 0l-1.3-.1 1.2.8 1.4.2.6.2.4.2.2-.5a1.2 1.2 0 0 0-1-.8m-8 7.4c-1.4 3.2 3.8 4.8 4.6 1.3a10.5 10.5 0 0 1-4.6-1.3"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "#806600",
      d: "M298.8 117.6v.3a2.6 2.6 0 0 0 0 2.3 2.6 2.6 0 0 0 5-.8v-.3h-.2a10.2 10.2 0 0 1-4.6-1.3l-.2-.1zm.2.5a13.3 13.3 0 0 0 4.5 1.2 3.1 3.1 0 0 1-1 1.7 3 3 0 0 1-2 .2 3.4 3.4 0 0 1-1.6-1.4 2.5 2.5 0 0 1 0-1.7z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "#377bc8",
      stroke: "#2c5aa0",
      strokeMiterlimit: 128.6,
      strokeWidth: 0.2,
      d: "M301.1 115.2a14.4 14.4 0 0 0-.8 6.7c1.6-1.6 2.4-4 2.9-6.1l-.5-.4a6.5 6.5 0 0 1-.3-.5 3.2 3.2 0 0 1-.7.3 2 2 0 0 1-.6 0z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "gold",
      d: "M305 105.4a6 6 0 0 0-1.4.2 6.3 6.3 0 0 0-1.6 1.5 2.2 2.2 0 0 1 0-1.2c-.2 0-.4 0-.6.2a4.6 4.6 0 0 0-1.2.7 6.9 6.9 0 0 0-1 1c.6 0 1.7-1 2-.8.4 0 0 1 .5 1s.9-.6 1.5-1.1c.5-.5 1.2-.8 1.6-.7a2.4 2.4 0 0 1 .9 1.4c.2.8.4 1.6.8 1.8.3.2.6-.8 1-.7.4.2.6 1.6 1 1.9a6.9 6.9 0 0 0-.2-1.5 4.6 4.6 0 0 0-.6-1.2 2 2 0 0 0-.5-.5c0 .4-.4.8-.6 1a6.4 6.4 0 0 0-.5-2 6 6 0 0 0-1.1-1m-6.3 5.5c-.5.8.2 1.7 1.3 1.9l-.5 1 .7 1.2 1 .4 1.1-.4.7 1 1 .2 1.3-.8.5-.8h.8l.6-.4.2-.8c-.6.6-1.6.8-2.4.4a2 2 0 0 1-.4 1.3 1 1 0 0 1-1 .2 2.2 2.2 0 0 1-1.1-.9c-.5.2-.8.5-1.1.4a1.4 1.4 0 0 1-1-1 1.5 1.5 0 0 1 .4-1.3c-2.4-.7-1.6-1.3-2-1.6zm-1.2.2a18.8 18.8 0 0 1-1.8 2.6c-.4.3-.8.5-1.3.5.4.8.5 1.2 1.8 1.4-3 2-3.2 5.4-1 8.3.2-.5.5-1 .9-1.4a4 4 0 0 0 .8 2.5c.3.3.5 1.8.8 2.3l1 1s.3-1.3.9-1.5l2-.6a7.4 7.4 0 0 0 2-1.7l-.3 1.8c3.9-1.3 4.8-4 3.7-7.5 1 .6 2-.2 2.3-.2a2.5 2.5 0 0 1-.8-1.2 7.4 7.4 0 0 1-.3-1.8v-1.1l-.6 1.6a8 8 0 0 0 0 1.7 5.2 5.2 0 0 1-1.8-.8c.4 1.2.6 2.4.8 3.7 0 .8-.2 1.7-.5 2.5a6.6 6.6 0 0 1-1.6 1.7l.3-2.3-.3-2.8a15.7 15.7 0 0 1-.8 2.7l-1.2 2c.1-2 0-2.2-.2-2.9 0 0-.5 2.5-1.3 3.6a7.5 7.5 0 0 1-1.6.7 1.7 1.7 0 0 0-.7.6l-.6-1.7a19.8 19.8 0 0 1-1.2-2.2c-.3-1.2 1.2-3.6 1.2-3.6-.6 0-1.1.7-1.7 1.4a17.4 17.4 0 0 0-1.3 1.6 15.2 15.2 0 0 1-.5-2.2c0-.8.3-1.5.7-2.1.6-1 3.3-3 3.3-3a4.2 4.2 0 0 1-2.8 0l1.2-1.7a4.2 4.2 0 0 0 .5-1.9m5 1.1h-1.2v.5l.5.3.8 1 1.6-.5.3-.4a6.2 6.2 0 0 0-1.5-.8 2.4 2.4 0 0 0-.4 0z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "none",
      stroke: "#806600",
      strokeMiterlimit: 128.6,
      strokeWidth: 0.2,
      d: "M307 118.8c1 .6 2-.2 2.3-.2a2.5 2.5 0 0 1-.8-1.2 6.8 6.8 0 0 1-.3-1.8c0-1.6.5-1.8.6-1.6a7 7 0 0 0 1.4-.8c.4-.3.7-.8.8-1.3a4.8 4.8 0 0 0-.2-1.9c-1.5 0-1.8.2-2.2.6a6.9 6.9 0 0 0-.3-1.5 4.6 4.6 0 0 0-.5-1.2 2 2 0 0 0-.6-.5c0 .4-.3.8-.6 1a3.8 3.8 0 0 0-1.6-3c-1.3 0-2.1.7-3 1.7a2.2 2.2 0 0 1 0-1.2 2 2 0 0 0-.6.2 4.6 4.6 0 0 0-1 .7 6.9 6.9 0 0 0-1.1 1.1c0-.6-.3-1-1.6-1.7a4.8 4.8 0 0 0-1.1 1.6 2.4 2.4 0 0 0-.1 1.4 7 7 0 0 0 .8 1.4c.1 0 .5.4-.4 1.7a6.8 6.8 0 0 1-1.2 1.4c-.4.3-.8.5-1.3.5.4.8.5 1.2 1.8 1.4-3 2-3.2 5.4-1 8.3.2-.5.5-1 .9-1.4a4 4 0 0 0 .8 2.5c.3.3.5 1.8.8 2.3l1 1s.3-1.3.9-1.5l2-.6a7.4 7.4 0 0 0 2-1.7l-.3 1.8c3.8-1.3 4.8-4 3.7-7.5z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "#806600",
      d: "M297.7 107.2a3.1 3.1 0 0 0-.5 1.6 6 6 0 0 0 .9 1.6l.5-2.2c-.1-.4-.8-1-.8-1zm2 2a.8.8 0 0 0-.3.2c-.2.1-.4.1-.4.4l.7-.2a.3.3 0 0 1 .2 0l1.2.6h1.9l-.3.8-.9.4-.4.4-.2.4v.6h.2a1 1 0 0 1 .8.9l.2.2a.5.5 0 0 0 .2.1h.4a1 1 0 0 1 1.2-.3h.1l.1-.1a1.3 1.3 0 0 0 .3-.6v-.4a7.2 7.2 0 0 0-.2-.4c0-.4-.3-1-.3-1l.1-.8a4.7 4.7 0 0 0 1.5 1.1l1.3.1c.2 0 .3 0 .3.2l.4.5a.8.8 0 0 0-.1-.8l-.5-.2-1.3-.1a3.8 3.8 0 0 1-1.4-1l-.2-.2-.1.2a2 2 0 0 0-.4 1.2l.4 1a5.8 5.8 0 0 1 .2.7 1 1 0 0 1-.2.3 2.2 2.2 0 0 0-1.5.4h-.1a2.5 2.5 0 0 0-1.2-1.3v-.3l.2-.1c0-.2.2-.3.3-.3.3-.3.8-.5.9-.8.2-.3.4-.6.4-1v-.3h-.3a3.4 3.4 0 0 1-1.6.1c-.4 0-.8-.4-1.2-.5a.8.8 0 0 0-.3 0zm-.9 1.4a1.5 1.5 0 0 0-.2 1.6c.2.4.6.7 1 .8v.1c-.2.3-.2.6-.2.8 0 .6.4 1 .8 1.3.3.3.8.5 1.2.4a1.7 1.7 0 0 0 .8-.2l.5.6c.4.2.8.4 1.3.3a1.8 1.8 0 0 0 1.6-1.4v-.2a1.5 1.5 0 0 0 1.4-.1 1.6 1.6 0 0 0 .6-1.5c-.3.3 0 .8-.8 1.3-.4.2-.8.2-1.1 0l-.4-.3v.9l-.3.5a1.6 1.6 0 0 1-1 .6 1.4 1.4 0 0 1-1-.3 1.8 1.8 0 0 1-.4-.7l-.2-.5-.2.3-.4.2-.5.2c-.3 0-.7 0-.8-.3a2 2 0 0 1-.7-1.2v-.5c0-.2.1-.3.3-.4l.1-.3h-.4a1.4 1.4 0 0 1-1-.5c-.5-.7 0-1 0-1.5m11.4.2s-1 0-1.2.4a8.3 8.3 0 0 0-.8 2 6 6 0 0 0 1.6-.7c.3-.6.4-1.1.4-1.6z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "#2b2200",
      d: "M300.8 110a.5.5 0 0 0-.2 1.1.5.5 0 1 0 .1-1zm5.1 1.6a.5.5 0 0 0-.1 1 .5.5 0 1 0 .1-1"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "#377bc8",
      stroke: "#2c5aa0",
      strokeMiterlimit: 128.6,
      strokeWidth: 0.2,
      d: "M281 127.6c-.5.2-1.2-.2-2.5 1a2.4 2.4 0 0 1 2.2.8 1 1 0 0 0 .8-.5 1 1 0 0 0-.5-1.3zm32.3 1.5c-.5.2-1.1-.2-2.5 1a2.4 2.4 0 0 1 2.2.9c.4 0 .8-.3.8-.6a1 1 0 0 0-.5-1.3zm-34.7 1.8c-.4.3-1.2.2-2 1.8a2.4 2.4 0 0 1 2.4 0c.4-.1.6-.5.6-.8a1 1 0 0 0-1-1zm35.2 2.5c-.3.4-1 .4-1.8 2a2.4 2.4 0 0 1 2.4-.2 1 1 0 0 0 .6-.8 1 1 0 0 0-1.2-1zm-32.8 1.4a1.2 1.2 0 0 0-.5.2c-.2.4-.9.8-.8 2.5a2.4 2.4 0 0 1 2-1.2 1 1 0 0 0 .1-1 1 1 0 0 0-.8-.5zm70.2.2h-.4c-.2.6-1 .8-1 2.6a2.4 2.4 0 0 1 2.1-1c.3-.3.3-.7.3-1a1 1 0 0 0-1-.6zm-33.4 1.2a1.2 1.2 0 0 0-.6.3c0 .5-.8.8-.5 2.6a2.4 2.4 0 0 1 2-1.4 1 1 0 0 0 0-1 1 1 0 0 0-.9-.5zm41.6.2a1 1 0 0 0-1 .6c.2.4-.2 1 .9 2.5a2.4 2.4 0 0 1 1-2.1.9.9 0 0 0-.5-1 1.2 1.2 0 0 0-.4 0zm-4.4.5a1.1 1.1 0 0 0-.8.4c0 .5-.6 1 .1 2.6a2.4 2.4 0 0 1 1.6-1.7c.1-.4 0-.8-.2-1a1 1 0 0 0-.8-.3z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "gold",
      stroke: "#806600",
      strokeMiterlimit: 103.2,
      strokeWidth: 0.2,
      d: "M303.1 158.7a5 5 0 0 1-1.7-.3 4.6 4.6 0 0 1-1.2-1.4h-2a5.4 5.4 0 0 1-1.6-.8 3.1 3.1 0 0 0 1.6-.8 8.2 8.2 0 0 1-1.9-.3 9 9 0 0 1-1.6-1c.6-.2 1.2-.1 1.6-.7a7 7 0 0 1-1.7-.2 6.4 6.4 0 0 1-1.5-1 2.3 2.3 0 0 0 1.8-.7 6.3 6.3 0 0 1-1.8-.1 9 9 0 0 1-1.7-1.2 4 4 0 0 0 1.8-.5l-.4-.8c-.4-1-1.4-.7-2-.9a1.8 1.8 0 0 1-1.1-1.4c0-.7.3-1.7 1.8-1.6-.8-1 0-2 .9-2.4.8-.2 1.5-.1 2 1.2a4.2 4.2 0 0 1 1.2-.7 1.1 1.1 0 0 1 1.4.6v.9c-.3.4-.8.7-.8 1.3a3.7 3.7 0 0 0 .4 1.9s3 2.4 4.4 3.7c.8.7 2 2.2 2 2.2h3l.3 5z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "#377bc8",
      stroke: "#2c5aa0",
      strokeMiterlimit: 103.2,
      strokeWidth: 0.2,
      d: "M294.8 142c.5.6.7 1.3.5 2a.8.8 0 0 0 .8.2.8.8 0 0 0 .5-1c-.4-.2-.4-.8-1.8-1.1zm-3.4.5a3.5 3.5 0 0 0-.8 0 2 2 0 0 1 1.2 1.6.8.8 0 0 0 .8-.1.8.8 0 0 0 0-1.1c-.3 0-.5-.4-1.2-.4zm-1 3.2a3 3 0 0 0-2 .6 2 2 0 0 1 1.7.8c.2 0 .5 0 .6-.4a.8.8 0 0 0-.3-1z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "gold",
      stroke: "#806600",
      strokeMiterlimit: 103.2,
      strokeWidth: 0.2,
      d: "M318 161c-.6-.1-1.3-.8-1.8-.8a1.6 1.6 0 0 0-1.3.8 1.4 1.4 0 0 0 .3 1.2l1 .6a3.4 3.4 0 0 0-.7 1.2c0 .3.1.6.4.9.3.4.4.5.9.6l1.1-.1c0 .3 0 .6.2.8a1.8 1.8 0 0 0 1.6.8c.3.1.7 0 .9-.4.2-.3.1-1 .5-1.4l1.4-1.3c.6.4.6.9.5 1.5a5.3 5.3 0 0 0 1.2-1c.2-.4.4-.9.4-1.4.5.4.8 1 .6 1.6a6 6 0 0 0 1.2-1 6 6 0 0 0 .6-1.4c.4.4.6 1 .4 1.6a4.8 4.8 0 0 0 1.3-1.2l.3-1.2c1.3 0 2.1-.4 2.1-1 .1-.5-.4-1-1.4-1.2a5.4 5.4 0 0 1-.5-1 1.4 1.4 0 0 1 0-.8 3.7 3.7 0 0 1 1.2-1.5 14 14 0 0 1 2.2-1.3l-.5-2.1-5-.8-5.7 1.4c1 .4 3.4 2 3.2 2.7 0 .2-.5.4-.8.8-.2.1 0 .4.1.8.3.2.8.3 1 .6a.6.6 0 0 1 0 .8c-.3.5-1.6.7-2.3 1-1 .4-3 1.6-3 1.6a4.2 4.2 0 0 1-1.7-.4z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "gold",
      stroke: "#806600",
      strokeMiterlimit: 103.2,
      strokeWidth: 0.2,
      d: "M328 154.2s0 1.9-.7 2.3c-.4.2-.8.3-1.2.1a1.4 1.4 0 0 1-.7-.8l-.2-.8a7.2 7.2 0 0 0-1.8-.5c-1 0-1.8.1-2.7.5a6.2 6.2 0 0 1 2-2.5l3-.3 2.4 2z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "gold",
      d: "M333.8 142.2c.8 0 2.2-.4 2.7-1l.8-1a4 4 0 0 1-2.3 3.6 7.3 7.3 0 0 1-4 .5 15.1 15.1 0 0 1-2.4-.5c1 1 .5 1.8-.6 2.4 0 0 .2-1-.2-1.2-.6-.4-1.4 0-2.1.5-.6.3-1.2.6-2 .6a5.1 5.1 0 0 1-2.2-.4c-.5-.3-1.4-1-1.7-1-.8.2-2 .3-2.4 1v1a2.5 2.5 0 0 0 1.6 1.1c1.8.5 3.6.5 5.3.2 2-.3 4.2-1 6.1-1.4 2-.4 4.3-1 5.8-1.5a18 18 0 0 1 5.6-.6c3.2 0 4.4 2 4.3 4.1-.2 2.2-2.2 3.2-3.9 3.8-3 1.1-7.2.5-9.7.4l1.3 1.2c.4.4.6 1.4 1.2 1.6.8.2 2-.3 2.8-.4a29.3 29.3 0 0 1 3.2 0 2 2 0 0 1 .8-.6h.8c.3.1.5.6.4 1.5l.6.5h1.1l1 .6a5.6 5.6 0 0 0-.9.4 2.2 2.2 0 0 0-.5.6l1.3.1.8.8a1.6 1.6 0 0 0-.8.1 4 4 0 0 0-.6.6s1-.1 1.5.2l.6.8a3.4 3.4 0 0 0-.8 0l-.5.4a3.6 3.6 0 0 1 1 .9c.2.4.3.8.3 1.3a5 5 0 0 0-.6-.5 1.6 1.6 0 0 0-.6-.1l.2 1.8c0 .4.6.8.7 1.2.2.3 0 .7-.2 1-.2.4-.8.6-1.3.4a2 2 0 0 1-.7-.4l-.4.8c-.4.2-.5.2-1 .2a1 1 0 0 1-.7-.4 3.7 3.7 0 0 1-.5-1.2l-1 .3c-.4 0-.8-.3-1-.6a1.4 1.4 0 0 1 .2-1.3c.3-.4 1-.4 1.5-.6a4 4 0 0 0 1-1 25.3 25.3 0 0 1-2.5-2.4l-1-1.6s-2 .8-2.9.8a13.6 13.6 0 0 1-4 0c-3.1 0-5.1-5-7.8-6.2a2.6 2.6 0 0 0-2.1 0c-3.2.7-6.6 5.1-9.6 6a24 24 0 0 1-4 .6 4.3 4.3 0 0 1-.9 1.3 3.8 3.8 0 0 1-1.6.3 7.2 7.2 0 0 1-.6 1.8 4.4 4.4 0 0 1-1.3 1 3 3 0 0 0 0-1.7 7 7 0 0 1-1 1.4 7.2 7.2 0 0 1-1.3 1 2.4 2.4 0 0 0 0-1.6 6.2 6.2 0 0 1-.8 1.3 5.2 5.2 0 0 1-1.3.8 2.2 2.2 0 0 0 0-1.7 5.5 5.5 0 0 1-.7 1.3 7.2 7.2 0 0 1-1.6 1 3.4 3.4 0 0 0 .2-1.8h-.8c-1 0-1 1-1.4 1.5a1.5 1.5 0 0 1-1.5.3c-.6-.2-1-1.1-.4-2.3a1.6 1.6 0 0 1-1.9-1.6c0-.8.3-1.5 1.5-1.5a3.7 3.7 0 0 1 0-1c0-.6.4-1 .8-.9.4 0 .6.2.8.4.3.3.4.8.8 1.2a3.2 3.2 0 0 0 1.7.4 29.4 29.4 0 0 1 4-2.1 31 31 0 0 1 3.1-.8v-7c.7 0 1.4.2 2 0 2.1.2 4.2.5 6.2.9l3.2-.3s5.4-1 7.8-1.2c1.3-.3 2.6-.3 3.9-.3 1.9.2 3.6.8 5.4.8 1.4.3 2.7.3 4 .3 2.3-.2 6.2 0 7.4-2.4a2 2 0 0 0-2.3-2.6c-.4.2-1 .5-1 1 0 .3 0 .6.2.8.1.3.4.5.7.8a2 2 0 0 1-1.4-.4 5.2 5.2 0 0 1-.9-1.6 1.8 1.8 0 0 0-.3 1.2c0 .4.1.8.4 1.2a2.4 2.4 0 0 1-1.5-.7 5.8 5.8 0 0 1-.6-1.6c-.2.3-.4.7-.4 1.1 0 .5.1 1 .3 1.4a3 3 0 0 1-1.4-1 5.7 5.7 0 0 1-.5-1.6l-5.6 1.3-6 1.3c-3 .4-5.3.2-7.2-.7a2.6 2.6 0 0 1-1.6-2 2.7 2.7 0 0 1 .5-2.1 6 6 0 0 1 3.2-2 40.7 40.7 0 0 1 5.5-1.2 17.6 17.6 0 0 1 6 .3c.8.3 1.5 0 2-.4a1 1 0 0 0 .2-1.4c.5 0 .9.5 1 1a2.5 2.5 0 0 1 0 1.1"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "gold",
      d: "M337.4 140.2a9.2 9.2 0 0 1-1.6 2.1 6.8 6.8 0 0 1-3 1.1 10.7 10.7 0 0 1-3-.2 13.3 13.3 0 0 1-2.8-.9 5.6 5.6 0 0 1 .8 1.8 3.8 3.8 0 0 0-1.6-.1l-1.6.8c-.8.2-1.8 0-2.4-.2-.8-.1-1-.4-1.7-.3l-.7.3 2.1 1.2 2 .3 1.3-.3 1.4-.8 1.2-.1.3.5v.8l.8-.8.1-.5-.2-1 1.6.3 1.8.2 2-.4 1.8-.8.9-1.1zm5.2 5.4a2.6 2.6 0 0 0-1.3.5 2.2 2.2 0 0 0-.6 1.7 16.4 16.4 0 0 1-.8-2.1c-.8.8-.8 1.8-1 2.7a15.4 15.4 0 0 1-.8-2.5 4.8 4.8 0 0 0-1.4 2.3 4.8 4.8 0 0 1-.5-2h-.2c-2.6.4-8.2 2.3-12.6 2.7-2.4.2-5.2 0-6.7-1a3 3 0 0 1-1.3-2l-.2 1 .8 1.3 1.6 1 3 .7 3.4-.4 2-.1 10-2.4v1.3l.8.8.8.5-.2-1.1v-.8l.4-.5.5 1.4.7.6 1 .2-.5-.7v-.9l.3-.8.5 1.3.5.5h1.3l-.8-.7-.2-.8.6-.7 1.1-.3 1 .4.6.7.2 1-.1.8c1.7-1.6 0-3.6-2-3.6zm3.4 1.6a4.5 4.5 0 0 1-1.1 2.8c-3 3.3-9.8 2.2-13 1.1l-1.4-.2a15.5 15.5 0 0 0-.8-.3 8 8 0 0 0-2-.3 21.2 21.2 0 0 0-3.9.3c-2.4.2-7.8 1.2-7.8 1.2l-3.2.3a45.6 45.6 0 0 0-6.2-.8 9.5 9.5 0 0 1-2 0v1.1l2.8.6h-.4l-1.9 3.6-.4-1.6-.1 2.5-.4.7-2.4.6-2.4 1-1.8 1.4-1.8-.5-.8-1.3c.1.7.4 1.3.7 2 .5.5 2 .6 2 .6a30 30 0 0 1 3.3-2l1.6-.6a4.4 4.4 0 0 0 1.6 1.2c0-1.6 1-1.6 2.4-2.4v1s2.7-1 3.4-1.8a4.9 4.9 0 0 0 1.1-1.9 5 5 0 0 0 .1-2.1 62.6 62.6 0 0 0 1.8 0c2.7-.1 5.6-1.3 8.2-1.6 2-.4 4.5-.8 6.4-.4 1.6.3 2.2 1 3.6 2 1.2.8 2.4 3.2 4 3.2 0 0 .9 0 1.4-.2.8 0 1.3-.4 2-.5a12.2 12.2 0 0 1 2.4.2c.7-1 1-1 1.2-.8.4.2.4.8.1 1.3a2.2 2.2 0 0 0 1.9.8c-.4.4-.8.8-1 1.3a2.6 2.6 0 0 1 1.7.3 3.3 3.3 0 0 0-.8 1.2 5 5 0 0 1 1.6.3c-.4.2-.8.4-.8.8l1.3 1c-.6 0-.8 0-1 .3l.9 1.7-.2-1.6.6.2c.2 0 .5.2.6.5a3.4 3.4 0 0 0-.2-1.3 3.6 3.6 0 0 0-1-.9l.4-.3h.8a6.4 6.4 0 0 0-.6-.9c-.4-.3-1.5-.2-1.5-.2a4 4 0 0 1 .6-.6 1.6 1.6 0 0 1 .8 0 2.6 2.6 0 0 0-.8-.9 4.2 4.2 0 0 0-1.3-.1l.5-.6a5.6 5.6 0 0 1 .9-.4 5.8 5.8 0 0 0-1-.6h-1.1a1.2 1.2 0 0 1-.6-.5c.1-.8-.1-1.3-.4-1.5a1.3 1.3 0 0 0-.8 0c-.4.1-.7.4-.8.7a29.3 29.3 0 0 0-3.2 0c-.8 0-2 .5-2.8.3-.6-.2-.8-1.2-1.2-1.6l-1.3-1.2h2.9l3 .2h1.8c2.2-.6 4.7-1.2 5.7-3.8v-2zm-22.4 5.1a6 6 0 0 0-2.4.5 29.8 29.8 0 0 0-5.1 3.5 25 25 0 0 1-3.2 2 18.4 18.4 0 0 1-4.6.6s-.4 1.6-1 1.9c-.4.3-1.5-.3-1.5-.3l-.1 1.3a5.8 5.8 0 0 1-.5 1.4 4.5 4.5 0 0 0-.3-1 5.2 5.2 0 0 0-.8-1 9.4 9.4 0 0 1-.4 1.4l-.9 1.4a5.2 5.2 0 0 0-.2-.8 8.3 8.3 0 0 0-.8-1.2 13.4 13.4 0 0 1-.4 1.4l-.5 1a4.8 4.8 0 0 0-.2-.5 11.8 11.8 0 0 0-.8-1.2l-.7 1.5-.6.8a2.6 2.6 0 0 0-.2-1.2 1.2 1.2 0 0 0-1-.3c-1 .2-1.5 1.2-2.1 2.1-.2.2-.5.3-.4 0a.8.8 0 0 0 0-.7.6.6 0 0 0-.7-.3c-.4.3.8-1.2.8-1.2a8.6 8.6 0 0 1-1.6-.1c-.4-.1.1 0 .1-.8 0-.9-.8-.8-.5-.8a2.3 2.3 0 0 1 1.3.1s-.4-.4-.2-.8c0-.1.5-.4.6-.8a1.1 1.1 0 0 0-.5-1c-.1.4-.8.2-.8.7v1.1c-1.2 0-1.5.7-1.5 1.5a1.6 1.6 0 0 0 2 1.6c-.9 1.2-.3 2 .3 2.3a1.5 1.5 0 0 0 1.5-.3c.5-.5.5-1.5 1.4-1.5h.8a4 4 0 0 1-.2 1.9 7.2 7.2 0 0 0 1.6-1l.8-1.4a2.2 2.2 0 0 1 0 1.7 5.2 5.2 0 0 0 1.2-.8 6.2 6.2 0 0 0 .8-1.4 2.4 2.4 0 0 1 0 1.7 7.2 7.2 0 0 0 1.3-1 7 7 0 0 0 1-1.4 3 3 0 0 1 0 1.7 4.4 4.4 0 0 0 1.3-1 7.2 7.2 0 0 0 .6-1.7c.6 0 1-.1 1.6-.4a4.3 4.3 0 0 0 .8-1.3 24 24 0 0 0 4-.5c3.2-1 6.5-5.4 9.7-6.2a2.6 2.6 0 0 1 2 0c2.8 1.3 4.9 6.4 7.8 6.4 1.4 0 2.1.3 4 0l3-.9 1 1.6a25.3 25.3 0 0 0 2.4 2.4 3.5 3.5 0 0 1-1 1c-.3.2-1.1.2-1.4.6a1.4 1.4 0 0 0-.1 1.3c.2.3.5.5 1 .6l.9-.3a3.7 3.7 0 0 0 .4 1.2c.2.3.6.4.8.5.4 0 .8 0 1-.4l.4-.8c.2.3.4.4.7.5a1.3 1.3 0 0 0 1.3-.5c.3-.3 0-1.3-.1-1.7a7.8 7.8 0 0 0 0 1.2.8.8 0 0 0-1.5 0 1.4 1.4 0 0 1-.7-.8l-.2 1c-.1.2 0 .6-.3.6 0-1-.7-1-1.2-.8a2 2 0 0 1 0-1 7.2 7.2 0 0 1-1 .5c-.3 0 0-.2-.2-.5 0-.3-.6-.2-.4-.3l1.5-.8a5 5 0 0 0 1-1.4 25.6 25.6 0 0 1-2.5-2.4l-1.5-2.4a26.2 26.2 0 0 1-4.8 1 7.4 7.4 0 0 1-3.4-.4c-1.8-.9-2.8-3.1-4.3-4.3-1-.8-1.9-1.7-3-1.9a2.9 2.9 0 0 0-.4 0"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "none",
      stroke: "#806600",
      strokeMiterlimit: 103.2,
      strokeWidth: 0.2,
      d: "M333.8 142.2c.8 0 2.2-.4 2.7-1l.8-1a4 4 0 0 1-2.3 3.6 7.3 7.3 0 0 1-4 .5 15.1 15.1 0 0 1-2.4-.5c1 1 .5 1.8-.6 2.4 0 0 .2-1-.2-1.2-.6-.4-1.4 0-2.1.5-.6.3-1.2.6-2 .6a5.1 5.1 0 0 1-2.2-.4c-.5-.3-1.4-1-1.7-1-.8.2-2 .3-2.4 1v1a2.5 2.5 0 0 0 1.6 1.1c1.8.5 3.6.5 5.3.2 2-.3 4.2-1 6.1-1.4 2-.4 4.3-1 5.8-1.5a18 18 0 0 1 5.6-.6c3.2 0 4.4 2 4.3 4.1-.2 2.2-2.2 3.2-3.9 3.8-3 1.1-7.2.5-9.7.4l1.3 1.2c.4.4.6 1.4 1.2 1.6.8.2 2-.3 2.8-.4a29.3 29.3 0 0 1 3.2 0 2 2 0 0 1 .8-.6h.8c.3.1.5.6.4 1.5l.6.5h1.1l1 .6a5.6 5.6 0 0 0-.9.4 2.2 2.2 0 0 0-.5.6l1.3.1.8.8a1.6 1.6 0 0 0-.8.1 4 4 0 0 0-.6.6s1-.1 1.5.2l.6.8a3.4 3.4 0 0 0-.8 0l-.5.4 1 .9c.2.4.3.8.3 1.3a5 5 0 0 0-.6-.5 1.6 1.6 0 0 0-.6-.1l.2 1.8c0 .4.6.8.7 1.2.2.3 0 .7-.2 1-.2.4-.8.6-1.3.4a2 2 0 0 1-.7-.4l-.4.8a1 1 0 0 1-1 .3 1.2 1.2 0 0 1-.7-.5 3.7 3.7 0 0 1-.5-1.2l-1 .3c-.4 0-.8-.3-1-.6a1.4 1.4 0 0 1 .2-1.3c.3-.4 1-.4 1.5-.6a4 4 0 0 0 1-1 25.3 25.3 0 0 1-2.5-2.4l-1-1.6s-2 .8-2.9.8a13.6 13.6 0 0 1-4 0c-3.1 0-5.1-5-7.8-6.2a2.6 2.6 0 0 0-2.1 0c-3.2.7-6.6 5.1-9.6 6a24 24 0 0 1-4 .6 4.3 4.3 0 0 1-.9 1.3 3.8 3.8 0 0 1-1.6.3 7.2 7.2 0 0 1-.6 1.8 4.4 4.4 0 0 1-1.3 1 3 3 0 0 0 0-1.7 7 7 0 0 1-1 1.4 7.2 7.2 0 0 1-1.3 1 2.4 2.4 0 0 0 0-1.6 6.2 6.2 0 0 1-.8 1.3 5.2 5.2 0 0 1-1.3.8 2.2 2.2 0 0 0 0-1.7 5.5 5.5 0 0 1-.7 1.3 7.2 7.2 0 0 1-1.6 1 3.4 3.4 0 0 0 .2-1.8h-.8c-1 0-1 1-1.4 1.5a1.5 1.5 0 0 1-1.5.3c-.6-.2-1-1.1-.4-2.3a1.6 1.6 0 0 1-1.9-1.6c0-.8.3-1.5 1.5-1.5a3.7 3.7 0 0 1 0-1c0-.6.4-1 .8-.9.4 0 .6.2.8.4.3.3.4.8.8 1.2a3.2 3.2 0 0 0 1.7.4 29.4 29.4 0 0 1 4-2.1 31 31 0 0 1 3.1-.8v-7c.7 0 1.4.2 2 0 2.1.2 4.2.5 6.2.9l3.2-.3s5.4-1 7.8-1.2c1.3-.3 2.6-.3 3.9-.3 1.9.2 3.6.8 5.4.8 1.4.3 2.7.3 4 .3 2.3-.2 6.2 0 7.4-2.4a2 2 0 0 0-2.3-2.6c-.4.2-1 .5-1 1 0 .3 0 .5.2.8l.7.8a2.7 2.7 0 0 1-1.6-.4 3.8 3.8 0 0 1-.7-1.6 1.8 1.8 0 0 0-.3 1.2c0 .4.1.8.4 1.2a2.4 2.4 0 0 1-1.5-.7 5.8 5.8 0 0 1-.6-1.6c-.2.3-.4.7-.4 1.1 0 .5.1 1 .3 1.4a3 3 0 0 1-1.4-1 5.7 5.7 0 0 1-.5-1.6l-5.6 1.3-6 1.3c-3 .4-5.3.2-7.2-.7a2.6 2.6 0 0 1-1.6-2 2.7 2.7 0 0 1 .5-2.1 6 6 0 0 1 3.2-2 40.7 40.7 0 0 1 5.5-1.2 17.6 17.6 0 0 1 6 .3c.8.3 1.5 0 2-.4a1 1 0 0 0 .2-1.4c.5 0 .9.5 1 1 .2.3.1.7 0 1.1z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "gold",
      d: "M310.2 152.2c.8.4 1.6-.2 1.8-.3a2 2 0 0 1-.6-.8 5.4 5.4 0 0 1-.3-1.6c0-1.2.5-1.3.5-1.3a5.6 5.6 0 0 0 1.1-.5c.3-.3.6-.7.7-1.1a3.8 3.8 0 0 0-.2-1.5c-1.2 0-1.5 0-1.8.4a5.5 5.5 0 0 0-.2-1.2 3.7 3.7 0 0 0-.5-1 1.6 1.6 0 0 0-.4-.3c0 .3-.2.6-.4.8a5 5 0 0 0-.5-1.6 1.4 1.4 0 0 0-2-.7 5 5 0 0 0-1.2 1.2 1.8 1.8 0 0 1 0-1 1.6 1.6 0 0 0-.5.2 3.7 3.7 0 0 0-.9.6 5.6 5.6 0 0 0-.8.9c0-.5-.2-.8-1.3-1.4a4 4 0 0 0-.9 1.2 1.8 1.8 0 0 0-.1 1.2l.7 1.1s.4.4-.3 1.5a5.4 5.4 0 0 1-1 1 2 2 0 0 1-1 .4c.2.8.3 1 1.3 1.2-2.4 1.6-2.5 4.3-.8 6.6l.8-1.2c0 .8.3 1.5.7 2 .2.3.3 1.6.6 2l.7.7s.4-1 .8-1.1l1.6-.5a6 6 0 0 0 1.6-1.5l-.2 1.6c3.1-1.2 3.8-3.2 3-6"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "#504416",
      d: "M304.2 148.3a6.2 6.2 0 0 1-.6 3.1l2 .8 2 .3c-.2-.8.6-2.4 1-3h-1.5l-.6-.6-1.1.3-1.2-.8z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "#fff",
      d: "M304.6 148.8a2.4 2.4 0 0 0 0 1.5l.5-1.2zm2.8 1-.1 1.3c.3-.4.6-.8.7-1.3zm-2.8 1a2.4 2.4 0 0 0-.8 1.2h.6l.2-1.3zm2.5.6-.6 1.2.5.3a2.4 2.4 0 0 0 0-1.5zm-2.3-6.6c-.4 0-.6 0-.7.4-.1.4.1.8.8 1a1 1 0 0 0 1.2-.5c.1-.4-.3-.7-.8-.8a2 2 0 0 0-.5-.1m4.2 1.2c-.4 0-.6 0-.7.3a1 1 0 0 0 .8 1.1c.7.2 1.1 0 1.2-.4.2-.4-.1-.8-.8-1a2.6 2.6 0 0 0-.5 0"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "#d1b948",
      d: "M304.8 144.8a1.1 1.1 0 0 0-.3 0 .6.6 0 0 0-.5.5.8.8 0 0 0 .2.6c.1.3.4.4.6.5a1.1 1.1 0 0 0 1.4-.6.6.6 0 0 0-.2-.6 2.2 2.2 0 0 0-.8-.4 2 2 0 0 0-.4 0m0 .2h.4l.6.4c.2 0 .3.1.2.3-.2.5-.7.6-1.1.5a1 1 0 0 1-.6-.4.6.6 0 0 1-.1-.5.4.4 0 0 1 .3-.3zm4.2 1h-.2a.6.6 0 0 0-.6.3 1.1 1.1 0 0 0 1 1.3h.7a.8.8 0 0 0 .5-.6.6.6 0 0 0-.2-.5 1.5 1.5 0 0 0-.6-.4 2.6 2.6 0 0 0-.6-.2zm0 .2h.5c.3 0 .4.2.7.4a.4.4 0 0 1 0 .4.6.6 0 0 1-.4.4h-.6a1 1 0 0 1-.8-1c0-.2.2-.2.4-.2z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "gold",
      d: "M304.8 144a1 1 0 0 0-.8.2v.4h.3l.5.2 1 .5 1.2-.1-1-.5c-.4-.1-.7-.7-1.2-.8zm5.4 1.5H308l1 .6 1 .1.6.2.3.2.1-.4a1 1 0 0 0-.8-.7m-6.5 6c-1 2.6 3.1 4 3.7 1a8.4 8.4 0 0 1-3.7-1"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "#806600",
      d: "M303.6 151.2v.2a2 2 0 0 0 0 1.8 2.2 2.2 0 0 0 4-.6v-.3h-.2a8.2 8.2 0 0 1-3.6-1zm.2.3a10.6 10.6 0 0 0 3.6 1 2.5 2.5 0 0 1-.8 1.4 2.6 2.6 0 0 1-1.6.1 2.7 2.7 0 0 1-1.3-1 2 2 0 0 1 0-1.5z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "#377bc8",
      stroke: "#2c5aa0",
      strokeMiterlimit: 103.2,
      strokeWidth: 0.2,
      d: "M305.4 149.2a11.6 11.6 0 0 0-.6 5.4 11.5 11.5 0 0 0 2.4-5l-.5-.2a5.2 5.2 0 0 1-.2-.4l-.6.2z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "gold",
      d: "m308.6 141.4-1.2.1a5 5 0 0 0-1.2 1.2 1.8 1.8 0 0 1 0-1 1.6 1.6 0 0 0-.5.2 3.7 3.7 0 0 0-1 .6 5.6 5.6 0 0 0-.8.8c.4 0 1.3-.8 1.6-.7.3 0 .1.8.4.8.3.1.7-.4 1.2-.8.4-.4 1-.7 1.2-.6.4.2.7.6.8 1.1.2.7.3 1.4.6 1.5.3.1.5-.7.8-.5.4 0 .5 1.3.9 1.4a5.5 5.5 0 0 0-.2-1.2 3.7 3.7 0 0 0-.5-1 1.6 1.6 0 0 0-.4-.3c0 .3-.3.6-.5.8a5 5 0 0 0-.4-1.6 4.7 4.7 0 0 0-.8-.8m-5 4.4c-.5.7 0 1.3.9 1.6l-.3.8.4 1 1 .2.8-.3.6.8.8.2 1-.7.4-.7h.6l.5-.2.3-.7a1.8 1.8 0 0 1-2.1.3 1.6 1.6 0 0 1-.3 1 .8.8 0 0 1-.8.2 1.8 1.8 0 0 1-.8-.7c-.4.2-.8.4-1 .3a1.1 1.1 0 0 1-.8-.8 1.2 1.2 0 0 1 .3-1c-1.8-.5-1.2-1.1-1.6-1.3zm-1 .2a15.1 15.1 0 0 1-1.6 2 2 2 0 0 1-1 .4c.3.8.4 1 1.4 1.2-2.4 1.6-2.5 4.3-.8 6.6l.8-1.2c0 .8.3 1.5.7 2 .2.3.3 1.6.6 2l.7.7s.4-1 .8-1.1l1.6-.5a6 6 0 0 0 1.6-1.5l-.2 1.6c3.1-1.2 3.8-3.2 3-6 .8.4 1.6-.2 1.8-.3a2 2 0 0 1-.6-.8 6 6 0 0 1-.3-1.6v-.8l-.5 1.3a6.4 6.4 0 0 0 0 1.3 4.2 4.2 0 0 1-1.4-.7l.6 3c0 .7-.1 1.4-.4 2a5.3 5.3 0 0 1-1.2 1.4l.2-1.8-.3-2.3a12.6 12.6 0 0 1-.7 2.2l-1 1.6c.2-1.6.2-1.7 0-2.4a9 9 0 0 1-1.1 2.9 6 6 0 0 1-1.2.6 1.4 1.4 0 0 0-.6.5l-.5-1.4a16 16 0 0 1-1-1.8c-.2-.9 1-2.8 1-2.8-.4 0-.8.5-1.3 1.1l-1.1 1.3a12.2 12.2 0 0 1-.4-1.8 3.4 3.4 0 0 1 .5-1.6 16.5 16.5 0 0 1 2.7-2.6 3.4 3.4 0 0 1-2.3.1l1-1.3c.3-.5.5-1 .5-1.6zm4 .8h-1v.5l.4.1.6.8 1.4-.4.2-.3a5 5 0 0 0-1.2-.6 2 2 0 0 0-.4 0z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "none",
      stroke: "#806600",
      strokeMiterlimit: 103.2,
      strokeWidth: 0.2,
      d: "M310.2 152.2c.8.4 1.6-.2 1.8-.3a2 2 0 0 1-.6-.8 5.4 5.4 0 0 1-.3-1.6c0-1.2.5-1.3.5-1.3a5.6 5.6 0 0 0 1.1-.5c.3-.3.6-.7.7-1.1a3.8 3.8 0 0 0-.2-1.5c-1.2 0-1.5 0-1.8.4a5.5 5.5 0 0 0-.2-1.2 3.7 3.7 0 0 0-.5-1 1.6 1.6 0 0 0-.4-.3c0 .3-.2.6-.4.8a2 2 0 1 0-3.7-1 1.8 1.8 0 0 1 0-1 1.6 1.6 0 0 0-.5.1 3.7 3.7 0 0 0-.9.6 5.6 5.6 0 0 0-.8.9c0-.5-.2-.8-1.3-1.4a4 4 0 0 0-.9 1.2 1.8 1.8 0 0 0-.1 1.2l.7 1.1s.4.4-.3 1.5a5.4 5.4 0 0 1-1 1 2 2 0 0 1-1 .4c.2.8.3 1 1.3 1.2-2.4 1.6-2.5 4.3-.8 6.6l.8-1.2c0 .8.3 1.5.7 2 .2.3.3 1.6.6 1.9l.7.8s.4-1 .8-1.1l1.6-.6a6 6 0 0 0 1.6-1.4l-.2 1.6c3.1-1.2 3.8-3.2 3-6z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "#806600",
      d: "M302.7 142.9a2.5 2.5 0 0 0-.5 1.2 4.8 4.8 0 0 0 .8 1.3c.2-.6.4-1.2.4-1.8 0-.3-.7-.8-.7-.8zm1.6 1.6a.6.6 0 0 0-.2 0c-.2.1-.3.1-.4.5.2 0 .4-.1.5-.3a.3.3 0 0 1 .3 0l1 .5a3.8 3.8 0 0 0 1.4 0l-.2.6-.7.4-.2.3a.8.8 0 0 0-.3.3v.6h.1c.4.1.6.4.6.8h.1l.2.1h.5a.8.8 0 0 1 1-.2v-.1l.3-.4v-.3a5.8 5.8 0 0 0-.1-.4c0-.3-.4-.8-.4-.8 0-.3 0-.5.2-.7.3.4.8.7 1.2.8.3.2.7.2 1 .2h.2l.4.6a.7.7 0 0 0 0-.7l-.5-.1-1-.1a3 3 0 0 1-1.1-.8l-.2-.2-.2.2a1.6 1.6 0 0 0-.1 1l.2.7a5 5 0 0 1 .1.6.8.8 0 0 1 0 .2 1.8 1.8 0 0 0-1.3.4 2 2 0 0 0-1-1 .8.8 0 0 1 0-.3l.1-.1a6 6 0 0 1 .3-.3l.7-.5.3-.9v-.2h-1.6c-.2 0-.5-.3-.9-.3a.6.6 0 0 0-.2 0zm-.8 1a1.2 1.2 0 0 0-.1 1.3c.2.3.4.6.8.6v.2a1.6 1.6 0 0 0-.1.6c0 .4.2.8.5 1 .4.2.7.4 1 .4a1.4 1.4 0 0 0 .7-.2l.4.4c.3.3.7.4 1 .4a1.4 1.4 0 0 0 1.3-1.2v-.1c.4 0 .8 0 1.2-.2.3-.2.4-.7.4-1.1-.3.2 0 .6-.6 1h-.9l-.3-.3v.7a1.6 1.6 0 0 1-.2.4 1.4 1.4 0 0 1-1 .5l-.6-.1a1.4 1.4 0 0 1-.4-.6v-.4l-.3.2a1.6 1.6 0 0 1-.3.2h-.4a1 1 0 0 1-.7-.2 1.6 1.6 0 0 1-.6-.8l.1-.5.2-.3.1-.2h-.3a1.1 1.1 0 0 1-.8-.5c-.4-.5 0-.8 0-1.2zm9.2.2s-.8 0-1 .3a6.6 6.6 0 0 0-.6 1.7 4.8 4.8 0 0 0 1.3-.7 2.4 2.4 0 0 0 .3-1.3"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "#2b2200",
      d: "M305.1 145.1a.4.4 0 0 0 0 .8.4.4 0 1 0 0-.8m4.2 1.2a.4.4 0 0 0-.1.8.4.4 0 1 0 0-.8z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "#377bc8",
      stroke: "#2c5aa0",
      strokeMiterlimit: 103.2,
      strokeWidth: 0.2,
      d: "M293.8 159.2c-.3 0-.8-.2-1.6.8a1.4 1.4 0 0 1 1.4.6.6.6 0 0 0 .6-.4.8.8 0 0 0-.4-1zm21.4 1.2a2.8 2.8 0 0 0-2 .8 2 2 0 0 1 1.8.6.8.8 0 0 0 .7-.4.8.8 0 0 0-.5-1zm-23 1.4c-.2.3-.8.2-1.2 1.5a1.4 1.4 0 0 1 1.6 0 .8.8 0 0 0 .4-.7.7.7 0 0 0-.8-.8zm23.4 2c-.2.4-.8.3-1.4 1.6a2 2 0 0 1 1.9-.1.8.8 0 0 0 .4-.7.8.8 0 0 0-.8-.8zm-21.7 1.2a.7.7 0 0 0-.4.1 3.2 3.2 0 0 0-.5 2c.4-.7.7-.8 1.3-1a.8.8 0 0 0 .1-.7.6.6 0 0 0-.5-.4zm46.4.1a.8.8 0 0 0-.2.1 3.1 3.1 0 0 0-.7 2 1.4 1.4 0 0 1 1.4-.8c.2-.2.2-.6.2-.8a.6.6 0 0 0-.7-.5zm-21.5 1-.5.1a2.8 2.8 0 0 0-.4 2.2 2 2 0 0 1 1.6-1.1.8.8 0 0 0 0-.8.8.8 0 0 0-.7-.4zm27 .1c-.3 0-.4.1-.6.4 0 .8 0 1.6.5 2.1 0-.6.1-1.3.7-1.7a1 1 0 0 0-.3-.8.7.7 0 0 0-.3 0zm-3 .4a.7.7 0 0 0-.5.4 3.4 3.4 0 0 0 .1 2 1.8 1.8 0 0 1 1-1.4.8.8 0 0 0-.1-.8.6.6 0 0 0-.5-.2z"
    }),
    /* @__PURE__ */ jsx183("path", {
      fill: "gold",
      stroke: "#806600",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.5,
      d: "M378.7 21.3V21l.8-1.6a9 9 0 0 0-6.9 2 17.5 17.5 0 0 0-2.8 3.7 11.6 11.6 0 0 0-.8 3.2 18 18 0 0 0-1.9-1.6 2.7 2.7 0 0 0-1.3-.4 4.8 4.8 0 0 0-3.2 1.5 6 6 0 0 0-1.5 3c-.4 1.6 0 3.2-1 4.6l-1.6 1.8a8 8 0 0 0 2.7.6 4.2 4.2 0 0 0 2.8-1.5c.6-.8.9-1.9 1.8-2.5a1.4 1.4 0 0 1 1.2-.2c.5.2.6 1.2.4 1.6l-1 3.4-1.8-.4-1.4.8-.6.3h0l1.2 1.8.5.2h0a13.4 13.4 0 0 1-.4.2l-3.3 1.6-.4.2h0l-2.4.1a11.1 11.1 0 0 1-1.6-.2l-2.4-.8a7.2 7.2 0 0 1-.7-.4l-1.3-1.4a12 12 0 0 1-2.1-4.3 5.8 5.8 0 0 0 5-5.7v-.8a4.3 4.3 0 0 0-.1-.4 4.2 4.2 0 0 0-.3-1 6 6 0 0 0-.3-.6 6.7 6.7 0 0 0-.6-1 7.2 7.2 0 0 0-.4-.4 5.4 5.4 0 0 0-3.5-1.7h-1.3a5.8 5.8 0 0 0-3.2 1.6 5.6 5.6 0 0 0-1.4 2.2l-.2.8a7.4 7.4 0 0 0-.1 1.3h0a5.8 5.8 0 0 0 3.2 5.2 26.9 26.9 0 0 1-2.7 2.6 15.2 15.2 0 0 1-8.7 4 14.4 14.4 0 0 1-10.6-3 12.2 12.2 0 0 1-2.3-2.8h1.3l1.6-1.6h.1l-.5-.4-1.2-1h-.5l.4-3.8c0-.6.4-1.6 1-1.6a1.6 1.6 0 0 1 1.4.8c.8 1 .4 2.1.8 3.2a4.6 4.6 0 0 0 2.4 2.6c1.2.3 2.2.5 3.3.4l-.9-2.4c-.6-1.8.5-3.2.8-5a5.8 5.8 0 0 0-.2-3.6 5.6 5.6 0 0 0-3-2.8 3.6 3.6 0 0 0-1.6 0l-2.8.8s.8-2.4.5-3.6a15 15 0 0 0-1.6-4.8 22.6 22.6 0 0 0-3.5-3.7 22.6 22.6 0 0 0-3.5 3.7 15 15 0 0 0-1.6 4.8c-.2 1.2.5 3.6.5 3.6a23 23 0 0 0-2.8-.8 3.6 3.6 0 0 0-1.6 0 5.6 5.6 0 0 0-3 2.8 5.8 5.8 0 0 0-.2 3.6c.3 1.8 1.4 3.2.8 5l-1 2.4c1.2 0 2.2 0 3.3-.4a4.6 4.6 0 0 0 2.4-2.6c.5-1 .2-2.3 1-3.2.2-.5.7-.8 1.2-.8.7 0 1.1 1 1.1 1.6l.4 3.7h-.5l-1.6 1.6 1.6 1.5h1.3a12.2 12.2 0 0 1-2.4 2.8 14.4 14.4 0 0 1-10.6 3 15.2 15.2 0 0 1-8.6-4 27.4 27.4 0 0 1-2.6-2.6 5.8 5.8 0 0 0 3.4-5.2h0a6 6 0 0 0-1.8-4.2 5.8 5.8 0 0 0-3.3-1.6l-.3-.2h-1a5.4 5.4 0 0 0-3.4 1.8 6.6 6.6 0 0 0-1.3 2l-.3 1a4.3 4.3 0 0 0 0 .4 5.7 5.7 0 0 0 0 .8 5.8 5.8 0 0 0 4.7 5.7 12 12 0 0 1-2.1 4.3l-1.4 1.4a7.2 7.2 0 0 1-.8.4l-2.3.8a11.1 11.1 0 0 1-1.6.2l-2.3-.1h0l-.4-.1-3.4-1.7-.3-.2h0l.5-.2 1.2-1.8h0l-.6-.3-1.4-.8-1.7.4-1.1-3.3c-.2-.5-.1-1.5.4-1.7a1.4 1.4 0 0 1 1.2.2c.8.6 1.2 1.8 1.8 2.5a4.2 4.2 0 0 0 2.8 1.5 8 8 0 0 0 2.7-.6l-1.6-1.8c-1.1-1.4-.6-3-1-4.7a6 6 0 0 0-1.5-3 4.8 4.8 0 0 0-3.2-1.4 2.7 2.7 0 0 0-1.3.4 18 18 0 0 0-2 1.6 11.6 11.6 0 0 0-.7-3.2 17.5 17.5 0 0 0-2.8-3.7 8.6 8.6 0 0 0-6.8-2l.7 1.6v.3h.1l8.2 18.4-1.1.2-1.2 2 1.9 1 2.4-.6c.8 2 1.4 3.9 2 5.8l-2 .2h0c-.4.5-.6.5-.6 1h0c0 .3.1.8.4 1h0l.3.2h0l.5.3h1l.2 1.3-.1-.1v2l-1.2 2.6L274 59l.8 2.1.6-.4.1.7h-.3l.5 1h0l-.7.2c-.4.4-.5.5-.5 1h0c0 .2 0 .7.3 1h0l.8.5c3.8-.5 8-1 12.2-1.3l4-.3c7-.5 14.2-.5 21.3-.6h13.6c4.3 0 13.3 0 21.4.6a193 193 0 0 1 2.2.2l2.3.1a280.6 280.6 0 0 1 5.3.5l6.4.8h0l.3-.2.7-.7a1 1 0 0 0 0-.6h0c0-.5-.2-.6-.5-1h0l-.7-.1.2-.9h0l.2-.9.5.4.8-2 2-2.4-1.2-2.8V52h-.2l.3-1.3.9.1h0c.2 0 .3 0 .4-.2.6-.4.8-.8.8-1.3h0c0-.4-.2-.6-.6-1h0l-2.3-.2a286.4 286.4 0 0 1 2.2-5.9l2.5.7 2-1-1.2-2-1.2-.2 8.3-18.3h.1z"
    })
  ]
});
var Je_default = SvgJe;

// src/country-flag-icons/generated/Jm.tsx
init_esm_shims();
import { jsx as jsx184, jsxs as jsxs159 } from "react/jsx-runtime";
var SvgJm = (props) => /* @__PURE__ */ jsx184("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs159("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx184("path", {
        fill: "#000001",
        d: "m0 0 320 240L0 480zm640 0L320 240l320 240z"
      }),
      /* @__PURE__ */ jsx184("path", {
        fill: "#090",
        d: "m0 0 320 240L640 0zm0 480 320-240 320 240z"
      }),
      /* @__PURE__ */ jsx184("path", {
        fill: "#fc0",
        d: "M640 0h-59.6L0 435.3V480h59.6L640 44.7z"
      }),
      /* @__PURE__ */ jsx184("path", {
        fill: "#fc0",
        d: "M0 0v44.7L580.4 480H640v-44.7L59.6 0z"
      })
    ]
  })
});
var Jm_default = SvgJm;

// src/country-flag-icons/generated/Jo.tsx
init_esm_shims();
import { jsx as jsx185, jsxs as jsxs160 } from "react/jsx-runtime";
var SvgJo = (props) => /* @__PURE__ */ jsxs160("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx185("defs", {
      children: /* @__PURE__ */ jsx185("clipPath", {
        id: "jo_svg__a",
        children: /* @__PURE__ */ jsx185("path", {
          fillOpacity: 0.7,
          d: "M-117.8 0h682.6v512h-682.6z"
        })
      })
    }),
    /* @__PURE__ */ jsx185("g", {
      clipPath: "url(#jo_svg__a)",
      transform: "translate(110.5) scale(.9375)",
      children: /* @__PURE__ */ jsxs160("g", {
        fillRule: "evenodd",
        strokeWidth: "1pt",
        children: [
          /* @__PURE__ */ jsx185("path", {
            fill: "#000001",
            d: "M-117.8 0h1024v170.7h-1024z"
          }),
          /* @__PURE__ */ jsx185("path", {
            fill: "#fff",
            d: "M-117.8 170.7h1024v170.6h-1024z"
          }),
          /* @__PURE__ */ jsx185("path", {
            fill: "#090",
            d: "M-117.8 341.3h1024V512h-1024z"
          }),
          /* @__PURE__ */ jsx185("path", {
            fill: "red",
            d: "m-117.8 512 512-256-512-256z"
          }),
          /* @__PURE__ */ jsx185("path", {
            fill: "#fff",
            d: "m24.5 289 5.7-24.9H4.7l23-11-15.9-19.9 23 11 5.6-24.8 5.7 24.9L69 233.2l-16 19.9 23 11H50.6l5.7 24.9-15.9-20z"
          })
        ]
      })
    })
  ]
});
var Jo_default = SvgJo;

// src/country-flag-icons/generated/Jp.tsx
init_esm_shims();
import { jsx as jsx186, jsxs as jsxs161 } from "react/jsx-runtime";
var SvgJp = (props) => /* @__PURE__ */ jsxs161("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx186("defs", {
      children: /* @__PURE__ */ jsx186("clipPath", {
        id: "jp_svg__a",
        children: /* @__PURE__ */ jsx186("path", {
          fillOpacity: 0.7,
          d: "M-88 32h640v480H-88z"
        })
      })
    }),
    /* @__PURE__ */ jsxs161("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      clipPath: "url(#jp_svg__a)",
      transform: "translate(88 -32)",
      children: [
        /* @__PURE__ */ jsx186("path", {
          fill: "#fff",
          d: "M-128 32h720v480h-720z"
        }),
        /* @__PURE__ */ jsx186("circle", {
          cx: 523.1,
          cy: 344.1,
          r: 194.9,
          fill: "#bc002d",
          transform: "translate(-168.4 8.6) scale(.76554)"
        })
      ]
    })
  ]
});
var Jp_default = SvgJp;

// src/country-flag-icons/generated/Ke.tsx
init_esm_shims();
import { jsx as jsx187, jsxs as jsxs162 } from "react/jsx-runtime";
var SvgKe = (props) => /* @__PURE__ */ jsxs162("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx187("defs", {
      children: /* @__PURE__ */ jsx187("path", {
        id: "ke_svg__a",
        strokeMiterlimit: 10,
        d: "m-28.6 47.5 1.8 1 46.7-81c2.7-.6 4.2-3.2 5.7-5.8 1-1.8 5-8.7 6.7-17.7a58 58 0 0 0-11.9 14.7c-1.5 2.6-3 5.2-2.3 7.9z"
      })
    }),
    /* @__PURE__ */ jsx187("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx187("path", {
      fill: "#000001",
      d: "M0 0h640v144H0z"
    }),
    /* @__PURE__ */ jsx187("path", {
      fill: "#060",
      d: "M0 336h640v144H0z"
    }),
    /* @__PURE__ */ jsxs162("g", {
      id: "ke_svg__b",
      transform: "matrix(3 0 0 3 320 240)",
      children: [
        /* @__PURE__ */ jsx187("use", {
          xlinkHref: "#ke_svg__a",
          width: "100%",
          height: "100%",
          stroke: "#000"
        }),
        /* @__PURE__ */ jsx187("use", {
          xlinkHref: "#ke_svg__a",
          width: "100%",
          height: "100%",
          fill: "#fff"
        })
      ]
    }),
    /* @__PURE__ */ jsx187("use", {
      xlinkHref: "#ke_svg__b",
      width: "100%",
      height: "100%",
      transform: "matrix(-1 0 0 1 640 0)"
    }),
    /* @__PURE__ */ jsx187("path", {
      fill: "#b00",
      d: "M640.5 168H377c-9-24-39-72-57-72s-48 48-57 72H-.2v144H263c9 24 39 72 57 72s48-48 57-72h263.5z"
    }),
    /* @__PURE__ */ jsx187("path", {
      id: "ke_svg__c",
      d: "M377 312c9-24 15-48 15-72s-6-48-15-72c-9 24-15 48-15 72s6 48 15 72"
    }),
    /* @__PURE__ */ jsx187("use", {
      xlinkHref: "#ke_svg__c",
      width: "100%",
      height: "100%",
      transform: "matrix(-1 0 0 1 640 0)"
    }),
    /* @__PURE__ */ jsxs162("g", {
      fill: "#fff",
      transform: "matrix(3 0 0 3 320 240)",
      children: [
        /* @__PURE__ */ jsx187("ellipse", {
          rx: 4,
          ry: 6
        }),
        /* @__PURE__ */ jsx187("path", {
          id: "ke_svg__d",
          d: "M1 5.8s4 8 4 21-4 21-4 21z"
        }),
        /* @__PURE__ */ jsx187("use", {
          xlinkHref: "#ke_svg__d",
          width: "100%",
          height: "100%",
          transform: "scale(-1)"
        }),
        /* @__PURE__ */ jsx187("use", {
          xlinkHref: "#ke_svg__d",
          width: "100%",
          height: "100%",
          transform: "scale(-1 1)"
        }),
        /* @__PURE__ */ jsx187("use", {
          xlinkHref: "#ke_svg__d",
          width: "100%",
          height: "100%",
          transform: "scale(1 -1)"
        })
      ]
    })
  ]
});
var Ke_default = SvgKe;

// src/country-flag-icons/generated/Kg.tsx
init_esm_shims();
import { jsx as jsx188, jsxs as jsxs163 } from "react/jsx-runtime";
var SvgKg = (props) => /* @__PURE__ */ jsxs163("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx188("defs", {
      children: /* @__PURE__ */ jsx188("clipPath", {
        id: "kg_svg__a",
        children: /* @__PURE__ */ jsx188("path", {
          fillOpacity: 0.7,
          d: "M-85 0h682.7v512H-85z"
        })
      })
    }),
    /* @__PURE__ */ jsxs163("g", {
      fillRule: "evenodd",
      clipPath: "url(#kg_svg__a)",
      transform: "translate(79.6) scale(.9375)",
      children: [
        /* @__PURE__ */ jsx188("path", {
          fill: "red",
          d: "M-128 0h768.8v512H-128z"
        }),
        /* @__PURE__ */ jsx188("path", {
          fill: "#ff0",
          d: "M105.5 261.1c13.6-16.6 41.9-.4 65-12.3-27.4 1.5-42.3-13.2-63.9-11.1 22.4-13.8 41.5 4.5 66.5-2.8-33.1-2.8-31.7-17.7-61.9-19.8 26.8-11.4 40 11.8 66.3 6.5-31-7.1-35-25.3-58-29.2 33.6-5 31.4 14.8 64.3 17.2-33.4-14.3-24.7-26.8-52.6-37.7 31.3-.7 29.2 21 61 26.6-27.2-17.2-23.9-32.9-46.2-45.2 26.5.5 29 27.6 56.1 36-24.1-19.1-17.8-35.3-38.6-52.4 26.4 6.2 22.5 29.6 50 44.6-20.4-22.6-12.6-38.8-30.3-57.3 25.4 8.1 15.7 30.4 42 51.6-15-24.9-5.7-40.8-20.6-61.7 23.6 12.1 12.2 34.9 34 57.5-10.3-25.5 0-41.3-10.5-63.9 20.2 15 8.2 39.3 24.5 62.5-6-32 7.8-37.2 3.5-65.2 15.3 18.8-1.8 37.6 10 65.3-1.5-31.5 15.3-38.8 12.4-64 15.1 22.6-8.5 42.3 1.4 66.5 2.5-29.8 22.1-37.6 22.4-60.8 12 21.3-14 36.7-9.8 65 8.5-31.2 29.4-35 32-56 7.1 24.6-21.4 36-19.7 63.4 8.5-27.7 34.6-31 40-51.4 3.3 26-22.4 30.7-29.7 59.5 13.5-23.5 37.2-25.4 47.8-44-.8 25.8-29.8 29.2-38.7 53.3 16.7-20.5 37.7-17 54.4-35.1-1.8 23.3-31.3 22-47 46.1 18.1-16.7 45.4-11.7 59.3-26.1-.7 20.6-36.9 19-54 37.5 21-11.6 47.8-4.8 63.2-15.5-2.8 18-41 13.8-59.3 28 25.2-7 44.7 3.7 65-4-9.9 17.5-44.6 6.4-63 17.8 22-3.7 45.2 9.6 65.1 5.3-6.5 15.2-44.6-1-65 8.5 24.4-.2 40.3 15.5 63 14.4-12.3 13.8-45.7-5.1-65.2-1.9 23.8 5 42 24.6 60 25.6-14.9 11.3-42.5-14.5-65-11.3 23.2 6.2 42.6 32.5 55.8 33.1-14.3 9.8-42.5-22.5-61.8-21.3 23.5 10.6 34.2 37.5 49.7 41.3-19.1 6.1-37.9-29.2-58.4-30.5 23.8 15 25.1 38 43.4 48.2-19.3 4.7-33-35.2-53.3-38.6 19.5 14.3 22.5 45 35.4 54.6-19.6 1-26.7-40.7-46.8-46.7 17.2 14.4 13.1 45.6 26.5 59-20.4-4.3-17.8-40.6-39.1-52.9 15.3 19.4 7.5 46.9 17.5 62.4-19.9-8-11.3-40.6-30.2-59 10.3 20.6-.8 44.6 7.4 64.5-18.2-8.9-6-47.4-19.9-62.7 6.4 23.8-5.4 43.5-.6 64.8-18.6-21.5 2.8-43.2-13.3-65.1 4.2 25.1-13.4 42.7-10.6 63.7-14.7-17.2 8-44.7-3.5-66.4 2.4 24.7-20.3 46.4-18.7 62-12-20 13.3-43.6 6.5-66.3-1.4 23.6-24.4 36.4-28.7 57.9-7.7-23.7 19.6-40.8 17.2-64.1-7.8 22.1-30 31-37.8 52.5-6.4-23.7 26-36.2 26.8-61-10 23.2-36.5 28.4-45.3 46.2-3.3-23.5 33.8-34 35.2-56.3-12 21.4-41 22.3-51 39.3-1.5-23.4 37.6-26.3 43.7-50.8-11.9 18.2-43.7 15.9-57 30.7 2.1-21.7 44.4-23 51.2-42.6-15.8 15.2-45 9-61.5 21 9.2-21.4 48.9-16.9 57.8-32.3-17.5 9.1-48.6.2-64 9.4 14-20.2 44.8-8.1 62.3-22-28.4 4.1-45.5-7.2-65.2-2z"
        }),
        /* @__PURE__ */ jsx188("path", {
          fill: "#ff0",
          d: "M356 256.1a99.2 99.2 0 1 1-198.5 0 99.2 99.2 0 0 1 198.4 0z"
        }),
        /* @__PURE__ */ jsx188("path", {
          fill: "red",
          d: "M343.2 256.3a86.3 86.3 0 1 1-172.6 0 86.3 86.3 0 0 1 172.6 0"
        }),
        /* @__PURE__ */ jsx188("path", {
          fill: "#ff0",
          d: "M331.2 256.5a74 74 0 1 1-148.2 0 74 74 0 0 1 148.2 0"
        }),
        /* @__PURE__ */ jsx188("path", {
          fill: "red",
          d: "M194 208c20.5-.5 46 1.4 62.9 14.8a97.1 97.1 0 0 1 60.5-14.3l11 20.1a101 101 0 0 0-50 8.2 85.3 85.3 0 0 1 34.6 72.1c-2.7 3.4-7 7.1-9.7 10.5 4-28.5-11-60.3-32.9-77 17.8 25.6 28.3 48.6 25.4 80.4l-10 6.4c4.6-28-2-61-22.7-80 12 17.5 23.8 49 16.4 81-3.2 1-8.2 3.7-11.4 4.6a96 96 0 0 0-10.8-78.7c-13.8 19.8-18.3 50-10.5 78-3.8-1-6.7-2.2-10.6-3.1-5.7-30 2.2-64 15.9-81.7-14 8.1-27.1 42.7-23.4 78l-9.3-4.3c-4.5-26.3 7.4-60.6 24.5-80.4-19.4 12.2-35.2 42.3-32.5 74.6-3-2.6-5.7-3.9-8.7-6.6-3.4-28.2 13-56.6 32.1-73.6-16.1-7.3-30-8.7-50-8.4 3.1-6.5 6-14.1 9.2-20.7z"
        })
      ]
    })
  ]
});
var Kg_default = SvgKg;

// src/country-flag-icons/generated/Kh.tsx
init_esm_shims();
import { jsx as jsx189, jsxs as jsxs164 } from "react/jsx-runtime";
var SvgKh = (props) => /* @__PURE__ */ jsxs164("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx189("path", {
      fill: "#032ea1",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx189("path", {
      fill: "#e00025",
      d: "M0 120h640v240H0z"
    }),
    /* @__PURE__ */ jsxs164("g", {
      fill: "#fff",
      stroke: "#000",
      transform: "matrix(1.2 0 0 1.2 85.6 -522)",
      children: [
        /* @__PURE__ */ jsxs164("g", {
          strokeLinejoin: "bevel",
          children: [
            /* @__PURE__ */ jsx189("path", {
              d: "M139 623.5h113.8v43.8H139z"
            }),
            /* @__PURE__ */ jsx189("path", {
              d: "M247 647.6h3.5v16.5H247zm-108-8.1h113.8v5H139zm0-7h113.8v4.6H139z"
            }),
            /* @__PURE__ */ jsx189("path", {
              strokeWidth: 0.9,
              d: "M139 625.7h113.8v4.3H139z"
            }),
            /* @__PURE__ */ jsx189("path", {
              d: "M169 647.6h3.6v16.5H169zm49 0h3.6v16.5H218zm-78 0h3.5v16.5H140zm7 0h3.5v16.5H147zm7.5 0h3.5v16.5h-3.5zm7.5 0h3.5v16.5H162zm62.8 0h3.6v16.5h-3.6zm7.5 0h3.6v16.5h-3.6zm7.5 0h3.6v16.5h-3.6z"
            }),
            /* @__PURE__ */ jsx189("path", {
              strokeLinejoin: "miter",
              d: "M94.5 669.5a9.3 9.3 0 0 0 4.4-5.3H292a9.3 9.3 0 0 0 4.4 5.3z"
            })
          ]
        }),
        /* @__PURE__ */ jsx189("path", {
          d: "M193 556.8s-.1-4.1 2.3-4.2c2.3 0 2.2 4.2 2.2 4.2zm-12.5 54.5v-5.5c0-2.8-2.8-3-2.8-5 0 0-.4-3 .4-4.4 1.1 4 3 3.3 3 1.6 0-1.4-1-2.8-3.3-6.3-.8-1.1-.3-4.6.7-5.9.4 3 .9 4.5 2.2 4.5.8 0 1.4-.5 1.4-2 0-2-1.3-3-2-4.8a5 5 0 0 1 1.1-5.3c.5 3 .4 4.2 1.7 4.2 2.7-.9 0-4.8-.6-5.8-.6-1.1 1-3.4 1-3.4.8 2.7 1 2.9 2 2.6 1.2-.3 1-2-.4-3.4-.9-1-.8-2.3.2-3.3 1 1.9 2.2 1.8 2.3.6l-.8-4.4H204l-.9 4.3c-.2 1.2 1.4 1.5 2.4-.5 1 1 1.1 2.4.2 3.3-1.4 1.4-1.6 3.1-.4 3.4 1 .3 1.2 0 2-2.6 0 0 1.5 1.5 1 3.4-.6 1-3.3 5-.6 5.8 1.3 0 1.2-1.2 1.7-4.2a5 5 0 0 1 1 5.3c-.6 1.8-2 2.8-2 4.8 0 1.5.7 2 1.5 2 1.3 0 1.8-1.4 2.2-4.5 1 1.3 1.5 4.8.7 6-2.3 3.4-3.4 4.8-3.4 6.2 0 1.7 2 2.4 3-1.6.9 1.4.5 4.4.5 4.4 0 2-2.7 2.2-2.8 5v5.5zm7.2-46-.4-3.1h15.9l-.4 3.1zm1-3.2-.2-2.5H202l-.3 2.5zm2.3-2.6-.3-2.6h9l-.1 2.6zm33 110c-2-.7-5-2.9-5-5v-24.3l2.6-3.4H169l2.5 3.4v24.3c0 2.1-2 4.3-4 5z"
        }),
        /* @__PURE__ */ jsx189("path", {
          strokeLinejoin: "bevel",
          d: "M178.2 647.6h3.6v16.5h-3.6zm30.4 0h3.6v16.5h-3.6z"
        }),
        /* @__PURE__ */ jsx189("path", {
          d: "M168 609.2v27.6h54v-27.6a4.2 4.2 0 0 0-2.6 2.8v11.8h-48.7V612s-.6-2-2.8-2.8z"
        }),
        /* @__PURE__ */ jsx189("path", {
          d: "M214.6 669.5c-1.8-.7-5.6-2.9-5.6-5v-27.2c.4-1.5 2.4-2.4 3.7-3.4H177c1.7 1 3.6 1.7 4.3 3.4v27.2c0 2.1-3 4.3-4.8 5z"
        }),
        /* @__PURE__ */ jsx189("path", {
          d: "M219.4 634.2v-19.6h-4.9v-1.9h-38.8v2h-5v19.5zM207 669.5c-1.8-.7-4.3-2.9-4.3-5v-23.2l1.4-2.1h-17.7l1.5 2v23.3c0 2.1-2.6 4.3-4.3 5z"
        }),
        /* @__PURE__ */ jsx189("path", {
          d: "M190.7 639.2h9v30.3h-9z"
        }),
        /* @__PURE__ */ jsx189("path", {
          strokeLinejoin: "bevel",
          d: "M204.4 632.5c0-2 5.8-2.1 8.8-3.8h-36c3 1.7 8.7 1.8 8.7 3.8l1.2 3.9 15 .6z"
        }),
        /* @__PURE__ */ jsx189("path", {
          d: "M211.4 611.3c0-4.9.2-6.7 1.7-6.7V620c-3.7 1.4-6.3 6-6.3 6h-23.2s-2.6-4.6-6.3-6v-15.5c1.8 0 1.8 2 1.8 6.7zm1.7-2c0-5.6 4.9-6.2 4.9-6.2v5c-1.9-.1-2.8 1.6-2.8 4 0 2.5 1.5 2.5 1.5 2.5v14.2h-3.6z"
        }),
        /* @__PURE__ */ jsx189("path", {
          d: "M177.3 609.3c0-5.6-4.9-6.2-4.9-6.2v5c1.9-.1 2.8 1.6 2.8 4 0 2.5-1.5 2.5-1.5 2.5v14.2h3.6z"
        }),
        /* @__PURE__ */ jsxs164("g", {
          fill: "none",
          strokeWidth: 0.8,
          children: [
            /* @__PURE__ */ jsx189("path", {
              d: "M186.8 570.6H204m-19.2 5.4h21m-23 6.5h24.9m-27 7.9h29.5m-30.2 9h30.4"
            }),
            /* @__PURE__ */ jsx189("path", {
              strokeWidth: 1,
              d: "M170.8 629h48.6m-33.2 0h18v6.6h-18z"
            })
          ]
        }),
        /* @__PURE__ */ jsx189("path", {
          d: "M184 614.2c3 3.6 2.6 9.7 2.6 13.3H204c0-3.6-.4-9.7 2.6-13.3zm9.7-41-2.4-1.3v-3.5c1 .3 2 .4 2.2 2 .3-2.3 1-2.1 1.9-3 1 .9 1.5.7 1.9 3 0-1.6 1.2-1.7 2.1-2v3.5l-2.3 1.2z"
        }),
        /* @__PURE__ */ jsx189("path", {
          d: "m193.5 578.9-4-2.8V573c1.5.3 3 .5 3.2 2.2.4-2.5 1.3-3.7 2.7-4.7 1.3 1 2.2 2.2 2.7 4.7.1-1.7 1.7-1.9 3-2.2v3.2l-3.9 2.7z"
        }),
        /* @__PURE__ */ jsx189("path", {
          d: "m193.2 587.8-4.5-4v-4.7c1.6.4 3.4.6 3.6 3.1.5-3.5 1.5-5.4 3-6.8 1.6 1.4 2.6 3.3 3.2 6.8.2-2.5 2-2.7 3.6-3.1v4.7l-4.6 4zm8.4 5.3-4 5.7h-4.7l-4.1-5.7zm-15.2 9.5c2 1.1 2.8 3.4 3 7.6H201c.2-4.2 1-6.5 3-7.6z"
        }),
        /* @__PURE__ */ jsx189("path", {
          strokeLinejoin: "bevel",
          d: "M204.2 593v-5.6a5.2 5.2 0 0 0-3.8 3.3c0-2-2.5-6.3-5.2-8.5-2.7 2.4-5.3 6.4-5.2 8.4-.5-1.5-1.8-2.7-3.8-3.2v5.7z"
        }),
        /* @__PURE__ */ jsx189("path", {
          strokeLinejoin: "bevel",
          d: "M205 602.6V597c-2.1.6-3.5 1.7-4.1 3.3 0-2-2.7-6.3-5.7-8.5-3 2.5-5.8 6.4-5.7 8.5-.5-1.5-2-2.7-4.1-3.3v5.7z"
        }),
        /* @__PURE__ */ jsx189("path", {
          strokeLinejoin: "bevel",
          d: "M207.4 614.3v-6.6a9.6 9.6 0 0 0-5.1 3.8c0-3.5-4-9-7.1-10.7-3.2 1.8-7.1 7.4-7.1 10.7a9.7 9.7 0 0 0-5.2-3.8v6.6z"
        }),
        /* @__PURE__ */ jsx189("path", {
          strokeLinejoin: "bevel",
          d: "M206 629v-6.8c-2.4.9-3 3.1-3.8 4.7.3-6.9-3.8-14.2-7-16.1-3.2 1.9-7.4 9.4-7 16-.8-1.4-1.5-3.7-3.8-4.6v6.7z"
        }),
        /* @__PURE__ */ jsx189("path", {
          d: "M204.4 639.2v-6.8c-2.5.6-2.6 1.5-3.4 3 .3-4.1-2.6-8.8-5.8-10.6-3.2 1.8-6 6.5-5.8 10.6-.8-1.5-.9-2.4-3.4-3v6.8z"
        }),
        /* @__PURE__ */ jsxs164("g", {
          id: "kh_svg__a",
          children: [
            /* @__PURE__ */ jsx189("path", {
              d: "M99 664.2v-20.4c-.7-2.6-3-5-4.6-5.4v-18l3.7 2 4.3 18.9v23z"
            }),
            /* @__PURE__ */ jsx189("path", {
              d: "M99 664.3v-20.5c-.7-2.6-3-5-4.6-5.4v-19.2c2.5 0 3.7 3.2 3.7 3.2l4.3 18.9v22.9z"
            }),
            /* @__PURE__ */ jsx189("path", {
              d: "M96.3 669.5c1.7-.7 4.2-2.9 4.2-5v-25.6l-1.2-2H143l-1.7 2v25.6a6 6 0 0 0 3.4 5z"
            }),
            /* @__PURE__ */ jsx189("path", {
              d: "M135.8 669.5c-1.7-.7-4.2-2.9-4.2-5v-24.3l3.6-3.4h-29.6l3.6 3.4v24.3c0 2.1-2.5 4.3-4.2 5z"
            }),
            /* @__PURE__ */ jsx189("path", {
              d: "M131.7 669.5c-1.7-.7-4.3-2.9-4.3-5v-22l2.4-3.3H111l2.4 3.3v22c0 2.1-2.5 4.3-4.3 5z"
            }),
            /* @__PURE__ */ jsx189("path", {
              d: "M116 639.2h8.9v30.4h-9z"
            }),
            /* @__PURE__ */ jsx189("path", {
              strokeLinejoin: "bevel",
              d: "M103.7 647.6h3.6v16.5h-3.6zm30.8 0h3.5v16.5h-3.6zm-33.9-27.8h4.4v17h-4.4zm0-3.2h4.3v3.2h-4.3zm35.6 6.9h6.1v13h-6.1z"
            }),
            /* @__PURE__ */ jsx189("path", {
              d: "M104.9 636.6v-29c1.2 0 1.4 4.3 4.2 4.3 1.5 0 1.4-1.8.5-3.2-.7-1.3-1.6-3-.4-6.3.9 2.5 3.1 3.3 2.7 1.8-.7-2.7-2.8-3.2-1.2-7.3.5 3.4 2.7 3.3 2.2 1.3-.6-2.3-1.9-3.3-.3-6.5.9 3.7 2 3.5 2 1.2 0-3.4 0-7 4.2-8.3 0 0 .3-3 1.9-3 1.5 0 1.8 3 1.8 3 4.3 1.3 4.2 5 4.2 8.3 0 2.3 1.1 2.5 2-1.2 1.6 3.2.3 4.2-.3 6.5-.5 2 1.7 2.1 2.2-1.3 1.6 4.1-.5 4.6-1.2 7.3-.4 1.5 1.8.7 2.7-1.8 1.2 3.3.3 5-.4 6.3-.8 1.4-1 3.2.5 3.2 2.8 0 3-4.2 4.2-4.2v28.9zM98 614.7v22.1h2.5v-22.1c-.9-.5-1.7-.5-2.5 0z"
            }),
            /* @__PURE__ */ jsx189("path", {
              d: "M98.2 629c3.1 1.6 6.2 3.5 7 7.8h-7zm43.2-6.6v14.4h2v-14.4c-.6-.3-1.5-.4-2 0z"
            }),
            /* @__PURE__ */ jsx189("path", {
              d: "M143.4 629c-3.1 1.5-6.2 3.3-7 7.7h7zm-20.6-33.7 1.8-1.5v-2c-.6 0-1 .3-1.5 1a5 5 0 0 0-2.5-3 5 5 0 0 0-2.6 2.9c-.5-.7-.8-.8-1.5-1v2l1.8 1.6z"
            }),
            /* @__PURE__ */ jsx189("path", {
              d: "m123.8 600.2.8-1.9v-2.5c-.6 0-1 .3-1.5 1a5 5 0 0 0-2.5-3 5 5 0 0 0-2.6 2.9c-.5-.7-.8-.8-1.5-.9v2.5l.8 1.9z"
            }),
            /* @__PURE__ */ jsx189("path", {
              d: "m124 606.8 2.6-3.3v-3.2c-1 0-1.5.5-2.2 1.6-.7-2.3-2-2.7-3.8-3.8-1.9 1-3.2 1.5-3.8 3.7-.8-1.1-1.3-1.4-2.3-1.5v3.2l2.7 3.3z"
            }),
            /* @__PURE__ */ jsx189("path", {
              d: "M124.7 613.3s3.2-2.7 3.3-4.2v-3.5c-1.2.1-2.3.4-3.2 1.9-.8-2.9-2-3.7-4.2-5-2.3 1.3-3.5 2.1-4.2 5-1-1.5-2-1.8-3.3-2v3.6a15 15 0 0 0 3.3 4.2z"
            }),
            /* @__PURE__ */ jsx189("path", {
              d: "M126 625.3s4.4-4.7 4.5-6.6v-5.4c-1.6.2-3.2 1.3-4.4 3.6-1-4.5-2.6-7.6-5.5-9.8-3 2.2-4.6 5.3-5.6 9.8-1.2-2.3-2.7-3.4-4.3-3.6v5.4c.3 1.9 4.4 6.6 4.4 6.6z"
            }),
            /* @__PURE__ */ jsx189("path", {
              d: "M126 632.4s3.7-3.7 4.5-5.3v-5.4c-1.6.2-3.2 1.3-4.4 3.5a14 14 0 0 0-5.5-9.2c-3 2.2-4.6 4.7-5.6 9.2-1.2-2.2-2.7-3.3-4.3-3.5v5.4c1 1.6 4.4 5.3 4.4 5.3z"
            }),
            /* @__PURE__ */ jsx189("path", {
              d: "M127.5 636.6c-1-4.7-2-8.2-7.1-11.7-5.2 3.5-6.1 7-7.2 11.7z"
            }),
            /* @__PURE__ */ jsx189("path", {
              d: "M130.2 639.2v-6.8c-2.4 1-4.5 2.3-5.3 3.8-.8-3.8-2.5-5.4-4.6-7.7-2.1 2.3-3.5 4-4.4 7.7-.8-1.5-2.9-2.9-5.2-3.8v6.8z"
            })
          ]
        }),
        /* @__PURE__ */ jsx189("use", {
          xlinkHref: "#kh_svg__a",
          width: "100%",
          height: "100%",
          transform: "matrix(-1 0 0 1 390.7 0)"
        }),
        /* @__PURE__ */ jsx189("path", {
          d: "M72.7 694.3H318v12.5H72.7zm-6.5 12.5h258.3v12.5H66.2zm19.4-31.3H305v8.1H85.6z"
        }),
        /* @__PURE__ */ jsx189("path", {
          d: "M79.2 683.6h232.4v10.6H79.2zm10.2-14.3h212v6.2h-212z"
        }),
        /* @__PURE__ */ jsx189("path", {
          d: "M112.4 669.3h16v50h-16z"
        }),
        /* @__PURE__ */ jsx189("path", {
          d: "M116 669.3h8.9v50h-9zm71 0h16v50h-16z"
        }),
        /* @__PURE__ */ jsx189("path", {
          d: "M190.7 669.3h9v50h-9zm71.5 0h16v50h-16z"
        }),
        /* @__PURE__ */ jsx189("path", {
          d: "M265.7 669.3h9v50h-9z"
        }),
        /* @__PURE__ */ jsx189("path", {
          fill: "none",
          d: "M99 664.2h193M115.8 713h9.2m-9.2-6.3h9.2m-9.2-6.2h9.2m-9.2-6.3h9.2m-9.2-6.2h9.2m-9.2-6.3h9.2m-9.2-6.2h9.2m65.8 37.5h8.6m-8.6-6.3h8.6m-8.6-6.2h8.6m-8.6-6.3h8.6m-8.6-6.2h8.6m-8.6-6.3h8.6m-8.6-6.2h8.6m66.2 37.5h9.2m-9.2-6.3h9.2m-9.2-6.2h9.2m-9.2-6.3h9.2m-9.2-6.2h9.2m-9.2-6.3h9.2m-9.2-6.2h9.2"
        })
      ]
    })
  ]
});
var Kh_default = SvgKh;

// src/country-flag-icons/generated/Ki.tsx
init_esm_shims();
import { jsx as jsx190, jsxs as jsxs165 } from "react/jsx-runtime";
var SvgKi = (props) => /* @__PURE__ */ jsxs165("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx190("defs", {
      children: /* @__PURE__ */ jsx190("clipPath", {
        id: "ki_svg__a",
        children: /* @__PURE__ */ jsx190("path", {
          fillOpacity: 0.7,
          d: "M-86.3 0h682.6v512H-86.3z"
        })
      })
    }),
    /* @__PURE__ */ jsxs165("g", {
      clipPath: "url(#ki_svg__a)",
      transform: "translate(81) scale(.9375)",
      children: [
        /* @__PURE__ */ jsx190("path", {
          fill: "#e73e2d",
          fillRule: "evenodd",
          d: "M-164.3 0h835.8v306.5h-835.8z"
        }),
        /* @__PURE__ */ jsx190("path", {
          fill: "#fec74a",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "M204.3 282.1c-19.4-15.2-55.6-10-61.6-51.3 27.7 21.5 22.7-1.2 64 19.3z"
        }),
        /* @__PURE__ */ jsx190("path", {
          fill: "#fec74a",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "M209.5 263.4c-13.9-20.4-50-26.6-43-67.7 19.9 28.9 22 5.7 55.2 37.9z"
        }),
        /* @__PURE__ */ jsx190("path", {
          fill: "#fec74a",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "M215.8 250c-5-24.1-36-43.6-13.8-79 7.2 34.4 18 13.8 36.4 56.2z"
        }),
        /* @__PURE__ */ jsx190("path", {
          fill: "#fec74a",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "M230.3 237.6c2.7-24.5-20.8-52.6 11.1-79.4-3.6 34.9 13 18.7 17.5 64.6z"
        }),
        /* @__PURE__ */ jsx190("path", {
          fill: "#fec74a",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "M243.3 227.7c12.4-21.3 2.5-56.5 42.6-67.9-17.6 30.3 4.2 22.3-10.5 66z"
        }),
        /* @__PURE__ */ jsx190("path", {
          fill: "#fec74a",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "M262 230.3c18.6-16.2 20.4-52.8 62-50.9-26.3 23.2-3 22.5-31 59.4z"
        }),
        /* @__PURE__ */ jsx190("path", {
          fill: "#fec74a",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "M278.6 239.9c22.5-10.1 34.9-44.5 74.1-30.5-32 14.5-9.5 20.7-47 47.7z"
        }),
        /* @__PURE__ */ jsx190("path", {
          fill: "#fec74a",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "M292.5 255c24.4-3.4 46-33 79.7-8.4-34.7 4.9-15 17.1-58.5 32.5z"
        }),
        /* @__PURE__ */ jsx190("path", {
          fill: "#fec74a",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "m379.5 259.6-112.1 2.5 4.7 30.2z"
        }),
        /* @__PURE__ */ jsx190("path", {
          fill: "#fec74a",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "m363 218.4-103.8 39.9 17.3 33.3z"
        }),
        /* @__PURE__ */ jsx190("path", {
          fill: "#fec74a",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "m280.6 280.7 53.7-97.6-82.4 76.7z"
        }),
        /* @__PURE__ */ jsx190("path", {
          fill: "#fec74a",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "m279.5 272.6 17.2-109.4-53.8 97.2z"
        }),
        /* @__PURE__ */ jsx190("path", {
          fill: "#fec74a",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "m273 263.7-18-110.2-20 110.7z"
        }),
        /* @__PURE__ */ jsx190("path", {
          fill: "#fec74a",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "m263.7 254.3-52.3-92 20 111.8z"
        }),
        /* @__PURE__ */ jsx190("path", {
          fill: "#fec74a",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "m255.6 253.6-81.1-68.5 57.6 98z"
        }),
        /* @__PURE__ */ jsx190("path", {
          fill: "#fec74a",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "m146 218.9 87 71.9 13.4-37.6z"
        }),
        /* @__PURE__ */ jsx190("path", {
          fill: "#fec74a",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "m232.1 260.9-102.3-1.5 101.9 34z"
        }),
        /* @__PURE__ */ jsx190("path", {
          fill: "#fec74a",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "M315.1 279.2a61.4 61.4 0 1 1-122.7 0 61.4 61.4 0 0 1 122.7 0z"
        }),
        /* @__PURE__ */ jsx190("path", {
          fill: "#005989",
          fillRule: "evenodd",
          d: "M-165.1 303.4h839.9V512h-840z"
        }),
        /* @__PURE__ */ jsx190("path", {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M-165.6 454c15.6 7.2 38 25.3 62 25.3 40-.3 41-27.4 81.6-26.1 40.7 1 33.3 29.6 88.2 29.5 45.4-.2 60-34.7 99.2-30.6 29-1.5 40.8 32.7 85.3 33.2 46.2 1 63.1-37.3 92-34.1 31 0 41 30.8 84.3 31 55.2.3 64.9-32 99.3-30 24.6-.5 44 23.7 80 24.3 28.6.5 52.7-21.2 69-29l.7-36.8c-17 6.3-42.4 27.1-67.7 27.3-36.6 1.4-59.1-24-84.5-23.7-30.4.3-42.5 31.3-94 31.3-47.2 0-58-31.3-88.4-31.3-29.7.2-38.8 34-90.3 33.4-42-.5-58.3-32.3-88-32-31.5 0-64 30.9-99 29.4-48-2-58.5-29.4-90-29.4-23.5 0-49 25.6-77.3 26-28.2.5-59.9-25.5-62.8-26zm0-73c15.6 7.3 38 25.4 62 25.4 40-.3 41-27.4 81.6-26.2 40.7 1 33.3 29.7 88.2 29.5 45.4 0 60-34.6 99.2-30.5 29-1.5 40.8 32.7 85.3 33.1 46.2 1 63.1-37.2 92-34 31 0 41 30.8 84.3 31 55.2.3 64.9-32 99.3-30 24.6-.5 44 23.7 80 24.3 28.6.5 52.7-21.2 69-29l.7-36.8c-17 6.3-42.4 27-67.7 27.3-36.6 1.3-59.1-24-84.5-23.7-30.4.3-42.5 31.3-94 31.3-47.2 0-58-31.3-88.4-31.3-29.7.2-38.8 34-90.3 33.4-42-.5-58.3-32.3-88-32-31.5 0-64 30.8-99 29.3-48-2-58.5-29.4-90-29.4-23.5 0-49 25.7-77.3 26.1-28.2.4-59.9-25.5-62.8-26l.4 38.3z"
        }),
        /* @__PURE__ */ jsx190("path", {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M-165.6 309c15.6 7.2 38 25.2 61.9 25.2 40-.2 41-27.4 81.6-26.1 40.6 1 33.2 29.6 88.1 29.5 45.3-.1 60-34.7 99-30.5 29-1.5 40.8 32.7 85.3 33.1 46.1 1 63-37.3 92-34.1 30.8 0 41 30.8 84.2 31 55 .3 64.7-32 99.2-30 24.5-.5 43.9 23.7 79.8 24.3 28.7.5 52.7-21.2 69-29l.7-36.8c-17 6.4-42.3 27.1-67.7 27.3-36.4 1.4-59-23.9-84.4-23.7-30.3.3-42.4 31.3-94 31.3-47 0-57.8-31.3-88.2-31.3-29.7.3-38.8 34-90.1 33.4-42-.5-58.3-32.2-88-32-31.5 0-64 30.9-98.8 29.4-48.1-2-58.5-29.4-90-29.4-23.5 0-48.9 25.6-77.2 26-28.2.5-59.8-25.4-62.8-26l.4 38.3z"
        }),
        /* @__PURE__ */ jsx190("path", {
          fill: "#ffc84b",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.8,
          d: "M136.8 76c61-4.2 50-9.4 74.5-13.4 31 4.3 34.5 23 51.8 34.5 0 0-6.5 22-27.7 18.9-2.9-8.8 10.2-11.6-27.5-34.6-22-1.3-61.3 3.9-71-5.4zm189.3 33.9-44 1.8v10.9c29.7 1 35-3 44-12.7z"
        }),
        /* @__PURE__ */ jsx190("path", {
          fill: "#ffc84b",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeLinejoin: "round",
          strokeWidth: 1.7,
          d: "M174.8 108c7.7-3.9 11.5-2.3 18.2-2.5 4.5 8.3 8.8 9 18.8 10a49.5 49.5 0 0 0 39.9 21.8c29.9-.8 39.4-21.7 59.5-24h21.2c-3.5-6-6.3-9.5-14-9.9-15.8-.8-36.2-.4-54 3.6l-25.1 6.3c-7.4-3.6-25.3-22.4-36.8-22-6.7 1.8-6.7 4.1-10 6.7-6.5 2.8-13 1.4-17.7 10z"
        }),
        /* @__PURE__ */ jsx190("path", {
          fill: "#ffc84b",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.7,
          d: "M205.1 99a3.2 3.2 0 1 1-6.3 0 3.2 3.2 0 0 1 6.3 0z"
        }),
        /* @__PURE__ */ jsx190("path", {
          fill: "#ffc84b",
          fillRule: "evenodd",
          stroke: "#d8aa3f",
          strokeWidth: 1.8,
          d: "M225.6 107.8c44.9-54.1 84.1-47.5 135.3-51.2 1.7 6.3 1 15.7-23.3 24-33.4 5-93.1 40.2-93.4 40.2-11.1-.6-18.9-12.2-18.6-13z"
        }),
        /* @__PURE__ */ jsx190("path", {
          fill: "none",
          stroke: "#d9a43e",
          strokeLinecap: "round",
          strokeWidth: 1.8,
          d: "M317.9 72.5 351 74m-36.7 4 24.1 2"
        })
      ]
    })
  ]
});
var Ki_default = SvgKi;

// src/country-flag-icons/generated/Km.tsx
init_esm_shims();
import { jsx as jsx191, jsxs as jsxs166 } from "react/jsx-runtime";
var SvgKm = (props) => /* @__PURE__ */ jsxs166("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx191("defs", {
      children: /* @__PURE__ */ jsx191("clipPath", {
        id: "km_svg__a",
        children: /* @__PURE__ */ jsx191("path", {
          fillOpacity: 0.7,
          d: "M0 0h682.7v512H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs166("g", {
      fillRule: "evenodd",
      clipPath: "url(#km_svg__a)",
      transform: "scale(.9375)",
      children: [
        /* @__PURE__ */ jsx191("path", {
          fill: "#ff0",
          d: "M0 0h768.8v128H0z"
        }),
        /* @__PURE__ */ jsx191("path", {
          fill: "#fff",
          d: "M0 128h768.8v128H0z"
        }),
        /* @__PURE__ */ jsx191("path", {
          fill: "#be0027",
          d: "M0 256h768.8v128H0z"
        }),
        /* @__PURE__ */ jsx191("path", {
          fill: "#3b5aa3",
          d: "M0 384h768.8v128H0z"
        }),
        /* @__PURE__ */ jsx191("path", {
          fill: "#239e46",
          d: "M0 0v512l381.9-255.3z"
        }),
        /* @__PURE__ */ jsx191("path", {
          fill: "#fff",
          d: "M157.2 141.4c-85-4.3-123.9 63.5-123.8 115.9-.2 62 58.6 113 112.8 110C117 353.5 81.2 314.6 81 257c-.3-52.1 29.5-97.5 76.3-115.6z"
        }),
        /* @__PURE__ */ jsx191("path", {
          fill: "#fff",
          d: "m156 197-12-9.3-14.6 4.6 5.2-14.4-8.8-12.4 15.2.6 9-12.3 4.3 14.7 14.4 4.8-12.6 8.5zm-.3 52.1-12-9.4-14.6 4.6 5.3-14.3-8.9-12.4 15.3.5 9-12.2 4.2 14.6 14.5 4.9-12.7 8.5zm.2 52.6-12-9.4-14.5 4.6 5.2-14.3-8.8-12.4 15.2.5 9-12.2 4.3 14.6 14.4 4.8-12.6 8.6zm-.2 53-12-9.3L129 350l5.3-14.4-8.9-12.4 15.3.6 9-12.3 4.2 14.7 14.5 4.8-12.7 8.5z"
        })
      ]
    })
  ]
});
var Km_default = SvgKm;

// src/country-flag-icons/generated/Kn.tsx
init_esm_shims();
import { jsx as jsx192, jsxs as jsxs167 } from "react/jsx-runtime";
var SvgKn = (props) => /* @__PURE__ */ jsxs167("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx192("defs", {
      children: /* @__PURE__ */ jsx192("clipPath", {
        id: "kn_svg__a",
        children: /* @__PURE__ */ jsx192("path", {
          fillOpacity: 0.7,
          d: "M-80.1 0h682.7v512H-80.1z"
        })
      })
    }),
    /* @__PURE__ */ jsxs167("g", {
      fillRule: "evenodd",
      clipPath: "url(#kn_svg__a)",
      transform: "translate(75.1) scale(.9375)",
      children: [
        /* @__PURE__ */ jsx192("path", {
          fill: "#ffe900",
          d: "M-107.8.2h737.6v511.3h-737.6z"
        }),
        /* @__PURE__ */ jsx192("path", {
          fill: "#35a100",
          d: "m-108.2.2.8 368.6L466.6 0z"
        }),
        /* @__PURE__ */ jsx192("path", {
          fill: "#c70000",
          d: "m630.7 511.5-1.4-383.2-579 383.5z"
        }),
        /* @__PURE__ */ jsx192("path", {
          fill: "#000001",
          d: "m-107.9 396.6.5 115.4 125.3-.2 611.7-410.1L629 1.4 505.2.2z"
        }),
        /* @__PURE__ */ jsx192("path", {
          fill: "#fff",
          d: "m380.4 156.6-9.8-42.2 33.3 27 38-24.6-17.4 41.3 33.4 27-44.2-1.5-17.3 41.3-9.9-42.2-44.1-1.5zm-275.2 179-9.9-42.3 33.3 27 38-24.6-17.4 41.3 33.4 27-44.1-1.5-17.4 41.3-9.8-42.2-44.1-1.5z"
        })
      ]
    })
  ]
});
var Kn_default = SvgKn;

// src/country-flag-icons/generated/Kp.tsx
init_esm_shims();
import { jsx as jsx193, jsxs as jsxs168 } from "react/jsx-runtime";
var SvgKp = (props) => /* @__PURE__ */ jsxs168("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx193("defs", {
      children: /* @__PURE__ */ jsx193("clipPath", {
        id: "kp_svg__a",
        children: /* @__PURE__ */ jsx193("path", {
          fillOpacity: 0.7,
          d: "M5 .1h682.6V512H5.1z"
        })
      })
    }),
    /* @__PURE__ */ jsxs168("g", {
      fillRule: "evenodd",
      clipPath: "url(#kp_svg__a)",
      transform: "translate(-4.8 -.1) scale(.93768)",
      children: [
        /* @__PURE__ */ jsx193("path", {
          fill: "#fff",
          stroke: "#000",
          d: "M776 511.5H-76V.5h852z"
        }),
        /* @__PURE__ */ jsx193("path", {
          fill: "#3e5698",
          d: "M776 419H-76v92.5h852z"
        }),
        /* @__PURE__ */ jsx193("path", {
          fill: "#c60000",
          d: "M776 397.6H-76V114.4h852z"
        }),
        /* @__PURE__ */ jsx193("path", {
          fill: "#3e5698",
          d: "M776 .6H-76V93h852z"
        }),
        /* @__PURE__ */ jsx193("path", {
          fill: "#fff",
          d: "M328.5 256c0 63.5-53 115-118.6 115S91.3 319.5 91.3 256s53-114.8 118.6-114.8c65.5 0 118.6 51.4 118.6 114.9z"
        }),
        /* @__PURE__ */ jsx193("path", {
          fill: "#c40000",
          d: "m175.8 270.6-57-40.7 71-.2 22.7-66.4 21.1 66.1 71-.4-57.9 41.2 21.3 66.1-57-40.7-58 41.3z"
        })
      ]
    })
  ]
});
var Kp_default = SvgKp;

// src/country-flag-icons/generated/Kr.tsx
init_esm_shims();
import { jsx as jsx194, jsxs as jsxs169 } from "react/jsx-runtime";
var SvgKr = (props) => /* @__PURE__ */ jsxs169("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx194("defs", {
      children: /* @__PURE__ */ jsx194("clipPath", {
        id: "kr_svg__a",
        children: /* @__PURE__ */ jsx194("path", {
          fillOpacity: 0.7,
          d: "M-95.8-.4h682.7v512H-95.8z"
        })
      })
    }),
    /* @__PURE__ */ jsxs169("g", {
      fillRule: "evenodd",
      clipPath: "url(#kr_svg__a)",
      transform: "translate(89.8 .4) scale(.9375)",
      children: [
        /* @__PURE__ */ jsx194("path", {
          fill: "#fff",
          d: "M-95.8-.4H587v512H-95.8Z"
        }),
        /* @__PURE__ */ jsxs169("g", {
          transform: "rotate(-56.3 361.6 -101.3) scale(10.66667)",
          children: [
            /* @__PURE__ */ jsxs169("g", {
              id: "kr_svg__c",
              children: [
                /* @__PURE__ */ jsx194("path", {
                  id: "kr_svg__b",
                  fill: "#000001",
                  d: "M-6-26H6v2H-6Zm0 3H6v2H-6Zm0 3H6v2H-6Z"
                }),
                /* @__PURE__ */ jsx194("use", {
                  xlinkHref: "#kr_svg__b",
                  width: "100%",
                  height: "100%",
                  y: 44
                })
              ]
            }),
            /* @__PURE__ */ jsx194("path", {
              stroke: "#fff",
              d: "M0 17v10"
            }),
            /* @__PURE__ */ jsx194("path", {
              fill: "#cd2e3a",
              d: "M0-12a12 12 0 0 1 0 24Z"
            }),
            /* @__PURE__ */ jsx194("path", {
              fill: "#0047a0",
              d: "M0-12a12 12 0 0 0 0 24A6 6 0 0 0 0 0Z"
            }),
            /* @__PURE__ */ jsx194("circle", {
              cy: -6,
              r: 6,
              fill: "#cd2e3a"
            })
          ]
        }),
        /* @__PURE__ */ jsxs169("g", {
          transform: "rotate(-123.7 191.2 62.2) scale(10.66667)",
          children: [
            /* @__PURE__ */ jsx194("use", {
              xlinkHref: "#kr_svg__c",
              width: "100%",
              height: "100%"
            }),
            /* @__PURE__ */ jsx194("path", {
              stroke: "#fff",
              d: "M0-23.5v3M0 17v3.5m0 3v3"
            })
          ]
        })
      ]
    })
  ]
});
var Kr_default = SvgKr;

// src/country-flag-icons/generated/Kw.tsx
init_esm_shims();
import { jsx as jsx195, jsxs as jsxs170 } from "react/jsx-runtime";
var SvgKw = (props) => /* @__PURE__ */ jsxs170("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx195("defs", {
      children: /* @__PURE__ */ jsx195("clipPath", {
        id: "kw_svg__a",
        children: /* @__PURE__ */ jsx195("path", {
          fillOpacity: 0.7,
          d: "M0 0h682.7v512H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs170("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      clipPath: "url(#kw_svg__a)",
      transform: "scale(.9375)",
      children: [
        /* @__PURE__ */ jsx195("path", {
          fill: "#fff",
          d: "M0 170.6h1024v170.7H0z"
        }),
        /* @__PURE__ */ jsx195("path", {
          fill: "#f31830",
          d: "M0 341.3h1024V512H0z"
        }),
        /* @__PURE__ */ jsx195("path", {
          fill: "#00d941",
          d: "M0 0h1024v170.7H0z"
        }),
        /* @__PURE__ */ jsx195("path", {
          fill: "#000001",
          d: "M0 0v512l255.4-170.7.6-170.8z"
        })
      ]
    })
  ]
});
var Kw_default = SvgKw;

// src/country-flag-icons/generated/Ky.tsx
init_esm_shims();
import { jsx as jsx196, jsxs as jsxs171 } from "react/jsx-runtime";
var SvgKy = (props) => /* @__PURE__ */ jsxs171("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx196("path", {
      fill: "#006",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx196("path", {
      fill: "#012169",
      d: "M0 0h320v240H0z"
    }),
    /* @__PURE__ */ jsx196("path", {
      fill: "#fff",
      d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0z"
    }),
    /* @__PURE__ */ jsx196("path", {
      fill: "#c8102e",
      d: "M212 140.5 320 220v20l-135.5-99.5zm-92 10 3 17.5-96 72H0zM320 0v1.5l-124.5 94 1-22L295 0zM0 0l119.5 88h-30L0 21z"
    }),
    /* @__PURE__ */ jsx196("path", {
      fill: "#fff",
      d: "M120.5 0v240h80V0zM0 80v80h320V80z"
    }),
    /* @__PURE__ */ jsx196("path", {
      fill: "#c8102e",
      d: "M0 96.5v48h320v-48zM136.5 0v240h48V0z"
    }),
    /* @__PURE__ */ jsxs171("g", {
      stroke: "#fff",
      strokeLinejoin: "round",
      strokeWidth: 9.6,
      transform: "translate(-306.8 -21.2) scale(.87136)",
      children: [
        /* @__PURE__ */ jsx196("use", {
          xlinkHref: "#ky_svg__a",
          width: "100%",
          height: "100%"
        }),
        /* @__PURE__ */ jsx196("use", {
          xlinkHref: "#ky_svg__b",
          width: "100%",
          height: "100%"
        }),
        /* @__PURE__ */ jsx196("use", {
          xlinkHref: "#ky_svg__c",
          width: "100%",
          height: "100%"
        }),
        /* @__PURE__ */ jsx196("use", {
          xlinkHref: "#ky_svg__d",
          width: "100%",
          height: "100%"
        }),
        /* @__PURE__ */ jsx196("use", {
          xlinkHref: "#ky_svg__e",
          width: "100%",
          height: "100%"
        }),
        /* @__PURE__ */ jsx196("use", {
          xlinkHref: "#ky_svg__f",
          width: "100%",
          height: "100%"
        }),
        /* @__PURE__ */ jsx196("use", {
          xlinkHref: "#ky_svg__g",
          width: "100%",
          height: "100%"
        })
      ]
    }),
    /* @__PURE__ */ jsxs171("g", {
      stroke: "#000",
      strokeWidth: 1.4,
      transform: "translate(-306.8 -21.2) scale(.87136)",
      children: [
        /* @__PURE__ */ jsxs171("g", {
          id: "ky_svg__b",
          fill: "#fcea83",
          children: [
            /* @__PURE__ */ jsx196("path", {
              d: "M754.4 449.6c2.9 7.6 23.5 17.7 47.5 4.8 16.3-9.2 26.8-22 36.9-45 2.8-5.8 4.3-13-2.4-17.3-5.3-3.9-14-8.2-17.8-12-1.9-2-3.8-3.4-5.2-4.8 1 1 1.9 1.9 2.8 3.3 9.6 11.5-.4 28.3-11 38.4-7.7 7.2-21.5 24.9-41.7 8.1-4.3-3.8-14.4 12-9 24.5zm291.4 0c-3.4 7.6-24 17.7-47.5 4.8-16.2-9.2-26.8-22-37.3-45-2.4-5.8-3.9-13 2.8-17.3 5.3-3.9 14-8.2 17.8-12 1.9-2 3.3-3.4 5.2-4.8-1 1-1.9 1.9-2.8 3.3-9.6 11.5.4 28.3 10.5 38.4 7.7 7.2 22 24.9 42.2 8.1 4.3-3.8 13.9 12 9 24.5z"
            }),
            /* @__PURE__ */ jsx196("path", {
              d: "M900.1 490.8c38.3 0 97.3-17.3 129-77.7 5.2-10 0-15.3-6.3-18.6a73 73 0 0 1-19.2-14c7.7 7.7 6.2 13 1 21.6-24.5 40.8-58 61.4-104.5 61.4s-80-20.6-104.5-61.4c-5.2-8.6-6.7-13.9.5-21.5a66 66 0 0 1-19.2 13.9c-6.2 3.3-11.5 8.6-6.2 18.6 31.6 60.4 91 77.7 129.4 77.7z"
            })
          ]
        }),
        /* @__PURE__ */ jsx196("path", {
          id: "ky_svg__c",
          fill: "#c8102e",
          d: "M811.4 409.8c-1-4.8-7.1-2.9-9 2.9a68.4 68.4 0 0 1-6.8-10.6c-5.7-8.6-6.7-14.4 1.5-22.5 3.8-3.8 11.5-8.2 16.7-3.4 11 9.1 5.3 24-2.4 33.6zm176.9 0c1-4.8 7.7-2.9 9.6 2.9 2.4-3.4 4.8-6.7 6.7-10.6 5.7-8.6 6.7-14.4-2-22.5-3.3-3.8-11-8.2-16.7-3.4-10.6 9.1-5.3 24 2.4 33.6zm-233.9 39.8c-4.8-7.2-8.6-26-9.6-30.7-1.4-4.3-1.9-8.2 3.4-10 5.3-2 10 4.7 12.4 10.5 2.4 5.7 6.3 14.3 10.6 24.9-10.6-6.2-19.2-2-16.8 5.3zm291.4 0c4.3-7.2 8.1-26 9.6-30.7 1-4.3 1.9-8.2-3.4-10-5.3-2-10 4.7-12.4 10.5-2.4 5.7-6.3 14.3-10.6 24.9 10.6-6.2 18.7-2 16.8 5.3z"
        }),
        /* @__PURE__ */ jsxs171("g", {
          fill: "#00493d",
          stroke: "none",
          children: [
            /* @__PURE__ */ jsx196("path", {
              d: "m782.2 406.4-3.8 2c-1 .4-1 1.4-1 1.9h-.5L775 406h.5c0 .4.5 1 1.4.4l8.2-4.3c1-.5 1-1 .5-1.4l.4-.5 2.4 4.8h-.4c-.5-.5-1-1-2-.5l-3.3 2 1.4 2.8 3.9-1.4c1-.5.4-1.5.4-2h.5l2 4.4c-.5-.5-1-1-2-.5l-8.1 4.3c-1 .5-1 1-.5 1.4l-.5.5-2.4-4.3.5-.5c.5.5 1 1 2 .5l3.8-2zm8.2 6.3c1-.5 1-1 .4-2h.5l4.8 7.2-3.3 2.4v-.4c1.9-1.5 1.9-3.4 1.4-3.9s-1-1-1-1.4c-.4 0-.4-.5-1.4.5l-3.4 2.4c.5.4 1 1.9 3.4.4h.5l-5.3 3.9v-.5c2.4-2 1.4-3.4 1-3.8l-3.4 2.4c-1 .4-1 1-1 1.4.5 0 .5.5 1 1 .5 1 2 1.9 4.3 1l.5.4-3.8 1.4-4.8-7.6h.5c.4.4 1 1 1.9.4zm7.6 18.2-3.3 2.8c-.5.5-.5 1.5 0 2h-.5l-3.4-3.4.5-.5c.5.5 1 1 2 0l6.2-6.2c1-.5 1-1 .4-2l3.4 4c-.5-.6-1.4-.6-2 0l-2.8 2.8 2.4 2.4 2.9-2.4c1-1 .5-1.4 0-2l.5-.4 3.3 3.8h-.5c-.4 0-1-.4-1.9.5l-6.2 5.8c-1 1-1 1.4-.5 1.9v.5l-3.3-3.9c.4 0 1.4.5 1.9 0l3.3-3.3zm7.2 10.1 1.5 1.4 1.9-4.3s-1.5.4-3.9 1.9zl-.5.4-1-1c-.4.5-.9.5-1.4 1-1.4 1-1 1.5-.4 2v.4l-2.4-2.4h.4l2-.5 9.5-5.2.5.4s-.5.5-4.8 10.1c0 1-.4 1.4 0 2.4l-3.8-3.3.5-.5c.5 1 1.4 1 1.9 0 0-.5.5-1.5.5-2l-1.5-1.4.5-.5zm3.8 9.5.5-.5c.5.5 1 .5 2 0l6.2-8.1-.5-.5c-1-.5-2.4-.5-3.8 1v-.5l1.9-2.4 7.2 5.3-2.4 2.8h-.5c1.4-1.4 1-3.3 0-3.8v-.5l-6.2 8.2c-1 .5-.5 1.4 0 1.9h-.5z"
            }),
            /* @__PURE__ */ jsx196("path", {
              d: "m821.5 452.4-2.4 3.4c-.5 1 0 1.4.5 2l-.5.4-3.8-2.9v-.5c1 .5 1.4.5 1.9-.4l5.3-7.2c.4-1 0-1.5-.5-2l.5-.4 3.8 2.8v.5c-1-.5-1.4-.5-2 .5L822 452l2.9 1.9 2.4-3.4c.4-1 0-1.4-.5-1.9l.5-.5 3.8 2.9v.5c-.5-.5-1.4-.5-2 .5l-4.7 7.6c-1 .5-.5 1 0 1.5v.4l-4.3-2.8h.5c.4 0 1 0 1.4-.5l2.4-3.8zm9.6 13.5.5-.5c.5.5 1.4.5 1.9-.5l3.8-8.1c.5-1 0-1.5-.5-2l8.2 3.9-2 3.8-.4-.5c1.4-1.9 0-3.8-.5-4.3-.5 0-1-.5-1.4-.5-.5 0-.5 0-1 1-.5.5-1.9 3.3-1.9 3.3.5.5 1.4 1.5 3.4-1h.4l-2.8 5.8-.5-.4c1.4-3-.5-3.4-1-3.4l-1.9 3.8c-.5 1 0 1.5.5 1.5v.5zm13.9 6.7c-1.4-1-1.4-3.9 0-6.7 1-3 2.9-5.3 4.8-4.4 1.4.5 1 3.4 0 6.3-1.5 3.3-3.4 5.2-4.8 4.8h-.5c3.4 1.4 5.8-.5 7.2-3.9 1.4-2.8 1-6.2-2-7.6-2.8-1.5-5.7.4-7.1 3.8-1.4 3.4-1 6.7 2 7.7zm14.8.9 2-5.7c.4-1 0-1.5-.5-2l2.4.5v.5c-.5 0-1 0-1.5 1l-1.9 5.7c-1 2.4-2.4 4.3-5.2 3.4-2-.5-3.4-2.9-2.4-5.3l2.4-6.2c.4-1 0-1.5-.5-2v-.4l4.3 1.9v.5c-.5-.5-1.4-.5-1.4.5L855 472c-.5 1.9-.5 3.8 1 4.3 1.4.5 2.8-.5 3.7-2.9zm4.4-6.2c0-.5 0-.5-.5-.5l3.3.5 3 9.1 1.4-5.8c.4-1 0-1.4-.5-1.9l2.8.5-.4.5c-.5 0-1 0-1.5 1l-2.4 10.5h-.4l-3.9-11.5-2.4 7.7c0 1.4.5 1.4 1 1.9v.5l-2.9-1v-.5c.5.5 1.4 0 1.4-1l2.4-8.6zm16.3 9.6c-1 4.3-3 5.3-3.9 5.3h-1s-.4-.5 0-1l1.5-9.6c.5-.5.5-1 1-.5h1c.9 0 1.8 2 1.4 5.8l1.4.5c1-4.8-1-6.8-3.4-7.2-1.9-.5-4.8-1-4.8-1v.5c.5.5 1.5.5 1 2l-1.4 8.5c-.5 1-1 1.5-1.5 1.5h-.4l4.7 1c2.4.4 4.8 0 5.8-5.3zm4.3-3.9c0-1-1-1.4-1.5-1.4v-.5l8.7 1-.5 3.8c0-2.4-1.5-3.3-2.4-3.3-.5-.5-1-.5-1.5-.5-.4 0-.4 0-.4 1.4l-.5 3.9c.5 0 1.9.4 2.9-2.4l-.5 6.2h-.5c0-2.9-1.4-2.9-2-2.9l-.4 4.3c0 1 0 1 .5 1l1 .5c1.4 0 2.8-.5 3.8-3.4h.5l-1 3.8-9.1-1c1 0 1.4-.4 2-1.3zm15.8 5.8c0 4.3-1.5 5.7-2.9 5.7-.5-.4-.5-.4-1-.4l-.4-.5.5-10c0-.6 0-.6.4-.6h1c1 0 2.4 1.5 2.4 5.8h1.9c0-4.8-2.4-6.2-4.8-6.2-2-.5-4.8-.5-4.8-.5v.5c.5 0 1.5.4 1.5 1.4l-.5 9.1c0 1-.5 1.4-1 1.4v.5h4.3c2.4 0 4.8-1 5.3-6.2h-2zm13.9 3.8c0 1 .5 1 1.4 1v.5l-5.3.4c.5-.4 1.5-1 1.5-1.9l-1-9c-.5-1-1-1-1.9-1v-.5l5.3-.5c-.5.5-1.5 1-1 2zm4.8 1v-.5c.5 0 1-.5 1-1.4l-2-10h-.5c-1 .4-1.9 1.3-1.4 3.3h-.5l-.5-3.4 8.7-1.4.4 3.3h-.4c0-1.9-1.5-2.4-3-2.4h-.4l2 10c0 1 .4 1.5 1.4 1.5v.5zm20.6-9.6-2-5.7c0-1-.9-1-1.4-1v-.5l2.4-1v.5c-.5.5-.5.5-.5 1.5l2 6.2c.4 2 .4 4.8-2.4 5.8-2 .4-4.3-.5-4.8-3.4l-2-6.2c-.4-1-.9-1-1.4-1l-.5-.5 4.8-1.4v.5c-.4.5-1 1-.4 1.9l1.4 6.2c.5 2 2 2.9 3.3 2.9 1.5-.5 2-2.4 1.5-4.8m5.3-3.4c2.3-1 1.9-2.3 1.4-3.8-.5-1.4-1.4-2.4-2.4-1.9-.5 0-1 .5-.5 1zl.4.5 1 3.9c.5 1 1.4 1 2 .4v.5l-4.4 2-.5-.5c1-.5 1-1 1-2l-3.4-8.1c-.5-1.4-1-1-1.9-1v-.4l4.8-2c2-.4 3.8 0 4.8 2 .5 2.4-.5 3.8-2.4 4.8-.5 0-1 .4-1 .4z"
            }),
            /* @__PURE__ */ jsx196("path", {
              d: "M957.1 472c-1.4.6-3.3-1.4-4.8-4.7-1.4-2.9-1.4-5.8 0-6.2 1.5-.5 3.4 1.4 4.8 4.3 1.5 2.9 1.5 5.7 0 6.7 3-1 3.9-4.3 2.4-7.7-1.4-2.9-4.3-4.8-7.2-3.8a5.6 5.6 0 0 0-2.4 7.7c1.5 3.3 4.4 5.2 7.2 3.8zm.5-13.3h-.9l2.8-2 8.7 4.8-3-5.2c-.4-1-1.4-1-1.8-1v-.5l2.4-1c-.5.6-1 1 0 2l4.8 9.6-.5.5-10.6-5.8 3.9 7.2c.4 1 1.4 1 1.9.5v.5l-2.4 1.4v-.5c.5-.5.5-1 0-1.9l-3.8-7.7zm21.6 1.4v-.5c0-.5.5-1 0-1.9l-5.8-8.1h-.5c-1 .4-1.4 2.4 0 3.8l-.4.5-2-3.4 7.2-4.8 2 3c-1.5-1.5-3-1.5-3.9-1l-.5.4 5.8 8.2c.5 1 1.4 1 2 .5v.4z"
            }),
            /* @__PURE__ */ jsx196("path", {
              d: "m984.5 448.6 2.8 3.4c.5.4 1.5.4 2 0v.4l-3.9 3.4v-.5c.5-.5.5-1 0-1.9l-5.7-7.2c-.5-1-1-.5-2-.5l3.9-3.3v.5c0 .4-.5 1 0 1.9l2.4 2.8 2.8-1.9-2.3-3.3c-.5-1-1.5-.5-2-.5l3.9-3.4v.5c-.5.5-.5 1 0 2l5.7 7.1c.5.5 1 .5 1.5 0l.4.5-3.8 3.4-.5-.5c.5-.5 1-1 .5-2l-2.9-3.3zm4.3-10.1c-.5-.4-1.5-.4-2 0v-.4l6.3-5.8 2.9 2.9h-.5c-1.5-2-3.4-1-4.3-.5 0 .5-.5.5-1 1 0 0 0 .4.5 1.4l2.9 2.9c.4-.5 1.9-1.5 0-3.9h.4l3.9 4.4v.4c-2.4-2.4-3.4-1-3.9-.4l3 2.8c.4 1 .9 1 .9 1l1.4-1.4c.5-.5 1-2 0-4.8h.5l1.9 3.3-6.2 6.2-.5-.4c.5-.5 1-1 0-2zm11.5-13.4c-.5.5-.5 1.5.4 2 1 .9 2 .9 3.9 0 1-.5 2.8-1 4.3.4 2.4 2.4 1.4 4.3 1 5.3-.5.5-1.5 1-2 1.4-.5 0-.5 0-.5.5v.5l-3.3-2.9h.5c1.9 1 3.8 1.4 4.8 0 1-1 0-2-.5-2.4-1-1-2-1-3.4 0-1.4.5-3.3.5-4.8-.5-1.9-1.9-1.9-3.3-1-4.8l2-1.4c.5 0 .5 0 0-1l3.4 2.4h-.5c-2.4-1-3.9-.4-4.3.5m4.3-3.8c-1-.5-1.5 0-2 .5h-.4l5.3-7.7 3.3 2.4-.5.5a3.3 3.3 0 0 0-4.3 0c0 .5-.5 1-.5 1.4-.4 0-.4.5.5 1 .5.5 3.4 2.4 3.4 2.4.5-.5 1.4-1.5-.5-3.4v-.5l4.8 3.9c-2.9-1.5-3.4 0-3.8.4l3.3 2.4c1 .5 1.4.5 1.4.5 0-.5.5-1 1-1.4.5-1 1-2.4-1-4.3l.5-.5 2.4 2.9-4.8 7.2h-.5c.5-1 .5-1.5-.4-2.4zm12.9-8.6-1.4 2.4c-2-2-2.9-3.4-2.9-3.4zh1c.5 0 1.4.4 1.9.4 1.4.5 1 1 .5 2h.5l2.4-4.4c-1 1-1.5.5-2.4.5-10.1-1.9-11-2.4-11-2.4v.5l7.6 8.6c.5.5.5 1.5.5 2h.5l1.4-2.4-.5-.5c-.5 1-1 1.4-1.9 0l-1-1 1.5-3.3zm-2.9-10.6c-.4.5-.4 1.5 1 2 1.4.4 2 0 3.4-1s2.8-2 4.7-1c3 1.5 2.4 3.9 2 4.8l-1.5 2v.9l-3.8-2c2.4.5 4.3 0 4.8-1.4.5-1-.5-1.9-1-2.4-1-.4-1.9 0-3.3 1-1.5 1.4-3 2-4.8 1-2-1-2.9-2.4-2-3.9 0-1 1-1.4 1.5-1.9 0-.5 0-.5-.5-1v-.4l3.9 1.9h-.5c-2.4-.5-3.9.5-3.9 1.4"
            })
          ]
        })
      ]
    }),
    /* @__PURE__ */ jsxs171("g", {
      stroke: "#000",
      strokeWidth: 1.4,
      transform: "translate(-306.8 -21.2) scale(.87136)",
      children: [
        /* @__PURE__ */ jsxs171("g", {
          id: "ky_svg__d",
          fill: "#073163",
          children: [
            /* @__PURE__ */ jsx196("path", {
              fill: "#fff",
              d: "M863.2 232.5c-6.2 1.4-10.5 1.9-16.3-3.4-3.8-3.8-2.9-10.5 1-13 4.3-2.8 8.1-4.7 13.4-3.3 5.3 1.5 19.2 14.4 15.8 14.9-3.4 0-8.6 3.3-13.9 4.8zm14.8-23c2-1.5 4.4-2.4 10.6-3 5.8-.4 10-.4 11.5 4 2 5.2 3.4 11.4 7.2 14.3-2.4 1.4-14.4 2.9-18.7.5-5.7-2.9-7.2-14-10.5-15.8zm41.3.5c1.9-1.5 4.3-1.5 10.5-1s8.6 1 10 5.3c1.5 4.8 0 11 3 15.3-3 1-12.5 1-15.9-2.4-5.2-3.8-4.8-14.9-7.6-17.3z"
            }),
            /* @__PURE__ */ jsx196("path", {
              d: "M948 212.8c-4.3-1-7.2-1.4-9 0 2.3 2.9.4 14.4 5.2 18.2 3.3 2.4 12 3 13.9-2.4 2.4-4.8 2.4-12-10-15.8zm-49.3-4.8c1.4-1.4 4.3-1.9 10-1.9 6.3 0 10 1 12 4.8 2 4.8 1.4 11 4.8 14.9-1.4 1.9-14.4 1.9-18.2-1-5.3-3.4-5.8-14.4-8.6-16.8zm-40.7 4.3c0-2.4 3.3-2.8 12-3.3 8.5-1 9-.5 11.9 5.7 1.4 3.4 3.3 9.1 7.2 11-10.6 2.5-14 3.9-19.7.5a29.2 29.2 0 0 1-10-10.5c-.5-1.4-.5-2.9-1.5-3.4z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs171("g", {
          fill: "#f9d050",
          strokeWidth: 0.6,
          children: [
            /* @__PURE__ */ jsxs171("g", {
              id: "ky_svg__f",
              children: [
                /* @__PURE__ */ jsx196("path", {
                  d: "M881 163.5c-10.1-7.7-22.1-14.9-33.1-16.3a280 280 0 0 1 32.6 25.4"
                }),
                /* @__PURE__ */ jsx196("path", {
                  d: "M886.7 156.3c-12-8.2-25.9-17.3-39.3-18.2a124 124 0 0 1 33 27.8m21.6-23a93 93 0 0 1 23.5-32.2c-4.8 10.1-10 30.7-12.5 38.9"
                }),
                /* @__PURE__ */ jsx196("path", {
                  d: "M912.6 140.5A48.4 48.4 0 0 1 937 115a101.2 101.2 0 0 0-18.2 35"
                }),
                /* @__PURE__ */ jsx196("path", {
                  d: "M916.9 150a84.5 84.5 0 0 1 37.8-31.6c-12 12-29.7 34-34 42.7m2.9-.5c8.6-4.8 25.9-12.5 38.3-10-7.6 2.8-30.6 13.3-40.7 23"
                }),
                /* @__PURE__ */ jsx196("path", {
                  d: "M921.7 157.2c8.1-8.6 23-21.5 38.8-26.8-11.5 11-36 36-39.3 39.8M898.7 152c-5.8-17.8-14.4-34.5-27.3-39.8a130.9 130.9 0 0 1 21 48.9m-4.8-9.6c-9.5-11.5-22.5-23-37.3-25.4a90.1 90.1 0 0 1 33 38.8"
                }),
                /* @__PURE__ */ jsx196("path", {
                  d: "M893 151c-12-21.6-21.2-25.4-26.4-29.7 4.3 8.1 14.8 29.7 21 38.8"
                }),
                /* @__PURE__ */ jsx196("path", {
                  fill: "none",
                  d: "M869 149.6a57.7 57.7 0 0 1 17.2 16.7"
                }),
                /* @__PURE__ */ jsx196("path", {
                  d: "M869 159.6c2.8 2.4 8.1 5.3 12.9 9.6m44.1-2.4c4.8-3.8 15.3-10 20.6-12m-24 8.7c4.8-6.3 14.4-14.9 17.8-17.8m-4.4-12a286.9 286.9 0 0 0-18.2 22.6m5.8-26.9a157 157 0 0 0-12 21.1m-25.9-20.1c2.9 7.7 8.2 20.6 10 25.9m-14.3-17.8c2 3 5.8 9.6 7.2 14.4"
                })
              ]
            }),
            /* @__PURE__ */ jsxs171("g", {
              id: "ky_svg__g",
              children: [
                /* @__PURE__ */ jsx196("path", {
                  d: "M897.7 136.1c0-4.3 2.9-9 5.8-9 3.3 0 5.7 5.7 5.7 9 0 3.9-2.9 7.2-5.7 7.2-3 0-5.8-2.8-5.8-7.2z"
                }),
                /* @__PURE__ */ jsx196("path", {
                  d: "M891.5 140c.5-4.8 3.8-8.6 6.7-8.2 2.9.5 4.3 6.3 3.8 9.6-.5 3.8-3.8 6.7-6.2 6.2-2.4 0-4.8-3.3-4.3-7.6zm12.9 1.4c-1-4.3 1-9 3.9-9.6 2.8-.4 5.7 4.3 6.2 8.2 1 3.8-1.5 7.6-3.9 7.6-2.3.5-5.7-1.9-6.2-6.2z"
                }),
                /* @__PURE__ */ jsx196("path", {
                  d: "M897.2 145.2c0-4.7 2.9-9 5.8-9 3.3 0 5.7 5.2 5.7 9 0 3.9-2.8 7.2-5.7 7.2-2.9 0-5.8-2.8-5.8-7.2z"
                }),
                /* @__PURE__ */ jsx196("path", {
                  d: "M888.6 147.6c0-4.3 3.4-9 6.2-9 3 0 5.8 5.7 5.8 9 0 3.9-3.4 7.2-5.8 7.2-2.8 0-6.2-2.8-6.2-7.2zm17.7-1.9c0-4.3 3-9 5.8-9 3.3 0 5.7 5.7 5.7 9 0 3.9-2.8 7.2-5.7 7.2-2.9 0-5.8-2.9-5.8-7.2z"
                }),
                /* @__PURE__ */ jsx196("path", {
                  d: "M904.4 149.6c0-4.8 3.4-9.1 6.2-9.1 3 0 5.8 5.2 5.8 9 0 3.9-2.9 7.3-5.8 7.3-2.8 0-6.2-3-6.2-7.2z"
                }),
                /* @__PURE__ */ jsx196("path", {
                  d: "M896.8 153.9c0-4.8 2.8-9.1 5.7-9.1 3.4 0 5.8 5.7 5.8 9 0 4-3 7.3-5.8 7.3-2.9 0-5.8-3-5.8-7.2zm-12 0c0-4.8 2.4-9.1 4.8-9.1s4.3 5.7 4.3 9c0 4-2.4 7.3-4.3 7.3-2.4 0-4.8-3-4.8-7.2zm26.8-.9c0-4.4 2.4-8.7 4.8-8.7s4.8 5.3 4.8 8.6c0 4.3-2.9 7.2-4.8 7.2-2.4 0-4.8-2.9-4.8-7.2z"
                }),
                /* @__PURE__ */ jsx196("path", {
                  d: "M914.5 161c1-4.7 3.8-8.6 5.7-8 2 .4 2.4 6.1 1.5 9.5-.5 4.3-3.4 6.7-5.3 6.2-2-.4-2.9-3.8-2-7.6z"
                }),
                /* @__PURE__ */ jsx196("path", {
                  d: "M905.4 159.6c.5-4.3 3.3-8.6 5.7-8.1 2.9 0 4.3 5.7 3.9 9-.5 4.4-3 7.3-5.3 6.8-2.4 0-4.8-3.4-4.3-7.7zM892 161c-1.5-4.7-4.4-8-6.3-7.6-1.9.5-2.4 6.2-1.4 9.6 1 3.8 3.8 6.2 5.7 5.7 1.5-.4 3-3.8 2-7.6z"
                }),
                /* @__PURE__ */ jsx196("path", {
                  d: "M888.6 160.1c0-4.3 2.4-8.6 4.8-8.6 2.9 0 4.8 5.3 4.8 8.6 0 4.3-2.4 7.2-4.8 7.2-2 0-4.8-2.9-4.8-7.2z"
                }),
                /* @__PURE__ */ jsx196("path", {
                  d: "M895.8 162c0-4.8 2.9-9 5.7-9 3.4 0 5.8 5.2 5.8 9 0 3.9-2.9 7.2-5.8 7.2-2.8 0-5.7-2.9-5.7-7.2zm2.4-52.7c-1 3.8-4.3 7.2-2 12.5-4.2-1.5-8-2-11.4 1.9 4.3-.5 8.1 1 10 3.8-3.8-.5-5.7 1.5-6.7 3.9 3.4-1 6.7-2 8.2-1.5-1.5 1.5-3.9 3.8-4.3 5.8 2.8-2.4 6.2-2 8.1-3.4-1.4 3.4 1.4 6.7 3.8 10-.4-4.7 2.4-8 1-10.5 4.3 1 4.8 4.8 11 4.8-2.4-1.4-3.8-6.2-6.7-6.2 1.4-.5 7.2-1 8.2 0-1-2-4.4-3.8-6.3-3.8 2-2 5.3-5.8 7.7-6.8-3.4.5-8.6 1-10.5 3.9 4.7-3.9 3.8-11 9-12-2.8-.5-7.1 1.4-10.5 4.8 1.5-2.9 1.5-6.7 3.4-7.7-3.9 1-8.2 5.8-9.6 8.2a18 18 0 0 0-2.4-7.7z"
                }),
                /* @__PURE__ */ jsx196("path", {
                  d: "M900.6 117c0 1.4 0 4.3-.5 5.2m6.7-5.7c-1 1-2.9 4.3-2.9 7.2"
                }),
                /* @__PURE__ */ jsx196("path", {
                  fill: "none",
                  d: "M909.7 122.2a7.6 7.6 0 0 0-3.4 4.4"
                })
              ]
            })
          ]
        }),
        /* @__PURE__ */ jsxs171("g", {
          id: "ky_svg__e",
          fill: "#059334",
          children: [
            /* @__PURE__ */ jsx196("path", {
              d: "M858.9 169.7c-3.4 0-6.2-1.4-8.2-3.8-3.3-4.4-12.4-6.3-16.3-2.4-1.4 1-3.3 1-4.7 1.4-2.4 0-5.3 2.4-4.4 7.2 2-1.5 2.4 0 3.9 0 1-.5.5.5.5 1.4 0 2.4 5.2 7.2 10 6.7 5.3 0 7.7 2 8.6 3 1.5 1.3.5.9 1.5 3.3 1.4 1.4 1.9 1.9-.5 3.8a9.7 9.7 0 0 0 0 14.9c6.2 4.7 22 12 39.8-2 17.2-13.4 44-5.7 46-1 2.4 4.9 3.3 7.7 3.8 10.1.5 2 2.9 3.9 6.3 3.4 3.3 0 7.1 1.4 9 2.9 2.5 1.4 5.8 1 4.9-3.4-2-13.4-10.1-15.3-11-21.5 4.7.4 8 .4 10-1.5 1.4-1.9 3.3-5.3 5.3-6.2 1.4-1 1.4-2-.5-1.5-2.4.5-3.8 1.5-8.2 1-22-2.4-83.8-19.2-95.8-15.8z"
            }),
            /* @__PURE__ */ jsx196("path", {
              fill: "#000001",
              d: "M956.7 186a34.8 34.8 0 0 0-9.2 9.6c-4.7 6.2-19.1 12.4-36.9 12.4-17.2 0-27.7-2.8-35.4-9a60.6 60.6 0 0 0-10.6-6.8c-5.2-2.4-6.2-7.7-4.8-12-1.4 2.4-2.3 4.8-5.2 4.3-2 0-5.8 0-4.8 2-.5-1-.5-2.4-1-3l-1-.9c1.5 1 4.9-1.9 7.3-1.9 1.9.5 4.3-1.9 3.8-4.8l-1.4-6.2c3.8-2 54.1 7.2 64.2 8.1 10 .5 38.8 4.8 35 8.2z"
            }),
            /* @__PURE__ */ jsx196("path", {
              d: "M865.6 167.8c4.8-4.8 10.5-7.2 16.3-5.8h1.4c3-2.4 9.6-2.9 13.5-1h1.9c5.7-1.9 16.7 0 20.6 3.9l1.4 1c13-1 20.6 4.7 29.7 13.9 1 1 2.4 2.8 4.8 3.3 2.9.5 3.4 2 1 3.4a37.8 37.8 0 0 0-10 9c-4.4 5.8-18.3 11.6-35.6 11.6-16.7 0-26.8-3-34.5-8.7-4.3-3.3-7.6-5.2-10-6.7-2.9-1-6.7-4.8-5.3-8.6 1-3.8-1.4-8.6-3.3-13.4 1.4-1 5.2-2.4 7.1-1.4z"
            }),
            /* @__PURE__ */ jsxs171("g", {
              fill: "#00493d",
              children: [
                /* @__PURE__ */ jsx196("path", {
                  d: "M950.4 179.8c-9-9.2-16.7-14.9-29.7-14 0 .5 0 2-.5 3a66.3 66.3 0 0 1 23.5 17.7c2-2 5.3-4.3 6.7-6.7zm-31.1-14.9c-3.9-3.8-14.9-5.8-20.6-3.8 0 1.9 0 4.8-1 6.7 3.4 1.4 6.2 4.8 9.1 8.1 2-.5 6.7-1.9 9.1-2.4a44 44 0 0 0 3.4-8.6zm-22.5-3.9c-3.9-1.9-10.6-1.4-13.5 1-1 2-1.4 5.8-1.4 7.7 2 0 4.8 1.4 5.7 2.4 3-1 6.8-2.9 8.2-4.3.5-2 1.4-4.8 1-6.7zm-31.2 6.8c4.8-4.8 10.5-7.2 16.3-5.8-1 1.5-1.4 4.3-1.4 7.2-5.3-.5-12 1-14.9 2.9z"
                }),
                /* @__PURE__ */ jsx196("path", {
                  d: "M941.8 187.4a64.2 64.2 0 0 0-22-16.8c0 .5-1 2.4-1.5 3.9 2.9 4.3 8.6 13.9 11 19.2 2.4-1 9.1-3.9 12.5-6.3zM905.4 198a179 179 0 0 0 1.4-19.7c2.4-.5 7.2-1.9 9.1-2.4 2.4 3.9 8.2 14 10.6 18.7-5.8 1.4-15.4 3.8-21.1 3.4zm-16.8-23c2.4-1 5.8-3 8.1-4.8 2 1.4 5.8 4.8 7.2 6.7 0 4.3-1.4 16.8-1.9 21-3.8 0-10-.9-13.4-2.8.5-7.2 1-15.3 0-20.1zm-24 5.7c.5-1 1-4.3 1-5.7 3.8-2.4 13.4-4.8 20.6-1 .5 4.8 0 16.8-.5 19.7a96.4 96.4 0 0 0-21-13z"
                })
              ]
            }),
            /* @__PURE__ */ jsxs171("g", {
              fill: "none",
              children: [
                /* @__PURE__ */ jsx196("path", {
                  fill: "#000001",
                  stroke: "none",
                  d: "M840.7 172c-1 0-1.5-2.8-3.4-2.8-.5 0-1.9.5-2.4 0 0 1 .5 2 1 2.4.5 1.4 2.9.5 4.8.5z"
                }),
                /* @__PURE__ */ jsx196("path", {
                  d: "M840.7 180.2c5.7 0 6.7-7.2 9.6-7.6m-6.3 8.1c4.3 2 7.7-8.1 11-7.7m-19.6-4.7c1.4 0 2.4-2 4.8.4 1 1 2.4 1.5 3.4 1.5m-1 5.2c-2 3-5.3 4.8-7.2 3.9m-1-15.8c-1.4 1-2.3 2.8-3.3 4.3m-1.4 2.8v2.4"
                })
              ]
            })
          ]
        })
      ]
    }),
    /* @__PURE__ */ jsxs171("g", {
      strokeWidth: 1.4,
      transform: "translate(-306.8 -21.2) scale(.87136)",
      children: [
        /* @__PURE__ */ jsx196("path", {
          id: "ky_svg__a",
          fill: "#fff",
          d: "M989.7 233v93.4c0 81-38.3 108.8-89.6 130.8-51.3-22-90-49.8-90-130.8v-93.5h179.6z"
        }),
        /* @__PURE__ */ jsx196("path", {
          fill: "#c8102e",
          d: "M900.1 312c4.3 0 11-3.8 16.8-9.6 6.2-6.7 16.8-9 27.8 0 11 9.1 17.7 5.3 23.5 0 5.7-5.2 10.5-7.2 21.5-7.2V233H810v62.3c11 0 15.8 2 21.6 7.2 5.7 5.3 12.4 9.1 23.5 0 11.5-9 21.5-6.7 28.2 0 5.3 5.8 12 9.6 16.8 9.6z"
        }),
        /* @__PURE__ */ jsx196("path", {
          fill: "#0b50a0",
          d: "M900.1 360c5.8 0 17.3-6.3 20.1-7.7 10.6-6.3 18.2-.5 24.5 2.4 6.7 2.8 19.1 6.2 26.8 0 7.7-6.3 12-5.8 17.3-5.8 1-7.2 1-14.4 1-22.5v-5.8c-6.8-1.4-10.1.5-17.3 6.8-7.2 6.2-15.4 4.8-26 1-10-4.4-20-12-30.1 0a24.2 24.2 0 0 1-16.3 8c-7.2 0-13.4-4.7-16.3-8-10.5-12-20.1-4.4-30.2 0-10.5 3.8-19.2 5.2-26.3-1-6.7-6.3-10.1-8.2-17.3-6.8v5.8c0 8.1.5 15.3 1.4 22.5 5.3 0 9.2-.5 16.8 5.8 7.7 6.2 20.6 2.8 26.9 0 6.7-2.9 14.3-8.7 24.9-2.4 2.9 1.4 13.9 7.6 20.1 7.6zm0 20.6a51 51 0 0 0 23.5-7.2c9.6-5.3 16.3-3 25.9 1.9 10 4.8 18.2 3.3 24 0 2.8-2 5.2-5.8 11.4-4.3-2.8 12-7.2 22.5-12.4 31.1a32.5 32.5 0 0 1-25-1.9c-10-4.8-22.5-7.7-29.2-3.4a36 36 0 0 1-18.2 5.8c-5.3 0-12-2-18.2-5.8-6.7-4.3-19.2-1.4-29.2 3.4a32.5 32.5 0 0 1-25 2c-5.2-8.7-9.5-19.3-12.4-31.2 6.2-1.5 8.6 2.4 11.5 4.3a23.9 23.9 0 0 0 23.5 0c10-4.8 16.7-7.2 26.3-2a51 51 0 0 0 23.5 7.3m0 76.6a191.9 191.9 0 0 0 51.3-29.7c-3.9-1.4-6.2-.5-9.6-2.9-3.4-2.4-13.4-3.3-22 1.5a39 39 0 0 1-39.3 0c-8.7-4.8-18.7-3.9-22-1.5-3.4 2.4-5.8 1.5-9.7 3a184.7 184.7 0 0 0 51.3 29.6"
        }),
        /* @__PURE__ */ jsxs171("g", {
          stroke: "#000",
          children: [
            /* @__PURE__ */ jsx196("path", {
              fill: "#f9d050",
              d: "M887.6 256.4c.5 1-.4 3.4 0 4.3 1 2 1 3 2.4 3.9h3.4c10.5 0 23-4.3 33.5-4.3 10.1 0 16.3 3.3 22 3.3 3.4 0 6.3-2.4 6.3-4.8s-3.8-3.8-12-3.8c-11.5 0-17.7 2.9-27.3 2.9-14.4 0-16.8-5.3-16.8-7.7 0-2.4 2.4-5.7 10.1-5.7 2.4 0 4.3-.5 5.3-1.5.5-1 1.9-2.9 4.8-4.3 3.3-2 10 0 13.4-2.4 0 2-2.9 4.8-5.3 5.8 4.8-1.5 10-1.5 11 2.4-2.4-1.5-6.2-.5-7.6 0-2 .4-2.9 1-4.8 1.4 1.9-.5 2.9 3.3 5.7 3.3-2.8 2.4-7.6 2.4-12.4.5-1.5-.5-5.3-1.9-7.7-1.9-4.8 0-7.7 1-7.7 2.9 0 2.4 3 3.8 11.5 3.8 8.7 0 13.5-2.4 26.4-2.4-1-1.4.5-2.9-1.4-4.3 4.8 0 10 1.4 12 4.8-.5-3.4 2.3-6.2 1.4-9.1 2.9.5 5.3 3.3 5.7 5.7 0-1.4 2-1.4 2-2.8a7.4 7.4 0 0 1 3.8 7.6c1.4-2.4 2.9-1.4 3.8-4.3 1 2 .5 7.7-2.9 9.6 3-2 7.2-2 10.1 1.4-2.9-.4-4.3 1-5.7 1.5A44.4 44.4 0 0 1 948 267c-7.6-.5-8.6-2-13.4-2 2.9.5 8.6 6.3 14 6.3 3.3 0 5.7 0 7.1-.5 1.4-.5 3.8 0 5.7 1 1.5 1.4 4.4 2.8 6.3 2.4-.5 1.9-1.5 2.8-2.9 3.3 2.4 1.5 1 2.4 3.4 4.3-1 0-2 1-3.4.5 1.4 1.4 1.4 3.4 2.9 4.3-.5 0-2 .5-2.9 0 1.4 2 0 4.3 1.4 5.3 1.5 2-1.4 4.3-3.8 2.4.5 1.4-1 2.9-2.4 2.4s-2.4-2-2-2.4c0-.5 0-.5.6-1-1 1.5-2.9 1.5-3.9 1-.4-.5-1-1-1-1.4-3.3 1-4.7-2-4.2-3.4.4-1.4 3.3-2 4.3-1.4 1 .4 1.9 1 2.9 0 1-.5 1.4-1.5 1.4-2.4 0-1.5-1.4-5.8-7.7-5.3-7.2.5-18.7-1.4-24.4-3.4-.5-.4-1-.4-1.5-1 0 2-1.9 3-1.9 4.9 0 2.4 1 4.3 3.9 5.2-1.5 2.4-3.9 2-4.8.5 0 1.5-2 2.4-2 4.3-.4-1-1-1.4-1.4-2.4-1.4 3.4-5.3 5.3-7.2 4.4-2.4 1.9-5.2 1.4-6.2-.5-1.4 1-3.4 1-4.3 0 0 1.4-1 1-1.5 2.9 0 1-1.9 1.4-2.8 1-1-.6-1.5-2.5-.5-3.4-1.4 1-2.9 1-3.8 0 0-1 0-2.4 1-3h.9c-1-.4-2.4 0-3.4-.4-1-1-1-2-.5-2.9.5-.5 2-1.4 3-.5l.4.5c0-1 .5-1.9 1-1.9 1-.5 2.3-.5 3.8 1 1 1.4 1.9 1.4 4.8 1 2.4 0 6.2-2.5 9-4.9-8-1.4-3.3-6.7-.9-8.6-1.9-.5-4.8-.5-6.7.5-10 5.3-20.6 11.5-27.3 9.6a6 6 0 0 0 1 2.8c-1.5 0-4.4 0-5.3-1.4-.5 1-1.4 3.4-.5 5.3-1-1-3.8-2-5.3-2.4 1 1 0 2.9.5 4.3-1.4-1.4-3.8-2.4-4.8-1.4s-2.9 1.4-4.3 1a7.5 7.5 0 0 1-3.8 2.8c0-1 0-2.4-.5-2.9-.5 1.5-2 3.4-3.8 4.3 0-1 0-2.4-.5-3.3 0 1.9-3.8 2.9-4.3 4.3.5-1.4.5-2.9.5-3.8a7.3 7.3 0 0 1-4.8 3.3c.4-1 1-2 .4-2.9-.4 2-3.3 3-5.7 2.4 0 1-2 2.4-4.3 1-1.5-.5-2.4-2-1.5-2.9-1.9 0-3.8-1.9-2.8-3.3 0-.5.4-1 .4-1.5-1.4-1-1.9-2.9-.4-4.3.4-.5 1.9-.5 2.8-.5 0-3.8 3.4-3.8 4.8-1 1 1.5 3.9 3.9 6.3 3.4 1 0 1.4-.5 2.4-.5a43 43 0 0 0 12-6.2c.4-1.4.4-2.4.4-3.3-1.9 1-3.8 1.9-4.8 3.3v-1.4c-1.4 0-3.8-.5-4.8-.5.5-.5 1-2.9 2-3.4-2.4.5-4.8 0-6.8-.4 1-1 1-2.4 1.5-3.9-1 .5-3.4-.4-5.3 0 .5-1.4 1-3.3 2.4-3.8-2 .5-4.3 0-6.7-1 2 0 2.9-2.4 4.3-2.4-3.8 0-4.8-1.9-6.7-2.8 1.4.4 2.4-1 3.8-1-1.4-.5-3.8-2.9-2.8-4.3-.5.5-1 1.4-2 2-1 .4-2.8 0-4.3-1.5-1-2-.5-4.3 1.5-4.8a2.3 2.3 0 0 1-1.5-3.9c.5-1 2.4-2.3 3.4-1l1.4 2c-.5-1-.5-2.9-.5-4.3.5-1.4 1.5-1.4 3-2 1.3 0 2.3 1.5 2.3 3 0 1.4.5 2.3 1 4.3l.4-2c0-1.9 2.4-1.4 3.9-1 1.4.6 1.9 3.4 0 4.9-1 1-.5 2.4.5 3.3 3.3 5.3 9 9.6 13.9 10.1 0-2 1-3.8 2.4-5.3 0-1 .4-2.4 1-3.3.4-2.9 1.8-4.3 3.7-3.4-.4-.5-1-1-1-1.4-1.4-1.5-2.8-3.9-1.8-5.8 1-1.9 3.8-1.4 4.8-.4-.5-3 2.8-5.3 2.8-6.8.5 1.5 1.5 3.4 1 4.8.5-1.9 3.8-4.3 6.2-5.2-1 1.4 2 3.8 1.5 5.2 1-2.4 4.8-3.8 7.6-3.8-1 1-1 2.9-1 3.8 1.5 0 4-.4 4.9-1.9 0 2-1 3.9-2 4.8.5-.5 2.4-.5 3.9-.5-1.5 1.5-1 3-2.4 3.9 1.9-1 4.3-1 4.8 1 1 1.4-.5 3.8-1.5 5.2-1 .5-1.9 1.4-2.4 1.4z"
            }),
            /* @__PURE__ */ jsxs171("g", {
              fill: "none",
              children: [
                /* @__PURE__ */ jsx196("path", {
                  d: "M858 262.2c-3.4 1.4-4.4 4.8-4.9 6.7"
                }),
                /* @__PURE__ */ jsx196("path", {
                  d: "M857.5 265.5c-4.8 3-6.8 5.3-5.8 10.6m8.1 3.9c3-1 4.8-2 7.2-6.3"
                }),
                /* @__PURE__ */ jsx196("path", {
                  d: "M865.6 275.6c-1 2 0 5.3-1.4 6.7a8.8 8.8 0 0 0 4.8-6.7"
                }),
                /* @__PURE__ */ jsx196("path", {
                  d: "M866.6 280.9c1.9-1 4.8-3.9 6.2-7.2-.5 1.4 0 3.8-1 5.3 2.4-2.4 3.4-3.9 3.9-6.3l.4 2c1-1 2-2 2-3.9m-.1 1.4v2.4c2-1.4 2.5-3.3 2.5-5.7"
                }),
                /* @__PURE__ */ jsx196("path", {
                  d: "M880 271.8c2.9-2 3.3-4.8 3.3-9.1m0 4.8c2-1.5 2.4-2.4 2.4-6.8m-6.2-12.9c-1 0-2 .5-2 2 0 .9-1.4 2.3-1.4 3.8-.4 1.9-1.4 2.4-2.8 1.9-1.5-1-1.5-1-1.5-2.4 0-2 2.4-2.4 2.4-4.3.5-1 1-2.4 1.5-2.4-2.4 1.4-5.8.4-6.3-2.4"
                }),
                /* @__PURE__ */ jsx196("path", {
                  d: "M883.8 249.2c-1 .5-2-1-3.3-.4-.5 0-2 .4-2.4 0"
                }),
                /* @__PURE__ */ jsx196("path", {
                  d: "M877.1 251.6c.5.5 2.9 1.5 5.3.5-2 .5-3.4-1.9-1.5-3.3m-8.1-2c-2 0-3.4 1.5-2.9 3 .5 1.4 2.4 1.4 3.8.4m-4.3 20.6c.5-.5 1-1.4 1-2 1 0 2-.4 2.4-.9 1.9 0 3.3-1.4 3.8-2.8 1 0 1.5-2.4 2-3.4.4.5 1.4 0 1.9-2 1 .6 2.4 0 2.8-1.4m-19.6-3.3c0 .5-1 1.4-2 2 .5.9 0 3.3-.9 3.7.5 1 0 2.4-.5 3.4 0 .5.5 2 .5 2.4m4.8-21.1c-1 2.4-.5 5.3 1.4 5.8"
                }),
                /* @__PURE__ */ jsx196("path", {
                  d: "M866.6 253c-.5 2.5-.5 5.8-1 7.3-.5 1-1.4 4.3 2.4 5.2 4.3 1 6.7.5 9.1-6.7m7.2 18.7c0 .5-.5 1.5-1.4 1.5m4.7-2.4c0 1-1 2.4-1.4 2.8m4.8-3.8c0 1 0 2.4-1 2.9m-28.2-32.6c.4 0 1 1 1.4 1.9-1.4-1-2.9 1.4-2 2.9m-.9 3.3-1.9 1.5m.5 2.8c-.5 0-1 .5-1.4.5m-21.6-9.1c0-.5 0-.5.5-1m-4.8-.4c-.5 0-.5 0-1-.5m1.4 7.2h1m-2.9-2.9a5 5 0 0 0-2.8-1.4m29.2 19.2c-3.4 2.8-4.8 5.2-5.3 8.6m8.6-6.3a11 11 0 0 1-3.8 4.4m-14.8 10a11 11 0 0 1-9.6-1.4c-.5-.5-1-.5-1.5-1m25.4-4.2c-.4 1.8-1 4.2-1.9 4.7 3.9-2 7.2-4.8 7.7-9.1M827.7 289c1.5-.5 3 .5 3.9-.5m79.5-15.3c1 .5 2.4 1 2.9 1.4.5-1 2.4-2.4 3.8-2.8m-40.7 11.5c-.5-2 .5-4.3 3.4-5.3m-22.1 13.4c.5-1 .5-2.4 1-3.3m-22.1 4.8c-.5 1-1.4 1.9-1.4 2.8m-5.8-1.9s0-.5.5-.5c1-.4 2.4-1.4 2.9-2.4m61.8-3.8c-1 .5-1.4 0-1.9-.5m1.4 2.9s-.4.5-1 .5m3.4 1.9c-.5.5-1 1-1.4 1m15.3 0c1-.5 1.5-1.5 2-3.4m-8.2 2.9c1.4-.5 2.4-1.5 3.8-2.9m9.6-1c0-1 0-1.9.5-2.8m35 7.2c-1-1-1-2.4.5-3.4 1-.5 1.4-1 2.4-1.4"
                }),
                /* @__PURE__ */ jsx196("path", {
                  d: "M924.5 276c-7.6-3.3-7.1-7.6-13.4-7.1m47.5 22.1c.5.4 0 1.9 0 2.3m4.3-2.3c-.5 1.4-.5 1.9-.5 3.3M926 245.9h-4m-36.3 16.3c0 1 1.5 2.9 5.3 2.9-.5 0-1-.5-1-.5m-2.4-8.2c-.4.5-1 0-1 0-.9-1 .6-2.8 2-3.8-1.4.5-2.4.5-3.4.5-1 2.9-3.8 4.3-5.7 2.4-.5 1.9-2.9 4.3-4.8 3.8-2-1-2.4-2.4-2-3.8-2.3 2.8-5.2 1-6.1 0-.5-1 0-3.4 1-6.3"
                })
              ]
            }),
            /* @__PURE__ */ jsx196("path", {
              stroke: "none",
              d: "M918.3 274.6c-1.4 1-2.9 0-4.3 1.5-1 1 .5 1.4 1.4 1.4-.4 1.5-.4 2 2 2-1 1.4 1.9 1.9 1.4 3.8a4.6 4.6 0 0 0 1-4.8c-.5-1.5-3-2.4-1.5-3.9"
            }),
            /* @__PURE__ */ jsx196("path", {
              fill: "#073163",
              stroke: "none",
              d: "M874.7 259.3c-2-1-2.4-2.4-2-3.8-.4 1-1.3 1.4-2.3 1.4-2 4.3-4.3 8.2-7.2 8.2-3.4.4-2.9 3.8-.5 3.8 5.3 1 7.7-1 12-9.6m-47.4-11.5c1.4-1.4.4-2.9-.5-3.3-1.5-.5-4.3 0-5.8 2.3 1.5-.4 3-.4 3.4.5.5 1 1.4 2 2.9.5m2.4-8.6c3.3 0 4.3.5 4.7 1.9.5 1-.4 2.4-1.4 2.4-1.4 0-2.9-1-2.4-1.4.5-1 .5-2.4-1-3zm9.5 7.6c2.4.5 3.4-1 2-2.8-.5-1.5-2-2.4-4.4-2 2.4 1.5 0 3.9 2.4 4.8m-17.7 8.2a4 4 0 0 0 4.8 2c1.4-.6 2-2 1.4-3-1-1.4-2.4-1.9-2.8 0-1 2-2.4 1.5-3.4 1m7.2 29.2c-1-1.9-3.8-1.9-6.2 0 1-.5 2.8 0 3.3 1s1.5 1 2 1c.4-.5 1.4-1 .9-2m3.8-2.8c0-2.4-3.3-3-5.2-2 1 0 2.4 1 2.4 2 .4 1 1.4 1.4 1.9 1.4 1-.5 1.4-1 1-1.4zm-4.8 8.6c-2.8-.5-4.3 2.9-4.3 5.2.5-1.4 2-2.3 3.4-1.9 1.4 0 1.9-.4 1.9-1.4.5-1 0-1.4-1-2zm.5 8.1c1 .5 2-.5 2.4-1.9 0-1 2-1 2.4-.5 1 .5 1 2.4-.5 3.4-1 .5-3.3 1-4.3-1m66.6-14.4c-1-.4-3.3-1.4-5.2 0 1.4-.4 2.4.5 2.8 1.5 0 1 1.5 1.4 2 .5.4-.5 1-1.5.4-2m-4.3 3.4c-1.9-1-4.3 1.4-4.8 3.4a7 7 0 0 1 3.4-1.5c1 .5 1.9 0 1.9-1 .5-.4.5-.9-.5-.9m2.5 3.9c-1.5 0-3.4 1.9-3.4 3.8.4-1 1.4-1.5 2.4-1 1 0 2.4-.5 2.4-1.4 0-1-.5-1.5-1.5-1.5zm4.2 3.8c-1-.5-2.4 0-2.4 1.4s0 2.9-.4 3.4c1-1 1.9-1.5 2.8-2 .5-.4 1-1.9 0-2.8m54.2-4.3c-1-1-2.4-.5-2.9.4-.5 1-1 3.4 0 5.3 0-1 1-2.4 2-2.4 1.4-.5 1.8-2.4.9-3.3m2.9 1.9c-2 1-2 4.3-.5 6.2 0-1 .5-2.4 1.4-2.9 1.5 0 2-1.9 1.5-2.8-1-1-2-.5-2.4-.5m5.7 1.9c-1-.5-2 .5-2 1.4-.4 1.5.6 3.4 2 4.3 0-1 .5-1.9 1-2.4 1.4-1 1-2.8-1-3.3m4.3-.5c-1 0-1.9 1.4-1 2.9.5 1 1.5 1.4 3.4 1-.5 0-1.4-1.5-1-2 .5-1 0-1.9-1.4-1.9"
            })
          ]
        }),
        /* @__PURE__ */ jsxs171("g", {
          id: "ky_svg__h",
          children: [
            /* @__PURE__ */ jsx196("path", {
              fill: "#f9d050",
              d: "m831.1 383.4 24-73.8 24 73.8-62.9-45.5H894Z"
            }),
            /* @__PURE__ */ jsx196("path", {
              fill: "#024919",
              d: "m835.9 376.7 49.8-36.4h-61.3l49.3 36.4-18.6-58.4z"
            })
          ]
        }),
        /* @__PURE__ */ jsx196("use", {
          xlinkHref: "#ky_svg__h",
          width: "100%",
          height: "100%",
          x: 90.1
        }),
        /* @__PURE__ */ jsx196("use", {
          xlinkHref: "#ky_svg__h",
          width: "100%",
          height: "100%",
          x: 45,
          y: 52.2
        }),
        /* @__PURE__ */ jsx196("path", {
          fill: "none",
          stroke: "#000",
          d: "M989.7 233v93.4c0 81-38.3 108.8-89.6 130.8-51.3-22-90-49.8-90-130.8v-93.5h179.6z"
        })
      ]
    })
  ]
});
var Ky_default = SvgKy;

// src/country-flag-icons/generated/Kz.tsx
init_esm_shims();
import { jsx as jsx197, jsxs as jsxs172 } from "react/jsx-runtime";
var SvgKz = (props) => /* @__PURE__ */ jsxs172("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx197("path", {
      fill: "#00abc2",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsxs172("g", {
      fill: "#ffec2d",
      children: [
        /* @__PURE__ */ jsxs172("g", {
          transform: "matrix(.48 0 0 .48 345.8 201.6)",
          children: [
            /* @__PURE__ */ jsx197("circle", {
              r: 134.6
            }),
            /* @__PURE__ */ jsxs172("g", {
              id: "kz_svg__c",
              children: [
                /* @__PURE__ */ jsxs172("g", {
                  id: "kz_svg__b",
                  children: [
                    /* @__PURE__ */ jsx197("path", {
                      id: "kz_svg__a",
                      d: "M0-152.9c8-.1 11-5.1 11-11.1 0-8-11-46.1-11-46.1S-11-172-11-164c0 6 3 11.1 11 11.1"
                    }),
                    /* @__PURE__ */ jsx197("use", {
                      xlinkHref: "#kz_svg__a",
                      width: "100%",
                      height: "100%",
                      transform: "rotate(90)"
                    }),
                    /* @__PURE__ */ jsx197("use", {
                      xlinkHref: "#kz_svg__a",
                      width: "100%",
                      height: "100%",
                      transform: "scale(-1)"
                    }),
                    /* @__PURE__ */ jsx197("use", {
                      xlinkHref: "#kz_svg__a",
                      width: "100%",
                      height: "100%",
                      transform: "rotate(-90)"
                    })
                  ]
                }),
                /* @__PURE__ */ jsx197("use", {
                  xlinkHref: "#kz_svg__b",
                  width: "100%",
                  height: "100%",
                  transform: "rotate(22.5)"
                }),
                /* @__PURE__ */ jsx197("use", {
                  xlinkHref: "#kz_svg__b",
                  width: "100%",
                  height: "100%",
                  transform: "rotate(45)"
                }),
                /* @__PURE__ */ jsx197("use", {
                  xlinkHref: "#kz_svg__b",
                  width: "100%",
                  height: "100%",
                  transform: "rotate(67.5)"
                })
              ]
            }),
            /* @__PURE__ */ jsx197("use", {
              xlinkHref: "#kz_svg__c",
              width: "100%",
              height: "100%",
              transform: "rotate(11.3)"
            })
          ]
        }),
        /* @__PURE__ */ jsxs172("g", {
          transform: "translate(-172.8) scale(.48)",
          children: [
            /* @__PURE__ */ jsx197("path", {
              d: "M1075.8 655c-3.5 6.3-5.6 13.6-10 19.3-13.6-12.3-33.2-12-50.4-12.7-14.2-.8-29.6-2.1-40.6-12.2-11.5-9.5-21-21.7-33.8-29.4a83.2 83.2 0 0 1-33.1-15.3c-20.2-16.5-31.8-41-51.6-58-3.7-3.6-8.2-6.5-12.4-9.6-4 1-2.2 9.6-7.1 5.2-2.7-2-9.4-2.1-10 .6 6 8 12.1 17 13 27.2-4.2.4-11.5-.9-13.5.6a84.3 84.3 0 0 0 20.4 21.3c-3.8.6-11.3.3-12.8 1.8a59 59 0 0 0 26.8 14.7c2 2.8-3.1 8.2 1.3 10.6 2.5 1 10.9 2.8 5.1 5.7-4 2.6-2.5 8.9 2.6 8.7 3.2 1.7 10.4 2 11 5-2.9 2.8-11.7 6.2-4.2 9a52 52 0 0 0 23.1 6.7c-4 3.4-9 5.3-13.1 8.5 18.5 10.9 39 18 59.4 25 8 2.6 16.3 5.1 24.7 6.7-24.4-1.4-48-8.6-70.2-18.5-11.5-5-23-9.9-34.8-14.2 5.1-2.7 11.1-3.4 16.5-5.7-11.2-2.2-23.3-3-33-9 1.4-2.8 7-2.9 10.2-4.3 6-1.4 9.6-3 1.3-3.6-8.4-2.3-18-1.3-25.5-6.3.5-3 8.3-2 11.4-3.3 4-.7 8.4-1.3 11.6-4-13-5.3-30-1.5-40.2-13-2.3-4.4 7.3-.9 10-1.6 7 0 14.5 2.2 21.2-.6-19-8.3-39.3-16-53.7-31.4-1.6-2.5-6.4-9.3-2.5-10.1 11.2 1.5 19.3 13.7 31.4 11.8 1.6-2.1-7-5.6-9.2-8.7a229.4 229.4 0 0 1-46.8-51c-.8-6.7 9.5-7.7 12.2-2.6 13.4 13 25.5 28 42.2 36.8 6 2.9-3.4-3.4-4.6-5.7a298.7 298.7 0 0 1-40.9-57.9c-2-3.8-5.1-10.7.7-12.7 5.7-2.9 11.5 1 14.4 6 11.3 14.3 19.7 31.3 33.8 43.2-12-23.3-24.9-48-25.2-74.8.3-5.2.6-13 7.7-12.9 6-.9 5 6.7 7 10.3 5.8 19.8 8.3 41.2 20 58.6-2.5-14.6-6.4-29.7-3.8-44.6.6-5 6-6.4 9.7-3.4 2.9 7 3.5 15.9 6.1 23.5a237 237 0 0 0 93 127.2 244.7 244.7 0 0 0 123.3 42.3c4 .4 8 .5 11.9.7m136.4 91.1c-7.2 4.4-12.8-3.4-18.8-5.7-4.4 2.4-4.8 10.2-8.8 14-4.8 5.5-10.8-1.6-10.3-7-5.8 4.9-8.7 16-18 14.4-4.5-3.6-7.8-11.2-11.2-2.5-2.7 4.2-10 10.2-13.9 3.8-1.2-5.6-4-12.2-7-3.3-2.2 6.4-9 11-15.4 8.2-3.6-2.9 2.8-13.7-1.7-13-6.8 4.6-10.8 15.7-20.3 14.8-3.7-4 2.3-11.1-1.8-15.7-4.7 6.1-10 15.1-18.3 15.7-4-3.2.2-12.5-2.4-13.8-8.4 5-17.4 14.1-28 11.3 4.1-16 21.5-21.5 36-22.7 25.1-3.1 51.5 2.6 75.7-6.5 3.9-2.4 13.3-5.7 10-11.2-3-4.4 7.7-2.7 8.7-7.8-.6-6.4 5-5.5 10.4-6 24.4-1.1 48.5 4 72.8 4.9 1.8 11.8-11.3 20.1-22 16.5-5 .8-12.5-11.6-11-2.6-1 4.8-.4 11-4.7 14.2m-207.4-24.2c5.6 5.1 9.6-1 14.9-3.3a197 197 0 0 0 48.3-27.3c9.2-7.6 17.2-17.5 29.6-20 24.2-7.3 49.9-6.4 74.1-13.2 18.5-25.2 49.8-34.3 76.1-48.8 5.9-1.8 8.2-6.7 10-12 10-15.9 23.7-29.9 39.9-39.5a37.2 37.2 0 0 1 25.4-4.6 42.4 42.4 0 0 1-13.7 26.5c5.9-.1 11-3.8 16.8-3.6 2 10.6-9.4 16.1-15.5 22.7 3.4.8 16.4 1.8 9.3 5.2-9 6.2-19.3 10.5-27.6 17.8 7.7 1.4 8.6 3 .8 5.8-4.3 2.8-12.4 3.8-13.2 9.4 5.8 3.6-2.6 7-5.9 8.2-6.2 1.5-12.8 4.2-4.5 9-3.1 4.7-9.9 5.7-15.4 5.2 1.7 5.4 4.1 11.4-2.8 13.8a107.7 107.7 0 0 1-53.6 22.4c24.5 1.8 49.8-2.7 70.7-16 2.8-3.3 17.3-6.9 9.2-9.6-3.8-1.6-12-3.4-12.6-6.3 11.4-7 25.7-4.5 37.9-8.6.3-4-9.3-2.9-12.9-3.8-8.5-.7-8-2.9.2-3.7 10.4-2.8 22.2-3.3 31-10-7.1-3.4-16.1-.5-23.7-3.2 12.9-5.6 28.1-6.2 39.7-14.7 5.3-5.9-6.8-4-10.3-3.9-7.1 1.3-10.4-2.2-2.3-5.1 13.9-10.3 31.4-16.9 41.2-31.7 2.3-3.3 5.4-13.3-2-9.8-9.6 3.3-18.1 14.1-29.2 10.8 21.8-16.9 42.4-36 57.3-59.3.8-6.8-9.8-7.5-12.5-2.2-14 13.4-26.6 29.3-44.5 37.8a280.6 280.6 0 0 0 43.6-56.4c2.7-6 9.8-13.3 6-20-6.3-5.2-14.1-.4-17.3 5.7-10.9 14.2-19.1 30.7-33 42.3 12.1-23.3 24.8-48.2 25-75 0-5.6-1-13.8-8.6-12.7-6 1-4.5 10-7 14.5-5.4 18.4-8 38.3-19 54.3 2.5-14.9 6.8-30.5 3.5-45.5-1.6-6.8-12.5-3.9-11 2.8-13 65.9-57.3 123.5-115 156.8-26.5 15-56 24.6-86.2 29-8 1.7-16.8.7-24.5 3.5-18.8 14.3-30.1 38.4-53.8 45.9-10.7 5.3-24.5 6.4-32.1 16.2a8.6 8.6 0 0 0-.8 4.2m51.7-10.3c-3.6.2-7.1.6-10.6 1.7-4.7.7-9.2 2.3-13.8 3l-1.9.4-3.1.3a10.9 10.9 0 0 1 0 5.1 6 6 0 0 1-1.4 2c-.6.8-1.3 1.4-2.2 1.8a7 7 0 0 1-2.6.7c-.9 0-1.8 0-2.7-.4-.9-.3-1.7-.8-2.5-1.5l-2.8.5h-2.6l-2.8-1a16.1 16.1 0 0 1-2.6-1.3c-3.4 2-7.2 3.9-9.3 7.4a11 11 0 0 0-1.6 5.3c-.2 2.4.4 4.8 1.4 7 .4.6.7-2.3 1.8-2.7 1.9-1.6 4.3-2.7 6.7-3.3 2-1 1.7 0 .9 1.6-.2.9-1.3 4 .2 2.4a65 65 0 0 1 21.6-4.1c10.6-1.1 21.2-1.4 31.8-1.5l30 .6c4.8.2 9.6 1.2 14.3.4 1.1-.3 2.9-.3 3.6-1-2.2-1.2-4.7-1.3-7-1.6h-19.1c-5.3-.5-10.8-.6-15.8-2.6-1.4-.5-2.6-1.8-3.9-.4a24 24 0 0 1-5.9 1.3c-3.5.2-7-.5-10.2-1.8 2.3-3.2 5.1-6 7.7-9l-6.2-1.3c3.7-2.5 7-5.4 10.6-8"
            }),
            /* @__PURE__ */ jsx197("circle", {
              cx: 1020,
              cy: 720.9,
              r: 2.4
            }),
            /* @__PURE__ */ jsx197("circle", {
              cx: 1019.8,
              cy: 720.5,
              r: 1,
              stroke: "#ffec2d",
              strokeWidth: 0.4
            })
          ]
        }),
        /* @__PURE__ */ jsxs172("g", {
          transform: "scale(.48)",
          children: [
            /* @__PURE__ */ jsxs172("g", {
              id: "kz_svg__f",
              children: [
                /* @__PURE__ */ jsxs172("g", {
                  id: "kz_svg__e",
                  children: [
                    /* @__PURE__ */ jsx197("path", {
                      d: "M120 73s-9.6-8.2-12.9-4.1c-5.2 6.5 16.2 39 16.2 50.4 0 18.8-12.6 23.9-28 26.5-10.4 1.8-27.3-.7-27.3-.7 3.2-4.3 5.3-5.6 10.6-5.9-6-3-12-9.8-12-20.3 0-16.1 6.6-22.8 6.6-41C73.2 68 65 55 65 55c14.6 1.5 21.8 15 17.7 25.8a7 7 0 0 0 6.3-1.9c1 3-.6 6.5-2.9 9.5 1.8 1 3.2.4 6-.2-.2 3-2 6.4-6.6 9.5 13.2-3.4 21.2 5.7 21.2 15.3 0 7.3-5 12.5-10 12.5-1.6 0-4-.7-5.3-1.7-1 2-.4 4.7.5 6.7-3.6-1-6-3.2-4.3-7.7-2.8-.2-5-1.2-6.5-3 1.5-2 3.8-3 6.5-3-2-4.2.3-6.5 3.6-8.4 0 0-2.1 8.4 3.2 8.4 2.4 0 4.6-.7 4.6-4.3 0-3.1-2.7-7.4-9-7.1-6.2.3-11.3 4.3-11.3 14.3 0 9.2 7.5 13.8 17.3 14 8.8.4 15.5-4.4 15.5-13.5C111.5 108 94 80.4 94 69.6c0-8.1 7.2-12.7 14.4-12.7 9.2 0 17 9.2 17 9.2l-5.4 6.8z"
                    }),
                    /* @__PURE__ */ jsx197("path", {
                      id: "kz_svg__d",
                      d: "M122 292.1c0 20.3-18.2 30.7-32.5 30.7-19.2 0-29.5-11.5-29.5-26.6 0-8.5 1.6-13.9 5.5-22l44.2-91.7a27 27 0 0 0 2-12.2c0-8.2-8-14.9-16.3-15-7.6-.3-16 7-16 15.3 0 10.1 5.3 14.6 10.7 14.6 6.6 0 9.2-2.7 9.2-7.4 0-3.2-1.5-4.6-3.8-4.6-5.7 0-4 7.6-4 7.6a5.2 5.2 0 0 1-3.9-7 10.2 10.2 0 0 1-5.5-3.3c1.5-1.5 3.3-2.6 5.5-3-1.3-4.4.5-6.5 4.3-7.5a7.6 7.6 0 0 0-.5 4.8c6-1.8 15.3 1 15.3 11.4s-7.2 19.1-20.7 17c3.2 1.5 4.8 4.6 5.2 8.1-2.5-1-5.2-1-5.2-1 1.6 2.7 3.8 5 3.7 10.6-2.5-1.2-4.9-3.3-8-2 5 10-1.2 23.6-17 26.8 5.8-6.8 8.6-14 8.6-21.3 0-23.5-6.5-27.4-6.5-43.8a24 24 0 0 1 10.5-19.2v.3A14 14 0 0 1 68 145a62 62 0 0 1 34 .3 25 25 0 0 1 18 12 36 36 0 0 1 0 28.9c-6.3 13-35.7 75.6-44.9 95.2-2 4.2-3.1 8.6-3.1 13.4 0 12 11 16.2 17.2 16.2 7.5 0 15.2-5.7 15.2-12.8 0-4.5-2.5-7.3-6-7.3-8.5 0-8 7.2-6.3 11.8-5.3-2.4-8.3-6.6-7.5-11a14 14 0 0 1-8.4-4.8c2-2.6 4.6-4.6 8.4-4.7-1.7-6.9 3-9.8 7.5-11.4-1.4 5-2.4 10.9 6.3 10.9 6.3 0 11.2 1 14.1 5.2l.7-27c.4-8.1-10.8-8-18-5.5 2.7-9.3 8.2-14.4 21-13.1a10 10 0 0 1-6.4-9.8c0-7.6 6.2-16 10.2-18.5l2 79z"
                    }),
                    /* @__PURE__ */ jsx197("use", {
                      xlinkHref: "#kz_svg__d",
                      width: "100%",
                      height: "100%",
                      transform: "matrix(1 0 0 -1 0 645)"
                    })
                  ]
                }),
                /* @__PURE__ */ jsx197("use", {
                  xlinkHref: "#kz_svg__e",
                  width: "100%",
                  height: "100%",
                  transform: "matrix(-1 0 0 1 240 0)"
                })
              ]
            }),
            /* @__PURE__ */ jsx197("use", {
              xlinkHref: "#kz_svg__f",
              width: "100%",
              height: "100%",
              transform: "matrix(1 0 0 -1 0 1000)"
            })
          ]
        })
      ]
    })
  ]
});
var Kz_default = SvgKz;

// src/country-flag-icons/generated/La.tsx
init_esm_shims();
import { jsx as jsx198, jsxs as jsxs173 } from "react/jsx-runtime";
var SvgLa = (props) => /* @__PURE__ */ jsxs173("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx198("defs", {
      children: /* @__PURE__ */ jsx198("clipPath", {
        id: "la_svg__a",
        children: /* @__PURE__ */ jsx198("path", {
          fillOpacity: 0.7,
          d: "M0 0h640v480H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs173("g", {
      fillRule: "evenodd",
      clipPath: "url(#la_svg__a)",
      children: [
        /* @__PURE__ */ jsx198("path", {
          fill: "#ce1126",
          d: "M-40 0h720v480H-40z"
        }),
        /* @__PURE__ */ jsx198("path", {
          fill: "#002868",
          d: "M-40 119.3h720v241.4H-40z"
        }),
        /* @__PURE__ */ jsx198("path", {
          fill: "#fff",
          d: "M423.4 240a103.4 103.4 0 1 1-206.8 0 103.4 103.4 0 1 1 206.8 0"
        })
      ]
    })
  ]
});
var La_default = SvgLa;

// src/country-flag-icons/generated/Lb.tsx
init_esm_shims();
import { jsx as jsx199, jsxs as jsxs174 } from "react/jsx-runtime";
var SvgLb = (props) => /* @__PURE__ */ jsxs174("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx199("defs", {
      children: /* @__PURE__ */ jsx199("clipPath", {
        id: "lb_svg__a",
        children: /* @__PURE__ */ jsx199("path", {
          fillOpacity: 0.7,
          d: "M-85.3 0h682.6v512H-85.3z"
        })
      })
    }),
    /* @__PURE__ */ jsxs174("g", {
      clipPath: "url(#lb_svg__a)",
      transform: "translate(80) scale(.9375)",
      children: [
        /* @__PURE__ */ jsxs174("g", {
          fillRule: "evenodd",
          strokeWidth: "1pt",
          children: [
            /* @__PURE__ */ jsx199("path", {
              fill: "#EE161F",
              d: "M-128 384h768v128h-768zm0-384h768v128h-768z"
            }),
            /* @__PURE__ */ jsx199("path", {
              fill: "#fff",
              d: "M-128 128h768v256h-768z"
            })
          ]
        }),
        /* @__PURE__ */ jsx199("path", {
          fill: "#00A850",
          d: "M252.1 130c-7.8 15.5-13 15.5-26 26-5.2 5.1-13 7.7-2.6 13-10.5 5.1-15.7 7.7-20.9 18.1l2.6 2.6s10-4.8 10.4-2.6c1.8 2.1-13 10-14.9 11.3l-11 7c-13.1 10.3-21 7.7-28.7 23.3l26-2.6c5.2 18.2-13 20.8-26 28.6l-20.9 13c5.3 18.2 20.9 7.8 33.9 2.6l2.6 2.6v5.2l-26 13s-30.8 17.6-31.3 18.2c-.2 1 0 5.2 0 5.2 10.4 2.6 26 5.2 36.5 0 13-5.2 15.6-10.4 31.2-10.4a100.6 100.6 0 0 1-52 20.8v10.4c15.6 0 26 0 39-2.6l33.8-10.4c7.8 0 15.7 7.8 13 15.6-7.7 28.6-39 23.4-49.4 46.8L213 369c10.4-5.2 20.8-10.3 33.8-7.7 15.6 5.2 15.6 15.6 36.4 20.8l-5.2-13c5.2 2.6 10.4 2.6 15.7 5.2 13 5.2 15.6 10.4 31.2 7.8-13-15.6-15.6-13-26-23.4-10.4-15.6-15.7-39 0-41.6l18.2 5.2c18.2 2.6 18.2-2.6 44.2 7.8 15.7 5.2 20.9 13 39 7.8-7.7-18.2-36.3-31.2-54.6-36.4 20.9-13 15.6 5.2 44.3-2.6v-5.2C369.3 278 361.4 265 332.8 265l44.3-5.2v-5.2s-43.7-11.4-44.7-11.9c.3-1.3 1.4-3.3 4.3-4.5 8.3 5.4 33.3 4.8 34.8 4.7-.8-6.4-12.7-11.7-23-16.9 0 0-44.7-27.5-44.9-29.9.9-7 18.3 1.1 37 6.5-5.2-10.4-15.6-15.6-26-18.2l15.6-2.6c-10.4-23.4-36.4-20.8-52-31.2-10.5-7.8-10.5-13-26.1-20.7z"
        }),
        /* @__PURE__ */ jsx199("path", {
          fill: "#fff",
          fillRule: "evenodd",
          stroke: "#fff",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 3.2,
          d: "M224 303c1.9-6.1 4.4-11.6-7.2-16.9-11.6-5.3 5.8 21.1 7.2 17zm13.7-12.3c-2.3.3-3.6 8.8 1.1 11.2 5.2.8 1-11.1-1.1-11.2m13.5-1c-2.4.8-2.5 12.8 6 10.6 8.6-2.1 0-11.5-6-10.5zM267 259c1.8-3-.1-15-7.4-10-7.4 5.1 5 10.8 7.4 10m-16-10c2.3-.9 2.5-8.3-4-6.3-6.3 1.9 2.3 7.8 4 6.3m-14.4 2.9s-4.5-6.2-8-4.9c-4.3 4.2 8.3 5 8 4.9M187 271.7c1.9.2 16-2.3 20.9-7.8 4.9-5.5-25.1 2.3-25.1 2.4 0 .1 2.8 4.9 4.2 5.4m141.1-35c.7-1.3-7.5-7.1-12.4-4.8-1.3 4.3 12.4 5.7 12.4 4.8m-27.8-14c1.6-2.2-3.5-11.3-13.7-6.2-10.2 5 10.7 9.8 13.7 6.3zm-32.1-5.3s2.5-8.2 8.6-6.6c7 5.3-8.3 6.9-8.6 6.6m-6-6.2c-1-2.3-7.3-1-14.6 3.9-7.4 4.7 16.8 1.4 14.6-4zm18.7-22.1s6.5-3 8.5 0c2.7 4.3-8.6 0-8.5 0m-5.5-2.9c-1.3-2.6-8.5-2.9-8.3 1-1.2 3 9.4 2.4 8.3-1m-17.2 0c-.7-1.5-11 0-14 6.2 5 2.4 16.3-2.3 14-6.2m-22 6.3s-13.4 8.3-14.3 14.3c.4 5.2 16.8-9.4 16.8-9.4s1.4-5.8-2.4-4.9zm-14.9-7.5c.4-1.7 6.7-5.6 7.2-5.3.5 1.7-5.1 6.3-7.2 5.3m4.3 31.6c.3-2.5-16-2.3-9.9 5.2 5.2 6.3 11-4.1 9.9-5.2m-15 10.7c-.8-1.6-2-6-4.2-6.4-1.9 0-11.7 2-12.5 3.6-.4 1.3 4.1 9.4 5.6 9.6 1.8.7 10.9-6 11.2-6.8zm88.4 55.2c.5-1.8 17.3-7.5 23-2 6.8 9.3-23.4 5-23 2m46 10.9c3.7-6.2-11.3-13.6-17.6-6.5 2.2 8.5 14.6 11.6 17.6 6.5"
        })
      ]
    })
  ]
});
var Lb_default = SvgLb;

// src/country-flag-icons/generated/Lc.tsx
init_esm_shims();
import { jsx as jsx200, jsxs as jsxs175 } from "react/jsx-runtime";
var SvgLc = (props) => /* @__PURE__ */ jsx200("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs175("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx200("path", {
        fill: "#65cfff",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsx200("path", {
        fill: "#fff",
        d: "m318.9 42 162.7 395.3-322.6.9z"
      }),
      /* @__PURE__ */ jsx200("path", {
        fill: "#000001",
        d: "m319 96.5 140.8 340-279 .8z"
      }),
      /* @__PURE__ */ jsx200("path", {
        fill: "#ffce00",
        d: "m318.9 240.1 162.7 197.6-322.6.5z"
      })
    ]
  })
});
var Lc_default = SvgLc;

// src/country-flag-icons/generated/Li.tsx
init_esm_shims();
import { jsx as jsx201, jsxs as jsxs176 } from "react/jsx-runtime";
var SvgLi = (props) => /* @__PURE__ */ jsxs176("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx201("path", {
      fill: "#002b7f",
      d: "M0 0h640v240H0z"
    }),
    /* @__PURE__ */ jsx201("path", {
      fill: "#ce1126",
      d: "M0 240h640v240H0z"
    }),
    /* @__PURE__ */ jsxs176("g", {
      fill: "#ffd83d",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      transform: "scale(.8)",
      children: [
        /* @__PURE__ */ jsxs176("g", {
          id: "li_svg__a",
          children: [
            /* @__PURE__ */ jsx201("path", {
              stroke: "none",
              d: "m216.4 122.3-1.9 62.5h-63.4c-7.8-15.2-14.2-28-14.2-45.5 0-14.6 11.5-26.2 28-26.2 17.5 0 36.8 5.9 51.5 9.2"
            }),
            /* @__PURE__ */ jsxs176("g", {
              strokeWidth: 1.5,
              children: [
                /* @__PURE__ */ jsx201("path", {
                  d: "M144.5 125.2v36m5-39.7v48m5.2-50.5v57.2m5-58.4v44.9m5.1-45.1v45.3m5.1-47v47m5.1-47v47m5.1-46.5v47m5.1-46.5v46.9m5.1-44v47m5-46.5v52.9m5.2-52.9v47m5-47v47"
                }),
                /* @__PURE__ */ jsx201("path", {
                  fill: "#000001",
                  d: "M176.4 118c10.8 1.7 34.4 12.8 31.7 27.7-3.8 21.2-16.2 12.7-32.6 9.7l-12.4 4.1c-4.5 4.5-11 8.7-15.4 3.2h-7.4v28.8h81.4V122z"
                })
              ]
            }),
            /* @__PURE__ */ jsx201("circle", {
              cx: 212.8,
              cy: 113,
              r: 4.9
            }),
            /* @__PURE__ */ jsx201("circle", {
              cx: 201.7,
              cy: 110.3,
              r: 4.9
            }),
            /* @__PURE__ */ jsx201("circle", {
              cx: 190.4,
              cy: 107.5,
              r: 4.9
            }),
            /* @__PURE__ */ jsx201("circle", {
              cx: 179.1,
              cy: 105.6,
              r: 4.9
            }),
            /* @__PURE__ */ jsx201("circle", {
              cx: 167.8,
              cy: 104.5,
              r: 4.9
            }),
            /* @__PURE__ */ jsx201("circle", {
              cx: 156.8,
              cy: 105.1,
              r: 4.9
            }),
            /* @__PURE__ */ jsx201("circle", {
              cx: 146.2,
              cy: 108.7,
              r: 4.9
            }),
            /* @__PURE__ */ jsx201("circle", {
              cx: 137.3,
              cy: 115.3,
              r: 4.9
            }),
            /* @__PURE__ */ jsx201("circle", {
              cx: 131,
              cy: 124.4,
              r: 4.9
            }),
            /* @__PURE__ */ jsx201("circle", {
              cx: 127.9,
              cy: 135.2,
              r: 4.9
            }),
            /* @__PURE__ */ jsx201("circle", {
              cx: 128,
              cy: 146.3,
              r: 4.9
            }),
            /* @__PURE__ */ jsx201("circle", {
              cx: 130.2,
              cy: 157.2,
              r: 4.9
            }),
            /* @__PURE__ */ jsx201("path", {
              d: "m215 119.5-.5 6.5c-12.3-2-29.7-8.8-46-8.8-15 0-26.6 6-26.6 21.2 0 14.9 6.3 28.5 14.7 42.3l-8.7 4c-7.8-15-14.3-28-14.3-45.4 0-14.6 11.5-29 31.3-29 17.5 0 35.4 6 50.1 9.2"
            })
          ]
        }),
        /* @__PURE__ */ jsx201("use", {
          xlinkHref: "#li_svg__a",
          width: "100%",
          height: "100%",
          transform: "matrix(-1 0 0 1 444 0)"
        }),
        /* @__PURE__ */ jsx201("path", {
          d: "m222 53.1-5.2 9.7 5.2 9.6 5.1-9.6L222 53zm0 24.4-5.2 9.6 5.2 9.7 5-9.8zM203.6 75l8.1 5.1 8.1-5.1-8-5.2zm20.5 0 8.1 5.1 8.2-5.1-8.2-5.2z"
        }),
        /* @__PURE__ */ jsx201("circle", {
          cx: 222,
          cy: 75.1,
          r: 3.9
        }),
        /* @__PURE__ */ jsx201("circle", {
          cx: 222,
          cy: 100,
          r: 10.5
        }),
        /* @__PURE__ */ jsx201("path", {
          fill: "none",
          strokeWidth: 1.5,
          d: "M219.3 89.9v6.6a62.5 62.5 0 0 0-7.4.8m20.2 0a62.1 62.1 0 0 0-7.5-.8v-6.6m-12.8 12.7a61.4 61.4 0 0 1 10.2-.9c3.4 0 6.8.3 10 .9"
        }),
        /* @__PURE__ */ jsx201("path", {
          d: "M211.8 117.7c-1 17-3 34.5-9.7 47.1l10.8-4.4c3.8-14.3 4.6-32.8 5.7-41.6zm20.4 0-6.9 1.1c1.2 8.8 2 27.3 5.7 41.6l10.8 4.4c-6.6-12.6-8.6-30-9.6-47.1"
        }),
        /* @__PURE__ */ jsx201("path", {
          d: "M222 154.7c-13 0-22.5 6-23 21.6-3.2-5.6-16.5-23-29-20.7-7.4 1.4-14 11.7-12.8 23.4-6.2-17.6-24.1-20.5-37.3-10 11.7 9.5 16.9 37.8 26.7 50h150.7c9.8-12.2 15-40.5 26.7-50-13.1-10.5-31.1-7.6-37.2 10 1-11.7-5.5-22-13-23.4-12.4-2.3-25.7 15.1-28.9 20.7-.5-15.5-10-21.6-23-21.6z"
        }),
        /* @__PURE__ */ jsxs176("g", {
          strokeWidth: 1.5,
          children: [
            /* @__PURE__ */ jsx201("path", {
              fill: "#000001",
              d: "M297.1 219c0 5.6-33.6 11.7-75.1 11.7s-75.2-6-75.2-11.7c0-5.5 33.7-8.5 75.2-8.5 41.4 0 75.1 3 75.1 8.5"
            }),
            /* @__PURE__ */ jsx201("circle", {
              cx: 222,
              cy: 114.4,
              r: 3.5
            }),
            /* @__PURE__ */ jsx201("circle", {
              cx: 222,
              cy: 122,
              r: 3.7
            }),
            /* @__PURE__ */ jsx201("circle", {
              cx: 222,
              cy: 130.2,
              r: 4.1
            }),
            /* @__PURE__ */ jsx201("circle", {
              cx: 222,
              cy: 139.3,
              r: 4.7
            }),
            /* @__PURE__ */ jsx201("circle", {
              cx: 222,
              cy: 149.4,
              r: 5.1
            }),
            /* @__PURE__ */ jsx201("path", {
              fill: "#000001",
              stroke: "none",
              d: "M220 159.2c-.6 0-1.1.5-1 1.4l.6 4.3c.2 1.5 1 1 1.3 0 .2-1.2.1-2 .2-4.1 0-1.1-.6-1.6-1.2-1.6zm4 0c-.6 0-1.1.5-1.1 1.6 0 2.1 0 2.9.2 4 .2 1.2 1 1.6 1.3 0l.5-4.2c.2-1-.4-1.4-.9-1.4m-7.7.6a1 1 0 0 0-1 1c0 1 .3 2.3.4 3.8.2 1.5 1.3 1 1.4 0 0-.8.2-2.2 0-3.9 0-.6-.2-.9-.6-1a.8.8 0 0 0-.2 0zm11.1 0c-.3 0-.6.3-.7 1a20.1 20.1 0 0 0 .2 3.8c0 1 1.2 1.5 1.3 0 0-1.5.4-2.7.4-3.7 0-.6-.5-1-1-1.1a.8.8 0 0 0-.2 0m-15.4 1.7c-.5.1-1 .7-.8 1.3.3 1.3.6 2.7.6 4 0 1.1.9.7 1 0a59.8 59.8 0 0 0 .1-4c0-1-.5-1.4-1-1.3zm19.6 0c-.3.1-.6.5-.6 1.3l.2 4c0 .7 1 1.1 1 0 0-1.3.2-2.7.5-4 .2-.6-.3-1.2-.7-1.3a.6.6 0 0 0-.3 0zm-59 .2c-.6 0-1 .7-.6 1.5.6 1.4 1.3 2.2 1.9 3.6.5 1.3 1.4.5 1.1-.4l-1.4-3.7c-.3-.7-.7-1-1-1m98.8 0c-.4 0-.7.3-1 1-.9 1.9-1.2 2.8-1.5 3.7-.2 1 .6 1.7 1.2.4l1.8-3.6c.4-.8 0-1.5-.5-1.5m-94.8 0c-.5.2-.7.7-.5 1.3.6 1.2 1.3 2.5 1.8 3.8.4 1.1 1.4.8 1-.2l-1-3.7c-.4-1-1-1.3-1.3-1.2m90.5 0c-.4.1-.8.5-1 1.2-.7 2-.8 2.6-1.1 3.7-.4 1 .6 1.3 1 .2l1.8-3.8c.2-.6 0-1.1-.4-1.3a.6.6 0 0 0-.3 0m-85.5 1c-.6.1-1 .9-.6 1.9.4 1.2 1 2.3 1.6 3.7.6 1.4 1.5 1.1 1.3.2-.3-.9-.5-2.3-1.2-4.5-.3-1-.7-1.4-1.1-1.3m80.8 0c-.4 0-.9.3-1.2 1.3-.6 2.2-1 3.6-1.1 4.5-.3 1 .7 1.2 1.2-.2.6-1.4 1.2-2.5 1.6-3.7.4-1 0-1.8-.5-1.9m-93.2.7c-.6 0-1 1-.7 1.7.5 1 .9 1.4 1.4 2.6.6 1.2 1.2.3 1-.5-.3-.8-.6-1.7-.8-2.8-.2-.8-.6-1-1-1zm105.6 0c-.4 0-.7.2-1 1l-.7 2.8c-.2.8.4 1.7 1 .5.5-1.2.8-1.5 1.4-2.6.3-.7-.2-1.6-.7-1.7m-67 2.8c-.7 0-1.3.8-1 1.5.2 1.2.8 2.2 1.1 3.7.4 1.3 1.3.7 1.2-.2a28.7 28.7 0 0 0-.5-4c-.2-.7-.5-1-.9-1zm28.4 0c-.3 0-.7.3-.8 1a28.7 28.7 0 0 0-.6 4c0 .9.9 1.5 1.2.2l1.2-3.7c.2-.7-.4-1.5-1-1.5m-14.2 1.2c-.8 0-.9 1-.9 1.7a12.3 12.3 0 0 1-2 6.4c-1 1.2-2.3.9-3.5.2a22.3 22.3 0 0 1-3.3-2.2c-1.4-1-2.4-.4-.8 1.9 4.6 6.6 9.6 12.2 9.6 23 0 1.3.3 1.7.9 1.7s.8-.4.8-1.8c0-10.7 5-16.3 9.6-23 1.6-2.2.6-2.8-.7-1.8a21 21 0 0 1-3.3 2.2c-1.3.7-2.6 1-3.5-.2a12.3 12.3 0 0 1-2-6.4c-.1-.7-.2-1.7-1-1.7zm-35.3-1.6a.6.6 0 0 0-.2 0c-.3.1-.4.4-.3 1l1.1 3.9c.3 1 1.4.7 1.2-.5l-.6-3.1c-.2-.8-.8-1.3-1.2-1.3m70.6 0c-.5 0-1 .5-1.2 1.3-.4 1.4-.4 1.8-.6 3-.3 1.3.9 1.5 1.1.6l1.2-4c0-.5-.1-.8-.4-.9a.6.6 0 0 0-.2 0zm-91.6.4c-.6 0-1 .8-.4 1.8.6 1.2 1.7 2.6 2.2 3.5.5.8 1.4.2.8-.8-.6-1-.8-2.3-1.6-3.8a1 1 0 0 0-1-.7m112.5 0c-.3 0-.7.2-1 .7-.7 1.5-1 2.7-1.5 3.8-.6 1 .2 1.6.7.8.5-.9 1.6-2.3 2.2-3.5.6-1 .2-1.8-.4-1.8M134 169.5c-.6 0-.8 1.2-.2 2a19.2 19.2 0 0 0 2.6 2.7c.8.8 1-.2.6-1l-1.8-2.7c-.5-.7-.9-1-1.2-1m175.9 0c-.3 0-.7.3-1.1 1l-1.9 2.7c-.4.8-.2 1.8.7 1a19 19 0 0 0 2.6-2.7c.6-.8.4-2-.3-2m-170.8 1c-.6 0-1 .4-.5 1.3l1.9 3.8c.5 1 2 1.3 1.4-.2l-1.3-3.8c-.3-.7-1-1-1.5-1zm165.8 0c-.6 0-1.3.4-1.6 1.1l-1.2 3.8c-.6 1.5.9 1.2 1.4.2.5-1 1.3-2.5 1.8-3.8.5-.9.1-1.3-.4-1.3m-175.6.4c-.8 0-.8.7-.1 1.2.9.7 2 1.4 3 2.3 1.3 1 1.7 0 1-.8-.6-.8-1.2-1.6-2.9-2.5-.4-.2-.7-.2-1-.2m185.3 0c-.2 0-.6 0-1 .2-1.6.9-2.3 1.7-3 2.5-.6.9-.1 1.8 1.1.8 1-.9 2.2-1.6 3-2.3.8-.5.7-1.2 0-1.2zm-109.6.7c-.5 0-.8.5-.7 1.2l1 3.6c.2 1.1 1.5 1.1 1.3 0-.2-1-.3-2.3-.7-3.9-.1-.6-.4-.9-.8-1a.6.6 0 0 0-.1 0zm33.8 0c-.3 0-.6.3-.8 1-.4 1.5-.5 2.8-.7 3.9-.2 1 1.1 1 1.3-.1l1-3.6c.2-.7-.2-1.2-.6-1.2a.6.6 0 0 0-.2 0m-64-2c-.3 0-.5.7-.2 1.7a26 26 0 0 1 1.6 9c-.3 1.2-1 1.3-1.9 1a18.8 18.8 0 0 1-2.8-1.7c-.8-.5-1.7.1-.5 1.1 6 5 10.3 10.7 12 17.6.2 1.4 1.1 1.6.9 0-1.4-8.7-1.7-15.9.4-20.3.8-1.7 0-3.3-1.2-.6-.9 1.8-2.2 2.5-3.3 1a47.9 47.9 0 0 1-4-7.7c-.2-.7-.5-1-.8-1.1a.3.3 0 0 0-.1 0zm94.1 0c-.3 0-.6.4-.8 1-.7 2-2.9 6.2-4 7.8s-2.4.8-3.2-1c-1.3-2.7-2-1.1-1.3.6 2.1 4.4 1.8 11.6.5 20.3-.3 1.6.6 1.4 1 0a32.4 32.4 0 0 1 11.8-17.6c1.2-1 .3-1.6-.5-1a18 18 0 0 1-2.8 1.5c-1 .4-1.6.3-1.9-1-.2-1.2.2-3.9 1.7-9 .2-.8 0-1.5-.3-1.6a.3.3 0 0 0-.2 0M144.4 172c-.5 0-1 .4-.7 1.2.4 1.4 1.2 2.8 1.5 3.6.3.9 1.2.5 1-.7l-.5-3.1c0-.6-.7-1-1.3-1m155.1 0c-.6 0-1.2.4-1.3 1l-.4 3.1c-.2 1.2.7 1.6 1 .7.2-.8 1-2.2 1.4-3.6.3-.8-.1-1.2-.7-1.2m-136.3-1.7c-.6-.1-.7 1.5-.2 2.2l2.8 3.1c.8 1 1.3.1.8-.7l-2.6-3.8c-.3-.5-.6-.8-.8-.8m117.5 0c-.2 0-.5.3-.8.8l-2.6 3.8c-.5.8 0 1.7.9.7l2.7-3.1c.5-.7.5-2.3-.2-2.2m-132 4c-.4 0-.7.2-.5 1 .2 1.2.5 2 .8 3.1.3 1 1 .9 1-.1l-.3-3.2a1.1 1.1 0 0 0-1-.9zm146.5 0a1 1 0 0 0-1 .8l-.3 3.2c0 1 .8 1.2 1 .1l.9-3c.2-.9-.2-1.2-.6-1.2zm-133.4 1.4c-.6 0-1.1.7-.4 1.6 1.1 1.5 2.4 2.5 2.9 3 .4.6 1.5.4.8-.7l-2.3-3.5c-.2-.4-.6-.5-1-.4m120 0c-.2 0-.5.1-.6.4l-2.4 3.5c-.7 1.1.4 1.3.9.8.4-.6 1.7-1.6 2.9-3.1.7-1 .1-1.6-.5-1.6a.9.9 0 0 0-.2 0zm-140.7 4.1c-.4 0-.6.4 0 1.3a17 17 0 0 1 3.3 6.4c.1 1.4-.5 1.4-1.1 1.4-1.9 0-2.8-1.4-4.4-1.8-1.7-.3-2 .5-.8 1.4a53.4 53.4 0 0 1 14.7 13.8c1 1.9 2.3 2.5 1.6.8a23.7 23.7 0 0 1-2.4-12.6c.5-2.8 1.2-4.6 1.1-6.2 0-1.5-1-1.4-1.3 0l-1 2.8c-.4.5-1.8.8-3-.9a48 48 0 0 0-5.6-5.8c-.3-.3-.7-.5-1-.6zm161.7 0c-.3 0-.7.2-1.1.6a48.2 48.2 0 0 0-5.5 5.8c-1.3 1.7-2.7 1.4-3 1a12 12 0 0 1-1-2.9c-.4-1.4-1.3-1.5-1.4 0 0 1.6.6 3.4 1.1 6.2s0 7.2-2.3 12.6c-.8 1.7.6 1 1.6-.8a53 53 0 0 1 14.6-13.8c1.2-.9 1-1.7-.7-1.4-1.7.4-2.6 1.8-4.4 1.8-.6 0-1.3 0-1.2-1.4.1-1.3 1.8-4.4 3.3-6.4.6-1 .5-1.3 0-1.3"
            }),
            /* @__PURE__ */ jsx201("path", {
              d: "m150.1 212.7 2 6.1m2-7.3 1.8 6.2m2.6-7 1.2 6.4m2.8-7.1 1.3 6.3m3.8-6.8 1 6.4m4.5-6.4 1.1 6.3m4.3-8.1.8 6.4m4.2-6.1.8 6.4m4.1-7 .8 6.4m4-7 .5 6.5m4.8-6.5.4 6.5m4.4-6.8.3 6.5m4.9-6.8.3 6.4m5.7-6.6.3 6.5m79 .2-2 6.1m-2-7.3-1.7 6.2m-2.6-7-1.2 6.4m-2.8-7.1-1.3 6.3m-4-6.8-1 6.4m-4.4-6.4-1.1 6.4m-4.2-8.2-.8 6.4m-4.3-6.1-.8 6.4m-4-7-.9 6.4m-4-7-.5 6.5m-4.8-6.5-.4 6.5m-4.3-6.8-.3 6.5m-5-6.8-.2 6.4m-5.8-6.6-.2 6.5m-7.2-7v7.2"
            })
          ]
        })
      ]
    })
  ]
});
var Li_default = SvgLi;

// src/country-flag-icons/generated/Lk.tsx
init_esm_shims();
import { jsx as jsx202, jsxs as jsxs177 } from "react/jsx-runtime";
var SvgLk = (props) => /* @__PURE__ */ jsxs177("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx202("path", {
      fill: "#ffb700",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx202("path", {
      fill: "#ff5b00",
      d: "m26.7 240 88-213.3h88v426.6h-88z"
    }),
    /* @__PURE__ */ jsx202("path", {
      fill: "#005641",
      d: "M26.7 26.7h88v426.6h-88z"
    }),
    /* @__PURE__ */ jsx202("path", {
      fill: "#8d2029",
      d: "M229.3 26.7H616v426.6H229.3z"
    }),
    /* @__PURE__ */ jsx202("path", {
      id: "lk_svg__a",
      fill: "#ffb700",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "M579.3 408.6s3.6 7.3 7.6 10.4c6 4.4 18 4 23.3 9.3 6.1 6.1-.5 14.2-.5 15l.4 4.2s-4.2 0-6 .3c-2.6.4-3.6 2.6-8.6 2.3-12.3-.8-11.8-12-12.5-21.5-.6-3.6-2-8.4-2.9-12-.7-3-.8-8-.8-8z"
    }),
    /* @__PURE__ */ jsx202("use", {
      xlinkHref: "#lk_svg__a",
      width: "100%",
      height: "100%",
      transform: "matrix(-1 0 0 1 845.3 0)"
    }),
    /* @__PURE__ */ jsx202("use", {
      xlinkHref: "#lk_svg__a",
      width: "100%",
      height: "100%",
      transform: "matrix(1 0 0 -1 0 480)"
    }),
    /* @__PURE__ */ jsx202("use", {
      xlinkHref: "#lk_svg__a",
      width: "100%",
      height: "100%",
      transform: "rotate(180 422.7 240)"
    }),
    /* @__PURE__ */ jsxs177("g", {
      transform: "translate(0 -76)",
      children: [
        /* @__PURE__ */ jsx202("use", {
          xlinkHref: "#lk_svg__b",
          width: "100%",
          height: "100%",
          stroke: "#000",
          strokeWidth: 5.6
        }),
        /* @__PURE__ */ jsxs177("g", {
          id: "lk_svg__b",
          fill: "#ffb700",
          children: [
            /* @__PURE__ */ jsx202("path", {
              d: "m363.5 415.8 2.3-1.4 1 1.4c1.3 1.8 5 1.7 7.4 0l1.9-1.5 1.6 1.4c2 1.9 5.8 1.9 8.3 0 1.7-1.2 2-1.3 3-.3.7.6 2.7 1.2 4.4 1.5 3.2.4 3.2.4 5-2.4 1.6-2.3 1.8-3.2 1.5-5.5a59.4 59.4 0 0 1-.6-5.3c-.2-2.6-.1-2.6 3.6-4a50.5 50.5 0 0 0 5.4-2c1.5-.9 5.7-5.8 5.7-6.8 0-.2-1.6-.6-3.6-.8-8-1-9.3-5.2-4.1-13 8.3-13 13.4-25.5 13.4-33.4 0-3.6.3-4.8.7-4 1.9 3.1-1.5 16.4-6.5 26l-2 3.8 1.9-.4c1-.3 7.4-3 14-6 18.2-8.2 24.4-9.8 36.2-9.3 9.9.4 14 2.3 21 9.6 3.7 4 7.3 6.7 13.8 10.8 13.8 8.6 14.4 9.4 15.1 19.6.7 10.3.3 10.9-7.5 12.6-6.7 1.5-10.9 4.6-12 9-.6 2.2.7 2.3 4 .1l2.5-1.6 1.1 1.6c1.5 2.1 4.5 2.1 7 0l2-1.5 2 1.5c3 2.5 7 1.9 8.2-1.2.2-.5.8-.4 2 .7 2.3 2 8 2.8 8.6 1.2.2-.6-.2-2-1-3.2-3.3-5-4.4-7.3-4.4-10 0-3.8 1-5.7 5.4-8.7 5.2-3.8 6.8-8.6 2.8-8.6-2.4 0-4.9-2.2-6.5-5.7-3.2-7.2-2.5-15.2 2.3-28.6a57.6 57.6 0 0 0 5.4-25.2c0-7.4-.2-8.6-1.8-12.7a45.4 45.4 0 0 0-4.6-8.1l-2.8-3.7 3.5-3c10.8-8.9 8.6-23.5-4.4-29.1-4-1.8-5-1.9-12-1.9-4 0-10.5.6-14 1.3a98.2 98.2 0 0 1-14.2 1.2c-6.8 0-8-.2-10.6-1.6-2.7-1.4-3.2-2.1-3.7-5.5a2 2 0 0 0-1.1-1.5c-1-.3-5.2 3.4-5.8 5-.4.9-.6.8-1.5-.3a13.4 13.4 0 0 1-2-3.6c-1-3.3.3-5.7 4.2-7.6l3-1.4-1.8-1.1c-3.6-2.3-9.8-.7-12 3-.7 1-1.4 2-1.6 2-.2 0-1.4-1-2.6-2.3-4.7-4.6-3.1-11.4 3.2-13.4 3.3-1.1 6.3-.3 6.9 2 1 3.3 3.8-1.1 3.3-5.2-.3-2.7-.3-2.8 1.6-2.8 2.6 0 8 3.4 9.8 6 2 3.1 1.8 8-.4 11.6l-1.7 2.8 2.3-.4c3.2-.7 6.4-2.7 8-5.2a12 12 0 0 0 .4-10.4c-1.5-2.7-1.3-3.1.9-2.2 3.6 1.5 5.6 3.2 7 6.1 1.4 2.6 1.5 3.2.8 6a17 17 0 0 1-2.2 4.8c-1.2 1.6-1.3 1.9-.3 1.9 1.8 0 5.4-1.7 6.7-3 .7-.8 1.7-2.5 2.2-4l1-2.5 1 2c1.5 2.7 4.5 5.2 8.1 6.8 3.9 1.6 5.5 1.7 3.5.2-1.4-1-4-8.5-3.1-9.2a51 51 0 0 1 11.7 9c5.7 5.1 9.3 6.8 14.5 6.8 6.7 0 10.6-5.8 7.6-11.3-1.7-3.2-5.6-3.7-8-1-1 1.3-1.3 2.3-1 3.7.4 1.6.3 1.8-1.2 1.8-2 0-5.8-2.5-12.6-8.2a102 102 0 0 0-32.1-18.7 70.4 70.4 0 0 0-24.3-1.3c-6.4 1.2-14 4.9-18.2 8.8-7.3 7-7.4 16.3-.3 24.8l2 2.4-1.3 2.2a9.3 9.3 0 0 0 .4 10.4c1 1.4 2 2.5 2.3 2.5.2 0 .4-.9.5-2 .2-2.7 1.4-4.5 3.4-5.2 1.8-.7 3-.3 11.2 3 8.7 3.4 23 3.6 38.2.6a42.6 42.6 0 0 1 20 .2c7.2 3 8.8 10.7 3.6 16.5-2.3 2.6-4.4 3.6-11.7 5.6a54.3 54.3 0 0 1-19.5 1.5c-10.8-.1-14.7.1-19 1-4.9 1-7.8 1.1-21.8.8l-16.3-.4 1.8 1.4a22 22 0 0 0 3.1 2.3c1.3.7 1.2.8-.6 1.5-1 .4-3.4.7-5.3.7h-3.3l-.4 2.8a10 10 0 0 0 0 4c.4 1 .2 1.2-.8.8-.7-.3-2.6-.8-4.3-1.1a26.7 26.7 0 0 1-5-1.6c-1.9-1-2.1-1-2.8.3-.6 1-6.2 5.2-7 5.2a26.7 26.7 0 0 0-2.2-7.5c-1-2.1-1.9-4.5-2.2-5.2-.3-1.1-.5-1.2-1-.3-.3.5-.7 2-1 3.2a15.5 15.5 0 0 1-1.8 4.6l-1.5 2.2-1-1.9c-1-2-2.6-4.2-3.2-4.2-.2 0-.5.6-.7 1.5-.5 1.6-4.4 6.3-5.4 6.3-.3 0-.6-1.3-.6-3 0-1.5-.3-2.9-.7-2.9-.4 0-.7.5-.7 1 0 1.2-3.3 5-4.5 5-.4 0-1.2.4-1.7 1-1.2 1.3-2.2 1.1-1.7-.4a9 9 0 0 0-.4-3.8l-1-3.2c-.2-.5-1.4-.3-4 .5-4 1.3-5.4 1-3.3-.6.8-.6 2-2.7 2.6-4.6.7-2 1.7-3.7 2.2-3.9.7-.2.7 0-.2 1.2a5.7 5.7 0 0 0-1.1 2.6c0 .5-.5 1.8-1 2.9-.6 1-1 2-.9 2.1s1.7-.5 3.5-1.3l3.2-1.6v1.4c0 .8.4 2.8.9 4.5l.9 3 2.2-1c2.2-1 4.3-4.6 4.3-7.5 0-1.4.8-1.2 1.2.3 0 .4.6 2.1 1 3.7l1 2.8 1.5-1.8c.9-1 1.9-3 2.3-4.3.8-2.4 2-3.5 2-1.7 0 1.2 3.4 5.8 4 5.4.4-.2 1-1.9 1.5-3.8 1-4 2.5-6.6 3.5-6 .4.2.5.6.3 1-.2.2.6 2.8 1.8 5.6a2557.7 2557.7 0 0 1 2.6 6.3c.4 1 .8 1 3.3-1.3 1.5-1.4 3-2.9 3.1-3.4.3-.8.6-.7 2 .2a25 25 0 0 0 9.5 2.8c.2-.2.4-2 .4-4l.1-3.7 2 .4c1 .3 3.3.3 5 0l3-.4-2.7-2c-1.5-1-3-2.3-3.4-2.9-.3-.6-1.7-1.2-3.2-1.3-4.1-.4-11.4-4.4-11.4-6.4 0-.4 1 .3 2.2 1.4 2.8 2.5 6.6 4 10 4h2.4l-1.5-2a11.9 11.9 0 0 1-2-5.2c-.2-3-.5-3.4-3.6-5.5a35.2 35.2 0 0 1-5-4.3l-1.7-1.9-.9 2.3c-.5 1.3-1 2.3-1.3 2.3-.2 0-1.2-.8-2-1.7a7 7 0 0 0-2-1.6c-.3 0-1 1.2-1.8 2.7l-1.4 2.7-1-1.5a23.8 23.8 0 0 0-3-3.4c-1.2-1-1.7-1.8-1.3-1.8.4 0 1.7 1 3 2.3l2.2 2.3 1-1.7a6 6 0 0 0 .5-3.8c-.4-1.8-.3-1.9.3-.7a16 16 0 0 0 3 3l2.2 1.8 1.5-2.7c1.5-2.8 1.5-2.8 2.1-1.1 1 2.1 7.5 7.5 13 10.6 1 .5.6-1.1-1-5a12.7 12.7 0 0 1-.8-4c0-1.8-.5-2.6-2.8-4.4a10.9 10.9 0 0 1-5-8.4c-.3-1.7-.9-3.5-1.4-4.1-.6-1-.8-.4-.6 2.6.2 2.1-.1 4.7-.6 5.8l-.8 2-.6-1.7c-.4-.9-2-2.5-3.5-3.5s-2.6-2-2.4-2.2c.2-.2 1.8.7 3.5 2 2.7 2.1 3.2 2.3 3.6 1.4.4-1 0-5.6-.8-8.8-.4-1.6-.4-1.6 1.6.4 1.4 1.4 2.2 3.2 2.9 6.2.8 3.8 1.2 4.5 4.7 7.6 2.1 1.9 4 3.3 4.1 3.2.2-.2.4-5 .6-10.8.4-11.1 0-13.8-2.7-17.2l-1.4-1.8 2.2-2.3a16 16 0 0 0 4.7-8.8l.4-2.7-2.4 2.3c-2 1.9-3 2.3-5.3 2.3s-3.2-.4-4.7-2a20 20 0 0 0-8.3-4.8c-1.2-.4-1.6-.2-1.6.6 0 .6-.6 2.2-1.4 3.7l-1.4 2.6-3-3c-1.9-1.7-4-3.2-5.7-3.6-4.1-1-4.3-1-4.3 2.1 0 4.7-2 5.6-5.6 2.5-2.8-2.4-5-3-10.3-2.3l-4 .4.7 1.8c.6 1.5.5 2.2-.8 3.9-2.1 2.8-4.8 4-9 4-2 0-4.4.4-5.4.9s-3.6 1-5.7 1.2c-2 .2-4.3.6-5 .8-1 .4-1 0-.7-2.2.5-3.4-2-6-5.7-6-4.9 0-7.1 4.4-5.2 10.2a44.6 44.6 0 0 1 1 3.8 23 23 0 0 0 5.2 6.6c2.6 2.6 5 5.3 5.4 6a9 9 0 0 0 3 2.5l2.2 1.2-.3-2.4c-.3-2.6.2-3 1.6-1.1.5.6 1.8 1.7 2.8 2.3 1.7 1 2 1 2 .2 0-.6.3-1.9.7-2.9l.7-1.8 1.3 2.5c.7 1.4 3 4.5 5.1 7 4.1 4.7 6.7 10 5.4 11.2-.6.5-2 .5-5-.1-2.2-.4-5-.7-6.2-.5-2.3.3-2.5 0-1-1.8 1.5-2 1.2-2.3-1.8-2.3-3.5 0-12.2-1.7-15.6-3-3.2-1.3-4-1-5 2.1l-1.7 5.6-1 3 3.6-.3a37 37 0 0 0 5.5-1 6 6 0 0 1 2.2-.3c.2.1-.3 1.3-1 2.7l-1.4 2.4 2.2-.4c1.2-.3 3-.9 4-1.4 1.8-.8 2-.8 3.4 1.5 1.7 2.7 3 2.6 3.3-.3.3-3 1.3-2.6 3.2 1.4 1.8 3.8 3.6 5.2 4 3 .1-.8 1-2 2.1-2.8 2.2-1.5 3.8-1 4.7 1.3 1 2.5-1.2 5-7.4 8.8a43 43 0 0 0-21.7 31c-1.9 11.8 4 24 15.6 32.9 5.6 4.2 14.5 8.6 13.9 7-2.4-7.3-2.3-21 .1-23.3.4-.4.3 1-.3 3.1-2 7.9-1 14.1 4 28.7 4.4 13.2 3.8 18.9-2.6 22.6-2 1.2-3.3 1.4-8.8 1.3-6 0-6.7 0-8.6 1.6a15.7 15.7 0 0 0-4.3 8.6c0 1.3 1.4 1.1 4-.4z"
            }),
            /* @__PURE__ */ jsx202("path", {
              d: "m460.5 415.5 2.5-1.6 1.7 1.6c2.2 2.1 4.9 2 7-.1 1-1 1.8-1.6 1.9-1.5l.9 1.6c.5.9 1.6 1.3 3.6 1.5 2.3.1 3 0 4-1.4l1-1.7 2.5 1.6c6.8 4.4 10.4-.2 7.3-9.3-1.5-4.6-.6-7.2 4.3-13 2.1-2.5 3.8-5.2 3.8-6 0-1.1-.4-1.3-3.2-1.2-2.6 0-3.4-.3-4.8-1.8-2.3-2.5-2.1-5.4.4-8.6l2-2.5-3.6-2.4a59.7 59.7 0 0 1-8-7.1 25.7 25.7 0 0 0-17.5-9l-4.7-.5v3.6c0 4.5 2.2 8.9 8 16.3 6.6 8.4 7 9.7 7.3 20.7l.3 9.3-2 1.8c-1.7 1.6-2.4 1.9-8 2.2-5.3.3-6.5.6-8 2a8.7 8.7 0 0 0-3.4 5.3c-.3 1.5-.2 1.8.9 1.8.7 0 2.4-.7 3.8-1.6m-142.2-24a5.8 5.8 0 0 0 1-3c0-1 .6-1.4 3.2-1.8l3.1-.4-2-1.7c-2.5-2-2.8-3.5-.6-3.5s5.8-2.2 6.4-3.9c.3-.8 0-1.8-.4-2.3-1.2-1.4-3.5-1.2-3.9.4-.5 1.6-1.2 1.6-3 0-2.5-2.5-2.6-7.6 0-10.6 1.1-1.4 1.1-1.4-.4-2.9-1.6-1.6-2.8-4.6-2-5.4.2-.2 1.5 0 2.8.5 2 .6 2.7.6 3.5 0 2.3-1.9-.2-4.3-4-3.7-1.6.2-2.2 0-2.4-.8-.2-.6-1.5-1.4-3-1.8-2.7-.7-2.7-.7-2.7 1.2 0 2-1.2 2.4-3.4 1.1-1.8-1-3.5-.2-3.5 1.7 0 1.8 1.7 2.6 5 2.4 2.4-.1 2.5 1.7.2 4.3l-1.7 2 1.3 1.9c2 2.8 1.8 7.5-.3 9.9l-1.7 1.8-1.1-1.5c-1.6-2-3.7-1.9-4.3.3-.3 1.4 0 2 1.8 3.6 1.2 1 3 1.8 3.9 1.8 2.3 0 2.2 1.9-.2 3.7l-2 1.5 3 .4c1.6.3 3 .7 3 1 0 1.3 2 5.2 2.6 5.2.4 0 1.2-.7 1.8-1.5z"
            }),
            /* @__PURE__ */ jsx202("path", {
              d: "M356.5 374.9c2.7-1 8.5-6 8.5-7.1 0-.4-1.6-2.2-3.6-4-4-3.6-8.5-9.9-9.7-13.5-.6-2-3.5-5.2-11.7-13.2l-10.9-10.5-3.1.8c-1.8.4-3.9.8-4.7.8-1.5 0-1.5 0 .5 1.6l2 1.6 3-1.6c2.7-1.6 2.8-1.6 3.1-.3.2.7-.2 2-1 2.9-.7.9-1.1 2-1 2.3.3.3-.4 1-1.5 1.6-2 1-3.5 4.3-1.9 4.3 1.5 0 4.7-4 4.3-5.3-.2-.7 0-1.4.2-1.6 1.3-.7 1.2 2.4 0 4-.8.8-1.2 1.8-1 2.2.2.3-.5 1-1.6 1.6-2 1-3.5 4.3-1.9 4.3s4.7-3.8 4.4-5.2c-.2-.7-.2-1.5.1-1.7.9-.4 1.3 2 .6 3.2a2.3 2.3 0 0 0 0 2.2c.7 1.3 0 3.7-1.3 4.5-.5.3-.2 1 1.2 2 2 1.4 2 1.6 2 8 0 5.4.2 6.8 1.2 7.7 1 1 1.2 1 1.2 0s2-2.4 3.5-2.4c.5 0 3.4 2.5 6.5 5.5s6.4 5.7 7.3 5.8l2.2.4c.3 0 1.7-.3 3.1-1zm-33.3-26.1c0-1.7-3.6-3.6-7.9-4-3.5-.5-3.5-.4-3.5 1.3 0 1.4.5 2 3 3 3.8 1.7 8.4 1.5 8.4-.3"
            }),
            /* @__PURE__ */ jsx202("path", {
              d: "M327.1 348.6c1.8-1.6 2.6-3.4 1.5-3.4-1.2 0-4.4 2.8-4.4 4 0 1.6.6 1.5 3-.6zm-3.7-5.1c.1-1-.5-1.6-2.3-2.5-4-1.7-8.6-2.6-9.7-1.7-2.1 1.7-.7 3.9 2.6 4.3 1.4.1 3.2.5 4.1.9 2.6 1 5 .5 5.3-1m0-5.3c.2-1.3-.7-1.8-8-4.4-5.5-2-7.9-1-6.1 2.3.6 1.1 1.6 1.6 3.9 2 1.7.2 4 .7 5.1 1.1 3 1 4.8.6 5-1zm3.6-4.9c1.1-1.1 2-2.4 2-3 0-1.5-4.3 1.3-4.9 3.3-.6 2.3.5 2.2 3-.3zm-3.6-.3c.2-1.6-2.4-3-7.6-4.1-3.9-.9-5.6-.4-5.3 1.4.2 1 1.5 1.7 5 2.8 5.9 1.8 7.6 1.8 7.9-.1m5-7.4c6.8-3 7.3-10.5 1-12.5-2.6-.8-4.2-.3-5.2 1.4-.8 1.4-.3 3.8.7 3.8.4 0 .7.5.7 1 0 2.7-10.2 3.8-14.4 1.7-1.5-.7-2-2.7-.9-2.7 1 0 1.6-2 1.1-3.3-.6-2-2.6-2.6-5.3-1.8-6.3 1.6-6.1 9 .3 12a33.6 33.6 0 0 0 22 .4"
            }),
            /* @__PURE__ */ jsx202("path", {
              d: "M324.3 319.8c.4-.4.2-1-.4-1.4-1.4-1.1-1.3-2.8.2-4.7 1.2-1.4 1.3-3.6 1.7-25.1.7-37.1 3.5-65 7.1-71.8 1.5-2.6 1.3-2.6-2.5 0a36 36 0 0 0-11.7 13.6c-6.2 11.5-8.3 27-8.3 60.2 0 18.8.1 21.3 1.2 23 1 1.8 1 2.4.4 4.2-.5 1.1-.7 2.3-.5 2.5 1.4 1.3 11.4 1 12.8-.5m56.1-35.4c.3-.3-.2-2-1-3.6-1.2-2.6-1.7-3-3.4-3a65 65 0 0 1-23-6.4c-5.1-2.3-7-2.8-7.5-2.2-1.6 1.5 1 5 5 6.9a64 64 0 0 0 18.3 3.7c2.7 0 2.8 0 1.2 2.3l-1 1.6h3l5 .6c3 .7 3 .7 3.4.1"
            }),
            /* @__PURE__ */ jsx202("path", {
              fill: "#000001",
              d: "M412 301.1c0-1-2.9-3.5-5.7-5.2-2.3-1.3-2.7-1.4-2.7-.3 0 1.6-1.4 5.7-2 5.7-.3 0-.8-.8-1-1.7-.3-1-1.4-3-2.5-4.3l-2-2.5-1.4 2.3c-1.4 2.2-3.9 4.3-5 4.3-.2 0-.3-1.2 0-2.5.1-1.6 0-2.8-.5-3-.4-.3-.8-.2-.8.2 0 .8-3.4 4.6-4 4.6-.4 0-.8-1-1-2.4l-.8-4.8c-.2-1.2.3-.4 1 2l1.6 4.1 1.6-2.5a11 11 0 0 0 1.6-3.4c0-.5.3-.7.7-.5.4.2.9 1.9 1.1 3.7l.5 3.4 1.8-2a28.8 28.8 0 0 0 2.6-3.2c.7-1.2.8-1.2 2.3 0 .8.8 2.1 2.5 2.9 3.9s1.5 2.4 1.6 2.3l.6-3.2.4-3c.1-.5 5.4 3 7.4 4.7 1.2 1.1 2.4 1.9 2.6 1.7.2-.2.4-1.8.4-3.7 0-2.8-.3-3.6-2-5.1-2-1.8-2-1.8-2.8-.5-1 1.7-2.1 1.7-2.1 0 0-1.2-3.8-5.9-4.7-5.9-.3 0-1.1 1-1.8 2.3s-1.5 2.3-1.7 2.3c-1 0-6.3-6-6.3-7 0-.8.4-.6 1.3.8a21 21 0 0 0 3.1 3.6c2 1.8 2.8 1.4 3.6-2.1.3-1 .7-1.8 1-1.8.8 0 5.4 4.9 6 6.5l.7 1.6.5-1.8c.6-2.2 1.3-2.2 2.3-.2.4.8 2.4 2.6 4.4 3.8l3.7 2.4.7-2.4c.4-1.3 1-2 1.2-1.6.4.5-.6 4.5-1.3 5.3 0 .1-1.3-.6-2.6-1.5l-2.5-1.8v3.2c0 1.7-.2 3.8-.4 4.6-.5 1.6-1.7 2-1.7.6zm-18.5-25.4c-4.4-3.6-5-4.4-5-6.2l.1-1.8.3 1.7c.2 1 1.4 2.6 2.8 3.8l2.6 2 1.5-1.8c.9-1 1.6-2.2 1.6-2.6 0-1.2.2-1.1 3.2 1.5 2.6 2.3 2.7 2.3 3 .8.3-.8.2-2.4 0-3.5-1-3-.8-3.4.5-1.6l2.4 2.8c1 1.1 1.1 1.1 1.5-.3.3-.9.5-2.4.5-3.4v-1.9l2.3 2.7c2.3 2.6 2.5 2.7 3.1 1.4.5-.7.8-2.4.8-3.7 0-1.8.2-2.2.6-1.6.8 1.2.3 4.2-1.1 6.8l-1 2-1.3-2.1c-1.7-2.6-2.3-2.6-3.3.2-1 2.7-1.7 2.9-2.7.8-.6-1.3-.8-1.1-1.2 1.7l-.5 3-3-2.3-3-2.3-1.5 1.5c-.7.9-1.3 2-1.3 2.4 0 1-.8 1-1.9 0m39-13.6c-1.5-1.4-2.6-2.8-2.4-3 .3-.3.5-.4.6-.2a67 67 0 0 0 3 3c3.4 3.6 2.7 3.7-1.1.2zm-52-5.4c-1.4-2-1.3-3.2.5-5.4 1.2-1.5 1.8-1.7 4-1.4 1.5.1 4.6 1.4 6.9 2.8a21.2 21.2 0 0 0 11 3l-1.7-2.8c-2.2-3.3-2.2-3.7.4-1.7 2.6 2.1 5.7 2.7 12.7 2.5l3.4-.1-2-2c-2.7-2.7-1.9-3 1.2-.3 2.8 2.5 2.7 2.7-3.4 3.3a23 23 0 0 1-7.6-.5c-3.4-1-3.6-.9-2.9.2.4.7 1 1.2 1.3 1.2.4 0 .7.4.7.8 0 1.3-7.4.1-11-1.6-8-4.1-9-4.5-11-3.9a4.3 4.3 0 0 0-2.4 2.3c-1.3 3.3 3.4 5.9 5.3 3 .6-.9.5-1.4-.5-2.5-1.4-1.4-1.2-1.6.6-1 1.3.5 1.4 3.6.2 4.8-1.3 1.3-4.5 1-5.7-.7"
            }),
            /* @__PURE__ */ jsx202("path", {
              fill: "#000001",
              d: "M412.4 248.6c-1-1-.2-1.2 4.3-1.3 5.6-.1 9-1 13-3.6 3.2-2 4.1-1.6 1 .5-2.7 2-7 3.4-11.3 3.8l-5.1.7c-.8.2-1.7.1-2-.1z"
            })
          ]
        })
      ]
    })
  ]
});
var Lk_default = SvgLk;

// src/country-flag-icons/generated/Lr.tsx
init_esm_shims();
import { jsx as jsx203, jsxs as jsxs178 } from "react/jsx-runtime";
var SvgLr = (props) => /* @__PURE__ */ jsxs178("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx203("defs", {
      children: /* @__PURE__ */ jsx203("clipPath", {
        id: "lr_svg__a",
        children: /* @__PURE__ */ jsx203("path", {
          fillOpacity: 0.7,
          d: "M0 0h682.7v512H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs178("g", {
      fillRule: "evenodd",
      clipPath: "url(#lr_svg__a)",
      transform: "scale(.9375)",
      children: [
        /* @__PURE__ */ jsx203("path", {
          fill: "#fff",
          d: "M0 0h767.9v512H0z"
        }),
        /* @__PURE__ */ jsx203("path", {
          fill: "#006",
          d: "M0 0h232.7v232.8H0z"
        }),
        /* @__PURE__ */ jsx203("path", {
          fill: "#c00",
          d: "M0 464.9h767.9V512H0z"
        }),
        /* @__PURE__ */ jsx203("path", {
          fill: "#c00",
          d: "M0 465.4h767.9V512H0zm0-92.9h767.9v46.2H0zm0-93.2h766V326H0zM232.7 0h535.1v46.5H232.7zm0 186h535.1v46.8H232.7zm0-92.7h535.1v46.5H232.7z"
        }),
        /* @__PURE__ */ jsx203("path", {
          fill: "#fff",
          d: "m166.3 177.5-50.7-31-50.4 31.3 18.7-50.9-50.3-31.4 62.3-.4 19.3-50.7L135 95h62.3l-50.1 31.7z"
        })
      ]
    })
  ]
});
var Lr_default = SvgLr;

// src/country-flag-icons/generated/Ls.tsx
init_esm_shims();
import { jsx as jsx204, jsxs as jsxs179 } from "react/jsx-runtime";
var SvgLs = (props) => /* @__PURE__ */ jsxs179("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx204("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx204("path", {
      fill: "#009543",
      d: "M0 336h640v144H0z"
    }),
    /* @__PURE__ */ jsx204("path", {
      fill: "#00209f",
      d: "M0 0h640v144H0z"
    }),
    /* @__PURE__ */ jsx204("path", {
      stroke: "#000",
      strokeWidth: 1.6,
      d: "M319.6 153c-2.7 0-5.4 3-5.4 3l.3 32.4-10.3 10.7h8.3v18.5l-49 66-7.2-2.6-12.7 27s31.3 19.6 76.7 19c49.8-.5 76.9-19.9 76.9-19.9l-13-26.6-6.5 2.8-49.6-65.6v-19.1h8.2L325.1 188v-32.2s-2.7-3-5.5-2.9z"
    }),
    /* @__PURE__ */ jsx204("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 8,
      d: "M336.7 230.4h-33.9s-12.2-25.9-10.3-44c2-18.4 12.6-27.1 26.6-27.3 16.6-.1 25.2 8.1 27.8 26.6 2.6 18.3-10.2 44.7-10.2 44.7z"
    }),
    /* @__PURE__ */ jsx204("path", {
      fill: "#fff",
      d: "M260.5 292.1c-.6.7-4.7 8.9-4.7 8.9l7-1.5zm4 10.5-7.4 2.4 8.9 3.5zm3.3-10.3 3.7 10.9 9-2.6-2.3-5.2zm5.8 14.8 1.2 4.4 12 3-4.8-10.2zm13.2-9.3 4.3 10.2 9-3.5-3-4.5zm6 13.9 1.4 3.8 14 2-5.9-9.2-9.6 3.4zm13.4-11 5.2 9.1 13-4.8-1.4-3.5-16.8-.7zm7.6 12.4 2.7 4.8 16.2-.5-6-9-13 4.7zm17.1-12 4.4 7.6 10.4-5-2.8-4zm17 5.8-10.3 5.1 2.7 4.5 13.8-2.2zm3.3-8 5.3 6.7 8.7-6.9-3-3zm15.9 3.5-8.3 6.3 2.2 3.9 11.4-3zm11.4-13 2 2.9-5.7 8.5-5.9-7.6zm3.9 7.3 3.5 7-7 2.4-.6-3.3 4-6z"
    })
  ]
});
var Ls_default = SvgLs;

// src/country-flag-icons/generated/Lt.tsx
init_esm_shims();
import { jsx as jsx205, jsxs as jsxs180 } from "react/jsx-runtime";
var SvgLt = (props) => /* @__PURE__ */ jsx205("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs180("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    transform: "scale(.64143 .96773)",
    children: [
      /* @__PURE__ */ jsx205("rect", {
        width: 1063,
        height: 708.7,
        fill: "#006a44",
        rx: 0,
        ry: 0,
        transform: "scale(.93865 .69686)"
      }),
      /* @__PURE__ */ jsx205("rect", {
        width: 1063,
        height: 236.2,
        y: 475.6,
        fill: "#c1272d",
        rx: 0,
        ry: 0,
        transform: "scale(.93865 .69686)"
      }),
      /* @__PURE__ */ jsx205("path", {
        fill: "#fdb913",
        d: "M0 0h997.8v164.6H0z"
      })
    ]
  })
});
var Lt_default = SvgLt;

// src/country-flag-icons/generated/Lu.tsx
init_esm_shims();
import { jsx as jsx206, jsxs as jsxs181 } from "react/jsx-runtime";
var SvgLu = (props) => /* @__PURE__ */ jsxs181("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx206("path", {
      fill: "#ed2939",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsx206("path", {
      fill: "#fff",
      d: "M0 160h640v160H0z"
    }),
    /* @__PURE__ */ jsx206("path", {
      fill: "#00a1de",
      d: "M0 320h640v160H0z"
    })
  ]
});
var Lu_default = SvgLu;

// src/country-flag-icons/generated/Lv.tsx
init_esm_shims();
import { jsx as jsx207, jsxs as jsxs182 } from "react/jsx-runtime";
var SvgLv = (props) => /* @__PURE__ */ jsx207("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs182("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx207("path", {
        fill: "#fff",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsx207("path", {
        fill: "#981e32",
        d: "M0 0h640v192H0zm0 288h640v192H0z"
      })
    ]
  })
});
var Lv_default = SvgLv;

// src/country-flag-icons/generated/Ly.tsx
init_esm_shims();
import { jsx as jsx208, jsxs as jsxs183 } from "react/jsx-runtime";
var SvgLy = (props) => /* @__PURE__ */ jsxs183("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx208("defs", {
      children: /* @__PURE__ */ jsx208("clipPath", {
        id: "ly_svg__a",
        children: /* @__PURE__ */ jsx208("path", {
          d: "M166.7-20h666.6v500H166.7z"
        })
      })
    }),
    /* @__PURE__ */ jsxs183("g", {
      clipPath: "url(#ly_svg__a)",
      transform: "matrix(.96 0 0 .96 -160 19.2)",
      children: [
        /* @__PURE__ */ jsx208("path", {
          fill: "#239e46",
          d: "M0-20h1000v500H0z"
        }),
        /* @__PURE__ */ jsx208("path", {
          fill: "#000001",
          d: "M0-20h1000v375H0z"
        }),
        /* @__PURE__ */ jsx208("path", {
          fill: "#e70013",
          d: "M0-20h1000v125H0z"
        }),
        /* @__PURE__ */ jsx208("path", {
          fill: "#fff",
          d: "M544.2 185.8a54.3 54.3 0 1 0 0 88.4 62.5 62.5 0 1 1 0-88.4M530.4 230l84.1-27.3-52 71.5v-88.4l52 71.5z"
        })
      ]
    })
  ]
});
var Ly_default = SvgLy;

// src/country-flag-icons/generated/Ma.tsx
init_esm_shims();
import { jsx as jsx209, jsxs as jsxs184 } from "react/jsx-runtime";
var SvgMa = (props) => /* @__PURE__ */ jsxs184("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx209("path", {
      fill: "#c1272d",
      d: "M640 0H0v480h640z"
    }),
    /* @__PURE__ */ jsx209("path", {
      fill: "none",
      stroke: "#006233",
      strokeWidth: 11.7,
      d: "M320 179.4 284.4 289l93.2-67.6H262.4l93.2 67.6z"
    })
  ]
});
var Ma_default = SvgMa;

// src/country-flag-icons/generated/Mc.tsx
init_esm_shims();
import { jsx as jsx210, jsxs as jsxs185 } from "react/jsx-runtime";
var SvgMc = (props) => /* @__PURE__ */ jsx210("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs185("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    children: [
      /* @__PURE__ */ jsx210("path", {
        fill: "#f31830",
        d: "M0 0h640v240H0z"
      }),
      /* @__PURE__ */ jsx210("path", {
        fill: "#fff",
        d: "M0 240h640v240H0z"
      })
    ]
  })
});
var Mc_default = SvgMc;

// src/country-flag-icons/generated/Md.tsx
init_esm_shims();
import { jsx as jsx211, jsxs as jsxs186 } from "react/jsx-runtime";
var SvgMd = (props) => /* @__PURE__ */ jsxs186("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsxs186("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      children: [
        /* @__PURE__ */ jsx211("path", {
          fill: "#00319c",
          d: "M0 0h213.3v480H0z"
        }),
        /* @__PURE__ */ jsx211("path", {
          fill: "#ffde00",
          d: "M213.3 0h213.4v480H213.3z"
        }),
        /* @__PURE__ */ jsx211("path", {
          fill: "#de2110",
          d: "M426.7 0H640v480H426.7z"
        })
      ]
    }),
    /* @__PURE__ */ jsx211("path", {
      fill: "#ff1900",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.7,
      d: "m360.4 320.4 24.2 35c1.4 2 2.7 3.9.7 5.2-2 1.3-1.4 6.4 0 8.4 2.7 3.9 6 4.5 8 3.2l18.4-11.6c2-1.2 2.7-4.5 0-8.4-1.5-2-6-4.5-8-3.2-2.1 1.3-3.5-.7-4.8-2.6l-24.3-35"
    }),
    /* @__PURE__ */ jsx211("path", {
      fill: "#a77b3b",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 2.5,
      d: "M177.2 696.3c0 24.4-9.6 44.3-21.3 44.3-11.7 0-21.3-19.9-21.3-44.3S144.3 652 156 652s21.3 19.8 21.3 44.3z",
      transform: "matrix(.52728 -.42386 .44358 .50386 -32.4 20)"
    }),
    /* @__PURE__ */ jsx211("path", {
      fill: "#ff1900",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.7,
      d: "m262 306.1-21.5 36.7c-1.2 2-2.4 4-4.5 3-2.1-1.2-6.6 1.7-7.8 3.8-2.4 4-1.5 7.2.7 8.4l19.2 10.2c2 1.1 5.4.2 7.8-3.8 1.1-2.2 1.4-7.3-.7-8.4-2.1-1.1-1-3.2.3-5.2l21.4-36.7"
    }),
    /* @__PURE__ */ jsx211("path", {
      fill: "#a77b3b",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.7,
      d: "M331.2 280.6h-19.6c-.6.6-6.2 35.6-12.2 49-7.3 16.3-29.2 30.7-29.2 30.7s13.1 4 17 6.6c1-.3 22-4.7 24.4-30.3 2.4 25.6-14.6 37.3-14.6 37.3s24.4 7 24.4 23.3c0-16.3 24.4-23.3 24.4-23.3s-12.2-11.7-14.7-37.3c5 25.6 23.5 30 24.5 30.3 3.9-2.6 17-6.6 17-6.6s-21.9-14.4-29.2-30.7c-6-13.4-11.6-48.4-12.2-49zm-83-116.7 36.6 11.7c12.1 0 24.4-11.7 24.4-23.4.4-26-9.8-35-12.2-35l4.8-4.6-7.3-7s2.5-12.1 26.9-11.7c24.4.5 24.4 11.7 24.4 23.3s-12.2 11.7-12.2 35c0 11.7 12.2 23.4 24.4 23.4l36.6-11.7v116.7H248.1z"
    }),
    /* @__PURE__ */ jsxs186("g", {
      fill: "none",
      stroke: "#000",
      children: [
        /* @__PURE__ */ jsx211("path", {
          strokeWidth: 0.5,
          d: "m302.2 292.2 14.6 15 14.7-15 14.6 15 29.3-15 14.3 15.8 15-15.8 21.6 15.8 22.3-15.8 14.6 15 14.7-15",
          transform: "matrix(.16672 0 0 .46773 253.9 31.9)"
        }),
        /* @__PURE__ */ jsx211("path", {
          strokeWidth: 0.2,
          d: "m432.3 435.8-7.1 39m10.6-39v39m7.1-39v39m7.1-39 3.5 39m3.6-39 3.5 39",
          transform: "matrix(.68905 0 0 .65843 16.2 -144)"
        })
      ]
    }),
    /* @__PURE__ */ jsxs186("g", {
      stroke: "#000",
      strokeWidth: 2.5,
      children: [
        /* @__PURE__ */ jsx211("path", {
          fill: "#a77b3b",
          fillRule: "evenodd",
          d: "M318.9 361.4c35.4 17.7 35.4 53.2 35.4 70.9-1.2 16.1 0 354.3 0 354.3s-2.3-20-17.7-35.4L319 733.5l-17.7-17.7c-13-11.8-17.7-35.5-17.7-53.2v-248s0-17.8 35.4-53.2z",
          transform: "matrix(-.68905 0 0 .65843 443.4 -144)"
        }),
        /* @__PURE__ */ jsx211("path", {
          fill: "none",
          d: "M283.5 574c.4 0 17.7-17.7 17.7-17.7l17.7 17.7 17.7-17.7 17.7 17.7",
          transform: "matrix(-.68905 0 0 .65843 443.4 -237.3)"
        }),
        /* @__PURE__ */ jsx211("path", {
          fill: "none",
          d: "M283.5 574c.4 0 17.7-17.7 17.7-17.7l17.7 17.7 17.7-17.7 17.7 17.7",
          transform: "matrix(-.68905 0 0 -.65843 443.4 530.2)"
        }),
        /* @__PURE__ */ jsx211("path", {
          fill: "none",
          d: "M283.5 574c.4 0 17.7-17.7 17.7-17.7l17.7 17.7 17.7-17.7 17.7 17.7",
          transform: "matrix(-.68905 0 0 .65843 443.4 -190.7)"
        }),
        /* @__PURE__ */ jsx211("path", {
          fill: "none",
          d: "m301.4 557-.2 158.8",
          transform: "matrix(-.68905 0 0 1.24911 443.4 -566.8)"
        }),
        /* @__PURE__ */ jsx211("path", {
          fill: "none",
          d: "m301.4 539.3-.2 176.5",
          transform: "matrix(-.68905 0 0 1.12111 431.4 -464)"
        }),
        /* @__PURE__ */ jsx211("path", {
          fill: "none",
          d: "m301.4 539.3-.2 176.5",
          transform: "matrix(-.68905 0 0 1.2559 419.2 -548.3)"
        })
      ]
    }),
    /* @__PURE__ */ jsxs186("g", {
      stroke: "#000",
      strokeWidth: 2.5,
      children: [
        /* @__PURE__ */ jsx211("path", {
          fill: "#a77b3b",
          fillRule: "evenodd",
          d: "M318.9 361.4c35.4 17.7 35.4 53.2 35.4 70.9-1.2 16.1 0 354.3 0 354.3s-2.3-20-17.7-35.4L319 733.5l-17.7-17.7c-13-11.8-17.7-35.5-17.7-53.2v-248s0-17.8 35.4-53.2z",
          transform: "matrix(.68905 0 0 .65843 199.3 -144)"
        }),
        /* @__PURE__ */ jsx211("path", {
          fill: "none",
          d: "M283.5 574c.4 0 17.7-17.7 17.7-17.7l17.7 17.7 17.7-17.7 17.7 17.7",
          transform: "matrix(.68905 0 0 .65843 199.3 -237.3)"
        }),
        /* @__PURE__ */ jsx211("path", {
          fill: "none",
          d: "M283.5 574c.4 0 17.7-17.7 17.7-17.7l17.7 17.7 17.7-17.7 17.7 17.7",
          transform: "matrix(.68905 0 0 -.65843 199.3 530.2)"
        }),
        /* @__PURE__ */ jsx211("path", {
          fill: "none",
          d: "M283.5 574c.4 0 17.7-17.7 17.7-17.7l17.7 17.7 17.7-17.7 17.7 17.7",
          transform: "matrix(.68905 0 0 .65843 199.3 -190.7)"
        }),
        /* @__PURE__ */ jsx211("path", {
          fill: "none",
          d: "m301.4 557-.2 158.8",
          transform: "matrix(.68905 0 0 1.24911 199.3 -566.8)"
        }),
        /* @__PURE__ */ jsx211("path", {
          fill: "none",
          d: "m301.4 539.3-.2 176.5",
          transform: "matrix(.68905 0 0 1.12111 211.4 -464)"
        }),
        /* @__PURE__ */ jsx211("path", {
          fill: "none",
          d: "m301.4 539.3-.2 176.5",
          transform: "matrix(.68905 0 0 1.2559 223.6 -548.3)"
        })
      ]
    }),
    /* @__PURE__ */ jsx211("path", {
      fill: "#a77b3b",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 2.5,
      d: "M177.2 696.3c0 24.4-9.6 44.3-21.3 44.3-11.7 0-21.3-19.9-21.3-44.3S144.3 652 156 652s21.3 19.8 21.3 44.3z",
      transform: "matrix(.63605 .25323 -.26502 .60778 361.1 -165.2)"
    }),
    /* @__PURE__ */ jsx211("path", {
      fill: "red",
      fillRule: "evenodd",
      d: "M248.1 175.6h146.5v70H248.1z"
    }),
    /* @__PURE__ */ jsx211("path", {
      fill: "#564dff",
      fillRule: "evenodd",
      d: "M248.1 245.6h146.5v35c0 23.3-36.6 23.3-73.2 46.6C284.7 304 248 304 248 280.6z"
    }),
    /* @__PURE__ */ jsx211("path", {
      fill: "none",
      stroke: "#ff0",
      strokeWidth: 2,
      d: "M336.6 485.4h212.6V645c0 35.4-53.1 35.4-106.3 70.9-53.1-35.5-106.3-35.5-106.3-71V485.5z",
      transform: "matrix(.68905 0 0 .65843 16.2 -144)"
    }),
    /* @__PURE__ */ jsx211("path", {
      fill: "#ff0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 2.5,
      d: "M385.6 129.9S335 185.4 335 238.5c0 53.1 53.1 70.9 53.1 70.9s-17.7 0-17.7 70.8c0 35.5 53.1 17.8 53.1 35.5s-.7 60.5 0 88.6c0 17.7-35.4 0-35.4 17.7 0 8.8 26.6 53.1 53.2 53.1s53.1-44.3 53.1-53.1c0-17.7-35.4 0-35.4-17.7v-88.6c0-17.7 53.1 0 53.1-35.5 0-70.8-17.7-70.8-17.7-70.8s53.2-17.7 53.2-70.9-50.7-108.6-50.7-108.6 28.5 73.2 28.5 108.6c0 17.7-13.3 53.2-48.7 53.2 0 0-9-17.8-17.7 0 0 0-10.2-17.8-17.7 0-2.6 6-7.2-17.8-17.8 0-4.4 4.7-8-17.8-17.7 0-17.7 0-53.1-17.8-53.1-53.2s32.9-108.6 32.9-108.6z",
      transform: "matrix(.48234 0 0 .30917 108.5 140.1)"
    }),
    /* @__PURE__ */ jsx211("path", {
      fill: "#ff0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 2.5,
      d: "M382.7 248c-3.6 3.6 4.6 61.3 7 63.8 3.6 3.5 24.9 3.5 28.4 0 2.5-2.5 0-56.7-3.5-60.2-3.6-3.6-29.4-6-32-3.6z",
      transform: "matrix(.48234 0 0 .30917 110.4 201.6)"
    }),
    /* @__PURE__ */ jsx211("path", {
      fill: "#ff0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 2.5,
      d: "M382.7 248c-3.6 3.6 4.6 61.3 7 63.8 3.6 3.5 24.9 3.5 28.4 0 2.5-2.5 0-56.7-3.5-60.2-3.6-3.6-29.4-6-32-3.6z",
      transform: "matrix(-.48234 0 0 .30917 532.4 201.6)"
    }),
    /* @__PURE__ */ jsx211("path", {
      fill: "#ff0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 2.5,
      d: "M414.6 228.5a16 16 0 1 1-32 0 16 16 0 0 1 32 0z",
      transform: "matrix(.5544 0 0 .38542 82.7 183.7)"
    }),
    /* @__PURE__ */ jsx211("path", {
      fill: "#ff0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 2.5,
      d: "M414.6 228.5a16 16 0 1 1-32 0 16 16 0 0 1 32 0z",
      transform: "matrix(.55441 0 0 .38543 118 183.7)"
    }),
    /* @__PURE__ */ jsx211("path", {
      fillRule: "evenodd",
      d: "M336.8 307.5c0 1.5-2 2.7-4.3 2.7-2.4 0-4.3-1.2-4.3-2.7s2-2.7 4.3-2.7 4.3 1.2 4.3 2.7m-22.3 0c0 1.5-1.9 2.7-4.2 2.7-2.4 0-4.3-1.2-4.3-2.7s1.9-2.7 4.3-2.7c2.3 0 4.2 1.2 4.2 2.7"
    }),
    /* @__PURE__ */ jsx211("path", {
      fill: "#ff0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "m439.4 550-7.8-10.3-12.8 1.7 1.8-12.8-10.3-7.7 10.3-7.8-1.8-12.8 12.8 1.8 7.8-10.3 7.8 10.3 12.7-1.8-1.7 12.8 10.2 7.8-10.2 7.8 1.7 12.7-12.8-1.7z",
      transform: "matrix(.67225 0 0 .64237 26 -133.3)"
    }),
    /* @__PURE__ */ jsx211("path", {
      fill: "#ff0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "m496 591.7 21.3 10.7 21.3-10.7-21.3-10.6z",
      transform: "matrix(.68905 0 0 .65843 16.2 -144)"
    }),
    /* @__PURE__ */ jsx211("path", {
      fill: "#ff0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "m496 591.7 21.3 10.7 21.3-10.7-21.3-10.6z",
      transform: "matrix(.68905 0 0 .65843 -88.8 -144)"
    }),
    /* @__PURE__ */ jsx211("path", {
      fill: "#ff0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "M535 659c-3.5-7-14.1-10.6-21.2-10.6s-14.2 0-21.3 10.7c0-14.2 10.5-21.3 21.3-21.3a22.7 22.7 0 0 1 21.2 21.3z",
      transform: "matrix(.59753 -.3279 .34316 .57097 -165.2 86.5)"
    }),
    /* @__PURE__ */ jsx211("path", {
      fill: "#ff0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "M386.2 652a7 7 0 1 1-14.1 0 7 7 0 0 1 14.1 0z",
      transform: "matrix(.68905 0 0 .65843 13.7 -155.7)"
    }),
    /* @__PURE__ */ jsx211("path", {
      fill: "#ff0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "M386.2 652a7 7 0 1 1-14.1 0 7 7 0 0 1 14.1 0z",
      transform: "matrix(.68905 0 0 .65843 8.8 -139.4)"
    }),
    /* @__PURE__ */ jsx211("path", {
      fill: "#ff0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "M386.2 652a7 7 0 1 1-14.1 0 7 7 0 0 1 14.1 0z",
      transform: "matrix(.68905 0 0 .65843 6.4 -148.7)"
    }),
    /* @__PURE__ */ jsx211("path", {
      fill: "#ff0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "M386.2 652a7 7 0 1 1-14.1 0 7 7 0 0 1 14.1 0z",
      transform: "matrix(.68905 0 0 .65843 18.6 -139.4)"
    }),
    /* @__PURE__ */ jsx211("path", {
      fill: "#ff0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "M386.2 652a7 7 0 1 1-14.1 0 7 7 0 0 1 14.1 0z",
      transform: "matrix(.68905 0 0 .65843 21 -148.7)"
    }),
    /* @__PURE__ */ jsx211("path", {
      fill: "#ff0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "M386.2 652a7 7 0 1 1-14.1 0 7 7 0 0 1 14.1 0z",
      transform: "matrix(.68905 0 0 .65843 13.7 -146.4)"
    }),
    /* @__PURE__ */ jsxs186("g", {
      fillRule: "evenodd",
      children: [
        /* @__PURE__ */ jsx211("path", {
          fill: "#da4500",
          d: "M297.8 120.4c-12.4 0-14 2-19.6 3.9 0-5.4 13.8-11.7 26-11.7 0 3.9-3.2 7.8-6.4 7.8"
        }),
        /* @__PURE__ */ jsx211("path", {
          fill: "#cac9c7",
          d: "M316.5 108c0 2.5-2.2 4.6-4.9 4.6s-4.9-2.1-4.9-4.7 2.2-4.6 4.9-4.6 4.9 2 4.9 4.6z"
        }),
        /* @__PURE__ */ jsx211("path", {
          fill: "#ff0",
          stroke: "#000",
          strokeWidth: 1.1,
          d: "M361.4 357.9v10.6h17.7v53.1h10.7v-53.1h17.7v-10.6h-17.7v-14.2H379v14.2z",
          transform: "matrix(.68905 0 0 .65843 16.2 -144)"
        }),
        /* @__PURE__ */ jsx211("path", {
          fill: "#da4500",
          d: "M304.3 112.6a78.5 78.5 0 0 0-29.3 3.9c0-7.2 8.4-15.6 22.8-15.6 3.2 0 6.5 7.8 6.5 11.7"
        })
      ]
    }),
    /* @__PURE__ */ jsxs186("g", {
      fillRule: "evenodd",
      children: [
        /* @__PURE__ */ jsx211("path", {
          fill: "#008500",
          stroke: "#000",
          strokeWidth: 0.7,
          d: "M67.3 613c-14.2-14.2-16.6-21.4 3.6-10.1l283.7 247.5-3.4 7L67.4 613z",
          transform: "matrix(.38821 .29653 -.14073 .23692 237.4 71.3)"
        }),
        /* @__PURE__ */ jsx211("path", {
          fill: "#008f00",
          d: "M228.4 330.4c.8-10.6-18.6-22-19.4-21.3-.7.8 1.2 7 4.9 10.1-7-3.6-14.4-5.8-14.6-4.3-.6 2.2 11 7.2 12 9.2 0 1.4-8.6 1.2-8.4 2.6.2 1.4 24.3 13.6 25.5 3.7M209 299.6c.8-10.6-18.6-22-19.3-21.3-.8.7 1.1 6.9 4.8 10.1-7-3.6-14.4-5.9-14.6-4.3-.5 2.1 11 7.2 12 9.2.1 1.4-8.5 1.2-8.4 2.6.2 1.4 24.3 13.5 25.5 3.7m-14.8-28c.8-10.6-18.6-22-19.4-21.3-.7.7 1.2 6.9 4.9 10.1-7-3.6-14.4-5.9-14.6-4.3-.5 2.1 11 7.2 12 9.2 0 1.4-8.5 1.2-8.4 2.6.2 1.4 24.3 13.6 25.5 3.7m-14.6-30.4c.7-10.5-18.6-22-19.4-21.3-.8.8 1.2 7 4.8 10.2-7-3.7-14.4-5.9-14.5-4.3-.6 2.1 11 7.2 11.9 9.1.1 1.4-8.5 1.3-8.3 2.7.1 1.4 24.2 13.5 25.5 3.6"
        }),
        /* @__PURE__ */ jsx211("path", {
          fill: "#008f00",
          d: "M184.6 239.9c9.4-5.7 7.5-27.4 6.5-27.6-1.1-.1-5.2 5-5.7 9.8-1.1-7.6-3.6-14.6-5-13.8-2.1.8.4 12.7-.7 14.6-1 1-6-5.8-7-4.8-1.2 1 2.8 26.7 12 21.8zm13.6 26.6c10.8-2.4 16.7-23.4 15.7-23.9s-6.6 3-8.7 7.4c1.6-7.5 1.7-14.9 0-14.6-2.3.1-4 12.1-5.7 13.5-1.3.6-3.7-7.3-5-6.8-1.4.6-6.6 26.1 3.7 24.4m16.2 27.2c9.9-4.8 10-26.6 9-26.8-1-.3-5.5 4.5-6.5 9.2-.4-7.7-2.2-14.8-3.7-14.1-2.2.6-.8 12.6-2 14.4-1.2.9-5.5-6.3-6.7-5.4-1.2.8.4 26.8 10 22.7zm17.6 35.6c10.3-3.9 12.8-25.5 11.8-25.9-1-.3-6 4-7.5 8.6.4-7.7-.6-15-2.2-14.4-2.3.4-2.1 12.5-3.5 14.2-1.3.7-4.8-6.8-6-6-1.3.6-2.5 26.7 7.4 23.5"
        })
      ]
    }),
    /* @__PURE__ */ jsx211("path", {
      fill: "#ff1900",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "M209 776c0 7.8-10.2 14.2-23 14.2s-23-6.4-23-14.2 10.3-14.2 23-14.2 23 6.4 23 14.2z",
      transform: "matrix(.60164 .32097 -.3359 .5749 389.6 -146.8)"
    }),
    /* @__PURE__ */ jsxs186("g", {
      fill: "#ff0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.5,
      children: [
        /* @__PURE__ */ jsx211("path", {
          d: "M156 414.6v-7.1h7v-7.1h7v7h7.2v7.2H170v17.7h-7v-17.7zm7 60.2h7v205.5h-7z",
          transform: "matrix(.49887 .1571 -.1826 .4713 451.4 -3.7)"
        }),
        /* @__PURE__ */ jsx211("path", {
          d: "M159.4 676.8h14.2v56.7h-14.2zM156 439.4h21.3c14.1 0-3.6 39-3.6 39h-14.1s-17.8-39-3.6-39zm17.6-5.4c0 3-3.1 5.4-7 5.4s-7.1-2.4-7.1-5.3 3.1-5.4 7-5.4 7.1 2.4 7.1 5.4z",
          transform: "matrix(.49887 .1571 -.1826 .4713 451.4 -3.7)"
        })
      ]
    }),
    /* @__PURE__ */ jsx211("path", {
      fill: "#ff1900",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "M209 776c0 7.8-10.2 14.2-23 14.2s-23-6.4-23-14.2 10.3-14.2 23-14.2 23 6.4 23 14.2z",
      transform: "matrix(.57449 -.36357 .38048 .54895 -2.3 4.2)"
    })
  ]
});
var Md_default = SvgMd;

// src/country-flag-icons/generated/Me.tsx
init_esm_shims();
import { jsx as jsx212, jsxs as jsxs187 } from "react/jsx-runtime";
var SvgMe = (props) => /* @__PURE__ */ jsxs187("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx212("path", {
      fill: "#d3ae3b",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#c40308",
      d: "M24 24h592v432H24z"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#b96b29",
      d: "M424.5 236.1a58 58 0 0 0 19.4-9.2c7-5.6 8.3-10.1 8.8-12.5.6-2.4.8-4.3-1-3-1.8 1.4-7.1 5.6-10.7 7.6-3.7 2-7 3-9 3.6-2 .5-3.6.9-1.7.1 2-.7 8.1-2.9 13-7.7 4.7-4.8 8.5-12 8.6-16.4 0-4.4-.3-4-1.7-3-1.4 1.1-6.4 7.3-9.3 9.7a90 90 0 0 1-9.7 6.9c-2.3 1.3-5.5 2.8-1-.3 4.5-3 13-10.3 16.5-19.7a35.4 35.4 0 0 0 2.7-15.8c0-1-.8-2.8-1.6-1.1-.8 1.7-6.5 13-11 18-4.6 4.8-3.5 3.9-4.6 4.7-1 .8-2.7 2.2-.5-.6a51.2 51.2 0 0 0 12.2-31.7c0-3.6-1.5-8.6-2.2-10.1-.7-1.5-1.4-2.6-1.7-.9a191 191 0 0 1-5.8 18.4 75 75 0 0 1-6.7 12.8c-.8 1.1-2.8 3.6-.6-.5a77.4 77.4 0 0 0 7-27.6 44 44 0 0 0-2.6-20.9c-1.6-3.1-3-4.2-3-4.2s.3 7.8-2 19-5.7 17-5.7 17-1.5 1.7-.5-1a62.4 62.4 0 0 0 1.4-34.5c-2.3-7.5-6.2-11.3-6.2-11.3-1 10.7-.9 24.5-4.8 35.7-.7-.7-1.7-1.9-2.1.6a63.1 63.1 0 0 1-7 19.4c-4.8 8.8-6.8 10-6.8 10l-1.5-3.4c-.6-1.2-1-1.8-1.8-.2s-3.5 7.8-9.4 14.6-9.2 10.2-9 15.3c.1 5 2.8 7.7 6.4 10 3.6 2.3 4.2 3.6 3.7 6.4-.6 2.8-3.8 3.7-6.6 3.8-2.7.1-6.2-.1-7.5.6-1.2.7-1.3 2.5-2.6 3.7-1.2 1.3-1.8 2-3 2.2l-1 .1c-.2-13.5 5-19.5 5-19.5l-14.6-17.1a50.8 50.8 0 0 1-2.2 1 4 4 0 0 0-.4-.6 11 11 0 0 1-2.6-7.8c.7 0 2.2.6 3.5.3 1.3-.2.3-1.6 0-2.8-.5-1.3-.9-5.7-.6-7.3l.4-2.3s2.1 2.3 3.4 2.3c1.3 0 1.2-1.3 1.4-2.8.3-2.2 1.3-5 3-6.5 0 0 2.4 1.6 5 1.6s6.2-.7 9-3.5c3-2.7 2.9-3.3 2.9-3.3s5.3 1.8 9.3 2c4 .2 8.3-.4 10.4-4.7 2-4.2-.6-8.2-1-8.8-.6-.7-1.9-1.2-1.9 0s.1 4.4-2.4 6c-2.4 1.6-4.3 1.5-6.6.8a20.5 20.5 0 0 0-13.1-.4 17 17 0 0 1 6.1-4.2c3-.9 4.8.4 5.8 1.6 1 1.2 1.9 3 2.7.3.8-2.8.3-6-1-8a7.6 7.6 0 0 0-7.2-3c-3 .2-4 .7-4 .7s-1.5-4.3-5.3-5a21 21 0 0 0-14 3s-3.1.7-6.4-.2a21 21 0 0 1-5.4-2.8l1.1-3.5 1.9-.6c1-.4.7-.7.9-1.5.1-.8-1.8-2.2-1.8-2.2s-.3-2.5 2.9-4.1l2.8-1.4s1.9.3 2.6-.2c.8-.6.8-1 .8-1s1.4-.4 2-1.2c.4-.9.5-2.1.2-3.1-.4-1-.9-1.2-.4-1.7s1-1.6 1-2.4l.1-1s1.1-.4 1-2c0-1.7-.9-2.3-1.4-2.5l-.9-.1s0-1-.9-2.3c-.8-1.4-1.4-2-1.4-2s.6-.4.3-1.5-1.1-1.7-1.9-2c-.7-.2-1.5 0-1.5 0l-3.7-2.1-1.5-.8s0-1-.4-1.6c-.5-.5-1.5-.8-2-.8s-1 .3-1 .3l-6-1.4c-1.8-.2-1.9-.4-1.9-.4s-3.8-1.8-5.2-2l-2-.5s1.6-1.8 1.7-4a6 6 0 0 0-2.8-5l-1.6-.8V93l2.8.3.2-4.6-2.7.3.4-2.7h-5.8l.4 2.7-2.8-.2.3 4.5 3-.4-.4 1.7s-1 .2-2 .9a5.4 5.4 0 0 0-2.6 4.7c0 2.2 1.3 4 1.3 4l-1.8.4c-1.5.3-5.3 2.1-5.3 2.1s0 .2-1.8.4l-6 1.4s-.6-.3-1-.3-1.6.3-2 .8c-.4.6-.5 1.6-.5 1.6l-1.4.8-3.7 2.1s-.8-.2-1.6 0c-.7.3-1.5 1-1.8 2-.3 1.1.3 1.6.3 1.6s-.6.5-1.5 1.9a6 6 0 0 0-.9 2.3l-.8.1c-.6.2-1.5.8-1.5 2.5 0 1.6 1 2 1 2v1c.1.8.6 2 1.1 2.4.5.5 0 .7-.3 1.7-.4 1-.3 2.2.2 3 .5 1 2 1.4 2 1.4s0 .3.7.9 2.6.2 2.6.2l2.9 1.4c3.2 1.6 2.9 4 2.9 4s-2 1.5-1.8 2.3c.1.8 0 1.1.9 1.5l1.9.6 1 3.5a21 21 0 0 1-5.4 2.8c-3.2.9-6.4.2-6.4.2a21 21 0 0 0-13.9-3c-3.8.7-5.4 5-5.4 5s-1-.4-4-.8c-3-.3-5.8 1-7.1 3-1.4 2.1-1.8 5.3-1 8.1s1.6.9 2.6-.3 2.8-2.5 5.8-1.6c3 1 6 4 6.2 4.2 0 0-.5-.3-3.9-.8-3.7-.5-6.9.4-9.2 1.2-2.3.7-4.2.8-6.7-.8-2.4-1.6-2.4-4.8-2.4-6 0-1.2-1.3-.7-1.8 0-.4.6-3 4.6-1 8.8 2 4.3 6.3 5 10.4 4.7 4-.2 9.3-2 9.3-2s0 .6 2.8 3.3a13 13 0 0 0 9 3.5c2.7 0 5-1.6 5-1.6 1.7 1.5 2.7 4.3 3 6.5.2 1.5.1 2.8 1.4 2.8 1.4 0 3.5-2.3 3.5-2.3l.4 2.3a26 26 0 0 1-.6 7.3c-.4 1.2-1.4 2.6 0 2.8 1.3.3 2.7-.2 3.5-.3 0 3.2-.7 5.3-2.6 7.8a4.4 4.4 0 0 0-.4.6 53.9 53.9 0 0 1-2.2-1l-14.6 17.1s5.3 6 5 19.6a20.6 20.6 0 0 1-1-.2c-1.2-.2-1.8-1-3-2.2-1.3-1.2-1.4-3-2.6-3.7-1.3-.8-4.8-.5-7.5-.6-2.8 0-6-1-6.6-3.8-.5-2.8.1-4 3.7-6.4 3.6-2.3 6.3-5 6.4-10 .2-5.1-3-8.5-9-15.3-5.9-6.8-8.6-13-9.4-14.6-.8-1.6-1.2-1-1.8.2l-1.5 3.3s-2-1.2-6.8-10a63 63 0 0 1-7-19.3c-.4-2.5-1.4-1.3-2-.6-4-11.2-3.8-25-4.9-35.7 0 0-3.9 3.8-6.2 11.3-2 6.8-2 14.9-1.3 22 .6 6.7 2 10.7 2.7 12.5 1 2.7-.5 1-.5 1s-3.4-5.8-5.7-17c-2.3-11.2-2-19-2-19s-1.4 1-3 4.2a44 44 0 0 0-2.6 21 77.4 77.4 0 0 0 7 27.5c2.2 4 .2 1.6-.6.5a71 71 0 0 1-6.7-12.8c-2-5.5-5.6-16.6-5.8-18.4-.3-1.7-1-.6-1.7.9s-2.3 6.5-2.2 10.2a51.2 51.2 0 0 0 12.2 31.6c2.2 2.8.5 1.4-.5.6-1-.8 0 .1-4.5-4.7a91.7 91.7 0 0 1-11-18c-.9-1.7-1.6.1-1.7 1.1-.1 1-.7 6.5 2.7 15.8 3.5 9.4 12 16.7 16.5 19.7 4.5 3.1 1.3 1.6-1 .3a90 90 0 0 1-9.7-6.9c-2.9-2.4-7.9-8.6-9.3-9.7-1.4-1-1.7-1.4-1.7 3 .1 4.4 3.9 11.6 8.7 16.4 4.8 4.8 11 7 12.9 7.7 1.9.8.3.4-1.7-.1a40.2 40.2 0 0 1-9-3.6 93 93 0 0 1-10.7-7.6c-1.8-1.4-1.6.6-1 3 .5 2.4 1.9 6.9 8.8 12.5a57.7 57.7 0 0 0 19.4 9.2c2.9.8.9.8.9.8l-6.8-1.4a71.3 71.3 0 0 1-16.7-7.3c-2.3-1.5-2.7-2-2.4 1a20 20 0 0 0 8.9 12.9 49.6 49.6 0 0 0 17.2 4.8c2.5.1 1.8.4.7.5a50.5 50.5 0 0 1-19.2-3.2l-.5-2c-.2-1.2-.9-1-1.2-.8-.4.3-.7.5-2 1.1-1.3.7-1.3-.1-1.4-.5l-.3-3c0-.8-.5-.9-1.1-.6l-4.7 2c-1 .4 0 1.3.5 2.3a147.3 147.3 0 0 0 1.5 2.6l-3.7 1c-.8.2-.6.8-.3 1.4l1.9 4.6c.3.8 1.1.3 1.1.3l2.7-1.6 1 3.7s-1.3.3-2.7 1.2c-1.3 1-1 2.3.7 2.7 1.6.5 3.6 1.4 5.7 5.3 2.2 3.9 2.7 10.9 4 22 1.4 11 8.4 16.6 9.4 17.3 1 .7.4 1.3.4 1.3s-1 1.4-.5 3.5a5.3 5.3 0 0 0 3.2 3.8c1 .3.7 1.3.7 1.3s-.5 2.3 0 6.7c.5 4.3 4 9.1 5 10 1 .8 1 1.2 1 1.6-.2.3-.9 0-2 1a12.2 12.2 0 0 0-3.4 3.6c-.8 1.6-.5 2.5-.2 4.5.2 2.1 3.3 4 3.3 4s-.6.1-.7 1.7c-.1 1.5 1 3.2 2.4 4.4 1.3 1 4 1.6 4 1.6l.3 2.2c.2 1 1.9 1.9 3 2.5 1.1.6 3.3.3 4.2-.2.9-.4 1.5.1 2 1 .6 1 .4 4.4.4 5.8 0 1.4-.8 2.8-.4 3.5.5.7 1.8.2 3.2-.5 1.3-.8 1.6-.2 2.8.5a9 9 0 0 0 3.5 1.4c.5 0 .3-1.3.3-2.3s.2-3.4.7-3.8c.2-.2 2.3-.3 3.8-1 .7-.3 1.7-.6 1.7-1.3.1-.7-1-.7-3.2-1.9-2.3-1.1-2.7-1.8-4.2-2.8-1.4-1-.7-1.3-.7-1.8 0-.4.7-.9 1-1.4.2-.6 0-1.8 0-1.8l1.8-1.8 2-2.3c.8-.6 2-3.6 2.7-4.5.8-1 2.5-2 3.6-3.4a29.7 29.7 0 0 1 11.3-7.6s-.1 2.6 1 3.9 2.6-1 7.5-4.5c5-3.5 8.6-4.7 8.6-4.7l2.4 3.3c1.3 1.6 2.5-.1 8.5-8.5 4.8-6.5 11-12.6 13.5-14.8l1.3.6-.4 1c-.5 1.8-1.4 3-2.6 5.3-1.1 2.4-3 3-5 6.2s-2.4 5.5-2.6 8.8c-.2 3.3 1.7 4 1.7 4s-3 3-4 5.2c-.9 2.2-1.3 6.7-1.3 6.7s-.5.2-1.6 2.5-3.1 2.6-6 5.5c-3 3-6.2 4.2-7.7 5-1.5 1-1 1.9-.7 3 .4 1.2 2.5 2.4 5 3.3 2.3.9 3.2.5 4.8.5 1.7-.1.4 1.2-.3 1.9s-1.6 3.1-1.5 5.8c.2 2.7 2.2 2 4.7 1.6a28 28 0 0 0 5.3-1.6l-.2.8c-.3.7-.4 1.3-.4 3.4 0 2.1.3 3.2 1 3.7.5.6 1.8-.6 2.7-.9.9-.2 2.4-1.1 4.6-1.6 2.2-.5 3-1.5 3-1.5s-.5.7-.6 2.2c-.2 1.6-.1 3.8.2 5.2a9.4 9.4 0 0 0 2.9 4.2c1.5 1.4 1.8.8 3-1 1-1.7 3.3-3.9 3.3-3.9l1.7 5.5c1.5 4.9 6.5 9 6.5 9s5-4.1 6.5-9l1.6-5.5s2.3 2.2 3.4 4c1.1 1.7 1.5 2.3 3 1a9.4 9.4 0 0 0 2.8-4.3c.3-1.4.4-3.6.3-5.2-.2-1.5-.7-2.2-.7-2.2s.8 1 3 1.5 3.8 1.4 4.7 1.6c.9.3 2.1 1.5 2.7 1 .6-.6 1-1.7 1-3.8 0-2.1-.1-2.7-.4-3.4l-.3-.8s2.9 1.2 5.4 1.6c2.5.5 4.5 1 4.6-1.6a10 10 0 0 0-1.4-5.8c-.7-.7-2-2-.4-2 1.7.1 2.5.5 5-.4 2.3-1 4.4-2.1 4.8-3.3.4-1.1.9-2-.7-3-1.5-.8-4.7-2-7.6-5-3-2.9-5-3.2-6-5.5-1.1-2.3-1.6-2.5-1.6-2.5s-.5-4.5-1.4-6.7c-1-2.2-4-5.2-4-5.2s2-.7 1.7-4c-.2-3.3-.5-5.5-2.5-8.8-2.1-3.2-4-3.8-5-6.2-1.3-2.4-2.2-3.5-2.7-5.2l-.4-1a146 146 0 0 1 1.8-.8c2.4 2.2 8.7 8.2 13.5 14.8 6 8.4 7.2 10.1 8.5 8.4l2.4-3.2s3.7 1.2 8.6 4.7c5 3.5 6.4 5.7 7.5 4.4.6-.6.8-1.7.8-2.6a104 104 0 0 1 11.8 4.2c4.3 1.8 4.7 2.8 8.1 5.4 3.4 2.7 8.2 2.5 12.8 1a304 304 0 0 0 21.6-7.5c4.9-2 8.4-4 9-4.9.4-1 1-3.7 1-4.7s-1-2.4-1.4-2.7c-.4-.2-.2-1-.1-1.6 0-.6-.3-2.5-1-3.3-.8-.8-.7-1.1-.6-3.5.2-5-3.4-11.4-8.4-13.4 0 0-.2-.6-.6-1l-1-.6v-3.5c0-.6.2-.5.6-.4.3.2.9.9 1.7 1.1.8.2 1.3-.4 1.5-1.3.2-1 .8-2.8 1.2-3.7.3-1-.1-1-.5-1.2l-2.2-.4c-.6-.1-.6-.2-.4-.5l1-2c.8-1 .1-1.1-.6-1.4a58.4 58.4 0 0 0-4.9-1.3c-.9-.2-1 .6-1 1v2.6c0 .6-.5.4-.9.3a12.6 12.6 0 0 1-1.7-1.2c-.7-.4-1 0-1.3.7l-1.3 4.3c-.2.9-.1 1.5.2 1.6.3.2 2 0 3 0 .9 0 .3.6.3.6l-1.3 2.3c-.4.7-1 .8-1.8.8h-2s-5.3.2-9.2 3-5 5.3-5.6 6.7c-.6 1.4-1.3 1.1-1.9 1.6-.6.5-2.3 2.3-2.3 3.4s.4 1.7-1.3 2.8c-1.7 1.1-3 5.9-.8 8.3 2.3 2.5 3.2 5 4 6.2.6 1.2 0 1.7-.7 1.7s-1.8-1-2.9-1.8l-8.5-6.5c-2.3-1.7-.6-1.5-.6-1.5s.6 0 1.9-.5c1.3-.6 1.5-1.3.2-1.7a16.7 16.7 0 0 1-4.6-2.6c-.7-.7-1-1.4.3-2.1 1.3-.7 4.2-2.6 2-3.2-2.4-.7-5-1.1-7.3-1.8-2.2-.6-2.4-1.2-2.4-1.2l1.5-2.1s1.1-1.7-.2-1.9c-1.4-.2-4.8-.6-7.8-2a18.8 18.8 0 0 1-11.3-12.5v-.1c1.2 2.2 3.8 6.4 7.8 6.5 5.5.2 6.1-1.5 4.9-3.3-1.3-1.8-2.7-3.4-3-4-.4-.5-.5-1.2 1 .2 1.4 1.3 4 5.9 12.3 5.4 8.2-.6 8.2-2.2 8.2-2.6 0-1.6-1.7-1.9-2.7-2.9-.5-.5-.8-1.2.9-.6s5.7 1.4 11.3.2c2.1-.5 8-3 8.5-6 0 0-3.7-.2-6.3-1.3-2.5-1-4-2-1.3-1.4 2.7.5 8 1.6 12.7 0 2.7-.9 6.2-3 6.2-7.1 0 0-5-1-6.9-1.8-1.9-.6-2.5-1.2-2.5-1.2s7.3 2.3 13.8-1c6.6-3.3 6.9-7.9 6.9-9 0-1-.2-1.3-.2-1.3s-6 1.4-10.4 1.4c-4.5 0-5.9-.4-5.9-.4s12.5-.4 18.8-4.2c6.3-3.9 6.7-11.5 6.7-11.5s-7.1 2.6-11.6 3.1-7.2.5-8.3.4c-1.1 0-1.8-.4.7-.5a49 49 0 0 0 17.2-4.8c5.3-3.1 8.6-9.7 8.9-12.8.3-3.1 0-2.6-2.4-1-2.3 1.4-11 5.9-16.7 7.2l-6.8 1.4s-2.2-.1.7-.9zm-225.2 14.4-2.5 1.4-1.3-2.7c-.2-.6-.1-.8.2-.8l2.3-.4h.3c.3.7.6 1.6 1.1 2.4zm76.8 45a20.1 20.1 0 0 1-8.8 7c-3 1.4-6.3 1.8-7.7 2-1.4.2-.2 2-.2 2l1.4 2s-.2.6-2.4 1.3c-2.2.6-5 1-7.2 1.7-2.3.6.6 2.5 2 3.2 1.2.7 1 1.5.2 2.1-.7.7-3.2 2.2-4.6 2.6-1.3.4-1 1.1.2 1.7 1.4.5 5 1.2 5 1.2l-2.3 1.8a18.9 18.9 0 0 1-8.7 3c-2.5.1-6.6.3-11.7 0l-5.8-.3-.5-4.3a21.5 21.5 0 0 0-3-7.8l-3.7-5 .2-1.5c.2-.8 0-1.7-.5-3.3-.6-1.5-3.6-3.8-3.6-3.8l-.2-3.2c0-1.6-1-7.7-2-10.6-1-2.9-5.7-10.5-7.8-14a39.2 39.2 0 0 1-4.3-19.8l.5-1.3a12.9 12.9 0 0 0 3.5 3.2c6.3 3.8 18.8 4.2 18.8 4.2s-1.4.4-5.9.4-10.4-1.4-10.4-1.4-.2.3-.2 1.4c0 1 .3 5.6 6.9 9 6.5 3.2 13.8 1 13.8 1s-.6.5-2.5 1.1c-1.8.7-7 1.8-7 1.8 0 4 3.6 6.2 6.3 7.2 4.7 1.5 10 .4 12.7-.1 2.8-.6 1.2.3-1.3 1.4-2.6 1.1-6.3 1.3-6.3 1.3.6 3 6.4 5.5 8.6 6 5.5 1.2 9.6.4 11.2-.2 1.7-.6 1.4.1.9.6-1 1-2.7 1.3-2.7 2.9 0 .4 0 2 8.2 2.6 8.2.5 11-4 12.4-5.4 1.4-1.4 1.3-.7 1-.1-.4.5-1.8 2.1-3 4-1.3 1.7-.7 3.4 4.8 3.2 4 0 6.6-4.4 7.8-6.6v.1l.3.3a51.7 51.7 0 0 1-2.4 5.3zm66.4-178.2-1.1-2s3 1.4 5 3.5c1.8 2 1.7 3.2 2 4.2.3 1 0 2.9-.3 4.7-.3 1.7-.3 2.8.1 3.4.3.7.7 1 .7 1l-2.7.8c-1.3.6-3 1-4 .2-.9-.8-1.1-1.3-.5-1.8.6-.5 2.8-1.2 3-5 .3-3.7-1.5-7.6-2.2-9m-17 10.3c.8-1.8 1-3.5.5-7.2-.4-3.1-1-5.7-1.2-9 0 0 2.3.4 5.6 3.4s4 6.1 4 7.6-.7 3.4-.9 4.8c0 1.5.4 2.8.4 2.8s-1.1.5-2.2 1.3c-1.1.7-1.9 1.2-3.5 1-1.7 0-2.7-.7-3.7-1.2l-1.5-.6s1.9-1.1 2.6-3zm-16-12.8a14 14 0 0 1 5.6-3.5c-.1 3.4-.7 6-1.2 9-.5 3.8-.3 5.5.5 7.3.7 1.8 2.6 2.9 2.6 2.9s-.6 0-1.6.6c-1 .5-2 1.2-3.6 1.3-1.7 0-2.4-.4-3.5-1.1a14 14 0 0 0-2.3-1.3s.5-1.3.4-2.7c-.1-1.5-1-3.3-1-4.8.1-1.6.8-4.6 4.1-7.7m-11.8 18.3c-1 .8-2.7.4-4-.2l-2.6-.8s.3-.3.6-1c.4-.6.4-1.7.1-3.4-.3-1.8-.5-3.7-.3-4.7.3-1 .3-2.2 2.1-4.2 1.9-2.1 5-3.6 5-3.6l-1.2 2.1c-.7 1.4-2.5 5.3-2.2 9 .3 3.8 2.5 4.5 3 5 .6.5.4 1-.6 1.8zm43.8 31.7c-3.2 1.7-5 1.3-5 2.7.2 1.3 3.1 2.3 3.1 2.3s-3 3.2-5.3 4.6c-2.3 1.5-5 2.4-5 2.4s-1 .2-.4 1.6a5.4 5.4 0 0 0 2.2 2.9l1.1.5s-4 4.3-5.8 5.7a15.3 15.3 0 0 1-4.3 2.5c-1.4.6-.7 3-.4 4 .4 1 1.6 2.5 2.4 2.7.7.2 1 .8 0 2.2-.7 1.1-3 4-4 5.6h-.1l-4.2-5.6c-.9-1.4-.6-2 0-2.2.8-.2 2-1.6 2.4-2.7.3-1 1-3.4-.4-4a15.2 15.2 0 0 1-4.2-2.5 80.2 80.2 0 0 1-5.8-5.7l1-.5a5.4 5.4 0 0 0 2.3-2.9c.5-1.4-.4-1.6-.4-1.6s-2.7-1-5-2.4c-2.4-1.4-5.4-4.6-5.4-4.6s3-1 3-2.3c.2-1.4-1.6-1-4.9-2.7-3.2-1.8-4.3-4.1-4.3-4.1s3.8-1.3 5.7-5a7 7 0 0 0 .7-3.6h.1c6 2 13.1 2.8 19.4 2.8a63 63 0 0 0 19.3-2.8h.2a7 7 0 0 0 .7 3.6c1.9 3.7 5.6 5 5.6 5s-1 2.3-4.3 4z"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M361.2 237.8c0-10.2 4.7-16.7 4.7-16.7l-12.7-14.6c-12.2 4.7-23.3 5-33.2 0-9.9 5-21 4.7-33.1 0L274 221.1s4.7 6.5 4.7 16.6-2 17.8-3.1 22.7c-1.2 5-2.1 14.1.5 20.7a26.3 26.3 0 0 0 16.7 17c11.3 4.8 17.3 7.3 21.2 10.6 4 3.2 5.9 5.9 5.9 5.9s2-2.7 6-6c3.9-3.2 9.8-5.7 21-10.4a26.4 26.4 0 0 0 16.8-17.1c2.7-6.6 1.7-15.8.5-20.7-1.1-5-3-12.5-3-22.6"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#b96b29",
      d: "M357.2 242c-1.6-9.8 4-18.3 4-18.3l-10.9-12.8c-8.4 4.7-20.1 4.1-30.3-.6-10.1 4.7-21.8 5.3-30.2.6l-11 12.8s5.7 8.5 4 18.3c-1.5 9.7-5 25-4.1 31.3.9 6.3 5.3 13.6 9.8 17.4a58 58 0 0 0 16.2 8.7 46.7 46.7 0 0 1 15.3 10s1.5-1.5 3.7-3.2c2.3-1.7 7-5 11.7-6.8a59 59 0 0 0 16.1-8.7c4.6-3.8 9-11.1 9.9-17.4.8-6.3-2.6-21.7-4.2-31.4z"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#1d5e91",
      d: "M356.1 243.1a32.5 32.5 0 0 1 3.2-19l-9.8-11c-8.4 4.4-18.5 3.3-29.5-.6-11 3.9-21.1 5-29.4.7l-9.9 11s4.7 8.4 3.2 18.9-4 22.4-3.6 29.4l.2 1.4h9s.5-.6 1.5-1 1.3-.7 1.3-.7.2-1.8 1.2-2.2c1.1-.4 1.6-.4 2-.4.5 0 .8-.1 1.3-.6.5-.6 2-1.8 2.6-3.6.6-1.9 1-2.6 1-3.8 0-1.2.4-3 .4-3s-.2-.6-1.1-.3c-1 .3-1-.6-1.2-1.5 0-.9 0-2.7.5-3.6l.7-1.1-.4-1.5s-5.7 1.2-6.7-3.3-1.1-6.5-1.3-7c-.1-.5-.3-.7-1-.7-.8 0-2.4-.4-3.6-2.7-1-2.3-1.2-3.3-.8-4.2.3-.9.9-.5 1-.3.3.3 1.8 2.5 2.4 1.9.6-.6.3-.6-.6-2.3-.8-1.8-.5-2.3-.4-3.2l-.3-2.5c0-.4.5-.8 1-.6.6.3 1 .6 1.3 1 .2.2.3.6.8.4.5-.3.2-1.9.2-2.4 0-.6.6-1 1.3-.5a2.2 2.2 0 0 1 1.2 1.8c0 .6 0 1.1.3 1.1s.6-.9.7-1.4c0-.6.4-1.5.9-.7.5.7.7 1.7.5 2.8-.2 1.1.2.5-.2 2.4-.4 2-.6 2.8-.5 4.2 0 1.5 0 2.3.8 4 .7 1.8 1.3 3.8 2.6 3.9h1.7s1.5-2.8 2.6-3.5c1.2-.6 2.8-.7 4-.9 1-.1 1.5-.5 1.5-.8 0-.2-.3-.3-1.7-.5s-2.5-.5-2.6-1.6c0-1 .3-2-.6-2-1 0-3.2-.8-4-2.2-.8-1.5-.6-1.8-.5-2.7 0-.8 1.1-2.4 1.8-.9.7 1.6 1.1 1.8 1.7 2 .5.4 1.3.5 1-.5-.5-1-.7-1.7-.6-2.5 0-.8.6-1.1 1.2-1.2l3.4-1 1-.2s.1-.7 1.4-1a9 9 0 0 1 3-.5c.8 0 1.5.1 2.7-.4a5.7 5.7 0 0 1 2.9-.7 3.7 3.7 0 0 1 1.9.8c.5.3.4.9.4 1.4 0 .5 0 .8.8.8.9 0 1.6 0 2.3.3.8.3 1.8.7 1.2 1.5-.7.8-.7 1.7-1.2 1.7-.4 0-.4.4-.5.7-.2.3-.4.5.1.8.5.3.5.6 1.2 1.2.6.6 1.6 1.3.6 2.3-1 1-2.7 1.8-2.7 1.8s-1 .5.1 1.1c1.2.7 1.7 2 2.1 2.3l1.2.8c.3.1.2 1 .2 1l-1.5.8c-.8.4-1.7.8-2.5.8s-1.3 0-1 .7c.4.8 1 1.6 1.1 2l.3 1.2s1.4.3 2.6.3l4.3-.2c2.6-.3 3.4-.4 5.9-.1 2.5.2 2.9.2 3.5.4l1.4.6s3.5 0 5.5-.5c2-.4 2.4-1.7 2.1-2.4-.3-.6-.2-1.6-3.6-2-3.5-.6-4.8-.4-7.5-.9-2.8-.5-7-1.9-7.7-5.3-.8-3.4 2-4.8 3.3-5.5l5.8-2.3c1.4-.5 3.9-1 6.5-.7 2.7.4 4.2 1 5.3.5 1-.7 1.9-.2 1.7.8-.2 1-1.3 2.9-4.3 3.8-3 .9-6.6 1-8.5.5-2-.6-3.4-1.3-4.6-.9-1.2.4-2.5 1.9-1.3 3.7 1.3 1.7 7.9 2.3 9.6 2.4 1.8.2 8.3-.2 10.2 3 1.8 3.2.3 6.9-1.8 7.7a29 29 0 0 1-5.7 1.5l-1.7.3s.8 1.7.8 2.4-.1 2 .7 2.6c.8.5 2 .9 3.3.7 1.4-.1 3 .8 3.1 2 .1 1.3.5 3 .6 5.5.2 2.5 0 4.5 0 4.5s0 1-.4 1.9c-.3 1-2 4.4-2 4.4h9.5l.2-1.4c.4-7.1-2-19-3.6-29.5z"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#6d8c3e",
      d: "M281.6 278.6a27.4 27.4 0 0 0 11.6 14.3c8.2 5 11.8 4.3 19.5 9.3 7.7 5 7.2 5.8 7.3 5.8.1 0-.4-.8 7.3-5.8s11.3-4.4 19.5-9.3a27.4 27.4 0 0 0 11.6-14.3h-76.7z"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M288.3 237.2c.9 1 1.5 1.2 2.9 1 1.3 0 1.7.9 1.9 2 .2 1 .2 3.5 1.2 5.8s4.2 2.5 4.2 2.5c0-1.1.5-2.6 1-3.9 0-.2.5-1.2-.7-1.2s-1.1-.5-1.8-1.6c-.7-1-2-4-2.4-6a16 16 0 0 1 .6-5.7c.4-1 .4-1.7 0-1.9h-1s.2 1-.1 1c-.3.2-.6-.4-.8-1-.3-.7-.5-.6-1-.6s-.5.5-.1 1c.3.4.1 1.3.1 1.3l-1.4-1c-.5-.2-1.4.2-1.5.8-.1.5.3 2 1.2 2.7s1 2.2.6 3c-.2.6-1.5.5-1.8.2a.8.8 0 0 0-1.2 0c-.4.5-.8.7.1 1.6m-.5-2.5-.7-.6a35.1 35.1 0 0 1-.5-.7l-.1.7c0 .5.6 1.2.6 1.2zm2-6.4c.4-.1.7-.2.4-.7-.4-.5-.6-1-1-1-.3-.2-.6-.1-.6-.1l.5 1.3c0 .5.2.7.6.5zm2.4-2c0 .5 0 .7.4.5.4-.2.5-.7.3-1a2 2 0 0 0-.6-.7l-.3-.2s.2 1 .1 1.5zm3.4.6-.1-1s0 .6-.3 1c-.2.3-.1.2 0 .5.3.2.4 0 .4-.5m5.4 23.5c.7 1.6 2.4-.9 4-2.9s1.5-.4 1.3 1.2a7.6 7.6 0 0 0 1 4.5c.7 1 1.2.4 1.5-.4.2-.7.5-2.4 1-3.2.5-.7 1 0 1 .6.1.7 1 2.2 1.7 3.1.8 1 1.2-.3 1.5-1.4l.7-3.5c.2-.6 1 0 1 0l1.6 1.5c1 1 1.1-.6 1.2-1.4.1-.8-.1-2.5.2-2.8.3-.3 1.2.4 2.5 1 1.4.7 1.3-.6 1.2-1.3a7.4 7.4 0 0 0-2-3.4c-1.2-1-1.3-2-1-2.5.4-.5 1.7 0 2.6-.1l1.8-.3c.7-.2.7-.8.7-.8s-.5-.8-1.4-1.6c-.9-.8-1.4-1.4-2.5-1.6-1.1-.3-2.6 0-2.6 0l-.2-.4c-.1-.3-.4-.3-.6 0l-1.2 1.1c-.4.4-.7.6-1 .5-.2-.2.3-.6.3-.6s.5-.4 1-1.4c.6-1 .7-2 .3-2.6-.4-.4-1.5 0-2.2 0-.6 0-1 .2-1-.2 0-.3.6-.1 1.4-.2.8-.1 1.3-1 1.5-1.9s.5-.6 1-.2c.4.5.9.4 1 0l1-1.8c.5-.8.8-1.9.3-2.6-.6-.8-2-.7-2.6-.2-.6.5-1 1-1.1 2.1-.2 1.2-.5.5-.5.2 0-.4-.4-1-.2-1.5.2-.4 0-1 0-1s-.1-1-1.2-1.1a8.6 8.6 0 0 0-3.5.3c-1 .2-.9 1.2-.9 1.2l-1.7.1c-.9.1-2 .5-2.8.7-.8.2-1.1.3-1.1.7l.1 1.1s.7 0 1 .3.2.5-.2.7c-.4.2-.6.2-.6.7s.2.7.7.7c.4 0 1.3 0 2.3.4s1.3 1.4 1.2 2c0 .5-1.5 1.2-2.3 1.2s-1 .1-1 .6 1 .4 1 .4l2.6.3c1.7.2 2 .6 2.8 1.2.7.7.2.9-.2 1-.4.3-1 .8-1.5 1-.6.2-1 .6-1.5.7-.5.1-1.8 0-4.2 1-2.4 1-3.3 4.1-3.3 4.1l1.4-.7c1.1-.5 2.5-1.2 3.8-2 1.2-.7 1.2.4.6 1.5s.6.9 1 .6l2-1.3c1.2-.6.8.4.8.4s-.4.7-.5 2.5c-.1 1.7 1.7 0 2.5-1 .9-1.1 1.2 0 .6 1.2-.6 1.3-1.8 2.3-2.5 2.3s-1.2-.8-1.3-1.2c0-.4.3-1.7-.1-2-.5-.3-1.7 0-2.6.6-.9.5-1 .1-1.3-.4-.2-.4.3-.6.1-1-.2-.2-.6 0-1 .2l-2.8 1.5c-1.7.9-1.6 1.3-1.6 2.5s.3 1.5 1 3"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "m316.7 224.2 1-.5 1.5-.3c.7 0 .6-.5.4-.8-.1-.4-.4-.5-1.4-.5-.9 0-1.5.5-2 .7l-1.1.4.4.6c.4.5.9.6 1.2.4m3.8 3.7.8-.2 1.3-.6c.6-.2.8-.3 1.2-1 .4-.8-.4-.8-1.5-1-1-.3-1.6 0-1.7.5-.1.4 0 .8-.5 1.6s0 .7.4.7m-.3 1c-1 0-2.3 1.5-2.7 1.8-.4.3-.2.6-.2.6l.4 1.2c.2.7.2 1.7.2 1.7h.8c.6 0 1-.2 1.6-.7a4 4 0 0 1 1.8-.7c.9-.2 1.3-.3 2.2-.8 1-.5-.5-1.4-1.5-2.2a3.7 3.7 0 0 0-2.6-1zm-14 3.6c.8-.1 1.2-.5 1.2-1s-.4-1-1.5-.9c-2.6.3-5.1-.7-5.6-3.2 0 0-.8 1.6.8 3.4 1.6 1.8 4.3 1.8 5.1 1.7m-8.9 41 .5.4h4c.7-.2.7-.8.7-1.2 0-.5.4-2 1-4.7.5-2.6 1.5-4.5 1.9-5.6.4-1-.4-1.4-.7-2l-.8-2.5c-.1-.6-1-.5-1.6-.5-.5 0-.6.9-.7 1.7 0 .8-.4 3.1-.8 5.1-.4 2-2.7 4.7-3.3 5.3-.6.6-1.2.8-1.6.8-.4 0-1.4 0-1.8.3a2.4 2.4 0 0 0-1 1.6c0 .6.9 1 .9 1l1-.8c.3-.4 1-.5 1.5-.6.7-.1.7.1.5.4-.2.3-.1.4.3 1.2zm-6-.2c-.4 0-.6.4-.7.6h2.6a1.4 1.4 0 0 0-.3-.7c-.3-.3-1.1-.1-1.7 0z"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M294.8 273.2a3 3 0 0 0-1 .7h2.9c0-.2.1-.6-.2-.9-.7-.5-1.3 0-1.7.2M319 272c-.3 0-.6.3-1 .6-.5.3-.6.8-.7 1.2a.3.3 0 0 0 0 .1h1.3a.2.2 0 0 0 0-.1c0-.4.2-.7.7-1.1.5-.5 0-.7-.3-.7m2.3 1.3c0-.4-.1-.7-.4-.7-.2 0-.7.5-1 .8a2.4 2.4 0 0 0-.5.5h1.7z"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M332.3 260.4c.8-.6.7-.8.7-1.5 0-.6 0-.8-.3-1a5.9 5.9 0 0 0-2.8-.8c-1.1 0-3.4.3-4.2.8-.9.6-1.3 2.7-1.3 3.8 0 1 .2 1.2.5 1.2s.8-.8.8-.8l1.8 2.5c.7 1 .4 1.4 0 2.2-.2.8-1.4 2.9-2.2 3.3-1 .5-1.6 0-2.6-.1-1.1-.2-1.7.1-2.3.7s0 1.1.4 1.1c.3 0 .8 0 1.2.5.3.3.1 1.2 0 1.6h5.2c.9-.4 1.5-1.6 1.7-2.3.3-.7 1.4-1.7 2-2.2.5-.5.5-.8.5-2s-.2-1.7-.6-2.5c-.5-.8-.8-2-.6-2.6 0-.7 1.2-1.4 2-2z"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M323.7 247.4c.6.9.3 1-.4 1.2a8.5 8.5 0 0 1-2.8.2c-1.1-.1-1.1 0-1.1.6a5 5 0 0 1-.8 2.7c-.7 1-1.6.6-2 .2-.6-.3-.9-.2-1 .4l-1.2 2.1c-.5 1-.9 1-1.3.9-.4-.1-.7-.7-1.1-.7-.4 0-1-.8-1.6-1.8-.6-.9-.9.1-1.3 1-.4.8-.7 1.3-1.5 1.2-.7 0-1.6-1.5-2-2.3-.4-.8-.7-1.6-1.3-1.6-.7 0-1.7 1.4-2.4 1.7-.7.4-1 .3-1.3-.2-.3-.4-.7.2-1.1 1.2-.4 1.1 0 2 .6 2.3.6.3 1.7-.5 2.5-1 .8-.6 1.1-.5 2-.5.8 0 .7 1.4 1 3.3.4 2 1.5 2.2 1.5 2.2s.4.3 1.3-1.1c.9-1.5 1-3 1.8-3 .9 0 1 .2 1.8 1.4.8 1.1 1.5 2 2 1.1.5-.8.9-2.1 1.5-2.6.5-.4 1-.6.4.3-.5.8-.8 1.7.4 1.4 1.2-.4 5.7-2.2 7.6-2.6l4.7-.5 4-.3c1 0 1 0 1.1-.7 0-.7-.5-.5-2.3-.5-1.8 0-3 .2-4.3.4-1.3.2-1.8.2-1.6-.2.2-.3.6-.5 2-.7a58 58 0 0 1 6-.5c1.6 0 1 .5 1 1.5-.2 1 0 2.6.2 3.5 0 1 .1 1.3 1 2.7s3.7 2.2 4.5 2.6c.9.5.7 0 .7-.8s.7-.8 1.4-.3c.7.4 2 .7 2.9 1 .8.2 1 .4 1 .8 0 .5 0 1.5.2 2.4 0 1 0 1.2-.4 1.8l-2 2.3s-.8 0-2.3.4c-1.6.3-2.1 1.1-2.3 1.7-.1.7.3.9.4 1.1v.8h.4c0-.2.3-.5.5-.8.6-.7 2-.9 2.9-.5.6.3.6 1 .5 1.3h3.6l2-3.9a6 6 0 0 0 .6-2.6c0-1.2.2-5.8 0-6-.3-.3 0-1.1 0-2.4-.1-1.3 0-2.3-2.4-2.5-2.4-.2-3.2-1.2-4-2-.8-.8-.6-2.7-1.2-5-.7-2.2-2.3-2.6-5-3.1a23.3 23.3 0 0 0-7-.5c-2.2.2-4.8.5-6.2.4-1.5-.2-1.2.2-.7 1z"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "m337.3 273.4-.5.5h2.4a1 1 0 0 0-.2-.7c-.4-.4-1-.2-1.7.2m4.4-.2a2.2 2.2 0 0 0-.8.7h2.5a1 1 0 0 0 0-.3c-.1-.4-.9-.8-1.7-.4m-61 1.6a24.1 24.1 0 0 0 .5 2.3h77.6l.6-2.3h-78.8zm52.3-37.1c2.4 1.6 10.2 1.7 13.9 2.4 3.6.8 3.4 3.6 2.3 5-1.2 1.5-6.3 1.7-7.2 1.8.5.3 1.2 1.4 1.2 1.4l2.1-.2a11 11 0 0 0 6.1-2c1.9-1.6 1.8-4 .1-5.8-1.6-1.6-4.3-1.8-7-2.1-2.8-.3-5-.5-8-1-3.2-.6-4.7-1.8-4.7-3.6s1.7-2.8 2.9-3.1c1.2-.4 3.1-.9 4.9-.2 1.7.6 3.7.7 7.1.3 3.4-.5 4.2-2.8 4.2-2.8s-.4.2-2.2.2c-1.7 0-3-.7-6-.7-3.2 0-4.3 1-5.8 1.6-1.5.5-5.4.9-6.5 3.4-1.2 2.5.1 3.7 2.6 5.4"
    }),
    /* @__PURE__ */ jsx212("ellipse", {
      cx: 312.6,
      cy: 226,
      fill: "#b96b29",
      rx: 1.5,
      ry: 1.4
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#b96b29",
      d: "M344 228.4c-2-.2-4.5.4-4.5.4s.5.4 1.2.3c.6 0 1.8 0 3.7.3 1.9.3 3.2-.6 3.2-.6z"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#1d5e91",
      d: "M325.6 264.6c-.5-.8-.6-.7-1.2-.2-.5.4-1-1.2-1.1-2.2l.4-4.1s-2.6.5-4 1l-4 .9c-1.1.2-1.8.5-2.4.4-.6-.2-1.9-.2-2.9-.2s-1 .2-2 1.2-1.3 1.5-2 3.4a20 20 0 0 0-1.4 6 15.6 15.6 0 0 1-.7 3.1h12.2l.5-1.2a3 3 0 0 1 1.4-1.4c.5-.2 1-.2 1.2-.8.2-.5.8-1 1.4-1.2.7-.3 1.8-.2 2.8.1 1 .3 1.4-.4 1.7-.8.3-.4.4-1 1-1.6.5-.7 0-1.3 0-1.3l-1-1.1zm19.5.3c-.1-.7 0-.8-.5-.9-.4 0-1.1-.2-1.7-.5-.6-.2-.5 1.4-.5 1.4s-1.5.2-3.1 0-3.5-1.7-4.2-2.2a5.5 5.5 0 0 1-1.4-1.5l-1 .7c-.5.3-.8 1.3-1 2.4 0 1 1.3 2.2 1.4 3.2 0 1-1.2 3.1-1.8 4a9 9 0 0 0-1.2 2.4h5.9a3 3 0 0 1 .6-1c.6-.6 1.6-.7 1.6-.7l.2-.8c.2-.5.9-1.2 2.3-1.8 1.5-.5 3.3-.6 3.3-.6s.7-.6 1.2-1.4c.5-.8 0-2 0-2.7z"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M296.2 329.6c1.1.4 3.2-.4 4.2-1.6 1-1.3 1.4-3.2 2.1-4.3l1.3-1.9s-.2 1.8-1.2 4.3a15.5 15.5 0 0 0-.8 6.8c.4 2.7 2.2 3.1 3.2 2.7.8-.2 2-1.4 3-3.2l1-2c.6-1.3 1.2-3.5 1.5-3.4.7.1.3 1.6 0 2.6-.5 2-1.5 5-1.6 7 0 1.7.2 5 2 5.2 1.8.1 2.8-1.5 3.8-5.2s1.2-5 1.7-5c.4 0 .4 2.6.4 3.7a18.2 18.2 0 0 0 1.6 7.4c.9.8 1.6.7 1.6.7s.7.1 1.6-.7c.9-.8 1.6-6.3 1.6-7.4 0-1 0-3.6.5-3.6s.6 1.2 1.6 4.9 2 5.3 3.8 5.2c1.9-.2 2-3.5 2-5.3 0-1.8-1.1-4.8-1.6-6.9-.5-2 .2-1.9 1.6.8l1.3 2.5c1 1.6 2 2.5 2.6 2.7 1 .4 2.8 0 3.2-2.7.5-2.7-1.6-10.5-1.6-10.5l1 1.3c.7 1.1 1 3 2 4.3 1 1.2 3.1 2 4.2 1.7 1-.4 1.2-2.4.4-6.1s-4-5.7-6.4-8.6a31.6 31.6 0 0 1-4-8.2 27 27 0 0 0-7.9 5.6l-5.9 6.3s-1-1.3-5.8-6.3a27 27 0 0 0-8-5.6c-.2.6-2.2 5.2-4.4 7.9-1 1.3-2.5 2.3-3.6 3.6a12.4 12.4 0 0 0-2.4 5.3c-.8 3.6-.6 5.7.5 6z"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M296 342c1.5-1.2 2.2-2 2.2-2s1-.8.8.9c-.3 1.6-.8 5-.5 6.4.4 1.4.5 2.7 2.3 1.6 1.8-1 2.3-1.7 3.1-2.6.9-.9 1.8-1.3 1.6.1-.3 1.4-.9 3.6-.6 6.4.3 3 1.7 3.3 3.6.9a32.3 32.3 0 0 0 3.5-5.9c.5-1.2 1.6-2.2 1.6 0 0 4.8 1.1 11.8 6.4 13.6 5.3-1.8 6.4-8.8 6.4-13.6 0-2.2 1.1-1.2 1.7 0a32.4 32.4 0 0 0 3.5 5.9c1.8 2.4 3.2 2 3.5-.9.3-2.8-.3-5-.5-6.4-.2-1.4.6-1 1.5-.1s1.3 1.5 3 2.6c1.9 1 2-.2 2.4-1.6.3-1.5-.2-4.8-.5-6.4-.2-1.7.8-.8.8-.8l2.1 2a6 6 0 0 0 3.4 1.2s.9-5-1.2-8c-2-3-2.9-4-2.9-4s-1.1 0-2-.4c-1-.3-1.8-1-1.8-1v2.8l3.1 3.1c.6.8 1.8 2 0 .8a50.5 50.5 0 0 1-3.1-2.4s-.4 2.5-1.1 3.2c-.7.6-1.8.7-2.2.5l-.4-.1-.2 1s1.6 3 1.8 4.1c.3 1.2 0 1-.8-.5-.7-1.5-2.2-3.5-2.8-4.5-.6-1.1-1.6-1.8-1.5-.5.1 1.4-.5 3.9-1 4.8-.4.9-.7 1.2-.7 1.2l1.1 4c.1.7 0 1.5-.5.6-.6-.8-2.1-4.2-2.1-4.2s-2.1 0-2.7-.7c-.6-.6-1.6-2.9-1.6-2.9s-.8 3-1.5 4c-.7.9-2.4 1.8-2.4 1.8l-.2 6c-.2 1-.2 1.3-.6 1.3s-.4-.4-.5-1.3l-.3-6s-1.6-1-2.3-1.9c-.7-1-1.6-3.9-1.6-3.9s-1 2.3-1.5 3c-.6.5-2.7.6-2.7.6s-1.6 3.4-2.2 4.2c-.5.9-.6.1-.5-.5l1.1-4.1s-.3-.3-.7-1.2c-.5-1-1-3.4-1-4.8.1-1.3-.8-.6-1.5.5s-2 3-2.8 4.5-1 1.7-.8.5c.2-1.2 1.8-4.1 1.8-4.1l-.1-1-.5.1c-.4.2-1.4.1-2.2-.5-.7-.6-1-3.2-1-3.2l-3.2 2.4c-1.8 1.2-.6 0 0-.8l3.2-3.1v-2.8s-1 .7-1.8 1c-1 .4-2.1.4-2.1.4l-2.9 4c-2 3-1.2 8-1.2 8s2 0 3.4-1.3zm25.8 33.5L320 373s-.4.8-1.8 2.4a43 43 0 0 1-4.5 4s.3 4.2 1.8 6.5c1.3 1.9 2.5 3.6 4.5 5 2-1.4 3.3-3.1 4.5-5 1.6-2.3 1.9-6.5 1.9-6.5s-3.2-2.4-4.6-4z"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#b96b29",
      d: "M319.4 380.6c0 1 0 3.4.6 3.4s.5-2.4.6-3.4l.2-3.3h-1.6s0 2.3.2 3.3"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M320 151.3c-5.7.1-12.3-.7-16-2l-3.8.8a52 52 0 0 0 19.8 3.3c8.8-.1 13.8-1 19.8-3.3l-4-.8a50.7 50.7 0 0 1-15.8 2m20.5-4.7c-.4-.4-3-2.2-3.7-2.5-.6-.4-.1-1.3 0-1.6.1-.4 3-1.2 4.6-1.7 1.6-.4 1.4-.7 1.4-.7s-1-1.1-6.8-1.7c-5.8-.7-16-.5-16-.5s-10.2-.2-16 .5c-5.8.6-6.8 1.7-6.8 1.7s-.2.3 1.4.7a19 19 0 0 1 4.6 1.6c.1.4.6 1.3 0 1.6a45 45 0 0 0-3.7 2.6c-.5.4-.5 1 .2 1s.7 0 2.7-.4a94.4 94.4 0 0 1 35.2 0c2 .4 2 .4 2.7.4.7 0 .7-.6.2-1"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M333.9 149c-4-.4-6.5-1-13.9-.9-7.4.1-10 .5-13.9 1 2.5 1 6.6 1.5 13.9 1.5s11.4-.5 13.9-1.5zm-15-57.5-.1 2.8 3-.2-.3-2.7 3.3.5.1-2.6-3.4.3.6-2.9h-3.8l.7 2.9-3.3-.3v2.6zm6.5 7.1h-4v-3.4a6 6 0 0 0-1.3-.2l-1 .1v3.5h-4.3a4.6 4.6 0 0 0-.2 2h11v-.6a5.4 5.4 0 0 0-.2-1.4"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#1d5e91",
      d: "M320.1 105a5.5 5.5 0 0 0 5.2-3.4H315a5.5 5.5 0 0 0 5.2 3.5zm2.3-9.5v2.4h2.7a5.3 5.3 0 0 0-2.7-2.4m-4.5 0a5.3 5.3 0 0 0-2.8 2.4h2.8z"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#b96b29",
      d: "m323.3 140-3.3-1.5-3.3 1.7c-1.2.5-1 .4-1.4 1.2-.3.9 0 1.2.6 1.4l4.1 2 4.6-2c.8-.4.7-.8.4-1.5-.2-.6-.7-.8-1.7-1.3"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "m320 139.3-3.5 1.7 3.6 1.9 3.5-1.9zm0-12.3s-.3 1.2-.7 1.8c-.4.5-.7 1-.6 1.7 0 .6.8 1 1.3 1 .4 0 1.2-.4 1.3-1 0-.7-.2-1.2-.6-1.7-.4-.6-.7-1.8-.7-1.8"
    }),
    /* @__PURE__ */ jsx212("circle", {
      cx: 320,
      cy: 132.8,
      r: 0.7,
      fill: "#d4af3a"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M317.6 129.4s1.1-1.3 1.6-2.2l.8-1.5.8 1.5c.4.9 1.6 2.2 1.6 2.2s1.6-1 2.6-4c1-3.2-.3-6.6-.7-10.1a208 208 0 0 1-.8-9.8 7.3 7.3 0 0 1-3.5 1 7.3 7.3 0 0 1-3.6-1s-.3 6.2-.8 9.8c-.4 3.6-1.6 6.9-.6 10 1 3.2 2.6 4 2.6 4z"
    }),
    /* @__PURE__ */ jsx212("ellipse", {
      cx: 320,
      cy: 122.3,
      fill: "#b96b29",
      rx: 2.8,
      ry: 2.7
    }),
    /* @__PURE__ */ jsx212("ellipse", {
      cx: 320,
      cy: 115.8,
      fill: "#b96b29",
      rx: 2.7,
      ry: 2.6
    }),
    /* @__PURE__ */ jsx212("ellipse", {
      cx: 320,
      cy: 109.7,
      fill: "#b96b29",
      rx: 2.6,
      ry: 2.5
    }),
    /* @__PURE__ */ jsx212("ellipse", {
      cx: 320,
      cy: 121.8,
      fill: "#d4af3a",
      rx: 1.5,
      ry: 1.4
    }),
    /* @__PURE__ */ jsx212("circle", {
      cx: 320,
      cy: 115.4,
      r: 1.4,
      fill: "#d4af3a"
    }),
    /* @__PURE__ */ jsx212("ellipse", {
      cx: 320,
      cy: 109.2,
      fill: "#d4af3a",
      rx: 1.3,
      ry: 1.2
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#b96b29",
      d: "M319.9 336c.2.1.2-.3.2-1.2l.4-4c.2-1.2-.3-1.1-.6-1-.3 0-.5.9-.5 1.4l.1 4.2c0 .6.2.6.4.7z"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "m290.4 359.1 5.2-3.6a11.8 11.8 0 0 0 4-4h-1c-.6 0-1-.7-1.1-1.5 0-.8 0-2.3.2-4.1.2-1.8-.3-3.3-.3-3.3s-1.2 1.1-3 2c-2 1-2.7.6-2.7.6l-.4-1.9-2 3.7c-1.1 2-4.2 4.2-6.4 5.8a28.6 28.6 0 0 1-6.4 4c-1.8.7-.7 1.5-.7 1.5s1.8 1.8 6.5 2.7c4.6.8 6.9-1 8.1-1.9"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M306.8 357.3c-1.7-.2-2.7-.8-3-2.6-.2-1.2 0-5.7 0-5.7l-1.1 1.2c-.7.8-2 1-2 1l-1 1.6a9.3 9.3 0 0 1-3 3.2 50.7 50.7 0 0 0-4.6 3.2 28.1 28.1 0 0 1-4.3 3.1 7 7 0 0 0-3.6 4.7c-.5 2.4 0 3.1 1.8 3 1.8-.1 2 0 5-.7 3-.8 7.3-4.1 10.4-6 3-2 5.4-6 5.4-6"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M315 360s-1.2-1.6-1.7-3.4l-1.3-5.4-1.5 3.3c-1 2.1-2.7 2.7-2.7 2.7s0 .9-1.5 2.7a21 21 0 0 1-5.7 4.8c-2.1 1.2-5 3-6.4 5.1-1.5 2.2-1.7 4.4-1 5.4.8 1 1.8-.1 3.2-.9 1.4-.7 5.5-1.3 11.2-4.4 5.6-3 7.4-9.9 7.4-9.9"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M317.5 372.7c1.5-2.4 1.8-8 1.8-8l-1.3-1c-.8-.7-2.2-2.9-2.2-2.9l-2 3.8c-1 1.8-1.5 2.4-3.6 4.3-2.1 2-5 3.9-6.2 6-1.2 2-.5 6.1.3 7.5.8 1.5 2 1 3-.1l3.7-3.3c2.1-1.8 5-4 6.5-6.3"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#b96b29",
      d: "M299 325.3c.8-1.7 1.7-3.7 2.5-4.8a15 15 0 0 0 1.3-2.2s-2 1.8-2.8 3.1c-.8 1.4-1.3 2.6-1.7 4-.3 1.4-.2 1.6.7 0zm8 1.5.5-1.9s.3-1 .1-1.1c-.2-.1-1 .6-1.6 2.5-.5 1.8-1.4 4.5-1.2 4.6.2 0 1.8-3 2.2-4.1m6.3 5 .3-.8s.7-2 .7-2.5c0-.4-.2-1-.8.1s-.6 2.2-.7 2.6c0 .5-.7 2.1-.5 2.3.2.1.6-.9 1-1.7M293.7 351l-.8-.5-1.3 1.5c-.7.7-1.5 1-2 1.7a8 8 0 0 1-2.7 2.3c-1.3.7-1.8 1-1.6 1.1.3.2 1.2-.3 1.2-.3s.3 0 1.9-1c1.6-.9 2-1.4 3-2.3 1-.9 2.3-2.5 2.3-2.5m6.8 8.1c.6-.6 1.3-1 1-1.4-.4-.3-.8-.3-1.4.2l-2.8 2.6-2 1.5c-.7.6-2.3 1.4-3 1.8-.8.5-.1.5-.1.5l1.2-.5 2.5-1s.7-.3 1.6-1c1-.7 2.4-2 3-2.7m7.9 5.5c.5-1 0-.8-.9-.4-.8.3-2.7 2.4-3.8 3.1-1.1.8-2 1.1-3 1.6-.9.4-.9.7-.8.9 0 .2.4.2.8 0l1.6-.9 1-.2c.6 0 1.3-.6 2.4-1.6 1.2-1 2.2-1.5 2.7-2.5m3.7 7.2c-1.4.8-3.8 2.7-4.5 4-.6 1.2-1 2.1-.8 2.3.2.2.9-.2 1.2-.7l.9-1.2s2.4-2.4 3.3-3a8.3 8.3 0 0 0 2.6-3c.4-1 .1-1.4.1-1.4s-1.5 2.1-2.8 3"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#c52126",
      d: "M275 170a22.3 22.3 0 0 0-8.3-2.6c-3.7-.3-6.5.2-9.5 1-2.2.6-4 .7-5.7.3-2.6-.7-4.6-3-5.3-6 0 0-2.4 3.1 0 6.5a7.2 7.2 0 0 0 4.4 2.9c5 1 10-2 14.3-2.4 4-.2 7.3 2.4 7.3 2.4s1 .8 2.3 0c1.4-.8 1.8-1.4.5-2.2z"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "m260.3 317.5-1.2-.2c-.7 0-2.2-.6-2.7-.8-.4-.2-1.1-.2-1.6.3-.4.5-4 2.7-4 2.7h6c2 0 3.5-2 3.5-2"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M277.4 316.4v-.5l-.8-1.8s-1 .6-1.9 1.5c-1.2 1.3-2.4 3-3 3.7-1 1.3-2.4 2.5-1.2.5s1.6-3 2.6-4.4c1-1.3 1.7-2 1.5-2l-3.4-.5c-2.5-.3-4.1-1.3-5.3-2l-3.3-1.9s-4.3 1.9-5.9 2.3c-1.6.4-2.6.6-1 1.4 1.6.8 2.9 1 3.7 1.5a11 11 0 0 0 4.6 1.2c1.4 0 3.9 0 3 1-1 1.1-2.1 3-3.2 6a20.3 20.3 0 0 0-1 7v2.5s1.8-2 6.6-5 6.6-4 7.5-4.4c.9-.4 1.3-.4 1.1-1.5z"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M295.6 302a68.5 68.5 0 0 1-.9-.4 1 1 0 0 0-.2 0 15 15 0 0 0-4.6 4.2c-1.2 1.9-2.4 2-1.1 0a17.9 17.9 0 0 1 3.2-4.2 23.5 23.5 0 0 1 1-.8 53.3 53.3 0 0 1-7.3-4.2l-1.6 2.5c-1 1-3.3 2-3.3 2s1.8-2 2.4-3.3l.8-2.5a31.6 31.6 0 0 1-4.8-4.6 17.8 17.8 0 0 1-4.1 7.4c-3.8 4.2-11.3 6.3-11.3 6.3s-2.6.3-.5.9c2.2.5 3.7 1.5 7.8.8l5-1.1c.6-.2 2 0 0 .7-2 .8-6.9 1.5-8.7 1.4-1.9-.2-4.4-.6-1.8.8 2.7 1.4 3.8 2 5.4 2s2.3.5 3.9.5 2-.3 3-.5c1.2-.3 2 .1 2 .6 0 .4-1.6 1.7-1.5 4.7 0 3.1.3 5.1.5 6 .3 1 1 2.4 1.4 3.2.5.8.7 1.7 1.1-.1.5-1.8 1.5-4.4 1.9-6.1.3-1.7.6-1.8.7-2.7.2-.9 1.2-1.6.7 0a133.4 133.4 0 0 0-1.3 5.2c-.3 1.5-1.1 4.2.2 2 1.4-2 6.4-7.7 7.3-8.8l2-2.8c.7-.8 2.4-1.9 3.3-3.1a28.5 28.5 0 0 1 3.9-4zm-69.5-129.2c0 3.1 3.5 9 5.5 12.2 1.9 3.1 2.4 4.4 2 4.6-.2.2-1-1.4-2.1-2.8s-3.2-4.7-5-7.2c-1.6-2.5-4.2-8.4-4.5-8.9-.4-.5-.5-.9-1.4-.2-.8.7-2.5 7.2-.5 11.6 2 4.4 5 7.6 6.3 9.2 1.3 1.5 3 4 2.7 4.1-.3.2-.8-.4-2.3-2L221 187a51.6 51.6 0 0 1-3.8-6c-.2-.5-.6-.4-.8-.2-.5.6-1.4 1.9-1 5.4a17 17 0 0 0 5.3 10.2c2.3 2.4 4.6 4.5 4.2 4.9-.3.3-2.7-1.8-4.3-3.3-1.6-1.6-5.5-5.4-6.4-6.5-.9-1-2.1-.5-2 3.7 0 4.3 4.7 8.5 6.6 10.9 2 2.3 4.4 3.7 4.2 4.2-.2.5-2.2-.7-3.4-1.6l-7-4.6c-1-.7-1.4.6-.2 4.6 1.2 4 4.7 7.2 6.8 8.7 2 1.5 5.4 3.3 5.2 3.8-.2.4-1.6-.2-3.6-1.1a39.4 39.4 0 0 0-6-2.3c-1.6-.5-1.6.7-1.6.7s-.3 3.5 2.2 6.2a13.3 13.3 0 0 0 8 4.3c2.6.5 3 .6 3 1-.1.4-.4.5-1 .5l-5.4.2c-2.2 0-3.4.6-3.4 1.6s-.1 2.3 3.3 4.6 7.2 2.6 8.8 3c1.6.3 1.7.4 1.4.9-.4.5-1.1.4-3.6.7-2.6.2-4.1 1.2-4.5 2-.3.6.2 2.6 2.3 4 2 1.4 4.8 1.9 8.8 1.6 4-.3 5-.3 5.1.3.2.7-1.2 1-3.2 1.2-2 .4-3.5.4-4.7 1.3-1.1 1-.2 2.9 1.7 4.3 2 1.4 6.8 1.4 8.8 1.3 2-.2 5-.9 5.3-.4.2.6-1.5 1.4-3.6 2.1-2 .8-2.7 1.2-3 2.1-.5.9-.1 1.7 2.3 2.6 2.5 1 6.1 1 8 0 1.9-.8 2.9-1.1 3.2-.8.4.3 0 .7-.4 1.1-.4.5-2 1.8-4 2.3-2.1.6-2.3.6-3 2.2-.8 1.7 1 3 4.8 3.2 3.8.1 8.8-1.4 10.4-2.3 1.6-1 2.2-1.1 2.5-.8.2.3.2.5-.6 1.1-.8.6-3.4 2.5-4.7 2.8-1.2.3-1.4 1.3-1.4 2.1 0 1-.3 2.6 3 3.5 3.4.8 7.3.2 11-2.4a8.3 8.3 0 0 0 2.2-2 28 28 0 0 1 .2-8c-.7 0-2-.3-3.4-.9-2-.8-2.8-2.6-3.3-3.6-.4-1-1.1-1-2-.8-.7.3-1.5.6-2.6.6a7.9 7.9 0 0 1-5.3-2.8c-1.8-2-1.4-4-1.5-5 0-1-1.7-.3-2.5-.3s-3.1-.4-5.3-1.9c-2.1-1.4-2.1-3.4-2.3-4.3-.2-.8-1-1.3-1.7-1.6-.7-.2-1.8-.5-3.3-1.7a6.9 6.9 0 0 1-2-4.4c-.1-.8-1-.8-4-2.4-3-1.5-2.7-4.7-2.6-6 .1-1.3 1.5-2.3 1.5-2.8s-1-.6-2-1.2-3.5-1.6-3.6-5.4c0-3.7 2.4-4.1 2.4-4.1l-1.4-.8c-1-.6-3.8-2.5-3.8-4.7s1-3.2 1.8-3.8 2.7-1 2.7-1-1.3-.9-1.8-2.6c-.5-1.7-.7-3.9.5-5.4 1.3-1.6 3.4-1.6 4.6-1.6 1.1 0 2.1.6 2.5.3.4-.3.5-.6 0-1.5a6.6 6.6 0 0 1 0-3.7c.3-.8.4-2.2 3.2-3.2 2.9-.9 6 1 6.9 1.6.9.5.5-.8.5-1.7 0-1-2-3.3-4.2-6.6a73 73 0 0 1-5.6-10.2 65.7 65.7 0 0 1-4.5-13.4c-.3-1.6-1-.8-1-.8s-.6.2-2.2 4.1a25 25 0 0 0-1.6 10.5"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M276.5 241.4c-1.7-.1-4-1-5.7-3.6-1.7-2.5-4.3-3-8.8-3-4.4.1-6.5-2-7.6-5.2-1.1-3 .1-6.6 4.7-8.9 4.6-2.2 6.7-4.7 6.8-8.6.2-3.9-4.5-8.7-9.3-14.1-4.7-5.5-8.4-13.2-8.4-13.2s-1.4 1.8-1.4 3.7c0 1.8.7 3.7 0 4.2s-1-.8-3.7-2c-2.8-1.2-5-1.4-6.7.6-1.8 2 0 5.4 1.5 7 1.6 1.7 2.9 3 2.4 3.5-.4.6-2.7-.9-3.5-1.4-.8-.5-2.6-2.5-5.3-2.3-2.6.3-3.6 1-3.8 3.3-.3 2.3 2.4 4.2 4.1 5.1 1.7.9 2.4 1.6 2 2-.5.3-.9 0-1.7-.3a8 8 0 0 0-4.3 0c-1.4.6-3.6 2.5-1.5 4.8s6.4 3.2 7.2 3.3c.9.2 1.3 0 1.4.6 0 .7-1.8.7-4.1.8-2.4.1-3 2.4-2.7 4 .3 1.8 4.2 3.7 6.4 4 2.1.4 2.9 0 3 .7.2.6-.2.8-1.4 1.2-1.2.3-3.5.6-4 2.5-.4 1.9-.5 2.7 1.3 4.4 1.8 1.6 4.8 1.4 5.6 1.2.9-.2 2-1.1 2.8-.3.9.9-.8 1.6-2.3 2.6-1.4 1-1.3 3 1.2 4.4 2.5 1.4 5 .9 6 .5 1-.3 2.4-2 3.1-1 .7 1.1-2.2 1.5-3.4 3-1.2 1.4-.7 3.8 1.7 5.3s6.4.4 7-.2c.7-.6 1.6-.8 2.1-.3s-.2 1.9-.8 3c-.5 1.3-1.4 4.8 2.2 6.2s6.9-1.7 7.5-2.3c.6-.6 1.2-.7 1.7-.5.5.3.3.8-.1 1.4-.5.6-1.4 3.2 1.2 5a6.3 6.3 0 0 0 4.7 1l2-7.2h-.6c-.3 0-.4.5-.4.7 0 .2 0 .4-.2.4-.3 0-.4.2-.8.5-.5.3-.9.7-1.1.5-.3-.2 1-.8 1.2-1.2.3-.4 1-1 1-1.4 0-.4.2-.6.9-1.1l.4-.6a100.5 100.5 0 0 0 1.7-12.7zM203 187.6a37.3 37.3 0 0 0 9.3 12.1l-1-3.2c-.4-1.4-.2-2.9-.2-2.9s-1.3-1.7-3.8-5.6c-2.6-3.9-3.9-9.6-3.9-9.6s2.4 5.7 4.2 8.8c1.8 3 4 5.5 4 5.5s.6-2.7 1.2-2.8c.5-.2.9.2 1.3.8.5.6.9.6.9.6l-1.6-2.8-1.5-2.2c-1.5-2.3-4.6-6.6-6.1-10.9-1.6-4.3-5.1-15.1-5.7-18.3-.6-3.2-1.2-1.4-1.8.9a27.6 27.6 0 0 0-1 10.7 53.5 53.5 0 0 0 5.7 18.9m5 21a135.9 135.9 0 0 0 3.5 2.5l-.6-1.7-.3-2.9-2.8-2.5a41.7 41.7 0 0 1-5.6-6c-3-3.6-.6-1.4 1.8 1.2s7 6.3 7 6.3v-.8a3.1 3.1 0 0 1 .7-1.9c.4-.6.2-.6-2.4-2.6a74.5 74.5 0 0 1-17.6-24.4s-1.4 9 4 18.7c5.4 9.9 10.8 13 12.2 14.1zm28.5 56.3c3-1.2 2.1-4.1 2.1-4.1s-1.8.5-3.5 1.2c-1.7.6-5.8 1.8-7.4 1.8-1.7 0-1.7-.2-1.7-.4s1.2 0 3.6-.4a29 29 0 0 0 7.2-3.1c.7-.5.6-.6-.4-.7a4.5 4.5 0 0 1-2.4-.9c-.4-.3-1.5.1-4.2.8a50.8 50.8 0 0 1-21.5.7c-.6-.2-1.3.2.7 3.7 2.1 3.5 9.4 5.3 14.4 5.3s10.1-2.8 13-3.9zm-13.4-7.2c5.2 0 7.1-1.5 7.1-1.5l-.7-1.3c-.7-1-.6-2.9-.6-2.9l-3.4.6c-2.1.3-4.6.6-7.4.1-2.8-.5-1.6-.8.6-.5 2.2.2 6.4-.6 7.8-1 1.4-.5.8-1-.1-1.3-1-.3-3.5-1.9-3.5-1.9s-6.3.8-12.1.2c-6-.7-9.6-2.2-10.8-2.4-1.2-.2-1.2.3-1.2.3s-.3.6 1.8 3.7c2 3.2 6 5.3 9.3 6.3 3.4 1 8 1.6 13.2 1.6m-1.4-12.2-.5-1.3c-.3-1 .6-1.9.6-1.9s-1.2-.3-5.1-.8c-3.9-.5-4.1-.8-6.5-1.3-2.4-.6-4-1.3-4-1.5.1-.3.9 0 2.3.6 1.4.5 7.4 1.2 9.9 1.5 2.5.4 3.9.6 4.3.4.5-.3 2-.7 2-.7l-2.4-.5a8.4 8.4 0 0 1-3.2-1.3c-.7-.5-.9-.6-4-1-3.3-.3-5.8-1.3-11.5-3.4-5.7-2-10-4.6-11.1-5.5-1.2-1-1-.3-.8 1 .3 1.1.3 2.6 3.2 6 2.8 3.3 4.2 4.8 11.5 7.4 7.2 2.7 15.3 2.3 15.3 2.3M200.2 228a40.6 40.6 0 0 0 15.5 6.4c.4-.4-.4-2 0-2.8.4-1.1 1-1.1 2.6-1.2 1.6-.1.5-.4.2-.4l-3-.7c-2.6-.7-5.2-1.1-8.7-2.4-3.5-1.4-4.6-2.3-4.5-2.6.1-.3 1.6.8 5 2 3.2 1.3 7 1.8 9 2.3 2.1.4.3-.5-.7-1-1-.6-2.3-2.8-2.3-2.8s-2.3-.4-6-1.5a48.8 48.8 0 0 1-10-4.2c-1.1-.6-2.2-1.4-3.3-2.2l-5.1-3.7c-1.3-1-1-.2-.8.4s1 3.2 3 6.1c2 3 2.7 3.8 9.1 8.3m-1-12.7c6.3 5 11.7 6.6 12.6 7 1 .4.9-.2.7-.7-.2-.5-.3-2.2-.3-2.2l-4.8-2.8a79.6 79.6 0 0 1-7.1-4.7c-1.9-1.3-.8-1.2-.2-.7.6.5 3.1 2 5.7 3.6l6.4 3.9s.1-.9.7-1.4c.5-.5 1.8-.4 1.8-.4l-1-1.3c-.4-.6-2.5-1.3-4.9-2.4a57.5 57.5 0 0 1-9.6-6.8c-3-2.6-9-9.1-9.5-9.7-.4-.5-.6-.4-.7.3 0 .6-.2 1 .4 4 .7 3 3.5 9.4 9.8 14.3m22.3-47.2c.7 1.5 1.5 2.6 2 3.6a52 52 0 0 1 1.4 2.4s.2-.5 0-1.4c-.1-.8-.2-2 0-3.5l.3-2.3c0-.7-.4-1.4-.5-1.9l-1.5-7c-.5-2.7-1-6.4-.9-9.7 0-3.2.5-1.6.5 0a62.2 62.2 0 0 0 2.8 17.2s0-.9.5-2.1c.5-1.3 1.3-2.7 2-4.2.5-1.6.3-1.9.3-1.9s-2.2-10.6-2.8-15.6c-.6-5-1.5-18.1-1.5-18.1-3.3 3.2-5.7 11.8-6 20-.4 6 .6 11.7.9 14 .5 4.5 1.3 8 2.5 10.5m-7.2 16.8c.1-2.4.7-4.3 2.2-4.8 0 0-1.3-2.4-2.5-5.8a45.7 45.7 0 0 1-1.9-7.7c-.8-5.6-1.5-11.5.2-2 1.7 9.7 3.7 13 3.7 13l2.5 4a17.3 17.3 0 0 1-.4-4.9c.1-1.9.4-4.5 1-6.5 0 0-3-6-4.9-13a82.2 82.2 0 0 1-3.2-22.7s-3 2.3-4 13.9a69 69 0 0 0 7.3 36.5m33.3 88.6-2-1.3c-1.4-.9-1-3.7-1-3.7l-1.4 1a19.2 19.2 0 0 1-3.7 2.2c-1.5.6-2.2 1-3 1.2-1 .3-.8 0 0-.5.8-.4 1-.7 3-1.4 1.9-.8 5.7-4.2 5.7-4.2l-2.5-.1c-1.6 0-3.6-.9-3.6-.9s-1.6 1.4-8 4.2a50 50 0 0 1-11.8 3.5s.7 3.2 3.8 4.3c2.5 1.1 6 1.8 12.9.2a43.5 43.5 0 0 0 11.6-4.5m8.4 6.5c.5-2.7-1-4.6-1-4.6l-1.3 1.1c-1 .9-2.4 2.5-5 3.9-2.8 1.3-3.7 1.2-1.1-.2s6.4-5.3 6.4-5.3l-1-.4c-1-.4-2.8.3-10 4.6s-11.4 4.5-11.4 4.5 3.2 3.9 12 3.6c8.7-.3 11.8-4.5 12.4-7.2m16.5-3.1s-1 1.3-2.3 2.2c-1.3.9-4.7 1.4-4.7 1.4l-.8 1.2c-.7 1-2.2 3-3.7 4-1.6 1.2-4 2-4.1 1.6-.1-.3 1.4-.8 2.9-1.8 1.5-.9 2.8-2.6 3.8-3.7 1-1.2-.4-1-.4-1h-3.5c-1.7-.2-1.4 0-1.9.7l-2.4 3-4.4 5.1c-1 1.2-.2 1.5-.2 1.5s.4.7 4.3 1.2c2.4.2 5 0 7.8-1.6a23 23 0 0 0 5.2-4.5c4.6-5.1 4.4-9.3 4.4-9.3m2 10.5-1.4 1.8 1.2-3c.3-.6.7-1 1-1.4-.7-1.4-1.3-3-1.6-4.7-.5 1.4-1.8 5.5-3.4 8.1-2 3.2-3.8 4.4-2.7 5.3 1.2.8 3.4 1 6-.2 2.4-1.2 3.1-3.3 3.5-5a24.8 24.8 0 0 1-1.2-2.1 5 5 0 0 0-1.3 1.2z"
    }),
    /* @__PURE__ */ jsx212("ellipse", {
      cx: 274,
      cy: 158.6,
      fill: "#d4af3a",
      rx: 1.8,
      ry: 1.6
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M270.3 155.5c1.6 0 2.4-.8 4.2-.6 2.2.2 5 1.4 8.6 3.3a14.6 14.6 0 0 0 9.8.9c1-.3 2-.9 2.9-1.4 4.2-2.4 3.2-7.1 3.2-7.1a16.7 16.7 0 0 1-10.7 3.2l1 .8c.5.6 1.7 1.4 1.3 1.7-.4.3-2-1.2-3.2-2.2a19.4 19.4 0 0 0-6.5-3.2c-3.3-1-7-1-9.5.4-2.5 1.3-2.7 3-2.3 3.7.2.4.6.5 1.1.5zm46.2 34.7c-.8-.2-2.1-.4-3.8-2a71.4 71.4 0 0 1-6.3-7c-.5-.8-.3-1.5.9-2 1.1-.5 2-2 2-2s-2.6-1-4.3-2.2a44 44 0 0 1-6.2-5.7c-.6-1-.3-1 .5-1.3.8-.3 1-.8 1-.8s-1.8-1.2-3.5-2.6a71 71 0 0 1-4-3.6c-2.6 1-6.7.6-8.9.2-3.8-.7-6.6-2.3-6.6-2.3l-.6 1.8c-.5 1.2-2.3 1.8-4 .7-1.8-1.2-1.4-3.7-1.4-3.7s-1.5-1-4.4-2c-3-1.1-5.4-1.3-7.8-.2-2.4 1.1-3.6 4.4-3.6 7 0 2.4 1.4 1.3 1.6 1 .3-.3.9-2.1 3.9-2.6s5.7 1 9.2 3.8c3.4 2.8 4.1 3 5.9 4.8 1.7 1.8.3 2.7-2.6 3.7-3 1-6.8-1-6.9-.9-.6.3 1.3 3 3.8 4 2.6 1 5.8.3 8.3-.8 1.7-.6 2 0 2.6.6a15 15 0 0 1 4 9 4 4 0 0 0 2.6-3c0-.6.2-1.8 1.2-1 1 1 1.7 6 1.7 8.2s-.7 5.3-.7 5.3h.7l2.3-1.2c1.1-.7 1.2 0 1.2 1.3s.4 3.6 2 7.8c1.7 4.2 4.1 5.5 4.1 5.5s.5-.8 1-2.5.8-4.8.8-7.7c0-2.8-.8-8.8-.8-8.8s3.5 4.2 7 5.2c3.6 1 7.2.4 8.7-1.3 1.5-1.7.1-2.5-.6-2.7"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M293 201s-1 2.5-1.7 3.3l-.8 1s1 1 2.6 1.4l3 .8s-1.8-2.4-2.4-4.1l-.7-2.3zm21.4-1.3a71.6 71.6 0 0 0-.8-2.1 15 15 0 0 1-8.2-1.7s1.7 3.3 3.3 4.5l1.9 1.2s-1.7.3-3.9-2c-2.2-2-3.1-4.6-3.1-4.6s.5 5.8-.4 9.3l-1.1 4s4.6.9 9.8-.6c5.2-1.4 5.6-1.9 5.6-1.9s.6-.1-.2-1.2a28 28 0 0 1-2.9-5z"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#b96b29",
      d: "M305 187a11 11 0 0 1-1.8-2.3s-.5.5 0 1.3a15 15 0 0 0 4.3 3.7 11.1 11.1 0 0 0 3 1.2v-.4s-3.9-1.7-5.5-3.5m-6.3 12-.4-8.3c0-1-.7-.8-.7-.8l-.8.3 1.6 10.6c.1 1.2.7 1 1 1-.6-.3-.7-2.5-.7-2.8m-9.8-31.4c-.6-.6-2-1-.7.4s3 3.2 3.5 4.7c.5 1.4.8 3.3 0 2.9-.9-.4-1.5-.4-2.4-1.2a15 15 0 0 0-3.2-2.1c-.7-.2-2 0-1 1a24.8 24.8 0 0 0 4 3.6c1.8 1.3 3 2 4 2.6a36.9 36.9 0 0 0 1.9 1.3s-.9-6-2.5-8.5a26.3 26.3 0 0 0-3.6-4.7m-32 99.2a7 7 0 0 1-2.8 1.3s-.8 0-.8.2 1 0 1.8-.1a8 8 0 0 0 2.6-1.4c.5-.4 1.2-.8 1-1.4-.3-.6-.6.5-1.8 1.4m10.3 5.5-2.2 1.8-1.3.7c-.7.2-.9.6-.9.6s.2.2.9 0 2.7-1.7 3.4-2.3c.7-.6 1-.7.7-1s-.4 0-.6.2M225.3 198c.4.4.8 1 1 .9.2-.2 0-.5-.5-1l-.8-.9-1.1-1.5c-.4-.4-1-.7-.3.3zm-3.2 7 1.4 1.3c.5.5.8 1.1 1.1.8.3-.3-.7-.9-1.2-1.5a7.5 7.5 0 0 0-1.4-1.4 10 10 0 0 0-1.2-.8zm1.2 11.2c.8.9 2 1.1 2.1.8.2-.4 0-.6-.7-1a24 24 0 0 1-2.3-1.4l-1.4-1.1c-.4-.4-.8-.7-1-.6-.1.1 1.1 1.5 1.5 1.7.4.2 1 .8 1.8 1.6m2.3 9c0-.3 0-.5-.6-.5a26.9 26.9 0 0 1-1.6-.2s-1.3-.5-1.3-.2c-.1.3 1 .8 1.5.8l1.4.4c.3.2.6 0 .6-.3m1 9.8c-1.4 0-2.6-.3-2.7 0-.1.1.6.5 1.3.7.8.3 2 .3 3 .4 1 0 1-.2 1-.6 0-.5-1.2-.5-2.6-.5m11 10.8c-.2-.2-.7 0-1.5 0-.8.3-2 .5-2.8.5l-2.4-.1-.9.2c0 .2 1.2.2 3 .4 1.7.2 2.9-.2 3.7-.3.8-.2 1.1-.5 1-.7zm4.6 7.6a5.6 5.6 0 0 1-2.2.4l-2.2.3s-.8 0-.6.4c0 .3.3 0 1-.1h2.3c1.1 0 1.8-.4 2.5-.5.7-.1 1.5-.5 1.2-1-.4-.4-1.2.2-2 .5m8.9 5.8-2.4 1.8-1.2.6c-.7.4-.7.6-.6.8.2.2.6-.3 1-.5.5-.1 1.8-1 2.5-1.6.7-.6 1.6-1 1.5-1.5-.2-.4-.3-.1-.8.4m-14.8-74.8 1.7 2.3c1.6 1.9.7.1.3-.4l-3.4-4.5c-.8-.9-.9-.5-.5 0zm-3.2 9.8c.2-.2-.3-.4-1.2-1.5l-2.6-3.3s-.5-1-.7-1c-.1.1.6 1.8 1.3 2.5.7.7 1.7 2 2.2 2.7.5.6.7.9 1 .6m4.2 18.5c0-.5-1.7-.5-2.5-.6l-2.2-.5s-1.6-.3-1.7 0c0 .1.3.3 1.2.5l3.4.8c1 .1 1.8.3 1.8-.2m-4.2-10c1.1 1 1.9 1.4 2.5 1.7.6.4 1 .8 1.4.5.3-.4-.3-.7-1.3-1.1-1-.5-1.4-.9-1.4-.9l-1-.5c-.6-.3-1.4-.6-.2.3m9.9-6.5-1.4-1s-.8-.8-1-.5c-.2.3 1 1 1.5 1.6.6.5 1.6 1.9 2 1.6.6-.3-.4-1.1-1.1-1.7m-6.5 25.7-1.6.4c-.6.2-.7.4.5.4 1.1 0 1.5-.3 2.7-.5 1-.2 1.5-.3 1.3-.7-.2-.3-.8-.2-1.2 0zm1.7 9.3c0 .2.8 0 1.4-.2.6-.2 1.8-.9 2.5-1 .7-.3.7-.4.7-.8s-.8 0-1.7.2c-.9.3-2 1.2-2 1.2s-.8.4-.9.6m12 5.6c.9-.5 1-.8.7-1-.3-.3-.5-.3-1.2.2a51 51 0 0 1-2 1.5l-1 .5c-.6.2-1.2.7-1 1 .1.1 1.2 0 1.7-.6s2-1 2.8-1.6m5.7 7.5c.3-.3 1.3-.6 1.8-1 .4-.3.7-1.3.3-1.4-.3-.1-.5.4-1.3 1l-3.5 2.4-.7.3c-.8.2-.4.5.2.4.6-.1 1-.1 1.8-.7zm8.3 7.1a10 10 0 0 0 2.3-1.7c.5-.4 1.1-1 .7-1.3-.3-.3-.7.1-1.3.6l-2.1 2.2s-.3 0-1 .7c-1 .7 0 .5.2.3a3 3 0 0 1 1.2-.8"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "m295.2 143.5 3.2 1.4 3.4-2.4-4-1z"
    }),
    /* @__PURE__ */ jsx212("ellipse", {
      cx: 309.2,
      cy: 142.1,
      fill: "#b96b29",
      rx: 3.2,
      ry: 3.1
    }),
    /* @__PURE__ */ jsx212("circle", {
      cx: 309.2,
      cy: 141.4,
      r: 1.9,
      fill: "#d4af3a"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M302.4 131.4c.9.3 2 .2 2 .2s.3-1.4-.5-2.1l-2-1.7-.5-.6-.1 2c0 .8.3 1.9 1.2 2.2z"
    }),
    /* @__PURE__ */ jsx212("circle", {
      cx: 304.2,
      cy: 133,
      r: 0.6,
      fill: "#d4af3a"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "m299.8 132.4-.8.9s.6 0 1.2.4c.5.4 1.2.7 1.8.6.7 0 1-.7.8-1-.1-.5-.4-1-1.5-1.3-1-.4-1.3 0-1.5.4m2.2 3.7c-2 .2-4.7-2-4.7-2-.2 1.8-1.3 2.7-3 3l.1.1s1.6.8 3.5 1.1a7 7 0 0 0 2.5-.2c1-.2 2.3-.5 3-1 1.2-.7.8-2.6.8-2.6s-.2 1.5-2.2 1.6m-7.9-2c-.8-.3-2-.9-2.6-1-.5 0-1.2 0-1.1.9.1 1 1.1 1.4 2 1.4 1 0 1.5-.3 2.1-.6.6-.3.5-.4-.4-.7m-6.3-3.4c-.9-.7-1.7-.9-1.7-.9s-.6 1.6-.3 2.6c.4 1 1 1.2 2 1.2.8 0 2-.5 1.7-1.2a5 5 0 0 0-1.7-1.7"
    }),
    /* @__PURE__ */ jsx212("ellipse", {
      cx: 288.6,
      cy: 135.1,
      fill: "#d4af3a",
      rx: 0.7,
      ry: 0.5
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M290.6 127.3a11 11 0 0 1 2-9.3c2.5-3.6 7-5.1 7-5.1l1.5-1.8c1.4-1.5 4.2-3.4 4.2-3.4l-5.2 1.5a2.3 2.3 0 0 1-2.2 2.4c-.5 0-1-.2-1.3-.4-1 .1-4.4 2.2-5.3 2.9l.3 1.2a2.3 2.3 0 0 1-2.2 2.3c-.4 0-.7 0-1-.2a9.6 9.6 0 0 0-.3.5 23.4 23.4 0 0 0-1.7 3.7c.6.4 1 1.1 1 2 0 1.3-.9 2.3-2 2.3a7.9 7.9 0 0 0 0 1.5c.1.7.4 1.2 1.7 1.6 1.3.3 3.1 2.6 3.1 2.6.1 0 1-1.6.4-4.3"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M298.6 110.3c.5-.4.6-1 .2-1.4-.4-.3-1-.3-1.5.1s-.6 1-.2 1.4c.3.3 1 .3 1.5-.1m-8.5 5.7c.6-.5.7-1.3.3-1.7-.5-.4-1.2-.4-1.8.1s-.6 1.3-.2 1.7c.4.4 1.2.4 1.8-.1z"
    }),
    /* @__PURE__ */ jsx212("circle", {
      cx: 285.1,
      cy: 123.2,
      r: 1.3,
      fill: "#d4af3a"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M313.3 105c-.7.2-2 .6-3.8 1.6 1.3 0 2.3.8 2.3 1.9 0 1-1.1 2.2-2.4 2.2a2.2 2.2 0 0 1-2.2-2.2l.1-.7-1.7 1.2a17.6 17.6 0 0 0-7.2 8c-2 3.8-2.8 8-2 10.4 1 2.5 4.2 3 4.3 3 0 0-.4-.3-.5-.8l.3-1.6v-2.1s.8-.1 1.2.4l1.4 1.7 1.6 1.5s.6-1 .6-2.1-.7-2.3-.9-4.3c-.1-2 1-5.5 2.8-8 2-2.6 5.5-5 6.6-5.5a2.1 2.1 0 0 0 1.3-1.7l.3-2c0-1.2-1-1.1-2-.9z"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M309.2 109.5c.7 0 1.4-.7 1.4-1.3 0-.6-.6-1-1.3-1-.8 0-1.4.4-1.4 1s.6 1.3 1.3 1.3m6.2 24.4c1 .4 2.1.1 2.6-.2.6-.4.7-1.3.1-1.8a2 2 0 0 0-2.1-.2l-2 1.3s.4.5 1.4.9"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M318.6 135c-.4.6-.7.9-1.8 1-1 0-2.3 0-3-.8a7.7 7.7 0 0 1-1.3-1.7h-1.2s-.4 1.7-1 2.1c-.5.5-2.5.6-3.3 0-.9-.7-1.6-1.4-1.8-1.3-.1 0 0 .7.9 1.4s1.5 1.3 2.9 1.3h8s1.6 0 2-1c.5-.9.5-1.5.3-1.7-.2-.3-.4.1-.7.7"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M306.4 133.7c1.2.6 1.9.2 2.3-.3l.6-.8-1.7-.7c-.6-.4-1-.7-1.5-.6l-.6.1s-.3 1.6 1 2.2z"
    }),
    /* @__PURE__ */ jsx212("ellipse", {
      cx: 300.7,
      cy: 121.9,
      fill: "#b96b29",
      rx: 2.7,
      ry: 2.6
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#b96b29",
      d: "M305.3 112.7c-1-.7-2.6-.4-3.5.6-.9 1.1-.7 2.6.4 3.3 1 .7 2.6.4 3.5-.6.8-1.1.7-2.6-.4-3.3"
    }),
    /* @__PURE__ */ jsx212("ellipse", {
      cx: 300.6,
      cy: 121.5,
      fill: "#d4af3a",
      rx: 1.6,
      ry: 1.5
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M304.2 113a1.8 1.8 0 0 0-2 .8c-.3.6.1 1.2 1 1.4 1.7.3 2.5-1.8 1-2.2m-40.7 206s-4.1 2-5.4 2.3l-1.6.4s-2.8 2.5-4.9 3.8a18.3 18.3 0 0 1-7.1 2.4c-3.2.4-12 .3-16 .1-4-.1-6.4.8-8.1 2.7-1.7 2-2.1 4.7 0 6.8 2.2 2.1 4.6 1 5.4-.2.8-1.3.4-3 0-3.7-.3-.8.7-1 1.8-1.1a24.3 24.3 0 0 1 10.7 2.3c1.3.7.6.8-.3.7-1-.2-2-.5-3.5-1.1-1.6-.6-3-1-4-1s-.7.5-.5.9l1 1.6c.1.4-.3 1.9-.3 1.9l.5 1 .8-1.5c.2-.5-.1-1.5.1-2 .2-.4 1-.4 1.7.4a6.7 6.7 0 0 1 1.8 3.5c.3 2-.3 3.3-.3 3.3s.8.7 1 1.1l-.3 2.3s.6.3 1-.7c.6-1 1.2-3 1.3-3.6.2-.7.6-1.9 1.4-1 .8 1 1.4 2 1.5 2.6l.2 1s1.8-1.7 2.4-2.8a17 17 0 0 1 3.6-3.9c1.7-1.4 4.6-4.2 6-5.2 1.5-1 5.2-3 6.4-3.6 1.1-.7 1.3-.8 1.5-2.7.2-2 1.2-3.8 1.6-5.1zm-65.8-73.7c0-.4-.7-1.5-.8-2.1-.2-.6-.8-.3-.8-.3s-1.3.8-2.3 1c-1 .3-1 0-1.2-.6l-.5-3.2c-.2-1-.4-1-.8-.8l-2.4 1c-.9.3-.6.7-.3 1.2l1.6 3.1c.5.7 0 1-.4 1.3l-2.3.6c-1 .4-1 .6-.8 1 0 .3.8 1.7 1.1 2.3.4.6.7.2.7.2s1.1-1 2-1.4c.9-.4 1-.3 1.2.4l1.5 4.8c.2.7.5.6 1 .4l1.6-.4c.5-.2.7-1.3.7-1.3l-2.5-4.4c-.5-1 0-1.1.4-1.2.4 0 1.6-.2 2.6-.5 1-.2.7-.8.7-1.2zm22.3 96.5c-.1-.8 0-1.7-.6-2.3a8.1 8.1 0 0 1-1.8-3c-.3-1 .3-1.6.2-2.2-.1-.6-1-.6-1.7 0-.8.7-1.9 1.3-1.9 3.2 0 2 .7 4.2 3.4 5 2.6.8 2.6.2 2.4-.6zm2.7-.9s-.5-.3-.8.2c-.2.5-.2.7.5 1.9.7 1 1.2 1.3 2 1.8s.2-.5.1-.8c0-.3 0-.7-.2-1s-.3-.5-.3-1.3-1.3-.8-1.3-.8"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M226 350c.5-.8 1-1 2.1-1.5a15.3 15.3 0 0 1 4.2-1c.7 0 2.5-1.4 2.2-3-.3-1.4-1.4-2-2.3-2.2-1-.3-1.8-.3-2.1.2-.3.5-.9 1-2 1.4s-1.1.7-1.8 1c-.6.1-.1.5-.7 1-.5.4-1.3 0-2.1-.3-.9-.2-1-.4-1.9-.4l-3.4-.2h-.7c-.6 0-.6 0-.9.6s.1 2.1.7 2.9c.6.7 2.6 1 3.9 1.5l3 .8c1.2.1 1.3 0 1.8-.8m12.2 1.2c1-.7.4-2 .2-2.7-.3-.7-1.7-.9-2.5-.9-.7 0-1.1 0-1.5.4-.4.3-1 .8-2 1.2-1.2.3-2 .7-3.6 1.3-1.5.6-2 1.6-2.6 2-.6.4-1.9 0-1.9 0s-.9-.2-1.2 0c-.3.3 0 .8.6 1.5.6.6 1.8.6 3 1 1.4.4 1.6 0 2.1-.3s1-1 1.8-1.6c1-.6 3-.7 3.9-.8 1-.1 2.6-.4 3.7-1.1m0-4.6c.4.4 1 1 1.3.3.4-.6 1-2 .6-2.8-.4-.8-1-1.5-1-1.5l-1 3c-.4.5-.4.6 0 1zm-4-7c0-1.2-1-2.8-1-2.8s-.3 1.2-.9 2.2c-.5 1-1 1.6-1 1.6l1.7.4c.5 0 1.1 0 1.1-1.3zm-7.6 2.8c1.4-.2 2.1-.8 2.7-1.3.6-.5 1-1.9.6-2.6-.4-.7-1.4-1.4-1.8-1.4h-.8s-.4 1.3-1 2c-.5.6-1.1 1-1 1.9 0 .8-.1 1.7 1.3 1.4m2.8-6.3a2.4 2.4 0 0 0-.6-1.9l-.8-.7-.2 1.6-.1.6.7.6c.4.1 1 .4 1-.2m-17.3-35.7 1-6a39 39 0 0 0-6.3-15.4c-2.4-3.8-5-10-6-13.2a37.4 37.4 0 0 1-2-10c0-2.3 1-3.5 1-3.5s.5-.6.1-1-1 0-1.7.6a7.5 7.5 0 0 0-1.5 2.6l-.3 1.1s-1.2-.3-3.3-.1c-2 .2-3 .3-3 .8 0 .4.3.7 1.7 1.4 1.5.6 2.4.9 3.1 1.7.8.9 2.6 5.2 3.2 7.3.6 2.1 1.8 7.8 2.3 12.2a49 49 0 0 0 4 14.4c.8 1.5 4.5 8.5 7.7 7zm3.7 10.4c-1.4.8-1.3 6.4-.7 9.3.6 2.9 3.4 6.5 4.3 7.5.9 1 1 1 1.5.7l.7-.2s1.2-.5 2.1-1.2c1-.7.6-2.5.4-4-.1-1.6-1.4-4.8-3.6-8.5-2.2-3.6-3.3-4.4-4.7-3.6m1.5-4.5c0-1.9-1.6-3.2-3.4-3.2-.9 0-1.6.2-2.1.6-1.9 1.7-.7 5.8 2 5.8.9 0 2-.1 2.7-.8.7-.6.8-1.6.8-2.4m26.5 52.7a7 7 0 0 1-2.2-1.2 10 10 0 0 1-3.1-3c-.3-.7-.3-.7-1.4-.4-1 .4-2.5.3-3.6.4-1 0 .2 1.3 1 2.4.7 1.2.4 5.1.4 5.1l-.1.9c-.2.6 0 1 .2 1 .3.2.5 0 1.3-1 .8-.9 2.2-3.2 2.2-3.2l1.4.3c1.2.3 3.1.1 4.1-.2 1-.3.6-1-.2-1.1"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M239.2 362c-.5 0-.7-.1-1 .2l-.6 1.4c-.1.3 0 .6.2.9l.8.5s.4.5.8.7c.5.2.5-.4.5-.9l.3-1.9c0-.6-.4-.8-1-.9"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#1d5e91",
      d: "M435 324.2c-1.3-.3-1.9-.8-1.9-.8s-.5 0-1 .7c-.3.8-2 1.8-2 1.8s-2.2.6-2.5 2.2c-.3 1.5.8 2 1.8 1.9 1.1-.2 3.7-.7 4.9-2.1 1.1-1.4 1.3-2.2 1.5-2.7.2-.5.4-.7-.9-1zm3.5-12.4a15 15 0 0 0-7.4-9.9l-2.1 7.5c-.5 1.8-.5 1.7.9 2l6.7 1.6c.9.3 2.4 1 1.9-1.2m-20.6-3.2c1 .1 1-.3 1.3-1.7l2.1-8.2s-4.5-.1-8.5 1.8c-3.9 1.9-5.6 5.4-5.6 5.4s1 .4 3.7 1 6 1.5 7 1.6zm-10.5 9.3-2.2-.4s1 3.8 2.7 6c1.7 2.2 3.5 3.2 7 3.3 3.5 0 6-1.9 6.5-3.4.4-1.5 1.1-2.6 1.1-2.6s-6.2-.8-8.8-1.4z"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "m406.3 315.5 15.5 3c1 .3 2 .5 2.2.2.3-.3.5-.5 1.6-.9 1.2-.4 1.1-1.5 1.1-1.5l.4-2.2c.2-1 .8-1.4 2-.1 1.3 1.3 1.5 3.2 1.7 5 .3 2 3.2 2.4 4.4 2.6 1.1.2 1.6-.2 2.3-1.3.7-1 1-3.2 1.2-4.6.2-1.4 0-1.2-1.4-1.6l-9.3-2.2c-1.2-.2-1-1-.7-1.9.1-.8 2.8-9.2 2.8-9.2a18.9 18.9 0 0 0-7.7-2.3l-2.3 10c-.3 1.3-1.2 1.3-2.5 1-1.4-.2-11.3-2.5-11.3-2.5l-.8 1.8a15.5 15.5 0 0 0-1.1 5.2c0 1.2.4 1.2 1.9 1.5"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M440.3 323.3c-1.3-.9-2.3-1.1-3 .5-.7 1.6-.7 4-2.4 5.6-1.8 1.7-4.2 3.4-6.6 3.2-2.4-.2-3.7-.7-3.2-3.5.6-2.7 4.3-3.6 5.1-5 .9-1.5.7-3.1-.6-4.2-1.3-1.1-3.1-1.3-3.6-1a8 8 0 0 0-2.8 3.7c-.7 2-1.2 3.7-2.8 5a12.2 12.2 0 0 1-9 2c-3.1-.8-4.3-1.8-5.5-5-1.2-3.1-2.6-8.3-3.2-9-.7-.5-1.5-1-2.8 0-1.4 1-1.5 2.4-1.7 3.6-.2 1.1 0 2.5 1.4 4.1 1.4 1.7 2.8 3.3 3.3 5 .5 1.8 2 4.4-.1 4.5-2.2.2-3.2.2-4.8-1.4-1.7-1.6-8.2-6-10-7.4a29 29 0 0 0-2.5-2c-3 0-6-1.2-9-3.3 0 0 1.8 4.4 2.1 6.1.4 1.7.3 2.6.3 2.6l9.1 4.6a168 168 0 0 1 10.3 5.8c2.5 1.5 4.7 4 9.1 3 4.5-.9 13.5-3.6 16.5-4.5 2.9-.9 11-2.9 14-5 3-2 3.2-1.9 3.7-4 .5-2 0-3.1-1.3-4m-17.2-31 2.2-.3c1.5-.1 1 1.3.7 1.9l-1.4 2.7c-.6 1 .2 1.2.6 1.4l2.3.6c1.3.3 1-.6 1-1l.3-3.8c.1-.9 1-.6 1.2-.5l1.7 1c.6.3 1 0 1-.4l.8-2c.2-1-.4-.8-1-.8h-2.4c-1 0-.4-1-.4-1l1.3-2.1c.6-.9.4-1-.2-1.2l-2.8-.7c-.5-.1-.7 0-.7.3l-.1 2.7c0 .7 0 1-1 1-.8.1-1.3-.4-2-1.1-.7-.8-1-.5-1-.2l-.8 3c-.2.7.1.6.6.6zm4.8 21.8s-.1 1.7-.3 2.3c-.2.7-.6 1.6.1 1.8.8.2 1.4.5 1.8.4.5-.1.3-1 0-1.7a6.4 6.4 0 0 0-1.1-2.2zm10.5 7c.2.5.7.6 1 .7.4.1 1 .1 1-.5s0-1.5-.5-2.2c-.5-.8-.8-1.3-1.1-.2-.4 1-.6 1.6-.4 2.2m-36.7-7 1.4.4s0-1.7.3-2.8c.2-1.2.7-2 .3-2-.4 0-.7.4-1 .9-.3.5-1.1.6-1.4 2-.3 1.3.1 1.4.4 1.4z"
    }),
    /* @__PURE__ */ jsx212("circle", {
      cx: 408.9,
      cy: 311.2,
      r: 2.3,
      fill: "#b96b29"
    }),
    /* @__PURE__ */ jsx212("circle", {
      cx: 415.5,
      cy: 312.8,
      r: 2.4,
      fill: "#b96b29"
    }),
    /* @__PURE__ */ jsx212("circle", {
      cx: 434.6,
      cy: 316.9,
      r: 2.4,
      fill: "#b96b29"
    }),
    /* @__PURE__ */ jsx212("circle", {
      cx: 422.1,
      cy: 314.4,
      r: 2.4,
      fill: "#b96b29"
    }),
    /* @__PURE__ */ jsx212("circle", {
      cx: 423.8,
      cy: 308.6,
      r: 2.4,
      fill: "#b96b29"
    }),
    /* @__PURE__ */ jsx212("circle", {
      cx: 425.5,
      cy: 302.9,
      r: 2.4,
      fill: "#b96b29"
    }),
    /* @__PURE__ */ jsx212("circle", {
      cx: 409.1,
      cy: 310.9,
      r: 1.2,
      fill: "#d4af3a"
    }),
    /* @__PURE__ */ jsx212("circle", {
      cx: 415.6,
      cy: 312.6,
      r: 1.2,
      fill: "#d4af3a"
    }),
    /* @__PURE__ */ jsx212("circle", {
      cx: 434.8,
      cy: 316.6,
      r: 1.2,
      fill: "#d4af3a"
    }),
    /* @__PURE__ */ jsx212("circle", {
      cx: 422.2,
      cy: 314.1,
      r: 1.2,
      fill: "#d4af3a"
    }),
    /* @__PURE__ */ jsx212("circle", {
      cx: 424,
      cy: 308.4,
      r: 1.2,
      fill: "#d4af3a"
    }),
    /* @__PURE__ */ jsx212("circle", {
      cx: 425.7,
      cy: 302.6,
      r: 1.2,
      fill: "#d4af3a"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "m349.5 359.1-5.2-3.6a11.8 11.8 0 0 1-3.9-4h1c.6 0 1-.7 1-1.5.1-.8 0-2.3-.2-4.1-.2-1.8.3-3.3.3-3.3s1.3 1.1 3.1 2c1.9 1 2.6.6 2.6.6l.5-1.9 2 3.7c1 2 4.1 4.2 6.3 5.8 2.2 1.7 4.6 3.4 6.4 4 1.8.7.8 1.5.8 1.5s-1.8 1.8-6.5 2.7c-4.7.8-7-1-8.2-1.9"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M333.2 357.3c1.7-.2 2.7-.8 3-2.6.2-1.2-.1-5.7-.1-5.7l1.2 1.2c.6.8 2 1 2 1s.2.6.9 1.6a9.3 9.3 0 0 0 3 3.2c1.6 1 3.5 2.2 4.7 3.2a28.1 28.1 0 0 0 4.2 3.1 7 7 0 0 1 3.6 4.7c.6 2.4.1 3.1-1.7 3-1.9-.1-2 0-5-.7-3-.8-7.3-4.1-10.4-6-3.1-2-5.4-6-5.4-6"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M325 360s1.2-1.6 1.6-3.4l1.4-5.4 1.4 3.3a4.9 4.9 0 0 0 2.8 2.7s0 .9 1.5 2.7a21 21 0 0 0 5.6 4.8c2.2 1.2 5 3 6.5 5.1 1.5 2.2 1.6 4.4 1 5.4-.8 1-1.8-.1-3.2-.9-1.5-.7-5.6-1.3-11.2-4.4-5.6-3-7.5-9.9-7.5-9.9z"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M322.5 372.7c-1.6-2.4-1.8-8-1.8-8l1.3-1c.7-.7 2.2-2.9 2.2-2.9l2 3.8c1 1.8 1.4 2.4 3.6 4.3 2 2 5 3.9 6.1 6 1.3 2 .6 6.1-.2 7.5-.8 1.5-2 1-3.1-.1L329 379c-2.1-1.7-5-4-6.5-6.3"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#b96b29",
      d: "M341 325.3c-.8-1.7-1.8-3.7-2.5-4.8a15 15 0 0 1-1.3-2.2s2 1.8 2.8 3.1c.8 1.4 1.3 2.6 1.6 4 .4 1.4.2 1.6-.6 0zm-8 1.5-.5-1.9s-.3-1-.2-1.1c.2-.1 1 .6 1.6 2.5.6 1.8 1.5 4.5 1.3 4.6-.2 0-1.9-3-2.2-4.1m-6.3 5-.4-.8s-.6-2-.6-2.5c0-.4.2-1 .7.1s.6 2.2.7 2.6c.1.5.7 2.1.5 2.3-.1.1-.5-.9-1-1.7zm19.5 19.2.9-.5 1.2 1.5c.7.7 1.5 1 2 1.7a8 8 0 0 0 2.8 2.3c1.3.7 1.8 1 1.5 1.1-.2.2-1.1-.3-1.1-.3s-.4 0-2-1c-1.5-.9-1.9-1.4-2.9-2.3zm-6.8 8.1c-.6-.6-1.2-1-.9-1.4.4-.3.8-.3 1.3.2l2.9 2.6 2 1.5c.7.6 2.3 1.4 3 1.8.8.5 0 .5 0 .5l-1.2-.5-2.4-1-1.7-1c-1-.7-2.4-2-3-2.7m-7.8 5.5c-.5-1 0-.8.8-.4.9.3 2.8 2.4 3.9 3.1 1 .8 2 1.1 3 1.6.8.4.8.7.8.9 0 .2-.4.2-.8 0l-1.7-.9-1-.2c-.5 0-1.3-.6-2.4-1.6-1.1-1-2.1-1.5-2.6-2.5m-3.7 7.2c1.4.8 3.8 2.7 4.4 4 .6 1.2 1 2.1.9 2.3-.3.2-1-.2-1.2-.7l-1-1.2s-2.4-2.4-3.2-3a8.3 8.3 0 0 1-2.7-3c-.3-1 0-1.4 0-1.4s1.4 2.1 2.8 3"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#c52126",
      d: "M365 170a22.3 22.3 0 0 1 8.3-2.6c3.6-.3 6.4.2 9.5 1 2.1.6 3.9.7 5.6.3 2.6-.7 4.6-3 5.3-6 0 0 2.4 3.1 0 6.5a7.2 7.2 0 0 1-4.3 2.9c-5.1 1-10.1-2-14.3-2.4-4.1-.2-7.3 2.4-7.3 2.4s-1 .8-2.4 0c-1.3-.8-1.7-1.4-.4-2.2z"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "m379.6 317.5 1.2-.2c.7 0 2.2-.6 2.7-.8.5-.2 1.2-.2 1.6.3.5.5 4.1 2.7 4.1 2.7h-6c-2.1 0-3.5-2-3.5-2z"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M362.6 316.4v-.5l.8-1.8s1 .6 1.8 1.5c1.2 1.3 2.5 3 3 3.7 1 1.3 2.5 2.5 1.3.5s-1.6-3-2.6-4.4l-1.6-2 3.4-.5c2.5-.3 4.2-1.3 5.3-2l3.3-1.9s4.3 1.9 6 2.3c1.6.4 2.5.6 1 1.4-1.6.8-3 1-3.7 1.5a12 12 0 0 1-4.6 1.2c-1.5 0-4 0-3 1a22 22 0 0 1 4.2 13l-.1 2.5s-1.8-2-6.6-5a71 71 0 0 0-7.4-4.4c-.9-.4-1.3-.4-1.2-1.5z"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M344.4 302a68.5 68.5 0 0 0 .8-.4h.3c.5.3 3.4 2.3 4.6 4.2 1.2 1.9 2.4 2 1 0a17.9 17.9 0 0 0-3.2-4.2 23.4 23.4 0 0 0-1-.8 53.3 53.3 0 0 0 7.3-4.2c.4.6 1 1.7 1.7 2.5 1 1 3.2 2 3.2 2s-1.8-2-2.4-3.3l-.8-2.5a31.7 31.7 0 0 0 4.8-4.6c.3 1.3 1.3 4.2 4.2 7.4 3.7 4.2 11.2 6.3 11.2 6.3s2.6.3.5.9c-2.1.5-3.6 1.5-7.8.8l-5-1.1c-.5-.2-2 0 0 .7 2.1.8 7 1.5 8.8 1.4 1.8-.2 4.4-.6 1.7.8-2.6 1.4-3.7 2-5.3 2s-2.3.5-4 .5c-1.5 0-2-.3-3-.5-1.2-.3-1.9.1-1.9.6 0 .4 1.5 1.7 1.5 4.7 0 3.1-.3 5.1-.6 6-.3 1-1 2.4-1.4 3.2-.4.8-.6 1.7-1-.1-.5-1.8-1.5-4.4-1.9-6.1l-.8-2.7c-.1-.9-1.1-1.6-.6 0a133.4 133.4 0 0 1 1.2 5.2c.4 1.5 1.1 4.2-.2 2-1.3-2-6.4-7.7-7.2-8.8l-2.1-2.8c-.7-.8-2.4-1.9-3.2-3.1a28.5 28.5 0 0 0-4-4zm69.5-129.2c-.1 3.1-3.5 9-5.5 12.2-2 3.1-2.5 4.4-2.1 4.6.3.2 1.1-1.4 2.2-2.8l4.9-7.2c1.7-2.5 4.2-8.4 4.6-8.9.3-.5.4-.9 1.3-.2s2.6 7.2.5 11.6c-2 4.4-5 7.6-6.2 9.2-1.3 1.5-3 4-2.7 4.1.3.2.7-.4 2.3-2a47.3 47.3 0 0 0 9.6-12.5c.2-.4.5-.3.8 0 .5.5 1.4 1.8 1 5.3a17 17 0 0 1-5.3 10.2c-2.3 2.4-4.6 4.5-4.3 4.9.4.3 2.7-1.8 4.3-3.3 1.6-1.6 5.6-5.4 6.4-6.5 1-1 2.2-.5 2.1 3.7 0 4.3-4.7 8.5-6.7 10.9-2 2.3-4.3 3.7-4.1 4.2.2.5 2.1-.7 3.4-1.6l7-4.6c.9-.7 1.3.6.1 4.6-1.2 4-4.6 7.2-6.7 8.7-2 1.5-5.4 3.3-5.2 3.8.2.4 1.6-.2 3.5-1.1 2-1 4.3-1.8 6-2.3 1.6-.5 1.6.7 1.6.7s.4 3.5-2.1 6.2a13.3 13.3 0 0 1-8 4.3c-2.6.5-3 .6-3 1s.4.5 1 .5l5.3.2c2.3 0 3.5.6 3.5 1.6s0 2.3-3.3 4.6c-3.5 2.3-7.3 2.6-8.9 3-1.6.3-1.6.4-1.3.9.3.5 1 .4 3.6.7 2.5.2 4 1.2 4.4 2 .3.6-.2 2.6-2.3 4-2 1.4-4.7 1.9-8.7 1.6-4-.3-5-.3-5.2.3-.1.7 1.2 1 3.2 1.2 2 .4 3.6.4 4.7 1.3 1.2 1 .3 2.9-1.7 4.3-1.9 1.4-6.7 1.4-8.7 1.3-2-.2-5.1-.9-5.3-.4-.2.6 1.5 1.4 3.5 2.1 2.1.8 2.7 1.2 3.1 2.1.4.9 0 1.7-2.4 2.6a12 12 0 0 1-8 0c-1.8-.8-2.8-1.1-3.2-.8-.3.3 0 .7.4 1.1.4.5 2 1.8 4.1 2.3 2 .6 2.3.6 3 2.2.8 1.7-1.1 3-4.9 3.2-3.7.1-8.7-1.4-10.3-2.3-1.6-1-2.2-1.1-2.5-.8-.3.3-.2.5.6 1.1.8.6 3.3 2.5 4.6 2.8 1.3.3 1.4 1.3 1.4 2.1 0 1 .4 2.6-3 3.5-3.3.8-7.3.2-10.9-2.4a8.3 8.3 0 0 1-2.2-2 28 28 0 0 0-.3-8c.7 0 2-.3 3.4-.9 2-.8 2.8-2.6 3.3-3.6s1.2-1 2-.8c.8.3 1.6.6 2.7.6a7.9 7.9 0 0 0 5.3-2.8c1.7-2 1.4-4 1.5-5 0-1 1.6-.3 2.4-.3.8 0 3.2-.4 5.3-1.9 2.2-1.4 2.2-3.4 2.4-4.3.2-.8 1-1.3 1.7-1.6.7-.2 1.7-.5 3.2-1.7 1.5-1.2 2-3.5 2-4.4.2-.8 1-.8 4-2.4 3-1.5 2.8-4.7 2.6-6 0-1.3-1.5-2.3-1.5-2.8s1-.6 2-1.2 3.6-1.6 3.6-5.4c0-3.7-2.4-4.1-2.4-4.1l1.5-.8c1-.6 3.7-2.5 3.7-4.7s-1-3.2-1.7-3.8c-.7-.5-2.7-1-2.7-1s1.2-.9 1.8-2.6c.5-1.7.7-3.9-.6-5.4-1.2-1.6-3.4-1.6-4.5-1.6-1.2 0-2.2.6-2.6.3-.4-.3-.4-.6 0-1.5.4-.8.4-3 .1-3.7-.3-.8-.4-2.2-3.3-3.2-2.9-.9-5.9 1-6.8 1.6-1 .5-.5-.8-.5-1.7 0-1 1.9-3.3 4.1-6.6 2.2-3.4 3.2-5.1 5.7-10.2A65.7 65.7 0 0 0 409 159c.4-1.6 1-.8 1-.8s.7.2 2.2 4.1a25 25 0 0 1 1.7 10.5"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M363.4 241.4c1.7-.1 4-1 5.7-3.6 1.7-2.5 4.3-3 8.8-3 4.5.1 6.6-2 7.7-5.2 1-3-.2-6.6-4.8-8.9-4.5-2.2-6.6-4.7-6.8-8.6-.1-3.9 4.6-8.7 9.3-14.1 4.8-5.5 8.5-13.2 8.5-13.2s1.4 1.8 1.4 3.7c0 1.8-.7 3.7 0 4.2s.9-.8 3.7-2c2.7-1.2 5-1.4 6.7.6 1.7 2 0 5.4-1.6 7-1.5 1.7-2.8 3-2.4 3.5.4.6 2.8-.9 3.5-1.4.8-.5 2.6-2.5 5.3-2.3 2.7.3 3.6 1 3.9 3.3.2 2.3-2.4 4.2-4.2 5.1-1.7.9-2.4 1.6-2 2 .5.3 1 0 1.7-.3a8 8 0 0 1 4.3 0c1.4.6 3.6 2.5 1.6 4.8-2.1 2.3-6.4 3.2-7.3 3.3-.8.2-1.3 0-1.4.6 0 .7 1.8.7 4.2.8 2.3.1 3 2.4 2.7 4-.4 1.8-4.3 3.7-6.4 4-2.2.4-3 0-3.1.7-.2.6.2.8 1.4 1.2 1.2.3 3.6.6 4 2.5.4 1.9.5 2.7-1.3 4.4-1.8 1.6-4.7 1.4-5.6 1.2-.9-.2-1.9-1.1-2.8-.3-.8.9.8 1.6 2.3 2.6 1.5 1 1.4 3-1.1 4.4-2.5 1.4-5 .9-6 .5-1-.3-2.5-2-3.2-1-.7 1.1 2.2 1.5 3.4 3 1.2 1.4.8 3.8-1.6 5.3-2.5 1.5-6.4.4-7.1-.2-.7-.6-1.6-.8-2-.3-.6.5.2 1.9.7 3 .5 1.3 1.5 4.8-2.2 6.2s-6.9-1.7-7.5-2.3c-.6-.6-1.2-.7-1.7-.5-.5.3-.2.8.2 1.4.4.6 1.4 3.2-1.2 5a6.3 6.3 0 0 1-4.7 1c-.6-2-1.3-4.2-2-7.2h.5c.4 0 .5.5.5.7 0 .2-.1.4.2.4.3 0 .3.2.8.5.4.3.8.7 1 .5.3-.2-.9-.8-1.2-1.2-.3-.4-1-1-1-1.4 0-.4-.2-.6-.8-1.1a2.4 2.4 0 0 1-.5-.6 97.9 97.9 0 0 1-1.2-7.2 57.1 57.1 0 0 1-.4-5.5zm73.7-53.8c-3.9 7.8-9.3 12.1-9.3 12.1l1-3.2c.3-1.4.1-2.9.1-2.9s1.4-1.7 3.9-5.6c2.5-3.9 3.8-9.6 3.8-9.6s-2.3 5.7-4.1 8.8c-1.9 3-4 5.5-4 5.5s-.7-2.7-1.2-2.8c-.5-.2-1 .2-1.4.8-.4.6-.8.6-.8.6l1.5-2.8 1.6-2.2c1.4-2.3 4.5-6.6 6-10.9a169 169 0 0 0 5.7-18.3c.7-3.2 1.3-1.4 1.9.9.6 2.3 1.4 5.7.9 10.7a53.5 53.5 0 0 1-5.6 18.9m-5 21a135.9 135.9 0 0 1-3.5 2.5l.5-1.7.3-2.9 2.9-2.5a41.7 41.7 0 0 0 5.6-6c2.9-3.6.5-1.4-1.9 1.2-2.3 2.6-6.9 6.3-6.9 6.3v-.8a3.1 3.1 0 0 0-.7-1.9c-.4-.6-.2-.6 2.3-2.6a73.8 73.8 0 0 0 17.6-24.4s1.5 9-4 18.7c-5.4 9.9-10.8 13-12.2 14.1m-28.5 56.3c-3-1.2-2.2-4.1-2.2-4.1s1.8.5 3.5 1.2a36 36 0 0 0 7.5 1.8c1.6 0 1.6-.2 1.7-.4 0-.2-1.3 0-3.7-.4a29 29 0 0 1-7.2-3.1c-.7-.5-.6-.6.5-.7a4.5 4.5 0 0 0 2.3-.9c.4-.3 1.5.1 4.2.8a50.6 50.6 0 0 0 21.5.7c.7-.2 1.4.2-.7 3.7-2 3.5-9.3 5.3-14.4 5.3-5 0-10-2.8-13-3.9m13.4-7.2c-5.2 0-7.2-1.5-7.2-1.5l.7-1.3c.7-1.1.6-2.9.6-2.9l3.4.6c2.2.3 4.7.6 7.5.1s1.6-.8-.6-.5a29 29 0 0 1-7.8-1c-1.4-.5-.9-1 0-1.3 1-.3 3.5-1.9 3.5-1.9s6.3.8 12.2.2c5.9-.7 9.6-2.2 10.8-2.4 1.1-.2 1.1.3 1.1.3s.3.6-1.7 3.7c-2 3.2-6 5.3-9.4 6.3a50.3 50.3 0 0 1-13.1 1.6m1.3-12.2.6-1.3c.3-1-.6-1.9-.6-1.9s1.2-.3 5-.8c4-.5 4.2-.8 6.5-1.3 2.4-.6 4-1.3 4-1.5 0-.3-.8 0-2.2.6a94 94 0 0 1-14.3 1.9c-.4-.3-2-.7-2-.7l2.4-.5a8.4 8.4 0 0 0 3.2-1.3c.7-.5 1-.6 4.1-1 3.2-.3 5.8-1.3 11.5-3.4 5.6-2 10-4.6 11-5.5 1.2-1 1.1-.3.8 1-.3 1.1-.2 2.6-3.1 6-2.9 3.3-4.3 4.8-11.5 7.4-7.3 2.7-15.4 2.3-15.4 2.3m21.4-17.6a40.5 40.5 0 0 1-15.5 6.4c-.3-.4.4-2 0-2.8-.3-1.1-1-1.1-2.6-1.2-1.5-.1-.5-.4-.1-.4l3-.7c2.5-.7 5.1-1.1 8.6-2.4 3.6-1.4 4.6-2.3 4.5-2.6 0-.3-1.6.8-4.9 2-3.2 1.3-7 1.8-9 2.3-2.2.4-.4-.5.6-1 1-.6 2.4-2.8 2.4-2.8s2.3-.4 6-1.5a48.8 48.8 0 0 0 10-4.2l3.2-2.2 5.2-3.7c1.3-1 .9-.2.7.4s-1 3.2-3 6.1c-2 3-2.7 3.8-9 8.3zm1-12.7c-6.2 5-11.7 6.6-12.6 7-1 .4-.8-.2-.7-.7.2-.5.3-2.2.3-2.2l4.8-2.8c2.5-1.4 5.3-3.4 7.2-4.7 1.8-1.3.7-1.2.1-.7-.5.5-3.1 2-5.7 3.6l-6.4 3.9s0-.9-.6-1.4c-.5-.5-1.9-.4-1.9-.4l1-1.3c.5-.6 2.6-1.3 4.9-2.4 2.3-1 6.5-4.2 9.6-6.8 3.1-2.6 9.1-9.1 9.5-9.7.4-.5.7-.4.7.3 0 .6.3 1-.4 4s-3.4 9.4-9.7 14.3zM418.5 168c-.7 1.5-1.5 2.6-2 3.6L415 174v-1.4c.1-.8.3-2 0-3.5 0-.8-.3-1.6-.2-2.3 0-.7.3-1.4.4-1.9l1.6-7c.4-2.7.9-6.4.8-9.7 0-3.2-.5-1.6-.5 0s-.1 4-.6 7.8c-.5 3.7-2.1 9.4-2.1 9.4s-.1-.9-.6-2.1l-1.9-4.2c-.6-1.6-.4-1.9-.4-1.9s2.3-10.6 2.8-15.6c.6-5 1.6-18.1 1.6-18.1 3.2 3.2 5.6 11.8 6 20 .4 6-.6 11.7-1 14-.5 4.5-1.3 8-2.5 10.5zm7.2 16.8c0-2.4-.6-4.3-2.2-4.8 0 0 1.4-2.4 2.6-5.8a45 45 0 0 0 1.8-7.7c.9-5.6 1.6-11.5-.1-2-1.7 9.7-3.8 13-3.8 13l-2.4 4c.3-1.7.4-3 .3-4.9 0-1.9-.3-4.5-1-6.5 0 0 3-6 5-13a81.4 81.4 0 0 0 3.1-22.7s3 2.3 4 13.9a68.4 68.4 0 0 1-7.3 36.5m-33.2 88.6 1.9-1.3c1.5-.9 1-3.7 1-3.7a48.7 48.7 0 0 0 5.2 3.2c1.4.6 2.1 1 3 1.2 1 .3.7 0 0-.5-.8-.4-1-.7-3-1.4-2-.8-5.8-4.2-5.8-4.2l2.5-.1c1.6 0 3.6-.9 3.6-.9s1.6 1.4 8 4.2a50 50 0 0 0 11.8 3.5s-.6 3.2-3.7 4.3c-2.6 1.1-6 1.8-13 .2a43.5 43.5 0 0 1-11.5-4.5m-8.4 6.5c-.6-2.7 1-4.6 1-4.6l1.3 1.1c1 .9 2.3 2.5 5 3.9 2.7 1.3 3.7 1.2 1-.2a39.3 39.3 0 0 1-6.3-5.3l1-.4c1-.4 2.7.3 10 4.6 7.1 4.3 11.4 4.5 11.4 4.5s-3.2 3.9-12 3.6c-8.7-.3-11.9-4.5-12.4-7.2m-16.6-3.1s1 1.3 2.3 2.2c1.3.9 4.8 1.4 4.8 1.4l.8 1.2c.6 1 2.1 3 3.7 4 1.5 1.2 4 2 4 1.6.2-.3-1.3-.8-2.8-1.8-1.5-.9-2.9-2.6-3.9-3.7-1-1.2.5-1 .5-1h3.5c1.7-.2 1.3 0 1.8.7l2.4 3 4.4 5.1c1 1.2.3 1.5.3 1.5s-.5.7-4.4 1.2c-2.4.2-5 0-7.7-1.6a23.4 23.4 0 0 1-5.2-4.5c-4.7-5.1-4.5-9.3-4.5-9.3m-2 10.5 1.5 1.8s-.7-2-1.3-3l-.9-1.4c.7-1.4 1.2-3 1.6-4.7.4 1.4 1.7 5.5 3.4 8.1 2 3.2 3.8 4.4 2.6 5.3-1.1.8-3.4 1-6-.2-2.4-1.2-3-3.3-3.4-5a24.8 24.8 0 0 0 1.2-2.1c.3.2.8.5 1.3 1.2"
    }),
    /* @__PURE__ */ jsx212("ellipse", {
      cx: -365.9,
      cy: 158.6,
      fill: "#d4af3a",
      rx: 1.8,
      ry: 1.6,
      transform: "scale(-1 1)"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M369.7 155.5c-1.6 0-2.5-.8-4.3-.6a26 26 0 0 0-8.5 3.3 14.6 14.6 0 0 1-9.8.9c-1-.3-2-.9-2.9-1.4-4.3-2.4-3.2-7.1-3.2-7.1a16.7 16.7 0 0 0 10.6 3.2l-.9.8c-.6.6-1.7 1.4-1.4 1.7.4.3 2-1.2 3.3-2.2 1.3-1 3.2-2.2 6.5-3.2s7-1 9.4.4c2.5 1.3 2.7 3 2.4 3.7-.2.4-.7.5-1.2.5m-46.2 34.7c.8-.2 2-.4 3.8-2a69 69 0 0 0 6.3-7c.5-.8.3-1.5-1-2-1-.5-1.9-2-1.9-2s2.5-1 4.3-2.2c1.7-1.2 5.6-4.8 6.2-5.7.5-1 .3-1-.5-1.3-.9-.3-1-.8-1-.8s1.8-1.2 3.5-2.6a71 71 0 0 0 4-3.6c2.6 1 6.6.6 8.8.2 3.8-.7 6.7-2.3 6.7-2.3l.6 1.8c.5 1.2 2.2 1.8 4 .7 1.8-1.2 1.4-3.7 1.4-3.7s1.4-1 4.4-2c3-1.1 5.3-1.3 7.7-.2 2.4 1.1 3.6 4.4 3.6 7 0 2.4-1.3 1.3-1.6 1-.3-.3-.8-2.1-3.8-2.6s-5.8 1-9.2 3.8c-3.4 2.8-4.2 3-6 4.8-1.6 1.8-.3 2.7 2.7 3.7s6.7-1 6.9-.9c.5.3-1.3 3-3.9 4-2.5 1-5.8.3-8.3-.8-1.7-.6-2 0-2.5.6a15 15 0 0 0-4 9 4 4 0 0 1-2.6-3c-.1-.6-.3-1.8-1.2-1-1 1-1.8 6-1.8 8.2s.7 5.3.7 5.3h-.7l-2.3-1.2c-1-.7-1.2 0-1.2 1.3s-.4 3.6-2 7.8c-1.7 4.2-4 5.5-4 5.5s-.5-.8-1-2.5a33 33 0 0 1-.8-7.7c0-2.8.7-8.8.7-8.8s-3.4 4.2-7 5.2-7.1.4-8.6-1.3c-1.5-1.7-.2-2.5.6-2.7"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M347 201s1 2.5 1.6 3.3c.6.9.9 1 .9 1s-1.1 1-2.7 1.4a35.5 35.5 0 0 1-3 .8s1.8-2.4 2.4-4.1l.7-2.3zm-21.5-1.3a71.6 71.6 0 0 1 .9-2.1 15 15 0 0 0 8.1-1.7s-1.6 3.3-3.3 4.5l-1.8 1.2s1.6.3 3.8-2c2.2-2 3.2-4.6 3.2-4.6s-.5 5.8.4 9.3l1 4s-4.6.9-9.8-.6c-5.2-1.4-5.6-1.9-5.6-1.9s-.6-.1.2-1.2a28 28 0 0 0 3-5z"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#b96b29",
      d: "m335 187 1.7-2.3s.6.5 0 1.3a16 16 0 0 1-4.2 3.7c-1.6.9-3.1 1.2-3.1 1.2v-.4s4-1.7 5.5-3.5zm6.3 12 .4-8.3c0-1 .6-.8.6-.8l.8.3-1.5 10.6c-.2 1.2-.7 1-1 1 .5-.3.6-2.5.7-2.8m9.8-31.4c.6-.6 1.9-1 .6.4-1.3 1.4-3 3.2-3.4 4.7-.5 1.4-.8 3.3 0 2.9.8-.4 1.4-.4 2.3-1.2 1-.7 2.6-2 3.3-2.1.7-.2 2 0 1 1a24.8 24.8 0 0 1-4 3.6l-4 2.6a36.9 36.9 0 0 1-2 1.3s1-6 2.6-8.5a26.3 26.3 0 0 1 3.6-4.7m32 99.2c1.2 1 2.8 1.3 2.8 1.3s.7 0 .7.2-.9 0-1.8-.1a8 8 0 0 1-2.6-1.4c-.4-.4-1.1-.8-.9-1.4.2-.6.6.5 1.8 1.4m-10.4 5.5 2.3 1.8 1.3.7c.6.2.8.6.8.6s-.1.2-.8 0c-.7-.2-2.8-1.7-3.5-2.3-.6-.6-1-.7-.7-1 .3-.2.4 0 .6.2m42-74.4c-.4.4-.9 1-1 .9-.3-.2 0-.5.4-1l.8-.9 1.1-1.5c.4-.4 1-.7.3.3zm3.1 7-1.3 1.3c-.5.5-.9 1.1-1.2.8-.3-.3.7-.9 1.2-1.5a7.5 7.5 0 0 1 1.4-1.4 10 10 0 0 1 1.3-.8zm-1.2 11.2c-.8.9-2 1.1-2 .8-.2-.4 0-.6.7-1a24.4 24.4 0 0 0 4.6-3c.2 0-1 1.4-1.4 1.6-.4.2-1 .8-1.9 1.6m-2.2 9c0-.3-.1-.5.5-.5l1.6-.2s1.3-.5 1.4-.2c0 .3-1 .8-1.6.8l-1.4.4c-.3.2-.5 0-.5-.3m-1 9.8c1.4 0 2.6-.3 2.7 0 0 .1-.7.5-1.4.7-.7.3-2 .3-3 .4-.9 0-1-.2-1-.6 0-.5 1.3-.5 2.7-.5m-11 10.8c.1-.2.6 0 1.4 0 .8.3 2.1.5 2.8.5l2.4-.1 1 .2c0 .2-1.3.2-3 .4-1.8.2-3-.2-3.8-.3-.8-.2-1-.5-.9-.7zm-4.6 7.6a6 6 0 0 0 2.1.4l2.3.3s.7 0 .6.4c-.1.3-.4 0-1-.1h-2.4c-1.2 0-1.8-.4-2.5-.5-.7-.1-1.5-.5-1.1-1 .4-.4 1.1.2 2 .5m-9 5.8 2.5 1.8 1.1.6c.8.4.7.6.6.8-.1.2-.6-.3-1-.5a16.4 16.4 0 0 1-2.5-1.6c-.7-.6-1.6-1-1.4-1.5.1-.4.3-.1.8.4zm14.9-74.8-1.7 2.3c-1.6 2-.7.1-.4-.4l3.4-4.5c.8-.9 1-.5.5 0zm3.2 9.8c-.2-.2.3-.4 1.1-1.5l2.7-3.3.6-1c.2.1-.6 1.8-1.3 2.5-.7.7-1.6 2-2.1 2.7-.5.6-.8.9-1 .6m-4.3 18.5c0-.5 1.8-.5 2.6-.6l2.2-.5s1.6-.3 1.6 0c0 .1-.3.3-1.2.5l-3.3.8c-1 .1-1.9.3-1.9-.2m4.3-10a15.3 15.3 0 0 1-2.5 1.7c-.6.4-1.1.8-1.4.5-.4-.4.2-.7 1.2-1.1l1.5-.9 1-.5c.5-.3 1.3-.6.2.3m-10-6.5 1.4-1s.9-.8 1-.5c.2.3-1 1-1.5 1.6-.5.5-1.5 1.9-2 1.6-.5-.3.5-1.1 1.2-1.7zm6.6 25.7 1.5.4c.7.2.7.4-.4.4s-1.6-.3-2.7-.5-1.5-.3-1.3-.7c.1-.3.7-.2 1.2 0zm-1.8 9.3c.1.2-.8 0-1.4-.2-.5-.2-1.7-.9-2.4-1-.7-.3-.7-.4-.7-.8s.7 0 1.6.2c1 .3 2 1.2 2 1.2l1 .6zm-12 5.6c-.8-.5-1-.8-.7-1 .3-.3.6-.3 1.2.2a51 51 0 0 0 2 1.5l1.1.5c.5.2 1.2.7 1 1-.2.1-1.2 0-1.7-.6s-2-1-2.9-1.6m-5.6 7.5c-.4-.3-1.4-.6-1.8-1-.5-.3-.8-1.3-.4-1.4.4-.1.6.4 1.4 1l3.5 2.4.7.3c.7.2.4.5-.2.4-.7-.1-1-.1-1.8-.7zm-8.4 7.1a9.2 9.2 0 0 1-2.2-1.7c-.5-.4-1.2-1-.8-1.3.4-.3.8.1 1.4.6l2.1 2.2s.2 0 1 .7c.9.7 0 .5-.3.3a3 3 0 0 0-1.2-.8"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "m338.2 142.5 4-1 2.5 2-3.1 1.4z"
    }),
    /* @__PURE__ */ jsx212("ellipse", {
      cx: -330.8,
      cy: 142.1,
      fill: "#b96b29",
      rx: 3.2,
      ry: 3.1,
      transform: "scale(-1 1)"
    }),
    /* @__PURE__ */ jsx212("circle", {
      cx: -330.8,
      cy: 141.4,
      r: 1.9,
      fill: "#d4af3a",
      transform: "scale(-1 1)"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M337.5 131.4c-.8.3-1.9.2-1.9.2s-.3-1.4.5-2.1l2-1.7.5-.6v2c.1.8-.3 1.9-1.1 2.2"
    }),
    /* @__PURE__ */ jsx212("circle", {
      cx: -335.8,
      cy: 133,
      r: 0.6,
      fill: "#d4af3a",
      transform: "scale(-1 1)"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "m340.2 132.4.8.9s-.7 0-1.2.4c-.6.4-1.2.7-1.9.6a.9.9 0 0 1-.8-1c.2-.5.5-1 1.5-1.3 1-.4 1.3 0 1.6.4m-2.2 3.7c2 .2 4.6-2 4.6-2 .3 1.8 1.4 2.7 3 3v.1s-1.7.8-3.5 1.1a7 7 0 0 1-2.5-.2 10.6 10.6 0 0 1-3-1c-1.2-.7-.9-2.6-.9-2.6s.2 1.5 2.2 1.6zm7.8-2c.8-.3 2-.9 2.6-1 .5 0 1.3 0 1.1.9 0 1-1 1.4-2 1.4s-1.5-.3-2-.6c-.6-.3-.5-.4.3-.7m6.3-3.4c1-.7 1.7-.9 1.7-.9s.6 1.6.3 2.6-1 1.2-1.9 1.2c-.8 0-2.1-.5-1.8-1.2.4-.6.8-1 1.7-1.7"
    }),
    /* @__PURE__ */ jsx212("ellipse", {
      cx: -351.3,
      cy: 135.1,
      fill: "#d4af3a",
      rx: 0.7,
      ry: 0.5,
      transform: "scale(-1 1)"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M349.4 127.3c.5-2.7.4-5.6-2-9.3a16 16 0 0 0-7-5.1L339 111c-1.4-1.5-4.3-3.4-4.3-3.4l5.2 1.5a2.3 2.3 0 0 0 2.3 2.4c.4 0 .9-.2 1.3-.4 1 .1 4.4 2.2 5.2 2.9a2.3 2.3 0 0 0-.3 1.2 2.3 2.3 0 0 0 2.3 2.3c.3 0 .7 0 1-.2l.3.5a23.4 23.4 0 0 1 1.6 3.7c-.6.4-1 1.1-1 2 0 1.3 1 2.3 2 2.3v1.5c0 .7-.4 1.2-1.7 1.6-1.3.3-3 2.6-3 2.6-.2 0-1.1-1.6-.4-4.3z"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M341.3 110.3c-.4-.4-.5-1-.1-1.4.3-.3 1-.3 1.5.1s.6 1 .2 1.4c-.4.3-1 .3-1.6-.1m8.5 5.7c-.5-.5-.6-1.3-.2-1.7.4-.4 1.2-.4 1.7.1.6.5.7 1.3.2 1.7-.4.4-1.2.4-1.7-.1"
    }),
    /* @__PURE__ */ jsx212("circle", {
      cx: -354.8,
      cy: 123.2,
      r: 1.3,
      fill: "#d4af3a",
      transform: "scale(-1 1)"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M326.6 105c.7.2 2 .6 3.8 1.6-1.3 0-2.3.8-2.3 1.9 0 1 1.2 2.2 2.5 2.2s2.2-1.1 2.2-2.2c0-.2 0-.5-.2-.7l1.8 1.2c4.2 2.8 5.1 4.1 7.2 8 2 3.8 2.8 8 1.9 10.4-.9 2.5-4.2 3-4.2 3s.4-.3.4-.8l-.2-1.6c-.2-1 0-2.1 0-2.1s-.8-.1-1.2.4l-1.5 1.7-1.5 1.5s-.7-1-.7-2.1.8-2.3 1-4.3c0-2-1-5.5-2.9-8a22 22 0 0 0-6.6-5.5 2.1 2.1 0 0 1-1.3-1.7l-.2-2c-.1-1.2 1-1.1 2-.9"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M330.8 109.5c-.8 0-1.4-.7-1.4-1.3 0-.6.5-1 1.3-1 .7 0 1.3.4 1.3 1s-.5 1.3-1.2 1.3m-6.2 24.4c-1 .4-2.2.1-2.7-.2-.5-.4-.7-1.3 0-1.8a2 2 0 0 1 2-.2l2 1.3s-.3.5-1.3.9"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M321.4 135c.3.6.6.9 1.7 1 1.1 0 2.3 0 3-.8a7.7 7.7 0 0 0 1.3-1.7h1.3s.4 1.7 1 2.1c.5.5 2.4.6 3.3 0 .8-.7 1.6-1.4 1.7-1.3.2 0 0 .7-.8 1.4s-1.5 1.3-3 1.3H323s-1.6 0-2-1c-.5-.9-.6-1.5-.3-1.7.2-.3.3.1.7.7"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M333.5 133.7c-1.2.6-1.9.2-2.3-.3l-.5-.8 1.7-.7c.5-.4.9-.7 1.5-.6l.6.1s.2 1.6-1 2.2z"
    }),
    /* @__PURE__ */ jsx212("ellipse", {
      cx: -339.3,
      cy: 121.9,
      fill: "#b96b29",
      rx: 2.7,
      ry: 2.6,
      transform: "scale(-1 1)"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#b96b29",
      d: "M334.7 112.7c1-.7 2.6-.4 3.5.6.8 1.1.7 2.6-.4 3.3-1 .7-2.6.4-3.5-.6-.9-1.1-.7-2.6.4-3.3"
    }),
    /* @__PURE__ */ jsx212("ellipse", {
      cx: -339.4,
      cy: 121.5,
      fill: "#d4af3a",
      rx: 1.6,
      ry: 1.5,
      transform: "scale(-1 1)"
    }),
    /* @__PURE__ */ jsx212("path", {
      fill: "#d4af3a",
      d: "M335.8 113c.7-.2 1.5.2 1.9.8.3.6 0 1.2-1 1.4-1.7.3-2.5-1.8-1-2.2z"
    })
  ]
});
var Me_default = SvgMe;

// src/country-flag-icons/generated/Mf.tsx
init_esm_shims();
import { jsx as jsx213, jsxs as jsxs188 } from "react/jsx-runtime";
var SvgMf = (props) => /* @__PURE__ */ jsxs188("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx213("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx213("path", {
      fill: "#000091",
      d: "M0 0h213.3v480H0z"
    }),
    /* @__PURE__ */ jsx213("path", {
      fill: "#e1000f",
      d: "M426.7 0H640v480H426.7z"
    })
  ]
});
var Mf_default = SvgMf;

// src/country-flag-icons/generated/Mg.tsx
init_esm_shims();
import { jsx as jsx214, jsxs as jsxs189 } from "react/jsx-runtime";
var SvgMg = (props) => /* @__PURE__ */ jsx214("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs189("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    children: [
      /* @__PURE__ */ jsx214("path", {
        fill: "#fc3d32",
        d: "M213.3 0H640v240H213.3z"
      }),
      /* @__PURE__ */ jsx214("path", {
        fill: "#007e3a",
        d: "M213.3 240H640v240H213.3z"
      }),
      /* @__PURE__ */ jsx214("path", {
        fill: "#fff",
        d: "M0 0h213.3v480H0z"
      })
    ]
  })
});
var Mg_default = SvgMg;

// src/country-flag-icons/generated/Mh.tsx
init_esm_shims();
import { jsx as jsx215, jsxs as jsxs190 } from "react/jsx-runtime";
var SvgMh = (props) => /* @__PURE__ */ jsx215("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs190("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx215("path", {
        fill: "#3b5aa3",
        d: "M0 0h639.9v480H0z"
      }),
      /* @__PURE__ */ jsx215("path", {
        fill: "#e2ae57",
        d: "M0 467 639.9 0v87L0 480z"
      }),
      /* @__PURE__ */ jsx215("path", {
        fill: "#fff",
        d: "M22.4 480 640 179.2l-.1-95.5L0 480zm153-464.8L169 118l-27-65.6 10.4 69.8-41.9-56.4 27.5 64.3-55-42.6 42.8 53.6-62.1-27.6 54.4 41.2-67.7-9 64 25.4L14 180.3l100.6 6.7-63.7 26.2 67-9-54.3 40 63-27.6-43 54 54.6-41.3-27 62.9 43.6-54.7-11.8 68.1 27.5-63.7 6.2 100.7 9.7-100.4 23.7 64-9-69 43.4 54.8-28.6-64 54.6 44-43.4-54.9 64.9 27-57.4-41.9 69.9 11.8-67-25.7 104.1-6.5-104-9.7 68.5-22.8-71 9 58.6-41-66 26.5 45.6-55.3-55.6 43.4 26.7-66.4-43.1 56.4 9.3-70.4-25.7 66.5-9.6-102.8z"
      })
    ]
  })
});
var Mh_default = SvgMh;

// src/country-flag-icons/generated/Mk.tsx
init_esm_shims();
import { jsx as jsx216, jsxs as jsxs191 } from "react/jsx-runtime";
var SvgMk = (props) => /* @__PURE__ */ jsxs191("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx216("path", {
      fill: "#d20000",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx216("path", {
      fill: "#ffe600",
      d: "M0 0h96l224 231.4L544 0h96L0 480h96l224-231.4L544 480h96zm640 192v96L0 192v96zM280 0l40 205.7L360 0zm0 480 40-205.7L360 480z"
    }),
    /* @__PURE__ */ jsx216("circle", {
      cx: 320,
      cy: 240,
      r: 77.1,
      fill: "#ffe600",
      stroke: "#d20000",
      strokeWidth: 17.1
    })
  ]
});
var Mk_default = SvgMk;

// src/country-flag-icons/generated/Ml.tsx
init_esm_shims();
import { jsx as jsx217, jsxs as jsxs192 } from "react/jsx-runtime";
var SvgMl = (props) => /* @__PURE__ */ jsx217("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs192("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx217("path", {
        fill: "red",
        d: "M425.8 0H640v480H425.7z"
      }),
      /* @__PURE__ */ jsx217("path", {
        fill: "#009a00",
        d: "M0 0h212.9v480H0z"
      }),
      /* @__PURE__ */ jsx217("path", {
        fill: "#ff0",
        d: "M212.9 0h214v480h-214z"
      })
    ]
  })
});
var Ml_default = SvgMl;

// src/country-flag-icons/generated/Mm.tsx
init_esm_shims();
import { jsx as jsx218, jsxs as jsxs193 } from "react/jsx-runtime";
var SvgMm = (props) => /* @__PURE__ */ jsxs193("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx218("path", {
      fill: "#fecb00",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx218("path", {
      fill: "#34b233",
      d: "M0 160h640v320H0z"
    }),
    /* @__PURE__ */ jsx218("path", {
      fill: "#ea2839",
      d: "M0 320h640v160H0z"
    }),
    /* @__PURE__ */ jsxs193("g", {
      transform: "translate(320 256.9) scale(176.87999)",
      children: [
        /* @__PURE__ */ jsx218("path", {
          id: "mm_svg__a",
          fill: "#fff",
          d: "m0-1 .3 1h-.6z"
        }),
        /* @__PURE__ */ jsx218("use", {
          xlinkHref: "#mm_svg__a",
          width: "100%",
          height: "100%",
          transform: "rotate(-144)"
        }),
        /* @__PURE__ */ jsx218("use", {
          xlinkHref: "#mm_svg__a",
          width: "100%",
          height: "100%",
          transform: "rotate(-72)"
        }),
        /* @__PURE__ */ jsx218("use", {
          xlinkHref: "#mm_svg__a",
          width: "100%",
          height: "100%",
          transform: "rotate(72)"
        }),
        /* @__PURE__ */ jsx218("use", {
          xlinkHref: "#mm_svg__a",
          width: "100%",
          height: "100%",
          transform: "rotate(144)"
        })
      ]
    })
  ]
});
var Mm_default = SvgMm;

// src/country-flag-icons/generated/Mn.tsx
init_esm_shims();
import { jsx as jsx219, jsxs as jsxs194 } from "react/jsx-runtime";
var SvgMn = (props) => /* @__PURE__ */ jsxs194("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#ffd900",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx219("path", {
      fill: "#da2032",
      d: "M0 0h640v480H0Z"
    }),
    /* @__PURE__ */ jsx219("path", {
      fill: "#0066b3",
      d: "M213.3 0h213.4v480H213.3Z"
    }),
    /* @__PURE__ */ jsx219("circle", {
      cx: 106.7,
      cy: 181.8,
      r: 40
    }),
    /* @__PURE__ */ jsx219("circle", {
      cx: 106.7,
      cy: 163.6,
      r: 43.6,
      fill: "#da2032"
    }),
    /* @__PURE__ */ jsx219("circle", {
      cx: 106.7,
      cy: 170.9,
      r: 29.1
    }),
    /* @__PURE__ */ jsx219("path", {
      d: "M109.7 76.4a8.7 8.7 0 0 0-5.2 7.5c-.2 2.5.9 5.3 1 7.7 0 4.2-4.3 5.6-4.3 11.5 0 2 1.9 4.3 1.9 9.6-.4 2.8-2 3.5-3.7 3.7a3.6 3.6 0 0 1-3.6-3.7 3.6 3.6 0 0 1 1-2.5 3.6 3.6 0 0 1 .4-.3c.8-.9 2-1.2 2-3.4 0-1.1-.8-2.2-1.5-4.2s-.2-5.2 1.4-7.1c-2.6 1-4.1 3.4-5 5.6-.8 2.7 0 4.2-1.2 6.5-.7 1.4-1.5 2-2.3 3.2-1 1.4-2 4.4-2 5.9a18.2 18.2 0 0 0 36.3 0c0-1.5-1.1-4.5-2-5.9-.9-1.2-1.7-1.8-2.4-3.2-1.2-2.3-.4-3.8-1.3-6.5-.8-2.2-2.3-4.6-4.9-5.6 1.6 2 2 5.2 1.4 7.1-.7 2-1.4 3-1.4 4.2 0 2.2 1.1 2.5 2 3.4a3.6 3.6 0 0 1 .3.3 3.6 3.6 0 0 1 1 2.5 3.6 3.6 0 0 1-3.6 3.7c-2-.3-3.5-1.2-3.7-3.7 0-7 3-7.4 3-12.6 0-7.4-6.6-10.9-6.6-16.3 0-1.8.4-5 3-7.4M26.7 229H63v174.5H26.7Zm123.6 0h36.4v174.5h-36.4zm-80 0H143l-36.3 21.8Zm0 29H143v14.6H70.3Zm0 101.9H143v14.6H70.3Zm0 21.8H143l-36.3 21.8Z"
    }),
    /* @__PURE__ */ jsx219("circle", {
      cx: 106.7,
      cy: 316.4,
      r: 36.4
    }),
    /* @__PURE__ */ jsxs194("g", {
      fill: "#da2032",
      transform: "translate(-38.8 32.7) scale(.72727)",
      children: [
        /* @__PURE__ */ jsx219("circle", {
          cx: 200,
          cy: 363.5,
          r: 10
        }),
        /* @__PURE__ */ jsx219("circle", {
          cx: 200,
          cy: 416.5,
          r: 10
        }),
        /* @__PURE__ */ jsx219("path", {
          d: "M200 334a29.5 29.5 0 0 1 0 59 23.5 23.5 0 0 0 0 47v6a29.5 29.5 0 0 1 0-59 23.5 23.5 0 0 0 0-47z"
        })
      ]
    })
  ]
});
var Mn_default = SvgMn;

// src/country-flag-icons/generated/Mo.tsx
init_esm_shims();
import { jsx as jsx220, jsxs as jsxs195 } from "react/jsx-runtime";
var SvgMo = (props) => /* @__PURE__ */ jsxs195("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx220("path", {
      fill: "#00785e",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx220("path", {
      fill: "#fbd116",
      d: "m295 108.7 40.5 29.5L320 90.5l-15.5 47.7 40.6-29.5z"
    }),
    /* @__PURE__ */ jsxs195("g", {
      id: "mo_svg__a",
      children: [
        /* @__PURE__ */ jsx220("path", {
          fill: "#fff",
          d: "M320 331.6H217.5a146.3 146.3 0 0 1-3.8-4H320a2.1 2.1 0 0 1 1.4 2c0 .8-.5 1.7-1.4 2m0-31.3a13 13 0 0 0 1.2-7.6 12.4 12.4 0 0 0-1.2-3.8 82 82 0 0 1-32.5 19 81 81 0 0 1-23.5 3.5h-63.1a144.4 144.4 0 0 0 5.8 8h61c20 0 38.2-7.2 52.3-19.1m-109.6-24.7a32.3 32.3 0 0 1-9.7 2 81 81 0 0 0 60.8 27.5 80.9 80.9 0 0 0 58.5-25 441 441 0 0 0 4.5-58.8 441 441 0 0 0-4.5-67.7c-6.6 6-19 18.7-24.8 38.3A81 81 0 0 0 292 215a80.7 80.7 0 0 0 13.7 45 80.7 80.7 0 0 1-17-49.5c0-12.4 2.8-24.2 7.8-34.7a32.5 32.5 0 0 1-7.5-13 80.7 80.7 0 0 0-10.5 40c0 18 5.9 34.7 15.9 48.1a95 95 0 0 0-73.4-29.4 32.6 32.6 0 0 1 6.8 8.9 95 95 0 0 1 68.6 29.4 95 95 0 0 0-61-22.2 95 95 0 0 0-36.7 7.3 81.2 81.2 0 0 0 82.6 52.2c-4.7.8-9.5 1.3-14.4 1.3a80.8 80.8 0 0 1-56.4-22.8zM320 364.4h-53.1a143.5 143.5 0 0 0 53.1 10.1 11 11 0 0 0 1.3-5 11 11 0 0 0-1.3-5.1m0-24.5h-93.6a143.8 143.8 0 0 0 7.8 6.2H320a4.6 4.6 0 0 0 1.3-3.1 4 4 0 0 0-1.3-3.1m0 12.5h-76.7a143.6 143.6 0 0 0 14.4 8H320a7.6 7.6 0 0 0 1.2-4.2 7.5 7.5 0 0 0-1.2-3.8"
        }),
        /* @__PURE__ */ jsx220("path", {
          fill: "#fbd116",
          d: "m200.5 174.8 25.4 23.6-6.7-34-14.6 31.4 30.3-16.8zm36.9-32 34.7.6-27.7-21 10.1 33.3 11.3-32.9z"
        })
      ]
    }),
    /* @__PURE__ */ jsx220("use", {
      xlinkHref: "#mo_svg__a",
      width: "100%",
      height: "100%",
      transform: "matrix(-1 0 0 1 640 0)"
    })
  ]
});
var Mo_default = SvgMo;

// src/country-flag-icons/generated/Mp.tsx
init_esm_shims();
import { jsx as jsx221, jsxs as jsxs196 } from "react/jsx-runtime";
var SvgMp = (props) => /* @__PURE__ */ jsxs196("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx221("defs", {
      children: /* @__PURE__ */ jsx221("clipPath", {
        id: "mp_svg__a",
        children: /* @__PURE__ */ jsx221("path", {
          fillOpacity: 0.7,
          d: "M0 0h640v480H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs196("g", {
      clipPath: "url(#mp_svg__a)",
      children: [
        /* @__PURE__ */ jsx221("path", {
          fill: "#0071bc",
          fillRule: "evenodd",
          d: "M-160 0h960v480h-960z"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "#fff",
          fillRule: "evenodd",
          stroke: "#000",
          strokeWidth: 1.9,
          d: "M370 365.7s15.2-16.1 29.8-13c4.4-17 21-18.4 21-18.4s-1.7-18.7 19.5-22.8c.6-12.7 13.5-23.3 13.5-23.3s-2.6-19.7 10.8-24.3c-8.2-15.6 2.8-27 2.7-27.3-.2-.3-14-24.8-1.6-31.8-13-11-8.8-23.4-8.8-23.4s-14.2-3.7-9.1-20.7c-11.7-2-14-20.9-14-20.9s-18 3.7-20.2-12c-12 1.9-13.2-9.8-13.4-9.8-.1 0-23.5 6.3-28.2-11.4-9.1 4.7-13-3.7-13-3.7s-13 6.5-20.8-6c-15.5 9.7-24.2-.4-24.2-.4s-20.3 13.4-27 3c-12 12.2-22.8 7-22.8 7s-9 16-23.7 12c-3.3 14.9-20.2 15.2-20.2 15.2s1.8 13.1-18.4 16.7c-2.6 15.5-13.2 18-13.2 18s1 15.2-8.5 20c3.4 8.5-5.4 18.9-5.4 18.9s9.4 11.7-3.4 24.9c12.3 3.2 3.4 24.4 3.4 24.4s17 7.6 6.3 21.7c12.2 4 8.4 13.6 8.5 19.3 7.8 3.5 14.6 1.8 11.3 17.4 23.8 2.7 12.6 15.8 12.6 15.8s11 .5 6.7 9.3c20.3-.5 23.3 15.2 23.3 15.2s18.8-5 21.3 2.3-8.2 56.7-8.2 56.7-16 0-27.8-12.8c-27.8-.7-21.6-19-22-19-.5 0-9.3 3.4-13.8-11.9-18.6 3.8-18-11.8-18.2-12-.1-.1-8.3-3.8-5.3-11.5-19.1 1.7-17.7-17-17.7-17-4.2-1.7-5.7-5.6-5.1-9.5-2.5-.9-19.5-1.2-10.7-23.6-16.2-9.8-6.1-21-6.1-21s-22.4-11.6-5.1-25c-13-19 1-28.5 1-28.5s-17.9-18.1.3-31c-3-27.5 13.4-34.1 13.4-34.1s-8.6-22.4 14.8-31.8c1.5-22.7 17.9-23.3 17.9-23.3s.4-18 26.2-16.2c5-16.1 22.5-12.9 22.5-12.9s5.4-19.5 29.3-10.1c12.1-23.7 30.2-11.6 30.2-11.6s11.4-7.4 17-5c7.3-12.5 22.8-.6 32.7 1.9 3.7-1.5 16.6-11.2 26.5 1 13.2-8.5 24.5 7 24.5 7s18.1-9.2 26.6 11.8c38.5-3.5 33 21.7 33 21.7s30.2-6.9 23.6 23.3c27.6 1.9 24.8 20 24.8 20s17.4 13.2 9.8 25c15.5.8 9.8 15.7 9.8 15.7s11.9 4.6 2 23c22.7 18.1 4.4 36.2 4.3 36-.2-.1 12.1 14.6 1 31.6 3.4 27-10.2 33.8-10.2 33.8s3.5 17.5-11.7 22.4c-.3 20.5-19.7 23-19.7 23s5.2 9-14 18.3c-.8 13.7-20.8 14.8-20.8 14.8s-1.9 25.2-27.4 18.4c-6.1 20.2-36 14.2-36.6 14-.5-.3-5.7-43.4-5.7-43.5z"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "#217900",
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinejoin: "round",
          strokeWidth: 1.9,
          d: "M185 124s6.4 5.6 5.2 14c-1.2 8.3-6 19.9-5 28.5.6 3.5.3 9.7.3 9.7s-5.7-8.2-5.8-17 6.2-17.1 6.2-23.6-1.1-11.7-1-11.5zm-3.2 2.6s-8.4 8-9.5 15.7c-.8 4-1 22.7-1.2 31-.2 2.5-1.2 12.5-1.4 16.2-.3 3.6 6.1-6.2 6.5-14.3-.2-8.3-.2-25.8.6-28.5.8-3.4.6-7.1 1.8-10.5z"
        }),
        /* @__PURE__ */ jsxs196("g", {
          fill: "#ffd200",
          fillRule: "evenodd",
          stroke: "#ef8a10",
          children: [
            /* @__PURE__ */ jsx221("path", {
              strokeWidth: 1.9,
              d: "M366 100.5s10.8-5 14-14.4-9.5-9.4-11.1-6.4c-1.7 3 1.4 10.3.6 12.3-.8 2-5.2 6.6-3.5 8.4z"
            }),
            /* @__PURE__ */ jsx221("path", {
              strokeWidth: 2.5,
              d: "M269.8 103.9s7-9.7 5.2-19.4c-1.9-9.6-12.8-3.6-12.8-.2s6.2 8.3 6.5 10.4c.3 2.1-1.3 8.4 1 9.1zm-19.1 5.7s7-9.7 5.2-19.3c-1.8-9.7-12.8-3.7-12.8-.3 0 3.4 6.3 8.4 6.6 10.5.2 2-1.3 8.3 1 9.1zm-21.1 6.5s7-9.6 5.2-19.3c-1.9-9.7-12.8-3.7-12.8-.3 0 3.4 6.2 8.4 6.5 10.5.3 2-1.3 8.3 1 9.1zm-15 14.9s7.1-9.7 5.3-19.3c-1.8-9.7-12.8-3.7-12.8-.3 0 3.4 6.3 8.4 6.5 10.5.3 2-1.3 8.3 1 9.1zM199 145.4s7-9.7 5.2-19.4-12.8-3.6-12.8-.2 6.3 8.3 6.6 10.4c.2 2.1-1.3 8.4 1 9.2z"
            }),
            /* @__PURE__ */ jsx221("path", {
              strokeWidth: 1.9,
              d: "M235 61.7s-9.4 7.4-10.2 17.2c-.8 9.8 11.3 7 12.2 3.7 1-3.3-3.7-9.7-3.4-11.8.3-2 3.5-7.7 1.4-9zm31.3-9.6s-9.3 7.4-10.2 17.2c-.8 9.8 11.3 7 12.3 3.7.9-3.3-3.8-9.8-3.5-11.9.3-2 3.5-7.7 1.4-9zm-116.7 84.5s2 11.8 10.2 17.3c8.2 5.4 11.5-6.6 9.1-9s-10.3-1.4-12-2.6c-1.7-1.3-5-6.8-7.3-5.7zm-15.6 40s0 12 7.3 18.7c7.2 6.6 12.4-4.7 10.4-7.4s-10-3-11.4-4.5c-1.5-1.6-4-7.5-6.3-6.7zm36 44.8s-4.2-11.2-13.3-15c-9.1-3.6-10 8.8-7.2 10.7 2.9 1.8 10.4-.7 12.3.2 2 .9 6.3 5.6 8.3 4zm-7.4-19.4s7.2-9.5 5.6-19.1c-1.7-9.7-12.7-4-12.8-.6 0 3.4 6 8.5 6.3 10.6.2 2.1-1.5 8.3.9 9.2zm225.6-91.9s10.8-5 14-14.3-9.5-9.4-11.1-6.5c-1.7 3 1.4 10.4.6 12.3-.8 2-5.2 6.7-3.5 8.5zm32.8 16.4s6.4-10.1 3.9-19.6c-2.5-9.5-13-2.8-12.8.6.2 3.3 6.8 7.9 7.2 10 .4 2-.7 8.4 1.7 9zm89.6 93s-4.3-11.1-13.4-14.9c-9.1-3.7-10 8.8-7.2 10.6 2.9 1.9 10.5-.7 12.3.2 2 1 6.3 5.7 8.3 4.1zm-43.8 7s.2-12 7.5-18.6c7.3-6.6 12.4 4.9 10.4 7.6-2.1 2.7-10 2.8-11.6 4.3-1.4 1.5-4 7.4-6.3 6.6zm-7-126.8s-11.3-4.3-20 0c-9 4.4-.2 13.4 3 12.5 3.3-1 6.4-8.3 8.4-9.1 2-.8 8.4-1 8.5-3.4zM434 78.3s-11.1-4.3-20 0c-8.8 4.4-.1 13.4 3.2 12.5 3.2-1 6.4-8.3 8.3-9.1 2-.8 8.4-1 8.5-3.4zm-38-20.4s-9.5 7.3-10.4 17c-1 9.8 11.2 7.1 12.2 3.9 1-3.3-3.7-9.8-3.4-11.9.4-2 3.6-7.6 1.6-9zm-24.8-6s-4.4 11.1-.1 20c4.3 8.9 13.3.2 12.4-3-.9-3.3-8.2-6.5-9-8.4-.8-2-.9-8.5-3.3-8.6zm-70.5 43s7.7-9.2 6.6-19c-1.1-9.7-12.5-4.5-12.7-1.1-.3 3.4 5.6 8.8 5.7 10.9.1 2-1.9 8.2.4 9.1z"
            })
          ]
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "#8c8a8c",
          fillRule: "evenodd",
          stroke: "#000",
          strokeWidth: 1.9,
          d: "M342.8 114.4s18.5 1.2 19.4 11.8-4.4 17.1-4.4 17.1 2.3 23-15.8 29.7c-19.4 2.3-49.9.5-49.9.5s-9 2.2-12.6-16.3a305 305 0 0 1-4.6-31.6s1.8-10.4 14.9-11c13-.7 52.8 0 53-.2z"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "none",
          stroke: "#000",
          strokeLinecap: "round",
          strokeWidth: 1.9,
          d: "M357.7 143.2s-10 12.4-9 17.5"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "#8c8a8c",
          fillRule: "evenodd",
          stroke: "#000",
          strokeWidth: 1.9,
          d: "M344.3 172.3c2.5 2.1 4.8 4.4 5.3 12l1 15.4 13 116.6 11.4 84.3.8 13s-2.7 9.7-10.4 10.5c-5.5 11.6-35.7 15-38.7 14.9-2.7-.2-12.3-4.2-18.1-3.7-5.9.5-16 4.4-20.5 3.8-4.5-.7-14.8-4.2-16.6-11.6-12.7-4-14.7-13.7-14.7-13.7l13.7-97.5 13.3-123.4s1.6-16.4 8.2-18.9c6.9-.6 42.4.7 52.3-1.7z"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 1.9,
          d: "m274.4 341.1-2.7 86.3m86.5-74.9 7.6 71.2"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "none",
          stroke: "#000",
          d: "m136.6 296.3-.3 1m358.7-4.1.3 1"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "none",
          stroke: "#6b18b5",
          strokeLinejoin: "round",
          strokeWidth: 1.9,
          d: "M127 179.8s5.6 7.9 6.7 12.4c1 4.5 2.9 13.4 5.3 17 2.5 3.7 16.6 23.9 17.4 32.3.1 5.6-5.9 15-14.7 15.2-5.6-.2-19.8-3.8-20.4-16-.6-12.3 4.3-12.5 5-20 .5-7.4.7-40.7.7-40.9z"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "none",
          stroke: "#6b18b5",
          strokeLinejoin: "round",
          d: "M224.5 72.8s-6 .4-10.4 2.9c-3.5 2.1-9.5 5.3-13.6 11-10.6 8.2-26.5 12-31.5 19-3 4.6-2.8 15.7 4.7 20.5 4.8 2.7 19 7 25.8-3.1 6.8-10.2 2.7-13 6-19.6a117.4 117.4 0 0 1 19-30.7zM367 58s-4.4-4-9.3-5.5c-4-1-10.6-.6-17.5-1.3-13.3-1.8-27-11.4-35.3-10.2-5.4 1-13.3 9-11.5 17.6 1.3 5.4 7.3 16.2 19.4 14.1 12-2.1 12-4.8 19-7 17.4-9.7 35-7.7 35.2-7.7zm141.4 137.4c1-2.3-.9-6.6-2.2-11.5-1.2-4-3.1-10-7.7-15.5-5.4-12.2-4.5-29-10-35.4-3.7-4-14.6-6.6-21-.4-3.9 4-11.4 16.6-3.2 25.7 8.2 9 11.8 5.7 17.4 10.5 13.5 9 20 25 26.7 26.6zM503.5 302c1.9-2.5 5.2-7.4 4.8-11.5-.3-3.2 1.5-13 1.7-17.3 1.2-13.3 9.5-24.2 7.2-35.7-1.3-5.4-9.2-13-17.8-10.8-5.2 1.6-17 8-14.3 20 2.7 12 6.6 11.7 9.1 18.7 7.3 14.5 2.7 31.7 9.3 36.6z"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 1.9,
          d: "M405.5 386.8s-2.3 4.4 6.8 8.2m11.3-18.4s10-2.5 16.8 0m13.2-25.4c0 .2-1.4 4.5 6.6 10.8m-.8-22s5.9 4.3 15.8 4m-75.4 8.6s.3 11.5-5.6 16.8m25.4-34.5s9.7 2.4 17.7-1.6m44.6-15.3s2.1 3 12.9 2.5m-54.9-9.3c.3.2 12.7 4.2 20.5.6m4.2-47.8s.5-.7 4.3 12.7m5.2-50.4s-.5 7.1-6.2 10.2m42.9-39.4s-8.4 6.8-6.8 9.5m-34.7-14.4s4.3 7.3-2.8 12.3M448.2 161s7.5-.3 10.8 6.1m-24.8-27.3h5.7m24-26c0 .1 1.5 1.5-1.4 4.5m-52-3.8s4 6.2 3.3 13.9m19.8-35.1c1.8-.2 7.7-2.8 7.7-2.8m-33.4-22c-.1 0-2.2 7.7 1.6 10.5m-11.1 25c0 8.4 6.6 6.3 2 14.3M382.2 97a57 57 0 0 0-10.4 9.4m-16.4-13.7s4.4 4.3 3.3 10.2m-16-13.7s-2.2 6.6-5.1 8.3m-18-10c-.1.3-3.6 7.8-6 9.1m-25.6-9c.2 0 3.5 7-.8 12m-6.5-48c.2.2.7 5.4-2.6 10m-28.7 1.9c0 .1 1.4 5.9-7.8 7.8m-9.9 45.2c.2.3 8.9 1.7 8.9 1.7M210 136.6c.2-.2 10.6-3.3 10.6-3.3m-27.4 16.3c.3 0 7.3 1.3 9 .4m-14 6s2.3 1.3.4 13m-34.2-43.5 4.2 6.2m-18.5 26c0-.2 4.2 6.2 9.8 7.4m23 25.2a49 49 0 0 0 8-2M170 213.8c.2 0-.1-4.3 5.2-7.3M163 224.7c0 .2 5 6.4 8.5 7.3m-11.5 4.7c.6-.2 6-4.9 12.2-4.5m-13.9 20.6s.2 5.4 16.2 4m-14.6 15c0-.2 4.7-10.8 14.2-14.8m-1.4 28.4s1.4-4.6 9.4-7.7m-.5 25.5s5.7-4.7 7.8-5.3m-.7 19.3s3.5 3.6 12.2-2.7m-54 5.6c1-.2 13.7-3.1 18 3.5m-13 7s13.4-1.8 15.1-.4m32.7 3.1s-1.8 3.7 14.7-2.4m5.8 9c-3 5 .7 9-3.2 11.3m-47-4.3c.5-.4 6-2.3 5.2-10.3m-.2 22.3c.7-.2 9.9-4.2 11.8-2.1m6.3 13.7s1.2-8.2 3.8-9m10 21.3s7.7-.1 11-2.6m3.8-25c.2.2 7.1 3.8 22 .2m-16.4 33s2 10.6 2 13"
        }),
        /* @__PURE__ */ jsxs196("g", {
          fill: "#de2010",
          fillRule: "evenodd",
          stroke: "#000",
          strokeWidth: 1.5,
          children: [
            /* @__PURE__ */ jsx221("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(1.60885 -.2011 .2072 1.65762 94.8 75)"
            }),
            /* @__PURE__ */ jsx221("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(1.60885 -.2011 .2072 1.65762 93.4 57.3)"
            }),
            /* @__PURE__ */ jsx221("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(1.58497 -.3417 .35206 1.633 78 74)"
            }),
            /* @__PURE__ */ jsx221("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(1.4455 -.73446 .7567 1.4893 55.9 163)"
            }),
            /* @__PURE__ */ jsx221("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(1.4455 -.73446 .7567 1.4893 48.9 147.1)"
            }),
            /* @__PURE__ */ jsx221("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(1.3781 -.85423 .88011 1.41987 40 167.4)"
            }),
            /* @__PURE__ */ jsx221("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(1.28907 -.98346 1.01327 1.32812 33.8 193)"
            }),
            /* @__PURE__ */ jsx221("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(1.1329 -1.15994 1.19508 1.16722 35.3 239)"
            }),
            /* @__PURE__ */ jsx221("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(1.02138 -1.25922 1.29739 1.05234 34.3 262.7)"
            }),
            /* @__PURE__ */ jsx221("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(.79817 -1.41132 1.45408 .82236 51.9 315)"
            }),
            /* @__PURE__ */ jsx221("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(.66642 -1.4781 1.52289 .6866 56.8 337.4)"
            }),
            /* @__PURE__ */ jsx221("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(.56582 -1.51945 1.5655 .58296 57.9 352.4)"
            }),
            /* @__PURE__ */ jsx221("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(.4482 -1.5582 1.60543 .46178 63 370.4)"
            }),
            /* @__PURE__ */ jsx221("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(.20288 -1.60864 1.65738 .20903 94.7 408.9)"
            }),
            /* @__PURE__ */ jsx221("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(.06506 -1.62008 1.66918 .06703 106.3 427.4)"
            }),
            /* @__PURE__ */ jsx221("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(.06506 -1.62008 1.66918 .06703 88.8 428)"
            }),
            /* @__PURE__ */ jsx221("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(-.36132 -1.5806 1.62852 -.37226 172.5 473.5)"
            }),
            /* @__PURE__ */ jsx221("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(-.49045 -1.54542 1.59227 -.50531 188.3 485.8)"
            }),
            /* @__PURE__ */ jsx221("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(-.67103 -1.476 1.52073 -.69138 221.9 499.1)"
            }),
            /* @__PURE__ */ jsx221("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(-.7945 -1.41337 1.4562 -.81858 241.4 508.3)"
            }),
            /* @__PURE__ */ jsx221("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(-.94339 -1.31867 1.35863 -.97197 271.6 515.4)"
            }),
            /* @__PURE__ */ jsx221("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(-1.05159 -1.2341 1.27151 -1.08344 292.4 520.2)"
            }),
            /* @__PURE__ */ jsx221("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(-1.13737 -1.15553 1.19056 -1.17183 308.9 526.1)"
            }),
            /* @__PURE__ */ jsx221("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(-1.2301 -1.05628 1.08829 -1.26738 331.4 529.6)"
            }),
            /* @__PURE__ */ jsx221("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(-1.33573 -.91908 .94693 -1.3762 362.5 526.1)"
            }),
            /* @__PURE__ */ jsx221("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(-1.47374 -.67597 .69645 -1.51841 415.9 504)"
            }),
            /* @__PURE__ */ jsx221("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(-1.52895 -.53958 .55593 -1.5753 438.7 497.5)"
            }),
            /* @__PURE__ */ jsx221("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(-1.61445 -.12005 .15429 -1.33344 500.5 406)"
            }),
            /* @__PURE__ */ jsx221("path", {
              d: "M232.8 119c0-2-.8-4-2-5-1.4-1.1-3-1.1-4.2 0s-2.1 3-2.1 5c0 2.1.8 4 2 5.1 1.4 1.1 3 1.1 4.2 0s2.2-3 2.1-5z",
              transform: "matrix(-1.58082 -.36035 .37125 -1.62873 468.4 480.8)"
            })
          ]
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "#ffe300",
          fillRule: "evenodd",
          d: "M480 194.7c2.2-2.3 4.2-3 6.7-2.1-1-6.1-2.8-8.2-5.2-7.4-2.3.7-3.4 3.8-1.5 9.5m3.3 18.2c2.3-2.1 4.3-2.6 6.8-1.6-.4-6-2.2-8.3-4.6-7.7-2.4.5-3.6 3.6-2.2 9.3m-7.8-35c1.5-2.7 3.3-3.8 6-3.7-2.5-5.6-4.8-7.1-7-5.8-2 1.3-2.2 4.6 1 9.6zm-8.1-16.6c1.5-2.8 3.3-3.9 6-3.7-2.5-5.7-4.9-7.2-7-5.9-2 1.3-2.2 4.6 1 9.6m-19.5-30.5c1-3 2.6-4.4 5.2-4.6-3.3-5.2-5.9-6.3-7.7-4.7s-1.5 5 2.5 9.3M435 117.5c1-3 2.4-4.4 5-4.8-3.4-5-6-6-7.8-4.4-1.8 1.7-1.4 5 2.8 9.2M408.3 95c0-3.2 1-5 3.3-6.2-4.8-3.7-7.7-3.8-8.8-1.7s.2 5.1 5.5 7.9m14 10.5c.4-3.1 1.7-4.8 4.3-5.5-4.2-4.5-6.9-5.2-8.4-3.3-1.5 2-.7 5.1 4 8.8zm-30-19.3c-.3-3.1.5-5 2.7-6.5-5.2-3.2-8-3-9-.8-.9 2.3.8 5.1 6.4 7.3zM376.2 79c-.8-3-.3-5 1.7-6.8-5.6-2.4-8.4-1.9-9 .5-.6 2.4 1.5 4.9 7.3 6.3m-17.5-5.4c-1.1-3-.8-5 1.1-7-5.8-1.9-8.5-1.1-9 1.3-.3 2.4 2 4.8 7.9 5.7m-17.3-3.4c-1.2-2.8-1-5 .7-7-6-1.5-8.6-.5-8.8 2-.3 2.4 2.2 4.6 8.1 5m-18.2-1.4c-1.6-2.7-1.6-4.8 0-7-6.1-.9-8.7.4-8.6 2.8 0 2.5 2.7 4.4 8.6 4.2m-35.7 2.7c-2.2-2.2-2.7-4.3-1.8-6.8-6 .6-8.2 2.4-7.6 4.8.6 2.4 3.7 3.6 9.4 2m17.6-2.3c-1.9-2.5-2.2-4.6-.9-7-6.1-.2-8.5 1.3-8.2 3.8.3 2.4 3.2 4 9 3.2zm-34.9 6c-2.4-1.9-3.3-3.8-2.7-6.4-6 1.5-7.8 3.6-6.9 5.8 1 2.3 4.2 3 9.6.6m-33 15.2c-2.8-1.4-4-3.1-3.9-5.8-5.6 2.6-7 5-5.6 7 1.3 2 4.6 2.2 9.5-1.2m16-8.1c-2.7-1.7-3.6-3.6-3.2-6.2-5.9 1.8-7.6 4-6.5 6.2 1.1 2.2 4.4 2.8 9.6 0zm-45.6 28.8c-3-.8-4.6-2.3-5-5-5 3.8-5.8 6.4-4.1 8.1 1.8 1.7 5 1.2 9-3.1zm14.1-11.6c-3-1-4.4-2.6-4.6-5.2-5.2 3.2-6.3 5.8-4.7 7.7 1.6 1.8 5 1.5 9.3-2.5m-26.7 24c-3-.6-4.7-1.9-5.4-4.5-4.6 4.1-5.2 6.9-3.3 8.4 1.9 1.6 5 .7 8.7-4zM183.7 138c-3.2-.2-5-1.3-5.8-3.8-4.2 4.5-4.6 7.2-2.6 8.6 2 1.4 5.1.2 8.4-4.8m-9.4 15c-3.2.2-5-.7-6.4-3-3.4 5.1-3.4 8-1.2 9s5.1-.6 7.6-6m-8.3 16c-3 .6-5 0-6.7-2.2-2.7 5.5-2.3 8.3 0 9 2.3.8 5-1.2 6.7-6.9zm-6.6 16.3c-3 1.1-5 .8-7-1-1.8 5.8-1 8.5 1.5 8.9 2.4.3 4.7-2 5.5-8zm-4.5 18.2c-2.8 1.3-4.9 1.2-7-.5-1.4 6-.4 8.5 2 8.7 2.5.3 4.7-2.2 5-8.2m-1.8 15.2c-2.6 1.4-4.7 1.6-7 .5-.7 4.9.6 6.8 3 6.6 2.4-.2 4.3-2.4 4-7.1m307-72.2c1.1-3 2.7-4.4 5.3-4.6-3.2-5.2-5.7-6.3-7.6-4.8-1.9 1.6-1.6 5 2.3 9.4m25.2 85c2.3-2.2 4.4-2.7 6.8-1.6-.4-6.1-2.2-8.3-4.6-7.8-2.3.6-3.6 3.6-2.2 9.4"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "#217900",
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinejoin: "round",
          strokeWidth: 1.9,
          d: "M461.3 132s-7 6.9-5.7 15.2c1.2 8.3 6.5 18.6 5.5 27.3-1 8.6-2.5 14.3-2.5 14.3s8-9.1 8-18c.2-8.7-5.4-20.3-5.4-26.7s.3-12.2.1-12zm12.7 28s-5.3 4-4.8 13c.5 9.1 10 25.8 10 25.8s6.8 14 6.5 17.7c-.2 3.7 1.3-3.5.6-11.5s-11-25.8-11-25.8-2.2-3.6-2-9.7c.2-6 .8-9.4.8-9.5z"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "#6b18b5",
          fillRule: "evenodd",
          d: "M313 47.4c0-1.8-2.2-3.4-4.8-3.4s-4.7 1.6-4.7 3.4 2 3.4 4.7 3.4 4.7-1.5 4.7-3.4zm2 8c0-1.8-2.2-3.3-5-3.3-2.6 0-4.8 1.4-4.8 3.2s2.2 3.3 4.9 3.3 4.8-1.5 4.8-3.3zm6-9.4s-5.6 4.1-3.3 5.8c2.3 1.7 8.6-3.6 8.6-3.6zm163.3 95.4c0-1.2-.5-2.3-1.4-2.9a2.6 2.6 0 0 0-3 0c-.9.6-1.4 1.7-1.4 2.9s.5 2.3 1.4 2.9a2.6 2.6 0 0 0 3 0c.9-.6 1.4-1.7 1.4-2.9m-2.1-8c0-2-1.4-3.5-3-3.5s-3.1 1.6-3.1 3.6 1.4 3.5 3 3.5 3.1-1.6 3.1-3.5zm1.5 16.2c0-1-.6-1.8-1.2-1.8s-1.2.8-1.2 1.8.5 1.9 1.2 1.9 1.2-.9 1.2-1.9m4.9-14.4c0-1.2-.6-2.1-1.2-2.1-.7 0-1.2.9-1.2 2s.5 2.2 1.2 2.2c.6 0 1.2-1 1.2-2.1m-13.4 1.4c0-1-.6-1.7-1.2-1.7s-1.2.8-1.2 1.7.5 1.8 1.2 1.8 1.2-.8 1.2-1.8m2.1 11.4c0-1.5-1.1-2.7-2.5-2.7s-2.5 1.2-2.5 2.7c0 1.6 1 2.8 2.5 2.8s2.5-1.2 2.5-2.8m-6.6-5c0-1.3-1-2.4-2.1-2.4-1.2 0-2.2 1-2.2 2.4s1 2.4 2.2 2.4c1.1 0 2-1 2-2.4zm-1-6.8a2 2 0 0 0-1-1.7 1.8 1.8 0 0 0-1.9 0 2 2 0 0 0-.9 1.7 2 2 0 0 0 1 1.8 1.8 1.8 0 0 0 1.8 0c.6-.4 1-1 1-1.8m30.1 34.4c-2.7-3.6-7.1-5.1-9.8-3.4-2.6 1.7-2.6 6 .2 9.7 2.7 3.6 7 5.1 9.7 3.4 2.7-1.8 2.7-6 0-9.7zm7.8 66.7c.5-4.5-1.6-8.4-4.8-8.8-3.2-.3-6.2 3-6.8 7.4-.5 4.4 1.7 8.3 4.9 8.7 3.2.4 6.2-3 6.7-7.3m1.6 38.8c1-4.4-.9-8.5-4-9.2-3.2-.6-6.5 2.4-7.4 6.8-.9 4.3 1 8.4 4 9 3.2.7 6.5-2.3 7.4-6.7zm7.5-36.4c0-1.7-1.2-3.1-2.6-3.1s-2.7 1.4-2.7 3.1c0 1.8 1.2 3.2 2.7 3.2s2.6-1.4 2.6-3.2m-6.5 7.3-5.4 6.2s-5.1.1-4.8 1.8c.2 1.6 7 6.6 7 8.6-.1 2 4.4-.5 4.4-.5l3.7-11.1s-.2-7.7-2.2-7.6c-2 .2-2.5 2.5-2.7 2.6m-357.4-2.4a2.6 2.6 0 1 0-5.1 0 2.6 2.6 0 0 0 5.1 0m2.5-8c0-1.4-1.2-2.6-2.6-2.6s-2.6 1.2-2.6 2.7 1.2 2.7 2.6 2.7a2.7 2.7 0 0 0 2.6-2.7zM134 199.2c-1-2.2-3-3.4-4.5-2.7-1.5.7-2 3-1 5.2s3 3.4 4.5 2.7c1.6-.7 2-3 1-5.2m6.5 23.4c-1.4-2.8-4.1-4.4-6.2-3.5s-2.7 3.9-1.4 6.7 4 4.4 6.2 3.5 2.7-3.9 1.4-6.7m6.8 17.2c.5-3.5-1-6.8-3.2-7.2-2.3-.5-4.4 2-4.9 5.5-.4 3.5 1 6.7 3.3 7.2 2.2.5 4.4-2 4.8-5.5m-11 2.5c1.4-3.3.9-6.8-1.1-7.8s-4.8.7-6.2 4-.9 6.7 1.2 7.8 4.7-.7 6.1-4"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "#6b18b5",
          fillRule: "evenodd",
          d: "M131.3 234.8c0-1.7-1.3-3-2.9-3s-2.9 1.4-2.9 3 1.3 3 3 3 2.8-1.3 2.8-3m-2.3-7.5c0-1.5-1.2-2.7-2.6-2.7a2.7 2.7 0 0 0-2.6 2.8c0 1.4 1.2 2.7 2.6 2.7s2.6-1.3 2.6-2.8m2.4-14.3c0-2.6-1.1-4.6-2.5-4.6s-2.5 2-2.5 4.6c0 2.5 1.1 4.6 2.5 4.6s2.5-2 2.5-4.6m7.8-1.1c.3-2.5-.5-4.7-2-5-1.3-.1-2.7 1.8-3 4.3-.4 2.5.5 4.7 1.9 4.9 1.3.2 2.7-1.7 3-4.2zm55-110c1.1-3.6 0-7.2-2.3-8-2.3-.9-5 1.3-6 4.9-1 3.6 0 7.2 2.3 8 2.3.9 5-1.3 6-4.9m-10.4 15.9c3-2.7 4.4-6.3 3-8.1-1.5-1.9-5.2-1.2-8.3 1.4s-4.3 6.2-2.9 8c1.5 1.9 5.2 1.3 8.2-1.3m-6-8.8c3-2.3 4.2-5.4 2.8-7s-5-1-8 1.2c-3.1 2.3-4.4 5.4-3 7s5 1 8.1-1.2zm23.5-15.5c2-1.6 2.9-3.8 2-4.9-1-1-3.5-.7-5.6.9s-2.9 3.7-1.9 4.8c1 1.1 3.4.7 5.5-.8"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "#6b18b5",
          fillRule: "evenodd",
          d: "M189 108.5c1.4-2.2 1.5-4.5.2-5.2-1.3-.7-3.5.4-4.9 2.6s-1.5 4.5-.2 5.2c1.3.7 3.5-.5 4.9-2.6m17.7-9.3c2.2-1.9 3-4.3 2-5.5-1.2-1.2-4-.6-6.2 1.2s-3 4.3-1.9 5.5c1.2 1.2 3.9.6 6.1-1.2m-32 21.6c2 0 3.6-1.1 3.4-2.3 0-1.1-1.9-2-4-1.9-2 .1-3.6 1.2-3.4 2.3.1 1.2 2 2 4 2zm38.7-33.1c1.4-2.2 1.5-4.5.2-5.2-1.2-.7-3.4.4-4.8 2.6s-1.5 4.5-.2 5.2c1.3.7 3.4-.4 4.8-2.6"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "#ffd200",
          fillRule: "evenodd",
          stroke: "#ef8a10",
          d: "M446.8 153.4s6.4-10.1 4-19.7c-2.5-9.5-13-2.7-12.8.7.2 3.3 6.8 7.9 7.2 10 .4 2-.8 8.3 1.6 9z"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "#217900",
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinejoin: "round",
          strokeWidth: 2.3,
          d: "M324.9 69.3s23 .9 23.1 15.8c0 2.3 0 5-.8 11.7 4.6-2.5 7.6-9.3 7-13.7.1-15.1-20.5-25.5-29.3-13.8z"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "#217900",
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinejoin: "round",
          strokeWidth: 2.3,
          d: "M310.3 68.6s18.5-3.8 18.7 11c.1 15-6 17.3-6 17.3s14.3-3 14.4-18.1c0-15.2-18.3-21.9-27.1-10.2z"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "#f7df73",
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinejoin: "round",
          strokeWidth: 2.5,
          d: "M373.3 390s86.8-24.6 113-131C471 368.1 376 403 376 403l-2.8-13z"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "#8c1800",
          fillRule: "evenodd",
          d: "M382.2 396.6c2.7 0 9.3-7.4 13.1-8.2 3.8-.8 4.2-4.7-.1-4.8-4.4-.2-8.2 5-8.2 5s-3.8 3.2-7.8 3.6c-4 .4-1.4 5.4 3 4.4"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "#8c1800",
          fillRule: "evenodd",
          stroke: "#8c1800",
          strokeWidth: 2.5,
          d: "M432.2 359.3s-9 5.2-7.8 6.5c1.3 1.3 9.3-5 9.5-5 .1-.2 3.4-4.2-1.7-1.5z"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "#8c1800",
          fillRule: "evenodd",
          d: "M400.7 383s-2.7-1 4.2-3.6c7-2.7 6.5-5.8 8.8-7.1 2.2-1.3 7-4.7 8-2.7s-5 6-6.5 6.4c-1.4.4-8.3 6.8-10.3 7.3-2 .6-3.4.3-4.2-.3"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "none",
          stroke: "#8c1800",
          strokeLinecap: "round",
          strokeWidth: 3,
          d: "M445.6 346c-6 6.7-6 6.5-6 6.5"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "none",
          stroke: "#8c1800",
          strokeLinecap: "round",
          strokeWidth: 2.8,
          d: "m454.5 335.2-5.7 6.9"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "none",
          stroke: "#8c1800",
          strokeLinecap: "round",
          strokeWidth: 2.5,
          d: "m463.4 321-6.4 10.2"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "none",
          stroke: "#8c1800",
          strokeLinecap: "round",
          strokeWidth: 2.3,
          d: "m470.9 306.6-5.3 10.5m8.6-18-1.6 3.6"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "none",
          stroke: "#8c1800",
          strokeLinecap: "round",
          strokeWidth: 1.4,
          d: "m478 289-1.4 4.4"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "#f7df73",
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinejoin: "round",
          strokeWidth: 1.5,
          d: "M160.3 216s52-14.7 67.6-78.5c-9.1 65.5-66 86.2-66 86.2z",
          transform: "matrix(-1.65528 0 0 1.70062 524.8 20.4)"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "#8c1800",
          fillRule: "evenodd",
          d: "M250.7 394.4c-2.7 0-9.2-7.5-13-8.3-3.8-.9-4.2-4.8.1-5 4.4 0 8.1 5.1 8.1 5.1s3.8 3.3 7.7 3.8c4 .4 1.4 5.4-2.9 4.4"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "#8c1800",
          fillRule: "evenodd",
          stroke: "#8c1800",
          strokeWidth: 1.5,
          d: "M195.5 197.6s-5.4 3.2-4.6 4c.7.7 5.5-3 5.6-3.1.1-.1 2-2.5-1-.9z",
          transform: "matrix(-1.65528 0 0 1.70062 524.8 20.4)"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "#8c1800",
          fillRule: "evenodd",
          d: "M232.4 380.6s2.6-1-4.2-3.7-6.5-6-8.7-7.2c-2.2-1.3-7-4.7-8-2.7s5 6 6.5 6.4c1.4.5 8.2 7 10.2 7.5 2 .6 3.3.3 4.2-.3"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "none",
          stroke: "#8c1800",
          strokeLinecap: "round",
          strokeWidth: 1.8,
          d: "m203.5 189.7-3.5 3.9",
          transform: "matrix(-1.65528 0 0 1.70062 524.8 20.4)"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "none",
          stroke: "#8c1800",
          strokeLinecap: "round",
          strokeWidth: 1.7,
          d: "m208.9 183.2-3.4 4.1",
          transform: "matrix(-1.65528 0 0 1.70062 524.8 20.4)"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "none",
          stroke: "#8c1800",
          strokeLinecap: "round",
          strokeWidth: 1.5,
          d: "m214.2 174.7-3.8 6.1",
          transform: "matrix(-1.65528 0 0 1.70062 524.8 20.4)"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "none",
          stroke: "#8c1800",
          strokeLinecap: "round",
          strokeWidth: 1.4,
          d: "m218.7 166.1-3.2 6.3m5.2-10.9-1 2.2",
          transform: "matrix(-1.65528 0 0 1.70062 524.8 20.4)"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "none",
          stroke: "#8c1800",
          strokeLinecap: "round",
          strokeWidth: 0.8,
          d: "m223 155.5-.9 2.7",
          transform: "matrix(-1.65528 0 0 1.70062 524.8 20.4)"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "#217900",
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinejoin: "round",
          strokeWidth: 2.3,
          d: "M490.4 239.3c.5 6.7 7 13 4.4 24.7-3.2 13.3-14.8 44.7-12.8 50.2-3.4-4.7-2.8-9-3-15.6-.4-6.5 9.4-30.9 10.3-39.1 0-7.4.7-17.5 1.1-20.2z"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "#217900",
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinejoin: "round",
          strokeWidth: 2.3,
          d: "M490.4 239.4s10.7 13.5 10.1 24.2c-.5 10.7-6.5 23.2-4.5 28.7a21.7 21.7 0 0 1-4.6-14.2c-.3-6.5 5.3-13.8 4.1-20.9-1.1-7-5.2-17.8-5-17.8zm-349.3 3c-.4 6.7-5.4 12.7-2.8 24.3 3.2 13.3 15 30 13 49.2 3.5-4.7 4.5-10 4.8-16.5.2-6.5-13-28.5-13.8-36.8 0-7.4-.8-17.5-1.2-20.2z"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "#217900",
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinejoin: "round",
          strokeWidth: 2.3,
          d: "M141.1 242.6s-10.4 13-9.8 23.7c.1 7.1 13.2 36.8 11.2 42.4 3.5-4.7 4.4-4.1 4.3-11.2-3.8-18.3-10.7-29.9-9.5-37 1.1-7.1 4-18 3.8-18z"
        }),
        /* @__PURE__ */ jsx221("path", {
          fill: "#fff",
          stroke: "#000",
          strokeDashoffset: 1,
          strokeLinecap: "square",
          strokeLinejoin: "round",
          strokeWidth: 1.7,
          d: "m100 125.8 22 68.2h72l-58 42.2 22.1 68.2-58-42.1-58 42.1 22-68.2L6 194h71.8z",
          transform: "matrix(1.16516 0 0 1.16534 202 -23.6)"
        })
      ]
    })
  ]
});
var Mp_default = SvgMp;

// src/country-flag-icons/generated/Mq.tsx
init_esm_shims();
import { jsx as jsx222, jsxs as jsxs197 } from "react/jsx-runtime";
var SvgMq = (props) => /* @__PURE__ */ jsxs197("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx222("path", {
      fill: "#231f1e",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx222("path", {
      fill: "#00a650",
      d: "M0 0h640v240H0z"
    }),
    /* @__PURE__ */ jsx222("path", {
      fill: "#ef1923",
      d: "m0 0 320 240L0 480z"
    })
  ]
});
var Mq_default = SvgMq;

// src/country-flag-icons/generated/Mr.tsx
init_esm_shims();
import { jsx as jsx223, jsxs as jsxs198 } from "react/jsx-runtime";
var SvgMr = (props) => /* @__PURE__ */ jsxs198("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx223("path", {
      fill: "#cd2a3e",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx223("path", {
      fill: "#006233",
      d: "M0 72h640v336H0z"
    }),
    /* @__PURE__ */ jsx223("path", {
      fill: "#ffc400",
      d: "M470 154.6a150 150 0 0 1-300 0 154.9 154.9 0 0 0-5 39.2 155 155 0 1 0 310 0 154.4 154.4 0 0 0-5-39.2",
      className: "mr_svg__mr-st1"
    }),
    /* @__PURE__ */ jsx223("path", {
      fill: "#ffc400",
      d: "m320 93.8-13.5 41.5H263l35.3 25.6-13.5 41.4 35.3-25.6 35.3 25.6-13.5-41.4 35.3-25.6h-43.6z"
    })
  ]
});
var Mr_default = SvgMr;

// src/country-flag-icons/generated/Ms.tsx
init_esm_shims();
import { jsx as jsx224, jsxs as jsxs199 } from "react/jsx-runtime";
var SvgMs = (props) => /* @__PURE__ */ jsxs199("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx224("path", {
      fill: "#012169",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx224("path", {
      fill: "#fff",
      d: "M384.9 111h205.5l-.3 146.3c1.7 58.7-34.9 95.2-102.3 111.7-47.9-12-103-36.5-103.2-110z"
    }),
    /* @__PURE__ */ jsx224("path", {
      fill: "#00a2bd",
      stroke: "#000",
      strokeWidth: 1.8,
      d: "M389.4 115.4h196.4l-.2 140.2c1.6 56.3-33.4 91.2-97.8 107-45.8-11.4-98.5-35-98.6-105.4z"
    }),
    /* @__PURE__ */ jsx224("path", {
      fill: "#a53d08",
      d: "M584.3 272.2c-7.2 53.7-48.6 77.2-96.5 89.7-42.5-11.4-88.2-29.6-97-89.5z"
    }),
    /* @__PURE__ */ jsx224("path", {
      d: "m480 141.5-.3-17.6 14 .1.1 17.5H532l.1 13.7-38.3.2-.3 161.4-13.6.1-.2-161.7-38 .2v-14z"
    }),
    /* @__PURE__ */ jsx224("path", {
      fill: "#ff9a08",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.8,
      d: "m449 278.8 35 36.3c12.1-13.3 3.7-63-12.2-72.1-1.9 5.9-5.1 13-8.6 15.2-7.5 5.2-26.1 11.2-19.9 15 1.4-1.9 5.1-3.7 6.9.6 2 6.9-7.8 7.3-7.8 7.3s-6.2-.8-7.3-7c-1-6.4 9.3-12.2 10.2-12.6.8-.3 14.3-4 16.6-15.9 2.9-11.8 5.8-10 6.3-10.2 17.7 1.7 29.2 33.3 29.9 55.5.6 22.2-9 37-10.8 38-1.7.9-42-47.9-42-47.9z"
    }),
    /* @__PURE__ */ jsx224("path", {
      fill: "#ff9a08",
      stroke: "#000",
      strokeWidth: 0.8,
      d: "m474.6 245 .2 65.5m-4.2-64.2.3 59.4m-4.5-50.8.2 47.2m-3.7-43.9.2 39.1m-3.9-37.3v33m-4-30.4v26.1m-3.5-24v20"
    }),
    /* @__PURE__ */ jsxs199("g", {
      fill: "none",
      stroke: "#ffdf00",
      strokeLinecap: "round",
      strokeWidth: 1.8,
      children: [
        /* @__PURE__ */ jsx224("path", {
          strokeWidth: 0.8,
          d: "m448.5 283 36 41.2"
        }),
        /* @__PURE__ */ jsx224("path", {
          strokeWidth: 1.4,
          d: "M486.3 257s16.4 35.7 1.2 65m-43.2-46.6s1.2-3.1 2.7-1.8m-5.5-7.3s-6.6 5.7-3 9.5"
        })
      ]
    }),
    /* @__PURE__ */ jsx224("path", {
      fill: "#008021",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M494 175.4c2.3-2 3.6-3.3 5.1-3 1.5.2 3.5 0 5-.4a31 31 0 0 1 12-.4c1 .2 2.5.7 4.6 2.5 2.1 1.8 5.2 5 4.2 13.6s-.7 12.3-1.2 17.2c-.8 8.5-2.7 15.5-6 15 4.5 8 5 15 8 20.5s4.8 16.8 3.7 29c-1.2 12.3-4.4 39.7 5.3 58.2-1.6 1.1-5.5 0-9-3.7s-5-3.6-7.8-1.4c-8.8 6.7-17 14.8-29.1 6.7-2.8-1.8-3.6-4-1.6-9.7 5-14 7.5-33.4 6.7-42.4z"
    }),
    /* @__PURE__ */ jsx224("path", {
      fill: "#ffe1cf",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M502.3 166.8a9.6 9.6 0 0 1-.1 6.8 9 9 0 0 0 .5 8.4c2.7-4 6.6-3.2 9-5.4 2.2-2.3 2.7-4.5 4.4-5-1.7-1.5-4.3-3.2-3.8-7.5.6-4.4 6.7-8 1.2-14.6a8 8 0 0 0-13.4 1.2c-.3.8.2 2.4-.7 3.4a8 8 0 0 1-2.1 2c-.5.4-.8.9-.2 1.6.2.3.6.3 1 .4l-.8 1.5c-.3.3-.2.6.2 1-.5 1.3.4 1.5-.2 2.5-.6.9-1.2 2 .6 3 .6.3 3 .8 4.4.7zm-22.5 23c-3.2.8-8.4-.6-12.3-.2-1.8.2-3.2-.7-3-2.4.3-1.7.6-4.4.2-6.8a31.6 31.6 0 0 1 3.8-14.8 33 33 0 0 0 3.8-11.6c0-1.9.2-3.9 1.8-5 1.2-.7 1.4-1.4 1.8-2 1-1.5 2-1.8 2-1 .1.5 0 1-.5 1.6 1-.8 2.8-1.8 3.2-2 .4-.4 2.4-1.8 2.5-.4.8-.4 1.4-.4 1.6 0 .2.5 0 .7-.3 1 .6 0 1.2.9 0 1.8.7-.2 1.3.8.2 1.7-1 1-2.4 1.6-2.7 2.4-.4.8-3.2 2.9-4.3 3.3-1.1.5-1.2 1.1-1.2 2.7 0 17.8-2 16.3-2 20.7 0 1-.3 2.1.8 1.8a15 15 0 0 1 4.6-.9v10zm.7 38.2c5.2-2.6 11.2-3.6 14.3-4.4a62.4 62.4 0 0 0 10.4-4.4c2.5-1.3 4.5-3 5.9-3.5a6.5 6.5 0 0 0 3.8-3.2 50.4 50.4 0 0 0 6.9-21.8c0-4-1-8.6-5-5.4a29.6 29.6 0 0 0-8.8 13.2c-1.6 6.4-3 7.9-3.3 9.1-.4 1.3-1.6 1.3-3.2 1.6a26.7 26.7 0 0 0-13.6 6.4 136 136 0 0 1-14.2 9.2c-3.7 2.1-4.4 2.3-5.2 4-.8 1.6-1.6 3-2.2 3.6-.8.8-1 1.6-.8 2.6.1.8-.2 4.2-.3 5.4 0 1.2.3 1.4.7 1.5.4 0 1-.2 1.3-1.6-.2 1.4 1.7 1 1.8-.1 0 1.5 2 .6 2-.8 0 1 1.7.3 1.7 0 .4-1.3.7-2.5 1.2-3.4.6-1.4 1.3-3.2 2.7-4 1.5-1.2.8-2.4 3.9-4zm37.4 94.5c.3 1.3 1 2.7 1.2 3.6.2.8-.2 1.1-.4 1.6a32.8 32.8 0 0 0-2.8 8.8c0 1.2-1 2.4-1.3 3.2-.5.8-.3 1.5.8 2.3.4.3 2-.2 2.1-1 .7.6 1.6.4 2.1-.5.6.5 1.5.2 2-.7.5.3 1.3-.3 1.6-.8.8.4 1.6 0 1.6-1.6 0-.4.3-1 .5-1.3.2-.4.3-1.1.3-1.7 0-.7.3-2 .9-2.8.6-1 1.5-2.5 1.1-4-.4-1.4-1-1.3-1.5-3.2-1.3-1.4-3-3.2-4.8-3.4-1.8 0-2.8 1.1-3.4 1.5zm-32.9 9.9c1.7 1.6 5.3 1.6 7.8-1-.9-.4-3-1.4-3.8-2a12.4 12.4 0 0 1-4 3z"
    }),
    /* @__PURE__ */ jsx224("path", {
      fill: "#870f00",
      stroke: "#000",
      strokeWidth: 0.3,
      d: "M501.4 149c.6-4 3.5-4 5.3-3.5.8.1 2.6.3 4.4-.2 3.4-.9 6 .3 5.6 3.6 1 .7 2 2.3 1.7 3.7-.1 1.4.2 2 1.4 2.1 1.3.2 4 1.8 2.2 4 1.7 1 3 3.7 2.1 5.4-.9 1.8-3.6 2.1-4.8.5-1.3.6-3.3.7-4.6-.6-.9 1-3 .9-3.5 0-.4-1-1-1.4-1.9-1.7-.9-.3-1-2.8.4-3.1-.1-.8 0-1.6.3-2 .3-.4 0-1.2-.8-1.8-.8-.7-1.5-3-.7-4.4-1.4.5-4.4-.9-5-1.8-.7-1-1.6-1-2.1-.2z"
    }),
    /* @__PURE__ */ jsxs199("g", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.3,
      children: [
        /* @__PURE__ */ jsx224("path", {
          d: "M502.3 166.8c2.2-.3 3-1.6 4.6-1.6m-9.4-4.7.5.3c.4.3 1 .4 1.4.4m-1.3-3.1 1 .6m4.2-9.7c-1.3-1.3 2.2-3.8 6-.2.8.8 2.5.8 3 .6m-3.8 1.6c1.8-.4 4.3-.4 5.1 1.6.8 2 2.3.6 3.5 3 1.2 2.3 3 4.8 5 3m-7.4 5.4a4 4 0 0 1-.4-3.2c-.7-.8-.4-2.5 0-3.3m-4.6 1.7c0 .7 1 2 2.4 2.2m7.2 3.2c-.8-1-.7-2-.5-3.2"
        }),
        /* @__PURE__ */ jsx224("path", {
          d: "M510.9 153c0 1.1.6 2.5 1.6 3 .3.6 1.4 2.2 3.8 2m.4-9a10.9 10.9 0 0 0-5.2-2.6m-8.8 35.6c-2 2.7-3.2 6.4-2.4 11.6 1 5.2 2.4 12.8-1.3 16.2m18.6 10.1c-2.6-.7-6.4-.7-8.5.9-2 1.5-5.6 1.6-7.9.4"
        }),
        /* @__PURE__ */ jsx224("path", {
          d: "M512 219.6c-2.3.4-3.3 2.1-3.3 6.4 0 4.2-1 10.4-.2 16.6m-.6-21.1c-1.6.4-3.2.4-2.8 4.5m-5.1 0c.1-2.4 1-4.8 2.6-4.3m14.1 4.9c0-5.6-1.2-7.1-2.8-7 2.2 0 3.7.3 4.7 9.2.6 6.8 2 9 3.7 14.4 4.1 13.6 2 34.5 4.1 42m-12.9-57a71.4 71.4 0 0 1-.4 49.3c4.8 13.4 9.6 23.1 10.5 28.6m-23.9-48c.8-2.9-2.2-3.2.4-13.3 1.1-4.4 1.3-7 .6-8.4"
        }),
        /* @__PURE__ */ jsx224("path", {
          d: "M500.7 242.4c-1 4.4 3.3 12.8 1.2 19m-5.5 1.1c0 4 .9 9 .7 13-.2 3.9 1.4 5.7 3.2 9.4 6.8 13.4 11.2 22.9 10.7 35.5-.2 2.4.6 7.2-1.8 8.6m-12.6 3.4c.7 0 1.4-.4 2.3-2.4a64.8 64.8 0 0 0 2.4-23m1.4 9.6c.4 2.6.4 8-1.3 12.4"
        }),
        /* @__PURE__ */ jsx224("path", {
          d: "M507.1 308.7c1 5.6 1 10.7.1 14.3m-2.4 0c.2 2.2 1.2 8-.5 8.5m9.2-35.3c4.3 6.7 7.6 23.2 11.2 26.6m-7.6-2.6c0-1.8-.1-4.4-1.2-5.6M471 239.4c.1-1.2-.1-2.4 1.3-4.4m-3.3 5.2c.2-4.4.1-4.8 1.4-6m-3.2 6.1c0-3.2-.3-4.3 1-6.3m14.9-88.8-4.5 3.4m5.8-2.4c-.5 0-2.1 1.4-5 3.6m5.1-1.8c-1 .4-2.6 2-4.2 3.2m-2.9-3.5-1.6 1.6M517.5 341c-.2-.2-.2-1.3.3-2.4m1.9 1.9c-.4-.3 0-1.7.2-2.6m1.7 1.9c-.4-.2-.5-1 0-2m1.5 1.2c-.2 0-.3-.6.1-1.8"
        })
      ]
    }),
    /* @__PURE__ */ jsx224("path", {
      d: "M500.5 152.7c.8 1 1.7 1 1.8 1.6.2.8.3.8.4 1 .2.2-.4.2-.6 0h-1.4c-.4 0-.8-.5-.6-.5.3-.1.3-.2.2-.4 0-.3.2-.6.4-.7l-.1-.3c-.2-.3-.3-1-.1-.8zm.5-1.1a6.4 6.4 0 0 1 3.4 1.6c.7.8.1.6-.2.6s-1-.2-1.4-.6a4.6 4.6 0 0 0-1.9-1.2c-.3 0-.6-.4 0-.4z"
    }),
    /* @__PURE__ */ jsx224("path", {
      fill: "#012169",
      d: "M0 0h320v240H0z"
    }),
    /* @__PURE__ */ jsx224("path", {
      fill: "#FFF",
      d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0z"
    }),
    /* @__PURE__ */ jsx224("path", {
      fill: "#C8102E",
      d: "M212 140.5 320 220v20l-135.5-99.5zm-92 10 3 17.5-96 72H0zM320 0v1.5l-124.5 94 1-22L295 0zM0 0l119.5 88h-30L0 21z"
    }),
    /* @__PURE__ */ jsx224("path", {
      fill: "#FFF",
      d: "M120.5 0v240h80V0zM0 80v80h320V80z"
    }),
    /* @__PURE__ */ jsx224("path", {
      fill: "#C8102E",
      d: "M0 96.5v48h320v-48zM136.5 0v240h48V0z"
    })
  ]
});
var Ms_default = SvgMs;

// src/country-flag-icons/generated/Mt.tsx
init_esm_shims();
import { jsx as jsx225, jsxs as jsxs200 } from "react/jsx-runtime";
var SvgMt = (props) => /* @__PURE__ */ jsxs200("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx225("path", {
      fill: "#fff",
      d: "M0 0h640v480H0Z"
    }),
    /* @__PURE__ */ jsx225("path", {
      fill: "#cf142b",
      d: "M320 0h320v480H320Z"
    }),
    /* @__PURE__ */ jsxs200("g", {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 96,
      transform: "translate(161.8 160.6) scale(.0147)",
      children: [
        /* @__PURE__ */ jsx225("path", {
          fill: "none",
          stroke: "#cf142b",
          strokeWidth: 512,
          d: "M-2048-7168h4096v3890.8A1094 964 45 0 1 3277.2-2048H7168v4096H3277.2A964 1094 45 0 1 2048 3277.2V7168h-4096V3277.2A1094 964 45 0 1-3277.2 2048H-7168v-4096h3890.8A964 1094 45 0 1-2048-3277.2Z"
        }),
        /* @__PURE__ */ jsx225("path", {
          stroke: "none",
          d: "M2024-3275.2A1094 964 45 0 1 3275.2-2024v4048A964 1094 45 0 1 2024 3275.2h-4048A1094 964 45 0 1-3275.2 2024v-4048A964 1094 45 0 1-2024-3275.2Z"
        }),
        /* @__PURE__ */ jsx225("path", {
          strokeWidth: 48,
          d: "M-2024-7144h4048V7144h-4048zm-5120 5120H7144v4048H-7144Z"
        }),
        /* @__PURE__ */ jsx225("path", {
          d: "M-1792-6912h3584V6912h-3584zm-5120 5120H6912v3584H-6912Z"
        }),
        /* @__PURE__ */ jsx225("circle", {
          r: 3200
        }),
        /* @__PURE__ */ jsx225("circle", {
          r: 2368
        }),
        /* @__PURE__ */ jsxs200("g", {
          id: "mt_svg__a",
          strokeLinejoin: "round",
          strokeWidth: 48,
          children: [
            /* @__PURE__ */ jsx225("path", {
              d: "M3084-2565c-111 85-322 302-450 461l-119-74c163-141 389-350 514-499zm-101-185c-201 59-585 172-749 276l-36-52c69-99 147-506 144-622l125 28c-41 100-81 314-92 453 129-23 435-123 522-186z"
            }),
            /* @__PURE__ */ jsx225("path", {
              d: "M3240.8-2291.9h-158.6a600 330 45 1 0-242.3 173.3l112.1-133.7 138.1 138.1-154.5 154.4a1070 940 45 0 1-974.1-1283 1070 940 45 0 1 1279.3 950.9z"
            })
          ]
        }),
        /* @__PURE__ */ jsx225("use", {
          xlinkHref: "#mt_svg__a",
          transform: "rotate(90)"
        }),
        /* @__PURE__ */ jsx225("use", {
          xlinkHref: "#mt_svg__a",
          transform: "scale(-1)"
        }),
        /* @__PURE__ */ jsx225("use", {
          xlinkHref: "#mt_svg__a",
          transform: "rotate(-90)"
        })
      ]
    }),
    /* @__PURE__ */ jsxs200("g", {
      transform: "translate(161.8 160.6) scale(.0147)",
      children: [
        /* @__PURE__ */ jsx225("path", {
          d: "M-2541 1790c-72-126-167-287-219-329 32-22 75-54 97-60-1 80 120 246 120 246l178-117c-50-77-94-136-130-159 44-32 91-59 104-62 1 39 24 104 92 184 0 0 166-88 220-156l70 114c-78 15-428 233-532 339m-247-1517c-187 34-282 193-250 372 32 181 194 305 372 275 178-31 279-195 245-385s-180-296-367-262m27 108c150-27 276 46 297 162s-72 231-223 258-271-69-288-166c-18-99 63-227 214-254m366-1100c-62 98-199 188-320 271-17-86-81-141-155-146-79-4-160 59-174 101-20 58-45 307-45 307 156-12 497 15 614 58l14-132c-77 20-251-16-251-16l4-58 180-142c23-18 158-144 162-234 1-28-23-21-29-9m-361 441c-71 2-219-6-260-24 16-143 60-194 136-187 70 7 144 47 124 211m682-1772c-136 11-306 139-302 249 1 58 21 138 98 196 76 58 155 75 218 63 61-11 162-96 161-143 0-46-108-174-176-174l113-121c29 70 145 172 188 185-49 117-110 239-238 298-128 60-261 57-382-57-114-108-70-316 2-397 79-89 226-127 229-196zm638-673 24 454s9 161-28 261l141-99c-55-44-44-179-44-179l228-122s108 69 97 153l194-79c-113-43-253-142-253-142zm73 141 208 138-203 109zm1018-474c-26 111 2 330 43 512 141-13 249-27 297-87l13 150c-139 0-292 16-432 38 2-205-19-474-77-590zm1059 67c-65 94-119 308-147 492 136 40 242 66 309 27l-43 145c-129-50-278-92-416-123 76-189 155-448 144-576zm1071 485-396 225s-140 81-246 93l151 80c15-68 141-119 141-119l212 149s-14 129-94 156l157 138c-11-120 14-291 14-291zm-94 128-31 249-189-133zm304 932-62-117c102-8 409-188 550-280l22 40-132 603c118-47 305-145 356-199l70 133c-131-19-374 101-558 213l-18-32 113-587s-305 138-341 226m930 872c-12-89-14-150-57-170l-5-37 109-18c45 117 96 443 89 527l-112 18-5-31c37-42 0-196 0-196-166 17-455 64-496 121l-26-154c59 20 350-11 503-60M2388 752c62-98 201-187 322-269 17 86 80 142 155 146 79 5 160-56 174-99 21-58 47-306 47-306-156 10-496-19-613-63l-15 132c77-19 251 17 251 17l-4 58-181 141c-24 18-160 143-165 233-1 28 23 20 29 10m365-439c71-1 219 8 260 26-17 143-62 194-138 186-70-8-143-48-122-212m-566 836-93 160c72-11 172 46 253 99 27 72 133 256 125 436l120-206c-53-24-115-50-155-243 158-59 276-78 326-50l106-180c-123 74-412 150-460 134-50-29-192-73-222-150"
        }),
        /* @__PURE__ */ jsx225("circle", {
          cx: 1475,
          cy: 2361,
          r: 125
        }),
        /* @__PURE__ */ jsx225("circle", {
          cx: -1475,
          cy: 2361,
          r: 125
        })
      ]
    }),
    /* @__PURE__ */ jsxs200("g", {
      transform: "translate(161.8 201.5) scale(.0147)",
      children: [
        /* @__PURE__ */ jsx225("path", {
          d: "M195 268c-13 9-48-9-56-37 0 9-2 37-19 53-41 39-85 20-120 20s-79 19-120-20c-17-16-19-44-19-53-8 28-43 46-56 37-12-9-6-48 18-64-8 2-36 9-56-2-50-27-45-75-56-108s-43-69-18-120c10-21 36-32 44-35-29 1-56-27-52-41 5-15 44-21 67-3-6-7-20-31-16-54 10-56 57-66 85-87 29-21 53-62 109-54 23 3 41 24 47 31-10-27 8-62 23-62s33 35 23 62c6-7 24-28 47-31 56-8 80 33 109 54 28 21 75 31 85 87 4 23-10 47-16 54 23-18 62-12 67 3 4 14-23 42-52 41 8 3 34 14 44 35 25 51-7 87-18 120s-6 81-56 108c-20 11-48 4-56 2 24 16 30 55 18 64M-93 128c16 12-27 48-10 93 19 53 72 37 103 37s84 16 103-37c17-45-26-81-10-93s38 40 85 39c57-3 58-57 67-87 10-30 42-75-3-110-37-30-86 0-92-19s50-23 64-69c15-55-37-72-62-91-26-18-59-62-106-31-39 27-26 82-46 82s-7-55-46-82c-47-31-80 13-106 31-25 19-77 36-62 91 14 46 70 50 64 69s-55-11-92 19c-45 35-13 80-3 110 9 30 10 84 67 87 47 1 69-51 85-39"
        }),
        /* @__PURE__ */ jsx225("path", {
          d: "M0 199c-9 0-20-21-14-38-3 5-14 17-28 19-34 5-48-20-65-32-17-13-45-19-51-52-3-14 6-29 9-33-14 11-37 7-40-2-3-8 14-25 31-25-5-1-20-8-26-20-15-31 4-52 11-72 6-20 3-49 33-65 12-7 29-3 34-1-15-10-18-33-11-39 8-5 29 6 34 22 0-5 1-22 11-31 25-24 51-12 72-12s47-12 72 12c10 9 11 26 11 31 5-16 26-27 34-22 7 6 4 29-11 39 5-2 22-6 34 1 30 16 27 45 33 65 7 20 26 41 11 72-6 12-21 19-26 20 17 0 34 17 31 25-3 9-26 13-40 2 3 4 12 19 9 33-6 33-34 39-51 52-17 12-31 37-65 32-14-2-25-14-28-19 6 17-5 38-14 38M0 85c11 0 4 30 25 44 25 17 43-6 57-16s42-20 33-49c-7-25-37-27-34-38 3-10 29 6 50-10 24-19 7-43 2-59-6-16-6-46-37-47-26-1-37 27-46 21s15-26 6-50c-11-29-39-20-56-20s-45-9-56 20c-9 24 15 44 6 50s-20-22-46-21c-31 1-31 31-37 47-5 16-22 40 2 59 21 16 47 0 50 10 3 11-27 13-34 38-9 29 19 39 33 49s32 33 57 16c21-14 14-44 25-44"
        }),
        /* @__PURE__ */ jsx225("circle", {
          r: 48
        })
      ]
    }),
    /* @__PURE__ */ jsxs200("g", {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 36,
      children: [
        /* @__PURE__ */ jsx225("path", {
          strokeWidth: 0.7,
          d: "M137.9 185.8a588.3 588.3 0 0 1 48 0"
        }),
        /* @__PURE__ */ jsx225("path", {
          strokeWidth: 0.4,
          d: "m160 143.3 1.3 1.5m2 19.2c-.1 1.2 0 2.5.2 3.2m-3.2-3c.4.5 1 2.3 1 3"
        }),
        /* @__PURE__ */ jsx225("path", {
          fill: "#fff",
          strokeWidth: 0.5,
          d: "M170.2 185.6c-.6.2-1.6.8-1.6 1.3s1.2.6 1.6.7c-.7.2-2.7.6-3.6.2-.6.3-5.2-.7-6.2-.7-.6 0-1.4-.6-1.3-1.7 0-.2.2-.8.7-1-.3-.6 1.1-1.5 2.5-2.4-2 .3-4.7-.5-5.4-1.3-1.6-.6-2.3 0-3 1.4 0 2.4-1.3 3.6-3 3.4-1-.2-1.3.3-1.6.5l3.3 1c2.2 2 1 3.6.5 4-.5.3-1.7.1-2.4.1-.8 0-.8.3-1 .4-.6.3-1.1.4-1.3.2 0-.3.3-1.7 1.2-1.9.5 0 1.5-.3 1.5-.8 0-.4-1.8-.4-3.2-.9-1.1-.4-1.5-1-1.1-2.9.3-2 2.7-2.3 3.9-2.3-.2-.8 0-2.3 1-3.3 1.6-1.5 4-1 6.1-.8 1.2-.7 3.4-1.7 5.6-1.8 2 0 10.6-2.3 14.5-1.8-1-1.3-.7-4.4.9-5.3 2-1.2 4.2 2 4.8 1.4.5-.6-.7-1.4-2.2-3-.4-.6-.3-.6-.3-.8 0-.5 0-1 .3-1.2.2-.1 1.4.3 1.7.8.4.6.9.8 1.3.5.5-.4-.2-.2-.5-1-.1-.5-.5-.9-.4-1.3a7 7 0 0 1 2.3-1.6c.4.4.6.9.9 1.3.7 1.1 1.4.8 1.9 1.6.1.3.1 1 .5 1.7a9.6 9.6 0 0 0 3.5 3.6c.3.2.6.5.6.7 0 .4-.2.8-.4 1-.2.2-1 .2-1.6-.1-1-.5-1.5-.8-2.1-.7-1.4.2-2.3 2.4-4.3 2.4-1.8-.2-3-2.9-4.1-2.1-1.1.8 2.5 3 2 4 .4.2.9 1 .7 1.7a6 6 0 0 0 3.9-2.7c1-1.3 1.7-2 2.2-2.2.6-.3 1.3 0 1.3.5l.9.3c.5.2.3.8.2 1l-.6-.4c-.3 0-.8.3-1.2.6-.4.4-.7 1.2-1.2 1.7l-2 2.2c.3.4.2 1.1.2 1.5.1 0 .5 0 .7.2.2.1.1.3 0 .7 0 .5-2 2.7-2.4 2.6-.8 0-1.4-1-1.3-1.3-.9.4-1.3-.6-1.3-1a7 7 0 0 1-2.2 1.5c-.4.1-.6.2-.8-.4-.1.4-1.3.8-1.6.9-1.5.3-3.1 1-4.6 1l-3.8-.1z"
        }),
        /* @__PURE__ */ jsx225("path", {
          fill: "#fff",
          strokeWidth: 0.3,
          d: "M175.5 171.4c0 .6-.9 2 .4 3.2.8.6 2.1 1.1 2.5 2 .4.7-.1 1.3-.3 1.3-.8-.2-1.9 1.2-2.3 2.2-.4-1.4-1.3-1-2.5-.8.3-1.5-.8-2.4-2.6-2.6.3-.3-.2-.7-.6-1.1-.4-.4-1.8-.1-2-.4 0-.3.7-1 .3-1.5-.4-.7-2-.3-2.6-.5.2-.8.2-1.3-.2-2s-2.2-.5-3.1-.7c.7-.5 1-1.3.6-2.1-.4-1-2.4.1-2.4-1 .1-.5 2.4-.8 3.3-.9.8 0 3.7.7 6.5 1.3.6.6 5 1.9 5 3.6"
        }),
        /* @__PURE__ */ jsx225("path", {
          strokeWidth: 0.5,
          d: "M182.8 182.6c1.4-.7 2.7-1.6 4.1-2.8m-25.6-1c1.2 0 3.9.4 4.7 1.4.7 1 1.2 2.7-4.1 4 1.6 0 4-.3 4.8-.1.8-.2 2.5-.7 3.2-.5-.3.1-1.2.4-1.2 1 0 .5.4.5 1.1.8m5.1-3.6c1.9.4 4.6-.2 5 1.8"
        }),
        /* @__PURE__ */ jsx225("path", {
          strokeWidth: 0.4,
          d: "M181.2 166.8c.5.6 2 1.5 2.7 2 1 .8 1.4-.1.7-1.4"
        }),
        /* @__PURE__ */ jsx225("path", {
          strokeWidth: 0.3,
          d: "M168.1 175.2a30 30 0 0 1 6.1-.7m-8.4-1.3c3-.8 6.2-.5 8.2-.5m-.5 6.4 2.6-2.5m-5.4 0c1-.3 2.6-1 4-1.2m-4.2-7.6c1.6-1.5 3.4-1.3 5.2-2.2 1-.6 2-2 3-3.1.5-.4.9-.8 2-.7 1.4.1 1.5.5-.1.7-1.2.2-1.3.7-1.7 1.6-.4.8 0 1.7.2 2.3a9 9 0 0 0-.8 2.2c0 .3.1.6.5 1.1m-16.3.8c4-.9 10 .7 11.1.7"
        }),
        /* @__PURE__ */ jsx225("path", {
          strokeWidth: 0.2,
          d: "M187.7 177c1.3-.7 1.3-2 3-2.6m-6.6 9.1c1.7-.8 2-1.5 3-2.2m.9-13.7c-.2 0-.6 0-.8-.3-.2-.3-.3-.7-.1-.8.1-.2.3-.1.7.2s.3.7.2.9m.3 3c-.8.2-1-.5-1.7-.6-.9-.2-1.4.4-1.4.9s.5 1 1 1c.6 0 1-.3 2.1-.2m-3.8-7.2c.6 0 1.3.2 1.7-.2"
        }),
        /* @__PURE__ */ jsx225("path", {
          fill: "#fff",
          strokeWidth: 0.1,
          d: "M162.7 150.7a.4.2 75 0 1-.2-.7.4.2 76 0 1-.2-.7.4.2 77 0 1-.2-.7.4.2 79 0 1-.1-.7.4.2 80 0 1-.2-.7.2.4-8 0 1-.1-.7.2.4-7 0 1-.1-.8.2.4-5 0 1-.1-.7.2.4-3 0 1-.1-.7.2.4-1 0 1 0-.8.2.4 1 0 1-.1-.7.2.4 4 0 1 0-.8.2.4 6 0 1 0-.8.2.4 9 0 1 .1-.7.2.4 12 0 1 .2-.8.2.4 15 0 1 .1-.7.2.4 19 0 1 .2-.8.2.4 23 0 1 .3-.7.2.4 27 0 1 .3-.7.2.4 31 0 1 .3-.7.2.4 35 0 1 .5-.7.2.4 40 0 1 .5-.7.2.4 45 0 1 .5-.6.2.4 49 0 1 .6-.7"
        }),
        /* @__PURE__ */ jsx225("path", {
          strokeWidth: 0.1,
          d: "m163.6 150.4-.9.3m.7-1-.9.3m.8-1-1 .3m.9-1-1 .3m.9-.9-1.1.2m1-1-1.2.3m1-1-1.1.3m1.1-1-1.2.2m1.2-.8h-1.4m1.4-.7h-1.4m1.4-.7h-1.5m1.5-.7h-1.5m1.6-.7-1.6-.1m1.7-.6-1.6-.2m1.7-.4-1.7-.3m1.9-.4-1.7-.4m1.9-.2-1.8-.5m2-.2-1.8-.6m2 0-1.7-.7m2 .2-1.7-1m2.1.4-1.8-1m2.2.5-1.7-1.2m2.1.7-1.6-1.4m2.1 1-1.6-1.6m2.1 1-1.5-1.7"
        }),
        /* @__PURE__ */ jsx225("path", {
          fill: "#fff",
          strokeWidth: 0.5,
          d: "m173 140.7-2.5.3c-.2.5-.2 1.9-.2 2.4 2.3 2.3 4.6 5.2 4.8 7.9.7.6 1.2 1.2 1.6 2.3 1.7-.9 3.4-2.3 4.8-2.7 1-.2 2.6-.3 3.5.2l5.6 3.4c1.2.8 2 1.7 2.6 2.6.5.8.6 2.3.4 2.7l-3.4-1c-.2-.5 0-1.2.3-1.7.2-.6.2-.6-.3-1-.3-.2-.8-.2-1 0-.4 0-1-.2-1.2-.6-.3-.5-3.9-2-4.5-2.2-.6 0-1.5 0-2.2.6-.4.6-1.6 2.4-2.5 3.3-.2.2-.3.5-.1.8l3.6.1c1.4.2 3 1.6 3.8 2.5 3.5 3.2 4.8 5 5.9 6 .5.5 1 1 1 1.8h-3.4c0-1.3-.2-2.1-.4-2.8-.4-.5-1.1-.3-1.4-.3-.3 0-.7-.5-1-1-.5-1-2.3-2.3-3.1-2.8-.8-.5-1.1-.3-2-.4-.5-.1-1.6-.3-2.5 0-.9.3-3.4 1.1-5.7 1.4-.8.4-3.3.8-6 1.4-2 .4-6.5 1.2-7.4 1.2-.3 2.1-2.6 5.2-3.2 5.5-.7.9-.7 1.7-.2 2 .5.5 3.9.5 4.7.5l2.9.1c.5.1 1.3.8 2.2 1.3.6.3.7.7 1.1 1.3.3.4.7.8.8 1.2h-4c0-1-.5-1.7-1-1.7-.6.4-1.3.9-2.1.6-3.1-.2-5.1 0-8-.3-.9 0-1.6-1.2-1.3-2.3.3-1 .2-1.8 0-2.6-.3.3-1.5 1.4-2.1 2.2-1 1.1-.4 2.3 0 3 .5.5 3.9 3.7 4.3 4.6.3.6 1.7 1.6 3 2.7.4 1 1.2 1.5 1.8 2.1h-5l.2-1.3c0-.3-.3-.9-1-.8-.6 0-1.2-.7-1.4-1.3-.2-.7-2.5-3.6-3.2-4.2l-3-2.9c-.4-.1-.5-.8 0-1.3.4-.4 1.6-2.4 2-3.8.3-.9 0-1-.2-1.2a19.8 19.8 0 0 1-5.4-6 7 7 0 0 1-4-.3c-1-.5-2.2-.6-2.9.4-.4.7-.4 1.8.3 2.3 1 .8 2.1 2 3.3 3.4 1 1.3.1 2.3-1.3 3.5.2.5 0 .4.2 1.3.5.7.5 2.4-.1 2.7-.6.4-1.4.8-2 1.6-.8.9-1 0-.8-1.4.2-.9-.5-1.6-1.1-2.3-.6-.6-.3-2.6 0-3.2.5-.6.8-1.7 0-2.6-.9-.8-2.5-2.6-2.3-5a3.8 3.8 0 0 1 5.2-3.3c3 1.3 4.7 1 5.6.8.8-1.4 2-2.8 3.8-3.8 1.7-1 5-2.3 8.3-2.8l8.1-3c1.1-.2 1-1.2 1-1.8-1-5.5-.8-11.3 3.7-14.2.5-.5.3-1.7 1-2.6l1.3 2.2c2 .7 5.4 1.9 6.8 2.6.6.3 1.3.3 1.7.5.4.2.7.5 1 1 .3.6 0 1.3-.4 1.5-.3.1-1.9-.4-2.3 0 0 .3.5.7 1.4 1 .3.2-.3 1-.7 1-.3 0-.7 0-.9-.3-1-.2-2-.6-3-1"
        }),
        /* @__PURE__ */ jsx225("path", {
          strokeWidth: 0.5,
          d: "M167.3 137.1c0 3.4 1.1 5.1 3 6.3m6.4 10.2a9.5 9.5 0 0 1 0 4m-24.7 13c2.5-1.1 4.8-4 4.7-5.8 0-1-.9-2.5-3.1-2.6m3 2.6c.8.3 2.3.1 3.5.3m12.6-8.3c2 .1 4.6 1.3 6 1.2m-7 2.8c1.8.4 1.8 1.2 5.3 1m-6-12.2c1.9 0 3 1 4 1.7"
        }),
        /* @__PURE__ */ jsx225("path", {
          strokeWidth: 0.3,
          d: "M156.3 166.4c1.4 0 2.4-.2 3-1.4m8-27.9c0 2.8 1 3.5 3.2 3.9"
        }),
        /* @__PURE__ */ jsx225("path", {
          strokeWidth: 0.2,
          d: "M178 137.6c-.1.7-.2 1.3 1 1.2m-6.1-3.1c-.9 2.2 3.6 2.5 3.7 4m-25 14.7c2.2 1 2 5.3 2 7.8"
        }),
        /* @__PURE__ */ jsx225("path", {
          fill: "#fff",
          strokeWidth: 0.2,
          d: "M175.6 139.7c-.7 1.4-2.3 3.5-3.8 4.6-2.4 1.7-5 3-8.1 3.7-.5.1-1 .3-1.6.1-.6 0-1.3-.5-1.7-1.4-.2-.4-.1-2.6.7-2.9a6 6 0 0 1 2.4-.4c.5 0 1 .2 1 .8 0 .5-.5.8-1 .7-.6-.2-1.5-.6-2-.2-.4.2-.7 1.2-.4 1.7.4.7.7.9 1.1 1l1.3-.1c3-.8 5.5-2 7.8-3.6 1.5-1 3-3.4 3.6-4.4zm-12 4.3c-.9-.2-2.4 0-2.5.4.7-.4 1.5-.3 2.5 0 .3 0 .4-.3 0-.4m6-7.5.3-.7c.1-.1-.2-1.7 1.4-.9 1.7 1 .4 1.7.3 1.8l-.4.7"
        }),
        /* @__PURE__ */ jsx225("path", {
          strokeWidth: 0.4,
          d: "m166.7 135 9.5 5"
        }),
        /* @__PURE__ */ jsxs200("g", {
          strokeWidth: 0.3,
          children: [
            /* @__PURE__ */ jsx225("path", {
              fill: "#fff",
              d: "M154.7 135.4c-1.6.2-4.7-.2-6.4-.5-.8-.1-3.1 3.2-4.3 3.4-1.2.3-2.4-2.4-4.1-1.8-.9.7 0 4-.5 4.3-.5.5-2-1.6-3-1-1 .8.8 5.1.3 5.6-.4.5-2.6-1.9-3.3-1.4-.7.4.7 7.2 0 7.5-.6.4-3.7-1.8-4-.9-.5 1 4.3 3.1 5.6 3.2l1.3-.5c.4.2 4.2.5 4.6.5l2.1-2.2c3.3-4.3 7-8.3 11.7-8z"
            }),
            /* @__PURE__ */ jsx225("path", {
              d: "m140.2 136.5 6.3-.3m-10.1 3.6 3-1m-6 5 2.9-1.2m-7 8 4-3.6m3 6.2c1.7-3 5-6.2 7.9-7.9m-10.7 6.2c2.4-2.9 9.1-7.6 11.3-8m-5.4-2.7c2.8-1.2 6.8-1.4 10-1.7m-5.5-.8c.4 0 5.2-.6 7.3-.5m-14.5 7.7c3.7-2.2 7.4-4 11.5-5.3"
            })
          ]
        }),
        /* @__PURE__ */ jsx225("path", {
          fill: "#fff",
          strokeWidth: 0.4,
          d: "M168.2 191.2c.3.1.6.8.6.8s-.6.3-.8.2l-29.5-8.8c-.8-.2-.5-1.6.4-1.3zm-28-41c-.2-.7-.8-1.2-1.2-1.3-.2 0-.9.7-.8.9 0 .4.9 1 1.2 1zm2.7 1-2.5 2.5c-.3.3.3.8.6.5l2.5-2.4c.3-.3-.3-.9-.6-.6m-1.2 2.4 7.7 7.9 1.5.2-.2-1.6-8-7.6z"
        }),
        /* @__PURE__ */ jsx225("path", {
          strokeWidth: 0.1,
          d: "m149.8 160.6-7.6-7.6"
        }),
        /* @__PURE__ */ jsx225("path", {
          fill: "#fff",
          strokeWidth: 0.5,
          d: "M160 138.6c0-.5.2-.7.5-1 .5-.3.3-.1.6 0l.8.5c.2.2.3.1.4 0 .1-.2.1-.6.3-.8a.2.2 0 0 0 .2-.2c.2 0 .2-.1.2-.3 0-.1.1-.4.3-.4.2 0 .6.3.6 0l.3-1.6c.6.1.4-.6.6-.6.6.2.9-.8.5-1.2 0-.8.7-1 1.7-1-.1-.5-.9-.7-1.4-1.4-.5-.7-2-1.6-3.8-1.6-1.7 0-3.1 1.6-3.8 2.3-.6.7-2 1-2.3 1-.4-.1-.6-.4-1-.4H153c-.6 0-.8.4-1.5.3-.4 0-2 0-2.5.2-.4.2 0 1.2.5 1.3.2 0 1.5 0 2 .3s2 .4 2.6.1c1.3-.4 2.1.4 3.5.8l.5.1c0 .8 0 1.1-.4 1.1h-1.2l-1.3-.6c-.6-.1-1 .1-1.2.2-1.7.7-7.7 5.4-8.3 6.5-.7 1.2-1.7 1.9-2.6 3.7-.5 1-1.5 2.2-2.1 3.8-1 .5-2.1 1.4-2.3 1.7-.1.2.2.6.4.6 0 .1.3.5.6.5-.2.2.2.5.4.4 0 .2.2.7.5.7l2.4-2.5c0-1 .6-2.2 1-2.8 1.3-1.5 3-4.2 3.4-4.9.3-.4 3.2-1.5 4-2.2-.3 2-.2 3.4 0 4.6.5 2 1.1 3.3 1.5 5 .4 1.7 0 2.7 0 3.5.1.6.3.7 1 1 .5.4 2.9 0 3.6.3 1.4.4 2.6.5 3.1.6a5 5 0 0 1 3.5.6c.6.5 1.7 3 2.1 4 .4.9 2.6 2.1 3 2.7.5.5.9 2 .8 2.7 0 .6 0 .9.7.8.5 0 2.5.3 2.8.5.4.2 1.2.9 1.5.9.3 0 1.7.2 2.4.1s.6-1.1.3-1.2a30 30 0 0 1-2-.4 8.2 8.2 0 0 1-2.7-2.1c-.6-.7-.9-1.7-1.3-2.5a58 58 0 0 0-3.1-4.5c-.2-.3-1.4-3-1.6-3.8-.3-.7-.8-.7-1.3-.9-1.8-.5-2.5-.7-4.4-1-1.3-.3-1.6-.4-1.8-1.4 0-.8-.6-2.2-.3-3.2l.4-1.8c0-.5.4-1.3.4-1.7l.2-3zm1.4 8.2c-.2 0-1 .2-1.5 0-.1 0 0-.4 0-.4s-.2-.3 0-.4c0 0-.2-.4 0-.4-.2-.2-.2-.4 0-.5.1-.1 1-.2 1.4-.1.3.5.2 1.3.1 1.8"
        }),
        /* @__PURE__ */ jsx225("path", {
          strokeWidth: 0.5,
          d: "M158.1 135.1c.4.3.4 0 1.1-.2.8-.3 1.3.4 1 1-.2.6-.2 1.2.6 1.2s1-.7 1.2-1c.2-.3.5-.3.7-.7.2-.8 1-.6 1.5-.5m1-1.9c-.3.2-1.2-.5-1.4-1.1-.2-.8-.8-1.4-1.8-1.4s-3 .6-3.3 1.7a43 43 0 0 0-.3 1.7c-.3.1-.7 0-.7.2l-.1.8m-6.3 6.3 2-1"
        }),
        /* @__PURE__ */ jsx225("path", {
          strokeWidth: 0.3,
          d: "M153.4 140.3c.5 1.3 1 2.6 1.7 3m1.1.5c.9.5 1.5.3 2.5.2m-5.1 9.5c2.1 0 3 1 4.7 1.6 1.8.5 4.2.2 6.5 1.3m-11.9-9.7c.6.4 1.3.6 2 .6m.9 0c1.1.3 2.1.7 2.3 1.4m-2.8 1.1c1 1 3 1.8 4.2 1.8"
        }),
        /* @__PURE__ */ jsx225("path", {
          strokeWidth: 0.2,
          d: "M157 136c.9 3.2 1 4.4 3.2 5m-4.1-5.1c1 3.1 2 4.8 4.1 5m-5-5.4c1 3.1 2.4 5.3 5 5.4m11.6 24.8c-.5-.4-.6-.6-1-1.3l-.7-1.6-.5.3c-.3.1-.5-.3-.2-.4l.4-.2-.6-1.2c-.3 0 0-.2.2-.3.3-.1.6-.3.4 0l.6 1.2.4-.2c.3-.2.5.3.2.4l-.5.2.8 1.6c.4.7.5.9.5 1.5m-.1-3.4-2.4 1.3m-2.2-1.8 3.2-1.6m-3.7 1 3.3-1.6"
        }),
        /* @__PURE__ */ jsx225("path", {
          strokeWidth: 0.1,
          d: "m140.1 153 1.1-1m-1.5.5 1-1m-1.6.5 1.1-1m19.8-4.6h1m-1.1-.8h1m-1 .4h1m1.3-9.2.6.3"
        })
      ]
    })
  ]
});
var Mt_default = SvgMt;

// src/country-flag-icons/generated/Mu.tsx
init_esm_shims();
import { jsx as jsx226, jsxs as jsxs201 } from "react/jsx-runtime";
var SvgMu = (props) => /* @__PURE__ */ jsx226("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs201("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx226("path", {
        fill: "#00a04d",
        d: "M0 360h640v120H0z"
      }),
      /* @__PURE__ */ jsx226("path", {
        fill: "#151f6d",
        d: "M0 120h640v120H0z"
      }),
      /* @__PURE__ */ jsx226("path", {
        fill: "#ee2737",
        d: "M0 0h640v120H0z"
      }),
      /* @__PURE__ */ jsx226("path", {
        fill: "#ffcd00",
        d: "M0 240h640v120H0z"
      })
    ]
  })
});
var Mu_default = SvgMu;

// src/country-flag-icons/generated/Mv.tsx
init_esm_shims();
import { jsx as jsx227, jsxs as jsxs202 } from "react/jsx-runtime";
var SvgMv = (props) => /* @__PURE__ */ jsxs202("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx227("path", {
      fill: "#d21034",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx227("path", {
      fill: "#007e3a",
      d: "M120 120h400v240H120z"
    }),
    /* @__PURE__ */ jsx227("circle", {
      cx: 350,
      cy: 240,
      r: 80,
      fill: "#fff"
    }),
    /* @__PURE__ */ jsx227("circle", {
      cx: 380,
      cy: 240,
      r: 80,
      fill: "#007e3a"
    })
  ]
});
var Mv_default = SvgMv;

// src/country-flag-icons/generated/Mw.tsx
init_esm_shims();
import { jsx as jsx228, jsxs as jsxs203 } from "react/jsx-runtime";
var SvgMw = (props) => /* @__PURE__ */ jsx228("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs203("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    children: [
      /* @__PURE__ */ jsx228("path", {
        fill: "#f41408",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsx228("path", {
        fill: "#21873b",
        d: "M0 320h640v160H0z"
      }),
      /* @__PURE__ */ jsx228("path", {
        fill: "#000001",
        d: "M0 0h640v160H0z"
      }),
      /* @__PURE__ */ jsx228("path", {
        fill: "#f31509",
        d: "M220.5 141c22.3-49.2 84.5-72.8 138.8-52.5a98.4 98.4 0 0 1 58 52.5zm-26 6.4a332.3 332.3 0 0 1-52.4-7.8c-4.1-1.3-4.3-3.6-3.8-5.3.5-1.7 3.1-3.6 6.2-3 5.6 1.4 28.8 7 50 16.1m124.6-85.9c-4.2-21-5.2-44-4.8-48C314.7 9.6 317 9 319 9s4.7 1.8 4.7 4.7c0 5.3-.1 27-4.6 48zm11.6.5a249 249 0 0 1-.3-48.2c.8-3.9 3.2-4.4 5.1-4.2 2 .1 4.5 2.1 4.2 5-.5 5.3-2.6 26.9-9 47.4m10.4 1.3c-.2-21.3 3-44.3 4.1-48 1.1-3.9 3.6-4.2 5.5-3.9 2 .3 4.3 2.5 3.8 5.3-1 5.3-5.2 26.6-13.4 46.6m11 2.2c1.8-21.2 7.3-43.8 8.8-47.5 1.5-3.7 4-3.8 5.8-3.4 2 .5 4 2.8 3.3 5.6-1.6 5.1-7.7 26-17.8 45.3zm10.9 3.2c3.9-21 11.5-43.1 13.3-46.7 1.9-3.5 4.3-3.5 6.2-2.9 1.8.6 3.7 3.2 2.7 5.8A264 264 0 0 1 363 68.7m10.1 3.8c5.8-20.7 15.5-42 17.7-45.5 2.2-3.4 4.6-3.1 6.4-2.3 1.8.7 3.4 3.4 2.1 6-2.5 4.8-12.5 24.4-26.2 41.8m10 4.7a262.9 262.9 0 0 1 22-43.9c2.4-3.2 4.9-2.7 6.6-1.8a4.4 4.4 0 0 1 1.5 6.1c-3 4.6-14.9 23.4-30.1 39.6m9.4 5.5c9.7-19.4 23.3-39 26.1-42 2.8-3 5.2-2.3 6.8-1.3a4.4 4.4 0 0 1 1 6.2c-3.5 4.4-17.2 22.1-34 37zm8.8 6.2c11.6-18.6 27-37 30.1-39.7 3-2.8 5.4-2 6.9-.8a4.3 4.3 0 0 1 .3 6.2c-3.8 4.1-19.1 20.7-37.3 34.3m8.3 6.9a284 284 0 0 1 33.8-37.2c3.3-2.5 5.5-1.5 6.9-.3a4.3 4.3 0 0 1-.3 6.3c-4.1 3.8-21 19.1-40.4 31.2m7.6 7.5A278.4 278.4 0 0 1 454.4 69c3.6-2.3 5.7-1.1 7 .3 1.2 1.3 1.5 4.4-1 6.2a306 306 0 0 1-43.2 27.8m6.5 7.8A297.1 297.1 0 0 1 464 79.6c3.7-2 5.7-.6 6.8.9 1.2 1.4 1.1 4.5-1.4 6.1-4.8 3-24.3 15.6-45.7 24.5m5.9 8.3a307 307 0 0 1 43-28.1c4-1.7 5.9-.2 6.9 1.3 1 1.6.6 4.6-2 6a320.8 320.8 0 0 1-48 20.8zm5.4 9.6a313.4 313.4 0 0 1 45.8-24.4c4.1-1.4 5.8.3 6.6 1.9.9 1.6.3 4.6-2.6 5.8-5.3 2.2-27 11.4-49.8 16.7m4.2 9.2a320 320 0 0 1 48-20.8c4.2-1 5.7.8 6.4 2.5.6 1.6-.3 4.6-3.2 5.5-5.5 1.9-28 9.3-51.2 12.8m3.4 9.8a324.5 324.5 0 0 1 49.8-16.9c4.2-.6 5.6 1.2 6.1 3 .5 1.7-.7 4.5-3.7 5.3-5.7 1.3-28.8 7-52.2 8.6M307.8 62a252.4 252.4 0 0 1-9.7-47.4c0-3.9 2.3-4.8 4.2-5 2-.1 5 1.5 5.2 4.3.5 5.3 2.6 26.9.4 48.1zm-11 1.3a251 251 0 0 1-14.3-46.4c-.4-4 1.8-5 3.7-5.3 2-.3 5 1 5.6 3.8a263 263 0 0 1 5 47.9m-11 2.2A259 259 0 0 1 267 20.3c-.8-3.9 1.3-5.1 3.2-5.6 1.9-.4 5 .6 5.9 3.4 1.5 5.1 7.7 26 9.6 47.3zm-10.5 3A264 264 0 0 1 252.5 25c-1.1-3.8.8-5.2 2.6-5.8 1.9-.6 5.1.2 6.2 2.8 2 5 10.2 25.4 14 46.4zM265.2 72a270.4 270.4 0 0 1-27-41.5c-1.4-3.7.4-5.3 2.2-6 1.8-.8 5-.2 6.4 2.4 2.5 4.8 12.5 24.5 18.4 45.1m-10.3 5a275.6 275.6 0 0 1-31-39.2c-1.7-3.5-.1-5.2 1.6-6.1 1.7-.9 5-.6 6.6 1.9 3 4.6 15 23.3 22.8 43.4m-9.4 5.4A285.2 285.2 0 0 1 211 45.7c-2.1-3.4-.7-5.2 1-6.3 1.5-1 5-1 6.7 1.4 3.4 4.3 17.1 22 26.8 41.5zm-8.7 6a292.2 292.2 0 0 1-37.9-33.9c-2.4-3.2-1.1-5 .4-6.2a5.5 5.5 0 0 1 6.8.8c3.8 4 19.2 20.7 30.7 39.3m-8.5 7a299 299 0 0 1-41-30.7c-2.8-3-1.7-5-.3-6.3a5.5 5.5 0 0 1 6.9.3c4.2 3.7 21 19 34.4 36.6zm-7.4 7A306.6 306.6 0 0 1 177.2 75c-3-2.8-2.1-4.8-.8-6.2 1.2-1.4 4.5-2.1 6.9-.3a292 292 0 0 1 37.6 34zm-7 8.2a313 313 0 0 1-46.2-23.8c-3.3-2.5-2.6-4.7-1.5-6.1 1.1-1.5 4.3-2.5 6.9-.9 4.8 3.1 24.3 15.5 40.8 30.8m-6.3 8.8c-22.2-7-44.9-17.6-48.4-19.9-3.6-2.2-3-4.4-2.1-6s4-2.8 6.8-1.4c5 2.7 25.8 13.5 43.7 27.3m-5.3 9c-22.8-5.3-46.3-14-50.1-16-3.7-2-3.5-4.2-2.6-5.8.8-1.6 3.7-3.1 6.6-2 5.3 2.3 27 11.4 46.1 23.8m-4.2 9a328.5 328.5 0 0 1-51.4-12.2c-4-1.6-3.8-3.9-3.2-5.5.7-1.7 3.5-3.4 6.4-2.5 5.6 1.9 28 9.3 48.2 20.2"
      }),
      /* @__PURE__ */ jsx228("path", {
        fill: "#f31509",
        d: "M194.5 147.4a332.4 332.4 0 0 1-52.4-7.8c-4.1-1.3-4.3-3.6-3.8-5.3.5-1.7 3.1-3.6 6.2-3 5.6 1.4 28.8 7 50 16.1"
      }),
      /* @__PURE__ */ jsx228("path", {
        d: "M129.4 141.5h381.2v12.6H129.4z"
      })
    ]
  })
});
var Mw_default = SvgMw;

// src/country-flag-icons/generated/Mx.tsx
init_esm_shims();
import { jsx as jsx229, jsxs as jsxs204 } from "react/jsx-runtime";
var SvgMx = (props) => /* @__PURE__ */ jsxs204("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsxs204("defs", {
      children: [
        /* @__PURE__ */ jsx229("radialGradient", {
          xlinkHref: "#mx_svg__a",
          id: "mx_svg__b",
          cx: 842.3,
          cy: 103.7,
          r: 25.9,
          gradientTransform: "matrix(.14152 .03595 -.03453 .14198 213.1 162.4)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx229("radialGradient", {
          xlinkHref: "#mx_svg__a",
          id: "mx_svg__c",
          cx: 651.5,
          cy: 550.5,
          r: 25.9,
          gradientTransform: "matrix(-.13441 -.05384 .04964 -.12489 397.9 -24.3)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx229("radialGradient", {
          xlinkHref: "#mx_svg__a",
          id: "mx_svg__d",
          cx: 380.8,
          cy: 740.4,
          r: 25.9,
          gradientTransform: "matrix(.07536 .00282 -.00343 .14804 412.4 -203.6)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsxs204("linearGradient", {
          id: "mx_svg__a",
          children: [
            /* @__PURE__ */ jsx229("stop", {
              offset: 0,
              stopColor: "#fff"
            }),
            /* @__PURE__ */ jsx229("stop", {
              offset: 1,
              stopColor: "#f15770"
            })
          ]
        })
      ]
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#ce1126",
      d: "M426.7 0H640v480H426.7z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fff",
      d: "M213.3 0h213.4v480H213.3z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#006847",
      d: "M0 0h213.3v480H0z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.3,
      d: "m355.8 289.4.2 4.5 1.7-1.1-1.3-3.7z"
    }),
    /* @__PURE__ */ jsx229("circle", {
      cx: 355.6,
      cy: 288.2,
      r: 1.4,
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.3,
      d: "m361.1 296.4-3.2-3.1-1.5 1.2 4.5 2.6z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2,
      d: "M360.9 298.2c-.5-.6-.3-1.5.3-2 .7-.5 1.6-.4 2 .2.5.6.3 1.5-.3 2-.7.5-1.6.4-2-.2z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.3,
      d: "m386.3 249.6 3.4 3.3.4-1.7-3.1-2z"
    }),
    /* @__PURE__ */ jsx229("circle", {
      cx: 385.9,
      cy: 248.7,
      r: 1.4,
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.3,
      d: "M395.2 251.6 390 253l.5-1.7 4.4-.4z"
    }),
    /* @__PURE__ */ jsx229("circle", {
      cx: 396,
      cy: 250.8,
      r: 1.4,
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.3,
      d: "m378 276.8-3.2-4.8.5-.3 3.5 4.2z"
    }),
    /* @__PURE__ */ jsx229("circle", {
      cx: 374.5,
      cy: 270.8,
      r: 1.4,
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.3,
      d: "m378.1 277 4 .7.1-.5-3.3-1.4z"
    }),
    /* @__PURE__ */ jsx229("circle", {
      cx: 383.3,
      cy: 277.7,
      r: 1.4,
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2,
      d: "M284.6 288c0 .8-.5 1.2-1 1.2s-1-.5-1-1.2.5-1.3 1-1.3 1 .7 1 1.4z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.3,
      d: "m284.6 290.3 1 5-1.3-.5-.4-4.3z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2,
      d: "M285.7 288.6c.6.7-.4 1.9-1.4 2.2-1 .3-2.4-.2-2.4-1.2s1.6-.5 2-.6c.6-.2 1.2-1.2 1.8-.4z"
    }),
    /* @__PURE__ */ jsx229("ellipse", {
      cx: 277,
      cy: 296.3,
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2,
      rx: 1.6,
      ry: 1.1
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.3,
      d: "m279.6 296 4.8-.2-.8-1-4 .4z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2,
      d: "M280 295.4c.5 1.3.5 3-.9 2.7-1.4-.1-1-1.4-1.2-1.8-.2-.9-1-1.7-.2-2.5s2 .4 2.3 1.6z"
    }),
    /* @__PURE__ */ jsx229("ellipse", {
      cx: 264.4,
      cy: 269.2,
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2,
      rx: 0.9,
      ry: 1.4
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.3,
      d: "m264.4 272.4.1 4.6-1.2-1v-3.8z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2,
      d: "M266.2 271c.3 1-1.3 1.6-2.4 1.4-1-.2-1.9-.7-1.7-1.7.1-1 1.5-.8 2-.5.4.3 1.8-.8 2.1.7z"
    }),
    /* @__PURE__ */ jsx229("ellipse", {
      cx: 256.2,
      cy: 276.5,
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2,
      rx: 1.6,
      ry: 0.7
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.3,
      d: "m259.1 276.5 3.6-.3 1.6 1.2-5.3-.2z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2,
      d: "M257.8 274.5c1 0 1.6 1.1 1.5 2.3-.2 1.1-1 2-2 2-.9-.2-.8-1-.8-1.2 0-.3.5-.7.6-1 0-.4-.3-1.3-.1-1.6 0-.4.3-.5.8-.5zm-3-28.3c-.4.6-1.2 1.1-1.6.9-.4-.3-.2-1.2.2-1.8.4-.7 1-1 1.4-.8.4.3.4 1 0 1.7z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.3,
      d: "m250.7 253.5 2-4.8-.2-.3-2.4 3.4z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2,
      d: "M252.4 248.7c-1-.7-1.2-1.5-1-2.3.4-.7 1.2-.2 1.2-.2l.8.7c.4.2 1 0 1.4.6.5.6.2 1.2-.1 1.4-.4.1-1.5.4-2.3-.2zm-8.5-.6c.7.4 1.1 1 .9 1.5-.3.5-1 .5-1.8 0-.7-.3-1-1-.8-1.5.2-.4 1-.5 1.7 0z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.3,
      d: "m246 250.2 3.8 2.2-.1 1.8-4.1-3.5z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2,
      d: "M246 250.6c-.8 1-1.6 1-2.3.7-.7-.5-.1-1.2-.1-1.2l.8-.7c.2-.4 0-1 .7-1.4.7-.4 1.2 0 1.3.3.1.4.3 1.5-.4 2.3z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#aa8c30",
      d: "m356.6 289.8-.4.4-.3 1v-1.5l.5-.3zm.2-.9s-.3.5-1.1.5-1.2-.4-1.3-.8c-.1-.4-.1-.7.2-1.2.2-.5-.4.4-.4.4v1l.6.6.5.2h.4l.7-.2.4-.3zm4.2 7.3s-.4.2-.7.1c-1.9-.6-3.5-1.8-3.5-1.8l3.8 2.4zm2.4 1.1s0 .7-.8 1c-.7.3-1.2.2-1.5-.1s-.4-.6-.4-1.2l-.1.6.4.8.8.4.5-.1.5-.2.4-.5.3-.5zm24.3-47.6-.1.4v.7l-.9-1 .4-.5zm-.5-1.2c0 .7-.9 1.6-1.6 1.3-.7-.3-1.2-1-.9-1.8l-.2.3.1 1.1.7.6h.9l.6-.3.4-.7zm10 1.8s-.1-.4 0 0-.6 1.7-1.4 1.6c-.7-.1-1-.8-1-1.4 0-.6-.1.2-.1.2v.8l.5.4.6.4.6-.2.7-.3.2-.6v-.9z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#aa8c30",
      d: "M393.8 251s0 .4-.4.7l-1.3.7 2.8-.8-.2-.7zm-17.1 22.5-.1.5v.8l-1.6-2.5.5-.3zm-.9-2.4c-.2.7-1.4 1-2 .8-.5-.4-1-1.6-.3-2l-.4.2-.1.7.2.7.6.7.5.1.8-.2.6-.4s.4-1.3.1-.6m5.6 5.7s0 .3-.5.3h-1.6l2.6.6.2-.6z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#aa8c30",
      d: "M384.6 277.5c.3.8-.5 1.7-1.5 1.4-1-.3-1.3-1.3-1-1.8l-.2.6.2.8.6.6h1.3l.6-.7.2-.7-.1-.2zm-99 11.1c.3.3-.1 1.5-1.2 2-1.2.4-1.7 0-2-.4-.3-.4-.3-.8-.3-.8l-.2.2.2.6.5.5 1 .2.8-.1.7-.5.4-.3.3-.5v-.6z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#aa8c30",
      d: "m284.6 291.1-.3.4-.3.8v-1.4l.5-.3zm-3.8 4s0 .3.2.5l1 .3h-1.8l-.2-.7h.8zm-.6 1.2v.2a1.4 1.4 0 0 1-.1.5c-.2.5-.3 1-1 .9a1.2 1.2 0 0 1-1-1.1c0-.4-.2-.6-.2-.6v.6l.4 1 .7.3h.5l.5-.2.2-.6.1-.5zm-4.7-.1s.2.8 1.2.8 1.2-.2 1.2-.2v.3l-.2.2H276l-.3-.3-.3-.5v-.3zm-9.4-25.4v.4c-.1.3-.7 1-1.8 1-1 0-1.5-.3-1.8-.7-.3-.3-.4-.8-.4-.8v.5l.4.7 1.1.5h1l1-.3.5-.5.1-.6zm-1.7 2.3s-.4 0-.6.2a4 4 0 0 0-.4.4v-1.3h1zm-4.7 3.4.5.3c.5.3 3.1.5 3.1.5h-4.1l.1-.8zm-.5 0-.2.6c-.2.5-.7 1.6-1.6 1.4-.9-.1-.7-.8-.7-.8v-.4l-.2.7.2.4.4.2.7.1.4-.2.6-.5.2-.5.2-.6zm-2.2.2s0 .2-.7.2-1.7-.3-1.7-.3l.4.4.5.2h1.3zm-2-29s0 .5-.3.8c-.4.3-1.3.5-1.8.2s-1.5-1.3-1.5-1.3l.4.8.7.6 1 .3 1-.2.4-.4.2-.3z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#aa8c30",
      d: "M252 249.1v.6l-.2 1.1.9-2-.4-.2zm-5.4 1.5.2.5c.2.5 2.3 2.6 2.3 2.6l-3.3-2.9.4-.5zm-1 .3s-.5.3-1 .3c-.3 0-1 0-1-.4-.1-.5.1-.7.1-.7l-.3.6.1.4.5.3h.7l.6-.3.2-.2zm-1.5-1.4h-.5c-.7 0-1.4-.8-1.4-.8l.5.8 1 .5z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#9ca168",
      d: "M399.9 240.2c-.3 3.8-4.1 5.8-6.1 7.2-2 1.4-3 3.2-3 3.2l-.6 2.2-.3 1.5-.1.5c.1.4.3 1 .3 2l-.1 4.3 2.7-1.9 1.9-.7.6-.1s-2.2 2.1-3 4.4c-.8 2.3-2.4 7.2-5.3 8.8-3 1.6-4.8 1-5.7 1.8-1 .8-1 1-1 1l-1.3 1.8-1 1.2-.9.7-.6.4a7.5 7.5 0 0 1-.2 1.7l-.7 2.4s.6-.4 1.3-.5h1.3s-.5.6-.7 1.3c-.2.6.1 4.6-3.6 7-3.8 2.3-13.4 2-13.4 2l-1.8.7-1.7 1.3-1.6 1.7v.4s-1.3 1.5-2.1 2l-2.8 1.9 2.2.1 3.5 1.5s-2.2 0-3.6.5c-1.5.6-8.2 4.4-11.4 4.3-3.3-.1-8-4.9-8-4.9l-2-1.4-3.5-.7-4.3-.2v-.6l.1-.7s1.5-.2 3.8.1c2 .2 2.7 1 4.4 1.1 1.7.2 3 0 3.5-.3.7-.3 5.9-4.7 5.9-4.7l5.8-2 2.3.3 1 .2.9.3-1 1a7.3 7.3 0 0 1-1.4 1.1l.7.6 3.7-.6 1.2.3.3.2c0-.3.2-.8.6-1.3.4-.6 2.5-2.3 3.4-2.9l1.4-1c.3-.3 1.5-3.3 1.5-3.3l.1-1.6 4.1-4 2.8-2.9 1.2-3.3-.2-.7s1 1 .9 3c-.2 2.2-.7 2.9-.7 2.9s2.8-2 4.3-2.6c1.2-.5 2-.5 2.4-.5.4-.2 1.5-.9 2.1-1.8.8-1.2 1-1.5 1-2l.2-2.8-.3-7 2.4-5.4 3.5-3.1.7-.4-.4 1.2v1.5s1.8-2.5 2.7-2.9l.5-.3a7 7 0 0 0 .8-2l.3-3v-3l-.5-2.3-1.7-4.3v-5.8l-1.2-1.6s1.1 0 2.5 2a13.5 13.5 0 0 1 1.9 5l3.3-10.3s.9 1.2 1.5 3.3l.8 3.3 1.4-2.8.1 1c.2 1 2.3 2.1 2 6m-67.3 65s-.7-1.6-3.9-3.2c-3.1-1.5-5.5-1.8-5.5-1.8v1.1l5 2.2 2.4 2z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#717732",
      d: "M355.4 295.6c.3-.4 3-2.8 4.4-3.5s3.2-.8 3.2-.8c1.9-.4 2.2-.1 6.6-2.5 4.3-2.4 5.3-5.2 6.2-5.9.8-.7 2.3-.8 2.3-.8l-3.4 3.9a28.5 28.5 0 0 1-5.8 4.5 17.8 17.8 0 0 1-7.6 1.8 7.7 7.7 0 0 0-4 2c-1.3 1-2 2.2-2 2.2s-.2-.5 0-.9zm12-12.7c-4 3.7-5.3 7.2-5.3 7.2l5.4-4.9c1.9-1.8 4.5-2.6 5.6-3.7 1.2-1.1 1.3-2 2-2.7l1.3-1s-1.8-1.4-9 5.1m-8.5 8.6s1.7-.8 2.4-2.3c.5-1.2.2-1.5 1-2.8 0 0 4.2-4 5.7-5.8 2.6-3.1 1.4-5.7 1.4-5.7s.3 1.3-.8 2.7c-1 1.4-6.5 5-7.2 7.2-.6 2.2-.3 2.3-.6 3.4-.6 2.6-1.9 3.3-1.9 3.3m-2.8 10.5s-2.1-1.4-4.5-1.3c-4.9.4-9 3.4-12.2 3.4-3.1.1-4.4-1.5-6.9-3.2-2.6-1.8-9.2-1.5-9.2-1.5v.3s4.4 0 6.4.6c3.6 1 5.6 4.8 9.7 4.6 5.5-.3 9.9-3.6 12-3.6 3.8 0 4.7.7 4.7.7m-24-2.4s3.7.6 6.6-1.5c3-2.1 6.4-5 8.3-5.2 2 0 4 .4 4 .4s-2.5-1-4.4-1c-2 0-4 .2-5.8 1.3-1.8 1.1-2.7 3-4.6 4.3a12.8 12.8 0 0 1-4.1 1.7m-.7 5c-.5 0-1.1.3-1.3.3-.2 0-1.3-1.2-3-2-1.6-1-4-1.4-4-1.4s-.3 0 .3.2l3.8 1.5a8.6 8.6 0 0 1 2.6 2.1c.1.3.6.9 1.5.8 1 0 1.3-.5 1.2-1 0-.3-.6-.5-1.1-.5m2.6-3.6s1.5.8 4 .8c5.2-.2 8.6-3.8 12-5 3.4-1.4 5.2-.3 5.2-.3s.1-.2 0-.2a7 7 0 0 0-3.9-1.2c-5.7 0-11.2 3.7-13.5 4.7-2.3 1-3.8 1.2-3.8 1.2m56-39.9c-1.8 1.9-4.5 7.7-5.6 9.3-1.2 1.6-2.7 2-3.3 2.7-.6.6-2.7 3.5-3.2 4.1-.5.7-.6.5-1 .8-.3.3-.5.3.1.2.6-.1.8-.5 1.6-1.5 1-1 .9-1.4 2.3-2.7 1.4-1.2 3.9-2.6 5.1-4.2 1.3-1.5 3.8-7.5 5.2-9 1.4-1.5 4-2.4 4-2.4s-2-.6-5.3 2.7zm-9 11.1s-.1-1 1.2-2.6 1.7-1.3 2.8-3.6c1-2.3 1.5-4.5 2.3-6.9.9-2.4 2.3-4.8 2.3-4.8s-1.3.2-2.7 2a34.5 34.5 0 0 0-4.8 8.7c-1.1 3.4-1.1 7.2-1.1 7.2m-1.7 2.2s.5-.2.5-3.2c.1-2.9-.1-7 .7-9 .9-2 5.4-7 5.4-7s-1.9.5-4.5 2.5-3.7 4.7-3.6 6.7c.2 2 1.3 4.2 1.4 6.1l.1 4zm10.5-20.1s1.1-4 1.6-5 .5-1.5 2.7-4c1.3-1.5 2.6-2.4 3.1-4.4.6-2 .6-7.7.6-7.7s-.6.5-1.1 1.5c-.5 1-.1 4.7-1 6.4-.8 1.7-2.7 5.6-3.7 6.5 0 0-.2-2.9.2-5.7.3-3 1.3-3.8 1.7-5.7.4-1.9.2-6.7.2-6.7s-1.5 1.5-2.3 3.4c-.8 1.8-1.2 5-1.2 7.5s.5 4.5.6 5.9c.1 1.4.2 2-.4 3.6l-.6 2a34.8 34.8 0 0 1-.7 2.6zm-3.5-21.6s1.4 1.7 1.2 3.6c-.3 2-1 4.5-.2 6.5.7 2 1.9 2.2 2.2 3.4.3 1.2.3 3.4.3 3.4s.6-4.3.2-5.5c-.5-1.1-.7-.6-1.3-1.8s0-4.7-.4-6.7c-.5-2-2-2.9-2-2.9"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#9ca168",
      d: "M306.7 304.8s.4-1 3.1-2.4a34 34 0 0 1 7.3-3c.3.3-.3 1.8-.3 1.8l-2.6.8-2.1 1.2-2.5 1.6z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#9ca168",
      d: "M313.6 297.7c-3.4.1-5.3 1-6 1-.2.1-.7.5-1.2.3a4.9 4.9 0 0 1-1.5-1.5l-.7-.7-.2 2.5-5-4.4-.6 3-.7 1.3-5-4.8.2 3.7-1.4.1-3.6-2.5-1 .4 1.2 2.2-4.6.3-1 .8a6.3 6.3 0 0 0-1 1v.4h1.9c.4-.2.6-.7.7-.5.2.2.3 1.2.9 1.1.6 0 2.7-1.7 4.2-1 1.7.8-2.2 2-1.8 3.1.4 1.2 3.2.7 4 .3.6-.3 2.7-3 3.6-2 1.2 1.4-2.5 2.5-1.8 3.9.6 1.3 2.7 1 3.7.4 1-.5 3.4-4.1 3.9-3.4.9 1.4-2 2.7-1.3 3.7.8 1 2.3 0 3.4-.8s1.5-2.5 3-3.3c1.4-.8 1.3-.5 1.7-.5.4 0 1.5-1.1 1.5-1.1l3.5-1.5 1.6.2.9.4 1.7.2.2-1.4s-2-1-3.3-1zm-27.4 0 .7-1.3-.4-.6s-1.2-.7-2.3-1.8a6.9 6.9 0 0 0-2-1.6L280 291l-.8-2.8-.5-.9-1.3.6-1.7-6.1-.3-1.1h-.7l-1.5 3.6-1.5-2.3-.4-5-1 1-1.3 1.4-2.3-4.6s-.1-.1-.3.3c0 .3-.3 1.8-.1 2.6a26.2 26.2 0 0 1-6-5.2l-1-2.5 1-2 .5-2.6-2.2.9-.4-5.7-.3-1.8-2.7 3.8-1-1.7v-3.6l-.7-.2-1 2s-1.1-2-1.6-2.5c.1-.8.2-2.9-.3-4.5-.6-2-1.3-3.1-1-4.8.2-1.6.9-1.8.8-2.5 0-.8-1.2.5-.8-.5.4-1 3.8-3.2 3.1-4.4-.7-1.1-4 1.9-3.3-.1.8-2 4-2 4.2-4.9.1-1.7-3 1.1-3.3.2-.3-.8 2-2.6 1.9-3.8 0-1 .4-1.2-.2-1.8-.6-.6-2.6 2.3-2.6 2.3l-2-.7-.8 3-.6 2.5-2.6-1.5.7 3.1.6 3-2.7-.7 1.4 2.6 1.9 2 1.1 1.5.9.4 1 1.1.5 1.7.6 1.9.1 1.8v2.4l-.1.4v1.1c-.5 0-1.4-.8-1.7-.3-.3.6 1.6 2 1.2 2.4-.3.4-3-.5-3.2.3-.2 1 .2 2.2 1.8 2.6s5.3 1.2 4.7 2c-.6.7-4.7-2.3-4.5-.1a3.8 3.8 0 0 0 2.6 3.4c1 .4 5.1 0 4.9 1-.3.9-3.3-.4-3.6 1-.3 1.4 2.1 1.6 2.6 1.6s2.2-.1 2.9.4l4.3 4.1a75.7 75.7 0 0 0 4.6 3.4c-.8 0-2.4-.3-2.6.3-.3.7 6 3 4.2 3.8-1.8.7-3.8-2-4.3-.4-.6 1.7 1.2 3 2.2 3.6 1 .6 6.7.1 5.6 1.4-1.1 1.3-5.3-.8-5.3.7s2.7 4 4.2 3.9c1.4 0 3-2.4 3.6-1.1.7 1.2-1 1.7.3 2 1.4.4 2.3-1.4 4-1 1.5.3 4 1.3 5.4 2.5a79 79 0 0 1 2.9 2.8"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#717732",
      d: "M308.4 304.1c1 0 1 .6 1.2.6.1 0 1.8-1.5 3.3-2.3a17.5 17.5 0 0 1 4-1.4l.1.2s-2.8.7-4.2 1.7l-3 2.1c-.2.2-.8.7-1.7.7-1 0-1.4-.6-1.4-.9 0-.2.7-.7 1.7-.7m8.5-4.3s-.9.1-1.3-.3a4.3 4.3 0 0 0-2.6-.8 7 7 0 0 0-4 1.8c0 .1-.3.6-1.4 1.3.4.1 1.1-.4 2-1a7.4 7.4 0 0 1 3.6-1.4c1-.2 1.7.4 2.2.7.5.4 1.4.3 1.4.3zm-50.5-20.6v-.7a16.1 16.1 0 0 1-2.2-1.1c-1.6-1-5-3.8-5-3.8l2.8 2.7c1.4 1.3 4 2.9 4 2.9zm35.6 25.2 1.5-2.1c.9-1.5 1.7-2 1.9-2.2.1-.2-.4-.9-.7-1.4l-.2-1.2s.4.8 1 1.3a9.5 9.5 0 0 1 1.1 1s1.4-.2 1.4-.5c0-.2 0-.4-.2-.5-.3-.1-.5.2-1.1 0-1.3-.6-1.8-2.6-2.6-2.6-.8-.1-.2 2-.6 2-1.1.2-2-4.3-5-4.5-2 0-2.3.3-2.4.7 0 .5 2.5 3.1 1.6 3.5-.8.4-3.5-4.2-5.5-4.2-1.9 0-2 .7-2 1.1.2.4 2.2.8 1.8 2.2-.5 1.4-2.5-2-4.3-1.9-1.8.2-2 .3-2 .9-.1.5.6 1.2.3 1.4-.2.2-1.4.1-2.3.7-.9.7-2.1 2.4-2.1 2.4s1.2-1.7 2.7-1.9a50 50 0 0 1 5.6 0l-1.1-.8c-.6-.5-1.1-1.6-1.1-1.6l1.7 1.5c.8.7 1.9 1.2 1.9 1.2s1.7.2 1.8.4c.1.2 0 .6-.8 1.3l-1.7 1.7 2-1.6 1.5-1.2 1.4.2c.1 0 0-.5-.8-1.7l-1.6-2.5s1 .9 2 2.3c1.1 1.3 1 2 1.4 2 .4 0 1 .2 1.4.1.4 0 .3.6-.4 1.7s-1.2 2.5-1.2 2.5.8-1.2 1.6-2c.7-.8 1.1-1.7 1.5-1.8h1.5l-.8-1.6c-.6-1-.8-2.6-.8-2.6s.6 1.4 1.4 2.5l1.3 1.9 1.4-.1.3.1c0 .5-.2.7-.7 1.8a17.7 17.7 0 0 0-1 2.1M280.5 292c1.2.5 1.7.5 1.7.5s-1.7-1-2.1-2.4c-.5-1.4 0-4.4-.8-4.3-.7 0-1.1 2.1-1.8 1.7-.8-.4.2-4.4-.6-6-.8-1.7-2.6-2.9-3-2.3-.4.6-.3 4.2-1.5 3.5-1.1-.8.1-4-.2-5.3-.4-1.5-1.2-2.5-1.9-2.1-.6.3.3 3-.7 3s-.9-1.9-1.3-2c-.5-.2-.6.3-.9 0-.2-.4 0-1.7-.6-1.6-.6.1-.5 1.2-.3 1.7.1.6.5 1.4.7 1.8.2.4 1 .9 1 1.2-.1.3-.5.6-1 .6h-1.9s1.4.4 1.9.4 1.4-.2 1.7.2c.2.5 1.4 2 1.4 2s.3-.8.4-2.2c.2-1.5 0-2.7 0-2.7s.5 1.6.4 2.7c0 1-.4 3-.4 3s1.1.8.8 1c-.3.3-1.5.3-2.8.3-1.4 0-3.3-.5-3.3-.5a13.7 13.7 0 0 0 6.7 1.3l1.8 2s.9-1.5 1-3v-3l.4 2.8c0 1.3-.4 3.6-.6 3.8a5 5 0 0 1-1.9 1l-3.5.5s2.2.3 3.8 0c1.5-.4 1.7-.9 2.2-.6l.8.7 1.3 1c.1.1-.7.4-1 .7l-1.5.7 2.2-.7a22.3 22.3 0 0 0 1.1-.4l.5.2-.1-1.2-.3-1.8s.5.8.7 1.6l.1 1.6s.2.2 1.4.6m-31.1-35.6s.3-1.7.3-3.6a14.3 14.3 0 0 0-1.9-5.8l1-1.4-1.2 1-1.2-.5a3 3 0 0 1-.9-1l1.2.8c.6.2.7.1.7.1l-.5-2-1.9-1c-1.3-.6-2.5-1.8-2.5-1.8l2.8 1.5c1 .4 1.6.4 1.6.4l1.6-.6 1.7-1.1s-1 .6-1.8.7l-1.6.3-.3-2.4-1.1-1.1c-.9-1.2-1.6-2.9-1.6-2.9s1 1.2 1.7 1.7c.7.6 1.4 1.5 1.4 1.5l1.6-1 2.8-2-2.7 1.3-1.6.7s-.2-1 0-1.5c.3-.4.8-1.2.7-1.6 0-.5-.4-.3-.5-.7-.2-.3.4-2.6.4-2.6l.1 1.2c0 .5-.2 1 .4 1 .6 0 3.2-2.7 3.6-3.2.3-.5.8-1.8-.6-1.3-1.4.6-1 1.8-2.2 1.7-.4 0-.8-1.5-1.2-1.2-.4.4-1.4 1.3-1.6 2.4-.2 1 .2 2.6-.4 3.1-.6.5-1-1.8-2.2-1.5-1.2.3-1.5 2-1.3 2.6.2.6 2.7 3.5 2 4-.9.3-2.9-2.6-4-.6-1 1.9 3.4 4 4 4.4.5.5 0 .6.8 1.6s1.8 1.2 2.4 1.8a13 13 0 0 1 2.1 5.9zm11.7 17.1s-1-1.2-.7-3.3c.3-2 1.8-5.7 1.3-6.2s-2 2.2-2.4 1.6c-.4-.6.9-4.3.2-5.8-.6-1.5-.7-2.5-2-2.3-1.3.1-1.8 4.4-2.5 3.6-.6-.7.4-2.6 0-3.7-.5-1-.7-1.3-1.3-1.2-.7.2-1 2.2-1.4 2.1-.5 0-1.2-2.3-2.2-2-.9.3 2.3 4.5 2.3 4.5s.5-.5.8-1.2l.6-1.5s.3 1.3 0 1.9c-.2.5-.3 1.7-.3 1.7s-.8.3-2.1 0a8.8 8.8 0 0 1-2.3-.7s.8.6 2.1 1l2.7.7a44.9 44.9 0 0 0 2 2.7l.8-2.1 1.3-3.5-.6 3.9-.7 3s-1 0-2.6-.3l-3.6-.8 3.6 1.2 2.8.7 1.4 1.9 1-1.5 1-1.8s-.3 1.4-.7 2.3a27.4 27.4 0 0 1-.7 1.4l-1.8.2h-2.5a19.6 19.6 0 0 0 4.5.9s0 .5.7 1.3a4.6 4.6 0 0 0 1.3 1.3"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fff",
      d: "M314.4 310.8s-.6-.6-1.4-1c-.9-.5-1.2-.4-1.2-.4l-.4-.1.8-2 5.5-5.3.9-5.3h3.4v7.2l1 .5 6.2 3.7v1.6l-1 .4-.7.4-2.3.2-4-3-1.8-1.7-3 4z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#016848",
      d: "m318.8 296.7-.1 1c0 .9 0 5.2-.2 5.8-.2.6-3.2 1.8-4.9 3.3-1.7 1.5-1.8 2.6-1.8 2.6s-.5 0-1.6.4c-1 .4-1.5 1-1.5 1s.6-2.6 3.4-5c2.7-2.6 4-2.8 4.4-3.2.3-.4 0-5 0-5.5.1-.4.5-.4.7-.4zm7 15.7.8-1.1 1-.8-1.5-.8c-1.5-.6-2.3-.4-3.3-1.2a13.6 13.6 0 0 1-2.2-2l-1.5 1.2 1.7 2c.9.8 2.7 1.1 3.5 1.6a8.8 8.8 0 0 1 1.6 1.1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#cd202a",
      d: "M321.5 296.6s1.7 0 1.9.2l.2.6c0 .1 0 4-.2 5.3a8 8 0 0 1-1.4 3l-4 3.7c-1.2 1.2-2.4 2.8-2.4 2.8l-.8-1c-.3-.4-.7-.6-.6-.9a10 10 0 0 1 3.3-3.4c2-1.3 3.6-2.8 4-4.9.3-2 0-5.4 0-5.4"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#cd202a",
      d: "M332.5 310s-.4-.4-1.8-.4l-1.5.1s-.8-1-2-1.7c-1.2-.8-2.1-.7-3.5-1.6-1.3-.8-2-2.1-2-2.1l1-2s1.2 1.5 2.4 2.4c1.1.9 3.7 1.7 4.6 2.4z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#30c2dc",
      stroke: "#0872a7",
      strokeWidth: 0.5,
      d: "M345 286.4s-3.6-1.4-3.4-2.7c.3-1.2 8.3-3.3 8.3-3.3l.1-2.1s-1.2-.1-3.2.5c-2 .7-5.2 1.6-8.6 1.6a1735.4 1735.4 0 0 0-34.4-2.2c-3.7-.3-6-6-6-6l-1.8.4s.5 2.7-.4 3a65 65 0 0 1-13.9-6l-.6 2.6s7.3 4 7.1 5.5c-.2 1.4-2.4 1.3-2.4 1.3l1 1.8c.3 0 12 .6 12.3 4.1 0 1.5-3 2.3-3 2.3l1 1.2v.6s6.7 0 8.5 1c1.8 1 2.7 2.6 5 3.8 2.2 1.3 17.3 1 19.6.3 2.7-.7 4.3-3.7 8.7-5 4.3-1.4 5.7-1.4 5.7-1.4z"
    }),
    /* @__PURE__ */ jsx229("circle", {
      cx: 284.5,
      cy: 280.7,
      r: 2.1,
      fill: "#fff",
      stroke: "#0872a7"
    }),
    /* @__PURE__ */ jsx229("circle", {
      cx: 296.4,
      cy: 270.9,
      r: 2.1,
      fill: "#fff",
      stroke: "#0872a7"
    }),
    /* @__PURE__ */ jsx229("circle", {
      cx: 346.5,
      cy: 286.6,
      r: 2.1,
      fill: "#fff",
      stroke: "#0872a7"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f8c83c",
      d: "M275.1 267.8c-.7 1.6 2 4.6 4 5 1.8.2 2.8-.2 3.2-1.1a2.8 2.8 0 0 0-.4-2.5c-1.2-1.7-6-3-6.8-1.4"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fff",
      d: "M281 270.2c0-1-1.6-1.9-2.6-1.9s-2 0-1.8.5c.1.6 2.7 1.3 2.8 1.6 0 .3-.8.6-.4 1 .5.4 1 .1 1.4-.2.4-.3.7-.4.7-1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f8c83c",
      d: "M297.7 288.3c.4 1.4-.7 2-2 2.7-1.5.6-4.3.2-5-.9-.6-1.1 1-3 2.8-3.4 1.7-.4 3.8.3 4.2 1.6"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fff",
      d: "M294.8 289c.5 0 .6 1 1 .8.5 0 1-.8.8-1.3-.1-.6-1-1.3-1.8-1.2-.8 0-3 2-2.8 2.5.2.5.8.5 1.2.3.4-.2 1-1 1.6-1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f8c83c",
      d: "M349.2 281c1.3 1.7 3.6.2 4.2-.5.6-.6 2.4-1.7 1.7-2.8-.8-1.1-2-1-3-1-.8 0-2.6 1.4-2.9 2-.3.5-.6 1.6 0 2.4z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fff",
      d: "M349.6 280s.1-1.9 1.8-2c1 0 1 .3 1.8.7.7.4 1-.5 1-.5s0 1.3-1.1 1.3c-1.2 0-.8-.5-2-.7-1-.2-1.5 1.1-1.5 1.1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f9aa51",
      stroke: "#953220",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.5,
      d: "m321.9 276.4-.9-.6h-2.8l-3.4.1 3.4 9.9 4 5.8 1.6.6 3.1-.2.6-1.6-1.2-9.5z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f9aa51",
      stroke: "#953220",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.5,
      d: "m310.6 277 .2-1.1 1.8-.1a7.2 7.2 0 0 1 2.2.1s2.3 2.9 3.1 4.7c.8 1.8 1.7 4.8 2.7 6.6 1 1.9 3.2 5 3.2 5h-4l-2-.6-5.6-9z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f9aa51",
      stroke: "#953220",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.5,
      d: "M308.2 275.8h2.6a14 14 0 0 1 3.9 5.4c1 2.8.5 3.2 1.8 6.2 1.4 2.9 3.2 4.9 3.2 4.9s-3.9.2-6-.2c-2.3-.4-3-.3-3.6-1a9.2 9.2 0 0 0-1.7-1.3h-2.2l.5-3.1-.6-6.9.1-3.5zm23.4 1.8-3.7-1.5-7-.4.6 3.6a30.2 30.2 0 0 0 2.6 7.7c1.1 2 2.2 4.4 2.8 5 .6.5 4.6-1.1 4.6-1.1l2.6-.4-.3-2.8-.4-1 .6-8-.6-1.2z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f9aa51",
      stroke: "#953220",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.5,
      d: "M307.1 277.7c0 .8 1 .9 1.2.8.2 0 1-.3 1-1.5s-.7-2.1-2.2-2.2c-1.4 0-2.5 1.7-2.5 3 0 1.2 1.2 1.8 1.2 2.3 0 0-1.2 1.1-1.1 3.1 0 2 1.6 3.6 1.6 3.6s-1.7 1.3-1.7 2.7c0 1.4 1.3 2.3 2.6 2.3 1.2 0 2.8-.8 2.8-1.8s-1-1.7-1.7-1.7c-.8 0-1.1.5-1.1.8m25.6-10.9c0 .9-.6 1-1 1s-1.2-.4-1.2-1.5c0-1 1.4-1.6 2.4-1.6.9 0 2.4 1.2 2.4 2.7 0 1.5-1 2.6-1 2.6s.6.3.6 2.2c0 2-1.2 3.3-1.2 3.3s1.6.6 1.6 2.6-1.4 2.6-2.3 2.6c-1 0-2.6-.5-2.6-1.9 0-1.3.8-1.8 1.5-1.8.6 0 1.3.7 1.3 1.5"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#953220",
      d: "m309.5 288.6.4.6c.2.4.3 1 .8 1.4.8.7 7.2 1 9.2 1 2 0 7.8.2 8.9-.4 1-.7 1.2-1.8 1.9-2.3l.9-.4-.9.7v1.4l.5.8s-.1.4-.8.8c-.7.4-1.3.5-2.3.6-1 .1-13.2.1-15.2-.2-2-.4-1.8-.3-2.4-.7a4.3 4.3 0 0 1-1-1l.3-.8-.3-1.4zm20-11.8 1 .5s-.9.3-1.6 2.3c-.7 2-.1 2.5-.6 2.7-.5.2-5.8 0-5.8 0l-1-2.1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#231f20",
      d: "M346.4 276s-.9-.3-1.3-1c-.4-.8-.8-1.7-.5-2 .4-.1 1 .5 1 1.1 0 .6.8 2 .8 2zm10.4-2.8s.7 1.2 1 1.3l1.2.6s-1.5 0-2-.4a8.3 8.3 0 0 1-1-1.5z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#231f20",
      d: "M360 274.2s-1 .5-1.6.2c-.8-.3-1.4-.7-1-1 .2-.4.4-.3.8.2.4.4 1.8.6 1.8.6m5.3-4.5s-.8.6-1.3.6-1.5-.2-1.5-.4 1.3-.4 1.6-.3zm-8-10.5s-1.1.4-1.5 1c-.4.5-.3 1.2.2 1.2s.6-.7.6-1zm-5.2 2.9s-.9.5-1 1c-.3.5-.5 1.6 0 1.6s.7-.8.7-1.2c0-.5.3-1.4.3-1.4"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8cbebf",
      stroke: "#04534e",
      strokeWidth: 0.5,
      d: "m342.8 268.4-2.9 3s6.6 3.7 11.7 3.5c5-.1 10.8-4 11.2-5 .4-.7 0-4.3-.6-5.4-.7-1.1-4.2-3.8-5.5-3.7-1.3.1-3.7 1.9-5.8 4-2.2 2.1-2 3.9-5 3.7z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#0c8489",
      d: "M342 269.6s7 1 9.1-.8c2-1.8 4.3-5.3 5.7-6 1.4-.9 2-.9 2-.9l1.6 1.1 1.8 1.5.6 3.4v1.8l-2.2 1.8-4 1.9-4 1.2-3.2-.1-6.7-2-1.7-1.1-.4-.4z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#04534e",
      d: "M352.8 265.5c0-.6.4-.6 1-.6s1 .2 1 .8-.5 1.4-1 1.4c-.6 0-1-1-1-1.6m2.8 1.8c0-.6.4-.8 1-.8.7 0 1.3.7 1.3 1.2s-.5 1-1.1 1c-.7 0-1.2-.9-1.2-1.4m-1 4.2c0-.7.5-.8 1.1-.8.6 0 1 .3 1 1a1.2 1.2 0 0 1-1.1 1.2c-.7 0-1-.7-1-1.4m-3.7-1.3c0-.7.7-1 1.3-1 .6 0 1 .7 1 1.4s-.4 1.3-1 1.3-1.3-1-1.3-1.7m-5.9.7a1.4 1.4 0 1 1 3 0 1.4 1.4 0 0 1-3 0"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8cbebf",
      d: "M355.6 267.3c0-.5.7-.8 1-.8.5 0 .8.4.8.8s-.3 1-.7 1c-.4 0-1-.5-1-1zm-1 4c0-.5.6-.8 1.2-.8s1 .3 1 .8-.5 1-1 1c-.6 0-1.1-.4-1.1-1zm-3.7-1.2c0-.6 1-.9 1.5-.9.4 0 .3.4.3 1 0 .7-.3 1.2-.7 1.2s-1-.7-1-1.3zm1.8-4.7c0-.5.4-.5.8-.5s.6.1.6.7-.3 1-.6 1c-.4 0-.8-.6-.8-1.2m-7.7 5.1c0-.6.6-1.3 1.4-1.3s1.7.3 1.7 1c0 .6-1 1.8-1.8 1.8-.9 0-1.3-.8-1.3-1.5"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#231f20",
      d: "M347.7 269.4s-1 .1-1.5.6-.5 1-.3 1.2c.3.2.7-.3.8-.6 0-.2 1-1.2 1-1.2m4.7-1s-1 .6-1 1.3c-.1.6 0 1 .2 1 .3 0 .5-.9.4-1.2-.1-.3.4-1.2.4-1.2z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#231f20",
      d: "M353.2 269.3s-.6 0-1 .4c-.5.5-.9 1-.6 1 .3 0 .8-.2.8-.5 0-.2.8-.9.8-.9m1-5.4-.8.6c-.2.2-.5 1-.2 1 .3.2.5 0 .8-.5.2-.5.2-1.1.2-1.1m3.5 2.3s-.9 0-1.2.5c-.3.4-.5.8 0 .8.3 0 .4-.2.6-.5.1-.4.6-.8.6-.8m-.5 4.1s-.2.7-.8 1c-.5.3-.7.5-1 .1-.1-.4.2-.6.4-.7z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#04534e",
      d: "M362.8 267.5s.4 2-1.3 3c-1.7.9-6.4 4.2-10.9 3.8-4.5-.4-9.6-3-9.6-3l-.7.4 1.2.5 3.4 1.4 4 1.2 2.5.1 2.1-.2 4-1.3 3.3-1.7 1.8-1.4.4-.6v-1.9z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#231f20",
      d: "M274.9 242.2s1 .9 1 1.6c-.2.8-.4 1.1-.7 1-.3-.2-.3-1-.3-1.3zm7.7 7.1s-.3 1.4-.9 1.5c-.5.1-.9-.4-.8-.7.1-.2.6 0 .8-.2zm-16.8 1s.4.8 1 1c.8 0 1-.4 1-.6-.1-.2-.4-.2-.8-.2zm3 6s.7.6 1.5.7a1.3 1.3 0 0 0 1.3-.7c0-.2-1-.2-1.3 0-.3.3-1.5 0-1.5 0m5.3 4.4s1.4-.2 1.6-.6c.2-.4.6-1 .3-1.3-.3-.4-.5.5-.7.9-.1.3-1.2 1-1.2 1"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8cbebf",
      stroke: "#04534e",
      strokeWidth: 0.5,
      d: "M282.6 257.1s1-6-4-10.4c-5-4.3-8.1-3.2-9.8-1.6-1.7 1.6-3.2 6.7 2 11.3 5.3 4.5 11.7 3 11.7 3z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#0c8489",
      d: "M267.6 250.7s-.1-3.4 1.5-4.4c1.5-1 6.8-1.8 9.3 3.1 2.6 5 2.7 7.4 2 10h-2.7l-4.3-1.8-3.5-2.6z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#04534e",
      d: "M282 258s-.9 1-2.7 1c-1.7-.2-10-2.3-12-9.8v1.7l.1.5.6 1.5 1.7 2.5 2.2 1.9 2.8 1.4 2 .6 2.5.4h1.5z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#04534e",
      d: "M277.7 255.9c0-.7.3-.7.8-.7s1-.2 1 .4c0 .7-.4 1.6-1 1.6-.4 0-.8-.7-.8-1.3m.3-4c0-.4.4-.8 1-.8.5 0 .9.4.9.9 0 .4-.4.8-1 .8-.5 0-.9-.4-.9-.8zm-3.7 4.4c0-.4.4-.7 1-.7s1 .3 1 .7c0 .3-1 .8-1.5.8-.6 0-.5-.5-.5-.8m-.4-4.6c0-.6.3-.4.8-.4s1.2.1 1.2.7-.7 1.4-1.2 1.4-.8-1.2-.8-1.7m-3.4.7c0-.5.3-1.1.9-1.1s1.3.6 1.3 1.1c0 .5-.5 1-1.1 1-.6 0-1.1-.5-1.1-1m.6-4c0-.6.3-.5 1-.5.6 0 1.1.2 1.1.7 0 .5-.7 1.2-1.4 1.2-.6 0-.7-1-.7-1.5zm3.7-.5c0-.4.5-.3 1-.3.7 0 1.1.4 1.1 1s-.7 1-1.3 1c-.6 0-.8-1.2-.8-1.6z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8cbebf",
      d: "M271 248.3c.2-.4.4-.7.8-.7.5 0 .9.1.9.7 0 .4-.4.9-.8.9-.5 0-1-.5-.8-1zm-.6 4c0-.5.2-1 .7-1s1 0 1 .5-.5 1.1-1 1.1-.7-.1-.7-.6m4.4-4.3c0-.4.3-.4.8-.4s.8 0 .8.5c0 .4-.4.7-.8.7s-.8-.4-.8-.8m-.9 3.9c0 .5.5 1 1 1s1-.5 1-1c0-.6-.6-1-1-1s-1 .4-1 1m4.3-.6c0 .5.4.9 1 .9.5 0 .9-.4.9-.9s-.5-.9-1-.9-1 .4-1 1zm-4.1 5c0-.5.5-.9.9-.9s.9.3.9.7c0 .4-.8 1-1.2 1-.5 0-.6-.4-.6-.9zm3.6-.7c0-.5.4-.6 1-.6.5 0 .8.1.8.6 0 .6-.5 1-1 1s-.8-.5-.8-1"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#231f20",
      d: "M278.7 249.4s.5.7.6 1.3v1.2c-.3 0-.6-.4-.7-.9-.1-.5 0-1.6 0-1.6zm-3.2-3.3s.4.5.4 1 0 1-.3 1-.3-.4-.3-.8zm-3.7.5s.4.5.4 1 0 1-.3 1-.3-.4-.3-.8z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#231f20",
      d: "m270.5 247.3 1 .4c.3.4.5.8.3 1-.1.2-.5-.1-.6-.4zm2.8 3.8s.7 0 1.1.5c.4.3.8.6.5.9-.2.2-.7-.2-1-.5zm-3.4 0 1 .3c.3.2.4.7.2.8-.1.1-.4 0-.6-.4zm8.3 2.5.2 1.4c0 .5.1 1-.2 1s-.3-.7-.3-1c0-.5.3-1.4.3-1.4"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#231f20",
      d: "m277.3 254.9.8.5c.3.2.3.6.1.6l-.4-.5a9.2 9.2 0 0 1-.5-.6m-3.7.2.9.3c.2.2.3 1 .2 1.1 0 .1-.4 0-.6-.3z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#04534e",
      d: "M272.1 243.8s-3.2.7-3.8 2.9c-.6 2-.7 4.4-.7 4.4l-.4-2.7.6-1.7 1-1.6 1.4-1 1.3-.4zm10.2 12.5s.4-.8-.6-3.4c-1-2.5-3-6-3-6l1.6 1.8 1.2 2 .6 1.8.5 1.7v1.6l-.3.6z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#231f20",
      d: "M285.6 252.2s1.2.7 1.3 1.1c.1.4.2.6-.1.7-.3.1-.8-.4-1-.7a6.5 6.5 0 0 1-.2-1.1m-4.8 12.8s.6-1 1.3-1.3c.7-.4 1.2-.4 1.4-.1.2.2-.4.7-1 .9zm8.1 3.1s.8-.4 1.3-1c.5-.5.6-.9.4-1-.2-.3-.8 0-1.1.5-.3.4-.6 1.5-.6 1.5m-.9-.7s.3-1 .6-1.4c.3-.3.6-.5 1-.3.2.2 0 .6-.2.9a7.8 7.8 0 0 1-1.4.8"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8cbebf",
      stroke: "#04534e",
      strokeWidth: 0.5,
      d: "M301.5 261.2s-5-7.2-12.8-7.6a7.4 7.4 0 0 0-8 7c.2 1.6 2.6 5.2 10.9 5.8 8.3.6 9.6-3.9 10-4.1.3-.2-.1-1-.1-1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#0c8489",
      d: "M295.6 256.3s2 1.5 3 2.8c.8 1.2 1 2.2.5 2.3-.5.2-5-4-8.8-4.9-3.7-.9-6.9 0-7.6 1.7s-.4 4.5 1.2 5.6c1.8 1 9.7 2.3 9.7 2.3l3.7-.5 2.3-1.3.5-1.3.6-1.6.2-.7-1.9-2z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#04534e",
      d: "M289.2 257.3c0 .4-.5.7-1 .7s-.9-.3-.9-.7c0-.5.4-.9 1-.9s1 .4 1 .9zm-4.6 1.6c0-.5.6-.4 1-.4.6 0 1 .3 1 .8s-.8 1.1-1.3.9c-.6-.3-.7-.8-.7-1.3m5 2.7c0-.6.4-1 1-1 .7 0 1.2.4 1.2 1s-.8 1.2-1.5 1.2-.7-.6-.7-1.2"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8cbebf",
      d: "M285.8 262.7c0-.5.6-.6 1-.6.5 0 1 .5 1 1s-.5.9-1 .9c-.4 0-1-.8-1-1.3"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#04534e",
      d: "M292.5 264.5c0-.4.2-.8.7-.8.4 0 1 .3 1 .7 0 .4-.5.9-1 .9a.8.8 0 0 1-.7-.8m3-2.3c0-.5.3-.4.8-.4s1 .2 1 .8-.6.8-1.1.8c-.5 0-.7-.6-.7-1.2"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8cbebf",
      d: "M289 256.9c0 .4-.2.6-.7.6s-.9-.2-.9-.6c0-.5.2-.6.6-.6s1 .1 1 .6m-2.5 1.9c0 .5-.7.7-1 .7-.5 0-.8-.2-.8-.7 0-.5.3-.6.8-.6s1 .1 1 .6m1 3.8c0 .4 0 .7-.5.7s-1-.3-1-.7c0-.4 0-.7.5-.7s1.1.3 1.1.7zm4-1.3c0 .4-.7 1-1.2 1-.4 0-.6-.9-.6-1.3s.4-.7.8-.7 1 .6 1 1m5.8 1.3c0 .4-.7.4-1 .4-.5 0-.8-.5-.8-1 0-.4.1-.8 1-.7.5 0 .8.8.8 1.3m-3.4 1.7c0 .5-.3.8-.7.8a.8.8 0 0 1-.8-.8c0-.4.4-.6.8-.6s.7.2.7.6"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#231f20",
      d: "M294.4 262s.8-.3 1.5-.3c.6 0 .6.3.6.4 0 .1-.5.3-.7.2a86.2 86.2 0 0 1-1.4-.4zm-3.3 2.8s.6-.4 1.1-.5c.5-.1.9 0 .8.4 0 .3-.2.3-.6.3zm-2.2-5s1.4.6 1.7 1.1c.3.6.4.7.1.9-.3.2-.6-.2-.8-.5z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#231f20",
      d: "m288.5 261.6 1.6-.3c.5 0 .6 0 .7.2 0 .2-.1.3-.5.3zm-3.4 0s1.2.2 1.5.5c.3.3.3.6.1.7 0 .2-.6.1-.8 0z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#231f20",
      d: "M285 263.3s.4-.7.8-.8 1-.1 1 .1c.1.2-.4.5-.7.6zm-1-5.1 1.2.3c.4.3.5.6.4.7 0 .1-.5.2-.8 0-.5-.4-.7-1-.7-1zm2.6-3s1.2.4 1.6 1c.4.5.3.8.1.9l-.9-.4c-.3-.3-.8-1.4-.8-1.4z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#04534e",
      d: "M300 263.7s-2.3 2-7.7 1.9c-5.5-.2-10.4-2.5-11.6-5l.5 1.2 1.2 1.6 3.8 2 4.3.9 3.3.2 3.2-.6 2.5-1.1.4-.7zm.8-2.5s-.9-1.2-2.2-2.3c-1.2-1.2-6.2-4.4-6.2-4.4l4 1.8 2.7 2.2 1.8 2z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#231f20",
      d: "M301 256.4s1.4.5 1.6.8l.5.6s-.3 1-.6.6l-.8-.9zm4-2.2s1.3.5 1.8 1.1c.5.7.4 1.2.2 1.3-.2 0-1-.7-1.2-1a47.3 47.3 0 0 0-.7-1.4z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#231f20",
      d: "M306.4 254s1.2.8 1.4 1.2c.1.4.5 1 .1 1-.3.2-.9-.4-1-.8l-.6-1.5zm6.8 1.5s1 .4 1 1.2v1.3l-.7-.7v-.7l-.3-1zm1.8.7s.8.7.9 1.2c0 .5.2.8-.3 1-.4 0-.6-.5-.6-1zm-12.3 15s.6.2 1.2 0c.5-.2 1-.7.9-1-.1-.4-.4-.7-.8-.2-.4.4-.2.6-.5.8zm6.8 1.8s.9-.2 1.5-.9c.6-.6.9-1 .5-1.2-.4-.2-1 0-1 .5zm5.5.1 1.3-.9c.5-.4.7-.7.4-1-.3-.5-.6-.2-.8 0l-.2.7z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#231f20",
      d: "M316.7 273.1s.8-.9 1-1.4c.1-.5.2-1-.1-1-.4 0-.8.5-.8.9z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8cbebf",
      stroke: "#04534e",
      strokeWidth: 0.5,
      d: "M299.9 264.1c0-2.4 3.5-8 7.5-8 1.6 0 4.9 1 7.5 2.1 2.2 1 3 2 4.4 2.4 1.5.4 3.7.1 3.7.1l5-.5-4 5.7-1.4 1.2s-1.2 2.4-4.7 3.8c-3.6 1.4-9.5.4-12.2-.3-2.7-.7-6-3.2-5.8-6.5z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#04534e",
      d: "M299.9 264.1h.2c0-.5.2-1.3.6-2.1a12.2 12.2 0 0 1 2.7-3.8c1.1-1 2.5-1.8 3.9-1.8.8 0 2 .2 3.4.6a29.4 29.4 0 0 1 4.1 1.4c1 .5 1.8 1 2.4 1.5.7.4 1.3.8 2 1a9 9 0 0 0 2 .2l1.8-.1 4.4-.5-3.6 5.2-1.4 1.2v.1a9 9 0 0 1-4.6 3.7c-1.3.4-2.8.6-4.5.6-2.8 0-5.9-.5-7.6-1a8.4 8.4 0 0 1-3.8-2.1 5.7 5.7 0 0 1-1.8-4h-.5c0 1.7.8 3.2 2 4.4a9 9 0 0 0 4 2.3c1.7.4 4.8 1 7.7 1a14 14 0 0 0 4.7-.7 9.4 9.4 0 0 0 4.9-4h-.3l.2.1 1.4-1.3 4.3-6.2-5.6.7h-.1a14.8 14.8 0 0 1-3.4-.1 5.5 5.5 0 0 1-1.9-1c-.6-.4-1.4-1-2.5-1.4a29 29 0 0 0-4.2-1.5c-1.3-.4-2.6-.6-3.4-.6h-.1c-1 0-2 .3-3 1a11.2 11.2 0 0 0-3.3 3.5 8.3 8.3 0 0 0-1.4 3.7z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#0c8489",
      d: "M324 264.9c-.4.3-1 .3-1.4.3-.5 0-11.6-6.7-15-6.4-3.5.3-6.8 1.7-6.9 5.3 0 3.5.8 3.5 1.5 4.5s7.5 2.5 7.5 2.5h4.1l3.3-.4 3-1.6 1.5-1.3 1.1-1.3z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#04534e",
      d: "M306.5 263c0 .8-.3 1.3-1 1.3-.6 0-1.1-.3-1.1-1s.4-1 1-1c.7 0 1 .1 1 .8zm1.1-3c0-.6.6-.8 1.2-.8.7 0 1.2.2 1.2.8 0 .6-.5 1-1.2 1-.6 0-1.2-.4-1.2-1m6.7 1.8c0-.5.4-.9 1-.9.5 0 .9.4.9 1s-.4.8-1 .8a1 1 0 0 1-1-.9zm1.3 4c0-.6.5-1 1-1 .6 0 1.2.2 1.2.8s-.2 1.3-.8 1.3c-.6 0-1.4-.4-1.4-1zm-3.2 2.7c0-.6.5-1 1-1 .7 0 1.2.4 1.2 1 0 .5-.5.9-1 .9-.7 0-1.2-.4-1.2-1zm-6-1c0-.6.3-1 .9-1a1 1 0 1 1 0 1.9 1 1 0 0 1-1-1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8cbebf",
      d: "M306.4 263c0 .5-.4 1-1 1a1 1 0 0 1-1-1c0-.6.4-.8 1-.8s1 .2 1 .7zm3.3-3.2c0 .5-.2.9-.8.9-.5 0-1.3-.4-1.3-.9s.5-1 1-1c.6 0 1 .5 1 1zm6.4 1.7c0 .5-.4.9-1 .9s-.9-.4-.9-.9c0-.4.4-.8 1-.8s.9.4.9.8"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#04534e",
      d: "M312.7 264.2c0 .7-.3 1.2-1 1.2-.6 0-1.1-.3-1.1-1s.3-1 1-1 1 .2 1 .8z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8cbebf",
      d: "M308 267.2c0 .5-.4 1-1 1s-1-.5-1-1 .6-.8 1.2-.8.8.3.8.8m4.5-3a1 1 0 0 1-1 1 1 1 0 0 1-1-1 1 1 0 0 1 1-1 1 1 0 0 1 1 1m5.2 1.3c0 .6-.3 1-1 1-.6 0-1.1-.4-1.1-1s.2-.8.8-.8c.6 0 1.3.2 1.3.8m-3.3 2.7c0 .6-.4 1-1 1s-1.1-.4-1.1-1c0-.5.5-.8 1-.8.6 0 1 .3 1 .8z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#231f20",
      d: "M314.8 265s1.6-.2 1.9 0c.3.4.3.8.1 1-.1 0-.8.1-1-.1 0-.3-1-1-1-1zm-1.7-5.4s1.3.3 1.8.9c.5.5.4 1 .4 1.1-.2.1-.6.2-1-.2zm-3.7 2.6s1.5.8 1.8 1.3c.3.4.4.8.2 1-.1.2-.8 0-1-.3 0-.3-1-2-1-2"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#231f20",
      d: "M308.7 263.3s1.7.2 2 .5c.5.4.8.4.8.6 0 .3-.3.4-.5.4a3.6 3.6 0 0 1-1.2-.5l-1-1zm-1.9-4.8s1.7.2 2 .5c.4.3.5 1 .1 1.2-.4.2-.8-.2-1-.5a8.2 8.2 0 0 0-1-1.2zm-3.6 2.5s1.5.8 2 1.4c.3.4.5.7 0 1-.4 0-.9-.7-.9-1a9 9 0 0 0-1.1-1.4"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#231f20",
      d: "m302.8 263 1.5-.2c.5 0 1.2-.1 1.2.2 0 .4-.6.5-1 .4zm8.6 5.6s1.1-.7 1.7-.6c.5.1.7.1.7.4 0 .4-.7.3-.9.3zm-6-.9s.4-.6.9-.7c.4 0 .6 0 .7.2 0 .2-.4.6-.6.6h-1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#04534e",
      d: "M322.6 266.6s-1.6 2-4 3a14 14 0 0 1-7.2 1.1 15.2 15.2 0 0 1-11.2-5.2l.4 1.1 2 2.6 2.3 1 3.5 1 3.3.3h2.5l3-.5 1.9-.7 1.3-.8 1-.8 1.2-2zm-3-5.9s-1 .3-3-.9-4.3-2.8-8.8-2.8c-4.5 0-5.9 3-6.2 3.2l2-2.6 2-1.1 1.7-.3h1.5l2 .6 1.7.6 2.1.7 1.8 1 2.2 1.1zm6 1.4h-3.4c-.8 0-.8.2-1 .4a4 4 0 0 1-.2.4l-.8-1.7 3.5-.5 2 .7-.2.6z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#0c8489",
      stroke: "#04534e",
      strokeWidth: 0.5,
      d: "M320.7 280.4c.2.5.6 1 1.1 1h1.6l3.6-.3 1.2-1.4.8-3.2 1-1.2 3.3-1.9 2.8-.8 1.9-.2 2.5-.8 1.9-1 .8-1.2.8-1.8-.8-2.5-2-2.7-3.4-1.3H335l-3 1.1-5.5 1.3s-3 1.3-4.3 3.7c-1.3 2.3-1.2 3-1.5 6-.2 3.2 0 7.2 0 7.2z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8cbebf",
      d: "M322.2 279.2c1 0 .2-1.7 1.4-3.8 1.2-2 2.6-4.6 3-4.6s.4.4.9.3c.4-.2 1.2-.8 1.2-1 0-.2 0-1.3 1-2 .8-.8 2.1-1.9 2.7-2 .6-.1 1-.3 1 0 .1.3-.3.7.1.8.4.2 1.4.1 1.6-.5l.2-1s.6-.5 1.8-.3c1.2.3 1.3.2 1.4.7.1.4-.5.5-.4.8v.6c.2.2.4 1 1.2 1 .8-.1 1.1-.6 1.1-.6l.3-.4s.2-.5-.1-.7c-.3-.2-.2-.4 0-.3.4.1 1.6 1.8 2 1.1.4-.7.5-1.7.2-2a91.2 91.2 0 0 1-1.9-2.7l-3-1-4 .3-4 2.2-3.6 2s-.2 2.9-.8 2.3c-.7-.5-1.6-2-1.9-1.5-.3.5-.9 2.7-1.3 3.8-.3 1-1.4 4.4-1.3 5.6.1 1.2.8 2.9 1.2 2.9"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8cbebf",
      d: "M325.8 274.4c-.3 0-.7.3-.8.5-.2.2-.3.5-.2 1 0 .3.7.7.7.7h.5l1-.3.3-.8c0-.5-.3-.6-.4-.6a29 29 0 0 1-1.1-.5m6.2-5c-.6-.3-.8.1-1 .3v.5s.2.8.4 1c.3 0 1.1.3 1.3 0 .3-.2.5-.4.5-.9s-.7-.7-.7-.7zm5 1.1c0-.2-.5-.3-.9-.2-.3 0-.7.4-.6 1 .2.7.8.7 1.2.6.5-.1.4-.8.4-.9zm-14.4 1c0 .3.5 1 1.2.9a1.3 1.3 0 0 0 1.2-1c0-.4-.4.3-1 .5s-.7.2-1 0c-.2-.4-.4-.4-.4-.4"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#04534e",
      d: "M327.3 275.5s0 .6-.4 1c-.5.3-.8.3-1 .3-.3 0-.6 0-.8-.3l-.3-.7s.5.8 1.3.6a2 2 0 0 0 1.2-.9m13.3-8.3s0 .6-.5.9c-.5.3-.7.3-1 .3-.2 0-.6-.1-.7-.4-.6-1-.3-1.5-.3-1.5s.4 1.6 1.3 1.5a2 2 0 0 0 1.2-.8m-11.9 2.9s-.4 1.2-1.2 1.2c-.9 0-.8-.2-.7-.4 0-.1.3.2.7 0 .4 0 1.2-.8 1.2-.8m2.3-.3s0 1 .2 1.2c.3.4.7.5 1 .5s.6 0 .9-.4.1-.8.1-.8l-.2.5c-.3.3-.5.3-.8.3s-.7 0-.8-.3zm4.3-4.3s.2.7-.3 1.2c-.5.6-1.5.2-1.5.2s.8.3 1.2-.2c.4-.4.6-1.2.6-1.2"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#04534e",
      d: "M321.7 281.1s5.3 0 5.7-.8c.4-.7-.4-3.6 2.7-5.8 3.2-2.2 5.7-2.2 7.4-2.3 1.7-.2 5.3-1.3 6-4.5.3-2-2.3-2.2-3.3-4-1-2-3.6-1.2-3.8-1.2-.1 0-3 0-4.3 1.3-.9.8-.8 1.8-1.1 2.2-.4.5-4 0-4.3.6-.4.6.1 1.7-.2 2-.2.3-1-.8-1-.8l.2-2.8 4.5-2.6 5-2.8 3.5.1 3.5 1.8 1.7 2s.3.8.5 2.3a5.3 5.3 0 0 1-.2 2c-.8 2.8-3.7 4.8-6.7 5a14 14 0 0 0-7 2.5c-1.4 1-2.1 5.3-2.1 5.9 0 .5-6.6.1-6.6.1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#231f20",
      d: "M324 270.8c-.3.3-.7.2-.8 0-.2-1 .3-2.2.3-2.2v1.6c.1.2.4.1.5.3zm3.2-.6c-.2-.1-.1-1 0-1.3.2-.3 1.7-1.4 1.7-1.4l-.6 1.5c-.2.4-.7 1.3-1 1.2zm-1.2 5.3c-.3 0-.3-.4-.3-1s1-1.6 1-1.6l-.4 1.2.2 1c0 .3-.3.4-.5.4"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#231f20",
      d: "M328.4 274s-.5.6-1 .9c-.5.3-1.1.7-1.4.6-.4 0 .1-.8.3-.9zm4.5-6.4s-.6.5-.9 1.2c-.3.7-.4 1.3-.1 1.4.3.2.7-.8.8-1.1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#231f20",
      d: "M334.6 269.9s-.5-.4-1.2-.6c-.8-.2-1 0-1.2.2 0 .2-.6.5-.3.7.2.2.6-.3.8-.3.2-.1.5-.3.9-.2zm-1-4.5c.3.3.7-.2 1-.6.4-.4.7-1.2.7-1.2l-1 .7c-.4.3-.9 1-.7 1.1m6.9-.1s-1 .4-1.2.8c-.3.4-.7.8-.4 1 .3.3.6-.2.8-.5zm-2 4.6s-.3.6-.9 1c-.5.4-1.2.5-1.3.3-.1-.2.1-.6.3-.7l.8-.2a7.3 7.3 0 0 0 1.1-.4"
    }),
    /* @__PURE__ */ jsx229("ellipse", {
      cx: 328.8,
      cy: 207.4,
      fill: "url(#mx_svg__b)",
      rx: 2.9,
      ry: 4.3,
      transform: "rotate(8.7)"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.3,
      d: "m295.4 247-1.7 4.2 1.4-.2.7-3.8z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2,
      d: "M296.1 245.1c-.6 0-1.1.4-1.2 1 0 .7.4 1.3 1 1.4.6 0 1.1-.4 1.2-1 0-.7-.3-1.3-1-1.4z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.3,
      d: "m369.7 255.8-4.2 4 1.7.4 2.9-3.8z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2,
      d: "M371.6 254.1a1.5 1.5 0 0 0-2 .6c-.5.7-.3 1.5.4 2 .7.3 1.6 0 2-.7.4-.6.2-1.5-.4-1.9z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.3,
      d: "m262.8 233 2.2 4.9 1-1.4-2.6-3.7z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fcca3e",
      stroke: "#aa8c30",
      strokeWidth: 0.2,
      d: "M261.9 230.9c-.6.4-.6 1.3-.1 1.9.4.6 1.3.7 1.8.2.6-.5.6-1.3.1-2a1.3 1.3 0 0 0-1.8-.1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#aa8c30",
      d: "M296.6 245.3s.3.1 0 0c-.5 0-1.4.4-1.4 1a1 1 0 0 0 1 1c.5 0-.2.2-.2.2l-.7-.2-.2-.4-.2-.5.1-.6.4-.5.5-.2h.3z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#aa8c30",
      d: "M295.6 248.1s-.3 0-.5.3a49.4 49.4 0 0 1-.7 1.1l1-2.3.4.2zm76.4 6.4s.3.4-.1 0c-.4-.3-1.8-.2-2.1.5-.4.8 0 1.4.6 1.7.6.2-.2 0-.2 0l-.7-.5-.1-.6v-.7l.5-.6.7-.3h.7l.3.2z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#aa8c30",
      d: "M369.4 257.3s-.3-.2-.8 0l-1.4.9 2.3-2.2.5.6zm-107-26.7s.4-.1 0 .1c-.5.3-.8 1.4-.3 2 .6.5 1.3.4 1.7 0 .4-.5 0 .2 0 .2l-.7.4h-.6l-.6-.3-.4-.6v-.8l.2-.5.3-.3.3-.2z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#aa8c30",
      d: "M264 233.8s-.3.1-.2.6l.3 1.5-1.2-2.7.7-.2z"
    }),
    /* @__PURE__ */ jsx229("ellipse", {
      cx: 337.6,
      cy: -128.1,
      fill: "url(#mx_svg__c)",
      rx: 4.6,
      ry: 3.1,
      transform: "rotate(62.9)"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#e92736",
      d: "M262.6 241.2s1 .2 1.5 0 .6-.7.7-.8.3-.6.2-1a3.8 3.8 0 0 0-1-1.4l-1-.1c-.1-.1 0-.4-.2-.5-.3 0-1.7 1.6-1.5 1.8.3.3.4 0 .5.1v1.1c0 .3.8.8.8.8"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#e92736",
      d: "M264 238.1c.1.3.7 1 .9 1 .2.2.8.2 1 0 .3 0 1-.7 1-1a1.5 1.5 0 0 0-.1-.7c-.2-.3-.1-1-.4-1.1-.2 0-.3-.1-.5-.3v-.7c-.3-.3-2.6 1.1-2.4 1.4.2.2.4 0 .5.1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#e92736",
      d: "M269.2 237.6c.2-.4.1-1.5-.1-1.8s-.6-.3-.7-.4c0-.1.3-.2.3-.5s-2.6.1-2.4.4c.2.3.6.1.6.3 0 .2-.4.4-.5.6l.3 1.1c0 .2 0 .4.2.5l.6.2h1.4c.1-.1.2-.1.3-.5zm22 12.8s.3.7.8 1h1l.6-.5c.2-.2.4-1.2.3-1.4 0-.2-.5-.6-.5-.8 0-.2.3-.2.2-.4-.1-.2-2-.2-2 .2 0 .3.3.2.2.3 0 .2-.5.5-.6.7-.2.1 0 1 0 1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#e92736",
      d: "M293.8 249.5c0 .2-.2 1 0 1.1 0 .2.3.7.5.8h1.2a1.2 1.2 0 0 0 .4-.6c.1-.3.6-.7.5-.9-.1-.2-.2-.2-.1-.4 0-.2.3-.2.3-.5s-2.1-1-2.2-.7c0 .3.3.2.2.4 0 .2-.7.6-.8.8"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#e92736",
      d: "M297.3 252.5c.3-.2 1-.9 1-1.1 0-.4-.3-.6-.2-.7l.5-.1c.1-.2-1.6-1.6-1.7-1.3 0 .3.3.4.2.5l-.7.1c-.1.1-.5.6-.5.8 0 .2-.3.2-.2.5l.2.4c.1.2.8.9 1 .9zm66 5.5s0 .8.4 1.2c.3.3.6.3.8.4h.7a3 3 0 0 0 1-1c0-.3-.3-.8-.2-1s.3 0 .3-.2c0-.3-1.6-1.1-1.7-.8-.1.2.2.3 0 .4l-.8.2c-.2 0-.5.8-.5.8"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#e92736",
      d: "m366 258.5-.8.8c0 .2 0 .7.2.8 0 .2.7.6 1 .5.1 0 .3 0 .5-.2.2-.1.8-.2.8-.4l.1-.4c.1-.1.4 0 .6-.2.2-.2-1.2-1.7-1.4-1.5-.2.2 0 .3 0 .4-.2 0-.9 0-1 .2"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#e92736",
      d: "M366.4 262.2h1.4l.4-.5c.1 0 .1.2.4.2.2 0 0-2-.3-1.8-.2.1-.1.5-.2.4-.2 0-.3-.3-.5-.3a2.4 2.4 0 0 0-1 .1s-.2 0-.3.2l-.2.4v1c.1.2 0 .2.3.3"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f7e204",
      d: "M264.2 239c.2.4-.1 1.2-.3 1.4-.1.2-1.3-.1-1.3-.3 0-.2-.1-.6 0-.8.2-.2.6-.7.9-.6.3 0 .6.3.7.4zm.3-1.3c-.2.3 0 .6.2.7.1.2 1 .4 1.2.3.2-.2.6-1.5.4-1.7-.2-.2-.6-.2-.7-.2-.2 0-1 .6-1.1.9m2.7-1.3v.7c.2.1.7.5 1 .5.3 0 .5-1 .5-1.1 0-.2-.1-.3-.3-.4l-1.2.2zm26.1 13.7c0 .4-.7.7-.9.7-.2 0-.7-1-.6-1 .1-.2.3-.5.5-.5s.7 0 .9.2zm1.1-.6c-.2.1-.3.4-.3.6 0 .2.3.8.5.9.2 0 1.2-.5 1.3-.7 0-.2-.2-.5-.4-.6l-1-.2zm2.4 1c-.2 0-.4.3-.4.5 0 0 0 .6.3.8.2.2.8-.2.9-.3v-.4c0-.2-.8-.6-.8-.6m68.6 8.2c-.2.2-.9.2-1 0-.3 0-.3-1-.1-1 .1-.1.4-.3.6-.2.2 0 .6.3.6.6zm1 .1c-.3 0-.5.1-.6.3-.1.1-.2.7 0 .9.1.1 1.2.2 1.3 0v-.5zm1 2h-.5c-.1 0-.4.4-.4.7 0 .2.7.3.8.3l.3-.2-.1-.8z"
    }),
    /* @__PURE__ */ jsx229("ellipse", {
      cx: 438.6,
      cy: -93,
      fill: "url(#mx_svg__d)",
      rx: 2.2,
      ry: 4.5,
      transform: "rotate(47.9)"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#a8ac71",
      d: "M285.8 199.3s-3.8.3-6.5-.1-2-7.3-2.1-7.5c0-.2-1.6-1.8-1.4-3.3.3-1.5 5.2-5.5 5.8-5.8.5-.1 1.5.3 1.5.3s1.2-1.2 1.6-1.2c.4 0 .9.7.8 1-.2.3-1.9 1.3-2 2-.2.8 0 1.5-.5 2.3-.5.7-1.4 1.7-1.5 2.4-.1.6-.4 1.1 0 1.4.5.2 2.1 0 3.5-.6 1.4-.7 2-1.5 2.1-1.4.2 0-.8 1.7-2.3 2.4-1.5.6-2.5 1.3-3.3 1.2 0 0-.8 2 1.8 2.2 2.6 0 4-.6 4-.6zm-15 16s2 .8 2 3-2.1 4.1-2 8c0 4 .6 4 5.8 8.3a5.7 5.7 0 0 1 1.6 2.5c.3 1.3 1.2 8.9 6.2 8.9s5.8-3.3 5.8-3.3l-2.2-3.1s-1.7.5-2.7.3a3.4 3.4 0 0 1-2.3-2.1c-.6-1.2-.7-4.1-1.6-5.4-2-3.2-5.8-3.7-5.9-7 0-3.4 2.3-3.7 1.7-7.7-.7-4-5.4-5.8-5.4-5.8l-1.9-.8-.7 4z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f1a720",
      d: "M284.7 187.6c1.7-.4.7-4.8.7-4.8l-1.2 1s.8 1 .8 2-.3 1.8-.3 1.8"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#a8ac71",
      d: "m287.8 231.5-.9-.7c-.6-.4-3.2-2.6-2.8-8.9.5-7.2 11-11 11.6-13.8.8-3.2 3.1-4.5-5.2-11l-2 2.2 3.5 2.6s.7-.4.8.6c0 1-1 1.7-1.2 2.5-.2.7-5.4 4.3-5.8 4.6l-3 2.4s-1.3 1.3-2.5 4.1c-1.3 2.8-.7 6.4-.7 6.4s0 7.6 8.2 9"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#78732e",
      d: "m282.7 235.5.6 2.7-1.7.6h-.7l-.5.2-1.3 1.2h-.3s-.2 0-.3-.8c0-.8-.2-1.5-.2-1.5l1.6.7h.6l.3-.1.7-1.5zm-4.8.5-.8-1-1-.9 1.2-.6h1.2l-.2 1.5zm2.7-4.3s.8.3 1 1l.6 1.2-2-.2-1.4-.4 1-1.4zm-.7 11.9s-.4-.3-.7-.9l-.4-1.6 1.3-.3 1.5.7h.4l-.3.8-1.5 1.3zm5-4.1s-1-.4-1.2-1c-.2-.5-.4-.4-.4-.4l-.3 1.5-.5 1.5.2.2 1.1-.3.9-.9.3-.6zm-4.7 4.8 1.4.7c.8.5 1.2.5 1.2.5l.6-.6.7-1.3v-.1l-3 .3zm4.4-1.2 2.7-1.6.1-1.4-.5-.4h-1.5l-.5 1.8zm-1.8 2.5s1.8.8 5-.4c1.4-.5 1.7-1.2 1.7-1.2l-1.3-.5-1.2 1zm-2.5-20.3-.4-1.4c-.2-.8-.1-1.1-.1-1.1l.9.5 1.3 1-1 .7zm2.2 3.7-.9-1a12.4 12.4 0 0 1-.6-1.2l1 .2 1.1.6z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#c6c7a6",
      d: "M276.6 187c-.2.7-.4 1.9.5 2 .4.2 2.3 0 4.5-2.4 1-1.2 1-2.4 1-2.4l.5-1.3s-.9-.6-2.2.2c-1.3.8-4.3 4-4.3 4z"
    }),
    /* @__PURE__ */ jsx229("circle", {
      cx: 282.5,
      cy: 183.6,
      r: 0.4,
      fill: "#1c242f"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#a8ac71",
      d: "M279.7 184a17.7 17.7 0 0 0-1.7 1.7s1.4-.4 2.6-1.5c.6-.6 2-.8 2.6-.7.4.1.2-.4 0-.5-.3-.3-1.4-.4-1.6-.3z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#78732e",
      d: "M284.1 224.5v-2.2l-.9.8-.8 1.1 1.3.5zm-4.5-2.6v-2.3c0-1 .5-3.1.5-3.1l.6 1.4 1.5 2.4.5.4-1.3 1-1.4.4zm4.5-.6.3-1c.1-.6.5-1.4.5-1.4v.1a25 25 0 0 0-2 1.7l.8.7h.5m-3.7-6s.2-.6 1-1.5l1.3-1.8.6 2.4.4 2v.4l-.7.2c-.2 0-1.6 0-1.8-.3zm4.8 2.9.8-.9 1-1-3.2.6.5 1zm-2-6.7s.3 0 1.2-1c.8-.8 1.3-.7 1.3-.7l.3 3.4-1.6-.5z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#78732e",
      d: "m287.3 216.2 2-2-3.3-1 .6 2.3zm1.4-5.2.2-3.3s-.7.3-1.5 1l-1.2.9.4.6 1 .7h1zm2.8-3.2V205s-.5.8-1 1.2l-.9.8.9.6h1zm1.2 3.5 1.6-1.3a6.5 6.5 0 0 0 1.5-1.7l-4.2-.3.2 1.7 1 1.6zm-9.6-13.8-.2 1.8h3.5l-.9-1.2-1-.6-1-1zm6.6 16.2c.2 0 1.1-.8 1.6-1.2.4-.5 1.2-1 1.2-1l-3.3-.3v2.2zm6.3-5.9s.4-1.3.3-2.6c0-1.2-.2-1.8-.2-1.8l-2.5 1.7.4 1.2 1 1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#78732e",
      d: "M291.8 204.8s.7-1 .8-1.4v-.4h2l1.1.2h.2l-.9 1.1-1.2.7-1.5.2zm4-2-1.3-2c-.4-.7-.8-1-.8-1l-1 2.7v.3h3z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fff",
      d: "m271.6 222.2-.3.8s1.3-.7 2.3-.7c1 0 2.1 1.3 2.1 1.3l.2-.9s-1.3-1.3-2.2-1.3c-.8-.1-2 .8-2 .8zm.7-5.8.3.4c0 .1.1-1 1.4-1.5 1.4-.6 2-.1 2-.1s-.2-.8-.8-1c-.6-.1-1.1 0-1.8.5a3.7 3.7 0 0 0-1.1 1.7m4.4 4.4s-.6-1.4-1.6-1.6c-1.1-.3-2.5.5-2.5.5l-.2.7s1.5-.8 2.5-.4c1.1.5 1.5 1.7 1.5 1.7l.3-1zm-5-5.1.4.5s-.2-1.4.5-2.1a4.9 4.9 0 0 1 1.1-1l-.6-.3s-.9.5-1.2 1.1a3.2 3.2 0 0 0-.2 1.8m-.5-2.3c.3-.8 1.2-1 1.2-1l-.3-.3h-.5s-.5.3-.9 1c-.3.9-.3 2-.3 2l.6.3s-.1-1.4.2-2m7.8-19.2c.9-.4 1.5-.3 1.5-.3s-1.3 1.3-.7 2.9c-.7 1.3-.9 2.3-.9 2.3h.7l.4-1.8c.8 1.3 2 2 2 2h1s0-1.3.4-2.4h.1a5 5 0 0 0 2 1.5v-.4s-1.1-.6-1.7-1.5l-.1-.1a4.2 4.2 0 0 1 1.8-1.7l.7.6.2-.2-.5-.7h-.6l-1.8 1.7a9.2 9.2 0 0 1-.8-1.5l-.4-.2s-1.1.1-2 1.7c-.2-1.2 1.1-2.4 1.1-2.4v-.5l-2.4.6c-1 .3-1.7 1.2-1.7 1.2v.8s1-1.1 1.7-1.6m1.5 2.2c.6-1 2-1.5 2-1.5s0 .7.7 1.7c-.5.9-.8 2.2-.8 2.2s-1-.6-1.9-2a1.6 1.6 0 0 1-.2-.3zm-7.6 21.1v.8s.8-.9 2-1c1.2 0 2.3 1 2.3 1s0-1-.2-1.2c-.1 0-1.1-.6-2-.6s-2.1 1-2.1 1m21.4-11.2-.5-1 .6-.3a12.5 12.5 0 0 0 1.7-1.6l-.4-.6h-1.6l-1.4-.1.5-1.7.6-1.4-.6-.5s.2.5-.8.6c-1 .1-2.8-.8-2.8-.8v.4l2.5.7c.6 0 1-.1 1.2-.3l-.5 1.3-.3 1 .2.2v.8l1.4.1 1.6.1s-.8 1-1.7 1.5a2.3 2.3 0 0 1-.3 0l-1-1.5-.1.5.7 1.2a5 5 0 0 1-1.5-.1l-.4.4v2.5l-1.8-.6-.3.3v-.1l-.4.4s-.4 1.4-.3 3.1v.1a4.9 4.9 0 0 1-2.4-1.3l-.4.3s-.3 1.4 0 3.2c-1.3-.3-2.5-1.5-2.5-1.5l-.5.5a60 60 0 0 0 .7 4.7 4.9 4.9 0 0 1-.7 0c-1.4 0-2.3-1.3-2.3-1.3l-.4 1s.6 2.7 2 4l.4.2c-1.3 1-2.8 1.2-2.8 1.2v.9a44.7 44.7 0 0 0 2.2 1.5 4.8 4.8 0 0 1-1.6 1l.2.5 1.8-1.3 1.8.5v-.5l-1.5-.3.1-.1c.5-.4 1.4-1.8 1.4-1.8v-1s-.5 0-1.1-.6c1.8-1.2 1.9-1.8 1.9-1.8l.4-.6s-.7-.3-1.1-1.2l2.9-.7.2-.2s-.7-1.2-1-2.6l3 .6.4-.4-.5-2.4c1.8 0 3.2.2 3.2.2l.3-.3s-1-1.9-1-3a4.8 4.8 0 0 0 1 0h3l.3-.5s-1.4-1-1.7-1.5m-10.5 15.5s-.5 1-1.4 2l-.2.2a4.6 4.6 0 0 1-.5-.2c-1.1-.6-1.4-1.3-1.4-1.3l2.5-1.6zm.9-3.2-2 2a4.1 4.1 0 0 1-.4-.5c-.8-1.2-2-2.1-1.8-3.8 0 0 .7 1.2 2.2 1a14 14 0 0 0 1-.1c.4 1 1 1.4 1 1.4m2-2.5-2.7.7a5.3 5.3 0 0 1-.1-.5c-.5-1.6-.5-4-.5-4s1 .8 2.6 1.2zm-.5-3c-.2-1.4.1-2.9.1-2.9s.8.8 2.3 1c.1 1.5.3 2.1.3 2.1zm5.8-2.2s-1 .4-2.8.1a15.3 15.3 0 0 1 0-.5 23 23 0 0 1 0-3l2.3.7a10 10 0 0 0 .5 2.7m0-3.1h-.2V205s1 .3 1.7.2c.2.4 0 .5.5 1.2.4.7 1.1 1.3 1.1 1.3s-2.3.2-3.2 0zm-7.6 18.6-.1-.5s-1 .7-1.2 1.4a1.6 1.6 0 0 1-.3-.1l-2-.8.2.4 1.8.8h.2l-.5 1.4.2.3.5-1.7 1.2.1-.2.8-.4 1.5.5.3h2l-.3-.4-.7-.1h-1.1l.3-1.2.3-.8-.3-.7-1 .2a3 3 0 0 1 .9-.9m-11.3-1.3c1.3 0 2.3.9 2.3.9v-.6s-1-1.4-2.1-1.4c-1.2 0-2.5 1.2-2.5 1.2v1.2s1-1.3 2.3-1.3m13.3 19.4c-1.3.6-2.7.6-2.7.6l.8-1.5c2.5-.8 3-2.4 3-2.4l-.2-.7s-.6 1.6-2.6 2.4c.4-1.2.7-3.2.7-3.2l-.7-.2s-1 1.3-2 1.6a7.7 7.7 0 0 0 .8-2.7l-.3-.5s-.7.6-1.7.8a1.8 1.8 0 0 1-.6 0c.6-.8 1.7-3.2 1.7-3.2l-.2-.5s-.8 2.1-1.7 3.2a10.6 10.6 0 0 1-.3.4c-1-.3-2.2-1-2.2-1l.1.3s.8.6 1.8 1a27.3 27.3 0 0 1-1.3 1.2v1l3 .4c-1 1.6-2 2.1-2 2.1l.5.7s1.3 0 3.7-.6c-.6 1.2-1.2 1.8-1.2 1.8s2.2.2 3.7-.6 2-1.6 2-1.6l-.4-.4s-.4 1-1.7 1.6m-6.9-4 1.2-1.5c1.6.3 2-.1 2-.1s.3.8-.6 2.3c-1.1 0-2.6-.8-2.6-.8zm1.4 3 1.3-1.6.3-.3c1.5 0 2.3-1.3 2.3-1.3s.2 1.2-.5 2.7c-1.9.7-3.4.5-3.4.5m-1.9-9.8c1.5 0 3.3.7 3.3.7l-.2-.7-2.9-.6a3.6 3.6 0 0 1 1.6-1.6l-.5-.3s-.6.1-1.4 1.5a4.1 4.1 0 0 0-.2.4 4 4 0 0 0-.3 0 5 5 0 0 0-2.4.7l.2.4s1.1-.5 2.3-.5a25.7 25.7 0 0 0-.7 2.4l.3.6zm-3-6.2-.3-.7s-1.5-.6-2.7 0c-1.1.5-2 1.9-2 1.9l.5.9s.8-1.5 1.9-1.9c1-.3 2.6-.2 2.6-.2m3 2.4-1-.6s-1.7.5-2.2 1.1c-.6.6-1.1 2.1-1 2.5.2.5.7.7.7.7s.3-1.5 1.1-2.3c.8-.8 2.4-1.4 2.4-1.4m-3.9-.5a4.5 4.5 0 0 1 2-1l-.7-.5s-1.5.2-2.2.9c-.8.7-1.8 2.1-1.8 2.1l.9.9s1.2-1.8 1.8-2.4m5.2-44.7c.8-1 1.6-1 1.9-1h.6a9.3 9.3 0 0 0-.8 2.5c-.2 1-.7 1.2-1 1.9-.4.7-1.1 1.8-1.2 2.8 0 1 .3 1.6.5 1.7.3.1.8-.4.7-.7 0-.3-.3 0-.4 0-.2 0-.2-.3-.3-.9-.1-.6.7-2.2 1-2.8.3-.5 1-1.1 1-2l.7-2.5c0-.1-.4-.2-1.3-.3-.6 0-1.5.5-1.9 1.2-.4.6-1.7 1.1-1.7 1.1s1.4 0 2.2-1"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#78732e",
      d: "M285.2 194.5h-2.5l.7 2zm-3-.1-.5-.4a1.5 1.5 0 0 0-.3-.3l-.9.5-.5 1.9.3.3 2-2zm-.3 5-1.8-2.7-1 2.2.5.2 1.2.2h1.1zm7.4 44.7a9 9 0 0 1-4.8 1.5 6.7 6.7 0 0 1-3.4-1 4 4 0 0 1-1.5-1.7c-.6-1.1-.8-2.5-1-4-.3-1.3-.5-2.6-1.1-3.6-.8-1.3-2.4-2.1-3.8-3.3a7.3 7.3 0 0 1-2.8-5.2 8.1 8.1 0 0 1 0-.8c0-1.7.5-3.2 1-4.5s1.2-2.5 1.2-3.5v-.5c-.3-.7-1-1.4-1.5-1.9s-1.2-.8-1.2-.8l-1-.2-.1.3 1 .2v-.1.1l1.3 1c.5.4 1 1 1.1 1.5a1.9 1.9 0 0 1 0 .4c0 1-.5 2-1 3.3a11.7 11.7 0 0 0-1.2 4.7v.8a7.7 7.7 0 0 0 3 5.5c1.5 1.1 3 2 3.7 3.2.8 1.2 1 3 1.3 5 .2.8.4 1.7.8 2.5s.9 1.5 1.6 2a7 7 0 0 0 3.7 1c2.7 0 4.9-1.6 4.9-1.6z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#78732e",
      d: "M287.2 239.2a2.6 2.6 0 0 1-1.3.4c-.5 0-1.1-.2-1.7-.8a4 4 0 0 1-1.2-2.3c-.2-.9-.3-2-1-3.3-.5-1.5-2-2.6-3.5-3.7-1.3-1.1-2.6-2.2-2.9-3.4a3.3 3.3 0 0 1 0-.7c0-1 .4-2 .8-3.1a10.8 10.8 0 0 0 .9-4.8c-.2-2-1.7-3.5-3.2-4.5a14.1 14.1 0 0 0-2.8-1.4l-.1.3h.2c.5.3 1.8.9 3 1.8 1.3 1 2.4 2.2 2.6 3.8v.8c0 1.5-.4 2.7-.9 3.9s-.9 2.2-.9 3.2l.1.8c.3 1.3 1.6 2.4 3 3.6 1.5 1 3 2.2 3.5 3.5.6 1.3.7 2.4.9 3.2.2 1 .4 1.7 1.2 2.5.7.7 1.4.9 2 .9a2.8 2.8 0 0 0 1.4-.4z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#a8ac71",
      d: "M296.4 231.6s1.7.4 1.6 1.8a13.3 13.3 0 0 1-.8 3.4l-2.4-2.2 1.3-1.2.5-.7z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M266.4 214.5s-1.7.6-2.1-.1c-.4-.8-.2-1.4-.2-1.5 0-.2-1-.3-1-1.3.1-1 1.4-.9 1.6-.9.3 0 .4-1.5 1.3-1.4.8 0 1.2 1 1.2 1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M268.3 215s-1.5.8-2 0c-.4-.7 0-1.6-.1-1.8-.2-.1-1-.4-.9-1.3.2-.9 1.1-.6 1.4-.8.3-.1.6-1.4 1.5-1.2.9.3 1 1 1 1l-1 4.1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M270.8 215.3s-.5 1-1.5.8c-1-.2-.7-1.7-.9-2-.1-.3-.9-.5-.8-1.4.2-1 1.1-.9 1.5-1 .3-.1.7-1.6 1.4-1.4.7.3 1.3 1.1 1.2 1.5 0 0-1.5.5-1.7 1.5-.2 1 .8 2 .8 2z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#af7029",
      d: "m293.7 231.2-2.2-2.6c-.9-1.3-2.3-2.7-2.3-2.7l-2.2-1.1-1.4-2.4-.2-2.8.6-1.6.8-1.2s-4.6 1.7-2.2 10.5c1 3.8 3.5 4.3 3.5 4.3l4.3-.3h1.3z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#816c2a",
      d: "M291.6 201.7c.4 0 .6.2.8.4l.2.6v.4c-1.6 3.4-4.8 5-7.8 7a13.8 13.8 0 0 0-3.8 4 12 12 0 0 0-1.6 6.8c.1 5 2 7.8 4.2 9.3a9.7 9.7 0 0 0 5.2 1.5h.4l1.4-.1a35.8 35.8 0 0 1 3-.2l1.8.1.9.4a.8.8 0 0 1 .2.5c0 .4-.3.8-.6 1.2l-1 .7.2.3a4 4 0 0 0 1-.8c.4-.4.7-.9.7-1.4 0-.2 0-.5-.3-.7-.2-.3-.6-.4-1.1-.5l-1.8-.1c-2 0-4.5.3-4.5.3v.2-.2a6.8 6.8 0 0 1-.3 0 9.4 9.4 0 0 1-5-1.5c-2.1-1.4-4-4-4-9v-.4c0-2.7.5-4.7 1.5-6.3 1.4-2.4 3.7-3.8 6-5.3a14 14 0 0 0 5.5-5.7v-.5c0-.2 0-.6-.2-.8-.2-.3-.5-.5-1-.5z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fff",
      d: "M297.8 232.7s-1 2-1.4 2c-.2 0 1 .3 1.3.8l-.3.5s-1.2-.9-2-1v-.6l1.1-.7a4 4 0 0 0 .9-1.7z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fcca3d",
      d: "m302 234-2.7.8-1.3-1s0-1-.5-1.5l-1.6-1c-.6-.2-2.5-.2-2.5-.2l-5-5.3 2 .2 2.8-.4 2.7-.2 1.4.2 1.6.4.8.7.8.8.8 1.3.6 1.6.2 1.7v1.9z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#af7029",
      d: "M302.2 233.8s-1 .3-2.2.3c-1.3 0-2-.2-2-.2l-.2.9c-.2.9-.5 1.3-.5 1.3v3.2l2.6.5 1.4-.5.7-3.5z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fcca3d",
      d: "M301.5 232.5v1.2l.6.2v-1.2zm-2.5-30-.3-2.1-.8-1.5-1.1-1.5-1.2-1.3-.6-.5-.3-.5-2.9.2-1.4 1.7s3.8 2.8 5.3 5.8a7 7 0 0 1 2.8 1.7l.1-.2z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#af7029",
      d: "M296.3 205c0 2.2-.5 3.2-.8 3.7l1.8-2 1.2-2.2a7 7 0 0 0-2.8-1.7c.4.7.6 1.4.6 2.1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#816c2a",
      d: "m300.3 237.9-1.4-1.6c-.6-.6-1.3-1-1.3-1l-.2.4h.1l1.2.8a17.6 17.6 0 0 1 1.3 1.6z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#6f5b24",
      d: "M302 235.5s-.3 1-1.3 1.8c-1 1-2.2 1.5-2.2 1.5l2.8 1 1.9-1.7z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#404118",
      d: "m302.4 237.8-.2.3-.5.5-.4.5.6-3 .6 1v.4z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "none",
      stroke: "#78732e",
      strokeWidth: 0.2,
      d: "M285.8 199.3s-3.8.3-6.5-.1-2-7.3-2.1-7.5c0-.2-1.6-1.8-1.4-3.3.3-1.5 5.2-5.5 5.8-5.8.5-.1 1.5.3 1.5.3s1.2-1.2 1.6-1.2c.4 0 .9.7.8 1-.2.3-1.9 1.3-2 2-.2.8 0 1.5-.5 2.3-.5.7-1.4 1.7-1.5 2.4-.1.6-.4 1.1 0 1.4.5.2 2.1 0 3.5-.6 1.4-.7 2-1.5 2.1-1.4.2 0-.8 1.7-2.3 2.4-1.5.6-2.5 1.3-3.3 1.2 0 0-.8 2 1.8 2.2 2.6 0 4-.6 4-.6z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#ab6d29",
      stroke: "#4d2a15",
      strokeWidth: 0.4,
      d: "M318.7 170.6s-7-1.3-7 4.5c.1 1.9.5 2.5 2 3 1.5.3 4.4.5 7 2.7 2.5 2.3 2.7 4 2.7 5.3 0 1.4-.7 2.6-.7 2.6l1.6 7.7 1.6 5.7 4.8-2.7 2.8-8.5-3.6-15.2z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#4d2a15",
      d: "M325.6 200s2.5-1 3-3c.3-.5-2.4-2.9-2.4-2.9-.1 0 1.3.7 2 1.3.6.6 1.1.9 1.3.8.2-.1 1.3-2.7.9-3.3-.4-.6-1.1-2-2.1-2.6-1-.7-2.4-.6-2.4-.6s1.9-.6 2.8 0c1 .5 1 1 1.1.9.1-.3-.2-2.9-.6-3.7-.4-1-.8-1.3-2-1.6-1.1-.2-2.3-.1-2.3-.1s1.6-.9 2.8-.6c1.3.3 1.3 1 1.4.8 0-.1-.6-2.4-1-3a6.7 6.7 0 0 0-2.1-1.8l-1.8-.2h-.6s1-.6 2.1-.5c1.2.1 1.3.5 1.4.4.2 0-.1-.2-.8-.7s-4.2-2-4.2-2h-3.3s0-.8 1-1c.9-.1 1.1.1 1-.1 0-.3-2.6-.8-2.6-.8H316l-3 .3s.2-.5.7-.9c.3-.3.9-.5 1.3-.6 1-.3-.6-1.1-.6-1.1l.9-1.3 3.9.3 8.2 4.8 3.9 3.3 2.4 6.2-.7 10.8-5.5 4.5-2.4.3z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#d2a567",
      d: "M318.4 173.3s-.2-.7-.2-1.7.2-.9.2-.9-2.7-.3-4.6 1.2c-1.9 1.5-.8 4.1-.8 4.1s.8-.8 1.9-1.2c1-.4 3-.3 3-.3.2-.2-.4-1-1.1-1.1-.8-.2-2.1-.2-2.1-.2s.8-.5 2.2-.4c1.4.1 1.6.5 1.6.5z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8f4620",
      d: "m326.7 200.9-1.8.6 1 7.5 7.2 12.1 3.7-.6 1.3-2.3 1 .5c.4.4 1.8 2.8 3 3.3 1.1.4 1.7.2 2.7 1 1 1 4.9 6.6 5 6.8.3.2-.1-2.4-.1-2.4l-1.2-3.4-1.4-2.4-.3-.6h2l1.2.8 2 1.5.9 1.2.5 1.2.2 1 .5 1.6 1 2.3 1.3 2.1.4-.9-.6-2.5-2-6-1-2 1.9 1.2c.4.1 1.8 2.2 1.8 2.2l.9 2.2.6 2 .4 1.7.7 1.9 1-.7-.1-1.3-1-4.2-.4-4.5s.6 0 1.2.7a9 9 0 0 1 1.2 2.3l.5 4.1.7 3.8 1.2 3.8 1.2 2.4.9 1.3v-2l-1.6-16 .2-.6s.2-.1.8.7c.5.7 1 1.9 1 1.9l.5 2.5.2 1.7.3 3.3.5 3.5 1.6 3.8.9 2 .5-2.4-.8-17.1.4-.5s.9.7 1.2 1.3l.8 1 .6 3.8.4 10.7.4 2.8 3.2-28.2 2-.4.2-.6-1.5-1-3.2-5-2.1-4.9-3.8-7-6.6-8-5.2-4.3a20 20 0 0 0-1.9-1.3l.4-1 1-1.7-.1-.1h-.9l-2.2.4-2.2-.7-4.4-3-4.6-2.3-2.8-1-6.6-1.6-6.6-1h-3l-2.6.5s-1.4.6-1.8 1.5c-.5.8-.5 1.4-.4 2.6.2 1.3 1 1.9 2.8 2.7 1.8.7 6.2 3.6 6.2 3.6l2 2.1.8 1 .2.8 1.4 11.1-2.8 6z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#ab6d29",
      d: "M333.8 218.2s1.2 2 2.9.5c1.7-1.6-.8-6-.7-6.3 0-.3.7-.3.7-.3l1.3 2.2s.7 1.3.4 3.2c-.2 2-2.1 3.7-2.1 3.7l-2.2-.5z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#4d2a15",
      d: "m375.3 244.2-1.6-4.5-.4-3.5c0-.6-.3-7.9-.5-9.3 0-1.4 0-3-.2-3.1l-1.6-2.2-.7-.7.5-.3s.6.6.7.3c.2-.4 0-2-.6-4.5-.7-2.5-3.9-8.3-3.9-8.3l.4.2.9 1 1.8 1.5 4.1 1.5 2.2.3 1.4 2.9s1 4.9 1 7.4c0 2.4-.2 4.5-1.2 7-1 2.4-1.2 10.3-1.3 11.5-.1 1.3-.6 2.5-.6 2.5l-.5.3z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8f4620",
      d: "M375.3 231.2s.8-1 1.2-2.4c.4-1.4.5-12.4-.8-13.7a10 10 0 0 0-4-2.3c-.2 0 1 3.5 1 3.5l.8 1.4.6 1.8c.1 1 .9 3.1 1 6z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#4d2a15",
      d: "M369.3 238s.5-5.1.3-9c-.3-3.7-.6-4.2-1-4.9a32.3 32.3 0 0 1-2.5-6.3c-.9-3.2-1.5-5.6-2-6.2-.6-.6-1.7-2-2-1.6-.3.3-.3 1.1-.3 1.1l-1.5-.4-.4-1 .5-1.6v-.7l-.3-1.1 2 1.6 4.2 2.8 2 8.6 2 5.3.2 9-.2 8-1-3.5zm2.4-24.7s1 1 1.7 1.4c.7.4 1.8 1.1 1.6 1.2a8 8 0 0 1-2-.8l-1.2-.8v-1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#4d2a15",
      d: "M363.7 236s.8-1.8.7-4.1a49 49 0 0 0-1.6-8.6c-.4-.7-2-1.7-3.5-4.8s-1.3-3.8-2.3-5c-1-1-2-2.4-2-2.4l.3-3.3 3.6 1.8 1.6.8 1.8 8.7 1.6 2.5.7 3.5.9 8 .4 6.6-.2.5zm-4.2-3.7s.1-2.5-.5-4.8c-.7-2.3-1.1-4-1.9-4.8-.7-.7-2.5-2.6-4.1-5-1.6-2.5-3.9-5-3.9-5v-3.3l2 1.5a57.1 57.1 0 0 1 2.4 1.2l1 3.7 1.2 2.7 1.8 2.4 1.2 1.1.7 4 .4 2.3 1 3.2-.4 1.7zm-3 0-1-.9s.6-.6.3-2c-.3-1.2-.6-2.4-1.2-3.7-.6-1.2-.7-2-1-2.3a121 121 0 0 0-4.5-4c-1-1-2.7-2.6-3.7-3.3-1-.6-1.8-.8-1.8-.8l-.5-4s1.3 1.8 2.1 2a54.7 54.7 0 0 0 2.1.8l2.8 5 1 1.3 2.6 2 1 2.2.9 2.5 1 3.4.1 2zm-5.5-1s-1.7-2-2-3.2c-.2-1.2.2-1.2-.3-2.6-.5-1.4-2.3-3.5-3.7-4.6-1.4-1.2-3.4-2.8-3.3-3.8.1-.9.4-1 .4-1l.8.8 4.5 4.7 1.4 2.5 1 3.1.7 1.5.7 1.8zm16-23.3s3.1 3.8 4 .3c.3-1.6-1.2-4.6-1.2-4.6s-2.8-5-3.8-6.2l-5.7-7.3-3.5-1.6 1.2 2s2.6 2.6 5.9 8.4c3.3 5.7 2.7 8.9 2.7 8.9zm-17.8-23s6.1 5.2 10 10.8c4 5.7 5.5 9.4 4.7 10.2-1 .7-3.4-.4-4.4-2-1-1.6-1.8-4.4-5.5-8.6-3.7-4.2-5.5-4.8-5.5-4.8l-2.7-4.3zm-3.2 12.5s3.6 3 6 5.4a37.4 37.4 0 0 1 3.4 4.2l1.4 1.4s-.9-1.5-.4-2c.5-.6 1.1-.3 1.1-.3l-11.5-12zm-.7.3s1.2 2.3 3 4.1a464.6 464.6 0 0 0 4.1 4l.8 2.9s-5.2-4-5.2-3 1.2 3 1.2 3l-1.6-1-2.2-3.1-1.3-2.8-1.5-3.8z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#4d2a15",
      d: "M329.5 210.2s2.7 2.4 4.2 0c1.5-2.3.3-5 .3-5s3.9 5.6 5 .3c.2-1-2.4-4.6-2.4-4.6l1-.9 1.9 3.3s1.8-.8 1.8-3-1.9-5.3-1.9-5.3l1.8 2s3.6 0 3.7-2c0-2.2-3-4.5-3-4.5s2.4.1 2.4-1.3c0-1.4-3.4-2.4-3.4-3.3 0-.9 1-2.4 2.5-1.5 1.5.8 3.5 1.4 4.4-.2.8-1.6-.1-2-.1-2l-2.1-.4-3.4-1.8-2.7-1-2.8-.4 1 2 .8 5.8v2.6l.5 5.8-1.4 4.7-.7.9-.5.6-1.2 2.6-1.6 1.8-2.2 2.7z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#ab6d29",
      d: "M348.8 220.9s-.7-1.7-2.2-2.9a7.8 7.8 0 0 0-3.8-1.2l4 4.2zm5.6 1s-1.3-2.6-2.8-4.2c-1.5-1.6-2.5-3.6-3-3.6h-.6l.4 3.3 2.7 2.7s2.6 2 3.3 1.8m4.6-.2s-.6-3-2.2-6c-1.5-2.8-3.1-4-3.1-4l.4 3 1.2 3 2 3zm3.8-1.7s1-6.2 0-8c-.9-1.6-2.7-2-2.7-2l-.6 1 .6 4.3 1.5 3.4zm3.7-10.3s.9.4 2 2.5a40 40 0 0 1 2.6 8.6c0 .3-.5.2-.7.2-.2-.1-3.9-6-3.9-6l-.6-5.4z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#d2a567",
      d: "M340.4 216.8s2-.4 2-1c0-.8-2.4-2.2-2.2-3.3 0-.5 2 .1 2.1-.3.1-.4-2-3.6-1.3-4.4.6-.8 2.4 3.5 2.4 3.5s1 2 .7 3.2c-1.2 3.6-3.7 2.3-3.7 2.3m4.6-4.4c.1-.3 3.1.4 3.1.2.2-.7-2.7-3-2.7-3s-.6-1.2-.4-1.4c.2-.2 2 .2 2 0 .2-.3-2-3.2-2-3.7s.6 0 .6 0 1.7 1.7 2.6 3.2c1 1.4 1.8 2.6 1.5 4.9-.4 2.5-5 .6-4.7-.2m13.6-4.6s-.5-2-.2-2.3l1.1-.5s-1.6-1-2.4-1c-.7 0-.8-.2-1 0-.2.4 1.3 2.4 1.3 2.4z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#d2a567",
      d: "M349.4 209.4s4.7 1.2 4.9.8c.2-.3-3.7-4-3.7-4s-.3-.6-.2-.8c0-.2 1.7-.3 2.2.1s0 1.2.1 1.5c.2.3 1.7 2.5 2 2.1.2-.3-.4-3-.3-3.3.2-.2 1.8 1.6 2.3 1.9.4.3 3 2.3 3.3 1.4.3-1 .4-1.1.3-1.7 0-.6.9 2.6-.3 3-1.2.4-2.6-.4-2.6-.4l-1.1-.8-.6-.7s.7 2.5-.2 2.7c-.8.3-1.7.2-1.7.2l-2-.2zm10.7-3.2s5 3 5.4 2.5c.5-.5-1.2-7.5-1-8.2.3-.6 4 7.9 2.2 9-1.4 1-2 .3-2 .3l-2.5-1.3zm13.8 12.6 1 .5.7.2-1.4.2-.3-1zm-4.8-16.4.7.3.7.3s-.4.3-.6.2h-.4zm-1.4-2.5s.5.3 1.1-.2c.7-.4.7-.8.6-1 0-.2-1-.2-1.4-.5-.3-.2-.3-.6-.3-.6h-1.1l-.4.1zm4.3 14.4s1.5 1 2 1c.4 0 1.1.5 1 .6 0 .1-1.2.2-1.8-.1-.6-.3-.7-.1-.7-.1zm-8.1-22.5h.6c.3 0 .5-.2.6 0 .2.2 0 1.2-.3 1.5l-1 .5a48.4 48.4 0 0 1-1.6-2.2zm-7.1-6.4h1.5c.5 0 1 .3 1.5.6.4.3.9 3.3.6 3.8-.2.6-3.6-2-3.7-2.1 0-.3-1.5-2.5-1.5-2.5zm-3.2-1.4s2.5.2 2.2-1.3a3.2 3.2 0 0 0-1.3-2.3l-2.9 2.1zm-6.5-2.8s.7.4 1.4 0c.7-.2 2.6-2.7 4-3 1.4-.3 1.7-.3 2 0 .2.4 0 1.8-.2 2.2-.3.4-4.4 2-4.4 2l-1.5-.1a9.6 9.6 0 0 1-1.3-.5zm-.7-4.5c-.7-1.4-1.7-2-2.2-1.9-.4.1 1.4 1.5 1.7 3.5.3 2 .2 3.3.2 3.4l.8.1.2-.7.1-.5v-.5l-.1-1-.2-.9-.2-.6zm-5.8-2a15.4 15.4 0 0 0-5.5-3.7c-.2 0 4 2.5 5 4 .9 1.7.9 3.9 1.3 4.2.4.3.8-.2.9-.2 0 0 .3-.5.2-.7l-.2-1-.7-1-.4-.8zm-5.5-2.3c-2.4-2-6.6-3-10-3-3.5-.2-5.3.2-4.8 2s2 2.8 5 2.8c2.9 0 3.6-.3 5.2.2a9.7 9.7 0 0 1 3.6 2c.5.5-1.1-1.5-2.6-2.6-1.5-1.2-2.5-1.7-2.5-1.7s-.3-.7 1.7-.4c2 .3 4.7 1.6 5.5 3.3.7 1.7.6 2.6.6 3 0 .3.7-.2.7-.2l.3-.9s0-.6-.3-1.4c-.4-.7-.5-1-1.4-2-.9-1.1-1-1-1-1zm-9.6 28.5c1.5 0 4.8-2.8 5.2-6.7.5-4-1.9-11.9-2.5-12.7-.5-.9 1-.4 1.7.4a25 25 0 0 1 2.5 10.6c0 4.2-.8 5.3-3 7.5-2.2 2-4 1.8-4 1.8zm5.1 11.6s.7 1 1.6.6c1.5-.5 3.8-1.7 3.8-3.8 0-1.4-1.8-2.7-1.9-3.2v-1l1.6.4.5 2.2s.6.7 1.3.4c.6-.2 2.5-1.6 2.2-3-.3-1.2-2-2.9-2.2-3.5-.2-.7 0-1.2 0-1.2l1.6.2.4 2s.4.6 1.3.4c.8-.1 2.4-1.7 2-2.5l-1.5-2.6v-.9l.5.4s.6.2 1.8-.1c1.1-.4 2.3-1.2 2.3-2s-1-1.6-1-2v-.6h.8l1 1.2.1 1.4-.3 1.2-1.4 1.6-1.4.6h-.4l.8 1.4-.2 2-1.3 1.2-1.7 1-.1 1.9-1 2-2 1.2h-.7l-.2 1.2-1.4 2-2.3 1.5-1.7.3-1-1.4z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#d2a567",
      d: "M343.4 191.4s4 1.1 3.8-1.4c0-1.3-3.8-4.5-4-5-.3-.6-.2-1.3-.2-1.3l1.9 1.8s2.5.6 3.2-.9c.7-1.4.1-2.3 0-2.3l.6-.1 1.1.2-.1 2.2-1.3 5.5s.3 2.2-1.4 2.3c-1.7.2-3.6-1-3.6-1m3.7 29.5s0-1.1-.8-2c-.9-.7-2.5-1.4-2.8-1.6a63 63 0 0 0 2.8 3.5zm5.6.2s-2-2.4-2.3-3.3c-.5-.8-1.5-2.6-2.3-2.7-.8 0 .8 3 .8 3l3.2 2.9zm5.4 0-2.1-4.2c-.4-.9-1.3-3.4-2.3-4.1-1-.7.1 1.1.1 1.1l1.1 3.3 1.9 2.9zm3.9-2.4s-.1-2.7-.5-4.6c-.3-1.8-1.7-3.4-1.8-3.3v3.3zm8.1 2-2-4.7c-.5-1.6-1.8-4.1-2-4.2l.4 3 1.7 4.7zm7-8.5s-1.2-1.2-3.9-2.3c-2.7-1-5.4-1.2-5.4-1.2l.3.4 1.3 1 2.8 1.5 3.7.9 1.3-.3z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#202020",
      d: "M348.2 213.8s0 2.4 1.3 3.8c1.2 1.5 4 4 4.6 4.6.6.5 1 3.4 1.9 5.8.8 2.4 1 4.4 1.4 5.1.4.7 1.1 1.8.5 1.7-.5-.1-1-.8-1.4-1.7-.3-.9-.2-.9-.2-2 0-1.3-1.8-7.5-2.7-8.1-.9-.7-4.8-4-6.4-6.3-1.5-2.3-1.2-2.8-1.2-2.8z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#202020",
      d: "M354.6 229.3c-.8-1.7-1-3.3-1.2-4.3a16 16 0 0 0-4.4-4.2c-.6-.3-1.9 0-2.4-.3l-3.7-4s-.5.5-.3.6c.1.1 3.4 3.7 4.6 4.8 1.2 1.2 1.9 3.7 2.7 5.7.9 2 .5 1.6.6 2.5.1 1 .7 1.5 1.3 1.5.6 0 .8-.2.6-.4a10.3 10.3 0 0 1-2.2-3.5c-.7-1.7-1.5-4.9-2.5-6l-.3-.3 1.3-.2c.8 0 4.1 3 4.4 4 .3.8 0 1.2 1.4 4.2s2 3.7 2 3.7h.2s-1.2-2-2-3.8zm-5.2-19.9s2.5 1.5 3.2 1.7a9.8 9.8 0 0 0 1.2.3s.4 4.4 2.1 6.8c1.8 2.5 3.2 3.4 3.2 3.4s0 4.8 1.4 8c1.3 3.3 1.5 7.3 1.2 8-.3.6-1.4-2-2-4.3l-2-6.2a13 13 0 0 0-2.5-4.4c-.8-.7-.2-.6.3-.2.4.4 1.7 2 2.5 4.5s1.1 5 1.5 5c.5 0 .8-.3.8-.9 0-.4-.6-1.8-1-4.1a17 17 0 0 0-1.2-4.7c-.4-.6-1-.7-2.4-3.4a20.3 20.3 0 0 1-2.5-5.3c-.2-1.2 0-1-.2-1.3-.2-.1-.4 0-1.6-.6-1.1-.6-2-2.3-2-2.3"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#202020",
      d: "M355.7 208.5s1.4 1.2 2.3 1.5c.8.4 2 .4 2 .4s-.3 4.2 1.3 6.9 3.3 4.2 3.3 4.2.3 1 .8 6.8l.7 8.3c.1 2.3.2 10.6-.1 10.3-1.3-1-.2-5.4-.9-7.3-.6-1.8-1.6-2.1-2.8-7.4-1.2-5.2-.4-6.4-1.3-8.3-.9-2-2-2.2-2-2.2s1.6.4 2.3 2c.6 1.6.7 6 1.3 8.2 1.2 4.9 2.9 7.4 2.9 7.4s-.4-6.2-.8-9.7c-.5-3.5-.5-6.4-1.1-7.7-.7-1.4-2.1-2.4-3-4.2-.8-1.8-1.1-5.3-1.5-6.2-.4-.9-.6-.6-1.2-.8-2-.8-2.2-2.2-2.2-2.2"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#202020",
      d: "M360.1 206.2s1.3 1.5 3.1 2.6c1.8 1 2.8.7 3 1 .3.2-.3 3.8 1.6 7.2 1.9 3.4 2.6 3.5 2.6 4l.6 13.9c.3 3.4.5 14.8-.9 14.8s-.1-8.5-.8-10.4c-.7-2-.7-1.4-1.3-3-.7-1.6-.7-7.8-1.8-11.5-.8-2.8-1.6-3.2-1.6-3.2s1.4.7 2 3c.6 2.2.8 10 1.5 11.1.8 1.3 1.8 2.8 2 4a157 157 0 0 0-.4-15.6c-.3-1-3.5-6.6-3.7-9.7-.3-3.2-.4-3.5-.7-3.7-.2-.3-1.1 0-2.6-1.5-1.5-1.4-2.6-3-2.6-3"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#202020",
      d: "M367.3 208c0-.3 1 1.7 3.7 2.8 2.9 1.2 5.6 1 6 1.3.3.3 2 4.5 2.1 10.2.1 5.6-1 5.1-1.8 10-.9 4.9-1 14.8-1.5 16.3-.2.5-.5.8-.8 1.7-.3 1 .2 2.8-.7 2.8-.8 0-1-1.4-1-2.1 0-.8 1-3.5 1-6.2s-.6-3-1-6.2c-.4-3.3-.4-13.5-.8-14.5-.3-1-2.1-3.1-2.1-3.1s1.9 1.2 2.4 2.6c.4 1.3.5 12.7 1 15 .5 2.4.3-.5.5-1.8s.9-7 .8-10c-.1-3-1.4-9.4-2.4-10.5 0 0 .5.6 1.1 2 0 .1.4.5.8.7l1 .5s-.6 0-1-.3c-.4-.1-.6-.4-.6-.4a23.9 23.9 0 0 1 1.3 8c.1 5.2-.7 16.4.1 16.5.8.2.7-6 1.5-11.2.8-5 2-5.8 1.6-9.9-.3-4.1-1.4-8.6-2.3-9.2-.9-.5-3.4-.3-5.6-1.8-2.2-1.4-3.4-2.9-3.3-3.2m-35.8 5.7s.8.4 1.7 0c1-.5 3.5-2.5 3.5-3.3v-1.6s0 .3.7.4c.8.1 2.8-1.4 3-2.4a8 8 0 0 0-.1-3.1c-.2-.4.6.3 1 0 .4-.4 2.4-1.7 2.4-3 0-1.4-1.1-2.6-1.1-2.6s1 .2 1.6 0c.5-.1 2.5-1.3 2.4-2.4 0-1.2-.7-3-2.3-3.2 0 0 1.2.3 2.3-.1 1-.4 1.5-1 1.5-2.3 0-1.2-2.3-4-2.6-4.2-.4-.2 2.4.8 3-.3.8-1.1.9-1.9.7-2.5-.2-.7-.8-.8-.8-.8s1.2.3 2.8-.5 3-2 3.8-1.9c.8 0-2.3 1.7-2.5 2.6 0 .4.9 1 2.3 2 0 .1 0 .2.2.3.7.3 3 .4 3.3.5.2.2-2.4.1-2.2.3a34.1 34.1 0 0 1 5.7 5.4c.1 0 .5.4 1 .5l1.3.3h-1.6a65.3 65.3 0 0 1 3.3 4.7c0 .1.4.6.9.8.5.2 1 .1 1.1.2.1.2-1.4 0-1.3.2a82 82 0 0 1 3.3 6s-3-5.3-6.7-9.5c-3.8-4.2-4.7-4.7-4.8-4.4-.2.4 2.7 4.1 4.3 6.7 1.6 2.6 3 5.9 3 5.9s-3.7-7.8-9-12.6c-5.2-4.8-5.8-5.5-6.3-5.4-.6.2-1 3.8-.7 4.5.3.7 4.2 3.6 7.4 7.5 3.3 3.8 7.5 10.4 7.5 10.4s-3-4.7-8-10-6.9-6.6-7.3-6.5c-.4 0-.4 1-1 1.8-.6.7-1.8.6-1.8 1s4.2 4.3 5 4.7c.9.5 1.4.3 2 .6l1.4 1-1.6-.5c-.6-.2-1.3-.3-1.3 0s3.5 4.3 4 4.6c.6.3 1 .1 1.7.4.8.3 2 1.1 2 1.1s-1.3-.7-2.1-.8c-.9-.2-1.2 0-1.2.2s2.6 3.6 2.5 3.6c-.1 0-4-4.6-7.3-7.5-3.3-3-4.8-3.6-5-3.5-.2.1 0 1-.9 1.3-.8.3-1.5.4-1.5.7 0 .3 3 3 5 5.4a149.4 149.4 0 0 1 4 4.5l-4.5-4.3c-2.3-2.2-3.5-3-3.8-3-.2.2-.2 1.3 0 1.6.2.3 4.6 5.4 4.4 5.5-.1.2-5-6-5.4-6-.3 0-.5.7-.8 1-.4.4-1.8.4-1.8 1 0 .4 7 7.3 6.9 7.5 0 0-5.8-5-6-4.7-.2.3 2.4 5 2.2 5.2-.1 0-3.4-5-3.7-5-.3 0-.2.6-1 1.3-1 .8-2 .4-2 .8 0 .3 4.8 5.7 4.7 5.8-.2.1-5-5.1-5-4.8-.1 0-.4.3-.2.7.3 1.3 1.4 3.6 1.3 3.8 0 0-1.6-3.2-2-3-.4 0-.4.7-1.2 1.1-.7.5-1.3.4-1.3.7 0 .3.8 1 1.2 1.7.4.7.7 2.4.7 2.4s-.5-1.4-1.1-2.3c-.7-.9-1.3-1.5-1.9-1.5s-.8.5-.8.5z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#202020",
      d: "M377 212s1.5 0 1.7-.4c.2-.3-.6 0-2-1.6s-5-12.1-9-17.4c-6.6-8.7-12.7-12.7-12.7-12.7s7.3 4.2 13 12.4c5.6 8.4 7 14.9 8.6 16.6 1.6 1.7 3.2 2 3 2.5 0 .5-.3.8-.9 1l-2 .1zm-48-2.2.3.1c.3 0 2.3-1.9 2.2-2.5 0 0-1-.3-1.6-1-.7-.8-.9-1.9-.9-1.9s.7 1.3 1.2 1.6c.6.4 1.4.6 1.8.3.3-.2 3.2-2.4 3-3.2 0 0-.9 0-1.8-.6-.8-.6-1-2-1-2s.6 1.1 1.5 1.5c.8.4 1.7.3 2 0 .2-.3 2-3 1.8-3.7 0 0-1 0-1.8-.5-.9-.6-1.3-2.2-1.3-2.2s.6 1.3 1.7 1.5c1.1.3 2-.4 2.2-1.2.2-.8.8-3.7-.2-4.5 0 0-1.4.5-2.4 0-1-.6-1.4-1.9-1.4-1.9s.9 1.2 2 1.4c1.2.1 1.7-.5 1.9-1a5.9 5.9 0 0 0-.1-3c-.4-1-1.1-.8-1.3-2.2 0 0-.3.5-1.8.5s-2.3-1.6-2.3-1.6 1.2 1 2.4 1a1.9 1.9 0 0 0 1.6-1.9c0-.7-.6-1.4-1-2.1-.2-.8-.3-1.7-.5-1.6-.2 0-.5.8-2 .6-1.5-.3-1.8-1.3-1.8-1.3s1 .7 2 .7c.8 0 1.3-.5 1.3-1 0-.6-.3-1.7-2.2-3.3a58.1 58.1 0 0 0-3.5-2.7 21.8 21.8 0 0 0 6.6 5.3s1.7.6 2 0c.1-.6.1-1.4-.5-2.4-.5-1-2-2.6-2-2.6s1.6 1.3 2.3 2.7c.8 1.3.4 2.2.5 2.6 0 .3 3.3 1.6 4 1.1.8-.4.5-1.4-.2-2.3l-1-1.8s.7.8 1.2 1.8c.6 1 1 1.7.8 2.1-.2.5-.6.7-.6.9l2.3 1.3c1 .6 2.3 1 2.5.8.2-.4.3-1.1.2-2.2-.1-1-.7-2.7-.7-2.7s.7 1.6.8 2.7-.1 2 .1 2.4c.3.4 1.1.5 1.1.5s-.6.4-2 0c-1.5-.4-7.7-3.6-8-3.3-.3.4 2.9 2.3 4.3 3.7 1.5 1.3 2.2 2.8 2.2 2.8s-1.1-1-2.2-1.6c-1.1-.6-4.4-2.3-4.7-2-.2.2 1.3.5 1.4.7.1.3-1 1.3-1 1.8 0 .4 4.7 3.7 4.5 4-.1.4-1.2 1.3-1.4 1.2-.1 0-2.5-1.8-2.5-1.6s1.4 1.5 1.4 1.7c0 .3-1 .8-.8 1.4.2.6 2.6 2.6 2.6 3.3 0 .7-1.4 1.3-1.1 1.7l1.5 2s-1.4-.9-1.8-1.4c-.4-.4-1.3-1.5-1.5-1.3-.1.1-1 2-1 2.5.2.4 1.3 1 1.5 2.3.2 1.1-.2 2.4-.3 2.4 0 0-1.6-2-2-2.1-.2 0-.6.1-.9.6s-1.2 2.1-1 2.4c0 .3 1.6.7 1.6 1.9a3.4 3.4 0 0 1-1 2.3l-2.1-2.4c-.2 0-2.2 2.3-2.3 2.6 0 .2 1.4 1.3 1.2 1.7-.3.4-1.3-.2-1.8.1l-1.7.7c-.2 0-.5-.6-.5-.6"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#202020",
      d: "m355 180 .5-1c.3-.3 1.5-1.7 1-2-.4-.2-2 .3-3 .2-1 0-1.7.2-4.6-2.3 0 0-9.3-6.4-23.6-7.3-4.6-.2-6.6 1.4-6.8 2.2 0 .2 1.2-1.8 5.7-1.7 2 0 16.5 1.1 24 7 .4.3 2.9 2.7 5.2 2.4 2.3-.2 2.8-.5 2.7-.2 0 .4-.7 1.2-.9 1.6a9.2 9.2 0 0 0-.3 1.1zm-25 2v-.2c-.2-.4-1.1-1.7-2.7-3.1a37.4 37.4 0 0 0-8-4.3c-.3-.1 6 2.9 7.7 4.5z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#d2a567",
      d: "M330 192.2s-.4-.6-1.7-1.4a9.9 9.9 0 0 0-2.5-1.1l3 .7a4.8 4.8 0 0 1 1.1 1.8zm-.8-5.3s-.4-.6-2.1-1.2-2.2-.5-2.2-.5 1.6-.7 2.8 0a2.7 2.7 0 0 1 1.5 1.6zm-1-4.5s-.4-.8-2-1.3c-1.5-.6-2.6-.7-2.6-.7s1.6-.4 3.2.2c1.5.6 1.4 1.8 1.4 1.8m-2-2.8s-.4-.6-3.3-1.3c-3-.7-4-.7-4-.7s4.1-.4 5.2.1c1.1.5 2.2 1.9 2.2 1.9zm-5.3-3s-1.8-.6-3.5-.7-4.4.1-4.4.1 5-.8 6.3-.5c1.4.3 1.6 1 1.6 1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M304.5 238.4s.9 1.6 2.6 1.6c1.8.1 3.1 2.6 3.1 2.6l-1.9 1.9-4.6.2-1.5-2.4zm0-1.6c.2-.3-1.3-3.3-2.4-3.8-1-.5.4 1 .2 1.6-.3.6-.4 1.4-.3 1.5 0 0 .9 1.4.4 2-.4.5 2.2-1.3 2.2-1.3z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M303.8 241.4s.8.4 1.4.2c.7-.2 1.3-.9 1.3-.9m-3.6-.5s2.6-1.9 2.4-2.9c-.2-1-.7-1-1-.9a7 7 0 0 0-2.1 1.7c-.1.3.7 2.1.7 2.1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M301 241.5s.6 1.3 1.4 1.3c.8 0 2-.7 2-1.2.1-.5-.8-1.5-1.3-1.7-.6-.3-1.9.4-1.9.4z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M303.4 239.8c0 .4-1.7 1.2-2.3 1.2-.5 0-1.6-1.3-1.2-1.5l1.5-.4c.4-.2.5-.8.7-.8.3 0 1 .1 1.1.5.2.5.4.6.2 1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M301.8 240.9s-2.6 3.4-3.7 3.3c-1-.2.5-5 .5-5l1.2.6c.9.2 1.7.6 2 1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M297.2 238.4s3.3.6 3.4 1.1c.2.6-1.5 1.3-2.5 1.3-.9 0-.9-2.4-.9-2.4z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#202220",
      d: "M289 243.4s.5 1.6 1.9 1.7c1.4 0 2.8-1.5 2.8-1.5l-3.4-1.3z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#4b4139",
      d: "m289 243.4.4.9c.3.4.7.8 1.5.9h.1c1.4 0 2.7-1.6 2.7-1.6l-3.4-1.4zl1.3-1 3.3 1.3v-.1l-.2.2c-.4.4-1.4 1.2-2.4 1.2h-.1a1.8 1.8 0 0 1-1.4-.8 2.8 2.8 0 0 1-.3-.6v-.1l-.1-.1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#202220",
      d: "M290 243s.5 1.2 2.4 1.2 3.3-1.5 3.3-1.5l-3-2.3z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#4b4139",
      d: "M290 243s.5 1.2 2.4 1.3c2 0 3.4-1.5 3.4-1.5l-3-2.5-3 2.7zl2.8-2.5 2.9 2.3v-.1a5 5 0 0 1-3.2 1.4 3 3 0 0 1-2-.6 2.2 2.2 0 0 1-.3-.4 1.1 1.1 0 0 1-.1-.1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#4b4139",
      d: "M290.2 243.3s.9.6 1.8.7c1 0 2.2-.3 2.2-.3l-1.1.4-.8.1-.8-.1-.6-.3zv-.2z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#202220",
      d: "M292.4 241.6s.8 2 2.6 1.8c1.7-.2 1.7-1.2 1.7-1.2l-2-2.8z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#4b4139",
      d: "m292.4 241.6.5 1c.4.4 1 1 1.8 1l.3-.1c.8-.1 1.3-.4 1.5-.7.3-.3.3-.6.3-.6l-2-3zl2.4-2.1 1.9 2.7c0 .2-.3 1-1.8 1.1h-.2a2.2 2.2 0 0 1-1.7-.8 4 4 0 0 1-.4-.6v-.2a1.5 1.5 0 0 1-.1-.1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#4b4139",
      d: "M292.6 242s1 1.3 2 1.3a3 3 0 0 0 1.5-.4v.1l-.5.3-.8.1h-.8l-.7-.5zm-3.2 2s.8.9 1.5.9a4.7 4.7 0 0 0 1.9-.6h.1l-.2.1-.8.4-.9.3-.7-.1-.6-.4-.3-.4z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M297 238.3c.8-.2 2.4 2 2.4 3.2s-.5 2.7-1.3 2.7-2.6-1.7-3-2.5c-.4-.9-.8-1.4-.5-1.9.3-.4 2.4-1.5 2.4-1.5zm-8 .2s-1.4-1-1.9-.5-.3 2.3 0 2.6c.4.4 2-.8 2-.8z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M288.8 239.7s-1.8.2-1.8 1 .9 1.6 1 1.8c.2.1 1.8-.7 1.8-.7z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M289.5 241.1s-1.8.6-1.8 1.2.8 1.7 1.3 1.7 1-1 1.2-1.3c.3-.2-.7-1.6-.7-1.6zm.8-5.1s-.3-.5-1-.2c-.8.3-1.6 1-1.5 2.3.1 1.1.6 2 .6 2l2.7-1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M290.5 238s-2.2.8-2.3 1.7c-.1.9.5 1.7 1 2 .7 0 2.6-1.8 2.6-1.8z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M292.5 241.7s-2.2 1.5-2.5 1.5c-.3 0-1.2-1.2-1-2 .2-.8 1.7-1.3 2.3-1.6.6-.2 1.2 2.1 1.2 2.1zm2-8.2s-.7-.6-2-.5c-1.4.1-2.4 2-2.6 2.8-.2.9 0 2.6.5 2.8.5.3 3.3-2 3.3-2l.8-3z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M291.8 240.3c-1-.1-1.8-1.5-1.7-2.3.2-.8 2-2.2 3-2 1 .1.8 2.5.8 2.5s-1.2 1.9-2.1 1.8z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M294.7 240s-.4 1.2-1.4 1.7c-1 .4-1.5 0-2-.7-.6-.8.2-1.2.6-1.6.5-.4 1.7-.7 1.7-.7l1.1 1.4z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M293.2 237.2s-1 .8-.4 1.8 1 1.4 1.8 1.5c.8.1 1.3-.2 1.9-.9.6-.7 1.5-1 1.4-2-.1-.9-.4-1.6-1-1.8-.5-.3-2.2 0-3.7 1.4z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#202220",
      d: "M296.2 233s-1-.5-1.9 0c-.8.5-1.4 1.5-1.5 2.4l.2 2.3s1.2-.4 2-1c.7-.6 1-.8.8-1.1 0-.2-.4-.4-.4-1.2 0-1.4.8-1.5.8-1.5z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#4b4139",
      d: "M296.2 233s-1.2-.3-1.9.1a3.2 3.2 0 0 0-1.3 1.9c-.3.8-.1 1-.1 1v-1.4c.4-.8 1-1.5 1.6-1.7.8-.3 1.7 0 1.7 0z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "m328.8 257 1.6-.8 2-1.2.4 2.2-1.8 1.4h-1.5l-.9-.7.2-1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M326.4 257.2h1c1.1 0 1.2-.3 1.4-.3.2.1.5 1.3.5 1.3l-.4.7-1.5.9-1.3-.8-.1-1.8zm12.1-.8s-.3-.5-.9-1l-2.2-1.9v5l2.3-.1 1.1-1.5z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M326.4 257.2s-.4-.5-1.3-.4c-1 0-2 .9-2.1 1.5-.1.7 0 2.6.5 3 .5.4 1.2.5 2.2.3 1-.3 6.4-3.6 6.4-3.6l-1.4.3c-.7.2-1.4-.1-1.4-.1s-.7.8-1.6 1c-.8 0-1-.5-1.2-.9z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "m330 258.9-1.2.5-1.3.6.4 1.6 2.3.5 1.4-1.1v-1.6l-1.7-.5zm10.4-1.2-.8-.8c-.4-.4-1-.5-1-.5l-1.3 1.5v1l1.2.7.9.2 1.1-.8z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M332.6 257s-1 .4-1.5.8l-1.2 1c0 .2 1.1 1.4 1.1 1.4l1.2.1 2.5-1.7-.2-1.6zm9.5 2-.5-.7c-.4-.4-1-.6-1.2-.6-.3 0-1.3 1.5-1.3 1.5v.4l.8 1 1.6.5 1.1-1.2z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.3,
      d: "m338 260.8 1.2.2s0 .3.3.5c.3.3.3 0 .3 0s.2 1.2 1.4 2c0 0 1.4.6 2 .2.8-.4.7 0 .7 0l2-2.4s0-.5-.5-.5c0 0 .4-1.6-1-2-1.2-.2-2.2.2-2.2.2s-1 1.8-1.6 1.6a2.4 2.4 0 0 1-.8-.5l-.7-.9s-.4.1-.9-.2c-.5-.3-.9-1.1-.9-1.1s-.7-.1-1-.4l-.5-.8-1.9 1.4s0 .5-1.1 1.3-1.7.8-1.7.8-.4 1.7-1.6 1.4c-1.2-.3-2-1.6-2-1.6s-.9-.2-1.4.6c-.6.7-.9 1-.9 1.7 0 .8.5 1.8 1 2.2.3.3 1.5 1.3 3 .6 1.4-.8.9-2 .9-2l.8-.5c.9-.6 1.8-1.5 2.5-1.7"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeWidth: 0.3,
      d: "M335.8 250.8v3.2s.4 2.9-.2 3.7c-.6 1-2.9.7-3.2 0-.3-.8-.2-3.2-.2-3.2z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f8c83c",
      stroke: "#977c2e",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.3,
      d: "M333.3 260.5s-.5.8 1 1c.4 0 .7-.2.9-.4.4-.4.3-.8.3-.8s-.2 1.2 1.2 1.2c1.4.1 1.3-1.3 1.3-1.3"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#202220",
      d: "M321.2 263.1s-.8-1.4.1-1.9c1-.5 1.5 0 2.1 0 .6 0 .4-1.4.3-1.7a3.7 3.7 0 0 0-.7-1.2c-.2-.2-3.5.2-3.4 2.3 0 2.1 1.6 2.5 1.6 2.5m5 5.2s-1-1.5-.4-2.4c.5-.9 1-.3 1.2-.4.3 0 .4-.6 0-1.6-.5-1-1.1-1.4-1.4-1.5-.4 0-2.3 1.4-2 3.2a3.5 3.5 0 0 0 2.6 2.7m18.2-1.8s3.5 1.5 3.7-2c.2-2-1.5-3.3-2-3.3-.4 0-.7.3-1.3 1-.7.8-1.1 1.3-.9 1.6.3.3 1.3-.3 1.8.8.7 2-1.3 1.9-1.3 1.9"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#4b4139",
      d: "M326.2 268.3s-2.7-.6-2.7-3.3c0-1.8 2-2.6 2-2.6s-1.8 1-1.8 2.6c-.1 2.7 2.5 3.3 2.5 3.3m-5-5.2s-1.6-.3-1.7-2.6c-.2-2.3 3.5-2.2 3.5-2.2s-3.5.2-3.4 2.4c.2 2.2 1.6 2.4 1.6 2.4m23.2 3.4s.7.3 1.5.3 1.8-.3 2-1.6c.4-1.3.3-2-.6-3.1-.6-.9-1.2-.8-1.2-.8s.6 0 1 .8c.6.8 1.3 1.6.8 3.1s-2 1.5-2.5 1.5a5.5 5.5 0 0 1-1-.2"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#904720",
      d: "m302.6 192.4-.6-.2.4-1 1.9-.7 1.8-.1 2-.1.8.6 1 2.3-3.6 2.2-.6.2-.2-1-.6-1.4z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#202020",
      d: "m337 245.5-.3-5.5-14.8 4.6 5.8 5.5z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#d2a567",
      d: "m309.4 235.9-1.2-1-1.4-.8h-1.1l-.2.3.2.5 1.3 1.6 2.3 1.2.8.7.5.2-1.1-2.7zm-.3 2.3.8.2.9 1 .5 1 .7 1.3.2.8-1.6-.3-4.8-1.5.4-1.2.8-.7.7-.3 1-.2z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#d2a567",
      d: "M312.2 242.2h.8l.6-.5-.3-1.8.3-5.8-3.9-4.6-.8 2.6 1.1 4.7.9 2.8z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#ab6d29",
      d: "M309.4 231.7s-.2.4.1 2c.3 1.5.9 4.9 2.2 7.2l-1.3-1.9s-2-4.6-1.7-8.2c.3-3.5.7.8.7.8zm2.9 2.9s-.9 1-1 1.9v2.2s0-1 .8-1.3c.9-.3.7 2.3.8 2.6l.5-4.7zm.4 9.6-4.4-1c-2.3-1-3.5-1.8-3.4-2.3 0-.6 4 .1 4.6.2l2.4 1h1l1.9-.8.2 2zm-7.3-.8s1 .8.5 1a4.4 4.4 0 0 1-2.3.3l4.2 1 .9-.7z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#d2a567",
      d: "M304.2 242.2c.2-.2.3.7 1.8.8 1.5.2 2.2-.2 2.2-.2l.7.4.8.2-.7 1.1-2.8-.8-1.5-.8z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#ab6d29",
      d: "m314 240.3.8 1 .5-2.4v-2.5l-1.6-1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#4d2a15",
      d: "m309.7 236.1-1.3-2.1-1.7-3.1 1-1.8 1.3 1.8s-.4 1.3-.1 2.5c.2 1.2.8 2.7.8 2.7"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#d2a567",
      d: "M300.8 244s.6-.9 1.9-1a7.6 7.6 0 0 1 2.4.2l2.6 1.4.6.9-5-.7z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8f4620",
      d: "m314 235 .2 4c0 1 .7 2 .6 2.3-.2.4-.4.6-1 .9-.6.2-2 0-2 0s1.3-.2 1.4-.5c0-.2-.4-1.4-.5-2.4 0-1 .1-2.2-.3-2.2-.3 0-.7.4-.8.6 0 0 .4-3.8.8-4.2.4-.4 1.6 1.6 1.6 1.6z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#ab6d29",
      d: "M304.7 243s-.5-.4-.5-.8c0-.3.6 1.6 3.4 1.5 2.8 0 2.6-.2 2.6-.2h1.3s-.3 1.3-.5 1.4a61 61 0 0 0-2.2 1.4l-.7.4v-.2l-.3-2.1-2.4-1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8f4620",
      d: "M309.7 236.1s-3.2-3.3-4.3-5.5c-1-2.2-.4-5.2-.4-5.2l3 4s-.4.7-.3 2c.2 1.2 2 4.7 2 4.7"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#ab6d29",
      d: "M307.6 248.3c0-.3-.2-1 .4-1.8 2-2.4 6.8-4 6.8-4v2.8l-6.2 3z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8f4620",
      d: "M308 246c.3-.1 1.4-1 1.4-1.3 0-.4-.7-.4-2.1-.7-1.5-.3-2.6-1-2.6-1s1.7 1.4 2.4 1.7c.7.2.6.5.5.7zm8.3.7s-.9-1.3-1.2-2.1c-.3-.8-.3-2.1-.3-2.2l-1 .7-2 .7s2 0 2 .6c0 .7-3 1-3 1 0 .1 2.4-.4 2.3.1-.2.6-1.2.7-2.5 1.2l-2.3 1-.7.5s.6.4 1.5.3c.9 0 2.9-.5 2.9-.5l3.8-1.5z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#ab6d29",
      d: "M316.3 246.7s-1-.3-1.8-4.8-.6-5.7-.6-5.7l1.8 1.3 1.7 3z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8f4620",
      d: "M316.9 239.3s-.9 2.5-.9 4c0 1.4-.1 2.4.3 3.4s1.8 2.3 1.8 2.3l.7-.6.3-2 .1-3.4z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#202020",
      d: "M319.4 242.7s.4 6.3-1.2 6.5c-.7 0-1.9-2.4-1.9-2.5 0 0 1.4 2.3 2 2.1 1-.4.6-6.6.6-6.6zm-3.1 4s-.3 0-.7-.8c-.4-.7 0 .6-3.4 1.8-3.4 1.2-4.6.5-4.6.5s1.1 1 4.5 0 3.1-1.3 3.6-1.4z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#ab6d29",
      d: "M310 238.7s.6.5 1.2 1.7a363.3 363.3 0 0 0 1 2h.2s-.4-1.3-1-2.2l-2.2-3.1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8f4620",
      d: "M308 246.5s.3-1.1 0-1.4c-.3-.2-.7 0-3-.2a34 34 0 0 1-4.2-.9s1.6 1 3 1.4l3.5.8.5.1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#202020",
      d: "m308 246.5-.2-.5c-.3-.3-.7.1-3.5-.7-2.8-.7-3.5-1.3-3.5-1.3s1 1 3.4 1.5z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#ab6d29",
      d: "M309.3 238.2s-2.1.1-2.8.7c-.7.5-1.6 2-1.6 2l1.3.1s-.1-1.2.5-1.9c.7-.6 1.7-.7 2.6-.9"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8f4620",
      d: "M305.3 234.2s.8 1.2 1.7 1.5c.9.4 1.8.8 2.2 1.2.4.4.9 1.8.9 1.8s-3-1.3-3.7-2a9.6 9.6 0 0 1-1.1-2.5"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8f4620",
      d: "M308.2 235s-.3-.5-1.1-.9-1.4-.3-1.7-.1-.1.2-.1.2l1 1.7.7-.2s-1.6-1-1.3-1.3c.8-.7 2.5.5 2.5.5z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#202020",
      d: "m316.3 231.1 17-8.7 8 11.1-14.7 4-7.7.6-3.8-2.7z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#4d2a15",
      d: "m339 235.9 21 18.2-2.3 1.6-5-1.4-10.2-10.1-3.8-3.8z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#4d2a15",
      d: "m366 250.5-12-9.1-15.3-11.5.4 5.5 17.4 16 5.7 2.7 3-.8 1.4-1.6z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#803f1d",
      d: "M339 237.6s6 6.9 10.6 10.4 9 7.3 10 6.7c.8-.5.5-1 .5-1l-21.3-17.5z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#4d2a15",
      d: "m353.8 255.1-2.1 1.7-2.5-1-13-13.2.7-2.5 1.8.3z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#202020",
      d: "M366 250.5s-1.6 3.8-5 2.9c-3.4-.9-22-18.5-22-18.5v1.8s18.8 17.3 22.5 18c3.6.7 6.6-2.5 6.2-2.8a43.7 43.7 0 0 0-1.7-1.4"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#803f1d",
      d: "M336.9 240.4s6 7.7 9.1 10.5c3.2 2.9 6 5 7.2 4.8 1.3-.2-.7-1.7-.7-1.7l-9.1-9-4.7-4.6s-1.8-.7-1.8 0"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#202020",
      d: "M338.4 240.4s15.2 15.5 16.4 15.9c2.5.7 6.2-2 6.2-2l-1.3-.7-.2.5s-.7 1.6-4 .9c-3.2-.7-16.6-15.1-16.6-15.1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#4d2a15",
      d: "m344 255.3-5.5-6.4-1.2-2.1-.3-2.7 11 11.1-1.5 1-1.4-.4z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#202020",
      d: "M354.1 255.5s-1.3 2-3.2 1.6a5.4 5.4 0 0 1-2.8-1.7L337.5 245l-.3-1.6s11.7 12.3 13.7 12.8c1.6.4 2.7-1.4 2.7-1.4z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#202020",
      d: "M348.2 255.1s-.5 1.6-2 1.4c-1.6-.3-2-.9-2-.9l-6.6-7.7-.1-2s6.8 9.3 8.3 9.8c1.6.5 2-1 2-1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#b07229",
      d: "M341.3 234.9s6.3 5.4 6.8 5.6c.5.3 2.7.4 2.8.7.2.3-1.4 0-1.5.3-.1.4 3.2 3 3.7 3.1.5 0 3.2 0 3.1.4 0 .3-1.8 0-1.9.4 0 .4 2.9 2.7 3.4 2.8.5 0 3.9 0 3.9.4 0 .3-2.7 0-2.7.5.1.6 4.6 3.4 4.4 3.8-.2.4-5.4-3.5-5.5-3.3-.2.2-.4 1.4-.7 1.6-.3.2 0-1.6-.2-2.4-.3-.8-3.4-3.1-3.7-2.9-.3.3 0 1.7-.4 1.7s.1-1.7-.2-2.3a16 16 0 0 0-3.6-3c-.4 0-.1 1.3-.4 1.5-.3.2-.2-1.5-.6-2-.4-.5-7-6.5-6.7-7z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#4d2a15",
      d: "M330.5 252.3s0 2.4-1 2.8c-1.1.3-3.1-4.4-3.1-4.4l-.5-4.4 3.1 3zm8.4-1.2V250c0-.6-.3-1.5-.3-1.5l-.2-2.4-.6-1.7-.4-1h-.7l-1.7 1.2-.5 1.6.8 3 .8 2.7 1.3.4 1.5-1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#4d2a15",
      d: "M336.8 255.3c.3-.1-.4-3.4-.4-3.4l-2-4.8-.5-1.7-1.5-.6-1 1.2.2 1.9s1.5 3.2 2.2 4.3c.8 1.1 2.3 3.3 3 3.1"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#202020",
      d: "M335 245a6 6 0 0 1 1.4 2.6s1.3 3.6 1.1 4c-.2.3-1 .3-1 .3s1.8 1.8 2.3 1.6c.5-.2.3-2 .1-2.4-.1-.4-.7 0-1-.5-.1-.4-.8-2.7-.8-4.2v-2.7c.2-.3 1.5 3 1.5 4.7l.6.7-.6-3.2-.7-2.3c0-.2.3-.8.3-1.5v-1s.6.5.9.5c.3 0 .7-.4.8-2 .2-1.5-.1-6-.1-6l-6.8 9z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#202020",
      d: "M335 244.3s-.3 2.4.6 4.8l1.3 3c.2.3.2 2.9-.1 3.2 0 0-1.8-4.4-2.4-6.6-.5-2.1-.7-3-1-3.2l-.8-.2z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#4d2a15",
      d: "M334.4 257c.2 0 0-1 0-1l-.2-2.3-2.4-4.9-2.6-2.3-1.4-2-.2 4s2 4 3.1 5c1.3 1.2 3.3 3.6 3.7 3.5"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#202020",
      d: "M324.7 246s.4 1.1.4 1.8v1.4l1.8 3.5c.9 1.5 1.7 3.1 2.4 2.8.7-.4 1-1.5 1-1.7.1-.1-.8 1.3-1.2 1.1a40 40 0 0 1-2.3-6.6l-1-.8a18.4 18.4 0 0 1-1.1-1.4zm7 5.5-1.7-3.1c-.5-1-1.2-1.7-1.4-1.7-.2 0-.5-2-.5-2s.7 1.3 1.6 1.7c1 .5 1.5.8 2 .7l.2 2z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#5c3a1d",
      d: "M327.4 248.3s.5 1.4 1.4 2.7c.8 1.3 2.3 2.9 2.3 2.9s-1.6-1.6-2.5-2.8a14 14 0 0 1-1.4-2.8z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#202020",
      d: "M332 246.7s.5-1.2.8-1.3l1.2-.3s-.7-.1-1.2-.8l-1.3-1.3.4 2zm-.4.4s2 4 2.4 5.5c.5 1.3.4 3.4.4 3.4s-.2-1.5-.6-2.7l-2.4-5c-.1-.3.2-1.2.2-1.2"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#4d2a15",
      d: "m334.2 244.4.5-6-.5-2.2-2.7-6s-.1.8-.8.8a6.2 6.2 0 0 1-3.1-1.8 9.2 9.2 0 0 0-.2 4.8l5.3 9.9z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8b441f",
      d: "M323.8 248.3s.8 1 1.3 1c.4-.2.3-2.1-.3-3.2-.6-1-7-9.6-8-10.1s7 12.3 7 12.3"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8b441f",
      stroke: "#5c3a1d",
      strokeWidth: 0.1,
      d: "M328.1 244.8c.2.4.6 3.1-.5 3.4-1.5.3-8.5-9.4-9.6-10.7 0 0-4.4-2.8-4.5-3.5-.1-.7 4.7 1 4.7 1l9.5 9z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#202020",
      d: "M323.8 248.3s-.8-1.3-.9-2.3c0-1-.4-1.5-.4-1.9 0-.3-5.2-7.7-5.7-8.2-.6-.5-2.3-1.4-2.3-1.4a15.5 15.5 0 0 0 .3 2.4s1.6 3 4 5.7a458.4 458.4 0 0 0 5 5.8z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#4d2a15",
      d: "M331.6 247c.7-.3.4-2.7.1-3.5a458.4 458.4 0 0 0-4.4-9.4l-1.3.4-2.3-1.8-1.4-1.5s.5 2.1.4 3.1v1.6l3.3 5.9zm4.7-5.2 1-1.3-.5-4.4-2.8-9.4s-.7.1-1.4-.3c-.6-.4-1.4-1.3-1.4-1.3l.7 5.7 2.9 8 .2 2.3z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#202020",
      d: "M327.7 244s-2.8-3-3.7-4.5l-1.7-3s-.8.3-1.8 0c-1-.5-2.2-1.8-2.2-1.8s-.8 1.5 3.2 5.6c4.6 4.6 6.2 3.7 6.2 3.7"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8b441f",
      d: "M334.4 245c1.2-.4 1.1-5.4 0-8.7-1-3.3-2.9-6.2-2.9-6.2s2.3 5.4 2.8 7.5c.4 2.2 0 3.7-.4 3.6-.4-.1-.4-1.3-1.3-3.4-1-2-1.6-2.6-1.6-2.6s3.3 8.8 2.3 8.6c-.9-.2-5.3-9.9-5.5-10.2-.2-.2-.4.4-.4.4s4 12.2 7 11"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#4d2a15",
      d: "m337 221.3 2 4.2.6 4.4.2 3.7s0 7.4-.8 7.6c-1 .1-1.4-.7-1.4-.9a2729 2729 0 0 1-1.7-8.3l-1.7-8.5.6-.6.2-1.2 1.3-.1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8b441f",
      d: "M331.6 247c.8 0 0-2 0-2s-.6 1-1.2.3c-.5-.7-1.3-3.1-1.3-3.1l-.5-1.5s-.6 1.6-1.3 1.6-4.6-6.4-4.6-6.4l-.4.6s5.4 11.1 9.3 10.6z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#202020",
      d: "M329.1 242.2s.7-1.6.4-3c-.3-1.5-2.2-5.1-2.2-5.1s-.6.1-1.4-.2a9.6 9.6 0 0 1-2.2-1.2 38.3 38.3 0 0 0 5.4 9.5m3.1-2.3s-.5-3.4-2-6.6c-1.6-3.1-2.6-4.1-2.6-4.1v3.5s1.5.5 2.6 2.4c1 2 2 4.8 2 4.8m4.3-5.8s-.3-3.7-.8-5.8l-1.2-5s0-.2.3-.4h.6c.8.3 1.1 2.2 1.1 2.2l-.1-3.1-.3-.5h-1.4s.3 1-.1 1.3c-.3.3-.6-.2-.7-.3l-.2.4.4 2-.1 1.7s.5 2.2 1.2 3.5c.6 1.4 1.3 4 1.3 4m3.3-.5s.6-5.3-.6-8.7c-1.2-3.4-2.2-4.2-2.2-4.2l-.6.6s1.8 3 2.4 5.6zm-5.4 2.7s-.6-4.1-1.3-6.8a82.8 82.8 0 0 1-1-3.6l-1.1-1s.7 2.7.6 3.6l-.1 1.4s.5 1.4 1.3 2.6a25.5 25.5 0 0 1 1.6 3.8"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#904720",
      d: "M337.2 242.9c1 0 .1-6-.3-7.5-.4-1.6-3-8.8-3-8.8s3 10.3 2.8 10.8c-.3.8-1.5-3.1-1.7-3-.2 0 2.2 6.9 1.3 7-.8 0-1.3-1.5-1.3-1.5l.1 1.5s.6 1.4 2.1 1.5"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#904720",
      d: "M338.5 239.9c.7 0-.2-5.7-.7-8.2l-2-7.5s1.5 3.5 2.3 7.5c.8 4 1.4 9 .6 9.2-.8 0-1.2-.8-1.2-.8v-.9s.3.7 1 .7"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#312317",
      d: "M328.8 246.5c0 .4 0 2.4-1 2.2-1-.1-2.9-1.9-3.3-3 0 0 2.2 2.5 3 2.4.8 0 .8-2.5.6-3.2 0-.6.6 1.6.6 1.6z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#d2a567",
      d: "M334.1 219.5s1.4.9 2.4.3a4 4 0 0 0 1.8-3c0-.8 0-1.5-.7-2.4-.7-.9 1 .7 1 2.3 0 1.6 0 4.3-2.5 5-2.5.5-1.4-.2-1.4-.2z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8f4620",
      d: "M332.1 214.7s1.6 2.6 2.2 5c.7 2.3.5 3.2.2 3.3-.4 0-.6-.3-.7-.9 0-.6-1.7-7.4-1.7-7.4"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#1e2121",
      d: "m304.1 218 10.6 15.3 13.2-15-8.3-8.6z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#4d2a15",
      d: "m317.5 208.5-.6 2.4 1.3 4.1 2.2 2.3 2.5 1.7.6-2 .6-2.2.7-.2 1.6.6 1-1.5 1.8-3.1-.4-1.2-.4-.9-2.7-4.6-.9 1.7-.8.5-1.6-.8-1.8 2.4-2.3-1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#5c3818",
      d: "M323 219s.4-.3.6-1.6c.2-1.2.2-4.9-.1-6.4-.3-1.5-1.3-4.4-1.5-4.2-.2.3 1.5 3.3 1.3 7-.3 3.6-.2 4.6-1 5-.7.3.6.2.6.2z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#5c3818",
      d: "M323.6 212.8s1.7 2.5 2.5 1.6c.9-.9.5-4 0-5.3l-1.2-3 .5-.6.9 3.4c.3 1.4 1.3 5.2.1 6-1.1.6-2.8-1.5-2.8-1.5z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8f4620",
      d: "M317.9 214.6s.6-1 1.4-1c.8 0 1 .3 1 .3l.6 2 1.2 2.2 1 1-.5.6-.9.2-2.5-1.4-.7-1-.6-3z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#d2a567",
      d: "M322 236.3c-.8.5-2.7-.5-3.7-1.4l-6.8-6.7-.8-3.2 2.2.6 3.9-1.7.7-1.3 4.6-2.4 2.6-1.4 5.5-.1 1.4-2.7s1.8 3.2 2.1 4.5c.4 1.4.3 5.4-.2 5.7-.5.3-2.3-1.2-2.6-1.3-.2-.1 1.4 5.7 0 6-1.3.2-3.6-2.2-3.6-2.2s1 5.2-.2 5.2a10 10 0 0 1-5-2.6s1.3 4.3 0 5z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8f4620",
      d: "m321 229.6 1.1 1.7c.3.4 0 2.9-.2 3.4-.3.9-1.6-1.2-2.3-3l-2.2-3.8c0-.4 3.5 1.7 3.5 1.7zm10.8-12.9s2 8.1 1 8.4c-1 .3-3.6-2.6-4-3l-4-6.4-.8-.8.2-.4 1.7.6z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8f4620",
      d: "M317.9 232.3c-.4.3-1.3-1-1.7-1.4l-3-3.3a11.5 11.5 0 0 1-2.2-2.5c0-.3-.8-1.1-.8-1.1l.7-1h.9s5.4 4.2 5.7 5c.4.6.6 4.1.4 4.3m8 0c-.2.3-3.7-2.3-5.2-4.4-1.5-2.2-3-4-3.5-5l-.6-1.9 1 .2s8.8 10.8 8.4 11.2zm1.3-3.7c-.2.3-1.7-.9-2.7-2.1-1-1.3-.4-2.9-.4-2.9s3.3 4.8 3.1 5m2-.5c-.5.3-2.5-2.2-4.2-5-1.3-2-1.6-2.3-1.8-2.5-.5-.3-1.4-.4-1.4-.4l-.2-.3 1-.2.6-.8 1-1.3 4.3 8.5s1 1.9.7 2"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#ab6d29",
      d: "M318.3 234.9c0 .3 0 .6-1.2.5a21 21 0 0 1-9.9-7.8l-3-5 1.1-1.4 9.6 11z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8f4620",
      d: "M318.3 234.9c0 .5-.5.6-1.1.5-.6-.2-3-1-6.9-5.3a33.3 33.3 0 0 1-5.3-7.4l-.2-1.8 1.2-.5 6.5 10z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#4d2a15",
      d: "M324.6 230.6s-2-1.5-3.2-3a24 24 0 0 1-3.8-5.7c.1-.7 1.2-.7 1.2-.7v-1.8l.2-.6 1.9.8 2.3 2.9.9 1.1s1.5 3.7 1.2 4c-.3.3-2.4-2-2.7-1.7-.3.3 2.4 4.4 2 4.7m-3.7-1s.7 1 .4 1.7c-.3.7-.5 1-1.5-.4a16 16 0 0 0-2.3-3c0 .1.1 2.3-.3 2.3-.5 0-2-1.9-3-3.3l-2.5-3.9v-2l-.1-2.5.3.9.4.7 3.6 4.2 1-.7 2.1 4zm-13.5-6.1s2.8 4.8 5.3 7.5a17.4 17.4 0 0 0 5.6 3.9l-8.4-9.9zm21.2 2.8a12 12 0 0 1-3-3.4c-1-1.6-1.9-4-1.8-5 0-1 .4-3.4.4-3.4s2.8 3 3.4 4.3c.5 1.4 1.7 3.3 1.4 3.5-.2.2-2.1-1.3-2.4-1-.2.4 2.3 4.8 2 5m3.2-3c-.3.1-1.8-1.6-2.1-2.6a14.8 14.8 0 0 1-.6-3.2l-1.2-3v-3.3l1.4-.2 1.9 2.7s.7 1.5.7 3.7c0 2.3.3 5.6 0 5.8zm-22.5 8a41.8 41.8 0 0 1-4-6l-1-2.9.5.4s.8 3.2 4.7 7.1c4 4 4.9 4.2 4.9 4.2s.7 2.2.4 3c0 0-2.9-2.6-5.5-5.7z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#202020",
      d: "M313.6 235.9s-3.4-3-6-6.4a46.6 46.6 0 0 1-4.4-6.6l1.2-1a46.3 46.3 0 0 0 9.2 14m4.7-1-6-6.1c-2-2.2-3-4.4-3-4.4l1.6.6s.7 1.7 2 3.5zm-.8-7s-2.1-2.6-3.1-4.2l-2-3.8s2.8 3.3 3.6 3.5c.9.2.9 0 .9 0s-.4 1.2-.1 2.2zm.9-10.6s.3 1.9.1 3c-.2 1-.8 1-.8 1a15.7 15.7 0 0 0 4 4l-1.8-2.7c-.5-1-1.3-2-1-2.8.4-1 2.1.6 2.6 1l2.6 2.8s-.8-2.5-1.8-3.4a53.6 53.6 0 0 0-4-2.9z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#202020",
      d: "m327 222.8-1.7-4.2-1.6-5.2v2.8c-.1 1.2-.5 3-1 3.3-.6.2-.7.3-1.7 0-1-.2.7.5.7.5s1 0 1.4-.5c.4-.5.5-1.5 1-1.4.4.2 1 1.7 1.3 2.4z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#202020",
      d: "M323.7 213.4s2 2.3 3 1.3c.8-1 .3-4 .3-4s1.2.5 1.6.2c.4-.4.2-1.5.2-1.5s2.3 3.2 3.3 5.3c1.1 2 1.6 5.8 1.6 5.8s-1.8-3-2.7-5.8c-.9-2.6-2.1-3.8-2.3-3.5a5.3 5.3 0 0 0-.3 3c.2 1 1 2.1 1.5 3.5l1.1 3.4-1.6-2.5c-.7-.8-1.3-1.2-1.7-1.6-.4-.4-1-1.2-1.7-1.4-.6-.3-1.8-.9-1.8-.4s-.3-1-.3-1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#171717",
      d: "M316.8 223.3a27 27 0 0 0 4.2 6.3s-2-1.8-2.8-3a15.5 15.5 0 0 1-1.4-3.3"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8f4620",
      d: "M330.2 223.9c-.3 0-1.3-.3-1.4 0 0 .4.6 1.8 1.3 2.5.7.7 1 .7 1.1.6.2 0 0-.7-.2-1.4v-1.7c-.1-.3-.8 0-.8 0"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#d2a567",
      d: "m306 209.4-1.3.7-1.4 3 .4 5.3 2.1 3c.8 1.2 3.5 4.2 4.2 4 .7-.2 1.4-2.3 1.5-3.4l.2-3.2 1.8 2.3c1.1 1.3 2 2.4 2.6 2.3.5 0 2-3.2 2-3.6.1-.4-3.8-10-3.8-10l-1.8-1-6.6.6z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#ab6d29",
      d: "m314.8 217.4 1 3.7c.5 1.2 0 2.3.3 2.3.2 0 2.3-2.7 2.3-4 0-1.2 0-2.5-.5-6.3s.2-5 .2-5l-1.2-1-2 4.2zm-7-2.2.7 5c.3 1.2 1 3.3 1.4 3.2.4 0 1.6-3.3 1.7-4.4 0 0-.9-1.6-.8-5.5 0-4-.4-4.4-.4-4.4z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#45392d",
      d: "M302.5 207.5s-3.1 4.6-3 7c0 2.5.4 2 1.1 4.2.7 2.3 1.1 5.6 1.2 5.9 0 .2.5-.2.5-.5z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#ab6d29",
      d: "M302.5 208s-2.7 4.3-2.5 6.6c.2 2.3.5 2.3 1.3 4.4.8 2 .8 5.4.8 5.4s1-.2 1.9-.9c1-.7 1.8-2.1 1.8-2.1l-1-2.1a8 8 0 0 1-.6-2l-.8-1 .2-4.1.7-3v-1l-1.8-.1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#dbad6c",
      d: "M317.2 215.3s-1.3-.3-1.9-.6c-.6-.3-.8-1.1-.8-1.1l.4-.8z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#d2a567",
      d: "M303 208.5s-2 4.3-1.7 7.2 1.9 6.6 2 6.7c.2 0 0-.3.1-1v-8.7l.9-2.8v-1.5z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8f4620",
      d: "M307.8 209.5s.3 1.2.1 1.8c-.2.5-1.2 1.2-1.6 2-.5.8-1 2.8-1 2.8s.4-1.1 1-1.8c.7-.7 1-1.2 1-.8.2.4.4 2 .3 2.3-.1.3-.7.8-1 2-.4 1.3 0 2.4 0 2.4l.5-2.2c.2-.6.7-1 .7-1l1 2.4s0-1.1.3-2c.1-.8 1-2 1.3-2 .3 0 .8-.1-.3-.7-.4-.2-.1-4.2.1-4.4.3-.2 1.9-.2 1.7-.8a11 11 0 0 0-1.6-2.2c-.1-.1-2.5 2.2-2.5 2.2"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#dbad6c",
      d: "m317 218.1-1.5-.3c-.5 0-.6-.6-.6-.6l.2-.6 1.2.7z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8f4620",
      d: "M304.4 218.6c0 .4-.3.9-.5 1.5-.3.7-.4 1.6-.4 1.6l-.4-3.3-.3-2.4c-.2 0-.7.7-.7.7s0-1.6.3-2.3c.3-.7.5-1.8.3-2-.3-.1-.8.3-1 .7a30.8 30.8 0 0 0-.8 1.3s.3-1.3.6-1.9c.3-.5 1.8-2.2 2-2.8.4-.7.4-1.4.4-1.4h1s1 .8 1 1.5c0 .4-1 .9-1 1 0 0-.8-.1-1 3.2-.2 3.4.6 3.2.5 4.6m9.4-8.7s.2 1.8 0 2.4c-.2.6-.7 1-1.1 1.8-.4.7-.4 2.4-.4 2.4l.5-1.4.7-1c.1 0 .6.7.8 1.7l.8 2.5s-.2-1.2.1-1.2.5-.1.9.2l.9.8s0-.5-.7-1.1c-.6-.7-1-.6-1.1-1.5-.2-1-.3-1.8-.2-2.2 0-.3.5.3.9.7l1.5 1.4-.7-1v-3c0-1 0-1.9.4-2.1.3-.3.4-1.6.2-1.8-.1-.2-3.5 2.4-3.5 2.4"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#1e2121",
      d: "M324.6 206.1a23.7 23.7 0 0 0 1.5 7.1s-1-2-1.6-3.6-.9-3.5-1.3-3.6c-.4-.2-1 .8-1 1.5s.5 3.3 1.1 4.2c.6 1-1-1.2-1.3-2.3l-.7-2.2s-.4 1-.3 2c.2 1.1 1.1 2.7 1.1 2.7l-1-1-.6-.7s0 1.5.4 2.1l1.2 1.7-1.3-1-.4-.8s.2 2.1.6 3.3l1.5 3s-1.2-1-2-2.9c-.8-1.8-1.2-7.3-1-8.1l1.1-1.9c.6-.8 1.3-4.7 1.3-4.7s.9 3.6 1.5 4.3c.6.7 1.2 1 1.2 1zm-8.6-1 .8 1.3.6 1s-1 1.1-2.3 2c-1.2 1-2.8 2-3.1 1.5-.4-.5-.4-1-.4-1s1.4-.8 2.4-1.8a6.6 6.6 0 0 0 1.6-2.2c.2-.6.5-.9.5-.9zm-10.9 3.5s.2 2.2 1.2 2.2c.9 0 3.7-2.9 3.9-3 .2-.1.4-.8.4-1l-.2-.8s-3 3-4 3.2c-.9 0-1.3-.6-1.3-.6m.1-3-.3 2c0 .5.2.9.2.9s-2.2.7-2.5 0c-.4-.6-.1-1.6-.1-1.6h1.5c.6-.2 1.2-1.3 1.2-1.3m20.3-3.1 1.5 3.2 1.4 2.8s-1.4-1.7-1.9-2l-1.2-1 .2-1.1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#dbad6c",
      d: "M302.1 207h1.3c.5 0 .8-.2.8-.2l.9-1.2s-.5 1.4-.2 2.5c.3 1 1 1.1 1.2 1.1a4 4 0 0 0 2.2-1.1c.9-1 2.1-1.9 2.1-1.9s-.3 1.3.2 2.7c.5 1.3 1.2 1.3 2.2.4 1-.8 2-2.2 2.6-2.8l.7-1 1.1-1 1-5.4-.5-.7-1.4.7-1.7-.7-.5-.7-1 1.7-1 .6-.5.1-1.2.3-.5-1.1-.3-.8-.6-.3-2.4 2.5-1.4-.1-1.3 2.2-1 1.3-1 2.4z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8f4620",
      d: "M313.9 201.5s.2 1.3-.5 3.6-1.6 3.9-1.6 3.9 2.4-1.5 3.6-4.2c1.1-2.6.9-5.7.9-5.7zm3-2.5s.2.4 0 2.4l-.8 4 .6 1.2c.4.7 1.2 1.8 1.7 1.6.6-.2 1.6-.9 2.2-2.2.6-1.4 1.1-2.7 1.4-2.9.2-.2.3.1.4.2 0 .1.3 1.3.9 1.8.5.5 1.3 1.3 1.6 1 .4-.2.8-.9.7-1.2l-1.3-4-1.6-4-1-1.6-2.8.3z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#ab6d29",
      d: "M321.7 195.3s.8 1.7.9 3.6c0 1.8-.4 3.8-.4 3.8s.2-2.3 0-3.7c-.3-1.4-.7-2.3-.7-2.7z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#4d2a15",
      d: "M325.6 202.6v2.3c-.2.8-1.3-.5-2-3-.6-2.5-.5-3-1-4.3l-.9-2.2 1.5-.3zm-7 4.6s2.8-1.5 3.1-6.2c.2-2.1-1.2-5.7-1.2-5.7s0 3.8-1 6.2a60.9 60.9 0 0 1-1.9 4s.7-.2 1-.6l.8-1.1s.1.7-.1 1.6l-.6 1.8zm-2.3-8.1s-.1 1-1.3 2c-1 .9-3.1 1.9-3.1 1.9s1.5-1.4 2-2.6c.6-1.2.1-2 .1-2s-.2.6-.8 1.1c-.6.5-1.6.6-1.6.6s0-.6.7-1.3c0-.1 0-.4.2-.7.3-1 1.1-2.3 1.1-2.3s.7 1.4 1.3 2z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#1e2121",
      d: "M324.7 193.6a17.6 17.6 0 0 0 .9 9s-1.4-2.2-1.7-3c-.4-1-.4-2.3-.7-3a3.2 3.2 0 0 0-1-1c-.3-.2-1-.1-1-.1s.8-.4.8-1.1v-1l1.4.3h1.3zm-6 9.8s1.4-2 1.8-4.6c.4-2.6 0-3.5 0-3.5s-.6 0-1.1-.5c-.5-.5-1.3-1.8-1.3-1.8s.2 1.4 0 3c-.4 1.6-1.8 3-1.8 3s.8.4 1.4 0c1.5-.9 1.4-2.5 1.4-2.5s.3.2.3 2.2-.7 4.7-.7 4.7"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8f4620",
      d: "M301.2 206.9c-.3 0 1-2 1.8-3.4l2.1-3.4s.3.3.8.3a3.6 3.6 0 0 0 2.4-1.7 7 7 0 0 0 1-2.5c0-.3-.1 1.8 1 3 1 1.1.9 1 1.3 1 0 0 0 1.4-.4 2.7l-.8 3.3s.2-2.5-.3-3.2c-.4-.8-.6 0-1 1-.3.9-1.1 1.5-1.1 1.5s.6-1.1 1-2.3c.4-1.2.2-1.2 0-1.2 0 0-.2-.1-.6.4-.5.5-.9.6-.9.6s.5-.4.7-1a6 6 0 0 1 1-1.8c.2-.3.4-.7.4-1 0-.2 0-.7-.2-.7s-.5.3-1.4 1.2l-1.3 1.3-.9 2.6a17 17 0 0 1-1 2.8l-.6.4.9-2.4 1-3.4c-.2-.3-.7-.3-.8 0l-2 2.8c-1 1.4-1 3.1-1.2 3.2l-1-.1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#874f20",
      d: "M325.7 192.1c0 .2 0 1.2-1 1.5a3.5 3.5 0 0 1-2.3-.2c-.2 0-.2-1.4-.2-1.4z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#b27129",
      d: "M306 195.4s-.2.9-.8 2c-.5 1.2-1.4 2.2-1.3 2.4 0 .1.6.7 1.4.6.8 0 1.1-4.8 1.1-4.8l-.1-.2z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#dbad6c",
      d: "M318.4 192.7s-.3 6.4-2.1 6.4-2.7-3.2-2.7-3.2-.1 4.3-2.4 4.3c-1 0-2.1-3.4-1.9-4 0 0-.4 2.3-1.5 3.2-2.2 1.7-3.5.9-3.6.6 0-.3 1.8-2 2-4.6 0 0 .4.1 1-.6s.7-1.6 1.3-1.5c.5.2 3-1 3-1l1.4-1.7s.2.5 1.2-.2a3.6 3.6 0 0 0 1.3-1.7l2.7 2.3z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#b27129",
      d: "m311.4 186.6 2.7 3.8.6-.5c.4.5.6.9.4 1.2-.4 1-1.3 2.3-.5 3.7 0 0-.3-.8.1-1.8s.7-1.4 1-1.3c.2 0 .6 5.8 1 5.8.3 0 .9-2.7.9-4.5 0-1.8.3-.3.5 0 .2.4 1.8 3 3.1 2.6 1.4-.4 1.2-2.8 1.2-3.3 0-.6-1-3.7-1-3.7l-6.1-3.9-.5 1.6c-.3 1-3.4.3-3.4.3"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8f4620",
      d: "M320 186s.4.4 1 1.9.7 6.4-.1 6.4c-.8 0-2.3-1-2.6-1.6-.3-.7 0-3.1-.4-3.8a8.1 8.1 0 0 1-1.2-2.7l.1-2 1.4-.5z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#4d2a15",
      d: "m319.6 184.5 2.6 3.9 2.3 3.3 1.2.4a2.5 2.5 0 0 1-3.2.5c-.9-.5-.4-2-1.5-4.5-1.2-2.5-3.2-3.6-3.2-3.6l.7-.7z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#1e2121",
      d: "M318.2 182.4s2.3 1.5 3.1 3.2c.9 1.7 1.3 2.7 2.3 4.3 1 1.6 2.1 2.1 2 2.2 0 .1-.7.3-1.2 0a4.7 4.7 0 0 1-1.4-1.6 35 35 0 0 0-2.4-4.2c-.5-.7-2.3-2-2.3-1.9 0 .1.5.5 1.5 2.1a7 7 0 0 1 1.2 3.1l-1.1-2c-1-1.5-2.8-3.3-2.9-3-.1.2 1 1.9 1.5 2.9l1.3 3.3-1.8-3c-1-1.5-1.2-1.3-1.6-1.8l-1.4-1.8s1 .3 1.8-.3c1-.6 1.4-1.5 1.4-1.5"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8f4620",
      d: "M312.3 186.7s1.5.3 2.3.2h1.1s.5.6.5 1.4c0 .7-.5 2.1-.8 2.2-.2 0-.2-1.3-.5-1.8z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#b27129",
      d: "M313.1 190.6s.5 1.6.1 3.9c-.4 2.2-1.7 4.6-2 4.6-.3 0-.2-2.6-.4-4a38.8 38.8 0 0 0 0-.4l-.5 1.6.4-2.6-.1-.8 1.6-2z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8f4620",
      d: "M310.3 192.3c-.5.5-1.2.4-1.8.6-.6.2-.9 1-.9 1s.5-.3.7-.2c.3.1.5.1.1 1.2-.5 1.1-2.2 3-2.1 3 0 0 2-1.5 2.5-2.5.7-.9.6-1.4.8-1.8 0-.3.8-.7 1-.7.1 0 .5 0 .6.7l.6 2.6.8-2.6c.2-1 .2-2.9.2-2.9l-.6-.1c-.5-.1-1.5-1-1.5-1s.2 2-.5 2.7z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#dbad6c",
      d: "M318.3 180.8s.6 1.5-.7 2.6c-.4.3-.7.5-1.4.6a4.5 4.5 0 0 1-1.7-.6l-4-1.6-2-.6-1-.3.2-1.1h3l3 1.2 1.3.5 1.1.2h.9l.7-.2.4-.3z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#ab6d29",
      d: "M318.3 180.8c0 .3-.3 1.1-.6 1.3-.3 0-.8.3-2 0-1.1-.2-2.3-1-3.6-1.3-1.3-.4-2.3-.7-3.3-.7s-.5-.4-.5-.4 2.3-.3 4.3.5c2 .7 2.9 1.2 4 1.2 1.4 0 1.7-.6 1.7-.6"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#4d2a15",
      d: "M307.6 179.6h.9c.4 0 .7-.3.7-.3s0 .5-.2.7c-.3.2-1 .1-1.2.1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#dbad6c",
      d: "M315.3 184.4s1.3 1.3 1 2.4l-2.7-1.2-4.2-1.7-2.3-.7-.3-.4.6-.8.2-.8 2.8.4 3 1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#dbad6c",
      d: "M312.4 186.3s2.4 3.1 1.8 4.1l-5.6-3.5-2 3.3-4.7-2.3s3.8-3 4.2-3.5l.5-.7 2 .4 3.4 1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#ab6d29",
      d: "M311 181.6s2 .5 3.3 1.2c1.3.6 3 .8 3 .8s-.6.7-2 .8c-.4 0-1.4-.8-2-1.3-.7-.4-2.6-1-2.6-1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#4d2a15",
      d: "M307.6 180.6s1.4.3 2.2.7c1 .3 1 .2 1.2.1.3 0 .3-.2.3-.2s.2 1-.5 1-1-.3-1.8-.7c-1-.4-1.5 0-1.5 0v-1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#ab6d29",
      d: "M315.4 186s1 .7.9.9c-.2 0-.7.3-1.6.4a3.4 3.4 0 0 1-2-.4c-.6-.2-1-1.3-2.5-2a18 18 0 0 0-2.8-.9l-1.3-.2 1-.4 3.2.6 2.8.9 1.7.8.6.4zm-5.4 2 .6 2.6-.4 1.5-.8.6-.8-.3-.3-.5s.4-.6 0-1.1c-.3-.6-2-1.2-2-1.2s.7-1.3 1.4-1.6c.8-.3.4-1.2.4-1.2z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#4d2a15",
      d: "M306.8 182.8s.5.4 1.5.5c.5 0 1.3.2 2.2.5l1-.3-.5.4c.9.2 2 .7 2.5.9a5.8 5.8 0 0 1 2 1.3l-2-1a17.4 17.4 0 0 0-3-.9c-2-.3-4-.2-4.3-.4-.4 0 .1-.1.4-.3.2-.2.2-.7.2-.7"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#ab6d29",
      d: "M314 189.8s.7.7 0 .9c-.6.2-2.4.2-3.2-.7l-.6-1.2a14 14 0 0 0-2.4-1.7c-.7-.5.3-.5.3-.5l3.6 1.5a13 13 0 0 1 2.3 1.7"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#4d2a15",
      d: "M314 189.9s-1.2-1.8-4.9-3.3l1.2-.2h-2a24 24 0 0 0-.8-.3c-2-.6-2-.6-2.2-.8-.1-.3-.4 0-.6.3l-.7 1a5 5 0 0 1 2.5-.1c1.1.3 1 .7 1 1-.1.5-1.4 2-1.3 2.1.2 0 1-1.5 2-1.3 1 .3 1.2.8 1.2.8s0-.6-.2-.8c-.2-.2-1.3-1.3-1-1.3.3 0 1.6.3 3.3 1.2 1.8.9 2 1.1 2.6 1.7z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#dbad6c",
      d: "M308.1 187s2.8.8 2.7 3.8c-.1 3-2.3 2.4-2.5 1.3-.2-1 .3.5 1 .4.9-.2 1-1 1-2.2 0-1-.3-1.6-1-2.2a12 12 0 0 0-1.2-1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#6c3f18",
      d: "M296 179.9s.4.2-.4 2.3c-.8 2.1-1.3 2.8-2.5 4.2-2.2 2.4-3.2 2.5-3 3.5.3 1 1.1.8 1.3.8.2 0 4.3-6 4.3-6l.9-3.5-.2-1-.3-.3z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#dbad6c",
      d: "M306.1 175.6s1.2 1.8.8 5c-.3 3.4-4.7 6.3-4.7 6.3l-6.4 4.4-2.7-.2h-.8c-.4-.1-.8-.5-.9-.5l-.5-1.2.9-1 2.3-2.3 1.4-2s.7-1.3.8-2.5c0-1.1-.2-1.7-.2-1.7l.5.8.3 1.8-.2 2 1.6-1.2 2.2-1s.7 0 1-1.3c.5-1.2.9-3 .9-3.8l-.1-1.8h.3c.2 0 .7 1.2.7 1.7l.4 2.8 1-1 1-1.5c.2-.5.4-1.3.4-1.8"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#904720",
      d: "M306.8 192.2s.5.4.3 1.6c-.2 1.2-1.1 1.8-1.6 1.8V194l-1.4-1.2-1.5-.4.3-.3c.1-.2 1.7-.8 1.7-.8z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#ab6d29",
      d: "M305.7 192.2s.5.4 1.2.3c.7-.2 1-1.3.6-1.8-.4-.4-.2 1-.7 1.3-.4.1-1-1.2-1.5-1.3-.7-.1-1.6.3-1.9.7-.2.4 1 0 1 0l.7.3h.5z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#904720",
      d: "M296.5 187.6s.8.3 1.7.1l3.1-1 1.8-1.3c.7-.7 3.1-2.2 3.4-5.1.2-3-.4-4.7-.4-4.7s3.5 3.8.5 8.2c-2 2.8-3.8 3.7-3.8 3.7s3.4-1 3.7-.2c.3.8-.1 2-.2 2.3 0 0 1.9.4 2.2 1.4.1.6-2.2-.7-4-.2-1.8.4-2.5 1.4-2.5 1.4s-.4-.5-2-.5c-1.5 0-2.2.7-3.1.7-1 0-3.7-.6-4.2-1.4l1.8-2.2c.8-1.6 2-1.2 2-1.2"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#ab6d29",
      d: "M303.8 179.7s1.3-1.3 1.8-2.3c.4-1 .5-1.8.5-1.8s.2 1-.6 2.3-1.7 2-1.7 2z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#904720",
      d: "M303.4 176.7s1.1 4.4 0 6.1c-1.3 1.8-6.5 4.1-6.5 4.1s4-2.1 5.2-4.6 1.1-4.5 1.1-4.5z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#1e2121",
      d: "M298.2 187.7s1.7 0 2.6-.6c1-.5 2.3-1.7 2.3-1.7s-1.2 1-1.6 1c-.3 0-.6-.5-.5-.9 0 0-.3.8-1 1.4-.8.5-1.8.8-1.8.8m3.9-5.4s1.4-1.4 1.4-4.4c0-3-1.2-2.5-1.2-2.5s1 .7.7 3c-.2 2.3-1 4-1 4zm1.7.3s1.6-.3 2.1-1.3.6-2.7.6-2.7-.2 1.7-.7 2.3c-.4.6-2 1.7-2 1.7m-1 9.5s.8-1.5 1.9-1.1c1 .4 1 1.2 1 1.2s-.4-.6-1.2-.7c-.7 0-1.6.6-1.6.6zm-2.9-2.7 3.7-1 3-1s-1.2 1.3-3 2.3c-1.6 1-3 1-3 1s3.2-1.4 3.4-2c0 0-3 .9-4 .7z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fff",
      d: "M296.2 185.8a2.6 2.7 67.8 0 1-3 4.4"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f16e16",
      d: "M296.1 186.1a2.3 2.4 67.8 0 1-2.7 3.8"
    }),
    /* @__PURE__ */ jsx229("path", {
      d: "M295 187.4a1 1 0 1 1-.8 1.4"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#d5d3ca",
      d: "M295.2 188.6a.3.3 0 1 1-.6-.1.3.3 0 0 1 .3-.3.3.3 0 0 1 .3.4"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#ab6d29",
      d: "M296.8 184.2s1.6-1.5 1.9-3.5c.3-2 .1-3.2.1-3.2l.9 1 .3 1.4-.5 2.6 1.6-.8c.6-.8 1.5-4.2 1.2-6.3 0 0 .4 1-.2 3.8-.6 2.9-1 3.2-3.2 4.4a9.6 9.6 0 0 0-3.8 4.2 19 19 0 0 1-2.3 3l1.6-2.6c.8-1.8 1.7-2.8 1.7-2.8z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#904720",
      d: "M296.1 185.4s.7-2 .7-3.1-.7-2.4-.7-2.4 1-.1 1 2.2c.1 2.4-.4 2.6-1 3.3"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#4d2a15",
      d: "M299.2 182.8s.7-1.7.7-3c0-1.1-1-2.3-1-2.3s1.1.3 1.2 2.4c.1 2.2-.2 2.2-1 3z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#ab6d29",
      d: "M292.1 191s-.6-.8-.5-1.3c0-.6 0-.7 1.4-2.2a13 13 0 0 0 2.5-3c.3-.9 1.5-3 .6-4.6 0 0 .6 2.4-.8 4.3a15.7 15.7 0 0 1-3.3 3.7c-1.1.8-1.3 1.2-1.2 1.7 0 .5.1 1 .3 1 .4.3 1 .3 1 .3z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#6c4119",
      d: "M305.5 195.6s.3 0 .5-.3.2-1-.3-1.6a3.3 3.3 0 0 0-1.7-1.1l-2-.4s.4.8 1.3 1.3c.4.2 1.2 0 1.6.4.5.4.6 1.7.6 1.7"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#6c4119",
      d: "M305.5 195.6s1.5-.5 1.6-2l-.1-1.2s.2.5.8.7l.6-.2s-1 2.8-3 2.7z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#bf802d",
      d: "m294.8 195.3.8.8.9 1 3.7-1 1.2-1.2-1-1.6h-2.7l-3 2z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f9c83a",
      stroke: "#8f4620",
      strokeWidth: 0.4,
      d: "m303.8 194-.7-.9-.7-.6c-.6-.3-2.8-.3-2.8-.3l-1.6.3s-.5.5-1.3.3a22 22 0 0 1-2.6-1l-1.9-.7s-1.3-.6-1.6-.5c-.3.1-1.5 1.3-1.5 1.3s-.2.7.3.7c.4 0-.7.2-.7.2s-2.8 1.6-3.2 4.4c-.5 2.7 4.6 6.8 6.5 4.7 0 0-2.8-2-2.2-3.7.5-1.7 1.8-2.8 4-3 2.1 0 2.3-.3 3.2-1 1-.6 2.7-1 4 .3 1.3 1.4-5 2.7-5 2.7l.7 1s7.7-2.7 7-4.1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fcf3d8",
      d: "M289.4 200.7s-3.1-.8-2.9-3.7c.3-2.8 3-3.9 3.4-4 .4-.2.3-1.6.8-1.8a2.4 2.4 0 0 1 2 .5l1.4.8s-5.5 2.4-5.5 5.6c0 2.1.8 2.5.8 2.5z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fdeaaf",
      d: "M303.8 193.8s-.4.2-.5 0c-.6-1-2-1.4-3-1.3-1.5 0-2.4.5-3.4.5s-.7-.1-1.8-.2c-1.1 0-3.5-1.8-4-1.6-.6.2-.8.8-.8 1.1.1.4-1 .4-1 .1-.2-.2.7-1.7 1.7-1.7 2.6 0 4.6 1.7 5.8 1.7 1.3 0 1.7-.7 3.4-.7s3.5.8 3.6 2z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#513625",
      d: "M295.2 195.8s1.3-.2 2.2-.6l2.2-.8-2 1.2-2 .5z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f9c83a",
      d: "M290.8 202.3c-.2 0-1.3 0-3-1.1-1.8-1.2-2.3-3.2-2.3-3.2s-.4-1.9 1.4-3.8c1.8-1.9 2.1-1.3 2.2-1.2.1 0 0 .1 0 .1l-1.7 1.3-.7 1.3-.7 1.2v1.4l.8 1.5 2.5 1.5z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8b5122",
      d: "M289.8 191.4v-.2.3-.3.3-.3l-.3.2h.2v-.2l-.2.2.2-.2h-.2a.3.3 0 0 0 0 .2l.2-.2h-.2.2-.2.2-.2.2l-.2-.1.2.1-.2-.1-.1.1a4.6 4.6 0 0 0-.4.5l-.2.6v.1c0 .3.2.5.4.6h1.4a.3.3 0 0 0 .1-.4.3.3 0 0 0-.3-.2l-.7.1a.8.8 0 0 1-.3 0v-.2a.5.5 0 0 1 0-.2 3 3 0 0 1 .3-.5l.2-.1zl.1-.2a.3.3 0 0 0-.3-.2.3.3 0 0 0-.2.3.3.3 0 0 0 .3.2z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f9c83a",
      d: "m295.1 194.1-3.8 1.1c-.3.2 1.2 0 2.4 0l1.3.1.9-.2c1.4-.5 4.4-1.6 4.7-.3.2 1-4.1 2-4.1 2v.5l3.4-.9 1.9-1 .5-.9-1.7-1.2H298l-1.2.3z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8f4620",
      d: "M289.7 199.5c.3.8.9 2 1.6 2.3 0 0 .1 0 0 0 0 .1-.5.5-1.7.1-1.2-.3-3-.7-4.1-4v.7l.7 1.3 1.1 1.2 1.9 1.1 1.2.3 1-.2.6-.4-1.1-1-1.4-2.3z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fcca3d",
      d: "M302.1 232.6v1.2h-.7v-1.5zm-4.7-34.4-1.2-1.4-.8.1 1.2 1.8z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#816c2a",
      d: "m302 235.5-1.7-1a10 10 0 0 0-2.4-.6v.3h.2l2.1.6a14.3 14.3 0 0 1 1.7 1zm0-3.1h-3a4 4 0 0 0-1.3.7l.1.2a3.8 3.8 0 0 1 2.6-.7 23 23 0 0 1 1.4.1v-.3zm-.4-2.7-2.6 1.4-1.6 1.2.2.2.5-.4a16.5 16.5 0 0 1 2.6-1.6l1-.5zm-1.7-2.7s0 .7-.3 1.2a8.6 8.6 0 0 1-.6.8 86.3 86.3 0 0 1-2.5 2.6l.2.3a220.4 220.4 0 0 0 2.5-2.7l.7-.8c.3-.6.3-1.3.3-1.4zm-2.1-1.2a4.2 4.2 0 0 1-.2 2.2l-1 2.2-.4.9-.2.3.2.2s1.3-2.2 1.7-3.5c.2-.5.2-1 .2-1.5a4 4 0 0 0 0-.9zm-2.1-.3a8.7 8.7 0 0 0 0 1.2c0 .6 0 1.2-.2 1.7l-.7 1.8-.3 1 .3.1 1-2.8c.2-.5.2-1.2.2-1.8v-1.2zm-1.6 0v1.2l-.3 2a52.2 52.2 0 0 0-.5 2.5h.3l.2-.8.3-1.7c.3-1 .3-3.2.3-3.2zm-1.8.3a13 13 0 0 0 0 2.9 14 14 0 0 0-.4 2.5h.3a23.3 23.3 0 0 1 .4-2.4l.1-1.4v-1.6zm-1.3.2v.2a9 9 0 0 1-.3 2.2l-.6 1.9-.2 1h.3l.8-2.9a8.9 8.9 0 0 0 .3-2.2v-.2zm-1.6 0v.7c0 .6 0 1.4-.4 2a5.5 5.5 0 0 1-1.3 1.6 9.8 9.8 0 0 1-.7.4l-.2.2.1.3s1.7-1 2.4-2.3c.4-.7.5-1.6.5-2.2v-.7zm-.9-.3v.2a6.7 6.7 0 0 1-1 1.9c-.3.4-.9.8-1.3 1.1a12.1 12.1 0 0 1-.8.5l.2.3s1.4-.8 2.1-1.7a8 8 0 0 0 1.1-2.2h-.3zm-1.5-.7v.1a6.2 6.2 0 0 1-1 1.3c-.1.2-.5.4-.9.6l-.6.4.1.3.7-.4 1-.7.7-.9.3-.6zm-.7-1-.3.3-.9 1a6.5 6.5 0 0 1-.5.4l-.4.3.1.3.7-.4c.7-.6 1.5-1.7 1.5-1.7zm-.4-.6-.2.2-.9.6a2 2 0 0 1-.8.3v.4l.6-.3c.7-.3 1.5-1 1.5-1zm-.2-.7-.8.4-.6.3a1.9 1.9 0 0 1-.4.2v.3c.2 0 .3 0 .5-.2l1.4-.7zm-.4-1.3-.5.5-.9.3v.3a2 2 0 0 0 1.2-.5 3.8 3.8 0 0 0 .5-.4zm.1-2.2-.6.5c-.3.3-.6.6-.7 1a.6.6 0 0 1-.1 0v.5l.2-.2a.8.8 0 0 0 .2-.2c0-.2.4-.6.7-.9a7.9 7.9 0 0 1 .5-.5zm10.7-12.8h1.6l.1-.2v-.1h-.1v.3-.1h-.2.1-.1v-.2l.1.1v-.1.1-.1h-1.5zm0-1h.2c.2 0 .4 0 .6-.2.4-.1.7-.4 1-.6l.5-.3a.8.8 0 0 1 .3 0v-.4l-.6.2-1 .7-.8.3zm0-1.5.7-.2 1.2-.8c.4-.3.7-.4 1-.4v-.3c-.3 0-.5 0-.8.2l-1.2.7a3 3 0 0 1-1 .5v.3zm-.6-1.4 1.5-1 1.6-1.2-.1-.3-1.7 1.2c-.5.5-1.1.9-1.5 1l.2.4zm-1-1.5 3.2-2.3-.2-.3-3.2 2.3zm-1.5-1.6a20.7 20.7 0 0 1 3.4-2.3l-.2-.2-1.5 1-1.9 1.3zm-1-1a123.7 123.7 0 0 1 2.6-1.8l.8-.5-.1-.3a7.6 7.6 0 0 0-.8.5 113 113 0 0 0-2.7 2z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#78732e",
      d: "m294.5 195.4.1.1a17.3 17.3 0 0 1 2.5 2.5c1 1.2 1.8 2.7 1.8 4.1v.5a9.5 9.5 0 0 1-2.5 5c-2 2.3-4.8 4.4-7 6.4a18 18 0 0 0-3 3.1 6.1 6.1 0 0 0-1.2 3.7 6.4 6.4 0 0 0 1.1 3.4 4.4 4.4 0 0 0 3.9 2c1.8 0 3.8-.7 5.6-.7 1.6 0 3 .4 4.4 1.9 1.3 1.4 1.7 3.6 1.7 5.7 0 1.6-.2 3-.4 4.2a25.6 25.6 0 0 1-.4 1.8h.3s.8-2.8.8-6c0-2.1-.4-4.5-1.8-6a5.8 5.8 0 0 0-4.6-1.9c-1.9 0-3.9.6-5.6.6a4 4 0 0 1-3.6-1.8 6 6 0 0 1-1-3.3v-.1c0-1.6.7-3 1.9-4.3 1.8-2 4.5-4 7-6.2 2.3-2.2 4.4-4.5 4.7-7.5v-.5c0-1.8-1.1-3.5-2.3-4.8a17.2 17.2 0 0 0-2.3-2.2z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#a8ac71",
      d: "m292.1 198.4-.4-.3-.3.1.6.5zm1 1-.3-.3h-.1l.2.4z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#78732e",
      d: "m294.5 201-.2-.4-.2.2zm1 1.5-.1-.3h-.3l.4.5zm.7 1.5-.2-.4v.4zm0 1.5v-.4l-.2-.1v.5zm0 1v-.5l-.1-.1v.6zM284 221.1l.1-.7c.1-.3-.3.1-.3.1v.5z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fff",
      d: "m284 222.1-.3.1.1.5.1-.2z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#78732e",
      d: "M284 223.9v-.4h-.2v.6z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fff",
      d: "M284 224.9v-.4h-.1v.4zm.3 1.4v-.4l-.2.1zm.4 1.4-.1-.5h-.2l.2.6z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#a8ac71",
      d: "m285.6 229.7-.2-.3h-.2zm1.5 1.4-.5-.3c-.3-.3-.1.2-.1.2l.4.2zm9.8.8-.4-.3c-.2 0 0 0 .2.4.1.3.2-.1.2-.1"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fff",
      d: "m297.7 232.5-.3-.3v.3h.2z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#a8ac71",
      d: "M297.9 233c-.1-.2-.2.1-.2.1l.2.3zm0 1.3v-.5c0-.2-.1 0-.1 0v.5z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#fff",
      d: "m297.4 235.7.2-.4h-.2zm-14.8-52s.5-.2.1.4l.3-.5h-.5z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#f9c83a",
      d: "m294.6 195 .4.3h-.5z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#8f4620",
      d: "m295 195.3-.7.1c-.2 0 .2-.2.2-.2l.4.1z"
    }),
    /* @__PURE__ */ jsx229("path", {
      fill: "#977c2e",
      d: "M301 239.1s.3 0 .5-.3-.1.4-.1.4l-.3.1-.2-.2z"
    })
  ]
});
var Mx_default = SvgMx;

// src/country-flag-icons/generated/My.tsx
init_esm_shims();
import { jsx as jsx230, jsxs as jsxs205 } from "react/jsx-runtime";
var SvgMy = (props) => /* @__PURE__ */ jsxs205("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsxs205("g", {
      clipPath: "url(#my_svg__a)",
      children: [
        /* @__PURE__ */ jsx230("path", {
          fill: "#C00",
          d: "M0 0h640v480H0z"
        }),
        /* @__PURE__ */ jsx230("path", {
          fill: "#C00",
          d: "M0 0h640v34.3H0z"
        }),
        /* @__PURE__ */ jsx230("path", {
          fill: "#fff",
          d: "M0 34.3h640v34.3H0z"
        }),
        /* @__PURE__ */ jsx230("path", {
          fill: "#C00",
          d: "M0 68.6h640v34.3H0z"
        }),
        /* @__PURE__ */ jsx230("path", {
          fill: "#fff",
          d: "M0 102.9h640V137H0z"
        }),
        /* @__PURE__ */ jsx230("path", {
          fill: "#C00",
          d: "M0 137.1h640v34.3H0z"
        }),
        /* @__PURE__ */ jsx230("path", {
          fill: "#fff",
          d: "M0 171.4h640v34.3H0z"
        }),
        /* @__PURE__ */ jsx230("path", {
          fill: "#C00",
          d: "M0 205.7h640V240H0z"
        }),
        /* @__PURE__ */ jsx230("path", {
          fill: "#fff",
          d: "M0 240h640v34.3H0z"
        }),
        /* @__PURE__ */ jsx230("path", {
          fill: "#C00",
          d: "M0 274.3h640v34.3H0z"
        }),
        /* @__PURE__ */ jsx230("path", {
          fill: "#fff",
          d: "M0 308.6h640v34.3H0z"
        }),
        /* @__PURE__ */ jsx230("path", {
          fill: "#C00",
          d: "M0 342.9h640V377H0z"
        }),
        /* @__PURE__ */ jsx230("path", {
          fill: "#fff",
          d: "M0 377.1h640v34.3H0z"
        }),
        /* @__PURE__ */ jsx230("path", {
          fill: "#C00",
          d: "M0 411.4h640v34.3H0z"
        }),
        /* @__PURE__ */ jsx230("path", {
          fill: "#fff",
          d: "M0 445.7h640V480H0z"
        }),
        /* @__PURE__ */ jsx230("path", {
          fill: "#006",
          d: "M0 .5h320v274.3H0z"
        }),
        /* @__PURE__ */ jsx230("path", {
          fill: "#FC0",
          d: "m207.5 73.8 6 40.7 23-34-12.4 39.2 35.5-20.8-28.1 30 41-3.2-38.3 14.8 38.3 14.8-41-3.2 28.1 30-35.5-20.8 12.3 39.3-23-34.1-6 40.7-5.9-40.7-23 34 12.4-39.2-35.5 20.8 28-30-41 3.2 38.4-14.8-38.3-14.8 41 3.2-28.1-30 35.5 20.8-12.4-39.3 23 34.1zm-33.3 1.7a71.1 71.1 0 0 0-100 65 71.1 71.1 0 0 0 100 65 80 80 0 0 1-83.2 6.2 80 80 0 0 1-43.4-71.2 80 80 0 0 1 126.6-65"
        })
      ]
    }),
    /* @__PURE__ */ jsx230("defs", {
      children: /* @__PURE__ */ jsx230("clipPath", {
        id: "my_svg__a",
        children: /* @__PURE__ */ jsx230("path", {
          fill: "#fff",
          d: "M0 0h640v480H0z"
        })
      })
    })
  ]
});
var My_default = SvgMy;

// src/country-flag-icons/generated/Mz.tsx
init_esm_shims();
import { jsx as jsx231, jsxs as jsxs206 } from "react/jsx-runtime";
var SvgMz = (props) => /* @__PURE__ */ jsxs206("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx231("defs", {
      children: /* @__PURE__ */ jsx231("clipPath", {
        id: "mz_svg__a",
        children: /* @__PURE__ */ jsx231("path", {
          fillOpacity: 0.7,
          d: "M0 0h682.7v512H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs206("g", {
      clipPath: "url(#mz_svg__a)",
      transform: "scale(.9375)",
      children: [
        /* @__PURE__ */ jsx231("path", {
          fill: "#009a00",
          fillRule: "evenodd",
          d: "M0 0h768v160H0z"
        }),
        /* @__PURE__ */ jsx231("path", {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M0 160h768v16H0z"
        }),
        /* @__PURE__ */ jsx231("path", {
          fill: "#000001",
          fillRule: "evenodd",
          d: "M0 176h768v160H0z"
        }),
        /* @__PURE__ */ jsx231("path", {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M0 336h768v16H0z"
        }),
        /* @__PURE__ */ jsx231("path", {
          fill: "#ffca00",
          fillRule: "evenodd",
          d: "M0 352h768v160H0z"
        }),
        /* @__PURE__ */ jsx231("path", {
          fill: "red",
          fillRule: "evenodd",
          d: "M0 0v512l336-256z"
        }),
        /* @__PURE__ */ jsx231("path", {
          fill: "#ffca00",
          fillRule: "evenodd",
          d: "m198.5 333-51.2-37.5L96.1 333l19.9-60.3-51.5-37.1 63.5.2 19.3-60.4 19.4 60.5 63.5-.3-51.5 37.1z"
        }),
        /* @__PURE__ */ jsx231("path", {
          fill: "#fff",
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.1,
          d: "M102.8 290.9h37c3 3.3 9.5 4.7 15.8 0 11.6-6.4 34 0 34 0l4.4-4.7-10.7-35.2-3.9-4.2s-8.3-5-24-3.3c-15.7 1.7-21.2-.5-21.2-.5s-13.7 1.6-17.6 3.6l-4.4 4.4z"
        }),
        /* @__PURE__ */ jsx231("path", {
          fill: "none",
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.1,
          d: "M110.3 281.8s35.2-4.4 45.4 9.1c-5.7 4-10.8 4.3-16.2.3.8-1.5 12.6-13.8 42.7-9.7"
        }),
        /* @__PURE__ */ jsx231("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 1.2,
          d: "m148 246.6-.3 38.8m31.7-38.3L186 278"
        }),
        /* @__PURE__ */ jsx231("path", {
          fill: "none",
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.1,
          d: "m117 246.6-3.7 16"
        }),
        /* @__PURE__ */ jsx231("path", {
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.1,
          d: "m78.9 295.1 8.6 10.2c1 .6 2 .6 2.9 0l12.8-15.4 5.4-6.7c.9-1 1.1-2.1 1-3l10.4-9.3 2.2.2c-1-.2-1.7-.7-1-1.8l2.4-1.8 1.8 2.3s-2.6 3.4-2.9 3.4h-2.8l-5.4 4.9 2.4 2 3.5 9.8 4.4-3.1-2.8-10 6.1-6.7-2.3-3.6 1.6-2s21.3 13.4 29.6 9.8c.2 0 .5-9.6.5-9.6s-22.2-2.3-22.7-6.7 5-5 5-5l-2.4-3.2.5-1.8 3.9 4.8 8.7-7.4 51.5 58.6c2.8-1.1 3.4-1.8 3.6-4.6L155 241.5l3.8-4.1c.8-.9 1-1.2 1-2.6l6-5.1a7.3 7.3 0 0 1 3.8 3L186 219c.4.4 1.7.8 2.6.4l26.9-25.9-29.3 20.7-1-.7c0-.9 1-1 0-2.6-1.2-1.4-2.9 1.3-3.1 1.3-.3 0-4.3-1.4-5.2-3.2l-.2 4.7-7.5 7-5.7-.3-8.2 8-1 3 1.3 2.7s-4.4 3.8-4.4 3.6c0-.3-.9-1.2-1-1.3l3.8-3.4.5-2.3-1.2-2c-.4.3-5.2 5.4-5.5 4.8l-14-15.5.8-2.9-8.7-9.5c-3.2-1.1-8.3-1.3-9.3 5.7-.8 1.6-7.4.2-7.4.2l-3.6.8L85.2 241l11.3 13.6 23.2-29.3.7-8.3 4.8 5.4c1.7.2 3.2.3 4.7-.5l13.7 15.3-2.3 2.3 2 2.2 2.4-1.6.9 1.3c-1.1.6-2 1.5-3.1 2.1-1.8-1.2-3.6-2.7-3.5-5l-7.7 6.4-.3 1.2-22.9 19-2 .3-.5 6 14.9-12.4v-1.8l1.5 1.3 11.6-9.3s.8 1 .5 1-10.3 9.3-10.3 9.3l-.2 1-1.8 1.6-1-.8-14 12.4h-2l-7.7 7.7c-2 .2-3.7.4-5.4 1.5z"
        })
      ]
    })
  ]
});
var Mz_default = SvgMz;

// src/country-flag-icons/generated/Na.tsx
init_esm_shims();
import { jsx as jsx232, jsxs as jsxs207 } from "react/jsx-runtime";
var SvgNa = (props) => /* @__PURE__ */ jsxs207("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx232("defs", {
      children: /* @__PURE__ */ jsx232("clipPath", {
        id: "na_svg__a",
        children: /* @__PURE__ */ jsx232("path", {
          fillOpacity: 0.7,
          d: "M0 0h640v480H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs207("g", {
      fillRule: "evenodd",
      clipPath: "url(#na_svg__a)",
      children: [
        /* @__PURE__ */ jsx232("path", {
          fill: "#fff",
          d: "M0 0h640v480H0z"
        }),
        /* @__PURE__ */ jsx232("path", {
          fill: "#3662a2",
          d: "m-26.4.2.8 345.6L512.5 0z"
        }),
        /* @__PURE__ */ jsx232("path", {
          fill: "#38a100",
          d: "M666.4 479.6 665 120.3 122.3 479.8l544-.2z"
        }),
        /* @__PURE__ */ jsx232("path", {
          fill: "#c70000",
          d: "m-26 371.8.4 108.2 117.5-.1L665.4 95.4l-.7-94.1-116-1L-26 371.7z"
        }),
        /* @__PURE__ */ jsx232("path", {
          fill: "#ffe700",
          d: "m219.6 172-21.8-13.2-12.6 22.1-12.2-22.2-22 12.9.6-25.4-25.4.2 13.2-21.8-22.1-12.5 22.2-12.3-12.8-22 25.4.6-.1-25.5 21.7 13.2L186.3 44l12.2 22.2 22-12.9-.6 25.4 25.4-.2-13.2 21.8 22.1 12.5-22.2 12.3 12.8 22-25.4-.6z"
        }),
        /* @__PURE__ */ jsx232("path", {
          fill: "#3662a2",
          d: "M232.4 112.4c0 25.6-20.9 46.3-46.6 46.3s-46.6-20.7-46.6-46.3 20.8-46.2 46.6-46.2 46.6 20.7 46.6 46.2"
        }),
        /* @__PURE__ */ jsx232("path", {
          fill: "#ffe700",
          d: "M222.3 112.4a36.5 36.5 0 1 1-73 0 36.5 36.5 0 0 1 73 0"
        })
      ]
    })
  ]
});
var Na_default = SvgNa;

// src/country-flag-icons/generated/Nc.tsx
init_esm_shims();
import { jsx as jsx233, jsxs as jsxs208 } from "react/jsx-runtime";
var SvgNc = (props) => /* @__PURE__ */ jsxs208("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx233("path", {
      fill: "#009543",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx233("path", {
      fill: "#ed4135",
      d: "M0 0h640v320H0z"
    }),
    /* @__PURE__ */ jsx233("path", {
      fill: "#0035ad",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsx233("circle", {
      cx: 240,
      cy: 240,
      r: 157.3,
      fill: "#fae600",
      stroke: "#000",
      strokeWidth: 5.3
    }),
    /* @__PURE__ */ jsx233("path", {
      stroke: "#000",
      strokeWidth: 6.4,
      d: "M213.3 263.5h53.3M213.3 224h53.3M240 83.2V352"
    }),
    /* @__PURE__ */ jsx233("path", {
      fill: "#000001",
      d: "M176.6 384.4c64.2 26.3 124.4 1.7 124.4 1.7s-22.7-24.6-34.3-34.2c-11.4-9.4-44.8-9-56.2 0a488.7 488.7 0 0 0-33.9 32.5"
    }),
    /* @__PURE__ */ jsx233("ellipse", {
      cx: 240,
      cy: 312.5,
      fill: "#000001",
      rx: 17.6,
      ry: 25.6
    }),
    /* @__PURE__ */ jsx233("ellipse", {
      cx: 240,
      cy: 243.7,
      fill: "#000001",
      rx: 21.3,
      ry: 13.5
    }),
    /* @__PURE__ */ jsx233("circle", {
      cx: 240,
      cy: 181.3,
      r: 21.3,
      fill: "#000001"
    }),
    /* @__PURE__ */ jsx233("path", {
      fill: "#000001",
      d: "M265.6 101.9s1.8 3-2 10c-18.6 33.5-37.3 34.2-40.8 37.1-4 3.2-5.6 3-5.6 3 .3-2.9.5-14.6.7-15.7 2.9-15.7 26.5-15.5 45-31.5 2.9-2.5 2.7-3 2.7-3zm-62.4 72s4.3 12 4.8 24c1 19.2 19.4 19.7 32 19.7v-10.7c-9.5 0-17.7-1.4-24.5-15.4a122.7 122.7 0 0 0-12.3-17.6m-.5 154.6s6.7-8.3 14.6-27.7c4-10.1 13.8-16 22.7-16v-15c-20.3 0-30 7.5-31 18.6a329 329 0 0 1-6.3 40.1"
    }),
    /* @__PURE__ */ jsx233("path", {
      d: "M276.8 173.9s-4.3 12-4.8 24c-1 19.2-19.4 19.7-32 19.7V207c9.5 0 17.7-1.4 24.5-15.5 3.6-6.2 7.7-12.1 12.3-17.6m.5 154.7s-6.7-8.4-14.6-27.8c-4-10.1-13.8-16-22.7-16V270c20.3 0 30 7.5 31 18.6a329 329 0 0 0 6.3 40"
    })
  ]
});
var Nc_default = SvgNc;

// src/country-flag-icons/generated/Ne.tsx
init_esm_shims();
import { jsx as jsx234, jsxs as jsxs209 } from "react/jsx-runtime";
var SvgNe = (props) => /* @__PURE__ */ jsxs209("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx234("path", {
      fill: "#0db02b",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx234("path", {
      fill: "#fff",
      d: "M0 0h640v320H0z"
    }),
    /* @__PURE__ */ jsx234("path", {
      fill: "#e05206",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsx234("circle", {
      cx: 320,
      cy: 240,
      r: 68,
      fill: "#e05206"
    })
  ]
});
var Ne_default = SvgNe;

// src/country-flag-icons/generated/Nf.tsx
init_esm_shims();
import { jsx as jsx235, jsxs as jsxs210 } from "react/jsx-runtime";
var SvgNf = (props) => /* @__PURE__ */ jsx235("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs210("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx235("path", {
        fill: "#fff",
        d: "M194.8 0h250.4v480H194.8z"
      }),
      /* @__PURE__ */ jsx235("path", {
        fill: "#198200",
        d: "M0 0h194.8v480H0zm445.2 0H640v480H445.2z"
      }),
      /* @__PURE__ */ jsx235("path", {
        fill: "#198200",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.7,
        d: "M313.5 351.3v52.6l21.3.2s-6.8-45.8-3.1-52c3.7-6 7.2-5.2 7.2-5.2s13.9 4.2 15.4 3.5c1.5-.6-.2-5.2 7.2-4.6 2.4-.9 1.1-5 3.3-5.2 2.2-.3 44.5 11.8 53.7.4-2.4-6.4-10.7-.5-12.9-.2-2 0-10.3-4-15.1 0-4.4-3.3-24.4-5.5-24.4-5.5-2.6-2.6 47.6 1.3 50.5-.7 5.9-5.9-11-5.2-13.6-3.3a14.8 14.8 0 0 0-14.2-.6c-1.7-4.1-18-2.4-27-3.5-3-1.7-2.5-2.7-.5-3.8 19 .8 37.8 3.3 56.8 2.5 5.1-6.7-6.5-9.3-13.6-3.5-4.2-7-12.7-.3-18.4-1-5.7-.6-3-7.6 4.2-6.5 7.2 1 20.1-.4 22.5-3.7s-1.4-6.7-13.3-3.5c-4-4-13 0-17.1 1.3-5.6-3.1-18.5-.5-22.8.6-4.3-2.6 22.5-7 22.5-7 10.4-.2 16.3-2 19.5-2.8 15.7-8.4-.2-9.3-8.4-3.2-5.1-4-10 .3-14.6 1.8a38.2 38.2 0 0 1-13.4 2c0-.6 12.6-8.3 12.6-8.3s15.3-1.1 18.4-1.5c3-.5 18.8-8.5-2.7-3.1-7.4.6-11.8.2-14.7.4-16.5-1.7 1.6-3.3 1.6-3.3s23.4-2.1 23.7-3.3c.4-9-19.1-4.8-19.3-4.8 0-6.5-18.2.2-18.2 0-3.5-2 2-4.1 2-4.1 4.8-1.2 12-1.6 13.9-3.1 0 0 13.6-.1 15.2-3.7-3.3-9.3-28.8 1.6-32.2 3.2-4.6 0 3-7.4 3.3-7.6.2-.3 21-1.1 30.9-14.5.7-8.1-11.6 4.6-11.6 4.6-1-10.6-13.4.7-20.6 1.5-7.3 1-7.5-3.3-2.5-4 5-.6 10.8-.1 13.6-7.8 2.9-7.7 11.4.4 13-2.4 1.5-2.9-3.1-5.3-3.1-5.3s6.4-6.6-4-6.3c-10.2.2-23.6-1.4-23.6-1.4s10.7-4.1 20.8-4c10 .3 4.6-7.1-5-7.1-9.7 0-14.7-3.3-14.7-3.3l16.4-6.2-1-4.6s9.6-7.7-4-5.9l-15.2 2-27.4 4.1c-.2 0-7.4-2.2-.4-4s31.8-6.7 35.5-5.4c3.7 1.3-.4-9.2-13.6-10.5-13.1-1.3-21.3 3.3-21.3 3.3s-8.5-3.1-.6-5.7c7.9-2.7 20.4.9 20.4.9s14-4.2 2.4-6c-11.6-1.7-15.3 1.6-20.6 1.8-2.1-2.7 18.2-3.3 19.5-5.5-2.2-4-14.8 0-22.2 0-3-1.3-3.3-3.5.3-4.8 7.5-.3 14.6.1 22.1-.2-.2-4 0-8.7-.2-12.8-9.6-1.7-20.8 1.3-26.1 1 1.4-4.3 22-5.5 24.3-6.7 4.8-6-20.1 0-20.4 0-4.3-.6-4-3.4-1.3-5 6.4-.7 20.6 1 19.6-3.4-.8-4-10-1.9-13.6-1-3.8.9-9.3.2-9.3.2-2.3-3.2 21.5-1.9 21.3-4.4-.3-2.8-15.1-.8-20.2-.6-3.9-2.7 19-4.5 19.3-4.8.9-7.3-15.3 0-18.4 0-3 0-1.5-4.6-1.5-4.6s6.3-2.9 6.1-3.3a22 22 0 0 0-5.2-2c-.5 0 0-5 0-5s5.2-4 4.8-5.1c-.5-1.1-6.2.9-6.2.9v-4.4s4.2-.4 4.6-2.4c.5-2-5-2.2-5-2.2l-2.2-23-2 21.5-7.2 1s5 2.9 6 5.8c.8 2.8-6.2 2-6.2 2s5.7 4.8 6.1 6.5c.5 1.8-7.9 2.2-7.9 2.2s7 5 7.5 7.9c.4 2.8 0 4.4 0 4.4s-11.6-10.1-19-7.3c-4 2 8.8 3 17.2 10.3 0 1.7-20.5-5-21.2-.8.4 1.1 21.9 4.2 23.4 7-7.8.3-24-1.7-23.4.9-1.7 3 15.2 1.3 22.3 3.7 2.1 2.4 1.9 4.4-1.7 4.6-6.9-3.3-22.1-5.7-22.2-1.5.1 1 15.8.4 21.5 4.1-7.6 1.8-33.4-3.5-33.5-1 .7 1.3 4.8 6.5 11.8 6.3 7-.2 23.3 2.8 24.4 5 1 2.2-21.1-4.6-29.4-.6-8.4 4 23.9 1.5 29.1 6.3 5.3 4.9-10.5-.4-10.5-.4s-22-3-25.2-1.5c-3.3 1.5-7 5-7 5s2.2 4.4 4.4 3.5c2.2-.9-.7 2.7-.7 2.7s30.7 7.4 37.5 14c6.8 6.6-39-10.3-39-10.3s-18.5 6.8 1 7.2c-2.2 3.3 1.2 5.3 1.2 5.3s32.4 6.8 35.7 12c3.3 5.3-22.1-5-27.9-7.9-5.7-2.8-21.9 1.8-21.7 2.9.3 1 8 2.6 8.1 4.6.3 2-9.4 2.6-9.4 4.4 0 1.7 41 10.3 52 19.5s-32.2-11-32.2-11 2.4 3.3 0 4.2c-2.5.9-11-12.3-25-4.2-2.6 3.4 12.2 6 16 6.4-1.3 3.3-2.4 4.4 2.8 7.7s-10.3-4.8-10.3-4.4l1.1 5.7c-4.8-4-10.7-5.1-16.2-1.1 0 0-.2 4 5.5 6.4-3.1 6.3 3.5 4.3 14 10.3-15.6-4.1-16.9 3.5-5.7 5.2s41.9 2.9 49.1 12.3c7.3 9.4-10.3-3.6-12.3-4-.4.3-.8 4.9-.8 4.9-4.7-2.7-9-5.2-14.6-6.3-.5.9-.3 2.1-.8 3-5-3.7-9.5-6.2-16.9-6.6l-.9 3.5s-6.1-7.7-18.2 0c-6.7 4.9 25.5 1.8 30.7 7.5 5.3 5.7 1.1 6.6 1.1 6.6l-13.1-4.9s-15.6-2.8-20 .7 64 12 66 21.5c1.4 5-16-5.4-31.1-9.9l-1.8 5s-6-6-12.7-7c-.2 0 1.3 6 1.3 6s-16.8-8-25.4-3.8c-8.5 4.2 29.8 6.4 33.3 10.3 3.5 4-11.6-2.6-13 0-1.2 2.7-19.9-4.8-19.6-1.3.2 3.5 2.6 5.5 2.6 5.5s38.8 3.7 40.1 8.3c1.3 4.6-21.5-2.6-21.5-2.6s-2.2 3.3-.4 4.8c1.7 1.6-13.2-8.7-11.8-2-4.9-1.9-17.4-7.8-15.6-3.2 1.7 4.6 35.3 11.2 35.3 11.2s-14.7 1-14 4.8c-19-11.5-18.5-4.2-18-4 .4.2-24.4-6.1-5.7 4s10 8.3 10.3 8.5c.2.2 2 5 1.5 5-.4 0-12.7-6.5-16.9-7-4.1-.4-23.9 5.5-2.8 14.8s34-2.2 45.6-1c11.6 1.4 17 3.4 16 7-1.1 3.8-11.9-12.1-23.2 1.7-13-2.6-21.7-4-15 5.4-21-7.9-34 2.4-7.4 6.6 26 .8 42-6.4 42-6.4s4.5 8.1 10.8 2.4c6.4-5.7 6.6 2.2 6.8 2.2l6.2-2.6z"
      }),
      /* @__PURE__ */ jsx235("path", {
        fill: "#fff",
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.8,
        d: "M316 320.2v-3.7s-8.2-1.5-12.3-.7c-2.3-1.3-4.6-3.1-7.5-1.6-.5 1.2 5.3 4.3 7.2 4.3a41.1 41.1 0 0 0 12.7 1.7zm0 6s-8.3-3.1-11.6.4c.5 3.7 9.7 5.5 11.7 4.5 1.9-1 0-4.8-.1-5zm14 1.4v2.6s9.8 1.9 11.6-.2c1.7-2.1-8-3.5-11.7-2.4zm-.5-10.2.3 2.9s8.6 1.9 11.9-2.8c3.3-4.7-7.5 0-12.2-.1m.4-10v2s6.5 1 8-1.8c1.4-2.8-7.8 0-8-.2m-13.4-6c-1-1.3-4.5-4.8-13.8-5.8-6.5 0 11.7 9.5 13.8 5.9zm13.2-9.7-.2 2.7s22-6.6 27.1-6.1c4.6-1.3 5.6-4.5 5.4-4.5-4-2.9-22.9 2.3-32.3 7.9m.5-7.8-.3 2.6s15.5-3 19.7-6c4.1-3-19.2 3.5-19.4 3.4m-.6-7.6v2.6s10.3-.4 12.5-2.4c1.3-2.1-9.2-.3-12.5-.2m21.6 21.7s5.4.8 6.4-.8c-.2-2.8-6.4 1-6.4.8M330 266.6l.1 5.7s24.9-7.9 26.5-9.3c1.5-1.5 5-6-26.6 3.6m-.7-7.9v4.2s10-.8 14.6-4.5c4.6-3.8-14.6.4-14.6.3m-12-9.3.6 3.7-32.9-10.6c.1 0-1.6-5.4 32.3 6.9m.5-13.3c0 .4 0 3.6-.2 3.5 0 0-22.8-9.5-23.7-8.7-3-7 24 5.4 24 5.2zm11.1 6 .4 3.1s14-2.9 14.8-4.3c.8-1.4-15.2 1.2-15.2 1.1zm.3 7.4c.2.7.4 3.3.4 3.3s5.6-.5 6.5-1.8c.8-1.3-6.9-1.5-6.9-1.5m-.8-17v3s15.4-3 17-4.4c1.7-1.5-17.3 1.4-17 1.4m0-8.5c0 .2-.5 3.1-.1 3.1s18.6-3 21.5-5.7c2.8-2.5-21 2.9-21.3 2.6zm-.2-14.9v3.3s11.8-2.5 14-5c2.2-2.5-14 2-14 1.7m-2-21.6.2 4.8s16-2.2 18.2-4.8c2.3-2.7-18.5 0-18.4 0m-7.4-36.5v3s-7.5-.3-5.7-1.6 5.7-1.1 5.7-1.4m7 4 .2 4.2s9.7-1 10.4-2.5c.8-1.5-10.4-1.6-10.6-1.6zm-.6 6s.2 2.6.4 2.6 3.9-.3 4.7-1.3c.8-1-4.7-1-5-1.3zm-8.2 11.8c0 .3.3 4 0 3.8s-21.2-6.1-23.2-6c-1.9 0-2.4-4.9 23.2 2.2m1.7 6.9c0 .7.5 4.6-.3 4.4-.7-.2-14.3-4.5-12.9-5.8 1.4-1.3 13.2 1.7 13.2 1.4m-1.2 29 .1 3.5s-23.7-7.2-24.5-8.4c-.8-1.2-3.1-6.8 24.4 4.9m1 8.5v3.3l-32.2-11.3s-2.6-8.4 32.1 8z"
      }),
      /* @__PURE__ */ jsx235("path", {
        fill: "#fff",
        stroke: "#000",
        strokeLinejoin: "round",
        strokeWidth: 0.8,
        d: "m280.3 328.7-.2 3.5s-6.2-1.8-8.2-5.3c3.6-1 8.5 1.9 8.4 1.8z"
      })
    ]
  })
});
var Nf_default = SvgNf;

// src/country-flag-icons/generated/Ng.tsx
init_esm_shims();
import { jsx as jsx236, jsxs as jsxs211 } from "react/jsx-runtime";
var SvgNg = (props) => /* @__PURE__ */ jsx236("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs211("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    children: [
      /* @__PURE__ */ jsx236("path", {
        fill: "#fff",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsx236("path", {
        fill: "#008753",
        d: "M426.6 0H640v480H426.6zM0 0h213.3v480H0z"
      })
    ]
  })
});
var Ng_default = SvgNg;

// src/country-flag-icons/generated/Ni.tsx
init_esm_shims();
import { jsx as jsx237, jsxs as jsxs212 } from "react/jsx-runtime";
var SvgNi = (props) => /* @__PURE__ */ jsxs212("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsxs212("defs", {
      children: [
        /* @__PURE__ */ jsxs212("linearGradient", {
          id: "ni_svg__f",
          x1: 498.7,
          x2: 500.6,
          y1: 289.1,
          y2: 283.4,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx237("stop", {
              offset: 0,
              stopColor: "#510000"
            }),
            /* @__PURE__ */ jsx237("stop", {
              offset: 0.3,
              stopColor: "#8a0000"
            }),
            /* @__PURE__ */ jsx237("stop", {
              offset: 1,
              stopColor: "#a00"
            })
          ]
        }),
        /* @__PURE__ */ jsxs212("linearGradient", {
          id: "ni_svg__g",
          x1: 501.4,
          x2: 502.9,
          y1: 291.4,
          y2: 287.4,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx237("stop", {
              offset: 0,
              stopColor: "#ff2a2a"
            }),
            /* @__PURE__ */ jsx237("stop", {
              offset: 1,
              stopColor: "red"
            })
          ]
        }),
        /* @__PURE__ */ jsxs212("linearGradient", {
          id: "ni_svg__b",
          x1: 484.8,
          x2: 484.8,
          y1: 311.7,
          y2: 317.6,
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ jsx237("stop", {
              offset: 0,
              stopColor: "#F5F549"
            }),
            /* @__PURE__ */ jsx237("stop", {
              offset: 1,
              stopColor: "#97C924"
            })
          ]
        }),
        /* @__PURE__ */ jsxs212("linearGradient", {
          id: "ni_svg__a",
          children: [
            /* @__PURE__ */ jsx237("stop", {
              offset: 0,
              stopColor: "#025"
            }),
            /* @__PURE__ */ jsx237("stop", {
              offset: 0.5,
              stopColor: "#04a"
            }),
            /* @__PURE__ */ jsx237("stop", {
              offset: 1,
              stopColor: "#025"
            })
          ]
        }),
        /* @__PURE__ */ jsx237("linearGradient", {
          xlinkHref: "#ni_svg__a",
          id: "ni_svg__h",
          x1: 444.5,
          x2: 634.4,
          y1: 317.5,
          y2: 317.5,
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx237("linearGradient", {
          xlinkHref: "#ni_svg__b",
          id: "ni_svg__v",
          x1: 484.8,
          x2: 484.8,
          y1: 311.7,
          y2: 317.6,
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx237("linearGradient", {
          xlinkHref: "#ni_svg__a",
          id: "ni_svg__o",
          x1: 444.5,
          x2: 634.4,
          y1: 317.5,
          y2: 317.5,
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx237("linearGradient", {
          xlinkHref: "#ni_svg__a",
          id: "ni_svg__p",
          x1: 444.5,
          x2: 634.4,
          y1: 317.5,
          y2: 317.5,
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx237("linearGradient", {
          xlinkHref: "#ni_svg__a",
          id: "ni_svg__q",
          x1: 444.5,
          x2: 634.4,
          y1: 317.5,
          y2: 317.5,
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx237("linearGradient", {
          xlinkHref: "#ni_svg__a",
          id: "ni_svg__r",
          x1: 444.5,
          x2: 634.4,
          y1: 317.5,
          y2: 317.5,
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx237("linearGradient", {
          xlinkHref: "#ni_svg__b",
          id: "ni_svg__u",
          x1: 484.8,
          x2: 484.8,
          y1: 311.7,
          y2: 317.6,
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx237("linearGradient", {
          xlinkHref: "#ni_svg__a",
          id: "ni_svg__x",
          x1: 98.9,
          x2: 125,
          y1: 1440.2,
          y2: 1440.2,
          gradientTransform: "scale(4.45715 .22436)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx237("linearGradient", {
          xlinkHref: "#ni_svg__a",
          id: "ni_svg__j",
          x1: 444.5,
          x2: 634.4,
          y1: 317.5,
          y2: 317.5,
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx237("linearGradient", {
          xlinkHref: "#ni_svg__a",
          id: "ni_svg__l",
          x1: 444.5,
          x2: 634.4,
          y1: 317.5,
          y2: 317.5,
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx237("linearGradient", {
          xlinkHref: "#ni_svg__a",
          id: "ni_svg__m",
          x1: 444.5,
          x2: 634.4,
          y1: 317.5,
          y2: 317.5,
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx237("linearGradient", {
          xlinkHref: "#ni_svg__a",
          id: "ni_svg__i",
          x1: 444.5,
          x2: 634.4,
          y1: 317.5,
          y2: 317.5,
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx237("linearGradient", {
          xlinkHref: "#ni_svg__b",
          id: "ni_svg__s",
          x1: 484.8,
          x2: 484.8,
          y1: 311.7,
          y2: 317.6,
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx237("linearGradient", {
          xlinkHref: "#ni_svg__a",
          id: "ni_svg__y",
          x1: 47.9,
          x2: 61.7,
          y1: 3054.2,
          y2: 3054.2,
          gradientTransform: "scale(9.12405 .1096)",
          gradientUnits: "userSpaceOnUse"
        }),
        /* @__PURE__ */ jsx237("clipPath", {
          id: "ni_svg__c",
          children: /* @__PURE__ */ jsx237("path", {
            d: "m500 226.4-63.7 110.3h127.4z"
          })
        })
      ]
    }),
    /* @__PURE__ */ jsx237("path", {
      fill: "#0067c6",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx237("path", {
      fill: "#fff",
      d: "M0 160h640v160H0z"
    }),
    /* @__PURE__ */ jsx237("path", {
      fill: "#c8a400",
      d: "m248 239.5 8 .5v-1.2l-3-.2.2-3.8 3.3-2.4.1-1.5-3.5 2.5c-.1-.8-.6-1.7-1.4-2-.8-.2-1.6-.2-2.3.3-.8.6-1 1.6-1 2.5zm1.2-1.1.3-4c.1-.6.2-1.4.8-1.8a1 1 0 0 1 1.5.5c.4 1 .2 2.1.1 3.2l-.1 2.2zm-.2-11.2 7.8 1.8 1.8-7.6a198 198 0 0 1-1.1-.2l-1.5 6.4-2.4-.5 1.4-5.8-1.1-.3-1.4 5.8-2-.5 1.4-6.2-1.2-.2zm2.8-10.5 7.6 2.7.4-1.1-3-1 1.2-3.5c.2-1 .4-2-.1-3a2.5 2.5 0 0 0-2-1c-1 0-1.6.7-2 1.5-.6 1-1 2.2-1.3 3.4zm1.5-.7 1.2-3.4c.3-.6.6-1.3 1.3-1.5a1 1 0 0 1 1.2.9c.2 1-.3 2-.6 3l-.7 1.9zm2.7-9 4.3 2.6c.8.4 1.8.6 2.7.2a6.5 6.5 0 0 0 2.4-3c.4-1 .8-2.2.2-3.2-.6-1-1.7-1.4-2.7-2l-2.7-1.6-.6 1 4 2.4c.7.4 1.2 1 1.1 1.9a6 6 0 0 1-1.2 2.5c-.4.6-1.2 1.1-2 1-.8-.2-1.5-.8-2.2-1.2l-2.7-1.5-.6 1zm5.8-9.3 6.3 4.8 3-3.8c.6-.9 1-2 .7-3a2.5 2.5 0 0 0-2-1.4c-.5 0-1 .3-1.2.4.2-.9-.5-1.7-1.2-1.9-1-.3-2 .3-2.6 1l-2 2.5zm1.6-.3c.7-1 1.4-2 2.2-2.8.4-.4 1-1 1.5-.6.5.2.7.9.4 1.3-.4.9-1 1.5-1.6 2.3l-.8 1.1zm2.6 2 2.3-3c.4-.4 1-1 1.6-.8.6.1 1 .7.8 1.3-.3 1-1.1 1.8-1.8 2.7l-1 1.3zm3-10.2 5.5 5.8 4.7-4.5-.8-.8-3.8 3.6h-.1l-4.7-5zm7-6.2 4.9 6.3 1-.7-5-6.3zm7.2-4.9a6.7 6.7 0 0 0-2 1.8 3.6 3.6 0 0 0-.1 4.2 4.1 4.1 0 0 0 1.6 1.5 3.6 3.6 0 0 0 2 .4 6.5 6.5 0 0 0 2.7-1 5.4 5.4 0 0 0 2-2c.4-.8.5-1.6.3-2.4l-1 .4c.2 1.6-.8 2.4-2 3-1.8 1.2-3.5 1.1-4.6-.5-1.1-1.9 0-3.4 1.6-4.4 1.1-.7 2.2-1.2 3.2-.5l.9-.8a3.2 3.2 0 0 0-2-.6c-.9 0-1.7.4-2.6 1zm9.5-4.7-.9 9 1.3-.5.2-2.8 4-1.6 2.2 1.8 1.2-.5-6.8-5.9zm1 1 2.7 2.2-3 1.2zm16.5-6 .5 8 4.3-.2c1.2-.2 2.4-.4 3.1-1.4 1-1 1.2-2.7.7-4.1a3.5 3.5 0 0 0-2.7-2.4c-1.2-.2-2.4 0-3.6 0l-2.3.2zm1.2 1.1 3.5-.1a3 3 0 0 1 1.8.5c.8.6 1.3 1.5 1.2 2.5a2.7 2.7 0 0 1-2 2.4c-.6.2-1.3.2-1.9.3l-2.2.1zm10-1.5-.5 8 7.8.4v-1.1l-6.6-.4.1-2.4 6 .3v-1.1l-5.9-.3.1-2.2 6.4.4v-1.2zm20.8 3.3-2.9 7.5 1 .4 2.4-6v-.2l.2.3 2.8 8 1.3.5 2.9-7.5-1-.4-2.3 6-.1.2-.2-.3-2.7-8zM353 176l-3.7 7-1-.5 3.6-7.1zm6 3.5a6.7 6.7 0 0 0-2.4-1 3.6 3.6 0 0 0-4 1.5 4.1 4.1 0 0 0-.6 2.1c0 .7.1 1.4.6 2.1.4.7 1 1.3 2 2a6 6 0 0 0 2.7 1 3.5 3.5 0 0 0 2.2-.7l-.8-.9c-1.4 1-2.5.3-3.6-.4-1.8-1.2-2.5-2.8-1.4-4.5 1.2-1.8 3.1-1.3 4.7-.3 1 .7 2 1.5 1.8 2.7l1 .4a3.2 3.2 0 0 0-.3-2c-.4-.8-1-1.4-1.9-2m7.6 5.7-8.3 3.4 1 .9 2.6-1 3.3 2.8-.7 2.7 1 .9 2.1-8.8zm-.3 1.4-.8 3.4-2.5-2zm6.4 4.2-6.2 5 .7 1 2.5-2 2.4 3-.7 4 .9 1.1.8-4.2c.7.5 1.7.8 2.5.4.7-.4 1.4-1 1.4-1.8 0-1.1-.7-2-1.3-2.8zm-.2 1.6 2.6 3.2c.4.6.9 1.4.4 2-.3.6-1.1.6-1.6.2-1-.7-1.6-1.7-2.4-2.6l-1-1.1zm9.5 11.1-9 .4.7 1.2 2.8-.1 2.2 3.8-1.6 2.3.7 1.2 4.9-7.6zm-.7 1.2-2 3-1.5-2.8zm5.9 9.4c-.5-1.3-1.3-2.7-2.7-3.4a3.8 3.8 0 0 0-4.5 1c-1 1-1 2.5-.7 3.9.3 1.5 1 3 2 4.1l-.6.2.4 1.1 3.8-1.3-1.5-4.1-.8.3 1 3-1.2.5a7 7 0 0 1-2.1-3.8c-.3-1.1-.3-2.4.5-3.2 1-1 2.6-1.3 3.7-.5s1.7 2.1 2 3.4c.3.9.2 1.9-.4 2.6-.2 0 0 .3.1.4l.3.5a2.8 2.8 0 0 0 1.1-2.2 7 7 0 0 0-.4-2.5m2.3 6.3-4.5.8a4.1 4.1 0 0 0-1.9.8 2.5 2.5 0 0 0-.8 1.5v2.4c.3 1 .6 1.7 1 2.3.3.6.7 1 1.2 1a4 4 0 0 0 2 0l4.5-.8-.2-1.1-4.4.8c-2 .4-2.6-.6-3-2.4-.3-1.8 0-3 1.9-3.3l4.4-.9zm2.4 13.6-8.3-3.6.1 1.4 2.6 1 .3 4.4-2.4 1.5.1 1.3 7.7-4.7zm-1.2.7-3 1.9-.2-3.2zm-136.5 20-1.2.3 1.3 4.9 1.2-.3zm131.6 0 1.2.3-1.3 4.9-1.2-.3zm-119.2 20.5-9 1 .8 1.1 2.8-.3 2.4 3.6-1.4 2.5.8 1 4.3-7.8zm-.7 1.3-1.7 3-1.8-2.6zm4.1 3.6-5.7 5.3.8.8 4.8-4.5-2.6 7 1 .9 6.8-2-4.7 4.3.8.8 5.7-5.3-1.2-1.2-7 2 2.6-6.7zm8.3 8.4-4.8 6.5 6.2 4.6.7-.9-5.3-4 1.5-2 4.7 3.7.7-1-4.7-3.5 1.3-1.7 5 3.8.7-1zm7.8 5.8-3.7 7 1 .6 1.5-2.8 3.4 1.8.8 4 1.3.7-.9-4.2c.9.3 2 .1 2.5-.6.5-.6.9-1.3.6-2.1-.2-1-1.3-1.6-2.1-2.1zm.5 1.5 3.6 2c.6.4 1.3.9 1.2 1.6 0 .7-.7 1-1.3.9-1.2-.2-2.2-.9-3.2-1.4l-1.5-.8zm8.6 3.2-3 7.4 1 .5 3-7.4zm7.2 2.5a6.7 6.7 0 0 0-2.6-.4 3.6 3.6 0 0 0-3.4 2.6 4.1 4.1 0 0 0 0 2.1c0 .8.4 1.4 1 2a6 6 0 0 0 2.4 1.3 5.4 5.4 0 0 0 2.9.2 3.4 3.4 0 0 0 2-1.2l-1-.6c-1 1.3-2.3 1-3.6.5-2-.7-3.1-2-2.5-4 .7-2 2.7-2 4.4-1.5 1.2.4 2.3 1 2.4 2.1l1.2.2a3.2 3.2 0 0 0-.9-2 5.4 5.4 0 0 0-2.3-1.3m8 1.8-5.2 7.3 1.3.2 1.6-2.3 4.4.7.9 2.6 1.3.2-3-8.5zm.5 1.3 1.2 3.4-3.2-.5zm18.3-1.2c-1 .1-1.7.4-2.4.9a3.6 3.6 0 0 0-1.7 3.9c.1.7.4 1.3 1 2 .4.5 1 .8 1.8 1 .7.2 1.7.2 2.8 0 1-.2 2-.6 2.6-1.2a3.4 3.4 0 0 0 1.1-2h-1.2c-.3 1.6-1.5 2-2.8 2.2-2.1.4-3.7-.3-4.1-2.3-.4-2.1 1.3-3.1 3-3.5 1.3-.2 2.5-.3 3.2.7l1-.4a3.2 3.2 0 0 0-1.6-1.3 5.4 5.4 0 0 0-2.7 0m5.3-1 2.3 7.7 7.5-2.2-.4-1.1-6.3 1.9-.7-2.4 5.7-1.7-.3-1-5.7 1.6-.6-2 6-1.8-.3-1.1zm8.7-2.7 3.3 7.3 1-.5-2.8-6 7.8 3.5h.5l1-.5-3.4-7.3-1 .5 2.8 6-8-3.6zm8.8-4.1.6 1 2.8-2h.2l3.7 5.7 1-.7-3.7-5.6v-.1l2.9-2-.6-.9zm8-5.6 5.4 6 .9-.9-2.1-2.3 2.8-2.6 4 .6 1.2-1-4.3-.6c.5-.7.7-1.8.2-2.6-.4-.7-1-1.3-1.9-1.2-1 0-2 .8-2.7 1.4zm1.6.1 3-2.8c.6-.4 1.4-.9 2-.5.7.3.7 1.1.3 1.6-.6 1-1.5 1.7-2.4 2.6l-1.1 1-1.8-2zm7.7-9.4 3.6 8.3.8-1-1-2.6 2.7-3.4 2.7.6.9-1-8.8-2zm1.4.3 3.5.7-2 2.5zm2.1-4.8 6.7 4.3 3.5-5.4-1-.6-2.7 4.3-.1.2h-.1l-5.7-3.8z"
    }),
    /* @__PURE__ */ jsxs212("g", {
      clipPath: "url(#ni_svg__c)",
      transform: "matrix(.8 0 0 .8 -80 0)",
      children: [
        /* @__PURE__ */ jsx237("path", {
          fill: "#fff",
          d: "m500 226.4-31.5 54.5-15.4 26.7h93.8l-14.7-25.4z"
        }),
        /* @__PURE__ */ jsxs212("g", {
          id: "ni_svg__e",
          children: [
            /* @__PURE__ */ jsxs212("g", {
              id: "ni_svg__d",
              children: [
                /* @__PURE__ */ jsx237("path", {
                  fill: "#17c0eb",
                  stroke: "#17c0eb",
                  strokeWidth: 0.1,
                  d: "m500 226.4-2.4 4 2.4 55 2.4-55z",
                  opacity: 0.6
                }),
                /* @__PURE__ */ jsx237("path", {
                  fill: "#fff",
                  d: "M500 277.5h-.1l.1 3 .1-3z"
                })
              ]
            }),
            /* @__PURE__ */ jsx237("use", {
              xlinkHref: "#ni_svg__d",
              width: "100%",
              height: "100%",
              transform: "rotate(72 500 285.5)"
            }),
            /* @__PURE__ */ jsx237("use", {
              xlinkHref: "#ni_svg__d",
              width: "100%",
              height: "100%",
              transform: "rotate(144 500 285.5)"
            }),
            /* @__PURE__ */ jsx237("use", {
              xlinkHref: "#ni_svg__d",
              width: "100%",
              height: "100%",
              transform: "rotate(-144 500 285.5)"
            }),
            /* @__PURE__ */ jsx237("use", {
              xlinkHref: "#ni_svg__d",
              width: "100%",
              height: "100%",
              transform: "rotate(-72 500 285.5)"
            })
          ]
        }),
        /* @__PURE__ */ jsx237("use", {
          xlinkHref: "#ni_svg__e",
          width: "100%",
          height: "100%",
          transform: "rotate(8 500 285.5)"
        }),
        /* @__PURE__ */ jsx237("use", {
          xlinkHref: "#ni_svg__e",
          width: "100%",
          height: "100%",
          transform: "rotate(16 500 285.5)"
        }),
        /* @__PURE__ */ jsx237("use", {
          xlinkHref: "#ni_svg__e",
          width: "100%",
          height: "100%",
          transform: "rotate(24 500 285.5)"
        }),
        /* @__PURE__ */ jsx237("use", {
          xlinkHref: "#ni_svg__e",
          width: "100%",
          height: "100%",
          transform: "rotate(32 500 285.5)"
        }),
        /* @__PURE__ */ jsx237("use", {
          xlinkHref: "#ni_svg__e",
          width: "100%",
          height: "100%",
          transform: "rotate(40 500 285.5)"
        }),
        /* @__PURE__ */ jsx237("use", {
          xlinkHref: "#ni_svg__e",
          width: "100%",
          height: "100%",
          transform: "rotate(48 500 285.5)"
        }),
        /* @__PURE__ */ jsx237("use", {
          xlinkHref: "#ni_svg__e",
          width: "100%",
          height: "100%",
          transform: "rotate(56 500 285.5)"
        }),
        /* @__PURE__ */ jsx237("use", {
          xlinkHref: "#ni_svg__e",
          width: "100%",
          height: "100%",
          transform: "rotate(64 500 285.5)"
        }),
        /* @__PURE__ */ jsx237("path", {
          fill: "red",
          d: "M500 265.8a44.2 44.2 0 0 0-29 10.8L456.4 302a45 45 0 0 0-.8 8.3h5a39.4 39.4 0 0 1 78.7 0h5a45 45 0 0 0-.7-8.3L529 276.6a44.3 44.3 0 0 0-29-10.8"
        }),
        /* @__PURE__ */ jsx237("path", {
          fill: "#f60",
          d: "M500 266.7a43.5 43.5 0 0 0-30.3 12.2l-12 20.9a43.6 43.6 0 0 0-1.3 10.4h4.3a39.4 39.4 0 0 1 78.6 0h4.3a43.9 43.9 0 0 0-1.3-10.5l-12-20.8a43.5 43.5 0 0 0-30.3-12.2"
        }),
        /* @__PURE__ */ jsx237("path", {
          fill: "#ff0",
          d: "M500 267.5a42.7 42.7 0 0 0-32 14.3l-8.7 15a42.7 42.7 0 0 0-2 13.5h3.3a39.4 39.4 0 0 1 78.7 0h3.5c0-4.7-.8-9.2-2.1-13.4l-8.8-15.1a42.6 42.6 0 0 0-31.9-14.3"
        }),
        /* @__PURE__ */ jsx237("path", {
          fill: "#0f0",
          d: "M500 268.3a42 42 0 0 0-34.9 18.6l-2.8 4.9a41.8 41.8 0 0 0-4.3 18.5h2.7a39.4 39.4 0 0 1 78.6 0h2.7a41.8 41.8 0 0 0-4.3-18.5l-2.8-5a42 42 0 0 0-34.9-18.6z"
        }),
        /* @__PURE__ */ jsx237("path", {
          fill: "#0cf",
          d: "M500 269a41.2 41.2 0 0 0-41.2 41.3h1.9a39.4 39.4 0 0 1 78.6 0h1.9A41.2 41.2 0 0 0 500 269"
        }),
        /* @__PURE__ */ jsx237("path", {
          fill: "#00f",
          d: "M500 269.8a40.4 40.4 0 0 0-40.4 40.4h1.4a39 39 0 1 1 78 0h1.4A40.4 40.4 0 0 0 500 270z"
        }),
        /* @__PURE__ */ jsx237("path", {
          fill: "purple",
          d: "M500 270.7a39.6 39.6 0 0 0-39.6 40.3h.8v-.8a38.8 38.8 0 1 1 77.6.8h.8v-.8a39.6 39.6 0 0 0-39.6-39.6z"
        }),
        /* @__PURE__ */ jsx237("path", {
          fill: "#510000",
          d: "M500.4 288.1c-.7 0-1.2-.5-1.8-.6a2.2 2.2 0 0 0-.7 2.1c.3.1.3.4.9.9s.5.7.4 2c0 .4.1 1.5.6 1.6.5.1 1-.3 1.1-1.2.1-.7.4-1.2.7-1.6.3-1.9-.2-2.6-1.2-3.2"
        }),
        /* @__PURE__ */ jsx237("path", {
          fill: "red",
          d: "M497.2 283.5c-.6 0-1.6 1-2 .5-.2-.3-.3-.9 0-1.4a4.8 4.8 0 0 1 2.2-2.3c2.3-1.4 3.9-1 5 1 1.1 1.8 2.2 3.8 2.3 5.4 0 .5.3 1.4-.2 1.9-1.3 1.4-4.6-1.5-6.5-1-.6.1-1.4.6-2 .2-.4-.3 0-1 .3-1.3.6-.5 1.5-2.4 1.4-3.2 0-.4 0 .2-.5.2"
        }),
        /* @__PURE__ */ jsx237("path", {
          fill: "url(#ni_svg__f)",
          d: "M497 282.6c-1.2.4-1 1-1.6 1.5.2.1.8.3 1.4-.3.2-.2.5-.3.7-.3l-.7.7a5.2 5.2 0 0 0-1.4 1.8c-.3.8-.4 1.7-.3 1.8 0 0 .4.8 1.5 1.2 2 .8 2.4 2.5 4.5 2.5 1.6 0 1.4-1.1 2.7-.9 1 .2 1.7-.7.6-1.2a14 14 0 0 0-5.4 0c-.4-4 0-2.6-.1-4.4-.1-1.7-.7-1.8 0-3.3-.5 1-1.2.8-2 .8z"
        }),
        /* @__PURE__ */ jsx237("path", {
          fill: "#ff2a2a",
          d: "m501 279.8-.1.6.3 1 .2 1c0 .3.4.4.7.6.4.3 0 1 .3 1.1.2 0 .5-1 .5-1.2v-.7a15.3 15.3 0 0 0-.5-.9 3.6 3.6 0 0 0-.2-.3 4.2 4.2 0 0 0-.8-.9 4 4 0 0 0-.3-.2l-.2-.1z"
        }),
        /* @__PURE__ */ jsx237("path", {
          fill: "url(#ni_svg__g)",
          d: "m501.3 287.4-2-.7c-1.3-.4-2.6-1.2-3.5-.8-.3.1-.3.4-.4.9 0 .5-.5 1.3 0 1 .6-.4 2.4.8 3 1.1.3.2 1 .6 1.1 1 .2.6 0 1.8 0 2.4 0 .5.2 1.8.7 2 .6.1 1.1-.4 1.3-1.3.3-.9.4-1.4.8-1.9s.8-.8 1.3-.9c.6 0 1.4.5 1.4-.2 0-.4-.4-.8-.2-1.4.1-.5-.4-.4-.9-.6z"
        }),
        /* @__PURE__ */ jsx237("path", {
          fill: "#910000",
          d: "M498.4 288.9c-.4-.2-2.3-1.5-3-1-.3 0-.4 0-.4-.3l.2-.9c0-.3.2-.8.5-1 .7-.6 2.3.5 3.1.8z"
        }),
        /* @__PURE__ */ jsx237("path", {
          fill: "#ff3a3a",
          d: "M501.8 291.4c.9-1.6 1.5-1.4 2.6-1.4.4 0 .5-.3.4-.7-.3.6-1.7 0-2.5.3-1.5.7-1.2 3.7-2 4 .8.7 1.1-1.7 1.5-2.2"
        }),
        /* @__PURE__ */ jsxs212("g", {
          fill: "url(#ni_svg__h)",
          children: [
            /* @__PURE__ */ jsx237("path", {
              fill: "#fff",
              d: "m453.1 307.6-10 17.3H557l-10-17.2h-93.8z"
            }),
            /* @__PURE__ */ jsxs212("g", {
              id: "ni_svg__n",
              fill: "url(#ni_svg__i)",
              children: [
                /* @__PURE__ */ jsx237("path", {
                  id: "ni_svg__k",
                  fill: "url(#ni_svg__j)",
                  d: "M449.7 321.4a36 36 0 0 0-4.7.3l-.5.9c2.4-.3 4.7-.7 7.2-.7 3.2 0 6.2.8 9.7.8h4.6c3.5 0 6.4-.8 9.7-.8 3.3 0 6.3.8 9.8.8h4.6c3.5 0 6.4-.8 9.7-.8 3.3 0 6.3.8 9.8.8h4.5c3.5 0 6.5-.8 9.8-.8 3.3 0 6.3.8 9.8.8h4.5c3.5 0 6.5-.8 9.8-.8 2.6 0 5 .5 7.5.7l-.5-1a38 38 0 0 0-4.4-.2h-4.5c-3.5 0-6.5.7-9.8.8-3.3 0-6.3-.8-9.8-.8H522c-3.5 0-6.5.7-9.8.8-3.3 0-6.3-.8-9.8-.8H498c-3.5 0-6.5.7-9.8.8-3.3 0-6.3-.8-9.8-.8h-4.5c-3.5 0-6.5.7-9.8.8-3.3 0-6.2-.8-9.7-.8z"
                }),
                /* @__PURE__ */ jsx237("use", {
                  xlinkHref: "#ni_svg__k",
                  width: "100%",
                  height: "100%",
                  y: -1.1,
                  fill: "url(#ni_svg__l)"
                }),
                /* @__PURE__ */ jsx237("use", {
                  xlinkHref: "#ni_svg__k",
                  width: "100%",
                  height: "100%",
                  y: -2.2,
                  fill: "url(#ni_svg__m)"
                })
              ]
            }),
            /* @__PURE__ */ jsx237("use", {
              xlinkHref: "#ni_svg__n",
              width: "100%",
              height: "100%",
              y: -3.3,
              fill: "url(#ni_svg__o)"
            }),
            /* @__PURE__ */ jsx237("use", {
              xlinkHref: "#ni_svg__n",
              width: "100%",
              height: "100%",
              y: -6.7,
              fill: "url(#ni_svg__p)"
            }),
            /* @__PURE__ */ jsx237("path", {
              fill: "url(#ni_svg__q)",
              d: "M453.2 307.5v.2h93.7l-.1-.2zm-.2.3-.1.3H547l-.1-.3h-94zm-.2.4-.2.3h94.8l-.2-.3zm-.3.5-.3.5h95.6l-.3-.5zm-.4.7-.3.5h96.4l-.3-.5zm-.4.7-.2.4h97l-.2-.4zm-.4.7-.2.4H549l-.3-.4zm-.4.7-.3.6h98.8l-.3-.6H451z"
            }),
            /* @__PURE__ */ jsx237("path", {
              fill: "url(#ni_svg__r)",
              d: "M457.4 312.3c3.4.7 3.7 0 3.7 0zm81.5 0s.3.7 3.7 0z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs212("g", {
          fill: "#ccd11e",
          children: [
            /* @__PURE__ */ jsxs212("g", {
              id: "ni_svg__t",
              children: [
                /* @__PURE__ */ jsx237("path", {
                  fill: "url(#ni_svg__s)",
                  d: "M530.6 297c-1.7 0-2.2.9-2.2.9-2.7 10.6-11.8 21.3-22.6 21.3h-8V330h61.4l-6.2-11c-9.7-1.4-17.6-11.3-20.1-21.1 0 0-.6-.9-2.3-.9"
                }),
                /* @__PURE__ */ jsx237("path", {
                  fill: "#97c924",
                  d: "M530.6 297.5c-.8 0-1.2.1-1.5.3l-.3.3a33.6 33.6 0 0 1-8.4 14.7c-4 4.1-9 6.9-14.6 6.9h-7.7v9.9H559l-5.7-10c-4.7-.7-9-3.2-12.4-6.8a33.6 33.6 0 0 1-8.4-14.7l-.3-.3a2.8 2.8 0 0 0-1.6-.3"
                }),
                /* @__PURE__ */ jsx237("path", {
                  fill: "#ede71f",
                  d: "M530.6 297.5h.4v10.8a13 13 0 0 1-2 6.4c-.5 1.6-1 1-2.3 2.9a25.4 25.4 0 0 1-5.2 1.2c-2.5.4-8 .8-10.9.1a23 23 0 0 0 9.8-6 30.6 30.6 0 0 0 2.1-2.5 33.7 33.7 0 0 0 3-4.4l1-2a33.9 33.9 0 0 0 1.3-2.9 29.8 29.8 0 0 0 1-3l.3-.3.6-.2z"
                }),
                /* @__PURE__ */ jsx237("path", {
                  fill: "#c6cb24",
                  d: "M530 298.9c-.5 6-2.3 13.2-6.7 17.8-1.6 1.3-3.7 2.6-5.6 2.3 6.7-5.5 10.8-14 12.2-20.1z"
                }),
                /* @__PURE__ */ jsx237("path", {
                  fill: "#9ecb34",
                  d: "M524.5 309.3c-1 2.7-4.8 6.7-8.8 10h-2.9c2.5-.2 8.3-5 11.7-10"
                })
              ]
            }),
            /* @__PURE__ */ jsx237("use", {
              xlinkHref: "#ni_svg__t",
              width: "100%",
              height: "100%",
              x: -15.3
            }),
            /* @__PURE__ */ jsxs212("g", {
              fill: "#c6cb24",
              children: [
                /* @__PURE__ */ jsx237("path", {
                  fill: "url(#ni_svg__u)",
                  d: "M502.2 298c2.8 10.5 11.8 21.2 22.6 21.2h8.1V330h-65.8v-10.8h8c10.8 0 19.9-10.7 22.6-21.3 0 0 .6-.8 2.3-.8 1.7 0 2.2.8 2.2.8z"
                }),
                /* @__PURE__ */ jsx237("path", {
                  fill: "#97c924",
                  d: "M500 297.5c.8 0 1.2.2 1.5.3l.3.3a33.6 33.6 0 0 0 8.4 14.7c4 4.1 9 6.9 14.6 6.9h7.7v9.9h-65v-10h7.7c5.5 0 10.6-2.7 14.6-6.8a33.6 33.6 0 0 0 8.3-14.7l.3-.3a3 3 0 0 1 1.6-.3"
                }),
                /* @__PURE__ */ jsx237("path", {
                  fill: "#ede71f",
                  d: "M499.3 297.5a3.4 3.4 0 0 0-.3 0l-.6.3-.3.3a28.9 28.9 0 0 1-1 3 34.2 34.2 0 0 1-1.2 3 34.2 34.2 0 0 1-1 1.9 33.6 33.6 0 0 1-3 4.4 30.7 30.7 0 0 1-2.1 2.4 23 23 0 0 1-9.8 6.1c2.8.7 4 0 6.5-.4 2-.3 4.2-.6 6-1.2 1.5-2 1-1.3 1.5-2.9 1.2-2.2 3-4.2 3.4-6.7 1.6-3 1.9-8.6 1.9-10.2"
                }),
                /* @__PURE__ */ jsx237("path", {
                  d: "M499.3 298.9c-.4 6-2.3 13.2-6.7 17.8-1.6 1.3-3.6 2.6-5.6 2.3 6.8-5.5 10.9-14 12.3-20.1"
                }),
                /* @__PURE__ */ jsx237("path", {
                  fill: "#9ecb34",
                  d: "M493.8 309.3a31 31 0 0 1-8.8 10h-2.8c2.5-.2 8.2-5 11.6-10"
                }),
                /* @__PURE__ */ jsx237("path", {
                  fill: "#ede71f",
                  d: "m501 297.6.5.2.4.3a32.3 32.3 0 0 0 1 3 33.6 33.6 0 0 0 1.2 3l1 1.9a33.6 33.6 0 0 0 3 4.4 30.7 30.7 0 0 0 2.1 2.4 24 24 0 0 0 9.8 6.5c-7.3 0-10.4-.6-13-4a19 19 0 0 1-4.2-7c-.5-2-2-6.5-1.9-10.7z"
                }),
                /* @__PURE__ */ jsx237("path", {
                  d: "M501.5 298.9c.4 6 2.2 12 6.6 16.6 1.6 1.4 3.6 2.6 5.6 2.3a31.1 31.1 0 0 1-12.2-18.9"
                })
              ]
            }),
            /* @__PURE__ */ jsxs212("g", {
              id: "ni_svg__w",
              children: [
                /* @__PURE__ */ jsx237("path", {
                  fill: "url(#ni_svg__v)",
                  d: "M484.8 297c-1.8 0-2.3.9-2.3.9-2.5 9.8-11.8 22.3-21.5 23.8l-4.8 8.3h49v-11.3c-8.8-2.4-15.9-11.7-18.2-20.8 0 0-.5-.8-2.3-.8z"
                }),
                /* @__PURE__ */ jsx237("path", {
                  fill: "#97c924",
                  d: "M484.8 297.5c-.8 0-1.3.2-1.6.3l-.3.3a43.4 43.4 0 0 1-8.1 15c-3.4 4.3-9.7 8.6-14 9l-4.3 7.5h48v-10.7a23.2 23.2 0 0 1-9.5-6 33.6 33.6 0 0 1-8.4-14.8l-.3-.3a2.9 2.9 0 0 0-1.5-.3"
                }),
                /* @__PURE__ */ jsx237("path", {
                  fill: "#93bc30",
                  d: "M483.4 298.9c-.6 9-5.6 20.5-11.3 22.4-1.9.7-5.1.9-6.2 1a36 36 0 0 0 17.6-23.4z"
                }),
                /* @__PURE__ */ jsx237("path", {
                  fill: "#ede71f",
                  d: "M484.8 297.5h-.5v10.8c0 2.3.9 4.2 2 6.4l.2.5c.5 1.1.8 1.5 2.3 2.7a22 22 0 0 0 14.8 4c-1.1-.9-2.3-1.7-3.4-2.4l4.5-.5a23 23 0 0 1-9.7-6.2 30.5 30.5 0 0 1-1.4-1.5l-.6-.8a35 35 0 0 1-3.2-4.5 34.2 34.2 0 0 1-1-2 34 34 0 0 1-1.6-3.9 31.7 31.7 0 0 1-.6-2l-.3-.3a2.2 2.2 0 0 0-.6-.2 3.6 3.6 0 0 0-1-.1z"
                }),
                /* @__PURE__ */ jsx237("path", {
                  d: "M485.4 298.9c.5 6 2.3 13.2 6.7 17.8 1.6 1.3 3.6 2.6 5.6 2.3a38.5 38.5 0 0 1-12.3-20.1"
                }),
                /* @__PURE__ */ jsx237("path", {
                  fill: "#9ecb34",
                  d: "M489.6 307.3a35 35 0 0 0 14.6 14.9h2.5c-4.4-2.4-11.5-5.8-17-15z"
                })
              ]
            }),
            /* @__PURE__ */ jsx237("use", {
              xlinkHref: "#ni_svg__w",
              width: "100%",
              height: "100%",
              x: -15.4,
              fill: "#c6cb24"
            })
          ]
        }),
        /* @__PURE__ */ jsx237("path", {
          fill: "#fff",
          d: "M556.5 324.7c-.6.2-4.4-.2-6.4 0l-1.3.3h-3.3c-3.6 0-6.7 1-10.1 1-3.4 0-6.5-1-10-1H522c-3.6 0-6.7 1-10.1 1-3.4 0-6.5-1-10-1h-3.4c-3.6 0-6.7 1-10 1-3.5 0-6.5-1-10.1-1H475c-3.6 0-6.6 1-10 1-3.5 0-6.5-1-10.1-1h-3.4c-2.8 0-6.2.6-8.9.8l-6.3 10.9h127.4z"
        }),
        /* @__PURE__ */ jsx237("path", {
          fill: "url(#ni_svg__x)",
          d: "M548 323.1h-.6c-3.2.1-5.6 1.1-11.2 1.1s-6.2-1-12.6-.8c-6 0-8.4 1.2-11.7 1.2-3.2 0-8.4-.7-12.5-.3-4 .4-8.8 1.3-12 1.3-3.9 0-7.8-.7-11.8-.3-4.1.4-6 1.5-11.1 1.5-4.4 0-9-.7-12.8-.7-3.4 0-7.2 1-10 1.4l-.9 1.5c2.3-.3 8.6-1.3 10.8-1.3 2.4 0 10.7.5 15.3.3 4.7-.1 5.2-1.2 10.7-1.2 3.8 0 6.6.4 10.5.4 2.5 0 4.7-1.2 8.4-1.2l2.8-.1c3.1-.5 8.4 0 12 .2 3.3.2 5.5-.6 9-.7l4.4-.1c3.5-.2 6.4.6 9.7.6 3.2-.2 6.4-1 9.8-1l4.5-.2c2.3 0 5.9 0 8.3.5l-.8-1.4c-2.4-.1-5.3-.7-8.2-.7"
        }),
        /* @__PURE__ */ jsxs212("g", {
          id: "ni_svg__A",
          children: [
            /* @__PURE__ */ jsx237("path", {
              id: "ni_svg__z",
              fill: "url(#ni_svg__y)",
              d: "M450.3 334.8c-3.4 0-6.4.8-9.6.9a31.8 31.8 0 0 1-3.6-.3l-.5.8h6c3.5 0 6.4-.8 9.6-.9 3.3.1 6.2 1 9.7 1h4.5c3.4 0 6.4-.9 9.6-1 3.3.1 6.3 1 9.7 1h4.5c3.5 0 6.4-.9 9.7-1 3.2.1 6.1 1 9.6 1h4.5c3.4 0 6.4-.9 9.7-1 3.2.1 6.2 1 9.6 1h4.5c3.5 0 6.4-.9 9.6-1 3.3.1 6.2 1 9.7 1h4.5l1.8-.1-.5-.8c-1 .1-2.1.3-3.2.3-3.3 0-6.2-1-9.7-1h-4.5c-3.4 0-6.4 1-9.6 1-3.3-.1-6.2-1-9.7-1h-4.5c-3.4 0-6.4 1-9.6 1-3.3-.1-6.2-1-9.7-1h-4.5c-3.5 0-6.4 1-9.6 1-3.3-.1-6.2-1-9.7-1h-4.5c-3.4 0-6.4 1-9.6 1-3.3-.1-6.2-1-9.7-1h-4.5z"
            }),
            /* @__PURE__ */ jsx237("use", {
              xlinkHref: "#ni_svg__z",
              width: "100%",
              height: "100%",
              y: -1.3
            }),
            /* @__PURE__ */ jsx237("use", {
              xlinkHref: "#ni_svg__z",
              width: "100%",
              height: "100%",
              y: -2.6
            })
          ]
        }),
        /* @__PURE__ */ jsx237("use", {
          xlinkHref: "#ni_svg__A",
          width: "100%",
          height: "100%",
          y: -3.9
        }),
        /* @__PURE__ */ jsx237("use", {
          xlinkHref: "#ni_svg__A",
          width: "100%",
          height: "100%",
          y: -7.7
        }),
        /* @__PURE__ */ jsx237("path", {
          fill: "#97c924",
          d: "m443.9 324.7-2.5 4.2c2.9-.5 7.1-1.7 10.7-1.7 3.6 0 8 .9 12.4 1 5 0 7-1.2 11-1.6 4.1-.4 8 .5 12 .6 3.1 0 7.9-1.1 12-1.5 4-.5 7.7.3 12.5.3 4.9.1 5.7-1.2 11.6-1.3 6.4-.1 7 .9 12.6.9 4.2.2 7.9-.9 11.7-1.1 3.8-.3 5.5 0 8.3 0l-1.9-3.2-101.3 2.3z"
        }),
        /* @__PURE__ */ jsx237("path", {
          fill: "#fff",
          d: "m550 324.6 4 .3a91.4 91.4 0 0 0 2.9.3l-.4-.5c-.6.2-4.4-.2-6.4 0z"
        })
      ]
    }),
    /* @__PURE__ */ jsx237("path", {
      fill: "#c8a400",
      d: "m320 179.9-25.7 44.5L268 270h104l-25.7-44.6zm0 2.4 25.2 43.7 24.7 42.8h-99.8l25.2-43.8z"
    })
  ]
});
var Ni_default = SvgNi;

// src/country-flag-icons/generated/Nl.tsx
init_esm_shims();
import { jsx as jsx238, jsxs as jsxs213 } from "react/jsx-runtime";
var SvgNl = (props) => /* @__PURE__ */ jsxs213("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx238("path", {
      fill: "#ae1c28",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsx238("path", {
      fill: "#fff",
      d: "M0 160h640v160H0z"
    }),
    /* @__PURE__ */ jsx238("path", {
      fill: "#21468b",
      d: "M0 320h640v160H0z"
    })
  ]
});
var Nl_default = SvgNl;

// src/country-flag-icons/generated/No.tsx
init_esm_shims();
import { jsx as jsx239, jsxs as jsxs214 } from "react/jsx-runtime";
var SvgNo = (props) => /* @__PURE__ */ jsxs214("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx239("path", {
      fill: "#ed2939",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx239("path", {
      fill: "#fff",
      d: "M180 0h120v480H180z"
    }),
    /* @__PURE__ */ jsx239("path", {
      fill: "#fff",
      d: "M0 180h640v120H0z"
    }),
    /* @__PURE__ */ jsx239("path", {
      fill: "#002664",
      d: "M210 0h60v480h-60z"
    }),
    /* @__PURE__ */ jsx239("path", {
      fill: "#002664",
      d: "M0 210h640v60H0z"
    })
  ]
});
var No_default = SvgNo;

// src/country-flag-icons/generated/Np.tsx
init_esm_shims();
import { jsx as jsx240, jsxs as jsxs215 } from "react/jsx-runtime";
var SvgNp = (props) => /* @__PURE__ */ jsxs215("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx240("defs", {
      children: /* @__PURE__ */ jsx240("clipPath", {
        id: "np_svg__a",
        children: /* @__PURE__ */ jsx240("path", {
          fillOpacity: 0.7,
          d: "M0-16h512v512H0z"
        })
      })
    }),
    /* @__PURE__ */ jsx240("g", {
      clipPath: "url(#np_svg__a)",
      transform: "translate(0 15) scale(.9375)",
      children: /* @__PURE__ */ jsxs215("g", {
        fillRule: "evenodd",
        children: [
          /* @__PURE__ */ jsx240("path", {
            fill: "#ce0000",
            stroke: "#000063",
            strokeWidth: 13.8,
            d: "M6.5 489.5h378.8L137.4 238.1l257.3.3L6.6-9.5v499z"
          }),
          /* @__PURE__ */ jsx240("path", {
            fill: "#fff",
            d: "m180.7 355.8-27 9 21.2 19.8-28.5-1.8 11.7 26.2-25.5-12.3.5 28.6-18.8-20.9-10.7 26.6-9.2-26.3-20.3 20.6 1.8-27.7L49 409l12.6-25-29.3.6 21.5-18.3-27.3-10.5 27-9L32.2 327l28.4 1.8L49 302.6l25.6 12.3-.5-28.6 18.8 20.9 10.7-26.6 9.1 26.3 20.4-20.6-1.9 27.7 27-11.4-12.7 25 29.4-.6-21.5 18.3zm-32.4-184.7-11.3 8.4 5.6 4.6a93.8 93.8 0 0 0 30.7-36c1.8 21.3-17.7 69-68.7 69.5a70.6 70.6 0 0 1-71.5-70.3c10 18.2 16.2 27 32 36.5l4.7-4.4-10.6-8.9 13.7-3.6-7.4-12.4 14.4 1-1.8-14.4 12.6 7.4 4-13.5 9 10.8 8.5-10.3 4.6 14 11.8-8.2-1.5 14.3 14.2-1.7-6.7 13.2z"
          })
        ]
      })
    })
  ]
});
var Np_default = SvgNp;

// src/country-flag-icons/generated/Nr.tsx
init_esm_shims();
import { jsx as jsx241, jsxs as jsxs216 } from "react/jsx-runtime";
var SvgNr = (props) => /* @__PURE__ */ jsxs216("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx241("defs", {
      children: /* @__PURE__ */ jsx241("clipPath", {
        id: "nr_svg__a",
        children: /* @__PURE__ */ jsx241("path", {
          fillOpacity: 0.7,
          d: "M-54.7 0H628v512H-54.7z"
        })
      })
    }),
    /* @__PURE__ */ jsxs216("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      clipPath: "url(#nr_svg__a)",
      transform: "translate(51.3) scale(.9375)",
      children: [
        /* @__PURE__ */ jsx241("path", {
          fill: "#002170",
          d: "M-140 0H884v512H-140z"
        }),
        /* @__PURE__ */ jsx241("path", {
          fill: "#ffb20d",
          d: "M-140 234.1H884V278H-140z"
        }),
        /* @__PURE__ */ jsx241("path", {
          fill: "#fff",
          d: "m161.8 438-33-33-10.5 45.4-12-45-31.9 34 12.1-45L42 407.9l33-33-45.4-10.6 45-12-34-31.8 45 12L72 288l33 33 10.6-45.4 12 45 31.8-34-12 45 44.5-13.5-33 33 45.4 10.5-45 12 34 32-45-12.2z"
        })
      ]
    })
  ]
});
var Nr_default = SvgNr;

// src/country-flag-icons/generated/Nu.tsx
init_esm_shims();
import { jsx as jsx242, jsxs as jsxs217 } from "react/jsx-runtime";
var SvgNu = (props) => /* @__PURE__ */ jsxs217("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx242("path", {
      fill: "#fedd00",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx242("path", {
      fill: "#012169",
      d: "M0 0h320v240H0z"
    }),
    /* @__PURE__ */ jsx242("path", {
      fill: "#fff",
      d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0z"
    }),
    /* @__PURE__ */ jsx242("path", {
      fill: "#c8102e",
      d: "M212 140.5 320 220v20l-135.5-99.5zm-92 10 3 17.5-96 72H0zM320 0v1.5l-124.5 94 1-22L295 0zM0 0l119.5 88h-30L0 21z"
    }),
    /* @__PURE__ */ jsx242("path", {
      fill: "#fff",
      d: "M120.5 0v240h80V0zM0 80v80h320V80z"
    }),
    /* @__PURE__ */ jsx242("path", {
      fill: "#c8102e",
      d: "M0 96.5v48h320v-48zM136.5 0v240h48V0z"
    }),
    /* @__PURE__ */ jsx242("circle", {
      cx: 160,
      cy: 120,
      r: 40.8,
      fill: "#012169"
    }),
    /* @__PURE__ */ jsx242("path", {
      fill: "#fedd00",
      d: "m160 79.2 24 73.8-62.8-45.6h77.6L136 153M66.7 98.3l14 43.4L43.9 115h45.7l-37 26.8m200.7-43.5 14.1 43.4-36.9-26.8h45.7l-37 26.8M160 178.3l14.1 43.4-37-26.8h45.7l-37 26.8M160 18.3l14.1 43.4-37-26.8h45.7l-37 26.8"
    })
  ]
});
var Nu_default = SvgNu;

// src/country-flag-icons/generated/Nz.tsx
init_esm_shims();
import { jsx as jsx243, jsxs as jsxs218 } from "react/jsx-runtime";
var SvgNz = (props) => /* @__PURE__ */ jsxs218("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx243("defs", {
      children: /* @__PURE__ */ jsxs218("g", {
        id: "nz_svg__b",
        children: [
          /* @__PURE__ */ jsxs218("g", {
            id: "nz_svg__a",
            children: [
              /* @__PURE__ */ jsx243("path", {
                d: "M0-.3v.5l1-.5z"
              }),
              /* @__PURE__ */ jsx243("path", {
                d: "M.2.3 0-.1l1-.2z"
              })
            ]
          }),
          /* @__PURE__ */ jsx243("use", {
            xlinkHref: "#nz_svg__a",
            transform: "scale(-1 1)"
          }),
          /* @__PURE__ */ jsx243("use", {
            xlinkHref: "#nz_svg__a",
            transform: "rotate(72 0 0)"
          }),
          /* @__PURE__ */ jsx243("use", {
            xlinkHref: "#nz_svg__a",
            transform: "rotate(-72 0 0)"
          }),
          /* @__PURE__ */ jsx243("use", {
            xlinkHref: "#nz_svg__a",
            transform: "scale(-1 1) rotate(72)"
          })
        ]
      })
    }),
    /* @__PURE__ */ jsx243("path", {
      fill: "#00247d",
      fillRule: "evenodd",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsxs218("g", {
      transform: "translate(-111 36.1) scale(.66825)",
      children: [
        /* @__PURE__ */ jsx243("use", {
          xlinkHref: "#nz_svg__b",
          width: "100%",
          height: "100%",
          fill: "#fff",
          transform: "matrix(45.4 0 0 45.4 900 120)"
        }),
        /* @__PURE__ */ jsx243("use", {
          xlinkHref: "#nz_svg__b",
          width: "100%",
          height: "100%",
          fill: "#cc142b",
          transform: "matrix(30 0 0 30 900 120)"
        })
      ]
    }),
    /* @__PURE__ */ jsxs218("g", {
      transform: "rotate(82 525.2 114.6) scale(.66825)",
      children: [
        /* @__PURE__ */ jsx243("use", {
          xlinkHref: "#nz_svg__b",
          width: "100%",
          height: "100%",
          fill: "#fff",
          transform: "rotate(-82 519 -457.7) scale(40.4)"
        }),
        /* @__PURE__ */ jsx243("use", {
          xlinkHref: "#nz_svg__b",
          width: "100%",
          height: "100%",
          fill: "#cc142b",
          transform: "rotate(-82 519 -457.7) scale(25)"
        })
      ]
    }),
    /* @__PURE__ */ jsxs218("g", {
      transform: "rotate(82 525.2 114.6) scale(.66825)",
      children: [
        /* @__PURE__ */ jsx243("use", {
          xlinkHref: "#nz_svg__b",
          width: "100%",
          height: "100%",
          fill: "#fff",
          transform: "rotate(-82 668.6 -327.7) scale(45.4)"
        }),
        /* @__PURE__ */ jsx243("use", {
          xlinkHref: "#nz_svg__b",
          width: "100%",
          height: "100%",
          fill: "#cc142b",
          transform: "rotate(-82 668.6 -327.7) scale(30)"
        })
      ]
    }),
    /* @__PURE__ */ jsxs218("g", {
      transform: "translate(-111 36.1) scale(.66825)",
      children: [
        /* @__PURE__ */ jsx243("use", {
          xlinkHref: "#nz_svg__b",
          width: "100%",
          height: "100%",
          fill: "#fff",
          transform: "matrix(50.4 0 0 50.4 900 480)"
        }),
        /* @__PURE__ */ jsx243("use", {
          xlinkHref: "#nz_svg__b",
          width: "100%",
          height: "100%",
          fill: "#cc142b",
          transform: "matrix(35 0 0 35 900 480)"
        })
      ]
    }),
    /* @__PURE__ */ jsx243("path", {
      fill: "#012169",
      d: "M0 0h320v240H0z"
    }),
    /* @__PURE__ */ jsx243("path", {
      fill: "#fff",
      d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0z"
    }),
    /* @__PURE__ */ jsx243("path", {
      fill: "#c8102e",
      d: "M212 140.5 320 220v20l-135.5-99.5zm-92 10 3 17.5-96 72H0zM320 0v1.5l-124.5 94 1-22L295 0zM0 0l119.5 88h-30L0 21z"
    }),
    /* @__PURE__ */ jsx243("path", {
      fill: "#fff",
      d: "M120.5 0v240h80V0zM0 80v80h320V80z"
    }),
    /* @__PURE__ */ jsx243("path", {
      fill: "#c8102e",
      d: "M0 96.5v48h320v-48zM136.5 0v240h48V0z"
    })
  ]
});
var Nz_default = SvgNz;

// src/country-flag-icons/generated/Om.tsx
init_esm_shims();
import { jsx as jsx244, jsxs as jsxs219 } from "react/jsx-runtime";
var SvgOm = (props) => /* @__PURE__ */ jsxs219("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx244("defs", {
      children: /* @__PURE__ */ jsx244("clipPath", {
        id: "om_svg__a",
        children: /* @__PURE__ */ jsx244("path", {
          fillOpacity: 0.7,
          d: "M0 0h640v480H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs219("g", {
      clipPath: "url(#om_svg__a)",
      children: [
        /* @__PURE__ */ jsx244("path", {
          fill: "#ef2d29",
          fillRule: "evenodd",
          d: "M-3.3-21.6H699v553H-3.3z"
        }),
        /* @__PURE__ */ jsx244("path", {
          fill: "#009025",
          fillRule: "evenodd",
          d: "M174.6 317.3h535.7V525H174.6z"
        }),
        /* @__PURE__ */ jsx244("path", {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M174.6-35.4h564.9v190h-565z"
        }),
        /* @__PURE__ */ jsxs219("g", {
          stroke: "#ef2d28",
          children: [
            /* @__PURE__ */ jsxs219("g", {
              fill: "#fff",
              fillRule: "evenodd",
              transform: "matrix(.19848 0 0 .17744 111.3 -13.4)",
              children: [
                /* @__PURE__ */ jsx244("rect", {
                  width: 138.2,
                  height: 85,
                  x: 17.7,
                  y: 467.7,
                  strokeWidth: 1.4,
                  rx: 11.3,
                  ry: 11.8
                }),
                /* @__PURE__ */ jsx244("rect", {
                  width: 131.1,
                  height: 78,
                  x: 21.3,
                  y: 471.3,
                  strokeWidth: 1.3,
                  rx: 10.7,
                  ry: 10.9
                }),
                /* @__PURE__ */ jsx244("path", {
                  strokeWidth: 1.3,
                  d: "m65 396 9.7.5.4 5.8 8 5.3 6.2-6.7 7.5 5.3-7 5.8 1.7 8 8.8-.5V430l-7-.4-3.6 6.6 8 7.5-6.2 6.2-6.7-6.6-9.7 2.6.5 9.7-10.6 1-1.4-9.4-8.8-4.8-4.9 6.6-7.5-4.9 4.4-7.5-5.3-4.8H34l-.4-13.7 7.5.9 5.3-8-6.2-6.2 8-7 5.7 5.7 9.7-1.8z",
                  transform: "matrix(.68108 0 0 .5852 38 260.7)"
                }),
                /* @__PURE__ */ jsx244("ellipse", {
                  cx: 68.9,
                  cy: 426.8,
                  strokeWidth: 1.3,
                  rx: 11.1,
                  ry: 9.9,
                  transform: "matrix(.65819 0 0 .70224 38.8 209.6)"
                }),
                /* @__PURE__ */ jsx244("path", {
                  strokeWidth: 1.3,
                  d: "m39 474.8-10.7 10.6m17.8-10.6-10.7 10.6m17.7-10.6-10.6 10.6m17.7-10.6-10.6 10.6m17.7-10.6-10.6 10.6m17.7-10.6-10.6 10.6m17.7-10.6-10.6 10.6m17.7-10.6L78 485.4m17.7-10.6L85 485.4m17.8-10.6L92 485.4m17.7-10.6-10.6 10.6m17.7-10.6-10.6 10.6m-17.7-10.6L78 485.4m46-10.6-10.6 10.6m17.7-10.6-10.6 10.6m17.7-10.6-10.6 10.6m17.7-10.6-10.6 10.6m0-10.6 10.6 10.6m-17.7-10.6 10.6 10.6m-17.7-10.6 10.6 10.6m-17.7-10.6 10.6 10.6m-17.7-10.6 10.6 10.6m-17.7-10.6 10.6 10.6m-17.7-10.6 10.7 10.6M85 474.8l10.6 10.6m-17.8-10.6 10.7 10.6m-17.7-10.6 10.6 10.6m-17.7-10.6 10.6 10.6m-17.7-10.6 10.6 10.6M85 474.8l10.6 10.6m-46-10.6 10.5 10.6m-17.7-10.6 10.7 10.6m-17.8-10.6L46 485.4m-17.8-10.6L39 485.4m0 49.6-10.6 10.7M46 535l-10.7 10.7M53.2 535l-10.7 10.7M60.2 535l-10.6 10.7M67.3 535l-10.6 10.7M74.4 535l-10.6 10.7M81.5 535 71 545.7M88.6 535 78 545.7M95.7 535 85 545.7m17.7-10.7L92 545.7m18-10.7-10.7 10.7M117 535l-10.6 10.7M88.6 535 78 545.7m46-10.7-10.6 10.7m17.7-10.7-10.6 10.7m17.7-10.7-10.6 10.7m17.7-10.7-10.6 10.7m0-10.7 10.6 10.7M127.6 535l10.6 10.7M120.5 535l10.6 10.7M113.4 535l10.6 10.7M106.3 535l10.6 10.7M99.2 535l10.7 10.7M92 535l10.7 10.7M85 535l10.6 10.7M78 535l10.6 10.7M70.9 535l10.6 10.7M63.8 535l10.6 10.7M56.7 535l10.6 10.7M85.1 535l10.6 10.7m-46-10.7 10.5 10.7M42.5 535l10.7 10.7M35.4 535l10.7 10.7M28.4 535 39 545.7"
                })
              ]
            }),
            /* @__PURE__ */ jsxs219("g", {
              fill: "#fff",
              fillRule: "evenodd",
              transform: "matrix(.19848 0 0 .17744 19.1 -14)",
              children: [
                /* @__PURE__ */ jsx244("rect", {
                  width: 138.2,
                  height: 85,
                  x: 17.7,
                  y: 467.7,
                  strokeWidth: 1.4,
                  rx: 11.3,
                  ry: 11.8
                }),
                /* @__PURE__ */ jsx244("rect", {
                  width: 131.1,
                  height: 78,
                  x: 21.3,
                  y: 471.3,
                  strokeWidth: 1.3,
                  rx: 10.7,
                  ry: 10.9
                }),
                /* @__PURE__ */ jsx244("path", {
                  strokeWidth: 1.3,
                  d: "m65 396 9.7.5.4 5.8 8 5.3 6.2-6.7 7.5 5.3-7 5.8 1.7 8 8.8-.5V430l-7-.4-3.6 6.6 8 7.5-6.2 6.2-6.7-6.6-9.7 2.6.5 9.7-10.6 1-1.4-9.4-8.8-4.8-4.9 6.6-7.5-4.9 4.4-7.5-5.3-4.8H34l-.4-13.7 7.5.9 5.3-8-6.2-6.2 8-7 5.7 5.7 9.7-1.8z",
                  transform: "matrix(.68108 0 0 .5852 38 260.7)"
                }),
                /* @__PURE__ */ jsx244("ellipse", {
                  cx: 68.9,
                  cy: 426.8,
                  strokeWidth: 1.3,
                  rx: 11.1,
                  ry: 9.9,
                  transform: "matrix(.65819 0 0 .70224 38.8 209.6)"
                }),
                /* @__PURE__ */ jsx244("path", {
                  strokeWidth: 1.3,
                  d: "m39 474.8-10.7 10.6m17.8-10.6-10.7 10.6m17.7-10.6-10.6 10.6m17.7-10.6-10.6 10.6m17.7-10.6-10.6 10.6m17.7-10.6-10.6 10.6m17.7-10.6-10.6 10.6m17.7-10.6L78 485.4m17.7-10.6L85 485.4m17.8-10.6L92 485.4m17.7-10.6-10.6 10.6m17.7-10.6-10.6 10.6m-17.7-10.6L78 485.4m46-10.6-10.6 10.6m17.7-10.6-10.6 10.6m17.7-10.6-10.6 10.6m17.7-10.6-10.6 10.6m0-10.6 10.6 10.6m-17.7-10.6 10.6 10.6m-17.7-10.6 10.6 10.6m-17.7-10.6 10.6 10.6m-17.7-10.6 10.6 10.6m-17.7-10.6 10.6 10.6m-17.7-10.6 10.7 10.6M85 474.8l10.6 10.6m-17.8-10.6 10.7 10.6m-17.7-10.6 10.6 10.6m-17.7-10.6 10.6 10.6m-17.7-10.6 10.6 10.6M85 474.8l10.6 10.6m-46-10.6 10.5 10.6m-17.7-10.6 10.7 10.6m-17.8-10.6L46 485.4m-17.8-10.6L39 485.4m0 49.6-10.6 10.7M46 535l-10.7 10.7M53.2 535l-10.7 10.7M60.2 535l-10.6 10.7M67.3 535l-10.6 10.7M74.4 535l-10.6 10.7M81.5 535 71 545.7M88.6 535 78 545.7M95.7 535 85 545.7m17.7-10.7L92 545.7m18-10.7-10.7 10.7M117 535l-10.6 10.7M88.6 535 78 545.7m46-10.7-10.6 10.7m17.7-10.7-10.6 10.7m17.7-10.7-10.6 10.7m17.7-10.7-10.6 10.7m0-10.7 10.6 10.7M127.6 535l10.6 10.7M120.5 535l10.6 10.7M113.4 535l10.6 10.7M106.3 535l10.6 10.7M99.2 535l10.7 10.7M92 535l10.7 10.7M85 535l10.6 10.7M78 535l10.6 10.7M70.9 535l10.6 10.7M63.8 535l10.6 10.7M56.7 535l10.6 10.7M85.1 535l10.6 10.7m-46-10.7 10.5 10.7M42.5 535l10.7 10.7M35.4 535l10.7 10.7M28.4 535 39 545.7"
                })
              ]
            }),
            /* @__PURE__ */ jsx244("path", {
              fill: "#fff",
              fillRule: "evenodd",
              strokeWidth: 1.3,
              d: "M538.6 531.5c1.7 166.6 24.8 202 3.5 202s-31.9-92.1-31.9-205.5 14.2-205.5 35.5-205.5-9 31.9-7.1 209z",
              transform: "matrix(-.32136 -.12684 -.20158 .20221 345.9 61.4)"
            }),
            /* @__PURE__ */ jsx244("path", {
              fill: "#fff",
              fillRule: "evenodd",
              strokeWidth: 1.2,
              d: "m545.7 779.5-60.3 17.7c56.7 60.3 120.5 85 138.2 74.4 17.7-10.6-31.9-35.4-78-92z",
              transform: "matrix(-.19848 0 0 .17744 145.3 -13.4)"
            }),
            /* @__PURE__ */ jsx244("path", {
              fill: "#fff",
              fillRule: "evenodd",
              strokeWidth: 1.3,
              d: "m547.3 786.9-51 14.7c56.7 60.3 112.8 77.4 127.3 70 14.6-7.3-30.3-28-76.3-84.7z",
              transform: "matrix(-.19334 0 0 .17062 142.8 -8.1)"
            }),
            /* @__PURE__ */ jsx244("path", {
              fill: "none",
              strokeWidth: 1.8,
              d: "M353.1 634.2c.2 1.3.8 7.1 1.3 9.4 0 3.2.3 5.6.6 8.1.8 2.2.7 4.2 3.1 5a9.9 9.9 0 0 0 5 4.4 27.7 27.7 0 0 0 6.3 3.8 11.6 11.6 0 0 0 7.5.6c2.2-1.5 3.8-3.1 5.6-4.4.4-2 .8-4.9 1.3-6.9a32.6 32.6 0 0 0-1.3 8.2c.2 3 1.3 4.4 2.5 6.8",
              transform: "matrix(-.13978 0 0 .12414 123 20.4)"
            }),
            /* @__PURE__ */ jsx244("path", {
              fill: "none",
              strokeWidth: 1.8,
              d: "m389.4 681.7.6-.6c-1.5 1.5-.9.8 2.5-1.3 2.4-1.2 5-1.8 8.1-2.4h8.8c3.4 0 5.7.5 8.1 1.2 1.8 1.8 4.4 2.8 6.3 4.4a11 11 0 0 1 3.7 5c1.7 1.7 2.8 4.3 4.4 5.6.7 2.9 2.1 2.8 3.1 5-3 .2-5.3.6-6.9 2.5-2.6 1.3 2.2-1.3 3.2-2.5 2-.6 2.5-1.2 5.6-1.2 2.8-1 4.6.7 7.5 1.2 1.7 1 2.2 1.3 4.4 1.3",
              transform: "matrix(-.13978 0 0 .12414 124.9 19.7)"
            }),
            /* @__PURE__ */ jsx244("path", {
              fill: "none",
              strokeWidth: 1.8,
              d: "M438.1 724.9c1.3 0 7.1 1.1 9.4 0 2.6-.7 4-2 5.6-4.4.8-1.7 0 3 0 5 .3 3.7 1.4 3.7 3.2 6.2 1.8 1.2 3.7 2.8 5.6 3.8a18 18 0 0 0 5.6 3.1c2 1 4.1 1.8 5.6 3.1 2.1 1.5 2 3.3 3.2 5.7-.3 3-.8 4.8-2.5 6.2-.8 2.1-2.4 4.2-3.8 5.6-1.5 3-3.3 4.3.6 5 2.2 1 3.4.2 5.7 0",
              transform: "matrix(-.13978 0 0 .12414 127 18.2)"
            }),
            /* @__PURE__ */ jsx244("path", {
              fill: "none",
              strokeWidth: 1.8,
              d: "M480.6 771.7c1.6-.4 7-2.2 9.4-3.1h8.8c3.3.3 4 1.3 6.8 2.5 1.9 1.9 3.1 3.2 5.7 4.4 1.3 1.7 4 4.7 5 6.9a25.5 25.5 0 0 1 1.2 8c0 3.7-1 4.4-1.2 7.6a19.3 19.3 0 0 1-3.8 7.5c-.3.8-.5 1-1.2 1.2",
              transform: "matrix(-.13978 0 0 .12414 127.4 17.8)"
            }),
            /* @__PURE__ */ jsx244("path", {
              fill: "none",
              strokeWidth: 2.3,
              d: "M538.1 818c.4 0 1.2 2 2.5 3.7 2.9 3 3.2 3.2 7.5 3.2 4-.2 3.5-1.6 6.3-2.5 1.3-2 2.9-3.6 4.4-6.3 1-1.6 1.9-4.1 3-5.6 1.2-1.9 2.6-3.3 3.8-5 1.2-.5 1.6-1 3.2-1.3-3.6.6-4 1.9-6.3 3.8a58.9 58.9 0 0 0-3.1 5.6c-.4 2.7-1.2 4.8-1.3 8.1 0 3.5 0 5.9 1.3 8.8 1.5 1.5 2.5 3.1 4.4 4.4a36.7 36.7 0 0 1 4.3 5l5.7 3.7c1.8 1.1 3.9 2.2 6.8 2.5 3.7-.3 4.8-1.3 7.5-2.5 2.4-1.7 4.2-2.8 6.3-4.4a21 21 0 0 0 4.4-5c3.3-.8 5.5-.5 7.5 1.3a16.5 16.5 0 0 1 4.3 4.4c1 .5 2.8 2 3.8 2.5",
              transform: "matrix(-.09924 0 0 .09799 109.5 38.8)"
            }),
            /* @__PURE__ */ jsx244("path", {
              fill: "none",
              strokeWidth: 1.9,
              d: "M503.8 836.1c-.8.3-3.8 2.4-5 3.1-.8 2.7-2.1 4.1-2.5 7-.7 2.6-.7 5.6-.7 8.7.7 3.2 2 5.5 3.2 8 2 1.4 3 2.4 5.6 3.8 2.5.4 5 .7 8.1.7 2 .6 5.6.9 7.5 0 2.8-.4 4.9-1.5 6.9-2.5 2.3-1.3 3.7-2.6 6.2-3.8 1.3-1.8 3.2-3.5 5-5.6 1.6-2.1 2.7-3.3 3.8-5.6-1 2.6-2.3 5-3.1 7.5-1.5 2.6-2.3 3.6-2.5 6.8-1 2.6-.7 5.8-.7 8.8.3 2 .4 5.8 1.3 7.5v1.9",
              transform: "matrix(-.12338 0 0 .12229 111.4 19.3)"
            }),
            /* @__PURE__ */ jsx244("path", {
              fill: "none",
              strokeWidth: 1.2,
              d: "M541.3 799.2v.7c0-1.7 0-.9-.7 2.5-1.1 1.4-4 1.8-6.2 1.2-2-1.7-2-3-5.6-3.7-3.6.2-5 1.2-7 2.5a9.5 9.5 0 0 0-5 4.3c-.7 2.1-1.1 3.6 1.3 4.4a15.2 15.2 0 0 0 7 2.5c2.8 0 4.9-.3 6.2 1.3 2 2 1.8 3.2 1.8 6.8.7 1.1.8 4.4 1.3 5.7a10.6 10.6 0 0 0 5.6 1.2c.7-2 1.4-5.4 1.9-7.5.5-2.2.6-5.4 1.9-6.9a16.6 16.6 0 0 1 4.3-4.4 8 8 0 0 1 3.8-2.4c-2.5 1.2-2.8 2.6-3.1 5.6 2.1 1 2.7 1.8 6.2 1.9 3.5-.3 4.3-1.2 5.6-3.2.3 3.2 1.3 4.2 2 7 1.2 1.8 1.7 3.7 3 6.2-.5 3-1.7 3.1-1.8 6.8-.8 2.5-.8 4.8-2.5 6.3-.8 1-1.4 1.1-3.2 1.2 3.6 0 5.8-.4 8.2-1.8 1.8-1.2 3.2-2.6 5-3.8a23.9 23.9 0 0 1 7.5-3.8c2.9 0 5-.3 6.2 1.3 1.8 1.3 3 3.5 3.8 6.3.5 3.2.8 5.4-.7 7.5-1 2.4-1.3 3.3 0 6.2 1.5 2 3.6 2.3 7 3.1 2.3-.1 4.6-.6 6.2-1.2",
              transform: "matrix(-.19848 0 0 .17744 145.3 -13.4)"
            }),
            /* @__PURE__ */ jsxs219("g", {
              fillRule: "evenodd",
              strokeWidth: 1.3,
              transform: "matrix(-.19848 0 0 .17744 145.3 -13.4)",
              children: [
                /* @__PURE__ */ jsx244("path", {
                  fill: "#fff",
                  d: "M531.5 359.6c0-165.2 8-299.4 17.7-299.4 9.8 0 17.7 134.2 17.7 299.4z",
                  transform: "matrix(1.4216 -.73423 .46161 .89375 -716.8 541)"
                }),
                /* @__PURE__ */ jsx244("path", {
                  fill: "#fff",
                  d: "M531.5 359.6c0-165.2 8-299.4 17.7-299.4 9.8 0 17.7 134.2 17.7 299.4",
                  transform: "matrix(1.1373 -.58739 .44532 .86221 -554.8 471.8)"
                }),
                /* @__PURE__ */ jsx244("path", {
                  fill: "#fff",
                  d: "M563.4 301.2c.2 18.9 0 40.2 0 60.2H535c0-20-.2-41.3 0-60.2z",
                  transform: "matrix(1.4216 -.73423 .45889 .88849 -716.7 541.4)"
                }),
                /* @__PURE__ */ jsx244("path", {
                  fill: "#fff",
                  d: "M559.8 304.7c.2 19 0 33.1 0 53.2h-21.2c0-20-.2-34.3 0-53.2z",
                  transform: "matrix(1.4216 -.73423 .45889 .88849 -716.7 541.4)"
                }),
                /* @__PURE__ */ jsx244("path", {
                  fill: "#fff",
                  d: "M542.1 311.8h14.2v39h-14.2zm0 0 14.2 39m-14.2 0 14.2-39m-14.2-198.4h14.2",
                  transform: "matrix(1.4216 -.73423 .45889 .88849 -716.7 541.4)"
                }),
                /* @__PURE__ */ jsx244("circle", {
                  cx: 545.7,
                  cy: 92.1,
                  r: 3.5,
                  fill: "#ef0000",
                  transform: "matrix(1.6046 .45375 -.36215 1.5787 -734.9 -170.8)"
                })
              ]
            }),
            /* @__PURE__ */ jsx244("path", {
              fill: "#fff",
              fillRule: "evenodd",
              strokeWidth: 1.3,
              d: "M538.6 531.5c1.7 166.6 24.8 202 3.5 202s-31.9-92.1-31.9-205.5 14.2-205.5 35.5-205.5-9 31.9-7.1 209z",
              transform: "matrix(.32136 -.12684 .20158 .20221 -181.5 60.8)"
            }),
            /* @__PURE__ */ jsx244("path", {
              fill: "#fff",
              fillRule: "evenodd",
              strokeWidth: 1.2,
              d: "m545.7 779.5-60.3 17.7c56.7 60.3 120.5 85 138.2 74.4 17.7-10.6-31.9-35.4-78-92z",
              transform: "matrix(.19848 0 0 .17744 19.1 -14)"
            }),
            /* @__PURE__ */ jsx244("path", {
              fill: "#fff",
              fillRule: "evenodd",
              strokeWidth: 1.3,
              d: "m547.3 786.9-51 14.7c56.7 60.3 112.8 77.4 127.3 70 14.6-7.3-30.3-28-76.3-84.7z",
              transform: "matrix(.19334 0 0 .17062 21.6 -8.8)"
            }),
            /* @__PURE__ */ jsx244("path", {
              fill: "none",
              strokeWidth: 1.8,
              d: "M353.1 634.2c.2 1.3.8 7.1 1.3 9.4 0 3.2.3 5.6.6 8.1.8 2.2.7 4.2 3.1 5a9.9 9.9 0 0 0 5 4.4 27.7 27.7 0 0 0 6.3 3.8 11.6 11.6 0 0 0 7.5.6c2.2-1.5 3.8-3.1 5.6-4.4.4-2 .8-4.9 1.3-6.9a32.6 32.6 0 0 0-1.3 8.2c.2 3 1.3 4.4 2.5 6.8",
              transform: "matrix(.13978 0 0 .12414 41.4 19.7)"
            }),
            /* @__PURE__ */ jsx244("path", {
              fill: "none",
              strokeWidth: 1.8,
              d: "m389.4 681.7.6-.6c-1.5 1.5-.9.8 2.5-1.3 2.4-1.2 5-1.8 8.1-2.4h8.8c3.4 0 5.7.5 8.1 1.2 1.8 1.8 4.4 2.8 6.3 4.4a11 11 0 0 1 3.7 5c1.7 1.7 2.8 4.3 4.4 5.6.7 2.9 2.1 2.8 3.1 5-3 .2-5.3.6-6.9 2.5-2.6 1.3 2.2-1.3 3.2-2.5 2-.6 2.5-1.2 5.6-1.2 2.8-1 4.6.7 7.5 1.2 1.7 1 2.2 1.3 4.4 1.3",
              transform: "matrix(.13978 0 0 .12414 39.5 19)"
            }),
            /* @__PURE__ */ jsx244("path", {
              fill: "none",
              strokeWidth: 1.8,
              d: "M438.1 724.9c1.3 0 7.1 1.1 9.4 0 2.6-.7 4-2 5.6-4.4.8-1.7 0 3 0 5 .3 3.7 1.4 3.7 3.2 6.2 1.8 1.2 3.7 2.8 5.6 3.8a18 18 0 0 0 5.6 3.1c2 1 4.1 1.8 5.6 3.1 2.1 1.5 2 3.3 3.2 5.7-.3 3-.8 4.8-2.5 6.2-.8 2.1-2.4 4.2-3.8 5.6-1.5 3-3.3 4.3.6 5 2.2 1 3.4.2 5.7 0",
              transform: "matrix(.13978 0 0 .12414 37.4 17.6)"
            }),
            /* @__PURE__ */ jsx244("path", {
              fill: "none",
              strokeWidth: 1.8,
              d: "M480.6 771.7c1.6-.4 7-2.2 9.4-3.1h8.8c3.3.3 4 1.3 6.8 2.5 1.9 1.9 3.1 3.2 5.7 4.4 1.3 1.7 4 4.7 5 6.9a25.5 25.5 0 0 1 1.2 8c0 3.7-1 4.4-1.2 7.6a19.3 19.3 0 0 1-3.8 7.5c-.3.8-.5 1-1.2 1.2",
              transform: "matrix(.13978 0 0 .12414 37 17.2)"
            }),
            /* @__PURE__ */ jsx244("path", {
              fill: "none",
              strokeWidth: 2.3,
              d: "M538.1 818c.4 0 1.2 2 2.5 3.7 2.9 3 3.2 3.2 7.5 3.2 4-.2 3.5-1.6 6.3-2.5 1.3-2 2.9-3.6 4.4-6.3 1-1.6 1.9-4.1 3-5.6 1.2-1.9 2.6-3.3 3.8-5 1.2-.5 1.6-1 3.2-1.3-3.6.6-4 1.9-6.3 3.8a58.9 58.9 0 0 0-3.1 5.6c-.4 2.7-1.2 4.8-1.3 8.1 0 3.5 0 5.9 1.3 8.8 1.5 1.5 2.5 3.1 4.4 4.4a36.7 36.7 0 0 1 4.3 5l5.7 3.7c1.8 1.1 3.9 2.2 6.8 2.5 3.7-.3 4.8-1.3 7.5-2.5 2.4-1.7 4.2-2.8 6.3-4.4a21 21 0 0 0 4.4-5c3.3-.8 5.5-.5 7.5 1.3a16.5 16.5 0 0 1 4.3 4.4c1 .5 2.8 2 3.8 2.5",
              transform: "matrix(.09924 0 0 .09799 55 38.2)"
            }),
            /* @__PURE__ */ jsx244("path", {
              fill: "none",
              strokeWidth: 1.9,
              d: "M503.8 836.1c-.8.3-3.8 2.4-5 3.1-.8 2.7-2.1 4.1-2.5 7-.7 2.6-.7 5.6-.7 8.7.7 3.2 2 5.5 3.2 8 2 1.4 3 2.4 5.6 3.8 2.5.4 5 .7 8.1.7 2 .6 5.6.9 7.5 0 2.8-.4 4.9-1.5 6.9-2.5 2.3-1.3 3.7-2.6 6.2-3.8 1.3-1.8 3.2-3.5 5-5.6 1.6-2.1 2.7-3.3 3.8-5.6-1 2.6-2.3 5-3.1 7.5-1.5 2.6-2.3 3.6-2.5 6.8-1 2.6-.7 5.8-.7 8.8.3 2 .4 5.8 1.3 7.5v1.9",
              transform: "matrix(.12338 0 0 .12229 53 18.6)"
            }),
            /* @__PURE__ */ jsx244("path", {
              fill: "none",
              strokeWidth: 1.2,
              d: "M541.3 799.2v.7c0-1.7 0-.9-.7 2.5-1.1 1.4-4 1.8-6.2 1.2-2-1.7-2-3-5.6-3.7-3.6.2-5 1.2-7 2.5a9.5 9.5 0 0 0-5 4.3c-.7 2.1-1.1 3.6 1.3 4.4a15.2 15.2 0 0 0 7 2.5c2.8 0 4.9-.3 6.2 1.3 2 2 1.8 3.2 1.8 6.8.7 1.1.8 4.4 1.3 5.7a10.6 10.6 0 0 0 5.6 1.2c.7-2 1.4-5.4 1.9-7.5.5-2.2.6-5.4 1.9-6.9a16.6 16.6 0 0 1 4.3-4.4 8 8 0 0 1 3.8-2.4c-2.5 1.2-2.8 2.6-3.1 5.6 2.1 1 2.7 1.8 6.2 1.9 3.5-.3 4.3-1.2 5.6-3.2.3 3.2 1.3 4.2 2 7 1.2 1.8 1.7 3.7 3 6.2-.5 3-1.7 3.1-1.8 6.8-.8 2.5-.8 4.8-2.5 6.3-.8 1-1.4 1.1-3.2 1.2 3.6 0 5.8-.4 8.2-1.8 1.8-1.2 3.2-2.6 5-3.8a23.9 23.9 0 0 1 7.5-3.8c2.9 0 5-.3 6.2 1.3 1.8 1.3 3 3.5 3.8 6.3.5 3.2.8 5.4-.7 7.5-1 2.4-1.3 3.3 0 6.2 1.5 2 3.6 2.3 7 3.1 2.3-.1 4.6-.6 6.2-1.2",
              transform: "matrix(.19848 0 0 .17744 19.1 -14)"
            }),
            /* @__PURE__ */ jsxs219("g", {
              fillRule: "evenodd",
              strokeWidth: 1.3,
              transform: "matrix(.19848 0 0 .17744 19.1 -14)",
              children: [
                /* @__PURE__ */ jsx244("path", {
                  fill: "#fff",
                  d: "M531.5 359.6c0-165.2 8-299.4 17.7-299.4 9.8 0 17.7 134.2 17.7 299.4z",
                  transform: "matrix(1.4216 -.73423 .46161 .89375 -716.8 541)"
                }),
                /* @__PURE__ */ jsx244("path", {
                  fill: "#fff",
                  d: "M531.5 359.6c0-165.2 8-299.4 17.7-299.4 9.8 0 17.7 134.2 17.7 299.4",
                  transform: "matrix(1.1373 -.58739 .44532 .86221 -554.8 471.8)"
                }),
                /* @__PURE__ */ jsx244("path", {
                  fill: "#fff",
                  d: "M563.4 301.2c.2 18.9 0 40.2 0 60.2H535c0-20-.2-41.3 0-60.2z",
                  transform: "matrix(1.4216 -.73423 .45889 .88849 -716.7 541.4)"
                }),
                /* @__PURE__ */ jsx244("path", {
                  fill: "#fff",
                  d: "M559.8 304.7c.2 19 0 33.1 0 53.2h-21.2c0-20-.2-34.3 0-53.2z",
                  transform: "matrix(1.4216 -.73423 .45889 .88849 -716.7 541.4)"
                }),
                /* @__PURE__ */ jsx244("path", {
                  fill: "#fff",
                  d: "M542.1 311.8h14.2v39h-14.2zm0 0 14.2 39m-14.2 0 14.2-39m-14.2-198.4h14.2",
                  transform: "matrix(1.4216 -.73423 .45889 .88849 -716.7 541.4)"
                }),
                /* @__PURE__ */ jsx244("circle", {
                  cx: 545.7,
                  cy: 92.1,
                  r: 3.5,
                  fill: "#ef0000",
                  transform: "matrix(1.6046 .45375 -.36215 1.5787 -734.9 -170.8)"
                })
              ]
            }),
            /* @__PURE__ */ jsxs219("g", {
              fill: "#fff",
              fillRule: "evenodd",
              transform: "matrix(.19848 0 0 .17744 19.1 -14)",
              children: [
                /* @__PURE__ */ jsx244("path", {
                  strokeWidth: 1.3,
                  d: "M305.6 396.9c0 124 .5 170.7-5.6 177.1-5.8 6.9-167.1 0-167.1 35.4s132.8 71 172.7 71c53.2 0 79.7-35.5 79.7-106.4V397h-79.7z",
                  transform: "matrix(1.3333 0 0 1 -141.7 0)"
                }),
                /* @__PURE__ */ jsx244("path", {
                  strokeWidth: 1.3,
                  d: "M265.8 396.9v17.7a321.1 321.1 0 0 0 106.2 0v-17.7a321.1 321.1 0 0 1-106.2 0z",
                  transform: "matrix(1 0 0 .99999 0 35.4)"
                }),
                /* @__PURE__ */ jsx244("path", {
                  strokeWidth: 1.3,
                  d: "M265.8 396.9v17.7a321.1 321.1 0 0 0 106.2 0v-17.7a321.1 321.1 0 0 1-106.2 0z",
                  transform: "scale(1 .99999)"
                }),
                /* @__PURE__ */ jsx244("path", {
                  strokeWidth: 1.3,
                  d: "M265.8 396.9v17.7a321.1 321.1 0 0 0 106.2 0v-17.7a321.1 321.1 0 0 1-106.2 0z",
                  transform: "matrix(1 0 0 .99999 0 17.7)"
                }),
                /* @__PURE__ */ jsx244("path", {
                  strokeWidth: 1.3,
                  d: "M265.8 396.9v17.7a321.1 321.1 0 0 0 106.2 0v-17.7a321.1 321.1 0 0 1-106.2 0z",
                  transform: "matrix(1 0 0 .99999 0 53.1)"
                }),
                /* @__PURE__ */ jsx244("ellipse", {
                  cx: 256.9,
                  cy: 210.8,
                  strokeWidth: 4.4,
                  rx: 8.9,
                  ry: 26.6,
                  transform: "matrix(.54545 0 0 .14383 130.5 394.3)"
                }),
                /* @__PURE__ */ jsx244("ellipse", {
                  cx: 292.3,
                  cy: 246.3,
                  strokeWidth: 4.4,
                  rx: 8.9,
                  ry: 26.6,
                  transform: "matrix(.54545 0 0 .14383 130.5 391.1)"
                }),
                /* @__PURE__ */ jsx244("ellipse", {
                  cx: 327.8,
                  cy: 264,
                  strokeWidth: 4.4,
                  rx: 8.9,
                  ry: 26.6,
                  transform: "matrix(.54545 0 0 .14383 130.5 390.5)"
                }),
                /* @__PURE__ */ jsx244("ellipse", {
                  cx: 363.2,
                  cy: 264,
                  strokeWidth: 4.4,
                  rx: 8.9,
                  ry: 26.6,
                  transform: "matrix(.54545 0 0 .14383 130.5 390.5)"
                }),
                /* @__PURE__ */ jsx244("ellipse", {
                  cx: 398.6,
                  cy: 246.3,
                  strokeWidth: 4.4,
                  rx: 8.9,
                  ry: 26.6,
                  transform: "matrix(.54545 0 0 .14383 130.5 391.1)"
                }),
                /* @__PURE__ */ jsx244("ellipse", {
                  cx: 434.1,
                  cy: 210.8,
                  strokeWidth: 4.4,
                  rx: 8.9,
                  ry: 26.6,
                  transform: "matrix(.54545 0 0 .14383 130.5 394.3)"
                }),
                /* @__PURE__ */ jsx244("path", {
                  strokeWidth: 1.3,
                  d: "M265.8 485.4 372 581.1m-95.6-95.7 95.7 85M290.5 489l81.6 70.9m-71-71 71 60.3M311.8 489l60.2 49.6M322.4 489l49.6 39m-39-39 39 28.3M343.8 489l28.4 21.2M354.3 489l17.8 14.2M365 489l7 7m-106.2 0L372 591.8m0-106.3L255 591.7m106.3-106.3-102.7 92.2m88.6-88.6-81.5 70.8m70.8-70.8-70.8 60.2M326 489l-60.2 49.6m49.6-49.6-49.6 39m39-39-39 28.3M294 489l-28.3 21.2m17.7-21.2-17.7 14.2m7-14.2-7 7m106.3 0L255 602.5m117-95.7L255 613m117-95.7L255 623.6m117-95.7L255 634.4m117-95.7L255 644.9m117-95.7L255 655.5m117-95.7L255 666.1m117-95.6L255 676.8m117-95.7-109.9 99.2M372 591.7l-99.2 88.6m95.6-74.4-78 70.9M365 620l-63.8 56.7m56.7-39-32 28.3m-60.1-159.4 102.7 92.1m-102.7-81.5 102.7 92.2M265.8 528l99.2 88.5m-99.2-78 99.2 88.7m-99.2-78 95.6 85m-99.2-77.9 95.7 85M262.2 567l88.6 78m-92.1-71 88.6 78M255 581l85 74.4m-85-63.8 81.5 70.9M255 602.3l71 63.7"
                }),
                /* @__PURE__ */ jsx244("path", {
                  strokeWidth: 1.3,
                  d: "M265.8 396.9v17.7a321.1 321.1 0 0 0 106.2 0v-17.7a321.1 321.1 0 0 1-106.2 0z",
                  transform: "matrix(1 0 0 .99999 0 70.9)"
                }),
                /* @__PURE__ */ jsx244("path", {
                  strokeWidth: 1.3,
                  d: "m255.1 613 63.8 56.7m-63.8-46 56.7 49.5m-56.7-39 49.6 42.6m-49.6-32 35.5 32M255 655.5l28.4 24.8M255 666.1l17.7 14.2"
                }),
                /* @__PURE__ */ jsx244("ellipse", {
                  cx: 256.9,
                  cy: 210.8,
                  strokeWidth: 4.4,
                  rx: 8.9,
                  ry: 26.6,
                  transform: "matrix(.54545 0 0 .14383 130.5 447.5)"
                }),
                /* @__PURE__ */ jsx244("ellipse", {
                  cx: 292.3,
                  cy: 246.3,
                  strokeWidth: 4.4,
                  rx: 8.9,
                  ry: 26.6,
                  transform: "matrix(.54545 0 0 .14383 130.5 444.3)"
                }),
                /* @__PURE__ */ jsx244("ellipse", {
                  cx: 327.8,
                  cy: 264,
                  strokeWidth: 4.4,
                  rx: 8.9,
                  ry: 26.6,
                  transform: "matrix(.54545 0 0 .14383 130.5 443.6)"
                }),
                /* @__PURE__ */ jsx244("ellipse", {
                  cx: 363.2,
                  cy: 264,
                  strokeWidth: 4.4,
                  rx: 8.9,
                  ry: 26.6,
                  transform: "matrix(.54545 0 0 .14383 130.5 443.6)"
                }),
                /* @__PURE__ */ jsx244("ellipse", {
                  cx: 398.6,
                  cy: 246.3,
                  strokeWidth: 4.4,
                  rx: 8.9,
                  ry: 26.6,
                  transform: "matrix(.54545 0 0 .14383 130.5 444.3)"
                }),
                /* @__PURE__ */ jsx244("ellipse", {
                  cx: 434.1,
                  cy: 210.8,
                  strokeWidth: 4.4,
                  rx: 8.9,
                  ry: 26.6,
                  transform: "matrix(.54545 0 0 .14383 130.5 447.5)"
                }),
                /* @__PURE__ */ jsx244("path", {
                  strokeWidth: 1.3,
                  d: "m113.4 652 127.5-74.4m-134.6 70.8 120.5-70.8m-124 63.7 109.8-63.7M99.2 634.3l95.7-56.7M92 627.2l88.6-49.6m-85 39 60.2-35.5M92 609.4l46-28.3m-46 17.7 32-17.7m0 74.4 120.4-70.9M134.7 659 248 591.7m-102.7 70.9 106.3-63.8m-95.7 67.3 88.6-53.1M170 666.1l78-46m-67.4 49.6 67.3-39m-56.7 42.5 53.2-31.9m-39 32 42.5-24.9m-28.3 28.4L248 659m-14 17.8 17.7-10.6"
                }),
                /* @__PURE__ */ jsx244("path", {
                  strokeWidth: 1.3,
                  d: "M265.8 396.9v17.7a321.1 321.1 0 0 0 106.2 0v-17.7a321.1 321.1 0 0 1-106.2 0z",
                  transform: "matrix(0 1 -.99999 0 655.5 308.3)"
                }),
                /* @__PURE__ */ jsx244("path", {
                  strokeWidth: 1.3,
                  d: "m49.6 623.6 42.5-35.4m-42.5 10.6 42.5 42.5"
                }),
                /* @__PURE__ */ jsx244("path", {
                  strokeWidth: 1.3,
                  d: "m260.1 388 5.6 26.6c35.5 5.9 65.3 5.9 100.8 0l11.1-26.6c-35.4 5.9-82 5.9-117.5 0z",
                  transform: "matrix(0 .63333 -.8 0 423.8 416.3)"
                }),
                /* @__PURE__ */ jsx244("path", {
                  strokeWidth: 1.3,
                  d: "M258.7 350.8v-17.9c-10.7.2-17.8-10.5-17.8-21.2l-35.4.1c0 10.6-7 21.3-17.7 21.3v17.7z",
                  transform: "matrix(1.4983 0 0 1 -15.6 53.1)"
                }),
                /* @__PURE__ */ jsx244("path", {
                  strokeWidth: 1.4,
                  d: "M296 343.7h45.6V365H296zm3.9-21.3h37.9v21.3h-38zm0-21.2h37.9v21.2h-38zm3.8-28.4H334v28.4h-30.3zm-1.3-24.8h33v24.8h-33z"
                }),
                /* @__PURE__ */ jsx244("ellipse", {
                  cx: 237.4,
                  cy: 161.2,
                  strokeWidth: 1.3,
                  rx: 42.5,
                  ry: 33.7,
                  transform: "matrix(1.0333 0 0 1 75.3 63.8)"
                }),
                /* @__PURE__ */ jsx244("path", {
                  strokeWidth: 1.3,
                  d: "M258.7 159.4c0 9.3 10.6 24.8 10.6 24.8-7.7 6.2-20.2 10.7-31.9 10.7s-26.3-2.6-31.9-10.7c0 0 10.6-15.4 10.6-24.7s-10.6-21.3-10.6-21.3a54.6 54.6 0 0 1 32-10.6c11.6 0 24 4.5 31.8 10.6 0 0-10.6 12-10.6 21.3z",
                  transform: "matrix(1.0333 0 0 1 75.3 63.8)"
                }),
                /* @__PURE__ */ jsx244("path", {
                  strokeWidth: 1.3,
                  d: "M251.6 159.4c0 9.3 10.6 28.4 10.6 28.4-7.7 6-13 7-24.8 7s-19.2 1.1-24.8-7c0 0 10.6-19 10.6-28.4s-10.6-24.8-10.6-24.8c7.7-6 13-7 24.8-7 11.7 0 17.1 1 24.8 7 0 0-10.6 15.5-10.6 24.8z",
                  transform: "matrix(1.0333 0 0 1 75.3 63.8)"
                }),
                /* @__PURE__ */ jsx244("circle", {
                  cx: 194.9,
                  cy: 166.5,
                  r: 10.6,
                  strokeWidth: 1.3,
                  transform: "matrix(1.0333 0 0 1 75.3 60.2)"
                }),
                /* @__PURE__ */ jsx244("circle", {
                  cx: 194.9,
                  cy: 166.5,
                  r: 10.6,
                  strokeWidth: 1.3,
                  transform: "matrix(1.0333 0 0 1 163.2 60.2)"
                }),
                /* @__PURE__ */ jsx244("circle", {
                  cx: 194.9,
                  cy: 166.5,
                  r: 10.6,
                  strokeWidth: 1.3,
                  transform: "matrix(1.0333 0 0 1 119.3 60.2)"
                }),
                /* @__PURE__ */ jsx244("circle", {
                  cx: 194.9,
                  cy: 166.5,
                  r: 10.6,
                  strokeWidth: 1.3,
                  transform: "matrix(1.0333 0 0 1 119.3 24.8)"
                }),
                /* @__PURE__ */ jsx244("circle", {
                  cx: 194.9,
                  cy: 166.5,
                  r: 10.6,
                  strokeWidth: 1.3,
                  transform: "matrix(1.0702 0 0 1 80 226.8)"
                }),
                /* @__PURE__ */ jsx244("circle", {
                  cx: 194.9,
                  cy: 166.5,
                  r: 10.6,
                  strokeWidth: 1.3,
                  transform: "matrix(1.0702 0 0 1 140.6 226.8)"
                }),
                /* @__PURE__ */ jsx244("path", {
                  strokeWidth: 1.3,
                  d: "M212.6 311.8h49.6l-24.8 31.9z",
                  transform: "matrix(1.0702 0 0 1 64.8 53.1)"
                }),
                /* @__PURE__ */ jsx244("circle", {
                  cx: 194.9,
                  cy: 166.5,
                  r: 10.6,
                  strokeWidth: 1.3,
                  transform: "matrix(1.427 0 0 1.3333 40.7 167.7)"
                })
              ]
            }),
            /* @__PURE__ */ jsxs219("g", {
              fill: "#fff",
              fillRule: "evenodd",
              transform: "matrix(.19848 0 0 .17744 18.8 -19.1)",
              children: [
                /* @__PURE__ */ jsx244("rect", {
                  width: 81.5,
                  height: 21.3,
                  x: 262.2,
                  y: 524.4,
                  strokeWidth: 1.2,
                  rx: 4.3,
                  ry: 3.7
                }),
                /* @__PURE__ */ jsx244("path", {
                  strokeWidth: 1.2,
                  d: "M368.5 506.7c-9.8 0-17.7 8.3-17.7 18.5v16.1a18 18 0 0 0 17.7 18.5 18 18 0 0 0 17.7-18.5v-16a18 18 0 0 0-17.7-18.6zm0 7c-5.9 0-10.6 6.7-10.6 14.9v9.3c0 8.2 4.7 14.8 10.6 14.8 5.9 0 10.6-6.6 10.6-14.8v-9.3c0-8.2-4.7-14.8-10.6-14.8zm-92.1-3.5c-6 0-10.6 6.6-10.6 14.9v16.4c0 8.2 4.7 14.8 10.6 14.8 5.9 0 10.6-6.6 10.6-14.8V525c0-8.3-4.7-14.9-10.6-14.9zm0-7a18 18 0 0 0-17.7 18.5v23.2a18 18 0 0 0 17.7 18.5c9.8 0 17.7-8.3 17.7-18.5v-23.2a18 18 0 0 0-17.7-18.6z"
                }),
                /* @__PURE__ */ jsx244("path", {
                  strokeWidth: 1.2,
                  d: "M248 517.3c-5.9 0-10.6 6.6-10.6 14.8v3.9c0 8.2 4.7 14.8 10.6 14.8 6 0 10.7-6.6 10.7-14.8v-3.9c0-8.2-4.8-14.8-10.7-14.8zm0-7a18 18 0 0 0-17.7 18.5v10.6a18 18 0 0 0 17.7 18.5c9.8 0 17.8-8.3 17.8-18.5v-10.6a18 18 0 0 0-17.8-18.6z"
                }),
                /* @__PURE__ */ jsx244("path", {
                  strokeWidth: 0.9,
                  d: "M478.4 237.4c-6 0-10.7 6.6-10.7 14.8v16.5c0 8.1 4.8 14.8 10.7 14.8 5.8 0 10.6-6.6 10.6-14.9v-16.4c0-8.2-4.8-14.8-10.6-14.8zm0-7a18 18 0 0 0-17.8 18.4V272a18 18 0 0 0 17.7 18.6c9.9 0 17.8-8.3 17.8-18.6v-23.2a18 18 0 0 0-17.7-18.5z",
                  transform: "matrix(1.8 0 0 1.1176 -655.5 242.2)"
                }),
                /* @__PURE__ */ jsx244("path", {
                  strokeWidth: 0.9,
                  d: "M478.4 237.4c-6 0-10.7 6.6-10.7 14.8v16.5c0 8.1 4.8 14.8 10.7 14.8 5.8 0 10.6-6.6 10.6-14.9v-16.4c0-8.2-4.8-14.8-10.6-14.8zm0-7a18 18 0 0 0-17.8 18.4V272a18 18 0 0 0 17.7 18.6c9.9 0 17.8-8.3 17.8-18.6v-23.2a18 18 0 0 0-17.7-18.5z",
                  transform: "matrix(1.8 0 0 1.1176 -425.2 245.7)"
                }),
                /* @__PURE__ */ jsx244("rect", {
                  width: 42.5,
                  height: 21.3,
                  x: 375.6,
                  y: 524.4,
                  strokeWidth: 1.2,
                  rx: 2.3,
                  ry: 3.7
                }),
                /* @__PURE__ */ jsx244("rect", {
                  width: 24.8,
                  height: 28.4,
                  x: 336.6,
                  y: 520.9,
                  strokeWidth: 1.2,
                  rx: 1.3,
                  ry: 4.9
                }),
                /* @__PURE__ */ jsx244("rect", {
                  width: 24.8,
                  height: 28.4,
                  x: 219.7,
                  y: 520.9,
                  strokeWidth: 1.2,
                  rx: 1.3,
                  ry: 4.9
                }),
                /* @__PURE__ */ jsx244("rect", {
                  width: 49.6,
                  height: 35.4,
                  x: 141.7,
                  y: 517.3,
                  strokeWidth: 1.2,
                  rx: 2.6,
                  ry: 6.1
                }),
                /* @__PURE__ */ jsx244("rect", {
                  width: 46.1,
                  height: 35.4,
                  x: 450,
                  y: 520.9,
                  strokeWidth: 1.2,
                  rx: 2.5,
                  ry: 6.1
                })
              ]
            })
          ]
        })
      ]
    })
  ]
});
var Om_default = SvgOm;

// src/country-flag-icons/generated/Pa.tsx
init_esm_shims();
import { jsx as jsx245, jsxs as jsxs220 } from "react/jsx-runtime";
var SvgPa = (props) => /* @__PURE__ */ jsxs220("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx245("defs", {
      children: /* @__PURE__ */ jsx245("clipPath", {
        id: "pa_svg__a",
        children: /* @__PURE__ */ jsx245("path", {
          fillOpacity: 0.7,
          d: "M0 0h640v480H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs220("g", {
      clipPath: "url(#pa_svg__a)",
      children: [
        /* @__PURE__ */ jsx245("path", {
          fill: "#fff",
          d: "M0 0h640v480H0z"
        }),
        /* @__PURE__ */ jsx245("path", {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M92.5 0h477.2v480H92.4z"
        }),
        /* @__PURE__ */ jsx245("path", {
          fill: "#db0000",
          fillRule: "evenodd",
          d: "M323 3.6h358v221.7H323z"
        }),
        /* @__PURE__ */ jsx245("path", {
          fill: "#0000ab",
          fillRule: "evenodd",
          d: "M3.2 225.3h319.9V480H3.2zm211.6-47.6-42-29.4-41.7 29.6 15.5-48L105 100l51.6-.4 16-48 16.3 47.9h51.6l-41.5 30 15.9 48z"
        }),
        /* @__PURE__ */ jsx245("path", {
          fill: "#d80000",
          fillRule: "evenodd",
          d: "m516.9 413.9-42.4-27.7-42.1 28 15.6-45.6-42-28 52-.5 16.2-45.4 16.4 45.3h52l-41.8 28.5 16 45.4z"
        })
      ]
    })
  ]
});
var Pa_default = SvgPa;

// src/country-flag-icons/generated/Pe.tsx
init_esm_shims();
import { jsx as jsx246, jsxs as jsxs221 } from "react/jsx-runtime";
var SvgPe = (props) => /* @__PURE__ */ jsxs221("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx246("path", {
      fill: "#D91023",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx246("path", {
      fill: "#fff",
      d: "M213.3 0h213.4v480H213.3z"
    })
  ]
});
var Pe_default = SvgPe;

// src/country-flag-icons/generated/Pf.tsx
init_esm_shims();
import { jsx as jsx247, jsxs as jsxs222 } from "react/jsx-runtime";
var SvgPf = (props) => /* @__PURE__ */ jsxs222("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx247("defs", {
      children: /* @__PURE__ */ jsx247("clipPath", {
        id: "pf_svg__a",
        children: /* @__PURE__ */ jsx247("path", {
          fillOpacity: 0.7,
          d: "M0 0h640v480H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs222("g", {
      clipPath: "url(#pf_svg__a)",
      children: [
        /* @__PURE__ */ jsx247("path", {
          fill: "#fff",
          d: "M0 0h640v480H0z"
        }),
        /* @__PURE__ */ jsx247("path", {
          fill: "#fff",
          d: "M80 0h480v480H80z"
        }),
        /* @__PURE__ */ jsx247("path", {
          fill: "#083d9c",
          fillRule: "evenodd",
          stroke: "#083d9c",
          strokeWidth: "2pt",
          d: "M277.3 340.8s10.8-8.8 21.4-8.8 13.4 7.3 20.8 7.9c7.3.6 13.4-7.3 22.5-7.6 9.1-.3 20.5 6.4 20.5 6.4l-39.8 12-45.4-10zm-22.9-13 135.4.7s-11.7-12.7-25.5-13c-13.8-.2-10 6-20.5 6.8-10.6.9-13.2-6.4-22.9-6.2-9.6.3-15.2 6.2-22.5 6.5-7.4.3-16.7-7.3-22.3-7-5.6.3-25.5 8.7-25.5 8.7l3.8 3.6zm-17.3-16 167 .5c2.7-3.8-8.2-12.9-18.1-13.7-8.2.3-14 8.5-20.8 8.8-6.8.3-14.4-8.5-22-8.2-7.6.3-15.5 8.2-23.1 8.2-7.7 0-13.2-8.5-22.9-8.5s-14 9.3-21.4 8.8c-7.3-.6-13.8-9.4-20.8-9.4s-18.7 10.5-21 10c-2.4-.7 2.9 4.3 3.1 3.4z"
        }),
        /* @__PURE__ */ jsx247("path", {
          fill: "red",
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinejoin: "round",
          strokeWidth: 2.5,
          d: "m301.3 218.9 38.4 10.2v-54.8c-17.6 1-32.2-33.4-1.2-35.7-30.5-4.4-34 3.5-37.5 12z"
        }),
        /* @__PURE__ */ jsx247("path", {
          fill: "#083d9c",
          fillRule: "evenodd",
          stroke: "#083d9c",
          strokeLinecap: "round",
          strokeWidth: 5,
          d: "m277 258.7 86.7.3"
        }),
        /* @__PURE__ */ jsx247("path", {
          fill: "none",
          stroke: "#000",
          strokeLinecap: "round",
          strokeWidth: 4,
          d: "m281.1 238 10.3 13.7m-10.3 0 11.1-13.5M287 237l-.3 8.5m10.8-7.6 10.3 13.8m-10.3 0 11.1-13.5m-5.2-1.2-.3 8.5m11.1-7.6 10.3 13.8m-10.3 0 11.1-13.5m-5.2-1.2-.3 8.5m11.7-7.6 10.2 13.8m-10.2 0 11.1-13.5m-5.3-1.2-.2 8.5m11-7.6 10.3 13.8m-10.2 0 11.1-13.5M354 237l-.3 8.5"
        }),
        /* @__PURE__ */ jsx247("path", {
          fill: "#ef7d08",
          fillRule: "evenodd",
          d: "m218.7 259.6 36.9.3v-23.1l-42.2-2.1zm-1.8-32 39.3 3.9-.3-16.4-38.4-15.3-.6 27.9zm8-32.7 30.1 14.6 4.3-4.5s-2.8-1.9-2.6-3.7c0-1.7 2.8-2 2.8-4 0-1.7-3-2-3.1-3.7-.2-2 2.4-4 2.4-4l-27.2-23.7-6.8 29zm198 65h-39l-.3-22.6 42.8-3.2zM384.2 232l46.3-5.6-10-26.7-36.6 15.6zm33.7-39.6L384.5 210c-.5-2-.9-3.8-3.2-5.3 0 0 2-1.2 2-3.2s-2.6-2.4-2.6-3.5 2.4-2.2 2.6-4.9c-.3-1.8-2.6-4.4-2.2-4.9l26-19.8zm-72.4 39.1 16.7-.7.3-6.7zm-51-.5-17.5-.5v-7l17.6 7.5zm0-2-17.5-9v-11.8s-2 .3-1.8-2c.1-4.9 12.9 8.9 19.4 13.4zm51-1.1v-7.7s15.8-14.2 19.1-16.9c0 3-1.8 5.2-1.8 5.2v11.2zM243 163.8l17.8 19.7c.4-1.8 4.5-2.1 8.6-1.8 4 .3 7.3-.3 7.3 2.6s-2 2.5-2 4.6 3 1.9 3 4.5-2.2 2.1-2.2 4.1c0 1.7 2.4 1.8 2.4 1.8l16.6 16.1v-17.2l-34.2-53.7zm27.4-20.4 23.3 47.5s.2-43.8 4.1-46.1l-6.5-12zm101 1.9-26 46.2V172s2.2-3.2-1.2-3c-3.4.3-7.5-.2-7.5-.2l10.4-36.6zM398 165c-.3.5-17.5 18-17.5 18-.8-2-6-1-11-1-4.9 0-5.6 1.6-5.3 2.9.5 3.3 2.2.8 2.2 4 0 3.1-2.4 2-2.7 4.2.3 2.7 3.8 2 1.7 4l-19.9 19.2v-18.2l37.1-57.6z"
        }),
        /* @__PURE__ */ jsx247("path", {
          fill: "red",
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinejoin: "round",
          strokeWidth: 2.5,
          d: "M309.8 268.4c-8.3 13.8-30.6 9.7-35.9 0-1.5-.4-.6-59.5-.6-59.5s-2.5-1.1-2.6-3c-.1-1.8 3.4-2 3.4-4.3s-3.6-1.4-3.7-3.8c0-2.2 3.9-2 3.7-4-.2-2.4-4.3-2-4.5-4.2 0-1.7 3-3.2 3.8-4a61.3 61.3 0 0 1-2.8 0l-6.4.1c-4.6 0 0 1 0 3.6 0 1.7-2.3 2.9-2.5 4.3-.1 1.6 3.2 2.6 3.3 4.5 0 1.6-3.3 1.7-3.2 3.3.2 2.5 3 3.1 2.9 4.7 0 1.5-3.6 2.1-3.7 3.3.2 2.4.6 60.8.6 60.8 5.7 29.8 38.8 37.3 48.2-1.8zm21.9 0c8.3 13.8 30.6 9.7 35.8 0 1.6-.4.7-59.5.7-59.5s2.5-1.1 2.6-3c.1-1.8-3.2-2-3.2-4.3s3.4-1.4 3.4-3.8c0-2.2-3.5-2-3.3-4.2.2-2.3 3-2 3.1-4.2.1-1.9-1.7-3-2.6-3.8h2.7l6.4.1c4.5 0 0 1 0 3.6 0 1.7 2.3 2.9 2.5 4.3 0 1.6-3.2 2.6-3.3 4.5 0 1.6 3.3 1.7 3.2 3.3-.2 2.5-3 3.1-3 4.7.1 1.5 3.7 2.1 3.7 3.3l-.5 60.8c-5.7 29.8-38.9 37.3-48.2-1.8z"
        }),
        /* @__PURE__ */ jsx247("path", {
          fill: "#083d9c",
          fillRule: "evenodd",
          stroke: "#083d9c",
          strokeWidth: "2pt",
          d: "M301.7 295.6H339c.3-.3-8.4-13-18.6-12-11.5.3-19.3 12-18.7 12zm118.9-1h-51s6.6-3.8 8.4-7.4c3.3 1.8 2.4 3.6 9 3.9 6.6.3 12.9-7.5 19.2-7.2 6.3.3 14.4 11 14.4 10.8zm-201 0h51s-6.6-3.8-8.4-7.4c-3.3 1.8-2.4 3.6-9 3.9-6.6.3-13-7.5-19.2-7.2-6.3.3-14.4 11-14.4 10.8zm3.8-16 36.3.3s-2.3-5-2.6-11.1c-9.4-3.2-17 7-23.8 7.3-6.7.3-13.7-7.3-13.7-7.3zm194 0-36.4.3s2.3-5 2.6-11.1c9.4-3.2 17 7 23.8 7.3 6.7.3 13.7-7.3 13.7-7.3zM311 279l18.4-.5s.3-5.6-9.3-5.6-8.8 6.4-9.1 6.1zm-11.2-7.9a17 17 0 0 0 8.2-7.6l-12.6.3s-5.8 3.5-8.7 7.3zm40.8 0a17 17 0 0 1-8.2-7.6l12.6.3s5.8 3.5 8.7 7.3z"
        }),
        /* @__PURE__ */ jsx247("path", {
          fill: "#de2010",
          fillRule: "evenodd",
          d: "M-40 360h720v120H-40zm0-360h720v120H-40z"
        })
      ]
    })
  ]
});
var Pf_default = SvgPf;

// src/country-flag-icons/generated/Pg.tsx
init_esm_shims();
import { jsx as jsx248, jsxs as jsxs223 } from "react/jsx-runtime";
var SvgPg = (props) => /* @__PURE__ */ jsxs223("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsxs223("g", {
      fillRule: "evenodd",
      children: [
        /* @__PURE__ */ jsx248("path", {
          fill: "#000001",
          d: "m1.6 0-.5 480h640z"
        }),
        /* @__PURE__ */ jsx248("path", {
          fill: "red",
          d: "m640.6 480 .5-480H1.1z"
        })
      ]
    }),
    /* @__PURE__ */ jsx248("path", {
      fill: "#fc0",
      stroke: "#fc0",
      strokeWidth: 1.1,
      d: "m178 54-3.8-.2c-1.2-2.8-4.5-3.8-6.6-2.6A333 333 0 0 1 156 51l7.1 3.1C165 59 171 60 171 60c-.6 8.8-8.9-1.1-15.9 3.9-5 3-5 6.5-7.7 12.3-.9 1.6-4.4 5.8-4.4 5.8l5.9-.5L147 84l7-1-1.5 1.4c1 .2 8-1.7 8-1.7L160 85l8-2.9s1.6 1.3 3 1.9l1-4 4 1 1-4c6 8 8 16 19 18l-1-4a262.2 262.2 0 0 1 8.7 4l.9-1.7c4.8 3.4 8.7 3.3 11.4 3.7l-2-5 2 1-3-8 3 1-4-6 1.5-1-.5-3c6 2 14 5 15 12 1 11-11 14-19 13 6 5 17 3 22-2 2-2 3-5 4-8 1 3 3 7 3 11-1 9-13 12-21 13 9 5 25-1 26-14 0-11-7-16-10-21l-1-5.4 3 1.4s-1.8-3.3-2-4c0 0-3.1-8.5-4.2-10.4l2.2.4-8.2-10.3 2.3-.2S215.6 44 213 43l3-1c-6-3-13-1-19 3l1-3-1.8.2v-3.5L198 36l-3-1 2-5-3 1 1-5s-2.2 1-3.6.9a51.7 51.7 0 0 0 1.6-3.4c-1-1.5 0-4.5 0-4.5-7 1-8 2-12 8-6 11-4 16-3 27z",
      transform: "matrix(2.21989 0 0 2.21194 1.1 0)"
    }),
    /* @__PURE__ */ jsx248("path", {
      fill: "red",
      fillRule: "evenodd",
      stroke: "red",
      strokeWidth: 1.4,
      d: "M215.8 70.4c.5.9 6.2 3.6 10.4 6-1.1-4.6-9.4-5.6-10.4-6z",
      transform: "matrix(2.21989 0 0 2.21194 1.1 0)"
    }),
    /* @__PURE__ */ jsx248("path", {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m175 399-14.2-9-19 9.1 4.3-16.2-14.5-15.1 16.7-1 10-18.4 6.1 15.5 20.7 3.8-13 10.6zm36.2-79-6.6-3-6.3 3.6 1-7.2-5.4-4.9 7.1-1.3 3-6.6 3.5 6.4 7.2.8-5 5.2zm32-45.2-14.5-7-13.9 7.8 2.3-15.7-11.8-10.8 15.7-2.8 6.6-14.4 7.6 14 15.8 1.8-11 11.5zm-65.8-63-17-8.5-16.5 9.1 2.8-18.6-13.8-13 18.7-3 8-17 8.7 16.7 18.8 2.3-13.3 13.4zm-60.8 65.4-17-10-17 10.3 4.3-19.3-15.1-13 19.7-1.8 7.7-18.3 7.9 18.2 19.8 1.6-14.9 13z"
    })
  ]
});
var Pg_default = SvgPg;

// src/country-flag-icons/generated/Ph.tsx
init_esm_shims();
import { jsx as jsx249, jsxs as jsxs224 } from "react/jsx-runtime";
var SvgPh = (props) => /* @__PURE__ */ jsxs224("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx249("path", {
      fill: "#0038a8",
      d: "M0 0h640v240H0z"
    }),
    /* @__PURE__ */ jsx249("path", {
      fill: "#ce1126",
      d: "M0 240h640v240H0z"
    }),
    /* @__PURE__ */ jsx249("path", {
      fill: "#fff",
      d: "M415.7 240 0 480V0"
    }),
    /* @__PURE__ */ jsx249("path", {
      fill: "#fcd116",
      d: "M26.7 42.4 41 55l16.6-9.2-7.4 17.5 14 13-19-1.6-8.1 17.2-4.3-18.5L14 71l16.3-10zm323.8 172.3.4 19 18 6.3-18 6.2-.4 19-11.5-15.1-18.2 5.5 10.8-15.6-10.8-15.6 18.2 5.5zM37.2 388.1l8 17.2 19-1.6-13.9 13 7.4 17.5-16.6-9.1-14.4 12.4 3.6-18.7L14 409l18.9-2.4zm114.2-249-6.2 6.2 3.1 47-3 .3-5.7-42.9-5.1 5 7.6 38.4a47.5 47.5 0 0 0-17.2 7.1l-21.7-32.4H96l26.4 34.3a48 48 0 0 0-2.4 2l-31.1-35.5h-8.8v8.8l35.4 31-2 2.5-34.3-26.3v7.1l32.5 21.7c-3.4 5.2-5.9 11-7.1 17.2L66.3 223l-5.1 5 42.9 5.7c-.2 1-.3 2.1-.3 3.1l-47-3-6.2 6.2 6.2 6.2 47-3.1.3 3.1-42.9 5.7 5 5 38.4-7.6a47.5 47.5 0 0 0 7.1 17.2l-32.5 21.7v7.2l34.3-26.3a48 48 0 0 0 2 2.4l-35.4 31v8.8H89l31-35.4 2.5 2L96 312.2h7.2l21.7-32.5c5.1 3.4 11 5.9 17.2 7.1l-7.6 38.4 5 5 5.7-42.9c1 .2 2 .3 3.1.3l-3 47 6.1 6.2 6.3-6.2-3.1-47 3-.3 5.7 43 5.1-5.1-7.6-38.4a47.5 47.5 0 0 0 17.2-7.1l21.7 32.5h7.2l-26.4-34.3a48 48 0 0 0 2.4-2l31.1 35.4h8.8v-8.8l-35.4-31 2-2.4 34.3 26.3v-7.2l-32.5-21.7c3.4-5.1 5.9-11 7.1-17.2l38.3 7.6 5.1-5-42.9-5.7c.2-1 .3-2 .3-3.1l47 3 6.2-6.1-6.2-6.2-47 3-.3-3 42.9-5.7-5-5-38.4 7.5a47.5 47.5 0 0 0-7.1-17.2l32.5-21.7v-7.1l-34.3 26.3a48 48 0 0 0-2-2.4l35.4-31v-8.9H214l-31 35.5a48 48 0 0 0-2.5-2l26.4-34.3h-7.2L178 200.2c-5.1-3.4-11-5.9-17.2-7.1l7.6-38.3-5-5-5.7 42.8-3.1-.3 3-47z"
    })
  ]
});
var Ph_default = SvgPh;

// src/country-flag-icons/generated/Pk.tsx
init_esm_shims();
import { jsx as jsx250, jsxs as jsxs225 } from "react/jsx-runtime";
var SvgPk = (props) => /* @__PURE__ */ jsxs225("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx250("defs", {
      children: /* @__PURE__ */ jsx250("clipPath", {
        id: "pk_svg__a",
        children: /* @__PURE__ */ jsx250("path", {
          fillOpacity: 0.7,
          d: "M-52.3 0h682.6v512H-52.3z"
        })
      })
    }),
    /* @__PURE__ */ jsxs225("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      clipPath: "url(#pk_svg__a)",
      transform: "translate(49) scale(.9375)",
      children: [
        /* @__PURE__ */ jsx250("path", {
          fill: "#0c590b",
          d: "M-95 0h768v512H-95z"
        }),
        /* @__PURE__ */ jsx250("path", {
          fill: "#fff",
          d: "M-95 0H97.5v512H-95z"
        }),
        /* @__PURE__ */ jsxs225("g", {
          fill: "#fff",
          children: [
            /* @__PURE__ */ jsx250("path", {
              d: "m403.7 225.4-31.2-6.6-16.4 27.3-3.4-31.6-31-7.2 29-13-2.7-31.7 21.4 23.6 29.3-12.4-15.9 27.6 21 24z"
            }),
            /* @__PURE__ */ jsx250("path", {
              d: "M415.4 306a121.2 121.2 0 0 1-161.3 59.4 122.1 122.1 0 0 1-59.5-162.1A118.6 118.6 0 0 1 266 139a156.2 156.2 0 0 0-11.8 10.9A112.3 112.3 0 0 0 415.5 306z"
            })
          ]
        })
      ]
    })
  ]
});
var Pk_default = SvgPk;

// src/country-flag-icons/generated/Pl.tsx
init_esm_shims();
import { jsx as jsx251, jsxs as jsxs226 } from "react/jsx-runtime";
var SvgPl = (props) => /* @__PURE__ */ jsx251("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs226("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx251("path", {
        fill: "#fff",
        d: "M640 480H0V0h640z"
      }),
      /* @__PURE__ */ jsx251("path", {
        fill: "#dc143c",
        d: "M640 480H0V240h640z"
      })
    ]
  })
});
var Pl_default = SvgPl;

// src/country-flag-icons/generated/Pm.tsx
init_esm_shims();
import { jsx as jsx252, jsxs as jsxs227 } from "react/jsx-runtime";
var SvgPm = (props) => /* @__PURE__ */ jsxs227("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx252("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx252("path", {
      fill: "#000091",
      d: "M0 0h213.3v480H0z"
    }),
    /* @__PURE__ */ jsx252("path", {
      fill: "#e1000f",
      d: "M426.7 0H640v480H426.7z"
    })
  ]
});
var Pm_default = SvgPm;

// src/country-flag-icons/generated/Pn.tsx
init_esm_shims();
import { jsx as jsx253, jsxs as jsxs228 } from "react/jsx-runtime";
var SvgPn = (props) => /* @__PURE__ */ jsxs228("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx253("path", {
      fill: "#00247d",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#012169",
      d: "M0 0h320v240H0Z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#fff",
      d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0Z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#c8102e",
      d: "M212 140.5 320 220v20l-135.5-99.5Zm-92 10 3 17.5-96 72H0ZM320 0v1.5l-124.5 94 1-22L295 0ZM0 0l119.5 88h-30L0 21Z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#fff",
      d: "M120.5 0v240h80V0ZM0 80v80h320V80Z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#c8102e",
      d: "M0 96.5v48h320v-48zM136.5 0v240h48V0Z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#f7e017",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M410.1 252.3a56.5 56.5 0 0 0-19 27.8c-5.7 27.3-13.3 33.4-25 27.5 0 14.7 12.9 15.8 18.5 7.3 0 13.7 5 25.6 16.2 35.8 4.8 4.3 5.7 1.4 3.4-3.4-2.2-4.7-2.2-20-6.7-28.8 7.2 5.1 17.8 2.2 17-12-9.3 5.4-18.5 5.2-19.5-7.7-1.1-15 4.7-37 15.1-46.5zm-11-108.6c.7-5.5-.5-11-4.5-14.5-7.6-6.7-15.1-4.5-20.7 1-8.3-4.6-12.8 11.4-22.2 8.7 1.5 5.2 4 7.4 8.8 5.6-5 4.5 0 10-5.9 15.4 10.6 3.4 16.2-2.5 15.8-12.7a9.6 9.6 0 0 0 13.7-.7c-5.6-1.8-5.6-6.7-3.4-11.2 3.4-6.8 19.3-6.5 18.4 8.4z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#337321",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M423.6 222.1c-12 6.4-33.8 3.7-35.9-12-2-15.5 13.1-22.5 17.2-24.5 6.3-3.2 11.3 2.5 9.2 9 7-2.4 8.6-10.6 5.2-15.3 9.3.7 17.8-6.3 21.4-16.2-3.2 3-12 1-19.3.5 2.2-2.5 2.2-7.3 1.5-9.8-7.6 7.9-18.7 4.3-33.3 27a1023.3 1023.3 0 0 0 9.6-37.1c.8-15-15-15.2-18.4-8.4 3.7 4.2 1.7 9 .4 16.5-1.6 8.7-5 29-7.9 35.8-.9-10.6-7.9-11.3-9.2-16.5-2 1.4-3.2 5-2.7 7.5-2.5-2.7-11.1.7-14.3-3.4-3.3 6.7 2 13.5 7.7 16.5-3.3.2-4 4.1-7.7 4.1 4.9 5.7 9.9 8 15.6 8.4 5.8.4 10 2.6 13.5 9.6 5.7 11.3 27.2 18.6 47.4 8.3z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#f7e017",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M453.4 208.4c-6.8 18.7-25.3 32-33.6 34-14.2 3.5-43.2 17.6-51 24.8a9 9 0 0 1-3.2-1.3c-3.8-2.7-7-11.5-.2-19 21.2-19.8 44-11.2 58.2-24.8-12 6.3-33.8 3.6-35.8-12a55 55 0 0 0 54.5-16.2 97.7 97.7 0 0 1 11 14.5z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#337321",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M410.1 252.3c-10.7 9-16.2 31.4-15.1 46.5.3 4.2 1.5 7 3.3 8.8.8-8.6 6.7-30.7 22-40.6 12.8-8.3 32.9-27 40.3-48.5a17.2 17.2 0 0 0-7.9-9.2c-7.4 20.2-27.1 29.9-42.6 43z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#316d3a",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M446.5 199.7a50.3 50.3 0 0 1-20.9 16.8 11 11 0 0 0 2.5-6.8 76.9 76.9 0 0 1-40.4.5 55 55 0 0 0 54.6-16.2 21 21 0 0 1 4.2 5.7z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#337321",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M365.4 247c-17.2 16-5.8 30.2 1 33.3-1.9 11.3 8.7 10 8.5 19.4 4.3-2.4 5.4-9 4.7-14.2 5.5 5.9 19.2-.7 22.1 10.2 1.9-12-7.4-24-18.9-22.8 4.8-4.3 2-11.3-2.5-13.1-.9 8.8-10.8 8.8-14.6 6-3.9-2.6-7-11.4-.3-18.9z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#f7e017",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M402.7 349.6c-1.8 1-1.7 3.5-.5 5 2.3 3.2-1.7 10.4 6 11.9 2.2.5 4-1 4.8-3.5 2.4-7.1-5.2-7.9-5.9-11.3-.6-3.4-2.8-3-4.4-2.1z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#f7e017",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M409.2 362.9c-2.5 1.2-4.8 2.8-3.7 11 .4 3.3.2 11.4-2.8 11.5 1.8 1 5.7 2 7.3-.2 1.5 2.6 5 1.8 6.3-1.3 1.8 1.4 4.3-1 4.3-3.2 1.5 1 4.7-.4 3.9-5.3 2 .7 4.4-.7 5.3-1.9-2.8-.6-10-4.4-11.6-7.4-1.7-3.1-6-4.6-9-3.2z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M370 134.7c1.2-1.6 2.5-3.2 4-4.6m39 34.5c2-1.1 5-1.3 8.4-1M410 385.2c-.8-1.1-1.1-5.8-.6-8.7m6.9 7.4c-1.3-1-3.6-4.3-4-7.1m8.3 3.9a19 19 0 0 1-6.3-8.9m10.2 3.6c-1.9-.4-7.6-4.1-10-8"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#f7e017",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M528.5 247.2c27.7 23.2 29.5 41.7 25.3 52.5-2.3-10.1-13.8-25.9-25.8-30z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#337321",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M478.9 234h51.4v61c0 51.9-28.8 82.5-58.2 98.8A108.3 108.3 0 0 1 414 295v-61h36c0 3.2.4 8 4 12.7 8.6-.8 18.2-7.2 24.9-12.6z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#006ec7",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M530.3 234v61c0 15.6-2.6 29.4-7 41.3L472 242.6l-51 93.7c-4.5-12-7.1-25.7-7.1-41.3v-61z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#f7e017",
      d: "M524.8 331.9a116 116 0 0 1-3.8 10L472 251l-48.7 91c-1.3-2.8-2.9-7.3-3.8-10l52.7-97.6z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#f7e017",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "m495.3 365.3 5 2.3a36 36 0 0 0 2.2-19.8c-2.9 7.4-12.8 7.2-15.5 11.7 1.6.8 3.2 2 4.5 2.9-3.4 3.4-11.3 9-15.8 10.4v-48.4c0-3.4-1.2-6.2-1.2-9v-10c0-2.3-.4-5.6-2.4-5.6s-2.5 3.3-2.5 5.6v10c0 2.8-1.1 6-1.1 9v48.4c-2.5-7.2-12.2-4.8-16.7-12a14 14 0 0 1 5.4-.2c-3.4-11.5-12.7-12.4-14.4-15.8 0 4.8-2 15.8 1.1 20.6.7-.9 1.8-1.8 3-2.5 3.9 8.3 21.1 8.3 25.2 22.1 3.3-5 15-11 23.2-19.7z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#f7e017",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M472.1 325c3.8 0 16-1.2 20.4-1.2 1.2 0 2.1-1.8 2.1-3.9 0-2-.9-3.8-2-3.8-4.5 0-16.6-1.2-20.5-1.2-3.8 0-16 1.2-20.4 1.2-1.2 0-2.1 1.7-2.1 3.8 0 2.1 1 3.9 2 3.9 4.5 0 16.7 1.2 20.5 1.2zm-2.5-19.8c-.8-.7-1.8-1-3-1-2.6 0-4.7 1.8-4.7 4.1 0 2.4 2.1 4.3 4.7 4.3 2.5 0 4.6-2 4.6-4.3 0-1.8 2.6-1.8 2.6 0 0 3.7-3.2 6.7-7.2 6.7s-7.3-3-7.3-6.7c0-3.6 3.3-6.6 7.3-6.6a8 8 0 0 1 3.3.8c0 .6-.3 1.7-.3 2.7z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#f7e017",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M451.7 323.8c1.1 0 2-1.8 2-3.9 0-2-.9-3.8-2-3.8"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#f7e017",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M453.4 323.8c1.1 0 2-1.8 2-3.9 0-2-.9-3.8-2-3.8m11.1 8.4c1.4 0 2.5-2 2.5-4.6 0-2.5-1-4.6-2.5-4.6m2.6 9.4c1.5 0 2.6-2.1 2.6-4.8 0-2.7-1.1-4.8-2.6-4.8m8.7 9.7c1.5 0 2.6-2.2 2.6-4.9s-1.2-4.9-2.6-4.9m2.7 9.6c1.4 0 2.6-2 2.6-4.7 0-2.6-1.2-4.7-2.6-4.7m12.1 8.6c1.2 0 2.1-1.7 2.1-3.9s-.9-4-2-4m-43.7 47c1.3-.9 3-1.6 4.8-2m41.1 2.4-1.4-1m3.8 3c3.2-3.4 5.8-7.3 7.3-11.7"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M461.8 277.2c0-1.2.9-1.6 2-2.4 1.2-1 1.7-1.4 2.9-1.4h14.8c1 0 1.3.3 1.3 1.3v20c0 1-.2 1.4-1.3 1.4h-19.7v-19.2"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#e5e5e5",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M477.8 297.8c2 0 1.6 0 3-1.4s1.3-1.3 1.3-2.6v-18.4c0-1-.3-1.2-1.3-1.2h-13.7c-1 0-1.5.4-2.7 1.3-1 .8-1.8 1.2-1.8 2.2v20.1z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M479.3 297.4c0 1-.3 1.3-1.4 1.3h-14.8c-1.1 0-1.3-.3-1.3-1.3v-20.1c0-1 .2-1.3 1.3-1.3h14.8c1.1 0 1.4.3 1.4 1.3z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#96877d",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M508 222.3c2.8 3.2 3.8 7.5 2.2 11.8H506c1.8-5.5.7-10.6-7-11.3-11.4-1-24.8 21.2-44.9 23.9-5.8-7-5.5-20.3 2-26.6a82 82 0 0 0-17.7-28.6 55 55 0 0 0-10.7-.7c3-6.4 11.3-13 18.1-15.7a82 82 0 0 1 3.4-4.5c.7-8.7 42-4.7 50.7.7 0 9.8 3.9 42.2 8.2 51z"
    }),
    /* @__PURE__ */ jsx253("path", {
      d: "M458 228.2c-1-15-7.1-27.4-15.7-35.8a23.5 23.5 0 0 0 18-3c7.5-5 27-13.6 34-9.9.6 1.3 1 4 .5 5.9-1.7-4.5-20.4 2.4-25.7 4.6-5 2.3-7.3 5.5-5.5 12.6-3-2.5-2-4.8-5-6.6 1.2 2.9 2.2 8.2 2.6 12.5-1.2-3-3.2-9.6-7.6-13.5a74.2 74.2 0 0 1 5.6 34.8c3 0 9.8-3 12.4-5-2.3 3.3-9.2 5.7-13.5 6.6a22 22 0 0 0-3.3 11.8c-.3-4.2 1-14.3 3.1-15zm50-5.9c-3.8-4.2-10.7-6.4-19.6-4a28 28 0 0 1 6.8-2.3c-.3-2.3-2.4-12.5-2.8-15l2.5-1c1.3 6.1 2.8 13.1 3.8 16 .8.1 2.6.5 4.2 1.3-.7-2.4-4.5-19.4-4.4-21.2l3.4-1.8a138 138 0 0 0 6 28z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#96877d",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M506 234c1.7-5.3.6-10.5-7-11.2-6-.5-12.4 5.3-20 11.3zm-49.9-48.5a45 45 0 0 1-14.8-1.5c.2-1 .6-2 1.1-3.2a47 47 0 0 0-8.5 6.8c5.4 1.2 16.6 1.7 22.2-2.1z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M456 220c1.2 3.7 2 7.2 2.1 10.3m-12.4-55.2c-2 3-3.8 6.2-4.4 9a47.6 47.6 0 0 0 14.8 1.4"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M438.4 191.5c1.4.3 2.8.5 4 .9 4 1.1 12.3 1.1 18-3 5.6-4 21-16.7 38.3-18"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M433.9 187.6c5.4 1.2 16.6 1.7 22.2-2.1a76.1 76.1 0 0 1 38.4-14.8"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#337321",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M528.5 247.2c19 13 33 25.7 37 46s11.7 25.7 21.2 20.3c-2.2 11.7-14 13-23.9 4 1 13.6-4.5 29.8-18.5 35.7-.9-8.1 4.5-14.6 3-21.2-.7-3-1-9.7 2.9-12.9-7.5 2.5-19.2-2.2-20.3-13.3 8.6 4 19.6 4.7 23.9-6.1 4.2-10.8 2.4-29.3-25.3-52.5zm23.9-105.6c5.9-15.3 21.2-13.7 26.4-7.2 15.1-8.6 17.2 10.8 30 7-.2 3.6-4.5 7-9.2 6.7 5 4.5-2 11.3 8.5 15.4-9 4.5-21.6-.2-25-12.7-3 5.9-13.5 5.9-17.8 1.2 9.2-2.5 8.6-11 3.4-14.5-5.3-3.4-14.5-2-16.3 4.1zm-45.7 33.8a82.2 82.2 0 0 0 22.3 34.8c10.8 10 27.1 7.4 36.3-2 .2 18.8-19.4 20.3-30.2 14.4-4.8-2.6-8.7-1.3-4.1 3 7 6.2 22.3 11 40.4 14.8 31.5 6.8 20.3 31.8 11 31.6 2.7 0 4.9-2.9 1-6.3-27.4-24.7-83-15-82.2-70-5.8 14.5-30 8.8-18.7-8.3 3.6 2.9 10 3.1 11.7-1.4 1.4-3.5.5-9.6-5.8-14.9 1 0 3.3 0 3-2.6.3 1.6 1.7 3.8 5.3 3 1 1.7 2 2.7 3.5 2.1.3 0 1.1-.5.8-2.1.2 3 3.8 4.1 5.7 3.9z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#f7e017",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M535 222.6c13.1 8.5 28 8.5 41.5-7.2 4.3-5 11-9.3 15.8-9.7 4.8-.5 4.5-5 8.1-6-2.2-.6-3.1-3.3-6.5-3 8.5-2.9 6-9.7 10.1-13-3.4 1.3-8.6-3.7-13.5 2.7 1.3-3-.5-6.4-1.7-7.8.5 3.4-6.6 4-8 12.6-.7 4.8-3.4 4.6-3.8-2.9-.3-5.4-3-20.5-6-28.2-3.2-7.6-4-18.2.3-19.7a7.7 7.7 0 0 0-2.6-2.8c-5.3-3.4-14.5-2-16.3 4-5.8 15.4 10.6 24.2 9.3 40.9-2.5-12.4-22.6-15.6-22.4-27.8-6.5 3-5.6 8.4-3.1 12.7-4-6.3-13.3 4-21.2-4.5-1 11.3 9 15.5 17.1 16-4 7.2 1.4 13.3 6.8 15.3.2-12.6 26.1-7.5 26.4 14.2.2 18.5-19.7 20-30.3 14.2zm36.4 17.8c31.5 6.8 20.3 31.8 11 31.6-5.9-.2-11.5-5.1-11.8-9.4-6.8 3.6-5 10.7.2 13.5-14.2-1.6-20.2 7.7-20.5 18 2.6-4.8 10.4-5 13.4-4s10.5 1.5 13.5-2c-2.5 2.2 1.6 7.2-2 11 12-.4 17.1-11.5 15-16.3 15.4-14 12.5-36.8-18.8-42.4zm-24.1 107.2c2 1.2 1.8 4 .4 5.7-2.8 3.4 1.4 11.5-7.2 13-2.5.3-4.4-1.3-5.2-4.2-2.4-8 6.1-8.6 7-12.3 1-3.8 3.3-3.3 5-2.2z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#f7e017",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M539.6 362.1c2.7 1.4 5.1 3.4 3.7 12.4-.7 3.7-.8 12.8 2.5 13-2 1-6.4 1.9-8-.5-1.9 2.8-5.7 1.8-7-1.8-2.2 1.6-4.8-1.3-4.7-3.7-1.8 1-5.3-.7-4.2-6-2.2.6-4.9-1-5.8-2.4 3.1-.6 11.2-4.5 13.3-7.8 2-3.4 7-4.8 10.2-3.2z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M537.7 387c1-1.2 1.5-6.5 1-9.7m-8 7.9c1.5-1 4.2-4.5 4.8-7.7m-9.5 4a22 22 0 0 0 7.4-9.7m-11.5 3.7c2-.4 8.6-4.3 11.4-8.6"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#f7e017",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M501.2 195.8c-.4 23 9.2 34.8 22.6 42.4-5-3-2.8-13.1-9.5-16.4 1.6-.1 4 2.1 8 1.2-2-4.2-5-10.8-12.4-11.7 2-.2 6 .5 8.8-.5-3.8-6-14-3.1-17.5-15zm-2.4-22c-.8-.3-1.5-1.1-2.1-2.2-3.6.8-5-1.5-5.3-3 .3 2.6-2 2.5-3 2.6 6.3 5.2 7.2 11.3 5.8 14.8-1.8 4.5-8 4.3-11.7 1.4-.5 9.6 12 12.7 16.5.7 0 2 2.6 1.8 3.2 4.5 3.2-5.2.8-12.7-3.4-18.8z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#337321",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M479 128a27 27 0 0 1-8-18.9c.2-5 2.2-10.3 9.5-8-2.3 0-.7 4.4-3 4.9 1.8.7 4.4-.9 4.8-2 .4 1.6 3.4 1.2 3.6 3 1.1-.9-.1-5.3-1.8-6.2 1.2-.7 2-4.2 1.4-5.9-1.2.2-2.9 1.8-3.2 4.1.6-1.8-.1-6.3-3.3-7-.9 1.2-1.1 4.3.1 6-2.9-.7-7.2 1.2-8.2 3.7.2-3 .6-7.3 2.5-10 .6-.8-1-2.4-2.1-.3-2.2-4.3-8-6.5-10.7-4.4-2.6 2.2-6-1-8.2 2.4-2.1 3.4-9.4 3.7-9 7.3.2 2.2-.3 5.5-1.4 6.7-2.6 2.9 1.3 5 2 7.6-.5-8.5 13.1-25.2 26.8-18.7a30.2 30.2 0 0 0-2.7 11.6c-.6 7.7.6 18.5 8 24.9z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#c8102e",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M483 101.1c0-2 3.5-4.7 8.2-4.6 5.7 0 10 5.2 14.6 4.7s2.4 2 1.4 2.8c-1 .6-1.5 1.6-1.2 2.9.3 1.2-.2 2-2 .9-4.1-2.6-8.2 1-13.6-1-4.5-1.7-7.2-2.7-7.4-5.7z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#96877d",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M459.8 154.4a34.3 34.3 0 0 0-15-16.7l-.2-3.8a50 50 0 0 0 10.1-7.6c17 8 40-3.4 50.6-15.3l4 2.4-2 2.7-2.1-1.1a129.6 129.6 0 0 1-15.2 14.2c3.9 1 9.3 1.7 10.8 1.6 9.4-6.8 16.9-12.9 20.5-13.3l3 4-2.7 2-2.1-1.3a108.7 108.7 0 0 0-26.2 38.8c-6.3-1.4-28.9-.5-33.5-6.6z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M490 129.2c-1.5-.4-2.8-.8-3.5-1.2a22.7 22.7 0 0 1-12.1 3.4"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M460.7 151.9c-1.5-8.4 1-17.8 5.2-20.6a33.6 33.6 0 0 0 34.8-.5"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M460.7 147.5c7.2-.2 23 1 26.7 1.5 3.9.6 10.3 2.2 9.4 4.1m-32.8-6.8 2.1-2-2-2.1-2.1 2z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#337321",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M469 104.3c-2.6-3.6-9.8-4.8-11.3 0-.7 2.2-1.7 4.5-3.4 5.5s-1.3 4.1-.6 5.4c1.8 3.3.2 6.5 3.7 8.6 0-2.6 3.9-5.3 7.1-6 3.3-.6 8.3-3.6 9-6.8.6-3.4 1.8-6-4.5-6.7z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#96877d",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M452.7 136.8h1v6.1l.5.3 5.3-3 .5.7-5.4 3.1v.6l5.4 3-.5.8-5.4-3c-.1.1-.3.3-.5.3v6.2h-.9v-6.2a2 2 0 0 1-.5-.3l-5.3 3.1-.5-.8 5.3-3v-.7l-5.3-3 .5-.8 5.3 3 .5-.3z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#96877d",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M460.7 151.8a10.7 10.7 0 1 1 .9-14 24 24 0 0 0-1.2 5.7 7.3 7.3 0 1 0-7.3 8c3.4 0 6.3-2.3 7.2-5.4 0 1.4 0 4.6.4 5.7z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#337321",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M448.6 162c-.6-.8-1.9-3-1.7-4.5a6 6 0 0 1 3.8 1.5c-.1-1.2-.6-3.6-.3-4.8 1.2.5 3.8 2 4.7 3.6-.2-1.1-.7-4-.2-5.8 1.3.8 3.6 2.9 4 4.4.2-2.3 1-6 1.6-7 1 1 2.6 2 3.6 3.4.2-1.9 1.2-4 2.5-4.5 1 1 2.6 3.7 3 6.6 1-.3 2.3-2 2.9-3 .5 1 1.1 2.5.7 4.5 1.3-1.2 2.8-2.7 3-4.1 1 .7 2.7 2.4 3.1 4.2-.2-1.5 0-4.1-.5-5.6 1.6 1 3 2.5 3.3 4.2.5-1.6 1.5-4.4 2.4-5 .9 1.8 1.8 4 1.7 5.7.6-1.1 1.4-3.2 2.3-3.6.8 1.2.7 4 .5 5.4.8-1.1 2.3-2.5 3.2-3 0 .8.2 2.1 0 3.1a14 14 0 0 0 3.2-5.2c1.6.8 3.2 3.5 3.3 4.9 1.2-.5 3.4-2.5 4-3.6 0 .8.4 3 0 4.6.7-.7 1.3-2 1.7-2.6.4 1.1 0 3.8-.4 5.3a6 6 0 0 1 3.4-1.5 20 20 0 0 1-2.5 7.8c-10.8-3-33.5-4.1-56.3-5.4z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#f7e017",
      d: "M486.4 102.3c0-.9 1.8-2.7 5.1-2.7 4 0 7.7 3 10.9 2.7 3.2-.2 1.6.9 1 1.1-.8.3-1.1.7-1 1.2.3.6 0 .9-1.4.4-2.8-1-5.7.4-9.4-.4-3.2-.7-5.1-1-5.2-2.3"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#f7e017",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M452.1 168.8c-3.3 4-6.7 3.4-7.4.8-.7-2.6 1.8-3.8.9-6.1s1.5-3.3 2.6-2.3 4.8-2.2 6.3 1.2c1.6 3.4 2.8 5.7 2 7-1 1.4-3.7.7-4.4-.6zm14.6-6.1c-.6-1.5 2.9-4.4 4.7-2.3 1.8 2 4.6-2.2 6.2 1 1.6 3.2 2 4.9 2.9 6.7.7 1.8-4.3 2.7-5.9 1.2.2 1-4.4 1.9-5.6-1.2zm23.4 1.9c-.8-1.6 3.3-3.9 5.5-1 .5-1.2 4.6-1.4 4.9 2l.5 6.9c.1 1.3-2.5 2.6-4.3-.9-3.4.7-4.9-1.2-5.3-3.1-.4-2-.8-3-1.3-4z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "#337321",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M454.3 162.3c-.5-1.1 3-3.4 5.2-1.7 2.3 1.7 5.5-1.4 7 1.6 2.7 6.2 2.8 6.6 2 7.8-.8 1.2-4.5.7-5.4-1-.1 1.2-3.3 1-4.9.1-1.8-1-3.1-4.8-3.9-6.8zm23.7.3c-.7-1.8 4.6-3.3 7-.2 1.1-1.1 3.7-1.2 5.1 2.2 1.5 3.3 1.7 5.1.7 6-.8.6-3.5 1-4.4-.5-1.3.8-5.1.1-6-2-.8-2.1-1.5-4-2.3-5.5zm22.5 3.4c0-1.7 2.8-2.4 3.9 0 1 2.2 4.5.1 4.8 4 0 .7-.4 3.5-1.5 4.9-1 1.3-6.3 0-6.7-2.9z"
    }),
    /* @__PURE__ */ jsx253("path", {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "M452.1 168.8c-1.2-1.7-2.9-4.4-5-1.5m16.1 1.7c-.8-.9-1.7-2.5-2-3.7m13.4 4c-.8-.6-2-1.7-2.6-2.9m1.6-3c2 .2 3.3 2 3.9 2.9.6.8 2 2.4 3 2.5m5.9 1.3c-.7-1-1.4-2-1.5-2.8m.1-4.9c.6 1 1.1 1.7 1.5 2.6m10.1 6.6a9.3 9.3 0 0 0-3.5-3.9m3.1-2.3c.1 3.3 4.5 3.6 4.7 6m3.5-5.4c.4.8.6 1.6.6 3"
    })
  ]
});
var Pn_default = SvgPn;

// src/country-flag-icons/generated/Pr.tsx
init_esm_shims();
import { jsx as jsx254, jsxs as jsxs229 } from "react/jsx-runtime";
var SvgPr = (props) => /* @__PURE__ */ jsxs229("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx254("defs", {
      children: /* @__PURE__ */ jsx254("clipPath", {
        id: "pr_svg__a",
        children: /* @__PURE__ */ jsx254("path", {
          fillOpacity: 0.7,
          d: "M-37.3 0h682.7v512H-37.3z"
        })
      })
    }),
    /* @__PURE__ */ jsxs229("g", {
      fillRule: "evenodd",
      clipPath: "url(#pr_svg__a)",
      transform: "translate(35) scale(.9375)",
      children: [
        /* @__PURE__ */ jsx254("path", {
          fill: "#ed0000",
          d: "M-37.3 0h768v512h-768z"
        }),
        /* @__PURE__ */ jsx254("path", {
          fill: "#fff",
          d: "M-37.3 102.4h768v102.4h-768zm0 204.8h768v102.4h-768z"
        }),
        /* @__PURE__ */ jsx254("path", {
          fill: "#0050f0",
          d: "m-37.3 0 440.7 255.7L-37.3 511z"
        }),
        /* @__PURE__ */ jsx254("path", {
          fill: "#fff",
          d: "M156.4 325.5 109 290l-47.2 35.8 17.6-58.1-47.2-36 58.3-.4 18.1-58 18.5 57.8 58.3.1-46.9 36.3z"
        })
      ]
    })
  ]
});
var Pr_default = SvgPr;

// src/country-flag-icons/generated/Ps.tsx
init_esm_shims();
import { jsx as jsx255, jsxs as jsxs230 } from "react/jsx-runtime";
var SvgPs = (props) => /* @__PURE__ */ jsxs230("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx255("defs", {
      children: /* @__PURE__ */ jsx255("clipPath", {
        id: "ps_svg__a",
        children: /* @__PURE__ */ jsx255("path", {
          fillOpacity: 0.7,
          d: "M-118 0h682.7v512H-118z"
        })
      })
    }),
    /* @__PURE__ */ jsx255("g", {
      clipPath: "url(#ps_svg__a)",
      transform: "translate(110.6) scale(.9375)",
      children: /* @__PURE__ */ jsxs230("g", {
        fillRule: "evenodd",
        strokeWidth: "1pt",
        children: [
          /* @__PURE__ */ jsx255("path", {
            fill: "#000001",
            d: "M-246 0H778v170.7H-246z"
          }),
          /* @__PURE__ */ jsx255("path", {
            fill: "#fff",
            d: "M-246 170.7H778v170.6H-246z"
          }),
          /* @__PURE__ */ jsx255("path", {
            fill: "#090",
            d: "M-246 341.3H778V512H-246z"
          }),
          /* @__PURE__ */ jsx255("path", {
            fill: "red",
            d: "m-246 512 512-256L-246 0z"
          })
        ]
      })
    })
  ]
});
var Ps_default = SvgPs;

// src/country-flag-icons/generated/Pt.tsx
init_esm_shims();
import { jsx as jsx256, jsxs as jsxs231 } from "react/jsx-runtime";
var SvgPt = (props) => /* @__PURE__ */ jsxs231("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx256("path", {
      fill: "red",
      d: "M256 0h384v480H256z"
    }),
    /* @__PURE__ */ jsx256("path", {
      fill: "#060",
      d: "M0 0h256v480H0z"
    }),
    /* @__PURE__ */ jsxs231("g", {
      fill: "#ff0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.6,
      children: [
        /* @__PURE__ */ jsx256("path", {
          d: "M339.5 306.2c-32.3-1-180-93.2-181-108l8.1-13.5c14.7 21.3 165.7 111 180.6 107.8z"
        }),
        /* @__PURE__ */ jsx256("path", {
          d: "M164.9 182.8c-2.9 7.8 38.6 33.4 88.4 63.8 49.9 30.3 92.9 49 96 46.4l1.5-2.8c-.6 1-2 1.3-4.3.6-13.5-3.9-48.6-20-92.1-46.4-43.6-26.4-81.4-50.7-87.3-61a6.3 6.3 0 0 1-.6-3.1h-.2l-1.2 2.2zm175.3 123.8c-.5 1-1.6 1-3.5.8-12-1.3-48.6-19.1-91.9-45-50.4-30.2-92-57.6-87.4-64.8l1.2-2.2.2.1c-4 12.2 82.1 61.4 87.2 64.6 49.8 30.8 91.8 48.9 95.5 44.2z"
        }),
        /* @__PURE__ */ jsx256("path", {
          d: "M256.2 207.2c32.2-.3 72-4.4 95-13.6l-5-8c-13.5 7.5-53.5 12.5-90.3 13.2-43.4-.4-74.1-4.5-89.5-14.8l-4.6 8.6c28.2 12 57.2 14.5 94.4 14.6"
        }),
        /* @__PURE__ */ jsx256("path", {
          d: "M352.5 193.8c-.8 1.3-15.8 6.4-37.8 10.2a381.2 381.2 0 0 1-58.6 4.3 416.1 416.1 0 0 1-56.2-3.6c-23.1-3.6-35-8.6-39.5-10.4l1.1-2.2c12.7 5 24.7 8 38.7 10.2A411.5 411.5 0 0 0 256 206a391.8 391.8 0 0 0 58.3-4.3c22.5-3.7 34.8-8.4 36.6-10.5zm-4.4-8.1c-2.4 2-14.6 6.3-36 9.7a388.2 388.2 0 0 1-55.8 4c-22 0-40.1-1.6-53.8-3.6-21.8-2.8-33.4-8-37.6-9.4l1.3-2.2c3.3 1.7 14.4 6.2 36.5 9.3a385 385 0 0 0 53.6 3.4 384 384 0 0 0 55.4-4c21.5-3 33.1-8.4 34.9-9.8zM150.3 246c19.8 10.7 63.9 16 105.6 16.4 38 .1 87.4-5.8 105.9-15.6l-.5-10.7c-5.8 9-58.8 17.7-105.8 17.4-47-.4-90.7-7.6-105.3-17v9.5"
        }),
        /* @__PURE__ */ jsx256("path", {
          d: "M362.8 244.5v2.5c-2.8 3.4-20.2 8.4-42 12a434 434 0 0 1-65.4 4.4 400 400 0 0 1-62-4.3 155 155 0 0 1-44.4-12v-2.9c9.7 6.4 35.9 11.2 44.7 12.6 15.8 2.4 36.1 4.2 61.7 4.2 26.9 0 48.4-1.9 65-4.4 15.7-2.3 38-8.2 42.4-12.1m0-9v2.5c-2.8 3.3-20.2 8.3-42 11.9a434 434 0 0 1-65.4 4.5 414 414 0 0 1-62-4.3 155 155 0 0 1-44.4-12v-3c9.7 6.5 36 11.2 44.7 12.6a408 408 0 0 0 61.7 4.3c26.9 0 48.5-2 65-4.5 15.7-2.2 38-8.1 42.4-12m-107 68.8c-45.6-.2-84.7-12.4-93-14.4l6 9.4a249.8 249.8 0 0 0 87.4 14.3c34.7-1 65-3.7 86.3-14.1l6.2-9.8c-14.5 6.9-64 14.6-93 14.6"
        }),
        /* @__PURE__ */ jsx256("path", {
          d: "M344.9 297.3a143 143 0 0 1-2.8 4c-10 3.6-26 7.4-32.6 8.4a295.5 295.5 0 0 1-53.7 5c-40.4-.6-73.5-8.5-89-15.3l-1.3-2.1.2-.4 2.1.9a286.5 286.5 0 0 0 88.2 14.5c18.8 0 37.5-2.1 52.6-4.8 23.2-4.7 32.6-8.2 35.5-9.8l.7-.4zm5.3-8.8a287.2 287.2 0 0 1-2 3.5c-5.4 2-20 6.2-41.3 9.2-14 1.9-22.7 3.8-50.6 4.3a347.4 347.4 0 0 1-94.2-14L161 289a390 390 0 0 0 95.4 14c25.5-.5 36.4-2.4 50.3-4.3 24.8-3.8 37.3-8 41-9.1a2.9 2.9 0 0 0 0-.2l2.6-1z"
        }),
        /* @__PURE__ */ jsx256("path", {
          d: "M350.8 237.6c.1 30-15.3 57-27.6 68.8a99.3 99.3 0 0 1-67.8 28.2c-30.3.5-58.8-19.2-66.5-27.9a101 101 0 0 1-27.5-67.4c1.8-32.8 14.7-55.6 33.3-71.3a99.6 99.6 0 0 1 64.2-22.7 98.2 98.2 0 0 1 71 35.6c12.5 15.2 18 31.7 20.9 56.7M255.6 135a106 106 0 0 1 106 105.2 105.6 105.6 0 1 1-211.4 0c-.1-58 47.3-105.2 105.4-105.2"
        }),
        /* @__PURE__ */ jsx256("path", {
          d: "M255.9 134.5c58.2 0 105.6 47.4 105.6 105.6S314.1 345.7 256 345.7s-105.6-47.4-105.6-105.6c0-58.2 47.4-105.6 105.6-105.6zM152.6 240c0 56.8 46.7 103.3 103.3 103.3 56.6 0 103.3-46.5 103.3-103.3s-46.7-103.3-103.3-103.3S152.6 183.2 152.6 240"
        }),
        /* @__PURE__ */ jsx256("path", {
          d: "M256 143.3a97 97 0 0 1 96.7 96.7 97.1 97.1 0 0 1-96.7 96.8c-53 0-96.7-43.6-96.7-96.8a97.1 97.1 0 0 1 96.7-96.7M161.6 240c0 52 42.6 94.4 94.4 94.4s94.4-42.5 94.4-94.4c0-52-42.6-94.4-94.4-94.4a94.8 94.8 0 0 0-94.4 94.4"
        }),
        /* @__PURE__ */ jsx256("path", {
          d: "M260.3 134h-9.1v212.3h9z"
        }),
        /* @__PURE__ */ jsx256("path", {
          d: "M259.3 132.8h2.3v214.7h-2.2V132.8zm-9 0h2.4v214.7h-2.3z"
        }),
        /* @__PURE__ */ jsx256("path", {
          d: "M361.6 244.2v-7.8l-6.4-6-36.3-9.6-52.2-5.3-63 3.2-44.8 10.6-9 6.7v7.9l22.9-10.3 54.4-8.5h52.3l38.4 4.2 26.6 6.4z"
        }),
        /* @__PURE__ */ jsx256("path", {
          d: "M256 223.8c24.9 0 49 2.3 68.3 6 19.8 4 33.7 9 38.5 14.5v2.8c-5.8-7-24.5-12-39-15-19-3.6-43-6-67.9-6-26.1 0-50.5 2.6-69.3 6.2-15 3-35.1 9-37.6 14.8v-2.9c1.3-4 16.3-10 37.3-14.3 18.9-3.7 43.3-6.1 69.6-6.1zm0-9.1a383 383 0 0 1 68.3 6c19.8 4 33.7 9 38.5 14.6v2.7c-5.8-6.9-24.5-12-39-14.9-19-3.7-43-6-67.9-6a376 376 0 0 0-69.2 6.2c-14.5 2.7-35.4 8.9-37.7 14.7v-2.8c1.4-4 16.6-10.3 37.3-14.3 19-3.7 43.3-6.2 69.7-6.2m-.6-46.2c39.3-.2 73.6 5.5 89.3 13.5l5.7 10c-13.6-7.4-50.6-15-94.9-14-36.1.3-74.7 4-94 14.4l6.8-11.4c15.9-8.3 53.3-12.5 87.1-12.5"
        }),
        /* @__PURE__ */ jsx256("path", {
          d: "M256 176.7a354 354 0 0 1 61.3 4.3c16 3 31.3 7.4 33.5 9.8l1.7 3c-5.3-3.4-18.6-7.3-35.6-10.5s-38.7-4.3-61-4.2c-25.3-.1-45 1.2-61.8 4.2a108.9 108.9 0 0 0-33.3 10.3l1.7-3.1c6-3 15.3-6.7 31.1-9.6 17.5-3.2 37.4-4.1 62.4-4.2m0-9c21.4-.2 42.6 1 59.1 4a96 96 0 0 1 30.6 10l2.5 4c-4.2-4.7-20-9.2-34.1-11.6-16.4-2.9-36.7-4-58.1-4.2a361 361 0 0 0-59.5 4.4 97.3 97.3 0 0 0-29.6 9.1l2.2-3.3c5.8-3 15.2-5.8 27-8.1a357 357 0 0 1 59.9-4.4zM308.4 284a276.4 276.4 0 0 0-52.5-4c-65.5.8-86.6 13.5-89.2 17.3l-5-8c16.8-12 52.4-18.8 94.6-18.2 21.9.4 40.8 1.9 56.6 5l-4.5 8"
        }),
        /* @__PURE__ */ jsx256("path", {
          d: "M255.6 278.9c18.2.3 36 1 53.3 4.2l-1.2 2.2c-16-3-33.2-4-52-4-24.3-.2-48.7 2.1-70 8.2-6.7 1.9-17.8 6.2-19 9.8l-1.2-2c.4-2.2 7-6.6 19.6-10 24.4-7 47.2-8.3 70.5-8.4m.8-9.2a327 327 0 0 1 57.3 5l-1.3 2.3a299 299 0 0 0-56-4.9c-24.2 0-49.9 1.8-73.3 8.6-7.5 2.2-20.6 7-21 10.7l-1.2-2.2c.2-3.4 11.5-7.9 21.7-10.8 23.5-6.9 49.3-8.6 73.8-8.7"
        }),
        /* @__PURE__ */ jsx256("path", {
          d: "m349.4 290.5-7.8 12.3-22.7-20.1-58.6-39.5-66.2-36.3-34.3-11.7 7.3-13.6 2.5-1.3 21.3 5.3 70.4 36.3 40.6 25.6L336 272l13.9 16z"
        }),
        /* @__PURE__ */ jsx256("path", {
          d: "M158.6 195.5c6-4 50.2 15.6 96.6 43.6 46.1 28 90.3 59.6 86.3 65.5l-1.3 2.1-.6.5c.1-.1.8-1 0-3.1-2-6.5-33.4-31.5-85.3-62.9-50.7-30.1-92.9-48.3-97-43.1zM351 290.4c3.8-7.6-37.2-38.5-88.1-68.6-52-29.5-89.6-46.9-96.5-41.7L165 183c0 .1 0-.2.4-.5 1.2-1 3.3-1 4.2-1 11.8.2 45.5 15.7 92.8 42.8 20.8 12 87.6 55 87.3 67 0 1 .1 1.2-.3 1.8l1.7-2.6z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs231("g", {
      transform: "translate(0 26.7) scale(1.06667)",
      children: [
        /* @__PURE__ */ jsx256("path", {
          fill: "#fff",
          stroke: "#000",
          strokeWidth: 0.7,
          d: "M180.6 211a58.7 58.7 0 0 0 17.5 41.7 59 59 0 0 0 41.8 17.6 59.4 59.4 0 0 0 42-17.4 59 59 0 0 0 17.4-41.8v-79.2l-118.7-.2z"
        }),
        /* @__PURE__ */ jsx256("path", {
          fill: "red",
          stroke: "#000",
          strokeWidth: 0.5,
          d: "M183 211.1a56.4 56.4 0 0 0 16.8 40 57 57 0 0 0 40.2 16.8 56.9 56.9 0 0 0 40.2-16.6 56.4 56.4 0 0 0 16.7-40v-77H183v76.8m91-53.7v48.9l-.1 5.1a33.2 33.2 0 0 1-10 24 34 34 0 0 1-24 10c-9.4 0-17.7-4-23.9-10.2a34 34 0 0 1-10-24v-54z"
        }),
        /* @__PURE__ */ jsxs231("g", {
          id: "pt_svg__e",
          children: [
            /* @__PURE__ */ jsxs231("g", {
              id: "pt_svg__d",
              fill: "#ff0",
              stroke: "#000",
              strokeWidth: 0.5,
              children: [
                /* @__PURE__ */ jsx256("path", {
                  stroke: "none",
                  d: "M190.2 154.4c.1-5.5 4-6.8 4-6.8.1 0 4.3 1.4 4.3 6.9z"
                }),
                /* @__PURE__ */ jsx256("path", {
                  d: "m186.8 147.7-.7 6.3h4.2c0-5.2 4-6 4-6 .1 0 4 1.1 4.1 6h4.2l-.8-6.4zm-1 6.4h17c.3 0 .6.3.6.7 0 .5-.3.8-.6.8h-17c-.3 0-.6-.3-.6-.8 0-.4.3-.7.7-.7z"
                }),
                /* @__PURE__ */ jsx256("path", {
                  d: "M192 154c0-3.3 2.3-4.2 2.3-4.2s2.3 1 2.3 4.2H192m-5.8-9h16.3c.3 0 .6.4.6.8 0 .3-.3.6-.6.6h-16.3c-.3 0-.6-.3-.6-.7 0-.3.3-.6.6-.6zm.4 1.5H202c.3 0 .6.3.6.7 0 .4-.3.7-.6.7h-15.5c-.4 0-.6-.3-.6-.7 0-.4.2-.7.6-.7zm5-10.6h1.2v.8h.9v-.8h1.3v.9h.9v-1h1.2v2c0 .4-.2.6-.5.6h-4.4c-.3 0-.6-.2-.6-.5zm4.6 2.7.3 6.4h-4.3l.3-6.5h3.7"
                }),
                /* @__PURE__ */ jsx256("path", {
                  id: "pt_svg__a",
                  d: "M191 141.6v3.4h-4v-3.4z"
                }),
                /* @__PURE__ */ jsx256("use", {
                  xlinkHref: "#pt_svg__a",
                  width: "100%",
                  height: "100%",
                  x: 10.6
                }),
                /* @__PURE__ */ jsx256("path", {
                  id: "pt_svg__b",
                  d: "M186.3 139h1.2v1h.9v-1h1.2v1h.9v-1h1.2v2c0 .4-.2.6-.5.6h-4.3a.6.6 0 0 1-.6-.6z"
                }),
                /* @__PURE__ */ jsx256("use", {
                  xlinkHref: "#pt_svg__b",
                  width: "100%",
                  height: "100%",
                  x: 10.6
                }),
                /* @__PURE__ */ jsx256("path", {
                  fill: "#000001",
                  stroke: "none",
                  d: "M193.9 140.6c0-.6.9-.6.9 0v1.6h-.9z"
                }),
                /* @__PURE__ */ jsx256("path", {
                  id: "pt_svg__c",
                  fill: "#000001",
                  stroke: "none",
                  d: "M188.6 142.8c0-.6.8-.6.8 0v1.2h-.8z"
                }),
                /* @__PURE__ */ jsx256("use", {
                  xlinkHref: "#pt_svg__c",
                  width: "100%",
                  height: "100%",
                  x: 10.6
                })
              ]
            }),
            /* @__PURE__ */ jsx256("use", {
              xlinkHref: "#pt_svg__d",
              width: "100%",
              height: "100%",
              y: 46.3
            }),
            /* @__PURE__ */ jsx256("use", {
              xlinkHref: "#pt_svg__d",
              width: "100%",
              height: "100%",
              transform: "rotate(-45.2 312.8 180)"
            })
          ]
        }),
        /* @__PURE__ */ jsx256("use", {
          xlinkHref: "#pt_svg__d",
          width: "100%",
          height: "100%",
          x: 45.7
        }),
        /* @__PURE__ */ jsx256("use", {
          xlinkHref: "#pt_svg__e",
          width: "100%",
          height: "100%",
          transform: "matrix(-1 0 0 1 479.8 0)"
        }),
        /* @__PURE__ */ jsxs231("g", {
          id: "pt_svg__f",
          fill: "#fff",
          children: [
            /* @__PURE__ */ jsx256("path", {
              fill: "#039",
              d: "M232.6 202.4a8.3 8.3 0 0 0 2.2 5.7 7.2 7.2 0 0 0 5.3 2.4c2.1 0 4-1 5.3-2.4a8.3 8.3 0 0 0 2.2-5.7v-10.8h-15z"
            }),
            /* @__PURE__ */ jsx256("circle", {
              cx: 236.1,
              cy: 195.7,
              r: 1.5
            }),
            /* @__PURE__ */ jsx256("circle", {
              cx: 244.4,
              cy: 195.7,
              r: 1.5
            }),
            /* @__PURE__ */ jsx256("circle", {
              cx: 240.2,
              cy: 199.7,
              r: 1.5
            }),
            /* @__PURE__ */ jsx256("circle", {
              cx: 236.1,
              cy: 203.9,
              r: 1.5
            }),
            /* @__PURE__ */ jsx256("circle", {
              cx: 244.4,
              cy: 203.9,
              r: 1.5
            })
          ]
        }),
        /* @__PURE__ */ jsx256("use", {
          xlinkHref: "#pt_svg__f",
          width: "100%",
          height: "100%",
          y: -26
        }),
        /* @__PURE__ */ jsx256("use", {
          xlinkHref: "#pt_svg__f",
          width: "100%",
          height: "100%",
          x: -20.8
        }),
        /* @__PURE__ */ jsx256("use", {
          xlinkHref: "#pt_svg__f",
          width: "100%",
          height: "100%",
          x: 20.8
        }),
        /* @__PURE__ */ jsx256("use", {
          xlinkHref: "#pt_svg__f",
          width: "100%",
          height: "100%",
          y: 25.8
        })
      ]
    })
  ]
});
var Pt_default = SvgPt;

// src/country-flag-icons/generated/Pw.tsx
init_esm_shims();
import { jsx as jsx257, jsxs as jsxs232 } from "react/jsx-runtime";
var SvgPw = (props) => /* @__PURE__ */ jsxs232("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx257("defs", {
      children: /* @__PURE__ */ jsx257("clipPath", {
        id: "pw_svg__a",
        children: /* @__PURE__ */ jsx257("path", {
          fillOpacity: 0.7,
          d: "M-70.3 0h640v480h-640z"
        })
      })
    }),
    /* @__PURE__ */ jsxs232("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      clipPath: "url(#pw_svg__a)",
      transform: "translate(70.3)",
      children: [
        /* @__PURE__ */ jsx257("path", {
          fill: "#4aadd6",
          d: "M-173.4 0h846.3v480h-846.3z"
        }),
        /* @__PURE__ */ jsx257("path", {
          fill: "#ffde00",
          d: "M335.6 232.1a135.9 130.1 0 1 1-271.7 0 135.9 130.1 0 1 1 271.7 0"
        })
      ]
    })
  ]
});
var Pw_default = SvgPw;

// src/country-flag-icons/generated/Py.tsx
init_esm_shims();
import { jsx as jsx258, jsxs as jsxs233 } from "react/jsx-runtime";
var SvgPy = (props) => /* @__PURE__ */ jsxs233("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx258("path", {
      fill: "#0038a8",
      d: "M0 319.7h640V480H0z"
    }),
    /* @__PURE__ */ jsx258("path", {
      fill: "#fff",
      d: "M0 160h640v160H0z"
    }),
    /* @__PURE__ */ jsx258("path", {
      fill: "#d52b1e",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsxs233("g", {
      fill: "none",
      stroke: "#000",
      transform: "translate(-116.4) scale(1.45455)",
      children: [
        /* @__PURE__ */ jsx258("circle", {
          cx: 300,
          cy: 165,
          r: 42.2,
          strokeWidth: 1.1
        }),
        /* @__PURE__ */ jsx258("circle", {
          cx: 300,
          cy: 165,
          r: 34.7,
          strokeWidth: 0.5
        }),
        /* @__PURE__ */ jsx258("circle", {
          cx: 300,
          cy: 165,
          r: 26.6,
          strokeWidth: 0.4
        })
      ]
    }),
    /* @__PURE__ */ jsx258("path", {
      d: "m287.3 263.7-7.1 4.2-2.2-3.7a6.2 6.2 0 0 1-.7-1.6 2 2 0 0 1 .1-1.3c.2-.4.5-.7 1-1 .4-.2.7-.3 1.1-.3a2.3 2.3 0 0 1 1.1.2l.8.6v-1.3l.3-.5 1.5-2.3 1.4 2.5-1.4 2.4-.3.8.1.6.1.2 3-1.7zm-5.5.3-.6-1-.4-.5a.7.7 0 0 0-.5-.2.8.8 0 0 0-.5.1l-.4.6c0 .2.1.5.4.9l.5 1zm-6.7-5.5-2.2-6.5 1.7-.6 1.3 4.1 1.3-.4-1.3-3.8 1.6-.5 1.3 3.7 1.5-.5-1.4-4.2 1.8-.5 2.2 6.6zm-2.9-9.7-.4-4.2c-.2-1 0-1.6.4-2.1.4-.6 1-.9 1.8-1 .8 0 1.5.1 2 .6.5.4.8 1.2 1 2.2l.1 1.4 3-.4.4 2.6zm3.3-3-.1-.6c0-.5-.2-.8-.4-1a.8.8 0 0 0-.7-.2 1 1 0 0 0-.6.4c-.2.1-.2.5-.2 1l.1.7zm-3.5-12.5.3-2.6 4.8.6a4.2 4.2 0 0 1 1.4.4c.4.2.8.4 1 .8.4.3.5.7.6 1 .2.6.2 1.2.1 1.9l-.2 1.3c-.1.5-.3.8-.5 1.1a3 3 0 0 1-1.8 1.3h-1.4l-4.9-.5.3-2.5 5 .5c.4 0 .8 0 1-.2.4-.2.5-.6.6-1a1.4 1.4 0 0 0-.3-1c-.2-.4-.6-.5-1-.6zm1-6 1.7-4.6c.2-.8.6-1.3 1.1-1.5a2 2 0 0 1 1.6-.2c.5.2.8.5 1 .9.2.3.3.6.3 1 .3-.5.7-.8 1.1-1a2 2 0 0 1 1.4 0 2.2 2.2 0 0 1 1.5 1.8v1l-.3 1-1.5 4.2zm4-1.4.4-1.1c0-.4.1-.7 0-.8 0-.2-.2-.4-.4-.5a.7.7 0 0 0-.6 0c-.2.2-.4.4-.5.8l-.4 1zm3 1 .5-1.2c.1-.4.2-.7 0-1a.8.8 0 0 0-.4-.4.7.7 0 0 0-.7 0l-.5.9-.4 1.2zm-3-9.6 1.3-2.2 5.4 3.2 2-3.4 1.8 1-3.4 5.6zm5-7.6 1.6-2 6.4 5.3-1.6 2zm11.1-4.3 2.2-1c.3.6.4 1.2.5 1.7a3.1 3.1 0 0 1-.3 1.5 4.5 4.5 0 0 1-1.2 1.5 4 4 0 0 1-2 1.1 3.5 3.5 0 0 1-2 0 4.7 4.7 0 0 1-2-1.6c-1-1-1.4-2-1.3-3.1a4.2 4.2 0 0 1 1.6-2.9 4.2 4.2 0 0 1 2.3-1c.7-.1 1.5 0 2.3.5l-1.4 1.9a1.9 1.9 0 0 0-.6-.3 1.5 1.5 0 0 0-.7 0 1.5 1.5 0 0 0-.6.4 1.5 1.5 0 0 0-.6 1.4c0 .4.4.9.8 1.4.6.7 1.1 1.1 1.6 1.2.4 0 .8 0 1.2-.4.4-.3.6-.6.6-1s-.1-.8-.4-1.3m8.8-3.2-2.5 1.4.3 1.4-2.3 1.2-1.2-8.7 2.5-1.3 6.6 5.8-2.4 1.3zm-1.3-1.3-2.2-2.2.6 3zm7.8-8.5 3.8-.6a4.6 4.6 0 0 1 1.8 0c.5.1 1 .3 1.3.7s.7.7.9 1.2c.2.4.4 1 .4 1.5.2.9.2 1.6.1 2a3.4 3.4 0 0 1-.6 1.4 2.7 2.7 0 0 1-1 .9 6 6 0 0 1-1.5.5l-3.7.6zm2.9 1.4.8 4.5.6-.1c.5-.1.9-.2 1-.4.3-.1.4-.4.5-.7v-1.4c-.2-.9-.5-1.4-.8-1.7-.3-.3-.8-.4-1.5-.3zm7.8-2.8 6.8.3v1.8l-4.3-.2-.1 1.3 4 .2-.1 1.7-4-.2v1.6l4.4.2-.1 1.9-7-.3zm10 .8 2.4.6-1.5 6 4 1-.6 2-6.3-1.6zm13.2 4.4 3.7 2.2c.8.4 1.3 1 1.4 1.6.2.6 0 1.3-.3 2a2.5 2.5 0 0 1-1.7 1.3c-.6.1-1.4 0-2.3-.6l-1.2-.7-1.6 2.6-2.2-1.3zm.4 4.4.6.3 1 .3a.8.8 0 0 0 .6-.4 1 1 0 0 0 0-.7c0-.3-.2-.5-.6-.8l-.6-.3zm7.2 9.6-2.1-2-1.2.7-2-1.7 8-4 2 2-3.4 8.1-2-1.8zm.8-1.7 1.4-2.8-2.7 1.6zm1 5.5 6.9-4.7 2.3 3.5 1 1.7-.1 1.2a2.3 2.3 0 0 1-1 1.1c-.3.3-.7.4-1 .4a2.3 2.3 0 0 1-1.2-.2c-.2 0-.5-.3-.8-.5l.2.7-.2.6a3.3 3.3 0 0 1-.2.6l-1.3 2.3-1.6-2.3 1.3-2.6.3-.7a1 1 0 0 0-.2-.7l-.1-.2-2.8 2zm5.5-.6.7.9.4.4c.2.2.3.2.5.2a.8.8 0 0 0 .5-.1.8.8 0 0 0 .3-.6c0-.2 0-.5-.3-.9l-.7-.9zm2.6 12.4-1-2.8-1.5.2-1-2.5 8.9-.1 1 2.6-6.5 6-1-2.6zm1.5-1.2 2.4-2-3.1.3zm2.1 9 1.7-.2.6 3.9-3.5.5a8 8 0 0 1-1.3-1.8 6.8 6.8 0 0 1-.6-2 5 5 0 0 1 .1-2.5 4 4 0 0 1 1.3-1.6 4.9 4.9 0 0 1 2.2-.9 5 5 0 0 1 2.4.2 3.6 3.6 0 0 1 1.7 1.4c.4.6.6 1.3.8 2.2v2a2.7 2.7 0 0 1-.6 1.3c-.3.4-.7.6-1.2.9l-.8-2.4c.3-.1.5-.3.7-.6s.1-.6 0-1a1.7 1.7 0 0 0-.7-1.2c-.4-.3-1-.4-2-.2a3 3 0 0 0-1.7.7c-.4.4-.5 1-.4 1.5 0 .3.1.6.3.8l.5.8h.8zm5.4 12-.2 2.6-5-.4a4.2 4.2 0 0 1-1.3-.4 3 3 0 0 1-1-.8 3 3 0 0 1-.6-1.1 5.1 5.1 0 0 1-.2-1.8l.2-1.3.5-1.2a3 3 0 0 1 .8-.8 2.6 2.6 0 0 1 1-.4 4.9 4.9 0 0 1 1.4-.2l5 .5-.3 2.5-5-.4c-.5 0-.9 0-1.1.3a1.4 1.4 0 0 0-.5 1c0 .4 0 .8.3 1 .2.3.5.5 1 .5zm-9.1 8.8.9-2.8-1.2-.8.8-2.5 7 5.6-1 2.6-8.8.4.9-2.5zm1.9 0 3 .1-2.5-1.8zm3 6.8-1.5 2.4h-3.3l1.5 2.9-1.4 2.4-2.5-5.2-3-1.8 1.4-2.2 3 1.8z"
    }),
    /* @__PURE__ */ jsxs233("g", {
      fill: "#009b3a",
      stroke: "#000",
      strokeWidth: 0.1,
      children: [
        /* @__PURE__ */ jsx258("path", {
          d: "M328.1 211.3s23.4 10.1 19.3 30.9c-4 20.8-17 20.6-22.2 23-5 2.2-8.6 5.5-10.6 5-2-.4-4.7-2-4.7-2s-.2 3.5 3.9 4c4.1.7 9.5-5.3 12-6 2.6-.6 18.5-2.4 22.4-23.5 4.5-22.6-20-30.7-20-31.4z"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M339.9 215.8a3.2.8 75.1 0 1-1.5 0 3.2.8 75.1 1 1 1.5 0z"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M339.1 216a3.3.7 63.3 1 1-1.4.5 3.3.7 63.3 0 1 1.4-.5zm-2.3 1.5a3.1.8 17 0 1-.2 1.6 3.1.8 17 0 1 .2-1.6z"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M337.1 216.7a3.3.7 34.2 1 1-.7 1.3 3.3.7 34.2 1 1 .7-1.3z"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M338.1 216.3a3.3.7 46.2 1 1-1 1 3.3.7 46.2 0 1 1-1z"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m339.7 219.2-1 .6c-.3 0-.6-.3-1.2 0s-1 .9-1.1 1.2c-.1.3.2.5.9.1.7-.3.9-.9 1.2-1.1l1.3-.7.8-1.3c.3-.4 1.2-1 1.6-1.8.3-.6.2-1.1-.2-.9a3 3 0 0 0-1.2 1.3c-.2.4 0 1-.3 1.4zm7.3 2.4a1 4.8-1.6 1 1-2.2-.5 1 4.8-1.6 1 1 2.2.5z"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M345.8 221.5a5 1 77.5 1 1-2.2.1 5 1 77.5 1 1 2.1 0z"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M342 222.7a4.7 1.1 35 1 1-.7 2.2 4.7 1.1 35 1 1 .7-2.2z"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M342.8 221.6a5 1 50.9 0 1-1.4 1.6 5 1 50.9 1 1 1.4-1.5z"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M344.3 221.5a5.1 1 61.8 1 1-1.8 1 5.1 1 61.8 1 1 1.8-1z"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m345.6 226.4-1.8.4c-.3 0-.6-.7-1.5-.5-.9.2-1.7.8-2 1.2-.2.4.1.8 1.2.6 1.2-.2 1.6-1 2.2-1 .5-.2 1.4-.4 2-.4.2-.4 1-1.2 1.5-1.6.5-.5 2-1 2.7-1.8.7-.8.7-1.6 0-1.5a4.8 4.8 0 0 0-2 1.3c-.5.6-.4 1.5-.9 2zm5.1 4.9a1 4.8 8.7 1 1-2-1 1 4.8 8.7 1 1 2 1z"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M349.6 231a1 5-2 1 1-2-.3 1 5-2 1 1 2 .3z"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M345.7 231.4a4.7 1.1 46 1 1-1 2 4.7 1.1 46 1 1 1-2z"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M346.7 230.5a5 1 61.8 1 1-1.7 1.3 5 1 61.8 1 1 1.7-1.3z"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M348.1 230.7a5.1 1 72.5 1 1-1.9.7 5.1 1 72.5 1 1 2-.7z"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M348.5 235.8h-1.7c-.3 0-.5-.8-1.4-.8a3.3 3.3 0 0 0-2.1.8c-.4.4-.1.8 1 .8s1.7-.5 2.3-.6h2l1.8-1.2c.6-.4 2.1-.6 3-1.3.7-.6.9-1.4.3-1.4a5 5 0 0 0-2.3.9c-.5.4-.6 1.3-1.2 1.7-.4.2-1.6 1.1-1.7 1m2.5 6.4a1 4.8 31.3 0 1-1.4-1.7 1 4.8 31.3 0 1 1.4 1.7"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M350.1 241.3a1 5 20.6 0 1-1.8-1.1 1 5 20.6 0 1 1.8 1.1m-3.7-1.2a4.8 1 70 0 1-1.8 1.5 4.8 1 70 0 1 1.8-1.5"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M347.6 239.7a1 5.1-4.9 0 1-2 .5 1 5.1-4.9 1 1 2-.5"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M349 240.4a1 5.2 5.5 1 1-2-.1 1 5.2 5.5 1 1 2 .1"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M347.3 245.3s-1.4-.5-1.6-.7c-.3-.2-.1-.8-1-1.3a3.1 3.1 0 0 0-2.2 0c-.5 0-.4.6.6 1 1 .6 1.8.2 2.3.4l1.8.9c.5-.2 1.6-.3 2.2-.4.6-.1 2.1.4 3.2 0 .9-.3 1.3-1 .7-1.2a4.5 4.5 0 0 0-2.3 0c-.7.1-1.1 1-1.8 1-.5 0-1.9.4-2 .3m1 7.7a1.3 5.5 48.5 1 1-1.1-2.4 1.3 5.5 48.5 1 1 1 2.4"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M347.3 251.9a1.2 5.8 37.5 1 1-1.5-2 1.2 5.8 37.5 1 1 1.5 2"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M343.7 249.2a1.3 5.5-3.5 1 1-2.4 1 1.3 5.5-3.5 1 1 2.4-1"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M345.1 249.2a1.2 5.9 11.6 0 1-2.3-.2 1.2 5.9 11.6 1 1 2.3.1"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M346.3 250.4a1.2 6 22.1 1 1-2.1-.8 1.2 6 22.1 1 1 2.1.8"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M343 255.3a16.3 16.3 0 0 1-1.6-1.4c-.2-.3.1-1-.7-1.8s-1.8-1-2.4-1c-.6.1-.6.7.3 1.6 1 1 2 .8 2.4 1.2.6.4 1.4 1.1 1.7 1.6l2.6.4c.7 0 2.2 1.1 3.5 1.1 1 0 1.8-.5 1.2-1a5.3 5.3 0 0 0-2.6-1c-.8 0-1.5.8-2.2.6l-2.3-.3m-2.3 7.3a1.4 6 79.8 1 1 .3-2.9 1.4 6 79.8 1 1-.3 2.9"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M340.5 261a1.3 6.4 68.5 0 1-.5-2.6 1.3 6.4 68.5 0 1 .5 2.7"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M338.4 256.4a1.4 6 26.2 0 1-2.8-.5 1.4 6 26.2 1 1 2.8.5"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M339.9 257.2a1.3 6.5 41.8 0 1-2.3-1.5 1.3 6.5 41.8 0 1 2.3 1.5"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M340.3 259.1a1.3 6.5 52.7 1 1-1.6-2 1.3 6.5 52.7 0 1 1.6 2"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M334.4 261.7a18.1 18.1 0 0 1-.7-2.2c-.1-.4.6-.8.3-2a4.3 4.3 0 0 0-1.9-2.3c-.5-.3-.9.2-.5 1.6.4 1.4 1.4 1.9 1.7 2.6l.8 2.4 2.2 1.9c.6.5 1.5 2.4 2.7 3.1 1 .7 2 .5 1.8-.2a6.2 6.2 0 0 0-2-2.4c-.7-.6-1.8-.3-2.5-.8-.4-.5-2-1.6-2-1.7"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M330.8 268a1.8 6.1 89 0 1 0-3.5 1.8 6.1 89 0 1 0 3.5"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M330 262.5a1.7 6.3 37.6 0 1-2.7-2.2 1.7 6.3 37.6 1 1 2.6 2.2"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M330.8 265.3a1.7 6.2 66.5 0 1-1.2-3.3 1.7 6.2 66.5 0 1 1.2 3.3m1.7-53.4a3.8.8 41.1 0 1-1.5.8 3.8.8 41.1 1 1 1.5-.8m-1.9 1.5a3.9.8 8.2 0 1 .3 1.6 3.9.8 8.2 1 1-.3-1.6"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M331.4 212.4a4 .7 26.8 1 1-.8 1.3 4 .7 26.8 0 1 .8-1.3M303.7 262s5.1 1.1 9.6 2.7c4.5 1.7 11.3 7.2 13.1 7.6 2 0 4.9-.7 6-3.6-3.2.8-5 2.1-8 .5-1.1-.4-4.6-3.6-8.5-5.3-3.8-1.7-11.5-3.6-11.5-3.6l-.7 1.7m5.5-46.5 5.9-3.1-6.5 1.7-.8 1.1 1.4.3"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M314.8 217c-2.3-.5-5.8-1.3-8-1.4 1.5-1.7 3.6-4.7 5-6.4-1 1.7-2.3 4-2.8 5.5 1.5.9 4 1.6 5.8 2.2"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M308.1 215.9a314.4 314.4 0 0 1 5.3-4.1l-6.1 2.7-.6 1.3h1.4"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M313.7 216.9c-2.3-.5-5.8-1.3-8-1.5 1.4-1.7 3.5-4.7 4.8-6.6-.8 1.8-2.2 4.1-2.7 5.8 1.6.9 4.1 1.6 6 2.3"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m307.3 216.2 6.1-2.6-6.6 1.1-.9 1 1.3.5"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M313 217c-2.3-.3-6-.7-8.2-.6 1.3-2 3-5.3 4.1-7.3-.6 1.9-1.7 4.4-2 6.1 1.7.8 4.3 1.2 6.1 1.7"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m306.6 216.2 4.2-5-5.3 3.9-.3 1.3 1.4-.2"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M313 217.3c-2.5 0-6.4-.3-8.8 0 1.2-2.3 2.7-6 3.6-8.3-.4 2.1-1.3 5-1.4 6.9 1.8.6 4.6 1 6.6 1.4"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m305.8 217.4 5-4.9-6.1 3.5-.4 1.4h1.5"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M311.9 217.4c-2.7 0-6.8-.1-9.5.2 1.8-2.5 4.2-6.6 5.6-9.1-1 2.3-2.4 5.4-3 7.5 1.9.7 4.8 1 6.9 1.4"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m304 217.8 6.6-5.5-7.4 3.9-.8 1.6h1.6"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M311 217.6c-2.7.4-6.9.8-9.4 1.5 1.3-2.7 3.1-7 4.2-9.7-.6 2.4-1.7 5.6-2 7.8 2 .4 5 .3 7.1.4"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m303.2 218.9 5-7-6.3 5.7-.3 1.7 1.6-.4"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M309.4 218.4c-2.6.3-6.8.5-9.4 1 1.5-2.6 3.5-6.8 4.8-9.4-.8 2.3-2 5.5-2.4 7.7 2 .5 5 .5 7 .7"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m302.3 219.6 6.4-5.5-7.3 3.9-.7 1.6h1.6"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M308.7 218.7c-2.7.6-6.9 1.3-9.4 2.1 1.2-2.7 2.8-7.1 3.8-9.8-.5 2.4-1.4 5.6-1.6 7.8 2 .3 5 0 7.2-.1"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m301.2 220 4-7.7-5.4 6.6-.1 1.7 1.5-.7"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M308.7 219.1c-3 .8-7.4 1.8-10 2.8 1-3.1 2.1-8 2.9-11.1-.3 2.7-.9 6.3-.8 8.8 2.3.2 5.5-.3 7.8-.5"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m300.4 221.7 5.2-7.6-6.6 6.1-.3 2 1.7-.5"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M307.5 220c-2.8.9-7.2 2.1-9.8 3.3.8-3.2 1.8-8.1 2.4-11.2-.1 2.7-.5 6.3-.3 8.7 2.2.1 5.4-.6 7.7-.8"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m299.4 222.8 3.9-8.4-5.6 7.2v2l1.7-.8"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M306.4 221.2c-2.8.6-7.3 1.5-10 2.4 1.1-3 2.5-8 3.4-11-.4 2.7-1.1 6.4-1.1 8.7 2.2.3 5.4-.1 7.7-.2"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m298.4 223.6 6.4-6.6-7.5 4.9-.6 1.8 1.7-.1"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M305.2 222.3c-2.9.4-7.3.8-10 1.5 1.3-3 3-7.8 4-10.8-.6 2.7-1.5 6.3-1.7 8.7 2.2.5 5.4.4 7.7.6"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m297.2 223 4.3-8.3-5.9 7v1.9l1.6-.7"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M305.5 221.3c-3 1.3-8 3-10.9 4.6 1-3.7 2-9.5 2.6-13.1 0 3.1-.5 7.4-.3 10.1 2.5 0 6-1.1 8.6-1.6"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m296.6 225.4 5.2-9.4-6.9 8-.2 2.2 1.9-.8"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M304.3 222.5c-3 1.4-7.8 3.4-10.6 5.1.8-3.6 1.5-9.5 2-13 0 3-.2 7.3.1 10 2.5-.3 6-1.5 8.5-2.1"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m295.5 226.8 3.8-10.1-5.7 9 .2 2.3 1.7-1.2"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M303 223.3c-3 1.5-7.8 3.5-10.6 5.3.7-3.7 1.4-9.5 1.9-13.1 0 3-.2 7.3.2 10 2.5-.3 6-1.6 8.5-2.2"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m294.7 228 5.8-8.9-7.4 7.3-.3 2.2 1.9-.6"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M302.7 222.8c-2.7 2.2-7 5.4-9.4 7.8 0-3.8-.5-9.5-.8-13 .6 2.9 1.3 7 2.3 9.5 2.4-.9 5.5-3 8-4.2"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m295 228.5.6-10.7-2.8 10.4.8 2 1.4-1.7"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M302 223.8c-2.8 2.2-7 5.3-9.5 7.7 0-3.7-.5-9.5-.8-13 .7 3 1.3 7 2.3 9.5 2.4-.8 5.5-3 8-4.2"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m294.3 230.3 2.7-10.5-4.7 9.6.3 2.2 1.7-1.3"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M301.6 224c-2.5 2.6-6.6 6.4-8.9 9-.4-3.7-1.5-9.6-2.2-13.2 1 3 2.1 7.1 3.4 9.5 2.3-1.1 5.4-3.6 7.7-5.2"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m294.3 231.6.5-11.1-2.7 10.8.8 2 1.4-1.7"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M300.8 226c-2.7 2.2-7 5.5-9.6 8 0-3.8-.7-9.8-1-13.5.7 3 1.5 7.3 2.5 9.9 2.5-1 5.7-3.1 8.1-4.5"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m293.5 232.9 3.8-10.5-5.8 9.3.2 2.3 1.8-1.1"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M300.8 226c-2.5 2.5-6.3 6.4-8.5 9.1-.4-3.8-1.5-9.8-2.1-13.4 1 3 2 7.2 3.2 9.6 2.3-1.2 5.1-3.7 7.4-5.3"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m293.6 233.4-.4-11-1.8 11 1 1.9 1.2-1.9"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M299.6 226.8c-2.4 2.6-6.1 6.5-8.2 9.3-.5-4-1.8-9.8-2.5-13.5 1 3 2.3 7.2 3.5 9.6 2.2-1.2 5-3.8 7.2-5.4"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m293 234.5 1.2-11.2-3.3 10.6.7 2.2 1.4-1.6"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M299 227.2c-2 2.9-5.5 7-7.4 10-.8-3.8-2.5-9.5-3.5-13 1.3 2.8 2.8 6.8 4.2 9.1 2.1-1.4 4.7-4.2 6.8-6"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m293 235.6-.8-11.3-1.4 11.2 1 2 1.1-2"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M298.9 227.9c-2 3-5.3 7.3-7 10.4-1-3.8-3-9.5-4.2-13 1.4 2.8 3.1 6.8 4.7 9 2-1.5 4.5-4.5 6.5-6.4"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m293.6 236.6 1.2-11.3-3.2 10.6.6 2.3 1.4-1.6"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M298.4 229c-1.7 3.1-4.5 8-6 11.3-1.3-3.6-3.8-9-5.3-12.4 1.7 2.6 3.7 6.3 5.5 8.4 1.9-1.8 4-5.2 5.8-7.4"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m293.3 237.6-3.2-10.8 1 11.3 1.5 1.6.6-2.1"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M298.4 230.2c-1.8 3.2-4.8 8-6.3 11.3-1.3-3.6-3.8-9-5.4-12.3 1.7 2.6 3.8 6.3 5.6 8.3 2-1.8 4.2-5.1 6-7.3"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m293.4 239.6-1.2-11.3-1 11.3 1.1 2 1.1-2"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M298.6 231.2c-1.9 3.1-5 7.9-6.5 11.1-1.3-3.6-3.7-9-5.2-12.4 1.7 2.6 3.7 6.4 5.5 8.4 2-1.7 4.3-5 6.2-7.1"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m293.3 240.5-2.1-11-.1 11.2 1.3 1.8.9-2"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M297.8 232.8c-2 3-5.3 7.5-7 10.7-1.1-3.7-3.3-9.4-4.6-12.8 1.5 2.7 3.4 6.6 5 8.8 2.1-1.6 4.6-4.7 6.6-6.7"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m292.3 241.7 1-11.3-3.1 10.7.7 2.2 1.4-1.6"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M297.9 233c-1.7 3.3-4.6 8.3-6 11.6-1.4-3.5-4-8.8-5.7-12 1.8 2.4 4 6 5.8 8 2-1.9 4-5.3 5.9-7.5"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m292 242.7-3.5-10.6 1.3 11.2 1.5 1.6.6-2.2"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M297.4 233.9c-1.2 3.6-3.2 9-4 12.7-2-3.2-5.5-7.8-7.6-10.7 2.1 2.1 4.9 5.2 7 6.7 1.6-2.3 3.2-6 4.6-8.7"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m295 243.5-3.7-10.4 1.6 11.2 1.5 1.4.6-2.2"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M297.4 235c-1.2 3.6-3.2 9.1-4 12.7-2-3.2-5.4-7.7-7.6-10.5 2.1 2 4.9 5 7 6.6 1.6-2.3 3.2-6.1 4.6-8.8"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m295 245.3-4.8-9.7 2.8 10.8 1.7 1.2.4-2.3"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M297 235.9c-.7 3.7-2 9.5-2.5 13.2-2.3-2.9-6.3-7-8.7-9.4 2.3 1.7 5.4 4.4 7.7 5.5 1.3-2.5 2.4-6.5 3.5-9.3"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m295.4 246.8-2.6-10.9.4 11.3 1.4 1.7.8-2"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M297 237c-.4 3.9-1.2 9.8-1.2 13.5-2.6-2.5-6.9-6-9.5-8.1 2.4 1.4 5.7 3.6 8.1 4.4 1-2.6 1.8-6.8 2.6-9.7"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m295.5 247.6-6.9-7.8 5.2 9.5 2 .6-.3-2.3"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M297.2 238.4c-.4 3.8-1.2 9.7-1.3 13.4-2.6-2.5-6.9-6-9.5-8.2 2.5 1.4 5.8 3.7 8.1 4.5 1.1-2.6 1.8-6.8 2.7-9.7"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M296.3 249.4 291 240l3.3 10.7 1.7 1.1.3-2.3"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M297.5 240c-.3 3.8-.8 9.7-.8 13.5a117 117 0 0 0-9.8-7.6c2.6 1.2 6 3.3 8.3 4 1-2.7 1.6-7 2.3-10"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m297 251.2-6.6-8.3 4.8 9.8 1.8.8v-2.3"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M297.6 241.8c-.3 3.8-.8 9.7-.7 13.5-2.7-2.4-7.1-5.6-9.9-7.6 2.6 1.3 6 3.3 8.4 4 1-2.7 1.5-7 2.2-10"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m297.5 252.6-4.5-10 2.5 11 1.6 1.3.4-2.3"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M297.7 242.9c.2 3.9.2 9.8.6 13.6a134 134 0 0 0-10.4-6.2c2.6.9 6.1 2.4 8.6 2.8.7-2.9.8-7.1 1.2-10.2"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m298.3 252.2-8.3-5.7 7 7.8 2 .1-.7-2.2"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M298 243.3c.3 3.9.7 9.8 1.3 13.5-3-1.9-7.8-4.3-10.8-5.8 2.7.8 6.3 2.2 8.8 2.5.5-2.9.4-7.1.7-10.2"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m299.3 254.3-7-8 5.3 9.6 1.9.7-.3-2.3"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M298.6 244.8c.5 3.8 1 9.7 1.9 13.4-3-1.7-8-3.8-11-5.1 2.7.6 6.4 1.8 8.8 2 .4-3 .2-7.2.3-10.3"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m300.6 255.7-8.3-5.9 7 8 2 .1-.7-2.2"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M298.9 246.4c.7 3.8 1.7 9.7 2.7 13.3-3.1-1.5-8.2-3.1-11.3-4.1 2.8.3 6.5 1.2 9 1 .2-2.9-.3-7-.4-10.2"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m301.6 256.9-7-8.2 5.2 9.7 2 .8-.2-2.3"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M299.3 247.4c1.1 3.7 2.6 9.5 4 13-3.3-1-8.4-2-11.6-2.6 2.8 0 6.5.3 9-.1 0-3-1-7.1-1.4-10.2"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m302 256.9-9.7-2 9.1 4.5 1.9-.7-1.4-1.8"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M300 248.6c1 3.7 2.5 9.4 3.8 12.9-3.2-1-8.3-2-11.5-2.6 2.8 0 6.5.3 9 0 0-3-1-7.2-1.3-10.3"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m303.5 257.9-9.2-4.5 8.2 6.7 2-.2-1-2"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M299.5 249.2c1.8 3.4 4.5 8.7 6.5 11.7-3.4-.2-8.6 0-11.8 0 2.7-.5 6.4-1 8.7-2-.7-2.9-2.4-6.7-3.4-9.7"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m305 258.9-9.6-2.6 9 5 1.8-.5-1.3-2"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M300.4 250.7c1.9 3.3 4.6 8.6 6.7 11.6-3.4-.2-8.6 0-11.8.2 2.6-.7 6.4-1.2 8.6-2.2-.6-2.9-2.4-6.7-3.4-9.6"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m306.1 259.7-8.9-5.3 7.8 7.4h2l-.9-2.1"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M301.2 251.5c2.1 3.1 5.3 8 7.6 10.9a90 90 0 0 0-11.6 1.7c2.6-1 6.2-2 8.4-3.3-1-2.8-3.1-6.5-4.4-9.3"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m306.8 260.5-9.6-.3 9.5 2.9 1.7-1.1-1.6-1.5m5.6-46.6 6.9-1.1-6.9.1-1.2.6 1.2.4"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M316.2 215.4c-2-.6-5-1.6-7.1-2l7.4-3.5c-1.5 1-3.8 2.2-5 3.2 1.2.8 3.3 1.6 4.7 2.3"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m312 214.1 6.8-1.8-7 .9-1 .7 1.3.2"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M316.5 215.9c-2.4-.3-6-.7-8.3-.7 1.8-1.6 4.2-4.1 5.7-5.7-1 1.5-2.6 3.4-3.3 4.8 1.6.7 4.1 1.1 5.9 1.6"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m309.6 214.6 7-.8-6.8-.2-1.3.6 1 .4"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m314.7 216.1-7.5-1.3 6.9-3.8c-1.4 1-3.4 2.4-4.4 3.4 1.3.6 3.5 1.2 5 1.7"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m309 214.6 6.1-2.7-6.7 1.8-.8.8h1.4"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M314.5 216.9c-1.7-.7-4.5-2-6.2-2.5l4.4-4.8c-.8 1.3-2 3-2.6 4.4 1.2 1 3 2 4.4 2.9"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m309.3 215 4.8-2-5.2.6-.6 1 1 .4m-4 44.6h-9.8l10 2.5 1.6-1-1.8-1.5"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m307.1 260.2-10-2.3 9.6 4.7 2-.6-1.6-1.8"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m308.8 260.9-10-.5 10 3 1.7-1-1.7-1.5"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M302.5 253.9c2.5 2.8 6.4 7.4 9.1 9.9-3.3.5-8.3 1.8-11.4 2.7 2.4-1.2 6-2.6 8-4-1.4-2.6-4-6-5.7-8.6"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m310.1 261.4-10-3.3 9.4 5.6 2-.4-1.4-2"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M303.4 254.5c2.8 2.6 7 6.7 10 9-3.2.9-8 2.8-11 4 2.3-1.4 5.6-3.2 7.4-5-1.6-2.4-4.5-5.5-6.4-8"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m311 262-9.5 1.9 10 .6 1.4-1.3-2-1.2"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m309 261.4-9.8.8 10.1 1.7 1.6-1.2-2-1.3"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m310.8 262-10.2-1.7 10 4 1.8-.7z"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m312.5 262.5-10 .2 10.2 2.3 1.6-1.1z"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M305.7 256c2.8 2.6 7 6.8 9.9 9.2-3.3.7-8.3 2.4-11.3 3.4 2.4-1.3 5.8-2.9 7.7-4.5-1.6-2.5-4.4-5.7-6.3-8.2z"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m313.9 262.9-10.2-2.6 9.8 5 1.9-.6z"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "M306.6 256.5c3 2.4 7.6 6.2 10.7 8.2-3.2 1.1-7.8 3.5-10.6 4.9 2.2-1.7 5.3-3.7 7-5.5-1.8-2.4-5-5.3-7-7.6z"
        }),
        /* @__PURE__ */ jsx258("path", {
          d: "m314.8 263.4-9.3 2.6h10l1.3-1.5-2-1z"
        })
      ]
    }),
    /* @__PURE__ */ jsx258("path", {
      fill: "#fedf00",
      stroke: "#000",
      strokeWidth: 0.4,
      d: "m327.6 249.5-7.6-5.3-7.6 5.3 2.9-8.4-6.7-5.2h8.6l2.8-8.4 2.8 8.4h8.6l-6.7 5.2z"
    })
  ]
});
var Py_default = SvgPy;

// src/country-flag-icons/generated/Qa.tsx
init_esm_shims();
import { jsx as jsx259, jsxs as jsxs234 } from "react/jsx-runtime";
var SvgQa = (props) => /* @__PURE__ */ jsxs234("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx259("path", {
      fill: "#8d1b3d",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx259("path", {
      fill: "#fff",
      d: "M0 0v480h158.4l97.8-26.7-97.8-26.6 97.7-26.7-97.7-26.7 97.7-26.6-97.7-26.7 97.8-26.7-97.8-26.6 97.7-26.7-97.7-26.7 97.7-26.6-97.7-26.7 97.8-26.7-97.8-26.6L256.1 80l-97.7-26.7 97.8-26.6L158.3 0z"
    })
  ]
});
var Qa_default = SvgQa;

// src/country-flag-icons/generated/Re.tsx
init_esm_shims();
import { jsx as jsx260, jsxs as jsxs235 } from "react/jsx-runtime";
var SvgRe = (props) => /* @__PURE__ */ jsxs235("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx260("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx260("path", {
      fill: "#000091",
      d: "M0 0h213.3v480H0z"
    }),
    /* @__PURE__ */ jsx260("path", {
      fill: "#e1000f",
      d: "M426.7 0H640v480H426.7z"
    })
  ]
});
var Re_default = SvgRe;

// src/country-flag-icons/generated/Ro.tsx
init_esm_shims();
import { jsx as jsx261, jsxs as jsxs236 } from "react/jsx-runtime";
var SvgRo = (props) => /* @__PURE__ */ jsx261("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs236("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    children: [
      /* @__PURE__ */ jsx261("path", {
        fill: "#00319c",
        d: "M0 0h213.3v480H0z"
      }),
      /* @__PURE__ */ jsx261("path", {
        fill: "#ffde00",
        d: "M213.3 0h213.4v480H213.3z"
      }),
      /* @__PURE__ */ jsx261("path", {
        fill: "#de2110",
        d: "M426.7 0H640v480H426.7z"
      })
    ]
  })
});
var Ro_default = SvgRo;

// src/country-flag-icons/generated/Rs.tsx
init_esm_shims();
import { jsx as jsx262, jsxs as jsxs237 } from "react/jsx-runtime";
var SvgRs = (props) => /* @__PURE__ */ jsxs237("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx262("defs", {
      children: /* @__PURE__ */ jsx262("clipPath", {
        id: "rs_svg__a",
        children: /* @__PURE__ */ jsx262("path", {
          fillRule: "evenodd",
          d: "M60 0h1200v900H60z"
        })
      })
    }),
    /* @__PURE__ */ jsxs237("g", {
      clipPath: "url(#rs_svg__a)",
      transform: "translate(-32) scale(.53333)",
      children: [
        /* @__PURE__ */ jsx262("path", {
          fill: "#fff",
          d: "M0 0h1350v900H0z"
        }),
        /* @__PURE__ */ jsx262("path", {
          fill: "#0c4076",
          d: "M0 0h1350v600H0z"
        }),
        /* @__PURE__ */ jsx262("path", {
          fill: "#c6363c",
          d: "M0 0h1350v300H0z"
        }),
        /* @__PURE__ */ jsxs237("g", {
          transform: "matrix(1 0 0 1.00437 0 -.3)",
          children: [
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "M473.4 259.4v-.2h1v.2l-.5.5-.6-.6zm1 0v.5h-.5l.4-.6zm-93 5.2-1 .2.3-.6 4.2-.2 4-.3 4-.2 3.8-.3 4-.2 3.6-.3 3.7-.2 3.7-.2 3.5-.2h3.4l3.3-.3 3.2-.2 3.2-.2 3-.2h3l3-.2 3-.2 2.7-.2h2.8l2.7-.2 2.5-.2h2.5l2.4-.3h2.2l2.2-.2h2.2l2-.2h2l2-.2h5.3v1h-5.5l-1.8.2h-2l-2 .2h-2.2l-2.2.2-2.4.2h-2.4l-2.5.2-2.5.2H446l-2.8.3h-2.8l-3 .3-2.8.2h-3l-3 .3-3.3.2-3.3.2-3.3.2h-3.5l-3.5.3-3.6.2-3.5.3-3.8.2-3.8.2-4 .3-4 .2-4 .3-4.2.2.5-.6zm-1 .2-.3-.5h.7zm6.4 31-6.5-31 1-.2 6.5 31-.5.7zm.5.5h-.4l-.2-.4.5.3zm95-4-.2 1h.2-5.8l-3 .2h-3l-2.8.2h-3l-3 .2h-6l-3 .2h-3l-3 .2h-3l-3 .2h-3.2l-3 .2h-3l-3 .2h-3l-3 .2h-3l-3 .2h-3l-3 .2h-3l-3 .2h-3l-2.8.2h-5.8l-2.7.2h-2.7v-1h5.8l2.7-.2h5.8l3-.2h3l2.8-.2h3l3-.2h3l3-.2h3l3-.2h3l3-.2h3l3-.2h3.2l3-.2h3l3-.2h3l3-.2h3l3-.2h3l3-.2h3l2.8-.2h3l2.8-.2h.2zm-.2 0h.2zm94.5 3.4 1 .2-.5.3h-2.8l-2.8-.2h-8.8l-2.8-.2h-3l-3-.2H551l-3-.2h-3l-3-.2h-3l-3-.2h-3l-3-.2h-3l-3.2-.2h-3l-3-.2h-3l-3-.2h-3l-3-.2h-3l-3-.2h-3l-3-.2h-3l-3-.2H485l-3-.2.2-1h2.8l3 .2h3l2.8.2h3l3 .2h3l3 .2h3l3 .2h3l3 .2h3l3 .2h3l3 .2h3.2l3 .2h3l3 .2h3l3 .2h3l3 .2h3l3 .2h5.8l2.7.2h3l2.7.2h2.8l-.5.5zm1 .2v.3h-.5l.5-.4zm6.5-31.2-6.5 31h-1l6.5-31.2.6-.4zm-.4-.6h.5v.6zm-93.7-4.8h1l-.6-.5h5.4l2 .2h2l2 .2h2l2.4.2h2.4l2.4.3h5l2.6.3h2.7l3 .3 2.8.2h3l3 .3 3 .3 3.3.2 3.3.2 3.4.2h3.4l3.6.3 3.6.2 3.7.2 3.6.3 4 .2 3.8.3 4 .2 4 .3 4.2.2v1l-4.3-.2-4-.3-4-.2-4-.3-3.7-.2-3.8-.2-3.6-.3-3.6-.2-3.5-.2h-3.4l-3.3-.3-3.3-.2-3.2-.2-3-.2h-3l-3-.2-3-.2h-2.7l-2.6-.3h-2.6l-2.6-.3h-2.5l-2.4-.2-2.3-.2h-2.2l-2.2-.2h-2l-2-.2h-2l-1.8-.2h-3.3l-.5-.6zm.4.5h-.5v-.6l.4.5zm.5-.8v.2h-1v-.2l.3-.5.6.5zm-1 0v-.4h.3l-.4.4zm-8 .3.2-1h8.8l.3.2v.8h-.5v.2h-.3l-.2-1h.2v.7h.2-8.2zm-8.1.2v-1l-.2 1h-.4l-.2-.2-.3-.3v-.5l.2-.2h9.4v1h-8.8l.2-.2v-.8h-.2.4v1zm0-1v1l-.6-.5.5-.5zm-.6.5v-.5h.5l-.6.5z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#edb92e",
              d: "M583.5 264.2c3.2-6.6 6.7-13 11.2-18.7-11.7 8.8-18 7.5-18.7-4-.7-.2-1.7-.2-2.6-.2-9 14-17.7 12-26.2-5.8-11.5 18.4-21.4 18-29.2-1-13.3 16.6-24.5 16.7-33.6.2v-2c.5.2 0 .3-1 0l-.3-.3a69.3 69.3 0 0 1-1 .2c-.2 0-.5 0-.8-.2l-.2.4c-1.2.2-1.6 0-1 0v2c-9.2 16.4-20.4 16.3-33.7-.4-7.8 19-17.7 19.5-29.2 1-8.4 18-17 20-26 6-1 0-2 0-2.7.2-.8 11.4-7 12.7-18.8 4 4.6 5.5 8 12 11.3 18.6 34-1.4 67.6-3.2 101.3-5 34 1.8 67.6 3.6 101.5 5z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "m595 246-.6-1 .7 1-.3.4-.4.5-.4.4-.5.6-.4.5-.3.6-.4.6-.4.6-.5.5-.3.6-.4.6-.4.4-.3.6-.3.6-.3.6-.4.6-.3.5-.3.6-.4.5-.3.6-.3.7-.4.6-.3.6-.3.5-.3.6-.2.8-.3.6-.4.6-.2.6-.3.6-.3.6-.3.6-1-.4.3-.6.3-.7.3-.6.2-.5.4-.6.3-.7.2-.6.3-.6.3-.6.4-.6.3-.6.3-.6.3-.6.5-.6.3-.6.4-.6.3-.6.4-.5.2-.5.4-.6.4-.7.3-.6.4-.5.4-.6.5-.6.4-.5.3-.6.4-.6.4-.6.5-.5.4-.6.4-.5.7.7zm-19.2-4 .3-1 .5.5v1l.2 1v1l.3.7.2.8.3.7.3.7.2.6.4.5.3.5.4.4.5.3.4.3.4.3.5.2h.4l.5.2h1.9l.7-.2.7-.2.8-.3.8-.3.8-.3 1-.5.8-.6 1-.5 1-.7 1-.7 1-.7 1-1 .7 1-1 .7-1 .8-1 .7-1 .6-1 .5-1 .5-1 .5-.8.4-1 .3-.7.3-.8.2h-.8l-.8.2h-2l-.7-.3-.5-.2-.6-.3-.5-.5-.6-.4-.5-.4-.5-.5-.3-.5-.4-.7-.3-.7-.2-.7-.3-.8-.2-1v-.8l-.2-1v-1l.2.3zm.3-1 .4.2v.3zm-2.2.6-.8-.6.4-.2h2v.2h.4l-.2 1h-1.2v-.2h-1.2l.4-.2zm-.8-.6v-.2h.4zm-25.3-5.2-1-.6h1l.8 1.7.8 1.4.8 1.5.8 1.2.8 1.2.8 1.2.8 1 .8 1 .8.8.8.8.8.7.7.5 1 .4.7.3.8.3.7.3h2.3l.8-.2.8-.2.8-.3.8-.4.8-.6.8-.6.8-.7.8-.6 1-1 .7-1 .8-1 .8-1 1-1.4.8.6-.8 1.3-1 1-.7 1.2-1 1-.7 1-1 .7-.8.6-.8.6-1 .6-.7.4-1 .4-.8.2-1 .2h-3l-1-.4-.7-.3-1-.5-.7-.5-1-.6-.7-.7-1-.8-.8-1-.8-1-.8-1-.8-1.2-.8-1.3-.8-1.3-.8-1.5-.8-1.6-.8-1.7h1zm-1-.6.6-.7.4.8h-1zm-28.3-.5-.8-.6 1 .2.6 1.7.7 1.5.7 1.5.8 1.4.7 1.3.8 1.2.8 1 .8 1 .8.7.8.7.8.6 1 .5.7.4.8.2 1 .2h2.5l1-.3.8-.2 1-.4.8-.6 1-.7 1-.6 1-1 1-1 1-1 1-1.2 1-1.3 1-1.6 1-1.5 1.2-1.8 1 .6-1.2 1.7-1 1.5-1.2 1.5-1 1.3-1 1.3-1 1.2-1.2 1-1 1-1 .8-1 .7-1 .6-1 .4-1 .4-1 .4h-3l-1-.2-1-.3-.8-.6-1-.5-.8-.8-1-.8-.7-.8-1-1-.8-1-.8-1.3-.8-1.4-.8-1.5-.8-1.5-.7-1.7-.8-1.7h1zm-.8-.6.5-.6.5.8h-1zm-33.8.7h1v-.2l.8 1.5 1 1.4.8 1.2 1 1.2.8 1 1 1 .8 1 1 .8.8.7 1 .6 1 .4 1 .4.8.3 1 .3 1 .2h2l1-.2 1-.3 1-.3 1.2-.4 1-.6 1.2-.6 1-.6 1.3-.8 1-1 1.3-1 1.2-1 1-1.3 1.4-1.3 1.2-1.4 1.2-1.5.8.7-1.3 1.5-1 1.5-1.3 1.3-1.2 1.3-1.2 1-1.2 1-1 1-1.3 1-1.2.7-1 .6-1.3.6-1 .5-1.3.3-1.2.3h-1l-1.2.2h-1l-1.2-.2-1-.2-1-.3-1-.4-1-.5-1-.7-1-.6-1-1-1-.8-1-1-1-1.2-.8-1.2-1-1.3-.8-1.5-1-1.5v-.3zm0 .3v-.3zm1-2.3v2h-1v-2l.8-.5.3.5zm-1 0v-.8l.8.2-.8.5zm-1 .3 1-.4-.4-.3h1l-.2.2v.4l.4-1h.2v.2l.2.2v.6h-1.8l-.5-.3zm.5.3h-.3v-.3zm.3-1 .2.3-1 .4v-.4l.2-.7.6.2zm-.6-.4.4-.2.2.4zm-1 1 .2-1h.8l.2 1h-1zm-.4-.4-1-.4.7-.3h.8v1h-1zm-1-.4.3-.4h.3zm0 .4v-.4l1 .4-.2.4-.4.3zm.8.4v.3h-.4zm-1-.3h-1l.7.4v.2h.2v-.8h-.2.2l.2-.2h.4l.2 1h-1.9v-.2h-.2v-.5h.2v-.2h.2l.8.4zm-.7-.5.7-.3v.7zm-.3 2.5v-2h1v2.3zm1 0v.2zm-33.6 0-1-.5h1l1 1.4 1.3 1.4 1.3 1.3 1.2 1.2 1.2 1 1.2 1.2 1 1 1.2.7 1 .7 1.2.7 1 .6 1.2.4 1 .3 1 .3h1l1 .2h1l1-.2 1-.2 1-.2 1-.4 1-.5 1-.7.8-.7 1-.8.8-1 1-1 .8-1 1-1.2.8-1.2.8-1.4 1-1.5.8.5-1 1.5-.8 1.4-1 1.2-.8 1.2-1 1.2-1 1-.8 1-1 .8-1 .7-1 .8-1 .5-1 .4-1 .4-1 .3-1.2.2h-2.2l-1-.2-1.3-.3-1-.3-1.2-.5-1-.6-1.2-.6-1.2-.8-1.2-.8-1.2-1-1.2-1-1.2-1-1.2-1.4-1.2-1.3-1.3-1.5-1-1.5h.8zm-1-.5.3-.8.7.7zm-28.3 1.5-1-.4h1l1 1.6 1 1.4 1.2 1.5 1 1.2 1 1.2 1 1 1 1 1 1 1 .7 1 .8 1 .6.8.4 1 .3.8.4h2.8l.8-.2.8-.3.8-.5 1-.5.7-.6 1-.7.7-.8.8-1 .8-1 .8-1.3.8-1.3.8-1.4.8-1.5.7-1.6.8-1.8 1 .4-.8 1.7-.7 1.7-.8 1.5-.8 1.4-.8 1.3-1 1.2-.7 1-1 1-.7 1-1 .7-.8.7-1 .4-.8.5-1 .2-1 .2h-3l-1-.3-1-.3-1-.4-1-.6-1-.7-1-.8-1-1-1-1-1-1-1-1.4-1-1.3-1.2-1.5-1-1.5-1.2-1.7h1zm-1-.4.5-.8.5.7h-1zm-25.6 6.5v-1l.3.2 1 1.3.7 1.2.8 1 .8 1 .8.8 1 .8.7.8 1 .6.7.5.7.3.8.3.8.2.8.2h2.3l.8-.4.8-.3.8-.4.7-.5 1-.6.7-.8.8-.8.8-.8.8-1 1-1 .7-1.2.7-1.2.8-1.3.8-1.6.8-1.5.8-1.7 1 .4-1 1.7-.7 1.5-1 1.4-.7 1.3-.8 1.3-.8 1.2-.8 1-1 1-.8 1-.8.8-.8.7-1 .6-.7.5-1 .5-1 .3-.7.3h-2.6l-1-.2-.8-.2-1-.4-.8-.4-1-.6-.8-.6-.8-.7-1-1-.7-.8-1-1-.8-1-1-1.3-.7-1.4.4.2zm0-1h.2v.2l-.3-.2zm-2.2.8h-1l.4-.5h1.2v-.2h1.5v1H389v.2h-.4zm-1 0v-.4h.4zm-18 3.6-.6.7.6-1 1 1 1.2.6 1 .7 1 .6 1 .4.8.5 1 .4.7.3.8.3.8.3.8.2h.7l.7.2h1.7l.4-.2.5-.2.4-.3.4-.3.4-.3.4-.4.3-.5.2-.5.3-.6.3-.7.3-.7.3-.8v-.8l.3-1v-.8l.2-1h1v1l-.2 1-.2 1-.2 1-.2.7-.2.8-.3.8-.4.7-.2.6-.5.6-.4.5-.6.5-.5.4-.7.2-.6.2-.6.2h-3.3l-.8-.3-.8-.3-1-.3-.8-.4-1-.5-.8-.5-1-.5-1-.6-1-.7-1-.8-1.2-.8.7-.8zm11 18.5v1l-.4-.3-.3-.6-.2-.6-.3-.6-.3-.6-.4-.6-.3-.6-.3-.7-.3-.5-.4-.6-.4-.7-.3-.6-.4-.6-.3-.5-.4-.6-.4-.7-.4-.5-.3-.6-.4-.6-.4-.6-.4-.6-.3-.5-.4-.7-.3-.6-.3-.5-.4-.6-.4-.5-.4-.5-.4-.5-.4-.6-.4-.5-.4-.6-.4-.5.7-.8.4.5.4.6.4.5.4.6.4.5.4.5.4.5.4.6.4.6.4.5.3.6.4.6.4.5.4.6.4.6.3.6.5.6.3.6.3.6.5.6.3.6.3.6.5.6.3.7.3.7.4.6.3.6.4.5.4.6.3.7.3.7.3.6-.5-.3zm0 1h-.3v-.3zm101.4-6v1l-3.2.2h-3.2l-3 .3h-3.3l-3 .3-3.3.2H460l-3 .3-3.3.3h-3.2l-3 .3H444l-3 .3h-3.3l-3.3.2-3 .2h-3.3l-3.2.3h-3l-3.3.3-3.3.2h-3l-3.3.3h-3.2l-3 .2-3.3.2h-3.3l-3.2.2h-3l-3.3.3H384l-3 .2-.2-1h3.2l3.2-.3h3l3.3-.2 3.2-.2h3l3.3-.3h3.2l3-.3h3.3l3.2-.3h3l3.3-.2h3.2l3-.3h3.3l3.2-.3 3-.2h3.3l3.2-.3h3l3.3-.3 3.2-.2h3l3.3-.3 3-.3h3.3l3.2-.3 3-.2h3.3l3.2-.3 3-.3h.2zm101.2 5v1h-3l-3.3-.2-3-.2h-3.3l-3-.3h-3.3l-3.2-.3h-3l-3.3-.2-3.3-.2h-3l-3.3-.3-3.2-.2h-3l-3.3-.3h-3.3l-3-.3h-3.3l-3.2-.3-3-.3h-3.3l-3.3-.3h-3l-3.3-.3h-3l-3.3-.2-3-.2-3.2-.2h-3.2l-3.2-.3h-3l-3.3-.2.2-1h3l3.3.3 3.2.2 3 .2 3.3.2h3l3.3.3h3.2l3 .2 3.3.2 3.2.2h3l3.3.3h3l3.3.2 3.2.2h3l3.3.3h3.3l3 .3h3.3l3.2.3h3l3.3.3h3.3l3 .3h3.3l3.2.2h3.2l3 .2 3.3.2h3.2zm0 1v-1l.5.7zm.5-.3-.2.3h-.4z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#edb92e",
              d: "m459.4 276.2 22.7-11.5 23 11.5-23 11.4z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#edb92e",
              d: "M474 259.2v.2c-17.6.7-48.6 2.5-93.2 5.3l6.5 31c29.6-.8 64.3-2 94.8-3 30.7 1 65.3 2.2 95 3l6.5-31c-44.6-2.8-75.6-4.6-93-5.3v-.2c1.7-.4-1-.4-8.4-.2-7-.2-10-.2-8 .2z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#edb92e",
              d: "m597.3 236.7-3.7-.6c-7 17.5-13.4 18-14.6 1.4 1.6-.6 1-3.3 2.8-2.2 1 .5 2-1 1.3-2-2-1.5-3.6-1.3-5.4.4-.8-2.7-3-4-5.4-2.8-1 .5-.7 2.5.4 2.4 1.8-.2 1 1.6 1.6 3-12.5 16.4-19 14.4-17.4-7.3-3-.7-6.5-1.3-9.6-2.4-11.5 23.3-19.7 24.3-26.4 3.4 1.4-1 1-3.8 3-3 1.3.6 2.3-1.5 1.2-2.4-2.4-2-5-1.3-6.8 1.3-1.4-3-4-4-6.6-2.2-1.2.7-.5 3 .8 2.6 2.3-.7 1.3 2.4 3 3.5-5 19.6-30.8 21-26.6-8.2-2.4 0-4.5 0-6.6.2l-6.7-.2c4.2 29-21.5 27.8-26.6 8 1.6-1 .6-4 3-3.4 1.2.3 2-2 .7-2.7-2.6-1.7-5.2-.7-6.6 2.2-1.7-2.7-4.3-3.4-6.7-1.4-1 1 0 3 1 2.5 2.2-.8 1.8 2 3.2 3-6.7 21-15 20-26.4-3.4-3 1-6.5 1.7-9.5 2.3 1.6 21.6-5 23.6-17.4 7 .6-1.2 0-3 1.7-2.8 1 0 1.5-2 .4-2.4-2.4-1-4.5 0-5.3 2.8-1.7-1.7-3.5-2-5.5-.4-.8 1 .4 2.5 1.3 2 1.8-1 1.2 1.6 2.8 2.2-1.2 16.5-7.6 16-14.6-1.3l-3.7.7c0 4 1.3 8.5 3.8 11.7 10.6 13.5 18.5 10.4 18.8-4.7 14 16.4 24.4 14.3 26.2-3 11.7 21.8 30.5 11.4 31-2 5 19.4 33.5 19.2 35.4-3 1.8 22.2 30.3 22.4 35.4 3 .4 13.4 19.2 23.8 31 2 1.7 17.3 12.3 19.4 26 3 .4 15 8.3 18.2 19 4.7 2.4-3.2 3.8-7.6 3.7-11.7z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "m593.7 235.6 3.7.6-.2 1-3.6-.6-.4-.7zm-.5.3v-.4h.5zm-14.3 1 .2 1 .3-.6.2 1.4v1.4l.3 1.3.2 1.2.2 1 .3 1 .3 1 .3.7.3.7.3.6.3.5.3.5.4.2.3.2h1.3l.4-.3.4-.2.5-.4.4-.3.6-.6.5-.6.6-.7.7-1 .6-.8.7-1.2.6-1.2.6-1.3.7-1.3.5-1.5.7-1.6 1 .3-.8 1.6-.6 1.4-.7 1.4-.5 1.3-.7 1.3-.6 1-.6 1-.7 1-.7.8-.6.8-.6.6-.5.5-.6.3-.7.4-.5.2h-1.2l-.6-.2-.5-.2-.5-.4-.5-.4-.4-.6-.3-.6-.3-.8-.4-.8-.3-1-.2-1-.3-1-.2-1.3-.2-1.3-.2-1.5v-1.6l.3-.5zm-.5.4v-.4h.4zm3.5-2.7-.5 1v-.2h-.4v.2h-.2v.2l-.2.2v.3l-.2.3-.2.3v.2h-.2v.3h-.3v.2h-.3l-.2.2-.3-1v-.2h.2v-.2h.2v-.2l.2-.2v-.5h.2v-.4l.2-.2v-.3l.2-.2.2-.2h.2l.2-.2h1l.2.2zm.8-1 .6-1v.2h.2l.2.3v1.6h-.2v.2h-.2v.2h-.2v.2h-.2v.2h-.5v.2h-.8l-.3-.2.5-1v.2h.4v-.2h.2v-.2h.2v-.8zm.6-1v.2zm-6.3 1 1-.3-.8-.2h.2l.2-.3.2-.2.2-.2.3-.2h.2l.2-.2h.2v-.2h.4l.2-.2h2.3l.2.2h.2l.2.2h.2l.2.2h.2l.2.2.2.2-.6.8-.3-.2h-.2l-.2-.2-.2-.2h-.3l-.2-.2h-2.1v.2h-.3v.2h-.2l-.3.2v.2h-.3v.2l-.3.2zm1 .3-.7.5-.2-.8 1 .3zm-5.6-2.7-.4-1h.5l.3-.2h2.1l.4.2h.4l.2.3h.2v.2l.3.2h.2l.2.2v.2l.2.2v.2l.2.2.2.2v.2l.2.3v.2l.2.2v.2l-1 .3v-.5h-.2v-.3l-.2-.2v-.2h-.3v-.3h-.2v-.4h-.3v-.2h-.3v-.2h-.6v-.2h-2l-.2.2zm0 1.4.2 1h-.6v-.2h-.2l-.2-.2-.2-.2-.2-.2V231l.2-.2.2-.2.3-.2.4 1h-.2v1.2h.2zm2.2 3.7-.8-.6v.5-.2h-.2v-1h-.2v-1l-.2-.2h-.7v-1.2h.6l.3.2.2.2h.2v.2l.2.3v.4h.2v1.5h.2v.8zm0-.5h.2l-.2.4zm-18-6.6.3-1 .3.6v2l-.2 1.8v4.9l.3 1.4v1.3l.3 1 .2 1 .3 1 .4.8.3.8.4.5.5.5.4.3.4.3.5.2h1l.6-.2.7-.3.7-.4.8-.5 1-.4.7-.8 1-.8 1-1 1-1 1-1 1-1.4 1-1.4 1.3-1.4.8.6-1.2 1.5-1 1.3-1.2 1.3-1 1-1 1.2-1 1-1 .8-1 .8-.8.6-1 .5-.7.4-.8.3h-.8l-.8.2h-.7l-.7-.2-.6-.3-.6-.5-.5-.5-.4-.7-.5-.7-.4-1-.2-1-.2-1-.2-1.2-.2-1.3V229l.5.6zm.3-1h.3v.6zm-9.3-1.6-1-.4.7-.3.3.2h.3l.3.2h.3l.2.2h.3l.4.2h.6l.3.2h.3l.4.2h.6l.3.2h.5l.3.2h.7l.3.2h.6l.3.2h.5l.3.2h.8l.3.2h.3l-.3 1h-.8l-.2-.2h-.6l-.3-.2h-.8l-.3-.2h-.6l-.4-.2h-.7l-.4-.2h-.3l-.3-.2h-.6l-.3-.2h-.2l-.3-.2h-.6l-.4-.2h-.3l-.4-.2h-.4l-.3-.2h-.2l.7-.4zm-1-.4.3-.4h.4l-.6.4zm-26.2 3.2.6.8.3-.6.6 2 .5 1.7.7 1.6.6 1.6.7 1.4.7 1.2.6 1 .7 1 .7 1 .7.6.6.6.7.4.7.4.7.2h1.4l1-.2.6-.2.8-.4 1-.6.7-.6 1-.8 1-1 .8-1 1-1.2 1-1.3.8-1.4 1-1.6 1-1.7 1-1.8 1-2 1.2-2 1 .3-1.2 2.2-1 2-1 1.8-1 1.8-1 1.6-1 1.5-1 1.3-1 1.2-1 1-1 1-1 1-.8.7-1 .5-.8.4-1 .2-.8.2h-1.8l-.8-.3-.8-.3-.8-.5-.8-.6-.7-.8-.8-1-.7-1-.7-1-.7-1.4-.7-1.4-.7-1.5-.7-1.7-.6-1.7-.7-1.8.2-.6zm-.2.6v-.4l.2-.2zm3.8-3.6-.3 1h-.3l-.2-.2h-.2v.2h-.2v.2h-.2v.5h-.2v.4l-.2.3-.2.2v.2l-.2.3-.3.3-.2.3h-.2l-.5-.7.2-.2.2-.2v-.5h.2v-.4h.2v-.3l.2-.3v-.2l.2-.2.2-.3.2-.2h.2v-.2h.5v-.2h.7l.2.2zm.7-1.6.6-.8.2.2.2.2v.2l.2.3v1.3l-.2.3v.2l-.2.2h-.2v.2h-.2v.2h-.2l-.2.2h-1.1l.4-1h.7v-.2h.2v-.6h.2v-.7h-.2v-.2zm-7 1 1-.3h-1l.2-.3v-.3h.3l.2-.3.2-.3.2-.2.3-.3.3-.3h.2l.2-.3h.3l.2-.2h.5l.2-.2h2.2l.3.2h.2l.3.2h.3l.3.3h.2l.3.3.3.2-.6.8-.2-.2h-.2l-.2-.3-.4-.2h-.2l-.2-.2H521v.2h-.5l-.2.3h-.2v.2h-.2l-.2.3-.2.2-.3.3v.2l-.2.3-.2.2h-1zm1 .2-.6.7-.3-1 1 .2zm-7-2-.4-1h.3l.2-.2h.3l.4-.2h.2l.3-.2h.4l.3-.2h1.6l.2.2h.2l.3.2h.2l.2.3.3.2.2.2v.2l.3.2.2.2.2.2v.2l.3.2.2.3.3.4v.3l-.8.4-.2-.4-.2-.2v-.2l-.3-.2v-.2l-.3-.2-.3-.3h-.2v-.2h-.3l-.3-.2h-.2l-.3-.2h-.4l-.2-.2h-1.2l-.2.2h-.5l-.2.2h-.2l-.2.2-.2.2zm.5 1.7.3 1h-.5l-.2-.2h-.2l-.2-.2-.2-.2-.2-.2v-.2l-.2-.2V224l.2-.2.2-.3.3-.2.5 1h-.2v1.2h.2v.2h.4zm3.7 4-1-.2.2.5h-.2l-.2-.2h-.2v-.3h-.2l-.2-.3v-.4l-.2-.2v-.3l-.2-.2v-.4l-.2-.2v-.2l-.2-.2v-.2h-.2v-.2h-.6l-.4-1h1.1l.3.2h.2v.4h.2v.3l.2.2v.2h.2v.5l.2.3v.5h.2v.4h.2l.2.2.2.2.3.6zm-.3-.5.3.2v.3zm-27-7.2v-1l.6.5-.3 2.7-.2 2.4v2.2l.2 2 .3 2 .4 1.7.5 1.5.7 1.4.6 1 .8 1.2 1 1 1 .7 1 .6 1 .5 1 .4 1.3.3h2.4l1.3-.2 1.2-.3 1.2-.5 1.2-.5 1-.7 1.2-1 1-.8 1-1 1-1.3 1-1.3.8-1.3.8-1.5.6-1.7.5-1.7 1 .2-.6 2-.7 1.6-.8 1.6-1 1.5-1 1.4-1 1.3-1 1-1.2 1-1.2 1-1.2.8-1.3.7-1.2.5-1.3.3-1.4.2h-2.5l-1.2-.3-1.3-.4-1.2-.5-1-.7-1-1-1-1-1-1-.8-1.5-.7-1.5-.6-1.6-.4-1.8-.3-2-.2-2.2V227l.2-2.6.3-2.7.5.6zm0-1h.7v.5l-.6-.5zm-6.6 1.2.2-1h4l.2-.2h2.1v1h-4.1l-.2.2h-2zm-6-.8h-1l.5-.4h5.1l.2.2h1.2v1h-4l-.3-.2h-2l.5-.6zm-1 0v-.5h.5zm-26.4 7.8.5.8.3-.5.6 1.7.5 1.7.7 1.5 1 1.4.8 1.4 1 1.2 1 1 1 1 1.2 1 1.2.6 1.2.5 1.2.5 1.2.3 1.2.2h2.4l1.2-.3 1-.3 1.2-.4 1-.7 1-1 .8-.8 1-1 .6-1.3.6-1.5.6-1.6.4-1.8.3-2v-2l.2-2.3-.2-2.5-.3-2.7h1l.3 2.6.2 2.5v2.2l-.2 2.2-.3 2-.5 1.8-.5 1.6-.7 1.5-.8 1.4-1 1.2-1 1-1 .8-1 .7-1.2.5-1.3.4-1.3.3H463l-1.2-.2-1.3-.3-1.3-.5-1.3-.6-1.3-.7-1.2-1-1.2-1-1-1-1-1.2-1-1.3-1-1.5-.7-1.6-.7-1.7-.6-2 .2-.5zm-.2.5v-.3l.2-.2zm3.7-4-.2 1-.2-.2h-.7v.2l-.2.2v.4l-.2.2v.5l-.2.2v.2l-.2.3v.2l-.2.2v.2h-.2v.3h-.3l-.2.2h-.2l-.4-.7.2-.2.2-.2h.2v-.3l.2-.2v-.5l.2-.2v-.5l.2-.3v-.3l.2-.2.3-.3.2-.2h.2l.2-.2h1.1zm.4-1.8.6-1v.2h.3v.3h.2v.2l.2.2v1.5l-.2.2v.2l-.2.2-.3.2-.2.2h-.9l.3-1h.4v-.4l.2-.2v-.8h-.2v-.2h-.2zm-6.7 2 .8-.6h-.8v-.2l.2-.3.3-.4v-.2l.3-.2.2-.2.2-.2.2-.2.2-.2.2-.2h.2l.3-.3.3-.2h.2l.3-.2h.5l.2-.2h1.6l.4.2h.2l.3.2h.2l.3.2.2.2h.3l-.6 1-.2-.2h-.2l-.2-.2h-.3l-.2-.2h-.5l-.2-.2h-1.3l-.2.2h-.3v.2h-.3l-.2.3-.2.2-.3.3-.3.3-.2.2v.2l-.2.2-.2.2v.3h-.2zm1 0-.5.7-.5-.8h1zm-7-1.2-.8-.8.2-.2.2-.2h.3l.2-.3h.2l.2-.2h.3l.3-.2h2.5l.3.2h.2l.3.2.2.2h.2l.2.3h.2l.2.2.2.2.2.3.2.2h.2v.4l.3.2-.8.6-.2-.2v-.3l-.3-.2-.2-.2-.3-.3-.2-.2h-.2l-.2-.2v-.2h-.2l-.2-.2h-.4l-.2-.2H441l-.2.2h-.2l-.2.2h-.2l-.2.3h-.2l-.2.3zm.5 1.6.4 1h-1.3l-.2-.2-.3-.2h-.2v-.2l-.2-.3v-.2l-.2-.2v-1.6l.2-.2.2-.2v-.2l.8.8-.2.2v1l.2.2.2.2h.4zm3.8 3.6-1-.4.2.6h-.2v-.3h-.3v-.2h-.2v-.3h-.2v-.5h-.2v-.6h-.2v-.5l-.2-.2-.2-.2h-.2v-.2h-.5v.2l-.5-1h.4l.2-.2h.6l.2.2.3.2h.2v.2l.2.2.2.3v.2l.2.2v.2l.2.3v.2l.2.2.2.2.2.2.2.2.2.6zm-.2-.6.3.2v.4l-.2-.6zm-26.6-2.5-.3-1 .5.4 1 2 1 2 1.2 2 1 1.6 1 1.6 1 1.5 1 1.4.8 1.2 1 1 .8 1 1 .8.7.6 1 .6.6.4.8.2.8.2h1.3l.7-.2.7-.4.7-.4.7-.6.7-.7.8-.7.6-1 .7-1 .8-1.3.6-1.4.7-1.5.7-1.5.7-1.8.6-2 1 .5-.7 2-.6 1.6-.7 1.7-.6 1.5-.7 1.4-.7 1.3-.7 1.2-.7 1-.8.8-.7.8-.7.6-.8.5-1 .4-.7.4H432l-1-.2-.7-.3-1-.5-1-.6-.8-.8-1-1-.8-1-1-1-1-1.2-1-1.3-1-1.5-1-1.6-1-1.8-1-1.8-1-2-1-2.2.5.3zm-.3-1h.3l.2.4zm-9 3h-1l.4-.6h.7l.3-.2h.6l.4-.2h.9l.3-.2h.5l.3-.2h.6l.4-.2h.3l.3-.2h.6l.3-.2h.5l.3-.2h.3l.4-.2h.3l.3-.2h.3l.3-.2h.3l.2 1h-.7l-.3.2h-.3l-.3.2h-.3l-.3.2h-.5l-.3.2h-.3l-.4.2h-.6l-.4.2h-.6l-.3.2h-.6l-.2.2h-.6l-.3.2h-.7l-.3.2h-.8v.2h-.4zm-1 0v-.5h.4zm-17.4 7 1 .3v-.5l1 1.4 1 1.4 1.2 1.3 1 1 1 1 1 1 1 .8.8.8 1 .6.6.4.8.4.7.3h.6l.6.2h.4l.5-.2.3-.2.5-.2.4-.5.3-.5.4-.7.2-.7.3-1 .2-1 .2-1v-2.7l.2-1.5v-5l-.2-1.8h1v2l.2 1.8v4.9l-.2 1.4v1.4l-.3 1.2-.3 1-.3 1-.2 1-.4.7-.4.7-.6.5-.5.5-.7.3-.7.2H402l-.6-.2-.8-.4-1-.5-.7-.5-1-.6-1-.8-1-.8-1-1-1-1-1-1.2-1-1.3-1.2-1.4-1-1.6-.2-.5zm0 .4v-.3.4zm2-3.7v1h-.6v.8l-.2.3v1h-.2v.3l-1-.4v-.4l.2-.2v-.9h.2v-.5l.2-.2v-.2h.4v-.2h1zm.3-1.4.3-1 .2.2h.2v.2h.2v.7h.2v1.2l-.2.2v.3l-.2.2-.2.2h-.2l-.2.2h-.5v-1h.4v-.2h.2v-.8l-.2-.2zm-5.7 2.7.7-.8-.8.2v-.2l.2-.3v-.3l.2-.3v-.2l.2-.2.2-.2v-.2l.3-.2v-.2l.3-.2h.2v-.3h.3l.3-.2.2-.2h.4v-.2h2.5l.3.2h.2l.3.2-.4 1-.3-.2h-.5l-.2-.2h-1.3l-.3.2h-.2v.2h-.2l-.2.2v.2h-.2l-.2.2v.2h-.2v.3l-.2.2v.2h-.2v.5l-.2.2-1 .3zm1-.3-.4.8-.7-.5zm-5.8-.2-.7-.6v-.2l.3-.2h.3l.2-.2h.2l.2-.2.3-.2h.2l.2-.2h2.1l.2.2h.2l.2.2h.2l.2.2.3.2.2.2h.2l.2.3v.2l-.7.8v-.2h-.3v-.2l-.3-.2-.3-.2h-.3v-.2h-.2l-.2-.2h-2v.2h-.3l-.2.2-.2.2zl-.2.2zm-.7-.6v-.2zm1.4 1.7.6 1h-1.3l-.3-.2-.2-.2v-.2h-.2l-.2-.2v-.3l-.2-.2v-.8l.2-.3h.2l.7.5v.8h.2v.2h.2v.2h.2zm3.6 2.7h-1l.3.5v-.2h-.3v-.2h-.3v-.3h-.2v-.2h-.2v-.2l-.2-.2v-.3h-.2v-.2l-.2-.3v-.2h-.7l-.6-.8h.2l.2-.2h1.1l.3.2.2.2v.2h.2v.4l.2.2v.5h.2v.2l.2.2.2.2h.2zm-.4-.5h.4v.4zm-14.7-.4v-1l.4.3.8 1.5.6 1.5.7 1.3.7 1.3.6 1.2.6 1 .6 1 .6 1 .5.6.6.7.5.7.6.4.5.5.3.2.5.2h1.1l.3-.3.3-.2.4-.4.3-.4.4-.5.3-.6.3-.8.3-.8.2-1 .3-1 .3-1.3.2-1.3v-1.4l.2-1.4h1v1.5l-.2 1.4-.2 1.3-.2 1.2-.2 1-.2 1-.3 1-.4.8-.4.8-.4.6-.4.6-.5.4-.5.4-.5.2-.6.2h-1.1l-.6-.3-.7-.4-.6-.4-.5-.6-.6-.6-.7-.7-.7-.7-.6-1-.6-1-.6-1-.6-1.2-.6-1.2-.7-1.4-.7-1.5-.6-1.7zm0-1h.3v.3zm-3.8.6 3.6-.6v1l-3.6.6-.5-.5zm-.5.5v-.4h.4zm4.7 11.4-.8.7-.3-.3v-.3l-.3-.3-.2-.3-.3-.3-.2-.3-.2-.3v-.4l-.3-.3-.2-.4-.2-.4v-.4l-.2-.4v-.4l-.3-.4v-.4l-.2-.3v-.4l-.2-.4v-.9l-.2-.3v-.8l-.2-.5V238l-.2-.5v-.7h1v1.9l.2.4v1.1l.2.5v.7l.2.3v.4l.2.4.2.3v.4l.2.5.2.3v.4l.2.3.2.4.2.2v.3l.3.4.2.2v.3l.3.3.2.4.2.3.2.3.2.3zm18.7-4.7-.8.7 1-.3-.2 1.4v1.4l-.2 1.3-.2 1.2-.2 1-.3 1-.2 1-.3 1-.4.7-.4.8-.4.7-.6.6-.5.5-.5.4-.7.3-.6.3h-.7l-.8.2h-.7l-.8-.2-.8-.2-.8-.2-1-.4-.7-.5-1-.7-1-.6-.8-.8-1-1-1-1-1-1-.8-1-1-1.3.8-.6 1 1.3 1 1 .8 1 1 1 1 .8.7 1 1 .5.7.6.8.5.8.4.7.2h.7l.7.3h1.4l.6-.2.4-.2.6-.2.4-.3.5-.5.4-.5.4-.6.4-.7.3-.8.3-.8.3-1 .4-1 .2-1 .2-1.2v-1.2l.2-1.3v-1.3l1-.4zm-1 .4V242l1 1zm27.3-3.2-1 .4 1-.2-.2 1.6v1.5l-.4 1.3-.4 1.3-.4 1.2-.4 1.2-.5 1-.7 1-.6 1-.6.7-.6.7-.8.6-.7.5-1 .4h-.8l-1 .3h-2.8l-1-.3-1-.4-1.2-.4-1-.6-1.2-.6-1.2-.8-1-.8-1.3-1-1.2-1-1.3-1.2-1.2-1.3-1.3-1.5-1.3-1.5.7-.7 1.2 1.5 1.3 1.4 1.2 1.2 1.2 1.2 1 1 1.3 1 1 .8 1.2.7 1 .7 1 .6 1 .4 1 .3 1 .2h1l.8.2h.8l1-.2.7-.3.7-.4.7-.5.7-.4.6-.6.6-.7.5-.8.5-1 .4-1 .5-1 .2-1.2.4-1.3.3-1.3v-1.5l.3-1.6h1zm-1 0 .2-1.5.8 1.5zm31.8-1.8-.8.3h1v1l-.3 1.4-.4 1.2-.4 1.2-.5 1-.6 1.3-.6 1-.7 1-.8 1-1 1-1 .7-1 .7-1 .7-1 .6-1.2.5-1.2.4-1.2.3h-3.8l-1.3-.2-1.3-.4-1.4-.4-1.3-.7-1.3-1-1.3-.8-1.3-1.2-1.3-1.2-1-1.5-1.3-1.6-1.2-1.8-1-2 .8-.5 1 2 1.2 1.6 1.2 1.7 1.2 1.4 1 1.3 1.3 1 1.2 1 1.3.7 1.2.6 1.2.5 1.3.5 1.2.2h3.6l1.2-.3 1-.3 1-.3 1.2-.5 1-.6 1-.7.7-.8 1-1 .6-.7.6-1 .6-1 .6-1 .4-1 .4-1.2.3-1V239h1zm35.6-3-1 .2h1l-.2 2-.4 2-.6 1.6-.6 1.7-.8 1.6-1 1.3-1 1.3-1 1-1.3 1-1.3 1-1.3.8-1.3.6-1.5.6-1.5.3-1.5.2h-1.5l-1.6.2-1.4-.2-1.6-.2-1.5-.3-1.5-.5-1.4-.6-1.4-.7-1.4-1-1.3-1-1.2-1-1-1.2-1-1.4-1-1.4-1-1.6-.6-1.6-.5-1.8 1-.3.5 1.7.6 1.6.8 1.5 1 1.3 1 1.3 1 1.2 1.2 1 1.2 1 1.3.8 1.3.7 1.4.5 1.4.5 1.4.3 1.5.2h4.4l1.5-.3 1.4-.4 1.3-.5 1.3-.5 1.3-.7 1-1 1.2-.8 1-1 1-1.3 1-1.4.6-1.4.7-1.7.5-1.7.4-1.8.2-2h1zm35.5 3-1 .2h1l-.4 1.8-.7 1.6-1 1.6-1 1.4-1 1.4-1 1.2-1.3 1-1.2 1-1.4 1-1.3.6-1.5.6-1.4.5-1.6.3-1.5.2-1.5.2h-1.6l-1.5-.2-1.4-.3-1.5-.4-1.4-.6-1.4-.6-1.3-.8-1.4-1-1.2-1-1-1-1.2-1.3-1-1.4-.7-1.7-.7-1.7-.5-1.7-.4-2-.4-2 1-.2.3 2 .3 1.8.5 1.7.6 1.6.8 1.3 1 1.4.8 1.2 1 1 1.2 1 1.2.8 1.3.7 1.3.6 1.4.6 1.4.3 1.4.2h4.5l1.4-.2 1.5-.3 1.4-.5 1.3-.5 1.3-.7 1.3-.8 1-1 1.2-1 1-1 1-1.4 1-1.3.7-1.5.6-1.6.5-1.7h1zm31 2h-1l1 .2-1.2 2-1.2 1.7-1.2 1.6-1.2 1.5-1.3 1.2-1.4 1.2-1.3 1-1.3.7-1.3.6-1.3.5-1.4.5-1.3.2H530l-1.3-.3-1.2-.3-1.2-.4-1-.5-1-.6-1-.7-1-.8-1-1-.7-1-.8-1-.6-1-.6-1-.5-1.2-.3-1.2-.3-1.2-.2-1.3v-1l1-.2v1.2l.2 1.2.3 1 .4 1.2.5 1 .6 1 .7 1 .7 1 .7 1 1 .8.8.7 1 .6 1 .6 1 .5 1 .4 1 .4 1.3.2 1.2.2h2.4l1.2-.3 1.2-.4 1.3-.4 1.2-.6 1.3-.7 1.2-1 1.2-1 1.2-1.2 1.2-1.3 1.2-1.6 1-1.6 1.2-2 1 .2zm-1-.2.8-1.5.2 1.6h-1zm27.2 3.2h-1l1 .3-1.4 1.5-1.3 1.4-1.2 1.2-1.3 1-1.2 1.2-1.2 1-1.2.8-1 .8-1.2.6-1 .6-1.2.4-1 .4-1 .2-1 .2h-2l-1-.3h-.8l-.8-.5-.8-.5-.7-.6-.8-.7-.6-.8-.6-1-.6-1-.5-1-.5-1-.4-1.4-.3-1.3-.3-1.4-.2-1.6-.3-1.6 1-.2.2 1.6.2 1.5.3 1.3.3 1.3.4 1.2.4 1 .5 1 .5 1 .6.8.6.7.6.6.6.5.7.6.6.3.8.2h.8l.8.2h.8l1-.2 1-.2.8-.3 1-.4 1-.6 1.2-.6 1-.6 1.2-.8 1.2-1 1-1 1.4-1.2 1.2-1.2 1.3-1.4 1.3-1.5zm-1-.4 1-1v1.4zm19 4.8.7.7-1 1.2-1 1-1 1-1 1-1 1-.8.7-1 .6-.8.6-.8.4-1 .4-.7.3-1 .3-.7.2h-1.5l-.7-.2-.6-.3-.6-.3-.6-.4-.6-.5-.5-.6-.4-.7-.4-.8-.4-.8-.3-1-.3-1-.3-1-.3-1-.2-1.3V246l-.2-1.3v-1.3h1v2.6l.2 1.3.2 1 .2 1.2v1l.4 1 .4.7.3.8.5.6.4.5.4.5.4.5.5.3.5.3.6.3h.6l.6.2h.6l.7-.2h.6l.7-.4.8-.5 1-.4.7-.5 1-.6.7-1 1-.7.8-1 1-1 1-1 1-1.2zm4-10.7v-1l.6.4v2.9l-.2.4v.7l-.2.4v.5l-.2.4v.3l-.2.4v.3l-.3.4v.4l-.2.4-.2.4v.3l-.3.3-.2.4-.2.3-.2.4-.2.3-.2.4-.2.4-.2.3-.2.4-.2.4-.3.3-1-.6.3-.2.3-.3.2-.3.2-.4.2-.3.2-.3.2-.3v-.5l.3-.3v-.3l.2-.5.2-.3v-.4l.3-.3v-.4l.2-.3v-.7l.2-.4v-.3l.2-.4v-.5l.2-.4v-1l.2-.4v-1.8l.5.5zm0-1h.6v.4l-.5-.5zm0 0v1zm0 1"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#edb92e",
              d: "M482 263h-22.5l-1.3.2H451l-1.3.2h-4.4l-1.2.2h-2.3l-6.3.4h-.3c-3 0-6 .3-9 .4h-.8l-18.2 1.3h-.2a965 965 0 0 0-26.4 2.4c-5 .6-6-5.3 0-6a960.5 960.5 0 0 1 26.3-2.2 983.7 983.7 0 0 1 37-2.2h2.4l15.4-.5h16.8a1082.3 1082.3 0 0 1 7.2 0h16.6l15.2.5h3.3a984 984 0 0 1 37 2.3 960.5 960.5 0 0 1 26.2 2c5.8.7 5 6.6 0 6a965.6 965.6 0 0 0-26.4-2.3h-.3a978.4 978.4 0 0 0-18.3-1.2h-.6l-9.2-.5h-.3c-2.2 0-4.3-.2-6.4-.3h-2.3l-1.2-.2h-4.5l-1.3-.2H506l-1-.2z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#0c4076",
              d: "M482 105a17.3 17.3 0 0 1 .1 34.7c-9.3 0-17-7.8-17-17.3 0-9.6 7.7-17.3 17-17.3z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#edb92e",
              d: "M485.3 85c1.6-.2 3-1.5 3-3.2 0-1.7-1.4-3-3-3.2 0-1.7-1.4-3-3.2-3a3 3 0 0 0-3 3c-1.6 0-3 1.5-3 3.2a3 3 0 0 0 3 3v6.5h-5.5a3 3 0 0 0-3-3c-1.8 0-3 1.3-3.2 3a3 3 0 0 0-3 3c0 1.8 1.3 3.2 3 3.2a3 3 0 0 0 3 3c1.8 0 3.2-1.2 3.2-3h5.5V119h6.3V97.6h5.5a3 3 0 0 0 3 3c1.8 0 3-1.4 3.2-3 1.7 0 3-1.5 3-3.2a3 3 0 0 0-3-3c0-1.8-1.4-3.2-3-3.2-2 0-3.2 1.4-3.2 3h-5.5V85z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "M487.8 81.8h1v1h-.2v.5h-.2v.3l-.2.3-.2.2v.2h-.2l-.2.2-.2.2h-.2v.2h-.2l-.2.2h-.2v.2h-.8l-.2.2h-.3v-1h.7V84h.2l.3-.2h.2v-.2h.2v-.2l.2-.2V83h.2l.2-.2v-.4l.2-.2zm-3-3.2h1l-.5-.5h.2l.3.2h.4l.3.2h.3l.2.2.2.2h.2v.2h.2l.2.2.2.3.2.2v.2h.2v.4h.2v.5l.2.2v.7h-1V81h-.2v-.4l-.2-.2V80h-.4v-.2h-.2v-.2h-.2l-.3-.2h-.2V79h-.8l-.4-.6zm.4.5h-.4v-.4zm-3-3v-1h.7l.2.2h.2l.3.2h.2l.2.2.2.2h.2v.3l.2.2.2.3.2.2v.2h.2v.4h.2v.8h.2v.3h-1V78h-.2v-.5h-.2v-.2l-.2-.2-.2-.2-.2-.2h-.2v-.2h-.2l-.2-.2h-.4zh-.4zm-3.2 3v-1l-.5.6v-.8l.2-.2V77h.2v-.6h.2v-.2l.2-.2.2-.2.2-.2h.2v-.2h.3v-.2h.3l.3-.2h.4l.2-.2h.4v1h-.5v.2h-.3l-.2.2h-.2v.2h-.2v.2h-.2v.2l-.2.2v.2h-.2v.5h-.2v1l-.6.5zm.5-.4v.5h-.5zm-3 3.2h-1V81l.2-.3v-.5l.2-.2v-.2l.2-.2.2-.3.2-.2h.2l.2-.2h.2v-.2h.3v-.2h.5l.3-.2h.7v1h-.7l-.2.2h-.2l-.2.2-.2.2-.2.2-.2.2v.2h-.2v.4l-.2.2v.8zm3 3h-1l.5.6h-1V85h-.7v-.2h-.3v-.2h-.2l-.2-.2-.2-.2V84h-.2v-.2l-.2-.2-.2-.3v-.5h-.2v-1h1v1h.2v.4h.2v.2h.2v.2l.2.2h.2v.2h.2l.3.2h.7v.2h.2zm-.5-.4h.5v.5l-.5-.6zm-.5 7V85h1v6.3l-.5.5-.5-.5zm1 0v.4h-.5l.5-.5zm-6-.6h5.5v1h-5.5l-.5-.5zm0 1h-.5v-.5zm-3-3v-1h1.2v.2h.3l.3.2.3.2.3.2v.2l.2.2.2.3.2.3.2.3v.4l.2.2v.8h-1v-.7l-.2-.2V90h-.2v-.2h-.2v-.2l-.2-.2-.2-.2h-.2V89h-.4l-.2-.2h-.8zm-3.2 3v-1l-.5.4v-.8l.2-.3V90l.2-.3v-.2h.2v-.2l.2-.2h.2v-.3h.2l.2-.2.2-.2h.2V88h.7v-.2h1.1v1h-1l-.2.2h-.2v.2h-.2v.2h-.2l-.2.2v.2h-.2v.4h-.2v.8l-.2.2v.3l-.5.5zm.5-.5v.5h-.5zm-3 3h-1V93h.2v-.2h.2v-.3l.2-.3.3-.3v-.2h.2v-.2h.2v-.2h.2l.2-.2h.2V91h.7l.2-.2h.8v1h-.7l-.2.2h-.2v.2h-.2v.2h-.2l-.2.2-.2.2v.2h-.2v.5h-.2v.7zm3 3.2h-1l.5.5h-1v-.2h-.5l-.2-.2h-.2v-.2h-.2l-.2-.2-.2-.2v-.2h-.3v-.2l-.2-.2V96h-.2v-.4l-.2-.3v-.8h1v.9h.2v.2l.2.3h.2v.2h.2v.2h.2v.2h.2l.2.2h.5v.2h.4l.6.5zm-.5-.5h.5v.5zm3 3v1h-1l-.2-.2h-.3v-.2h-.3v-.2h-.2l-.2-.2-.2-.3v-.2h-.2v-.3h-.2V99h-.2v-.5l-.2-.2V98h-.2v-.5h1v.7h.2v.4h.2v.2l.2.2v.2h.2v.2h.2v.2h.2l.2.2h.2l.3.2h.6zm3.2-3v1l.5-.4v.8l-.2.2v.3h-.2v.3l-.2.3-.2.2-.2.2-.2.2-.3.2-.2.2h-.2l-.2.2h-.2l-.3.2h-.8v-1h.9v-.2h.2l.2-.2h.2v-.2h.2l.2-.2V99h.2v-.2l.2-.3v-.2l.2-.2v-.4zm-.5.6V97h.5l-.5.6zm6 .5h-5.5v-1h5.5l.5.6zm0-1h.5v.6zm-.5 22V97.6h1V119l-.5.5-.5-.5zm.5.5h-.5v-.5zm6.3 0H479v-1h6.3l.5.5zm.5-.5v.5h-.5zm0-21.4V119h-1V97.6l.5-.5.5.6zm-1 0V97h.5l-.5.6zm6 .5h-5.5v-1h5.5l.5.6zm0-1h.4v.6zm3 3v1h-1l-.3-.2h-.2l-.3-.2-.2-.2h-.2v-.2h-.2l-.2-.2v-.2h-.2v-.2l-.2-.2V99h-.2v-.2h-.2v-1l-.2-.2h1v.4l.2.2v.2l.2.3v.2h.2v.2h.2l.2.2v.2h.2l.3.2h.2v.2h1.1zm3.2-3v1l.5-.5v.7h-.2v.5l-.2.3v.4h-.2v.3h-.2v.2h-.2v.2h-.3v.2l-.3.2h-.3l-.2.2h-.3l-.2.2h-.8v-1h.9v-.2h.2v-.2h.2l.2-.2.2-.2V99h.2v-.2l.2-.2v-.2l.2-.2v-.6l.6-.6zm-.5.5V97h.5l-.5.5zm3-3h1v.9l-.2.3v.2h-.2v.6h-.2l-.2.2v.2h-.2v.2h-.3v.2h-.2v.2h-.3l-.3.2h-.2l-.3.2h-.7v-1h.8V97h.2v-.2h.2l.2-.2.2-.2h.2V96l.2-.3v-.2h.2v-.7l.2-.3zm-3-3.2h1l-.5-.6h.7l.2.2h.4l.3.2.3.2.3.2.2.2.2.3.2.2v.5h.2v.3h.2v.7l.2.3v.4h-1v-.6h-.2v-.4l-.2-.2-.2-.2v-.2h-.2l-.2-.2-.2-.2h-.2V92h-.5l-.2-.2h-.5l-.5-.5zm.5.5h-.5v-.5zm-3-3v-1h1.1l.2.2h.4v.2h.3v.2l.3.2.2.3h.2v.3h.2v.4l.2.2v.4h.2v.7h-1v-.8h-.2V90l-.2-.2-.2-.2-.2-.2-.2-.2h-.2V89h-.5v-.2h-.6zm-3.2 3v-1l-.6.5v-.9l.2-.2V90l.2-.3.2-.3.2-.3h.2v-.2l.2-.2h.2v-.2h.2l.2-.2h.3l.2-.2h.3l.2-.2h1v1h-1l-.3.2h-.2v.2h-.2l-.2.2v.2l-.2.2-.2.2v.2l-.2.2v.7l-.7.6zm.5-.5v.5h-.6zm-6-.5h5.5v1h-5.5l-.5-.5zm0 1h-.5v-.5zm.5-7v6.5h-1V85l.4-.6.6.5zm-1 0v-.4h.4zm.5 0v-.4zm-.5 0v-.4h.4z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "M499.8 122.4h-1v-1.7l-.2-1v-.7l-.3-.8-.2-.8-.2-.8-.3-.8-.3-.7-.4-.6-.4-.7-.4-.7-.5-.7-.5-.6-.5-.6-.6-.5-.7-.6-.6-.6-.6-.5-.5-.6-.7-.4-.7-.4-.6-.4-.8-.3-.7-.4-1-.3-.7-.2h-.8l-.8-.2h-.8l-1-.2h-1v-1h2l.8.2h1l.8.3.8.4.8.2.8.4.8.3.8.4.7.4.7.6.7.5.7.6.6.6.6.6.6.6.6.6.5.7.5.7.5.7.4 1 .4.6.4.8.3.8.3 1 .3.7.2.8v1l.2.7v2zM482 140.2v-1h1.8l1-.2.7-.2.8-.2.8-.2 1-.3.6-.2.8-.3.7-.4.8-.3.7-.4.6-.5.7-.5.6-.5.6-.6.5-.5.5-.6.5-.6.5-.6.4-.7.4-.6.4-.8.3-.7.3-1 .3-.6.3-.8.2-.8v-1l.2-.7v-1.6h1v2.8l-.2.8-.2.8-.3 1-.3.7-.3.8-.3.8-.3 1-.4.6-.5.7-.5.7-.5.7-.6.6-.6.7-.6.6-.6.5-.7.6-.7.5-.7.6-.7.4-.8.4-.8.4-.8.3-.8.4-.8.2-1 .2-.8.2h-.8l-1 .2h-1zm-17.5-17.8h1v1.8l.2.7v.8l.3.8.2.8.3.7.3 1 .3.6.5.8.4.7.3.8.5.6.5.6.5.7.6.5.5.6.5.5.7.5.6.5.7.4.7.4.7.5.7.3.7.3.8.4.8.2.8.2.8.2h1.8l.7.2v1h-1.8l-.7-.2-1-.2-.8-.2-.8-.2-1-.3-.7-.2-.8-.4-.8-.4-.7-.4-.7-.5-.7-.4-.7-.5-.7-.4-.7-.6-.5-.7-.5-.6-.5-.7-.5-.7-.5-.7-.4-.7-.4-1-.3-.7-.5-.8-.2-.8-.3-1-.2-.7v-1l-.2-.8v-1.8zm17.6-17.8v1h-1.7l-.7.2h-.8l-.8.3-.8.3-.8.3-.7.3-.8.2-.8.4-.7.4-.7.4-.6.5-.7.4-.6.5-.6.5-.6.6-.5.7-.5.6-.5.7-.4.7-.5.7-.4.7-.2.8-.3.8-.3.8-.2.8-.2.8v.8l-.2 1v1.7h-1v-2.8l.2-1 .2-.8.3-1 .2-.8.4-.8.2-.8.4-.7.4-1 .5-.6.5-.7.5-.7.6-.6.6-.6.7-.6.6-.6.6-.5.7-.4.7-.5.7-.3.8-.4.8-.3.8-.4 1-.2.7-.3h1l.8-.2h.8l1-.2h.8z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#edb92e",
              d: "M499 118.8a17.6 17.6 0 0 1 0 6c-5.5-.2-11.2-.3-17-.3-5.5 0-11.2 0-17 .3a17.5 17.5 0 0 1 .3-6l16.8-.3c5.8 0 11.4.2 17 .3z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "M499.8 122.4h-1V120h-.2v-1l1-.2v1.7l.2.2v1.6zm-.7 3 .2-1-.6.3v-.8l.2-.2v-1.1h1v2.2h-.2zm.6-.5v.3h-.5l.6-.4zm-17.5 0v-1H494l.4.2h4.8v1h-10.6l-.5-.2h-6zm-17.4 0 1-.3-.5-.4h4.7l.4-.2H482v1h-11l-.5.2H465l-.5-.3zm.6.3h-.5v-.4l.5.3zm-.7-3h1v2.4l-1 .3v-2.6zm.8-4v1l.5-.3v.8l-.2.2v2.5h-1v-3h.2v-.4l.5-.5zm-.5.5v-.4h.5zm17.3-.8v1h-9.1l-.5.2H466l-.7.2v-1h2.5l.5-.2h9l.5-.2h4.2zm17.5.8-1 .2.4.4h-3.6l-.5-.2h-10.3l-.5-.2h-2.1v-1h10l.5.2h6.1l.5.6zm-.5-.5h.4v.5z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#edb92e",
              d: "M468.8 133.2c-3.6-2.3-4.3 1.2-4.2 4.7.4 13.2 3 25.8-.6 42-1.4 6.4-3.7 10-1.5 11.3 5.7 3.2 8.3 6 7.4 7.7 1.5 3.2 5.7 2.6 12 1.6 6.6 1 10.7 1.6 12.4-1.6-1-1.6 1.7-4.5 7.4-7.7 2.2-1.2 0-5-1.5-11.3-3.5-16.2-1-28.8-.7-42 0-3.6-.5-7-4-4.8a28.6 28.6 0 0 1-26.8 0z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "M465 138h-1v-1.5l.2-.3v-1.6l.2-.3v-.3h.2v-.4l.2-.2v-.3h.2l.2-.3.2-.2.2-.2h.2l.2-.2h1.8l.4.2.4.2h.3l.4.3-.4 1-.4-.3h-.2l-.3-.2h-.3l-.2-.2h-1.2v.2h-.2v.2l-.2.2v.2l-.2.2v.4l-.2.3v.4l-.2.2v2.5zm-.5 42-1-.2.3-1.5.3-1.4.3-1.6.2-1.4.2-1.5.2-1.4v-2.5l.2-1.4V154l-.2-1.2v-2.5l-.2-1.2V148l-.2-1.2v-1.2l-.2-1.3V142l-.2-1.3V138h1v3.5l.2 1.2v2.6l.2 1.2v1.3l.2 1.2v2.5l.2 1.2v1.3l.2 1.3v13.3l-.2 1.4v1.4l-.3 1.5-.2 1.4-.2 1.6-.2 1.4-.2 1.5-.3 1.6zm-1.8 11-.4.8-.3-.2-.2-.2-.2-.2-.2-.2v-.2l-.2-.3V188l.2-.3v-.4l.2-.3v-.4l.2-.4v-.5l.3-.4.2-.4v-.5l.3-.3v-.5l.3-.5v-.6l.3-.4.2-.6v-.6l.3-.6 1 .3-.2.7v.6l-.3.5v.6l-.2.5-.2.4v.6l-.3.4v.5l-.3.4v.4l-.2.4v.4l-.2.4v.4l-.2.3v.4l-.2.4v1.9zl.2.2zm7.6 7.8-1 .4v-.4h.2v-1l-.2-.2v-.2l-.2-.2v-.4l-.3-.2-.2-.2-.2-.3h-.3l-.2-.4-.3-.2-.3-.3h-.3l-.4-.4-.4-.3-.3-.2-.5-.2-.4-.3-.3-.3-.5-.3-.5-.3-.4-.3-.5-.3-.6-.2.5-1 .6.4.5.3.5.3.4.3.5.4.4.3.5.3.5.2.3.3.4.3.4.3.3.4.2.2.3.3.3.2.2.2.2.3.3.2.2.2v.2l.3.3v.2l.3.2v.5l.2.2v1.1l-.2.3v-.5zm-1 .4v-.4zm13 1-.2 1h.2-1.2l-.5.2h-1.2l-.6.2h-1l-.5.2h-4.7l-.4-.2h-.3l-.3-.2-.3-.2-.3-.2-.2-.2-.3-.2-.2-.2-.3-.3h-.2l-.2-.4-.2-.4 1-.4v.2l.2.3.2.2.2.2.2.2h.2l.2.2h.2l.3.2h.3l.3.2h.3l.2.2h4.3l.5-.2h1l.6-.2h1.1l.5-.2h.8zm-.2 0h.2zm12-1 1-.4v.4l-.3.4-.2.3h-.2l-.3.4-.2.2-.3.2-.3.2-.3.2-.4.2h-.3l-.3.2h-.4l-.4.2H486l-.6-.2h-.5l-.6-.2h-1.2l-.5-.2h-.6l.2-1h1.8l.5.2h.6l.6.2h1.1l.5.2h4.2l.3-.2h.3l.2-.2h.3l.2-.2.2-.2.3-.3.2-.2.2-.2v-.3l.3-.2v.5zm1-.4v.4zm6.5-8 .5 1-.5.3-.5.4-.5.3-.4.2-.4.2-.4.3-.4.3-.4.3-.4.3-.3.3-.3.3h-.3l-.2.4-.3.2-.3.3h-.2l-.2.4-.2.2-.2.2v.2l-.3.2v.7h-.2v1.2l-.8.5v-.2l-.2-.2v-1.3l.2-.2v-.3l.3-.3v-.3l.3-.2.2-.3.2-.3.3-.3.2-.2.3-.3.3-.4.4-.2.3-.3.4-.2.4-.3.4-.3.4-.2.4-.3.5-.3.5-.3.5-.2.5-.3.5-.3.5-.3zm-1.7-10.7 1-.2v.6l.3.6.2.6.2.5v.7l.3.5v.5l.2.4v.6l.2.5.2.5v.4l.2.3v.4l.2.4v.5l.2.3v.7l.2.3v1.8l-.2.3v.2l-.3.3h-.2l-.2.3-.3.2-.5-1h.2l.2-.2v-.4h.2v-2.5l-.2-.3v-.3l-.2-.3v-.4l-.2-.4v-.4l-.2-.4v-.4l-.3-.5v-.6l-.2-.4v-.6l-.3-.5v-.6l-.3-.6v-.5l-.2-.6-.2-.6zm-.7-42h1v5.9l-.2 1.4v1.2l-.2 1.2v1.3l-.2 1.3v2.5l-.2 1.2v2.6l-.2 1.2v9.3l.2 1.4v1.4l.2 1.3.2 1.5.2 1.5.2 1.4.2 1.5.3 1.3.3 1.5-1 .3-.3-1.5-.3-1.5-.2-1.4-.2-1.5-.2-1.3-.2-1.5v-1.4l-.2-1.4V167l-.2-1.3v-10.3l.2-1.3v-2.5l.2-1.3V149l.2-1.2v-1.3l.2-1.2V143l.2-1.2zm-3.3-4.4-.5-1h.4l.3-.2.2-.2h.3l.4-.2h1.2l.3.2h.2l.2.3v.2l.2.2h.2v.4l.2.2v.3h.2v.7l.2.3v1.5l.2.3v1.1h-1v-2.4l-.2-.3v-.8l-.2-.3v-.4l-.2-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2h-1.1l-.2.2h-.3l-.3.2-.3.2zm-27 0 .4-1 .8.5.7.5.7.4.7.2.7.3.8.2.8.3 1 .2.7.2 1 .2h.7l1 .2h.8l1 .2h4.6l.7-.2h1l.8-.3h.8l1-.3.7-.2.8-.3.8-.2.8-.3.7-.4.8-.3.7-.4.7-.3.5 1-.7.3-.7.4-.8.4-.7.3-1 .4-.7.3-.7.3-1 .2-.7.2-1 .2h-.8l-1 .2h-1l-.8.2h-4.6l-1-.2h-.8l-1-.2-.8-.2-1-.2-.7-.2-.8-.3-.8-.3-.8-.3-.8-.2-.8-.4-.7-.4-.7-.4z"
            }),
            /* @__PURE__ */ jsxs237("g", {
              id: "rs_svg__b",
              children: [
                /* @__PURE__ */ jsx262("path", {
                  fill: "#edb92e",
                  d: "M363 212c-2-4-.3-9.8.3-11 .3-.8-.6-2.2-1-2.8-13-18.3-13.2-20-4.3-26.8 8-6 26.2-12 39.2-16.2 2.7-2 4.4-5 6.8-7.2-25 1.8-52 12-65.5 23.8-7.2 6.2 1.5 19 12.2 38 6.7 5 9.8 7 12.3 2.3z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "m362.8 200.7 1 .4v.2l-.2.2v.3l-.2.3v.5l-.2.2v.6l-.2.4v.7l-.2.3v1.6l-.2.4v2.5l.2.4v.4l.2.4v.4l.2.4v.3l.3.4-1 .3v-.4l-.3-.5v-.4l-.2-.4v-.4l-.2-.5v-.8l-.2-.6v-2.9l.2-.4v-1.2l.2-.3v-.4l.2-.2v-.6l.2-.3v-.6l.2-.2v-.2l.2-.2zm-1-2.2 1-.6v.2h.2v.4h.2v.4h.2v.2l.2.2v.4h.2v1.2l-1-.3v-.6l-.2-.2v-.2l-.2-.2v-.2l-.2-.2v-.2h-.2v-.2zm-4-27.5.5 1-.8.5-.7.6-.7.6-.5.6-.6.5-.6.5-.5.6-.5.5-.3.4-.3.5-.3.5v.5l-.3.5v1.7l.2.6.2.8.2.7.4.8.4.8.4 1 .5 1 .6 1 .7 1 .7 1.3 1 1.2.7 1.3 1 1.4 1 1.5 1 1.5 1.3 1.7-.8.5-1.3-1.7-1-1.5-1-1.5-1-1.4-1-1.3-.8-1.2-.8-1.2-.7-1-.6-1-.7-1-.4-1-.6-1-.3-.7-.2-1-.2-.7v-.7l-.2-.7v-1.4l.2-.6.2-.6.2-.6.3-.6.4-.6.5-.5.5-.5.5-.5.6-.6.7-.5.7-.7.7-.6.7-.7zm39-16.2.7.8h-.2l-1.2.5-1.2.5-1.2.4-1.4.3-1.3.4-1.4.5-1.4.4-1.3.5-1.5.5-1.4.5-1.3.5-1.3.5-1.4.5-1.4.5-1.3.5-1.4.5-1.4.5-1.3.6-1.3.6-1.3.5-1.2.7-1.2.5-1.2.6-1 .5-1.2.6-1 .4-1 .6-1 .6-1 .5-1 .7-.7.6-.7.6-.6-1 .8-.5 1-.6.8-.7 1-.6 1-.6 1-.4 1-.6 1.2-.6 1.2-.5 1-.7 1.4-.6 1.3-.5 1.3-.6 1.3-.5 1.2-.4 1.4-.5 1.3-.5 1.3-.5 1.4-.5 1.3-.5 1.4-.5 1.4-.5 1.4-.4 1.4-.5 1.3-.4 1.3-.4 1.3-.4 1.3-.5 1.2-.4 1.3-.5 1.3-.4 1.2-.3zm.7.8h-.2zm6.6-7v-1l.4.8-.2.2-.3.2-.3.3-.2.3-.2.2-.2.2v.3l-.3.2-.2.2-.2.2-.2.3-.3.3-.2.3-.2.2-.2.3v.3l-.3.2-.2.3-.2.2-.3.2-.2.3-.2.2-.2.2h-.2l-.3.4-.3.2-.2.2-.3.2-.2.2-.3.2-.2.2-.6-.8v-.2l.3-.2.3-.2.2-.2.2-.2.2-.2.3-.2.2-.2.2-.2v-.2l.3-.3.2-.2.2-.2.2-.2v-.2l.3-.2.2-.2.2-.3.2-.3v-.3l.3-.2.2-.2.2-.3.2-.2v-.2l.4-.3.2-.2.2-.2.2-.3.2-.2h.3l.2-.3.4.8zm0-1 1.4-.2-1 1-.4-1zM338.8 172l-.7-.8 1.5-1 1.4-1.2 1.4-1 1.5-1.2 1.5-1 1.7-1 1.7-1 1.7-1 2-1 1.8-1 2-1 2-1 2-.8 2-1 2.2-.7 2-.8 2.3-.8 2.3-1 2.2-.6 2.3-.7 2.3-.6 2.4-.5 2.3-.6 2.4-.7 2.4-.5 2.4-.4 2.4-.4 2.4-.4 2.3-.3 2.3-.3 2.4-.3 2.3-.2v1l-2.3.2-2.3.3-2.3.3-2.3.3-2.4.4-2.3.4-2.4.4-2.3.5-2.3.6-2.3.5-2.3.6-2.3.7-2.2.7-2.2.7-2.2.8-2.2.8-2.2.8-2 1-2 .7-2.2 1-2 1-2 1-1.8.8-1.8 1-1.8 1-1.7 1-1.6 1-1.5 1-1.6 1-1.5 1.2-1.4 1-1.2 1.2zm12.2 37.3-.5.8-.2-.2-1-1.6-1-1.8-1-1.7-1-1.7-.8-1.7-1-1.6-.8-1.5-.8-1.5-1-1.5-.7-1.5-.8-1.4-.7-1.3-.7-1.4-.5-1.3-.6-1.3-.6-1.2-.4-1.2-.5-1.2-.3-1-.3-1-.4-1.2v-1l-.2-1v-2.8l.3-.8.3-.8.4-.7.5-.8.5-.7.6-.6.8.8-.6.5-.5.6-.4.7-.3.6-.3.7-.2.8v4.5l.4 1v1l.5 1 .4 1 .4 1.3.5 1.2.4 1.2.6 1.3.7 1.3.7 1.4.7 1.4 1 1.4.7 1.5 1 1.5.8 1.5 1 1.6.8 1.7 1 1.7 1 1.7 1 2 1 1.6h-.3zm-.5.8-.2-.2.2.3zm12.5 1.3v1l.5-.2-.3.4-.2.4-.3.4-.3.3-.3.2-.2.3-.3.2-.3.2h-.3l-.5.2h-2.1l-.4-.2-.5-.2-.4-.2-.3-.2-.5-.2-.4-.3-.5-.3-.5-.3-.4-.4-.6-.3-.5-.3-.5-.4-.6-.4-.5-.4-.6-.4-.5-.5.5-.8.7.4.5.3.6.5.6.3.5.5.4.4.5.2.4.3.4.3.5.3.4.3.4.2.5.2.4.2h.5l.3.2h1.5l.2-.2h.3l.2-.3.2-.2.3-.2.2-.3v-.3l.4-.4.2-.4.4-.4zm-.4.3v-.4h.4zm.4.6v-1l.5.3zm.5-.7.3.6h-.8z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#edb92e",
                  d: "M359 213.6a34 34 0 0 1-1-4.7c-.7-2.8-.4-5.7.5-8.3-3-4.2-6.4-8.8-8.8-13.3-1.7-3.3-3-7-2-10.6 1-4 4.5-6.6 7.6-9 3.7-2.8 8.6-5.3 13.6-7.5 11-4.6 20-7 26.5-7l-4.2 3.8c-12 4-26.4 9.2-33.3 14.5-9 6.8-8.6 8.4 4.3 26.7.4.6 1.3 2 1 2.7-.6 1.2-1.8 7.2 0 11.4-1 2-2.6 1-4.2 1.2z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "m357.4 209 1-.2v.7l.2.2v.7h.2v.8l.2.3v.3l.2.3v.7h.2v.6h.2l-1 .4v-.3l-.2-.3v-.2l-.2-.3v-.5l-.2-.3v-.6h-.2v-.5l-.2-.3v-.7l-.2-.3v-.2zm.6-8 1-.6v.5l-.2.4v.2l-.2.2v1l-.2.2v.8l-.2.2v4.7l.2.3-1 .2v-.6l-.2-.2V203h.2v-1l.2-.2v-.5l.2-.2v-.2l.2-.3v.5zm1-.6v.5zm-9.7-12.8 1-.5v.6l.3.4.3.4v.4l.4.5.2.4.3.4v.5l.4.4.3.4.2.4.2.4.3.4.2.4.3.5.3.4.3.3.3.4.2.4.2.5.3.5.3.4.3.4.3.4.3.4.2.4.3.4.2.4.3.4.3.4.3.4.3.4-1 .6-.2-.4-.3-.4-.3-.4-.3-.4-.4-.4-.3-.4-.2-.4-.2-.4-.3-.4-.3-.4-.3-.5-.4-.4-.3-.3-.3-.4-.2-.4-.3-.5-.3-.5-.3-.4-.4-.4-.3-.4-.2-.5-.2-.4-.3-.5-.2-.4-.3-.4-.3-.4-.2-.4-.3-.5-.2-.4-.2-.5-.3-.5-.2-.4zm-2-11 1 .4-.2.3v4.1l.2.4v.3l.2.3v.7l.3.3v.4l.2.4v.6l.3.3v.3l.3.3v.2l.3.3v.3l.2.3-1 .6v-.3l-.2-.3-.2-.3v-.3l-.3-.4v-.3l-.3-.3v-.3l-.3-.3-.2-.3v-.3l-.2-.2v-.4l-.2-.3v-.3l-.2-.3v-.7l-.2-.4V180l-.2-.4V178l.2-.2v-.7l.2-.3zm7.7-9.2.6.8-.3.2-.3.3-.3.2h-.3l-.3.3-.2.3-.2.2-.3.3-.3.3-.3.2-.3.3-.2.2-.3.3-.4.3-.2.2-.3.3v.3l-.4.3-.2.3-.2.2-.3.3-.3.3-.2.3-.2.4v.3l-.3.3-.2.3v.3l-.3.3v.3l-.2.3v.4l-1-.3v-.4l.2-.4v-.4l.2-.4.2-.4v-.3l.3-.4.2-.2.2-.3.2-.3v-.3l.4-.5.2-.3.2-.2.3-.3.4-.3.2-.3.3-.2.2-.2.3-.3.2-.3.3-.2.3-.3.3-.2.3-.3.2-.2.3-.2.3-.3.3-.2h.4l.3-.4.3-.2zm13.7-7.5.4.8-.4.2-.4.2-.5.2-.5.2-.4.2-.5.2-.4.3-.6.2-.5.2-.5.2h-.5l-.4.3-.5.3-.3.2-.4.2-.5.3-.4.2-.4.2-.4.3-.5.2-.3.2-.4.3-.4.2-.5.2-.4.2-.2.3-.4.2-.4.2-.4.2-.3.3-.4.3-.4.2-.6-.8.3-.3h.4l.4-.4.4-.3.4-.2.4-.2.4-.2.4-.3.4-.2.4-.2.4-.2.4-.3.5-.2.5-.2.4-.2.4-.2.4-.3h.4l.5-.3.4-.3.6-.2.4-.2.5-.2.5-.3.4-.2.5-.2h.4l.4-.3.5-.2.5-.2.4-.2h.5zm27-6.4-.6-.7.5.7H394l-.6.2h-1.8l-.7.2h-.8l-.7.2h-.7l-.8.3-.8.2h-.7l-.8.2-.8.2-1 .2-.8.2-.8.3-1 .3-.8.3-1 .3-.8.2-1 .3-.8.3-1 .3-1 .5-1 .3-.8.4-1 .4-1 .4-1 .4-1 .4-.5-1 1-.4 1-.4 1-.4 1-.4 1-.3 1-.5 1-.3 1-.4 1-.3.8-.3 1-.3.8-.4 1-.2.8-.3h1l.8-.4.8-.2.8-.2.8-.2h.8l.8-.3.8-.2h.7l.7-.2h.8l.7-.2h1.4l.5-.2h1.9l.4.8zm-.3-1h1.4l-1 1zm-4.4 4 4-3.7.8.6-4 3.8-.3.2zm.7.8-.2.2zM358.3 172l-.6-1 .7-.5.7-.5 1-.5.7-.5.8-.5 1-.5.8-.4 1-.5 1-.4.8-.5 1.2-.4 1-.5 1-.3 1-.5 1.2-.5 1-.4 1.3-.5 1-.4 1.2-.5 1-.5 1.3-.5 1-.4 1.3-.4 1.2-.5 1.2-.4 1.2-.4 1.2-.5 1-.4 1.3-.3 1.2-.4 1-.3 1.2-.4.3 1-1.2.3-1 .3-1.3.4-1 .4-1.3.5-1.2.4-1.2.3-1.2.4-1 .4-1.2.6-1.2.4-1 .4-1.3.5-1 .3-1.3.5-1 .4-1.2.5-1 .4-1 .6-1.2.5-1 .5-1 .5-1 .5-1 .5-.8.5-1 .4-.8.4-.8.5-.8.4-.7.5-.7.4zm4.4 26-.8.5-1.3-1.7-1-1.5-1-1.5-1-1.4-1-1.3-.8-1.2-.8-1.2-.7-1-.6-1-.7-1-.4-1-.5-1-.4-.7-.2-1-.2-.7v-.7l-.2-.7v-1.4l.2-.6.2-.6.2-.6.3-.6.4-.6.5-.5.5-.5.5-.5.6-.6.7-.5.7-.7.7-.6.7-.7.6 1-.8.5-.7.6-.7.6-.5.6-.6.5-.6.5-.5.6-.5.5-.3.4-.3.5-.3.5v.5l-.2.6v2.2l.3.8.3.7.4.8.4.8.4 1 .6 1 .5 1 .7 1 .7 1.3 1 1.2.7 1.3 1 1.4 1 1.5 1 1.5 1.3 1.7zm1 3-1-.3v-1h-.2v-.2l-.2-.2v-.2h-.2v-.4l.7-.7.2.2v.4h.2v.2l.2.2v.2l.2.2v.4h.2v1.4zm.2 11.6-1-.5v.6l-.2-.4-.2-.5v-.4l-.2-.4v-.6l-.2-.4v-.5l-.2-.4v-5.4l.2-.4v-.7l.2-.4v-.5l.2-.3v-.4l.2-.2 1 .3v.2l-.2.2v.6l-.2.2v.6l-.2.3v1.1l-.2.4v5.1l.2.4v.8l.3.4v.4l.2.4zv.4zm0-.4v.4zm-5 1v1zh.2l.2-.2h1.4v.2h1.5l.2-.2h.2v-.2h.2v-.2l.2-.2.2-.3 1 .6-.2.2-.2.2v.2l-.2.2h-.2v.2l-.3.2h-.4l-.2.2h-.3v.2h-3v-1zm0 1v-1l.6.2-.5.7zm.6-.8.2.7h-.7l.6-.6z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#edb92e",
                  d: "M468 132.2c.3-2.3 0-2-.3 1.6-.3-.7-.8-1-1.4-1-1 0-1.7 1.6-1.8 5.2l.2 2.8c-33-.7-52.7 4.3-57.7 14-4.2 7.8 3 21 13.6 36 1.3 1.8 1.2 1.6 0 3-1.8 2.3-3.8 6-2.3 9.2a24.3 24.3 0 0 1-21 1.5c-1-3-3.4-4.4-5.4-5.8-.5-.2-2-1-2-1.4l-10.2-31.6c-9.5-30.7 75.3-33.5 88.3-33.5"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "m467.3 134 1-.4-1 .2V132h.2v-1.2l.2-.2.6-.3.3.3v1.6h-1V131l.4.2h.6v-.2 1l-.2.2v1.8h-1zm1 0-.2 1.6-.7-1.5h1zm-2-.7v-1h.7v.2h.4v.2h.2v.2h.2v.2h.2v.2h.2v.2l-1 .5v-.2h-.2v-.2h-.2v-.2zM465 138h-1v-1.8l.2-.3v-.9l.2-.3v-.7h.2v-.3l.2-.3.2-.3.2-.2h.2v-.2h.2v-.2h.5v1h-.2v.2h-.2v.2l-.2.2v.3l-.2.3v.6l-.2.2v2l-.2.3v.4zm-.3 3.3v-1l-.5.5v-2.3h-.2v-.4l1-.2v1.8l.2.2v1zm.5-.5v.5h-.5zM407.4 155l-1-.5.7-1 .7-.8.7-1 .8-.7 1-.8 1-.8 1-.8 1-.7 1.3-.7 1.2-.7 1.4-.6 1.6-.6 1.5-.5 1.7-.7 1.7-.5 1.8-.4 2-.5 1.8-.5 2-.3 2.2-.4 2.2-.3 2.2-.2 2.4-.3 2.4-.2 2.5-.2h2.5l2.7-.2h2.7l2.8-.2h9v1H453l-2.8.2h-2.6l-2.6.2-2.5.2-2.4.2-2.3.3-2.2.2-2.2.3-2 .4-2 .3-2 .4-1.8.4-1.8.4-1.7.5-1.6.5-1.5.6-1.5.5-1.3.5-1.3.7-1.2.6-1 .7-1 .7-1 .7-1 .7-.6.8-.7.8-.6.8-.6 1zm13.6 35.5-.8.6-1-1.3-1-1.4-1-1.4-1-1.5-.8-1.3-.8-1.4-1-1.3-.7-1.3-.8-1.3-.8-1.4-.7-1.2-.7-1.3-.6-1-.6-1.3-.5-1.2-.5-1.2-.5-1.2-.4-1-.5-1-.3-1.2-.3-1-.3-1-.2-1.2v-1l-.2-1V158l.3-.8.3-1 .2-.7.3-.8 1 .5-.4.7-.2.7-.2.8-.2.8v4.5l.2 1 .3 1v1l.5 1 .3 1.2.4 1 .5 1.2.5 1 .5 1.2.6 1.2.6 1.2.6 1.3.7 1 .7 1.4.8 1.3.8 1.3.8 1.3 1 1.3.8 1.4 1 1.3.8 1.4 1 1.4 1 1.5zm0 3.8-.8-.7.2-.3.2-.2h.2v-.2l.2-.2v-.4l-.2-.2v-.2h-.2v-.3h-.2v-.3h-.2l.8-.7.2.3.2.3v.2h.2v.4h.2v.2l.2.2v1l-.2.2v.2h-.2v.2l-.2.2-.2.2-.2.3zm-2.5 9-.4-.8-.2.7v-.3l-.2-.5v-.3l-.2-.3v-3.5l.2-.3v-.3l.2-.4.2-.3v-.3l.2-.3.2-.3v-.3l.3-.2v-.3l.3-.2.2-.3v-.2l.3-.3.2-.2v-.3l.3-.2.2-.2.8.7-.2.2-.2.2v.2h-.3v.3l-.3.3-.2.2v.3l-.3.3v.3l-.2.2-.2.3v.7l-.2.2v.2l-.2.3v.6l-.2.4v2.7l.2.3.2.3-.3.6zm.3-.5v.4l-.3.2zm-22 1.8 1-.3-.2-.3.6.2.7.3.5.2.6.2h.8l.6.2.6.2h.7l.6.2h5.7l.7-.2h.5l.7-.3h.6l.7-.2.6-.2.7-.2.7-.2.6-.2.6-.3.6-.3.6-.2.7-.4.6-.3.5 1-.6.2-.7.4-.6.4-.7.2-.6.3-.7.2-.6.2-.6.2-.7.2-.6.2h-.6l-.7.3h-.7l-.6.2h-.7l-.7.2h-5l-.7-.2h-.7l-.6-.3h-.7l-.7-.3-.6-.3-.7-.3-.6-.2-.8-.3-.3-.4zm.4.3-.2-.2v-.2zm-5.6-5.8.6-1 .2.2.2.2h.2l.2.2.2.2h.2l.2.2v.2h.3v.3h.3l.2.3h.2l.2.3.3.3.2.2.2.2.2.2v.2l.3.2v.2l.3.2.2.2v.2l.3.3.2.2.2.2v.2l.3.3v.3l.2.3-1 .3-.2-.2v-.3h-.2v-.3l-.2-.3-.2-.2v-.2l-.2-.2-.2-.2v-.2l-.3-.2-.2-.2-.3-.3-.2-.2-.3-.3h-.2l-.2-.3v-.2l-.3-.2h-.2v-.3h-.3l-.2-.2h-.2l-.2-.2h-.2l-.2-.3h-.2zh-.2zm-2-1.7.8-.3h.2v.2h.2l.2.2h.2v.2h.4v.2h.2l.2.2h.2l-.6 1-.2-.2h-.2v-.2h-.4v-.2h-.2l-.2-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2zm-10.2-31.7 1-.3.2 1 .3 1 .2.8.3 1 .3 1 .3.8.4 1 .3 1 .3 1 .3 1 .3 1 .3.8.2 1 .4 1 .3 1 .2 1 .3 1 .3 1 .4 1 .3 1 .3 1 .3 1 .5 1 .3 1 .3 1 .5 1 .3 1 .3 1 .4 1.2.4 1 .3 1 .4 1.2-1 .3-.3-1-.2-1.2-.3-1-.4-1-.2-1-.3-1-.3-1.2-.4-1-.3-1-.3-1-.4-1-.3-1-.3-1-.3-1-.4-1-.4-1-.3-1-.4-1-.3-1-.3-.8-.3-1-.4-1-.3-1-.3-1-.3-.8-.3-1-.2-1-.3-1-.3-.8-.3-1-.4-.8-.2-1zm88.2-33.6h1l-.5.5h-5.4l-2.5.2h-2.8l-3 .2-3.3.2-3.5.2-3.7.3-3.8.3-4 .4-4 .5-4 .6-4.2.6-4 .7-4.2 1-4 .8-4 1-3.7 1-3.7 1.3-3.4 1.4-3.3 1.4-3 1.5-2.6 1.6-2.3 1.7-2 2-1.6 1.8-1.2 2.2-.8 2.2-.4 2.3v2.5l.7 2.7-1 .3-.6-2.8v-2.8l.3-2.6 1-2.4 1.2-2.2 1.8-2 2-2 2.5-2 2.7-1.6 3-1.5 3.3-1.6 3.5-1.3 3.6-1 4-1.2 3.8-1 4-1 4-.7 4.2-.6 4.2-.6 4-.6 4-.5 4-.4 4-.4 3.7-.4 3.5-.2 3.3-.2 3-.2h3l2.4-.2h5.4l-.6.4zm1 0v.5h-.5l.7-.5zm-.5 0h-.4zm.7 0v.5h-.6z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#fff",
                  d: "M405 190.2c3.5 0 6.4 2.8 6.4 6.4 0 3.5-3 6.4-6.4 6.4s-6.4-3-6.4-6.4c0-3.6 3-6.4 6.4-6.4"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "M412 196.6h-1a6 6 0 0 0-3.4-5.3 5.8 5.8 0 0 0-2.6-.6v-1c2.3 0 4.6 1.2 5.8 3.2a7 7 0 0 1 1 3.6zm-7 7v-1c2.2 0 4.3-1.4 5.2-3.4a6 6 0 0 0 .7-2.6h1c0 2.3-1.4 4.6-3.4 6a7 7 0 0 1-3.6 1zm-7-7h1c0 2.2 1.4 4.3 3.4 5.3a5.8 5.8 0 0 0 2.6.5v1a7 7 0 0 1-5.8-3.3 7 7 0 0 1-1-3.6zm7-7v1a6 6 0 0 0-5.2 3.3 6 6 0 0 0-.7 2.6h-1c0-2.4 1.4-4.7 3.4-6a6.8 6.8 0 0 1 3.6-1z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#fff",
                  d: "M350.8 203.6c3.2 0 6 2.7 6 6s-2.8 6-6 6c-3.3 0-6-2.7-6-6s2.7-6 6-6"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "M357.2 209.6h-1c0-2-1-4-2.8-4.8a5.4 5.4 0 0 0-2.6-.7v-1a7 7 0 0 1 5.4 3 6.5 6.5 0 0 1 1 3.6zm-6.4 6.4v-1c2 0 4-1.2 4.8-3a5.5 5.5 0 0 0 .6-2.4h1c0 2-1.2 4.3-3 5.4a6.4 6.4 0 0 1-3.4 1m-6.5-6.4h1c0 2 1.2 4 3 4.8.8.4 1.6.6 2.5.6v1a6.6 6.6 0 0 1-5.5-3 6.5 6.5 0 0 1-1-3.4m6.5-6.5v1c-2 0-4 1.3-5 3a5.5 5.5 0 0 0-.5 2.6h-1c0-2.2 1.2-4.4 3-5.5a6.4 6.4 0 0 1 3.5-1z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#fff",
                  d: "M345 192.7c3.4 0 6 2.7 6 6s-2.6 6-6 6c-3.2 0-5.8-2.7-5.8-6s2.6-6 6-6z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "M351.5 198.7h-1c0-2-1.2-4-3-5a5.3 5.3 0 0 0-2.4-.5v-1c2.3 0 4.4 1.2 5.5 3a6.5 6.5 0 0 1 1 3.5zM345 205v-1c2 0 4-1 4.8-2.7a5.5 5.5 0 0 0 .7-2.6h1c0 2.2-1.2 4.3-3 5.5a6.4 6.4 0 0 1-3.4 1zm-6.3-6.3h1c0 2 1.2 4 3 4.8a5 5 0 0 0 2.4.6v1c-2 .2-4.2-1-5.3-3a6.5 6.5 0 0 1-1-3.3zm6.4-6.5v1c-1.8 0-3.7 1-4.6 2.8a5.5 5.5 0 0 0-.7 2.7h-1c0-2.2 1.2-4.4 3-5.5a6.4 6.4 0 0 1 3.4-1z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#fff",
                  d: "M339.8 181.7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "M346.2 187.7h-1c0-2-1.2-4-3-5a5.4 5.4 0 0 0-2.4-.5v-1c2.2 0 4.3 1.2 5.4 3a6.5 6.5 0 0 1 1 3.5m-6.4 6.4v-1c2 0 3.8-1 4.7-2.7.5-.8.7-1.7.7-2.6h1c0 2-1 4.3-3 5.4a6.4 6.4 0 0 1-3.4 1zm-6.4-6.3h1c0 2 1 4 3 4.8.7.4 1.5.6 2.4.6v1a6 6 0 0 1-5.4-3 6.5 6.5 0 0 1-1-3.3zm6.4-6.5v1c-2 0-4 1.2-4.8 3a5.5 5.5 0 0 0-.6 2.5h-1c0-2.2 1-4.4 3-5.5a6.4 6.4 0 0 1 3.4-1"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#edb92e",
                  d: "M444.3 202.2c3.4-.3 2.5 5.8 2 7.2-1 1.8-1.8 1.8-3 .2-.8-1.3-2.4-7.2 1-7.5z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "m446.6 209.6-1-.4h.2v-.7l.2-.3v-.5l.2-.3V204h-.2v-.3l-.2-.2v-.2l-.2-.2h-.2l-.3-.2h-.2l-.2-.2h-.3v-1h.7l.3.2h.3l.3.2v.2l.3.3.2.2.2.3v.2l.2.3v.7l.2.3v3.7l-.2.3v.5l-.2.3v.5h-.2zm-3.7.3.8-.7.2.3v.2h.2v.2h.2v.2h.7l.2-.2v-.2h.2v-.2h.2v-.3l1 .3v.2l-.2.2v.3h-.2v.2l-.2.2-.2.2h-.4v.2H444v-.2h-.2v-.2h-.2v-.2h-.2v-.3h-.2v-.3h-.3zm1.2-8.4v1h-.4v.2h-.3v.2h-.3v.3l-.2.2v.4h-.2v3.2l.2.2v.6l.2.2v.3l.2.2v.2l.2.2v.2h.2l-1 .7v-.5l-.2-.2v-.2l-.2-.4v-.2l-.2-.3v-.2l-.2-.3v-.7l-.2-.3v-3l.2-.3v-.3l.3-.3.2-.2.2-.3h.2l.2-.3.3-.2h.4l.2-.2z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#fff",
                  d: "M444.5 205.5c8-.6 6 13.8 4.4 17-2 4.2-4 4.3-6.7.5-2-3-5.8-17 2.2-17.5z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "m449.4 222.7-1-.4.2-.3.2-.4v-.4l.3-.5.2-.5v-.6l.2-.6.2-.7V217l.2-.7v-5.1l-.3-.7v-.6l-.3-.7-.3-.6-.3-.5-.3-.5-.3-.4-.3-.4-.4-.4-.5-.2-.5-.2-.5-.2h-1.4v-1h1.5l.6.2.7.2.5.4.6.4.4.4.4.5.4.7.3.6v.7l.3.6.2.7v.7l.3.8v6.3l-.3.7v.7l-.2.6v.6l-.3.6v.5l-.3.5v.4l-.3.3zm-7.5.5.8-.5.2.3.2.3.3.3.2.3h.2v.4h.3l.2.3.2.2h.4l.2.2h1v-.2h.3l.2-.3v-.2l.2-.2.2-.2h.2l.2-.4v-.3l.3-.3.3-.3.2-.4 1 .4-.3.4-.2.5-.2.3-.2.4-.2.3-.2.3-.2.2-.2.2-.2.3-.3.2h-.2v.3h-.4l-.2.2H445l-.4-.2h-.2l-.3-.3v-.2l-.4-.2-.2-.2-.2-.2-.3-.2-.3-.3-.3-.4-.2-.4zm2.5-17.2v-1zh-.6l-.7.2-.5.2-.5.3-.4.3-.5.4-.3.4-.3.4-.3.6-.2.5v.6l-.2.5v.7l-.2.7v.6l.2.7v1.4l.2.7v.8l.3.7v.6l.3.7.2.6.2.5.2.6.2.7.2.5.2.4.2.4.2.4.2.3-1 .5v-.3l-.3-.5-.2-.4-.2-.4v-.6l-.4-.5-.2-.7-.2-.6-.2-.7-.2-.7v-.7l-.3-.6v-.8l-.2-.7V213l-.2-.7v-.8l.2-.7v-.6l.2-.7v-.7l.4-.6.2-.6.4-.6.4-.5.4-.5.5-.4.6-.3.7-.3.7-.2h.8v1zm0-1v1z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#edb92e",
                  d: "M379.7 210.8c3.3-1 4 5 3.6 6.6-.4 2-1.2 2.2-2.7 1-1-1.2-4-6.5-1-7.6z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "m383.8 217.5-1-.2v-2.8l-.2-.3v-.7l-.2-.3v-.3l-.2-.2v-.3l-.3-.2-.2-.2-.3-.3-.3-.3h-.3l-.3-.2h-.6l-.4-1h1.5l.2.2.3.2.2.2.3.2.2.3.2.2v.3l.3.3v.4l.2.3v.3l.2.3v.3l.2.4v.6l.2.3v2.5zm-3.5 1 .7-.6h.2v.2h.2l.2.2h.2v.2h.4l.2-.2v-.2h.2v-.6h.2v-.3l1 .2v.4h-.2v.4l-.2.3v.2h-.2l-.2.2-.2.2h-.2l-.2.2h-1v-.2h-.3l-.2-.2h-.2v-.2h-.2zv-.2zm-.7-8.2.3 1h-.3l-.2.2h-.2v.2l-.2.2v.2l-.2.2v1.8l.2.4v.3l.2.3v.2l.2.3.2.3v.3l.2.3.2.3v.2l.3.2v.2l.2.2.3.3.2.2-.7.6h-.2v-.4l-.3-.2v-.2l-.3-.2v-.3l-.3-.2v-.2l-.2-.3v-.3l-.3-.3v-.4l-.2-.3v-.3l-.3-.3v-.7l-.2-.3V212l.3-.2.2-.3.2-.3.3-.2.2-.2h.2l.4-.3z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#fff",
                  d: "M380.7 214c7.7-2.5 9.2 12 8.4 15.5-1 4.5-2.8 5-6.2 2-2.6-2.4-9.7-15-2-17.5z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "m389.6 229.6-1-.2v-.8l.2-.4v-2.9l-.2-.7V223l-.3-.7v-.7l-.3-.8-.2-.7-.2-.6-.2-.7-.3-.7-.2-.6-.3-.6-.3-.4-.4-.5-.3-.4-.4-.3-.4-.4-.4-.4-.5-.2h-.5l-.5-.2h-1.1l-.6.3-.4-1 .7-.2h2.2l.7.2.7.2.5.4.5.5.5.4.4.5.4.5.4.6.3.7.3.6.3.6.3.7.2.8.2.8.2.7v.8l.3.7v1.5l.2.7v4.4zm-7 2.3.5-1 .5.4.2.2.3.3h.3l.3.3h.2l.3.3h.3l.2.2h1.4l.2-.2.2-.2.2-.3.3-.3v-.6l.2-.2v-.3l.2-.4v-.2l.2-.4 1 .2v.4l-.2.4v.4l-.2.4-.2.3v.3l-.2.3-.2.4v.3l-.3.2h-.2v.3l-.3.2h-.2l-.2.3h-.8l-.3.2h-.5l-.3-.2h-.2l-.3-.2h-.4l-.3-.3-.3-.2h-.3l-.3-.3-.3-.3-.2-.2-.3-.3zm-2-18.5.3 1-.7.2-.6.3-.4.3-.4.4-.4.4-.3.5-.2.5v.5l-.2.6v2.5l.2.6.2.7.2.6.2.7.3.7v.7l.4.6.3.7.4.6.4.6.3.6.4.6.4.5.3.4.3.4.4.4.2.4.3.3-.5 1-.3-.4-.3-.3-.4-.4-.4-.5-.3-.5-.4-.5-.4-.6-.3-.7-.5-.6-.3-.6-.4-.6-.3-.6-.3-.7-.3-.7-.3-.7-.3-.7-.2-.8-.2-.8v-.7l-.2-.7V218l.2-.7.2-.6.2-.6.3-.5.4-.5.6-.5.6-.4.7-.2.6-.3zm0 .5v-.5z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#edb92e",
                  d: "M464.2 137.8c-17.2-1.6-35 .2-52.3 7-14.8 6-13.4 23.2 4.6 47-1.7 3-2.6 6.8-2.7 11h4.8c-1.3-2.8 0-6.4 1.8-9 1-1.5 1.3-1.2 0-3-10.7-15-17.8-28.2-13.6-36 5-9.7 24.6-14.7 57.7-14 0-1 0-1.8-.2-2.7 0 0-.2 0-.3-.2z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "m412 145.4-.3-1 1.7-.6 1.6-.6 1.7-.6 1.6-.5 1.6-.4 1.6-.5 1.6-.4 1.7-.4 1.5-.4 1.7-.4 1.6-.4 1.7-.3 1.6-.3 1.8-.3h1.6l1.7-.3 1.7-.2 1.7-.2 1.6-.2h3.3l1.6-.2h11.5l1.6.2h1.6l1.6.3v1l-1.7-.2h-4.9l-1.6-.2h-9.7l-1.6.2H443l-1.5.3-1.7.2-1.6.2-1.6.2H435l-1.7.4-1.6.3-1.7.3-1.6.4-1.6.3-1.7.5-1.5.4-1.6.4-1.8.5-1.6.6-1.6.6-1.7.6-1.6.6-1.6.6zm5 46.7-1-.4.2.5-1.7-2-1.5-2.3-1.5-2-1.3-2.2-1.3-2-1.2-2-1-2-1-2-1-2-.7-1.7-.6-1.8-.5-1.8-.6-1.7-.4-1.6-.3-1.7-.2-1.6v-4.4l.2-1.3.3-1.3.4-1.2.5-1.2.5-1.2.7-1 .8-1 .8-1 1-.7 1-.8 1.3-.8 1.4-.6 1.3-.5.4 1-1.2.5-1.2.6-1 .7-1 .8-1 1-1 .8-.6 1-.7 1-.5 1-.5 1-.3 1.2-.3 1.2-.2 1.2v3.8l.2 1.5.3 1.7.3 1.6.5 1.6.6 1.6.7 1.8.8 1.8 1 2 .8 1.8 1 2 1.2 2 1.2 2 1.4 2 1.4 2.2 1.5 2 1.7 2.3zm0-.5.2.3-.2.3v-.5zm-3 11v1l-.6-.6v-2.5l.2-.4v-1l.2-.4v-.7l.2-.5v-.4l.2-.2v-.4l.2-.3v-.3l.2-.3v-.4l.2-.3v-.3l.2-.3v-.3l.3-.3v-.3l.2-.2.2-.3v-.3l.3-.3v-.4l1 .5v.4l-.3.2v.3l-.2.2-.2.3v.3l-.2.3v.4l-.2.3v.3l-.2.4v.3l-.2.3v.3l-.2.4v.7l-.2.3v.8l-.2.4v.8l-.2.4v1.4l-.2.4v.7l-.5-.6zm0 1h-.6v-.6l.5.5zm4.3-.4 1-.4-.5.8h-4.6v-1h4.6l-.5.7zm1-.4.3.7h-.8l.4-.7zm1-9 .7.6-.2.2v.3l-.2.2-.2.2v.2l-.3.3v.4l-.2.3-.2.2v.3l-.2.3v.2l-.2.3v.7l-.2.2v.5l-.2.3v2.2l.2.3v.4l.2.2-1 .5v-.5l-.2-.3v-.7l-.2-.3v-2.7l.2-.3v-.3l.2-.2v-.3l.2-.3v-.3l.2-.4v-.3l.2-.3.2-.3v-.2l.2-.3.2-.3v-.3l.3-.3v-.3h.3l.2-.3zm0-2.5.7-.5.2.3.2.3v.2h.2v.4h.2v.4l.2.2v.5l-.2.2v.2h-.2v.2l-.2.2v.2h-.2v.3l-.2.2-.8-.6v-.2l.2-.2.2-.2v-.2h.2v-.4h.2v-.2h-.2v-.2l-.2-.2v-.3h-.2v-.3h-.2zm-13.8-36.5 1 .5-.4.7-.2.7-.2.8-.2.8v4.5l.2 1 .3 1v1l.5 1 .3 1.2.4 1 .5 1.2.5 1 .5 1.2.6 1.2.6 1.2.6 1.3.7 1 .7 1.4.8 1.3.8 1.3.8 1.3 1 1.3.8 1.4 1 1.3.8 1.4 1 1.4 1 1.5-.8.6-1-1.3-1-1.4-1-1.4-1-1.5-.8-1.3-.8-1.4-1-1.3-.7-1.3-.8-1.3-.8-1.4-.7-1.2-.7-1.3-.6-1-.6-1.3-.5-1.2-.5-1.2-.5-1.2-.4-1-.5-1-.3-1.2-.3-1-.3-1-.2-1.2v-1l-.2-1V158l.3-.8.3-1 .2-.7.3-.8zm57.7-13.7h1l-.5.5h-14.5l-2.6.2H445l-2.5.3-2.4.2-2.3.3-2.2.2-2.2.3-2 .4-2 .3-2 .4-1.8.4-1.8.4-1.7.5-1.6.5-1.5.6-1.5.5-1.3.5-1.3.7-1.3.6-1 .7-1 .7-1 .7-.8.7-.8.8-.7.8-.6.8-.6 1-1-.5.7-1 .7-.8.7-1 .8-.7 1-.8 1-.8 1-.8 1-.7 1.2-.7 1.3-.7 1.4-.6 1.6-.6 1.5-.5 1.7-.7 1.7-.5 1.8-.4 2-.5 1.8-.5 2-.3 2.2-.4 2.2-.3 2.2-.2 2.4-.3 2.4-.2 2.5-.2h2.5l2.7-.2h2.7l2.8-.2h9l-.6.6zm1 0v.5h-.5zm-1-2.3.7-.7v1.9h.2v1h-1v-2.3l-.2-.2v-.4.3zm.7-.7v.3-.2zm-1.2-.4.8.7v-.6.2h.2v.2l-.7.7v-.4h-.2v-.6zm0 .7-.3-.2.3-.4zm.8 0-.8-.6h.4zm-.4-.7h1l-.6.8-.4-.7z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#fff",
                  d: "M380.6 142.7c3.4 0 6 2.7 6 6s-2.6 6.3-6 6.3-6.2-2.7-6.2-6.2a6 6 0 0 1 6.2-6z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "M387.2 148.8h-1c0-2-1.2-4-3-5a5.6 5.6 0 0 0-2.6-.6v-1c2.2 0 4.5 1.2 5.6 3a6.7 6.7 0 0 1 1 3.6m-6.6 6.7v-1c2 0 4-1.2 5-3a7 7 0 0 0 .6-2.7h1a7 7 0 0 1-3 5.7 6.6 6.6 0 0 1-3.6 1m-6.7-6.7h1c0 2 1.2 4.2 3 5a5.6 5.6 0 0 0 2.6.7v1a6.6 6.6 0 0 1-5.6-3 6.7 6.7 0 0 1-1-3.7m6.6-6.7v1.2c-2 0-4 1.2-5 3a5.7 5.7 0 0 0-.6 2.6h-1c0-2.2 1-4.4 3-5.6a6.6 6.6 0 0 1 3.6-1z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#fff",
                  d: "M392.6 138.7c3.4 0 6.2 2.8 6.2 6.2 0 3.3-2.8 6-6.2 6a6 6 0 0 1-6-6c0-3.5 2.6-6.3 6-6.3z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "M399.3 145h-1c0-2.2-1.3-4.3-3.2-5.2a5.6 5.6 0 0 0-2.4-.6v-1a7 7 0 0 1 5.7 3 6.7 6.7 0 0 1 1 3.7zm-6.7 6.6v-1c2 0 4-1.3 5-3a5.7 5.7 0 0 0 .7-2.7h1c0 2.2-1.2 4.4-3.2 5.6a6.6 6.6 0 0 1-3.4 1zM386 145h1c0 2 1.2 4 3 5a5.6 5.6 0 0 0 2.6.6v1a6.7 6.7 0 0 1-5.6-3.2 6.7 6.7 0 0 1-1-3.5zm6.6-6.8v1c-2 0-4 1.2-5 3a5.7 5.7 0 0 0-.6 2.7h-1c0-2.4 1.2-4.7 3.2-5.8a6.6 6.6 0 0 1 3.4-1z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#edb92e",
                  d: "M394.2 144a261.2 261.2 0 0 0 2 2.4c-9.8 5.4-14 11-13 16.7.2 1 3.2 11.5 9.8 31.7 4.5 3 7.8 6 10 8.4-.2.4.8 1.2.5 1.5.7 3-2.8 2.4-5 1.7-1.2-3-4.6-6-6.6-7.5-.5-.2-2-1-2-1.4l-10.2-31.6c-3-9.8 3.6-16.8 14.4-21.7z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "m396.3 147-.5-1v.7h-.2v-.2h-.2v-.2l-.2-.2h-.2v-.2l-.2-.2v-.2h-.2v-.2h-.2v-.2l-.2-.2-.2-.2v-.2h-.2l.8-.7.2.2h.2v.4h.2v.2h.2v.2l.2.2.2.2v.2h.2v.2h.2v.2l.2.2v1zm.2-1 .3.6-.5.3zm-12.7 17-1 .2v-3.9l.2-.6.2-.5.2-.6.2-.5.3-.5.2-.5.3-.6.4-.5.3-.6.4-.6.5-.5.4-.6.6-.5.5-.5.6-.5.6-.6.5-.5.7-.4.7-.5.6-.5.8-.5.8-.5 1-.5.7-.5.8-.5.5 1-1 .4-.7.5-.8.4-.8.5-.8.4-.7.5-.7.4-.6.5-.7.4-.6.5-.6.4-.5.5-.6.4-.5.6-.5.5-.4.5-.3.5-.3.5-.3.5-.2.5-.2.5-.2.5-.2.5-.2.5v.5l-.2.5v3.1zm9.5 31.3-.6.8-.2-.2-.6-1.8-.7-1.8-.5-1.8-.6-1.7-.5-1.6-.5-1.5-.5-1.5-.5-1.5-.4-1.4-.4-1.2-.4-1.3-.4-1.3-.4-1-.3-1.3-.4-1-.3-1-.3-1-.3-1-.3-.8-.2-.8-.2-.8-.2-.6-.2-.7v-.5l-.3-.5v-.5l-.2-.4v-.8h-.2v-.3h1v.3l.2.3v.4l.2.3v.5l.2.5.2.6.2.7.2.7.2.7.2 1 .3.7.2 1 .2 1 .3 1 .3 1 .4 1 .4 1.2.3 1.2.3 1.3.5 1.3.4 1.4.5 1.5.4 1.5.7 1.6.5 1.6.5 1.7.6 2 .6 1.7.5 1.8-.2-.2zm-.6.8-.2-.2.2.3zm10.7 8.4-.7-.6v.6l-.2-.2-.2-.2-.3-.3-.2-.2-.2-.2-.3-.3-.2-.2-.2-.2-.2-.3-.3-.2-.3-.2-.2-.2-.3-.3-.3-.3-.3-.2-.4-.3-.3-.2-.4-.3-.4-.3-.3-.2-.4-.3-.4-.3-.4-.3-.3-.3-.5-.3-.4-.2-.3-.3-.4-.2-.4-.3-.5-.3-.4-.3-.3-.3.6-.7.4.3.4.3h.5l.4.4.3.3.4.3.4.3.5.3.3.2.4.3.3.4.4.3.2.2.4.2.3.3.2.2.3.3.3.3.3.2.4.3.3.2.3.3.3.3.2.2.3.3.3.3.3.3.2.2.3.2.2.3.2.2.2.3v.6zm0-.6.3.3-.3.4v-.6zm.6 1.6-1 .2.2-.5v.2h-.2v.2-.2l-.2-.2v-.2h-.2v-1.2l.8.6v-.2h.2v.2l.2.2v.2l.2.2v.7l-.2.2.2-.6zm-1 .2v-.3l.2-.2-.2.6zm-5 1.8 1-.4-.4-.3h.4l.2.2h.7l.4.2h2.3v-.2h.2v-1.4l1-.2v1.6l-.2.3v.2l-.2.2h-.2l-.2.2h-.4l-.2.2h-3l-.3-.2h-.5l-.3-.2h-.5l-.3-.4zm.2.3h-.2v-.3zm-6.6-7.5.6-1 .2.3h.2l.2.3h.2l.3.3.2.3.2.2.2.2.2.2h.2l.2.3.3.2v.3l.4.2.2.3.2.2.3.3.3.2.2.3.3.3.2.2.2.3.2.4.2.3.2.3.2.2.2.3v.3l.3.3v.4l.3.3v.3l-1 .4v-.3l-.2-.4-.2-.3v-.2l-.3-.2v-.3l-.2-.2-.2-.3-.2-.3-.2-.2-.2-.3-.2-.2-.2-.3-.3-.2-.2-.3v-.2l-.3-.3-.3-.2-.2-.2-.2-.2-.3-.2-.2-.2-.2-.2h-.2l-.2-.3h-.2l-.2-.3h-.2l-.2-.3h-.2l-.2-.2zm.6-1 .3.3-.3-.2zm-2.7-.7 1-.3.2.2h.2v.2h.2v.2h.4v.2h.2l.2.2h.2l-.6 1-.2-.2h-.2v-.2h-.4v-.2h-.2l-.2-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2zm-10-31.7.8-.3.3 1 .3 1 .2.8.3 1 .3 1 .3.8.4 1 .3 1 .3 1 .3 1 .3 1 .3.8.2 1 .4 1 .3 1 .2 1 .3 1 .3 1 .4 1 .3 1 .3 1 .3 1 .5 1 .3 1 .3 1 .5 1 .3 1 .3 1 .4 1.2.4 1 .3 1 .4 1.2-1 .3-.3-1-.2-1.2-.3-1-.4-1-.2-1-.3-1-.3-1.2-.4-1-.3-1-.3-1-.4-1-.3-1-.3-1-.3-1-.4-1-.4-1-.3-1-.4-1-.3-1-.3-.8-.3-1-.4-1-.3-1-.3-1-.3-.8-.3-1-.2-1-.3-1-.3-.8-.3-1-.4-.8-.2-1zm15-22-.7.5h.6l-1 .6-1 .4-1 .5-.8.4-1 .5-.7.4-1 .5-.7.5-.8.5-.7.6-.7.6-.5.6-.7.6-.5.6-.6.7-.5.6-.4.7-.4.6-.4.7-.3.7-.3.7-.3.7v.8l-.2.7v.7l-.2.8v2.6l.3.8v1l.3.7-1 .3-.2-1v-.8l-.3-1V159l.2-1 .2-.7.2-.6.3-.8.4-.7.5-1 .4-.6.4-.7.6-.7.5-.7.6-.6.8-.6.6-.6.8-.6.7-.6.7-.5.8-.6 1-.5.7-.5 1-.5 1-.5.8-.5 1-.5 1-.5.6.2zm-.5-.3.4-.2.2.4z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#edb92e",
                  d: "m356 217-.4 2c-2.8.5-5.3.7-7.3.3 3.4-3.3 6-4 7.6-2.4z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "m355 218.8.4-2 1 .2-.3 2-.3.4-.6-.6zm1 0v.5h-.3zm-8 .2.7.7-.3-1 .2.2h4.1l.3-.2h1l.2-.2h.7l.2-.2h.3l.2 1h-.8l-.4.2h-.5l-.4.2h-1.3v.2h-3.7l-.4-1zm.2 1-1-.3.8-.7zm8.2-3-1-.2.2.5v-.2h-.6v-.2h-.6l-.2-.2H353v.2h-.6l-.2.3-.2.2h-.3l-.2.2-.3.2-.2.2-.3.2-.3.2-.2.2-.3.2-.4.3h-.3l-.3.4-.3.3-.7-.7.3-.3.3-.3.3-.3.2-.2.3-.2.3-.2.3-.3h.4l.3-.3h.3l.2-.3h.3l.3-.3h.6l.3-.2h.5l.4-.2h1.3l.2.2h.3l.2.2h.2l.2.2.3.3v.5zm0-.5v.5zm-.5.4h.4-.5zm.3-.5.2.2v.3z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#edb92e",
                  d: "M355.6 212.3c1.8.4 2 .7 2.7 1 1 0 2.4 0 3.3-1 4-2.2 4 2 2.5 5-1 2.4-.5 5 .6 7 1.2 2.2 1 3.2 0 4l-1.6 1c-1 1.2-1.8 1-2-.6-3.8-1.6-5-5.3-6.2-8.6-1.7-4.7-7.8-5.8.8-7.7z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "M358.4 212.7v1h-.7v-.2h-.4l-.2-.2h-.4l-.2-.2h-.8l-.3-.2.2-1h.4l.2.2h.4l.2.2h.4v.2h.8v.2zm3-.7.5 1v-.2l-.2.2h-.3v.2h-.2l-.2.2h-.2l-.2.2h-2.1v-1h2.2l.2-.2h.2v-.2h.2zm3 5.6-.8-.4v-.3l.3-.4v-.5l.2-.2v-.6l.2-.3v-2.2h-.2v-.2h-.2v-.2h-1.2l-.3.2-.3.2-.3.2-.6-1 .4-.2.3-.2h.5l.3-.2h1.8l.2.2.2.2v.2l.2.3v.4l.2.3v2.4l-.2.3v.3l-.2.4v.3l-.2.3v.3zm.6 6.3-1 .4v-.4l-.2-.2v-.4l-.2-.2v-.2l-.2-.2v-.5l-.2-.2v-.8l-.2-.2v-2.3l.2-.2v-.3l.2-.3v-.3l.2-.2 1 .4-.2.2v.4l-.2.2v.8l-.2.2v2l.2.2v.5l.2.2v.4h.2v.2l.2.2v.4h.2zm0 4.6-.6-1h.2v-.2h.2v-1.6l-.2-.3v-.3l-.2-.2v-.2l-.2-.2v-.2l.8-.5v.2l.2.2v.2l.2.2v.2l.2.2v.2l.2.3v1.7l-.2.2v.2h-.2v.2h-.2v.2l-.2.2zm-1.6 1-.8-.7v-.2h.2l.2-.2h.2v-.2h.4v-.2h.2v-.2h.4v-.2h.2l.6.8h-.2v.2h-.4v.2h-.2l-.2.2h-.2v.2h-.2zm-.8-.7v-.2zm-1.8 0 .4-.8.3.4v.5h.2v.2h.4v-.2h.2v-.2h.2l.8.6-.2.2-.2.2-.3.2h-.2v.2h-1.1l-.2-.2v-.2l-.2-.2v-.4h-.2v-.7zm.4-.8h.3v.4zm-7-8 1-.3.2.2v.3l.2.3v.4l.2.3v.3l.3.3.2.4v.3l.2.3.2.3v.3l.3.3v.2l.2.3v.2l.3.3.2.3.2.2v.3l.3.2.2.3.2.2.2.2.2.2h.2l.3.3.3.2.3.2.3.2h.3l.2.2-.4 1-.3-.2-.4-.2-.2-.2-.4-.2-.3-.2-.2-.3-.3-.3-.2-.2-.3-.3-.3-.2-.2-.3-.2-.3-.2-.3-.3-.4-.2-.3-.2-.3-.2-.3v-.4l-.2-.3v-.3l-.3-.3v-.3l-.3-.2v-.3l-.2-.4v-.2l-.2-.3-.2-.3v-.3l-.2-.4v-.3zm1.4-8.4v1l-.6.2-.7.2h-.6l-.5.3h-.4l-.4.3h-.3v.3l-.2.2v.2h-.2v.2l.2.3.3.2.2.3.2.2.2.3.3.2v.3l.4.3.2.3.3.5.2.3.2.4.3.4.2.4v.5l.3.4-1 .3v-.4l-.3-.5-.2-.4-.2-.3-.3-.3-.2-.3v-.2l-.4-.3-.2-.3-.3-.3v-.4l-.3-.2-.3-.3-.3-.4v-.2l-.2-.3-.2-.4v-.6l.3-.3v-.2l.3-.3h.3l.4-.3.4-.3.5-.2h.4l.7-.3.8-.2zm0 1v-1zm0-1"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#edb92e",
                  d: "M357 212.5c3.5 1.2 4-.7 6-.6-.8 5-1.7 7.7-7 5-3-1.6-6.7.7-7.4 2.3-.3.6-2-.6-2.6-2-2.6-5.8 6.7-6.4 11-4.8z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "m363.6 212-1-.2.5.6H362v.2h-.3l-.2.2h-.2l-.3.2h-.3v.2h-.7l-.2.2h-2l-.4-.2h-.3l-.3-.2.3-1h.3l.3.2h.4l.2.2h1.3l.2-.2h.2l.2-.2h.5l.2-.2h.2l.3-.2h.5l.2-.2h.4l.6.6zm-.5-.6h.7v.6zm-7.2 6 .4-1 .5.4.5.2h.4l.4.3h.3l.4.2h1.7l.2-.2.3-.3.2-.3v-.2l.2-.2.2-.3v-.3l.2-.3v-.3l.2-.2v-.4l.2-.4v-.4l.2-.4v-.9l.2-.5 1 .2v.5l-.2.5v.8l-.2.5v.4l-.2.4v.4l-.3.4v.3l-.2.4-.2.4v.2l-.3.3-.2.3-.2.2-.3.2-.2.2h-.2l-.3.2h-.3l-.3.2h-1.6l-.4-.2-.4-.2h-.4l-.4-.3-.5-.3-.5-.3zm-6.8 2-1-.3h.2v-.3h.3v-.3l.3-.2v-.2l.3-.2h.3l.2-.3.2-.2h.3l.2-.3h.3l.2-.3h.3l.3-.2h.3l.2-.2h.3l.4-.2h2.3l.3.2h.3l.3.2h.2l-.4 1h-.3l-.2-.2h-.5l-.3-.2h-1.8l-.3.2h-.3l-.3.2h-.3l-.2.3h-.2l-.3.2h-.2l-.2.2h-.2v.2l-.2.2h-.2v.3h-.2v.2h-.2v.2zm-3.5-2 1-.3v.4h.2v.4h.2v.2l.2.2h.2v.2l.2.2h.2v.2h.4v.2l.8.5v.2l-.3.2h-1v-.2h-.2l-.3-.2h-.2v-.2l-.2-.2-.2-.2h-.2v-.3h-.2v-.2h-.2v-.3h-.2v-.4h-.2zm11.8-5.4-.3 1-.4-.2h-.5l-.3-.2h-.5l-.5-.2h-5l-.5.2-.4.2h-.4l-.4.3-.4.3-.3.2v.2l-.4.2-.2.2v.3l-.3.2v1.6l.3.4.2.5-1 .5-.2-.5-.2-.6V215l.2-.6.2-.4.2-.4.3-.3.2-.4.3-.3.4-.3.4-.2.4-.2.5-.2h.5l.5-.3h1.1l.5-.2h3.3l.6.2h.5l.4.2.5.2h.3zm0 .5v-.5z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#fff",
                  d: "M458.8 124.5c3.4 0 6.2 2.7 6.2 6 0 3.5-2.8 6.3-6.2 6.3s-6-2.8-6-6.2a6 6 0 0 1 6-6z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "M465.5 130.6h-1c0-2-1.3-4.2-3.3-5a5.5 5.5 0 0 0-2.4-.6v-1a7 7 0 0 1 5.7 3 6.7 6.7 0 0 1 1 3.6m-6.7 6.7v-1c2 0 4-1.2 5-3a5.6 5.6 0 0 0 .6-2.7h1c0 2.3-1 4.5-3 5.7a6.6 6.6 0 0 1-3.6 1m-6.6-6.7h1c0 2 1.3 4.2 3.2 5a5.5 5.5 0 0 0 2.4.7v1a6.6 6.6 0 0 1-5.6-3.2 6.7 6.7 0 0 1-1-3.4zm6.6-6.6v1c-2 0-4 1.2-5 3a5.6 5.6 0 0 0-.6 2.6h-1c0-2.2 1.2-4.4 3.2-5.6a6.6 6.6 0 0 1 3.4-1"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#fff",
                  d: "M446.3 124.5a6 6 0 0 1 6 6c0 3.5-2.6 6.3-6 6.3s-6-2.8-6-6.2c0-3.4 2.6-6 6-6z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "M453 130.6h-1c0-2-1.3-4-3.2-5a5.5 5.5 0 0 0-2.5-.6v-1c2.3 0 4.5 1.2 5.6 3a6.7 6.7 0 0 1 1 3.6zm-6.7 6.7v-1c2 0 4-1.3 5-3a7 7 0 0 0 .6-2.7h1c0 2.3-1.3 4.5-3.2 5.7a6.6 6.6 0 0 1-3.5 1zm-6.6-6.7h1c0 2 1.2 4.2 3 5a5.5 5.5 0 0 0 2.6.7v1a6.5 6.5 0 0 1-5.6-3.2 6.7 6.7 0 0 1-1-3.4zm6.6-6.6v1c-2 0-4 1.2-5 3a5.6 5.6 0 0 0-.6 2.6h-1a7 7 0 0 1 3-5.6 6.6 6.6 0 0 1 3.6-1"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#fff",
                  d: "M433.8 125.5a6 6 0 0 1 6 6c0 3.5-2.6 6.3-6 6.3s-6-2.8-6-6.2 2.6-6 6-6z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "M440.4 131.6h-1c0-2-1.2-4-3-5a5.5 5.5 0 0 0-2.6-.6v-1a7 7 0 0 1 5.6 3 6.7 6.7 0 0 1 1 3.6m-6.6 6.7v-1c2 0 4-1.3 5-3a5.7 5.7 0 0 0 .6-2.7h1a7 7 0 0 1-3 5.7 6.6 6.6 0 0 1-3.6 1m-6.6-6.7h1c0 2.2 1.3 4.3 3.2 5.2a5.5 5.5 0 0 0 2.4.5v1a6.4 6.4 0 0 1-5.6-3.2 6.7 6.7 0 0 1-1-3.4zm6.6-6.6v1c-2 0-4 1.2-5 3a5.7 5.7 0 0 0-.6 2.6h-1c0-2.3 1.3-4.6 3.3-5.7a6.6 6.6 0 0 1 3.3-1z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#fff",
                  d: "M422.3 127.7c3.3 0 6 2.8 6 6.2 0 3.3-2.7 6-6 6s-6.2-2.7-6.2-6 3-6.3 6.3-6.3z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "M429 134h-1a6 6 0 0 0-3.3-5.2 5.5 5.5 0 0 0-2.4-.6v-1c2.2 0 4.4 1.2 5.6 3.2a6.7 6.7 0 0 1 1 3.5zm-6.7 6.5v-1c2 0 4-1.2 5-3 .4-1 .6-1.8.6-2.6h1c0 2-1.3 4.3-3.3 5.5a6.6 6.6 0 0 1-3.4 1zm-6.7-6.6h1c0 2 1.2 3.8 3 4.8a5 5 0 0 0 2.7.7v1a7 7 0 0 1-5.7-3 6.7 6.7 0 0 1-1-3.6zm6.7-6.8v1c-2 0-4.2 1.3-5 3.2a5.7 5.7 0 0 0-.7 2.5h-1c0-2.5 1.3-4.7 3.3-6a6.6 6.6 0 0 1 3.3-.8z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#fff",
                  d: "M346.3 159.4a6 6 0 0 1 6 6.2c0 3.4-2.6 6.2-6 6.2s-6-2.8-6-6.2a6 6 0 0 1 6-6.2"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "M353 165.6h-1c0-2-1.3-4-3.2-5a5.6 5.6 0 0 0-2.5-.7v-1c2.2 0 4.5 1 5.6 3a6.7 6.7 0 0 1 1 3.6zm-6.7 6.7v-1c2 0 4-1.2 5-3a7 7 0 0 0 .6-2.7h1c0 2.3-1.3 4.5-3.2 5.7a6.6 6.6 0 0 1-3.5 1zm-6.7-6.7h1c0 2 1.3 4.2 3.2 5a5.6 5.6 0 0 0 2.5.7v1a7 7 0 0 1-5.6-3 6.7 6.7 0 0 1-1-3.7zm6.7-6.7v1c-2 0-4 1.2-5 3a5.7 5.7 0 0 0-.6 2.6h-1a7 7 0 0 1 3-5.7 6.6 6.6 0 0 1 3.6-1z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#fff",
                  d: "M356.8 152.8c3.4 0 6.2 2.7 6.2 6 0 3.6-2.8 6.3-6.2 6.3-3.4 0-6-2.6-6-6a6 6 0 0 1 6-6.2z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "M363.5 159h-1c0-2.2-1.3-4.2-3-5a5.6 5.6 0 0 0-2.7-.7v-1a7 7 0 0 1 5.7 3 6.7 6.7 0 0 1 1 3.6zm-6.7 6.6v-1a5.7 5.7 0 0 0 5.7-5.7h1a7 7 0 0 1-3 5.6 6.6 6.6 0 0 1-3.7 1zm-6.6-6.7h1c0 2 1.2 4 3 5a5.6 5.6 0 0 0 2.6.6v1a7 7 0 0 1-5.6-3 6.7 6.7 0 0 1-1-3.7zm6.6-6.8v1c-2 0-4 1.3-5 3.2a5.7 5.7 0 0 0-.6 2.5h-1c0-2.3 1.2-4.6 3-5.8a6.6 6.6 0 0 1 3.6-1z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#fff",
                  d: "M368.8 147c3.4 0 6 3 6 6.3 0 3.4-2.6 6.2-6 6.2s-6-2.8-6-6.2a6 6 0 0 1 6-6.2z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "M375.4 153.3h-1c0-2-1.2-4.2-3-5a5.6 5.6 0 0 0-2.6-.7v-1a7 7 0 0 1 5.6 3 6.7 6.7 0 0 1 1 3.7m-6.6 6.7v-1c2 0 4-1.3 5-3a5.7 5.7 0 0 0 .6-2.7h1a7 7 0 0 1-3 5.7 6.6 6.6 0 0 1-3.6 1m-6.7-6.7h1c0 2 1.4 4 3.2 5a5.6 5.6 0 0 0 2.6.7v1a6.9 6.9 0 0 1-5.7-3.2 6.7 6.7 0 0 1-1-3.5zm6.8-6.7v1c-2 0-4 1.2-5 3a5.7 5.7 0 0 0-.6 2.7h-1c0-2.3 1-4.5 3-5.7a6.6 6.6 0 0 1 3.6-1"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#fff",
                  d: "M338.2 169.5a6 6 0 0 1 6 6.2c0 3.4-2.6 6.2-6 6.2s-6.2-3-6.2-6.3 2.8-6.2 6.2-6.2z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "M344.8 175.7h-1c0-2-1.3-4.2-3.2-5a5.6 5.6 0 0 0-2.4-.7v-1a7 7 0 0 1 5.6 3 6.7 6.7 0 0 1 1 3.7m-6.6 6.7v-1c2 0 4-1.3 5-3a5.7 5.7 0 0 0 .6-2.7h1c0 2.3-1.2 4.5-3.2 5.7a6.6 6.6 0 0 1-3.4 1m-6.7-6.7h1c0 2 1.2 4 3 5a5.6 5.6 0 0 0 2.7.7v1a6.9 6.9 0 0 1-5.7-3.2 6.7 6.7 0 0 1-1-3.5m6.7-6.7v1c-2 0-4 1.2-5 3a5.7 5.7 0 0 0-.7 2.7h-1c0-2.3 1.2-4.5 3.2-5.7a6.6 6.6 0 0 1 3.5-1"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#edb92e",
                  d: "m454.2 276.3-22 12.8-23.4-10 22-12.8z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "m431 266.7-22 12.8-.4-1 22-12.7h.5v1zm-.4-1h.5-.4zm23.5 11-23.3-10 .4-1 23.4 10v1h-.3zm.4-1 1 .5-1 .5zm-22.4 13 22-13 .5 1-22 12.8h-.5zm.5.8-.2.2h-.3zm-23.4-11 23.4 10-.4 1-23.3-10v-1h.4zm-.3 1-1-.4 1-.4v1z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#c6363c",
                  d: "M431 270.6c5.8-.3 10.5 2.5 10.8 6.3.2 3.7-4.2 7-9.8 7.4-5.7.3-10.4-2.5-10.7-6.3-.2-3.6 4.2-7 9.8-7.4z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "M442.3 277h-1v-.7l-.2-.3v-.6l-.3-.3v-.2l-.3-.2-.2-.3-.2-.3-.3-.2-.3-.3-.2-.2-.3-.2h-.5l-.3-.3-.3-.2-.5-.2-.4-.2h-.3l-.4-.2h-.4l-.5-.3h-.9l-.5-.2h-.8l-.5-.2h-1l-.5.2v-1h3.6l.4.2.5.2h.5l.4.2.5.2.5.2.4.2.3.2.4.2.4.2.4.2.4.3.3.3.4.3.3.3.3.3.2.4.2.3.2.3.2.4v.3l.3.4.2.4v.8zm-10.3 8v-1l.4-.2h.9l.5-.2h.4l.4-.2h.5l.4-.3h.5l.4-.2.4-.2.4-.2.3-.2.4-.2.4-.3.4-.2.3-.2.3-.3.3-.2.3-.3v-.3l.3-.3.2-.4.2-.2v-.3l.2-.2v-.6l.2-.3v-1.1l1-.2v1.6l-.2.4v.3l-.3.5v.3l-.3.4-.3.3v.3l-.4.4-.3.3-.3.3-.3.2-.3.3-.4.3-.4.2-.4.3-.4.3-.4.2-.4.2-.5.2h-.4l-.4.2-.5.2h-.4l-.5.2h-.4l-.5.2h-1zm-11.2-6.8h1v.5l.2.3v.3l.2.3.2.3v.2l.3.3.2.2v.3l.4.2.2.3.3.2.2.2.3.2.4.2.2.2h.4l.4.3h.4l.4.2.4.2h.4l.5.2h1l.4.2h2.3v1H428l-.5-.2h-.4l-.5-.3h-.6l-.4-.3h-.4l-.5-.3-.3-.2-.3-.3-.4-.2-.4-.2-.3-.3-.3-.2-.3-.3-.3-.3-.3-.3v-.3l-.3-.3-.2-.3-.2-.4-.2-.3v-1l-.2-.4zm10.3-8 .2 1h-1.5l-.5.2h-.5l-.5.2-.4.2h-.5l-.4.3-.5.2-.4.2-.3.2-.4.2-.3.2-.3.3-.4.2-.3.3-.3.2-.2.3-.3.2-.2.3-.2.3-.2.4-.2.3v.3l-.3.3v.8l-.2.3v.6l-1 .2V277l.2-.4v-.3l.2-.4v-.5l.3-.3.2-.4.3-.3.2-.3.3-.3.2-.4.4-.3.4-.3.3-.3.4-.3.5-.2.3-.3.5-.3.4-.2.4-.2.6-.2h.4l.5-.2h.5l.5-.3h.5l.5-.2zl.5-.2z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#edb92e",
                  d: "m382.4 270 23.8 9-19.7 13c-5-1.6-9-19-4-22z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "m406 279.4-23.8-9 .4-1 23.7 9v1zm.3-1 1 .4-1 .5v-1zm-20 13.3 19.6-13.2.4.8-19.6 13.3h-.4zm.5 1h-.4zm-4.2-23.3-.4 1h.5l-.4.2-.4.3-.4.4-.2.5-.2.4-.2.7-.2.8v1.5l-.2.8v2.8l.3.8v1l.2.8.2 1 .2 1 .3.7v1l.5 1 .3.7.3.7.5.8.4.6.3.6.4.6.4.5.5.4.4.2.3.3.4.2-.3 1-.6-.3-.5-.3-.5-.3-.5-.5-.4-.6-.6-.6-.4-.7-.4-.7-.4-.7-.4-1-.3-.8-.3-1-.3-.8-.4-1-.2-.8-.2-1-.2-1v-.8l-.3-1v-5.2l.3-.8.2-.7.3-.6.3-.6.4-.5.4-.5.5-.4h.6zm-.5 0h.6-.5zm.4.4.2-.4zm-.3-.4h.6-.5z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#0c4076",
                  d: "M382.8 274.3c5.7-.6 10.5 2 11 5.8.3 3.8-4 7.4-9.6 8-3.6.3-6-3-6.3-6.3-.5-3.4 1-7 4.8-7.4z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "M394.2 280h-1v-.5l-.2-.3v-.3l-.2-.4-.2-.3-.2-.2-.2-.2-.2-.3-.2-.2-.3-.3-.2-.2-.3-.2-.3-.2-.4-.2-.3-.2-.4-.2-.3-.2h-.4l-.5-.3h-.4l-.4-.2h-.8l-.5-.2h-3.6l-.2-1h3.8l.4.2h.5l.4.2.4.2h.4l.5.3.4.2h.5l.4.3.2.2.4.3.3.2.2.3.3.3.3.3.2.2.3.3.2.3.2.3v.5l.3.4v.2l.2.4v.4zm-10 8.4v-1h1l.5-.2h.4l.6-.2.5-.2h.5l.4-.3.4-.2h.4l.4-.3.3-.3.4-.2.2-.2.4-.3.3-.2.2-.3.3-.2.2-.3.3-.3.2-.3.2-.2.2-.3v-.4l.3-.3v-.8l.2-.4v-1h1v1.6l-.2.3v.3l-.2.4-.2.3-.2.4-.2.3-.2.4-.3.4-.2.3-.3.3-.3.3-.5.3-.3.3h-.4l-.4.4-.4.2-.4.3h-.4l-.4.3-.5.2h-.5l-.4.3-.5.2h-.6l-.5.2h-.7l-.5.2h-.5zm-6.8-6.7h1v.7l.2.3v.3l.2.4v.3l.2.2v.2l.2.3.2.2v.3l.3.2.2.3v.2l.2.2h.2l.2.3h.2l.2.3.2.2h.3l.2.2h.2l.2.2h.2l.3.2h1.4v1h-2.1l-.3-.2h-.4l-.3-.3-.3-.2-.3-.2-.3-.2-.2-.2-.3-.2-.3-.2-.2-.2-.3-.3-.2-.2v-.2l-.3-.3-.2-.3v-.2l-.3-.4v-.3l-.3-.3-.2-.3v-.3l-.2-.3v-.6l-.2-.3v-.3zm5.4-8v1h-.2l-.4.2h-.8l-.3.3-.3.2-.3.2-.2.2h-.2l-.2.2v.2l-.3.2v.3h-.3v.3l-.2.3-.2.2v.7l-.2.3v.4l-.2.3v2.2h-1V279l.2-.3v-.3l.2-.2v-.3l.2-.3.2-.3v-.4l.3-.3.2-.3.2-.2v-.3l.3-.2.3-.2h.2l.3-.3.4-.2.3-.2h.3l.3-.2h.7l.4-.2h.4z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#fff",
                  d: "M457.5 280.4c1.7 0 3.2 1.5 3.2 3.2 0 1.8-1.5 3.3-3.2 3.3-1.8 0-3.2-1.6-3.2-3.4 0-1.7 1.4-3.2 3.2-3.2z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "M461.2 283.6h-1v-.6l-.2-.2v-.2l-.2-.3v-.2h-.2v-.2h-.2v-.2h-.2l-.2-.2-.3-.2h-.2l-.2-.2h-.7v-1h1l.3.2.2.2h.2l.3.2v.2h.2v.2h.2v.3h.2v.2l.2.2v.2h.2v.2l.2.3v.5l.2.2v.2zm-3.7 3.8v-1h.4l.3-.2h.2l.2-.2h.2v-.2h.2v-.2h.2v-.2l.2-.2.2-.2v-.2l.2-.2v-1h1.2v.8l-.2.2v.3l-.2.2v.2l-.2.2-.2.3h-.2v.3h-.3l-.2.2-.3.2-.3.2h-.6v.2h-.6v.2h-.3zm-3.7-3.8h1v1h.2v.2l.2.2v.2l.2.2h.2v.2h.2v.2h.2l.2.2h.2v.2h1v1.2h-.7l-.2-.2h-.5v-.2h-.3l-.2-.2-.3-.2-.2-.2h-.2v-.3h-.2l-.2-.3-.2-.3v-.2l-.2-.3v-.3l-.2-.3zm3.7-3.7v1h-.9l-.2.2h-.2v.2h-.2v.2h-.2v.2h-.2v.2h-.2v.2l-.2.3v.5h-.2v.8h-1v-1.2l.2-.2v-.3h.2v-.3l.2-.2.2-.2v-.2h.4v-.2l.2-.2h.2v-.2h.5v-.2h.4v-.2h1z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#fff",
                  d: "M408.7 283c1.8 0 3.2 1.6 3.2 3.4 0 1.7-1.5 3.2-3.3 3.2a3.2 3.2 0 0 1-3.2-3.2c0-1.8 1.4-3.3 3.2-3.3z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "M412.4 286.4h-1v-.9l-.2-.2v-.2l-.2-.2v-.2l-.2-.2-.2-.2h-.2v-.2h-.2v-.2h-.4l-.2-.2h-.8v-1.2h.7v.2h.7v.2h.3v.2h.3v.2h.3l.2.2.2.3h.2l.2.3.2.3v.3h.2v.6l.2.2v.9zm-3.7 3.7v-1h1v-.2h.2l.2-.2h.2v-.2h.2v-.2h.2v-.2l.2-.2v-.3h.2v-.5l.2-.2v-.4h1v.8l-.2.2v.3l-.2.2v.3h-.2v.3h-.2l-.2.3h-.2v.2h-.3l-.2.2h-.2v.2h-.3v.2h-.5l-.2.2h-.8zm-3.7-3.6h1v.8h.2v.5h.2v.2h.2v.2h.2v.2h.2l.2.2h.2v.2h.5v.2h.7v1h-1.2v-.2h-.3v-.2h-.2l-.2-.2-.2-.2h-.2v-.2h-.2v-.3h-.3v-.3h-.2v-.3l-.2-.2v-.2l-.2-.3v-.8zm3.7-3.8v1h-.7v.2h-.5v.2h-.2l-.2.2v.2h-.2l-.2.2v.2l-.2.2v.2h-.2v.7l-.2.3v.4h-1v-1l.2-.2v-.3l.2-.3.2-.3v-.3h.3v-.3h.2l.2-.2.2-.2h.2v-.2h.6l.3-.2h.5l.3-.2h.2z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#fff",
                  d: "M407 268.3c1.8 0 3.2 1.4 3.2 3.2 0 1.8-1.4 3.2-3.2 3.2a3.2 3.2 0 0 1-3.2-3.2c0-1.8 1.4-3.2 3.2-3.2"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "M410.7 271.5h-1v-.7l-.2-.2v-.3l-.2-.2h-.2v-.4h-.2v-.2h-.2l-.2-.2h-.2l-.2-.2h-.5v-.2h-.4v-1h.8v.2h.3l.3.2h.2l.3.2h.2v.2l.3.2.2.2.3.3.2.3v.3h.2v.4l.2.2v1zm-3.7 3.7v-1h1v-.2h.2l.2-.2h.2v-.2h.2v-.2h.2v-.2l.2-.2.2-.2v-.4h.2v-1h1v1.2l-.2.2-.2.3v.3h-.2l-.2.3h-.2v.3h-.3v.2h-.2v.2h-.2l-.2.2h-.5l-.3.2h-.7zm-3.7-3.7h1v.8l.2.2v.4h.2v.2l.2.2v.2h.2v.2h.2v.2h.2l.2.2h.5l.2.2h.5v1h-.9l-.3-.2h-.2l-.3-.2-.3-.2h-.2l-.2-.2-.2-.3h-.3v-.3l-.2-.3v-.3h-.2v-.4l-.2-.2v-.8zm3.7-3.7v1h-.8v.2h-.5l-.2.2h-.2v.2h-.2v.2h-.2v.2h-.2v.2l-.2.2v.3l-.2.2v.7h-1v-1.2h.2v-.6h.2v-.3h.2v-.3h.3l.2-.2v-.2h.3v-.2h.3l.2-.2h.4v-.2h.5l.2-.2z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#fff",
                  d: "M457.3 266.2c1.8 0 3.2 1.4 3.2 3.2 0 1.8-1.4 3.2-3.2 3.2a3.2 3.2 0 0 1-3.2-3.2c0-1.8 1.6-3.2 3.3-3.2z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "M461 269.4h-1v-.8h-.2v-.3l-.2-.2v-.2h-.2v-.2h-.2v-.2l-.2-.2h-.2l-.2-.2h-.2l-.3-.2h-.7v-1h1.1l.2.2h.3l.3.2.3.2.2.3h.2v.2h.2v.2h.2v.3h.2v.3l.2.2v.5l.2.2zm-3.7 3.7v-1h1.2v-.2h.2l.2-.2.2-.2v-.2h.2v-.2h.2v-.2l.2-.2v-.5h.2v-.8h1v1.1l-.2.2v.2l-.2.2-.2.3-.2.3-.2.2-.2.2-.2.2h-.2v.2h-.3v.2h-.4l-.2.2h-1zm-3.7-3.6h1v.5l.2.2v.3l.2.2v.2h.2l.2.2v.2h.2v.2h.2l.3.2h.2l.2.2h.7v1h-1l-.3-.2h-.3l-.3-.2-.3-.2v-.2l-.3-.2-.2-.2v-.2h-.2v-.3h-.2v-.6l-.2-.2v-.7zv-.2zm3.7-3.7v1h-.7v.2h-.4l-.2.2h-.2v.2h-.2v.2l-.2.2-.2.2v.4h-.2v.8h-1.2v-.5l.2-.3v-.4l.2-.2v-.2h.2v-.3h.2v-.3h.2v-.2h.3v-.3l.3-.2.3-.2h.3l.2-.2z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#edb92e",
                  d: "M371 237.4c2.3-.8 6 4.6 7 4.5 1.2-3-1.2-10.5-5.5-16.3-3-1-3.2-3-3.8-7.3-.2-1.3-2.7-.4-2.7 2 0 2.3-.3 3.6.3 5.6.2.8 0 1.6-.8 2.3 4.5 1.8 5.6 4 5.4 9z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "m377.6 241.8 1 .3-.5.4h-.4l-.3-.2-.2-.2-.3-.3-.2-.2-.2-.2-.2-.2-.3-.3-.3-.2-.2-.2-.2-.3-.3-.2-.2-.2-.3-.2-.2-.3h-.3l-.3-.3h-.2l-.3-.3-.3-.2h-.2l-.3-.2h-.4l-.2-.2h-.4l-.4-1h1.3l.3.2h.3l.3.2.2.2h.3l.3.3.2.2h.3l.3.3.3.3v.2l.4.2.2.3.3.2v.2l.4.3.2.2.2.2.2.2.2.2.2.2h.2v.2h.3v.2zm1 .3-.2.4h-.3l.5-.3zm-6.3-15.8.4-1 .2.2.3.5.4.5.4.6.4.7.4.5.3.6.5.6.3.6.3.6.4.6.3.6.2.6.2.6.2.5.2.6.2.7.2.5v.6l.3.5v.6l.2.4v.5l.2.4v3.3l-.2.3-1-.2v-.3l.2-.3v-3.6l-.3-.5v-.4l-.2-.5-.2-.5-.2-.5v-.5l-.4-.6-.2-.7-.2-.5-.3-.6-.2-.6-.3-.5-.3-.5-.4-.6-.3-.7-.4-.5-.4-.6-.4-.6-.3-.5-.5-.5-.4-.5.3.2zm.4-1 .2.2-.3-.2zm-4.5-6.7h1v.7l.2.3v1l.2.3v.5l.2.3v.5l.2.2v.4h.2v.3l.2.2v.2h.2v.3h.2l.2.2v.2h.2l.2.2h.2l.2.2h.2l.2.2h.2l.3.2-.4 1h-.2l-.2-.2-.3-.2h-.2l-.2-.2h-.2l-.2-.3-.2-.2h-.2v-.2l-.3-.2-.2-.2-.2-.2v-.2l-.2-.2v-.2l-.2-.3v-.2l-.2-.2v-.3l-.2-.2v-.9l-.2-.3v-.6l-.2-.3V219l-.2-.5zm-1.7 1.8h-1v-1l.2-.2.2-.2v-.4h.2l.2-.3h.2l.2-.2.3-.2h.2l.2-.2h1.2v.2h.2v.3l.2.2v.2h-1.6v.2h-.2v.2h-.2v.2h-.2v.3l-.2.2v.8zm.3 5.6-1 .2v-.6l-.2-.2V224h-.2v-3.6h1v4.2l.2.2v.7l.2.2zm-1 2-.5.8v-1l.2-.2v-.2h.2v-.4h.2v-.4l-.2-.2v-.2l1-.3v1.8h-.2v.4h-.2v.2h-.2v.2l-.2.2h-.2zm-.5.8-.8-.3.7-.6v.8zm5 8.6h1zv-.5l.2-.5v-2l-.2-.3v-.7l-.2-.3v-.6l-.2-.3v-.2l-.2-.3-.2-.3v-.2l-.3-.3v-.2l-.3-.2-.2-.2-.3-.2-.2-.2-.3-.2h-.3l-.3-.3-.2-.2-.3-.2-.4-.2h-.3l-.4-.2.4-1 .4.2.5.2.4.2.3.2.3.2.4.2.3.2.3.2.3.2v.2l.4.3.2.3.3.3v.2l.3.3v.4l.3.3v.3l.3.3v.7l.2.3v.7l.2.4v2.9h-1zm1 0h-1l.5-.5.6.4zm-1 0v-.4h.5l-.4.4z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#edb92e",
                  d: "M368.8 218.5c-.4 1-.6 1.8-.7 3.4 0 1 .5 2 1.2 3 .8 1 1.8 2 3 2.6.8.5 1.6 1.7 2.3 3 .7 1.4 1.2 3 1.2 4 0 3.5.8 6.7 2.4 7.3 1.2.3 1.6.2 2.4 0-.2-.6 0-1.5-.7-2.4a8 8 0 0 1-1.4-3.7c0-1-.5-1.6-.2-3.3.4-1.2 1-1.6 1-2.7-.3-2-2-6-4.3-6s-3.4-.3-4.6-3.4c-.3-1-1-1.6-1.2-2z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "m368.6 222-1-.2v-1.2l.2-.2v-1h.2v-.7h.2v-.4l1 .3v.4h-.2v1l-.2.2v1.5zm1 2.8-.8.6v-.2h-.2v-.2l-.2-.2v-.2h-.2v-.4h-.2v-.5l-.2-.2v-.7l-.2-.2v-.7h1v1.1h.2v.7h.2v.4h.2v.4h.2v.2zv.2zm3 2.4-.6 1v-.2h-.4v-.2h-.2v-.2h-.2l-.2-.2h-.2v-.2h-.3v-.2h-.2l-.2-.2v-.2l-.2-.2h-.2v-.2h-.2v-.2h-.2v-.2l-.2-.2-.2-.2.8-.6.2.2.2.2v.2h.2l.2.2v.2h.2l.2.2.2.2h.2v.2h.2v.2h.3l.2.2.2.2h.2v.2zm2.4 3.2-1 .4v-.2l-.2-.2v-.2l-.2-.2v-.2h-.2v-.2l-.2-.2v-.2h-.2v-.2l-.2-.2-.2-.2v-.2h-.2l-.2-.2h-.2l.5-1h.2v.2h.2v.2h.2v.2l.2.2.2.2v.2h.2v.2h.2v.2l.2.2v.2l.2.2v.2h.2v.3h.2v.3h.2zm1.2 4.2h-1v-.8l-.2-.2v-.8h-.2v-.5h-.2v-.4h-.2v-.5h-.2v-.2l-.2-.2 1-.4v.4h.2v.4h.2v.5l.2.2v.3h.2v.6h.2v1h.2zm2 6.8-.3 1h-.3l-.2-.2-.3-.3v-.2l-.3-.2h-.2l-.2-.3v-.2h-.2v-.3l-.2-.2v-.3l-.2-.2v-.3l-.2-.2v-.5l-.2-.3v-.8l-.2-.3V236l-.2-.3v-1.5h1v2.1l.2.3v1.4l.2.2v.8l.2.2v.2l.2.2v.4l.2.2v.2l.2.2.2.2v.2h.2v.2h.2l.2.2zm1.7.8 1-.3-.5.5h-.4v.2h-1.4l-.2-.2h-.4l.3-1h.7v.2h1.2v-.2zm1-.3v.4h-.5l.4-.5zm-1.7-2 .8-.7h.2v.4h.2v.4h.2v.8l.2.2v1l-1 .4V241l-.2-.2v-.8h-.2v-.2zm-1.5-4h1v.8h.2v.8l.2.2v.2l.2.2v.2h.2v.5h.2v.2h.2v.2l-.7.7v-.2l-.2-.2v-.4h-.2v-.5h-.2v-.2l-.2-.3v-.2l-.2-.2v-.2l-.2-.3v-.4l-.2-.2v-.5zm-.2-3.4 1 .2v3l.2.2-1 .2v-.8l-.2-.2zm1-2.5h1v.7h-.2v.6l-.2.2v.2l-.2.2v.2h-.2v.6h-.2v.2l-1-.2v-.4h.2v-.4l.2-.2v-.2l.2-.2v-.2l.2-.2v-.9zm-4-5.5v-1h1.1l.3.2h.2l.2.2h.3l.2.2.2.2v.2l.3.2v.2l.3.2.2.3v.2l.3.3.2.2.2.3v.2l.2.3v.2l.2.3v.3l.2.2v.3l.2.2v.5l.2.3v.8h-1v-1l-.2-.2v-.4l-.2-.3-.2-.4v-.2l-.2-.2v-.3l-.3-.3v-.2l-.2-.2v-.3l-.2-.2-.3-.3-.2-.2-.3-.3-.3-.2-.3-.2h-.8zm-5-3.7 1-.4v.3l.2.3v.2l.2.2v.2l.2.2v.2l.2.2.2.2v.2h.2v.2h.2v.2h.4v.2h.7v.2h1.7v1H373l-.3-.2h-.4v-.2h-.3v-.2h-.3v-.3h-.3v-.2l-.2-.2-.2-.3-.2-.2v-.2l-.2-.2-.2-.4-.2-.2v-.3l-.2-.2zm-.4-2-1-.5h1.2v.4h.2v.2h.2v.2h.2v.4h.2v.2l.2.2v.2l.2.2-1 .4v-.2l-.2-.2v-.2l-.2-.2v-.2h-.2v-.2l-.2-.2v-.2h-.2v-.2h-.2v-.2zm-1-.5.5-1 .5 1zm.6.2.4.2zm-.5-.2.4-1 .5 1z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#edb92e",
                  d: "m360 227 2-1a6 6 0 0 1 4-.2c5.5 1.7 8 11.6 1.8 14-1.2.2-2.3-1-3.4-3.3a20.5 20.5 0 0 0-4-6.8c-1-1-1-2-.4-2.6z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "m362 225.5.3 1h-.4v.2h-.4v.2h-.8v.2h-.2l-.2.2-.7-.7.2-.2v-.2h.4v-.2h.8v-.2h.4v-.2h.4zm4-.2-.2 1h-.5v-.2h-2.1v.2h-.7l-.2.2-.5-1h.4l.3-.2h.8v-.2h1.6l.2.2h.4zm2 15-.2-1h-.2l.5-.2h.6l.4-.4.4-.3.3-.4.3-.5.2-.4.2-.3.2-.5v-.5l.2-.5V232l-.3-.4-.2-.5-.2-.5v-.5l-.4-.4-.2-.5-.4-.3-.3-.5-.4-.3-.3-.5-.4-.3-.5-.3-.3-.4-.5-.2h-.4l.2-1h.6l.5.3.7.3.4.4.6.3.5.4.5.6.3.4.4.5.3.5.3.6.3.5.3.7.2.6v.6l.3.5v3.4l-.2.5-.2.6-.3.6-.2.5-.3.5-.4.5-.4.4-.4.3-.6.3-.6.3zm-4-3.6 1-.4v.4l.2.2.2.3.2.3v.2h.2v.5h.2v.2l.2.2.2.2h.2v.2h.2l.2.2h.8v1.2h-.8v-.2h-.5l-.2-.2-.2-.2-.2-.2-.2-.2v-.2h-.2l-.2-.2v-.2h-.2v-.3l-.2-.2v-.2h-.2v-.2l-.2-.2v-.2l-.2-.3-.3-.3zm-4-6.6.7-.6.2.2v.2h.2l.2.3v.3h.2l.2.3v.2l.2.2h.2v.3l.3.2v.2l.2.2.2.2v.4l.2.2.2.3v.3l.2.2.2.3v.3l.2.3v.3l.3.3.2.4v.3l.3.3v.3l-1 .4v-.6l-.2-.2v-.3l-.3-.2v-.3l-.2-.2v-.5l-.3-.3v-.2l-.2-.2v-.3l-.3-.2-.2-.3v-.2l-.3-.2v-.2h-.2v-.3h-.3v-.3l-.2-.2-.3-.3v-.2l-.2-.2h-.2v-.2l-.2-.2zm0-3.4v1l.3-.2v.2h-.2v.8h.2v.4l.2.2.2.2v.2l-.7.7h-.2v-.2l-.2-.2-.2-.2v-.3h-.2V227h.2v-.2h.2zm-.4 0h.4zm.4 1v-1l.3 1zm.3 0h-.2.3z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#edb92e",
                  d: "M362.8 227.7c5.4-2 9.4 8.3 4.3 10.2-2.6 1-2.8-2.4-3.4-4.3-.7-2.5-6-4-.8-6z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "m367.3 238.4-.4-1h.3l.3-.3.3-.2.2-.3.2-.3.2-.3v-.5l.2-.4v-2.7l-.2-.4-.2-.5-.2-.4-.2-.4-.3-.4-.3-.4-.2-.3-.4-.4-.3-.2-.3-.2-.4-.2-.4-.2h-.4l-.3-.2h-1.3l-.4.2-.4-1h.6l.5-.2h1.6l.5.3.5.2.4.2.4.4.5.4.4.4.3.4.3.5.2.4.3.6.3.5.2.6.2.6v.5l.2.5v1.6l-.2.5v.5l-.3.5-.2.4-.3.5-.4.3-.4.4-.4.2-.5.2zM363 234l1-.4.2.2v.6l.2.2v.8l.2.2v.4l.2.2v.2l.2.3.2.3v.2h.2v.2h.2l.2.2h1.2l.3.8h-.3l-.3.2h-1.2l-.2-.2h-.2v-.2l-.3-.2-.3-.3v-.2l-.2-.2v-.2h-.2v-.3l-.2-.2v-.4h-.2v-.8l-.2-.2v-.8l-.2-.2v-.2zm-.4-6.7.4 1h-.5l-.3.3h-.4l-.2.3h-.2l-.2.2v.2h-.2v.4h.2v.3l.2.2v.2h.3v.3l.3.2h.2l.2.2.2.2.2.2.2.2.2.3.2.3.2.2v.3l.3.2v.6l-1 .3v-.7l-.2-.2h-.2v-.3l-.3-.2h-.2v-.3l-.3-.2-.2-.2-.2-.2-.2-.2v-.2l-.2-.2h-.2v-.3l-.3-.3v-.2l-.2-.2v-.8l.2-.3v-.3l.3-.2.2-.2.3-.3.3-.2h.4l.4-.3.6-.2z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#0c4076",
                  d: "M363.4 229.3c2.6-1 6.2 5 3 6.5-2.3 1-4-.3-4.8-2-.7-2 0-3.8 1.7-4.5z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "m366.5 236.3-.4-1h.3l.2-.2h.2v-.2l.2-.2v-2l-.2-.3v-.3h-.2v-.4l-.3-.3-.2-.2-.3-.4-.2-.2-.2-.2h-.2v-.2l-.3-.2h-1.1l-.3-1h1.5l.4.3.3.2.2.3.2.2.3.2.2.2.2.3v.3l.3.3.2.4.2.3v.4l.2.4v2.6l-.2.3-.2.4-.2.3-.2.2h-.4l-.3.3zm-5.4-2.5 1-.3.2.3.2.3v.2l.2.3.2.2.2.2h.3v.2h.2l.3.2h.4v.2h1.3l.3-.2.5 1h-.7l-.2.2h-1.9l-.2-.2h-.2v-.2h-.3l-.2-.2-.3-.2-.3-.3-.3-.3h-.2v-.3l-.2-.3-.2-.3v-.2zv-.2zm2.2-5 .3 1h-.3l-.2.2-.2.2-.2.2-.2.2-.2.2v.2h-.2v.7l-.2.2v1.1l.2.2v.3l-1 .3v-.7l-.2-.3v-1.5l.2-.2v-.3l.2-.2.2-.3.2-.3v-.2l.3-.2v-.2h.3l.2-.2.3-.2h.2zm.2.5-.2-.5z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#fff",
                  d: "M400 179.7c3.6 0 6.4 2.8 6.4 6.4 0 3.6-2.8 6.5-6.3 6.5s-6.3-3-6.3-6.4 3-6.3 6.4-6.3z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "M407 186h-1c0-2-1.4-4.3-3.3-5.2a5.8 5.8 0 0 0-2.6-.6v-1c2.4 0 4.7 1.2 6 3.2a7 7 0 0 1 1 3.7zm-7 7v-1a6 6 0 0 0 5.3-3.3 6 6 0 0 0 .6-2.6h1c0 2.4-1.3 4.7-3.3 6a6.8 6.8 0 0 1-3.6 1zm-6.8-7h1a6 6 0 0 0 3.3 5.4 5.8 5.8 0 0 0 2.6.6v1a6.8 6.8 0 0 1-5.7-3.3 7 7 0 0 1-1-3.6zm7-7v1.2a5.9 5.9 0 0 0-5.3 3.2 6 6 0 0 0-.8 2.7h-1a7 7 0 0 1 3.3-5.8 6.8 6.8 0 0 1 3.6-1z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#fff",
                  d: "M395.4 169c3.5 0 6.4 3 6.4 6.4 0 3.6-3 6.4-6.4 6.4s-6.3-2.8-6.3-6.4c0-3.5 3-6.4 6.4-6.4z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "M402.3 175.4h-1c0-2.2-1.3-4.3-3.2-5.3a5.8 5.8 0 0 0-2.6-.5v-1c2.4 0 4.6 1.3 6 3.2a7 7 0 0 1 1 3.7zm-7 7v-1c2.3 0 4.4-1.4 5.4-3.3a6 6 0 0 0 .6-2.6h1c0 2.4-1.2 4.7-3.2 6a6.8 6.8 0 0 1-3.6 1zm-6.7-7h1a6 6 0 0 0 3.2 5.3c.8.4 1.7.6 2.6.6v1a6.8 6.8 0 0 1-5.8-3.2 7 7 0 0 1-1-3.6zm6.8-7v1c-2 0-4.2 1.4-5.2 3.3a6 6 0 0 0-.6 2.7h-1c0-2.3 1.2-4.6 3.2-6a7 7 0 0 1 3.6-1"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#fff",
                  d: "M410.7 131.5c3.4 0 6 2.7 6 6s-2.6 6.3-6 6.3-6.2-2.7-6.2-6.2a6 6 0 0 1 6.2-6z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "M417.3 137.7h-1c0-2.2-1.2-4.2-3-5a5.6 5.6 0 0 0-2.6-.7v-1a7 7 0 0 1 5.6 3 6.7 6.7 0 0 1 1 3.7m-6.6 6.6v-1c2 0 4-1.2 5-3 .4-1 .6-1.8.6-2.6h1c0 2.2-1.2 4.5-3 5.6a6.6 6.6 0 0 1-3.6 1m-6.7-6.7h1c0 2.2 1.3 4.2 3.2 5a5.6 5.6 0 0 0 2.5.7v1a6.6 6.6 0 0 1-5.6-3 6.7 6.7 0 0 1-1-3.6zm6.7-6.6v1c-2 0-4 1.2-5 3a5.7 5.7 0 0 0-.7 2.6h-1a7 7 0 0 1 3-5.6 6.6 6.6 0 0 1 3.7-1"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#fff",
                  d: "M400.4 136.2c3.5 0 6.3 3 6.3 6.4 0 3.5-2.8 6.4-6.3 6.4s-6.4-3-6.4-6.4c0-3.5 2.8-6.4 6.4-6.4"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "M407.2 142.6h-1a6 6 0 0 0-3.3-5.3 5.8 5.8 0 0 0-2.6-.6v-1c2.3 0 4.6 1.2 5.8 3.2a7 7 0 0 1 1 3.6zm-6.8 7v-1c2 0 4.2-1.4 5.2-3.3a6 6 0 0 0 .6-2.7h1c0 2.3-1.2 4.7-3.2 6a6.8 6.8 0 0 1-3.6 1m-7-7h1c0 2.2 1.4 4.3 3.3 5.3a5.8 5.8 0 0 0 2.7.5v1a7.2 7.2 0 0 1-6-3.2 7 7 0 0 1-1-3.7zm7-7v1a6.2 6.2 0 0 0-5.3 3.3 6 6 0 0 0-.5 2.6h-1c0-2.4 1.2-4.7 3.2-6a6.8 6.8 0 0 1 3.7-1z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#fff",
                  d: "M392.8 145.3c3.5 0 6.3 2.8 6.3 6.4 0 3.5-2.7 6.4-6.2 6.4s-6.4-2.8-6.4-6.3c0-3.6 3-6.4 6.4-6.4z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "M399.6 151.7h-1a6 6 0 0 0-3.2-5.3 5.8 5.8 0 0 0-2.6-.6v-1c2.3 0 4.6 1.2 5.8 3.2a7 7 0 0 1 1 3.7m-6.8 7v-1c2 0 4.2-1.4 5.2-3.4a6 6 0 0 0 .6-2.6h1c0 2.3-1.2 4.6-3.2 6a6.8 6.8 0 0 1-3.6 1m-7-7h1c0 2 1.4 4.3 3.3 5.2a5.8 5.8 0 0 0 2.8.6v1a7.4 7.4 0 0 1-6-3.3 7 7 0 0 1-1-3.6zm7-7v1a6 6 0 0 0-5.3 3.3 6 6 0 0 0-.6 2.7h-1c0-2.4 1-4.7 3.2-6a7 7 0 0 1 3.6-1z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#fff",
                  d: "M391.5 156.7c3.6 0 6.4 2.8 6.4 6.4s-3 6.5-6.5 6.5-6.3-3-6.3-6.4 2.8-6.3 6.3-6.3z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "M398.4 163h-1c0-2-1.3-4.2-3.2-5.2a5.8 5.8 0 0 0-2.7-.6v-1c2.4 0 4.7 1.2 6 3.2a7 7 0 0 1 1 3.7zm-7 7v-1a6 6 0 0 0 5.4-3.3 6 6 0 0 0 .6-2.6h1c0 2.5-1.3 5-3.4 6a6.8 6.8 0 0 1-3.5 1zm-6.7-7h1c0 2.3 1.3 4.4 3.2 5.4.7.4 1.6.6 2.5.6v1a7 7 0 0 1-5.8-3.2 7 7 0 0 1-1-3.7zm6.8-6.8v1c-2 0-4.2 1.3-5.2 3.2a6 6 0 0 0-.6 2.7h-1c0-2.3 1.2-4.6 3.2-5.8a7 7 0 0 1 3.5-1z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#edb92e",
                  d: "M474.4 198c-2.7-5-5.6-8.2-8.6-9.6 4.2-13.2 5.2-30.2 2.7-51-.2-3.3-1-4.6-2.2-4.6-1 0-1.7 1.6-1.8 5.2.8 11.6 1.7 21.6 1.2 30.2-.5 7.6-2.3 14-4.2 21.2-.3 1 .4 1.7 3.8 3.7 2.6 1.5 4.2 3.3 4.7 5 .7-.2 1.2 0 1.5 0 2.5.8 3.6.6 3 0z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "m465.3 188.2 1 .3-.3-.6h.3l.3.2.3.2.2.2h.3l.3.3h.3l.4.4.2.2.3.2.2.3.3.3.3.3.3.3.3.2.3.3.3.3.2.3.2.5.3.3.3.4.2.3.3.4.3.3.2.4.3.4.3.5.2.5.3.4.3.4.3.5.3.5-1 .5-.3-.5-.2-.4-.3-.5-.2-.5-.3-.4-.3-.3-.2-.4-.3-.4-.3-.5-.3-.4-.2-.2-.3-.4-.4-.3-.2-.2-.3-.3v-.3l-.4-.3-.3-.4-.2-.3-.2-.2-.3-.2-.2-.2-.3-.2-.3-.2-.2-.2-.3-.2-.3-.2-.3-.2h-.3l-.3-.3-.4-.2-.3-.6zm.3.6h-.4v-.6zm2.4-51.5h1l.2 2 .2 1.8.2 2 .2 2v1.8l.2 1.8v1.8l.2 1.8v15l-.3 1.5-.2 1.5v1.5l-.3 1.5-.2 1.5-.2 1.4-.2 1.5-.2 1.3-.3 1.4-.3 1.3-.3 1.4-.3 1.3-.4 1.3-.3 1.3-.4 1.2-1-.3.4-1.2.4-1.3.4-1.3.3-1.3.3-1.2.3-1.3.3-1.4.2-1.3.3-1.4.3-1.5.2-1.4V172l.3-1.6V169l.2-1.7v-1.6l.2-1.6v-13.6l-.2-1.8v-2l-.2-1.7-.2-2-.2-1.8-.2-2-.2-2zm-1.7-4v-1h.6v.2h.3v.2h.2l.2.3h.2v.5h.2v.3l.2.2v.3l.2.2v.4l.2.4v.9l.2.3v.4h-1v-.9l-.2-.2v-.6l-.2-.2v-.5h-.2v-.5h-.2v-.2l-.2-.2h-.2v-.2h-.4zM465 138h-1v-1.7l.2-.3v-1l.2-.3v-.7h.2v-.3l.2-.3v-.3h.2l.2-.2.3-.2.2-.2h.5v1h-.2v.2h-.2v.2l-.2.2v.3l-.2.3v.6l-.2.2v1.6l-.2.4v.7zm1.2 30.2h-1V154l-.2-1v-2.8l-.2-1v-2l-.2-1v-1l-.2-1v-2l-.2-1V139l-.2-1 1-.2v1l.2 1.2v2l.2 1v2.2l.2 1v2l.2 1v2l.2 1v2.8l.2 1v12zm-4.3 21.3-1-.3.2-.6v-.7l.3-.8.2-.6.2-.7v-.7l.2-.7.2-.6.2-.7v-.6l.3-.6v-.6l.2-.6.2-.7v-.5l.2-.6.2-.8v-.6l.2-.7.2-.7v-.7l.2-.6v-.7l.2-.6v-.7l.2-.7v-.7l.2-.6V169l.2-.8h1v1.5l-.2.7v1.5l-.2.6v.7l-.2.8v.7l-.2.6v.8l-.2.7-.2.6v.8l-.2.6-.2.7v.7l-.3.7v.6l-.3.7v.6l-.3.6-.2.6v.6l-.3.7-.2.5-.2.7v.6l-.3.7-.2.7-.2.6v.7zm3.6 3-.5 1-.2-.2h-.3l-.3-.3-.3-.2h-.4l-.2-.3h-.2l-.3-.3h-.3v-.2l-.3-.2h-.2l-.2-.2-.2-.3h-.2v-.2h-.2l-.2-.2v-.2l-.2-.2v-1l1 .2v.5h.2v.2l.2.2h.2v.2h.2l.2.2.3.3h.2l.2.2.2.2h.2l.2.3h.3l.3.3.3.2h.3zm4.2 5.2.4 1-.7-.4v-.2l-.2-.2v-.3l-.2-.2v-.3l-.2-.3-.3-.3-.2-.3-.3-.2-.3-.3v-.2h-.3v-.2h-.3v-.2l-.3-.2h-.2v-.3h-.3l-.2-.2h-.3l-.2-.2-.2-.2h-.2l.6-1 .2.2h.2l.3.3.2.2.2.2h.2v.3h.4l.2.3.3.3.3.3.2.2.3.3v.3l.3.2h.2v.3l.3.2v.2h.2v.3l.2.2v.2l.2.3v.3l.2.2v.2l-.6-.3zm.4 1h-.5l-.2-.4zm1.4-1.2-.3 1h-1l-.4-.8h.2l.2-.2zm3.3.5h-1l.7-.4.2.2v.8l-.2.2h-.2v.2h-1.8l-.2-.2h-.3l-.2-.2h-.5l.3-1h.7l.2.2h1v.2h.7v.4zm-1 0v-1l.7.6-.8.4zm0 0h1l-1 .3z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#edb92e",
                  d: "M458.4 214.6c1.6-1 2-.8 2.4-1.4.6-.8.6-2.2.4-3.5-.8-5.3 2.4-4.6 6-2.2 1.7 1 3.5 4 5 5.3s2.8 1.5 3.2 2v9.2c-.4.6-1.7.7-3.2 2-1.5 1.5-3.3 4.2-5 5.4-3.6 2.3-6.8 3-6-2.2.2-1.3.2-2.7-.4-3.5-.5-.7-.8-.4-2.4-1.4a7 7 0 0 1-2.3-2.2c-.4-.8 0-1.7 0-2.6 0-1-.4-1.8 0-2.6.6-.8 1.4-1.6 2.4-2.2z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "m460.4 213 .8.5-.2.2-.2.2h-.4v.2h-.4l-.2.2h-.2l-.2.2h-.2v.2h-.5v.2l-.7-1h.6v-.2h.2l.2-.2h.2l.2-.2h.4v-.2h.4v-.2h.2zm.3-3.2 1-.2v2.9l-.2.3v.2h-.2v.2l-1-.5v-.2h.2v-.4h.2v-2.6zm6.7-2.8-.6 1-.3-.3-.3-.2-.3-.2-.4-.2h-.3l-.3-.2h-.3l-.3-.2h-.3v-.2h-.4l-.2-.2h-1.1v.2h-.2v.2l-.2.2v.6l-.2.3v2l-1 .2v-3l.2-.4v-.3l.3-.2.3-.2.2-.2h.2l.2-.2h.2l.2-.2h1.5v.2h.5l.3.2h.3l.4.3h.3l.3.2.4.2.3.2.3.2zm5 5.4-.6.7-.3-.2-.3-.3-.3-.3-.2-.2-.2-.2-.3-.3-.2-.2v-.2h-.2v-.3l-.3-.2-.3-.3-.2-.2v-.2l-.3-.2v-.2h-.3l-.2-.3-.3-.2-.2-.2h-.2l-.2-.2v-.2h-.3v-.2h-.2l.6-1 .2.2.3.2v.2h.3v.3h.3l.2.2.2.2v.2l.3.2h.2v.3l.3.3.2.2v.2l.3.2.3.3h.2v.3l.3.2.2.2.2.2.3.3v.2h.3v.3h.3v.3h.2zm3.5 2.4h-1.2v.3h-.2l-.2-.2h-.2v-.2h-.4l-.2-.2h-.2v-.2h-.3v-.2h-.3v-.2l-.3-.2-.3-.2-.2-.3.7-.6h.2v.2h.2v.2h.2v.2h.2v.2h.3l.2.2.2.2h.2l.2.2h.2l.2.2h.2v.2h.4v.2l.2.2v.2zm-.2-.2v.2zm0 4.8h-1v-4.5l1-.2v4.5zm-1 0h1zm1 5-1-.7v.3-4.4h1zm0-.4v.2zm-3.3 2.5-.7-.8h.2v-.2l.3-.2.3-.2h.3v-.2h.3v-.2h.2l.2-.2h.2v-.2h.4v-.2h.4v-.2l1 .5-.2.2-.2.2h-.2v.2h-.4l-.2.2h-.2v.2h-.4v.2h-.3v.2h-.2l-.2.2-.2.2v.2h-.3zm-5 5.3-.7-.8h.2v-.2l.3-.2.3-.2.2-.2.3-.3.2-.2.2-.2.2-.2v-.2h.3v-.3l.2-.3.2-.2v-.2l.3-.2.3-.2v-.2l.3-.2.2-.2v-.2h.3v-.3l.3-.2.2-.2h.2v-.3h.3v-.3l.8.8-.2.2-.2.2-.2.2v.2h-.3v.3l-.3.2-.3.2-.2.2-.2.2-.2.2v.2l-.3.2v.2l-.2.2h-.2v.3h-.3l-.2.3v.2h-.2l-.2.3-.2.2-.3.3-.3.3-.3.2zm-6.8-2.7 1 .3v2.6l.2.2v.2h.2v.2h1.7v-.2h.4l.3-.2h.3l.3-.3.3-.3h.3l.2-.3.3-.2.3-.2.6.8-.4.2-.3.3-.3.2h-.4l-.3.3-.3.2h-.3l-.2.3h-.4l-.3.2h-.4l-.3.2h-.9l-.3-.2h-.3l-.2-.3-.2-.2-.2-.2v-.3l-.2-.2v-.7l-.2-.3zm-.3-3 .8-.6v.2h.2v.4h.2v.6l.2.2v2.4l-1-.2v-2.5h-.2v-.4h-.2zm-2.3-1.3.7-.8h.2l.2.2h.2l.2.2h.2l.2.2h.4v.2h.2v.2h.2l.2.2.2.2-.8.6-.2-.2h-.2v-.2h-.4l-.2-.2h-.4v-.2h-.2l-.2-.2h-.2v-.2zm.7-.8.5.2zm-3-1.7.8-.5.2.2v.2h.2v.4h.2v.2h.2v.2h.2v.2h.2l.2.2.2.2h.2v.2h.2l-.5 1v-.2h-.2l-.2-.2-.2-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2l-.2-.2-.2-.2v-.2zm-.3-3h1v2.4l-.7.5v-.2h-.2v-.4l-.2-.2v-2.1zm.3-2.8.8.6v.4l-.2.2v1.8h-1V217h.2v-.4zm2.4-2.4.7 1h-.2v.2h-.2l-.2.2-.2.2-.2.2-.2.2-.2.2-.2.2v.2h-.2v.2h-.2v.2l-1-.5h.2v-.2l.2-.2.2-.2v-.2h.2l.2-.2v-.2h.2v-.2h.2l.2-.2h.2v-.2l.2-.2h.2v-.2h.2zm.7 1 .5-.3z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "M475.5 220.2v1c-4 .4-7 2-9.7 4.3 1.8-2.7 5.7-4.7 9.7-5.3m0-1.6v-.8c-4-.5-7-2-9.7-4.4 1.8 2.7 5.7 4.6 9.7 5.2"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#edb92e",
                  d: "M461.2 207.3c1 .4 2.3 1 3.4 2 1.6 1.5.6 4-1.5 6.6-.6.7-1 2-1 3.5 0 1.3.5 2.7 1 3.5 2.2 2.5 3.2 5 1.6 6.6-1 1-2.3 1.5-3.4 2v-2.4c.2-1.3.2-2.7-.4-3.5-.5-.7-.8-.4-2.4-1.4a7 7 0 0 1-2.3-2.2c-.4-.8 0-1.7 0-2.6 0-1-.4-1.8 0-2.6.6-.8 1.4-1.6 2.4-2.2 1.6-1 2-.8 2.4-1.4.6-.8.6-2.2.4-3.5v-2.4z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "m465 209-.8.6-.2-.2-.2-.2h-.2v-.2h-.2l-.2-.2h-.2v-.2h-.4v-.2h-.5v-.2h-.2l-.2-.2h-.2l-.2-.2h-.2l.4-1h.2l.2.2h.2l.2.2h.3l.2.2h.2v.2h.3l.2.2h.2v.2h.3v.2h.2l.2.2.2.2.2.2zm-1.5 7.2-.8-.6.2-.3v-.2h.2l.2-.3.2-.3v-.2l.3-.2v-.5l.2-.2v-.2h.2v-.3l.2-.2v-.4h.2v-1.6l-.2-.3-.2-.2-.2-.2.7-.7.3.3v.2l.2.2v.2h.2v.5l.2.2v1l-.2.2v.4l-.2.2v.5l-.2.3v.3l-.3.2v.5l-.3.2v.3l-.3.2-.2.3v.2l-.3.2-.3.3-.2.2zm-1 3.3h-1v-.7l.2-.2v-1.2h.2v-1h.2v-.4l.2-.2v-.2h.2v-.2l1 .6h-.2v.4h-.2v.2l-.2.2v.9h-.2v1.4h-.2v.5zm1 3.2-.8.6v-.2h-.2v-.2h-.2v-.4h-.2v-1.1l-.2-.3V220h-.2v-.5h1v1.1l.2.2v.4l.2.2v.4l.2.2v.2h.2v.2zm1.5 7.3-.8-.8h.2v-.2h.2v-.3l.2-.2v-1.9l-.2-.2v-.2l-.2-.2v-.2l-.2-.3v-.2l-.2-.2-.3-.3v-.3l-.3-.2-.2-.2v-.2l-.3-.3-.3-.2.8-.6.2.2h.2v.4l.2.2.2.3h.2v.3l.3.3v.5l.3.3v.3l.2.2v.5l.2.2v.5l.2.2v.7l-.2.4v.4l-.2.2v.2l-.2.2v.2l-.3.2v.2zm-4.3 1.7 1-.2-.7-.4h.7v-.2h.4l.2-.2h.2l.2-.2h.2v-.2h.4v-.2h.2l.2-.2.2-.2h.2v-.2h.2v-.2l.8.8h-.2v.2h-.2v.2h-.2l-.2.2-.2.2h-.2l-.2.2h-.2v.2h-.4v.2h-.4v.2h-.5v.2h-.2l-.2.2h-.2l-.7-.3zm.7.4-.6.3v-.6l.6.4zm-.7-3 1 .3v2l-1 .3v-2.4zm-.3-3 .8-.6v.2h.2v.4h.2v.6l.2.2v2.4l-1-.2v-2.4h-.2v-.4h-.2zm-2.3-1.3.7-.8h.2l.2.2h.2l.2.2h.2l.2.2h.4v.2h.2l.2.2.2.2.2.2-.8.6-.2-.2h-.2v-.2h-.4l-.2-.2h-.4v-.2h-.2l-.2-.2h-.2v-.2zm0 0-.3-.2zm-2.3-2.4.8-.5.2.2v.2h.2v.4h.2v.2h.2v.2h.2v.2h.2l.2.2h.2v.2h.2v.2h.2l-.5 1v-.2h-.2l-.2-.2-.2-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2l-.2-.2-.2-.2v-.2zm0 0 .3.5zm-.3-3h1v2.4l-.7.5v-.2h-.2v-.4l-.2-.2v-2.2zm.3-2.8.8.6v.4l-.2.2v1.8h-1V217h.2v-.4zm2.4-2.4.7 1h-.2v.2h-.2l-.2.2-.2.2-.2.2-.2.2-.2.2-.2.2v.2h-.2v.2h-.2v.2l-1-.5h.2v-.2l.2-.2.2-.2v-.2h.2l.2-.2v-.2h.2v-.2h.2l.2-.2h.2v-.2h.2v-.2h.2v-.2h.2zm2.4-1 .8.5-.2.2-.2.2h-.4v.2h-.4l-.2.2h-.2l-.2.2h-.2v.2h-.5v.2l-.7-1h.6v-.2h.2l.2-.2h.2l.2-.2h.4v-.2h.4v-.2h.2zm.3-3.2 1-.2v2.9l-.2.2v.2h-.2v.2l-1-.5v-.2h.2v-.4h.2zm.5-2v-1l.5.6v2.1l-1 .2V207l.5.6zm0-1h.6v.6zm0 0v1h-.2zM361 226.3l.7-.3c-1.6-2.2-2-4.2-1.3-6.3-1.3 1.6-1 4.2.6 6.6"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#edb92e",
                  d: "M410.7 200c1.4 1.6 1.2 2 2 2.5 1 .6 2 .4 3.3 0 5-2 5 2 3.5 6.4-.7 2-2.8 4.3-3.7 6.2-1 1.7-.7 3-1 3.5a95.4 95.4 0 0 1-4 .6l-4 .5c-.6-.3-1-1.6-2.6-3s-4.4-3-6-4.6c-3-3.5-4.6-6.8.2-6.7 1.2 0 2.4-.2 3-1 .4-.7 0-1 .4-3 .3-1.2.8-2.3 1.4-3 .6-.8 1.5-.6 2.3-.7 1-.2 1.6-.7 2.5-.2 1 .4 2 1.2 2.7 2.3z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "m413 202-.6 1-.2-.2-.2-.2-.2-.2v-.2h-.2v-.2l-.2-.2v-.2l-.2-.2v-.2h-.2v-.2l-.2-.2-.2-.3-.3-.3.8-.6.3.2.2.3v.2h.2v.4h.2v.4h.2v.2l.2.2v.2h.2v.2l.2.2zm2.9 0 .2 1h-.5l-.2.2h-.8v.2h-1.2l-.3-.2h-.2l-.2-.2h-.2l.5-1v.2h.8v.2h1l.2-.2h.4l.2-.2zm4 7-1-.3v-.4l.2-.4v-.5l.2-.4v-.3l.2-.3v-.7l.2-.4v-1.7l-.2-.2v-.4h-.2l-.2-.3h-.2l-.3-.2H417l-.4.3h-.4l-.3-.8.3-.2h.5l.4-.2h1.8l.3.2h.3l.2.3.2.4v.2l.3.3.2.4v3.3l-.2.4v.4l-.2.4v.4l-.2.4v.4zm-3.7 6.4-1-.5v-.2l.2-.2.2-.2v-.2l.2-.2v-.4l.2-.2.2-.2v-.2l.2-.2.2-.2.2-.3.2-.2.2-.3.2-.2v-.2l.2-.2h.2v-.3l.2-.2v-.2l.2-.2.2-.3v-.2l.2-.2v-.2l.2-.3 1 .3v.2l-.2.3v.2l-.2.2-.2.3v.2l-.2.2v.3l-.3.2-.2.2v.2l-.2.2-.2.2v.2l-.2.2-.2.2v.2l-.3.2v.2l-.2.2-.2.2v.2l-.2.2v.4h-.3v.3l-.2.2-.2.2v.2zm-1.5 3.8-.2-1-.3.2v-.4h.2v-1l.2-.2v-.4l.2-.3v-.4l.2-.3v-.2h.2l1 .4-.2.2-.2.3v.3h-.2v.7h-.2v.9l-.2.2v.4l-.2.2v.2zm.3 0h-.2.3zm-4.3.6v-1h1.1v-.2h1.2v-.2h1.1l.3-.2.2 1h-.4l-.3.2h-.9l-.2.2h-1.3v.2h-.7zm0 0v-1 .5-.5zv-.5zm-4 .5.4-1h-.2 1.3l.3-.2h1.9l.2-.2.2 1h-.8v.2h-1.4v.2h-2zm.2 0h-.3.2zm-3-3 .5-1 .2.3.3.3h.2l.2.3.2.2.2.3.2.2v.2h.2v.2h.2v.2l.2.2v.2h.2v.2h.2v.2l-.4 1v-.2h-.2l-.2-.2-.2-.2v-.2h-.2v-.2l-.2-.2v-.2h-.2v-.2l-.2-.2-.2-.2-.2-.2-.2-.3v-.2h-.2v-.2h-.3v-.3zm-6-4.8.7-.6.2.2.3.3.3.3h.2v.3l.3.2h.3l.2.3h.2l.2.3.3.3.2.2.2.2h.2v.2l.3.2h.2l.2.3.2.2.3.3h.2l.2.3.3.2.2.2h.2v.2l-.5.8h-.3v-.2l-.3-.2h-.2v-.2l-.3-.2h-.3l-.2-.2-.2-.2h-.2v-.2l-.3-.2h-.2l-.2-.3h-.2v-.2h-.3l-.2-.2-.2-.2h-.2v-.3h-.3l-.2-.3-.2-.2h-.2v-.3h-.3v-.3l-.3-.2h-.2v-.3l-.3-.2zm.4-7.5v1H397l-.2.2h-.4l-.2.2v.2h-.2v1.5l.2.3v.3l.2.2.2.3.2.4.2.3.2.3.2.3.2.3.3.3v.2l.4.3.3.4-.8.5-.4-.3-.3-.3-.2-.4-.2-.4-.2-.3-.3-.4-.2-.3v-.4l-.3-.4v-.3l-.3-.3v-.3l-.3-.3V206l.2-.2.2-.2.2-.2.3-.2h.2l.3-.2h.7l.4-.2h.8zm2.5-.8.8.5-.2.2-.2.2h-.2v.2h-.2l-.2.2h-.2l-.2.2h-.5l-.2.2h-1.1v-1h1.4l.2-.2h.2l.2-.2h.2v-.2zv-.2zm.4-2.8 1 .2v.4h-.2v2h-.2v.4l-.2.2-1-.4h.2v-1.4l.2-.3v-.8zm1.4-3.2.8.6-.2.2v.2h-.2v.4h-.2v.4h-.2v.4l-.2.2v.4l-.2.2v.4l-1-.2v-.7l.2-.2v-.4l.2-.2v-.4h.2v-.4h.2v-.4h.2v-.2h.2v-.4zm.8.6.5-.7zm1.8-1.5.2 1H404v.2h-.4v.2h-.2l-.8-.5.2-.2.2-.2h.2v-.2h.4l.2-.2zm.2 1h-.7.6zm2.7-1.2-.5 1H406l-.2.2h-.4l-.2-1h.8l.2-.2h2.1zm3 3h-1v.2-.2h-.2v-.2l-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2h-.2v-.2h-.2l-.2-.2-.2-.2h-.2l-.2-.2.5-1v.2h.2l.2.2h.2v.2h.2v.2h.2l.2.2.2.2.2.2h.2v.2h.2v.2l.2.2.2.2.2.2v.2l.3.3zm-.2-.4h.2v.3-.4zm-.8.3h1l-1 .2v-.3zm0 .2v-.3.2z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "M410 219.4h-.7c-1.4-3.8-3.5-7-6.3-9.5 2.8 1.4 5.5 5.3 7 9.4zm1.4-.2c.3 0 .5 0 .8-.2-.5-4 0-7.5 1.5-11-2 2.5-2.8 7-2.3 11.2"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#edb92e",
                  d: "M418.3 202c-.2 1.4-.4 3-1 4.3-1 2-3.8 1.3-6.6-.7-.8-.6-2.2-.8-3.4-.6-1.3.3-2.4.8-3 1.7-1.5 2.6-3.4 4-5.2 2.6-1-1-2-2.3-2.7-3.5.5-.2 1.2-.3 2-.3 1.3 0 2.5-.2 3-1 .5-.7 0-1 .6-3 0-1.2.6-2.3 1.2-3 .6-.8 1.5-.6 2.3-.7 1-.2 1.6-.7 2.5-.2 1 .4 2 1.2 2.7 2.3 1.4 1.6 1.2 2 2 2.5 1 .6 2.2.4 3.3 0 1-.4 1.7-.6 2.3-.5z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "m417.7 206.5-1-.4.2-.2v-.5l.2-.2v-.4l.2-.2v-.9l.2-.2v-1.2h.2v-.4h1v1.1l-.2.3v1h-.2v.7h-.2v.7h-.2v.3l-.2.3zm-7.2-.5.5-.8.3.2h.2l.3.3h.2l.3.3h.2l.3.2.2.2h.2l.3.2h.4v.2h.7l.2.2h1v-.2h.2l.2-.2.2-.3.2-.2 1 .5-.2.2-.2.3-.3.3v.2h-.2l-.2.2h-.2l-.3.2h-2l-.2-.2h-.2l-.3-.2h-.2l-.2-.2h-.2l-.3-.2-.2-.2h-.2l-.3-.3-.2-.2h-.3l-.3-.3-.2-.2zm-3-.4-.3-1h1.1v-.2h1.3v.2h.6v.2h.4v.2h.2l.2.2-.5.8h-.2v-.2h-.4v-.2zm-2.7 1.3-.8-.6v-.2h.2v-.2h.2v-.2l.2-.2h.2v-.2h.2l.2-.2h.2l.2-.2h.3v-.2h.8l.2-.2h.5l.2 1h-.7v.2h-.4v.2h-.4l-.2.2h-.2v.2h-.2v.2h-.2v.2h-.2zm-6 2.7.6-.8h.3v.2h.5l.2.2h.5l.3-.2h.3v-.2h.3v-.2h.2v-.3h.3v-.3h.3v-.3l.3-.3.2-.2.2-.2v-.2h.3v-.4l.3-.2.8.5v.2l-.3.2v.3l-.3.2h-.2v.3l-.3.2-.2.2-.2.2-.3.3h-.2l-.2.3h-.2v.3h-.3l-.3.2h-.4l-.3.2h-1.2l-.2-.2h-.2l-.2-.2-.2-.2h-.2zm-2.7-4.4.5 1 .3-.8v.3h.2v.2l.2.2v.2h.2v.2l.2.2v.2h.2v.2l.2.2.2.2.2.2v.2h.2v.2h.2v.2h.2v.2h.2v.2h.2l-.6 1-.2-.2-.2-.2-.2-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.3h-.2v-.2h-.2v-.2h-.2v-.3h-.2v-.2h-.2v-.4h-.2v-.2h-.2V205zm0 .8-.4-.4.5-.3v.8zm2.4-1v1H397v.2h-.4l-.5-1h1.2v-.2zm2.5-.8.8.5-.2.2-.2.2h-.2v.2h-.2l-.2.2h-.2l-.2.2h-.7l-.2.2h-1.2v-1h1.4l.2-.2h.4v-.2h.2v-.2h.2v-.2zm.4-2.8 1 .3v.3l-.2.3v1.7h-.2v.7h-.2l-1-.4h.2v-1.4h.2v-1.3zm1.4-3.2.8.6-.2.2v.2h-.2v.4h-.2v.4h-.2v.4l-.2.2v.7h-.2v.5l-1-.3v-.7l.2-.2v-.4l.2-.2v-.4h.2v-.4h.2v-.4h.2v-.2h.2v-.4zm0 0 .4-.5zm2.6-1 .2 1h-.6v.2h-1v.2h-.2l-.2.2-.8-.6.2-.2.2-.2h.2v-.2h.4l.2-.2h1.4zm0 0h.6zm3 0-.6.8H406v.2h-.5l-.2-1h.8v-.2h2.1zm-.6.8.3.2zm3.3 1.6-.6.6-.2-.2h-.2v-.2l-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2h-.2v-.2h-.2l-.2-.2h-.2v-.2h-.2l-.2-.2.5-1v.2h.2l.2.2h.2v.2h.2v.2h.2l.2.2.2.2.2.2h.2v.2h.2v.2l.2.2.2.2.2.2v.2zm2 2.5-.6 1-.2-.2-.2-.2-.2-.2v-.2h-.2v-.2l-.2-.2v-.2l-.2-.2v-.2h-.2v-.2l-.2-.2-.2-.3-.2-.3.7-.6.3.2.2.3v.2h.2v.2l.2.2v.4h.2v.2l.2.2v.2h.2v.2l.2.2zm-.6 1-.2-.2h.2zm3.5-1 .2 1h-.5l-.2.2h-.8v.2h-1.3l-.2-.2h-.2l-.2-.2h-.2l.5-1v.2h.6l.2.2h1.1l.2-.2h.4l.2-.2zm2.8 0h-1l.5.5h-1l-.2.2h-.4l-.2.2h-.2l-.3-1 .2-.2h.8v-.2h1.5l.5.4zm-.5-.5h.6l-.2.5-.5-.5z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#edb92e",
                  d: "M391.8 221.2c.7-1 1-.8 1.2-1.3.2-1-.3-2-1-3.2-2.2-4.6.3-4.2 3.6-2.4 1 .4 2 1.2 3 2 1 1 1.8 1.8 2.7 2.4 1.6 1.2 2.7 1.2 3 1.7 1 2 1.5 3.5 1.8 4.2.3.7 1 2.3 1.6 4.2 0 .4-1 .5-1.8 2-.7 1.2-1.2 3.5-2 4.7-1.4 1.6-2.5 2.6-3.4 2.4-1 0-1.6-1.3-1.8-4.2a4 4 0 0 0-1.5-3c-.5-.6-.6-.4-2-1.2a9.3 9.3 0 0 1-2.4-2c-.6-.6-.7-1.3-1-2-.3-1-.8-1.6-.7-2.4a3.8 3.8 0 0 1 .8-2z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "m392.5 219.7 1 .3v.2l-.2.2v.2h-.2v.2h-.2v.2h-.2l-.2.2v.2h-.2l-.8-.5v-.2l.2-.2.2-.2.2-.2h.2v-.2h.2zm-.8-2.7 1-.5v.4l.2.2v.4l.2.3v.2l.2.2v2l-1-.3v-1.2l-.2-.2v-.4h-.2v-.4h-.2v-.4zm4.2-3-.6.8h-.3l-.2-.3h-.3l-.3-.3h-.3l-.3-.2h-.3l-.2-.2h-.5l-.2-.2h-.6v1.5l.3.4.2.3.2.4.2.5-1 .5v-.4l-.3-.4-.2-.4v-.7l-.2-.2v-1.5l.2-.2h.2l.2-.2h.2l.2-.2h1.2l.2.2h.6l.3.3.3.2h.3l.3.2.2.2.4.2h.3zm2.8 2-.7 1v-.4h-.2l-.2-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2l-.2-.2h-.2v-.2h-.2l-.2-.2-.2-.2h-.2l-.2-.2.5-1v.2h.2v.2h.2l.2.2h.2v.2h.2l.2.2h.2v.2h.2v.2h.2l.2.2.2.2.2.2h.2v.2zm2.8 2.4-.6.8h-.2v-.2h-.2v-.2h-.2l-.2-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2l-.2-.2-.2-.2-.2-.2h-.2v-.2h-.2v-.2h-.2l.6-1v.2h.2l.2.2v.2h.2l.2.2.2.2h.2v.2h.2v.2h.2v.2h.2l.2.2.2.2h.2v.2h.2zm3.3 2-1 .3v.2-.2h-.2v-.2h-.4l-.2-.2h-.2l-.2-.2h-.3l-.2-.2h-.3v-.2h-.3v-.2h-.3v-.2h-.3v-.2l.6-.8.2.2h.2v.2h.3l.2.2h.2l.2.2h.2v.2h.4l.2.2h.4v.2h.2l.2.2h.2v.3zm-.2-.3v.2zm1.7 4.5-1 .4v-.7l-.2-.2v-.4l-.2-.2v-.5h-.2v-.4l-.2-.3v-.3h-.2v-.5h-.2v-.5h-.2v-.3l1-.4v.4l.2.3v.2l.2.3v.2l.2.3v.3l.2.3v.4h.2v.4l.2.2v.4h.2v.4zm0 0-1 .4h.3l.3.2-.5-.5.6.5-.5-.5.6.5-.5-.5.2.4-.2-.3v.2l1-.5v.2-.4.4l-.4-.5.6.5-.5-.5.6.5-.5-.5h.4v.3zm0-.2v.2zm1.6 4.7-1-.2v.3-.5l-.2-.3v-.2l-.2-.3v-.3l-.2-.3v-.2l-.2-.2v-.4l-.2-.2v-.2l-.2-.2v-.4l-.2-.2 1-.5v.4h.2v.5h.2v.5l.2.2v.3l.2.3v.5l.2.2v.3l.2.2v.2l.2.2v.6zm0-.3v.3zm-1.7 2.4-1-.4.2-.2v-.2h.2v-.2l.2-.2v-.2h.2v-.2h.2l.2-.2h.2v-.2h.2v-.2l1 .2v.4h-.2v.2h-.2v.2h-.2l-.2.2-.2.2-.2.2-.2.2-.2.2zm-2.2 5-.7-.7.2-.3v-.2h.2v-.3l.2-.2v-.4l.2-.2v-.5h.2v-.4h.2v-.5h.2v-.2l.2-.3v-.2l.2-.3v-.2l.2-.2 1 .5-.2.2v.3h-.2v.4h-.2v.5l-.2.2v.3l-.2.2v.3l-.2.2v.3l-.2.2v.3l-.2.2v.3h-.2v.3h-.2v.3l-.2.2v.2zm-3.7 2.7.2-1h.4v-.2h.2l.2-.2h.2v-.2h.2l.2-.2.2-.2.2-.2.2-.2.2-.3.2-.2v-.2h.2v-.3l1 .7h-.2v.3h-.3v.3h-.2v.3h-.4v.4h-.2v.2h-.2l-.2.2-.2.2-.2.2h-.3v.2h-.4v.2h-1zm-2.2-5h1v.3l.2.2v1.1h.2v.5l.2.2v.3l.2.2v.2h.2v.2h.2v.2h.2v1h-.8v-.2h-.2l-.2-.2-.2-.2v-.3h-.2v-.2l-.2-.2v-.3l-.2-.3v-.4h-.2v-1l-.2-.2v-1zm-1.2-2.6.7-.6.2.2v.2h.2v.2l.2.2v.2h.2v.3l.2.2v.2h.2v.7h.2v.6l-1 .2v-1h-.2v-.4l-.2-.2v-.2h-.2v-.2h-.2v-.4h-.2v-.2zm-2-1 .4-.8h.3v.2h.4v.2h.4v.2h.4v.2h.4v.2h.2v.2l-.6.7h-.2l-.2-.2h-.4v-.2h-.4l-.2-.2h-.2l-.2-.2h-.3zm-2.5-2 .7-.6.2.2.2.2.2.2.2.2h.2v.2h.2v.2h.2l.2.2h.2v.2h.2l.2.2-.5 1v-.2h-.2v-.2h-.4v-.2l-.2-.2h-.2l-.2-.2-.2-.2-.2-.2-.2-.2h-.2v-.2h-.2v-.2zm-1.2-2.3 1-.4v.2h.2v.4h.2v.5h.2v.4h.2v.2l.2.2-.7.7h-.2v-.4h-.2v-.4h-.2v-.4l-.2-.2v-.8h-.2v-.2zm-.6-2.5h1v.8h.2v.4l.2.2v.2l.2.2v.2l-1 .5v-1h-.2v-.4h-.2v-.6h-.2v-.8zm1 0v.2zm.4-1.5v-1l.3.8v.4h-.2v.2h-.2v.8h-.2v.2h-1v-.9l.2-.2v-.4l.2-.2v-.2h.2v-.4h.2v-.2h.2l.4.7zm0-1h1l-.7.8-.2-.8zm0 0v1l-.4-.8.4-.3zm0 1h-1l.6-.8.4.7z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "m406.5 226 .2 1c-1.4.4-2.6 1-3.6 1.8s-1.7 2-2.3 3.2c.2-1.4 1-2.7 2-3.7s2.3-1.8 3.8-2.2zm-.6-1.6-.5-1c-1.6 0-3.2-.4-4.7-1-1.5-.7-3-1.6-4.4-2.8 1 1.3 2.6 2.4 4.3 3.3 1.6.7 3.5 1.3 5.2 1.5z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#edb92e",
                  d: "M391.4 213.8c1 .4 1.6.8 2.8 1.8.8.7 1.3 1.7 1.5 3 0 1 0 2.5-.3 3.8-.2.8 0 2.2.5 3.6.4 1.4 1 2.8 2 3.5 2.3 2.5 4 5 3.4 6.7a4 4 0 0 1-1.5 1.8c-.4-.6-1-1.2-1.4-2.2a8 8 0 0 0-1.5-3.5c-.5-.6-.7-1.3-2-2.2-1-.5-2-.3-2.6-1-1.2-1.6-3-5.5-1.3-7.2 1.7-1.7 2.3-2.7 1-5.6-.5-1-.5-1.8-.6-2.4z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "m394.5 215.2-.7.8-.2-.2-.2-.2-.2-.2h-.2v-.2h-.2v-.2h-.4v-.2h-.2l-.2-.2h-.2l-.2-.2h-.4l.3-1h.4v.2h.4v.2h.4v.2h.4v.2h.2v.2h.2l.2.2.2.2h.2v.2h.2v.2zm1.7 3.2-1 .2v-.6h-.2v-.7h-.2v-.4l-.2-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2l.7-.8h.2v.2l.2.2v.2h.2v.2l.2.2v.2h.2v.4l.2.2v.4h.2v.8h.2v.2zm-.3 4h-1V221h.2v-2.4l1-.2v3.3l-.2.2zm-1 0v-.3zm1.4 3.5-1 .2v-.5l-.2-.3v-.4l-.2-.3v-.8h-.2v-1.4h1v1.9h.2v.7h.2v.7h.2zm1.8 3.2-.7.7v-.2l-.2-.2h-.2v-.4h-.2v-.2l-.2-.3v-.2h-.2v-.2l-.2-.3v-.2h-.2v-.5l-.2-.2-.2-.3v-.4h-.2l1-.4v.2l.2.2v.2l.2.3.2.2v.3l.2.2v.2h.2v.2h.2v.4h.2v.2h.2v.2h.2v.2zm3.6 7.2-1-.4.2-.2v-1.3l-.2-.2v-.4l-.2-.2v-.2l-.2-.2-.2-.2v-.2l-.2-.2-.2-.2v-.2l-.3-.2-.2-.3v-.3l-.3-.2-.2-.2-.2-.3-.2-.2-.2-.2-.2-.2-.3-.3h-.2l.7-.8.3.2.2.2.2.3.3.4.3.2.2.2v.3l.3.3.3.2.2.3v.2l.3.2.2.3v.2l.2.2.2.2v.2l.2.2v.2l.2.3v.7l.2.2v1.2l-.2.2zm-2.4 1.8 1-.4-.8-.2.2-.2h.2v-.2h.2v-.2h.2v-.2l.2-.2v-.2l.2-.2v-.2l1 .4v.2l-.2.2v.2l-.2.2v.2h-.2v.2h-.2v.2h-.2v.2h-.2v.2h-.2l-.2.2zm.8.2-.5.3-.3-.5zm-2-2.5 1-.3v.4h.2v.4h.2v.2h.2v.2l.2.2v.2h.2v.4l-.8.4v-.2h-.2v-.2l-.2-.2v-.2h-.2v-.2h-.2v-.4l-.2-.2v-.2zv-.3zm-1.5-3.3.8-.7v.2h.2v.2l.2.2v.2l.2.2v.2h.2v.5h.2v.4l.2.2v.4l.2.3v.7l-.8.2v-.4h-.2v-.5l-.2-.2v-.5h-.2v-.2l-.2-.2v-.2l-.2-.2v-.2h-.2v-.2l-.2-.2zm-2-2.2.4-1 .3.2.2.2h.2l.2.2.2.2.2.2v.2h.2v.2h.2v.2l.2.2.2.2v.2h.2v.2l-.7.7-.2-.2v-.2h-.2v-.2h-.2v-.4h-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.4v-.2zm-2.7-1.3.8-.6h.2v.2h.2v.2h.9l.2.2h.4l.2.2h.2l.2.2-.4 1v-.2h-.4l-.2-.2h-.9v-.2h-.4l-.2-.2h-.2l-.2-.2-.2-.2zm-1.2-7.8.7.7v.3h-.2v.3h-.2v2.2l.2.3v.5l.2.2v.2l.2.3v.2l.2.2v.2l.2.2v.2l.3.2v.2h.2v.3l.2.2-.7.7-.2-.3-.2-.3v-.2l-.2-.2v-.2h-.3v-.3l-.2-.3-.2-.4v-.2l-.2-.3v-.2l-.2-.2v-.6l-.2-.3v-2.1l.2-.3v-.2h.2l.2-.3.2-.3zm.7-5 1-.5v.5l.2.2v.3l.2.2v.7h.2v1.7l-.2.2v.2l-.2.2v.2h-.2v.3h-.2v.2l-.2.2-.3.3h-.2l-.2.3-.8-.6.2-.3h.2l.2-.3.2-.3.2-.2v-.3l.2-.2v-.2l.2-.3v-.7l-.2-.2v-.5l-.2-.2-.2-.4v-.2zm0-3v1l.4-.7v1.4h.2v1.1h.2l-1 .6v-.9h-.2v-.7l-.2-.2v-1l.4-.7zm-.6.5-.3-.7h.7l-.5.6zm.4.3v-1zm0-1"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#edb92e",
                  d: "M434 226.2c-1.2 1-1.5 1-2 1.6-.3.8 0 2 .3 3.3 1.5 5-1.4 4.4-5 2.6-1.6-1-3.6-3.2-5.2-4.4-1.5-1-2.6-1-3-1.6a118.7 118.7 0 0 1-1-4.3c0-.7-.5-2.4-1-4.4.4-.7 1.4-1 2.5-2.5 1-1.7 2.2-4.7 3.6-6 3-3.2 6-4.5 6 1.3 0 1.4.3 3 1 3.6.6.6 1 .3 2.5 1 1 .6 2 1.3 2.6 2 .7 1 .5 2 .7 2.8 0 1 .5 1.7.2 2.6-.5 1-1 1.7-2 2.4z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "m432.6 228-1-.5h.2v-.4h.4v-.2h.4v-.2h.2l.2-.2h.2v-.2h.2v-.2h.2v-.2l.8.8-.2.2h-.2v.2h-.2l-.2.2-.2.2h-.2v.2h-.4v.2zm0 2.9-.8.3v-.2l-.2-.2v-.7h-.2v-2.3h.2v-.2l1 .4v.2h-.2v2.1h.2v.7zm-5.4 3 .5-.8h.3l.3.3h.3l.3.3h.2l.3.2h.2l.3.2h.7l.2.2h.7v-.2h.2v-.4l.2-.3v-1.1l-.2-.3v-.3l-.2-.4 1-.4v.4l.2.4v.8l.2.3v1.1l-.2.4v.2l-.3.2-.2.2h-.2l-.2.2-.4.2h-1.2l-.3-.2h-.6l-.3-.3-.2-.2h-.3l-.3-.2-.4-.2-.3-.2zm-5.4-4.3.6-1 .2.2.3.2.2.3h.2v.3h.3v.3l.3.2.2.2h.2v.3h.3l.2.3.2.3.2.2.3.3h.2v.2l.2.2h.2l.2.2v.2h.3v.2h.2l.2.2.3.2-.5 1-.2-.2h-.2v-.2l-.3-.2h-.2l-.2-.2-.2-.3h-.2l-.2-.2h-.2v-.3h-.3l-.3-.3h-.2v-.3l-.3-.3h-.2l-.2-.3-.3-.3h-.2v-.2h-.3l-.2-.3-.3-.3-.3-.2-.3-.2h-.2zm-3.4-2 1-.2v-.2h.2v.2h.4l.2.2h.4v.2h.7l.2.2h.2l.2.2.3.2h.2l.2.2-.6 1v-.2h-.3v-.2h-.2l-.2-.2-.2-.2h-.3l-.2-.2h-.2v-.2h-.4l-.2-.2h-.2l-.2-.2h-.2v-.2h-.2v-.3zm.2.3v-.3zm-.6-4.2v-1l.5.4v.4l.2.2v1h.2v1.3h.2v1h.2v.5l-1 .2v-.7l-.2-.3v-.7l-.2-.3v-.7h-.2v-.8l-.2-.2v-.6l.4.4zm0-1h.5v.4zm-.5.6 1-.2v-.2l-.5-.2v1h-.3zm-.8-4.7 1 .4v-.2 1.1h.2v1.1l.2.3v.8l.2.2v.9l-1 .2V222l-.2-.2v-.8l-.2-.3v-.7h-.2v-.8l-.2-.2v-.3zm0 .3v-.3zm2.4-2.8 1 .5-.2.2-.2.2-.2.3-.2.2-.2.2h-.2v.2h-.2l-.2.2h-.2v.2h-.2v.2h-.2v.2h-.2l-1-.3h.2v-.4h.2v-.2h.4v-.2h.2l.2-.2.2-.2.2-.2h.2v-.2l.2-.2.2-.2v-.2h.2zm3.7-6.2.8.7h-.2v.3h-.2v.3l-.3.3v.2l-.2.2v.2h-.2v.3l-.2.3v.4l-.3.2v.2l-.2.2v.2l-.2.2v.2l-.2.2v.3l-.2.3v.2l-.2.2v.2h-.2v.2l-.2.2-.2.2-1-.4.2-.2.2-.3v-.2h.2v-.3l.2-.2v-.2l.2-.2v-.2l.2-.2v-.2l.2-.2v-.3l.2-.2v-.2h.2l.2-.3v-.2l.2-.2v-.3l.2-.2v-.2l.3-.2v-.2l.2-.2.2-.3v-.2l.2-.2h.2zm6.8 1.8h-1v-1.4l-.2-.4v-.6l-.2-.2v-.4l-.2-.2h-.3v-.2h-1.2l-.3.2-.3.2h-.2l-.3.3-.2.3-.3.2-.2.2-.3.2-.2.2-.3.2-.2.3-.8-.7.3-.3.3-.3.3-.2.2-.3.3-.3.4-.2.3-.2.2-.2h.2l.3-.3h.2l.3-.2h.3l.2-.2h1.2l.3.2.3.3.2.2.2.2.2.3v.6l.2.5v.4l.2.3v1.5zm1 3.3-.8.8-.2-.2v-.2h-.2v-.2l-.2-.2v-.6l-.2-.2v-.7l-.2-.2V212h1v2h.2v.3l.2.2v.2h.2v.2zm2.2 1-.4 1-.3-.2h-.2l-.3-.2h-.4v-.2h-.9v-.2h-.4v-.2h-.2v-.2l.6-.7v.2h.4v.2h.8l.2.2h.4l.2.2h.2l.2.2zm2.8 2.2-.8.6h-.2v-.2l-.2-.2h-.2v-.4h-.2l-.2-.2h-.2v-.2h-.2v-.2h-.4v-.2h-.2l-.2-.2.3-1 .3.2h.2l.2.2.2.2h.2v.2h.2l.2.2h.2v.2h.2v.2h.2v.2h.2v.2h.2v.2h.2zm-.8.6.4.5zm1.5 2.3-1 .2V220l-.2-.2v-.8h-.2v-.4l.7-.6v.2l.2.2v.2l.2.2v2.2h.2v.2zm0 3-.8-.4v-2.1l-.2-.2v-.4h1v1l.2.2v1.8zm-1.8 2.6-.7-.8h.2v-.2l.2-.2v-.2h.2v-.2h.2v-.2h.2v-.2l.2-.2v-.2l.2-.2v-.2h.2v-.2l1 .4-.2.2v.2l-.2.2v.2h-.2v.4h-.2v.2h-.2v.2l-.2.2-.2.2v.2h-.2l-.2.2zm-.7-.8"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "m418 222.6-.2-1a14 14 0 0 0 7.8-5.3c-1.2 3-4.3 5.3-7.7 6.3zm.2 1.5c0 .4.2.7.3 1 3.4 0 6.4 1 9.2 3-2-2.3-5.8-3.8-9.5-4"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#edb92e",
                  d: "M432.7 233.3a11 11 0 0 1-3.4-1.5c-1.6-1.3-1.2-3.8.3-6.4.4-.8.5-2.2.2-3.5a6.3 6.3 0 0 0-1.4-3.5c-2.4-2.3-3.8-4.8-2.6-6.6.8-1.3 2-2 2.8-2.7.3.6.4 1.5.4 2.5 0 1.4.3 3 1 3.6.6.6 1 .3 2.5 1 1 .7 2 1.3 2.6 2 .7 1 .6 2 .7 2.8 0 1 .5 1.7.2 2.6-.5 1-1 1.7-2 2.4-1.2 1-1.5 1-2 1.6-.3.8 0 2 .3 3.3.3 1 .4 1.7.4 2.3z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "m429 232.2.6-.8h.2v.2h.2l.2.2h.2l.2.2h.2l.2.2h.4v.2h.4l.2.2h.4l.2.2h.2l-.3 1h-.4v-.2h-.4l-.2-.2h-.3v-.2h-.4l-.2-.2h-.2l-.2-.2h-.2v-.2h-.2l-.3-.2h-.2v-.2zm0-7 1 .5v.2h-.2l-.2.4v.2l-.2.2v.2l-.2.3v.4l-.2.2v.5l-.2.2v1.5l.2.3v.2h.2v.3l.2.2.2.2-.6.8-.2-.2-.3-.3v-.2h-.2v-.3l-.2-.2v-.4l-.2-.3V228h.2v-.7l.2-.3.2-.3v-.3l.2-.2v-.3l.3-.3v-.5zm.3-3.3 1-.2v.8h.2v1.9l-.2.2v.7h-.2v.2l-1-.4h.2v-.6h.2V222zm-1.3-3.2.7-.7v.2h.2v.4h.2v.2l.2.2v.2l.2.2v.2l.2.2v.5h.2v.7l.2.2v.8h-1v-1.2l-.2-.2v-.4h-.2v-.4h-.2v-.2l-.2-.2v-.2h-.2v-.2l-.2-.2zm-2.7-7.2 1 .6h-.2v.7l-.2.2v.7l.2.2v.4l.2.2v.2l.2.2v.2l.2.2v.2l.3.2v.2l.2.2.2.2v.2l.3.3.2.3v.2l.3.2.2.2h.2l-.7.8-.2-.2-.2-.2-.3-.2-.2-.2v-.3l-.2-.2-.2-.2-.2-.2-.2-.2v-.2l-.3-.2-.2-.3h-.2v-.3l-.2-.2v-.3l-.2-.2v-.2l-.2-.3v-.4l-.2-.2v-1l.2-.3v-.2l.2-.2v-.2zm3.8-2.5-.8.4.7.3h-.2l-.2.2h-.2l-.2.2h-.2v.2h-.2v.2h-.2l-.2.2-.2.2-.2.2-.2.2-.2.2v.2h-.2v.2l-.2.2-1-.6h.2v-.2l.2-.2.2-.2v-.2h.2v-.2h.2v-.2h.2v-.2h.2l.2-.2.2-.2h.2v-.2h.2l.2-.2.2-.2h.2v-.2zm-.6 0 .5-.5v.6h-.6zm1 2.8h-1v-2.1h-.2v-.4l1-.3v1h.2v2zm1 3.3-.7.8-.2-.2v-.2h-.2v-.2l-.2-.2v-.7l-.2-.2v-.7l-.2-.2V212h1v1.7h.2v.6l.2.2v.2h.2v.2l.2.2zm2.3 1-.4 1-.3-.2h-.2l-.3-.2h-.4v-.2h-.9v-.2h-.4v-.2h-.2v-.2l.6-.7v.2h.4v.2h.8l.2.2h.4l.2.2h.2l.2.2zm2.8 2.2-.8.6h-.2v-.2l-.2-.2h-.2v-.4h-.2l-.2-.2h-.2v-.2h-.2v-.2h-.4v-.2h-.2l-.2-.2.3-1 .3.2h.2l.2.2.2.2h.2v.2h.2l.2.2h.2v.2h.2v.2h.2v.2h.2v.2h.2v.2h.2zm-.8.6.4.5zm1.5 2.3-1 .2V220h-.2v-.8h-.2v-.4l.7-.6v.2l.2.2v.2l.2.2v2h.2v.2zm0 3-.8-.4v-2.2l-.2-.2v-.4h1v1l.2.2v1.8zm-1.8 2.6-.7-.8h.2v-.2l.2-.2v-.2h.2v-.2h.2v-.2h.2v-.2l.2-.2v-.2h.2v-.4h.2v-.2l1 .4-.2.2v.2l-.2.2v.2l-.2.2v.2h-.2v.2h-.2v.2l-.2.2-.2.2v.2h-.2l-.2.2zm-1.7 1.4-1-.5v-.2h.2v-.2h.2v-.2h.4v-.2h.2l.2-.2h.2v-.2h.2v-.2h.2v-.2l.8.8-.2.2h-.2v.2h-.2l-.2.2-.2.2h-.2l-.2.2h-.2zh-.2v.2zm0 2.9-1 .3v-.7h-.2v-3h.2l1 .4h-.2v2.6h.2v.2zm-.2 2.8.3-1-.6.5v-1h-.2v-.9l-.2-.2 1-.5v.9h.2v1h.2v.7zm.7-.5v.7l-.7-.2zm-.5 0-.2.5zm.5 0v.7l-.7-.2z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#edb92e",
                  d: "M410.6 216.4c4 0 8 3.4 8.4 7.7.6 4.4-2.2 7.7-6 7.8-4 0-7.5-3-8.3-7.3-.7-4 1.8-8 6-8z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "m419.5 224-1 .2v-.8l-.2-.4v-.3l-.2-.4v-.3l-.2-.4-.2-.3-.2-.3-.2-.4-.2-.3-.2-.3-.3-.2-.2-.3-.3-.3-.2-.2-.3-.3-.3-.2-.3-.2-.4-.2h-.3l-.3-.3h-.4l-.3-.3h-.3l-.4-.2h-.3l-.3-.2h-1.5v-1h1.9l.4.2h.3l.4.3h.4l.4.3.4.2.3.2.5.2.3.3.3.2.4.2.3.3.3.3.3.3.3.4.2.3.2.4.3.4.2.4.2.4.2.4v.4l.2.4v.4l.2.4v.8zm-6.6 8.3v-1h.9l.2-.2h.6l.3-.2h.4l.2-.2.3-.2h.2l.2-.3h.2l.2-.3.3-.3.3-.2v-.2l.3-.3.2-.2v-.3l.3-.3.2-.4v-.3l.2-.3v-.7l.2-.3V224l1-.2v2.5l-.2.4v.8l-.3.4v.3l-.2.3v.4l-.3.3-.2.3-.3.3h-.2l-.2.4-.3.2-.3.3h-.3l-.3.3-.3.2h-.2l-.3.3h-.4l-.2.2h-.4l-.3.2H413zm-8.7-7.7 1-.2v.7l.2.5v.3l.3.4v.3l.3.3.2.4.2.3.2.3.2.3.2.3.3.3.2.3h.3l.2.3.3.3.2.2.3.2.3.2h.4l.3.3.3.2h.3l.3.2h.7l.3.2h1.2v1h-2l-.3-.2h-.4l-.4-.3h-.4l-.4-.3-.3-.2-.4-.2-.3-.2-.4-.2-.4-.2-.3-.3-.2-.2-.2-.2-.3-.3-.2-.3-.3-.3-.2-.4-.2-.3-.2-.3-.2-.4-.2-.3-.2-.4v-.4l-.2-.4-.2-.4v-.8zm6.2-8.7v1h-1l-.3.2h-.4l-.3.2h-.3l-.3.3h-.2l-.2.3-.3.2-.2.2v.2l-.3.2-.2.2-.2.3-.2.3v.2l-.2.3v.4l-.3.3v.6l-.2.3v.7l-.2.3v.7l.2.4v.8l-1 .2v-3.3l.2-.3v-.3l.2-.4v-.3l.3-.4v-.3l.3-.3.2-.3.2-.3.2-.3h.2l.2-.4.3-.2.3-.2.3-.2.3-.2.3-.2.3-.2h.3l.4-.2h.4l.3-.2h.9z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#edb92e",
                  d: "M411 218.6c2.8-.2 5.7 2.4 6 5.5.5 3.3-1.5 5.8-4.4 5.8-2.8 0-5.5-2.3-6-5.3s1.3-5.8 4.3-6z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "m417.6 224-1 .2v-.6l-.2-.3v-.2l-.2-.3v-.4l-.2-.2v-.2l-.2-.3-.2-.3v-.2l-.3-.2-.2-.2-.2-.3-.2-.2-.2-.2h-.2l-.2-.3h-.2l-.3-.3h-.2l-.2-.2-.4-.2h-.5v-.2h-1.1v-1h1.1l.4.2h.3l.2.2h.2l.3.2h.3l.2.3h.3l.2.2.3.2h.2l.3.3.2.3.2.2.2.2v.2l.3.3h.2v.4l.3.3v.3l.3.2.2.3v.3l.2.3v.8l.2.3zm-5 6.3v-1h1.1l.2-.2h.4l.2-.2h.2v-.2l.3-.2h.3v-.2l.3-.2v-.2h.2l.2-.3v-.2l.2-.2.2-.3v-.7l.2-.2v-1.6h1v2.2l-.2.3v.2l-.2.3v.2l-.3.3-.2.2v.3l-.3.2-.2.2-.2.2-.3.2-.2.2-.2.2h-.2l-.2.2h-.2l-.3.2h-.2l-.2.2zm-6.5-5.8h1l.2.4.2.4v.2l.2.3.2.3v.3l.3.2.2.2.2.2v.2l.3.2.2.2.3.3.2.2.2.2h.2v.3h.3l.2.2h.7l.2.2h1.1v1H411l-.4-.2h-.2l-.3-.2h-.2l-.2-.3h-.3l-.2-.3-.4-.3-.2-.3-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.2-.3v-.2l-.3-.2-.2-.2-.2-.3v-.3l-.2-.3v-.3l-.2-.2v-.7zm5-6.4v1h-.6l-.2.2h-.5l-.2.2h-.2l-.2.2-.2.2h-.2l-.2.3v.2l-.3.2-.2.3v.2h-.2v.3l-.2.2v.2l-.2.2v.7l-.2.2v1.7h-1V222h.2v-.4l.2-.3v-.2l.2-.2v-.2l.3-.3v-.2h.2l.2-.3.2-.2.2-.2.2-.2h.2l.2-.2h.3l.2-.3h.2l.2-.2h.6l.3-.2h.6z"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#0c4076",
                  d: "M411.2 220.7c2 0 3.6 1.5 4 3.5.2 2-1 3.6-3 3.6a4 4 0 0 1-3.7-3.4c-.3-2 1-3.6 2.7-3.7"
                }),
                /* @__PURE__ */ jsx262("path", {
                  fill: "#21231e",
                  d: "m415.6 224-1 .3v-.4l-.2-.2v-.4h-.2v-.3l-.2-.2-.2-.3-.2-.2-.2-.2h-.2l-.2-.2-.2-.2h-.2l-.2-.2h-.6v-.2h-.6v-1h1l.2.2h.2l.3.2h.3v.2h.3l.2.3v.2h.3l.2.2.2.2.2.3.3.2v.4h.2v.3l.2.3v.4zm-3.3 4.3v-1h.7l.2-.2h.4v-.2h.2v-.2h.2v-.2h.2v-.2l.2-.2v-.5l.2-.2v-1.1l1-.3v2h-.2v.3l-.2.3-.2.3-.2.2h-.2v.2l-.2.2h-.2v.2h-.3l-.2.2h-.4v.2h-1zm-4.3-3.8 1-.2v.5l.2.3v.4h.2v.2l.2.2.2.2.2.3.2.2.2.2h.3v.2h.4l.3.2h.8v1h-1.3l-.2-.2h-.2l-.3-.2h-.2v-.2h-.2v-.2l-.3-.2-.3-.2v-.2h-.2v-.3h-.3v-.3l-.2-.2v-.2h-.2v-.5l-.2-.2v-.5zm2.7-3.8h1l-.5.5h-.7l-.2.2h-.2v.2h-.2l-.2.2-.2.2-.2.2v.2h-.2v.5h-.2v1.3l-1 .3v-1.8h.2v-.5h.2v-.3h.2v-.3h.3v-.3h.3v-.2h.3v-.2h.3v-.2zl.2-.2h.4l-.5.5zm1 0v.5h-.5zm0 0h-1l.5-.5zm-1 0v-.5h.5z"
                })
              ]
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#fff",
              d: "M482 183c4 0 7 3 7 7s-3 6.7-7 6.7c-3.6 0-6.7-3-6.7-6.8 0-4 3-7 6.8-7z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "M489.5 189.8h-1c0-2.3-1.4-4.6-3.5-5.6a6.3 6.3 0 0 0-3-.7v-1c2.6 0 5 1.3 6.4 3.5a7.4 7.4 0 0 1 1 3.8zm-7.4 7.4v-1c2.5 0 4.7-1.4 5.8-3.4a6.4 6.4 0 0 0 .7-3h1c0 2.6-1.5 5.2-3.7 6.5a7.3 7.3 0 0 1-3.7 1zM475 190h1a6.4 6.4 0 0 0 6.3 6.2v1a7.1 7.1 0 0 1-6-3.4 7.4 7.4 0 0 1-1.2-4zm7.3-7.5v1a6.3 6.3 0 0 0-5.5 3.5 6.4 6.4 0 0 0-.7 3h-1c0-2.7 1.4-5 3.5-6.4a7.3 7.3 0 0 1 3.8-1z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#fff",
              d: "M482 171c4 0 7 3 7 7a6.8 6.8 0 1 1-13.7-.2c0-3.7 3-6.7 6.8-6.7z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "M489.5 178h-1c0-2.4-1.4-4.7-3.6-5.8a6.3 6.3 0 0 0-3-.6v-1c2.6 0 5 1.3 6.4 3.4a7.4 7.4 0 0 1 1 4zm-7.4 7.3v-1c2.5 0 4.7-1.4 5.8-3.4a6.4 6.4 0 0 0 .7-3h1c0 2.5-1.5 5-3.7 6.4a7.3 7.3 0 0 1-3.7 1zM475 178h1a6.4 6.4 0 0 0 6.3 6.3v1a7.1 7.1 0 0 1-6-3.4 7.4 7.4 0 0 1-1.2-4zm7.3-7.4v1a6.3 6.3 0 0 0-5.5 3.5 6.4 6.4 0 0 0-.7 3h-1c0-2.6 1.4-5 3.5-6.3a7.3 7.3 0 0 1 3.8-1z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#fff",
              d: "M482 159.6c4 0 7 3 7 7a6.8 6.8 0 1 1-13.7-.2c0-3.7 3-6.8 6.8-6.8z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "M489.5 166.5h-1c0-2.4-1.4-4.7-3.6-5.7a6.3 6.3 0 0 0-3-.7v-1c2.6 0 5 1.5 6.4 3.6a7.4 7.4 0 0 1 1 4zM482 174v-1c2.5 0 4.7-1.5 5.8-3.6.4-1 .7-2 .7-3h1c0 2.6-1.4 5-3.5 6.4a7.3 7.3 0 0 1-4 1zm-7.2-7.5h1c0 2.4 1.4 4.7 3.6 5.7a6.3 6.3 0 0 0 2.7.7v1a7.2 7.2 0 0 1-6-3.6 7.4 7.4 0 0 1-1.2-4zm7.3-7.4v1a6.4 6.4 0 0 0-5.5 3.6 6.4 6.4 0 0 0-.7 3h-1c0-2.6 1.4-5 3.5-6.4a7.3 7.3 0 0 1 3.8-1z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#fff",
              d: "M482 127c4 0 7 3.2 7 7s-3 6.8-7 6.8a7 7 0 0 1 .1-13.8z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "M489.5 134h-1c0-2.4-1.4-4.7-3.6-5.8a6.3 6.3 0 0 0-3-.6v-1c2.6 0 5 1.3 6.4 3.4a7.4 7.4 0 0 1 1 4zm-7.4 7.3v-1c2.5 0 4.7-1.4 5.8-3.4a6.4 6.4 0 0 0 .7-3h1c0 2.5-1.5 5-3.7 6.3a7.3 7.3 0 0 1-3.7 1zM475 134h1c0 2.3 1.4 4.6 3.5 5.6a6.3 6.3 0 0 0 2.8.7v1a7.3 7.3 0 0 1-6-3.4 7.4 7.4 0 0 1-1.2-4zm7.3-7.4v1a6.3 6.3 0 0 0-5.5 3.5 6.4 6.4 0 0 0-.7 3h-1c0-2.6 1.4-5 3.5-6.3a7.3 7.3 0 0 1 3.8-1z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#fff",
              d: "M482 137.2c4 0 7 3 7 6.8s-3 7-7 7c-3.6 0-6.7-3.2-6.7-7s3-6.8 6.8-6.8z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "M489.5 144h-1c0-2.3-1.4-4.6-3.5-5.7a6.3 6.3 0 0 0-3-.6v-1c2.7 0 5.2 1.4 6.5 3.6a7.4 7.4 0 0 1 1 3.7m-7.4 7.4v-1c2.5 0 4.7-1.4 5.8-3.4a6.4 6.4 0 0 0 .7-3h1c0 2.6-1.5 5-3.7 6.4a7.3 7.3 0 0 1-3.7 1zM475 144h1c0 2.4 1.4 4.7 3.5 5.7a6.3 6.3 0 0 0 2.8.7v1a7 7 0 0 1-6-3.5 7.4 7.4 0 0 1-1.2-4zm7.3-7.4v1a6.4 6.4 0 0 0-5.5 3.6c-.5 1-.7 2-.7 2.8h-1c0-2.5 1.4-5 3.5-6.2a7.3 7.3 0 0 1 3.8-1.2z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#fff",
              d: "M482 148.2c4 0 7 3 7 6.8s-3 7-7 7c-3.6 0-6.7-3.2-6.7-7s3-6.8 6.8-6.8z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "M489.5 155h-1c0-2.3-1.4-4.6-3.6-5.7a6.3 6.3 0 0 0-3-.6v-1c2.6 0 5 1.3 6.4 3.4a7.4 7.4 0 0 1 1 4zm-7.4 7.4v-1c2.5 0 4.7-1.4 5.8-3.4a6.4 6.4 0 0 0 .7-3h1c0 2.6-1.5 5-3.7 6.4a7.3 7.3 0 0 1-3.7 1zM475 155h1c0 2.4 1.4 4.7 3.5 5.7a6.3 6.3 0 0 0 2.8.7v1a7.3 7.3 0 0 1-6-3.4 7.4 7.4 0 0 1-1.2-4zm7.3-7.4v1a6.5 6.5 0 0 0-5.5 3.5 6.4 6.4 0 0 0-.7 3h-1c0-2.5 1.4-5 3.5-6.3a7.3 7.3 0 0 1 3.8-1z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#edb92e",
              d: "M487 195.5c1 1.6.7 2 1.4 2.4.8.6 2 .6 3.4.4 5.3-1 4.5 2.3 2.2 6-1 1.7-3.8 3.5-5.2 5-1.4 1.5-1.6 2.8-2 3.2h-9.2c-.5-.4-.7-1.7-2-3.2-1.5-1.5-4.2-3.3-5.3-5-2.4-3.7-3-7 2.2-6 1.3.2 2.6.2 3.4-.5.6-.6.3-1 1.3-2.5a7 7 0 0 1 2.2-2.3c1-.5 1.8-.2 2.6-.2 1 0 2-.3 2.8.2a7 7 0 0 1 2.2 2.3z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "m488.7 197.5-.7.8-.2-.2h-.2v-.4h-.2v-.4h-.2v-.4l-.2-.2v-.2l-.2-.2-.2-.3v-.2l.8-.6v.2h.2v.3l.2.2v.2h.2v.4h.2v.4h.2v.4h.2zm-.7.8-.3-.3zm3.8-.4v1h-2.4l-.2-.2h-.2l-.2-.2h-.3l-.2-.2.7-1v.2h.2v.2h.8l.2.2h1.9zm2.6 6.6-.8-.6.2-.3.2-.3.2-.4.2-.3v-.3l.3-.3v-.2l.2-.2v-.6l.2-.2v-1.3l-.2-.2h-.2v-.2h-.5l-.2-.2h-2l-.2-1h2.8l.3.2h.2l.2.2.2.2.2.2.2.2v.3l.2.3v1.7l-.2.3v.3l-.3.2v.4l-.3.3v.2l-.3.4v.3l-.3.2-.3.4zm-5.3 5.2-.6-.7.3-.2v-.2h.3l.2-.3v-.2h.3l.2-.2h.2v-.3h.2l.2-.3.2-.2h.2l.2-.3h.2v-.3l.3-.2h.2l.2-.3v-.2l.2-.2.2-.2h.2v-.3h.3v-.4h.3v-.3h.2v-.3l1 .6-.2.2-.2.3v.3l-.2.2h-.2l-.2.3v.2l-.3.2-.3.3v.2h-.3l-.2.3-.2.2h-.2l-.2.3-.2.2-.3.3-.3.3h-.2v.3l-.3.2h-.2v.3l-.3.2h-.2v.3h-.2l-.2.3zm-2.3 3.3v-1l-.3.2v-.2h.2v-.2l.2-.2v-.2l.2-.2v-.2l.2-.2v-.2l.2-.2v-.2h.2v-.2l.2-.2.2-.3.3-.3.8.6v.2l-.2.2-.2.2-.2.3v.2h-.2v.2l-.2.2v.2l-.2.2v.2h-.2v.4h-.2v.2l-.2.2v.2h-.5zm.3 0h-.2zm-5 .2v-1h4.7v1h-4.5zm0-1h.2zm0 0v1zm-4.7.8.6-.8h-.4 4.2l.2 1h-4.7l-.3-.2zm.3 0h-.2zm-2.4-3.2.7-.7v.2l.2.2.2.3.2.3.2.2v.2h.2v.4h.2v.4h.2v.4h.2v.4h.2v.2l-.5.8-.2-.2v-.2l-.2-.2v-.2h-.2v-.4h-.2v-.4l-.2-.2v-.2h-.2v-.2l-.2-.3-.2-.2-.2-.3-.2-.2zm-5.4-5.2 1-.6v.2l.2.3h.2v.3l.2.2h.2v.3h.3v.3l.2.2h.2l.2.3.2.2v.2l.3.2h.3l.2.3h.2l.2.2v.2h.2l.2.3h.2l.2.3h.2v.3l.3.2h.2v.3h.3v.3l-.6.8-.2-.2-.3-.3-.3-.2-.3-.2v-.2l-.2-.2h-.2l-.2-.3h-.2l-.2-.2h-.2v-.3l-.3-.2h-.2l-.2-.3v-.2h-.3l-.2-.3v-.2h-.3l-.2-.3v-.2l-.3-.2h-.2v-.3l-.3-.2-.2-.2-.2-.2zm2.7-6.7v1l-.6-.2h-2.1l-.2.2h-.2v.2h-.2v.4l-.2.2v1.1l.2.2v.3l.2.3v.2l.2.3.2.4v.3l.3.3.3.4.2.3.2.3-1 .6v-.4l-.3-.3-.2-.4-.2-.4v-.3l-.3-.4v-.4l-.3-.3v-.4l-.2-.3v-.6l-.2-.3v-1l.2-.2v-.2l.3-.2.2-.2.2-.2.4-.2h.3l.3-.2zm3-.5.8.8-.2.2h-.2l-.2.2h-.4l-.2.2h-3v-1h2.5l.2-.2h.4v-.2zm1.4-2.3.7.6v.3l-.2.2v.2h-.2v.4h-.2v.8h-.2v.2h-.2v.2l-.2.2-.8-.7h.2v-.4h.2v-.4h.2v-.2l.2-.2v-.4h.2v-.3h.2v-.3zm0 0 .2-.4zm2.3-2.4.5.8-.2.2h-.2v.2h-.2v.2h-.2l-.2.2-.2.2-.2.2v.2h-.2v.2l-.2.2-.2.2v.2l-1-.6.2-.2.2-.2v-.2h.2v-.2l.2-.2h.2v-.2l.2-.2.2-.2h.2v-.2l.2-.2h.2v-.2h.2zm2.8-.3v1h-2.4l-.5-.7h.2v-.2h.4l.2-.2zm3 .3-.5.8h-.4v-.2H482v-1h2.5l.2.2h.2zm0 0 .3.2zm2 3.2v-1l-.4.8-.2-.2v-.2h-.2v-.2l-.2-.2-.2-.2v-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.4v-.2h-.2v-.2l.4-.8h.2l.2.2.2.2h.2v.2h.2v.2h.2v.2h.2v.2h.2v.2l.2.2.2.2v.2h.2v.2h.2v.2zm.4-.8.5.8h-1zm-.4-.2v1l-.4-.2zm-.4.8-.5-.8h1l-.4.8z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "m481.4 212.8-1-.2c-.4-3.7-2-7-4.3-9.6 2.8 1.8 4.8 5.7 5.4 9.8z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#edb92e",
              d: "M494.2 198.3c-.5 1-1 2.4-2 3.5-1.5 1.6-4 .5-6.5-1.6-.8-.6-2.2-1-3.6-1a6 6 0 0 0-3.4 1c-2.5 2-5 3.2-6.6 1.6-1-1-1.5-2.4-2-3.5h2.5c1.3.3 2.6.3 3.4-.4.6-.6.3-1 1.3-2.5a7 7 0 0 1 2.2-2.3c1-.5 1.7-.2 2.6-.2 1 0 2-.3 2.8.2.8.5 1.5 1.3 2.2 2.3 1 1.6.7 2 1.3 2.4 1 .6 2.2.6 3.5.4 1-.2 1.8-.2 2.4 0z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "m492.6 202-.7-.6v-.2l.2-.2.2-.2v-.2h.2v-.2l.2-.2v-.2l.2-.2v-.2l.2-.2v-.2l.2-.2v-.2l.2-.3v-.4l1 .5v.4l-.2.2v.2l-.2.2v.4h-.2v.2l-.2.2v.3h-.2v.2h-.2v.2h-.2v.3l-.2.2-.2.2h-.2zm-7.3-1.4.7-.7h.2l.2.2.3.2.2.2.3.3h.3l.2.2h.2l.2.2h.2l.2.2h.2l.2.2h.4l.2.2h1.6l.2-.2.2-.2h.2v-.2l.8.7-.2.3h-.2v.3h-.3l-.3.2h-.3l-.2.2h-1.9l-.3-.2h-.3l-.2-.2h-.3l-.2-.2h-.3l-.2-.2-.2-.2h-.3l-.2-.3h-.3l-.2-.3-.2-.2-.2-.2-.2-.2-.3-.2zm.7-.7.5.3zm-4-.2v-1h2v.2h.7v.2h.4l.2.2h.2l.2.2h.2v.2h.2l-.7.8h-.2v-.2h-.2v-.2h-1v-.2h-1v-.2zm-3 .8-.7-.7v-.2h.2l.2-.2h.2v-.2h.2l.2-.2h.5v-.2h1.2v-.2h1v1h-1.5v.2h-.5l-.2.2h-.4v.2h-.2zm-7.3 1.5.7-.6.3.2.2.2h.2v.2h1.7v-.2h.5l.2-.2h.2v-.2h.3l.2-.2.2-.2h.3l.2-.3h.2l.2-.3.3-.2v-.2h.3l.7.6-.3.2-.2.2-.3.2-.2.2-.2.2h-.3l-.2.3h-.3l-.2.2h-.2l-.3.2h-.2l-.2.2h-.2l-.2.2h-.3l-.3.2H473l-.4-.2h-.2l-.2-.2-.2-.2zm-1.7-4 .2 1 .3-.7v.2l.2.2v.3l.2.2v.4l.2.2v.2h.2v.4h.2v.4h.2v.2h.2v.2h.2v.2l.2.2-.7.7h-.2v-.2h-.2v-.2h-.2v-.5h-.2v-.2h-.2v-.3l-.2-.2v-.2h-.2v-.4h-.2v-.4l-.2-.2v-.4h-.2l.4-.8zm-.4.7-.2-.6.6-.2zm3-.6-.2 1-.2-.2H470l-.2-1h2.4zm3-.5.7.8-.2.2h-.2l-.2.2h-.4l-.2.2h-2.8v-1h2.3l.2-.2h.4v-.2h.2zm.7.8-.5.4zm.6-3 .7.5v.3l-.2.2v.2h-.2v.4h-.2v.8h-.2v.2h-.2v.2l-.2.2-.8-.7h.2v-.4h.2v-.4h.2v-.2l.2-.2v-.4h.2v-.3h.2zm2.3-2.5.5.8-.2.2h-.2v.2h-.2v.2h-.2l-.2.2-.2.2-.2.2v.2h-.2v.2l-.2.2-.2.2v.2l-1-.6.2-.2.2-.2v-.2h.2v-.2l.2-.2h.2v-.2l.2-.2.2-.2h.2v-.2l.2-.2h.2v-.2h.2zm2.8-.3v1h-2.3l-.5-.7h.2v-.2h.4l.2-.2zm3 .3-.5.8h-.4v-.2H482v-1h2.5l.2.2h.2zm0 0 .3.2zm2.4 2.4-.8.6-.2-.2v-.2h-.2v-.2l-.2-.2-.2-.2-.2-.2v-.2h-.2v-.2h-.2v-.2h-.4v-.2h-.2v-.2l.4-.8h.2l.2.2.2.2h.2v.2h.2v.2h.2v.2h.2v.2h.2v.2l.2.2.2.2v.2h.2v.2h.2zm1.3 2.3-.7.8-.2-.2h-.2v-.4h-.2v-.4h-.2v-.4l-.2-.2v-.2l-.2-.2-.2-.3v-.2l.8-.6v.2h.2v.3l.2.2v.2h.2v.4h.2v.4h.2v.4h.2zm-.7.8-.3-.3zm3.8-.4v1h-2.4l-.2-.2h-.2l-.2-.2h-.4v-.2h-.2l.7-1v.2h.2v.2h.8l.2.2h1.9zm3 .5-1-.4.3.8H492l-.2-1h2.4l.5.7zm-.5-.7h.6l-.3.7zm0 .5.4.2zm0-.5h.6l-.3.7z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#edb92e",
              d: "M482 211.7c4.4 0 8 3.4 8 7.7s-3.6 7.8-8 7.8-7.6-3.5-7.6-7.8 3.5-7.8 7.7-7.8z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "m483 212.8.8-.2c.5-3.7 2-7 4.3-9.6a14.7 14.7 0 0 0-5 9.8z"
            }),
            /* @__PURE__ */ jsx262("use", {
              xlinkHref: "#rs_svg__b",
              width: 1350,
              height: 900,
              transform: "matrix(-1 0 0 1 964.3 0)"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#edb92e",
              stroke: "#21231e",
              d: "M577 293.6c2 .3 3 1.5 3 2.8 0 1.3-1 2.6-3 3a8.7 8.7 0 0 1-1.6.2c-60.8 5.2-125.7 5.2-186.5 0a8.7 8.7 0 0 1-1.6-.3c-2-.3-3-1.6-3-3 0-1.2 1-2.4 3-2.7a8.6 8.6 0 0 1 1.5-.3c60.7-5.2 125.6-5.2 186.4 0 .6 0 1 .2 1.5.3z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "M412 298.4h-.2v-.2h-.2v-1h.4v-.2.2-.2h2.3l.7-.2h3l.7-.2h3l.7-.2h3l.8-.2h3.3l.7-.2h3.8l.7-.2h.8v1.2h-2.9l-.7.2H428l-.7.2h-2.7l-.8.2H421l.7.2h3.7l.7.2h2.9l.7.2h3.7l.7.2h1.5v1.2h-3.7l-.7-.2h-3.8l-.7-.2h-2.9l-.7-.2H420l-.6-.2h-2.9l-.7-.2H413zv-.2zm46.8-3.3v1.3H453l-.7.2h-6.6l-.7.2h-5l-1 .2h-3.5v-1.2h3.5l.8-.2h5.2l.7-.2h5.9l.7-.2h6.8zm23.3 0v1h-13.7l-.7.2h-8.8v-1h1.4l.8-.2H482zm23.5 0v1.3h-11.1l-.7-.2H482v-1zm23.3 1v1h-5.2l-.8-.2h-5.2l-.7-.2h-6.5l-.8-.2h-4.3V295h.7l.7.2h7.5l.8.2h5l.8.2h5.1l.6.2h2.3zm23.4 1v.2h.4v1h-.2l-.2.2h-3l-.7.2h-2.2l-.7.2h-3.8l-.8.2h-2.8l-.7.2H534l-.8.2h-3.6l-.8.2v-1.2h2.2l.7-.2h3.7l.8-.2h3.7l.7-.2h1.8-1.4l-.8-.2h-2.7l-.7-.2H533l-.6-.2h-3.6V296h6.5l.7.2h3l.8.2h2.8l.7.2h3l.7.2h3l.7.2h1.5zm-116.7 1.4h.2l.2.2v.8h-.2v.2h-.2zm93.3 1.2h-.2l-.2-.2v-.2h-.2v-.8h.2v-.2h.4v1.2zm-50.3-36.2v-1h3.8v1h-4zm-1.2-1h1.2v1h-1.2zm-.6 0h.6v1h-.6zm-1 0h1v1h-1zm-.8 0h.6v1h-.7v-1zm-.5 0h.4v1h-.5v-1zm-.8 0h.8v1h-.8zm-1.2 0h1.2v1h-1.2zm-1 0h1v1h-1zm-.2 0h.2v1h-.2zm-1 0h1v1h-1zm-2.5 1v-1h2.6v1zm-.3-1h.2v1h-.2zm-.2 0h.2v1h-.2zm-1 0h1v1h-1zm-.5 0h.4v1h-.4zm-.4 0h.4v1h-.4zm-1.2 0h1.2v1h-1.2zm0 0v1zm0 1h-.2zm-1.2-1h1.2v1l-1.2.2v-1zm-.4 0h.4v1.2h-.4v-1zm-.8.2h.8v1h-.8zm0 0h.3-.2zm-.3 0h.3v1h-.3zm0 1h-.5zm-1-1h1v1h-1zm-1 0h1v1h-1zm-.2 0v1zm-1 0h1v1h-1zm-.6 0h.5v1h-.4v-1zm0 0v1zm-4.2 1.2v-1h3.5v-.2h.4v1h-2.7l-.2.2h-.8zm-.6-1h.5v1h-.6v-1zm-1.7 0h1.6v1h-1.7zm-.2 0h.3v1h-.2v-1zm-1.3 0h1.4v1h-1.3zm-1 0h1v1h-1zm-.6 0h.7v1h-.6zm0 0v1.2-1zm-1.6.2h1.5v1h-1.5zm0 0v1zm-1.2 0h1.2v1h-1.2zm0 0v1zm-1.2 0h1l.2 1H444v-1zm-.8 0h.8v1h-.7zm-1.6.2h1.6v1h-1.5zm0 0v1zm-6.2 1.3v-1h1.7l.2-.2h3.9v1H436l-.2.2zm-.4-1h.3v1h-.2zm-9 1.4v-1h1.3l.3-.2h3.2l.3-.2h3.5v1h-5.1l-.3.2H426zm-.3-1h.2v1h-.3v-1zm-.5 0h.5v1h-.4zm-18.2 2.2v-1h1.8l.5-.2h1.7l.5-.2h2.4l.6-.2h2.6l.6-.2h2.2l.6-.2h2.8l.6-.2h1.2v1h-2.1l-.6.2h-2.7l-.6.2h-2.3l-.6.2h-2.8l-.6.2h-2.2l-.5.2H408l-.6.2h-.6zm-.3-1h.3v1h-.2zm0 0v1zm-26.3 3.4v-1h.7l1-.2h.8l.8-.2h1.6l.8-.2h1l.7-.2h1.6l.8-.2h1.8l.8-.2h.8l1-.2h1.7l.7-.2h1.7l.8-.2h1.8l.7-.2h1.6l1-.2h1.5l1-.2v1H405l-.7.2h-1.7l-.8.2H400l-.7.2h-.8l-1 .2H396l-.8.2h-1.7l-.8.2H391l-.8.2h-.8l-.8.2H387l-1 .2h-.7l-.8.2H383l-1 .2h-.8l-.8.2zm0-7v1h-.5l-.5.2h-.5l-.3.2-.4.2-.3.2h-.2l-.3.3-.2.2-.3.3v.5l-.2.2v1.1h.2v.3l.2.2.2.2.3.3.3.2h.2l.3.2h.3l.4.2h1v1h-1.6l-.4-.2-.4-.2-.3-.2-.3-.2-.3-.2-.4-.2-.2-.3-.2-.2v-.3l-.3-.3-.2-.3v-1.6l.2-.3.2-.3.2-.4.2-.3.2-.3.4-.3.3-.2.4-.2.3-.2h.4l.5-.2h.6l.5-.2zm26.3-2.3v1H405l-.7.2h-1.7l-.8.2H400l-.7.2H396l-.8.2h-1l-.7.2H392l-1 .2h-1.6l-.8.2h-.8l-.8.2h-1.7l-.8.2h-.8l-.8.2H381l-.8.2v-1h1.7l.8-.2h.8l.8-.2h.8l.8-.2h1.7l.8-.2h1.6l1-.2h.8l.8-.2h1.8l.7-.2h1.7l1-.2h.7l.8-.2h1.8l.7-.2h1.6l1-.2h2.5zm0 1v-1zm37-3.2v1.2H439l-1 .2h-2.3l-1.3.2H431l-1.2.2h-2.2l-1.3.2H424l-1.2.2h-2.3l-1 .2H417l-1.2.2h-1.2l-1 .2h-2.3l-1.3.2h-1l-1.2.2h-1.2v-1h2.2l1.2-.2h1l1.2-.2h2.2l1.3-.2h1l1.2-.2h2.3l1-.2h2.3l1.3-.2h2.4l1.2-.2h2.3l1-.2h3.5l1.2-.2h3.5l1-.2h2.5zm1 1-1 .2v-1h1v1zm.2 0h-.3v-1l.2 1zm.2 0h-.3l-.2-1h.4v1zm1.2 0h-1.2v-1h1.2zm0 0v-1zm15.4-1.4v1h-5.5l-.5.2h-6.5l-.4.2h-2.6v-1h5l.5-.2h7.7l.5-.2zm.8 1h-.8v-1h.8zm0 0v-1zm1.4 0h-1.4v-1h1.4zm.2 0h-.2v-1h.2zm0 0h-.2zm0 0v-1zm1.2 0h-1.2v-1h1.2zm.5 0h-.6v-1h.4v1zm.6 0h-.7l-.2-1h.8zm1 0h-1v-1h1zm.2 0h-.3v-1h.2v1zm.4 0h-.4v-1h.4zm3-1 .2 1H468v-1h3.3zm1.2 1h-1v-1l1-.2v1zm0 0v-1.2 1zm1.3-.2h-1.2v-1h1.2zm3.5-1v1h-3.5v-1zm0 1v-1zm1.3 0h-1.2v-1h1.2zm3.6-1v1h-3.5v-1h3.7zm3.8 0v1H482v-1zm1 1h-1v-1h1.2v1zm.2 0v-1zm3.6-1v1H487v-1h4zm1 1h-1v-1h1.2v1zm.2 0v-1zm1 0h-1v-1h1zm3.3-1v1H493v-1h3zm.5 1h-.4v-1h.5zm.3 0h-.3v-1h.3zm1 0h-1v-1h1zm.6 0h-.7v-1h.8zm.5.2h-.6v-1h.5v1zm1 0h-1v-1h1zm0 0v-1zm0 0h.3zm.3 0h-.2v-1h.3zm1.3 0h-1.3v-1h1.4zm0 0v-1zm0 0h.2zm1 0h-1v-1h1zm15.2-.6v1h-6l-.4-.2H504l-.6-.2h-.9v-1h6l.4.2h6.6l.4.2h1.7zm0 1v-1zm1.3 0h-1v-1h1zm.4 0h-.3v-1h.5v1zm.2 0h-.2v-1h.2zm1 .2h-1v-1h1zm37 1v1h-2.3l-1.2-.2h-1l-1.2-.2h-2.2l-1.3-.2H546l-1-.2h-1.3l-1-.2h-2.3l-1.3-.2H537l-1-.2h-4l-1-.2h-2.6l-1-.2H524l-1-.2h-2.4v-1h4.7l1.2.2h3.3l1.3.2h2.3l1.3.2h2.3l1 .2h2.4l1 .2h2.3l1.3.2h2.3l1 .2h2.3l1.2.2h1.2l1 .2h1.3l1 .2h1.3zm0 1v-1zm26.4 1.4v1H582l-.8-.2h-.8l-.8-.2H578l-.7-.2h-.8l-.8-.2H574l-.8-.2h-.8l-.8-.2h-1.8l-.7-.2h-1.5l-.8-.2H565l-.8-.2h-1.7l-.8-.2H560l-.8-.2h-1.6v-1h3.5l.8.2h1.6l1 .2h1.7l.7.2h1.7l.8.2h1.8l.7.2h.8l.8.2h1.8l.8.2h.8l.8.2h1.8l.7.2h.7l.8.2h1.8zm0 7v-1h1.6l.3-.2h.3l.3-.2.2-.2.2-.2h.2v-.3l.2-.2v-.2h.2v-1.4l-.2-.3v-.2h-.3l-.2-.3-.3-.2h-.2l-.3-.3-.4-.2h-.4l-.4-.2h-.4l-.5-.2v-1h.5l.6.2h.5l.5.3.4.3.4.2.3.2.4.3.3.3.2.3v.3l.3.2v.3l.2.3v1.3l-.3.3v.3l-.3.3-.3.4-.3.2-.3.2-.2.2-.3.2-.4.2h-.3l-.4.2H584zm-26.5-2.4v-1h1.8l.8.2h1.8l.8.2h1.8l.7.2h1.7l1 .2h.7l.8.2h1.8l.7.2h1.6l.8.2h1l.8.2h1.6l.8.2h1l.7.2h1.5l.8.2h1l.7.2v1h-1l-.8-.2h-1.6l-.8-.2h-.8l-.8-.2h-1.7l-.8-.2h-.8l-1-.2h-1.6l-.8-.2h-.8l-1-.2h-1.4l-.8-.2H566l-.7-.2h-1.6l-1-.2H561l-1-.2h-1.6zm0-1v1zm-.2 0h.3v1h-.4v-1zM539 265v-1h2.9l.5.2h3l.5.2h2.3l.6.2h2.2l.6.2h2.3l.5.2h2.4l.5.2v1h-1.7l-.5-.2h-2.3l-.6-.2H550l-.7-.2H547l-.6-.2h-2.9l-.6-.2H540l-.6-.2h-.6zm-.4-1h.5v1h-.4v-1zm-.2 0h.2v1h-.2zm-9.2.5v-1h4l.3.2h3.2l.3.2h1.3v1h-1.6l-.3-.2H533l-.4-.2h-3.3zm-.3-1h.2v1h-.3zm-6.4.7v-1h4.5l.2.2h1.7v1h-4.4l-.2-.2h-1.7zm0-1v1zm-1.5 0h1.7v1H521zm-.7 0h.8v1h-.7zm-1-.2h1v1H519zm-.2 0h.2v1-1zm-1 0h1v1h-1zm-.2 0v1zm-1.4 0h1.4v1h-1.4zm-.2 0h.2v1h-.2zm-.6 0h.6v1h-.7v-1zm-1 0h1v1h-1zm-1.4-.2h1.4v1h-1.4zm-.2 0h.2v1h-.2zm-1.6 0h1.6v1h-1.6zm-.6 0h.6v1h-.6zm-4.2 1v-1.2h3.3l.2.2h.8v1zm0-1.2v1zm-.5 0h.6v1h-.5zm-1 0h1v1h-1zm0 0v1zm-1.3 0h1.2v1h-1.3v-1zm-1 0h1v1h-1zm0 1h.6zm-.2-1h.3v1h-.3zm0 0h-.3zm-.8 0h.8v1h-.8zm-.4 0h.4v1h-.4zm-1.2 0h1.3v1H500v-1zm0 1h.2zm0-1v1zm-1 0h1v1h-1zm-.5 0h.4v1h-.6v-1zm-.4 0h.5v1h-.4zm-1 0h1v1h-1zm-.2 0h.2v1h-.2zm-.3 0h.3v1h-.3zm-2.6.8v-1h2.3v1H494zm-1-1h1v1h-1zm-.2 0h.2v1h-.2zm-1 0h1v1h-1zm-1.2 0h1.2v1h-1.3v-1zm-.8 0h.8v1h-.8zm-.4 0h.4v1h-.5v-1zm-.7 0h.7v1h-.7zm-1 0h1v1h-1zm-.7 0h.6v1h-.6zm-1.2 0h1.2v1H486v-1zm-3.7 1v-1h3.9v1h-4.1zm.4 1.8L460 276.6l-.4-1 22.7-11.3h.4v1zm-.5-1h.4-.5zm22.7 12.4-23-11.4.4-1 22.7 11.5v1h-.3zm.4-1 1 .6-1 .4zm-23 11.6 22.7-11.5.4 1-22.6 11.4h-.5v-.8zm.4 1h-.3zM460 275.7l22.8 11.5-.5 1-22.8-11.6v-1h.4zm-.4 1-1-.5 1-.5z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#0c4076",
              d: "M482 269c5.8 0 10.4 3.2 10.4 7s-4.6 7-10.3 7-10-3.2-10-7 4.5-7 10-7z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "M493 276h-1v-.3l-.2-.3v-.5l-.2-.3v-.3l-.3-.3-.2-.4v-.3l-.3-.2-.2-.2-.2-.3-.3-.2-.3-.3-.3-.2-.3-.2-.2-.2-.4-.2-.4-.2-.3-.2-.4-.2h-.5l-.4-.3h-.4l-.5-.2h-.8l-.5-.2h-1.9v-1.2h1.7l.6.2h.5l.5.2h.5l.5.2h.4l.5.3.4.2.5.2h.5l.4.3.3.2.4.2.3.3.4.3.3.2.3.3.3.3.2.4.3.3.2.4.2.4.2.4v.3l.2.5v.4l.2.2v.8zm-11 7.4v-1h1.6l.5-.2h1.1l.5-.2h.5l.4-.3h.4l.5-.3h.4l.3-.3h.4l.4-.3.3-.2.4-.3.3-.2.3-.2.3-.3.2-.3.2-.2.3-.3v-.3l.3-.3h.2v-.4l.2-.3v-.7l.2-.3v-.3h1v.4l-.2.4v.4l-.2.4v.3l-.2.3-.2.3-.2.4-.2.3-.3.3-.2.3-.3.2-.3.3-.3.3-.4.3-.3.3-.4.2-.4.3-.5.2-.4.2-.4.2h-.4l-.5.3h-.4l-.5.3h-.5l-.5.2h-1.1l-.5.2zm-10.6-7.4h1v1l.2.3v.3l.2.2.2.3v.4l.3.3.2.3.3.2.2.3.3.3.3.2.3.2.2.3.3.2.4.2h.2l.4.3h.4l.4.3h.5l.3.3h.9l.5.2h1.5l.6.2h.5v1h-1.9l-.5-.2h-.5l-.5-.2-.5-.2h-.4l-.5-.3h-.4l-.4-.3-.4-.2-.4-.2-.4-.3-.4-.2-.3-.2-.4-.2-.4-.3-.3-.3-.3-.3-.2-.4-.3-.3-.2-.3-.2-.4v-.3l-.2-.4-.2-.4v-.8l-.2-.4v-.4zm10.7-7.4v1h-1.3l-.5.2h-.3l-.5.2h-.5l-.4.2h-.4l-.6.3h-.4l-.4.3-.4.2-.3.2-.5.2-.3.2-.3.2-.4.2-.3.3-.3.2-.2.3-.3.3-.2.3-.2.3v.3l-.2.2v.3l-.2.3v.7l-.2.3v.3h-1V275l.2-.5.2-.4v-.2l.3-.4.3-.3.2-.3.3-.3.2-.3.3-.2.3-.3.3-.2.3-.3.3-.3.4-.2.4-.2.4-.2h.4l.4-.3.5-.2.5-.2h.5l.5-.2h1l.5-.2h1.1l.6-.2h.5z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#edb92e",
              d: "M482 211.7c4.4 0 8 3.4 8 7.7s-3.6 7.8-8 7.8-7.6-3.5-7.6-7.8 3.5-7.8 7.7-7.8z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "M490.4 219.4h-1v-1l-.2-.3v-.4l-.2-.3v-.4l-.2-.4v-.3l-.3-.3-.2-.3-.2-.3v-.3l-.3-.2-.2-.3-.2-.2-.3-.2-.3-.2-.2-.2-.3-.2-.3-.2-.4-.2h-.3l-.3-.3h-.4l-.3-.2h-.4l-.4-.2H482V211l.6.2h1.2l.4.2h.4l.4.2.3.2.4.2h.4l.4.3.3.3.4.2.4.2.3.3.3.3.2.3.3.2.2.3.3.3.2.3.2.5.2.3v.4l.3.4v.8l.2.4v.8l.2.4zm-8.3 8.3v-1h1.5l.3-.2h.3l.3-.2.4-.2h.3l.3-.2h.3l.2-.3.3-.2.2-.2.3-.2.3-.2.2-.3.2-.2.2-.2v-.3l.3-.3.2-.3.2-.4v-.3l.2-.4v-.7l.2-.4v-.8l.2-.4v-.4h1v1.2l-.2.4v.5l-.2.4v.3l-.3.4v.3l-.3.4-.2.3-.2.4-.3.4-.2.3-.3.3-.2.3-.3.3-.3.2-.3.3-.3.3-.3.2-.3.2-.3.2h-.4l-.3.2-.4.2h-.4l-.4.2H482zm-8-8.3h1v1.8l.2.3.2.3v.3l.2.3.2.3.2.2.2.3.2.3.2.3.2.3.2.3.3.2.2.3.3.3.3.2.4.2h.3l.3.3h.3l.4.3h.3l.3.2h.7l.4.2h.7v1h-1.6l-.4-.2h-.3l-.4-.3h-.4l-.4-.3-.4-.3-.3-.2-.5-.2-.3-.2-.3-.2-.4-.2-.3-.3-.3-.3-.2-.3-.3-.3-.2-.3-.2-.3v-.3l-.3-.4v-.3l-.3-.4v-.4l-.2-.5v-.4l-.2-.3zm8-8.3v1.2h-1.3l-.4.2h-.3l-.3.2h-.4l-.3.3h-.3l-.3.2-.3.2-.2.2-.3.2-.2.3-.3.3-.2.2-.2.3-.2.3-.2.4-.2.3-.2.3-.2.3v.3l-.2.3-.2.3v.7l-.2.3v1.1h-1v-1.6l.2-.4v-.4l.2-.4.2-.4v-.4l.3-.3v-.4l.3-.2.2-.3.3-.3.2-.3.3-.4.3-.3.3-.3.2-.2.3-.2.4-.3.2-.2h.4l.3-.2.3-.2h.4l.4-.2h.5l.4-.2h1.1z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#edb92e",
              d: "M482 213.7c3.3 0 5.8 2.6 5.8 5.7 0 3.2-2.5 5.8-5.7 5.8-3 0-5.5-2.6-5.5-5.8 0-3 2.5-5.7 5.6-5.7z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "M488.3 219.4h-1V218h-.2v-.7l-.2-.2v-.2l-.2-.3-.2-.2v-.2l-.3-.2-.2-.2-.2-.2-.2-.2h-.2l-.2-.3h-.4l-.2-.3h-.2l-.3-.2h-.6l-.2-.2H482v-1h1.8l.3.2h.3l.2.2h.3l.3.3h.4l.2.3h.2l.3.3.3.2.2.2.2.2.2.3v.2l.3.3v.2l.3.3v.2l.2.3.2.3v.6l.2.2v1.3zm-6.2 6.3v-1h1.1l.2-.2h.3l.2-.2h.2l.2-.2h.4l.2-.2.2-.2h.2l.2-.3.2-.2h.2v-.2l.3-.2v-.2l.3-.3.2-.3v-.2l.2-.3v-.2l.2-.3v-1.3h1v2l-.2.3-.2.3-.2.4-.2.3v.2l-.3.2v.2l-.3.2-.2.3h-.2l-.2.3h-.2l-.2.3-.3.2h-.2l-.2.3-.3.2h-.2l-.3.2h-.3l-.3.2h-1.4zm-6-6.3h1v1.3l.2.3v.2l.2.3v.2l.2.2.2.4.2.2v.2h.3l.2.3.2.3v.2h.3l.2.3h.3l.2.2h.2v.2h.4l.2.2h.2l.3.2h.9v1h-1.5l-.3-.2h-.3l-.3-.2h-.2l-.3-.3-.3-.2-.3-.2-.3-.2h-.2l-.2-.3h-.2l-.2-.4-.2-.2-.2-.2-.2-.3-.2-.3v-.3l-.2-.3h-.2v-.4l-.2-.3v-.6l-.2-.3v-.9zm6-6.2v1H481l-.2.2h-.4l-.3.2-.3.3h-.5l-.2.3h-.2v.3l-.3.2h-.2l-.2.3v.3l-.2.2v.2l-.2.3v.2l-.2.2v.2l-.2.3v.4l-.2.2v.7h-1V218l.2-.4v-.3l.2-.3.2-.3v-.2l.2-.3.2-.2.2-.3.2-.2.2-.3.2-.2.2-.2.2-.2.2-.2h.3l.2-.3h.2l.3-.2h.2l.3-.2h.3l.3-.2h.5l.3-.2h.6z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#0c4076",
              d: "M482 215.8c2 0 3.7 1.6 3.7 3.6S484 223 482 223c-1.8 0-3.4-1.6-3.4-3.6s1.6-3.6 3.5-3.6z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "M486.2 219.4h-1v-.8h-.2v-.3l-.2-.2v-.2l-.2-.2-.2-.2-.2-.3h-.2l-.3-.2h-.2l-.2-.2h-.2v-.2H482v-1h1.4v.2h.5v.2h.3v.2h.3v.3h.3v.2l.2.2.2.3.2.3v.2l.2.2.2.3v.4l.2.2v.6zm-4 4.2v-1h.6v-.2h.5l.3-.2h.2l.2-.2v-.2h.2v-.2h.2v-.2h.2v-.2l.2-.2v-.2l.2-.2v-.4h.2v-1h1v1l-.2.2v.2l-.2.2v.2l-.2.2-.2.3-.2.2-.2.2-.3.2-.3.3h-.3l-.3.2-.3.2h-1l-.3.2zm-4-4.2h1v1.3l.2.2v.2l.2.2.2.2.2.2.2.2.2.2h.2v.2h.4l.2.2h.8v1.2h-.7l-.2-.2h-.3v-.2h-.5l-.2-.2-.3-.3h-.2v-.2l-.2-.2h-.2v-.2l-.2-.3-.2-.3v-.2l-.2-.2-.2-.3v-1.4zm4-4v1h-1l-.2.2h-.2l-.2.2h-.2v.2h-.2l-.2.3-.2.2-.2.2-.2.3v.4h-.2v1h-1V218l.2-.2.2-.3v-.2l.2-.2.2-.2.3-.3.2-.2.2-.2h.2l.2-.2h.2l.2-.2h.3l.3-.2h.9z"
            })
          ]
        }),
        /* @__PURE__ */ jsx262("path", {
          fill: "#c6363c",
          d: "M314.6 301.2v271.3c0 48.5 18.8 92.6 49.2 124.6A162.9 162.9 0 0 0 482 749a163 163 0 0 0 118.5-51.7c30.4-32 49.2-76 49.2-124.5V301.2h-335z"
        }),
        /* @__PURE__ */ jsx262("path", {
          fill: "#fff",
          d: "M313.4 300v277l.2 4.6.3 4.5.3 4.6.5 4.4.5 4.5.7 4.3.8 4.4 1 4.3 1 4.2 1 4.3 1.2 4.2 1.3 4 1.4 4.2 1.4 4 1.7 4 1.6 4 1.8 4 2 3.8 1.8 3.8 2 3.7 2 3.7 2.2 3.6 2.2 3.6 2.4 3.5 2.4 3.6 2.4 3.4 2.6 3.3 2.6 3.2 2.7 3.2 2.8 3 3 3.2 1.6-1.7-2.8-3-2.7-3-2.6-3.3-2.5-3.2-2.7-3.3-2.4-3.3-2.5-3.4-2.2-3.5-2.3-3.5-2-3.6-2-3.6-2-3.7-2-4-1.8-3.7-1.7-3.8-1.6-4-1.7-4-1.4-4-1.5-4-1.2-4-1.2-4.2-1-4-1-4.3-.8-4.3-.8-4.3-.7-4.3-.6-4.2-.4-4.5-.4-4.4-.2-4.5-.2-4.5V302.5h332.7V577l-.2 4.5-.3 4.4-.3 4.3-.5 4.5-.6 4.3-.7 4.4-1 4.3-.8 4.3-1 4.2-1 4-1.2 4.3-1.3 4-1.3 4-1.4 4-1.6 4-1.6 4-1.7 3.8-1.7 3.8-2 4-2 3.6-2 3.6-2 3.6-2.3 3.5-2.3 3.5-2.3 3.4-2.5 3.3-2.6 3.3-2.6 3.2-2.6 3.2-2.7 3-2.8 3-3 3-2.8 3-3 2.7-3 2.6-3.3 2.6-3 2.6-3.4 2.4-3.3 2.5-3.3 2.3-3.4 2.2-3.5 2.2-3.5 2-3.5 2-3.6 2-3.7 1.7-3.7 1.8-3.8 1.7-3.8 1.5-3.8 1.4-4 1.3-3.8 1.3-4 1-4 1-4 1-4 1-4.2.6-4 .6-4.3.5-4 .4-4.3.4-4.3.2H482v2.4h4.5l4.3-.2 4.3-.3 4.4-.4 4.2-.4 4.2-.6 4.2-.8 4-.8 4.2-1 4-1 4-1.2 4-1.2 4-1.4 4-1.4 3.8-1.6 3.7-1.6 3.8-1.7 3.7-2 3.7-1.8 3.5-2 3.5-2 3.6-2.3 3.4-2.2 3.4-2.4 3.3-2.5 3.3-2.4 3.2-2.6 3.2-2.7 3-2.7 3-2.8 3-3 3-3 2.8-3 2.8-3 2.7-3.3 2.6-3.2 2.5-3.3 2.5-3.4 2.4-3.5 2.3-3.4 2.3-3.6 2-3.6 2.2-3.7 2-3.7 2-3.8 1.7-4 1.8-3.8 1.6-4 1.6-4 1.4-4 1.4-4 1.3-4.2 1.2-4.2 1-4.3 1-4.2 1-4.3.7-4.4.7-4.3.5-4.5.5-4.4.4-4.5.3-4.4V577l.2-4.5V300z"
        }),
        /* @__PURE__ */ jsxs237("g", {
          fill: "#fff",
          stroke: "#21231e",
          children: [
            /* @__PURE__ */ jsx262("path", {
              d: "M483.7 734.8c1.4-.2 4 0 5.7-1.4 2.5-2 1.5-9.8 1.3-14.8-1-25.3-2.2-68-3.5-128-2-.2-3.6 0-5 .2a12 12 0 0 0-5 0c-1.4 59.8-2.5 102.5-3.6 127.8-.2 5-1.2 13 1.3 14.8 1.7 1.5 4.2 1 5.6 1.4h3z"
            }),
            /* @__PURE__ */ jsx262("path", {
              d: "M499.6 734c-1.5 0-4 .5-6-.8-2.6-1.7-2.8-9.7-3-14.7a6148 6148 0 0 0-7.6-127.6c2-.6 3.6-.6 5-.5.3 0 .5 0 .7-.2 9.6 59.2 13.2 101.2 19.7 126.5 1 3.5 2.8 12.2-.2 15-1.7 1.7-4.2 1.6-5.6 2z"
            }),
            /* @__PURE__ */ jsx262("path", {
              d: "M518.2 731.4c-1.5 0-3.8.8-6-.3-2.7-1.4-2.6-9.4-3.8-14.2-6.6-25.3-10.2-67.3-19.7-126.5 2-.7 3.6-.8 5-1h.2c15 57.6 19.6 98.2 31.4 123.2 1 3.5 4 12.7 1.2 16-1.5 1.7-4 1.8-5.4 2.3l-3 .6z"
            }),
            /* @__PURE__ */ jsx262("path", {
              d: "M537 726c-1.5.3-4 1.6-6 .7-3-1.2-3.5-9.7-5.6-14.2-11.8-25-16.3-66-31.7-124 2-.8 3.5-1 5-1.3 1.3-.6 1-1 3-1.2 18 57.3 23.7 97 40.5 121.8 2.7 4 4.7 12 3 14.5-1.5 2-4 2.3-5.3 3zm-72.2 8c1.4 0 3.8.5 5.8-.8 2.7-1.7 3-9.7 3-14.7a7227 7227 0 0 1 7.7-127.6c-2-.6-3.6-.6-5-.5a25.4 25.4 0 0 0-.7-.2c-9.6 59.2-13.2 101.2-19.7 126.5-1 3.5-3 12.2 0 15 1.8 1.7 4.3 1.6 5.7 2l3 .3z"
            }),
            /* @__PURE__ */ jsx262("path", {
              d: "M446 731.4c1.6 0 4 .8 6-.3 2.8-1.4 2.7-9.4 4-14.2 6.4-25.3 10-67.3 19.6-126.5-2-.7-3.6-.8-5-1h-.3c-15 57.6-19.6 98.2-31.4 123.2-1.2 3.5-4.2 12.7-1.3 16 1.5 1.7 4 1.8 5.4 2.3l3 .6z"
            }),
            /* @__PURE__ */ jsx262("path", {
              d: "M427.3 726c1.5.3 4 1.6 6 .7 3-1.2 3.5-9.7 5.6-14.2 11.7-25 16.2-66 31.6-124-2-.8-3.5-1-5-1.3-1.3-.6-1-1-3-1.2-18 57.3-23.7 97-40.5 121.8-2.6 4-4.6 12-2.8 14.5 1.4 2 4 2.3 5.2 3l3 .8zm99.7-43c-1.3 0-3.3 1-5.4 0-2.8-1.4-4.6-9-6-14-12-23.5-23-65.3-40.8-123.4 1.8-.7 3-1 4.5-1 1-.5 2.4-1 4.3-1.2 19.3 57.5 28 99 46.7 122 3 3.8 5.4 12 4 14.4-1.2 1.8-3.4 2-4.6 2.6z"
            }),
            /* @__PURE__ */ jsx262("path", {
              d: "M512 685.8c-1.5 0-3.6.6-5.6-.5-2.6-1.6-3.5-9.4-4.5-14.3-5-25-13.7-67-26.3-126 1.8-.7 3.2-.8 4.5-.8 1.2-.4 2.6-.8 4.5-.8 15 58.7 18.3 102.6 32.4 125 2.6 4.2 4 12.5 2.3 14.8-1.3 1.7-3.5 1.7-4.8 2.2l-2.7.4z"
            }),
            /* @__PURE__ */ jsx262("path", {
              d: "M496.4 687.6c-1.4-.2-3.5.3-5.4-1-2.4-1.7-2.4-9.6-2.8-14.6-2-25.3-6-68-11.6-127.6 2-.5 3.3-.4 4.6-.3 1.2-.2 2.6-.5 4.5-.4 8 59.6 12.8 102.8 18 127.2 1 5 2.4 12.6.4 14.8-1.4 1.5-3.6 1.4-5 1.8l-2.6.2z"
            }),
            /* @__PURE__ */ jsx262("path", {
              d: "M437.2 682.8c1.4 0 3.4 1 5.5 0 2.8-1.4 4.6-9 6-14 12-23.5 23-65.3 40.8-123.4-1.8-.7-3-1-4.5-1-1-.5-2.4-1-4.3-1.2-19.3 57.5-28 99-46.7 122-3 3.8-5.4 12-4 14.4 1.2 1.8 3.4 2 4.6 2.6z"
            }),
            /* @__PURE__ */ jsx262("path", {
              d: "M452.4 685.8c1.4 0 3.5.6 5.5-.5 2.5-1.6 3.4-9.4 4.4-14.3 4.8-25 13.6-67 26.2-126-1.8-.7-3.2-.8-4.5-.8a12 12 0 0 0-4.4-.8c-15 58.7-18.3 102.6-32.4 125-2.5 4.2-4 12.5-2.2 14.8 1.3 1.7 3.5 1.7 4.7 2.2z"
            }),
            /* @__PURE__ */ jsx262("path", {
              d: "M468 687.6c1.3-.2 3.4.3 5.3-1 2.4-1.7 2.4-9.6 2.8-14.6 2-25.3 6-68 11.7-127.6-2-.5-3.3-.4-4.6-.3-1-.2-2.5-.5-4.4-.4-8 59.6-12.8 102.8-18 127.2-1 5-2.4 12.6-.4 14.8 1.5 1.5 3.7 1.4 5 1.8l2.7.2z"
            }),
            /* @__PURE__ */ jsx262("path", {
              d: "M483.5 688c1.3 0 3.5.2 5.2-1.3 2.3-2 1.4-9.8 1.2-14.8-1.2-25.4-2-68-3.3-128a14 14 0 0 0-4.6 0c-1.2-.2-2.5-.3-4.4 0-1.2 60-2 102.6-3.2 128-.2 5-1 12.8 1.2 14.7 1.6 1.5 4 1 5.2 1.4z"
            }),
            /* @__PURE__ */ jsx262("path", {
              d: "M516.5 648c-1 0-2.5 1-4 0-2.3-1.5-3.7-9.2-4.8-14-9.2-23.5-17.5-65.4-31.2-123.5 1.4-.7 2.4-1 3.4-1 .8-.5 1.8-1 3.3-1 14.7 57.4 21.3 99 35.7 121.8 2.4 3.8 4 12 3 14.5-.8 1.8-2.5 2-3.4 2.5z"
            }),
            /* @__PURE__ */ jsx262("path", {
              d: "M505 651c-1 0-2.7.6-4.3-.6-2-1.5-2.7-9.4-3.4-14.3-3.7-25-10.5-67-20-126 1.3-.6 2.3-.7 3.4-.7 1-.4 2-.7 3.4-.8 11.5 58.7 14 102.6 25 125.2 2 4 3 12.4 1.6 14.6-1 1.7-2.7 1.8-3.6 2.2l-2 .5z"
            }),
            /* @__PURE__ */ jsx262("path", {
              d: "M493 652.7c-1 0-2.6.4-4-1-2-1.7-2-9.6-2.2-14.5-1.5-25.4-4.5-68-9-127.7 1.5-.4 2.6-.4 3.6-.3 1-.3 2-.6 3.5-.4 6 59.6 9.7 102.7 13.6 127 .7 5 2 12.8.4 15-1.2 1.5-3 1.4-4 1.7z"
            }),
            /* @__PURE__ */ jsx262("path", {
              d: "M447.8 648c1 0 2.5 1 4 0 2.3-1.5 3.7-9.2 4.8-14 9.2-23.5 17.5-65.4 31-123.5-1.2-.7-2.2-1-3.2-1-1-.5-2-1-3.4-1-14.7 57.4-21.3 99-35.7 121.8-2.4 3.8-4.2 12-3 14.5.8 1.8 2.5 2 3.4 2.5z"
            }),
            /* @__PURE__ */ jsx262("path", {
              d: "M459.4 651c1 0 2.6.6 4-.6 2.2-1.5 3-9.4 3.6-14.3 3.7-25 10.5-67 20-126a7.7 7.7 0 0 0-3.4-.7c-1-.4-2-.7-3.4-.8-11.4 58.7-14 102.6-24.8 125.2-2 4-3 12.4-1.7 14.6 1 1.7 2.7 1.8 3.6 2.2l2 .5z"
            }),
            /* @__PURE__ */ jsx262("path", {
              d: "M471.3 652.7c1 0 2.6.4 4-1 2-1.7 2-9.6 2.2-14.5 1.5-25.4 4.5-68 9-127.7a9.5 9.5 0 0 0-3.6-.3c-1-.3-2-.6-3.6-.4-6.2 59.6-9.8 102.7-13.7 127-.7 5-2 12.8-.4 15 1.2 1.5 3 1.4 4 1.7l2 .2z"
            }),
            /* @__PURE__ */ jsx262("path", {
              d: "M483.2 653.2c1-.2 2.7 0 4-1.4 1.7-2 1-9.7 1-14.7-1-25.3-1.6-68-2.5-128-1.5-.2-2.6 0-3.6.2-.8-.2-2-.4-3.4 0-1 59.8-1.6 102.5-2.4 128 0 5-.8 12.7 1 14.6 1.2 1.5 3 1.2 4 1.4h2z"
            }),
            /* @__PURE__ */ jsx262("path", {
              d: "M475 559c-.2 4.4-.3 9-.3 14l-10.6 2.3c0 4.8 12 55.4 18 55.4 6.3 0 18.2-50.6 18.2-55.5l-10.6-2v-.2c0-5 0-9.6-.2-14-2.2 2-4.7 5.2-7.3 8-2.4-2.8-5-6-7-8z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs237("g", {
          id: "rs_svg__d",
          children: [
            /* @__PURE__ */ jsx262("path", {
              fill: "#edb92e",
              stroke: "#21231e",
              d: "M412 584.5c-3 .2-7 2-18.5 12-5 10.2-10 20.5-17 29.4-2.4 1.4-4.2 2.5-6 3.2a84 84 0 0 1-17-.5c-4.4-4-11.3-1.2-9 3.2-1.8 1.6 2.2 7.8 5.3 5.2 3-2.4 13-.2 16.4-1.4-1.3 3-10.4 5-16.8 5.5-5.8.2-5.4 6-3 10.5 2.7 1.8.5-.4 1.4.8 2.6 4 8.2 3.4 8.4-.4.2-4 13.8-9 15.8-12-2.5 6-8.2 11.5-11 17.3-3 3-5 3.7-1 10 4.4-.6 4.6-1.7 7.3.8 6-.6 7-2.4 6-7.2-1-5 3.2-14 4.6-16.6 1.2-2.4 1.5-4.8 2.8-6.3 2.2-2.5 12.6-7.7 15.2-6.3 5 2.7 8.7 1 9.3-3.7-1.6-1.2-.4-8-3.8-8.2-2.8-.3-4.4.6-7 2.7-4 3.2-6 5-7.4 4.6-3-.7 5.8-5 13.8-15.6 11-14.5 11.8-22 11.3-27z"
            }),
            /* @__PURE__ */ jsx262("use", {
              xlinkHref: "#rs_svg__c",
              width: 1350,
              height: 900,
              transform: "matrix(-1 0 0 1 801.6 0)"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#edb92e",
              stroke: "#21231e",
              d: "M345.2 634.5c-4-2.3-6.3-2.2-8-.5-.7 1-1.8.5-1.2-1 2.7-6.3 7-7 10.7-4.2l2.8 2.7c-.6 1-3.8 2.3-4.3 3zm57.4-5.6c4.3-3 8.3-3.6 10.5-2 1.3 1 2.5.3 1.4-1.2-4.4-6.2-9.6-6.5-13.5-3-1.2 1-2 2-2.8 3 1.3 1.6 4.3 3.2 4.4 3zM369 664.4c.2-.2-1-5.4-2.6-7-1.4 1-3 2-4.3 3.5-4.2 4.5-4 11 2.5 16.7 1.6 1.5 2.4 0 1.7-1.7-1-2.7.3-6.3 3-11.5zM352.6 651c-4 1.6-5.4 3.7-5.2 6.4 0 1.5-1 2-1.5.3-4.8-11.2.2-13.3 7.5-13 .4 2-.7 6.2-.8 6.2z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "m384 621.3 1 .6h-.2v1.8h.2v.4h.2v.2h.2l.2.3.3.2v.2h.4l.2.3h.2l-.6 1h-.2l-.3-.2h-.2l-.2-.2-.2-.2-.3-.3-.3-.3v-.2h-.2v-.3l-.2-.2v-.2h-.2v-.2l-.2-.2V622l.2-.3v-.2zm6.5.8-.8 1-.2-.2-.3-.2-.2-.2-.2-.2h-.3l-.2-.3-.2-.3-.3-.2-.2-.2-.3-.2h-.7l-.2-.2h-.7v.2h-.2l-.2.2v.2h-.2v.3l-.2.2-1-.7v-.3l.2-.2.2-.2.2-.2.3-.3h.3l.2-.2h.4v-.2h.8l.2.2h.4l.2.2h.2l.2.2h.2l.2.3h.2l.2.3h.2l.3.3.2.3.2.2.3.2.2.2h.3z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "m387.3 617.6 1 .6v.4h-.2v.8l.2.2v.2l.2.2v.2l.2.2.2.3.3.2h.2l.2.2h.2l.2.2.2.2h.2l-.6 1h-.2l-.3-.2-.3-.3h-.2l-.2-.2-.2-.2-.2-.3v-.2h-.2l-.2-.2v-.2h-.2v-.5h-.2V618h.2v-.3zm6.5.8-.7 1-.2-.3h-.2l-.2-.3-.3-.2-.3-.3h-.2l-.2-.3-.2-.2-.3-.2-.3-.2h-.3v-.2h-.8l-.2.2-.2.2-.2.2v.2l-.3.2-1-.6.2-.3v-.2h.3v-.3h.3l.3-.3h.2l.2-.2h.2v-.2h1.4l.2.2h.2v.2h.3l.3.3h.2l.2.2h.2l.2.3h.2l.3.3v.2l.3.2.3.2z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "m391 612.8 1 .6-.2.2v.6h-.2v1l.2.3v.3h.2v.4h.2l.2.3v.2h.2l.2.2.2.2.3.3.3.2h.2l.2.2-.6 1-.3-.2-.2-.2-.2-.2-.3-.2-.2-.2v-.2l-.3-.2v-.2l-.3-.2v-.2l-.3-.2v-.4l-.2-.3v-.2h-.2v-.7h-.2v-1l.2-.3v-.4l.2-.3zm7 1-.8 1-.3-.3-.3-.2-.3-.3-.3-.2v-.2l-.3-.2-.3-.2-.2-.2-.2-.2-.2-.2h-.2l-.2-.2-.3-.2h-.2l-.2-.2h-.7l-.2.2-.2.2-.3.3v.2h-.2v.4l-1-.6v-.3l.2-.2.2-.3v-.2l.3-.2.2-.2v-.2h.3l.2-.2h.3l.2-.2h1.2l.2.2h.2l.2.2.3.2h.3l.2.3.2.2h.3l.2.3.3.2.2.2.3.2.2.2.3.2.2.3.3.2z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "m394.8 607.7 1 .5v.5l-.2.3v1.7l.2.2v.3l.2.2v.2l.2.2.3.3v.2l.3.2.2.2h.2l.2.3.2.2.3.2v.2l-.6.8-.3-.2v-.2l-.4-.2-.2-.3-.3-.3v-.2l-.3-.3-.2-.2v-.2l-.3-.3v-.2l-.3-.2-.2-.2v-.2l-.2-.2v-.3l-.2-.3v-2.1l.2-.2v-.2l.2-.3zm7.6 1.3-1 .8-.2-.3-.3-.3-.3-.2-.3-.3-.3-.3v-.2l-.4-.2-.2-.2-.2-.2-.2-.2-.2-.2h-.2l-.2-.2h-.2l-.2-.2h-.3v-.2h-.7v.2l-.3.2-.2.3-.2.2v.2l-.3.2v.2l-1.2-.5.2-.3.2-.3v-.2l.3-.3.2-.2.2-.2.3-.2.3-.2h.5l.3-.2h.8l.3.2h.2l.3.2h.2l.2.3.3.3.2.2.3.2.2.2h.3l.2.3.3.3.2.2.3.3.3.4.3.3.4.3z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "m399 602.6 1.2.6v.2l-.2.2-.2.3v2.1l.2.2v.2l.2.2.2.2v.2l.2.2.2.2.2.2v.2l.3.2.2.2.2.2.3.2.2.2.3.2-.8 1-.3-.3-.2-.3-.3-.2-.3-.3-.2-.2-.3-.2-.2-.3v-.2l-.3-.2-.2-.2v-.2l-.3-.2v-.3h-.2v-.4l-.2-.2v-.2l-.2-.3v-2.6l.2-.2v-.2l.2-.2v-.2zm7.7 1.4-1 .8-.2-.3-.3-.3-.2-.3-.3-.3-.3-.3-.2-.2-.2-.3-.3-.3-.2-.2h-.2l-.2-.3-.2-.2h-.2v-.2h-1.3l-.3.2v.2h-.2v.3l-.3.2-.2.3v.2l-1.2-.6.3-.3.2-.3.2-.2.2-.3v-.2l.4-.2h.2l.2-.2h.2l.2-.2h1.7l.2.2.2.2h.2l.2.3h.3l.3.3.2.3h.3l.2.3.3.3.2.2.3.3.3.4.4.3.3.3z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#fff",
              stroke: "#21231e",
              d: "m462.6 580.6-9.5-5.4c-4 3-6.8 13.5 0 22.2 8.5 11 12 18.7 14 27.5 6.2-8 8.3-16.3 4.4-24.5-5.3-11-8.7-17-8.8-20z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#fff",
              stroke: "#21231e",
              d: "m470.4 573-9.5-5.4c-4 3-12.5 13.2-5.6 22 8.5 10.8 17.3 19 19.4 27.7 6.2-8 8.8-16.2 5-24.4-5.4-11-9.4-17.2-9.4-20z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#fff",
              stroke: "#21231e",
              d: "m449.4 569.2-9.5-5.4c-4 3-7 13.5-.2 22.2a65 65 0 0 1 14 27.5c6.2-8 8.4-16.3 4.4-24.4-5.3-11-8.7-17-8.8-19.8z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#fff",
              d: "M405.5 469c.2 8.7-1.4 66.5-1.8 74.7-.5 8.2-4 13.7-8 17-3.5-5-5.6-11.5-6-19.3-.4-4 .4-58.7.7-70 6.4-17 11.2-17.8 15-2.4z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "M404 543.8h-1l.2-1v-2.6l.2-1.7v-4l.2-2.3v-5l.2-2.7v-2.8l.2-3v-3l.2-3v-6.2l.2-3v-6.2l.2-3v-5.8l.2-2.7v-7.4l.2-2V469h1v11.7l-.2 2.5v8.3l-.2 2.8v6l-.2 3.2v3l-.2 3.2v6l-.2 3v3l-.2 2.8v5.3l-.2 2.5v2.3l-.2 2v3.6l-.2 1.5v2zm-8.7 17 .8-.5h-.6l.3-.4.4-.4.4-.3.4-.3.3-.4.5-.4.3-.3.3-.5.4-.4.4-.4.3-.4.4-.5.3-.4.2-.5.2-.5.3-.5.3-.5.2-.6.2-.5.3-.6.2-.5.2-.5v-.7l.3-.6v-.6l.3-.7v-.7l.2-.7v-.7l.2-.8v-1.5h1v2.3l-.2.7v.8l-.3.6v.8l-.3.7-.2.6-.2.8-.2.6-.2.6-.2.6-.3.6-.4.5-.2.6-.3.5-.2.5-.3.5-.3.5-.3.5-.4.4-.4.5-.3.4-.5.5-.3.4-.4.3-.3.4-.4.3-.2.4-.4.3-.4.3h-.7zm.7.2-.4.3-.3-.4h.7zm-7-19.5h1v.6l.2.8v1.4l.2.7v.6l.2.7v.6l.3.6v1.5l.3.5v.7l.3.6.2.6.2.6.2.6.2.5.2.7.2.6.2.5.3.6.2.5.3.4.2.6.3.5.3.5.3.5.2.4.3.4.3.5.3.3-.7.6-.3-.6-.4-.4-.3-.5-.3-.5-.3-.5-.3-.6-.2-.6-.3-.5-.4-.7-.2-.5-.3-.6v-.6l-.3-.5-.3-.5-.2-.6-.2-.7-.2-.6v-.7l-.3-.6-.2-.6v-.7l-.3-.5v-.7l-.2-.7-.2-.6v-.6l-.2-.7v-1l-.2-.8v-1.5zm1-70.2.8.3v8l-.2 2.3V492l-.2 2.7v11.6l-.2 3v19l-.2 2.2v11h-1v-20.9l.2-2.7v-14.6l.2-2.8V489l.2-2.6v-8.9l.2-2v-4.2zm16-2.3h-1l-.4-1.3-.3-1.3-.4-1-.5-1.2-.4-1-.2-1-.4-.7-.4-.8-.4-.6-.4-.4-.4-.4-.4-.3-.3-.3h-.3l-.4-.2h-.7l-.4.3-.4.3-.5.5-.5.4-.5.5-.5.7-.5.7-.5.8-.5 1-.6 1-.5 1.2-.6 1.3-.6 1.3-.6 1.5-.6 1.6-1-.3.7-1.6.6-1.5.7-1.3.6-1.4.5-1.2.6-1 .5-1 .5-1 .5-.8.6-.7.5-.7.6-.6.6-.4.5-.4.6-.3.5-.2h1.1l.5.3.5.3.5.5.5.5.4.6.4.6.5.8.4.8.4 1 .5 1 .3 1 .4 1.4.4 1.3.4 1.4zm0 0"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#fff",
              d: "m368 454.8-2.6 79.6c-.8 7 8.4 49 13.5 57.4 12.3-5.3 15-33.8 12.6-61.6-2.4-27.8.4-51.8 2.3-56.8 0-6.3-1-12.8-1-19.3-8 .5-17.2.4-25 .8z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "m365 534.4 2.4-79.6h1l-2.5 79.6h-1zm13.7 57 .3.8-.6-.2-.5-1-.6-1-.5-1.2-.7-1.4-.5-1.6-.6-1.6-.6-1.8-.6-2-.5-2-.6-2-.7-2.2-.6-2.2-.6-2.3-.4-2.3-.6-2.3-.5-2.3-.6-2.3-.6-2.3-.4-2.2-.5-2.2-.4-2.2-.3-2-.4-2.2-.3-2-.3-1.8-.3-1.7-.2-1.6v-1.4l-.3-1.3v-2.8h1v4.1l.2 1.5.2 1.6.3 1.7.3 1.8.3 2 .4 2 .4 2.2.5 2.2.4 2.2.4 2.3.5 2.2.4 2.3.6 2.3.5 2.4.6 2.3.7 2.2.5 2.2.6 2 .6 2.2.6 2 .6 2 .5 1.7.7 1.5.6 1.5.5 1.4.5 1.2.5 1 .5 1-.6-.3zm.3.8-.4.2-.2-.4zm12-62h1l.3 2.5v2.7l.3 2.6v2.6l.2 2.6v12.5l-.3 2.4-.2 2.5-.2 2.3v2.3l-.4 2.3-.4 2.2-.3 2-.6 2-.4 2-.6 2-.5 1.7-.8 1.7-.6 1.5-.7 1.5-1 1.5-.7 1.3-1 1.2-1 1-1 1-1 1-1 .6-1.3.6-.3-1 1-.4 1-.7 1-.7 1-1 1-1 .7-1 .8-1.3.8-1.4.7-1.5.6-1.5.6-1.6.5-2 .5-1.7.5-2 .4-2 .3-2 .3-2 .3-2.3v-2.3l.4-2.3V558l.3-2.3V538l-.2-2.6-.2-2.6-.2-2.6zm2.4-56.8h1v.2l-.2.5-.2.7-.2.7-.2 1-.2.8-.2 1-.2 1.2v1.2l-.3 1.3-.2 1.3-.2 1.4v1.6l-.3 1.6v1.7l-.3 1.7v2l-.2 1.8v2l-.2 2V520l.2 2.5.2 2.5.2 2.6v2.5l-1 .2v-2.6l-.3-2.5-.2-2.5V520l-.2-2.5v-20.1l.2-2v-2l.3-2v-1.7l.2-1.7.2-1.8.2-1.6v-1.4l.3-1.5.2-1.3v-1.2l.3-1V477l.3-1 .2-.8.2-.7.2-.7.2-.5zm1 0v.2zm-1.5-18.8v-1l.4.4v3.7l.2.6v2.5l.2.6v1.8l.2.6v2.4l.2.6v3.6l.2.6v2.4h-1V468l-.2-.5V465l-.2-.5v-1.9l-.2-.6v-1.7l-.2-.6v-3l-.2-.6V454l.5.6zm0-1h.4v.4l-.5-.4zm-24.6 1.2h-1l.4-.5h3.9l.8-.2h12.8l.8-.2h4.7l.8-.2h1.7v1h-4.1l-.7.2h-8l-.8.2h-7.1l-.8.2h-3.9l.4-.4zm-1 0v-.4h.4zm.5 0h.4-.5zm-.6 0v-.4h.4z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#fff",
              d: "m353 468 1.8 79.5c-.4 7 11 48.5 16.4 56.5 12.6-9.8 10-49.8 8.2-62-4-24-3.2-52-2-56.5 0-6.3-.2-13.8-.6-20.4-8 1-15.8 2-23.7 2.8z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "m354.3 547.5-1.7-79.6 1-.2 1.7 79.6h-1zm16.6 56 .5 1-.7-.2-.5-1-.6-1-.6-1.2-.5-1.2-.7-1.6-.6-1.6-.7-1.8-.7-1.8-.7-2-.5-2-.7-2.2-.7-2.2-.6-2.2-.7-2.3-.7-2.2-.7-2.3-.6-2.3-.6-2.3-.5-2.3-.6-2.2-.6-2.2-.5-2-.6-2-.4-2-.4-2-.4-1.6-.3-1.6-.3-1.3-.2-1.3v-1.2l-.2-1v-.8h1v1.8l.2 1 .2 1.3.2 1.5.2 1.5.3 1.7.4 2 .4 1.8.4 2 .5 2 .6 2.2.4 2.2.6 2.3.7 2.3.6 2.3.7 2.2.6 2.3.7 2.3.7 2.3.7 2.2.7 2 .7 2.2.8 2 .7 1.8.6 1.7.8 1.7.6 1.4.6 1.3.6 1.2.5 1 .6.7h-.7zm.5 1-.4.2-.2-.4h.7zM379 542l1-.2v1.2l.2 1.4.2 1.5.2 1.8.2 1.7v2l.3 2 .2 2v2l.2 2.3v12l-.2 2.4v2.3l-.3 2.4-.4 2.4-.3 2.4-.3 2.2-.4 2.2-.5 2.2-.4 2-.6 2-.7 2-.8 1.6-.8 1.7-1 1.5-1 1.3-1 1.4-1.2 1-.6-.8 1-1 1-1 1-1.4.8-1.4.8-1.6.8-1.7.6-1.8.6-2 .5-2 .6-2 .4-2.2.4-2.3.3-2.3.2-2.4v-2.3l.3-2.4V569l.2-2.2V560l-.2-2.3v-2.2l-.2-2v-2l-.2-2-.2-1.6-.2-1.8-.2-1.5v-1.3l-.3-1.2zm-2-56.7h1v.6l-.2.7-.2.7v1l-.2.8v2.4l-.2 1.3v2.8l-.2 1.6v15.2l.2 2v2.3l.3 2v2.4l.3 2.3v2.2l.3 2.2.4 2.3.2 2.4.3 2.2.2 2.3.3 2.2.4 2.3-1 .2-.5-2.3-.3-2.4-.3-2.3-.4-2.3-.2-2.4-.2-2.3-.2-2.3-.2-2.3-.2-2.2v-2.3l-.3-2.2V512l-.2-2v-16l.2-1.4v-1.3l.2-1.2v-2l.3-1v-.8l.2-.6v-.7.2zm-.2-20v-1l.5.6v3.4l.2.7v3.8l.2.6v6l.2.6v5.3h-1V480l-.2-.7v-5.7l-.2-.6v-4.5l-.2-.7v-2.4l.4.4zm0-1h.4v.6l-.5-.4zm-23.7 4v-1l.8-.2h.8l.7-.2h2.2l.7-.2h.8l.7-.2h.8l.7-.2h1.4l.7-.2h.8l.7-.2h.6l.8-.2h1.7l.6-.2h.7l.8-.2h.8l.7-.2h1.5l.8-.2h.7l.7-.2h.8l.7-.2v1h-.6l-.6.2h-.8l-.7.2h-1.6l-.7.2h-.8l-.8.2h-.8l-.7.2h-1.5l-.7.2h-.8l-.7.2h-.7l-.8.2H362l-.7.2h-.7l-.8.2h-.7l-.6.2H357l-1 .2h-.6l-.7.2h-.8zm.2-1v1l-.6-.6.5-.6zm-.6.4v-.6h.5l-.4.5z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#fff",
              d: "m342.2 486.7 21-.5c-2 8.6-.5 35.6 3.2 56.2 3.3 19.3 8 69.3-12 81.3-12.5-26.4-3-52-9.2-75-5-24.3-6-44.6-3-62"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "m363 486.7-20.8.5v-1l21-.5.4.6zm0-1h.7v.6zm3.8 56.6-1 .2-.3-2-.3-2-.3-2-.4-2-.3-2-.2-2-.2-2.2-.2-2-.2-2.2-.2-2-.2-2-.2-2-.2-2.2v-2l-.3-2v-2l-.2-2V499l-.2-1.7v-4.5l.2-1.4v-1.2l.2-1.2v-1l.3-1v-1l1 .3v.8l-.2 1v1l-.2 1.3v5.4l-.2 1.6v4.9l.2 1.8v4l.2 1.8v2l.3 2v2l.3 2 .2 2v2l.3 2.2.3 2 .2 2.2.3 2 .3 2 .3 2 .3 2.2.2 2 .3 2 .3 2zM354 624l.8-.6-.7-.2 2-1.2 1.5-1.4 1.5-1.6 1.4-1.8 1.3-2 1-2 1-2.3 1-2.6 1-2.5.6-2.8.6-2.7.4-2.8.4-3 .4-3 .3-3 .2-3v-3l.2-3v-6.2l-.2-3-.2-3v-3l-.4-3-.2-2.7-.3-2.7-.2-2.5-.4-2.5-.2-2.4-.3-2.2-.3-2-.3-2h.8l.4 1.8.3 2 .3 2.3.3 2.3.4 2.5.3 2.7.3 2.7.2 2.8.2 3 .2 2.8.2 3v15.5l-.3 3-.3 3.2-.4 3-.4 2.8-.5 3-.8 2.7-.7 2.7-.8 2.6-1 2.4-1 2.4-1.2 2.2-1.3 2-1.4 2-1.6 1.5-1.7 1.5-1.8 1.3zm.7 0-.5.4-.3-.5h.7zm-10-75.2 1-.2.5 2.2.4 2.2.4 2.2.3 2.2.3 2.2.2 2.3v2l.2 2.4v25.4l.2 2.4v2.4l.3 2.4.3 2.4.3 2.4.5 2.4.4 2.4.5 2.4.7 2.5.7 2.4.8 2.5 1 2.5 1 2.4-.8.5-1.2-2.6-1-2.5-.8-2.6-.8-2.5-.7-2.5-.5-2.5-.5-2.4-.4-2.5-.2-2.3-.3-2.5-.2-2.4V594l-.2-2.4V564l-.2-2.3-.2-2.3-.2-2.2-.4-2.2-.3-2-.5-2.3-.5-2v-.2zm-2.5-62.6v1l.5-.4-.3 1.6-.2 1.7-.2 1.7-.2 1.7-.2 1.7v1.8l-.3 1.8v3.5l-.2 2v7.3l.2 2v1.8l.2 2v2l.2 2 .2 2 .2 2 .2 2 .3 2 .2 2 .3 2.3.3 2 .3 2.2.4 2.2.4 2.2.4 2 .4 2.4.4 2.2-1 .2-.4-2.2-.4-2.3-.4-2.2-.4-2-.3-2.3-.4-2.2-.3-2-.3-2.2-.2-2-.3-2.2-.2-2-.2-2-.2-2v-2l-.2-2v-2l-.2-1.8v-13l.2-1.8v-1.8l.2-1.7.2-1.7.2-1.7.2-1.7.2-1.7.3-1.7.5-.4zm-.5.4v-.4h.5zm.5 0v-.4zm-.5 0v-.4h.5z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#fff",
              d: "M422 454.4c0 8.7-3.2 66.5-4 74.6-.7 8-4.5 13.6-8.4 16.6-3.4-5-5.3-11.5-5.5-19.3 0-4 2.3-58.7 3-70 7-17 11.8-17.4 15-2z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "M418.5 529h-1v-1l.2-1v-1.5l.2-1.7v-2l.2-2v-2.3l.3-2.4v-2.5l.3-2.7.2-2.8v-3l.3-3 .2-3 .2-3v-3l.3-3.2.2-3 .2-3.2v-3l.3-3V474l.3-3v-2.5l.2-2.4V464l.2-2v-2l.2-1.8v-3.7h1v5.6l-.2 2v2l-.2 2.3v2.6l-.3 2.6-.2 2.7v2.8l-.3 3-.2 3v3l-.3 3-.2 3v3.2l-.3 3-.2 3.2-.2 3v3l-.2 2.7-.2 2.6v2.6l-.3 2.4v2.3l-.3 2v2l-.2 1.5v1.5l-.2 1.2v1zm-9.3 17 .8-.6-.7-.2.4-.2.3-.3.4-.4.3-.3.4-.3.4-.4.4-.3.3-.4.4-.4.4-.4.3-.5.4-.4.3-.6.3-.4.3-.5.3-.5.3-.5v-.5l.4-.6.2-.5.3-.7v-.6l.3-.6.2-.5.2-.7.2-.6V532l.3-.8v-.8l.2-.7v-.7h1v1.6l-.2.7-.2.7v.7l-.2.7-.2.7-.2.8-.2.6-.2.6-.2.6-.3.6-.2.6-.3.6-.3.5-.2.5-.3.5-.3.5-.5.5-.3.5-.3.4-.4.4-.4.4-.3.4-.5.4-.4.4-.2.4-.4.3-.4.4-.3.4-.4.3-.4.3h-.8zm.7 0-.5.4-.3-.5h.7zm-6.4-19.7h1v2.8l.2.8v.7l.2.7v1.2l.3.6v.8l.2.6.2.7v.7l.3.6v.6l.3.5.2.6.2.6.2.6v.6l.3.5.3.6.2.4.2.5.3.5.3.5.2.5.3.4.4.4.3.5.3.4-.8.5-.3-.6-.4-.4-.3-.5-.3-.6-.3-.6-.3-.5-.3-.6v-.6l-.4-.5-.2-.6-.2-.6-.2-.4-.2-.6-.2-.6-.2-.6-.2-.6-.2-.7-.2-.6v-.7l-.3-.7v-.6l-.2-.7v-.6l-.2-.7v-1.4l-.2-.7v-1.5l-.2-.7v-1.5zm3-70 .8.3v-.2 2.6l-.2 1.6v2l-.2 2v2l-.2 2.4v2.5l-.2 2.6v2.8l-.3 2.8v2.8l-.2 3v2.8l-.2 3v3l-.2 2.8v3l-.3 2.7v2.7l-.2 2.7v7.3l-.2 2v3.8l-.2 1.6v3.3h-1v-6.8l.2-2V513l.2-2.4V508l.2-2.6.2-2.8v-2.8l.2-3V494l.2-3 .2-2.8v-3l.2-2.8v-3l.3-2.7V474l.2-2.5V469l.2-2.4v-4.2l.2-1.8V459l.2-1.5v-1.2zm16-2h-1v.2l-.3-1.4-.3-1.2-.3-1.2-.4-1-.3-1-.4-1-.3-1-.4-.6-.5-.6-.4-.5-.2-.5-.4-.4h-.4l-.3-.2h-1.1l-.4.2-.5.2-.4.4-.5.5-.5.6-.6.7-.5.7-.5 1-.6.8-.5 1-.6 1.2-.7 1.2-.6 1.4-.6 1.4-.6 1.6-1-.4.7-1.6.8-1.4.6-1.4.6-1.2.6-1.2.6-1 .6-1 .6-1 .6-.7.5-.7.6-.6.6-.6.6-.4.5-.3h.6l.5-.3h1.2l.5.3.5.4.5.4.4.5.4.6.4.5.4.8.3 1 .4.8.3 1.2.3 1 .4 1.3.3 1.4.3 1.3zm-.5 0h.6-.5zm.6 0"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#fff",
              d: "M385 407.2c-.6 18.7-1 59-.8 62.6a51 51 0 0 0 6.7 22.6c4-3 7.7-8.5 8.4-16.6.6-6.7.8-39.5 1-56-4.3-2.6-8.7-6-12.2-9.7l-3.2-2.8z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "M384.7 469.8h-1v-23.4l.2-2.4v-19.6l.2-2.4v-9l.2-2v-3.8h1v7.8l-.2 2.4v9.4l-.2 2.5v12.5l-.2 2.4v25.4zm6 22.2.5.8h-.7l-.3-.6-.3-.5-.4-.6-.4-.4-.3-.6-.4-.6-.3-.7-.3-.6-.2-.6-.3-.7-.3-.7-.3-.7-.3-.7-.3-.8-.2-.7-.3-.7-.3-.8-.2-.8-.2-.7-.2-.8v-.8l-.3-.8v-.8l-.3-.8v-.8l-.2-.8v-.8l-.2-.8v-.7l-.2-.7v-1.5h1v2.5l.2.8v.8l.3.7v.8l.2.8.2.8.2.8v.7l.2.7.3.8.2.7.2.8v.8l.4.7.2.7.3.7v.7l.4.6.3.7.3.7.2.6.3.6.3.5.3.6.4.6.3.6.3.5.3.4h-.7zm.5.8-.4.3-.3-.3zm7.7-17h1l-.2.8v.8l-.2.7v.8l-.3.7-.2.7v.7l-.2.5-.2.7-.2.6-.3.6v.6l-.4.6-.2.6-.3.5-.2.5-.3.6-.3.5-.3.5-.4.4-.4.5-.3.4-.5.6-.3.4-.4.4-.3.4-.4.4-.3.3-.3.4-.4.2-.4.3-.4.3-.6-.8.4-.3.3-.3.4-.3.4-.2.4-.4.4-.3.3-.3.4-.4.4-.4.3-.5.4-.4.3-.3.3-.5.3-.5.3-.4.3-.5.2-.6.3-.5.2-.5.3-.6.2-.6.2-.5.2-.6.2-.8.2-.6.2-.6v-.7l.3-.7v-.7l.2-.8v-.7l.2-.8zm1-55.5.6-.8.2.4v18.8l-.2 2.2v14.6l-.2 2v8.9l-.2 1.5v4.3l-.2 1v2.6h-1V471l.2-1.5v-6.3l.2-1.8v-12l.2-2v-20.8l.2-1.7v-5.1l.2.3zm.6-.8h.2v.4l-.2-.5zm-12.4-9.8v1l.4-1 .3.4.2.5.4.3.3.3.3.5.3.3.4.3.3.4.4.4.3.3.4.4.4.3.4.3.3.3.4.3.3.4.4.3.4.3.5.3.3.2.4.2.4.3.4.3.4.3.4.3.4.3h.4l.4.4.4.3.4.2.4.2.4.3-.6.8-.4-.3-.4-.2-.4-.3-.4-.3-.4-.2-.4-.3-.4-.3-.4-.3-.4-.2-.4-.3-.4-.3-.4-.3-.4-.4-.3-.3-.4-.3-.3-.3-.4-.3-.4-.3-.5-.2-.4-.3-.2-.3-.4-.4-.4-.3-.3-.3-.4-.3-.4-.5-.4-.3-.4-.3-.3-.5-.5-.3-.3-.4-.3-.3.2-.8zm-.3.8-1-.8h1.2l-.3.8zm-2.5-3.3h-1l1-.3.2.2.2.2v.2h.3v.3h.4v.2l.3.2.3.2v.2h.3v.2h.2v.2h.3l.2.2v.2h.2v.2l-.2.8v-1l-.3 1h-.2v-.2h-.2v-.2h-.2v-.2h-.2l-.2-.2v-.2h-.2l-.2-.2-.3-.3h-.3v-.3h-.3v-.2l-.2-.2h-.2v-.2h-.2v-.2h-.2v-.2h-.2l1-.4zm-1 0v-1.4l1 1z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#fff",
              d: "M400 419.3c-.4 20-.2 51.7 0 54.3a34 34 0 0 0 5.4 19.3c4-3.2 8-8.8 8.8-17 .5-5 2-26.4 2-42.8-5.3-1.7-12-10.4-16.3-14z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "M400.4 473.5h-1v-12.9l-.2-1.7v-33.7l.2-2v-4h1v14.5l-.2 2v37.1l.2.5v.3zm4.7 19 .7.8h-.7l-.3-.6-.3-.5-.3-.5-.2-.5-.3-.5-.3-.5-.2-.6-.3-.5-.2-.5-.3-.5-.2-.6-.2-.6-.2-.6-.2-.6-.2-.6-.2-.6-.2-.6v-.6l-.3-.7v-.6l-.3-.8v-.6l-.2-.7v-.8l-.2-.6v-.7l-.2-.8v-1.5l-.2-.7v-1.4h1v2.8l.2.7v.7l.2.7v.7l.2.7v.7l.2.6v.7l.3.6v.6l.3.5v.6l.3.7.3.6.2.6.2.5.2.5v.6l.4.5.2.7.3.5v.5l.4.5.2.5.3.5.2.5.3.5.3.4zm.7.8-.4.3-.3-.4zm8-17.3h1v1.7l-.3.7v.7l-.3.8v.7l-.2.7-.2.7-.2.5-.3.7v.6l-.4.6-.2.6-.3.5-.2.6-.3.6-.4.6-.2.5-.3.5-.4.5-.2.4-.4.6-.3.4-.3.5-.3.4-.4.3-.4.3-.4.4-.3.3-.5.4-.4.3-.3.3-.6-.8.5-.3.3-.3.4-.4.4-.3.3-.4.3-.4.3-.4.4-.4.3-.4.4-.4.3-.5.3-.4.4-.4.3-.5.3-.3.3-.6.3-.4.2-.5.3-.5.2-.5.3-.6.2-.6.2-.6.2-.6.2-.7.2-.7.2-.7v-.7l.3-.8v-.7l.2-.7v-.8zm2.4-42.3.4-1 .3.5v7.9l-.2 1.6v5.1l-.2 1.6v1.7l-.2 1.7v4.6l-.2 1.6v2.9l-.2 1.3v1.4l-.2 1.3v2.5l-.2 1v2.2l-.2 1v1.6l-.2.7v1.1h-1v-2l.2-.8v-1.8l.2-1v-2.2l.2-1.2v-2.7l.2-1.3v-1.5l.2-1.4V457l.2-1.6v-1.6l.2-1.6V449l.2-1.6V443l.2-1.6V433l.5.5zm.4-1h.3v.5zm-16-13.4h-1l.8-.4.5.2.4.4.5.4.5.4.5.5.4.4.4.4.5.5.4.6.5.4.4.5.5.4.5.6.5.5.5.5.5.6.6.5.5.6.7.5.5.6.5.5.6.5.5.5.5.4.6.4.4.4.5.3.4.3.5.3.4.3.5.2.4.2-.3 1-.5-.2-.5-.3-.5-.2-.6-.3-.6-.4-.6-.3-.5-.4-.6-.4-.5-.4-.6-.5-.5-.5-.5-.5-.5-.5-.6-.5-.5-.5-.7-.5-.5-.6-.5-.5-.6-.5-.5-.6-.5-.4-.5-.5-.5-.5-.5-.5-.5-.5-.5-.4-.4-.4-.5-.4-.4-.5-.6-.4-.4-.3-.4-.4.8-.3zm-1 0v-1l.8.6-.8.2z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#fff",
              d: "M387 405.6 373 385c-2.8 10.2-6.3 82.8-2.2 88.8a36 36 0 0 0 6.4 19.3c4-3 9.8-8.5 8-16.7-1.6-8.2.4-62.3 2-70.7z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "m373.3 384.7 14.2 20.6-.8.5-14.3-20.5v-.4zm-1 .2.4-1 .5.7-.8.2zm-1.2 88.7h-1l.2.3-.5-.8-.3-1.2-.3-1.5v-1.8l-.3-2-.2-2.5v-2.6l-.2-2.8v-20.3l.2-3.7V431l.2-4 .2-3.6v-3.8l.3-3.7.2-3.7.2-3.4.3-3.5.2-3.2.3-3 .2-3 .3-2.5.3-2.4.2-2 .3-2 .3-1.3.4-1 1 .2-.3 1-.2 1.5-.3 1.8-.3 2-.2 2.4-.3 2.5-.3 2.8-.2 3-.3 3.3-.3 3.3-.2 3.4-.2 3.6-.2 3.7v3.7l-.3 3.8v3.8l-.2 3.7v3.8l-.2 3.6v19.6l.2 2.6.2 2.3.2 2v1.8l.4 1.5.3 1 .3.7zm0-.2v.2zm5.7 19.2.6.8-.7-.2-.3-.4-.3-.6-.3-.5-.3-.6-.3-.5-.2-.6-.3-.6-.3-.5-.3-.6-.4-.5-.2-.6-.3-.6v-.6l-.4-.6-.2-.6-.2-.6-.3-.6-.3-.6-.2-.7v-.6l-.3-.5-.2-.7v-.7l-.3-.6v-.6l-.2-.7v-.6l-.2-.7v-1.5l-.2-.7v-.7h1v1.4l.2.7v.6l.2.6v.7l.2.6v.7l.2.6.2.6v.6l.3.6.2.7.2.6.2.7v.6l.3.6.2.5.3.6.2.6.3.6.2.5.3.6.3.5.3.5.3.6.3.4.2.5.3.4.3.4.3.5.4.5h-.7zm.6.8-.4.3-.4-.5zm7.4-17 1-.3v.8l.2.7v3l-.2.7-.2.7v.7l-.3.7-.2.6-.2.6-.2.6-.3.6-.3.5-.4.6-.3.4-.4.5-.5.4-.3.5-.4.4-.4.4-.4.4-.5.5-.4.4-.3.5-.4.3-.4.4-.5.3-.4.3-.3.4-.4.3-.6-.8.4-.3.5-.3.4-.2.3-.4.3-.3.4-.3.4-.4.4-.3.4-.4.4-.5.4-.3.4-.4.4-.5.3-.5.5-.5.3-.5.3-.5.4-.5.3-.5.2-.6v-.6l.3-.5.2-.5.2-.7v-.6l.2-.6v-3.1l-.2-.7zM387 406v-1l.6.7-.2 1-.2 1v1.4l-.3 1.7-.2 2-.2 2v2l-.3 2.4v2.5l-.3 2.6v2.8l-.2 2.7-.2 2.8v3l-.2 2.8v3l-.2 3v8.5l-.2 2.8v13.5l.2 2v1.5l.2 1.4v1l.2 1-1 .2v-1l-.2-1v-1.5l-.2-1.7v-4l-.2-2v-15.5l.2-3V441l.2-3v-2.8l.2-3 .2-2.7v-2.8l.2-2.7.2-2.5V419l.3-2.3v-2.2l.3-2v-2l.3-1.5.3-1.4v-1.2l.3-1 .5.7zm0-1h.7v.7zm0 0v1l-.3-.2.4-.7zm0 1h-.2v-.2l.3.3z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#fff",
              d: "M358 451.2c-.8 11.3-1.2 19-1 23 .2 7.6 2 14.2 5.5 19.2 4-3 9-8.5 8.4-16.6-2-31.5 1.4-61 5.4-89.6-3.4-2.5-9-5-12.5-7.6-6.8 38.3-9 62-6 71.6z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "M357.4 474h-1v-7.4l.2-.7V463l.2-.7V459l.2-1v-1.8l.2-1v-3l.2-1h1v2l-.2 1v2l-.2 1v2.8l-.2.7v3.2l-.2.7v4.2l-.2.6v4.3zm4.8 19 .6.8h-.7l-.3-.6-.3-.5-.3-.5-.2-.5-.2-.5-.3-.5-.3-.6-.2-.4-.3-.6-.2-.5-.3-.6-.2-.7-.2-.6-.2-.6-.2-.5-.2-.6v-.7l-.3-.6v-.7l-.3-.6v-.7l-.2-.6-.2-.6v-.7l-.2-.7v-1.4l-.2-.7v-1.5l-.2-.7v-.7h1v2.2l.2.7v1.2l.2.7v.6l.2.6v.7l.2.5.2.7v.6l.3.6v.6l.3.6.2.6.2.6.2.6.2.6.2.5.2.6.2.6.3.6.2.5.2.5.2.5.3.5.3.5.3.5.3.5.3.4zm.6.8-.4.3-.3-.3h.8zm7.6-17h1v3.7l-.3.7v.6l-.2.7v.7l-.4.6-.2.6-.2.6-.3.6-.3.6-.3.5-.2.6-.3.5-.4.5-.2.5-.4.4-.4.5-.4.4-.3.6-.4.4-.5.4-.4.4-.3.4-.4.3-.4.3-.5.4-.4.3-.2.3-.6-.8.3-.3.4-.3.3-.3.3-.2.4-.4.4-.3.4-.3.4-.4.3-.4.4-.5.3-.4.3-.4.4-.4.3-.5.3-.5.3-.5.2-.5.3-.5.3-.5.2-.6.3-.6.2-.5.2-.6.2-.8v-.6l.2-.6v-.7l.2-.6zm5.7-89.2.7-.8.2.5-.5 2.6-.4 2.6-.3 2.7-.3 2.7-.4 2.7-.3 2.7-.3 2.7-.4 2.8-.3 2.8-.3 2.7-.3 2.8-.2 2.8-.2 2.8-.3 2.7-.2 2.8v3l-.3 2.7-.2 2.8-.2 2.8v2.8l-.2 3v8.5l-.2 3v8.6l.2 3v3l.2 2.8.2 3h-1l-.2-3v-3l-.2-2.8v-5.8l-.2-3V451l.2-2.8v-3l.2-2.7v-2.7l.3-3 .2-2.7.2-2.8V428l.3-2.7.3-2.8.3-2.8V417l.4-2.8.3-2.7.3-2.8.4-2.7.3-2.7.4-2.7.4-2.7.4-2.8.3-2.7.5-2.7.4-2.7v.6zm.7-.8.2.2v.3l-.3-.5zm-12.3-7-1-.3.8-.3.3.2.4.2.2.3h.3l.4.3.3.3.4.2.4.2.5.3.4.2.3.2.4.3.4.2.5.3.5.2.4.2.4.2.4.2.5.3.4.2.5.2.4.2.3.2.4.3h.4l.5.4.4.2.3.2.3.3.4.3.3.3.4.2-.6.8-.2-.2-.4-.3h-.3l-.3-.3-.3-.3-.4-.2-.4-.2-.4-.3-.4-.2-.4-.2-.4-.3-.4-.2-.4-.3-.5-.2-.4-.2-.4-.2-.5-.2-.5-.3-.4-.2-.4-.2-.4-.2-.4-.2-.4-.3h-.4l-.4-.4-.4-.2-.4-.2-.4-.3-.4-.3-.3-.3-.4-.2-.4-.2.8-.3zm-1-.3.2-.8.6.5zm-6 71.4.8.6-.8-.2-.3-1v-1l-.3-1-.2-1.3v-1l-.2-1.4V443l-.2-1.6v-5l.2-1.8v-2l.2-2 .2-2 .2-2.3.2-2.3.2-2.5.3-2.4.3-2.5.3-2.6.4-2.8.4-2.8.4-3 .4-2.8.5-3 .6-3.2.5-3.2.6-3.3.6-3.5.6-3.5.6-3.5 1 .2-.6 3.5-.6 3.5-.6 3.4-.5 3.3-.4 3.3-.5 3-.4 3-.4 3-.4 3-.4 2.7-.3 2.7-.3 2.7-.3 2.5-.2 2.4-.3 2.4-.3 2.3v2.2l-.3 2v2l-.2 2v9.8l.2 1.4v1.2l.3 1 .2 1.2v1l.4 1-1-.3zm.8.6-.5.6-.3-.8zm0 0-.7-.7 1 .3zm-.7-.7 1-1v1.3z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#fff",
              d: "m343.6 471.8 4 14.7c.2 7.7 5 14 8.3 19 4-3 7.5-8 6.5-16-5.8-46.5-3.8-77.3 6-115-22 15-32.3 46.6-25 97.3z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "m347 486.6-3.8-14.7 1-.3 3.8 14.6zm8.6 18.7.6.7h-.7l-.3-.6-.3-.5-.4-.5-.4-.5-.3-.5-.5-.6-.3-.6-.4-.5-.3-.7-.4-.5-.2-.6-.4-.5-.3-.6-.2-.5-.4-.6-.3-.7-.2-.6-.3-.6-.3-.5-.3-.7-.3-.6-.3-.7-.2-.7-.2-.6-.2-.7-.2-.7-.2-.7v-.6l-.2-.7v-.8l-.2-.8v-.7h1v1.4l.2.7v.7l.2.7.2.6v.6l.3.7v.5l.4.7.2.6.3.6v.6l.4.7.3.6.3.6.3.4.3.6.4.6.3.6.3.5.4.6.3.5.4.5.3.6.3.4.4.5.3.4.4.5.3.4.3.5.4.3h-.8zm.6.7-.4.3-.3-.4h.8zm5.8-16.5h1v5.5l-.2.6v.7l-.3.6v.4l-.3.6-.2.6-.3.5-.2.6-.2.5-.3.6-.3.5-.3.6-.3.4-.2.4-.3.4-.4.5-.2.3-.3.4-.4.4-.3.3-.3.4-.4.4-.4.3-.3.3-.7-.8.4-.3.4-.4.3-.3.4-.3.4-.3.3-.4.4-.3.4-.4.3-.4.3-.4.3-.4.3-.4.3-.4v-.5l.4-.3.2-.5.2-.5.2-.5.2-.5.2-.5.2-.6v-.6l.2-.5v-.6l.2-.7v-5.1zm6.8-114.7-.6-1 .8.7-1 3.5-.8 3.5-.8 3.4-.7 3.4-.7 3.4-.7 3.3-.6 3.5-.6 3.4-.4 3.2-.5 3.3-.3 3.4-.4 3.2-.4 3.4-.4 3.3-.2 3.3-.2 3.4-.2 3.4v3.6l-.2 3.5v14.7l.3 3.7.3 4 .2 3.8.3 4 .4 3.8.3 4 .5 4.2.4 4.3.6 4.4h-1l-.6-4.2-.4-4.3-.5-4.2-.3-4-.4-4-.3-4-.2-3.8-.2-3.8v-3.7l-.2-3.7v-14.3l.2-3.4.2-3.4.2-3.4.2-3.4.3-3.3.3-3.4.4-3.3.4-3.3.6-3.4.5-3.3.7-3.4.6-3.3.7-3.4.7-3.4.8-3.5.8-3.4.8-3.5 1-3.6.8.6zm-.6-1 1-.6-.2 1.3zm-24 98h-1l-.7-4.6-.5-4.6-.5-4.5-.3-4.3-.3-4.2-.2-4.2v-8l.2-3.8.2-3.7.3-3.7.4-3.4.5-3.4.6-3.3.8-3.3.7-3 1-3 1-3 1-2.8 1-2.8 1.2-2.5 1.3-2.5 1.4-2.4 1.5-2.3 1.4-2 1.6-2.2 1.7-2 1.7-2 2-1.6 1.8-1.7 2-1.6 2-1.5.6.8-2 1.4-2 1.6-1.8 1.6-1.8 1.7-1.8 2-1.6 2-1.6 2-1.5 2-1.4 2.3-1.4 2.4-1.4 2.4-1.2 2.6-1 2.7-1 2.7-1 3-1 3-.7 3-.7 3-.6 3.4-.5 3.3-.5 3.5-.3 3.6-.3 3.7-.2 3.8v12l.4 4.4.3 4.3.5 4.5.5 4.6.6 4.7zm-.6 0h.5-.4zm-.4 0"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#fff",
              d: "m344.8 486.2-20.3-6.7c-2.5 20.2 1.4 45.6 7 79 4.6 29 2 51.6-1.5 66.2 21.6-3 30.7-30.7 20-83-3-13.7-5.8-31.3-5.2-55.5"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "m324.7 479 20.2 6.7-.4 1-20.2-6.7-.3-.6zm-.6.4v-.6l.7.2zm8 79-1 .3-.6-3-.5-3.2-.6-3-.5-3-.5-3-.5-2.8-.4-3-.4-2.7-.4-2.7-.4-2.7-.4-2.7-.3-2.7-.4-2.6-.3-2.6-.3-2.4-.2-2.5-.3-2.3-.2-2.4-.2-2.4v-2.4l-.3-2.3V500l-.2-2v-10.7l.2-2 .2-2v-2l.4-2 1 .3-.2 2-.2 1.8v2l-.2 2v4l-.2 2v4.3l.2 2.3v2.3l.2 2.3.2 2.3.2 2.2.2 2.4.3 2.4.2 2.5.3 2.5.3 2.5.3 2.6.4 2.8.4 2.6.3 2.7.4 3 .6 2.7.4 2.8.4 3 .5 3 .4 2.8.5 3 .4 3 .5 3.2zm-2 65.8v1l-.5-.6.4-1.4.2-1.4.3-1.5.3-1.5.3-1.6.4-1.6.3-1.7.2-1.8.2-1.7.2-1.8.2-2 .2-1.8v-2l.3-2 .2-2v-2l.2-2v-13.4l-.2-2.3-.2-2.4-.2-2.4-.2-2.5-.3-2.5-.3-2.6-.3-2.6-.4-2.6-.4-2.7 1-.2.3 2.7.4 2.7.3 2.5.3 2.6.3 2.6.2 2.5.2 2.6v2.4l.3 2.4v6.8l.2 2.3v4.3l-.2 2v2l-.2 2v2l-.2 2-.2 2-.2 1.8-.3 1.8v1.8l-.4 1.7-.2 1.8-.3 1.6-.2 1.6-.3 1.5-.3 1.5-.4 1.5-.3 1.4-.5-.8zm0 1h-.6v-.6zm19.4-83.5 1-.2 1 5 .8 4.6.7 4.6.5 4.5.5 4.3.4 4 .3 4 .2 4v7.2l-.2 3.4-.2 3.2-.4 3-.4 3-.6 3-.6 2.6-.7 2.6-1 2.4-1 2.3-1 2.2-1 2-1.2 1.8-1.3 1.7-1.4 1.5-1.4 1.4-1.5 1.3-1.5 1-1.8 1-1.8.7-2 .7-2 .5-2 .2v-1l2-.3 1.8-.6 1.8-.6 1.7-.8 1.6-1 1.5-1 1.5-1 1.4-1.5 1.3-1.5 1.3-1.6 1-1.8 1.2-2 1-2 1-2.2.7-2.3.6-2.4.7-2.7.5-3 .4-2.8.4-3 .2-3.3v-3.5l.2-3.5v-3.7l-.3-3.8-.3-4-.3-4-.4-4.3-.7-4.4-.8-4.5-.8-4.7-1-5zm-4.8-55 .3-1 .3.5V503l.2 2 .2 1.8v2l.2 1.8v1.8l.2 1.8.2 1.7.2 1.8.2 1.7.2 1.7.2 1.6.2 1.6.2 1.6.2 1.5.3 1.5.3 1.5.3 1.5.2 1.4.3 1.4.3 1.4.3 1.4.3 1.3v1.3l.4 1.2-1 .2-.2-1.3-.3-1.3-.4-1.2-.2-1.4-.3-1.4-.2-1.4-.2-1.4-.3-1.5-.2-1.5v-1.5l-.4-1.6-.2-1.5-.2-1.6-.2-1.7-.2-1.7-.2-1.7-.2-1.8-.2-1.8v-1.7l-.3-2-.2-1.7v-2l-.3-1.8v-4l-.2-2v-13l.3.5zm.3-1 .3.2v.2l-.4-.5z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "M343.6 584h1v.7h-.8v-.2h-.2v-.4zm-4.3-40 1-.4.4 1.2.2 1.2v1l.4 1.3.2 1.3.2 1.2.2 1.2.2 1.2.2 1.3.2 1.3.2 1.2.2 1.3.2 1.3.2 1.2.2 1.3v1.4l.3 1.3v2.6l.3 1.3v1.3l.2 1.2v2.6l.2 1.3v9.1h-1v-7.6l-.2-1.2v-2.7l-.2-1.3V570l-.2-1.3v-1.3l-.2-1.3v-1l-.3-1.4v-1.3l-.3-1.3-.2-1.3v-1.2l-.3-1.3-.2-1.3-.2-1.3-.2-1.3v-1.2l-.4-1.2-.2-1.2-.2-1.2-.2-1.2-.3-1.2-.2-1.2-.2-1.2zm-5.5-50.4h1.2v6.4l.2 1.5v3.3l.2 1.5v1.6l.2 1.5v1.6l.3 1.5v3.1l.3 1.5.2 1.7v1.5l.3 1.6.2 1.5.2 1.6.2 1.4.2 1.6.3 1.5v1.6l.4 1.6.2 1.6.3 1.6.2 1.5.3 1.6.3 1.5.3 1.5.4 1.6-1 .3-.5-1.7-.4-1.6-.3-1.6-.3-1.5-.3-1.5-.2-1.6-.3-1.6-.2-1.5-.3-1.6-.2-1.6-.2-1.4-.3-1.6-.2-1.5-.2-1.6v-1.7l-.3-1.5-.2-1.6v-1.5l-.2-1.6v-1.4l-.2-1.6-.2-1.6V508l-.2-1.7V503l-.2-1.4v-6.4l-.2-1.6zm1.2 0h-1.2v-.2h.2v-.2h.2v-.2h.8v.2h.2v.4z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#fff",
              d: "m344 367.3 13.2 2.2-4.6 23.3c-5 24.3-8.2 53-4.5 84.2 1.5 11.7 4 21.2 7.6 28.5-14.6-1.6-24-15.8-22.7-40.6-2.6-29-1.5-52 3.2-69.4 1.4-5 5.8-24.2 7.8-28.3z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "m357 370-13-2.3v-1l13.3 2.3.4.6zm.3-1h.5v.6zm-4.2 24-1-.3.2-.3v-.4l.2-.5v-.6l.2-.7v-.6l.3-.7v-.8l.2-.8v-1l.3-.7.2-1 .2-1v-.8l.2-1 .2-1 .2-1 .2-1 .2-1 .2-.8v-1l.3-.7.2-1v-.7l.3-.7v-.7l.3-.6v-.6l.2-.5v-.4l.2-.3v-.3l1 .2v.6l-.2.5v.5l-.3.6v.5l-.2.7-.2.8-.2.8v1l-.3.7-.2 1v.8l-.2 1-.2 1-.2 1-.2.8-.2 1-.2 1v1l-.3 1-.2.7-.2 1v.7l-.2.7v1l-.2.5-.2.6v.7l-.2.5v.7zm-4.4 84h-1l-.3-2.8-.3-3-.3-3-.2-2.8v-2.8l-.3-3V457l-.2-3v-11l.2-2.7v-2.7l.2-2.7.2-2.8.2-2.6.2-2.6.3-2.6.2-2.6.3-2.6.3-2.5.4-2.5.4-2.5.4-2.5.3-2.4.4-2.4.3-2.4.5-2.4.4-2.3.5-2.3.4-2.3 1 .2-.4 2.2-.4 2.3-.5 2.3-.4 2.4-.4 2.4-.5 2.4-.4 2.4-.2 2.4-.4 2.5-.3 2.5-.2 2.5-.3 2.6-.3 2.5-.2 2.5-.2 2.7-.2 2.6-.2 2.6v2.6l-.2 2.7v2.7l-.2 2.7v11.5l.2 3v2.7l.3 3 .2 2.7.3 3 .3 2.8.3 3zm7 29v-1l-.4.8-.4-.7-.3-.6-.3-.8-.4-.7-.3-1-.3-.6-.3-.8-.4-.8-.3-.8-.2-.8-.2-.8-.3-1-.2-.7-.3-1-.2-.8-.3-1-.2-1-.2-.8v-1l-.3-1-.2-.8-.2-1-.2-1v-1l-.3-1-.2-1v-1l-.3-1-.2-1v-1l-.2-1.2-.2-1 1-.2v1l.3 1v1.2l.2 1v1l.3 1 .2 1 .2 1v1l.2 1 .2 1 .2 1 .2 1 .3.8.3 1 .2.8.2 1 .3.7.2 1 .3.7.2.8.3 1 .3.7.3.8.3.7v.8l.4.8.4.7.3.7.4.7.3.6.3.7-.5.7zm.4-.7.4.8h-1l.6-.7zM332.4 465l1-.2v8.8l.2 2 .2 2 .3 2 .4 1.8.4 1.7.4 1.8.5 1.7.5 1.5.6 1.5.6 1.5.7 1.3.8 1.3.7 1.3.8 1 1 1 .8 1.2 1 1 1 .8 1 .8 1 .8 1 .7 1.2.6 1.2.4 1.2.5 1.2.3 1.2.3 1.3.3h1.4l-.2 1h-1.3l-1.4-.4-1.3-.4-1.3-.4-1.2-.5-1.2-.5-1.2-.7-1-.6-1.2-.8-1-.8-1-1-1-1-1-1-1-1.2-.7-1.2-.8-1.3-.8-1.2-.7-1.4-.7-1.5-.5-1.6-.6-1.6-.5-1.7-.4-1.6-.4-1.8-.3-2-.2-1.8-.2-2-.2-2v-8.9zm3.3-69.6 1 .3-.5 1.6-.4 1.7-.4 1.7-.3 1.7-.3 1.8-.3 1.8-.3 1.8-.2 2-.2 1.8-.3 2-.2 2v2l-.3 2v2l-.2 2-.2 2.3v4.3l-.2 2.2v9.6l.2 2.5v2.4l.2 2.5v2.5l.2 2.6.2 2.6.2 2.5.2 2.6.2 2.8h-1l-.2-2.6-.2-2.6-.2-2.7-.2-2.7v-2.5l-.2-2.6v-2.5l-.2-2.4v-18.5l.3-2v-2.2l.3-2v-2.2l.3-2 .3-2 .3-2 .2-1.8.3-2 .4-1.8.4-1.8.3-1.8.5-1.7.4-1.7.3-1.7.4-1.6zm8.3-28.6v1l.4-.3-.2.4-.2.4-.2.6-.2.6-.3.7-.2.8-.2 1-.2.8-.3 1-.3 1-.2 1-.3 1-.3 1-.3 1.2-.4 1-.3 1.2-.3 1-.2 1.2-.3 1-.3 1.2-.3 1-.3 1-.3 1-.2 1-.3 1-.3 1-.2.8-.2.8-.2.7v.6l-.2.6v.5l-1-.3v-.5l.2-.7.2-.6.2-.8v-1l.4-.7.2-1 .2-.8.3-1 .2-1 .3-1 .2-1.2.3-1 .3-1.2.3-1 .4-1 .2-1.2.3-1 .2-1.2.3-1 .3-1 .3-1 .4-1 .2-1 .3-1v-.8l.4-.8.2-.7.3-.7v-.6l.3-.5.2-.5.5-.2zm-.5.2.2-.3h.3zm.5.3v-.5zm-.5-.3.2-.3h.3z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#fff",
              d: "m336 370.4 6.4 7.4c-1.8 1.4 1.3 7-.4 18-1 6.4-4.8 13.8-5.6 22-2.5 26.5-2.5 59.8 5.4 81-14.5-1.6-19.5-14.8-20-39.6-.4-20.6-.4-44.7 4.7-72.7 1-6.5 4.2-11.7 9.4-16z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "m342 378.2-6.5-7.5.8-.6 6.5 7.5v.7h-.7zm.8-.7.4.4-.5.2v-.7zm-.3 18.5h-1l.2-1.2v-1l.2-1V385l-.2-.6v-1.2l-.2-.6v-1l-.2-.4v-2.8l.2-.3.3-.4v-.2l.7.8v.2h-.2v.5h-.2v2.2l.2.4v1.1l.2.6v1.1l.2.7v8.1l-.2 1v1l-.3 1zm-5.6 21.7h-1v-1.8l.2-.7.2-.7v-.7l.3-1v-.6l.3-.8.2-.7.2-.8.2-.7.2-.7.2-.7.2-.6.2-.7.2-.7.3-.7v-.7l.3-.6.2-.7.2-.7.2-.6v-.7l.3-.6.2-.6.2-.5.2-.7v-.6l.2-.6v-.6l.2-.6v-.5h1v1.2l-.3.6v.7l-.2.6v.7l-.3.7-.2.6-.2.6v.7l-.3.7-.2.6-.3.7-.2.6-.2.6-.2.7-.2.7-.2.7-.3.7-.3.7-.2.8-.2.7-.2.7v.7l-.2.6-.2.7v.7l-.3.8v.7l-.2.7v1.5zm4.8 81.6v-1l-.4.7-.8-2-.6-2-.7-2.3-.6-2.2-.5-2.3-.5-2.4-.5-2.4-.4-2.4-.4-2.5-.4-2.5-.3-2.5-.3-2.6-.2-2.7-.2-2.7-.2-2.6v-2.7l-.2-2.7V455l-.2-2.8v-10.9l.2-2.7V436l.2-2.8v-2.7l.3-2.6.3-2.7.2-2.6.2-2.6.2-2.4h1l-.3 2.6-.2 2.6-.2 2.5-.2 2.6v2.6l-.2 2.6v2.7l-.2 2.6v2.7l-.2 2.7V455l.2 2.7v2.7l.2 2.7.2 2.5.2 2.7.2 2.6.3 2.5.3 2.6.4 2.4.4 2.4.4 2.5.4 2.3.5 2.4.7 2.2.6 2.2.6 2.2.6 2 .7 2-.5.7zm.5-.6.3.7h-.8zm-21-39.5h1v2.2l.2 2.3v2l.2 2.2.2 2v2l.3 1.7.3 1.8.3 1.8.2 1.6.4 1.5.4 1.6.4 1.5.5 1.4.4 1.2.6 1.3.6 1.2.6 1 .7 1 .6 1 .8 1 .8 1 .8.6 1 .7 1 .7 1 .6 1 .5 1 .4 1 .4 1.3.3 1.3.2 1.3.2-.2 1-1.4-.2-1.3-.3-1-.4-1.3-.4-1.2-.5-1-.6-1.2-.5-1-.7-1-.7-.8-.7-1-1-.7-1-.7-1-.6-1-.7-1.2-.6-1-.5-1.4-.5-1.3-.5-1.5-.5-1.5-.4-1.5-.3-1.7-.4-1.5-.4-1.8-.3-1.8-.2-2v-2l-.3-2v-2l-.2-2.3v-2.2l-.2-2.3zm4.7-72.8 1 .2-.5 2.6-.4 2.6-.3 2.5-.4 2.6-.3 2.4-.4 2.5-.3 2.4-.3 2.4-.2 2.4-.2 2.5-.3 2.3v2.4l-.3 2.4-.2 2.3v2.4l-.2 2.2v2.3l-.2 2v4.5l-.2 2.2V459h-1v-26.9l.2-2.2v-2l.2-2.4v-2.3l.2-2.3.2-2.3.2-2.4.2-2.3.2-2.4.2-2.5.3-2.3.3-2.4.3-2.5.4-2.5.3-2.6.4-2.5.4-2.6.6-2.6.4-2.6zm10.3-16.3-.8.7h.7l-.4.5-.5.4-.5.4-.4.4-.4.5-.4.3-.4.4-.4.5-.4.4-.4.5-.3.5-.4.5-.3.5-.3.4-.3.4-.3.5-.2.4-.3.5-.2.4-.3.5-.2.4-.2.6-.2.5-.2.5-.2.6-.2.5-.2.7v.5l-.3.6v.6l-.2.6v.6l-1-.2v-.6l.2-.6.2-.6v-.6l.3-.6v-.6l.3-.5.2-.6.2-.6.2-.4.3-.6v-.5l.4-.5.2-.6.3-.5.2-.6.3-.5.3-.6.4-.5.3-.6.4-.5.2-.6.4-.4.4-.5.4-.4.4-.4.5-.4.4-.5.5-.4.4-.4.5-.6.6-.4h.7zm-.7 0 .4-.3.3.4z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#fff",
              d: "m372.3 390-13.4-1.6c-2.6 12.7-4.5 21.7-5 26.2-1 9 1.8 17 5 23 5-3 7.2-9.4 9.2-18.6 2-9.2 2.7-19.2 4-29z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "m359 388 13.3 1.5v1l-13.5-1.6-.4-.7.5-.4zm-.6.3v-.4h.5l-.6.3zm-4 26.4h-1l.2-.6v-.8l.2-.6v-1l.2-.6v-.7l.3-.6v-.7l.2-.7v-.7l.3-.7v-1l.2-.7.2-.8.2-1v-.7l.3-1 .2-.8v-1l.2-1 .2-1 .2-1 .2-1 .2-1 .3-1 .2-1 .2-1.2.2-1.2v-1l.4-1.3 1 .2-.3 1.2v1l-.3 1.3-.3 1-.2 1.2-.2 1-.2 1-.2 1-.2 1-.2 1-.2 1v1l-.3 1-.2.8-.2.8v1l-.3.7v.8l-.3.7v.8l-.2.7-.2.7v.6l-.2.7v1.3l-.2.5v1.1l-.2.5v.9zm4.3 22.6.5.8h-.7l-.3-.7-.3-.6-.4-.6-.3-.5-.3-.6-.2-.7-.3-.7-.2-.6-.3-.7-.2-.7-.3-.7-.2-.8-.2-.7v-.7l-.3-.7-.2-.7-.2-.7v-.8l-.3-.7v-.7l-.2-.8v-.8l-.2-.7v-.8l-.2-.8v-6.1h1v6.6l.2 1v1.4l.3.7v1.6l.3.8.2.7v.8l.3.7.2.7.3.7.2.6.2.7.2.6.2.6.2.6.3.7.3.5.2.6.3.7.3.6.3.6.3.5-.7-.2zm.5.8-.5.4-.2-.5h.7zm8.6-19h1l-.3 1-.2.8-.2 1v.7l-.3.8-.2.7-.2.8-.2.7v.8l-.4.7-.2.7-.3.6v.7l-.4.6-.2.7-.3.6-.2.5-.3.5-.3.6-.3.5-.4.7-.3.5-.4.5-.5.4-.3.6-.4.4-.4.4-.4.4-.5.3-.4.5-.4.3-.4.3-.5-.7.4-.3.5-.3.4-.3.3-.4.4-.3.4-.4.4-.4.4-.5.3-.4.4-.4.4-.5.3-.4.4-.5.2-.4.3-.6.2-.5.3-.6.2-.7.3-.7.2-.6.3-.7.2-.6.2-.7v-.8l.3-.7.3-.7.2-.8.2-.8.2-.8.2-.8.2-.8.2-1zm4.5-28.5v-1l.5.5v1l-.3 1v.8l-.2 1v1l-.2.8v1l-.2.8v1l-.2 1v.8l-.2 1v1l-.2.8v1l-.2.8v1l-.2.8v1l-.2 1-.2.8v1l-.2.8-.2 1v.8l-.2 1-.2.8-.2.8v1l-.3.8v1l-.3.7h-1l.3-1v-.8l.3-1 .2-.7v-1l.3-.8v-1l.3-.8.2-1v-1l.3-.8v-1l.2-.8v-1l.2-.8v-1.8l.2-1v-1l.2-.8v-1l.2-.8v-1l.3-1v-1.8l.2-1v-.8l.2-1v-.8l.3-1v-1l.6.7zm0-1h.6l-.2.5zm0 0v1zm0 1"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#fff",
              d: "M407 418.6h-11.8c-.4 11-.7 18.5-.5 22.3.4 7.5 2.3 14 5.5 18.7 3.6-3 7-8.3 7.6-16.2.6-8-.6-16.5-.7-25z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "M395.2 418.2h12v1h-12l-.5-.5zm-.5.5v-.5h.5zm.5 22.2h-1v-11.4l.2-.8v-4.4l.2-.8v-5h1v7.8l-.2.7v5.6l-.2.7v7.7zm4.7 18.4.6.7h-.8l-.3-.5-.3-.4-.3-.4-.4-.5-.2-.4-.3-.5v-.4l-.4-.6-.2-.5-.3-.5v-.6l-.3-.6-.2-.5-.2-.6-.2-.6v-.5l-.2-.6-.2-.7-.2-.6v-.6l-.2-.6-.2-.6v-.7l-.2-.5v-.7l-.2-.7v-.5l-.2-.7v-2.6l-.2-.7h1v1.1l.2.7v1.4l.2.7v.7l.2.6v.7l.2.6v.6l.3.6v.7l.3.6v.7l.3.5v.6l.2.6.2.5.2.5.2.5.3.6.3.5.2.6.3.5.2.6.3.5.2.6.3.5.3.6.4.4.2.5h-.7zm.6.7-.5.5-.2-.5h.8zm6.7-16.6h1v1.6l-.2.7v1.4l-.3.8v.6l-.3.7-.2.7-.2.6-.2.6-.2.5-.2.5-.3.6v.5l-.4.7-.2.5-.3.5-.2.5-.3.4-.3.5-.3.5-.4.4-.3.3-.4.4-.4.4-.3.5-.4.3-.4.4-.4.3-.3.3-.4.3-.7-.6.2-.3.4-.2.3-.3.2-.4.3-.2.4-.3.2-.4.3-.3.3-.4.3-.4.4-.5.3-.4.2-.4.2-.4.3-.5.2-.5.3-.5.2-.5.3-.5.2-.6.2-.4v-.6l.3-.6v-.6l.3-.6v-.7l.3-.6v-1.4l.2-.7V444zm0-24.3v-1l.4.6v5.6l.2 1v4.6l.2.8v2.8l.2.8v9.2h-1v-11.8l-.2-.8V429l-.2-1v-3l-.2-1v-5.3l.4.5zm0-1h.4v.6l-.5-.5z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#fff",
              d: "m420 424.2-12 .6c0 11 0 18.4.3 22.2a37 37 0 0 0 6.2 18.6c3.5-3 6.8-8.6 7-16.5.3-8-1-16.3-1.5-24.8z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "m408 424.3 12-.6v1l-12 .6-.4-.5.5-.5zm-.4.5v-.5h.5l-.4.5zm1.2 22.2h-1v-4l-.2-.6v-17.8h1V445l.2.4zm5.4 18.2.6.8h-.7l-.2-.5-.3-.5-.3-.5-.3-.5-.4-.5-.3-.5-.3-.5-.2-.5-.3-.5-.3-.5-.2-.6-.2-.5-.3-.7-.2-.6-.2-.6v-.4l-.3-.6-.2-.6v-.7l-.3-.6-.2-.5v-.6l-.3-.8v-.6l-.2-.7v-.8l-.2-.6v-.7l-.2-.8v-2h.8v.7l.2.7v1.4l.2.7.2.7v.7l.2.7v.6l.3.6v.7l.2.6v.5l.3.6.2.7.2.5v.6l.3.6.2.5.2.5.2.5.2.5.2.6.2.6.3.5.2.6.2.4.3.5.3.5.3.4.3.5.3.3h-.8zm.6.8-.4.4-.3-.5h.8zm6.2-17h1v2.3l-.2.7v.7l-.2.7-.2.6v.7l-.3.6v.6l-.2.5-.2.6-.2.7-.2.6-.3.5-.3.6-.3.5-.2.4-.3.5-.4.4-.3.4-.3.5-.3.4-.3.4-.3.5-.2.4-.3.3-.3.4-.4.3-.3.4-.3.3-.4.3-.6-.8.3-.3.3-.4.3-.3.4-.3.3-.4.4-.3.4-.4.2-.5.3-.4.2-.3.3-.4.3-.5.2-.4.3-.5.2-.6.3-.5.2-.6.2-.5.2-.6.2-.6.2-.6.2-.5.2-.6v-.5l.3-.7v-.6l.2-.7v-.6l.2-.8zm-1-25.3v1l.5-.5v2.4l.2.8v1.5l.2.7v3.4l.2.7v1.5l.2.8v.8l.2.8v2.5l.2.7v2.3l.2.8v5.3h-1v-7.4l-.2-.7v-1.6l-.2-.8V437l-.2-1v-1.5l-.2-.7v-1.6l-.2-.8v-1.6l-.2-.8v-1.6l-.2-.8v-2.2l.4-.6zm-.5.6v-.6h.5zm.5.4v-1z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#fff",
              d: "m395 412.4-12-.8c-1.2 11-2 18.2-2.2 22-.2 7.7 1 14.2 4 19.3 3.8-2.8 7.7-8 8.8-15.7 1.2-8 .8-16.4 1.4-25z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "m383 411 12 1v1l-12-1-.4-.5.5-.4zm-.4.5v-.5h.5l-.4.5zm-1.3 22.2h-1V431l.2-.4V429l.2-.6v-1.2l.2-.6v-2.2l.2-.7v-1.4l.2-.8v-.8l.2-.8v-1l.2-.8v-1l.2-.8v-1l.3-1v-1l.2-1v-1l1 .2v2l-.3 1v1l-.2 1v.8l-.2 1v.7l-.2 1v.8l-.2.8v.8l-.2.8v1.3l-.2.7v1.4l-.2.6v1.1l-.2.6v1.7l-.2.5v2.7zm3.2 18.8.5.8-.7-.2-.2-.4-.2-.5-.2-.4-.3-.5-.2-.4v-.5l-.3-.5-.3-.5v-.6l-.3-.5v-.7l-.3-.6v-.6l-.3-.4v-.6l-.3-.7V443l-.2-.5v-.7l-.2-.6V440l-.2-.8v-5.5h1v6.8l.2.7v.7l.2.6v.6l.2.5v.6l.2.7.2.6v.6l.3.5v.5l.3.6.2.5.2.7.2.5.2.5.2.5.2.5.3.5.2.5.2.5.2.4h-.7zm.5.8-.4.3-.3-.5.8.3zm8.2-16h1l-.2.8v.8l-.3.7v.7l-.3.7-.2.6-.2.6-.2.6-.3.6-.2.6-.3.6-.2.6-.3.5-.3.6-.3.5-.4.5-.3.5-.3.4-.3.5-.3.4-.4.6-.3.4-.4.4-.3.3-.4.4-.3.5-.4.3-.5.3-.3.4-.4.3-.4.3-.3.3-.5-.8.3-.3.4-.2.3-.3.4-.3.2-.3.4-.2.3-.4.3-.3.3-.3.3-.4.2-.4.4-.5.3-.4.2-.3.3-.5.3-.5.3-.4.4-.5.2-.5.3-.6v-.5l.4-.6.2-.5.2-.5.2-.6.2-.7.2-.7.2-.6.2-.7v-.7l.2-.7.2-.8zm1.8-24.4v-1l.5.5v1.5l-.2.8v5.6l-.2.7v9l-.2.8v2.2l-.2.8v.7l-.2.8v1l-.2.6v.8l-1-.2v-.7l.2-.8v-1.5l.2-.7V432l.2-.8V428l.2-.8V421l.2-.7v-4.8l.2-.8v-2.3l.6.5zm0-1h.5v.5z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#fff",
              d: "m384 399.6-13.2-5.4c-2.2 8.8-5.2 37.8 0 50 4.5-3 9-8.4 10.3-17 1.6-9 2-18.2 3-27.6z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "m371 393.7 13 5.4-.3 1-13-5.4-.4-.6zm-.7.3.2-.5.5.2zm.3 50 .6.7-.7-.2-.5-1.2-.5-1.3-.3-1.4-.4-1.5-.3-1.5-.3-1.6-.2-1.7-.2-1.7v-1.8l-.2-1.8v-3.6l-.2-2V418l.2-2v-1.8l.2-1.8.2-1.8V409l.3-1.8.2-1.7V404l.3-1.6.2-1.5.3-1.4.2-1.3.2-1.2.2-1v-1l.3-1 1 .3-.2 1v.8l-.3 1.2-.3 1.2-.2 1.3-.2 1.4-.2 1.5-.2 1.6-.2 1.6v1.7l-.3 1.7v1.7l-.2 1.8v1.8l-.2 1.8v3.8l-.2 2v5.4l.2 1.8v1.7l.2 1.8.2 1.7.2 1.6.3 1.6.3 1.5.3 1.3.5 1.4.4 1.2.4 1h-.8zm.6.7-.5.3-.2-.5zm9.4-17.7h1v1l-.3.8-.2.8v.7l-.3.8-.2.8-.3.7-.2.7-.3.7-.3.5-.3.7-.2.6-.3.6-.3.6-.3.6-.5.5-.3.7-.4.5-.4.5-.3.5-.3.4-.4.5-.4.5-.5.4-.4.3-.3.4-.4.4-.4.4-.5.4-.5.3-.4.4-.4.3-.6-.8.4-.4.4-.3.4-.3.4-.3.4-.4.4-.3.4-.4.4-.4.4-.4.3-.4.4-.4.3-.5.3-.4.4-.4.3-.5.4-.4.3-.6.3-.5.3-.6.3-.6.2-.6.3-.7.3-.5.2-.6.3-.8.2-.7.2-.7.3-.7v-.7l.3-.7.2-.8v-.8zm3-27 .4-1 .4.6v1l-.2.8v1.7l-.2 1v1l-.2.8v1.8l-.2.8v1.7l-.2 1v1.7l-.2 1v1.6l-.2 1v.7l-.2 1v.8l-.2.8v1l-.2.7v.8l-.2 1v.8l-.2 1v.7l-.3.8v.8h-1v-.8l.2-1v-1.5l.2-.8v-1l.2-.8v-1l.2-.7v-1l.2-.7v-1l.2-.7v-1.6l.2-1v-.7l.2-1V410l.2-.8v-1.8l.2-.8v-1.8l.2-1v-1.5l.2-1v-.8l.2-1zm.4-1 .4.3v.3l-.4-.5zm0 .6-.3.4.2-.4zm0-.5.4.3v.3l-.4-.5z"
            }),
            /* @__PURE__ */ jsx262("path", {
              id: "rs_svg__c",
              fill: "#edb92e",
              stroke: "#21231e",
              d: "M387.8 701.2c8 6.3 15.2-8.3 8-27.6-5-14.2-30.6-8.7-16.4 10.5.7 1 1.6.6 1.5-.4-1-4 1.6-6.3 5.5-5.5 10.5 2 11 22-.6 17.6-2.2-.2-.4 4 1.7 5.6z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#edb92e",
              stroke: "#21231e",
              d: "M400 639.2c-1 3.4-5 7.6-8 10.8-4.5 4.8-3.4 12.2-.2 16 3.5 4.4 5 9.2 5.8 13 .5 2.3 1.5 7.4.8 15.5-.4 4-2.7 6-5 7.7-1 1 .5 3 4.3 6 .4.2 1.5 1 2 3 .2.4 2 .4 2.2 0 .4-2 1.6-2.8 2-3 3.7-3 5.4-5 4.2-6-2.2-1.7-4.6-3.8-5-7.7-.6-8 .3-13.2.8-15.5.8-3.8 2.3-8.6 6-13 3-3.8 4.2-11.2-.5-16-3-3.2-7-7.4-8-10.7 0-.8-.3-1-.7-1-.3 0-.7.2-.7 1z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#edb92e",
              d: "M395 685.5h11.6c2 0 3.6 1.6 3.6 3.5 0 2-1.6 3.5-3.6 3.5H395c-2 0-3.5-1.5-3.5-3.5s1.6-3.5 3.6-3.5z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "M406.6 686H395v-1h11.6zm4 3h-1v-1l-.2-.2v-.2l-.2-.2v-.2h-.2v-.2h-.2v-.2h-.3v-.2h-.2v-.2h-.3l-.2-.2h-.5v-.2h-.6v-1h1l.2.2h.4v.2h.3l.2.2h.2v.2h.2v.2l.3.2.2.2v.2l.3.2.2.3v.3l.2.3v.4l.2.2zm-1 0h1zm-3 4v-1h.8l.3-.2h.2l.2-.2.2-.2h.3v-.2l.2-.2v-.2l.2-.2.2-.3v-.3l.2-.2v-.8h1v1.2l-.2.2v.4h-.2v.3l-.2.3h-.2v.3h-.2v.3h-.3l-.3.2v.2h-.3l-.2.2h-.2l-.3.2h-.4l-.2.2h-.8zm-11.5-1h11.6v1H395v-1zm-4-3h1v1l.2.2v.3h.2v.2h.2v.2h.2v.2h.2v.2h.2l.3.2h.2l.2.2.3.2h.6v1h-1.2v-.2h-.3l-.2-.2h-.2l-.2-.2-.2-.2-.3-.2-.3-.3-.2-.3-.2-.3-.2-.2v-.2l-.2-.2v-.4l-.2-.2zm1 0h-1zm3-4v1H394v.2h-.3l-.2.2h-.2v.2h-.2v.2l-.2.2-.2.2-.2.2v.2l-.2.2v.5h-.2v.6h-1v-1.2l.2-.2v-.2h.2v-.3h.2v-.2l.2-.2v-.2h.2l.2-.2v-.2h.3v-.2h.3v-.2h.3l.3-.2h.2l.2-.2h.5l.2-.2h.7z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#fff",
              d: "m417 579.2.5-11c-4.4-2.2-15.2 0-19.7 10.2a64.7 64.7 0 0 1-18 25.2c10 1.8 18.4-.2 23.7-7.4 7.3-9.8 11.2-15.7 13.6-17z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "m418 568.3-.4 11h-1l.4-11 .7-.5zm-.3-.5.3.2v.3zm-19.5 10.8-1-.4.6-1 .5-.8.5-1 .6-.7.5-.8.5-.8.7-.7.6-.6.7-.7.7-.5.7-.6.6-.4.7-.5.8-.4.8-.4.7-.3.8-.3.7-.2.7-.3h.7l.8-.3h1.2l.7-.2h2l.7.2h.5l.6.2.5.2.4.2-.4 1-.4-.3h-.5l-.5-.2h-.5l-.5-.2h-3l-.7.2h-.6l-.7.3-.7.2-.7.2-.7.2-.8.3-.7.3-.7.4-.7.4-.5.5-.7.5-.7.6-.5.6-.6.6-.7.7-.6.6-.5.7-.6.8-.5 1-.3.7zM380 603l-.2 1-.2-.8.6-.6.6-.5.7-.5.6-.6.7-.6.6-.6.5-.6.6-.6.6-.7.6-.7.5-.6.7-.7.5-.7.6-.7.5-.7.6-.8.4-.8.5-.7.5-.8.5-1 .5-.8.6-.8.6-1 .5-.8.6-1 .6-1 .5-1 .5-1 .5-1 .6-1 .5-1.2.5-1.2 1 .4-.6 1.2-.5 1-.6 1.2-.5 1-.4 1-.6 1-.5 1-.5 1-.6 1-.5 1-.6.8-.6.8-.5.8-.5.8-.6.8-.5.8-.6.7-.4.7-.6.8-.6.6-.5.7-.7.7-.6.6-.6.7-.4.6-.6.5-.6.6-.7.7-.6.5-.5.6-.6.6-.8.5-.2-1zm-.2 1h-1l.8-.8zm23.4-8 .8.5-.6.7-.5.6-.7.6-.6.6-.6.6-.5.5-.6.6-.7.5-.7.5-.7.4-.8.3-.7.4-.7.3-.7.3-.7.2-.7.3-.8.2-.8.2h-.8l-.8.2h-.8l-1 .2h-6.1l-1-.2-.8-.2-1-.2.2-1 1 .2.8.2h1l.8.2h6.6l.8-.3h.8l.7-.3.8-.2.7-.2.7-.3.7-.2.7-.2.8-.4.6-.3.7-.3.7-.4.6-.5.6-.5.5-.5.5-.5.6-.5.5-.6.7-.6.5-.7zm13.4-16.8h1l-.2.4-.2.2h-.2l-.3.3-.2.3-.3.2-.2.3-.3.3-.3.4-.3.3-.2.4-.4.5-.3.4-.3.3-.4.5-.3.5-.4.5-.5.6-.3.5-.4.5-.5.7-.5.6-.5.7-.5.7-.5.7-.5.6-.6.8-.6.8-.5.8-.6 1-.7.7-.7 1-.6.8-.8-.6.6-1 .7-1 .6-.7.7-1 .6-.7.6-.8.5-.7.5-.7.5-.7.5-.7.5-.8.5-.6.5-.6.4-.6.4-.6.4-.6.4-.5.4-.5.3-.5.3-.4.4-.5.3-.4.3-.4.3-.3.4-.3.3-.3.2-.2.3-.3.3-.2.4-.2h.2l.3-.2zm1 0v.3h-.2z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#fff",
              d: "m425.2 580.6-11.8-5c-5 10-8.2 16.6-9.5 20.2-2.8 7-3.5 13.8-2.3 19.5a22 22 0 0 0 14-11.6c3.8-7 6-15.3 9.5-23z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "m413.6 575.2 11.7 5-.3 1-11.8-5-.3-.8.6-.2zm-.7.2v-.4l.6.2zm-8.7 20.6-1-.4.2-.3.2-.4.2-.5v-.4l.2-.3.2-.5.2-.4.2-.5.2-.5.3-.5.2-.5.3-.6.2-.5.3-.6.3-.5.3-.7.2-.6.3-.6.3-.7.4-.8.3-.7.4-.8.2-.7.4-.8.4-.8.4-.8.4-.8.4-.8.4-1 .4-.8.5-.8.4-1 .8.5-.4.8-.5 1-.5.8-.4.8-.3 1-.4.7-.4 1-.5.7-.4.7-.3.8-.3.7-.4.6-.3.7-.3.7-.3.6-.2.7-.3.6-.3.5-.3.6-.3.6-.3.6-.2.5-.3.5-.3.5-.2.5-.2.4-.2.5v.5l-.2.4-.2.3v.3l-.3.4zm-2.7 18.8.2 1-.6-.4v-.5l-.2-.7v-.6l-.2-.5v-1.7l-.2-.5v-3.7l.2-.6v-1.2l.2-.7v-.6l.2-.5v-.7l.2-.6.2-.7v-.6l.3-.8v-.6l.3-.7.2-.7.2-.7.2-.7.2-.7.2-.7 1 .4-.3.6v.7l-.4.6-.2.6-.2.6-.2.7v.5l-.3.6v.8l-.3.6v.6l-.2.7v.6l-.2.6v.5l-.2.6v1.9l-.2.5v3.5l.2.5v1.2l.2.5v.7l.2.5-.6-.4zm.2 1h-.5v-.4zm13.5-12.4 1 .5-.5.6-.3.6-.4.6-.3.6-.4.6-.4.5-.5.6-.5.6-.4.5-.4.6-.5.4-.4.5-.5.4-.5.3-.4.4-.6.4-.5.4-.5.4-.5.3-.5.4-.5.3-.4.2-.5.2-.4.2-.5.2-.4.3h-.4l-.5.2-.5.2h-.5l-.4.3h-.5l-.2-1h.9l.4-.3h.4l.4-.3h.5l.4-.3.5-.2.4-.2.5-.2.5-.2.5-.3.5-.3.4-.3.4-.4.4-.3.5-.4.4-.4.4-.4.6-.4.4-.5.4-.4.5-.6.3-.4.4-.5.4-.6.5-.6.4-.5.2-.7.4-.6.4-.6.3-.6zM425 581l.3-.8.3.6-.3.7-.3.8-.3.7-.3.7-.3.8-.2.7-.3.7-.2.7-.3.7-.3.8-.3.7-.2.6-.3.8-.4.7-.3 1-.2.6-.2.7-.3.8-.3.8-.2.7-.3.7-.3.8-.3.7-.2.7-.3.7-.3.8-.3.7-.5.7-.3.7-.3.6-.5.6-.3.7-1-.6.5-.6.3-.7.3-.6.3-.6.4-.7.3-.6.3-.7.3-.7.2-.7.3-.7.2-.7.3-1 .3-.6.3-.7.3-.7v-.8l.4-.7.3-.7.3-.8.2-.7.3-.7.3-.8.3-.7.3-.7.3-.7.3-.7.2-1 .3-.6.3-.8.3-.7.4-.8.3-.8zm.3-.8.5.2-.2.4z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#fff",
              d: "m428.6 580.6-12.7-2c-2.4 10.8-4 18-4.4 22-1 7.5 0 14 2.7 19.4 4.3-2.3 8.8-7 10.7-14.7 2-7.8 2.2-16.3 3.6-24.7z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "m416 578.2 12.6 2v1l-12.8-2-.4-.6zm-.6.4v-.5l.6.2-.6.4zm-3.3 22h-1l.2-.5V599l.2-.6v-.5l.2-.6v-.5l.2-.6v-.6l.2-.5v-.6l.2-.6v-.6l.2-.6.2-.7v-.6l.3-.7v-.7l.2-.8v-.8l.3-.8.2-.8v-.8l.3-1 .2-.7.2-1 .2-.8.2-1 .2-1 .2-1 .2-1 1 .3-.2 1-.2 1-.2 1-.2 1-.2.8-.2 1-.2.7-.2 1-.2.7v.8l-.3.8-.2.8v.8l-.2.7v.6l-.2.7-.2.7v.6l-.2.6-.2.7v.4l-.2.6v.6l-.2.5v1.1l-.2.6v.4l-.2.4v1.2zm2 19 .5.8-.7-.2-.2-.5-.3-.5-.2-.5v-.6l-.3-.4-.2-.5-.2-.5-.2-.6v-.6l-.2-.6v-.6l-.3-.6v-.6l-.2-.6v-.6l-.2-.6v-2.8l-.2-.6v-5.4l.2-.7v-1.5h1v3.1l-.2.7v5.1l.2.6v1.2l.2.6v.6l.2.6v.6l.3.6v.5l.2.6v.7l.3.5v.5l.3.6.2.5.2.5.2.5.3.5.2.5-.7-.2zm.5.8-.5.3-.2-.5zm10-15.2 1 .2-.2.7-.2.8v.7l-.3.7-.3.7-.2.5-.3.6-.4.7-.3.6-.3.6-.3.4-.3.6-.4.5-.3.5-.4.5-.4.5-.4.4-.4.5-.4.3-.4.4-.4.4-.4.5-.4.3-.4.4-.4.3-.4.3-.4.3-.4.4-.5.3-.4.3-.4.2-.5.2-.5-.8.4-.2.4-.3h.4l.4-.4.4-.3.4-.3.4-.3.4-.3.4-.3.4-.3.3-.3.4-.4.4-.4.5-.4.3-.4.4-.5.3-.4.4-.6.2-.5.3-.6.3-.5.3-.6.4-.6.3-.5.3-.6.2-.6.3-.5.2-.6.3-.8.2-.7.2-.6zm4-25v1l.5-.5v.8l-.2.8v.7l-.2.8v.8l-.2.8v.8l-.2.8v.7l-.2.8v.8l-.2.8v1.7l-.2.7v.8l-.2.8v.8l-.2.8v.7l-.2.8v1l-.2.6v.8l-.2.8-.2.7v.7l-.2.7-.2.8v.7l-.3.7-.2.7-1-.2.2-.8.2-.7v-.7l.2-.8v-.7l.3-.7v-.8l.2-.8v-.7l.2-.8v-1.5l.2-.8v-.7l.2-.8v-1l.2-.7v-.7l.2-.8v-1.6l.2-.8v-.8l.2-.7v-1l.2-.7v-.8l.2-.8v-.8l.2-1v-.7l.3-.8.5-.4zm-.4.3v-.4h.5l-.4.5zm.5.6v-1z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#fff",
              d: "M430.4 563.4h7.6c4.4 2 9 12.2 3.7 22a65.8 65.8 0 0 0-9.5 29.2c-7.4-6.8-10.8-14.7-8.2-23.3 3.4-11.7 6.8-25.2 6.4-28z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "M438 564h-7.6v-1h7.8zm0-1h.2zm4 22.5-.8-.5.5-1 .4-.8.4-.8.3-1 .3-.8.2-1v-.7l.3-1V574l-.2-1v-.6l-.3-.8-.2-.7-.3-.8-.2-.7-.3-.6-.3-.7-.3-.6-.3-.6-.3-.4-.3-.5-.4-.3-.4-.4-.3-.4-.4-.4-.5-.3-.4-.3-.3-.2.5-1 .4.4.5.2.5.4.4.4.4.4.4.4.4.5.4.6.3.6.3.6.3.6.3.7.2.7.3.7.2.6.2.8v.7l.3 1v.8l.2.8v3.5l-.2 1v1l-.4.8-.3 1-.3 1-.4.8-.4 1-.5 1zM432 615l.5-.7-.8.3v-.8l.2-1v-2.3l.3-1v-.7l.2-.8.2-1 .2-.8v-1l.2-.7.3-1 .2-.8.2-1 .2-.7.3-1 .3-.8.3-1 .4-1 .4-.8.4-1 .4-1 .4-1 .4-1 .5-1 .4-1 .5-1 .5-1 .5-1.2.6-1 .6-1.2 1 .5-.7 1-.6 1.2-.7 1-.5 1-.5 1.2-.5 1-.4 1-.5 1-.5.8-.4 1-.3 1-.3 1-.4.8-.3 1-.3.8-.2.8-.3 1-.4.8-.2.8-.2 1-.2.7-.2 1v.7l-.3.8v1l-.3.7v.8l-.2.8v1l-.2.7v1.8l-1 .2zm.7-.3v1l-.8-.7.7-.3zm-9.2-23.6 1 .4-.3.8-.2.8v.8l-.2.7v.8l-.2.8v3l.2.8.2.8v.7l.3.7.3.7.2.8.3.7.4.7.4.6.3.7.5.7.4.7.4.7.5.6.4.7.5.7.4.6.6.7.6.6.6.7.7.6.5.7-.6.7-.8-.6-.7-.7-.6-.7-.7-.6-.6-.7-.6-.7-.4-.7-.6-.7-.4-.7-.5-.8-.3-.7-.5-.7-.3-.8-.5-.7-.3-.7-.3-.8-.4-.7-.2-.7-.2-.8-.2-.7v-.8l-.2-.8v-.8l-.2-.8v-2.5l.2-.8v-.8l.3-.8.3-1 .2-.7zm7-28v1l.4-.7v1.8l-.2.5v1.1l-.2.7-.2.7v.8l-.3.8v.8l-.2 1-.2.8-.2 1-.3 1v1l-.4 1-.2 1-.3 1-.2 1-.2 1-.3 1.2-.3 1-.3 1.2-.3 1-.3 1.2-.3 1.2-.3 1-.3 1.2-.2 1-.4 1.2-1-.3.4-1 .3-1 .5-1.2.3-1 .3-1.2.4-1.2.3-1 .3-1.2.3-1 .3-1.2.3-1 .2-1 .2-1 .3-1.2.2-1 .2-1 .2-1 .2-.8.2-1 .2-.8.2-.8v-.8l.3-.7v-.8l.2-.7v-.6l.2-.6v-2l.4-.6zm-.6.5v-.6h.4l-.5.5zm.4 0v-.6.4zm-.5 0v-.6h.4l-.5.5z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#fff",
              d: "m433.8 558.2-12-4.3c-4.3 10-7.2 16.8-8.4 20.5-2.3 7.3-2.6 14-1 19.6a21.3 21.3 0 0 0 14-11.6c3.3-7.3 4.5-16.3 7.4-24.2"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "m422 553.4 12 4.3-.4 1-12-4.4-.3-.6zm-.7.3.2-.4h.4l-.7.4zm-7.4 21-1-.3v-.4l.2-.4v-.4l.3-.4v-.4l.3-.5.2-.5v-.5l.3-.5.2-.5.2-.6.3-.6.2-.5.2-.6.3-.6.2-.6.2-.6.3-.7.3-.6.3-.7.4-.7.3-.8.3-.8.3-.7.4-.8.3-1 .4-.8.3-1 .4-.8.5-1 .4-.8.3-1 1 .5-.5 1-.4 1-.4.8-.3 1-.4.8-.4.8-.4.8-.3.8-.4.8-.4.8-.3.7-.3.8-.3.8-.3.7-.3.6v.8l-.4.6-.2.6-.3.6v.6l-.3.6-.2.5-.2.5-.2.5v.5l-.3.5-.2.4v.5l-.3.4v.3l-.2.3v.4zm-1.8 19 .3 1-.6-.4-.3-.6v-.5l-.2-.6v-.5l-.2-.5v-.6l-.2-.7V583l.2-.7V581l.3-.6v-.7l.2-.6v-.6l.3-.6.2-.7v-.6l.3-.7.2-.6.2-.6 1 .3-.3.6-.2.7-.2.7-.2.6v.7l-.2.6v.7l-.2.6-.2.6v.6l-.2.6v1l-.2.7v6.5l.2.6v1.1l.2.4.2.6v.5l.2.5zm.3 1h-.5v-.4l.5.3zM426 582l.8.6-.3.6-.4.7-.2.5-.4.6-.4.7-.4.6-.4.5-.4.5-.4.5-.5.5-.5.5-.5.4-.4.4-.5.4-.4.4-.4.4-.5.3-.5.5-.5.3-.5.3-.5.4-.4.2-.5.3h-.5l-.5.4-.5.2-.5.2-.5.2h-.4l-.6.3-.4.2h-.5l-.3-.8.4-.2h.5l.5-.3.5-.2h.4l.5-.3.4-.2.4-.3.5-.2.5-.2.5-.3.4-.3.5-.3.5-.4.4-.3.6-.3.4-.4.5-.3.4-.4.4-.5.4-.4.4-.4.4-.4.4-.5.4-.5.4-.5.4-.5.4-.6.3-.6.3-.6.3-.6.3-.7zm7.6-23.4.4-1 .3.7-.3.8-.3.8-.2.8-.3.7-.2.8-.2 1-.2.6-.2.8-.3.8v.8l-.3.7-.2.8-.2.8-.2.8v1l-.3.6-.2.8-.2.8-.2.8v.7l-.3.8-.2.8-.3.7-.2.8-.2.7-.3.8-.3.7-.2.7-.3.8-.3.7-.3.7-.2.6-1-.5.4-.5.3-.7.3-.7.3-.6.3-.7.3-.8.2-.8.2-.7.3-.8.2-.7.2-.8.2-.7v-.8l.4-.8.2-.8.2-.8.2-.8.2-.8.2-.7.2-.7.2-.8.2-.8.2-.8.2-1 .2-.6.2-.8.3-.8.3-.8.2-.7.3-.8.3-.8.3-.7.3.6zm.4-1 .4.3v.3zm-.2.6-.2.4zm.2-.5.4.2v.3l-.4-.6z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#fff",
              d: "m425.6 549.7-2.6-16.4c-2.8-.7-6.5 5.8-10 9.5-1 1-2 1.7-2.6 2.8a23.3 23.3 0 0 0-3.4 8 62.3 62.3 0 0 1-13 27.6c10.2-.2 18-3.8 21.8-12 5-11 7.7-17.7 9.8-19.5"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "m423.4 533.3 2.7 16.4h-1l-2.5-16.3.6-.6.4.5zm-.3-.4h.4v.2l-.3-.4zm-9.7 10.2-.8-.7.4-.4.2-.2.3-.4.4-.4.2-.4.3-.4.4-.4.2-.5.3-.4.4-.5.2-.4.3-.3.4-.5.2-.4.3-.4.4-.3.2-.3.3-.4.3-.3.4-.3.3-.4.3-.2.3-.2.4-.2.4-.3h.3l.4-.3h.3l.4-.2h1.1l-.2 1h-1l-.3.2-.2.2-.3.2-.3.2-.3.2-.3.3v.4l-.5.3-.3.3-.3.3-.4.4-.3.4-.3.5-.4.4-.3.3-.3.4-.3.4-.4.5-.3.5-.3.4-.4.4-.3.4-.4.4-.3.4-.4.4-.4.4-.3.4zm-2.5 2.7-.8-.7v-.2h.2l.2-.2v-.2h.2v-.2h.2v-.2h.2v-.2h.2v-.2l.2-.2h.2v-.2l.2-.2h.2v-.2h.2v-.2h.2v-.2l1 .6h-.2l-.2.2v.2h-.2v.2h-.2l-.2.2v.2h-.2l-.2.2v.2h-.2v.2h-.2v.2h-.2v.2h-.2v.2l-.2.2v.2zm-3.3 7.7-1-.2v-.6l.2-.4v-.3l.2-.3v-.8l.2-.3v-.3l.2-.3v-.3h.2v-.4l.2-.3v-.2l.2-.2v-.2l.3-.3v-.2l.2-.2v-.2l.3-.2v-.3h.2v-.3l.3-.3v-.2l.3-.2v-.2l.2-.3.2-.2.8.6-.3.3v.2l-.2.2-.2.2v.4l-.2.2-.2.2v.3l-.2.3v.2l-.2.3-.2.2v.2l-.2.3v.2l-.2.3v.2l-.2.3v.2l-.2.3v.5l-.2.3v.2l-.2.3v.5l-.2.3v.7zm-13.4 27v1l-.3-.8.5-.8.5-.7.5-.6.5-.8.5-.7.5-.7.4-.6.6-.7.4-.7.5-.8.4-.7.4-.7.4-.8.4-.7.4-.7.4-.8.4-.8.4-.8.4-1 .4-1 .3-.8.3-1 .3-.8.4-1 .3-1 .4-1 .3-1 .3-1.2.3-1 .3-1.3.2-1.3.3-1.2 1 .2-.3 1.2-.3 1-.4 1.3-.3 1.2-.4 1-.4 1-.3 1.2-.4 1-.4 1-.4 1-.3 1-.5.8-.4 1-.3.8-.4.8-.4 1-.5.8-.4.8-.3.7-.5.8-.4.8-.5.8-.4.7-.6.7-.5.7-.5.7-.5.7-.5.8-.5.7-.5.6-.5.8-.5.7-.4-.8zm0 1h-1l.7-.8zm21.3-12.8 1 .4-.5.7-.4 1-.4.6-.4.7-.5.7-.4.6-.5.6-.5.6-.5.6-.6.5-.6.4-.6.5-.7.4-.6.4-.8.4-.7.4-.7.4-.7.3-.7.3-.8.3-.8.2-.8.2-1 .2-.7.2-1 .2-.7.2h-1l-.8.2h-1l-.8.2h-2v-1h2.8l1-.2h.8l.8-.2 1-.2h.7l1-.3.7-.2.7-.3.8-.2.7-.3.7-.3.7-.3.6-.3.7-.3.6-.4.7-.5.6-.4.6-.4.5-.4.6-.6.5-.5.5-.4.5-.6.5-.6.4-.7.5-.6.4-.6.3-.7.3-.8zm9.8-19.2h1v.3l-.3.3v.2l-.3.2-.2.2-.2.2-.2.3-.3.4-.2.2-.2.4v.4l-.4.5-.2.5-.3.5-.2.5-.3.6-.2.6-.3.6-.3.6-.4.7-.3.8-.3.8-.4.7-.3.8-.4 1-.4.7-.4 1-.4.8-.4 1-.4 1-.5.8-.3 1-.5 1-1-.4.6-1 .4-1 .5-1 .4-1 .5-1 .4-.8.3-1 .4-.7.4-.8.4-.8.4-1 .3-.6.4-.7.4-.7.3-.6.4-.7.3-.6.2-.4.2-.6.3-.5.2-.5.3-.4.2-.5.3-.3.2-.4.2-.3.2-.4.2-.3.2-.3.2-.2.3-.2.3-.2-.2.4zm1 0v.3z"
            })
          ]
        }),
        /* @__PURE__ */ jsx262("use", {
          xlinkHref: "#rs_svg__d",
          width: 1350,
          height: 900,
          transform: "matrix(-1 0 0 1 964.3 0)"
        }),
        /* @__PURE__ */ jsx262("path", {
          fill: "#fff",
          stroke: "#21231e",
          d: "M536.4 415a38 38 0 0 0 4.8-1.5 66.2 66.2 0 0 1-21.4-22c-7.8-12 3.3-33 8-44.3a53 53 0 0 0 21.2-31c1-7.3-19-4.7-33 2-17 8-19.3 5.7-25.4 7-2.2 10.5 2.4 11.4 6.7 11-9.4 15-13.3 29.8-15 51.4-2-21.6-6-36.5-15.3-51.5 4.3.6 9-.3 6.7-10.7-6-1.4-8.4.8-25.4-7.2-14-6.5-34-9-33-1.8 3 13.7 11.8 24 21.3 31 4.6 11.2 15.7 32.4 8 44.2a67.3 67.3 0 0 1-21.5 22c1.7.7 3.3 1.2 5 1.5-1.2 1.5-11 4.5-12.3 3.7-7.6-5.3-15-18-21.4-25.2-18.2-20.8-27.3-36.7-24-49.6 4.5-14 20.8-29.6-.8-27-21.7 2.8-39.6 32.5-45.4 68.3-2 13.2-3.3 24.4-4.7 33.5 11.8-4.3 17-8.5 20.2-13.7-1.4 5-2.5 9.7-3.2 14.2 9.7-1.7 16.7-6.4 19.2-15 1-3.6 2.3-6.5 3.6-9 3 1 7 1 11.6 0 1.7 4 15 19 22.2 30 8 12.2 20.2 21.6 24.2 22 2 .4 2.7-4 2.2-10.2 21 .2 42.3.3 63-.4 20.7.7 41.8.6 63 .4-.6 6 0 10.6 2 10.3 4-.5 16.2-10 24.3-22.2 7-10.8 20.5-25.7 22.2-30a20 20 0 0 0 11.6.2c1.3 2.5 2.5 5.4 3.5 9 2.5 8.6 9.5 13.3 19.2 15-.7-4.5-1.8-9-3.2-14 3.2 5 8.4 9.3 20.2 13.6-1.4-9-2.7-20.3-4.8-33.5-5.8-35.8-23.7-65.5-45.4-68.2-21.6-2.6-5.3 13-.7 27 3.3 12.8-5.8 28.7-24 49.5-6.5 7.3-13.8 20-21.4 25.2-1.2.8-11-2.2-12.2-3.8z"
        }),
        /* @__PURE__ */ jsxs237("g", {
          id: "rs_svg__e",
          children: [
            /* @__PURE__ */ jsx262("path", {
              fill: "#edb92e",
              d: "M440.6 356.8c-2 1.8-8.8 1.8-18 2.4-14.8.5-23.4-4-25.3-13.5 5.6 6.6 12.2 10 19.7 8 10.2-2.5 16-4.3 18.3-3.8 1.6.4 4 3.3 5.3 6.8z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "M422.6 359.7v-1h1.8l.7-.2h2.5l.8-.2h2.8l.8-.2h3l.5-.2h1l.4-.2h.5l.4-.2h.4l.5-.2h.3l.3-.2h.4l.3-.2h.2v-.3h.3l.6.7h-.3l-.3.3-.3.2h-.2l-.3.3h-.4l-.3.2h-.4l-.4.2h-.5l-.5.2h-1l-.5.2h-1.5l-.6.2H432l-.6.2h-2.8l-.8.2h-2.3l-1 .2H423zm-25-14.3-.7.6.8-.4.2 1 .2.7.3.8.3 1 .3.6.5.7.4.7.4.6.5.6.4.6.6.6.6.5.6.4.7.5.6.3.8.5.8.4.8.3 1 .4.8.2 1 .3 1 .2 1 .2h1l1 .3h1.2l1.2.3h6.6v1H416l-1-.2h-1.3l-1-.3h-1.2l-1-.3-1-.3-1-.3-1-.2-1-.4-.8-.3-.8-.4-1-.4-.7-.5-.7-.5-.7-.5-.7-.6-.6-.5-.6-.6-.4-.8-.5-.7-.3-.7-.4-.8-.4-.7-.4-1-.3-.7-.3-1-.2-.8 1-.4zm19.3 8 .2 1h-.8l-.7.2h-1.4l-.7.2h-2.8l-.6-.2-.7-.2h-.7l-.6-.3h-.7l-.6-.3-.8-.3-.6-.3-.6-.2-.6-.3-.6-.4-.6-.3-.6-.4-.6-.4-.6-.6-.6-.4-.6-.5-.5-.6-.6-.6-.4-.6-.6-.5-.5-.6-.6-.7.7-.6.5.6.5.6.6.6.5.5.5.5.6.5.4.5.6.5.6.4.5.5.7.4.6.3.6.3.4.3.6.2.6.3.6.2.7.2h.5l.6.3.7.2h.6l.7.2h4.7l.6-.3h.7zm18.5-4-.3 1h-2.6l-.4.2h-.9l-.5.2-.5.2h-.5l-.6.2h-.5l-.6.3h-.5l-.7.3-.7.2h-.6l-.7.3-.7.2-.8.2-.8.2h-.8l-.8.3-1 .3-.8.2-1 .2-.8.3-.3-1 1-.2.8-.2 1-.2.7-.2 1-.2.7-.2.8-.2.7-.2.8-.2.7-.2.7-.2.6-.2h.6l.6-.3h.6l.6-.3h.6l.5-.2h.6l.5-.2h.6l.4-.2h.9l.3-.2zm5.4 7.8-.7-.8-.2.6v-.7l-.3-.3v-.3l-.3-.3v-.3l-.3-.2v-.3l-.2-.2-.2-.3v-.3l-.3-.2-.2-.3v-.2l-.2-.2-.2-.3v-.2l-.3-.2h-.2v-.3h-.2l-.2-.3v-.2h-.3l-.2-.2v-.2h-.2v-.2h-.4v-.2h-.2l.3-1h.2l.2.2.2.2h.2l.2.2.2.2h.2v.3l.3.2.2.2h.2l.2.3v.2l.2.2.2.2.2.2.2.2.2.3v.2l.3.2.2.3.2.3v.3l.3.4.2.3v.3l.3.3v.3l.3.3v.3l.2.3v.6zm0-.6.2.3-.3.2v-.6zm-21.5-35.4v1.5h-.4v-.4h-.2v-.7l.2-.2h.2v-.2zm15.3 4-.5 1.3-.6-.2-.5-.2h-.6l-.5-.2-.4-.2-.5-.2-.4-.2-.5-.2-.4-.2h-.5l-.4-.3-.5-.2h-.4l-.4-.3h-.5l-.4-.3h-.5l-.4-.2h-.4l-.5-.2h-.4l-.3-.2h-1.3l-.4-.2H420v-2h2.9l.5.2h1l.4.2h.5l.3.2.5.2h.5l.4.2.5.2h.5l.4.3h.6l.5.3.6.2h.5l.6.3.5.2.6.2h.5l.6.3.6.2.5.2.6.2h.5zm9 2.5v1.5H442l-.3-.2h-.4l-.3-.2h-.3l-.4-.2h-.3l-.4-.2h-.4l-.3-.2h-.5l-.3-.2-.4-.2h-.3l-.4-.2h-.2l-.3-.2h-.3l-.3-.3h-.7l-.2-.2h-.4l-.2-.2.4-1.5h.2l.2.2h.2l.2.2h.3v.2h.4l.3.2h.3l.3.2h.4l.3.2.3.2h.4l.3.2h.4l.3.2h.4l.4.2h.3l.4.2h.4l.3.2h.6l.3.2zm0 1.5v-1.5h.4v.2h.2v.2h.2v.9h-.2v.2h-.2v.2h-.2zm23.4 7.5.2-1.2h.2v.2h.2v.8h-.6zm-10-2 .4-1.2h.5l.3.2h.4l.3.2h1.1l.2.2h.6l.2.2h.6l.3.2h.7l.4.2h.8l.3.2h.9l.2.2h.9l.5.2h.8l-.2 1.3h-.9l-.4-.2h-.6l-.4-.2h-.7l-.4-.2h-1.4l-.3-.2h-.7l-.3-.2h-.6l-.3-.2h-.5l-.4-.2h-.5l-.3-.2h-.5l-.2-.2h-.5l-.2-.2zm.4-1.2-.3 1h-.2v-.8h.8z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "m431.5 332-.7 1.3-.4-.3-.4-.2-.4-.3-.3-.2-.4-.3-.4-.3-.3-.3-.4-.3-.4-.2-.3-.4-.3-.3-.2-.3-.3-.3-.3-.4-.2-.3-.3-.4-.2-.3-.3-.4-.2-.4-.2-.3-.3-.5-.2-.4-.2-.2v-.4l-.3-.4-.2-.3-.2-.4-.2-.3v-.4l-.2-.3-.2-.3-.2-.4 1.4-.7.2.2.2.4v.3l.3.2.2.4.2.3v.3l.3.3.2.4.2.3.2.4v.3l.3.4.3.3.2.4.2.4.2.4.3.3.2.4.3.4.2.3.3.4.3.3.3.3.3.2.3.3.3.3.2.2.4.3.3.2.2.2.3.2zm7.6-5.3 1.5.8-.2.4-.2.3-.2.4-.2.4-.3.5-.3.4-.2.2-.3.4-.3.3-.3.2-.3.3-.3.3-.3.3-.2.4-.3.2-.3.2-.4.2-.3.2-.3.2h-.3l-.5.2h-.3l-.3.2h-2.2l-.4-.2-.3-.2h-.2l.7-1.5h.5l.2.2h1.7l.3-.2h.2l.3-.2h.2l.3-.3.2-.2.3-.2h.2l.3-.3.2-.3.3-.2.2-.3.3-.4.2-.3.3-.3.2-.4.2-.3.3-.4.2-.5.2-.4v-.3z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "m429.6 331-2.2-2.3c-1-1.3-.5-3 2-5.4 1.5.7 3 1.3 4.2 2-1 3-2.2 4.8-4 5.6zm-6.3 82-.4 1h-.4v-1zm23.8-3.6 1 1-.7.5-.6.4-.7.5-.6.4-.7.5-.7.3-.7.4-.7.4-.7.4-1 .3-.6.3-.8.2-.7.2-1 .2-.7.2h-.8l-.8.2h-5l-1-.2h-.8l-.8-.3h-1l-.8-.4h-1l-.7-.3-1-.3-.8-.3.3-1 .8.2 1 .3 1 .3.7.2 1 .2.7.2h.8l1 .2h.7l.7.2h4.8l.7-.2h1l.6-.3.7-.2h.7l.7-.4.7-.3.7-.3.8-.3.6-.4.7-.4.7-.5.6-.5.6-.5.5-.5zm3-2.8 1 .8h-.2v.2h-.2l-.2.2v.2h-.2v.2h-.2v.2h-.2l-.2.2-.2.2v.2h-.2v.2h-.2l-.2.2-.2.2-.2.2-.2.2v.2h-.2l-1-.8h.2v-.2h.2v-.2h.2l.2-.2.2-.2.2-.2v-.2h.2v-.2h.2l.2-.2.2-.2.2-.2v-.2h.2l.2-.2.2-.2v-.2zm1 .8-1-.8.2-.2h.7v.2h.2z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "m452.2 401.3-1.2-.2v-.2h.2l.2-.2h.6v.4h.2zm-5.5 16 .3 1-.7-.8.2-.4.2-.4.2-.5v-.4l.3-.4.2-.5.2-.5v-.5l.3-.4.2-.5.2-.5v-.5l.3-.5v-.5l.3-.5v-.5l.3-.5v-.5l.3-.5v-.5l.2-.5.2-.6v-.5l.2-.6v-.5l.2-.4v-.6l.2-.6v-.5l.2-.7v-.6l.2-.6 1.2.3v.6l-.2.5v.6l-.2.6v.6l-.2.6v.5l-.2.6-.2.4v.6l-.2.5v.6l-.3.6v.5l-.3.6v.6l-.3.5v.5l-.2.5-.2.5v.5l-.3.5-.2.5v.5l-.2.4-.2.5-.2.6-.2.5-.2.6-.2.5-.2.5-.2.5-.7-.8zm-.4.2 1 .5v.2h-.2v.2h-.4l-.2-.2v-.2h-.2v-.4zm15.2-9.5 1 .7-.3.4-.4.6-.3.4-.4.4-.2.4-.4.4-.4.4-.4.4-.4.3-.4.4-.5.3-.4.4-.6.3-.4.3-.5.3-.5.3-.5.3-.5.2-.5.3-.5.3-.6.2-.5.3-.7.2-.5.3-.6.2-.6.2-.6.2-.6.2-.6.2-.6.2-.6.2-.6.2-.3-1.2.6-.2h.6l.5-.3.6-.2.6-.2.6-.2h.6l.5-.3.6-.3.4-.2.5-.2.4-.3.5-.2.4-.3.5-.3.4-.4.5-.3.3-.3.5-.3.4-.3.4-.3.4-.2.4-.4.4-.3.4-.3.4-.3.3-.4.3-.4.3-.4.3-.4.2-.4.3-.4zm1 .7-1-.7h.2v-.2h.7v.2h.2z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "M461.3 400.2H460v-.2h.2v-.2h1v.4zm4.4 15.7.7 1-.8-.3-.3-.4-.3-.4-.2-.5-.3-.5-.2-.4-.3-.4-.2-.5-.3-.5-.2-.4-.2-.5v-.5l-.3-.5-.2-.5-.2-.5-.2-.5v-.5l-.2-.5-.2-.5v-.6l-.3-.5v-.5l-.3-.6v-.4l-.2-.6v-.6l-.2-.5v-.7l-.2-.6v-.6l-.2-.5v-1.2h1v.5l.2.6v.6l.2.5v1.4l.2.5.2.6v.5l.2.5v.6l.3.5v.4l.2.5.2.4v.5l.2.4.2.5.2.4.2.5.2.4.2.4.2.5.2.4.2.5.3.4.3.4.2.4.3.5.2.3.3.4.3.3h-1zm0 .7 1-.7v.8l-.2.2h-.2v.2h-.4v-.2h-.2zm7.6-12.6 1 .4v.6l-.2.5v.5l-.2.5-.2.5-.2.5-.2.5-.2.5-.2.4-.2.4-.2.4-.3.5v.4l-.4.4-.2.5-.3.4v.3l-.4.3-.3.4-.3.4-.2.3-.3.3-.3.4-.3.3-.4.3-.3.3-.3.3-.3.2-.3.3-.3.4-.3.2-.3.3-.7-1 .3-.3.3-.2.3-.3.3-.2.2-.3.3-.3.2-.2.3-.3.3-.4.3-.3.2-.4.3-.4.4-.3.2-.4.3-.4v-.4l.4-.3.2-.5.3-.4v-.3l.3-.4.2-.4.2-.6.2-.4v-.5l.3-.4.2-.4.2-.5v-.4l.3-.5v-.4zm1 .4-1-.3v-.2h.8v.2h.2z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#edb92e",
              d: "M406 317.8c-16.7 1.8-16 12.6-.4 28 3 3 4 3 4.6-.2 1.2-5.3 7-8.5 10.2-4.4 2 2.7 1.6 4.3 8.6 3.3 9 7.5 16.2 12.8 4.5 12.3-5-.2-9 2.8-15.7 2.5 2 4 2.3 4.3 3.4 4.6 6.5 1.2 13.3-2.8 19.8-1.6 14.3 2.6-23-38.6-22.4-40.3 1-4-9-11.5-12.7-4.2z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "m406 345.5-.7.7-1.4-1.5-1.5-1.4-1.2-1.4-1.2-1.4-1-1.3-1-1.3-.8-1.3-.8-1.2-.8-1.2-.6-1.2-.5-1-.5-1.2-.3-1-.3-1v-1l-.2-1v-1l.2-1 .2-.8.4-.8.4-.8.6-.7.6-.7.8-.6.8-.6 1-.5 1-.5 1-.4 1.4-.4 1.3-.3 1.3-.2 1.6-.2v1l-1.5.2-1.4.2-1.2.3-1.2.3-1 .4-1 .5-1 .4-.6.5-.7.7-.6.6-.4.6-.4.6-.4.7-.2.8-.2 1v1.7l.2.8.2 1 .4 1 .4 1 .5 1 .5 1.3.7 1 .8 1.3 1 1.4.8 1.2 1 1.3 1.2 1.3 1.2 1.3 1.4 1.4 1.4 1.5zm3.8 0 1 .2v.3l-.2.3v.5l-.2.2v.2l-.2.2v.2l-.2.2-.3.3v.2h-.3l-.2.2H408l-.2-.2h-.2l-.2-.2h-.2l-.2-.3-.2-.2h-.2l-.3-.4h-.2l-.2-.3-.3-.3-.2-.2.7-.7.2.2.3.3.2.2.3.2.2.2.2.2h.2l.2.2.2.2h.3v.2h.6l.2-.2v-.2l.2-.2v-.2l.2-.4v-.4l.2-.3zm11-4.6-.8.5-.3-.4h-.3l-.3-.4-.2-.2-.3-.2h-.3l-.3-.2h-.5l-.3-.2h-1.5l-.3.2-.4.2h-.2l-.4.3-.3.2-.2.2-.4.2-.3.2-.2.3-.3.3-.2.4-.3.3-.2.4-.3.5-.2.4-.2.3v.5l-.2.4v.5l-1-.2v-.5l.2-.5.2-.5.2-.5.3-.5.2-.4.2-.4.3-.4.3-.4.3-.4.4-.3.4-.3.4-.3.4-.2.3-.2.3-.2.5-.2h.4l.4-.2h.4l.4-.2h1l.4.2h.6l.4.3.4.3.3.2.4.3.4.5.4.4zm8.6 3.2-.7.7h.4-.5l-.6.2h-4.5l-.2-.2h-.3l-.2-.2h-.2l-.2-.2-.2-.2-.2-.2h-.2v-.3l-.3-.3v-.2l-.3-.2v-.2h-.3l-.2-.3-.2-.3v-.2l-.3-.2v-.3l-.3-.2.8-.6h.2v.4l.3.2.2.3.3.3v.2l.2.2.2.2.2.2.2.2.2.2h.2v.2h.3l.2.2h.2l.2.2h5.4zm-.4 0 .2-.2.2.2zm4.5 13v-1h4.1l.5-.2h.4l.3-.3h.2v-1l-.2-.3-.2-.4-.3-.5-.4-.4-.5-.4-.4-.4-.4-.5-.6-.5-.6-.6-.6-.6-.7-.5-.6-.6-.7-.7-.7-.7-.8-.6-.8-.7-.8-.7-1-.7.8-.8.8.7.8.5.8.7.8.7.7.5.8.6.8.7.7.6.6.6.7.4.6.6.5.5.5.5.4.5.4.4.4.4.3.4.2.4v2.3l-.4.3-.3.2-.4.3-.6.2h-.6l-.7.2h-3.6zm-15.2 2-1 .4.5-.8h3.4l.6-.2h.5l.5-.2h.5l.5-.2h.5l.4-.2h.5l.5-.2.4-.2h.6l.4-.2.5-.2h.4l.4-.2h.5l.3-.2h.5l.4-.2h.5l.5-.2h2.6v1H431l-.4.2h-.9l-.4.3h-.8l-.4.2h-.5l-.4.3h-.6l-.5.2h-.5l-.5.3h-.5l-.5.2h-.5l-.5.2h-.5l-.6.2h-.6l-.6.2h-3l.5-.7zm-1 .4-.3-.8h.8l-.4.8zm4 4-.2.8h-.4v-.2h-.2l-.2-.2h-.2v-.2h-.2v-.2h-.2v-.2l-.2-.3-.2-.2-.3-.3-.2-.2v-.2h-.2v-.4l-.3-.2v-.3h-.3v-.4l-.3-.3v-.4l-.3-.4 1-.5v.5l.2.3.2.3v.4l.3.3.2.2v.2l.3.2v.2l.2.2v.2h.2v.3l.2.2v.2l.2.2h.2v.2h.4v.2h.4zm19.8-1.7v1l-.7-.2h-4.7l-.6.2h-.7l-.6.2h-.7l-.6.2-.6.2h-.6l-.6.2h-.7l-.7.3-.6.2h-.6l-.6.2h-.6l-.6.2h-4.6l-.6-.2.3-1 .6.2h4.8l.6-.2h.6l.5-.2h.6l.7-.2.7-.2h.6l.6-.2.6-.2h.7l.5-.2h.6l.7-.2h.7l.6-.2h4.9zm-23-40 1 .3.3.3.5.7.6.8.8 1.2 1 1.2 1 1.3 1 1.5 1.3 1.5 1.3 1.7 1.4 1.8 1.4 1.8 1.5 1.8 1.5 2 1.5 1.8 1.4 2 1.4 2 1.3 1.7 1.3 2 1.2 1.7 1 1.7 1 1.6.8 1.5.6 1.4.4 1.3.3 1.2v2l-.6.7-.8.5H441v-1h2l.4-.3.3-.4V360l-.3-1.2-.4-1.2-.6-1.3-.8-1.5-1-1.6-1-1.7-1-1.8-1.3-1.8-1.4-2-1.4-2-1.4-1.8-1.5-2-1.4-1.8-1.5-1.8-1.4-1.8-1.3-1.8-1.3-1.6-1.2-1.6-1-1.5-1.2-1.3-1-1.2-.7-1-.6-1-.5-.7-.3-.4v-.6zm-12-3.7v-1l-.5.2.4-.6.3-.7.5-.6.5-.4.5-.3.6-.3.5-.2.5-.2h2.6l.6.2.6.2.5.3.6.2.6.3.4.4.5.2.4.4.4.4.5.5.4.4.3.4.3.4.3.5.2.5.2.5v.5l.2.5v1l-1-.3v-1l-.2-.4v-.4l-.3-.4-.2-.4-.3-.4-.3-.4-.5-.4-.3-.4-.5-.4-.4-.4-.5-.3-.4-.3-.5-.3h-.7l-.5-.3-.5-.2h-.5l-.6-.2h-2l-.4.3-.5.2-.4.3-.5.5-.4.4-.3.4-.3.6-.4.3zm.4-.3-.2.2h-.2zm-.5-.2v.5zm.4.2-.2.2h-.2z"
            }),
            /* @__PURE__ */ jsx262("path", {
              fill: "#21231e",
              d: "m407 317.2-1.3.4v-.6h.2v-.2h.8v.2h.2v.2zm7.6 10.6-.8 1-.4-.4-.3-.4-.3-.3-.3-.3-.4-.3-.3-.2-.3-.4-.3-.3-.2-.2-.3-.4-.3-.3-.3-.2-.4-.4-.3-.3-.2-.2-.2-.4-.2-.3-.3-.3-.2-.3v-.4l-.4-.3-.2-.4-.2-.4-.2-.4-.2-.4v-.4l-.3-.3-.2-.4v-.3l-.3-.3v-.4l-.3-.4 1.2-.4v.7l.3.3v.3l.3.4v.3l.3.4v.3l.3.4.2.3.2.3.2.4v.3l.3.3.2.4.3.3.2.3.3.4.2.3.3.3.3.3.4.4.2.3.3.3.2.3.3.3.4.2.2.3.3.3.4.4.2.3.4.3zm-.8 1 .8-1v.2h.2v.7h-.4v.2zm-9.5-4.6c.8 0 1.3.7 1.2 1.5s-.8 1.3-1.5 1.2c-.8-.2-1.3-.8-1.2-1.6s.8-1.3 1.5-1.2zm-45.9 38.4h.2v-.2h.4v.2h.2v.2l.2.2v.4h-.2zm-22.7 56 .2-1V416l.4-1.5.3-1.5.4-1.7.6-1.8.5-2 .7-2 .6-2 .6-2 .6-2.2.8-2.2.7-2.2 1-2 .7-2.3 1-2.3.7-2.2 1-2.2.8-2 1-2.2.8-2 1-2 .8-2 1-1.7.8-1.5 1-1.6.7-1.5 1-1.3.7-1.2.8-1 .8-.8.8-.6.7 1-.6.5-.7.8-.7 1-.8 1-1 1.3-.7 1.5-1 1.5-.7 1.7-1 1.7-.8 2-1 1.8-.8 2-1 2-.8 2.3-1 2-.7 2.3-1 2.3-.7 2.3-.8 2.2-.7 2.2-.8 2.2-.6 2-.6 2-.6 2.2-.6 2-.5 1.8-.4 1.8-.4 1.6-.5 1.6-.2 1.4-.2 1.3v1H336zm5.6 80.5-.7-2-.7-2-.7-2.2-.6-2.2-.6-2.2-.4-2.4-.4-2.3-.5-2.4-.4-2.5-.3-2.4-.3-2.5-.3-2.7-.2-2.6-.3-2.6-.2-2.5-.2-2.6v-3l-.2-2.7v-18.5l.3-2.7v-2.5l.2-2.6v-2.7l.3-2.6.2-2.5.2-2.5h1.2l-.3 2.6-.2 2.5-.2 2.6-.2 2.6v2.6l-.2 2.6v2.6l-.2 2.7v18.8l.2 2.6v2.6l.3 2.6.3 2.6.3 2.6.3 2.5.2 2.5.3 2.5.4 2.4.3 2.5.5 2.3.5 2.3.5 2.3.6 2.2.6 2 .7 2.2.7 2-1 .4zm1-.4v.8h-.8v-.2l1-.6z"
            })
          ]
        }),
        /* @__PURE__ */ jsx262("use", {
          xlinkHref: "#rs_svg__e",
          width: 1350,
          height: 900,
          transform: "matrix(-1 0 0 1 964.3 0)"
        }),
        /* @__PURE__ */ jsx262("path", {
          fill: "#21231e",
          d: "M473 398.4h-.2v.5h-.2v.8l.2.7v1.6l.2.8.2.8v.7l.3.8v.8l.3.7.2.8.3.7.2.7.2.7.3.7.3.8.3.7.3.7.2.7.3.6.4.6.2.7.4.5.4.7.4.7.4.5.5.6.4.8.5.6.4.6.5.6.6.6.2.2h.8v-.2l.6-.6.5-.6.5-.6.4-.6.5-.7.5-.5.4-.6.3-.8.4-.6.3-.7.4-.8.4-.6.3-.7.4-.8.3-.7.3-.7.3-.7.3-.6.2-.7.3-.7.3-.7.2-.8v-.7l.3-.7.2-.7v-.7l.3-.8v-1.4l.2-.8v-2.1h-1v.4l-.2 1v1.4l-.2.7v.7l-.2.7-.2.7v.8l-.3.7-.2.7-.2.7v.6l-.3.7-.3.7-.2.7-.3.7-.4.6-.2.7-.4.7-.3.6-.3.7-.4.6-.4.7-.3.6-.4.6-.5.6-.4.6-.4.7-.4.7-.4.6-.5.6h-.2l-.5-.7-.4-.6-.4-.6-.4-.6-.4-.6-.4-.6-.4-.6-.4-.6-.3-.7-.4-.6-.4-.7-.3-.6-.3-.7-.4-.7-.2-.6-.3-.7-.2-.7-.2-.7-.2-.7-.2-.7-.2-.8-.2-.7-.2-.7v-.7l-.3-.6v-.8l-.2-.7v-2.3l-.2-.8v-.4h-.2v-.2h-.5z"
        }),
        /* @__PURE__ */ jsx262("path", {
          fill: "#c6363c",
          d: "M549.2 422v108.6a72 72 0 0 1-19.7 49.8 65 65 0 0 1-94.7.1 72.9 72.9 0 0 1-19.7-49.8V422z"
        }),
        /* @__PURE__ */ jsx262("use", {
          xlinkHref: "#rs_svg__f",
          width: 1350,
          height: 900,
          transform: "matrix(-1 0 0 1 964.3 -90)"
        }),
        /* @__PURE__ */ jsx262("path", {
          fill: "#fff",
          stroke: "#21231e",
          d: "M549.2 488.6v28h-53v83a63.8 63.8 0 0 1-14 1.5 59 59 0 0 1-14-1.5v-83h-53v-28h53V422h28v66.6z"
        }),
        /* @__PURE__ */ jsx262("use", {
          xlinkHref: "#rs_svg__f",
          width: 1350,
          height: 900,
          transform: "translate(0 -90)"
        }),
        /* @__PURE__ */ jsx262("path", {
          id: "rs_svg__f",
          fill: "#fff",
          stroke: "#21231e",
          d: "M459 567.3V528c-8.4-2.3-29.3-10.6-30.3 7.6-.5 8.4 10.4 14 13.3 6.5 1.4-3.4 0-6-2-6.7-2.4-.8-4.6 1-4 3.6-8.8-4.7 8-14.6 15.5-1.7 2.2 3.7-3.7 7.6-3.7 10.4 0 2.7 5.8 7 3.7 10.3-7.7 12.8-24.3 3-15.5-1.6-.6 2.7 1.6 4.5 4 3.6 2-.8 3.4-3.3 2-6.8-3-7.5-13.8-2-13.3 6.5 1 18.2 22 10 30.4 7.6z"
        }),
        /* @__PURE__ */ jsx262("use", {
          xlinkHref: "#rs_svg__f",
          width: 1350,
          height: 900,
          transform: "matrix(-1 0 0 1 964.3 0)"
        }),
        /* @__PURE__ */ jsx262("path", {
          fill: "#21231e",
          d: "M414 421v113.3l.2 1.7v2l.4 1.7.2 1.8.3 1.7.4 1.8.3 1.8.4 1.7.6 1.7.5 1.7.6 1.5.6 1.7.5 1.6.7 1.6.7 1.6.7 1.6.8 1.6.8 1.5.8 1.5 1 1.5.8 1.5 1 1.4.8 1.4 1 1.4 1 1.4 1 1.3 1 1.5 1.2 1.2 1 1.3 1.2 1.2 1.2 1.2 1.2 1.2 1.2 1 1.3 1.3 1 1 1.4 1 1.3 1 1.4 1 1.5 1 1.4 1 1.3.8 1.4.8 1.5.8 1.4.8 1.6.7 1.5.6 1.5.7 1.5.6 1.6.5 1.6.5 1.5.5 1.6.5 1.8.4 1.6.4 1.7.4 1.8.2 1.7.3 1.7.2h1.7l1.6.2h8.9l1.7-.3 1.8-.3 1.7-.3 1.7-.2 1.7-.4 1.5-.4 1.7-.4 1.6-.5 1.6-.5 1.6-.5 1.5-.6 1.6-.7 1.6-.7 1.6-.7 1.5-.8 1.4-.8 1.6-.8 1.4-1 1.5-.7 1.4-1 1.2-1 1.4-1 1.3-1 1.2-1 1.3-1 1.2-1.3 1.2-1 1-1.3 1.3-1.2 1.2-1.2 1-1.3 1.2-1.2 1-1.4 1-1.2 1-1.4 1-1.4 1-1.4 1-1.4.7-1.5 1-1.5.7-1.5.8-1.5.8-1.6.7-1.6.6-1.6.6-1.6.6-1.6.5-1.7.5-1.6.5-1.8.4-1.7.6-1.7.3-1.8.2-1.8.3-1.7.3-1.8v-.9l.3-2 .2-1.7V421zm2.3 2.2H548V536l-.3 1.6-.2 1.8-.2 1.7-.3 1.8-.3 1.7-.4 1.7-.3 1.7-.5 1.5-.4 1.7-.4 1.6-.5 1.6-.5 1.6-.6 1.5-.8 1.6-.7 1.6-.7 1.5-.7 1.6-.7 1.4-.8 1.5-.8 1.4-1 1.3-.8 1.4-1 1.3-1 1.3-1 1.3-1 1.3-1 1.2-1.2 1.2-1 1.2-1.2 1-1.2 1.3-1.2 1-1.2 1-1.2 1-1.3 1-1.2 1-1.4 1-1.4 1-1.3.8-1.4 1-1.5.7-1.4.8-1.3.7-1.5.8-1.5.6-1.4.7-1.5.7-1.6.5-1.5.6-1.5.5-1.6.4-1.6.4-1.6.5-1.6.3-1.6.3-1.7.4H489l-1.8.3h-1.7l-1.6.2h-3.6l-1.6-.2H477l-1.6-.3h-1.6l-1.7-.4-1.5-.2-1.6-.3-1.7-.4-1.6-.3-1.6-.4-1.4-.5-1.6-.6-1.5-.5-1.5-.6-1.5-.6-1.4-.6-1.4-.8-1.4-.7-1.4-.8-1.4-.8-1.4-1-1.3-.7-1.4-1-1.3-1-1.2-1-1.3-1-1.2-1-1.2-1-1-1-1.3-1.3-1-1-1.2-1.3-1-1.2-1-1.3-1.2-1.4-1-1.3-1-1.3-1-1.3-.8-1.4-.8-1.4-1-1.5-.7-1.5-.8-1.4-.7-1.5-.8-1.4-.6-1.5-.6-1.5-.6-1.5-.5-1.6-.6-1.6-.5-1.6-.5-1.7-.4-1.6-.4-1.8-.4-1.7-.3-1.7-.3-1.7-.2-1.6-.2-1.8-.2-1.7v-5.4z"
        })
      ]
    })
  ]
});
var Rs_default = SvgRs;

// src/country-flag-icons/generated/Ru.tsx
init_esm_shims();
import { jsx as jsx263, jsxs as jsxs238 } from "react/jsx-runtime";
var SvgRu = (props) => /* @__PURE__ */ jsxs238("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx263("path", {
      fill: "#fff",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsx263("path", {
      fill: "#0039a6",
      d: "M0 160h640v160H0z"
    }),
    /* @__PURE__ */ jsx263("path", {
      fill: "#d52b1e",
      d: "M0 320h640v160H0z"
    })
  ]
});
var Ru_default = SvgRu;

// src/country-flag-icons/generated/Rw.tsx
init_esm_shims();
import { jsx as jsx264, jsxs as jsxs239 } from "react/jsx-runtime";
var SvgRw = (props) => /* @__PURE__ */ jsxs239("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx264("path", {
      fill: "#20603d",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx264("path", {
      fill: "#fad201",
      d: "M0 0h640v360H0z"
    }),
    /* @__PURE__ */ jsx264("path", {
      fill: "#00a1de",
      d: "M0 0h640v240H0z"
    }),
    /* @__PURE__ */ jsxs239("g", {
      transform: "translate(511 125.4) scale(.66667)",
      children: [
        /* @__PURE__ */ jsxs239("g", {
          id: "rw_svg__b",
          children: [
            /* @__PURE__ */ jsx264("path", {
              id: "rw_svg__a",
              fill: "#e5be01",
              d: "M116.1 0 35.7 4.7l76.4 25.4-78.8-16.3L100.6 58l-72-36.2L82 82.1 21.9 28.6l36.2 72-44.3-67.3L30 112 4.7 35.7 0 116.1-1-1z"
            }),
            /* @__PURE__ */ jsx264("use", {
              xlinkHref: "#rw_svg__a",
              width: "100%",
              height: "100%",
              transform: "scale(1 -1)"
            })
          ]
        }),
        /* @__PURE__ */ jsx264("use", {
          xlinkHref: "#rw_svg__b",
          width: "100%",
          height: "100%",
          transform: "scale(-1 1)"
        }),
        /* @__PURE__ */ jsx264("circle", {
          r: 34.3,
          fill: "#e5be01",
          stroke: "#00a1de",
          strokeWidth: 3.4
        })
      ]
    })
  ]
});
var Rw_default = SvgRw;

// src/country-flag-icons/generated/Sa.tsx
init_esm_shims();
import { jsx as jsx265, jsxs as jsxs240 } from "react/jsx-runtime";
var SvgSa = (props) => /* @__PURE__ */ jsxs240("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx265("defs", {
      children: /* @__PURE__ */ jsx265("clipPath", {
        id: "sa_svg__a",
        children: /* @__PURE__ */ jsx265("path", {
          fillOpacity: 0.7,
          d: "M-85.3 0h682.6v512H-85.3z"
        })
      })
    }),
    /* @__PURE__ */ jsxs240("g", {
      fillRule: "evenodd",
      clipPath: "url(#sa_svg__a)",
      transform: "translate(80) scale(.9375)",
      children: [
        /* @__PURE__ */ jsx265("path", {
          fill: "#165d31",
          d: "M-128 0h768v512h-768z"
        }),
        /* @__PURE__ */ jsx265("path", {
          fill: "#fff",
          d: "M65.5 145.1c-.8 12-2 33 8.3 35.2 12.3 1.2 5.5-20.8 10-24.8.8-2 2.3-2 2.4.5v18.7c0 6 4 7.8 7 9 3.2-.2 5.4 0 6.6 3l1.6 32.3s7.4 2.2 7.8-18.1c.3-12-2.4-21.9-.8-24.2 0-2.3 3-2.4 5-1.3 3.2 2.2 4.6 5 9.6 4 7.6-2.2 12.2-5.9 12.3-11.7a47 47 0 0 0-3.5-16.6c.4-1-1.4-3.7-1-4.7 1.3 2.2 3.4 2 3.8 0-1.3-4.2-3.3-8.3-6.5-10-2.7-2.4-6.7-2-8 3-.8 5.7 2 12.4 6.1 18 .9 2.1 2.1 5.7 1.6 8.9-2.2 1.3-4.4.7-6.3-1.2 0 0-6-4.5-6-5.6 1.6-10.2.3-11.4-.6-14.3-.6-3.9-2.5-5.2-4-7.8-1.5-1.6-3.5-1.6-4.5 0-2.7 4.6-1.4 14.5.5 19 1.4 4.1 3.5 6.7 2.5 6.7-.8 2.3-2.5 1.7-3.8-1a66.6 66.6 0 0 1-2.1-17.4c-.5-4.6-1.1-14.4-4.2-17-1.8-2.4-4.5-1.2-5.5 1a82.4 82.4 0 0 0 .3 13.4c2 7.4 2.7 14 3.7 21.5.3 10.1-5.8 4.4-5.5-.7a45 45 0 0 0-.3-19.4c-1-2.6-2.1-3.2-4.6-2.8-1.9 0-6.8 5.3-8.2 14.3 0 0-1.2 4.6-1.7 8.7-.7 4.6-3.7 8-5.9-.6-1.8-6.3-3-21.6-6-18z"
        }),
        /* @__PURE__ */ jsx265("path", {
          fill: "#fff",
          d: "m99 194.2-32 15.4c.3-7.3 15.1-20.4 25.3-20.5 6.5.1 4.9 2.5 6.6 5.1z"
        }),
        /* @__PURE__ */ jsx265("path", {
          fill: "#fff",
          d: "M93.3 204.2c-16.8 43.5 39.5 49.6 45.8 1.8.6-2 3-3.9 3.4-.7-1.3 43.3-43.6 46.2-50.8 32.6a41.9 41.9 0 0 1-2.5-14.6c-1-8.5-5.5-5.2-6.2 3.2-.7 4.7-.5 6-.5 10.5 2.2 34.2 56.7 19.5 65.6-8.7 4.7-15.6-.8-27.1 1.7-27.1 5.4 5.8 13 .8 14.7-1.2.7-1 2.5-1.7 3.7-.4 4.2 3 11.6 1.6 13.2-3.7.9-5.3 1.6-10.7 1.8-16.2-3.5 1-6 1.7-6.3 3.2l-.7 4.6c-.3 1.5-3.2 1.5-3.4-.4-1.3-6-6.7-6.7-10 2.5-2.1 1.8-6.1 2.2-6.5-.5.5-6.2-2-7-7-4.1l-4.8-36.2c2 0 4 1.5 5.9-.9-2-6.5-6.5-19.7-9-20.7-1.1-1.4-2.1-.5-3.7-.1-2.6.8-5 3-4.2 7.4 3 18.8 5 33.1 8.1 52 .5 2.1-1.3 5-3.7 4.7-4-2.7-5-8.2-12-8-5 0-10.6 5.5-11.3 10.7-.9 4.2-1.2 8.7 0 12.3 3.5 4.2 7.7 3.8 11.4 2.9 3-1.3 5.5-4.3 6.6-3.6.7.9.1 10.9-14.3 18.5-8.7 4-15.7 4.8-19.4-2.3-2.3-4.5.2-21.4-5.6-17.5"
        }),
        /* @__PURE__ */ jsx265("path", {
          fill: "#fff",
          d: "M165 160c3.3-1.2 19.3-19.6 19.3-19.6l-2.4-2c-.9-.7-.8-1.5 0-2.2 4-2.4 2.7-7.4.7-9.8a9.7 9.7 0 0 0-8.7.1c-2.8 2.7-3.4 7-1.2 9.6 2.1 1 4.2 3.2 2.8 4.4-6.6 7-24.5 19.1-22.4 19.5.4.6 11.5.6 11.8 0zm-97 65c-6 9.6-6.5 23.9-3.2 28.2 1.8 2 4.7 2.9 6.8 2.2 3.8-1.6 5.5-9.3 4.6-12-1.3-2-2.3-2.3-3.6-.7-2.6 5.4-3.7 1.7-4-1.3a70 70 0 0 1 .8-15.2c.7-4.2 0-3-1.4-1.2m257.1-15.3c-5.8-12.6-13.9-25-16.4-29.7a557.6 557.6 0 0 0-24.8-36c-6.2-7.4 10.2 3.1-2-11.7l-8.9-7.5c-2-1.4-6.8-4-7.6.2-.4 3.8-.2 5.8.4 8.9.5 2 3.5 5.5 5 7.5a565 565 0 0 1 53.8 86.5c2.6-1.3 2-16.1.5-18.2"
        }),
        /* @__PURE__ */ jsx265("path", {
          fill: "#fff",
          d: "M299.6 251.5c-1.2 1.3 2.8 6.8 8 6.8 8.6-1 16.2-5.8 23.2-18.6a33 33 0 0 0 5.3-14.2 317 317 0 0 0-5.8-72.4c-.3-2 0-4.4.2-5 .6-.7 2.5 0 3.5-1.7 1.5-1.5-4-14-7-18.7-1-2.2-1.5-3.6-3.3.2a27 27 0 0 0-3 13.6c4.1 28.5 5.4 53.4 8 81.9.3 2.8-.1 6.8-2 8.4a80.2 80.2 0 0 1-27.1 19.7m116.5-.1c-6.2 3.6-6.2 7.7-1.2 7.8 8.6-1 18.8-1.7 25.8-12.3a41 41 0 0 0 4.2-16 303 303 0 0 0-4.7-71.4c-.2-2-1.1-6.7-.8-7.3.6-1.4 3.4.1 4.4-1.5 1.4-1.5-7.3-12.7-10.4-17.5-1-2.2-1.4-3.6-3.3.2a22.3 22.3 0 0 0-1.8 13.6c4.6 31 8 54.2 8.7 81.6-.4 2.6-.5 4-1.7 7.3-2.7 3.4-5.7 7.8-8.5 9.9-2.8 2-8.8 4-10.7 5.6"
        }),
        /* @__PURE__ */ jsx265("path", {
          fill: "#fff",
          d: "M420.7 223.7c0-7.3.1-13.5-.1-19a34 34 0 0 0-3-13.5c-1.8-4.1-.7-7.4-1.6-11.8-.8-4.4-.6-11-1.8-16.1-.4-2-1.4-8.5-1.1-9.2.5-1.4 2.4 0 3.4-1.6 1.4-1.5-5-18-8.2-22.7-1.1-2.1-3.3-1.4-5.8 2-2.5 2.3-1.6 7.4-.6 12.3 6.1 32.3 10.8 61.6 9.8 92.3-.4 2.6 9-7.8 9-12.7m-45.7-40c-3.9-.2-12-7.7-14.4-12a8 8 0 0 1 .4-6.5c1.5-1 3.7-2 5.4-1 0 0 1.7 2.4 1.4 2.7 2 1 3 .5 3.2-.4.1-1.5-.6-2.4-.6-4 .9-4.6 6-5.3 8-2.4 1.4 1.8 2 5.5 2.1 8 0 1.3-2-.2-3.3 0-1.1.4-1.4 1.8-1.5 3-.2 3.3-.6 8.6-.7 12.5zm-71.8 48c1-9.8-.4-27.3-.5-33.1A477 477 0 0 0 299 154c-1.2-8.4 3.4.9 2.8-4-1.5-8.3-6.1-14-11.6-21.5-1.7-2.5-1.7-3-4.4.6-3 6.7-.4 11.4.4 16.7 3.9 17.2 6.2 33 7.3 48.7a393.4 393.4 0 0 1 .4 49c3 .1 7.6-4.7 9.3-11.8"
        }),
        /* @__PURE__ */ jsx265("path", {
          fill: "#fff",
          d: "M434 216c-6.9-11.6-17.2-24-20-28.7a658 658 0 0 0-29.2-37.8c-8.5-9 4-1.5-1.6-8.5-4.7-5.1-6-6.8-10.1-9.9-2-1.3-3.2-3.8-4 .5a83 83 0 0 0-.2 11.2c0 1.7 1.8 5 3.4 7 20.7 25.5 43.4 51.5 61.6 84.2 2.6-1.3 1.7-16 0-18z"
        }),
        /* @__PURE__ */ jsx265("path", {
          fill: "#165d31",
          d: "M122.6 194.7c-.5.9-1.6 2-1.2 3.1.7 1 1.4 1.3 2.6 1.3 1.1 0 2.7.3 3-.3.6-.7 1-2 .6-3.3-1.2-3-4.4-1.8-5-.8"
        }),
        /* @__PURE__ */ jsx265("path", {
          fill: "#fff",
          d: "M354.2 362.5c9.2.4 15.2.5 23.3 1.4l9.6-1c10.6-1 11 15.1 11 15.1 0 9.5-3.7 10-8.4 11-2.7.4-4-1.6-5.5-3.6a14 14 0 0 1-7 .4c-3.9-.2-7.7-.2-11.5-.5-4-.3-6.2.5-10.3.1-.8 1.3-2 3.1-4.4 2.6-2-.3-4.5-6-3.8-10.5 1.5-3.2 1-2.1 1-3.5-37.6-1-75.5-2.7-112.3-2.2-28.8.1-57.2 1.3-85.7 2.5-15.2-.2-26.8-2.6-34.8-14.3.8 0 38.8 2.1 49.9 1.4 20.5-.2 39.3-1.9 60.2-2.5 41.2.7 82.1.7 123.3 3.6-4-2.7-4-9 2-10.6.5-.4.8 3.1 1.7 3 4.9-.3 2.7 6.3 1.7 7.6M188.6 135.3c-6.2 17.8 3.6 37.4 10.4 35.5 5 2 8-7.4 10-17.6 1.5-2.9 2.5-3.2 3.2-1.7-.2 13.6 1 16.7 4.5 20.8 7.8 6 14.3.8 14.8.3l6-6.1c1.4-1.5 3.2-1.5 5.1-.3 1.9 1.7 1.6 4.6 5.6 6.6 3.4 1.4 10.5.4 12.2-2.5 2.2-3.9 2.8-5.2 3.8-6.6 1.6-2.1 4.3-1.2 4.3-.5-.3 1.2-1.9 2.3-.8 4.5 2 1.4 2.4.5 3.5.2 4-2 7-10.6 7-10.6.1-3.2-1.7-3-2.9-2.2l-3.1 2.1c-2 .3-5.7 1.6-7.6-1.3-1.9-3.4-1.9-8.3-3.3-11.8 0-.2-2.6-5.5-.2-5.8 1.2.2 3.7.9 4.1-1.2 1.2-2.1-2.6-8-5.3-11-2.3-2.5-5.5-2.8-8.6-.2-2.2 2-1.9 4.2-2.3 6.3a9.8 9.8 0 0 0 2 8.7c2.2 4.2 6.1 9.7 4.8 17.5 0 0-2.3 3.6-6.3 3.1-1.7-.3-4.4-1-5.8-11.8-1.1-8 .2-19.4-3.2-24.7-1.3-3.3-2.2-6.4-5.2-.9-.8 2.2-4.3 5.5-1.8 12.2a36 36 0 0 1 2 19c-1.5 2.2-1.8 2.9-3.7 5-2.6 3-5.5 2.2-7.7 1.1-2-1.3-3.6-2-4.6-6.5.2-7 .6-18.5-.7-20.9-1.9-3.8-5-2.4-6.3-1.2a47.7 47.7 0 0 0-11.5 23.5c-1.8 5.8-3.7 4.1-5 1.8-3.2-3-3.5-26.7-7.4-22.8"
        }),
        /* @__PURE__ */ jsx265("path", {
          fill: "#fff",
          d: "M207.4 174.1c2.9-2 1.6-3.4 5.8.8a72 72 0 0 1 9.2 31.3c-.2 2.6 1.6 4.2 2.5 3.6.4-6 15.1-14.4 28.6-15.6 2-.5 1-4.4 1.3-6.4-.8-7.5 4.2-14.3 11.2-14.8 9.6 1.4 12.8 6.5 13 14.2-1.1 15-16.7 17.5-25.4 18.7-1.3.5-1.9 1.1 0 1.8l36.6.2 1.9 1c.2 1-.6.2-2 2.6a29.5 29.5 0 0 0-3.7 11.5c-10.9 3.6-22.2 5-33.6 6.5-4 2-6 4.7-5.2 7.7 1.4 3.3 10.2 6.7 10.2 6.8 1.7 1 3.6 3.5-.5 8.6-17.8-.8-31.7-8.4-36.5-19.1-1.4-1.1-3 0-4 1.4-7 9-13.8 17-25.7 21.4-7 1.8-14.3-1.1-17.7-5.7-2.3-2.7-2.2-5.6-3-6.2-3.9 1.7-36.9 15.7-32.7 9.1 8-8.5 22-14.9 34.2-23.3.9-2.9 2.5-12.5 7.3-15.6.3 0-.7 5.6-.6 8 0 2-.2 2.7.2 2.2.9-.5 15.7-12.2 17-15.8 1.4-2 .3-7.2.3-7.4-2.8-7.2-6.7-7.8-8.1-11.4-1.3-4.7-.7-10.1 2-11.7 2.4-2.1 5.2-1.9 7.9.5 3 2.7 5.6 8 6.4 11.9-.5 1.5-4-1-5-.3a16 16 0 0 1 3.7 7.8c2 8.2 1.4 11.4-.6 16.7-6.6 13.9-15 18-22.4 23.2-.2 0-.3 3.5 2.4 5.4 1 1 4.9 1.5 9.4 0a54.5 54.5 0 0 0 22.3-23.3 51 51 0 0 0-2.4-22.2c-2.9-6.7-6.3-16.2-6.3-16.4-.1-4.2.2-5.6 2-7.7m-95.8-38.6c4.2 2 12.2 1.1 11.8-5.7l-.2-3.1c-.8-2-3.2-1.5-3.7.5-.2.7.3 1.8-.3 2.1-.4.4-1.7.2-1.7-1.7 0-.6-.4-1.2-.7-1.6-.2-.2-.4-.2-.9-.2-.6 0-.6.1-.9.6-.1.5-.3 1-.3 1.6 0 .7-.4.9-.8 1-.6 0-.5 0-1-.2-.2-.3-.5-.4-.5-1l-.3-1.6c-.2-.3-.6-.5-1-.6-2.3 0-2.5 2.7-2.3 3.7-.2.2-.3 4.9 2.8 6.2"
        }),
        /* @__PURE__ */ jsx265("path", {
          fill: "#fff",
          d: "M235.1 187.7c4.2 2 14.3.9 11.8-5.6l-.2-3.2c-.9-2-3.2-1.5-3.7.6-.2.6.3 1.7-.4 2-.3.4-1.7.2-1.6-1.6 0-.6-.4-1.3-.7-1.7-.3-.1-.4-.2-1-.2-.5 0-.5.2-.8.7-.2.5-.3 1-.3 1.6-.1.6-.4.8-.9 1-.5 0-.4 0-.8-.3-.3-.3-.6-.4-.6-.9l-.3-1.6c-.2-.3-.6-.5-1-.6-2.3 0-2.5 2.6-2.4 3.6-.1.2-.2 5 3 6.2zm72-21.6c4.2 2 12.1 1.1 11.8-5.6l-.2-3.2c-.9-2-3.2-1.5-3.7.5-.2.7.3 1.8-.4 2.2-.3.3-1.7.1-1.6-1.8 0-.6-.4-1.2-.7-1.6-.3-.2-.4-.2-1-.2-.5 0-.5.2-.8.7l-.3 1.5c-.1.7-.4 1-.9 1s-.4 0-.8-.2c-.3-.3-.6-.4-.6-.9s-.1-1.3-.3-1.7c-.2-.3-.6-.4-1-.5-2.3 0-2.5 2.6-2.4 3.6-.1.2-.2 4.9 3 6.2zm37.3 54.3c-7.3 8.3-4.1 22-2.4 25 2.4 4.8 4.3 7.9 9 10.3 4.3 3.1 7.7 1.2 9.5-1 4.3-4.5 4.4-16 6.4-18.2 1.4-4.2 5-3.5 6.7-1.6a16.5 16.5 0 0 0 6.2 5.3c4 3.5 8.8 4.2 13.6 1 3.2-1.9 5.3-4.2 7.2-8.9 2-5.6 1-31.6.5-47l-4.2-21.5c0-.2-.5-10.2-1-12.5 0-1-.3-1.3.7-1.2 1.1 1 1.2 1 2 1.3 1 .2 2-1.7 1.3-3.3l-10-18.6c-.8-.8-1.9-1.6-3.2.2a7.3 7.3 0 0 0-2.4 5.5c.3 4.4 1 8.9 1.3 13.3l4 22.6c1.3 16 1.6 29.2 2.9 45.3-.2 6.8-2.3 12.7-4.3 13.6 0 0-3 1.7-5-.2-1.5-.6-7.4-9.9-7.4-9.9-3-2.7-5-2-7.1 0-6 5.8-8.6 16.4-12.7 23.8-1 1.7-4 3-7.2-.1-8.2-11.3-3.4-27.3-4.4-23.2M309 126.7c3.8 1.5 6.4 9.2 5.6 13-.8 4.5-2.8 9.5-4.2 8.9-1.6-.6 1-4.6-.5-8.8-.8-2.8-6-7.8-5.4-9.2-1-3.1 2.2-4.5 4.5-4z"
        }),
        /* @__PURE__ */ jsx265("path", {
          fill: "#fff",
          d: "M356.6 225c.7-9.2-.6-14.8-.8-20.2s-6.1-46.6-7.3-50.6c-1.5-7.8 5.7-1 4.9-5.6-2.5-5.6-8.6-13.9-10.5-18.8-1.2-2-.7-4-3.3-.5a42.3 42.3 0 0 0-2.3 19.2c6.2 32.3 12.5 59.1 11.5 89.8 3 0 6.3-6.7 7.8-13.3m64.4-85.3c3.5 1.7 5.5 11.3 5.1 14-.7 5-2.5 10.4-3.8 9.7-1.5-.6.3-7.4-.4-9.5-.8-3-5.5-8.4-5-10-1-3.4 2-4.8 4.1-4.2m-255.7 67.9c3.3 1.3 5.3 8.3 5 10.3-.8 3.7-2.5 7.7-3.8 7.1-1.3-.4.3-5.4-.3-7-.3-3.7-4.9-5.7-4.8-7.3-.8-3 2-3.5 4-3.1z"
        }),
        /* @__PURE__ */ jsx265("path", {
          fill: "#165d31",
          d: "M244.9 218.2c4.2.2 6.3 3.6 2.4 5-4 1.3-7.7 2.4-7.8 8 1.5 8-2 5.2-4 4.2-2.4-1.8-9.2-6-10.2-15-.1-2.1 1.6-4 4.3-4 4 1.1 10 1.2 15.3 1.8"
        }),
        /* @__PURE__ */ jsx265("path", {
          fill: "#fff",
          d: "M77.4 124.4c4.8 1.4 5.1 8.6 4.8 10.7-.7 3.8-2.4 7.9-3.6 7.4-1.4-.5 0-5.7-.7-7.3-.7-2.2-4.8-6.4-4.4-7.6-.9-2.5 2-3.7 3.9-3.2m95.9 33.6c-3.8 2-5.2 8-2.9 11.6 2.2 3 5.6 1.9 6 1.9 3.7.4 5.9-6.9 5.9-6.9s.1-2-4.2 1.9c-1.9.3-2-.4-2.5-1.4a9 9 0 0 1 .5-5.7c.7-1.8-.7-2.6-2.8-1.4m28-36.4c-2 1.3-5.7 5.2-5.8 9.6-.1 2.5-.6 2.5 1 4 1.3 1.8 2.4 1.7 4.8.4a5.1 5.1 0 0 0 2.3-3.4c.6-2.8-3 1.4-3.4-1.8-.8-3 1.5-4.2 3.7-7 0-2 0-3.3-2.7-1.8zm22.4 4a59.5 59.5 0 0 0-1.6 11.1c-.6 2.8 3 4 4.5.4 2.4-6.5 2.4-9.3 2.6-12-.7-4.3-3.6-4.2-5.5.5m142 72.3c.4-.5 20-14.4 20-14.4 2-.7 1.5 7.2.6 7.1a77.8 77.8 0 0 1-20.7 14.3c-1 .7-1.9-5.3 0-7zm17.7-.2c3.5 1.7 4.9 11.8 4.5 14.5 0 5.4-3.3 9.6-4.7 9-1.4-.7.2-6.7-.5-8.8-.8-3-3.7-8.5-3.2-10.1-1-3.4 1.8-5.2 4-4.6zm-116 43.4a26 26 0 0 1 5.6-4.9c2-1 3.8.8 3.7.7.3 2-1.2 3.7-.7 6.3.4 1 .7 2.2 2.6 1.8 3.1-2.5 6-2.7 9-2.8 2.5.1 2.6 4.2 1 4.2-5.7 1.2-8.2 2.8-12.3 4.3-2 1.2-3.6-.3-3.6-.4s-1.1-1.1-.4-3.7c.2-2-.6-3.2-2.4-3-1.2.8-2.4 1.2-3-.3-.3-1-.4-1.6.5-2.2m136.6 5.4c.8 1 1.4 2-.1 3.8l-3.7 3.2c-.6 1-1 2.8 1 3.3 3.6 1 12-4.5 12-4.6 1.4-1 1-3 .8-3-.8-.9-2.6-.3-3.8-.5-.6 0-2.5-.2-1.6-2a11.4 11.4 0 0 0 1.6-2.9c.5-1.2 0-2-2-2.7-2.1-.4-3-.2-5.3 0-1.2.2-1.6.8-1.9 2.3.1 2.3 1.5 2.2 3 3z"
        }),
        /* @__PURE__ */ jsx265("path", {
          fill: "#165d31",
          d: "M268.1 189.7c-.5 1-2.3 1-4 0s-2.7-2.6-2.1-3.5 2.3-.9 4 0 2.6 2.6 2.1 3.5m-89-53.6c-1 .3-2.4-.6-3-2s-.3-2.6.7-2.9 2.3.7 3 2 .3 2.7-.8 3zM355.2 375c9.4.4 18.2 0 27.5.5 1.7 1.5.5 5-.6 4.8l-7.8-.3c-.1-3-7.7-2.5-7.5.1-4.1.5-7.8-.1-12-.3-1.2-1.5-1-4.2.4-4.8"
        })
      ]
    })
  ]
});
var Sa_default = SvgSa;

// src/country-flag-icons/generated/Sb.tsx
init_esm_shims();
import { jsx as jsx266, jsxs as jsxs241 } from "react/jsx-runtime";
var SvgSb = (props) => /* @__PURE__ */ jsxs241("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx266("defs", {
      children: /* @__PURE__ */ jsx266("clipPath", {
        id: "sb_svg__a",
        children: /* @__PURE__ */ jsx266("path", {
          fillOpacity: 0.7,
          d: "M0 0h682.7v512H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs241("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      clipPath: "url(#sb_svg__a)",
      transform: "scale(.9375)",
      children: [
        /* @__PURE__ */ jsx266("path", {
          fill: "#0000d6",
          d: "M0 507.2 987.4 0H0z"
        }),
        /* @__PURE__ */ jsx266("path", {
          fill: "#006000",
          d: "M1024 0 27.2 512H1024z"
        }),
        /* @__PURE__ */ jsx266("path", {
          fill: "#fc0",
          d: "M1024 0h-54.9L0 485.4V512h54.9L1024 27.6z"
        }),
        /* @__PURE__ */ jsx266("path", {
          fill: "#fff",
          d: "m71.4 9.1 11.8 34.5h38.5L90.6 64.7l11.9 34.4L71.4 78 40.3 99.2l11.9-34.4-31.1-21.3h38.4zm191.1 0 11.9 34.5h38.5l-31.2 21.2 12 34.4L262.4 78l-31 21.3 11.9-34.4-31.2-21.3h38.5zm0 144.5 11.9 34.5h38.5l-31.2 21.2 12 34.4-31.2-21.3-31 21.3 11.9-34.4-31.2-21.3h38.5zm-95-71.4 11.9 34.4h38.4l-31 21.3 11.8 34.4-31-21.3-31.2 21.3 12-34.4-31.2-21.3h38.5zm-96.1 71.4 11.8 34.5h38.5l-31.1 21.2 11.9 34.4-31.1-21.3-31.1 21.3 12-34.4L21 188h38.4z"
        })
      ]
    })
  ]
});
var Sb_default = SvgSb;

// src/country-flag-icons/generated/Sc.tsx
init_esm_shims();
import { jsx as jsx267, jsxs as jsxs242 } from "react/jsx-runtime";
var SvgSc = (props) => /* @__PURE__ */ jsxs242("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx267("path", {
      fill: "#fff",
      d: "M0 0h640v480H0Z"
    }),
    /* @__PURE__ */ jsx267("path", {
      fill: "#d92223",
      d: "M0 480V0h640v160z"
    }),
    /* @__PURE__ */ jsx267("path", {
      fill: "#fcd955",
      d: "M0 480V0h426.7z"
    }),
    /* @__PURE__ */ jsx267("path", {
      fill: "#003d88",
      d: "M0 480V0h213.3z"
    }),
    /* @__PURE__ */ jsx267("path", {
      fill: "#007a39",
      d: "m0 480 640-160v160z"
    })
  ]
});
var Sc_default = SvgSc;

// src/country-flag-icons/generated/Sd.tsx
init_esm_shims();
import { jsx as jsx268, jsxs as jsxs243 } from "react/jsx-runtime";
var SvgSd = (props) => /* @__PURE__ */ jsxs243("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx268("defs", {
      children: /* @__PURE__ */ jsx268("clipPath", {
        id: "sd_svg__a",
        children: /* @__PURE__ */ jsx268("path", {
          fillOpacity: 0.7,
          d: "M0 0h682.7v512H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs243("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      clipPath: "url(#sd_svg__a)",
      transform: "scale(.9375)",
      children: [
        /* @__PURE__ */ jsx268("path", {
          fill: "#000001",
          d: "M0 341.3h1024V512H0z"
        }),
        /* @__PURE__ */ jsx268("path", {
          fill: "#fff",
          d: "M0 170.6h1024v170.7H0z"
        }),
        /* @__PURE__ */ jsx268("path", {
          fill: "red",
          d: "M0 0h1024.8v170.7H0z"
        }),
        /* @__PURE__ */ jsx268("path", {
          fill: "#009a00",
          d: "M0 0v512l341.3-256z"
        })
      ]
    })
  ]
});
var Sd_default = SvgSd;

// src/country-flag-icons/generated/Se.tsx
init_esm_shims();
import { jsx as jsx269, jsxs as jsxs244 } from "react/jsx-runtime";
var SvgSe = (props) => /* @__PURE__ */ jsxs244("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx269("path", {
      fill: "#005293",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx269("path", {
      fill: "#fecb00",
      d: "M176 0v192H0v96h176v192h96V288h368v-96H272V0z"
    })
  ]
});
var Se_default = SvgSe;

// src/country-flag-icons/generated/Sg.tsx
init_esm_shims();
import { jsx as jsx270, jsxs as jsxs245 } from "react/jsx-runtime";
var SvgSg = (props) => /* @__PURE__ */ jsxs245("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx270("defs", {
      children: /* @__PURE__ */ jsx270("clipPath", {
        id: "sg_svg__a",
        children: /* @__PURE__ */ jsx270("path", {
          fillOpacity: 0.7,
          d: "M0 0h640v480H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs245("g", {
      fillRule: "evenodd",
      clipPath: "url(#sg_svg__a)",
      children: [
        /* @__PURE__ */ jsx270("path", {
          fill: "#fff",
          d: "M-20 0h720v480H-20z"
        }),
        /* @__PURE__ */ jsx270("path", {
          fill: "#df0000",
          d: "M-20 0h720v240H-20z"
        }),
        /* @__PURE__ */ jsx270("path", {
          fill: "#fff",
          d: "M146 40.2a84.4 84.4 0 0 0 .8 165.2 86 86 0 0 1-106.6-59 86 86 0 0 1 59-106c16-4.6 30.8-4.7 46.9-.2z"
        }),
        /* @__PURE__ */ jsx270("path", {
          fill: "#fff",
          d: "m133 110 4.9 15-13-9.2-12.8 9.4 4.7-15.2-12.8-9.3 15.9-.2 5-15 5 15h15.8zm17.5 52 5 15.1-13-9.2-12.9 9.3 4.8-15.1-12.8-9.4 15.9-.1 4.9-15.1 5 15h16zm58.5-.4 4.9 15.2-13-9.3-12.8 9.3 4.7-15.1-12.8-9.3 15.9-.2 5-15 5 15h15.8zm17.4-51.6 4.9 15.1-13-9.2-12.8 9.3 4.8-15.1-12.9-9.4 16-.1 4.8-15.1 5 15h16zm-46.3-34.3 5 15.2-13-9.3-12.9 9.4 4.8-15.2-12.8-9.4 15.8-.1 5-15.1 5 15h16z"
        })
      ]
    })
  ]
});
var Sg_default = SvgSg;

// src/country-flag-icons/generated/Sh.tsx
init_esm_shims();
import { jsx as jsx271, jsxs as jsxs246 } from "react/jsx-runtime";
var SvgSh = (props) => /* @__PURE__ */ jsxs246("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx271("path", {
      fill: "#012169",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx271("path", {
      fill: "#FFF",
      d: "m75 0 244 181L562 0h78v62L400 241l240 178v61h-80L320 301 81 480H0v-60l239-178L0 64V0z"
    }),
    /* @__PURE__ */ jsx271("path", {
      fill: "#C8102E",
      d: "m424 281 216 159v40L369 281zm-184 20 6 35L54 480H0zM640 0v3L391 191l2-44L590 0zM0 0l239 176h-60L0 42z"
    }),
    /* @__PURE__ */ jsx271("path", {
      fill: "#FFF",
      d: "M241 0v480h160V0zM0 160v160h640V160z"
    }),
    /* @__PURE__ */ jsx271("path", {
      fill: "#C8102E",
      d: "M0 193v96h640v-96zM273 0v480h96V0z"
    })
  ]
});
var Sh_default = SvgSh;

// src/country-flag-icons/generated/Si.tsx
init_esm_shims();
import { jsx as jsx272, jsxs as jsxs247 } from "react/jsx-runtime";
var SvgSi = (props) => /* @__PURE__ */ jsxs247("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx272("defs", {
      children: /* @__PURE__ */ jsx272("clipPath", {
        id: "si_svg__a",
        children: /* @__PURE__ */ jsx272("path", {
          fillOpacity: 0.7,
          d: "M-15 0h682.6v512H-15.1z"
        })
      })
    }),
    /* @__PURE__ */ jsxs247("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      clipPath: "url(#si_svg__a)",
      transform: "translate(14.1) scale(.9375)",
      children: [
        /* @__PURE__ */ jsx272("path", {
          fill: "#fff",
          d: "M-62 0H962v512H-62z"
        }),
        /* @__PURE__ */ jsx272("path", {
          fill: "#d50000",
          d: "M-62 341.3H962V512H-62z"
        }),
        /* @__PURE__ */ jsx272("path", {
          fill: "#0000bf",
          d: "M-62 170.7H962v170.6H-62z"
        }),
        /* @__PURE__ */ jsx272("path", {
          fill: "#d50000",
          d: "M228.4 93c-4 61.6-6.4 95.4-15.7 111-10.2 16.8-20 29.1-59.7 44-39.6-14.9-49.4-27.2-59.6-44-9.4-15.6-11.7-49.4-15.7-111l5.8-2c11.8-3.6 20.6-6.5 27.1-7.8 9.3-2 17.3-4.2 42.3-4.7 25 .4 33 2.8 42.3 4.8 6.4 1.4 15.6 4 27.3 7.7z"
        }),
        /* @__PURE__ */ jsx272("path", {
          fill: "#0000bf",
          d: "M222.6 91c-3.8 61.5-7 89.7-12 103.2-9.6 23.2-24.8 35.9-57.6 48-32.8-12.1-48-24.8-57.7-48-5-13.6-8-41.7-11.8-103.3 11.6-3.6 20.6-6.4 27.1-7.7 9.3-2 17.3-4.3 42.3-4.7 25 .4 33 2.7 42.3 4.7a284 284 0 0 1 27.4 7.7z"
        }),
        /* @__PURE__ */ jsx272("path", {
          fill: "#ffdf00",
          d: "m153 109.8 1.5 3.7 7 1-4.5 2.7 4.3 2.9-6.3 1-2 3.4-2-3.5-6-.8 4-3-4.2-2.7 6.7-1z"
        }),
        /* @__PURE__ */ jsx272("path", {
          fill: "#fff",
          d: "m208.3 179.6-3.9-3-2.7-4.6-5.4-4.7-2.9-4.7-5.4-4.9-2.6-4.7-3-2.3-1.8-1.9-5 4.3-2.6 4.7-3.3 3-3.7-2.9-2.7-4.8-10.3-18.3-10.3 18.3-2.7 4.8-3.7 2.9-3.3-3-2.7-4.7-4.9-4.3-1.9 1.8-2.9 2.4-2.6 4.7-5.4 4.9-2.9 4.7-5.4 4.7-2.7 4.6-3.9 3a65.8 65.8 0 0 0 18.6 36.3 107 107 0 0 0 36.6 20.5 104.1 104.1 0 0 0 36.8-20.5c5.8-6 16.6-19.3 18.6-36.3"
        }),
        /* @__PURE__ */ jsx272("path", {
          fill: "#ffdf00",
          d: "m169.4 83.9 1.6 3.7 7 1-4.6 2.7 4.4 2.9-6.3 1-2 3.4-2-3.5-6-.8 4-3-4.2-2.7 6.6-1zm-33 0 1.6 3.7 7 .9-4.5 2.7 4.3 2.9-6.3 1-2 3.4-2-3.4-6-.9 4-3-4.2-2.7 6.7-1z"
        }),
        /* @__PURE__ */ jsx272("path", {
          fill: "#0000bf",
          d: "M199.7 203h-7.4l-7-.5-8.3-4h-9.4l-8.1 4-6.5.6-6.4-.6-8.1-4H129l-8.4 4-6.9.6-7.6-.1-3.6-6.2.1-.2 11.2 1.9 6.9-.5 8.3-4.1h9.4l8.2 4 6.4.6 6.5-.6 8.1-4h9.4l8.4 4 6.9.6 10.8-2 .2.4zm-86.4 9.5 7.4-.5 8.3-4h9.4l8.2 4 6.4.5 6.4-.5 8.2-4h9.4l8.3 4 7.5.5 4.8-6h-.1l-5.2 1.4-6.9-.5-8.3-4h-9.4l-8.2 4-6.4.6-6.5-.6-8.1-4H129l-8.4 4-6.9.6-5-1.3v.2l4.5 5.6z"
        })
      ]
    })
  ]
});
var Si_default = SvgSi;

// src/country-flag-icons/generated/Sj.tsx
init_esm_shims();
import { jsx as jsx273, jsxs as jsxs248 } from "react/jsx-runtime";
var SvgSj = (props) => /* @__PURE__ */ jsxs248("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx273("path", {
      fill: "#ef2b2d",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx273("path", {
      fill: "#fff",
      d: "M180 0h120v480H180z"
    }),
    /* @__PURE__ */ jsx273("path", {
      fill: "#fff",
      d: "M0 180h640v120H0z"
    }),
    /* @__PURE__ */ jsx273("path", {
      fill: "#002868",
      d: "M210 0h60v480h-60z"
    }),
    /* @__PURE__ */ jsx273("path", {
      fill: "#002868",
      d: "M0 210h640v60H0z"
    })
  ]
});
var Sj_default = SvgSj;

// src/country-flag-icons/generated/Sk.tsx
init_esm_shims();
import { jsx as jsx274, jsxs as jsxs249 } from "react/jsx-runtime";
var SvgSk = (props) => /* @__PURE__ */ jsxs249("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx274("path", {
      fill: "#ee1c25",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx274("path", {
      fill: "#0b4ea2",
      d: "M0 0h640v320H0z"
    }),
    /* @__PURE__ */ jsx274("path", {
      fill: "#fff",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsx274("path", {
      fill: "#fff",
      d: "M233 370.8c-43-20.7-104.6-61.9-104.6-143.2 0-81.4 4-118.4 4-118.4h201.3s3.9 37 3.9 118.4S276 350 233 370.8"
    }),
    /* @__PURE__ */ jsx274("path", {
      fill: "#ee1c25",
      d: "M233 360c-39.5-19-96-56.8-96-131.4s3.6-108.6 3.6-108.6h184.8s3.5 34 3.5 108.6C329 303.3 272.5 341 233 360"
    }),
    /* @__PURE__ */ jsx274("path", {
      fill: "#fff",
      d: "M241.4 209c10.7.2 31.6.6 50.1-5.6 0 0-.4 6.7-.4 14.4s.5 14.4.5 14.4c-17-5.7-38.1-5.8-50.2-5.7v41.2h-16.8v-41.2c-12-.1-33.1 0-50.1 5.7 0 0 .5-6.7.5-14.4 0-7.8-.5-14.4-.5-14.4 18.5 6.2 39.4 5.8 50 5.6v-25.9c-9.7 0-23.7.4-39.6 5.7 0 0 .5-6.6.5-14.4 0-7.7-.5-14.4-.5-14.4 15.9 5.3 29.9 5.8 39.6 5.7-.5-16.4-5.3-37-5.3-37s9.9.7 13.8.7c4 0 13.8-.7 13.8-.7s-4.8 20.6-5.3 37c9.7.1 23.7-.4 39.6-5.7 0 0-.5 6.7-.5 14.4 0 7.8.5 14.4.5 14.4a119 119 0 0 0-39.7-5.7v26z"
    }),
    /* @__PURE__ */ jsx274("path", {
      fill: "#0b4ea2",
      d: "M233 263.3c-19.9 0-30.5 27.5-30.5 27.5s-6-13-22.2-13c-11 0-19 9.7-24.2 18.8 20 31.7 51.9 51.3 76.9 63.4 25-12 57-31.7 76.9-63.4-5.2-9-13.2-18.8-24.2-18.8-16.2 0-22.2 13-22.2 13S253 263.3 233 263.3"
    })
  ]
});
var Sk_default = SvgSk;

// src/country-flag-icons/generated/Sl.tsx
init_esm_shims();
import { jsx as jsx275, jsxs as jsxs250 } from "react/jsx-runtime";
var SvgSl = (props) => /* @__PURE__ */ jsx275("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs250("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx275("path", {
        fill: "#0000cd",
        d: "M0 320.3h640V480H0z"
      }),
      /* @__PURE__ */ jsx275("path", {
        fill: "#fff",
        d: "M0 160.7h640v159.6H0z"
      }),
      /* @__PURE__ */ jsx275("path", {
        fill: "#00cd00",
        d: "M0 0h640v160.7H0z"
      })
    ]
  })
});
var Sl_default = SvgSl;

// src/country-flag-icons/generated/Sm.tsx
init_esm_shims();
import { jsx as jsx276, jsxs as jsxs251 } from "react/jsx-runtime";
var SvgSm = (props) => /* @__PURE__ */ jsxs251("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsxs251("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      children: [
        /* @__PURE__ */ jsx276("path", {
          fill: "#19b6ef",
          d: "M0 240h640v240H0z"
        }),
        /* @__PURE__ */ jsx276("path", {
          fill: "#fff",
          d: "M0 0h640v240H0z"
        })
      ]
    }),
    /* @__PURE__ */ jsx276("path", {
      fill: "#fd0",
      fillRule: "evenodd",
      stroke: "#7d6c00",
      strokeWidth: 2.4,
      d: "M317 339.2C369.6 300 426 220 359.9 177.8c-12.3-2.4-26-1.7-32.7 3.6-3.5-2-6.3-1.8-9.8 1.9-2.5-3-5-4.4-10-2.9a40.8 40.8 0 0 0-31.5-3C218 211.8 253.4 294 317 339.1z"
    }),
    /* @__PURE__ */ jsxs251("g", {
      stroke: "#3a9d4f",
      children: [
        /* @__PURE__ */ jsx276("path", {
          fill: "#4fd46b",
          fillRule: "evenodd",
          strokeLinejoin: "round",
          strokeWidth: 2.4,
          d: "M414 250.1s6-8 6.2-8c5.9-3.4 6.5-7.9 6.5-7.9 5.9-1.8 4-6.7 4.5-7.3a6.4 6.4 0 0 0 1.4-7.1c0-.8 2-8.4-.8-9.4.1-8-4.8-7.3-8.8-2-4.2 1.2-5.1 4.7-3.6 8.5-5.5 0-5.7 8-4.1 12.4-7.3-.2-3.3 8-3.5 8.4-2.4 1.2 1.9 12.8 2.3 12.4zm-46 68.2 3.6 2.2c.8 2.8 3.4 4.6 5.3 4.1 1 4.3 5.6 3.7 9 1.2 2.7 4 6 4 10.6 2.7 4 3 9.3 1.7 12.8-1.4 3.7 3 6.2.8 8.1-2.5 3 .8 5.2.3 6.3-2.6 5.7-.5 2.9-5.9-1.8-8.2 3.7-3.2 7.9-10 2-11-1.8-1.3-5.3-1-7.9.2-.7-3-4.8-3.7-9.4-.4-1.5-3.3-7-1.7-9.5.6-3.3-2.8-7.2-2.8-12.9.4zm0-8.7c.6-3.8-2-10.6 2-11.2-.7-6.3.3-13.3 7.5-12.7 1.2-5.9 1-11.4 7.8-12.2 0 0 5.5-19.1 11.2-5.9 2.2 3.9 1.8 10.2-2.7 9 .9 4.7-.7 8.9-5.9 8.7 2.3 3.4 1.6 7.9-1 10zm33.1-23.9 6-1.2c6-4 8.5-5.7 11.5-1.2 5.1-1 10-.6 9.8 3.4 6 .5 6 4.3 5.3 7.4 1 5.3-1.4 12.3-5 3.8-11.9-7.2-18.6-6.2-37.3-2zm3.1-5.9c.2-.2 17.5-4.7 15.7-10 4.9-.8 5.9-5.7 6-5.7 10.3-3.2 9.7-9.1 9.7-9.1 2.9-3.1 8-6.3 6.9-11.8.3-6.3.9-10.2-7.6-6.1-6.3-.6-8.5 3-10.3 8.5-3-3.5-7.8 2.1-8.4 7.1 0 0-7.7 7.6-7.7 7.8l-6.5 12z"
        }),
        /* @__PURE__ */ jsx276("path", {
          fill: "#4fd46b",
          fillRule: "evenodd",
          strokeLinejoin: "round",
          strokeWidth: 2.4,
          d: "M404.5 266.4c-4.1-3.1-6.4-6.9-5.7-10.6-2.7-3.7-4.6-5.9-2-9.2l-2-7.5c-5.4-2-3.1-6.5-1.7-8.1-2.5-3.5-2.6-7.2-.2-10.4 0-6.5 4.6-4 8.3 0 0 0 6.4 4.5 1.7 8.5 4.7 1.7 6 5.7 3.4 7.4 4.1 1.8 4.7 5.5 2.5 8 4.1 3.2 2.6 7.4 3.8 11.1z"
        }),
        /* @__PURE__ */ jsx276("path", {
          fill: "#4fd46b",
          fillRule: "evenodd",
          strokeLinejoin: "round",
          strokeWidth: 2.4,
          d: "M411.8 236c-.2-.1-6.9-8.7-5-9.3-.5-2.6-2.5-5.5-1.3-8.1-3.3-3.4-3.4-7.3-.8-10.4-2.2-3-1.2-7.1 1.8-9.8-1-5 2.6-6.2 5.7-7.1 2.3-8 6-6 8.2.2 3.2 2.8 2.7 7 1.6 10.2 3.8 2.5 1.5 5.7-.2 7z"
        }),
        /* @__PURE__ */ jsx276("path", {
          fill: "#4fd46b",
          fillRule: "evenodd",
          strokeLinejoin: "round",
          strokeWidth: 2.4,
          d: "m410.8 193.1-5.7-5.7c1.5-3 2.7-8.3-1.6-10.8-2.4-5.7-14.2-12.9-16.1.8-1.8-4.1-5.6-8.2-8.3-3.4-6.2-5.3-9.5-3.7-6.3 3 0 0-2.9 4.5 4.6 8 .6.6-2.4 8.1 6.6 8.3-1.7 2.6 1 6.2 4.6 6-2.5 3.1 1.8 6.5 4.5 5.2-1.1 3.5-1 5.2 3.9 5.7l5.5 6.3 4.5 6.1z"
        }),
        /* @__PURE__ */ jsx276("path", {
          fill: "none",
          strokeLinecap: "round",
          strokeWidth: 2.2,
          d: "M414.3 246.5c.3-.3 11-24.8 12.4-32.2M415.4 203s1.8 20-3.1 34.6m-29.7-54.7s21.9 21 24 29.7m-8.7-32s1.4 17.3 7.5 34.3m31 28.4S414.6 261.8 404 278m11.8 30s-28.8 4-41.4 4.3m32 8s-35.8-.8-38.4-3.4m20.5-43c0 .4-18.2 30.3-18.8 40"
        })
      ]
    }),
    /* @__PURE__ */ jsx276("path", {
      fill: "#65c7ff",
      fillRule: "evenodd",
      stroke: "#7d6c00",
      strokeWidth: 2.4,
      d: "M316.9 333.4c-37.8-35.6-76.5-102.4-38-136.2 6.8 3.8 14.9.4 26-4 3.4 3.7 7.7 4.6 12 1.8a9 9 0 0 0 10.7-2.1c11 6.3 24.9 9.6 28.2 3.3 37.8 36-.6 103.2-39 137.3z"
    }),
    /* @__PURE__ */ jsx276("path", {
      fill: "#8fc753",
      fillRule: "evenodd",
      d: "M317 332.4a212.8 212.8 0 0 1-42.3-57.6c2-1.7 2.9-2.2 3.9-5 5.8.8 8.9 1 16.5-.4 1.6 5.8 1.9 10.6 5.5 15.4l7.7-15a33.6 33.6 0 0 0 16.5 0c3.2 4.2 2 10.7 7.7 15.6 3.4-10 6.7-10.6 10.1-16 5 1.8 8.2 1 12.3-.3 2 2.5 1 2.4 5 6a193.7 193.7 0 0 1-42.8 57.3z"
    }),
    /* @__PURE__ */ jsx276("path", {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "M272.6 164.3a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.8 0zm-3.5-7.7a3.4 3.4 0 1 1-6.6 0 3.4 3.4 0 0 1 6.7 0zm-4-7.1a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm-2.8-7a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm.5-7.6a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm17.6-12.5a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0z"
    }),
    /* @__PURE__ */ jsx276("path", {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "M273.8 123.6a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm-7.3 4.3a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm22.4-5.4a3.4 3.4 0 1 1-6.6 0 3.4 3.4 0 0 1 6.6 0zm9.4.8a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm8.2-.5a3.4 3.4 0 1 1-6.6 0 3.4 3.4 0 0 1 6.7 0z"
    }),
    /* @__PURE__ */ jsx276("path", {
      fill: "#fd0",
      fillRule: "evenodd",
      stroke: "#7d6c00",
      strokeWidth: 1.1,
      d: "M325.9 117.5a8.6 8.6 0 1 1-17.2 0 8.6 8.6 0 0 1 17.2 0z"
    }),
    /* @__PURE__ */ jsx276("path", {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "M335 122.7a3.4 3.4 0 1 1-6.8 0 3.4 3.4 0 0 1 6.7 0zm8.6.7a3.4 3.4 0 1 1-6.6 0 3.4 3.4 0 0 1 6.7 0zm8.5-.4a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm7.1-.3a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm8.9 1a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm7 4.4a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0z"
    }),
    /* @__PURE__ */ jsx276("path", {
      fill: "#e40000",
      fillRule: "evenodd",
      stroke: "#ac0000",
      strokeWidth: 2.4,
      d: "m269.4 151.7 8.6 16.5h79.2l9.2-15.9c-5.4-3.7-9-6.5-16.7-4.8-4.3-6.2-9-7.3-16-6.7-2.1-2.1-4-3.4-7.6-4l-16.6.5c-4.4.4-7.8 3.8-8 3.8-7-.9-13.5-.7-15.2 6.2-6.5-1.6-11 .2-16.9 4.4z"
    }),
    /* @__PURE__ */ jsx276("path", {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "M378 135.3a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm.6 8a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm-2.5 7.2a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm-3 6a3.4 3.4 0 1 1-6.8 0 3.4 3.4 0 0 1 6.7 0zm-3.7 7.5a3.4 3.4 0 1 1-6.7 0 3.4 3.4 0 0 1 6.7 0zm-46.8-9.6a5 5 0 1 1-10 0 5 5 0 0 1 10 0z"
    }),
    /* @__PURE__ */ jsx276("path", {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "M323.6 143a6 6 0 1 1-12 0 6 6 0 0 1 12 0z"
    }),
    /* @__PURE__ */ jsx276("path", {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 1.1,
      d: "M322.7 132a5.4 5.4 0 1 1-10.8 0 5.4 5.4 0 0 1 10.8 0z"
    }),
    /* @__PURE__ */ jsx276("path", {
      fill: "#fd0",
      fillRule: "evenodd",
      stroke: "#7d6c00",
      strokeWidth: 1.1,
      d: "M315.5 109v-4.2l-3.6-.1.2-3.2h3v-2.8h4.5v2.5h3.5l-.1 3.4h-3.6v4.5h-4z"
    }),
    /* @__PURE__ */ jsx276("path", {
      fill: "none",
      stroke: "#fd0",
      strokeWidth: 3.3,
      d: "M277.6 168.2c-7.1-12-17.6-28.4-11-35.5 8.9-10.1 29.9-1 43.3-6.8 1 11.4-2.2 30.4 2.9 34.3l-4.8 4.2c-3-3.7-8.4-8.8-15.2.2-4-3.4-8.3-2.8-10.4 1.7-2 .3-1.9 1.1-4.8 1.9zm80-.5c7.2-12 17.6-28.3 11.1-35.4-9-10.1-30-1-43.3-6.9-1 11.5 2.2 30.5-3 34.4l4.8 4.2c4.7-6.5 10.4-6.7 15.3.2 3.9-3.4 7.9-3 10.4 1.7 2 .3 1.8 1 4.8 1.8z"
    }),
    /* @__PURE__ */ jsx276("path", {
      fill: "#fd0",
      fillRule: "evenodd",
      stroke: "#7d6c00",
      strokeWidth: 2.4,
      d: "M277.3 177.1a437 437 0 0 1 79.3 0l3.1-9c-27.7-5-46.8-5.6-83-.6z"
    }),
    /* @__PURE__ */ jsx276("path", {
      fill: "#c76e2e",
      fillRule: "evenodd",
      d: "m314.1 329.4.6-4.2c2.9.8 5 .5 7.4-.4l2.4-3.7-1.8-2.1c-1.6.3-3 1.8-4 3.1-1.6.1-3-.7-4.6-1l-1.5-6.4c-1.5-1.8-4.7-1.7-4 1.5l.3 2.5c.6 1.5.9 3.6 1.9 4.7v2.6zm1.2-18.3c-2 1-4.6-.8-7.3-1.9-2.5-.1-4.4 2-7.4 1.3.6-1.6 1.9-1.9 2.8-2.8-.7-4.1 1.5-5.5 2.1-5.5.6 0 3.1.6 3.1.6l2.4.3c1.5 2.7 3.5 5 4.3 8"
    }),
    /* @__PURE__ */ jsx276("path", {
      fill: "#ffe100",
      fillRule: "evenodd",
      stroke: "#e9bf00",
      strokeWidth: 2.4,
      d: "M300.8 366c7-11.4 56.2-34.4 102.4-84.2-47 45.3-76.4 56.4-114.8 84l12.4.3z"
    }),
    /* @__PURE__ */ jsx276("path", {
      fill: "#9d4916",
      fillRule: "evenodd",
      stroke: "#68300e",
      strokeWidth: 1.1,
      d: "M368.4 313.2a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0zm34.4-34.9a4 4 0 1 1-8.1 0 4 4 0 0 1 8 0zm11.4-29.6a3.6 3.6 0 1 1-7.1 0 3.6 3.6 0 0 1 7.1 0zM403 210.3a3.6 3.6 0 1 1-7.1 0 3.6 3.6 0 0 1 7.1 0z"
    }),
    /* @__PURE__ */ jsx276("path", {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#a9a9a9",
      strokeWidth: 1.1,
      d: "M279.1 269.6v-15.2l-1.5-1.2v-3.6l2.8-.3.5-17-1.8-1-.2-2.8s2 .8 2 .3l.5-3.4s-1.3-.2-1.3-.7 1.6-1.8 1.6-1.8-.8-.8-1-1.3l-.8-2.8.8-2.9-.5-1.5-1.3-2.3 1.8-1.8-.5-2.8a10 10 0 0 1 1.5-2.9c.3-.2 2.3-3 2.3-3l4.4-1 5.1.7 2.8 1.8.5 4.6s-.5 2.8-.7 2.8l-2.3 1s-2.6.3-2.9 0 .8 3.2.8 3.2v3l-.2 3.9s0 1.8-.3 2-.8 1-.8 1l-.2 4 4 1-.2 2.3-2.8.2.5 15.7 4.1.7v4.4l-1.8 1-.5 15.7zm62.4.3v-15.2l-1.5-1.3v-3.6l2.8-.2.5-17-1.8-1-.2-2.8s2 .7 2 .2l.5-3.3s-1.3-.3-1.3-.8 1.6-1.8 1.6-1.8-.8-.7-1-1.3l-.8-2.8.8-2.8-.6-1.5-1.2-2.3 1.8-1.8-.6-2.9a10 10 0 0 1 1.6-2.8l2.3-3 4.4-1.1 5.1.8 2.8 1.8.5 4.6s-.5 2.8-.7 2.8l-2.3 1s-2.6.3-2.9 0 .8 3.1.8 3.1v3.1l-.3 3.9s0 1.7-.2 2l-.8 1-.2 3.9 4 1-.2 2.3-2.8.3.5 15.6 4.1.8v4.4l-1.8 1-.5 15.7zm-31.6.5v-15.2l-1.5-1.2v-3.7l2.8-.2.5-17-1.8-1-.2-2.8s2 .8 2 .3l.5-3.4s-1.2-.2-1.2-.7 1.5-1.9 1.5-1.9-.8-.7-1-1.2l-.8-2.9.8-2.8-.5-1.5-1.3-2.3 1.8-1.8-.5-2.9a9 9 0 0 1 1.5-2.8c.3-.2 2.3-3 2.3-3l4.4-1 5.1.7 2.8 1.8.6 4.6s-.6 2.8-.8 2.8l-2.3 1s-2.6.3-2.8 0 .7 3.1.7 3.1v3.1l-.2 3.9s0 1.8-.3 2l-.8 1-.2 3.9 4 1-.2 2.3-2.8.3.5 15.7 4.1.7v4.4l-1.8 1-.5 15.7H310z"
    }),
    /* @__PURE__ */ jsx276("path", {
      fillRule: "evenodd",
      d: "M283 269.5v-12h6.6V270zm31.4 1 .3-12.2h6v11.9l-6.3.2zm31-.3-.4-11.5 6.5-.2v12l-6-.3zm-60.8-36h3.8v6.1h-3.8zm30.3.2h5.3v6h-5.3zm31 .5h4.6v5.7H346z"
    }),
    /* @__PURE__ */ jsx276("path", {
      fill: "none",
      stroke: "#a8a8a8",
      strokeWidth: 1.1,
      d: "M286.6 207c4 4.6 4.3 4.6 4.3 4.6m26.2-4.6c.8 1.5 2 4.8 3.6 5.1m29.3-4.4s1.3 3.6 3 4.1"
    }),
    /* @__PURE__ */ jsx276("path", {
      fill: "#b97700",
      fillRule: "evenodd",
      d: "M282.2 194c12-3.9-2.8-11.6-5.3 0-3.8.7-4.3 3.5-12.7 2.3-20.4 33-5.3 86.5 54.1 141.8-106.4-90.6-63.2-157.6-33.7-155 16 1 8 21-2.4 11z"
    }),
    /* @__PURE__ */ jsx276("path", {
      fill: "none",
      stroke: "#7d6c00",
      strokeWidth: 2.4,
      d: "M285.6 177s9.7 2.7 9.7 6.8m0-7.5s6.8 3 8.3 5.6m45.1-4.5s-8.6 1.2-10.5 3.8m-2.6-3s-5 4.1-4.5 5.3m3.4 12.7c-.8-.3-4.2-4.9-3.4-10.5m-29.8 7.5s2.3-2.6 2.3-7.5m13.5-1.9.4 11m9.4-1.6c0-.7 3-7.9-.4-11.3m-20.3-1.5s-2.6 7.2-.7 13.2m20-6.8s-4.2 1.2-6 3m-11.8-1.9c0-.3 4.6-1 6 1.6"
    }),
    /* @__PURE__ */ jsx276("path", {
      fill: "#c76e2e",
      fillRule: "evenodd",
      d: "M300.6 301.9c.2 0 3.8-.7 3.8-2.4 1.8-1.2.5-4.5.5-4.5l-3.4-.6-4.6-5.2c-.2-1.6.3-3.1-.7-4.8-3.2.8-5 3.5-6 6.5.7 1 .8 2 2.3 2.9 1.5.2 2.5-.7 3.9-.4.7 1.3.5 2.4.8 3.6 1.9 1.3 2.3 3.2 3.4 4.9m-4.1-22.2v-6.2l-4.4-.2c-.6 1-1.6 1.4-2.2 2.2l-3.1 1.6c1.3 1.5 2.9 2.4 3.8 3.2 2.3.6 4.1.6 5.9-.6m-13.8 9.1-2.4-4a7.2 7.2 0 0 1 4.7.3s1 2.5.3 3.4c-.4.9-2.7.5-2.6.3m36.5 4.1a4.6 4.6 0 0 0 2.7-3.3l-4.5-5.1-4-.1c-1-1-2.4-1.2-3.6-1.2 0 0 1.2 2 2.8 2.3 1.2 2.6 6.2 7.4 6.6 7.4m4.3.6c0-.1 4-1.4 6-1.3-.1-1.6 3-5.3 3-5.3l5.6 7.3c-1 .8-2.8.6-4.2.8 0 0-2.7 2.6-3 2.7s-5.2 1.3-7.6-.2c-1-2 .3-4.3.2-4m3.2-12.8a14 14 0 0 0 0-7.6h-6.4l-4.2 2s1.3 4.2 3 3.8c.7 2.1 2.9 1.6 4 2.4zm24.9-6.4c-1 2.7-1.4 5.5-.2 8 1.2.3 2.6 1 3.6.8l5.1-9.2c-3.5-1.1-6.4-1-8.6.4z"
    }),
    /* @__PURE__ */ jsx276("path", {
      fill: "#b97700",
      fillRule: "evenodd",
      d: "M353.1 193.2c-12-3.9 2.8-11.7 5.3 0 3.9.6 4.4 3.5 12.8 2.3 20.3 33 5.2 86.5-54.2 141.8 106.5-90.6 63.2-157.6 33.7-155.1-16 1-8 21 2.4 11"
    }),
    /* @__PURE__ */ jsx276("path", {
      fill: "#c76e2e",
      fillRule: "evenodd",
      d: "M354.3 284.7c-.2 0-3 2-3 2l-4.2 1.7-4.4.1-1-3 3.4-3c-2.8-.5-5.7.7-8 2.8 0 0 0 3.3 2 5 1.1 1.4 4.5 4 4.5 4a7 7 0 0 0 5.4-1zm-23.2 30.1c1.4.4 11.3-12.7 11.3-12.7a10 10 0 0 0-4.9-5.4s-4.8 5.7-4.9 7.6c-.8 1.7-3 8.3-2 9.2-.1.2-.5 2.9.5 1.3"
    }),
    /* @__PURE__ */ jsx276("path", {
      fill: "#006800",
      fillRule: "evenodd",
      stroke: "#004100",
      strokeLinejoin: "round",
      strokeWidth: 2.4,
      d: "M266.4 317.4c-14.8-12.9-34.8-20-62.7-10.3 7.5 3.2 15.6 4.3 22.5 7.9z"
    }),
    /* @__PURE__ */ jsx276("path", {
      fill: "none",
      stroke: "#00a400",
      strokeLinecap: "round",
      strokeWidth: 2.2,
      d: "M223.4 308.3c29.3.6 37.8 7.9 36.3 6.7"
    }),
    /* @__PURE__ */ jsx276("path", {
      fill: "#006800",
      fillRule: "evenodd",
      stroke: "#004100",
      strokeLinejoin: "round",
      strokeWidth: 2.2,
      d: "M267 319c-8.8 1.6-20.8 10-24.4 9.7-9.5-1.1-18.5-5-27.7-8-3.8-1.2-7.7 0-11.6 0 32.8-15.5 44-13.4 63.7-1.8z"
    }),
    /* @__PURE__ */ jsx276("path", {
      fill: "#006800",
      fillRule: "evenodd",
      stroke: "#004100",
      strokeLinejoin: "round",
      strokeWidth: 2.4,
      d: "M245.4 296s-11 1.6-15.9 1.9c-4.8-.3-12-4.8-19.8-13-4-4.6-13.4-4-13.4-4 20.6-4.4 36.7-.2 49 15.2zm-15-21.2c-14.9-1-33.5-14.3-37.7-30.2 0 .2 5.5 3.5 4.6 4.3 24.4 6.2 26 11.2 33.1 25.9zm25 25.5c2.1-13.5 2.7-22.4-3.6-30.4-5.3-6-6.6-9.7-10.4-18.3-1.1 17.8-5 32.5 14 48.7zM232 263c11-16.1 13-28.3 11.2-47.5-.3 1.5-4 11-4.2 11-16.5 10.3-9.2 26.5-7 36.5z"
    }),
    /* @__PURE__ */ jsx276("path", {
      fill: "#006800",
      fillRule: "evenodd",
      stroke: "#004100",
      strokeLinejoin: "round",
      strokeWidth: 2.4,
      d: "M222.2 185c11 16.1 9.4 31.3 7.6 50.5-.3-1.5-4-11-4.2-11-16.5-10.3-5.5-29.5-3.4-39.5z"
    }),
    /* @__PURE__ */ jsx276("path", {
      fill: "#006800",
      fillRule: "evenodd",
      stroke: "#004100",
      strokeLinejoin: "round",
      strokeWidth: 2.4,
      d: "M231.3 210c26.8-13.6 16.5-30.7 21.4-44-18.6 13.9-21 28.6-21.3 44z"
    }),
    /* @__PURE__ */ jsx276("path", {
      fill: "none",
      stroke: "#00a400",
      strokeLinecap: "round",
      strokeWidth: 2.2,
      d: "M235 206.6c3.4-9.5 10-25.6 10.7-25.6M227 226.4c-.6-6.7-4-24.7-4.3-26.5"
    }),
    /* @__PURE__ */ jsx276("path", {
      fill: "#006800",
      fillRule: "evenodd",
      stroke: "#004100",
      strokeLinejoin: "round",
      strokeWidth: 2.4,
      d: "M228.3 256.5c-15-1-31-21.3-35.3-37.1 0 .2 5.5 3.4 4.6 4.2 21.4 9.6 23.6 18.2 30.7 32.9zm-4.4-14c-11-16.1-13-28.3-11.3-47.5.3 1.5 4 11 4.3 11 16.4 10.3 9.1 26.5 7 36.5zm9.9-28.3c27.7-12.3 19.2-25.2 27.4-38.7-18.6 13.8-27.1 23.4-27.4 38.7z"
    }),
    /* @__PURE__ */ jsx276("path", {
      fill: "none",
      stroke: "#00a400",
      strokeLinecap: "round",
      strokeWidth: 2.2,
      d: "M235 211.4a70.7 70.7 0 0 0 15.2-20.7"
    }),
    /* @__PURE__ */ jsxs251("g", {
      fillRule: "evenodd",
      children: [
        /* @__PURE__ */ jsx276("path", {
          fill: "#ffe100",
          stroke: "#e9bf00",
          strokeWidth: 2.4,
          d: "m333.6 366.4 13.4.2c-44.7-42-130.5-60.2-118.6-137.4-12.3 83.7 70.1 91.5 105.2 137.2z"
        }),
        /* @__PURE__ */ jsx276("path", {
          fill: "#9d4916",
          stroke: "#68300e",
          strokeWidth: 1.1,
          d: "M235.4 212.7a4.3 4.3 0 1 1-8.6 0 4.3 4.3 0 0 1 8.6 0zm-2.6 23.6a4 4 0 1 1-8.1 0 4 4 0 0 1 8 0zm3.8 33.7a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0zm31.3 37.2a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0zm4.5 10.7a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs251("g", {
      fill: "#fff",
      fillRule: "evenodd",
      children: [
        /* @__PURE__ */ jsxs251("g", {
          stroke: "#000",
          strokeWidth: 1.1,
          children: [
            /* @__PURE__ */ jsx276("path", {
              d: "M288.2 349a15.5 15.5 0 0 1-4.8-5.8l-14-1.5-.2 8z"
            }),
            /* @__PURE__ */ jsx276("path", {
              strokeLinejoin: "round",
              d: "M185.3 339.6c8.2 1.5 20.5-.8 24.5 4.5 4.8 5.4-15.1 13.9-12.3 18.6 6.2 6.5 12.5 3.8 19.4.2 1.7-3.5 3-9.8 3.8-11.7-2.5-5.7-9.3-8.6-7.5-17.3 11.3-4.2 33.2-3.9 35.6-2.2 1.8 3.6.1 5.2.5 8.1-1.9 3.7-6.7 9.8-6.7 13.1 12 4.2 15-.6 25.8-.4 12.6.2 20.2 3.6 23-1.4-2-4.4-13.5-.8-17.8-3.6-2.2-.7-3.6-2.5-5.5-4.4s-7.2-2-8-6.9c2.2-10.2 17-8.6 19.3-10.2l38.4 2.7c7-.2 11 12.3 1.5 16-9.4 3.8-37.1-5.5-49.2.9-.6-2.6-9.3-6.6-9.9-6.7-3.7 1-10.9.7-10.9.7-1.7 3.2-3.8 5.6-5.5 8.9-8-3.5-15.5 2.7-24.2.9l-13.6 1.5-8.6-.8-13.2 3.8 9.4-8.3z"
            }),
            /* @__PURE__ */ jsx276("path", {
              d: "M184.7 338a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0zm-1 18a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.3 0z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs251("g", {
          stroke: "#000",
          strokeWidth: 1.1,
          children: [
            /* @__PURE__ */ jsx276("path", {
              d: "M346.3 349.1c2.3-2.1 3.8-3.5 4.7-5.8l14-1.6.3 8z"
            }),
            /* @__PURE__ */ jsx276("path", {
              strokeLinejoin: "round",
              d: "M449.1 339.6c-8.1 1.5-20.4-.7-24.4 4.5-4.9 5.5 15 14 12.2 18.6-6.2 6.6-12.5 3.9-19.4.3-1.6-3.5-2.9-9.8-3.8-11.7 2.6-5.8 9.3-8.6 7.6-17.3-11.4-4.3-33.3-4-35.6-2.3-1.9 3.7-.2 5.3-.6 8.2 2 3.6 6.8 9.8 6.8 13-12 4.3-15.1-.6-25.8-.3-12.6.2-20.3 3.5-23-1.5 1.9-4.3 13.4-.8 17.8-3.5 2.2-.8 3.6-2.5 5.5-4.5s7.2-2 8-6.8c-2.2-10.2-17-8.7-19.4-10.2l-38.4 2.6c-7-.2-10.9 12.3-1.5 16.1 9.4 3.8 37.2-5.6 49.2.8.7-2.6 9.3-6.5 10-6.7 3.6 1.1 10.8.7 10.8.7 1.8 3.3 3.8 5.7 5.6 9 8-3.6 15.5 2.7 24.2.8l13.5 1.5 8.7-.7 13.2 3.7-9.4-8.2 8.2-6z"
            }),
            /* @__PURE__ */ jsx276("path", {
              d: "M449.7 338a3.6 3.6 0 1 0 7.3 0 3.6 3.6 0 0 0-7.3 0zm1 18a3.6 3.6 0 1 0 7.2 0 3.6 3.6 0 0 0-7.2 0z"
            })
          ]
        }),
        /* @__PURE__ */ jsx276("path", {
          d: "M317 329.3c-3.2-.6-4.4-.4-6.6-.6l-5.1 15.8c8 .7 15.3.7 15.3.7-4.8-1-3.7-15.8-3.6-15.9"
        })
      ]
    }),
    /* @__PURE__ */ jsxs251("g", {
      fontFamily: "Trebuchet MS",
      fontSize: 9,
      fontWeight: "bold",
      children: [
        /* @__PURE__ */ jsx276("path", {
          d: "M283.4 340.2v-10.7h1.8v9h5v1.7z",
          "aria-label": "L"
        }),
        /* @__PURE__ */ jsx276("path", {
          d: "M291.7 340.7V330h1.9v10.7z",
          "aria-label": "I"
        }),
        /* @__PURE__ */ jsx276("path", {
          d: "M300 341.5h-3.3V331l3.2-.2q1.7 0 2.5.7 1 .8 1 2.1 0 1.2-1.3 2 2 .7 2 2.9 0 1.5-1.2 2.3-1 .8-2.8.8zm-1.3-9.1v2.5h1q1.7 0 1.7-1.4 0-1.1-1.7-1.1zm0 4v3.5h1q1.2 0 1.7-.4.7-.3.7-1.3t-.5-1.3q-.5-.5-1.9-.5z",
          "aria-label": "B"
        }),
        /* @__PURE__ */ jsx276("path", {
          d: "M308.6 333v2.7h3.4v1.7h-3.4v3.1h5v1.7h-6.9v-10.7h6.7v1.7z",
          "aria-label": "E"
        }),
        /* @__PURE__ */ jsx276("path", {
          d: "m322.2 342.4-2.8-4.5H318v4.5h-1.8v-10.7h1.2l1.6-.2q4.2 0 4.2 3.2 0 1-.5 1.7-.7.8-1.5 1.1l3.3 4.9zm-4.2-9v2.8h.9l1.6-.2q.7-.3.7-1.3 0-.8-.5-1.2-.7-.3-2-.3h-.7z",
          "aria-label": "R"
        }),
        /* @__PURE__ */ jsx276("path", {
          d: "M329.9 333v9h-2v-9h-3.4v-1.6h8.9v1.6z",
          "aria-label": "T"
        }),
        /* @__PURE__ */ jsx276("path", {
          d: "m340.7 340.5-.8-2.1h-3.7l-.7 2.1h-2.1l4.3-10.8h.8l4.4 10.8zM338 333l-1.1 4h2.5z",
          "aria-label": "A"
        }),
        /* @__PURE__ */ jsx276("path", {
          d: "m344.4 339.7.6-1.7q1.2.7 2.2.7 1.7 0 1.7-1.2l-.4-1-1.6-1.1-1.7-1-.7-1-.1-1.2q0-1.3.8-2.2 1-.6 2.3-.6 1.9 0 2.9.6l-.7 1.7q-1-.8-2.2-.8-.6 0-1 .3-.3.3-.3 1 0 .8 2 1.8 1.2.5 1.7 1l.6 1 .2 1.4q0 1.3-1 2.1t-2.7.9q-1.6 0-2.6-.9z",
          "aria-label": "S"
        })
      ]
    }),
    /* @__PURE__ */ jsx276("path", {
      fill: "none",
      stroke: "#00a400",
      strokeLinecap: "round",
      strokeWidth: 2.2,
      d: "M231.3 318.6c10.1 1.2 24.1.3 30.2 0M216 284.2c8.6 6.7 27.1 10.7 26.8 10.7m10.7 1.8c-2.8-14-5.8-17.4-8.3-26.2m-43.5-15.8c14.3 6.4 16.5 10.6 25.6 17m5.2-14c1.2-17.3 3.6-21.9 7.9-25.9m-38.7-2c5.2 5.7 22.2 23.7 22.2 23.7m-7-39.6c6.4 4.5 6.4 21 6.4 21"
    })
  ]
});
var Sm_default = SvgSm;

// src/country-flag-icons/generated/Sn.tsx
init_esm_shims();
import { jsx as jsx277, jsxs as jsxs252 } from "react/jsx-runtime";
var SvgSn = (props) => /* @__PURE__ */ jsxs252("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsxs252("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      children: [
        /* @__PURE__ */ jsx277("path", {
          fill: "#0b7226",
          d: "M0 0h213.3v480H0z"
        }),
        /* @__PURE__ */ jsx277("path", {
          fill: "#ff0",
          d: "M213.3 0h213.3v480H213.3z"
        }),
        /* @__PURE__ */ jsx277("path", {
          fill: "#bc0000",
          d: "M426.6 0H640v480H426.6z"
        })
      ]
    }),
    /* @__PURE__ */ jsx277("path", {
      fill: "#0b7226",
      d: "M342 218.8h71.8l-56.6 43.6 20.7 69.3-56.6-43.6-56.6 41.6 20.7-67.3-56.6-43.6h69.8l22.7-71.3z"
    })
  ]
});
var Sn_default = SvgSn;

// src/country-flag-icons/generated/So.tsx
init_esm_shims();
import { jsx as jsx278, jsxs as jsxs253 } from "react/jsx-runtime";
var SvgSo = (props) => /* @__PURE__ */ jsxs253("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx278("defs", {
      children: /* @__PURE__ */ jsx278("clipPath", {
        id: "so_svg__a",
        children: /* @__PURE__ */ jsx278("path", {
          fillOpacity: 0.7,
          d: "M-85.3 0h682.6v512H-85.3z"
        })
      })
    }),
    /* @__PURE__ */ jsxs253("g", {
      fillRule: "evenodd",
      clipPath: "url(#so_svg__a)",
      transform: "translate(80) scale(.9375)",
      children: [
        /* @__PURE__ */ jsx278("path", {
          fill: "#40a6ff",
          d: "M-128 0h768v512h-768z"
        }),
        /* @__PURE__ */ jsx278("path", {
          fill: "#fff",
          d: "M336.5 381.2 254 327.7l-82.1 54 30.5-87.7-82-54.2L222 239l31.4-87.5 32.1 87.3 101.4.1-81.5 54.7z"
        })
      ]
    })
  ]
});
var So_default = SvgSo;

// src/country-flag-icons/generated/Sr.tsx
init_esm_shims();
import { jsx as jsx279, jsxs as jsxs254 } from "react/jsx-runtime";
var SvgSr = (props) => /* @__PURE__ */ jsxs254("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx279("path", {
      fill: "#377e3f",
      d: "M.1 0h640v480H.1z"
    }),
    /* @__PURE__ */ jsx279("path", {
      fill: "#fff",
      d: "M.1 96h640v288H.1z"
    }),
    /* @__PURE__ */ jsx279("path", {
      fill: "#b40a2d",
      d: "M.1 144h640v192H.1z"
    }),
    /* @__PURE__ */ jsx279("path", {
      fill: "#ecc81d",
      d: "m320 153.2 56.4 173.6-147.7-107.3h182.6L263.6 326.8z"
    })
  ]
});
var Sr_default = SvgSr;

// src/country-flag-icons/generated/Ss.tsx
init_esm_shims();
import { jsx as jsx280, jsxs as jsxs255 } from "react/jsx-runtime";
var SvgSs = (props) => /* @__PURE__ */ jsxs255("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx280("path", {
      fill: "#078930",
      d: "M0 336h640v144H0z"
    }),
    /* @__PURE__ */ jsx280("path", {
      fill: "#fff",
      d: "M0 144h640v192H0z"
    }),
    /* @__PURE__ */ jsx280("path", {
      fill: "#000001",
      d: "M0 0h640v144H0z"
    }),
    /* @__PURE__ */ jsx280("path", {
      fill: "#da121a",
      d: "M0 168h640v144H0z"
    }),
    /* @__PURE__ */ jsx280("path", {
      fill: "#0f47af",
      d: "m0 0 415.7 240L0 480z"
    }),
    /* @__PURE__ */ jsx280("path", {
      fill: "#fcdd09",
      d: "M200.7 194.8 61.7 240l139 45.1L114.9 167v146z"
    })
  ]
});
var Ss_default = SvgSs;

// src/country-flag-icons/generated/St.tsx
init_esm_shims();
import { jsx as jsx281, jsxs as jsxs256 } from "react/jsx-runtime";
var SvgSt = (props) => /* @__PURE__ */ jsxs256("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx281("path", {
      fill: "#12ad2b",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx281("path", {
      fill: "#ffce00",
      d: "M0 137.1h640V343H0z"
    }),
    /* @__PURE__ */ jsx281("path", {
      fill: "#d21034",
      d: "M0 0v480l240-240"
    }),
    /* @__PURE__ */ jsxs256("g", {
      id: "st_svg__c",
      transform: "translate(351.6 240) scale(.34286)",
      children: [
        /* @__PURE__ */ jsxs256("g", {
          id: "st_svg__b",
          children: [
            /* @__PURE__ */ jsx281("path", {
              id: "st_svg__a",
              fill: "#000001",
              d: "M0-200V0h100",
              transform: "rotate(18 0 -200)"
            }),
            /* @__PURE__ */ jsx281("use", {
              xlinkHref: "#st_svg__a",
              width: "100%",
              height: "100%",
              transform: "scale(-1 1)"
            })
          ]
        }),
        /* @__PURE__ */ jsx281("use", {
          xlinkHref: "#st_svg__b",
          width: "100%",
          height: "100%",
          transform: "rotate(72)"
        }),
        /* @__PURE__ */ jsx281("use", {
          xlinkHref: "#st_svg__b",
          width: "100%",
          height: "100%",
          transform: "rotate(144)"
        }),
        /* @__PURE__ */ jsx281("use", {
          xlinkHref: "#st_svg__b",
          width: "100%",
          height: "100%",
          transform: "rotate(-144)"
        }),
        /* @__PURE__ */ jsx281("use", {
          xlinkHref: "#st_svg__b",
          width: "100%",
          height: "100%",
          transform: "rotate(-72)"
        })
      ]
    }),
    /* @__PURE__ */ jsx281("use", {
      xlinkHref: "#st_svg__c",
      width: "100%",
      height: "100%",
      x: 700,
      transform: "translate(-523.2)"
    })
  ]
});
var St_default = SvgSt;

// src/country-flag-icons/generated/Sv.tsx
init_esm_shims();
import { jsx as jsx282, jsxs as jsxs257 } from "react/jsx-runtime";
var SvgSv = (props) => /* @__PURE__ */ jsxs257("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx282("path", {
      fill: "#0f47af",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx282("path", {
      fill: "#fff",
      d: "M0 160h640v160H0z"
    }),
    /* @__PURE__ */ jsxs257("g", {
      transform: "matrix(.8 0 0 .8 -92.7 0)",
      children: [
        /* @__PURE__ */ jsxs257("g", {
          fill: "#fff",
          fillRule: "evenodd",
          stroke: "#000",
          strokeWidth: 0.3,
          children: [
            /* @__PURE__ */ jsx282("path", {
              d: "M515 353.4c1.5 0 3.2 0 10.1-1.7 7-1.7 12.7-5.9 14-6.5 1.4-.6 3.3-.4 3.3-.4a8.4 8.4 0 0 0-5.8-2.8c-3 0-1.9 0-4.4 1.1-2.6 1-8 4.3-17 4.3h-.1c-9 0-14.7-3.2-17.2-4.3-2.6-1-1.4-1-4.4-1-3 0-5.1 1.9-6 2.7 0 0 2-.2 3.4.4 1.4.6 7.1 4.8 14 6.5 7 1.7 8.6 1.7 10.1 1.7z"
            }),
            /* @__PURE__ */ jsx282("path", {
              d: "M488.4 347.4c.7-.4-.2-1.6-.2-1.6l2.7-.6c-1.3-.6-3.3-.4-3.3-.4-.5.4-.4.9-.5 1.3 0 .4 0 1 .2 1.3.3.3 1 0 1 0z"
            }),
            /* @__PURE__ */ jsx282("path", {
              d: "m491 345.2-2.8.6s.9 1.2.2 1.7l4.8-1-2.3-1.3zm50.7 2.2c-.7-.4.1-1.6.1-1.6l-2.7-.6c1.4-.6 3.3-.4 3.3-.4.6.4.5.9.6 1.3 0 .4 0 1-.3 1.3-.3.3-1 0-1 0z"
            }),
            /* @__PURE__ */ jsx282("path", {
              d: "m539.1 345.2 2.7.6s-.8 1.2-.1 1.7l-4.8-1z"
            })
          ]
        }),
        /* @__PURE__ */ jsx282("path", {
          d: "m495.8 343.3-1.2 3 .6.3c.9.3 1.8.1 2.2-.9.4-1-.1-1.8-1-2.1zm.3.6c.8.4 1.2.9.9 1.7-.3.8-1 .8-1.7.5h-.1z"
        }),
        /* @__PURE__ */ jsx282("path", {
          fillRule: "evenodd",
          d: "m497.6 347.6-.4-.1 1.4-3 .3.1z"
        }),
        /* @__PURE__ */ jsx282("path", {
          d: "M500.2 345.3c-.6 0-1.2.4-1.5 1-.4 1 0 1.9.8 2.3.8.3 1.8 0 2.2-1a1.7 1.7 0 0 0-.9-2.2 1.5 1.5 0 0 0-.6-.1m0 .5h.5c.6.3.8 1 .5 1.6-.2.6-1 1-1.5.7-.5-.3-.8-1-.5-1.6.2-.4.5-.7 1-.7"
        }),
        /* @__PURE__ */ jsx282("path", {
          fillRule: "evenodd",
          d: "M503.8 347.4c0-.3-.1-.4-.3-.5-.3-.1-.6 0-.7.2l.2.6.3.2c.3.3.5.7.3 1.2a1 1 0 0 1-1.3.6 1 1 0 0 1-.6-1.2h.4c-.1.4 0 .7.4.9.3 0 .6-.1.7-.4.2-.4 0-.6-.2-.8l-.2-.2c-.3-.2-.5-.5-.3-1 .1-.5.7-.6 1-.5.4.2.6.4.7.8zm2.4.1-.5 1.9c-.1.5-.1 1 .4 1.2.6.1.9-.3 1-.8l.6-1.9.3.2-.5 1.9c-.2.7-.8 1.1-1.5 1-.7-.3-1-1-.7-1.6l.6-2zm4.4 4.5-1.8-3-.5 2.4h-.4l.7-3.4 1.8 3 .4-2.4h.4zm.8 0 .4-3.2h.3l-.4 3.2z"
        }),
        /* @__PURE__ */ jsx282("path", {
          d: "M514.2 348.9a1.6 1.6 0 0 0-1.7 1.6c0 1 .7 1.7 1.6 1.8.8 0 1.6-.7 1.6-1.7 0-.9-.7-1.7-1.5-1.7m0 .5c.6 0 1 .6 1 1.2a1.1 1.1 0 0 1-1.1 1.2c-.6 0-1.1-.6-1.1-1.3 0-.6.5-1.2 1.1-1.2z"
        }),
        /* @__PURE__ */ jsx282("path", {
          fillRule: "evenodd",
          d: "m519 352.1-2.4-2.3.1 2.4h-.4l-.2-3.4 2.5 2.4-.2-2.4h.4zm2.1-.5-.6-3.2h.4l.6 2.8.9-.2v.4zm1.8-.3-.8-3.2h.4l.7 3.1z"
        }),
        /* @__PURE__ */ jsx282("path", {
          d: "M523.9 347.7h-.4l-.4.2.9 3.1.7-.1c.5-.2 1-.6.8-1.2-.1-.4-.4-.7-.8-.6l.1-.8c-.2-.5-.5-.6-1-.6zm0 .4c.2 0 .4 0 .5.4.2.4-.1.5-.4.6h-.1l-.3-1h.1a1 1 0 0 1 .2 0m.5 1.3c.3 0 .6 0 .6.4.2.4-.1.5-.4.6l-.3.1-.3-1h.4z"
        }),
        /* @__PURE__ */ jsx282("path", {
          fillRule: "evenodd",
          d: "m527.2 348 .2.3-1.2.4.4 1.2 1.2-.5.1.4-1.5.6-1.1-3.1 1.6-.6v.3l-1.1.5.3.8z"
        }),
        /* @__PURE__ */ jsx282("path", {
          d: "M528.6 346.2c-.3 0-.5 0-.8.2l-.4.1 1.2 3h.3l-.4-1.4 1.4.9.5-.1-1.5-1c.4-.2.6-.7.4-1.1a.9.9 0 0 0-.7-.6m0 .4.3.3c.2.5-.2.7-.5.8l-.5-1h.1l.5-.1z"
        }),
        /* @__PURE__ */ jsx282("path", {
          fillRule: "evenodd",
          d: "m529.2 345.8 1.7-.8.2.3-.7.3 1.2 2.7-.3.1-1.2-2.6-.7.3z"
        }),
        /* @__PURE__ */ jsx282("path", {
          d: "m532.2 344.2.2 3.7.4-.2v-.8l1.3-.7.6.6.4-.3zm.4.9 1 .8-.8.5-.1-1.3zm2.7-2.2-1 .3-.5.3 1.7 2.8.5-.3c.9-.5 1.3-1.4.7-2.3-.4-.6-.9-.8-1.4-.8m.2.5c.3 0 .6.2.8.5.4.8 0 1.3-.6 1.7l-1.3-1.9h.1z"
        }),
        /* @__PURE__ */ jsxs257("g", {
          id: "sv_svg__a",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          children: [
            /* @__PURE__ */ jsx282("path", {
              fill: "#e60000",
              fillRule: "evenodd",
              strokeWidth: 0.1,
              d: "M485 355.2c.6 0 1-.4 1-1a.9.9 0 0 0-1-.8c-.4 0-.8.4-.8.9s.4.9.9.9zm-5 6.3c.5 0 .9-.4.9-1a1 1 0 0 0-1-.8 1 1 0 0 0-.9.9c0 .5.5.9 1 .9zm-12-19.9c.5 0 1-.4 1-.9a1 1 0 0 0-1-.9.9.9 0 0 0-.8 1c0 .4.3.8.9.8zm-7.3 3.7c.5 0 1-.4 1-1 0-.5-.5-1-1-1a1 1 0 0 0-1 1c0 .6.4 1 1 1zm-1.4-22.3a1 1 0 0 0 1-1c0-.5-.4-1-1-1a1 1 0 0 0-1 1 1 1 0 0 0 1 1zm-6.2 1.8a1 1 0 0 0 1-1 1 1 0 0 0-1-1 1 1 0 0 0-1 1 1 1 0 0 0 1 1zm3.2-19.8a1 1 0 0 0 1-1 1 1 0 0 0-1-1 1 1 0 0 0-1 1c0 .5.4 1 1 1zm-5.5-18.3c.5 0 1-.4 1-1a1 1 0 0 0-1-1 1 1 0 0 0-1 1c0 .6.4 1 1 1zm7 1.8a1 1 0 0 0 1-1c0-.5-.4-1-1-1a1 1 0 0 0-1 1 1 1 0 0 0 1 1zm7-15.2c.5 0 1-.4 1-1 0-.5-.5-1-1-1a1 1 0 1 0 0 2zm-5.3-4.2a1 1 0 0 0 1-1 1 1 0 0 0-1-1 1 1 0 0 0-1 1 1 1 0 0 0 1 1zm10.5-10.3a1 1 0 0 0 1-1 1 1 0 0 0-1-1 1 1 0 0 0-1 1 1 1 0 0 0 1 1zm-21.5 46.3c.6 0 1-.4 1-1s-.4-1-1-1a1 1 0 0 0-1 1c0 .6.5 1 1 1z"
            }),
            /* @__PURE__ */ jsx282("path", {
              fill: "none",
              strokeWidth: 0.3,
              d: "M486 358.9s-.8-3.2-.7-3.9l.8-.6m-1.4 5.7s-2.8.1-3.7.4l-.3.8m-13.4-15.5s-.2-3.8.6-4c0 0 .7-.4 1.2-1m-4.7 3.8s-2.1-.3-2.7 0c0 0-.2.6-.6.8m-.8-23-.7.5c-.8.3-2.3 4-2.3 4s-2.4-1.9-3.4-2h-1.1m-4.8-20.2s.6.6 1.2.3c0 0 3 2 3.1 2.7 0 0 3.2-3.2 3.8-2.9 0 0 .3.5 1-.1m-5.8-18.6s.3.5.9.8c0 0 1.4 2 1.4 3.5 0 0 2.5-2.3 3.3-2.1 0 0 .9.3 1.5 0m.3-19.5s.6.8 1 .2c0 0 1.8 2.2.8 4 0 0 2.5-.7 3.3-.3 0 0 .3 1 1.2.5"
            }),
            /* @__PURE__ */ jsxs257("g", {
              fill: "#1f601a",
              fillRule: "evenodd",
              strokeWidth: 0.3,
              children: [
                /* @__PURE__ */ jsx282("path", {
                  d: "m532.8 378.3-4.5-.3c-.6 0-2-2.7-2.6-3.1-.6-.5-10.8-5.5-17.5-6.5a95 95 0 0 1-19-6 88 88 0 0 1-26-19.2c-2.9-4.2-6-14-7.2-19.2-.7-2.5-4-12.4-4-19.2a84 84 0 0 1 2.2-19.4 111 111 0 0 1 15.3-26.8s-12 18.7-14.2 25.9a81 81 0 0 0-2.5 21.5c.1 4.2 3.6 19.6 8.7 30.9 4.1 9 7.7 10.2 14 15.2 3 2.4 8.8 6.2 13.6 8.6 4.8 2.4 15 5.5 17.8 5.9 2.7.5 16.4 4.5 18.2 5.4 1.8 1 6.5 5 7.7 6.3z"
                }),
                /* @__PURE__ */ jsx282("path", {
                  d: "M464.1 343.4c.3-1.4.4-2.4 1-2.8a14 14 0 0 0 2.2-3.5c.3-1.2 0-2.2 0-2.8l.4-2.7s-.7-2.5-1.3-3c-.6-.4-2.2-2.6-2.5-3.2 0 0 .2 1.3-.3 1.9a7 7 0 0 0-.6 3c0 .9.3 3 0 4-.3 1.2-.7 2.2-.4 3.5zm-.5-1.5s-3.4-4.4-3.4-6.2c0-1.8-.3-2.9-.6-3.3-.3-.4-2.3-2.7-.5-5.6.8-1.2 1-1 1.4-2.4.6-1.6 1.8-1.6 2-3.3 0 0 .4 2 .5 3.6.2 1.7-.1 2.3-.2 3.2-.2.9.4 2 .4 3.3 0 1.4-.2 1.9-.2 2.7 0 .4-.5 6.2.6 8zm38.6 23.5-4-.5c-.7 0-2.5-.5-3.5-.9a10 10 0 0 1-4-2.8c-2.8-3-2.5-4.5-3-4.6-1-.2 1.5-.4 2.8-.3 1.1.2 2.8 1 3.8 2 1.2 1.1 3 2.3 3.5 2.7.6.5 1 .7 1.7 1.5.7 1 .6 1.5 2.7 3z"
                }),
                /* @__PURE__ */ jsx282("path", {
                  d: "M506.2 367.5s-7.2-3.2-8-3.8a25 25 0 0 1-2.8-2.6c-.7-.8-3.8-2.4-4.3-3.4-.3-.7-2.3-3.3-3.4-5.4-.5-1 4.9.3 4.9.3 4.4 1.8 2.4.6 4.8 2.4 1.5 1.1 2.5 2 2.9 2.9.6 1.3 1.2 3.5 1.9 4.7.6 1.2 1.7 2.7 4 5z"
                }),
                /* @__PURE__ */ jsx282("path", {
                  d: "M510.2 368.4s-6-1.5-8.8-5.2c-2-2.6-2-1.8-2.7-2.7-1-1-2.6-2.3-4-4.5.2.3-1.6-5.9-1.6-6.6 0-.4 2.3.3 4.2 1 1.5.7 2.4 2 3.8 2.8 1.6 1 1.8 3.7 2.5 4.9 1 1.8 1.2 2.7 1.2 3.5 0 1.4.8 1.8 1.2 3 .5 1.3 2.1 1 4.2 3.8zm-9.6-2-5.9-2.4c-.8-.1-1-.6-2.1-.9-.9-.2-1.7-.9-3.8-.4-.9.2-4.6 1-5.5.6-1-.5 1.3 2.5 2.3 3.1 1.1.7 2.9 1 4.4.8h4.4c.7 0 1.2.2 2.3-.1 1-.3 1.3-.8 3.9-.7z"
                }),
                /* @__PURE__ */ jsx282("path", {
                  d: "M504 366.4s-5.7-1.4-6.7-1.4l-4.8.4c-1 .2-4.5-.2-5.5.4-1 .4-5.6 1-6.8.8-1.2-.3 2.4 3.2 3.9 3.6 4.6 1.3 3.2 1.1 6.2.4 1.8-.5 4.4-.6 5.4-.8.9-.1.7-.7 2-1.2 1.1-.5 3.2-1.8 6.3-2.2z"
                }),
                /* @__PURE__ */ jsx282("path", {
                  d: "M508.7 368.8s-5.7-2.4-10.2-1.1l-4.2 1c-1.4.1-2.6-.6-5 .4-1.2.4-6.2 2.5-7.5 2.4-1.3-.1 4 3.3 5.4 3.1 4.6-.6 9 1 11 0l4-1.5c1-.4 1.5-1.2 2.1-1.7.6-.4 1-1.6 4.4-2.6zm-30.6-13.1s-3.3-3.6-4-4.1l-3-2.4c-.6-.6-1.3-2-3.4-2.5-1-.2-3.1-.6-3.8-1.4-.6-.8.1 3 .8 4a8.1 8.1 0 0 0 3.6 2.5c1.5.5 3.3 1.5 4 1.9.6.3 1 .6 2 .8 1.1.2 1.6 0 3.8 1.2z"
                }),
                /* @__PURE__ */ jsx282("path", {
                  d: "M481.3 357.2s-5.7-4-6.5-4.4l-3.5-1.3c-1.1-.3-4-2.3-5-2.3-1.2 0-3.3-.1-4.3-.8-1-.8-.1 2.7 1 3.7 3.6 3.2 1.1 2.2 4.1 2.8l5.1 1.7c1 .3 1-.3 2.3-.2 1.3 0 3.8-.2 6.8.8z"
                }),
                /* @__PURE__ */ jsx282("path", {
                  d: "M482.6 358.3s-2.3-1.6-6.9-2.4c-3-.5-3-.6-4.1-1-1.4-.4-1.7-.4-4.3-.5-1.2-.1-6.2 1.5-7.4.8-1-.6 1.3 1.5 2.6 2 2 .8 1.8 2 4 2.8 2.2.7 4.7 1.6 6 1.4 1-.2 1.8-.7 3.3-.8 1.4-.2 4-2.3 6.8-2.4zm.5-1.2s1.1-5.5.1-6.8a5.2 5.2 0 0 1-1.2-2.9 11 11 0 0 0-1.6-4.3c-.6-.8-1.8-4.2-1.5-5.1 0 0-3.2 3.1-3 5.1v2.4c-.2.9.7 3.9 1.3 4.8.6 1 .3 3.6 1 4.2.5.6 4.1 3 4.9 2.6z"
                }),
                /* @__PURE__ */ jsx282("path", {
                  d: "M482.6 358.3c.3.1-2-1.8-3-2.3-1-.4-5.3-1.6-5.6-2.7-.3-1-3.7-4.6-3.9-5.6 0-.6-.7-2-.6-2.8.2-.7.5-2.6 1-3.6.4-1.1 1.4-3.6 2.5-4l1.2 3.8c.3 1 .6 2.3 1 2.9.5.6 2 3.4 2.1 4.5l1.1 5.3c.1.7 3 3.8 4.2 4.4zM464 343.4c.1.8-2.3-.8-3.5-.8-1.2 0-4.8.5-5.7-.4-.9-1-2.2-2.6-2.7-2.9-.5-.3-2.1-3-2.6-4.5-.4-1.5-3.6-4.2-4-4.5 0 0 4.3-.9 7 .9s3 1.4 3.5 1.6c.6.3 5.3 4.3 5.6 5.8.3 1.5 2.2 4 2.4 4.8z"
                }),
                /* @__PURE__ */ jsx282("path", {
                  d: "M464.1 343.4s-3.9-2.7-4.8-2.6c-1 .2-5.2-3-5.4-5-.2-1-2.2-2.5-2.6-3.1-1-1.8-1.7-5.9-3.2-7l5.2 1.3c2 .3 3.6.6 4.3 2.2.8 1.7 1.4 3 2 3.2.6.2 1.5 2.3 1.8 4.4a32 32 0 0 0 2.7 6.6zm-7.4-20.5c.7 1 .6-6 .9-6.8a11.3 11.3 0 0 1 1.7-2.8c.6-.6.6-2.7.9-3.3.3-.6.1-4.7-.3-5.8L458 306c-.6.7-1.7 1-2 2-.3.8-.9.8-1.3 1.8a5.6 5.6 0 0 0-.6 3.6c.3 1.2.1 1.6.1 2.7 0 1 1.5 5.6 2.4 6.9z"
                }),
                /* @__PURE__ */ jsx282("path", {
                  d: "M456.9 323.5s-.3-2 .4-2.7c.8-.8 1.5-.8 1.8-1.2.3-.5.2-1 .5-1.7.3-.6 1-1.6 1-2 .3-1.7 1.3-3.6.5-5.3 0 0-1.7.5-2.1.8-.5.3-1.8 1.6-2 2.8-.1 1.3-.3 1.5-.7 2.2-.5.8-1 3-.3 4.4a7.4 7.4 0 0 1 .9 2.7zm-4.4-23s-.3-4.4.9-5.8c1.2-1.3 1.5-3.9 4.2-5.3v1.9c.2.7.5 2.8 0 3.6-.4.7-2 2-2 2.7 0 .6-1 2.1-1.7 2.4z"
                }),
                /* @__PURE__ */ jsx282("path", {
                  d: "M452.5 302.8s0-3 .9-4c.9-.9 1.4-1.4 1.8-2 .5-.5 1-2 2-2.7 1-.6 2.8-2.1 3-2.7 0 0 .4 3.8-.6 5.8s-1 3-2.3 3.4c-1.2.5-1.4.8-1.8 1-.5.4-1.2.8-1.8.8-.6 0-1.2.4-1.2.4zm3.5 20.6c.1.8.7-2-2.4-2-3.2 0-5.8-1.2-6.8-2.3l-2.1-2.3a9 9 0 0 1-1.8-3.1c-.2-.9-1-4.2-1-4.8 0 0 1.7.3 2.5.9.7.6 2 .6 2.8 1 .8.5 1.4 1.7 1.9 2.1.4.5 1.7.5 2.3 1.4.6.9 1.7 2.9 1.9 3.8 0 .9 1.2 1.8 2 2.2.6.5.5 2.3.6 3z"
                }),
                /* @__PURE__ */ jsx282("path", {
                  d: "M455.6 322.1s-2-2.5-3.1-2.5c-1 0-3.8-2.7-4-4 0-1.1-1-3.4-1.6-3.9a3.6 3.6 0 0 1-1.5-3.3c.2-1.8.2-4.8.2-4.8s.6 1.8 1.5 2.3c.9.4 2.5 1 2.8 1.6.3.6 1.5.6 2 2.5.5 1.7.5 1.6.8 2.2.3.6 1 1.4 1.3 2.6.3 1.2 2 4.3 1.7 7.3zm-3-16.6c-.2.8 1.1-1.6-1.7-2.4a9.6 9.6 0 0 1-5.6-4l-1.3-2.6a9 9 0 0 1-.7-3.4c0-.9.2-4.1.5-4.6 0 0 1.4.7 2 1.4.4.8 1.7 1.2 2.3 1.8.5.6.7 1.9 1 2.5.3.5 1.5.9 1.8 1.8.3 1 .7 3.1.6 4-.1.8.6 2 1.2 2.6.5.6-.1 2.2-.2 3z"
                }),
                /* @__PURE__ */ jsx282("path", {
                  d: "M452.6 304.3s-1.3-2.9-2.2-3.2c-1-.3-2.5-2.7-2.6-3.9-.1-1.2-.3-3.4-.7-4-.5-.6-1.3-2.4-.6-4l1.6-3.7 1.3 2.1c.8 1.6 1.6 1.7 1.7 2.3.1.7 1 1 1.4 2.3.5 1.7 0 1.6 0 2.3.2.6.7 1.5.6 2.7 0 1.1.6 4.5-.5 7.1zm2.3-18.2c.1-.4 1-.9 2.1-1.2 1-.3 2.7-2.7 3.5-3.3.7-.6 1-1.6 2-2.1.9-.5 1.4-2.4 1.7-4.2l-3.3.7a7.2 7.2 0 0 0-2.8 1.8c-.6.8-1.2 2-1.9 2.3-.6.3-1.3 2.1-1.3 3.3z"
                }),
                /* @__PURE__ */ jsx282("path", {
                  d: "m454.8 284.8-.2-2.6c0-.9-.6-3.3.7-5.3 1-1.3 4.3-3.9 5.2-4 0 0 .6 2.4.4 3.1-.1.8-1 3.8-1.6 4.1-.7.3-2.4 3.9-4.5 4.7z"
                }),
                /* @__PURE__ */ jsx282("path", {
                  d: "M454 286.1c-.4.7-.1-2.2-1-3-1-.7-1-1.8-1-3s.2-2 .3-2.9c.2-.7 2.5-3.9 2.3-4.8l1.7 3.8c.4 1-.3 2.1-.2 3 .2.9.9 2.6.3 3.5L454 286zm8-15.5s.2-.4 1.5-.4 3.3-.1 3.9-.8c.6-.6 1.6-1.4 2.3-1.7a5.2 5.2 0 0 0 1.8-2.2c.1-.6 1.2-1.8 1.6-1.8 0 0-1.6-.2-3.4.3-1.8.5-4.4 1.4-5 2.6-.6 1.2-2.7 4-2.7 4z"
                }),
                /* @__PURE__ */ jsx282("path", {
                  d: "M462.5 270.3c.3 1 2.8-1 3.4-1.8l1.5-2 1.8-2.4c1-1.6.7-4.6.3-4.3a31 31 0 0 1-2.5 1.4c-.5 0-1.4.4-1.7 1.1-.3.8-.6 1.8-1 2.3-.5.5-3.2 2-1.8 5.7z"
                }),
                /* @__PURE__ */ jsx282("path", {
                  d: "M461.6 270.3s2-1.5 2.8-2.3c1-.8.5-2 1-2.6.3-.6 1.4-2 1.1-3l-.9-3.4-1.8 1.8c-.8.8-.9 1.4-1.2 2.3-.3.9-1 1.5-1.2 2.2-.3.8 0 2.3.2 3.2z"
                })
              ]
            }),
            /* @__PURE__ */ jsxs257("g", {
              fill: "none",
              strokeWidth: 0.1,
              children: [
                /* @__PURE__ */ jsx282("path", {
                  d: "M494.8 365.2s-10-.1-10.8-1.3m16.6 2.6s-6.5 1.7-10 1.3c-3.5-.4-5.1.3-5.9.3-.7 0-4.5-1.5-4.5-1.5m27 2.2-6 1.3c-1 .3-6.2 2.2-7.7 2.2h-5a18 18 0 0 1-6.3-.4m6.2-15s3.7 2.3 4.4 3c.5.8 3.8 3.5 4.5 3.5m-9-11.1s6.5 5.6 7.6 6.3c1 .8 7.4 7 8.1 7.8M493.6 350s5.1 4 5.7 5.7c.6 1.7 2.2 3.6 2.2 3.6s2 4.2 2.8 4.8c.8.6 2.3 2.2 4.1 3.4m-44-21.3s5.4 4.6 6.9 5.4m-9.1-2.5s5.4 3.7 7.8 4.6c2.4 1 4.4 1.7 9.6 2.4m2.1 2.2s-6-.3-7 0-5.8-.8-7-1.1l-6.6-1.4m11.4-17.9s-.3 3.3.2 4.7c.4 1.3 2.6 5.3 2.4 6.2-.1.9 1.2 5 2.4 5.7m1.2-16s-1 3.3-.6 4.4c.5 1 1.2 3 1.2 4.2 0 1.2.8 3 1 3.8.4.7-.1 3.3.7 4l1.6 2.2m-36.1-26.3s4.8 1.9 5.4 3c.6 1.3 1.5 1.6 2 2.2m10.3-9.7s1.3 4.9 1 6c-.3 1.2-.3 3.7-.3 4.6 0 .9-1.4 4.5-1.3 5m-1.3-19.6-.6 4c-.1 1.2 0 3.2-.3 4-.3.7-.8 4.8 0 6.6M449 326.2l4.8 4.2c.9 1 5 5.3 5.1 6.4.1 1 3 4.3 3.9 5m-20.5-32.5s4 4 4.2 4.9c.3.9 2 2.3 2.8 2.8m11.4-6s-1.5 2.3-1.5 3c0 .8-.6 2.7-1.2 3.5-.4.5-1.7 2.7-1.5 4m3-16.8-1 3.6c-.2 1.5-1 3-1.3 4-.3.8-1.5 5.2-1 7.9m-10.4-15.7s.4 2.1 1.5 3.2c1 1 2.7 2.6 2.8 3.4.2 1 1.6 5.4 3 7a5.4 5.4 0 0 1 1.7 3m-10.5-32s.4 2.6.7 3.4c.3.7 1.5 4 2.7 5.1m9.5-7.7-.9 3c-.1 1-1 2-1.2 2.4l-.7 2m5.5-5.3c-.1.9-1.8 3.6-2 4-.1.5-1 2.6-1.9 3.2-.9.6-3.6 2.6-3.4 3.4m-4.4-16.5s-.2 3.3.4 4.5a37.2 37.2 0 0 1 1.7 4c.3.9.3 2.4.4 3.4.2 1.1.6 3 1.2 3.8m11.8-25.9-3.2 3.5c-1 1-4.8 5-5 5.8m4.6-11.6s-2.1 4.7-2.6 5.4l-.9 2m-2-7.5s.2 3.6 0 4.5a7.9 7.9 0 0 0 0 2.9c.2.4-.4 3.7-.5 4.5m18-21.3s-4.8 2.9-5.5 3.6m2.7-7.3-3.3 4.8-.8 1.4m.3-6.7s-1 2.6-1.2 3.6a36 36 0 0 1-2.2 5.6"
                }),
                /* @__PURE__ */ jsx282("path", {
                  strokeWidth: 0.3,
                  d: "M469.2 258s-.4 1 1.4.7"
                })
              ]
            })
          ]
        }),
        /* @__PURE__ */ jsx282("use", {
          xlinkHref: "#sv_svg__a",
          width: "100%",
          height: "100%",
          transform: "matrix(-1 0 0 1 1030 0)"
        }),
        /* @__PURE__ */ jsx282("path", {
          fill: "#00209f",
          fillRule: "evenodd",
          d: "M514.6 366.1s.7-1.8 2.2-.1c0 0 1.9 4.2.5 4.3-1.4.2-2.7.5-2.9-.3-.1-.7.2-3.9.2-3.9"
        }),
        /* @__PURE__ */ jsx282("path", {
          fill: "#00209f",
          fillRule: "evenodd",
          d: "M516.5 365.5s.5-6.4 1.4-6.7c.9-.3 3.6-1.8 5.3-.5 1.6 1.4 0 8-.5 8.7-.6.6-1.5 2.5-5 2l-.4-1.6s1.8-.2 3-.8c1.2-.6 1.6-1.2 1.5-1.8-.2-.9 0-4.2-1-4.5l-2.3-.8-1.7 6.5z"
        }),
        /* @__PURE__ */ jsx282("path", {
          fill: "#00209f",
          fillRule: "evenodd",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.2,
          d: "M514.4 370s-6.2 3.7-3 9l-2.1-1.3s-1.2 2.2-.1 3.4c0 0-4.3-3.8-1-8.3 3.4-4.6 6-4.3 6-4.3z"
        }),
        /* @__PURE__ */ jsx282("path", {
          fill: "#00209f",
          fillRule: "evenodd",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.2,
          d: "M514.4 367s-2.7-1.8-6.6-.7c0 0-1.7-5.6-1-7.4.2-.8.8-.9.8-.9s-2-1.2-1.3 4c.6 5.4 1.6 6.8 1.6 6.8s5.2.3 6.4-.3l.1-1.4z"
        }),
        /* @__PURE__ */ jsx282("path", {
          fill: "#00209f",
          fillRule: "evenodd",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.2,
          d: "M514.4 367s-5.4-9-6.8-9c0 0-1.5-.2 2-.6 1.2-.1 3.2 0 4 1.7 1 1.6 1.7 5.5 2 6.1 0 0-1 .3-1.2 1.9z"
        }),
        /* @__PURE__ */ jsx282("path", {
          fill: "#011322",
          fillRule: "evenodd",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.2,
          d: "M514.4 367s-3.6-1.6-4-2c-.5-.5-1.2-5.6-.8-5.3 0 0-1.5-1.7-2-1.7-.3 0-1.3.8-1 2.6.3 1.8.7 4.5 1.2 5.7 0 0 2.9-1.2 6.6.8z"
        }),
        /* @__PURE__ */ jsx282("path", {
          fill: "#00209f",
          fillRule: "evenodd",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.2,
          d: "M517.7 370s2 1.3 2 3.5c0 2.3.9 6.4 2.7 7.3 0 0 .5-1.7 1-2 0 0 1.9 2.1 2.5 2.1 0 0-1-2-1-2.9 0-.9-1-4.3-2-5.2-.8-1-2.6-3-5.2-3.8z"
        }),
        /* @__PURE__ */ jsx282("path", {
          fill: "#011322",
          fillRule: "evenodd",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.2,
          d: "m518.5 359.5-1.7 6.5.5 1.4s.6-.2.9-1c.3-.7 1.2-6.3 1.7-6.5z"
        }),
        /* @__PURE__ */ jsx282("path", {
          fill: "#011d33",
          fillRule: "evenodd",
          d: "M514.4 369.3s-3 1-4.1 3.2c0 0-.4-1.5 4-3.6v.4zm3.4 0s2 .8 2.6 2l-2.6-1.5zm-3.4-1.7s-4.6.7-5.6.5c0 0 1.3.3 5.6 0zm7.4-2.8s.5 2.3.9 2.2c.4-.2 1.2-3.9 1.2-5.6 0-1.7-.7-2.1-1.4-2-.7 0-1 1.5-1 2.2a49 49 0 0 0 .3 3.2"
        }),
        /* @__PURE__ */ jsx282("path", {
          fill: "#011d33",
          fillRule: "evenodd",
          d: "M516.8 366s1.9 4.1.5 4.4c-1.4.2.6.1-.4-2.7-.4-1.1-1-2.5-1.3-2.5 0 0 1.1.4 1.2.8"
        }),
        /* @__PURE__ */ jsx282("path", {
          fill: "none",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.2,
          d: "M514.6 366.1s.7-1.8 2.2-.1c0 0 1.9 4.2.5 4.3-1.4.2-2.7.5-2.9-.3-.1-.7.2-3.9.2-3.9z"
        }),
        /* @__PURE__ */ jsx282("path", {
          fill: "none",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.2,
          d: "M516.5 365.5s.5-6.4 1.4-6.7c.9-.3 3.6-1.8 5.3-.5 1.6 1.4 0 8-.5 8.7-.6.6-1.5 2.5-5 2l-.4-1.6s1.8-.2 3-.8c1.2-.6 1.6-1.2 1.5-1.8-.2-.9 0-4.2-1-4.5l-2.3-.8-1.7 6.5z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs257("g", {
      transform: "matrix(.8 0 0 .8 -92.7 0)",
      children: [
        /* @__PURE__ */ jsx282("path", {
          fill: "#00209f",
          fillRule: "evenodd",
          d: "M509.8 255.9c-.4-1-.4-7.4-.4-8.4a68 68 0 0 1 3.8-11.2c.6-1 .5-1.2.7-1.8l.9-1.2a10.9 10.9 0 0 1 1.3 4.1s-.6 4.1-1.1 6c-.4 1.7-1.6 4.3-1.8 4.8-.6 1.2-.5 2.4-.2 2.5z"
        }),
        /* @__PURE__ */ jsx282("path", {
          fill: "#fff",
          fillRule: "evenodd",
          d: "m515 247.3.5.6c1.3-1.5 1.4-4.5 1.4-4.5l-.9-6s-.5 4-1 6c-.4 1.7-1.6 4.3-1.8 4.8-.9 2.2-.2 2.4-.2 2.5z"
        }),
        /* @__PURE__ */ jsx282("path", {
          fill: "#00209f",
          fillRule: "evenodd",
          d: "M515.5 247.9c1.3-1.5 1.4-4.5 1.4-4.5s1 5 .4 6c-.5 1-.5.7-.4 1.3z"
        }),
        /* @__PURE__ */ jsx282("path", {
          fill: "none",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.3,
          d: "M517 250.7c-.2-.6-.2-.3.3-1.3s-.4-6-.4-6l-.9-6c0-1.3-.6-3-1.2-4.1l-.9 1.2c-.2.6 0 .8-.7 1.8-.6 1-3.6 9.5-3.8 11.2 0 1 0 7.5.4 8.4"
        }),
        /* @__PURE__ */ jsx282("path", {
          fill: "#fc0",
          fillRule: "evenodd",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.1,
          d: "m515 234.1-.2-1.3c0-.2.6.9 1 .7.9.3 1.9 1.5 2.1 1.8-.4.5-1.3 1.6-2 1.4-.5-.2-.4-1-.5-1.5-.1-.3-.4-.6-.4-1z"
        }),
        /* @__PURE__ */ jsx282("path", {
          fill: "none",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.1,
          d: "m515 233.3.4.4c.2.2.4 0 .7.2.6.4.9.8 1.6 1.5m-2-1.4c.8.4 1.2 1 1.8 1.7"
        }),
        /* @__PURE__ */ jsx282("path", {
          fill: "#fc0",
          fillRule: "evenodd",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.1,
          d: "m514 233.4 1.3-.6c.1 0-.7.8-.4 1.2 0 .9-.7 2.2-1 2.5-.6-.1-1.2-.1-1.8-1.1-.2-.4.4-.8.8-1.1.2-.2.7-.8 1.2-.9z"
        }),
        /* @__PURE__ */ jsx282("path", {
          fill: "none",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.1,
          d: "m514.9 233.2-.3.5.1.7c-.2.7-.5 1-.9 2"
        }),
        /* @__PURE__ */ jsx282("path", {
          fill: "none",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.1,
          d: "M514.4 234c0 .9-.5 1.5-1 2.3h.2"
        }),
        /* @__PURE__ */ jsx282("path", {
          fill: "#fc0",
          fillRule: "evenodd",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.1,
          d: "M515.4 232.8c.6-.7 1.7-1.4 2.3-1l.6.6c.2.3.2.5 0 .8-.3.8-1.4.4-2 0-.2 0-.6-.4-.8-.3l-.3.1.3.1 1.8.9c.5.2 1.5-.5 1.4-1 0-.5-.9-1.5-1.3-1.5-1 0-1.8.6-2.5 1.4.2-.2.4 0 .5 0z"
        }),
        /* @__PURE__ */ jsx282("path", {
          fill: "#fc0",
          fillRule: "evenodd",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.1,
          d: "M514.9 232.8c-.6-.7-1.7-1.4-2.2-1l-.6.6c-.3.3-.3.5-.1.8.3.8 1.4.4 2 0 .2 0 .6-.4.8-.3l.4.1-.4.1-1.8.9c-.5.2-1.4-.5-1.4-1 0-.6 1-1.5 1.4-1.5 1 0 1.7.6 2.4 1.4-.1-.2-.4 0-.5 0z"
        }),
        /* @__PURE__ */ jsx282("path", {
          fill: "#fc0",
          fillRule: "evenodd",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.1,
          d: "M515 232.4c-.2-.1-.5.1-.6.3 0 .2.1.6.4.6.3.2.8 0 .9-.3 0-.4-.3-.5-.6-.6z"
        }),
        /* @__PURE__ */ jsx282("path", {
          fill: "#fc0",
          fillRule: "evenodd",
          d: "M515 226.3s.4 2.4 1.6 4c1.2 1.8-1.4 1.6-1.6 2.2 0 0-.8-1.7-1.6-2.2 0 0 1.3-2 1.6-4"
        }),
        /* @__PURE__ */ jsx282("path", {
          fill: "none",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.1,
          d: "M515 226.3s.4 2.4 1.6 4c0 0-1.4 1.6-1.6 2.2 0 0-.8-1.7-1.6-2.2 0 0 1.3-2 1.6-4"
        }),
        /* @__PURE__ */ jsx282("path", {
          fill: "none",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.1,
          d: "m515 228.8.7 1.8s-.6.4-.7.7c0 0-.3-.8-.6-1 0 0 .6-.8.6-1.5z"
        }),
        /* @__PURE__ */ jsx282("path", {
          fill: "#fff",
          fillRule: "evenodd",
          d: "m515 344.5-.3-.2c-.4-.2-1.2-.2-1.3-.5-1-1.1-.4-3.4 0-4.8 1-2.6 1-5 1.6-7.4.6 2.4.7 4.8 1.6 7.4.4 1.4 1.1 3.7.1 4.8-.2.3-.9.3-1.3.5z"
        }),
        /* @__PURE__ */ jsx282("path", {
          fill: "#00209f",
          fillRule: "evenodd",
          d: "M515 331.5c.6 2.5.7 5 1.6 7.6.4 1.3 1 3.4.3 4.5.4 0 .7-.1 1-.3.2 0 .3 0 .4-.2l.4-.5c.3-.2.6 0 .9-.2l.1-.2c.6-.3 1-.6 1.3-1.1.1-.4.2-.9 0-1.3 0-.3 0-.5-.2-.8l-.5-1.1-.6-1.2a2.4 2.4 0 0 0-.3-.5l-.3-.6-.4-.4-.4-.3s-.3-.1-.2-.2l-.3-.1-1-2a3 3 0 0 1-.2-1.1zm0 0c-.5 2.5-.7 5-1.6 7.6-.3 1.3-1 3.4-.2 4.5-.4 0-.7-.1-1.1-.3-.1 0-.3 0-.3-.2a1.4 1.4 0 0 0-.5-.5c-.2-.2-.5 0-.8-.2l-.2-.2c-.5-.3-1-.6-1.2-1.1a2.5 2.5 0 0 1-.1-1.3l.2-.8.6-1.1.6-1.2c0-.2.1-.4.3-.5l.3-.6.4-.4.4-.3.2-.2.2-.1 1-2c.2-.2.2-.8.2-1.1z"
        }),
        /* @__PURE__ */ jsxs257("g", {
          id: "sv_svg__b",
          fill: "none",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.2,
          children: [
            /* @__PURE__ */ jsx282("path", {
              stroke: "#011322",
              d: "M514.3 331.6s-1 4-1.6 5c-.6 1.1-3 3-1.4 6"
            }),
            /* @__PURE__ */ jsx282("path", {
              stroke: "#011d33",
              d: "M514.4 331.6s-1 4-1.6 5.1c-.6 1.1-3 3-1.4 6"
            }),
            /* @__PURE__ */ jsx282("path", {
              stroke: "#022743",
              d: "M514.5 331.6s-1 4.1-1.6 5.2c-.6 1-2.9 3.1-1.3 6"
            }),
            /* @__PURE__ */ jsx282("path", {
              stroke: "#033054",
              d: "M514.6 331.6s-1 4.2-1.6 5.3c-.6 1-2.9 3-1.2 6.1"
            }),
            /* @__PURE__ */ jsx282("path", {
              stroke: "#053a65",
              d: "M514.7 331.6s-1 4.3-1.6 5.3c-.6 1-2.8 3.2-1.2 6.3"
            }),
            /* @__PURE__ */ jsx282("path", {
              stroke: "#011d33",
              d: "M514.2 331.6s-1 4-1.6 5c-.6 1.1-3 3-1.4 6"
            }),
            /* @__PURE__ */ jsx282("path", {
              stroke: "#022743",
              d: "M514 331.6s-.9 3.8-1.6 5c-.6 1-3 3-1.4 5.9"
            }),
            /* @__PURE__ */ jsx282("path", {
              stroke: "#033054",
              d: "M514 331.6s-1 3.7-1.7 5c-.5 1-3 3-1.4 5.9"
            }),
            /* @__PURE__ */ jsx282("path", {
              stroke: "#053a65",
              d: "M513.8 331.6s-.8 3.6-1.6 5c-.6 1-3 3-1.4 5.9"
            }),
            /* @__PURE__ */ jsx282("path", {
              stroke: "#00209f",
              d: "M513.8 331.6s-.9 3.4-1.7 5c-.6 1-3 2.9-1.4 5.8"
            }),
            /* @__PURE__ */ jsx282("path", {
              stroke: "#00209f",
              d: "M514.8 331.6s-1 4.3-1.6 5.4c-.6 1-2.8 3.3-1.1 6.3"
            })
          ]
        }),
        /* @__PURE__ */ jsx282("use", {
          xlinkHref: "#sv_svg__b",
          width: "100%",
          height: "100%",
          transform: "matrix(-1 0 0 1 1030 0)"
        }),
        /* @__PURE__ */ jsx282("path", {
          fill: "none",
          stroke: "#000",
          strokeMiterlimit: 2.6,
          strokeWidth: 0.2,
          d: "m518.6 335.2.5.5.3.5.3.5.6 1.2.5 1.1.3.8a2.5 2.5 0 0 1-.1 1.3c-.2.5-.8.8-1.3 1.1l-.1.2c-.3.2-.6 0-.9.2a1.9 1.9 0 0 0-.4.5l-.3.2c-.4.2-.7.3-1.1.3l-.2.3c-.2.2-1 .2-1.3.4l-.4.2-.3-.2c-.4-.2-1.2-.2-1.3-.4a.7.7 0 0 1-.2-.3l-1.2-.3s-.2 0-.3-.2a1.4 1.4 0 0 0-.4-.5c-.3-.2-.6 0-.8-.2l-.2-.2c-.6-.3-1-.6-1.2-1.1a2.5 2.5 0 0 1-.1-1.3l.2-.8.5-1.1.7-1.2c0-.2.1-.4.3-.5 0-.2.1-.4.3-.5 0-.2.3-.3.4-.5"
        }),
        /* @__PURE__ */ jsxs257("g", {
          id: "sv_svg__c",
          children: [
            /* @__PURE__ */ jsxs257("g", {
              fillRule: "evenodd",
              children: [
                /* @__PURE__ */ jsx282("path", {
                  fill: "#fff",
                  d: "M487.4 293.6c-1.5-3.7-3-11.3-3-13 .3-7.1.2-9.3.9-16.5l7.3 8.3c-.2 2.8-.2 3.7 0 5.5.1.7.5 3.9 1 5.1z"
                }),
                /* @__PURE__ */ jsx282("path", {
                  fill: "#00209f",
                  d: "M493.6 283c-.5-1.3-.9-4.5-1-5.1-.2-1.8-.2-2.7 0-5.5l4.5 5zm-18.6 7a75.6 75.6 0 0 1-.3-4.4c0-5.1-.6-8 0-13.4.4-4.2 1.5-9.8 1.3-14.4-.1-1.3.1-2.6.2-3.9l9 10.1c-.6 7.3-.5 9.5-.8 16.6 0 1.7 1.5 9.3 3 13l-2 3.2zm6.3 13.7c-.6-1-1-3.9-1.2-4.5-.3-1.5-.3-2.3-.2-5l5 3.3zm-14.3 24a5.2 5.2 0 0 1-1.8-2.2c-.7-1.8-.5-1.7-1-3.6-.2-1.1-.2-2.3-.5-3.4-.2-1.2-1.8-4.8-1.8-6.2-.2-4.8-1.8-8-1.4-13.2.3-4 1.2-9.4.7-13.5l.1-3.6 10.3 6.7c-.4 6.8-.2 8.8-.2 15.4 0 1.6 1.3 8.1 3 11zm17 3.8c1.9 1.7 5.4 2.6 6 3 1.2 1 3 2.3 6.3 2.4 2.3.2 3.3-.4 5.7-.7 2.8-.3-.3.1 2.3-.5 1.4-.3 1.4-.5 3.2-1 1.3-.3 2.7-.6 3.5-1.8.3-.4.6-.7.6-1.4h1.8c.2.5-.3 1.5-.5 1.8l-.5.7c-.2.6-.2.4-.7.9l-.8.6c-.4.3-.7.6-1.1.7-1.8.3-2.5.7-4.2 1.1-1.6.5-.7.4-2 .7l-2.4.7-2.4.6c-2.9.7-5.7.5-8.6.3-1.1 0-4-.7-5-1.4-1.8-1.2-5.7-1.7-7.4-2.9-.3-.2-1.4-.7-1.6-1-1.7-1.3-3-1.7-4.8-2.8z"
                }),
                /* @__PURE__ */ jsx282("path", {
                  fill: "#00209f",
                  d: "M497.7 331.5h14c-.1.7-.4 1-.7 1.5-.8 1-2.2 1.4-3.5 1.7-1.4.4-2.9-.4-4.4-.4-3.7-1.1-4.1-2.3-5.4-2.8"
                }),
                /* @__PURE__ */ jsx282("path", {
                  fill: "#fff",
                  d: "M497.7 331.5c1.3.6 2 1.7 5.4 2.8 1.3 0 2.8.6 4 .6-1.5.3-1.5.5-2.8.8-2.6.6.5.2-2.3.5-2.4.3-3.4 1-5.7.8a11 11 0 0 1-6.3-2.5c-.6-.4-4.1-1.3-6-3z"
                })
              ]
            }),
            /* @__PURE__ */ jsxs257("g", {
              fill: "none",
              strokeMiterlimit: 2.6,
              strokeWidth: 0.2,
              children: [
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022743",
                  d: "M476.6 259.7s1.7 15 7.5 14.4"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022847",
                  d: "M484.2 274c-3 .2-4.9-3.5-6-7a46.3 46.3 0 0 1-1.5-7.3"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032b4c",
                  d: "M484.2 274c-3-.1-4.9-3.8-5.8-7a43.6 43.6 0 0 1-1.7-7.4"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032d4f",
                  d: "M484.2 274c-2.9-.3-4.9-4.1-5.8-7.2a48.2 48.2 0 0 1-1.7-7.2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032f53",
                  d: "M484.2 273.9c-2.9-.5-4.9-4.4-5.8-7.2a43 43 0 0 1-1.7-7.2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043258",
                  d: "M484.2 273.8c-3-.6-4.9-4.6-5.7-7.1-1.1-3.2-1.8-7.1-1.9-7.2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#04345b",
                  d: "M484.2 273.8c-2.9-.9-4.9-4.9-5.6-7.2a46 46 0 0 1-2-7.2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#04365e",
                  d: "M484.3 273.7c-3-1-5-5-5.7-7.3a48.7 48.7 0 0 1-1.9-7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043862",
                  d: "M484.3 273.7c-3-1.2-5-5.4-5.6-7.3a47.5 47.5 0 0 1-2-7.1"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053b67",
                  d: "M484.3 273.6c-3-1.3-5-5.6-5.6-7.3-1-2.8-2-6.8-2-7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053d6a",
                  d: "M484.3 273.6c-3-1.6-5-6-5.5-7.4a50.3 50.3 0 0 1-2.1-7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053f6e",
                  d: "M484.3 273.5c-3-1.7-5-6.2-5.4-7.4a45.7 45.7 0 0 1-2.2-7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#064172",
                  d: "M484.4 273.5c-3-2-5-6.4-5.5-7.5a66 66 0 0 1-2.2-7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#00209f",
                  d: "M476.7 259a47 47 0 0 0 2.3 6.9c.3.8 2.4 5.4 5.4 7.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022743",
                  d: "M476.9 256.3s4.8 12 8 10.6"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022a49",
                  d: "M484.8 266.9c-1.3.5-3.3-1.8-5-4.6a65.2 65.2 0 0 1-3-6"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032d4f",
                  d: "M484.8 266.8c-1.2.5-3.2-1.8-4.9-4.6a86 86 0 0 1-3-6"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#033054",
                  d: "M484.8 266.8c-1 .4-3.2-1.7-4.9-4.7a91.5 91.5 0 0 1-3-5.9"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043359",
                  d: "M484.8 266.8c-.8.3-3.1-1.7-4.8-4.8-2-3.4-3-5.8-3-5.8"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043760",
                  d: "M484.9 266.7c-.7.3-3.1-1.7-4.8-4.8l-3.1-5.8"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053a65",
                  d: "M484.9 266.7c-.6.3-3-1.7-4.8-4.9a749.5 749.5 0 0 0-3.2-5.8"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053d6a",
                  d: "M484.9 266.7c-.4.2-3-1.6-4.7-5a281 281 0 0 0-3.2-5.7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#064171",
                  d: "M484.9 266.7c-.2 0-2.9-1.6-4.7-5L477 256"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#00209f",
                  d: "M477 255.9s1 1.4 3.3 5.7a13.6 13.6 0 0 0 4.5 5m8 12.1 3.8-.7m-4-3.1 4.1 2.2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#064171",
                  d: "m492.5 275 4.2 2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053e6c",
                  d: "m492.5 275.2 4.2 2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053b67",
                  d: "m492.5 275.4 4.2 1.8"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043862",
                  d: "m492.6 275.6 4.2 1.6"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#04355c",
                  d: "m492.6 275.8 4.2 1.4"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043258",
                  d: "m492.6 276 4.3 1.2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032f53",
                  d: "m492.6 276.1 4.3 1.2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032c4d",
                  d: "m492.6 276.3 4.4 1"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022a49",
                  d: "m492.6 276.5 4.4.9"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#064171",
                  d: "m492.8 278.5 3.9-.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053e6c",
                  d: "m492.8 278.3 4-.4"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053b67",
                  d: "m492.8 278.1 4-.3"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043862",
                  d: "m492.8 278 4-.2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#04355c",
                  d: "M492.8 277.7h4"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043258",
                  d: "m492.8 277.5 4.1.2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032f53",
                  d: "m492.8 277.3 4.2.3"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032c4d",
                  d: "m492.7 277.1 4.3.4"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022a49",
                  d: "m492.7 276.9 4.4.6"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022743",
                  d: "m492.7 276.7 4.4.7m-22.1.4s.2 3.2.9 4.5c1 1.9 3.9 4.7 7.2 6.8"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022847",
                  d: "M483.2 289.1a27.2 27.2 0 0 1-5.5-4.6 13.7 13.7 0 0 1-1.7-2.3c-.7-1.4-1-4.5-1-4.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032b4c",
                  d: "M483.3 289.1a27.2 27.2 0 0 1-5.4-4.7 9.3 9.3 0 0 1-1.7-2.3c-.8-1.4-1.2-4.5-1.2-4.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032d4f",
                  d: "M483.3 289.1a31.3 31.3 0 0 1-5.3-4.7 12 12 0 0 1-1.7-2.4c-.8-1.5-1.3-4.5-1.3-4.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032f53",
                  d: "M483.4 289a31.3 31.3 0 0 1-5.3-4.7 13.6 13.6 0 0 1-1.7-2.4c-.8-1.5-1.4-4.4-1.4-4.4"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043258",
                  d: "M483.5 289c-2.1-1.3-4-3.5-5.3-4.8a10 10 0 0 1-1.6-2.4c-1-1.5-1.6-4.4-1.6-4.4"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#04345b",
                  d: "M483.6 289c-2.1-1.4-4-3.6-5.3-4.9a15.1 15.1 0 0 1-1.6-2.3 21.4 21.4 0 0 1-1.7-4.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#04365e",
                  d: "M483.6 289c-2-1.4-4-3.7-5.1-5a14 14 0 0 1-1.7-2.3c-1-1.7-1.8-4.5-1.8-4.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043862",
                  d: "M483.7 289c-2-1.4-4-3.8-5.1-5a15 15 0 0 1-1.6-2.4 26 26 0 0 1-2-4.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053b67",
                  d: "M483.8 289c-2-1.5-4-4-5-5.1a13.8 13.8 0 0 1-1.7-2.4c-1.1-1.8-2-4.5-2-4.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053d6a",
                  d: "M483.9 289c-2-1.5-4-4-5-5.2a16.8 16.8 0 0 1-1.7-2.4c-1-1.8-2.1-4.5-2.1-4.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053f6e",
                  d: "M484 289c-2-1.5-4-4.2-5-5.3a18.7 18.7 0 0 1-1.7-2.4l-2.2-4.4"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#064172",
                  d: "M484 289c-2-1.6-3.9-4.3-4.9-5.4a16.1 16.1 0 0 1-1.6-2.4l-2.4-4.4"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#00209f",
                  d: "M475 276.7s3 5.3 4.3 6.8c1 1 2.8 4 4.8 5.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#011d33",
                  d: "m475.2 290 10.2 6.6 2-3-1-2.7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#011e34",
                  d: "m475.2 289.9 10.2 6.5h.1l1.7-3s0-.3-.3-.7l-.6-1.7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022037",
                  d: "M475.2 289.9c2.9 1.9 4.1 2.7 10.2 6.4l.1-.1 1.6-2.9-.2-.7a18.1 18.1 0 0 1-.6-1.6"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022139",
                  d: "M475.2 289.9c2.8 1.8 4.3 2.8 10.2 6.3l.1-.1 1.5-2.9-.2-.7-.5-1.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#02223b",
                  d: "M475.2 289.8c2.7 1.8 4.5 2.9 10.2 6.3l.1-.2 1.4-2.8-.1-.7a8.2 8.2 0 0 1-.5-1.4"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#02233d",
                  d: "M475.3 289.8c2.5 1.7 4.6 3 10.1 6.1h.1c0-.3 1.3-2.9 1.3-3l-.1-.5a9.6 9.6 0 0 1-.4-1.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022540",
                  d: "M475.3 289.8c2.4 1.6 4.7 3 10.2 6v-.1l1.2-2.8v-.6a5 5 0 0 1-.4-1.3"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022541",
                  d: "M475.3 289.8c2.3 1.6 5 3 10.2 5.9v-.2l1.1-2.8v-.5a4.8 4.8 0 0 1-.4-1.3"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022743",
                  d: "M475.3 289.8a110 110 0 0 0 10.2 5.8v-.2l1-2.8v-.5a4.1 4.1 0 0 1-.3-1.2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022847",
                  d: "M475.3 289.7a92.6 92.6 0 0 0 10.2 5.8v-.2c0-.3 1-2.8 1-2.8v-.5c-.3-.3-.3-.7-.3-1"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022a49",
                  d: "M475.3 289.7a80.5 80.5 0 0 0 10.2 5.6.3.3 0 0 0 0-.1c0-.4.8-2.8.8-2.8s.2-.1 0-.4v-1"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032a4a",
                  d: "M475.3 289.7a80 80 0 0 0 10.2 5.5v-.2l.7-2.7s.2-.1 0-.4v-1"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032b4c",
                  d: "M475.4 289.7a67.8 67.8 0 0 0 10 5.4l.2-.2.5-2.7s.2-.1.1-.4c-.1-.3 0-.5 0-.8"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032d4f",
                  d: "M475.4 289.7a62.4 62.4 0 0 0 10 5.3l.2-.2.4-2.8s.3 0 .2-.3c-.2-.3 0-.4 0-.7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032e50",
                  d: "M475.4 289.7c1.7 1 6 3.6 10.1 5.2v-.2l.4-2.7s.3 0 .2-.3c-.1-.3 0-.3.1-.7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032f53",
                  d: "M475.4 289.6a54.3 54.3 0 0 0 10.1 5.1.5.5 0 0 0 0-.2l.3-2.7.2-.2c-.1-.3 0-.3.2-.6"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#033156",
                  d: "M475.4 289.6c1.5 1 6.3 3.8 10.1 5a.5.5 0 0 0 0-.2l.2-2.7s.4 0 .3-.2c-.2-.3 0-.2.1-.6"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043258",
                  d: "M475.4 289.6a45 45 0 0 0 10.1 4.9l.1-.2v-2.7s.4 0 .3-.2c-.1-.2.1-.1.3-.4"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043359",
                  d: "M475.4 289.6c1.3.9 6.7 4 10.1 4.7l.1-.2-.1-2.6s.4 0 .3-.1c0-.3.2-.1.3-.4"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#04355c",
                  d: "M475.4 289.6c1.2.8 6.8 4 10.1 4.6l.1-.2-.3-2.6.5-.1c-.1-.3.2 0 .3-.4"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#04365e",
                  d: "M475.4 289.6c1.1.7 7 4 10.1 4.5l.1-.2c0-.7-.3-2.6-.4-2.6h.5c0-.3.2 0 .4-.3"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043760",
                  d: "M475.4 289.6c1 .6 7.2 4.1 10.1 4.4l.1-.3c0-.6-.4-2.5-.5-2.6 0 0 .6.2.5 0 0-.1.3.2.5-.1"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043862",
                  d: "M475.4 289.6c1 .5 7.3 4.2 10.1 4.3l.2-.3a12.5 12.5 0 0 0-.7-2.6s.6.2.5 0c0-.1.4.3.6 0"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053a65",
                  d: "M475.5 289.5c.8.5 7.4 4.3 10 4.2l.2-.2c0-.8-.7-2.6-.8-2.6s.6.2.6 0c0 0 .3.4.6 0"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053b67",
                  d: "M475.5 289.5c.7.5 7.6 4.4 10 4.1l.2-.3c0-.7-.8-2.4-.9-2.5l.6.1c0-.1.5.3.7 0"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053c68",
                  d: "M475.5 289.5c.6.4 7.8 4.4 10 4l.2-.3a6 6 0 0 0-1-2.5l.7.1c0-.1.4.4.7.1"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053e6c",
                  d: "M475.5 289.5c.5.3 8 4.5 10 3.9a.5.5 0 0 0 .2-.3c0-.8-1-2.5-1.1-2.5l.7.1s.5.6.8.3"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053f6e",
                  d: "M475.5 289.5c.4.2 8 4.6 10 3.8l.2-.4c0-.8-1.1-2.4-1.2-2.5l.7.3s.6.6.9.2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053f6f",
                  d: "M475.5 289.5c.3.2 8.2 4.6 10 3.6l.2-.3c0-.9-1.2-2.4-1.3-2.5l.7.3s.6.6 1 .4"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#064171",
                  d: "M475.5 289.4c.2.2 8.4 4.8 10 3.6a.7.7 0 0 0 .2-.3c0-1-1.3-2.4-1.4-2.5l.8.3s.6.7 1 .4"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#064374",
                  d: "M475.5 289.4c.1 0 8.6 4.9 10 3.5l.2-.3c0-1-1.4-2.4-1.6-2.5l1 .3s.6.8 1 .6"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#00209f",
                  d: "M475.6 289.4s9.7 5.5 10.1 3c0-1-1.6-2.4-1.6-2.4l.9.3s.6 1 1 .6"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#011d33",
                  d: "m474.4 315.1-7.5 12.6a5.2 5.2 0 0 1-1.8-2.2c-.6-1.7-.5-1.7-1-3.6l-.4-3.4c-.3-1.2-1.9-4.8-2-6.2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#011d33",
                  d: "M461.8 312.3c0 1.4 1.6 5 1.9 6 .2 1.2.2 2.4.5 3.5.4 1.9.3 1.8 1 3.6a5.2 5.2 0 0 0 1.7 2.2l7.5-12.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#011e34",
                  d: "M461.8 312.3c0 1.4 1.6 5 1.8 6 .3 1.2.3 2.3.6 3.4.4 1.8.3 1.8 1 3.6.2.8 1.2 1.8 1.7 2.1l7.5-12.3"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#011e34",
                  d: "M461.8 312.3c0 1.4 1.6 4.9 1.8 6 .3 1 .3 2.2.6 3.3.4 1.8.3 1.8 1 3.5a5.5 5.5 0 0 0 1.7 2.2l7.5-12.2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#011f36",
                  d: "M461.8 312.3c0 1.3 1.6 4.8 1.8 5.9.3 1.1.3 2.3.6 3.3.4 1.8.3 1.8 1 3.5a5.5 5.5 0 0 0 1.7 2.1l7.5-12"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#011f36",
                  d: "M461.8 312.3c0 1.3 1.6 4.8 1.8 5.9.3 1 .3 2.2.6 3.3.4 1.7.3 1.7 1 3.4.2.8 1.2 1.8 1.7 2.1l7.5-11.9"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022037",
                  d: "M461.8 312.3c0 1.3 1.5 4.7 1.8 5.8.3 1 .3 2.2.6 3.3.4 1.7.3 1.7 1 3.4.2.8 1.2 1.7 1.7 2 .2.1 7.4-11.6 7.5-11.7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022037",
                  d: "M461.8 312.3c0 1.3 1.5 4.6 1.8 5.7l.6 3.3c.4 1.7.4 1.7 1 3.3.2.8 1.2 1.8 1.7 2.1.2 0 7.3-11.5 7.5-11.6"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022139",
                  d: "M461.8 312.3c0 1.3 1.5 4.6 1.8 5.7.3 1 .3 2.2.6 3.2.4 1.7.4 1.7 1 3.3.3.8 1.2 1.7 1.7 2 .2.1 7.3-11.3 7.5-11.4"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022139",
                  d: "M461.8 312.3c0 1.3 1.5 4.6 1.8 5.6.3 1 .3 2.2.6 3.2.4 1.7.4 1.7 1 3.3a5.4 5.4 0 0 0 1.7 2c.3 0 7.3-11.2 7.5-11.3"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022139",
                  d: "M461.8 312.3c0 1.3 1.5 4.5 1.8 5.6.3 1 .3 2 .6 3.1.5 1.7.4 1.7 1 3.3.3.8 1.2 1.7 1.7 2 .3 0 7.2-11 7.5-11.2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#02223b",
                  d: "M461.8 312.3c0 1.3 1.5 4.4 1.8 5.5.3 1 .3 2.1.6 3 .5 1.8.4 1.8 1 3.3a5 5 0 0 0 1.7 2c.3.1 7.2-10.9 7.5-11"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#02223b",
                  d: "M461.8 312.3c0 1.2 1.5 4.4 1.8 5.4.3 1 .3 2.2.6 3.1.5 1.7.4 1.7 1 3.2a5.2 5.2 0 0 0 1.7 2c.3.1 7.2-10.8 7.5-10.9"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#02233d",
                  d: "M461.8 312.3c0 1.2 1.5 4.3 1.8 5.4l.6 3c.5 1.7.4 1.7 1 3.2a5.1 5.1 0 0 0 1.8 2c.3 0 7-10.6 7.4-10.8"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#02233d",
                  d: "M461.8 312.3c0 1.2 1.4 4.3 1.8 5.3l.6 3 1 3.2a7 7 0 0 0 1.8 2c.3 0 7-10.6 7.4-10.7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#02233e",
                  d: "M461.8 312.3c0 1.2 1.4 4.3 1.8 5.3l.6 3 1 3a6 6 0 0 0 1.8 2c.3.1 7-10.3 7.4-10.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#02233e",
                  d: "M461.8 312.3c0 1.1 1.4 4.2 1.8 5.2l.6 3 1 3a5 5 0 0 0 1.8 2c.4 0 7-10.3 7.4-10.4"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022540",
                  d: "M461.8 312.2c0 1.2 1.4 4.2 1.8 5.3l.6 2.9 1 3a5.2 5.2 0 0 0 1.8 2c.4 0 7-10.1 7.4-10.3"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022540",
                  d: "M461.8 312.2c0 1.2 1.4 4.2 1.8 5.2l.6 2.9 1 3c.4.7 1.3 1.5 1.8 1.8.4.2 7-9.8 7.4-10"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022540",
                  d: "M461.8 312.2c0 1.2 1.4 4.1 1.8 5.1l.7 2.9c.4 1.5.4 1.6 1 3a5 5 0 0 0 1.7 1.8c.4.1 7-9.7 7.4-9.9"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022541",
                  d: "M461.8 312.2c0 1.2 1.4 4 1.8 5l.7 3 1 2.9a5.2 5.2 0 0 0 1.7 1.8c.4.1 6.9-9.6 7.4-9.8"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022541",
                  d: "M461.8 312.2c0 1.1 1.4 4 1.8 5l.7 2.8 1 3c.3.6 1.2 1.5 1.7 1.8.5 0 6.9-9.5 7.4-9.7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022743",
                  d: "M461.8 312.2c0 1.1 1.4 4 1.8 5l.7 2.7c.4 1.5.5 1.5 1 2.9a6 6 0 0 0 1.7 1.8c.5.1 6.8-9.3 7.4-9.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022743",
                  d: "M461.8 312.2c0 1.1 1.4 4 1.8 5l.7 2.6 1 3a5 5 0 0 0 1.7 1.6c.5.2 6.8-9 7.4-9.3"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022845",
                  d: "M461.8 312.2c0 1.1 1.4 3.9 1.8 4.8l.7 2.8 1 2.8a4.9 4.9 0 0 0 1.7 1.7c.6.2 6.8-9 7.4-9.2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022845",
                  d: "M461.8 312.2c0 1.1 1.4 3.8 1.8 4.8l.7 2.7c.4 1.4.5 1.4 1 2.7a5.3 5.3 0 0 0 1.7 1.8c.6.2 6.7-8.9 7.4-9"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022847",
                  d: "M461.8 312.2c0 1 1.3 3.7 1.8 4.7l.7 2.7 1 2.7a4.8 4.8 0 0 0 1.7 1.7c.6.2 6.7-8.7 7.4-8.9"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022847",
                  d: "M461.8 312.2c0 1 1.3 3.7 1.8 4.6l.7 2.7 1.1 2.7a5 5 0 0 0 1.6 1.7c.7.2 6.7-8.6 7.4-8.8"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022847",
                  d: "M461.8 312.2c0 1 1.3 3.7 1.8 4.6l.7 2.6 1.1 2.7a5 5 0 0 0 1.6 1.7c.7.1 6.7-8.4 7.4-8.7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022a49",
                  d: "M461.8 312.2c0 1 1.3 3.6 1.8 4.6l.7 2.5 1.1 2.7c.4.6 1.1 1.3 1.7 1.6.6.2 6.6-8.2 7.3-8.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022a49",
                  d: "M461.8 312.2c0 1 1.3 3.5 1.8 4.5l.7 2.5 1.1 2.6c.4.6 1.1 1.4 1.7 1.6.7.3 6.5-8 7.3-8.3"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032a4a",
                  d: "M461.8 312.2c0 1 1.3 3.5 1.8 4.4l.7 2.5c.5 1.3.5 1.4 1.2 2.6.3.6 1 1.4 1.6 1.6.7.2 6.5-8 7.3-8.2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032a4a",
                  d: "M461.8 312.2c0 1 1.3 3.4 1.7 4.4l.8 2.4 1.2 2.6a5 5 0 0 0 1.6 1.6c.7.2 6.5-7.8 7.3-8.1"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032b4c",
                  d: "M461.8 312.2c0 1 1.2 3.4 1.7 4.3.4.8.5 1.7.8 2.4l1.2 2.6c.3.6 1 1.2 1.6 1.5.7.3 6.4-7.6 7.3-8"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032b4c",
                  d: "M461.8 312.2c0 1 1.2 3.3 1.7 4.3.4.7.5 1.6.8 2.3l1.2 2.6c.3.5 1 1.2 1.6 1.5.8.2 6.4-7.5 7.3-7.8"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032c4d",
                  d: "M461.8 312.2c0 1 1.2 3.3 1.7 4.2.4.8.5 1.6.8 2.4l1.2 2.4c.3.6 1 1.3 1.6 1.6.8.2 6.4-7.4 7.3-7.7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032c4d",
                  d: "M461.8 312.2c0 .9 1.2 3.2 1.7 4.1l.9 2.4c.4 1.2.5 1.3 1.1 2.4a5.2 5.2 0 0 0 1.6 1.5c.8.3 6.3-7.2 7.3-7.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032c4d",
                  d: "M461.8 312.2a13 13 0 0 0 1.7 4l.9 2.4c.4 1.2.5 1.2 1.1 2.4a4.7 4.7 0 0 0 1.6 1.4c.9.4 6.3-7 7.3-7.3"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032d4f",
                  d: "M461.8 312.2c0 .9 1.2 3.1 1.7 4 .4.8.5 1.6.9 2.3.4 1.2.5 1.3 1.1 2.3.3.6 1 1.3 1.6 1.5.9.3 6.3-6.8 7.3-7.2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032d4f",
                  d: "M461.8 312.2c0 .8 1.2 3 1.7 4 .4.7.5 1.5.9 2.2.4 1.2.6 1.2 1.1 2.4a5 5 0 0 0 1.6 1.4c1 .3 6.3-6.7 7.3-7.1"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032e50",
                  d: "M461.8 312.2c0 .8 1.2 3 1.7 4 .4.6.5 1.4.9 2.1.4 1.2.6 1.2 1.1 2.3a5.4 5.4 0 0 0 1.6 1.5c1 .2 6.3-6.6 7.3-7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032e50",
                  d: "M461.8 312.2c0 .8 1.1 3 1.7 3.8.4.8.5 1.5.9 2.2.4 1.2.6 1.3 1.1 2.3a4.8 4.8 0 0 0 1.6 1.4c1 .3 6.2-6.4 7.3-6.8"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032f53",
                  d: "M461.8 312.2c0 .8 1.1 3 1.7 3.8.4.7.5 1.5.9 2.1.4 1.1.6 1.2 1.2 2.3a5 5 0 0 0 1.5 1.4c1 .3 6.2-6.3 7.3-6.7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032f53",
                  d: "M461.8 312.2a11 11 0 0 0 1.7 3.7c.4.7.5 1.5.9 2.2l1.2 2.1a5 5 0 0 0 1.5 1.4c1 .3 6.2-6 7.3-6.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#033054",
                  d: "M461.8 312.2a12 12 0 0 0 1.7 3.7c.4.6.5 1.4.9 2l1.2 2.2a5.1 5.1 0 0 0 1.6 1.4c1 .3 6-6 7.2-6.4"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#033054",
                  d: "M461.8 312.2c0 .7 1 2.7 1.7 3.6.4.7.5 1.4 1 2l1 2.2a4.5 4.5 0 0 0 1.7 1.3c1 .4 6-5.8 7.2-6.2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#033054",
                  d: "M461.8 312.2c0 .7 1 2.7 1.7 3.6l1 2c.4 1 .6 1.1 1.1 2a5.4 5.4 0 0 0 1.6 1.4c1 .3 6-5.7 7.2-6.1"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#033156",
                  d: "M461.8 312.2c0 .7 1 2.7 1.7 3.5l1 2c.3 1 .6 1.1 1.1 2a5.4 5.4 0 0 0 1.5 1.4c1.1.3 6-5.6 7.3-6"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#033156",
                  d: "M461.8 312.2c0 .7 1 2.6 1.7 3.4l1 2c.3 1 .6 1.1 1.1 2a5.4 5.4 0 0 0 1.5 1.3c1.2.3 6-5.3 7.3-5.8"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043258",
                  d: "M461.8 312.2c0 .7 1 2.6 1.7 3.4l1 1.9c.3 1 .6 1 1.2 2 .3.5 1 1 1.4 1.3 1.2.3 6-5.2 7.3-5.7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043258",
                  d: "M461.8 312.2a8 8 0 0 0 1.7 3.3l1 2c.3.9.6 1 1.2 2 .3.4 1 1 1.4 1.1 1.2.4 6-5 7.3-5.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043359",
                  d: "M461.8 312.2c0 .6 1 2.4 1.7 3.3l1 1.8c.4 1 .6 1.1 1.2 2 .3.5 1 1 1.4 1.2 1.3.3 6-5 7.3-5.4"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043359",
                  d: "M461.8 312.2c0 .6 1 2.4 1.7 3.2l1 1.9c.4.8.6 1 1.2 1.8.4.5 1 1 1.5 1.2 1.2.4 5.8-4.7 7.2-5.2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#04345b",
                  d: "M461.8 312.2c0 .6 1 2.4 1.7 3.1l1 1.9c.4.9.7 1 1.2 1.8.4.5 1 1 1.5 1.2 1.2.4 5.8-4.6 7.2-5.1"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#04345b",
                  d: "M461.8 312.2c0 .6 1 2.3 1.7 3l1 1.9c.4.8.7 1 1.2 1.8.4.5 1 1 1.5 1.2 1.3.4 5.8-4.5 7.2-5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#04345b",
                  d: "M461.8 312.2c0 .6 1 2.2 1.7 3l1 1.8c.4.9.7 1 1.2 1.8.4.4 1 1 1.5 1.1 1.3.4 5.8-4.3 7.2-4.8"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#04355c",
                  d: "M461.8 312.2c0 .5 1 2.2 1.7 3l1 1.7c.4.8.7 1 1.2 1.8.4.4 1 .9 1.5 1 1.3.5 5.7-4.1 7.2-4.6"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#04355c",
                  d: "M461.8 312.2c0 .5 1 2.1 1.7 3l1 1.6c.4.8.7 1 1.3 1.7.3.5 1 1 1.4 1.1 1.3.5 5.7-4 7.2-4.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#04365e",
                  d: "M461.8 312.2c0 .5 1 2.1 1.7 2.9l1 1.6c.4.9.7 1 1.3 1.7.3.5 1 .9 1.4 1.1 1.4.4 5.7-3.9 7.2-4.4"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#04365e",
                  d: "M461.8 312.2c0 .5 1 2 1.7 2.8l1 1.6c.4.8.7 1 1.3 1.7.3.4 1 .9 1.4 1 1.4.5 5.6-3.7 7.2-4.2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043760",
                  d: "M461.8 312.2c0 .5 1 2 1.7 2.8l1 1.5c.4.8.7 1 1.3 1.7.3.4 1 .8 1.4 1 1.4.4 5.6-3.6 7.2-4.1"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043760",
                  d: "M461.8 312.2c0 .5 1 2 1.7 2.7l1 1.6c.4.7.7.8 1.3 1.6.3.4 1 .8 1.4 1 1.5.4 5.6-3.5 7.2-4"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043862",
                  d: "M461.8 312.2c0 .5 1 1.9 1.7 2.6l1 1.6c.4.7.7.9 1.3 1.5.3.4 1 .8 1.4 1 1.5.5 5.5-3.3 7.2-3.9"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043862",
                  d: "M461.8 312.2c0 .4 1 1.8 1.7 2.6l1 1.5c.4.7.7.9 1.3 1.5l1.4 1c1.5.4 5.5-3.2 7.2-3.8"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043862",
                  d: "M461.8 312.2c0 .4.9 1.8 1.7 2.5l1 1.5c.4.7.8.8 1.3 1.5l1.4 1c1.5.4 5.5-3 7.2-3.7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043963",
                  d: "M461.8 312.2c0 .4.9 1.7 1.7 2.4l1 1.5c.4.7.8.8 1.3 1.5l1.4.9c1.5.5 5.5-2.8 7.2-3.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043963",
                  d: "M461.8 312.2c0 .4.9 1.7 1.7 2.4l1 1.4c.4.7.8.8 1.3 1.5l1.4.9c1.6.5 5.5-2.7 7.2-3.4"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053a65",
                  d: "M461.8 312.2c0 .4.9 1.6 1.7 2.3l1 1.4 1.3 1.4 1.4 1c1.6.4 5.4-2.6 7.2-3.3"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053a65",
                  d: "M461.8 312.2c0 .3.8 1.6 1.7 2.3l1 1.3c.5.7.8.8 1.4 1.4.3.4.9.7 1.4.9 1.6.5 5.3-2.4 7.1-3"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053b67",
                  d: "M461.8 312.2c0 .3.8 1.5 1.7 2.2l1 1.3 1.4 1.4c.4.3.9.7 1.4.8 1.6.5 5.3-2.2 7.1-2.9"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053b67",
                  d: "M461.8 312.2c0 .3.8 1.5 1.7 2.1.3.5.6 1 1 1.3.5.7.8.8 1.4 1.4l1.4.8c1.6.5 5.2-2 7.1-2.8"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053c68",
                  d: "M461.8 312.2c0 .3.8 1.4 1.7 2.1l1 1.3 1.4 1.3c.4.3.9.6 1.4.7 1.7.6 5.2-1.9 7.1-2.6"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053c68",
                  d: "M461.8 312.2c0 .3.8 1.4 1.7 2l1 1.3 1.4 1.2 1.4.8c1.7.5 5.2-1.8 7.1-2.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053c68",
                  d: "M461.8 312.2a6 6 0 0 0 1.7 2l1 1.2 1.4 1.2a6 6 0 0 0 1.4.8c1.7.5 5.1-1.7 7.1-2.4"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053d6a",
                  d: "M461.8 312.2c0 .2.8 1.2 1.7 2l1 1 1.4 1.3a6 6 0 0 0 1.4.8c1.8.5 5.1-1.5 7.1-2.3"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053d6a",
                  d: "M461.8 312.2a6 6 0 0 0 1.7 1.9l1 1.1 1.4 1.1 1.4.8c1.8.5 5.1-1.3 7.1-2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053e6c",
                  d: "M461.8 312.2c0 .2.7 1.1 1.7 1.8l1 1.1c.5.5 1 .7 1.5 1.1l1.3.8c1.8.5 5.1-1.2 7.1-2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053e6c",
                  d: "M461.8 312.2c0 .2.7 1.1 1.6 1.8l1.1 1c.5.5 1 .7 1.5 1.1l1.3.7c1.8.6 5-1 7.1-1.8"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053f6e",
                  d: "M461.8 312.2c0 .1.7 1 1.6 1.7l1.1 1c.5.5 1 .7 1.5 1 .4.4.8.6 1.3.8 1.8.6 5-1 7.1-1.7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053f6e",
                  d: "M461.8 312.2c0 .1.7 1 1.6 1.6a14.2 14.2 0 0 0 1.2 1c.4.5.9.7 1.4 1 .4.3.9.6 1.3.7 1.9.6 5-.7 7.1-1.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053f6f",
                  d: "M461.8 312.2c0 .1.7 1 1.6 1.6l1.2 1 1.4 1 1.3.6c2 .5 5-.6 7.1-1.4"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053f6f",
                  d: "M461.8 312.2c0 .1.7.9 1.6 1.5l1.2 1 1.4 1 1.3.6c2 .5 5-.5 7.1-1.3"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053f6f",
                  d: "M461.8 312.2c0 .1.7.8 1.6 1.5l1.2.9 1.4 1 1.3.5c2 .6 5-.3 7.1-1"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#064171",
                  d: "M461.8 312.2s.7.8 1.6 1.4l1.2.9 1.5.9 1.2.6c2 .6 4.9-.2 7.1-1"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#064171",
                  d: "m461.8 312.2 1.6 1.4 1.2.8 1.5.9 1.3.5c2 .6 4.8 0 7-.8"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#064172",
                  d: "M461.8 312.2s.7.7 1.6 1.3l1.2.8 1.5.8 1.3.6c2 .6 4.7.2 7-.7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#064172",
                  d: "M461.8 312.1c0 .1.7.7 1.6 1.3l1.2.8 1.5.8 1.3.6c2 .6 4.7.3 7-.6"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#064374",
                  d: "M461.8 312.1c0 .1.6.7 1.6 1.3l1.2.7a12.7 12.7 0 0 0 2.8 1.3c2 .6 4.7.5 7-.4"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#064374",
                  d: "M461.8 312.1s.6.6 1.6 1.2l1.2.7a15.7 15.7 0 0 0 2.8 1.3c2 .6 4.7.6 7-.3"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#00209f",
                  d: "m461.8 312.1 1.6 1.2 1.2.7 1.5.6a12 12 0 0 0 8.3.4m-12.6-2.9s6.5 5.1 12.6 3"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022743",
                  d: "M461.6 292.2s1.2 8 1.7 9.3c.4 1 3 5.6 6.9 6.7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022a49",
                  d: "M461.6 292.2s1.3 8 1.8 9.2c.5 1 2.8 5.4 6.8 6.8"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032b4c",
                  d: "M461.6 292.1s1.4 8 1.9 9.2a14 14 0 0 0 6.7 6.9"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032e50",
                  d: "M461.6 292.1s1.5 8 2 9.1c.5 1 2.5 5 6.6 7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#033054",
                  d: "M461.6 292.1s1.6 7.9 2 9a15.2 15.2 0 0 0 6.7 7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043359",
                  d: "M461.6 292.1s1.6 7.8 2.2 9a15.8 15.8 0 0 0 6.5 7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#04355c",
                  d: "M461.6 292s1.7 7.8 2.3 9c.5 1.1 2 4.3 6.4 7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043760",
                  d: "M461.7 292s1.7 7.8 2.3 9c.5 1 1.9 4 6.3 7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053a65",
                  d: "M461.7 292s1.8 7.7 2.4 8.9c.5 1 1.7 3.8 6.2 7.1"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053c68",
                  d: "M461.7 292s1.9 7.7 2.5 8.8c.6 1.1 1.6 3.5 6.1 7.2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053f6e",
                  d: "M461.7 292s2 7.6 2.6 8.8c.5 1 1.4 3.2 6 7.2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#064172",
                  d: "M461.8 292s2 7.5 2.6 8.7c.6 1.1 1.3 3 6 7.2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#00209f",
                  d: "M461.8 292s2.1 7.5 2.7 8.6c.6 1.1 1.1 2.8 5.9 7.3"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022743",
                  d: "M462 287.2s1.1 11.4 9.3 14.6"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022a49",
                  d: "M462 287.2c.1 0 .5 3.7 2.2 7.2 1.3 2.8 3.5 5.9 7 7.4"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032b4c",
                  d: "M462.1 287.2s.5 3.8 2.2 7.2a15 15 0 0 0 7 7.4"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032e50",
                  d: "M462.1 287.2s.7 3.9 2.3 7.1c1.1 2.3 3.3 5.7 6.9 7.4"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#033054",
                  d: "M462.2 287.2s.7 4 2.3 7c1 2.2 3.2 5.7 6.8 7.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043359",
                  d: "M462.2 287.2c0 .1.8 4 2.4 7 1 2 3.1 5.6 6.7 7.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#04355c",
                  d: "M462.2 287.2c0 .1 1 4.2 2.5 7a18 18 0 0 0 6.6 7.4"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043760",
                  d: "M462.2 287.1c0 .3 1 4.4 2.6 7 .8 1.5 3 5.4 6.5 7.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053a65",
                  d: "M462.2 287.1a30 30 0 0 0 2.6 6.9c.8 1.4 3 5.4 6.5 7.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053c68",
                  d: "M462.3 287.1c0 .3 1.2 4.5 2.6 6.8.7 1.3 2.8 5.4 6.4 7.7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053f6e",
                  d: "M462.3 287.1a30 30 0 0 0 2.8 6.8c.6 1 2.6 5.2 6.2 7.6"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#064172",
                  d: "M462.3 287.1a31 31 0 0 0 2.9 6.7c.5.8 2.5 5.2 6 7.7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#00209f",
                  d: "M462.3 287.1c0 .3 1.6 4.9 3 6.6.4.7 2.4 5.2 6 7.8"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022743",
                  d: "M462.2 284s2.4 9.2 9 11.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022847",
                  d: "M462.2 284s.9 3.3 3 6.4c1.5 2.2 3.6 4.2 6 5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032a4a",
                  d: "M462.2 284s1 3.2 3 6.4c1.6 2.1 3.7 4.3 6 5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032c4d",
                  d: "M462.2 284s1 3.1 3.2 6.3c1.5 2.2 3.7 4.4 5.8 5.1"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032f53",
                  d: "M462.2 283.9s1 3.1 3.3 6.3a15 15 0 0 0 5.7 5.2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#033156",
                  d: "M462.2 283.9s1 3 3.3 6.2c1.7 2.3 4 4.7 5.7 5.3"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043359",
                  d: "M462.2 283.8s1 3 3.4 6.2a17 17 0 0 0 5.6 5.4"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#04355c",
                  d: "M462.2 283.8a27.1 27.1 0 0 0 9 11.6"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043760",
                  d: "M462.3 283.8s1 2.9 3.5 6.1a21 21 0 0 0 5.4 5.4"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043963",
                  d: "M462.3 283.8s1 2.8 3.5 6a23 23 0 0 0 5.4 5.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053b67",
                  d: "M462.3 283.7s1.1 2.8 3.6 6a28 28 0 0 0 5.3 5.6"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053e6c",
                  d: "M462.3 283.7s1.2 2.7 3.7 6a39 39 0 0 0 5.2 5.6"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053f6f",
                  d: "M462.3 283.7s1.2 2.7 3.8 5.9a44 44 0 0 0 5.1 5.7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#064172",
                  d: "M462.3 283.6s1.3 2.7 3.9 6c2 2.5 4.9 5.6 5 5.7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#00209f",
                  d: "M462.3 283.6s1.3 2.6 3.9 5.8c2.1 2.7 5 5.9 5 5.9m8.7 1.3 4.6.8m-4.1 2.6 4-1.7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#064171",
                  d: "m479.9 296.7 4.5.7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053e6c",
                  d: "m479.9 296.9 4.6.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053b67",
                  d: "m479.9 297 4.6.4"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043862",
                  d: "m479.9 297.2 4.7.3"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#04355c",
                  d: "M479.9 297.4h4.7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043258",
                  d: "M480 297.6h4.6"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032f53",
                  d: "m480 297.7 4.7-.2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032c4d",
                  d: "m480 297.9 4.7-.3"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022a49",
                  d: "m480 298 4.8-.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#064171",
                  d: "m480.3 299.8 4.2-1.6"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053e6c",
                  d: "m480.3 299.6 4.3-1.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053b67",
                  d: "m480.3 299.5 4.3-1.4"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043862",
                  d: "m480.3 299.3 4.3-1.3"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#04355c",
                  d: "m480.2 299.1 4.5-1.2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043258",
                  d: "m480.2 299 4.5-1.2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032f53",
                  d: "m480.2 298.7 4.6-.9"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032c4d",
                  d: "m480.1 298.6 4.7-.9"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022a49",
                  d: "m480.1 298.4 4.7-.7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022743",
                  d: "m480 298.2 4.9-.6"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032b4c",
                  d: "m484.2 331.6-2.6.2-9.9-.2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032e50",
                  d: "m484.3 331.6-2.7.3-9.8-.2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#033054",
                  d: "m484.3 331.6-2.8.4c-.5.1-9.6-.3-9.6-.3"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043359",
                  d: "m484.3 331.7-2.8.5c-.7.1-9.6-.5-9.6-.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#04355c",
                  d: "m484.3 331.7-3 .6c-.7.2-9.3-.5-9.3-.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043760",
                  d: "m484.3 331.7-3 .7c-.8.3-9.2-.6-9.2-.6"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053a65",
                  d: "m484.4 331.8-3.1.8c-1 .2-9.1-.7-9.1-.7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053c68",
                  d: "m484.4 331.8-3.1 1c-1.2.2-9-.8-9-.8"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053f6e",
                  d: "m484.4 331.9-3.2 1c-1.2.3-8.9-.9-8.9-.9"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#064172",
                  d: "M484.4 332s-1.8.7-3.2 1c-1.4.3-8.8-1-8.8-1"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#00209f",
                  d: "M472.5 332s7.1 1.4 8.6 1.1c1.5-.3 3.3-1.1 3.3-1.1"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022a49",
                  d: "m486 337 4.8.7 2.7-.2 2.2-.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032d4f",
                  d: "M485.8 337s4.7.7 5 .6l2.7-.1 2-.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#033054",
                  d: "M485.5 336.9s4.9.8 5.3.7l2.6-.2 2-.4"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043359",
                  d: "M485.3 336.7s4.9.9 5.6.8a56.9 56.9 0 0 1 2.5-.2l1.7-.3"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043760",
                  d: "M485 336.6s5 1 5.9.8l2.5-.2 1.5-.3"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053a65",
                  d: "M484.8 336.5s5.1 1 6.1.8l2.4-.2 1.4-.2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053d6a",
                  d: "M484.5 336.4s5.3 1 6.4.9c.7-.2 2-.3 2.4-.3a24.4 24.4 0 0 0 1.2-.2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#064171",
                  d: "M484.2 336.3s5.4 1.1 6.8.9c.7-.2 1.7-.3 2.2-.3h1.1"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022743",
                  d: "m486.3 337.2 4.4.6 2.9-.1 2.4-.6"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#00209f",
                  d: "M484 336.2s5.5 1.2 7 .9c1.5-.3 3-.3 3-.3m11.8 0 4.3-1.6c2.6-1 3-3.6 3-3.6"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#00209f",
                  d: "m505.5 336 3.1-1.3c3.8-1.4 3.4-3.2 3.4-3.2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053e6c",
                  d: "m505.2 336.1 3.4-1.3 1.8-.8c.5-.3 1.2-1 1.3-1.2.4-.5.4-1.3.4-1.3"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043862",
                  d: "m505 336.3 3.6-1.4 1.8-.7 1.4-1.2c.3-.5.4-1.5.4-1.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043258",
                  d: "m504.7 336.5 4-1.5 1.6-.7a6 6 0 0 0 1.5-1.2c.2-.3.5-1.6.5-1.6"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032c4d",
                  d: "m504.4 336.7 4.2-1.5 1.7-.7 1.6-1.3.6-1.6"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053e6c",
                  d: "m505.5 336.9 4.6-1.8c.8-.3 1.7-1 2-1.5.6-.9.9-2 .9-2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043862",
                  d: "m505.1 336.9 5-2c.6-.1 1.7-1 2-1.4.4-.6.7-2 .7-2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043258",
                  d: "m504.8 336.9 5.4-2a8.1 8.1 0 0 0 1.9-1.4c.3-.5.6-2 .6-2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032c4d",
                  d: "m504.5 336.9 5.7-2.1 1.8-1.4.7-1.8"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#022743",
                  d: "m504.2 336.9 6-2.3 1.7-1.2.6-1.8"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032b4c",
                  d: "m511.3 331.6-2.8.2-10.3-.2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#032e50",
                  d: "m511.3 331.6-2.8.3-10.2-.2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#033054",
                  d: "m511.3 331.6-2.9.4c-.5.1-10-.3-10-.3"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043359",
                  d: "m511.3 331.7-3 .5c-.6.1-9.8-.5-9.8-.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#04355c",
                  d: "m511.4 331.7-3 .6c-.9.2-9.8-.5-9.8-.5"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#043760",
                  d: "m511.4 331.7-3.1.7c-1 .3-9.7-.6-9.7-.6"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053a65",
                  d: "m511.4 331.8-3.2.8c-1 .2-9.5-.7-9.5-.7"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053c68",
                  d: "m511.4 331.8-3.3 1c-1.1.2-9.3-.8-9.3-.8"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#053f6e",
                  d: "m511.4 331.9-3.3 1c-1.3.2-9.2-.9-9.2-.9"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#064172",
                  d: "M511.4 332s-1.9.7-3.3 1c-1.5.3-9.2-1-9.2-1"
                }),
                /* @__PURE__ */ jsx282("path", {
                  stroke: "#00209f",
                  d: "M499 332s7.5 1.4 9 1.1c1.6-.3 3.5-1.1 3.5-1.1"
                })
              ]
            }),
            /* @__PURE__ */ jsx282("path", {
              fill: "none",
              stroke: "#000",
              strokeMiterlimit: 2.6,
              strokeWidth: 0.2,
              d: "M475 290a34 34 0 0 1-.2-3.3c0-5.2-.7-9-.1-14.5.4-4.2 1.5-9.8 1.3-14.4-.1-1.3.1-2.6.2-3.9l21 23.5M467 327.7a5.2 5.2 0 0 1-1.9-2.2c-.6-1.7-.4-1.7-.9-3.6-.2-1.1-.2-2.3-.5-3.4-.2-1.2-1.8-4.8-1.9-6.2-.1-4.8-1.7-8-1.3-13.1.3-4 1.2-9.5.7-13.6l.1-3.6 23.6 15.6m28.5 33.9c.2.5-.3 1.5-.5 1.9l-.5.6c-.2.6-.2.4-.7.9l-.8.6c-.4.3-.7.6-1.1.7-1.8.3-2.5.7-4.2 1.1-1.6.5-.8.4-2 .7l-2.4.7-2.4.6c-2.9.7-5.7.5-8.6.3-1.1 0-4-.7-5-1.4-1.8-1.2-5.7-1.7-7.4-2.9-.3-.2-1.4-.7-1.6-1-1.7-1.3-3-1.7-4.8-2.8"
            }),
            /* @__PURE__ */ jsxs257("g", {
              stroke: "#000",
              strokeMiterlimit: 2.6,
              strokeWidth: 0.1,
              children: [
                /* @__PURE__ */ jsx282("path", {
                  fill: "#fc0",
                  fillRule: "evenodd",
                  d: "m484.9 297.6.6-.8-24-15.6-.4.6zm-23.7-16.7c-.2-1 0-2.1.7-2.3 0 0 .5-.1.8 0 .4 0 .5 0 .7.4.3.8-.7 1.3-1.4 1.6-.2 0-.6.1-.7.3l-.1.4.3-.3 1.7-.7c.6-.3.7-1.4.3-1.7-.4-.4-1.8-.3-2 0-.7.7-.8 1.7-.6 2.7 0-.2.3-.1.3-.4z"
                }),
                /* @__PURE__ */ jsx282("path", {
                  fill: "#fc0",
                  fillRule: "evenodd",
                  d: "M460.8 281.3c-1 0-2.1.4-2.2 1v.9c0 .4.2.5.6.6.8.2 1.2-.8 1.4-1.6 0-.1 0-.6.2-.7l.4-.2-.3.3-.5 1.9c-.2.6-1.3.8-1.6.4-.5-.3-.6-1.7-.3-2 .7-.7 1.7-1 2.7-1-.2.1-.2.5-.4.4z"
                }),
                /* @__PURE__ */ jsx282("path", {
                  fill: "#fc0",
                  fillRule: "evenodd",
                  d: "M460.6 281c-.3 0-.3.4-.1.6 0 .2.5.3.6.2.4-.2.6-.6.4-1-.2-.3-.6 0-.9.1z"
                }),
                /* @__PURE__ */ jsx282("path", {
                  fill: "#fc0",
                  fillRule: "evenodd",
                  d: "M455.6 277.8s2.5 1 4.5 1c0 0 .1 1.8.5 2.3 0 0-1.8-.3-2.6 0 0 0-1.1-2.4-2.4-3.3z"
                }),
                /* @__PURE__ */ jsx282("path", {
                  fill: "none",
                  d: "M457.6 279s1 .4 1.8.4c0 0 0 .8.2 1 0 0-.7-.2-1 0 0 0-.4-1-1-1.4z"
                }),
                /* @__PURE__ */ jsx282("path", {
                  fill: "#fc0",
                  fillRule: "evenodd",
                  d: "m460.8 282.9.6-1.1c0-.2 0 1 .4 1 .5.8.7 2.3.7 2.7-.7.2-1.3.6-2.3.2-.3-.3 0-1 0-1.4.2-.3.3-1 .6-1.4z"
                }),
                /* @__PURE__ */ jsx282("path", {
                  fill: "none",
                  d: "M461.3 282.2v.6c0-.2.3.2.3.3.3.7.5 1.1.6 2.4m-.7-2.2c.2 1 .4 1 .4 2.4v-.1m-.5-1.4.2 1.4-.3.2"
                }),
                /* @__PURE__ */ jsx282("path", {
                  fill: "#fc0",
                  fillRule: "evenodd",
                  d: "m497.1 277.4.7-.6-21.4-23.7-.4.5z"
                }),
                /* @__PURE__ */ jsx282("path", {
                  fill: "#fc0",
                  fillRule: "evenodd",
                  d: "M476.6 253c0-.9.6-2 1.2-2l.9.1c.3.1.4.3.5.6.1.9-1 1.2-1.7 1.3l-.8.1-.2.3.3-.1c.6-.2 1.2-.2 2-.3.5-.1.9-1.3.6-1.6-.3-.5-1.6-.8-2-.5-.8.5-1 1.5-1.2 2.5 0-.2.4-.1.4-.3z"
                }),
                /* @__PURE__ */ jsx282("path", {
                  fill: "#fc0",
                  fillRule: "evenodd",
                  d: "M476.1 253.4c-.9-.3-2.1-.2-2.3.5l-.2.8c0 .4 0 .5.4.7.7.4 1.4-.5 1.7-1.2 0-.2.2-.6.4-.7h.4l-.3.2-1 1.7c-.2.5-1.4.5-1.7 0-.3-.4 0-1.7.3-2 .8-.6 1.8-.5 2.8-.2-.2 0-.3.3-.5.2z"
                }),
                /* @__PURE__ */ jsx282("path", {
                  fill: "#fc0",
                  fillRule: "evenodd",
                  d: "M476 253c-.3 0-.3.4-.3.6 0 .2.4.4.6.3.4-.1.7-.4.6-.8-.1-.4-.6-.2-.9-.1z"
                }),
                /* @__PURE__ */ jsx282("path", {
                  fill: "#fc0",
                  fillRule: "evenodd",
                  d: "M472 248.7s2 1.6 4 2c0 0-.3 1.9 0 2.4 0 0-1.7-.7-2.6-.5 0 0-.4-2.6-1.5-4z"
                }),
                /* @__PURE__ */ jsx282("path", {
                  fill: "none",
                  d: "M473.6 250.4s.8.6 1.6.9v.9s-.7-.3-1-.2c0 0-.2-1-.6-1.6z"
                }),
                /* @__PURE__ */ jsx282("path", {
                  fill: "#fc0",
                  fillRule: "evenodd",
                  d: "m475.7 254.9 1-1c0-.1-.4 1 0 1.3.4.8.1 2.3 0 2.7-.7 0-1.3.3-2-.4-.4-.3 0-.9.3-1.3 0-.3.4-1 .7-1.3z"
                }),
                /* @__PURE__ */ jsx282("path", {
                  fill: "none",
                  d: "M476.4 254.4v.5l.2.7v2.2m-.3-2.5c.2.9 0 1.6-.1 2.5m0-1c-.2.4-.2.6-.2 1h-.3"
                })
              ]
            })
          ]
        }),
        /* @__PURE__ */ jsx282("use", {
          xlinkHref: "#sv_svg__c",
          width: "100%",
          height: "100%",
          transform: "matrix(-1 0 0 1 1030 0)"
        })
      ]
    }),
    /* @__PURE__ */ jsx282("path", {
      fill: "#fc0",
      stroke: "#000",
      strokeMiterlimit: 2.6,
      strokeWidth: 0.3,
      d: "m319.3 197.9-40.2 67.3h80.5z"
    }),
    /* @__PURE__ */ jsx282("path", {
      fill: "#fff",
      stroke: "#fff",
      strokeMiterlimit: 2.6,
      strokeWidth: 0.1,
      d: "M319.3 202.3 283 263h72.7z"
    }),
    /* @__PURE__ */ jsx282("path", {
      fill: "#007e93",
      stroke: "#007e93",
      strokeMiterlimit: 2.6,
      strokeWidth: 0.2,
      d: "M293.8 245 283 263h72.7l-10.9-18z"
    }),
    /* @__PURE__ */ jsxs257("g", {
      fill: "none",
      strokeMiterlimit: 2.6,
      strokeWidth: 0.1,
      children: [
        /* @__PURE__ */ jsx282("path", {
          stroke: "#086aad",
          d: "M313 212.9a9 9 0 0 1 6.2-2.2h.2c2.3 0 4.7.6 6.3 2.2"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#0863aa",
          d: "M313 213a9 9 0 0 1 6.2-2.2h.2c2.4 0 4.8.5 6.3 2.2"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#095fa8",
          d: "M313 213a8.8 8.8 0 0 1 6.2-2.2h.2c2.4 0 4.9.6 6.4 2.3"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#0a58a5",
          d: "M312.9 213.1a8.7 8.7 0 0 1 6.3-2.2h.2c2.5 0 5 .6 6.5 2.3"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#0a52a2",
          d: "M312.8 213.2c1.6-1.7 4-2.3 6.5-2.3h.1c2.6 0 5 .7 6.5 2.4"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#0b4d9f",
          d: "M312.8 213.3c1.6-1.7 4-2.3 6.5-2.3h.2c2.5 0 5 .6 6.5 2.4"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#0c479d",
          d: "M312.7 213.4c1.6-1.8 4-2.4 6.6-2.4h.2c2.6 0 5 .7 6.6 2.5"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#270a7f",
          d: "M312.3 214c1.9-2 4.2-2.5 7-2.5h.2c3.1 0 5.7 1 7.3 3.2"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#241183",
          d: "M312.3 214c1.9-2 4.2-2.6 7-2.6h.2c3 0 5.6 1 7.2 3.2"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#221786",
          d: "M312.4 214c1.8-2 4.1-2.6 7-2.6 3 0 5.7 1 7.2 3"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#1f1f8a",
          d: "M312.4 213.8c1.8-1.9 4.2-2.5 6.9-2.5h.1c3 0 5.6 1 7.2 3"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#1a258d",
          d: "M312.5 213.7c1.7-1.8 4-2.4 6.8-2.4h.1c3 0 5.5.8 7 2.9"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#172d91",
          d: "M312.5 213.7c1.7-1.9 4.1-2.5 6.7-2.5h.2c2.9 0 5.4.8 7 2.8"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#143393",
          d: "M312.5 213.6c1.7-1.8 4-2.4 6.7-2.4h.2c2.8 0 5.3.7 7 2.7"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#113b97",
          d: "M312.6 213.5c1.6-1.8 4-2.4 6.6-2.4h.1c2.8 0 5.4.7 7 2.7"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#ff0a00",
          d: "M315.3 209a6.5 6.5 0 0 1 4-1.2c1.5 0 2.8.3 4 1"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#f10",
          d: "M315.3 209a6.6 6.6 0 0 1 4-1 7 7 0 0 1 4 1"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#ff1500",
          d: "M315.3 209a6.8 6.8 0 0 1 4-1c1.5 0 2.9.2 4 1"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#ff1a00",
          d: "M315.2 209.2a6.6 6.6 0 0 1 4.1-1.2c1.5 0 3 .3 4.1 1"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#ff2000",
          d: "M315.2 209.2a6.7 6.7 0 0 1 4.1-1.1c1.5 0 3 .3 4.1 1"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#ff2700",
          d: "M315.1 209.3a6.8 6.8 0 0 1 4.2-1.2c1.5 0 3 .3 4.2 1.1"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#ff2f00",
          d: "M315.1 209.4a6.9 6.9 0 0 1 4.2-1.2c1.5 0 3 .3 4.2 1"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#f30",
          d: "M315 209.4a6.8 6.8 0 0 1 4.3-1.1 7.7 7.7 0 0 1 4.3 1"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#ff3c00",
          d: "M315 209.5a6.9 6.9 0 0 1 4.3-1.2c1.6 0 3.1.3 4.3 1.1"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#ff4100",
          d: "M315 209.6a7 7 0 0 1 4.3-1.2 8 8 0 0 1 4.3 1.1"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#ff4600",
          d: "M315 209.7a7 7 0 0 1 4.3-1.3 8 8 0 0 1 4.4 1.2"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fff500",
          d: "M314 211.2a9.7 9.7 0 0 1 10.7 0"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#ffeb00",
          d: "M314.1 211.1a9 9 0 0 1 5.2-1.5c2 0 4 .5 5.3 1.6"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#ffe000",
          d: "M314.1 211a9 9 0 0 1 5.2-1.5c1.9 0 4 .5 5.3 1.6"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#ffd600",
          d: "M314.2 211a9 9 0 0 1 5.1-1.6c1.9 0 3.9.5 5.2 1.6"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#ffcf00",
          d: "M314.2 210.9a9 9 0 0 1 5.1-1.5 9 9 0 0 1 5.2 1.5"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#ffc400",
          d: "M314.3 210.8c1.3-1 3.3-1.5 5-1.5a8 8 0 0 1 5.1 1.5"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#ffba00",
          d: "M314.3 210.7c1.4-1 3.3-1.5 5-1.5s3.7.5 5 1.5"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#ffb000",
          d: "M314.4 210.6a8.4 8.4 0 0 1 5-1.4c1.7 0 3.6.4 5 1.4"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#ffa600",
          d: "M314.4 210.5a8.1 8.1 0 0 1 5-1.4 8 8 0 0 1 4.8 1.4"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#ff9c00",
          d: "M314.5 210.4a8 8 0 0 1 4.8-1.4c1.7 0 3.6.4 4.9 1.4"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#ff9100",
          d: "M314.6 210.3a8 8 0 0 1 4.7-1.4c1.7 0 3.5.5 4.8 1.4"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#ff8700",
          d: "M314.6 210.2a8 8 0 0 1 4.7-1.3c1.7 0 3.5.4 4.8 1.3"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#ff7d00",
          d: "M314.6 210.2a7.7 7.7 0 0 1 4.7-1.4c1.7 0 3.4.4 4.7 1.3"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#ff7500",
          d: "M314.7 210a7.6 7.6 0 0 1 4.6-1.2c1.7 0 3.4.4 4.7 1.2"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#ff6b00",
          d: "M314.8 210a7.6 7.6 0 0 1 4.5-1.3 8 8 0 0 1 4.6 1.2"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#ff6100",
          d: "M314.8 209.9a7.3 7.3 0 0 1 4.5-1.3c1.6 0 3.3.4 4.6 1.3"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#ff5700",
          d: "M314.9 209.8a7.3 7.3 0 0 1 4.4-1.3 8 8 0 0 1 4.5 1.3"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#ebf605",
          d: "M313.9 211.4a9.5 9.5 0 0 1 5.4-1.7c2 0 4.1.6 5.5 1.7"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#d6ec09",
          d: "M313.8 211.5a9.1 9.1 0 0 1 5.5-1.7c2 0 4.2.6 5.6 1.7"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#c2e30e",
          d: "M313.8 211.6a9 9 0 0 1 5.5-1.7c2 0 4.2.5 5.6 1.7"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#add912",
          d: "M313.7 211.7a8.8 8.8 0 0 1 5.6-1.8c2 0 4.2.6 5.6 1.8"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#99cf16",
          d: "M313.6 211.8a8.8 8.8 0 0 1 5.7-1.8c2 0 4.3.6 5.7 1.8"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#85c61a",
          d: "M313.6 211.9a8.7 8.7 0 0 1 5.7-1.9c2 0 4.3.7 5.7 1.9"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#70bc1f",
          d: "M313.5 212a8.4 8.4 0 0 1 5.8-1.9c2 0 4.4.6 5.8 1.8"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#5cb323",
          d: "M313.5 212.1a8.4 8.4 0 0 1 5.8-2c2.1 0 4.4.7 5.8 2"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#47a928",
          d: "M313.4 212.2a8.4 8.4 0 0 1 5.9-2c2.1 0 4.4.7 5.9 1.9"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#0d74a4",
          d: "M313.1 212.7a8.8 8.8 0 0 1 6.2-2 9 9 0 0 1 6.3 2"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#127a97",
          d: "M313.1 212.7a8.7 8.7 0 0 1 6.2-2.2 9 9 0 0 1 6.2 2.1"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#17808b",
          d: "M313.2 212.6a8.7 8.7 0 0 1 6.2-2 9 9 0 0 1 6 2"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#1a847d",
          d: "M313.2 212.6a8.7 8.7 0 0 1 6.1-2.1 9 9 0 0 1 6.1 2"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#1e8a6d",
          d: "M313.2 212.5a8.5 8.5 0 0 1 6.1-2c2.3 0 4.6.6 6 2"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#238f5e",
          d: "M313.3 212.5a8.5 8.5 0 0 1 6-2.1c2.2 0 4.6.6 6 2"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#2b944e",
          d: "M313.3 212.4a8.3 8.3 0 0 1 6-2c2.2 0 4.6.6 6 2"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#2f9b3e",
          d: "M313.3 212.3c2-1.6 3.7-2 6-2 2.2 0 4.5.7 6 2"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "red",
          d: "M323.2 208.8a6.8 6.8 0 0 0-3.9-1 6.6 6.6 0 0 0-4 1"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#2a007c",
          d: "M326.9 214.9c-1.6-2.3-4.3-3.4-7.5-3.4-3 0-5.2.7-7.2 2.7"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#0671b0",
          d: "M325.6 212.7c-1.5-1.5-4-2-6.3-2a9 9 0 0 0-6.2 2.1"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#0c419a",
          d: "M326.2 213.7c-1.6-2-4.1-2.6-6.9-2.6-2.6 0-5 .6-6.7 2.3"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#ff0",
          d: "M324.8 211.3a9.1 9.1 0 0 0-5.5-1.6c-1.8 0-4 .5-5.4 1.6"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#ff4d00",
          d: "M323.7 209.7a8.1 8.1 0 0 0-4.4-1.2 7 7 0 0 0-4.4 1.2"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#33a02c",
          d: "M325.2 212.2a9.5 9.5 0 0 0-5.9-2 8.3 8.3 0 0 0-6 2"
        })
      ]
    }),
    /* @__PURE__ */ jsxs257("g", {
      fill: "none",
      strokeMiterlimit: 2.6,
      strokeWidth: 0.1,
      children: [
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fef2ec",
          d: "M312 214.5a16.3 16.3 0 0 1 7.3-1.8c2.6 0 5.4 1 7.6 2.1l7.7 13a15.3 15.3 0 0 1-30.6 0z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fef2ea",
          d: "M319.3 212.9c2.6 0 5.3 1 7.5 2.1l7.6 12.7c0 8.3-6.8 15.2-15 15.2-8.4 0-15.1-6.7-15.2-15.1l7.9-13a15.8 15.8 0 0 1 7.2-2z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fef0e6",
          d: "M319.3 213.3c2.5 0 5.2 1 7.3 2l7.4 12.4c0 8.1-6.6 14.9-14.7 14.9a14.7 14.7 0 0 1-14.7-14.8l7.6-12.7a15.6 15.6 0 0 1 7-1.8z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#feede3",
          d: "M319.3 213.7c2.4 0 5 .9 7 2 .2 0 7.3 11.9 7.3 12a14.4 14.4 0 0 1-14.3 14.4c-7.9 0-14.2-6.3-14.3-14.3 0-.2 7.3-12.3 7.4-12.4a16 16 0 0 1 6.9-1.7z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fee8dc",
          d: "M319.3 214.3c2.3 0 4.8.9 6.8 2 .2 0 6.8 11.2 6.8 11.5 0 7.5-6.1 13.7-13.6 13.7s-13.6-6-13.7-13.7c0-.3 6.9-11.7 7.1-11.8 2-1 4.2-1.7 6.6-1.7z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fee6d5",
          d: "M319.3 214.7c2.3 0 4.7.8 6.6 1.9.2.2 6.6 10.8 6.6 11.2 0 7.3-6 13.3-13.2 13.3s-13.2-6-13.2-13.3c0-.4 6.5-11.3 6.8-11.5 2-1 4-1.6 6.4-1.6z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fee3cf",
          d: "M319.3 215.3c2.2 0 4.5.8 6.2 1.8.4.2 6.4 10.2 6.4 10.7 0 7-5.7 12.7-12.6 12.7-7 0-12.6-5.6-12.7-12.7 0-.4 6.2-10.7 6.6-11a13.3 13.3 0 0 1 6-1.5z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fee0cc",
          d: "M319.3 215.7c2.1 0 4.3.8 6 1.8a76 76 0 0 1 6.2 10.3c0 6.7-5.5 12.3-12.2 12.3a12.2 12.2 0 0 1-12.3-12.3c0-.5 6-10.3 6.4-10.6 1.8-1 3.7-1.5 5.9-1.5z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fedec6",
          d: "M319.3 216.1c2 0 4.2.8 5.9 1.7.4.3 6 9.4 6 10a12 12 0 0 1-12 11.9 11.8 11.8 0 0 1-11.7-11.9c0-.6 5.6-10 6-10.2a12.5 12.5 0 0 1 5.8-1.5z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fdcdaa",
          d: "M319.3 218.8c1.6 0 3.2.5 4.5 1.3.9.5 4.6 6.7 4.6 7.7a9.2 9.2 0 0 1-9.1 9.2 9.2 9.2 0 0 1-9.2-9.2c0-1 3.9-7.4 4.7-8a9.6 9.6 0 0 1 4.5-1z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fdcdaa",
          d: "M319.3 219a9 9 0 0 1 4.4 1.2c1 .6 4.5 6.6 4.5 7.6a9 9 0 1 1-17.9 0c0-1 3.7-7.2 4.6-7.7a9.2 9.2 0 0 1 4.4-1.1z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fdc59e",
          d: "M319.3 220a8 8 0 0 1 4 1.1c1 .6 4 5.5 4 6.7a8 8 0 0 1-8 8 8 8 0 0 1-8-8c0-1.2 3-6.3 4.1-6.8 1.2-.7 2.5-1 3.9-1z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fdc59e",
          d: "M319.3 220.2a7.8 7.8 0 0 1 3.9 1 16 16 0 0 1 3.8 6.6 7.8 7.8 0 0 1-7.7 7.8 7.7 7.7 0 0 1-7.8-7.7c0-1.4 3-6.1 4-6.8a7.9 7.9 0 0 1 3.8-1z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fef0e9",
          d: "M319.3 213c2.5 0 5.2 1 7.4 2.2l7.5 12.5a15 15 0 0 1-14.9 15 15 15 0 0 1-14.9-14.9l7.7-13a15.6 15.6 0 0 1 7.2-1.7z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#feede3",
          d: "M319.3 213.5c2.5 0 5.1 1 7.1 2 .2.1 7.4 12.1 7.4 12.3a14.5 14.5 0 0 1-29 0l7.5-12.6a15.1 15.1 0 0 1 7-1.7z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#feebdf",
          d: "M319.3 214c2.4 0 5 .8 7 1.9.1 0 7 11.6 7 11.9 0 7.7-6.3 14.1-14 14.1s-14-6.3-14-14.1c0-.2 7-12.1 7.2-12.2a14.9 14.9 0 0 1 6.8-1.7z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#feebdd",
          d: "M319.3 214c2.4 0 4.9 1 6.9 2 .1.2 7 11.5 7 11.8a14 14 0 0 1-14 14 14 14 0 0 1-13.8-14c0-.2 7-11.9 7.2-12 2-1 4.2-1.7 6.7-1.7z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fee8d9",
          d: "M319.3 214.5c2.3 0 4.8.9 6.7 2 .2 0 6.7 11 6.7 11.3 0 7.4-6 13.5-13.4 13.5s-13.4-6-13.5-13.5c0-.3 6.7-11.5 7-11.7 2-1 4.1-1.6 6.5-1.6z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fee6d3",
          d: "M319.3 215c2.2 0 4.6.7 6.5 1.8.3.1 6.5 10.6 6.5 11 0 7.1-5.9 13.1-13 13.1a13.1 13.1 0 0 1-13-13c0-.5 6.4-11.3 6.7-11.4a13.8 13.8 0 0 1 6.3-1.6z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fee3d2",
          d: "M319.3 215.1c2.2 0 4.5.8 6.4 1.8.3.2 6.4 10.5 6.4 10.9 0 7-5.8 13-12.8 13a13 13 0 0 1-12.9-13c0-.4 6.3-11 6.7-11.1a13.8 13.8 0 0 1 6.2-1.6z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fee0cc",
          d: "M319.3 215.5c2.2 0 4.4.8 6.1 1.8.5.2 6.3 10 6.3 10.5 0 6.8-5.6 12.5-12.4 12.5a12.5 12.5 0 0 1-12.5-12.5c0-.5 6-10.6 6.5-10.8a13 13 0 0 1 6-1.5z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fedec8",
          d: "M319.3 216c2 0 4.2.7 6 1.6.4.3 6 9.6 6 10.2a12 12 0 0 1-12 12 12 12 0 0 1-12-12 88 88 0 0 1 6.2-10.4c1.7-1 3.6-1.5 5.8-1.5z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fddbc5",
          d: "M319.3 216.3c2 0 4.1.8 5.8 1.7a87 87 0 0 1 5.8 9.8c0 6.4-5.2 11.7-11.6 11.7-6.4 0-11.6-5.2-11.6-11.7 0-.6 5.5-9.7 6-10a12.1 12.1 0 0 1 5.6-1.5z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fddbc2",
          d: "M319.3 216.5c2 0 4 .8 5.7 1.7.5.3 5.7 9 5.7 9.6 0 6.3-5.1 11.5-11.4 11.5s-11.4-5.1-11.5-11.5c0-.7 5.4-9.6 6-9.9a12 12 0 0 1 5.5-1.4z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fdd9bf",
          d: "M319.3 216.7c2 0 4 .7 5.6 1.6.5.4 5.6 8.8 5.6 9.5a11.2 11.2 0 0 1-22.4 0c0-.7 5.2-9.4 5.8-9.7a11.9 11.9 0 0 1 5.4-1.4z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fdd9bf",
          d: "M319.3 217c2 0 3.9.6 5.4 1.5a55 55 0 0 1 5.6 9.3c0 6-5 11-11 11s-11-4.8-11-11c0-.7 5-9.2 5.7-9.5a11.5 11.5 0 0 1 5.3-1.4z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fdd6bc",
          d: "M319.3 217.1c1.9 0 3.8.7 5.3 1.6.7.3 5.5 8.3 5.5 9.1 0 6-4.9 10.9-10.8 10.9a10.8 10.8 0 0 1-10.8-10.9c0-.8 5-9 5.6-9.3a11 11 0 0 1 5.2-1.4z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fdd6b9",
          d: "M319.3 217.3c1.8 0 3.7.7 5.2 1.5.7.4 5.3 8.2 5.3 9 0 5.8-4.7 10.7-10.5 10.7a10.6 10.6 0 0 1-10.6-10.7c0-.8 4.8-8.8 5.5-9.2a11 11 0 0 1 5-1.3z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fdd4b8",
          d: "M319.3 217.6c1.8 0 3.7.6 5.2 1.4.6.4 5.2 8 5.2 8.8 0 5.7-4.7 10.5-10.4 10.5s-10.4-4.7-10.4-10.5c0-.8 4.6-8.6 5.3-9a10.8 10.8 0 0 1 5-1.2z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fdd4b6",
          d: "M319.3 217.7c1.8 0 3.6.7 5 1.5.8.4 5.2 7.7 5.2 8.6 0 5.6-4.6 10.3-10.2 10.3a10.2 10.2 0 0 1-10.2-10.3c0-.9 4.5-8.4 5.2-8.8a10.8 10.8 0 0 1 5-1.3z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fdd2b2",
          d: "M319.3 218c1.7 0 3.5.6 5 1.4.7.4 5 7.5 5 8.4 0 5.5-4.6 10-10 10s-10-4.4-10-10a39 39 0 0 1 5.1-8.6 10.7 10.7 0 0 1 4.9-1.3z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fdd1b0",
          d: "M319.3 218.2c1.7 0 3.5.6 4.9 1.4.7.4 4.9 7.3 4.9 8.2 0 5.4-4.5 9.9-9.8 9.9s-9.8-4.4-9.8-9.9c0-.9 4.2-8 5-8.4a9.8 9.8 0 0 1 4.8-1.3z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fdd0b0",
          d: "M319.3 218.4c1.7 0 3.4.6 4.8 1.3.8.5 4.7 7.1 4.7 8.1a9.5 9.5 0 1 1-19.1 0c0-1 4.1-7.8 5-8.3a9.8 9.8 0 0 1 4.6-1.1z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fdd0ad",
          d: "M319.3 218.6a9.8 9.8 0 0 1 4.7 1.3c.8.5 4.6 7 4.6 8 0 5-4.2 9.3-9.3 9.3s-9.4-4.1-9.4-9.4c0-1 4-7.6 4.8-8a9.6 9.6 0 0 1 4.6-1.2z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fdcaa6",
          d: "M319.3 219.2c1.5 0 3 .5 4.4 1.2.9.5 4.3 6.3 4.3 7.4a8.8 8.8 0 0 1-8.7 8.8 8.8 8.8 0 0 1-8.8-8.7c0-1.2 3.6-7.1 4.5-7.7a9.1 9.1 0 0 1 4.3-1z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fdcaa4",
          d: "M319.3 219.4a9.1 9.1 0 0 1 4.3 1.2c.9.5 4.2 6 4.2 7.2a8.6 8.6 0 0 1-8.5 8.6 8.6 8.6 0 0 1-8.6-8.5c0-1.2 3.5-7 4.4-7.5a9 9 0 0 1 4.2-1z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fdc8a4",
          d: "M319.3 219.6c1.5 0 3 .5 4.2 1.2a19 19 0 0 1 4.1 7 8.4 8.4 0 0 1-16.7.1c0-1.2 3.3-6.7 4.3-7.3a8.5 8.5 0 0 1 4-1z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fdc8a1",
          d: "M319.3 219.8c1.4 0 2.9.5 4 1.1 1 .6 4.1 5.7 4.1 7a8.2 8.2 0 0 1-8.1 8.1 8.2 8.2 0 0 1-8.2-8.1c0-1.3 3.2-6.6 4.2-7.1 1.2-.6 2.5-1 4-1z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fdc39b",
          d: "M319.3 220.4c1.3 0 2.7.4 3.7 1a15 15 0 0 1 3.8 6.4 7.5 7.5 0 0 1-7.5 7.6 7.5 7.5 0 0 1-7.6-7.5c0-1.4 2.8-6 3.9-6.6a7.7 7.7 0 0 1 3.7-1z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fdc398",
          d: "M319.3 220.6c1.3 0 2.6.4 3.6 1a13 13 0 0 1 3.7 6.3c0 4-3.3 7.3-7.3 7.3a7.3 7.3 0 0 1-7.4-7.3 14 14 0 0 1 3.8-6.4 7.7 7.7 0 0 1 3.6-1z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fdc097",
          d: "M319.3 220.8a7.5 7.5 0 0 1 3.6 1 13 13 0 0 1 3.5 6c0 4-3.2 7.2-7.1 7.2a7.1 7.1 0 0 1-7.2-7.1c0-1.5 2.5-5.6 3.7-6.3a7.3 7.3 0 0 1 3.5-.8z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fdc095",
          d: "M319.3 221a7 7 0 0 1 3.5 1c1.1.7 3.4 4.4 3.4 5.9a7 7 0 0 1-7 7 7 7 0 0 1-6.9-7c0-1.5 2.4-5.4 3.6-6a6.8 6.8 0 0 1 3.4-.9z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fdbe92",
          d: "M319.3 221.2a7 7 0 0 1 3.4 1c1.1.6 3.3 4.2 3.3 5.7a6.7 6.7 0 1 1-13.5 0c0-1.5 2.3-5.2 3.5-5.9 1-.5 2-.8 3.3-.8z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fdbe90",
          d: "M319.3 221.4c1.1 0 2.3.4 3.3 1 1.1.6 3.2 4 3.2 5.5a6.5 6.5 0 0 1-6.5 6.5 6.5 6.5 0 0 1-6.6-6.5c0-1.6 2.1-5 3.4-5.7a6.6 6.6 0 0 1 3.2-.8z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fdbb8f",
          d: "M319.3 221.6c1.1 0 2.2.3 3.2.9 1.2.7 3 3.8 3 5.4a6.3 6.3 0 0 1-6.2 6.3 6.3 6.3 0 0 1-6.4-6.3 9 9 0 0 1 3.3-5.5c1-.5 2-.8 3-.8z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fdbb8d",
          d: "M319.3 221.8c1 0 2.2.3 3 .9a8 8 0 0 1 3 5.2 6.1 6.1 0 0 1-6 6 6.1 6.1 0 0 1-6.1-6c0-1.6 1.8-4.6 3-5.3a6 6 0 0 1 3-.8z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fdb98a",
          d: "M319.3 222a5.8 5.8 0 0 1 3 .8c1.2.8 2.9 3.5 2.9 5a6 6 0 0 1-6 6 6 6 0 0 1-5.8-6c0-1.6 1.6-4.3 3-5a6 6 0 0 1 2.9-.8z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fdb98a",
          d: "M319.3 222.2a5.8 5.8 0 0 1 2.8.8 7 7 0 0 1 2.9 4.9 5.7 5.7 0 0 1-11.4 0 7 7 0 0 1 2.9-5 5.5 5.5 0 0 1 2.8-.7z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fcb687",
          d: "M319.3 222.4c1 0 2 .3 2.8.8a6.5 6.5 0 0 1 2.6 4.7 5.5 5.5 0 1 1-11 0c0-1.7 1.5-4 2.9-4.8a6 6 0 0 1 2.7-.7z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fcb685",
          d: "M319.3 222.6c1 0 1.9.3 2.7.8a5.9 5.9 0 0 1 2.5 4.5 5.3 5.3 0 0 1-5.2 5.3 5.3 5.3 0 0 1-5.3-5.3 5.9 5.9 0 0 1 2.7-4.6 5 5 0 0 1 2.6-.7z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fcb485",
          d: "M319.3 222.8c1 0 1.8.3 2.6.7a5.3 5.3 0 0 1 2.4 4.4 5 5 0 1 1-10.1 0c0-1.8 1.1-3.6 2.6-4.4a5 5 0 0 1 2.5-.7z"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fcb482",
          d: "M319.3 232.8a4.9 4.9 0 0 0 4.8-4.9c0-2.7-2.2-4.9-4.8-4.9a4.9 4.9 0 0 0-5 4.9 4.9 4.9 0 0 0 5 4.9z"
        })
      ]
    }),
    /* @__PURE__ */ jsx282("path", {
      fill: "#fff",
      fillRule: "evenodd",
      stroke: "#fff",
      strokeMiterlimit: 2.6,
      strokeWidth: 0.1,
      d: "M319.3 232.8a4.9 4.9 0 0 0 4.9-4.9 4.9 4.9 0 0 0-4.9-4.8 4.9 4.9 0 0 0-4.9 4.8 4.9 4.9 0 0 0 5 4.9z"
    }),
    /* @__PURE__ */ jsxs257("g", {
      stroke: "#000",
      strokeWidth: 0.1,
      children: [
        /* @__PURE__ */ jsx282("path", {
          fill: "none",
          d: "m320.4 223.1.5-2.6m-1 2.6.2-2.7m-.8 2.6v-2.6m-.5 2.7-.3-2.7m-.2 2.7-.6-2.6m.1 2.8-.8-2.6m.3 2.7-1-2.4m.6 2.6-1.4-2.3m1 2.6-1.6-2.1m1.2 2.5-1.9-2m1.5 2.3-2-1.8m1.7 2.2-2.2-1.5m1.8 2-2.2-1.4m2 1.8-2.4-1m2.2 1.5-2.5-.9m2.4 1.4-2.6-.6m2.5 1-2.6-.2m2.6.8h-2.7m2.7.5-2.6.3m2.7.2-2.6.6m2.7-.1-2.5.8m2.7-.3-2.4 1m2.6-.6-2.8 1.8m3.1-1.3-5.7 4m6-3.6-6.1 5.4m6.5-5-5.1 5.6m5.5-5.3-3.9 5.1m4.3-4.8-4 7m4.5-6.8-2.3 5m2.7-4.8-2.2 7m2.7-6.9-1 4.7m1.6-4.6-.7 7.2m1.7-7.2.2 2.6m.3-2.7 1.5 6.8m-1-7 1.3 4.1m-.8-4.2 3 6.7m-2.6-7 3.3 5.8m-2.8-6 4.7 6.2m-4.3-6.5 4.1 4.8m-3.8-5.2 6.2 5.7m-5.9-6 3.4 2.4m-3-2.9 2.2 1.3m-2-1.7 2.4 1m-2.2-1.5 2.5.8M324 229l2.6.5m-2.5-1 2.6.2m-2.6-.8h2.6m-2.6-.5 2.6-.2m-2.7-.3 2.6-.5m-2.7 0 2.5-.8m-2.7.4 2.4-1.1m-2.6.6 2.3-1.3m-2.6.9 2.1-1.6m-2.4 1.1 2-1.7m-2.4 1.4 1.8-2m-2.2 1.6 1.6-2m-2 1.8 1.3-2.3m-1.8 2 1.1-2.4m-1.6 2.3.9-2.5m-2.4-4v-2M317 217l-.4-2m-1.8 2.7-.8-1.8m-1.2 3-1.2-1.7m-.5 3.2-1.6-1.3m.2 3.2-1.8-1m.8 3.2-2-.7m1.5 3-2-.3m2 2.5-2 .2m2.5 2.1-2 .7m22.2 1.5 1.8 1m-.8-3.1 1.9.6m-1.5-2.9 2 .2m-2-2.5 2-.2m-2.4-2.1 2-.6m-3-1.5 1.8-1m-3.1-.9 1.5-1.4m-3.2-.2 1.2-1.6m-3.2.5.8-1.9m-3 1.1.4-2"
        }),
        /* @__PURE__ */ jsx282("path", {
          fill: "#e60000",
          fillRule: "evenodd",
          strokeMiterlimit: 2.6,
          d: "M322.1 230.2s-.7-.4-1-.4l-3 .1c-.5.1-.8.5-.8.5s.5.5 1.4.6c1 0 1.7 0 2.2-.2z"
        }),
        /* @__PURE__ */ jsx282("path", {
          fill: "#e60000",
          fillRule: "evenodd",
          strokeMiterlimit: 2.6,
          d: "M317.4 229.5s.1-1.4 1-3l-.4.8s-.6.3-.9 0c-.3-.4-.1-.5.1-1 .2-.4.2-.8.5-1 .2-.3.4-.3 1-.3.7 0 1.2 0 1.7.8l1 1.7c.6.8.6 1.9.6 1.9l.2.8s-.7-.4-1.1-.4l-3 .1-.8.5s-.3-.6.1-1z"
        }),
        /* @__PURE__ */ jsx282("path", {
          fill: "none",
          strokeMiterlimit: 2.6,
          d: "M317.4 229.5s.6-.3 2.3-.3c2 0 2.1.2 2.3.3"
        }),
        /* @__PURE__ */ jsx282("path", {
          fill: "#fc0",
          fillRule: "evenodd",
          strokeMiterlimit: 2.6,
          d: "M319.2 237.1v-7.2s.2-.2.8 0v7.1s.2 5.5-.4 5.5c-.7 0-.4-1.3-.4-5.4z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs257("g", {
      fill: "#e60000",
      children: [
        /* @__PURE__ */ jsx282("path", {
          fillRule: "evenodd",
          d: "m311.8 231 .1.3-1.4.6.2.5h-.2c-.1-.2-.2-.3-.6-.3v-.2zm-1.5-.5a.6.6 0 0 1-.3-.4c0-.4.1-.7.6-.8.2-.1.7-.1.9.5 0 .3 0 .7-.5.8v-.2c.2-.1.3-.3.2-.6 0-.2-.3-.3-.6-.3-.3.1-.4.3-.3.6a.5.5 0 0 0 .3.3v.2l-1.2.1-.2-1h.3l.2.8zm-.6-4c-.3 0-.5.3-.5.6 0 .2 0 .5.3.5s.3-.1.4-.2l.2-.6c0-.3.2-.5.6-.5.5 0 .6.6.5 1l-.2.6c-.2.1-.4.2-.6.1v-.2c.4 0 .6-.3.6-.6 0-.2 0-.5-.3-.6-.3 0-.3 0-.4.4l-.2.5c0 .1-.1.4-.5.4s-.7-.3-.6-.8c0-.8.5-.8.7-.8v.3zm0-1.3.5.2.4-1.1h.3l-.4 1.2.7.3.4-1.3h.2l-.4 1.6-2.1-.7.5-1.5.2.1z"
        }),
        /* @__PURE__ */ jsx282("path", {
          d: "M311 222a.7.7 0 0 0-.4.4l-.5.8 1.9 1.1.1-.2-.8-.5.4-.6c.2-.4 0-.7-.2-.9a.6.6 0 0 0-.5 0zm.2.4a.4.4 0 0 1 .1 0c.2.2.2.3.1.6l-.3.4-.6-.3.3-.5c.1-.2.2-.3.4-.2"
        }),
        /* @__PURE__ */ jsx282("path", {
          fillRule: "evenodd",
          d: "m313.6 222.1-.2.2-1.4-1.3-.5.5-.2-.1 1.2-1.3.2.2-.5.5zm.7-.6-1.3-1.7.2-.2 1.3 1.7zm0-2.3.3.6 1-.5.2.2-1 .6.2.6 1.2-.6.1.2-1.4.8-1-2 1.4-.7.1.2zm4 .6-.3-1.2v-.6l-.3 2h-.3l-1-1.6.2.5.2 1.3h-.2l-.5-2.1h.4l1 1.6.2-2h.4l.5 2z"
        }),
        /* @__PURE__ */ jsx282("path", {
          d: "M319 217.6v2.2h.8c.5 0 .8-.2.8-.6 0-.3-.2-.4-.4-.5.3-.1.3-.3.3-.5 0-.3-.1-.5-.5-.6zm.3.3h.5c.3 0 .4.2.4.4s-.1.3-.4.2h-.5zm0 .9h.5c.2 0 .5.1.5.4 0 .2-.2.4-.5.4l-.5-.1zm2.1-1-.5 2.1.2.1.3-.9.7.2c.3.1.3.3.2.5v.5l.3.1v-.7c.1-.2 0-.3 0-.4 0 0 .3-.1.3-.4.2-.5-.1-.7-.5-.8zm.3.4.6.2c.2 0 .4 0 .3.4 0 .3-.3.3-.5.2l-.6-.1z"
        }),
        /* @__PURE__ */ jsx282("path", {
          fillRule: "evenodd",
          d: "m324 219-.3.6 1 .6-.1.2-1-.5-.4.6 1.1.6-.1.2-1.4-.8 1-1.8 1.5.8-.2.2z"
        }),
        /* @__PURE__ */ jsx282("path", {
          d: "M326.6 220.7 325 222l.6.7c.4.5 1 .3 1.4 0 .5-.4.6-1 .2-1.4zm0 .4.3.4c.3.3.3.6-.1 1-.4.3-.8.3-1 0l-.3-.4z"
        }),
        /* @__PURE__ */ jsx282("path", {
          fillRule: "evenodd",
          d: "m328.2 223-.7.4.6 1-.3.2-.5-1.1-.6.3.6 1.2h-.3l-.7-1.3 2-1 .7 1.4-.3.1zm-.8 4v-.3l1.5-.2-.1-.5h.2c0 .3.1.4.5.5v.2z"
        }),
        /* @__PURE__ */ jsx282("path", {
          d: "m328 227.6-.4.2a.9.9 0 0 0-.2.5c0 .5.3.8.6.8.2 0 .4 0 .6-.3 0 0 .1.2.4.2.3 0 .6 0 .6-.6 0-.5-.3-.7-.6-.7-.2 0-.3.1-.4.4 0-.3-.3-.4-.5-.5zm0 .4c.2 0 .4.1.4.4 0 .2-.1.4-.4.4-.3 0-.3-.3-.3-.5 0-.3.2-.3.4-.3zm1 0c.2 0 .3.1.3.4 0 .3-.2.4-.3.4a.4.4 0 0 1-.3-.4c0-.2.1-.3.3-.3z"
        }),
        /* @__PURE__ */ jsx282("path", {
          fillRule: "evenodd",
          d: "M328.7 229.5c.7.2.6.7.6 1-.1.3-.4.5-.8.4-.4 0-.5-.3-.6-.7v-.2c0-.4-.2-.5-.3-.5l-.3 1.1h-.3l.4-1.4c.4.1.6.3.7.7v.3c.2.2.2.4.5.5.1 0 .4 0 .5-.4 0-.3-.3-.4-.4-.5zm-2.1 2.1.1-.3 1.4.7.2-.5.2.1c-.1.4-.2.5.1.7v.2z"
        })
      ]
    }),
    /* @__PURE__ */ jsx282("path", {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 2.6,
      strokeWidth: 0.2,
      d: "M319.3 202.3 283 263h72.7z"
    }),
    /* @__PURE__ */ jsxs257("g", {
      fill: "none",
      strokeMiterlimit: 2.6,
      children: [
        /* @__PURE__ */ jsx282("path", {
          stroke: "#000",
          strokeWidth: 0.1,
          d: "M321.3 255.5a6.3 6.3 0 0 0 3.2 0c1.5-.3 3-1.2 4.8-1 1.4 0 3.2 1.2 5.3 1.2 2.2 0 3-.7 4.8-1.1 1.3-.3 2-.2 3.4.2 1.6.3 2.5 1.2 5.2 1"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fff",
          strokeWidth: 0.4,
          d: "M293.2 258.1c1.3-1 3.4-1.3 5-1 2.2.5 3.1 1 5.4 1 1.7 0 3.2-1.1 5-1.1 2.8 0 2.9.6 5.4 1a5.6 5.6 0 0 0 2.2 0 9.5 9.5 0 0 0 2.5-.8c.8-.4 2.8-.4 3.8-.3 1.8.2 2.6.9 3 1 1 .2 2 .4 3.2 0 1.5-.4 3-1.4 4.9-1.2 1.3.2 3 1.4 5.2 1.4s3-.8 4.8-1.2c1.4-.3 2-.2 3.4.1 1.6.4 2.5 1.5 5.2 1.2"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fff",
          strokeWidth: 0.3,
          d: "M289.1 256a7.6 7.6 0 0 1 5-.8c2.2.4 3.1 1 5.4 1 1.7-.1 3.2-1.1 5-1.1 2.8 0 2.9.5 5.4 1h2.2a9.4 9.4 0 0 0 2.5-.9c.8-.3 2.8-.3 3.8-.2 1.8.2 2.6.8 3 .9 1 .2 2 .3 3.2 0 1.5-.4 3-1.2 4.9-1 1.3 0 3.1 1.2 5.2 1.2 2.2 0 3-.8 4.8-1.1 1.4-.3 2-.1 3.4.1 1.6.4 2.5 1.3 5.2 1"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fff",
          strokeWidth: 0.5,
          d: "M285.4 262a6.3 6.3 0 0 1 5-1c2.1.5 3 1.1 5.4 1 1.7 0 3.2-1.3 4.9-1.3 2.9 0 3 .7 5.5 1.3a5.8 5.8 0 0 0 2.2 0 8.4 8.4 0 0 0 2.5-1c.8-.5 2.8-.4 3.8-.3 1.8.2 2.5 1 2.9 1 1 .3 2 .5 3.3.2 1.5-.6 3-1.6 4.8-1.4 1.3.1 3.1 1.6 5.3 1.6 2.1 0 3-1 4.7-1.5 1.4-.3 2-.1 3.5.2 1.6.4 2.5 1.6 5.2 1.3"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fff",
          strokeWidth: 0.3,
          d: "M286.4 258.6c1.2-.9 3.4-1.2 5-.9 2.1.5 3 1 5.4 1 .7 0 1.4-.3 2.2-.5"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#000",
          strokeWidth: 0.2,
          d: "M297.4 255c.3 0 1.3-.5 2.8-.5 2.9 0 1 0 3.6.5.7 0 2.5 0 3-.4m25.4 8.2c1-.2 1.8-.5 2.6-.8.7-.3 2.7-.3 3.8-.2 1.8.2 2.5.8 2.9.8a6.3 6.3 0 0 0 3.2 0c1.6-.3 3-1.2 5-1 1.2.1 3 1.3 5.2 1.3"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#fff",
          strokeWidth: 0.3,
          d: "M336.7 254.8c2.1 0 2.9-.8 4.8-1.2 1.3-.2 2 0 3.3.2 1.7.3 2.5 1.3 5.2 1"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#000",
          strokeWidth: 0.1,
          d: "M285.5 262.2a7.7 7.7 0 0 1 5-.8c2.2.4 3.1.9 5.4.9 1.7 0 3.2-1.1 5-1.1 2.8 0 2.9.6 5.4 1a7.5 7.5 0 0 0 2.2 0 9.8 9.8 0 0 0 2.5-.8c.8-.4 2.8-.3 3.8-.2 1.8.1 2.5.7 3 .8"
        }),
        /* @__PURE__ */ jsx282("path", {
          stroke: "#000",
          strokeWidth: 0.5,
          d: "M290 259.6c1.3-.9 3.5-1.2 5.1-.9 2.2.4 3.1 1 5.4.9 1.7 0 3.1-1 4.8-1 3 0 3 .5 5.6 1a7.4 7.4 0 0 0 2.2 0 11.3 11.3 0 0 0 2.5-.9c.7-.3 2.8-.3 3.8-.2 1.8.2 2.5.8 3 .9.9.2 2 .3 3.2 0 1.5-.4 3-1.3 4.8-1 1.5 0 3.3 1.2 5.3 1.2 2.2 0 3-.8 4.8-1.2 1.3-.2 2 0 3.4.2 1.6.3 2.5 1.3 5.2 1"
        })
      ]
    }),
    /* @__PURE__ */ jsxs257("g", {
      fill: "#fc0",
      fillRule: "evenodd",
      stroke: "#000",
      strokeWidth: 0.2,
      children: [
        /* @__PURE__ */ jsx282("path", {
          d: "M291 249.5c.4 0 1.2-.6 1.5-.8.3-.2.5-.7.8-1l1.5-1a10.8 10.8 0 0 0 3.5-3.1 17.8 17.8 0 0 1 5.7-5.2c.8-.4 1.9-.3 2.7 0l.8.7c1 .7 2.3 1.3 3.9 1.8 1.5.4 1.9 1.4 3 2.5.7.5 1.3 1 2 1.3l.4.4 2 1.4a67 67 0 0 1 3.2 3.1l.4.7c.8.7 1.6 1.5 2.6 2l2.7 1.6c-9.2.4-17.7-.2-27 0H299l-1.8.1h-8.8z"
        }),
        /* @__PURE__ */ jsx282("path", {
          d: "m327.3 253.7-2.3-1.4c-1-.5-1.8-1.3-2.6-2l-.4-.7a67 67 0 0 0-3.2-3.1l-2-1.4-.3-.4a8.5 8.5 0 0 1-2-1.3l-1.9-2a7.5 7.5 0 0 1 1.3-.7c.6-.4 1.5-.3 2.2 0l.7.5c.8.7 1.9 1.1 3.2 1.5 1.3.4 1.6 1.2 2.6 2.1.5.5 1 .8 1.6 1.1l.3.3 1.7 1.3 2.7 2.5.3.6c.7.6 1.3 1.3 2.1 1.6l2.3 1.4h-6.2z"
        }),
        /* @__PURE__ */ jsx282("path", {
          d: "m319.1 242.4.9.3c1.3.4 1.6 1.2 2.6 2.1.5.5 1 .8 1.6 1.1l.3.3 1.7 1.3a63 63 0 0 1 2.7 2.5l.3.6c.7.6 1.3 1.3 2.1 1.6.7.3 1.3.8 2 1.2l5-.1c-.6-.4-1.2-1-2-1.3-.7-.3-1.3-1-1.9-1.5l-.3-.5-2.4-2.3-1.6-1.1-.2-.3a6.2 6.2 0 0 1-1.5-1c-1-.8-1.2-1.6-2.4-2a9 9 0 0 1-2.9-1.3c-.2-.1-.4-.4-.6-.4-.6-.3-1.5-.4-2 0a9.8 9.8 0 0 0-1.4.8z"
        }),
        /* @__PURE__ */ jsx282("path", {
          d: "m327.6 244.4.8.9 1.5 1 .2.3 1.6 1 2.4 2.4.3.5c.6.6 1.2 1.2 2 1.5l1.3.8h6c-.6-.4-1-.8-1.7-1l-1.5-1.3-.3-.4a93.8 93.8 0 0 0-2-1.9l-1.2-.9-.2-.2a5 5 0 0 1-1.2-.8c-.7-.7-1-1.3-1.9-1.6a7.3 7.3 0 0 1-2.4-1l-.4-.4c-.6-.2-1.2-.3-1.7 0a9.5 9.5 0 0 0-1.6 1z"
        }),
        /* @__PURE__ */ jsx282("path", {
          d: "M343.3 252.5a7.4 7.4 0 0 0-1.3-.8l-1.5-1.2-.3-.4c-.6-.7-1.2-1.3-2-1.9l-1.2-.9-.2-.2a5.7 5.7 0 0 1-1.2-.8c-.6-.6-.9-1-1.5-1.4a6.3 6.3 0 0 1 1-.7c.5-.2 1 0 1.5 0l.4.4c.5.4 1.2.7 2 1 .9.2 1 .7 1.7 1.3.3.2.6.5 1 .6l.2.3 1 .7 1.7 1.6.2.4 1.3 1 1.5.9z"
        })
      ]
    }),
    /* @__PURE__ */ jsx282("path", {
      fill: "none",
      stroke: "#00633b",
      strokeWidth: 0.1,
      d: "M303.2 239c.4 0 .2-.2.6 0m-1.5.5c.5 0 .7-.4 1 0m-1.4.3c.2 0 .3-.2 1 .2m-1.5.4h1m-1.6.4c.5-.1.7.2 1.3.1m-1.9.5h1.4m-2 .6h.7c.5 0 .4.1.8 0m-1.9.5c.7 0 1 0 1.4.2m-2.3 1.1h1.4m-11 10c1.8-.4 4 0 6-.3m3.8-10.3c.5-.2.4 0 1 0h.7m-2.4 1.1c.5-.2 1 0 1.5 0m-.3.5c-.5-.1-1 0-1.6 0m1.2.6a2.9 2.9 0 0 0-1.7 0m-.8.4c.7 0 1.4-.2 2.1 0m-2.6.6c.7-.3 1.4 0 2.2 0m-3 .4h2.3c.1 0 .4-.2.5 0m-.2.4c-1.2.2-2.3 0-3.5.1m2.8.5c-.3 0-1 .2-1.5.1h-.3a4.2 4.2 0 0 0-1.7.1m-.2.4a1 1 0 0 1 .7 0h2.1l.6.3m-3.9 0h1.6l2 .4m-4 0c.5 0 1 0 1.6.2l2.1.1m-4.4 0c.7.3 1.5 0 2.2.2l2.1.2m-4.8.2c1.1 0 2.2 0 3.4.2.3 0 .8.2 1.2.1m-5 .2c1.1.2 2.2 0 3.3.3l1.5.2m-5.2.3.3-.1h2.6c.7 0 1.5 0 2.2.2m-5.5.5c1.7-.2 3.5 0 5.2 0m-5.5.5c1.8.2 3.7 0 5.5.1m-5.8.4c.8.2 1.6 0 2.4.1.6.1 1.1.2 1.7.1h1.5m7.4-7.6h.2m-.4.2h.2m-.4.3h.4m-.5.2h.4m-.8.3.8.1m-1 .4 1-.1h-.1m-1.3.5h1.3m-1.6.4h1.4m-1.6.4h1.6m-2 .5 1 .2c.3.1.6 0 .8 0m-1.8.2 1.6.2m-2 .2c.5 0 1 0 1.4.2h.6m-2.5.4c.5-.2 1.2 0 1.8.1h.6m-2.5.4c.6-.2 1.3-.2 2 0h.3m-2.7.5c.8.1 1.7-.1 2.6.1m-2.9.2c.7.3 1.5 0 2.2.2.3.1.5.1.8 0m-3.5.4c.3-.1.7-.2 1-.1.8.2 1.6.1 2.3.2m-3.6.4c.1 0 .3.1.4 0h3.2m-4 .4c1 .3 1.8 0 2.7.3h1.2m-4.1.3c1.3 0 2.5 0 4 .2m3.3-7.5h.3m-.5.3h.5m-.6.4h.6m-.8.5h.8m-1 .5 1-.1m-1.1.4h1m-1.2.6h1.3m-1.3.4h1.4m-1.6.6h1.5m-1.7.5c.2 0 .4-.2.6-.1h1m-1.7.6c.6-.2 1.2.2 1.8-.2m-2 .8h2m-2 .5c.6-.2 1.4 0 2 0m-2.5.5 2.8-.2m-2.7.7c1-.2 2 0 3.1-.1m-3.3.7c1 .1 1.3 0 2.3-.1l1.2-.2h.6m-4 .6c1.5-.2 3 .1 4.6-.3m-11.3 0h1.2m4.7.3c.2 0 .3-.1.4 0m5.4-.1c1.3-.2 2.5.2 3.8 0m-4.4-.5c.8-.2 1.5 0 2.3.1l.1.2h2m-8.9-.3h-.8m-4.1-.2-1.7.1m12.1-11.8h.3m-.2.3h.3m-.2.6.4-.1m-.3.4h.6m0 .4h-.5m.3.6a.8.8 0 0 1 .5-.1m.3.4h-.8m.2.4.8-.1m.2.6h-.9m.2.6c.4 0 .7 0 1-.2m0 .3-.9.2m.2.6c.4-.2.9 0 1.2-.2m.1.5h-.9l-.3.1m.2.8c.3-.1.5-.3.8-.3h.6m.2.4-1.4.2m.1.6 1.6-.3m-1.5 1 1.8-.4m.4.4c-.7.1-1.4 0-2 .3m.2.6s.1.1.2 0a4 4 0 0 1 2-.3m0 .4c-.5.4-1.3.2-2 .3h-.2m.2.5 2.3-.2m.5.5h-1.8c-.3 0-.5.2-.8.3m0 .5h.4c.8-.5 1.6-.4 2.5-.4m.2.5c-.7 0-1.4-.2-2.1 0-.3.1-.5.3-.8.3m.3.5 1-.3h2.4m0 .4c-.4-.1-1-.2-1.3 0-.7.1-1.3.3-2 .3m.4.4c.5 0 1-.3 1.6-.4h1.3m-3 .7c1-.1 1.7 0 2.6-.3h.9m0-.3c1.4.1 2.8-.1 4.1.2m-3.8.3.4-.1h3.4m-.4-2.9h.2m-.1.4c.1 0 .2-.2.4 0m-.3.4h.7m-.5.6c.2-.3.6 0 .8-.2m-.6.8c.3-.3.7 0 1-.3m-1 .7c.5-.2 1 0 1.4-.3m-1.2.7c.7-.3 1.5.1 2.1-.4m-2 .7c.8-.2 1.7 0 2.6 0m.6 0h4.6m-5.3-.6c1.4.2 3.4 0 5.1.2m-12.6-10.6 1.1-.2m-.8.4 1.2-.1m-.7.6.8-.2h.4m-.9.4h1.5m.2.3-1.2.1m.8.5 1-.2m.5.4h-1.2m.6.5 1-.2m.6.5h-1m.5.5 1.2-.1m.4.2-1 .2m.5.5c.3-.2.9 0 1.3-.2m.4.5h-1l-.4.1m2.6.8-1.5.1m.5.6c.5-.2 1.1-.2 1.6-.3m-.4 1.7h.8c.8-.2 1-.4 1.7-.3m.5.4-2.2.2-.4.1m.4.4c.8-.2 2-.1 2.7-.3m.8.5-2 .1-1 .1m.7.5h.3c.6-.4 1.7-.4 2.6-.4m.5.5h-1.9l-.9.2m.8.5c.8-.2 2.3-.3 1.4-.3h1.9m.2.3a4.3 4.3 0 0 0-1.5 0c-.4.2-.3.3-1.4.3m.4.2 1.2-.1 1.5-.1m-2.4.4h2.7m-16.2-11h.7c0-.2.2 0 .3-.2h.3m-1.7-.2h.8c-.1-.2.2 0 .2-.1h.4m5.5 6c.2-.1.2-.2.6-.1-.1-.2.3 0 .4-.1h.5m0 1.5c.5 0 1.2 0 1.7-.3m.8.6c-.6.1-1.6 0-2.1.3m-8-8.4c-.6 0-.7.2-1.1.2m8 1.6 1-.2m-.7.5c.4-.1.7 0 1-.2m-.7.5.7-.1h.4m-.7.4h1.2m.3.2a4 4 0 0 0-1.2.2m.4.4 1.3-.2m.5.3-1.3.1m.4.4c.3 0 1.2 0 1.3-.2m.5.5h-1.2m.4.4 1.3-.1m.4.2c-.2.2-.9.2-1.1.3m.6.4c.3-.2.8 0 1.2-.2m.4.4h-1c0 .1-.1.2-.3.1m2.4.8-1.4.1m.5.5c.4-.2 1-.2 1.5-.3m-.3 1.7.6-.1c.8-.1.9-.3 1.6-.3m.4.4-2 .2-.4.1m.4.3c.7 0 1.8 0 2.5-.2m.7.4-1.7.1-1 .2m.6.4h.3c.6-.4 1.5-.3 2.4-.3m.5.4H332l-.9.2m.6.4 1.5-.2h1.7m.2.3h-1.4c-.2 0-.3.2-1.5.2m.4.3 1.3-.2h1.4m-2.1.4 1.7-.1h.7m-15-10.1c.3-.1.2-.2.5-.1l.5-.1h.3m-1.7 0c.2-.2.2-.3.6-.2l.4-.1h.4m5.2 5.5c.2-.1 0-.2.4-.1-.1-.2.3 0 .4-.1h.5m0 1.5 1.5-.4m.8.6c-.6.1-1.4 0-1.8.2m-7.5-7.6a2.3 2.3 0 0 0-1.4.5m8.6 2.5.9-.1m-.7.3 1-.1m-.7.4.7-.1h.3m-.7.3h1.1m.2.2h-.9m.5.4.8-.2m.4.3h-1m.3.4 1-.2m.4.4h-1m.4.3 1-.1m.3.2-.9.2m.3.3 1.1-.1m.3.3h-1m1.9.7-1.2.1m.4.3 1.2-.2m-.3 1.2h.6l1.2-.2m.3.3-1.5.2h-.4m.3.3 2-.2m.6.3H336a7.3 7.3 0 0 1-.9.2m.5.4.6-.2 1.6-.1m.3.3H337l-.9.3m.6.2 1.2-.2h1.3m.2.2h-1c-.3.1-.5.2-1.3.2m.3.2 1-.1 1.1-.1m-1.7.4h1.4l.5-.1m-11.5-7.7c.2 0 .2-.2.5-.2h.6m-1.4 0c.2-.1.2-.2.5-.2h.6m3.8 4.2.5-.1h.3c0-.1.3 0 .4 0m0 1c.3 0 .8 0 1.1-.2m.6.4c-.4.1-1 0-1.5.2m-5.6-5.9c-.4 0-.5.2-.8.4m7 .9 1-.1m-.7.3.9-.1m-.6.4.6-.1h.3m-.6.4 1-.2m.2.2c-.2 0-1 0-1 .2m.4.2s.7-.2.9-.1m.4.2-1 .1m.3.2 1-.1m.3.3-1 .1m.4.3 1-.1m.3.1-1 .2m.4.3 1-.1m.3.3h-1m1.8.6-1 .1m.2.3 1.3-.2m-.4 1.2.5-.1c.6 0 .7-.2 1.2-.1m.2.2a12.4 12.4 0 0 1-1.7.2m.2.3a36.3 36.3 0 0 1 1.9-.2m.5.3H342l-.8.2m.4.3.5-.1 1.5-.2m.4.3h-1.2l-1 .2m.6.3 1.2-.2h1.2m.2.2a3 3 0 0 0-1 0 3 3 0 0 1-1.2.2m.3.1 1-.1h1m-1.7.3h1.3l.5-.1m-10.6-7.1.4-.1h.6m-1.3-.1c.2 0 .2-.2.4-.1h.4l.2-.1m3.6 3.9h.4c0-.2.2 0 .3-.1h.3m0 1c.3 0 .8 0 1.1-.2m.6.4-1.5.1m-5-5.4c-.5 0-.6.2-.9.3"
    }),
    /* @__PURE__ */ jsxs257("g", {
      fill: "#fc0",
      children: [
        /* @__PURE__ */ jsx282("path", {
          d: "m287.6 298.6.6 4.5c-1.1-.4-2.2.2-2.7 1.2-.9 1.7-.1 3 1.5 3.7l2.1 1.2 4-7.8-1.6-.8-1.6 3.1-.4-4.1zm.6 5.9.9.3h.1l-1 2.2-.3-.1c-.7-.4-1.2-.9-.8-1.7.3-.6.7-.8 1.1-.7"
        }),
        /* @__PURE__ */ jsx282("path", {
          fillRule: "evenodd",
          d: "m280.7 302.7 1-1.6-2.3-1.6.8-1.2 2.3 1.6 1.4-2-2.5-1.6.9-1.3 3.8 2.7-4.8 7.2-3.9-2.6.8-1.2z"
        }),
        /* @__PURE__ */ jsx282("path", {
          d: "m279 292.5-2 2.5-.7-.6c-1.4-1.2-2.8-1.2-4 .2-1.3 1.5-.8 2.9.6 4.1l1.9 1.6 5.6-6.7-1.3-1.1zm-4.4 2.8c.3 0 .7.3 1 .6l.3.2-1.6 1.8-.2-.2c-.7-.6-1-1-.4-1.9.4-.4.6-.5 1-.5z"
        }),
        /* @__PURE__ */ jsx282("path", {
          fillRule: "evenodd",
          d: "m268.4 294.6-1.2-1.3 3.6-3.3c.8-.7 1.9-1.8.9-3-1-1-2.3 0-3 .6L265 291l-1.2-1.3 3.9-3.5c1.6-1.4 3.4-1.8 5 0 1.7 1.8 1.1 3.6-.5 5z"
        }),
        /* @__PURE__ */ jsx282("path", {
          d: "M265.1 278.1c-.5 0-1 .1-1.5.5-.8.5-1.4 1.5-.9 2.5-.6-.3-1.3 0-1.9.3-1.4 1-1.4 2.2-.4 3.6l1.3 1.8 7.2-5-1.6-2.2c-.6-.8-1.3-1.4-2.2-1.5m0 1.9c.5 0 1 .4 1.3.9l.2.3-1.8 1.2-.2-.2c-.4-.6-.9-1.4 0-2zm-2.5 2.5c.3 0 .6.2.8.6l.1.2-1.7 1.2v-.2c-.5-.6-.6-1 .1-1.5z"
        }),
        /* @__PURE__ */ jsx282("path", {
          fillRule: "evenodd",
          d: "m264.6 275.3-7.7 4.2-.8-1.6 6.3-3.4-1.1-2.2 1.2-.7zm-11.4-3.5 8-3.5.6 1.6-8 3.5zm-1-9.5a2.7 2.7 0 0 0-.3 2.2c.6 1.5 2.3 2 3.7 1.5 1.4-.4 2.5-1.8 2-3.4a2.8 2.8 0 0 0-1.5-1.6l1.9-.6c.5.5 1 1 1.1 1.8a4.5 4.5 0 0 1-2.9 5.6c-2.4.7-5-.3-5.8-2.8a4.7 4.7 0 0 1-.2-2.1z"
        }),
        /* @__PURE__ */ jsx282("path", {
          d: "m256.4 250.6-8.2 5 .2 1.3 9.4 2-.3-1.9-2-.4-.5-3.1 1.7-1zm-2.7 3.6.4 2.1-3.3-.4zm-2-19.9c-2.2 0-4 1.6-4.2 4l-.2 2.6 8.7.7.2-2.5a4.3 4.3 0 0 0-4-4.8zm-.3 2a3 3 0 0 1 .6 0c1.6.1 2.6 1 2.4 3v.2l-5.2-.4v-.3c.1-1.6.9-2.4 2.2-2.5"
        }),
        /* @__PURE__ */ jsx282("path", {
          fillRule: "evenodd",
          d: "m250.2 229.5 1.9.4.6-2.8 1.4.3-.6 2.8 2.3.5.6-2.9 1.5.3-1 4.6-8.5-1.8 1-4.6 1.4.3zm3.3-11.4 1.8.6 1-2.6 1.4.6-1 2.6 2.2.8 1-2.7 1.4.5-1.7 4.4-8.1-3.1 1.7-4.4 1.4.5zm8.9-2.3-7.8-4 .8-1.5 6.4 3.3 1.2-2.2 1.3.6zm1.9-15.9c-.6 0-1 .2-1.4.7a1 1 0 0 0 0 1.5c1.3.8 3-2.4 5.3-.7 1.4 1 1.7 2.7.6 4.2-.8 1-1.9 1.3-3 1.2l-.2-1.6c.7.3 1.5.1 2-.5.4-.6.2-1.3-.4-1.7-.7-.5-1.4 0-2 .4-1 .7-2 1-3.1.2a2.6 2.6 0 0 1-.6-3.6 3.9 3.9 0 0 1 2.3-1.5z"
        }),
        /* @__PURE__ */ jsx282("path", {
          d: "m268.1 192.3-1 1 4 8.7 1.3-1.4-.7-1.7 2.1-2.3 1.8.8 1.3-1.4-8.7-3.8zm1.4 2.4 2.8 1.3-1.4 1.4z"
        }),
        /* @__PURE__ */ jsx282("path", {
          fillRule: "evenodd",
          d: "m278.3 195-5.5-6.8 1.4-1.1 4.5 5.6 2-1.6 1 1.2zm4.5-14 1.6-1 1.8 9.5-.8.5-7.8-5.7 1.6-1 5 3.8z"
        }),
        /* @__PURE__ */ jsx282("path", {
          d: "m290.6 176.8-1.3.6.5 9.6 1.7-.7v-2l2.8-1.4 1.4 1.4 1.7-.7zm.3 2.9 2.2 2.2-1.8.8-.3-3zm9.4-6-1.4.3-2.4.7 2.5 8.3 2.4-.6a4.3 4.3 0 0 0 3-5.5c-.6-1.9-2.1-3.1-4-3.1zm0 1.9c1 0 1.8.7 2.2 2 .4 1.4 0 2.7-2 3.2l-.2.1-1.5-5 .3-.1zm10.5-4.3h-.5a4.4 4.4 0 0 0-3.8 5.1 4.4 4.4 0 0 0 5 4 4.5 4.5 0 0 0 3.9-5.1 4.5 4.5 0 0 0-4.6-4m-.2 1.9c1.4-.2 2.5 1 2.7 2.3.2 1.1-.7 2.8-2 3-1.4.1-2.6-1.2-2.8-2.4-.1-1.3.7-2.7 2.1-2.9m7.4-2.4v8.8h1.7V176l2.2 3.5h2.1l-2.5-3.7c1.2-.1 1.9-1.2 1.9-2.4 0-1.8-1.2-2.6-3-2.6zm1.8 1.6h.3c.8 0 1.5.2 1.4 1.2 0 1-.6 1.2-1.5 1.2h-.2z"
        }),
        /* @__PURE__ */ jsx282("path", {
          fillRule: "evenodd",
          d: "m336.6 174.3-.5 2 2.7.6-.3 1.4-2.8-.7-.5 2.3 2.8.8-.4 1.4-4.5-1.2 2.1-8.4 4.5 1.1-.3 1.5zm6.6 0 1.2.5 2.1 7.5 2.2-5.5 1.7.7-3.3 8.3-1.2-.5-2.2-7.5-2.2 5.5-1.6-.6zm9.3 14.3 4.7-7.4 1.5 1-3.9 6 2.1 1.4-.8 1.2z"
        }),
        /* @__PURE__ */ jsx282("path", {
          d: "m365.4 186.6-8.4 4.7 1.4 1.2 1.8-1 2.4 2-.6 2 1.5 1.1 3-9.1zm-1.3 2.5-1 3-1.6-1.3zm14.3 11.2-9.2 2.3 1 1.5 2-.4 1.8 2.5-1 1.7 1 1.5 5.3-8-.9-1.2zm-1.8 2-1.8 2.6-1.1-1.6z"
        }),
        /* @__PURE__ */ jsx282("path", {
          fillRule: "evenodd",
          d: "m375.4 211.9-.8-1.6 8.7-2.7.6 1.1-4.1 4.6 6-.6.6 1.1-7.3 5.3-.9-1.6 4.6-3.1-6 .6-.2-.5 4-4.3zm11.6 8.3-1.8.6 1 2.7-1.5.5-.9-2.7-2.2.7 1 2.8-1.5.5-1.5-4.5 8.3-2.7 1.5 4.4-1.4.5z"
        }),
        /* @__PURE__ */ jsx282("path", {
          d: "m390.3 225.7-8.6 1.8.4 1.8 3.4-.8-3 3 .6 2 3-3.2a2.2 2.2 0 0 0 2.7 1.2c1.9-.3 2.4-1.7 2-3.4zm-1.1 2.1v.2c.2.9.1 1.6-.8 1.7-1 .3-1.3-.3-1.5-1.2v-.2z"
        }),
        /* @__PURE__ */ jsx282("path", {
          fillRule: "evenodd",
          d: "m392 236-8.6 1-.2-1.7 8.7-1zm-1.8 9.5a3 3 0 0 0 .8-2c0-1.7-1.5-2.7-3-2.6-1.5 0-3 1-2.9 2.6 0 .8.4 1.5 1 2h-2a4.8 4.8 0 0 1-.6-2 4.5 4.5 0 0 1 4.4-4.5c2.5 0 4.7 1.7 4.8 4.4a4.4 4.4 0 0 1-.5 2z"
        }),
        /* @__PURE__ */ jsx282("path", {
          d: "m383.7 247.1-.2 1.9 1.8.9-.4 3.1-2 .5-.2 1.8 9.3-2.2.2-1.4zm3 3.6 2.7 1.2-3 .7.3-2z"
        }),
        /* @__PURE__ */ jsx282("path", {
          fillRule: "evenodd",
          d: "M384 272.1a2.8 2.8 0 0 0 1.6-1.5c.7-1.6-.4-3-1.8-3.6-1.3-.5-3-.1-3.7 1.4a2.8 2.8 0 0 0 .2 2.2l-2-.7a4.9 4.9 0 0 1 .3-2.1 4.5 4.5 0 0 1 5.8-2.5c2.4.9 3.7 3.4 2.8 5.9a4.6 4.6 0 0 1-1.3 1.7zm-1.4 4.7-1.7-.9-1.3 2.5-1.3-.7 1.3-2.5-2-1.1-1.5 2.6-1.3-.7 2.3-4.2 7.6 4.2-2.2 4.1-1.3-.7zm-1.7 6.4-.7 1-7.7.3 4.7 3.5-1 1.4-7.3-5.2.8-1 7.7-.3-4.8-3.5 1.1-1.4zm-9 8.7 1.2-1.3 1 1-3.7 4-1-1 1.2-1.4-5.2-5 1.2-1.3z"
        }),
        /* @__PURE__ */ jsx282("path", {
          d: "m362.8 290.7-1.4 1.1 2.3 2.8-4-1.3-1.6 1.4 4.3 1.1c-.8 1-.6 2.2.2 3 1.1 1.5 2.6 1.3 4 .2l1.8-1.6zm1.7 5 1.5 1.8-.2.1c-.6.5-1.2.8-1.8 0-.7-.7-.3-1.3.4-1.8zm-7.1-.4-1.6 1 .3 1.9-2.7 1.6-1.5-1.1-1.6 1 7.7 5.7 1.1-.7-1.7-9.5zm-1 4.5.8 3h-.1l-2.4-2z"
        }),
        /* @__PURE__ */ jsx282("path", {
          fillRule: "evenodd",
          d: "m348.7 300.3 3.8 8-1.6.7-3-6.5-2.4 1-.6-1.3z"
        })
      ]
    })
  ]
});
var Sv_default = SvgSv;

// src/country-flag-icons/generated/Sx.tsx
init_esm_shims();
import { jsx as jsx283, jsxs as jsxs258 } from "react/jsx-runtime";
var SvgSx = (props) => /* @__PURE__ */ jsxs258("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx283("defs", {
      children: /* @__PURE__ */ jsx283("clipPath", {
        id: "sx_svg__a",
        children: /* @__PURE__ */ jsx283("path", {
          fillOpacity: 0.7,
          d: "M0 0h682.7v512H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs258("g", {
      clipPath: "url(#sx_svg__a)",
      transform: "scale(.9375)",
      children: [
        /* @__PURE__ */ jsx283("path", {
          fill: "#ed2939",
          fillRule: "evenodd",
          d: "M0 0h768v256H341.3z"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "#002395",
          fillRule: "evenodd",
          d: "M0 512h768V256H341.3z"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "#fff",
          fillRule: "evenodd",
          d: "m0 0 341.3 256L0 512z"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "#ff0",
          d: "m172.3 193.2.1-4s-2.1-3.4.4-7c0 0-5.3-2.8-4-7.2 0 0-4.8-1.2-4.5-6.4 0 0-5-.3-5.6-4.7 0 0-5.1.8-7.4-3.4 0 0-5 1-6.4-2.5 0 0-4.9 1.6-7.7-2.5 0 0-5.2 2.1-7.3-1.8-2.1 3.9-7.3 1.8-7.3 1.8-2.8 4.1-7.7 2.4-7.7 2.4-1.4 3.5-6.3 2.5-6.3 2.5-2.3 4.3-7.4 3.4-7.4 3.4-.5 4.4-5.6 4.8-5.6 4.8a6 6 0 0 1-4.4 6.4c1.3 4.3-4 7.1-4 7.1 2.6 3.7.5 7 .5 7l-.1 3.7z"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 0.3,
          d: "M377.2 843.1v-3.5s-1.8-3 .4-6c0 0-4.6-2.5-3.5-6.3 0 0-4.2-1-3.9-5.6 0 0-4.5-.3-5-4.1 0 0-4.4.7-6.3-3 0 0-4.4.8-5.6-2.2 0 0-4.3 1.5-6.8-2.1 0 0-4.5 1.8-6.3-1.6-1.9 3.4-6.4 1.6-6.4 1.6-2.4 3.5-6.7 2-6.7 2-1.2 3.1-5.5 2.3-5.5 2.3-2 3.7-6.5 3-6.5 3-.4 3.7-4.9 4-4.9 4a5.1 5.1 0 0 1-3.7 5.6c1 3.8-3.5 6.2-3.5 6.2 2.2 3.2.3 6.2.3 6.2v3.2z",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "red",
          d: "M170.3 188.2c-13.3-1.3-28.6-4.5-40.4 2.2-8-4.7-19-4.4-28.4-3.5-5.1 1-11.1 1-16.5 1.8l-.8.1c-9.7.7-18.5-2.2-27-6 2.8 15.2 5.7 30.7 7.2 46.6C67.6 253 53.3 272.7 59 296c3.5 11.2 15.8 17.7 27 19a214.7 214.7 0 0 1 32.2 4.5 32 32 0 0 1 5.5 1.9 19.7 19.7 0 0 1 6.6 4.7c6-6.3 15-8.1 23.7-9 15.8-1.9 35.3-.9 45-15.2v-.8c5.3-8 4.6-20 2.3-29-.2-3.1-1-5.9-1.5-8.9-9.6-25.5-1.3-54.2 2.8-80a61 61 0 0 1-16.4 5.5c-4.5.6-9.5.4-14 .1z"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "#80cfe1",
          d: "M190.2 261.5c0 1.6.9 3 1.2 4.5 1.9 11.2 3.6 26-7.8 32.9-12.8 8-29.4 4.6-44.1 8.9-3 .8-7 3.5-9 5.4-1.4-.9-2.7-2.2-4.4-3-12.1-6.4-27.9-4.3-41.5-7.8-6.9-2.1-14-7.5-15.8-14.5-4.4-18.4 6.2-34.1 5-52.4-.8-14-3.2-27.3-6.4-40.4 10.7 5 23 5.8 35 3.4A51.6 51.6 0 0 1 130 201c4.6-2 10-2.9 15-3.4 9.3 1 19.4 2.6 29.1 2.6 6.5-.4 12.4-2.2 18-4.7-3.3 21.6-9.8 44.2-1.9 66"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "#fff",
          d: "M171 265.8v-20.4h2.4l-31-20-.1-10.5h3l-15.6-11-15.4 11h3v10.5l-30.9 20h2.5v20.3H171"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 1.2,
          d: "M376 906.5v-17.8h2.1l-27-17.5-.1-9h2.6l-13.6-9.8-13.5 9.7h2.6l.1 9.1-27 17.5h2.2v17.7z",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "#fff",
          d: "M180.6 292.5v6.3H80.5v-6.4z"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 1.2,
          d: "M384.4 929.8v5.5H297v-5.6h87.4z",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "#fff",
          d: "M87.1 292.1v-21.5h4l-.2 21.7.2-21.6-5.8-.1v-4.7l89.4.2v4.5h-5.4v21.8l-.1-21.8h4l.2 21.6"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 1.2,
          d: "M302.8 929.4v-18.8h3.5l-.2 19 .2-18.8-5-.2v-4l78 .1v4h-4.8l.1 19-.2-19h3.6l.1 18.8",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 1.2,
          d: "M319.6 924.8v-13.1H309v13l10.5.1",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 1.2,
          d: "M312 914.4v7.6h4.8v-7.6h-4.9m59 10.4-.1-13h-10.4v13h10.5",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 1.2,
          d: "M363.2 914.5v7.6h4.8v-7.6h-4.8m7.6-11v-13h-10.5v13z",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 1.2,
          d: "M363.1 893.2v7.6h4.8v-7.6h-4.8m-43.6 10.3v-13.1H309v13h10.5z",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 1.2,
          d: "M311.9 893.1v7.6h4.8v-7.6h-4.8m26.6 10.4v-13.1H328v13h10.5",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 1.2,
          d: "M330.8 893.1v7.6h4.8v-7.6h-4.8m22.3 10.4v-13l-10.5-.1v13l10.5.1",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 1.2,
          d: "M345.4 893.1v7.6h4.9v-7.6h-4.9",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "#fff",
          d: "m147.7 257.8.2 34.6H113l-.1-34.6z"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 1.2,
          d: "m355.7 899.5.1 30.2h-30.3l-.1-30.2zm-30.5 8.6h30.6M329 929.7v-21.4m23.1 21.4v-21.3m14.7-21.8-17-12.4h-19.3l-17 12.4h53.3M332 863.8v7.6h16.2v-7.6H332",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 1.2,
          d: "M336.4 865.7v3.8h7.4v-3.8h-7.4M340 855l9 6.4h-17.9l9-6.4",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "#fff",
          d: "M171.4 202c2.9 0 3.6 12 3.6 18 2.6.8 8.1 4.3 10.6 7.4h-28.2c2.4-3.1 7.9-6.6 10.4-7.3 0-6 .6-18.2 3.6-18"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 1.2,
          d: "M376.3 850.8c2.6 0 3.2 10.5 3.2 15.8 2.2.6 7.1 3.7 9.2 6.4h-24.6c2.1-2.7 7-5.8 9.1-6.4 0-5.3.6-15.8 3.1-15.8m-49.5 49.5h2.2l-.6 1.2s1 1.4 0 3l.6 1h-2.2l.6-1s-1-1.8 0-3l-.6-1.2m4.5 0h2.2l-.6 1.2s1 1.4 0 3l.6 1h-2.2l.6-1s-1-1.8 0-3l-.6-1.2m5 0h2.1l-.6 1.2s1 1.4 0 3l.6 1h-2.1l.5-1s-1-1.8 0-3l-.6-1.2zm5.5 0h2.2l-.7 1.3s1.1 1.3 0 2.9l.6 1h-2.1l.6-1s-1-1.8 0-3zm4.9 0h2.2l-.7 1.3s1.1 1.3 0 2.9l.6 1h-2l.5-1s-1-1.8 0-3l-.6-1.1m4.9 0h2.2l-.7 1.2s1.1 1.3 0 2.9l.6 1h-2l.5-1s-1-1.8 0-3l-.6-1.1",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "#ff0",
          d: "M130.5 336.8c13 0 29-2.7 36.5-6.5l16.5-1.5.4 20.1c-14 7.7-46.2 9.4-53.3 9.3-7.1 0-39.7-1.6-53.8-9.3l.2-20.2 16.5 1.5a98 98 0 0 0 37 6.6"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 0.3,
          d: "M340.7 968.4c11.4 0 25.3-2.3 31.9-5.7l14.3-1.2.3 17.5c-12.1 6.7-40.3 8.2-46.4 8.1-6.2 0-34.7-1.4-47-8.2l.2-17.5 14.4 1.3c6.6 3.4 21 5.7 32.3 5.7",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "#ff0",
          d: "m34.4 251 14.5 4.6-4.4 23.5-13.7 2.2s-2.3-12.4 3.6-30.3"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 0.3,
          d: "m256.9 893.6 12.6 4-3.8 20.5-12 1.9s-2-10.8 3.2-26.4z",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "#7e7e7e",
          d: "m44.5 278.9-13.7 2.4 8.7-12.4z"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 0.3,
          d: "m265.7 917.9-12 2 7.6-10.7 4.4 8.7",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "#ff0",
          d: "m25.7 268 14 1c.3 11.8 1.8 57 55.8 59.5L93.8 345c-65.7.6-70.7-55.5-68-77"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 0.3,
          d: "m249.3 908.4 12.2.8c.3 10.4 1.5 49.8 48.7 52l-1.5 14.4c-57.4.6-61.7-48.4-59.4-67.2zm44.8 70.1 14.4-3.1",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "#ff0",
          d: "m225.4 251.2-14.4 4.6 4.6 23.4 13.8 2.2s2.2-12.3-4-30.2"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 0.3,
          d: "m423.5 893.7-12.6 4 4 20.5 12 2s2-10.8-3.4-26.5z",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "#7e7e7e",
          d: "m215.6 279 13.7 2.5-8.8-12.4-5 9.9"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 0.3,
          d: "m414.9 918 12 2.1-7.7-10.7-4.3 8.6",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "#ff0",
          d: "m234.3 268.1-14 1c-.2 11.8-1.3 57-55.3 59.5l2 16.4c65.7.8 70.2-55.4 67.4-76.9"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 0.3,
          d: "m431.2 908.5-12.2.8c-.2 10.4-1 49.9-48.2 52l1.6 14.3c57.4.7 61.3-48.3 58.8-67zm-44.2 70-14.4-3",
          transform: "matrix(1.1464 0 0 1.1461 -260 -773.1)"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "#009fc5",
          d: "M121.8 346.7c-.4.2-1 .3-1.5.2l-2.6-.1.2-3.3 2.6.2c.5 0 1 .1 1.2.3.5.2.7.7.7 1.4 0 .6-.3 1-.7 1.3m-4.3 5 .2-3.9 3 .2c1 .1 1.8-.2 2.3-.7.5-.4.8-1 .8-1.8a2.5 2.5 0 0 0-.6-2 3.2 3.2 0 0 0-2-.9l-4.4-.3-.6 9.4zm9.4-7.7h3.2l1.1.2c.5.3.7.7.7 1.4 0 .6-.1 1-.5 1.3a2.6 2.6 0 0 1-1.4.3h-3.1zm0 8.2v-4l3 .1c.5 0 1 0 1.2.2.4.2.7.6.7 1.2v2.3l.2.3h1.6v-.2a.8.8 0 0 1-.4-.5 3.4 3.4 0 0 1-.1-.8v-1.3c0-.6-.2-1-.4-1.2a1.7 1.7 0 0 0-.8-.6c.4-.2.8-.5 1-.8.2-.4.4-.8.4-1.4 0-1-.5-1.8-1.4-2.2a4.7 4.7 0 0 0-1.8-.4h-4.5v9.4zm10-2a4.5 4.5 0 0 1-1-2.6c0-1.3.2-2.3.8-3a3.1 3.1 0 0 1 2.4-1 3 3 0 0 1 2.4.8c.7.6 1 1.5 1.1 2.6a5 5 0 0 1-.6 2.8c-.5.8-1.3 1.3-2.5 1.3s-2-.2-2.7-.9m-1.5-5.9a6 6 0 0 0-.8 3.3c.1 1.4.5 2.6 1.4 3.4a4.6 4.6 0 0 0 3.6 1.3 4.4 4.4 0 0 0 3.5-1.8 6 6 0 0 0 1-3.6 5 5 0 0 0-1.2-3.1c-.9-1-2.2-1.5-3.9-1.4-1.6 0-2.8.7-3.6 1.9m44-13.5c1-.1 1.8-.1 2.5.1 1 .4 1.7 1.1 2.2 2.3l-1.3.2a2.4 2.4 0 0 0-1.2-1.3 3.5 3.5 0 0 0-2-.2 3 3 0 0 0-2 1.3c-.5.7-.7 1.7-.5 3a4.5 4.5 0 0 0 1.2 2.6c.6.6 1.5.8 2.6.7a3.2 3.2 0 0 0 2-1.1c.6-.6.7-1.4.5-2.5l-3 .5-.1-1 4.2-.7.8 5h-.9l-.5-1-1 1c-.5.5-1.2.7-2 .9a4.3 4.3 0 0 1-3.2-.7 5 5 0 0 1-1.9-3.4 5.1 5.1 0 0 1 .7-4 4.1 4.1 0 0 1 3-1.7m9.4-.7 3-1.1c.4-.2.8-.2 1.1-.2.6 0 1 .4 1.2 1 .2.6.2 1.1 0 1.5-.3.3-.7.6-1.3.8l-2.8 1zm3 7.7-1.4-3.7 2.8-1a3 3 0 0 1 1.1-.3c.5.1.9.4 1.2 1l.6 1.4.3.7.2.3 1.5-.6v-.2c-.3 0-.5-.1-.6-.4-.2-.1-.3-.4-.4-.7l-.5-1.2c-.2-.5-.5-.8-.7-1a2.4 2.4 0 0 0-1-.2l.6-1.2c0-.4 0-.9-.2-1.4-.4-1-1-1.6-2-1.6a4.5 4.5 0 0 0-1.9.3l-4.2 1.5 3.4 8.8 1.2-.4m11-4.7-5.3-7.8 5.8-3.8.7 1-4.8 3 1.6 2.4 4.5-2.8.6.9-4.5 2.8 1.8 2.7 5-3.2.6 1zm4.7-13.8 1.5-1.7c.8-.8 1.5-1.1 2.3-1 .9 0 1.7.5 2.6 1.3a4.7 4.7 0 0 1 1.4 2c.2.6.1 1.1 0 1.6a4 4 0 0 1-.7 1l-1.5 1.6zm8.1 3.6c1.1-1.2 1.3-2.4.7-4a6.7 6.7 0 0 0-1.7-2.1 5.2 5.2 0 0 0-3.1-1.4c-1.2-.1-2.2.3-3.1 1.3l-2.6 2.8 7.2 6.3 2.6-2.8m5.6-7.3-8.3-5 .7-1 8.3 4.9zm3.3-5.6-9-3.6 2.6-6.3 1.1.4-2.1 5.2 2.7 1 2-4.7 1 .4-2 4.8 3 1.2 2.3-5.2 1 .4zm4-11-9.4-2 .4-1.5 8.7-3-7.7-1.7.3-1.1 9.4 2-.3 1.4-8.7 3 7.7 1.7zm-.8-12 .1-1.2c.6 0 1 0 1.4-.2.7-.4 1-1.1 1.2-2.1a3.7 3.7 0 0 0-.1-1.4c-.2-.7-.6-1.2-1.3-1.2-.6-.1-1 0-1.2.3-.3.3-.5.8-.7 1.5l-.5 1.2c-.2.8-.5 1.4-.8 1.7-.4.6-1 .8-1.8.7a2.8 2.8 0 0 1-2-1c-.6-.6-.8-1.5-.7-2.6.1-1 .4-1.8 1-2.4.5-.6 1.3-1 2.4-.8l-.1 1.2c-.5 0-1 0-1.2.3-.6.3-.9 1-1 1.9 0 .7 0 1.2.4 1.6.3.4.6.6 1 .6.5 0 .9 0 1.1-.4l.7-1.7.4-1.3c.2-.6.5-1 .8-1.4.5-.5 1.2-.7 2-.7 1.1.1 1.9.6 2.2 1.4.4.8.6 1.6.5 2.7a3.9 3.9 0 0 1-1.2 2.6c-.7.6-1.5.8-2.6.7M32 286.7l.3 1.2c-.6.1-1 .3-1.3.6-.5.5-.7 1.3-.5 2.4a4 4 0 0 0 .4 1.2c.4.7 1 1 1.7.9.5-.1.8-.3 1-.7l.3-1.6v-1.3c0-.8.2-1.5.3-1.8.3-.6.9-1 1.7-1.2.8-.1 1.6 0 2.2.6.7.4 1.1 1.2 1.3 2.2a4 4 0 0 1-.3 2.6c-.4.8-1 1.2-2.1 1.4l-.2-1.1a3 3 0 0 0 1-.6c.5-.5.6-1.2.5-2.1-.2-.8-.4-1.3-.8-1.5a1.5 1.5 0 0 0-1.2-.3 1 1 0 0 0-1 .7l-.1 1.8-.1 1.3a3.5 3.5 0 0 1-.4 1.6 2.2 2.2 0 0 1-1.7 1.2c-1 .2-2-.1-2.5-.8a5 5 0 0 1-1.2-2.4 3.8 3.8 0 0 1 .5-2.9 3 3 0 0 1 2.2-1.3m-.6 12.3 9.3-2.8 2.1 6.5-1.1.4-1.8-5.3-2.8.8 1.7 5-1.1.3-1.6-5-3.2 1 1.8 5.4-1 .3zm4.1 11.3 8.5-4.5 1 1.6-5.9 6.1 8.5-1.4.9 1.5-8.5 4.5-.6-1 5-2.7.9-.4 1.3-.7-8.5 1.5-.6-1.1 5.8-6.2-.3.2-1 .5a7 7 0 0 1-.9.5l-5 2.6zm15.8 12.5c-.4-.1-.8-.4-1.2-.8l-1.8-1.8 2.4-2.2 1.8 1.8a3 3 0 0 1 .7 1c.2.5 0 1-.5 1.5-.5.4-1 .6-1.4.5m-6.8.8 3-2.7 2 2.1c.8.7 1.5 1 2.2 1a3 3 0 0 0 2-.8 3 3 0 0 0 .8-2c0-.6-.3-1.3-.9-1.9l-3-3-7 6.4zm8.4 7.5 5.1-8 6 3.6-.6 1-5-3-1.5 2.5 4.5 2.7-.5 1-4.6-2.8-1.7 2.7 5 3-.6 1zm15-1.6 3.1 1 1 .5c.4.4.5.9.2 1.5-.2.6-.4 1-.9 1.1l-1.5-.1-2.9-1zm-2.6 7.9 1.3-3.8 2.8.9c.5.1 1 .3 1.1.5.3.3.4.8.3 1.4l-.5 1.5-.1.7v.3l1.5.5v-.2l-.2-.7.2-.7.4-1.2c.1-.6.2-1 0-1.2 0-.3-.3-.6-.6-.9.5 0 1-.2 1.3-.5.3-.3.6-.7.7-1.2.4-1 .2-1.9-.6-2.5a5.2 5.2 0 0 0-1.6-.9l-4.3-1.3-3 8.9z"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "#bc715f",
          d: "M78.5 175.6c1-2.7 11.3-10 44.8-6.8 0 0 5.7 3.5 9 3 2-.2-1 .2-3.6-1.9-2.5-2-3-6.3 2.7-6.1 5.8.1 27.3 1.3 27.7 3.3.4 1.9-11.4 2.7-15.7 2.6-4.4-.1-4 2.1.4 2 13.7-.6 28.6-5.4 44.3 5.8 1.9 1.3-4.7 1.5-9.8-.6 0 0-14 .7-20-.3 0 0-4.5 3.8-10.6 3.4.8 2-2.2 9.2-21 3.7-3.2 1-14.5 2.9-13.3-.5-3 0-8.2 1-9-.7-.8-1.7 9.2-4.2 11-6 0 0-21.2.2-25.2-1.3 0 0-12.5 2.8-11.7.4"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "#008737",
          d: "M85.3 205.2c.4-.6.6-1.8 1.6-1.7 2 .5 3.5 4.4 6 1.9 1-.2 1.3 1 2 1.2.5 2.1 2.3-.5 3.5-.3 2.8-1.2 6.1-1.5 9.4-1 0 2.2-1.6 4.5-3.6 5.7 0 2 2 3.4 1.9 5.5-.3.8 0 2-1.2 2.3-1.6-.3-3-.4-4.3-1.3-.2-.1-.3-.4-.6-.3-.2.7 1 1.4 1.4 2.1-.8 1.3-2 .1-3.1.1-.3.8 0 1.7-.8 2.2-1.3 0-1.6-1.5-2.4-2.2-.9.9.6 1.4.8 2.1-.6 2.8-.5 5.5-3.2 7.3l-1.9.9c-.5-1.4-.2-3.5-.5-5-1 1.8-2 3.4-3.5 4.9-2-.6-3-2.8-3.4-4.7a5.8 5.8 0 0 1 1.3-6.2c-.5-1-2.5-.8-2.8-2.4-3-2-4.5 3.3-6.4.6a8.6 8.6 0 0 1 2-7.6c-.5-1-1.9-.8-2.7-1.4-1.8-1.6-4.5-3.2-4.3-6a14 14 0 0 1 14.7 3.3"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "#ff0",
          d: "M87.9 204.9c-.1 2.3 1.5.6 2.8 2-1-.4-1.7 1.7-2.7.5l-.6.6c.4.8 1 .9.4 1.8-1 .4-1.3-1-1.8-1.5 0-.2.2-.6-.2-.8-.6.5-1.2.7-2 .6-.2-.4-.7-1-.2-1.4.8-1 2 .4 2.6-.3.1-.7-.5-1.5.3-2 .5.1 1.2-.2 1.4.5m6.2 1.9c.1.4-.2 1 .4 1.4.8-.4 1.6-.1 2 .6 0 .4.1 1-.4 1.2l-1.2-.3c.1-.2-.3-.3-.4-.6-.5-.1-.9.3-1.2.6.3.4 1 .7.8 1.2-.7.7-1-.6-1.8-.2-.6-.2.1-1.3-.7-1.7-1 0-.3 1.6-1.6 1-.4-.5-.8-1.2-.4-1.7a1.6 1.6 0 0 1 1.9.2c.8-.9.8-4.1 2.7-1.7m-7.8 3.3c.5.8-.2 1.8.5 2.6 1-2 2 .4 3.2.2.4.5.1 1.1.2 1.6-1.5.4-3.3.9-4.6-.3l-.4.4c.8.7 1.5 1.6.9 2.8-1.1.2-2.9.3-3.4-.9-.3-1 .7-1.6-.4-2.4-.7 1-.7 2.2-2.2 1.3a1.9 1.9 0 0 1-.8-2.5c1-1.6 2.8 0 3.8-.7.2-1.4-.3-2.6 1-3.3 1-.2 1.5.6 2.2 1.2"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "#fff",
          d: "M90.6 211c-.5 2.3-2.2-.1-3-.2 1-2 1.7.6 3 .2m5.4 2.5c-1.2.3-1-1.2-1.6-1.8l.5-.4c.4.5.7 1.5 1.1 2.2"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "#ff0",
          d: "M94.4 213c.3.8-.8 1.5.2 2l.8-.7c.9.2 1.8.4 2.4 1.2.6 1.7-1.1 1.7-2 2.2h-1c.2-.6-.5-.8-.6-1a1 1 0 0 0-1.1.3c.2 1 1.5 2 .2 2.9-1.2 0-3 .4-2.9-1.2-.4-1 1.2-2.3-.5-2.4-.6 1.3-1.2 2.4-2.7 1.3l.2-1.8c1.4 0 3.1.3 3.7-1.3.4-1.1-.7-2.2.3-3 1.5-.4 2.3.6 3 1.5"
        }),
        /* @__PURE__ */ jsx283("path", {
          d: "M93.4 215.6c.3.9-.6 1-1.1 1.4-.6 0-1-.2-1.4-.6-.3-1 .5-1.2 1-1.6.7-.3 1 .5 1.5.8"
        }),
        /* @__PURE__ */ jsx283("path", {
          fill: "#fff",
          d: "M92.5 216.2c-.1.2-.4.1-.6.2l-.2-1c.5 0 1 .1.8.8"
        })
      ]
    })
  ]
});
var Sx_default = SvgSx;

// src/country-flag-icons/generated/Sy.tsx
init_esm_shims();
import { jsx as jsx284, jsxs as jsxs259 } from "react/jsx-runtime";
var SvgSy = (props) => /* @__PURE__ */ jsxs259("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx284("path", {
      fill: "#000001",
      d: "M0 0h640v480H0Z"
    }),
    /* @__PURE__ */ jsx284("path", {
      fill: "#fff",
      d: "M0 0h640v320H0Z"
    }),
    /* @__PURE__ */ jsx284("path", {
      fill: "#ce1126",
      d: "M0 0h640v160H0Z"
    }),
    /* @__PURE__ */ jsx284("path", {
      fill: "#007a3d",
      d: "m161 300 39-120 39 120-102-74.2h126M401 300l39-120 39 120-102-74.2h126"
    })
  ]
});
var Sy_default = SvgSy;

// src/country-flag-icons/generated/Sz.tsx
init_esm_shims();
import { jsx as jsx285, jsxs as jsxs260 } from "react/jsx-runtime";
var SvgSz = (props) => /* @__PURE__ */ jsxs260("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx285("path", {
      fill: "#3e5eb9",
      d: "M0 0h640v480H0Z"
    }),
    /* @__PURE__ */ jsx285("path", {
      fill: "#ffd900",
      d: "M0 90h640v300H0Z"
    }),
    /* @__PURE__ */ jsx285("path", {
      fill: "#b10c0c",
      d: "M0 120h640v240H0Z"
    }),
    /* @__PURE__ */ jsxs260("g", {
      fill: "#ffd900",
      stroke: "#000",
      transform: "translate(-43.2) scale(1.2)",
      children: [
        /* @__PURE__ */ jsxs260("g", {
          id: "sz_svg__a",
          children: [
            /* @__PURE__ */ jsx285("path", {
              fill: "#fff",
              d: "m492.9 154.3-24.3 8.6 24.2 8.5 24.3-8.5z"
            }),
            /* @__PURE__ */ jsx285("rect", {
              width: 357.1,
              height: 5.7,
              x: 122.8,
              y: 160,
              rx: 3.1,
              ry: 2.9
            }),
            /* @__PURE__ */ jsx285("path", {
              d: "M471.4 165.7a3 3 0 0 0 2.9-2.8 3 3 0 0 0-2.9-2.9m-2.8 5.7a3 3 0 0 0 2.8-2.8 3 3 0 0 0-2.8-2.9m-2.9 5.7a3 3 0 0 0 2.9-2.8 3 3 0 0 0-2.9-2.9"
            })
          ]
        }),
        /* @__PURE__ */ jsx285("use", {
          xlinkHref: "#sz_svg__a",
          width: "100%",
          height: "100%",
          x: -23.3,
          y: 17.1
        }),
        /* @__PURE__ */ jsx285("rect", {
          width: 485.7,
          height: 8.6,
          x: 59.8,
          y: 195.7,
          strokeWidth: 1.1,
          rx: 4.2,
          ry: 4.3
        })
      ]
    }),
    /* @__PURE__ */ jsx285("path", {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 1.2,
      d: "M488.2 240c-34.3 34.3-80 102.9-171.4 102.9-80 0-137.1-68.6-171.4-102.9 34.2-34.3 91.4-102.9 171.4-102.9 91.4 0 137.1 68.6 171.4 102.9z"
    }),
    /* @__PURE__ */ jsx285("path", {
      d: "M304.8 173c9.2 10.2 1.5 14.3 11.2 15 10.2.7 4.4 10.8 13 11.2 6 .2-.6 24.2 5.1 32 5.9 8.3 10.8 2.5 11 8.4 0 6.2-16 5.5-16.3 24.5-.5 10.9-13.6 11.6-14.2 18.6-.8 6.6 25.8 10.3 25.4 16.2-.3 6-28.7 5-30 11.7-.6 6 39 11 42.2 28.5-6 2-22.7 3.7-35.4 3.8-80 0-137.1-68.6-171.4-103 34.3-34.2 91.4-102.8 171.4-102.8 0 0-23.7 21.7-12 35.8z"
    }),
    /* @__PURE__ */ jsx285("g", {
      stroke: "#fff",
      transform: "translate(-43.2) scale(1.2)",
      children: /* @__PURE__ */ jsxs260("g", {
        id: "sz_svg__d",
        strokeWidth: 6.9,
        children: [
          /* @__PURE__ */ jsxs260("g", {
            id: "sz_svg__c",
            children: [
              /* @__PURE__ */ jsx285("path", {
                id: "sz_svg__b",
                d: "M214 192.4v-22.9m13.8 0v22.9m13.8-22.9v22.9"
              }),
              /* @__PURE__ */ jsx285("use", {
                xlinkHref: "#sz_svg__b",
                width: "100%",
                height: "100%",
                y: 38.1
              })
            ]
          }),
          /* @__PURE__ */ jsx285("use", {
            xlinkHref: "#sz_svg__c",
            width: "100%",
            height: "100%",
            x: 41.6
          })
        ]
      })
    }),
    /* @__PURE__ */ jsx285("use", {
      xlinkHref: "#sz_svg__d",
      width: "100%",
      height: "100%",
      x: 104.8,
      stroke: "#000",
      transform: "translate(-43.2) scale(1.2)"
    }),
    /* @__PURE__ */ jsxs260("g", {
      fill: "#a70000",
      children: [
        /* @__PURE__ */ jsx285("path", {
          fill: "#333",
          stroke: "#000",
          d: "M570.4 236c-5.2 8.9 4-3 26.4 12a21.6 21.6 0 0 1 7.8 15.3c-1-.7-1.9-2.3-3-3.2-1.6 1.6 1.6 9 2 12.5-3.5-2-3.2-2.8-4.3-5.2.2 2.8-.7 10.8.8 14-2.8-.8-2.6-3-4-3.5 1 3.5-.9 7.2-.4 11.2-1.6-1.6-3.4-2.9-4.1-3.5-.2 2-3.1 6.8-3.2 8.6a4.5 4.5 0 0 1-2-3 59.2 59.2 0 0 0-8 12.4c-4.7-4-16.6-14-18.2-19.4-1.4 3-3.4 4-7.2 6.2-1.6-8.4-7.5-17.8-4.4-25.1a75.2 75.2 0 0 0-6.1 4.2 49.6 49.6 0 0 1 28-33.6z"
        }),
        /* @__PURE__ */ jsx285("path", {
          fill: "#b3b3b3",
          d: "M551 280.5c2.2-4.3 4.2-5.7 5.6-8.5 2.4-4.8 2.8-8.8 5-8.2 2 .6 2 2.6-.7 7.4-2.7 4.8-4 5.8-9.9 9.3m14.6 10.2c-.2-3.2.7-4.6.6-6.7-.4-3.8-1.9-6.3.1-6.5 2-.1 2.9 1.1 2.9 4.8 0 3.8-.6 4.8-3.6 8.4m11.1 6.4c-.9-4.5-.2-6.5-.8-9.5-1-5.2-2.9-8.6-1-9.1 1.8-.5 3 1.2 3.7 6.5.6 5.2.3 6.7-1.9 12.2zm11.5-32c-2.7-2-4.3-2.2-6-3.5-3-2.4-4.6-4.8-5.6-3.6-1 1.2-.3 2.6 3 4.7s4.2 2.3 8.6 2.4m-1.9 15.2c-1.4-3-3-3.7-3.8-5.6-1.6-3.4-1.6-6.3-3.5-5.6-1.7.8-1.9 2.3 0 5.6 2 3.2 3 3.8 7.2 5.6z"
        }),
        /* @__PURE__ */ jsx285("path", {
          fill: "#333",
          stroke: "#000",
          strokeWidth: 1.3,
          d: "M53.8 244.6c-.4-2.6.2-3-1.4-5 2.4 1 2.4 3.7 5.3 1.8 1-.5 1.5-.5.2-3.5 3 .2 12.7 3.5 14.3 3.6 4.1.2 11.6-4.3 16.8 1.2 5 5 3.2 10.3 3.2 17.2-2-1-1-1.3-3.2-3.9 1.6 6.2 0 17.1 0 23.6-.8-1.6-.7-.9-1.5-2.5-2 5.9-4.6 7-4.6 14.1-.8-2.8 0-2.2-.9-3.6-2 4.5-16 8.3-10.6 12.8-4.8-2.8-7-2.6-9-5-1 .5-1.8 1.7-2.6 3.2-8.5-3.8-5.5-12.2-12.1-17.9-1.2 2.4-.7 2.1-2 5.9-1.2-5.3-1.6-8.7-3.1-12.6-1.3 2.2-1.2 1.3-3.6 4.6-1-6.4-2.5-8-2-12.3-2.4 1.8-.8 1-3.3 3.2 2.4-16.5 12.6-28.8 20-25z"
        }),
        /* @__PURE__ */ jsx285("path", {
          fill: "#b3b3b3",
          d: "M43.4 271.7c2.1-5.4 4-7 5.5-10.4 2.5-6.1 2.9-11 5-10.3 2 .8 2 3.2-.8 9.2-2.8 6-4 7.2-9.7 11.5m8.2 13.3c.8-4.8 2.2-6.4 2.8-9.6 1-5.4.5-9.4 2.4-9.2 2 .2 2.4 2.3 1.1 7.6-1.3 5.5-2.2 6.8-6.4 11.2zm9.8 9.4c.3-4.6 1.4-6.5 1.6-9.5.3-5.2-.8-9 1-9 2 0 2.6 1.9 2 7.1-.6 5.2-1.2 6.6-4.6 11.4M82.6 264c-4-4-6.4-4.8-9-7.4-4.6-4.6-6.9-8.8-8.6-7.3-1.6 1.5-.6 3.7 4.3 8 4.8 4.5 6.5 5.1 13.4 6.7zm-2.4 15.6c-2.6-4-4.6-5.1-6.3-7.8-3-4.5-4-8.4-5.7-7.5-1.7 1-1.3 3 1.9 7.5 3.3 4.4 4.5 5.2 10.1 7.8"
        }),
        /* @__PURE__ */ jsx285("path", {
          fill: "#333",
          stroke: "#000",
          d: "M261.4 155.4c-4.8 9.2 8.3-3 28.8 12.4a35.4 35.4 0 0 1 9.2 19.3 61.7 61.7 0 0 1-12-5.3s9 9.2 9 19.6c-3.2-2-4.8-1.7-6-4.1 0 3.3 3 5.5 3 10.7a42.4 42.4 0 0 0-6.3-4.2c3 5.3-5.5 15.5-1.2 18.8a26.6 26.6 0 0 1-18.1-11c-1.6 1-1.8 2.7-1.9 4.6.3.1-11.3-8.7-10.2-12a10.1 10.1 0 0 0-2.2 5.8 31.7 31.7 0 0 1-9.6-13.8c-1.8 2.4-2 2.4-3.9 5-1.4-8.7-1.4-8.4 1.4-15.8a69 69 0 0 0-5.6 4.3 50 50 0 0 1 25.6-34.3z"
        }),
        /* @__PURE__ */ jsx285("path", {
          fill: "#b3b3b3",
          d: "M249.6 200.2c.8-6.3 2.4-8.6 3-12.8.8-7-.2-12.4 2.4-12.2 2.4.2 3.2 2.8 2 10-1.3 7.1-2.4 8.8-7.3 15.1zm13.3 11.6c-.5-5.2.5-7.6.1-11-.5-6-2.4-10.2-.2-10.5 2.2-.4 3.4 1.6 3.6 7.8.2 6-.3 7.7-3.5 13.7m20.8 9.6c-2.3-4.7-4.3-6-5.7-9-2.6-5.3-3.2-9.5-5.1-8.8-2 .8-1.9 3 1 8.2 2.8 5 4.1 6.1 9.7 9.6zm7.1-41.5c-5.8-3-8.7-3-12.4-5-6.5-3.4-10.3-7.1-11.6-5-1.4 2 .4 4.1 7.1 7.2 6.7 3.1 8.8 3.2 16.8 2.8zm2 17.3c-4-3.4-6.6-4-9.3-6.2-4.8-4-7.1-7.7-8.6-6.2-1.6 1.6-.6 3.6 4.4 7.3 5 3.7 6.7 4.1 13.6 5.1z"
        })
      ]
    })
  ]
});
var Sz_default = SvgSz;

// src/country-flag-icons/generated/Tc.tsx
init_esm_shims();
import { jsx as jsx286, jsxs as jsxs261 } from "react/jsx-runtime";
var SvgTc = (props) => /* @__PURE__ */ jsxs261("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx286("path", {
      fill: "#002868",
      d: "M640 480V0H0v480z"
    }),
    /* @__PURE__ */ jsxs261("g", {
      fill: "none",
      stroke: "#000",
      children: [
        /* @__PURE__ */ jsx286("path", {
          fill: "#fcd116",
          strokeWidth: 8,
          d: "M590 174.6v90c0 60-30 124.6-105 159.6-75-35-105-99.6-105-159.6v-90z"
        }),
        /* @__PURE__ */ jsx286("path", {
          stroke: "#fff",
          strokeWidth: 7,
          d: "M590 174.6v90c0 60-30 124.6-105 159.6-75-35-105-99.6-105-159.6v-90z"
        }),
        /* @__PURE__ */ jsxs261("g", {
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 2.2,
          children: [
            /* @__PURE__ */ jsx286("path", {
              fill: "#fcad56",
              strokeWidth: 0.3,
              d: "M447.1 273.7c-2.7 4.7-7.4 5.7-11 4.2-3.7-1.5-7.1-10.3-10.9-15-3.6-4.7-4.6-2.7-7-5.4a37.6 37.6 0 0 0-12-7.4c-3.3-1.5-6.7-2.9-9-8.6a9.8 9.8 0 0 1 5.2-5.1c1.9-.7 3.4-3.4 3.6-5.8.3-2.2 2.3-4.7 5-6.6-1.3.2-3.9-.3-5.1-1.1-1.1-1-3-.8-4.1 0-1.2.8-2.6 1-4.6.8.8-.6 2.2-2 2.3-3.2s1.6-1.9 4.5-1.9c2.8 0 4.6-3.2 6.9-3.2-1.6 0-1.3-2.8-.4-3-4-.7-3.5-4-1.9-4-.1-.4-.6-1-2.5-1.5-1.7-.7-.9-2.3.5-3.3-1.2-2.5-.1-4.4 1.9-6-2.8-.1.3-4 1-6.1.8-2 1.1-2.3 2-1 1 1.1 3.3 3.7 5.9 4.5 2.5.7 4 2.1 4.5 4.2.5 2.3 1.5 3.4 4.2 4.4 2.9.9 6.8 3.3 6.3 8.6a9 9 0 0 1 5.2 1.9"
            }),
            /* @__PURE__ */ jsx286("path", {
              fill: "#ffa1a1",
              strokeWidth: 0.3,
              d: "M454 206a8 8 0 0 0 3.1 6.4c1.9 1.5 3.5 2.7 3.1 4.6-.3 2 .4 3.2 2 4.5 1.8 1.2 3 2.7 2.6 5.2s-.2 4 .8 5.9 2.8 3.4 2 6.4-.4 7 .6 9c1 1.9 0 3.4-1.7 6.7-1.8 3.3-2.8 4.5-6.4 5.8-3.7 1.1-4 3.4-4 7.2 0 4-2.6 6-7.5 5.3-5 4.1-8.1-.8-9.4-6.9s-1.4-12.8-8.8-18.1c-7.3-5.5-4.4-14.8 1.7-18.5 6.1-3.6 5.4-14.4 4.6-21-.6-6.6 3.8-10.4 7.2-14 4.5 1.7 10.1 8.6 10.1 11.5"
            }),
            /* @__PURE__ */ jsx286("path", {
              fill: "#f1b2dc",
              strokeWidth: 0.3,
              d: "M443.4 248.6c-1.4-3.2-2.9-6.5.7-13.5 3.8-7.1 1.4-12.5.3-16.1-1.1-3.5-1.4-6.8 0-8.3 1.5-1.3 2.1-2.2 2.2-4.6.1-2.2 2-1.5 2.3-.4s.5 3-1.5 6.4c-2 3.5 5.6 12 2.1 21.1-2.4 6.4.8 14.5 2 20.2s2 19-6.3 21c5.7-2.7.4-20.5-1.8-25.8"
            }),
            /* @__PURE__ */ jsx286("path", {
              strokeWidth: 0.3,
              d: "M406.3 247.6c1.3.3 2-.5 2.4-1.4s.7-1.3 2-1.5c1.2 0 3.2-.3 3.7-1.3.4-1 1.9-.2 3.2-2.7 1.3-2.6 2.1-5.6 5.5-6.7m9.3-21.8c-1.3 0-4.9.2-6.4 3.4m-10.4-18.9c3 .9 1.8 2.9 3.3 4 2.7 2.2.2 4.4 2.5 5s2.1 1 1.6 3.5c-.8 2.9 2 3 1 4.9m-13 9.9c1.8-1.6 6.1-2.9 7.1-4.6m-7.2-4c2.6-.2 6.1.8 6.6-.2m-7-2.7c1.3 0 3.9-.9 4.4-2.6m-6.3-1.4c1.5 0 3.4-.1 5.3-1.5m-7.3-3.4c1.1-.9 3.1.1 5-1.1m-3.1-4.9c.9 0 2.8-.2 2.8.9"
            }),
            /* @__PURE__ */ jsxs261("g", {
              fill: "#9e540a",
              transform: "matrix(.125 0 0 .125 535 249.6)",
              children: [
                /* @__PURE__ */ jsxs261("g", {
                  id: "tc_svg__b",
                  children: [
                    /* @__PURE__ */ jsx286("path", {
                      d: "M-55-233s-70-59-128-99-128-89-128-99c11-8 70 30 151 79 82 50 128 99 128 99zm-5 40s-68-41-135-70c-70-29-175-29-186-39 0-10 122-16 209 19 89 41 135 70 135 70zm-1 68s-74-34-146-50c-70-16-170-10-182-19 0-10 124-30 217 0 94 29 134 49 134 49zm-4 69s-56-38-130-46c-70-7-163 46-175 36 0-10 81-69 182-59 99 10 146 49 146 49zm23-218s-71-65-71-109c0-39 43-99 62-99-10 20-43 60-43 99 0 40 75 89 75 89z"
                    }),
                    /* @__PURE__ */ jsx286("path", {
                      d: "M-42-274s14-65 14-109c0-59-42-113-38-128 15 15 57 59 57 128 0 60-10 89-10 89z"
                    }),
                    /* @__PURE__ */ jsxs261("g", {
                      stroke: "none",
                      children: [
                        /* @__PURE__ */ jsx286("use", {
                          xlinkHref: "#tc_svg__a",
                          width: "100%",
                          height: "100%",
                          stroke: "#fcd116",
                          strokeWidth: 12
                        }),
                        /* @__PURE__ */ jsx286("path", {
                          id: "tc_svg__a",
                          d: "M-25-295c0-19-7-36-19-49-16-19-40-25-65-21-30 5-54 23-69 51-20 37-22 77-23 116 0 135 5 190 9 323 1 39 8 119-10 182-7 27-15 52-27 78 8-33 12-50 16-75 11-65 8-126 6-186-4-123-11-186-15-335-1-45 3-79 24-115 22-37 60-64 103-64 18 0 33 3 48 12 30 16 44 49 44 82z"
                        })
                      ]
                    }),
                    /* @__PURE__ */ jsx286("path", {
                      d: "M-19 187s-28 50-49 86-38 44-54 33c-15-11-2-40 10-54s79-79 79-79z"
                    }),
                    /* @__PURE__ */ jsx286("path", {
                      d: "M-12 191s-11 57-20 98c-8 41-22 55-39 50-18-4-15-37-8-54s49-103 49-103z"
                    }),
                    /* @__PURE__ */ jsx286("path", {
                      d: "M0 193v100c0 42-10 59-29 58-18-1-22-33-18-52 3-18 28-111 28-111z"
                    })
                  ]
                }),
                /* @__PURE__ */ jsx286("use", {
                  xlinkHref: "#tc_svg__b",
                  width: "100%",
                  height: "100%",
                  transform: "scale(-1 1)"
                }),
                /* @__PURE__ */ jsxs261("g", {
                  id: "tc_svg__c",
                  children: [
                    /* @__PURE__ */ jsx286("path", {
                      d: "M0 192c-53-1-58-20-58-20s-7-24-8-39c-1-2-15-32-11-45-5-12-17-41-6-46-5-14-13-30-14-45-4-11-14-35-6-43 0 0-19-40-10-50 0 0-9-39 0-49 0 0 0-40 10-50 0 0 0-39 9-49 0 2 28-55 94-55l-1 85h1z"
                    }),
                    /* @__PURE__ */ jsx286("path", {
                      fill: "none",
                      d: "M0-26c-85-1-103-20-103-20M0-76c-85 0-113-20-113-20M0-125c-85-1-113-20-113-20M0-175c-85-1-103-20-103-20m102-19c1 0-64 0-74-10l-19-19M0 152c-25 0-53-4-66-19m66-21c-47 0-75-19-75-19s-1-2-2-5M0 63c-62-1-79-14-83-21M0 23C-85 23-94 3-94 3l-3-6"
                    })
                  ]
                }),
                /* @__PURE__ */ jsx286("use", {
                  xlinkHref: "#tc_svg__c",
                  width: "100%",
                  height: "100%",
                  transform: "scale(-1 1)"
                })
              ]
            }),
            /* @__PURE__ */ jsxs261("g", {
              transform: "matrix(.125 0 0 .125 485 299.6)",
              children: [
                /* @__PURE__ */ jsxs261("g", {
                  id: "tc_svg__d",
                  children: [
                    /* @__PURE__ */ jsx286("path", {
                      fill: "#009e49",
                      d: "M0 712c-43 40-126 14-152-4-27 9-99-19-118-50-52 7-70-67-61-86 14-28-11-46 7-65 25-24-14-47 10-63 24-17-6-45 18-63 25-19-13-45 13-58s-3-47 19-60-13-46 17-61c29-15 3-41 26-52 25-13 2-40 25-49 26-11 7-40 29-48 19-7 7-25 19-41H0"
                    }),
                    /* @__PURE__ */ jsx286("path", {
                      d: "M-99 18c-20 20 4 35-16 59-21 25-2 38-19 60s8 33-11 58c-19 24 4 39-17 59-20 21 4 39-17 61-20 23 4 38-16 58-21 21 3 43-17 63-20 21 4 47-19 71-22 24 4 43-14 61-19 19-2 38-15 51s-15 31-10 39M-60 25c-18 25 10 36-7 56-17 21 7 28-6 52s10 30-7 54 9 43-9 67c-19 24 9 37-8 61-16 25 8 38-7 56-15 19 11 37-8 60-18 22 8 39-7 59-15 21 6 43-7 60-13 16 9 41-10 63-18 22 4 37-7 52s-20 37-9 43"
                    })
                  ]
                }),
                /* @__PURE__ */ jsx286("use", {
                  xlinkHref: "#tc_svg__d",
                  width: "100%",
                  height: "100%",
                  transform: "scale(-1 1)"
                }),
                /* @__PURE__ */ jsx286("path", {
                  stroke: "#009e49",
                  d: "M0 712V12"
                }),
                /* @__PURE__ */ jsx286("path", {
                  d: "M0 48c-9 39 13 73 0 106-13 32 9 45 2 71-8 26 9 45-2 73s15 50 0 87c-15 36 10 45 0 82-11 42 19 64 0 94s17 37 2 71c-15 33 9 46-2 80"
                }),
                /* @__PURE__ */ jsx286("path", {
                  fill: "#fcd116",
                  d: "M15 174c-5 11 15 37 4 57-12 19 6 49-6 73s19 54 7 82c-13 28 6 63 0 89-5 26 13 76 0 94-13 19 13 24-2 70s-25 7-16-7c19-31-21-41-2-71s-11-52 0-94c10-37-15-46 0-82 15-37-11-59 0-87s-6-47 2-73c7-26-15-39-2-71 10-32 20 9 15 20m-84 32c-7 12 12 35-5 58-12 16 8 35-9 58-11 16 11 36-4 59-10 13 7 38-5 57-12 20 6 36-15 62-12 14 9 49-4 60s-1 54-10 60c-8 7 0 38-22 45 11-15-11-30 7-52 19-22-3-47 10-63 13-17-8-39 7-60 15-20-11-37 7-59 19-23-7-41 8-60 15-18-9-31 7-56 17-24-11-37 8-61 18-24-8-43 9-67s-6-30 7-54c24 9 12 61 4 73m-50-65c-10 16 4 35-11 55-15 21 0 47-15 64-15 16 4 48-15 61s-7 52-22 65 0 50-17 69-9 58-19 67c-9 9 13 28-3 41-17 13-17 39-39 56 13-13-4-32 15-51 18-18-8-37 14-61 23-24-1-50 19-71 20-20-4-42 17-63 20-20-4-35 16-58 21-22-3-40 17-61 21-20-2-35 17-59 19-25-6-36 11-58 8-10 8-19 8-27 12-31 12 23 7 31"
                }),
                /* @__PURE__ */ jsx286("path", {
                  fill: "#ce1126",
                  d: "M-139 35c0-210 29-283 139-283s139 73 139 283z"
                }),
                /* @__PURE__ */ jsx286("path", {
                  fill: "#000001",
                  d: "M-139 35c0-210 29-283 139-283-50 0-81 39-89 65-9 26-4 24 7 14s6 12-4 24c-9 12-18 47-5 36 13-12 23 1 9 21-14 19-26 65-12 49s17 10 8 23c-8 13-7 25 0 19 8-6 7 21 0 32zm191-4C52 0 53-73 36-97c-12-19-12-39 2-17s21 11 11-11c-12-28-28-59-24-65 5-7 8-4 18 11s12-7 1-22c-11-14-10-17 13-7 41 17 61 66 61 231z"
                }),
                /* @__PURE__ */ jsx286("path", {
                  fill: "#ce1126",
                  d: "M0 65c-44 0-92-7-124-20-38-15-40-28-27-44 10-12 30-5 50 4 19 8 73 14 101 14s82-6 101-15c20-8 40-15 50-3 13 16 11 29-27 44C92 58 44 65 0 65"
                })
              ]
            })
          ]
        })
      ]
    }),
    /* @__PURE__ */ jsx286("path", {
      fill: "#012169",
      d: "M0 0h320v240H0Z"
    }),
    /* @__PURE__ */ jsx286("path", {
      fill: "#fff",
      d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0Z"
    }),
    /* @__PURE__ */ jsx286("path", {
      fill: "#c8102e",
      d: "M212 140.5 320 220v20l-135.5-99.5Zm-92 10 3 17.5-96 72H0ZM320 0v1.5l-124.5 94 1-22L295 0ZM0 0l119.5 88h-30L0 21Z"
    }),
    /* @__PURE__ */ jsx286("path", {
      fill: "#fff",
      d: "M120.5 0v240h80V0ZM0 80v80h320V80Z"
    }),
    /* @__PURE__ */ jsx286("path", {
      fill: "#c8102e",
      d: "M0 96.5v48h320v-48zM136.5 0v240h48V0Z"
    })
  ]
});
var Tc_default = SvgTc;

// src/country-flag-icons/generated/Td.tsx
init_esm_shims();
import { jsx as jsx287, jsxs as jsxs262 } from "react/jsx-runtime";
var SvgTd = (props) => /* @__PURE__ */ jsx287("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs262("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx287("path", {
        fill: "#002664",
        d: "M0 0h214v480H0z"
      }),
      /* @__PURE__ */ jsx287("path", {
        fill: "#c60c30",
        d: "M426 0h214v480H426z"
      }),
      /* @__PURE__ */ jsx287("path", {
        fill: "#fecb00",
        d: "M214 0h212v480H214z"
      })
    ]
  })
});
var Td_default = SvgTd;

// src/country-flag-icons/generated/Tf.tsx
init_esm_shims();
import { jsx as jsx288, jsxs as jsxs263 } from "react/jsx-runtime";
var SvgTf = (props) => /* @__PURE__ */ jsxs263("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx288("defs", {
      children: /* @__PURE__ */ jsx288("path", {
        id: "tf_svg__a",
        fill: "#fff",
        d: "m0-21 12.3 38L-20-6.5h40L-12.3 17z"
      })
    }),
    /* @__PURE__ */ jsx288("path", {
      fill: "#002395",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx288("path", {
      fill: "#fff",
      d: "M0 0h292.8v196.8H0z"
    }),
    /* @__PURE__ */ jsx288("path", {
      fill: "#002395",
      d: "M0 0h96v192H0z"
    }),
    /* @__PURE__ */ jsx288("path", {
      fill: "#ed2939",
      d: "M192 0h96v192h-96z"
    }),
    /* @__PURE__ */ jsx288("path", {
      fill: "#fff",
      d: "m426 219.6 15.4 24.6h44V330l-33-51.6-44.4 70.8h21.6l22.8-40.8 46.8 84 46.8-84 22.8 40.8h21.6L546 278.4 513 330v-47.4h19.8l14.7-23.4H513v-15h44l15.4-24.6zm51.6 105h-48v16.8h48zm91.2 0h-48v16.8h48z"
    }),
    /* @__PURE__ */ jsx288("use", {
      xlinkHref: "#tf_svg__a",
      width: "100%",
      height: "100%",
      x: 416,
      y: 362,
      transform: "scale(1.2)"
    }),
    /* @__PURE__ */ jsx288("use", {
      xlinkHref: "#tf_svg__a",
      width: "100%",
      height: "100%",
      x: 371,
      y: 328,
      transform: "scale(1.2)"
    }),
    /* @__PURE__ */ jsx288("use", {
      xlinkHref: "#tf_svg__a",
      width: "100%",
      height: "100%",
      x: 461,
      y: 328,
      transform: "scale(1.2)"
    }),
    /* @__PURE__ */ jsx288("use", {
      xlinkHref: "#tf_svg__a",
      width: "100%",
      height: "100%",
      x: 333,
      y: 227,
      transform: "scale(1.2)"
    }),
    /* @__PURE__ */ jsx288("use", {
      xlinkHref: "#tf_svg__a",
      width: "100%",
      height: "100%",
      x: 499,
      y: 227,
      transform: "scale(1.2)"
    })
  ]
});
var Tf_default = SvgTf;

// src/country-flag-icons/generated/Tg.tsx
init_esm_shims();
import { jsx as jsx289, jsxs as jsxs264 } from "react/jsx-runtime";
var SvgTg = (props) => /* @__PURE__ */ jsxs264("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx289("defs", {
      children: /* @__PURE__ */ jsx289("clipPath", {
        id: "tg_svg__a",
        children: /* @__PURE__ */ jsx289("path", {
          fillOpacity: 0.7,
          d: "M0 0h682.7v512H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs264("g", {
      fillRule: "evenodd",
      clipPath: "url(#tg_svg__a)",
      transform: "scale(.9375)",
      children: [
        /* @__PURE__ */ jsx289("path", {
          fill: "#ffe300",
          d: "M0 0h767.6v512H0z"
        }),
        /* @__PURE__ */ jsx289("path", {
          fill: "#118600",
          d: "M0 208.1h767.6V311H0zM0 .2h767.6v102.9H0z"
        }),
        /* @__PURE__ */ jsx289("path", {
          fill: "#d80000",
          d: "M0 .3h306.5v310.6H0z"
        }),
        /* @__PURE__ */ jsx289("path", {
          fill: "#fff",
          d: "M134.4 128.4c0-.8 18.9-53 18.9-53l17 52.2s57.4 1.7 57.4.8-45.3 34.3-45.3 34.3 21.4 60 20.5 58.2c-.8-1.7-49.6-36-49.6-36s-49.7 34.3-48.8 34.3c.8 0 18.8-56.5 18.8-56.5l-44.5-33.4z"
        }),
        /* @__PURE__ */ jsx289("path", {
          fill: "#118600",
          d: "M0 409.2h767.6V512H0z"
        })
      ]
    })
  ]
});
var Tg_default = SvgTg;

// src/country-flag-icons/generated/Th.tsx
init_esm_shims();
import { jsx as jsx290, jsxs as jsxs265 } from "react/jsx-runtime";
var SvgTh = (props) => /* @__PURE__ */ jsx290("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs265("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx290("path", {
        fill: "#f4f5f8",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsx290("path", {
        fill: "#2d2a4a",
        d: "M0 162.5h640v160H0z"
      }),
      /* @__PURE__ */ jsx290("path", {
        fill: "#a51931",
        d: "M0 0h640v82.5H0zm0 400h640v80H0z"
      })
    ]
  })
});
var Th_default = SvgTh;

// src/country-flag-icons/generated/Tj.tsx
init_esm_shims();
import { jsx as jsx291, jsxs as jsxs266 } from "react/jsx-runtime";
var SvgTj = (props) => /* @__PURE__ */ jsxs266("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx291("path", {
      fill: "#060",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx291("path", {
      fill: "#fff",
      d: "M0 0h640v342.9H0z"
    }),
    /* @__PURE__ */ jsx291("path", {
      fill: "#c00",
      d: "M0 0h640v137.1H0z"
    }),
    /* @__PURE__ */ jsx291("path", {
      fill: "#f8c300",
      d: "M300.8 233.6a8.6 8.6 0 0 1 16 4V272h6.4v-34.3a8.6 8.6 0 0 1 16-4 20.2 20.2 0 1 0-38.4 0"
    }),
    /* @__PURE__ */ jsx291("path", {
      fill: "#fff",
      d: "M305.4 224.7a13.7 13.7 0 0 1 14.6 6.5 13.7 13.7 0 0 1 14.6-6.5 14.7 14.7 0 0 0-29.2 0"
    }),
    /* @__PURE__ */ jsx291("path", {
      id: "tj_svg__a",
      fill: "#f8c300",
      d: "M316.8 258.3a26 26 0 0 1-43.8 16.6 27 27 0 0 1-41 12c2.5 25 40 19.9 42.8-4.4 11.7 20.7 37.6 14.7 45.2-10.6z"
    }),
    /* @__PURE__ */ jsx291("use", {
      xlinkHref: "#tj_svg__a",
      width: "100%",
      height: "100%",
      fill: "#f8c300",
      transform: "matrix(-1 0 0 1 640 0)"
    }),
    /* @__PURE__ */ jsx291("path", {
      id: "tj_svg__b",
      fill: "#f8c300",
      d: "M291.8 302.6c-5.3 11.3-15.7 13.2-24.8 4.1 0 0 3.6-2.6 7.6-3.3-.8-3.1.7-7.5 2.9-9.8a15 15 0 0 1 6.1 8.1c5.5-.7 8.2 1 8.2 1z"
    }),
    /* @__PURE__ */ jsx291("use", {
      xlinkHref: "#tj_svg__b",
      width: "100%",
      height: "100%",
      fill: "#f8c300",
      transform: "rotate(9.4 320 551.3)"
    }),
    /* @__PURE__ */ jsx291("use", {
      xlinkHref: "#tj_svg__b",
      width: "100%",
      height: "100%",
      fill: "#f8c300",
      transform: "rotate(18.7 320 551.3)"
    }),
    /* @__PURE__ */ jsx291("path", {
      fill: "none",
      stroke: "#f8c300",
      strokeWidth: 11,
      d: "M253.5 327.8a233.1 233.1 0 0 1 133 0"
    }),
    /* @__PURE__ */ jsx291("g", {
      fill: "#f8c300",
      transform: "translate(320 164.6) scale(.68571)",
      children: /* @__PURE__ */ jsx291("path", {
        id: "tj_svg__c",
        d: "m301930 415571-790463-574305h977066l-790463 574305L0-513674z",
        transform: "scale(.00005)"
      })
    }),
    /* @__PURE__ */ jsxs266("g", {
      id: "tj_svg__d",
      fill: "#f8c300",
      transform: "translate(320 260.6) scale(.68571)",
      children: [
        /* @__PURE__ */ jsx291("use", {
          xlinkHref: "#tj_svg__c",
          width: "100%",
          height: "100%",
          transform: "translate(-70 -121.2)"
        }),
        /* @__PURE__ */ jsx291("use", {
          xlinkHref: "#tj_svg__c",
          width: "100%",
          height: "100%",
          transform: "translate(-121.2 -70)"
        }),
        /* @__PURE__ */ jsx291("use", {
          xlinkHref: "#tj_svg__c",
          width: "100%",
          height: "100%",
          transform: "translate(-140)"
        })
      ]
    }),
    /* @__PURE__ */ jsx291("use", {
      xlinkHref: "#tj_svg__d",
      width: "100%",
      height: "100%",
      fill: "#f8c300",
      transform: "matrix(-1 0 0 1 640 0)"
    })
  ]
});
var Tj_default = SvgTj;

// src/country-flag-icons/generated/Tk.tsx
init_esm_shims();
import { jsx as jsx292, jsxs as jsxs267 } from "react/jsx-runtime";
var SvgTk = (props) => /* @__PURE__ */ jsxs267("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx292("path", {
      fill: "#00247d",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx292("path", {
      fill: "#fed100",
      d: "M108.1 354.6c-6.7-.1 62.8-37 120.9-84.4 76.2-62.1 240.3-161.4 288.6-177.6 5-1.7-10.3 8.6-12.3 11.9-51.5 61-10.4 176 54 233.9 19.4 14.8 18.4 15.6 54.3 17v3.4zm-4.2 6.7s-4.9 3.5-4.9 6.1c0 2.9 5.5 6.7 5.5 6.7l498.5 5.5 9.2-6.1-12.8-7.9z"
    }),
    /* @__PURE__ */ jsx292("path", {
      fill: "#fff",
      d: "m106.8 109.1-4 12.2 10.4-7.5 10.3 7.5-3.9-12.2 10.3-7.5h-12.8l-3.9-12.2-4 12.2H96.4zm78.1 57.4 8.6-6.3h-10.7l-3.3-10.1-3.3 10.1h-10.6l8.6 6.3-3.3 10.1 8.6-6.3 8.7 6.3zm-145.2 13-4-12.2-3.9 12.2H19l10.3 7.5-3.9 12.2 10.3-7.5 10.4 7.5-4-12.2 10.4-7.5zm78.1 122.3-4.6-14.2-4.6 14.2h-15l12.1 8.7-4.6 14.3 12.1-8.8 12.1 8.8-4.7-14.3 12.1-8.7z"
    })
  ]
});
var Tk_default = SvgTk;

// src/country-flag-icons/generated/Tl.tsx
init_esm_shims();
import { jsx as jsx293, jsxs as jsxs268 } from "react/jsx-runtime";
var SvgTl = (props) => /* @__PURE__ */ jsxs268("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx293("defs", {
      children: /* @__PURE__ */ jsx293("clipPath", {
        id: "tl_svg__a",
        children: /* @__PURE__ */ jsx293("path", {
          fillOpacity: 0.7,
          d: "M0 0h682.7v512H0z"
        })
      })
    }),
    /* @__PURE__ */ jsxs268("g", {
      fillRule: "evenodd",
      clipPath: "url(#tl_svg__a)",
      transform: "scale(.9375)",
      children: [
        /* @__PURE__ */ jsx293("path", {
          fill: "#cb000f",
          d: "M0 0h1031.2v512H0z"
        }),
        /* @__PURE__ */ jsx293("path", {
          fill: "#f8c00c",
          d: "M0 0c3.2 0 512 256.7 512 256.7L0 512z"
        }),
        /* @__PURE__ */ jsx293("path", {
          fill: "#000001",
          d: "M0 0c2.1 0 340.6 256.7 340.6 256.7L0 512z"
        }),
        /* @__PURE__ */ jsx293("path", {
          fill: "#fff",
          d: "M187.7 298.2 127 284.7l-31 52.8-5-59.7-60.7-13.3 54.9-24.9-3.3-59.3 40.2 43.4 55.4-25.3-28.9 54 39.2 45.8z"
        })
      ]
    })
  ]
});
var Tl_default = SvgTl;

// src/country-flag-icons/generated/Tm.tsx
init_esm_shims();
import { jsx as jsx294, jsxs as jsxs269 } from "react/jsx-runtime";
var SvgTm = (props) => /* @__PURE__ */ jsxs269("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx294("path", {
      fill: "#00843d",
      d: "M0 0h640v480H0Z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#fff",
      d: "M357.6 53A59.7 59.7 0 1 1 295 153.7a59.7 59.7 0 0 0 62.3-100.1ZM301 97l6.4-20.8-17.7 12.9h21.9l-17.8-12.9Zm0-30.6 6.4-20.8-17.7 12.9h21.9l-17.8-13.2ZM331.2 82l6.4-20.8-17.8 12.9h22L324 61.2Zm-61 30.3 6.9-20.8-17.8 12.8h22l-17.8-12.8Zm30.3 15.4 6.8-20.7-17.7 12.8h21.9L293.7 107z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#d22630",
      d: "M86.6 0h129.6v480H86.6Z"
    }),
    /* @__PURE__ */ jsxs269("g", {
      fill: "#383739",
      children: [
        /* @__PURE__ */ jsx294("path", {
          d: "M118 0h-4.2l-8.3 7.6-3-3.4h3l-.8-3h-4.9l-10.2 9V14h5v-3l2.2 2.2-5.3 4.6L94 20l-7.5 6.8v5L99 20.3l-2.2-2.6 4.9-4.6L97.5 9l2.7-3 5.6 5.2ZM87 0v8.7L89.5 6V2.3h3L95.3 0Zm22.6 0h-3l.4 2.3z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#ffc72c",
          d: "M117.6 0h-3.8l-8 7.6-3.7-3.8h3.4l-.8-2.7h-4.5l-9.9 9.5v3h3.8V9.8l3.4 3.4-5.3 4.6 2.3 2.2-7.6 7.6v3.8L98.3 20 96 17.8l5.3-4.6-4.5-4.1 3.8-3.4 5.2 5.3 11.4-11Zm-31 0v8.3l2.2-2.6V1.9h3.4L94.5 0Zm22.6 0h-1.8v1.5z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs269("g", {
      fill: "#383739",
      children: [
        /* @__PURE__ */ jsx294("path", {
          d: "M86.6 55.6v4.9l7.2 6.8-2.7 2.2 5.3 5-2.3 1.8v-3h-4.5v3.8l10.2 9.5h5l.7-3.8H102l3-2.7 8.3 7.6-8.3 6.8-3-2.7h3l-.8-3.7h-4.9l-9.8 10.2v3.7h5v-3.7l2.2 2.2-5.3 4.6 2.6 2.6-7.5 6.8v4.6L99 107.7l-2.2-2.6 4.9-4.6-4.2-4.1 2.7-2.7 5.6 4.6 12.5-11.4-12.5-11.3-5.6 5.3-2.7-2.7 4.2-4.1-5-5L99 67 87 55.6zm0 22.6v18.2l2.6-3v-3.8h3l2.7-2.3-2.7-2.3h-3v-3.7zm20.8 6.5v4.9l2.6-2.3z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#ffc72c",
          d: "M86.6 56.3v3.8l7.5 7.2-2.2 2.2 5.3 5-3.4 2.6v-3.4H90v3l9.8 9.5h4.5l.8-2.7h-3.8l4.2-3.8 8.7 7.6-8.7 7.6-3.8-3.8h3.4l-.8-2.3h-4.5l-9.8 9v3.1h3.8v-3.8l3.4 3.4-5.3 4.6 2.2 2.6-7.5 7.2v3.8l11.3-11.4-2.3-2.2 5.3-4.6-4.5-4.1 3.8-3.4 5.6 5.3 11.8-11-12.1-11-5.7 5.3-3.4-3 4.5-4.1-5.3-5 2.7-2.2zm0 22.7v16.6l2.2-2.2v-3.8h3.4l2.3-2.3-2.3-1.9h-3.4v-3.8zm21.1 6.4v3.4l2-1.5Z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs269("g", {
      fill: "#383739",
      children: [
        /* @__PURE__ */ jsx294("path", {
          d: "M86.6 145.9v5.3l7.2 6.8-2.7 2.3 5.3 4.5-2.3 2.3v-3h-4.5v3.7l10.2 9h5l.7-3H102l3-3 8.3 7.2-8.3 7.6-3-3.4h3l-.8-3.4h-4.9l-10.2 9.4v3.8h5.3v-3l2.3 1.9-5.3 4.9L94 198l-7.5 6.9v4.9L99 198.4l-2.2-2.6 4.9-5-4.2-3.7 2.7-3 5.6 4.9 12.5-11.4-12.5-11.3-5.6 5.3-2.7-3 4.2-3.8-5-5 2.3-2.2-12-11.3zm0 22.7v17.7l2.6-2.6v-3.8h3l2.7-2.3-2.7-2.6h-3v-3.4zm20.8 6.4v5l2.6-2.7z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#ffc72c",
          d: "M86.6 146.3v3.7l7.5 7.6L92 160l5.3 4.5-3.4 3v-3.7H90v3.7l9.8 8.7h4.5l.8-2.6h-3.8l4.2-3.8 8.7 7.6-8.7 7.9-3.8-3.8h3.4l-.8-2.6h-4.5l-9.8 9.4v3h3.8v-3.7l3.4 3-5.3 4.9 2.2 2.3-7.5 7.5v3.8l11.3-11.3-2.3-2.3 5.3-5-4.5-3.7 3.8-3.8 5.6 6 11.8-11.3-12.1-10.5-5.7 5.2-3.4-3.4 4.5-3.7-5.3-5 2.7-2.2zm0 22.6v17l2.2-2.6v-3.8h3.4l2.3-1.9-2.3-2.2h-3.4v-3.8l-2.2-2.3zm21.1 6.8v3.4l2-1.8Z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs269("g", {
      fill: "#383739",
      children: [
        /* @__PURE__ */ jsx294("path", {
          d: "M86.6 236.2v4.6l7.2 6.8-2.7 2.2 5.3 5-2.3 2.2v-3h-4.5v3.8l10.2 9h5l.7-3.4H102l3-2.6 8.3 7.2-8.3 7.1-3-3h3l-.8-3.4h-4.9l-10.2 9.5v3.8h5.3v-3l2.3 1.8-5.3 5L94 288l-7.5 6.8v5L99 288.3l-2.2-2.7 4.9-4.9-4.2-3.8 2.7-3 5.6 5.3 12.5-11.3-12.5-11.4-5.6 5-2.7-2.7 4.2-3.8-5-5.3 2.3-2.2-12-11.4zm0 22.7v17.8l2.6-3v-3.5h3L95 268l-2.7-2.7h-3V262zm20.8 6.4v5l2.6-2.7z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#ffc72c",
          d: "M86.6 236.6v3.8l7.5 7.5-2.2 2 5.3 4.8-3.4 3V254H90v3.4l9.8 9h4.5l.8-2.6h-3.8l4.2-3.8 8.7 7.6-8.7 8-3.8-3.9h3.4l-.8-2.6h-4.5l-9.8 9v3.5h3.8v-3.8l3.4 3-5.3 5L94 288l-7.5 7.6v3.7L97.9 288l-2.3-2.3 5.3-4.9-4.5-3.8 3.8-3.7 5.6 5.6 11.8-11.3-12.1-10.6-5.7 5.3-3.4-3.4 4.5-3.8-5.3-5.3 2.7-2.2zm0 22.7v17l2.2-2.7V270h3.4l2.3-2-2.3-2.2h-3.4V262l-2.2-2.2zm21.1 6.8v3.4l2-2Z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs269("g", {
      fill: "#383739",
      children: [
        /* @__PURE__ */ jsx294("path", {
          d: "M86.6 326.6v4.5l7.2 6.8-2.7 2.3 5.3 4.9-2.3 1.9v-3h-4.5v3.7l10.2 9.5h5l.7-3.4H102l3-3 8.3 7.5-8.3 7.2-3-3h3l-.8-3.4h-4.9l-10.2 9.4v3.8h5.3v-3.4l2.3 2.2-5.3 5 2.6 2.2-7.5 6.8v4.6L99 378.3l-2.2-2.2 4.9-5-4.2-4.1 2.7-2.7 5.6 5.3 12.5-11.3-12.5-11.3-5.6 4.9-2.7-2.7 4.2-4.1-5-5L99 338zm0 22.6V367l2.6-3v-3.4h3l2.7-2.7-2.7-2.2h-3v-3.8zm20.8 6.5v4.5l2.6-2.3z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#ffc72c",
          d: "M86.6 327v3.7L94 338l-2.2 2.3 5.3 4.9-3.4 3v-3.8H90v3.4l9.8 9h4.5l.8-2.6h-3.8l4.2-3.7 8.7 7.5-8.7 8-3.8-3.8h3.4l-.8-2.7h-4.5l-9.8 9.1v3.4h3.8v-3.8l3.4 3-5.3 5 2.2 2.2-7.5 7.6v3.4L97.9 378l-2.3-2 5.3-4.9-4.5-4.1 3.8-3.4 5.6 5.3 11.8-11-12.1-11-5.7 5.4-3.4-3 4.5-4.2-5.3-5 2.7-2.2Zm0 22.6v17l2.2-2.3v-3.7h3.4l2.3-2.3-2.3-1.9h-3.4v-3.8l-2.2-2.6zm21.1 6.4v3.8l2-1.9Z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs269("g", {
      fill: "#383739",
      children: [
        /* @__PURE__ */ jsx294("path", {
          d: "M184.5 0h4.5l7.6 7.6 3.8-3.8h-3l.7-3h4.9l10.2 9v3.8H208v-3l-2.3 2.3 5.3 4.5-2.6 2.3 7.6 6.8v4.9L203.4 20l2.2-2.6-4.9-4.5 4.2-4.2-2.7-3-5.6 5.6Zm31.7 0v8.7l-3-2.7V2.3h-3L207.5 0Zm-23.8 0h3l-.3 2.3z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#ffc72c",
          d: "M185.2 0h3l8.8 7.6 3.7-3.8h-3.4l.8-2.7h4.5l9.9 9.5v3h-3.8V9.8l-3 3.4 4.9 4.6-2.3 2.6 7.6 7.2v3.8L204.5 20l2.3-2.2-5.3-4.6 4.5-4.1-3.8-3.4-4.9 5.6L185 0Zm31 0v8.3l-2.6-2.6V1.9h-3.4l-2-1.9Zm-23.4 0h2.3v1.5z"
        }),
        /* @__PURE__ */ jsx294("path", {
          d: "M216.2 55.6v4.9l-7.5 6.8 2.6 2.2-5.3 5 2.3 1.8v-3h4.5v3.8l-10.2 9.5h-4.9l-.7-3.8h3l-3-2.7-8 7.6 7.6 6.8 3.4-2.7h-3l.7-3.7h5l10.1 9.8v3.8H208v-3.4l-2.3 2.2 5.3 4.6-2.6 2.6 7.6 6.8v4.6l-12.5-11.4 2.2-2.6-4.9-4.6 4.2-4.1-2.7-2.7-5.6 4.6L184 86.9l12.5-11.3 5.6 5.3 2.7-2.7-4.2-4.1 5-5-2.3-2.2 12.5-11.3zm0 22.6v18.2l-3-3v-3.8h-3l-2.7-2.3 2.7-2.3h3v-3.7zm-21.1 6.5.3 2.6-.3 2.3-2.7-2.3z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#ffc72c",
          d: "M216.2 56.3v3.8l-8.3 6.8 2.3 2.3-5 4.9 3 2.6v-3.4h3.9v3l-9.9 9.5h-4.5l-.7-2.7h3.7l-4.1-3.7-8.7 7.5 8.7 7.6 3.8-3.8H197l.7-2.3h4.5l9.9 9.1v3h-3.8v-3.7l-3 3.4 4.9 4.5-2.3 2.6 7.6 7.2v3.8L204 107l2.3-2.3-5.3-4.5 4.5-4.2-3.7-3.4-5.3 5.3-12.1-11 12-11 5.7 5.4 3.4-3-4.5-4.2 5.3-5-2.6-2.2zm0 22.7v16.6l-2.6-2.2v-3.8h-3.4l-2-2.3 2-1.9h3.4v-3.8zm-21.5 6.4.4 2v1.4l-2.3-1.5Z"
        }),
        /* @__PURE__ */ jsx294("path", {
          d: "M216.2 145.9v5.3l-7.5 6.8 2.6 2.3-5.3 4.5 2.3 2.3v-3h4.5v3.7l-10.2 9h-4.9l-1.1-3h3l-3-3-7.6 6.8 7.6 7.6 3.4-3.4h-3l.7-3.4h5l10.1 9.4v3.8H208v-3l-2.3 1.9 5.3 4.9-2.6 2.3 7.6 6.8v4.9L203.4 198l2.2-2.6-4.9-5 4.2-3.7-2.7-3-5.6 5.3-12.5-11.4 12.5-11.3 5.6 5.3 2.7-3-4.2-3.8 5-5-2.3-2.2 12.5-11.3zm0 22.7v17.7l-3-2.6v-3.8h-3l-2.7-2.3 2.7-2.6h3v-3.4zm-21.1 6.4.3 2.3-.3 2.6-2.7-2.6z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#ffc72c",
          d: "M216.2 146.3v3.7l-8 7.6 2.4 2.3-5 4.5 3 3v-3.7h3.9v3.7l-9.9 8.7h-4.5l-.8-2.6h3.8l-4.5-3.4-8.7 7.5 8.7 8 3.8-3.8H197l.7-2.7h4.5l9.9 9.5v3h-3.8v-3.8l-3 3 4.9 5-2.3 2.2 7.6 7.6v3.8L204 198l2.3-2.2-5.3-5 4.5-3.7-3.7-3.8-5.3 5.7-12.1-11.4 12-10.5 5.7 5.2 3.4-3.4-4.5-3.7 5.3-5-2.6-2.2zm0 22.6v17l-2.6-2.6v-3.8h-3.4l-2-1.9 2-2.2h3.4v-3.8l2.6-2.3zm-21.5 6.8.4 1.6v1.8l-2.3-1.8Z"
        }),
        /* @__PURE__ */ jsx294("path", {
          d: "M216.2 236.2v4.6l-7.5 6.8 2.6 2.2-5.3 5 2.3 2.2v-3h4.5v3.8l-10.2 9h-4.9l-.7-3.4h3l-3-2.6-8 7.2 7.6 7.1 3.4-3h-3l.7-3.4h5l10.1 9.5v3.8H208v-3l-2.3 1.8 5.3 5-2.6 2.2 7.6 6.8v5l-12.5-11.4 2.2-2.7-4.9-4.9 4.2-3.8-2.7-3-5.6 5.3L184 268l12.5-11.4 5.6 5 2.7-2.7-4.2-3.8 5-5.3-2.3-2.2 12.5-11.4zm0 22.7v17.8l-3-3v-3.5h-3l-2.7-2.2 2.7-2.7h3V262zm-21.1 6.4.3 2.3-.3 2.6-2.7-2.6z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#ffc72c",
          d: "M216.2 236.6v3.8l-8 7.5 2.4 2-5 4.8 3 3V254h3.9v3.4l-9.9 9h-4.5l-.8-2.6h3.8L197 260l-8.7 7.6 8.7 8 3.7-3.9h-3.4l.8-2.6h4.5l9.9 9v3.5h-3.8v-3.8l-3 3 4.9 5-2.3 2.2 7.6 7.6v3.7L204.5 288l2.3-2.3-5.3-4.9 4.5-3.8-3.8-3.7-5.2 5.6-12.1-11.3 12-10.6 5.7 5.3 3.4-3.4-4.5-3.8 5.3-5.3-2.7-2.2zm0 22.7v17l-2.6-2.7V270h-3.4l-2-2 2-2.2h3.4V262l2.6-2.2zm-21.5 6.8.4 1.5v1.9l-2.3-2Z"
        }),
        /* @__PURE__ */ jsx294("path", {
          d: "M216.2 326.6v4.5l-7.5 6.8 2.6 2.3-5.3 4.9 2.3 1.9v-3h4.5v3.7l-10.2 9.5h-4.9l-.7-3.4h3l-3-3-8 7.5 7.6 7.2 3.4-3h-3l.7-3.4h5l10.1 9.4v3.8H208v-3.4l-2.3 2.2 5.3 5-2.6 2.2 7.6 6.8v4.6l-12.5-11.4 2.2-2.2-4.9-5 4.2-4.1-2.7-2.7-5.6 5.3-12.5-11.3 12.5-11.3 5.6 4.9 2.7-2.7-4.2-4.1 5-5-2.3-2.2zm0 22.6V367l-3-3v-3.4h-3l-2.7-2.7 2.7-2.2h3v-3.8zm-21.1 6.5.3 2.2-.3 2.3-2.7-2.3z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#ffc72c",
          d: "M216.2 327v3.7L208 338l2.3 2.3-5 4.9 3 3v-3.8h3.9v3.4l-9.9 9h-4.5l-.7-2.6h3.7l-4.1-3.7-8.7 7.5 8.7 8 3.8-3.8H197l.7-2.7h4.5l9.9 9.1v3.4h-3.8v-3.8l-3 3 4.9 5-2.3 2.2 7.6 7.6v3.4L204 378l2.3-2-5.3-4.9 4.5-4.1-3.7-3.4-5.3 5.3-12.1-11 12-11 5.7 5.4 3.4-3-4.5-4.2 5.3-5-2.6-2.2zm0 22.6v17l-2.6-2.3v-3.7h-3.4l-2-2.3 2-1.9h3.4v-3.8l2.6-2.6zm-21.5 6.4.4 2v1.8l-2.3-1.9Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#ffc72c",
      d: "M96.8 424.8c.7 2.7 3 4.6 3.8 7.6.7-3 1.5-5.7 1-8.7-.7-2.3-2.6-3.8-2.6-6.4-2.2 1.8-2.6 4.5-2.2 7.5m-.4 11.4a17.8 17.8 0 0 0 7.2 5.6c-.8-2.2 0-3.8 1.5-5.6 1.1-2 1.9-3.8.7-6.5a14.4 14.4 0 0 1-1.8 3.4 10 10 0 0 0-2.3 5.3c-1.5-1.1-1.9-2.6-2.7-4.1a12.9 12.9 0 0 0-5.2-5.3c.7 2.6 1 4.9 2.6 7.2m10.2 7.5-.8 3.8-4.1-3c-1.9-2-4.2-2.7-5.7-5a9 9 0 0 0 3.8 7.2l8 5c-.4-2.7.7-5 1.4-7.6a6.8 6.8 0 0 0-1.5-6c0 1.8-.7 3.7-1.1 5.2zm5.3 8.7 3 5.3c-2.6-.8-4.9-2.3-7.5-3.8-2.7-1.5-5.7-2.2-8.4-4.5a13 13 0 0 0 9.1 9c3.4.8 6 .4 9.8 2a26.5 26.5 0 0 0-2.6-7.6l-2.3-5.3a5.7 5.7 0 0 0-1.1 5zm9.8 7.2a12.1 12 0 0 0 3.8 3.8c-3.8 0-6.8-2-10.6-2.3-2.2 0-4.5.8-6.8.4 3 1.9 5.7 3.8 9 3.8 4.2.7 8.4 0 13.3 0a17.2 17.2 0 0 1-4.9-5.7c-1.9-3-3.8-5-7.2-5.3l3.8 5.3zm13.3 6c-6.5 1.2-12.9 2.7-19.7 2.7a30.3 30.3 0 0 0 22.3.4c3.8-1.2 7.2-2.3 10.2-2 4.5 0 9.8 2.3 15.9 8.4l2.3-1.9a36.3 36.3 0 0 0-31-7.6"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#383739",
      d: "M102.8 56.3 92.2 50V34.8l10.6-6.5V20l9.5-5.6h8l15-8.7h31.8l15.1 8.7h7.6l10.6 5.6v8.3l10.2 6.5v15l-10.2 6.5v8l-9.9 6h-8l-15 8.3h-31.8l-15.1-8.3H113l-10.6-6z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#00843d",
      d: "m135.3 6-15 8.7h-7.6l-9.9 5.7v8l-10.2 6.4v15l10.2 6.1v8.4l9.9 5.6h7.5l15.1 8.3h31.8l15.1-8.3h7.6l9.8-5.6v-8.4l10.2-6V34.8l-10.2-6.5v-7.9l-9.8-5.7h-7.6L167.1 6Zm.8 3.4h30.2l15.2 8.4h7.5l7.6 4.1v8.3l10.2 6.5V48l-10.6 6.4v8l-7.2 4.5h-7.5l-15.2 8.3h-30.2L121 67h-7.6l-7.6-4.5v-8L95.6 48V36.7l10.6-6.5V22l7.6-4.1h7.5z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#ffc72c",
      d: "M151.2 42.3V9.4h-15.1l-14.8 8.7h-7.5l-7.6 3.8v8.3L96 36.7V42h55.2v32.8h15.1l15.2-8.3h7.5l6.8-4.1V54l10.6-6.4v-5.3z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#fff",
      d: "M96 42.3v5.3l10.6 6.4v8.4l6.8 3.7h8l15 8.7h14.8V42h55.2v-5.3l-10.6-6.5v-7.5L189 18h-7.5l-15.2-8.7h-15v33Z"
    }),
    /* @__PURE__ */ jsxs269("g", {
      fill: "#383739",
      children: [
        /* @__PURE__ */ jsx294("path", {
          d: "m118.7 21.2-2.6-2.7-2.3 1.5 2.6 2.7-3.7 1.9h7.5l6 6 2-2.3-6.1-5.6v-3.8Z"
        }),
        /* @__PURE__ */ jsx294("path", {
          d: "m130.8 20-2.6-2.2-2.3 1.5 2.6 2.2-3.8 2h7.6l6 6 2-2.3-5.7-5.7v-3.7zm-12.9 7.6-2.6-2.3-2.6 2 2.6 2.2-3.4 1.9h7.6l6 6 1.9-2.3-6-5.6v-3.8z"
        }),
        /* @__PURE__ */ jsx294("path", {
          d: "M151.2 9.4h-6.4l-3.4 3h-6.8l-4.6 2.7 1.2 2.7 4.1-2.3h2l6.7 7.6 7.2-4.2Z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#d22630",
          d: "m116 18.9 2.3 2.3-1.9 1.1-2.2-1.9zm6.1.8v3l5.7 5.6-1.5 1.6-6-5.7h-6.1l7.5-5zm6-1.6 2.3 2-1.9 1.4-2.2-2.2Zm6.1 0V22l5.7 5.3-1.5 1.9-6-6.4h-6.1l7.5-4.6z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#d22630",
          d: "m115.3 26 2.3 2-2 1.1-2.2-1.9Zm5.7 0v4l6 5.2-1.5 1.6-6-5.7h-6Zm30.2-16.6h-6.4l-3.4 3.8H135l-4.6 2 .8 2.2L135 15h2.6l6 7.6 7.6-3.8Z"
        }),
        /* @__PURE__ */ jsx294("path", {
          d: "m118.7 63.5-2.6 2.3-2.3-1.5 2.6-2.3-3.7-2.3h7.5l6-5.7 2 2.3L122 62v3.8z"
        }),
        /* @__PURE__ */ jsx294("path", {
          d: "m130.8 64.3-2.6 2.6-2.3-1.5 2.6-2.3-3.8-2.2h7.6l6-5.7 2 1.9-5.7 5.6v3.8zm-12.9-7.6-2.6 2.3-2.6-1.6 2.6-2.2-3.4-2.3h7.6l6-5.7 1.9 2-6 5.6v3.8z"
        }),
        /* @__PURE__ */ jsx294("path", {
          d: "M151.2 75.2h-6.4l-3.4-3.4h-6.8l-4.6-2.3 1.2-3 4.1 2.3h2l6.7-7.6 7.6 4.6z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#d22630",
          d: "m116 65.4 2.3-2.3-1.9-1.1-2.2 2.3zm6.1-.4v-3.4l5.7-5.7-1.5-1.5-6 5.7h-6.1l7.5 5zm6 1.5 2.3-2.2-1.9-1.2-2.2 2.3zm6.1-.4v-3.7l5.7-5.3-1.5-1.5-6 5.6h-6.1l7.5 5z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#d22630",
          d: "m115.3 58.6 2.3-2.3-2-1.1-2.2 2.2Zm5.7-.4v-3.4l6-5.7-1.5-1.5-6 5.7h-6Zm30.2 16.6h-6.4l-3.4-3.4H135l-4.6-2.2.8-2 3.8 2h2.6l6.4-7.6 7.2 4.2z"
        }),
        /* @__PURE__ */ jsx294("path", {
          d: "m114.5 31.7-3-1-4.1 2.6v.7l-6.5 8.3 6.5 8v.7l3.7 3 3.4-1-1.8-1.6v-2.3l.7-.7h3.4V36.3H113l-.3-.8V33Z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#d22630",
          d: "m107.7 33.6 3.8-2.6 2.3.7-1.5 1.2v2.6l.7 1.2h3.4V48H113l-.7 1.1v2.7l1.5.7-2.3 1.2-3.8-2.7v-.7l-6.4-8 6.4-8.3Z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs269("g", {
      fill: "#383739",
      children: [
        /* @__PURE__ */ jsx294("path", {
          d: "m183.7 21.2 2.7-2.7 2.2 1.5-2.2 2.7 3 1.9h-7.2l-6 6-2-2.3 6.1-5.6v-3.8Z"
        }),
        /* @__PURE__ */ jsx294("path", {
          d: "m171.6 20 2.7-2.2 2.2 1.5-2.2 2.2 3 2H170l-6 6-2-2.3 6.1-5.7v-3.7zm12.9 7.6 2.6-2.3 2.7 2-2.7 2.2 3.4 1.9H183l-5.7 6.4-1.9-2.3 6-5.6V26z"
        }),
        /* @__PURE__ */ jsx294("path", {
          d: "M151.2 9.4h6.4l3.8 3h6.4l5 2.7-1.2 2.7-4.5-2.3h-1.9l-6.8 7.6-7.2-4.2Z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#d22630",
          d: "m186.4 18.9-2.3 2.3 1.9 1.1 2.3-1.9zm-5.7.8v3l-6 5.6 1.5 1.6 6-5.7h6l-7.5-5zm-6.8-1.6-2.3 2 2 1.4 2.2-2.2Zm-5.7 0V22l-5.6 5.3 1.5 1.9 6-6.4h6l-7.5-4.6z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#d22630",
          d: "m187.1 26-2.2 2 1.8 1.1 2.3-1.9Zm-5.6 0v4l-6.1 5.2 1.5 1.6 6-5.7h6.1ZM151.2 9.5h6.4l3.4 3.8h6.5l4.5 2-.8 2.2-3.7-2.3h-2.3l-6.8 7.6-7.2-3.8Z"
        }),
        /* @__PURE__ */ jsx294("path", {
          d: "m183.7 63.5 2.7 2.3 2.2-1.5-2.2-2.3 3-2.3h-7.2l-6-5.7-2 2.3 6.1 5.7v3.8z"
        }),
        /* @__PURE__ */ jsx294("path", {
          d: "m171.6 64.3 2.7 2.6 2.2-1.5-2.2-2.3 3-2.2H170l-6-5.7-2 1.9 6.1 5.6v3.8zm12.9-7.6L187 59l2.7-1.6-2.7-2.2 3.4-2.3H183l-6-5.7-2 2 6 5.6v3.8z"
        }),
        /* @__PURE__ */ jsx294("path", {
          d: "M151.2 75.2h6.4l3.8-3.4h6.4l5-2.3-1.2-3-4.5 2.3h-1.9l-6.8-7.6-7.2 4.6z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#d22630",
          d: "M186.4 65.4 184 63l2-1 2.3 2.3zm-5.7-.4v-3.4l-6-5.7 1.5-1.5 6 5.7h6zm-6.4 1.5-2.3-2.2 1.9-1.2 2.3 2.3zm-5.7-.4v-3.7l-6-5L164 56l6 5.7h6l-7.5 5z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#d22630",
          d: "m187.1 58.6-2.2-2.3 1.8-1.1 2.3 2.2zm-5.6-.4v-3.4l-6.1-5.7 1.5-1.5 6 5.7h6.1Zm-30.3 16.6h6.4l3.4-3.4h6.5l4.5-2.2-.8-2-3.7 2h-2.3l-6.8-7.6-7.2 4.2z"
        }),
        /* @__PURE__ */ jsx294("path", {
          d: "m187.9 31.7 3-1 4.2 2.6v.7l6.4 8.3-6.4 8v.7l-3.8 3-3.4-1 1.9-1.6v-2.3l-.8-.7h-3.4V36.3h3.8l.4-.8V33Z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#d22630",
          d: "m194.7 33.6-3.8-2.6-2.3.7 1.5 1.2v2.6l-.7 1.2H186V48h3.4l.7 1.1v2.7l-1.5.7 2.3 1.2 3.8-2.7v-.7l6.4-8-6.4-8.3Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#383739",
      d: "m108.9 49.1-1.5-1.5V47l-3.8-4.6 3.8-4.5V37l1.5-1.5 3.4 2.7h-2l2.7 2.6h6l5-3.8v-9.8h11.7l14-8.7v-2.2l-2.3-1.2-2.6 2v1l-2-2.6 3.9-3 4.1-2.7h1.5l3.8 2.7h.8l3.8 3-2 2.6-.3-1-2.7-2h-.7l-2.3 1.5V19l14 8.7h12.1v9.8l4.5 3.8h6l2.7-2.6h-1.5l3-2.7 1.6 1.5v.8l3.7 4.5-3.7 4.5v.8l-1.6 1.5-3-2.6h1.5l-2.6-2.7h-6l-4.6 3.8v9.8h-12.5l-14 8.3v2.3l2.3 1.5h.4l2.6-1.5v-1.1l2 2.6-3.5 2.7h-.4l-4.1 3H150l-3.8-3h-.8l-3.7-3 2.2-2.3v1.1l2.7 1.5h.4l2.2-1.5v-2.3l-14-8.3h-11.7V48l-4.9-3.8h-6L110 47h1.9z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#ffc72c",
      d: "m151.2 70 1.9 1-1.9 1.2zm-4.5 1.8 3.8 3h.7v-2.2L149 71l2.3-1.6V65l-15.1-9h-11v-9.1l-5.6-4.6h-8.7l-2 2.7-2.2-2.7H104l3.7 4.2v.7l1.2 1.6 2.2-2h-1v-.3l2.6-3h6.4l5.3 3.7v9.9h11.3l14.4 8.7v2.6l-2.3 1.5h-1.1l-2.3-1.5v-.7l-1.5 1.5 3 2.6zm-37.8-31.7 1.5 1.9H107zm42.3-27.6-1.5 1.1 1.5 1.1zM192 42.7l1.5 1.5 2-1.9zm-36.3-30.2-3.7-3h-.8v2.2l2.3 2-2.3 1.4V19l15.1 9h11v9.9L183 42h8.7l1.8-2.3 2.3 2.3h2.7l-3.8-3.8V37l-1.2-1-2.2 1.8h1.1l-2.6 3.4h-6.5l-4.9-3.8V27.2h-12l-14-8.3v-2.6l2.2-1.6h1.1l2.3 1.6v.7l1.5-1.9-3-2.6z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#fff",
      d: "m151.2 72.2-1.5-1.1 1.5-1.2zm-40.8-29.9-1.5 2-2-2zm45.3 29.5-3.7 3h-.8v-2.2l2.3-1.5-2.3-1.6V65l15.1-9h11v-9.1l5.7-4.6h8.7l1.8 2.7 2.3-2.7h2.7l-3.8 4.2v.7l-1.2 1.6-2.2-2h1.1v-.3l-2.6-3h-6.5l-4.9 3.7v9.9h-12L152 65.8v2.6l2.2 1.5h1.2l2.2-1.5v-.7l1.5 1.5-3 2.6zm37.8-31.7L192 42h3.4zm-46.8-27.6 3.8-3h.7v2.2l-2.3 2 2.3 1.4V19l-15.1 9h-11v9.9l-5.6 3.8h-8.7l-2-2.3-2.2 2.3H104l3.7-3.8v-1.1l1.2-1.2 2.2 2h-1l2.6 3.3h6.4l5.3-3.8v-9.8h11.3l14.8-8.3v-2.6l-2.3-1.6H147l-2.3 1.6v.7l-1.5-1.9 3-2.6h.8zm4.5 2.6 1.9-1.1-1.9-1.1z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#00843d",
      d: "M151.2 42.3V19.7l-15.1 9h-10.6v9.1l-5.3 4.2h31v22.6l15.1-9H177v-8.7l5.3-4.6z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#d22630",
      d: "m120.2 42.3 5.3 4.6v8.7h10.6l15.1 9V42h31l-5.3-4.2v-9h-10.6l-15-9.1v22.6z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#383739",
      d: "m135.3 31.4-2.6-2.7-2.3 2 2.3 2.2-3 1.9h7.1l6 6 2-2.2-6-5.7V29zm31.8 21.9 2.6 2.3 2.7-1.6-2.7-2.2 3-2.3h-6.4l-6.4-5.7-1.9 2 6 5.6v3.8zm-31.8 0-2.6 2.3-2.3-1.6 2.3-2.2-3-2.3h7.1l6-5.7 2 2-6 5.6v3.8zm31.8-22 2.6-2.6 2.7 2-2.7 2.2 3 1.9h-6.4l-6.4 6-1.9-2.2 6-5.7V29z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#d22630",
      d: "m169.7 55.2-2.2-2.3 1.9-1.1 2.2 2.2zm-5.6-.4v-3.4l-6-5.7 1.4-1.5 6 5.7h6.1zm-31.8-25.3 2.3 1.9-2 1.1-2.2-1.9zm5.7 0v3.8l6 5.3-1.5 1.5-6-5.7h-6l7.5-4.5z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#00843d",
      d: "m169.7 29.5-2.2 1.9 1.9 1.1 2.2-1.9zm-5.6 0v3.8l-6 5.3 1.4 1.5 6-5.7h6.1zm-31.8 26 2.3-2.2-2-1.1-2.2 2.2zm5.7-.3v-3.4l6-5.7-1.5-1.5-6 5.7h-6z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#383739",
      d: "M167 42.3 151.3 53l-15.9-10.6 16-10.6Z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#fff",
      d: "M151.2 32.1 136.1 42h30.2zv20l15-9.8H136l15.1 9.9z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#383739",
      d: "M155.4 45.7v3h-8v-3h-5.6v-7.1h5.6v-3h7.6v3h5.7V46z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#d22630",
      d: "M147.4 36v3h-5.6v3h9.4v-6zm3.8 6h9.5v-3H155v-3h-3.8zm-9.4.3v3.4h5.6v2.7h3.8v-6zm9.4 6h3.8v-2.6h5.7v-3.4h-9.5z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#383739",
      d: "M178.4 162.9v-4.5h12.9v-5h12.5v-41.9h-12.5v-5h-12.9V102h-12.8v-4.5h-28.8v4.5H124v4.6h-13v4.9H98.7v42H111v5.2h13v3.8h12.8v4.6h28.8v-4.6z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#ffc72c",
      d: "M137.2 97.9v4.1h-12.5v4.6H112v4.9H99.4v41.6H112v4.5h12.8v5h12.9v4.5h28v-4.6h12.8V158h12.9v-5H204v-41.5h-12.8V107h-13.6v-4.6h-12.9V98zm3.8 3.4h20.8v4.5h12.8v4.6h12.9v4.9h12.9v34.4h-12.9v5.3h-12.9v3.7h-12.8v4.6h-21.2v-4.6h-12.8V155h-12.9v-5h-12.5v-34.3H115v-5h12.9v-4.9h12.8z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#d22630",
      d: "M128.5 158.7v-4.5h-13.2v-4.5h-12.9v-34h12.9v-5h13.2v-4.5h12.9v-4.5h20.4v4.1h12.8v4.6h12.9v4.9h12.9v34h-12.9v4.5h-13.6v5H161v4.9h-20.4v-5z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#383739",
      d: "m131.2 109.6-3.4-2.6v4.9l-3 1.9v-3l-3 3-3.1-3v3l-3.8-2v4.2l-2.6 2.3v-2.6l-3.8 2.2-3-2.2v2.6L102 116v13.3h-3.8v6.8h3.8v13.2l3.4-2.3v3l3.4-2.6 3.4 2.6v-3l2.6 2.3v4.5l3.8-2.2v3l3-3 3 3v-3.4l3 1.9v4.9l3.5-2.7v3.4l3.4-3 3 3V155l3 2.2v5.3l4.6-4.1v4.5l6-3.8 6 3.8v-4.2l4.6 3.8v-4.9l3-2.3v3.4l3-3 3.8 3V155l3 2.6v-5l3-1.8v3l3.1-3 3 3v-2.6l3.8 2.2V149l2.6-2.3v3l3.8-2.6 3 2.7v-3l3.5 2.2v-12.8h3.7v-6.5h-3.7v-13.2l-3.4 2.3V116l-3.5 2.3-3.4-2.3v2.7l-2.6-2.3v-4.1l-3.8 1.8v-3l-3 3-3-3v3l-3-1.8v-5l-3.5 2.7v-3.4l-3 3-3.8-3v3.4l-2.6-2.3v-4.9l-4.5 3.8V102l-6 3.8-6.1-3.8v3.8l-4.6-3.8v5l-3 2.2v-3.4l-3 3-3.4-3z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#00843d",
      d: "M105.8 119v-3l3 2.3 3.1-2.3v3l3-2.6v32.1l-3-2.2v2.6l-3-2.3-3 2.3v-2.6l-3.5 2.2v-13.2h-3.7v-5.7h3.7v-13.2zm25.8-12 3 2.6 2.6-2.6v3.4l3.4-2.7V157l-3.4-2.3v3.4l-2.6-2.7-3 2.7v-3.4l-3.4 2.6v-49.1l3.4 2.3zm39.3 0-2.7 2.6-3-2.6v3.4l-3.4-2.7V157l3.4-2.3v3.4l3-2.7 2.7 2.7v-3.4l3.4 2.6v-49.1l-3.4 2.3zm25.7 12v-3l-3 2.3-3-2.3v3l-3.1-2.6v32.1l3-2.2v2.6l3-2.3 3 2.3v-2.6l3.5 2.2v-13.2h3.8v-5.7H200v-13.2z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#ffc72c",
      d: "m119 111.9 2.7 2.2 2.7-2.2v2.6l3.8-2.2v40.4l-3.8-2.3v3l-2.7-2.6-2.6 2.6v-3l-3.8 2.3v-40.4l3.8 2.2zm26.5-5-4.5-3.7v59l4.5-4.2v4.5l5.7-3.8 5.7 3.8v-4.9l4.5 3.8v-57.8l-4.5 3.7V102l-5.7 3.8-5.7-3.8zm37.8 5-2.6 2.2-2.6-2.2v2.6l-3.8-2.2v40.4l3.8-2.3v3l2.6-2.6 3 2.6v-3l3.4 2.3v-40.4l-3.8 2.2z"
    }),
    /* @__PURE__ */ jsxs269("g", {
      fill: "#383739",
      children: [
        /* @__PURE__ */ jsx294("path", {
          d: "m107.4 126.6 1.5.8c.3 0 1.1 0 1.5-.8 1.1-1.1 1.1-3.4 1.1-4.9l-1.9 1.9-.7-1.9-1.2 1.9-1.5-1.9c0 1.5 0 3.8 1.2 5zm13.6-3.4-1.2-1.1v-2l-2.2 2.4 3.7 3.7 4.6-3.7-2.3-2.3v1.9l-1.1 1.1v-3.8l1.9-1.5-2.7-2.2-2.6 2.2 1.9 2zm12.4-3.8-.7-1.1V116l-2.7 2.3 4.6 4.2 3.8-3.8-2.3-2.7v2.3l-.8.8v-3.8l2-1.2-2.7-2.2-2.7 2.2 1.5 1.6z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#fff",
          d: "m108.9 122.5.7 1.5 1.5-1.5c0 1.8-.3 3.4-1 3.7a1.5 1.5 0 0 1-2.4 0c-.7-.3-1.1-1.9-1.1-3.7l1.5 1.5zm26-7.2v4.9l1.6-1.9v-1.1l1.5 1.5-3.8 3.8-3.8-3.8 2-1.5v1.5l1.4 1.9v-5l-1.5-1 2.3-2 1.9 2z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#d22630",
          d: "M122.1 119.4v4.6l1.9-1.5v-1.6l1.5 1.6-3.8 3.7-3.8-3.7 1.6-1.6v1.6l1.5 1.5v-4.6l-1.5-1.5 2.2-1.5 2 1.5z"
        }),
        /* @__PURE__ */ jsx294("path", {
          d: "m195 126.6-1.5.8c-.3 0-.7 0-1-.8-1.6-1.1-1.6-3.4-1.6-4.9l1.9 1.9.7-1.9 1.2 1.9 1.5-1.9c0 1.5 0 3.8-1.1 5zm-13.2-3.4.8-1.1v-2l2.3 2.4-3.8 3.7-4.6-3.7 2.3-2.3v1.9l1.1 1.1v-3.8l-1.8-1.5 2.6-2.2 2.6 2.2-1.5 2zm-12.8-3.8.7-1.1V116l2.7 2.3-4.2 4.2-4.5-3.8 2.6-2.7v2.3l.8.8v-3.8l-1.5-1.2 2.6-2.2 2.7 2.2-2 1.6z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#fff",
          d: "m193.5 122.5-.7 1.5-1.5-1.5c0 1.8.4 3.4 1.1 3.7a1.5 1.5 0 0 0 2.3 0c.7-.3 1.1-1.9 1.1-3.7l-1.1 1.5zm-26-7.2v4.9l-1.5-1.9v-1.1l-1.6 1.5 3.8 3.8 3.8-3.8-1.9-1.5v1.5l-1.5 1.9v-5l1.5-1-1.9-2-2.2 2z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#d22630",
          d: "M180.3 119.4v4.6l-1.5-1.5v-1.6l-1.5 1.6 3.8 3.7 3.8-3.7-2-1.6v1.6l-1.4 1.5v-4.6l1.5-1.5-2.3-1.5-1.9 1.5z"
        }),
        /* @__PURE__ */ jsx294("path", {
          d: "m156.1 121-1.1-2.3 3.4-3-3.4-2.7v1.9l-1.1 1.1v-3.7l3-2-5.7-4.5-5.7 3.8 3 2.7v3.4l-1-1.2v-1.9l-3.5 2.7 3.8 3-1.5 1.9z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#d22630",
          d: "m147 120.6 1.2-2-3.8-3 2.7-1.8v1.1l1.8 1.9v-4.5l-2.6-2 5-3.7 4.8 3.8-2.6 1.9v4.9l1.9-2v-1l2.6 1.8-3.8 3 1.5 2z"
        }),
        /* @__PURE__ */ jsx294("path", {
          d: "m148.6 110.4 2.6 1.9 2.7-2-2.7-1.8Z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#00843d",
          d: "m151.2 108.9 1.9 1.5-1.9 1.1-1.9-1.1z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs269("g", {
      fill: "#383739",
      children: [
        /* @__PURE__ */ jsx294("path", {
          d: "M107.4 138.3a1.9 1.9 0 0 1 1.5-.7c.3 0 1.1 0 1.5.7 1.1 1.2 1.1 3.4 1.1 5l-1.9-1.6-.7 1.5-1.2-1.5-1.5 1.5c0-1.5 0-3.7 1.2-4.9m13.6 3.4-1.2 1.2v1.9l-2.2-2.3 3.7-3.8 4.6 3.8-2.3 2.3v-2l-1.1-1v3.7l1.9 1.5-2.7 2.3-2.6-2.3 1.9-1.9zm12.4 3.8-.7 1.1v2.3l-2.7-2.3 4.6-4.1 3.8 4.1-2.3 2.3v-2.3l-.8-.7v3.8l2 1.1-2.7 2.3-2.7-2.3 1.5-1.5z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#fff",
          d: "m108.9 142.5.7-1.5 1.5 1.5c0-1.9-.3-3.4-1-3.8a1.5 1.5 0 0 0-2.4 0c-.7.4-1.1 1.9-1.1 3.8l1.5-1.5zm26 7.2v-5l1.6 2v1.5l1.5-1.6-3.8-3.7-3.8 3.7 2 1.6v-1.6l1.4-1.8v4.9l-1.5 1.1 2.3 1.9 1.9-1.9z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#d22630",
          d: "M122.1 145.5V141l1.9 1.5v1.5l1.5-1.5-3.8-3.8-3.8 3.8 1.6 1.5v-1.5l1.5-1.5v4.5l-1.5 1.5 2.2 1.5 2-1.5z"
        }),
        /* @__PURE__ */ jsx294("path", {
          d: "M195 138.3a1.9 1.9 0 0 0-1.5-.7c-.3 0-.7 0-1 .7-1.6 1.2-1.6 3.4-1.6 5l1.9-1.6.7 1.5 1.2-1.5 1.5 1.5c0-1.5 0-3.7-1.1-4.9zm-13.2 3.4.8 1.2v1.9l2.3-2.3-3.8-3.8-4.6 3.8 2.3 2.3v-2l1.1-1v3.7l-1.8 1.5 2.6 2.3 2.6-2.3-1.5-1.9zm-12.8 3.8.7 1.1v2.3l2.7-2.3-4.2-4.1-4.5 4.1 2.6 2.3v-2.3l.8-.7v3.8l-1.5 1.1 2.6 2.3 2.7-2.3-2-1.5z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#fff",
          d: "m193.5 142.5-.7-1.5-1.5 1.5c0-1.9.4-3.4 1.1-3.8a1.5 1.5 0 0 1 2.3 0c.7.4 1.1 1.9 1.1 3.8l-1.1-1.5zm-26 7.2v-5l-1.5 2v1.5l-1.6-1.6 3.8-3.7 3.8 3.7-1.9 1.6v-1.6l-1.5-1.8v4.9l1.5 1.1-1.9 1.9-2.2-1.9z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#d22630",
          d: "M180.3 145.5V141l-1.5 1.5v1.5l-1.5-1.5 3.8-3.8 3.8 3.8-2 1.5v-1.5l-1.4-1.5v4.5l1.5 1.5-2.3 1.5-1.9-1.5z"
        }),
        /* @__PURE__ */ jsx294("path", {
          d: "m156.1 144.4-1.1 1.9 3.4 3-3.4 2.6V150l-1.1-1v3.7l3 1.9-5.7 4.1-5.7-3.7 3-2.7V149l-1 1.1v2l-3.5-2.7 3.8-3-1.5-2z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#d22630",
          d: "m147 144.8 1.2 1.5-3.8 3 2.7 1.9V150l1.8-1.8v4.5l-2.6 1.9 5 3.8 4.8-3.8-2.6-2v-4.4l1.9 1.8v1.2l2.6-2-3.8-3 1.5-1.4z"
        }),
        /* @__PURE__ */ jsx294("path", {
          d: "m148.6 155 2.6-2.3 2.7 1.9-2.7 1.9Z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#00843d",
          d: "m151.2 156 1.9-1.4-1.9-1.2-1.9 1.2Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#383739",
      d: "M196.6 130.4h-5.3v-1.9h-17.4l-12.1-7.6h-21.2l-12 7.6H111v2.3h-5.3v3.8h5.3v2.6h17.4l12.1 7.6h21.2l12-7.6h17.5v-2.3h5.3z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#d22630",
      d: "m140.6 121-12 7.5h-17v2.3h-5.4v3.4h5.3v2.2h17l12.1 7.6h21.2l12-7.6H191v-2.2h5.7v-3.4H191v-2.3h-17l-12.1-7.6zm0 1h20.8l11.4 7.3v1h12v4.6h-12.4v1.2l-11 6.8H141l-11.3-6.8v-1.2h-12.1v-4.5H130v-1.1z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#d22630",
      d: "m161.4 122 10.6 7.6v.8h12.5v3.8H172v1.5l-10.6 7.2H141l-10.6-7.2v-1.1H118v-3.8h12.5v-1.5L141 122z"
    }),
    /* @__PURE__ */ jsxs269("g", {
      fill: "#383739",
      children: [
        /* @__PURE__ */ jsx294("path", {
          d: "m135.7 136.4 4.5 3.8 3-2.6-1.4-1.2-1.6.8-1-.8 17.3-13.2h-3.4zm10.2 5.3h3.4l17.4-13.2-4.5-3.8-3 2.7 1.8 1.1 1.2-.8 1.1.8zm7.6 0h3l-17.4-13.2 1.1-.8 1.6.8 1.5-1.1-3-2.3-4.6 3.4Zm9.8-5.3-1.1.8-1.2-.8-1.9 1.2 3 2.2 4.6-3.4-17.4-13.2h-3.8zm-31-3.7 3 1.9 3-2-3-2.2zm15.9-.4 3 2.3 3-2-3-2.2Zm22 0-3.1 2.3-3-2 3-2.2z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#ffc72c",
          d: "m166.3 136.4-4.1 3-2.7-1.8 1.5-.8 1.2.8 1.5-1.2-17-12.8h2.6zm-10.6 5h-2.6l-17-12.9 4.1-3 2.7 1.9-1.1.7-1.6-.7-1.5 1.1zm-6.4 0h-2.6l17-12.9-1.5-1.1-1.2.7-1.5-.7 2.7-2 3.8 3.1zm3.8-17.8h2.6l-17 12.8 1.5 1.2 1.6-.8 1 .8-2.6 1.9-3.7-3z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#00843d",
          d: "m135.3 130.8 2.3 1.9-2.3 1.5-2.6-1.5zm16 0 2.6 1.9-2.7 1.5-2.6-1.5zm15.8 0-2.3 1.9 2.3 1.5 2.6-1.5z"
        })
      ]
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#383739",
      d: "m96.4 219.2-1.1 1.9 2.2 1.5-2.2 1.9 1.1 1.5 2.6.4 2.3-1.9 6.4 3.8v-3l-3.7-2.7 3.7-2.3V217l-6.4 3.8-2.3-1.5zm0-11.3-1.1 1.9 2.2 1.5-2.2 1.9 1.1 1.5 2.6.4 2.3-2 6.4 3.8v-3l-3.7-2.6 3.7-2.3v-3.4l-6.4 3.8-2.3-1.5zm0 29.5-1.1-1.6 2.2-1.8-2.2-1.6 1.1-1.8H99l2.3 1.5 6.4-3.8v3.4L104 234l3.7 2.6v3l-6.4-3.8-2.3 2zM206 219.2l1.2 1.9-2.3 1.5 2.3 1.9-1.2 1.5-2.6.4-2.3-1.9-6.4 3.8v-3l3.8-2.7-3.8-2.3V217l6.4 3.8 2.3-1.5zm0-11.3 1.2 1.9-2.3 1.5 2.3 1.9-1.2 1.5-2.6.4-2.3-2-6.4 3.8v-3l3.8-2.6-3.8-2.3v-3.4l6.4 3.8 2.3-1.5zm0 29.5 1.2-1.6-2.3-1.8 2.3-1.6-1.2-1.8h-2.6L201 232l-6.4-3.8v3.4l3.8 2.3-3.8 2.6v3l6.4-3.8 2.3 2zM181.5 189v4.5h3.4v2.3h3.4V192h-3v-3Zm9.8 7.5v3.8h3.8v1.9h3v-3.8h-3v-1.9ZM121 189v4.5h-3.4v2.3h-3.4V192h3v-3Zm60.5 68v-4.5h3.4v-2h3.4v3.9h-3v3zm-60.5 0v-4.5h-3.4v-2h-3.4v3.9h3v3zm70.3-7.6V245h3.8v-2.3h3v3.8h-3v3ZM111 196.5v3.8h-3.7v1.9h-3v-3.8h3v-1.9Zm0 53.3v-4.5h-3.7V243h-3v3.8h3v3zm53-60.8-2.7-2.7-2.6 2.3 2.2 2.3-3 2.6h4.2l1.5-1.5 1.5 1.5h5L167 191l2.3-2.3-2.7-2.3zm-12.9 0-2.6-2.7-2.7 2.3 2.3 2.3-2.7 2.6h4.2l1.5-1.5 1.5 1.5h4.2l-2.7-2.6 2.3-2.3-2.6-2.3zm-12.5 0 2.7-2.7 2.3 2.3-2.3 2.3 3 2.6h-4.2l-1.5-1.5-1.5 1.5h-4.9l3-2.6-2.2-2.3 2.6-2.3 2.7 2.7zm25 68-2.3 3-2.6-2.6 2.2-1.9-3-3h4.2l1.5 1.5 1.5-1.5h5l-3.1 3 2.3 1.9-2.7 2.6zm-12.5 0-2.6 3-2.7-2.6 2.3-1.9-2.7-3h4.2l1.5 1.5 1.5-1.5h4.2l-2.7 3 2.3 1.9-2.6 2.6zm-12.5 0 2.7 3 2.3-2.6-2.3-1.9 3-3h-4.2l-1.5 1.5-1.5-1.5h-4.9l3 3-2.2 1.9 2.6 2.6 2.7-2.6z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#00843d",
      d: "M107.4 225.3v2.6l-6-3.8-2.4 2h-2.2l-1.2-1.6 2.3-1.9-2.3-1.5 1.2-1.5H99l2.3 1.9 6-3.8v2.3l-4.1 2.6zm0-11.4v2.7l-6-3.8-2.4 1.9h-2.2l-1.2-1.5 2.3-2-2.3-1.4 1.2-1.5H99l2.3 1.8 6-3.7v2.2l-4.1 2.7zm0 17.4V229l-6 3.8-2.4-2.2h-2.2l-1.2 1.5L98 234l-2.3 1.8 1.2 1.2H99l2.3-1.5 6 3.7v-2.6l-4.1-2.6zm87.7-6v2.6l6-3.8 2.7 2h1.8l1.2-1.6-2.3-1.9 2.3-1.5-1.2-1.5h-1.5l-2.6 1.9-6-3.8v2.3l4.1 2.6zm0-11.4v2.7l6-3.8 2.7 1.9h1.8l1.2-1.5-2.3-2 2.3-1.4-1.2-1.5h-1.5l-2.6 1.8-6-3.7v2.2l4.1 2.7zm0 17.4V229l6 3.8 2.7-2.2h1.8l1.2 1.5-2.3 1.9 2.3 1.8-1.2 1.2h-1.5l-2.6-1.5-6 3.7v-2.6l4.1-2.6zm-9.9-42.3v3h3v3h-3v-2.2h-3.7V189zm10.2 7.5v2.7h2.7v3h-2.7v-1.9H192v-3.8zm-78.2-7.5v3h-3v3h2.6v-2.2h3.8V189zm68 67.6v-3.4h3v-3h-3v1.9h-3.7v3.8zm-67.3 0v-3.4h-3v-3h2.7v1.9h3.7v3.8zm77.5-7.5v-3h2.7v-3h-2.7v2.2H192v3.8zm-87.7-52.6v3h-3v3h2.7v-2.2h3.4v-3.8zm0 53v-3h-3v-3.1h2.7v2.3h3.4v3.7zm53.7-62.8 2.3 2.7 2.6-2.7 2.3 1.9-2.3 2.3 2.7 2.2h-3.8l-1.5-1.5-1.5 1.5h-3.4l2.6-2.2-2.3-2.3zm-12.8 0 2.6 2.7 2.7-2.7 1.8 1.9-2.2 2.3 2.6 2.2h-3.4l-1.5-1.5-1.5 1.5h-3.8l3-2.2-2.2-2.3zm-7.6 0-2.3 2.7-2.6-2.7-2.3 1.9 2.3 2.3-2.3 2.2h3l2-1.5 1.4 1.5h3.5L141 191l2.3-2.3zm20.4 72.6 2.3-2.3 2.6 2.3 2.3-2-2.3-1.8 2.7-2.6h-3.8l-1.5 1.5-1.5-1.5h-3.4l2.6 2.6-2.3 1.9zm-12.8 0 2.6-2.3 2.7 2.3 1.8-2-2.2-1.8 2.6-2.6h-3.4l-1.5 1.5-1.5-1.5h-3.8l3 2.6-2.2 1.9zm-7.6 0-2.3-2.3-2.6 2.3-2.3-2 2.3-1.8-2.3-2.6h3l2 1.5 1.4-1.5h3.5l-2.7 2.6 2.3 1.9z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#383739",
      d: "M117.2 245.3v7.6h68v-7.6h9.9v-45h-9.9v-7.5h-68v7.5h-9.8v45z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#ffc72c",
      d: "M117.6 193.1v7.6h-9.9v44.2h9.5v7.6h68v-7.6h9.9v-44.6h-9.9v-7.5h-68zm4.5 3h58.2v7.2l2.7 1.6h9v35.5h-9l-2.7 1.9v7.1h-58.2V242l-2.6-1.5h-9.1V205h9l2.7-1.6v-7.5z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#d22630",
      d: "M122.5 196.5v6.5l8.7-6.5zm49.1 0 8.3 6.5v-6.5zm-60.5 8.7v6.5l8-6zm72.2 0 8.4 6.5v-6.5zm8.4 28.8-8.4 6h8.4zm-81 0v6h8.4zm11.4 8.6v6.5h9zm57.8 0-8.7 6.5h8.7z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#00843d",
      d: "m170.9 196.5 20.8 15.2v21.9l-20.8 15h-39.3l-20.8-15v-22l20.8-15.4z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#383739",
      d: "m115.7 235.8-2.3-2.6 2.3-2.6-2.3-2.7 2.3-2.6-2.3-2.7 2.3-2.6-2.3-2.7 2.3-2.6-2.3-2.3 2.3-3h71l2.3 3-2.3 2.3 2.3 2.6-2.3 2.7 2.3 2.6-2.3 2.7 2.3 2.6-2.3 2.7 2.3 2.6-2.3 2.6zm49.1-35.9-3-2.6-2.7 2.3-2.6-2.3-2.6 2.3-2.7-2.3-2.6 2.3-2.7-2.3-2.6 2.3-2.7-2.3-2.6 2.6v45.4l2.6 2.6 2.7-2.2 2.6 2.2 2.7-2.2 2.6 2.2 2.7-2.2 2.6 2.2 2.6-2.2 2.7 2.2 2.6-2.2z"
    }),
    /* @__PURE__ */ jsxs269("g", {
      fill: "#ffc72c",
      children: [
        /* @__PURE__ */ jsx294("path", {
          d: "m158.8 200.3-2.3-2.3-2.6 2v45.3l2.6 2.3 2.3-2.3zm-10.2 0-2.7-2.3-2.2 2v45.3l2.2 2.3 2.7-2.3z"
        }),
        /* @__PURE__ */ jsx294("path", {
          d: "m116 235.8-2.2-2.6 2.3-2.3h70.3l2.2 2.3-2.2 2.6zm70.4-15.5 2.2 2.3-2.2 2.7H116l-2.3-2.7 2.3-2.3zm0-5.6 2.2-2.3-2.2-2.6H116l-2.3 2.6 2.3 2.3z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs269("g", {
      fill: "#d22630",
      children: [
        /* @__PURE__ */ jsx294("path", {
          d: "m164 200.3-2.2-2.3-2.7 2v45.3l2.7 2.3 2.3-2.3zm-20.3 0L141 198l-2.3 2v45.3l2.3 2.3 2.7-2.3z"
        }),
        /* @__PURE__ */ jsx294("path", {
          d: "m116 230.6-2.2-2.7 2.3-2.3h70.3l2.2 2.3-2.2 2.7zm0-10.6-2.2-2.7 2.3-2.2h70.3l2.2 2.2-2.2 2.7z"
        }),
        /* @__PURE__ */ jsx294("path", {
          d: "m153.9 245.7-2.7 1.9-2.3-2.3v-45l2.3-1.9 2.7 2Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#383739",
      d: "M175 200.7h-47.6v3.8H121v36.3h6v3.7h47.6v-3.7h6.9v-36.3h-6.1v-3.8z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#d22630",
      d: "M127.8 201v3.9h-6v35.5h6v3.8h4.5l-9.8-8.4v-26.4l9.8-8.3h-4.9zm42 0 9.8 8.8v26.4l-9.5 7.6h5V240h6v-35.5h-6v-3.8h-5z"
    }),
    /* @__PURE__ */ jsxs269("g", {
      fill: "#00843d",
      children: [
        /* @__PURE__ */ jsx294("path", {
          d: "m133 201-9.8 8.8v26l9.9 8.4h36.3l9.8-8.4v-26.4l-9.8-8.3zm.8 1.6h34.8l9.5 7.5v25l-9.5 7.5h-34.8l-9.4-7.5v-24.6z"
        }),
        /* @__PURE__ */ jsx294("path", {
          d: "m142.9 235.5 1.5.7.4 2-2 1.4 3.1 2.7h-3l-1.9-2-1.9 2h-3l2.6-2.7-1.9-1.5v-1.9l2-.7 1.8 1.5zm10.2 0 1.5.7.4 2-1.9 1.4 3 2.7h-3l-1.9-2-1.9 2h-2.6l2.6-2.7-1.9-1.5v-1.9l2-.7 1.8 1.5zm6.4 0-1.5.7-.4 2 2 1.4-2.7 2.7h2.6l2-2 1.8 2h3l-3-2.7 1.9-1.5v-1.9l-1.9-.7-1.9 1.5zM143 210l1.5-.7.4-1.9-2-1.9 3.1-2.6h-3l-1.9 1.9-1.9-2h-3l2.6 2.7-1.9 1.9v1.9l2 .7 1.8-1.8zm10.2 0 1.5-.7.4-1.9-1.9-1.9 3-2.6h-3l-1.9 1.9-1.9-2h-2.6l2.6 2.7-1.9 1.9v1.9l2 .7 1.8-1.8zm6.4 0-1.5-.7-.4-1.9 2-1.9-2.7-2.6h2.6l2 1.9 1.8-2h3l-3 2.7 1.9 1.9v1.9l-1.9.7-1.9-1.8zm18.2 2.7-1.5 1.5 1.5 1.1v2.3l-2.7-1.9-1.5 1.5h-1.9l-.7-1.5 1.5-1.5-1.5-1.5.7-1.5h2l1.4 1.5 2.7-1.9zm0 8.7-1.5 1.1 1.5 1.5v2l-2.7-2-1.5 1.5h-1.9l-.7-1.5 1.5-1.5-1.5-1.5.7-1.1h2l1.4 1.1 2.7-1.9Zm0 11.3-1.5-1.5 1.5-1.5v-1.9l-2.7 1.9-1.5-1.5h-1.9l-.7 1.5 1.5 1.5-1.5 1.5.7 1.2h2l1.4-1.2 2.7 2zm-53-20 2 1.5-2 1.1v2.3l2.7-1.9 1.5 1.5h1.9l.8-1.5-1.6-1.5 1.6-1.5-.8-1.5H129l-1.5 1.5-2.7-1.9Zm0 8.7 2 1.1-2 1.5v2l2.7-2 1.5 1.5h1.9l.8-1.5-1.6-1.5 1.6-1.5-.8-1.1H129l-1.5 1.1-2.7-1.9Zm0 11.3 2-1.5-2-1.5v-1.9l2.7 1.9 1.5-1.5h1.9l.8 1.5-1.6 1.5 1.6 1.5-.8 1.2H129l-1.5-1.2-2.7 2Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#d22630",
      d: "m133.8 203-8.7 7.5 2.3 2 1.5-1.6h2.3l.7 1.9-1.5 1.5 1.5 1.5-.7 1.5h-2.7l-1.5-1.1-2.6 1.9v.7l2.6 2 1.5-1.6 2.3.4.8 1.5-1.6 1.5 1.6 1.5-.8 2h-2.3l-1.5-1.6-2.6 2.3v.3l2.6 2.3 1.5-1.5h2.3l.8 1.9-1.6 1.5 1.6 1.5-.8 1.5h-2.3l-1.5-1.1-2.3 1.9 8.7 7.5h2l3-3-2-1.5v-2.3l2.3-.7 2 1.5 1.8-1.5 2 .7.3 2.3-2 1.5 3.1 2.7 2.7-2.7-2-1.5v-2.3l2.3-.7 2 1.5 1.8-1.5 2 .7.3 2.3-1.9 1.5 2.6 2.7 3-2.7-1.8-1.5v-2.3l2.2-.7 2 1.5 1.8-1.5 2 .7.3 2.3-1.9 1.5 3 2.7h2l8.6-7.6-2.3-1.5-1.5 1.5-2.2-.4-.8-1.5 1.5-1.5-1.5-1.5.8-1.5 2.2-.4 1.5 1.5 2.7-2.3v-.3l-2.7-2.3-1.5 1.5H171l-.8-1.9 1.5-1.5-1.5-1.5.8-1.5h2.2l1.5 1.1 2.7-1.9v-.7l-2.7-2-1.5 1.6-2.2-.4-.8-1.5 1.5-1.5-1.5-1.5.8-1.5 2.2-.4 1.5 1.5 2.3-1.9-8.7-7.5h-1.9l-3 2.6 1.9 1.9v2.3l-2.3.7-1.9-1.5-1.9 1.5-1.8-.7-.4-2.3 1.9-1.9-2.7-2.6-3 2.6 1.9 1.9v2.3l-2.3.7-1.9-1.5-1.9 1.5-1.8-.7-.4-2.3 1.9-1.9-2.7-2.6-3 2.6 1.9 1.9v2.3l-2.3.7-1.9-1.5-1.9 1.5-1.9-.7-.3-2.3 1.9-1.9-3-2.6zm-9 18.9v1.8l1-1z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#fff",
      d: "m141 241.1-1.5 1.2h3zm10.2 0-1.5 1.2h3zm10.2 0-1.5 1.2h3zm-22-37.8 1.6 1.2 1.5-1.5zm10.3 0 1.5 1.2 1.5-1.5zm10.2 0 1.5 1.2 1.5-1.5zm17.8 10.2-1.2.8 1.2.8zm0 8.4-1.2.7 1.2 1.1zm0 8.7-1.2.7 1.2.8zm-53-17.4v1.9l1.2-.8zm0 8.7v1.8l1.2-1zm0 8.3v1.9l1.2-.8z"
    }),
    /* @__PURE__ */ jsxs269("g", {
      fill: "#383739",
      children: [
        /* @__PURE__ */ jsx294("path", {
          d: "M160 220v-3h-3.1v-3.5h-11.4v3.4h-3v3h-4.1v5.7h4.1v3h3v3.5H157v-3.8h3v-2.7h4.2V220z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#ffc72c",
          d: "M151.2 214v3.3l-4.9 2.7v2.6h-7.6v-2.3h3.8v-3h3.4v-3.8zm0 17.7v-3.8l5-2.6V223h7.5v2.3h-3.8v3h-3.4v3.4z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#fff",
          d: "M156.1 222.6V220l-4.9-2.7v-3.8h5.3v3.8h3v3h4.2v2.3zm-17.4 0h7.6v2.7l5 3v3.4h-5.4v-3.8h-3v-2.6h-4.2z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#d22630",
          d: "M146.7 223v2.3l4.5 2.6v-5Z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#00843d",
          d: "m151.2 217.7-4.5 2.6v2.3h4.5Z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#d22630",
          d: "M155.7 222.6v-2.3l-4.5-2.6v5z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#00843d",
          d: "m151.2 228 4.5-2.7V223h-4.5Z"
        })
      ]
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#d22630",
      d: "M110 283v9.5h-8.7v8.4h-9V325h9v8.7h8.3v9.1h32.5l5.7 3.8-2.6 1.5h-11.4l-1.1-1.1h11l-3-3h-15.2l6.8 7.1h14l5-3.4 4.8 3h14l6.8-7.1h-15.1l-3 3h10.6l-.8 1.1h-11.7l-2.7-1.9 5.7-3.4h32.5v-9h8.7V325h9v-24h-9v-8.4h-8.3v-9.4h-32.5l-5.7-3.8 2.7-1.5h11.3l1.1 1.1h-11l3.1 3h15.1l-6.8-7.1h-14l-4.9 3-4.9-3h-14l-6.8 7.5h15.1l3-3.4h-10.5l.7-1.1h11.7l2.7 1.9-5.7 3.4z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#ffc72c",
      d: "M160 342.4h32v-9h8.4v-8.7h9v-23.5h-9v-8.7h-8.7v-9h-32.2L146 275h-13.6l-6 6.5h14l2.2-2.3h-10.2l1.5-1.9h11.7l15.2 9.5H189v9h9v8.7h9.2v16.7H198v8.7h-9v9.4h-27.7l-15.1 9h-12.1l-1.5-1.8h10.2l-2.3-2.3h-14l6 6.4h14zm-18.6-3h-27.6V330H105v-8.7h-9v-16.7h9V296h8.3v-8.7H141l15.1-9.4h12.1l1.5 1.9h-10.2l2.3 2.3h14L170 275h-14l-13.2 8.4h-32.5v9H102v8.7h-9v23.5h9v8.7h8.8v9h32.5l13.2 8.3h13.6l6-6.4h-14l-2.2 2.3h10.2l-1.5 1.9h-11.7z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "none",
      d: "m151.2 281.2-9.4 6h-27.6v9.5h-8.7v8.7h-9.1v15.9h9v8.7h8.8v9.4h27.6l9.4 5.7 9.5-5.7h27.6V330h9v-8.7h9.1v-16h-9v-8.6h-9.1v-9.5h-27.6zm0 2.3 9 5.6h26.2v9.5h8.7v8.3h9v12h-9v8.8h-8.7v8.7h-26.5l-8.7 6-9-6H116v-9h-8.7v-8.8h-9.1v-12h9v-8h8.8V289h26.4z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#00843d",
      d: "M186 327.3v9h-25.7l-9 5.7-9.2-5.6h-25.7v-9h-8.7v-8.8h-9.4v-11.3h9v-8.7h8.8v-9h25.7l9-5.4 9.1 5.3h25.7v9h8.7v8.8h9.8v11.3h-9v8.7z"
    }),
    /* @__PURE__ */ jsxs269("g", {
      fill: "#383739",
      children: [
        /* @__PURE__ */ jsx294("path", {
          d: "M119.8 324v8.6h14.4l-14.4-9.5zm0-22v-9h14.4l-14.4 9.4Zm62.8 22v8.6h-14.4l14.4-9.5zm0-22v-9h-14.4l14.4 9.4z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#d22630",
          d: "m120.2 324.3 12.9 8.3h-12.9zm0-22.7 12.9-8.3h-12.9zm62 22.7-12.8 8.3h12.8zm0-22.7-12.8-8.3h12.8z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs269("g", {
      fill: "#383739",
      children: [
        /* @__PURE__ */ jsx294("path", {
          d: "M138 310.3v-4.2h-1.5l-7.6-4.5-7.6 4.5h-1.5v4.6h-3.7v5.3h3.7v4.5h1.5l7.6 4.5 7.6-4.5h1.5V316h5.3v-6Z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#d22630",
          d: "m128.5 301.6 7.6 4.2h-14.4zm7.6 18.5-7.6 4.2-6.8-4.2zm-1.9-9.4v4.5h-8.7v-4.5z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#ffc72c",
          d: "M137.6 315.6v4.1h-8.7v-4.1zm-9 0v4.1h-8.8v-4.1zm14.3-5v4.6h-8.3v-4.5zm-17.8 0v4.6h-8.7v-4.5Zm12.5-4.5v4.2h-8.7v-3.8zm-9 0v4.2h-8.8v-3.8z"
        }),
        /* @__PURE__ */ jsx294("path", {
          d: "M122.9 311.8v2.3H119v-2.3zm3.4-4.5v2.2h-3.8v-2.2zm9 0v2.2h-3.7v-2.2zm-3.7 4.5v2.3h-3.8v-2.3zm9 0v2.3h-3.8v-2.3zm-5.3 4.5v2.3h-3.7v-2.3zm-9 0v2.3h-3.8v-2.3z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#fff",
          d: "M122.5 312.2H119v1.5h3.4zm3.8-4.5h-3.8v1.5h3.8zm8.7 0h-3.4v1.5h3.4zm-3.8 4.5h-2.7v1.5h3zm9 0h-3v1.5h3zm-5.2 4.5h-3.4v1.5h3.4zm-9.1 0h-3v1.5h3z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs269("g", {
      fill: "#383739",
      children: [
        /* @__PURE__ */ jsx294("path", {
          d: "M164.4 310.3v-4.2h1.6l7.5-4.5 7.6 4.5h1.9v4.6h3.4v5.3h-3.8v4.5h-1.1l-7.6 4.5-7.6-4.5h-1.5V316h-5.3v-6Z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#d22630",
          d: "m173.9 301.6-7.6 4.2h14zm-7.6 18.5 6.8 4.2 7.2-4.2zm1.5-9.4v4.5h8.7v-4.5z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#ffc72c",
          d: "M164.8 315.6v4.1h8.7v-4.1zm9 0v4.1h8.8v-4.1zm-14.3-5v4.6h8.7v-4.5zm17.8 0v4.6h8.7v-4.5Zm-12.5-4.5v4.2h8.7v-3.8zm9 0v4.2h8.8v-3.8z"
        }),
        /* @__PURE__ */ jsx294("path", {
          d: "M180 311.8v2.3h3.7v-2.3zm-3.8-4.5v2.2h3.7v-2.2zm-9.1 0v2.2h3.8v-2.2zm3.8 4.5v2.3h3.7v-2.3zm-9.1 0v2.3h3.8v-2.3zm5.3 4.5v2.3h3.8v-2.3zm9 0v2.3h3.8v-2.3z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#fff",
          d: "M180 312.2h3.3v1.5H180zm-3.5-4.5h3v1.5h-3zm-9 0h3.4v1.5h-3.4zm3.7 4.5h3v1.5h-3zm-9 0h3v1.5h-2.6Zm5.3 4.5h3.4v1.5h-3.4zm9 0h3v1.5h-3z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs269("g", {
      fill: "#383739",
      children: [
        /* @__PURE__ */ jsx294("path", {
          d: "M160.3 302.7v4.6h-1.5l-7.6 4.9-7.5-5H142v-4.5h-4.5v-4.9h4.5v-4.5h1.6l7.5-5 7.6 5h1.5v4.5h4.5v4.6Z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#ffc72c",
          d: "m151.2 311.8 6.8-4.5h-13.6zM158 293l-6.8-3.8-6.8 3.8z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#d22630",
          d: "M160 297.8v-4.5h-8.4v4.5zm-8.8 0v-4.5h-8.7v4.5zm13.2 4.6v-3.8h-8.7v3.8zm-9 0v-3.8h-8v3.8zm-8.7 0v-3.8H138v3.8zm13.2 4.5v-4.2h-8.3v4.2zm-8.7 0v-4.2h-8.7v4.2z"
        }),
        /* @__PURE__ */ jsx294("path", {
          d: "M148.6 294.4v2.3h-3.8v-1.9Zm9 0v2.3H154v-1.9ZM144 299v2.6h-3.8v-3Zm9.1 0v2.6h-3.8v-3Zm9 0v2.6h-3.7v-3Zm-13.5 4.9v2.2h-3.8V304zm9 0v2.2H154V304z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#fff",
          d: "M148.2 294.8h-3v1.5h3zm9 0h-3v1.5h3zm-13.5 4.5h-3v2h3Zm9 0h-3v2h3zm9.1 0h-3v2h3zm-13.6 4.6h-3v1.9h3zm9 0h-3v1.9h3z"
        })
      ]
    }),
    /* @__PURE__ */ jsxs269("g", {
      fill: "#383739",
      children: [
        /* @__PURE__ */ jsx294("path", {
          d: "M160.3 328v5h-1.5l-7.6 4.5-7.5-4.5H142v-5h-4.5v-4.9h4.5v-4.5h1.6l7.5-4.9 7.6 5h1.5v4.4h4.5v5z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#ffc72c",
          d: "m151.2 337.1 6.8-4.1h-13.6zm6.8-18.9-6.8-3.7-6.8 3.7z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#d22630",
          d: "M160 323.1V319h-8.4v4.1zm-8.8 0V319h-8.7v4.1zm13.2 4.6v-4.2h-8.7v4.2zm-9 0v-4.2h-8v4.2zm-8.7 0v-4.2H138v4.2zm13.2 4.9v-4.5h-8.3v4.5Zm-8.7 0v-4.5h-8.7v4.5Z"
        }),
        /* @__PURE__ */ jsx294("path", {
          d: "M148.6 319.7v2.7h-3.8v-2.7zm9 0v2.7H154v-2.7ZM144 325v2.3h-3.8V325Zm9.1 0v2.3h-3.8V325Zm9 0v2.3h-3.7V325Zm-13.5 3.8v2.3h-3.8v-2.3Zm9 0v2.3H154v-2.3Z"
        }),
        /* @__PURE__ */ jsx294("path", {
          fill: "#fff",
          d: "M148.2 320.1h-3v2h3zm9 0h-3v2h3zm-13.5 5h-3v1.5h3Zm9 0h-3v1.5h3zm9.1 0h-3v1.5h3zm-13.6 4.5h-3v1.5h3zm9 0h-3v1.5h3z"
        })
      ]
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#383739",
      d: "m102 383.6 34-18.1h30.3l34 18.1v29.9l-34 17.7h-30.2l-34-17.7z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#00843d",
      d: "m136 365.9-33.6 17.7v29.5l33.7 18.1h30.2l33.7-18.1v-29.5L166.7 366zm.5 2.2h29.8l31.8 17v26.5l-31.8 17h-29.5l-31.7-17V385z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#ffc72c",
      d: "M151.2 398.4v30.2h15.1l31.4-17v-12.9h-46.5v-30.2h-15.1l-31.4 16.6v13.3z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#fff",
      d: "M151.2 398.4v30.2h-15.1l-31.4-17v-12.9h46.5v-30.2h15.1l31.4 16.6v13.3z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#383739",
      d: "M153.9 426.7V418l-2.7 2-2.6-2v8.7h-9.1l6-4.5v-6l-9-5.7h-6v-24.2h5.6l9-5.7v-6L140 370h9v8.7l2.7-1.5 2.6 1.5v-8.3h9.1l-6 4.5v6l9 5.7h6.5v24.2h-6.5l-9 5.7v6l6 4.6z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#ffc72c",
      d: "M154.2 370.4v9l-3-1.8v2.6l14 8.7h4.5v9.5h2.3V387h-6l-9.5-6v-6.8l5.3-3.8zm-23.4 28.3v11.4h5.3l9.4 6v6.5l-5.3 3.7h7.6v-9l3 1.8v-2.6l-14-8.7h-4.5v-9z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#fff",
      d: "m140.6 370.4 5.3 3.8v6.8l-9.4 5.6h-5.7V398h1.9v-8.7h4.5l14-8.7V378l-3 1.8v-9.4zm29.1 28.3v9.1h-4.5l-14 8.7v2.6l3-1.8v9h7.6l-5.3-3.7v-6.9l9.5-6h6v-11.3Z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#d22630",
      d: "M133 407.4h4.2l14 9.1 14-9h4.2v-18.2h-4.2l-14-8.7-14 8.7h-3.8z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#383739",
      d: "M160.7 402.9h3v-1.5h-2.3v-2.7h5v6.5h-4.6v4.5h-9.5v-6.4h4.2v2.6H155v1.2h3.8v-2.3l-17.4-10.6h-3v1.1h2.2v2.7h-4.5v-6.4h4.5V387h9.5v6.4h-3.8v-2.6h1.1v-1.1h-3.7v2.2zm-1.6-11v-2.2H155v1.1h1.5v2.6h-4.2V387h9.5v4.6h4.5v6.4h-4.9v-2.7h2.3v-1.1h-3l-17 10.2v2.3h3.7v-1.2H146V403h4.2v6.4h-9.5v-4.5h-4.5v-6.4h4.9v2.6h-2.3v1.5h3z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#fff",
      d: "M159.5 404.4v3H155v-1.9h1.5v-1.8h-3.4v5.6h8.7v-4.5h4.5V399h-3.7v2h1.8v2.2H161l-17.7-11.4v-2.6h4.9v1.9h-1.5v1.9h3.8v-5.7h-9.1v4.5h-4.6v5.7h3.8v-1.9h-1.9v-1.9h3.4zm1.2-10.6h3.7v2h-2.6v1.8h4.5V392h-4.5v-4.5h-8.7v5.7h3.4v-2H155v-1.8h5v3l-17.9 11h-3.4V401h2.3v-1.9h-3.8v5.7h4.2v4.5h8.7v-5.6h-3.4v1.8h1.5v2h-5v-3z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#383739",
      d: "M190.5 399.9v9.4h-3.8V406h-4.1v3.4h-4.2V400h3.8v3.4h4.2V400zm-14.3 12.4v9.5h-3.8v-3.4h-4.2v3.4h-3.8v-9.5h3.8v3.4h3.8v-3.4zm14.3-15v-9.9h-3.8v3.4h-4.1v-3.4h-4.2v9.5h3.8v-3.5h4.2v3.8zm-78.6 2.6v9.4h3.8V406h4.1v3.4h4.2V400h-3.8v3.4h-4.1V400zm0-3v-9.5h3.8v3.4h4.1v-3.4h4.2v9.5h-3.8v-3.5h-4.1v3.8zm64.3-12.5v-9.5h-3.8v3.4h-4.2V375h-3.8v9.5h3.8V381h3.8v3.8zm-50 28v9.4h3.8v-3.4h4.2v3.4h4.2v-9.5h-3.8v3.4h-4.2v-3.4zm0-28v-9.5h3.8v3.4h4.2V375h4.2v9.5h-3.8V381h-4.2v3.8zm52.2-6.4v7.1h13.3zM124 419v-7.5h-13.2zm0-41.5v7.5h-13.2zm54.4 41.5v-7.5h13.3z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#d22630",
      d: "M186.7 405.5v3.8h3.4v-9h-3.4v3.4h-4.5v-3.4h-3.8v8.6h3.8v-3.4zM172.4 418v3.8h3.4v-9h-3.4v3.3h-4.6v-3.4h-3.4v8.7h3.4V418zm14.3-26.8v-3.4h3.4v8.7h-3.4V393h-4.5v3.8h-3.8v-9.1h3.8v3.4zm-71 14.3v3.8h-3.4v-9h3.4v3.4h4.5v-3.4h3.8v8.6h-3.8v-3.4zm0-14.3v-3.4h-3.4v8.7h3.4V393h4.5v3.8h3.8v-9.1h-3.8v3.4zm56.7-12.5v-3.4h3.4v8.7h-3.4v-3.4h-4.6v3.8h-3.4v-9h3.4v3.3zM130 418v3.8h-3.4v-9h3.4v3.3h4.6v-3.4h3.8v8.7h-3.8V418zm0-39.3v-3.4h-3.4v8.7h3.4v-3.4h4.6v3.8h3.8v-9h-3.8v3.3z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#ffc72c",
      d: "M178.8 378.3v6.5h11.3zm-66.9 34 11.3 6v-6z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#fff",
      d: "m123.6 378.3-11.3 6.5h11.3zm55.2 34v6l11.3-6z"
    }),
    /* @__PURE__ */ jsx294("path", {
      fill: "#ffc72c",
      d: "M205.6 424.8c-.7 2.7-3 4.6-3.4 7.6-1-3-1.8-5.7-1-8.7 0-2.3 2.2-3.8 2.6-6.4 1.8 1.8 2.2 4.5 1.8 7.5m.4 11.4a17.8 17.8 0 0 1-6.8 5.6c.4-2.2-.7-3.8-1.9-5.6-1.1-2-1.9-3.8-.7-6.5a14.4 14.4 0 0 0 1.9 3.4c1.1 1.5 2.2 3 2.2 5.3 1.5-1.1 2-2.6 2.7-4.1a12.9 12.9 0 0 1 5.3-5.3c-.8 2.6-1.2 4.9-2.7 7.2m-9.8 7.5.4 3.8 4.1-3c2-2 4.2-2.7 5.7-5a9.5 9.4 0 0 1-3.8 7.2l-7.5 5c0-2.7-.8-5-2-7.6a6.8 6.8 0 0 1 2-6c0 1.8.3 3.7 1.1 5.2zm-5.7 8.7-3 5.3c2.6-.8 5-2.3 7.6-3.8 2.6-1.5 5.6-2.2 8.3-4.5-1.2 4.9-4.6 7.5-9 9-3.1.8-6.1.4-10 2a26.5 26.5 0 0 1 2.7-7.6l2.7-5.3c.7 1.5 1.1 3 .7 5zm-9.8 7.2a12.1 12 0 0 1-3.8 3.8c3.8 0 6.8-2 10.6-2.3 2.3 0 4.5.8 6.8.4-2.6 1.9-5.7 3.8-9 3.8-4.2.7-8.4 0-13 0 2.3-1.6 3.5-3.8 4.6-5.7 2-3 3.8-5 7.2-5.3-1.5 1.5-2.3 3.8-3.4 5.3m-13.2 6c6.4 1.2 12.8 2.7 19.6 2.7a30.3 30.3 0 0 1-22.3.4c-3.8-1.2-7.2-2.3-10.2-2-4.1 0-9.8 2.3-15.9 8.4l-2.2-1.9c8.7-7.6 20-9.5 31-7.6"
    })
  ]
});
var Tm_default = SvgTm;

// src/country-flag-icons/generated/Tn.tsx
init_esm_shims();
import { jsx as jsx295, jsxs as jsxs270 } from "react/jsx-runtime";
var SvgTn = (props) => /* @__PURE__ */ jsxs270("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx295("path", {
      fill: "#e70013",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx295("path", {
      fill: "#fff",
      d: "M320 119.2a1 1 0 0 0-1 240.3 1 1 0 0 0 1-240.3M392 293a90 90 0 1 1 0-107 72 72 0 1 0 0 107m-4.7-21.7-37.4-12.1-23.1 31.8v-39.3l-37.4-12.2 37.4-12.2V188l23.1 31.8 37.4-12.1-23.1 31.8z"
    })
  ]
});
var Tn_default = SvgTn;

// src/country-flag-icons/generated/To.tsx
init_esm_shims();
import { jsx as jsx296, jsxs as jsxs271 } from "react/jsx-runtime";
var SvgTo = (props) => /* @__PURE__ */ jsx296("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs271("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    children: [
      /* @__PURE__ */ jsx296("path", {
        fill: "#c10000",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsx296("path", {
        fill: "#fff",
        d: "M0 0h250v200.3H0z"
      }),
      /* @__PURE__ */ jsxs271("g", {
        fill: "#c10000",
        children: [
          /* @__PURE__ */ jsx296("path", {
            d: "M102.8 31.2h39.9v139.6h-39.8z"
          }),
          /* @__PURE__ */ jsx296("path", {
            d: "M192.6 81v40H53V81z"
          })
        ]
      })
    ]
  })
});
var To_default = SvgTo;

// src/country-flag-icons/generated/Tr.tsx
init_esm_shims();
import { jsx as jsx297, jsxs as jsxs272 } from "react/jsx-runtime";
var SvgTr = (props) => /* @__PURE__ */ jsx297("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs272("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx297("path", {
        fill: "#e30a17",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsx297("path", {
        fill: "#fff",
        d: "M407 247.5c0 66.2-54.6 119.9-122 119.9s-122-53.7-122-120 54.6-119.8 122-119.8 122 53.7 122 119.9"
      }),
      /* @__PURE__ */ jsx297("path", {
        fill: "#e30a17",
        d: "M413 247.5c0 53-43.6 95.9-97.5 95.9s-97.6-43-97.6-96 43.7-95.8 97.6-95.8 97.6 42.9 97.6 95.9z"
      }),
      /* @__PURE__ */ jsx297("path", {
        fill: "#fff",
        d: "m430.7 191.5-1 44.3-41.3 11.2 40.8 14.5-1 40.7 26.5-31.8 40.2 14-23.2-34.1 28.3-33.9-43.5 12-25.8-37z"
      })
    ]
  })
});
var Tr_default = SvgTr;

// src/country-flag-icons/generated/Tt.tsx
init_esm_shims();
import { jsx as jsx298, jsxs as jsxs273 } from "react/jsx-runtime";
var SvgTt = (props) => /* @__PURE__ */ jsxs273("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx298("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx298("path", {
      fill: "#e00000",
      fillRule: "evenodd",
      d: "M463.7 480 0 1v478.8zM176.3 0 640 479V.2z"
    }),
    /* @__PURE__ */ jsx298("path", {
      fill: "#000001",
      fillRule: "evenodd",
      d: "M27.7.2h118.6l468.2 479.3H492.2z"
    })
  ]
});
var Tt_default = SvgTt;

// src/country-flag-icons/generated/Tv.tsx
init_esm_shims();
import { jsx as jsx299, jsxs as jsxs274 } from "react/jsx-runtime";
var SvgTv = (props) => /* @__PURE__ */ jsxs274("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx299("path", {
      fill: "#009fca",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx299("path", {
      fill: "#fff40d",
      fillRule: "evenodd",
      d: "M593.3 122.7H621l-22.3 15.2 8.5 24.7-22.3-15.3-22.2 15.3 8.5-24.7-22.3-15.2h27.5l8.5-24.7zm-69.2 196.8h27.6l-22.3 15.2 8.5 24.7-22.3-15.3-22.3 15.3 8.6-24.7-22.3-15.2H507l8.5-24.7zm69.2-44.6H621l-22.3 15.2 8.5 24.7-22.3-15.3-22.2 15.3 8.5-24.7-22.3-15.2h27.5l8.5-24.7zM295.8 417.7h27.6L301 432.8l8.6 24.6-22.3-15.2-22.3 15.2 8.6-24.6-22.4-15.3h27.6l8.5-24.6zm62.6-76.5h-27.6l22.3-15.3-8.5-24.6 22.3 15.2 22.3-15.2-8.6 24.6 22.3 15.3h-27.5l-8.5 24.6zm81.3-112.5H412l22.3-15.2-8.5-24.7 22.3 15.3 22.3-15.3-8.6 24.7 22.3 15.2h-27.5l-8.5 24.7zm68.3-23.3h-27.6l22.4-15.3-8.6-24.6 22.3 15.2 22.3-15.2-8.6 24.6 22.4 15.3H525l-8.5 24.6zM439.7 400H412l22.3-15.2L426 360l22.3 15.2 22.3-15.2-8.6 24.7 22.3 15.2h-27.5l-8.5 24.7zm-81.3 19.9h-27.6l22.3-15.2-8.5-24.7 22.3 15.2 22.3-15.2-8.6 24.6L403 420h-27.5l-8.5 24.7z"
    }),
    /* @__PURE__ */ jsx299("path", {
      fill: "#012169",
      d: "M0 0h320v240H0z"
    }),
    /* @__PURE__ */ jsx299("path", {
      fill: "#FFF",
      d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0z"
    }),
    /* @__PURE__ */ jsx299("path", {
      fill: "#C8102E",
      d: "M212 140.5 320 220v20l-135.5-99.5zm-92 10 3 17.5-96 72H0zM320 0v1.5l-124.5 94 1-22L295 0zM0 0l119.5 88h-30L0 21z"
    }),
    /* @__PURE__ */ jsx299("path", {
      fill: "#FFF",
      d: "M120.5 0v240h80V0zM0 80v80h320V80z"
    }),
    /* @__PURE__ */ jsx299("path", {
      fill: "#C8102E",
      d: "M0 96.5v48h320v-48zM136.5 0v240h48V0z"
    })
  ]
});
var Tv_default = SvgTv;

// src/country-flag-icons/generated/Tw.tsx
init_esm_shims();
import { jsx as jsx300, jsxs as jsxs275 } from "react/jsx-runtime";
var SvgTw = (props) => /* @__PURE__ */ jsxs275("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx300("clipPath", {
      id: "tw_svg__a",
      children: /* @__PURE__ */ jsx300("path", {
        d: "M0 0h640v480H0z"
      })
    }),
    /* @__PURE__ */ jsxs275("g", {
      clipPath: "url(#tw_svg__a)",
      children: [
        /* @__PURE__ */ jsx300("path", {
          fill: "red",
          d: "M0 0h720v480H0z"
        }),
        /* @__PURE__ */ jsx300("path", {
          fill: "#000095",
          d: "M0 0h360v240H0z"
        }),
        /* @__PURE__ */ jsxs275("g", {
          fill: "#fff",
          children: [
            /* @__PURE__ */ jsx300("path", {
              d: "m154 126.9-2.5 9.6 9.4 2.6-1.8-7.1zm46.9 5.1-1.8 7.1 9.4-2.6-2.5-9.6zm-41.8-24-5.1 5.1 1.9 6.9z"
            }),
            /* @__PURE__ */ jsx300("path", {
              d: "m155.9 120-1.9 6.9 5.1 5.1z"
            }),
            /* @__PURE__ */ jsx300("path", {
              d: "m154 113.1-6.9 6.9 6.9 6.9 1.9-6.9zm14 27.8 5.1 5.1 6.9-1.9zm18.9 5.1 9.6 2.5 2.6-9.4-7.1 1.8z"
            }),
            /* @__PURE__ */ jsx300("path", {
              d: "m192 140.9 7.1-1.8 1.8-7.1zm-31.1-1.8 2.6 9.4 9.6-2.5-5.1-5.1zm19.1 5 6.9 1.9 5.1-5.1z"
            }),
            /* @__PURE__ */ jsx300("path", {
              d: "m173.1 146 6.9 6.9 6.9-6.9-6.9-1.9zm-12.2-45.1-9.4 2.6 2.5 9.6 5.1-5.1zm-1.8 31.1 1.8 7.1 7.1 1.8zm45-12 1.9-6.9-5.1-5.1z"
            }),
            /* @__PURE__ */ jsx300("path", {
              d: "m168 99.1-7.1 1.8-1.8 7.1zm32.9 8.9-1.8-7.1-7.1-1.8zm5.1 18.9 6.9-6.9-6.9-6.9-1.9 6.9z"
            }),
            /* @__PURE__ */ jsx300("path", {
              d: "m200.9 108-8.9-8.9-12-3.2-12 3.2-8.9 8.9-3.2 12 3.2 12 8.9 8.9 12 3.2 12-3.2 8.9-8.9 3.2-12z"
            }),
            /* @__PURE__ */ jsx300("path", {
              d: "m200.9 132 5.1-5.1-1.9-6.9zm5.1-18.9 2.5-9.6-9.4-2.6 1.8 7.1zm-6.9-12.2-2.6-9.4-9.6 2.5 5.1 5.1zm-26-6.9-9.6-2.5-2.6 9.4 7.1-1.8zm6.9 1.9-6.9-1.9-5.1 5.1z"
            }),
            /* @__PURE__ */ jsx300("path", {
              d: "m186.9 94-6.9-6.9-6.9 6.9 6.9 1.9z"
            }),
            /* @__PURE__ */ jsx300("path", {
              d: "m192 99.1-5.1-5.1-6.9 1.9zM173.1 146l-9.6 2.5 4.5 16.6 12-12.2zm-5.1 19.1 12 44.9 12-44.9-12-12.2zm-7.1-26-9.4-2.6-4.4 16.4 16.4-4.4z"
            }),
            /* @__PURE__ */ jsx300("path", {
              d: "m147.1 152.9-12 45.1 32.9-32.9-4.5-16.6zm-12-20.9L102 165.1l45.1-12.2 4.4-16.4z"
            }),
            /* @__PURE__ */ jsx300("path", {
              d: "m154 126.9-6.9-6.9-12 12 16.4 4.5zm0-13.8-2.5-9.6-16.4 4.5 12 12z"
            }),
            /* @__PURE__ */ jsx300("path", {
              d: "M135.1 108 90 120l45.1 12 12-12zm90 24-16.6 4.5 4.4 16.4 45.1 12.2z"
            }),
            /* @__PURE__ */ jsx300("path", {
              d: "m199.1 139.1-2.6 9.4 16.4 4.4-4.4-16.4zm-12.2 6.9-6.9 6.9 12 12.2 4.5-16.6zm19.1-19.1 2.5 9.6 16.6-4.5-12.2-12z"
            }),
            /* @__PURE__ */ jsx300("path", {
              d: "m192 165.1 33.1 32.9-12.2-45.1-16.4-4.4zm7.1-64.2 9.4 2.6 4.4-16.4-16.4 4.4z"
            }),
            /* @__PURE__ */ jsx300("path", {
              d: "M225.1 108 258 75.1l-45.1 12-4.4 16.4zm-12.2-20.9L225.1 42 192 75.1l4.5 16.4zm12.2 44.9 44.9-12-44.9-12-12.2 12z"
            }),
            /* @__PURE__ */ jsx300("path", {
              d: "m206 113.1 6.9 6.9 12.2-12-16.6-4.5zm-38-38L135.1 42l12 45.1 16.4 4.4z"
            }),
            /* @__PURE__ */ jsx300("path", {
              d: "m160.9 100.9 2.6-9.4-16.4-4.4 4.4 16.4z"
            }),
            /* @__PURE__ */ jsx300("path", {
              d: "m147.1 87.1-45.1-12 33.1 32.9 16.4-4.5zm39.8 6.9 9.6-2.5-4.5-16.4-12 12z"
            }),
            /* @__PURE__ */ jsx300("path", {
              d: "M192 75.1 180 30l-12 45.1 12 12z"
            }),
            /* @__PURE__ */ jsx300("path", {
              d: "m173.1 94 6.9-6.9-12-12-4.5 16.4z"
            })
          ]
        }),
        /* @__PURE__ */ jsx300("circle", {
          cx: 180,
          cy: 120,
          r: 51.1,
          fill: "#000095"
        }),
        /* @__PURE__ */ jsx300("circle", {
          cx: 180,
          cy: 120,
          r: 45.1,
          fill: "#fff"
        })
      ]
    })
  ]
});
var Tw_default = SvgTw;

// src/country-flag-icons/generated/Tz.tsx
init_esm_shims();
import { jsx as jsx301, jsxs as jsxs276 } from "react/jsx-runtime";
var SvgTz = (props) => /* @__PURE__ */ jsxs276("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx301("defs", {
      children: /* @__PURE__ */ jsx301("clipPath", {
        id: "tz_svg__a",
        children: /* @__PURE__ */ jsx301("path", {
          fillOpacity: 0.7,
          d: "M10 0h160v120H10z"
        })
      })
    }),
    /* @__PURE__ */ jsxs276("g", {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      clipPath: "url(#tz_svg__a)",
      transform: "matrix(4 0 0 4 -40 0)",
      children: [
        /* @__PURE__ */ jsx301("path", {
          fill: "#09f",
          d: "M0 0h180v120H0z"
        }),
        /* @__PURE__ */ jsx301("path", {
          fill: "#090",
          d: "M0 0h180L0 120z"
        }),
        /* @__PURE__ */ jsx301("path", {
          fill: "#000001",
          d: "M0 120h40l140-95V0h-40L0 95z"
        }),
        /* @__PURE__ */ jsx301("path", {
          fill: "#ff0",
          d: "M0 91.5 137.2 0h13.5L0 100.5zM29.3 120 180 19.5v9L42.8 120z"
        })
      ]
    })
  ]
});
var Tz_default = SvgTz;

// src/country-flag-icons/generated/Ua.tsx
init_esm_shims();
import { jsx as jsx302, jsxs as jsxs277 } from "react/jsx-runtime";
var SvgUa = (props) => /* @__PURE__ */ jsx302("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs277("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    children: [
      /* @__PURE__ */ jsx302("path", {
        fill: "gold",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsx302("path", {
        fill: "#0057b8",
        d: "M0 0h640v240H0z"
      })
    ]
  })
});
var Ua_default = SvgUa;

// src/country-flag-icons/generated/Ug.tsx
init_esm_shims();
import { jsx as jsx303, jsxs as jsxs278 } from "react/jsx-runtime";
var SvgUg = (props) => /* @__PURE__ */ jsxs278("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx303("defs", {
      children: /* @__PURE__ */ jsx303("clipPath", {
        id: "ug_svg__a",
        children: /* @__PURE__ */ jsx303("path", {
          fillOpacity: 0.7,
          d: "M-85.3 0h682.6v512H-85.3z"
        })
      })
    }),
    /* @__PURE__ */ jsxs278("g", {
      clipPath: "url(#ug_svg__a)",
      transform: "translate(80) scale(.9375)",
      children: [
        /* @__PURE__ */ jsx303("path", {
          fill: "#ffe700",
          fillRule: "evenodd",
          d: "M-128 341.4h768v85.3h-768z"
        }),
        /* @__PURE__ */ jsx303("path", {
          fill: "#000001",
          fillRule: "evenodd",
          d: "M-128 256h768v85.3h-768z"
        }),
        /* @__PURE__ */ jsx303("path", {
          fill: "#de3908",
          fillRule: "evenodd",
          d: "M-128 170.7h768V256h-768z"
        }),
        /* @__PURE__ */ jsx303("path", {
          fill: "#ffe700",
          fillRule: "evenodd",
          d: "M-128 85.4h768v85.3h-768z"
        }),
        /* @__PURE__ */ jsx303("path", {
          fill: "#000001",
          fillRule: "evenodd",
          d: "M-128 0h768v85.3h-768z"
        }),
        /* @__PURE__ */ jsx303("path", {
          fill: "#fffdff",
          fillRule: "evenodd",
          stroke: "#000",
          d: "M335.7 256a79.7 79.7 0 1 1-159.4 0 79.7 79.7 0 0 1 159.4 0z"
        }),
        /* @__PURE__ */ jsx303("path", {
          fill: "#de3108",
          fillRule: "evenodd",
          stroke: "#000",
          d: "m242 194.9-5.2-9.5c2-2 5.3-3.6 10.7-3.6l-.6 10.5z"
        }),
        /* @__PURE__ */ jsx303("path", {
          fill: "#ffe700",
          fillRule: "evenodd",
          stroke: "#000",
          d: "m247 192.3.7-10.5s10.7-.6 16.5 6.4l-5.7 8.2z"
        }),
        /* @__PURE__ */ jsx303("path", {
          fill: "#de3108",
          fillRule: "evenodd",
          stroke: "#000",
          d: "m258.6 196.3 5.3-8.2c3.5 3.7 5 6.3 5.5 10.3.1.1-8.3 2.1-8.3 2z"
        }),
        /* @__PURE__ */ jsx303("path", {
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0.9,
          d: "M244.6 331.1s9.9-11.3 29.1-8.9c-2.9-4.7-12.3-4.1-12.3-4.1s-2.8-22-.6-23.2 12 .1 12 .1c1.2 0 3.4-3.4 1.6-5.6-1.7-2.2-6.8-10.5-4.7-12.2 2.1-1.6 13.4 1 13.4 1l-32-41s-3.3-15.5 3.3-23c7.9-6.5 7-13.6 6.8-13.5-1.1-7.2-12-12.3-19.4-5.7-4.3 5.2-1.4 9.2-1.4 9.2s-11.5 3.1-11.9 5.1c-.5 2 12.9-.3 12.9-.3l-1.3 9.1s-26 23.6-6 44l.6-.8s7 8.6 14.3 10.5c7 7 6.3 6 6.3 6s1.3 11.1 0 13.3c-1.7-.5-19.3-1.2-21.9-.2-2.4.8-11.4.3-9.2 15.1l3.3-7.5s-.3 5.3 1.9 7.2c-.4-5.6 2.1-9.4 2.1-9.4s.4 6.2 1.8 7c1.4 1 1.4-10 9-9 7.4.9 12.9.6 12.9.6s2.5 21.4 1.7 23.4c-5.4-1.3-18.4.5-19.2 3.8 7.6-.5 11.1.4 11.1.4s-6.1 5.5-4.2 8.6"
        }),
        /* @__PURE__ */ jsx303("path", {
          fill: "#9ca69c",
          fillRule: "evenodd",
          stroke: "#9ca69c",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0.9,
          d: "M247.6 214.8s-18.9 20.8-10.7 36.7c.4-2.2.2-3.6.5-3.5-.5-.3 2.3 1.9 2.1 1.5 0-1.2-.8-3.7-.8-3.7l2.5.7-1.5-2.8 3.7.4s-1.3-3.4-.9-3.4l3 .2c-5.4-9.6-.3-17.6 2.1-26.2z"
        }),
        /* @__PURE__ */ jsx303("path", {
          fill: "#9ca69c",
          fillRule: "evenodd",
          stroke: "#9ca69c",
          d: "M254.2 196.9s1 7.2-3 9.2c-.5.5-3 1.3-2.6 2.8.4 2 1.5 1.6 3 1.2 4.1-.7 8.9-9.4 2.6-13.2z"
        }),
        /* @__PURE__ */ jsx303("path", {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M247.2 203a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
        }),
        /* @__PURE__ */ jsx303("path", {
          fill: "#de3108",
          fillRule: "evenodd",
          stroke: "#000",
          d: "M241.1 209c-1 .9-6.2 6.3-1 8.3 5.3-1.4 3.8-2.4 5-3.6 0-2.5-2.6-3.1-4-4.6z"
        }),
        /* @__PURE__ */ jsx303("path", {
          fill: "#9ca69c",
          fillRule: "evenodd",
          stroke: "#9ca69c",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0.9,
          d: "M252.6 260.5c-.3 1.2-1.5 5.6.1 9 4.6-2 6.7-1.4 8.2-.4-3.7-3-5.2-4.3-8.3-8.6"
        }),
        /* @__PURE__ */ jsx303("path", {
          fill: "#fff",
          fillRule: "evenodd",
          stroke: "#fff",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0.9,
          d: "m260.4 281.1.2 10.2s3.6.6 5.2 0 0-7-5.4-10.2"
        }),
        /* @__PURE__ */ jsx303("path", {
          fill: "#9ca69c",
          fillRule: "evenodd",
          stroke: "#000",
          d: "M286 282.4s-6.5-15.8-23.2-19.8-14.5-21.8-13.2-22.9c.8-1.5 1.3-3.9 6.1-1.6s27 13.4 30.2 14 .4 30.7.2 30.3z"
        }),
        /* @__PURE__ */ jsx303("path", {
          fill: "#de3108",
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinejoin: "round",
          strokeWidth: 0.9,
          d: "M270.2 262.5c-.3.2 22.3 13.4 15.5 24.7 6.4-4.3 4.4-11.7 4.4-11.7s5.2 13.7-7.6 20.4c1.4 1.2 2.3 1 2.3 1l-2.2 2.1s-1 1.7 7.6-2.5c-2.3 1.9-2.5 3.3-2.5 3.3s.6 1.8 6.2-3.1c-4.5 4.9-5.5 7.4-5.5 7.3 12.3-1 39-41-8.4-52.7l2.1 2.2z"
        }),
        /* @__PURE__ */ jsx303("path", {
          fill: "#fff",
          fillRule: "evenodd",
          stroke: "#000",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 0.9,
          d: "M271.2 258.6c3 2.2 4.1 3 4.5 4-2.8-.6-5.3-.4-5.3-.4s-6.1-5.8-7.2-6.3c-.8 0-5.6-3-5.6-3-2.3-1.2-4.5-9.3 4.2-7a93 93 0 0 0 10.3 4.6l10.7 3.4 6.2 6.9s-11-5.4-12.4-5.5c3 2.4 4.7 5.8 4.7 5.8-3.5-1-6.5-2-10.1-2.5"
        }),
        /* @__PURE__ */ jsx303("path", {
          fill: "none",
          stroke: "#fff",
          strokeLinecap: "round",
          strokeWidth: 0.9,
          d: "M228.4 209.9s10.5-2.6 11.8-2.2"
        }),
        /* @__PURE__ */ jsx303("path", {
          fill: "#de3908",
          fillRule: "evenodd",
          d: "M-128 426.7h768V512h-768z"
        })
      ]
    })
  ]
});
var Ug_default = SvgUg;

// src/country-flag-icons/generated/Um.tsx
init_esm_shims();
import { jsx as jsx304, jsxs as jsxs279 } from "react/jsx-runtime";
var SvgUm = (props) => /* @__PURE__ */ jsxs279("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx304("path", {
      fill: "#bd3d44",
      d: "M0 0h640v480H0"
    }),
    /* @__PURE__ */ jsx304("path", {
      stroke: "#fff",
      strokeWidth: 37,
      d: "M0 55.3h640M0 129h640M0 203h640M0 277h640M0 351h640M0 425h640"
    }),
    /* @__PURE__ */ jsx304("path", {
      fill: "#192f5d",
      d: "M0 0h364.8v258.5H0"
    }),
    /* @__PURE__ */ jsx304("marker", {
      id: "um_svg__a",
      markerHeight: 30,
      markerWidth: 30,
      children: /* @__PURE__ */ jsx304("path", {
        fill: "#fff",
        d: "m14 0 9 27L0 10h28L5 27z"
      })
    }),
    /* @__PURE__ */ jsx304("path", {
      fill: "none",
      markerMid: "url(#um_svg__a)",
      d: "m0 0 16 11h61 61 61 61 60L47 37h61 61 60 61L16 63h61 61 61 61 60L47 89h61 61 60 61L16 115h61 61 61 61 60L47 141h61 61 60 61L16 166h61 61 61 61 60L47 192h61 61 60 61L16 218h61 61 61 61 60z"
    })
  ]
});
var Um_default = SvgUm;

// src/country-flag-icons/generated/Us.tsx
init_esm_shims();
import { jsx as jsx305, jsxs as jsxs280 } from "react/jsx-runtime";
var SvgUs = (props) => /* @__PURE__ */ jsxs280("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx305("path", {
      fill: "#bd3d44",
      d: "M0 0h640v480H0"
    }),
    /* @__PURE__ */ jsx305("path", {
      stroke: "#fff",
      strokeWidth: 37,
      d: "M0 55.3h640M0 129h640M0 203h640M0 277h640M0 351h640M0 425h640"
    }),
    /* @__PURE__ */ jsx305("path", {
      fill: "#192f5d",
      d: "M0 0h364.8v258.5H0"
    }),
    /* @__PURE__ */ jsx305("marker", {
      id: "us_svg__a",
      markerHeight: 30,
      markerWidth: 30,
      children: /* @__PURE__ */ jsx305("path", {
        fill: "#fff",
        d: "m14 0 9 27L0 10h28L5 27z"
      })
    }),
    /* @__PURE__ */ jsx305("path", {
      fill: "none",
      markerMid: "url(#us_svg__a)",
      d: "m0 0 16 11h61 61 61 61 60L47 37h61 61 60 61L16 63h61 61 61 61 60L47 89h61 61 60 61L16 115h61 61 61 61 60L47 141h61 61 60 61L16 166h61 61 61 61 60L47 192h61 61 60 61L16 218h61 61 61 61 60z"
    })
  ]
});
var Us_default = SvgUs;

// src/country-flag-icons/generated/Uy.tsx
init_esm_shims();
import { jsx as jsx306, jsxs as jsxs281 } from "react/jsx-runtime";
var SvgUy = (props) => /* @__PURE__ */ jsxs281("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx306("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx306("path", {
      fill: "#0038a8",
      d: "M266 53.3h374v53.4H266zm0 106.7h374v53.3H266zM0 266.7h640V320H0zm0 106.6h640v53.4H0z"
    }),
    /* @__PURE__ */ jsxs281("g", {
      fill: "#fcd116",
      stroke: "#000",
      strokeMiterlimit: 20,
      strokeWidth: 0.6,
      transform: "translate(133.3 133.3) scale(2.93333)",
      children: [
        /* @__PURE__ */ jsxs281("g", {
          id: "uy_svg__c",
          children: [
            /* @__PURE__ */ jsxs281("g", {
              id: "uy_svg__b",
              children: [
                /* @__PURE__ */ jsxs281("g", {
                  id: "uy_svg__a",
                  children: [
                    /* @__PURE__ */ jsx306("path", {
                      strokeLinecap: "square",
                      d: "m-2 8.9 3 4.5c-12.4 9-4.9 14.2-13.6 17 5.4-5.2-.9-5.7 3.7-16.8"
                    }),
                    /* @__PURE__ */ jsx306("path", {
                      fill: "none",
                      d: "M-4.2 10.2c-6.8 11.2-2.4 17.4-8.4 20.3"
                    }),
                    /* @__PURE__ */ jsx306("path", {
                      d: "M0 0h6L0 33-6 0h6v33"
                    })
                  ]
                }),
                /* @__PURE__ */ jsx306("use", {
                  xlinkHref: "#uy_svg__a",
                  width: "100%",
                  height: "100%",
                  transform: "rotate(45)"
                })
              ]
            }),
            /* @__PURE__ */ jsx306("use", {
              xlinkHref: "#uy_svg__b",
              width: "100%",
              height: "100%",
              transform: "rotate(90)"
            })
          ]
        }),
        /* @__PURE__ */ jsx306("use", {
          xlinkHref: "#uy_svg__c",
          width: "100%",
          height: "100%",
          transform: "scale(-1)"
        }),
        /* @__PURE__ */ jsx306("circle", {
          r: 11
        })
      ]
    }),
    /* @__PURE__ */ jsxs281("g", {
      transform: "translate(133.3 133.3) scale(.29333)",
      children: [
        /* @__PURE__ */ jsxs281("g", {
          id: "uy_svg__d",
          children: [
            /* @__PURE__ */ jsx306("path", {
              d: "M81-44c-7 8-11-6-36-6S16-35 12-38s21-21 29-22 31 7 40 16m-29 9c7 6 1 19-6 19S26-28 32-36"
            }),
            /* @__PURE__ */ jsx306("path", {
              d: "M19-26c1-12 11-14 27-14s23 12 29 15c-7 0-13-10-29-10s-16 0-27 10m3 2c4-6 9 6 20 6s17-3 24-8-10 12-21 12-26-6-23-10"
            }),
            /* @__PURE__ */ jsx306("path", {
              d: "M56-17c13-7 5-17 0-19 2 2 10 12 0 19M0 43c6 0 8-2 16-2s27 11 38 7c-23 9-14 3-54 3h-5m63 6c-4-7-3-5-11-16 8 6 10 9 11 16M0 67c25 0 21-5 54-19-24 3-29 11-54 11h-5m5-29c7 0 9-5 17-5s19 3 24 7c1 1-3-8-11-9S25 9 16 7c0 4 3 3 4 9 0 5-9 5-11 0 2 8-4 8-9 8"
            })
          ]
        }),
        /* @__PURE__ */ jsx306("use", {
          xlinkHref: "#uy_svg__d",
          width: "100%",
          height: "100%",
          transform: "scale(-1 1)"
        }),
        /* @__PURE__ */ jsx306("path", {
          d: "M0 76c-5 0-18 3 0 3s5-3 0-3"
        })
      ]
    })
  ]
});
var Uy_default = SvgUy;

// src/country-flag-icons/generated/Uz.tsx
init_esm_shims();
import { jsx as jsx307, jsxs as jsxs282 } from "react/jsx-runtime";
var SvgUz = (props) => /* @__PURE__ */ jsxs282("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx307("path", {
      fill: "#1eb53a",
      d: "M0 320h640v160H0z"
    }),
    /* @__PURE__ */ jsx307("path", {
      fill: "#0099b5",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsx307("path", {
      fill: "#ce1126",
      d: "M0 153.6h640v172.8H0z"
    }),
    /* @__PURE__ */ jsx307("path", {
      fill: "#fff",
      d: "M0 163.2h640v153.6H0z"
    }),
    /* @__PURE__ */ jsx307("circle", {
      cx: 134.4,
      cy: 76.8,
      r: 57.6,
      fill: "#fff"
    }),
    /* @__PURE__ */ jsx307("circle", {
      cx: 153.6,
      cy: 76.8,
      r: 57.6,
      fill: "#0099b5"
    }),
    /* @__PURE__ */ jsxs282("g", {
      fill: "#fff",
      transform: "matrix(1.92 0 0 1.92 261.1 122.9)",
      children: [
        /* @__PURE__ */ jsxs282("g", {
          id: "uz_svg__e",
          children: [
            /* @__PURE__ */ jsxs282("g", {
              id: "uz_svg__d",
              children: [
                /* @__PURE__ */ jsxs282("g", {
                  id: "uz_svg__c",
                  children: [
                    /* @__PURE__ */ jsxs282("g", {
                      id: "uz_svg__b",
                      children: [
                        /* @__PURE__ */ jsx307("path", {
                          id: "uz_svg__a",
                          d: "M0-6-1.9-.3 1 .7"
                        }),
                        /* @__PURE__ */ jsx307("use", {
                          xlinkHref: "#uz_svg__a",
                          width: "100%",
                          height: "100%",
                          transform: "scale(-1 1)"
                        })
                      ]
                    }),
                    /* @__PURE__ */ jsx307("use", {
                      xlinkHref: "#uz_svg__b",
                      width: "100%",
                      height: "100%",
                      transform: "rotate(72)"
                    })
                  ]
                }),
                /* @__PURE__ */ jsx307("use", {
                  xlinkHref: "#uz_svg__b",
                  width: "100%",
                  height: "100%",
                  transform: "rotate(-72)"
                }),
                /* @__PURE__ */ jsx307("use", {
                  xlinkHref: "#uz_svg__c",
                  width: "100%",
                  height: "100%",
                  transform: "rotate(144)"
                })
              ]
            }),
            /* @__PURE__ */ jsx307("use", {
              xlinkHref: "#uz_svg__d",
              width: "100%",
              height: "100%",
              y: -24
            }),
            /* @__PURE__ */ jsx307("use", {
              xlinkHref: "#uz_svg__d",
              width: "100%",
              height: "100%",
              y: -48
            })
          ]
        }),
        /* @__PURE__ */ jsx307("use", {
          xlinkHref: "#uz_svg__e",
          width: "100%",
          height: "100%",
          x: 24
        }),
        /* @__PURE__ */ jsx307("use", {
          xlinkHref: "#uz_svg__e",
          width: "100%",
          height: "100%",
          x: 48
        }),
        /* @__PURE__ */ jsx307("use", {
          xlinkHref: "#uz_svg__d",
          width: "100%",
          height: "100%",
          x: -48
        }),
        /* @__PURE__ */ jsx307("use", {
          xlinkHref: "#uz_svg__d",
          width: "100%",
          height: "100%",
          x: -24
        }),
        /* @__PURE__ */ jsx307("use", {
          xlinkHref: "#uz_svg__d",
          width: "100%",
          height: "100%",
          x: -24,
          y: -24
        })
      ]
    })
  ]
});
var Uz_default = SvgUz;

// src/country-flag-icons/generated/Va.tsx
init_esm_shims();
import { jsx as jsx308, jsxs as jsxs283 } from "react/jsx-runtime";
var SvgVa = (props) => /* @__PURE__ */ jsxs283("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx308("path", {
      fill: "#fff",
      d: "M320 0h320v480H320z"
    }),
    /* @__PURE__ */ jsx308("path", {
      fill: "#ffe000",
      d: "M0 0h320v480H0z"
    }),
    /* @__PURE__ */ jsxs283("g", {
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 3.2,
      children: [
        /* @__PURE__ */ jsxs283("g", {
          fill: "#ce9d09",
          strokeLinecap: "round",
          transform: "translate(123) scale(.192)",
          children: [
            /* @__PURE__ */ jsxs283("g", {
              id: "va_svg__a",
              children: [
                /* @__PURE__ */ jsx308("path", {
                  fill: "#fff",
                  d: "m1781 990.3 16.2 3.8 25.6 4.2 11.8 1.3-2 50s-2.9 33-7.8 48.9c-3.6 11.7-15.7 33.2-15.7 33.2l-7.7 11.7-45.4-39.3s7.8-11 10.6-17c3.5-7.5 7.7-23.8 7.7-23.8l4.4-26 2.4-32.7zm-57 151.5 41.4 36s-8.4 7.4-13.4 9.7a73.6 73.6 0 0 1-31.6 7.3 58 58 0 0 1-22.3-6.2c-15.7-7.2-33-14.7-43.2-28.7-3.6-5-5-11.6-4.9-17.7.2-7 6.3-19.9 6.3-19.9s2.4 8.7 5.1 12a49.2 49.2 0 0 0 17.6 12.4 42.5 42.5 0 0 0 36.2 1.1c3.3-1.3 8.9-6 8.9-6z"
                }),
                /* @__PURE__ */ jsx308("path", {
                  fill: "#fff",
                  d: "M1658.7 877.7s3.2 6.6 4.2 10.1c1.8 6 3 12.3 3 18.6a78.8 78.8 0 0 1-3.2 18.6 171 171 0 0 1-10.3 26.3c-2.6 5.4-6 10.3-8.6 15.8-4.1 8.7-7 18-10.6 26.8-3 7.5-6.9 14.7-9.2 22.4-3 10.2-4.5 20.9-6 31.4a230 230 0 0 0-2.3 27.5c0 11 .3 22 2.3 32.6 2 10.6 5 21.2 9.8 31a79.1 79.1 0 0 0 31.8 34.8c5.5 3.4 11.9 5.3 18 7.8 8.3 3.3 25.4 9.3 25.4 9.3s-23.6-11.6-31.8-21.4a68.4 68.4 0 0 1-12.8-28.9 112.3 112.3 0 0 1-1.2-36.6 196 196 0 0 1 9.2-38.3c4.2-13.2 10-25.9 15.4-38.6 3.9-9.3 8.3-18.2 12-27.5 4.5-11 8.8-22 12.4-33.2 2.1-6.9 4.8-13.7 5.4-20.9a76 76 0 0 0-2.2-23.4 89 89 0 0 0-11.8-30.6 41.1 41.1 0 0 0-14.8-13.2c-5.7-2.9-12.5-5.4-18.9-4.1-2 .4-5.2 3.7-5.2 3.7"
                }),
                /* @__PURE__ */ jsx308("path", {
                  fill: "#fff",
                  d: "M1711.6 945.6s4.4-18 5.2-27.2c.6-7.9.2-15.8-.6-23.7-1-8.7-1.5-17.8-4.9-25.9a68.3 68.3 0 0 0-38.2-37 92.2 92.2 0 0 0-28-4.8 130 130 0 0 0-38 4c-4 1.4-11.7 5.7-11.7 5.7l30 49s9.3-5.6 14.5-7a54.7 54.7 0 0 1 17-1.2c5.8.4 11.7 1 17 3.3a57 57 0 0 1 17.6 13.3 73.9 73.9 0 0 1 15 22c3 7.5 3.5 16 4.6 24.2.3 1.7.5 5.3.5 5.3"
                }),
                /* @__PURE__ */ jsx308("path", {
                  d: "M1717 906.7s-5.3-16.6-10.3-23.5a63.8 63.8 0 0 0-22.3-19.8c-9.4-4.7-31-6.2-31-6.2l11.4 21-20-.4-10.3-17.4-19.3 8.7-9.5-15.7 20.4-9.4-9.4-15.2 20.4-2 8.9 14.7s15.9 0 23.6 1.7a58.2 58.2 0 0 1 27.5 14.4 68 68 0 0 1 12 14.2c3 5.1 6.5 16.7 6.5 16.7z"
                }),
                /* @__PURE__ */ jsx308("path", {
                  d: "m1581.7 845 31.8 46.7m-18-54.8-15 8.8-14.3 11 31 47.1 13.7-10.6 14.1-8.2zm58.3 199 17.9-37 19.1 7.7 7.8-19-19-9 9.8-21.3-14-6.3-10.6 20.5-19.2-8-8.4 20 18.6 7.7-17.2 36.7zm143.2-11.1 18.1-.4v21l17.6.9-3 21.4-16.4-1s-2.7 12.5-5.1 18.4c-2.5 6.2-9.7 17.4-9.7 17.4l-19.4-4.8s7-11 9.7-17c2.4-5.4 5.7-16.6 5.7-16.6l-20-2.5 3.5-20.2 18.1 1.2z"
                })
              ]
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__a",
              width: "100%",
              height: "100%",
              transform: "matrix(-1 0 0 1 3717.8 0)"
            }),
            /* @__PURE__ */ jsx308("path", {
              fill: "#fff",
              d: "m1756.7 735.6-27.5 29.4 17 51 9.6 35.8-27.7 25.8 50.7 71-17.4 19.9a12.2 12.2 0 0 0-2.1 8.6c.3 2.7 1.6 5.4 3.6 7.3 4.5 4.1 11.3 5.1 17.3 6.7 21 5.6 42.9 8 64.6 9.7 4.7.4 14 0 14 0s9.4.4 14.1 0c21.8-1.6 43.6-4.1 64.7-9.7 6-1.6 12.7-2.6 17.3-6.7a12.2 12.2 0 0 0 1.4-15.9l-16.3-36 51.8-55.4-19.7-17.9-.5-43.2 17-51-25.5-25.7-23-61.2s-4.7-17.1-8.8-25c-2.4-4.6-5.8-8.7-9.2-12.8-4-4.9-8-9.9-12.8-13.9a85 85 0 0 0-14.6-9c-5.5-2.9-11-6-16.9-7.5-6.1-1.5-19-1.5-19-1.5s-12.7 0-18.9 1.5c-6 1.6-11.4 4.6-16.8 7.5a85 85 0 0 0-14.6 9c-4.9 4-8.9 9-12.9 13.9-3.3 4-6.7 8.2-9.1 12.9-4.1 7.8-8.9 24.9-8.9 24.9z"
            }),
            /* @__PURE__ */ jsx308("path", {
              d: "M1963.3 933.1s-3.2-2.8-5-4a64.5 64.5 0 0 0-12-6c-5.5-2.2-11.5-3.3-17.3-4.7a196.8 196.8 0 0 0-44.3-5.7c-8.6 0-25.8 1.3-25.8 1.3s-17.2-1.3-25.8-1.3a195.2 195.2 0 0 0-44.3 5.7c-5.9 1.4-11.8 2.5-17.4 4.7a64.5 64.5 0 0 0-12 6c-1.7 1.2-5 4-5 4m218.8-42.7s-5.2-5.2-8.6-5.9a9 9 0 0 0-6.6 1.5 13.1 13.1 0 0 0-4 15.2c.8 2 2 4.3 4.1 5.2 4.8 1.9 15.4-2 15.4-2zm5.1-3.6c5.8.2 8 3.2 9.5 6.5m-243.2-2.9-.3 14s10.5 3.9 15.3 2c2-.9 3.4-3.1 4.2-5.2a13.1 13.1 0 0 0-4-15.2 8.9 8.9 0 0 0-6.6-1.5c-3.5.7-8.6 6-8.6 6zm-5.2-3.6c-5.8.2-8 3.2-9.4 6.5m198.1 1.4-8.4-1m-130 1 8.4-1m76 .8c-2.9-.4-7.6-4.2-7.6-4.2m-22.8 4.2c2.8-.4 7.6-4.2 7.6-4.2m141-19.3s-4.3 3.3-7.4 3.8l-1.2.7s-2 5.7-3.6 8.2a44.7 44.7 0 0 1-6.5 6.2s-4.8-4.1-7.7-5c-2-.5-4.2-.5-6 .3a11 11 0 0 0-4.8 4.3c-1.4 2-2.7 4.6-2.6 7 .1 3 3.9 8.3 3.9 8.3l-2.6 4.5-3.7 2.3a90.3 90.3 0 0 1-19-7.5 18.9 18.9 0 0 1-4.4-9s4.5-2.7 5.6-5c1.2-2.5 1.6-6 .2-8.4-1.6-2.6-5.3-4-8.4-4a8.8 8.8 0 0 0-6.3 2.7c-1.6 1.8-3 4.5-2.5 7 .4 2.4 4.7 5.7 4.7 5.7s-1.8 4.6-3.8 5.5c-6 2.5-10 4-15.3 4.8a39 39 0 0 1-16.3 0 17 17 0 0 1-9-5.5c-.6-.9-.8-3-.8-3s6.5-1.7 9-3.7c2.6-2 5.3-4.6 5.9-7.8.5-3.2-1.2-6.6-3-9.2a18 18 0 0 0-7.6-6c-1.3-.6-4.3-.7-4.3-.7l-1 .9a14.6 14.6 0 0 1-4.7 3.8h-.1l-.2.1-1.1.6-.8.1-2.4.8s3.8 1.2 5 2.8c.6.9.9 2 1 3.3l.2 2c0 1.2-.3 2.3-.7 3.4a9 9 0 0 1-1.7 3.5c-.4.6-1 1-1.6 1.4 0 0 0 0 0 0l-.2.1c-1 .7-2.2 1.2-3.3 1.5-1.4.4-4.2.1-4.3.1 0 0 5.5 0 7.6-1.6l.2-.1a10.7 10.7 0 0 0 3.8-7.2v-3c-.3-1.6-1-3.2-2.2-4.2-2.4-2.1-9.3-2.4-9.4-2.4-.1 0-7 .3-9.4 2.4a7.6 7.6 0 0 0-2.3 4.2v3.1l.5 2.3c.7 2 1.8 3.7 3.3 4.9l.2.1c2.2 1.6 7.6 1.6 7.7 1.6-.1 0-3 .3-4.3 0-1.2-.4-2.4-.9-3.4-1.6h-.1v-.1c-.7-.4-1.2-.8-1.7-1.4a9 9 0 0 1-1.7-3.5c-.3-1-.6-2.2-.7-3.3l.2-2.1c.2-1.2.5-2.4 1.1-3.3 1.1-1.6 5-2.8 5-2.8l-2.5-.8-.7-.1-1.2-.6h-.1l-.1-.1a15 15 0 0 1-4.8-3.8l-1-.9s-3 0-4.2.7a18 18 0 0 0-7.6 6c-1.8 2.6-3.5 6-3 9.2.5 3.2 3.3 5.8 5.8 7.8 2.6 2 9 3.7 9 3.7s-.2 2.1-.8 3a17 17 0 0 1-9 5.5 39 39 0 0 1-16.3 0 59 59 0 0 1-15.2-4.8c-2-1-3.9-5.5-3.9-5.5s4.4-3.3 4.8-5.8c.4-2.4-1-5-2.6-6.9a8.8 8.8 0 0 0-6.2-2.8c-3.1 0-6.8 1.5-8.4 4.1-1.5 2.4-1 5.9.2 8.4 1 2.3 5.6 5 5.6 5a18.9 18.9 0 0 1-4.5 9 88.5 88.5 0 0 1-19 7.5l-3.6-2.3-2.6-4.5s3.7-5.2 3.8-8.2c.2-2.5-1.1-5-2.5-7.1a11.2 11.2 0 0 0-4.8-4.3c-1.8-.8-4-.8-6-.2-3 .8-7.7 4.9-7.7 4.9s-4.8-3.8-6.5-6.2a48.7 48.7 0 0 1-3.7-8.2l-1.2-.7c-3-.5-7.3-3.8-7.3-3.8l-4.4 1s-4.1 2.1-4.2 4c0 2.8 3.8 4 5.5 6 1.4 1.9 2.8 3.7 4.1 5.7 1.2 1.8 2.9 3.4 3.5 5.5.6 2.3-1 5 0 7.2 1.2 2.7 3.7 5.4 6.7 6 2.6.5 7.6-2.6 7.6-2.6l-.2 19.9 10.3 9.3 9.7 20.3-3.8 5.2 1.1 10c7.5-9.6 20.5-13.8 32.2-17.2 15.7-4.5 44.6-4.8 58-4.7l7.3.1s44.3-1.4 65.2 4.6c11.7 3.4 24.7 7.6 32.2 17.2l1.2-10-3.9-5.2 9.7-20.3 10.3-9.3-.1-19.9s5 3.1 7.6 2.6c3-.6 5.5-3.3 6.7-6 1-2.2-.7-4.9 0-7.2.6-2 2.2-3.7 3.4-5.5 1.3-2 2.7-3.8 4.2-5.6 1.7-2.1 5.5-3.3 5.4-6 0-2-4.1-4.2-4.1-4.2zm-148.4-2.6c1 1 3 2.8 4.8 3.8l.2.1c.5.3 1.2.5 2 .7 2.8.8 7.8.3 8 .3h0c.1 0 5.1.5 8-.3l2-.7.2-.1c1.7-1 3.7-2.9 4.8-3.8.5-.7 1-1.4 1.3-2.2 1.1-2.7 1-6.1-.2-8.7-1.6-3-5.2-4.5-8.1-6.3-2.5-1.5-8-3.7-8-3.7a69 69 0 0 0-8 3.7c-3 1.8-6.6 3.3-8.1 6.3-1.3 2.6-1.4 6-.2 8.7.3.8.8 1.5 1.3 2.2"
            }),
            /* @__PURE__ */ jsx308("path", {
              d: "M1980.8 829.8s-11-5-16.6-6.9c-10.4-3.3-21.3-5.2-32-7.3-12.5-2.4-25.2-3-37.6-6-3.9-.8-7.5-2.7-11.5-3.5-5.4-1.1-11-2.9-16.4-1.7-3 .6-7.8 4.6-7.8 4.6s-4.9-4-7.8-4.6c-5.4-1.2-11.1.6-16.5 1.7-4 .8-7.6 2.7-11.4 3.6-12.4 2.9-25.2 3.5-37.7 6-10.7 2-21.5 3.9-32 7.2-5.6 1.8-16.5 6.9-16.5 6.9m197.4-45.1s5.4-2.9 7.3-5a9.5 9.5 0 0 0 2.7-5.3 9 9 0 0 0-2.3-6.5 9 9 0 0 0-6.2-2.2c-1.9 0-3.9.6-5.3 1.8a9.1 9.1 0 0 0-3 5.6c-.3 1.8.5 3.7 1.3 5.3a33 33 0 0 0 5.5 6.3m-151 0s4.1-3.8 5.4-6.3a9.4 9.4 0 0 0 1.4-5.3 9.1 9.1 0 0 0-3-5.6 8.2 8.2 0 0 0-5.3-1.8 9 9 0 0 0-6.3 2.2 8.7 8.7 0 0 0-2.2 6.5c.1 2 1.3 3.7 2.6 5.2 2 2.2 7.3 5 7.3 5zm-41.2 18-11.9 15.6s0 4 .8 5.8a24 24 0 0 0 5.9 5.7l.8 21.4-11.3 19.6-1 .2 7.3 3.8 1 .1c4.4-.3 7-5.2 10.9-7.4 4.8-2.8 10-5 15.2-7.2a239.8 239.8 0 0 1 50-15.1 141.8 141.8 0 0 1 29.5-1.2c6.6.5 19.4 3.4 19.5 3.4 0 0 12.9-3 19.5-3.4a140.7 140.7 0 0 1 57.8 8.3 239.8 239.8 0 0 1 36.9 15.2c3.8 2.2 6.5 7 10.8 7.4h1l7.3-4-1-.1-11.3-19.6.9-21.4s4.6-3.3 5.8-5.7c1-1.7.8-5.8.8-5.8l-11.9-15.6s-6 6-9.9 7.3c-2 .6-4.4.6-6.5 0-2.5-.8-4.4-2.9-6.5-4.5a84 84 0 0 1-12.9-12.1 70.2 70.2 0 0 1-5.3-8.7s-12.9 10.1-20.6 12.1c-7.6 2-16 1.6-23.5-.6-1.9-.6-5-3-5-3a42 42 0 0 0-26.4-8 42 42 0 0 0-26.4 8s-3.2 2.4-5 3a44.8 44.8 0 0 1-23.6.6 82.4 82.4 0 0 1-20.6-12.1s-3.1 6-5.3 8.7a84 84 0 0 1-12.9 12.1c-2 1.6-4 3.7-6.5 4.5-2 .6-4.4.6-6.4 0a37 37 0 0 1-10-7.3"
            }),
            /* @__PURE__ */ jsx308("path", {
              d: "M1985.9 796.4s.4-5.7-.2-8.5a21 21 0 0 0-3.1-7c-1.5-2.3-5.7-6-5.7-6m-1.4 27.8s3.4.1 4.9-.6c2.6-1.3 6-6.3 6-6.3s6.7 4.6 10.4 4c1.8-.2 3.2-1.8 4.2-3.4a8 8 0 0 0 1.2-5.7c-.3-1.5-1.6-2.6-2.8-3.6-2.3-2-6.4-1.7-7.9-4.2-1.2-2-.5-4.9.2-7.1 1.4-4.8 4.7-8.7 7.5-12.8 1.7-2.6 5.3-4.4 5.6-7.5.2-1.6-2-4.6-2-4.6s-5.2-.1-7.7.6c-4 1.2-8.3 3-11.2 6.1-2.4 2.6-3 6.4-4.3 9.7-1 2.5-2.5 7.7-2.5 7.7s-6 0-8.7 1.2a17.1 17.1 0 0 0-8.7 7.7c-1.2 2.7-1 6.2 0 9 1.1 3 3.5 5.3 6.1 7 2.9 1.8 9.7 2.8 9.7 2.8M1740.8 775s-4.1 3.6-5.6 5.8a21 21 0 0 0-3.2 7.1c-.6 2.8-.1 8.5-.1 8.5m-17-45.5s-2.2 3-2 4.6c.4 3.1 4 5 5.7 7.5 2.7 4.1 6 8 7.5 12.8.6 2.2 1.3 5 .1 7-1.4 2.6-5.6 2.4-7.8 4.3-1.2 1-2.5 2.1-2.9 3.6a8 8 0 0 0 1.2 5.7c1 1.6 2.5 3.2 4.3 3.4 3.6.6 10.3-4 10.3-4s3.5 5 6 6.3c1.5.7 5 .6 5 .6s6.8-1 9.7-2.9c2.5-1.6 5-4 6-6.8 1-2.9 1.3-6.4 0-9.1a16.8 16.8 0 0 0-8.7-7.7c-2.6-1.3-8.7-1.2-8.7-1.2s-1.4-5.2-2.4-7.7c-1.3-3.3-2-7.1-4.4-9.7a24.7 24.7 0 0 0-11.2-6.1c-2.5-.7-7.7-.6-7.7-.6m135.6 14.3 8.4-2.4 8.3 2.4m-14.5 20s-6.5-5.8-7.7-9.8a8 8 0 0 1 .4-5.5c1.2-2.2 5.9-4.7 5.9-4.7s-7.1-3.4-9-6.6a8.6 8.6 0 0 1-.5-6.3 17 17 0 0 1 5.8-8c3.2-2.7 11.3-5.4 11.3-5.4s8 2.7 11.2 5.3a17 17 0 0 1 5.9 8.1c.5 2 .4 4.4-.6 6.3-1.9 3.2-9 6.6-9 6.6s4.8 2.5 6 4.7c.8 1.6.9 3.7.3 5.5-1.2 4-7.7 9.9-7.7 9.9l-6.1.4zm22.7-26.8s13.4 5.7 18 11.1c1.2 1.5 2.3 3.5 2.2 5.5-.5 7-10.3 18.2-10.3 18.2l-20-8.3h-12.9l-20 8.3s-9.8-11.3-10.2-18.2c-.2-2 1-4 2.2-5.5 4.5-5.4 18-11.1 18-11.1"
            }),
            /* @__PURE__ */ jsx308("path", {
              d: "m1844.4 669.2 8-6.2 6.5.2-6.6-.2s-3.6-2.4-4.6-4.2a9 9 0 0 1-1-6c.5-2.7 2-5.5 4.4-6.9 2.3-1.3 7.8-.5 7.8-.5s5.5-.8 7.7.5c2.4 1.4 3.9 4.2 4.5 6.8.4 2 0 4.3-1 6-1 1.9-4.6 4.3-4.6 4.3l-6.7.2 6.5-.2 8 6.2m52.7 5.1-2.7 4.7m32.6-20-7.5 1m8.5 8.8-11.5.6m-1.5-13.8c1.5 1 4.2 2.9 4.6 4.6a10 10 0 0 1-3.1 9.2c-2.4 2-9.3 1.5-9.3 1.5m-181.7 33.6 17-4.2c8-2 16-4.2 24.2-5.7 9.3-1.6 18.7-2.8 28-3.5 11.8-.9 35.3-.6 35.3-.6s23.5-.3 35.2.6c9.4.7 18.7 1.9 28 3.5 8.2 1.5 16.2 3.8 24.3 5.7l17 4.2m-171.6-30.2 2.7 4.7m-32.7-20 7.5 1m-8.5 8.8 11.5.6m-6.4 16s12.5-3.2 18.8-4.5c7-1.4 14-2.8 21-3.7 8-1 16.1-1.5 24.3-2 9.6-.4 28.9-.3 28.9-.3s19.2 0 28.9.4a284.2 284.2 0 0 1 45.2 5.6c6.3 1.3 18.9 4.5 18.9 4.5M1781.6 671s-6.8.5-9.2-1.5c-2.5-2-4-6-3.2-9.2.7-2.4 5.6-5.2 5.6-5.2m63.1 74c-12 .8-24 1.5-35.8 3.7a220.2 220.2 0 0 0-36.2 9.7c-11.1 4-22.9 22.6-32 15.2-2-1.6.7-5 1.6-7.4a43 43 0 0 1 7.8-12.6c2.4-2.7 8-3 8.5-6.6.5-2.6-3.4-4-4.3-6.6a17 17 0 0 1-.5-10c1.2-4.1 6.5-6.2 7.7-10.3 1-3.6-2.5-7.8-.9-11.2 2.2-4.2 11.4-2.7 12-7.4.4-2.3-3.8-3-4.5-5.1-.6-1.6.3-3.3.3-5 0-2.1.4-4.5-.6-6.5-.9-1.7-3.7-2.1-4.3-4a5.5 5.5 0 0 1 1.1-5.4c1-1 3.7.4 4.3-.9 1.4-2.6-2.5-5.3-3.7-8-1.4-3.2-3.2-6.3-4-9.7-.6-2.7-3-7-.6-8.3 2.8-1.6 5.5 3.2 8 5.1 3.4 2.5 7.2 4.8 9.5 8.3 1.7 2.5.7 6.5 3 8.6 2.6 2.5 7.7.5 10.4 2.9 2.4 2 4.5 5.5 3.8 8.5-.7 3-7.6 2.9-7 5.8.9 3.4 7 3.2 10.4 2.5 2-.3 3.5-2.2 5.1-3.4 1.4-1 2.4-2.2 4-2.8 1.6-.8 5.3-1 5.3-1l-2.1-.5s-3.2-2.5-3.5-4.3a6 6 0 0 1 1.6-5 7.7 7.7 0 0 1 5.5-2.2c1.7 0 3.5.7 4.6 1.9a6.3 6.3 0 0 1 1.7 4.8 6 6 0 0 1-2.3 3.7 13 13 0 0 1-4.6 1.5l2.3.6 6.1 8.5 26.6-1.5s3.3-3.3 2.6-5.2c-.7-1.9-2.5-2.6-5.7-2.5-8.5.4-10.3-6.8-10-12 .3-4.4 5.5-7.3 9.5-9 4-1.5 10.8 3.7 12.6-.1 1.5-3.3-5.8-5-7-8.5-.5-1.5-.5-3.4.2-4.8 1.8-3.6 5.7-6 9.4-7.7 1.6-.7 5-.8 5-.8s3.6.1 5.1.8c3.7 1.7 7.6 4.1 9.4 7.7.7 1.4.7 3.3.2 4.8-1.1 3.5-8.5 5.2-7 8.5 1.8 3.8 8.7-1.4 12.6.2 4 1.6 9.2 4.5 9.5 8.9.3 5.2-1.4 12.4-10 12-3.2-.1-5 .6-5.7 2.5-.6 1.9 2.7 5.2 2.7 5.2l26.5 1.5 6.1-8.5 2.3-.6s-3.3-.5-4.5-1.5a6 6 0 0 1-2.3-3.7c-.2-1.7.5-3.6 1.6-4.8 1.1-1.2 3-1.9 4.6-1.9 2 0 4.1.7 5.5 2.2 1.2 1.2 2 3.2 1.6 5-.3 1.8-3.5 4.3-3.5 4.3l-2.1.5s3.7.2 5.4 1c1.5.6 2.6 1.9 3.9 2.8 1.7 1.2 3.1 3 5.1 3.4 3.5.7 9.6 1 10.3-2.5.7-3-6.1-2.9-6.8-5.8-.7-3 1.3-6.5 3.7-8.5 2.7-2.4 7.9-.4 10.5-2.9 2.2-2 1.3-6 3-8.6 2.3-3.5 6-5.8 9.4-8.3 2.5-1.9 5.3-6.7 8-5.1 2.4 1.4 0 5.6-.6 8.3-.8 3.4-2.6 6.5-4 9.7-1.2 2.7-5 5.4-3.7 8 .7 1.3 3.3-.2 4.3.9a5.5 5.5 0 0 1 1.1 5.4c-.6 1.9-3.4 2.3-4.3 4-1 2-.5 4.4-.5 6.6 0 1.6.8 3.3.3 4.9-.8 2.1-5 2.8-4.6 5.1.7 4.7 9.9 3.2 12 7.4 1.7 3.4-1.9 7.6-.9 11.2 1.2 4.1 6.5 6.2 7.8 10.3 1 3.2.4 6.8-.6 10-.8 2.5-4.7 4-4.3 6.6.6 3.6 6.2 3.9 8.6 6.6 3.3 3.6 5.8 8 7.7 12.6 1 2.3 3.7 5.8 1.7 7.4-9.2 7.4-21-11.1-32-15.2a220.2 220.2 0 0 0-72-13.4c-7-.4-21-.4-21-.4s-14 0-21 .4m31.1-133.7-10.1.1-10.2-.1m17-33.9c2.6-5.6-2-9.7-6.8-13.8-4.8 4-9.4 8.2-6.8 13.8m14.1 46.8c3.9.2 8.6 4.2 11.6 1.7 1.3-1.2.7-3.7 0-5.3-1.6-3.8-8.4-4.7-8.7-8.8-.3-3.5 5.1-5.2 6.3-8.5.5-1.7.6-3.7 0-5.3-2.8-6.6-14.5-7-16.6-13.7-.9-3 6-6.5 6.8-6.9 4.4-1.9 9.7 2.7 14 .8 3-1.2 6.1-4.1 6-7.3 0-3.4-3.6-6.3-6.8-7.7-6.1-2.6-16.2 6-20 .5-3.4-5.1 8.7-11.1 7-17-.7-2.9-7-5.3-7-5.3s-6.1 2.4-6.9 5.3c-1.6 5.9 10.5 11.9 7 17-3.7 5.5-13.8-3.1-20-.5-3.1 1.4-6.8 4.3-6.8 7.7 0 3.2 3.1 6 6 7.3 4.3 1.9 9.7-2.7 14-.8.9.4 7.7 4 6.8 6.9-2 6.7-13.7 7-16.5 13.7a7.8 7.8 0 0 0 0 5.3c1.1 3.3 6.6 5 6.3 8.5-.3 4.1-7.2 5-8.7 8.8-.7 1.6-1.4 4.1 0 5.3 3 2.5 7.7-1.5 11.6-1.7 2.4-.2 7.3 0 7.3 0s4.8-.2 7.3 0"
            }),
            /* @__PURE__ */ jsx308("path", {
              fill: "none",
              d: "M1953.7 953.5s-7.1-3-10.8-4.3a258 258 0 0 0-20-6.5c-6.6-1.8-13.2-3.7-20-4.5-14.6-1.6-44-.2-44-.2s-29.4-1.4-44 .2c-6.8.8-13.5 2.7-20 4.5a258 258 0 0 0-30.9 10.8M1966 731s-12-4.8-18.1-6.9c-5.1-1.7-10.2-3.5-15.5-4.8-6.4-1.6-12.9-2.6-19.4-3.5a387.1 387.1 0 0 0-54.1-3.4s-17.2.1-25.8.6a376.5 376.5 0 0 0-47.8 6.3c-5.2 1.3-10.3 3-15.4 4.8-6.1 2.1-18 6.9-18 6.9m-14.2 120.4s17.5-6 26.4-8.7c9.1-2.8 18.2-6 27.5-8 11.2-2.5 22.6-3.7 34-5 11-1.1 33.3-2.3 33.3-2.3s22.2 1.2 33.3 2.4c11.3 1.2 22.8 2.4 34 4.8 9.3 2 18.3 5.3 27.5 8.1l26.4 8.7"
            })
          ]
        }),
        /* @__PURE__ */ jsxs283("g", {
          fill: "#ccc",
          transform: "translate(123) scale(.192)",
          children: [
            /* @__PURE__ */ jsxs283("g", {
              id: "va_svg__b",
              children: [
                /* @__PURE__ */ jsx308("path", {
                  d: "m1533.3 904 101.2 86.8s-5.2 11.2-7.3 17a142.6 142.6 0 0 0-9.3 41l-118-108c1.7-24.7 15.6-33.5 33.4-36.8z"
                }),
                /* @__PURE__ */ jsx308("path", {
                  d: "m1519 958.2-24.3 27.2 15.2 14.6-23.5 22.8-15.2-15.1-25.5 27.2-.2 33.7 58 45.5 20.1-14.9-1.1-32.3 15.4 8.6 15.5-9.4.8 29.1-12.6-9.1-13.7 18-1.4 32 43.7 39 53-47.1-4-14.1-2.2-12.7-1.3-25.1 2-27.5z"
                }),
                /* @__PURE__ */ jsx308("path", {
                  d: "m1494.7 985.4-.6 30 15.6-15.3z"
                }),
                /* @__PURE__ */ jsx308("path", {
                  fill: "none",
                  d: "m1572 1140.4-1.9 34.3m-18.6-139.7.6 31.8m-14.8-17.3.9 25.8m-14.5-36.3.6 29m-21.4 15.2.3 30.6m24.7-9.7 44 37 45.1-39.6m-171-66.9 57.6 49.2 18.9-16.9-15-12.6 16.7-15.7 12.9 11.1 14.5-14.8 19 18.3-17.2 13.4 16 14.6-15.2 14"
                }),
                /* @__PURE__ */ jsx308("path", {
                  d: "m1901.3 1229.3 48.7 44.6 10.7 31.5-62.6-6.7-35.7-35.3-38-35.2-164-142.1s3.5-13.1 5.6-19.5c3.2-9.3 6.9-18.4 10.6-27.5l3-6.8 183 162.3z"
                }),
                /* @__PURE__ */ jsx308("path", {
                  d: "M1942.7 1236c27 38 72.7 73.7 86.5 90.9 13.9 17.2 22.8 33.5 2.6 55.5s-43 9.5-61.1-2.6c-18.1-12-49.6-51.3-94.8-81.3z"
                }),
                /* @__PURE__ */ jsx308("path", {
                  d: "m1926.7 1299.8-35.2-16m41-38.2c2.4 8 .5 16.8 3.6 24.4 3 7.6 14 20 14 20s-7 1-10.3 2.2c-4.7 1.9-12 2.7-13.1 7.7-1 4.3 4 8 7 11.2 3 3.1 6.7 5.4 10.4 7.6 6.1 3.6 12.4 7.6 19.4 8.9 8.7 1.6 25.1-10.8 26.6-2 .6 3.6-7.4 1.3-10.7 3-7.8 3.8-11.6 12-4.8 17.8 4.4 3.7 11.3 2.4 17 2.9 5.5.4 11.7-2.8 16.5 0 5.6 3.2 12.7 11 9.7 16.8-3 6-14.5 5.8-20 2-4-3-2.9-9.5-3.5-14.4v-4.4"
                }),
                /* @__PURE__ */ jsx308("circle", {
                  cx: 2154.7,
                  cy: 1480.1,
                  r: 129.7
                }),
                /* @__PURE__ */ jsx308("path", {
                  fill: "#fff",
                  d: "M2106.1 1485.7a40.5 40.5 0 1 0 40.5 40.4l14-.6a40.5 40.5 0 1 0 40.5-40.5l.6-7.9a40.5 40.5 0 1 0-40.5-40.5l-14-1.2a40.5 40.5 0 1 0-40.5 40.5z"
                }),
                /* @__PURE__ */ jsx308("circle", {
                  cx: 2154.7,
                  cy: 1446.1,
                  r: 14.6
                }),
                /* @__PURE__ */ jsx308("circle", {
                  cx: 2189.4,
                  cy: 1480.1,
                  r: 14.6
                }),
                /* @__PURE__ */ jsx308("circle", {
                  cx: 2155.3,
                  cy: 1511.2,
                  r: 14.6
                }),
                /* @__PURE__ */ jsx308("circle", {
                  cx: 2119.3,
                  cy: 1480.1,
                  r: 14.6
                }),
                /* @__PURE__ */ jsx308("path", {
                  fill: "#fff",
                  d: "M2152.2 1558.4c-5.3 11-12.6 16-21.9 22a63.2 63.2 0 0 0 43.8 0 54 54 0 0 1-21.9-22zm-76.5-80.2c-11-5.3-16-12.6-22-22a63.2 63.2 0 0 0 0 44 53 53 0 0 1 22-22zm159.2 3.6c11-5.3 16-12.6 22-21.9a63.2 63.2 0 0 1 0 43.9c-4.7-9.3-12-16-22-22zm-78.4-80.8c-5.3-11-12.6-16-22-22a63.2 63.2 0 0 1 44 0 53 53 0 0 0-22 22z"
                })
              ]
            }),
            /* @__PURE__ */ jsx308("g", {
              fill: "#ce9d09",
              children: /* @__PURE__ */ jsxs283("g", {
                id: "va_svg__c",
                children: [
                  /* @__PURE__ */ jsx308("path", {
                    d: "M1533.5 903.8s.7-5 0-7.4a22.6 22.6 0 0 0-6.6-10.2 19.6 19.6 0 0 0-9.2-4.6 24.5 24.5 0 0 0-17.7 4.2l-15 6.2-5.5 17.7s-3.2 5.6-4 8.7a23 23 0 0 0-.5 10.1c1 3.9 3.2 7.6 6.3 10.2a19 19 0 0 0 10.3 4 28 28 0 0 0 8.3-1.9c1.6-18.6 9.9-32.8 33.5-36.9z"
                  }),
                  /* @__PURE__ */ jsx308("path", {
                    d: "m1500.3 885.6-38.8-17-3.1 3 21 38.2s6-8.7 9.4-12.7c3.6-4.1 11.5-11.5 11.5-11.5z"
                  }),
                  /* @__PURE__ */ jsx308("circle", {
                    cx: 1457.3,
                    cy: 865.3,
                    r: 16
                  }),
                  /* @__PURE__ */ jsx308("path", {
                    d: "M1566.2 932.3c3.4 28 7.3 55.9 16 83.8l31 28.5c-6.5-29.3-18.4-58.5-18.3-87.7z"
                  }),
                  /* @__PURE__ */ jsx308("path", {
                    d: "m1613 972.4-85.4-6.4 27.2 25 78 3.3 1.2-4zm105.4 94.6a61.9 61.9 0 0 0-37.9 37c-6.4.7-12.3.7-14.4-4a58.5 58.5 0 0 1 35.7-47.8c15-2.8 12.2 8.9 16.6 14.7zm27.5 25.8a61.9 61.9 0 0 0-37.9 37.2c-6.3.5-12.3.6-14.4-4.1a58.5 58.5 0 0 1 35.8-47.8c15-2.8 12.1 8.9 16.5 14.7zm312.8 261.9a72 72 0 0 0-15.1 1.5c.3 8-3 16.6-11.8 26.2a33.4 33.4 0 0 1-23.7 12s-2.8 17.7 2.6 23.3c6.3 6.6 27.1 3.9 27.1 3.9l1.8-1.1a129.7 129.7 0 0 1 31.9-39.8l.3-1.3s3-16.5-2.1-21.5c-2.4-2.3-6.6-3-11 0z"
                  }),
                  /* @__PURE__ */ jsx308("circle", {
                    cx: 2254.5,
                    cy: 1375.4,
                    r: 17.7
                  }),
                  /* @__PURE__ */ jsx308("circle", {
                    cx: 2260.6,
                    cy: 1580,
                    r: 17.7
                  }),
                  /* @__PURE__ */ jsx308("circle", {
                    cx: 2062.1,
                    cy: 1591.6,
                    r: 17.7
                  })
                ]
              })
            })
          ]
        }),
        /* @__PURE__ */ jsxs283("g", {
          fill: "#ce9d09",
          transform: "matrix(-.192 0 0 .192 837 0)",
          children: [
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__b",
              width: "100%",
              height: "100%"
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__c",
              width: "100%",
              height: "100%",
              fill: "#ccc"
            })
          ]
        }),
        /* @__PURE__ */ jsxs283("g", {
          fill: "#fa0204",
          transform: "translate(123) scale(.192)",
          children: [
            /* @__PURE__ */ jsx308("path", {
              id: "va_svg__d",
              d: "M1869.2 1175.8c0 5.4-4.5 7.4-13.3 7.4-8.7 0-12.7-2.5-12.7-7.9s4-6.7 12.7-6.7c8.8 0 13.3 1.8 13.3 7.2z"
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__d",
              width: "100%",
              height: "100%",
              x: 6.4,
              y: 14.3
            }),
            /* @__PURE__ */ jsx308("path", {
              d: "M1877.3 1208.7c-1.7 5-6.7 5.6-15 2.7-8.2-3-11.2-6.6-9.4-11.7 1.8-5 6-5 14.3-2.1 8.2 2.9 12 6 10.1 11z"
            }),
            /* @__PURE__ */ jsx308("path", {
              id: "va_svg__e",
              d: "M1877.5 1222.5c-1 5.3-5.9 6.4-14.4 4.7-8.6-1.7-12-5-11-10.3 1-5.3 5.3-5.8 13.8-4 8.6 1.7 12.7 4.3 11.6 9.6z"
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__e",
              width: "100%",
              height: "100%",
              x: 4,
              y: 16.1
            }),
            /* @__PURE__ */ jsx308("path", {
              d: "M1921.7 1216.2c-2.6-.7-2.3-5.3-1.6-7.9 1.2-4 8.4-9.1 8.4-9.1s1.8 5.6 1 8.2c-1.2 3.7-4 9.8-7.8 8.8z"
            }),
            /* @__PURE__ */ jsx308("path", {
              d: "M1912.3 1224.4c-2.8-.6-3.2-5.5-2.5-8.3 1.2-4.3 9.7-9.3 9.7-9.3s1.5 6 .5 8.8c-1.3 3.7-3.9 9.7-7.7 8.8zm-10.8 15.6c-4.3-1.1-3.8-8.8-2.6-13 1-3.6 3.7-9.2 7.2-8.3 4.2 1 4.2 8.3 3.1 12.5-.9 3.8-4 9.8-7.7 8.8z"
            }),
            /* @__PURE__ */ jsx308("path", {
              d: "M1888.7 1252.2c-4.2-1-6-7.6-5.1-11.9.9-4.4 5.3-10.4 9.7-9.4 4.5 1 6 8.3 5 12.8-1 4.1-5.4 9.4-9.6 8.5zm-2.2 7.4c-1 5-7.5 6.8-11.5 5.5-4.1-1.3-9.5-7.1-8.4-12.5 1.2-5.4 8.2-6.8 12.3-5.2 3.9 1.5 8.7 7.2 7.6 12.2zm-85-49.3s5.1 2.5 7.3 4.8c2.3 2.4 5.1 3.3 3.7 6.9-1.4 3.6-5.8 2.4-8.1-.2-2.1-2.3-3-11.5-3-11.5zm25.3 8.7c5.3 1.1 5.1 7.2 2.5 11-2.8 3.8-10.9 8.9-16.4 7.8-5.5-1.1-4.8-7.8-1.8-11.7 2.9-3.6 10.6-8 15.7-7z"
            }),
            /* @__PURE__ */ jsx308("path", {
              id: "va_svg__f",
              d: "M1844.3 1230.5c4.8 2.2 3.4 8.1 0 11.2-3.6 3.2-12.6 6.3-17.7 4-5.2-2.2-3-8.6.8-11.7 3.6-3 12-5.6 16.9-3.5z"
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__f",
              width: "100%",
              height: "100%",
              x: 14,
              y: 10.7
            }),
            /* @__PURE__ */ jsx308("path", {
              d: "M1863 1250.7c4.8.7 6 7.4 4.6 11.7-1.6 4.5-7.5 10.6-12.5 9.8-5.1-.8-6-8-4.2-12.6 1.6-4.2 7.3-9.7 12-9z"
            }),
            /* @__PURE__ */ jsx308("path", {
              d: "M1875.1 1265.3c4 2.3 3 9.6.4 13.6-2.7 4.1-9.8 8.6-14 6.2-4.2-2.5-2.7-10.3.2-14.4 2.8-3.8 9.5-7.6 13.4-5.4zm-86.1-39.9c4.3-.3 7.2 6 7.1 10.6 0 4.9-3.3 12.4-7.7 12.8-4.5.4-7.3-6.7-7-11.6.1-4.6 3.4-11.4 7.6-11.8z"
            }),
            /* @__PURE__ */ jsx308("path", {
              d: "M1803 1237.7c4 .9 5 7.8 3.5 12.2-1.6 4.6-7 10.8-11.3 9.8-4.4-1-5-8.6-3.2-13.2 1.6-4.3 6.8-9.8 11-8.9z"
            }),
            /* @__PURE__ */ jsx308("path", {
              d: "M1815.8 1246.2c5 1.2 6 9.8 4.2 15.3-1.8 5.7-8.2 13.4-13.4 12.2-5.2-1.3-5.8-10.7-3.7-16.5 1.9-5.3 8-12.1 12.9-11z"
            }),
            /* @__PURE__ */ jsx308("path", {
              d: "M1826.2 1256.8c5-.6 9 7 9.3 12.8.3 6-3 15.4-8.2 16-5.3.7-9.2-7.9-9.3-14-.1-5.6 3.3-14.2 8.2-14.8z"
            }),
            /* @__PURE__ */ jsx308("path", {
              id: "va_svg__g",
              d: "M1838.6 1265.7c4.5-.6 8.2 5.8 8.4 10.5.3 5-2.7 12.8-7.4 13.4-4.9.6-8.4-6.6-8.5-11.6 0-4.7 3-11.8 7.5-12.3z"
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__g",
              width: "100%",
              height: "100%",
              x: 12.8,
              y: 10.4
            }),
            /* @__PURE__ */ jsx308("path", {
              id: "va_svg__h",
              d: "M1929.3 1250.9c-3.3 2.8-9.7.3-12.6-2.9-3.1-3.3-5.3-10.5-1.8-13.5 3.4-3 10.2.2 13.2 3.6 2.7 3.3 4.4 10 1.2 12.8z"
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__h",
              width: "100%",
              height: "100%",
              x: -7,
              y: 12.8
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__h",
              width: "100%",
              height: "100%",
              x: -19.5,
              y: 23.5
            }),
            /* @__PURE__ */ jsx308("path", {
              d: "M1905.2 1281.2c-1.1 4.1-8 5.6-12.1 4.5-4.4-1-10.2-5.8-9-10.2 1.3-4.4 8.7-5.6 13-4.3 4.2 1.2 9.2 5.9 8 10z"
            }),
            /* @__PURE__ */ jsx308("path", {
              d: "M1887.2 1278.2c3.6 2.5 2.8 10.5.4 14.9-2.6 4.5-9 9.5-12.9 6.8-3.9-2.7-2.5-11.3.2-15.8 2.5-4.2 8.7-8.4 12.3-6z"
            }),
            /* @__PURE__ */ jsx308("path", {
              d: "M1869.6 1287.5c4 2.4 3 9.6.4 13.6-2.7 4.1-9.8 8.6-14 6.2-4.2-2.5-2.7-10.3.2-14.4 2.8-3.8 9.5-7.6 13.4-5.4z"
            }),
            /* @__PURE__ */ jsx308("path", {
              id: "va_svg__i",
              d: "M1831.3 1313c-3.4 3.1-.7 11.2 2.8 15.2 3.7 4.2 11.8 8.1 15.4 4.7 3.5-3.4.3-12-3.6-16.1-3.7-3.9-11.2-7-14.6-3.9z"
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: -7.3,
              y: 13.8
            }),
            /* @__PURE__ */ jsx308("path", {
              id: "va_svg__j",
              d: "M1820.8 1339.5c-4.3 1.8-4.8 10.2-3 15.3 1.8 5.3 7.9 11.9 12.5 10 4.6-1.8 4.7-11 2.6-16.3-2-4.9-7.8-10.7-12-9z"
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__j",
              width: "100%",
              height: "100%",
              x: -10.5,
              y: 14.9
            }),
            /* @__PURE__ */ jsx308("path", {
              id: "va_svg__k",
              d: "M1802.7 1371c-4.6 1-6.5 9.3-5.5 14.6 1 5.5 6 13 10.8 11.9 4.8-1.1 6.4-10.2 5.2-15.7-1.2-5.1-6-11.8-10.5-10.8z"
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__k",
              width: "100%",
              height: "100%",
              x: -10.1,
              y: 15.9
            }),
            /* @__PURE__ */ jsx308("path", {
              id: "va_svg__l",
              d: "M1784 1403.3c-4.6.2-8 8-8 13.3 0 5.6 3.5 13.9 8.4 13.7 5-.2 8.2-8.8 8-14.5-.2-5.3-3.7-12.7-8.3-12.5z"
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__l",
              width: "100%",
              height: "100%",
              x: -10.3,
              y: 19.2
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__l",
              width: "100%",
              height: "100%",
              x: -22.4,
              y: 37
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__l",
              width: "100%",
              height: "100%",
              x: -34.9,
              y: 52.3
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__l",
              width: "100%",
              height: "100%",
              x: -47.8,
              y: 66.5
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__l",
              width: "100%",
              height: "100%",
              x: -62,
              y: 78.1
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__l",
              width: "100%",
              height: "100%",
              x: -75.6,
              y: 90.6
            }),
            /* @__PURE__ */ jsx308("path", {
              d: "m1692.8 1500.2-5.3 20.6s3 7.3 6 7c5.5-.6 7-9 8-14.5 1-8.4-8.7-13.1-8.7-13.1zm324.4 13.1c1.6 6 15.3 11.3 15.3 11.3l-6.7-27.8c-5.7.2-9.5 12.4-8.6 16.4z"
            }),
            /* @__PURE__ */ jsx308("path", {
              d: "M2016 1491c-4.3-1.8-10.5 4-12.7 8.9-2.3 5.1-2.4 14 2.2 15.9 4.6 1.8 11-4.8 13.1-10 2-5 1.7-13.1-2.6-14.9z"
            }),
            /* @__PURE__ */ jsx308("path", {
              id: "va_svg__m",
              d: "M2000.8 1478.7c-4.7-.3-8.7 7.2-9.2 12.5-.5 5.6 2.2 14.1 7.1 14.4 5 .2 9-8 9.3-13.7.3-5.3-2.6-13-7.2-13.2z"
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__m",
              width: "100%",
              height: "100%",
              x: -13.4,
              y: -13.7
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__m",
              width: "100%",
              height: "100%",
              x: -25.9,
              y: -29.2
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__m",
              width: "100%",
              height: "100%",
              x: -38.7,
              y: -42.3
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__m",
              width: "100%",
              height: "100%",
              x: -49,
              y: -60.3
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__m",
              width: "100%",
              height: "100%",
              x: -60.3,
              y: -76.4
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__m",
              width: "100%",
              height: "100%",
              x: -70.6,
              y: -93.5
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__m",
              width: "100%",
              height: "100%",
              x: -79.8,
              y: -113.3
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__m",
              width: "100%",
              height: "100%",
              x: -89.8,
              y: -131.2
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__m",
              width: "100%",
              height: "100%",
              x: -98,
              y: -152.5
            }),
            /* @__PURE__ */ jsx308("path", {
              d: "M1883.8 1304.6s-1.6 26.6 8 28.3c6.1 1.1 10.9-14.9 10.9-14.9z"
            }),
            /* @__PURE__ */ jsx308("path", {
              id: "va_svg__n",
              d: "M1862 1610.8c-2.9 3.6 1 11.2 5 14.7 4.3 3.6 12.9 6.2 15.9 2.3 3-3.9-1.5-11.9-6-15.4-4-3.2-12-5.3-14.9-1.6z"
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__n",
              width: "100%",
              height: "100%",
              x: 18.3,
              y: -2.2
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__n",
              width: "100%",
              height: "100%",
              x: 36.8,
              y: -5.8
            }),
            /* @__PURE__ */ jsx308("path", {
              id: "va_svg__o",
              d: "M1916.2 1603.8c-2.3 4 2.6 11 7.1 13.8 4.8 3 13.7 4.3 16 0 2.5-4.4-3.2-11.6-8.1-14.4-4.6-2.6-12.8-3.4-15 .6z"
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__o",
              width: "100%",
              height: "100%",
              x: 20,
              y: -3.2
            }),
            /* @__PURE__ */ jsx308("path", {
              id: "va_svg__p",
              d: "M1953.5 1595.4c-2 4.3 3.6 10.7 8.4 13.1 5 2.5 14 3 16-1.5s-4.4-11.2-9.5-13.5c-4.8-2.2-13-2.3-15 2z"
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__p",
              width: "100%",
              height: "100%",
              x: 18.9,
              y: -5.6
            }),
            /* @__PURE__ */ jsx308("path", {
              id: "va_svg__q",
              d: "M1991.3 1583.9c-1.7 4.4 4.2 10.5 9.1 12.5 5.2 2.2 14.2 2.2 15.9-2.4 1.7-4.7-5-11-10.3-13-5-1.8-13.1-1.4-14.7 2.9z"
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__q",
              width: "100%",
              height: "100%",
              x: 19.2,
              y: -6.2
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__q",
              width: "100%",
              height: "100%",
              x: 37.7,
              y: -14
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__q",
              width: "100%",
              height: "100%",
              x: 57.5,
              y: -22.2
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__q",
              width: "100%",
              height: "100%",
              x: 77.5,
              y: -28.6
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__q",
              width: "100%",
              height: "100%",
              x: 79.9,
              y: -44.3
            }),
            /* @__PURE__ */ jsx308("path", {
              d: "M2066.7 1534.9s13.6 2 14.8-2.9c1.6-6.5-15.4-12.7-15.4-12.7z"
            }),
            /* @__PURE__ */ jsx308("path", {
              id: "va_svg__r",
              d: "M1701.6 1575.6c-4 2.5-3 10.9-.4 15.5 2.7 4.9 9.8 10.4 14 7.8 4.2-2.6 2.8-11.7-.2-16.5-2.7-4.5-9.4-9.2-13.4-6.8z"
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__r",
              width: "100%",
              height: "100%",
              x: 18.9,
              y: 7.8
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__r",
              width: "100%",
              height: "100%",
              x: 37,
              y: 10.6
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__r",
              width: "100%",
              height: "100%",
              x: 56.8,
              y: 15.5
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__r",
              width: "100%",
              height: "100%",
              x: 74.7,
              y: 18.1
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__r",
              width: "100%",
              height: "100%",
              x: 92.3,
              y: 21.7
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__r",
              width: "100%",
              height: "100%",
              x: 110.4,
              y: 26.7
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__r",
              width: "100%",
              height: "100%",
              x: 128.3,
              y: 29.9
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__r",
              width: "100%",
              height: "100%",
              x: 146.6,
              y: 32.7
            }),
            /* @__PURE__ */ jsx308("path", {
              d: "M1648.2 1517.5c-4.2-2.1-11 3-13.6 7.6-2.7 5-3.8 13.8.6 16 4.4 2.3 11.5-3.6 14-8.6 2.5-4.7 3-12.9-1-15z"
            }),
            /* @__PURE__ */ jsx308("path", {
              d: "M1642 1534.4c-4.4-1.6-10.4 4.4-12.4 9.4-2 5.2-2 14.1 2.7 15.8 4.7 1.6 10.9-5.2 12.8-10.5 1.8-5 1.3-13.1-3-14.7z"
            }),
            /* @__PURE__ */ jsx308("path", {
              d: "M1647.7 1550c-4.5-1.2-10 5.3-11.5 10.4-1.6 5.4-.6 14.3 4.2 15.5 4.8 1.2 10.3-6.1 11.8-11.6 1.3-5.1 0-13.2-4.5-14.4z"
            }),
            /* @__PURE__ */ jsx308("path", {
              d: "M1662.4 1556.3c-4.5-1.3-10.2 5-11.9 10-1.7 5.4-1 14.3 3.7 15.7 4.7 1.4 10.5-5.8 12.1-11.2 1.5-5 .5-13.2-4-14.5z"
            }),
            /* @__PURE__ */ jsx308("path", {
              id: "va_svg__s",
              d: "M1672 1558.8c-4.6 1.1-6.3 9.4-5.2 14.7 1.1 5.5 6.2 12.8 11 11.6 4.8-1.2 6.2-10.3 4.8-15.8-1.2-5-6.2-11.6-10.7-10.5z"
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__s",
              width: "100%",
              height: "100%",
              x: 16.8,
              y: 6.2
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 8.6,
              y: -11.2
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 4.7,
              y: 6.5
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 4.9,
              y: 26.7
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 4.7,
              y: 47.9
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 5.6,
              y: 68.6
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 2.2,
              y: 87.7
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 4.7,
              y: 109.1
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 2.2,
              y: 126.4
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 4.7,
              y: 143.5
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 4.7,
              y: 163.9
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 3.4,
              y: 183.9
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 3.7,
              y: 203.1
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 4.4,
              y: 223.5
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 4.4,
              y: 243.3
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 3.7,
              y: 263.1
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 2.5,
              y: 283.2
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 2.5,
              y: 305.1
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 1.9,
              y: 327.9
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 1.9,
              y: 349.3
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 1.9,
              y: 369
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__i",
              width: "100%",
              height: "100%",
              x: 1.3,
              y: 391.3
            }),
            /* @__PURE__ */ jsx308("path", {
              id: "va_svg__t",
              d: "M1882.2 1303.2c2.5 3.7-1.3 10.8-5.1 14-4 3.2-12 5.4-14.5 1.5-2.6-4 1.9-11.4 6-14.6 4-3 11.2-4.6 13.6-1z"
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__t",
              width: "100%",
              height: "100%",
              x: 2.7,
              y: 16.1
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__t",
              width: "100%",
              height: "100%",
              x: 2.4,
              y: 34.1
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__t",
              width: "100%",
              height: "100%",
              x: 2.1,
              y: 52.4
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__t",
              width: "100%",
              height: "100%",
              x: 1.8,
              y: 69.1
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__t",
              width: "100%",
              height: "100%",
              x: 2.7,
              y: 87.1
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__t",
              width: "100%",
              height: "100%",
              x: 1.5,
              y: 104.4
            }),
            /* @__PURE__ */ jsx308("path", {
              d: "M1883.3 1426c2.6 3.9-1.5 11.3-5.7 14.5-4.5 3.4-13.2 5.7-16 1.6-2.9-4 2-11.8 6.6-15 4.4-3.1 12.4-4.8 15-1z"
            }),
            /* @__PURE__ */ jsx308("path", {
              id: "va_svg__u",
              d: "M1882 1443.6c3.5 3.2.8 11.3-2.7 15.3-3.7 4.2-11.8 8-15.3 4.7-3.6-3.5-.3-12 3.6-16.2 3.6-3.8 11.1-7 14.5-3.8z"
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__u",
              width: "100%",
              height: "100%",
              x: 0.6,
              y: 20.4
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__u",
              width: "100%",
              height: "100%",
              x: 0.9,
              y: 40.5
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__u",
              width: "100%",
              height: "100%",
              x: 0.3,
              y: 62.1
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__u",
              width: "100%",
              height: "100%",
              x: 0.9,
              y: 82.2
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__u",
              width: "100%",
              height: "100%",
              x: 0.3,
              y: 102.6
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__u",
              width: "100%",
              height: "100%",
              x: 0.6,
              y: 123
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__u",
              width: "100%",
              height: "100%",
              x: 0.6,
              y: 143.7
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__u",
              width: "100%",
              height: "100%",
              x: -0.3,
              y: 164.4
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__u",
              width: "100%",
              height: "100%",
              x: 0.9,
              y: 183.3
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__u",
              width: "100%",
              height: "100%",
              x: 0.9,
              y: 203.1
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__u",
              width: "100%",
              height: "100%",
              x: 0.3,
              y: 224.4
            }),
            /* @__PURE__ */ jsx308("use", {
              xlinkHref: "#va_svg__u",
              width: "100%",
              height: "100%",
              x: 0.3,
              y: 245.4
            })
          ]
        }),
        /* @__PURE__ */ jsxs283("g", {
          transform: "translate(123) scale(.192)",
          children: [
            /* @__PURE__ */ jsx308("path", {
              fill: "#fa0204",
              d: "M1849.6 1848.3a77 77 0 0 0 48.3.4l-17.5-28"
            }),
            /* @__PURE__ */ jsx308("path", {
              fill: "#ce9d09",
              d: "m1888.3 1776.2-31.7-8.2s.4-35.2 20.4-32.1c16.6 2.5 12 40.3 11.3 40.3z"
            }),
            /* @__PURE__ */ jsx308("circle", {
              cx: 1872.9,
              cy: 1723,
              r: 12.9,
              fill: "#ce9d09"
            }),
            /* @__PURE__ */ jsx308("path", {
              fill: "#fa0204",
              d: "M1885.4 1791.9c7 17.8 11.3 33.2 4.7 53.3m7.6 3.5c-10.2-8.3-36.6-5.9-48-.4-4.4 0-16.4-83.2 25.7-81.2 38.8 2 25 82 22.3 81.6z"
            })
          ]
        }),
        /* @__PURE__ */ jsxs283("g", {
          transform: "translate(123) scale(.192)",
          children: [
            /* @__PURE__ */ jsx308("path", {
              fill: "#fa0204",
              d: "M1815.2 1866.3a47 47 0 0 0 54.2.5l-40.2-42"
            }),
            /* @__PURE__ */ jsx308("circle", {
              cx: 1843.4,
              cy: 1738.3,
              r: 12.9,
              fill: "#ce9d09"
            }),
            /* @__PURE__ */ jsx308("path", {
              fill: "#ce9d09",
              d: "m1859.3 1780-32.7-.6s-4.2-26.6 16.2-27.8c16.9-1 17.2 28.4 16.5 28.4z"
            }),
            /* @__PURE__ */ jsx308("path", {
              fill: "#fa0204",
              d: "M1843.6 1860.7c-6.3-13.9-6.9-31-5.2-49.5m-9.4 50.4c-7.7-13.2-9.1-30-3-51.2m43.4 56.6c-5-6.2-40.3-8.8-54.1-.4-5 0-18.6-93.8 29-91.5 43.6 2.1 28 92.3 25 91.9z"
            })
          ]
        })
      ]
    })
  ]
});
var Va_default = SvgVa;

// src/country-flag-icons/generated/Vc.tsx
init_esm_shims();
import { jsx as jsx309, jsxs as jsxs284 } from "react/jsx-runtime";
var SvgVc = (props) => /* @__PURE__ */ jsx309("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs284("g", {
    fillRule: "evenodd",
    children: [
      /* @__PURE__ */ jsx309("path", {
        fill: "#f4f100",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsx309("path", {
        fill: "#199a00",
        d: "M490 0h150v480H490z"
      }),
      /* @__PURE__ */ jsx309("path", {
        fill: "#0058aa",
        d: "M0 0h150v480H0z"
      }),
      /* @__PURE__ */ jsx309("path", {
        fill: "#199a00",
        d: "m259.3 130-46.4 71.3 44.7 74.4 43.8-73.7zm121.2 0-46.3 71.3 44.7 74.4 43.8-73.7zm-61.2 97.3-46.4 71.4 44.8 74.4 43.8-73.7-42.2-72z"
      })
    ]
  })
});
var Vc_default = SvgVc;

// src/country-flag-icons/generated/Ve.tsx
init_esm_shims();
import { jsx as jsx310, jsxs as jsxs285 } from "react/jsx-runtime";
var SvgVe = (props) => /* @__PURE__ */ jsxs285("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx310("defs", {
      children: /* @__PURE__ */ jsxs285("g", {
        id: "ve_svg__d",
        transform: "translate(0 -36)",
        children: [
          /* @__PURE__ */ jsxs285("g", {
            id: "ve_svg__c",
            children: [
              /* @__PURE__ */ jsxs285("g", {
                id: "ve_svg__b",
                children: [
                  /* @__PURE__ */ jsx310("path", {
                    id: "ve_svg__a",
                    fill: "#fff",
                    d: "M0-5-1.5-.2l2.8.9z"
                  }),
                  /* @__PURE__ */ jsx310("use", {
                    xlinkHref: "#ve_svg__a",
                    width: 180,
                    height: 120,
                    transform: "scale(-1 1)"
                  })
                ]
              }),
              /* @__PURE__ */ jsx310("use", {
                xlinkHref: "#ve_svg__b",
                width: 180,
                height: 120,
                transform: "rotate(72)"
              })
            ]
          }),
          /* @__PURE__ */ jsx310("use", {
            xlinkHref: "#ve_svg__b",
            width: 180,
            height: 120,
            transform: "rotate(-72)"
          }),
          /* @__PURE__ */ jsx310("use", {
            xlinkHref: "#ve_svg__c",
            width: 180,
            height: 120,
            transform: "rotate(144)"
          })
        ]
      })
    }),
    /* @__PURE__ */ jsx310("path", {
      fill: "#cf142b",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx310("path", {
      fill: "#00247d",
      d: "M0 0h640v320H0z"
    }),
    /* @__PURE__ */ jsx310("path", {
      fill: "#fc0",
      d: "M0 0h640v160H0z"
    }),
    /* @__PURE__ */ jsxs285("g", {
      id: "ve_svg__f",
      transform: "matrix(4 0 0 4 320 336)",
      children: [
        /* @__PURE__ */ jsxs285("g", {
          id: "ve_svg__e",
          children: [
            /* @__PURE__ */ jsx310("use", {
              xlinkHref: "#ve_svg__d",
              width: 180,
              height: 120,
              transform: "rotate(10)"
            }),
            /* @__PURE__ */ jsx310("use", {
              xlinkHref: "#ve_svg__d",
              width: 180,
              height: 120,
              transform: "rotate(30)"
            })
          ]
        }),
        /* @__PURE__ */ jsx310("use", {
          xlinkHref: "#ve_svg__e",
          width: 180,
          height: 120,
          transform: "rotate(40)"
        })
      ]
    }),
    /* @__PURE__ */ jsx310("use", {
      xlinkHref: "#ve_svg__f",
      width: 180,
      height: 120,
      transform: "rotate(-80 320 336)"
    })
  ]
});
var Ve_default = SvgVe;

// src/country-flag-icons/generated/Vg.tsx
init_esm_shims();
import { jsx as jsx311, jsxs as jsxs286 } from "react/jsx-runtime";
var SvgVg = (props) => /* @__PURE__ */ jsxs286("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx311("defs", {
      children: /* @__PURE__ */ jsxs286("linearGradient", {
        id: "vg_svg__a",
        x1: 103.1,
        x2: 92.6,
        y1: 111.3,
        y2: 107.8,
        gradientTransform: "matrix(.99614 0 0 2.25255 703.8 -75)",
        gradientUnits: "userSpaceOnUse",
        children: [
          /* @__PURE__ */ jsx311("stop", {
            offset: 0,
            stopColor: "red"
          }),
          /* @__PURE__ */ jsx311("stop", {
            offset: 1,
            stopColor: "#ff0"
          })
        ]
      })
    }),
    /* @__PURE__ */ jsx311("path", {
      fill: "#006",
      d: "M0 0h640v480H0Z"
    }),
    /* @__PURE__ */ jsx311("path", {
      fill: "#012169",
      d: "M0 0h320v240H0Z"
    }),
    /* @__PURE__ */ jsx311("path", {
      fill: "#fff",
      d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0Z"
    }),
    /* @__PURE__ */ jsx311("path", {
      fill: "#c8102e",
      d: "M212 140.5 320 220v20l-135.5-99.5Zm-92 10 3 17.5-96 72H0ZM320 0v1.5l-124.5 94 1-22L295 0ZM0 0l119.5 88h-30L0 21Z"
    }),
    /* @__PURE__ */ jsx311("path", {
      fill: "#fff",
      d: "M120.5 0v240h80V0ZM0 80v80h320V80Z"
    }),
    /* @__PURE__ */ jsx311("path", {
      fill: "#c8102e",
      d: "M0 96.5v48h320v-48zM136.5 0v240h48V0Z"
    }),
    /* @__PURE__ */ jsxs286("g", {
      transform: "translate(-217.5 -9.4) scale(.77497)",
      children: [
        /* @__PURE__ */ jsx311("path", {
          fill: "#fff",
          d: "m776.3 144 250.4-.9-.5 223s8.8 34-105 85.5c40.9-4.2 85.5-47.8 85.5-47.8s18.1-23.3 27-10.3c8.8 13 17.1 19.6 23.6 24.7 6.5 5 11.6 19 1.9 29.2-9.8 10.3-25.1 11.6-29.3-.9-6.5 3.3-46.4 51.6-128.2 53.9C818.5 499 773 446 773 446s-11.1 17.7-27 3.8c-15.3-18.2-3.7-29.8-3.7-29.8s13-7.4 16.8-12.5c6-7 7.9-16.3 18-16.3 12.2 1 16.8 10.7 16.8 10.7s41.8 44.1 86.9 49.7c-101.7-48.8-105.5-79-105-86.4z"
        }),
        /* @__PURE__ */ jsx311("path", {
          fill: "#006129",
          stroke: "#000",
          strokeWidth: 1.9,
          d: "m782.3 150.1 238.8-1.4v214.6c.5 28-46.5 56.3-119.9 92.5-75.7-39-119.4-62.7-119.8-93z"
        }),
        /* @__PURE__ */ jsxs286("g", {
          id: "vg_svg__b",
          fill: "#ffc72c",
          stroke: "#000",
          strokeWidth: 0.9,
          children: [
            /* @__PURE__ */ jsx311("path", {
              fill: "none",
              stroke: "#ffc72c",
              strokeWidth: 1.9,
              d: "m814.8 181.8 14-20.7 14.3 20.8"
            }),
            /* @__PURE__ */ jsx311("path", {
              d: "M831.7 174a2.8 2.8 0 1 1-5.6 0 2.8 2.8 0 0 1 5.6 0z"
            }),
            /* @__PURE__ */ jsx311("path", {
              d: "M817.4 197.1h21.9s.3-2.8-2.3-4.5c11.5-1.6 8.5-11.6 18-12.2 2 .3-5 4.3-5 4.3s-5.7 4-3 6.1c2 1.7 3-1 3.2-3 .3-2 9.3-3.3 8-9-2.1-4.7-14.7 3.2-14.7 3.2l-9-.1c-.6-1-3-5-5.6-5-3 0-5.2 5-5.2 5h-20.3s-.7 5.3 9.6 6.3c2.3 3 4.1 3.8 6.2 4.6-1.4 1.1-1.8 2.5-1.8 4.3zm1.6-4.4h18.2"
            }),
            /* @__PURE__ */ jsx311("path", {
              d: "M810.7 182s1.4 8.5 8.2 10.5"
            }),
            /* @__PURE__ */ jsx311("path", {
              fill: "url(#vg_svg__a)",
              d: "M809.6 181.8c.6-3.2 1.9-3.8 3.2-8 .2-4-3.2-3.5-2.2-6 1.8-2.9.9-5.6-2.5-7.7.7 3.7-4.4 7.2-4.4 10.2 0 3 2.6 2.4 2.3 7 .2 2.6-.7 2-1 4.5z"
            }),
            /* @__PURE__ */ jsx311("path", {
              d: "M831.5 161.7a2.6 2.6 0 1 1-5.2 0 2.6 2.6 0 0 1 5.2 0z"
            })
          ]
        }),
        /* @__PURE__ */ jsx311("use", {
          xlinkHref: "#vg_svg__b",
          width: "100%",
          height: "100%",
          x: -0.8,
          y: 41.3
        }),
        /* @__PURE__ */ jsx311("use", {
          xlinkHref: "#vg_svg__b",
          width: "100%",
          height: "100%",
          x: -1.1,
          y: 82
        }),
        /* @__PURE__ */ jsx311("use", {
          xlinkHref: "#vg_svg__b",
          width: "100%",
          height: "100%",
          x: 25.6,
          y: 126.1
        }),
        /* @__PURE__ */ jsx311("use", {
          xlinkHref: "#vg_svg__b",
          width: "100%",
          height: "100%",
          x: -4.6,
          y: 162.2
        }),
        /* @__PURE__ */ jsx311("use", {
          xlinkHref: "#vg_svg__b",
          width: "100%",
          height: "100%",
          x: -3.8,
          y: 204.8
        }),
        /* @__PURE__ */ jsx311("use", {
          xlinkHref: "#vg_svg__b",
          width: "100%",
          height: "100%",
          x: 146.3,
          y: 0.7
        }),
        /* @__PURE__ */ jsx311("use", {
          xlinkHref: "#vg_svg__b",
          width: "100%",
          height: "100%",
          x: 144.9,
          y: 41.2
        }),
        /* @__PURE__ */ jsx311("use", {
          xlinkHref: "#vg_svg__b",
          width: "100%",
          height: "100%",
          x: 143.1,
          y: 82.7
        }),
        /* @__PURE__ */ jsx311("use", {
          xlinkHref: "#vg_svg__b",
          width: "100%",
          height: "100%",
          x: 145.2,
          y: 123.4
        }),
        /* @__PURE__ */ jsx311("use", {
          xlinkHref: "#vg_svg__b",
          width: "100%",
          height: "100%",
          x: 144.7,
          y: 164.2
        }),
        /* @__PURE__ */ jsx311("use", {
          xlinkHref: "#vg_svg__b",
          width: "100%",
          height: "100%",
          x: 144.9,
          y: 205.2
        }),
        /* @__PURE__ */ jsxs286("g", {
          fill: "#ffc6b5",
          stroke: "#000",
          strokeWidth: 0.9,
          children: [
            /* @__PURE__ */ jsx311("path", {
              fill: "#ffc72c",
              d: "M915.8 406.3s5.7 13.2 12.2 5c6.5-8 4.2-11.5 4.2-11.5l-14.6-7.9-4.3 9z"
            }),
            /* @__PURE__ */ jsx311("path", {
              d: "M928.4 404.6s1 .1 1.7-1.3c.8-1.4-1.7-2-2.9-3.6l-1.2 2.5zm-33-3.6-12.8 7s-6.4 1.3-6.8 0c-.5-1.2.1-2.3 3.5-2.5 3.3-.1 12.3-8.4 12.3-8.4l3.8 4zm.2-227.9.4 4.6c.2 1.6-2.5 5-2.6 4.8-.2-.2-1.5.2-1.3 1.1.1 1 2 1.3 2 1.3s-.7 3.3 0 3.5c.8.1-2 4.2 0 5.3 2.1 1.1 5.6 2.6 7.2 2.3 1.6-.4 0 6.1 0 6.1l-4.5 9.5 24.4-2.5-5-8s-2.4-1.7-1.8-6.3c.7-4.5-.3-25.3-.3-25.3l-17.4-2.4zm-4.5 36.2s-7.9 3.6-7.6 13.4c-2 9.5-3.1 19-3.1 19s-9.4 10.6-12.2 14.5c-2.9 3.8-7.2 11.5-8.7 13.6-1.6 2-7.8 8.8-7.7 11.4.2 2.5-1.4 13.8 4.8 15 1.6.7 6.7-13 6.7-13s.3-5.8-1.5-7c-1.7-1 3.8-4.8 3.8-4.8l13-9.7c2.4-2 8.9-9.2 8.9-9.2z"
            }),
            /* @__PURE__ */ jsx311("path", {
              fill: "#fff",
              d: "M900.2 201.8s2 5.6 6.6 4.6 10-5.2 10-5.2 4.3-.2 4.9.5c.6.6 11.6 11.2 11.2 14.5-.3 3.4-5 2.4-6.8 4.6-1.7 2.2-4.6 7.8-3.8 12 .8 4 3.2 9.4 2.9 11.5-.3 2-2 2.7-2 3.8 0 1 1.4 3 1.4 5 0 2.1-2 5.1-1.6 7.2.3 2 .4 8 .4 8l-.4 28s1.6.9 1.7 2.5c.2 1.5 10.8 47.6 10.8 47.6s-.5 1.5-1.6 1.3c-1.1-.2 4.3 7.1 4.4 9.2.2 2 5.6 18.2 5.4 20.4-.1 2.2-1 7.2-1.4 7.3-.5.2 3.5 10.2 2.8 11.7-.6 1.6-7 1.5-7 1.5l-1.8-.4s.1 2.1-1.1 2.3c-1.3.1-10.6-.5-10.6-.5s-2.7 4.1-4.3 4c-1.6-.2-3.7-3-4.1-2.6-.5.5 1.4 3.2 1 4-.6.8-8.6 2.5-10.2-1.3-1.6-3.8 1-2.8.4-3.6-.4-.8-4-2.9-5.2-2.3-1 .7 2.9 1.6 2.7 3.2-.1 1.6-3.5 4-4.7 4-1.3 0-4.3-5.9-8.8-5.3-4.4.7-7.2 1.8-7.2 1.8s-5.3 2.2-7.5 1.7c-2.2-.4-3.2-2.2-3.2-3.1 0-1 1.6-5.1 1.5-6.4-.2-1.2-1.5-2.5-1.5-4.4 0-2 3.7-8.4 3.7-8.4l-.2-29.2s-3.3 0-3.5-2c-.1-2 5.1-46.1 6-49l2.8-13s-2.4 1.2-2.6 0c-.1-1 7.2-26.2 7.2-26.2s1.2-12.6 1.2-15.9c0-3.3-.6-7.9-.6-7.9s-6.5-2.8-6.7-7c-.6-6.7 6.2-10.4 7-12.6l3.2-9s3.5-6 9.2-6.9z"
            }),
            /* @__PURE__ */ jsx311("path", {
              fill: "#ffc72c",
              d: "M897.8 403s-15.4 8-17.6 8.7c-2.2.6-3.6-2.7-1.4-3.3 2.2-.7 5.7-1 5.7-1s-5.2-4.1-5-4.3l7.2-2.6c.2 0 2.2 4 3.6 3.8a31 31 0 0 0 5.6-3.5z"
            }),
            /* @__PURE__ */ jsx311("path", {
              d: "M919.4 407.4c1.5 1.9 2 5.1 5.4 3.2 3.3-1.9-1.7-5.4-1.7-5.4z"
            }),
            /* @__PURE__ */ jsx311("path", {
              d: "M925.5 407.1s1.6 1.3 3-.2c1.4-1.4-2.8-4.4-2.8-4.4l-2.1 2.4zm6.8-190.1c.2 0 5.2 15.6 5.9 19.6.6 4 2.7 19.8 1.9 22-.8 2.2-8.9 12.8-9.8 15.5-1 2.7-6.7 13-6.7 13s-1.4 10.2-2 10.6c-.7.5 1.6 3 1.4 3.8-.3 1-4.6 5.4-6.5 5-2-.5-5-2.7-5-4.8-.3-2 0-8.9 1.5-10.6 1.4-1.8 8.9-19.3 9.3-20.4.5-1.2 6.8-15 7-17.3.2-2.4-2-7.9-4.2-9.9-5-14.7-3-23.5 7.2-26.5z"
            }),
            /* @__PURE__ */ jsx311("path", {
              fill: "#9c5100",
              d: "M895 172.2s3.6.5 5.5-.6 4.1-1.6 5.7.6c1.6 2.2 2.7 2 2.7 2s-2.4 6 0 6.6c2.3.6 3.5.6 3.6 1.4.2.8-2 2.5-1.4 3.3.6.8 1.7 1.7 1.9 2.4.1.6-1.4 3.3-1 4 .5.6 2 3.1 2.9 3.1 1 0 .3 4 3.2 3 2.8-1 2.7-3.5 2.7-3.5s3-.4 3.8-3.1c.7-2.7 2.6-3.4 2.6-3.4s3.8-2-1.2-5.2c0-22.2-14.6-19.8-14.6-19.8s-1.7-4-4.6-3.5c-2.8.5-3 3.8-5 3.5-2.1-.3-2.6-1.7-2.7-1.6-.2.2-2 3.4-2 4.1 0 .8-5.5-1-5 3 .5 4.2 3.2 4 3 3.7z"
            }),
            /* @__PURE__ */ jsxs286("g", {
              fill: "none",
              children: [
                /* @__PURE__ */ jsx311("path", {
                  d: "M920.8 208s-14.1 9-13.8 12.2m17-10.6s-3.2 3.5-3.4 3.5m7.6.3s-7 5.7-5.9 9.3m-27-15.5s-2.1 4.3-1.6 5.7c.4 1.4 4 6.8 4.4 10.1.5 3.4 0 5.7 0 5.7m-6.5-13.6s.6 5 1.6 6 3.5 5.3 3.8 7m-6.7 8.1s4.2 2 8-5.9m6.1-5.5c-.1 0-3 7.7 2.1 10.6 5 2.9 8.9 2.5 11 1.7 2.3-.7 4.7-2.2 4.7-2.2m-20-.6s.3 10.4 15.7 20.7m-15-10.9s-.2 9.2 5.8 13.3m-9-24.1s-4.6 13.7-8.3 15m6.9-5s-.2 9.8-1.5 13.3m-1.2 2.4s3.1 4 6.6 3.6c3.5-.3 5-4.4 7.3-3.8 2.4.7 4.6 2.6 10.1 2.1m-7.9 4.1s0 8.1 1.5 8.9c1.4.8.7 8.2.7 8.2m-21.5-20.9s-.2 7.6-1.1 10.3c-1 2.7-2.9 7.3-2.5 11.3m-6.1 4.4c.8-.3 3.5-2.7 3.5-2.7m1.4 1.7s-6.8 29.2-4.9 46.6m6.5-45.1s-3.5 21.8-1.9 26m.2-26.7 13.3 1m1.9-1.8s3.6 2 8.7 1.6m-10.3 9.1s-.6 37.3-1.6 45.6m21.1-37.1s4.1 32.8 6.5 35.8m-14.4-31.7s2.5 29 4 31.6m-40 10.1s5-1.6 9.4-6.3c5 6.8 12.8.3 12.8.3s12 8.2 17.4-1c8.3 5.4 12.4-.8 12.4-.8s3 4.6 5.2 4.1m-13.1 3.2s6.1 29 15.3 37.2"
                }),
                /* @__PURE__ */ jsx311("path", {
                  d: "M889 347.7s.7 24.2 2.1 41.3m-3.3-13.9s-.8 15.8-1.7 17m-7.6 1.5s1.7 6.9 10.4.5c8.7-6.3 8.9 2.4 9.2 3.3.3 1 1.7 7.8 5 2.1m7-9.3s-1.4 14 11.1 3.8c12.5-10.3 14.6-.2 15 3m-25.9-230.2s-1.1 7 6.3 6.3c-1 3.9 2 5.1 2 5.1m5.4 4.3c.2 0 3.4 2 0 4.6m-10.7.9s1.6 2 3.3 1.5c1.8-.5 4.6 1.7 4.6 1.7s2.4.8 2.7.3m-20.3 2.5s5.4 2.1 9-6.4m-18.9-2.6 3.1.2M858.5 285l.3 6.9m-6.8-7.5s4.5 7.5 4 11.4"
                }),
                /* @__PURE__ */ jsx311("path", {
                  strokeLinejoin: "round",
                  d: "M894.1 188.2h2.9l-2.5 1.1M911.7 300s3.3-.4 3.2 5.2c2.1-7 6.4-7.1 6.4-7.1"
                }),
                /* @__PURE__ */ jsx311("path", {
                  strokeLinejoin: "round",
                  strokeWidth: 1.7,
                  d: "M898.1 179.3c.5 0 2.2-.6 2.5-.1.4.4-1.9.8-2.5.1z"
                })
              ]
            })
          ]
        }),
        /* @__PURE__ */ jsxs286("g", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 1.9,
          children: [
            /* @__PURE__ */ jsx311("path", {
              fill: "#ffc72c",
              d: "M900.3 458.6a160.4 160.4 0 0 0 109.6-50.7c-.4-.4 8.9-13.4 16.3-11.6 7.4 1.9 18.1 23.7 31.1 28.4 6.5 10.2-1.8 19.5-4.6 21.3-2.8 1.9-15.4 7-17.2-.4-1.9-7.5-5.6-6-5.6-6s-59.5 58-128.2 55.7c-71 .4-129.6-55.8-129.6-55.8l-5.1 5.6s-5.6 6-8.4 5.6c-2.8-.5-14.9-8.4-15.8-16.3-1-7.9 7.4-13 7.4-13s20.5-15.8 22.8-24.1c4.7-4.7 13.5 3.2 13.5 3.2s53.9 61.8 113.8 58z"
            }),
            /* @__PURE__ */ jsx311("path", {
              d: "M748.9 422.6s5.5-1.4 7.5.9 16 16 16 16"
            }),
            /* @__PURE__ */ jsx311("path", {
              d: "m761.5 429.1-5.6 4.1s14 2.8 10.8 12m285.6-23s-2.7-1.5-7 1.7c-4.4 3.3-15.3 15.5-15.3 15.5"
            }),
            /* @__PURE__ */ jsx311("path", {
              d: "m1039.9 428.7 6 4.6s-12.5.9-9.8 12.7"
            })
          ]
        }),
        /* @__PURE__ */ jsx311("path", {
          d: "M819.7 437.4c-.4 1-1.4 0-2.2.2-2 0-3.8 1.4-5.6 2.4l-18.4 10.7c-.6-.2-.5-.7-.3-1.2l5-23c.2-1.3.6-3-.7-4-.5-.4.3-1.1.7-.4l9.4 6.7c-.3.9-.9.2-1.4-.1-1.3-1.3-2.9-.1-2.8 1.5l-3.4 15.1c4.2-2.4 8.4-4.8 12.6-7.4 1.4-.6 2.5-2.6 1-3.8-.6-.4-1.6-1.3-.6-1.5zm6.6 32c-.2.6-.5.7-1 .3l-11-6c.1-.7.4-.8.9-.4 1 .7 2.6 1 3.4-.2l4-7.3 5.6-10.2c.8-1.3-.1-2.8-1.3-3.3-.4-.2-1-.4-.5-.8.2-.3.8.3 1.1.4l10.6 5.8c-.1.6-.4.7-.9.3-1-.7-2.6-1-3.4.2l-4 7.3-5.6 10.2c-.8 1.2.1 2.8 1.3 3.3zm42.6-10-3 8.4c-1.3-.1-.4-1.7-.8-2.5a9.5 9.5 0 0 0-7-8.2c-3-.8-6 .7-7.8 3.1a22.9 22.9 0 0 0-4.4 12.2 7 7 0 0 0 3.2 6.4 10 10 0 0 0 5.9 1.5l2.1-6.3c.3-1.4-1.2-2.3-2.3-2.6-.2-.4.2-1 .7-.5l11 4c0 1.3-1.6-.2-2.5.4-1.3.5-1.4 2.1-2 3.3l-1.3 3.8c-5 .3-10-.7-14.4-3.2-4.1-2.6-7-7.7-6.1-12.7.6-4.3 3.3-8.3 7.2-10.2 3.6-2 8-1.9 11.8-.4 2 .7 3.8 2 5.4 3.4 1 1.3 2.8 1.3 3.6-.1zm17.9 28.8c0 .4 0 .9-.6.6l-12.6-1.9c0-.5 0-.9.6-.6 1 .2 2.6.2 3-1 .6-1.7.7-3.5 1-5.2l2.2-14.6c.3-1 0-2.2-1.1-2.6-.7-.3-1.3-.3-2-.5 0-.4 0-.8.6-.6l12.6 2c0 .4 0 .8-.6.6-1-.3-2.5-.2-3 1-.6 1.6-.7 3.4-1 5.1l-2.2 14.6c-.3 1 0 2.3 1.2 2.7l2 .4zM921 480l-.5 8.9-22.6 1.1c-.1-.5 0-.8.6-.7 1.1 0 2.6-.5 2.8-1.8l-.3-6.6-.7-13.4c.1-1.3-1-2.3-2.3-2.2-.4-.2-1.5.4-1.4-.3-.2-.6.7-.3 1-.4l12.6-.7c0 .6 0 .9-.7.8-1.1 0-2.6.2-3 1.6-.1 1.9.1 3.8.2 5.7l.7 14c0 1.1 1 2.2 2.2 2 1.8-.1 3.7 0 5.5-.5 2.5-.7 3.8-3.2 4.5-5.5.5-.6 0-2.2 1-2zm17.5-21.8c-.6 0-.3.8-.5 1.2-1 7.5-1.9 15-3 22.4-.2 1.7-.6 3.6-2.2 4.4-.6.3-.1 1.2.5.7l7.5-2.3c-.1-1.2-1.6 0-2.4-.3-1.7 0-2-2.1-1.7-3.4 0-1 .2-1.8.3-2.7l8.6-2.6c1.1 1.4 2.3 2.7 3.3 4.2.8 1.4-1 2-2 2.3-.6 0-.2 1 .3.6l11.3-3.4c0-1.3-1.6 0-2.3-1-2.2-1.5-3.7-3.7-5.4-5.7zm0 9 6 7.3-7.3 2.2zm38.6-25.8 3.3 6c-1 1-1.6-1.1-2.5-1.4a4.7 4.7 0 0 0-5.5-.5l-2 1.1 9.8 18.3c.5 1.5 2.4 1.8 3.7 1 .4-.4.9-.6 1 .1-1.6 1-3.5 1.9-5.2 2.8l-6.5 3.5c-.5-.5-.2-.8.4-1a2.4 2.4 0 0 0 1.1-3.7l-9.7-18c-1.8 1-4 1.8-4.5 4-.5 1.5.2 3.2.2 4.4-.5.6-.7-.2-1-.6l-2.7-5.2zm15.3-9.1 6.2 8.3c1.4-1 2.6-2.6 2.2-4.4.2-1.4-1.8-3-1.1-4 .4-.2.7.8 1 1.1l7.2 9.5c-1 1-1.6-1.1-2.6-1.4-1.4-1-3.3-1.5-4.8-.4-1.1.4-1 1-.3 1.7 1.6 2.1 3.2 4.4 5 6.5 1 1 2.4 0 3.3-.8 2.4-1.6 4.5-4.2 4.4-7.2.2-1.4-.7-2.8-.7-4 .6-.7.7.4 1 .8l3.4 6-17.6 13.3c-.7-.5 0-.9.5-1.2 1.6-1 1.1-3.1 0-4.2L988.1 437c-1-1.3-2.8-.6-3.7.3-.5.6-1-.5-.3-.6l16.5-12.5 4.5 6c-1 1-2-1.3-3.1-1.4-2.2-1.2-4.8-.3-6.6 1.2l-3.1 2.3"
        })
      ]
    })
  ]
});
var Vg_default = SvgVg;

// src/country-flag-icons/generated/Vi.tsx
init_esm_shims();
import { jsx as jsx312, jsxs as jsxs287 } from "react/jsx-runtime";
var SvgVi = (props) => /* @__PURE__ */ jsxs287("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx312("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx312("path", {
      fill: "#369443",
      stroke: "#010002",
      strokeMiterlimit: 10,
      strokeWidth: 1.5,
      d: "M204.3 315s-.5-3.6 6.2-6.1c6.6-2.6 7.2-12.2 5.8-18.6 0 0-3.4 6-7.7 8.1 0 0-6.8 3.6-7.2 10.4 0 0 0 2.5-.5 4.5-.3 1-3.4-8.6 2.4-15.8 6-7.3 7.6-13.3 2.9-25 0 0-.5 7-5.1 11.1-4.7 4-5.3 4.4-5.2 14 0 0 0 3.4-1.7 4.5 0 0-3.6-5.3-4.6-8.8-1-3.5-1.4-5 2.8-9 0 0 13.2-8.7 3.7-27.4 0 0-.3 6.4-5 10.2-4.5 3.9-4.2 6.4-4.4 13-.2 6.7-.6 6.2-1.1 7.2 0 0-8.5-15.6-2-23.8 6.5-8.3 10.2-10 3-25.4 0 0 .3 8-5.5 11.8-5.7 4-4.4 13-4.4 13s.4 3.5-.8 6c0 0-8.1-15.9-.4-24.4 6.6-7.3 7-12.4 3.5-22.6 0 0-.4 4.7-4 7.3-3.7 2.6-6.6 5.1-5.9 15 0 0 .3 7-.6 9 0 0-3.4-6.4-4.4-10.5-1-4.2-1.3-6.6 1.2-10.7s12.5-16 .6-33c0 0-.3 5.5-3.4 10.5-3 5-1.6 10.9-1 15.4.7 4.5-1.5 8.9-1.5 8.9s-5.2-9.5-4-20.4c1-11-3.4-20-13.5-26.4 0 0-7.3 17 2.7 25.7 0 0 8.5 8.4 10.7 18.6 0 0-6.5-.6-12.3-12-5.9-11.4-18-9.6-18.8-9.7 0 0 2 17.6 20.6 22.6 0 0 12 2 14.2 10.8 0 0 2 6 2.8 9.2 0 0-3.8-1.5-7.3-6.7-3.5-5-3-5.7-14.8-6.9 0 0-4.7-.5-7.2-3.9 0 0 5 18.6 17.7 18.5 0 0 11.6-1.3 18 14l-2.9-2c-1.7-1.1-6-3.3-14.5-2.3s-10.9-.4-13-1c0 0 8.6 15.7 20.7 11 12.2-4.7 18 12.4 18.2 12.7 0 0-1.7-1.2-3.8-3.3-2.2-2.1-6.6-4.7-15-2 0 0-6.1 2.3-12.3.4 0 0 6 11.5 19.8 9.5a15.1 15.1 0 0 1 17.3 10.2s-1.8-1-3-2c-1.3-1-6-3.7-16-.8-10 3-13.6-.4-13.6-.4s5.5 10 16.2 11.3c0 0 6-.1 8.4-1 2.5-1 9.2-2.5 13.8 4.2 0 0-1.3.2-3.2-.7 0 0-7-2.5-12.5 2 0 0-4.8 4.9-11.6 4 0 0 8.8 8.5 22.8 1.3 0 0 4.7-3.4 8.2-.8 3.5 2.7 11.5-2.6 11.5-2.6z"
    }),
    /* @__PURE__ */ jsxs287("g", {
      fill: "#f4c53d",
      stroke: "#010002",
      strokeMiterlimit: 10,
      strokeWidth: 1.5,
      children: [
        /* @__PURE__ */ jsx312("path", {
          d: "M282.2 103.7s-1.6-14.5 10-16a38 38 0 0 1 18 1.2l5.5 10.6-2 7.2-7.4 3.4s1.3-11-8.8-11.2c-2.6 0-4 1-8.1.3s-6.3 3.8-7.2 4.5z"
        }),
        /* @__PURE__ */ jsx312("path", {
          d: "M363.8 139.6c-1.8 2.2-8.7 3-8.7 3s7.1 5.5 10.2 13.3c3 7.7-82.4 0-82.4 0s3.8-2.6 6.3-7.6c0 0-3.8 1.4-7.6-2.4 0 0 2.8 1 6.5-4.6 0 0 5.5-7 9.4-9 0 0-1.8 1.2-6.1-1.2 0 0 7.4-1 10-13.5 0 0 .5-2.8 3.3-7 2.8-4 2.2.9 7.4-5.4 0 0 2.4-4.4.3-7-2-2.8-4.3-1.8-8.6-4.4-4.4-2.6-6.3-4-4.8-8s5.3-3.4 5.9-3.4.8-3.5 5.5-5.9 17.4-1.3 19.2-.3c2 1 9.5 3.3 14 14.5 4.4 11.2-1.2 15.4 10.8 32.4 0 0-4.8 1-7.9 0 0 0 6.3 11.2 17.3 16.5z"
        }),
        /* @__PURE__ */ jsx312("path", {
          fill: "none",
          d: "M311 92.2c-10-.5-6.1-9.8-6.1-9.8"
        }),
        /* @__PURE__ */ jsx312("path", {
          d: "M328 93.5s-1.7-.8-3.2-2.8c-2-2.7-6.7-4-9.1-1.4 0 0-2.5 2.8-4.8 3 0 0 2.6.7 4.3 2.3 1.7 1.6 3.5 2.8 6.1 2.4 2.6-.3 3-1.7 4.2-2.5 1.3-.8 2.5-1 2.5-1z"
        })
      ]
    }),
    /* @__PURE__ */ jsx312("path", {
      fill: "#369443",
      stroke: "#010002",
      strokeMiterlimit: 10,
      strokeWidth: 1.5,
      d: "M202.8 336.5s-.2-6.4 7.8-6.8l23.5 32.7s-.9 2.1-11.5 1.9c0 0-1.2 0-1.8 1.2-.9 2-18-29-18-29z"
    }),
    /* @__PURE__ */ jsxs287("g", {
      id: "vi_svg__a",
      fill: "#f4c53d",
      stroke: "#010002",
      strokeWidth: 10,
      transform: "translate(3.6 26.2) scale(.15055)",
      children: [
        /* @__PURE__ */ jsx312("path", {
          d: "M1495 1807.9s-49.9 85.6-110.2 87c0 0-103.7-12.6-133 14.5-20.5 18.9-41.4 34.5-50 82.8-8.4 48.3 16.5 58.7 22.4 60.8 0 0 4.6 34.5 38.7 25.5 0 0 2 36 62.2 18.7 60.3-17.3 85.3-11.8 97-71.8 11.9-60.1 22.8-59.1 33.5-66.3 14.4-9.7 41.5-18.8 61.6-30.4 18-10.4 87.2-45.6 110.8-48.3 23.6-2.8 18.4-82.2 18.4-82.2h-61l-29.5-43.5zm192-429.4s-61 49.7-112.2 0c0 0-20.6 24.8-62 17.6-41.2-7.3-48.1-29-52-41.4 0 0-35.8 20.8-66 4.3-30-16.4-30-41.3-30-41.3s-52.5 10.4-79.4-25.2c-26.9-35.5-10.5-70.7 4-74.9 0 0-56.7 14.9-72.2-33.8a56 56 0 0 1 16.4-62.8s-119.4-.6-168.4-38c0 0-40.7-25.6-16.4-52.5 0 0-107.5-17.2-134.4-60 0 0-11.8-11.8-7.9-32.5 0 0 .7-11.7 12.5-12.4 0 0-122.6-19-158-59.4 0 0-17-18.6-8.5-43.5 0 0 1.8-6.5 4.7-11 0 0-111.6-23.5-166.6-73.2 0 0-31.8-28.3-15.4-66.3 0 0-186.5-51-143.3-133.2 0 0-87.2-28.3-59.6-107 0 0-72.1-36.6-40.7-94.6 30.1-55.5 122.6 9.7 232 40 0 0 296.4 93.2 442.3 118l414.6 617.3 241.9 93.2z"
        }),
        /* @__PURE__ */ jsx312("path", {
          d: "M1689.9 923.9s-38.9-29.2-108.2 5.1c0 0-23.3 16.1-41.7-1.5a37.3 37.3 0 0 1 4.3-57.5c51.7-38.3 70.8-153.2-7.8-200.9 0 0-114-67.6-532.3-174 0 0-35-9.8-53.8-5.1a52 52 0 0 0-37.6 37.8S894 581.1 957 611.6c0 0 28.4 13 57.7 21.4 0 0-32.2-7-46 24.8-13 30.4 6 61.5 65 81.5 0 0 16 6.2 38.7 11.7 0 0-50.5 14.5-26.2 55.3 0 0 21.6 42.8 98 50.4 0 0-57 6.2-16.8 60.4 0 0 17.7 29.7 73.4 40.7 0 0-42.2 1.4-21 39.3 21.4 38 71.5 59.4 120.9 62.9 0 0 26.7 1.4 45.4-2.8 0 0-47 23.5-19.4 62.8 0 0 20.3 28 71.1 26.6 0 0-13.1 44 24.1 60.6 29 13 53.1-7.8 53.1-7.8s-9.8 47.1 32.5 63.7c0 0 21.1 10.9 52.6 0 0 0 24 53.9 109.6 16 85.6-37.7 20.2-355.1 20.2-355.1zm5 489.4s-12.5 67.4-112 152.2c0 0-76.8 67.7-74.9 145.7 2 79.5-13.7 88.4-43.9 115.3 0 0 62.3 4.9 92.4-36.6 0 0-1.3 69-10.5 75.3 0 0 19.6 1.2 47.9-29.7 0 0 17-18 32.8-24.9 0 0-18.4 47.7-4 91.9 0 0 4.6-17.3 28.9-24.9 0 0 44-9 61-72.5 0 0 11.1-42 80-79.4 0 0 78-29.4 76-67.8-2-38.5-173.6-244.6-173.6-244.6z"
        }),
        /* @__PURE__ */ jsx312("path", {
          strokeMiterlimit: 10,
          d: "M2056.5 2282.2s-17.9 78.8-80 72.5c0 0-43.9-4.2-40.6-77.4 0 0-64.9 34.6-75.4-51 0 0-59 13.7-58.3-66.3 0 0-55 9.6-48.5-61.5 0 0-59.7 16-59.7-51 0 0-139.6-23.2 151.4-288.6l259.6 154.6z"
        }),
        /* @__PURE__ */ jsx312("path", {
          d: "M2085.4 1928.3s-43.3 38.4-74.1-19c0 0-42-2-48.5-33.8 0 0-34.1-3.4-40.7-35.9 0 0-46.5-4.8-45.2-44.1 0 0-84.6-6.6 0-102.4 84.6-95.8 228.1 159 228.1 159zm48.2-23.8c42 0 89.5 262 77.2 419.9-4.5 57.3-35.2 104.1-77.2 104.1s-72.6-46.8-77-104.1c-12.4-157.9 35.1-419.9 77-419.9"
        }),
        /* @__PURE__ */ jsx312("ellipse", {
          cx: 2133.6,
          cy: 1902.5,
          rx: 58,
          ry: 86
        }),
        /* @__PURE__ */ jsx312("path", {
          fill: "none",
          strokeMiterlimit: 10,
          d: "M1935.9 2277.3s6.6-138.7 126.8-337.6m-202.2 286.6s-18.7-80.1 150.8-317c0 0-19.7-56.5 40.6-92.8M1802.2 2160s-5.3-86.7 160.6-284.5c0 0-14.7-51 45.4-91.8m-254.5 314.8s6.2-87.6 168.4-258.9c0 0-8-52.4 50-84.9m-278 292.8s11.7-100.1 182.8-252c0 0-5.9-39.4 51.1-79.4"
        }),
        /* @__PURE__ */ jsx312("path", {
          fill: "none",
          d: "M372.3 432s134.3 77.8 552.9 155.6M431.9 539S795.6 657.6 965 672.2m-389.9 0s213.4 67 463.3 109.3m-281.2 30.3s241 57.9 356.2 67.5M919 925.6s203.9 42.5 255.5 47.6m-125.7 57.3s148.8 22.6 208 21.4m-23.2 69s60.2-2.8 89.1-7.6m-33.4 104.3s51.2-13.8 81.3-33.1m-5.9 133.2s39.4-15.2 58.4-56.6m37.7 93.6s30.4-27.3 32.4-57.7m81.6 81.5s-11.4-9.9-3.6-52.7m-11.1-62.8s-6-12.2-4-31.6m-211-581.3s68.8 27.6 91.7 65.6c23 38 7.9 74.9 0 96-3.9 10.7-52.4 104.2 4.6 171.9M1346 1057s.4-.3 24.6-8m-169.8-91.4s41 8.2 81.3 8.6m-138-109.8s48.2 4.9 93.5 4.2m-165.2-109.8s69.5 13.8 106.8 14.5M1014.7 633s85.7 24.4 149.4 33.1m141.6 50.4s-61.6 57.3 12.5 110.5c0 0-30.8 48.3 30.8 98.7m-16.4 23.8s-9.2 92.2 103.6 92.2c0 0-21.7 82.1 87.2 79.4 0 0 12.4 65.6 91 52.4M1441.3 1895s-17.9 4-56.6 0m-108.8 48.3s-54.4-8.3-51.8 109.8m84.6-82.9s-49.2-6.2-46 108.4m520.7-384.5s-23.6 4.8-40 23.5c-16.3 18.6-47.8 15.1-47.8 15.1s17-13.8 23-48.3c5.8-34.5 24.9-44.9 24.9-44.9m-56.3-32.6s-23.6 4.8-40 23.4c-16.4 18.7-47.9 15.2-47.9 15.2s17-13.8 23-48.3c5.9-34.5 24.9-44.9 24.9-44.9m23.7 188.5s-20.6 4.3-34.9 20.5c-14.3 16.3-41.8 13.3-41.8 13.3s15-12 20-42.2c5.2-30.1 21.8-39.2 21.8-39.2"
        })
      ]
    }),
    /* @__PURE__ */ jsx312("use", {
      xlinkHref: "#vi_svg__a",
      width: "100%",
      height: "100%",
      stroke: "#010002",
      strokeWidth: 10,
      transform: "matrix(-1 0 0 1 647.2 0)"
    }),
    /* @__PURE__ */ jsx312("path", {
      fill: "#0081c6",
      stroke: "#010002",
      strokeMiterlimit: 10,
      strokeWidth: 1.5,
      d: "m466 256-14.3 61.7-5.9-4.2 14-59.2-9.8.2 23.1-42.3 1.5 48.7zm37 13-43 50.8-4.6-5.2 42.8-50.2-8.7-4.6 39.2-26-20.3 43.8z"
    }),
    /* @__PURE__ */ jsx312("path", {
      fill: "#0081c6",
      stroke: "#010002",
      strokeMiterlimit: 10,
      strokeWidth: 1.5,
      d: "m492.6 242-38.5 74-5.9-3.5 38.7-73.8-9.4-2.4 32.7-34.6-10.5 47.5zm-48 96.6-2.9 11.7 8 8-11.2 47-10-13.3-14.6 6.8 11.1-47 10.4-3 2.6-11.7s3.2-1.2 6.6 1.5z"
    }),
    /* @__PURE__ */ jsx312("path", {
      fill: "#0081c6",
      stroke: "#010002",
      strokeMiterlimit: 10,
      strokeWidth: 1.5,
      d: "m447.3 330.8-5.7 10.6 5.7 9.7-22.4 42.5-6.3-15.6-15.9 2.6 22.4-42.4h10.7l5.5-10.6s4 0 6 3.2z"
    }),
    /* @__PURE__ */ jsx312("path", {
      fill: "#0081c6",
      stroke: "#010002",
      strokeMiterlimit: 10,
      strokeWidth: 1.5,
      d: "m448.2 333.9-15 19.2 3.4 10.8-30.9 36-2.8-16.6-16-1.2 30.8-36 10.4 2.5 16-20.4s4.4 2.2 4.1 5.7zm-382.7-45c3.6-1.5 6.2-2.9 6.2-6.7 0-1-.5-3-1.5-6.1L46 202a59 59 0 0 0-3-7.9c-1.1-2-3.2-2.9-6.1-4h30.7c-3.3 1.5-6.4 2.7-6.3 6.3 0 1.3.4 3.2 1.1 5.7l18.6 58 18.5-58a20 20 0 0 0 1.1-5.7c0-3.7-3.2-5-6.3-6.4h29.8c-2.7 1.1-5 2-6 4.1a63 63 0 0 0-3.1 8L90.8 276a37.9 37.9 0 0 0-1.5 6.1s-1.1 4.7 6.2 6.7zm515.3-7.6v-83.7c0-1.4-.3-2.5-.8-3.3s-2.5-3-5.5-4.2h27.7a11.5 11.5 0 0 0-5.5 4.2c-.5.8-.7 1.9-.7 3.3v83.7c0 1.5.2 2.6.7 3.4.5.8 2.5 2.8 5.5 4.2h-27.7c3-1.4 5-3.4 5.5-4.2.5-.8.8-1.9.8-3.4z"
    }),
    /* @__PURE__ */ jsx312("path", {
      fill: "#fff",
      stroke: "#010002",
      strokeWidth: 1.5,
      d: "M324.8 309.8S399 276.9 399.1 201H250.5c.2 76 74.3 108.8 74.3 108.8z"
    }),
    /* @__PURE__ */ jsx312("path", {
      fill: "#a60032",
      stroke: "#010002",
      strokeWidth: 1.5,
      d: "M262 201v48.5s5.6 11.3 11.4 18.3V201zm22.8 0v80s7.2 7 11.4 10.4V201zm22.9 0v98.9s8.1 5.2 11.4 7v-106h-11.4zm80 0v48.5s-5.7 11.3-11.5 18.3V201zm-22.9 0v80s-7.1 7-11.4 10.4V201zm-22.8 0v98.9s-8.2 5.2-11.5 7v-106H342z"
    }),
    /* @__PURE__ */ jsx312("path", {
      fill: "#162667",
      stroke: "#010002",
      strokeMiterlimit: 10,
      strokeWidth: 1.5,
      d: "M399.1 145.8s-36.4 19-74.3-1.6c-37.9 20.6-74.3 1.6-74.3 1.6V201h148.6z"
    })
  ]
});
var Vi_default = SvgVi;

// src/country-flag-icons/generated/Vn.tsx
init_esm_shims();
import { jsx as jsx313, jsxs as jsxs288 } from "react/jsx-runtime";
var SvgVn = (props) => /* @__PURE__ */ jsxs288("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx313("defs", {
      children: /* @__PURE__ */ jsx313("clipPath", {
        id: "vn_svg__a",
        children: /* @__PURE__ */ jsx313("path", {
          fillOpacity: 0.7,
          d: "M-85.3 0h682.6v512H-85.3z"
        })
      })
    }),
    /* @__PURE__ */ jsxs288("g", {
      fillRule: "evenodd",
      clipPath: "url(#vn_svg__a)",
      transform: "translate(80) scale(.9375)",
      children: [
        /* @__PURE__ */ jsx313("path", {
          fill: "#da251d",
          d: "M-128 0h768v512h-768z"
        }),
        /* @__PURE__ */ jsx313("path", {
          fill: "#ff0",
          d: "M349.6 381 260 314.3l-89 67.3L204 272l-89-67.7 110.1-1 34.2-109.4L294 203l110.1.1-88.5 68.4 33.9 109.6z"
        })
      ]
    })
  ]
});
var Vn_default = SvgVn;

// src/country-flag-icons/generated/Vu.tsx
init_esm_shims();
import { jsx as jsx314, jsxs as jsxs289 } from "react/jsx-runtime";
var SvgVu = (props) => /* @__PURE__ */ jsxs289("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx314("defs", {
      children: /* @__PURE__ */ jsx314("clipPath", {
        id: "vu_svg__a",
        children: /* @__PURE__ */ jsx314("path", {
          d: "M0 0v475l420-195h480v-85H420Z"
        })
      })
    }),
    /* @__PURE__ */ jsx314("path", {
      fill: "#009543",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx314("path", {
      fill: "#d21034",
      d: "M0 0h640v240H0z"
    }),
    /* @__PURE__ */ jsxs289("g", {
      clipPath: "url(#vu_svg__a)",
      transform: "scale(.71111 1.01053)",
      children: [
        /* @__PURE__ */ jsx314("path", {
          stroke: "#fdce12",
          strokeWidth: 110,
          d: "m0 0 420 195h480v85H420L0 475"
        }),
        /* @__PURE__ */ jsx314("path", {
          fill: "none",
          stroke: "#000",
          strokeWidth: 60,
          d: "m0 0 420 195h480m0 85H420L0 475"
        })
      ]
    }),
    /* @__PURE__ */ jsxs289("g", {
      fill: "#fdce12",
      transform: "translate(-22) scale(1.01053)",
      children: [
        /* @__PURE__ */ jsx314("path", {
          d: "M106.9 283v27c23.5 0 69.7-18 69.7-76.1 0-58.1-49.3-68.9-64-68.9-14.8 0-60.3 10.6-60.3 58 0 47.6 44.7 52 53.5 52 8.8 0 41.8-8 38-43.6a35.5 35.5 0 0 1-35.4 31.5c-24 0-39-17.8-39-35.4 0-17.6 14.6-41.2 39.9-41.2 25.3 0 43.8 22.5 43.8 45.1 0 22.7-17.8 51.5-46.2 51.5z"
        }),
        /* @__PURE__ */ jsxs289("g", {
          id: "vu_svg__b",
          children: [
            /* @__PURE__ */ jsx314("path", {
              stroke: "#fdce12",
              strokeWidth: 0.8,
              d: "m86.2 247.7 1.4 1s11.2-25.5 41.1-43.6c-3.8 2-23.8 12-42.5 42.6z"
            }),
            /* @__PURE__ */ jsx314("path", {
              d: "M89.1 243.3s-3.4-7-.4-10.2c3-3.1 1.7 8.3 1.7 8.3l1.3-1.9s-2-8.6.2-10.4c2.3-1.9 1.2 8.3 1.2 8.3l1.4-1.8s-1.5-8.4.7-10c2.3-1.6.9 8 .9 8l1.6-2s-1.2-8 1.5-9.9c2.7-1.9.3 7.6.3 7.6l1.8-2s-.8-7.3 1.5-9c2.3-1.6.4 7 .4 7l1.6-1.8s-.5-6.8 1.7-8.4c2.3-1.6.2 6.5.2 6.5l1.7-1.6s-.4-6.9 2.4-8.2c2.8-1.3-.5 6.4-.5 6.4l2-1.6s.5-8 2.9-8.7c2.4-.8-1 7-1 7l1.7-1.4s.9-6.8 3.5-7.6c2.7-.9-1.6 6.2-1.6 6.2l1.7-1.3s1.9-6.8 4.4-7.6c2.4-.7-2.6 6.5-2.6 6.5l1.7-1.2s2.7-6.2 5-6.6c2.1-.4-2.6 5.1-2.6 5.1l2.1-1.2s3.5-6.4 4.8-4.5c1.2 2-5 4.9-5 4.9l-2 1.2s7.5-3.6 8.4-1.8c.9 1.8-10.3 3-10.3 3l-1.8 1.2s7.5-2 6.6-.1c-1 1.9-8.4 1.5-8.4 1.5l-1.7 1.2s7.5-1.8 6.5 0c-1 1.6-8.3 1.5-8.3 1.5l-1.8 1.5s7.3-2 6.2.3c-1 2.2-9.4 2.1-9.4 2.1l-2 2s7.7-2.7 7-.6c-.6 2-9.4 3-9.4 3l-2 2s8.3-2.7 5.8-.2c-2.4 2.6-8.5 3.2-8.5 3.2l-2.3 3s8.2-5 7-2.2c-1.1 2.8-9.2 4.7-9.2 4.7l-1.6 2s7.4-4.3 6.6-2c-.7 2.5-8.6 5-8.6 5l-1.3 1.8s8.7-5.2 8-2.5c-.8 2.6-9.1 4.5-9.1 4.5l-1 1.7s8-4.7 8-2.4c.2 2.2-9.4 4.4-9.4 4.4z"
            })
          ]
        }),
        /* @__PURE__ */ jsx314("use", {
          xlinkHref: "#vu_svg__b",
          width: "100%",
          height: "100%",
          transform: "matrix(-1 0 0 1 220 0)"
        })
      ]
    })
  ]
});
var Vu_default = SvgVu;

// src/country-flag-icons/generated/Wf.tsx
init_esm_shims();
import { jsx as jsx315, jsxs as jsxs290 } from "react/jsx-runtime";
var SvgWf = (props) => /* @__PURE__ */ jsxs290("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx315("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx315("path", {
      fill: "#000091",
      d: "M0 0h213.3v480H0z"
    }),
    /* @__PURE__ */ jsx315("path", {
      fill: "#e1000f",
      d: "M426.7 0H640v480H426.7z"
    })
  ]
});
var Wf_default = SvgWf;

// src/country-flag-icons/generated/Ws.tsx
init_esm_shims();
import { jsx as jsx316, jsxs as jsxs291 } from "react/jsx-runtime";
var SvgWs = (props) => /* @__PURE__ */ jsx316("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs291("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    children: [
      /* @__PURE__ */ jsx316("path", {
        fill: "#ce1126",
        d: "M0 0h640v480H0z"
      }),
      /* @__PURE__ */ jsx316("path", {
        fill: "#002b7f",
        d: "M0 0h320v240H0z"
      }),
      /* @__PURE__ */ jsx316("path", {
        fill: "#fff",
        d: "m180 229.3-20.7-14-19.9 14.1 6.5-24.9-19-15.2 24.5-1.5 8.1-23.6 8.8 24 24 .7-19 16.3zm-3.6-165.6L159.8 53l-16 10.4 4.4-20-14.6-12.7 19.4-1.6 7.2-18.6 7.4 18.7 19.1 1.7L172 44.3zm-73 59.5-16-11-16.7 11 5.2-19.4L60.8 91 80 90l7-19 6.8 18.9 19.6 1.1-15 12.5zM250 110l-15.4-10-15 10 4.4-18.3-14-11.8 18.3-1.5 6.3-17.2 7 17.4 17.7 1-13.7 12.3zm-43.1 43.4-10.3-6.4-10.3 6.6 2.7-12.3-9.2-8.3 12-1 4.6-11.6 4.9 11.6 11.9 1-9.1 8.3z"
      })
    ]
  })
});
var Ws_default = SvgWs;

// src/country-flag-icons/generated/Ye.tsx
init_esm_shims();
import { jsx as jsx317, jsxs as jsxs292 } from "react/jsx-runtime";
var SvgYe = (props) => /* @__PURE__ */ jsx317("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: /* @__PURE__ */ jsxs292("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt",
    children: [
      /* @__PURE__ */ jsx317("path", {
        fill: "#fff",
        d: "M0 0h640v472.8H0z"
      }),
      /* @__PURE__ */ jsx317("path", {
        fill: "#f10600",
        d: "M0 0h640v157.4H0z"
      }),
      /* @__PURE__ */ jsx317("path", {
        fill: "#000001",
        d: "M0 322.6h640V480H0z"
      })
    ]
  })
});
var Ye_default = SvgYe;

// src/country-flag-icons/generated/Yt.tsx
init_esm_shims();
import { jsx as jsx318, jsxs as jsxs293 } from "react/jsx-runtime";
var SvgYt = (props) => /* @__PURE__ */ jsxs293("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx318("path", {
      fill: "#fff",
      d: "M0 0h640v480H0z"
    }),
    /* @__PURE__ */ jsx318("path", {
      fill: "#000091",
      d: "M0 0h213.3v480H0z"
    }),
    /* @__PURE__ */ jsx318("path", {
      fill: "#e1000f",
      d: "M426.7 0H640v480H426.7z"
    })
  ]
});
var Yt_default = SvgYt;

// src/country-flag-icons/generated/Za.tsx
init_esm_shims();
import { jsx as jsx319, jsxs as jsxs294 } from "react/jsx-runtime";
var SvgZa = (props) => /* @__PURE__ */ jsxs294("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx319("defs", {
      children: /* @__PURE__ */ jsx319("clipPath", {
        id: "za_svg__a",
        children: /* @__PURE__ */ jsx319("path", {
          fillOpacity: 0.7,
          d: "M-71.9 0h682.7v512H-71.9z"
        })
      })
    }),
    /* @__PURE__ */ jsx319("g", {
      clipPath: "url(#za_svg__a)",
      transform: "translate(67.4) scale(.93748)",
      children: /* @__PURE__ */ jsxs294("g", {
        fillRule: "evenodd",
        strokeWidth: "1pt",
        children: [
          /* @__PURE__ */ jsx319("path", {
            fill: "#000001",
            d: "M-71.9 407.8V104.4L154 256.1z"
          }),
          /* @__PURE__ */ jsx319("path", {
            fill: "#000c8a",
            d: "m82.2 512.1 253.6-170.6H696V512H82.2z"
          }),
          /* @__PURE__ */ jsx319("path", {
            fill: "#e1392d",
            d: "M66 0h630v170.8H335.7S69.3-1.7 66 0"
          }),
          /* @__PURE__ */ jsx319("path", {
            fill: "#ffb915",
            d: "M-71.9 64v40.4L154 256-72 407.8v40.3l284.5-192z"
          }),
          /* @__PURE__ */ jsx319("path", {
            fill: "#007847",
            d: "M-71.9 64V0h95l301.2 204h371.8v104.2H324.3L23 512h-94.9v-63.9l284.4-192L-71.8 64z"
          }),
          /* @__PURE__ */ jsx319("path", {
            fill: "#fff",
            d: "M23 0h59.2l253.6 170.7H696V204H324.3zm0 512.1h59.2l253.6-170.6H696v-33.2H324.3L23 512z"
          })
        ]
      })
    })
  ]
});
var Za_default = SvgZa;

// src/country-flag-icons/generated/Zm.tsx
init_esm_shims();
import { jsx as jsx320, jsxs as jsxs295 } from "react/jsx-runtime";
var SvgZm = (props) => /* @__PURE__ */ jsxs295("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx320("defs", {
      children: /* @__PURE__ */ jsx320("clipPath", {
        id: "zm_svg__a",
        children: /* @__PURE__ */ jsx320("path", {
          fillOpacity: 0.7,
          d: "M-170.7 0H512v512h-682.7z"
        })
      })
    }),
    /* @__PURE__ */ jsxs295("g", {
      fillRule: "evenodd",
      clipPath: "url(#zm_svg__a)",
      transform: "translate(160) scale(.9375)",
      children: [
        /* @__PURE__ */ jsx320("path", {
          fill: "#198a00",
          d: "M-256 0h768v512h-768z"
        }),
        /* @__PURE__ */ jsx320("path", {
          fill: "#ef7d00",
          d: "M421.9 184H512v328h-90.1z"
        }),
        /* @__PURE__ */ jsx320("path", {
          fill: "#000001",
          d: "M331.9 183.8h90v328h-90z"
        }),
        /* @__PURE__ */ jsx320("path", {
          fill: "#de2010",
          d: "M240 184h91.9v328h-92z"
        }),
        /* @__PURE__ */ jsxs295("g", {
          fill: "#ef7d00",
          stroke: "#000",
          children: [
            /* @__PURE__ */ jsx320("path", {
              strokeLinejoin: "round",
              d: "M451.6 65.6s34-14.5 37.2-17.5c1.5 1.8-13.6 20-42.9 26.7 26.6-6.2 49.3-26 54-25.4 1.3.3 1 19.3-60 35.8 42.2-11 66.7-31.4 66.4-29.2.3.5-4.2 16-41.1 28.1 10.3-2.4 38.3-19.4 38-16.1.9 1.3-27 37.2-77.6 25.5 40.4 10.5 66.5-14.8 70.2-14.3.8.1-7.4 22-58.2 23.4 24.3-2.5 17.3-.1 17.3-.1s-14.3 11.2-31.7 3.6c13.6 3.7 15.1 3.9 15.4 5-.9 1.6-12 3.8-22.9-2 8.7 3.6 16.5 4.2 16.6 5.5-.1.4-5.6 3.6-10.6 1.3-4.9-2.2-50.3-30.1-50.3-30.1l77.4-21.3 2.8 1zm-91 75.6c-6.8 0-7 6-7 6s-.5.5-.2 3.4l1.7-2.6c.8.1 3.9 1 8.8-2.8-4.5 4.7-1.8 6.4-1.8 6.4s-1 3.7 2.4 4.4c-1-1.5-.4-2.8-.4-2.8s4.8-.5 4.5-6.3c.1 5.3 3 6.6 3 6.6s0 2.9 3.1 3.2c-1.6-1.5-1.3-3.8-1.3-3.8s4-3 .7-8c2-1.2 3.7-4.5 3.7-4.5s-2.8-1.2-4.1-2.2c-.6-1.3 0-8.5 0-8.5l-1.8-9.3-4.8 14.5c.2-2 .3 6.3-6.5 6.3z"
            }),
            /* @__PURE__ */ jsx320("path", {
              strokeLinejoin: "round",
              d: "M394.2 120.3c.2.1 5.1 5.6 9.9 5.3 1.8-1.5-3.7-4.7-3.7-5.5 2 1.8 10.1 8.8 15.4 6.3 2-3-3.8-2.5-10.2-10.6 4.5 3 15.7 9.5 21 7 2.1-2.4-11.7-9.9-16.4-15.7l-12-6.1-16.2 13.3 12.3 6z"
            }),
            /* @__PURE__ */ jsx320("path", {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              d: "M375.9 74.8s5.5-3.2 27.6-1.6c2.4.3 15-4.3 19.1-5.7 6.4-1.2 27-5.6 32.4-9.8 4-.5-1 7.1-6 9-5.2 2.3-24.1 8.9-30.9 8 8.1.1 3.6 6.7-9.8 3.6 6.4 3.6 4 4.2 4 4.2s-11.3.6-14.3-2c7.6 2.9 4.4 4 4.4 4s-7.7.7-11.3-1c5.5 1.7 2.7 2.7 2.7 2.7s-4.5.8-8.2-.6c-3.8-1.3-9.4-10.7-9.7-10.7z"
            }),
            /* @__PURE__ */ jsx320("path", {
              strokeLinejoin: "round",
              d: "m384.7 123.4.8 14.6-.8 1.2c-.3.4-10.3-1.6-9 6 0 3.2 0 4 2.2 5.7-.5-2-.4-3.5-.4-3.5s2.9 1.7 5.6-3c-1.9 4.6-.6 6.3-.1 6.4.4.8-.8 4.5 3 4.4-1.5-1.4-.8-3.4-.8-3.4s4-.6 2.6-7.7c1.4-1.4 2 0 2 0s.4 4.2 3.9 3.3c1.5.9-.3 3.2-.3 3.2s2.5 0 3.3-2c.7-2.2 1.6-6-2.5-7.6-.5-1.5 1.6-1.6 1.6-1.6s2.6.9 3.4 2.2.5-3.4-2.8-4c-4 0-4.2-.9-4.2-1l-1-13.7z"
            }),
            /* @__PURE__ */ jsx320("path", {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 1.1,
              d: "M398.6 135.8c0-.7-6.8-9.9-5-11 1.7.3 4.5 4.5 6.9 3.1-.7-1.6-2.8-.7-5.1-4.9-2.4-4.8-2.7-11.9-11-19.6 5.4 8.2 17.4 13 18 10.6s-10.7-11.4-10.1-13.6c2.2 4.4 13.4 14.4 21.6 13.6.6-2-6.7-5.8-8.6-9.4-5.3-3.6-19.4-15.7-19.6-18.5a33.3 33.3 0 0 0-9.9-10.6 5 5 0 0 1-.8-1.7c-3.2-7.5 1-10 3.5-10.3 2-.3 2.6 0 4-.7l-5.1-2c2.3 1.7 8 .2 6.8 5 2.5-1 7.9-7.4-6.1-8.8-4.6-5.2-23.3-8.2-28 14.6.4.3.6.6 1.8 1.4-6-2.8-21.9-5-27.6-6-15.6-4.4-31.7-15.2-33.2-13.9-2 1 9.4 11.6 8.8 11.8a263 263 0 0 0-27.5-13.6c-6-2.2-11.9-7.4-12.5-6.4-2.2 4.5 9.5 15.9 11.7 17.2 2.2 1.3 19.3 9.3 19 9.4-25.8-11.7-30-13.9-31.4-15.2-2.3-.5-7.8-8-9.3-7.5-.9.8.8 12.6 13.1 18 2 1.4 26.4 10.1 26.2 10.8 0 .2-28-11.5-29-12-5.4-2-12-9.4-13.2-8.6-1.2.8 3 8.8 8.4 11.3 2.9 1.2 13.8 6.6 23.6 10 .6.3-17.7-6.9-26.5-10.5-4-2.2-5.8-5-6.4-4.4-1 .6 1.4 12.4 29.7 19 .7.4 10-2.1 9.5-1.8a113.3 113.3 0 0 1-15.8 2.8c-.3.8 1.8 5 16.4 4.2 1.8-.1 12-3.7 11.1-3a174 174 0 0 1-14.8 4.9c-.9 0-5.6.6-5.8 1-.2.8 3.5 3.8 11.3 4.2 7 .4 20.2-4.2 20-3.9-.4.3-12.8 4.6-13.1 4.8-.5.3-5 .5-5.2.9-.4.9 6.6 7.4 27.1.4-2 2.8-12 4.7-12 5.2 0 .4 2.2 2.5 5.7 3.3 1.7.4 4.1.3 6.3 0 4-.8 8-2.3 13.3-7.2.6 1.5-13.1 8.5-12.5 9.1 3 2.8 12.9-.3 13.5-.7.7-.3 19-10.7 19-12 .3 1.6-23.7 14.7-23.4 15.2 1.5 2.4 9.7-.1 10-.4l10.8-5.8c.3-.1-11.8 7-10.8 8.2-.5 4.7 19-3.2 20.5-4.2.7-.5-9.4 4.4-9.4 6.7 3.3 5.5 13.7 3.8 15.3 2.6.8-.6-1 4-.4 3.6a16 16 0 0 0 3-4.3c-.2 1.6-1.4 4-2 6.8-.7 2.7-.9 5.9-1.8 9.2-.2 1.4 6.4-2.9 5.4-13.2.6 5.4-2 15.4-1.3 16 1.3 1 5.2-5 5.6-9.1 1.1 2 3.5 6.3 5.6 7.3-.2-3.1 0-3-1-6 .6-4.1.7-9.7.8-16.1 5.6 10.7 7.9 15.3 6.3 23.5 1.7.7 4.3-5.8 4.1-9a13.3 13.3 0 0 0 11.5 10.2"
            }),
            /* @__PURE__ */ jsx320("path", {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 1.1,
              d: "M305.4 67.7s-3.9 2.9-8.6 2.7c1.2 4.8 11 1.1 11 1.1s-4.7 5.3-8.1 6.1c2 1.7 10.6 1.1 12 .3 1.4-.9 4-4.2 4-4.2s-8.8 10.2-10 10.1c-.3 1.2 9.1.8 11-1 2-1.8 7-4.4 7-4.4s-13 9-13.5 9c4.8 1.2 14.5-1.6 20.7-5.4-9.2 6.1-10 7.2-14.7 9.3 4.2.9 6.3 3.7 20.3-2.4 8-3.8 12.6-10.8 12.6-10.8a81.7 81.7 0 0 1-21.6 18c-.5 1 9.4 5.2 21.9-7.9"
            }),
            /* @__PURE__ */ jsx320("path", {
              strokeLinecap: "round",
              strokeWidth: 1.1,
              d: "M373.4 96s.9 4 4.3 7 3.6 6 3.6 6m-9.5-39s1.1 3.7 4.6 6c3.6 2.2 9 9.4 9.3 10.7.4 1.5 2.5 12.6 2.3 13.8m-37.8-25c.2 1.5-5 8.3 2.2 16.4-6.6 8-6.6 9-6.6 9s3.7 2 10.2-3.6c10.8 13.2 7.2 19.2 7.2 19.2"
            }),
            /* @__PURE__ */ jsx320("path", {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 1.1,
              d: "M362.3 107.2s-1-1.4.8-6.7c1.6 2 3.4 2.3 4.1 3 .8.9 9 2 9.4 7.5"
            }),
            /* @__PURE__ */ jsx320("path", {
              strokeWidth: 1.1,
              d: "M371.9 57.5c0-.4-1.7-4-7.8.4 3.3.2 6.5 2.1 7.8-.4z"
            }),
            /* @__PURE__ */ jsx320("path", {
              strokeLinejoin: "round",
              strokeWidth: 1.1,
              d: "M430.1 73.5c.3.2 18.2 4 24.2 2.1-7.6 10.2-22.9 3.3-22.9 3.3 7.5 2.2 7.8 2 10.2 4.2.8 2-13.8 1-18.5-1.7 13.3 4.2 13.6 4 14 5.5.6 2.3-21.8-.6-23.7-3.5 6 4.6 9.2 5.5 12.5 7.6-4 1.8-11.5 3.6-25.2-6.1 18 16.4 34.3 15.4 36.9 18.3-6.3 9.3-30.7-5.5-41.9-13s24.5 18.1 27.8 17.7c-1.6 2.5-13.4.3-14.2-1"
            }),
            /* @__PURE__ */ jsx320("path", {
              strokeLinecap: "round",
              strokeWidth: 1.1,
              d: "M434.7 90.7c-2 .3-8.3.3-9.2.1"
            }),
            /* @__PURE__ */ jsx320("path", {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 1.1,
              d: "M300.1 65s13.6 7.2 19.4 6.7a10 10 0 0 1-3.8 2c1.4.6 5.4 2.7 11.4 1.4l-3.3 3s5.2 2 11-1a46.4 46.4 0 0 0-2.8 3.7l4.1.3"
            })
          ]
        })
      ]
    })
  ]
});
var Zm_default = SvgZm;

// src/country-flag-icons/generated/Zw.tsx
init_esm_shims();
import { jsx as jsx321, jsxs as jsxs296 } from "react/jsx-runtime";
var SvgZw = (props) => /* @__PURE__ */ jsxs296("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 640 480",
  width: "100%",
  height: "100%",
  ...props,
  children: [
    /* @__PURE__ */ jsx321("defs", {
      children: /* @__PURE__ */ jsx321("clipPath", {
        id: "zw_svg__a",
        children: /* @__PURE__ */ jsx321("rect", {
          width: 546,
          height: 420.1,
          x: 1.9,
          y: 0.1,
          fill: "#00f",
          fillRule: "evenodd",
          ry: 0
        })
      })
    }),
    /* @__PURE__ */ jsxs296("g", {
      clipPath: "url(#zw_svg__a)",
      transform: "matrix(1.1722 0 0 1.1426 -2.3 -.1)",
      children: [
        /* @__PURE__ */ jsx321("path", {
          fill: "#006400",
          d: "M0 0h840v420H0z"
        }),
        /* @__PURE__ */ jsx321("path", {
          fill: "#ffd200",
          d: "M0 60h840v300H0z"
        }),
        /* @__PURE__ */ jsx321("path", {
          fill: "#d40000",
          d: "M0 120h840v180H0z"
        }),
        /* @__PURE__ */ jsx321("path", {
          fill: "#000001",
          d: "M0 180h840v60H0z"
        }),
        /* @__PURE__ */ jsx321("path", {
          stroke: "#000",
          strokeWidth: 20,
          d: "M0 0v420l280-210z"
        }),
        /* @__PURE__ */ jsx321("path", {
          fill: "#fff",
          d: "M0 0v420l280-210z"
        }),
        /* @__PURE__ */ jsx321("path", {
          fill: "#d40000",
          d: "M106.5 104.4 162 275.1 16.8 169.6h179.5L51 275.1z"
        }),
        /* @__PURE__ */ jsx321("path", {
          fill: "#fc0",
          d: "m82.8 253.7 9.8-1.8 18.1-.7 6.7.6 15 2.5 1.1-1.5V242l1.8-9.3 3-9.4 3.3-7.5 4.2-7.8 6.8 1.7h1.8l.2-1.3-14.4-12.3-15-11.5-21.7-16.2-2-.5-2.3-17-1.7-5.1-2.3-2-4.3-1.4-4.8.2-2.2 1.2-4.6 1-2.4.4-1.6 1.9-.2 2.4 6.7.2 1.7.7-.2.7-3.8.5-1.8.6 2.1 1.6 2.2.8 2.8 1 .6 2 .2 25.8-1.5 4-.5 7.5 2.2 9-5.6 6.4L77 216l-.6 3.5-1.7 3.5-.2 2.2 1.1 2.4 4.3 14.2 2.2 11.7z"
        }),
        /* @__PURE__ */ jsx321("path", {
          d: "M88 142c-1.8 0-2.6.2-4.3 1.1a10.8 10.8 0 0 1-4.6 1.4c-2.5 0-4.5 1.8-4.5 4.1v1.5l3.6-.1c10.6.3 1 1.3.2 1.4-2.6.5.6 2.6 3.7 3.7 3.3 1 3.1.4 3.1 15 0 11.9 0 13.6-1 16.3-1.3 4-1.3 10 0 14 .6 1.6 1 3 1 3.3 0 .2-1.6 2.1-3.5 4.3-3.5 4-5.6 8.1-5.6 11a6 6 0 0 1-1 2.6c-1.3 1.7-1.3 4.6-.1 5.7 1.3 1.2 6.6 21.8 6.7 25.7 0 1.4.2 1.4 8.3-.2 6.6-1.3 22.1-1.6 30-.6 3.6.5 7.8 1.3 9.3 1.6 4.8 1.3 4.6 1.5 4.6-4.3a74 74 0 0 1 5.1-26.7 94.7 94.7 0 0 1 6.9-14s1.8.2 4 .8c4.1 1 5.3.9 5.3-1 0-1-4.3-4.6-25.4-21a432.2 432.2 0 0 0-26.3-19.9c-.6 0-1.2-.3-1.3-.7l-1.5-9.5c-.7-4.9-1.7-9.7-2.1-10.7-1.4-3-4.1-4.5-8.6-4.8a31.2 31.2 0 0 0-2 0m.1 1h2c6.6.4 7.8 2.2 9.6 14a173 173 0 0 1 1.2 9.4c0 .8-.9 1.8-3.2 3.3a46.8 46.8 0 0 0-10 9.5l-1.3 1.8-.3-4.2V165c.3-8.7 0-9.5-2.8-10.5-2.3-.8-5.3-1.6-4.5-2.1 1-.6 2-.2 4.4-.9 1-.2.9-.1.7-.9-.2-1.3-1.6-2-5.3-1.8-3 .2-3.3.1-3.1-.7.4-1.6 2-2.6 4.5-2.9a13.4 13.4 0 0 0 4.4-1.3 7 7 0 0 1 3.7-1zm14.9 25.8h.4c1.7.3 50.8 38.7 50.8 39.8 0 .4-.4.7-1 .7-.4 0-12.9-3.5-27.7-7.8-23.6-7-27-8-28-9.3a5.1 5.1 0 0 1-.1-6.2 5 5 0 0 0 1-2c0-1.2-2.5 1.8-3 3.5-.5 2 .5 5.4 2 6.5.6.5 5.1 2 10 3.5 8.4 2.4 9 2.7 9.4 4.1 1 3.3-2.5 7.2-7.5 8.3a14.6 14.6 0 0 0-5.2 2.4 68.2 68.2 0 0 1-17.2 10.4c-.4.3-.9 1.9-1.2 3.4-.6 3.3-.8 3.8-1.8 3.8-.5 0-.6-.3-.2-1.4.7-2 .6-4.4-.1-4.4-.5 0-.7.7-.7 1.8 0 1-.3 2.2-.7 2.5-.5.6-.6.2-.4-2.3.2-1.7.1-3-.1-3-.5 0-1.4 2.5-1.7 4.7-.2 1.3-.2 1.3-.6-.3-.3-1.2-.2-2 .7-3.5a9 9 0 0 0 1-3.5c0-1.3 1-2.6 5.7-7.3 3-3.1 6.7-7 8-8.7 2.3-2.8 2.4-3 2.3-5.9 0-1.6-.2-3.1-.4-3.3-.6-.6-1.4 2.6-1 4.3.2 1.6 0 2.1-3.3 6a113.2 113.2 0 0 1-7.5 7.8c-3.9 3.6-5.3 5.6-5.3 7.4 0 .6-.4 2-1 3.3s-.8 2.6-.6 2.9c.2.3 0 .3-.3 0-.5-.5-.5-1.3-.1-3a7 7 0 0 0 .2-2.6c-.5-1-1.2.2-1.5 2.7-.2 1.4-.5 2.5-.8 2.3-.7-.4-.5-3 .4-4.4.5-.7 1-2.3 1.3-3.6.7-3.7 2.3-6.7 5.8-10.7a57.5 57.5 0 0 0 3.2-3.8l-1-3.3a25 25 0 0 1-.2-13.7c1.3-3.8 3.9-7.6 8-11.7 4-3.9 7.9-6.3 10-6.4m15 32.2a.9.6 0 0 1 1 .6.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.6m2.5.3a.9.6 0 0 1 1 .6.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.6m2.6.5a.9.6 0 0 1 1 .6.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.6m2.4.5a.9.6 0 0 1 1 .6.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.6m-6.3.6a.9.6 0 0 1 1 .6.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.6m2.4.4a.9.6 0 0 1 1 .6.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.6m5.2.2a.9.6 0 0 1 1 .6.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.6m-2.7 0a.9.6 0 0 1 1 .6.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.6m5 .6c.1 0 3.7.8 8 2l7.9 2.3-1.5 2.7a96.2 96.2 0 0 0-2.4 4.4c-1 2-1.2 2-6 .9-5.2-1.2-13.4-2.3-21.8-3l-8-.7 3-1.1a50.4 50.4 0 0 0 5.3-2.4c2-1.1 2.8-1.3 5.9-1 4.5.3 7.5-.6 8.7-2.4l1-1.7zm-8.8.6a.9.6 0 0 1 1 .6.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.6m5.6 0a.9.6 0 0 1 1 .6.9.6 0 0 1-1.6 0 .9.6 0 0 1 .7-.6zm-8 0a.9.6 0 0 1 1 .6.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.5zm5.3.2a.9.6 0 0 1 1 .5.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.5m-6.6 1.1a.9.6 0 0 1 1 .6.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.6m2.5 0a.9.6 0 0 1 1 .7.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.6zm2.6.2a.9.6 0 0 1 1 .5.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.5m2.8 0a.9.6 0 0 1 1 .6.9.6 0 0 1-1.7 0 .9.6 0 0 1 .7-.6m-20.3 8.1a191.2 191.2 0 0 1 35.1 4.2c.1.1-.6 2.5-1.7 5.4l-2 6c-.1.5-.8.5-2.5.3-8.3-1.3-32.3-1.2-41.5.2-5.3.8-6 .7-5.6-.4l1-3.5.6-2.7L93 221a63.4 63.4 0 0 0 10.2-6.5h.9zm-27 14.2c.3 0 .9.3 1.6.8 1 .6 2.2 1.1 2.7 1.1 2.6 0 4 3.7 6.2 16l.8 4.4c.2 1 0 1.2-2.3 1.7-2.8.6-3.5.7-3.5.3 0-1-2.8-13.7-4-18.2a96.9 96.9 0 0 1-1.6-6 .1.1 0 0 1 .1 0zm28.6 2h2.9l-1 1c-1.7 2-2.5 2.1-3.7.8a5 5 0 0 1-1-1.5c0-.2 1.3-.4 2.8-.4zm6.1 0h5.4l-1.2 1.2c-1.4 1.6-1.5 1.6-3 0l-1.2-1.3zm8.2 0h1.3c.7 0 2 0 2.8.2l1.5.3-1.4 1.3c-.8.7-1.5 1.3-1.6 1.2l-1.4-1.6zm8.5.3 1.2.3c.7.2 2.2.3 3.3.4h2l-1.5 1.3a8.9 8.9 0 0 1-1.8 1.3c-.1 0-1-.8-1.7-1.7zm-30.2.1h.2c.1.2-.3 1-1 1.7l-1 1.4-1.5-1.2-1.5-1.3 2.4-.3zm2.3.2 1.6 1.4 1.6 1.5-3 .2-3 .1 1.4-1.5zm18 0c.3 0 .5.1.8.3a6.6 6.6 0 0 1 1.3 1.7c.4.8.3 1-1 1l-2.5-.5-1.2-.3 1.3-1.3c.6-.6 1-1 1.4-1zm-8.3 0c.5 0 1 .3 1.6 1.3.7 1.1.7 1.1-2 1.1h-2.7l1.4-1.3c.7-.7 1.3-1 1.7-1zm17 .2 1.2 1.2c1.4 1.3 1.6 2.1.6 2l-2.8-.3-2.2-.2 1.6-1.3zm-35.2.7c.2 0 1 .5 1.6 1.2l1.2 1.3-2.5.4-3.5.5c-.7.2-.5-.3 1-1.6 1-1 2-1.8 2.2-1.8m-3.7 0h.4c.8.2.8.4-.6 1.8l-1.5 1.5-.5-1.3c-.4-1-.3-1.3.6-1.7a4.8 4.8 0 0 1 1.6-.3m46 1.8c.2 0 .2.2 0 .6-.2.8-1.1 1-1.1.2 0-.2.3-.5.7-.7zm-21.4 1.6c7.7 0 15.5.2 17.4.4 3.1.4 3.4.5 3.4 1.7 0 1.4-.4 1.5-4.6.8-1.2-.3-6.3-.7-11.2-1.1a149.6 149.6 0 0 0-28.5 1c-1.9.2-2.4 0-2.4-.6 0-1.3 10.2-2.2 25.9-2.2m-10.3 2.9h5.4l-1.2 1.3c-1.5 1.6-1.6 1.6-3 0zm7 0 1.4 1.4 1.4 1.6-2.9.1h-2.9l1.5-1.6zm2.1 0h5.4l-1.2 1.3c-1.4 1.6-1.5 1.6-3 0zm-12.8 0c.2 0 0 .5-.7 1.5-.7.9-1.4 1.6-1.5 1.6-.2 0-.9-.6-1.5-1.3l-1.2-1.3H96a9 9 0 0 0 2.7-.4 1 1 0 0 1 .4 0zm2 .5 1.3 1.2 1.5 1.3-2.6.2-2.9.2 1.4-1.5zm17.4 0 1.4 1.6c1.6 1.7 1.5 1.8-2.1 1.1l-1.7-.3 1.2-1.2zm2 0h2.4c2.6 0 2.9.4 1.4 1.8-1.2 1-1.2 1-2.6-.5zm-30.6.5c1.2 0 1.1.1-.4 1.6-1.1 1.1-1.2 1.1-1.6.3-.3-1 .6-1.8 2-1.9m38.8.2c.4 0 1.2 0 2 .2l2.3.4-1.3 1.2-1.2 1.2-1.1-1.4-1-1.6zm-36 .5c.3 0 .6.2 1.1.7 1 1 1 1 .2 1.4a8 8 0 0 1-2.4.4H90l1.3-1.4c.7-.7 1-1 1.3-1.1zm34.1.3c.4 0 .7.2 1.2 1l.9 1.2h-2.1c-1.4 0-2-.2-2-.6.2-.4.7-1 1.3-1.3zm6.4 1.3c.2 0 .2.2.2.5 0 1-.9 1.7-1.3 1-.1-.3.1-.8.5-1.1zm-25.9 1.2c8.7 0 18.3.6 24 1.6l1.6.3v4.4c0 3.3-.2 4.4-.7 4.4l-5-1a126 126 0 0 0-35-1l-2.3.3-.6-3.7a21 21 0 0 1-.4-3.8s2.3-.5 5-.8c3.3-.5 8.2-.7 13.4-.7"
        }),
        /* @__PURE__ */ jsx321("path", {
          id: "zw_svg__b",
          d: "M124.8 217.8c-3 0-5.1 2.1-5.1 5.2 0 4.8 5.4 7.2 8.6 3.8s1-9-3.5-9m0 1.2a4 4 0 0 1 4 4c0 3-3.3 5-6 3.7-2.7-1.5-2.5-6.1.4-7.3a4.3 4.3 0 0 1 1.5-.4z"
        }),
        /* @__PURE__ */ jsx321("use", {
          xlinkHref: "#zw_svg__b",
          width: "100%",
          height: "100%",
          x: -20.1,
          y: -0.6
        }),
        /* @__PURE__ */ jsx321("path", {
          d: "M88 145.3a1.7 1.8 0 0 0-1.6 1.7 1.7 1.8 0 1 0 3.5 0 1.7 1.8 0 0 0-1.9-1.7m.1.6a1.2 1.1 0 0 1 1.2 1.1 1.2 1.1 0 1 1-2.4 0 1.2 1.1 0 0 1 1.2-1.1"
        })
      ]
    })
  ]
});
var Zw_default = SvgZw;

// src/uds/components/IconCountryFlag/IconCountryFlag.tsx
import { jsx as jsx322 } from "react/jsx-runtime";
function modSize5(sizeName = 16) {
  return css22`
  & > svg {
    height: ${sizeName}px;
    width: ${sizeName}px;
  }
`;
}
var IconWrapper5 = styled33.span`
  display: inline-flex;
  flex-shrink: 0;

  ${({ $size }) => modSize5($size)}
`;
function IconCountryFlag({ className, glyph, size, ...attrs }) {
  const GlyphComponent = generated_exports2[glyph];
  if (GlyphComponent === void 0) {
    console.error(`Icon: No icon found for glyph "${glyph}"`);
    return null;
  }
  return /* @__PURE__ */ jsx322(IconWrapper5, {
    className,
    $size: size,
    children: /* @__PURE__ */ jsx322(GlyphComponent, {
      ...attrs
    })
  });
}
IconCountryFlag.displayName = "IconCountryFlag";
var IconCountryFlag_default = withStyleModifiers(styled33(IconCountryFlag)``, {
  modSize: modSize5
});

// src/uds/components/Menu/index.ts
init_esm_shims();

// src/uds/components/Menu/Menu.tsx
var Menu_exports = {};
__export(Menu_exports, {
  Content: () => Content10,
  Item: () => Item7,
  LinkItem: () => LinkItem,
  Root: () => Root14,
  Trigger: () => Trigger7
});
init_esm_shims();
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { styled as styled35 } from "styled-components";

// src/uds/components/Menu/MenuItem.tsx
init_esm_shims();
import React4 from "react";
import { styled as styled34 } from "styled-components";
import { Fragment, jsx as jsx323, jsxs as jsxs297 } from "react/jsx-runtime";
var ItemWrapper2 = styled34.button`
  width: 100%;
  min-height: ${tokPx("semantics_controls_m_min_height")};
  padding: ${space("primitives_space_8")};
  display: flex;
  align-items: center;
  gap: ${space("primitives_space_8")};
  border-radius: ${tokPx("primitives_corner_radius_l")};
  position: relative;
  text-decoration: none;

  &:hover {
    text-decoration: none;
    color: inherit;
    background-color: ${tok("primitives_color_neutral_100")};
  }

  ${focusOutline()}


  &:focus-visible:hover {
    outline: none;
  }
`;
styled34(ItemWrapper2)`
  text-decoration: none;
  color: inherit;

  &:hover {
    text-decoration: none;
    color: inherit;
  }
`;
var RightSlot = styled34(Typography_default)`
  margin: 0 0 0 auto;
  color: ${tok("semantics_content_secondary_color")};
`;
var TextCell = styled34.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;
  text-align: left;
`;
var SupportingText2 = styled34(Typography_default)`
  color: ${tok("semantics_content_secondary_color")};
`;
function Content8({ children, glyph, rightSlot, supportingText }) {
  return /* @__PURE__ */ jsxs297(Fragment, {
    children: [
      glyph ? /* @__PURE__ */ jsx323(IconCell_default, {
        glyph,
        size: "sm"
      }) : /* @__PURE__ */ jsx323(IconCell_default, {
        glyph: "QuestionMarkInCircle",
        size: "sm",
        hidden: true
      }),
      /* @__PURE__ */ jsxs297(TextCell, {
        children: [
          /* @__PURE__ */ jsx323(Typography_default, {
            $variant: "body-m-regular-tight",
            children
          }),
          supportingText && /* @__PURE__ */ jsx323(SupportingText2, {
            $variant: "body-s-regular-tight",
            children: supportingText
          })
        ]
      }),
      rightSlot && /* @__PURE__ */ jsx323(RightSlot, {
        $variant: "body-m-regular-tight",
        children: rightSlot
      })
    ]
  });
}
var MenuItem = React4.forwardRef(({ children, glyph, rightSlot, supportingText, ...rest }, forwardedRef) => {
  return /* @__PURE__ */ jsx323(ItemWrapper2, {
    ref: forwardedRef,
    ...rest,
    children: /* @__PURE__ */ jsx323(Content8, {
      glyph,
      children,
      rightSlot,
      supportingText
    })
  });
});
var MenuLinkItem = React4.forwardRef(({
  children,
  glyph,
  rightSlot,
  ...rest
}, forwardedRef) => {
  return /* @__PURE__ */ jsx323(ItemWrapper2, {
    as: "a",
    ref: forwardedRef,
    ...rest,
    children: /* @__PURE__ */ jsx323(Content8, {
      glyph,
      children,
      rightSlot
    })
  });
});

// src/uds/components/Menu/Menu.tsx
import { jsx as jsx324 } from "react/jsx-runtime";
var PositionMap = {
  "top": { side: "top", align: "center" },
  "bottom": { side: "bottom", align: "center" },
  "left": { side: "left", align: "center" },
  "right": { side: "right", align: "center" },
  "top-left": { side: "top", align: "end" },
  "top-right": { side: "top", align: "start" },
  "bottom-left": { side: "bottom", align: "end" },
  "bottom-right": { side: "bottom", align: "start" }
};
var ContentWrapper3 = styled35(DropdownMenu.Content)`
  background-color: ${tok("semantics_views_background_color")};
  padding: ${space("primitives_space_8")};
  border-radius: ${tokPx("semantics_overlays_corner_radius")};
  box-shadow: ${tok("primitives_box_shadows_level_4")};
  min-width: 280px;
  display: flex;
  flex-direction: column;
`;
var DropDownMenuItem = styled35(DropdownMenu.Item)`
  &:focus-visible {
    border-radius:  ${tokPx("primitives_corner_radius_l")};
    background: ${tok("primitives_color_neutral_100")};
  }
`;
var Root14 = DropdownMenu.Root;
function MenuContent({ children, position = "bottom", ...rest }) {
  const { side, align } = PositionMap[position];
  return /* @__PURE__ */ jsx324(DropdownMenu.Portal, {
    children: /* @__PURE__ */ jsx324(ContentWrapper3, {
      align,
      side,
      collisionPadding: 8,
      ...rest,
      children
    })
  });
}
var Content10 = styled35(MenuContent)``;
function Item7({ children, glyph, asChild, onSelect, ...rest }) {
  return /* @__PURE__ */ jsx324(DropDownMenuItem, {
    asChild: asChild != null ? asChild : true,
    onSelect,
    children: /* @__PURE__ */ jsx324(MenuItem, {
      glyph,
      ...rest,
      children
    })
  });
}
function LinkItem({
  children,
  glyph,
  ...rest
}) {
  return /* @__PURE__ */ jsx324(DropdownMenu.Item, {
    asChild: true,
    children: /* @__PURE__ */ jsx324(MenuLinkItem, {
      glyph,
      ...rest,
      children
    })
  });
}
function Trigger7({ children, ...rest }) {
  return /* @__PURE__ */ jsx324(DropdownMenu.Trigger, {
    ...rest,
    asChild: true,
    children
  });
}

// src/uds/components/Fields/PhoneField/PhoneField.tsx
import { jsx as jsx325, jsxs as jsxs298 } from "react/jsx-runtime";
var BaseFieldStyled2 = styled36(BaseField)`
  padding-right: ${space("primitives_space_12")};
  cursor: auto;
  &:has(div:focus) {
    outline: none;
  }
`;
var PhoneFieldCountry = styled36.div`
  display: flex;
  height: ${space("primitives_space_40")};
  padding: 0px ${space("primitives_space_4")} 0px ${space("primitives_space_8")};
  justify-content: center;
  align-items: center;
  align-self: stretch;
  background: ${tok("primitives_color_neutral_50")};
  border-radius: ${tokPx("primitives_corner_radius_m")} 0px 0px ${tokPx("primitives_corner_radius_m")};
  border-right: 1px solid ${tok("semantics_dividers_color")};
  ${focusWithinOutline(-4)};
`;
var IconCountryFlagWrapper = styled36(IconCountryFlag_default)`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: ${space("primitives_space_4")};
`;
var IconArrowWrapper = styled36(Icon_default)`
  display: flex;
  align-items: center;
  gap: ${space("primitives_space_8")};
`;
var CountryCodeText = styled36(Typography_default)`
  gap: ${space("primitives_space_8")};
`;
var OverFlowMenu = styled36(Menu_exports.Content)`
  width: ${tokPx("primitives_area_size_240")};
  max-height: calc((${space("primitives_space_40")} * 5) + (${space("primitives_space_40")} * 0.25));
  overflow-y: hidden;
  padding: ${space("primitives_space_0")};
  border-radius: ${tokPx("primitives_corner_radius_l")};
  background: ${tok("semantics_views_background_color")};
  box-shadow: ${tok("primitives_box_shadows_level_4")};
`;
var PhoneField = forwardRef3(
  ({
    children,
    countries,
    id,
    hintMessage,
    errorMessage,
    label,
    placeholder,
    $horizontalLabel,
    $disabled,
    value,
    countryCode,
    status = "default",
    onPhoneChange,
    onCountryChange,
    ...rest
  }, ref) => {
    var _a;
    const [open, setOpen] = React5.useState(false);
    const [selectedCountry, setSelectedCountry] = React5.useState(
      (_a = countries.find(({ code }) => code === countryCode)) != null ? _a : countries[0]
    );
    const [isCountryChanging, setIsCountryChanging] = React5.useState(false);
    const [visiblePhoneValue, setVisiblePhoneValue] = React5.useState(
      typeof value === "string" ? value.replace(`+${selectedCountry.code} `, "").trim() : ""
    );
    React5.useEffect(() => {
      if (isCountryChanging) {
        const currentPhoneWithoutCode = visiblePhoneValue.trim();
        onPhoneChange && onPhoneChange({
          phoneNumber: currentPhoneWithoutCode,
          countryCode: selectedCountry.code
        });
        setIsCountryChanging(false);
      }
    }, [selectedCountry, isCountryChanging, onPhoneChange, visiblePhoneValue]);
    React5.useEffect(() => {
      if (value) {
        setVisiblePhoneValue(value.replace(`+${selectedCountry.code} `, "").trim());
      }
    }, [value, selectedCountry]);
    const handleCountryClick = (country) => {
      setIsCountryChanging(true);
      setSelectedCountry(country);
      onCountryChange && onCountryChange(country);
      setOpen(false);
    };
    const handleChange = (event) => {
      const newPhoneValue = event.target.value;
      setVisiblePhoneValue(newPhoneValue);
      if (!isCountryChanging) {
        onPhoneChange && onPhoneChange({
          phoneNumber: newPhoneValue,
          countryCode: selectedCountry.code
        });
      }
    };
    return /* @__PURE__ */ jsxs298(BaseFieldStyled2, {
      ...rest,
      status,
      tabIndex: -1,
      children: [
        /* @__PURE__ */ jsxs298(Menu_exports.Root, {
          onOpenChange: setOpen,
          open,
          children: [
            /* @__PURE__ */ jsx325(Menu_exports.Trigger, {
              "data-country-selector": true,
              children: /* @__PURE__ */ jsxs298(PhoneFieldCountry, {
                tabIndex: 0,
                children: [
                  /* @__PURE__ */ jsx325(IconCountryFlagWrapper, {
                    glyph: selectedCountry.icon,
                    size: 16
                  }),
                  /* @__PURE__ */ jsxs298(CountryCodeText, {
                    $variant: "body-s-regular-tight",
                    children: [
                      "+",
                      selectedCountry.code
                    ]
                  }),
                  /* @__PURE__ */ jsx325(IconArrowWrapper, {
                    size: 16,
                    glyph: open ? "ChevronUpExtraSmall" : "ChevronDownExtraSmall"
                  })
                ]
              })
            }),
            /* @__PURE__ */ jsx325(OverFlowMenu, {
              position: "bottom-right",
              children: /* @__PURE__ */ jsx325("div", {
                style: { overflowY: "auto", padding: "8px" },
                children: countries == null ? void 0 : countries.map((item) => /* @__PURE__ */ jsxs298(Menu_exports.Item, {
                  asChild: false,
                  onSelect: () => handleCountryClick(item),
                  glyph: item.code === selectedCountry.code ? "CheckMarkSmall" : void 0,
                  children: [
                    item.name,
                    " ",
                    "(+",
                    item.code,
                    ")"
                  ]
                }, item.code))
              })
            })
          ]
        }),
        /* @__PURE__ */ jsx325(Input, {
          tabIndex: 0,
          ref,
          name: rest.name,
          disabled: $disabled,
          value: visiblePhoneValue,
          type: "tel",
          onChange: handleChange,
          onBlur: rest.onBlur
        }),
        /* @__PURE__ */ jsx325(StyledValidationIcon, {
          status
        })
      ]
    });
  }
);
PhoneField.displayName = "PhoneField";
var PhoneField_default = styled36(PhoneField)``;

// src/uds/components/Fields/RadioButtonField.tsx
init_esm_shims();
import { jsx as jsx326 } from "react/jsx-runtime";
function RadioButtonField({
  label,
  id,
  disabled,
  className,
  variant = "transparent",
  ...rest
}) {
  return /* @__PURE__ */ jsx326(SelectionField, {
    label,
    disabled,
    className,
    variant,
    select: "radio",
    ...rest
  });
}

// src/uds/components/Fields/SearchField.tsx
init_esm_shims();
import * as React6 from "react";
import { styled as styled37 } from "styled-components";
import { jsx as jsx327, jsxs as jsxs299 } from "react/jsx-runtime";
var IconWrapper6 = styled37(Icon_default)`
  padding-left: ${space("primitives_space_8")};
  padding-right: ${space("primitives_space_8")};
  color: ${tok("semantics_content_secondary_color")};
`;
var IconClear = styled37(Icon_default)`
  border-radius: ${tokPx("primitives_corner_radius_full")};
  background-color: ${tok("primitives_color_neutral_100")};
  padding: ${space("primitives_space_2")};
`;
var SearchInput = styled37(Input)`
  padding-left: 0;
`;
var ClearButton = styled37.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${space("primitives_space_48")};

  ${focusOutline()}
`;
function SearchField(props) {
  var _a;
  const [internalValue, setInternalValue] = React6.useState(props.defaultValue || "");
  const inputRef = React6.useRef(null);
  const handleOnChange = (e) => {
    var _a2;
    setInternalValue(e.target.value);
    (_a2 = props.onChange) == null ? void 0 : _a2.call(props, e);
  };
  const handleOnClear = () => {
    var _a2;
    if (!(inputRef == null ? void 0 : inputRef.current))
      return;
    inputRef.current.value = "";
    setInternalValue("");
    (_a2 = props.onChange) == null ? void 0 : _a2.call(props, { target: { value: "" } });
  };
  React6.useEffect(() => {
    if (inputRef.current) {
      setInternalValue(inputRef.current.value);
    }
  }, [(_a = inputRef == null ? void 0 : inputRef.current) == null ? void 0 : _a.value]);
  return /* @__PURE__ */ jsxs299(BaseField, {
    ...props,
    children: [
      /* @__PURE__ */ jsx327(IconWrapper6, {
        glyph: "Magnifier",
        size: 20
      }),
      /* @__PURE__ */ jsx327(SearchInput, {
        defaultValue: props.defaultValue,
        name: props.name,
        disabled: props.disabled,
        onChange: handleOnChange,
        onBlur: props.onBlur,
        placeholder: props.placeholder,
        ref: inputRef,
        autoFocus: true
      }),
      internalValue.length > 0 && /* @__PURE__ */ jsx327(ClearButton, {
        onClick: handleOnClear,
        children: /* @__PURE__ */ jsx327(IconClear, {
          glyph: "DismissSmall",
          size: 16
        })
      })
    ]
  });
}
var SearchField_default = styled37(SearchField)``;

// src/uds/components/Fields/SwitchField.tsx
init_esm_shims();
import { css as css24, styled as styled39 } from "styled-components";

// src/uds/components/Switch/index.ts
init_esm_shims();

// src/uds/components/Switch/Switch.tsx
init_esm_shims();
import * as SwitchPrimitives from "@radix-ui/react-switch";
import * as React7 from "react";
import { css as css23, styled as styled38 } from "styled-components";
import { jsx as jsx328 } from "react/jsx-runtime";
var Thumb4 = styled38(SwitchPrimitives.Thumb)`
  width: 16px;
  height: 16px;
  color: ${tok("semantics_selectors_shape_color")};
  background: ${tok("semantics_selectors_shape_color")};
  border-radius: ${tokPx("primitives_corner_radius_full")};
  display: block;
  transition-property: transform, background, color;
  transition-duration: 300ms;

  &[data-state='checked'] {
    transform: translateX(20px) scale(1.25);
    background: ${tok("semantics_selectors_selected_content_color")};
    color: ${tok("semantics_selectors_selected_background_color")};
  }
`;
var Wrapper4 = styled38(SwitchPrimitives.Root)`
  width: 44px;
  height: 24px;
  background-color: ${tok("semantics_selectors_background_color")};
  border-radius: ${tokPx("primitives_corner_radius_full")};
  padding: ${space("primitives_space_2")};
  border-width: ${tokPx("semantics_selectors_border_width")};
  border-style: solid;
  border-color: ${tok("semantics_selectors_shape_color")};
  transition-property: background, border-color;
  transition-duration: 300ms;
  position: relative;

  &[data-state='checked'] {
    background-color: ${tok("semantics_selectors_selected_background_color")};
    border-color: ${tok("semantics_selectors_selected_background_color")};
  }

  &:hover {
    background-color: ${tok("semantics_selectors_hover_background_color")};
    border-color: ${tok("semantics_selectors_hover_shape_color")};
  }

  &[data-state='checked']:hover {
    background-color: ${tok("semantics_selectors_selected_hover_background_color")};
    border-color: ${tok("semantics_selectors_selected_hover_background_color")};

    ${Thumb4} {
      color: ${tok("semantics_selectors_selected_hover_background_color")};
    }
  }

  ${focusOutline()}
  ${({ disabled }) => disabled && modDisabled7()}
`;
function modDisabled7() {
  return css23`
  pointer-events: none;
  opacity: ${tok("primitives_opacity_disabled")}%;
`;
}
var Switch = React7.forwardRef(({ ...props }, ref) => /* @__PURE__ */ jsx328(Wrapper4, {
  ...props,
  ref,
  children: /* @__PURE__ */ jsx328(Thumb4, {
    children: /* @__PURE__ */ jsx328(Icon_default, {
      size: 16,
      glyph: "CheckMarkExtraSmall"
    })
  })
}));
var Switch_default = styled38(Switch)``;
Switch.displayName = SwitchPrimitives.Root.displayName;

// src/uds/components/Fields/SwitchField.tsx
import { jsx as jsx329, jsxs as jsxs300 } from "react/jsx-runtime";
var Wrapper5 = styled39.label`
  padding: ${space("primitives_space_12")} 0;
  display: flex;
  align-items: center;
  gap: ${space("primitives_space_8")};
  user-select: none;
  width: 100%;
  border-radius: ${tokPx("semantics_controls_m_corner_radius")};
  color: ${tok("semantics_content_color")};

  ${Switch_default} {
    ${resetFocusOutline()}
    flex-shrink: 0;
    ${({ $disabled }) => $disabled && css24`opacity: initial;`}
  }

  ${({ $variant }) => $variant === "outlined" && css24`
      padding: ${space("primitives_space_12")};
      background-color: ${tok("semantics_views_background_color")};
      border: ${tokPx("semantics_input_fields_border_width")} solid ${tok("semantics_selectors_border_color")};
    `}

  ${({ $disabled }) => $disabled && css24`
    opacity: ${tok("primitives_opacity_disabled")}%;
  `}

  ${focusWithinOutline()}
`;
function SwitchField({
  label,
  id,
  disabled,
  className,
  variant = "transparent",
  ...rest
}) {
  return /* @__PURE__ */ jsxs300(Wrapper5, {
    $disabled: disabled,
    htmlFor: id,
    className,
    $variant: variant,
    children: [
      /* @__PURE__ */ jsx329(Switch_default, {
        disabled,
        id,
        "aria-describedby": label ? `${id}-label` : void 0,
        ...rest
      }),
      label && /* @__PURE__ */ jsx329(Typography_default, {
        $variant: "body-m-regular-tight",
        id: `${id}-label`,
        children: label
      })
    ]
  });
}

// src/uds/components/Fields/TextArea.tsx
init_esm_shims();
import { forwardRef as forwardRef5 } from "react";
import { styled as styled40 } from "styled-components";
import { jsx as jsx330, jsxs as jsxs301 } from "react/jsx-runtime";
var BaseFieldTextArea = styled40(BaseField)`
  height: ${space("primitives_space_96")};
  padding-right: ${space("primitives_space_12")};

  ${StyledValidationIcon} {
    align-self: flex-start;
    padding-top: ${space("primitives_space_12")};
  }

  & > textarea {
    width: 100%;
    height: 100%;
    resize: none;
    cursor: text;
  }
`;
var TextAreaElement = styled40.textarea`
  ${inputStyles()}
`;
var TextArea = forwardRef5(
  (props, ref) => {
    const { children, value, status, ...rest } = props;
    return /* @__PURE__ */ jsxs301(BaseFieldTextArea, {
      ...props,
      children: [
        /* @__PURE__ */ jsx330(TextAreaElement, {
          ref,
          value,
          ...rest,
          children: Boolean(!value) && children
        }),
        /* @__PURE__ */ jsx330(StyledValidationIcon, {
          status: status != null ? status : "default"
        })
      ]
    });
  }
);
TextArea.displayName = "TextArea";
var TextArea_default = styled40(TextArea)``;

// src/uds/components/Fields/TextField.tsx
init_esm_shims();
import { forwardRef as forwardRef6 } from "react";
import { styled as styled41 } from "styled-components";
import { jsx as jsx331, jsxs as jsxs302 } from "react/jsx-runtime";
var BaseFieldStyled3 = styled41(BaseField)`
  padding-right: ${space("primitives_space_12")};
  ${Input} {
    cursor: auto;
  }
`;
var TextField = forwardRef6((props, ref) => {
  var _a;
  return /* @__PURE__ */ jsxs302(BaseFieldStyled3, {
    ...props,
    children: [
      /* @__PURE__ */ jsx331(Input, {
        ref,
        name: props.name,
        disabled: props.disabled,
        value: props.value,
        onChange: props.onChange,
        onBlur: props.onBlur,
        placeholder: props.placeholder
      }),
      /* @__PURE__ */ jsx331(StyledValidationIcon, {
        status: (_a = props.status) != null ? _a : "default"
      })
    ]
  });
});
TextField.displayName = "TextField";
var TextField_default = styled41(TextField)``;

// src/uds/components/IndeterminateProgressCircle/index.ts
init_esm_shims();

// src/uds/components/IndeterminateProgressCircle/IndeterminateProgressCircle.tsx
init_esm_shims();
import { keyframes as keyframes3, styled as styled42 } from "styled-components";
import { jsx as jsx332 } from "react/jsx-runtime";
var loadingIconSpinningAnimation = keyframes3`
  to {
    transform: rotate(360deg);
  }
`;
var IndeterminateProgressCircle = styled42(({ className, size = 24 }) => /* @__PURE__ */ jsx332(Icon_default, {
  className,
  glyph: "Spinner",
  size
}))`
  animation: ${loadingIconSpinningAnimation} 1s linear infinite;
`;
var IndeterminateProgressCircle_default = IndeterminateProgressCircle;

// src/uds/components/InputStepper/index.ts
init_esm_shims();

// src/uds/components/InputStepper/InputStepper.tsx
init_esm_shims();
import * as React8 from "react";
import { css as css25, styled as styled43 } from "styled-components";
import { jsx as jsx333, jsxs as jsxs303 } from "react/jsx-runtime";
var INITIAL_VALUE = 0;
var STEP_VALUE = 1;
var Button3 = styled43.button`
  height: 100%;
  background-color: ${tok("primitives_color_neutral_100")};
  border-radius: ${tokPx("primitives_corner_radius_xs")};
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  outline: 0;

  &:hover {
    background-color: ${tok("primitives_color_neutral_150")};
  }

  ${focusOutline()}

  ${Icon_default} {
    :focus {
      outline: 0;
    }
    color: ${tok("semantics_content_color")};
  }

  ${({ disabled }) => disabled && modDisabled8()}
}`;
function modDisabled8() {
  return css25`
  pointer-events: none;
  opacity: ${tok("primitives_opacity_disabled")}%;
`;
}
function modSize6(sizeName = "M") {
  return {
    S: css25`
      height: ${tok("semantics_controls_s_min_height")}px;
      width: 100px;
      ${Button3} {
        width: 24px;
      }
      ${Icon_default} {
        ${Icon_default.modSize(16)}
      }
    `,
    M: css25`
      height: ${tok("semantics_controls_m_min_height")}px;
      width: 124px;
      ${Button3} {
        width: 36px;
      }
      ${Icon_default} {
        ${Icon_default.modSize(24)}
      }
    `
  }[sizeName];
}
var Wrapper6 = styled43.div`
  display: flex;
  border: 2px solid ${tok("semantics_input_fields_border_color")};
  border-radius: ${tokPx("semantics_controls_m_corner_radius")};
  padding: ${space("primitives_space_2")};
  justify-content: space-between;
  align-items: center;
  background-color: ${tok("semantics_views_background_color")};
  &:hover {
    border-color: ${tok("semantics_input_fields_hover_border_color")};
  }
  ${({ $size }) => modSize6($size)}
  ${({ $disabled }) => $disabled && modDisabled8()}
`;
var Value2 = styled43.input`
  border: transparent;
  text-align: center;
  background: transparent;
  margin: 0;
  padding: 0;
  min-width: 0;
  width: 36px;
  height: calc(100% - ${space("primitives_space_4")});
  border-radius: ${tokPx("primitives_corner_radius_xs")};
  ${Typography_default.modVariant("body-m-regular-tight")};
  font-size: ${tokPx("primitives_font_size_body_l")};
  line-height: 125%;

  ${focusOutline(0)}

  &[type='number'] {
    -moz-appearance: textfield;
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
`;
function InputStepper({
  initialValue = INITIAL_VALUE,
  minimumValue = 0,
  maximumValue = Number.MAX_SAFE_INTEGER,
  stepValue = STEP_VALUE,
  decrementButtonAriaLabel = "decrement",
  incrementButtonAriaLabel = "increment",
  valueAriaLabel = "value",
  size = "M",
  disabled = false,
  onChange = (val) => val,
  disableInput = false
}) {
  const [value, setValue] = React8.useState(initialValue);
  const canBeDecreased = value - stepValue >= minimumValue;
  const canBeIncreased = value + stepValue <= maximumValue;
  const handleChangeValue = (itemValue) => {
    setValue(itemValue);
    onChange(itemValue);
  };
  const handleValidateValue = (itemValue) => {
    if (itemValue < minimumValue) {
      setValue(minimumValue);
      onChange(minimumValue);
      return;
    }
    if (itemValue > maximumValue) {
      setValue(maximumValue);
      onChange(maximumValue);
      return;
    }
    handleChangeValue(itemValue);
  };
  const decreaseValueHandler = () => {
    if (!canBeDecreased)
      return;
    const newValue = value - stepValue;
    handleChangeValue(newValue);
  };
  const increaseValueHandler = () => {
    if (!canBeIncreased)
      return;
    const newValue = value + stepValue;
    handleChangeValue(newValue);
  };
  return /* @__PURE__ */ jsxs303(Wrapper6, {
    $size: size,
    $disabled: disabled,
    children: [
      /* @__PURE__ */ jsx333(Button3, {
        onClick: decreaseValueHandler,
        "aria-disabled": disabled || !canBeDecreased,
        "aria-label": decrementButtonAriaLabel,
        disabled: disabled || !canBeDecreased,
        children: /* @__PURE__ */ jsx333(Icon_default, {
          glyph: "Minus",
          "aria-hidden": "true"
        })
      }),
      !disableInput ? /* @__PURE__ */ jsx333(Value2, {
        type: "number",
        "aria-label": valueAriaLabel,
        value,
        disabled,
        onChange: (e) => handleChangeValue(Number(e.target.value)),
        onBlur: (e) => handleValidateValue(Number(e.target.value))
      }) : /* @__PURE__ */ jsx333(Typography_default, {
        $variant: "body-m-regular-tight",
        children: value
      }),
      /* @__PURE__ */ jsx333(Button3, {
        onClick: increaseValueHandler,
        "aria-disabled": disabled || !canBeIncreased,
        "aria-label": incrementButtonAriaLabel,
        disabled: disabled || !canBeIncreased,
        children: /* @__PURE__ */ jsx333(Icon_default, {
          glyph: "Plus",
          "aria-hidden": "true"
        })
      })
    ]
  });
}
InputStepper.displayName = "InputStepper";
var InputStepper_default = withStyleModifiers(styled43(InputStepper)``, {
  modSize: modSize6
});

// src/uds/components/Layout/index.ts
init_esm_shims();

// src/uds/components/Layout/Layout.tsx
init_esm_shims();
import { css as css26, styled as styled44 } from "styled-components";
var Layout = styled44.div`
  margin-left: auto;
  margin-right: auto;
  max-width: ${tokPx("primitives_area_size_1440")};

  ${modVariant2()}
`;
var Layout_default = Layout;
function modFullWidth3() {
  return css26`
    padding: 0;
  `;
}
function modPadded() {
  return css26`
    padding-left: ${space("primitives_space_16")};
    padding-right: ${space("primitives_space_16")};

    @media ${mqMin("primitives_breakpoint_m_min")} {
      padding-left: ${space("primitives_space_32")};
      padding-right: ${space("primitives_space_32")};
    }

    @media ${mqMin("primitives_breakpoint_l_min")} {
      padding-left: ${space("primitives_space_48")};
      padding-right: ${space("primitives_space_48")};
    }
  `;
}
function modVariant2(variant = "padded") {
  switch (variant) {
    case "fullWidth":
      return modFullWidth3();
    default:
      return modPadded();
  }
}

// src/uds/components/ListItem/index.ts
init_esm_shims();

// src/uds/components/ListItem/ListItem.tsx
init_esm_shims();
import { css as css27, styled as styled45 } from "styled-components";
import { jsx as jsx334 } from "react/jsx-runtime";
var Wrapper7 = styled45.div`
  ${({ $variant }) => ["divider", "tinted", "outlined"].includes($variant != null ? $variant : "") && css27`
      padding: ${space("primitives_space_12")};
      border-radius: ${tokPx("primitives_corner_radius_m")};
      min-height: ${tokPx("semantics_controls_m_min_height")};

      @media ${mqMin("primitives_breakpoint_m_min")} {
        padding: ${space("primitives_space_16")};
        min-height: ${space("primitives_space_48")};
      }
    `}

  ${({ $variant }) => modVariant3($variant)};

  ${({ $hasHover, $variant }) => $hasHover && ["transparent", "divider"].includes($variant != null ? $variant : "") && css27`
      &:hover {
        background-color: ${tok("primitives_color_neutral_100")};
      }
    `}
`;
function ListItem2({ children, hasHover, variant }) {
  return /* @__PURE__ */ jsx334(Wrapper7, {
    $hasHover: hasHover,
    $variant: variant,
    children
  });
}
function modVariant3(variantName = "outlined") {
  return {
    transparent: css27`
      padding-top: ${tokPx("primitives_space_8")};
      padding-right: ${tokPx("primitives_space_0")};
      padding-bottom: ${tokPx("primitives_space_8")};
      padding-left: ${tokPx("primitives_space_0")};
      min-height: ${space("primitives_space_24")};
    `,
    divider: css27`
      padding-right: ${tokPx("primitives_space_0")} !important;
      padding-left: ${tokPx("primitives_space_0")} !important;
      border-bottom: ${tokPx("semantics_dividers_tickness")} solid ${tok("semantics_dividers_color")} !important;
      border-radius: ${tokPx("primitives_corner_radius_none")} !important;
    `,
    tinted: css27`
       background-color: ${tok("semantics_views_tinted_background_color")};
    `,
    outlined: css27`
      background-color: ${tok("semantics_views_background_color")};
      border: ${tokPx("semantics_dividers_tickness")} solid ${tok("semantics_dividers_color")};
    `
  }[variantName];
}
var ListItem_default = withStyleModifiers(styled45(ListItem2)``, {
  modVariant: modVariant3
});

// src/uds/components/Pagination/index.ts
init_esm_shims();

// src/uds/components/Pagination/Pagination.tsx
init_esm_shims();
import * as React9 from "react";
import { css as css28, styled as styled46 } from "styled-components";

// src/uds/components/Pagination/utils.ts
init_esm_shims();
var DOTS = "...";
function getPaginationRange(currentPage, totalPages, totalPageNumbers) {
  if (totalPages <= totalPageNumbers) {
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  }
  const leftSiblingIndex = Math.max(currentPage - 1, 1);
  const rightSiblingIndex = Math.min(currentPage + 1, totalPages);
  const firstPageIndex = 1;
  const lastPageIndex = totalPages;
  if (totalPageNumbers === 1) {
    return [currentPage];
  }
  if (totalPageNumbers === 4) {
    if (currentPage === 1) {
      return [firstPageIndex, firstPageIndex + 1, DOTS, lastPageIndex];
    }
    if (currentPage === firstPageIndex + 1) {
      return [firstPageIndex, currentPage, DOTS, lastPageIndex];
    }
    if (currentPage === totalPages) {
      return [firstPageIndex, DOTS, lastPageIndex - 1, lastPageIndex];
    }
    if (currentPage === totalPages - 1) {
      return [firstPageIndex, DOTS, currentPage, lastPageIndex];
    }
    return [firstPageIndex, DOTS, currentPage, DOTS];
  }
  if (totalPageNumbers === 5) {
    if (currentPage <= 3) {
      return [1, 2, 3, DOTS, lastPageIndex];
    }
    if (currentPage >= totalPages - 2) {
      return [firstPageIndex, DOTS, totalPages - 2, totalPages - 1, totalPages];
    }
    return [firstPageIndex, DOTS, currentPage, DOTS, lastPageIndex];
  }
  if (totalPageNumbers === 7) {
    if (currentPage <= 4) {
      return [1, 2, 3, 4, 5, DOTS, lastPageIndex];
    }
    if (currentPage >= totalPages - 3) {
      return [firstPageIndex, DOTS, totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    }
    if (currentPage === leftSiblingIndex && rightSiblingIndex < totalPages - 1) {
      return [firstPageIndex, DOTS, leftSiblingIndex, currentPage, rightSiblingIndex, DOTS, lastPageIndex];
    }
    if (currentPage === rightSiblingIndex && leftSiblingIndex > 2) {
      return [firstPageIndex, DOTS, leftSiblingIndex, currentPage, rightSiblingIndex, DOTS, lastPageIndex];
    }
    return [firstPageIndex, DOTS, leftSiblingIndex, currentPage, rightSiblingIndex, DOTS, lastPageIndex];
  }
  return [];
}

// src/uds/components/Pagination/Pagination.tsx
import { jsx as jsx335, jsxs as jsxs304 } from "react/jsx-runtime";
var PreviousAndNextButtonWrapper = styled46(IconButton_default)``;
var PaginationButton = styled46.button`
  border-radius: ${tokPx("semantics_buttons_m_corner_radius")};
  border: ${tokPx("semantics_dividers_tickness")} solid ${tok("semantics_dividers_color")};
  background: ${tok("primitives_color_neutral_50")};

  @media ${mqMin("primitives_breakpoint_m_min")} {
    ${Typography_default.modVariant("body-m-bold-tight")};
  }

  ${({ $selected }) => $selected ? css28`
          background-color: ${tok("semantics_navigation_item_neutral_current_background_color")};
          border: none;
          ${Typography_default} {
            color: ${tok("semantics_navigation_item_primary_current_content_color")};
          }
        ` : css28`
          @media (hover: hover) {
            &:hover {
              background-color: ${tok("semantics_selectors_hover_background_color")};
              border: ${tokPx("semantics_dividers_tickness")} solid ${tok("semantics_selectors_hover_border_color")};
            }
          }
        `}
`;
function PreviousPageButton({ ...rest }) {
  return /* @__PURE__ */ jsx335(PreviousAndNextButtonWrapper, {
    type: "secondary",
    glyph: "ChevronLeft",
    ...rest,
    size: "M"
  });
}
function NextPageButton({ ...rest }) {
  return /* @__PURE__ */ jsx335(PreviousAndNextButtonWrapper, {
    type: "secondary",
    glyph: "ChevronRight",
    ...rest,
    size: "M"
  });
}
function PageButton({ children, selected = false, ...rest }) {
  return /* @__PURE__ */ jsx335(PaginationButton, {
    $selected: selected,
    ...rest,
    children: /* @__PURE__ */ jsx335(Typography_default, {
      $variant: "body-s-bold-tight",
      children
    })
  });
}
var EllipsisWrapper = styled46.div`
  display: flex;
  align-items: center;
  justify-content: center;

  @media ${mqMin("primitives_breakpoint_m_min")} {
    ${Icon_default} {
      ${Icon_default.modSize(24)};
    }
  }
`;
function Ellipsis({ ...rest }) {
  return /* @__PURE__ */ jsx335(EllipsisWrapper, {
    ...rest,
    children: /* @__PURE__ */ jsx335(Icon_default, {
      glyph: "EllipsisHorizontal",
      size: 16
    })
  });
}
var Root16 = styled46.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${space("primitives_space_8")};
  gap: ${space("primitives_space_8")};
  border-radius: ${tokPx("components_pagination_corner_radius")};
  border: ${tokPx("semantics_dividers_tickness")} solid ${tok("semantics_dividers_color")};
  background-color: ${tok("semantics_views_background_color")};

  > * {
    width: ${tokPx("semantics_controls_m_min_height")};
    height: ${tokPx("semantics_controls_m_min_height")};
  }
`;
var PaginationWrapper = styled46.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: stretch;
`;
function Pagination({
  currentPage,
  totalPages,
  totalPageNumbers,
  goToPreviousPage,
  goToNextPage,
  goToPage
}) {
  const { isMobile, isTablet, isDesktop } = useBreakpoints();
  const totalItems = totalPageNumbers || (isDesktop ? 7 : isTablet ? 5 : isMobile ? 4 : 1);
  const paginationRange = React9.useMemo(() => {
    return getPaginationRange(currentPage, totalPages, totalItems);
  }, [currentPage, totalPages, totalItems]);
  const isFirstPage = currentPage === 1;
  const isLastPage = currentPage === totalPages;
  return /* @__PURE__ */ jsx335(PaginationWrapper, {
    children: /* @__PURE__ */ jsxs304(Root16, {
      children: [
        /* @__PURE__ */ jsx335(PreviousPageButton, {
          onClick: goToPreviousPage,
          disabled: isFirstPage
        }),
        paginationRange.map((pageNumber, index) => {
          if (pageNumber === DOTS) {
            return /* @__PURE__ */ jsx335(Ellipsis, {}, index);
          }
          return /* @__PURE__ */ jsx335(PageButton, {
            onClick: () => goToPage(Number(pageNumber)),
            selected: pageNumber === currentPage,
            children: pageNumber
          }, index);
        }),
        /* @__PURE__ */ jsx335(NextPageButton, {
          onClick: goToNextPage,
          disabled: isLastPage
        })
      ]
    })
  });
}

// src/uds/components/Popover/index.ts
init_esm_shims();

// src/uds/components/Popover/Popover.tsx
var Popover_exports = {};
__export(Popover_exports, {
  Body: () => Body,
  Content: () => Content12,
  PopoverContent: () => PopoverContent,
  Root: () => Root19,
  Trigger: () => Trigger9
});
init_esm_shims();
import * as RadixPopover from "@radix-ui/react-popover";
import * as React11 from "react";
import { css as css29, styled as styled48 } from "styled-components";

// src/uds/components/TopTitleBar/index.ts
init_esm_shims();

// src/uds/components/TopTitleBar/TopTitleBar.tsx
init_esm_shims();
import React10 from "react";
import { styled as styled47 } from "styled-components";

// src/uds/components/TopTitleBar/constants.ts
init_esm_shims();
var TOP_TITLE_BAR_HEIGHT = "48px";

// src/uds/components/TopTitleBar/TopTitleBar.tsx
import { jsx as jsx336, jsxs as jsxs305 } from "react/jsx-runtime";
var SIDE_AREA_WIDTH = "120px";
var LeftAreaWrapper = styled47.div`
  flex: 0 0 ${SIDE_AREA_WIDTH};
  width: ${SIDE_AREA_WIDTH};
`;
var CenterAreaWrapper = styled47.div`
  display: flex;
  padding: 0 ${space("primitives_space_6")};
  justify-content: center;
  align-items: center;
  flex: 1 1 0;
  align-self: stretch;
  overflow: hidden;
  white-space: nowrap;
`;
var RightAreaWrapper = styled47.div`
  flex: 0 0 ${SIDE_AREA_WIDTH};
  display: flex;
  width: ${SIDE_AREA_WIDTH};
  justify-content: flex-end;

  & > button {
    display: flex;
    align-items: center;
    justify-content: center;
    ${focusOutline()}
    color: ${tok("semantics_buttons_transparent_primary_content_color")};
  }
`;
var Title4 = styled47(Typography_default)`
  text-overflow: ellipsis;
  overflow: hidden;
`;
var Wrapper8 = styled47.div`
  width: 100%;
  display: flex;
  align-items: center;
  min-height: ${TOP_TITLE_BAR_HEIGHT};
  height: ${TOP_TITLE_BAR_HEIGHT};
  border-bottom: ${tokPx("semantics_dividers_tickness")} solid ${tok("semantics_dividers_color")};
  background-color: ${tok("semantics_views_background_color")};

  ${LeftAreaWrapper}, ${RightAreaWrapper} {
    & > button {
      min-height: calc(${tokPx("semantics_controls_m_min_height")} - ${tokPx("primitives_space_12")});
      max-height: calc(${tokPx("semantics_controls_m_min_height")} - ${tokPx("primitives_space_12")});
      margin: ${space("primitives_space_8")};
      padding: ${space("primitives_space_4")} ${space("primitives_space_8")};
      border-radius: ${tokPx("primitives_corner_radius_l")};
    }
  }
`;
function Root17({ children, ...rest }) {
  let left = null;
  let titleLabel = "";
  let right = null;
  React10.Children.forEach(children, (child) => {
    if (!React10.isValidElement(child))
      return;
    const element = child;
    if (element.type === LeftArea)
      left = child.props.children;
    if (element.type === CenterArea)
      titleLabel = child.props.title;
    if (element.type === RightArea)
      right = child.props.children;
  });
  return /* @__PURE__ */ jsxs305(Wrapper8, {
    ...rest,
    children: [
      /* @__PURE__ */ jsx336(LeftArea, {
        children: left
      }),
      /* @__PURE__ */ jsx336(CenterArea, {
        title: titleLabel
      }),
      /* @__PURE__ */ jsx336(RightArea, {
        children: right
      })
    ]
  });
}
function LeftArea({ children }) {
  return /* @__PURE__ */ jsx336(LeftAreaWrapper, {
    children
  });
}
function CenterArea({ title }) {
  return /* @__PURE__ */ jsx336(CenterAreaWrapper, {
    children: title && /* @__PURE__ */ jsx336(Title4, {
      $variant: "body-m-bold-tight",
      children: title
    })
  });
}
function RightArea({ children }) {
  return /* @__PURE__ */ jsx336(RightAreaWrapper, {
    children
  });
}
var TopTitleBar = {
  Root: Root17,
  LeftArea,
  CenterArea,
  RightArea
};

// src/uds/components/Popover/Popover.tsx
import { jsx as jsx337, jsxs as jsxs306 } from "react/jsx-runtime";
var POPOVER_UPPER_SPACING = space("primitives_space_48");
var PositionMap2 = {
  "top": { side: "top", align: "center" },
  "bottom": { side: "bottom", align: "center" },
  "left": { side: "left", align: "center" },
  "right": { side: "right", align: "center" },
  "top-left": { side: "top", align: "end" },
  "top-right": { side: "top", align: "start" },
  "bottom-left": { side: "bottom", align: "end" },
  "bottom-right": { side: "bottom", align: "start" }
};
var StyledPopoverContent = styled48(RadixPopover.Content)`
  max-height: calc(100vh - ${POPOVER_UPPER_SPACING});
  max-height: calc(100dvh - ${POPOVER_UPPER_SPACING}); // using dvh to support for Safari mobile
  z-index: ${zIndex.level6};

  @media ${mqMin("primitives_breakpoint_m_min")} {
    max-height: var(--radix-popover-content-available-height, initial);
  }
`;
var StyledPopover = styled48.aside`
  max-height: inherit;
  height:inherit;
  display: flex;
  flex-direction: column;
  background: ${tok("semantics_views_background_color")};
  color: ${tok("semantics_content_color")};
  overflow: hidden; // Prevents content overflow making corner radius consistent
  border-radius: ${tokPx("semantics_overlays_corner_radius")};
  box-shadow: ${tok("primitives_box_shadows_level_4")};

  //Focus State
  ${focusOutline()}
`;
var Body = styled48.div`
  flex: 1 1 auto;
  overflow-y: auto;
  max-height: calc(100vh - (${POPOVER_UPPER_SPACING} + ${TOP_TITLE_BAR_HEIGHT}));
`;
function modWithPadding(hasPadding = true) {
  return css29`
    ${Body} {
      padding: ${hasPadding ? space("primitives_space_16") : "0"};
    }
  `;
}
var Backdrop3 = styled48(RadixPopover.Close)`
  ${backdropStyles()}
`;
var StyledPopoverWrapper = styled48.div`
  @media ${mqMin("primitives_breakpoint_m_min")} {
    ${StyledPopoverContent} {
      width: 340px;
    }

    ${Backdrop3} {
      display: none; // Hide backdrop on desktop to prevent clicking outside to close the popover
    }
  }

  [data-radix-popper-content-wrapper] {
    ${({ $fullHeight }) => $fullHeight && css29`
        @media ${mqMax("primitives_breakpoint_s_max")} {
          &,
          ${StyledPopoverContent}, ${StyledPopover} {
            height: 100%;
          }
          ${StyledPopoverContent} {
            bottom: 0;
            position: fixed;
            width: 100%;
          }
        }
      `}
  }

  @media ${mqMax("primitives_breakpoint_s_max")} {
    [data-radix-popper-content-wrapper] {
      top: auto !important; // Enforced to override radix inline styles
      bottom: 0;
      right: 0;
      transform: translate(0, 0) !important; // Enforced to override radix inline styles
      z-index: ${zIndex.level6} !important; // Enforced to override radix inline styles
      min-width: auto !important; // Enforced to override radix inline styles
    }

    ${StyledPopoverContent} {
      animation-duration: 0.6s;
      animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);

      &[data-side='bottom'] {
        animation-name: ${slideInFromBottom};
      }
    }
  }
`;
var TopTitleBarRoot = styled48(TopTitleBar.Root)`
  border-top-left-radius: ${tokPx("primitives_corner_radius_xxl")};
  border-top-right-radius: ${tokPx("primitives_corner_radius_xxl")};

  @media ${mqMin("primitives_breakpoint_m_min")} {
    ${({ $showOnDesktop }) => !$showOnDesktop && css29`
        display: none;
      `}
  }
`;
var Root19 = RadixPopover.Root;
function Trigger9({ children, ...props }) {
  return /* @__PURE__ */ jsx337(RadixPopover.Trigger, {
    asChild: true,
    ...props,
    onMouseDown: (e) => e.preventDefault(),
    children
  });
}
function PopoverContent({
  children,
  showTitleOnDesktop = false,
  title,
  position = "bottom",
  fullHeight = false,
  className,
  closeText,
  autoFocus = false,
  ...rest
}) {
  const { side, align } = PositionMap2[position];
  const popoverRef = React11.useRef(null);
  return /* @__PURE__ */ jsx337(RadixPopover.Portal, {
    children: /* @__PURE__ */ jsxs306(StyledPopoverWrapper, {
      $fullHeight: fullHeight,
      children: [
        /* @__PURE__ */ jsx337(Backdrop3, {}),
        /* @__PURE__ */ jsx337(StyledPopoverContent, {
          onOpenAutoFocus: (e) => {
            var _a;
            if (!autoFocus) {
              e.preventDefault();
              (_a = popoverRef.current) == null ? void 0 : _a.focus();
            }
          },
          side,
          align,
          collisionPadding: 8,
          ...rest,
          className,
          children: /* @__PURE__ */ jsxs306(StyledPopover, {
            tabIndex: -1,
            ref: popoverRef,
            children: [
              /* @__PURE__ */ jsxs306(TopTitleBarRoot, {
                $showOnDesktop: showTitleOnDesktop,
                children: [
                  /* @__PURE__ */ jsx337(TopTitleBar.CenterArea, {
                    title
                  }),
                  /* @__PURE__ */ jsx337(TopTitleBar.RightArea, {
                    children: /* @__PURE__ */ jsx337(RadixPopover.Close, {
                      children: /* @__PURE__ */ jsx337(Typography_default, {
                        children: closeText
                      })
                    })
                  })
                ]
              }),
              /* @__PURE__ */ jsx337(Body, {
                children
              })
            ]
          })
        })
      ]
    })
  });
}
var Content12 = withStyleModifiers(
  styled48(PopoverContent)`
    ${({ hasPadding }) => modWithPadding(hasPadding)}
  `,
  {
    modWithPadding
  }
);

// src/uds/components/PriceArea/index.ts
init_esm_shims();

// src/uds/components/PriceArea/PriceArea.tsx
init_esm_shims();
import { css as css31, styled as styled50 } from "styled-components";

// src/uds/components/Tag/index.ts
init_esm_shims();

// src/uds/components/Tag/Tag.tsx
init_esm_shims();
import { css as css30, styled as styled49 } from "styled-components";
import { jsx as jsx338, jsxs as jsxs307 } from "react/jsx-runtime";
var Wrapper9 = styled49.div`
  flex-direction: row;
  align-items: center;
  display: inline-flex;
  justify-content: center;

  ${Icon_default} {
    margin-right: ${space("primitives_space_2")};
  }

  ${({ $size }) => modSize7($size)}
  ${({ $variant }) => modVariant4($variant)};
`;
function Tag2({ children, size, variant, icon, className }) {
  return /* @__PURE__ */ jsxs307(Wrapper9, {
    $size: size,
    $variant: variant,
    className,
    children: [
      icon && /* @__PURE__ */ jsx338(Icon_default, {
        glyph: icon,
        size: 16
      }),
      /* @__PURE__ */ jsx338(Typography_default, {
        children
      })
    ]
  });
}
function modVariant4(variantName = "primary") {
  return {
    "primary-tinted": css30`
      background-color: ${tok("primitives_color_primary_150")};
      color: ${tok("primitives_color_primary_700")};
    `,
    "primary": css30`
      background-color: ${tok("primitives_color_primary_500")};
      color: ${tok("primitives_color_neutral_0")};
    `,
    "success-tinted": css30`
      background-color: ${tok("primitives_color_success_150")};
      color: ${tok("primitives_color_success_700")};
    `,
    "success": css30`
      background-color: ${tok("primitives_color_success_500")};
      color: ${tok("primitives_color_neutral_0")};
    `,
    "neutral-tinted": css30`
      background-color: ${tok("primitives_color_neutral_150")};
      color: ${tok("primitives_color_neutral_700")};
    `,
    "neutral": css30`
      background-color: ${tok("primitives_color_neutral_500")};
      color: ${tok("primitives_color_neutral_0")};
    `
  }[variantName];
}
function modSize7(sizeName = "M") {
  return {
    M: css30`
      padding-top: ${tokPx("components_tag_m_padding_top")};
      padding-right: ${tokPx("components_tag_m_padding_right")};
      padding-bottom: ${tokPx("components_tag_m_padding_bottom")};
      padding-left: ${tokPx("components_tag_m_padding_left")};

      border-radius: ${tokPx("components_tag_m_corner_radius")};

      ${Typography_default} {
        ${Typography_default.modVariant("body-s-bold-tight")}
      }
    `,
    S: css30`
      padding-top: ${tokPx("components_tag_s_padding_top")};
      padding-right: ${tokPx("components_tag_s_padding_right")};
      padding-bottom: ${tokPx("components_tag_s_padding_bottom")};
      padding-left: ${tokPx("components_tag_s_padding_left")};

      border-radius: ${tokPx("components_tag_s_corner_radius")};

      ${Typography_default} {
        ${Typography_default.modVariant("body-xs-bold-tight")}
      }

      ${Icon_default} {
        display: none;
      }
    `
  }[sizeName];
}
var Tag_default = withStyleModifiers(styled49(Tag2)``, {
  modSize: modSize7
});

// src/uds/components/PriceArea/PriceArea.tsx
import { jsx as jsx339, jsxs as jsxs308 } from "react/jsx-runtime";
var Price = styled50(Typography_default)``;
function modSize8(sizeName = "S") {
  return {
    S: css31`
      ${Price} {
        ${Typography_default.modVariant("display-g-regular")}
      }

      ${Tag_default} {
        ${Tag_default.modSize("S")}
      }
    `,
    M: css31`
      ${Price} {
        ${Typography_default.modVariant("display-f-regular")}
      }

      ${Tag_default} {
        ${Tag_default.modSize("S")}
      }
    `,
    L: css31`
      ${Price} {
        ${Typography_default.modVariant("display-c-regular")}
      }

      ${Tag_default} {
        ${Tag_default.modSize("M")}
      }
    `
  }[sizeName];
}
var Wrapper10 = styled50.div`
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  width: 100%;

  ${({ $size }) => modSize8($size)}
`;
var PriceBox = styled50.div`
  display: flex;
  align-items: center;
  gap: ${space("primitives_space_4")};
`;
var PreviousPriceText = styled50(Typography_default)`
  text-align: right;
  color: ${tok("semantics_content_secondary_color")};
  ${Typography_default} {
    text-decoration: line-through;
    color: ${tok("primitives_color_primary_500")};
  }
`;
var SupportingText3 = styled50(Typography_default)`
  color: ${tok("semantics_content_secondary_color")};
`;
function PriceArea({
  children,
  price,
  areaText,
  discounts,
  supportingText,
  size,
  className
}) {
  const hasDiscount = discounts && discounts.discountPercentage > 0 && "originalPrice" in discounts;
  return /* @__PURE__ */ jsxs308(Wrapper10, {
    $size: size,
    className,
    children: [
      hasDiscount && /* @__PURE__ */ jsx339(Tag_default, {
        "data-ab-discount-label": "true",
        variant: "primary-tinted",
        children: `-${discounts.discountPercentage}%`
      }),
      /* @__PURE__ */ jsxs308(PreviousPriceText, {
        $variant: "body-xs-regular-snug",
        children: [
          areaText,
          hasDiscount && /* @__PURE__ */ jsx339(Typography_default, {
            $variant: "body-s-regular-snug",
            children: discounts.originalPrice
          })
        ]
      }),
      /* @__PURE__ */ jsxs308(PriceBox, {
        children: [
          /* @__PURE__ */ jsx339(Price, {
            "data-qa-price-value": price,
            children: price
          }),
          children
        ]
      }),
      supportingText && /* @__PURE__ */ jsx339(SupportingText3, {
        $variant: "body-xs-regular-tight",
        children: supportingText
      })
    ]
  });
}
PriceArea.displayName = "PriceArea";
var PriceArea_default = withStyleModifiers(styled50(PriceArea)``, { modSize: modSize8 });

// src/uds/components/Rating/index.ts
init_esm_shims();

// src/uds/components/Rating/Rating.tsx
init_esm_shims();
import { styled as styled51 } from "styled-components";
import { jsx as jsx340, jsxs as jsxs309 } from "react/jsx-runtime";
var StyledRating = styled51.div`
  svg {
    color: ${tok("primitives_color_neutral_500")};
  }
  min-width: fit-content;
`;
var S_SIZE = 16;
function Rating({ rating, ...attributes }) {
  const validValues = [0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5];
  const isRatingValid = validValues.includes(rating);
  if (!isRatingValid) {
    return null;
  }
  const fullStars = Math.floor(rating);
  const halfStars = rating - fullStars;
  return /* @__PURE__ */ jsxs309(StyledRating, {
    ...attributes,
    children: [
      Array.from({ length: fullStars }).map((_, index) => /* @__PURE__ */ jsx340(Icon_default, {
        glyph: "StarFilled",
        size: S_SIZE
      }, `full-${index}`)),
      halfStars > 0 && /* @__PURE__ */ jsx340(Icon_default, {
        glyph: "StarHalfFilled",
        size: S_SIZE
      })
    ]
  });
}
Rating.displayName = "Rating";

// src/uds/components/SegmentedControls/index.ts
init_esm_shims();

// src/uds/components/SegmentedControls/SegmentedControls.tsx
init_esm_shims();
import * as React12 from "react";
import { css as css33, styled as styled53 } from "styled-components";

// src/uds/components/SegmentedControls/Segment.tsx
init_esm_shims();
import { css as css32, styled as styled52 } from "styled-components";
import { jsx as jsx341 } from "react/jsx-runtime";
var StyledSegment = styled52.button`
  position: relative;
  height: 100%;
  border-radius: calc(${tokPx("semantics_controls_m_corner_radius")} - ${space("primitives_space_4")});
  border: none;
  padding: ${space("primitives_space_4")} ${space("primitives_space_16")};
  text-decoration: none;
  width: 100%;

  ${({ $active }) => $active ? css32`
          background-color: ${tok("semantics_selectors_selected_background_color")};
          color: ${tok("semantics_selectors_neutral_selected_content_color")};

          &:hover&:not(:disabled) {
            color: ${tok("semantics_selectors_selected_hover_content_color")};
            background: ${tok("semantics_selectors_selected_hover_background_color")};
          }

        ` : css32`
          color: ${tok("semantics_selectors_content_color")};

          &:not(:last-child)::after {
            content: '';
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: -${tokPx("semantics_dividers_tickness")};
            width: ${tokPx("semantics_dividers_tickness")};
            height: ${space("primitives_space_24")};
            background-color: ${tok("semantics_dividers_color")};
          }
      `}

  ${focusOutline()}

  ${Typography_default} {
    ${Typography_default.modVariant("body-m-regular-tight")}
  }

`;
function SegmentComponent({ active, children, onClick, value, ...attributes }) {
  const onClickHandler = () => {
    onClick == null ? void 0 : onClick(value);
  };
  return /* @__PURE__ */ jsx341(StyledSegment, {
    $active: active,
    onClick: onClickHandler,
    ...attributes,
    children: /* @__PURE__ */ jsx341(SpaceBetween, {
      alignItems: "center",
      justifyContent: "center",
      direction: "x",
      spacing: tk("spacing_2xs"),
      children: wrapTextChildrenWithTypography(children)
    })
  });
}
var Segment = styled52(SegmentComponent)``;

// src/uds/components/SegmentedControls/SegmentedControls.tsx
import { jsx as jsx342 } from "react/jsx-runtime";
var StyledWrapper2 = styled53.div`
  align-items: center;
  background-color: ${tok("semantics_selectors_background_color")};
  border: ${tokPx("semantics_selectors_border_width")} solid ${tok("semantics_selectors_border_color")};
  border-radius: ${tokPx("semantics_controls_m_corner_radius")};
  display: inline-flex;
  padding: calc(${space("primitives_space_4")} - ${tokPx("semantics_selectors_border_width")});
  height: ${tokPx("semantics_controls_m_min_height")};

  ${({ $fixed }) => $fixed && css33`
      max-width: 36rem;
      width: 100%;

      ${Segment} {
        flex: 1 0 0;
      }
    `}

  ${({ $disabled }) => $disabled && css33`
      opacity: ${tok("primitives_opacity_disabled")}%;
    `}
`;
function SegmentedControls({
  children,
  defaultActive,
  disabled,
  fixed,
  onActiveChange,
  ...attributes
}) {
  const [active, setActive] = React12.useState(defaultActive != null ? defaultActive : 0);
  const onClickHandler = (index, value) => {
    setActive(index);
    onActiveChange == null ? void 0 : onActiveChange({ index, value });
  };
  return /* @__PURE__ */ jsx342(StyledWrapper2, {
    $fixed: fixed,
    $disabled: disabled,
    ...attributes,
    children: React12.Children.map(children, (child, index) => {
      if (React12.isValidElement(child)) {
        const { disabled: childDisabled, name, value } = child.props;
        return React12.cloneElement(child, {
          active: [name, value].includes(active) || index === active,
          onClick: () => onClickHandler(index, value),
          disabled: disabled || childDisabled
        });
      }
    })
  });
}
SegmentedControls.Segment = Segment;

// src/uds/components/Sheet/index.ts
init_esm_shims();

// src/uds/components/Sheet/Sheet.tsx
init_esm_shims();
import * as DialogPrimitive5 from "@radix-ui/react-dialog";

// src/uds/components/Sheet/Body.tsx
init_esm_shims();
import * as DialogPrimitive2 from "@radix-ui/react-dialog";
import * as React15 from "react";
import { css as css35, styled as styled56 } from "styled-components";

// src/uds/components/Sheet/Content.tsx
init_esm_shims();
import * as React14 from "react";
import { styled as styled54 } from "styled-components";

// src/uds/components/Sheet/context.ts
init_esm_shims();
import * as React13 from "react";
import { useEffect as useEffect5 } from "react";
var SheetContext = React13.createContext({ contentElement: null, setContentElement: () => {
} });
var SheetContextProvider = SheetContext.Provider;
function useIsContentOverflown() {
  const { contentElement } = React13.useContext(SheetContext);
  const [isOverflown, setIsOverflown] = React13.useState(true);
  React13.useEffect(() => {
    const checkHeight = () => {
      const contentHeight = (contentElement == null ? void 0 : contentElement.scrollHeight) || 0;
      const clientHeight = (contentElement == null ? void 0 : contentElement.clientHeight) || 0;
      setIsOverflown(contentHeight > clientHeight);
    };
    const resizeObserver = new ResizeObserver(() => {
      checkHeight();
    });
    if (contentElement) {
      resizeObserver.observe(contentElement);
    }
    window.addEventListener("resize", checkHeight);
    return () => {
      window.removeEventListener("resize", checkHeight);
      if (contentElement) {
        resizeObserver.unobserve(contentElement);
      }
    };
  }, [contentElement]);
  return isOverflown;
}
function useSetContentElement(contentElementRef) {
  const { setContentElement } = React13.useContext(SheetContext);
  useEffect5(() => {
    setContentElement((contentElementRef == null ? void 0 : contentElementRef.current) || null);
  }, [contentElementRef]);
}

// src/uds/components/Sheet/Content.tsx
import { jsx as jsx343 } from "react/jsx-runtime";
function ContentWrapper4({ children, className }) {
  const contentWrapperRef = React14.useRef(null);
  useSetContentElement(contentWrapperRef);
  return /* @__PURE__ */ jsx343("div", {
    className,
    ref: contentWrapperRef,
    children
  });
}
var Content13 = styled54(ContentWrapper4)`
  overflow-y: auto;
  overflow-x: hidden;
  height: auto;
`;

// src/uds/components/Sheet/Footer.tsx
init_esm_shims();
import { css as css34, styled as styled55 } from "styled-components";
import { jsx as jsx344 } from "react/jsx-runtime";
var InnerFooter = styled55.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: ${tok("semantics_views_background_color")};

  ${({ $isSticky }) => $isSticky ? modSticky() : modNotSticky()}
`;
function modSticky() {
  return css34`
    border-top: ${tokPx("semantics_dividers_tickness")} solid ${tok("semantics_dividers_color")};
  `;
}
function modNotSticky() {
  return css34`
    &&& {
      padding-top: ${space("primitives_space_0")};
    }
  `;
}
function FooterWrapper({ children, className }) {
  const isContentOverflown = useIsContentOverflown();
  return /* @__PURE__ */ jsx344(InnerFooter, {
    className,
    $isSticky: isContentOverflown,
    children
  });
}
var Footer = styled55(FooterWrapper)``;

// src/uds/components/Sheet/Body.tsx
import { jsx as jsx345 } from "react/jsx-runtime";
var Backdrop4 = styled56(DialogPrimitive2.Overlay)`
  ${backdropStyles()}
`;
var BodyWrapper = styled56(DialogPrimitive2.Content)`
  background-color: ${tok("semantics_views_background_color")};
  box-shadow: ${tok("primitives_box_shadows_level_5")};
  z-index: ${zIndex.sheet};
  position: fixed;
  height: 100%;
  top: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border-radius: ${tokPx("semantics_overlays_corner_radius")};

  ${({ $side, $bottomSideInMobile }) => modSide($side, $bottomSideInMobile)}

  ${({ $hasPadding }) => !$hasPadding && modWithoutPadding()}
`;
function Body2({
  side = "right",
  hasPadding = true,
  bottomSideInMobile = true,
  onChange,
  children
}) {
  const [contentElement, setContentElement] = React15.useState(null);
  return /* @__PURE__ */ jsx345(DialogPrimitive2.Portal, {
    children: /* @__PURE__ */ jsx345(Backdrop4, {
      children: /* @__PURE__ */ jsx345(BodyWrapper, {
        $side: side,
        $hasPadding: hasPadding,
        $bottomSideInMobile: bottomSideInMobile,
        onChange,
        children: /* @__PURE__ */ jsx345(SheetContextProvider, {
          value: { contentElement, setContentElement },
          children
        })
      })
    })
  });
}
var TABLET_SPACING = space("primitives_space_48");
var DESKTOP_SPACING = space("primitives_space_80");
var MOBILE_UPPER_SPACING = space("primitives_space_48");
function modWithoutPadding() {
  return css35`
    ${Content13} {
      padding: 0;
    }

    ${Footer} {
      padding: 0;
    }
  `;
}
function modSide(sideName = "right", bottomInMobile = true) {
  return {
    right: css35`
      width: 360px;
      max-width: calc(100vw - (2 * ${space("primitives_space_16")}));

      &[data-state='closed'] {
        animation: ${slideOutToRight} 0.3s forwards;
      }

      &[data-state='open'] {
        animation: ${slideInFromRight} 0.3s forwards;
      }

      @media ${mqMax("primitives_breakpoint_s_max")} {
        ${!bottomInMobile && css35`
          border-radius: initial;
        `}
        ${bottomInMobile && applyMobileBottomSideStyles()}
      }

      @media ${mqMin("primitives_breakpoint_m_min")} {
        top: ${space("primitives_space_16")};
        right: ${space("primitives_space_16")};
        max-height: calc(100vh - (2 * ${space("primitives_space_16")}));
        width: 480px;
      }

      ${Footer}, ${Content13} {
        padding: ${space("primitives_space_16")};
      }
    `,
    left: css35`
      left: 0;
      right: initial;
      width: 360px;
      max-width: calc(100vw - (2 * ${space("primitives_space_16")}));

      &[data-state='closed'] {
        animation: ${slideOutToLeft} 0.3s forwards;
      }

      &[data-state='open'] {
        animation: ${slideInFromLeft} 0.3s forwards;
      }

      @media ${mqMax("primitives_breakpoint_s_max")} {
        ${!bottomInMobile && css35`
          border-radius: initial;
        `}
        ${bottomInMobile && applyMobileBottomSideStyles()}
      }

      @media ${mqMin("primitives_breakpoint_m_min")} {
        left: ${space("primitives_space_16")};
        top: ${space("primitives_space_16")};
        max-height: calc(100vh - (2 * ${space("primitives_space_16")}));
        width: 480px;
      }

      ${Footer}, ${Content13}{
        padding: ${space("primitives_space_16")};
      }
    `,
    bottom: css35`
      ${applyMobileBottomSideStyles()} @media ${mqMin("primitives_breakpoint_m_min")} {
      width: 1280px;
      max-width: calc(100vw - (2 * ${TABLET_SPACING}));
      height: calc(100vh - ${TABLET_SPACING});
      height: calc(100dvh - ${TABLET_SPACING}); // using dvh to support for Safari mobile
    }

      @media ${mqMin("primitives_breakpoint_l_min")} {
        max-width: calc(100vw - (2 * ${DESKTOP_SPACING}));
        height: calc(100vh - ${DESKTOP_SPACING});
        height: calc(100dvh - ${DESKTOP_SPACING}); // using dvh to support for Safari mobile
      }

      ${Content13} {
        padding: ${space("primitives_space_16")};

        @media ${mqMin("primitives_breakpoint_m_min")} {
          padding: ${space("primitives_space_24")};
        }

        @media ${mqMin("primitives_breakpoint_l_min")} {
          padding: ${space("primitives_space_32")};
        }
      }

      ${Footer} {
        padding: ${space("primitives_space_12")} ${space("primitives_space_16")};

        @media ${mqMin("primitives_breakpoint_m_min")} {
          padding: ${space("primitives_space_16")} ${space("primitives_space_24")};
        }

        @media ${mqMin("primitives_breakpoint_l_min")} {
          padding: ${space("primitives_space_24")} ${space("primitives_space_32")};
        }
      }
    `
  }[sideName];
}
function applyMobileBottomSideStyles() {
  return css35`
    width: 100%;
    height: calc(100vh - ${MOBILE_UPPER_SPACING});
    height: calc(100dvh - ${MOBILE_UPPER_SPACING}); // using dvh to support for Safari mobile
    bottom: 0;
    top: unset;
    left: 0;
    right: 0;
    margin: auto;
    max-width: initial;

    border-bottom-left-radius: unset;
    border-bottom-right-radius: unset;

    &[data-state='closed'] {
      animation: ${slideOutToBottom} 0.3s forwards;
    }

    &[data-state='open'] {
      animation: ${slideInFromBottom} 0.3s forwards;
    }
  `;
}

// src/uds/components/Sheet/Header.tsx
init_esm_shims();
import * as DialogPrimitive3 from "@radix-ui/react-dialog";
import { jsx as jsx346, jsxs as jsxs310 } from "react/jsx-runtime";
function Close3({ children }) {
  return /* @__PURE__ */ jsx346(DialogPrimitive3.Close, {
    asChild: true,
    children
  });
}
function Header2({ titleLabel, closeLabel, children, className }) {
  return /* @__PURE__ */ jsxs310(TopTitleBar.Root, {
    className,
    children: [
      /* @__PURE__ */ jsx346(TopTitleBar.LeftArea, {
        children
      }),
      /* @__PURE__ */ jsx346(TopTitleBar.CenterArea, {
        title: titleLabel
      }),
      /* @__PURE__ */ jsx346(TopTitleBar.RightArea, {
        children: /* @__PURE__ */ jsx346(Close3, {
          children: /* @__PURE__ */ jsx346(Button_default, {
            $type: "transparentPrimary",
            children: closeLabel
          })
        })
      })
    ]
  });
}

// src/uds/components/Sheet/Trigger.tsx
init_esm_shims();
import * as DialogPrimitive4 from "@radix-ui/react-dialog";
import { jsx as jsx347 } from "react/jsx-runtime";
function Trigger11({ children }) {
  return /* @__PURE__ */ jsx347(DialogPrimitive4.Trigger, {
    asChild: true,
    children
  });
}

// src/uds/components/Sheet/Sheet.tsx
var Root21 = DialogPrimitive5.Root;
var Sheet = {
  Root: Root21,
  Trigger: Trigger11,
  Body: Body2,
  Content: Content13,
  Footer,
  Header: Header2,
  Close: Close3
};

// src/uds/components/Skeleton/index.ts
init_esm_shims();

// src/uds/components/Skeleton/Skeleton.tsx
init_esm_shims();
import { keyframes as keyframes4, styled as styled57 } from "styled-components";
import { jsx as jsx348 } from "react/jsx-runtime";
var opacityAnimation = keyframes4`
  50% {
    opacity: 0.3;
  }
`;
var StyledSkeleton = styled57.div`
  animation-name: ${opacityAnimation};
  animation-duration: 2s;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  background: ${tok("primitives_color_neutral_100")};
`;
function Skeleton(props) {
  return /* @__PURE__ */ jsx348(StyledSkeleton, {
    ...props
  });
}

// src/uds/components/Slider/index.ts
init_esm_shims();

// src/uds/components/Slider/Slider.tsx
init_esm_shims();
import * as SliderPrimitive from "@radix-ui/react-slider";
import { css as css36, styled as styled58 } from "styled-components";
import { jsx as jsx349, jsxs as jsxs311 } from "react/jsx-runtime";
var Root23 = styled58(SliderPrimitive.Root)`
  position: relative;
  display: flex;
  align-items: center;
  user-select: none;
  touch-action: none;
  width: 100%;
`;
var IconContainer = styled58.div`
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
var Wrapper11 = styled58.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: ${tokPx("semantics_controls_m_min_height")};
  padding: ${space("primitives_space_6")} ${space("primitives_space_2")};
  background: ${tok("semantics_selectors_background_color")};
  border: ${tokPx("semantics_selectors_border_width")} solid ${tok("semantics_selectors_border_color")};
  border-radius: ${tokPx("semantics_controls_m_corner_radius")};

  ${({ $disabled }) => $disabled && css36` opacity: ${tok("primitives_opacity_disabled")}%;`}
`;
var Track2 = styled58(SliderPrimitive.Track)`
  position: relative;
  flex-grow: 1;
  border-radius: ${tokPx("primitives_corner_radius_s")};
  height: ${space("primitives_space_6")};
  background-color: ${tok("primitives_color_neutral_150")};
`;
var Range2 = styled58(SliderPrimitive.Range)`
  position: absolute;
  border-radius: ${tokPx("primitives_corner_radius_full")};
  height: 100%;
  background-color: ${tok("primitives_color_neutral_600")};
`;
var Thumb6 = styled58(SliderPrimitive.Thumb)`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${tokPx("components_slider_thumb_corner_radius")};
  background-color: ${tok("primitives_color_neutral_600")};
  cursor: grab;

  &:hover:not([data-disabled]) {
    background-color: ${tok("primitives_color_neutral_700")};
  }

  ${focusOutline()}

  &:not([data-disabled]):active {
    outline: none;
    background-color: ${tok("primitives_color_neutral_700")};
    cursor: grabbing;
  }

  &:not([data-disabled]):active:after {
    position: absolute;
    content: '';
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    border-radius: ${tokPx("components_slider_thumb_corner_radius")};
    box-shadow: 0 0 0 6px ${tok("primitives_color_neutral_600")}26;
  }

  ${Icon_default} {
    color: ${tok("semantics_content_white_color")};
    padding: ${space("primitives_space_4")} ${space("primitives_space_6")};
  }
`;
function Slider({
  ariaLabel,
  value,
  defaultValue,
  disabled = false,
  max = 100,
  min = 0,
  minStepsBetweenThumbs = 0,
  onValueChange,
  onValueCommit,
  step = 1,
  className
}) {
  const thumbValues = defaultValue || value;
  return /* @__PURE__ */ jsxs311(Wrapper11, {
    className,
    $disabled: disabled,
    children: [
      /* @__PURE__ */ jsx349(IconContainer, {
        children: /* @__PURE__ */ jsx349(Icon_default, {
          glyph: "MinusExtraSmall"
        })
      }),
      /* @__PURE__ */ jsxs311(Root23, {
        value,
        defaultValue,
        disabled,
        max,
        min,
        minStepsBetweenThumbs,
        onValueChange,
        onValueCommit,
        step,
        children: [
          /* @__PURE__ */ jsx349(Track2, {
            children: /* @__PURE__ */ jsx349(Range2, {})
          }),
          thumbValues == null ? void 0 : thumbValues.map((_, i) => /* @__PURE__ */ jsx349(Thumb6, {
            "aria-label": ariaLabel,
            children: /* @__PURE__ */ jsx349(Icon_default, {
              glyph: "ChevronDoubleSmall",
              size: 20
            })
          }, `${i}${ariaLabel}`))
        ]
      }),
      /* @__PURE__ */ jsx349(IconContainer, {
        children: /* @__PURE__ */ jsx349(Icon_default, {
          glyph: "PlusExtraSmall"
        })
      })
    ]
  });
}
Slider.displayName = "Slider";

// src/uds/components/TabBar/index.ts
init_esm_shims();

// src/uds/components/TabBar/TabBar.tsx
init_esm_shims();
import * as React16 from "react";
import { css as css38, styled as styled60 } from "styled-components";

// src/uds/components/TabBar/Tab.tsx
init_esm_shims();
import { css as css37, styled as styled59 } from "styled-components";
import { jsx as jsx350 } from "react/jsx-runtime";
var TabContent = styled59.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: ${space("primitives_space_0")};

  ${Icon_default} {
    ${Icon_default.modSize(24)}
  }

  ${Typography_default} {
    ${Typography_default.modVariant("body-xs-regular-tight")}
  }

  @media ${mqMin("primitives_breakpoint_m_min")} {
    flex-direction: row;
    gap: ${space("primitives_space_6")};

    ${Icon_default} {
      ${Icon_default.modSize(18)}
    }

    ${Typography_default} {
      ${Typography_default.modVariant("body-m-regular-tight")}
    }
  }
`;
var TabStyled = styled59.button`
  ${({ $active }) => $active ? css37`
          --tab-color: ${tok("semantics_navigation_item_neutral_current_content_color")};
          --tab-background-color: ${tok("semantics_navigation_item_neutral_current_background_color")};
          --tab-background-color-hover: ${tok("semantics_navigation_item_neutral_current_hover_background_color")};
        ` : css37`
          --tab-color: ${tok("semantics_content_color")};
          --tab-background-color: transparent;
          --tab-background-color-hover: ${tok("components_tab_bar_item_hover_background_color")};
        `}


  border: none;
  text-decoration: none;

  border-radius: ${tokPx("components_tab_bar_icon_top_item_corner_radius")};
  padding: ${space("primitives_space_6")} ${space("primitives_space_2")};
  flex-basis: 0;
  flex-grow: 1;

  @media ${mqMin("primitives_breakpoint_m_min")} {
    padding: 10px ${space("primitives_space_16")};
    border-radius: ${tokPx("components_tab_bar_horizontal_item_corner_radius")};
    flex-grow: initial;
    flex-basis: initial;
  }

  background-color: var(--tab-background-color);
  color: var(--tab-color);

  &:hover:not(:disabled) {
    background: var(--tab-background-color-hover);
  }
`;
function TabComponent({ active, children, onClick, value, ...attributes }) {
  const onClickHandler = () => {
    onClick == null ? void 0 : onClick(value);
  };
  return /* @__PURE__ */ jsx350(TabStyled, {
    $active: active,
    onClick: onClickHandler,
    ...attributes,
    children: /* @__PURE__ */ jsx350(TabContent, {
      children: wrapTextChildrenWithTypography(children)
    })
  });
}
var Tab = styled59(TabComponent)``;

// src/uds/components/TabBar/TabBar.tsx
import { jsx as jsx351 } from "react/jsx-runtime";
var StyledWrapper3 = styled60.div`
  align-items: center;
  background-color: ${tok("components_tab_bar_background_color")};
  display: inline-flex;
  padding: ${space("primitives_space_2")};
  width: 100%;
  border-radius: ${tokPx("components_tab_bar_icon_top_corner_radius")};
  border: ${tokPx("semantics_dividers_tickness")} solid ${tok("components_tab_bar_border_color")};

  @media ${mqMin("primitives_breakpoint_m_min")} {
    width: auto;
    border-radius: ${tokPx("components_tab_bar_horizontal_corner_radius")};
  }

  ${({ $disabled }) => $disabled && css38`
      opacity: ${tok("primitives_opacity_disabled")}%;
    `}
`;
function TabBar({ children, defaultActive, disabled, onActiveChange, ...attributes }) {
  const [active, setActive] = React16.useState(defaultActive != null ? defaultActive : 0);
  const onClickHandler = (index, value) => {
    setActive(index);
    onActiveChange == null ? void 0 : onActiveChange({ index, value });
  };
  return /* @__PURE__ */ jsx351(StyledWrapper3, {
    $disabled: disabled,
    ...attributes,
    children: React16.Children.map(children, (child, index) => {
      if (React16.isValidElement(child)) {
        const { disabled: childDisabled, name, value } = child.props;
        return React16.cloneElement(child, {
          active: [name, value].includes(active) || index === active,
          onClick: () => onClickHandler(index, value),
          disabled: disabled || childDisabled
        });
      }
    })
  });
}
TabBar.Tab = Tab;

// src/uds/components/ToggleButton/index.ts
init_esm_shims();

// src/uds/components/ToggleButton/ToggleButton.tsx
init_esm_shims();
import * as ToggleGroupPrimitives from "@radix-ui/react-toggle-group";
import { forwardRef as forwardRef7 } from "react";
import { css as css39, styled as styled61 } from "styled-components";
import { jsx as jsx352 } from "react/jsx-runtime";
var colorStyles = {
  selected: createColorStyles("semantics_selectors_selected_background_color", "semantics_selectors_selected_hover_background_color", "semantics_selectors_selected_border_color", "semantics_selectors_selected_hover_border_color"),
  neutral: createColorStyles("semantics_selectors_neutral_selected_background_color", "semantics_selectors_neutral_selected_hover_background_color", "semantics_selectors_neutral_selected_border_color", "semantics_selectors_neutral_selected_hover_border_color")
};
function createColorStyles(baseColor, hoverColor, borderColor, hoverBorderColor) {
  return css39`
  color: ${tok("semantics_selectors_neutral_selected_content_color")};
  background-color: ${tok(baseColor)};
  border-color: ${tok(borderColor)};

  &:not(:disabled):hover {
    background-color: ${tok(hoverColor)};
    border-color: ${tok(hoverBorderColor)};
  }
`;
}
var ItemToggle = styled61(ToggleGroupPrimitives.Item)`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  border-radius: ${tokPx("semantics_controls_m_corner_radius")};
  border: ${tokPx("semantics_selectors_border_width")} solid ${tok("semantics_selectors_border_color")};
  background: ${tok("semantics_selectors_background_color")};

  &[data-state='on'] {
    ${({ color = "selected" }) => colorStyles[color]}
  }

  &:not([data-state='on']):hover {
    &:not(:disabled){
      background-color: ${tok("semantics_selectors_hover_background_color")};
      border-color: ${tok("semantics_selectors_hover_border_color")};
    }
  }

  ${({ size = "M" }) => modSize9(size)}

  ${focusOutline()}
`;
function modSize9(size = "M") {
  return {
    M: css39`
      height: ${tokPx("semantics_controls_m_min_height")};
      min-width: ${tokPx("semantics_controls_m_min_height")};
      padding: ${space("primitives_space_12")};
      gap: ${space("primitives_space_6")};

      ${Typography_default}{
        ${Typography_default.modVariant("body-m-regular-tight")}
      }
    }
    `,
    S: css39`
      height: ${tokPx("semantics_controls_s_min_height")};
      min-width: ${tokPx("semantics_controls_s_min_height")};
      padding: ${space("primitives_space_2")} ${space("primitives_space_8")};
      gap: ${space("primitives_space_4")};

      ${Typography_default}{
        ${Typography_default.modVariant("body-s-regular-tight")}
      }
    `
  }[size];
}
var ToggleButton = forwardRef7(({ title, className, ...rest }, ref) => /* @__PURE__ */ jsx352(ItemToggle, {
  className,
  ref,
  ...rest,
  children: /* @__PURE__ */ jsx352(Typography_default, {
    children: title
  })
}));
function ToggleButtonGroup({ ...props }) {
  return /* @__PURE__ */ jsx352(ToggleGroupPrimitives.Root, {
    ...props
  });
}
function modDisabled9() {
  return css39`
  pointer-events: none;
  opacity: ${tok("primitives_opacity_disabled")}%;
`;
}
var StyledToggleButton = withStyleModifiers(styled61(ToggleButton)``, {
  modDisabled: modDisabled9
});
StyledToggleButton.displayName = "ToggleButton";
var ToggleButton_default = StyledToggleButton;

// src/uds/components/Token/index.ts
init_esm_shims();

// src/uds/components/Token/Token.tsx
init_esm_shims();
import * as React17 from "react";
import { css as css40, styled as styled62 } from "styled-components";
import { jsx as jsx353, jsxs as jsxs312 } from "react/jsx-runtime";
var Text2 = styled62(Typography_default)``;
var RightIcon = styled62(Icon_default)`
  cursor: pointer;
  color: ${tok("semantics_content_color")};
  margin-right: -${space("primitives_space_2")};
`;
var LeftIcon = styled62(Icon_default)`
  position: absolute;
  cursor: pointer;
  color: ${tok("semantics_content_color")};
  margin-left: -${space("primitives_space_2")};
`;
var Wrapper12 = styled62.button`
  display: inline-flex;
  position: relative;
  align-items: center;

  height: 32px;
  gap: ${space("primitives_space_2")};
  padding-left: calc(${space("primitives_space_8")} + ${space("primitives_space_2")});
  padding-right: calc(${space("primitives_space_8")} + ${space("primitives_space_2")});
  white-space: nowrap;

  border-radius: ${tokPx("components_token_corner_radius")};

  user-select: none;
  outline: none;

  background: ${tok("primitives_color_neutral_100")};
  color: ${tok("semantics_content_color")};

  &:hover {
    background: ${tok("primitives_color_neutral_150")};
    color: ${tok("semantics_content_color")};
  }

  cursor: pointer;

  ${focusOutline()}

  ${({ $disabled }) => $disabled && modDisabled($disabled)}
  ${({ $hasIcon }) => $hasIcon && css40`
      ${Text2} {
        margin-left: ${space("primitives_space_20")};
      }
    `}
`;
function Token({
  children,
  value,
  dismissible,
  onDismissClick,
  disabled,
  icon,
  type = "button",
  ...rest
}) {
  const [visibleDisabled, setVisibleDisabled] = React17.useState(false);
  React17.useEffect(() => {
    if (disabled) {
      const t = setTimeout(() => setVisibleDisabled(true), 0);
      return () => clearTimeout(t);
    } else {
      setVisibleDisabled(false);
    }
  }, [disabled]);
  const handleClick = React17.useCallback(
    (e) => {
      if (!disabled && dismissible && value && onDismissClick) {
        onDismissClick(value, e);
      }
    },
    [disabled, dismissible, value, onDismissClick]
  );
  return /* @__PURE__ */ jsxs312(Wrapper12, {
    type,
    $disabled: visibleDisabled,
    ...rest,
    tabIndex: !disabled ? 0 : void 0,
    onClick: handleClick,
    $hasIcon: Boolean(icon),
    children: [
      icon && /* @__PURE__ */ jsx353(LeftIcon, {
        glyph: icon,
        size: 20
      }),
      /* @__PURE__ */ jsx353(Text2, {
        $variant: "body-m-regular-tight",
        children
      }),
      dismissible && value && /* @__PURE__ */ jsx353(RightIcon, {
        glyph: "DismissSmall",
        size: 20
      })
    ]
  });
}
var Token_default = styled62(Token)``;

// src/uds/index.ts
var allIconGlyphNames = Object.keys(glyphs_exports);
export {
  Accordion_exports as Accordion,
  AirlineIcon_default as AirlineIcon,
  AlertWindow,
  Badge_default as Badge,
  Banner_default as Banner,
  Benefits_exports as Benefits,
  Breadcrumbs_default as Breadcrumbs,
  BreakpointProvider,
  Button_default as Button,
  Card,
  Carousel,
  Checkbox,
  CheckboxField,
  ContentUnavailable_default as ContentUnavailable,
  DateField_default as DateField,
  DatePicker,
  Dropdown_exports as Dropdown,
  EmblaCarouselContext,
  FormField,
  Icon_default as Icon,
  IconButton_default as IconButton,
  IconCell_default as IconCell,
  IconCountryFlag_default as IconCountryFlag,
  IndeterminateProgressCircle_default as IndeterminateProgressCircle,
  InputStepper_default as InputStepper,
  Layout_default as Layout,
  ListItem_default as ListItem,
  Menu_exports as Menu,
  MenuItem,
  MenuLinkItem,
  MonthPicker,
  Pagination,
  PasswordField_default as PasswordField,
  PhoneField_default as PhoneField,
  Popover_exports as Popover,
  PriceArea_default as PriceArea,
  RadioButton_default as RadioButton,
  RadioButtonField,
  RadioButtonGroup,
  Rating,
  ScrollArea_exports as ScrollArea,
  SearchField_default as SearchField,
  SegmentedControls,
  Sheet,
  Skeleton,
  Slider,
  Switch_default as Switch,
  SwitchField,
  TabBar,
  Tag_default as Tag,
  TextArea_default as TextArea,
  TextField_default as TextField,
  ToggleButton_default as ToggleButton,
  ToggleButtonGroup,
  Token_default as Token,
  TopTitleBar,
  Typography_default as Typography,
  allIconGlyphNames,
  countryData,
  focusOutline,
  focusWithinOutline,
  modDisabled,
  resetFocusOutline,
  slideInFromBottom,
  slideInFromLeft,
  slideInFromRight,
  slideOutToBottom,
  slideOutToLeft,
  slideOutToRight,
  useBreakpoints,
  useCarouselItemsInView,
  withStyleModifiers2 as withStyleModifiers
};
